/**
 * @license almond 0.2.9 Copyright (c) 2011-2014, The Dojo Foundation All Rights Reserved.
 * Available via the MIT or new BSD license.
 * see: http://github.com/jrburke/almond for details
 */
//Going sloppy to avoid 'use strict' string cost, but strict practices should
//be followed.
/*jslint sloppy: true */
/*global setTimeout: false */

var requirejs, require, define;
(function (undef) {
    var main, req, makeMap, handlers,
        defined = {},
        waiting = {},
        config = {},
        defining = {},
        hasOwn = Object.prototype.hasOwnProperty,
        aps = [].slice,
        jsSuffixRegExp = /\.js$/;

    function hasProp(obj, prop) {
        return hasOwn.call(obj, prop);
    }

    /**
     * Given a relative module name, like ./something, normalize it to
     * a real name that can be mapped to a path.
     * @param {String} name the relative name
     * @param {String} baseName a real name that the name arg is relative
     * to.
     * @returns {String} normalized name
     */
    function normalize(name, baseName) {
        var nameParts, nameSegment, mapValue, foundMap, lastIndex,
            foundI, foundStarMap, starI, i, j, part,
            baseParts = baseName && baseName.split("/"),
            map = config.map,
            starMap = (map && map['*']) || {};

        //Adjust any relative paths.
        if (name && name.charAt(0) === ".") {
            //If have a base name, try to normalize against it,
            //otherwise, assume it is a top-level require that will
            //be relative to baseUrl in the end.
            if (baseName) {
                //Convert baseName to array, and lop off the last part,
                //so that . matches that "directory" and not name of the baseName's
                //module. For instance, baseName of "one/two/three", maps to
                //"one/two/three.js", but we want the directory, "one/two" for
                //this normalization.
                baseParts = baseParts.slice(0, baseParts.length - 1);
                name = name.split('/');
                lastIndex = name.length - 1;

                // Node .js allowance:
                if (config.nodeIdCompat && jsSuffixRegExp.test(name[lastIndex])) {
                    name[lastIndex] = name[lastIndex].replace(jsSuffixRegExp, '');
                }

                name = baseParts.concat(name);

                //start trimDots
                for (i = 0; i < name.length; i += 1) {
                    part = name[i];
                    if (part === ".") {
                        name.splice(i, 1);
                        i -= 1;
                    } else if (part === "..") {
                        if (i === 1 && (name[2] === '..' || name[0] === '..')) {
                            //End of the line. Keep at least one non-dot
                            //path segment at the front so it can be mapped
                            //correctly to disk. Otherwise, there is likely
                            //no path mapping for a path starting with '..'.
                            //This can still fail, but catches the most reasonable
                            //uses of ..
                            break;
                        } else if (i > 0) {
                            name.splice(i - 1, 2);
                            i -= 2;
                        }
                    }
                }
                //end trimDots

                name = name.join("/");
            } else if (name.indexOf('./') === 0) {
                // No baseName, so this is ID is resolved relative
                // to baseUrl, pull off the leading dot.
                name = name.substring(2);
            }
        }

        //Apply map config if available.
        if ((baseParts || starMap) && map) {
            nameParts = name.split('/');

            for (i = nameParts.length; i > 0; i -= 1) {
                nameSegment = nameParts.slice(0, i).join("/");

                if (baseParts) {
                    //Find the longest baseName segment match in the config.
                    //So, do joins on the biggest to smallest lengths of baseParts.
                    for (j = baseParts.length; j > 0; j -= 1) {
                        mapValue = map[baseParts.slice(0, j).join('/')];

                        //baseName segment has  config, find if it has one for
                        //this name.
                        if (mapValue) {
                            mapValue = mapValue[nameSegment];
                            if (mapValue) {
                                //Match, update name to the new value.
                                foundMap = mapValue;
                                foundI = i;
                                break;
                            }
                        }
                    }
                }

                if (foundMap) {
                    break;
                }

                //Check for a star map match, but just hold on to it,
                //if there is a shorter segment match later in a matching
                //config, then favor over this star map.
                if (!foundStarMap && starMap && starMap[nameSegment]) {
                    foundStarMap = starMap[nameSegment];
                    starI = i;
                }
            }

            if (!foundMap && foundStarMap) {
                foundMap = foundStarMap;
                foundI = starI;
            }

            if (foundMap) {
                nameParts.splice(0, foundI, foundMap);
                name = nameParts.join('/');
            }
        }

        return name;
    }

    function makeRequire(relName, forceSync) {
        return function () {
            //A version of a require function that passes a moduleName
            //value for items that may need to
            //look up paths relative to the moduleName
            return req.apply(undef, aps.call(arguments, 0).concat([relName, forceSync]));
        };
    }

    function makeNormalize(relName) {
        return function (name) {
            return normalize(name, relName);
        };
    }

    function makeLoad(depName) {
        return function (value) {
            defined[depName] = value;
        };
    }

    function callDep(name) {
        if (hasProp(waiting, name)) {
            var args = waiting[name];
            delete waiting[name];
            defining[name] = true;
            main.apply(undef, args);
        }

        if (!hasProp(defined, name) && !hasProp(defining, name)) {
            throw new Error('No ' + name);
        }
        return defined[name];
    }

    //Turns a plugin!resource to [plugin, resource]
    //with the plugin being undefined if the name
    //did not have a plugin prefix.
    function splitPrefix(name) {
        var prefix,
            index = name ? name.indexOf('!') : -1;
        if (index > -1) {
            prefix = name.substring(0, index);
            name = name.substring(index + 1, name.length);
        }
        return [prefix, name];
    }

    /**
     * Makes a name map, normalizing the name, and using a plugin
     * for normalization if necessary. Grabs a ref to plugin
     * too, as an optimization.
     */
    makeMap = function (name, relName) {
        var plugin,
            parts = splitPrefix(name),
            prefix = parts[0];

        name = parts[1];

        if (prefix) {
            prefix = normalize(prefix, relName);
            plugin = callDep(prefix);
        }

        //Normalize according
        if (prefix) {
            if (plugin && plugin.normalize) {
                name = plugin.normalize(name, makeNormalize(relName));
            } else {
                name = normalize(name, relName);
            }
        } else {
            name = normalize(name, relName);
            parts = splitPrefix(name);
            prefix = parts[0];
            name = parts[1];
            if (prefix) {
                plugin = callDep(prefix);
            }
        }

        //Using ridiculous property names for space reasons
        return {
            f: prefix ? prefix + '!' + name : name, //fullName
            n: name,
            pr: prefix,
            p: plugin
        };
    };

    function makeConfig(name) {
        return function () {
            return (config && config.config && config.config[name]) || {};
        };
    }

    handlers = {
        require: function (name) {
            return makeRequire(name);
        },
        exports: function (name) {
            var e = defined[name];
            if (typeof e !== 'undefined') {
                return e;
            } else {
                return (defined[name] = {});
            }
        },
        module: function (name) {
            return {
                id: name,
                uri: '',
                exports: defined[name],
                config: makeConfig(name)
            };
        }
    };

    main = function (name, deps, callback, relName) {
        var cjsModule, depName, ret, map, i,
            args = [],
            callbackType = typeof callback,
            usingExports;

        //Use name if no relName
        relName = relName || name;

        //Call the callback to define the module, if necessary.
        if (callbackType === 'undefined' || callbackType === 'function') {
            //Pull out the defined dependencies and pass the ordered
            //values to the callback.
            //Default to [require, exports, module] if no deps
            deps = !deps.length && callback.length ? ['require', 'exports', 'module'] : deps;
            for (i = 0; i < deps.length; i += 1) {
                map = makeMap(deps[i], relName);
                depName = map.f;

                //Fast path CommonJS standard dependencies.
                if (depName === "require") {
                    args[i] = handlers.require(name);
                } else if (depName === "exports") {
                    //CommonJS module spec 1.1
                    args[i] = handlers.exports(name);
                    usingExports = true;
                } else if (depName === "module") {
                    //CommonJS module spec 1.1
                    cjsModule = args[i] = handlers.module(name);
                } else if (hasProp(defined, depName) ||
                           hasProp(waiting, depName) ||
                           hasProp(defining, depName)) {
                    args[i] = callDep(depName);
                } else if (map.p) {
                    map.p.load(map.n, makeRequire(relName, true), makeLoad(depName), {});
                    args[i] = defined[depName];
                } else {
                    throw new Error(name + ' missing ' + depName);
                }
            }

            ret = callback ? callback.apply(defined[name], args) : undefined;

            if (name) {
                //If setting exports via "module" is in play,
                //favor that over return value and exports. After that,
                //favor a non-undefined return value over exports use.
                if (cjsModule && cjsModule.exports !== undef &&
                        cjsModule.exports !== defined[name]) {
                    defined[name] = cjsModule.exports;
                } else if (ret !== undef || !usingExports) {
                    //Use the return value from the function.
                    defined[name] = ret;
                }
            }
        } else if (name) {
            //May just be an object definition for the module. Only
            //worry about defining if have a module name.
            defined[name] = callback;
        }
    };

    requirejs = require = req = function (deps, callback, relName, forceSync, alt) {
        if (typeof deps === "string") {
            if (handlers[deps]) {
                //callback in this case is really relName
                return handlers[deps](callback);
            }
            //Just return the module wanted. In this scenario, the
            //deps arg is the module name, and second arg (if passed)
            //is just the relName.
            //Normalize module name, if it contains . or ..
            return callDep(makeMap(deps, callback).f);
        } else if (!deps.splice) {
            //deps is a config object, not an array.
            config = deps;
            if (config.deps) {
                req(config.deps, config.callback);
            }
            if (!callback) {
                return;
            }

            if (callback.splice) {
                //callback is an array, which means it is a dependency list.
                //Adjust args if there are dependencies
                deps = callback;
                callback = relName;
                relName = null;
            } else {
                deps = undef;
            }
        }

        //Support require(['a'])
        callback = callback || function () {};

        //If relName is a function, it is an errback handler,
        //so remove it.
        if (typeof relName === 'function') {
            relName = forceSync;
            forceSync = alt;
        }

        //Simulate async callback;
        if (forceSync) {
            main(undef, deps, callback, relName);
        } else {
            //Using a non-zero value because of concern for what old browsers
            //do, and latest browsers "upgrade" to 4 if lower value is used:
            //http://www.whatwg.org/specs/web-apps/current-work/multipage/timers.html#dom-windowtimers-settimeout:
            //If want a value immediately, use require('id') instead -- something
            //that works in almond on the global level, but not guaranteed and
            //unlikely to work in other AMD implementations.
            setTimeout(function () {
                main(undef, deps, callback, relName);
            }, 4);
        }

        return req;
    };

    /**
     * Just drops the config on the floor, but returns req in case
     * the config return value is used.
     */
    req.config = function (cfg) {
        return req(cfg);
    };

    /**
     * Expose module registry for debugging and tooling
     */
    requirejs._defined = defined;

    define = function (name, deps, callback) {

        //This module may not have dependencies
        if (!deps.splice) {
            //deps is not an array, so probably means
            //an object literal or factory function for
            //the value. Adjust args.
            callback = deps;
            deps = [];
        }

        if (!hasProp(defined, name) && !hasProp(waiting, name)) {
            waiting[name] = [name, deps, callback];
        }
    };

    define.amd = {
        jQuery: true
    };
}());
define("libs/almond.js", function(){});

/*!
 * routie - a tiny hash router
 * v0.3.2
 * http://projects.jga.me/routie
 * copyright Greg Allen 2013
 * MIT License
*/
(function(n){var e=[],t={},r="routie",o=n[r],i=function(n,e){this.name=e,this.path=n,this.keys=[],this.fns=[],this.params={},this.regex=a(this.path,this.keys,!1,!1)};i.prototype.addHandler=function(n){this.fns.push(n)},i.prototype.removeHandler=function(n){for(var e=0,t=this.fns.length;t>e;e++){var r=this.fns[e];if(n==r)return this.fns.splice(e,1),void 0}},i.prototype.run=function(n){for(var e=0,t=this.fns.length;t>e;e++)this.fns[e].apply(this,n)},i.prototype.match=function(n,e){var t=this.regex.exec(n);if(!t)return!1;for(var r=1,o=t.length;o>r;++r){var i=this.keys[r-1],a="string"==typeof t[r]?decodeURIComponent(t[r]):t[r];i&&(this.params[i.name]=a),e.push(a)}return!0},i.prototype.toURL=function(n){var e=this.path;for(var t in n)e=e.replace("/:"+t,"/"+n[t]);if(e=e.replace(/\/:.*\?/g,"/").replace(/\?/g,""),-1!=e.indexOf(":"))throw Error("missing parameters for url: "+e);return e};var a=function(n,e,t,r){return n instanceof RegExp?n:(n instanceof Array&&(n="("+n.join("|")+")"),n=n.concat(r?"":"/?").replace(/\/\(/g,"(?:/").replace(/\+/g,"__plus__").replace(/(\/)?(\.)?:(\w+)(?:(\(.*?\)))?(\?)?/g,function(n,t,r,o,i,a){return e.push({name:o,optional:!!a}),t=t||"",""+(a?"":t)+"(?:"+(a?t:"")+(r||"")+(i||r&&"([^/.]+?)"||"([^/]+?)")+")"+(a||"")}).replace(/([\/.])/g,"\\$1").replace(/__plus__/g,"(.+)").replace(/\*/g,"(.*)"),RegExp("^"+n+"$",t?"":"i"))},s=function(n,r){var o=n.split(" "),a=2==o.length?o[0]:null;n=2==o.length?o[1]:o[0],t[n]||(t[n]=new i(n,a),e.push(t[n])),t[n].addHandler(r)},h=function(n,e){if("function"==typeof e)s(n,e),h.reload();else if("object"==typeof n){for(var t in n)s(t,n[t]);h.reload()}else e===void 0&&h.navigate(n)};h.lookup=function(n,t){for(var r=0,o=e.length;o>r;r++){var i=e[r];if(i.name==n)return i.toURL(t)}},h.remove=function(n,e){var r=t[n];r&&r.removeHandler(e)},h.removeAll=function(){t={},e=[]},h.navigate=function(n,e){e=e||{};var t=e.silent||!1;t&&l(),setTimeout(function(){window.location.hash=n,t&&setTimeout(function(){p()},1)},1)},h.noConflict=function(){return n[r]=o,h};var f=function(){return window.location.hash.substring(1)},c=function(n,e){var t=[];return e.match(n,t)?(e.run(t),!0):!1},u=h.reload=function(){for(var n=f(),t=0,r=e.length;r>t;t++){var o=e[t];if(c(n,o))return}},p=function(){n.addEventListener?n.addEventListener("hashchange",u,!1):n.attachEvent("onhashchange",u)},l=function(){n.removeEventListener?n.removeEventListener("hashchange",u):n.detachEvent("onhashchange",u)};p(),n[r]=h})(window);
define("libs/routie", function(){});

define('libs/core',[
	"libs/routie"
],function(){

	function show(path, config){
		if (config == -1)
			return render_sub_stack(this, path);
		if (this._subs[path])
			return render_sub_stack(this._subs[path], config);
		

		var scope = get_app_scope(this);
		var index = this.index;

		if (typeof path == "string"){
			var index = index;

			//child page
			if (path.indexOf("./") === 0){
				index++;
				path = path.substr(2);
			}

			//route to page
			var parsed = parse_parts(path);
			scope.path = scope.path.slice(0, index).concat(parsed);
		} else {
			//set parameters
			webix.extend(scope.path[index].params, path, true);
		}

		scope.show(url_string(scope.path), -1);
	}

	function get_app_scope(scope){
		while(scope){
			if (scope.app)
				return scope;
			scope = scope.parent;
		}
		return app;
	}

	function url_string(stack){
		var url = [];
		var start = app.config.layout ? 1 : 0;

		for (; start<stack.length; start++){
			url.push("/"+stack[start].page);
			var params = params_string(stack[start].params);
			if (params)
				url.push(":"+params);
		}

		return url.join("");
	}

	function params_string(obj){
		var str = [];
		for (var key in obj){
			if (str.length)
				str.push(":");
			str.push(key+"="+obj[key]);
		}
		
		return str.join("");
	}

	function subui(ui, name, stack){
		if (run_plugins(url_plugins, ui, name, stack, this) === false) return;

		if (name.page != this.name){
			this.name = name.page;
			this.ui = create_temp_ui;
			this.on = create_temp_event;
			this.show = show;
			this.module = ui;
			
			destroy.call(this);

			//collect init and destory handlers
			//set subview container
			this._init = [];
			this._destroy = [];
			this._subs = {};
			this.$layout = false;

			var subview = copy(ui, null, this);
				subview.$scope = this;

			create.call(this, subview);
		
			//prepare layout for view loading
			if (this.$layout){
				this.$layout = {
					root : (this._ui.$$ || webix.$$)(this.name+":subview"),
					sub: 		subui,
					parent: 	this,
					index: 		this.index + 1
				};
			}
		}

		run_plugins(ui_plugins, ui, name, stack, this);

		if (!ui.$onurlchange || ui.$onurlchange.call(ui, name.params, stack, this) !== false)
			return this.$layout;
	}

	function parse_parts(url){
		//split url by "/"
		var chunks = url.split("/");
		
		//use optional default layout page
		if (!chunks[0]){
			if (app.config.layout)
			 	chunks[0] = app.config.layout;
			else
				chunks.shift();
		}

		//for each page in url
		for (var i = 0; i < chunks.length; i++){
			var test = chunks[i];
			var result = [];

			//detect params
			var pos = test.indexOf(":");
			if (pos !== -1){
				var params = test.substr(pos+1).split(":");
				//detect named params
				var objmode = params[0].indexOf("=") !== -1;

				//create hash of named params
				if (objmode){
					result = {};
					for (var j = 0; j < params.length; j++) {
						var dchunk = params[j].split("=");
						result[dchunk[0]] = dchunk[1];
					}
				} else {
					result = params;
				}
			}
			
			//store parsed values
			chunks[i] = { page: (pos > -1 ? test.substr(0, pos) : test), params:result };
		}

		//return array of page objects
		return chunks;
	}

	function copy(obj, target, config){
		if (obj.$oninit)
			config._init.push(obj.$oninit);
		if (obj.$ondestroy)
			config._destroy.push(obj.$ondestroy);
		if (obj.$subview){
			if (typeof obj.$subview == "string"){
				var tname = (config.name + ":subview:"+obj.$subview);
				var tobj = config._subs[obj.$subview] = { 
					parent:this,
					root: tname,
					sub:subui,
					index:0,
					app:true
				};

				obj.id   = tname;
			} else {
				obj = { id: (config.name + ":subview") };
				config.$layout = true;
			}
		}
		if (obj.$ui)
			obj = obj.$ui;
		if (obj.$init){
			return obj;
		}
	
		target = target || (webix.isArray(obj)?[]:{});
		for (var method in obj){
			if(obj[method] && typeof obj[method] == "object" && !webix.isDate(obj[method])){
				target[method] = copy(obj[method], (webix.isArray(obj[method])?[]:{}), config);
			} else {
				target[method] = obj[method];
			}
		}

		return target;
	}

	function render_sub_stack(scope, path){
		if (scope.root)
			scope.root = webix.$$(scope.root);

		var parts = parse_parts(path);
		scope.path = [].concat(parts);
		render_stack(scope, parts);
	}

	function render_stack(layout, stack){
		var line = stack[0];
		if (line){
			var url = line.page;
			var issubpage = url.indexOf(".") === 0;

			if (issubpage)
				url = (layout.fullname||"")+url;
			url = url.replace(/\./g,"/");

			if (run_plugins(require_plugins, url, line, stack, layout) === false) return;

			require(["views/" + url], function(ui){
				stack.shift();

				var next = layout.sub(ui, line, stack);
				if (next){
					next.fullname = (issubpage ? (layout.fullname || "") : "") + line.page;
					render_stack(next, stack);
				} else {
					webix.ui.$freeze = false;
					webix.ui.resize();
				}
			});
		} else {
			webix.ui.$freeze = false;
			webix.ui.resize();
		}
	}

	var ui_plugins = [];
	var url_plugins = [];
	var require_plugins = [];
	function run_plugins(plugins, ui, name, stack, scope){
		for (var i = 0; i < plugins.length; i++)
			if (plugins[i](ui, name, stack, scope) === false) return false;
		return true;
	}

	var app = {
		create:function(config){
			//init config
			app.config = webix.extend({
				name:"App",
				version:"1.0",
				container: document.body,
				start:"/home"
			}, config, true);

			//init self
			app.debug = config.debug;
			app.$layout = {
				sub:subui,
				root: app.config.container,
				index:0,
				add:true
			};
			webix.extend(app, webix.EventSystem);

			//show start page
			setTimeout(function(){
				webix.ready(function(){
					app.start();
				});
			},1);

			var node = app.config.container;
			webix.html.addCss(node, "webixappstart");
			setTimeout(function(){
				webix.html.removeCss(node, "webixappstart");
				webix.html.addCss(node, "webixapp");
			}, 10);

			return app;
		},

		ui:create_temp_ui,

		//navigation
		router:function(name){
			var parts = parse_parts(name);
			app.path = [].concat(parts);

			//webix.ui.$freeze = true;
			render_stack(app.$layout, parts);
		},
		show:function(name, options){
			routie.navigate("!"+name, options);
		},
		start:function(name){
			//init routing
			routie("!*",		app.router);

			if (!window.location.hash)
				app.show(app.config.start);
			 else {
				webix.ui.$freeze = false;
				webix.ui.resize();
 			}
 		},


		//plugins
		use:function(handler, config){
			if (handler.$oninit)
				handler.$oninit(this, (config || {}) );

			if (handler.$onurlchange)
				url_plugins.push(handler.$onurlchange);
			if (handler.$onurl)
				require_plugins.push(handler.$onurl);
			if (handler.$onui)
				ui_plugins.push(handler.$onui);
		},


		//event helpers
		trigger:function(name){
			app.apply(name, [].splice.call(arguments, 1));
		},
		apply:function(name, data){
			app.callEvent(name, data);
		},
		action:function(name){
			return function(){
				app.apply(name, arguments);
			};
		},
		on:function(name, handler){
			this.attachEvent(name, handler);
		},

		_uis:[],
		_handlers:[]
	};

	function create_temp_event(obj, name, code){
		var id = obj.attachEvent(name, code);
		this._handlers.push({ obj:obj, id:id });
		return id;
	}

	function create_temp_ui(module, container){
		var view;
		var temp = { _init:[], _destroy:[] };
		var ui = copy(module, null, temp);
			ui.$scope = this;

		if (ui.id)
			view = $$(ui.id);
			
		if (!view){
			view = webix.ui(ui, container);
			this._uis.push(view);
			run_handlers(temp._init, view, this);
		}

		return view;
	}

	function run_handlers(arr, view, scope){
		if (arr)
			for (var i = 0; i < arr.length; i++)
				arr[i](view, scope);
	}

	function destroy(){
		if (!this._ui) return;

		if (this.$layout)
			destroy.call(this.$layout);

		var handlers = this._handlers;
		for (var i = handlers.length - 1; i >= 0; i--)
			handlers[i].obj.detachEvent( handlers[i].id );
		this._handlers = [];

		var uis = this._uis;
		for (var i = uis.length - 1; i >= 0; i--)
			if (uis[i] && uis[i].destructor) uis[i].destructor();
		this._uis = [];

		run_handlers(this._destroy, this._ui, this);

		if (!this.parent && this._ui)
			this._ui.destructor();
	}


	function delete_ids(view){
		delete webix.ui.views[view.config.id];
		view.config.id = "";
		var childs = view.getChildViews();
		for (var i = childs.length - 1; i >= 0; i--)
			delete_ids(childs[i]);
	}
	function create(subview){
		this._uis=[];
		this._handlers=[];

		//naive solution for id dupplication
		if (this.root && this.root.config)
			delete_ids(this.root);

		this._ui = webix.ui(subview, this.root);
		if (this.parent)
			this.root = this._ui;

		run_handlers(this._init, this._ui, this);
	}

	function invalid_url(err){
		if (app.debug)
			console.log(err.stack);

		if (!err.requireModules) throw(err);
		if (app.debug)
			webix.message({ type:"error", expire:5000, text:"Can't load "+err.requireModules.join(", ") });

		app.show(app.config.start);
	}

	requirejs.onError = invalid_url;
	return app;
});
define('helpers/menu',[], function(){

	function select_menu(menu_id, id){
		var menu = $$(menu_id);
		if (menu.setValue)
			menu.setValue(id);
		else if (menu.select && menu.exists(id))
			menu.select(id);
	}

	function get_menu(scope){
		if (scope.parent)
			return scope.parent.module.$menu || get_menu(scope.parent);
	}

	return {
		$onurlchange:function(ui, name, url, scope){
			//menu handling
			if (ui.$menuid){
				var id = ui.$menuid.call ? ui.$menuid.call(ui, ui, name, url) : ui.$menuid;
				var menu = get_menu(scope);
				if (menu && id)
					select_menu(menu, id);
			}
		},

		$onui:function(ui, name, url, scope){
			//menu handling
			if (ui.$menu && url.length)
				select_menu(ui.$menu, url[0].page)
		}
	}
});
//     (c) 2012 Airbnb, Inc.
//
//     polyglot.js may be freely distributed under the terms of the BSD
//     license. For all licensing information, details, and documention:
//     http://airbnb.github.com/polyglot.js
//
//
// Polyglot.js is an I18n helper library written in JavaScript, made to
// work both in the browser and in Node. It provides a simple solution for
// interpolation and pluralization, based off of Airbnb's
// experience adding I18n functionality to its Backbone.js and Node apps.
//
// Polylglot is agnostic to your translation backend. It doesn't perform any
// translation; it simply gives you a way to manage translated phrases from
// your client- or server-side JavaScript application.
//

!function(root) {
  'use strict';

  // ### Polyglot class constructor
  function Polyglot(options) {
    options = options || {};
    this.phrases = {};
    this.extend(options.phrases || {});
    this.currentLocale = options.locale || 'en';
    this.allowMissing = !!options.allowMissing;
    this.warn = options.warn || warn;
  }

  // ### Version
  Polyglot.VERSION = '0.4.1';

  // ### polyglot.locale([locale])
  //
  // Get or set locale. Internally, Polyglot only uses locale for pluralization.
  Polyglot.prototype.locale = function(newLocale) {
    if (newLocale) this.currentLocale = newLocale;
    return this.currentLocale;
  };

  // ### polyglot.extend(phrases)
  //
  // Use `extend` to tell Polyglot how to translate a given key.
  //
  //     polyglot.extend({
  //       "hello": "Hello",
  //       "hello_name": "Hello, %{name}"
  //     });
  //
  // The key can be any string.  Feel free to call `extend` multiple times;
  // it will override any phrases with the same key, but leave existing phrases
  // untouched.
  //
  // It is also possible to pass nested phrase objects, which get flattened
  // into an object with the nested keys concatenated using dot notation.
  //
  //     polyglot.extend({
  //       "nav": {
  //         "hello": "Hello",
  //         "hello_name": "Hello, %{name}",
  //         "sidebar": {
  //           "welcome": "Welcome"
  //         }
  //       }
  //     });
  //
  //     console.log(polyglot.phrases);
  //     // {
  //     //   'nav.hello': 'Hello',
  //     //   'nav.hello_name': 'Hello, %{name}',
  //     //   'nav.sidebar.welcome': 'Welcome'
  //     // }
  //
  // `extend` accepts an optional second argument, `prefix`, which can be used
  // to prefix every key in the phrases object with some string, using dot
  // notation.
  //
  //     polyglot.extend({
  //       "hello": "Hello",
  //       "hello_name": "Hello, %{name}"
  //     }, "nav");
  //
  //     console.log(polyglot.phrases);
  //     // {
  //     //   'nav.hello': 'Hello',
  //     //   'nav.hello_name': 'Hello, %{name}'
  //     // }
  //
  // This feature is used internally to support nested phrase objects.
  Polyglot.prototype.extend = function(morePhrases, prefix) {
    var phrase;

    for (var key in morePhrases) {
      if (morePhrases.hasOwnProperty(key)) {
        phrase = morePhrases[key];
        if (prefix) key = prefix + '.' + key;
        if (typeof phrase === 'object') {
          this.extend(phrase, key);
        } else {
          this.phrases[key] = phrase;
        }
      }
    }
  };

  // ### polyglot.clear()
  //
  // Clears all phrases. Useful for special cases, such as freeing
  // up memory if you have lots of phrases but no longer need to
  // perform any translation. Also used internally by `replace`.
  Polyglot.prototype.clear = function() {
    this.phrases = {};
  };

  // ### polyglot.replace(phrases)
  //
  // Completely replace the existing phrases with a new set of phrases.
  // Normally, just use `extend` to add more phrases, but under certain
  // circumstances, you may want to make sure no old phrases are lying around.
  Polyglot.prototype.replace = function(newPhrases) {
    this.clear();
    this.extend(newPhrases);
  };


  // ### polyglot.t(key, options)
  //
  // The most-used method. Provide a key, and `t` will return the
  // phrase.
  //
  //     polyglot.t("hello");
  //     => "Hello"
  //
  // The phrase value is provided first by a call to `polyglot.extend()` or
  // `polyglot.replace()`.
  //
  // Pass in an object as the second argument to perform interpolation.
  //
  //     polyglot.t("hello_name", {name: "Spike"});
  //     => "Hello, Spike"
  //
  // If you like, you can provide a default value in case the phrase is missing.
  // Use the special option key "_" to specify a default.
  //
  //     polyglot.t("i_like_to_write_in_language", {
  //       _: "I like to write in %{language}.",
  //       language: "JavaScript"
  //     });
  //     => "I like to write in JavaScript."
  //
  Polyglot.prototype.t = function(key, options) {
    var result;
    options = options == null ? {} : options;
    // allow number as a pluralization shortcut
    if (typeof options === 'number') {
      options = {smart_count: options};
    }
    var phrase = this.phrases[key] || options._ || (this.allowMissing ? key : '');
    if (phrase === '') {
      this.warn('Missing translation for key: "'+key+'"');
      result = key;
    } else {
      options = clone(options);
      result = choosePluralForm(phrase, this.currentLocale, options.smart_count);
      result = interpolate(result, options);
    }
    return result;
  };


  // #### Pluralization methods
  // The string that separates the different phrase possibilities.
  var delimeter = '||||';

  // Mapping from pluralization group plural logic.
  var pluralTypes = {
    chinese:   function(n) { return 0; },
    german:    function(n) { return n !== 1 ? 1 : 0; },
    french:    function(n) { return n > 1 ? 1 : 0; },
    russian:   function(n) { return n % 10 === 1 && n % 100 !== 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2; },
    czech:     function(n) { return (n === 1) ? 0 : (n >= 2 && n <= 4) ? 1 : 2; },
    polish:    function(n) { return (n === 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2); },
    icelandic: function(n) { return (n % 10 !== 1 || n % 100 === 11) ? 1 : 0; }
  };

  // Mapping from pluralization group to individual locales.
  var pluralTypeToLanguages = {
    chinese:   ['fa', 'id', 'ja', 'ko', 'lo', 'ms', 'th', 'tr', 'zh'],
    german:    ['da', 'de', 'en', 'es', 'fi', 'el', 'he', 'hu', 'it', 'nl', 'no', 'pt', 'sv'],
    french:    ['fr', 'tl', 'pt-br'],
    russian:   ['hr', 'ru', 'be'],
    czech:     ['cs'],
    polish:    ['pl'],
    icelandic: ['is']
  };

  function langToTypeMap(mapping) {
    var type, langs, l, ret = {};
    for (type in mapping) {
      if (mapping.hasOwnProperty(type)) {
        langs = mapping[type];
        for (l in langs) {
          ret[langs[l]] = type;
        }
      }
    }
    return ret;
  }

  // Trim a string.
  function trim(str){
    var trimRe = /^\s+|\s+$/g;
    return str.replace(trimRe, '');
  }

  // Based on a phrase text that contains `n` plural forms separated
  // by `delimeter`, a `locale`, and a `count`, choose the correct
  // plural form, or none if `count` is `null`.
  function choosePluralForm(text, locale, count){
    var ret, texts, chosenText;
    if (count != null && text) {
      texts = text.split(delimeter);
      chosenText = texts[pluralTypeIndex(locale, count)] || texts[0];
      ret = trim(chosenText);
    } else {
      ret = text;
    }
    return ret;
  }

  function pluralTypeName(locale) {
    var langToPluralType = langToTypeMap(pluralTypeToLanguages);
    return langToPluralType[locale] || langToPluralType.en;
  }

  function pluralTypeIndex(locale, count) {
    return pluralTypes[pluralTypeName(locale)](count);
  }

  // ### interpolate
  //
  // Does the dirty work. Creates a `RegExp` object for each
  // interpolation placeholder.
  function interpolate(phrase, options) {
    for (var arg in options) {
      if (arg !== '_' && options.hasOwnProperty(arg)) {
        // We create a new `RegExp` each time instead of using a more-efficient
        // string replace so that the same argument can be replaced multiple times
        // in the same phrase.
        phrase = phrase.replace(new RegExp('%\\{'+arg+'\\}', 'g'), options[arg]);
      }
    }
    return phrase;
  }

  // ### warn
  //
  // Provides a warning in the console if a phrase key is missing.
  function warn(message) {
    root.console && root.console.warn && root.console.warn('WARNING: ' + message);
  }

  // ### clone
  //
  // Clone an object.
  function clone(source) {
    var ret = {};
    for (var prop in source) {
      ret[prop] = source[prop];
    }
    return ret;
  }


  // Export for Node, attach to `window` for browser.
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = Polyglot;
  } else {
    root.Polyglot = Polyglot;
  }

}(this);

define("libs/polyglot", function(){});

define('models/user',[

], function () {
    var user = null,
        credentials = {},
        oauthUrl = ''
        ;
    var host = "";
    var start = "";
    require(["app"], function (app) {
        host = app.config.host;
        start = app.config.start;
    });
    credentials = Cookies.getJSON("appCookie") || {};
    function saveSetting(key, value, reload) {
        if (current_user) {
            var id = current_user.id,
                settings = current_user.settings;
            if (!settings[key] || value != settings[key]) {
                if (reload)
                    document.location.reload();
            }
        }
    }

    return {
        saveSetting: saveSetting,
        getDvcsID: function () {
            var cookie = this.getAppCookie();

            if (cookie == null) {
                return null;
            }
            return cookie.ma_dvcs;
        },
        getCurrentUser: function () {
            var cookie = this.getAppCookie();
            if (cookie == null) {
                return null;
            }
            return cookie.username;
        },
        getLanguage: function () {
            var cookie = this.getAppCookie();
            if (cookie == null) {
                return null;
            }
            return cookie.language;
        },
        getAccessToken: function () {
            var cookie = this.getAppCookie();
            if (cookie === null || cookie === undefined) {
                return null;
            }
            if (cookie.access_token === undefined) {
                return null;
            }
            if ((cookie.expires_in + cookie.timestamp) < (Date.now() / 1000)) {
                return null;
            }
            return cookie.access_token;
        },
        getCredentials: function () {
            return credentials;
        },
        getAppCookie: function () {
            var baseUrl = document.location.href;
            if (baseUrl.startsWith("file")) {
                var cookie = webix.storage.local.get("appCookie");
                return cookie;
            }
            else {
                var cookie = Cookies.getJSON("appCookie");
                return cookie;
            }
        },
        setCurrentUser: function (userId) {
            user = userId;
            return true;
        },
        login: function (username, password, ma_dvcs, language, component) {

            webix.extend(component, webix.ProgressBar);
            component.disable();
            component.showProgress({
                type: "icon"
            });

            webix.ajax().post(host + "/Account/Login", {
                username: username,
                password: password,
                ma_dvcs: ma_dvcs
            }, function (text, data) {

                var result = JSON.parse(text);
                if (result.error != null) {
                    webix.message(result.error, "error");
                    component.enable();
                    component.hideProgress();
                    return;
                }

                credentials = {
                    "access_token": result.token,
                    "expires_in": 3600 * 6, // 3600 = 1 hours
                    "token_type": "Bearer",
                    "scope": null,
                    "username": username,
                    "language": language,
                    "ma_dvcs": ma_dvcs
                };

                credentials.timestamp = Date.now() / 1000 | 0;
                var baseUrl = document.location.href;
                if (baseUrl.startsWith("file")) {
                    webix.storage.local.put("appCookie", credentials);
                }
                else {
                    Cookies.set("appCookie", credentials);
                }
                //component.$scope.show("./"+ start);                
                require(["app"], function (app) {
                    app.show("/app")
                    app.router(start);
                });

            }).then(null, function () {
                component.enable();
                component.hideProgress();
            });
        },
        logout: function () {
            credentials = {};
            var baseUrl = document.location.href;
            if (baseUrl.startsWith("file")) {
                webix.storage.local.remove("appCookie");
            }
            else {
                Cookies.remove("appCookie");
            }
        },
        session: {
            status: function () {
                return new Promise(function (resolve, reject) {
                    resolve(true);
                });
            }
        }
    };
});
define('helpers/locale',[
	"libs/polyglot",
	"models/user"	
], function(polyglot, users){

	var defaultlang = "vi";
	var key = "--:app:lang";
	var current_lang = "";

	function _get_lang(){
		return webix.storage.local.get(key) || defaultlang;
	}

	function _set_lang(lang, init){
		webix.storage.local.put(key, lang);
		document.location.reload();
	}

	function create_locale(lang,host){
		current_lang = lang;
		define("locale", [
			"locales/"+lang
		], function(data){
			var poly = new Polyglot({ phrases:data });
				poly.locale(lang);

			var t = webix.bind(poly.t, poly);
			t.template = function(a){
				return a.replace(/%([a-zA-Z0-9.]+)%/g, function(_, match){
					return poly.t(match);
				});
			};
			return t;
		});	
				
		
	}

	return {
		$oninit:function(app, config){
			key = (app.config.id || "")+key;

			var lang = _get_lang();
			create_locale(lang,app.config.host);
		},
		setLang: _set_lang,
		getLang: _get_lang,
		isNow:function(val){ return val == current_lang; }
	};
});
define('helpers/theme',[
	"models/user"
], function(users){

	var key = "--:app:theme";
	var current_theme = webix.storage.local.get(key) || "siberia:webix";

	function _get_theme(){
		if(users.getCurrentUser())
			return users.getCurrentUser().settings.theme;

		return current_theme;
	}

	function _set_theme(theme){
		webix.storage.local.put(key, theme);
		if(users.getCurrentUser())
			users.saveSetting("theme", theme, theme != current_theme);
		else
			document.location.reload();

		current_theme = theme;
	}

	return {
		setTheme: _set_theme,
		getTheme: _get_theme,
		isNow:function(val){ return val == current_theme; }
	};
});
define('libs/rollbar',['require','exports','module'],function(require,exports,module){function _isUndefined(a){return"undefined"==typeof a}function computeStackTraceWrapper(a){function b(a){if(!t)return"";try{var b=function(){try{return new window.XMLHttpRequest}catch(a){return new window.ActiveXObject("Microsoft.XMLHTTP")}},c=b();return c.open("GET",a,!1),c.send(""),c.responseText}catch(d){return""}}function c(a){if(!s.hasOwnProperty(a)){var c="";-1!==a.indexOf(document.domain)&&(c=b(a)),s[a]=c?c.split("\n"):[]}return s[a]}function d(a,b){var d,e=/function ([^(]*)\(([^)]*)\)/,f=/['"]?([0-9A-Za-z$_]+)['"]?\s*[:=]\s*(function|eval|new Function)/,g="",h=10,i=c(a);if(!i.length)return UNKNOWN_FUNCTION;for(var j=0;h>j;++j)if(g=i[b-j]+g,!_isUndefined(g)){if(d=f.exec(g))return d[1];if(d=e.exec(g))return d[1]}return UNKNOWN_FUNCTION}function e(a,b){var d=c(a);if(!d.length)return null;var e=[],f=Math.floor(u/2),g=f+u%2,h=Math.max(0,b-f-1),i=Math.min(d.length,b+g-1);b-=1;for(var j=h;i>j;++j)_isUndefined(d[j])||e.push(d[j]);return e.length>0?e:null}function f(a){return a.replace(/[\-\[\]{}()*+?.,\\\^$|#]/g,"\\$&")}function g(a){return f(a).replace("<","(?:<|&lt;)").replace(">","(?:>|&gt;)").replace("&","(?:&|&amp;)").replace('"','(?:"|&quot;)').replace(/\s+/g,"\\s+")}function h(a,b){for(var d,e,f=0,g=b.length;g>f;++f)if((d=c(b[f])).length&&(d=d.join("\n"),e=a.exec(d)))return{url:b[f],line:d.substring(0,e.index).split("\n").length,column:e.index-d.lastIndexOf("\n",e.index)-1};return null}function i(a,b,d){var e,g=c(b),h=new RegExp("\\b"+f(a)+"\\b");return d-=1,g&&g.length>d&&(e=h.exec(g[d]))?e.index:null}function j(a){for(var b,c,d,e,i=[window.location.href],j=document.getElementsByTagName("script"),k=""+a,l=/^function(?:\s+([\w$]+))?\s*\(([\w\s,]*)\)\s*\{\s*(\S[\s\S]*\S)\s*\}\s*$/,m=/^function on([\w$]+)\s*\(event\)\s*\{\s*(\S[\s\S]*\S)\s*\}\s*$/,n=0;n<j.length;++n){var o=j[n];o.src&&i.push(o.src)}if(d=l.exec(k)){var p=d[1]?"\\s+"+d[1]:"",q=d[2].split(",").join("\\s*,\\s*");b=f(d[3]).replace(/;$/,";?"),c=new RegExp("function"+p+"\\s*\\(\\s*"+q+"\\s*\\)\\s*{\\s*"+b+"\\s*}")}else c=new RegExp(f(k).replace(/\s+/g,"\\s+"));if(e=h(c,i))return e;if(d=m.exec(k)){var r=d[1];if(b=g(d[2]),c=new RegExp("on"+r+"=[\\'\"]\\s*"+b+"\\s*[\\'\"]","i"),e=h(c,i[0]))return e;if(c=new RegExp(b),e=h(c,i))return e}return null}function k(a){if(!a.stack)return null;for(var b,c,f=/^\s*at (?:((?:\[object object\])?\S+(?: \[as \S+\])?) )?\(?((?:file|http|https):.*?):(\d+)(?::(\d+))?\)?\s*$/i,g=/^\s*(\S*)(?:\((.*?)\))?@((?:file|http|https).*?):(\d+)(?::(\d+))?\s*$/i,h=a.stack.split("\n"),j=[],k=/^(.*) is undefined$/.exec(a.message),l=0,m=h.length;m>l;++l){if(b=g.exec(h[l]))c={url:b[3],func:b[1]||UNKNOWN_FUNCTION,args:b[2]?b[2].split(","):"",line:+b[4],column:b[5]?+b[5]:null};else{if(!(b=f.exec(h[l])))continue;c={url:b[2],func:b[1]||UNKNOWN_FUNCTION,line:+b[3],column:b[4]?+b[4]:null}}!c.func&&c.line&&(c.func=d(c.url,c.line)),c.line&&(c.context=e(c.url,c.line)),j.push(c)}return j[0]&&j[0].line&&!j[0].column&&k&&(j[0].column=i(k[1],j[0].url,j[0].line)),j.length?{mode:"stack",name:a.name,message:a.message,url:document.location.href,stack:j,useragent:navigator.userAgent}:null}function l(a){for(var b,c=a.stacktrace,f=/ line (\d+), column (\d+) in (?:<anonymous function: ([^>]+)>|([^\)]+))\((.*)\) in (.*):\s*$/i,g=c.split("\n"),h=[],i=0,j=g.length;j>i;i+=2)if(b=f.exec(g[i])){var k={line:+b[1],column:+b[2],func:b[3]||b[4],args:b[5]?b[5].split(","):[],url:b[6]};if(!k.func&&k.line&&(k.func=d(k.url,k.line)),k.line)try{k.context=e(k.url,k.line)}catch(l){}k.context||(k.context=[g[i+1]]),h.push(k)}return h.length?{mode:"stacktrace",name:a.name,message:a.message,url:document.location.href,stack:h,useragent:navigator.userAgent}:null}function m(a){var b=a.message.split("\n");if(b.length<4)return null;var f,i,j,k,l=/^\s*Line (\d+) of linked script ((?:file|http|https)\S+)(?:: in function (\S+))?\s*$/i,m=/^\s*Line (\d+) of inline#(\d+) script in ((?:file|http|https)\S+)(?:: in function (\S+))?\s*$/i,n=/^\s*Line (\d+) of function script\s*$/i,o=[],p=document.getElementsByTagName("script"),q=[];for(i in p)p.hasOwnProperty(i)&&!p[i].src&&q.push(p[i]);for(i=2,j=b.length;j>i;i+=2){var r=null;if(f=l.exec(b[i]))r={url:f[2],func:f[3],line:+f[1]};else if(f=m.exec(b[i])){r={url:f[3],func:f[4]};var s=+f[1],t=q[f[2]-1];if(t&&(k=c(r.url))){k=k.join("\n");var u=k.indexOf(t.innerText);u>=0&&(r.line=s+k.substring(0,u).split("\n").length)}}else if(f=n.exec(b[i])){var v=window.location.href.replace(/#.*$/,""),w=f[1],x=new RegExp(g(b[i+1]));k=h(x,[v]),r={url:v,line:k?k.line:w,func:""}}if(r){r.func||(r.func=d(r.url,r.line));var y=e(r.url,r.line),z=y?y[Math.floor(y.length/2)]:null;r.context=y&&z.replace(/^\s*/,"")===b[i+1].replace(/^\s*/,"")?y:[b[i+1]],o.push(r)}}return o.length?{mode:"multiline",name:a.name,message:b[0],url:document.location.href,stack:o,useragent:navigator.userAgent}:null}function n(a,b,c,f){var g={url:b,line:c};if(g.url&&g.line){a.incomplete=!1,g.func||(g.func=d(g.url,g.line)),g.context||(g.context=e(g.url,g.line));var h=/ '([^']+)' /.exec(f);if(h&&(g.column=i(h[1],g.url,g.line)),a.stack.length>0&&a.stack[0].url===g.url){if(a.stack[0].line===g.line)return!1;if(!a.stack[0].line&&a.stack[0].func===g.func)return a.stack[0].line=g.line,a.stack[0].context=g.context,!1}return a.stack.unshift(g),a.partial=!0,!0}return a.incomplete=!0,!1}function o(a,b){for(var c,e,f,g=/function\s+([_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*)?\s*\(/i,h=[],k={},l=!1,m=o.caller;m&&!l;m=m.caller)if(m!==p&&m!==v){if(e={url:null,func:UNKNOWN_FUNCTION,line:null,column:null},m.name?e.func=m.name:(c=g.exec(m.toString()))&&(e.func=c[1]),f=j(m)){e.url=f.url,e.line=f.line,e.func===UNKNOWN_FUNCTION&&(e.func=d(e.url,e.line));var q=/ '([^']+)' /.exec(a.message||a.description);q&&(e.column=i(q[1],f.url,f.line))}k[""+m]?l=!0:k[""+m]=!0,h.push(e)}b&&h.splice(0,b);var r={mode:"callers",name:a.name,message:a.message,url:document.location.href,stack:h,useragent:navigator.userAgent};return n(r,a.sourceURL||a.fileName,a.line||a.lineNumber,a.message||a.description),r}function p(a,b){var c=null;b=null==b?0:+b;try{if(c=l(a))return c}catch(d){if(r)throw d}try{if(c=k(a))return c}catch(d){if(r)throw d}try{if(c=m(a))return c}catch(d){if(r)throw d}try{if(c=o(a,b+1))return c}catch(d){if(r)throw d}return{mode:"failed"}}function q(a){a=(null==a?0:+a)+1;try{throw new Error}catch(b){return p(b,a+1)}}var r=!1,s={},t=a.remoteFetching,u=a.linesOfContext,v=a.tracekitReport;return p.augmentStackTraceWithInitialElement=n,p.guessFunctionName=d,p.gatherContext=e,p.ofCaller=q,p}function Notifier(a){_topLevelNotifier=_topLevelNotifier||this;var b=window.location.protocol;0!==b.indexOf("http")&&(b="https:");var c=b+"//"+Notifier.DEFAULT_ENDPOINT;this.options={enabled:!0,endpoint:c,environment:"production",scrubFields:Util.copy(Notifier.DEFAULT_SCRUB_FIELDS),checkIgnore:null,logLevel:Notifier.DEFAULT_LOG_LEVEL,reportLevel:Notifier.DEFAULT_REPORT_LEVEL,uncaughtErrorLevel:Notifier.DEFAULT_UNCAUGHT_ERROR_LEVEL,payload:{}},this.lastError=null,this.plugins={},this.parentNotifier=a,this.logger=function(){if(window.console&&"function"==typeof window.console.log){var a=["Rollbar:"].concat(Array.prototype.slice.call(arguments,0));window.console.log(a)}},a&&(a.hasOwnProperty("shimId")?a.notifier=this:(this.logger=a.logger,this.configure(a.options)))}function _wrapNotifierFn(a,b){return function(){var c=b||this;try{return a.apply(c,arguments)}catch(d){c&&c.logger(d)}}}function _guessErrorClass(a){if(!a)return["Unknown error. There was no error message to display.",""];var b=a.match(ERR_CLASS_REGEXP),c="(unknown)";return b&&(c=b[b.length-1],a=a.replace((b[b.length-2]||"")+c+":",""),a=a.replace(/(^[\s]+|[\s]+$)/g,"")),[c,a]}function _payloadProcessorTimer(a){for(var b;b=window._rollbarPayloadQueue.shift();)_processPayload(b.endpointUrl,b.accessToken,b.payload,b.callback);a||(payloadProcessorTimeout=setTimeout(_payloadProcessorTimer,1e3))}function _processPayload(a,b,c,d){d=d||function(){};var e=(new Date).getTime();e-rateLimitStartTime>=6e4&&(rateLimitStartTime=e,rateLimitPerMinCounter=0);var f=window._globalRollbarOptions.maxItems,g=window._globalRollbarOptions.itemsPerMinute,h=function(){return!c.ignoreRateLimit&&f>=1&&rateLimitCounter>=f},i=function(){return!c.ignoreRateLimit&&g>=1&&rateLimitPerMinCounter>=g};return h()?(d(new Error(f+" max items reached")),void 0):i()?(d(new Error(g+" items per minute reached")),void 0):(rateLimitCounter++,rateLimitPerMinCounter++,h()&&_topLevelNotifier._log(_topLevelNotifier.options.uncaughtErrorLevel,"maxItems has been hit. Ignoring errors for the remainder of the current page load.",null,{maxItems:f},null,!1,!0),c.ignoreRateLimit&&delete c.ignoreRateLimit,XHR.post(a,b,c,function(a,b){return a?d(a):d(null,b)}),void 0)}function _rollbarWindowOnError(a,b,c){!c[4]&&window._rollbarWrappedError&&(c[4]=window._rollbarWrappedError,window._rollbarWrappedError=null),globalNotifier.uncaughtError.apply(globalNotifier,c),b&&b.apply(window,c)}function _extendListenerPrototype(a,b){if(b.hasOwnProperty&&b.hasOwnProperty("addEventListener")){var c=b.addEventListener;b.addEventListener=function(b,d,e){c.call(this,b,a.wrap(d),e)};var d=b.removeEventListener;b.removeEventListener=function(a,b,c){d.call(this,a,b._wrapped||b,c)}}}var setupCustomJSON=function(JSON){function f(a){return 10>a?"0"+a:a}function quote(a){return escapable.lastIndex=0,escapable.test(a)?'"'+a.replace(escapable,function(a){var b=meta[a];return"string"==typeof b?b:"\\u"+("0000"+a.charCodeAt(0).toString(16)).slice(-4)})+'"':'"'+a+'"'}function str(a,b){var c,d,e,f,g,h=gap,i=b[a];switch(i&&"object"==typeof i&&"function"==typeof i.toJSON&&(i=i.toJSON(a)),"function"==typeof rep&&(i=rep.call(b,a,i)),typeof i){case"string":return quote(i);case"number":return isFinite(i)?String(i):"null";case"boolean":case"null":return String(i);case"object":if(!i)return"null";if(gap+=indent,g=[],"[object Array]"===Object.prototype.toString.apply(i)){for(f=i.length,c=0;f>c;c+=1)g[c]=str(c,i)||"null";return e=0===g.length?"[]":gap?"[\n"+gap+g.join(",\n"+gap)+"\n"+h+"]":"["+g.join(",")+"]",gap=h,e}if(rep&&"object"==typeof rep)for(f=rep.length,c=0;f>c;c+=1)"string"==typeof rep[c]&&(d=rep[c],e=str(d,i),e&&g.push(quote(d)+(gap?": ":":")+e));else for(d in i)Object.prototype.hasOwnProperty.call(i,d)&&(e=str(d,i),e&&g.push(quote(d)+(gap?": ":":")+e));return e=0===g.length?"{}":gap?"{\n"+gap+g.join(",\n"+gap)+"\n"+h+"}":"{"+g.join(",")+"}",gap=h,e}}"function"!=typeof Date.prototype.toJSON&&(Date.prototype.toJSON=function(){return isFinite(this.valueOf())?this.getUTCFullYear()+"-"+f(this.getUTCMonth()+1)+"-"+f(this.getUTCDate())+"T"+f(this.getUTCHours())+":"+f(this.getUTCMinutes())+":"+f(this.getUTCSeconds())+"Z":null},String.prototype.toJSON=Number.prototype.toJSON=Boolean.prototype.toJSON=function(){return this.valueOf()});var cx=/[\u0000\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g,escapable=/[\\\"\x00-\x1f\x7f-\x9f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g,gap,indent,meta={"\b":"\\b","	":"\\t","\n":"\\n","\f":"\\f","\r":"\\r",'"':'\\"',"\\":"\\\\"},rep;"function"!=typeof JSON.stringify&&(JSON.stringify=function(a,b,c){var d;if(gap="",indent="","number"==typeof c)for(d=0;c>d;d+=1)indent+=" ";else"string"==typeof c&&(indent=c);if(rep=b,b&&"function"!=typeof b&&("object"!=typeof b||"number"!=typeof b.length))throw new Error("JSON.stringify");return str("",{"":a})}),"function"!=typeof JSON.parse&&(JSON.parse=function(text,reviver){function walk(a,b){var c,d,e=a[b];if(e&&"object"==typeof e)for(c in e)Object.prototype.hasOwnProperty.call(e,c)&&(d=walk(e,c),void 0!==d?e[c]=d:delete e[c]);return reviver.call(a,b,e)}var j;if(text=String(text),cx.lastIndex=0,cx.test(text)&&(text=text.replace(cx,function(a){return"\\u"+("0000"+a.charCodeAt(0).toString(16)).slice(-4)})),/^[\],:{}\s]*$/.test(text.replace(/\\(?:["\\\/bfnrt]|u[0-9a-fA-F]{4})/g,"@").replace(/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g,"]").replace(/(?:^|:|,)(?:\s*\[)+/g,"")))return j=eval("("+text+")"),"function"==typeof reviver?walk({"":j},""):j;throw new SyntaxError("JSON.parse")})},UNKNOWN_FUNCTION="?",Util={merge:function(){var a,b,c,d,e,f,g=arguments[0]||{},h=1,i=arguments.length,j=!0;for("object"!=typeof g&&"function"!=typeof g&&(g={});i>h;h++)if(null!==(a=arguments[h]))for(b in a)a.hasOwnProperty(b)&&(c=g[b],d=a[b],g!==d&&(j&&d&&(d.constructor==Object||(e=d.constructor==Array))?(e?(e=!1,f=[]):f=c&&c.constructor==Object?c:{},g[b]=Util.merge(f,d)):void 0!==d&&(g[b]=d)));return g},copy:function(a){var b;return"object"==typeof a&&(a.constructor==Object?b={}:a.constructor==Array&&(b=[])),Util.merge(b,a),b},parseUriOptions:{strictMode:!1,key:["source","protocol","authority","userInfo","user","password","host","port","relative","path","directory","file","query","anchor"],q:{name:"queryKey",parser:/(?:^|&)([^&=]*)=?([^&]*)/g},parser:{strict:/^(?:([^:\/?#]+):)?(?:\/\/((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?))?((((?:[^?#\/]*\/)*)([^?#]*))(?:\?([^#]*))?(?:#(.*))?)/,loose:/^(?:(?![^:@]+:[^:@\/]*@)([^:\/?#.]+):)?(?:\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/}},parseUri:function(a){if(!a||"string"!=typeof a&&!(a instanceof String))throw new Error("Util.parseUri() received invalid input");for(var b=Util.parseUriOptions,c=b.parser[b.strictMode?"strict":"loose"].exec(a),d={},e=14;e--;)d[b.key[e]]=c[e]||"";return d[b.q.name]={},d[b.key[12]].replace(b.q.parser,function(a,c,e){c&&(d[b.q.name][c]=e)}),d},sanitizeUrl:function(a){if(!a||"string"!=typeof a&&!(a instanceof String))throw new Error("Util.sanitizeUrl() received invalid input");var b=Util.parseUri(a);return""===b.anchor&&(b.source=b.source.replace("#","")),a=b.source.replace("?"+b.query,"")},traverse:function(a,b){var c,d,e,f="object"==typeof a,g=[];if(f)if(a.constructor===Object)for(c in a)a.hasOwnProperty(c)&&g.push(c);else if(a.constructor===Array)for(e=0;e<a.length;++e)g.push(e);for(e=0;e<g.length;++e)c=g[e],d=a[c],f="object"==typeof d,a[c]=f?null===d?b(c,d):d.constructor===Object?Util.traverse(d,b):d.constructor===Array?Util.traverse(d,b):b(c,d):b(c,d);return a},redact:function(a){return a=String(a),new Array(a.length+1).join("*")},uuid4:function(){var a=(new Date).getTime(),b="xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g,function(b){var c=(a+16*Math.random())%16|0;return a=Math.floor(a/16),("x"==b?c:7&c|8).toString(16)});return b}},RollbarJSON={};setupCustomJSON(RollbarJSON);var XHR={XMLHttpFactories:[function(){return new XMLHttpRequest},function(){return new ActiveXObject("Msxml2.XMLHTTP")},function(){return new ActiveXObject("Msxml3.XMLHTTP")},function(){return new ActiveXObject("Microsoft.XMLHTTP")}],createXMLHTTPObject:function(){var a,b=!1,c=XHR.XMLHttpFactories,d=c.length;for(a=0;d>a;a++)try{b=c[a]();break}catch(e){}return b},post:function(a,b,c,d){if("object"!=typeof c)throw new Error("Expected an object to POST");c=RollbarJSON.stringify(c),d=d||function(){};var e=XHR.createXMLHTTPObject();if(e)try{try{var f=function(){try{f&&4===e.readyState&&(f=void 0,200===e.status?d(null,RollbarJSON.parse(e.responseText)):"number"==typeof e.status&&e.status>=400&&e.status<600?d(new Error(e.status.toString())):d(new Error))}catch(a){var b;b="object"==typeof a&&a.stack?a:new Error(a),d(b)}};e.open("POST",a,!0),e.setRequestHeader&&(e.setRequestHeader("Content-Type","application/json"),e.setRequestHeader("X-Rollbar-Access-Token",b)),e.onreadystatechange=f,e.send(c)}catch(g){if("undefined"!=typeof XDomainRequest){var h=function(){d(new Error)},i=function(){d(new Error)},j=function(){d(null,RollbarJSON.parse(e.responseText))};e=new XDomainRequest,e.onprogress=function(){},e.ontimeout=h,e.onerror=i,e.onload=j,e.open("POST",a,!0),e.send(c)}}}catch(k){d(k)}}};Notifier.NOTIFIER_VERSION="1.1.9",Notifier.DEFAULT_ENDPOINT="api.rollbar.com/api/1/",Notifier.DEFAULT_SCRUB_FIELDS=["passwd","password","secret","confirm_password","password_confirmation"],Notifier.DEFAULT_LOG_LEVEL="debug",Notifier.DEFAULT_REPORT_LEVEL="debug",Notifier.DEFAULT_UNCAUGHT_ERROR_LEVEL="warning",Notifier.DEFAULT_ITEMS_PER_MIN=60,Notifier.DEFAULT_MAX_ITEMS=0,Notifier.LEVELS={debug:0,info:1,warning:2,error:3,critical:4},window._rollbarPayloadQueue=[],window._globalRollbarOptions={startTime:(new Date).getTime(),maxItems:Notifier.DEFAULT_MAX_ITEMS,itemsPerMinute:Notifier.DEFAULT_ITEMS_PER_MIN};var TK=computeStackTraceWrapper({remoteFetching:!1,linesOfContext:3}),_topLevelNotifier;Notifier._generateLogFn=function(a){return _wrapNotifierFn(function(){var b=this._getLogArgs(arguments);return this._log(a||b.level||this.options.logLevel||Notifier.DEFAULT_LOG_LEVEL,b.message,b.err,b.custom,b.callback)})},Notifier.prototype._getLogArgs=function(a){for(var b,c,d,e,f,g,h,i=this.options.logLevel||Notifier.DEFAULT_LOG_LEVEL,j=0;j<a.length;++j)h=a[j],g=typeof h,"string"===g?c=h:"function"===g?f=_wrapNotifierFn(h,this):h&&"object"===g&&("Date"===h.constructor.name?b=h:h instanceof Error||h.prototype===Error.prototype||h.hasOwnProperty("stack")?d=h:e=h);return{level:i,message:c,err:d,custom:e,callback:f}},Notifier.prototype._route=function(a){var b=this.options.endpoint,c=/\/$/.test(b),d=/^\//.test(a);return c&&d?a=a.substring(1):c||d||(a="/"+a),b+a},Notifier.prototype._processShimQueue=function(a){for(var b,c,d,e,f,g,h,i={};c=a.shift();)b=c.shim,d=c.method,e=c.args,f=b.parentShim,h=i[b.shimId],h||(f?(g=i[f.shimId],h=new Notifier(g)):h=this,i[b.shimId]=h),h[d]&&"function"==typeof h[d]&&h[d].apply(h,e)},Notifier.prototype._buildPayload=function(a,b,c,d,e){var f=this.options.accessToken,g=this.options.environment,h=Util.copy(this.options.payload),i=Util.uuid4();if(void 0===Notifier.LEVELS[b])throw new Error("Invalid level");if(!c&&!d&&!e)throw new Error("No message, stack info or custom data");var j={environment:g,endpoint:this.options.endpoint,uuid:i,level:b,platform:"browser",framework:"browser-js",language:"javascript",body:this._buildBody(c,d,e),request:{url:window.location.href,query_string:window.location.search,user_ip:"$remote_ip"},client:{runtime_ms:a.getTime()-window._globalRollbarOptions.startTime,timestamp:Math.round(a.getTime()/1e3),javascript:{browser:window.navigator.userAgent,language:window.navigator.language,cookie_enabled:window.navigator.cookieEnabled,screen:{width:window.screen.width,height:window.screen.height},plugins:this._getBrowserPlugins()}},server:{},notifier:{name:"rollbar-browser-js",version:Notifier.NOTIFIER_VERSION}};h.body&&delete h.body;var k={access_token:f,data:Util.merge(j,h)};return this._scrub(k.data),k},Notifier.prototype._buildBody=function(a,b,c){var d;return d=b&&"failed"!==b.mode?this._buildPayloadBodyTrace(a,b,c):this._buildPayloadBodyMessage(a,c)},Notifier.prototype._buildPayloadBodyMessage=function(a,b){a||(a=b?RollbarJSON.stringify(b):"");var c={body:a};return b&&(c.extra=Util.copy(b)),{message:c}},Notifier.prototype._buildPayloadBodyTrace=function(a,b,c){var d=_guessErrorClass(b.message),e=b.name||d[0],f=d[1],g={exception:{"class":e,message:f}};if(a&&(g.exception.description=a||"uncaught exception"),b.stack){var h,i,j,k,l,m,n,o;for(g.frames=[],n=0;n<b.stack.length;++n)h=b.stack[n],i={filename:h.url?Util.sanitizeUrl(h.url):"(unknown)",lineno:h.line||null,method:h.func&&"?"!==h.func?h.func:"[anonymous]",colno:h.column},j=k=l=null,m=h.context?h.context.length:0,m&&(o=Math.floor(m/2),k=h.context.slice(0,o),j=h.context[o],l=h.context.slice(o)),j&&(i.code=j),(k||l)&&(i.context={},k&&k.length&&(i.context.pre=k),l&&l.length&&(i.context.post=l)),h.args&&(i.args=h.args),g.frames.push(i);return c&&(g.extra=Util.copy(c)),{trace:g}}return this._buildPayloadBodyMessage(e+": "+f,c)},Notifier.prototype._getBrowserPlugins=function(){if(!this._browserPlugins){var a,b,c=window.navigator.plugins||[],d=c.length,e=[];for(b=0;d>b;++b)a=c[b],e.push({name:a.name,description:a.description});this._browserPlugins=e}return this._browserPlugins},Notifier.prototype._scrub=function(a){function b(a,b,c,d,e,f){return b+Util.redact(f)}function c(a){var c;if("string"==typeof a)for(c=0;c<h.length;++c)a=a.replace(h[c],b);return a}function d(a,b){var c;for(c=0;c<g.length;++c)if(g[c].test(a)){b=Util.redact(b);break}return b}function e(a,b){var e=d(a,b);return e===b?c(e):e}var f=this.options.scrubFields,g=this._getScrubFieldRegexs(f),h=this._getScrubQueryParamRegexs(f);return Util.traverse(a,e),a},Notifier.prototype._getScrubFieldRegexs=function(a){for(var b,c=[],d=0;d<a.length;++d)b="\\[?(%5[bB])?"+a[d]+"\\[?(%5[bB])?\\]?(%5[dD])?",c.push(new RegExp(b,"i"));return c},Notifier.prototype._getScrubQueryParamRegexs=function(a){for(var b,c=[],d=0;d<a.length;++d)b="\\[?(%5[bB])?"+a[d]+"\\[?(%5[bB])?\\]?(%5[dD])?",c.push(new RegExp("("+b+"=)([^&\\n]+)","igm"));return c},Notifier.prototype._urlIsWhitelisted=function(a){var b,c,d,e,f,g,h,i,j,k;try{if(b=this.options.hostWhiteList,c=a.data.body.trace,!b||0===b.length)return!0;if(!c)return!0;for(h=b.length,f=c.frames.length,j=0;f>j;j++){if(d=c.frames[j],e=d.filename,"string"!=typeof e)return!0;for(k=0;h>k;k++)if(g=b[k],i=new RegExp(g),i.test(e))return!0}}catch(l){return this.configure({hostWhiteList:null}),this.error("Error while reading your configuration's hostWhiteList option. Removing custom hostWhiteList.",l),!0}return!1},Notifier.prototype._messageIsIgnored=function(a){var b,c,d,e,f,g,h;try{if(f=!1,d=this.options.ignoredMessages,h=a.data.body.trace,!d||0===d.length)return!1;if(!h)return!1;for(b=h.exception.message,e=d.length,c=0;e>c&&(g=new RegExp(d[c],"gi"),!(f=g.test(b)));c++);}catch(i){this.configure({ignoredMessages:null}),this.error("Error while reading your configuration's ignoredMessages option. Removing custom ignoredMessages.")}return f},Notifier.prototype._enqueuePayload=function(a,b,c,d){var e={callback:d,accessToken:this.options.accessToken,endpointUrl:this._route("item/"),payload:a},f=function(){if(d){var a="This item was not sent to Rollbar because it was ignored. This can happen if a custom checkIgnore() function was used or if the item's level was less than the notifier' reportLevel. See https://rollbar.com/docs/notifier/rollbar.js/configuration for more details.";d(null,{err:0,result:{id:null,uuid:null,message:a}})}};if(this._internalCheckIgnore(b,c,a))return f(),void 0;try{if(this.options.checkIgnore&&"function"==typeof this.options.checkIgnore&&this.options.checkIgnore(b,c,a))return f(),void 0}catch(g){this.configure({checkIgnore:null}),this.error("Error while calling custom checkIgnore() function. Removing custom checkIgnore().",g)}if(this._urlIsWhitelisted(a)&&!this._messageIsIgnored(a)){if(this.options.verbose){if(a.data&&a.data.body&&a.data.body.trace){var h=a.data.body.trace,i=h.exception.message;this.logger(i)}this.logger("Sending payload -",e)}"function"==typeof this.options.logFunction&&this.options.logFunction(e);try{"function"==typeof this.options.transform&&this.options.transform(a)}catch(g){this.configure({transform:null}),this.error("Error while calling custom transform() function. Removing custom transform().",g)}this.options.enabled&&window._rollbarPayloadQueue.push(e)}},Notifier.prototype._internalCheckIgnore=function(a,b,c){var d=b[0],e=Notifier.LEVELS[d]||0,f=Notifier.LEVELS[this.options.reportLevel]||0;if(f>e)return!0;var g=this.options?this.options.plugins:{};return g&&g.jquery&&g.jquery.ignoreAjaxErrors&&c.body.message?c.body.messagejquery_ajax_error:!1},Notifier.prototype._log=function(a,b,c,d,e,f,g){var h=null;if(c){if(h=c._tkStackTrace?c._tkStackTrace:TK(c),c===this.lastError)return;this.lastError=c}var i=this._buildPayload(new Date,a,b,h,d);g&&(i.ignoreRateLimit=!0),this._enqueuePayload(i,f?!0:!1,[a,b,c,d],e)},Notifier.prototype.log=Notifier._generateLogFn(),Notifier.prototype.debug=Notifier._generateLogFn("debug"),Notifier.prototype.info=Notifier._generateLogFn("info"),Notifier.prototype.warn=Notifier._generateLogFn("warning"),Notifier.prototype.warning=Notifier._generateLogFn("warning"),Notifier.prototype.error=Notifier._generateLogFn("error"),Notifier.prototype.critical=Notifier._generateLogFn("critical"),Notifier.prototype.uncaughtError=_wrapNotifierFn(function(a,b,c,d,e,f){if(f=f||null,e&&e.stack)return this._log(this.options.uncaughtErrorLevel,a,e,f,null,!0),void 0;if(b&&b.stack)return this._log(this.options.uncaughtErrorLevel,a,b,f,null,!0),void 0;var g={url:b||"",line:c};g.func=TK.guessFunctionName(g.url,g.line),g.context=TK.gatherContext(g.url,g.line);var h={mode:"onerror",message:a||"uncaught exception",url:document.location.href,stack:[g],useragent:navigator.userAgent};e&&(h=e._tkStackTrace||TK(e));var i=this._buildPayload(new Date,this.options.uncaughtErrorLevel,a,h);this._enqueuePayload(i,!0,[this.options.uncaughtErrorLevel,a,b,c,d,e])}),Notifier.prototype.global=_wrapNotifierFn(function(a){a=a||{},Util.merge(window._globalRollbarOptions,a),void 0!==a.maxItems&&(rateLimitCounter=0),void 0!==a.itemsPerMinute&&(rateLimitPerMinCounter=0)}),Notifier.prototype.configure=_wrapNotifierFn(function(a){Util.merge(this.options,a)}),Notifier.prototype.scope=_wrapNotifierFn(function(a){var b=new Notifier(this);return Util.merge(b.options.payload,a),b}),Notifier.prototype.wrap=function(a,b){var c;if(c="function"==typeof b?b:function(){return b||{}},"function"!=typeof a)return a;if(a._isWrap)return a;if(!a._wrapped){a._wrapped=function(){try{a.apply(this,arguments)}catch(b){throw b.stack||(b._tkStackTrace=TK(b)),b._rollbarContext=c(),b._rollbarContext._wrappedSource=a.toString(),window._rollbarWrappedError=b,b}},a._wrapped._isWrap=!0;for(var d in a)a.hasOwnProperty(d)&&(a._wrapped[d]=a[d])}return a._wrapped};var ERR_CLASS_REGEXP=new RegExp("^(([a-zA-Z0-9-_$ ]*): *)?(Uncaught )?([a-zA-Z0-9-_$ ]*): "),payloadProcessorTimeout;Notifier.processPayloads=function(a){(!payloadProcessorTimeout||a)&&_payloadProcessorTimer(a)};var rateLimitStartTime=(new Date).getTime(),rateLimitCounter=0,rateLimitPerMinCounter=0,globalNotifier=new Notifier;window._rollbarWrappedError=null,globalNotifier.init=function(a){if(this.configure(a),a.captureUncaught){var b=window.onerror;window.onerror=function(){var a=Array.prototype.slice.call(arguments,0);_rollbarWindowOnError(globalNotifier,b,a)};var c,d,e=["EventTarget","Window","Node","ApplicationCache","AudioTrackList","ChannelMergerNode","CryptoOperation","EventSource","FileReader","HTMLUnknownElement","IDBDatabase","IDBRequest","IDBTransaction","KeyOperation","MediaController","MessagePort","ModalWindow","Notification","SVGElementInstance","Screen","TextTrack","TextTrackCue","TextTrackList","WebSocket","WebSocketWorker","Worker","XMLHttpRequest","XMLHttpRequestEventTarget","XMLHttpRequestUpload"];for(c=0;c<e.length;++c)d=e[c],window[d]&&window[d].prototype&&_extendListenerPrototype(this,window[d].prototype)}Notifier.processPayloads()},module.exports=globalNotifier});
define('views/user',[
	"models/user",
	"libs/routie"
], function (users) {
	var config = {
		login: "#!/app/login",
		afterLogin: "",
		afterLogout: "#!/app/login",
		ping: 5000
	};
	var session = users.session;
	//check user's status
	function ping() {
		if (users.getCurrentUser()) {
			session.status().then(function (status) {
				var timestampNow = Date.now() / 1000 | 0;
				var credential = users.getAppCookie();
				var difference = timestampNow - credential.timestamp;
				//var daysDifference = Math.floor(difference/1000/60/60/24);
				var date = new Date(difference * 1000);
				var minutes = date.getMinutes();
				if (minutes >= 355) {
					try_to_logout();
				}
			});
		}
	}
	//show inner or external link
	function show(url) {
		// Using the router() or show()-methods will not change the url in the browser.
		/*if (url.indexOf("#") === 0)
			require(["app"], function(app){
				//app.show(url.substr(2));
				app.router(url.substr(2));
			});
		else*/
		document.location.href = url;
	}
	//reaction on logout link
	function try_to_logout() {
		users.logout();
		show(config.afterLogout);
	}
	//reaction on login link
	function try_to_login(a) {
		console.log("Trying to login");
		if (users.getAccessToken())
			show(config.afterLogin);
		else
			require(["app"], function (app) {
				//app.router("/login");
				app.show("/login");
			});
	}
	routie("!/logout", try_to_logout);
	return {
		$oninit: function (app, newconfig) {
			if (newconfig)
				webix.extend(config, newconfig, true);
			if (config.ping)
				setInterval(ping, config.ping);
			config.afterLogin = config.afterLogin || ("#!" + app.config.start);
			ping();
		},
		$onurl: function (url) {
			var user = users.getAccessToken();
			var isUserNullAndNotLogin = !user && url !== "login";
			var isUserExistAndLogin = user && url === "login";
			var specialUrls = ["retrivepass", "updateToWeb", "quenmk", "buyer-sign"];

			if (isUserNullAndNotLogin || isUserExistAndLogin) {
				if (!specialUrls.includes(url)) {
					try_to_login();
					return false;
				}
			}
		},
		login: try_to_login,
		logout: try_to_logout,
		afterLogin: function (response) {
			users.setCurrentUser(response, true);
			webix.delay(function () {
				require(["app"], function (app) {
					app.router("app/" + config.afterLogin);
					//app.show("/login");
				});
				//show(config.afterLogin);
			});
		}
	};
});

/*
	App configuration
*/

define('app',[
	"libs/core",
	"helpers/menu",
	"helpers/locale",
	"helpers/theme",
	"libs/rollbar",
	"views/user"
], function (core, menu, locale, theme, tracker, user) {
	// webix.skin.set("mini");
	webix.skin.$active.inputHeight = 32;
	webix.skin.$active.menuHeight = 28;
	webix.skin.$active.listItemHeight = 28;
	webix.skin.$active.buttonHeight = 30;
	webix.skin.$active.rowHeight = 25;
	// webix.skin.mini = {
	//     topLayout:"space",
	//     //bar in accordion
	//     barHeight:44,           //!!!Set the same in skin.less!!!
	//     tabbarHeight: 42,
	//     sidebarTitleHeight: 44,
	//     rowHeight:36,
	//     toolbarHeight:44,
	//     listItemHeight:36,      //list, grouplist, dataview, etc.
	//     inputHeight: 38,
	//     buttonHeight: 38,
	//     inputPadding: 3,
	//     menuHeight: 36,
	//     labelTopHeight: 22,
	//     propertyItemHeight: 28,
	//     unitHeaderHeight:36,
	//     inputSpacing: 4,
	//     borderWidth: 1,
	//     sliderHandleWidth: 14,
	//     sliderPadding: 10,
	//     sliderBorder: 1,
	//     vSliderPadding:15,
	//     vSliderHeight:100,
	//     switchHeight:22,
	//     switchWidth:50,
	//     //margin - distance between cells
	//     layoutMargin:{ 
	//         space:10, wide:10, clean:0, head:4, 
	//         line:-1, toolbar:4, form:8, accordion: 2  
	//     },
	//     //padding - distance inside cell between cell border and cell content
	//     layoutPadding:{ 
	//         space:10, wide:0, clean:0, head:0, 
	//         line:0, toolbar:2, form:17, accordion: 0  
	//     },
	//     //space between tabs in tabbar
	//     tabMargin: 0,
	//     tabOffset: 0,
	//     tabBottomOffset: 0,
	//     tabTopOffset:0,
	//     tabbarWithBorder: true,
	//     customCheckbox: true,
	//     customRadio: true,
	//     sidebarMarkAll: true,
	//     noPoint: true,
	//     borderlessPopup: true,
	//     popupPadding: 0,
	//     calendar:{ timepickerHeight:24 },
	//     calendarHeight: 70,
	//     padding:0,
	//     accordionType: "accordion",
	//     optionHeight: 32,
	//     organogramLineColor: "#CCD7E6"
	// };
	webix.codebase = document.location.href.split("#")[0].replace("index.html", "") + "libs/webix/";
	webix.i18n.dateFormat = "%d/%m/%Y";
	webix.i18n.setLocale();
	// set CDN not default  using export (excel, pdf) of webix
	webix.require.disabled = true;
	function isValidCCCD(value) {
		if (!/^\d{12}$/.test(value)) return false;

		const region = parseInt(value.substr(0, 3), 10);
		const genDigit = parseInt(value.charAt(3), 10);
		const birthYear = parseInt(value.substr(4, 2), 10);
		const randomPart = value.substr(6, 6);

		return genDigit >= 0 && genDigit <= 5;
	};
	function isValidTaxCode(value) {
		var patt = /^[0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9]$/;
		if (value.length > 10) {
			patt = /^[0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9][-][0-9][0-9][0-9]$/;
		}
		if (value == "") return true;
		if (patt.test(value) == false) {
			return false;
		}
		var number = Number(value.charAt(0)) * 31 + Number(value.charAt(1)) * 29 + Number(value.charAt(2)) * 23
			+ Number(value.charAt(3)) * 19 + Number(value.charAt(4)) * 17 + Number(value.charAt(5)) * 13
			+ Number(value.charAt(6)) * 7 + Number(value.charAt(7)) * 5 + Number(value.charAt(8)) * 3;

		return (10 - number % 11) == Number(value.charAt(9));
	};
	webix.rules.validateDenominator = function (value, name) {
		if (value.length != 11) {
			this.markInvalid(name, "Too short");
			return false;
		}
		else
			return true;
	}
	webix.rules.validateMoney = function (obj) {
		var matt = webix.storage.local.get("MA_TIEN_TE");
		var DECIMAL_TOTAL_AMOUNT = webix.storage.local.get("DECIMAL_TOTAL_AMOUNT");
		var so_luong = webix.rules.isNumber(obj.sluong) ? obj.sluong : 0;
		var don_gia = webix.rules.isNumber(obj.dgia) ? obj.dgia : 0;
		if (so_luong != 0 && don_gia != 0) {
			var tien_ck = webix.rules.isNumber(obj.stckhau) ? obj.stckhau : 0;
			var tien = (so_luong * don_gia) - tien_ck;
			if (matt == null || matt == "VND" || matt == "VNĐ")
				tien = Number(tien.toFixed(0));
			if (tien.toFixed(DECIMAL_TOTAL_AMOUNT) != obj.thtien)
				return false;
			else
				return true;
		}
		else
			return true;
	};
	webix.rules.isSpecialCharacter = function (value) {
		var patt = /^[a-zA-Z0-9\$%\^\&*\)\(+=._-]+$/;
		return patt.test(value);
	};
	webix.rules.isPhoneNumber = function (value) {
		if (value == "") return true;
		var patt = /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/;
		return patt.test(value);
	};
	webix.rules.isTaxCode = function (value) {
		return isValidTaxCode(value);
	};
	webix.rules.isTaxOrCCCD = function (value) {
		return isValidTaxCode(value) || isValidCCCD(value);
	};
	if (!webix.env.touch && webix.ui.scrollSize && webix.CustomScroll)
		webix.CustomScroll.init();

	//configuration
	var app = core.create({
		id: "admin-demo",
		name: "Webix Admin",
		version: "0.1",
		debug: true,
		start: "/app/dashboard",
		host: "http://localhost:18374"
	});
	var port = "";
	if (document.location.protocol == "file:" || document.location.host.startsWith("127.0.0.1")) {
		app.config.host = "http://localhost:18374/";
	}
	else {
		if (document.location.port != 80 && document.location.port != 445 && document.location.port != 443) {
			port = ":" + document.location.port.toString();
		}
		app.config.host = document.location.protocol + "//" + document.location.hostname + port + "/api";
	}
	document.onkeydown = function () {
		var x = event.keyCode;
		if (((x == 70) || (x == 78) || (x == 79) || (x == 80)) && (event.ctrlKey) || (x > 111 && x < 124)) {
			//alert ("No new window")
			event.cancelBubble = true;
			event.returnValue = false;
			event.keyCode = false;
			return false;
		}
	}
	webix.attachEvent('unload', function (e) {
		console.log(e);
	});
	webix.UIManager.addHotKey("any", function (view, ev) {
		if (typeof view.getTopParentView !== "function") return;
		var topParent = view.getTopParentView();
		var elButtons = topParent.$view.getElementsByClassName("webix_el_button");
		if (elButtons.length > 0) {
			for (var i = 0; i < elButtons.length; i++) {
				var element = elButtons[i];
				var viewId = element.attributes["view_id"].value;
				var button = webix.$$(viewId);
				if (button.config.shortcut != "undefined") {
					var shortcut = button.config.shortcut;
					if (shortcut == ev.code) {
						button.callEvent("onClick");
						return;
					}
				}
			}
		}
	});
	webix.UIManager.addHotKey("esc", function (view) {
		if (typeof view.getTopParentView !== "function") return;
		var topParent = view.getTopParentView();
		var elButtons = topParent.$view.getElementsByClassName("webix_el_button");
		if (elButtons.length > 0) {
			for (var i = 0; i < elButtons.length; i++) {
				var element = elButtons[i];
				var viewId = element.attributes["view_id"].value;
				var button = webix.$$(viewId);

				if (button.config.shortcut == "esc") {
					button.callEvent("onClick");
					return;
				}
			}
		}
	});
	if (webix.storage.local.get("APP_CACHE") == null) {
		var app_cache = {
		};
		webix.storage.local.put("APP_CACHE", app_cache);
	}
	app.use(menu);
	app.use(locale);
	app.use(theme);
	app.use(user);

	return app;
});
;
define("views/1", function(){});

define('views/modules/Component/constantManager',[
    "app"
], function (app) {
    var baseApi = app.config.host;
    return {
        DA_GUI: "Đã gửi",
        DA_KY: "Đã ký",
        CHO_KY: "Chờ ký",
        THANH_CONG: "Thành công",
        CO_LOI: "Có lỗi",
        KEY_EMAIL: "6DEA50C84B9506624BE9",
        MESSAGE: {

        },
        COLOR: {
            DA_GUI: "#2a94db",
            CO_LOI: "#FF0000",
            DA_KY: "#0069B4",
            CHO_KY: "#f47537",
            CHO_DUYET: "#f47537",
            TIEP_NHAN: "#00b300",
            CHAP_NHAN: "#2a94db",
            KHONG_CHAP_NHAN: "#FF0000"
        },
        CHUNK: {
            DANH_SACH_KY_BIEN_LAI: 20
        },
        CACHE: {
            TTKHAC: "CACHE_TTKHAC_",
            TTKHAC_CT: "CACHE_TTKHAC_CT_",
            ON_INIT: "ON_INIT_",
            DECIMAL_PLACES: "DECIMAL_PLACES",
            AFTER_EDIT: "AFTER_EDIT_",
            BUTTON_EXCEL: "BUTTON_EXCEL_"
        },
        API: {
            GET_AFTER_EDIT: baseApi + "/Pattern/GetAfterEdit?type=",
            SERIAL: baseApi + "/Serial/GetAllSeriTTDC",
            SERIAL_SEARCH: baseApi + "/Serial/GetAllSeriTTDC?khieu=",
            SERIAL_TYPE: baseApi + "/Invoice68/GetTypeInvoiceSeries?type=",
            TTKHAC: baseApi + "/Pattern/GetTTKhacColumn?type=",
            TTKHAC_CT: baseApi + "/Pattern/GetTTKhacColumnCT?type=",
            DECIMAL_PLACES: baseApi + "/Invoice/GetDecimalPlace?ma_nt=",
            GET_DETAIL_INVOICE: baseApi + "/Invoice68/GetDetailInvoice?id=",
            GET_MA_TIEN_TE: baseApi + "/System/GetDataReferencesByRefId?refId=RF00188",
            GET_HTTTOAN: baseApi + "/Pattern/GetData?command=CM0027&start=0&count=100&filter=null",
            GET_COMBOBOX_XANGDAU: baseApi + "/Pattern/GetData?command=CM0032&start=0&count=2000&filter=null",
            GET_DM_XANGDAU: baseApi + "/Pattern/GetData?command=CM0031&start=0&count=2000&filter=null",
            GET_DM_XANGDAU_FILTER: baseApi + "/Pattern/GetData?command=CM0031&start=0&count=2000&filter=",
            POST_INFO_MST_GOV: "https://hoadondientu.gdt.gov.vn:30000/category/public/dsdkts/",
            SEARCH_TAXCODE: "https://mst.minvoice.com.vn/api/System/SearchTaxCode?tax=",
            POST_INFO_MST: baseApi + "/Pattern/GetInfoMST",
            POST_INFO_CID: "https://mst.minvoice.com.vn/api/System/SearchCMND?cid=",
            GET_MA_DT: baseApi + "/System/GetDataByReferencesId?id=2b52e2d9-5394-431a-b8bb-a234e5f9e4a4",
            GET_NHOM_DT: baseApi + "/System/GetDataByReferencesId?id=da48ab0e-65f8-4ca9-a1b2-3b75c0d10632",
            GET_COMBO_DVT: baseApi + "/System/GetDataByReferencesId?id=883B9B50-C52B-46BE-9D5A-4755D48183A5",
            GET_DVT: baseApi + "/System/GetDataByReferencesId?id=883B9B50-C52B-46BE-9D5A-4755D48183A5",
            GET_DVT_PETRO: baseApi + "/Pattern/GetData?command=CM0033&start=0&count=2000&filter=null",
            GET_MA_HANG_HOA: baseApi + "/System/GetDataByReferencesId?id=3A99C8EC-A467-4591-85E5-E5DFEC4FEAE0",
            GET_DMDVCS: baseApi + "/System/GetInfoCompany",
            GET_BUTTON_EXCEL: baseApi + "/Pattern/GetButtonExcel?type=",
            INVOICE_EXPORT_XML: baseApi + "/Invoice68/ExportFileXML?id=",
            INVOICE_THAY_THE: baseApi + "/Invoice68/ThayThe",
            INVOICE_DIEU_CHINH: baseApi + "/Invoice68/DieuChinh",
            INVOICE_DELETE_MULTIPLE: baseApi + "/Invoice68/DeleteMultiChoice",
            INVOICE_SEND_EMAIL_MULTIPLE: baseApi + "/Invoice68/EmailMulti",
            INVOICE_TEMP_EMAIL: baseApi + "/Invoice68/GetEmailTemplate",
            INVOICE_SAVE: baseApi + "/Pattern/Save",
            INVOICE_SAVE_XML_NOSEND: baseApi + "/Invoice68/SaveXMLNotSend",
            INVOICE_SAVE_XML: baseApi + "/Invoice68/SaveXml",
            INVOICE_GET_TYPE_SIGN: baseApi + "/Pattern/GetSignType",
            INVOICE_SIGN_FILE: baseApi + "/Invoice68/SignInvoiceByFile",
            INVOICE_SIGN_ICA_NOSEND: baseApi + "/TokenCloud/IcaSignInvoiceNotSend",
            INVOICE_SIGN_ICA: baseApi + "/TokenCloud/IcaSignInvoice",
            INVOICE_SIGN_INTRUSTCA: baseApi + "/TokenCloud/SignInvoiceByIntrustCa",
            INVOICE_TYPE_CREATE_NUMBER: baseApi + "/Invoice68/GetTypeCreateNumberInvoice",
            INVOICE_CHECK_DATE: baseApi + "/Invoice68/InvoiceCheckDate",
            TOKEN_SHOW_PIN: baseApi + "/TokenCloud/CheckShowPinCode",
            TOKEN_CERT_FILE: baseApi + "/Invoice/GetListCertificatesFile",
            TOKEN_CERT_AUTO: baseApi + "/Invoice/GetListCertificatesAuto",
            TOKEN_CERT_EASYCA: baseApi + "/Invoice/GetListCertificatesEasyCA",
            SEND_EMAIL_LOG: "/Invoice68/ViewLogEmail?id=",
            SEND_EMAIL: "/Invoice68/Email",
            GET_EMAIL_OPTIONS: "/System/GetOTPMail",
            GET_DETAIL_TAB_TABLE: "/System/GetDataDetailsByTabTable",
            SIGN: {
                GET_LIST_INVOICE: "/Invoice68/GetInvoiceChoky",
                GET_INVOICE_ALL_STATUS: "/Invoice68/GetInvoiceAllStatus",
                CHECK_SHOW_PIN: "/TokenCloud/CheckShowPinCode",

                EASY_CA: "/Invoice68/SignEasyCAMulti",
                EASY_CA_NOT_SEND: "/Invoice68/SignEasyCAMultiNotSend",
                EASY_CA_TAG_SIGN: "HDon/DSCKS/NBan",

                ICA: "/TokenCloud/IcaSignInvoiceMulti",
                ICA_LABEL: "invoiceSignMulti",
                ICA_NOT_SEND: "/TokenCloud/IcaSignInvoiceMultiNotSend",
                ICA_NOT_SEND_LABEL: "invoiceSignMultiNotSend",

                FILE: "/Invoice68/SignInvoiceByFile",
                INTRUSTCA: baseApi + "/TokenCloud/SignInvoiceByIntrustCa",
                INTRUSTCA_BTH: "/SummaryData/SignByIntrustCa",
                INTRUSTCA_DANGKY: "/Register68/SignRegisterByIntrustCa",
                INTRUSTCA_04SS: "/CancelInvoice/SignCancelInvoiceByIntrustCa",
                INTRUSTCA_VOUCHER: "/Voucher/SignByIntrustCa"
            },
            MAU04: {
                SEND_EMAIL_LOG: "/CancelInvoice/ViewLogEmail?id=",
                SEND_EMAIL: "/CancelInvoice/SendEmail"
            },
            VOUCHER: {
                SEND_EMAIL_LOG: "/Voucher/ViewLogEmail?id=",
                SEND_EMAIL: "/Voucher/SendEmail",
            },
            PAYMENT_REQUEST: {
                SAVE: baseApi + "/PaymentRequest/Save",
                GET_DETAIL: baseApi + "/PaymentRequest/GetDetail?id=",
                DELETE_MULTIPLE: baseApi + "/PaymentRequest/DeleteMultiChoice",
                CHANGE_STATUS: baseApi + "/PaymentRequest/ChangeStatus",
                PRINT: baseApi + "/PaymentRequest/Print?id=",
                CREATE_REPORT: baseApi + "/PaymentRequest/CreateReport",
                EXPORT_EXCEL: baseApi + "/PaymentRequest/ExportExcel",
            },
            BANGKE: {
                GET_INVOICE: "/Bangke70/GetHoaDon",
                SAVE_BANGKE: "/Bangke70/Save",
            },
            BIENBAN: {
                SAVE_BIENBAN: "/Bienban70/Save",
                SIGN_BIENBAN_BYFILE: "/Bienban70/SignByFile",
                SIGN_BY_ICA: "/Bienban70/SignByIca",
                SIGN_BY_INTRUSTCA: "/Bienban70/SignByIntrustCa",
                GET_BIENBAN_BY_ID: "/Bienban70/GetBienbanById",
                PRINT_BIENBAN: "/Bienban70/PrintBienban",
                GET_XML: "/Bienban70/GetXml",
                SAVE_XML: "/Bienban70/SaveXml",
                UPLOAD_BIENBAN: "/Bienban70/UploadFile",
                EMAIL_LOG: "/Bienban70/ViewLogEmail?bienban_id=",
                GET_XML_BUYER: "/Bienban70/GetXmlBuyer",
                SAVE_XML_BUYER: "/Bienban70/SaveXmlBuyer",
            },
            DMKH: {
                SAVE: baseApi + "/Category/CustomerSaveChange",
                DELETE_MULTIPLE: baseApi + "/Category/CustomerDeleteMultiChoice",
            },
            REGISTER70: {
                GET_REGISTERINVOICE: "/Register70/GetRegisterInvoice",
                SAVE_REGISTER70: "/Register70/Mau01SaveChange",
                BEFORADDNEW: "/Register70/BeforeAddNew",
                MAU01_DELETE: "/Register70/Mau01Delete",
                SIGN_BY_VNET: "/Register70/SignByVnet",
                PRINT_MAU01: "/Register70/PrintMau01",
                SIGN_BY_FILE: "/Register70/SignByFile",
                SIGN_BY_ICA: "/Register70/SignByIca",
                SIGN_BY_INTRUSTCA:"/Register70/SignRegisterByIntrustCa",
                GET_XML: "/Register70/GetXml",
                SAVE_XML: "/Register70/SaveXml",
                GET_GIAIPHAP: "/Register70/GetGiaiPhap",
                GET_TVAN: "/Register70/GetTVan"
            },
            BC26: {
                GET_DATA: "/Receip/BC26GetData",
                SAVE: "/Receip/BC26Save",
                DELETE: "/Receip/BC26Delete",
                GET_BY_ID: "/Receip/BC26GetById",
                DOWNLOAD_XML: "/Receip/ExportFileXML",
                SEND_TVAN: "/Receip/SendToTVAN",
                SIGN: "/Receip/BC26SignService",
                GET_XML:"/Receip/BC26GetXml",
                PRINTBC26:"/Receip/BC26Print",
                BC26SAVE_XML:"/Receip/BC26SaveXml"
            },
            RECEIP: {
                GET_XML: baseApi + "/Receip/GetXmlReceip",
                SIGN: baseApi + "/Receip/SignService",
                SAVE_XML: baseApi + "/Receip/SaveXml",
                PRINT: baseApi + "/Receip/Print?id="
            }
        },
        STATUS_SEND_INVOICE: [
            { id: "Chờ ký", value: "Chờ ký" },
            { id: "Đã ký", value: "Đã ký" },
            { id: "Đã gửi", value: "Đã gửi" },
            { id: "Thành công", value: "Thành công" },
            { id: "Có lỗi", value: "Có lỗi" }
        ],
        STATUS_INVOICE: [
            { id: "Mới", value: "Mới" },
            { id: "Hủy", value: "Hủy" },
            { id: "Xóa bỏ", value: "Xóa bỏ" },
            { id: "Điều chỉnh", value: "Điều chỉnh" },
            { id: "Thay thế", value: "Thay thế" },
            { id: "Giải trình", value: "Giải trình" },
            { id: "Bị thay thế", value: "Bị thay thế" },
            { id: "Bị điều chỉnh", value: "Bị điều chỉnh" }
        ],
        STATUS_SEND_EMAIL: [
            { id: "thirdState", value: "" },
            { id: "True", value: "Đã gửi" },
            { id: "False", value: "Chưa gửi" }
        ],
        STATUS_PAYMENT_REQUEST: [
            { id: "0", value: "Chờ TT" },
            { id: "1", value: "Đã TT" },
            { id: "2", value: "TT QR" },
        ],
        STATUS_PAYMENT_REQUEST_MAP: {
            "0": "Chờ TT",
            "1": "Đã TT",
            "2": "TT QR"
        },
        LOAI_TBAO_04SS: [
            { id: "1", value: "Thông báo của Người nộp thuế" },
            { id: "2", value: "Thông báo của Người nộp thuế theo thông báo của CQT" }
        ]
    }
});
define('views/modules/Component/functionExtension',["app", "locale", "views/modules/Component/constantManager"], function (app, _, Constant) {
	var eventChanged = "dataChangedMau0405";
	var eventChangedInvoice = "dataChangedInvoie68";

	const digit = [" không ", " một ", " hai ", " ba ", " bốn ", " năm ", " sáu ", " bảy ", " tám ", " chín "];
	const money = ["", " nghìn", " triệu", " tỷ", " nghìn", " triệu"];
	const ext = [" linh ", " mốt ", " lăm ", " mươi", " mười ", " trăm "];

	var a = ["", "one ", "two ", "three ", "four ", "five ", "six ", "seven ", "eight ", "nine ", "ten ", "eleven ", "twelve ", "thirteen ", "fourteen ", "fifteen ", "sixteen ", "seventeen ", "eighteen ", "nineteen "];
	var b = ["", "", "twenty", "thirty", "forty", "fifty", "sixty", "seventy", "eighty", "ninety"];

	var ChuSo = new Array(" không", " một", " hai", " ba", " bốn", " năm", " sáu", " bảy", " tám", " chín");
	var Tien = new Array("", " nghìn", " triệu", " tỷ", " nghìn tỷ", " triệu tỷ");
	var Tien4 = new Array("", " nghìn", " triệu", " tỷ", " nghìn", " triệu");

	function ExcelDateToJSDate(serial) {
		var utc_days = Math.floor(serial - 25569);
		var utc_value = utc_days * 86400;
		var date_info = new Date(utc_value * 1000);

		var fractional_day = serial - Math.floor(serial) + 0.0000001;
		var total_seconds = Math.floor(86400 * fractional_day);
		var seconds = total_seconds % 60;
		total_seconds -= seconds;
		var hours = Math.floor(total_seconds / (60 * 60));
		var minutes = Math.floor(total_seconds / 60) % 60;

		return new Date(date_info.getFullYear(), date_info.getMonth(), date_info.getDate(), hours, minutes, seconds);
	}
	var converAmountToWords = (amount, currencyType) => {
		let format = "";
		switch (currencyType) {
			case "VND":
				format = "vn";
				break;
			case "VNĐ":
				format = "vn";
				break;
			case "USD":
				format = "en";
				break;
			default:
				format = currencyType;
				break;
		}
		return numberToWords(amount, format);
	};
	function numberToWords(number, language) {
		if (language === "vn") {
			return numberToWordsVn(number);
		}
		if (language === "en") {
			return numberToWordsEn(number, "");
		}
		return numberToWordsEn(number, language);
	}
	function readThreeNumber(threeNumber) {
		var result = "";
		var hundred = parseInt(threeNumber / 100);
		var dozen = parseInt((threeNumber % 100) / 10);
		var unit = threeNumber % 10;
		if (hundred === 0 && dozen === 0 && unit === 0) return "";
		result += digit[hundred] + ext[5];
		if (dozen === 0 && unit !== 0) result += ext[dozen];
		if (dozen !== 0 && dozen !== 1) {
			result += digit[dozen] + ext[3];
			if (dozen === 0 && unit !== 0) result = result + ext[dozen];
		}
		if (dozen === 1) result += ext[4];
		switch (unit) {
			case 1:
				if (dozen !== 0 && dozen !== 1) {
					result += ext[1];
				} else {
					result += digit[unit];
				}
				break;
			case 5:
				if (dozen === 0) {
					result += digit[unit];
				} else {
					result += ext[2];
				}
				break;
			default:
				if (unit !== 0) {
					result += digit[unit];
				}
				break;
		}
		return result;
	}
	function numberToWordsVn(num) {
		num = parseInt(num);
		var times = 0,
			number = 0,
			i = 0;
		var result = "",
			tmp = "";
		var location = [];
		if (num < 0) return "Số tiền âm !";
		if (num === 0) return "Không đồng !";
		if (num > 0) {
			number = num;
		} else {
			number = -num;
		}
		if (num > 8999999999999999) {
			return "Số quá lớn!";
		}
		location[5] = Math.floor(number / 1000000000000000);
		if (isNaN(location[5])) location[5] = "0";
		number = number - parseFloat(location[5].toString()) * 1000000000000000;
		location[4] = Math.floor(number / 1000000000000);
		if (isNaN(location[4])) location[4] = "0";
		number = number - parseFloat(location[4].toString()) * 1000000000000;
		location[3] = Math.floor(number / 1000000000);
		if (isNaN(location[3])) location[3] = "0";
		number = number - parseFloat(location[3].toString()) * 1000000000;
		location[2] = parseInt(number / 1000000);
		if (isNaN(location[2])) location[2] = "0";
		location[1] = parseInt((number % 1000000) / 1000);
		if (isNaN(location[1])) location[1] = "0";
		location[0] = parseInt(number % 1000);
		if (isNaN(location[0])) location[0] = "0";
		if (location[5] > 0) {
			times = 5;
		} else if (location[4] > 0) {
			times = 4;
		} else if (location[3] > 0) {
			times = 3;
		} else if (location[2] > 0) {
			times = 2;
		} else if (location[1] > 0) {
			times = 1;
		} else {
			times = 0;
		}
		for (i = times; i >= 0; i--) {
			tmp = readThreeNumber(location[i]);
			if (i === times && tmp.startsWith(digit[0])) tmp = tmp.replace(digit[0], "").replace(ext[0], "").replace(ext[5], "");
			result += tmp;
			if (location[i] > 0) result += money[i];
			if (i > 0 && tmp.length > 0) result += " ";
		}

		if (times > 3 && result.trim().split(" ").length <= 5) result += money[3];
		if (result.substring(result.length - 1) === ",") {
			result = result.substring(0, result.length - 1);
		}
		result = result.substring(1, 2).toUpperCase() + result.substring(2);
		return result.trim() + " đồng";
	}
	function numberToWordsEn(num, l) {
		console.log(num);
		console.log(l);
		if (num === 0) return l === "" ? "Zero dollars !" : "Zero " + l;
		if ((num = num.toString()).length > 17) return "overflow";
		var n = ("00000000000000000" + num).substr(-17).match(/^(\d{2})(\d{1})(\d{2})(\d{1})(\d{2})(\d{1})(\d{2})(\d{1})(\d{2})(\d{1})(\d{2})$/);
		if (!n) return;
		var str = "";
		str += n[1] !== "00" ? (a[Number(n[1])] || b[n[1][0]] + " " + a[n[1][1]]) + "milion " : "";
		str += n[2] !== "0" ? (a[Number(n[2])] || b[n[2][0]] + " " + a[n[2][1]]) + "hundred " : n[1] !== "00" ? "bilion " : "";
		str += n[3] !== "00" ? (a[Number(n[3])] || b[n[3][0]] + " " + a[n[3][1]]) + "thousand " : n[2] !== "0" ? "thousand bilion " : "";
		str += n[4] !== "0" ? (a[Number(n[4])] || b[n[4][0]] + " " + a[n[4][1]]) + "hundred " : n[3] !== "00" ? "bilion " : "";
		str += n[5] !== "00" ? (a[Number(n[5])] || b[n[5][0]] + " " + a[n[5][1]]) + "bilion " : n[4] !== "0" ? "bilion " : "";
		str += n[6] !== "0" ? (a[Number(n[6])] || b[n[6][0]] + " " + a[n[6][1]]) + "hundred " : "";
		str += n[7] !== "00" ? (a[Number(n[7])] || b[n[7][0]] + " " + a[n[7][1]]) + "milion " : n[6] !== "0" ? "milion " : "";
		str += n[8] !== "0" ? (a[Number(n[8])] || b[n[8][0]] + " " + a[n[8][1]]) + "hundred " : "";
		str += n[9] !== "00" ? (a[Number(n[9])] || b[n[9][0]] + " " + a[n[9][1]]) + "thousand " : n[8] !== "0" ? "thousand " : "";
		str += n[10] !== "0" ? (a[Number(n[10])] || b[n[10][0]] + " " + a[n[10][1]]) + "hundred " : "";
		str += n[11] !== "00" ? (str !== "" ? "and " : "") + (a[Number(n[11])] || b[n[11][0]] + " " + a[n[11][1]]) : "";
		str = str.substring(0, 1).toUpperCase() + str.substring(1);
		return l === "" ? str + "dollars" : str + " " + l;
	}
	var changeType = (type) => {
		let format = "";
		switch (type) {
			case "VND":
				format = " đồng";
				break;
			case "VNĐ":
				format = " đồng";
				break;
			case "USD":
				format = " đô la Mỹ";
				break;
			case "JPY":
				format = " yên Nhật";
				break;
			case "AUD":
				format = " đô la Úc";
				break;
			case "CAD":
				format = " đô la Canada";
				break;
			case "GBP":
				format = " bảng Anh";
				break;
			case "SGD":
				format = " đô la Singapore";
				break;
			case "RUB":
				format = " rúp Nga";
				break;
			case "CNY":
				format = " nhân dân tệ";
				break;
			case "HKD":
				format = " đô la Hồng Công";
				break;
			case "KRW":
				format = " won Hàn Quốc";
				break;
			case "EUR":
				format = " euro";
				break;
			default:
				format = type;
				break;
		}
		return format;
	};
	//1. Hàm đọc số có ba chữ số;
	function DocSo3ChuSo(baso) {
		var tram;
		var chuc;
		var donvi;
		var KetQua = "";
		tram = parseInt(baso / 100);
		chuc = parseInt((baso % 100) / 10);
		donvi = baso % 10;
		if (tram == 0 && chuc == 0 && donvi == 0) return "";
		if (tram != 0) {
			KetQua += ChuSo[tram] + " trăm";
			if (chuc == 0 && donvi != 0) KetQua += " linh";
		}
		if (chuc != 0 && chuc != 1) {
			KetQua += ChuSo[chuc] + " mươi";
			if (chuc == 0 && donvi != 0) KetQua = KetQua + " linh";
		}
		if (chuc == 1) KetQua += " mười";
		switch (donvi) {
			case 1:
				if (chuc != 0 && chuc != 1) {
					KetQua += " mốt";
				} else {
					KetQua += ChuSo[donvi];
				}
				break;
			case 4:
				if (chuc != 0 && chuc != 1) {
					KetQua += " tư";
				} else {
					KetQua += ChuSo[donvi];
				}
				break;
			case 5:
				if (chuc == 0) {
					KetQua += ChuSo[donvi];
				} else {
					KetQua += " lăm";
				}
				break;
			default:
				if (donvi != 0) {
					KetQua += ChuSo[donvi];
				}
				break;
		}
		return KetQua;
	}
	//2. Hàm đọc số thành chữ (Sử dụng hàm đọc số có ba chữ số)
	function DocTienBangChu(money, type) {
		var strTachPhanSauDauPhay = [];
		var opNguyen = type;
		var opThapphan = type == "VND" || type == "VNĐ" ? "đồng" : " cent";
		var optionAnd = type == "USD" ? " và " : " và ";

		if (money.includes(".") || money.includes(",")) {
			strTachPhanSauDauPhay = money.split(".");
			if (Number(strTachPhanSauDauPhay[1].toString()) <= 0) {
				return DocTienBangChu(strTachPhanSauDauPhay[0], opNguyen);
			} else {
				var songuyen = DocTienBangChu(strTachPhanSauDauPhay[0], opNguyen);
				var sothapphan = DocTienBangChu(strTachPhanSauDauPhay[1], opThapphan);
				return songuyen + optionAnd + sothapphan.substring(0, 1).toLowerCase() + sothapphan.substring(1);
			}
		}

		var afterFix = changeType(type);
		var lan = 0;
		var i = 0;
		var so = 0;
		var KetQua = "";
		var tmp = "";
		var ViTri = new Array();
		var preFix = "";
		if (money < 0) preFix = "âm ";
		if (money == 0) return "Không" + afterFix;
		if (money > 0) {
			so = money;
		} else {
			so = -money;
		}
		if (money > 8999999999999999) {
			return "Số quá lớn!";
		}
		ViTri[5] = Math.floor(so / 1000000000000000);
		if (isNaN(ViTri[5])) ViTri[5] = "0";
		so = so - parseFloat(ViTri[5].toString()) * 1000000000000000;
		ViTri[4] = Math.floor(so / 1000000000000);
		if (isNaN(ViTri[4])) ViTri[4] = "0";
		so = so - parseFloat(ViTri[4].toString()) * 1000000000000;
		ViTri[3] = Math.floor(so / 1000000000);
		if (isNaN(ViTri[3])) ViTri[3] = "0";
		so = so - parseFloat(ViTri[3].toString()) * 1000000000;
		ViTri[2] = parseInt(so / 1000000);
		if (isNaN(ViTri[2])) ViTri[2] = "0";
		ViTri[1] = parseInt((so % 1000000) / 1000);
		if (isNaN(ViTri[1])) ViTri[1] = "0";
		ViTri[0] = parseInt(so % 1000);
		if (isNaN(ViTri[0])) ViTri[0] = "0";
		if (ViTri[5] > 0) {
			lan = 5;
		} else if (ViTri[4] > 0) {
			lan = 4;
		} else if (ViTri[3] > 0) {
			lan = 3;
		} else if (ViTri[2] > 0) {
			lan = 2;
		} else if (ViTri[1] > 0) {
			lan = 1;
		} else {
			lan = 0;
		}
		for (i = lan; i >= 0; i--) {
			tmp = DocSo3ChuSo(ViTri[i]);
			if (i < lan)
				if (ViTri[i] > 0 && ViTri[i] < 100)
					if (ViTri[i] > 0 && ViTri[i] < 10) tmp = " không trăm linh" + tmp;
					else tmp = " không trăm" + tmp;

			KetQua += tmp;
			if (i >= 4) {
				// nghìn tỷ và triệu tỷ
				if (ViTri[i] > 0 && ViTri[i - 1] == 0)
					// nếu số chẵn
					KetQua += Tien[i];
				else KetQua += Tien4[i];
			} else {
				if (ViTri[i] > 0) KetQua += Tien[i];
			}
		}
		if (KetQua.substring(KetQua.length - 1) == ",") {
			KetQua = KetQua.substring(0, KetQua.length - 1);
		}
		KetQua = preFix + KetQua.trim() + afterFix;
		return KetQua.substring(0, 1).toUpperCase() + KetQua.substring(1);
	}
	function showCertSelectionModal(title, dataUrl, columns, onCertConfirm) {
		var box = webix.modalbox({
			title: title,
			buttons: ["Nhận", "Hủy bỏ"],
			text: "<div id='ctnCerts'></div>",
			top: 100,
			width: 750,
			callback: function (result) {
				if (result === "1") {
					webix.modalbox.hide(box);
				} else if (result === "0") {
					var table = $$("tblCerts");
					var data = table.serialize();
					var cert = data.find(x => x.chon === true);
					if (!cert) return showError("Bạn chưa chọn chứng thư số");
					onCertConfirm(cert);
				}
			}
		});

		var popupText = document.getElementsByClassName("webix_popup_text")[0];
		if (popupText) popupText.style.paddingTop = 0;

		webix.ui({
			container: "ctnCerts",
			id: "tblCerts",
			view: "datatable",
			borderless: true,
			resizeColumn: true,
			height: 350,
			columns: columns,
			url: dataUrl
		});
	}
	function getCertColumns(fields) {
		const columnMap = {
			chon: {
				id: "chon", header: _("CHON"), width: 65,
				checkValue: true, uncheckValue: false, template: "{common.checkbox()}"
			},
			so_serial: { id: "so_serial", header: _("SO_SERIAL"), width: 150 },
			subjectname: { id: "subjectname", header: _("SUBJECTNAME"), width: 450 },
			ngaybatdau: { id: "ngaybatdau", header: _("NGAY_BAT_DAU"), width: 200 },
			ngayketthuc: { id: "ngayketthuc", header: _("NGAY_KET_THUC"), width: 200 },
			issuer: { id: "issuer", header: _("DONVI"), width: 450 },
			libraryName: { id: "libraryName", header: _("Loại"), width: 150 }
		};
		return fields.map(f => columnMap[f]);
	}
	function Sign04SS(item, component) {
		function enableUI() {
			component.enable();
			component.hideProgress();
		}
		function disableUI() {
			webix.extend(component, webix.ProgressBar);
			component.disable();
			component.showProgress();
		}

		function commonSign(cert, url, data, onSuccess) {
			disableUI();
			webix.ajax().headers({ "Content-type": "application/json" }).post(url, data, {
				error: enableUI,
				success: function (text) {
					enableUI();
					var res = JSON.parse(text);
					if (res.code !== "00") return showError(res.message);
					webix.message("Ký thành công thông báo 04/SS-HDDT", "success");
					app.callEvent(eventChanged, [1, null]);
					if (onSuccess) onSuccess(res);
				}
			});
		}

		function handleModalSign(certUrl, columns, onConfirm) {
			showCertSelectionModal("Chọn chứng thư số", certUrl, columns, onConfirm);
		}

		function handlePluginSign() {
			disableUI();
			webix.promise.all([
				webix.ajax(app.config.host + "/CancelInvoice/ExportXmlData?id=" + item.mau04_id),
				webix.ajax(app.config.host + "/Pattern/GetListCertificates"),
				webix.ajax(app.config.host + "/Pattern/GetSerialAcceptInvoice")
			]).then(function (results) {
				var xmlData = results[0].json();
				var listcerts = results[1].json();
				var certAccept = results[2].json();

				if (xmlData.code !== "00") return enableUI(), showError(xmlData.message);
				if (!listcerts.length) return enableUI(), showError("Bạn chưa được phân quyền chứng thư số");
				if (!certAccept || !certAccept.length) return enableUI(), showError("Đăng ký sử dụng hóa đơn NĐ 123 chưa được CQT chấp thuận.");

				require(["views/modules/minvoiceplugin"], function (plugin) {
					var hub = plugin.hub(), hubconnect = plugin.conn();
					if (hubconnect.state !== 1) {
						enableUI();
						webix.message("Chưa cài hoặc bật Plugin ký hóa đơn!", "error");
						var Form = $$("mau04_68").$scope.ui(modalPlugin.$ui);
						return Form.show();
					}

					hub.off("resCommand");
					hub.on("resCommand", function (result) {
						enableUI();
						var json = JSON.parse(result);
						if (json.error) return showError(json.error);

						var param = { xml: json.xml, id: item.mau04_id };
						commonSign(null, app.config.host + "/CancelInvoice/SaveXml", param);
					});

					var _listcerts = listcerts.map(function (_cert) {
						return {
							so_serial: _cert.so_serial,
							ngaybatdau: _cert.ngaybatdau,
							ngayketthuc: _cert.ngayketthuc,
							issuer: _cert.issuer,
							subjectname: _cert.subjectname,
						};
					});

					var arg = {
						idData: "#" + item.mau04_id,
						xml: xmlData.data["xml"],
						shdon: "",
						idSigner: "",
						tagSign: "NNT",
						listcerts: _listcerts,
						certAccept: certAccept,
					};

					hub.invoke("execCommand", "SignXmlTag", JSON.stringify(arg))
						.done(function () { console.log("Success !"); })
						.fail(function (error) { showError(error); });
				});
			}).fail(function (err) {
				enableUI();
				console.log(err);
				showError("Lỗi trong quá trình lấy dữ liệu ký");
			});
		}

		function openCertUI(modulePath, cert) {
			require(["app", "locale", modulePath], function (app, _, signView) {
				var frmModal = webix.$$("mau04_68").$scope.ui(signView.$ui);
				signView.initUI(cert, "cancelInvoice");
				webix.modalbox.hide();
				frmModal.show();
			});
		}

		webix.confirm({
			title: "KÝ GỬI MẪU 04SS-HĐĐT",
			text: "Bạn có muốn gửi thông báo hóa đơn sai sót đến CQT theo mẫu 04/SS-HĐĐT?",
			ok: "Có", cancel: "Không",
			callback: function (res) {
				if (!res) return;

				webix.ajax().headers({ "Content-Type": "application/json" })
					.get(Constant.API.INVOICE_GET_TYPE_SIGN, function (text) {
						var kytaptrung = JSON.parse(text)[0].gia_tri.toUpperCase();
						var certUrl = Constant.API.TOKEN_CERT_AUTO;
						var certCols = getCertColumns(["chon", "so_serial", "subjectname", "ngaybatdau", "ngayketthuc", "issuer", "libraryName"]);

						var handlers = {
							"FILE": function () {
								handleModalSign(certUrl, certCols, function (cert) {
									commonSign(cert, app.config.host + "/CancelInvoice/SignCancelInvoiceByFile", {
										so_serial: cert.so_serial, id: item.mau04_id
									});
								});
							},
							"VNET": function () {
								handleModalSign(certUrl, certCols, function (cert) {
									commonSign(cert, app.config.host + "/CancelInvoice/SignCancelInvoiceByVnet", {
										chukyso_id: cert.chukyso_id, id: item.mau04_id
									});
								});
							},
							"INTRUSTCA": function () {
								handleModalSign(certUrl, certCols, function (cert) {
									var signModel = {
										user_name: cert.username,
										credentialID: cert.tokenSerial,
										certificate: cert.cert_content,
										pinCode: cert.pin_code,
										auth_data: cert.auth_data,
										mode: 1,
										hoadon: [item.mau04_id],
									};
									commonSign(cert, app.config.host + Constant.API.SIGN.INTRUSTCA_04SS, signModel);
								});
							},
							"K": function () { handlePluginSign(); },
							"ICA": function () {
								handleModalSign(certUrl, certCols, function (cert) {
									cert.id = item.mau04_id;
									cert.tagSign = "TBao/DSCKS/NNT";
									cert.tagSignId = item.mau04_id;

									webix.ajax().headers({ "Content-type": "application/text" })
										.get(Constant.API.TOKEN_SHOW_PIN, function (text) {
											var response = JSON.parse(text);
											if (response.show) {
												openCertUI("views/forms/forms68/ICA/signICA", cert);
											} else {
												var param = {
													so_serial: cert.so_serial,
													pinCode: cert.pass,
													id: item.mau04_id,
													agreementUUID: cert.value,
												};
												commonSign(cert, app.config.host + "/CancelInvoice/SignCancelInvoiceIca", param);
											}
										});
								});
							},
							"EASYCA": function () {
								handleModalSign(certUrl, certCols, function (cert) {
									cert.id = item.mau04_id;
									cert.tagSign = "TBao/DSCKS/NNT";
									cert.tagSignId = item.mau04_id;
									openCertUI("views/forms/forms68/EasyCA/signEasyCA", cert);
								});
							},
							"NCCA": function () {
								handleModalSign(certUrl, certCols, function (cert) {
									cert.id = item.mau04_id;
									cert.tagSign = "TBao/DSCKS/NNT";
									cert.tagSignId = item.mau04_id;
									openCertUI("views/forms/forms68/NCCA/signNCCA", cert);
								});
							}
						};

						if (handlers[kytaptrung]) {
							handlers[kytaptrung]();
						} else {
							showError("Không hỗ trợ loại ký: " + kytaptrung);
						}
					});
			}
		});
	}
	function loadingStatus(current, code, message) {
		if (code == "00") webix.message(`Ký hóa đơn số: ${current}`, "debug");
		else webix.message(`Lỗi ký hóa đơn số: ${current} ${message}`, "error");
	}
	function SignInvoiceMultiple(typeSign, signOrSend, windowId, formComponent, dataInvoice, tableInvoiceComponent, signCloudMulti, plugin, user) {
		// signOrSend = 1 ký vả gửi CQT
		// signOrSend = 2 ký không gửi CQT
		var message_empty_data = "Bạn chưa chọn hóa đơn cần ký";
		var message_finish = "Kết thúc quá trình ký hóa đơn";
		var message_notice = signOrSend == 1 ? "Bạn có chắc chắn muốn ký và gửi hóa đơn cho CQT không?" : "Bạn có chắc chắn muốn ký hóa đơn để gửi Bảng tổng hợp không?";
		webix.confirm({
			title: "KÝ HÓA ĐƠN",
			text: message_notice,
			ok: "Có",
			cancel: "Không",
			callback: function (res) {
				if (res) {
					switch (typeSign.toUpperCase()) {
						case "FILE":
							var box = webix.modalbox({
								title: "Đang ký hóa đơn .... ",
								buttons: ["Hủy bỏ"],
								text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
								width: 350,
								height: 200,
								callback: function (result) {
									switch (result) {
										case "0":
											webix.modalbox.hide(box);
											break;
									}
								},
							});
							var txtCer = $$("txtCerSerial");
							var cert = txtCer.getList().getSelectedItem();
							var promisedata = [];
							var lstInvoice = [];
							var urlScheme = app.config.host + Constant.API.SIGN.FILE;
							for (var i = 0; i < dataInvoice.length; i++) {
								if (dataInvoice[i]["chon1"] != null && dataInvoice[i]["chon1"] == "C") {
									var invoice = {
										hoadon68_id: dataInvoice[i].hoadon68_id,
										shdon: dataInvoice[i].shdon,
									};
									lstInvoice.push(invoice);
								}
							}
							if ($$(windowId).config.sinhsosau == "true") {
								var dataPost = {
									so_serial: cert.so_serial,
									certData: cert,
									data: lstInvoice,
									type: signOrSend,
								};
								webix
									.ajax()
									.headers({ "Content-Type": "application/json" })
									.post(urlScheme, dataPost, function (text) {
										webix.modalbox.hide(box);
										tableInvoiceComponent.clearAll();
										formComponent.enable();
										formComponent.hideProgress();
										var response = JSON.parse(text);
										if (response.code == "00") {
											webix.message(message_finish, "success", 3000);
										} else {
											webix.message(response.message, "error");
										}
									});
							} else {
								var size = 5;
								for (var i = 0; i < lstInvoice.length; i += size) {
									var invoice = lstInvoice.slice(i, i + size);
									var dataPost = {
										so_serial: cert.so_serial,
										certData: cert,
										data: invoice,
										type: signOrSend,
									};
									var promise = webix.ajax().headers({ "Content-Type": "application/json" }).post(urlScheme, dataPost);
									promisedata.push(promise);
								}

								(async () => {
									const promises = promisedata.map((item) =>
										item.then((obj) => {
											if (obj.json().data != null) loadingStatus(obj.json().data.shdon, obj.json().code, obj.json().message);
										}),
									);
									await Promise.all(promises);
									webix.modalbox.hide(box);
									tableInvoiceComponent.clearAll();
									formComponent.enable();
									formComponent.hideProgress();
									webix.message(message_finish, "success", 3000);
								})();
							}
							break;
						case "C":
							var promises = [];
							for (var i = 0; i < dataInvoice.length; i++) {
								if (dataInvoice[i]["chon1"] != null && dataInvoice[i]["chon1"] == "C") {
									var a = webix.ajax().get(app.config.host + "/Invoice/ExportXml?id=" + dataInvoice[i].inv_InvoiceAuth_id);
									promises.push(a);
								}
							}
							webix.promise
								.all(promises)
								.then(function (results) {
									var promises = [];
									var server_cert = win.config.server_cert;
									var txtCer = $$("txtCerSerial");
									var cert = txtCer.getList().getSelectedItem();
									for (var i = 0; i < results.length; i++) {
										var dataXml = results[i].json();
										var parameters = {
											xml: dataXml["InvoiceXmlData"],
											refUri: "#data",
											certSerial: cert.so_serial,
											tokenSerial: cert.tokenSerial,
											signId: "seller",
											signTag: "Signatures",
											pass: cert.pass,
											inv_InvoiceAuth_id: dataXml["inv_InvoiceAuth_id"],
										};
										var a = webix
											.ajax()
											.headers({ "Content-Type": "application/json" })
											.post(server_cert + "/Token/SignXml", parameters, function (text) { });
										promises.push(a);
									}

									webix.promise
										.all(promises)
										.then(function (results) {
											var promises = [];
											for (var i = 0; i < results.length; i++) {
												var dataSign = results[i].json();
												var parameters = {
													InvoiceXmlData: dataSign.xml,
													inv_InvoiceAuth_id: dataSign.inv_InvoiceAuth_id,
												};
												var missing = webix
													.ajax()
													.headers({ "Content-Type": "application/json" })
													.post(server_cert + "/Invoice/SaveXml", parameters, function (text) { });
												promises.push(missing);
											}

											webix.promise
												.all(promises)
												.then(function (results) {
													var table = webix.$$("windowData");
													table.clearAll();
													table.load(table.config.url);
													formComponent.enable();
													formComponent.hideProgress();
													var win = $$(windowId);
													win.close();
												})
												.fail(function (err) {
													alert(err);
													formComponent.enable();
													formComponent.hideProgress();
												});
										})
										.fail(function (err) {
											alert(err);
											formComponent.enable();
											formComponent.hideProgress();
										});
								})
								.fail(function (err) {
									alert(err);
									formComponent.enable();
									formComponent.hideProgress();
								});
							break;
						case "CLOUD":
							var item = [];
							for (var i = 0; i < dataInvoice.length; i++) {
								if (dataInvoice[i]["chon1"] != null && dataInvoice[i]["chon1"] == "C") {
									item.push(dataInvoice[i].inv_InvoiceAuth_id);
								}
							}
							if (item.length <= 0) {
								webix.message(message_empty_data, "error");
								formComponent.enable();
								formComponent.hideProgress();
								return;
							}
							var win = $$(windowId);
							var frmSign = win.$scope.ui(signCloudMulti.$ui);
							signCloudMulti.initUI(item, $$("txtCerSerial").getValue());
							formComponent.enable();
							formComponent.hideProgress();
							win.close();
							frmSign.show();
							break;
						case "EASYCA":
							var item = [];
							for (var i = 0; i < dataInvoice.length; i++) {
								if (dataInvoice[i]["chon1"] != null && dataInvoice[i]["chon1"] == "C") {
									var hoadon = {
										id: dataInvoice[i].hoadon68_id,
										tagSign: Constant.API.SIGN.EASY_CA_TAG_SIGN,
										tagSignId: dataInvoice[i].hoadon68_id,
									};
									item.push(hoadon);
								}
							}
							if (item.length <= 0) {
								webix.message(message_empty_data, "error");
								formComponent.enable();
								formComponent.hideProgress();
								return;
							}
							var apiSignOrSend = signOrSend == 1 ? Constant.API.SIGN.EASY_CA : Constant.API.SIGN.EASY_CA_NOT_SEND;
							var frmSignEasyCA = webix.ui({
								view: "window",
								modal: true,
								id: "window-easy-multi",
								position: "center",
								move: true,
								padding: 30,
								css: { "border-radius": "6px" },
								head: {
									height: 30,
									cols: [
										{
											id: "head-formDelete",
											view: "template",
											css: "headform",
											template: function (obj) {
												return '<div style ="float:left; font-size:15px;"><i style="padding-right:8px;" class="fa fa-edit"></i> Mã pin Chữ ký số<div/>';
											},
										},
										{
											view: "icon",
											icon: "fas fa-times",
											id: "help_formESC",
											tooltip: _("Đóng"),
											click: function () {
												$$("window-easy-multi").close();
											},
										},
									],
								},
								body: {
									paddingY: 10,
									paddingX: 10,
									view: "form",
									id: "window-formesc-easy",
									complexData: true,
									keepViews: true,
									multiview: { keepViews: true },
									margin: 0,
									elements: [
										{
											view: "text",
											type: "password",
											name: "pin",
											id: "pin",
											label: "Mã pin",
											required: true,
											invalidMessage: "Bạn phải nhập mã pin",
										},
										{
											cols: [
												{},
												{
													id: "btnCo",
													view: "button",
													label: "Ký",
													type: "form",
													align: "center",
													on: {
														onClick: function () {
															if ($$("window-formesc-easy").validate()) {
																var frmPin = webix.$$("window-formesc-easy").getValues();
																$$("window-easy-multi").close();
																var dataPut = {
																	data: item,
																	so_serial: $$("txtCerSerial").getValue(),
																	pin: frmPin.pin,
																	option: null,
																};
																webix
																	.ajax()
																	.headers({ "Content-type": "application/json" })
																	.post(app.config.host + apiSignOrSend, dataPut, {
																		error: function (text, data, XmlHttpRequest) {
																			formComponent.enable();
																			formComponent.hideProgress();
																			webix.message(text + XmlHttpRequest, "error");
																		},
																		success: function (text, data, XmlHttpRequest) {
																			var response = JSON.parse(text);
																			formComponent.enable();
																			formComponent.hideProgress();
																			tableInvoiceComponent.clearAll();
																			if (response.code == "00") {
																				webix.message(message_finish, "success");
																				app.callEvent(eventChangedInvoice, [1, null]);
																			} else {
																				webix.message(response.message, "error");
																			}
																		},
																	});
															}
														},
													},
													click: function () {
														$$("btnCo").callEvent("onClick");
													},
												},
												{
													view: "button",
													id: "btnKo",
													shortcut: "esc",
													label: "Hủy",
													type: "danger",
													align: "center",
													on: {
														onClick: function () {
															formComponent.enable();
															formComponent.hideProgress();
															$$("window-easy-multi").close();
														},
													},
													click: function () {
														this.callEvent("onClick");
													},
												},
												{},
											],
										},
									],
								},
							});
							frmSignEasyCA.show();
							break;
						case "NCCA":
							var item = [];
							for (var i = 0; i < dataInvoice.length; i++) {
								if (dataInvoice[i]["chon1"] != null && dataInvoice[i]["chon1"] == "C") {
									var hoadon = {
										id: dataInvoice[i].hoadon68_id,
										tagSign: Constant.API.SIGN.EASY_CA_TAG_SIGN,
										tagSignId: dataInvoice[i].hoadon68_id,
									};
									item.push(hoadon);
								}
							}
							if (item.length <= 0) {
								webix.message(message_empty_data, "error");
								formComponent.enable();
								formComponent.hideProgress();
								return;
							}
							break;
						case "ICA":
							var apiSignOrSend = signOrSend == 1 ? Constant.API.SIGN.ICA : Constant.API.SIGN.ICA_NOT_SEND;
							var tagSignOrSend = signOrSend == 1 ? Constant.API.SIGN.ICA_LABEL : Constant.API.SIGN.ICA_NOT_SEND_LABEL;
							var item = [];
							for (var i = 0; i < dataInvoice.length; i++) {
								if (dataInvoice[i]["chon1"] != null && dataInvoice[i]["chon1"] == "C") {
									var hoadon = {
										id: dataInvoice[i].hoadon68_id,
										tagSign: "/DSCKS/NBan",
										tagSignId: dataInvoice[i].hoadon68_id,
										shdon: dataInvoice[i].shdon,
									};
									item.push(hoadon);
								}
							}
							if (item.length <= 0) {
								webix.message(message_empty_data, "error");
								formComponent.enable();
								formComponent.hideProgress();
								return;
							}
							webix
								.ajax()
								.headers({ "Content-type": "application/text" })
								.get(app.config.host + Constant.API.SIGN.CHECK_SHOW_PIN, function (text, data, XmlHttpRequest) {
									var response = JSON.parse(text);
									if (response.show == true) {
										require(["app", "locale", "views/forms/forms68/ICA/signInvoiceICA"], function (app, _, signICA) {
											var frmSign = formComponent.$scope.ui(signICA.$ui);
											var certificate = $$("txtCerSerial").getList().getSelectedItem();
											signICA.initUIMulti(certificate, item, tagSignOrSend, $$(windowId).config.sinhsosau);
											formComponent.enable();
											formComponent.hideProgress();
											frmSign.show();
										});
									} else {
										webix.extend(formComponent, webix.ProgressBar);
										formComponent.disable();
										formComponent.showProgress();
										var promiseData = [];
										var lstInvoice = [];
										var txtCer = $$("txtCerSerial");
										var cert = txtCer.getList().getSelectedItem();
										var apiHost = app.config.host + apiSignOrSend;

										for (var i = 0; i < dataInvoice.length; i++) {
											if (dataInvoice[i]["chon1"] != null && dataInvoice[i]["chon1"] == "C") {
												var hoadon = {
													id: dataInvoice[i].hoadon68_id,
													tagSign: "/DSCKS/NBan",
													tagSignId: dataInvoice[i].hoadon68_id,
													shdon: dataInvoice[i].shdon,
												};
												lstInvoice.push(hoadon);
											}
										}

										if ($$(windowId).config.sinhsosau == "true") {
											var param = {
												so_serial: cert.so_serial,
												pinCode: cert.pass,
												agreementUUID: cert.value,
												data: item,
											};
											webix
												.ajax()
												.headers({ "Content-type": "application/json" })
												.post(apiHost, param, {
													error: function (text, data, XmlHttpRequest) {
														formComponent.enable();
														formComponent.hideProgress();
														webix.message(text);
													},
													success: function (text, data, XmlHttpRequest) {
														var response = JSON.parse(text);
														formComponent.enable();
														formComponent.hideProgress();
														tableInvoiceComponent.clearAll();
														if (response.code == "00") {
															app.callEvent(eventChangedInvoice, [1, null]);
															webix.message(message_finish, "success");
														} else webix.message(response.message, "error");
													},
												});
										} else {
											var size = 5;
											for (var i = 0; i < lstInvoice.length; i += size) {
												var invoice = lstInvoice.slice(i, i + size);
												var param = {
													so_serial: cert.so_serial,
													pinCode: cert.pass,
													agreementUUID: cert.value,
													data: invoice,
												};
												var objPromise = webix.ajax().headers({ "Content-Type": "application/json" }).post(apiHost, param);
												promiseData.push(objPromise);
											}
											(async () => {
												const promises = promiseData.map((item) =>
													item.then((obj) => {
														if (obj.json().data != null) loadingStatus(obj.json().data.shdon, obj.json().code, obj.json().message);
													}),
												);
												await Promise.all(promises);
												webix.modalbox.hide(box);
												tableInvoiceComponent.clearAll();
												formComponent.enable();
												formComponent.hideProgress();
												webix.message(message_finish, "success", 3000);
												app.callEvent(eventChangedInvoice, [1, null]);
											})();
										}
									}
								});
							break;
						case "INTRUSTCA":
							var txtCer = $$("txtCerSerial");
							var cert = txtCer.getList().getSelectedItem();
							var promisedata = [];
							var lstInvoice = [];
							for (var i = 0; i < dataInvoice.length; i++) {
								if (dataInvoice[i]["chon1"] != null && dataInvoice[i]["chon1"] == "C") lstInvoice.push(dataInvoice[i].hoadon68_id);
							}
							if (lstInvoice.length <= 0) {
								webix.message("Không có hóa đơn nào được chọn", "error");
								formComponent.enable();
								formComponent.hideProgress();
								return;
							}
							var signModel = {
								user_name: cert.username,
								credentialID: cert.tokenSerial,
								certificate: cert.cert_content,
								pinCode: cert.pin_code,
								auth_data: cert.auth_data,
								mode: signOrSend,
								hoadon: lstInvoice,
							};
							webix.extend(formComponent, webix.ProgressBar);
							formComponent.disable();
							formComponent.showProgress();
							webix
								.ajax()
								.headers({ "Content-Type": "application/json" })
								.post(Constant.API.SIGN.INTRUSTCA, JSON.stringify(signModel), function (text) {
									formComponent.enable();
									formComponent.hideProgress();
									tableInvoiceComponent.clearAll();
									var result = JSON.parse(text);
									if (result.code == "00") {
										webix.message("Quá trình ký thành công", "success");
										app.callEvent(eventChangedInvoice, [1, null]);
									} else webix.message(result.message, "error");
								});
							break;
						case "VNET":
							var txtCer = $$("txtCerSerial");
							var cert = txtCer.getList().getSelectedItem();
							var lstInvoice = [];
							for (var i = 0; i < dataInvoice.length; i++) {
								if (dataInvoice[i]["chon1"] != null && dataInvoice[i]["chon1"] == "C") {
									var invoice = {
										hoadon68_id: dataInvoice[i].hoadon68_id,
									};
									lstInvoice.push(invoice);
								}
							}
							var postData = {
								chukyso_id: cert.chukyso_id,
								id: lstInvoice,
								type: signOrSend
							};
							webix.extend(formComponent, webix.ProgressBar);
							formComponent.disable();
							formComponent.showProgress();

							webix.ajax()
								.headers({ "Content-Type": "application/json" })
								.post(app.config.host + "/TokenCloud/MultiSignInvoiceByVnet", postData, function (text) {
									tableInvoiceComponent.clearAll();
									var result = JSON.parse(text);
									if (result.code == "00") {
										webix.message(message_finish, "success", 3000);
									}
									else
										webix.message(result.message, "error");
									webix.extend(formComponent, webix.ProgressBar);
									formComponent.enable();
									formComponent.hideProgress();
								});
							break;
						default:
							var promises = [];
							for (var i = 0; i < dataInvoice.length; i++) {
								if (dataInvoice[i]["chon1"] != null && dataInvoice[i]["chon1"] == "C") {
									promises.push(dataInvoice[i]);
								}
							}
							webix.extend(formComponent, webix.ProgressBar);
							formComponent.disable();
							formComponent.showProgress();
							var hub = plugin.hub();
							var hubconnect = plugin.conn();
							if (hubconnect.state != 1) {
								formComponent.enable();
								formComponent.hideProgress();
								webix.message("Quý khách hàng chưa cài Plugin ký hóa đơn hoặc Plugin ký hóa đơn chưa được bật !", "error");
								return;
							} else {
								hub.off("resCommand");
								hub.on("resCommand", function (result) {
									var resCommand = JSON.parse(result);
									if (resCommand.hasOwnProperty("error")) {
										webix.message({ type: "error", text: resCommand.error });
										formComponent.enable();
										formComponent.hideProgress();
									} else {
										var table = webix.$$("invoiceViews");
										table.clearAll();
										table.load(table.config.url);
										formComponent.enable();
										formComponent.hideProgress();
										var win = $$(windowId);
										win.close();
										webix.message(message_finish, "success");
									}
								});
								hub.off("resNotice");
								hub.on("resNotice", function (result) {
									webix.message(result, "debug");
								});
								var homeURL;
								if (document.location.protocol == "file:") homeURL = "http://localhost:18374/";
								else homeURL = document.location.origin;
								var item = formComponent.getValues();
								var token = user.getAccessToken();
								var dvcs = user.getDvcsID();
								var language = user.getLanguage();
								var jwt = token + ";" + dvcs + ";" + language;
								var arg = {
									data: promises,
									host: homeURL,
									auth: jwt,
									editmode: signOrSend,
									signOrSend: signOrSend,
									listcerts: [{ so_serial: item.cerSerial }],
								};
								hub
									.invoke("execCommand", "SignXmlTagMulti", JSON.stringify(arg))
									.done(function () {
										console.log("Success SignXmlTagMulti!");
									})
									.fail(function (error) {
										formComponent.enable();
										formComponent.hideProgress();
										webix.message(error, "error");
									});
							}
							break;
					}
				} else {
					formComponent.enable();
					formComponent.hideProgress();
				}
			},
		});
	}
	function ShowMessage(mess, rows) {
		webix.message(`${mess} tại dòng ${rows.stt}`, "debug", 5000);
	}
	function SaltEmail(nguoinhan) {
		var date = new Date();
		var dateSend = moment(date).format("DD/MM/YYYY HH");
		var s = nguoinhan.toString() + Constant.KEY_EMAIL + dateSend;
		return md5(s);
	}
	return {
		SaltEmail: SaltEmail,
		AmountToWord: converAmountToWords,
		DocTienBangChu: DocTienBangChu,
		ExcelDateToJSDate: function (nlap) {
			return ExcelDateToJSDate(nlap);
		},
		Sign04SS: Sign04SS,
		SignInvoiceMultiple: SignInvoiceMultiple,
		ValidateInvoice32: function () {
			return {
				ngay_hd32: function (value, rows, name) {
					var valid = true;
					var date = moment(value);
					var now = moment();
					if (date > now) {
						this.markInvalid(name, "Ngày hóa đơn có liên quan không được lớn hơn ngày hiện tại");
						valid = false;
					} else {
						var ngayHd32Control = $$("ngay_hd32");
						if ($$("ngay_hd32")) {
							ngayHd32Control.validate();
						}
					}
					return valid;
				},
				mauso_hd32: function (value, rows, name) {
					var valid = true;
					if (value != undefined) {
						var loaihd32 = $$("loai_hd32").getValue();
						if (loaihd32 == 1) {
							var validValues = ["1", "2", "3", "4", "5", "6"];
							if (value.length > 1 || !validValues.includes(value)) {
								this.markInvalid(name, "Mẫu số hóa đơn chỉ một giá trị từ 1 đến 6");
								valid = false;
							} else {
								valid = true;
								$$("mauso_hd32").validate();
							}
						} else if (loaihd32 == 3) {
							var lstLoai = ["01", "02", "03", "04"];
							var lstLoaiHD = ["GTKT", "GTTT", "XKNB", "HGDL"];
							var lstSoLien = ["0", "1", "2", "3"];
							if (value.length != 11) {
								this.markInvalid(name, "Độ dài mẫu hóa đơn liên quan phải là 11");
								valid = false;
							} else {
								if (lstLoai.indexOf(value.toString().substring(0, 2)) < 0) {
									this.markInvalid(name, "Hai ký tự đầu về loại hóa đơn không hợp lệ (01, 02, 03, 04)");
									valid = false;
								} else {
									if (lstLoaiHD.indexOf(value.toUpperCase().toString().substring(2, 6)) < 0) {
										this.markInvalid(name, "Bốn ký tự loại hóa đơn không hợp lệ (GTKT, GTTT, XKNB, HGDL)");
										valid = false;
									} else if (lstSoLien.indexOf(value.toString().substring(6, 7)) < 0) {
										this.markInvalid(name, "Ký tự số liên không hợp lệ (0, 1, 2, 3)");
										valid = false;
									} else if (value.toString().substring(7, 8) != "/") {
										this.markInvalid(name, "Ký tự phân cách trong ký hiệu không hợp lệ (/)");
										valid = false;
									} else {
										var patt = /^[0-9][0-9][0-9]$/;
										if (patt.test(value.toString().substring(8, 11)) == false) {
											this.markInvalid(name, "Ba ký tự lần phát hành không hợp lệ");
											valid = false;
										}
									}
								}
							}
						}
					}
					return valid;
				},
				kyhieu_hd32: function (value, rows, name) {
					var valid = true;
					if (value != undefined) {
						var loaihd32 = $$("loai_hd32").getValue();
						if (loaihd32 == 1) {
							const lstTypeInvoice = ["T", "M", "G", "H", "B", "N"];
							if (value.length != 6) {
								this.markInvalid(name, "Độ dài ký hiệu hóa đơn phải là 6");
								valid = false;
								return;
							}
							var firstChar = value.charAt(0).toUpperCase();
							if (firstChar != "C" && firstChar != "K") {
								this.markInvalid(name, "Ký tự đầu tiên phải bắt đầu từ C hoặc K");
								valid = false;
								return;
							}
							var year = value.toUpperCase().substring(1, 3);
							if (!/^\d{2}$/.test(year)) {
								this.markInvalid(name, "Ký tự số 2-3 phải là số năm từ 00-99");
								valid = false;
								return;
							}
							var typeInvoice = value.charAt(3).toUpperCase();
							if (!lstTypeInvoice.includes(typeInvoice)) {
								this.markInvalid(name, "Ký tự loại hình hóa đơn không hợp lệ");
								valid = false;
								return;
							} else {
								valid;
								$$("kyhieu_hd32").validate();
							}
						} else if (loaihd32 == 3) {
							var lstLoai = ["E", "P", "T"];
							if (value.length != 6) {
								this.markInvalid(name, "Độ dài ký hiệu hóa đơn liên quan phải là 6");
								valid = false;
							} else {
								var patt = /^[A,B,C,D,E,G,H,K,L,M,N,P,Q,R,S,T,U,V,X,Y][A,B,C,D,E,G,H,K,L,M,N,P,Q,R,S,T,U,V,X,Y]$/;
								if (patt.test(value.toUpperCase().substring(0, 2)) == false) {
									this.markInvalid(name, "2 ký tự đầu không hợp lệ");
									valid = false;
								} else {
									var patt = /^[/]$/;
									if (patt.test(value.toUpperCase().substring(2, 3)) == false) {
										this.markInvalid(name, "ký tự phân cách không hợp lệ (/)");
										valid = false;
									} else {
										patt = /^[0-9][0-9]$/;
										var nam = value.substring(3, 5);
										if (patt.test(nam) == false) {
											this.markInvalid(name, "Ký tự năm phát hành không hợp lệ");
											valid = false;
										} else if (lstLoai.indexOf(value.toUpperCase().substring(5, 6)) < 0) {
											this.markInvalid(name, "Ký tự loại hình hóa đơn không hợp lệ");
											valid = false;
										}
									}
								}
							}
						}
					}
					return valid;
				},
			};
		},
		Validate04SS: function () {
			return {
				khieu: function (value, rows, name, index) {
					var valid = true;
					if (rows.ladhddt == 1) {
						if (typeof value !== "string" || value.length != 7) {
							valid = false;
							ShowMessage("Ký hiệu có độ dài là 7 ký tự", rows);
						} else {
							value = value.toUpperCase();
							var patt = /^[1-6]$/;
							if (patt.test(value.substring(0, 1)) == false) {
								ShowMessage("Loại hóa đơn chỉ được nhập giá trị từ 1 đến 6", rows);
								valid = false;
							} else {
								var patt = /^[C,K]$/;
								if (patt.test(value.toUpperCase().substring(1, 2)) == false) {
									ShowMessage("Ký tự hình thức hóa đơn không hợp lệ (C,K)", rows);
									valid = false;
								} else {
									var patt = /^[0-9][0-9]$/;
									if (patt.test(value.substring(2, 4)) == false) {
										ShowMessage("Ký tự năm của ký hiệu không hợp lệ (00-99)", rows);
										valid = false;
									} else {
										var patt = /^[T,M,G,H,B,N]$/;
										if (patt.test(value.toUpperCase().substring(4, 5)) == false) {
											ShowMessage("Ký tự loại hóa đơn không hợp lệ", rows);
											valid = false;
										}
									}
								}
							}
						}
					} else {
						var lstLoai = ["E", "P", "T"];
						if (typeof value === "string") {
							value = value.toUpperCase();
							if (value.length != 6) {
								ShowMessage("Độ dài ký hiệu hóa đơn là 6 ký tự", rows);
								valid = false;
							} else {
								var patt = /^[A,B,C,D,E,G,H,K,L,M,N,P,Q,R,S,T,U,V,X,Y][A,B,C,D,E,G,H,K,L,M,N,P,Q,R,S,T,U,V,X,Y]$/;
								if (patt.test(value.toUpperCase().substring(0, 2)) == false) {
									ShowMessage("2 ký tự đầu của ký hiệu không hợp lệ", rows);
									valid = false;
								} else {
									var patt = /^[/]$/;
									if (patt.test(value.toUpperCase().substring(2, 3)) == false) {
										ShowMessage("Ký tự phân cách không hợp lệ (/)", rows);
										valid = false;
									} else {
										patt = /^[0-9][0-9]$/;
										var nam = value.substring(3, 5);
										if (patt.test(nam) == false) {
											ShowMessage("Ký tự năm phát hành không hợp lệ", rows);
											valid = false;
										} else if (lstLoai.indexOf(value.toUpperCase().substring(5, 6)) < 0) {
											ShowMessage("Ký tự loại hình hóa đơn không hợp lệ", rows);
											valid = false;
										}
									}
								}
							}
						}
					}
					return valid;
				},
				shdon: function (value, rows, name) {
					var valid = true;
					if (value != undefined) {
						if (webix.rules.isNumber(value) == false) {
							var valid = false;
							ShowMessage("Số hóa đơn chỉ được nhập số", rows);
						} else {
							if (rows.ladhddt == 1) {
								if (value.length > 8) {
									var valid = false;
									ShowMessage("Số hóa đơn có độ dài tối đa 8 chữ số", rows);
								}
							} else {
								if (value.length > 7) {
									var valid = false;
									ShowMessage("Số hóa đơn có độ dài tối đa 7 chữ số", rows);
								}
							}
						}
					}
					return valid;
				},
				ngay: function (value, rows, name) {
					var valid = true;
					var date = moment(value);
					var now = moment();
					if (date > now) {
						ShowMessage("Ngày hóa đơn có liên quan không được lớn hơn ngày hiện tại", rows);
						valid = false;
					}
					return valid;
				},
				macqt: function (value, rows, name) {
					var valid = true;
					if (value != undefined) {
						if (rows.ladhddt == 1) {
							if (value.length > 34) {
								var valid = false;
								ShowMessage("Mã cơ quan thuế có độ dài tối đa 34 ký tự", rows);
							}
						} else {
							if (value.length > 0) {
								var valid = false;
								ShowMessage("Mã cơ quan thuế không được phép nhập giá trị", rows);
							}
						}
					}
					return valid;
				},
				khmsohd: function (value, rows, name) {
					var valid = true;
					if (value != undefined) {
						value = value.toUpperCase();
						if (rows.ladhddt != 1) {
							var lstLoai = ["01", "02", "03", "04"];
							var lstLoaiHD = ["GTKT", "GTTT", "XKNB", "HGDL"];
							var lstSoLien = ["0", "1", "2", "3"];
							var lstPhathanh = ["001", "002", "003"];
							if (value.length != 11) {
								ShowMessage("Độ dài mẫu hóa đơn liên quan phải là 11", rows);
								valid = false;
							} else {
								if (lstLoai.indexOf(value.toString().substring(0, 2)) < 0) {
									ShowMessage("Hai ký tự đầu về loại hóa đơn không hợp lệ (01, 02, 03)", rows);
									valid = false;
								} else {
									if (lstLoaiHD.indexOf(value.toString().substring(2, 6)) < 0) {
										ShowMessage("Bốn ký tự loại hóa đơn không hợp lệ (GTKT, GTTT, XKNB, HGDL)", rows);
										valid = false;
									} else if (lstSoLien.indexOf(value.toString().substring(6, 7)) < 0) {
										ShowMessage("Ký tự số liên không hợp lệ (0, 1, 2, 3)", rows);
										valid = false;
									} else if (value.toString().substring(7, 8) != "/") {
										ShowMessage("Ký tự phân cách trong ký hiệu không hợp lệ (/)", rows);
										valid = false;
									} else {
										var patt = /^[0-9][0-9][0-9]$/;
										if (patt.test(value.toString().substring(8, 11)) == false) {
											ShowMessage("Ba ký tự lần phát hành không hợp lệ", rows);
											valid = false;
										}
									}
								}
							}
						}
					}
					return valid;
				},
				ldo: function (value, rows, name) {
					var valid = true;
					if (value !== undefined && value.length > 255) {
						valid = false;
						ShowMessage("Lí do có độ dài tối đa 255 kí tự", rows);
					}
					return valid;
				},
			};
		},
	};
});
//const { $$ } = require("webix");

define('views/forms/forms68/EXCEL/68_uploadExcel',["app", "locale"], function (app, _) {
  var typeInvoice = 0;
  var kyhieu;
  return {
    $ui: {
      view: "window",
      modal: true,
      id: "uploadfile-win78",
      position: "center",
      head: "Nhận dữ liệu từ file Excel",
      width: 500,
      height: 500,
      resize: true,
      body: {
        paddingY: 10,
        paddingX: 10,
        elementsConfig: { labelWidth: 100 },
        view: "form",
        id: "uploadfile-form78",
        complexData: true,
        elements: [
          {
            rows: [
              {
                rows: [
                  {
                    id: "uploader",
                    view: "uploader",
                    value: "Chọn file",
                    hide: true,
                    name: "uploader",
                    accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                    link: "mylist",
                    autosend: false,
                    multiple: false,
                    upload: app.config.host + "/Invoice68/UploadExcel",
                    on: {
                      onAfterRender: function () {
                        this.hide();
                      },
                      onAfterFileAdd: function (file) {
                        $$("mylist").refresh();
                      },
                      onUploadComplete: function (response) {
                      },
                      onFileUploadError: function (file, response) {
                        $$("uploadfile-win78").enable();
                        $$("uploadfile-win78").hideProgress();
                      },
                    },
                    apiOnly: true,
                  },
                  {
                    view: "list",
                    id: "mylist",
                    name: "mylist",
                    type: "uploader",
                    css: "lst-upload",
                    height: 120,
                    borderless: true,
                    onClick: {

                    }
                  },
                ],
              },
              { height: 10 },
              {
                view: "toolbar",
                // css: { background: "#e6f7ff !important" },
                borderless: true,
                cols: [
                  {
                    view: "button", type: "icon",
                    //  css: "btnExcel",
                    icon: "mdi mdi-folder-open-outline", label: "Chọn file",
                    on: {
                      onClick: function () {
                        webix.$$("uploader").fileDialog();
                      },
                    },
                    click: function () {
                      this.callEvent("onClick");
                    },
                  },
                  {
                    view: "button", type: "icon",
                    //  css: { "background-color": "#e6f7ff !important" },
                    icon: "mdi mdi-download-outline", label: "Tải file mẫu",
                    on: {
                      onClick: function () {
                        var uploader = webix.$$("uploader");
                        var formData = uploader.config.formData;
                        var table = $$("uploadfile-win78");
                        var url;
                        var fileName;
                        switch (typeInvoice) {
                          case 6:
                            fileName = "ExcelTemplatePxl.xlsx";
                            url = app.config.host + "/Invoice68/DownloadFileExcelTemplatePxk";
                            break;
                          case 100:
                            fileName = "Template chi tiết bảng tổng hợp dữ liệu.xlsx"
                            url = app.config.host + "/Invoice68/DownloadFileSummaryTableDetailExcelTemplate";
                            break;
                          case 10:
                            fileName = "Template danh sách khách hàng.xlsx"
                            url = app.config.host + "/Category/CustomerTemplateExcel";
                            break;
                          default:
                            if (kyhieu[4] == 'M')
                              fileName = "Template hóa đơn có mã từ máy tính tiền.xlsx";
                            else
                              fileName = "Template hóa đơn.xlsx";
                            url = app.config.host + "/Invoice68/DownloadFileExcelTemplate?kyhieu=" + kyhieu;
                            break;
                        }
                        webix.extend(table, webix.ProgressBar);
                        table.disable();
                        table.showProgress();
                        webix
                          .ajax()
                          .response("arraybuffer")
                          .headers({ "Content-type": "application/json" })
                          .get(url, {
                            error: function (text, data, XmlHttpRequest) {
                              table.enable();
                              table.hideProgress();
                            },
                            success: function (text, data, XmlHttpRequest) {
                              webix.delay(
                                function () {
                                  var file = new Blob([data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
                                  var fileURL = URL.createObjectURL(file);

                                  var link = document.createElement("a");
                                  document.body.appendChild(link);
                                  link.download = fileName;
                                  link.href = fileURL;
                                  link.click();
                                  document.body.removeChild(link); // remove the link when done
                                  //document.location.href = fileURL;
                                },
                                null,
                                null,
                                500
                              );

                              table.enable();
                              table.hideProgress();
                            },
                          });
                      },
                    },
                    click: function () {
                      this.callEvent("onClick");
                    },
                  },
                  {
                    shortcut: "F10",
                    view: "button",
                    // css: { background: "#e6f7ff !important" },
                    type: "icon",
                    icon: "mdi mdi-check",
                    label: "Nhận file (F10)",
                    id: "importExcel",
                    on: {
                      onClick: function () {
                        var table = $$("uploadfile-win78");
                        webix.extend(table, webix.ProgressBar);
                        table.disable();
                        table.showProgress();
                        var file = $$("uploader").files.getFirstId();
                        if (file == undefined || file == null) {
                          webix.message("Bạn chưa chọn file !", "error");
                          $$("uploadfile-win78").enable();
                          $$("uploadfile-win78").hideProgress();
                          return;
                        }

                        if(typeInvoice == 10) 
                        {
                          webix.$$("uploader").define("formData");
                        }
                        else
                        {
                          webix.$$("uploader").define("formData", { type_invoice: typeInvoice, khieu: kyhieu, cctbao_id: $$("kyhieu_id").getValue() });
                        }

                        $$("uploader").send(function (response) {                          
                          if (response != undefined) {
                            if (response.code == "00") {
                              $$("uploadfile-win78").enable();
                              $$("uploadfile-win78").hideProgress();
                              var topParentView = this.getTopParentView();
                              if (topParentView.config.tableId !== undefined) {
                                var table = $$(topParentView.config.tableId);
                                if (table != null) {
                                  table.clearAll();
                                  table.load(table.config.url);
                                }
                              }
                              webix.alert({
                                title: "Thành công !",
                                text: "Nhận dữ liệu Excel thành công !",
                                type: "alert-warning",
                                callback: function (result) {
                                  var table = typeInvoice == 10 ? webix.$$("customerViews") : webix.$$("invoiceViews");
                                  table.clearAll();
                                  table.load(table.config.url);
                                  webix.$$("uploadfile-win78").close();
                                },
                              });
                            } else {
                              $$("uploadfile-win78").enable();
                              $$("uploadfile-win78").hideProgress();
                              webix.alert({
                                title: "Lỗi !",
                                text: response.message,
                                type: "alert-error",
                              });
                            }
                          } else {
                            $$("uploadfile-win78").enable();
                            $$("uploadfile-win78").hideProgress();
                          }
                        });
                      },
                    },
                    click: function () {
                      this.callEvent("onClick");
                    },
                  },
                  {
                    hotkey: "esc",
                    view: "button",
                    // css: { background: "#e6f7ff !important" },
                    type: "icon",
                    icon: "mdi mdi-close",
                    label: "Hủy bỏ (ESC)",
                    on: {
                      onClick: function () {
                        $$("mylist").clearAll();
                        $$("mylist").unbind();
                        var id = $$("uploader").files.getFirstId();
                        if (id != undefined) {
                          $$("uploader").stopUpload(id);
                        }
                        webix.$$("uploadfile-win78").close();
                      },
                    },
                    click: function () {
                      this.callEvent("onClick");
                    },
                  },
                ],
              },
              { height: 10 }
            ],
          },
        ],
      },
    },
    setTypeInvoice: function (type) {
      kyhieu = $$("kyhieu_id").getText();
      typeInvoice = type;
      var title = "Nhận Excel hóa đơn GTGT";
      switch (type) {
        case 6:
          title = "Nhận Excel PXK KVNB";
          break;
        case 2:
          title = "Nhận Excel hóa đơn bán hàng";
          break;
        case 100:
          title = "Nhận Excel chi tiết bảng tổng hợp dữ liệu hóa đơn";
          break;
        default:
          title = "Nhận Excel hóa đơn GTGT";
          break;
      };
      $$("uploadfile-win78").getHead().setHTML(title);
      $$("uploader").addDropZone($$("mylist").$view, "Kéo và thả tệp vào đây");
    },
    setTypeDMKH: function (type) {
      typeInvoice = type;
      var title = "Nhận Excel danh sách khách hàng";
      $$("uploadfile-win78").getHead().setHTML(title);
      $$("uploader").addDropZone($$("mylist").$view, "Kéo và thả tệp vào đây");
      $$("uploader").define("upload", app.config.host + "/Category/CustomerUploadExcel");
    },
  };
});

define('views/forms/forms68/BTHopDL/68_bangdanhsachhoadon',["app", "models/user"], function (app, user) {
    var editmode = 0;
    var LoaiHD = 0;
    var DataHandle;
    var TaxOption;
    var Serial;

    var button = [
        {},
        {
            shortcut: "F10", view: "button", badge: "F10", css: "webix_primary",
            label: "Nhận", type: "icon", align: "center", width: 120,
            on: {
                onClick: function () {
                    var table = webix.$$("danhsach_hoadonFrm");
                    var frmInvoice = $$("danhsachhoadon-form");
                    var data = table.serialize();
                    var lstInvoice = "";
                    for (var i = 0; i < data.length; i++) {
                        var item = data[i];
                        if (item != undefined) {
                            if (item.chon != undefined) {
                                if (item.chon == "C") {
                                    lstInvoice = lstInvoice + "," + item.hoadon68_id;
                                }
                            }
                        }
                    }
                    if (lstInvoice.length == 0) {
                        webix.message({ type: "debug", text: "Bạn chưa chọn hóa đơn" });
                        return;
                    }
                    var dataPost = { Data: lstInvoice, TypeSummary: LoaiHD, TaxOption: TaxOption, Serial: Serial };
                    var apiHost = app.config.host + "/SummaryData/GetInvoiceToSummary";
                    webix.extend(frmInvoice, webix.ProgressBar);
                    frmInvoice.disable();
                    frmInvoice.showProgress();
                    webix.ajax()
                        .headers({ 'Content-type': 'application/json' })
                        .post(apiHost, dataPost, function (text) {
                            frmInvoice.enable();
                            frmInvoice.hideProgress();
                            var response = JSON.parse(text);
                            if (response.code == "00") {
                                $$("danhsachhoadon-win").close();
                                var frm = webix.$$("danhsach_hoadon");
                                frm.clearAll();
                                frm.parse(response.data);
                            }
                            else {
                                webix.message(response.message, "error");
                            }
                        });
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {
            view: "button", hotkey: "esc", label: "Hủy bỏ", badge: "ESC", css: "webix_danger",
            align: "center", type: "icon", width: 120,
            click: function () {
                webix.$$("danhsachhoadon-win").close();
            }
        },
        {}
    ]

    var ui = {
        view: "window",
        modal: true,
        move: true,
        id: "danhsachhoadon-win",
        position: "center",
        head: "Chọn hóa đơn vào bảng tổng hợp dữ liệu điện tử",
        body: {
            paddingY: 10,
            paddingX: 10,
            view: "form",
            width: 1200,
            height: 500,
            id: "danhsachhoadon-form",
            complexData: true,
            margin: 0,
            elements: [
                {
                    view: "datatable",
                    id: "danhsach_hoadonFrm",
                    name: "danhsach_hoadonFrm",
                    select: true,
                    resizeColumn: true,
                    footer: false,
                    editable: false,
                    scroll:true,
                    tooltip: true,
                    // url: {
                    //     $proxy: true,
                    //     load: function (view, callback, params) {
                    //         var item = DataHandle;
                    //         var start = null;
                    //         var count = null;
                    //         if (params == null) {
                    //             start = 0;
                    //             count = 2000;
                    //             // count = view.config.datafetch;
                    //         }
                    //         else {
                    //             start = params.start;
                    //             count = params.count;
                    //         }
                    //         if (item != undefined) {
                    //             item.skip = start;
                    //             item.take = count;
                    //             var apiHost = app.config.host + "/SummaryData/GetListInvoice";
                    //             webix.ajax()
                    //                 .headers({ 'Content-type': 'application/json' })
                    //                 .bind(view)
                    //                 .post(apiHost, item, callback, view);
                    //         }
                    //     }
                    // },
                    on: {
                        onBeforeLoad: function () {
                            this.showOverlay("<p style='padding-top:160px;'><i style='font-size:450%;' class='fa fa-spin fa-spinner fa-pulse'></i></p>");
                        },
                        onAfterLoad: function () {
                            if (!this.count())
                                this.showOverlay("<div><img src='assets/imgs/nodata.png'><div class='showOverlaydata'>Không có dữ liệu </br> Chúng tôi không tìm thấy hóa đơn</div></div>");
                            else
                                this.hideOverlay();
                        }
                    },
                    scheme: {
                        $init: function (obj) {

                        },
                    },
                    columns: [
                        {
                            id: "chon",
                            header: [{ text: "", content: "masterCheckbox" }],
                            width: 55,
                            checkValue: 'C',
                            uncheckValue: 'K',
                            template: "{common.checkbox()}"
                        },
                        { id: "khieu", name: "khieu", header: ["Ký hiệu", { content: "textFilter" }], width: 100 },
                        { id: "shdon", name: "shdon", header: ["Số hóa đơn", { content: "textFilter" }], width: 100 },
                        { id: "mst", name: "mst", header: ["Mã số thuế", { content: "textFilter" }], width: 120 },
                        {
                            id: "tennguoimua",
                            name: "tennguoimua",
                            header: ["Tên đơn vị/Tên người mua", { content: "textFilter" }],
                            width: 300,
                        },
                        {
                            id: "tgtttbso",
                            name: "tgtttbso",
                            header: ["Thành tiền sau thuế", { content: "textFilter" }],
                            width: 150,
                            format: webix.Number.numToStr({
                                groupDelimiter: ",",
                                groupSize: 3,
                                decimalDelimiter: ".",
                                decimalSize: 0,
                            }),
                            css: { "text-align": "right" },
                        },
                        {
                            id: "nky",
                            name: "nky",
                            header: ["Ngày ký", { content: "datepickerFilter" }],
                            width: 100,
                            format: function (text) {
                                var format = webix.Date.dateToStr("%d/%m/%Y");
                                text = removeTimeZoneT(text);
                                return format(text);
                            }
                        },
                        {
                            id: "tdlap",
                            name: "tdlap",
                            header: ["Thời điểm lập", { content: "datepickerFilter" }],
                            width: 120,
                            format: function (text) {
                                var format = webix.Date.dateToStr("%d/%m/%Y");
                                text = removeTimeZoneT(text);
                                return format(text);
                            }
                        },
                        { id: "nglap", name: "nglap", header: "Người lập", header: ["Người lập", { content: "textFilter" }], width: 130 },
                        {
                          id: "tgia", name: "tgia", header: "Tỷ giá", width: 150,
                          format: webix.Number.numToStr({
                            groupDelimiter: ",",
                            groupSize: 3,
                            decimalDelimiter: ".",
                            decimalSize: 4,
                          }),
                          css: { "text-align": "right" },
                        },
                        {
                          id: "ttphi", name: "ttphi", header: "Tổng tiền phí", width: 150,
                          format: webix.Number.numToStr({
                            groupDelimiter: ",",
                            groupSize: 3,
                            decimalDelimiter: ".",
                            decimalSize: 4,
                          }),
                          css: { "text-align": "right" },
                        },
                        {
                          id: "tgtkhac", name: "tgtkhac", header: "Tổng giảm trừ khác", width: 150,
                          format: webix.Number.numToStr({
                            groupDelimiter: ",",
                            groupSize: 3,
                            decimalDelimiter: ".",
                            decimalSize: 4,
                          }),
                          css: { "text-align": "right" },
                        }
                    ],
                    //pager: "pagerA"
                },
                // {
                //     id: "pagerA",
                //     view: "pager",
                //     size: 2000,
                //     group: 5,
                //     on: {
                //         onAfterPageChange: function (id) {
                //         }
                //     },
                //     template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}"
                // },
                { view: "label", label: "Để đảm bảo dung lượng khi truyền dữ liệu với CQT. Chỉ chọn tối đa 2000 hóa đơn trong một bảng tổng hợp" },
                {
                    margin: 10,
                    cols: button
                }
            ]
        }
    };

    return {
        $ui: ui,
        setEditMode: function (mode, loaihd, tax, serial) {
            editmode = mode;
            LoaiHD = loaihd;
            TaxOption = tax;
            Serial = serial;
        },
        setValues: function (values) {
            var fmDate = function (text) {
                var format = webix.Date.dateToStr("%d/%m/%Y");
                text = removeTimeZoneT(text);
                return format(text);
            };
            DataHandle = {
                type: values.lkdlieu,
                ngay: fmDate(values.ngay),
                nam: values.nam,
                thang: values.thang,
                cctbao_id: values.kyhieu_id,
                skip: 0,
                take: 1000,
                dvtte: values.dvtte
            };
            // var table = webix.$$("danhsach_hoadonFrm");
            // table.clearAll();
            // table.load(table.config.url);
            // $$("danhsach_hoadonFrm").load({
            //     $proxy: true,
            //     load: function (view, callback, params) {
            //         var item = DataHandle;
            //         var start = null;
            //         var count = null;
            //         if (params == null) {
            //             start = 0;
            //             count = 2000;
            //             // count = view.config.datafetch;
            //         }
            //         else {
            //             start = params.start;
            //             count = params.count;
            //         }
            //         if (item != undefined) {
            //             item.skip = start;
            //             item.take = count;
            //             var apiHost = app.config.host + "/SummaryData/GetListInvoice";
            //             webix.ajax()
            //                 .headers({ 'Content-type': 'application/json' })
            //                 .bind(view)
            //                 .post(apiHost, item, callback, view);
            //         }
            //     }
            // });
            var tableHoadon = $$("danhsach_hoadonFrm");
            webix.extend(tableHoadon, webix.ProgressBar);
            tableHoadon.disable();
            tableHoadon.showProgress();
            var apiHost = app.config.host + "/SummaryData/GetListInvoice";
            webix.ajax()
                .headers({ 'Content-type': 'application/json' })
                .post(apiHost, DataHandle, {
                    error: function (text, data, XmlHttpRequest) {
                        tableHoadon.enable();
                        tableHoadon.hideProgress();
                    }, success: function (text, data, XmlHttpRequest) {
                        tableHoadon.enable();
                        tableHoadon.hideProgress();
                        var response = JSON.parse(text);
                        $$("danhsach_hoadonFrm").parse(response.data);
                    }
                });
        }
    };
});
define('views/forms/forms68/HDon/68_chonhanghoa',[
    "app",
    "locale",
    "models/user"
], function (app, _, user) {
    'use strict';

    var fm = function (number) {
        var k = webix.Number.numToStr({
            groupDelimiter: ".",
            groupSize: 3,
            decimalDelimiter: ",",
            decimalSize: 0
        });
        return k(number);
    }
    return {
        $ui: {
            view: "window",
            modal: true,
            position: "center",
            css: "headformchil",
            head: {
                height: 35,
                cols: [
                    {
                        id: "head-icondieuchinhhoadon",
                        view: "template",
                        css: "headform",
                        width: 35,
                        template: ""
                    },
                    {
                        id: "head-formdieuchinhhoadon", view: "template", css: "headform", template: function (obj) {
                            return '<div>Danh sách hóa đơn<div/>';
                        }
                    },
                    {
                        view: "icon", icon: "fas fa-question-circle", id: "help_dksdForms", tooltip: _("HELPER"), click: function () {
                        }
                    }
                ]
            },
            id: "DsHoaDon-Win",
            resize: true,
            width: 900,
            height: 500,
            // fullscreen: true,
            move: true,
            on: {
                onBeforeShow: function () {
                }
            },
            body: {
                view: "form",
                id: "frmDsHoadon",
                // width: 1500,
                position: "center",
                // autowidth:true,
                paddingY: 10,
                paddingX: 15,
                complexData: true,
                scroll: true,
                margin: 0,
                elements: [
                    {
                        // id: "header",
                        template: "<center><b><span style='font-size:16px;'>Danh sách hàng hóa của hóa đơn gốc</b></center>", borderless: true, height: 40
                    },
                    { height: 3 },
                    {
                        rows: [
                            {
                                view: "datatable",
                                id: "danhsach_hoadon",
                                // height: 250,
                                name: "danhsach_hoadon",
                                // select: true,
                                resizeColumn: true,
                                footer: false,
                                tooltip: true,
                                editable: false,
                                select: "row",
                                scheme: {
                                    $init: function (obj) {
                                    },
                                },
                                on: {
                                    "data->onStoreUpdated": function () {
                                        this.data.each(function (obj, i) {
                                            obj.stt = i + 1;
                                        });
                                    },
                                    onBeforeEditStart: function (id) {

                                    }
                                },
                                columns: [
                                    { editor: "text", id: "hoadon68_id", name: "hoadon68_id", hidden: true },
                                    { editor: "text", id: "hoadon68_chitiet_id", name: "hoadon68_chitiet_id", hidden: true },
                                    { id: "chon", header: { content: "masterCheckbox", contentId: "mc1" }, width: 45, checkValue: true, uncheckValue: false, template: "{common.checkbox()}" },
                                    { id: "stt", name: "stt", header: "STT", sort: "int", width: 40, },
                                    { id: "ma", name: "ma",  header: ["Mã hàng", { content: "textFilter" }], width: 140, editor: "text" },
                                    { id: "ten", name: "ten", header: ["Tên hàng", { content: "textFilter" }], width: 200, editor: "text" },
                                    { id: "mdvtinh", name: "mdvtinh", header: "ĐVT", width: 100, editor: "text" },
                                    { id: "sluong", name: "sluong", header: "Số lượng", width: 100, editor: "numeric" },
                                    {
                                        id: "dgia", header: "Đơn giá", width: 150, css: { "text-align": "right" }, columnType: "numeric",
                                        template: function (obj, common) {
                                            return obj.dgia == null ? 0 : fm(obj.dgia);
                                        }
                                    },
                                    {
                                        id: "thtien", header: "Thành tiền", width: 150, css: { "text-align": "right" }, columnType: "numeric",
                                        template: function (obj, common) {
                                            return obj.thtien == null ? 0 : fm(obj.thtien);
                                        }
                                    },
                                    {
                                        id: "tthue", header: "Tiền thuế", width: 150, css: { "text-align": "right" }, columnType: "numeric",
                                        template: function (obj, common) {
                                            return obj.tthue == null ? 0 : fm(obj.tthue);
                                        }
                                    },
                                    {
                                        id: "tgtien", header: "Tổng tiền", width: 150, css: { "text-align": "right" }, columnType: "numeric",
                                        template: function (obj, common) {
                                            return obj.tgtien == null ? 0 : fm(obj.tgtien);
                                        }
                                    },
                                ]
                            }
                        ]
                    },
                    {
                        id: "btnHuyHDDT",
                        cols: [
                            {},
                            {
                                view: "button", id: "btnXacNhan", label: "Xác nhận", badge: "F10", css: "webix_primary",
                                shortcut: "F10", label: "Xác nhận", type: "icon", align: "center", width: 120,
                                click: function () {
                                    var table = $$("danhsach_hoadon");
                                    var data = table.serialize();
                                    var dataDetail = [];
                                    for (var i = 0; i < data.length; i++) {
                                        if (data[i].chon == true) {
                                            data[i].hoadon68_id = null;
                                            data[i].hoadon68_chitiet_id = null;
                                            dataDetail.push(data[i]);
                                        }
                                    }
                                    if (dataDetail.length <= 0) {
                                        webix.message("Bạn chưa chọn hàng hóa", "debug");
                                        return;
                                    }
                                    webix.$$("hoadon68_chitiet").parse(dataDetail);
                                    $$("DsHoaDon-Win").close();
                                }
                            },
                            {
                                view: "button", hotkey: "esc", label: "Hủy bỏ", badge: "ESC", css: "webix_danger", width: 120, type: "icon", align: "center",
                                click: function () {
                                    webix.$$("DsHoaDon-Win").close();
                                }
                            },
                            {}
                        ]
                    }
                ]
            }
        },
        setEditMode: function (mode, id) {
            var table = webix.$$("invoiceViews");
            var item = table.getSelectedItem();
            var icon = "";
            if (mode == 1) {
                icon = "<span><i class='fa fa-plus' aria-hidden='true'></i></span>";
                var result = webix.ajax().sync().get(app.config.host + "/Invoice68/GetDetailInvoice?id=" + item.id);
                var json = JSON.parse(result.response);
                $$("danhsach_hoadon").parse(json);
            }
            else {
                if (mode == 2)
                    icon = "<i class='fa fa-edit' aria-hidden='true'></i>";
                else
                    icon = "<i class='fa fa-trash fa-lg' aria-hidden='true'></i>";
            }
            webix.$$("head-icondieuchinhhoadon").setHTML(icon);
            webix.$$("head-icondieuchinhhoadon").refresh();
            webix.$$("head-formdieuchinhhoadon").setHTML("Hóa đơn số " + item.shdon + " ký hiệu " + item.khieu);
            webix.$$("head-formdieuchinhhoadon").refresh();
        }
    };
});
define('views/modules/Component/modalPlugin',["app"], function (app) {

    return {
        $ui: {
            view: "window", move: true,
            // position: "center",
            position: function (state) {
                state.width = state.maxWidth * 0.4;
                state.height = state.maxHeight * 0.5;
                state.left = (state.maxWidth - state.width) / 2;
                state.top = (state.maxHeight - state.height) / 2;
            },
            modal: true,
            resize: true,
            minHeight: 400,
            id: "pluginBanner",
            head: {
                view: "toolbar",
                cols: [
                    { view: "label", label: "Thao tác không thành công" },
                    {
                        view: "label",
                        tooltip: "Đóng",
                        label: `<b style="border-radius:9999999px; padding:0.25rem; cursor: pointer; margin-right:1rem; border: 1px solid black: "> X </b>`,
                        align: "right",
                        width: 40,
                        click: function () {
                            $$("pluginBanner").close();
                        }
                    }
                ]
            },
            body: {
                paddingY: 0,
                paddingX: 0,
                view: "form",
                id: "pluginForm",
                complexData: true,
                keepViews: true,
                multiview: { keepViews: true },
                margin: 0,
                elements: [
                    { view: "template", template: "", height: 15, borderless: true },
                    {
                        id: "bodyBanner",
                        view: "template",
                        borderless: true,
                        template: "<div class='pluginbanner'><div class='imageplugin'><img src='assets/imgs/USB.png' alt='minvoice' width='160' height='160' /></div>"
                            + "<div><p>H&atilde;y kiểm tra c&aacute;c trường hợp dưới đ&acirc;y để khắc phục vấn đề của bạn</p>"
                            + " <p><strong>1.</strong> Bạn chưa c&agrave;i đặt c&ocirc;ng cụ <strong>M-INVOICE Plugin</strong></p>"
                            + " <p>H&atilde;y c&agrave;i đặt M-INVOICE Plugin để tiếp tục.</p>"
                            + " <p style='padding-left: 40px;'><i class='far fa-arrow-down' style='color:#0069b4;' aria-hidden='true'></i><a href='https://plugin.minvoice.com.vn/MinvoicePlugin/publish.htm' target='_blank' style = 'text-decoration: none;color:#0069b4;' rel='noopener'> Tải bộ c&agrave;i</a></p>"
                            + " <p style='text-align: left; padding-left: 40px;'><i class='far fa-info-circle' style='color:#0069b4;' aria-hidden='true'></i><a href='https://www.youtube.com/watch?v=e9PO-z4nb_0&feature=youtu.be' target='_blank' style = 'text-decoration: none;color:#0069b4;'> Xem hướng dẫn c&agrave;i đặt</a></p>"
                            + " <p style='text-align: left;'><strong>2.</strong> Bạn đ&atilde; c&agrave;i đặt c&ocirc;ng cụ <strong>M-INVOICE Plugin</strong></p>"
                            + " <p style='text-align: left;'>H&atilde;y mở c&ocirc;ng cụ M-INVOICE Plugin trước khi k&yacute; điện tử</p>"
                            + " <p style='text-align: left; padding-left: 40px;'><i class='far fa-info-circle' style='color:#0069b4;' aria-hidden='true'></i><a title='Mở M-INVOICE Plugin' href='#' style = 'text-decoration: none;color:#0069b4;' class = 'openPlugin'> Mở M-INVOICE Plugin</a></p>"
                            + " <p>&nbsp;</p></div></div>",
                        onClick: {
                            "openPlugin": function (ev, id) {
                                ev.preventDefault();
                                $$("pluginBanner").close();
                                webix.modalbox.hide();
                                window.open("minvocie://nampvminvoice");
                            }
                        }
                    }
                ]
            },
            on: {
                onShow: function () {
                    var self = this;
                    $(".webix_modal").one("click", function () {
                        self.hide();
                    });
                }
            }
        }
    };

});
define('views/modules/minvoiceplugin',[ "views/modules/Component/modalPlugin"], function (modalPlugin) {
    var uuid = function uuidv4() {
        return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
            (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
        );
    };
    var url = "http://localhost:19898/signalr";
    var isConnected = false;
    var isLocked = false;
    var conn = $.hubConnection(url, {
        useDefaultPath: false
    });
    conn.qs = { 'Access-Control-Allow-Private-Network': true };
    conn.logging = true;
    var hub = conn.createHubProxy('invoiceHub');
    hub.on('resCommand', function (result) {

    });
    conn.disconnected(function () {
        console.log('PLugin connection disconnected');
        isConnected = false;
        isLocked = false;
        setTimeout(function () {
            conn.start();
        }, 2000); // Restart connection after 2 seconds.
    });
    conn.connectionSlow(function () {
        console.log('Currently experiencing difficulties with the connection')
    });
    conn.start().done(function () {
        console.log("Connected to Plugin Id: " + hub.connection.id);
        isConnected = true;
        isLocked = false;
    })
        .fail(function () {
            isConnected = false;
            webix.message("Quý khách hàng chưa cài Plugin ký hóa đơn hoặc Plugin ký hóa đơn chưa được bật !", "debug");
            // var form =webix.ui(modalPlugin.$ui);
            // form.show();
            // var tagA = document.createElement("a");
            // document.body.appendChild(tagA);
            // tagA.href = "minvocie://nampvminvoice";
            // tagA.click();
        });

    return {
        hub: function () {
            return hub;
        },
        conn: function () {
            return conn;
        },
        isConnected: isConnected,
        setLocked: function (locked) {
            isLocked = locked;
        },
        getLocked: function () {
            return isLocked;
        }
    };
});
define('views/forms/signCloudMulti',["app"], function (app) {
    var editmode = 0;
    var item;
    var cerSerial;
    function initUI(obj, cert) {
        item = obj;
        cerSerial = cert;
    }
    return {
        $ui: {
            view: "window",
            modal: true,
            id: "signCloud",
            css: "signCloud",
            position: "center",
            move: true,
            head: false,
            minWidth: 350,
            // height: 100,
            body: {
                view: "form",
                id: "signCloud-frm",
                elementsConfig: {
                    labelWidth: 60
                },
                elements: [
                    {
                        view: "text", type: "password", name: "pin_Code", id: "pinCode", label: "Mã pin", required: true,
                        invalidMessage: "Bạn phải nhập mã pin"
                    },
                    {
                        cols: [
                            {},
                            {
                                shortcut: "F10", view: "button", label: "Nhận (F10)", type: "form", align: "center", width: 80,
                                on: {
                                    onClick: function () {
                                        if ($$("signCloud-frm").validate()) {
                                            var form = $$("signCloud");
                                            var promises = "[";
                                       
                                            for (var i = 0; i < item.length; i++) {
                                                var k = {};
                                                k.id = item[i];
                                                k.cerSerial = cerSerial;
                                                k.pinCode = $$("pinCode").getValue(),
                                                promises = promises + JSON.stringify(k) + ",";
                                            }

                                            promises = promises.substring(0, promises.length - 1) + "]";
                                            var param = JSON.parse(promises);
                          
                                            // var param = {
                                            //     agreementUUID: item.agreementUUID,
                                            //     pinCode: $$("pinCode").getValue(),
                                            //     id: item.inv_InvoiceAuth_id
                                            // }

                                            webix.extend(form, webix.ProgressBar);
                                            form.disable();
                                            form.showProgress();
                                            var url = app.config.host + "/TokenCloud/SignCloudMulti";

                                            webix.ajax()
                                                .headers({ 'Content-type': 'application/json' })
                                                .post(url,JSON.stringify(param), {
                                                    error: function (text, data, XmlHttpRequest) {
                                                        form.enable();
                                                        form.hideProgress();
                                                        webix.message(text);
                                                    },
                                                    success: function (text, data, XmlHttpRequest) {
                                                        var obj = JSON.parse(text);
                                                        if (!obj.hasOwnProperty("error")) {
                                                            // if (obj.trang_thai == "Đã ký") {

                                                            //     var table = webix.$$("windowData");
                                                            //     var item = table.getSelectedItem();

                                                            //     item.trang_thai = "Đã ký";
                                                            //     item.inv_invoiceNumber = obj.inv_invoiceNumber;
                                                            //     table.updateItem(item.id, item);

                                                            //     webix.ajax()
                                                            //         .headers({ 'Content-type': 'application/json' })
                                                            //         .post(app.config.host + "/System/ExecuteCommand",
                                                            //         {
                                                            //             command: "CM00025",
                                                            //             parameter: {
                                                            //             }
                                                            //         }
                                                            //         , function (text) {
                                                            //             var json = JSON.parse(text);
                                                            //             // auto send SMS 
                                                            //             if (json[1].gia_tri == "C") {
                                                            //                 var data = { id: item.inv_InvoiceAuth_id };

                                                            //                 webix.ajax()
                                                            //                     .headers({ 'Content-type': 'application/json' })
                                                            //                     .post(app.config.host + "/Sms/NotifyInvoice", data, function (text) {
                                                            //                         var data = JSON.parse(text);

                                                            //                         if (!data.hasOwnProperty("error")) {
                                                            //                         }
                                                            //                         else {
                                                            //                             webix.message(data.error, "error");
                                                            //                         }
                                                            //                     });
                                                            //             }
                                                            //             // send email ma = 'AUTO_SEND_EMAIL'
                                                            //             if (json[0].gia_tri == "C") {
                                                            //                 var data = { inv_InvoiceAuth_id: item.inv_InvoiceAuth_id, nguoinhan: item.inv_buyerEmail, tieude: "Thông báo xuất hóa đơn điện tử" };

                                                            //                 webix.ajax()
                                                            //                     .headers({ 'Content-type': 'application/json' })
                                                            //                     .post(app.config.host + "/Invoice/AutoEmail", data, function (text) {
                                                            //                         var data = JSON.parse(text);

                                                            //                         if (!data.hasOwnProperty("error")) {

                                                            //                         }
                                                            //                         else {
                                                            //                             webix.message(data.error, "error");
                                                            //                         }
                                                            //                     });
                                                            //             }
                                                            //         });

                                                            // }
                                                            form.enable();
                                                            form.hideProgress();
                                                            $$("btnCancel").callEvent("onClick");
                                                            webix.message("Ký hóa đơn thành công !", "success");
                                                        }
                                                        else {
                                                            form.enable();
                                                            form.hideProgress();
                                                            webix.message(obj.error, "error");
                                                        }

                                                    }
                                                });
                                        }
                                    }
                                },
                                click: function () {
                                    this.callEvent("onClick");

                                }
                            },
                            {
                                view: "button", id: "btnCancel", shortcut: "esc", label: "Hủy (ESC)", type: "danger", align: "center",
                                width: 80,
                                on: {
                                    onClick: function () {
                                        $$("signCloud").close();
                                    }
                                },
                                click: function () {
                                    this.callEvent("onClick");
                                }
                            },
                            {}
                        ]
                    }
                ]
            }
        },
        setEditMode: function (mode) {
            editmode = mode;
        },
        initUI: initUI
    };

});
define('views/modules/Component/ajaxHelper',["app"], function (app) {
    return {
        GET: function (api) {
            return new Promise((resolve, reject) => {
                webix.ajax().headers({ "Content-type": "application/json" })
                    .get(api, {
                        error: function (text, data, XmlHttpRequest) {
                            reject(text)
                        },
                        success: function (text, data, XmlHttpRequest) {
                            resolve(text)
                        },
                    });
            });
        },
        POST: function (api, data) {
            return new Promise((resolve, reject) => {
                webix.ajax().headers({ "Content-type": "application/json" })
                    .post(api, data, {
                        error: function (text, data, XmlHttpRequest) {
                            reject(text)
                        },
                        success: function (text, data, XmlHttpRequest) {
                            resolve(text)
                        },
                    });
            })
        }
    };
});
define('views/forms/forms68/HDon/popupDetailProduct',[
    "app",
    "locale",
    "models/user"
], function (app, _, user, popupProduct) {
    'use strict';

    var fm = function (number) {
        var k = webix.Number.numToStr({
            groupDelimiter: ".",
            groupSize: 3,
            decimalDelimiter: ",",
            decimalSize: 0
        });
        return k(number);
    }
    var productDetail = function () {
        var productDetailLayout = {
            view: "window",
            modal: true,
            position: "center",
            css: "headformchil",
            head: {
                height: 35,
                cols: [
                    {
                        id: "head-icondieuchinhhoadon",
                        view: "template",
                        css: "headform",
                        width: 35,
                        template: ""
                    },
                    {
                        id: "head-formdieuchinhhoadon", view: "template", css: "headform", template: function (obj) {
                            return '<div>Chọn chi tiết hàng hóa<div/>';
                        }
                    },
                    { view: "icon", icon: "fas fa-question-circle", id: "help_dksdForms", tooltip: _("HELPER"), click: function () { } }
                ]
            },
            id: "DsHoaDon-Win",
            resize: true,
            width: 900,
            height: 500,
            move: true,
            on: {
                onBeforeShow: function () {
                }
            },
            body: {
                view: "form",
                id: "frmDsHoadon",
                position: "center",
                paddingY: 10,
                paddingX: 15,
                complexData: true,
                scroll: true,
                margin: 0,
                elements: [
                    {
                        template: "<center><b><span style='font-size:16px;'>Danh sách hàng hóa của hóa đơn đã chọn</b></center>", borderless: true, height: 40
                    },
                    { height: 3 },
                    {
                        rows: [
                            {
                                view: "datatable",
                                id: "danhsach_hoadon",
                                name: "danhsach_hoadon",
                                resizeColumn: true,
                                footer: false,
                                tooltip: true,
                                editable: false,
                                select: "row",
                                scheme: {
                                    $init: function (obj) {
                                    },
                                },
                                //xóa hàm xử lý STT vì có RowNumber gọi stt từ db 
                                columns: [
                                    { editor: "text", id: "hoadon68_id", name: "hoadon68_id", hidden: true },
                                    { editor: "text", id: "hoadon68_chitiet_id", name: "hoadon68_chitiet_id", hidden: true },
                                    { id: "chon", header: { content: "masterCheckbox", contentId: "mc1" }, width: 45, checkValue: "C", uncheckValue: "K", template: "{common.checkbox()}" },
                                    { id: "stt", name: "stt", header: "STT", sort: "int", width: 40 },
                                    { id: "ma", name: "ma", header: ["Mã hàng", { content: "textFilter" }], width: 140, editor: "text" },
                                    { id: "ten", name: "ten", header: ["Tên hàng", { content: "textFilter" }], width: 200, editor: "text" },
                                    { id: "mdvtinh", name: "mdvtinh", header: "ĐVT", width: 100, editor: "text" },
                                    { id: "sluong", name: "sluong", header: "Số lượng", width: 100, editor: "numeric" },
                                    {
                                        id: "dgia", header: "Đơn giá", width: 150, css: { "text-align": "right" }, columnType: "numeric",
                                        template: function (obj, common) {
                                            return obj.dgia == null ? 0 : fm(obj.dgia);
                                        }
                                    },
                                    {
                                        id: "thtien", header: "Thành tiền", width: 150, css: { "text-align": "right" }, columnType: "numeric",
                                        template: function (obj, common) {
                                            return obj.thtien == null ? 0 : fm(obj.thtien);
                                        }
                                    },
                                    {
                                        id: "tthue", header: "Tiền thuế", width: 150, css: { "text-align": "right" }, columnType: "numeric",
                                        template: function (obj, common) {
                                            return obj.tthue == null ? 0 : fm(obj.tthue);
                                        }
                                    },
                                    {
                                        id: "tgtien", header: "Tổng tiền", width: 150, css: { "text-align": "right" }, columnType: "numeric",
                                        template: function (obj, common) {
                                            return obj.tgtien == null ? 0 : fm(obj.tgtien);
                                        }
                                    },
                                ],
                                on: {
                                    onItemClick: function (id, e, node) {
                                        var item = this.getItem(id);
                                        item.chon = item.chon === "C" ? "K" : "C";
                                        this.updateItem(id, item);
                                    },
                                    "data->onStoreUpdated": function () {
                                        this.data.each(function (obj, i) {
                                            obj.stt = i + 1;
                                        });
                                    },
                                },
                            }
                        ]
                    },
                    {
                        id: "btnHuyHDDT",
                        cols: [
                            {},
                            {
                                view: "button", id: "btnXacNhan", label: "Xác nhận", badge: "F10", css: "webix_primary",
                                shortcut: "F10", label: "Xác nhận", type: "icon", align: "center", width: 120,
                                click: function () {
                                    var table = webix.$$("danhsach_hoadon");
                                    var data = table.serialize();
                                    var dataDetail = [];
                                    for (var i = 0; i < data.length; i++) {
                                        if (data[i].chon == "C") 
                                        {
                                            data[i].cthuc = 1;
                                            dataDetail.push(data[i]);
                                        }
                                    }
                                    if (dataDetail.length <= 0) {
                                        webix.message("Bạn chưa chọn chi tiết hàng hóa", "debug");
                                        return;
                                    }
                                    webix.$$("hoadon68_chitiet").parse(dataDetail);
                                    $$("DsHoaDon-Win").close();
                                },
                                on: {
                                    onItemClick: function (id, e) {
                                        var table = webix.$$("hoadon68_chitiet");
                                        var item = { id: webix.uid(), tchat: 1, cthuc: 1 };
                                        table.add(item);
                                        table.select(item.id, "ma", false);
                                        table.edit({ row: item.id, column: "ma" });

                                        if ($$("tgtck20") != undefined) {
                                            $$("tgtck20").setValue(0);
                                        }
                                    },
                                },
                            },
                            {
                                view: "button", hotkey: "esc", label: "Hủy bỏ", badge: "ESC", css: "webix_danger", width: 120, type: "icon", align: "center",
                                click: function () {
                                    webix.$$("DsHoaDon-Win").close();
                                }
                            },
                            {}
                        ]
                    }
                ]

            },
            setEditMode: function (mode, id) {
                var table = webix.$$("invoiceViews");
                var item = table.getSelectedItem();
                var icon = "";
                if (mode == 1) {
                    icon = "<span><i class='fa fa-plus' aria-hidden='true'></i></span>";
                    var result = webix.ajax().sync().get(app.config.host + "/Invoice68/GetDetailInvoice?id=" + item.id);
                    var json = JSON.parse(result.response);
                    $$("danhsach_hoadon").parse(json);
                }
                else {
                    if (mode == 2)
                        icon = "<i class='fa fa-edit' aria-hidden='true'></i>";
                    else
                        icon = "<i class='fa fa-trash fa-lg' aria-hidden='true'></i>";
                }
                webix.$$("head-icondieuchinhhoadon").setHTML(icon);
                webix.$$("head-icondieuchinhhoadon").refresh();
                webix.$$("head-formdieuchinhhoadon").setHTML("Hóa đơn số " + item.shdon + " ký hiệu " + item.khieu);
                webix.$$("head-formdieuchinhhoadon").refresh();
            }
        };
        return productDetailLayout
    }
    return {
        $ui: function () {
            return productDetail();
        }
    };
});
define('views/forms/forms68/HDon/popupSelectProduct',[
    "app",
    "locale",
    "models/user",
    "views/modules/minvoiceplugin",
    "views/forms/signCloudMulti",
    "views/modules/Component/ajaxHelper",
    "views/modules/Component/constantManager",
    "views/modules/Component/functionExtension",
    "views/forms/forms68/HDon/popupDetailProduct"
],
    function (app, _, user, plugin, signCloudMulti, Ajax, Constant, functionExtension, popupDetailProduct) {
        var editmode = 0; // 1 là có mã, 2 là ko mã
        var windowId = "chukyso-wins";
        var formId = "chukyso-forms";
        var tableId = "tblHoadons";
        var message_nodata = "Không có dữ liệu";

        var layout =
        {
            view: "window", modal: true, resize: true, id: windowId, position: "center", move: true, css: "headformchil",
            head: {
                height: 40,
                cols: [
                    { id: "head-form", view: "template", css: "headform", template: function (obj) { return '<div>Chọn hóa đơn cần lấy chi tiết<div/>'; } },
                    { view: "icon", icon: "fas fa-question-circle", id: "help_dksdForms", tooltip: _("HELPER"), click: function () { } }
                ]
            },
            minWidth: 600,
            minHeight: 600,
            body: {
                paddingY: 10,
                paddingX: 10,
                view: "form",
                id: formId,
                complexData: true,
                margin: 0,
                elements: [
                    {
                        cols: [
                            { view: "datepicker", name: "tu_ngay", format: "%d/%m/%Y", label: "Từ ngày", labelPosition: "top", value: new Date(), editable: true },
                            { view: "datepicker", name: "den_ngay", format: "%d/%m/%Y", label: "Đến ngày", labelPosition: "top", value: new Date(), editable: true },
                        ]
                    },
                    {
                        view: "combo",
                        name: "quanlykyhieu68_id",
                        label: "Ký hiệu",
                        labelPosition: "top",
                        required: true,
                        invalidMessage: "Ký hiệu hóa đơn không được để trống !",
                        options:
                        {
                            view: "gridsuggest",
                            url: app.config.host + "/Invoice68/GetTypeInvoiceSeries?type=1,2,6",
                            body: {
                                scroll: true,
                                autoheight: false,
                                autofocus: true,
                                yCount: 10,
                                columns: [
                                    { id: "value", header: _("KY_HIEU"), width: 150 },
                                    {
                                        id: "date_new", header: _("Ngày tạo"), width: 150,
                                        format: function (text) {
                                            var format = webix.Date.dateToStr("%d/%m/%Y");
                                            text = removeTimeZoneT(text);
                                            return format(text);
                                        }
                                    },
                                ]
                            },
                        }
                    },
                    { view: "template", template: "Danh sách hóa đơn", type: "section" },
                    {
                        view: "datatable",
                        select: "row",
                        id: tableId,
                        resizeColumn: true,
                        datafetch: 50,
                        columns: [
                            {
                                id: "checkboxSelect",
                                header: [{ text: "", content: "masterCheckbox" }], width: 55, checkValue: 'C', uncheckValue: 'K',
                                template: "{common.checkbox()}"
                            },
                            { id: "RowNumber", sort: "int", header: "STT", width: 50 },
                            { id: "hoadon68_id", header: "ID hóa đơn", width: 250, hidden: true },
                            {
                                id: "tdlap", header: "Ngày hóa đơn", width: 150, format: function (text) {
                                    var format = webix.Date.dateToStr("%d/%m/%Y");
                                    text = removeTimeZoneT(text);
                                    return format(text);
                                }
                            },
                            { id: "shdon", header: "Số hóa đơn" },
                            {
                                id: "tgtttbso", header: "Tổng tiền", width: 150, format: webix.Number.numToStr({
                                    groupDelimiter: ",",
                                    groupSize: 3,
                                    decimalDelimiter: ".",
                                    decimalSize: 0
                                })
                            }
                        ],
                        on: {
                            onItemClick: function (id, e, node) {
                                var item = this.getItem(id);
                                item.checkboxSelect = item.checkboxSelect === "C" ? "K" : "C";
                                this.updateItem(id, item);
                            }
                        },
                        pager: "selectPagerA"
                    },
                    {
                        id: "selectPagerA",
                        view: "pager",
                        size: 50,
                        group: 5,
                        template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}"
                    },
                    {
                        margin: 10,
                        cols: [
                            {},
                            {
                                shortcut: "F9", view: "button", label: "Tải dữ liệu (F9)", type: "danger", align: "center", width: 120,
                                on: {
                                    onClick: function () {
                                        var formComponent = webix.$$(formId);
                                        if (formComponent.validate()) {
                                            var item = formComponent.getValues();
                                            var format = webix.Date.dateToStr("%Y-%m-%d");
                                            var parameter = {
                                                ma_dvcs: user.getDvcsID(),
                                                tu_ngay: format(item.tu_ngay),
                                                den_ngay: format(item.den_ngay),
                                                quanlykyhieu68_id: item.quanlykyhieu68_id,
                                            };
                                            webix.extend(formComponent, webix.ProgressBar);
                                            formComponent.disable();
                                            formComponent.showProgress();
                                            webix.ajax().headers({ 'Content-type': 'application/json' })
                                                .post(app.config.host + Constant.API.SIGN.GET_INVOICE_ALL_STATUS, parameter, function (text) {
                                                    var response = JSON.parse(text);
                                                    formComponent.enable();
                                                    formComponent.hideProgress();
                                                    if (!response.hasOwnProperty("error")) {
                                                        var table = $$(tableId);
                                                        table.clearAll();
                                                        if (response.length == 0) {
                                                            webix.message(message_nodata, "error");
                                                        }
                                                        else {
                                                            table.parse(response);
                                                        }
                                                    }
                                                });
                                        }
                                    }
                                },
                                click: function () {
                                    this.callEvent("onClick");
                                }
                            },
                            {
                                view: "button", type: "icon", icon: "mdi mdi mdi-file-document-outline", label: "Xác nhận",
                                type: "form",
                                width: 185,
                                on: {
                                    onItemClick: function () {
                                        var filteredCheckboxSelected = (webix.$$(tableId).serialize(true)).filter(function (item) {
                                            return item.checkboxSelect === "C";
                                        });
                                        var lstItemId = filteredCheckboxSelected.map(function (item) {
                                            return String(item.hoadon68_id)
                                        });
                                        var lstKH = filteredCheckboxSelected.map(function (item) {
                                            return String(item.khieu)
                                        });

                                        if (lstItemId.length === 0) {
                                            webix.message("Bạn chưa chọn hóa đơn", "debug");
                                            return;
                                        }
                                        var arr = [];
                                        for (var i = 0; i < lstItemId.length; i++) {
                                            arr.push(lstItemId[i]);
                                        }

                                        webix.ajax().headers({ 'Content-type': 'application/json' }).post(app.config.host + "/Invoice68/GetDetailInvoice", JSON.stringify(arr), function (text) {
                                            var data = JSON.parse(text);
                                            for (var i = 0; i < data.length; i++) {
                                                for (var j = 0; j < lstKH.length; j++) {
                                                    if (!(lstKH[j].startsWith("1C") || lstKH[j].startsWith("1K"))) {
                                                        data[i].ptthue = null;
                                                        data[i].tthue = 0;
                                                        data[i].tsuat = null;
                                                    }
                                                }
                                                data[i].hoadon68_chitiet_id = null,
                                                data[i].hoadon68_id = null
                                            }
                                            var tableDetail = webix.$$("danhsach_hoadon");
                                            tableDetail.clearAll();
                                            tableDetail.parse(data);
                                        });
                                        var frm = $$(windowId).$scope.ui(popupDetailProduct.$ui());
                                        frm.show();
                                    }
                                },
                            },
                            {
                                view: "button", hotkey: "esc", label: "Hủy bỏ (ESC)", type: "danger", align: "center", width: 100,
                                click: function () {
                                    webix.$$(windowId).close();
                                }
                            },
                            {}
                        ]
                    }
                ]
            }
        };
        return {
            $ui: layout,
        };
    }
);


define('views/forms/forms70/Bangke/chonHoaDon',[
    "app",
    "locale",
    "views/modules/Component/constantManager"
], function (app, _, CONSTANTS) {

    var datatableId = "bangkeDatatable";
    var bangkeIdWin = "bangkeWindown";
    var bangkeIdForm = "bangkeForm";
    const formatDate = date => webix.Date.dateToStr("%d/%m/%Y")(date);
    const monthOptions = Array.from({ length: 12 }, (_, i) => ({ id: i + 1, value: `${i + 1}` }));

    const today = new Date();
    const currentMonth = today.getMonth() + 1;
    const currentYear = today.getFullYear();

    var type = "";
    const fetchData = () => {
        var table = $$(datatableId);
        var form = $$(bangkeIdForm);
        var dataForm = form.getValues();
        // var tableForm = table.getValues();

        const kyhieu_text = dataForm.serialId;
        const mst = dataForm.filter_MST;
        const month = dataForm.filter_thang;
        const year = dataForm.filter_nam;
        const tuNgay = dataForm.filter_tu_ngay;
        const denNgay = dataForm.filter_den_ngay;
        // const shdon = tableForm.shdon;
        // const tnmua = tableForm.tnmua;
        // const nglap = tableForm.nglap;

        if (!mst || !/^\d{10}(-\d{3})?$/.test(mst)) {
            webix.message("Mã số thuế không đúng định dạng!", "error");
            if ($$("filter_MST")) $$("filter_MST").focus();
            return;
        }

        const start = 0;
        const count = 1000;
        const isListAll = true;

        const filterArr = [];
        if (kyhieu_text && kyhieu_text.trim() !== "") {
            filterArr.push({
                columnName: "khieu",
                value: kyhieu_text,
                columnCondition: "=",
                columnType: "string"
            });
        }
        if (mst) {
            filterArr.push({
                columnName: "mst",
                value: mst,
                columnCondition: "=",
                columnType: "string"
            });
        }
        if (tuNgay) {
            filterArr.push({
                columnName: "tdlap",
                value: webix.Date.dateToStr("%Y-%m-%d")(tuNgay),
                columnCondition: ">=",
                columnType: "date"
            });
        }
        if (denNgay) {
            filterArr.push({
                columnName: "tdlap",
                value: webix.Date.dateToStr("%Y-%m-%d")(denNgay),
                columnCondition: "<=",
                columnType: "date"
            });
        }
        if (month && year && !tuNgay && !denNgay) {
            filterArr.push({
                columnName: "tdlap",
                value: `${year}-${String(month).padStart(2, '0')}`,
                columnCondition: "month_year",
                columnType: "date"
            });
        }
        // if (shdon) {
        //     filterArr.push({
        //         columnName: "shdon",
        //         value: shdon,
        //         columnCondition: "<=",
        //         columnType: "string"
        //     });
        // }
        // if (tnmua) {
        //     filterArr.push({
        //         columnName: "tnmua",
        //         value: tnmua,
        //         columnCondition: "=",
        //         columnType: "string"
        //     });
        // }
        // if (nglap) {
        //     filterArr.push({
        //         columnName: "nglap",
        //         value: nglap,
        //         columnCondition: "=",
        //         columnType: "string"
        //     });
        // }
        const payload = {
            start,
            count,
            isListAll,
            filter: filterArr
        };

        const url = app.config.host.replace(/\/+$/, '') + CONSTANTS.API.BANGKE.GET_INVOICE;
        if (form.validate()) {
            webix.extend(form, webix.ProgressBar);
            form.disable();
            form.showProgress();
            webix.ajax()
                .headers({ "Content-Type": "application/json" })
                .post(url, payload)
                .then((data) => {
                    form.enable();
                    form.hideProgress();
                    try {
                        const obj = data.json();
                        if (obj.data) {
                            table.clearAll();
                            table.parse(obj.data);
                        } else {
                            webix.message("Không có dữ liệu trả về.");
                            table.clearAll();
                        }
                    } catch (e) {
                        console.error("Lỗi khi parse JSON:", e);
                        webix.message("Lỗi định dạng JSON từ máy chủ.");
                    }
                })
                .catch((err) => {
                    form.enable();
                    form.hideProgress();
                    console.error("Lỗi gọi API:", err);
                    webix.message("Lỗi khi gọi API. Vui lòng thử lại.");
                });
        }
    };
    const filterRow = {
        cols: [
            {
                id: "serialId",
                view: "combo",
                name: "serialId",
                width: 250,
                label: "Ký hiệu",
                options: {
                    body: {
                        data: [],
                        ready: function () {
                            const khieu = webix.$$("kyhieu_id").getText();
                            var twoChars = khieu.substring(0, 2);
                            webix.ajax().get(CONSTANTS.API.SERIAL_TYPE + twoChars).then(data => {
                                this.clearAll();
                                this.parse(data.json());
                                if (this.count() > 0) {
                                    const firstId = this.getFirstId();
                                    webix.$$("serialId").setValue(firstId);
                                }
                            }).catch(err => {
                                webix.message("Lỗi khi tải dữ liệu từ API.", "error");
                            });
                        }
                    }
                },

            },
            {
                view: "text",
                id: "filter_MST",
                name: "filter_MST",
                label: "Mã số thuế",
                labelWidth: 80,
                width: 200,
                on: {
                    onChange: function () {
                    }
                },
            },
            {
                view: "combo",
                id: "filter_thang",
                name: "filter_thang",
                label: "Tháng",
                labelWidth: 80,
                width: 200,
                options: monthOptions,
                value: currentMonth,
                on: {
                    onChange: function () {
                        $$("filter_tu_ngay").setValue(new Date($$("filter_nam").getValue(), this.getValue() - 1, 1));
                        $$("filter_den_ngay").setValue(new Date($$("filter_nam").getValue(), this.getValue(), 0));
                    }
                }
            },
            {
                view: "text",
                id: "filter_nam",
                name: "filter_nam",
                label: "Năm",
                labelWidth: 40,
                width: 200,
                value: currentYear,
                pattern: { mask: "####" },
                attributes: { maxlength: 4, inputmode: "numeric" },
                validate: function (value) {
                    var nowYear = new Date().getFullYear();
                    return /^\d{4}$/.test(value) && parseInt(value, 10) <= nowYear;
                },
                invalidMessage: "Nhập năm hợp lệ, không lớn hơn năm hiện tại",
                on: {
                    onChange: function () {
                        var val = this.getValue();
                        var nowYear = new Date().getFullYear();
                        if (!/^\d{4}$/.test(val) || parseInt(val, 10) > nowYear) {
                            webix.message("Năm phải gồm 4 chữ số và không lớn hơn năm hiện tại!", "error");
                            return;
                        }
                        $$("filter_tu_ngay").setValue(new Date(val, $$("filter_thang").getValue() - 1, 1));
                        $$("filter_den_ngay").setValue(new Date(val, $$("filter_thang").getValue(), 0));
                    }
                }
            },
            {
                view: "datepicker",
                id: "filter_tu_ngay",
                name: "filter_tu_ngay",
                label: "Từ ngày",
                labelWidth: 80,
                width: 200,
                format: "%d/%m/%Y",
                value: new Date(currentYear, currentMonth - 1, 1),
                on: {
                    onChange: function (newDate) {
                        var thang = parseInt($$("filter_thang").getValue(), 10);
                        var nam = parseInt($$("filter_nam").getValue(), 10);
                        if (newDate.getMonth() + 1 !== thang || newDate.getFullYear() !== nam) {
                            webix.message("Chỉ được chọn ngày trong tháng đã chọn!", "error");
                            this.setValue(new Date(nam, thang - 1, 1));
                            return;
                        }

                    }
                }
            },
            {
                view: "datepicker",
                id: "filter_den_ngay",
                name: "filter_den_ngay",
                label: "Đến ngày",
                labelWidth: 80,
                width: 200,
                format: "%d/%m/%Y",
                value: new Date(currentYear, currentMonth, 0),
                on: {
                    onChange: function (newDate) {
                        var thang = parseInt($$("filter_thang").getValue(), 10);
                        var nam = parseInt($$("filter_nam").getValue(), 10);
                        if (newDate.getMonth() + 1 !== thang || newDate.getFullYear() !== nam) {
                            webix.message("Chỉ được chọn ngày trong tháng đã chọn!", "error");
                            var lastDay = new Date(nam, thang, 0);
                            this.setValue(lastDay);
                            return;
                        }
                    }
                }
            },
            {
                view: "button",
                id: "search_button_id",
                type: "iconButton",
                icon: "mdi mdi-magnify",
                width: 40,
                tooltip: "Tìm kiếm",
                click: fetchData
            }
        ]
    };

    const grid = {
        view: "datatable",
        id: datatableId,
        select: true,
        resizeColumn: true,
        fixedRowHeight: false,
        leftSplit: 8,
        rowLineHeight: 25,
        rowHeight: 25,
        tooltip: true,
        footer: true,
        headermenu: {
            autoheight: false,
            scroll: true,
            autowidth: true
        },
        multiview: { keepViews: true },
        keepViews: true,
        editable: false,
        hover: "myhover",
        onClick: {

        },
        type: {
        },
        on: {
            "data->onStoreUpdated": function () {
                this.data.each(function (obj, i) {
                    obj.stt = i + 1;
                });
            },
            onBeforeLoad: function () {
                webix.extend(this, webix.ProgressBar);
                this.showProgress({
                    type: "top"
                });
            },
            onAfterLoad: function () {
                this.hideProgress();
                if (!this.count())
                    this.showOverlay("<div><img src='assets/imgs/nodata.png'><div class='showOverlaydata'>Không có dữ liệu </br> Chúng tôi không tìm thấy hóa đơn</div></div>");
                else
                    this.hideOverlay();
            }
        },
        columns: [
            { id: "checkbox", header: { content: "masterCheckbox" }, template: "{common.checkbox()}", width: 40 },
            {
                id: "ten_tt", header: [_("TRANG_THAI"), { content: "multiSelectFilter", options: CONSTANTS.STATUS_INVOICE }],
                template: "<span class='mcls_status#is_tthdon#'>#ten_tt#</span>",
                width: 120, columnType: "nvarchar", editor: "text", sort: "string"
            },
            { id: "tthai", header: [_("TT_GUI"), ], width: 140 },
            { id: "tdlap", header: [{ text: "Ngày hóa đơn" },], width: 120, template: obj => obj.tdlap ? webix.Date.dateToStr("%d/%m/%Y")(new Date(obj.tdlap)) : "", sort: "date", format: formatDate },
            { id: "khieu", header: [_("KY_HIEU"),], width: 100, editor: "text" },
            { id: "shdon", header: [_("SO_HDON"), { content: "textFilter" }], width: 100, editor: "text" },
            { id: "mst", header: [_("MST"),], width: 100, editor: "text" },
            { id: "tnmua", header: [_("DV_NMUA"), { content: "textFilter" }], width: 240, editor: "text" },
            { id: "is_send_email", header: ["Email", { content: "selectFilter", options: CONSTANTS.STATUS_SEND_EMAIL }], width: 60, columnType: "bit", css: { "text-align": "center" }, template: "{common.rcheckbox()}" },
            { id: "tgtcthue", header: [_("TIEN"), { content: "textFilter" }], width: 120, css: { "text-align": "right" }, columnType: "decimal", template: "{common.amount()}" },
            { id: "tgtthue", header: [_("TIEN_THUE"), { content: "textFilter" }], width: 120, css: { "text-align": "right" }, columnType: "decimal", template: "{common.amount()}" },
            { id: "tgtttbso", header: [_("THANH_TIEN"), { content: "textFilter" }], width: 120, css: { "text-align": "right" }, columnType: "decimal", template: "{common.amount()}" },
            { id: "htttoan", header: [_("HT_TTOAN"), { content: "textFilter" }], width: 120, editor: "text" },
            { id: "nlap", header: [_("NGAY_TAO_MOI"), { content: "dateRangeFilter" }], width: 120, hidden: true, format: formatDate },
            { id: "nglap", header: [_("USER_NEW"), { content: "textFilter" }], width: 150, editor: "text" }
        ]
    };

    const pager = {
        view: "pager",
        id: "pagerA",
        size: 50,
        group: 5,
        template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}",
        height: 40
    };
    function handleNhanButtonClick(type) {
        const table = $$(datatableId);
        const selectedItems = table.find(row => row.checkbox);

        if (!selectedItems || selectedItems.length === 0) {
            webix.message("Vui lòng chọn ít nhất một hóa đơn!", "error");
            return;
        }
        const validStatus = ["Đã gửi", "Đã ký"];
        const allSigned = selectedItems.every(item => validStatus.includes(item.tthai));
        if (!allSigned) {
            webix.message("Chỉ được chọn các hóa đơn đã ký gửi!", "error");
            return;
        }
        const firstKhieu = selectedItems[0].khieu;
        const allSameKhieu = selectedItems.every(item => item.khieu == firstKhieu);
        if (!allSameKhieu) {
            webix.message("Tất cả hóa đơn được chọn phải có cùng ký hiệu (khieu)!", "error");
            return;
        }

        const first = selectedItems[0];
        if (first) {
            $$("nmua").setValue(first.tnmua || "");
            $$("mst_nmua").setValue(first.mst || first.mnmua || "");
            $$("dchi_nmua").setValue(first.dchi || "");
        }
        if (type == "bangke_chitiet") {
            const bangkeChitiet = webix.$$("bangke_chitiet");
            selectedItems.forEach((invoice) => {
                if (invoice.id) {
                    const apiUrl = app.config.host + "/Invoice68/GetDetailInvoice?id=" + invoice.id;
                    webix.ajax().get(apiUrl, {
                        error: function (err) {
                            console.error("Error fetching details for invoice ID:", invoice.id, err);
                            webix.message("Không thể tải dữ liệu chi tiết cho hóa đơn: " + invoice.id, "error");
                        },
                        success: function (response) {
                            try {
                                const detailData = JSON.parse(response);
                                const mappedData = detailData.map((item, index) => ({
                                    stt: index + 1,
                                    kyhieu: invoice.khieu,
                                    sohoadon: invoice.shdon,
                                    ten_hhdv_goc: item.ten,
                                    sluong_goc: item.sluong,
                                    dgia_goc: item.dgia,
                                    thtien_goc: item.thtien,
                                    tsuat_goc: item.tsuat,
                                    tthue_goc: item.tthue,
                                    tgtien_goc: item.tgtien,
                                    ten_hhdv_tdoi: item.ten,
                                    sluong_tdoi: item.sluong,
                                    dgia_tdoi: item.dgia,
                                    thtien_tdoi: item.thtien,
                                    tthue_tdoi: item.tthue,
                                    tsuat_tdoi: item.tsuat,
                                    tgtien_tdoi: item.tgtien,
                                    hoadon68_id: invoice.id
                                }));
                                bangkeChitiet.parse(mappedData);
                            } catch (parseError) {
                                console.error("Error parsing response for invoice ID:", invoice.id, parseError);
                                webix.message("Dữ liệu trả về không hợp lệ cho hóa đơn: " + invoice.id, "error");
                            }
                        }
                    });
                }
            });
            $$(bangkeIdWin).close();
        } else {
            var hdckhauChitiet = webix.$$("hdck_chitiet");
            if (hdckhauChitiet) {
                hdckhauChitiet.parse(selectedItems);
                hdckhauChitiet.data.each(function (item, index) {
                    item.stt = index + 1;
                });
                hdckhauChitiet.refresh();
                const firstInvoice = selectedItems[0];
                if (firstInvoice) {
                    $$("nmua").setValue(firstInvoice.tnmua || "");
                    $$("mst_nmua").setValue(firstInvoice.mst || firstInvoice.mnmua || "");
                    $$("dchi_nmua").setValue(firstInvoice.dchi || "");
                }
                $$(bangkeIdWin).close();
            }
        }
    }
    const actionButtons = {
        cols: [
            {},
            { view: "button", value: "Đóng", type: "danger", width: 100, click: function () { $$(bangkeIdWin).close(); } },
            {
                view: "button", value: "Nhận", type: "form", width: 100, click: function () {
                    handleNhanButtonClick(type);
                }
            },
            {}
        ]
    };

    const layout = {
        view: "window",
        id: bangkeIdWin,
        modal: true,
        position: function (state) {
            state.width = state.maxWidth * 0.9;
            state.height = state.maxHeight * 0.9;
            state.left = (state.maxWidth - state.width) / 2;
            state.top = (state.maxHeight - state.height) / 2;
        },
        width: 1200,
        height: 700,
        head: "Chọn hóa đơn vào bảng kê",
        // on: {
        //     onBeforeShow: function () {
        //         const khieu = webix.$$("kyhieu_id").getText();
        //         console.log(khieu);
        //         type = khieu;
        //     }
        // },
        body: {
            view: "form",
            id: bangkeIdForm,
            position: "center",
            paddingY: 5,
            paddingX: 5,
            scroll: true,
            margin: 0,
            elements: [
                {
                    rows: [
                        filterRow,
                        { height: 5 },
                        grid,
                        pager,
                        actionButtons
                    ]
                }
            ]
        }
    };

    webix.rules.isYear = function (value) {
        return /^\d{4}$/.test(value);
    };

    return {
        $ui: layout,
        $oninit: function (view, scope) {
            scope.on(app, "dataChanged", function () {
                const table = $$(datatableId);
                // if (table) {
                //     table.clearAll();
                // }
            });
        },
        setType: function (newType) {
            type=newType;
        },
        setMSTValue: function (mst) {
            if ($$("filter_MST")) {
                $$("filter_MST").setValue(mst);
                if (mst && mst !== "") {
                    $$("filter_MST").disable();
                } else {
                    $$("filter_MST").enable();
                }
            }
        }
    };
});

define('views/modules/Component/componentHelper',[
  "app",
  "locale",
  "views/modules/Component/functionExtension",
  "views/forms/forms68/HDon/68_chonhanghoa",
  "views/modules/Component/constantManager",
  "views/forms/forms68/HDon/popupSelectProduct",
  "views/forms/forms70/Bangke/chonHoaDon"
], function (app, _, functionExtension, ChonHangHoa, constant, popupSelectProduct, chonHoaDonForm) {

  var calculatorMoney = function (tableId) {
    var table = webix.$$(tableId);
    var data = table.serialize();
    var theoMaHang = webix.$$("check_tinhctmathang").getValue();

    var tong = {
      all: { tt: 0, thue: 0, ck: 0, tong: 0 },
      10: { tt: 0, thue: 0, ck: 0, tong: 0 },
      8: { tt: 0, thue: 0, ck: 0, tong: 0 },
      5: { tt: 0, thue: 0, ck: 0, tong: 0 },
      0: { tt: 0, thue: 0, ck: 0, tong: 0 },
      '-1': { tt: 0, thue: 0, ck: 0, tong: 0 }, // không chịu thuế
      '-2': { tt: 0, thue: 0, ck: 0, tong: 0 }  // không kê khai
    };

    for (var i = 0; i < data.length; i++) {
      var e = data[i];
      var tsuat = e.tsuat;
      var tchat = e.tchat;
      var sign = (tchat === 3 || tchat === 4) ? -1 : 1;

      var thtien = (e.thtien || 0) * sign;
      var tthue = (e.tthue || 0) * sign;
      var stckhau = (e.stckhau || 0) * sign;
      var tgtien = (e.tgtien || 0) * sign;

      tong.all.tt += thtien;
      tong.all.ck += stckhau;

      if (theoMaHang == 0) {
        if (tong[tsuat]) {
          tong[tsuat].tt += thtien;
          tong[tsuat].ck += stckhau;
        }
      } else {
        tong.all.thue += tthue;
        tong.all.tong += tgtien;

        if (tong[tsuat]) {
          tong[tsuat].tt += thtien;
          tong[tsuat].ck += stckhau;
          tong[tsuat].thue += tthue;
          tong[tsuat].tong += tgtien;
        }
      }
    }

    if (theoMaHang == 0) {
      // Tính thuế và tổng tiền nếu theo mã hàng
      tong[10].thue = tong[10].tt * 0.1 + tong[8].tt * 0.08;
      tong[10].tong = tong[10].tt + tong[10].thue;

      tong[8].thue = tong[8].tt * 0.08;
      tong[8].tong = tong[8].tt + tong[8].thue;

      tong[5].thue = tong[5].tt * 0.05;
      tong[5].tong = tong[5].tt + tong[5].thue;

      tong[0].thue = 0;
      tong[0].tong = tong[0].tt;

      tong['-1'].thue = 0;
      tong['-1'].tong = tong['-1'].tt;

      tong['-2'].thue = 0;
      tong['-2'].tong = tong['-2'].tt;

      tong.all.thue = tong[10].thue + tong[8].thue + tong[5].thue + tong[0].thue;
      tong.all.tong = tong.all.tt + tong.all.thue;
    }

    // Hàm helper để gán giá trị nếu tồn tại view
    function set(id, val) {
      var el = $$(id);
      if (el) el.setValue(val);
    }

    set("tgtcthue", tong.all.tt);
    set("tgtcthue10", tong[10].tt + tong[8].tt);
    set("tgtcthue5", tong[5].tt);
    set("tgtcthue0", tong[0].tt);
    set("tgtcthuekct", tong['-1'].tt);
    set("tgtcthuekkk", tong['-2'].tt);

    set("ttcktmai", tong.all.ck);
    set("ttcktmai10", tong[10].ck);
    set("ttcktmai5", tong[5].ck);
    set("ttcktmai0", tong[0].ck);
    set("ttcktmaikct", tong['-1'].ck);
    set("ttcktmaikkk", tong['-2'].ck);

    set("tgtthue", tong.all.thue);
    set("tgtthue10", tong[10].thue + tong[8].thue);
    set("tgtthue5", tong[5].thue);
    set("tgtthue0", tong[0].thue);
    set("tgtthuekct", tong['-1'].thue);
    set("tgtthuekkk", tong['-2'].thue);

    set("tgtttbso", tong.all.tong);
    set("tgtttbso10", tong[10].tong);
    set("tgtttbso5", tong[5].tong);
    set("tgtttbso0", tong[0].tong);
    set("tgtttbsokct", tong['-1'].tong);
    set("tgtttbsokkk", tong['-2'].tong);
  };

  var changeVAT = function (typeVat) {
    function get(id) {
      var el = $$(id);
      return el && el.getValue() != null ? el.getValue() : 0;
    }

    var ttAll = get("tgtcthue");
    var thue10 = get("tgtthue10");
    var thue8 = get("tgtthuekhac");
    var thue5 = get("tgtthue5");
    var tongThue = thue10 + thue8 + thue5;

    var config = {
      10: {
        ttId: "tgtcthue10",
        tgttId: "tgtttbso10",
        thue: thue10
      },
      8: {
        ttId: "tgtcthuekhac",
        tgttId: "tgtttbsokhac",
        thue: thue8
      },
      5: {
        ttId: "tgtcthue5",
        tgttId: "tgtttbso5",
        thue: thue5
      }
    };

    var vatCfg = config[typeVat];
    if (vatCfg) {
      var tt = get(vatCfg.ttId);
      $$(vatCfg.tgttId).setValue(tt + vatCfg.thue);
    }

    $$("tgtthue").setValue(tongThue);
    $$("tgtttbso").setValue(ttAll + tongThue);
  };

  var dauphieuCommon = {
    empty_line: { height: 0, gravity: 0, template: "" },
    empty_cols: { width: 0, gravity: 0, template: "" },
    info_invoice: {
      cctbao_id: {
        view: "text",
        label: "cctbao_id",
        labelWidth: 100,
        id: "cctbao_id",
        name: "cctbao_id",
        hidden: true,
      },
      tdlap: {
        view: "datepicker",
        name: "tdlap",
        label: _("NGAY_LAP"),
        labelWidth: 100,
        id: "tdlap",
        value: new Date(),
      },
      khieu: {
        view: "combo",
        label: _("KY_HIEU"),
        labelWidth: 100,
        name: "khieu",
        css: "mcls_readonly_text",
        readonly: true,
        attributes: { readonly: true },
        id: "khieu",
        attributes: { maxlength: 7 },
        options: constant.API.SERIAL,
        on: {
          onChange: function (newv, oldv) {
            webix.ajax().headers({ "Content-type": "application/json" })
              .get(constant.API.SERIAL_SEARCH + newv, {
                error: function (text, data, XmlHttpRequest) {
                },
                success: function (text, data, XmlHttpRequest) {
                  var data = JSON.parse(text);
                  var cctbao_id = data[0]["quanlykyhieu68_id"];
                  $$("cctbao_id").setValue(cctbao_id);
                },
              });
          },
        },
      },
      shdon: {
        view: "text",
        name: "shdon",
        id: "shdon",
        label: _("SO_HDON"),
        labelWidth: 100,
        css: "mcls_readonly_text",
        readonly: true,
      },
      sophieu: {
        view: "text",
        name: "so",
        id: "so",
        label: _("Số phiếu"),
        labelWidth: 100,
        css: "mcls_readonly_text",
        readonly: true,
      },
      mahoso: {
        view: "text",
        name: "mhso",
        id: "mhso",
        label: _("Mã hồ sơ"),
        labelWidth: 100,
        value: "",
      },
      dvtte: {
        view: "combo",
        name: "dvtte",
        label: _("MA_TIEN_TE"),
        labelWidth: 100,
        //labelPosition: "top",
        id: "dvtte",
        required: true,
        hidden: false,
        value: "VND",
        invalidMessage: "Trạng thái hóa đơn không thể bỏ trống !",
        options: {
          view: "gridsuggest",
          value: "VND",
          template: "#value#",
          url: constant.API.GET_MA_TIEN_TE,
          body: {
            columns: [{ id: "value", header: _("MA_TIEN_TE"), width: 220 }],
            dataFeed: function (filtervalue, filter) {
              var check = filtervalue;
              if (filtervalue.length < 1) {
                this.load(this.config.url);
                return;
              }
              var urldata = "filtervalue=" + encodeURIComponent(filtervalue);
              this.load(constant.API.GET_MA_TIEN_TE + "&" + urldata, this.config.datatype);
            },
          },
        },
        on: {
          onChange: function (newv, oldv) {
            webix.storage.local.put("MA_TIEN_TE", newv);
            var table = webix.$$("hoadon68_chitiet");
            var form = $$("invoiceForms");
            var win = this.getTopParentView();
            var editmode = win.config.editmode;
            if (newv != null && newv != undefined) {
              webix.ajax().bind({ editmode: editmode })
                .headers({ "Content-type": "application/json" })
                .get(constant.API.DECIMAL_PLACES + encodeURIComponent(newv.toString()), function (text, data, XmlHttpRequest) {
                  var arr = JSON.parse(text);
                  var quantity = arr[0]["inv_quantity"];
                  var inv_TotalAmountWithoutVat = arr[0]["inv_TotalAmountWithoutVat"];
                  var inv_TotalAmount = arr[0]["inv_TotalAmount"];
                  var inv_unitPrice = arr[0]["inv_unitPrice"];
                  var inv_vatAmount = arr[0]["inv_vatAmount"];
                  webix.storage.local.put("DECIMAL_TOTAL_AMOUNT", inv_TotalAmount);
                  if (this.editmode == 1) {
                    var ty_gia = arr[0]["ty_gia"];
                    $$("tgia").setValue(ty_gia);
                  }

                  var format_config = table.getColumnConfig("sluong"); fmNumeric(format_config, quantity);
                  var tien_tt = table.getColumnConfig("thtien");
                  if (tien_tt != undefined) fmNumeric(tien_tt, inv_TotalAmountWithoutVat);
                  var tien_thue = table.getColumnConfig("tthue");
                  if (tien_thue != undefined) fmNumeric(tien_thue, inv_vatAmount);

                  var don_gia = table.getColumnConfig("dgia"); fmNumeric(don_gia, inv_unitPrice);
                  var tong_tien = table.getColumnConfig("tgtien");
                  if (tong_tien != undefined) fmNumeric(tong_tien, inv_TotalAmount);
                  var stckhau = table.getColumnConfig("stckhau");
                  if (stckhau != undefined) fmNumeric(stckhau, inv_TotalAmount);
                  tien_tt.decimal = inv_TotalAmountWithoutVat;
                  if (tien_thue != undefined) tien_thue.decimal = inv_vatAmount;

                  don_gia.decimal = inv_unitPrice;
                  tong_tien.decimal = inv_TotalAmount;
                  stckhau.decimal = inv_TotalAmount;

                  table.refreshColumns();

                  var total_amount = $$("tgtttbso").getValue();
                  total_amount = total_amount == "" ? 0 : total_amount;
                  var numTongtien = newv == "VND" || newv == "JPY" ? total_amount : Number(total_amount).toFixed(2);
                  var tien = functionExtension.DocTienBangChu(numTongtien.toString(), newv.toString());
                  webix.delay(
                    function (a) {
                      this.setValue(a);
                    }, $$("tgtttbchu"), [tien], 100);
                });
            }
          },
          onBeforeRender: function () {
            webix.storage.local.put("MA_TIEN_TE", null);
          },
        },
      },
      tgia: {
        view: "text",
        format: "1.111,00",
        label: _("TY_GIA"),
        labelWidth: 100,
        value: 1,
        hidden: false,
        name: "tgia",
        id: "tgia",
        on: {
          onChange: function (newv, oldv) {
            if (newv == undefined) return;
            if (newv == "") return;
            if (!webix.rules.isNumber(newv)) {
              webix.message("Tỷ giá phải nhập số", "error");
              this.focus();
              return;
            }
          },
        },
      },
      htttoan: {
        view: "comboIcon",
        labelWidth: 100,
        label: _("HT_TT"),
        icons: ["mdi-plus", "mdi-chevron-down"],
        name: "htttoan",
        id: "htttoan",
        value: "",
        options: {
          view: "gridsuggest",
          template: "#name#",
          id: "grdhtttoan",
          value: "TM/CK",
          url: constant.API.GET_HTTTOAN,
          body: {
            scroll: true,
            autoheight: false,
            columns: [
              { id: "name", header: _("Tên hình thức thanh toán"), width: 550 },
            ],
            // dataFeed: function (filtervalue, filter) {
            //     if (filtervalue.length < 1) return;
            //     var pathUrl = app.config.host + "/System/GetDataReferencesByRefId?refId=RF00003";
            //     var urldata = "filtervalue=" + encodeURIComponent(filtervalue);
            //     this.load(pathUrl + "&" + urldata, this.config.datatype);
            // }
          }
        },
        on: {
          onClickAddNew: function (e) {
            require(["views/forms/forms68/DanhMuc/htttoan"], function (editwindow) {
              editwindow.setEditMode(1);
              var win = webix.ui(editwindow.$ui);
              win.show();
              win.config.callback = function (obj) {
                $$("htttoan").getList().load(constant.API.GET_HTTTOAN);
                webix.delay(function (a) {
                  this.setValue(a);
                  this.refresh();
                }, $$("htttoan"), [obj.code], 100);
              };
            });
          },
          onAfterRender: function () {
            var self = this;
            webix.delay(function () {
              var current = self.getValue();
              if (!current || current === "") {
                webix.ajax().get(app.config.host + "/Pattern/GetHTTT", function (text) {
                  var result = JSON.parse(text);
                  var valueToSet = result && result.gia_tri ? result.gia_tri : "TM/CK";
                  self.setValue(valueToSet);
                });
              }
            }, self, null, 300);
          }

        }
      },
      sdhang: {
        view: "text",
        label: _("Số đơn hàng"),
        labelWidth: 100,
        name: "sdhang",
        id: "sdhang",
      },
      emailnban: {
        view: "text",
        label: _("Email người bán"),
        labelWidth: 100,
        id: "emailnban",
        name: "emailnban",
        readonly: true,
        css: "mcls_readonly_text",
      },
      sdtnban: {
        view: "text",
        label: _("SDT người bán"),
        labelWidth: 100,
        id: "sdt_ngban",
        name: "sdt_ngban",
        readonly: true,
        css: "mcls_readonly_text",
      },
      stknban: {
        view: "text",
        label: _("STK người bán"),
        labelWidth: 100,
        id: "stknban",
        name: "stknban",
        attributes: { maxlength: 30 },
        readonly: true,
        css: "mcls_readonly_text",
      },
      nganghang_ngban: {
        view: "text",
        label: _("NH người bán"),
        labelWidth: 100,
        id: "nganhang_ngban",
        name: "nganhang_ngban",
        readonly: true,
        css: "mcls_readonly_text",
      },
      kptquan: {
        view: "combo",
        name: "kptquan",
        label: "Khu phi thuế quan",
        labelWidth: 100,
        //labelPosition: "top",
        value: "đồng",
        id: "kptquan",
        value: "0",
        options: {
          view: "gridsuggest",
          template: "#name#",
          value: "0",
          body: {
            scroll: true,
            autoheight: false,
            columns: [
              { id: "code", header: _("Mã"), width: 80 },
              { id: "name", header: _("Tên"), width: 550 },
            ],
            data: [
              { id: "0", code: "0", name: "Hóa đơn dành cho tổ chức, cá nhân NGOÀI khu phi thuế quan", },
              { id: "1", code: "1", name: "Hóa đơn dành cho tổ chức, cá nhân TRONG khu phi thuế quan", },
            ],
          },
        },
        on: {},
      },
      sbke: {
        view: "text",
        label: "Số bảng kê",
        labelWidth: 100,
        id: "sbke",
        name: "sbke",
        css: "mcls_readonly_text",
        readonly: true,
        hidden: true,
      },

      nbke: {
        view: "datepicker",
        label: "Ngày bảng kê",
        labelWidth: 100,
        id: "nbke",
        name: "nbke",
        value: new Date(),
        css: "mcls_readonly_text",
        readonly: true,
        hidden: true,
      },
      tclquan: {
        view: "combo",
        label: "Tính chất hóa đơn liên quan",
        labelWidth: 200,
        id: "tclquan",
        name: "tclquan",
        css: "mcls_readonly_text",
        readonly: true,
        hidden: true,
        value: "5",
        options: [
          { id: "5", value: "Chiết khấu thương mại" },
        ],
      },

    },
    info_customer: {
      ma_ch: {
        view: "text",
        label: _("Mã cửa hàng"),
        labelWidth: 100,
        name: "ma_ch",
        attributes: { maxlength: 50 },
        id: "ma_ch",
      },
      ten_ch: {
        view: "text",
        label: _("Tên cửa hàng"),
        labelWidth: 100,
        name: "ten_ch",
        attributes: { maxlength: 400 },
        id: "ten_ch",
      },
      so_hchieu: {
        view: "text",
        label: _("Số hộ chiếu"),
        labelWidth: 120,
        attributes: { maxlength: 20 },
        name: "so_hchieu",
        id: "so_hchieu",
      },
      cccdan: {
        view: "text",
        label: _("Căn cước công dân"),
        labelWidth: 120,
        name: "cccdan",
        id: "cccdan",
        attributes: { maxlength: 12 },
      },
      mdvqhnsach_nmua: {
        view: "text",
        label: _("Mã đơn vị quan hệ ngân sách"),
        labelWidth: 190,
        attributes: { maxlength: 7 },
        name: "mdvqhnsach_nmua",
        id: "mdvqhnsach_nmua",
      },
      ckCustomer: {
        view: "checkbox",
        id: "ckCustomer",
        name: "ckCustomer",
        labelRight: "Xuất cho doanh nghiệp",
        labelWidth: 0,
        on: {
          onChange: function (newv, oldv) {
            var fieldName = ["ten", "dchi", "mst", "mnmua"];
            if (newv == 1) {
              fieldName.forEach((item, index) => {
                var element = $$("invoiceForms").elements[item];
                element.config.readonly = false;
                webix.html.removeCss(element.getNode(), "mcls_readonly_text");
                element.refresh();
              });
              $$("tnmua").setValue("");
            }
            else {
              fieldName.forEach((item, index) => {
                $$(item).setValue("");
                var element = $$("invoiceForms").elements[item];
                element.config.readonly = true;
                webix.html.addCss(element.getNode(), "mcls_readonly_text");
                element.refresh();
              });
              $$("tnmua").setValue("Khách lẻ không lấy hóa đơn");
            }
          }
        }
      },
      mst: {
        id: "mst",
        name: "mst",
        view: "search",
        label: _("MST"),
        labelWidth: 120,
        validate: webix.rules.isTaxOrCCCD,
        invalidMessage: "Mã số thuế không hợp lệ",
        placeholder: _("SEARCH") + "...",
        on: {
          onChange: function (newv, oldv) {
            if (newv == undefined || oldv == undefined) return;
            if (newv == "") return;
            if (!webix.rules.isTaxOrCCCD(newv)) {
              webix.message("Mã số thuế không hợp lệ", "error");
              this.focus();
              return;
            }
          },
          onTimedKeyPress: function () { },
          onSearchIconClick: function (e) {
            var text = this.getValue();
            var isCID = text.length === 12;
            var datapost = isCID ? { cid: text } : { masothue: text };
            var url1 = isCID ? constant.API.POST_INFO_CID + text : constant.API.POST_INFO_MST_GOV + text + "/manager";
            var url2 = constant.API.SEARCH_TAXCODE + text;

            var table = $$("invoiceForms");
            if (!webix.rules.isTaxOrCCCD(text)) return showError("Mã số thuế không hợp lệ");

            var called = false;
            var timeoutId = null;
            function enableUI() {
              table.enable();
              table.hideProgress();
            }
            function disableUI() {
              webix.extend(table, webix.ProgressBar);
              table.disable();
              table.showProgress();
            }
            function handleSuccess(response, mode) {
              if (response.hasOwnProperty("error")) return showError(response.error);
              if (mode == 2) {
                $$("ten").setValue(response.ten_cty || response.ho_ten);
                $$("dchi").setValue(response.dia_chi || "");
              }
              else {
                $$("ten").setValue(response.tennnt || response.ho_ten);
                var fullAddress = response.dctsdchi + ", " + response.dctsxaten;
                if (response.dctstinh.includes("TP")) fullAddress += ", " + response.dctstinh.replace("TP", "Thành phố");
                else fullAddress += ", Tỉnh " + response.dctstinh;
                fullAddress += ", Việt Nam";
                $$("dchi").setValue(fullAddress);
              }
            }

            // Gọi API2 fallback
            function callAPI2() {
              if (called) return;
              called = true;
              disableUI();
              webix.ajax().get(url2)
                .then(function (data) {
                  enableUI();
                  var res = data.json();
                  handleSuccess(res, 2);
                })
                .catch(function () {
                  enableUI();
                  showError("Không thể tìm kiếm mã số thuế");
                });
            }

            timeoutId = setTimeout(function () {
              callAPI2();
            }, 3000);

            // Gọi API1
            disableUI();
            webix.ajax().get(url1)
              .then(function (data) {
                enableUI();
                if (called) return;
                clearTimeout(timeoutId);
                called = true;
                var response = data.json();
                handleSuccess(response, 1);
              })
              .catch(function (xhr) {
                enableUI();
                if (called) return;
                clearTimeout(timeoutId);
                console.log("API1 lỗi:", xhr.status);
                callAPI2();
              });
          },
        },
      },
      mdtuong: {
        id: "mnmua",
        name: "mnmua",
        label: _("MA_DT"),
        labelWidth: 120,
        view: "search",
        icon: "mdi mdi-plus",
        suggest: {
          view: "gridsuggest",
          body: {
            columns: [
              { id: "id", hidden: true, header: "id" },
              { id: "ma_dt", width: 120, header: "Mã KH" },
              { id: "ten_dt", width: 350, header: "Tên khách hàng" },
            ],
            scroll: true,
            autoheight: false,
            datatype: "json",
            dataFeed: function (filtervalue, filter) {
              if (filtervalue.length < 1) return;
              var urldata = "filtervalue=" + encodeURIComponent(filtervalue);
              this.load(constant.API.GET_MA_DT + "&" + urldata, this.config.datatype);
            },
          },
          on: {
            onValueSuggest: function (obj) {
              $$("ten").setValue(obj.ten_dt);
              $$("dchi").setValue(obj.dia_chi);
              $$("mst").setValue(obj.ms_thue);
              $$("email").setValue(obj.email);
              $$("tnmua").setValue(obj.dai_dien);
              $$("cccdan").setValue(obj.cccdan);
              $$("mdvqhnsach_nmua").setValue(obj.mdvqhnsach_nmua);

              if ($$("BravoCustCode") != undefined) $$("BravoCustCode").setValue(obj.BravoCustCode);
              webix.ajax().get(app.config.host + "/Pattern/GetDmngh?id=" + obj.doc_id, function (text) {
                var data = JSON.parse(text);
                if (data.length > 0) {
                  if ($$("stknmua") != undefined) $$("stknmua").setValue(data[0].so_tk);
                  if ($$("stknmua") != undefined) $$("nganhang_ngmua").setValue(data[0].tai_ngh);
                }
              }
              );
            },
          },
        },
        on: {
          onSearchIconClick: function (e) {
            require(["views/forms/forms68/DanhMuc/dmkh"], function (dmkhForm) {
              dmkhForm.setEditMode(1);
              let win = $$("dmkhWin");
              if (!win) {
                let newUI = webix.copy(dmkhForm.$ui);
                win = webix.ui(newUI);
              }
              win.show();
              win.config.callback = function (obj) {
                $$("mnmua").setValue(obj.ma_dt);
                $$("ten").setValue(obj.ten_dt);
                $$("dchi").setValue(obj.dia_chi);
                $$("mst").setValue(obj.ms_thue);
                $$("email").setValue(obj.email);
                $$("tnmua").setValue(obj.dai_dien);
                $$("cccdan").setValue(obj.cccdan);
                $$("mdvqhnsach_nmua").setValue(obj.mdvqhnsach_nmua);
              };
            });
          },
        },
      },
      tnmua: {
        view: "text",
        label: _("TEN_NGUOI_MUA"),
        labelWidth: 120,
        name: "tnmua",
        id: "tnmua",
      },
      email: {
        view: "text",
        label: _("Email"),
        labelWidth: 120,
        name: "email",
        id: "email",
        invalidMessage: "Email không hợp lệ",
        validate: webix.rules.isEmail,
        attributes: { maxlength: 255 },
        on: {
          onTimedKeyPress: function () {
            if ($$("email").getValue().length > 255) {
              webix.message("Độ dài email không được vượt quá 255 ký tự", "debug");
              return;
            }
          },
          onChange: function (newValue, oldValue) { },
        },
      },
      tendvi: {
        id: "ten",
        name: "ten",
        label: _("TEN_DON_VI"),
        labelWidth: 120,
        view: "search",
        suggest: {
          view: "gridsuggest",
          body: {
            columns: [
              { id: "id", hidden: true, header: "id" },
              { id: "ma_dt", width: 120, header: "Mã KH" },
              { id: "ten_dt", width: 350, header: "Tên khách hàng" },
            ],
            scroll: true,
            autoheight: false,
            datatype: "json",
            textValue: "ten_dt",
            dataFeed: function (filtervalue, filter) {
              if (filtervalue.length < 1) return;
              var urldata = "filtervalue=" + encodeURIComponent(filtervalue);
              this.load(constant.API.GET_MA_DT + "&" + urldata, this.config.datatype);
            },
          },
          on: {
            onValueSuggest: function (obj) {
              if ($$("mnmua") != undefined) $$("mnmua").setValue(obj.ma_dt);
              debugger;
              $$("ten").setValue(obj.ten_dt);
              $$("dchi").setValue(obj.dia_chi);
              $$("mst").setValue(obj.ms_thue);
              $$("email").setValue(obj.email);
              $$("tnmua").setValue(obj.dai_dien);

              webix.ajax().get(app.config.host + "/Pattern/GetDmngh?id=" + obj.doc_id, function (text) {
                var data = JSON.parse(text);
                if (data.length > 0) {
                  if ($$("stknmua") != undefined) $$("stknmua").setValue(data[0].so_tk);
                  if ($$("stknmua") != undefined) $$("nganhang_ngmua").setValue(data[0].tai_ngh);
                }
              }
              );
            },
          },
        },
      },
      dchi: {
        view: "text",
        label: _("DIA_CHI"),
        labelWidth: 120,
        name: "dchi",
        id: "dchi",
      },
      stknmua: {
        view: "text",
        label: _("STK người mua"),
        labelWidth: 120,
        name: "stknmua",
        id: "stknmua",
        attributes: { maxlength: 30 },
      },
      nganhang_nmua: {
        view: "text",
        label: _("NH người mua"),
        labelWidth: 120,
        name: "nganhang_ngmua",
        id: "nganhang_ngmua",
      },
      sdtnmua: {
        view: "text",
        label: _("SĐT Người mua"),
        labelWidth: 120,
        name: "sdtnmua",
        id: "sdtnmua",
        validate: webix.rules.isPhoneNumber,
      },
    },
  };
  var dauphieuXangdau = function () {
    var tendvi = dauphieuCommon.info_customer.tendvi;
    var diachi = dauphieuCommon.info_customer.dchi;
    var mst = dauphieuCommon.info_customer.mst;
    var tdlap = dauphieuCommon.info_invoice.tdlap;
    var tnmua = dauphieuCommon.info_customer.tnmua;

    //tnmua.value = "Khách lẻ không lấy hóa đơn";
    // diachi.css = "mcls_readonly_text";
    // diachi.readonly = true;

    var layout = [
      {
        width: 400,
        view: "fieldset",
        label: "Thông tin hóa đơn",
        body: {
          id: "info-invoice",
          rows: [
            dauphieuCommon.info_invoice.khieu,
            tdlap,
            dauphieuCommon.info_invoice.cctbao_id,
            dauphieuCommon.info_invoice.htttoan
          ]
        }
      },
      {
        view: "fieldset",
        label: "Thông tin khách hàng",
        body: {
          id: "info-customer",
          rows: [
            {
              cols: [
                dauphieuCommon.info_customer.ckCustomer,
                dauphieuCommon.info_customer.mdtuong
              ]
            },

            {
              cols: [
                mst,
                dauphieuCommon.info_customer.email
              ]
            },
            tendvi,
            tnmua,
            diachi,
          ]
        }
      }
    ];
    return layout;
  }
  var masterPaymentRequest = function () {
    var tgia = dauphieuCommon.info_invoice.tgia;
    tgia.hidden = false;
    var dvtte = dauphieuCommon.info_invoice.dvtte;
    dvtte.hidden = false;
    var tendvi = dauphieuCommon.info_customer.tendvi;
    tendvi.label = _("TEN_DON_VI")
    var layout = [
      {
        width: 600,
        view: "fieldset",
        label: "Thông tin phiếu thu",
        body: {
          id: "info-invoice",
          rows: [
            {
              cols: [
                dauphieuCommon.info_invoice.tdlap,
                dauphieuCommon.info_invoice.sophieu,
                dauphieuCommon.info_invoice.cctbao_id,
                // dauphieuCommon.info_invoice.shdon,
              ],
            },
            {
              cols: [
                dvtte,
                tgia,
              ],
            },
            {
              cols: [
                dauphieuCommon.info_invoice.htttoan,
                dauphieuCommon.info_invoice.mahoso,
              ],
            },
            {
              cols: [
                dauphieuCommon.info_invoice.emailnban,
                dauphieuCommon.info_invoice.sdtnban,
              ],
            },
            {
              cols: [
                dauphieuCommon.info_invoice.stknban,
                dauphieuCommon.info_invoice.nganghang_ngban,
              ],
            },
          ],
        },
      },
      {
        view: "fieldset",
        label: `Thông tin khách hàng`,
        body: {
          id: "info-customer",
          rows: [
            // { view: 'label', id: 'textWarning', label: '', hidden: true },
            {
              cols: [
                dauphieuCommon.info_customer.mst,
                dauphieuCommon.info_customer.mdtuong,
              ],
            },
            {
              cols: [
                dauphieuCommon.info_customer.tnmua,
                dauphieuCommon.info_customer.email,
              ],
            },
            tendvi,
            dauphieuCommon.info_customer.dchi,
            {
              cols: [
                dauphieuCommon.info_customer.stknmua,
                dauphieuCommon.info_customer.nganhang_nmua,
              ],
            },
          ],
        },
      },
    ];
    return layout;
  };
  var dauphieuHoadonNormal = function (typeInvoice) {
    var tgia = dauphieuCommon.info_invoice.tgia;
    tgia.hidden = false;
    var dvtte = dauphieuCommon.info_invoice.dvtte;
    dvtte.hidden = false;
    // KHÔNG ép hiện sbke, nbke, tclquan ở đây nữa
    var tendvi = dauphieuCommon.info_customer.tendvi;
    tendvi.label = _("TEN_DON_VI")
    var layout = [
      {
        width: 600,
        view: "fieldset",
        label: "Thông tin hóa đơn",
        body: {
          id: "info-invoice",
          rows: [
            {
              cols: [
                dauphieuCommon.info_invoice.tdlap,
                dauphieuCommon.info_invoice.khieu,
                dauphieuCommon.info_invoice.cctbao_id,
                dauphieuCommon.info_invoice.shdon,
              ],
            },
            {
              cols: [
                dvtte,
                tgia,
              ],
            },
            {
              cols: [
                dauphieuCommon.info_invoice.htttoan,
                dauphieuCommon.info_invoice.sdhang,
              ],
            },
            {
              cols: [
                dauphieuCommon.info_invoice.emailnban,
                dauphieuCommon.info_invoice.sdtnban,
              ],
            },
            {
              cols: [
                dauphieuCommon.info_invoice.stknban,
                dauphieuCommon.info_invoice.nganghang_ngban,
              ],
            },
            dauphieuCommon.info_customer.ma_ch,
            dauphieuCommon.info_customer.ten_ch,
            // {
            //   cols: [
            //     dauphieuCommon.info_invoice.sbke,
            //     dauphieuCommon.info_invoice.nbke,
            //   ],
            // },
            // {
            //   cols: [
            //     dauphieuCommon.info_invoice.tclquan,
            //   ],
            // },
            typeInvoice == 2
              ? dauphieuCommon.info_invoice.kptquan
              : dauphieuCommon.empty_line,
          ],
        },
      },
      {
        view: "fieldset",
        label: `Thông tin khách hàng`,
        body: {
          id: "info-customer",
          rows: [
            // { view: 'label', id: 'textWarning', label: '', hidden: true },
            {
              cols: [
                dauphieuCommon.info_customer.mst,
                dauphieuCommon.info_customer.mdtuong,
              ],
            },
            {
              cols: [
                dauphieuCommon.info_customer.tnmua,
                dauphieuCommon.info_customer.email,
              ],
            },
            tendvi,
            dauphieuCommon.info_customer.dchi,
            {
              cols: [
                dauphieuCommon.info_customer.stknmua,
                dauphieuCommon.info_customer.nganhang_nmua,
              ],
            },
            {
              cols: [
                dauphieuCommon.info_customer.cccdan,
                dauphieuCommon.info_customer.so_hchieu,
              ]
            },
            dauphieuCommon.info_customer.mdvqhnsach_nmua,
          ],
        },
      },
    ];
    return layout;
  };
  var dauphieuHoadonMttien = function () {
    var tgia = dauphieuCommon.info_invoice.tgia;
    tgia.hidden = true;
    var dvtte = dauphieuCommon.info_invoice.dvtte;
    dvtte.hidden = true;
    var tenKh = dauphieuCommon.info_customer.tendvi;
    tenKh.label = _("Tên khách hàng");
    var layout = [
      {
        width: 700,
        view: "fieldset",
        label: "Thông tin hóa đơn",
        body: {
          id: "info-invoice",
          rows: [
            dauphieuCommon.info_invoice.tdlap,
            {
              cols: [
                dauphieuCommon.info_invoice.khieu,
                dauphieuCommon.info_invoice.htttoan,
              ]
            },
            dauphieuCommon.info_invoice.cctbao_id,
            dauphieuCommon.info_invoice.shdon,
            tgia,
            dvtte,
            dauphieuCommon.info_invoice.sdhang,
            dauphieuCommon.info_invoice.sdtnban,
            dauphieuCommon.info_customer.ma_ch,
            dauphieuCommon.info_customer.ten_ch,
            // {
            //   cols: [
            //     dauphieuCommon.info_invoice.sbke,
            //     dauphieuCommon.info_invoice.nbke,
            //   ],
            // },
            // {
            //   cols: [
            //     dauphieuCommon.info_invoice.tclquan,
            //   ],
            // },
          ],
        },
      },
      {
        view: "fieldset",
        label: "Thông tin khách hàng",
        body: {
          id: "info-customer",
          rows: [
            // { view: 'label', id: 'textWarning', label: '', hidden: true },
            {
              cols: [
                dauphieuCommon.info_customer.mst,
                dauphieuCommon.info_customer.mdtuong,
              ],
            },
            {
              cols: [
                dauphieuCommon.info_customer.cccdan,
                dauphieuCommon.info_customer.tnmua
              ]
            },
            tenKh,
            dauphieuCommon.info_customer.dchi,
            {
              cols: [
                dauphieuCommon.info_customer.stknmua,
                dauphieuCommon.info_customer.nganhang_nmua,
              ],
            },
            {
              cols: [
                dauphieuCommon.info_customer.sdtnmua,
                dauphieuCommon.info_customer.email,
              ]
            },
            {
              cols: [
                dauphieuCommon.info_customer.so_hchieu,
                dauphieuCommon.info_customer.mdvqhnsach_nmua,
              ]
            },
          ],
        },
      },
    ];
    return layout;
  };
  var dauphieuBangke = function () {
    var layout = [
      {
        cols: [
          {
            view: "fieldset",
            label: "<b>Thông tin chung</b>",
            body: {
              rows: [
                { view: "text", label: "Ký hiệu bảng kê", name: "khieu", labelWidth: 120, css: "mcls_readonly_text", readonly: true, value: "01/BK-DCTT" },
                { view: "text", label: "Số bảng kê", name: "so", labelWidth: 120, css: "mcls_readonly_text", readonly: true },
                { view: "datepicker", label: "Ngày bảng kê", name: "ngay", id: "ngay", labelWidth: 120, required: true, value: new Date(), },
                {
                  view: "combo", label: "Tính chất hóa đơn", name: "tchat", id: "tchat", labelWidth: 120, readonly: true, css: "mcls_readonly_text",
                  options: [
                    { id: 1, value: "Thay thế NHIỀU hóa đơn" },
                    { id: 2, value: "Điều chỉnh NHIỀU hóa đơn" },
                  ],
                },
              ],
            },
          },
          {
            view: "fieldset",
            label: "<b>Đơn vị bán</b>",
            body: {
              rows: [
                { view: "text", label: "Tên đơn vị:", id: "nban", name: "nban", labelWidth: 120, required: true, },
                { view: "text", label: "Mã số thuế:", id: "mst_nban", name: "mst_nban", labelWidth: 120, required: true, },
                { view: "text", label: "Địa chỉ:", id: "dchi_nban", name: "dchi_nban", labelWidth: 120, },
              ],
            },
          },
          {
            view: "fieldset",
            label: "<b>Đơn vị mua</b>",
            body: {
              rows: [
                { view: "text", label: "Tên đơn vị:", name: "nmua", id: "nmua", labelWidth: 120, required: true, },
                { view: "text", label: "Mã số thuế:", name: "mst_nmua", id: "mst_nmua", labelWidth: 120, },
                { view: "text", label: "Địa chỉ:", name: "dchi_nmua", id: "dchi_nmua", labelWidth: 120, },
              ],
            },
          },
          {
            view: "fieldset",
            label: "<b>Lý do sai sót</b>",
            body: {
              rows: [{ view: "textarea", name: "ldo", labelWidth: 120, height: 100, },],
            },
          },
        ],
      },
    ];


    return layout;
  };
  var dphdonchietkhau = function () {
    var layout = [
      {
        cols: [
          {
            view: "fieldset",
            label: "<b>Thông tin chung</b>",
            body: {
              rows: [
                { view: "text", label: "Ký hiệu bảng kê", name: "khieu", labelWidth: 120, css: "mcls_readonly_text", readonly: true, value: "01/BK-HĐCK" },
                { view: "text", label: "Số bảng kê", name: "so", labelWidth: 120, css: "mcls_readonly_text", readonly: true },
                { view: "datepicker", label: "Ngày bảng kê", name: "ngay", id: "ngay", labelWidth: 120, required: true, value: new Date(), },
              ],
            },
          },
          {
            view: "fieldset",
            label: "<b>Đơn vị bán</b>",
            body: {
              rows: [
                { view: "text", label: "Tên đơn vị:", id: "nban", name: "nban", labelWidth: 120, css: "mcls_readonly_text", readonly: true },
                { view: "text", label: "Mã số thuế:", id: "mst_nban", name: "mst_nban", labelWidth: 120, css: "mcls_readonly_text", readonly: true },
                { view: "text", label: "Địa chỉ:", id: "dchi_nban", name: "dchi_nban", labelWidth: 120, css: "mcls_readonly_text", readonly: true },
              ],
            },
          },
          {
            view: "fieldset",
            label: "<b>Đơn vị mua</b>",
            body: {
              rows: [
                { view: "text", label: "Tên đơn vị:", name: "nmua", id: "nmua", labelWidth: 120, editor: true, attributes: { maxlength: 400 }, },
                { view: "text", label: "Mã số thuế:", name: "mst_nmua", id: "mst_nmua", labelWidth: 120, css: "mcls_readonly_text", readonly: true },
                { view: "text", label: "Địa chỉ:", name: "dchi_nmua", id: "dchi_nmua", labelWidth: 120, editor: true, attributes: { maxlength: 400 }, },
              ],
            },
          },
        ],
      },
    ];
    return layout;
  };

  var changeReadonly = function (component, value) {
    if ($$("invoiceForms").elements[component] != undefined) {
      $$("invoiceForms").elements[component].config.readonly = value;
      $$("invoiceForms").elements[component].refresh();
    }
  };
  return {
    numeric: function (id, header, decimalSizeOp) {
      var res = {
        id: id,
        decimal: decimalSizeOp,
        header: _(header),
        editor: "text",
        width: 120,
        editable: true,
        css: { "text-align": "right" },
        editParse: function (value) {
          return webix.Number.parse(value, {
            groupSize: webix.i18n.groupSize,
            groupDelimiter: ".",
            decimalSize: decimalSizeOp,
            decimalDelimiter: ",",
          });
        },
        editFormat: function (value) {
          return webix.i18n.numberFormat(value, {
            groupDelimiter: ".",
            groupSize: 3,
            decimalDelimiter: ",",
            decimalSize: decimalSizeOp,
          });
        },
        format: webix.Number.numToStr({
          groupDelimiter: ".",
          groupSize: 3,
          decimalDelimiter: ",",
          decimalSize: decimalSizeOp,
        }),
      };

      return res;
    },
    shortNumber: function (value) {
      var integerPart = Math.floor(value);
      var decimalPart = value - integerPart;

      if (decimalPart >= 0.50) {
        return integerPart + 1;
      } else {
        return integerPart;
      }
    },
    kyhieuHoadon: function (type) {
      var res = {
        id: "kyhieu_id",
        view: "combo",
        //attributes: { readonly: true },
        width: 300,
        label: _("KY_HIEU"),
        options: {
          body: {
            url: constant.API.SERIAL_TYPE + type,
            ready: function () {
              var count = this.count();
              var combo = webix.$$("kyhieu_id");
              var kyhieuParam = app.path[1].params[0];
              if (kyhieuParam != undefined) {
                combo.setValue(kyhieuParam);
              }
              else {
                if (count > 0) {
                  combo.setValue(this.getFirstId());
                }
              }
            },
          },
        },
        on: {
          onChange: function (newv, oldv) {
            var table = $$("invoiceViews");
            table.clearAll();
            table.load(table.config.url);
          },
        },
      };
      return res;
    },
    headTitleHoadon: function (title) {
      var res = {
        height: 35,
        cols: [
          { id: "head-iconInvoice", view: "template", css: "headform", width: 35, template: "", },
          { id: "head-formInvoice", view: "template", css: "headform", template: function (obj) { return "<div>" + title + "<div/>"; }, },
          {
            view: "icon", icon: "fas fa-question-circle", id: "help_InvoiceForms", tooltip: _("HELPER"),
            click: function () {
              var newWin = window.open();
              newWin.location = "http://huongdansudung.minvoice.com.vn/Tomihoadon.html";
            },
          },
        ],
      };
      return res;
    },
    dauphieuXangdau: function () {
      var res = {
        id: "masterInvoice",
        cols: dauphieuXangdau()
      };
      return res;
    },
    masterPaymentRequest: function () {
      return {
        id: "masterInvoice",
        cols: masterPaymentRequest(),
      };
    },
    dauphieuHoadon: function (typeInvoice) {
      var res = {
        id: "masterInvoice",
        cols: dauphieuHoadonNormal(typeInvoice),
      };
      return res;
    },
    dauphieuBangke: function () {
      var res = {
        id: "masterBangke",
        cols: dauphieuBangke()
      };
      return res;
    },
    dphdonchietkhau: function () {
      var res = {
        id: "masterHdCKhau",
        cols: dphdonchietkhau()
      };
      return res;
    },
    dauphieuHoadonBangke: function () {
      return {
        rows: [
          {
            cols: [
              {
                view: "fieldset",
                label: "Thông tin hóa đơn",
                body: {
                  rows: [
                    {
                      cols: [
                        dauphieuCommon.info_invoice.tdlap,
                        dauphieuCommon.info_invoice.khieu,
                        dauphieuCommon.info_invoice.shdon,
                      ]
                    },
                    {
                      cols: [
                        dauphieuCommon.info_invoice.dvtte,
                        dauphieuCommon.info_invoice.tgia,
                      ]
                    },
                    {
                      cols: [
                        dauphieuCommon.info_invoice.htttoan,
                        dauphieuCommon.info_invoice.sdhang,
                      ]
                    },
                    {
                      cols: [
                        dauphieuCommon.info_invoice.emailnban,
                        dauphieuCommon.info_invoice.sdtnban,
                      ]
                    },
                    {
                      cols: [
                        dauphieuCommon.info_invoice.stknban,
                        dauphieuCommon.info_invoice.nganghang_ngban,
                      ]
                    },
                  ]
                }
              },
              {
                view: "fieldset",
                label: "Thông tin khách hàng",
                body: {
                  rows: [
                    {
                      cols: [
                        dauphieuCommon.info_customer.mst,
                        dauphieuCommon.info_customer.mdtuong,
                      ]
                    },
                    {
                      cols: [
                        dauphieuCommon.info_customer.tnmua,
                        dauphieuCommon.info_customer.email,
                      ]
                    },
                    dauphieuCommon.info_customer.tendvi,
                    dauphieuCommon.info_customer.dchi,
                    {
                      cols: [
                        dauphieuCommon.info_customer.stknmua,
                        dauphieuCommon.info_customer.nganhang_nmua,
                      ]
                    },
                  ]
                }
              }
            ]
          },
          {
            view: "fieldset",
            label: "Thông tin hóa đơn liên quan",
            body: {
              rows: [
                {
                  cols: [
                    {
                      view: "combo",
                      name: "tchat_hd",
                      id: "tchat_hd",
                      label: "Tính chất hóa đơn",
                      labelWidth: 130,
                      value: 2,
                      options: [
                        { id: 1, value: "Thay thế nhiều hóa đơn" },
                        { id: 2, value: "Điều chỉnh nhiều hóa đơn" }
                      ],
                      editable: true,
                      css: "mcls_readonly_text",
                    },
                    {
                      view: "text",
                      name: "sobangke",
                      id: "sobangke",
                      label: "Số bảng kê",
                      labelWidth: 100,
                      required: true,
                    },
                    {
                      view: "datepicker",
                      name: "ngaybangke",
                      id: "ngaybangke",
                      label: "Ngày bảng kê",
                      labelWidth: 100,
                      required: true,
                      value: new Date(),
                    }
                  ]
                },
                {
                  view: "text",
                  name: "ghichu",
                  id: "ghichu",
                  label: "Ghi chú",
                  labelWidth: 130,
                }
              ]
            }
          }
        ]
      };
    },
    dauphieuHoadonChietKhau: function () {
      return {
        rows: [
          {
            cols: [
              {
                view: "fieldset",
                label: "<b>Thông tin chung</b>",
                body: {
                  rows: [
                    {
                      view: "combo",
                      label: "Ký hiệu:",
                      id: "khieu",
                      name: "khieu",
                      labelWidth: 120,
                      required: true,
                    },
                    {
                      view: "datepicker",
                      label: "Ngày hóa đơn",
                      id: "tdlap",
                      name: "tdlap",
                      labelWidth: 120,
                      required: true,
                      value: new Date(),
                    },
                    {
                      view: "text",
                      label: "Số hóa đơn:",
                      id: "shdon",
                      name: "shdon",
                      labelWidth: 120,
                      required: true,
                    },
                    {
                      view: "combo",
                      label: "Đơn vị tiền tệ:",
                      id: "dvtte",
                      name: "dvtte",
                      labelWidth: 120,
                      required: true,
                    },
                    {
                      view: "text",
                      label: "Tỷ giá:",
                      id: "tgia",
                      name: "tgia",
                      labelWidth: 120,
                    },
                    {
                      view: "combo",
                      label: "HT thanh toán:",
                      id: "htthtoan",
                      name: "htthtoan",
                      labelWidth: 120,
                      required: true,
                    },
                    {
                      view: "text",
                      label: "Số bảng kê:",
                      id: "sbke",
                      name: "sbke",
                      labelWidth: 120,
                      required: true,
                    },
                    {
                      view: "text",
                      label: "Ngày bảng kê:",
                      id: "nbke",
                      name: "nbke",
                      labelWidth: 120,
                      required: true,
                    },
                  ],
                },
              },
              {
                view: "fieldset",
                label: "<b>Thông tin bên mua</b>",
                body: {
                  rows: [
                    {
                      cols: [
                        {
                          view: "text",
                          label: "Mã số thuế:",
                          id: "mst_nmua",
                          name: "mst_nmua",
                          labelWidth: 120,
                          fillspace: true,
                        },
                        {
                          view: "text",
                          label: "Mã KH:",
                          name: "ma_kh",
                          labelWidth: 120,
                          fillspace: true,
                        },
                      ],
                    },
                    {
                      view: "text",
                      label: "Tên đơn vị:",
                      name: "tendv",
                      labelWidth: 120,
                      required: true,
                    },
                    {
                      view: "text",
                      label: "Tên người mua:",
                      id: "nmua",
                      name: "nmua",
                      labelWidth: 120,
                      required: true,
                    },
                    {
                      view: "text",
                      label: "Địa chỉ:",
                      id: "dchi_nmua",
                      name: "dchi_nmua",
                      labelWidth: 120,
                    },
                    {
                      view: "text",
                      label: "Email:",
                      name: "email_nmua",
                      labelWidth: 120,
                      fillspace: true,
                    },
                    {
                      cols: [
                        {
                          view: "text",
                          label: "Số tài khoản:",
                          name: "stk_nmua",
                          labelWidth: 120,
                        },
                        {
                          view: "text",
                          label: "Số điện thoại:",
                          name: "so_dt",
                          labelWidth: 120,
                        },
                      ],
                    },
                    {
                      view: "text",
                      label: "Tại ngân hàng:",
                      name: "nganhang_nb",
                      labelWidth: 120,
                    },
                  ],
                },
              },
            ],
          },
          {
            view: "fieldset",
            label: "<b>Hóa đơn liên quan<b>",
            body: {
              rows: [
                {
                  cols: [
                    {
                      view: "combo",
                      name: "tchat_hd",
                      id: "tchat_hd",
                      label: "Tính chất hóa đơn liên quan",
                      labelWidth: 200,
                      value: 5,
                      width: 500,
                      options: [{ id: 5, value: "Chiết khấu thương mại" }],
                      editable: false,
                      css: "mcls_readonly_text",
                    },
                  ],
                },
              ],
            },
          },
        ],
      };
    },

    changeDauphieuHoadon: function (view, typeInvoice, isMttien) {
      var dauphieu = isMttien
        ? dauphieuHoadonMttien()
        : dauphieuHoadonNormal(typeInvoice);
      webix.ui(dauphieu, $$("masterInvoice"));
    },
    btnChitietHoadon: function () {
      var res = {
        id: "mainInvoiceManage",
        css: { "padding-bottom": "5px !important" },
        cols: [
          {
            view: "button",
            type: "icon",
            icon: "mdi mdi-plus-box-outline",
            width: 123,
            label: _("THEM_DONG") + " (F9)",
            id: "addrow",
            css: "btnForm",
            tooltip: "Thêm mới một dòng hàng hóa",
            on: {
              onItemClick: function (id, e) {
                var table = webix.$$("hoadon68_chitiet");
                var tchat = 1;
                if (table.isColumnVisible("skhung") ||
                  table.isColumnVisible("smay") ||
                  table.isColumnVisible("bien_sxe") ||
                  table.isColumnVisible("ten_ngui") ||
                  table.isColumnVisible("dc_ngui") ||
                  table.isColumnVisible("mst_ngui") ||
                  table.isColumnVisible("sddanh_ngui")) {
                  tchat = 5;
                }
                var item = { id: webix.uid(), tchat: tchat, cthuc: 1 };
                table.add(item);
                table.select(item.id, "ma", false);
                table.edit({ row: item.id, column: "ma" });

                if ($$("tgtck20") != undefined) {
                  $$("tgtck20").setValue(0);
                }
              },
            },
          },
          {
            view: "button",
            type: "icon",
            icon: "mdi mdi-minus-box-outline",
            width: 120,
            label: _("XOA_DONG") + " (F8)",
            id: "removerow",
            css: "btnForm",
            tooltip: "Xóa một dòng hàng hóa",
            on: {
              onItemClick: function (id, e) {
                var table = webix.$$("hoadon68_chitiet");
                table.editStop();
                var item = table.getSelectedItem();
                if (!webix.isUndefined(item)) {
                  table.remove(item.id);
                  table.clearSelection();
                  var row_id = table.getFirstId();
                  if (row_id != undefined) {
                    table.edit({ row: row_id, column: "ma" });
                    table.editStop();
                  } else {
                    calculatorMoney("hoadon68_chitiet");
                  }
                  return;
                }

                var editor = table.getEditState();
                if (!webix.isUndefined(editor)) {
                  table.remove(editor.row);
                  table.clearSelection();
                  var row_id = table.getFirstId();
                  if (row_id != undefined) {
                    table.edit({ row: row_id, column: "ma" });
                    table.editStop();
                  } else {
                    calculatorMoney("hoadon68_chitiet");
                  }
                  return;
                }
                if ($$("tgtck20") != undefined) {
                  $$("tgtck20").setValue(0);
                }
              },
            },
          },
          {
            view: "button",
            type: "icon",
            icon: "mdi mdi-content-duplicate",
            width: 120,
            label: _("COPY") + " (F7)",
            view: "button",
            id: "copyrow",
            css: "btnForm",
            tooltip: "Sao chép một dòng hàng hóa",
            on: {
              onItemClick: function (id, e) {
                var table = webix.$$("hoadon68_chitiet");
                table.editStop();
                var item = table.getSelectedItem();
                if (item == null || item == undefined) {
                  webix.message("Bạn chưa chọn dòng cần sao chép", "error");
                  return;
                }
                var copy = webix.copy(item);
                copy.id = webix.uid();
                copy.hoadon68_chitiet_id = null;
                copy.hoadon68_id = null;

                table.add(copy);
                table.unselect(item.id);
                table.select(copy.id, "ma", false);
                table.edit({ row: copy.id, column: "ma" });
                table.editStop(); // Dùng để call event onEditstop
                table.edit({ row: copy.id, column: "ma" });
                if ($$("tgtck20") != undefined) {
                  $$("tgtck20").setValue(0);
                }
              },
            },
          },
          {
            view: "button",
            type: "icon",
            icon: "mdi mdi-file-document-outline",
            width: 125,
            label: "Chọn hàng hóa",
            css: "btnForm",
            id: "btnChonHangHoa",
            hidden: true,
            tooltip: "Chọn hàng hóa của hóa đơn từ hóa đơn khác",
            on: {
              onItemClick: function (id, e) {
                var frm = $$("invoiceForms").$scope.ui(ChonHangHoa.$ui);
                ChonHangHoa.setEditMode(1, null);
                frm.show();
              },
            },
          },
          {
            view: "checkbox",
            id: "check_chietkhau",
            value: 0,
            labelRight: _("HDON_CK"),
            labelWidth: 2,
            width: 145,
            tooltip: "Tích vào đây nếu hóa đơn có chiết khấu",
            on: {
              onChange: function (newv, oldv) {
                if (newv == 1) {
                  $$("hoadon68_chitiet").showColumn("stckhau");
                  $$("hoadon68_chitiet").showColumn("tlckhau");
                } else {
                  $$("hoadon68_chitiet").hideColumn("stckhau");
                  $$("hoadon68_chitiet").hideColumn("tlckhau");
                }
              },
            },
          },
          {
            view: "checkbox",
            id: "check_congthuc",
            name: "mccqthue",
            value: 0,
            labelRight: _("CONFIG_CAL"),
            labelWidth: 2,
            width: 195,
            tooltip: "Cho phép sửa giá trị tiền thuế, tổng tiền",
            on: {
              onChange: function (newv, oldv) {
                var lstColumn = new Array(
                  "ttcktmai",
                  "ttcktmai10",
                  "ttcktmaikhac",
                  "ttcktmai5",
                  "ttcktmai0",
                  "ttcktmaikct",
                  "ttcktmaikkk",
                  "tgtcthue",
                  "tgtcthue10",
                  "tgtcthuekhac",
                  "tgtcthue5",
                  "tgtcthue0",
                  "tgtcthuekct",
                  "tgtcthuekkk",
                  "tgtthue",
                  "tgtthue10",
                  "tgtthuekhac",
                  "tgtthue5",
                  "tgtthue0",
                  "tgtthuekct",
                  "tgtthuekkk",
                  "tgtttbso",
                  "tgtttbso10",
                  "tgtttbsokhac",
                  "tgtttbso5",
                  "tgtttbso0",
                  "tgtttbsokct",
                  "tgtttbsokkk"
                );
                if (newv == 1) {
                  webix.message("Đã cho phép sửa giá trị tiền thuế, tổng tiền", "debug", 3000);
                  lstColumn.forEach((element) => {
                    changeReadonly(element, false);
                  });
                } else {
                  lstColumn.forEach((element) => {
                    changeReadonly(element, true);
                  });
                }
              },
            },
          },
          {
            view: "checkbox",
            id: "check_tinhctmathang",
            name: "theomh",
            value: 0,
            labelRight: _("TSUAT_CT"),
            labelWidth: 2,
            width: 285,
            tooltip: "Tính chi tiết theo mặt hàng",
            on: {
              onChange: function (newv, oldv) { },
            },
          },
          {
            view: "button",
            type: "icon",
            icon: "mdi mdi mdi-file-document-outline",
            label: _("HH_KHKHAC"),
            id: "theokhkhac",
            css: "margin-left-6px btnForm",
            width: 185,
            tooltip: "Cho phép chọn nhiều chi tiết hóa đơn",
            on: {
              onItemClick: function () {
                var frm = $$("invoiceForms").$scope.ui(popupSelectProduct.$ui);
                frm.show();
              }
            },
          },
        ],
      };
      return res;
    },
    btnChitietBangke: function () {
      var res = {
        id: "mainInvoiceManage",
        css: { "padding-bottom": "5px !important" },
        cols: [
          {
            view: "button",
            type: "icon",
            icon: "mdi mdi-plus-box-outline",
            width: 123,
            label: "Thêm hóa đơn" + " (F9)",
            id: "addrow",
            css: "btnForm",
            tooltip: "Thêm mới một dòng hàng hóa",
            on: {
              onItemClick: function (id, e) {
                var mst_nmua = $$("mst_nmua").getValue();
                var frm = $$("bangkeWindowId").$scope.ui(chonHoaDonForm.$ui);
                chonHoaDonForm.setType("bangke_chitiet");
                chonHoaDonForm.setMSTValue(mst_nmua);
                frm.show();
              },
            },
          },
          {
            view: "button",
            type: "icon",
            icon: "mdi mdi-minus-box-outline",
            width: 120,
            label: _("XOA_DONG") + " (F8)",
            id: "removerow",
            css: "btnForm",
            tooltip: "Xóa một dòng hàng hóa",
            on: {
              onItemClick: function (id, e) {
                var table = webix.$$("bangke_chitiet");
                table.editStop();
                var item = table.getSelectedItem();
                if (!webix.isUndefined(item)) {
                  table.remove(item.id);
                  table.clearSelection();
                  return;
                }
              },
            },
          },
          {
            view: "button",
            type: "icon",
            icon: "mdi mdi-delete-outline",
            width: 300,
            label: "Xóa dòng không có chênh lệch",
            id: "removerowNoDiff",
            css: "btnForm",
            tooltip: "Xóa dòng không có chênh lệch",
            on: {
              onItemClick: function (id, e) {
                var table = webix.$$("hoadon68_chitiet");
                var selectedRow = table.getSelectedItem();
                if (selectedRow) {
                  if (selectedRow.chenhLech === 0) {
                    table.remove(selectedRow.id);
                  } else {
                    webix.message("Không thể xóa dòng có chênh lệch.");
                  }
                }
              },
            }
          },
        ],
      };
      return res;
    },
    btnHoadonchietkhau_chitiet: function () {
      var res = {
        id: "mainInvoiceManage",
        css: { "padding-bottom": "5px !important" },
        cols: [
          {
            view: "button",
            type: "icon",
            icon: "mdi mdi-plus-box-outline",
            width: 123,
            label: "Thêm hóa đơn" + " (F9)",
            id: "addrow",
            css: "btnForm",
            tooltip: "Thêm mới một dòng hàng hóa",
            on: {
              onItemClick: function (id, e) {
                var mst_nmua = $$("mst_nmua").getValue();
                var frm = $$("hoadonchietkhauID").$scope.ui(chonHoaDonForm.$ui);
                chonHoaDonForm.setType("hoadonchietkhau");
                chonHoaDonForm.setMSTValue(mst_nmua);
                frm.show();
              },
            },
          },
          {
            view: "button",
            type: "icon",
            icon: "mdi mdi-minus-box-outline",
            width: 120,
            label: _("XOA_DONG") + " (F8)",
            id: "removerow",
            css: "btnForm",
            tooltip: "Xóa một dòng hàng hóa",
            on: {
              onItemClick: function (id, e) {
                var table = webix.$$("hdck_chitiet");
                table.editStop();
                var item = table.getSelectedItem();
                if (!webix.isUndefined(item)) {
                  table.remove(item.id);
                  table.clearSelection();
                  return;
                }
              },
            },
          },
        ],
      };
      return res;
    },

    soKhung: function () {
      return {
        id: "skhung", header: _("Số khung"), editor: "text", width: 200, editable: true, required: true, validate: webix.rules.isNotEmpty,
        invalidMessage: "Số khung không được để trống !", hidden: true,
        onShow: function () {
          this.define("required", true);
          this.define("validate", webix.rules.isNotEmpty);
          this.define("invalidMessage", "Số khung không được để trống !");
          this.refresh();
        }
      };
    },
    soMay: function () {
      return {
        id: "smay", header: _("Số máy"), editor: "text", width: 200, editable: true, required: true, validate: webix.rules.isNotEmpty,
        invalidMessage: "Số máy không được để trống !", hidden: true,
        onShow: function () {
          this.define("required", true);
          this.define("validate", webix.rules.isNotEmpty);
          this.define("invalidMessage", "Số máy không được để trống !");
          this.refresh();
        }
      };
    },
    bienSoXe: function () {
      return {
        id: "bien_sxe", header: _("Biển KSPT Vận chuyển"), editor: "text", width: 200, editable: true, required: true, validate: webix.rules.isNotEmpty,
        invalidMessage: "Biển KSPT Vận chuyển không được để trống !", hidden: true,
        onShow: function () {
          this.define("required", true);
          this.define("validate", webix.rules.isNotEmpty);
          this.define("invalidMessage", "Biển KSPT Vận chuyển không được để trống !");
          this.refresh();
        }
      };
    },
    tenNguoiGui: function () {
      return {
        id: "ten_ngui", header: _("Tên người gửi hàng"), editor: "text", width: 200, editable: true, required: true, validate: webix.rules.isNotEmpty,
        invalidMessage: "Tên người gửi hàng không được để trống !", hidden: true
      };
    },
    diaChiNguoiGui: function () {
      return {
        id: "dc_ngui", header: _("Địa chỉ người gửi hàng"), editor: "text", width: 200, editable: true, required: true, validate: webix.rules.isNotEmpty,
        invalidMessage: "Địa chỉ người gửi hàng không được để trống !", hidden: true
      };
    },
    mstNguoiGui: function () {
      return {
        id: "mst_ngui", header: _("MST người gửi hàng"), editor: "text", width: 200, editable: true, required: true, validate: webix.rules.isNotEmpty,
        invalidMessage: "MST người gửi hàng không được để trống !", hidden: true
      };
    },
    sddNguoiGui: function () {
      return {
        id: "sddanh_ngui", header: _("Số định danh người gửi hàng"), editor: "text", width: 200, editable: true, required: true, validate: webix.rules.isNotEmpty,
        invalidMessage: "Số định danh người gửi hàng không được để trống !", hidden: true
      };
    },
    tongtienHDBH: function () {
      var res = {
        rows: [
          {
            cols: [
              {
                view: "combo",
                name: "tlptdoanhthu20",
                label: "Tỷ lệ % theo doanh thu",
                css: "tldoanhthu",
                width: 215,
                clear: 1,
                labelWidth: 150,
                id: "tlptdoanhthu20",
                value: "1",
                options: {
                  view: "gridsuggest",
                  template: "#code# %",
                  value: "1",
                  body: {
                    scroll: true,
                    autoheight: false,
                    columns: [
                      { id: "code", header: _("% CK"), width: 60, template: "#code# %", },
                      { id: "name", header: _("Loại hàng hóa"), width: 300 },
                    ],
                    data: [
                      { id: "1", code: "1", name: "Phân phối, cung cấp hàng hóa dịch vụ", },
                      { id: "2", code: "2", name: "Hoạt động kinh doanh khác" },
                      { id: "3", code: "3", name: "Sản xuất, vận tải, dịch vụ có gắn với hàng hóa, xây dụng có bao thầu nguyên vật liệu", },
                      { id: "5", code: "5", name: "Dịch vụ xây dựng không bao thầu nguyên vật liệu", },
                    ],
                  },
                },
                on: {
                  onChange: function (newValue, oldValue, config) {
                    var tiencthue = $$("tgtcthue").getValue();
                    var tienck = $$("ttcktmai").getValue();
                    $$("tgtttbso").setValue(tiencthue + tienck);
                    $$("tgtck20").setValue(0);
                    $$("txtck20").setValue("");
                  },
                },
              },
              {
                view: "button",
                type: "htmlbutton",
                width: 85,
                label: `<i class="fa fa-calculator fa-lg" aria-hidden="true"></i><span class="text"> CK 20% </span>`,
                id: "addrowCK",
                css: "btnForm",
                // hidden: true,
                tooltip: "Thực hiện chiết khấu 20%",
                on: {
                  onItemClick: function (id, e) {
                    var tien = $$("tgtcthue").getValue();
                    var tlck = $$("tlptdoanhthu20").getValue();
                    var tienck = ((tien * 0.2 * tlck) / 100).toFixed(0);
                    $$("txtck20").setValue("Đã giảm " + formatDecimal(tienck, 0) + " tương ứng 20% mức tỷ lệ % để tính thuế giá trị gia tăng theo Nghị quyết số 204/2025/QH15");
                    $$("tgtck20").setValue(tienck);
                    $$("tgtttbso").setValue(tien - tienck);
                  },
                },
              },
              {
                view: "text",
                id: "txtck20",
                name: "txtck20",
              },
              {
                view: "text",
                id: "tgtck20",
                name: "tgtck20",
                hidden: true,
                on: {
                  onChange: function (newv, oldv) {
                    // var table = webix.$$("hoadon68_chitiet");
                    // table.callEvent("onAfterEditStop");
                    // webix.message(newv);
                    // if (newv == 0) {
                    //     var tien = $$("tgtttbso").getValue();
                    //     $$("tgtttbso").setValue(tien + oldv);
                    // }
                  },
                },
              },
            ],
          },
          {
            cols: [
              {
                view: "label",
                label: " + " + _("TONG_CONG_HH"),
                height: 22,
                css: {
                  "padding-left": "5px",
                  "font-weight": "bold",
                  "background-color": "#f4f5f9",
                },
              },
              {
                view: "text",
                id: "tgtcthue",
                name: "tgtcthue",
                label: "Cộng tiền hàng hóa",
                labelWidth: 120,
                css: "txtTongtien",
                readonly: true,
                height: 22,
                format: "1.111,00",
              },
              {
                view: "text",
                label: "Tiền chiết khấu",
                labelWidth: 120,
                format: "1.111,00",
                id: "ttcktmai",
                name: "ttcktmai",
                css: "txtTongtien",
                readonly: true,
                height: 22,
              },
              {
                view: "text",
                label: "Tổng tiền thanh toán",
                labelWidth: 120,
                id: "tgtttbso",
                name: "tgtttbso",
                css: "txtTongtien",
                clear: true,
                readonly: true,
                height: 22,
                on: {
                  onChange: function (newv, oldv) {
                    var total_amount = $$("tgtttbso").getValue();
                    var type_curency = $$("dvtte").getValue();

                    total_amount = total_amount == "" ? 0 : total_amount;
                    var numTongtien = type_curency == "VND" || type_curency == "JPY" ? total_amount : Number(total_amount).toFixed(2);

                    var tien = functionExtension.DocTienBangChu(numTongtien.toString(), type_curency.toString());
                    webix.delay(
                      function (a) {
                        this.setValue(a);
                      }, $$("tgtttbchu"), [tien], 100);
                  },
                },
                format: "1.111,00",
              },
            ],
          },
        ],
      };
      return res;
    },
    tongtien: function () {
      var res = {
        rows: [
          {
            cols: [
              { view: "label", label: _("LOAI_THUE"), css: "lblTongtien" },
              { view: "label", label: _("TIEN_CKHAU"), css: "lblTongtien" },
              { view: "label", label: _("TIEN_TTHUE"), css: "lblTongtien", },
              { view: "label", label: _("TIEN_THUE"), css: "lblTongtien" },
              { view: "label", label: _("TIEN_SAU_THUE"), css: "lblTongtien", },
            ],
          },
          {
            cols: [
              {
                view: "label",
                label: " + " + _("TONG_CONG_HH"),
                height: 22,
                css: { "padding-left": "5px", "font-weight": "bold", "background-color": "#f4f5f9", },
              },
              { view: "text", format: "1.111,00", id: "ttcktmai", name: "ttcktmai", css: "txtTongtien", readonly: true, height: 22, },
              { view: "text", id: "tgtcthue", name: "tgtcthue", css: "txtTongtien", readonly: true, height: 22, format: "1.111,00", },
              { view: "text", format: "1.111,00", id: "tgtthue", name: "tgtthue", css: "txtTongtien", readonly: true, height: 22, },
              {
                view: "text",
                id: "tgtttbso",
                name: "tgtttbso",
                css: "txtTongtien",
                clear: true,
                readonly: true,
                height: 22,
                on: {
                  onChange: function (newv, oldv) {
                    var total_amount = $$("tgtttbso").getValue();
                    var type_curency = $$("dvtte").getValue();

                    total_amount = total_amount == "" ? 0 : total_amount;
                    var numTongtien = type_curency == "VND" || type_curency == "JPY" ? total_amount : Number(total_amount).toFixed(2);
                    var tien = functionExtension.DocTienBangChu(numTongtien.toString(), type_curency.toString());
                    webix.delay(
                      function (a) {
                        this.setValue(a);
                      },
                      $$("tgtttbchu"),
                      [tien],
                      100
                    );
                  },
                },
                format: "1.111,00",
              },
            ],
          },
        ],
      };
      return res;
    },
    tongtienDetail: function () {
      var res = {
        rows: [
          {
            cols: [
              { view: "label", label: "Thuế suất 10%", css: "lblSubTongtien", height: 22, },
              { view: "text", format: "1.111,00", id: "ttcktmai10", name: "ttcktmai10", css: "txtTongtien", readonly: true, height: 22, },
              { view: "text", format: "1.111,00", id: "tgtcthue10", name: "tgtcthue10", css: "txtTongtien", readonly: true, height: 22, },
              {
                view: "text", format: "1.111,00", id: "tgtthue10", name: "tgtthue10", css: "txtTongtien", readonly: true, height: 22,
                on: {
                  onChange: function (newv, oldv) {
                    changeVAT(10);
                  },
                },
              },
              { view: "text", format: "1.111,00", id: "tgtttbso10", name: "tgtttbso10", css: "txtTongtien", readonly: true, height: 22, },
            ],
          },
          {
            cols: [
              { view: "label", label: "Thuế suất 8%", css: "lblSubTongtien", height: 22, },
              { view: "text", format: "1.111,00", id: "ttcktmaikhac", name: "ttcktmaikhac", css: "txtTongtien", readonly: true, height: 22, },
              { view: "text", format: "1.111,00", id: "tgtcthuekhac", name: "tgtcthuekhac", css: "txtTongtien", readonly: true, height: 22, },
              {
                view: "text", format: "1.111,00", id: "tgtthuekhac", name: "tgtthuekhac", css: "txtTongtien", readonly: true, height: 22,
                on: {
                  onChange: function (newv, oldv) {
                    changeVAT(8);
                  },
                },
              },
              { view: "text", format: "1.111,00", id: "tgtttbsokhac", name: "tgtttbsokhac", css: "txtTongtien", readonly: true, height: 22, },
            ],
          },
          {
            cols: [
              { view: "label", label: "Thuế suất 5%", css: "lblSubTongtien", height: 22, },
              { view: "text", format: "1.111,00", id: "ttcktmai5", name: "ttcktmai5", css: "txtTongtien", readonly: true, height: 22, },
              { view: "text", format: "1.111,00", id: "tgtcthue5", name: "tgtcthue5", css: "txtTongtien", readonly: true, height: 22, },
              {
                view: "text", format: "1.111,00", id: "tgtthue5", name: "tgtthue5", css: "txtTongtien", height: 22, readonly: true,
                on: {
                  onChange: function (newv, oldv) {
                    changeVAT(5);
                  },
                },
              },
              { view: "text", format: "1.111,00", id: "tgtttbso5", name: "tgtttbso5", css: "txtTongtien", readonly: true, height: 22, },
            ],
          },
          {
            cols: [
              { view: "label", label: "Thuế suất 0%", css: "lblSubTongtien", height: 22, },
              { view: "text", format: "1.111,00", id: "ttcktmai0", name: "ttcktmai0", css: "txtTongtien", readonly: true, height: 22, },
              { view: "text", format: "1.111,00", id: "tgtcthue0", name: "tgtcthue0", css: "txtTongtien", readonly: true, height: 22, },
              { view: "text", format: "1.111,00", id: "tgtthue0", name: "tgtthue0", css: "txtTongtien", readonly: true, height: 22, },
              { view: "text", format: "1.111,00", id: "tgtttbso0", name: "tgtttbso0", css: "txtTongtien", readonly: true, height: 22, },
            ],
          },
          {
            cols: [
              { view: "label", label: "Không chịu thuế GTGT", css: "lblSubTongtien", height: 22, },
              { view: "text", format: "1.111,00", id: "ttcktmaikct", name: "ttcktmaikct", css: "txtTongtien", readonly: true, height: 22, },
              { view: "text", format: "1.111,00", id: "tgtcthuekct", name: "tgtcthuekct", css: "txtTongtien", readonly: true, height: 22, },
              { view: "text", format: "1.111,00", id: "tgtthuekct", name: "tgtthuekct", css: "txtTongtien", readonly: true, height: 22, },
              { view: "text", format: "1.111,00", id: "tgtttbsokct", name: "tgtttbsokct", css: "txtTongtien", readonly: true, height: 22, },
            ],
          },
          {
            cols: [
              { view: "label", label: "Không kê khai, tính nộp thuế GTGT", css: "lblSubTongtien", height: 22, },
              { view: "text", format: "1.111,00", id: "ttcktmaikkk", name: "ttcktmaikkk", css: "txtTongtien", readonly: true, height: 22, },
              { view: "text", format: "1.111,00", id: "tgtcthuekkk", name: "tgtcthuekkk", css: "txtTongtien", readonly: true, height: 22, },
              { view: "text", format: "1.111,00", id: "tgtthuekkk", name: "tgtthuekkk", css: "txtTongtien", readonly: true, height: 22, },
              { view: "text", format: "1.111,00", id: "tgtttbsokkk", name: "tgtttbsokkk", css: "txtTongtien", readonly: true, height: 22, },
            ],
          },
        ],
      };
      return res;
    },
    inputTongTien: function (dec) {
      var res = {
        cols: [
          {
            rows: [
              { view: "label", label: "Loại thuế", css: "lblTongtien" },
              {
                view: "label",
                label: " + Tổng cộng hàng hóa, dịch vụ",
                height: 22,
                css: {
                  "padding-left": "5px",
                  "font-weight": "bold",
                  "background-color": "#f4f5f9",
                },
              },
              { view: "label", label: "Thuế suất 10%", css: "lblSubTongtien", height: 22, },
              { view: "label", label: "Thuế suất 5%", css: "lblSubTongtien", height: 22, },
              { view: "label", label: "Thuế suất 0%", css: "lblSubTongtien", height: 22, },
              { view: "label", label: "Không chịu thuế GTGT", css: "lblSubTongtien", height: 22, },
              { view: "label", label: "Không kê khai, tính nộp thuế GTGT", css: "lblSubTongtien", height: 22, },
              // { view: "label", label: "Tổng cộng phí lệ phí", css: { "font-weight": "bold", "background-color": "#86b2cf" } , height: 22 },
              // { view: "label", label: "Tổng cộng thanh toán", css: { "font-weight": "bold", "background-color": "#86b2cf" } , height: 22 },
            ],
          },
          {
            rows: [
              { view: "label", label: "Tiền chiết khấu", css: "lblTongtien" },
              { view: "text", format: "1.111,00", id: "ttcktmai", name: "ttcktmai", css: "txtTongtien", readonly: true, height: 22, },
              { view: "text", format: "1.111,00", id: "ttcktmai10", name: "ttcktmai10", css: "txtTongtien", readonly: true, height: 22, },
              { view: "text", format: "1.111,00", id: "ttcktmai5", name: "ttcktmai5", css: "txtTongtien", readonly: true, height: 22, },
              { view: "text", format: "1.111,00", id: "ttcktmai0", name: "ttcktmai0", css: "txtTongtien", readonly: true, height: 22, },
              { view: "text", format: "1.111,00", id: "ttcktmaikct", name: "ttcktmaikct", css: "txtTongtien", readonly: true, height: 22, },
              { view: "text", format: "1.111,00", id: "ttcktmaikkk", name: "ttcktmaikkk", css: "txtTongtien", readonly: true, height: 22, },
            ],
          },
          {
            rows: [
              { view: "label", label: "Thành tiền trước thuế", css: "lblTongtien", },
              { view: "text", id: "tgtcthue", name: "tgtcthue", css: "txtTongtien", readonly: true, height: 22, format: "1.111,00", },
              { view: "text", format: "1.111,00", id: "tgtcthue10", name: "tgtcthue10", css: "txtTongtien", readonly: true, height: 22, },
              {
                view: "text",
                format: "1.111,00",
                id: "tgtcthue5",
                name: "tgtcthue5",
                css: "txtTongtien",
                readonly: true,
                height: 22,
              },
              { view: "text", format: "1.111,00", id: "tgtcthue0", name: "tgtcthue0", css: "txtTongtien", readonly: true, height: 22, },
              { view: "text", format: "1.111,00", id: "tgtcthuekct", name: "tgtcthuekct", css: "txtTongtien", readonly: true, height: 22, },
              { view: "text", format: "1.111,00", id: "tgtcthuekkk", name: "tgtcthuekkk", css: "txtTongtien", readonly: true, height: 22, },
              // { view: "text", id: "2", name: "2", css: "txtTongtien", readonly: true, height: 22 }
            ],
          },
          {
            rows: [
              { view: "label", label: "Tiền thuế", css: "lblTongtien" },
              {
                view: "text", format: "1.111,00", id: "tgtthue", name: "tgtthue", css: "txtTongtien", readonly: true, height: 22,
                on: { onChange: function (newv, oldv) { }, },
              },
              {
                view: "text", format: "1.111,00", id: "tgtthue10", name: "tgtthue10", css: "txtTongtien", height: 22,
                on: {
                  onChange: function (newv, oldv) {
                    if (oldv == undefined) return;
                    changeVAT(10);
                  },
                },
              },
              {
                view: "text", format: "1.111,00", id: "tgtthue5", name: "tgtthue5", css: "txtTongtien", height: 22,
                on: {
                  onChange: function (newv, oldv) {
                    if (oldv == undefined) return;

                    changeVAT(5);
                  },
                },
              },
              { view: "text", format: "1.111,00", id: "tgtthue0", name: "tgtthue0", css: "txtTongtien", readonly: true, height: 22, },
              { view: "text", format: "1.111,00", id: "tgtthuekct", name: "tgtthuekct", css: "txtTongtien", readonly: true, height: 22, },
              { view: "text", format: "1.111,00", id: "tgtthuekkk", name: "tgtthuekkk", css: "txtTongtien", readonly: true, height: 22, },
            ],
          },
          {
            rows: [
              { view: "label", label: "Tổng tiền sau thuế", css: "lblTongtien", },
              {
                view: "text",
                id: "tgtttbso",
                name: "tgtttbso",
                css: "txtTongtien",
                clear: true,
                readonly: true,
                height: 22,
                on: {
                  onChange: function (newv, oldv) {
                    var total_amount = $$("tgtttbso").getValue();
                    var type_curency = $$("dvtte").getValue();
                    total_amount = total_amount == "" ? 0 : total_amount;
                    var numTongtien = type_curency == "VND" || type_curency == "JPY" ? total_amount : Number(total_amount).toFixed(2);
                    var tien = functionExtension.DocTienBangChu(numTongtien.toString(), type_curency.toString());
                    webix.delay(
                      function (a) {
                        this.setValue(a);
                      }, $$("tgtttbchu"), [tien], 100
                    );
                  },
                },
                format: "1.111,00",
              },
              { view: "text", format: "1.111,00", id: "tgtttbso10", name: "tgtttbso10", css: "txtTongtien", readonly: true, height: 22, },
              { view: "text", format: "1.111,00", id: "tgtttbso5", name: "tgtttbso5", css: "txtTongtien", readonly: true, height: 22, },
              { view: "text", format: "1.111,00", id: "tgtttbso0", name: "tgtttbso0", css: "txtTongtien", readonly: true, height: 22, },
              { view: "text", format: "1.111,00", id: "tgtttbsokct", name: "tgtttbsokct", css: "txtTongtien", readonly: true, height: 22, },
              { view: "text", format: "1.111,00", id: "tgtttbsokkk", name: "tgtttbsokkk", css: "txtTongtien", readonly: true, height: 22, },
            ],
          },
        ],
      };
      return res;
    },
    tienbangchu: function () {
      var res = {
        cols: [
          {
            view: "label",
            width: 140,
            label: _("TIEN_BANG_CHU") + " :",
            css: { "font-weight": "bold", "padding-left": "5px" },
            height: 22,
          },
          {
            view: "text",
            id: "tgtttbchu",
            name: "tgtttbchu",
            css: "tienbangchu",
            height: 22,
            validate: webix.rules.isNotEmpty,
            required: true,
            invalidMessage: "Tiền bằng chữ không thể bỏ trống !",
          },
        ],
      };
      return res;
    },
    dauphieuMau06: function () {
      var res = {
        cols: [
          {
            view: "fieldset",
            label: "Thông tin hóa đơn",
            body: {
              id: "info-invoice",
              width: 400,
              rows: [
                { view: "text", label: "cctbao_id", id: "cctbao_id", name: "cctbao_id", hidden: true, },
                dauphieuCommon.info_invoice.khieu,
                { view: "datepicker", name: "tdlap", label: "Ngày phiếu xuất", id: "tdlap", value: new Date(), },
                { view: "text", name: "shdon", id: "shdon", label: "Số phiếu xuất", css: "mcls_readonly_text", readonly: true, },
                {
                  view: "combo",
                  name: "dvtte",
                  label: _("MA_TIEN_TE"),
                  //labelPosition: "top",
                  id: "dvtte",
                  required: true,
                  value: "VND",
                  invalidMessage: "Trạng thái hóa đơn không thể bỏ trống !",
                  options: {
                    view: "gridsuggest",
                    value: "VND",
                    template: "#value#",
                    url: constant.API.GET_MA_TIEN_TE,
                    body: {
                      columns: [{ id: "value", header: _("Mã tiền tệ"), width: 220 }],
                      dataFeed: function (filtervalue, filter) {
                        if (filtervalue.length < 1) {
                          this.load(this.config.url);
                          return;
                        }
                        var urldata = "filtervalue=" + encodeURIComponent(filtervalue);
                        this.load(constant.API.GET_MA_TIEN_TE + "&" + urldata, this.config.datatype
                        );
                      },
                    },
                  },
                  on: {
                    onChange: function (newv, oldv) {
                      var table = webix.$$("hoadon68_chitiet");
                      var form = $$("invoiceForms");
                      webix
                        .ajax()
                        .headers({ "Content-type": "application/text" })
                        .get(constant.API.DECIMAL_PLACES + newv, function (text, data, XmlHttpRequest) {
                          var arr = JSON.parse(text);
                          var quantity = arr[0]["inv_quantity"];
                          var inv_TotalAmountWithoutVat =
                            arr[0]["inv_TotalAmountWithoutVat"];
                          var inv_TotalAmount = arr[0]["inv_TotalAmount"];
                          var inv_unitPrice = arr[0]["inv_unitPrice"];
                          var inv_vatAmount = arr[0]["inv_vatAmount"];

                          var format_config = table.getColumnConfig("sluong"); fmNumeric(format_config, quantity);
                          var don_gia = table.getColumnConfig("dgia"); fmNumeric(don_gia, inv_unitPrice);
                          var tien_tt = table.getColumnConfig("thtien"); fmNumeric(tien_tt, inv_TotalAmountWithoutVat);
                          var tien_thue = table.getColumnConfig("tthue");
                          if (tien_thue != undefined) fmNumeric(tien_thue, inv_vatAmount);
                          var tong_tien = table.getColumnConfig("tgtien");
                          if (tong_tien != undefined) fmNumeric(tong_tien, inv_TotalAmount);
                          tien_tt.decimal = inv_TotalAmountWithoutVat;
                          if (tien_thue != undefined) tien_thue.decimal = inv_vatAmount;
                          don_gia.decimal = inv_unitPrice;
                          if (tong_tien != undefined) tong_tien.decimal = inv_TotalAmount;
                          stckhau.decimal = inv_TotalAmount;
                        });
                    },
                  },
                },
                {
                  view: "text",
                  label: _("TY_GIA"),
                  type: "number",
                  value: 1,
                  name: "tgia",
                  id: "tgia",
                  on: {
                    onChange: function (newv, oldv) {
                      if (newv == undefined) return;
                      if (newv == "") return;
                      if (!webix.rules.isNumber(newv)) {
                        webix.message("Tỷ giá phải nhập số", "error");
                        this.focus();
                        return;
                      }
                    },
                  },
                },
                {
                  view: "text",
                  label: _("Số đơn hàng"),
                  name: "sdhang",
                  id: "sdhang",
                },
              ],
            },
          },
          {
            view: "fieldset",
            label: "Thông tin khách hàng",
            body: {
              id: "info-customer",
              rows: [
                // { view: 'label', id: 'textWarning06', label: '', hidden: true },
                {
                  cols: [
                    {
                      view: "text",
                      label: _("Lệnh điều động"),
                      name: "lddnbo",
                      id: "lddnbo",
                      invalidMessage: "Bạn phải nhập lệnh điều động",
                      required: true,
                      validate: webix.rules.isNotEmpty,
                    },
                    {
                      view: "text",
                      label: _("Hợp đồng vận chuyển"),
                      name: "sohopdong",
                      id: "sohopdong",
                    },
                  ],
                },
                {
                  cols: [
                    {
                      view: "text",
                      label: _("Địa chỉ kho xuất"),
                      name: "dckhoxuat",
                      id: "dckhoxuat",
                      invalidMessage: "Bạn phải nhập địa chỉ kho xuất",
                      required: true,
                      validate: webix.rules.isNotEmpty,
                    },
                    {
                      view: "text",
                      label: _("Tên người vận chuyển"),
                      name: "tnvchuyen",
                      id: "tnvchuyen",
                      // invalidMessage: "Bạn phải nhập tên người vận chuyển",
                      // required: true,
                    },
                  ],
                },
                {
                  cols: [
                    {
                      view: "text",
                      label: _("Tên người xuất"),
                      name: "hvtnxhang",
                      id: "hvtnxhang",
                    },
                    {
                      view: "text",
                      label: _("PT vận chuyển"),
                      name: "ptvchuyen",
                      id: "ptvchuyen",
                      invalidMessage: "Bạn phải nhập phương tiện vận chuyển",
                      required: true,
                      validate: webix.rules.isNotEmpty,
                    },
                  ],
                },
                {
                  view: "text",
                  label: _("Đơn vị nhận hàng"),
                  name: "ten",
                  id: "ten",
                },
                {
                  cols: [
                    {
                      id: "mst",
                      name: "mst",
                      view: "search",
                      label: "MST đơn vị nhận",
                      validate: webix.rules.isTaxCode,
                      invalidMessage: "Mã số thuế không hợp lệ",
                      placeholder: _("SEARCH") + "...",
                      on: {
                        onChange: function (newv, oldv) {
                          if (newv == undefined) return;
                          if (newv == "") return;
                          if (!webix.rules.isTaxCode(newv)) {
                            webix.message("Mã số thuế không hợp lệ", "error");
                            this.focus();
                            return;
                          }
                        },
                        onTimedKeyPress: function () {
                        },
                        onSearchIconClick: function (e) {
                          var text = this.getValue();
                          var datapost = { masothue: text };
                          var table = $$("invoiceForms");
                          webix.extend(table, webix.ProgressBar);
                          table.disable();
                          table.showProgress();
                          webix
                            .ajax()
                            .headers({ "Content-type": "application/json" })
                            .post(constant.API.POST_INFO_MST, datapost,
                              function (text) {
                                var json = JSON.parse(text);
                                table.enable();
                                table.hideProgress();
                                if (!json.hasOwnProperty("error")) {
                                  $$("ten").setValue(json.ten_cty);
                                  // var textWarning = $$("textWarning06");
                                  // if (json.tthai != '00' && json.tthai != '02' && json.tthai != '04') {
                                  //   textWarning.setValue("<i>Hóa đơn có thể bị lỗi do MST <span style='font-weight: bold;'>" + json.ma_so_thue + "</span> có trạng thái <span style='color: red;'>" + json.ten_tthai + "</span></i>");
                                  //   textWarning.define("hidden", false);
                                  //   textWarning.show();
                                  // }
                                  // else {
                                  //   textWarning.define("hidden", true);
                                  // }
                                } else {
                                  webix.message(json.error, "error", 1500);
                                }
                              }
                            );
                        },
                      },
                    },
                    {
                      view: "text",
                      label: _("Tên người nhận"),
                      name: "tennguoinhanhang",
                      id: "tennguoinhanhang",
                    },
                  ],
                },
                {
                  cols: [
                    {
                      view: "text",
                      label: _("Địa chỉ kho nhận"),
                      name: "dckhonhap",
                      id: "dckhonhap",
                      invalidMessage: "Bạn phải nhập địa chỉ kho nhận",
                      required: true,
                      validate: webix.rules.isNotEmpty,
                    },
                    {
                      view: "text",
                      label: _("Email người nhận"),
                      name: "email",
                      id: "email",
                    },
                  ],
                },
                {
                  id: "phieuxuatdaily",
                  cols: [
                    {
                      view: "text",
                      label: _("HĐ kinh tế số"),
                      name: "hdktso",
                      id: "hdktso",
                      invalidMessage: "Bạn phải nhập hợp đồng kinh tế số",
                      required: true,
                      validate: webix.rules.isNotEmpty,
                    },
                    {
                      view: "datepicker",
                      label: _("HĐ kinh tế ngày"),
                      name: "hdktngay",
                      id: "hdktngay",
                      invalidMessage: "Bạn phải nhập hợp đồng kinh tế ngày",
                      required: true,
                      validate: webix.rules.isNotEmpty,
                    },
                  ],
                },
              ],
            },
          },
        ],
      };
      return res;
    },
    vanbanHoadon: function () {
      var res = {
        rows: [
          {
            cols: [
              {
                view: "text",
                labelWidth: 100,
                id: "sovb",
                name: "sovb",
                label: "Số văn bản",
                require: true,
                invalidMessage: "Số văn bản không thể bỏ trống !",
                validate: webix.rules.isNotEmpty,
              },
              {
                view: "datepicker",
                labelWidth: 100,
                name: "ngayvb",
                label: "Ngày văn bản",
                id: "ngayvb",
                value: new Date(),
                require: true,
              },
            ],
          },
          {
            view: "text",
            labelWidth: 100,
            id: "ghi_chu",
            name: "ghi_chu",
            label: "Lý do",
            require: true,
            invalidMessage: "Lý do thay thế không thể bỏ trống !",
            validate: webix.rules.isNotEmpty,
          },
        ],
      };
      return res;
    },
    mahanghoaHoadon: function (mode) {
      var res = {
        id: "ma",
        header: _("MA_HV"),
        editor: "textsearch",
        width: 100,
        editable: true,
        onIconButtonClick: function (e) {
          require(["views/forms/editwindow"], function (editwindow) {
            var url = app.config.host + "/System/GetConfigWinByNo?id=WIN00015";
            webix.ajax().get(url, function (text) {
              var windowconfig = JSON.parse(text);
              var vc_window = windowconfig["data"][0];
              editwindow.$ui.id = vc_window.window_id;
              var win = webix.ui(editwindow.$ui);
              editwindow.initUI(windowconfig);
              editwindow.setEditMode(1);
              editwindow.setValues(null, windowconfig);
              win.show();
              win.config.callback = function (obj) {
                var table = $$("hoadon68_chitiet");
                var selectedItem = table.getSelectedItem();
                selectedItem["ma"] = obj.ma_hv;
                selectedItem["ten"] = obj.ten_hv;
                selectedItem["mdvtinh"] = obj.ma_dvt;
                selectedItem["dgia"] = obj.gia_ban;
                selectedItem["tsuat"] = obj.ma_thue;
                if (obj.StoreBravoCode != undefined)
                  selectedItem["StoreBravoCode"] = obj.StoreBravoCode;
                if (obj.ProductBravoCode != undefined)
                  selectedItem["ProductBravoCode"] = obj.ProductBravoCode;
                if (obj.CategoryBravoCode != undefined)
                  selectedItem["CategoryBravoCode"] = obj.CategoryBravoCode;
                table.updateItem(selectedItem.id, selectedItem);
              };
            });
          });
        },
        suggest: {
          view: "gridsuggest",
          columnName: "ma_hanghoa",
          body: {
            columns: [
              { id: "id", hidden: true, header: "id" },
              { id: _("ma_hv"), width: 120, header: "Mã hàng" },
              { id: _("ten_hv"), width: 350, header: "Tên hàng" },
            ],
            scroll: true,
            autoheight: false,
            datatype: "json",
            dataFeed: function (filtervalue, filter) {
              if (filtervalue.length < 1) return;
              var urldata = "filtervalue=" + encodeURIComponent(filtervalue);
              this.load(constant.API.GET_MA_HANG_HOA + "&" + urldata, this.config.datatype);
            },
          },
          on: {
            onValueSuggest: function (obj) {
              var table = $$("hoadon68_chitiet");
              var selectedItem = table.getSelectedItem();
              selectedItem["ma_hanghoa"] = obj["id"];
              selectedItem["ten"] = obj["ten_hv"];
              selectedItem["mdvtinh"] = obj["ma_dvt"];
              selectedItem["dgia"] = obj["gia_ban"];
              Object.keys(obj).forEach(function (k) {
                if (k != "id") selectedItem[k] = obj[k];
              });
              if (mode != 6) {
                selectedItem["tsuat"] = obj["ma_thue"];
              }
              table.updateItem(selectedItem.id, selectedItem);
            },
          },
        },
        onIconButtonClick: function () {
          require(["views/forms/editwindow"], function (editwindow) {
            var url = app.config.host + "/System/GetConfigWinByNo?id=WIN00015";

            webix.ajax().get(url, function (text) {
              var windowconfig = JSON.parse(text);
              var vc_window = windowconfig["data"][0];
              editwindow.$ui.id = vc_window.window_id;
              var win = webix.ui(editwindow.$ui);
              editwindow.initUI(windowconfig);
              editwindow.setEditMode(1);
              editwindow.setValues(null, windowconfig);
              win.show();

              win.config.callback = function (obj) {
                var table = $$("hoadon68_chitiet");
                var item = table.getSelectedItem();
                item.ma = obj.ma_hv;
                item.ten = obj.ten_hv;
                item.mdvtinh = obj.ma_dvt;
                item.dgia = obj.gia_ban;
                item.tsuat = obj.ma_thue;
                table.updateItem(item.id, item);
              };
            });
          });
        },
      };
      return res;
    },
    donvitinhHoadon: function () {
      var res = {
        id: "mdvtinh",
        header: _("DVT"),
        editor: "text",
        width: 80,
        editable: true,
        suggest: {
          view: "gridsuggest",
          columnName: "dvt",
          body: {
            columns: [
              { id: "id", hidden: true, header: "id" },
              { id: "ma_dvt", width: 120, header: "Mã ĐVT" },
            ],
            scroll: true,
            autoheight: false,
            datatype: "json",
            dataFeed: function (filtervalue, filter) {
              if (filtervalue.length < 1) return;
              var urldata = "filtervalue=" + encodeURIComponent(filtervalue);
              this.load(constant.API.GET_DVT + "&" + urldata, this.config.datatype);
            },
          },
          on: {
            onValueSuggest: function (obj) {
              var table = $$("hoadon68_chitiet");
              var selectedItem = table.getSelectedItem();
              selectedItem["mdvtinh"] = obj["dvt"];
              table.updateItem(selectedItem.id, selectedItem);
            },
          },
        },
      };
      return res;
    },
    dcttHoadon32: function (type) {
      var tite = "Thông tin HĐ bị điều chỉnh";
      var valueTC = 2;
      if (type == 1) {
        // hóa đơn thay thế
        tite = "Thông tin HĐ bị thay thế";
        valueTC = 1;
      }
      var info = {
        rows: [
          {
            view: "template",
            template: "<span style ='text-transform: none;color: black;'>" + tite + "</span>",
            type: "section",
          },
          {
            cols: [
              {
                view: "datepicker",
                name: "ngay_hd32",
                label: "Ngày hóa đơn",
                id: "ngay_hd32",
                value: new Date(),
                required: true,
                invalidMessage: "Ngày hóa đơn không được bỏ trống !",
              },
              {
                view: "text",
                name: "mauso_hd32",
                label: "Mẫu số",
                id: "mauso_hd32",
                attributes: { maxlength: 11 },
                css: "text_toupper",
                required: true,
                // validate: webix.rules.validateDenominator,
                // invalidMessage: "Mẫu số hóa đơn không được bỏ trống !",
              },
              {
                view: "text",
                label: _("KY_HIEU"),
                name: "kyhieu_hd32",
                id: "kyhieu_hd32",
                attributes: { maxlength: 6 },
                css: "text_toupper",
                required: true,
                // invalidMessage: "Ký hiệu hóa đơn không được bỏ trống !",
              },
            ],
          },
          {
            cols: [
              {
                view: "text",
                name: "so_hd32",
                label: "Số hóa đơn",
                id: "so_hd32",
                attributes: { maxlength: 7 },
                required: true,
                invalidMessage: "Số hóa đơn phải là số và không được bỏ trống",
                validate: webix.rules.isNumber,
                on: {
                  onChange: function (newValue, oldValue, config) {
                    newValue = newValue.padStart(7, "0");
                    this.setValue(newValue);
                  },
                },
              },
              {
                view: "combo",
                name: "loai_hd32",
                label: "Loại hóa đơn",
                value: 1,
                id: "loai_hd32",
                options: [
                  { id: "1", value: "HĐĐT theo NĐ 123/2020" },
                  // { id: "2", value: "HĐĐT xác thực theo QĐ 1209" },
                  { id: "3", value: "Hóa đơn theo NĐ 51/2010" },
                  // { id: "4", value: "Hóa đơn đặt in theo NĐ 123/2020" },
                ],
              },
              {
                view: "combo",
                label: _("Tính chất HĐ"),
                name: "tinhchat_hd32",
                id: "tinhchat_hd32",
                css: "mcls_readonly_text",
                readonly: true,
                value: valueTC,
                options: [
                  { id: "1", value: "Thay thế" },
                  { id: "2", value: "Điều chỉnh" },
                ],
              },
            ],
          },
        ],
      };
      return info;
    },
    layoutGrid: function (controls, grids) {
      var layout = {
        css: "frmView",
        id: "frmView",
        rows: [
          {
            height: 39,
            css: "btnControl",
            type: "toolbar",
            margin: 0,
            borderless: true,
            cols: controls
          },
          { rows: [grids] }
        ]
      };
      return layout;
    },
    dauphieuHoadonBangke: function () {
      return {
        rows: [
          {
            cols: [
              {
                view: "fieldset",
                label: "Thông tin hóa đơn",
                body: {
                  rows: [
                    {
                      cols: [
                        dauphieuCommon.info_invoice.tdlap,
                        dauphieuCommon.info_invoice.khieu,
                        dauphieuCommon.info_invoice.shdon,
                      ]
                    },
                    {
                      cols: [
                        dauphieuCommon.info_invoice.dvtte,
                        dauphieuCommon.info_invoice.tgia,
                      ]
                    },
                    {
                      cols: [
                        dauphieuCommon.info_invoice.htttoan,
                        dauphieuCommon.info_invoice.sdhang,
                      ]
                    },
                    {
                      cols: [
                        dauphieuCommon.info_invoice.emailnban,
                        dauphieuCommon.info_invoice.sdtnban,
                      ]
                    },
                    {
                      cols: [
                        dauphieuCommon.info_invoice.stknban,
                        dauphieuCommon.info_invoice.nganghang_ngban,
                      ]
                    },
                  ]
                }
              },
              {
                view: "fieldset",
                label: "Thông tin khách hàng",
                body: {
                  rows: [
                    {
                      cols: [
                        dauphieuCommon.info_customer.mst,
                        dauphieuCommon.info_customer.mdtuong,
                      ]
                    },
                    {
                      cols: [
                        dauphieuCommon.info_customer.tnmua,
                        dauphieuCommon.info_customer.email,
                      ]
                    },
                    dauphieuCommon.info_customer.tendvi,
                    dauphieuCommon.info_customer.dchi,
                    {
                      cols: [
                        dauphieuCommon.info_customer.stknmua,
                        dauphieuCommon.info_customer.nganhang_nmua,
                      ]
                    },
                  ]
                }
              }
            ]
          },
          {
            view: "fieldset",
            label: "Thông tin hóa đơn liên quan",
            body: {
              rows: [
                {
                  cols: [
                    {
                      view: "combo",
                      name: "tchat_hd",
                      id: "tchat_hd",
                      label: "Tính chất hóa đơn",
                      labelWidth: 130,
                      value: 2,
                      options: [
                        { id: 1, value: "Thay thế nhiều hóa đơn" },
                        { id: 2, value: "Điều chỉnh nhiều hóa đơn" }
                      ],
                      editable: true,
                      css: "mcls_readonly_text",
                    },
                    {
                      view: "text",
                      name: "sobangke",
                      id: "sobangke",
                      label: "Số bảng kê",
                      labelWidth: 100,
                      required: true,
                    },
                    {
                      view: "datepicker",
                      name: "ngaybangke",
                      id: "ngaybangke",
                      label: "Ngày bảng kê",
                      labelWidth: 100,
                      required: true,
                      value: new Date(),
                    }
                  ]
                },
                {
                  view: "text",
                  name: "ghichu",
                  id: "ghichu",
                  label: "Ghi chú",
                  labelWidth: 130,
                }
              ]
            }
          }
        ]
      };
    },
  }
});

define('views/forms/forms68/BTHopDL/68_bangtonghopform',[
  "views/modules/Component/functionExtension",
  "app", "locale",
  "models/user",
  "views/forms/forms68/EXCEL/68_uploadExcel",
  "views/forms/forms68/BTHopDL/68_bangdanhsachhoadon",
  "views/modules/Component/componentHelper",
  "views/modules/Component/constantManager"
], function (
  functionExtension,
  app,
  _,
  user,
  uploadExcel,
  bangdanhsachhoadon,
  componentHelper,
  constant
) {
  var editmode = 0;

  var importExcel = function () {
    var fileId = $$("uploader").files.getFirstId();
    if (fileId == undefined || fileId == null) {
      webix.message("Bạn chưa chọn file !", "error");
      $$("uploadfile-win78").enable();
      $$("uploadfile-win78").hideProgress();
      return;
    }
    var file = $$("uploader").files.getItem(fileId);
    var reader = new FileReader();
    reader.onload = function (e) {
      $$("uploadfile-win78").disable();
      $$("uploadfile-win78").showProgress();
      var data = e.target.result;
      var workbook = XLSX.read(data, {
        type: "binary",
      });
      var firstSheet = workbook.Sheets[workbook.SheetNames[0]];
      var numberOfRow = firstSheet["!ref"].split(":")[1].match(/(\d+)/)[0];
      var model = [
        "stt",
        "khieu",
        "shdon",
        "nlap",
        "tnmua",
        "mstnmua",
        "mhhdvu",
        "thhdvu",
        "dvtinh",
        "sluong",
        "tgia",
        "ttphi",
        "tgtkhac",
        "ttcthue",
        "tsuat",
        "tgtthue",
        "tgtttoan",
        "gchu",
        "tthdon",
        "lhdclquan",
        "khmshdclquan",
        "khhdclquan",
        "shdclquan",
        "lkdldchinh",
        "kdldchinh",
      ];
      var data = [];
      let regex = /[A-Za-z0-9]+\/[A-Za-z0-9]+\/[A-Za-z0-9]+/i;
      let regex2 = /[A-Za-z0-9]+\-[A-Za-z0-9]+\-[A-Za-z0-9]+/i;
      for (i = 1; i <= numberOfRow; i++) {
        var s = {};
        for (j = 65; j < 87; j++) {
          var pos = String.fromCharCode(j) + "" + i;
          if (firstSheet[pos]) {
            if (j == 68) {
              var nlap = firstSheet[pos].v;
              if (regex.test(nlap) || regex2.test(nlap))
                s[model[j - 65]] = new Date(nlap);
              else s[model[j - 65]] = functionExtension.ExcelDateToJSDate(nlap);
            } else {
              s[model[j - 65]] = firstSheet[pos].w;
            }
          }
        }
        if (Object.keys(s).length > 0) {
          data.push(s);
        }
      }
      data.splice(0, 1);
      $$("danhsach_hoadon").clearAll();
      $$("danhsach_hoadon").parse(data);
      webix.message("Nhập thành công", "success");
      $$("uploadfile-win78").enable();
      $$("uploadfile-win78").hideProgress();
      $$("uploadfile-win78").close();
    };
    reader.onerror = function (ex) {
      webix.message(ex, "error");
      $$("uploadfile-win78").enable();
      $$("uploadfile-win78").hideProgress();
    };
    reader.readAsBinaryString(file.file);
  };

  var button = [
    {},
    {
      shortcut: "F10",
      id: "btnBTHSave",
      view: "button",
      badge: "F10",
      css: "webix_primary",
      label: "Lưu tạm",
      type: "icon",
      align: "center",
      width: 120,
      on: {
        onClick: function () {
          var item = $$("bangtonghop-form").getValues();
          var tableHoadon = $$("bangtonghop-form");

          if (tableHoadon.validate()) {
            var ds_hdon = $$("danhsach_hoadon").serialize();
            if (ds_hdon.length == 0) {
              webix.message("Bạn chưa nhập chi tiết hóa đơn", "error");
              return;
            } else {
              item["bangtonghopdl_68_chitiets"] =
                $$("danhsach_hoadon").serialize();
              webix.extend(tableHoadon, webix.ProgressBar);
              tableHoadon.disable();
              tableHoadon.showProgress();
              webix
                .ajax()
                .headers({ "Content-type": "application/json" })
                .post(app.config.host + "/SummaryData/SaveChange", item, {
                  error: function (text, data, XmlHttpRequest) {
                    tableHoadon.enable();
                    tableHoadon.hideProgress();
                  },
                  success: function (text, data, XmlHttpRequest) {
                    var response = JSON.parse(text);
                    tableHoadon.enable();
                    tableHoadon.hideProgress();
                    if (response.code == "00") {
                      webix.$$("bangtonghop-win").close();
                      app.callEvent("dataChangeBangtonghop", [1, null]);
                    } else {
                      webix.message(response.message, "error");
                    }
                  },
                });
            }
          } else {
            webix.message("Tồn tại trường dữ liệu không hợp lệ", "error");
          }
        },
      },
      click: function () {
        this.callEvent("onClick");
      },
    },
    {
      view: "button",
      hotkey: "esc",
      label: "Quay lại",
      badge: "ESC",
      css: "webix_danger",
      align: "center",
      type: "icon",
      width: 120,
      click: function () {
        webix.$$("bangtonghop-win").close();
      },
    },
    {},
  ];
  var dNow = new Date();
  var quarter = Math.floor(dNow.getMonth() / 3) + 1;
  var montNow = dNow.getMonth() + 1;
  var headTitleBangTH = componentHelper.headTitleHoadon("Lập bảng tổng hợp dữ liệu hóa đơn");
  var fm = function (number) {
    var k = webix.Number.numToStr({
      groupDelimiter: ".",
      groupSize: 3,
      decimalDelimiter: ",",
      decimalSize: 2,
    });
    return k(number);
  };
  var layout = {
    view: "window",
    modal: true,
    move: true,
    fullscreen: true,
    id: "bangtonghop-win",
    position: "center",
    head: headTitleBangTH,
    body: {
      paddingY: 10,
      paddingX: 10,
      view: "form",
      // width: 1200,
      // height: 580,
      id: "bangtonghop-form",
      complexData: true,
      margin: 0,
      elements: [
        {
          rows: [
            {
              cols: [
                {},
                { view: "label", label: "[01] Kỳ dữ liệu", width: 100, },
                {
                  id: "lkdlieu",
                  name: "lkdlieu",
                  view: "combo",
                  width: 120,
                  value: "T",
                  attributes: { readonly: true },
                  options: [
                    { id: "N", value: "Ngày" },
                    { id: "T", value: "Tháng" },
                    { id: "Q", value: "Quý" },
                  ],
                  on: {
                    onChange: function (newv, oldv) {
                      if (newv == "T") {
                        var k = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12",];
                        $$("thang").define("options", k);
                        $$("thang").setValue("1");
                        $$("thang").refresh();

                        $$("thang").show();
                        $$("nam").show();
                        $$("ngay").define("hidden", true);
                      }
                      if (newv == "Q") {
                        var k = ["1", "2", "3", "4"];
                        $$("thang").define("options", k);
                        $$("thang").setValue(quarter);
                        $$("thang").refresh();

                        $$("thang").show();
                        $$("nam").show();
                        $$("ngay").define("hidden", true);
                      }
                      if (newv == "N") {
                        $$("thang").define("hidden", true);
                        $$("nam").define("hidden", true);
                        $$("ngay").show();
                      }
                    },
                  },
                },
                {
                  id: "thang",
                  name: "thang",
                  view: "combo",
                  attributes: { readonly: true },
                  width: 120,
                  value: montNow,
                  options: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12",],
                },
                { id: "nam", name: "nam", value: new Date().getFullYear(), view: "text", label: "Năm", labelWidth: 50, width: 120, },
                {
                  id: "ngay", name: "ngay", view: "datepicker", label: "Ngày", hidden: true, labelWidth: 50, width: 240, value: new Date(),
                  format: function (text) {
                    var format = webix.Date.dateToStr("%d/%m/%Y");
                    text = removeTimeZoneT(text);
                    return format(text);
                  },
                },
                {},
              ],
            },
            {
              cols: [
                {},
                { view: "label", label: "[02] Lần đầu", width: 100 },
                { id: "ldau", name: "ldau", view: "checkbox", width: 100 },
                { id: "bslthu", name: "bslthu", view: "text", label: "[03] Bổ sung lần thứ: ", labelWidth: 140, width: 260, },
                {},
              ],
            },
            {
              cols: [
                {},
                { id: "nlap", name: "nlap", view: "datepicker", label: "Ngày lập", width: 220, labelWidth: 100, value: new Date(), },
                { id: "sbthdlieu", name: "sbthdlieu", view: "text", readonly: true, css: "mcls_readonly_text", label: "Số:", labelWidth: 120, width: 240, },
                {},
              ],
            },
            {
              cols: [
                {},
                {
                  view: "combo",
                  id: "loaihd",
                  name: "loaihd",
                  label: "Loại hóa đơn",
                  labelWidth: 100, width: 220,
                  value: 9,
                  options: [
                    // { id: "1", value: "Xăng dầu" },
                    { id: "2", value: "Vận tải hàng không" },
                    { id: "9", value: "Khác" },
                  ],
                },
                {
                  view: "combo",
                  name: "dvtte",
                  label: _("MA_TIEN_TE"),
                  labelWidth: 120, width: 240,
                  //labelPosition: "top",
                  id: "dvtte",
                  required: true,
                  hidden: false,
                  value: "VND",
                  invalidMessage: "Mã tiền tệ không thể bỏ trống !",
                  on: {
                    onChange: function (newValue, oldValue, config) {

                    }
                  },
                  options: {
                    view: "gridsuggest",
                    value: "VND",
                    template: "#value#",
                    url: constant.API.GET_MA_TIEN_TE,
                    body: {
                      columns: [{ id: "value", header: _("MA_TIEN_TE"), width: 220 }],
                      dataFeed: function (filtervalue, filter) {
                        if (filtervalue.length < 1) {
                          this.load(this.config.url);
                          return;
                        }
                        var urldata = "filtervalue=" + encodeURIComponent(filtervalue);
                        this.load(constant.API.GET_MA_TIEN_TE + "&" + urldata, this.config.datatype);
                      },
                    },
                  }
                },
                {},
              ],
            },
            {
              cols: [
                {},
                {
                  view: "checkbox",
                  id: "multiple_taxcode",
                  name: "multiple_taxcode",
                  // value: 1,
                  label: "Sử dụng nhiều loại thuế suất trong một hóa đơn",
                  // labelRight: "Sử dụng nhiều loại thuế suất trong một hóa đơn",
                  labelWidth: 300
                },
                {}
              ]
            }
          ],
        },
        { height: 5 },
        {
          rows: [
            {
              cols: [
                {
                  id: "kyhieu_id",
                  view: "combo",
                  name: "kyhieu_id",
                  width: 250,
                  label: "Ký hiệu",
                  options: {
                    body: {
                      url: app.config.host + "/Invoice68/GetAllSerial",
                      ready: function () {
                        var count = this.count();
                        if (count > 0) {
                          var combo = webix.$$("kyhieu_id");
                          combo.setValue(this.getFirstId());
                        }
                      },
                    },
                  },
                },
                {
                  view: "button",
                  id: "my_button",
                  css: "webix_primary",
                  type: "icon",
                  icon: "mdi mdi-plus-box",
                  width: 120,
                  label: "Chọn hóa đơn",
                  on: {
                    onItemClick: function (id, e) {
                      var loaihd = $$("loaihd").getValue();
                      var TaxOptions = $$("multiple_taxcode").getValue();
                      var Serial = $$("kyhieu_id").getText();
                      var detailForm = this.$scope.ui(bangdanhsachhoadon.$ui);
                      bangdanhsachhoadon.setEditMode(1, loaihd, TaxOptions, Serial);
                      var frm = webix.$$("bangtonghop-form").getValues();
                      bangdanhsachhoadon.setValues(frm);
                      detailForm.show();
                    },
                  },
                },
                {
                  view: "button",
                  css: "webix_primary",
                  type: "icon",
                  icon: "mdi mdi-delete-sweep",
                  width: 100,
                  label: "Xóa dòng",
                  on: {
                    onItemClick: function (id, e) {
                      var table = webix.$$("danhsach_hoadon");
                      table.editStop();
                      var item = table.getSelectedItem();
                      if (!webix.isUndefined(item)) {
                        table.remove(item.id);
                        table.clearSelection();
                        return;
                      }
                      var editor = table.getEditState();
                      if (!webix.isUndefined(editor)) {
                        table.remove(editor.row);
                        table.clearSelection();
                        return;
                      }
                    },
                  },
                },
                {
                  view: "button",
                  css: "webix_primary",
                  type: "icon",
                  icon: "mdi mdi-microsoft-excel",
                  width: 120,
                  label: "Nhập từ excel",
                  on: {
                    onItemClick: function (id, e) {
                      //webix.callEvent("onLoadError");
                      var excelForm = this.$scope.ui(uploadExcel.$ui);
                      uploadExcel.setTypeInvoice(100);
                      $$("importExcel").attachEvent("onClick", importExcel);
                      excelForm.show();
                    },
                  },
                },
              ],
            },
            {
              view: "datatable",
              id: "danhsach_hoadon",
              // height: 350,
              name: "danhsach_hoadon",
              select: true,
              scroll: true,
              resizeColumn: true,
              footer: true,
              editable: false,
              tooltip: true,
              scheme: {
                $init: function (obj) { },
              },
              on: {
                "data->onStoreUpdated": function () {
                  this.data.each(function (obj, i) {
                    obj.stt = i + 1;
                  });
                },
              },
              columns: [
                { id: "stt", name: "stt", header: "STT", width: 40 },
                { id: "khieu", loname: "khieu", header: "Ký hiệu", width: 120 },
                { id: "shdon", name: "shdon", header: "Số hóa đơn", width: 120, footer: "Tổng cộng", },
                {
                  id: "nlap", name: "nlap", header: "Ngày hóa đơn", width: 120,
                  format: function (text) {
                    var format = webix.Date.dateToStr("%d/%m/%Y");
                    text = removeTimeZoneT(text);
                    return format(text);
                  },
                },
                { id: "tnmua", name: "tnmua", header: "Tên người mua", width: 350, },
                { id: "mstnmua", name: "mstnmua", header: "Mã số thuế người mua/mã khách hàng", width: 150, },
                { id: "mhhdvu", name: "mhhdvu", header: "Mã hàng", width: 100 },
                { id: "thhdvu", name: "thhdvu", header: "Tên hàng hóa, dịch vụ", width: 150, },
                { id: "dvtinh", name: "dvtinh", header: "Đơn vị tính", width: 150, },
                {
                  id: "sluong", name: "sluong", header: "Số lượng hàng hóa", width: 150,
                  format: webix.Number.numToStr({
                    groupDelimiter: ",",
                    groupSize: 3,
                    decimalDelimiter: ".",
                    decimalSize: 4,
                  }),
                  css: { "text-align": "right" },
                },
                {
                  id: "tgia", name: "tgia", header: "Tỷ giá", width: 150,
                  format: webix.Number.numToStr({
                    groupDelimiter: ",",
                    groupSize: 3,
                    decimalDelimiter: ".",
                    decimalSize: 4,
                  }),
                  css: { "text-align": "right" },
                },
                {
                  id: "ttphi", name: "ttphi", header: "Tổng tiền phí", width: 150,
                  format: webix.Number.numToStr({
                    groupDelimiter: ",",
                    groupSize: 3,
                    decimalDelimiter: ".",
                    decimalSize: 4,
                  }),
                  css: { "text-align": "right" },
                },
                {
                  id: "tgtkhac", name: "tgtkhac", header: "Tổng giảm trừ khác", width: 150,
                  format: webix.Number.numToStr({
                    groupDelimiter: ",",
                    groupSize: 3,
                    decimalDelimiter: ".",
                    decimalSize: 4,
                  }),
                  css: { "text-align": "right" },
                },
                {
                  id: "ttcthue", name: "ttcthue", header: "Tiền trước thuế", width: 150,
                  format: webix.Number.numToStr({
                    groupDelimiter: ",",
                    groupSize: 3,
                    decimalDelimiter: ".",
                    decimalSize: 2,
                  }),
                  css: { "text-align": "right" },
                  footer: {
                    content: "summColumn",
                    height: "22",
                    template: function (obj) {
                      var res = fm(obj.value);
                      return res;
                    },
                  },
                },
                {
                  id: "tsuat", name: "tsuat", header: "Thuế suất", width: 150,
                  // format: webix.Number.numToStr({
                  //   groupDelimiter: ",",
                  //   groupSize: 3,
                  //   decimalDelimiter: ".",
                  //   decimalSize: 0,
                  // }),
                  css: { "text-align": "right" },
                },
                {
                  id: "tgtthue", name: "tgtthue", header: "Tiền thuế", width: 150,
                  format: webix.Number.numToStr({
                    groupDelimiter: ",",
                    groupSize: 3,
                    decimalDelimiter: ".",
                    decimalSize: 2,
                    format: "1.111,00"
                  }),
                  css: { "text-align": "right" },
                  footer: {
                    content: "summColumn",
                    height: "22",
                    template: function (obj) {
                      var res = fm(obj.value);
                      return res;
                    },
                  },
                },
                {
                  id: "tgtttoan", name: "tgtttoan", header: "Tiền thanh toán", width: 150,
                  format: webix.Number.numToStr({
                    groupDelimiter: ",",
                    groupSize: 3,
                    decimalDelimiter: ".",
                    decimalSize: 2,
                  }),
                  css: { "text-align": "right" },
                  footer: {
                    content: "summColumn",
                    height: "22",
                    template: function (obj) {
                      var res = fm(obj.value);
                      return res;
                    },
                  },
                },
                { id: "gchu", name: "gchu", header: "Ghi chú", width: 150 },
                {
                  id: "tthdon",
                  name: "tthdon",
                  header: "Trạng thái hóa đơn ",
                  width: 150,
                  template: function (obj) {
                    var val = obj.tthdon;
                    console.log(val);
                    if (typeof val == "string" && val !== "") val = parseInt(val, 10);
                    switch (val) {
                      case 0: return "Mới";
                      case 2: return "Điều chỉnh";
                      case 3: return "Thay thế";
                      case 4: return "Giải trình";
                      case 5: return "Sai sót do tổng hợp";
                      case 6: return "Thông báo";
                    }
                    return val;
                  }
                },
                {
                  id: "lhdclquan",
                  name: "lhdclquan",
                  header: "Loại hóa đơn liên quan",
                  width: 150,
                  options: [
                    { id: 1, value: "Hóa đơn điện tử nghị định 123" },
                    { id: 2, value: "Hóa đơn xác thực" },
                    { id: 3, value: "Hóa đơn nghị định 51" },
                    { id: 4, value: "Hóa đơn giấy NĐ123" },
                  ],
                },
                {
                  id: "khmshdclquan",
                  name: "khmshdclquan",
                  header: "Mẫu số hóa đơn liên quan",
                  width: 150,
                },
                {
                  id: "khhdclquan",
                  name: "khhdclquan",
                  header: "Kí hiệu hóa đơn liên quan",
                  width: 150,
                },

                {
                  id: "shdclquan",
                  name: "shdclquan",
                  header: "Số hóa đơn liên quan",
                  width: 150,
                },
                {
                  id: "lkdldchinh",
                  name: "lkdldchinh",
                  header: "Loại kì dữ liệu điều chỉnh",
                  width: 150,
                },
                {
                  id: "kdldchinh",
                  name: "kdldchinh",
                  header: "Kì dữ liệu điều chỉnh",
                  width: 150,
                },
              ],
            },
          ],
        },
        {
          margin: 10,
          cols: button,
        },
      ],
    },
  };

  return {
    $ui: layout,
    setEditMode: function (mode) {
      editmode = mode;
      var form = $$(this.$ui.id);
      form.config.editmode = mode;
      var icon = "";
      if (editmode == 1) {
        icon = "<span><i class='fa fa-plus' aria-hidden='true'></i></span>";
      } else {
        if (editmode == 2)
          icon = "<i class='fa fa-edit' aria-hidden='true'></i>";
        else icon = "<i class='fa fa-trash fa-lg' aria-hidden='true'></i>";
      }
      webix.$$("head-iconInvoice").setHTML(icon);
      webix.$$("head-iconInvoice").refresh();
    },
    setValues: function (item) {
      var win = $$(this.$ui.id);
      var form = win.getChildViews()[1];
      item["nlap"] = removeTimeZoneT(item["nlap"]);
      form.setValues(item);
      var tableDetail = webix.$$("danhsach_hoadon");
      var apiHost =
        app.config.host + "/SummaryData/GetSummaryDataDetail?id=" + item.id;
      tableDetail.clearAll();
      tableDetail.load(apiHost);
    },
  };
});

define('views/forms/forms68/68_viewLogForm',["app", "locale"], function (app, _) {
    var fm = function (text, str) {
        var format = webix.Date.dateToStr(str);
        text = removeTimeZoneT(text);
        return format(text);
    };

    function initUI(type, mtdiep, item) {
        var window = $$("68_viewLogs_win");
        if (type == "hd") {
            $$("68_viewLogs_win").getHead().setHTML("<div class='headLog'>Lịch sử truyền nhận<br/>"
                + "<span>Số hóa đơn: " + item.shdon + " Ký hiệu: " + item.khieu + "</span><div>");
        }
        if (type == "mau04") {
            $$("68_viewLogs_win").getHead().setHTML("<div class='headLog'>Lịch sử truyền nhận</div>");
        }
        if (type == "bthop") {
            $$("68_viewLogs_win").getHead().setHTML("<div class='headLog'>Lịch sử truyền nhận<br/>"
                + "<span>Số BTH: " + item.sbthdlieu + " Kỳ dữ liệu: " + item.lkdlieu + " Tháng/Quý: " + item.thang + "</span><div>");
        }
        if (type == "bc26") {
            var lkdlieuMapping = { N: "Ngày", T: "Tháng", Q: "Quý" };
            var lkdlieuText = lkdlieuMapping[item.lkdlieu] || item.lkdlieu;
            $$("68_viewLogs_win").getHead().setHTML("<div class='headLog'>Lịch sử truyền nhận BC26<br/>"
                + "<span>Loại kỳ dữ liệu: " + lkdlieuText + ";" + " Kỳ dữ liệu " + item.kdlieu + "</span><div>");
        }
        $$("68_viewLogs_win").config.mtdiep = mtdiep;

        if (item.nky == undefined || item.nky == null)
            item.nky = new Date();

        $$("68_viewLogs_win").config.tu_ngay = fm(item.nky, "%Y-%m-%d");
        webix.extend(window, webix.ProgressBar);
        window.disable();
        window.showProgress();
        webix.ajax()
            .headers({ 'Content-type': 'application/json' })
            .get(app.config.host + "/Pattern/ViewsLogTD?mtdiep=" + mtdiep,
                {
                    error: function (text, data, XmlHttpRequest) {
                        window.enable();
                        window.hideProgress();
                    },
                    success: function (text, data, XmlHttpRequest) {
                        window.enable();
                        window.hideProgress();
                        var data = JSON.parse(text);
                        $$("68_tbl_viewLogs").parse(data);
                    }
                });
    };

    return {
        $ui: {
            view: "window", modal: true, id: "68_viewLogs_win", position: "center",
            head: "Lịch sử phản hồi Đăng ký/ Thay đổi thông tin SD HDDT",
            headHeight: 80,
            width: 1030,
            height: 450,
            move: true,
            body: {
                paddingY: 0,
                paddingX: 0,
                view: "form",
                id: "68_viewLogs_form",
                complexData: true,
                // margin: 0,
                elements: [
                    {
                        view: "datatable",
                        id: "68_tbl_viewLogs",
                        editable: false,
                        resizeColumn: true,
                        select: true,
                        onClick: {
                            "dowloadXml": function (event, cell, target) {
                                var win = webix.$$("68_tbl_viewLogs");
                                var record = win.getItem(cell.row);
                                if (!record.ghichu.startsWith('{')) {
                                    var file = new Blob([record.ghichu], { type: "application/xml" });
                                    webix.html.download(file, "thongdiep.xml");
                                }
                                else {
                                    var jsXml = JSON.parse(record.ghichu);
                                    var file = new Blob([jsXml.xml], { type: "application/xml" });
                                    webix.html.download(file, "thongdiep.xml");
                                }
                            },
                            "ViewXSD": function (event, cell, target) {
                                var win = webix.$$("68_tbl_viewLogs");
                                var record = win.getItem(cell.row);
                                if (!record.ghichu.startsWith('{')) {
                                    var newWin = window.open();
                                    const files = new Blob([record.ghichu], { type: "application/xml" });
                                    const fileURL = URL.createObjectURL(files);
                                    newWin.location = fileURL;
                                }
                                else {
                                    var jsXml = JSON.parse(record.ghichu);
                                    var newWin = window.open();
                                    const files = new Blob([jsXml.xml], { type: "application/xml" });
                                    const fileURL = URL.createObjectURL(files);
                                    newWin.location = fileURL;
                                }
                            },
                            "ViewPDF": function (event, cell, target) {
                                var win = webix.$$("68_tbl_viewLogs");
                                var record = win.getItem(cell.row);
                                //console.log(record);
                                if (record.fields2 == "204" || record.fields2 == "202" || record.fields2 == "102" || record.fields2 == "103" || record.fields2 == "301") {
                                    webix.extend(win, webix.ProgressBar);
                                    win.disable();
                                    win.showProgress();

                                    var dataPost = record;
                                    var newWin = window.open();
                                    var html = '<html><head><title>Hóa đơn điện tử M-Invoice</title>'
                                        + '<link rel="stylesheet" href="assets/fontawesome_pro/css/all.css" type="text/css" charset="utf-8">'
                                        + '<link rel="stylesheet" href="assets/fontawesome.css" type="text/css" charset="utf-8">'
                                        + '</head><body><center>Đang tải dữ liệu ... <br><p><i style="font-size:200%;" class="fa fa-spin fa-spinner"></i></p></center></body></html>';
                                    newWin.document.write(html);

                                    webix.ajax()
                                        .response("arraybuffer")
                                        .headers({ 'Content-type': 'application/json' })
                                        .post(app.config.host + "/Pattern/PrintTD", dataPost,
                                            {
                                                error: function (text, data, XmlHttpRequest) {
                                                    win.enable();
                                                    win.hideProgress();
                                                },
                                                success: function (text, data, XmlHttpRequest) {
                                                    win.enable();
                                                    win.hideProgress();
                                                    var file = new Blob([data], { type: 'application/pdf' });
                                                    var fileURL = URL.createObjectURL(file);
                                                    //window.open(fileURL, '_blank');
                                                    newWin.location = fileURL;
                                                }
                                            });
                                }
                                else {
                                    webix.message("Chưa hỗ trợ xem in loại thông điệp:" + record.fields2, "debug");
                                }
                            }
                        },
                        on: {
                            "data->onStoreUpdated": function () {
                                this.data.each(function (obj, i) {
                                    obj.stt = i + 1;
                                })
                            },
                            onItemDblClick: function (id, e, node) {
                            },
                            onBeforeRender: function () {
                            },
                            onBeforeLoad: function () {
                                webix.extend(this, webix.ProgressBar);
                                this.disable();
                                this.showProgress();
                            },
                            onAfterLoad: function () {
                                this.enable();
                                this.hideProgress();
                                if (!this.count())
                                    this.showOverlay("<div><img src='assets/imgs/nodata.png'><div class='showOverlaydata'>Không có dữ liệu </br> Nhấn 'Kiểm tra' để tải lại lịch sử truyền nhận</div></div>");
                                webix.delay(function () { this.adjustRowHeight("fields5", true); this.render(); }, this);
                            },
                            onColumnResize: function () {
                                // this.eachColumn(function(id){
                                //     this.adjustRowHeight(); 
                                //       $$(this).refresh();
                                //   });
                                this.adjustRowHeight("fields5", true);
                                this.render();
                            }
                        },
                        fixedRowHeight: false, rowLineHeight: 25, rowHeight: 25,
                        autowidth: true,
                        columns: [
                            { id: "stt", header: "STT", width: 40, css: { "text-align": "center" } },
                            {
                                id: "dowloadXml",
                                header: ["Tải về"],
                                css: { "text-align": "center" },
                                template: function (obj) {
                                    return "<span class='dowloadXml' style='color: #00b300'><i class='mdi mdi-18px mdi-flip-h mdi-download'></i></span> ";
                                },
                                width: 60
                            },
                            {
                                id: "ViewXSD",
                                header: ["Xem"],
                                css: { "text-align": "center" },
                                template: function (obj) {
                                    return "<span class='ViewXSD' style='color: #00b300'><i class='mdi mdi-17px mdi-flip-h mdi-eye'></i></span> ";
                                },
                                width: 60
                            },
                            {
                                id: "ViewPDF",
                                header: ["In"],
                                css: { "text-align": "center" },
                                template: function (obj) {
                                    return "<span class='ViewPDF' style='color: #00b300'><span class='mdi mdi-17px mdi-flip-h mdi-printer'></span></span> ";
                                },
                                width: 60
                            },
                            { id: "fields2", name: "fields2", header: "Loại TĐ", width: 80, editor: "text" },
                            { id: "fields4", name: "fields4", header: "Mã Lỗi", width: 100, editor: "text" },
                            { id: "fields5", name: "fields5", header: "Mô tả lỗi", width: 280, editor: "text" },
                            {
                                id: "datelog", name: "datelog", header: "Ngày nhận", width: 150, editor: "date",
                                format: function (text) {
                                    var format = webix.Date.dateToStr("%d/%m/%Y %H:%i:%s");
                                    text = removeTimeZoneT(text);
                                    return format(text);
                                }, sort: "date"
                            },
                            // { id: "fields1", name: "fields1", header: "Mã TĐ", width: 150, editor: "text" },
                            { id: "fields3", name: "fields3", header: "Mã TĐ TChiếu", width: 150, editor: "text" }
                        ],
                        pager: "pagerB",
                        ready: function () {
                        },
                    },
                    {
                        id: "pagerB",
                        view: "pager",
                        size: 100,
                        group: 5,
                        template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}"
                    },
                    {
                        margin: 10,
                        cols: [
                            {},
                            {
                                view: "button", label: "Kiểm tra", align: "center", width: 120,
                                type: "form",
                                click: function () {
                                    var win = this.getTopParentView();
                                    if (typeof win.showProgress === "undefined")
                                        webix.extend(win, webix.ProgressBar);

                                    win.disable();
                                    win.showProgress();
                                    webix.ajax()
                                        .bind(win)
                                        .headers({ 'Content-type': 'application/json' })
                                        .get(app.config.host + "/Pattern/CheckMessageMVAN?td=" + win.config.mtdiep + "&ngay=" + win.config.tu_ngay,
                                            {
                                                error: function (text, data, XmlHttpRequest) {
                                                    webix.message(text, "error");
                                                    this.enable();
                                                    this.hideProgress();
                                                },
                                                success: function (text, data, XmlHttpRequest) {
                                                    var data = JSON.parse(text);
                                                    if (data.code == "00") {
                                                        webix.ajax()
                                                            .bind(this)
                                                            .headers({ 'Content-type': 'application/json' })
                                                            .get(app.config.host + "/Pattern/ViewsLogTD?mtdiep=" + this.config.mtdiep,
                                                                {
                                                                    error: function (text, data, XmlHttpRequest) {
                                                                        webix.message(text, "error");
                                                                        this.enable();
                                                                        this.hideProgress();
                                                                    },
                                                                    success: function (text, data, XmlHttpRequest) {
                                                                        var data = JSON.parse(text);
                                                                        this.enable();
                                                                        this.hideProgress();
                                                                        $$("68_tbl_viewLogs").clearAll();
                                                                        $$("68_tbl_viewLogs").parse(data);
                                                                        if (data.length > 0)
                                                                            $$("68_tbl_viewLogs").hideOverlay();
                                                                    }
                                                                });
                                                    }
                                                    else {
                                                        webix.message(data.message, "error");
                                                        this.enable();
                                                        this.hideProgress();
                                                    }
                                                }
                                            });
                                }
                            },
                            {
                                view: "button", hotkey: "esc", label: "Hủy bỏ (ESC)", align: "center", width: 120, type: "danger",
                                click: function () {
                                    webix.$$("68_viewLogs_win").close();
                                }
                            },
                            {}
                        ]
                    },
                    { height: 5 }

                ]
            }

        },
        initUI: initUI
    };

});
define('views/forms/forms68/BTHopDL/68_autoCreate',["app",
    "models/user"
],
    function (app, user) {
        var editmode = 0;

        var button = [
            {},
            {
                shortcut: "F10", id: "btnBTHSave", view: "button", badge: "F10", css: "webix_primary",
                label: "Lưu tạm", type: "icon", align: "center", width: 120,
                on: {
                    onClick: function () {
                        var item = $$("bangtonghop-formAuto").getValues();
                        var tableHoadon = $$("bangtonghop-formAuto");

                        if (tableHoadon.validate()) {
                            webix.extend(tableHoadon, webix.ProgressBar);
                            tableHoadon.disable();
                            tableHoadon.showProgress();
                            webix.ajax()
                                .headers({ 'Content-type': 'application/json' })
                                .post(app.config.host + "/SummaryData/SaveChangeAuto", item, {
                                    error: function (text, data, XmlHttpRequest) {
                                        tableHoadon.enable();
                                        tableHoadon.hideProgress();
                                        webix.message(text + XmlHttpRequest, "error");

                                    }, success: function (text, data, XmlHttpRequest) {
                                        var response = JSON.parse(text);
                                        tableHoadon.enable();
                                        tableHoadon.hideProgress();
                                        if (response.code == "00") {
                                            webix.$$("bangtonghop-winAuto").close();
                                            app.callEvent("dataChangeBangtonghop", [1, null]);
                                        }
                                        else {
                                            webix.message(response.message, "error");
                                        }
                                    }
                                });

                        }
                    }
                },
                click: function () {
                    this.callEvent("onClick");
                }
            },
            {
                view: "button", hotkey: "esc", label: "Quay lại", badge: "ESC", css: "webix_danger",
                align: "center", type: "icon", width: 120,
                click: function () {
                    webix.$$("bangtonghop-winAuto").close();
                }
            },
            {}
        ]
        var dNow = new Date();
        var quarter = Math.floor((dNow.getMonth() / 3)) + 1;
        var montNow = dNow.getMonth() + 1;
        var layout = {
            view: "window",
            modal: true,
            move: true,
            //fullscreen: true,
            id: "bangtonghop-winAuto",
            position: "center",
            head: "Lập bảng tổng hợp dữ liệu hóa đơn",
            body: {
                paddingY: 10,
                paddingX: 10,
                view: "form",
                // width: 1200,
                // height: 580,
                id: "bangtonghop-formAuto",
                complexData: true,
                margin: 0,
                elements: [
                    {
                        rows: [
                            {
                                id: "kyhieu_id",
                                view: "combo",
                                name: "kyhieu_id",
                                labelWidth: 100,
                                label: "Ký hiệu",
                                options: {
                                    body: {
                                        url: app.config.host + "/Invoice68/GetAllSerial",
                                        ready: function () {
                                            var count = this.count();
                                            if (count > 0) {
                                                var combo = webix.$$("kyhieu_id");
                                                combo.setValue(this.getFirstId());
                                            }
                                        }
                                    }
                                }
                            },
                            {
                                cols: [
                                    {},
                                    {
                                        view: "label",
                                        label: "[01] Kỳ dữ liệu",
                                        width: 100
                                    },
                                    {
                                        id: "lkdlieu",
                                        name: "lkdlieu",
                                        view: "combo",
                                        width: 120,
                                        value: "T",
                                        attributes: { readonly: true },
                                        options: [
                                            { id: "N", value: "Ngày" },
                                            { id: "T", value: "Tháng" },
                                            { id: "Q", value: "Quý" }
                                        ],
                                        on: {
                                            onChange: function (newv, oldv) {
                                                if (newv == "T") {
                                                    var k = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"]
                                                    $$("thang").define("options", k);
                                                    $$("thang").setValue("1");
                                                    $$("thang").refresh();

                                                    $$("thang").show();
                                                    $$("nam").show();
                                                    $$("ngay").define("hidden", true);
                                                }
                                                if (newv == "Q") {
                                                    var k = ["1", "2", "3", "4"]
                                                    $$("thang").define("options", k);
                                                    $$("thang").setValue(quarter);
                                                    $$("thang").refresh();

                                                    $$("thang").show();
                                                    $$("nam").show();
                                                    $$("ngay").define("hidden", true);
                                                }
                                                if (newv == "N") {
                                                    $$("thang").define("hidden", true);
                                                    $$("nam").define("hidden", true);

                                                    $$("ngay").show();
                                                }
                                            }
                                        }
                                    },
                                    {
                                        id: "thang",
                                        name: "thang",
                                        view: "combo",
                                        attributes: { readonly: true },
                                        width: 120,
                                        value: montNow,
                                        options: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"]
                                    },
                                    { id: "nam", name: "nam", value: new Date().getFullYear(), view: "text", label: "Năm", labelWidth: 50, width: 120 },
                                    {
                                        id: "ngay", name: "ngay", view: "datepicker", label: "Ngày", hidden: true, labelWidth: 50, width: 240, value: new Date(),
                                        format: function (text) {
                                            var format = webix.Date.dateToStr("%d/%m/%Y");
                                            text = removeTimeZoneT(text);
                                            return format(text);
                                        }
                                    },
                                    {}
                                ]
                            },
                            {
                                cols: [
                                    {},
                                    { view: "label", label: "[02] Lần đầu", width: 100 },
                                    { id: "ldau", name: "ldau", view: "checkbox", id: "field_a", width: 100 },
                                    {
                                        id: "bslthu", name: "bslthu", view: "text", label: "[03] Bổ sung lần thứ: ", labelWidth: 140, width: 260
                                    },
                                    {},
                                ]
                            },
                            {
                                cols: [
                                    {},
                                    { id: "nlap", name: "nlap", view: "datepicker", label: "Ngày lập", width: 220, labelWidth: 100, value: new Date() },
                                    {
                                        id: "sbthdlieu", name: "sbthdlieu", view: "text", readonly: true,
                                        css: "mcls_readonly_text", label: "Số:", labelWidth: 120, width: 240
                                    },
                                    {}
                                ]
                            },
                            {
                                view: "combo", id: "loaihd", name: "loaihd", label: "Loại hóa đơn", labelWidth: 100, width: 460,
                                value: 9,
                                options: [
                                    // { id: "1", value: "Xăng dầu" },
                                    { id: "2", value: "Vận tải hàng không" },
                                    { id: "9", value: "Khác" }
                                ]
                            }
                        ]
                    },
                    {
                        margin: 10,
                        cols: button
                    }
                ]
            }

        };

        return {
            $ui: layout,
            setEditMode: function (mode) {
            },
            setValues: function (item) {
            }
        };
    });
define('views/68_bangtonghop',["app", "locale", "models/user",
  "views/forms/forms68/BTHopDL/68_bangtonghopform",
  "views/forms/forms68/68_viewLogForm",
  "views/forms/forms68/BTHopDL/68_autoCreate",
  "views/modules/Component/modalPlugin",
  "views/modules/Component/constantManager"
], function (app, _, user, bangtonghopform, viewLogForm, autoCreateForm, modalPlugin, CONSTANTS) {
  "use strict";

  var initUI = function () {
    var table = webix.$$("bangtonghop");
    var url = {
      $proxy: true,
      load: function (view, callback, params) {
        var url = app.config.host + "/Pattern/GetData";
        var start = null;
        var count = null;
        var filter = [];
        var tlbparam_s = [];
        if (params == null) {
          start = 0;
          count = view.config.datafetch;
          url = url + "?command=CM0011&start=0&count=" + view.config.datafetch + "&continue=null&filter=null";
        } else {
          start = params.start;
          count = params.count;
          url = url + "?command=CM0011&start=" + params.start + "&count=" + params.count + "&continue=" + params.continue;

          if (params.filter != null) {
            var array = [];
            for (var property in params.filter) {
              var column = view.getColumnConfig(property);
              var item = {
                columnName: property,
                columnType: column.columnType,
                value: params.filter[property],
              };
              array.push(item);
            }
            if (array.length > 0) {
              filter = array;
              url = url + "&filter=" + JSON.stringify(array);
            } else {
              url = url + "&filter=null";
            }
          }
        }
        var item = {
          command: "CM0011",
          start: start,
          count: count,
          filter: filter,
          tlbparam: tlbparam_s,
        };
        var apiHost = app.config.host + "/Pattern/GetData";
        webix.ajax().headers({ "Content-type": "application/json" }).bind(view).post(apiHost, item, callback, view);
      },
    };
    table.define("url", url);
  };
  var controls = [
    {
      view: "button", type: "htmlbutton", width: 100,
      label: '<i class="fa fa-refresh fa-lg" aria-hidden="true"></i><span class="text"> ' + _("REFRESH") + "</span>", id: "btnRefresh",
      on: {
        onClick: function () {
          var table = webix.$$("bangtonghop");
          table.clearAll();
          table.load(table.config.url);
        },
      },
      click: function () {
        this.callEvent("onClick");
      },
    },
    {
      view: "button",
      type: "htmlbutton",
      width: 100,
      label: '<i class="fa fa-plus fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("Thêm (F4)") + "</span>",
      id: "btnPlus",
      shortcut: "F4",
      on: {
        onClick: function () {
          var detailForm = this.$scope.ui(bangtonghopform.$ui);
          bangtonghopform.setEditMode(1);
          var form = $$("bangtonghop-form").elements;
          form.bslthu.define("readonly", "true");
          form.bslthu.define("css", "mcls_readonly_text");
          form.bslthu.refresh();
          form.ldau.data.value = 1;
          form.ldau.define("readonly", "true");
          form.ldau.refresh();
          detailForm.show();
        },
      },
      click: function () {
        this.callEvent("onClick");
      },
    },
    {
      view: "button",
      type: "htmlbutton",
      width: 100,
      label: '<i class="fa fa-edit fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("Sửa (F3)") + "</span>",
      id: "btnEdit",
      shortcut: "F3",
      on: {
        onClick: function () {
          var table = webix.$$("bangtonghop");
          var selectedItem = table.getSelectedItem();
          if (selectedItem == null) {
            webix.message("Bạn chưa chọn dòng nào ! ", "error");
            return;
          }
          if (selectedItem.trang_thai == "Đã ký" || selectedItem.trang_thai == "Đã gửi") {
            webix.message("Bảng tổng hợp đã ký không thể sửa ! ", "error");
            return;
          }
          var data = JSON.parse(JSON.stringify(selectedItem));
          var detailForm = this.$scope.ui(bangtonghopform.$ui);
          bangtonghopform.setEditMode(2);
          bangtonghopform.setValues(selectedItem);
          var form = $$("bangtonghop-form").elements;
          if (selectedItem.trang_thai == 1) {
            for (var key in form) {
              var $el = form[key];
              $el.define("readonly", "true");
              $el.define("css", "mcls_readonly_text");
              $el.refresh();
            }
            $$("btnBTHSave").destructor();
            // $$("btnBTHSend").destructor();
          }
          if (data.bslthu != null && data.ldau == 0) {
            form.ldau.disable();
            form.bslthu.define("required", "true");
            form.ldau.refresh();
            form.bslthu.refresh();
          } else if (data.bslthu == null && data.ldau == 1) {
            form.bslthu.define("readonly", "true");
            form.bslthu.define("css", "mcls_readonly_text");
            form.bslthu.refresh();
            form.ldau.define("readonly", "true");
            form.ldau.refresh();
          }
          detailForm.show();
        },
      },
      click: function () {
        this.callEvent("onClick");
      },
    },
    {
      view: "button",
      type: "htmlbutton",
      width: 110,
      label: '<i class="fal fa-files-medical fa-lg" aria-hidden="true"></i>' + '<span class="text">' + _("Bổ Sung (F5)") + "</span>",
      id: "btnBoSung",
      shortcut: "F5",
      on: {
        onClick: function () {
          var table = webix.$$("bangtonghop");
          var selectedItem = table.getSelectedItem();
          if (selectedItem == null) {
            webix.message("Bạn chưa chọn dòng nào ! ", "error");
            return;
          }
          var data = {
            ldau: 0,
            lkdlieu: selectedItem.lkdlieu,
            thang: selectedItem.thang,
            nam: selectedItem.nam,
            ngay: selectedItem.ngay,
            nlap: new Date(),
            sbthdlieu: selectedItem.sbthdlieu,
            loaihd: 9,
          };
          var detailForm = this.$scope.ui(bangtonghopform.$ui);
          bangtonghopform.setEditMode(1);
          bangtonghopform.setValues(data);

          var form = $$("bangtonghop-form").elements;
          for (var key in form) {
            var $el = form[key];
            if ($el.data.id == "ldau") $el.define("disabled", "true");
            else if ($el.data.id == "bslthu") $el.define("required", "true");
            $el.refresh();
          }
          detailForm.show();
        },
      },
      click: function () {
        this.callEvent("onClick");
      },
    },
    {
      view: "button",
      type: "htmlbutton",
      width: 100,
      label: '<i class="fa fa-trash-o fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("Xóa (F8)") + "</span>",
      id: "btnDelete",
      shortcut: "F8",
      on: {
        onClick: function () {
          var table = webix.$$("bangtonghop");
          var selectedItem = table.getSelectedItem();
          if (selectedItem == null) {
            webix.message("Bạn chưa chọn khách hàng ! ", "error");
            return;
          }
          if (selectedItem.trang_thai == "Đã ký" || selectedItem.trang_thai == "Đã gửi") {
            webix.message("Bảng tổng hợp đã ký không thể xóa ! ", "error");
            return;
          }
          webix.confirm({
            text: "Bạn có muốn xóa bản ghi",
            ok: "Có",
            cancel: "Không",
            callback: function (choose) {
              if (choose) {
                webix
                  .ajax()
                  .headers({ "Content-type": "application/json" })
                  .get(app.config.host + "/SummaryData/Delete?id=" + selectedItem.bangtonghopdl_68_id, function (text) {
                    var response = JSON.parse(text);
                    if (response.code != "00") {
                      webix.message({ type: "error", text: response.message });
                      return;
                    }
                    var btnRefresh = $$("btnRefresh");
                    btnRefresh.callEvent("onClick");
                  });
              }
            },
          });
        },
      },
      click: function () {
        this.callEvent("onClick");
      },
    },
    {
      view: "button",
      type: "htmlbutton",
      width: 100,
      label: '<i class="fa fa-print fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("PRINT") + "</span>",
      id: "btnPrint",

      // view: "button",
      // id: "btnPreview",
      // type: "icon",
      // icon: "eye",
      // label: "Xem in (F7)",
      // width: 100,
      // shortcut: "F7",
      on: {
        onClick: function () {
          var table = webix.$$("bangtonghop");
          var selectedItem = table.getSelectedItem();

          if (selectedItem == null) {
            webix.message("Bạn chưa dòng in ! ", "error");
            return;
          }
          var box = webix.modalbox({
            title: "Đang in bảng tổng hợp ....",
            text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
            width: 350,
            height: 200,
          });

          var newWin = window.open();
          var html = "<html><head><title>Hóa đơn điện tử M-Invoice</title>" + '<link rel="stylesheet" href="assets/fontawesome_pro/css/all.css" type="text/css" charset="utf-8">' + '<link rel="stylesheet" href="assets/fontawesome.css" type="text/css" charset="utf-8">' + '</head><body><center>Đang tải dữ liệu ... <br><p><i style="font-size:200%;" class="fa fa-spin fa-spinner"></i></p></center></body></html>';
          newWin.document.write(html);

          webix
            .ajax()
            .response("arraybuffer")
            .headers({ "Content-type": "application/json" })
            .get(app.config.host + "/SummaryData/PrintSummaryData?id=" + selectedItem.id + "&type=Pdf", {
              error: function (text, data, XmlHttpRequest) {
                webix.modalbox.hide(box);
              },
              success: function (text, data, XmlHttpRequest) {
                var file = new Blob([data], { type: "application/pdf" });
                var fileURL = URL.createObjectURL(file);
                //window.open(fileURL, '_blank');
                webix.modalbox.hide(box);
                newWin.location = fileURL;
              },
            });
        },
      },
      click: function () {
        this.callEvent("onClick");
      },
    },
    {
      view: "button",
      type: "htmlbutton",
      width: 100,
      label: '<i class="fa fa-sign-in fa-lg aria-hidden="true"></i> ' + '<span class="text">' + _("Ký") + "</span>",
      id: "btnKyCXL",
      on: {
        onClick: function () {
          var tableDK = webix.$$("bangtonghop");
          var selectedItem = tableDK.getSelectedItem();
          if (selectedItem == null) {
            webix.message("Bạn chưa chọn dòng dữ liệu ", "error");
            return;
          }
          if (selectedItem.trang_thai == "Đã ký" || selectedItem.trang_thai == "Đã gửi") {
            webix.message("Bảng tổng hợp Đã ký hoặc Đã gửi", "error");
            return;
          }
          webix.confirm({
            text: "Bạn có muốn ký bảng tổng hợp tháng: <b>" + selectedItem.thang + "</b> năm: <b>" + selectedItem.nam + "</b>",
            ok: "Có",
            cancel: "Không",
            callback: function (choose) {
              webix.ajax()
                .headers({ 'Content-Type': 'application/json' })
                .get(app.config.host + "/Pattern/GetSignType", function (text) {
                  var result = JSON.parse(text);
                  var kytaptrung = result[0].gia_tri;
                  if (kytaptrung.toUpperCase() == "INTRUSTCA") {
                    var box = webix.modalbox({
                      title: "Chọn chứng thư số IntrustCa",
                      buttons: ["Nhận", "Hủy bỏ"],
                      text: "<div id='ctnCerts'></div>",
                      top: 100,
                      width: 750,
                      callback: function (result) {
                        switch (result) {
                          case "1":
                            webix.modalbox.hide();
                            break;
                          case "0":
                            var frmBTH = webix.$$("bangtonghop");
                            var selectedItem = frmBTH.getSelectedItem();
                            var tableCert = $$("tblCerts");
                            var data = tableCert.serialize();
                            var cert = null;
                            for (var i = 0; i < data.length; i++) {
                              if (data[i].chon == true) {
                                cert = data[i];
                                break;
                              }
                            }
                            if (cert == null) {
                              webix.message("Bạn chưa chọn chứng thư số", "debug");
                              return;
                            }
                            var signModel = {
                              user_name: cert.username,
                              credentialID: cert.tokenSerial,
                              certificate: cert.cert_content,
                              pinCode: cert.pin_code,
                              auth_data: cert.auth_data,
                              mode: 1,
                              hoadon: [selectedItem.bangtonghopdl_68_id]
                            }
                            webix.extend(frmBTH, webix.ProgressBar);
                            frmBTH.disable();
                            frmBTH.showProgress();
                            webix.ajax().headers({ "Content-Type": "application/json" })
                              .post(app.config.host + CONSTANTS.API.SIGN.INTRUSTCA_BTH, JSON.stringify(signModel), function (text) {
                                frmBTH.enable();
                                frmBTH.hideProgress();
                                var result = JSON.parse(text);
                                if (result.code == "00") {
                                  webix.message("Ký thành công bảng tổng hợp số: " + selectedItem.sbthdlieu, "success");
                                  frmBTH.load(frmBTH.config.url);
                                } else
                                  webix.message(result.message, "error");
                              });
                            webix.modalbox.hide();
                            break;
                        }
                      },
                    });

                    var Certs = webix.ui({
                      container: "ctnCerts",
                      id: "tblCerts",
                      view: "datatable",
                      borderless: true,
                      resizeColumn: true,
                      height: 350,
                      columns: [
                        {
                          id: "chon",
                          header: _("CHON"),
                          width: 65,
                          checkValue: true,
                          uncheckValue: false,
                          template: "{common.checkbox()}",
                        },
                        {
                          id: "so_serial",
                          header: _("SO_SERIAL"),
                          width: 250,
                        },
                        {
                          id: "subjectname",
                          header: _("SUBJECTNAME"),
                          width: 400,
                        },
                        {
                          id: "ngaybatdau",
                          header: _("NGAY_BAT_DAU"),
                          width: 200,
                        },
                        {
                          id: "ngayketthuc",
                          header: _("NGAY_KET_THUC"),
                          width: 200,
                        },
                        { id: "issuer", header: _("DONVI"), width: 450 },
                      ],
                      url: CONSTANTS.API.TOKEN_CERT_AUTO,
                      ready: function () {
                        this.data.each(function (row, index) {
                          row.chon = false;
                          if (index == 0) row.chon = true;
                        });
                        this.refresh();
                      },
                      on: {
                        onCheck: function (rowId, colId, isChecked) {
                          if (isChecked) {
                            this.data.each(function (row) {
                              if (row.id !== rowId) {
                                this.getItem(row.id).chon = false;
                                this.updateItem(row.id);
                              }
                            });
                          }
                        }
                      }
                    });
                  }
                  else if (kytaptrung.toUpperCase() == "VNET") {
                    var box = webix.modalbox({
                      title: "Chọn chứng thư số Vnet",
                      buttons: ["Nhận", "Hủy bỏ"],
                      text: "<div id='ctnCerts'></div>",
                      top: 100,
                      width: 750,
                      callback: function (result) {
                        switch (result) {
                          case "1":
                            webix.modalbox.hide();
                            break;
                          case "0":
                            var frmBTH = webix.$$("bangtonghop");
                            var selectedItem = frmBTH.getSelectedItem();
                            var tableCert = $$("tblCerts");
                            var data = tableCert.serialize();
                            var cert = null;
                            for (var i = 0; i < data.length; i++) {
                              if (data[i].chon == true) {
                                cert = data[i];
                                break;
                              }
                            }
                            if (cert == null) {
                              webix.message("Bạn chưa chọn chứng thư số", "debug");
                              return;
                            }
                            var postData = {
                              chukyso_id: cert.chukyso_id,
                              id: selectedItem.bangtonghopdl_68_id
                          };
                            webix.extend(frmBTH, webix.ProgressBar);
                            frmBTH.disable();
                            frmBTH.showProgress();

                            webix.ajax().headers({ "Content-Type": "application/json", })
                              .post(app.config.host + "/SummaryData/SignByVnet", postData, function (text) {
                                var result = JSON.parse(text);
                                frmBTH.enable();
                                frmBTH.hideProgress();
                                if (result.code != "00") {
                                  webix.message({
                                    type: "error",
                                    text: result.message,
                                  });
                                  return;
                                } else {
                                  webix.message(
                                    "Ký thành công bảng tổng hợp số: " + result.data.sbthdlieu,
                                    "success"
                                  );
                                  frmBTH.load(frmBTH.config.url);
                                  webix.modalbox.hide();
                                }
                              }
                              );
                            break;
                        }
                      },
                    });

                    var Certs = webix.ui({
                      container: "ctnCerts",
                                      id: "tblCerts",
                                      view: "datatable",
                                      borderless: true,
                                      resizeColumn: true,
                                      height: 350,
                                      columns: [
                                          {
                                              id: "chon", header: _("CHON"), width: 65,
                                              checkValue: true, uncheckValue: false, template: "{common.checkbox()}"
                                          },
                                          { id: "so_serial", header: _("SO_SERIAL"), width: 150 },
                                          { id: "subjectname", header: _("SUBJECTNAME"), width: 450 },
                                          { id: "ngaybatdau", header: _("NGAY_BAT_DAU"), width: 200 },
                                          { id: "ngayketthuc", header: _("NGAY_KET_THUC"), width: 200 },
                                          { id: "issuer", header: _("DONVI"), width: 450 }
                                      ],
                                      url: app.config.host + "/Invoice/GetListCertificatesVnet"
                    });
                  }
                  else {
                    if (choose) {
                      require(["views/modules/minvoiceplugin"], function (plugin) {
                        var hub = plugin.hub();
                        var hubconnect = plugin.conn();

                        var table = $$("frmViewBTHDL");
                        webix.extend(table, webix.ProgressBar);
                        table.disable();
                        table.showProgress();

                        if (hubconnect.state != 1) {
                          table.enable();
                          table.hideProgress();
                          webix.message("Quý khách hàng chưa cài Plugin ký hóa đơn hoặc Plugin ký hóa đơn chưa được bật !", "error");
                          var Form = $$("bangtonghop").$scope.ui(modalPlugin.$ui);
                          Form.show();
                          return;
                        }
                        var arrId = [];
                        arrId.push(selectedItem.id);
                        var currentLocation = window.location.origin + "/api/";
                        if (document.location.protocol == "file:") {
                          currentLocation = "http://localhost:18374/";
                        }
                        var arg = {
                          signAndSend: false,
                          infoSign: {
                            tagSign: "NNT",
                            idData: "#data",
                          },
                          idSign: arrId,
                          cookie: user.getAppCookie(),
                          location: currentLocation,
                        };
                        hub
                          .invoke("execCommand", "SignSummaryTable", JSON.stringify(arg))
                          .done(function () {
                            console.log("SignSummaryTable Success !");
                          })
                          .fail(function (error) {
                            webix.message(error, "error");
                          });
                        hub.off("resNotice");
                        hub.on("resNotice", function (result) {
                          webix.message(result, "debug");
                        });
                        hub.off("resCommand");
                        hub.on("resCommand", function (result) {
                          var response = JSON.parse(result);
                          table.enable();
                          table.hideProgress();
                          if (response.code == "00") {
                            app.callEvent("dataChangeBangtonghop", [1, null]);
                            webix.message("Ký thành công", "success");
                            //webix.message("Code: " + response.code + " Message: " + response.message, "success");
                          } else {
                            webix.message("Code: " + response.code + " Message: " + response.message, "error");
                          }
                        });
                      });
                    }
                  }
                })
            },
          });
        },
      },
      click: function () {
        this.callEvent("onClick");
      },
    },
    {
      view: "button",
      type: "htmlbutton",
      width: 100,
      label: '<i class="fa fa-paper-plane fa-lg aria-hidden="true"></i><span class="text"> ' + _("Gửi CQT") + "</span>",
      id: "btnKyGuiCQT",
      click: function () {
        var table = webix.$$("bangtonghop");
        var selectedItem = table.getSelectedItem();
        if (selectedItem == null) {
          webix.message("Bạn chưa chọn dòng nào ! ", "error");
          return;
        }
        if (selectedItem.trang_thai != "Đã ký") {
          webix.message("Bảng tổng hợp chưa ký không thể gửi đi ! ", "error");
          return;
        }
        webix.confirm({
          title: "GỬI BẢNG TỔNG HỢP",
          text: "Bạn có muốn gửi bảng tổng hợp số:",
          ok: "Có",
          cancel: "Không",
          callback: function (res) {
            if (res) {
              webix.extend(table, webix.ProgressBar);
              table.disable();
              table.showProgress();
              webix
                .ajax()
                .headers({ "Content-Type": "application/json" })
                .get(app.config.host + "/SummaryData/SendToTVAN?id=" + selectedItem.bangtonghopdl_68_id, function (text) {
                  var result = JSON.parse(text);
                  var table = webix.$$("bangtonghop");
                  table.enable();
                  table.hideProgress();
                  if (result.code != "00") {
                    webix.message({ type: "error", text: result.message });
                    return;
                  } else {
                    var table = webix.$$("bangtonghop");
                    table.clearAll();
                    table.load(table.config.url);
                  }
                });
              //webix.message("Gửi đến cơ quan thuế thành công ", "success");
            }
          },
        });
      },
    },
    {
      view: "button",
      type: "htmlbutton",
      width: 100,
      label: '<i class="fa fa-download fa-lg aria-hidden="true"></i><span class="text"> ' + _("Tải xml") + "</span>",
      id: "btnDownloadXml",
      on: {
        onClick: function () {
          var table = webix.$$("bangtonghop");
          var selectedItem = table.getSelectedItem();
          if (selectedItem == null) {
            webix.message("Bạn chưa chọn bảng tổng hợp ! ", "error");
            return;
          }
          if (selectedItem.trang_thai === "Chờ ký") {
            webix.message("Bảng tổng hợp chưa ký không tồn tại xml ! ", "error");
            return;
          }

          webix.extend(table, webix.ProgressBar);
          table.disable();
          table.showProgress();

          var url = app.config.host + "/SummaryData/ExportFileXML?id=" + selectedItem.id;
          webix.ajax().response("arraybuffer").get(url, function (text, data) {
            table.enable();
            table.hideProgress();
            var file = new Blob([data], { type: "application/xml" });
            webix.html.download(file, "BangTHDL.xml");
          });
        },
      },
      click: function () {
        this.callEvent("onClick");
      },
    },
    {
      view: "button",
      type: "htmlbutton",
      width: 130,
      label: '<i class="fa fa-file-excel fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("EXPORT_EXCEL") + "</span>",
      id: "btnExport",
      on: {
        onClick: function () {
          var table = webix.$$("bangtonghop");
          var selectedItem = table.getSelectedItem();

          if (selectedItem == null) {
            webix.message("Bạn chưa dòng dữ liệu ! ", "error");
            return;
          }
          var box = webix.modalbox({
            title: "Đang kết xuất bảng tổng hợp ....",
            text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
            width: 350,
            height: 200,
          });

          var newWin = window.open();
          var html = "<html><head><title>Hóa đơn điện tử M-Invoice</title>" + '<link rel="stylesheet" href="assets/fontawesome_pro/css/all.css" type="text/css" charset="utf-8">' + '<link rel="stylesheet" href="assets/fontawesome.css" type="text/css" charset="utf-8">' + '</head><body><center>Đang tải dữ liệu ... <br><p><i style="font-size:200%;" class="fa fa-spin fa-spinner"></i></p></center></body></html>';
          newWin.document.write(html);

          webix.ajax().response("arraybuffer").headers({ "Content-type": "application/json" })
            .get(app.config.host + "/SummaryData/PrintSummaryData?id=" + selectedItem.id + "&type=Excel", {
              error: function (text, data, XmlHttpRequest) {
                webix.modalbox.hide(box);
                webix.message(XmlHttpRequest.statusText, "error");
              },
              success: function (text, data, XmlHttpRequest) {
                var file = new Blob([data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
                var fileURL = URL.createObjectURL(file);
                webix.modalbox.hide(box);
                window.location.href = fileURL;
              },
            });
        },
      },
      click: function () {
        this.callEvent("onClick");
      },
    },
    {},
  ];

  var table = {
    margin: 0,
    rows: [
      {
        id: "bangtonghop",
        view: "datatable",
        select: true,
        resizeColumn: true,
        footer: false,
        editable: false,
        tooltip: true,
        scheme: {
          $init: function (obj) { },
        },
        onClick: {
          btnViewLichsu: function (event, cell, target) {
            var table = webix.$$("bangtonghop");
            var item = table.getItem(cell.row);
            var detailForm = this.$scope.ui(viewLogForm.$ui);
            viewLogForm.initUI("bthop", item.matdiep, item);
            detailForm.show();
          },
        },
        type: {
          mtrangthaibth: function (obj, common, value, config) {
            var trang_thai = obj.trang_thai;
            var response = `<span class='btnViewLichsu' style='color: #0069b4;font-weight: bold; text-decoration: underline;'>${trang_thai}</span>`;
            if (trang_thai == CONSTANTS.DA_KY) response = `<span style='color: #63b4ea;font-weight: bold;'>${trang_thai}</span>`;
            if (trang_thai == CONSTANTS.CHO_KY) response = `<span style='color: #f47537;font-weight: bold;'>${trang_thai}</span>`;
            if (trang_thai == CONSTANTS.THANH_CONG) response = `<span class='btnViewLichsu' style='color: #008000;font-weight: bold; text-decoration: underline;'>${trang_thai}</span>`;
            if (trang_thai == CONSTANTS.CO_LOI) response = `<span class='btnViewLichsu' style='color: #FF0000;font-weight: bold; text-decoration: underline;'>${trang_thai}</span>`;
            return response;
          }
        },
        on: {
          // "data->onStoreUpdated": function () {
          //   this.data.each(function (obj, i) {
          //     obj.index = i + 1;
          //   });
          // },
          onItemDblClick: function (id, e, node) {
            var btnEdit = $$("btnEdit");
            btnEdit.callEvent("onClick");
          },
          onAfterLoad: function () { },
          onSubViewCreate: function (view, item) {
            var subView = view;
            if (subView != null) {
              var tableDetail = webix.$$("bangtonghop_chitiet_view");
              var apiHost = app.config.host + "/SummaryData/GetSummaryDataDetail?id=" + item.id;
              tableDetail.clearAll();
              tableDetail.load(apiHost);
            }
          },
        },
        subview: {
          borderless: true,
          view: "tabview",
          height: 255,
          css: "subInvoice",
          scrollX: true,
          // tabbar: {
          //     width: 200
          // },
          multiview: {
            fitBiggest: true,
          },
          cells: [
            {
              header: "Chi tiết bảng tổng hợp",
              select: "cell",
              body: {
                view: "datatable",
                resizeColumn: true,
                margin: 10,
                id: "bangtonghop_chitiet_view",
                height: 200,
                columns: [
                  { id: "stt", header: "", width: 30 },
                  { id: "khieu", header: _("Ký hiệu"), editor: "text", width: 120, editable: true, },
                  { id: "shdon", header: _("Số hóa đơn"), editor: "text", width: 120, editable: true, },
                  {
                    id: "nlap", header: _("Ngày lập"), editor: "text", width: 120, editable: true,
                    format: function (text) {
                      var format = webix.Date.dateToStr("%d/%m/%Y");
                      text = removeTimeZoneT(text);
                      return format(text);
                    },
                  },
                  { id: "tnmua", header: _("Tên người mua"), editor: "text", width: 300, editable: true, },
                  { id: "mstnmua", header: _("MST người mua"), editor: "text", width: 120, editable: true, },
                  {
                    id: "tgtttoan", header: _("Tổng tiền thanh toán"), width: 150, editor: "autonumeric", editable: true, css: { "text-align": "right" },
                    format: webix.Number.numToStr({
                      groupDelimiter: ",",
                      groupSize: 3,
                      decimalDelimiter: ".",
                      decimalSize: 2,
                    }),
                  },
                ],
                on: {
                  onBeforeLoad: function () {
                    this.showOverlay(_("LOADING") + "...");
                  },
                  onAfterLoad: function () {
                    this.hideOverlay();
                  },
                },
              },
            },
          ],
        },
        columns: [
          { id: "subRowMain", header: "&nbsp;", template: "{common.subrow()}", width: 40 },
          // { id: "index", header: "STT", sort: "int", width: 40, },
          {
            id: "trang_thai",
            header: ["Trạng thái", { content: "multiSelectFilter", options: CONSTANTS.STATUS_SEND_INVOICE }],
            width: 110,
            template: "{common.mtrangthaibth()}"
          },
          {
            id: "nlap", header: ["Ngày lập", { content: "datepickerFilter" }], width: 110,
            format: function (text) {
              var format = webix.Date.dateToStr("%d/%m/%Y %H:%i:%s");
              text = removeTimeZoneT(text);
              return format(text);
            },
          },
          {
            id: "ldau", header: ["Lần nộp", { content: "serverFilter" }], width: 110,
            template: function (obj) {
              var response = "<span class='mcls_status7'>Bổ sung</span> ";
              if (obj.ldau == 1) response = "<span class='mcls_status1'>Lần đầu</span> ";
              return response;
            },
          },
          { id: "lkdlieu", header: ["Kỳ dữ liệu", { content: "serverFilter" }], width: 100 },
          { id: "thang", header: ["Tháng/ Quý", { content: "serverFilter" }], width: 100 },
          { id: "nam", header: ["Năm", { content: "serverFilter" }], width: 80 },
          { id: "sbthdlieu", header: ["Số bảng TH", { content: "serverFilter" }], width: 110 },
          { id: "bslthu", header: ["Bổ sung lần thứ", { content: "serverFilter" }], width: 120 },
          { id: "dvtte", header: ["Đơn vị tiền tệ", { content: "serverFilter" }], width: 120 },
          // {
          //     id: "tgtcthue",
          //     header: ["Tổng tiền trước thuế", { content: "serverFilter" }],
          //     width: 150,
          //     format: webix.Number.numToStr({
          //         groupDelimiter: ",",
          //         groupSize: 3,
          //         decimalDelimiter: ".",
          //         decimalSize: 0,
          //     }),
          //     css: { "text-align": "right" }
          // },
          // {
          //     id: "tgtthue",
          //     header: ["Tổng tiền thuế", { content: "serverFilter" }], width: 150,
          //     format: webix.Number.numToStr({
          //         groupDelimiter: ",",
          //         groupSize: 3,
          //         decimalDelimiter: ".",
          //         decimalSize: 0,
          //     }),
          //     css: {
          //         "text-align": "right",
          //     },
          // },
          // {
          //     id: "tgtttoan",
          //     header: ["Tổng tiền thanh toán", { content: "serverFilter" }],
          //     width: 150,
          //     format: webix.Number.numToStr({
          //         groupDelimiter: ",",
          //         groupSize: 3,
          //         decimalDelimiter: ".",
          //         decimalSize: 0,
          //     }),
          //     css: {
          //         "text-align": "right",
          //     },
          // },
          { id: "nglap", header: ["Người lập", { content: "serverFilter" }], width: 120 },
          {
            id: "ngay_ky", header: ["Ngày giờ ký", { content: "datepickerFilter" }], width: 150,
            format: function (text) {
              var format = webix.Date.dateToStr("%d/%m/%Y %H:%i:%s");
              text = removeTimeZoneT(text);
              return format(text);
            },
          },
          { id: "gchu", name: "gchu", header: ["Ghi chú", { content: "serverFilter" }], width: 150 },
        ],
        pager: "pagerA",
      },
      {
        id: "pagerA", view: "pager", container: "paging_here", size: 50, group: 5,
        template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}"
      },
    ],
  };

  var layout = {
    css: "frmView",
    id: "frmViewBTHDL",
    rows: [
      { height: 39, css: "btnControl", margin: 0, borderless: true, type: "toolbar", cols: controls, },
      {
        rows: [table],
      },
    ],
  };
  return {
    $ui: layout,
    $oninit: function (view, $scope) {
      var table = webix.$$("bangtonghop");
      webix.extend(view, webix.ProgressBar);
      $scope.on(app, "dataChangeBangtonghop", function (mode, item) {
        table.clearAll();
        table.load(table.config.url);
      });
    },
    $onurlchange: function (ui, name, url, scope) {
      initUI();
    },
  };
});

define('views/forms/forms68/BaoCao/bc_component',[
    "app",
    "locale",
], function (app, _) {
    var date = new Date();
    var _month = date.getMonth() + 1;
    var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
    var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);

    function subviewT() {
        $$('cbQuy').define('label', "Tháng");
        $$('cbQuy').refresh();
        $$('cbQuy').define('options', ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"]);
    }

    function subviewQ() {
        $$('cbQuy').define('label', "Quý");
        $$('cbQuy').refresh();
        $$('cbQuy').define('options', ["1", "2", "3", "4"]);
    }

    return {
        HeaderReport: function () {
            var element = {
                cols: [
                    {
                        view: "radio",
                        id: "head_extension",
                        value: 1,
                        options: [
                            { "id": 1, "value": "Tháng" }, // the initially selected item
                            { "id": 2, "value": "Quý" }
                        ],
                        on: {
                            onChange: function (newv, oldv) {
                                var d = new Date();
                                var quarter = Math.floor((d.getMonth() / 3));
                                var quarter1 = quarter + 1;
                                if (newv == 2) {
                                    subviewQ();
                                    $$("cbQuy").setValue(quarter1);
                                }
                                if (newv == 1) {
                                    subviewT();
                                    $$("cbQuy").setValue(d.getMonth() + 1);
                                }
                            }
                        }
                    },
                    {
                        id: "cbQuy",
                        name: "quy",
                        view: "combo",
                        label: "Tháng",
                        value: _month,
                        options: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"],
                        on: {
                            onChange: function () {
                                var d = new Date();
                                var quarter = Math.floor((d.getMonth() / 3));
                                var quarter1 = quarter + 1;

                                var option = $$('head_extension').getValue();
                                if (option == 2) {
                                    var nam = d.getFullYear();
                                    var thang;
                                    var quy = $$("cbQuy").getValue();
                                    if (quy == 1) {
                                        thang = 0;
                                    }
                                    if (quy == 2) {
                                        thang = 3;
                                    }
                                    if (quy == 3) {
                                        thang = 6
                                    }
                                    if (quy == 4) {
                                        thang = 9
                                    }
                                    var firstDate = new Date(nam, thang, 1);
                                    var lastDate = new Date(nam, thang + 3, 0);

                                    $$("tu_ngay").setValue(firstDate);
                                    $$("tu_ngay").refresh();
                                    $$("den_ngay").setValue(lastDate);
                                    $$("den_ngay").refresh();
                                }
                                if (option == 1) {
                                    var year = d.getFullYear();
                                    var month = $$("cbQuy").getValue();
                                    var date1 = month + "/01" + "/" + year;

                                    var date = new Date(date1);
                                    var firstDay1 = new Date(date.getFullYear(), date.getMonth(), 1);

                                    var lastDay1 = new Date(date.getFullYear(), date.getMonth() + 1, 0);
                                    $$("tu_ngay").setValue(firstDay1);
                                    $$("tu_ngay").refresh();
                                    $$("den_ngay").setValue(lastDay1);
                                    $$("den_ngay").refresh();
                                }
                            }
                        }
                    }
                ]
            };
            return element;
        },
        TuNgay: function () {
            return {
                view: "datepicker", label: _("TU_NGAY"), name: "tu_ngay", id: "tu_ngay", attributes: { maxlength: 10 },
                value: firstDay,
                editable: true,
                // pattern: {  mask: "##/##/####" },
                placeholder: "dd/MM/yyyy"
            };
        },
        DenNgay: function () {
            return {
                view: "datepicker", label: _("DEN_NGAY"), name: "den_ngay",
                id: "den_ngay", value: lastDay, editable: true,
                attributes: { maxlength: 10 },
                // pattern: { mask: "##/##/####" },
                placeholder: "dd/MM/yyyy"

            };
        },
        KyHieuHD: function () {
            return {
                view: "multicombo",
                label: _("KY_HIEU"),
                name: "cctbao_id",
                suggest: {
                    selectAll: true,
                    body: {
                        url: app.config.host + "/Serial/GetAllSeri",
                    }
                }
            };
        },
        TrangThaiHD: function () {
            return {
                view: "combo",
                label: _("Trạng thái HĐ"),
                name: "tthai",
                value: "Đã gửi",
                options: [
                    { id: "Chờ ký", value: "Chờ ký" },
                    { id: "Đã ký", value: "Đã ký" },
                    { id: "Đã gửi", value: "Đã gửi" }
                ]
            };
        },
        TrangThaiCQT: function () {
            return {
                view: "combo",
                label: _("Trạng thái CQT"),
                name: "is_success",
                value: "1",
                options: [
                    { id: "", value: "" },
                    { id: "1", value: "Thành công" },
                    { id: "0", value: "Có lỗi" }
                ]
            };
        },
        TinhChatHD: function () {
            return {
                view: "multicombo",
                label: "Tính chất HĐ",
                name: "is_tthdon",
                options: {
                    data: [
                        { id: "0", value: "Mới (Gốc)" },
                        { id: "1", value: "Hủy" },
                        { id: "2", value: "Điều chỉnh" },
                        { id: "3", value: "Thay thế" },
                        { id: "4", value: "Giải trình" },
                        { id: "5", value: "Sai sót do tổng hợp" },
                        { id: "6", value: "Bị thay thế" },
                        { id: "7", value: "Bị điều chỉnh" }
                    ],
                    selectAll: true
                },
                value: "0,2,3,4,5,7"
            };
        }
    }
});
define('views/forms/forms68/BaoCao/68_bc_bkbanra',[
    "app",
    "locale",
    "models/user",
    "views/forms/forms68/BaoCao/bc_component"
], function (app, _, user, component) {
    return {
        $ui: {
            view: "window",
            modal: true,
            position: "center",
            head: "Bảng kê bán ra",
            width: 400,
            resize: true,
            body: {
                paddingY: 10,
                paddingX: 10,
                elementsConfig: { labelWidth: 100 },
                view: "form",
                id: "bangkebr",
                complexData: true,
                margin: 0,
                elements: [
                    component.HeaderReport(),
                    {
                        cols: [
                            { view: "label", label: "Cách tổng hợp tiền hóa đơn:" },
                            {
                                view: "radio",
                                id: "head_extension_tien",
                                name: "options",
                                value: 1,
                                options: [
                                    { "id": 1, "value": "Đầu phiếu" },
                                    { "id": 2, "value": "Chi tiết" }
                                ]
                            }
                        ]
                    },
                    component.TuNgay(),
                    component.DenNgay(),
                    component.KyHieuHD(),
                    component.TrangThaiHD(),
                    component.TrangThaiCQT(),
                    component.TinhChatHD(),
                    {
                        margin: 10,
                        cols: [
                            {},
                            {
                                shortcut: "F10", view: "button", label: "Nhận (F10)", width: 100, type: "form", align: "center",
                                on: {
                                    onClick: function () {
                                        var form = this.getParentView().getParentView();
                                        var win = this.getTopParentView();
                                        var item = form.getValues();
                                        item.skip = 0;
                                        item.take = 1000;
                                        var load_event = "loadBangkebanra";
                                        app.callEvent(load_event, [item]);
                                        win.close();
                                    }
                                },
                                click: function () {
                                    this.callEvent("onClick");

                                }
                            },
                            {
                                view: "button", hotkey: "esc", label: "Hủy bỏ (ESC)", width: 100, align: "center", type: "danger",
                                click: function () {
                                    this.getTopParentView().close();
                                }
                            },
                            {}
                        ]
                    }
                ]
            }

        },

        setValues: function (item) {
            var win = $$(this.$ui.id);
            var form = win.getChildViews()[1];

            form.setValues(item);
        }
    };

});

define('views/68_bc_bkbanra',[
    "app",
    "locale",
    "models/user",
    "views/forms/forms68/BaoCao/68_bc_bkbanra",
    "views/modules/minvoiceplugin",
], function (app, _, user, bangkebanra, plugin) {
    'use strict';

    function RemoveTimeT(text) {
        var format = webix.Date.dateToStr("%Y-%m-%d");
        text = removeTimeZoneT(text);
        return format(text);
    };

    var fm = webix.Number.numToStr({
        groupDelimiter: ",",
        groupSize: 3,
        decimalDelimiter: ".",
        decimalSize: 0
    });

    var controls = [
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-refresh fa-lg" aria-hidden="true"></i> ' +
                '<span class="text">' + _("REFRESH") + '</span>',
            id: "btnReload",
            on: {
                onClick: function () {
                    var wininfoparam = this.$scope.ui(bangkebanra.$ui);
                    wininfoparam.show();
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-print fa-lg" aria-hidden="true"></i> ' +
                '<span class="text">' + _("PRINT") + " PDF" + '</span>',
            id: "btnPrint",
            on: {
                onClick: function () {
                    var table = $$("bangkebanra");
                    var rpParameter = table.config.rpParameter;
                    if (rpParameter == undefined || rpParameter == null) {
                        webix.message("Bạn chưa chọn báo cáo hoặc chưa tải dữ liệu !", "error");
                        return;
                    }
                    rpParameter.type = "PDF";
                    if (rpParameter != null) {
                        var box = webix.modalbox({
                            title: "Đang in báo cáo ....",
                            text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                            width: 350,
                            height: 200
                        });

                        webix.ajax()
                            .response("arraybuffer")
                            .headers({ 'Content-type': 'application/json' })
                            .post(app.config.host + "/Report68/PrintDataReport", rpParameter,
                                {
                                    error: function (text, data, XmlHttpRequest) {
                                        webix.modalbox.hide(box);
                                        webix.message(XmlHttpRequest.statusText, "error");
                                    },
                                    success: function (text, data, XmlHttpRequest) {
                                        var file = new Blob([data], { type: 'application/pdf' });
                                        var fileURL = URL.createObjectURL(file);
                                        webix.modalbox.hide(box);
                                        window.open(fileURL, '_blank');
                                    }
                                }
                            );
                    }
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {
            view: "button", type: "htmlbutton", width: 120,
            label: '<i class="fa fa-file-excel fa-lg" aria-hidden="true"></i> ' +
                '<span class="text">' + _("EXPORT_EXCEL") + '</span>',
            id: "btnExport",
            on: {
                onClick: function () {
                    var table = $$("bangkebanra");

                    var rpParameter = table.config.rpParameter;
                    if (rpParameter == undefined || rpParameter == null) {
                        webix.message("Bạn chưa chọn báo cáo hoặc chưa tải dữ liệu !", "error");
                        return;
                    }
                    rpParameter.type = "xlsx";
                    if (rpParameter != null) {
                        var box = webix.modalbox({
                            title: "Đang kết xuất Excel ....",
                            text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                            width: 350,
                            height: 200
                        });

                        webix.ajax()
                            .response("arraybuffer")
                            .headers({ 'Content-type': 'application/json' })
                            .post(app.config.host + "/Report68/PrintDataReport", rpParameter,
                                {
                                    error: function (text, data, XmlHttpRequest) {
                                        webix.modalbox.hide(box);
                                    },
                                    success: function (text, data, XmlHttpRequest) {
                                        var file = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                                        var fileURL = URL.createObjectURL(file);
                                        webix.modalbox.hide(box);
                                        window.location.href = fileURL;
                                    }
                                }
                            );
                    }
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {
            view: "button", type: "htmlbutton", width: 120,
            label: '<i class="fa fa-file-text-o fa-lg" aria-hidden="true"></i> ' +
                '<span class="text">' + _("EXPORT_CSV") + '</span>',
            id: "btnExportCsv",
            on: {
                onClick: function () {
                    var table = $$("bangkebanra");

                    var rpParameter = table.config.rpParameter;
                    if (rpParameter == undefined || rpParameter == null) {
                        webix.message("Bạn chưa chọn báo cáo hoặc chưa tải dữ liệu !", "error");
                        return;
                    }
                    rpParameter.type = "CSV";

                    if (rpParameter != null) {
                        var box = webix.modalbox({
                            title: "Đang kết xuất Excel ....",
                            text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                            width: 350,
                            height: 200
                        });

                        webix.ajax()
                            .response("arraybuffer")
                            .headers({ 'Content-type': 'application/json' })
                            .post(app.config.host + "/Report68/PrintDataReport", rpParameter,
                                {
                                    error: function (text, data, XmlHttpRequest) {
                                        webix.modalbox.hide(box);
                                    },
                                    success: function (text, data, XmlHttpRequest) {
                                        var file = new Blob([data], { type: 'application/csv' });
                                        webix.html.download(file, "MinvoiceBangkebanra.csv");
                                        webix.modalbox.hide(box);
                                    }
                                }
                            );
                    }
                }
            },
            click: function () {
                this.callEvent("onClick");
            }

        },
        {
            view: "button", type: "htmlbutton", width: 120,
            label: '<i class="fa fa-file-excel fa-lg" aria-hidden="true"></i> ' +
                '<span class="text">' + _("Kết xuất Excel (Nhanh)") + '</span>',
            id: "btnExportNew", hidden: true,
            on: {
                onClick: function () {
                    var table = $$("bangkebanra");
                    var rpParameter = table.config.rpParameter;
                    if (rpParameter == undefined || rpParameter == null) {
                        webix.message("Bạn chưa chọn báo cáo hoặc chưa tải dữ liệu !", "error");
                        return;
                    }
                    rpParameter.type = "xlsx";
                    if (rpParameter != null) {
                        var box = webix.modalbox({
                            title: "Đang kết xuất Excel ....",
                            text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                            width: 350,
                            height: 200
                        });
                        webix.toExcel($$("bangkebanra"), {
                            filename: "Minvoice_BC_BangKeBanRa"
                        });
                        webix.modalbox.hide(box);
                    }
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {
            view: "button", type: "htmlbutton", width: 150,
            label: `<i class="fa fa-plug fa-lg" aria-hidden="true"></i> ${_("Kết xuất trên Plugin")}`,
            id: "btnExportPlugin",
            on: {
                onClick: function () {
                    var table = $$("bangkebanra");
                    var rpParameter = table.config.rpParameter;
                    if (rpParameter == undefined || rpParameter == null) {
                        webix.message("Bạn chưa chọn báo cáo hoặc chưa tải dữ liệu !", "error");
                        return;
                    }
                    var hub = plugin.hub();
                    var hubconnect = plugin.conn();
                    var form = $$("grdViewReport");
                    webix.extend(form, webix.ProgressBar);
                    form.disable();
                    form.showProgress();
                    if (hubconnect.state != 1) {
                        form.enable();
                        form.hideProgress();
                        webix.message("Quý khách hàng chưa cài Plugin ký hóa đơn hoặc Plugin ký hóa đơn chưa được bật !", "error");
                        var Form = $$("grdViewReport").$scope.ui(modalPlugin.$ui);
                        Form.show();
                        return;
                    }
                    var currentLocation = window.location.origin + "/api/";
                    if (document.location.protocol == "file:" || document.location.hostname == "127.0.0.1") {
                        currentLocation = "http://localhost:18374/";
                    };
                    rpParameter.location = currentLocation;
                    rpParameter.cookie = user.getAppCookie();
                    rpParameter.type = "pdf";
                    rpParameter.is_delete = "1";
                    var table = $$("bangkebanra");
                    rpParameter.data = table.data.getRange();
                    rpParameter.name = "Bảng kê bán ra";
                    if (rpParameter.tu_ngay) rpParameter.tu_ngay = RemoveTimeT(rpParameter.tu_ngay);
                    if (rpParameter.den_ngay) rpParameter.den_ngay = RemoveTimeT(rpParameter.den_ngay);


                    hub.invoke('execCommand', 'BC_BANGKEBANRA', JSON.stringify(rpParameter))
                        .done(function () {
                            console.log("Run report on plugin success !")
                        })
                        .fail(function (error) {
                            webix.message(error, "error");
                        });
                    hub.off('resNotice');
                    hub.on('resNotice', function (result) {
                        webix.message(result, "debug", 4000);
                    });
                    hub.off('resCommand');
                    hub.on('resCommand', function (result) {
                        var response = JSON.parse(result);
                        form.enable();
                        form.hideProgress();
                        if (response.code == "00") {
                            webix.message("Đã tạo báo cáo thành công trên plugin", "success", 3000);
                        }
                        else {
                            webix.message("Code: " + response.code + " Message: " + response.message + ". Plugin xảy ra lỗi", "error");
                        }
                    });
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {}
    ];

    var grid = {
        rows: [
            {
                container: "testA",
                view: "treetable",
                id: "bangkebanra",
                select: true,
                resizeColumn: true,
                fullScreen: true,
                leftSplit: 5,
                columns: [
                    {
                        id: "stt", header: "<center>STT</center>", sort: "int", width: 40
                    },
                    { id: "khhdon", header: [{ "text": "<center>Hóa đơn chứng từ bán ra</center>", "colspan": 3 }, { "text": "<center>Ký hiệu</center>" }, { content: "textFilter" }] },
                    {
                        id: "shdon", header: [null, { "text": "<center>Số hóa đơn</center>" }, { content: "numberFilter" }]
                    },
                    {
                        id: "ten_tt", header: [null, { "text": "<center>Tính chất HĐ</center>" }, { content: "selectFilter" }]
                    },
                    {
                        id: "tdlap", header: [null, { "text": "<center>Ngày hóa đơn</center>" }, { content: "dateFilter" }], width: 120, format: function (text) {
                            var format = webix.Date.dateToStr("%d/%m/%Y");
                            text = removeTimeZoneT(text);
                            return format(text);
                        }
                    },
                    {
                        id: "tenNguoiMua", header: [{ rowspan: 2, "text": "<center>Tên người mua</center>" }, { "text": "<center>Tên người mua</center>" }, { content: "textFilter" }], width: 500,
                        template: function (obj, common) {
                            if (obj.$level == 1) return common.treetable(obj, common) + "<span style='color:blue;'>" + obj.value + " ( " + (obj.$count - 1) + " )" + "</span>";
                            return obj.tenNguoiMua;
                        }
                    },
                    // {
                    //     header: "<center>Trạng thái</center>", width: 150, template: function (obj) {
                    //         if (obj.$group == true) return "";
                    //         return "<span class='hotro_status" + obj.trang_thai + "'>" + obj.trang_thai + "</span>"
                    //     }
                    // },
                    { id: "mstNguoiMua", header: [{ text: "<center>Mã số thuế</center>", rowspan: 2 }, null, { content: "textFilter" }], width: 120 },
                    { id: "mat_hang", header: "<center>Mặt hàng</center>", width: 200, hidden: true },
                    {
                        id: "tgtcthue", header: [{ text: "<center>Doanh thu chưa có thuế GTGT</center>", css: "multiline" }], width: 100, format: webix.Number.numToStr({
                            groupDelimiter: ",",
                            groupSize: 3,
                            decimalDelimiter: ".",
                            decimalSize: 0
                        }),
                        css: { "text-align": "right !important" }
                    },
                    {
                        id: "tien_ck", header: "<center>Tiền CK</center>", width: 100, format: webix.Number.numToStr({
                            groupDelimiter: ",",
                            groupSize: 3,
                            decimalDelimiter: ".",
                            decimalSize: 0
                        }),
                        css: { "text-align": "right !important" },
                        hidden: true
                    },
                    {
                        id: "tgtthue", header: "<center>Thuế GTGT</center>", width: 100, format: webix.Number.numToStr({
                            groupDelimiter: ",",
                            groupSize: 3,
                            decimalDelimiter: ".",
                            decimalSize: 0
                        }),
                        css: { "text-align": "right !important" }
                    },
                    {
                        id: "tong_tien", header: "<center>Tổng tiền</center>", width: 100, format: webix.Number.numToStr({
                            groupDelimiter: ",",
                            groupSize: 3,
                            decimalDelimiter: ".",
                            decimalSize: 0
                        }),
                        css: { "text-align": "right !important" },
                        hidden: true
                    },
                    { id: "tsuat", header: "<center>Thuế suất</center>", width: 90 },
                    { id: "loaiThue", header: "<center>Loại thuế</center>", width: 90, hidden: true },
                    { id: "gchu", header: "<center>Ghi chú</center>", width: 150 }
                ],
                pager: "pagerA",
                scheme: {
                    $init: function (obj) {
                        if (obj.$group) {
                            obj.$css = 'bangkebanra';
                        }
                        //console.log(obj);
                        // if (obj.year >= 2000) obj.$css = "koko";
                        // if (obj.year <= 1970) obj.$css = "oldtime";
                    },
                    $serialize: function (obj) {
                        //console.log(obj);
                        // if (obj.$group) {
                        //     obj.$css = 'koko';
                        // }
                    },
                    $group: {
                        by: "loaiThue",
                        // map hoặc footer
                        footer: {
                            tenNguoiMua: ["<span style='color: red;'>" + _("TOTAL") + "</span>", "string"],
                            tgtthue: ["tgtthue", "sum"],
                            tgtcthue: ["tgtcthue", "sum"],
                            //tien_ck: ["tien_ck", "sum"],
                            //tong_tien: ["tong_tien", "sum"]
                            // tong_tien: [function (obj) {
                            //     console.log(obj);
                            //     // var min = obj.year - obj.year%10; 
                            //     return obj.tong_tien;
                            // }]
                            // row: function (obj) {
                            // console.log(obj);
                            // return "<span style='float:right;'>Total: "
                            //     + webix.i18n.numberFormat(obj.tong_tien) + "</span>"
                            // }
                        }
                        , css: "bangkebanra"
                        // map:{
                        // 	nguoi_lien_he:["nguoi_lien_he", "count"]
                        // }
                    },
                    // $css: { "color": "red !important" }
                    //$sort: { by: "stt", dir: "asc" }
                },
                ready: function () {
                    //this.open(this.getFirstId());
                    //this.sort({ by: "stt", dir: "asc" });
                    this.openAll();
                },
                on: {
                    onAfterFilter: function () {
                        var tong_doanhthu = 0;
                        var tong_tienthue = 0;
                        var table = $$("bangkebanra");
                        table.eachRow(function (row) {
                            var item = table.getItem(row);
                            if (item.khhdon != null && item.khhdon != undefined && item.khhdon != "") {
                                var tgtthue = item.tgtthue == null || item.tgtthue == undefined || item.tgtthue == "" ? 0
                                    : item.tgtthue;
                                var tgtcthue = item.tgtcthue == null || item.tgtcthue == undefined || item.tgtcthue == "" ? 0
                                    : item.tgtcthue;
                                tong_doanhthu = tong_doanhthu + tgtcthue;
                                tong_tienthue = tong_tienthue + tgtthue;
                            }
                        });
                        $$("tong_doanhthu").setValue("<b>Tổng doanh thu hàng hóa, dịch vụ bán ra chịu thuế GTGT (*): " + fm(tong_doanhthu) + "</b>");
                        $$("tong_tienthue").setValue("<b>Tổng số thuế GTGT của hàng hóa dịch vụ bán ra (**): " + fm(tong_tienthue)) + "</b>";
                    }
                }
            },
            {
                id: "pagerA",
                view: "pager",
                size: 100,
                group: 5,
                template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}"
            },
            {
                id: "tong_doanhthu", view: "label", margin: 0, css: { "padding-left": "20px !important" },
                label: "Tổng doanh thu hàng hóa, dịch vụ bán ra chịu thuế GTGT (*): .......... "
            },
            {
                id: "tong_tienthue", view: "label", margin: 0, css: { "padding-left": "20px !important" },
                label: "Tổng số thuế GTGT của hàng hóa dịch vụ bán ra (**): .......... "
            }
        ]
    }

    var layout = {
        css: "frmView",
        id: "grdViewReport",
        rows: [
            {
                height: 39,
                type: "toolbar",
                css: "btnControl",
                borderless: true,
                cols: controls
            },
            {
                rows: [
                    grid
                ]
            }
        ]

    };

    return {
        $ui: layout,
        $oninit: function (view, $scope) {
            var load = $$("btnReload");
            load.callEvent("onClick");
            $scope.on(app, "loadBangkebanra", function (item) {
                var table = $$("bangkebanra");
                webix.extend(table, webix.ProgressBar);
                table.disable();
                table.showProgress();
                table.config.rpParameter = item;
                webix.ajax()
                    .headers({ 'Content-type': 'application/json' })
                    .post(app.config.host + "/Report68/GetDataReport", item, {
                        error: function (text, data, XmlHttpRequest) {
                            table.enable();
                            table.hideProgress();
                            alert(text);
                        },
                        success: function (text, data, XmlHttpRequest) {
                            var response = JSON.parse(text);
                            if (!response.hasOwnProperty("error")) {
                                $$("bangkebanra").clearAll();
                                $$("bangkebanra").parse(response.data);
                                var tong_doanhthu = 0;
                                var tong_tienthue = 0;
                                for (var i = 0; i < response.data.length; i++) {
                                    var item = response.data[i];
                                    if (item.khhdon != null && item.khhdon != undefined && item.khhdon != "") {
                                        var tgtthue = item.tgtthue == null || item.tgtthue == undefined || item.tgtthue == "" ? 0
                                            : item.tgtthue;
                                        var tgtcthue = item.tgtcthue == null || item.tgtcthue == undefined || item.tgtcthue == "" ? 0
                                            : item.tgtcthue;
                                        tong_doanhthu = tong_doanhthu + tgtcthue;
                                        tong_tienthue = tong_tienthue + tgtthue;
                                    }
                                }
                                $$("tong_doanhthu").setValue("<b>Tổng doanh thu hàng hóa, dịch vụ bán ra chịu thuế GTGT (*): " + fm(tong_doanhthu) + "</b>");
                                $$("tong_tienthue").setValue("<b>Tổng số thuế GTGT của hàng hóa dịch vụ bán ra (**): " + fm(tong_tienthue)) + "</b>";
                            }
                            else {
                                webix.message(response.error, "error");
                            }
                            table.enable();
                            table.hideProgress();
                        }
                    });
            });
        }
    };
});
define('views/forms/forms68/BaoCao/68_bc_chitiethoadon',[
    "app",
    "locale",
    "models/user",
    "views/forms/forms68/BaoCao/bc_component"
], function (app, _, user, component) {

    return {
        $ui: {
            view: "window",
            modal: true,
            position: "center",
            head: "Báo cáo chi tiết hóa đơn",
            width: 400,
            resize: true,
            body: {
                paddingY: 10,
                paddingX: 10,
                elementsConfig: { labelWidth: 100 },
                view: "form",
                id: "bc_chitiet_hoadon",
                complexData: true,
                margin: 0,
                elements: [
                    component.HeaderReport(),
                    component.TuNgay(),
                    component.DenNgay(),
                    component.KyHieuHD(),
                    component.TrangThaiHD(),
                    component.TrangThaiCQT(),
                    component.TinhChatHD(),
                    {
                        margin: 10,
                        cols: [
                            {},
                            {
                                shortcut: "F10", view: "button", label: "Nhận (F10)", width: 100, type: "form", align: "center",
                                on: {
                                    onClick: function () {
                                        var form = this.getParentView().getParentView();
                                        var win = this.getTopParentView();
                                        var item = form.getValues();
                                        item.skip = 0;
                                        item.take = 100;
                                        item.type_report = 1;
                                        var load_event = "loadchitiethoadon";
                                        app.callEvent(load_event, [item]);
                                        win.close();
                                    }
                                },
                                click: function () {
                                    this.callEvent("onClick");

                                }
                            },
                            {
                                view: "button", hotkey: "esc", label: "Hủy bỏ (ESC)", width: 100, align: "center", type: "danger",
                                click: function () {
                                    this.getTopParentView().close();
                                }
                            },
                            {}
                        ]
                    }
                ]
            }

        },

        setValues: function (item) {
            var win = $$(this.$ui.id);
            var form = win.getChildViews()[1];

            form.setValues(item);
        }
    };

});
define('views/68_bc_chitiethoadon',[
    "app",
    "locale",
    "models/user",
    "views/forms/forms68/BaoCao/68_bc_chitiethoadon",
    "views/modules/minvoiceplugin"
], function (app, _, user, chitiethoadon, plugin) {
    'use strict';

    function RemoveTimeT(text) {
        var format = webix.Date.dateToStr("%Y-%m-%d");
        text = removeTimeZoneT(text);
        return format(text);
    };
    var fm = webix.Number.numToStr({
        groupDelimiter: ",",
        groupSize: 3,
        decimalDelimiter: ".",
        decimalSize: 0
    });
    webix.ui.datafilter.mySummColumn = webix.extend({
        refresh: function (master, node, value) {
            var result = 0;
            master.data.each(function (obj) {
                if (obj.tchat_type != 2 && obj.tchat_type != 4)
                    result += obj[value.columnId];
            });
            node.firstChild.innerHTML = fm(result);
        }
    }, webix.ui.datafilter.summColumn);

    var controls = [
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-refresh fa-lg" aria-hidden="true"></i> ' +
                '<span class="text">' + _("REFRESH") + '</span>',
            id: "btnReload",
            on: {
                onClick: function () {
                    var wininfoparam = this.$scope.ui(chitiethoadon.$ui);
                    wininfoparam.show();
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {
            view: "button", type: "htmlbutton", width: 200,
            label: '<i class="fa fa-print fa-lg" aria-hidden="true"></i> ' +
                '<span class="text">Kết xuất báo cáo</span>',
            tooltip: 'Xem toàn bộ báo cáo, kết xuất excel, csv, pdf ...',
            id: "btnPrint",
            on: {
                onClick: function () {
                    var table = $$("chitiethoadon");
                    var rpParameter = table.config.rpParameter;
                    var page = table.getPage() + 1;
                    if (rpParameter == undefined || rpParameter == null) {
                        webix.message("Bạn chưa chọn báo cáo hoặc chưa tải dữ liệu !", "error");
                        return;
                    }
                    rpParameter.type = "PDF";
                    if (rpParameter != null) {
                        var hub = plugin.hub();
                        var hubconnect = plugin.conn();
                        var form = $$("reportChitiet");
                        webix.extend(form, webix.ProgressBar);
                        form.disable();
                        form.showProgress();

                        if (hubconnect.state != 1) {
                            form.enable();
                            form.hideProgress();
                            webix.message("Quý khách hàng chưa cài Plugin ký hóa đơn hoặc Plugin ký hóa đơn chưa được bật !", "error");
                            var box = webix.modalbox({
                                title: "Đang in báo cáo (trang " + page + ") ....",
                                text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                                width: 350,
                                height: 200
                            });

                            webix.ajax()
                                .response("arraybuffer")
                                .headers({ 'Content-type': 'application/json' })
                                .post(app.config.host + "/Report68/PrintPDFChitiethoadon", rpParameter,
                                    {
                                        error: function (text, data, XmlHttpRequest) {
                                            webix.modalbox.hide(box);
                                        },
                                        success: function (text, data, XmlHttpRequest) {
                                            var file = new Blob([data], { type: 'application/pdf' });
                                            var fileURL = URL.createObjectURL(file);
                                            webix.modalbox.hide(box);
                                            window.open(fileURL, '_blank');
                                        }
                                    }
                                );
                            return;
                        }
                        var currentLocation = window.location.origin + "/api/";
                        if (document.location.protocol == "file:") {
                            currentLocation = "http://localhost:18374/";
                        };
                        rpParameter.location = currentLocation;
                        rpParameter.cookie = user.getAppCookie();
                        rpParameter.tu_ngay = RemoveTimeT(rpParameter.tu_ngay);
                        rpParameter.den_ngay = RemoveTimeT(rpParameter.den_ngay);

                        hub.invoke('execCommand', 'BC_CHITIET', JSON.stringify(rpParameter))
                            .done(function () {
                                console.log("Run plugin success !")
                            })
                            .fail(function (error) {
                                webix.message(error, "error");
                            });
                        hub.off('resNotice');
                        hub.on('resNotice', function (result) {
                            webix.message(result, "debug", 4000);
                        });
                        hub.off('resCommand');
                        hub.on('resCommand', function (result) {
                            var response = JSON.parse(result);
                            form.enable();
                            form.hideProgress();
                            if (response.code == "00") {
                                webix.message("Đã tạo báo cáo thành công trên plugin", "success");
                            }
                            else {
                                webix.message("Code: " + response.code + " Message: " + response.message + ". Plugin xảy ra lỗi", "error");

                                var box = webix.modalbox({
                                    title: "Đang in báo cáo (trang " + page + ") ....",
                                    text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                                    width: 350,
                                    height: 200
                                });

                                webix.ajax()
                                    .response("arraybuffer")
                                    .headers({ 'Content-type': 'application/json' })
                                    .post(app.config.host + "/Report68/PrintDataReport", rpParameter,
                                        {
                                            error: function (text, data, XmlHttpRequest) {
                                                webix.modalbox.hide(box);
                                            },
                                            success: function (text, data, XmlHttpRequest) {
                                                var file = new Blob([data], { type: 'application/pdf' });
                                                var fileURL = URL.createObjectURL(file);
                                                webix.modalbox.hide(box);
                                                window.open(fileURL, '_blank');
                                            }
                                        }
                                    );
                            }
                        });
                    }
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {
            view: "button", type: "htmlbutton", width: 120,
            label: '<i class="fa fa-file-excel fa-lg" aria-hidden="true"></i> ' +
                '<span class="text">' + _("EXPORT_EXCEL") + '</span>',
            id: "btnExport",
            hidden: true,
            on: {
                onClick: function () {
                    var table = $$("chitiethoadon");
                    var rpParameter = table.config.rpParameter;
                    var page = table.getPage() + 1;
                    if (rpParameter == undefined || rpParameter == null) {
                        webix.message("Bạn chưa chọn báo cáo hoặc chưa tải dữ liệu !", "error");
                        return;
                    }
                    rpParameter.type = "xlsx";
                    if (rpParameter != null) {
                        var box = webix.modalbox({
                            title: "Đang kết xuất Excel (trang " + page + ") ....",
                            text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                            width: 350,
                            height: 200
                        });
                        webix.ajax()
                            .response("arraybuffer")
                            .headers({ 'Content-type': 'application/json' })
                            .post(app.config.host + "/Report68/PrintDataReport", rpParameter,
                                {
                                    error: function (text, data, XmlHttpRequest) {
                                        webix.modalbox.hide(box);
                                    },
                                    success: function (text, data, XmlHttpRequest) {
                                        var file = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                                        var fileURL = URL.createObjectURL(file);
                                        webix.modalbox.hide(box);
                                        webix.html.download(fileURL, "Minvoice_BC_Chitiethoadon_Page_" + page + ".xlsx");
                                    }
                                }
                            );
                    }
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        // {
        //     view: "button", type: "htmlbutton", width: 120,
        //     label: '<i class="fa fa-file-text-o fa-lg" aria-hidden="true"></i> ' +
        //         '<span class="text">' + _("EXPORT_CSV") + '</span>',
        //     id: "btnExportCsv",
        //     on: {
        //         onClick: function () {
        //             var table = $$("chitiethoadon");
        //             var rpParameter = table.config.rpParameter;
        //             var page = table.getPage() + 1;
        //             if (rpParameter == undefined || rpParameter == null) {
        //                 webix.message("Bạn chưa chọn báo cáo hoặc chưa tải dữ liệu !", "error");
        //                 return;
        //             }
        //             rpParameter.type = "CSV";
        //             if (rpParameter != null) {
        //                 var box = webix.modalbox({
        //                     title: "Đang kết xuất CSV (trang " + page + ") ....",
        //                     text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
        //                     width: 350,
        //                     height: 200
        //                 });

        //                 webix.ajax()
        //                     .response("arraybuffer")
        //                     .headers({ 'Content-type': 'application/json' })
        //                     .post(app.config.host + "/Report68/PrintPDFChitiethoadon", rpParameter,
        //                         {
        //                             error: function (text, data, XmlHttpRequest) {
        //                                 webix.modalbox.hide(box);
        //                                 webix.message(XmlHttpRequest.statusText, "error");
        //                             },
        //                             success: function (text, data, XmlHttpRequest) {
        //                                 var file = new Blob([data], { type: 'application/csv' });
        //                                 var fileURL = URL.createObjectURL(file);
        //                                 webix.html.download(fileURL, "Minvoice_BC_Chitiethoadon_Page_" + page + ".csv");
        //                                 webix.modalbox.hide(box);
        //                             }
        //                         }
        //                     );
        //             }
        //         }
        //     },
        //     click: function () {
        //         this.callEvent("onClick");
        //     }
        // },
        // {
        //     view: "button", type: "htmlbutton", width: 120,
        //     label: '<i class="fa fa-file-excel fa-lg" aria-hidden="true"></i> ' +
        //         '<span class="text">' + _("Kết xuất Excel (Nhanh)") + '</span>',
        //     id: "btnExportNew",
        //     on: {
        //         onClick: function () {
        //             var table = $$("chitiethoadon");
        //             var rpParameter = table.config.rpParameter;
        //             var page = table.getPage() + 1;
        //             if (rpParameter == undefined || rpParameter == null) {
        //                 webix.message("Bạn chưa chọn báo cáo hoặc chưa tải dữ liệu !", "error");
        //                 return;
        //             }
        //             rpParameter.type = "xlsx";
        //             if (rpParameter != null) {
        //                 var box = webix.modalbox({
        //                     title: "Đang kết xuất Excel (trang " + page + ") ....",
        //                     text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
        //                     width: 350,
        //                     height: 200
        //                 });
        //                 webix.toExcel($$("chitiethoadon"), {
        //                     filename: "Minvoice_BC_Chitiethoadon_Page_" + page
        //                 });
        //                 webix.modalbox.hide(box);
        //             }
        //         }
        //     },
        //     click: function () {
        //         this.callEvent("onClick");
        //     }
        // },
        {}
    ];
    var grid = {
        rows: [
            {
                container: "testA",
                view: "datatable",
                id: "chitiethoadon",
                select: true,
                footer: true,
                resizeColumn: true,
                fullScreen: true,
                leftSplit: 5,
                datafetch: 100,
                url: {
                    $proxy: true,
                    load: function (view, callback, params) {
                        var table = webix.$$("chitiethoadon");
                        var item = table.config.rpParameter;
                        var start = null;
                        var count = null;
                        if (params == null) {
                            start = 0;
                            count = view.config.datafetch;
                        }
                        else {
                            start = params.start;
                            count = params.count;
                        }
                        if (item != undefined) {
                            item.skip = start;
                            item.take = count;
                            var apiHost = app.config.host + "/Report68/GetDataReport";
                            table.config.rpParameter = item;
                            webix.ajax()
                                .headers({ 'Content-type': 'application/json' })
                                .bind(view)
                                .post(apiHost, item, callback, view);
                        }
                    }
                },
                on: {
                    onBeforeLoad: function () {
                        this.showOverlay("<p style='padding-top:160px;'><i style='font-size:450%;' class='fa fa-spin fa-spinner fa-pulse'></i></p>");
                    },
                    onAfterLoad: function () {
                        if (!this.count())
                            this.showOverlay("<div><img src='assets/imgs/nodata.png'><div class='showOverlaydata'>Không có dữ liệu</div></div>");
                        else
                            this.hideOverlay();
                    },
                },
                columns: [
                    { id: "khieu", header: "<center>Mẫu số ký hiệu hóa đơn</center>", width: 150 },
                    { id: "shdon", header: "<center>Số HĐ</center>", width: 150, footer: { text: "Tổng cộng", height: 22 } },
                    { id: "sdhang", header: "<center>Số đơn hàng</center>", width: 150 },
                    {
                        id: "tdlap", header: "<center>Ngày hóa đơn</center>", width: 150, format: function (text) {
                            var format = webix.Date.dateToStr("%d/%m/%Y");
                            text = removeTimeZoneT(text);
                            return format(text);
                        }
                    },
                    {
                        id: "ten_tt", header: [null, { "text": "<center>Tính chất HĐ</center>" }, { content: "selectFilter" }]
                    },
                    { id: "macqt", header: "<center>Mã cơ quan thuế</center>", width: 150 },
                    { id: "cccdan", header: "CCCD", width: 110, columnType: "nvarchar" },
                    { id: "mdvqhnsach_nmua", header: "Mã đơn vị QHNS", width: 150, columnType: "nvarchar" },
                    { id: "so_hchieu", header: "Số hộ chiếu", width: 130, columnType: "nvarchar" },
                    { id: "mnmua", header: "<center>Mã người mua</center>", width: 150 },
                    { id: "mst", header: "<center>Mã số thuế bên mua</center>", width: 150 },
                    { id: "ten", header: "<center>Tên đơn vị bên mua</center>", width: 150 },
                    { id: "tnmua", header: "<center>Tên người mua</center>", width: 150 },
                    { id: "dchi", header: "<center>Địa chỉ bên mua</center>", width: 150 },
                    { id: "htttoan", header: "<center>HTTT</center>", width: 150 },
                    { id: "dvtte", header: "<center>Ngoại tệ</center>", width: 150 },
                    { id: "tgia", header: "<center>Tỷ giá</center>", width: 150 },
                    { id: "tchat", header: "<center>Tính chất hàng hóa</center>", width: 150 },
                    { id: "maHang", header: "<center>Mã hàng hóa</center>", width: 150 },
                    { id: "tenHangHoa", header: "<center>Tên hàng hóa</center>", width: 150 },
                    { id: "mdvtinh", header: "<center>Đơn vị tính</center>", width: 150 },
                    {
                        id: "sluong", header: "<center>Số lượng</center>", width: 150, format: webix.Number.numToStr({
                            groupDelimiter: ",",
                            groupSize: 3,
                            decimalDelimiter: ".",
                            decimalSize: 0
                        }),
                        css: { "text-align": "right !important" }
                    },
                    {
                        id: "dgia", header: "<center>Đơn giá</center>", width: 150, format: webix.Number.numToStr({
                            groupDelimiter: ",",
                            groupSize: 3,
                            decimalDelimiter: ".",
                            decimalSize: 0
                        }),
                        css: { "text-align": "right !important" }
                    },
                    {
                        id: "thtien", header: "<center>Thành tiền trước thuế</center>", width: 150, format: webix.Number.numToStr({
                            groupDelimiter: ",",
                            groupSize: 3,
                            decimalDelimiter: ".",
                            decimalSize: 0
                        }),
                        footer: { content: "mySummColumn" },
                        css: { "text-align": "right !important" }
                    },
                    { id: "tlckhau", header: "<center>Tỷ lệ chiết khấu</center>", width: 150 },
                    {
                        id: "stckhau", header: "<center>Số tiền chiết khấu</center>", width: 150, format: webix.Number.numToStr({
                            groupDelimiter: ",",
                            groupSize: 3,
                            decimalDelimiter: ".",
                            decimalSize: 0
                        }),
                        footer: { content: "mySummColumn" },
                        css: { "text-align": "right !important" }
                    },
                    { id: "tsuat", header: "<center>Thuế suất</center>", width: 150 },
                    {
                        id: "tthue", header: "<center>Tiền thuế</center>", width: 150, format: webix.Number.numToStr({
                            groupDelimiter: ",",
                            groupSize: 3,
                            decimalDelimiter: ".",
                            decimalSize: 0
                        }),
                        footer: { content: "mySummColumn" },
                        css: { "text-align": "right !important" }
                    },
                    {
                        id: "tgtien", header: "<center>Tổng tiền sau thuế</center>", width: 150, format: webix.Number.numToStr({
                            groupDelimiter: ",",
                            groupSize: 3,
                            decimalDelimiter: ".",
                            decimalSize: 0
                        }),
                        footer: { content: "mySummColumn" },
                        css: { "text-align": "right !important" }
                    },
                    { id: "tthai", header: "<center>Trạng thái</center>", width: 150 },
                    { id: "tthdon", header: "<center>Trạng thái hóa đơn</center>", width: 150 }
                ],
                pager: "pagerA",
                scheme: {
                    $init: function (obj) {
                        if (obj.$group) {
                            obj.$css = 'chitiethoadon';
                        }
                    },
                    $serialize: function (obj) {

                    },
                },
                ready: function () {
                }
            },
            {
                cols: [
                    { width: 100 },
                    {
                        id: "pagerA",
                        view: "pager",
                        size: 100,
                        group: 5,
                        on: {
                            onAfterPageChange: function (id) {
                            }
                        },
                        template: function (data, common) {
                            return "Số dòng chi tiết của " + data.size + " hóa đơn là: " + data.count + ". " + common.first(data) + common.prev(data) + common.pages(data) + common.next(data) + common.last(data);
                        }
                        //template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}"
                    },
                    {
                        view: "label",
                        label: "Hiển thị chi tiết của 100 hóa đơn"
                    }
                ]
            }
        ]
    }

    var layout = {
        css: "frmView",
        id: "reportChitiet",
        rows: [
            {
                height: 39,
                type: "toolbar",
                css: "btnControl",
                borderless: true,
                cols: controls
            },
            {
                rows: [
                    grid
                ]
            }
        ]

    };

    return {
        $ui: layout,
        $oninit: function (view, $scope) {
            var load = $$("btnReload");
            load.callEvent("onClick");
            $scope.on(app, "loadChitiethoadon", function (item) {
                var table = webix.$$("chitiethoadon");
                table.config.rpParameter = item;
                table.clearAll();
                table.load(table.config.url);
            });
        }
    };
});

define('views/forms/forms68/BaoCao/68_bc_mau04',[
    "app",
    "locale",
    "models/user",
    "views/forms/forms68/BaoCao/bc_component"
], function (app, _, user, component) {

    var dataInfo;
    var gridUrl = {
        $proxy: true,
        load: function (view, callback, params) {
            var grid = $$("hoadonsaisot");
            webix.extend(grid, webix.ProgressBar);
            grid.disable();
            grid.showProgress();
            var filter = dataInfo;
            var url = app.config.host + "/Report68/GetDataReportV2";
            var start = 0;
            // var count = view.config.datafetch;
            var count  = 999999999;
            if (params != null) {
                start = params.start;
                count = params.count;
            }
           
            filter.Start = start;
            // filter.Count = count;
            filter.Count = 9999999;
            if (filter.IsSuccess == " ") delete filter.IsSuccess
            webix.ajax().headers({ "Content-type": "application/json" }).bind(view).post(url, filter, callback);
        }
    }
    return {
        $ui: {
            view: "window",
            modal: true,
            position: "center",
            head: "Báo cáo thông báo 04/SS-HDDT",
            width: 550,
            resize: true,
            body: {
                paddingY: 10,
                paddingX: 10,
                elementsConfig: { labelWidth: 150 },
                view: "form",
                id: "bc04ssForm",
                complexData: true,
                margin: 0,
                elements: [
                    component.HeaderReport(),
                    component.TuNgay(),
                    component.DenNgay(),
                    {
                        view: "combo",
                        label: "Loại thông báo",
                        name: "LoaiTBao",
                        options: [
                            { id: " ", value: "Tất cả" },
                            { id: "1", value: "Thông báo hủy/giải trình của NNT" },
                            { id: "2", value: "Thông báo hủy/giải trình của NNT theo yêu cầu của CQT" }
                        ],
                        value: "1",
                    },
                    {
                        view: "combo",
                        label: _("Trạng thái thông báo"),
                        name: "TrangThai",
                        options: [
                            { id: " ", value: "Tất cả" },
                            { id: "2", value: "Chờ ký" },
                            { id: "3", value: "Đã ký" },
                            { id: "4", value: "Đã gửi" }
                        ],
                        on: {
                            onChange: function (newv, oldv) {
                                if (newv == "2" || newv == "3") {
                                    $$("isSuccessCombo").setValue(" ");
                                    $$("isSuccessCombo").define("disabled", true);
                                } else {
                                    $$("isSuccessCombo").define("disabled", false);
                                }
                            }
                        },
                        value: "4",
                    },
                    { 
                        view:"multicombo",
                        label: "Tính chất HĐ",
                        name:"IsTthdon",
                        options: {
                            data: [
                                { id: "0", value: "Mới (Gốc)" },
                                { id: "1", value: "Hủy" },
                                { id: "2", value: "Điều chỉnh" },
                                { id: "3", value: "Thay thế" },
                                { id: "4", value: "Giải trình" },
                                { id: "5", value: "Sai sót do tổng hợp" },
                                { id: "6", value: "Bị thay thế" },
                                { id: "7", value: "Bị điều chỉnh" }
                            ], 
                            selectAll: true
                        }
                    },
                    {
                        view: "combo",
                        label: _("Trạng thái CQT"),
                        name: "IsSuccess",
                        id: "isSuccessCombo",
                        options: [
                            { id: " ", value: "Tất cả" },
                            { id: "true", value: "Chấp nhận" },
                            { id: "false", value: "Không chấp nhận" }
                        ],
                        value: "true",
                    },
                    {
                        margin: 10,
                        cols: [
                            {},
                            {
                                shortcut: "F10", view: "button", label: "Nhận (F10)", width: 100, type: "form", align: "center",
                                on: {
                                    onClick: function () {
                                        var form = this.getParentView().getParentView();
                                        if (form.validate()) {
                                            var win = this.getTopParentView();
                                            dataInfo = Object.assign({}, form.getValues());
                                            dataInfo.TypeReport = 1;
                                            var grid = $$("hoadonsaisot");
                                            grid.define("dataInfo", dataInfo);
                                            grid.define("url", gridUrl)
                                            grid.clearAll();
                                            grid.load(grid.config.url);
                                            win.close()
                                        }
                                        ;
                                    }
                                },
                                click: function () {
                                    this.callEvent("onClick");

                                }
                            },
                            {
                                view: "button", hotkey: "esc", label: "Hủy bỏ (ESC)", width: 100, align: "center", type: "danger",
                                click: function () {
                                    this.getTopParentView().close();
                                }
                            },
                            {}
                        ]
                    }
                ]
            }

        },
        setValues: function (item) {
            var win = $$(this.$ui.id);
            var form = win.getChildViews()[1];
            form.setValues(item);
        },
        dataInfo: dataInfo
    };

});
define('views/68_bc_mau04',[
    "app",
    "locale",
    "views/forms/forms68/BaoCao/68_bc_mau04"
], function (app, _, hoadonsaisot) {
    'use strict';

    var controls = [
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-refresh fa-lg" aria-hidden="true"></i> ' +
                '<span class="text">' + _("REFRESH") + '</span>',
            id: "btnReload",
            click: function () {
                var wininfoparam = this.$scope.ui(hoadonsaisot.$ui);
                wininfoparam.show();
            }
        },
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-print fa-lg" aria-hidden="true"></i> ' +
                '<span class="text">' + _("PRINT") + " PDF" + '</span>',
            id: "btnPrint",
            on: {
                onClick: function () {
                    var table = $$("hoadonsaisot");
                    var rpParameter = table.config.dataInfo;
                    if (rpParameter == undefined || rpParameter == null) {
                        webix.message("Bạn chưa chọn báo cáo hoặc chưa tải dữ liệu !", "error");
                        return;
                    }
                    rpParameter.PrintingType = "PDF";
                    var box = webix.modalbox({
                        title: "Đang in báo cáo ....",
                        text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                        width: 350,
                        height: 200
                    });

                    webix.ajax().response("arraybuffer").headers({ 'Content-type': 'application/json' }).post(app.config.host + "/Report68/PrintDataReportV2", rpParameter,
                        {
                            error: function (text, data, XmlHttpRequest) {
                                webix.modalbox.hide(box);
                                webix.message(XmlHttpRequest.statusText, "error");
                            },
                            success: function (text, data, XmlHttpRequest) {
                                var file = new Blob([data], { type: 'application/pdf' });
                                var fileURL = URL.createObjectURL(file);
                                webix.modalbox.hide(box);
                                window.open(fileURL, '_blank');
                            }
                        }
                    );
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {
            view: "button", type: "htmlbutton", width: 120,
            label: '<i class="fa fa-file-excel fa-lg" aria-hidden="true"></i> ' +
                '<span class="text">' + _("EXPORT_EXCEL") + '</span>',
            id: "btnExport",
            on: {
                onClick: function () {
                    var table = $$("hoadonsaisot");
                    var rpParameter = table.config.dataInfo;
                    if (rpParameter == undefined || rpParameter == null) {
                        webix.message("Bạn chưa chọn báo cáo hoặc chưa tải dữ liệu !", "error");
                        return;
                    }
                    rpParameter.PrintingType = "xlsx";
                    if (rpParameter != null) {
                        var box = webix.modalbox({
                            title: "Đang kết xuất Excel ....",
                            text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                            width: 350,
                            height: 200
                        });
                        webix.ajax().response("arraybuffer").headers({ 'Content-type': 'application/json' }).post(app.config.host + "/Report68/PrintDataReportV2", rpParameter,
                            {
                                error: function (text, data, XmlHttpRequest) {
                                    webix.modalbox.hide(box);
                                    webix.message(XmlHttpRequest.statusText, "error");
                                },
                                success: function (text, data, XmlHttpRequest) {
                                    var file = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                                    var fileURL = URL.createObjectURL(file);
                                    const link = document.createElement('a');
                                    link.href = fileURL;
                                    link.setAttribute('download', "BAO_CAO_04SS_HDDT.xlsx");
                                    document.body.appendChild(link);
                                    webix.modalbox.hide(box);
                                    link.click();
                                }
                            }
                        );
                    }
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {}
    ];
    var gridColumn = [
        { id: "mau04_id", header: "mau04_id", hidden: true },
        { id: "stt", header: "STT", width: 40 },
        {
            id: "trang_thai", header: ["<center>Trạng thái</center>"],
            template: function (obj) {
                var color = "2a94db";
                var valueCheck = obj.trang_thai;
                var statusName = "Chờ ký";
                switch (valueCheck) {

                    case "3":
                        color = "0069B4";
                        statusName = "Đã ký"
                        break;
                    case "4":
                        color = "2a94db";
                        statusName = "Đã gửi";
                        break;
                    case "2":
                    default:
                        color = "f47537";
                        statusName = "Chờ ký";
                        break;
                };
                return `<span style='color:#${color};font-weight: bold;'>${statusName}</span>`;
            },
            width: 100
        },
        {
            id: "is_success", header: ["Trạng thái CQT"], width: 150, css: { "text-align": "center" }, template: function (obj) {
                var response = "";
                if (obj.trang_thai == "4") {
                    switch (obj.is_success) {
                        case true:
                            response = "<span style='color: #00b300;font-weight: bold;'>Chấp nhận</span>";
                            break;
                        case false:
                            response = "<span style='color: red;font-weight: bold;'>Không chấp nhận</span>";
                            break;
                        case "":
                        case null:
                        default:
                            break;
                    };
                }
                return response;
            }
        },
        {
            id: "ntbao",
            header: ["Ngày thông báo"],
            width: 120,
            format: function (text) {
                var format = webix.Date.dateToStr("%d/%m/%Y");
                text = removeTimeZoneT(text);
                return format(text);
            },
        },
        {
            id: "ngay_gui",
            header: ["Ngày gửi"],
            width: 120,
            format: function (text) {
                var format = webix.Date.dateToStr("%d/%m/%Y %H:%i");
                text = removeTimeZoneT(text);
                return format(text);
            },
        },
        { id: "nguoi_gui", header: ["Người gửi"], width: 120 },
        { id: "khieu", header: ["Ký hiệu"], width: 120 },
        { id: "shdon", header: ["Số hóa đơn"], width: 150 },
        {
            id: "ngay",
            header: ["Ngày hóa đơn"],
            width: 120,
            format: function (text) {
                var format = webix.Date.dateToStr("%d/%m/%Y");
                text = removeTimeZoneT(text);
                return format(text);
            },
        },
        {
            id: "ladhddt", header: ["Loại hóa đơn áp dụng"], width: 150, template: function (obj) {
                switch (obj.ladhddt) {
                    case 1: return "Hóa đơn điện tử NĐ123";
                    case 2: return "Hóa đơn xác thực NĐ1209";
                    case 3: return "Hóa đơn NĐ51";
                    case 4: return "Hóa đơn giấy NĐ123";
                    default: return "";
                }
            }
        },
        {
            id: "tctbao", header: ["Tính chất thông báo"], width: 150, template: function (obj) {
                var ntbao = removeTimeZoneT(obj.ntbao);
                var date = new Date(2025, 5, 30);
                var ntbaoDate = new Date(ntbao);
                if (ntbaoDate > date) {
                    return "Thông báo";
                }
                switch (obj.tctbao) {
                    case 0: return "Mới";
                    case 1: return "Hủy";
                    case 2: return "Điều chỉnh";
                    case 3: return "Thay thế";
                    case 4: return "Giải trình";
                    case 5: return "Sai sót tổng hợp";
                    default: return "";
                }
            }
        },
        { id: "ldo", header: ["Lý do"], width: 330 },
        {
            id: "loai_tbao", header: ["Loại thông báo"], width: 150, template: function (obj) {
                switch (obj.loai_tbao) {
                    case "1": return "Thông báo của NNT";
                    case "2": return "Thông báo của NNT theo yêu cầu của CQT";
                    default: return "";
                }
            }
        },
        { id: "macqt", header: ["Mã CQT"], width: 150 },
        { id: "matdiep", header: ["Mã thông điệp"], width: 150 },


        { id: "khmsohd", header: ["Mẫu số"], width: 120 },
    ]
    var grid = {
        rows: [
            {
                container: "testA",
                view: "datatable",
                id: "hoadonsaisot",
                select: true,
                resizeColumn: true,
                fullScreen: true,
                leftSplit: 5,
                columns: gridColumn,
                pager: "hdssPager",
                on: {
                    onAfterLoad: function () {
                        this.enable();
                        this.hideProgress();
                        if (!this.count())
                            this.showOverlay("<div><img src='assets/imgs/nodata.png'><div class='showOverlaydata'>Không có dữ liệu</div></div>");
                        else
                            this.hideOverlay();
                    },
                    "data->onStoreUpdated": function () {
                        this.data.each(function (obj, i) {
                            obj.stt = i + 1;
                        });
                    },
                }
            },
            {
                id: "hdssPager",
                view: "pager",
                size: 50,
                group: 5,
                template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}"
            }
        ]
    }

    var layout = {
        css: "frmView",
        rows: [
            {
                height: 39,
                type: "toolbar",
                css: "btnControl",
                borderless: true,
                cols: controls
            },
            {
                rows: [
                    grid
                ]
            }
        ]

    };

    return {
        $ui: layout,
        $oninit: function (view, $scope) {
            $scope.ui(hoadonsaisot.$ui).show();
        }
    };
});
define('views/forms/forms68/BaoCao/68_bc_pl43qh15',[
    "app",
    "locale",
    "models/user",
    "views/forms/forms68/BaoCao/bc_component"
], function (app, _, user, component) {
 
    return {
        $ui: {
            view: "window",
            modal: true,
            move: true,
            position: "center",
            head: "Báo cáo PL101/2023/QH15",
            width: 400,
            resize: true,
            body: {
                paddingY: 10,
                paddingX: 10,
                elementsConfig: { labelWidth: 100 },
                view: "form",
                id: "reportpl43",
                complexData: true,
                margin: 0,
                elements: [
                    component.HeaderReport(),
                    component.TuNgay(),
                    component.DenNgay(),
                    component.KyHieuHD(),
                    {
                        view: "combo",
                        label: _("Trạng thái HĐ"),
                        name: "tthai",
                        options: [
                            { id: "Chờ ký", value: "Chờ ký" },
                            { id: "Đã ký", value: "Đã ký" },
                            { id: "Đã gửi", value: "Đã gửi" }
                        ]
                    },
                    {
                        view: "combo",
                        label: _("Trạng thái CQT"),
                        name: "is_success",
                        options: [
                            { id: "1", value: "Thành công" },
                            { id: "0", value: "Có lỗi" }
                        ]
                    },
                    {
                        view: "combo",
                        label: _("Loại hóa đơn"),
                        value: 1,
                        name: "loai_hd",
                        options: [
                            { id: "1", value: "Hóa đơn giá trị gia tăng" },
                            { id: "2", value: "Hóa đơn bán hàng" }
                        ]
                    },
                    {
                        view: "combo",
                        label: _("Nhóm theo"),
                        value: 2,
                        name: "nhom",
                        options: [
                            { id: "1", value: "Mã hàng" },
                            { id: "2", value: "Tên hàng" }
                        ]
                    }, {
                        view: "multicombo",
                        label: "Tính chất HĐ",
                        name: "is_tthdon",
                        options: {
                            data: [
                                { id: "0", value: "Mới (Gốc)" },
                                { id: "1", value: "Hủy" },
                                { id: "2", value: "Điều chỉnh" },
                                { id: "3", value: "Thay thế" },
                                { id: "4", value: "Giải trình" },
                                { id: "5", value: "Sai sót do tổng hợp" },
                                { id: "6", value: "Bị thay thế" },
                                { id: "7", value: "Bị điều chỉnh" }
                            ],
                            selectAll: true
                        }
                    },
                    {
                        margin: 10,
                        cols: [
                            {},
                            {
                                shortcut: "F10", view: "button", label: "Nhận (F10)", width: 100, type: "form", align: "center",
                                on: {
                                    onClick: function () {
                                        var form = this.getParentView().getParentView();
                                        var win = this.getTopParentView();
                                        var item = form.getValues();
                                        item.skip = 0;
                                        item.take = 5000;
                                        item.type_report = 4;
                                        var load_event = "loadPL43";
                                        app.callEvent(load_event, [item]);
                                        win.close();
                                    }
                                },
                                click: function () {
                                    this.callEvent("onClick");

                                }
                            },
                            {
                                view: "button", hotkey: "esc", label: "Hủy bỏ (ESC)", width: 100, align: "center", type: "danger",
                                click: function () {
                                    this.getTopParentView().close();
                                }
                            },
                            {}
                        ]
                    }
                ]
            }
        },
        setValues: function (item) {
            var win = $$(this.$ui.id);
            var form = win.getChildViews()[1];
            form.setValues(item);
        }
    };
});
define('views/68_bc_pl43qh15',[
    "app",
    "locale",
    "models/user",
    "views/forms/forms68/BaoCao/68_bc_pl43qh15"
], function (app, _, user, reportPL43Form) {
    'use strict';
    function RemoveTimeT(text) {
        var format = webix.Date.dateToStr("%Y-%m-%d");
        text = removeTimeZoneT(text);
        return format(text);
    };
    webix.$$("title").parse({ title: "Báo cáo > Báo cáo PL101/2023/QH15", details: "Báo cáo PL101/2023/QH15" });
    var controls = [
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-refresh fa-lg" aria-hidden="true"></i> ' +
                '<span class="text">' + _("REFRESH") + '</span>',
            id: "btnReload",
            on: {
                onClick: function () {
                    var form = this.$scope.ui(reportPL43Form.$ui);
                    form.show();
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-print fa-lg" aria-hidden="true"></i> ' +
                '<span class="text">' + _("PRINT") + " PDF" + '</span>',
            id: "btnPrint",
            on: {
                onClick: function () {
                    var table = $$("tblReportPL43");
                    var rpParameter = table.config.rpParameter;
                    if (rpParameter == undefined || rpParameter == null) {
                        webix.message("Bạn chưa chọn báo cáo hoặc chưa tải dữ liệu !", "error");
                        return;
                    }
                    rpParameter.type = "PDF";
                    if (rpParameter != null) {
                        var box = webix.modalbox({
                            title: "Đang in báo cáo ....",
                            text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                            width: 350,
                            height: 200
                        });

                        webix.ajax()
                            .response("arraybuffer")
                            .headers({ 'Content-type': 'application/json' })
                            .post(app.config.host + "/Report68/PrintDataReport", rpParameter,
                                {
                                    error: function (text, data, XmlHttpRequest) {
                                        webix.modalbox.hide(box);
                                        webix.message(XmlHttpRequest.statusText, "error");
                                    },
                                    success: function (text, data, XmlHttpRequest) {
                                        var file = new Blob([data], { type: 'application/pdf' });
                                        var fileURL = URL.createObjectURL(file);
                                        webix.modalbox.hide(box);
                                        window.open(fileURL, '_blank');
                                    }
                                }
                            );
                    }
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {
            view: "button", type: "htmlbutton", width: 120,
            label: '<i class="fa fa-file-excel fa-lg" aria-hidden="true"></i> ' +
                '<span class="text">' + _("EXPORT_EXCEL") + '</span>',
            id: "btnExport",
            on: {
                onClick: function () {
                    var table = $$("tblReportPL43");
                    var rpParameter = table.config.rpParameter;
                    var page = table.getPage() + 1;
                    if (rpParameter == undefined || rpParameter == null) {
                        webix.message("Bạn chưa chọn báo cáo hoặc chưa tải dữ liệu !", "error");
                        return;
                    }
                    rpParameter.type = "xlsx";
                    if (rpParameter != null) {
                        var box = webix.modalbox({
                            title: "Đang kết xuất Excel (trang " + page + ") ....",
                            text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                            width: 350,
                            height: 200
                        });

                        webix.ajax()
                            .response("arraybuffer")
                            .headers({ 'Content-type': 'application/json' })
                            .post(app.config.host + "/Report68/PrintDataReport", rpParameter,
                                {
                                    error: function (text, data, XmlHttpRequest) {
                                        webix.modalbox.hide(box);
                                        webix.message(XmlHttpRequest.statusText, "error");
                                    },
                                    success: function (text, data, XmlHttpRequest) {
                                        var file = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                                        var fileURL = URL.createObjectURL(file);
                                        webix.html.download(fileURL, "Minvoice_BC_PL101_Page_" + page + ".xlsx");
                                        webix.modalbox.hide(box);
                                        // webix.modalbox.hide(box);
                                        // window.location.href = fileURL;
                                    }
                                }
                            );
                    }
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {}
    ];

    var grid = {
        rows: [
            {
                container: "testA",
                view: "datatable",
                id: "tblReportPL43",
                select: true,
                resizeColumn: true,
                fullScreen: true,
                footer: true,
                leftSplit: 5,
                datafetch: 5000,
                url: {
                    $proxy: true,
                    load: function (view, callback, params) {
                        var table = webix.$$("tblReportPL43");
                        var item = table.config.rpParameter;
                        var start = null;
                        var count = null;
                        if (params == null) {
                            start = 0;
                            count = view.config.datafetch;
                        }
                        else {
                            start = params.start;
                            count = params.count;
                        }
                        if (item != undefined) {
                            item.skip = start;
                            item.take = count;
                            var apiHost = app.config.host + "/Report68/GetDataReport";
                            table.config.rpParameter = item;
                            webix.ajax()
                                .headers({ 'Content-type': 'application/json' })
                                .bind(view)
                                .post(apiHost, item, callback, view);
                        }
                    }
                },
                on: {
                    "data->onStoreUpdated": function () {
                        this.data.each(function (obj, i) {
                            obj.stt = i + 1;
                        });
                    },
                    onBeforeLoad: function () {
                        this.showOverlay("<p style='padding-top:160px;'><i style='font-size:450%;' class='fa fa-spin fa-spinner fa-pulse'></i></p>");
                    },
                    onAfterLoad: function () {
                        if (!this.count())
                            this.showOverlay("<div class='showOverlaydata'>Không có dữ liệu<div>");
                        else
                            this.hideOverlay();
                    },
                },
                columns: [
                    { id: "stt", header: "<center>STT</center>", width: 40 },
                    { id: "ten", header: "<center>Tên hàng hóa dịch vụ</center>", fillspace:true, footer: { text: "Tổng cộng", height: 22 } },
                    {
                        id: "tien_truoc_thue", header: "<center>Giá trị chưa có thuế</center>", width: 200, format: webix.Number.numToStr({
                            groupDelimiter: ",",
                            groupSize: 3,
                            decimalDelimiter: ".",
                            decimalSize: 0
                        }), footer: { content: "summColumn" },
                        css: { "text-align": "right !important" }
                    },
                    {
                        id: "thue_thuc_te", header: "<center>Thuế suất GTGT theo quy định</center>", width: 200, format: webix.Number.numToStr({
                            groupDelimiter: ",",
                            groupSize: 3,
                            decimalDelimiter: ".",
                            decimalSize: 0
                        }), footer: { content: "summColumn" },
                        css: { "text-align": "right !important" }
                    },
                    {
                        id: "thue_dc_giam", header: "<center>Thuế suất GTGT sau khi giảm 20 %</center>", width: 200, format: webix.Number.numToStr({
                            groupDelimiter: ",",
                            groupSize: 3,
                            decimalDelimiter: ".",
                            decimalSize: 2
                        }), footer: { content: "summColumn" },
                        css: { "text-align": "right !important" }
                    },
                    {
                        id: "tien_giam", header: "<center>Thuế GTGT được giảm</center>", width: 200, format: webix.Number.numToStr({
                            groupDelimiter: ",",
                            groupSize: 3,
                            decimalDelimiter: ".",
                            decimalSize: 0
                        }), footer: { content: "summColumn" },
                        css: { "text-align": "right !important" }
                    }
                ],
                pager: "pagerA",
                scheme: {
                    $init: function (obj) {
                        if (obj.$group) {
                            obj.$css = 'tonghophoadon';
                        }
                    },
                    $serialize: function (obj) {
                    },
                },
                ready: function () {
                }
            },
            {
                cols: [
                    { width: 100 },
                    {
                        id: "pagerA",
                        view: "pager",
                        size: 5000,
                        group: 5,
                        on: {
                            onAfterPageChange: function (id) {
                            }
                        },
                        template: function (data, common) {
                            return "Số dòng: " + data.count + ". " + common.first(data) + common.prev(data) + common.pages(data) + common.next(data) + common.last(data);
                        }
                        // template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}"
                    },
                    {
                        view: "label",
                        label: "5000 dòng/ trang"
                    }
                ]
            }
        ]
    }

    var layout = {
        css: "frmView",
        id: "reportTonghop",
        rows: [
            {
                height: 39,
                type: "toolbar",
                css: "btnControl",
                borderless: true,
                cols: controls
            },
            {
                rows: [
                    grid
                ]
            }
        ]

    };

    return {
        $ui: layout,
        $oninit: function (view, $scope) {
            if ($$("hr") == undefined && $$("hr2") == undefined) {
                $$("bodyInvoice").removeView("hr");
                $$("bodyInvoice").removeView("hr2");
            }
            var load = $$("btnReload");
            load.callEvent("onClick");
            $scope.on(app, "loadPL43", function (item) {
                var table = $$("tblReportPL43");
                table.config.rpParameter = item;
                table.clearAll();
                table.load(table.config.url);
            });
        }
    };
});
define('views/forms/forms68/BaoCao/68_bc_temvethe',[
    "app",
    "locale",
    "models/user",
    "views/forms/forms68/BaoCao/bc_component"
], function (app, _, user, component) {

    var dataInfo;
    return {
        $ui: {
            view: "window",
            modal: true,
            position: "center",
            head: "Báo cáo Tổng hợp Tem, Vé, Thẻ điện tử",
            width: 550,
            resize: true,
            body: {
                paddingY: 10,
                paddingX: 10,
                elementsConfig: { labelWidth: 150 },
                view: "form",
                id: "temVeTheBcForm",
                complexData: true,
                margin: 0,
                elements: [
                    component.HeaderReport(),
                    component.TuNgay(),
                    component.DenNgay(),
                    {
                        view: "multicombo",
                        label: _("KY_HIEU"),
                        name: "CctbaoId",
                        suggest: {
                            selectAll: true,
                            body: {
                                url: app.config.host + "/Invoice68/GetTypeInvoiceSeries?type=5",
                                //template: webix.template("#value#")
                            }
                        }
                    },
                    {
                        view: "combo",
                        label: _("Trạng thái HĐ"),
                        name: "TrangThai",
                        options: [
                            { id: " ", value: "Tất cả" },
                            { id: "Chờ ký", value: "Chờ ký" },
                            { id: "Đã ký", value: "Đã ký" },
                            { id: "Đã gửi", value: "Đã gửi" }
                        ],
                        on: {
                            onChange: function (newv, oldv) {
                                if (newv == "2" || newv == "3") {
                                    $$("isSuccessCombo").setValue(" ");
                                    $$("isSuccessCombo").define("disabled", true);
                                } else {
                                    $$("isSuccessCombo").define("disabled", false);
                                }
                            }
                        },
                    },
                    {
                        view: "multicombo",
                        label: "Tính chất HĐ",
                        name: "IsTthdon",
                        options: {
                            data: [
                                { id: "0", value: "Mới (Gốc)" },
                                { id: "1", value: "Hủy" },
                                { id: "2", value: "Điều chỉnh" },
                                { id: "3", value: "Thay thế" },
                                { id: "4", value: "Giải trình" },
                                { id: "5", value: "Sai sót do tổng hợp" },
                                { id: "6", value: "Bị thay thế" },
                                { id: "7", value: "Bị điều chỉnh" },
                            ],
                            selectAll: true
                        }
                    },
                    {
                        view: "combo",
                        label: _("Trạng thái CQT"),
                        name: "IsSuccess",
                        id: "isSuccessCombo",
                        options: [
                            { id: " ", value: "Tất cả" },
                            { id: "true", value: "Chấp nhận" },
                            { id: "false", value: "Không chấp nhận" }
                        ],
                        value: "true",
                    },
                    {
                        margin: 10,
                        cols: [
                            {},
                            {
                                shortcut: "F10", view: "button", label: "Nhận (F10)", width: 100, type: "form", align: "center",
                                on: {
                                    onClick: function () {
                                        var form = this.getParentView().getParentView();
                                        if (form.validate()) {
                                            var win = this.getTopParentView();
                                            dataInfo = Object.assign({}, form.getValues());

                                            var grid = $$("temVeTheBc");
                                            grid.config.dataInfo = dataInfo;
                                            grid.clearAll();
                                            grid.load(grid.config.url);
                                            win.close();
                                        }
                                        ;
                                    }
                                },
                                click: function () {
                                    this.callEvent("onClick");

                                }
                            },
                            {
                                view: "button", hotkey: "esc", label: "Hủy bỏ (ESC)", width: 100, align: "center", type: "danger",
                                click: function () {
                                    this.getTopParentView().close();
                                }
                            },
                            {}
                        ]
                    }
                ]
            }

        },
        setValues: function (item) {
            var win = $$(this.$ui.id);
            var form = win.getChildViews()[1];
            form.setValues(item);
        },
        dataInfo: dataInfo
    };

});

define('views/68_bc_temvethe',[
    "app",
    "locale",
    "views/forms/forms68/BaoCao/68_bc_temvethe"
], function (app, _, temVeTheBc) {
    'use strict';

    var controls = [
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-refresh fa-lg" aria-hidden="true"></i> ' +
                '<span class="text">' + _("REFRESH") + '</span>',
            id: "btnReload",
            click: function () {
                var wininfoparam = this.$scope.ui(temVeTheBc.$ui);
                wininfoparam.show();
            }
        },
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-print fa-lg" aria-hidden="true"></i> ' +
                '<span class="text">' + _("PRINT") + " PDF" + '</span>',
            id: "btnPrint",
            on: {
                onClick: function () {
                    var table = $$("temVeTheBc");
                    var rpParameter = table.config.dataInfo;
                    if (rpParameter == undefined || rpParameter == null) {
                        webix.message("Bạn chưa chọn báo cáo hoặc chưa tải dữ liệu !", "error");
                        return;
                    }
                    rpParameter.PrintingType = "PDF";
                    var box = webix.modalbox({
                        title: "Đang in báo cáo ....",
                        text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                        width: 350,
                        height: 200
                    });

                    webix.ajax().response("arraybuffer").headers({ 'Content-type': 'application/json' }).post(app.config.host + "/Report68/PrintDataReportV2", rpParameter,
                        {
                            error: function (text, data, XmlHttpRequest) {
                                webix.modalbox.hide(box);
                                webix.message(XmlHttpRequest.statusText, "error");
                            },
                            success: function (text, data, XmlHttpRequest) {
                                var file = new Blob([data], { type: 'application/pdf' });
                                var fileURL = URL.createObjectURL(file);
                                webix.modalbox.hide(box);
                                window.open(fileURL, '_blank');
                            }
                        }
                    );
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {
            view: "button", type: "htmlbutton", width: 120,
            label: '<i class="fa fa-file-excel fa-lg" aria-hidden="true"></i> ' +
                '<span class="text">' + _("EXPORT_EXCEL") + '</span>',
            id: "btnExport",
            on: {
                onClick: function () {
                    var table = $$("temVeTheBc");
                    var rpParameter = table.config.dataInfo;
                    if (rpParameter == undefined || rpParameter == null) {
                        webix.message("Bạn chưa chọn báo cáo hoặc chưa tải dữ liệu !", "error");
                        return;
                    }
                    rpParameter.PrintingType = "xlsx";
                    if (rpParameter != null) {
                        var box = webix.modalbox({
                            title: "Đang kết xuất Excel ....",
                            text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                            width: 350,
                            height: 200
                        });
                        rpParameter.Start = 0
                        rpParameter.Count = webix.storage.local.get("total_bctemvethe") || rpParameter.Count
                        webix.ajax().response("arraybuffer").headers({ 'Content-type': 'application/json' }).post(app.config.host + "/Report68/PrintDataReportV2", rpParameter,
                            {
                                error: function (text, data, XmlHttpRequest) {
                                    webix.modalbox.hide(box);
                                    webix.message(XmlHttpRequest.statusText, "error");
                                },
                                success: function (text, data, XmlHttpRequest) {
                                    var file = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                                    var fileURL = URL.createObjectURL(file);
                                    const link = document.createElement('a');
                                    link.href = fileURL;
                                    link.setAttribute('download', "BAO_CAO_TEM_VE_THE.xlsx");
                                    document.body.appendChild(link);
                                    webix.modalbox.hide(box);
                                    link.click();
                                }
                            }
                        );
                    }
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {}
    ];
    var gridColumn = [
        { id: "stt", header: "STT", width: 40 },
        {
            id: "tthai", header: ["<center>Trạng thái</center>"],
            // template: function (obj) {
            //     var color = "2a94db";
            //     var valueCheck = obj.trang_thai;
            //     var statusName = "Chờ ký";
            //     switch (valueCheck) {

            //         case "3":
            //             color = "0069B4";
            //             statusName = "Đã ký"
            //             break;
            //         case "4":
            //             color = "2a94db";
            //             statusName = "Đã gửi";
            //             break;
            //         case "2":
            //         default:
            //             color = "f47537";
            //             statusName = "Chờ ký";
            //             break;
            //     };
            //     return `<span style='color:#${color};font-weight: bold;'>${statusName}</span>`;
            // },
            width: 100
        },
        { id: "is_success", header: ["Trạng thái CQT"], width: 150, css: { "text-align": "center" }, },
        { id: "khieu", header: "Ký hiệu", width: 100 },
        {
            id: "tdlap",
            header: ["Ngày hóa đơn"],
            width: 120,
            format: function (text) {
                var format = webix.Date.dateToStr("%d/%m/%Y");
                text = removeTimeZoneT(text);
                return format(text);
            },
        },
        { id: "ten", header: ["Tên hàng"], width: 250 },
        {
            id: "sluong", header: ["Số lượng"], width: 100, format: webix.Number.numToStr({
                groupDelimiter: ",",
                groupSize: 3,
                decimalDelimiter: ".",
                decimalSize: 0
            }),
            css: { "text-align": "right !important" }
        },
        {
            id: "dgia", header: ["Đơn giá"], width: 120, format: webix.Number.numToStr({
                groupDelimiter: ",",
                groupSize: 3,
                decimalDelimiter: ".",
                decimalSize: 0
            }),
            css: { "text-align": "right !important" }
        },
        {
            id: "tgtttbso", header: ["Thành tiền"], width: 150, format: webix.Number.numToStr({
                groupDelimiter: ",",
                groupSize: 3,
                decimalDelimiter: ".",
                decimalSize: 0
            }), footer: { content: "summColumn" },
            css: { "text-align": "right !important" }
        },
        {
            id: "tgtcthue", header: ["Tiền trước thuế"], width: 150, format: webix.Number.numToStr({
                groupDelimiter: ",",
                groupSize: 3,
                decimalDelimiter: ".",
                decimalSize: 0
            }), footer: { content: "summColumn" },
            css: { "text-align": "right !important" }
        },
        {
            id: "tgtthue", header: ["Tiền thuế"], width: 150, format: webix.Number.numToStr({
                groupDelimiter: ",",
                groupSize: 3,
                decimalDelimiter: ".",
                decimalSize: 0
            }), footer: { content: "summColumn" },
            css: { "text-align": "right !important" }
        },
    ]
    var grid = {
        rows: [
            {
                container: "testA",
                view: "datatable",
                id: "temVeTheBc",
                select: true,
                resizeColumn: true,
                fullScreen: true,
                leftSplit: 5,
                footer: true,
                columns: gridColumn,
                datafetch: 50,
                pager: "temVeTheBcPager",
                url: {
                    $proxy: true,
                    load: function (view, callback, params) {
                        var grid = $$("temVeTheBc");
                        if (grid.config.dataInfo != undefined) {
                            webix.extend(grid, webix.ProgressBar);
                            grid.disable();
                            grid.showProgress();
                            var filter = grid.config.dataInfo;
                            var url = app.config.host + "/Report68/GetDataReportV2";
                            var start = 0;
                            var count = view.config.datafetch;
                            if (params != null) {
                                start = params.start;
                                count = params.count;
                            }

                            filter.Start = start;
                            filter.Count = count;
                            if (filter.IsSuccess == " ") delete filter.IsSuccess
                            webix.ajax().headers({ "Content-type": "application/json" }).bind(view).post(url, filter, callback).then((response)=>{
                                let data = response.json();
                                if (data.total_count){
                                    webix.storage.local.put("total_bctemvethe", data.total_count)
                                } 
                            });
                        }
                    }
                },
                on: {
                    onAfterLoad: function () {
                        this.enable();
                        this.hideProgress();
                        if (!this.count())
                            this.showOverlay("<div><img src='assets/imgs/nodata.png'><div class='showOverlaydata'>Không có dữ liệu</div></div>");
                        else
                            this.hideOverlay();
                    },
                    "data->onStoreUpdated": function () {
                        this.data.each(function (obj, i) {
                            obj.stt = i + 1;
                        });
                    },
                }
            },
            {
                id: "temVeTheBcPager",
                view: "pager",
                size: 50,
                group: 5,
                template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}"
            }
        ]
    }

    var layout = {
        css: "frmView",
        rows: [
            {
                height: 39,
                type: "toolbar",
                css: "btnControl",
                borderless: true,
                cols: controls
            },
            {
                rows: [
                    grid
                ]
            }
        ]

    };

    return {
        $ui: layout,
        $oninit: function (view, $scope) {
            $scope.ui(temVeTheBc.$ui).show();
        }
    };
});
define('views/forms/forms68/BaoCao/68_bc_tonghop_ct',[
    "app",
    "locale",
    "models/user",
    "views/forms/forms68/BaoCao/bc_component"
], function (app, _, user, component) {

    return {
        $ui: {
            view: "window",
            modal: true,
            position: "center",
            head: "Báo cáo tổng hợp hóa đơn",
            width: 400,
            resize: true,
            body: {
                paddingY: 10,
                paddingX: 10,
                elementsConfig: { labelWidth: 100 },
                view: "form",
                id: "bangkebr",
                complexData: true,
                margin: 0,
                elements: [
                    component.HeaderReport(),
                    component.TuNgay(),
                    component.DenNgay(),
                    {
                        view: "multicombo",
                        label: _("KY_HIEU"),
                        name: "cctbao_id",
                        suggest: {
                            selectAll: true,
                            body: {
                                url: app.config.host + "/Voucher/GetSerial",
                                //template: webix.template("#value#")
                            }
                        }
                    },
                    component.TrangThaiHD(),
                    {
                        view: "multicombo",
                        label: "Tính chất HĐ",
                        name: "is_tthdon",
                        options: {
                            data: [
                                { id: "0", value: "Mới (Gốc)" },
                                { id: "1", value: "Hủy" },
                                { id: "2", value: "Điều chỉnh" },
                                { id: "3", value: "Thay thế" },
                                { id: "4", value: "Giải trình" },
                                { id: "5", value: "Sai sót do tổng hợp" },
                                { id: "6", value: "Bị thay thế" },
                                { id: "7", value: "Bị điều chỉnh" }
                            ],
                            selectAll: true
                        }
                    },
                    {
                        margin: 10,
                        cols: [
                            {},
                            {
                                shortcut: "F10", view: "button", label: "Nhận (F10)", width: 100, type: "form", align: "center",
                                on: {
                                    onClick: function () {
                                        var form = this.getParentView().getParentView();
                                        var win = this.getTopParentView();
                                        var item = form.getValues();
                                        item.skip = 0;
                                        item.take = 5000;
                                        item.type_report = 3;
                                        var load_event = "loadtonghopchungtu";
                                        app.callEvent(load_event, [item]);
                                        win.close();
                                    }
                                },
                                click: function () {
                                    this.callEvent("onClick");

                                }
                            },
                            {
                                view: "button", hotkey: "esc", label: "Hủy bỏ (ESC)", width: 100, align: "center", type: "danger",
                                click: function () {
                                    this.getTopParentView().close();
                                }
                            },
                            {}
                        ]
                    }
                ]
            }

        },

        setValues: function (item) {
            var win = $$(this.$ui.id);
            var form = win.getChildViews()[1];

            form.setValues(item);
        }
    };

});
define('views/68_bc_tonghop_ct',[
    "app",
    "locale",
    "models/user",
    "views/forms/forms68/BaoCao/68_bc_tonghop_ct"
], function (app, _, user, tonghopchungtu) {
    'use strict';
    function RemoveTimeT(text) {
        var format = webix.Date.dateToStr("%Y-%m-%d");
        text = removeTimeZoneT(text);
        return format(text);
    };
    webix.$$("title").parse({ title: "Báo cáo > Báo cáo tổng hợp chứng từ", details: "Báo cáo tổng hợp chứng từ" });
    var controls = [
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-refresh fa-lg" aria-hidden="true"></i> ' +
                '<span class="text">' + _("REFRESH") + '</span>',
            id: "btnReload",
            on: {
                onClick: function () {
                    var wininfoparam = this.$scope.ui(tonghopchungtu.$ui);
                    wininfoparam.show();
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {
            view: "button", type: "htmlbutton", width: 200,
            label: '<i class="fa fa-print fa-lg" aria-hidden="true"></i> ' +
                '<span class="text">Xem toàn bộ báo cáo</span>',
            id: "btnPrint",
            on: {
                onClick: function () {
                    var table = $$("tonghopchungtu");
                    var rpParameter = table.config.rpParameter;
                    var page = table.getPage() + 1;
                    if (rpParameter == undefined || rpParameter == null) {
                        webix.message("Bạn chưa chọn báo cáo hoặc chưa tải dữ liệu !", "error");
                        return;
                    }
                    rpParameter.type = "PDF";
                    if (rpParameter != null) {
                        // require(["views/modules/minvoiceplugin"], function (plugin) {
                        //     var hub = plugin.hub();
                        //     var hubconnect = plugin.conn();
                        //     var form = $$("reportTonghop");
                        //     webix.extend(form, webix.ProgressBar);
                        //     form.disable();
                        //     form.showProgress();

                        //     if (hubconnect.state != 1) {
                        form.enable();
                        form.hideProgress();
                        // webix.message("Quý khách hàng chưa cài Plugin ký hóa đơn hoặc Plugin ký hóa đơn chưa được bật !", "error");
                        var box = webix.modalbox({
                            title: "Đang in báo cáo (trang " + page + ") ....",
                            text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                            width: 350,
                            height: 200
                        });

                        webix.ajax()
                            .response("arraybuffer")
                            .headers({ 'Content-type': 'application/json' })
                            .post(app.config.host + "/Report68/PrintDataReport", rpParameter,
                                {
                                    error: function (text, data, XmlHttpRequest) {
                                        webix.modalbox.hide(box);
                                        webix.message(XmlHttpRequest.statusText, "error");
                                    },
                                    success: function (text, data, XmlHttpRequest) {
                                        var file = new Blob([data], { type: 'application/pdf' });
                                        var fileURL = URL.createObjectURL(file);
                                        webix.modalbox.hide(box);
                                        window.open(fileURL, '_blank');
                                    }
                                }
                            );
                        return;
                        // }
                        //     var currentLocation = window.location.origin + "/api/";
                        //     if (document.location.protocol == "file:") {
                        //         currentLocation = "http://localhost:18374/";
                        //     };
                        //     rpParameter.location = currentLocation;
                        //     rpParameter.cookie = user.getAppCookie();
                        //     rpParameter.tu_ngay = RemoveTimeT(rpParameter.tu_ngay);
                        //     rpParameter.den_ngay = RemoveTimeT(rpParameter.den_ngay);

                        //     hub.invoke('execCommand', 'BC_TONGHOP', JSON.stringify(rpParameter))
                        //         .done(function () {
                        //             console.log("Run plugin success !")
                        //         })
                        //         .fail(function (error) {
                        //             webix.message(error, "error");
                        //         });
                        //     hub.off('resNotice');
                        //     hub.on('resNotice', function (result) {
                        //         webix.message(result, "debug", 4000);
                        //     });
                        //     hub.off('resCommand');
                        //     hub.on('resCommand', function (result) {
                        //         var response = JSON.parse(result);
                        //         form.enable();
                        //         form.hideProgress();
                        //         if (response.code == "00") {
                        //             webix.message("Đã tạo bảo cáo thành công trên plugin", "success");
                        //         }
                        //         else {
                        //             webix.message("Code: " + response.code + " Message: " + response.message + ". Plugin xảy ra lỗi", "error");
                        //             var box = webix.modalbox({
                        //                 title: "Đang in báo cáo (trang " + page + ") ....",
                        //                 text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                        //                 width: 350,
                        //                 height: 200
                        //             });

                        //             webix.ajax()
                        //                 .response("arraybuffer")
                        //                 .headers({ 'Content-type': 'application/json' })
                        //                 .post(app.config.host + "/Report68/PrintPDFtonghopchungtu", rpParameter,
                        //                     {
                        //                         error: function (text, data, XmlHttpRequest) {
                        //                             webix.modalbox.hide(box);
                        //                             webix.message(XmlHttpRequest.statusText, "error");
                        //                         },
                        //                         success: function (text, data, XmlHttpRequest) {
                        //                             var file = new Blob([data], { type: 'application/pdf' });
                        //                             var fileURL = URL.createObjectURL(file);
                        //                             webix.modalbox.hide(box);
                        //                             window.open(fileURL, '_blank');
                        //                         }
                        //                     }
                        //                 );
                        //         }
                        //     });
                        // });

                    }
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {
            view: "button", type: "htmlbutton", width: 120,
            label: '<i class="fa fa-file-excel fa-lg" aria-hidden="true"></i> ' +
                '<span class="text">' + _("EXPORT_EXCEL") + '</span>',
            id: "btnExport",
            on: {
                onClick: function () {
                    var table = $$("tonghopchungtu");
                    var rpParameter = table.config.rpParameter;
                    var page = table.getPage() + 1;
                    if (rpParameter == undefined || rpParameter == null) {
                        webix.message("Bạn chưa chọn báo cáo hoặc chưa tải dữ liệu !", "error");
                        return;
                    }
                    rpParameter.type = "xlsx";
                    if (rpParameter != null) {
                        var box = webix.modalbox({
                            title: "Đang kết xuất Excel (trang " + page + ") ....",
                            text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                            width: 350,
                            height: 200
                        });

                        webix.ajax()
                            .response("arraybuffer")
                            .headers({ 'Content-type': 'application/json' })
                            .post(app.config.host + "/Report68/PrintDataReport", rpParameter,
                                {
                                    error: function (text, data, XmlHttpRequest) {
                                        webix.modalbox.hide(box);
                                        webix.message(XmlHttpRequest.statusText, "error");
                                    },
                                    success: function (text, data, XmlHttpRequest) {
                                        var file = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                                        var fileURL = URL.createObjectURL(file);
                                        webix.html.download(fileURL, "Minvoice_BC_tonghopchungtu_Page_" + page + ".xlsx");
                                        webix.modalbox.hide(box);
                                    }
                                }
                            );
                    }
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {}
    ];

    var grid = {
        rows: [
            {
                container: "testA",
                view: "datatable",
                id: "tonghopchungtu",
                select: true,
                resizeColumn: true,
                fullScreen: true,
                footer: true,
                leftSplit: 4,
                datafetch: 5000,
                url: {
                    $proxy: true,
                    load: function (view, callback, params) {
                        var table = webix.$$("tonghopchungtu");
                        var item = table.config.rpParameter;
                        var start = null;
                        var count = null;
                        if (params == null) {
                            start = 0;
                            count = view.config.datafetch;
                        }
                        else {
                            start = params.start;
                            count = params.count;
                        }
                        if (item != undefined) {
                            item.skip = start;
                            item.take = count;
                            var apiHost = app.config.host + "/Report68/GetDataReport";
                            table.config.rpParameter = item;
                            webix.ajax()
                                .headers({ 'Content-type': 'application/json' })
                                .bind(view)
                                .post(apiHost, item, callback, view);
                        }
                    }
                },
                on: {
                    onBeforeLoad: function () {
                        this.showOverlay("<p style='padding-top:160px;'><i style='font-size:450%;' class='fa fa-spin fa-spinner fa-pulse'></i></p>");
                    },
                    onAfterLoad: function () {
                        if (!this.count())
                            this.showOverlay("<div><img src='assets/imgs/nodata.png'><div class='showOverlaydata'>Không có dữ liệu</div></div>");
                        else
                            this.hideOverlay();
                    },
                },
                columns: [
                    { id: "stt", header: "<center>STT</center>", width: 40 },
                    { id: "ky_hieu", header: "<center>Ký hiệu</center>", width: 100 },
                    {
                        id: "ngay_ct", header: "<center>Ngày chứng từ</center>", width: 150, format: function (text) {
                            var format = webix.Date.dateToStr("%d/%m/%Y");
                            text = removeTimeZoneT(text);
                            return format(text);
                        }
                    },
                    {
                        id: "ten_tt", header: [null, { "text": "<center>Tính chất</center>" }, { content: "selectFilter" }]
                    },
                    { id: "so_ct", header: "<center>Số chứng từ</center>", width: 100, footer: { text: "Tổng cộng", height: 22 } },
                    { id: "hoten_nnt", header: "<center>Tên người nộp thuế</center>", width: 220 },
                    { id: "ms_thue_nnt", header: "<center>MST TN cá nhân</center>", width: 150 },
                    { id: "so_cmnd", header: "<center>CMND/Hộ chiếu</center>", width: 150 },
                    { id: "thang", header: "<center>Tháng</center>", width: 100 },
                    { id: "nam", header: "<center>Năm</center>", width: 100 },
                    {
                        id: "khoan_dong_baohiem", header: "<center>Khoản đóng bảo hiểm bắt buộc</center>", width: 200, format: webix.Number.numToStr({
                            groupDelimiter: ",",
                            groupSize: 3,
                            decimalDelimiter: ".",
                            decimalSize: 0
                        }), footer: { content: "summColumn" },
                        css: { "text-align": "right !important" }
                    },
                    {
                        id: "thu_nhap_chiu_thue", header: "<center>Tổng thu nhập chịu thuế phải khấu trừ</center>", width: 200, format: webix.Number.numToStr({
                            groupDelimiter: ",",
                            groupSize: 3,
                            decimalDelimiter: ".",
                            decimalSize: 0
                        }), footer: { content: "summColumn" },
                        css: { "text-align": "right !important" }
                    },
                    {
                        id: "thu_nhap_tinh_thue", header: "<center>Tổng thu nhập tính thuế</center>", width: 200, format: webix.Number.numToStr({
                            groupDelimiter: ",",
                            groupSize: 3,
                            decimalDelimiter: ".",
                            decimalSize: 0
                        }), footer: { content: "summColumn" },
                        css: { "text-align": "right !important" }
                    },
                    {
                        id: "thue_khau_tru", header: "<center>Số thuế thu nhập cá nhân đã khấu trừ</center>", width: 200, format: webix.Number.numToStr({
                            groupDelimiter: ",",
                            groupSize: 3,
                            decimalDelimiter: ".",
                            decimalSize: 0
                        }), footer: { content: "summColumn" },
                        css: { "text-align": "right !important" }
                    },
                    {
                        id: "thu_nhap_dc_nhan", header: "<center>Thu nhập thực nhận</center>", width: 150, format: webix.Number.numToStr({
                            groupDelimiter: ",",
                            groupSize: 3,
                            decimalDelimiter: ".",
                            decimalSize: 0
                        }), footer: { content: "summColumn" },
                        css: { "text-align": "right !important" }
                    },
                    { id: "gia_tri", header: "<center>Trạng thái</center>", width: 150 },
                    { id: "ten_tt", header: "<center>Trạng thái CQT</center>", width: 150 },
                    { id: "user_new", header: "<center>Người lập</center>", width: 150 }
                ],
                pager: "pagerA",
                scheme: {
                    $init: function (obj) {
                        if (obj.$group) {
                            obj.$css = 'tonghopchungtu';
                        }
                    },
                    $serialize: function (obj) {
                    },
                },
                ready: function () {
                }
            },
            {
                cols: [
                    { width: 100 },
                    {
                        id: "pagerA",
                        view: "pager",
                        size: 5000,
                        group: 5,
                        on: {
                            onAfterPageChange: function (id) {
                            }
                        },
                        template: function (data, common) {
                            return "Số dòng: " + data.count + ". " + common.first(data) + common.prev(data) + common.pages(data) + common.next(data) + common.last(data);
                        }
                        // template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}"
                    },
                    {
                        view: "label",
                        label: "5000 dòng/ trang"
                    }
                ]
            }
        ]
    }

    var layout = {
        css: "frmView",
        id: "reportTonghop",
        rows: [
            {
                height: 39,
                type: "toolbar",
                css: "btnControl",
                borderless: true,
                cols: controls
            },
            {
                rows: [
                    grid
                ]
            }
        ]

    };

    return {
        $ui: layout,
        $oninit: function (view, $scope) {
            var load = $$("btnReload");
            load.callEvent("onClick");
            $scope.on(app, "loadtonghopchungtu", function (item) {
                var table = $$("tonghopchungtu");
                table.config.rpParameter = item;
                table.clearAll();
                table.load(table.config.url);
            });
        }
    };
});
define('views/forms/forms68/BaoCao/68_bc_tonghophoadon',[
    "app",
    "locale",
    "models/user",
    "views/forms/forms68/BaoCao/bc_component"
], function (app, _, user, component) {


    return {
        $ui: {
            view: "window",
            modal: true,
            position: "center",
            head: "Báo cáo tổng hợp hóa đơn",
            width: 400,
            resize: true,
            body: {
                paddingY: 10,
                paddingX: 10,
                elementsConfig: { labelWidth: 100 },
                view: "form",
                id: "bc_tonghop_hoadon",
                complexData: true,
                margin: 0,
                elements: [
                    component.HeaderReport(),
                    component.TuNgay(),
                    component.DenNgay(),
                    component.KyHieuHD(),
                    component.TrangThaiHD(),
                    component.TrangThaiCQT(),
                    component.TinhChatHD(),
                    {
                        margin: 10,
                        cols: [
                            {},
                            {
                                shortcut: "F10", view: "button", label: "Nhận (F10)", width: 100, type: "form", align: "center",
                                on: {
                                    onClick: function () {
                                        var form = this.getParentView().getParentView();//view: form
                                        var win = this.getTopParentView();//view: window
                                        var item = form.getValues();
                                        item.skip = 0;
                                        item.take = 5000;
                                        item.type_report = 2;
                                        var load_event = "loadtonghophoadon";
                                        app.callEvent(load_event, [item]);
                                        win.close();
                                    }
                                },
                                click: function () {
                                    this.callEvent("onClick");

                                }
                            },
                            {
                                view: "button", hotkey: "esc", label: "Hủy bỏ (ESC)", width: 100, align: "center", type: "danger",
                                click: function () {
                                    this.getTopParentView().close();
                                }
                            },
                            {}
                        ]
                    }
                ]
            }

        },

        setValues: function (item) {
            var win = $$(this.$ui.id);//bc_tonghop_hoadon
            var form = win.getChildViews()[1];

            form.setValues(item);//gán các giá trị thuộc tính của item tương ứng các trường trong form
        }
    };

});
define('views/68_bc_tonghophoadon',[
    "app",
    "locale",
    "models/user",
    "views/forms/forms68/BaoCao/68_bc_tonghophoadon",
    "views/modules/minvoiceplugin"
], function (app, _, user, tonghophoadon, plugin) {
    'use strict';
    function RemoveTimeT(text) {
        var format = webix.Date.dateToStr("%Y-%m-%d");
        text = removeTimeZoneT(text);
        return format(text);
    };

    var controls = [
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-refresh fa-lg" aria-hidden="true"></i> ' +
                '<span class="text">' + _("REFRESH") + '</span>',
            id: "btnReload",
            on: {
                onClick: function () {
                    var wininfoparam = this.$scope.ui(tonghophoadon.$ui);
                    wininfoparam.show();
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {
            view: "button", type: "htmlbutton", width: 200,
            label: '<i class="fa fa-print fa-lg" aria-hidden="true"></i> ' +
                '<span class="text">Xem toàn bộ báo cáo</span>',
            id: "btnPrint",
            on: {
                onClick: function () {
                    var table = $$("tonghophoadon");
                    var rpParameter = table.config.rpParameter;
                    var page = table.getPage() + 1;
                    if (rpParameter == undefined || rpParameter == null) {
                        webix.message("Bạn chưa chọn báo cáo hoặc chưa tải dữ liệu !", "error");
                        return;
                    }
                    rpParameter.type = "PDF";
                    if (rpParameter != null) {

                        var hub = plugin.hub();
                        var hubconnect = plugin.conn();
                        var form = $$("reportTonghop");
                        webix.extend(form, webix.ProgressBar);
                        form.disable();
                        form.showProgress();

                        if (hubconnect.state != 1) {
                            form.enable();
                            form.hideProgress();
                            webix.message("Quý khách hàng chưa cài Plugin ký hóa đơn hoặc Plugin ký hóa đơn chưa được bật !", "error");
                            var box = webix.modalbox({
                                title: "2Đang in báo cáo (trang " + page + ") ....",
                                text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                                width: 350,
                                height: 200
                            });

                            webix.ajax()
                                .response("arraybuffer")
                                .headers({ 'Content-type': 'application/json' })
                                .post(app.config.host + "/Report68/PrintDataReport", rpParameter,
                                    {
                                        error: function (text, data, XmlHttpRequest) {
                                            webix.modalbox.hide(box);
                                            webix.message(XmlHttpRequest.statusText, "error");
                                        },
                                        success: function (text, data, XmlHttpRequest) {
                                            var file = new Blob([data], { type: 'application/pdf' });
                                            var fileURL = URL.createObjectURL(file);
                                            webix.modalbox.hide(box);
                                            window.open(fileURL, '_blank');
                                        }
                                    }
                                );
                            return;
                        }
                        var currentLocation = window.location.origin + "/api/";
                        if (document.location.protocol == "file:") {
                            currentLocation = "http://localhost:18374/";
                        };
                        rpParameter.location = currentLocation;
                        rpParameter.cookie = user.getAppCookie();
                        rpParameter.tu_ngay = RemoveTimeT(rpParameter.tu_ngay);
                        rpParameter.den_ngay = RemoveTimeT(rpParameter.den_ngay);

                        hub.invoke('execCommand', 'BC_TONGHOP', JSON.stringify(rpParameter))
                            .done(function () {
                                console.log("Run plugin success !")
                            })
                            .fail(function (error) {
                                webix.message(error, "error");
                            });
                        hub.off('resNotice');
                        hub.on('resNotice', function (result) {
                            webix.message(result, "debug", 4000);
                        });
                        hub.off('resCommand');
                        hub.on('resCommand', function (result) {
                            var response = JSON.parse(result);
                            form.enable();
                            form.hideProgress();
                            if (response.code == "00") {
                                webix.message("Đã tạo báo cáo thành công trên plugin", "success");
                            }
                            else {
                                webix.message("Code: " + response.code + " Message: " + response.message + ". Plugin xảy ra lỗi", "error");
                                var box = webix.modalbox({
                                    title: "Đang in báo cáo (trang " + page + ") ....",
                                    text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                                    width: 350,
                                    height: 200
                                });

                                webix.ajax()
                                    .response("arraybuffer")
                                    .headers({ 'Content-type': 'application/json' })
                                    .post(app.config.host + "/Report68/PrintPDFTongHopHoaDon", rpParameter,
                                        {
                                            error: function (text, data, XmlHttpRequest) {
                                                webix.modalbox.hide(box);
                                                webix.message(XmlHttpRequest.statusText, "error");
                                            },
                                            success: function (text, data, XmlHttpRequest) {
                                                var file = new Blob([data], { type: 'application/pdf' });
                                                var fileURL = URL.createObjectURL(file);
                                                webix.modalbox.hide(box);
                                                window.open(fileURL, '_blank');
                                            }
                                        }
                                    );
                            }
                        });
                    }
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {
            view: "button", type: "htmlbutton", width: 120,
            label: '<i class="fa fa-file-excel fa-lg" aria-hidden="true"></i> ' +
                '<span class="text">' + _("EXPORT_EXCEL") + '</span>',
            id: "btnExport",
            on: {
                onClick: function () {
                    var table = $$("tonghophoadon");
                    var rpParameter = table.config.rpParameter;
                    var page = table.getPage() + 1;
                    if (rpParameter == undefined || rpParameter == null) {
                        webix.message("Bạn chưa chọn báo cáo hoặc chưa tải dữ liệu !", "error");
                        return;
                    }
                    rpParameter.type = "xlsx";
                    if (rpParameter != null) {
                        var box = webix.modalbox({
                            title: "Đang kết xuất Excel (trang " + page + ") ....",
                            text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                            width: 350,
                            height: 200
                        });

                        webix.ajax()
                            .response("arraybuffer")
                            .headers({ 'Content-type': 'application/json' })
                            .post(app.config.host + "/Report68/PrintDataReport", rpParameter,
                                {
                                    error: function (text, data, XmlHttpRequest) {
                                        webix.modalbox.hide(box);
                                        webix.message(XmlHttpRequest.statusText, "error");
                                    },
                                    success: function (text, data, XmlHttpRequest) {
                                        var file = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                                        var fileURL = URL.createObjectURL(file);
                                        webix.html.download(fileURL, "Minvoice_BC_TongHopHoaDon_Page_" + page + ".xlsx");
                                        webix.modalbox.hide(box);
                                    }
                                }
                            );
                    }
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {}
    ];

    var grid = {
        rows: [
            {
                container: "testA",
                view: "datatable",
                id: "tonghophoadon",
                select: true,
                resizeColumn: true,
                fullScreen: true,
                footer: true,
                leftSplit: 5,
                datafetch: 5000,
                url: {
                    $proxy: true,
                    load: function (view, callback, params) {
                        var table = webix.$$("tonghophoadon");
                        var item = table.config.rpParameter;
                        var start = null;
                        var count = null;
                        if (params == null) {
                            start = 0;
                            count = view.config.datafetch;
                        }
                        else {
                            start = params.start;
                            count = params.count;
                        }
                        if (item != undefined) {
                            item.skip = start;
                            item.take = count;
                            var apiHost = app.config.host + "/Report68/GetDataReport";
                            table.config.rpParameter = item;
                            webix.ajax()
                                .headers({ 'Content-type': 'application/json' })
                                .bind(view)
                                .post(apiHost, item, callback, view);
                        }
                    }
                },
                on: {
                    onBeforeLoad: function () {
                        this.showOverlay("<p style='padding-top:160px;'><i style='font-size:450%;' class='fa fa-spin fa-spinner fa-pulse'></i></p>");
                    },
                    onAfterLoad: function () {
                        if (!this.count())
                            this.showOverlay("<div><img src='assets/imgs/nodata.png'><div class='showOverlaydata'>Không có dữ liệu</div></div>");
                        else
                            this.hideOverlay();
                    },
                },
                columns: [
                    { id: "khieu", header: "<center>Mẫu số ký hiệu hóa đơn</center>", width: 150 },
                    { id: "shdon", header: "<center>Số HĐ</center>", width: 150, footer: { text: "Tổng cộng", height: 22 } },
                    { id: "sdhang", header: "<center>Số đơn hàng</center>", width: 150 },
                    {
                        id: "tdlap", header: "<center>Ngày hóa đơn</center>", width: 150, format: function (text) {
                            var format = webix.Date.dateToStr("%d/%m/%Y");
                            text = removeTimeZoneT(text);
                            return format(text);
                        }
                    },
                    {
                        id: "ten_tt", header: [null, { "text": "<center>Tính chất HĐ</center>" }, { content: "selectFilter" }]
                    },
                    { id: "macqt", header: "<center>Mã cơ quan thuế</center>", width: 150 },
                    { id: "cccdan", header: "CCCD", width: 110, columnType: "nvarchar" },
                    { id: "mdvqhnsach_nmua", header: "Mã đơn vị QHNS", width: 150, columnType: "nvarchar" },
                    { id: "so_hchieu", header: "Số hộ chiếu", width: 130, columnType: "nvarchar" },
                    { id: "mst", header: "<center>Mã số thuế bên mua</center>", width: 150 },
                    { id: "ten", header: "<center>Tên đơn vị bên mua</center>", width: 350 },
                    { id: "mnmua", header: "<center>Mã người mua</center>", width: 150 },
                    { id: "tnmua", header: "<center>Tên người mua</center>", width: 150 },
                    { id: "dchi", header: "<center>Địa chỉ</center>", width: 450 },
                    { id: "htttoan", header: "<center>HTTT</center>", width: 150 },
                    { id: "dvtte", header: "<center>Ngoại tệ</center>", width: 150 },
                    { id: "tgia", header: "<center>Tỷ giá</center>", width: 150 },
                    {
                        id: "tgtcthue", header: "<center>Tổng tiền trước thuế</center>", width: 150, format: webix.Number.numToStr({
                            groupDelimiter: ",",
                            groupSize: 3,
                            decimalDelimiter: ".",
                            decimalSize: 0
                        }), footer: { content: "summColumn" },
                        css: { "text-align": "right !important" }
                    },
                    {
                        id: "tgtthue", header: "<center>Tổng tiền thuế</center>", width: 150, format: webix.Number.numToStr({
                            groupDelimiter: ",",
                            groupSize: 3,
                            decimalDelimiter: ".",
                            decimalSize: 0
                        }), footer: { content: "summColumn" },
                        css: { "text-align": "right !important" }
                    },
                    {
                        id: "ttcktmai", header: "<center>Tổng tiền chiết khấu thương mại</center>", width: 150, format: webix.Number.numToStr({
                            groupDelimiter: ",",
                            groupSize: 3,
                            decimalDelimiter: ".",
                            decimalSize: 0
                        }), footer: { content: "summColumn" },
                        css: { "text-align": "right !important" }
                    },
                    {
                        id: "tgtttbso", header: "<center>Tổng tiền sau thuế</center>", width: 150, format: webix.Number.numToStr({
                            groupDelimiter: ",",
                            groupSize: 3,
                            decimalDelimiter: ".",
                            decimalSize: 0
                        }), footer: { content: "summColumn" },
                        css: { "text-align": "right !important" }
                    },
                    { id: "tthai", header: "<center>Trạng thái</center>", width: 150 },
                    { id: "tthdon", header: "<center>Trạng thái hóa đơn</center>", width: 150 },
                    { id: "sbmat", header: "<center>Số bảo mật</center>", width: 150 },
                    { id: "hdlk_khieu", header: [{ "text": "<center>Thông tin hóa đơn có liên quan</center>", "colspan": 3 }, { "text": "<center>Ký hiệu</center>" }] },
                    {
                        id: "hdlk_tdlap", batch:"HĐLQ", header:[null, "<center>Ngày hóa đơn</center>"], width: 150, format: function (text) {
                            var format = webix.Date.dateToStr("%d/%m/%Y");
                            text = removeTimeZoneT(text);
                            return format(text);
                        }
                    },
                    { id: "hdlk_shdon", batch:"HĐLQ", header:[null, "<center>Số HĐ</center>"], width: 100 }
                ],
                pager: "pagerA",
                scheme: {
                    $init: function (obj) {
                        if (obj.$group) {
                            obj.$css = 'tonghophoadon';
                        }
                    },
                    $serialize: function (obj) {
                    },
                },
                ready: function () {
                }
            },
            {
                cols: [
                    { width: 100 },
                    {
                        id: "pagerA",
                        view: "pager",
                        size: 5000,
                        group: 5,
                        on: {
                            onAfterPageChange: function (id) {
                            }
                        },
                        template: function (data, common) {
                            return "Số dòng: " + data.count + ". " + common.first(data) + common.prev(data) + common.pages(data) + common.next(data) + common.last(data);
                        }
                        // template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}"
                    },
                    {
                        view: "label",
                        label: "5000 dòng/ trang"
                    }
                ]
            }
        ]
    }

    var layout = {
        css: "frmView",
        id: "reportTonghop",
        rows: [
            {
                height: 39,
                type: "toolbar",
                css: "btnControl",
                borderless: true,
                cols: controls
            },
            {
                rows: [
                    grid
                ]
            }
        ]

    };

    return {
        $ui: layout,
        $oninit: function (view, $scope) {
            var load = $$("btnReload");
            load.callEvent("onClick");
            $scope.on(app, "loadtonghophoadon", function (item) {
                var table = $$("tonghophoadon");
                table.config.rpParameter = item;
                table.clearAll();
                table.load(table.config.url);
            });
        }
    };
});
define('views/forms/forms68/ChungTu/68_chungtuthueForm',[
    "app",
    "locale",
    "models/user",
    "views/modules/minvoiceplugin"
], function (app, _, user, minvoiceplugin) {
    'use strict';
    var editmode = 0;
    function uuidv4() {
        return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
            (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
        );
    }
    var thongtindonvi = {
        gravity: 2,
        view: "fieldset", label: "Thông tin đơn vị", body: {
            rows: [
                {
                    view: "text", label: "Tên đơn vị ", name: "ten_dvi", id: "ten_dvi", required: true,
                    invalidMessage: "Tên đơn vị không được để trống !",
                    css: "mcls_readonly_text",
                    validate: webix.rules.isEmpty,
                    attributes: { readonly: true }
                },
                { view: "text", label: "Mã số thuế ", css: "mcls_readonly_text", name: "ms_thue", id: "ms_thue", attributes: { readonly: true } },
                { view: "text", label: "Địa chỉ", css: "mcls_readonly_text", name: "dia_chi", id: "dia_chi", attributes: { readonly: true } },
                {
                    cols: [
                        { view: "text", css: "mcls_readonly_text", label: "Số điện thoại", id: "sdt", name: "sdt", attributes: { readonly: true } },
                        { view: "text", css: "mcls_readonly_text", label: "Nơi lập", id: "noi_lap", name: "noi_lap", attributes: { readonly: true } }
                    ]
                }
            ]
        }
    };
    var thongtinchung = {
        view: "fieldset", label: "Thông tin chung", body: {
            rows: [
                {
                    view: "text", label: "Mẫu số", name: "mau_so", id: "mau_so", required: true,
                    invalidMessage: "Mẫu số không được để trống !", css: "mcls_readonly_text",
                    validate: webix.rules.isEmpty,
                    attributes: {
                        readonly: true
                    }
                },
                {
                    view: "text", label: "Ký hiệu", name: "ky_hieu", id: "ky_hieu", required: true,
                    invalidMessage: "Ký hiệu không được để trống !", css: "mcls_readonly_text",
                    validate: webix.rules.isEmpty,
                    attributes: {
                        readonly: true
                    }
                },
                {
                    view: "datepicker", label: "Ngày chứng từ", name: "ngay_ct", id: "ngay_ct", required: true,
                    value: new Date(),
                    invalidMessage: "Ngày chứng từ không được để trống !",
                    validate: webix.rules.isEmpty,
                    attributes: {
                        readonly: true
                    }
                },
                {
                    view: "text", label: "Số chứng từ", name: "so_ct", id: "so_ct", css: "mcls_readonly_text",
                    attributes: {
                        readonly: true
                    }
                }
            ]
        }
    };
    var thongtinnguoinopthue = {
        gravity: 2,
        view: "fieldset", label: "Thông tin người nộp thuế", body: {
            rows: [
                {
                    id: "hoten_nnt", name: "hoten_nnt", label: "Họ và tên",
                    view: "search", icon: "mdi mdi-plus",
                    required: true, invalidMessage: "Tên NNT không được để trống !",
                    validate: webix.rules.isEmpty,
                    suggest: {
                        view: "gridsuggest",
                        body: {
                            columns: [
                                { "id": "dmngnopthue_id", "hidden": true, "header": "dmngnopthue_id" },
                                { "id": "ma_nnt", "width": 120, "header": "Mã NNT" },
                                { "id": "hoten", "width": 350, "header": "Tên NNT" },
                                { "id": "cmnd", "width": 150, "header": "Số CMND" }
                            ],
                            scroll: true,
                            autoheight: false,
                            datatype: "json",
                            dataFeed: function (filtervalue, filter) {
                                if (filtervalue.length < 1) return;
                                var subURL = "filter=" + encodeURIComponent(filtervalue);
                                this.load(app.config.host + "/Dmngnopthue/SearchNNT?" + subURL, this.config.datatype);
                            }
                        },
                        on: {
                            onValueSuggest: function (obj) {
                                var ngaycmnd = obj.ngaycap_cmnd;
                                var format = webix.Date.dateToStr("%Y/%m/%d");
                                ngaycmnd = removeTimeZoneT(ngaycmnd);
                                var ngay = format(ngaycmnd);

                                $$("hoten_nnt").setValue(obj.hoten);
                                $$("ms_thue_nnt").setValue(obj.mstcn);
                                $$("so_cmnd").setValue(obj.cmnd);
                                $$("noi_cap_cmnd").setValue(obj.noicap_cmnd);
                                $$("ngay_cap_cmnd").setValue(ngay);
                                $$("quoc_tich").setValue(obj.quoc_tich);
                                $$("dia_chi_nnt").setValue(obj.dia_chi);
                                $$("sdt_nnt").setValue(obj.dien_thoai);
                                $$("email_nnt").setValue(obj.email);
                                $$("nnt_cutru").setValue(obj.cu_tru);
                                $$("nnt_cutru").refresh();
                            }
                        }
                    },
                    on: {
                        onSearchIconClick: function (e) {
                            require(["views/forms/forms68/ChungTu/dmngnopthue"], function (editwindow) {
                                var win = webix.ui(editwindow.$ui);
                                win.show();
                                win.config.callback = function (obj) {
                                    var ngaycmnd = obj.ngaycap_cmnd;
                                    var format = webix.Date.dateToStr("%Y/%m/%d");
                                    ngaycmnd = removeTimeZoneT(ngaycmnd);
                                    $$("hoten_nnt").setValue(obj.hoten);
                                    $$("ms_thue_nnt").setValue(obj.mstcn);
                                    $$("so_cmnd").setValue(obj.cmnd);
                                    $$("noi_cap_cmnd").setValue(obj.noicap_cmnd);
                                    $$("ngay_cap_cmnd").setValue(format(ngaycmnd));
                                    $$("quoc_tich").setValue(obj.quoc_tich);
                                    $$("dia_chi_nnt").setValue(obj.dia_chi);
                                    $$("sdt_nnt").setValue(obj.dien_thoai);
                                    $$("email_nnt").setValue(obj.email);
                                    $$("nnt_cutru").setValue(obj.cu_tru);
                                    $$("nnt_cutru").refresh();
                                };
                            });
                        }
                    }
                },
                {
                    cols: [
                        {
                            view: "search", label: "Mã số thuế TNCN", name: "ms_thue_nnt", id: "ms_thue_nnt",
                            attributes: {
                                maxlength: 14
                            },
                            on: {
                                onChange: function (newv, oldv) {
                                    if (newv == undefined || oldv == undefined) return;
                                    if (oldv == "") return;
                                    if (newv == "") return;
                                },
                                onTimedKeyPress: function () {

                                },
                                onSearchIconClick: function (e) {
                                    $$("hoten_nnt").setValue("");
                                    $$("so_cmnd").setValue("");
                                    $$("noi_cap_cmnd").setValue("");
                                    $$("quoc_tich").setValue("");
                                    $$("dia_chi_nnt").setValue("");
                                    $$("sdt_nnt").setValue("");
                                    $$("email_nnt").setValue("");

                                    var text = this.getValue();
                                    var datapost = { "masothue": text };
                                    var table = $$("chungtuForms");
                                    webix.extend(table, webix.ProgressBar);
                                    table.disable();
                                    table.showProgress();
                                    webix.ajax()
                                        .bind(this)
                                        .headers({ 'Content-type': 'application/json' })
                                        .post(app.config.host + "/Pattern/GetInfoMST", datapost, {
                                            error: function (text, data, XmlHttpRequest) {
                                                var table = $$("chungtuForms");
                                                table.enable();
                                                table.hideProgress();
                                                this.focus();
                                            },
                                            success: function (text) {
                                                var response = JSON.parse(text);
                                                table.enable();
                                                table.hideProgress();
                                                this.focus();

                                                if (!response.hasOwnProperty("error")) {
                                                    $$("hoten_nnt").setValue(response.nguoi_dai_dien);
                                                    $$("dia_chi_nnt").setValue(response.dia_chi);
                                                    // $$("noi_cap_cmnd").setValue(response.cqthue_ql);
                                                }
                                                else {
                                                    webix.message(response.error, "error", 2000);
                                                }
                                            }
                                        });
                                }
                            }
                        },
                        {
                            view: "search", label: "Số CMND/ CCCD", name: "so_cmnd", id: "so_cmnd", attributes: {
                                maxlength: 20
                            },
                            on: {
                                onChange: function (newv, oldv) {
                                    if (newv == undefined || oldv == undefined) return;
                                    if (newv == "") return;
                                },
                                onTimedKeyPress: function () {

                                },
                                onSearchIconClick: function (e) {
                                    $$("hoten_nnt").setValue("");
                                    $$("ms_thue_nnt").setValue("");
                                    $$("noi_cap_cmnd").setValue("");
                                    $$("quoc_tich").setValue("");
                                    $$("dia_chi_nnt").setValue("");
                                    $$("sdt_nnt").setValue("");
                                    $$("email_nnt").setValue("");
                                    var text = this.getValue();
                                    var datapost = { "cid": text };
                                    var table = $$("chungtuForms");
                                    webix.extend(table, webix.ProgressBar);
                                    table.disable();
                                    table.showProgress();
                                    webix.ajax()
                                        .bind(this)
                                        .headers({ 'Content-type': 'application/json' })
                                        .post(app.config.host + "/Pattern/GetInfoCID", datapost, {
                                            error: function (text, data, XmlHttpRequest) {
                                                var table = $$("chungtuForms");
                                                table.enable();
                                                table.hideProgress();
                                                this.focus();
                                            },
                                            success: function (text) {
                                                var response = JSON.parse(text);
                                                table.enable();
                                                table.hideProgress();
                                                this.focus();

                                                if (!response.hasOwnProperty("error")) {
                                                    $$("hoten_nnt").setValue(response.ho_ten);
                                                    // $$("ngay_cap_cmnd").setValue(response.ngay_cap);
                                                    // $$("noi_cap_cmnd").setValue(response.noi_cap);
                                                    $$("ms_thue_nnt").setValue(response.mst_tncn);
                                                }
                                                else {
                                                    webix.message(response.error, "error", 2000);
                                                }
                                            }
                                        });
                                }
                            }
                        },
                    ]
                },
                {
                    cols: [
                        { view: "text", label: "Nơi cấp CMND/ CCCD", name: "noi_cap_cmnd", id: "noi_cap_cmnd", attributes: { maxlength: 100 } },
                        { view: "datepicker", label: "Ngày cấp CMND/ CCCD", name: "ngay_cap_cmnd", id: "ngay_cap_cmnd", format: webix.Date.dateToStr("%d/%m/%Y"), editable: true },
                    ]
                },
                { view: "text", label: "Địa chỉ", name: "dia_chi_nnt", id: "dia_chi_nnt" },
                {
                    cols: [
                        { view: "text", label: "Quốc tịch", name: "quoc_tich", id: "quoc_tich", attributes: { maxlength: 400 }, value: "Việt Nam" },
                        {
                            view: "radio",
                            label: "Cá nhân cư trú",
                            id: "nnt_cutru",
                            name: "nnt_cutru",
                            value: true, options: [
                                { "id": true, "value": "Có" },
                                { "id": false, "value": "Không" }
                            ]
                        }
                    ]
                },
                {
                    cols: [
                        { view: "text", label: "Số điện thoại", name: "sdt_nnt", id: "sdt_nnt", attributes: { maxlength: 20 } },
                        {
                            view: "text", label: "Email", name: "email_nnt", id: "email_nnt", attributes: { maxlength: 50 },
                            invalidMessage: "Email không hợp lệ",
                            validate: webix.rules.isEmail,
                            on: {
                                onTimedKeyPress: function () {
                                    var countMail = $$("email_nnt").getValue().split(/[\s,\;]+/);
                                    if (countMail.length > 1) {
                                        webix.message("Bạn không được phép nhập quá 1 email", "debug");
                                        return;
                                    }
                                }
                            }
                        }
                    ]
                },
                {
                    cols: [
                        {
                            view: "radio",
                            label: "Hiện nội dung quyết toán thuế TNCN thay",
                            id: "quyet_toan_thay",
                            name: "quyet_toan_thay",
                            css: "margin-top: 6px;",
                            
                            value: "K", options: [
                                { "id": "C", "value": "Có" },
                                { "id": "K", "value": "Không" }
                            ],
                            labelWidth: "260",
                            on: {
                                onChange: function(newVal) {
                                    if (newVal === "C") {
                                        $$("tai_dong_may").show();
                                        $$("tai_dong_may").define("required", true); // Đặt thuộc tính required
                                    } else {
                                        $$("tai_dong_may").hide();
                                        $$("tai_dong_may").setValue(""); // Clear the value of tai_dong_may
                                        $$("tai_dong_may").define("required", false); // Bỏ thuộc tính required
                                    }
                                   
                                }
                            }
                            
                        },
                        {
                            
                            view: "text", label: "Tại dòng mấy của PL Bảng kê 05-1/BK-TNCN:", name: "tai_dong_may", id: "tai_dong_may",
                            required: true,
                            invalidMessage: "Tại dòng mấy không được để trống !",
                            validate: webix.rules.isEmpty,
                            hidden: true, // Ẩn trường này mặc định
                            width: "415",
                            labelWidth: "280",
                            on: {
                                onKeyPress: function(code, e) {
                                    // Lấy mã phím
                                    var charCode = (e.which) ? e.which : e.keyCode;
                                    // Cho phép sử dụng phím backspace để xóa
                                    if (charCode == 8) {
                                        return true;
                                    }
                                    // Cho phép nhập các số từ bàn phím bên phải (mã phím từ 96 đến 105)
                                    if (charCode >= 96 && charCode <= 105) {
                                        return true;
                                    }
                                    // Kiểm tra xem ký tự được nhập có phải là số không
                                    if (charCode < 48 || charCode > 57) {
                                        // Nếu không phải là số, chặn sự kiện mặc định của phím
                                        if (e.preventDefault) e.preventDefault();
                                        return false;
                                    }
                                }
                            }
                        }
                    ]
                    
                }
            ]
        }
    };
    var thongtinnthueTNCN = {
        view: "fieldset", label: "Thông tin thuế TNCN khấu trừ", body: {
            rows: [
                {
                    view: "text", label: "Khoản thu nhập", id: "ten_khoan_thu", name: "ten_khoan_thu",
                    required: true, invalidMessage: "Khoản thu nhập không được để trống !", placeholder: "Điền tên khoản thu nhập",
                    validate: webix.rules.isEmpty
                },
                {
                    view: "autonumeric", label: "Khoản đóng bảo hiểm", name: "khoan_dong_baohiem", id: "khoan_dong_baohiem",
                    css: "css_numeric",
                    required: true, invalidMessage: "Khoản đóng bảo hiểm không được để trống !",
                    validate: webix.rules.isEmpty
                },
                {
                    cols: [
                        {
                            gravity: 2.2,
                            view: "multiselect", label: "Tháng/Năm", name: "thang", id: "thang",
                            options: { data: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"], selectAll: true },
                            attributes: { maxlength: 2 },
                            required: true, invalidMessage: "Tháng không được để trống !",
                            validate: webix.rules.isEmpty
                        },
                        {
                            view: "text", label: "", name: "nam",
                            id: "nam", value: new Date().getFullYear(),
                            attributes: { maxlength: 4 },
                            required: true, invalidMessage: "Năm không được để trống !",
                            validate: webix.rules.isEmpty
                        }
                    ]
                },
                {
                    view: "autonumeric", label: "Thu nhập chịu thuế", name: "thu_nhap_chiu_thue", id: "thu_nhap_chiu_thue",
                    css: "css_numeric",
                    required: true, invalidMessage: "Thu nhập chịu thuế không được để trống !",
                    validate: webix.rules.isEmpty,
                    on: {
                        "onchange": function (newv, oldv) {
                            if (newv == undefined)
                                newv = 0;
                            var thue_khau_tru = $$("thue_khau_tru").getValue();
                            var thu_nhap_dc_nhan = newv - thue_khau_tru;
                            $$("thu_nhap_dc_nhan").setValue(thu_nhap_dc_nhan);
                        }
                    }
                },
                {
                    view: "autonumeric", label: "Thu nhập tính thuế", name: "thu_nhap_tinh_thue", id: "thu_nhap_tinh_thue",
                    css: "css_numeric",
                    required: true, invalidMessage: "Thu nhập tính thuế không được để trống !",
                    validate: webix.rules.isEmpty
                },
                {
                    view: "autonumeric", label: "Số thuế khấu trừ", name: "thue_khau_tru", id: "thue_khau_tru",
                    css: "css_numeric",
                    required: true, invalidMessage: "Số thuế khấu trừ không được để trống !",
                    validate: webix.rules.isEmpty,
                    on: {
                        "onchange": function (newv, oldv) {
                            if (newv == undefined)
                                newv = 0;
                            var thu_nhap_chiu_thue = $$("thu_nhap_chiu_thue").getValue();
                            var thu_nhap_dc_nhan = thu_nhap_chiu_thue - newv;
                            $$("thu_nhap_dc_nhan").setValue(thu_nhap_dc_nhan);
                        }
                    }
                },
                {
                    view: "autonumeric", label: "Thu nhập thực nhận", name: "thu_nhap_dc_nhan", id: "thu_nhap_dc_nhan",
                    css: "css_numeric",
                }
            ]
        }
    };
    return {
        $ui: {
            view: "window",
            modal: true,
            position: "center",
            css: "headformchil",
            head: {
                height: 35,
                cols: [
                    { id: "head-icondksd", view: "template", css: "headform", width: 35, template: "" },
                    {
                        id: "head-formdksd", view: "template", css: "headform", template: function (obj) {
                            return '<div>Thêm chứng từ<div/>';
                        }
                    },
                    {
                        view: "icon", icon: "fas fa-question-circle", id: "help_dksdForms", tooltip: _("HELPER"), click: function () { }
                    }
                ]
            },
            id: "chungtuForms",
            resize: true,
            // fullscreen: true,
            width: 1300,
            height: 500,
            move: true,
            on: {
                onBeforeShow: function () {
                }
            },
            body: {
                view: "form",
                id: "chungtu",
                // width: 1500,
                position: "center",
                // autowidth:true,
                elementsConfig: { labelWidth: 150 },
                paddingY: 10,
                paddingX: 15,
                complexData: true,
                scroll: true,
                margin: 0,
                elements: [
                    { view: "text", label: "quanlykyhieu68_id", id: "quanlykyhieu68_id", name: "quanlykyhieu68_id", hidden: true },
                    {
                        cols: [
                            thongtindonvi,
                            thongtinchung
                        ]
                    },
                    {
                        cols: [
                            thongtinnguoinopthue,
                            thongtinnthueTNCN
                        ]
                    },
                    {
                        cols: [
                            {},
                            {
                                shortcut: "F10",
                                view: "button",
                                label: "Ghi (F10)",
                                id: "btnSaveChungtu",
                                width: 150,
                                align: "center",
                                type: "form",
                                on: {
                                    onClick: function () {
                                        var item = $$("chungtu").getValues();
                                        if (item.thu_nhap_tinh_thue < 0) {
                                            webix.message("Thu nhập tính thuế phải lớn hơn 0", "error");
                                            return;
                                        }
                                        if (item.thue_khau_tru < 0) {
                                            webix.message("Thuế khấu trừ phải lớn hơn 0", "error");
                                            return;
                                        }
                                        if (item.thu_nhap_chiu_thue < 0) {
                                            webix.message("Thu nhập chịu thuế phải lớn hơn 0", "error");
                                            return;
                                        }
                                        
                                        var menu_id = webix.storage.local.get("MENU_ID");
                                        item.menu_id = menu_id;
                                        var table = $$("chungtu");
                                        if (table.validate()) {

                                            webix.extend(table, webix.ProgressBar);
                                            table.disable();
                                            table.showProgress();

                                            webix.ajax()
                                                .headers({ 'Content-type': 'application/json' })
                                                .post(app.config.host + "/Voucher/SaveChange", item, {
                                                    error: function (text, data, XmlHttpRequest) {
                                                        table.enable();
                                                        table.hideProgress();
                                                        webix.message(text, "error");
                                                    }, success: function (text, data, XmlHttpRequest) {
                                                        table.enable();
                                                        table.hideProgress();
                                                        var response = JSON.parse(text);
                                                        if (response.code != "00") {
                                                            webix.message(response.message + response.data, "error");
                                                        }
                                                        else {
                                                            app.callEvent("dataChangeChungtuTNCN", [editmode, response]);
                                                            webix.message("Thành công !", "success");
                                                            webix.$$("chungtuForms").close();
                                                        }
                                                    }
                                                });
                                        }

                                    }
                                },
                                click: function () {
                                    this.callEvent("onClick");
                                }
                            },
                            {
                                view: "button",
                                hotkey: "esc",
                                label: "Hủy bỏ (ESC)",
                                width: 120,
                                type: "danger",
                                align: "center",
                                click: function () {
                                    webix.$$("chungtuForms").close();
                                }
                            },
                            {}
                        ]
                    }
                ]
            }
        },
        initUINew: function (item) {
            var form = $$("chungtu");
            var values = form.getValues();
            values["ky_hieu"] = item.khhdon;
            values["quanlykyhieu68_id"] = item.quanlykyhieu68_id;
            values["mau_so"] = item.mau_so;
            form.setValues(values);
        },
        setEditMode: function (mode) {
            editmode = mode;
            var form = $$(this.$ui.id);
            //var topParentView = form.getTopParentView();
            form.config.editmode = mode;
            var icon = "";
            if (editmode == 1) {
                icon = "<span><i class='fa fa-plus' aria-hidden='true'></i></span>";
                var result = webix.ajax().sync().get(app.config.host + "/System/GetCurrentDmdvcs");
                var dmdvcs = JSON.parse(result.response);
                $$("dia_chi").setValue(dmdvcs[0].dia_chi);
                $$("ten_dvi").setValue(dmdvcs[0].ten_dvcs);
                $$("ms_thue").setValue(dmdvcs[0].ms_thue);
                $$("sdt").setValue(dmdvcs[0].dien_thoai);
                $$("noi_lap").setValue(dmdvcs[0].tinh_thanh);
            }
            else {
                if (editmode == 2)
                    icon = "<i class='fa fa-edit' aria-hidden='true'></i>";
                else
                    icon = "<i class='fa fa-trash fa-lg' aria-hidden='true'></i>";
            }
            webix.$$("head-icondksd").setHTML(icon);
            webix.$$("head-icondksd").refresh();
        },
        setValues: function (item, winconfig, params) {
            var win = $$(this.$ui.id);
            var form = win.getChildViews()[1];

            item["ngay_ct"] = removeTimeZoneT(item["ngay_ct"]);
            item["ngay_cap_cmnd"] = removeTimeZoneT(item["ngay_cap_cmnd"]);
            form.setValues(item);
        },
        copyValues: function (item) {
            var win = $$(this.$ui.id);
            var form = win.getChildViews()[1];

            item["chungtu_tncn_id"] = "00000000-0000-0000-0000-000000000000";
            item["ngay_ct"] = new Date();
            item["so_ct"] = null;
            item["trang_thai"] = 2;
            item["tai_dong_may"] = item["tai_dong_may"] || null;
            item["quyet_toan_thay"] = item["quyet_toan_thay"] || null;
            item["ngay_ct"] = removeTimeZoneT(item["ngay_ct"]);
            item["ngay_cap_cmnd"] = removeTimeZoneT(item["ngay_cap_cmnd"]);
            form.setValues(item);
        }
    };
});
define('views/forms/forms68/ChungTu/uploadExcel',["app", "locale"], function (app, _) {
	var typeInvoice = 0;
	return {
		$ui: {
			view: "window", modal: true, id: "uploadfile-win-voucher", position: "center",
			head: "Nhận dữ liệu từ file Excel",
			width: 500,
			height: 500,
			body: {
				paddingY: 10,
				paddingX: 10,
				elementsConfig: { labelWidth: 100 },
				view: "form",
				id: "uploadfile-form-voucher",
				complexData: true,
				elements: [
					{
						cols: [
							{
								view: "toolbar",
								css: { "background": "#e6f7ff !important" },
								rows: [
									// { gravity: 2 },
									{
										view: "button", type: "icon", css: "btnExcel", icon: "fas fa-folder-open", label: "Chọn file", width: 110,
										on: {
											onClick: function () {
												webix.$$("uploader").fileDialog();
											}
										},
										click: function () {
											this.callEvent("onClick");
										}
									},
									{
										view: "button", type: "icon", css: { "background-color": "#e6f7ff !important" }, icon: "fas fa-download", label: "Tải file mẫu", width: 110,
										on: {
											onClick: function () {
												var uploader = webix.$$("uploader");
												var formData = uploader.config.formData;
												var table = $$("uploadfile-win-voucher");

												var url = app.config.host + "/Voucher/DownloadFileExcelTemplate";

												webix.extend(table, webix.ProgressBar);
												table.disable();
												table.showProgress();
												webix.ajax()
													.response("arraybuffer")
													.headers({ 'Content-type': 'application/json' })
													.get(url,
														{
															error: function (text, data, XmlHttpRequest) {
																webix.message(text + data.toString(), "error");
																table.enable();
																table.hideProgress();
															},
															success: function (text, data, XmlHttpRequest) {

																webix.delay(function () {
																	var file = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
																	var fileURL = URL.createObjectURL(file);

																	var link = document.createElement('a');
																	document.body.appendChild(link);
																	link.download = "VoucherTemplate.xlsx";
																	link.href = fileURL;
																	link.click();
																	document.body.removeChild(link); // remove the link when done
																	//document.location.href = fileURL;
																}, null, null, 500);

																table.enable();
																table.hideProgress();
															}
														}
													);
											}
										},
										click: function () {
											this.callEvent("onClick");
										}
									},
									{
										shortcut: "F10", view: "button", css: { "background": "#e6f7ff !important" }, type: "icon", icon: "fas fa-check", label: "Nhận file (F10)", width: 120, on: {
											onClick: function () {
												var table = $$("uploadfile-win-voucher");
												webix.extend(table, webix.ProgressBar);
												table.disable();
												table.showProgress();
												var file = $$("uploader").files.getFirstId();
												if (file == undefined || file == null) {
													webix.message("Bạn chưa chọn file !", "error");
													$$("uploadfile-win-voucher").enable();
													$$("uploadfile-win-voucher").hideProgress();
													return;
												}
												//webix.$$("uploader").define("formData", { type_invoice: typeInvoice });
												$$("uploader").send(function (response) {
													if (response != undefined) {
														if (response.code == "00") {
															$$("uploadfile-win-voucher").enable();
															$$("uploadfile-win-voucher").hideProgress();
															//this.callEvent("onUploadComplete");
															// success call event onUploadComplete ở trên 
															var topParentView = this.getTopParentView();
															if (topParentView.config.tableId !== undefined) {
																var table = $$(topParentView.config.tableId);
																if (table != null) {
																	table.clearAll();
																	table.load(table.config.url);
																}
															}
															webix.alert({
																title: "Thành công !",
																text: "Nhận dữ liệu Excel thành công !",
																type: "alert-warning",
																callback: function (result) {
																	webix.$$("uploadfile-win-voucher").close();
																}
															});
														}
														else {
															$$("uploadfile-win-voucher").enable();
															$$("uploadfile-win-voucher").hideProgress();

															webix.alert({
																title: "Lỗi !",
																text: response.message,
																type: "alert-error"
															});
														}
													}
													else {
														$$("uploadfile-win-voucher").enable();
														$$("uploadfile-win-voucher").hideProgress();
													}
												});
											}
										},
										click: function () {
											this.callEvent("onClick");
										}
									},
									{
										hotkey: "esc", view: "button", css: { "background": "#e6f7ff !important" }, type: "icon", icon: "fas fa-times", label: "Hủy bỏ (ESC)", width: 110,
										on: {
											onClick: function () {
												$$("mylist").clearAll();
												$$("mylist").unbind();
												var id = $$("uploader").files.getFirstId();
												if (id != undefined) {
													$$("uploader").stopUpload(id);
												}
												webix.$$("uploadfile-win-voucher").close();
											}
										},
										click: function () {
											this.callEvent("onClick");
										}
									}

								]
							},
							{
								rows: [
									{
										id: "uploader",
										view: "uploader",
										value: 'Chọn file',
										hide: true,
										name: "uploader",
										accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
										link: "mylist",
										autosend: false,
										multiple: false,
										upload: app.config.host + "/Voucher/ImportExcel",
										on: {
											onAfterRender: function () {
												this.hide();
											},
											onAfterFileAdd: function (file) {
												$$("mylist").refresh();
											},
											onUploadComplete: function (response) {

											},
											onFileUploadError: function (file, response) {
												$$("uploadfile-win-voucher").enable();
												$$("uploadfile-win-voucher").hideProgress();
											}
										},
										apiOnly: true,
									},
									{
										view: "list",
										id: "mylist",
										type: "uploader",
										height: 100,
										borderless: true
									}
								]
							}
						]
					}
				]
			}
		},
		setTypeInvoice: function (type) {
			typeInvoice = type;
		}
	};
});
define('views/forms/forms68/HDon/68_printfMultiChoice',["app", "locale"], function (app, _) {
    var fm = function (text) {
        var format = webix.Date.dateToStr("%d/%m/%Y %H:%i:%s");
        text = removeTimeZoneT(text);
        return format(text);
    };
    var array = new Array();
    var rpParameter = {
        parameter: array,
        type: "PDF"
    };
    var mimetype = "application/pdf";
    var url = app.config.host + "/Invoice68/PrintInvoiceMulti";
    var chunkSize = 9;

    function initUI(data, uri) {
        array = data;
        if (uri != undefined)
            url = uri;
    };
    function closePrint() {
        document.body.removeChild(this.__container__);
    }

    function setPrint() {
        this.contentWindow.__container__ = this;
        this.contentWindow.onbeforeunload = closePrint;
        this.contentWindow.onafterprint = closePrint;
        this.contentWindow.focus(); // Required for IE
        this.contentWindow.print();
    }

    function printPage(sURL) {
        var oHiddFrame = document.createElement("iframe");
        oHiddFrame.onload = setPrint;
        oHiddFrame.style.position = "fixed";
        oHiddFrame.style.right = "0";
        oHiddFrame.style.bottom = "0";
        oHiddFrame.style.width = "0";
        oHiddFrame.style.height = "0";
        oHiddFrame.style.border = "0";
        oHiddFrame.src = sURL;
        document.body.appendChild(oHiddFrame);
    }
    return {
        $ui: {
            view: "window",
            modal: true,
            id: "window-print",
            position: "center",
            move: true,
            padding: 30,
            css: { "border-radius": "6px" },
            // resize: true,
            // css: "headformchil",
            head: {
                height: 30,
                cols: [
                    {
                        id: "head-formDelete", view: "template", css: "headform", template: function (obj) {
                            return '<div style ="float:left; font-size:15px;"><i style="padding-right:8px;" class="fa fa-print"></i> In nhiều hóa đơn<div/>';
                        }
                    },
                    {
                        view: "icon", icon: "fas fa-times", id: "help_formDelete", tooltip: _("Đóng"), click: function () {
                            $$("window-print").close();
                        }
                    }
                ]
            },
            body: {
                paddingY: 10,
                paddingX: 10,
                view: "form",
                id: "window-formprint",
                complexData: true,
                keepViews: true,
                multiview: { keepViews: true },
                margin: 0,
                elements: [
                    {
                        view: "radio", id: "optPrint", value: "medium", options: [
                            { value: "Chất lượng hình ảnh thấp nhất", id: "lowest" },
                            { value: "Chất lượng hình ảnh thấp", id: "low" },
                            { value: "Chất lượng hình ảnh trung bình", id: "medium" },
                            { value: "Chất lượng hình ảnh cao", id: "high" },
                            { value: "Chất lượng hình ảnh cao nhất", id: "highest" }
                        ],
                        align: "center",
                        vertical: true
                    },
                    {
                        cols: [
                            { gravity: 0.3 },
                            {
                                id: "btnCoPrint",
                                view: "button",
                                label: "In",
                                type: "form",
                                align: "center",
                                on: {
                                    onClick: function () {
                                        rpParameter.opt = $$("optPrint").getValue();
                                        var printForm = $$("optionPrint").getValue();
                                        var form = webix.$$("window-print");
                                        for (let i = 0; i < array.length; i += chunkSize) {
                                            var chunk = array.slice(i, i + chunkSize);
                                            webix.extend(form, webix.ProgressBar);
                                            form.disable();
                                            form.showProgress();
                                            var paramPrint = {
                                                parameter: chunk,
                                                type: "PDF",
                                                opt: $$("optPrint").getValue(),
                                                file: printForm
                                            };
                                            var c = webix.ajax()
                                                .response("arraybuffer")
                                                .headers({ 'Content-type': 'application/json' })
                                                .post(url, paramPrint, {
                                                    error: function (text, data, XmlHttpRequest) {
                                                        form.enable();
                                                        form.hideProgress();
                                                        if ($$("window-print") != undefined)
                                                            $$("window-print").close();
                                                        alert(text);
                                                    },
                                                    success: function (text, data, XmlHttpRequest) {
                                                        form.enable();
                                                        form.hideProgress();
                                                        if ($$("window-print") != undefined)
                                                            $$("window-print").close();
                                                        var file = new Blob([data], { type: mimetype });
                                                        var fileURL = URL.createObjectURL(file);
                                                        // printPage(fileURL)

                                                        var newWin = window.open();
                                                        var html = '<html><head><title>Hóa đơn điện tử M-Invoice</title>'
                                                            + '<link rel="stylesheet" href="assets/fontawesome_pro/css/all.css" type="text/css" charset="utf-8">'
                                                            + '<link rel="stylesheet" href="assets/fontawesome.css" type="text/css" charset="utf-8">'
                                                            + '</head><body><center>Đang tải dữ liệu ... <br><p><i style="font-size:200%;" class="fa fa-spin fa-spinner"></i></p></center></body></html>';
                                                        newWin.document.write(html);
                                                        newWin.location = fileURL;
                                                        // window.print();
                                                    }
                                                });
                                            webix.promise.all([c]).then(function (results) {
                                                var response = results[0].json();
                                            });
                                            // webix.ajax()
                                            //     .response("arraybuffer")
                                            //     .headers({ 'Content-type': 'application/json' })
                                            //     .post(url, paramPrint, {
                                            //         error: function (text, data, XmlHttpRequest) {
                                            //             form.enable();
                                            //             form.hideProgress();
                                            //             if ($$("window-print") != undefined)
                                            //                 $$("window-print").close();
                                            //             alert(text);
                                            //         },
                                            //         success: function (text, data, XmlHttpRequest) {
                                            //             form.enable();
                                            //             form.hideProgress();
                                            //             if ($$("window-print") != undefined)
                                            //                 $$("window-print").close();
                                            //             var file = new Blob([data], { type: mimetype });
                                            //             var fileURL = URL.createObjectURL(file);
                                            //             var newWin = window.open();
                                            //             var html = '<html><head><title>Hóa đơn điện tử M-Invoice</title>'
                                            //                 + '<link rel="stylesheet" href="assets/fontawesome_pro/css/all.css" type="text/css" charset="utf-8">'
                                            //                 + '<link rel="stylesheet" href="assets/fontawesome.css" type="text/css" charset="utf-8">'
                                            //                 + '</head><body><center>Đang tải dữ liệu ... <br><p><i style="font-size:200%;" class="fa fa-spin fa-spinner"></i></p></center></body></html>';
                                            //             newWin.document.write(html);
                                            //             // webix.modalbox.hide(box);
                                            //             // var win = $$("windowData").$scope.ui(printf.$ui);
                                            //             // win.config.url = fileURL;
                                            //             // win.show();
                                            //             newWin.location = fileURL;
                                            //         }
                                            //     });
                                        }
                                    }
                                },
                                click: function () {
                                    $$("btnCoPrint").callEvent("onClick");
                                }
                            },
                            {
                                view: "button", id: "btnKoPrint", shortcut: "esc", label: "Thoát", type: "danger", align: "center",
                                on: {
                                    onClick: function () {
                                        $$("window-print").close();
                                    }
                                },
                                click: function () {
                                    this.callEvent("onClick");
                                }
                            },
                            { gravity: 0.3 }
                        ]
                    }

                ]
            }
        },
        initUI: initUI
    };

});
define('views/forms/forms68/68_viewsLogEmail',["app", "locale"], function (app, _) {
    var tableId = "tbl_email";
    var windowId = "email-win";
    var dataBase;
    var type = "INVOICE";
    var isRendered = false;
    return {
        $ui: {
            view: "window", modal: true, id: windowId, position: "center",
            head: "Lịch sử gửi Email", headHeight: 80,
            width: 930,
            height: 460,
            move: true,
            body: {
                paddingY: 10,
                paddingX: 10,
                view: "form",
                id: "email-form",
                complexData: true,
                margin: 0,
                elements: [
                    {
                        view: "datatable",
                        id: tableId,
                        editable: false,
                        resizeColumn: true,
                        select: true,
                        leftSplit: 5,
                        width: 880,
                        fixedRowHeight: false,
                        autowidth: true,
                        css: "table-email",
                        on: {
                            "data->onStoreUpdated": function () {
                                this.data.each(function (obj, i) {
                                    obj.stt = i + 1;
                                });
                            },
                            onItemDblClick: function (id, e, node) {
                            },
                            onBeforeRender: function () {
                                var text = ``;
                                switch (type) {
                                    case "04SS":
                                        text = `<div class="flex-1 m-2">
                                        <h5 class="mb-1" style="font-family:Arial;">Lịch sử gửi email thông báo hủy 04/SS-HDDT</h5>
                                        <p class="mb-0 font-size-14">Số hóa đơn: <span class='mb-1 font-size-14 text-primary'>${dataBase.shdon}</span>
                                        Ngày: <span class='mb-1 font-size-14 text-primary'>${formatDate(dataBase.ntbao)}</span></p>
                                        </div>`;
                                        break;
                                    case "VOUCHER":
                                        text = `<div class="flex-1 m-2">
                                            <h5 class="mb-1" style="font-family:Arial;">Lịch sử gửi Email chứng từ</h5>
                                            <p class="mb-0 font-size-14">Số chứng từ: <span class='mb-1 font-size-14 text-primary'>${dataBase.so_ct}</span> Ký hiệu: <span class='mb-1 font-size-14 text-primary'>${dataBase.ky_hieu}</span></p>
                                            </div>`;
                                        break;
                                    case "BIENBAN":
                                        text = `<div class="flex-1 m-2">
                                            <h5 class="mb-1" style="font-family:Arial;">Lịch sử gửi Email biên bản cho người mua ký</h5>
                                            </div>`;
                                        break;
                                    default:
                                        text = `<div class="flex-1 m-2">
                                            <h5 class="mb-1" style="font-family:Arial;">Lịch sử gửi Email hóa đơn</h5>
                                            <p class="mb-0 font-size-14">Số hóa đơn: <span class='mb-1 font-size-14 text-primary'>${dataBase.shdon}</span> Ký hiệu: <span class='mb-1 font-size-14 text-primary'>${dataBase.khieu}</span></p>
                                            </div>`
                                        break;
                                };
                                $$("email-win").getHead().setHTML(text);
                            },
                            onBeforeLoad: function () {
                                webix.extend(this, webix.ProgressBar);
                                this.disable();
                                this.showProgress();
                            },
                            onAfterLoad: function () {
                                this.enable();
                                this.hideProgress();
                                isRendered = true;
                            },
                            onAfterRender: function () {
                                this.adjustRowHeight("failed", true);
                                if (isRendered) {
                                    this.blockEvent();
                                    this.sort({ by: "date_send", dir: "desc" });
                                    this.unblockEvent();
                                    isRendered = false;
                                }
                            },

                            onAfterScroll: function () {
                                // Đảm bảo sau mỗi lần cuộn dữ liệu hiển thị đúng
                                this.callEvent("onAfterRender");
                            }
                        },
                        columns: [
                            { id: "stt", header: "STT", width: 40 },
                            { id: "user_send", name: "user_send", header: "Người gửi", width: 130, editor: "text" },
                            { id: "send_to", name: "send_to", header: "Email người nhận", width: 170, editor: "text" },
                            { id: "date_send", name: "date_send", header: "Ngày gửi", width: 110, editor: "date", format: function (text) { return formatDate(text); }, sort: "date" },
                            { id: "messId", name: "messId", header: "messId", width: 90, editor: "text", hidden: true },
                            {
                                id: "failed", name: "failed", header: "Trạng thái gửi", width: 330, editor: "text",
                                template: function (obj) {
                                    return  obj.failed === "OK" ? "<span style='color: #00b300'><i class='fas fa-check'></i></span> " + formatDateTime(obj.date_send) :
                                            obj.failed === null ? "<span style='color: red'><i class='fas fa-times'></i></span> Gửi lỗi" :
                                            obj.failed === "INFO" ? "<span style='color: yellow'><i class='fas fa-info-circle'></i></span>Không xác định" :
                                                "<span style='color: #00b300'><i class='fas fa-check'></i></span> " + (obj.failed || "Thành công");
                                }
                            },
                            {
                                id: "opened", name: "opened", header: "Trạng thái xem", width: 120, editor: "date", sort: "date",
                                template: function (obj) {
                                    var isNotOpen = obj.opened === "" || obj.opened === null;
                                    var color = isNotOpen ? "red" : "#00b300";
                                    var icon = isNotOpen ? "times" : "check";
                                    var text = isNotOpen ? "" : " " + formatDateTime(obj.opened);

                                    return "<div style='text-align: center; color: " + color + "'><i class='fas fa-" + icon + "'></i>" + text + "</div>";
                                }
                            },
                            // { id: "loai", name: "loai", header: "Loại gửi", width: 150, editor: "text" }
                        ],
                        pager: "pagerB",
                        ready: function () {
                            this.sort({ by: "stt", dir: "desc" });
                        },
                    },
                    {
                        id: "pagerB",
                        view: "pager",
                        size: 100,
                        group: 5,
                        template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}"
                    },
                    {
                        margin: 10,
                        cols: [
                            {},
                            {
                                view: "button", hotkey: "esc", label: "Hủy bỏ (ESC)", align: "center", width: 120, type: "danger",
                                click: function () {
                                    webix.$$("email-win").close();
                                }
                            },
                            {}
                        ]
                    }

                ]
            }
        },
        setValues: function (item) {
            dataBase = item;
            type = item.typeView;
            var table = webix.$$(tableId);
            var keyValue = item.bienban_id || item.id || item.hoadon_id || "";
            var apiHost = app.config.host + item.apiHost + keyValue;
          table.clearAll();
            table.load(apiHost);
        }
    };
});
define('views/forms/forms68/ChungTu/sendEmail',["app", "views/forms/forms68/68_viewsLogEmail", "views/modules/Component/constantManager"], function (app, viewLogEmail, CONSTANTS) {
    var item;
    return {
        $ui: {
            view: "window", move: true, resize: true,
            position: "center",
            // position: function (state) {
            //     state.width = state.maxWidth * 0.4;
            //     state.height = state.maxHeight * 0.25;
            //     state.left = (state.maxWidth - state.width) / 2;
            //     state.top = (state.maxHeight - state.height) / 2;
            // },
            modal: true,
            // head: false,
            head: "Gửi email chứng từ thuế TNCN",
            minWidth: 500,
            minHeight: 450,
            id: "sendEmailModal",
            on: {
                onShow: function () {
                }
            },
            body: {
                paddingY: 0,
                paddingX: 10,
                view: "form",
                id: "sendEmailForm",
                complexData: true,
                keepViews: true,
                multiview: { keepViews: true },
                elementsConfig: { labelWidth: 150 },
                margin: 0,
                elements: [
                    {
                        // type: "space",
                        borderless: false,
                        rows: [
                            {
                                borderless: true,
                                id: "temp_voucher",
                                onClick: {
                                    "showlogvoucher": function (ev, id) {
                                        var table = webix.$$("chungtuViews");
                                        var item = table.getSelectedItem();
                                        item.apiHost = CONSTANTS.API.VOUCHER.SEND_EMAIL_LOG;
                                        item.typeView = "VOUCHER";
                                        var detailForm = $$("sendEmailModal").$scope.ui(viewLogEmail.$ui);
                                        viewLogEmail.setValues(item);
                                        detailForm.show();
                                    }
                                },
                                template: function (obj) {
                                    return `<div class="card-body customize">
                                        <div class="p-3 bg-light mb-3">
                                            <h5 class="font-size-16 mb-0">Thông tin chứng từ <span id="num_ct" class="float-end ms-2">#</span></h5>
                                        </div>
                                        <div class="table-responsive">
                                            <table class="table table-centered mb-0 table-nowrap">
                                                <tbody>
                                                    <tr>
                                                        <td colspan="2">
                                                            <h5 class="font-size-14 m-0">Tên người nộp thuế :</h5>
                                                        </td>
                                                        <td id="ten_nnt">${obj.hoten_nnt}</td>
                                                    </tr>
                                                    <tr>
                                                        <td colspan="2">
                                                            <h5 class="font-size-14 m-0">Số CMND/ Hộ chiếu :</h5>
                                                        </td>
                                                        <td>${obj.so_cmnd}</td>
                                                    </tr>  
                                                    <tr>
                                                        <td colspan="2">
                                                            <h5 class="font-size-14 m-0">Ngày chứng từ :</h5>
                                                        </td>
                                                        <td>${formatDate(obj.ngay_ct)}</td>
                                                    </tr>
                                                    <tr>
                                                        <td colspan="2">
                                                            <h5 class="font-size-14 m-0">Số chứng từ :</h5>
                                                        </td>
                                                        <td>${obj.so_ct}</td>
                                                    </tr>                           
                                                    <tr class="bg-light">
                                                        <td colspan="2">
                                                            <h5 class="font-size-14 m-0">Thu nhập thực nhận:</h5>
                                                        </td>
                                                        <td>${formatDecimal(obj.thu_nhap_dc_nhan)}</td>
                                                    </tr>
                                                    <tr class="bg-light">
                                                        <td colspan="3">
                                                            <a href="#" class="showlogvoucher"><p class="text-primary">Chứng từ đã được gửi đi ${obj.fields2 == null ? 0 : obj.fields2} lần. <span class="mdi mdi-arrow-right-drop-circle text-danger"></span> Lịch sử gửi email</p></a>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                            
                                        </div>
                                    </div>`;
                                }
                            },
                            { height: 10 },
                            {
                                view: "text", id: "email_nnt", name: "email_nnt", labelPosition: "top", placeholder: "Mỗi email cách nhau bởi dấu ;",
                                label: "Email người nộp thuế", required: true,
                                invalidMessage: "Email không được để trống !"
                            },
                            { height: 10 },
                            {
                                margin: 10,
                                cols: [
                                    {},
                                    {
                                        shortcut: "F10", view: "button", id: "btnChuyendoi", label: "Gửi email", type: "form", align: "center", width: 120,
                                        on: {
                                            onClick: function () {
                                                var dataPost = {
                                                    id: item.id,
                                                    to: $$("email_nnt").getValue()
                                                };
                                                var table = $$("sendEmailModal");
                                                if ($$("sendEmailForm").validate()) {
                                                    webix.extend(table, webix.ProgressBar);
                                                    table.disable();
                                                    table.showProgress();
                                                    webix.ajax()
                                                        .headers({ 'Content-type': 'application/json' })
                                                        .post(app.config.host + CONSTANTS.API.VOUCHER.SEND_EMAIL, dataPost,
                                                            {
                                                                error: function (text, data, XmlHttpRequest) {
                                                                    table.enable();
                                                                    table.hideProgress();
                                                                },
                                                                success: function (text, data, XmlHttpRequest) {
                                                                    table.enable();
                                                                    table.hideProgress();
                                                                    var response = JSON.parse(text);
                                                                    if (response.code == "00") {
                                                                        $$("sendEmailModal").close();
                                                                        app.callEvent("dataChangeChungtuTNCN", [1, null]);
                                                                        webix.message(response.message, "success");
                                                                    }
                                                                    else {
                                                                        webix.message(response.message, "error");
                                                                    }
                                                                }
                                                            });
                                                }
                                            }
                                        },
                                        click: function () {
                                            this.callEvent("onClick");
                                        }
                                    },
                                    {
                                        view: "button", hotkey: "esc", label: "Đóng", width: 120, type: "danger", align: "center",
                                        click: function () {
                                            webix.$$("sendEmailModal").close();
                                        }
                                    },
                                    {}
                                ]
                            },
                            { height: 10 }
                        ]
                    }

                ]
            },
            on: {
                onShow: function () {
                    var self = this;
                    $(".webix_modal").one("click", function () {
                        self.hide();
                    });
                }
            }
        },
        InitUI: function (data) {
            item = data;
            webix.$$("sendEmailModal").getHead().setHTML("Gửi email chứng từ thuế TNCN");
            $$("sendEmailForm").setValues(data);
            $$("temp_voucher").setValues(data);
        }
    };
});
define('views/forms/forms68/ChungTu/signMultiple',["app", "locale", "models/user", "views/modules/minvoiceplugin", "views/modules/Component/constantManager"], function (app, _, user, plugin, CONSTANTS) {
    var signFormId = "frmSignVoucher";
    var layout = {
        view: "window", modal: true, resize: true, id: "chukyso-win", position: "center", move: true, css: "headformchil",
        head: {
            height: 40,
            cols: [
                { id: "head-form", view: "template", css: "headform", template: function (obj) { return '<div>Ký chứng từ chờ ký<div/>'; } },
                { view: "icon", icon: "fas fa-question-circle", id: "help_form", tooltip: _("HELPER"), click: function () { } }
            ]
        },
        minWidth: 600,
        minHeight: 600,
        on: {
            onBeforeShow: function () {

            }
        },
        body: {
            paddingY: 10,
            paddingX: 10,
            view: "form",
            id: signFormId,
            complexData: true,
            margin: 0,
            elements: [
                { view: "template", template: "Danh sách chứng từ chờ ký", type: "section" },
                {

                    view: "datatable",
                    select: "row",
                    id: "tblHoadon",
                    resizeColumn: true,
                    datafetch: 50,
                    on: {
                        "data->onStoreUpdated": function () {
                            this.data.each(function (obj, i) {
                                obj.index = i + 1;
                            })
                        }
                    },
                    columns: [
                        {
                            id: "chon1",
                            header: [{ text: "", content: "masterCheckbox" }],
                            width: 40,
                            checkValue: 'C',
                            uncheckValue: 'K',
                            template: "{common.checkbox()}"
                        },
                        { id: "index", sort: "int", header: "STT", width: 40 },
                        { id: "chungtu_tncn_id", header: "ID chứng từ", width: 250, hidden: true },
                        { id: "ky_hieu", header: "Ký hiệu" },
                        {
                            id: "ngay_ct", header: "Ngày chứng từ", width: 130, format: function (text) { return formatDate(text); }
                        },
                        { id: "so_ct", header: "Số chứng từ" },
                        {
                            id: "thu_nhap_dc_nhan", header: "Thu nhập thực nhận", width: 150, format: webix.Number.numToStr({
                                groupDelimiter: ",",
                                groupSize: 3,
                                decimalDelimiter: ".",
                                decimalSize: 0
                            })
                        }
                    ],
                    pager: "selectPagerA"
                },
                {
                    id: "selectPagerA",
                    view: "pager",
                    size: 50,
                    group: 5,
                    template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}"
                },
                {
                    margin: 10,
                    cols: [
                        {},
                        {
                            shortcut: "F9", id: "btnRefreshData", view: "button", label: "Tải dữ liệu (F9)", type: "danger", align: "center", width: 120,
                            on: {
                                onClick: function () {
                                    var form = webix.$$(signFormId);
                                    if (form.validate()) {
                                        var id = $$("kyhieu_chungtu").getValue();
                                        var apiHost = app.config.host + "/Voucher/GetVoucherSign?id=" + id;
                                        webix.extend(form, webix.ProgressBar);
                                        form.disable();
                                        form.showProgress();
                                        webix.ajax().headers({ 'Content-type': 'application/json' })
                                            .get(apiHost, function (text) {
                                                form.enable();
                                                form.hideProgress();
                                                var response = JSON.parse(text);
                                                var table = $$("tblHoadon");
                                                table.clearAll();
                                                table.parse(response);
                                            });
                                    }
                                }
                            },
                            click: function () {
                                this.callEvent("onClick");
                            }
                        },
                        {
                            shortcut: "F10", view: "button", id: "btnNhan", name: "btnNhan", width: 160, type: "form", label: "Ký (F10)", align: "center",
                            on: {
                                onClick: function () {
                                    var form = webix.$$(signFormId);
                                    var json = $$("tblHoadon").serialize();
                                    if (json.length == 0) {
                                        webix.message("Không có dữ liệu !", "error");
                                        form.enable();
                                        form.hideProgress();
                                        return;
                                    }
                                    var array = new Array();
                                    for (var i = 0; i < json.length; i++) {
                                        if (json[i]["chon1"] != null && json[i]["chon1"] == "C") {
                                            array.push(json[i].chungtu_tncn_id);
                                        }
                                    }
                                    webix.ajax()
                                        .headers({ 'Content-Type': 'application/json' })
                                        .get(CONSTANTS.API.INVOICE_GET_TYPE_SIGN, (function (text) {
                                            var result = JSON.parse(text);
                                            var kytaptrung = result[0].gia_tri;
                                            if (kytaptrung.toUpperCase() == "INTRUSTCA") {
                                                var box = webix.modalbox({
                                                    title: "Chọn chứng thư số IntrustCa",
                                                    buttons: ["Nhận", "Hủy bỏ"],
                                                    text: "<div id='ctnCerts'></div>",
                                                    top: 100,
                                                    width: 750,
                                                    callback: function (result) {
                                                        switch (result) {
                                                            case "1":
                                                                webix.modalbox.hide();
                                                                break;
                                                            case "0":
                                                                var tableCert = $$("tblCerts");
                                                                var data = tableCert.serialize();
                                                                var cert = null;
                                                                for (var i = 0; i < data.length; i++) {
                                                                    if (data[i].chon == true) {
                                                                        cert = data[i];
                                                                        break;
                                                                    }
                                                                }
                                                                if (cert == null) {
                                                                    webix.message("Bạn chưa chọn chứng thư số", "debug");
                                                                    return;
                                                                }
                                                                
                                                                var signMultiVoucherDataPost = [];
                                                                for (var i = 0; i < json.length; i++) {
                                                                    if (json[i]["chon1"] != null && json[i]["chon1"] == "C") 
                                                                        signMultiVoucherDataPost.push(json[i].chungtu_tncn_id);
                                                                }
                                                                var signModel = {
                                                                    user_name: cert.username,
                                                                    credentialID: cert.tokenSerial,
                                                                    certificate: cert.cert_content,
                                                                    pinCode: cert.pin_code,
                                                                    auth_data: cert.auth_data,
                                                                    mode: 1,
                                                                    hoadon: signMultiVoucherDataPost
                                                                }
                                                                webix.extend(form, webix.ProgressBar);
                                                                form.disable();
                                                                form.showProgress();
                                                                webix.ajax().headers({ "Content-Type": "application/json" })
                                                                    .post(app.config.host + CONSTANTS.API.SIGN.INTRUSTCA_VOUCHER, JSON.stringify(signModel),
                                                                        function (text) {
                                                                            var result = JSON.parse(text);
                                                                            if (result.code == "00") {
                                                                                var table = $$("tblHoadon");
                                                                                table.clearAll();
                                                                                $$("btnRefreshData").callEvent("onClick");
                                                                                var tableChungtu = webix.$$("chungtuViews");
                                                                                tableChungtu.load(tableChungtu.config.url);
                                                                            } else
                                                                                webix.message(result.message, "error")
                                                                        }
                                                                    );
                                                                webix.modalbox.hide();
                                                                break;
                                                        }
                                                    },
                                                });

                                                var Certs = webix.ui({
                                                    container: "ctnCerts",
                                                    id: "tblCerts",
                                                    view: "datatable",
                                                    borderless: true,
                                                    resizeColumn: true,
                                                    height: 350,
                                                    columns: [
                                                        {
                                                            id: "chon",
                                                            header: _("CHON"),
                                                            width: 65,
                                                            checkValue: true,
                                                            uncheckValue: false,
                                                            template: "{common.checkbox()}",
                                                        },
                                                        {
                                                            id: "so_serial",
                                                            header: _("SO_SERIAL"),
                                                            width: 250,
                                                        },
                                                        {
                                                            id: "subjectname",
                                                            header: _("SUBJECTNAME"),
                                                            width: 400,
                                                        },
                                                        {
                                                            id: "ngaybatdau",
                                                            header: _("NGAY_BAT_DAU"),
                                                            width: 200,
                                                        },
                                                        {
                                                            id: "ngayketthuc",
                                                            header: _("NGAY_KET_THUC"),
                                                            width: 200,
                                                        },
                                                        { id: "issuer", header: _("DONVI"), width: 450 },
                                                    ],
                                                    url: CONSTANTS.API.TOKEN_CERT_AUTO,
                                                    ready: function () {
                                                        this.data.each(function (row, index) {
                                                            row.chon = false;
                                                            if (index == 0) row.chon = true;
                                                        });
                                                        this.refresh();
                                                    },
                                                    on: {
                                                        onCheck: function (rowId, colId, isChecked) {
                                                            if (isChecked) {
                                                                this.data.each(function (row) {
                                                                    if (row.id !== rowId) {
                                                                        this.getItem(row.id).chon = false;
                                                                        this.updateItem(row.id);
                                                                    }
                                                                });
                                                            }
                                                        }
                                                    }
                                                });
                                            }
                                            else if (kytaptrung.toUpperCase() == "VNET") {
                                                var box = webix.modalbox({
                                                    title: "Chọn chứng thư số Vnet",
                                                    buttons: ["Nhận", "Hủy bỏ"],
                                                    text: "<div id='ctnCerts'></div>",
                                                    top: 100,
                                                    width: 750,
                                                    callback: function (result) {
                                                        switch (result) {
                                                            case "1":
                                                                webix.modalbox.hide();
                                                                break;
                                                            case "0":
                                                                var tableCert = $$("tblCerts");
                                                                var data = tableCert.serialize();
                                                                var cert = null;
                                                                for (var i = 0; i < data.length; i++) {
                                                                    if (data[i].chon == true) {
                                                                        cert = data[i];
                                                                        break;
                                                                    }
                                                                }
                                                                if (cert == null) {
                                                                    webix.message("Bạn chưa chọn chứng thư số", "debug");
                                                                    return;
                                                                }
                                                                var signMultiVoucherDataPost = [];
                                                                for (var i = 0; i < json.length; i++) {
                                                                    if (json[i]["chon1"] != null && json[i]["chon1"] == "C") {
                                                                        var objData = {
                                                                            chukyso_id: cert.chukyso_id,
                                                                            id: json[i].chungtu_tncn_id
                                                                        }
                                                                        signMultiVoucherDataPost.push(objData);
                                                                    }
                                                                }

                                                                webix.extend(form, webix.ProgressBar);
                                                                form.disable();
                                                                form.showProgress();
                                                                
                                                                webix.ajax().headers({ "Content-Type": "application/json", })
                                                                .post(app.config.host + "/Voucher/MultiSignByVnet", signMultiVoucherDataPost, function (text) {
                                                                    var result = JSON.parse(text);
                                                                    if (result.code != "00") {
                                                                        webix.message(result.message, "error");
                                                                        return;
                                                                    } else {
                                                                        webix.message("Ký thành công", "success");
                                                                        $$("btnRefreshData").callEvent("onClick");
                                                                    }
                                                                }
                                                                );
                                                            break;
                                                        }
                                                    },
                                                });

                                                var Certs = webix.ui({
                                                    container: "ctnCerts",
                                                    id: "tblCerts",
                                                    view: "datatable",
                                                    borderless: true,
                                                    resizeColumn: true,
                                                    height: 350,
                                                    columns: [
                                                        {
                                                            id: "chon",
                                                            header: _("CHON"),
                                                            width: 65,
                                                            checkValue: true,
                                                            uncheckValue: false,
                                                            template: "{common.checkbox()}",
                                                        },
                                                        {
                                                            id: "so_serial",
                                                            header: _("SO_SERIAL"),
                                                            width: 250,
                                                        },
                                                        {
                                                            id: "subjectname",
                                                            header: _("SUBJECTNAME"),
                                                            width: 400,
                                                        },
                                                        {
                                                            id: "ngaybatdau",
                                                            header: _("NGAY_BAT_DAU"),
                                                            width: 200,
                                                        },
                                                        {
                                                            id: "ngayketthuc",
                                                            header: _("NGAY_KET_THUC"),
                                                            width: 200,
                                                        },
                                                        { id: "issuer", header: _("DONVI"), width: 450 },
                                                    ],
                                                    url: app.config.host + "/Invoice/GetListCertificatesVnet",
                                                    ready: function () {
                                                        this.data.each(function (row, index) {
                                                            row.chon = false;
                                                            if (index == 0) row.chon = true;
                                                        });
                                                        this.refresh();
                                                    },
                                                    on: {
                                                        onCheck: function (rowId, colId, isChecked) {
                                                            if (isChecked) {
                                                                this.data.each(function (row) {
                                                                    if (row.id !== rowId) {
                                                                        this.getItem(row.id).chon = false;
                                                                        this.updateItem(row.id);
                                                                    }
                                                                });
                                                            }
                                                        }
                                                    }
                                                });
                                            }
                                            else {
                                                require(["views/modules/minvoiceplugin"], function (plugin) {
                                                    var hub = plugin.hub();
                                                    var hubconnect = plugin.conn();

                                                    var table = $$(signFormId);
                                                    webix.extend(table, webix.ProgressBar);
                                                    table.disable();
                                                    table.showProgress();

                                                    if (hubconnect.state != 1) {
                                                        table.enable();
                                                        table.hideProgress();
                                                        webix.message("Quý khách hàng chưa cài Plugin ký hóa đơn hoặc Plugin ký hóa đơn chưa được bật !", "error");
                                                        return;
                                                    }
                                                    var currentLocation = window.location.origin + "/api/";
                                                    if (document.location.protocol == "file:") {
                                                        currentLocation = "http://localhost:18374/";
                                                    }
                                                    var arg = {
                                                        signAndSend: false,
                                                        infoSign: {
                                                            tagSign: "NNT",
                                                            idData: "#data"
                                                        },
                                                        idSign: array,
                                                        cookie: user.getAppCookie(),
                                                        location: currentLocation
                                                    };
                                                    hub.invoke('execCommand', 'SignVoucher', JSON.stringify(arg))
                                                        .done(function () {
                                                            console.log("SignVoucher Success !")
                                                        })
                                                        .fail(function (error) {
                                                            webix.message(error, "error");
                                                        });
                                                    hub.off('resNotice');
                                                    hub.on('resNotice', function (result) {
                                                        webix.message(result, "debug");
                                                    });
                                                    hub.off('resCommand');
                                                    hub.on('resCommand', function (result) {
                                                        var response = JSON.parse(result);
                                                        table.enable();
                                                        table.hideProgress();
                                                        if (response.code == "00") {
                                                            app.callEvent("dataChangeChungtuTNCN", [1, null]);
                                                            var tableVoucher = $$("tblHoadon");
                                                            tableVoucher.clearAll();
                                                            webix.message("Ký thành công", "success");
                                                        }
                                                        else {
                                                            webix.message("Code: " + response.code + " Message: " + response.message, "error");
                                                        }
                                                    });
                                                });
                                            }
                                        }));
                                }
                            },
                            click: function () {
                                this.callEvent("onClick");
                            }
                        },

                        {
                            view: "button", hotkey: "esc", label: "Hủy bỏ (ESC)", type: "danger", align: "center", width: 100,
                            click: function () {
                                webix.$$("chukyso-win").close();
                            }
                        },
                        {}
                    ]
                }
            ]
        }
    };
    return {
        $ui: layout
    };
});
define('views/forms/forms68/ChungTu/modalPrint',["app", "locale"], function (app, _) {
    'use strict';

    var formId = "frm-print-voucher";
    var frameId = "frame-voucher";
    var item;
    var fileURL;
    var fileBlob;
    function initUI(data, urlBlob, dataBlob) {
        item = data;
        fileURL = urlBlob;
        fileBlob = dataBlob;
    };

    return {
        $ui: {
            view: "window",
            move: true,
            position: "center",
            id: formId,
            modal: true,
            resize: true,
            // borderless: false,
            // fullscreen: true,
            position: function (state) {
                state.width = state.maxWidth * 0.5;
                state.height = state.maxHeight * 0.9;
                state.left = (state.maxWidth - state.width) / 2;
                state.top = (state.maxHeight - state.height) / 2;
            },
            css: { "border-radius": "4px 4px 0px 0px", "border-bottom": "none !important" },
            head: {
                height: 35,
                cols: [
                    {
                        view: "button", width: 110, type: "icon", icon: "mdi mdi-download", label: "Tải PDF",
                        on: {
                            onClick: function () {
                                var link = document.createElement('a');
                                link.href = fileURL;
                                link.download = item.ms_thue + "_" + item.ky_hieu.replace(/\//g, "",) + "_" + item.so_ct + "_" + item.hoten_nnt + ".pdf";
                                document.body.appendChild(link);
                                link.click();
                                document.body.removeChild(link);
                            }
                        },
                        click: function () {
                            this.callEvent("onClick");
                        },
                    },
                    {
                        view: "button", width: 110, type: "icon", icon: "mdi mdi-printer", label: "In chứng từ",
                        on: {
                            onClick: function () {
                                var frames = $$(frameId).getWindow();
                                frames.print();
                            }
                        },
                        click: function () {
                            this.callEvent("onClick");
                        },
                    },
                    {},
                    { view: "icon", icon: "times", hotkey: "esc", click: function () { $$(formId).close(); } }
                ]
            },
            on: {
                onShow: function () {
                    var self = this;
                    $(".webix_modal").one("click", function () { self.close(); });
                },
                onBeforeShow: function () {
                    $$(frameId).define("src", `${fileURL}#toolbar=0&view=Fit`)
                }
            },
            body: {
                rows: [
                    { view: "iframe", id: frameId, },
                ]
            },

        },
        $oninit: function (view, $scope) {

        },
        initUI: initUI
    }
});
define('views/68_chungtuthue',[
    "app",
    "locale",
    "models/user",
    "views/forms/forms68/ChungTu/68_chungtuthueForm",
    "views/forms/forms68/68_viewLogForm",
    "views/forms/forms68/ChungTu/uploadExcel",
    "views/modules/Component/modalPlugin",
    "views/forms/forms68/HDon/68_printfMultiChoice",
    "views/forms/forms68/ChungTu/sendEmail",
    "views/forms/forms68/ChungTu/signMultiple",
    "views/forms/forms68/68_viewsLogEmail",
    "views/modules/Component/constantManager",
    "views/forms/forms68/ChungTu/modalPrint",
], function (
    app,
    _,
    user,
    chungtuForm,
    viewLogForm,
    uploadExcel,
    modalPlugin,
    printMulti,
    sendEmail,
    signMultiple,
    viewLogEmail,
    CONSTANTS,
    modalPrint
) {
    "use strict";

    var tableId = "chungtuViews";
    webix.ui({
        view: "contextmenu",
        id: "cmenuChungtu",
        autowidth: true,
        data: [
            { id: "cmenuAdd", value: "Thêm (F4)", icon: "mdi mdi-plus-box-outline" },
            { id: "cmenuEdit", value: "Sửa (F3)", icon: "mdi mdi-pencil-box-outline" },
            { id: "cmenuDelete", value: "Xóa (F8)", icon: "mdi mdi-trash-can-outline" },
            { $template: "Separator" },
            { id: "cmenuEmail", value: "Lịch sử gửi email", icon: "mdi mdi-email-outline" }
        ],
        on: {
            onItemClick: function (id) {
                if (this.getItem(id).id == "cmenuAdd") {
                    $$("btnPlus").callEvent("onClick");
                }
                if (this.getItem(id).id == "cmenuEdit") {
                    $$("btnEdit").callEvent("onClick");
                }
                if (this.getItem(id).id == "cmenuDelete") {
                    $$("btnDelete").callEvent("onClick");
                }
                if (this.getItem(id).id == "cmenuEmail") {
                    var table = webix.$$(tableId);
                    var item = table.getSelectedItem();
                    if (item == null || item == undefined) {
                        webix.message("Bạn chưa chọn chứng từ", "debug");
                        return;
                    }
                    item.apiHost = CONSTANTS.API.VOUCHER.SEND_EMAIL_LOG;
                    item.typeView = "VOUCHER";
                    var detailForm = $$("frmView").$scope.ui(viewLogEmail.$ui);
                    viewLogEmail.setValues(item);
                    detailForm.show();
                }
            }
        }
    });
    var initUI = function () {
        var table = webix.$$(tableId);
        var url = {
            $proxy: true,
            load: function (view, callback, params) {
                var start = null;
                var count = null;
                var filter = [];
                var infoparam = null;
                var tlbparam_s = [];
                var url = app.config.host + "/Pattern/GetData";

                if (params == null) {
                    start = 0;
                    count = view.config.datafetch;
                    url = url + "?command=CM0024&start=0&count=" + view.config.datafetch + "&continue=null&filter=null";
                }
                else {
                    start = params.start;
                    count = params.count;
                    url = url + "?command=CM0024&start=" + params.start + "&count=" + params.count + "&continue=" + params.continue;
                    if (params.filter != null) {
                        var array = [];
                        for (var property in params.filter) {
                            var column = view.getColumnConfig(property);
                            var item = {
                                columnName: property,
                                columnType: column.columnType,
                                value: params.filter[property]
                            };
                            array.push(item);
                        }
                        if (array.length > 0) {
                            filter = array;
                            url = url + "&filter=" + JSON.stringify(array);
                        }
                        else {
                            url = url + "&filter=null";
                        }
                        //url = url + "&filter=" + JSON.stringify(array);
                    }
                }
                var tlbParams = $$("paramKyHieu");
                if (tlbParams !== undefined) {
                    var childViews = tlbParams.getChildViews();
                    var parameters = [];
                    for (var i = 0; i < childViews.length; i++) {
                        var child = childViews[i];
                        var id = child.config.id;
                        var value = $$(id).getValue();
                        if (value != undefined && value != "") {
                            var item = {
                                columnName: "quanlykyhieu68_id",
                                value: $$(id).getValue()
                            };
                            parameters.push(item);
                        }
                        else {
                            $$(tableId).hideOverlay();
                            $$(tableId).showOverlay("<div class='showOverlaydata'>Bạn chưa chọn ký hiệu, hoặc chưa được phân quyền ký hiệu chứng từ</div>");
                            return;
                        }
                    }
                    tlbparam_s = parameters;
                    url = url + "&tlbparam=" + JSON.stringify(parameters);
                }
                else {
                    url = url + "&tlbparam=null";
                }
                // webix.ajax(url, callback, view);
                var item = {
                    command: "CM0024",
                    start: start,
                    count: count,
                    filter: filter,
                    tlbparam: tlbparam_s
                };
                var apiHost = app.config.host + "/Pattern/GetData";
                webix.ajax()
                    .headers({ 'Content-type': 'application/json' })
                    .bind(view)
                    .post(apiHost, item, callback, view);
            }
        };
        table.define("url", url);
    };
    var subNghiepvu = webix.ui({
        view: "submenu",
        width: 200,
        padding: 0,
        data: [
            { id: "cancelVoucher", value: "Hủy chứng từ", icon: "mdi mdi-file-document-remove-outline" },
            { $template: "Separator" },
            { id: "dowloadXml", value: "Tải XML", icon: "mdi mdi-file-xml-box" },
        ],
        on: {
            onItemClick: function (id, e, node) {
                var record = this.getItem(id);
                this.hide();
                var table = webix.$$(tableId);
                var item = table.getSelectedItem();
                if (item == null) {
                    webix.message("Bạn chưa chọn chứng từ", "error");
                    return;
                }
                if (record.id == "dowloadXml") {
                    if (item.trang_thai == 2) {
                        webix.message("Chứng từ đang ở trạng thái chờ ký, không thể tải XML !", "error");
                        return;
                    }
                    webix.extend(table, webix.ProgressBar);
                    table.disable();
                    table.showProgress();
                    var url = app.config.host + "/Voucher/ExportFileXML?id=" + item.id;
                    webix.ajax().response("arraybuffer")
                        .get(url, function (text, data) {
                            table.enable();
                            table.hideProgress();
                            var file = new Blob([data], { type: "application/xml" });
                            webix.html.download(file, item.ms_thue + "_" + item.ky_hieu.replace(/\//g, "",) + "_" + item.so_ct + "_" + item.hoten_nnt + ".xml");
                        });
                }
                if (record.id == "cancelVoucher") {
                    if (item.trang_thai == 2) {
                        webix.message("Chứng từ đang ở trạng thái chờ ký, không thể tải hủy !", "error");
                        return;
                    }
                    if (item.trang_thai_ct == 1) {
                        webix.message("Chứng từ đã hủy, không thể dùng chức năng.", "error");
                        return;
                    }
                    webix.confirm({
                        title: "M-Invoice",
                        text: "Bạn có chắc chắn muốn hủy chứng từ số: " + item.so_ct,
                        ok: "Có",
                        cancel: "Không",
                        callback: function (choose) {
                            if (choose) {
                                webix.extend(table, webix.ProgressBar);
                                table.disable();
                                table.showProgress();

                                webix.ajax()
                                    .headers({ 'Content-type': 'application/json' })
                                    .get(app.config.host + "/Voucher/CancelVoucher?id=" + item.id,
                                        {
                                            error: function (text, data, XmlHttpRequest) {
                                                table.enable();
                                                table.hideProgress();
                                            },
                                            success: function (text, data, XmlHttpRequest) {
                                                var response = JSON.parse(text);
                                                if (response.code == "00") {
                                                    table.clearAll();
                                                    table.load(table.config.url);
                                                }
                                                else {
                                                    webix.message(response.message, "error");
                                                }
                                                table.enable();
                                                table.hideProgress();
                                            }
                                        });
                            }
                        }
                    });
                }

            }
        }
    });
    var subChucnang = webix.ui({
        view: "submenu",
        width: 200,
        padding: 0,
        data: [
            { id: "importExcel", value: "Nhận excel", icon: "mdi mdi-file-excel-outline" },
            { $template: "Separator" },
            { id: "signMultiple", value: "Ký nhiều chứng từ", icon: "mdi mdi-checkbox-multiple-outline" },
        ],
        on: {
            onItemClick: function (id, e, node) {
                var record = this.getItem(id);
                this.hide();
                if (record.id == "importExcel") {
                    webix.callEvent("onLoadError");
                    var excelForm = webix.$$("frmView").$scope.ui(uploadExcel.$ui);
                    excelForm.show();
                }
                if (record.id == "signMultiple") {
                    webix.callEvent("onLoadError");
                    var signMulti = webix.$$("frmView").$scope.ui(signMultiple.$ui);
                    signMulti.show();
                    return;
                }

            }
        }
    });
    function GetSlectVoucher() {
        var table = $$(tableId);
        var array = new Array();
        table.eachRow(function (row) {
            var record = JSON.stringify(table.getItem(row));
            if (record != undefined) {
                var ref = JSON.parse(record);
                if (ref.colMultiChoice == "C") {
                    if (ref.trang_thai != 2) {
                        ref["colMultiChoice"] = "K";
                        table.updateItem(ref.id, ref);
                        table.refresh();
                        webix.message("Hóa đơn số: " + ref.so_ct + " đã ký", "debug");
                    }
                    if (ref.trang_thai == 2) {
                        array.push(ref.id);
                    }
                }
            }
        }, true);
        if (array.length == 0) {
            webix.message({ type: "error", text: "Không có bản ghi nào được chọn" });
            return null;
        }
        return array;
    }
    function SignMultiChoice() {
        var array = GetSlectVoucher();
        if (array != null) {
            require(["views/modules/minvoiceplugin"], function (plugin) {
                var hub = plugin.hub();
                var hubconnect = plugin.conn();

                var table = $$("frmView");
                webix.extend(table, webix.ProgressBar);
                table.disable();
                table.showProgress();

                if (hubconnect.state != 1) {
                    table.enable();
                    table.hideProgress();
                    webix.message("Quý khách hàng chưa cài Plugin ký hóa đơn hoặc Plugin ký hóa đơn chưa được bật !", "error");
                    return;
                }
                var currentLocation = window.location.origin + "/api/";
                if (document.location.protocol == "file:") {
                    currentLocation = "http://localhost:18374/";
                }
                var arg = {
                    signAndSend: false,
                    infoSign: {
                        tagSign: "NNT",
                        idData: "#data"
                    },
                    idSign: array,
                    cookie: user.getAppCookie(),
                    location: currentLocation
                };
                hub.invoke('execCommand', 'SignVoucher', JSON.stringify(arg))
                    .done(function () {
                        console.log("SignVoucher Success !")
                    })
                    .fail(function (error) {
                        webix.message(error, "error");
                    });
                hub.off('resNotice');
                hub.on('resNotice', function (result) {
                    webix.message(result, "debug");
                });
                hub.off('resCommand');
                hub.on('resCommand', function (result) {
                    var response = JSON.parse(result);
                    table.enable();
                    table.hideProgress();
                    if (response.code == "00") {
                        app.callEvent("dataChangeChungtuTNCN", [1, null]);
                        webix.message("Ký thành công", "success");
                    }
                    else {
                        webix.message("Code: " + response.code + " Message: " + response.message, "error");
                    }
                });
            });
        }
    };
    function printMultiChoice() {
        var table = $$(tableId);
        var array = new Array();
        table.eachRow(function (row) {
            var record = JSON.stringify(table.getItem(row));
            if (record != undefined) {
                var ref = JSON.parse(record);
                if (ref.colMultiChoice == "C") {
                    array.push(ref.id);
                }
            }
        }, true);
        if (array.length == 0) {
            webix.message({ type: "error", text: "Không có bản ghi nào được chọn" });
            return;
        }
        var printForm = table.$scope.ui(printMulti.$ui);
        var url = app.config.host + "/Voucher/PrintInvoiceMulti";
        printMulti.initUI(array, url);
        printForm.show();
    };
    function DeleteMultichoice() {
        var array = GetSlectVoucher();
        if (array != null) {
            webix.confirm({
                title: "M-INVOICE",
                text: "Bạn có muốn xóa bản ghi",
                ok: "Có",
                cancel: "Không",
                callback: function (choose) {
                    if (choose) {
                        var table = $$(tableId);
                        webix.extend(table, webix.ProgressBar);
                        table.disable();
                        table.showProgress();

                        webix.ajax()
                            .headers({ 'Content-type': 'application/json' })
                            .post(app.config.host + "/Voucher/DeleteMultiple", JSON.stringify(array),
                                {
                                    error: function (text, data, XmlHttpRequest) {
                                        table.enable();
                                        table.hideProgress();
                                    },
                                    success: function (text, data, XmlHttpRequest) {
                                        table.enable();
                                        table.hideProgress();
                                        var response = JSON.parse(text);
                                        if (response.code == "00") {
                                            table.clearAll();
                                            table.load(table.config.url);
                                        }
                                        else {
                                            webix.message(response.message, "error");
                                        }
                                    }
                                });
                    }
                }
            });
        }
    }
    var controls = [
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-refresh fa-lg" aria-hidden="true"></i> ' +
                '<span class="text">' + _("REFRESH") + '</span>',
            id: "btnRefresh",
            on: {
                onClick: function () {
                    var table = webix.$$(tableId);
                    table.clearAll();
                    table.load(table.config.url);
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-plus fa-lg" aria-hidden="true"></i> ' +
                '<span class="text">' + _("THEM") + ' (F4)</span>',
            id: "btnPlus",
            shortcut: "F4",
            on: {
                onClick: function () {
                    var id_ct = $$("kyhieu_chungtu").getValue();
                    var item = $$("kyhieu_chungtu").getList().getItem(id_ct);
                    if (item == undefined) {
                        webix.message("Bạn chưa chọn ký hiệu", "debug");
                        return;
                    }
                    var FormDialog = this.$scope.ui(chungtuForm.$ui);
                    chungtuForm.setEditMode(1);
                    chungtuForm.initUINew(item);
                    FormDialog.show();
                }
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-edit fa-lg" aria-hidden="true"></i> ' +
                '<span class="text">' + _("SUA") + ' (F2)</span>',
            id: "btnEdit",
            shortcut: "F2",
            on: {
                onClick: function () {
                    var table = webix.$$(tableId);
                    var selectedItem = table.getSelectedItem();
                    if (selectedItem == null) {
                        webix.message("Bạn chưa chọn chứng từ cần sửa ! ", "error");
                        return;
                    }
                    var FormDialog = this.$scope.ui(chungtuForm.$ui);
                    chungtuForm.setEditMode(2);
                    chungtuForm.setValues(selectedItem);
                    if (selectedItem.trang_thai == 3) {
                        var form = $$("chungtu").elements;
                        for (var key in form) {
                            var $el = form[key];
                            $el.define("readonly", "true")
                            $el.define("css", "mcls_readonly_text")
                            $el.refresh()
                        }
                        $$("btnSaveChungtu").destructor();
                    }
                    FormDialog.show();
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-trash-o fa-lg" aria-hidden="true"></i> ' +
                '<span class="text">' + _("XOA") + ' (F3)</span>',
            id: "btnDelete",
            shortcut: "F3",
            on: {
                onClick: function () {
                    var table = webix.$$(tableId);
                    if (table.getColumnConfig("colMultiChoice") == undefined) {
                        var selectedItem = table.getSelectedItem();
                        if (selectedItem == null) {
                            webix.message("Bạn chưa chọn chứng từ", "error");
                            return;
                        }
                        if (selectedItem.trang_thai == 3) {
                            webix.message("Chứng từ đã ký. Bạn không thể thực hiện chức năng này", "error");
                            return;
                        }
                        selectedItem.editmode = 3;
                        webix.confirm({
                            title: "M-INVOICE",
                            text: "Bạn có muốn xóa bản ghi",
                            ok: "Có",
                            cancel: "Không",
                            callback: function (choose) {
                                if (choose) {
                                    webix.extend(table, webix.ProgressBar);
                                    table.disable();
                                    table.showProgress();

                                    webix.ajax()
                                        .headers({ 'Content-type': 'application/json' })
                                        .get(app.config.host + "/Voucher/Delete?id=" + selectedItem.id,
                                            {
                                                error: function (text, data, XmlHttpRequest) {
                                                    table.enable();
                                                    table.hideProgress();
                                                    var res = JSON.parse(text);
                                                    webix.message(res.error, "error");
                                                },
                                                success: function (text, data, XmlHttpRequest) {
                                                    var response = JSON.parse(text);
                                                    if (response.code == "00") {
                                                        table.remove(selectedItem.id);
                                                    }
                                                    else {
                                                        webix.message(response.message, "error");
                                                    }
                                                    table.enable();
                                                    table.hideProgress();
                                                }
                                            });
                                }
                            }
                        });
                    }
                    else {
                        DeleteMultichoice();
                    }
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: `<i class="fa fa-files-o fa-lg" aria-hidden="true"></i><span class="text">${_("COPY")}</span>`,
            id: "btnCopy",
            on: {
                onClick: function () {
                    webix.callEvent("onLoadError");
                    var table = webix.$$(tableId);
                    var selectedItem = table.getSelectedItem();

                    if (selectedItem == null) {
                        webix.message("Bạn chưa chọn chứng từ cần sao chép.", "error");
                        return;
                    }

                    var FormDialog = this.$scope.ui(chungtuForm.$ui);
                    chungtuForm.setEditMode(1);
                    chungtuForm.copyValues(selectedItem);

                    FormDialog.show();
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-print fa-lg" aria-hidden="true"></i> ' +
                '<span class="text">' + _("PRINT") + '</span>',
            id: "btnPrint",
            on: {
                onClick: function () {
                    var table = webix.$$(tableId);
                    if (table.getColumnConfig("colMultiChoice") == undefined) {
                        var item = table.getSelectedItem();
                        if (item == null || item == undefined) {
                            webix.message("Bạn chưa chọn chứng từ cần in !", "error");
                            return;
                        }

                        var box = webix.modalbox({
                            title: "Đang in chứng từ ....",
                            text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                            width: 350,
                            height: 200
                        });
                        var apiPrint = app.config.host + "/Voucher/PrintVoucher?id=" + item.id + "&type=PDF";
                        if ($$("optionPrint") != undefined) {
                            var optionPrint = $$("optionPrint").getValue();
                            apiPrint = app.config.host + `/Voucher/PrintVoucher?id=${item.id}&type=PDF&file=${optionPrint}`;
                        }
                        // var newWin = window.open();
                        // var html = '<html><head><title>Hóa đơn điện tử M-Invoice</title>'
                        //     + '<link rel="stylesheet" href="assets/fontawesome_pro/css/all.css" type="text/css" charset="utf-8">'
                        //     + '<link rel="stylesheet" href="assets/fontawesome.css" type="text/css" charset="utf-8">'
                        //     + '</head><body><center>Đang tải dữ liệu ... <br><p><i style="font-size:200%;" class="fa fa-spin fa-spinner"></i></p></center></body></html>';
                        // newWin.document.write(html);

                        webix.ajax()
                            .response("arraybuffer")
                            .headers({ 'Content-type': 'application/json' })
                            .get(apiPrint,
                                {
                                    error: function (text, data, XmlHttpRequest) {
                                        webix.modalbox.hide(box);
                                        webix.message(XmlHttpRequest.statusText, "error");
                                    },
                                    success: function (text, data, XmlHttpRequest) {
                                        var file = new Blob([data], { type: 'application/pdf' });
                                        var fileURL = URL.createObjectURL(file);
                                        // //window.open(fileURL, '_blank');
                                        webix.modalbox.hide(box);
                                        // newWin.location = fileURL;
                                        var FormDialog = $$("frmView").$scope.ui(modalPrint.$ui);
                                        modalPrint.initUI(item, fileURL, file);
                                        FormDialog.show();
                                    }
                                });
                    }
                    else {
                        printMultiChoice();
                    }
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-envelope fa-lg" aria-hidden="true"></i> ' +
                '<span class="text">' + _("Gửi email") + '</span>',
            id: "btnEmail",
            on: {
                onClick: function () {
                    webix.callEvent("onLoadError");
                    var table = webix.$$(tableId);
                    if (table.getColumnConfig("colMultiChoice") == undefined) {
                        var item = table.getSelectedItem();
                        if (item == null || item == undefined) {
                            webix.message("Bạn chưa chọn chứng từ", "error");
                            return;
                        }
                        if (item.trang_thai == 2) {
                            webix.message("Chứng từ chưa ký không thể gửi email", "error");
                            return;
                        }
                        var FormDialog = this.$scope.ui(sendEmail.$ui);
                        sendEmail.InitUI(item);
                        FormDialog.show();
                    }
                    else {
                        webix.message("Chức năng gửi nhiều chưng từ sẽ hoàn thiện trong thời gian tới.", "debug");
                    }
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-sign-in fa-lg" aria-hidden="true"></i> ' +
                '<span class="text">' + _("Ký") + ' (F7)</span>',
            id: "btnSign",
            shortcut: "F7",
            on: {
                onClick: function () {
                    var tableDK = webix.$$(tableId);
                    var table = $$("frmView");
                    webix.extend(table, webix.ProgressBar);
                    table.disable();
                    table.showProgress();
                    webix.ajax()
                        .headers({ 'Content-type': 'application/json' })
                        .get(app.config.host + "/Voucher/CheckPerSign",
                            {
                                error: function (text, data, XmlHttpRequest) {
                                    table.enable();
                                    table.hideProgress();
                                    webix.message(text, "error");
                                },
                                success: function (text, data, XmlHttpRequest) {
                                    table.enable();
                                    table.hideProgress();
                                    if (text == "true") {
                                        if (tableDK.getColumnConfig("colMultiChoice") == undefined) {
                                            var selectedItem = tableDK.getSelectedItem();
                                            if (selectedItem == null) {
                                                webix.message("Bạn chưa chọn chứng từ ! ", "error");
                                                return;
                                            }
                                            if (selectedItem.trang_thai == 3 || selectedItem.trang_thai == 4) {
                                                webix.message("Chứng từ đã được ký bạn không thể thực hiện thao tác này", "error");
                                                return;
                                            }
                                            webix.confirm({
                                                title: "M-Invoice",
                                                text: "Bạn có muốn ký chứng từ số: <b>" + selectedItem.so_ct + "</b>",
                                                ok: "Có",
                                                cancel: "Không",
                                                callback: function (choose) {
                                                    if(choose) {
                                                    webix.ajax()
                                                        .headers({ 'Content-Type': 'application/json' })
                                                        .get(CONSTANTS.API.INVOICE_GET_TYPE_SIGN, (function (text) {
                                                            var result = JSON.parse(text);
                                                            var kytaptrung = result[0].gia_tri;
                                                            if (kytaptrung.toUpperCase() == "INTRUSTCA") {
                                                                var frmChungTu = webix.$$(tableId);
                                                                var box = webix.modalbox({
                                                                    title: "Chọn chứng thư số IntrustCa",
                                                                    buttons: ["Nhận", "Hủy bỏ"],
                                                                    text: "<div id='ctnCerts'></div>",
                                                                    top: 100,
                                                                    width: 750,
                                                                    callback: function (result) {
                                                                        switch (result) {
                                                                            case "1":
                                                                                webix.modalbox.hide();
                                                                                break;
                                                                            case "0":
                                                                                var selectedItem = frmChungTu.getSelectedItem();
                                                                                var tableCert = $$("tblCerts");
                                                                                var data = tableCert.serialize();
                                                                                var cert = null;
                                                                                for (var i = 0; i < data.length; i++) {
                                                                                    if (data[i].chon == true) {
                                                                                        cert = data[i];
                                                                                        break;
                                                                                    }
                                                                                }
                                                                                if (cert == null) {
                                                                                    webix.message("Bạn chưa chọn chứng thư số", "debug");
                                                                                    return;
                                                                                }
                                                                                var signModel = {
                                                                                    user_name: cert.username,
                                                                                    credentialID: cert.tokenSerial,
                                                                                    certificate: cert.cert_content,
                                                                                    pinCode: cert.pin_code,
                                                                                    auth_data: cert.auth_data,
                                                                                    mode: 1,
                                                                                    hoadon: [selectedItem.chungtu_tncn_id]
                                                                                }

                                                                                webix.extend(frmChungTu, webix.ProgressBar);
                                                                                frmChungTu.disable();
                                                                                frmChungTu.showProgress();
                                                                                webix.ajax().headers({ "Content-Type": "application/json" })
                                                                                    .post(app.config.host + CONSTANTS.API.SIGN.INTRUSTCA_VOUCHER, JSON.stringify(signModel),
                                                                                        function (text) {
                                                                                            frmChungTu.enable();
                                                                                            frmChungTu.hideProgress();
                                                                                            var result = JSON.parse(text);
                                                                                            if (result.code == "00") {
                                                                                                webix.message("Ký chứng từ thành công", "success");
                                                                                                frmChungTu.load(frmChungTu.config.url);
                                                                                            } else
                                                                                                webix.message(result.message, "error")
                                                                                        }
                                                                                    );
                                                                                webix.modalbox.hide();
                                                                                break;
                                                                        }
                                                                    },
                                                                });

                                                                var Certs = webix.ui({
                                                                    container: "ctnCerts",
                                                                    id: "tblCerts",
                                                                    view: "datatable",
                                                                    borderless: true,
                                                                    resizeColumn: true,
                                                                    height: 350,
                                                                    columns: [
                                                                        {
                                                                            id: "chon",
                                                                            header: _("CHON"),
                                                                            width: 65,
                                                                            checkValue: true,
                                                                            uncheckValue: false,
                                                                            template: "{common.checkbox()}",
                                                                        },
                                                                        {
                                                                            id: "so_serial",
                                                                            header: _("SO_SERIAL"),
                                                                            width: 250,
                                                                        },
                                                                        {
                                                                            id: "subjectname",
                                                                            header: _("SUBJECTNAME"),
                                                                            width: 400,
                                                                        },
                                                                        {
                                                                            id: "ngaybatdau",
                                                                            header: _("NGAY_BAT_DAU"),
                                                                            width: 200,
                                                                        },
                                                                        {
                                                                            id: "ngayketthuc",
                                                                            header: _("NGAY_KET_THUC"),
                                                                            width: 200,
                                                                        },
                                                                        { id: "issuer", header: _("DONVI"), width: 450 },
                                                                    ],
                                                                    url: CONSTANTS.API.TOKEN_CERT_AUTO,
                                                                    ready: function () {
                                                                        this.data.each(function (row, index) {
                                                                            row.chon = false;
                                                                            if (index == 0) row.chon = true;
                                                                        });
                                                                        this.refresh();
                                                                    },
                                                                    on: {
                                                                        onCheck: function (rowId, colId, isChecked) {
                                                                            if (isChecked) {
                                                                                this.data.each(function (row) {
                                                                                    if (row.id !== rowId) {
                                                                                        this.getItem(row.id).chon = false;
                                                                                        this.updateItem(row.id);
                                                                                    }
                                                                                });
                                                                            }
                                                                        }
                                                                    }
                                                                });
                                                            }
                                                            else if (kytaptrung.toUpperCase() == "VNET") {
                                                                var frmChungTu = webix.$$(tableId);
                                                                var box = webix.modalbox({
                                                                    title: "Chọn chứng thư số Vnet",
                                                                    buttons: ["Nhận", "Hủy bỏ"],
                                                                    text: "<div id='ctnCerts'></div>",
                                                                    top: 100,
                                                                    width: 750,
                                                                    callback: function (result) {
                                                                        switch (result) {
                                                                            case "1":
                                                                                webix.modalbox.hide();
                                                                                break;
                                                                            case "0":
                                                                                debugger
                                                                                var selectedItem = frmChungTu.getSelectedItem();
                                                                                var tableCert = $$("tblCerts");
                                                                                var data = tableCert.serialize();
                                                                                var cert = null;
                                                                                for (var i = 0; i < data.length; i++) {
                                                                                    if (data[i].chon == true) {
                                                                                        cert = data[i];
                                                                                        break;
                                                                                    }
                                                                                }
                                                                                if (cert == null) {
                                                                                    webix.message("Bạn chưa chọn chứng thư số", "debug");
                                                                                    return;
                                                                                }
                                                                                var postData = {
                                                                                    chukyso_id: cert.chukyso_id,
                                                                                    id: selectedItem.chungtu_tncn_id
                                                                                };
                                                                                webix.extend(frmChungTu, webix.ProgressBar);
                                                                                frmChungTu.disable();
                                                                                frmChungTu.showProgress();

                                                                                webix.ajax().headers({ "Content-Type": "application/json", })
                                                                                    .post(app.config.host + "/Voucher/SignByVnet", postData, function (text) {
                                                                                        var result = JSON.parse(text);
                                                                                        frmChungTu.enable();
                                                                                        frmChungTu.hideProgress();
                                                                                        if (result.code != "00") {
                                                                                            webix.message({
                                                                                                type: "error",
                                                                                                text: result.message,
                                                                                            });
                                                                                        } else {
                                                                                            webix.message("Ký thành công", "success");
                                                                                            frmChungTu.load(frmChungTu.config.url);
                                                                                        }
                                                                                    }
                                                                                    );
                                                                                break;
                                                                        }
                                                                    },
                                                                });

                                                                var Certs = webix.ui({
                                                                    container: "ctnCerts",
                                                                    id: "tblCerts",
                                                                    view: "datatable",
                                                                    borderless: true,
                                                                    resizeColumn: true,
                                                                    height: 350,
                                                                    columns: [
                                                                        {
                                                                            id: "chon",
                                                                            header: _("CHON"),
                                                                            width: 65,
                                                                            checkValue: true,
                                                                            uncheckValue: false,
                                                                            template: "{common.checkbox()}",
                                                                        },
                                                                        {
                                                                            id: "so_serial",
                                                                            header: _("SO_SERIAL"),
                                                                            width: 250,
                                                                        },
                                                                        {
                                                                            id: "subjectname",
                                                                            header: _("SUBJECTNAME"),
                                                                            width: 400,
                                                                        },
                                                                        {
                                                                            id: "ngaybatdau",
                                                                            header: _("NGAY_BAT_DAU"),
                                                                            width: 200,
                                                                        },
                                                                        {
                                                                            id: "ngayketthuc",
                                                                            header: _("NGAY_KET_THUC"),
                                                                            width: 200,
                                                                        },
                                                                        { id: "issuer", header: _("DONVI"), width: 450 },
                                                                    ],
                                                                    url: app.config.host + "/Invoice/GetListCertificatesVnet",
                                                                    ready: function () {
                                                                        this.data.each(function (row, index) {
                                                                            row.chon = false;
                                                                            if (index == 0) row.chon = true;
                                                                        });
                                                                        this.refresh();
                                                                    },
                                                                    on: {
                                                                        onCheck: function (rowId, colId, isChecked) {
                                                                            if (isChecked) {
                                                                                this.data.each(function (row) {
                                                                                    if (row.id !== rowId) {
                                                                                        this.getItem(row.id).chon = false;
                                                                                        this.updateItem(row.id);
                                                                                    }
                                                                                });
                                                                            }
                                                                        }
                                                                    }
                                                                });
                                                            }
                                                            else {
                                                                require(["views/modules/minvoiceplugin"], function (plugin) {
                                                                    var hub = plugin.hub();
                                                                    var hubconnect = plugin.conn();

                                                                    var table = $$("frmView");
                                                                    webix.extend(table, webix.ProgressBar);
                                                                    table.disable();
                                                                    table.showProgress();

                                                                    if (hubconnect.state != 1) {
                                                                        table.enable();
                                                                        table.hideProgress();
                                                                        webix.message("Quý khách hàng chưa cài Plugin ký hóa đơn hoặc Plugin ký hóa đơn chưa được bật !", "error");
                                                                        var Form = $$(tableId).$scope.ui(modalPlugin.$ui);
                                                                        Form.show();
                                                                        return;
                                                                    }
                                                                    var arrId = [];
                                                                    arrId.push(selectedItem.id);
                                                                    var currentLocation = window.location.origin + "/api/";
                                                                    if (document.location.protocol == "file:") {
                                                                        currentLocation = "http://localhost:18374/";
                                                                    };
                                                                    var arg = {
                                                                        signAndSend: false,
                                                                        infoSign: {
                                                                            tagSign: "NNT",
                                                                            idData: "#data"
                                                                        },
                                                                        idSign: arrId,
                                                                        cookie: user.getAppCookie(),
                                                                        location: currentLocation
                                                                    };
                                                                    hub.invoke('execCommand', 'SignVoucher', JSON.stringify(arg))
                                                                        .done(function () {
                                                                            console.log("SignVoucher Success !")
                                                                        })
                                                                        .fail(function (error) {
                                                                            webix.message(error, "error");
                                                                        });
                                                                    hub.off('resNotice');
                                                                    hub.on('resNotice', function (result) {
                                                                        webix.message(result, "debug");
                                                                    });
                                                                    hub.off('resCommand');
                                                                    hub.on('resCommand', function (result) {
                                                                        var response = JSON.parse(result);
                                                                        table.enable();
                                                                        table.hideProgress();
                                                                        if (response.code == "00") {
                                                                            app.callEvent("dataChangeChungtuTNCN", [1, null]);
                                                                            webix.message("Ký thành công", "success");
                                                                            //webix.message("Code: " + response.code + " Message: " + response.message, "success");
                                                                        }
                                                                        else {
                                                                            webix.message("Code: " + response.code + " Message: " + response.message, "error");
                                                                        }
                                                                    });
                                                                });
                                                            }
                                                        }));
                                                    }

                                                }
                                            });
                                        }
                                        else {
                                            webix.confirm({
                                                text: "Bạn có muốn ký chứng từ",
                                                ok: "Có",
                                                cancel: "Không",
                                                callback: function (choose) {
                                                    if (choose) {
                                                        SignMultiChoice();
                                                    }
                                                }
                                            });
                                        }
                                    }
                                    else {
                                        webix.message("Tài khoản không có quyền ký chứng từ", "error");
                                    }

                                }
                            });
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button", type: "htmlbutton", width: 120,
            label: '<i class="fa fa-th fa-lg aria-hidden="true"></i> ' +
                '<span class="text">' + _("Chức năng") + '</span>',
            id: "btnChucNang",
            click: function () {
                subChucnang.show(webix.$$("btnChucNang").$view);
            }
        },
        {
            view: "button", type: "htmlbutton", width: 120,
            label: '<i class="fa fa-th fa-lg aria-hidden="true"></i> ' +
                '<span class="text">' + _("Nghiệp vụ") + '</span>',
            id: "btnNghiepvu",
            click: function () {
                subNghiepvu.show(webix.$$("btnNghiepvu").$view);
            }
        },
        {},
        {
            view: "combo",
            id: "optionPrint",
            name: "optionPrint",
            width: 300,
            label: _("MAUIN"),
            attributes: { readonly: true },
            labelWidth: 50,
            value: "MauChungTu.repx",
            options: [
                { id: "MauChungTu.repx", value: "Chứng từ thuế TNCN" },
                { id: "MauChungTu19.repx", value: "Chứng từ thuế TNCN - 19 tiêu thức" },
                { id: "MauChungTuTT.repx", value: "Thư xác nhận theo thông tư" },
                { id: "MauChungTuTN.repx", value: "Thư xác nhận theo thu nhập" },
            ],
        },
        {
            view: "button",
            type: "icon",
            width: 30,
            icon: "mdi mdi-settings",
            click: function () {
                var menu = $$(tableId).config.headermenu;
                $$(menu).show(this.$view);
            },
        }
    ];
    function changeMultiChoice() {
        var table = $$(tableId);
        var columns = webix.toArray(table.config.columns);

        if (table.getColumnConfig("colMultiChoice") == undefined) {
            columns.insertAt({
                id: "colMultiChoice",
                header: [{ text: "", content: "masterCheckbox", contentId: "mc1" }],
                width: 50,
                checkValue: 'C',
                uncheckValue: 'K',
                template: "{common.checkbox()}",
                value: 'K'

            }, 0);
        }
        else {
            columns.removeAt(0);
        }
        table.refreshColumns();
    };
    var trangThaiOptions = CONSTANTS.STATUS_INVOICE.map(function (item) {
        return {
            id: item.id,
            value: item.value,
            checked: false
        };
    });

    // Định nghĩa options cho trạng thái CQT từ STATUS_SEND_INVOICE
    var trangThaiCQTOptions = CONSTANTS.STATUS_SEND_INVOICE.map(function (item) {
        return {
            id: item.id,
            value: item.value,
            checked: false
        };
    });
    var table = {
        margin: 0,
        rows: [{
            id: tableId,
            view: "datatable",
            select: true,
            resizeColumn: true,
            footer: false,
            editable: false,
            tooltip: true,
            leftSplit: 5,
            headermenu: {
                //width: 200,
                autoheight: false,
                scroll: true,
                autowidth: true
            },
            scheme: {
                $init: function (obj) {
                    // if (obj.date_new) {
                    //     obj.date_new = new Date(obj.date_new);
                    // }
                },
            },
            onClick: {
                "dowloadXmlDKSD": function (event, cell, target) {
                    var win = webix.$$(tableId);
                    var record = win.getItem(cell.row);
                    if (record.trang_thai != 3 && record.trang_thai != 4) {
                        webix.message("Mẫu chưa được ký không thể tải !", "error");
                        return;
                    }

                    var file = new Blob([record.xml_send], { type: "application/xml" });
                    webix.html.download(file, "Mau01.xml");
                },
                "btndowloadXMLRep": function (event, cell, target) {
                    var win = webix.$$(tableId);
                    var record = win.getItem(cell.row);
                    if (record.ket_qua == null || record.ket_qua == "") {
                        webix.message("Mẫu chưa được CQT trả về không thể tải !", "error");
                        return;
                    }
                    webix.extend(win, webix.ProgressBar);
                    win.disable();
                    win.showProgress();

                    var url = app.config.host + "/Invoice68/ExportXMLMau02?id=" + cell.row;
                    webix.ajax().response("arraybuffer")
                        .get(url, function (text, data) {

                            win.enable();
                            win.hideProgress();

                            var file = new Blob([data], { type: "application/xml" });
                            webix.html.download(file, "Mau02.xml");
                        });
                },
                "InMau01": function (event, cell, target) {
                    var table = webix.$$(tableId);
                    var item = table.getItem(cell.row);
                    var box = webix.modalbox({
                        title: "Đang in mẫu đăng ký/ thay đổi ....",
                        text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                        width: 350,
                        height: 200
                    });

                    var newWin = window.open();
                    var html = '<html><head><title>Hóa đơn điện tử M-Invoice</title>'
                        + '<link rel="stylesheet" href="assets/fontawesome_pro/css/all.css" type="text/css" charset="utf-8">'
                        + '<link rel="stylesheet" href="assets/fontawesome.css" type="text/css" charset="utf-8">'
                        + '</head><body><center>Đang tải dữ liệu ... <br><p><i style="font-size:200%;" class="fa fa-spin fa-spinner"></i></p></center></body></html>';
                    newWin.document.write(html);

                    webix.ajax()
                        .response("arraybuffer")
                        .headers({ 'Content-type': 'application/json' })
                        .get(app.config.host + "/Register68/PrintMau01?id=" + item.id + "&type=PDF",
                            {
                                error: function (text, data, XmlHttpRequest) {
                                    webix.modalbox.hide(box);
                                    webix.message(XmlHttpRequest.statusText, "error");
                                },
                                success: function (text, data, XmlHttpRequest) {
                                    var file = new Blob([data], { type: 'application/pdf' });
                                    var fileURL = URL.createObjectURL(file);
                                    webix.modalbox.hide(box);
                                    newWin.location = fileURL;
                                }
                            });

                },
                "InMau02": function (event, cell, target) {
                    var table = webix.$$(tableId);
                    var item = table.getItem(cell.row);

                    var box = webix.modalbox({
                        title: "Đang in mẫu đăng ký/ thay đổi ....",
                        text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                        width: 350,
                        height: 200
                    });

                    var newWin = window.open();
                    var html = '<html><head><title>Hóa đơn điện tử M-Invoice</title>'
                        + '<link rel="stylesheet" href="assets/fontawesome_pro/css/all.css" type="text/css" charset="utf-8">'
                        + '<link rel="stylesheet" href="assets/fontawesome.css" type="text/css" charset="utf-8">'
                        + '</head><body><center>Đang tải dữ liệu ... <br><p><i style="font-size:200%;" class="fa fa-spin fa-spinner"></i></p></center></body></html>';
                    newWin.document.write(html);

                    webix.ajax()
                        .response("arraybuffer")
                        .headers({ 'Content-type': 'application/json' })
                        .get(app.config.host + "/Invoice68/inMau02?id=" + item.id + "&type=PDF",
                            {
                                error: function (text, data, XmlHttpRequest) {
                                    webix.modalbox.hide(box);
                                    webix.message(XmlHttpRequest.statusText, "error");
                                },
                                success: function (text, data, XmlHttpRequest) {
                                    var file = new Blob([data], { type: 'application/pdf' });
                                    var fileURL = URL.createObjectURL(file);
                                    //window.open(fileURL, '_blank');
                                    webix.modalbox.hide(box);
                                    newWin.location = fileURL;
                                }
                            });
                },
                "btnViewLichsu": function (event, cell, target) {
                    var table = webix.$$(tableId);
                    var item = table.getItem(cell.row);
                    var detailForm = this.$scope.ui(viewLogForm.$ui);
                    viewLogForm.initUI(null, item.mtdiep_gui);
                    detailForm.config.mtdiep = item.mtdiep_gui;
                    detailForm.show();
                }
            },
            on: {
                "data->onStoreUpdated": function () {
                    this.data.each(function (obj, i) {
                        obj.stt = i + 1;
                    });
                },
                onItemDblClick: function (id, e, node) {
                    var btnEdit = $$("btnEdit");
                    btnEdit.callEvent("onClick");
                },
                onBeforeLoad: function () {
                    this.showOverlay("<p style='padding-top:160px;'><i style='font-size:450%;' class='fa fa-spin fa-spinner fa-pulse'></i></p>");
                },
                onAfterLoad: function () {
                    if (!this.count())
                        this.showOverlay("<div><img src='assets/imgs/nodata.png'><div class='showOverlaydata'>Không có dữ liệu </br> Chúng tôi không tìm thấy chứng từ</div></div>");
                    else
                        this.hideOverlay();
                    $$("cmenuChungtu").attachTo($$(tableId));
                }
            },
            columns: [
                { id: "stt", header: ["STT"], width: 40 },
                {
                    id: "ten_tt",
                    header: [
                        "Trạng thái",
                        {
                            content: "multiSelectFilter",
                            options: trangThaiOptions,
                            css: "multiselect_filter",
                            placeholder: "Chọn trạng thái",
                            template: function (obj, common) {
                                if (obj.value === undefined) {
                                    return "<input type='text' class='filter_search' placeholder='Tìm trạng thái...'>";
                                }
                                return "<label class='webix_table_checkbox'>" +
                                    "<input type='checkbox' class='webix_table_checkbox' " +
                                    (obj.checked ? "checked='1'" : "") + ">" +
                                    "<span>" + obj.value + "</span></label>";
                            }
                        }
                    ],
                    template: function (obj) {
                        var statusClass = "";
                        switch (obj.trang_thai_ct) {
                            case "1": statusClass = "status_pending"; break;
                            case "2": statusClass = "status_signed"; break;
                            case "3": statusClass = "status_sent"; break;
                            case "4": statusClass = "status_cancelled"; break;
                        }
                        return "<span class='mcls_status" + obj.trang_thai_ct + " " + statusClass + "'>" +
                            obj.ten_tt + "</span>";
                    },
                    width: 100,
                    columnType: "nvarchar"
                },
                {
                    id: "gia_tri",
                    header: [
                        "Trạng thái CQT",
                        {
                            content: "multiSelectFilter",
                            options: trangThaiCQTOptions,
                            css: "multiselect_filter",
                            placeholder: "Chọn trạng thái CQT",
                            template: function (obj, common) {
                                if (obj.value === undefined) {
                                    return "<input type='text' class='filter_search' placeholder='Tìm trạng thái CQT...'>";
                                }
                                return "<label class='webix_table_checkbox'>" +
                                    "<input type='checkbox' class='webix_table_checkbox' " +
                                    (obj.checked ? "checked='1'" : "") + ">" +
                                    "<span>" + obj.value + "</span></label>";
                            }
                        }
                    ],
                    width: 115,
                    template: function (obj) {
                        var statusClass = "";
                        switch (obj.trang_thai) {
                            case "1": statusClass = "status_cqt_pending"; break;
                            case "2": statusClass = "status_cqt_received"; break;
                            case "3": statusClass = "status_cqt_rejected"; break;
                        }
                        return "<span class='" + statusClass + "'>" +
                            (obj.trang_thai == 2 ?
                                "<span style='color: #f47537;font-weight: bold;'>" + obj.gia_tri + "</span>" :
                                "<span style='color: #63b4ea;font-weight: bold;'>" + obj.gia_tri +
                                "<sup style='color:blue'> <span class='mdi mdi-check'></span></sup></span>");
                    }
                },
                { id: "so_ct", header: ["Số chứng từ", { content: "serverFilter" }], width: 110, editor: "text", sort: "int" },
                {
                    id: "ngay_ct", header: ["Ngày chứng từ", { content: "serverDateRangeFilter" }], width: 120, columnType: "datetime",
                    format: function (text) { return formatDate(text); }
                },
                { id: "hoten_nnt", header: ["Tên người nộp thuế", { content: "serverFilter" }], width: 200, editor: "text", sort: "string" },
                { id: "ms_thue_nnt", header: ["Mã số thuế TNCN", { content: "serverFilter" }], width: 100 },
                { id: "so_cmnd", header: ["Số CMND/Hộ chiếu", { content: "serverFilter" }], width: 130 },
                { id: "thang", header: ["Tháng", { content: "serverFilter" }], width: 150 },
                { id: "nam", header: ["Năm", { content: "serverFilter" }], width: 100 },
                {
                    id: "fields1", header: ["Email", { content: "filterCheckBox" }], width: 60,
                    columnType: "bit", css: { "text-align": "center" },
                    template: function (obj) {
                        var checked = obj.fields1 == "1" ? 'checked="true"' : "";
                        return ("<input disabled class='webix_table_checkbox' type='checkbox' " + checked + ">");
                    }
                },
                {
                    id: "khoan_dong_baohiem", header: [{ text: "Khoản đóng bảo hiểm bắt buộc", css: "multilineColumn" }, { content: "textFilter" }], width: 160,
                    css: { "text-align": "right" }, editor: "text", sort: "int",
                    template: function (obj, common) {
                        return obj.khoan_dong_baohiem == null ? 0 : formatDecimal(obj.khoan_dong_baohiem, 0);
                    },
                    columnType: "decimal",
                    footer: {
                        content: "summColumn", height: "22", template: function (obj) {
                            var res = formatDecimal(obj.value, 0);
                            return res;
                        }
                    }
                },
                {
                    id: "thu_nhap_chiu_thue", header: [{ text: "Tổng thu nhập chịu thuế phải khấu trừ", css: "multilineColumn" }, { content: "textFilter" }], width: 160,
                    css: { "text-align": "right" }, editor: "text", sort: "int",
                    template: function (obj, common) {
                        return obj.thu_nhap_chiu_thue == null ? 0 : formatDecimal(obj.thu_nhap_chiu_thue, 0);
                    },
                    columnType: "decimal",
                    footer: {
                        content: "summColumn", height: "22", template: function (obj) {
                            var res = formatDecimal(obj.value, 0);
                            return res;
                        }
                    }
                },
                {
                    id: "thu_nhap_tinh_thue", header: [{ text: "Tổng thu nhập tính thuế", css: "multilineColumn" }, { content: "textFilter" }], width: 160,
                    css: { "text-align": "right" }, editor: "text", sort: "int",
                    template: function (obj, common) {
                        return obj.thu_nhap_tinh_thue == null ? 0 : formatDecimal(obj.thu_nhap_tinh_thue, 0);
                    },
                    columnType: "decimal",
                    footer: {
                        content: "summColumn", height: "22", template: function (obj) {
                            var res = formatDecimal(obj.value, 0);
                            return res;
                        }
                    }
                },
                {
                    id: "thue_khau_tru", header: [{ text: "Số thuế thu nhập cá nhân đã khấu trừ", css: "multilineColumn" }, { content: "textFilter" }], width: 160,
                    css: { "text-align": "right" }, editor: "text", sort: "int",
                    template: function (obj, common) {
                        return obj.thue_khau_tru == null ? 0 : formatDecimal(obj.thue_khau_tru, 0);
                    },
                    columnType: "decimal",
                    footer: {
                        content: "summColumn", height: "22", template: function (obj) {
                            var res = formatDecimal(obj.value, 0);
                            return res;
                        }
                    }
                },
                {
                    id: "thu_nhap_dc_nhan", header: [{ text: "Thu nhập thực nhận", css: "multilineColumn" }, { content: "textFilter" }], width: 120,
                    css: { "text-align": "right" }, editor: "text", sort: "int",
                    template: function (obj, common) {
                        return obj.thu_nhap_dc_nhan == null ? 0 : formatDecimal(obj.thu_nhap_dc_nhan, 0);
                    },
                    columnType: "decimal",
                    footer: {
                        content: "summColumn", height: "22", template: function (obj) {
                            var res = formatDecimal(obj.value, 0);
                            return res;
                        }
                    }
                },
                {
                    id: "da_gui_email", header: ["Email", { content: "textFilter" }], width: 60,
                    columnType: "bit", css: { "text-align": "center" },
                    template: function (obj) {
                        var checked = obj.da_gui_email == true ? 'checked="true"' : "";
                        return ("<input disabled class='webix_table_checkbox' type='checkbox' " + checked + ">");
                    }
                    // template: "{common.checkbox()}" 
                }
                // {
                //     id: "btnViewLichsu",
                //     header: ["Xem thông báo"],
                //     css: { "text-align": "center", "color": "blue", "text-decoration": "underline" },
                //     template: function (obj) {
                //         return "<span class='btnViewLichsu'>Thông báo<span>";
                //     },
                //     width: 150
                // }
            ],
            pager: "pagerA",
        },
        {
            cols: [
                {
                    view: "button",
                    type: "icon",
                    icon: "fas fa-th-list",
                    tooltip: "chọn nhiều chứng từ",
                    width: 30,
                    on: {
                        onClick: function () {
                            changeMultiChoice();
                        }
                    },
                    click: function () {
                        this.callEvent("onClick");
                    }
                },
                {
                    view: "icon", icon: "fas fa-question-circle", id: "help_form_main", tooltip: _("HELPER"),
                    css: "helper",
                    click: function () {
                        var newWin = window.open();
                        newWin.location = "http://huongdansudung.minvoice.com.vn/Tomihoadon.html";
                    }
                },
                {
                    view: "combo",
                    label: _("MENU_QUICK"),
                    id: "QuickMenuMain",
                    options: {

                    },
                    on: {
                        onChange: function (newv, oldv) {

                        }
                    }
                },
                {},
                {
                    id: "pagerA",
                    view: "pager",
                    size: 50,
                    group: 5,
                    on: {
                        onAfterPageChange: function (id) {
                        }
                    },
                    template: function (data, common) {
                        return "Số dòng: " + data.count + ". " + common.first(data) + common.prev(data) + common.pages(data) + common.next(data) + common.last(data);
                    }
                    // template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}"
                }
            ]
        }
        ]
    };
    var kyhieu = {
        id: "kyhieu_chungtu",
        view: "combo",
        //attributes: { readonly: true },
        width: 300,
        label: _("Ký hiệu"),
        options: {
            body: {
                url: app.config.host + "/Voucher/GetSerial",
                ready: function () {
                    var count = this.count();
                    if (count > 0) {
                        var combo = webix.$$("kyhieu_chungtu");
                        combo.setValue(this.getFirstId());
                    }
                }
            }
        },
        on: {
            onChange: function (newv, oldv) {
                var table = $$(tableId);
                table.clearAll();
                table.load(table.config.url);
            }
        }
    };
    var layout = {
        css: "frmView",
        id: "frmView",
        rows: [
            {
                id: "paramKyHieu",
                view: "toolbar",
                css: { "background-color": "#f5f5f5 !important" },
                borderless: true,
                height: 35,
                cols: [
                    kyhieu
                ]
            },
            {
                id: "btnRegister",
                height: 39,
                css: "btnControl",
                type: "toolbar",
                margin: 0,
                borderless: true,
                // hidden: true,
                cols: controls
            },
            {
                rows: [table],
            },
        ],
    };
    return {
        $ui: layout,
        $oninit: function (view, $scope) {
            var table = webix.$$(tableId);
            $scope.on(app, "dataChangeChungtuTNCN", function (mode, item) {
                table.clearAll();
                table.load(table.config.url);
            });
            $scope.on(app, "filterTable", function (report_id, infoWindowId, item) {
            });
        },
        $onurlchange: function (ui, name, url, scope) {
            initUI();
        }
    };
});
define('views/forms/forms68/DangKySD/68_dangkyForms',[
    "app",
    "locale",
    "models/user",
    "views/modules/minvoiceplugin"
], function (app, _, user, minvoiceplugin) {
    'use strict';

    webix.$$("title").parse({ title: "Đăng ký sử dụng", details: "Đăng ký sử dụng" });
    var editmode = 0;
    var thongtin = {
        rows: [
            {
                cols: [
                    {},
                    { gravity: 0.25 },
                    {
                        id: "hthuc", name: "hthuc",
                        view: "radio", value: 1,
                        css: "radioRegister",
                        options: [
                            { id: "1", value: "Đăng ký mới" },
                            { id: "2", value: "Thay đổi thông tin" }
                        ],
                        on: {
                            onChange: function (newValue, oldValue, config) {
                                // if (newValue == 2) {
                                //     var tableHoadon = $$("dangkysudungForms");
                                //     webix.extend(tableHoadon, webix.ProgressBar);
                                //     tableHoadon.disable();
                                //     tableHoadon.showProgress();
                                //     var url = app.config.host + "/Register68/GetSerialAcceptInvoice";
                                //     webix.ajax()
                                //         .headers({ 'Content-type': 'application/json' })
                                //         .get(url, {
                                //             error: function (text, data, XmlHttpRequest) {
                                //                 tableHoadon.enable();
                                //                 tableHoadon.hideProgress();
                                //                 webix.message(text + XmlHttpRequest, "error");

                                //             }, success: function (text, data, XmlHttpRequest) {
                                //                 tableHoadon.enable();
                                //                 tableHoadon.hideProgress();
                                //                 var data = JSON.parse(text);
                                //                 $$("danhsach_chukyso").parse(data);
                                //             }
                                //         });
                                // }
                                // if (newValue == 1) {
                                //     $$("danhsach_chukyso").clearAll();
                                // }
                            }
                        }
                    },
                    {}
                ]
            },
            {
                view: "datepicker",
                name: "nlap",
                label: "Ngày lập:",
                id: "nlap",
                css: "nlapRegister",
                value: new Date(),
                width: 280,
                required: true,
                invalidMessage: "Ngày lập không được để trống !",
                validate: webix.rules.isEmpty
            },
            {
                view: "text",
                label: "Tên người nộp thuế:",
                name: "tnnt",
                id: "tnnt",
                css: "tnntRegister",
                required: true,
                invalidMessage: "Tên đơn vị không được để trống !",
                validate: webix.rules.isEmpty
                // css: "mcls_uppercase",
            },
            {
                view: "text",
                label: "Mã số thuế:",
                id: "mst",
                name: "mst",
                css: "mstRegister",
                on: {
                    onSearchIconClick: function () {
                    }
                }
            },
            {
                view: "combo",
                name: "mcqtqly",
                label: "Cơ quan thuế quản lý:",
                id: "mcqtqly",
                css: "mcqtqlyRegister",
                required: true,
                validate: webix.rules.isEmpty,
                invalidMessage: "Cơ quan thuế quản lý không thể bỏ trống !",
                options: {
                    view: "gridsuggest",
                    scroll: true,
                    autoheight: false,
                    template: "#value#",
                    url: app.config.host + "/Pattern/GetTaxQL",
                    body: {
                        scroll: true,
                        autoheight: false,
                        columns: [
                            { id: "id", header: _("Mã"), width: 80 },
                            { id: "value", header: _("Tên"), width: 400 }
                        ],
                        dataFeed: function (filtervalue, filter) {
                            if (filtervalue.length < 1) {
                                this.load(this.config.url);
                                return;
                            }
                            var pathUrl = app.config.host + "/Pattern/GetTaxQL?";
                            var urldata = "val=" + encodeURIComponent(filtervalue);
                            this.load(pathUrl + urldata, this.config.datatype);
                        }
                    },
                    on: {
                        onValueSuggest: function (obj) {
                            // $$("cqtqly").setValue(obj.value);
                        }
                    }
                }
            },
            {
                view: "text",
                label: "Nơi lập:",
                css: "mcqtqlyRegister",
                id: "ddanh",
                name: "ddanh",
                required: true,
                invalidMessage: "Nơi lập không được để trống !",
                validate: webix.rules.isEmpty
            }
        ]
    };
    var nguoilienhe = {
        rows: [
            {
                view: "text",
                label: "Người liên hệ:",
                css: "mcqtqlyRegister",
                id: "nlhe",
                name: "nlhe",
                required: true,
                invalidMessage: "Người liên hệ không được để trống !",
                validate: webix.rules.isEmpty
            },
            {
                view: "text",
                label: "Địa chỉ liên hệ:",
                css: "mcqtqlyRegister",
                id: "dclhe",
                name: "dclhe",
                required: true,
                invalidMessage: "Địa chỉ liên hệ không được để trống !",
                validate: webix.rules.isEmpty
            },
            {
                view: "text",
                label: "Thư điện tử:",
                id: "dctdtu",
                name: "dctdtu",
                css: "mcqtqlyRegister",
                required: true,
                invalidMessage: "Thư điện tử không được để trống !",
                validate: webix.rules.isEmail,
                on: {
                    onTimedKeyPress: function () {
                        var countMail = $$("dctdtu").getValue().split(/[\s,\;]+/);
                        // console.log(countMail);
                        if (countMail.length > 1) {
                            webix.message("Bạn không được phép nhập quá 1 thư điện tử", "debug");
                            return;
                        }
                    }
                }
            },
            {
                view: "text",
                label: "Điện thoại liên hệ:",
                id: "dtlhe",
                name: "dtlhe",
                css: "mcqtqlyRegister",
                required: true,
                //pattern:{ mask:"###-## ########"},
                invalidMessage: "Điện thoại liên hệ không được để trống !",
                validate: webix.rules.isEmpty
            }
        ]
    };

    return {
        $ui: {
            view: "window",
            modal: true,
            position: function (state) {
                state.width = state.maxWidth * 0.6;
                state.height = state.maxHeight * 0.9;
                state.left = (state.maxWidth - state.width) / 2;
                state.top = (state.maxHeight - state.height) / 2;
            },
            css: "headformchil",
            id: "dangkysudungForms",
            resize: true,
            fullscreen: true,
            move: true,
            head: false,
            on: {
                onShow: function () {
                    var self = this;
                    $(".webix_modal").one("click", function () {
                        self.close();
                    });
                }
            },
            body: {
                view: "form",
                id: "dangkysudung",
                // width: 1500,
                position: "center",
                // autowidth:true,
                elementsConfig: { labelWidth: 150 },
                paddingY: 10,
                paddingX: 15,
                complexData: true,
                scroll: true,
                margin: 0,
                elements: [
                    {
                        view: "label", template: function (obj) { return "<div class='headRegisters'>TỜ KHAI</div>"; }
                    },
                    {
                        view: "label", template: function (obj) { return "<div class='headRegister'>Đăng ký/Thay đổi thông tin sử dụng hóa đơn điện tử</div>"; }
                    },
                    thongtin,
                    { height: 8 },
                    {
                        view: "label", css: "lblResgister", template: function () {
                            return `<div><i class='mdi mdi-18px mdi-lightbulb-on-10'></i>
                            <i>Sau khi tờ khai được <b>chấp nhận</b>, cơ quan thuế sẽ <b>gửi các thông báo quan trọng</b>
                             liên quan đến hóa đơn điện tử tới email/số điện thoại/địa chỉ này.</i></div>`;
                        }
                    },
                    { height: 5 },
                    nguoilienhe,
                    {
                        view: "label", autoheight: true, css: "lblResgisterMess", template: function () {
                            return `<div><span>Theo nghị định số 123/2020/NĐ-CP ngày 19 tháng 10 năm 2020 của chính phủ,
                             chúng tôi/tôi thuộc đối tượng sử dụng hóa đơn điện tử.
                             Chúng tôi/tôi đăng ký/thay đổi thông tin đã đăng ký với cơ quan thuế về việc sử dụng hóa đơn điện tử như sau:</span></div>`;
                        }
                    },
                    {
                        rows: [
                            { view: "label", label: "<b>1. Hình thức hóa đơn:</b>" },
                            {
                                view: "checkbox",
                                id: "cma",
                                name: "cma",
                                labelRight: "Có mã của cơ quan thuế",
                                labelWidth: 0,
                                on: {
                                    onChange: function (newv, oldv) {
                                        if (newv == 1) {
                                            $$("cddu").setValue(1);
                                            $$("cdlttdcqt").disable();
                                            $$("cdlqtvan").disable();
                                            $$("nntdbkkhan").disable();
                                            $$("nntktdnubnd").disable();
                                        }
                                        else {
                                            $$("cddu").setValue(0);
                                            $$("cdlttdcqt").enable();
                                            $$("cdlqtvan").enable();
                                            $$("nntdbkkhan").enable();
                                            $$("nntktdnubnd").enable();
                                        }
                                    }
                                }
                            },
                            {
                                view: "checkbox", id: "cmtmttien", name: "cmtmttien",
                                labelRight: "Có mã của cơ quan thuế (Khởi tạo từ máy tính tiền)", labelWidth: 0, on: {
                                    onChange: function (newv, oldv) {
                                        if (newv == 1) {
                                            $$("cddu").setValue(1);
                                            $$("cdlttdcqt").disable();
                                            $$("cdlqtvan").disable();
                                            $$("nntdbkkhan").disable();
                                            $$("nntktdnubnd").disable();
                                        }
                                        else {
                                            $$("cddu").setValue(0);
                                            $$("cdlttdcqt").enable();
                                            $$("cdlqtvan").enable();
                                            $$("nntdbkkhan").enable();
                                            $$("nntktdnubnd").enable();
                                        }
                                    }
                                }
                            },
                            {
                                view: "checkbox",
                                id: "kcma",
                                name: "kcma",
                                // value: 1,
                                labelRight: "Không có mã của cơ quan thuế",
                                labelWidth: 0,
                                on: {
                                    onChange: function (newv, oldv) {
                                        if (newv == 1) {
                                            $$("cddu").setValue(1);
                                            $$("cdlqtvan").setValue(1);
                                            $$("cdlttdcqt").disable();
                                            $$("cdlqtvan").disable();
                                            $$("nntdbkkhan").disable();
                                            $$("nntktdnubnd").disable();
                                        }
                                        else {
                                            $$("cddu").setValue(0);
                                            $$("cdlqtvan").setValue(0);
                                            $$("cdlttdcqt").enable();
                                            $$("cdlqtvan").enable();
                                            $$("nntdbkkhan").enable();
                                            $$("nntktdnubnd").enable();
                                        }
                                    }
                                }
                            },
                            { view: "label", label: "<b>2. Hình thức gửi dữ liệu hóa đơn điện tử:</b>" },
                            {
                                view: "label", css: "lblResgister", template: function () {
                                    return `<div><i class='mdi mdi-18px mdi-lightbulb-on-10'></i>
                                    <i>Vui lòng bỏ qua nếu bạn không thuộc đối tượng nào trong các đối tượng dưới đây.</i></div>`;
                                }
                            },
                            {
                                view: "label", template: function () {
                                    return `<div>a. Trường hợp sử dụng hóa đơn điện tử có mã không phải trả tiền dịch vụ theo khoản 1 Điều 14 của Nghị định:</div>`;
                                }
                            },
                            {
                                view: "checkbox",
                                id: "nntdbkkhan",
                                name: "nntdbkkhan",
                                css: "lblCheckbox",
                                autoheight: true,
                                labelRight: "Doanh nghiệp nhỏ và vừa, hợp tác xã, hộ, cá nhân kinh doanh tại địa bàn có điều kiện kinh tế xã hội khó khăn, địa bàn có điều kiện kinh tế xã hội đặc biệt khó khăn.",
                                labelWidth: 0,
                                on: {
                                    onChange: function (newv, oldv) {
                                        if (newv == 1) {
                                            $$("nntdbkkhan").setValue(1);
                                            $$("cdlttdcqt").setValue(0);
                                            $$("cdlqtvan").setValue(0);
                                            $$("nntktdnubnd").setValue(0);
                                        }
                                    }
                                }
                            },
                            {
                                view: "checkbox",
                                id: "nntktdnubnd",
                                name: "nntktdnubnd",
                                css: "lblCheckbox",
                                labelRight: "Doanh nghiệp nhỏ và vừa khác theo đề nghị của Ủy ban nhân dân tỉnh, thành phố trực thuộc trung ương gửi Bộ Tài chính trừ doanh nghiệp hoạt động tại các khu kinh tế, khu công nghiệp, khu công nghệ cao.",
                                labelWidth: 0,
                                on: {
                                    onChange: function (newv, oldv) {
                                        if (newv == 1) {
                                            $$("nntktdnubnd").setValue(1);
                                            $$("cdlttdcqt").setValue(0);
                                            $$("cdlqtvan").setValue(0);
                                            $$("nntdbkkhan").setValue(0);
                                        }
                                    }
                                }
                            },
                            {
                                view: "label", template: function () {
                                    return `<div>b. Trường hợp sử dụng hóa đơn điện tử không có mã của cơ quan thuế:</div>`;
                                }
                            },
                            {
                                view: "checkbox",
                                id: "cdlqtvan",
                                name: "cdlqtvan",
                                //value: 1,
                                labelRight: "Thông qua tổ chức truyền nhận hóa đơn điện tử (điểm b2, khoản 3, Điều 22 của Nghị định).",
                                labelWidth: 0,
                                on: {
                                    onChange: function (newv, oldv) {
                                        if (newv == 1) {
                                            $$("cdlqtvan").setValue(1);
                                            $$("cdlttdcqt").setValue(0);
                                            $$("nntdbkkhan").setValue(0);
                                            $$("nntktdnubnd").setValue(0);
                                        }
                                    }
                                }
                            },
                            {
                                view: "checkbox",
                                id: "cdlttdcqt",
                                name: "cdlttdcqt",
                                labelRight: "Chuyển dữ liệu hóa đơn điện tử trực tiếp đến cơ quan thuế (điểm b1, khoản 3, Điều 22 của Nghị định).",
                                labelWidth: 0,
                                on: {
                                    onChange: function (newv, oldv) {
                                        if (newv == 1) {
                                            $$("cdlttdcqt").setValue(1);
                                            $$("cdlqtvan").setValue(0);
                                            $$("nntktdnubnd").setValue(0);
                                            $$("nntdbkkhan").setValue(0);
                                        }
                                    }
                                }
                            },
                            {
                                rows: [
                                    { view: "label", label: "<b>3. Phương thức chuyển dữ liệu hóa đơn điện tử:</b>" },
                                    {
                                        view: "checkbox",
                                        id: "cddu",
                                        name: "cddu",
                                        //value: 1,
                                        labelRight: "Chuyển đầy đủ nội dung từng hóa đơn.",
                                        labelWidth: 0,
                                        on: {
                                            onChange: function (newv, oldv) {
                                                // if (newv == 1) {
                                                //     $$("cddu").setValue(1);
                                                //     $$("cbthop").setValue(0);
                                                // }
                                            }
                                        }
                                    },
                                    {
                                        view: "checkbox",
                                        id: "cbthop",
                                        name: "cbthop",
                                        labelRight: "Chuyển theo bảng tổng hợp dữ liệu hóa đơn điện tử (điểm a1, khoản 3, Điều 22 của Nghị định).",
                                        labelWidth: 0,
                                        on: {
                                            onChange: function (newv, oldv) {
                                                // if (newv == 1) {
                                                //     $$("cddu").setValue(0);
                                                //     $$("cbthop").setValue(1);
                                                // }
                                            }
                                        }
                                    },
                                ]
                            },
                            { view: "label", label: "<b>4. Loại hóa đơn sử dụng:</b>" },
                            {
                                view: "checkbox",
                                id: "hdgtgt",
                                name: "hdgtgt",
                                labelRight: "Hóa đơn giá trị gia tăng",
                                //value: 1,
                                labelWidth: 0
                            },
                            {
                                view: "checkbox",
                                id: "hdbhang",
                                name: "hdbhang",
                                labelRight: "Hóa đơn bán hàng",
                                labelWidth: 0
                            },
                            {
                                view: "checkbox",
                                id: "hdkhac",
                                name: "hdkhac",
                                labelRight: "Các loại hóa đơn khác",
                                labelWidth: 0
                            },
                            {
                                view: "checkbox",
                                id: "ctu",
                                name: "ctu",
                                labelRight: "Các chứng từ được in, phát hành, sử dụng và quản lý như hóa đơn",
                                labelWidth: 0
                            }
                        ]
                    },
                    {
                        rows: [
                            {
                                view: "label", label: "5. Danh sách chứng thư số sử dụng:", css: { "font-weight": "bold" }
                            },
                            {
                                cols: [
                                    {
                                        view: "button",
                                        type: "icon",
                                        icon: "mdi mdi-plus-box-outline",
                                        width: 123,
                                        label: "Thêm dòng (F9)",
                                        css: "btnForm",
                                        on: {
                                            onItemClick: function (id, e) {
                                                webix.ajax().headers({ 'Content-Type': 'application/json' })
                                                    .get(app.config.host + "/Pattern/GetSignType", function (text) {
                                                        var result = JSON.parse(text);
                                                        var kytaptrung = result[0].gia_tri;
                                                        switch (kytaptrung.toUpperCase()) {
                                                            case "FILE":
                                                                var box = webix.modalbox({
                                                                    title: "CHỌN CHỨNG THƯ SỐ",
                                                                    buttons: ["Nhận", "Hủy bỏ"],
                                                                    text: "<div id='ctnCerts'></div>",
                                                                    top: 100,
                                                                    width: 750,
                                                                    callback: function (result) {
                                                                        switch (result) {
                                                                            case "1":
                                                                                webix.modalbox.hide();
                                                                                break;
                                                                            case "0":
                                                                                var table = $$("tblCerts");
                                                                                var data = table.serialize();
                                                                                var cert = null;
                                                                                for (var i = 0; i < data.length; i++) {
                                                                                    if (data[i].chon == true) {
                                                                                        cert = data[i];
                                                                                        break;
                                                                                    }
                                                                                }
                                                                                if (cert == null) {
                                                                                    webix.message("Bạn chưa chọn chứng thư số");
                                                                                    return;
                                                                                }
                                                                                var table = webix.$$("danhsach_chukyso");
                                                                                var item = {
                                                                                    stt: table.count() + 1,
                                                                                    seri: cert.so_serial,
                                                                                    tngay: cert.ngaybatdau,
                                                                                    dngay: cert.ngayketthuc,
                                                                                    ttchuc: cert.issuer,
                                                                                    hthuc: 1
                                                                                };
                                                                                table.add(item);
                                                                                return;
                                                                        }
                                                                    }
                                                                });
                                                                var tblMatHang = webix.ui({
                                                                    container: "ctnCerts",
                                                                    id: "tblCerts",
                                                                    view: "datatable",
                                                                    borderless: true,
                                                                    resizeColumn: true,
                                                                    height: 350,
                                                                    columns: [
                                                                        {
                                                                            id: "chon", header: _("CHON"),
                                                                            width: 65, checkValue: true, uncheckValue: false, template: "{common.checkbox()}"
                                                                        },
                                                                        { id: "so_serial", header: _("SO_SERIAL"), width: 150 },
                                                                        { id: "subjectname", header: _("SUBJECTNAME"), width: 450 },
                                                                        { id: "ngaybatdau", header: _("NGAY_BAT_DAU"), width: 200 },
                                                                        { id: "ngayketthuc", header: _("NGAY_KET_THUC"), width: 200 },
                                                                        { id: "issuer", header: _("DONVI"), width: 450 }
                                                                    ],
                                                                    url: app.config.host + "/Invoice/GetListCertificatesFile"
                                                                });
                                                                break;
                                                            case "EASYCA":
                                                                var box = webix.modalbox({
                                                                    title: "Chọn chứng thư số EASYCA",
                                                                    buttons: ["Nhận", "Hủy bỏ"],
                                                                    text: "<div id='ctnCerts'></div>",
                                                                    top: 100,
                                                                    width: 750,
                                                                    callback: function (result) {
                                                                        switch (result) {
                                                                            case "1":
                                                                                webix.modalbox.hide();
                                                                                break;
                                                                            case "0":
                                                                                var table = $$("tblCerts");
                                                                                var data = table.serialize();
                                                                                var cert = null;
                                                                                for (var i = 0; i < data.length; i++) {
                                                                                    if (data[i].chon == true) {
                                                                                        cert = data[i];
                                                                                        break;
                                                                                    }
                                                                                }
                                                                                if (cert == null) {
                                                                                    webix.message("Bạn chưa chọn chứng thư số", "debug");
                                                                                    return;
                                                                                }
                                                                                var table = webix.$$("danhsach_chukyso");
                                                                                var item = {
                                                                                    stt: table.count() + 1,
                                                                                    seri: cert.so_serial,
                                                                                    tngay: cert.ngaybatdau,
                                                                                    dngay: cert.ngayketthuc,
                                                                                    ttchuc: cert.issuer,
                                                                                    hthuc: 1
                                                                                };
                                                                                table.add(item);
                                                                                return;
                                                                        }
                                                                    }
                                                                });
                                                                var popupText = document.getElementsByClassName("webix_popup_text")[0];
                                                                popupText.style.paddingTop = 0;
                                                                var tblMatHang = webix.ui({
                                                                    container: "ctnCerts",
                                                                    id: "tblCerts",
                                                                    view: "datatable",
                                                                    borderless: true,
                                                                    resizeColumn: true,
                                                                    height: 350,
                                                                    columns: [
                                                                        {
                                                                            id: "chon",
                                                                            header: _("CHON"),
                                                                            width: 65,
                                                                            checkValue: true,
                                                                            uncheckValue: false,
                                                                            template: "{common.checkbox()}"
                                                                        },
                                                                        { id: "libraryName", header: _("Loại"), width: 150 },
                                                                        { id: "so_serial", header: _("SO_SERIAL"), width: 150 },
                                                                        { id: "subjectname", header: _("SUBJECTNAME"), width: 450 },
                                                                        { id: "ngaybatdau", header: _("NGAY_BAT_DAU"), width: 200 },
                                                                        { id: "ngayketthuc", header: _("NGAY_KET_THUC"), width: 200 },
                                                                        { id: "issuer", header: _("DONVI"), width: 450 }
                                                                    ],
                                                                    url: app.config.host + "/Invoice/GetListCertificatesEasyCA"
                                                                });
                                                                break;
                                                            case "ICA":
                                                                var box = webix.modalbox({
                                                                    title: "Chọn chứng thư số ICA",
                                                                    buttons: ["Nhận", "Hủy bỏ"],
                                                                    text: "<div id='ctnCerts'></div>",
                                                                    top: 100,
                                                                    width: 750,
                                                                    callback: function (result) {
                                                                        switch (result) {
                                                                            case "1":
                                                                                webix.modalbox.hide();
                                                                                break;
                                                                            case "0":
                                                                                var table = $$("tblCerts");
                                                                                var data = table.serialize();
                                                                                var cert = null;
                                                                                for (var i = 0; i < data.length; i++) {
                                                                                    if (data[i].chon == true) {
                                                                                        cert = data[i];
                                                                                        break;
                                                                                    }
                                                                                }
                                                                                if (cert == null) {
                                                                                    webix.message("Bạn chưa chọn chứng thư số", "debug");
                                                                                    return;
                                                                                }
                                                                                var table = webix.$$("danhsach_chukyso");
                                                                                var item = {
                                                                                    stt: table.count() + 1,
                                                                                    seri: cert.so_serial,
                                                                                    tngay: cert.ngaybatdau,
                                                                                    dngay: cert.ngayketthuc,
                                                                                    ttchuc: cert.issuer,
                                                                                    hthuc: 1
                                                                                };
                                                                                table.add(item);
                                                                                return;
                                                                        }
                                                                    }
                                                                });
                                                                var popupText = document.getElementsByClassName("webix_popup_text")[0];
                                                                popupText.style.paddingTop = 0;
                                                                var tblMatHang = webix.ui({
                                                                    container: "ctnCerts",
                                                                    id: "tblCerts",
                                                                    view: "datatable",
                                                                    borderless: true,
                                                                    resizeColumn: true,
                                                                    height: 350,
                                                                    columns: [
                                                                        {
                                                                            id: "chon",
                                                                            header: _("CHON"),
                                                                            width: 65,
                                                                            checkValue: true,
                                                                            uncheckValue: false,
                                                                            template: "{common.checkbox()}"
                                                                        },
                                                                        { id: "libraryName", header: _("Loại"), width: 150 },
                                                                        { id: "so_serial", header: _("SO_SERIAL"), width: 150 },
                                                                        { id: "subjectname", header: _("SUBJECTNAME"), width: 450 },
                                                                        { id: "ngaybatdau", header: _("NGAY_BAT_DAU"), width: 200 },
                                                                        { id: "ngayketthuc", header: _("NGAY_KET_THUC"), width: 200 },
                                                                        { id: "issuer", header: _("DONVI"), width: 450 }
                                                                    ],
                                                                    url: app.config.host + "/Invoice/GetListCertificatesAuto"
                                                                });
                                                                break;
                                                            case "NCCA":
                                                                var box = webix.modalbox({
                                                                    title: "Chọn chứng thư số NCCA",
                                                                    buttons: ["Nhận", "Hủy bỏ"],
                                                                    text: "<div id='ctnCerts'></div>",
                                                                    top: 100,
                                                                    width: 750,
                                                                    callback: function (result) {
                                                                        switch (result) {
                                                                            case "1":
                                                                                webix.modalbox.hide();
                                                                                break;
                                                                            case "0":
                                                                                var table = $$("tblCerts");
                                                                                var data = table.serialize();
                                                                                var cert = null;
                                                                                for (var i = 0; i < data.length; i++) {
                                                                                    if (data[i].chon == true) {
                                                                                        cert = data[i];
                                                                                        break;
                                                                                    }
                                                                                }
                                                                                if (cert == null) {
                                                                                    webix.message("Bạn chưa chọn chứng thư số", "debug");
                                                                                    return;
                                                                                }
                                                                                var table = webix.$$("danhsach_chukyso");
                                                                                var item = {
                                                                                    stt: table.count() + 1,
                                                                                    seri: cert.so_serial,
                                                                                    tngay: cert.ngaybatdau,
                                                                                    dngay: cert.ngayketthuc,
                                                                                    ttchuc: cert.issuer,
                                                                                    hthuc: 1
                                                                                };
                                                                                table.add(item);
                                                                                return;
                                                                        }
                                                                    }
                                                                });
                                                                var popupText = document.getElementsByClassName("webix_popup_text")[0];
                                                                popupText.style.paddingTop = 0;
                                                                var tblMatHang = webix.ui({
                                                                    container: "ctnCerts",
                                                                    id: "tblCerts",
                                                                    view: "datatable",
                                                                    borderless: true,
                                                                    resizeColumn: true,
                                                                    height: 350,
                                                                    columns: [
                                                                        {
                                                                            id: "chon",
                                                                            header: _("CHON"),
                                                                            width: 65,
                                                                            checkValue: true,
                                                                            uncheckValue: false,
                                                                            template: "{common.checkbox()}"
                                                                        },
                                                                        { id: "libraryName", header: _("Loại"), width: 150 },
                                                                        { id: "so_serial", header: _("SO_SERIAL"), width: 150 },
                                                                        { id: "subjectname", header: _("SUBJECTNAME"), width: 450 },
                                                                        { id: "ngaybatdau", header: _("NGAY_BAT_DAU"), width: 200 },
                                                                        { id: "ngayketthuc", header: _("NGAY_KET_THUC"), width: 200 },
                                                                        { id: "issuer", header: _("DONVI"), width: 450 }
                                                                    ],
                                                                    url: app.config.host + "/Invoice/GetListCertificatesAuto"
                                                                });
                                                                break;
                                                            case "K":
                                                                var hub = minvoiceplugin.hub();
                                                                var hubconnect = minvoiceplugin.conn();
                                                                if (hubconnect.state != 1) {
                                                                    var form = webix.$$("chukyso-form");
                                                                    form.enable();
                                                                    form.hideProgress();
                                                                    webix.message("Quý khách hàng chưa cài Plugin ký hóa đơn hoặc Plugin ký hóa đơn chưa được bật !", "error");
                                                                    return;
                                                                }
                                                                else {
                                                                    hub.off("resCommand");
                                                                    hub.on("resCommand", function (response) {
                                                                        var result = JSON.parse(response);
                                                                        if (result.hasOwnProperty("error")) {
                                                                            webix.message(result.error, "error");
                                                                        } else {
                                                                            var table = webix.$$("danhsach_chukyso");
                                                                            var item = {
                                                                                stt: table.count() + 1,
                                                                                seri: result.data.so_serial,
                                                                                tngay: result.data.ngaybatdau,
                                                                                dngay: result.data.ngayketthuc,
                                                                                ttchuc: result.data.issuer,
                                                                                hthuc: 1
                                                                            };
                                                                            table.add(item);
                                                                        }
                                                                    });
                                                                    var f = {
                                                                        callback: "RegisterCert"
                                                                    };
                                                                    hub.invoke("execCommand", f.callback, JSON.stringify(f));
                                                                }
                                                                break;
                                                            case "INTRUSTCA":
                                                                var box = webix.modalbox({
                                                                    title: "Chọn chứng thư số IntrustCa",
                                                                    buttons: ["Nhận", "Hủy bỏ"],
                                                                    text: "<div id='ctnCerts'></div>",
                                                                    top: 100,
                                                                    width: 750,
                                                                    callback: function (result) {
                                                                        switch (result) {
                                                                            case "1":
                                                                                webix.modalbox.hide();
                                                                                break;
                                                                            case "0":
                                                                                var table = $$("tblCerts");
                                                                                var data = table.serialize();
                                                                                var cert = [];
                                                                                for (var i = 0; i < data.length; i++) {
                                                                                    if (data[i].chon == true)
                                                                                        cert.push(data[i]);
                                                                                }

                                                                                if (cert.length == 0) {
                                                                                    webix.message("Bạn chưa chọn chứng thư số", "debug");
                                                                                    return;
                                                                                }
                                                                                var table = webix.$$("danhsach_chukyso");
                                                                                cert.forEach((element) => {
                                                                                    var item = {
                                                                                        stt: table.count() + 1,
                                                                                        seri: element.so_serial,
                                                                                        tngay: element.ngaybatdau,
                                                                                        dngay: element.ngayketthuc,
                                                                                        ttchuc: element.issuer,
                                                                                        hthuc: 1
                                                                                    };
                                                                                    table.add(item);
                                                                                })
                                                                                return;
                                                                        }
                                                                    }
                                                                });
                                                                var popupText = document.getElementsByClassName("webix_popup_text")[0];
                                                                popupText.style.paddingTop = 0;
                                                                var cert = webix.ui({
                                                                    container: "ctnCerts",
                                                                    id: "tblCerts",
                                                                    view: "datatable",
                                                                    borderless: true,
                                                                    resizeColumn: true,
                                                                    height: 350,
                                                                    columns: [
                                                                        {
                                                                            id: "chon",
                                                                            header: _("CHON"),
                                                                            width: 60,
                                                                            checkValue: true,
                                                                            uncheckValue: false,
                                                                            template: "{common.checkbox()}"
                                                                        },
                                                                        { id: "libraryName", header: _("Loại"), width: 150 },
                                                                        { id: "so_serial", header: _("SO_SERIAL"), width: 250 },
                                                                        { id: "subjectname", header: _("SUBJECTNAME"), width: 300 },
                                                                        { id: "ngaybatdau", header: _("NGAY_BAT_DAU"), width: 200 },
                                                                        { id: "ngayketthuc", header: _("NGAY_KET_THUC"), width: 200 },
                                                                        { id: "issuer", header: _("DONVI"), width: 450 }
                                                                    ],
                                                                    url: app.config.host + "/Invoice/GetListCertificatesAuto",
                                                                });
                                                                break;
                                                            case "VNET":
                                                                var box = webix.modalbox({
                                                                    title: "Chọn chứng thư số Vnet",
                                                                    buttons: ["Nhận", "Hủy bỏ"],
                                                                    text: "<div id='ctnCerts'></div>",
                                                                    top: 100,
                                                                    width: 750,
                                                                    callback: function (result) {
                                                                        switch (result) {
                                                                            case "1":
                                                                                webix.modalbox.hide();
                                                                                break;
                                                                            case "0":
                                                                                var table = $$("tblCerts");
                                                                                var data = table.serialize();
                                                                                var cert = [];
                                                                                for (var i = 0; i < data.length; i++) {
                                                                                    if (data[i].chon == true)
                                                                                        cert.push(data[i]);
                                                                                }

                                                                                if (cert.length == 0) {
                                                                                    webix.message("Bạn chưa chọn chứng thư số", "debug");
                                                                                    return;
                                                                                }
                                                                                var table = webix.$$("danhsach_chukyso");
                                                                                cert.forEach((element) => {
                                                                                    var item = {
                                                                                        stt: table.count() + 1,
                                                                                        seri: element.so_serial,
                                                                                        tngay: element.ngaybatdau,
                                                                                        dngay: element.ngayketthuc,
                                                                                        ttchuc: element.issuer,
                                                                                        hthuc: 1
                                                                                    };
                                                                                    table.add(item);
                                                                                })
                                                                                return;
                                                                        }
                                                                    }
                                                                });
                                                                var popupText = document.getElementsByClassName("webix_popup_text")[0];
                                                                popupText.style.paddingTop = 0;
                                                                var cert = webix.ui({
                                                                    container: "ctnCerts",
                                                                    id: "tblCerts",
                                                                    view: "datatable",
                                                                    borderless: true,
                                                                    resizeColumn: true,
                                                                    height: 350,
                                                                    columns: [
                                                                        {
                                                                            id: "chon",
                                                                            header: _("CHON"),
                                                                            width: 60,
                                                                            checkValue: true,
                                                                            uncheckValue: false,
                                                                            template: "{common.checkbox()}"
                                                                        },
                                                                        { id: "libraryName", header: _("Loại"), width: 150 },
                                                                        { id: "so_serial", header: _("SO_SERIAL"), width: 250 },
                                                                        { id: "subjectname", header: _("SUBJECTNAME"), width: 300 },
                                                                        { id: "ngaybatdau", header: _("NGAY_BAT_DAU"), width: 200 },
                                                                        { id: "ngayketthuc", header: _("NGAY_KET_THUC"), width: 200 },
                                                                        { id: "issuer", header: _("DONVI"), width: 450 }
                                                                    ],
                                                                    url: app.config.host + "/Invoice/GetListCertificatesAuto",
                                                                });
                                                                break;
                                                        }
                                                    });
                                            }
                                        }
                                    },
                                    {
                                        view: "button",
                                        type: "icon",
                                        icon: "mdi mdi-minus-box-outline",
                                        width: 115,
                                        label: "Xóa dòng (F8)",
                                        css: "btnForm",
                                        on: {
                                            onItemClick: function (id, e) {
                                                var table = webix.$$("danhsach_chukyso");
                                                table.editStop();
                                                var item = table.getSelectedItem();
                                                if (!webix.isUndefined(item)) {
                                                    table.remove(item.id);
                                                    table.clearSelection();
                                                    return;
                                                }
                                                var editor = table.getEditState();
                                                if (!webix.isUndefined(editor)) {
                                                    table.remove(editor.row);
                                                    table.clearSelection();
                                                    return;
                                                }
                                            },
                                        },
                                    },
                                    {}
                                ],
                            },
                            {
                                view: "datatable",
                                id: "danhsach_chukyso",
                                height: 250,
                                name: "danhsach_chukyso",
                                select: true,
                                resizeColumn: true,
                                footer: false,
                                tooltip: true,
                                editable: true,
                                scheme: {
                                    $init: function (obj) {

                                    },
                                },
                                on: {

                                },
                                columns: [
                                    {
                                        id: "stt", name: "stt", header: "STT", sort: "int", width: 40,
                                    },
                                    {
                                        id: "ttchuc", name: "ttchuc", width: 250, header: [{ text: "<center>Tên tổ chức cơ quan chứng thực/cấp/công nhận chữ ký số, chữ ký điện tử</center>", css: "multilineColumn" }]
                                    },
                                    {
                                        id: "seri", name: "seri", header: "Số sê-ri chứng thư số", width: 300
                                    },
                                    {
                                        id: "tngay",
                                        name: "tngay",
                                        header: [
                                            {
                                                "text": "Thời hạn sử dụng chứng thư số",
                                                "colspan": 2
                                            },
                                            {
                                                "text": "Từ ngày"
                                            }
                                        ],
                                        width: 180
                                        //format: webix.i18n.dateFormatStr,
                                    },
                                    {
                                        id: "dngay",
                                        name: "dngay",
                                        header: [
                                            null,
                                            {
                                                "text": "Đến ngày"
                                            }
                                        ],
                                        width: 180
                                        //format: webix.i18n.dateFormatStr,
                                    },
                                    {
                                        id: "hthuc",
                                        name: "hthuc",
                                        width: 130,
                                        header: [{ text: "<center>Hình thức đăng ký ( Thêm mới, Gia hạn, ngừng sử dụng)</center>", css: "multilineColumn" }],
                                        editor: "combo",
                                        options: [
                                            { id: "1", value: "Thêm mới" },
                                            { id: "2", value: "Gia hạn" },
                                            { id: "3", value: "Ngừng sử dụng" }
                                        ]
                                    },

                                ]
                            }
                        ]
                    },
                    { height: 8 },
                    {
                        cols: [
                            {},
                            {
                                shortcut: "F10",
                                view: "button",
                                label: "Ghi (F10)",
                                id: "btnDKSDSave1",
                                width: 150,
                                align: "center",
                                type: "form",
                                on: {
                                    onClick: function () {
                                        var item = $$("dangkysudung").getValues();
                                        var form = $$("dangkysudungForms");
                                        var table = $$("dangkysudung");

                                        var countMail = $$("dctdtu").getValue().split(/[\s,\;]+/);
                                        if (countMail.length > 1) {
                                            webix.message("Bạn không được phép nhập quá 1 email", "debug");
                                            return;
                                        }
                                        if (table.validate()) {
                                            var cks = $$("danhsach_chukyso").serialize();
                                            if (cks.length == 0) {
                                                webix.message("Bạn chưa đăng ký chữ ký số cho thông báo phát hành.", "error");
                                                return;
                                            }
                                            item.cqtqly = $$("mcqtqly").getValue();
                                            item.hdbtscong = 0;
                                            item.hdbhdtqgia = 0;
                                            item["mau01_chitiets"] = $$("danhsach_chukyso").serialize();
                                            webix.extend(form, webix.ProgressBar);
                                            form.disable();
                                            form.showProgress();
                                            webix.ajax()
                                                .headers({ 'Content-type': 'application/json' })
                                                .post(app.config.host + "/Register68/Mau01SaveChange", item, {
                                                    error: function (text, data, XmlHttpRequest) {
                                                        form.enable();
                                                        form.hideProgress();
                                                        webix.message(text, "error");
                                                    }, success: function (text, data, XmlHttpRequest) {
                                                        form.enable();
                                                        form.hideProgress();
                                                        var response = JSON.parse(text);
                                                        if (response.code != "00") {
                                                            webix.message(response.message, "error");
                                                        }
                                                        else {
                                                            app.callEvent("dataChangeDangkysudung68", [editmode, null]);
                                                            webix.message("Thành công !", "success");
                                                            webix.$$("dangkysudungForms").close();
                                                        }
                                                    }
                                                });
                                        }

                                    }
                                },
                                click: function () {
                                    this.callEvent("onClick");
                                }
                            },
                            {
                                view: "button",
                                hotkey: "esc",
                                label: "Hủy bỏ (ESC)",
                                width: 120,
                                type: "danger",
                                align: "center",
                                click: function () {
                                    webix.$$("dangkysudungForms").close();
                                }
                            },
                            {}
                        ]
                    },
                    { height: 8 },
                ]
                // rules: {
                //     begin_date: function (value) {
                //         if (value != "") {
                //             if (value.toString().length != 5)
                //                 return false;
                //             var patt = /^[0-1][1-2][/][0-9][0-9]$/;
                //             return patt.test(value);
                //         }
                //         return true;
                //     }
                // }
            }
        },
        setEditMode: function (mode) {
            editmode = mode;
            var form = $$(this.$ui.id);
            form.config.editmode = mode;
            if (editmode == 1) {
                var result = webix.ajax().sync().get(app.config.host + "/System/GetCurrentDmdvcs");
                var data = JSON.parse(result.response);
                $$("dclhe").setValue(data[0].dia_chi);
                $$("tnnt").setValue(data[0].ten_dvcs);
                $$("mst").setValue(data[0].ms_thue);
                $$("dtlhe").setValue(data[0].dien_thoai);
                $$("dctdtu").setValue(data[0].email);
                $$("nlhe").setValue(data[0].nguoi_dai_dien);
                // $$("cqtqly").setValue(data[0].ten);
                $$("mcqtqly").setValue(data[0].ma_cqthuecapql);
                $$("ddanh").setValue(data[0].tinh_thanh);
            }
        },
        setValues: function (item, winconfig, params) {
            var win = $$(this.$ui.id);
            var form = $$("dangkysudung");
            item["nlap"] = removeTimeZoneT(item["nlap"]);
            form.setValues(item);
            var tableDetail = webix.$$("danhsach_chukyso");
            var url = app.config.host + "/Register68/GetMau01Detail?id=" + item.id;
            tableDetail.clearAll();
            tableDetail.load(url);
        },
        setValuesChange: function (item, mode) {
            editmode = mode;
            var form = $$("dangkysudung");
            item["nlap"] = new Date();
            item["mau01_id"] = "00000000-0000-0000-0000-000000000000";
            item["hthuc"] = 2;
            item["xml_send"] = null;
            item["mtdiep_gui"] = null;
            item["mtdiep_cqt"] = null;
            item["ket_qua"] = null;
            item["ngay_gui"] = null;
            item["nguoi_gui"] = null;
            form.setValues(item);
            var dataDetails = item.mau01_chitiets;
            $$("danhsach_chukyso").parse(dataDetails);
        }
    };
});
define('views/forms/forms68/DangKySD/68_dangkysudungV2Form',["app", "models/user"], function (app, user) {
    var editmode = 0;

    var button = [
        {},
        {
            shortcut: "F10",
            view: "button",
            label: "Nhận (F10)",
            type: "icon",
            align: "center",
            css: "webix_primary",
            width: 100,
            on: {
                onClick: function () {
                    var table = $$("dangkysudungv2-form");
                    var item = table.getValues();
                    if (table.validate()) {
                        item.editmode = editmode;
                        var format = webix.Date.dateToStr("%m/%d/%Y");
                        text = removeTimeZoneT(item.ngay_chapthuan);
                        var time = format(item.ngay_chapthuan);
                        item.ngay_chapthuan = time;
                        $$("uploader68").define("upload", app.config.host + "/Register68/SaveMau01File");
                        $$("uploader68").define("formData", item);
                        $$("uploader68").send(function (res) {
                            if (res != undefined) {

                                if (res.code != "00") {
                                    webix.message({ "type": "error", "text": res.message })
                                }
                                else {
                                    webix.message("Tải lên file thành công", "success");
                                    var win = $$("uploader68").getTopParentView();
                                    win.close();

                                    var mainTable = webix.$$("dangkysudung01Views");
                                    if (mainTable) {
                                        mainTable.clearAll();
                                        mainTable.load(mainTable.config.url);
                                    }
                                    app.callEvent("dataChangeDangkysudung68", [1, null]);
                                }
                            }
                            else {
                                webix.message("Bạn chưa chọn file", "error");
                            }
                        });
                    }
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {
            view: "button",
            hotkey: "esc",
            label: "Hủy (ESC)",
            type: "icon", css: "webix_danger",
            align: "center",
            width: 100,
            click: function () {
                webix.$$("dangkysudungv2-win").close();
            }
        },
        {}
    ]

    var ui = {
        view: "window",
        modal: true,
        move: true,
        id: "dangkysudungv2-win",
        position: "center",
        head: "Thêm mới file chấp thuận của CQT",
        body: {
            paddingY: 10,
            paddingX: 10,
            view: "form",
            width: 600,
            id: "dangkysudungv2-form",
            complexData: true,
            margin: 0, elementsConfig: {
                labelPosition: "top"
            },
            elements: [
                {
                    view: "datepicker",
                    label: "Thời gian chấp thuận",
                    name: "ngay_chapthuan",
                    id: "ngay_chapthuan",
                    validate: webix.rules.isEmpty,
                    invalidMessage: "Thời gian chấp thuận không được để trống",
                    required: true,
                    value: new Date(),
                    format: "%d/%m/%Y",
                    // readonly: true,
                    // css: "mcls_readonly_text",
                    labelWidth: 120
                },
                {
                    view: "uploader",
                    value: "Upload file",
                    label: "File Pdf hoặc Xml của CQT",
                    css: "btnUpload",
                    id: "uploader68",
                    name: "uploader68",
                    link: "mylist",
                    accept: "repx",
                    autosend: false,
                    // upload: app.config.host + "",
                    on: {
                        onUploadComplete: function (response) {

                        },
                        onFileUploadError: function (file, response) {

                        },
                        onAfterDelete: function (id) {

                        },
                    }
                },
                {
                    view: "list", id: "mylist", type: "uploader",
                    autoheight: true, borderless: true
                },
                { cols: button },
                { height: 20 },
                {
                    rows: [
                        {
                            view: "datatable",
                            id: "mau01_file",
                            editable: false,
                            height: 250,
                            resizeColumn: true,
                            width: 600,
                            select: "cell",
                            url: app.config.host + "/Pattern/GetData?command=CM0014&start=0&count=50&continue=null&filter=null",
                            onClick: {
                                "DeleteFile": function (event, cell, target) {
                                    var win = webix.$$("mau01_file");
                                    var record = win.getItem(cell.row);
                                    console.log(record);
                                    webix.ajax()
                                        .headers({ 'Content-type': 'application/json' })
                                        .post(app.config.host + "/Register68/DeleteMau01File", record, {
                                            error: function (text, data, XmlHttpRequest) {
                                            },
                                            success: function (text, data, XmlHttpRequest) {
                                                var result = JSON.parse(text);
                                                if (result.code == "00") {
                                                    win.clearAll();
                                                    win.load(win.config.url);
                                                }
                                                else {
                                                    webix.message(result.message, "error");
                                                }
                                            }
                                        });
                                }
                            },
                            columns: [
                                { id: "stt", header: "", width: 30, editable: true, editor: "text" },
                                {
                                    id: "ngay_chapthuan", header: "Ngày chấp thuận", width: 150,
                                    format: function (text) {
                                        var format = webix.Date.dateToStr("%d/%m/%Y");
                                        text = removeTimeZoneT(text);
                                        return format(text);
                                    }, columnType: "datetime"
                                },
                                {
                                    id: "file_name",
                                    name: "file_name",
                                    header: "File đính kèm",
                                    editor: "text",
                                    width: 200,
                                },
                                {
                                    id: "dowloadXml",
                                    header: ["Tải về"],
                                    css: { "text-align": "center" },
                                    template: function (obj) {
                                        return "<span class='dowloadXml' style='color: #00b300'><i class='mdi mdi-18px mdi-download'></i></span> ";
                                    },
                                    width: 60
                                },
                                {
                                    id: "ViewFile",
                                    header: ["Xem"],
                                    css: { "text-align": "center" },
                                    template: function (obj) {
                                        return "<span class='ViewFile' style='color: #00b300'><i class='mdi mdi-18px mdi-eye'></i></span> ";
                                    },
                                    width: 60
                                },
                                {
                                    id: "Delete",
                                    header: ["Xóa"],
                                    css: { "text-align": "center" },
                                    template: function (obj) {
                                        return "<span class='DeleteFile' style='color: #00b300'><i class='mdi mdi-18px mdi-trash-can-outline'></i></span> ";
                                    },
                                    width: 60
                                }
                            ],
                            rules: {

                            },
                            on: {
                                "data->onStoreUpdated": function () {
                                    this.data.each(function (obj, i) {
                                        obj.stt = i + 1;
                                    })
                                }
                            }
                        }
                    ]
                }
            ]
        }

    };

    return {
        $ui: ui,
        setEditMode: function (mode) {
            editmode = mode;
        },
        setValues: function (item) {
            var form = $$("dangkysudungv2-form");
            form.setValues(item);
            if (!item.ngay_chapthuan || item.ngay_chapthuan === "") {
                $$("ngay_chapthuan").setValue(new Date());
            }
        },
    };
});
define('views/68_dangkysudung',[
    "app",
    "locale",
    "models/user",
    "views/forms/forms68/DangKySD/68_dangkyForms",
    "views/forms/forms68/68_viewLogForm",
    "views/forms/forms68/DangKySD/68_dangkysudungV2Form",
    "views/modules/Component/modalPlugin",
    "views/modules/Component/constantManager"
], function (
    app,
    _,
    user,
    dangkysudung,
    viewLogForm,
    dangkysudungV2,
    modalPlugin,
    CONSTANTS
) {
    "use strict";

    var initUI = function () {
        var table = webix.$$("dangkysudung01Views");
        var url = {
            $proxy: true,
            load: function (view, callback, params) {
                var url = app.config.host + "/Pattern/GetData";
                if (params == null) {
                    url = url + "?command=CM0006&start=0&count=" + view.config.datafetch + "&continue=null&filter=null";
                    webix.ajax(url, callback, view);
                }
                else {
                    url = url + "?start=" + params.start + "&count=" + params.count + "&continue=" + params.continue;

                    if (params.filter != null) {
                        var array = [];
                        for (var property in params.filter) {
                            var column = view.getColumnConfig(property);
                            var item = {
                                columnName: property,
                                columnType: column.columnType,
                                value: params.filter[property]
                            };
                            array.push(item);
                        }
                        url = url + "&filter=" + JSON.stringify(array);
                    }
                }
                webix.ajax(url, callback, view);
            }
        };
        table.define("url", url);
    };
    var controls = [
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-refresh fa-lg" aria-hidden="true"></i> ' +
                '<span class="text">' + _("REFRESH") + '</span>',
            id: "btnRefresh",
            on: {
                onClick: function () {
                    var table = webix.$$("dangkysudung01Views");
                    table.clearAll();
                    table.load(table.config.url);
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        // {
        //     view: "button", type: "htmlbutton", width: 100,
        //     label: '<i class="fa fa-plus fa-lg" aria-hidden="true"></i> ' +
        //         '<span class="text">' + _("THEM") + ' (F4)</span>',
        //     id: "btnPlus",
        //     shortcut: "F4",
        //     on: {
        //         onClick: function () {
        //             var table = webix.$$("frmView");
        //             webix.extend(table, webix.ProgressBar);
        //             table.disable();
        //             table.showProgress();
        //             var detailForm = this.$scope.ui(dangkysudung.$ui);
        //             webix.ajax()
        //                 .headers({ 'Content-type': 'application/json' })
        //                 .get(app.config.host + "/Register68/BeforeAddNew",
        //                     {
        //                         error: function (text, data, XmlHttpRequest) {
        //                             table.enable();
        //                             table.hideProgress();
        //                         },
        //                         success: function (text, data, XmlHttpRequest) {
        //                             table.enable();
        //                             table.hideProgress();
        //                             var response = JSON.parse(text);
        //                             if (response.code == "00") {
        //                                 dangkysudung.setEditMode(1);
        //                                 detailForm.show();
        //                             } else {
        //                                 if (response.code == "01") {
        //                                     dangkysudung.setValuesChange(response.data, 1);
        //                                     detailForm.show();
        //                                 } else {
        //                                     webix.message(response.message, "error");
        //                                 }
        //                             }
        //                         }
        //                     });
        //         },
        //     },
        //     click: function () {
        //         this.callEvent("onClick");
        //     },
        // },
        // {
        //     view: "button", type: "htmlbutton", width: 100,
        //     label: '<i class="fa fa-edit fa-lg" aria-hidden="true"></i> ' +
        //         '<span class="text">' + _("SUA") + ' (F2)</span>',
        //     id: "btnEdit",
        //     shortcut: "F2",
        //     on: {
        //         onClick: function () {
        //             var table = webix.$$("dangkysudung01Views");
        //             var selectedItem = table.getSelectedItem();
        //             if (selectedItem == null) {
        //                 webix.message("Bạn chưa chọn mẫu đăng ký cần sửa ! ", "error");
        //                 return;
        //             }
        //             var detailForm = this.$scope.ui(dangkysudung.$ui);
        //             dangkysudung.setEditMode(2);
        //             dangkysudung.setValues(selectedItem);
        //             if (selectedItem.trang_thai == 3 || selectedItem.trang_thai == 4) {
        //                 var form = $$("dangkysudung").elements;
        //                 for (var key in form) {
        //                     var $el = form[key];
        //                     $el.define("readonly", "true")
        //                     $el.define("css", "mcls_readonly_text")
        //                     $el.refresh()
        //                 }
        //                 $$("btnDKSDSave1").destructor();
        //             }
        //             detailForm.show();
        //         },
        //     },
        //     click: function () {
        //         this.callEvent("onClick");
        //     },
        // },
        // {
        //     view: "button", type: "htmlbutton", width: 100,
        //     label: '<i class="fa fa-trash-o fa-lg" aria-hidden="true"></i> ' +
        //         '<span class="text">' + _("XOA") + ' (F3)</span>',
        //     id: "btnDelete",
        //     shortcut: "F3",
        //     on: {
        //         onClick: function () {
        //             var table = webix.$$("dangkysudung01Views");
        //             var selectedItem = table.getSelectedItem();
        //             if (selectedItem == null) {
        //                 webix.message("Bạn chưa chọn mẫu đăng ký ! ", "error");
        //                 return;
        //             }
        //             if (selectedItem.trang_thai == 3 || selectedItem.trang_thai == 4) {
        //                 webix.message("Thông báo đã được ký và gửi CQT. Bạn không thể thực hiện chức năng này ! ", "error");
        //                 return;
        //             }
        //             selectedItem.editmode = 3;
        //             webix.confirm({
        //                 title: "M-INVOICE",
        //                 text: "Bạn có muốn xóa bản ghi",
        //                 ok: "Có",
        //                 cancel: "Không",
        //                 callback: function (choose) {
        //                     if (choose) {
        //                         webix.extend(table, webix.ProgressBar);
        //                         table.disable();
        //                         table.showProgress();
        //                         webix.ajax()
        //                             .headers({ 'Content-type': 'application/json' })
        //                             .get(app.config.host + "/Register68/Mau01Delete?id=" + selectedItem.mau01_id,
        //                                 {
        //                                     error: function (text, data, XmlHttpRequest) {
        //                                         table.enable();
        //                                         table.hideProgress();
        //                                     },
        //                                     success: function (text, data, XmlHttpRequest) {
        //                                         table.remove(selectedItem.id);
        //                                         table.enable();
        //                                         table.hideProgress();
        //                                     }
        //                                 });
        //                     }
        //                 }
        //             });
        //         }
        //     },
        //     click: function () {
        //         this.callEvent("onClick");
        //     }
        // },
        {
            view: "button", type: "htmlbutton", width: 150,
            label: '<i class="fa fa-sign-in fa-lg" aria-hidden="true"></i> ' +
                '<span class="text">' + _('SIGN_SEND') + ' (F7)</span>',
            id: "btnSign",
            shortcut: "F7",
            on: {
                onClick: function () {
                    var tableDK = webix.$$("dangkysudung01Views");
                    var selectedItem = tableDK.getSelectedItem();
                    if (selectedItem == null) {
                        webix.message("Bạn chưa chọn mẫu đăng ký ! ", "error");
                        return;
                    }
                    if (selectedItem.trang_thai == 3 || selectedItem.trang_thai == 4) {
                        webix.message("Mẫu đã được ký hoặc gửi đi, bạn không thể ký lại ! ", "error");
                        return;
                    }
                    webix.ajax()
                        .headers({ 'Content-Type': 'application/json' })
                        .get(app.config.host + "/Pattern/GetSignType", function (text) {
                            var result = JSON.parse(text);
                            var kytaptrung = result[0].gia_tri;
                            switch (kytaptrung.toUpperCase()) {
                                case "FILE":
                                    var box = webix.modalbox({
                                        title: "Chọn chứng thư số",
                                        buttons: ["Nhận", "Hủy bỏ"],
                                        text: "<div id='ctnCerts'></div>",
                                        top: 100,
                                        width: 750,
                                        callback: function (result) {
                                            switch (result) {
                                                case "1":
                                                    webix.modalbox.hide();
                                                    break;
                                                case "0":
                                                    var table = $$("tblCerts");
                                                    var data = table.serialize();
                                                    var cert = null;
                                                    for (var i = 0; i < data.length; i++) {
                                                        if (data[i].chon == true) {
                                                            cert = data[i];
                                                            break;
                                                        }
                                                    }
                                                    if (cert == null) {
                                                        webix.message("Bạn chưa chọn chứng thư số");
                                                        return;
                                                    }
                                                    var postData = {
                                                        so_serial: cert.so_serial,
                                                        id: selectedItem.mau01_id
                                                    };
                                                    webix.extend(tableDK, webix.ProgressBar);
                                                    tableDK.disable();
                                                    tableDK.showProgress();
                                                    webix.ajax()
                                                        .headers({ 'Content-type': 'application/json' })
                                                        .post(app.config.host + "/Register68/SignByFile", postData, {
                                                            error: function (text, data, XmlHttpRequest) {
                                                                tableDK.enable();
                                                                tableDK.hideProgress();

                                                            }, success: function (text, data, XmlHttpRequest) {
                                                                var json = JSON.parse(text);
                                                                if (json.code != "00") {
                                                                    webix.message(json.message, "error");
                                                                    tableDK.enable();
                                                                    tableDK.hideProgress();
                                                                }
                                                                else {
                                                                    tableDK.enable();
                                                                    tableDK.hideProgress();
                                                                    app.callEvent("dataChangeDangkysudung68", [1, null]);
                                                                    webix.message("Ký và gửi CQT thành công!", "success");
                                                                }
                                                            }
                                                        });
                                                    return;
                                            }
                                        }
                                    });
                                    var tblMatHang = webix.ui({
                                        container: "ctnCerts",
                                        id: "tblCerts",
                                        view: "datatable",
                                        borderless: true,
                                        resizeColumn: true,
                                        height: 350,
                                        columns: [
                                            {
                                                id: "chon", header: _("CHON"), width: 65,
                                                checkValue: true, uncheckValue: false, template: "{common.checkbox()}"
                                            },
                                            { id: "so_serial", header: _("SO_SERIAL"), width: 150 },
                                            { id: "subjectname", header: _("SUBJECTNAME"), width: 450 },
                                            { id: "ngaybatdau", header: _("NGAY_BAT_DAU"), width: 200 },
                                            { id: "ngayketthuc", header: _("NGAY_KET_THUC"), width: 200 },
                                            { id: "issuer", header: _("DONVI"), width: 450 }
                                        ],
                                        url: app.config.host + "/Invoice/GetListCertificatesFile"
                                    });
                                    break;
                                case "EASYCA":
                                    var box = webix.modalbox({
                                        title: "Chọn chứng thư số",
                                        buttons: ["Nhận", "Hủy bỏ"],
                                        text: "<div id='ctnCerts'></div>",
                                        top: 100,
                                        width: 750,
                                        callback: function (result) {
                                            switch (result) {
                                                case "1":
                                                    webix.modalbox.hide();
                                                    break;
                                                case "0":
                                                    var table = $$("tblCerts");
                                                    var data = table.serialize();
                                                    var cert = null;
                                                    for (var i = 0; i < data.length; i++) {
                                                        if (data[i].chon == true) {
                                                            cert = data[i];
                                                            break;
                                                        }
                                                    }
                                                    if (cert == null) {
                                                        webix.message("Bạn chưa chọn chứng thư số", "debug");
                                                        return;
                                                    }
                                                    var tblInvoice = webix.$$("dangkysudung01Views");
                                                    var item = tblInvoice.getSelectedItem();
                                                    cert.id = item.id;
                                                    cert.tagSign = "TKhai/DSCKS/NNT";
                                                    cert.tagSignId = "data";

                                                    require(["app", "locale", "views/forms/forms68/EasyCA/signEasyCA"], function (app, _, signEasyCA) {
                                                        var frm = webix.$$("dangkysudung01Views").$scope.ui(signEasyCA.$ui);
                                                        signEasyCA.initUI(cert, "dangky");
                                                        webix.modalbox.hide();
                                                        frm.show();
                                                    });
                                            }
                                        }
                                    });
                                    var popupText = document.getElementsByClassName("webix_popup_text")[0];
                                    popupText.style.paddingTop = 0;
                                    var tblMatHang = webix.ui({
                                        container: "ctnCerts",
                                        id: "tblCerts",
                                        view: "datatable",
                                        borderless: true,
                                        resizeColumn: true,
                                        height: 350,
                                        columns: [
                                            {
                                                id: "chon", header: _("CHON"),
                                                width: 65, checkValue: true, uncheckValue: false, template: "{common.checkbox()}"
                                            },
                                            { id: "libraryName", header: _("Loại"), width: 150 },
                                            { id: "so_serial", header: _("SO_SERIAL"), width: 150 },
                                            { id: "subjectname", header: _("SUBJECTNAME"), width: 450 },
                                            { id: "ngaybatdau", header: _("NGAY_BAT_DAU"), width: 200 },
                                            { id: "ngayketthuc", header: _("NGAY_KET_THUC"), width: 200 },
                                            { id: "issuer", header: _("DONVI"), width: 450 }
                                        ],
                                        url: app.config.host + "/Invoice/GetListCertificatesEasyCA"
                                    });
                                    break;
                                case "NCCA":
                                    var box = webix.modalbox({
                                        title: "Chọn chứng thư số",
                                        buttons: ["Nhận", "Hủy bỏ"],
                                        text: "<div id='ctnCerts'></div>",
                                        top: 100,
                                        width: 750,
                                        callback: function (result) {
                                            switch (result) {
                                                case "1":
                                                    webix.modalbox.hide();
                                                    break;
                                                case "0":
                                                    var table = $$("tblCerts");
                                                    var data = table.serialize();
                                                    var cert = null;
                                                    for (var i = 0; i < data.length; i++) {
                                                        if (data[i].chon == true) {
                                                            cert = data[i];
                                                            break;
                                                        }
                                                    }
                                                    if (cert == null) {
                                                        webix.message("Bạn chưa chọn chứng thư số", "debug");
                                                        return;
                                                    }
                                                    var tblInvoice = webix.$$("dangkysudung01Views");
                                                    var item = tblInvoice.getSelectedItem();
                                                    cert.id = item.id;
                                                    cert.tagSign = "/DSCKS/NNT";
                                                    cert.tagSignId = "data";

                                                    require(["app", "locale", "views/forms/forms68/NCCA/signNCCA"], function (app, _, signNCCA) {
                                                        var frm = webix.$$("dangkysudung01Views").$scope.ui(signNCCA.$ui);
                                                        signNCCA.initUI(cert, "dangky");
                                                        webix.modalbox.hide();
                                                        frm.show();
                                                    });
                                            }
                                        }
                                    });
                                    var popupText = document.getElementsByClassName("webix_popup_text")[0];
                                    popupText.style.paddingTop = 0;
                                    var tblMatHang = webix.ui({
                                        container: "ctnCerts",
                                        id: "tblCerts",
                                        view: "datatable",
                                        borderless: true,
                                        resizeColumn: true,
                                        height: 350,
                                        columns: [
                                            {
                                                id: "chon", header: _("CHON"), width: 65, checkValue: true, uncheckValue: false,
                                                template: "{common.checkbox()}"
                                            },
                                            { id: "libraryName", header: _("Loại"), width: 150 },
                                            { id: "so_serial", header: _("SO_SERIAL"), width: 150 },
                                            { id: "subjectname", header: _("SUBJECTNAME"), width: 450 },
                                            { id: "ngaybatdau", header: _("NGAY_BAT_DAU"), width: 200 },
                                            { id: "ngayketthuc", header: _("NGAY_KET_THUC"), width: 200 },
                                            { id: "issuer", header: _("DONVI"), width: 450 }
                                        ],
                                        url: app.config.host + "/Invoice/GetListCertificatesAuto"
                                    });
                                    break;
                                case "ICA":
                                    var box = webix.modalbox({
                                        title: "Chọn chứng thư số",
                                        buttons: ["Nhận", "Hủy bỏ"],
                                        text: "<div id='ctnCerts'></div>",
                                        top: 100,
                                        width: 750,
                                        callback: function (result) {
                                            switch (result) {
                                                case "1":
                                                    webix.modalbox.hide();
                                                    break;
                                                case "0":
                                                    var table = $$("tblCerts");
                                                    var data = table.serialize();
                                                    var cert = null;
                                                    for (var i = 0; i < data.length; i++) {
                                                        if (data[i].chon == true) {
                                                            cert = data[i];
                                                            break;
                                                        }
                                                    }
                                                    if (cert == null) {
                                                        webix.message("Bạn chưa chọn chứng thư số", "debug");
                                                        return;
                                                    }
                                                    var tblInvoice = webix.$$("dangkysudung01Views");
                                                    var item = tblInvoice.getSelectedItem();
                                                    cert.id = item.id;
                                                    cert.tagSign = "/DSCKS/NNT";
                                                    cert.tagSignId = "data";

                                                    webix.ajax().headers({ 'Content-type': 'application/text' })
                                                        .get(app.config.host + "/TokenCloud/CheckShowPinCode", function (text, data, XmlHttpRequest) {
                                                            var response = JSON.parse(text);
                                                            if (response.show == true) {
                                                                require(["app", "locale", "views/forms/forms68/ICA/signICA"], function (app, _, signICA) {
                                                                    var frm = webix.$$("dangkysudung01Views").$scope.ui(signICA.$ui);
                                                                    signICA.initUI(cert, "dangky");
                                                                    webix.modalbox.hide();
                                                                    frm.show();
                                                                });
                                                            }
                                                            else {
                                                                var form = webix.$$("frmView");
                                                                webix.extend(form, webix.ProgressBar);
                                                                form.disable();
                                                                form.showProgress();

                                                                var apiHost = app.config.host + "/Register68/SignByIca";
                                                                var param = {
                                                                    so_serial: cert.so_serial,
                                                                    pinCode: cert.pass,
                                                                    id: item.id,
                                                                    agreementUUID: cert.value
                                                                };
                                                                webix.ajax()
                                                                    .headers({ 'Content-type': 'application/json' })
                                                                    .post(apiHost, param, {
                                                                        error: function (text, data, XmlHttpRequest) {
                                                                            form.enable();
                                                                            form.hideProgress();
                                                                        },
                                                                        success: function (text, data, XmlHttpRequest) {
                                                                            var response = JSON.parse(text);
                                                                            form.enable();
                                                                            form.hideProgress();
                                                                            if (response.code == "00") {
                                                                                app.callEvent("dataChangeDangkysudung68", [1, null]);
                                                                                webix.message("Ký và gửi CQT thành công!", "success");
                                                                            }
                                                                            else
                                                                                webix.message(response.message, "error");
                                                                        }
                                                                    });
                                                            }
                                                        });

                                            }
                                        }
                                    });
                                    var popupText = document.getElementsByClassName("webix_popup_text")[0];
                                    popupText.style.paddingTop = 0;
                                    var tblMatHang = webix.ui({
                                        container: "ctnCerts",
                                        id: "tblCerts",
                                        view: "datatable",
                                        borderless: true,
                                        resizeColumn: true,
                                        height: 350,
                                        columns: [
                                            {
                                                id: "chon", header: _("CHON"), width: 65, checkValue: true, uncheckValue: false,
                                                template: "{common.checkbox()}"
                                            },
                                            { id: "libraryName", header: _("Loại"), width: 150 },
                                            { id: "so_serial", header: _("SO_SERIAL"), width: 150 },
                                            { id: "subjectname", header: _("SUBJECTNAME"), width: 450 },
                                            { id: "ngaybatdau", header: _("NGAY_BAT_DAU"), width: 200 },
                                            { id: "ngayketthuc", header: _("NGAY_KET_THUC"), width: 200 },
                                            { id: "issuer", header: _("DONVI"), width: 450 }
                                        ],
                                        url: app.config.host + "/Invoice/GetListCertificatesAuto"
                                    });
                                    break;
                                case "INTRUSTCA":
                                    var box = webix.modalbox({
                                        title: "Chọn chứng thư số IntrustCa",
                                        buttons: ["Nhận", "Hủy bỏ"],
                                        text: "<div id='ctnCerts'></div>",
                                        top: 100,
                                        width: 750,
                                        callback: function (result) {
                                            switch (result) {
                                                case "1":
                                                    webix.modalbox.hide();
                                                    break;
                                                case "0":
                                                    var table = $$("tblCerts");
                                                    var data = table.serialize();
                                                    var cert = null;
                                                    for (var i = 0; i < data.length; i++) {
                                                        if (data[i].chon == true) {
                                                            cert = data[i];
                                                            break;
                                                        }
                                                    }
                                                    if (cert == null) {
                                                        webix.message("Bạn chưa chọn chứng thư số");
                                                        return;
                                                    }
                                                    var signModel = {
                                                        user_name: cert.username,
                                                        credentialID: cert.tokenSerial,
                                                        certificate: cert.cert_content,
                                                        pinCode: cert.pin_code,
                                                        auth_data: cert.auth_data,
                                                        mode: 1,
                                                        hoadon: [selectedItem.mau01_id]
                                                      }
                         
                                                    webix.extend(tableDK, webix.ProgressBar);
                                                    tableDK.disable();
                                                    tableDK.showProgress();
                                                    webix.ajax().headers({ "Content-Type": "application/json" })
                                                        .post(app.config.host + CONSTANTS.API.SIGN.INTRUSTCA_DANGKY, JSON.stringify(signModel), function (text) {
                                                            tableDK.enable();
                                                            tableDK.hideProgress();
                                                            var result = JSON.parse(text);
                                                            if (result.code == "00") {
                                                                app.callEvent("dataChangeDangkysudung68", [1, null]);
                                                                webix.message("Ký và gửi CQT thành công!", "success");
                                                            } else
                                                                webix.message(result.message, "error")
                                                        });
                                                    break;
                                            }
                                        }
                                    });

                                    var cert = webix.ui({
                                        container: "ctnCerts",
                                        id: "tblCerts",
                                        view: "datatable",
                                        borderless: true,
                                        resizeColumn: true,
                                        height: 350,
                                        columns: [
                                            {
                                                id: "chon", header: _("CHON"), width: 65, checkValue: true, uncheckValue: false,
                                                template: "{common.checkbox()}"
                                            },
                                            { id: "libraryName", header: _("Loại"), width: 100 },
                                            { id: "so_serial", header: _("SO_SERIAL"), width: 250 },
                                            { id: "subjectname", header: _("SUBJECTNAME"), width: 450 },
                                            { id: "ngaybatdau", header: _("NGAY_BAT_DAU"), width: 200 },
                                            { id: "ngayketthuc", header: _("NGAY_KET_THUC"), width: 200 },
                                            { id: "issuer", header: _("DONVI"), width: 450 }
                                        ],
                                        url: CONSTANTS.API.TOKEN_CERT_AUTO,
                                        ready: function () {
                                            this.data.each(function (row, index) {
                                                row.chon = false;
                                                if (index == 0) row.chon = true;
                                            });
                                            this.refresh();
                                        },
                                        on: {
                                            onCheck: function (rowId, colId, isChecked) {
                                                if (isChecked) {
                                                    this.data.each(function (row) {
                                                        if (row.id !== rowId) {
                                                            this.getItem(row.id).chon = false;
                                                            this.updateItem(row.id);
                                                        }
                                                    });
                                                }
                                            }
                                        }
                                    });
                                    break;
                                
                                case "VNET":
                                    var box = webix.modalbox({
                                        title: "Chọn chứng thư số Vnet",
                                        buttons: ["Nhận", "Hủy bỏ"],
                                        text: "<div id='ctnCerts'></div>",
                                        top: 100,
                                        width: 750,
                                        callback: function (result) {
                                            switch (result) {
                                                case "1":
                                                    webix.modalbox.hide();
                                                    break;
                                                case "0":
                                                    var table = $$("tblCerts");
                                                    var data = table.serialize();
                                                    var cert = null;
                                                    for (var i = 0; i < data.length; i++) {
                                                        if (data[i].chon == true) {
                                                            cert = data[i];
                                                            break;
                                                        }
                                                    }
                                                    if (cert == null) {
                                                        webix.message("Bạn chưa chọn chứng thư số");
                                                        return;
                                                    }
                                                    var postData = {
                                                        chukyso_id: cert.chukyso_id,
                                                        id: selectedItem.mau01_id
                                                    };
                                                    webix.extend(tableDK, webix.ProgressBar);
                                                    tableDK.disable();
                                                    tableDK.showProgress();
                                                    webix.ajax()
                                                        .headers({ 'Content-type': 'application/json' })
                                                        .post(app.config.host + "/Register68/SignByVnet", postData, {
                                                            error: function (text, data, XmlHttpRequest) {
                                                                tableDK.enable();
                                                                tableDK.hideProgress();

                                                            }, success: function (text, data, XmlHttpRequest) {
                                                                var json = JSON.parse(text);
                                                                if (json.code != "00") {
                                                                    webix.message(json.message, "error");
                                                                    tableDK.enable();
                                                                    tableDK.hideProgress();
                                                                }
                                                                else {
                                                                    tableDK.enable();
                                                                    tableDK.hideProgress();
                                                                    app.callEvent("dataChangeDangkysudung68", [1, null]);
                                                                    webix.message("Ký và gửi CQT thành công!", "success");
                                                                }
                                                            }
                                                        });
                                                    return;
                                            }
                                        }
                                    });
                                    var tblMatHang = webix.ui({
                                        container: "ctnCerts",
                                        id: "tblCerts",
                                        view: "datatable",
                                        borderless: true,
                                        resizeColumn: true,
                                        height: 350,
                                        columns: [
                                            {
                                                id: "chon", header: _("CHON"), width: 65,
                                                checkValue: true, uncheckValue: false, template: "{common.checkbox()}"
                                            },
                                            { id: "so_serial", header: _("SO_SERIAL"), width: 150 },
                                            { id: "subjectname", header: _("SUBJECTNAME"), width: 450 },
                                            { id: "ngaybatdau", header: _("NGAY_BAT_DAU"), width: 200 },
                                            { id: "ngayketthuc", header: _("NGAY_KET_THUC"), width: 200 },
                                            { id: "issuer", header: _("DONVI"), width: 450 }
                                        ],
                                        url: app.config.host + "/Invoice/GetListCertificatesVnet"
                                    });
                                    break;
                                default:
                                    var table = $$("dangkysudung01Views");
                                    webix.extend(table, webix.ProgressBar);
                                    table.disable();
                                    table.showProgress();

                                    var a = webix.ajax(app.config.host + "/Register68/GetXml?id=" + selectedItem.id);
                                    var b = webix.ajax(app.config.host + "/Pattern/GetListCertificates");
                                    var c = webix.ajax(app.config.host + "/Pattern/GetSerialAccept?id=" + selectedItem.id);
                                    webix.promise.all([a, b, selectedItem, c]).then(function (results) {
                                        var json = results[0].json();
                                        if (json.code != "00") {
                                            table.enable();
                                            table.hideProgress();
                                            webix.message({ type: 'error', text: json.message });
                                            return;
                                        }
                                        var listcerts = results[1].json();
                                        var item = results[2];

                                        if (listcerts.length == 0) {
                                            table.enable();
                                            table.hideProgress();
                                            webix.message({ type: "error", text: "Bạn chưa được phân quyền chứng thư số" });
                                            return;
                                        }
                                        var certAccept = results[3].json();
                                        if (certAccept == undefined || certAccept.length == 0) {
                                            table.disable();
                                            table.showProgress();
                                            webix.message("Không tồn tại chữ ký số đăng ký sử dụng", "error");
                                            return;
                                        }

                                        require(["views/modules/minvoiceplugin"], function (plugin) {
                                            var hub = plugin.hub();
                                            var hubconnect = plugin.conn();

                                            if (hubconnect.state != 1) {
                                                table.enable();
                                                table.hideProgress();
                                                webix.message("Quý khách hàng chưa cài Plugin ký hóa đơn hoặc Plugin ký hóa đơn chưa được bật !", "error");
                                                var Form = $$("dangkysudung01Views").$scope.ui(modalPlugin.$ui);
                                                Form.show();
                                                return;
                                            }
                                            hub.off('resCommand');
                                            hub.on('resCommand', function (result) {
                                                var json = JSON.parse(result);
                                                if (json.hasOwnProperty("error")) {
                                                    webix.message({ type: 'error', text: json.error });
                                                }
                                                else {
                                                    var parameters = {
                                                        xml: json.xml,
                                                        id: item.id
                                                    };

                                                    webix.ajax()
                                                        .headers({ "Content-Type": "application/json" })
                                                        .post(app.config.host + "/Register68/SaveXml", parameters, function (text) {
                                                            var result = JSON.parse(text);
                                                            if (result.hasOwnProperty("error")) {
                                                                webix.message(result.error, "error");
                                                            }
                                                            else {
                                                                app.callEvent("dataChangeDangkysudung68", [1, null]);

                                                                webix.message("Ký và gửi CQT thành công!", "success");
                                                            }

                                                        });
                                                }
                                                table.enable();
                                                table.hideProgress();
                                            });

                                            var _listcerts = [];

                                            for (var i = 0; i < listcerts.length; i++) {
                                                var _cert = listcerts[i];

                                                _listcerts.push({
                                                    so_serial: _cert.so_serial,
                                                    ngaybatdau: _cert.ngaybatdau,
                                                    ngayketthuc: _cert.ngayketthuc,
                                                    issuer: _cert.issuer,
                                                    subjectname: _cert.subjectname
                                                });
                                            }

                                            var arg = {
                                                idData: "#data",
                                                xml: json.data["xml"],
                                                shdon: "",
                                                idSigner: "",
                                                tagSign: "NNT",
                                                listcerts: _listcerts,
                                                certAccept: certAccept
                                            };
                                            hub.invoke('execCommand', 'SignXmlTag', JSON.stringify(arg))
                                                .done(function () {
                                                    console.log("Success !")
                                                })
                                                .fail(function (error) {

                                                    webix.message(error, "error");
                                                });
                                        });

                                    });
                                    break;
                            }
                        });
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        // {
        //     view: "button", type: "htmlbutton", width: 120,
        //     label: '<i class="fa fa-paper-plane fa-lg aria-hidden="true"></i> ' +
        //         '<span class="text">' + _("Gửi CQT") + '</span>',
        //     id: "btnKyGuiCQT",
        //     click: function () {
        //         var tableDK = webix.$$("dangkysudung01Views");
        //         var selectedItem = tableDK.getSelectedItem();
        //         if (selectedItem == null) {
        //             webix.message("Bạn chưa chọn mẫu đăng ký ! ", "error");
        //             return;
        //         }
        //         if (selectedItem.trang_thai == 4) {
        //             webix.message("Mẫu đã gửi đi, không thể gửi lại ! ", "error");
        //             return;
        //         }
        //         webix.confirm({
        //             title: "GỬI ĐĂNG KÝ/ THAY ĐỔI",
        //             text: "Bạn có chắc chắn muốn gửi", ok: "Có", cancel: "Không",
        //             callback: function (res) {
        //                 if (res) {
        //                     if (res) {
        //                         webix.extend(tableDK, webix.ProgressBar);
        //                         tableDK.disable();
        //                         tableDK.showProgress();
        //                         webix.ajax()
        //                             .headers({ 'Content-Type': 'application/json' })
        //                             .get(app.config.host + "/Register68/SendToTVAN?id=" + selectedItem.mau01_id, function (text) {
        //                                 var result = JSON.parse(text);
        //                                 tableDK.enable();
        //                                 tableDK.hideProgress();
        //                                 if (result.code != "00") {
        //                                     webix.message({ type: 'error', text: result.message });
        //                                     return;
        //                                 }
        //                                 else {
        //                                     var table = webix.$$("dangkysudung01Views");
        //                                     webix.message("Gửi đến cơ quan thuế thành công !", "success");
        //                                     table.clearAll();
        //                                     table.load(table.config.url);
        //                                 }
        //                             });
        //                     }
        //                 }
        //             }
        //         });

        //     }
        // },
        {
            view: "button", type: "htmlbutton", width: 210,
            label: '<i class="fa fa-plus fa-lg aria-hidden="true"></i> ' +
                '<span class="text">' + _("Tạo mẫu và ký hiệu hóa đơn") + '</span>',
            id: "btnInsertMau",
            click: function () {
                var tableDK = webix.$$("dangkysudung01Views");
                webix.confirm({
                    title: "TẠO MẪU VÀ KÝ HIỆU HĐ TỰ ĐỘNG",
                    text: "Bạn có chắc chắn muốn tạo mẫu hóa đơn theo mẫu mặc định ?", ok: "Có", cancel: "Không",
                    callback: function (res) {
                        if (res) {
                            if (res) {
                                webix.extend(tableDK, webix.ProgressBar);
                                tableDK.disable();
                                tableDK.showProgress();
                                webix.ajax()
                                    .headers({ 'Content-Type': 'application/json' })
                                    .post(app.config.host + "/Pattern/InsertMauAndKyHieu", function (text) {
                                        var result = JSON.parse(text);
                                        tableDK.enable();
                                        tableDK.hideProgress();
                                        if (result.code != "00") {
                                            webix.message({ type: 'error', text: result.message });
                                            return;
                                        }
                                        else {
                                            var table = webix.$$("dangkysudung01Views");
                                            webix.message("Tạo mẫu hóa đơn và ký hiệu hóa đơn thành công !", "success");
                                            table.clearAll();
                                            table.load(table.config.url);
                                        }
                                    });
                            }
                        }
                    }
                });
            }
        },
        {
            view: "button", type: "htmlbutton", width: 160,
            label: '<i class="fa fa-plus fa-lg" aria-hidden="true"></i> ' +
                '<span class="text">' + _("Tải lên file chấp thuận") + '</span>',
            id: "btnAddM01",
            shortcut: "F4",
            on: {
                onClick: function () {
                    var us = user.getCurrentUser();
                    if (us != "ADMINISTRATOR") {
                        webix.message("Bạn không có quyền thực hiện thao tác này.", "error");
                        return;
                    }
                    var detailForm = this.$scope.ui(dangkysudungV2.$ui);
                    dangkysudungV2.setEditMode(1);
                    detailForm.show();
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {}
    ];

    var table = {
        margin: 0,
        rows: [{
            id: "dangkysudung01Views",
            view: "datatable",
            select: true,
            resizeColumn: true,
            footer: false,
            editable: false,
            tooltip: true,
            scheme: {
                $init: function (obj) {
                    // if (obj.date_new) {
                    //     obj.date_new = new Date(obj.date_new);
                    // }
                },
            },
            onClick: {
                "dowloadXmlDKSD": function (event, cell, target) {
                    var win = webix.$$("dangkysudung01Views");
                    var record = win.getItem(cell.row);
                    if (record.trang_thai != 3 && record.trang_thai != 4) {
                        webix.message("Mẫu chưa được ký không thể tải !", "error");
                        return;
                    }

                    var file = new Blob([record.xml_send], { type: "application/xml" });
                    webix.html.download(file, "Mau01.xml");
                },
                "btndowloadXMLRep": function (event, cell, target) {
                    var win = webix.$$("dangkysudung01Views");
                    var record = win.getItem(cell.row);
                    if (record.ket_qua == null || record.ket_qua == "") {
                        webix.message("Mẫu chưa được CQT trả về không thể tải !", "error");
                        return;
                    }
                    webix.extend(win, webix.ProgressBar);
                    win.disable();
                    win.showProgress();

                    var url = app.config.host + "/Invoice68/ExportXMLMau02?id=" + cell.row;
                    webix.ajax().response("arraybuffer")
                        .get(url, function (text, data) {

                            win.enable();
                            win.hideProgress();

                            var file = new Blob([data], { type: "application/xml" });
                            webix.html.download(file, "Mau02.xml");
                        });
                },
                "InMau01": function (event, cell, target) {
                    var table = webix.$$("dangkysudung01Views");
                    var item = table.getItem(cell.row);
                    var box = webix.modalbox({
                        title: "Đang in mẫu đăng ký/ thay đổi ....",
                        text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                        width: 350,
                        height: 200
                    });

                    var newWin = window.open();
                    var html = '<html><head><title>Hóa đơn điện tử M-Invoice</title>'
                        + '<link rel="stylesheet" href="assets/fontawesome_pro/css/all.css" type="text/css" charset="utf-8">'
                        + '<link rel="stylesheet" href="assets/fontawesome.css" type="text/css" charset="utf-8">'
                        + '</head><body><center>Đang tải dữ liệu ... <br><p><i style="font-size:200%;" class="fa fa-spin fa-spinner"></i></p></center></body></html>';
                    newWin.document.write(html);

                    webix.ajax()
                        .response("arraybuffer")
                        .headers({ 'Content-type': 'application/json' })
                        .get(app.config.host + "/Register68/PrintMau01?id=" + item.id + "&type=PDF",
                            {
                                error: function (text, data, XmlHttpRequest) {
                                    webix.modalbox.hide(box);
                                },
                                success: function (text, data, XmlHttpRequest) {
                                    var file = new Blob([data], { type: 'application/pdf' });
                                    var fileURL = URL.createObjectURL(file);
                                    webix.modalbox.hide(box);
                                    newWin.location = fileURL;
                                }
                            });

                },
                "InMau02": function (event, cell, target) {
                    var table = webix.$$("dangkysudung01Views");
                    var item = table.getItem(cell.row);

                    var box = webix.modalbox({
                        title: "Đang in mẫu đăng ký/ thay đổi ....",
                        text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                        width: 350,
                        height: 200
                    });

                    var newWin = window.open();
                    var html = '<html><head><title>Hóa đơn điện tử M-Invoice</title>'
                        + '<link rel="stylesheet" href="assets/fontawesome_pro/css/all.css" type="text/css" charset="utf-8">'
                        + '<link rel="stylesheet" href="assets/fontawesome.css" type="text/css" charset="utf-8">'
                        + '</head><body><center>Đang tải dữ liệu ... <br><p><i style="font-size:200%;" class="fa fa-spin fa-spinner"></i></p></center></body></html>';
                    newWin.document.write(html);

                    webix.ajax()
                        .response("arraybuffer")
                        .headers({ 'Content-type': 'application/json' })
                        .get(app.config.host + "/Invoice68/inMau02?id=" + item.id + "&type=PDF",
                            {
                                error: function (text, data, XmlHttpRequest) {
                                    webix.modalbox.hide(box);
                                },
                                success: function (text, data, XmlHttpRequest) {
                                    var file = new Blob([data], { type: 'application/pdf' });
                                    var fileURL = URL.createObjectURL(file);
                                    //window.open(fileURL, '_blank');
                                    webix.modalbox.hide(box);
                                    newWin.location = fileURL;
                                }
                            });
                },
                "btnViewLichsu": function (event, cell, target) {
                    var table = webix.$$("dangkysudung01Views");
                    var item = table.getItem(cell.row);
                    var detailForm = this.$scope.ui(viewLogForm.$ui);
                    viewLogForm.initUI(null, item.mtdiep_gui, item);
                    detailForm.config.mtdiep = item.mtdiep_gui;
                    detailForm.show();
                }
            },
            on: {
                "data->onStoreUpdated": function () {
                    this.data.each(function (obj, i) {
                        obj.stt = i + 1;
                    });
                },
                onItemDblClick: function (id, e, node) {
                    var btnEdit = $$("btnEdit");
                    btnEdit.callEvent("onClick");
                },
                onBeforeLoad: function () {
                    this.showOverlay("<p><i style='font-size:450%;' class='fa fa-spin fa-spinner fa-pulse'></i></p>");
                },
                onAfterLoad: function (id) {
                    this.hideOverlay();
                }
            },
            columns: [
                { id: "stt", header: ["STT"], width: 40 },
                {
                    id: "nlap", format: function (text) {
                        var format = webix.Date.dateToStr("%d/%m/%Y");
                        text = removeTimeZoneT(text);
                        return format(text);
                    }, header: ["Ngày lập"], width: 130
                },
                {
                    id: "hthuc", header: ["Hình thức"], width: 120, template: function (obj) {
                        if (obj.hthuc == 1)
                            return "Đăng ký";
                        else
                            return "Thay đổi";
                    }
                },
                { id: "dctdtu", header: ["Email"], width: 200 },
                {
                    id: "ngay_gui", header: ["Ngày gửi"], width: 110, format: function (text) {
                        var format = webix.Date.dateToStr("%d/%m/%Y");
                        text = removeTimeZoneT(text);
                        return format(text);
                    }
                },
                {
                    id: "btnInMau01",
                    header: ["In"],
                    css: { "text-align": "center" },
                    template: function (obj) {
                        if (obj.trang_thai == 3 || obj.trang_thai == 4) {
                            return "<span class='InMau01' style='color: #00b300'><i class='mdi mdi-18px mdi-printer'></i></span> ";
                        } else
                            return "<span class='InMau01' style='color: #c8c8cc'><i class='mdi mdi-18px mdi-printer'></i></span> ";
                    },
                    width: 60
                },
                {
                    id: "dowloadXmlDKSD",
                    header: ["Tải về"],
                    css: { "text-align": "center" },
                    template: function (obj) {
                        if (obj.trang_thai == 3 || obj.trang_thai == 4) {
                            return "<span class='dowloadXmlDKSD' style='color: #00b300'><i class='fas fa-download'></i></span> ";
                        } else
                            return "<span class='dowloadXmlDKSD' style='color: #c8c8cc'><i class='fas fa-download'></i></span> ";
                    },
                    width: 60
                },
                {
                    id: "trang_thai", header: ["Trạng thái"], width: 130,
                    // css: { "text-align": "center" },
                    template: function (obj) {
                        if (obj.trang_thai == 3) {
                            return `<span style='color: ${CONSTANTS.COLOR.DA_KY};font-weight: bold;'>Đã ký</span>`;
                        } else {
                            if (obj.trang_thai == 4)
                                return `<span style='color: ${CONSTANTS.COLOR.DA_GUI};font-weight: bold;'>Đã Gửi</span>`;
                            else
                                return `<span style='color: ${CONSTANTS.COLOR.CHO_KY};font-weight: bold;'>Chờ ký</span>`;
                        }
                    }
                },
                {
                    id: "mtdiep_cqt", header: ["Trạng thái CQT"], width: 160, css: { "text-align": "center" }, template: function (obj) {
                        if (obj.trang_thai == 4) {
                            var response = "";
                            switch (obj.ket_qua) {
                                case "":
                                    break;
                                case null:
                                    break;
                                case "1":
                                    response = `<span style='color: ${CONSTANTS.COLOR.CHAP_NHAN};font-weight: bold;'>Chấp nhận</span>`;
                                    break;
                                case "98":
                                    response = `<span style='color: ${CONSTANTS.COLOR.TIEP_NHAN};font-weight: bold;'>Tiếp nhận</span>`;
                                    break;
                                case "99":
                                    response = `<span style='color: ${CONSTANTS.COLOR.KHONG_CHAP_NHAN};font-weight: bold;'>Không tiếp nhận</span>`;
                                    break;
                                default:
                                    response = `<span style='color: ${CONSTANTS.COLOR.KHONG_CHAP_NHAN};font-weight: bold;'>Không chấp nhận</span>`;
                                    break;
                            };
                            return response;
                        }
                        else
                            return "";
                    }
                },
                {
                    id: "btnViewLichsu",
                    header: ["Xem thông báo"],
                    css: { "text-align": "center", "color": "blue", "text-decoration": "underline" },
                    template: function (obj) {
                        return "<span class='btnViewLichsu'>Thông báo<span>";
                    },
                    width: 150
                },
                { id: "nguoi_gui", header: ["Người gửi"], width: 180 },
                { id: "mtdiep_gui", header: ["Mã thông điệp gửi"], width: 150 }
            ],
            pager: "pagerA",
        },
        {
            id: "pagerA",
            view: "pager",
            template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}",
            container: "paging_here",
            size: 50,
            group: 5,
        },
        ]
    };

    var layout = {
        css: "frmView",
        id: "frmView",
        rows: [
            {
                id: "btnRegister",
                height: 39,
                css: "btnControl",
                type: "toolbar",
                margin: 0,
                borderless: true,
                // hidden: true,
                cols: controls
            },
            {
                rows: [table],
            },
        ],
    };
    function loadData() {
        var table = webix.$$("dangkysudung01Views");
        table.clearAll();
        table.load(table.config.url);
    }
    return {
        $ui: layout,
        $oninit: function (view, $scope) {
            var table = webix.$$("dangkysudung01Views");
            webix.extend(view, webix.ProgressBar);
            $scope.on(app, "dataChangeDangkysudung68", function (mode, item) {
                if (mode == 1) {
                    table.clearAll();
                    table.load(table.config.url);
                }
                if (mode == 2) {
                    table.clearAll();
                    table.load(table.config.url);
                }
            });
            $scope.on(app, "filterTable", function (report_id, infoWindowId, item) {
                var infoparam = {
                    infowindow_id: infoWindowId,
                    parameter: item,
                };
                table.config.infoparam = infoparam;
                table.clearAll();
                table.load(table.config.url);
            });
        },
        $onurlchange: function (ui, name, url, scope) {
            initUI();
        }
    };
});
define('views/forms/forms68/DanhMuc/dmxangdau',["app", "locale", "views/modules/Component/constantManager"], function (app, _, constant) {
    var editMode = 0;
    var winId = "dmXangDauWin";
    var formId = "dmXangDauForm";
    var tblLog = "tblDmXangDauLog";
    var btnSave = "btnSave";
    return {
        $ui: {
            view: "window", modal: true, id: winId, position: "center",
            head: {
                height: 35,
                cols: [
                    {
                        id: "headHttoan", view: "template", css: "headform", width: 35, template: "<span><i class='fa fa-plus' aria-hidden='true'></i></span>",
                    },
                    {
                        id: "head-frmHttoan", view: "template", css: "headform",
                        template: function (obj) {
                            switch (editMode) {
                                case 1: return "<div>Thêm hàng hóa xăng dầu<div/>"; break;
                                case 2: return "<div>Sửa hàng hóa xăng dầu<div/>"; break;
                                case 3: return "<div>Lịch sử chỉnh sửa hàng hóa xăng dầu<div/>"; break;
                                case 4: return "<div>Sao chép hàng hóa xăng dầu<div/>"; break;
                            }
                        },
                    },
                    {
                        view: "icon",
                        icon: "fas fa-question-circle",
                        id: "help_frmhttoan",
                        tooltip: _("HELPER"),
                        click: function () {
                            var newWin = window.open();
                            newWin.location =
                                "http://huongdansudung.minvoice.com.vn/Tomihoadon.html";
                        },
                    },
                ],
            },
            move: true,
            resize: true,
            body: {
                paddingY: 10,
                paddingX: 10,
                view: "form",
                id: formId,
                elementsConfig: { labelWidth: 100, labelPosition: "top" },
                complexData: true,
                margin: 0,
                minWidth: 600,
                elements: [
                    { view: "text", name: "dmhanghoaxangdau_id", hidden: true },
                    { view: "text", name: "ma_hang", label: "Mã hàng hóa", required: true, invalidMessage: "Mã hàng hóa không được để trống" },
                    { view: "text", name: "ten_hang", label: "Tên hàng hóa", required: true, invalidMessage: "Tên hàng hóa không được để trống" },
                    {
                        cols: [
                            {
                                id: "dvtinh",
                                name: "dvtinh",
                                label: _("Đơn vị tính"),
                                view: "combo",
                                value: "Lít",
                                options: {
                                    view: "gridsuggest",
                                    columnName: "dvt",
                                    url: constant.API.GET_DVT_PETRO,
                                    body: {
                                        scroll: true,
                                        autoheight: false,
                                        datatype: "json",
                                        columns: [
                                            { id: "id", width: 100, header: "Mã ĐVT" },
                                            { id: "value", width: 150, header: "Tên ĐVT" },
                                        ]
                                    },
                                    on: {
                                        onValueSuggest: function (obj) {
                                        },
                                    },
                                },
                            },
                            {
                                view: "combo", id: "tsuat123", name: "tsuat", label: "Thuế suất", value: "10%", invalidMessage: "Thuế suất không được để trống", options: { url: app.config.host + "/Invoice68/GetVAT" },
                                on: {
                                    onChange: function () {
                                        var niemYetValue = $$("niem_yet");
                                        if (niemYetValue)
                                            niemYetValue.callEvent("onChange", [niemYetValue.getValue(), ""]);
                                    }
                                }
                            }
                        ],
                    },
                    {
                        cols: [
                            {
                                view: "autonumeric", id: "niem_yet", name: "niem_yet", label: "Giá niêm yết (Đã bao gồm thuế GTGT)", required: true, invalidMessage: "Đơn giá không được để trống",
                                on: {
                                    onChange: function (newVal) {
                                        var tsuatValue = $$("tsuat").getValue();
                                        var dgiaValue = newVal / (1 + (tsuatValue / 100));
                                        $$("dgia").setValue(dgiaValue);
                                    }
                                }
                            },
                            { view: "text", id: "dgia", format: "1,111.00", name: "dgia", label: "Đơn giá", required: true, invalidMessage: "Đơn giá không được để trống" },
                        ],
                    },
                    {
                        cols: [
                            { view: "autonumeric", name: "stt", label: "Thứ tự", required: true, invalidMessage: "Thứ tự không được để trống" },
                            {
                                view: "text", name: "mgia", label: "Danh sách mệnh giá", required: true, invalidMessage: "Danh sách mệnh giá không được để trống",
                                on: { onKeyPress: function (code, e) { return !(e.key === '.' || (e.key >= 'a' && e.key <= 'z') || e.shiftKey); } }//không nhận chữ cái hoa/thường và dấu chấm
                            }]
                    },
                    { view: "checkbox", name: "is_use", labelRight: "Sử dụng trên app mobile", labelWidth: 0, },
                    { height: 5 },
                    {
                        view: "datatable",
                        resizeColumn: true,
                        margin: 10,
                        id: tblLog,
                        height: 200,
                        hidden: true,
                        on: {
                        },
                        columns: [
                            { id: "ma_hang", header: "Mã hàng hóa", editor: "text", width: 150, editable: true },
                            { id: "ten_hang", header: "Tên hàng hóa", editor: "text", width: 150, editable: true },
                            { id: "dvtinh", header: "Đơn vị tính", editor: "text", width: 150, editable: true },
                            {
                                id: "niem_yet",
                                header: "Giá niêm yết", editor: "autonumeric", width: 100,
                                editable: true, css: { "text-align": "right" },
                                format: webix.Number.numToStr({
                                    groupDelimiter: ",",
                                    groupSize: 3,
                                    decimalDelimiter: ".",
                                    decimalSize: 2
                                })
                            },
                            {
                                id: "dgia",
                                header: "Đơn giá", editor: "autonumeric", width: 100,
                                editable: true, css: { "text-align": "right" },
                                format: webix.Number.numToStr({
                                    groupDelimiter: ",",
                                    groupSize: 3,
                                    decimalDelimiter: ".",
                                    decimalSize: 2
                                })
                            },
                            {
                                id: "tsuat",
                                header: _("Thuế suất"),
                                width: 100, editor: "autonumeric", editable: true, css: { "text-align": "right" },
                                format: webix.Number.numToStr({
                                    groupDelimiter: ",",
                                    groupSize: 3,
                                    decimalDelimiter: ".",
                                    decimalSize: 2
                                })
                            },
                            { id: "mgia", header: "Mệnh giá", editor: "text", width: 150, editable: true },
                            { id: "user_new", header: "Người sửa", editor: "text", width: 150, editable: true },
                            { id: "date_new", header: "Ngày sửa", editor: "text", width: 150, editable: true, template: function (obj) { return formatDate(obj.date_new); } },
                            {
                                id: "is_use", header: { text: "<p>Sử dụng trên Mobile" }, width: 100, height: 50, css: { "text-align": "center" }, template: function (obj) {
                                    if (obj.is_use)
                                        return "<div style='text-align:center;'><input type='checkbox' checked disabled></div>";
                                    else
                                        return "<div style='text-align:center;'><input type='checkbox' disabled></div>";
                                }
                            },
                            {
                                id: "stt", header: "Thứ tự", width: 150, sort: "server", columnType: "number",
                            }
                        ],
                        on: {
                            onBeforeLoad: function () {
                                this.showOverlay(_("LOADING") + "...");
                            },
                            onAfterLoad: function () {
                                this.hideOverlay();
                            },
                        }
                    },
                    {
                        margin: 10,
                        cols: [
                            {},
                            {
                                shortcut: "F10", id: btnSave, view: "button", label: "Nhận", type: "form", align: "center", width: 100,
                                on: {
                                    onClick: function () {
                                        var form = $$(formId);
                                        var win = $$(winId);
                                        if (form.validate()) {
                                            var formValue = form.getValues();
                                            var apiHost = app.config.host + "/Category/PetroSaveChange";
                                            formValue.editMode = editMode;
                                            if (editMode == 1 || editMode == 4) formValue.dmhanghoaxangdau_id = "00000000-0000-0000-0000-000000000000";
                                            webix.extend(win, webix.ProgressBar);
                                            win.disable();
                                            win.showProgress();

                                            webix.ajax().header({ "content-type": "application/json" }).post(apiHost, formValue, function (result) {
                                                win.enable();
                                                win.hideProgress();

                                                var response = JSON.parse(result);
                                                if (response.code == "00") {
                                                    app.callEvent("dataChangedDmXangDau", [editMode, null]);
                                                    if ($$(winId).config.callback != undefined) {
                                                        $$(winId).config.callback(response.data);
                                                    }
                                                    webix.message(editMode == 1 ? "Thêm mới" : (editMode == 4 ? "Sao chép" : "Chỉnh sửa") + " thành công", "success");
                                                    $$(winId).close();
                                                } else {
                                                    form.markInvalid("ma_hang", "Mã hàng hóa không được trùng tên");
                                                    webix.message(response.message, "error");
                                                }
                                            })
                                        }
                                    }
                                },
                                click: function () {
                                    this.callEvent("onClick");
                                }
                            },
                            { view: "button", id: "btnCancel", hotkey: "esc", label: "Hủy", type: "danger", align: "center", width: 100, click: function () { $$(winId).close(); } },
                            {}
                        ]
                    }
                ]
            }
        },
        setEditMode: function (mode, item) {
            editMode = mode;
            if (mode == 2 || mode == 3) {
                if (mode == 3) {
                    $$(formId).getChildViews().forEach(function (view) {
                        view.hide();
                    });
                    const btnCancelConfig = { view: "button", id: "btnCancel", hotkey: "esc", label: "Hủy", type: "danger", align: "center", width: 100, click: function () { $$(winId).close(); } }
                    $$(tblLog).show();
                    $$(formId).addView(btnCancelConfig);
                }
                // $$(tblLog).clearAll();
                // $$(tblLog).load(app.config.host + "/Category/GetDetailsPetro?id=" + item.dmhanghoaxangdau_id);
            }
        }
    }

});
define('views/68_dmxangdau',["app", "locale", "views/forms/forms68/DanhMuc/dmxangdau"], function (app, _, dmXangDauForm) {

    var gridId = "dmXangDauView";
    var formId = "dmXangDauForm";
    var btnReloadId = "btnReload";

    var controls = [
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-refresh fa-lg" aria-hidden="true"></i><span class="text">' + _("REFRESH") + "</span>",
            id: btnReloadId,
            on: {
                onClick: function () {
                    webix.callEvent("onLoadError");
                    var table = webix.$$(gridId);
                    table.clearAll();
                    table.load(table.config.url);
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-plus fa-lg" aria-hidden="true"></i><span class="text">' + _("Thêm (F4)") + "</span>",
            id: "btnPlus",
            shortcut: "F4",
            click: function () {
                var grid = $$(gridId);
                dmXangDauForm.setEditMode(1);
                grid.$scope.ui(dmXangDauForm).show();
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-edit fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("Sửa (F3)") + "</span>",
            id: "btnEditPetro",
            shortcut: "F3",
            on: {
                onClick: function () {
                    var grid = $$(gridId);
                    var selected = grid.getSelectedItem();
                    if (selected == null) {
                        webix.message("Bạn chưa chọn dòng cần sửa", "error");
                        return;
                    }
                    var form = grid.$scope.ui(dmXangDauForm);
                    dmXangDauForm.setEditMode(2, selected);
                    $$(formId).setValues(selected);
                    form.show();
                }
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-trash-o fa-lg" aria-hidden="true"></i><span class="text">' + _("Xóa (F8)") + "</span>",
            id: "btnDelete",
            shortcut: "F8",
            click: function () {
                var grid = $$(gridId);
                var selected = grid.getSelectedItem();
                if (selected == null) {
                    webix.message("Bạn chưa chọn dòng cần xóa", "error");
                    return;
                }
                selected.editMode = 3;
                webix.confirm({
                    title: "XÓA HÀNG HÓA",
                    text: "Bạn có muốn xóa hàng hóa này",
                    ok: "Có",
                    cancel: "Không",
                    callback: function (res) {
                        if (res) {
                            webix.extend(grid, webix.ProgressBar);
                            grid.disable();
                            grid.showProgress();
                            var url = app.config.host + "/Category/PetroSaveChange"
                            webix.ajax().header({ "content-type": "application/json" }).post(url, selected, function (result) {
                                grid.enable();
                                grid.hideProgress();
                                var response = JSON.parse(result);
                                if (response.code == "00") {
                                    webix.message("Xóa thành công", "success");
                                    $$(btnReloadId).callEvent("onClick");
                                } else {
                                    webix.message(response.message, "error");
                                }
                            })
                        }
                    }
                })
            }
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-edit fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("COPY") + "</span>",
            id: "btnCopyPetro",
            shortcut: "F3",
            on: {
                onClick: function () {
                    var grid = $$(gridId);
                    var selected = grid.getSelectedItem();
                    if (selected == null) {
                        webix.message("Bạn chưa chọn dòng cần sao chép", "error");
                        return;
                    }
                    var form = grid.$scope.ui(dmXangDauForm);
                    dmXangDauForm.setEditMode(1, selected);
                    $$(formId).setValues(selected);
                    form.show();
                }
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 150,
            label: '<i class="fa fa-edit fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("Lịch sử chỉnh sửa") + "</span>",
            id: "btnHistoryPetro",
            shortcut: "F3",
            on: {
                onClick: function () {
                    var grid = $$(gridId);
                    var selected = grid.getSelectedItem();
                    if (selected == null) {
                        webix.message("Bạn chưa chọn dòng cần sửa", "error");
                        return;
                    }

                    var form = grid.$scope.ui(dmXangDauForm);
                    dmXangDauForm.setEditMode(3, selected);
                    $$(formId).setValues(selected);
                    form.show();
                }
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
    ]
    var grid = {
        rows: [
            {
                view: "datatable",
                id: gridId,
                select: true,
                resizeColumn: true,
                datafetch: 50,
                pager: "pagerA",
                url: {
                    $proxy: true,
                    load: function (view, callback, params) {
                        webix.extend(view, webix.ProgressBar);
                        view.disable();
                        view.showProgress();
                        var start = null;
                        var count = null;
                        var filter = [];
                        var tlbparam_s = [];
                        if (params == null) {
                            start = 0;
                            count = view.config.datafetch;
                        }
                        else {
                            start = params.start;
                            count = params.count;
                            if (params.filter != null) {
                                var array = [];
                                for (var property in params.filter) {
                                    var column = view.getColumnConfig(property);
                                    var item = {
                                        columnName: property,
                                        columnType: column.columnType,
                                        value: params.filter[property]
                                    };
                                    array.push(item);
                                }
                                filter = array;
                            }
                        }
                        var item = {
                            command: "CM0031",
                            start: start,
                            count: count,
                            filter: filter,
                            tlbparam: tlbparam_s
                        };
                        var apiHost = app.config.host + "/Pattern/GetData";
                        webix.ajax()
                            .headers({ 'Content-type': 'application/json' })
                            .bind(view)
                            .post(apiHost, item, callback, view);
                    }
                },
                type: {
                    amount: function (obj, common, value, config) {
                        return value == null ? 0 : formatDecimal(value);
                    }`  `
                },
                columns: [
                    {
                        id: "indexs", header: ["STT"], width: 50,
                    },
                    {
                        id: "ma_hang", header: ["Mã hàng hóa", { content: "serverFilter" }], width: 240, sort: "server", columnType: "string",
                    },
                    {
                        id: "ten_hang", header: ["Tên hàng hóa", { content: "serverFilter" }], width: 240, sort: "server", columnType: "string",
                    },
                    {
                        id: "dvtinh", header: ["Đơn vị tính", { content: "serverFilter", }], width: 70, sort: "server", columnType: "string"
                    },
                    {
                        id: "niem_yet", header: ["Niêm yết", { content: "serverFilter" }], width: 140, sort: "server", columnType: "decimal"
                    },
                    {
                        id: "dgia", header: ["Đơn giá", { content: "serverFilter" }], width: 140, sort: "server", columnType: "decimal"
                    },
                    {
                        id: "tsuat", header: ["Thuế suất", { content: "serverFilter" }],
                        width: 70, columnType: "decimal", sort: "server", css: { "text-align": "center" }
                    },
                    {
                        id: "mgia", header: ["Mệnh giá", { content: "serverFilter" }], width: 180, sort: "server", columnType: "string"
                    },
                    {
                        id: "user_new", header: ["Người tạo", { content: "serverFilter" }], width: 150, sort: "server", columnType: "string",
                    },
                    {
                        id: "date_new", header: ["Ngày tạo", { content: "serverDateRangeFilter" }],
                        width: 150, format: function (text) { var format = webix.Date.dateToStr("%d/%m/%Y %H:%i"); text = removeTimeZoneT(text); return format(text); },
                        sort: "server", columnType: "datetime",
                    },
                    {
                        id: "is_use", header: { text: "<p>Sử dụng trên Mobile" }, width: 100, height: 50, css: { "text-align": "center" }, template: function (obj) {
                            if (obj.is_use)
                                return "<div style='text-align:center;'><input type='checkbox' checked disabled></div>";
                            else
                                return "<div style='text-align:center;'><input type='checkbox' disabled></div>";
                        }
                    },
                    {
                        id: "stt", header: "Thứ tự", width: 150, sort: "server", columnType: "number",
                    }
                ],
                on: {
                    "data->onStoreUpdated": function () {
                        this.data.each(function (obj, i) {
                            obj.indexs = i + 1;
                        });
                    },
                    onAfterLoad: function () {
                        $$(gridId).enable();
                        $$(gridId).hideProgress();
                    },
                    onItemDblClick: function (id, e, node) {
                        var btnEdit = $$("btnEditPetro");
                        btnEdit.callEvent("onClick");
                    },
                }
            },
            {
                cols: [
                    {
                        view: "icon", icon: "fas fa-question-circle", id: "help_form_main", tooltip: _("HELPER"),
                        css: "helper",
                        click: function () {
                            var newWin = window.open();
                            newWin.location = "http://huongdansudung.minvoice.com.vn/Tomihoadon.html";
                        }
                    },
                    {},
                    {
                        id: "pagerA",
                        view: "pager",
                        size: 50,
                        group: 5,
                        template: function (data, common) {
                            return "Số dòng: " + data.count + ". " + common.first(data) + common.prev(data) + common.pages(data) + common.next(data) + common.last(data);
                        }
                    },
                    {}
                ]
            }
        ]
    }
    var layout = {
        css: "frmView",
        id: "frmView",
        rows: [
            { height: 39, id: "btnControl", css: "btnControl", margin: 0, borderless: true, type: "toolbar", cols: controls },
            { rows: [grid] }
        ]
    };
    return {
        $ui: layout,
        $oninit: function (view, $scope) {
            $scope.on(app, "dataChangedDmXangDau", function (editmode, item) {
                var table = webix.$$(gridId);
                table.clearAll();
                table.load(table.config.url);
            });
        },
    }
});
define('views/forms/forms68/68_eventTableForm',["app", "models/user"], function (app, user) {
    var editmode = 0;
    var param;
    var button = [
        {},
        {
            shortcut: "F10",
            view: "button",
            label: "Nhận (F10)",
            type: "form",
            align: "center",
            width: 120,
            on: {
                onClick: function () {
                    var item = $$("eventTable-form").getValues();
                    var table = $$("eventTable-form");

                    if (table.validate()) {
                        webix.extend(table, webix.ProgressBar);
                        table.disable();
                        table.showProgress();
                        webix.ajax()
                            .headers({ 'Content-type': 'application/json' })
                            .post(app.config.host + "/Pattern/SaveChangeEventTable", item, {
                                error: function (text, data, XmlHttpRequest) {
                                    var table = $$("eventTable-form");
                                    table.enable();
                                }, success: function (text, data, XmlHttpRequest) {
                                    var json = JSON.parse(text);
                                    var table = $$("eventTable-form");
                                    table.enable();
                                    table.hideProgress();
                                    if (json.code == "00") {
                                        $$("eventTable-win").close();
                                        var table = $$("eventTableViews");
                                        table.clearAll();
                                        table.load(table.config.url);
                                    }
                                    else {
                                        webix.message(json.message, "error");
                                    }
                                }
                            });
                    }
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {
            view: "button",
            hotkey: "esc",
            label: "Hủy bỏ (ESC)",
            type: "danger",
            align: "center",
            width: 120,
            click: function () {
                webix.$$("eventTable-win").close();
            }
        },
        {}
    ]

    var ui = {
        view: "window",
        //modal: true,
        fullscreen: true,
        move: true,
        id: "eventTable-win",
        position: "center",
        head: "Danh mục event table",
        on: {
            onBeforeShow: function () {

            }
        },
        body: {
            paddingY: 10,
            paddingX: 10,
            view: "form",
            width: 800,
            id: "eventTable-form",
            complexData: true,
            margin: 0,
            elements: [
                {
                    view: "combo", label: "Loại hóa đơn", name: "type_invoice",
                    id: "type_invoice", required: true, invalidMessage: "Loại hóa đơn không được bỏ trống",
                    labelWidth: 120,
                    options: app.config.host + "/Pattern/GetData?command=CM0013&start=0&count=50&continue=null&filter=null",
                    on: {
                        onChange: function (newv, oldv) {
                        }
                    }
                },
                { id: "after_edit_stop", name: "after_edit_stop", label: "After edit stop", labelWidth: 120, view: "textarea" },
                { id: "after_delete", name: "after_delete", label: "After delete", labelWidth: 120, view: "textarea" },
                { id: "is_use", name: "is_use", label: "Sử dụng", labelWidth: 120, view: "checkbox" },
                {
                    margin: 10,
                    cols: button
                }
            ]
        }

    };

    return {
        $ui: ui,
        setEditMode: function (mode) {
            editmode = mode;
        },
        initUI: function (item) {
            param = item;
        },
        setValues: function (item) {
            $$("eventTable-form").setValues(item);
        }
    };
});
define('views/68_eventTable',[
    "app",
    "locale",
    "models/user",
    "views/forms/forms68/68_eventTableForm",
], function (app, _, user, eventTableForm) {
    'use strict';

    var controls = [
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-refresh fa-lg" aria-hidden="true"></i> ' +
                '<span class="text">' + _("REFRESH") + '</span>',
            id: "btnReload",
            on: {
                onClick: function () {
                    webix.callEvent("onLoadError");
                    var table = webix.$$("eventTableViews");
                    table.clearAll();
                    table.load(table.config.url);
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-plus fa-lg" aria-hidden="true"></i> ' +
                '<span class="text">' + _("THEM") + ' (F4)</span>',
            id: "btnPlus",
            shortcut: "F4",
            on: {
                onClick: function () {
                    var detailForm = this.$scope.ui(eventTableForm.$ui);
                    eventTableForm.setEditMode(1);
                    detailForm.show();
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-edit fa-lg" aria-hidden="true"></i> ' +
                '<span class="text">' + _("SUA") + ' (F3)</span>',
            id: "btnEdit",
            shortcut: "F2",
            on: {
                onClick: function () {
                    var table = webix.$$("eventTableViews");
                    var selectedItem = table.getSelectedItem();
                    if (selectedItem == null) {
                        webix.message("Bạn chưa chọn dòng ! ", "error");
                        return;
                    }

                    var detailForm = this.$scope.ui(eventTableForm.$ui);
                    eventTableForm.setEditMode(2);
                    eventTableForm.setValues(selectedItem);
                    detailForm.show();
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-trash-o fa-lg" aria-hidden="true"></i> ' +
                '<span class="text">' + _("XOA") + ' (F3)</span>',
            id: "btnDelete",
            shortcut: "F3",
            // id: "btnDelete",
            // view: "button",
            // type: "icon",
            // icon: "trash-o",
            // label: _("XOA") + " (F8)",
            // width: 100,
            // css: "button_raised",
            // shortcut: "F8",
            on: {
                onClick: function () {
                    var table = webix.$$("eventTableViews");
                    var selectedItem = table.getSelectedItem();
                    if (selectedItem == null) {
                        webix.message("Bạn chưa chọn dòng cần xóa ! ", "error");
                        return;
                    }

                    //selectedItem.editmode = 3;
                    // var dataPut = {
                    //     tab_masters: "ttkhac",
                    //     editmode: 3,
                    //     data: [selectedItem]
                    // };

                    webix.confirm({
                        text: "Bạn có muốn xóa bản ghi",
                        ok: "Có",
                        cancel: "Không",
                        callback: function (choose) {
                            if (choose) {
                                webix.extend(table, webix.ProgressBar);
                                table.disable();
                                table.showProgress();

                                webix.ajax()
                                    .headers({ 'Content-type': 'application/json' })
                                    .get(app.config.host + "/Pattern/DeleteEventTable?id=" + selectedItem.id,
                                        {
                                            error: function (text, data, XmlHttpRequest) {
                                                table.enable();
                                                table.hideProgress();
                                            },
                                            success: function (text, data, XmlHttpRequest) {
                                                var res = JSON.parse(text);
                                                if (res.code != "00") {
                                                    webix.message(res.error, "error");
                                                }
                                                else {
                                                    table.remove(selectedItem.id);
                                                    table.enable();
                                                    table.hideProgress();
                                                }
                                            }
                                        });
                            }
                        }
                    });
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        }
    ];
    
    var grid = {
        rows: [
            {
                view: "datatable",
                id: "eventTableViews",
                select: true,
                resizeColumn: true,
                fixedRowHeight: false,
                // leftSplit: 8,
                // rightSplit: 1,
                rowLineHeight: 25, rowHeight: 25,
                tooltip: true,
                //autowidth: true,
                url: {
                    $proxy: true,
                    load: function (view, callback, params) {
                        var tlbparam_s = [];
                        var url = app.config.host + "/Pattern/GetData";

                        if (params == null) {
                            url = url + "?command=CM0016&start=0&count=" + view.config.datafetch + "&continue=null&filter=null";
                        }
                        else {
                            url = url + "?command=CM0016&start=" + params.start + "&count=" + params.count + "&continue=" + params.continue;

                            if (params.filter != null) {
                                var array = [];

                                for (var property in params.filter) {

                                    var column = view.getColumnConfig(property);
                                    var item = {
                                        columnName: property,
                                        columnType: column.columnType,
                                        value: params.filter[property]
                                    };

                                    array.push(item);
                                }

                                //console.log(JSON.stringify(array));
                                url = url + "&filter=" + JSON.stringify(array);
                            }
                        }
                        var tlbParams = $$("paramKH");

                        if (tlbParams !== undefined) {
                            var childViews = tlbParams.getChildViews();

                            var parameters = [];

                            for (var i = 0; i < childViews.length; i++) {
                                var child = childViews[i];
                                // console.log(child);
                                var id = child.config.id;
                                //var value_field = child.config.value_field;

                                var item = {
                                    columnName: "cctbao_id",
                                    value: $$(id).getValue()
                                };

                                parameters.push(item);
                            }
                            tlbparam_s = parameters;
                            url = url + "&tlbparam=" + JSON.stringify(parameters);

                        }
                        // else {
                        //     url = url + "&tlbparam=null";
                        // }
                        webix.ajax(url, callback, view);
                    }
                },
                onClick: {
                    "dowloadXmlDKSD": function (event, cell, target) {

                    }
                },
                on: {
                    "data->onStoreUpdated": function () {
                        this.data.each(function (obj, i) {
                            obj.index = i + 1;
                        });
                    },
                    onItemClick: function (id) {

                    },
                    onClick: function (e) {
                        // var view = $$(e);
                        // if (!view || !view.getFormView || view.getFormView() != $$("invoiceDate"))
                        //     webix.confirm("The changes was not saved");
                    },
                    onItemDblClick: function (id, e, node) {
                        var btnEdit = $$("btnEdit");
                        btnEdit.callEvent("onClick");
                    },
                    onAfterLoad: function () {

                    },
                    onColumnResize: function () {
                        // this.adjustRowHeight("ten_loai", true);
                        // this.render();
                    }
                },
                columns: [
                    {
                        id: "index",
                        header: ["<center>STT</center>", { content: "textFilter" }],
                        sort: "int",
                        width: 40,
                    },
                    {
                        id: "ten", header: ["<center>Loại hóa đơn</center>", { content: "textFilter" }],
                        width: 200, columnType: "nvarchar"
                    },
                    {
                        id: "after_edit_stop", header: ["<center>After Edit Stop</center>", { content: "textFilter" }],
                        width: 200, columnType: "nvarchar"
                    },
                    {
                        id: "user_new", header: ["<center>UserNew</center>", { content: "textFilter" }],
                        width: 200, columnType: "nvarchar"
                    },
                    {
                        id: "is_use", header: ["<center>Sử dụng</center>", { content: "textFilter" }],
                        width: 200, columnType: "nvarchar",   editor: "checkbox",
                        template: function (obj) {
                            var checked =
                                obj.is_use == true ? 'checked="true"' : "";
                            return (
                                "<input disabled class='webix_table_checkbox' type='checkbox' " +
                                checked +
                                ">"
                            );
                        }
                    }
                ],
                pager: "pagerA"
            },
            {
                cols: [
                    {
                        view: "icon", icon: "fas fa-question-circle", id: "help_form_main", tooltip: _("HELPER"),
                        css: "helper",
                        click: function () {
                            webix.alert({
                                title: "Thông báo !",
                                text: "Bạn chưa khai báo hướng dẫn nhanh cho màn hình này !",
                                type: "alert-warning",
                                callback: function (result) {
                                }
                            });
                        }
                    },
                    {
                        view: "combo",
                        label: _("MENU_QUICK"),
                        id: "QuickMenuMain",
                        options: {

                        },
                        on: {
                            onChange: function (newv, oldv) {

                            }
                        }
                    },
                    {},
                    {
                        id: "pagerA",
                        view: "pager",
                        size: 100,
                        group: 5,
                        template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}"
                    }
                ]
            }
        ]
    }

    var layout = {
        css: "frmView",
        rows: [
            {
                height: 39,
                css: "btnControl",
                margin: 0,
                borderless: true,
                type: "toolbar",
                cols: controls
            },
            {
                rows: [
                    grid
                ]
            }
        ]

    };

    return {
        $ui: layout,
        $oninit: function (view, $scope) {
            $scope.on(app, "dataChangedViewsEventTable", function (editmode, item) {

            });
        }
    };
});
define('views/forms/forms68/DanhMuc/htttoan',["app", "locale"], function (app, _) {
    var editMode = 0;
    var winId = "HTTToanWin";
    var formId = "HTTToanForm";
    return {
        $ui: {
            view: "window", modal: true, id: winId, position: "center",
            head: {
                height: 35,
                cols: [
                  {
                    id: "headHttoan",
                    view: "template",
                    css: "headform",
                    width: 35,
                    template: "<span><i class='fa fa-plus' aria-hidden='true'></i></span>",
                  },
                  {
                    id: "head-frmHttoan",
                    view: "template",
                    css: "headform",
                    template: function (obj) {
                      return "<div>Danh mục hình thức thanh toán<div/>";
                    },
                  },
                  {
                    view: "icon",
                    icon: "fas fa-question-circle",
                    id: "help_frmhttoan",
                    tooltip: _("HELPER"),
                    click: function () {
                      var newWin = window.open();
                      newWin.location =
                        "http://huongdansudung.minvoice.com.vn/Tomihoadon.html";
                    },
                  },
                ],
              },
            move: true,
            resize: true,
            body: {
                paddingY: 10,
                paddingX: 10,
                view: "form",
                id: formId,
                elementsConfig: { labelWidth: 100, labelPosition: "top" },
                complexData: true,
                margin: 0,
                width: 400,
                elements: [
                    { view: "text", name: "dmhanghoaxangdau_id", hidden: true },
                    { view: "text", name: "name", label: "Tên hình thức thanh toán", required: true, invalidMessage: "Tên hình thức thanh toán không được để trống" },
                    {
                        margin: 10,
                        cols: [
                            {},
                            {
                                shortcut: "F10", view: "button", label: "Nhận", type: "form", align: "center", width: 100,
                                on: {
                                    onClick: function () {
                                        var form = $$(formId);
                                        var win = $$(winId);
                                        if (form.validate()) {

                                            var formValue = form.getValues();
                                            var apiHost = app.config.host + "/Category/HtttoanSaveChange";
                                            formValue.editMode = editMode;
                                            if (editMode == 1) formValue.dmhtttoan_id = "00000000-0000-0000-0000-000000000000";
                                            webix.extend(win, webix.ProgressBar);
                                            win.disable();
                                            win.showProgress();

                                            webix.ajax().header({ "content-type": "application/json" }).post(apiHost, formValue, function (result) {
                                                win.enable();
                                                win.hideProgress();
                                                var response = JSON.parse(result);
                                                if (response.code == "00") {
                                                    if ($$(winId).config.callback != undefined)
                                                    {
                                                        $$(winId).config.callback(response.data);
                                                    }
                                                    webix.message((editMode == 1 ? "Thêm mới" : "Chỉnh sửa") + " thành công", "success");
                                                    $$(winId).close();
                                                } else {
                                                    webix.message(response.message, "error");
                                                }
                                            })
                                        }
                                    }
                                },
                                click: function () {
                                    this.callEvent("onClick");
                                }
                            },
                            { view: "button", hotkey: "esc", label: "Hủy", type: "danger", align: "center", width: 100, click: function () { $$(winId).close(); } },
                            {}
                        ]
                    }
                ]
            }
        },
        setEditMode: function (mode) {
            editMode = mode;
        }
    };

});
define('views/68_htttoanViews',["app", "locale", "views/forms/forms68/DanhMuc/htttoan"], function (app, _, htttoanForm) {
    var editmode;
    var gridId = "HTTToanView";
    var formId = "HTTToanForm";
    var btnReloadId = "btnReload";

    var controls = [
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-refresh fa-lg" aria-hidden="true"></i><span class="text">' + _("REFRESH") + "</span>",
            id: btnReloadId,
            on: {
                onClick: function () {
                    webix.callEvent("onLoadError");
                    var table = webix.$$(gridId);
                    table.clearAll();
                    table.load(table.config.url);
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-plus fa-lg" aria-hidden="true"></i><span class="text">' + _("Thêm (F4)") + "</span>",
            id: "btnPlus",
            shortcut: "F4",
            click: function () {
                var grid = $$(gridId);
                editmode = 1;
                htttoanForm.setEditMode(editmode);
                grid.$scope.ui(htttoanForm).show();

            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-edit fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("Sửa (F3)") + "</span>",
            id: "btnEdit",
            shortcut: "F3",
            click: function () {
                var grid = $$(gridId);
                var selected = grid.getSelectedItem();
                if (selected == null) {
                    webix.message("Bạn chưa chọn dòng cần sửa", "error");
                    return;
                }

                var form = grid.$scope.ui(htttoanForm);
                editmode = 2;
                htttoanForm.setEditMode(editmode);
                $$(formId).setValues(selected);
                form.show();
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-trash-o fa-lg" aria-hidden="true"></i><span class="text">' + _("Xóa (F8)") + "</span>",
            id: "btnDelete",
            shortcut: "F8",
            click: function () {
                var grid = $$(gridId);
                var selected = grid.getSelectedItem();
                if (selected == null) {
                    webix.message("Bạn chưa chọn dòng cần xóa", "error");
                    return;
                }
                selected.editMode = 3;
                webix.confirm({
                    title: "XÓA HÌNH THỨC THANH TOÁN",
                    text: "Bạn có muốn xóa hình thức thanh toán này",
                    ok: "Có",
                    cancel: "Không",
                    callback: function (res) {
                        if (res) {
                            webix.extend(grid, webix.ProgressBar);
                            grid.disable();
                            grid.showProgress();
                            var url = app.config.host + "/Category/HtttoanSaveChange"
                            webix.ajax().header({ "content-type": "application/json" }).post(url, selected, function (result) {
                                grid.enable();
                                grid.hideProgress();
                                var response = JSON.parse(result);
                                if (response.code == "00") {
                                    webix.message("Xóa thành công", "success");
                                    $$(btnReloadId).callEvent("onClick");
                                } else {
                                    webix.message(response.message, "error");
                                }
                            })
                        }
                    }
                })
            }
        }
    ]
    var grid = {
        rows: [
            {
                view: "datatable",
                id: gridId,
                select: true,
                resizeColumn: true,
                datafetch:10,
                pager: "pagerA",
                url: {
                    $proxy: true,
                    load: function (view, callback, params) {
                        webix.extend(view, webix.ProgressBar);
                        view.disable();
                        view.showProgress();
                        var start = null;
                        var count = null;
                        var filter = [];
                        var tlbparam_s = [];
                        if (params == null) {
                            start = 0;
                            count = view.config.datafetch;
                        }
                        else {
                            start = params.start;
                            count = params.count;
                            if (params.filter != null) {
                                var array = [];
                                for (var property in params.filter) {
                                    var column = view.getColumnConfig(property);
                                    var item = {
                                        columnName: property,
                                        columnType: column.columnType,
                                        value: params.filter[property]
                                    };
                                    array.push(item);
                                }
                                filter = array;
                            }
                        }
                        var item = {
                            command: "CM0027",
                            start: start,
                            count: count,
                            filter: filter,
                            tlbparam: tlbparam_s
                        };
                        var apiHost = app.config.host + "/Pattern/GetData";
                        webix.ajax()
                            .headers({ 'Content-type': 'application/json' })
                            .bind(view)
                            .post(apiHost, item, callback, view);
                    }
                },
                columns: [
                    {
                        id: "stt",
                        header: ["STT"],
                        width: 50,
                    },
                    {
                        id: "code",
                        header: ["Mã hình thức", { content: "serverFilter" }],
                        fillspace: true,
                        columnType: "string",
                    },
                    {
                        id: "name",
                        header: ["Tên Hình thức", { content: "serverFilter" }],
                        fillspace: true,
                        sort: "server",
                        columnType: "string",
                    },
                    {
                        id: "date_new",
                        header: ["Ngày tạo", { content: "serverDateRangeFilter" }],
                        fillspace: true,
                        format: function (text) {
                            var format = webix.Date.dateToStr("%d/%m/%Y %H:%i");
                            text = removeTimeZoneT(text);
                            return format(text);
                        },
                        sort: "server",
                        columnType: "datetime",
                    },
                    {
                        id: "user_new",
                        header: ["Người tạo", { content: "serverFilter" }],
                        fillspace: true,
                        sort: "server",
                        columnType: "string",
                    }
                ],
                on: {
                    "data->onStoreUpdated": function () {
                        this.data.each(function (obj, i) {
                            obj.stt = i + 1;
                        });
                    },
                    onAfterLoad: function () {
                        $$(gridId).enable();
                        $$(gridId).hideProgress();
                    },
                    onItemDblClick: function (id, e, node) {
                        var btnEdit = $$("btnEdit");
                        btnEdit.callEvent("onClick");
                    },
                }
            },
            {
                cols: [
                    {
                        view: "icon", icon: "fas fa-question-circle", id: "help_form_main", tooltip: _("HELPER"),
                        css: "helper",
                        click: function () {
                            var newWin = window.open();
                            newWin.location = "http://huongdansudung.minvoice.com.vn/Tomihoadon.html";
                        }
                    },
                    {},
                    {
                        id: "pagerA",
                        view: "pager",
                        size: 10,
                        group: 5,
                        template: function (data, common) {
                            return "Số dòng: " + data.count + ". " + common.first(data) + common.prev(data) + common.pages(data) + common.next(data) + common.last(data);
                        }
                    },
                    {}
                ]
            }
        ]
    }
    var layout = {
        css: "frmView",
        id: "frmView",
        rows: [
            { height: 39, id: "btnControl", css: "btnControl", margin: 0, borderless: true, type: "toolbar", cols: controls },
            { rows: [grid] }
        ]
    };
    return {
        $ui: layout,
    }
});
define('views/forms/forms68/68_importExcelForm',["app", "models/user", "locale"], function (app, user, _) {
    var editmode = 0;
    var param;
    function uuidv4() {
        return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
            (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
        );
    }

    var button = [
        {},
        {
            shortcut: "F10",
            view: "button",
            label: "Nhận (F10)",
            type: "form",
            align: "center",
            width: 120,
            on: {
                onClick: function () {
                    var item = $$("importExcelViews-form").getValues();
                    var table = $$("importExcelViews-form");

                    if (table.validate()) {
                        webix.extend(table, webix.ProgressBar);
                        table.disable();
                        table.showProgress();
                        var details = $$("excel_chitiet").serialize();
                        if (editmode == 1) {
                            details.forEach(element => {
                                element.wb_exdetails_id = uuidv4();
                            });
                        }
                        item.wb_exdetailss = details;
                        //console.log(item);
                        //item.code = param.code;

                        // var dataPut = {
                        //     tab_masters: "quanlykyhieu68",
                        //     editmode: editmode,
                        //     data: [item]
                        // };

                        webix.ajax()
                            .headers({ 'Content-type': 'application/json' })
                            .post(app.config.host + "/Pattern/SaveChangeExcel", item, {
                                error: function (text, data, XmlHttpRequest) {
                                    var table = $$("importExcelViews-form");
                                    table.enable();
                                    table.hideProgress();
                                    // var json = JSON.parse(text);
                                    // webix.message(json.ExceptionMessage, "error");
                                    webix.message(text + XmlHttpRequest, "error");

                                }, success: function (text, data, XmlHttpRequest) {
                                    var json = JSON.parse(text);
                                    var table = $$("importExcelViews-form");
                                    table.enable();
                                    table.hideProgress();
                                    if (json.code == "00") {
                                        $$("importExcelViews-win").close();
                                        var table = $$("importExcelViews");
                                        table.clearAll();
                                        table.load(table.config.url);
                                    }
                                    else {
                                        webix.message(json.message, "error");
                                    }
                                }
                            });
                    }
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {
            view: "button",
            hotkey: "esc",
            label: "Hủy bỏ (ESC)",
            type: "danger",
            align: "center",
            width: 120,
            click: function () {
                webix.$$("importExcelViews-win").close();
            }
        },
        {}
    ]

    var ui = {
        view: "window",
        //modal: true,
        fullscreen: true,
        move: true,
        id: "importExcelViews-win",
        position: "center",
        head: "Import Excel",
        on: {
            onBeforeShow: function () {

            }
        },
        body: {
            paddingY: 10,
            paddingX: 10,
            view: "form",
            width: 800,
            id: "importExcelViews-form",
            complexData: true,
            margin: 0,
            elements: [
                {
                    id: "ex_name", name: "ex_name", label: "Tên excel", labelWidth: 120,
                    view: "text", required: true, invalidMessage: "Tên excel không được để trống"
                },
                {
                    view: "combo", label: "Loại hóa đơn", name: "ex_typeinvoice",
                    id: "ex_typeinvoice", required: true, invalidMessage: "Loại hóa đơn không được bỏ trống",
                    labelWidth: 120,
                    options: app.config.host + "/Pattern/GetData?command=CM0013&start=0&count=50&continue=null&filter=null",
                    on: {
                        onChange: function (newv, oldv) {

                        }
                    }
                },
                {
                    cols: [
                        { id: "ex_sql", name: "ex_sql", label: "Code SQL", labelWidth: 120, view: "text", required: true, invalidMessage: "Thủ tục nhận excel không được để trống" },
                        { id: "row_begin", name: "row_begin", label: "Row begin", labelWidth: 120, view: "text" },
                        { id: "is_use", name: "is_use", label: "Sử dụng", labelWidth: 120, view: "checkbox" }
                    ]
                },
                { id: "onClick", name: "onClick", label: "OnClick", labelWidth: 120, view: "textarea", height: 100 },
                { id: "note", name: "note", label: "Sheet hướng dẫn", labelWidth: 120, view: "textarea", height: 100 },
                {
                    borderless: true,
                    view: "tabview",
                    scrollX: true,
                    tabbar: {
                        width: 200
                    },
                    cells: [
                        {
                            header: "Cột trong excel",
                            select: "cell",
                            body: {
                                rows: [
                                    {
                                        id: "mainInvoiceManage",
                                        css: { "padding-bottom": "5px !important" },
                                        cols: [
                                            {
                                                view: "button", type: "htmlbutton", width: 65,
                                                label: '<i class="fa fa-plus fa-lg" aria-hidden="true"></i> ' +
                                                    '<span class="text">' + " (F9)" + '</span>',
                                                id: "addrow",
                                                css: "btnForm",
                                                on: {
                                                    onItemClick: function (id, e) {
                                                        var table = webix.$$("excel_chitiet");
                                                        var item = { id: webix.uid() };
                                                        table.add(item);
                                                        table.select(item.id, "field_name", false);
                                                        table.edit({ row: item.id, column: "field_name" });
                                                    }
                                                }
                                            },
                                            {
                                                view: "button", type: "htmlbutton", width: 65,
                                                label: '<i class="fa fa-minus fa-lg" aria-hidden="true"></i> ' +
                                                    '<span class="text">' + " (F8)" + '</span>',
                                                id: "removerow",
                                                css: "btnForm",
                                                on: {
                                                    onItemClick: function (id, e) {
                                                        var table = webix.$$("excel_chitiet");
                                                        table.editStop();
                                                        var item = table.getSelectedItem();
                                                        if (!webix.isUndefined(item)) {
                                                            table.remove(item.id);
                                                            table.clearSelection();
                                                            return;
                                                        }

                                                        var editor = table.getEditState();
                                                        if (!webix.isUndefined(editor)) {
                                                            table.remove(editor.row);
                                                            table.clearSelection();
                                                            return;
                                                        }
                                                    }
                                                }
                                            },
                                            {
                                                view: "button", type: "htmlbutton", width: 65,
                                                label: '<i class="fa fa-copy fa-lg" aria-hidden="true"></i> ' +
                                                    '<span class="text">' + " (F7)" + '</span>',
                                                view: "button",
                                                id: "copyrow",
                                                css: "btnForm",
                                                on: {
                                                    onItemClick: function (id, e) {
                                                        var table = webix.$$("excel_chitiet");;

                                                        table.editStop();

                                                        var item = table.getSelectedItem();
                                                        if (item == null || item == undefined) {
                                                            webix.message("Bạn chưa chọn dòng cần copy !", "error");
                                                            return;
                                                        }
                                                        //item.id = webix.uid();
                                                        var copy = webix.copy(item);
                                                        copy.id = webix.uid();
                                                        copy.wb_exdetails_id = uuidv4();
                                                        // if (editmode == 1) {
                                                        //     copy.wb_ex_id = null;
                                                        // }

                                                        table.add(copy);
                                                        table.unselect(item.id);
                                                        table.select(copy.id, "field_name", false);
                                                        table.edit({ row: copy.id, column: "field_name" });

                                                    }
                                                }
                                            }
                                        ]
                                    },
                                    {
                                        view: "datatable",
                                        resizeColumn: true,
                                        id: "excel_chitiet",
                                        editable: true,
                                        select: "cell",
                                        // height: 260,
                                        drag: true,
                                        columns: [
                                            { id: "stt", header: "", width: 30, editable: true, editor: "text" },
                                            {
                                                id: "field_name", header: _("Field name"), editor: "text", width: 250, editable: true
                                            },
                                            {
                                                id: "excel_column", header: _("Cột excel"), editor: "text", width: 150, editable: true
                                            },
                                            {
                                                id: "field_type", name: "field_type",
                                                header: "Kiểu dữ liệu",
                                                editable: false,
                                                width: 200,
                                                editor: "combo",
                                                options: [
                                                    { id: "nvarchar", value: "nvarchar" },
                                                    { id: "int", value: "int" },
                                                    { id: "decimal", value: "decimal" },
                                                    { id: "datetime", value: "datetime" }
                                                ],
                                            },
                                            {
                                                id: "field_caption", header: _("Caption"), editor: "text", width: 250, editable: true
                                            },
                                            {
                                                id: "default_value", header: _("Giá trị mặc định"), editor: "text", width: 250, editable: true
                                            },
                                            {
                                                id: "vi_tri", name: "vi_tri",
                                                header: "Vị trí",
                                                editable: false,
                                                width: 200,
                                                editor: "combo",
                                                options: [
                                                    { id: "dp", value: "Đầu phiếu" },
                                                    { id: "ct", value: "Chi tiết" }
                                                ]
                                            },
                                            {
                                                id: "field_req", header: _("Bắt buộc nhập"), editor: "checkbox", template: "{common.checkbox()}", width: 100, editable: true
                                            }
                                        ],
                                        scheme: {
                                            //$init: function (obj) { obj.stt = this.count() + 1; }
                                        },
                                        on: {
                                            "data->onStoreUpdated": function () {
                                                this.data.each(function (obj, i) {
                                                    obj.stt = i + 1;
                                                })
                                            },
                                            onBeforeRender: function () {
                                            },
                                            onKeyPress: function (code, e) {
                                                var table = this;
                                                if (e.key == "F8") {
                                                    $$("removerow").callEvent("onItemClick");
                                                }
                                                if (e.key == "F9") {
                                                    $$("addrow").callEvent("onItemClick");
                                                }
                                                if (e.key == "F7") {
                                                    $$("copyrow").callEvent("onItemClick");
                                                }
                                            },
                                            onAfterLoad: function () {
                                            },
                                            onCheck: function (row, column, state) {
                                            },
                                            onAfterAdd: function (id, index) {
                                            },
                                            onAfterEditStop: function (state, editor, ignore) {
                                            },
                                            onAfterEditStart: function (cell) {
                                            },
                                            onValidationError: function (id, obj, details) {
                                            }
                                        },
                                        rules: {
                                            "field_name": webix.rules.isNotEmpty,
                                            "vi_tri": webix.rules.isNotEmpty,
                                            "field_type": webix.rules.isNotEmpty
                                        },
                                        ready: function () {
                                            this.validate();
                                        }
                                    }
                                ]
                            }
                        }
                    ]
                },
                {
                    margin: 10,
                    cols: button
                }
            ]
        }

    };

    return {
        $ui: ui,
        setEditMode: function (mode) {
            editmode = mode;
        },
        initUI: function (item) {
            param = item;
        },
        setValues: function (item) {

            $$("importExcelViews-form").setValues(item);
            var tableDetail = webix.$$("excel_chitiet");
            var url = app.config.host + "/Pattern/GetDetailsExcel?id=" + item.id;
            tableDetail.clearAll();
            tableDetail.load(url);
        }
    };
});
define('views/68_importExcel',[
    "app",
    "locale",
    "models/user",
    "views/forms/forms68/68_importExcelForm",
], function (app, _, user, importExcelForm) {
    'use strict';
    webix.$$("title").parse({ title: "Import Excel", details: "Hệ thống -> Import Excel" });

    var controls = [
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-refresh fa-lg" aria-hidden="true"></i> ' +
                '<span class="text">' + _("REFRESH") + '</span>',
            id: "btnReload",
            on: {
                onClick: function () {
                    webix.callEvent("onLoadError");
                    var table = webix.$$("importExcelViews");
                    table.clearAll();
                    table.load(table.config.url);
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-plus fa-lg" aria-hidden="true"></i> ' +
                '<span class="text">' + _("THEM") + ' (F4)</span>',
            id: "btnPlus",
            shortcut: "F4",
            on: {
                onClick: function () {
                    var detailForm = this.$scope.ui(importExcelForm.$ui);
                    importExcelForm.setEditMode(1);
                    detailForm.show();
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-edit fa-lg" aria-hidden="true"></i> ' +
                '<span class="text">' + _("SUA") + ' (F3)</span>',
            id: "btnEdit",
            shortcut: "F2",
            on: {
                onClick: function () {
                    var table = webix.$$("importExcelViews");
                    var selectedItem = table.getSelectedItem();
                    if (selectedItem == null) {
                        webix.message("Bạn chưa chọn dòng ! ", "error");
                        return;
                    }

                    var detailForm = this.$scope.ui(importExcelForm.$ui);
                    importExcelForm.setEditMode(2);
                    importExcelForm.setValues(selectedItem);
                    detailForm.show();
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-trash-o fa-lg" aria-hidden="true"></i> ' +
                '<span class="text">' + _("XOA") + ' (F3)</span>',
            id: "btnDelete",
            shortcut: "F3",
            // id: "btnDelete",
            // view: "button",
            // type: "icon",
            // icon: "trash-o",
            // label: _("XOA") + " (F8)",
            // width: 100,
            // css: "button_raised",
            // shortcut: "F8",
            on: {
                onClick: function () {
                    var table = webix.$$("importExcelViews");
                    var selectedItem = table.getSelectedItem();
                    if (selectedItem == null) {
                        webix.message("Bạn chưa chọn dòng cần xóa ! ", "error");
                        return;
                    }
                    webix.confirm({
                        text: "Bạn có muốn xóa bản ghi",
                        ok: "Có",
                        cancel: "Không",
                        callback: function (choose) {
                            if (choose) {
                                webix.extend(table, webix.ProgressBar);
                                table.disable();
                                table.showProgress();

                                webix.ajax()
                                    .headers({ 'Content-type': 'application/json' })
                                    .get(app.config.host + "/Pattern/DeleteImportExcel?id=" + selectedItem.id,
                                        {
                                            error: function (text, data, XmlHttpRequest) {
                                                table.enable();
                                                table.hideProgress();
                                            },
                                            success: function (text, data, XmlHttpRequest) {
                                                var res = JSON.parse(text);
                                                if (res.code != "00") {
                                                    webix.message(res.error, "error");
                                                }
                                                else {
                                                    table.remove(selectedItem.id);
                                                    table.enable();
                                                    table.hideProgress();
                                                }
                                            }
                                        });
                            }
                        }
                    });
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        }
    ];

    var grid = {
        rows: [
            {
                view: "datatable",
                id: "importExcelViews",
                select: true,
                resizeColumn: true,
                fixedRowHeight: false,
                // leftSplit: 8,
                // rightSplit: 1,
                rowLineHeight: 25, rowHeight: 25,
                tooltip: true,
                //autowidth: true,
                url: {
                    $proxy: true,
                    load: function (view, callback, params) {
                        var tlbparam_s = [];
                        var url = app.config.host + "/Pattern/GetData";
                        if (params == null) {
                            url = url + "?command=CM0017&start=0&count=" + view.config.datafetch + "&continue=null&filter=null";
                        }
                        else {
                            url = url + "?command=CM0017&start=" + params.start + "&count=" + params.count + "&continue=" + params.continue;
                            if (params.filter != null) {
                                var array = [];
                                for (var property in params.filter) {

                                    var column = view.getColumnConfig(property);
                                    var item = {
                                        columnName: property,
                                        columnType: column.columnType,
                                        value: params.filter[property]
                                    };
                                    array.push(item);
                                }
                                url = url + "&filter=" + JSON.stringify(array);
                            }
                        }
                        var tlbParams = $$("paramKH");
                        if (tlbParams !== undefined) {
                            var childViews = tlbParams.getChildViews();

                            var parameters = [];

                            for (var i = 0; i < childViews.length; i++) {
                                var child = childViews[i];
                                var id = child.config.id;
                                var item = {
                                    columnName: "cctbao_id",
                                    value: $$(id).getValue()
                                };
                                parameters.push(item);
                            }
                            tlbparam_s = parameters;
                            url = url + "&tlbparam=" + JSON.stringify(parameters);
                        }
                        webix.ajax(url, callback, view);
                    }
                },
                onClick: {
                    "dowloadXmlDKSD": function (event, cell, target) {
                    }
                },
                on: {
                    "data->onStoreUpdated": function () {
                        this.data.each(function (obj, i) {
                            obj.index = i + 1;
                        });
                    },
                    onItemClick: function (id) {
                    },
                    onClick: function (e) {
                    },
                    onItemDblClick: function (id, e, node) {
                        var btnEdit = $$("btnEdit");
                        btnEdit.callEvent("onClick");
                    },
                    onAfterLoad: function () {
                    },
                    onColumnResize: function () {
                    },
                    onSubViewCreate: function (view, item) {
                        var subView = view;

                        if (subView != null) {
                            var tableDetail = webix.$$("import_excel_chitiet");
                            var url = app.config.host + "/Pattern/GetDetailsExcel?id=" + item.id;
                            tableDetail.clearAll();
                            tableDetail.load(url);
                        }
                    }
                },
                subview: {
                    borderless: true,
                    view: "tabview",
                    height: 255,
                    css: "subInvoice",
                    scrollX: true,
                    multiview: {
                        fitBiggest: true
                    },
                    cells: [
                        {
                            header: "Chi tiết Excel",
                            select: "cell",
                            body: {
                                view: "datatable",
                                resizeColumn: true,
                                margin: 10,
                                id: "import_excel_chitiet",
                                height: 200,
                                columns: [
                                    { id: "stt", header: "", width: 30 },
                                    { id: "field_name", header: _("Field name"), editor: "text", width: 100, editable: true },
                                    { id: "excel_column", header: _("Tên cột"), editor: "text", width: 150, editable: true },
                                    { id: "field_type", header: _("Kiểu dữ liệu"), editor: "text", width: 150, editable: true },
                                    { id: "field_caption", header: _("Caption"), editor: "text", width: 150, editable: true },
                                    { id: "vi_tri", header: _("Vị trí"), editor: "text", width: 150, editable: true },
                                    { id: "default_value", header: _("Default"), editor: "text", width: 150, editable: true },
                                    { id: "field_req", header: _("Bắt buộc"), editor: "checkbox", template: "{common.checkbox()}", width: 150, editable: true }
                                ],
                                on: {
                                    onBeforeLoad: function () {
                                        this.showOverlay(_("LOADING") + "...");
                                    },
                                    onAfterLoad: function () {
                                        this.hideOverlay();
                                    }
                                }
                            }
                        }
                    ]
                },
                columns: [
                    {
                        id: "subRowMain",
                        header: "&nbsp;",
                        template: "{common.subrow()}",
                        width: 40
                    },
                    {
                        id: "index",
                        header: ["<center>STT</center>", { content: "textFilter" }],
                        sort: "int",
                        width: 40,
                    },
                    {
                        id: "ex_name", header: ["<center>Tên</center>", { content: "textFilter" }],
                        width: 250, columnType: "nvarchar"
                    },
                    {
                        id: "ex_sql", header: ["<center>Code SQL</center>", { content: "textFilter" }],
                        width: 200, columnType: "nvarchar"
                    },
                    {
                        id: "onClick", header: ["<center>OnClick</center>", { content: "textFilter" }],
                        width: 300, columnType: "nvarchar"
                    },
                    {
                        id: "ten", header: ["<center>Loại hóa đơn</center>", { content: "textFilter" }],
                        width: 400, columnType: "nvarchar"
                    },
                    {
                        id: "is_use", header: ["<center>Sử dụng</center>", { content: "textFilter" }],
                        width: 150, columnType: "nvarchar", editor: "checkbox",
                        template: function (obj) {
                            var checked =
                                obj.is_use == true ? 'checked="true"' : "";
                            return (
                                "<input disabled class='webix_table_checkbox' type='checkbox' " +
                                checked +
                                ">"
                            );
                        }
                    }
                ],
                pager: "pagerA"
            },
            {
                cols: [
                    {
                        view: "icon", icon: "fas fa-question-circle", id: "help_form_main", tooltip: _("HELPER"),
                        css: "helper",
                        click: function () {
                            webix.alert({
                                title: "Thông báo !",
                                text: "Bạn chưa khai báo hướng dẫn nhanh cho màn hình này !",
                                type: "alert-warning",
                                callback: function (result) {
                                }
                            });
                        }
                    },
                    {
                        view: "combo",
                        label: _("MENU_QUICK"),
                        id: "QuickMenuMain",
                        options: {

                        },
                        on: {
                            onChange: function (newv, oldv) {

                            }
                        }
                    },
                    {},
                    {
                        id: "pagerA",
                        view: "pager",
                        size: 100,
                        group: 5,
                        template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}"
                    }
                ]
            }
        ]
    }

    var layout = {
        css: "frmView",
        rows: [
            {
                height: 39,
                css: "btnControl",
                margin: 0,
                borderless: true,
                type: "toolbar",
                cols: controls
            },
            {
                rows: [
                    grid
                ]
            }
        ]

    };

    return {
        $ui: layout,
        $oninit: function (view, $scope) {

            $scope.on(app, "dataChangedViewsExcel", function (editmode, item) {

            });
        }
    };
});
define('views/menus/version',["app"], function (app) {

    return {
        getVersion: function () {
            var result = webix.ajax().sync().get(app.config.host + "/System/GetVersion");
            var json = JSON.parse(result.response);
            return json;
        },
        getWarning: function () {
            var result = webix.ajax().sync().get(app.config.host + "/Invoice/canhbaosoluong");
            var json = JSON.parse(result.response);
            return json;
        },
        getInfocompany: function () {
            var result = webix.ajax().sync().get(app.config.host + "/System/GetInfoCompany");
            var json = JSON.parse(result.response);
            return json;
        },
        getMST: function () {
            var result = webix.ajax().sync().get(app.config.host + "/System/GetMST");
            var json = result.response.substring(1, result.response.length - 1);
            return json;
        },
        getSchema: function () {
            var result = webix.ajax().sync().get(app.config.host + "/Invoice/GetSchema");
            var json = result.response.substring(1, result.response.length - 1);
            return json;
        },
        getURL: function () {
            var url = window.location.host;
            return url;
        }
    };
});
define('views/modules/Component/eventTableHelper',["app", "locale", "views/modules/Component/componentHelper", "views/menus/version",
    "views/modules/Component/constantManager",
    "views/modules/Component/ajaxHelper"], function (app, _, componentHelper, version, Constant, Ajax) {

        var fmNumeric = function (format_config, decimalOp) {
            if (!format_config) return;
            format_config.decimal = decimalOp;
            format_config.editParse = function (value) {
                return webix.Number.parse(value, {
                    groupSize: webix.i18n.groupSize,
                    groupDelimiter: ".",
                    // decimalSize: webix.i18n.decimalSize,
                    decimalSize: decimalOp,
                    // decimalDelimiter: webix.i18n.decimalDelimiter,
                    decimalDelimiter: ","
                });
            };
            format_config.editFormat = function (value) {
                return webix.i18n.numberFormat(value, {
                    groupDelimiter: ".",
                    groupSize: 3,
                    decimalDelimiter: ",",
                    decimalSize: decimalOp
                });
            };
            format_config.format = webix.Number.numToStr({
                groupDelimiter: ".",
                groupSize: 3,
                decimalDelimiter: ",",
                decimalSize: decimalOp
            });
        };
        function AddColumn(array) {
            array.forEach(element => {
                if (element.hidden_in_form != true) {
                    var newCol = {
                        view: element.type_rows,
                        label: element.label,
                        labelWidth: 100,
                        id: element.ttruong,
                        name: element.ttruong,
                        format: element.format,
                        on: {}
                    };
                    // add field vào cùng 1 dòng nếu đặt parrent = field_parrent
                    var itemAdd = {
                        id: element.ttruong + "_parrent",
                        cols: []
                    };
                    if (element.type_rows == "autonumeric") {
                        newCol.inputAlign = "right";
                        newCol.decimalPlaces = element.format;
                    }
                    if (element.onchange != null && element.onchange != "") {
                        newCol.on.onChange = function (newv, oldv, config) {
                            var fn = Function("newv", "oldv", element.onchange);
                            fn(newv, oldv);
                        }
                    }
                    if (element.is_readonly == true) {
                        newCol.readonly = true;
                        newCol.css = "mcls_readonly_text"
                    }
                    itemAdd.cols.push(newCol);
                    $$(element.parrent).addView(itemAdd, element.rows);
                }
            });
        }
        function AddColumnCT(array) {
            var table = $$("hoadon68_chitiet");
            array.forEach(element => {
                if (element.hidden_in_grid != true) {
                    var newCol = {
                        header: element.label,
                        id: element.ttruong,
                        name: element.ttruong,
                        editor: element.type_rows,
                        editable: true
                    };
                    table.config.columns.splice(element.cols, 0, newCol);
                }
            });
            if (table != undefined)
                table.refreshColumns();
        }
        function AddColumnGrid(array) {
            var table = $$("invoiceViews");
            array.forEach(element => {
                if (element.hidden_in_grid != true) {
                    var newCol = {
                        header: ["<center>" + element.label + "</center>", { content: "serverFilter" }],
                        id: element.ttruong,
                        columnType: element.type_rows
                    };
                    if (element.type_rows == "datepicker" || element.type_rows == "datetime") {
                        newCol.format = function (text) {
                            var format = webix.Date.dateToStr(element.format || "%d/%m/%Y %H:%i");
                            text = removeTimeZoneT(text);
                            return format(text);
                        }
                        newCol.columnType = "datetime";
                    }
                    table.config.columns.splice(element.cols, 0, newCol);
                }
            });
            if (table != undefined)
                table.refreshColumns();
        }
        function FuncOnBeforeShowForm(type) {
            var ttkhac_cache = webix.storage.local.get(Constant.CACHE.TTKHAC + type);
            var ttkhac_ct_cache = webix.storage.local.get(Constant.CACHE.TTKHAC_CT + type);
            if (ttkhac_cache != null) {
                AddColumn(ttkhac_cache);
            } else {
                Ajax.GET(Constant.API.TTKHAC + type).then((data) => {
                    var arr = JSON.parse(data);
                    if (arr.code == "00") {
                        var array = arr.data;
                        AddColumn(array);
                        webix.storage.local.put(Constant.CACHE.TTKHAC + type, array);
                    }
                }).catch((error) => {
                    console.log(error);
                })
            }
            if (ttkhac_ct_cache != null) {
                AddColumnCT(ttkhac_ct_cache);
            } else {
                Ajax.GET(Constant.API.TTKHAC_CT + type).then((data) => {
                    var arr = JSON.parse(data);
                    if (arr.code == "00") {
                        var array = arr.data;
                        AddColumnCT(array);
                        webix.storage.local.put(Constant.CACHE.TTKHAC_CT + type, array);
                    }
                }).catch((error) => {
                    console.log(error);
                });
            }
        }
        function SetDecimalPlace(arr) {
            if (!arr) return;
            var cfg = Array.isArray(arr) ? arr[0] : arr;
            if (!cfg) return;

            var quantity = cfg["inv_quantity"] || 0;
            var inv_TotalAmountWithoutVat = cfg["inv_TotalAmountWithoutVat"] || 0;
            var inv_TotalAmount = cfg["inv_TotalAmount"] || 0;
            var inv_unitPrice = cfg["inv_unitPrice"] || 0;
            var inv_vatAmount = cfg["inv_vatAmount"] || 0;

            var table = $$("hoadon68_chitiet");
            if (!table) return;
            var format_config = table.getColumnConfig("sluong");
            fmNumeric(format_config, quantity);
            var tien_tt = table.getColumnConfig("thtien");
            fmNumeric(tien_tt, inv_TotalAmountWithoutVat);
            var tien_thue = table.getColumnConfig("tthue");
            if (tien_thue != undefined) fmNumeric(tien_thue, inv_vatAmount);
            var don_gia = table.getColumnConfig("dgia");
            fmNumeric(don_gia, inv_unitPrice);
            var tong_tien = table.getColumnConfig("tgtien");
            if (tong_tien != undefined) fmNumeric(tong_tien, inv_TotalAmount);
        }
        return {
            AfterEdit: function (component, state, editor, ignore) {
                if ($$("dvtte") != undefined) {
                    var maTienTe = $$("dvtte").getValue();
                    var table = $$(component.config.id);
                    var selectedItem = table.getItem(editor.row);
                    var columnId = editor.config.id;
                    var tchat = selectedItem.tchat;

                    var table_decimalPlaces = {
                        sluong: 0,
                        tthue: 0,
                        thtien: 0,
                        tgtien: 0,
                        stckhau: 0
                    }
                    table.eachColumn(function (columnId) {
                        var a = columnId.toString();
                        if (a == "sluong" || a == "thtien" || a == "tthue" || a == "tgtien" || a == "stckhau") {
                            var b = table.getColumnConfig(a).decimal;
                            if (b != null) {
                                table_decimalPlaces[a] = b;
                            }
                        }
                    });

                    var so_luong = webix.rules.isNumber(selectedItem.sluong) ? selectedItem.sluong : 0;
                    var don_gia = webix.rules.isNumber(selectedItem.dgia) ? selectedItem.dgia : 0;
                    var tien_tt = webix.rules.isNumber(selectedItem.thtien) ? selectedItem.thtien : 0;
                    var pt_ck = webix.rules.isNumber(selectedItem.tlckhau) ? selectedItem.tlckhau : 0;
                    var tien_ck = webix.rules.isNumber(selectedItem.stckhau) ? selectedItem.stckhau : 0;
                    var pt_thue = webix.rules.isNumber(selectedItem.tsuat) ? selectedItem.tsuat : 0;
                    var tien_thue = webix.rules.isNumber(selectedItem.tthue) ? selectedItem.tthue : 0;
                    var tong_tien = webix.rules.isNumber(selectedItem.tgtien) ? selectedItem.tgtien : 0;

                    var ctinh = selectedItem.ctinh == null || selectedItem.ctinh == undefined || selectedItem.ctinh == "" ? 1
                        : selectedItem.ctinh;
                    if (pt_thue < 0) pt_thue = 0;
                    // ctinh == 1 tính xuôi, 2 == tính nguọc
                    if (ctinh == 1) {
                        if (columnId == "sluong" || columnId == "dgia" || columnId == "tlckhau" || columnId == "ctinh") {

                            tien_ck = so_luong * don_gia * pt_ck / 100;
                            tien_tt = Number((so_luong * don_gia - tien_ck).toFixed(table_decimalPlaces.thtien));
                            tien_thue = Number((tien_tt * pt_thue / 100).toFixed(table_decimalPlaces.tthue));
                            tong_tien = Number((tien_tt + tien_thue).toFixed(table_decimalPlaces.tgtien));

                            selectedItem.stckhau = tien_ck;
                            selectedItem.thtien = tien_tt;
                            selectedItem.tthue = tien_thue;
                            selectedItem.tgtien = tong_tien;

                            table.updateItem(selectedItem.id, selectedItem);
                        }
                        if (columnId == "thtien") {
                            tien_thue = Number((selectedItem.thtien * pt_thue / 100).toFixed(table_decimalPlaces.tthue));
                            tong_tien = Number((selectedItem.thtien + tien_thue).toFixed(table_decimalPlaces.tgtien));
                            selectedItem.tthue = tien_thue;
                            selectedItem.tgtien = tong_tien;

                            table.updateItem(selectedItem.id, selectedItem);
                        }

                        if (columnId == "stckhau") {
                            tien_tt = Number((so_luong * don_gia - tien_ck).toFixed(table_decimalPlaces.thtien));
                            tien_thue = Number((pt_thue * tien_tt).toFixed(table_decimalPlaces.tthue));
                            tong_tien = Number((tien_tt + tien_thue).toFixed(table_decimalPlaces.tgtien));

                            selectedItem.stckhau = tien_ck;
                            selectedItem.thtien = tien_tt;
                            selectedItem.tgtien = tong_tien;
                            selectedItem.tthue = tien_thue;

                            table.updateItem(selectedItem.id, selectedItem);
                        }

                        if (columnId == "tsuat") {
                            tien_thue = Number((tien_tt * pt_thue / 100).toFixed(table_decimalPlaces.tthue));
                            tong_tien = Number((tien_tt + tien_thue).toFixed(table_decimalPlaces.tgtien));

                            selectedItem.tthue = tien_thue;
                            selectedItem.tgtien = tong_tien;

                            table.updateItem(selectedItem.id, selectedItem);
                        }
                    }
                    else {
                        if (columnId == "sluong" || columnId == "tgtien" || columnId == "tsuat" || columnId == "tlckhau" || columnId == "stckhau" || columnId == "ctinh") {
                            tien_tt = Number((tong_tien / (1 + pt_thue / 100)).toFixed(table_decimalPlaces.thtien));
                            tien_thue = Number((tong_tien - tien_tt).toFixed(table_decimalPlaces.tthue));

                            var tien_hang = 0;

                            if (pt_ck > 0) {
                                tien_hang = tien_tt / (1 - pt_ck / 100);
                                tien_ck = tien_hang - tien_tt;
                            }
                            else {
                                tien_hang = tien_tt + tien_ck;
                            }

                            don_gia = tien_hang / so_luong;

                            selectedItem.thtien = tien_tt;
                            selectedItem.tthue = tien_thue;
                            selectedItem.dgia = don_gia;
                            selectedItem.stckhau = tien_ck;

                            table.updateItem(selectedItem.id, selectedItem);
                        }
                    }

                    if (tchat == 4) {
                        selectedItem.sluong = 0;
                        selectedItem.thtien = 0;
                        selectedItem.tthue = 0;
                        selectedItem.dgia = 0;
                        selectedItem.stckhau = 0;
                        table.updateItem(selectedItem.id, selectedItem);
                    }
                    if (tchat == 2) {
                        selectedItem.thtien = 0;
                        selectedItem.tthue = 0;
                        selectedItem.dgia = 0;
                        selectedItem.stckhau = 0;
                        table.updateItem(selectedItem.id, selectedItem);
                    }

                    var data = table.serialize();
                    var tien_tt_all = 0;
                    var tien_thue_all = 0
                    var tien_ck_all = 0;
                    var tong_tien_all = 0

                    var tien_tt_10 = 0;
                    var tien_thue_10 = 0;
                    var tien_ck_10 = 0;
                    var tong_tien_10 = 0;

                    var tien_tt_5 = 0;
                    var tien_thue_5 = 0;
                    var tien_ck_5 = 0;
                    var tong_tien_5 = 0;

                    var tien_tt_0 = 0;
                    var tien_thue_0 = 0;
                    var tien_ck_0 = 0;
                    var tong_tien_0 = 0;

                    var tien_tt_kct = 0;
                    var tien_thue_kct = 0;
                    var tien_ck_kct = 0;
                    var tong_tien_kct = 0;

                    var tien_tt_kkk = 0;
                    var tien_thue_kkk = 0;
                    var tien_ck_kkk = 0;
                    var tong_tien_kkk = 0;

                    var tien_thue_7 = 0;
                    var tien_thue_35 = 0;

                    var tien_tt_8 = 0;
                    var tien_thue_8 = 0;
                    var tien_ck_8 = 0;
                    var tong_tien_8 = 0;

                    var txtChkTinhMaHang = webix.$$("check_tinhctmathang");
                    var theoMaHang = txtChkTinhMaHang.getValue();

                    // theoMaHang == 0  tính theo tổng tiền. khác thì tính theo chi tiết
                    data.forEach(function (entry) {

                        tien_tt_all += entry["thtien"] == null ? 0 : entry["tchat"] == 3 ? entry["thtien"] * -1 : entry["thtien"];
                        tien_ck_all += entry["stckhau"] == null ? 0 : entry["tchat"] == 3 ? entry["stckhau"] * -1 : entry["stckhau"];

                        if (theoMaHang == 0) {
                            if (entry["tsuat"] == 7) {
                                tien_thue_7 += entry["thtien"] == null ? 0 : entry["tchat"] == 3 ? entry["thtien"] * -1 : entry["thtien"];
                                //tien_ck_10 += entry["stckhau"] == null ? 0 : entry["tchat"] == 3 ? entry["stckhau"] * -1 : entry["stckhau"];
                            }

                            if (entry["tsuat"] == 3.5) {
                                tien_thue_35 += entry["thtien"] == null ? 0 : entry["tchat"] == 3 ? entry["thtien"] * -1 : entry["thtien"];
                                //tien_ck_10 += entry["stckhau"] == null ? 0 : entry["tchat"] == 3 ? entry["stckhau"] * -1 : entry["stckhau"];
                            }

                            if (entry["tsuat"] == 10) {
                                tien_tt_10 += entry["thtien"] == null ? 0 : entry["tchat"] == 3 ? entry["thtien"] * -1 : entry["thtien"];
                                tien_ck_10 += entry["stckhau"] == null ? 0 : entry["tchat"] == 3 ? entry["stckhau"] * -1 : entry["stckhau"];
                            }
                            if (entry["tsuat"] == 5) {
                                tien_tt_5 += entry["thtien"] == null ? 0 : entry["tchat"] == 3 ? entry["thtien"] * -1 : entry["thtien"];
                                tien_ck_5 += entry["stckhau"] == null ? 0 : entry["tchat"] == 3 ? entry["stckhau"] * -1 : entry["stckhau"];
                            }
                            if (entry["tsuat"] == 0) {
                                tien_tt_0 += entry["thtien"] == null ? 0 : entry["tchat"] == 3 ? entry["thtien"] * -1 : entry["thtien"];
                                tien_ck_0 += entry["stckhau"] == null ? 0 : entry["tchat"] == 3 ? entry["stckhau"] * -1 : entry["stckhau"];
                            }
                            if (entry["tsuat"] == -1) {
                                tien_tt_kct += entry["thtien"] == null ? 0 : entry["tchat"] == 3 ? entry["thtien"] * -1 : entry["thtien"];
                                tien_ck_kct += entry["stckhau"] == null ? 0 : entry["tchat"] == 3 ? entry["stckhau"] * -1 : entry["stckhau"];
                            }
                            if (entry["tsuat"] == -2) {
                                tien_tt_kkk += entry["thtien"] == null ? 0 : entry["tchat"] == 3 ? entry["thtien"] * -1 : entry["thtien"];
                                tien_ck_kkk += entry["stckhau"] == null ? 0 : entry["tchat"] == 3 ? entry["stckhau"] * -1 : entry["stckhau"];
                            }
                        }
                        else {
                            tien_thue_all += entry["tthue"] == null ? 0 : entry["tchat"] == 3 ? entry["tthue"] * -1 : entry["tthue"];
                            tong_tien_all += entry["tgtien"] == null ? 0 : entry["tchat"] == 3 ? entry["tgtien"] * -1 : entry["tgtien"];

                            // if (entry["tsuat"] == 7) {
                            //     tien_thue_7 += entry["thtien"] == null ? 0 : entry["tchat"] == 3 ? entry["thtien"] * -1 : entry["thtien"];
                            //     //tien_ck_10 += entry["stckhau"] == null ? 0 : entry["tchat"] == 3 ? entry["stckhau"] * -1 : entry["stckhau"];
                            // }

                            // if (entry["tsuat"] == 3.5) {
                            //     tien_thue_35 += entry["thtien"] == null ? 0 : entry["tchat"] == 3 ? entry["thtien"] * -1 : entry["thtien"];
                            //     //tien_ck_10 += entry["stckhau"] == null ? 0 : entry["tchat"] == 3 ? entry["stckhau"] * -1 : entry["stckhau"];
                            // }

                            if (entry["tsuat"] == 10) {
                                tien_tt_10 += entry["thtien"] == null ? 0 : entry["tchat"] == 3 ? Number(entry["thtien"]) * -1 : Number(entry["thtien"]);
                                tien_thue_10 += entry["tthue"] == null ? 0 : entry["tchat"] == 3 ? Number(entry["tthue"]) * -1 : Number(entry["tthue"]);
                                tien_ck_10 += entry["stckhau"] == null ? 0 : entry["tchat"] == 3 ? Number(entry["stckhau"]) * -1 : Number(entry["stckhau"]);
                                tong_tien_10 += entry["tgtien"] == null ? 0 : entry["tchat"] == 3 ? Number(entry["tgtien"]) * -1 : Number(entry["tgtien"]);
                            }
                            if (entry["tsuat"] == 5) {
                                tien_tt_5 += entry["thtien"] == null ? 0 : entry["tchat"] == 3 ? Number(entry["thtien"]) * -1 : Number(entry["thtien"]);
                                tien_thue_5 += entry["tthue"] == null ? 0 : entry["tchat"] == 3 ? Number(entry["tthue"]) * -1 : Number(entry["tthue"]);
                                tien_ck_5 += entry["stckhau"] == null ? 0 : entry["tchat"] == 3 ? entry["stckhau"] * -1 : entry["stckhau"];
                                tong_tien_5 += entry["tgtien"] == null ? 0 : entry["tchat"] == 3 ? entry["tgtien"] * -1 : entry["tgtien"];
                            }
                            if (entry["tsuat"] == 0) {
                                tien_tt_0 += entry["thtien"] == null ? 0 : entry["tchat"] == 3 ? entry["thtien"] * -1 : entry["thtien"];
                                tien_thue_0 += entry["tthue"] == null ? 0 : entry["tchat"] == 3 ? entry["tthue"] * -1 : entry["tthue"];
                                tien_ck_0 += entry["stckhau"] == null ? 0 : entry["tchat"] == 3 ? entry["stckhau"] * -1 : entry["stckhau"];
                                tong_tien_0 += entry["tgtien"] == null ? 0 : entry["tchat"] == 3 ? entry["tgtien"] * -1 : entry["tgtien"];
                            }
                            if (entry["tsuat"] == -1) {
                                tien_tt_kct += entry["thtien"] == null ? 0 : entry["tchat"] == 3 ? entry["thtien"] * -1 : entry["thtien"];
                                tien_thue_kct += entry["tthue"] == null ? 0 : entry["tchat"] == 3 ? entry["tthue"] * -1 : entry["tthue"];
                                tien_ck_kct += entry["stckhau"] == null ? 0 : entry["tchat"] == 3 ? entry["stckhau"] * -1 : entry["stckhau"];
                                tong_tien_kct += entry["tgtien"] == null ? 0 : entry["tchat"] == 3 ? entry["tgtien"] * -1 : entry["tgtien"];
                            }
                            if (entry["tsuat"] == -2) {
                                tien_tt_kkk += entry["thtien"] == null ? 0 : entry["tchat"] == 3 ? entry["thtien"] * -1 : entry["thtien"];
                                tien_thue_kkk += entry["tthue"] == null ? 0 : entry["tchat"] == 3 ? entry["tthue"] * -1 : entry["tthue"];
                                tien_ck_kkk += entry["stckhau"] == null ? 0 : entry["tchat"] == 3 ? entry["stckhau"] * -1 : entry["stckhau"];
                                tong_tien_kkk += entry["tgtien"] == null ? 0 : entry["tchat"] == 3 ? entry["tgtien"] * -1 : entry["tgtien"];
                            }
                        }

                    });

                    if (theoMaHang == 0) {
                        tien_thue_10 = Number(Number(tien_tt_10 * 0.1).toFixed(table_decimalPlaces.tthue))
                            + Number(Number(tien_thue_7 * 0.07).toFixed(table_decimalPlaces.tthue));
                        tong_tien_10 = Number(Number(tien_tt_10 + tien_thue_10).toFixed(table_decimalPlaces.tthue));
                        tien_thue_5 = Number(Number(tien_tt_5 * 0.05).toFixed(table_decimalPlaces.tthue))
                            + Number(Number(tien_thue_35 * 0.035).toFixed(table_decimalPlaces.tthue));
                        tong_tien_5 = Number(Number(tien_tt_5 + tien_thue_5).toFixed(table_decimalPlaces.tthue));
                        tien_thue_0 = tien_tt_0 * 0;
                        tong_tien_0 = tien_tt_0 + tien_thue_0;
                        tien_thue_kct = 0;
                        tong_tien_kct = tien_tt_kct;
                        tien_thue_kkk = 0;
                        tong_tien_kkk = tien_tt_kkk;

                        tien_thue_all = tien_thue_10 + tien_thue_5 + tien_thue_0 + tien_thue_kct + tien_thue_kkk;
                        tong_tien_all = parseFloat(Number(tien_tt_all + tien_thue_all).toFixed(table_decimalPlaces.thtien));
                    }

                    $$("tgtcthue").setValue(tien_tt_all);
                    if ($$("tgtcthue10") != undefined) $$("tgtcthue10").setValue(tien_tt_10);
                    if ($$("tgtcthue5") != undefined) $$("tgtcthue5").setValue(tien_tt_5);
                    if ($$("tgtcthue0") != undefined) $$("tgtcthue0").setValue(tien_tt_0);
                    if ($$("tgtcthuekct") != undefined) $$("tgtcthuekct").setValue(tien_tt_kct);
                    if ($$("tgtcthuekkk") != undefined) $$("tgtcthuekkk").setValue(tien_tt_kkk);

                    $$("ttcktmai").setValue(tien_ck_all);
                    if ($$("ttcktmai10") != undefined) $$("ttcktmai10").setValue(tien_ck_10);
                    if ($$("ttcktmai5") != undefined) $$("ttcktmai5").setValue(tien_ck_5);
                    if ($$("ttcktmai0") != undefined) $$("ttcktmai0").setValue(tien_ck_0);
                    if ($$("ttcktmaikct") != undefined) $$("ttcktmaikct").setValue(tien_ck_kct);
                    if ($$("ttcktmaikkk") != undefined) $$("ttcktmaikkk").setValue(tien_ck_kkk);

                    $$("tgtthue").setValue(tien_thue_all);

                    //Block Event để ngăn sự kiện onChange xảy ra
                    if ($$("tgtthue10") != undefined) {
                        $$("tgtthue10").blockEvent();
                        $$("tgtthue10").setValue(tien_thue_10);
                        $$("tgtthue10").unblockEvent();
                    }

                    //Block Event để ngăn sự kiện onChange xảy ra
                    if ($$("tgtthue5") != undefined) {
                        $$("tgtthue5").blockEvent();
                        $$("tgtthue5").setValue(tien_thue_5);
                        $$("tgtthue5").unblockEvent();
                    }
                    if ($$("tgtthue0") != undefined) $$("tgtthue0").setValue(tien_thue_0);
                    if ($$("tgtthuekct") != undefined) $$("tgtthuekct").setValue(tien_thue_kct);
                    if ($$("tgtthuekkk") != undefined) $$("tgtthuekkk").setValue(tien_thue_kkk);

                    $$("tgtttbso").setValue(tong_tien_all);
                    if ($$("tgtttbso10") != undefined) $$("tgtttbso10").setValue(tong_tien_10);
                    if ($$("tgtttbso5") != undefined) $$("tgtttbso5").setValue(tong_tien_5);
                    if ($$("tgtttbso0") != undefined) $$("tgtttbso0").setValue(tong_tien_0);
                    if ($$("tgtttbsokct") != undefined) $$("tgtttbsokct").setValue(tong_tien_kct);
                    if ($$("tgtttbsokkk") != undefined) $$("tgtttbsokkk").setValue(tong_tien_kkk);
                }
            },
            AfterAddRows: function (component, state, editor, igrone) {
            },
            OnBeforeShowForm: function (editmode, type) {
                var form = $$("invoiceForms");
                var values = form.getValues();

                if (editmode == 1) {
                    FuncOnBeforeShowForm(type);
                }

                var decimal_places = webix.storage.local.get(Constant.CACHE.DECIMAL_PLACES);
                if (decimal_places != null) {
                    SetDecimalPlace(decimal_places);
                }
                else {
                    webix.ajax().headers({ 'Content-type': 'application/text' }).get(Constant.API.DECIMAL_PLACES + values["dvtte"], function (text, data, XmlHttpRequest) {
                        var arr = JSON.parse(text);
                        SetDecimalPlace(arr);
                        webix.storage.local.put(Constant.CACHE.DECIMAL_PLACES, arr);
                    });
                }
                var after_edit = webix.storage.local.get(`${Constant.CACHE.AFTER_EDIT}${type}`);
                if (after_edit != null)
                    return after_edit;
                else
                    return webix.ajax().headers({ 'Content-type': 'application/text' }).get(Constant.API.GET_AFTER_EDIT + type);
            },
            OnInit: function (type) {
                var ttkhac_init = webix.storage.local.get(Constant.CACHE.ON_INIT + type);
                if (ttkhac_init != null) {
                    AddColumnGrid(ttkhac_init);
                } else {
                    webix.ajax().headers({ 'Content-type': 'application/text' })
                        .get(Constant.API.TTKHAC + type, function (text, data, XmlHttpRequest) {
                            var arr = JSON.parse(text);
                            if (arr.code == "00") {
                                var array = arr.data;
                                AddColumnGrid(array);
                                webix.storage.local.put(Constant.CACHE.ON_INIT + type, array);
                            }
                        });
                }
            },
            BeforEditRow: function (view, obj) {
                var row = view.getItem(obj.row)
                if (row.ctinh == 2)// tính ngược
                    return true;
                else {
                    var checkCalculator = webix.$$("check_congthuc");
                    var calculator = checkCalculator.getValue();
                    if (calculator == 1) {
                        return true;
                    }
                    else {
                        var lstColumn = new Array("tthue", "tgtien");
                        if (lstColumn.indexOf(obj.column) >= 0)
                            return false;
                        if (obj.column == "thtien") {
                            var so_luong = webix.rules.isNumber(row.sluong) ? row.sluong : 0;
                            var don_gia = webix.rules.isNumber(row.dgia) ? row.dgia : 0;
                            if (so_luong != 0 && don_gia != 0)
                                return false;
                            else
                                return true;
                        }
                    }
                }
            },
            ValidateError: function (views, id, obj, details) {
                var index = views.getIndexById(id) + 1;
                if (obj.tchat == "" || obj.tchat == null)
                    webix.message({ type: "error", text: "Bạn chưa nhập tính chất, tại dòng " + index });
            },
            InvoiceCopy: function (item) {
                var form = webix.$$("invoiceForms");
                webix.$$("khieu").define("readonly", false);
                webix.html.removeCss($$("khieu").getNode(), "mcls_readonly_text");

                webix.$$("khieu").refresh();
                var tableDetail = webix.$$("hoadon68_chitiet");
                webix.ajax()
                    .headers({ 'Content-type': 'application/json' })
                    .get(Constant.API.GET_DETAIL_INVOICE + item.id, function (text) {
                        var data = JSON.parse(text);
                        for (var i = 0; i < data.length; i++) {
                            data[i]["hoadon68_chitiet_id"] = null;
                            data[i]["hoadon68_id"] = null;
                        }
                        tableDetail.clearAll();
                        tableDetail.parse(data);
                    });
                item["hoadon68_id"] = null;
                item["hdlket_id"] = null;
                item["sovb"] = null;
                item["ngayvb"] = null;
                item["nky"] = null;
                item["shdon"] = null;
                item["tdlap"] = new Date();
                item["id"] = webix.uid();
                item["ngay_hd32"] = null;
                item["mauso_hd32"] = null;
                item["kyhieu_hd32"] = null;
                item["so_hd32"] = null;
                item["loai_hd32"] = null;
                item["tinhchat_hd32"] = null;
                webix.delay(function (a) {
                    form.setValues(a);
                }, form, [item], 300);
            },
            PaymentRequestCopy: function (item) {
                var formId = "invoiceForms";
                var datatableDetailId = "hoadon68_chitiet";
                var form = webix.$$(formId);

                var tableDetail = webix.$$(datatableDetailId);
                webix.ajax().headers({ 'Content-type': 'application/json' })
                    .get(Constant.API.PAYMENT_REQUEST.GET_DETAIL + item.id, function (text) {
                        var data = JSON.parse(text);
                        for (var i = 0; i < data.length; i++) {
                            delete data[i]["dntt_chitiet_id"];
                            delete data[i]["dntt_id"];
                            delete data[i]["dntt"];
                        }
                        tableDetail.clearAll();
                        tableDetail.parse(data);
                    });
                delete item["dntt_id"];
                item["so"] = null;
                item["mhso"] = "H26.103";
                item["tdlap"] = new Date();
                item["id"] = webix.uid();

                webix.delay(function (a) { 
                    form.setValues(a);
                    $$("tgtthue").setValue(item["tgtthue"]);
                    $$("tgtttbso").setValue(item["tgtttbso"]); 
                }, form, [item], 300);
            },
            InvoiceReplacement: function (invoiceBase) {
                webix.$$("head-formInvoice").setHTML("Hóa đơn thay thế cho hóa đơn số " + invoiceBase.shdon + " ký hiệu " + invoiceBase.khieu);
                webix.$$("head-formInvoice").refresh();
                var dmdvcs = version.getInfocompany();
                var table = webix.$$("invoiceViews");
                var item = table.getSelectedItem();
                var cctbao_id = $$("kyhieu_id").getValue();
                $$("cctbao_id").setValue(cctbao_id);
                var khieu = $$("kyhieu_id").getText();
                var form = $$("invoiceForms");
                var values = form.getValues();
                values["khieu"] = khieu;
                values["nganhang_ngban"] = dmdvcs.tai_nh;
                values["stknban"] = dmdvcs.tai_khoan;
                webix.delay(function (a) {
                    form.setValues(a);
                }, form, [values], 300);

                $$("khieu").define("readonly", false);
                $$("khieu").define("css", "mcls_unreadonly");
                $$("khieu").refresh();

                $$("btnHoadonSaveThayThe").show();
                $$("btnHoadonSave").destructor();
            },
            InvoiceAdjustment: function () {
                var table = webix.$$("invoiceViews");
                var item = table.getSelectedItem();
                webix.$$("head-formInvoice").setHTML("Hóa đơn điều chỉnh cho hóa đơn số " + item.shdon + " ký hiệu " + item.khieu);
                webix.$$("head-formInvoice").refresh();
                var dmdvcs = version.getInfocompany();

                var form = $$("invoiceForms");
                item["tgtttbso"] = 0;
                item["tgtcthue"] = 0;
                item["tgtthue"] = 0;
                item["ttcktmai"] = 0;
                item["tdlap"] = new Date();
                item["nganhang_ngban"] = dmdvcs.tai_nh;
                item["stknban"] = dmdvcs.tai_khoan;
                webix.delay(function (a) {
                    form.setValues(a);
                }, form, [item], 300);
            },
            InvoiceReplacement32: function () {
                webix.$$("head-formInvoice").setHTML("Hóa đơn thay thế");
                webix.$$("head-formInvoice").refresh();

                var cctbao_id = $$("kyhieu_id").getValue();
                $$("cctbao_id").setValue(cctbao_id);
                var khieu = $$("kyhieu_id").getText();
                var form = $$("invoiceForms");
                var values = form.getValues();
                values["hoadon68_id"] = null;
                values["khieu"] = khieu;
                values["hdlket_id"] = "00000000-0000-0000-0000-000000000000";

                form.setValues(values);

                var info = componentHelper.dcttHoadon32(1);
                $$("info-customer").addView(info, 10);
                //không phải
                $$("btnHoadonSaveThayThe").show();
                $$("btnHoadonSave").destructor();
            },
            InvoiceAdjustment32: function () {
                webix.$$("head-formInvoice").setHTML("Hóa đơn điều chỉnh");
                webix.$$("head-formInvoice").refresh();

                var cctbao_id = $$("kyhieu_id").getValue();
                $$("cctbao_id").setValue(cctbao_id);
                var khieu = $$("kyhieu_id").getText();
                var form = $$("invoiceForms");
                var values = form.getValues();
                values["hoadon68_id"] = null;
                values["khieu"] = khieu;
                values["hdlket_id"] = "00000000-0000-0000-0000-000000000000";
                form.setValues(values);

                var info = componentHelper.dcttHoadon32(2);
                $$("info-customer").addView(info, 10);
                if (webix.$$("btnHoadonSaveDieuChinh") != undefined) {
                    webix.$$("btnHoadonSaveDieuChinh").show();
                }
                if (webix.$$("btnHoadonSave") != undefined) {
                    webix.$$("btnHoadonSave").destructor();
                }
            },
            InvoiceDiscount: function (data, formId) {
                if (!data.ngay) {
                    data.ngay = new Date();
                } else {
                    const parsedDate = new Date(data.ngay);
                    data.ngay = isNaN(parsedDate.getTime()) ? new Date() : parsedDate;
                }

                const mappedValues = {
                    sbke: data.so,
                    nbke: data.ngay,
                    tnmua: data.nmua,
                    mst: data.mst_nmua,
                    dchi: data.dchi_nmua,
                    tdlap: data.ngay
                };

                if (Array.isArray(data.bangke_chitiets) && data.bangke_chitiets.length > 0) {
                    const firstDetail = data.bangke_chitiets[0];

                    mappedValues.dvtte = firstDetail.dvtte;
                    mappedValues.tgia = firstDetail.tgia;
                }

                $$(formId).setValues(mappedValues);
            }
        }
    });
define('views/forms/forms68/EXCEL/68_exportExcelAccounting',["app", "locale"], function (app, _) {
    return {
        $ui: {
            view: "window", modal: true, id: "excelAccounting-win", position: "center",
            head: "Kết xuất Excel vào PM Kế toán",
            width: 400,
            body: {
                paddingY: 10,
                paddingX: 10,
                view: "form",
                id: "excelAccounting-form",
                complexData: true,
                margin: 0,
                elements: [
                    {
                        view: "multicombo",
                        label: _("KY_HIEU"),
                        name: "invoiceSerial",
                        id: "invoiceSerial",
                        required: true,
                        invalidMessage: "Ký hiệu hóa đơn không được để trống",
                        validate: webix.rules.isNotEmpty,
                        labelWidth: 80,
                        suggest: {
                            selectAll: true,
                            body: {
                                url: app.config.host + "/Invoice68/GetTypeInvoiceSeries",
                            }
                        }
                    },
                    {
                        view: "datepicker",
                        label: _("Từ ngày"),
                        name: "from",
                        format: "%d/%m/%Y",
                        id: "from",
                        ediable: true,
                        required: true,
                        value: new Date(),
                        invalidMessage: "Từ ngày không được để trống"
                    },
                    {
                        view: "datepicker",
                        label: _("Đến ngày"),
                        name: "to",
                        ediable: true,
                        value: new Date(),
                        format: "%d/%m/%Y",
                        id: "to",
                        required: true,
                        invalidMessage: "Đến ngày không được để trống"
                    },
                    {
                        view: "combo",
                        name: "type",
                        label: "Loại báo cáo ",
                        id: "type",
                        required: true,
                        invalidMessage: "Loại báo cáo không được để trống",
                        validate: webix.rules.isNotEmpty,
                        options: {
                            view: "gridsuggest",
                            id: "grid_ExcelAccounting",
                            template: "#name#",
                            width: 550,
                            body: {
                                scroll: true,
                                autoheight: false,
                                columns: [
                                    { id: "id", header: "STT", editor: "text", width: 50 },
                                    { id: "name", header: "Tên báo cáo", editor: "text", width: 300 }
                                ],
                                data: [
                                    { id: "1", name: "Báo cáo Fast - Hàng hóa thường" },
                                    { id: "2", name: "Báo cáo Fast - Hàng hóa dịch vụ" }
                                ]
                            }
                        },
                    },
                    {
                        margin: 10,
                        cols: [
                            {},
                            {
                                shortcut: "F10", view: "button", label: "Nhận (F10)", type: "form", align: "center", width: 100,
                                on: {
                                    onClick: function () {
                                        if ($$("excelAccounting-form").validate()) {
                                            var win = $$("excelAccounting-win");
                                            webix.extend(win, webix.ProgressBar);
                                            win.disable();
                                            win.showProgress();
                                            var param = $$("excelAccounting-form").getValues();
                                            webix.ajax().response("arraybuffer").get(app.config.host + "/Invoice68/ExportExcelAccounting", param, function (text, data) {
                                                var file = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                                                webix.html.download(file, "Minvoice.xlsx");
                                                win.enable();
                                                win.hideProgress();
                                            });
                                        }
                                    }
                                },
                                click: function () {
                                    this.callEvent("onClick");

                                }
                            },
                            {
                                view: "button", hotkey: "esc", label: "Hủy bỏ (ESC)", type: "danger", align: "center", width: 100,
                                click: function () {
                                    webix.$$("excelAccounting-win").close();
                                }
                            },
                            {}
                        ]
                    }

                ]
            }

        },
    };

});
define('views/forms/forms68/HDon/68_chuyenhoadon',["app", "locale", "models/user"], function (app, _, user) {
    'use strict';
    var itemData = [];
    var fm = function (number) {
        var k = webix.Number.numToStr({
            groupDelimiter: ".",
            groupSize: 3,
            decimalDelimiter: ",",
            decimalSize: 0
        });
        return k(number);
    }
    return {
        $ui: {
            view: "window",
            modal: true,
            position: function (state) {
                state.width = state.maxWidth * 0.2;
                state.height = state.maxHeight * 0.4;
                state.left = (state.maxWidth - state.width) / 2;
                state.top = (state.maxHeight - state.height) / 2;
            },
            head: "Chuyển hóa đơn qua ký hiệu khác",
            id: "convertInvoice-Win",
            resize: true,
            // fullscreen: true,
            move: true,
            on: {
                onShow: function () {
                    var self = this;
                    $(".webix_modal").one("click", function () {
                        self.hide();
                    });
                },
                onBeforeShow: function () {
                    var khieu = $$("kyhieu_id").getText();
                    var cctbao_id = $$("kyhieu_id").getValue();
                    itemData.splice(0, itemData.length);
                    var data = { id: cctbao_id, value: khieu };
                    itemData.push(data);
                    $$("cctbao_id_old").define("options", itemData);
                    $$("cctbao_id_old").setValue(itemData[0].id);
                    $$("cctbao_id_old").refresh();
                }
            },
            body: {
                view: "form",
                id: "frmConvertInvoice",
                elementsConfig: { labelWidth: 110 },
                // width: 1500,
                position: "center",
                // autowidth:true,
                paddingY: 10,
                paddingX: 15,
                complexData: true,
                scroll: true,
                margin: 0,
                elements: [
                    {
                        view: "label", autoheight: true, css: "lblResgisterMess", template: function () {
                            return `<div><i class='mdi mdi-18px mdi-lightbulb-on-10'></i><b>Chỉ áp dụng với hệ thống <b style='color:blue;'>sinh số sau</b>.</b>
                            Để đảm bảo quy luật giữa năm của ký hiệu và năm của ngày hóa đơn. M-Invoice cho phép chuyển các hóa đơn <b style='color:blue;'>Chờ ký chưa sinh số, ngày</b> qua lại giữa các ký hiệu.</div>`;
                        }
                    },
                    {
                        id: "cctbao_id_old",
                        name: "cctbao_id_old",
                        view: "combo",
                        attributes: { readonly: true },
                        label: _("Ký hiệu hiện tại")
                    },
                    {
                        id: "cctbao_id_new",
                        name: "cctbao_id_new",
                        view: "combo",
                        label: _("Ký hiệu mới"),
                        options: {
                            body: {
                                url: app.config.host + "/Invoice68/GetTypeInvoiceSeries",
                                ready: function () {
                                    var count = this.count();
                                    if (count > 0) {
                                        var combo = webix.$$("cctbao_id_new");
                                        combo.setValue(this.getFirstId());
                                    }
                                },
                            },
                        },
                        on: {
                            onChange: function (newv, oldv) {
                            },
                        },
                    },
                    { height: 5 },
                    {
                        id: "btnConvertInvoice",
                        cols: [
                            {},
                            {
                                view: "button", id: "btnXacNhan", shortcut: "F10", label: "Thực hiện", type: "form", align: "center", width: 120,
                                click: function () {
                                    var frm = $$("frmConvertInvoice");
                                    var data = frm.getValues();
                                    var khieu_new = $$("cctbao_id_new").getText();
                                    var khieu_old = $$("cctbao_id_old").getText();
                                    if (khieu_new.substr(0, 1) != khieu_old.substr(0, 1)) {
                                        webix.message(`Loại hóa đơn cũ và mới không giống nhau. ${khieu_new.substr(0, 1)} khác ${khieu_old.substr(0, 1)}. Thao tác không thành công`, "error");
                                        return;
                                    }
                                    if (khieu_new.substr(1, 1) != khieu_old.substr(1, 1)) {
                                        webix.message(`Hình thức hóa đơn cũ và mới không giống nhau. ${khieu_new.substr(1, 1)} khác ${khieu_old.substr(1, 1)}. Thao tác không thành công`, "error");
                                        return;
                                    }
                                    if (khieu_new.substr(4, 1) != khieu_old.substr(4, 1)) {
                                        webix.message(`Kiểu hóa đơn cũ và mới không giống nhau. ${khieu_new.substr(4, 1)} khác ${khieu_old.substr(4, 1)}. Thao tác không thành công`, "error");
                                        return;
                                    }
                                    data.khieu_new = khieu_new;
                                    var hostConfig = app.config.host + "/Serial/ConvertSerialInvoice"
                                    webix.extend(frm, webix.ProgressBar);
                                    frm.disable();
                                    frm.showProgress();
                                    webix
                                        .ajax()
                                        .headers({ "Content-Type": "application/json" })
                                        .post(hostConfig, data, {
                                            error: function (text, data, XmlHttpRequest) {
                                                frm.enable();
                                                frm.hideProgress();
                                            },
                                            success: function (text, data, XmlHttpRequest) {
                                                var response = JSON.parse(text);
                                                frm.enable();
                                                frm.hideProgress();
                                                if (response.code == "00") {
                                                    app.callEvent("dataChangedInvoie68", [1, 1]);
                                                    webix.$$("convertInvoice-Win").close();
                                                    webix.message("Chuyển hóa đơn thành công", "success");
                                                } else {
                                                    webix.message(response.message, "error");
                                                }
                                            },
                                        });
                                }
                            },
                            {
                                view: "button", hotkey: "esc", label: "Hủy bỏ", width: 120, type: "danger", align: "center",
                                click: function () {
                                    webix.$$("convertInvoice-Win").close();
                                }
                            },
                            {}
                        ]
                    }
                ]
            }
        },
        InitParam: function () {

        }
    };
});
define('views/modules/Component/button',[
  "app",
  "locale",
  "views/menus/version",
  "models/user",
  "views/modules/Component/componentHelper",
  "views/forms/forms68/HDon/68_printfMultiChoice",
  "views/modules/Component/modalPlugin",
  "views/forms/forms68/EXCEL/68_exportExcelAccounting",
  "views/forms/forms68/HDon/68_chuyenhoadon",
  "views/modules/Component/constantManager",
  "views/modules/Component/ajaxHelper",
  "views/modules/Component/functionExtension"
], function (
  app,
  _,
  version,
  user,
  componentHelper,
  printMulti,
  modalPlugin,
  exportExcelAccounting,
  chuyenhoadonForm,
  constant,
  Ajax,
  functionExtension
) {
  function showCertSelectionModal(title, dataUrl, columns, onCertConfirm) {
    var box = webix.modalbox({
      title: title,
      buttons: ["Nhận", "Hủy bỏ"],
      text: "<div id='ctnCerts'></div>",
      top: 100,
      width: 750,
      callback: function (result) {
        if (result === "1") {
          webix.modalbox.hide(box);
        } else if (result === "0") {
          var table = $$("tblCerts");
          var data = table.serialize();
          var cert = data.find(x => x.chon === true);
          if (!cert) return showError("Bạn chưa chọn chứng thư số");
          onCertConfirm(cert);
        }
      }
    });

    var popupText = document.getElementsByClassName("webix_popup_text")[0];
    if (popupText) popupText.style.paddingTop = 0;

    webix.ui({
      container: "ctnCerts",
      id: "tblCerts",
      view: "datatable",
      borderless: true,
      resizeColumn: true,
      height: 350,
      columns: columns,
      url: dataUrl
    });
  }
  function getCertColumns(fields) {
    const columnMap = {
      chon: {
        id: "chon", header: _("CHON"), width: 65,
        checkValue: true, uncheckValue: false, template: "{common.checkbox()}"
      },
      so_serial: { id: "so_serial", header: _("SO_SERIAL"), width: 150 },
      subjectname: { id: "subjectname", header: _("SUBJECTNAME"), width: 450 },
      ngaybatdau: { id: "ngaybatdau", header: _("NGAY_BAT_DAU"), width: 200 },
      ngayketthuc: { id: "ngayketthuc", header: _("NGAY_KET_THUC"), width: 200 },
      issuer: { id: "issuer", header: _("DONVI"), width: 450 },
      libraryName: { id: "libraryName", header: _("Loại"), width: 150 }
    };
    return fields.map(f => columnMap[f]);
  }
  // isSend = 1 save xml và gửi thuế; isSend = 2 save xml
  function Sign(windowView, gridInvoice, itemInvoice, type, isSend) {
    function enableUI() {
      windowView.enable();
      windowView.hideProgress();
    }

    function disableUI() {
      webix.extend(windowView, webix.ProgressBar);
      windowView.disable();
      windowView.showProgress();
    }

    function reloadGrid() {
      if (gridInvoice) {
        gridInvoice.clearAll();
        gridInvoice.load(gridInvoice.config.url);
      }
    }

    function signSuccess() {
      webix.message("Ký gửi hóa đơn thành công!", "success");
      reloadGrid();
    }

    function openSignForm(modulePath, cert, urlScheme) {
      require(["app", "locale", modulePath], function (app, _, signView) {
        var frmModal = gridInvoice.$scope.ui(signView.$ui);
        signView.initUI(cert, urlScheme);
        webix.modalbox.hide();
        frmModal.show();
      });
    }

    webix.ajax().headers({ "Content-type": "application/json" })
      .get(constant.API.INVOICE_GET_TYPE_SIGN, function (text) {
        var result = JSON.parse(text);
        var kytaptrung = result[0].gia_tri;
        var khieu = itemInvoice.khieu;
        switch (kytaptrung.toUpperCase()) {
          case "FILE":
            var certUrl, certColumns, onCertConfirm;
            certUrl = constant.API.TOKEN_CERT_AUTO;
            certColumns = getCertColumns(["chon", "so_serial", "subjectname", "ngaybatdau", "ngayketthuc", "issuer", "libraryName"]);
            onCertConfirm = function (cert) {
              var postData = {
                so_serial: cert.so_serial,
                certData: cert,
                data: [{ hoadon68_id: itemInvoice.id }],
                type: isSend
              };
              disableUI();

              webix.ajax().headers({ 'Content-type': 'application/json' })
                .post(constant.API.INVOICE_SIGN_FILE, postData, {
                  error: function (text, data, XmlHttpRequest) { enableUI(); },
                  success: function (text) {
                    enableUI();
                    var response = JSON.parse(text);
                    if (response.code != "00") return showError(response.message);
                    signSuccess();
                  }
                });
            };
            showCertSelectionModal("Chọn chứng thư số", certUrl, certColumns, onCertConfirm);
            break;
          case "EASYCA":
          case "ICA":
          case "NCCA":
            var certUrl, certColumns, onCertConfirm;
            certUrl = constant.API.TOKEN_CERT_AUTO;
            certColumns = getCertColumns(["chon", "so_serial", "subjectname", "ngaybatdau", "ngayketthuc", "issuer", "libraryName"]);
            onCertConfirm = function (cert) {
              cert.id = itemInvoice.id;
              var tagSignMap = {
                "EASYCA": khieu[4] === "M" ? "TDiep/CKSNNT" : "HDon/DSCKS/NBan",
                "ICA": khieu[4] === "M" ? "/CKSNNT" : "/DSCKS/NBan",
                "NCCA": khieu[4] === "M" ? "/CKSNNT" : "/DSCKS/NBan"
              };
              var modulePathMap = {
                "EASYCA": "views/forms/forms68/EasyCA/signEasyCA",
                "ICA": "views/forms/forms68/ICA/signICA",
                "NCCA": "views/forms/forms68/NCCA/signNCCA"
              };
              cert.tagSign = tagSignMap[kytaptrung];
              cert.tagSignId = itemInvoice.id;
              var urlScheme = (isSend == 2 && kytaptrung == "ICA") ? "invoiceSignNotSend" : type === 2 ? "invoiceKma" : "invoiceCma";
              var modulePath = modulePathMap[kytaptrung];
              if (kytaptrung === "ICA") {
                webix.ajax().headers({ "Content-type": "application/text" })
                  .get(constant.API.TOKEN_SHOW_PIN, function (text) {
                    var response = JSON.parse(text);
                    if (response.show) {
                      openSignForm(modulePath, cert, urlScheme);
                    } else {
                      var apiHost = isSend == 2 ? constant.API.INVOICE_SIGN_ICA_NOSEND : constant.API.INVOICE_SIGN_ICA;
                      var param = {
                        so_serial: cert.so_serial,
                        pinCode: cert.pass,
                        id: itemInvoice.id,
                        agreementUUID: cert.value
                      };
                      disableUI();
                      webix.ajax().headers({ "Content-type": "application/json" }).post(apiHost, param,
                        {
                          error: function () { enableUI(); },
                          success: function (text) {
                            enableUI();
                            var res = JSON.parse(text);
                            if (res.code != "00") return showError(res.message);
                            signSuccess();
                          }
                        });
                    }
                  });
              } else {
                openSignForm(modulePath, cert, urlScheme);
              }
            };
            showCertSelectionModal("Chọn chứng thư số", certUrl, certColumns, onCertConfirm);
            break;
          case "K":
            disableUI();
            var a = webix.ajax(app.config.host + "/Invoice68/ExportXml?id=" + itemInvoice.id);
            var b = webix.ajax(app.config.host + "/Pattern/GetListCertificates");
            var c = webix.ajax(app.config.host + "/Pattern/GetSerialAcceptInvoice");
            webix.promise.all([a, b, itemInvoice, c]).then(function (results) {
              var xmlData = results[0].json();
              if (xmlData.code != "00") {
                enableUI();
                showError(xmlData.message);
                return;
              }
              var listcerts = results[1].json();
              var item = results[2];
              var certAccept = results[3].json();
              if (certAccept == undefined || certAccept.length == 0) {
                enableUI();
                showError("Đăng ký sử dụng hóa đơn NĐ 123 chưa được CQT chấp thuận");
                return;
              }
              if (listcerts.length == 0) {
                enableUI();
                showError("Bạn chưa được phân quyền chứng thư số");
                return;
              }
              require(["views/modules/minvoiceplugin",], function (plugin) {
                var hub = plugin.hub();
                var hubconnect = plugin.conn();
                if (hubconnect.state != 1) {
                  enableUI();
                  showError("Quý khách hàng chưa cài Plugin ký hóa đơn hoặc Plugin ký hóa đơn chưa được bật !");
                  var Form = gridInvoice.$scope.ui(modalPlugin.$ui);
                  Form.show();
                  return;
                }
                hub.off("resCommand");
                hub.on("resCommand", function (result) {
                  var xmlSign = JSON.parse(result);
                  enableUI();
                  if (xmlSign.hasOwnProperty("error")) return showError(xmlSign.error);

                  var parameters = {
                    xml: xmlSign.xml,
                    id: item.id,
                  };
                  var apiHost = isSend == 2 ? constant.API.INVOICE_SAVE_XML_NOSEND : constant.API.INVOICE_SAVE_XML;
                  disableUI();
                  webix.ajax().headers({ "Content-Type": "application/json", })
                    .post(apiHost, parameters, function (text) {
                      var result = JSON.parse(text);
                      enableUI();
                      if (result.code != "00") return showError(result.message);
                      signSuccess();
                    });
                });

                var _listcerts = [];
                for (var i = 0; i < listcerts.length; i++) {
                  var _cert = listcerts[i];
                  _listcerts.push({
                    so_serial: _cert.so_serial,
                    ngaybatdau: _cert.ngaybatdau,
                    ngayketthuc: _cert.ngayketthuc,
                    issuer: _cert.issuer,
                    subjectname: _cert.subjectname,
                  });
                }
                var arg = {
                  idData: "#" + (khieu[4] == "M" ? xmlData.data["idData"] : itemInvoice.hoadon68_id),
                  xml: xmlData.data["xml"],
                  shdon: "",
                  idSigner: khieu[4] == "M" ? null : "seller",
                  tagSign: khieu[4] == "M" ? "CKSNNT" : "NBan",
                  listcerts: _listcerts,
                  certAccept: certAccept,
                };

                hub.invoke("execCommand", "SignXmlTag", JSON.stringify(arg))
                  .done(function () { console.log("Success !"); })
                  .fail(function (error) { console.log(error); enableUI(); showError(error.toString()); });
              });
            }).fail(function (err) {
              enableUI();
              console.log(err);
              showError("Lỗi trong quá trình lấy dữ liệu ký");
            });
            break;
          case "VIETTEL":
            var certUrl, certColumns, onCertConfirm;
            certUrl = constant.API.TOKEN_CERT_AUTO;
            certColumns = getCertColumns(["chon", "so_serial", "subjectname", "ngaybatdau", "ngayketthuc", "issuer", "libraryName"]);

            onCertConfirm = function (cert) {
              var postData = {
                idData: itemInvoice.id,
                tagSign: "NBan",
                cert: cert.id,
                hoadon68_id: itemInvoice.id,
                typeSign: type,
              };
              disableUI();
              webix.ajax().headers({ 'Content-type': 'application/json' })
                .post(app.config.host + "/Invoice68/SignInvoiceByViettelCA", postData, {
                  error: function (text, data, XmlHttpRequest) { enableUI(); },
                  success: function (text) {
                    enableUI();
                    var response = JSON.parse(text);
                    if (response.code != "00") return showError(response.message);
                    signSuccess();
                  }
                });
            };
            showCertSelectionModal("Chọn chứng thư số", certUrl, certColumns, onCertConfirm);
            break;
          case "INTRUSTCA":
            var certUrl, certColumns, onCertConfirm;
            certUrl = constant.API.TOKEN_CERT_AUTO;
            certColumns = getCertColumns(["chon", "so_serial", "subjectname", "ngaybatdau", "ngayketthuc", "issuer", "libraryName"]);
            onCertConfirm = function (cert) {
              var postData = {
                user_name: cert.username,
                credentialID: cert.tokenSerial,
                certificate: cert.cert_content,
                pinCode: cert.pin_code,
                auth_data: cert.auth_data,
                mode: isSend,
                hoadon: [itemInvoice.id]
              };
              disableUI();

              webix.ajax().headers({ 'Content-type': 'application/json' })
                .post(constant.API.SIGN.INTRUSTCA, postData, {
                  error: function (text, data, XmlHttpRequest) { enableUI(); },
                  success: function (text) {
                    enableUI();
                    var response = JSON.parse(text);
                    if (response.code != "00") return showError(response.message);
                    signSuccess();
                  }
                });
            };
            showCertSelectionModal("Chọn chứng thư số", certUrl, certColumns, onCertConfirm);
            break;
          case "VNET":
            var certUrl, certColumns, onCertConfirm;
            certUrl = constant.API.TOKEN_CERT_AUTO;
            certColumns = getCertColumns(["chon", "so_serial", "subjectname", "ngaybatdau", "ngayketthuc", "issuer", "libraryName"]);
            onCertConfirm = function (cert) {
              var postData = {
                chukyso_id: cert.chukyso_id,
                id: itemInvoice.id,
                type: type
              };

              disableUI();
              webix.ajax().headers({ 'Content-type': 'application/json' })
                .post(app.config.host + "/TokenCloud/SignInvoiceByVnet", postData, {
                  error: function (text, data, XmlHttpRequest) { enableUI(); },
                  success: function (text) {
                    enableUI();
                    var response = JSON.parse(text);
                    if (response.code != "00") return showError(response.message);
                    signSuccess();
                  }
                });
            };
            showCertSelectionModal("Chọn chứng thư số", certUrl, certColumns, onCertConfirm);
            break;
        }
      });
  }
  var fmMoney = function (number) {
    var response = webix.Number.numToStr({
      groupDelimiter: ".",
      groupSize: 3,
      decimalDelimiter: ",",
      decimalSize: 0,
    });
    return response(number);
  };
  function printMultiChoice() {
    var table = $$("invoiceViews");
    var array = new Array();
    table.eachRow(function (row) {
      var record = JSON.stringify(table.getItem(row));
      if (record != undefined) {
        var ref = JSON.parse(record);
        if (ref.colMultiChoice == "C") {
          array.push(ref.id);
        }
      }
    }, true);
    if (array.length == 0) {
      webix.message({ type: "error", text: "Không có bản ghi nào được chọn" });
      return;
    }
    // var printForm = table.$scope.ui(printMulti.$ui);
    // printMulti.initUI(array);
    // printForm.show();

    var mimetype = "application/pdf";
    var url = app.config.host + "/Invoice68/PrintInvoiceMulti";
    var chunkSize = 9;
    var optPrint = "INVOICE";
    if ($$("optionPrint") != undefined) optPrint = $$("optionPrint").getValue();
    var form = webix.$$("frmView");
    for (let i = 0; i < array.length; i += chunkSize) {
      var chunk = array.slice(i, i + chunkSize);
      webix.extend(form, webix.ProgressBar);
      form.disable();
      form.showProgress();

      var paramPrint = {
        parameter: chunk,
        type: "PDF",
        opt: "medium",
        optionPrint: optPrint,
      };
      var c = webix
        .ajax()
        .response("arraybuffer")
        .headers({ "Content-type": "application/json" })
        .post(url, paramPrint, {
          error: function (text, data, XmlHttpRequest) {
            form.enable();
            form.hideProgress();
            if ($$("window-print") != undefined) $$("window-print").close();
            alert(text);
          },
          success: function (text, data, XmlHttpRequest) {
            form.enable();
            form.hideProgress();
            if ($$("window-print") != undefined) $$("window-print").close();
            var file = new Blob([data], { type: mimetype });
            var fileURL = URL.createObjectURL(file);
            var newWin = window.open();
            var html =
              "<html><head><title>Hóa đơn điện tử M-Invoice</title>" +
              '<link rel="stylesheet" href="assets/fontawesome_pro/css/all.css" type="text/css" charset="utf-8">' +
              '<link rel="stylesheet" href="assets/fontawesome.css" type="text/css" charset="utf-8">' +
              '</head><body><center>Đang tải dữ liệu ... <br><p><i style="font-size:200%;" class="fa fa-spin fa-spinner"></i></p></center></body></html>';
            newWin.document.write(html);
            newWin.location = fileURL;
          },
        });
      webix.promise.all([c]).then(function (results) {
        var response = results[0].json();
      });
    }
  }
  function sendEmailMulti() {
    var table = $$("invoiceViews");
    var emailList = [];
    var stopProcessing = false;

    table.eachRow(function (row) {
      var ref = table.getItem(row);
      if (!ref || ref.colMultiChoice !== "C") return;

      var hasError = false;

      //  Nếu hóa đơn lỗi (Đã gửi + is_success = 0) => bỏ chọn và set stopProcessing
      if (ref.tthai === "Đã gửi" && ref.is_success === 0) {
        ref.colMultiChoice = "K";
        table.updateItem(ref.id, ref);
        hasError = true;
        stopProcessing = true;
      }

      //  Nếu không nhập email
      if (!ref.email) {
        ref.colMultiChoice = "K";
        table.updateItem(ref.id, ref);
        webix.message("Hóa đơn số: " + ref.shdon + " không nhập email người mua", "debug");
        hasError = true;
      }

      //  Nếu chưa ký hoặc chưa gửi
      if (ref.tthai !== "Đã gửi" && ref.tthai !== "Đã ký") {
        ref.colMultiChoice = "K";
        table.updateItem(ref.id, ref);
        webix.message("Hóa đơn số: " + ref.shdon + " chưa ký", "debug");
        hasError = true;
      }

      if (!hasError) {
        emailList.push({
          id: ref.id,
          nguoi_nhan: ref.email,
          shdon: ref.shdon,
          khieu: ref.khieu,
          scret: functionExtension.SaltEmail(ref.email)
        });
      }
    }, true);

    if (stopProcessing) return showError("Hóa đơn có lỗi không thể gửi email !");
    if (emailList.length === 0) return showError("Không có bản ghi nào được chọn");

    var dataPost = {
      id: emailList,
      type: "Gửi hóa đơn"
    };

    webix.confirm({
      title: "GỬI EMAIL HÓA ĐƠN",
      text: "Bạn có chắc chắn muốn gửi email",
      ok: "Có",
      cancel: "Không",
      callback: function (res) {
        if (!res) return;

        var frm = $$("frmView");
        webix.extend(frm, webix.ProgressBar);
        frm.disable();
        frm.showProgress();

        webix.ajax()
          .headers({ "Content-type": "application/json" })
          .post(constant.API.INVOICE_SEND_EMAIL_MULTIPLE, dataPost, {
            error: function () {
              frm.enable();
              frm.hideProgress();
            },
            success: function (text) {
              frm.enable();
              frm.hideProgress();
              var data = JSON.parse(text);
              table.clearAll();
              table.load(table.config.url);

              if (data.code !== "00") return showError(data.message);
              webix.message("Gửi Email thành công !", "success");
            }
          });
      }
    });
  }
  function inChuyenDoi() {
    var table = webix.$$("invoiceViews");
    var item = table.getSelectedItem();
    if (item == null || item == undefined) {
      webix.message("Bạn chưa chọn hóa đơn cần in !", "error");
      return;
    }
    var box = webix.modalbox({
      title: "Đang in hóa đơn ....",
      text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
      width: 350,
      height: 200,
    });

    var newWin = window.open();
    var html =
      "<html><head><title>Hóa đơn điện tử M-Invoice</title>" +
      '<link rel="stylesheet" href="assets/fontawesome_pro/css/all.css" type="text/css" charset="utf-8">' +
      '<link rel="stylesheet" href="assets/fontawesome.css" type="text/css" charset="utf-8">' +
      '</head><body><center>Đang tải dữ liệu ... <br><p><i style="font-size:200%;" class="fa fa-spin fa-spinner"></i></p></center></body></html>';
    newWin.document.write(html);

    webix
      .ajax()
      .response("arraybuffer")
      .headers({ "Content-type": "application/json" })
      .get(app.config.host + "/Invoice68/PrintInvoice?id=" + item.id + "&type=PDF&inchuyendoi=true",
        {
          error: function (text, data, XmlHttpRequest) {
            webix.modalbox.hide(box);
          },
          success: function (text, data, XmlHttpRequest) {
            var file = new Blob([data], { type: "application/pdf" });
            var fileURL = URL.createObjectURL(file);
            webix.modalbox.hide(box);
            newWin.location = fileURL;
          },
        }
      );
  }
  function deleteInvoiceMulti() {
    var table = $$("invoiceViews");
    var array = [];
    table.eachRow(function (row) {
      var record = JSON.stringify(table.getItem(row));
      if (record != undefined) {
        var ref = JSON.parse(record);

        if (ref.colMultiChoice == "C") {
          var invoice = {
            hoadon68_id: ref.id,
            cctbao_id: ref.cctbao_id,
            shdon: ref.shdon,
            tthai: ref.tthai,
          };
          array.push(invoice);
        }
      }
    }, true);

    if (array.length == 0) {
      webix.message({ type: "error", text: "Không có bản ghi nào được chọn" });
      return;
    }

    var rpParameter = {
      menu_id: webix.storage.local.get("MENU_ID"),
      data: array,
    };
    webix.confirm({
      title: "XÓA NHIỀU HÓA ĐƠN",
      text: "Bạn có muốn xóa nhiều hóa đơn ",
      ok: "Có",
      cancel: "Không",
      callback: function (res) {
        if (res) {
          webix.extend(table, webix.ProgressBar);
          table.disable();
          table.showProgress();

          webix
            .ajax()
            .headers({ "Content-type": "application/json" })
            .post(constant.API.INVOICE_DELETE_MULTIPLE, rpParameter, {
              error: function (text, data, XmlHttpRequest) {
                table.enable();
                table.hideProgress();
                webix.message(text, "error");
                app.callEvent("dataChangedInvoie68", [1, null]);
              },
              success: function (text, data, XmlHttpRequest) {
                var res = JSON.parse(text);
                if (res.code != "00") {
                  webix.message(res.message, "error");
                }
                table.clearAll();
                table.load(table.config.url);
                table.enable();
                table.hideProgress();
              },
            });
        }
      },
    });
  }
  function showMenu(node) {
    var menu = $$("invoiceViews").config.headermenu;
    $$(menu).show(node);
  }
  function guiCQT(type) {
    // 1 là hóa đơn có mã. 2 là hóa đơn không mã
    webix.callEvent("onLoadError");
    var tableHdon = webix.$$("invoiceViews");
    var itemHdon = tableHdon.getSelectedItem();
    if (itemHdon.tthai == "Đã gửi") return showError("Hóa đơn đã gửi !");
    if (itemHdon.tthai == "Chờ ký") return showError("Hóa đơn chưa ký không thẻ gửi !");

    var hostConfig = type == 2 ?
      app.config.host + "/Invoice68/SendToTVAN?id=" + itemHdon.id + "&type=2" :
      app.config.host + "/Invoice68/SendToTVAN?id=" + itemHdon.id + "&type=1";

    webix.confirm({
      title: "GỬI HÓA ĐƠN",
      text: "Bạn có muốn gửi hóa đơn số: <span style='color: red'>" + itemHdon.shdon + "</span>",
      ok: "Có",
      cancel: "Không",
      callback: function (res) {
        if (res) {
          webix.extend(tableHdon, webix.ProgressBar);
          tableHdon.disable();
          tableHdon.showProgress();
          webix.ajax().headers({ "Content-Type": "application/json" })
            .get(hostConfig, function (text) {
              var result = JSON.parse(text);
              tableHdon.enable();
              tableHdon.hideProgress();
              if (result.code != "00") {
                webix.message({ type: "error", text: result.message });
                return;
              } else {
                webix.message("Gửi đến cơ quan thuế thành công", "success");
                var table = webix.$$("invoiceViews");
                table.clearAll();
                table.load(table.config.url);
              }
            });
        }
      },
    });
  }
  function validateMoney() {
    var response = { code: 0, messageData: "" };

    function getVal(id) {
      var el = $$(id);
      return el && el.getValue() != null ? el.getValue() : 0;
    }

    var tongtien_tt = getVal("tgtcthue");
    var tongtien_thue = getVal("tgtthue");
    var tongtien = getVal("tgtttbso");

    var tongtien_tt_ct = 0;
    var tongtien_thue_ct = 0;
    var tongtien_ct = 0;

    var dataDetail = $$("hoadon68_chitiet").serialize();

    for (var i = 0; i < dataDetail.length; i++) {
      var e = dataDetail[i];
      var hs = (e.tchat === 3 || e.tchat === 4) ? -1 : 1;

      tongtien_tt_ct += e.thtien ? e.thtien * hs : 0;
      tongtien_thue_ct += e.tthue ? e.tthue * hs : 0;
      tongtien_ct += e.tgtien ? e.tgtien * hs : 0;
    }

    var messages = [];

    function addDiffMessage(name, ct, head) {
      if (ct != head) {
        response.code = 1;
        messages.push(
          "Tổng " + name + " <b>chi tiết</b> <" + fmMoney(ct) + "> khác <b>đầu phiếu</b> <" + fmMoney(head) +
          ">, chênh lệch <" + fmMoney(Math.abs(ct - head)) + ">.</br>"
        );
      }
    }

    addDiffMessage("thành tiền", tongtien_tt_ct, tongtien_tt);
    addDiffMessage("tiền thuế", tongtien_thue_ct, tongtien_thue);
    addDiffMessage("tiền thanh toán", tongtien_ct, tongtien);
    addDiffMessage("tiền trước thuế + thuế đầu phiếu", tongtien_tt + tongtien_thue, tongtien);

    messages.push("<span style='color:#0069b4'>Bạn có muốn lưu hóa đơn này không?</span>");

    response.messageData = "<div>" + messages.join("") + "</div>";
    return response;
  }

  function frmYesNo(editmode, table, messageData, model) {
    function closeWindow() {
      $$("window-esc").close();
    }

    function onYesClick() {
      closeWindow();
      model.data[0].tgtttbchu = $$("tgtttbchu").getValue();

      webix.extend(table, webix.ProgressBar);
      table.disable();
      table.showProgress();

      Ajax.POST(constant.API.INVOICE_SAVE, model)
        .then(function (data) {
          var response = JSON.parse(data);
          table.enable();
          table.hideProgress();

          if (response.code !== "00") return showError(response.message);
          webix.$$("invoice68").close();
          app.callEvent("dataChangedInvoie68", [editmode, response.data]);
        })
        .catch(function (error) {
          console.log(error);
          table.enable();
          table.hideProgress();
          webix.message(error, "error");
        });
    }

    var iconColor = messageData.code != 0 ? "#ff8839" : "#00b300";
    var iconClass = messageData.code != 0
      ? "mdi-alert-outline"
      : "mdi-shield-check-outline";

    return webix.ui({
      view: "window",
      modal: true,
      id: "window-esc",
      position: "center",
      move: true,
      padding: 30,
      css: "frmSaveInvoice",
      autoheight: true,
      head: {
        borderless: true,
        view: "toolbar",
        cols: [
          { view: "label", width: 40, template: "<span style='color:" + iconColor + ";' class='mdi mdi-24px " + iconClass + "'></span>" },
          {
            view: "label",
            css: { color: "back !important" },
            template: "<span style='color:black;font-size:15px;'>" +
              (editmode === 2 ? "Sửa hóa đơn" : "Lập hóa đơn") +
              "</span>"
          },
          { view: "button", width: 30, type: "icon", icon: "mdi mdi-close", align: "right", click: closeWindow }
        ]
      },

      body: {
        paddingY: 10,
        paddingX: 10,
        view: "form",
        id: "window-formesc",
        css: "frmYesNo",
        complexData: true,
        keepViews: true,
        autoheight: true,
        margin: 0,
        elements: [
          { view: "template", autoheight: true, template: messageData.messageData },
          { height: 10 },
          {
            cols: [
              {},
              { id: "btnCo", view: "button", label: "Có", type: "form", align: "center", click: onYesClick },
              { view: "button", id: "btnKo", shortcut: "esc", label: "Không", type: "danger", align: "center", click: closeWindow },
              {}
            ]
          },
          { height: 10 }
        ]
      }
    }).show();
  }

  function validateBeforeSave(item) {
    var response = true;

    var checktinhtien = $$("check_tinhctmathang").getValue();
    var checkcongthuc = $$("check_congthuc").getValue();
    item.theomh = checktinhtien;
    item.mccqthue = checkcongthuc;

    // Kiểm tra thông tin khách hàng nếu không phải mẫu M
    if (item.khieu && item.khieu[4] !== "M" && item.khieu[0] !== "6") {
      var ten = item.ten || "";
      var dchi = item.dchi || "";
      var tnmua = item.tnmua || "";
      if (!tnmua && (ten.length === 0 || dchi.length === 0)) {
        webix.message("Bạn chưa nhập đủ thông tin khách hàng", "debug");
        response = false;
      }
    }

    // Kiểm tra định dạng email
    var emails = ($$("email").getValue() || "").split(/[\s,;]+/);
    for (var i = 0; i < emails.length; i++) {
      var mail = emails[i].trim();
      if (mail && !webix.rules.isEmail(mail)) {
        webix.message("Email không đúng định dạng " + mail, "error");
        response = false;
      }
    }

    return response;
  }

  function validateDetailBeforeSave(dataDetail, loai) {
    if (!dataDetail || dataDetail.length === 0) {
      webix.message("Bạn chưa nhập thông tin chi tiết", "debug");
      return false;
    }

    var table = $$("hoadon68_chitiet");
    var errorCount = 0;

    function isVisible(column) {
      return table.getColumnConfig(column) && table.isColumnVisible(column);
    }

    function show(index, label) {
      webix.message(label + " tại dòng " + (index + 1), "error");
      errorCount++;
    }

    function checkField(entry, key, label, index) {
      if (!entry[key]) {
        show(index, label + " không được để trống");
      }
    }

    function checkTaxRate(entry, index) {
      loai = parseInt(loai, 10);
      entry.tchat = parseInt(entry.tchat, 10);
      if (loai === 1 && (entry.tchat === 1 || entry.tchat === 2 || entry.tchat === 3)) {
        if (entry.tsuat == null || entry.tsuat === "") {
          show(index, "Thuế suất không được để trống khi tính chất khác Ghi chú/diễn giải");
        }
      }
    }

    function checkTchat(entry, index) {
      if (entry.tchat == null || entry.tchat === "") {
        show(index, "Tính chất không được bỏ trống");
      }
    }

    var mstRegex = /^\d{10}(-\d{3})?$/;

    var checks = [
      { key: "skhung", label: "Số khung" },
      { key: "smay", label: "Số máy" },
      { key: "bien_sxe", label: "Biển số xe" },
      { key: "ten_ngui", label: "Tên người gửi" },
      { key: "dc_ngui", label: "Địa chỉ người gửi" },
      { key: "sddanh_ngui", label: "Số định danh người gửi" },
      { key: "mst_ngui", label: "MST người gửi", validate: function (v) { return mstRegex.test(v); } }
    ];

    for (var i = 0, visibleChecks = []; i < checks.length; i++) {
      if (isVisible(checks[i].key)) visibleChecks.push(checks[i]);
    }

    for (var i = 0; i < dataDetail.length; i++) {
      var row = dataDetail[i];

      checkTaxRate(row, i);
      checkTchat(row, i);

      if (row.id != null) {
        for (var j = 0; j < visibleChecks.length; j++) {
          var check = visibleChecks[j];
          var val = row[check.key];

          if (check.validate) {
            if (val && !check.validate(val)) {
              show(i, check.label + " không đúng định dạng");
            }
          } else {
            checkField(row, check.key, check.label, i);
          }
        }
      }
    }

    return errorCount === 0;
  }

  function loadingStatus(current, code, message) {
    var text = code === "00"
      ? "Hóa đơn số: " + current
      : "Thao tác không thành công hóa đơn số: " + current + " " + message;
    var type = code === "00" ? "debug" : "error";
    webix.message(text, type);
  }

  function ttkhacInit(array) {
    var table = $$("hoadon68_chitiet");
    array.forEach((element) => {
      if (element.hidden_in_grid != true) {
        var newCol = {
          header: element.label,
          id: element.ttruong,
          name: element.ttruong,
          editor: element.type_rows,
          editable: true,
        };
        table.config.columns.splice(element.cols, 0, newCol);
      }
    });
    table.refreshColumns();
  }
  function ttkhacInitDP(array, item) {
    array.forEach((element) => {
      if (element.hidden_in_form != true) {
        var newCol = {
          view: element.type_rows,
          label: element.label,
          labelWidth: 100,
          id: element.ttruong,
          name: element.ttruong,
          on: {},
        };
        // add field vào cùng 1 dòng nếu đặt parrent = field_parrent
        var itemAdd = {
          id: element.ttruong + "_parrent",
          cols: [],
        };
        if (element.onchange != null && element.onchange != "") {
          newCol.on.onChange = function (newv, oldv, config) {
            var fn = Function("newv", "oldv", element.onchange);
            fn(newv, oldv);
          };
        }
        if (element.is_readonly == true) {
          newCol.readonly = true;
          newCol.css = "mcls_readonly_text";
        }
        itemAdd.cols.push(newCol);
        $$(element.parrent).addView(itemAdd, element.rows);
        if (element.type_rows == "datepicker") {
          item[element.ttruong] = removeTimeZoneT(item[element.ttruong]);
        }
      }
    });
  }
  function btnExcelCache(arr, options, optionsBtn) {
    arr.forEach((element) => {
      var data = {
        id: element.wb_ex_id,
        value: element.ex_name,
        on_click: element.onClick,
      };
      options.push(data);
    });
    optionsBtn.clearAll();
    optionsBtn.parse(options, "json");
  }
  function clearFilter(table) {
    table.eachColumn(function (id, col) {
      var filter = this.getFilter(id);
      if (filter) {
        if (filter.hasOwnProperty("1")) {
          if (filter["1"].setValue) filter["1"].setValue("");
          else filter["1"].value = "";
        } else {
          if (filter.setValue) filter.setValue("")
          else filter.value = "";
        }
      }
    });
    table.filterByAll();
  }

  return {
    settingColumn: function () {
      var res = {
        cols: [
          {
            view: "button",
            type: "icon",
            width: 30,
            icon: "mdi mdi-settings",
            click: function () {
              showMenu(this.$view);
            },
          },
          {
            view: "button",
            type: "icon",
            width: 30,
            icon: "mdi mdi-shield-bug-outline",
            tooltip: "Cấu hình thông tin khác",
            click: function () {
              app.router("app/68_thongtinkhac");
              if (webix.$$("title") != undefined)
                webix
                  .$$("title")
                  .parse({
                    title: "Điều khiển > Cấu hình thông tin khác",
                    details: "item.details",
                    code: "item.code",
                  });
            },
          },
        ],
      };
      return res;
    },
    optionPrint: function () {
      var res = {
        view: "combo",
        id: "optionPrint",
        name: "optionPrint",
        width: 220,
        label: _("MAUIN"),
        attributes: { readonly: true },
        labelWidth: 50,
        value: "INVOICE",
        options: [
          { id: "INVOICE", value: "Hóa đơn điện tử" },
          { id: "DNTT", value: "Đề nghị thanh toán" },
        ],
      };
      return res;
    },
    btnEmail: function (sendEmailForm) {
      var result = {
        view: "button",
        type: "htmlbutton",
        width: 100,
        label: '<i class="fa fa-envelope fa-lg" aria-hidden="true"></i><span class="text"> ' + _("SEND_EMAIL") + "</span>",
        id: "btnEmail",
        on: {
          onClick: function () {
            webix.callEvent("onLoadError");
            var table = webix.$$("invoiceViews");
            if (table.getColumnConfig("colMultiChoice") == undefined) {
              var item = table.getSelectedItem();
              if (item == null || item == undefined) return showError("Bạn chưa chọn hóa đơn cần gửi email !");
              if (item.tthai == "Đã gửi" && item.is_success == 0) return showError("Hóa đơn có lỗi không thể gửi email !");
              if (item.tthai == "Chờ ký") return showError("Hóa đơn chưa ký không thể gửi email !");

              var dataPost = {
                id: item.hoadon68_id,
                type: "Gửi hóa đơn",
              };
              webix.ajax().headers({ "Content-type": "application/json" })
                .post(constant.API.INVOICE_TEMP_EMAIL, dataPost, {
                  error: function (text, data, XmlHttpRequest) { },
                  success: function (text, data, XmlHttpRequest) {
                    var data = JSON.parse(text);
                    if (data.code == "00") {
                      var json = data.data;
                      var itemData = {
                        nguoi_gui: json.nguoi_gui,
                        tieude: json.tieu_de,
                        noidung: json.noi_dung,
                        mat_khau: json.pass,
                        hoadon68_id: item.hoadon68_id,
                        type: "Gửi hóa đơn",
                        nguoinhan: item.email,
                        his_email: json.his_email,
                        bcc: json.bcc,
                      };
                      var win = table.$scope.ui(sendEmailForm.$ui);
                      sendEmailForm.setValues(itemData);
                      win.show();
                    } else {
                      webix.message(data.message, "error");
                    }
                  },
                });
            } else {
              sendEmailMulti();
            }
          },
        },
        click: function () {
          this.callEvent("onClick");
        },
      };
      return result;
    },
    btnKy: function () {
      var res = {
        view: "button",
        type: "htmlbutton",
        width: 120,
        label: '<i class="fa fa-sign-in fa-lg aria-hidden="true"></i><span class="text">' + _("Ký") + "</span>",
        id: "btnKy",
        click: function () {
          var windowView = webix.$$("frmView");
          var tableHdon = webix.$$("invoiceViews");
          var itemHdon = tableHdon.getSelectedItem();
          if (itemHdon == undefined || itemHdon == null) return showError("Bạn chưa chọn hóa đơn !");
          if (itemHdon.tthai == "Đã gửi" || itemHdon.tthai == "Đã ký") return showError("Hóa đơn đã ký !");

          webix.confirm({
            title: "KÝ HÓA ĐƠN",
            text: "Bạn có muốn ký hóa đơn số: <span style='color: red'>" + itemHdon.shdon + "</span>",
            ok: "Có",
            cancel: "Không",
            callback: function (res) {
              if (res) Sign(windowView, tableHdon, itemHdon, 2, 2);
            },
          });
        },
      };
      return res;
    },
    btnKyCQT: function (type) {
      // type = 1 là hóa đơn có mã. 2 là hóa đơn không mã
      return {
        view: "button",
        type: "htmlbutton",
        width: 120,
        label: '<i class="fa fa-sign-in fa-lg" aria-hidden="true"></i><span class="text"> ' + _("SIGN_SEND") + '</span>',
        id: "btnKyCXL",
        click: function () {
          webix.callEvent("onLoadError");

          var windowView = webix.$$("frmView");
          var tableHdon = webix.$$("invoiceViews");
          var itemHdon = tableHdon.getSelectedItem();

          if (!itemHdon) return showError("Bạn chưa chọn hóa đơn !");
          if (itemHdon.is_tthdon === "10") return showError("Thao tác không thành công, hóa đơn không thể ký");
          if (itemHdon.tthai === "Đã gửi" || itemHdon.tthai === "Đã ký") return showError("Hóa đơn đã ký !");

          var dataRequest = [{
            id: itemHdon.id,
            shdon: itemHdon.shdon,
            tdlap: itemHdon.tdlap
          }];
          webix.extend(windowView, webix.ProgressBar);
          windowView.disable();
          windowView.showProgress();
          webix.ajax()
            .headers({ 'Content-type': 'application/json' })
            .post(constant.API.INVOICE_CHECK_DATE, JSON.stringify(dataRequest), {
              error: function () {
                windowView.enable();
                windowView.hideProgress();
              },
              success: function (text) {
                windowView.enable();
                windowView.hideProgress();
                var response = JSON.parse(text);
                if (response.code !== "00") return showError(response.message);

                var invalids = (response.data || []).filter(function (x) { return !x.Validate; });

                function confirmSign() {
                  webix.confirm({
                    title: "KÝ HÓA ĐƠN",
                    text: "Bạn có muốn ký và gửi CQT hóa đơn số: <span style='color: red'>" + itemHdon.shdon + "</span>",
                    ok: "Có",
                    cancel: "Không",
                    callback: function (res) {
                      if (res) Sign(windowView, tableHdon, itemHdon, type, 1);
                    }
                  });
                }

                if (invalids.length > 0) {
                  var hd = invalids[0];
                  var tdlap = webix.Date.dateToStr("%d/%m/%Y")(new Date(hd.tdlap));
                  var message =
                    "Theo quy định tại Điểm c Khoản 7 và Điểm b Khoản 14, Điều 1, Nghị định 70/2025/NĐ-CP, " +
                    "thời điểm ký gửi dữ liệu hóa đơn lên CQT chậm nhất là ngày làm việc tiếp theo kể từ thời điểm lập hóa đơn.<br/>" +
                    "Hóa đơn đang ký có ngày lập <b>" + tdlap + "</b>, ký hiệu <b>" + itemHdon.khieu +
                    "</b>, số <b>" + hd.shdon + "</b> không thỏa mãn quy định trên.</br>" +
                    "<span style='font-weight: bold;'>Bạn có muốn tiếp tục ký và gửi hóa đơn lên CQT không?</span>";

                  webix.modalbox({
                    title: "<div style='font-size: 16px; font-weight: bold; color: #FF0000;'>CẢNH BÁO KÝ GỬI HÓA ĐƠN QUÁ HẠN</div>",
                    text: "<div style='padding: 18px; font-size: 14px; color: black; line-height: 1.5;'>" + message + "</div>",
                    buttons: ["Có, tiếp tục Ký", "Không"],
                    width: 700,
                    callback: function (result) {
                      if (result === "0") {
                        Sign(windowView, tableHdon, itemHdon, type, 1);
                      }
                    }
                  });
                } else {
                  confirmSign();
                }
              }
            });
        }
      };
    },
    btnPrintInvoice: function () {
      var res = {
        view: "button",
        type: "htmlbutton",
        width: 100,
        label: '<i class="fa fa-print fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("PRINT") + "</span>",
        id: "btnPrint",
        on: {
          onClick: function () {
            var table = webix.$$("invoiceViews");
            if (table.getColumnConfig("colMultiChoice") == undefined) {
              var item = table.getSelectedItem();
              if (item == null || item == undefined) {
                webix.message("Bạn chưa chọn hóa đơn cần in !", "error");
                return;
              }
              var box = webix.modalbox({
                title: "Đang in hóa đơn ....",
                text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                width: 350,
                height: 200,
              });
              var apiPrint = app.config.host + "/Invoice68/PrintInvoice?id=" + item.id + "&type=PDF&inchuyendoi=false";
              if ($$("optionPrint") != undefined) {
                var optionPrint = $$("optionPrint").getValue();
                if (optionPrint == "DNTT")
                  apiPrint = app.config.host + "/Invoice68/PrintInvoice?id=" + item.id + "&type=PDF&inchuyendoi=false&file=DNTT";
              }
              var newWin = window.open();
              var html =
                "<html><head><title>Hóa đơn điện tử M-Invoice</title>" +
                '<link rel="stylesheet" href="assets/fontawesome_pro/css/all.css" type="text/css" charset="utf-8">' +
                '<link rel="stylesheet" href="assets/fontawesome.css" type="text/css" charset="utf-8">' +
                '</head><body><center>Đang tải dữ liệu ... <br><p><i style="font-size:200%;" class="fa fa-spin fa-spinner"></i></p></center></body></html>';
              newWin.document.write(html);

              webix
                .ajax()
                .response("arraybuffer")
                .headers({ "Content-type": "application/json" })
                .get(apiPrint, {
                  error: function (text, data, XmlHttpRequest) {
                    webix.modalbox.hide(box);
                  },
                  success: function (text, data, XmlHttpRequest) {
                    var file = new Blob([data], { type: "application/pdf" });
                    var fileURL = URL.createObjectURL(file);
                    webix.modalbox.hide(box);
                    newWin.location = fileURL;
                  },
                });
            } else {
              printMultiChoice();
            }
          },
        },
        click: function () {
          this.callEvent("onClick");
        },
      };
      return res;
    },
    btnPrintInvoiceChuyenDoi: function () {
      var res = {
        view: "button",
        type: "htmlbutton",
        width: 120,
        label: '<i class="fa fa-print fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("In chuyển đổi") + "</span>",
        id: "btnPrintConvert",
        on: {
          onClick: function () {
            inChuyenDoi();
          },
        },
        click: function () {
          this.callEvent("onClick");
        },
      };
      return res;
    },
    btnCopy: function (invoiceForms, type, petroForm) {
      var res = {
        view: "button",
        type: "htmlbutton",
        width: 100,
        label: `<i class="fa fa-files-o fa-lg" aria-hidden="true"></i><span class="text"> ${_(
          "COPY"
        )}</span>`,
        id: "btnCopy",
        on: {
          onClick: function () {
            webix.callEvent("onLoadError");
            var table = webix.$$("invoiceViews");
            var item = table.getSelectedItem();
            if (item == null) {
              webix.message("Bạn chưa chọn dòng dữ liệu sao chép", "debug");
              return;
            }
            var dataOptions = $$("kyhieu_id").getList().getItem(item.cctbao_id);
            if (dataOptions.loai_doanh_nghiep === 1) {
              var modal = this.$scope.ui(petroForm.$ui);
              petroForm.copyValues(item);
              petroForm.setEditMode(1);
              modal.show();
            } else {
              var data = JSON.parse(JSON.stringify(item));
              data.macqt = null;
              data.matdiep = null;
              var detailForm = this.$scope.ui(invoiceForms.$ui);
              var khieu = $$("kyhieu_id").getText();
              if (type != 6) {
                componentHelper.changeDauphieuHoadon(
                  this,
                  type,
                  khieu[4] === "M" ? true : false
                );
              }
              invoiceForms.setEditMode(1, dataOptions.loai_doanh_nghiep);
              invoiceForms.copyValues(data);
              detailForm.show();
            }
          },
        },
        click: function () {
          this.callEvent("onClick");
        },
      };
      return res;
    },
    btnDelete: function () {
      var res = {
        view: "button",
        type: "htmlbutton",
        width: 100,
        label: `<i class="fa fa-trash-o fa-lg" aria-hidden="true"></i><span class="text"> ${_("XOA")} (F8)</span>`,
        id: "btnDelete",
        shortcut: "F8",
        on: {
          onClick: function () {
            webix.callEvent("onLoadError");
            var table = webix.$$("invoiceViews");
            var item = table.getSelectedItem();

            if (table.getColumnConfig("colMultiChoice") == undefined) {
              if (item == null || item == undefined) return showError("Bạn chưa chọn dòng dữ liệu cần xóa !");
              if (item.is_tthdon == "10") return showError("Thao tác không thành công, hóa đơn không thể xóa");
              if (item.tthai != "Chờ ký") return showError("Không thể xóa hóa đơn có trạng thái Đã ký hoặc Đã gửi");
              if (item.is_success == "1") return showError("Hóa đơn đã gửi lên CQT, không thể xóa");
              var menu_id = webix.storage.local.get("MENU_ID");
              var dataPost = {
                tab_masters: "hoadon68",
                menu_id: menu_id,
                editmode: 3,
                data: [item],
              };

              webix.confirm({
                title: "XÓA HÓA ĐƠN",
                text: "Bạn có muốn xóa hóa đơn số: <span style='color: red'>" + item.shdon + "</span>",
                ok: "Có",
                cancel: "Không",
                callback: function (res) {
                  if (res) {
                    webix.extend(table, webix.ProgressBar);
                    table.disable();
                    table.showProgress();

                    webix
                      .ajax()
                      .headers({ "Content-type": "application/json" })
                      .post(constant.API.INVOICE_SAVE, dataPost, {
                        error: function (text, data, XmlHttpRequest) {
                          table.enable();
                          table.hideProgress();
                          app.callEvent("dataChangedInvoie68", [1, null]);
                        },
                        success: function (text, data, XmlHttpRequest) {
                          var js = JSON.parse(text);
                          table.enable();
                          table.hideProgress();
                          if (js.code != "00") return showError(js.message);
                          table.remove(item.id);
                          table.clearAll();
                          table.load(table.config.url);
                        },
                      });
                  }
                },
              });
            } else {
              deleteInvoiceMulti();
            }
          },
        },
        click: function () {
          this.callEvent("onClick");
        },
      };
      return res;
    },
    btnEdit: function (invoiceForms, type, petroForm) {
      var res = {
        view: "button",
        type: "htmlbutton",
        width: 100,
        label: `<i class="fa fa-edit fa-lg" aria-hidden="true"></i><span class="text"> ${_(
          "SUA"
        )} (F3)</span>`,
        id: "btnEdit",
        shortcut: "F3",
        //css:"button_raised",
        on: {
          onClick: function () {
            webix.callEvent("onLoadError");
            var table = webix.$$("invoiceViews");
            var item = table.getSelectedItem();

            if (item == null || item == undefined) {
              webix.message("Bạn chưa chọn dòng cần sửa", "error");
              return;
            }
            if (item.is_tthdon == "10") {
              webix.message(
                "Thao tác không thành công, hóa đơn thể sửa",
                "error"
              );
              return;
            }
            var dataOptions = $$("kyhieu_id").getList().getItem(item.cctbao_id);
            if (dataOptions.loai_doanh_nghiep === 1) {
              var modal = this.$scope.ui(petroForm.$ui);
              petroForm.setValues(item);
              petroForm.setEditMode(2);
              modal.show();
            } else {
              var detailForm = this.$scope.ui(invoiceForms.$ui);
              if (type != 6) {
                componentHelper.changeDauphieuHoadon(
                  this,
                  type,
                  item.khieu[4] === "M" ? true : false
                );
              }
              if (item.so_hd32 != "" && item.so_hd32 != null) {
                if (item.tthdon == 3) {
                  var info = componentHelper.dcttHoadon32(1);
                  $$("info-invoice").addView(info, 10);
                } else {
                  if (item.tthdon == 2) {
                    var info = componentHelper.dcttHoadon32(2);
                    $$("info-invoice").addView(info, 10);
                  }
                }
              }

              if (item.tthai != "Chờ ký" || item.is_success == "1") {
                var form = $$("invoiceForms").elements;
                for (var key in form) {
                  var $el = form[key];
                  $el.define("readonly", "true");
                  $el.define("css", "mcls_readonly_text");
                  $el.refresh();
                }
                if ($$("btnHoadonSave") != undefined) {
                  $$("btnHoadonSave").destructor();
                }
              }
              invoiceForms.setEditMode(2, dataOptions.loai_doanh_nghiep);
              detailForm.show();

              var ttkhac_cache = webix.storage.local.get(constant.CACHE.TTKHAC + type);
              var ttkhac_ct_cache = webix.storage.local.get(constant.CACHE.TTKHAC_CT + type);
              if (ttkhac_ct_cache != null) {
                ttkhacInit(ttkhac_ct_cache);
              } else {
                webix
                  .ajax()
                  .headers({ "Content-type": "application/text" })
                  .get(
                    constant.API.TTKHAC_CT + type,
                    function (text, data, XmlHttpRequest) {
                      var arr = JSON.parse(text);
                      if (arr.code == "00") {
                        var array = arr.data;
                        ttkhacInit(array);
                        webix.storage.local.put(constant.CACHE.TTKHAC_CT + type, array);
                      }
                    }
                  );
              }
              if (ttkhac_cache != null) {
                ttkhacInitDP(ttkhac_cache, item);
                invoiceForms.setValues(item, null);
              } else {
                webix
                  .ajax()
                  .headers({ "Content-type": "application/text" })
                  .get(
                    constant.API.TTKHAC + type,
                    function (text, data, XmlHttpRequest) {
                      var arr = JSON.parse(text);
                      if (arr.code == "00") {
                        var array = arr.data;
                        ttkhacInitDP(array, item);
                        invoiceForms.setValues(item, null);
                        webix.storage.local.put(constant.CACHE.TTKHAC + type, array);
                      }
                    }
                  );
              }
              webix
                .ajax()
                .bind(detailForm)
                .get(constant.API.GET_DMDVCS, function (text) {
                  var result = JSON.parse(text);
                  webix.delay(
                    function (a) {
                      var txtEmailnban = webix.$$("emailnban");
                      var txtSdt = webix.$$("sdt_ngban");
                      var txtStk = webix.$$("stknban");
                      var txtNH = webix.$$("nganhang_ngban");
                      if (txtEmailnban != null && txtEmailnban != undefined)
                        txtEmailnban.setValue(result.email);
                      if (txtSdt != null && txtSdt != undefined)
                        txtSdt.setValue(result["dien_thoai"]);
                      if (txtStk != null && txtStk != undefined)
                        txtStk.setValue(result["tai_khoan"]);
                      if (txtNH != null && txtNH != undefined)
                        txtNH.setValue(result["tai_nh"]);
                    },
                    invoiceForms,
                    [item],
                    100
                  );
                });
            }
          },
        },
        click: function () {
          this.callEvent("onClick");
        },
      };
      return res;
    },
    btnAdd: function (invoiceForms, type, petroForm) {
      var res = {
        view: "button",
        type: "htmlbutton",
        width: 100,
        label: `<i class="fa fa-plus fa-lg" aria-hidden="true"></i><span class="text"> ${_("THEM")} (F4)</span>`,
        id: "btnPlus",
        shortcut: "F4",
        on: {
          onClick: function () {
            webix.callEvent("onLoadError");

            var cctbao_id = $$("kyhieu_id").getValue();
            if (
              cctbao_id == undefined ||
              cctbao_id == null ||
              cctbao_id == ""
            ) {
              webix.message("Bạn chưa chọn ký hiệu hóa đơn", "error");
              return;
            }
            var khieu = $$("kyhieu_id").getText();
            var dataOptions = $$("kyhieu_id").getList().getItem(cctbao_id);
            if (dataOptions.loai_doanh_nghiep === 1) {
              var modal = this.$scope.ui(petroForm.$ui);
              petroForm.initUINew(cctbao_id, khieu);
              petroForm.setEditMode(1);
              modal.show();
            } else {
              var detailForm = this.$scope.ui(invoiceForms.$ui);
              if (type != 6) {
                componentHelper.changeDauphieuHoadon(
                  this,
                  type,
                  khieu[4] === "M" ? true : false
                );
              }
              invoiceForms.initUINew(cctbao_id, khieu);
              invoiceForms.setEditMode(1, dataOptions.loai_doanh_nghiep);
              detailForm.show();
              webix
                .ajax()
                .bind(detailForm)
                .get(constant.API.GET_DMDVCS, function (text) {
                  var result = JSON.parse(text);
                  var txtEmailnban = webix.$$("emailnban");
                  var txtSdt = webix.$$("sdt_ngban");
                  var txtStk = webix.$$("stknban");
                  var txtNH = webix.$$("nganhang_ngban");
                  if (txtEmailnban != null && txtEmailnban != undefined) {
                    txtEmailnban.setValue(result.email);
                  }
                  if (txtSdt != null && txtSdt != undefined) {
                    txtSdt.setValue(result["dien_thoai"]);
                  }
                  if (txtStk != null && txtStk != undefined) {
                    txtStk.setValue(result["tai_khoan"]);
                  }
                  if (txtNH != null && txtNH != undefined) {
                    txtNH.setValue(result["tai_nh"]);
                  }
                });
            }
          },
          onCreate: function () {
            const data = arguments[0];
            webix.callEvent("onLoadError");

            var cctbao_id = $$("kyhieu_id").getValue();
            if (
              cctbao_id == undefined ||
              cctbao_id == null ||
              cctbao_id == ""
            ) {
              webix.message("Bạn chưa chọn ký hiệu hóa đơn", "error");
              return;
            }
            var khieu = $$("kyhieu_id").getText();
            var dataOptions = $$("kyhieu_id").getList().getItem(cctbao_id);
            if (dataOptions.loai_doanh_nghiep === 1) {
              var modal = this.$scope.ui(petroForm.$ui);
              petroForm.initUINew(cctbao_id, khieu);
              petroForm.setEditMode(1);
              modal.show();
            } else {
              var detailForm = this.$scope.ui(invoiceForms.$ui);
              if (type != 6) {
                componentHelper.changeDauphieuHoadon(
                  this,
                  type,
                  khieu[4] === "M" ? true : false
                );
              }
              invoiceForms.initUIHoaDonChietKhau(data);
              invoiceForms.initUINew(cctbao_id, khieu);
              invoiceForms.setEditMode(1, dataOptions.loai_doanh_nghiep);

              detailForm.show();
              webix
                .ajax()
                .bind(detailForm)
                .get(constant.API.GET_DMDVCS, function (text) {
                  var result = JSON.parse(text);
                  var txtEmailnban = webix.$$("emailnban");
                  var txtSdt = webix.$$("sdt_ngban");
                  var txtStk = webix.$$("stknban");
                  var txtNH = webix.$$("nganhang_ngban");
                  if (txtEmailnban != null && txtEmailnban != undefined) {
                    txtEmailnban.setValue(result.email);
                  }
                  if (txtSdt != null && txtSdt != undefined) {
                    txtSdt.setValue(result["dien_thoai"]);
                  }
                  if (txtStk != null && txtStk != undefined) {
                    txtStk.setValue(result["tai_khoan"]);
                  }
                  if (txtNH != null && txtNH != undefined) {
                    txtNH.setValue(result["tai_nh"]);
                  }
                });
            }
          },
        },
        click: function () {
          this.callEvent("onClick");
        },
      };
      return res;
    },
    btnRefresh: function () {
      var res = {
        view: "button",
        type: "htmlbutton",
        width: 100,
        label: `<i class="fa fa-refresh fa-lg" aria-hidden="true"></i><span class="text"> ${_(
          "REFRESH"
        )}</span>`,
        id: "btnReload",
        on: {
          onClick: function () {
            webix.callEvent("onLoadError");
            var table = webix.$$("invoiceViews");
            clearFilter(table);
            table.clearAll();
            table.load(table.config.url);
          },
        },
        click: function () {
          this.callEvent("onClick");
        },
      };
      return res;
    },
    btnGuiCQT: function (type) {
      // 1 là hóa đơn có mã. 2 là hóa đơn không mã
      var res = {
        view: "button",
        type: "htmlbutton",
        width: 120,
        label: `<i class="fa fa-paper-plane fa-lg aria-hidden="true"></i><span class="text">${_(
          "Gửi CQT"
        )}</span>`,
        id: "btnKyGuiCQT",
        click: function () {
          webix.callEvent("onLoadError");
          var tableHdon = webix.$$("invoiceViews");
          var itemHdon = tableHdon.getSelectedItem();
          if (itemHdon.tthai == "Đã gửi") {
            webix.message("Hóa đơn đã gửi !", "error");
            return;
          }
          if (itemHdon.tthai == "Chờ ký") {
            webix.message("Hóa đơn chưa ký không thẻ gửi !", "error");
            return;
          }
          var hostConfig =
            app.config.host +
            "/Invoice68/SendToTVAN?id=" +
            itemHdon.id +
            "&type=1";
          if (type == 2) {
            hostConfig =
              app.config.host +
              "/Invoice68/SendToTVAN?id=" +
              itemHdon.id +
              "&type=2";
          }
          webix.confirm({
            title: "GỬI HÓA ĐƠN",
            text:
              "Bạn có muốn gửi hóa đơn số: <span style='color: red'>" +
              itemHdon.shdon +
              "</span>",
            ok: "Có",
            cancel: "Không",
            callback: function (res) {
              if (res) {
                webix.extend(tableHdon, webix.ProgressBar);
                tableHdon.disable();
                tableHdon.showProgress();
                webix
                  .ajax()
                  .headers({ "Content-Type": "application/json" })
                  .get(hostConfig, function (text) {
                    var result = JSON.parse(text);
                    tableHdon.enable();
                    tableHdon.hideProgress();
                    if (result.code != "00") {
                      webix.message({ type: "error", text: result.message });
                      return;
                    } else {
                      webix.message(
                        "Gửi đến cơ quan thuế thành công",
                        "success"
                      );
                      var table = webix.$$("invoiceViews");
                      table.clearAll();
                      table.load(table.config.url);
                    }
                  });
              }
            },
          });
        },
      };
      return res;
    },
    btnExportExcel: function () {
      var res = {
        view: "button",
        type: "htmlbutton",
        width: 115,
        label: `<i class="fa fa-file-text-o fa-lg" aria-hidden="true"></i><span class="text">${_(
          "EXPORT_EXCEL"
        )}"</span>`,
        id: "btnExport",
        on: {
          onClick: function () {
            webix.callEvent("onLoadError");
            var box = webix.modalbox({
              title: "Đang kết suất Excel ... ",
              buttons: ["Hủy bỏ"],
              text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
              width: 350,
              height: 200,
              callback: function (result) {
                switch (result) {
                  case "0":
                    clearTimeout(interVal);
                    webix.modalbox.hide(box);
                    break;
                }
              },
            });
            var interVal = setTimeout(function () {
              var table = $$("invoiceViews");
              webix.toExcel(table, {
                filename: "danh sach hoa don",
                rawValues: true,
                filterHTML: true,
              });
              clearTimeout(interVal);
              webix.modalbox.hide(box);
            }, 1500);
          },
        },
        click: function () {
          this.callEvent("onClick");
        },
      };
      return res;
    },
    btnImportExcel78: function (excelModal) {
      var res = {
        view: "button",
        type: "htmlbutton",
        width: 100,
        label:
          '<i class="fa fa-file-excel-o fa-lg" aria-hidden="true"></i><span class="text"> ' +
          _("Nhận Excel") +
          "</span>",
        id: "btnImportExcelInvoice",
        on: {
          onClick: function () {
            webix.callEvent("onLoadError");
            var excelForm = this.$scope.ui(excelModal.$ui);
            excelForm.show();
          },
        },
        click: function () {
          this.callEvent("onClick");
        },
      };
      return res;
    },
    btnKyNhieuHoadon: function (signMultiForm, mode) {
      var res = {
        view: "button",
        type: "htmlbutton",
        width: 150,
        label: '<i class="fa fa-paper-plane fa-lg" aria-hidden="true"></i><span class="text"> ' + _("SIGN_SEND_MULTIPLE") + "</span>",
        tooltip: "Ký và gửi hàng loạt",
        id: "btnSignMulti",
        on: {
          onClick: function () {
            webix.callEvent("onLoadError");
            var table = webix.$$("invoiceViews");
            var signMulti = this.$scope.ui(signMultiForm.$ui);
            signMultiForm.setEditMode(mode);
            signMulti.show();
          },
        },
        click: function () {
          this.callEvent("onClick");
        },
      };
      return res;
    },
    btnSaveHoadonDieuChinh: function (params) {
      var res = {
        // Lưu hóa đơn điều chỉnh
        view: "button",
        id: "btnHoadonSaveDieuChinh",
        hidden: true,
        badge: "F10",
        css: "webix_primary",
        shortcut: "F10",
        label: "Lưu dữ liệu",
        type: "icon",
        align: "center",
        width: 130,
        click: function () {
          webix.callEvent("onLoadError");
          $$("hoadon68_chitiet").editStop();
          var item = $$("invoiceForms").getValues();
          var tableHoadon = $$("invoiceForms");
          var loaiHD = item.khieu.toString();
          var loai = loaiHD.substring(0, 1);

          if (!validateBeforeSave(item)) return;
          if (tableHoadon.validate()) {
            var dataDetails = $$("hoadon68_chitiet").serialize();
            if (!validateDetailBeforeSave(dataDetails, loai)) return;

            var views = webix.$$("invoiceViews");
            var hoadon_old = views.getSelectedItem();
            item["details"] = [{ data: dataDetails }];
            if (item["mauso_hd32"] != undefined)
              item["mauso_hd32"] = item["mauso_hd32"].toUpperCase();
            if (item["kyhieu_hd32"] != undefined)
              item["kyhieu_hd32"] = item["kyhieu_hd32"].toUpperCase();
            if (hoadon_old != undefined) {
              if (item.so_hd32 == undefined)
                item["hdlket_id"] = hoadon_old.hoadon68_id;
            }

            item["hoadon68_id"] = null;
            item["macqt"] = null;
            var data_post = { data: [item] };
            webix.extend(tableHoadon, webix.ProgressBar);
            tableHoadon.disable();
            tableHoadon.showProgress();
            webix
              .ajax()
              .headers({ "Content-type": "application/json" })
              .post(constant.API.INVOICE_DIEU_CHINH, data_post, {
                error: function (text, data, XmlHttpRequest) {
                  tableHoadon.enable();
                  tableHoadon.hideProgress();
                },
                success: function (text, data, XmlHttpRequest) {
                  var response = JSON.parse(text);
                  tableHoadon.enable();
                  tableHoadon.hideProgress();
                  if (response.code == "00") {
                    app.callEvent("dataChangedInvoie68", [1, response.data]);
                    webix.$$("invoice68").close();
                    $$("thaythehoadonForms").close();
                  } else {
                    webix.message(
                      response.code + ":" + response.message,
                      "error"
                    );
                  }
                },
              });
          }
        },
      };
      return res;
    },
    btnSaveHoadonThayThe: function (params) {
      var res = {
        // Lưu hóa đơn thay thế
        view: "button",
        id: "btnHoadonSaveThayThe",
        hidden: true,
        badge: "F10",
        css: "webix_primary",
        shortcut: "F10",
        label: "Lưu dữ liệu",
        type: "icon",
        align: "center",
        width: 130,
        click: function () {
          webix.callEvent("onLoadError");
          $$("hoadon68_chitiet").editStop();
          var item = $$("invoiceForms").getValues();
          var tableHoadon = $$("invoiceForms");
          var loaiHD = item.khieu.toString();
          var loai = loaiHD.substring(0, 1);

          if (!validateBeforeSave(item)) return;
          if (tableHoadon.validate()) {
            var dataDetails = $$("hoadon68_chitiet").serialize();
            if (!validateDetailBeforeSave(dataDetails, loai)) return;
            var views = webix.$$("invoiceViews");
            var hoadon_old = views.getSelectedItem();

            item["details"] = dataDetails;
            item["tthdon"] = 3;
            item["macqt"] = null;
            if (item["mauso_hd32"] != undefined)
              item["mauso_hd32"] = item["mauso_hd32"].toUpperCase();
            if (item["kyhieu_hd32"] != undefined)
              item["kyhieu_hd32"] = item["kyhieu_hd32"].toUpperCase();
            if (hoadon_old != undefined) {
              if (item.so_hd32 == undefined)
                // nếu không phải là đc tt cho 32 thì lấy hdlket_id
                item["hdlket_id"] = hoadon_old.hoadon68_id;
            }

            var data_post = { invoices: item };
            webix.extend(tableHoadon, webix.ProgressBar);
            tableHoadon.disable();
            tableHoadon.showProgress();
            webix
              .ajax()
              .headers({ "Content-Type": "application/json" })
              .post(constant.API.INVOICE_THAY_THE, data_post, {
                error: function (text, data, XmlHttpRequest) {
                  tableHoadon.enable();
                  tableHoadon.hideProgress();
                },
                success: function (text, data, XmlHttpRequest) {
                  var response = JSON.parse(text);
                  tableHoadon.enable();
                  tableHoadon.hideProgress();
                  if (response.code == "00") {
                    webix.$$("invoice68").close();
                    app.callEvent("dataChangedInvoie68", [1, response.data]);
                  } else {
                    webix.message(
                      response.code + ":" + response.message,
                      "error"
                    );
                  }
                },
              });
          }
        },
      };
      return res;
    },
    btnSaveHoadon: function () {
      var res = {
        shortcut: "F10",
        view: "button",
        id: "btnHoadonSave",
        badge: "F10",
        css: "webix_primary",
        label: "Lưu dữ liệu",
        type: "icon",
        align: "center",
        width: 130,
        on: {
          onClick: function () {
            webix.callEvent("onLoadError");
            $$("hoadon68_chitiet").editStop();
            var item = $$("invoiceForms").getValues();
            var parent = $$("invoice68");
            var editmode = parent.config.editmode;

            var loaiHD = item.khieu.toString();
            var loai = loaiHD.substring(0, 1);
            if (!validateBeforeSave(item)) return;

            var table = $$("invoiceForms");
            if (table.validate()) {
              if (item["mauso_hd32"] != undefined)
                item["mauso_hd32"] = item["mauso_hd32"].toUpperCase();
              if (item["kyhieu_hd32"] != undefined)
                item["kyhieu_hd32"] = item["kyhieu_hd32"].toUpperCase();
              var dataDetails = $$("hoadon68_chitiet").serialize();
              dataDetails.forEach(function (item) {
                if (loai == 2 || loai == 6) {
                  (item.tsuat = null), (item.ptthue = null), (item.tthue = 0);
                }
              });
              if (!validateDetailBeforeSave(dataDetails, loai)) return;
              var details = {
                tab_details: "hoadon68_chitiet",
                data: dataDetails,
              };
              item["details"] = [details];
              var menu_id = webix.storage.local.get("MENU_ID");
              var model = {
                tab_masters: "hoadon68",
                menu_id: menu_id,
                editmode: editmode,
                data: [item],
              };
              var messageData = validateMoney();
              frmYesNo(editmode, table, messageData, model);
            }
          },
        },
        click: function () {
          this.callEvent("onClick");
        },
      };
      return res;
    },
    btnSaveBienlai: function () {
      var res = {
        shortcut: "F10",
        view: "button",
        id: "btnHoadonSave",
        badge: "F10",
        css: "webix_primary",
        label: "Lưu dữ liệu",
        type: "icon",
        align: "center",
        width: 130,
        on: {
          onClick: function () {
            webix.callEvent("onLoadError");
            $$("hoadon68_chitiet").editStop();
            var item = $$("invoiceForms").getValues();
            var parent = $$("invoice68");
            var editmode = parent.config.editmode;

            var loaiHD = item.khieu.toString();
            var loai = loaiHD.substring(0, 1);
            if (!validateBeforeSave(item)) return;

            var table = $$("invoiceForms");
            if (table.validate()) {
              if (item["mauso_hd32"] != undefined)
                item["mauso_hd32"] = item["mauso_hd32"].toUpperCase();
              if (item["kyhieu_hd32"] != undefined)
                item["kyhieu_hd32"] = item["kyhieu_hd32"].toUpperCase();
              var dataDetails = $$("hoadon68_chitiet").serialize();
              dataDetails.forEach(function (item) {
                if (loai == 2 || loai == 6) {
                  (item.tsuat = null), (item.ptthue = null), (item.tthue = 0);
                }
              });
              if (!validateDetailBeforeSave(dataDetails, loai)) return;
              var details = {
                tab_details: "hoadon68_chitiet",
                data: dataDetails,
              };
              item["details"] = [details];
              var menu_id = webix.storage.local.get("MENU_ID");
              var model = {
                tab_masters: "hoadon68",
                menu_id: menu_id,
                editmode: editmode,
                data: [item],
              };
              var message = {
                code: 0,
                messageData: "<span style='color:#0069b4'>Bạn có muốn lưu biên lai này không?</span>"
              };
              frmYesNo(editmode, table, message, model);
            }
          },
        },
        click: function () {
          this.callEvent("onClick");
        },
      };
      return res;
    },
    btnSaveHoadon: function () {
      var res = {
        shortcut: "F10",
        view: "button",
        id: "btnHoadonSave",
        badge: "F10",
        css: "webix_primary",
        label: "Lưu dữ liệu",
        type: "icon",
        align: "center",
        width: 130,
        on: {
          onClick: function () {
            webix.callEvent("onLoadError");
            $$("hoadon68_chitiet").editStop();
            var item = $$("invoiceForms").getValues();
            var parent = $$("invoice68");
            var editmode = parent.config.editmode;

            var loaiHD = item.khieu.toString();
            var loai = loaiHD.substring(0, 1);
            if (!validateBeforeSave(item)) return;

            var table = $$("invoiceForms");
            if (table.validate()) {
              if (item["mauso_hd32"] != undefined)
                item["mauso_hd32"] = item["mauso_hd32"].toUpperCase();
              if (item["kyhieu_hd32"] != undefined)
                item["kyhieu_hd32"] = item["kyhieu_hd32"].toUpperCase();
              var dataDetails = $$("hoadon68_chitiet").serialize();
              dataDetails.forEach(function (item) {
                if (loai == 2 || loai == 6) {
                  (item.tsuat = null), (item.ptthue = null), (item.tthue = 0);
                }
              });
              if (!validateDetailBeforeSave(dataDetails, loai)) return;
              var details = {
                tab_details: "hoadon68_chitiet",
                data: dataDetails,
              };
              item["details"] = [details];
              var menu_id = webix.storage.local.get("MENU_ID");
              var model = {
                tab_masters: "hoadon68",
                menu_id: menu_id,
                editmode: editmode,
                data: [item],
              };
              var messageData = validateMoney();
              frmYesNo(editmode, table, messageData, model);
            }
          },
        },
        click: function () {
          this.callEvent("onClick");
        },
      };
      return res;
    },
    btnCancelHoadon: function (component) {
      var res = {
        view: "button",
        hotkey: "esc",
        label: "Hủy bỏ",
        badge: "ESC",
        css: "webix_danger",
        align: "center",
        type: "icon",
        width: 120,
        click: function () {
          $$("invoice68").close();
        },
      };
      return res;
    },
    subChucnang: function (huyhoadon, invoiceForms, dieuchinhhoadon, type, bangkeForm, hdonchietkhauForm) {
      function showMessage(msg, type) {
        webix.message(msg, type || "error");
      }

      function getTable() {
        var table = webix.$$("invoiceViews");
        if (!table) showMessage("Không tìm thấy bảng hóa đơn");
        return table;
      }

      function getSelectedItem() {
        var table = getTable();
        var item = table.getSelectedItem();
        if (!item) {
          showMessage("Bạn chưa chọn hóa đơn");
          return null;
        }
        return item;
      }

      function checkWaitState(item, msg) {
        if (item.tthai == "Chờ ký" || item.tthai == "Chờ duyệt") {
          showMessage(msg);
          return true;
        }
        return false;
      }

      var handlers = {
        huyhoadon: function () {
          var table = getTable();
          var item = getSelectedItem();
          if (!item) return;
          if (item.tthdon == 1) return showMessage("Hóa đơn đã Hủy bạn không thể Hủy thêm");
          if (checkWaitState(item, "Hóa đơn đang ở trạng thái chờ ký, không thể Hủy")) return;
          if ([2, 3, 6, 7].includes(item.is_tthdon) || [2, 3].includes(item.tthdon))
            return showMessage("Không được hủy hóa đơn có trạng thái Hủy, Thay thế, Điều chỉnh, Bị thay thế, Bị điều chỉnh");

          var otp = item.khieu.toString();
          var win = table.$scope.ui(huyhoadon.$ui);
          huyhoadon.setEditMode(1, otp[1]);
          huyhoadon.setValues({
            khieu: item.khieu,
            shdon: item.shdon,
            ngay: item.tdlap,
            ladhddt: 1,
            tctbao: 1,
            hoadon68_id: item.hoadon68_id,
            macqt: item.macqt,
          });
          win.show();
        },

        thaythe: function () {
          var table = getTable();
          var item = getSelectedItem();
          if (!item) return;
          if (![0, 3, 4].includes(item.tthdon))
            return showMessage("Chỉ được phép thay thế hóa đơn Gốc, hóa đơn Giải trình hoặc hóa đơn Thay thế");
          if (checkWaitState(item, "Hóa đơn đang ở trạng thái chờ ký, không thể thay thế")) return;

          var win = table.$scope.ui(invoiceForms.$ui);
          if (type != 6)
            componentHelper.changeDauphieuHoadon(table, type, item.khieu[4] === "M");
          invoiceForms.initUIThaythe(item);
          invoiceForms.setEditMode(1, getDoanhNghiepLoai());
          $$("btnChonHangHoa").show();
          win.show();
        },

        dowloadXml: function () {
          var table = getTable();
          var item = getSelectedItem();
          if (!item) return;
          if (item.tthai == "Chờ ký") return showMessage("Không thể tải XML!");

          webix.extend(table, webix.ProgressBar);
          table.disable(); table.showProgress();
          webix.ajax().response("arraybuffer").get(
            constant.API.INVOICE_EXPORT_XML + item.hoadon68_id,
            function (text, data) {
              table.enable(); table.hideProgress();
              var file = new Blob([data], { type: "application/xml" });
              webix.html.download(file, "InvoiceXml.xml");
            }
          );
        },

        dieuchinh: function () {
          var table = getTable();
          var item = getSelectedItem();
          if (!item) return;
          if (![0, 4, 7].includes(item.is_tthdon))
            return showMessage("Chỉ được Điều chỉnh hóa đơn Đã gửi, Đã ký");
          if (checkWaitState(item, "Chỉ cho phép điều chỉnh hóa đơn Mới, Giải trình, Bị điều chỉnh, Giải trình")) return;

          var win = table.$scope.ui(invoiceForms.$ui);
          if (type != 6)
            componentHelper.changeDauphieuHoadon(table, type, item.khieu[4] === "M");

          invoiceForms.initUIDieuchinh(null, null);
          invoiceForms.setEditMode(1, getDoanhNghiepLoai());

          $$("khieu").define("readonly", false);
          $$("khieu").define("css", "mcls_unreadonly");
          $$("khieu").refresh();

          webix.$$("btnHoadonSaveDieuChinh").show();
          webix.$$("btnHoadonSave").destructor();
          $$("btnChonHangHoa").show();
          win.show();
        },

        dieuchinh32: function () {
          var table = getTable();
          var win = table.$scope.ui(invoiceForms.$ui);
          invoiceForms.initUIDieuchinhTT32();
          invoiceForms.setEditMode(1, getDoanhNghiepLoai());
          win.show();
        },

        thaythe32: function () {
          var table = getTable();
          var win = table.$scope.ui(invoiceForms.$ui);
          invoiceForms.initUIThaytheTT32();
          invoiceForms.setEditMode(1, getDoanhNghiepLoai());
          win.show();
        },

        thaythe70: function () {
          var table = getTable();
          var win = table.$scope.ui(bangkeForm.$ui);
          bangkeForm.setEditMode(1, getDoanhNghiepLoai());
          win.show();
        },

        dieuchinh70: function () {
          var table = getTable();
          var win = table.$scope.ui(bangkeForm.$ui);
          bangkeForm.setEditMode(2, getDoanhNghiepLoai());
          win.show();
        },

        hdonchietkhau: function () {
          var table = getTable();
          var win = table.$scope.ui(hdonchietkhauForm.$ui);
          hdonchietkhauForm.setEditMode(1, getDoanhNghiepLoai());
          win.show();
        }
      };

      function getDoanhNghiepLoai() {
        var cctbao_id = $$("kyhieu_id").getValue();
        return $$("kyhieu_id").getList().getItem(cctbao_id).loai_doanh_nghiep;
      }

      return {
        view: "submenu",
        width: 300,
        padding: 0,
        data: [
          // {id: "huyhoadon",value: "Hủy hóa đơn",icon: "mdi mdi-file-document-remove-outline",},
          { id: "thaythe", value: "Lập hóa đơn thay thế", icon: "mdi mdi-file-replace-outline" },
          { id: "dieuchinh", value: "Lập HĐ điều chỉnh", icon: "mdi mdi-file-arrow-left-right-outline" },
          { $template: "Separator" },
          { id: "thaythe32", value: "Thay thế hóa đơn hệ thống khác", icon: "mdi mdi-file-replace-outline" },
          { id: "dieuchinh32", value: "Điều chỉnh hóa đơn hệ thống khác", icon: "mdi mdi-file-arrow-left-right-outline" },
          // { $template: "Separator" },
          // {id: "thaythe70",value: "Thay thế NHIỀU hóa đơn",icon: "mdi mdi-file-replace-outline",},
          // {id: "dieuchinh70",value: "Điều chỉnh NHIỀU hóa đơn",icon: "mdi mdi-file-arrow-left-right-outline",},
          { $template: "Separator" },
          { id: "hdonchietkhau", value: "Tạo hóa đơn chiết khấu", icon: "mdi mdi-file-arrow-left-right-outline" },
          { $template: "Separator" },
          { id: "dowloadXml", value: "Tải XML", icon: "mdi mdi-file-xml-box" }
        ],
        on: {
          onItemClick: function (id) {
            this.hide();
            if (handlers[id]) handlers[id]();
          }
        }
      };
    },
    subOption: function (excelModal, excelModalDetail, excelModalDetail0102294599, typeInvoice, hoadonCma) {
      const mst = version.getMST();
      const table = webix.$$("invoiceViews");

      const options = [
        { id: "excel", value: "Tạo hóa đơn từ file excel", icon: "mdi mdi-file-excel-outline" },
        { id: "excelDetail", value: "Nhận excel vào chi tiết hóa đơn", icon: "mdi mdi-file-document-plus-outline" },
        { $template: "Separator" },
        { id: "inchuyendoi", value: "In chuyển đổi hóa đơn", icon: "mdi mdi-printer-outline" },
        { id: "guihoadon", value: "Gửi hóa đơn đến CQT", icon: "mdi mdi-file-send-outline" },
        { $template: "Separator" },
        { id: "excelAccounting", value: "Kết xuất excel nhận vào phần mềm kế toán", icon: "mdi mdi-file-excel-outline" },
        { $template: "Separator" },
        { id: "convertInvoice", value: "Chuyển hóa đơn chờ ký sang ký hiệu mới", icon: "mdi mdi-file-move-outline" },
        { $template: "Separator" },
        { id: "checkInvoice", value: "Kiểm tra hóa đơn có lỗi", icon: "mdi mdi-checkbox-multiple-outline" },
      ];

      if (mst === "0102294599") {
        options.push({ id: "excel0102294599", value: "Nhận excel chi tiết 0102294599" });
      }

      const handlers = {
        excelAccounting: () => {
          webix.callEvent("onLoadError");
          table.$scope.ui(exportExcelAccounting.$ui).show();
        },
        excel: () => {
          webix.callEvent("onLoadError");
          const form = table.$scope.ui(excelModal.$ui);
          excelModal.setTypeInvoice(typeInvoice);
          form.show();
        },
        excelDetail: () => handleExcelDetail(excelModalDetail),
        excel0102294599: () => handleExcelDetail(excelModalDetail0102294599),
        inchuyendoi: () => inChuyenDoi(),
        guihoadon: () => guiCQT(hoadonCma),
        convertInvoice: () => table.$scope.ui(chuyenhoadonForm.$ui).show(),
        checkInvoice: () => handleCheckInvoice(),
      };

      function handleExcelDetail(modalDetail) {
        webix.callEvent("onLoadError");
        const item = table.getSelectedItem();
        if (!item) return showError("Bạn chưa chọn hóa đơn");
        if (!["Chờ ký", "Chờ duyệt"].includes(item.tthai)) return showError("Không thể cập nhật hóa đơn Đã ký !");
        table.$scope.ui(modalDetail.$ui).show();
      }

      function handleCheckInvoice() {
        const tableHdon = webix.$$("frmView");
        const cctbao_id = $$("kyhieu_id").getValue();
        webix.extend(tableHdon, webix.ProgressBar);
        tableHdon.disable();
        tableHdon.showProgress();

        webix.ajax()
          .headers({ "Content-type": "application/json" })
          .get(`${app.config.host}/Invoice68/GetListInvoiceError?id=${cctbao_id}`, {
            error: () => {
              tableHdon.enable();
              tableHdon.hideProgress();
            },
            success: (text) => {
              const data = JSON.parse(text);
              tableHdon.enable();
              tableHdon.hideProgress();
              webix.confirm({
                title: "HÓA ĐƠN",
                text: `Có: <span style='color: red'> ${fmMoney(data.data.length)} </span> hóa đơn lỗi. Bạn có muốn kiểm tra các hóa đơn này ?`,
                ok: "Có",
                cancel: "Không",
                callback: function (res) {
                  if (!res) return;
                  tableHdon.disable();
                  tableHdon.showProgress();

                  const promises = data.data.map(el =>
                    webix.ajax()
                      .headers({ "Content-Type": "application/json" })
                      .get(`${app.config.host}/Invoice68/FixInvoiceError?id=${el.hoadon68_id}&shdon=${el.shdon}`)
                      .then(resp => {
                        const json = resp.json();
                        loadingStatus(json.data.shdon, json.code, json.message);
                      })
                  );

                  Promise.all(promises).then(() => {
                    const gridInvoice = webix.$$("invoiceViews");
                    gridInvoice.clearAll();
                    gridInvoice.load(gridInvoice.config.url);
                    tableHdon.enable();
                    tableHdon.hideProgress();
                    webix.message("Kết thúc quá trình kiểm tra dữ liệu hóa đơn", "success", 3000);
                  });
                }
              });
            }
          });
      }

      const submenu = webix.ui({
        view: "submenu",
        width: 300,
        padding: 0,
        data: options,
        on: {
          onItemClick: function (id) {
            this.hide();
            const record = this.getItem(id);
            if (record && handlers[record.id]) {
              handlers[record.id]();
            }
            const fn = Function("_", "user", "idEx", record.on_click);
            fn(_, user, record.id);
          }
        }
      });

      const buttonExcel = webix.storage.local.get(constant.CACHE.BUTTON_EXCEL + typeInvoice);
      if (buttonExcel != null) {
        btnExcelCache(buttonExcel, options, submenu);
      } else {
        webix.ajax()
          .headers({ "Content-type": "application/json" })
          .get(constant.API.GET_BUTTON_EXCEL + typeInvoice, {
            success: function (text) {
              const arr = JSON.parse(text);
              btnExcelCache(arr, options, submenu);
              webix.storage.local.put(constant.CACHE.BUTTON_EXCEL + typeInvoice, arr);
            }
          });
      }

      const btnChucNang = {
        view: "button",
        type: "htmlbutton",
        width: 120,
        label: '<i class="fa fa-th fa-lg aria-hidden="true"></i> <span class="text">' + _("CHUC_NANG") + '</span>',
        id: "btnOptions",
        click: function () { submenu.show(webix.$$("btnOptions").$view); }
      };

      const index = $$("btnControl").index($$("btnChucNang"));
      $$("btnControl").addView(btnChucNang, index);
    },
    cbGetAll: function () {
      var res = {
        view: "checkbox",
        value: 0,
        width: 150,
        labelRight: "Xem toàn bộ HĐ",
        labelWidth: 0,
        id: "cbGetAll",
        on: {
          onClick: function () {
            webix.callEvent("onLoadError");
            var table = webix.$$("invoiceViews");
            clearFilter(table);
            table.clearAll();
            table.load(table.config.url);
          },
        },
        click: function () {
          this.callEvent("onClick");
        },
      };
      return res;
    },
    validateDetailBeforeSave: validateDetailBeforeSave,
    validateMoney: validateMoney,
    clearFilter: clearFilter
  };
});

define('views/forms/forms68/HDon/68_invoiceForms_02',[
    "app",
    "locale",
    "models/user",
    "views/modules/Component/componentHelper",
    "views/modules/Component/eventTableHelper",
    "views/modules/Component/button",
    "views/modules/Component/constantManager",
    "views/modules/Component/functionExtension",
], function (app, _, user, componentHelper, eventTableHelper, buttonOptions, constant, functionExtension) {
    var editmode = 0;
    var afteredit = "";
    var fm = webix.Number.numToStr({
        groupDelimiter: ",",
        groupSize: 3,
        decimalDelimiter: ".",
        decimalSize: 0
    });

    var quantity = 0;
    var inv_TotalAmountWithoutVat = 0;
    var inv_TotalAmount = 0;
    var inv_unitPrice = 0;
    var inv_vatAmount = 0;
    var fmNumeric = function (format_config, decimalOp) {
        format_config.editParse = function (value) {
            return webix.Number.parse(value, {
                groupSize: webix.i18n.groupSize,
                groupDelimiter: ".",
                // decimalSize: webix.i18n.decimalSize,
                decimalSize: decimalOp,
                // decimalDelimiter: webix.i18n.decimalDelimiter,
                decimalDelimiter: ","
            });
        };
        format_config.editFormat = function (value) {
            return webix.i18n.numberFormat(value, {
                groupDelimiter: ".",
                groupSize: 3,
                decimalDelimiter: ",",
                decimalSize: decimalOp
            });
        };

        format_config.format = webix.Number.numToStr({
            groupDelimiter: ".",
            groupSize: 3,
            decimalDelimiter: ",",
            decimalSize: decimalOp
        });
    };
    var tongtien = componentHelper.tongtienHDBH();
    var dauphieuHoadon = componentHelper.dauphieuHoadon(2);
    var btnChitietHoadon = componentHelper.btnChitietHoadon();
    var headTitleHoadon = componentHelper.headTitleHoadon("Hóa đơn bán hàng");
    var tienbangchu = componentHelper.tienbangchu();

    var btnSaveHoadon = buttonOptions.btnSaveHoadon();
    var btnCancelHoadon = buttonOptions.btnCancelHoadon();
    var btnSaveHoadonThayThe = buttonOptions.btnSaveHoadonThayThe();
    var btnSaveHoadonDieuChinh = buttonOptions.btnSaveHoadonDieuChinh();

    var colPtCk = componentHelper.numeric("tlckhau", "% CK", 3); colPtCk.hidden = true;
    var colTienCk = componentHelper.numeric("stckhau", "Tiền CK"); colTienCk.hidden = true;
    var mahanghoaHoadon = componentHelper.mahanghoaHoadon(6); mahanghoaHoadon.maxLength = 50;
    var colTienSauThue = componentHelper.numeric("tgtien", "Tiền sau thuế"); colTienSauThue.hidden = true;
    var colSoKhung = componentHelper.soKhung();
    var colSoMay = componentHelper.soMay();
    var colBienSoXe = componentHelper.bienSoXe();
    var colTenNguoiGui = componentHelper.tenNguoiGui();
    var colDcNguoiGui = componentHelper.diaChiNguoiGui();
    var colMstNguoiGui = componentHelper.mstNguoiGui();
    var colSddNguoiGui = componentHelper.sddNguoiGui();
    var windowId = "invoice68";
    var formId = "invoiceForms";
    var datatableDetail = "hoadon68_chitiet";

    return {
        $ui: {
            view: "window",
            modal: true,
            position: "center",
            css: "headformchil",
            head: headTitleHoadon,
            id: windowId,
            resize: true,
            fullscreen: true,
            move: true,
            on: {
                onBeforeShow: function () {
                    var type = 2;
                    var promise = eventTableHelper.OnBeforeShowForm(editmode, type);
                    if (typeof promise === 'string') {
                        afteredit = promise;
                    } else {
                        Promise.resolve(promise).then(function (value) {
                            afteredit = value.json().data;
                            webix.storage.local.put(`${constant.CACHE.AFTER_EDIT}${type}`, value.json().data);
                        })
                    }
                }
            },
            body: {
                paddingY: 10,
                paddingX: 10,
                elementsConfig: { labelWidth: 100 },
                view: "form",
                id: formId,
                width: 800,
                height: 500,
                complexData: true,
                margin: 0,
                on: {
                    // onViewShow: function () {

                    // }
                },
                rules: functionExtension.ValidateInvoice32(),
                elements: [
                    {
                        view: "scrollview",
                        scroll: "y",
                        body: {
                            paddingX: 18,
                            rows: [
                                dauphieuHoadon,
                                {
                                    borderless: true,
                                    view: "tabview",
                                    scrollX: true,
                                    tabbar: {
                                        width: 200
                                    },
                                    cells: [
                                        {
                                            header: "Chi tiết hóa đơn",
                                            select: "cell",
                                            body: {
                                                rows: [
                                                    btnChitietHoadon,
                                                    {
                                                        view: "datatable",
                                                        resizeColumn: true,
                                                        id: datatableDetail,
                                                        editable: true,
                                                        select: "cell",
                                                        minHeight: 150,
                                                        drag: true,
                                                        columns: [
                                                            { id: "stt", header: "", width: 30 },
                                                            mahanghoaHoadon,
                                                            {
                                                                id: "ten", header: _("Tên hàng hóa"), editor: "text", width: 350, editable: true,
                                                            },
                                                            componentHelper.donvitinhHoadon(),
                                                            componentHelper.numeric("sluong", "Số lượng"),
                                                            componentHelper.numeric("dgia", "Đơn giá"),
                                                            colPtCk,
                                                            colTienCk,
                                                            componentHelper.numeric("thtien", "Tiền trước thuế"),
                                                            colSoKhung,
                                                            colSoMay,
                                                            colBienSoXe,
                                                            colTenNguoiGui,
                                                            colDcNguoiGui,
                                                            colMstNguoiGui,
                                                            colSddNguoiGui,
                                                            colTienSauThue,
                                                            {
                                                                id: "tchat", name: "tchat",
                                                                header: "Tính chất", editable: false, width: 200, editor: "combo",
                                                                options: [
                                                                    { id: "1", value: "Hàng hóa dịch vụ" },
                                                                    { id: "2", value: "Khuyến mại" },
                                                                    { id: "3", value: "Chiết khấu thương mại" },
                                                                    { id: "4", value: "Ghi chú/ diễn giải" },
                                                                    { id: "5", value: "Hàng hóa đặc trưng" }
                                                                ]
                                                            },
                                                            {
                                                                id: "ctinh", name: "ctinh",
                                                                header: "Cách tính",
                                                                editable: false,
                                                                width: 200,
                                                                editor: "combo",
                                                                options: [
                                                                    { id: "1", value: "Tính xuôi" },
                                                                    { id: "2", value: "Tính ngược" }
                                                                ],
                                                                /* on:{
                                                                    onChange: function(newv,oldv) {

                                                                    }
                                                                } */
                                                            }
                                                        ],
                                                        on: {
                                                            "data->onStoreUpdated": function () {
                                                                this.data.each(function (obj, i) {
                                                                    obj.stt = i + 1;
                                                                })
                                                            },
                                                            onKeyPress: function (code, e) {
                                                                var table = this;
                                                                if (e.key == "F8") {
                                                                    $$("removerow").callEvent("onItemClick");
                                                                }
                                                                if (e.key == "F9") {
                                                                    $$("addrow").callEvent("onItemClick");
                                                                }
                                                                if (e.key == "F7") {
                                                                    $$("copyrow").callEvent("onItemClick");
                                                                }

                                                            },
                                                            onAfterLoad: function () {
                                                                var table = this;
                                                                var data = table.serialize();
                                                                data.forEach(function (entry) {
                                                                    if (entry["stckhau"] != undefined || entry["tlckhau"] != undefined) {
                                                                        if (entry["stckhau"] != 0) {

                                                                            var ck = $$("check_chietkhau");
                                                                            if (ck != undefined) {
                                                                                ck.setValue(1);
                                                                                return false;
                                                                                // $$("edit_" + tab.tab_table).showColumn("inv_discountAmount");
                                                                                // $$("edit_" + tab.tab_table).showColumn("inv_discountPercentage");
                                                                            }
                                                                        }
                                                                    }
                                                                });
                                                            },
                                                            onCheck: function (row, column, state) {
                                                                var table = this;
                                                                if (column == "khuyen_mai") {

                                                                    if (state == true) {
                                                                        // var selectedItem = table.getItem(row);
                                                                        // table.updateItem(selectedItem.id, selectedItem);
                                                                        // table.callEvent("onAfterAdd");
                                                                    }
                                                                }

                                                            },
                                                            onAfterAdd: function (id, index) {
                                                                var table = $$(this.config.id);
                                                                var data = table.serialize();

                                                                // var format_config = table.getColumnConfig("sluong");
                                                                // fmNumeric(format_config, quantity);
                                                                // var tien_tt = table.getColumnConfig("thtien");
                                                                // fmNumeric(tien_tt, inv_TotalAmountWithoutVat);

                                                                // var don_gia = table.getColumnConfig("dgia");
                                                                // fmNumeric(don_gia, inv_unitPrice);
                                                                // var tong_tien = table.getColumnConfig("tgtien");
                                                                // fmNumeric(tong_tien, inv_TotalAmount);

                                                                var tong_tien_tt_dp = 0;
                                                                var tong_tien_thue_dp = 0
                                                                var tong_tien_ck_dp = 0;
                                                                var tong_tien_dp = 0
                                                                data.forEach(function (entry) {

                                                                    tong_tien_tt_dp += entry["tien_tt"] == null ? 0 : entry["tien_tt"];
                                                                    tong_tien_thue_dp += entry["tien_thue"] == null ? 0 : entry["tien_thue"];
                                                                    tong_tien_ck_dp += entry["tien_ck"] == null ? 0 : entry["tien_ck"];
                                                                    tong_tien_dp += entry["tong_tien"] == null ? 0 : entry["tong_tien"];

                                                                    // $$("inv_Invoice_tien_tt").setValue(tong_tien_tt_dp);
                                                                    // $$("inv_Invoice_tien_ck").setValue(tong_tien_ck_dp);
                                                                    // $$("inv_Invoice_tien_thue").setValue(tong_tien_thue_dp);
                                                                    // $$("inv_Invoice_tong_tien").setValue(tong_tien_dp);

                                                                });
                                                            },
                                                            onAfterEditStop: function (state, editor, ignore) {
                                                                //eventTableHelper.AfterEdit(this, state, editor, ignore);
                                                                var fn = Function("columnId", "tableId", "rowId", afteredit);
                                                                fn(editor.config.id, this.config.id, editor.row);
                                                            },
                                                            onValidationError: function (id, obj, details) {
                                                                eventTableHelper.ValidateError(this, id, obj, details);
                                                            },
                                                            onAfterEditStart: function (cell) {
                                                                if (cell.column == "ten") {
                                                                    this.getEditor().getInputNode().setAttribute("maxlength", 500);
                                                                }
                                                            },
                                                            onBeforeEditStart: function (obj) {
                                                                return eventTableHelper.BeforEditRow(this, obj);
                                                            }
                                                        },
                                                        rules: {
                                                            "tchat": webix.rules.isNotEmpty,
                                                            $obj: webix.rules.validateMoney
                                                        },
                                                        ready: function () {
                                                            this.validate();
                                                        }
                                                    }
                                                ]
                                            }
                                        }
                                    ]
                                },
                                {
                                    css: "regiontongtien",
                                    rows: [
                                        tongtien,
                                        tienbangchu,
                                        { height: 10 }
                                    ]
                                },
                                { height: 10 },
                                {
                                    margin: 10,
                                    cols: [
                                        {},
                                        btnSaveHoadonDieuChinh,
                                        btnSaveHoadonThayThe,
                                        btnSaveHoadon,
                                        btnCancelHoadon,
                                        {}
                                    ]
                                }
                            ]
                        }
                    }
                ]
            }
        },
        setValues: function (item, winconfig, params) {
            var win = $$(this.$ui.id);
            var form = win.getChildViews()[1];
            // nếu hóa đơn là điều chỉnh, thay thế thì add các cột thông tin vào
            if (item.tthdon == 2 || item.tthdon == 3) {
                // var vanbanComponent = componentHelper.vanbanHoadon();
                // $$("info-invoice").addView(vanbanComponent, 0);
                // set title cho hóa đơn điều chỉnh, thay thế
                if (item != null) {
                    var url = app.config.host + "/Invoice68/GetInvoiceById?id=" + item.hdlket_id;
                    webix.ajax()
                        .headers({ 'Content-type': 'application/json' })
                        .get(url, function (text) {
                            var data = JSON.parse(text);

                            if (data.code == "00") {
                                if (item.tthdon == 2) {
                                    webix.$$("head-formInvoice").setHTML("Hóa đơn điều chỉnh cho hóa đơn số "
                                        + data.data.shdon + " ký hiệu " + data.data.khieu);
                                    webix.$$("head-formInvoice").refresh();
                                }
                                if (item.tthdon == 3) {
                                    webix.$$("head-formInvoice").setHTML("Hóa đơn thay thế cho hóa đơn số "
                                        + data.data.shdon + " ký hiệu " + data.data.khieu);
                                    webix.$$("head-formInvoice").refresh();
                                }
                            }

                        });

                }

            }
            if (item != null) {
                item["tdlap"] = removeTimeZoneT(item["tdlap"]);
                item["ngayvb"] = removeTimeZoneT(item["ngayvb"]);
                form.setValues(item);

                var tableDetail = webix.$$("hoadon68_chitiet");
                var url = app.config.host + "/Invoice68/GetDetailInvoice?id=" + item.id;
                tableDetail.clearAll();
                tableDetail.load(url);
            }



            if (editmode == 2) {

            }
            // nếu có mẫu 04 (hóa đơn thay thế cũ)
            if (winconfig != null) {
                mau04 = winconfig;
                var cctbao_id = $$("kyhieu_id").getValue();
                var khieu = $$("kyhieu_id").getText();
                var form = $$("invoiceForms");
                var values = form.getValues();
                values["khieu"] = khieu;
                form.setValues(values);
                $$("btnHoadonSaveThayThe").show();
                // $$("btnHoadonCQT").destructor();
                $$("btnHoadonSave").destructor();
            }

        },
        setEditMode: function (mode, loai_doanh_nghiep) {
            editmode = mode;
            var form = $$(this.$ui.id);
            form.config.editmode = mode;
            var icon = "";
            switch (editmode) {
                case 1:
                    icon = "<span><i class='fa fa-plus' aria-hidden='true'></i></span>";
                    break;
                case 2:
                    icon = "<i class='fa fa-edit' aria-hidden='true'></i>";
                    break;
                default:
                    icon = "<i class='fa fa-trash fa-lg' aria-hidden='true'></i>";
                    break;
            };
            webix.$$("head-iconInvoice").setHTML(icon);
            webix.$$("head-iconInvoice").refresh();
            var formDetail = $$(datatableDetail);
            switch (loai_doanh_nghiep) {
                case 2:
                    formDetail.showColumn("skhung");
                    formDetail.showColumn("smay");
                    break;
                case 3:
                    formDetail.showColumn("bien_sxe");
                    break;
                case 4:
                    formDetail.showColumn("ten_ngui");
                    formDetail.showColumn("dc_ngui");
                    formDetail.showColumn("mst_ngui");
                    formDetail.showColumn("sddanh_ngui");
                    break;
            }
        },
        copyValues: function (item) {
            eventTableHelper.InvoiceCopy(item);
        },
        initUINew: function (cctbao_id, khieu) {
            $$("cctbao_id").setValue(cctbao_id);
            var form = $$("invoiceForms");
            var values = form.getValues();
            values["khieu"] = khieu;
            form.setValues(values);

        },
        initUIDieuchinh: function (dataDetail, hdlket_id) {
            eventTableHelper.InvoiceAdjustment();
        },
        initUIThaythe: function (invoiceBase) {
            eventTableHelper.InvoiceReplacement(invoiceBase);
        },
        initUIThaytheTT32: function () {
            eventTableHelper.InvoiceReplacement32();
        },
        initUIDieuchinhTT32: function () {
            eventTableHelper.InvoiceAdjustment32();
        },
        initUIHoaDonChietKhau: function (data) {
            webix.$$("head-formInvoice").setHTML("Hóa đơn chiết khấu đính kèm bảng kê");
            webix.$$("head-formInvoice").refresh();
            eventTableHelper.InvoiceDiscount(data, formId, datatableDetail);
        }
    };

});

define('views/forms/forms68/HDon/68_invoiceForms',[
    "app",
    "locale",
    "models/user",
    "views/modules/Component/componentHelper",
    "views/modules/Component/eventTableHelper",
    "views/modules/Component/button",
    "views/modules/Component/constantManager",
    "views/modules/Component/functionExtension",
], function (app, _, user, componentHelper, eventTableHelper, buttonOptions, constant, functionExtension) {
    var editmode = 0;
    var afteredit = "";
    var quantity = 0;
    var inv_TotalAmountWithoutVat = 0;
    var inv_TotalAmount = 0;
    var inv_unitPrice = 0;
    var inv_vatAmount = 0;
    var fmNumeric = function (format_config, decimalOp) {
        format_config.editParse = function (value) {
            return webix.Number.parse(value, {
                groupSize: webix.i18n.groupSize,
                groupDelimiter: ".",
                // decimalSize: webix.i18n.decimalSize,
                decimalSize: decimalOp,
                // decimalDelimiter: webix.i18n.decimalDelimiter,
                decimalDelimiter: ","
            });
        };
        format_config.editFormat = function (value) {
            return webix.i18n.numberFormat(value, {
                groupDelimiter: ".",
                groupSize: 3,
                decimalDelimiter: ",",
                decimalSize: decimalOp
            });
        };

        format_config.format = webix.Number.numToStr({
            groupDelimiter: ".",
            groupSize: 3,
            decimalDelimiter: ",",
            decimalSize: decimalOp
        });
    };

    var dauphieuHoadon = componentHelper.dauphieuHoadon();
    var btnChitietHoadon = componentHelper.btnChitietHoadon();
    var headTitleHoadon = componentHelper.headTitleHoadon("Hóa đơn giá trị gia tăng");

    var tongtien = componentHelper.tongtien();
    var tongtienDetail = componentHelper.tongtienDetail();
    var tienbangchu = componentHelper.tienbangchu();

    var btnSaveHoadon = buttonOptions.btnSaveHoadon();
    var btnCancelHoadon = buttonOptions.btnCancelHoadon();
    var btnSaveHoadonThayThe = buttonOptions.btnSaveHoadonThayThe();
    var btnSaveHoadonDieuChinh = buttonOptions.btnSaveHoadonDieuChinh();

    var mahanghoaHoadon = componentHelper.mahanghoaHoadon();
    mahanghoaHoadon.maxLength = 50;

    var colPtCk = componentHelper.numeric("tlckhau", "% CK", 3); colPtCk.hidden = true;
    var colTienCk = componentHelper.numeric("stckhau", "Tiền CK"); colTienCk.hidden = true;
    var colTienThue = componentHelper.numeric("tthue", "Tiền thuế");
    var colTienSauThue = componentHelper.numeric("tgtien", "Tiền sau thuế");
    var colSoKhung = componentHelper.soKhung();
    var colSoMay = componentHelper.soMay();
    var colBienSoXe = componentHelper.bienSoXe();
    var colTenNguoiGui = componentHelper.tenNguoiGui();
    var colDcNguoiGui = componentHelper.diaChiNguoiGui();
    var colMstNguoiGui = componentHelper.mstNguoiGui();
    var colSddNguoiGui = componentHelper.sddNguoiGui();
    var windowId = "invoice68";
    var formId = "invoiceForms";
    var datatableDetail = "hoadon68_chitiet";

    return {
        $ui: {
            view: "window",
            modal: true,
            position: "center",
            css: "headformchil",
            head: headTitleHoadon,
            id: windowId,
            resize: true,
            fullscreen: true,
            move: true,
            on: {
                onBeforeShow: function () {
                    var type = 1;
                    var promise = eventTableHelper.OnBeforeShowForm(editmode, type);
                    if (typeof promise === 'string') {
                        afteredit = promise;
                    } else {
                        Promise.resolve(promise).then(function (value) {
                            afteredit = value.json().data;
                            webix.storage.local.put(`${constant.CACHE.AFTER_EDIT}${type}`, value.json().data);
                        })
                    }
                }
            },
            body: {
                paddingY: 10,
                paddingX: 10,
                elementsConfig: { labelWidth: 100 },
                view: "form",
                id: formId,
                width: 800,
                height: 500,
                complexData: true,
                margin: 0,
                on: {
                    // onViewShow: function () {

                    // }
                },
                rules: functionExtension.ValidateInvoice32(),
                elements: [
                    {
                        view: "scrollview",
                        scroll: "y",
                        body: {
                            paddingX: 18,
                            rows: [
                                dauphieuHoadon,
                                {
                                    borderless: true,
                                    view: "tabview",
                                    scrollX: true,
                                    tabbar: {
                                        width: 200
                                    },
                                    cells: [
                                        {
                                            header: "Chi tiết hóa đơn",
                                            select: "cell",
                                            body: {
                                                rows: [
                                                    btnChitietHoadon,
                                                    {
                                                        view: "datatable",
                                                        resizeColumn: true,
                                                        id: datatableDetail,
                                                        editable: true,
                                                        select: "cell",
                                                        minHeight: 150,
                                                        drag: true,
                                                        columns: [
                                                            { id: "stt", header: "", width: 30 },
                                                            { id: "stt_rec", header: "STT", width: 40, editable: true, editor: "text" },
                                                            mahanghoaHoadon,
                                                            {
                                                                id: "ten", header: _("Tên hàng hóa"), editor: "text", width: 350, editable: true,
                                                            },
                                                            componentHelper.donvitinhHoadon(),
                                                            componentHelper.numeric("sluong", "Số lượng"),
                                                            componentHelper.numeric("dgia", "Đơn giá"),
                                                            colPtCk,
                                                            colTienCk,
                                                            componentHelper.numeric("thtien", "Tiền trước thuế"),
                                                            {
                                                                id: "tsuat",
                                                                header: _("Thuế suất"), width: 100,
                                                                editor: "combo",
                                                                editable: true,
                                                                value: "0",
                                                                options: app.config.host + "/Invoice68/GetVAT"
                                                            },
                                                            colTienThue,
                                                            colTienSauThue,
                                                            colSoKhung,
                                                            colSoMay,
                                                            colBienSoXe,
                                                            colTenNguoiGui,
                                                            colDcNguoiGui,
                                                            colMstNguoiGui,
                                                            colSddNguoiGui,
                                                            {
                                                                id: "tchat", name: "tchat",
                                                                header: "Tính chất", editable: false, width: 200, editor: "combo",
                                                                options: [
                                                                    { id: "1", value: "Hàng hóa dịch vụ" },
                                                                    { id: "2", value: "Khuyến mại" },
                                                                    { id: "3", value: "Chiết khấu thương mại" },
                                                                    { id: "4", value: "Ghi chú/ diễn giải" },
                                                                    { id: "5", value: "Hàng hóa đặc trưng" }
                                                                ]
                                                            },
                                                            {
                                                                id: "ctinh", name: "ctinh",
                                                                header: "Cách tính",
                                                                editable: false,
                                                                width: 200,
                                                                editor: "combo",
                                                                options: [
                                                                    { id: "1", value: "Tính xuôi" },
                                                                    { id: "2", value: "Tính ngược" }
                                                                ],
                                                                /* on:{
                                                                    onChange: function(newv,oldv) {

                                                                    }
                                                                } */
                                                            }
                                                        ],
                                                        on: {
                                                            "data->onStoreUpdated": function () {
                                                                this.data.each(function (obj, i) {
                                                                    obj.stt = i + 1;
                                                                })
                                                            },
                                                            onKeyPress: function (code, e) {
                                                                var table = this;
                                                                if (e.key == "F8") {
                                                                    $$("removerow").callEvent("onItemClick");
                                                                }
                                                                if (e.key == "F9") {
                                                                    $$("addrow").callEvent("onItemClick");
                                                                }
                                                                if (e.key == "F7") {
                                                                    $$("copyrow").callEvent("onItemClick");
                                                                }

                                                            },
                                                            onAfterLoad: function () {
                                                                var table = this;
                                                                var data = table.serialize();
                                                                data.forEach(function (entry) {
                                                                    if (entry["stckhau"] != undefined || entry["tlckhau"] != undefined) {
                                                                        if (entry["stckhau"] != 0) {

                                                                            var ck = $$("check_chietkhau");
                                                                            if (ck != undefined) {
                                                                                ck.setValue(1);
                                                                                return false;
                                                                            }
                                                                        }
                                                                    }
                                                                });
                                                            },
                                                            onCheck: function (row, column, state) {
                                                                var table = this;
                                                                if (column == "khuyen_mai") {
                                                                    if (state == true) {
                                                                    }
                                                                }
                                                            },
                                                            onAfterAdd: function (id, index) {
                                                                var table = $$(this.config.id);
                                                                var data = table.serialize();
                                                                var tong_tien_tt_dp = 0;
                                                                var tong_tien_thue_dp = 0
                                                                var tong_tien_ck_dp = 0;
                                                                var tong_tien_dp = 0
                                                                data.forEach(function (entry) {
                                                                    tong_tien_tt_dp += entry["tien_tt"] == null ? 0 : entry["tien_tt"];
                                                                    tong_tien_thue_dp += entry["tien_thue"] == null ? 0 : entry["tien_thue"];
                                                                    tong_tien_ck_dp += entry["tien_ck"] == null ? 0 : entry["tien_ck"];
                                                                    tong_tien_dp += entry["tong_tien"] == null ? 0 : entry["tong_tien"];
                                                                });
                                                            },
                                                            onAfterEditStop: function (state, editor, ignore) {
                                                                // eventTableHelper.AfterEdit(this, state, editor, ignore);
                                                                var fn = Function("columnId", "tableId", "rowId", afteredit);
                                                                fn(editor.config.id, this.config.id, editor.row);
                                                            },
                                                            onValidationError: function (id, obj, details) {
                                                                eventTableHelper.ValidateError(this, id, obj, details);
                                                            },
                                                            onAfterEditStart: function (cell) {
                                                                if (cell.column == "ten") {
                                                                    this.getEditor().getInputNode().setAttribute("maxlength", 500);
                                                                }
                                                            },
                                                            onBeforeEditStart: function (obj) {
                                                                return eventTableHelper.BeforEditRow(this, obj);
                                                            }
                                                        },
                                                        rules: {
                                                            "tchat": webix.rules.isNotEmpty,
                                                            $obj: webix.rules.validateMoney
                                                        },
                                                        ready: function () {
                                                            this.validate();
                                                        }
                                                    }
                                                ]
                                            }
                                        }
                                    ]
                                },
                                {
                                    css: "regiontongtien",
                                    rows: [
                                        tongtien,
                                        {
                                            view: "accordion",
                                            multi: true,
                                            borderless: true,
                                            type: "clean",
                                            css: "tongtienChitiet",
                                            rows: [ //or cols 
                                                { header: " + Tổng tiền chi tiết", css: "ttChitiet", collapsed: true, body: tongtienDetail }
                                            ]
                                        },
                                        tienbangchu,
                                        { height: 10 }
                                    ]
                                },
                                { height: 10 },
                                {
                                    margin: 10,
                                    cols: [
                                        {},
                                        btnSaveHoadonDieuChinh,
                                        btnSaveHoadonThayThe,
                                        btnSaveHoadon,
                                        btnCancelHoadon,
                                        {}
                                    ]
                                }
                            ]
                        }
                    }
                ]
            }
        },
        setValues: function (item, winconfig, params) {
            var win = $$(this.$ui.id);
            var form = win.getChildViews()[1];
            // nếu hóa đơn là điều chỉnh, thay thế thì add các cột thông tin vào
            if (item.tthdon == 2 || item.tthdon == 3) {
                // var vanbanComponent = componentHelper.vanbanHoadon();
                // $$("info-invoice").addView(vanbanComponent, 0);
                // set title cho hóa đơn điều chỉnh, thay thế
                if (item != null) {
                    var url = app.config.host + "/Invoice68/GetInvoiceById?id=" + item.hdlket_id;
                    webix.ajax()
                        .headers({ 'Content-type': 'application/json' })
                        .get(url, function (text) {
                            var data = JSON.parse(text);

                            if (data.code == "00") {
                                if (item.tthdon == 2) {
                                    webix.$$("head-formInvoice").setHTML("Hóa đơn điều chỉnh cho hóa đơn số "
                                        + data.data.shdon + " ký hiệu " + data.data.khieu);
                                    webix.$$("head-formInvoice").refresh();
                                }
                                if (item.tthdon == 3) {
                                    webix.$$("head-formInvoice").setHTML("Hóa đơn thay thế cho hóa đơn số "
                                        + data.data.shdon + " ký hiệu " + data.data.khieu);
                                    webix.$$("head-formInvoice").refresh();
                                }
                            }

                        });

                }

            }
            if (item != null) {
                item["tdlap"] = removeTimeZoneT(item["tdlap"]);
                item["ngayvb"] = removeTimeZoneT(item["ngayvb"]);
                form.setValues(item);

                var tableDetail = webix.$$("hoadon68_chitiet");
                var url = app.config.host + "/Invoice68/GetDetailInvoice?id=" + item.id;
                tableDetail.clearAll();
                tableDetail.load(url);
            }

            if (editmode == 2) {

            }
            // nếu có mẫu 04 (hóa đơn thay thế cũ)
            if (winconfig != null) {
                mau04 = winconfig;
                var cctbao_id = $$("kyhieu_id").getValue();
                var khieu = $$("kyhieu_id").getText();
                var form = $$("invoiceForms");
                var values = form.getValues();
                values["khieu"] = khieu;
                form.setValues(values);
                $$("btnHoadonSave").destructor();
            }

        },
        setEditMode: function (mode, loai_doanh_nghiep) {
            editmode = mode;
            var form = $$(this.$ui.id);
            form.config.editmode = mode;
            var icon = "";
            switch (editmode) {
                case 1:
                    icon = "<span><i class='fa fa-plus' aria-hidden='true'></i></span>";
                    break;
                case 2:
                    icon = "<i class='fa fa-edit' aria-hidden='true'></i>";
                    break;
                default:
                    icon = "<i class='fa fa-trash fa-lg' aria-hidden='true'></i>";
                    break;
            };
            webix.$$("head-iconInvoice").setHTML(icon);
            webix.$$("head-iconInvoice").refresh();
            var formDetail = $$(datatableDetail);
            switch (loai_doanh_nghiep) {
                case 2:
                    formDetail.showColumn("skhung");
                    formDetail.showColumn("smay");
                    break;
                case 3:
                    formDetail.showColumn("bien_sxe");
                    break;
                case 4:
                    formDetail.showColumn("ten_ngui");
                    formDetail.showColumn("dc_ngui");
                    formDetail.showColumn("mst_ngui");
                    formDetail.showColumn("sddanh_ngui");
                    break;
            }
        },
        copyValues: function (item) {
            eventTableHelper.InvoiceCopy(item);
        },
        initUINew: function (cctbao_id, khieu) {
            $$("cctbao_id").setValue(cctbao_id);
            var form = $$("invoiceForms");
            var values = form.getValues();
            values["khieu"] = khieu;
            form.setValues(values);
        },
        initUIDieuchinh: function (dataDetail, hdlket_id) {
            eventTableHelper.InvoiceAdjustment();
        },
        initUIThaythe: function (invoiceBase) {
            eventTableHelper.InvoiceReplacement(invoiceBase);
        },
        initUIThaytheTT32: function () {
            eventTableHelper.InvoiceReplacement32();
        },
        initUIDieuchinhTT32: function () {
            eventTableHelper.InvoiceAdjustment32();
        },
        initUIDieuchinhTT32Edit: function () {
            webix.$$("head-formInvoice").setHTML("Hóa đơn điều chỉnh");
            webix.$$("head-formInvoice").refresh();
            var info = componentHelper.dcttHoadon32(2);
            $$("info-customer").addView(info, 10);
        },
        initUIHoaDonChietKhau: function (data) {
            webix.$$("head-formInvoice").setHTML("Hóa đơn chiết khấu đính kèm bảng kê");
            webix.$$("head-formInvoice").refresh();
            eventTableHelper.InvoiceDiscount(data, formId, datatableDetail);
        }
    };
});

define('views/forms/forms68/HDon/68_huyhoadon',[
    "app",
    "locale",
    "models/user",
    "views/forms/forms68/HDon/68_invoiceForms",
    "views/modules/Component/functionExtension"
], function (app, _, user, invoiceForms, functionExtension) {
    'use strict';

    var editmode = 0;
    var editCheck = ""; // C là hóa đơn có mã, K là hóa đơn không mã

    return {
        $ui: {
            view: "window",
            modal: true,
            position: "center",
            css: "headformchil",
            head: {
                height: 35,
                cols: [
                    { id: "head-icondksd", view: "template", css: "headform", width: 35, template: "" },
                    { id: "head-formdksd", view: "template", css: "headform", template: function (obj) { return '<div>Thông báo hóa đơn điện tử có sai sót<div/>'; } },
                    { view: "icon", icon: "fas fa-question-circle", id: "help_dksdForms", tooltip: _("HELPER"), click: function () { } }
                ]
            },
            id: "huyhoadonForms",
            resize: true,
            width: 1300,
            height: 600,
            // fullscreen: true,
            move: true,
            on: {
                onBeforeShow: function () {
                }
            },
            body: {
                view: "form",
                id: "huyhoadon",
                // width: 1500,
                position: "center",
                // autowidth:true,
                paddingY: 10,
                paddingX: 15,
                complexData: true,
                elementsConfig: { labelWidth: 170 },
                scroll: true,
                margin: 0,
                elements: [
                    { template: "<center><b><span style='font-size:17px;'>THÔNG BÁO HÓA ĐƠN CÓ SAI SÓT</b></center>", borderless: true, height: 40 },
                    {
                        paddingX: 10,
                        rows: [
                            {
                                view: "combo",
                                label: "Loại thông báo",
                                value: 1,
                                options: [
                                    { id: "1", value: "Thông báo hủy/giải trình của NNT" },
                                    { id: "2", value: "Thông báo hủy/giải trình của NNT theo thông báo của CQT" }
                                ],
                                attributes: { readonly: true },
                                id: "loai_tbao", name: "loai_tbao",
                                required: true, invalidMessage: "Kính gửi không được để trống !"
                            },
                            {
                                view: "text", label: "Cơ quan thuế tiếp nhận ", id: "tcqt", name: "tcqt",
                                required: true,
                                invalidMessage: "Kính gửi không được để trống !"
                            },
                            {
                                view: "label",
                                borderless: true,
                                css: { "color": "red" },
                                template: "<span>Lưu ý: để thông báo hóa đơn sai sót Quý khách hàng cần cập"
                                    + " nhật đúng mã cơ quan thuế quản lý <a style='color: blue; 'text-decoration': 'underline'>tại đây<a></span>",
                                on: {
                                    onItemClick: function () {
                                        app.router('app/infocompany');
                                    }
                                }
                            },
                            {
                                view: "text", label: "Tên người nộp thuế",
                                required: true, invalidMessage: "Tên người nộp thuế không được để trống !",
                                id: "tnnt", name: "tnnt"
                            },
                            {
                                view: "text", label: "Mã số thuế", id: "mst", name: "mst", required: true,
                                invalidMessage: "Mã số thuế không được để trống !",
                            },
                            {
                                cols: [
                                    {
                                        view: "datepicker", label: "Ngày lập",
                                        value: new Date(),
                                        required: true, invalidMessage: "Ngày lập không được để trống !",
                                        id: "ntbao", name: "ntbao"
                                    },
                                    {
                                        view: "text", label: "Nơi lập",
                                        required: true, invalidMessage: "Nơi lập không được để trống !",
                                        id: "ddanh", name: "ddanh"
                                    }
                                ]
                            }
                        ]
                    },
                    { height: 3 },
                    {
                        template: "<b><span >Người nộp thuế thông báo về việc hủy/ giải trình hóa đơn điện tử do sai sót như sau:</b>", borderless: true, height: 40
                    },
                    { height: 3 },
                    {
                        rows: [
                            {
                                view: "datatable",
                                id: "danhsach_hoadonhuy",
                                name: "danhsach_hoadonhuy",
                                resizeColumn: true,
                                footer: false,
                                tooltip: true,
                                editable: true,
                                select: "cell",
                                scheme: {
                                    $init: function (obj) {

                                    },
                                },
                                on: {
                                    "data->onStoreUpdated": function () {
                                        this.data.each(function (obj, i) {
                                            obj.stt = i + 1;
                                        });
                                    },
                                    onBeforeEditStart: function (obj) {
                                        var lstColumn = new Array("stt", "khieu", "shdon", "ladhddt", "ngay", "huygiaitrinh", "tctbao");
                                        if (lstColumn.indexOf(obj.column) >= 0)
                                            return false;
                                    },
                                    onValidationError: function (id, obj, details) {
                                        var index = this.getIndexById(id) + 1;
                                        webix.message({ type: "error", text: "Bạn chưa nhập Mã cơ quan thuế, hoặc lý do, tại dòng " + index });
                                    }
                                },
                                columns: [
                                    { editor: "text", id: "hoadon68_id", name: "hoadon68_id", hidden: true },
                                    { id: "stt", name: "stt", header: "STT", sort: "int", width: 40, },
                                    {
                                        id: "khieu", header: _("Ký hiệu hóa đơn điện tử"),
                                        editor: "text", width: 150, editable: true,
                                        suggest: {
                                            view: "gridsuggest",
                                            columnName: "ky_hieu",
                                            body: {
                                                columns: [{ "id": "id", "hidden": true, "header": "id" }, { "id": _("khieu"), "width": 120, "header": "khieu" }, { "id": _("shdon"), "width": 350, "header": "shdon" }],
                                                scroll: true,
                                                autoheight: false,
                                                datatype: "json",
                                                dataFeed: function (filtervalue, filter) {
                                                    if (filtervalue.length < 1) return;
                                                    var pathUrl = app.config.host + "/System/GetDataByReferencesId?id=29f51d47-8bf6-4b32-a679-52e75b8cacc8";
                                                    var urldata = "filtervalue=" + encodeURIComponent(filtervalue);
                                                    this.load(pathUrl + "&" + urldata, this.config.datatype);
                                                }
                                            },
                                            on: {
                                                onValueSuggest: function (obj) {
                                                    var table = $$("danhsach_hoadonhuy");
                                                    var selectedItem = table.getSelectedItem();
                                                    selectedItem["shdon"] = obj["shdon"];
                                                    selectedItem["ngay"] = obj["nlap"];
                                                    selectedItem["huygiaitrinh"] = 1;
                                                    selectedItem["hoadon68_id"] = obj["hoadon68_id"];;
                                                    table.updateItem(selectedItem.id, selectedItem);

                                                }
                                            }
                                        }
                                    },
                                    { id: "shdon", name: "shdon", header: "Số hóa đơn điện tử", width: 150, editor: "text", },
                                    {
                                        id: "ngay", name: "ngay", header: "Ngày lập hóa đơn", width: 150, editor: "text",
                                        //format: webix.i18n.dateFormatStr,
                                    },
                                    {
                                        id: "ladhddt", name: "ladhddt",
                                        header: "Loại áp dụng hóa đơn điện tử", editable: false, width: 200, editor: "combo",
                                        options: [
                                            { id: "1", value: "Hóa đơn điện tử theo NĐ 123/2020" },
                                            { id: "2", value: "HĐĐT có mã của cơ quan thuế" },
                                            { id: "3", value: "Các loại hóa đơn theo Nghị đinh 51/2010" }
                                        ]
                                    },
                                    {
                                        id: "tctbao", name: "tctbao",
                                        header: "Hủy/ giải trình", editable: false, width: 150, editor: "combo",
                                        options: [
                                            { id: "1", value: "Hủy" },
                                            { id: "3", value: "Thay thế" },
                                            { id: "4", value: "Giải trình " }
                                        ]
                                    },
                                    { id: "ldo", name: "ldo", header: "Lý do", editable: true, editor: "text", width: 150 },
                                    { id: "macqt", name: "macqt", header: "Mã CQT", editable: true, editor: "text", width: 150, fillspace: true }
                                ],
                                rules: {
                                    //"macqt": webix.rules.isNotEmpty,
                                    "ldo": webix.rules.isNotEmpty
                                },
                                ready: function () {
                                    this.validate();
                                }
                            }
                        ]
                    },
                    {
                        id: "btnHuyHDDT",
                        cols: [
                            {},
                            {
                                view: "button",
                                id: "btnStep299",
                                label: "Lưu, chuyển sang bước tiếp theo",
                                type: "form",
                                hidden: true,
                                align: "center",
                                click: function () {
                                    var item = $$("huyhoadon").getValues();
                                    var details = [];
                                    details.push({ data: $$("danhsach_hoadonhuy").serialize() });
                                    item["details"] = details;
                                    var item1 = [];
                                    item1.push(item);
                                    var data_post = { khieu: "", editmode: editmode, data: item1 };
                                    var detailForm = this.$scope.ui(invoiceForms.$ui);
                                    var cctbao_id = webix.$$("kyhieu_id").getValue();
                                    invoiceForms.initUINew(cctbao_id);
                                    invoiceForms.setEditMode(1);
                                    invoiceForms.setValues(null, data_post, null);
                                    detailForm.show();
                                }
                            },
                            {
                                shortcut: "F10",
                                view: "button",
                                id: "btnGhiHuyhoadon",
                                label: "Ghi (F10)",
                                width: 150,
                                align: "center",
                                type: "form",
                                on: {
                                    onClick: function () {
                                        var item = $$("huyhoadon").getValues();
                                        var table = $$("huyhoadon");
                                        if ($$("danhsach_hoadonhuy").validate()) {
                                            var cks = $$("danhsach_hoadonhuy").serialize();
                                            if (cks.length == 0) {
                                                webix.message("Bạn chưa nhập thông tin hóa đơn cần hủy !", "error");
                                                return;
                                            }
                                            var dataDetail = $$("danhsach_hoadonhuy").serialize();
                                            if (editCheck == "C") {
                                                var i = 0;
                                                dataDetail.forEach(function (entry, count) {
                                                    if (entry["macqt"] == null || entry["macqt"] == "") {
                                                        webix.message("Mã cơ quan thuế không được để trống tại dòng " + (Number(count) + 1), "error");
                                                        i++;
                                                        return;
                                                    }
                                                });
                                                if (i > 0) {
                                                    return;
                                                }
                                            }

                                            webix.extend(table, webix.ProgressBar);
                                            table.disable();
                                            table.showProgress();

                                            var details = [];
                                            details.push({ "tab_details": "mau04_chitiet", data: $$("danhsach_hoadonhuy").serialize() });
                                            item["details"] = details;

                                            item["mau04_chitiets"] = $$("danhsach_hoadonhuy").serialize();
                                            webix.ajax()
                                                .headers({ 'Content-type': 'application/json' })
                                                .post(app.config.host + "/CancelInvoice/Mau04SaveChange", item, {
                                                    error: function (text, data, XmlHttpRequest) {
                                                        table.enable();
                                                        table.hideProgress();
                                                    }, success: function (text, data, XmlHttpRequest) {
                                                        var response = JSON.parse(text);
                                                        table.enable();
                                                        table.hideProgress();
                                                        if (response.code != "00") {
                                                            webix.message(response.code + " :" + response.message, "error");
                                                        }
                                                        else {
                                                            app.callEvent("dataChangedInvoie68", [editmode, null]);
                                                            webix.$$("huyhoadonForms").close();
                                                            webix.message("Tạo thông báo 04/SS-HDDT thành công", "success");
                                                            functionExtension.Sign04SS(response.data, $$("frmView"));
                                                        }
                                                    }
                                                });
                                        }
                                    }
                                },
                                click: function () {
                                    this.callEvent("onClick");
                                }
                            },
                            {
                                shortcut: "F4",
                                view: "button",
                                id: "btnSaveSignGiaiTrinh",
                                label: "Lưu (F4)",
                                width: 150,
                                hidden: true,
                                align: "center",
                                type: "form",
                                on: {
                                    onClick: function () {
                                        var item = $$("huyhoadon").getValues();
                                        var table = $$("huyhoadon");

                                        if (table.validate()) {
                                            var cks = $$("danhsach_hoadonhuy").serialize();
                                            if (cks.length == 0) {
                                                webix.message("Bạn chưa nhập thông tin hóa đơn cần hủy !", "error");
                                                return;
                                            }

                                            webix.extend(table, webix.ProgressBar);
                                            table.disable();
                                            table.showProgress();

                                            var details = [];
                                            details.push({ "tab_details": "mau04_chitiet", data: $$("danhsach_hoadonhuy").serialize() });
                                            item["details"] = details;

                                            var item1 = [];
                                            item1.push(item);
                                            var data_post = { editmode: editmode, "tab_masters": "mau04", data: item1 };

                                            webix.ajax()
                                                .headers({ 'Content-type': 'application/json' })
                                                .post(app.config.host + "/Pattern/Save", data_post, {
                                                    error: function (text, data, XmlHttpRequest) {
                                                        table.enable();
                                                        table.hideProgress();
                                                        webix.message(text + XmlHttpRequest, "error");

                                                    }, success: function (text, data, XmlHttpRequest) {
                                                        var json = JSON.parse(text);
                                                        table.enable();
                                                        table.hideProgress();
                                                        if (json.code != "00") {
                                                            webix.message(json.code + " :" + json.message, "error");
                                                        }
                                                        else {
                                                            app.callEvent("dataChangedInvoie68", [editmode, null]);
                                                            webix.message("Thành công !", "success");
                                                            webix.$$("huyhoadonForms").close();
                                                        }
                                                    }
                                                });
                                        }
                                    }
                                },
                                click: function () {
                                    this.callEvent("onClick");
                                }
                            },
                            {
                                view: "button", hotkey: "esc", label: "Hủy bỏ (ESC)", width: 120, type: "danger", align: "center",
                                click: function () {
                                    webix.$$("huyhoadonForms").close();
                                }
                            },
                            {}
                        ]
                    }
                ]
            }
        },
        setEditMode: function (mode, otpCheck) {
            editmode = mode;
            editCheck = otpCheck;
            var form = $$(this.$ui.id);
            form.config.editmode = mode;
            var icon = "";
            if (editmode == 1) {
                icon = "<span><i class='fa fa-plus' aria-hidden='true'></i></span>";
                var result = webix.ajax().sync().get(app.config.host + "/System/GetCurrentDmdvcs");
                var json = JSON.parse(result.response);
                $$("tnnt").setValue(json[0].ten_dvcs);
                $$("mst").setValue(json[0].ms_thue);
                $$("tcqt").setValue(json[0].ten);
                $$("ddanh").setValue(json[0].tinh_thanh);
            }
            else {
                if (editmode == 2)
                    icon = "<i class='fa fa-edit' aria-hidden='true'></i>";
                else
                    icon = "<i class='fa fa-trash fa-lg' aria-hidden='true'></i>";
            }
            webix.$$("head-icondksd").setHTML(icon);
            webix.$$("head-icondksd").refresh();
        },
        setValues: function (item, winconfig, params) {
            $$("danhsach_hoadonhuy").parse(item);
        }
    };
});
define('views/forms/forms68/HDon/68_dieuchinhhoadon',[
    "app",
    "locale",
    "models/user",
    "views/forms/forms68/HDon/68_invoiceForms"
], function (app, _, user, invoiceForms) {
    'use strict';

    var editmode = 0;
    var hdlket_id;
    var fm = function (number) {
        var k = webix.Number.numToStr({
            groupDelimiter: ".",
            groupSize: 3,
            decimalDelimiter: ",",
            decimalSize: 0
        });
        return k(number);
    }
    return {
        $ui: {
            view: "window",
            modal: true,
            position: "center",
            css: "headformchil",
            head: {
                height: 35,
                cols: [
                    { id: "head-icondieuchinhhoadon", view: "template", css: "headform", width: 35, template: "" },
                    { id: "head-formdieuchinhhoadon", view: "template", css: "headform", template: function (obj) { return '<div>Điều chỉnh hóa đơn<div/>'; } },
                    { view: "icon", icon: "fas fa-question-circle", id: "help_dksdForms", tooltip: _("HELPER"), click: function () { } }
                ]
            },
            id: "thaythehoadonForms",
            resize: true,
            width: 900,
            height: 500,
            // fullscreen: true,
            move: true,
            on: {
                onBeforeShow: function () {
                }
            },
            body: {
                view: "form",
                id: "dchoadon",
                position: "center",
                paddingY: 10,
                paddingX: 15,
                complexData: true,
                scroll: true,
                margin: 0,
                elements: [
                    {
                        // id: "header",
                        template: "<center><b><span style='font-size:17px;'>Chọn mặt hàng cần điều chỉnh</b></center>", borderless: true, height: 40
                    },
                    { height: 3 },
                    {
                        rows: [
                            {
                                view: "datatable",
                                id: "danhsach_hdthaythe",
                                // height: 250,
                                name: "danhsach_hdthaythe",
                                // select: true,
                                resizeColumn: true,
                                footer: false,
                                tooltip: true,
                                editable: false,
                                select: "row",
                                scheme: {
                                    $init: function (obj) {

                                    },
                                },
                                on: {
                                    "data->onStoreUpdated": function () {
                                        this.data.each(function (obj, i) {
                                            obj.stt = i + 1;
                                        });
                                    },
                                    onBeforeEditStart: function (id) {
                                        // if (id.column == "stt") {     // block editors in 'year' column
                                        //     return false;
                                        // } else if (id.column == "khieu") {
                                        //     return false;
                                        // } else if (id.column == "shdon") {
                                        //     return false;
                                        // } else if (id.column == "ladhddt") {
                                        //     return false;
                                        // }
                                        // else if (id.column == "ngay") {
                                        //     return false;
                                        // }
                                        // else if (id.column == "huygiaitrinh") {
                                        //     return false;
                                        // }
                                        // else if (id.column == "tctbao") {
                                        //     return false;
                                        // }
                                    }
                                },
                                columns: [
                                    { editor: "text", id: "hoadon68_id", name: "hoadon68_id", hidden: true },
                                    { editor: "text", id: "hoadon68_chitiet_id", name: "hoadon68_chitiet_id", hidden: true },
                                    {
                                        id: "chon",
                                        header: _("CHON"),
                                        width: 65,
                                        checkValue: true,
                                        uncheckValue: false,
                                        template: "{common.checkbox()}"
                                    },
                                    { id: "stt", name: "stt", header: "STT", sort: "int", width: 40, },
                                    { id: "ma", name: "ma", header: "Mã hàng", width: 140, editor: "text" },
                                    { id: "ten", name: "ten", header: "Tên hàng", width: 140, editor: "text" },
                                    { id: "mdvtinh", name: "mdvtinh", header: "ĐVT", width: 140, editor: "text" },
                                    { id: "sluong", name: "sluong", header: "Số lượng", width: 140, editor: "numeric" },
                                    {
                                        id: "dgia", header: "Đơn giá", width: 150, css: { "text-align": "right" }, columnType: "numeric",
                                        template: function (obj, common) {
                                            return obj.dgia == null ? 0 : fm(obj.dgia);
                                        }
                                    },
                                    {
                                        id: "thtien", header: "Thành tiền", width: 150, css: { "text-align": "right" }, columnType: "numeric",
                                        template: function (obj, common) {
                                            return obj.thtien == null ? 0 : fm(obj.thtien);
                                        }
                                    },
                                    {
                                        id: "tthue", header: "Tiền thuế", width: 150, css: { "text-align": "right" }, columnType: "numeric",
                                        template: function (obj, common) {
                                            return obj.tthue == null ? 0 : fm(obj.tthue);
                                        }
                                    },
                                    {
                                        id: "tgtien", header: "Tổng tiền", width: 150, css: { "text-align": "right" }, columnType: "numeric",
                                        template: function (obj, common) {
                                            return obj.tgtien == null ? 0 : fm(obj.tgtien);
                                        }
                                    },
                                ]
                            }
                        ]
                    },
                    {
                        id: "btnHuyHDDT",
                        cols: [
                            {},
                            {
                                view: "button",
                                id: "btnStep299",
                                label: "Tiếp theo",
                                width: 120,
                                type: "form",
                                align: "center",
                                click: function () {
                                    // var btnEdit = $$("btnPlus");
                                    // btnEdit.callEvent("onClick");
                                    var table = $$("danhsach_hdthaythe");
                                    var data = table.serialize();

                                    var dataDetail = [];

                                    for (var i = 0; i < data.length; i++) {
                                        if (data[i].chon == true) {
                                            data[i].hoadon68_id = null;
                                            data[i].hoadon68_chitiet_id = null;
                                            dataDetail.push(data[i]);
                                            //break;
                                        }
                                    }
                                    if (dataDetail.length <= 0) {
                                        webix.message("Bạn chưa chọn mặt hàng cần điều chỉnh", "debug");
                                        return;
                                    }

                                    var detailForm = this.$scope.ui(invoiceForms.$ui);

                                    var cctbao_id = webix.$$("kyhieu_id").getValue();
                                    var khieu = webix.$$("kyhieu_id").getText();
                                    //invoiceForms.initUINew(cctbao_id, khieu);
                                    invoiceForms.initUIDieuchinh(dataDetail, hdlket_id);
                                    invoiceForms.setEditMode(1);

                                    $$("khieu").define("readonly", false);
                                    $$("khieu").define("css", "mcls_unreadonly");
                                    $$("khieu").refresh();

                                    webix.$$("btnHoadonSaveDieuChinh").show();
                                    webix.$$("btnHoadonSave").destructor();
                                    detailForm.show();

                                    // $$("thaythehoadonForms").close();
                                }
                            },
                            {
                                view: "button",
                                hotkey: "esc",
                                label: "Hủy bỏ (ESC)",
                                width: 120,
                                type: "danger",
                                align: "center",
                                click: function () {
                                    webix.$$("thaythehoadonForms").close();
                                }
                            },
                            {}
                        ]
                    }
                ]
            }
        },
        setEditMode: function (mode, id) {
            var table = webix.$$("invoiceViews");
            var item = table.getSelectedItem();
            editmode = mode;
            hdlket_id = id;
            var form = $$(this.$ui.id);
            //var topParentView = form.getTopParentView();
            form.config.editmode = mode;
            var icon = "";
            if (editmode == 1) {
                icon = "<span><i class='fa fa-plus' aria-hidden='true'></i></span>";
                var result = webix.ajax().sync().get(app.config.host + "/Invoice68/GetDetailInvoice?id=" + id);
                var json = JSON.parse(result.response);
                $$("danhsach_hdthaythe").parse(json);

            }
            else {
                if (editmode == 2)
                    icon = "<i class='fa fa-edit' aria-hidden='true'></i>";
                else
                    icon = "<i class='fa fa-trash fa-lg' aria-hidden='true'></i>";
            }

            webix.$$("head-icondieuchinhhoadon").setHTML(icon);
            webix.$$("head-icondieuchinhhoadon").refresh();
            webix.$$("head-formdieuchinhhoadon").setHTML("Điều chỉnh hóa đơn số " + item.shdon + " ký hiệu " + item.khieu);
            webix.$$("head-formdieuchinhhoadon").refresh();
        },
        setValues: function (item, winconfig, params) {
            $$("danhsach_hdthaythe").parse(item);
        }
    };
});
define('views/forms/forms68/HDon/68_sendEmailForm',["app",
	"locale",
	"views/forms/forms68/68_viewsLogEmail",
	"views/modules/Component/constantManager",
	"views/modules/Component/functionExtension",
],
	function (app, _, viewLogEmail, CONSTANTS, functionExtension) {
		var editmode = 0;
		return {
			$ui: {
				view: "window", modal: true, id: "dmtab-win", position: "center", move: true,
				head: {
					height: 40,
					cols: [
						{ id: "head-iconInvoice", view: "template", css: "headform", width: 35, template: "<span><i class='fa fa-paper-plane' aria-hidden='true'></i></span>" },
						{ id: "head-form", view: "template", css: "headform", template: function (obj) { return '<div>Gửi hóa đơn cho khách hàng qua email<div/>'; } },
						{ view: "icon", icon: "fas fa-question-circle", id: "help_form", tooltip: _("HELPER"), click: function () { } }
					]
				},
				fullscreen: true,
				css: "headformchil",
				keepViews: true,
				move: true,
				on: {
					onBeforeShow: function () {
						webix.ajax().sync().get(app.config.host + CONSTANTS.API.GET_EMAIL_OPTIONS, function (text) {
							$$("otpMail").setValue(text);
						});
					}
				},
				body: {
					paddingY: 5,
					paddingX: 5,
					view: "form",
					id: "dmtab-form",
					on: {
					},
					elements: [
						{
							view: "fieldset",
							label: "Thông tin gửi mail",
							body: {
								rows: [
									{
										view: 'checkbox',
										id: "otpMail",
										label: "Sử dụng email của M-Invoice để gửi đi", labelPosition: "left",
										labelWidth: 230, tooltip: "Tích vào đây nếu bạn muốn email gửi đi sử dụng email của M-Invoice ! Gửi email bằng mail hệ thống của M-Invoice sẽ theo dõi được email gửi thành công hay không, người nhận đã xem email bạn gửi hay chưa.",
										on: {
											onChange: function (newv, oldv) {
												if (newv == 1) {
													$$("fromName").define("readonly", true);
													$$("fromName").define("css", "mcls_readonly_text");
													$$("fromName").setValue("***");
													$$("fromName").refresh();

													$$("passMail").define("readonly", true);
													$$("passMail").define("css", "mcls_readonly_text");
													$$("passMail").setValue("***");
													$$("passMail").refresh();
												}
												if (newv == 0) {
													var table = webix.$$("invoiceViews");
													var selectedItem = table.getSelectedItem();
													var dataPost = {
														id: selectedItem.hoadon68_id,
														type: "Gửi hóa đơn"
													};
													var url = "/Invoice68/GetEmailTemplate";
													webix.ajax()
														.headers({ 'Content-type': 'application/json' })
														.post(app.config.host + url, dataPost, function (text) {
															var data = JSON.parse(text);
															var json = data.data;
															$$("fromName").setValue(json.nguoi_gui);
															$$("fromName").define("readonly", false);
															webix.html.removeCss($$("fromName").$view, "mcls_readonly_text");
															$$("fromName").refresh();

															$$("passMail").setValue(json.pass);
															$$("passMail").define("readonly", false);
															webix.html.removeCss($$("passMail").$view, "mcls_readonly_text");
															$$("passMail").refresh();
														});
												}
											}
										}
									},
									{
										cols: [
											{
												view: "text",
												id: "fromName",
												name: "nguoi_gui",
												label: _("NGUOI_GUI"),
												labelPosition: "top",
												required: true,
												validate: webix.rules.isNotEmpty,
												invalidMessage: "Người gửi không được để trống !"
											}, {
												view: "text",
												id: "passMail",
												name: "mat_khau",
												label: _("PASSWORD"),
												type: "password",
												labelPosition: "top",
												required: true,
												validate: webix.rules.isNotEmpty,
												invalidMessage: "Mật khẩu không được để trống !"
											}
										]
									},
									{
										cols: [
											{
												view: "text",
												name: "nguoinhan",
												id: "nguoinhan",
												label: _("NGUOI_NHAN"),
												keyPressTimeout: 100,
												labelPosition: "top",
												placeholder: "Nhập email người nhận, nhiều hơn 1 email thì cách nhau bằng dấu phẩy (,)",
												required: true,
												validate: webix.rules.isNotEmpty,
												invalidMessage: "Người nhận không được để trống !",
												maxLength: 250,
												on: {
													onTimedKeyPress: function () {
														var value = this.getValue();
														if (value.length > 250) {
															webix.message("Email người nhận không được quá 250 ký tự !", "error");
														}
														var countMail = $$("nguoinhan").getValue().split(/[\s,\;]+/);
														if (countMail.length > 5) {
															webix.message("Bạn không được phép gửi quá 5 Email."
																+ " Vui lòng liên hệ nhà cung cấp để được giải đáp.", "debug");
															return;
														}
													},
												}
											},
											{ view: "text", name: "bcc", label: "BCC", labelPosition: "top" }
										]
									},
									{ view: "text", name: "tieude", label: _("TIEU_DE"), labelPosition: "top", }
								]
							}
						},
						{
							view: "label",
							name: "his_email",
							id: "his_email",
							template: function (obj) {
								if (obj.value == 0) return "<span style='color:blue'>Hóa đơn chưa gửi cho khách hàng !</span>";
								return "<span style='color:blue'>Hóa đơn đã được gửi <big>" + obj.value + " </big> lần ! <span class='bg-success badge me-2'> Lịch sử gửi email <i class='fa fa-hand-o-left' aria-hidden='true'></i></span></span>"
							},
							on: {
								onItemClick: function () {
									var item = webix.$$("invoiceViews").getSelectedItem();
									item.apiHost = CONSTANTS.API.SEND_EMAIL_LOG;
									item.typeView = "INVOICE";
									var detailForm = $$("dmtab-win").$scope.ui(viewLogEmail.$ui);
									viewLogEmail.setValues(item);
									detailForm.show();
								}
							}
						},
						{
							name: "noidung", view: "ckeditor", keepViews: true, label: _("NOI_DUNG"), labelPosition: "top",
						},
						{
							margin: 10,
							cols: [
								{},
								{
									shortcut: "F10", view: "button", label: "Nhận (F10)", type: "form", align: "center", width: 120,
									on: {
										onClick: function () {
											var form = webix.$$("dmtab-form");
											var itemData = form.getValues();
											const tempDiv = document.createElement("div");
											tempDiv.innerHTML = itemData.noidung;
											const textContent = tempDiv.textContent.replace(/\u00A0/g, '').trim();

											if (textContent === "") {
												webix.message("Nội dung không được để trống hoặc chỉ chứa khoảng trắng!");
												return;
											}
											itemData.otpmail = $$("otpMail").getValue();
											var url = app.config.host + CONSTANTS.API.SEND_EMAIL;
											var countMail = $$("nguoinhan").getValue().split(/[\s,\;]+/);
											var patt = /\S+@[^@\s]+\.[^@\s]+$/;
											var nguoinhan = [];
											for (i = 0; i < countMail.length; i++) {
												if (countMail[i] != "" && !patt.test(countMail[i])) {
													webix.message("Email người nhận không hợp lệ (tồn tại chuỗi không phải email)!", "error");
													return;
												} else if (patt.test(countMail[i])) {
													nguoinhan.push(countMail[i]);
												}
											}
											itemData.nguoinhan = nguoinhan.join(",");
											itemData.scret = functionExtension.SaltEmail(itemData.nguoinhan);
											if (nguoinhan.length > 5) {
												webix.message("Bạn không được phép gửi quá 5 Email. Vui lòng liên hệ nhà cung cấp để được giải đáp.", "debug");
												return;
											}
											else {
												if ($$("dmtab-form").validate()) {
													webix.extend(form, webix.ProgressBar);
													form.disable();
													form.showProgress();
													webix.ajax()
														.headers({ 'Content-type': 'application/json' })
														.post(url, itemData, {
															error: function (text, data, XmlHttpRequest) {
																var form = webix.$$("dmtab-form");
																form.enable();
																form.hideProgress();
																alert(text);
															},
															success: function (text, data, XmlHttpRequest) {
																var form = webix.$$("dmtab-form");
																form.enable();
																form.hideProgress();
																var data = JSON.parse(text);
																if (data.code == "00") {
																	webix.message("Gửi Email thành công !", "debug");
																	webix.$$("dmtab-win").close();
																}
																else {
																	webix.message(data.message, "error");
																}
															}
														});
												}
												else {
													$$("nguoinhan").focus();
												}
											}
										}
									},
									click: function () {
										this.callEvent("onClick");
									}
								},
								{
									view: "button", hotkey: "esc", label: "Hủy bỏ (ESC)", type: "danger", align: "center", width: 120,
									click: function () {
										webix.$$("dmtab-win").close();
									}
								},
								{}
							]
						}
					]
				}
			},
			setEditMode: function (mode) {
				editmode = mode;
			},
			setValues: function (values) {
				$$("dmtab-form").setValues(values);
			}
		};
	});

define('views/forms/forms68/HDon/68_kynhieuhoadon',[
    "app",
    "locale",
    "models/user",
    "views/modules/minvoiceplugin",
    "views/forms/signCloudMulti",
    "views/modules/Component/ajaxHelper",
    "views/modules/Component/constantManager",
    "views/modules/Component/functionExtension"
],
    function (app, _, user, plugin, signCloudMulti, Ajax, Constant, functionExtension) {
        var editmode = 0; // 1 là có mã, 2 là ko mã
        var windowId = "chukyso-win";
        var formId = "chukyso-form";
        var tableId = "tblHoadon";
        var message_nodata = "Không có dữ liệu";

        var layout = {
            view: "window", modal: true, resize: true, id: windowId, position: "center", move: true, css: "headformchil",
            head: {
                height: 40,
                cols: [
                    { id: "head-form", view: "template", css: "headform", template: function (obj) { return '<div>Ký hóa đơn chờ ký<div/>'; } },
                    { view: "icon", icon: " fa-question-cifasrcle", id: "help_form", tooltip: _("HELPER"), click: function () { } }
                ]
            },
            minWidth: 600,
            minHeight: 600,
            on: {
                onBeforeShow: function () {
                    webix.ajax().headers({ 'Content-type': 'application/json' })
                        .post(app.config.host + "/System/ExecuteCommand", {
                            command: "CM00019",
                            parameter: {
                                ma_dvcs: ""
                            }
                        }, {
                            error: function (text, data, XmlHttpRequest) {

                            },
                            success: function (text, data, XmlHttpRequest) {
                                var c_result = JSON.parse(text);
                                for (var i = 0; i < c_result.length; i++) {
                                    var item = c_result[i];
                                    if (item.ma == "KYTAPTRUNG") {
                                        $$(windowId).config.kytaptrung = item.gia_tri;
                                    }
                                    if (item.ma == "SERVER_CERT") {
                                        $$(windowId).config.server_cert = item.gia_tri;
                                    }
                                }
                            }
                        });
                    Ajax.GET(Constant.API.INVOICE_TYPE_CREATE_NUMBER).then((data) => {
                        $$(windowId).config.sinhsosau = data;
                    })
                }
            },
            body: {
                paddingY: 10,
                paddingX: 10,
                view: "form",
                id: "chukyso-form",
                complexData: true,
                margin: 0,
                elements: [
                    {
                        cols: [
                            { view: "datepicker", name: "tu_ngay", format: "%d/%m/%Y", label: "Từ ngày", labelPosition: "top", value: new Date(), editable: true },
                            { view: "datepicker", name: "den_ngay", format: "%d/%m/%Y", label: "Đến ngày", labelPosition: "top", value: new Date(), editable: true },
                        ]
                    },
                    {
                        view: "combo",
                        name: "quanlykyhieu68_id",
                        label: "Ký hiệu",
                        labelPosition: "top",
                        required: true,
                        invalidMessage: "Ký hiệu hóa đơn không được để trống !",
                        options:
                        {
                            view: "gridsuggest",
                            url: app.config.host + "/Invoice68/GetTypeInvoiceSeries",
                            body: {
                                scroll: true,
                                autoheight: false,
                                autofocus: true,
                                yCount: 10,
                                columns: [
                                    { id: "value", header: _("KY_HIEU"), width: 150 },
                                    {
                                        id: "date_new", header: _("Ngày tạo"), width: 150,
                                        format: function (text) {
                                            var format = webix.Date.dateToStr("%d/%m/%Y");
                                            text = removeTimeZoneT(text);
                                            return format(text);
                                        }
                                    },
                                ]
                            }
                        },
                        on: {
                            onChange: function (newv, oldv) {
                                var item = this.getPopup().getList().getItem(newv);
                                if (item.hthuc == "C") {
                                    $$("btnSignNotSend").disable();
                                    $$("btnSignNotSend").refresh();
                                }
                                else {
                                    $$("btnSignNotSend").enable();
                                    $$("btnSignNotSend").refresh();
                                    webix.ajax()
                                        .headers({ "Content-type": "application/text" })
                                        .get(app.config.host + "/Register68/GetLastRegister", function (text, data, XmlHttpRequest) {
                                            var response = JSON.parse(text);
                                            if (response.data == "F11") {
                                                $$("btnSignNotSend").disable();
                                                $$("btnSignNotSend").refresh();
                                            }
                                            if (response.data == "F10") {
                                                $$("btnNhan").disable();
                                                $$("btnNhan").refresh();
                                            }
                                        });
                                }
                            },
                            onBeforeRender: function () {
                            },
                        }
                        // validate: webix.rules.isEmpty
                    },
                    {
                        view: "combo",
                        name: "cerSerial",
                        label: "Chứng thư số",
                        labelPosition: "top",
                        id: "txtCerSerial",
                        required: true,
                        invalidMessage: "Chứng thư số không được để trống !",
                        options: {
                            view: "gridsuggest",
                            url: app.config.host + "/Invoice/GetListCertificatesAuto",
                            // template:"#subjectname#",
                            body: {
                                columns: [
                                    { id: "so_serial", header: _("SO_SERIAL"), width: 250 },
                                    { id: "subjectname", header: _("SUBJECTNAME"), width: 450 },
                                    {
                                        id: "ngaybatdau", header: _("NGAY_BAT_DAU"), width: 150,
                                        format: function (text) {
                                            var format = webix.Date.dateToStr("%d/%m/%Y");
                                            text = removeTimeZoneT(text);
                                            return format(text);
                                        }
                                    },
                                    {
                                        id: "ngayketthuc", header: _("NGAY_KET_THUC"), width: 150,
                                        format: function (text) {
                                            var format = webix.Date.dateToStr("%d/%m/%Y");
                                            text = removeTimeZoneT(text);
                                            return format(text);
                                        }
                                    }
                                ]
                            }

                        }
                    },
                    { view: "template", template: "Danh sách hóa đơn chờ ký", type: "section" },
                    {

                        view: "datatable",
                        select: "row",
                        id: tableId,
                        resizeColumn: true,
                        datafetch: 50,
                        on: {
                            "data->onStoreUpdated": function () {
                                this.data.each(function (obj, i) {
                                    obj.index = i + 1;
                                })
                            }
                        },
                        columns: [
                            {
                                id: "chon1",
                                header: [{ text: "", content: "masterCheckbox" }], width: 55, checkValue: 'C', uncheckValue: 'K',
                                template: "{common.checkbox()}"
                            },
                            { id: "index", sort: "int", header: "STT", width: 50 },
                            { id: "hoadon68_id", header: "ID hóa đơn", width: 250, hidden: true },
                            {
                                id: "tdlap", header: "Ngày hóa đơn", width: 150, format: function (text) {
                                    var format = webix.Date.dateToStr("%d/%m/%Y");
                                    text = removeTimeZoneT(text);
                                    return format(text);
                                }
                            },
                            { id: "shdon", header: "Số hóa đơn" },
                            {
                                id: "tgtttbso", header: "Tổng tiền", width: 150, format: webix.Number.numToStr({
                                    groupDelimiter: ",",
                                    groupSize: 3,
                                    decimalDelimiter: ".",
                                    decimalSize: 0
                                })
                            }
                        ],
                        pager: "selectPagerA"
                    },
                    {
                        id: "selectPagerA",
                        view: "pager",
                        size: 50,
                        group: 5,
                        template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}"
                    },
                    {
                        margin: 10,
                        cols: [
                            {},
                            {
                                shortcut: "F9", view: "button", label: "Tải dữ liệu (F9)", type: "danger", align: "center", width: 120,
                                on: {
                                    onClick: function () {
                                        var formComponent = webix.$$(formId);
                                        if (formComponent.validate()) {
                                            var item = formComponent.getValues();
                                            var format = webix.Date.dateToStr("%Y-%m-%d");
                                            var parameter = {
                                                ma_dvcs: user.getDvcsID(),
                                                tu_ngay: format(item.tu_ngay),
                                                den_ngay: format(item.den_ngay),
                                                quanlykyhieu68_id: item.quanlykyhieu68_id,
                                            };
                                            webix.extend(formComponent, webix.ProgressBar);
                                            formComponent.disable();
                                            formComponent.showProgress();
                                            webix.ajax().headers({ 'Content-type': 'application/json' })
                                                .post(app.config.host + Constant.API.SIGN.GET_LIST_INVOICE, parameter, function (text) {
                                                    var response = JSON.parse(text);
                                                    formComponent.enable();
                                                    formComponent.hideProgress();
                                                    if (!response.hasOwnProperty("error")) {
                                                        var table = $$(tableId);
                                                        table.clearAll();
                                                        if (response.length == 0) {
                                                            webix.message(message_nodata, "error");
                                                        }
                                                        else {
                                                            // $$("btnNhan").enable();
                                                            table.parse(response);
                                                        }
                                                    }
                                                });
                                        }
                                    }
                                },
                                click: function () {
                                    this.callEvent("onClick");
                                }
                            },
                            {
                                shortcut: "F10", view: "button", id: "btnNhan", name: "btnNhan", width: 160, type: "form", label: "Ký và gửi CQT (F10)", align: "center",
                                on: {
                                    onClick: function () {
                                        var formComponent = webix.$$(formId);
                                        webix.extend(formComponent, webix.ProgressBar);
                                        formComponent.disable();
                                        formComponent.showProgress();
                                        var tableInvoiceComponent = $$(tableId);
                                        var dataInvoice = tableInvoiceComponent.serialize();
                                        if (dataInvoice.length == 0) {
                                            webix.message(message_nodata, "error");
                                            formComponent.enable();
                                            formComponent.hideProgress();
                                            return;
                                        }
                                        var typeSign = $$(windowId).config.kytaptrung;
                                        var selectedInvoices = dataInvoice.filter(function (x) {
                                            return x.chon1 === "C";
                                        });
                                        var dataRequest = selectedInvoices.map(function (x) {
                                            return {
                                                id: x.hoadon68_id,
                                                shdon: x.shdon,
                                                tdlap: x.tdlap,
                                                khieu: x.khieu,
                                                tgtien: x.tgtttbso
                                            };
                                        });

                                        webix.extend(formComponent, webix.ProgressBar);
                                        formComponent.disable();
                                        formComponent.showProgress();
                                        webix.ajax()
                                            .headers({ 'Content-type': 'application/json' })
                                            .post(Constant.API.INVOICE_CHECK_DATE, JSON.stringify(dataRequest), {
                                                error: function () {
                                                    formComponent.enable();
                                                    formComponent.hideProgress();
                                                },
                                                success: function (text) {
                                                    formComponent.enable();
                                                    formComponent.hideProgress();
                                                    var response = JSON.parse(text);
                                                    if (response.code !== "00") return showError(response.message);
                                                    var invalids = (response.data || []).filter(function (x) { return !x.Validate; });
                                                    if (invalids.length > 0) {
                                                        var htmlList = "<table style='width:100%; border-collapse: collapse;'>" +
                                                            "<thead>" +
                                                            "<tr style='background-color: #f0f0f0;'>" +
                                                            "<th style='border: 1px solid #ccc; padding: 5px;'>#</th>" +
                                                            "<th style='border: 1px solid #ccc; padding: 5px;'>Ký hiệu</th>" +
                                                            "<th style='border: 1px solid #ccc; padding: 5px;'>Ngày lập</th>" +
                                                            "<th style='border: 1px solid #ccc; padding: 5px;'>Số hóa đơn</th>" +
                                                            "<th style='border: 1px solid #ccc; padding: 5px;'>Tổng tiền</th>" +
                                                            "</tr>" +
                                                            "</thead>" +
                                                            "<tbody>" +
                                                            invalids.map(function (hd, index) {
                                                                var dateStr = webix.Date.dateToStr("%d/%m/%Y")(new Date(hd.tdlap));
                                                                return "<tr>" +
                                                                    "<td style='border: 1px solid #ccc; padding: 5px; text-align: center;'>" + (index + 1) + "</td>" +
                                                                    "<td style='border: 1px solid #ccc; padding: 5px;'>" + hd.khieu + "</td>" +
                                                                    "<td style='border: 1px solid #ccc; padding: 5px;'>" + dateStr + "</td>" +
                                                                    "<td style='border: 1px solid #ccc; padding: 5px; text-align: center;'><b>" + hd.shdon + "</b></td>" +
                                                                    "<td style='border: 1px solid #ccc; padding: 5px; text-align: right;'>" + formatDecimal(hd.tgtien, 0) + "</td>" +
                                                                    "</tr>";
                                                            }).join("") +
                                                            "</tbody></table>";

                                                        var htmlMessage =
                                                            "<div style='line-height:1.5; color: black'>" +
                                                            "Theo quy định tại <b>Điểm c Khoản 7</b> và <b>Điểm b Khoản 14</b>, Điều 1, <b>Nghị định 70/2025/NĐ-CP</b>, " +
                                                            "thời điểm ký gửi dữ liệu hóa đơn lên CQT chậm nhất là ngày làm việc tiếp theo kể từ thời điểm lập hóa đơn." +
                                                            "<br><br><u>Danh sách các hóa đơn sau không thỏa mãn quy định trên:</u><br>" +
                                                            htmlList +
                                                            "<br><b>Bạn có muốn tiếp tục thao tác ký gửi không?</b>" +
                                                            "</div>";

                                                        webix.modalbox({
                                                            title: "<div style='font-size: 16px; font-weight: bold; color: #FF0000;'>CẢNH BÁO KÝ GỬI HÓA ĐƠN QUÁ HẠN</div>",
                                                            text: "<div style='padding: 10px; max-height: 350px; overflow-y: auto;'>" + htmlMessage + "</div>",
                                                            buttons: ["Có, tiếp tục Ký", "Không"],
                                                            width: 600,
                                                            callback: function (result) {
                                                                if (result === "0") {
                                                                    functionExtension.SignInvoiceMultiple(typeSign, 1, windowId, formComponent, dataInvoice, tableInvoiceComponent, signCloudMulti, plugin, user);
                                                                }
                                                            }
                                                        });
                                                    } else {
                                                        functionExtension.SignInvoiceMultiple(typeSign, 1, windowId, formComponent, dataInvoice, tableInvoiceComponent, signCloudMulti, plugin, user);
                                                    }
                                                }
                                            });
                                    }
                                },
                                click: function () {
                                    this.callEvent("onClick");
                                }
                            },
                            {
                                shortcut: "F11", view: "button", id: "btnSignNotSend", name: "btnSignNotSend", width: 160, type: "form", label: "Ký hóa đơn (F11)", align: "center",
                                on: {
                                    onClick: function () {
                                        var formComponent = webix.$$(formId);
                                        webix.extend(formComponent, webix.ProgressBar);
                                        formComponent.disable();
                                        formComponent.showProgress();
                                        var tableInvoiceComponent = $$(tableId);
                                        var dataInvoice = tableInvoiceComponent.serialize();
                                        if (dataInvoice.length == 0) {
                                            webix.message(message_nodata, "error");
                                            formComponent.enable();
                                            formComponent.hideProgress();
                                            return;
                                        }
                                        var typeSign = $$(windowId).config.kytaptrung;
                                        functionExtension.SignInvoiceMultiple(typeSign, 2, windowId, formComponent, dataInvoice, tableInvoiceComponent, signCloudMulti, plugin, user);
                                    }
                                },
                                click: function () {
                                    this.callEvent("onClick");
                                }
                            },
                            {
                                view: "button", hotkey: "esc", label: "Hủy bỏ (ESC)", type: "danger", align: "center", width: 100,
                                click: function () {
                                    webix.$$(windowId).close();
                                }
                            },
                            {}
                        ]
                    }
                ]
            }
        };
        return {
            $ui: layout,
            setEditMode: function (mode) {
                editmode = mode;
            }
        };
    }
);
define('views/forms/forms68/HDon/taxStatusForm',[
    "app",
    "locale",
],
    function (app, _,) {
        function statusMVANText(statusCode) {
            switch (statusCode) {
                case 0:
                    return "Hóa đơn gốc";
                case 3:
                    return "Thay thế";
                case 2:
                    return "Điều chỉnh";
                case 6:
                    return "Bị thay thế";
                case 7:
                    return "Bị điều chỉnh";
                case 1:
                    return "Hủy";
                default:
                    return "Trạng thái không hợp lệ";
            }
        }

        function statusCQTText(statusCode) {
            switch (statusCode) {
                case 1:
                    return "Hóa đơn gốc";
                case 2:
                    return "Thay thế";
                case 3:
                    return "Điều chỉnh";
                case 4:
                    return "Bị thay thế";
                case 5:
                    return "Bị điều chỉnh";
                case 6:
                    return "Hủy";
                default:
                    return "Trạng thái không hợp lệ";
            }
        }

        var layout =
        {
            view: "window", modal: true, resize: true, id: "invoiceInfoForm", position: "center", move: true, css: "headformchil",
            head: {
                height: 40,
                cols: [
                    { id: "head-form", view: "template", css: "headform", template: function (obj) { return '<div>Cập nhật trạng thái hóa đơn từ CQT<div/>'; } }
                ]
            },
            width: 360,
            minHeight: 600,
            body: {
                paddingY: 10,
                paddingX: 10,
                view: "form",
                id: "invoiceInfo",
                complexData: true,
                margin: 0,
                elements: [
                    { view: "text", id: "hoadon68_id", name: "hoadon68_id", label: "id", labelWidth: 140, readonly: true, hidden: true },
                    { view: "text", id: "nbmst", name: "nbmst", label: "MST người bán", labelWidth: 140, readonly: true },
                    { view: "text", id: "khmshdon", name: "khmshdon", label: "Ký hiệu", labelWidth: 140, readonly: true },
                    { view: "text", id: "shdon", name: "shdon", label: "Số hóa đơn", labelWidth: 140, readonly: true },
                    { view: "datepicker", id: "nlap", name: "nlap", label: "Ngày lập", labelWidth: 140, format: "%d/%m/%Y", readonly: true },
                    { view: "text", id: "tgtttbso", name: "tgtttbso", label: "Tổng tiền thanh toán", labelWidth: 140, readonly: true },
                    {
                        view: "text", id: "tthaiHienTai", name: "tthaiHienTai", label: "Trạng thái HĐ hiện tại", labelWidth: 140, readonly: true,
                        on: {
                            onAfterRender: function () {
                                var statusText = statusMVANText(this.getValue());
                                this.getInputNode().value = statusText
                            }
                        }
                    },
                    {
                        view: "text", id: "tthaiCQT", name: "tthaiCQT", label: "Trạng thái HĐ tại CQT", labelWidth: 140, readonly: true,
                        on: {
                            onAfterRender: function () {
                                var statusText = statusCQTText(this.getValue());
                                this.getInputNode().value = statusText;
                            }
                        }
                    },
                    {
                        margin: 10,
                        cols: [
                            {},
                            {
                                view: "button", type: "icon", icon: "mdi mdi mdi-file-document-outline", label: "Cập nhật", type: "form", width: 100,
                                on: {
                                    onClick: function () {
                                        var valueForm = $$("invoiceInfo").getValues();
                                        if (valueForm.tthaiHienTai == valueForm.tthaiCQT) {
                                            webix.message("Trạng thái hóa đơn trùng khớp!", "debug");
                                            return;
                                        }
                                        var frmViews = $$("invoiceInfoForm");
                                        var table = webix.$$("invoiceViews");

                                        var format = valueForm.khmshdon;
                                        var hdon = (format[0] == 6 && format[4] == "N") ? "06_01" : (format[0] == 6 && format[4] == "B") ? "06_02" : `0${format[0]}`;
                                        var hoadon68_id = valueForm.hoadon68_id;
                                        var khhdon = format.substring(1);
                                        var khmshdon = format[0];
                                        var nbmst = valueForm.nbmst;
                                        var shdon = valueForm.shdon;
                                        var tgtttbso = valueForm.tgtttbso;
                                        var nlap = valueForm.nlap;

                                        var param = {
                                            hdon: hdon,
                                            hoadon68_id: hoadon68_id,
                                            khhdon: khhdon,
                                            khmshdon: khmshdon,
                                            nbmst: nbmst,
                                            shdon: shdon,
                                            tgtttbso: tgtttbso
                                        }
                                        if (hdon.substring(0, 2) == "06") {
                                            delete param.tgtttbso;
                                            param.nlap = nlap;
                                        }
                                        webix.extend(frmViews, webix.ProgressBar);
                                        frmViews.disable();
                                        frmViews.showProgress();
                                        webix.ajax()
                                            .headers({ "Content-type": "application/json" })
                                            .post(app.config.host + "/Invoice68/FixInvoiceStatusFromTax", param, function (text, data, XmlHttpRequest) {
                                                var response = JSON.parse(text);
                                                frmViews.enable();
                                                frmViews.hideProgress();
                                                if (response.code == "00") {
                                                    webix.message("Cập nhật trạng thái thành công!", "success");
                                                    table.clearAll();
                                                    table.load(table.config.url);
                                                    webix.$$("invoiceInfoForm").close();
                                                }
                                                else webix.message(response.message, "error");
                                            });
                                    }
                                },
                                click: function () {
                                    this.callEvent("onClick");
                                }
                            },
                            {
                                view: "button", hotkey: "esc", label: "Đóng (ESC)", type: "danger", align: "center", width: 100,
                                click: function () {
                                    webix.$$("invoiceInfoForm").close();
                                }
                            },

                        ]
                    }
                ]
            }
        };
        return {
            $ui: layout,
        };
    }
);


define('views/forms/forms70/BienBan/SendEmailBienban',[
    "app",
    "locale",
    "views/forms/forms68/68_viewsLogEmail",
    "views/modules/Component/constantManager",
    "views/modules/Component/functionExtension"
], function (app, _, viewLogEmail, CONSTANTS, functionExtension) {
    var sendEmailModal = "sendEmailModal";
    var sendEmailForm = "sendEmailForm";
    var tempBienban = "temp_bienban";
    var customerEmail = "customer_email";
    var btnSendEmail = "btnSendEmailBienban";
    var bienbanForm = "BienBanForms";

    var currentBienban = null;

    function formatDate(dateStr) {
        if (!dateStr) return "";
        var d = new Date(dateStr);
        if (isNaN(d)) return "";
        return ("0" + d.getDate()).slice(-2) + "/" +
            ("0" + (d.getMonth() + 1)).slice(-2) + "/" +
            d.getFullYear();
    }

    function getSendCount(bienbanId) {
        return webix.ajax()
            .get(app.config.host + "/Bienban70/ViewLogEmail?bienban_id=" + encodeURIComponent(bienbanId))
            .then(function (res) {
                var logs = res.json();
                if (Array.isArray(logs)) return logs.length;
                if (logs.data && Array.isArray(logs.data)) return logs.data.length;
                return 0;
            })
            .catch(function () { return 0; });
    }

    return {
        $ui: {
            view: "window",
            move: true,
            resize: true,
            position: "center",
            modal: true,
            head: "Gửi email biên bản cho người mua ký",
            minWidth: 500,
            minHeight: 450,
            id: sendEmailModal,
            body: {
                view: "form",
                id: sendEmailForm,
                complexData: true,
                autoheight: true,
                elementsConfig: { labelWidth: 150, margin: 6 },
                rows: [
                    {
                        id: tempBienban,
                        borderless: true,
                        autoheight: true,
                        template: function (obj) {
                            return `
                                    <div class="card-body customize" style="padding:0 !important">
                                        <div class="p-3 bg-light mb-3">
                                            <h5 class="font-size-16 mb-0">Thông tin biên bản</h5>
                                        </div>
                                        <div class="table-responsive">
                                            <table class="table table-centered mb-0" style="table-layout: fixed; word-break: break-word; white-space: normal;">
                                                <tbody>
                                                    <tr><td style="width:40%;"><b>Ngày lập biên bản:</b></td><td>${formatDate(obj.ngay)}</td></tr>
                                                    <tr><td><b>Số biên bản:</b></td><td>${obj.so || ""}</td></tr>
                                                    <tr><td><b>Bên bán:</b></td><td>${obj.nban || ""}</td></tr>
                                                    <tr><td><b>Bên mua:</b></td><td>${obj.nmua || ""}</td></tr>
                                                    <tr class="bg-light">
                                                        <td colspan="2">
                                                            <a href="#" class="link-history">
                                                                <p class="text-primary" style="margin:0; word-break: break-word; white-space: normal;">
                                                                    Biên bản đã được gửi đi ${obj.sendCount || 0} lần.
                                                                    <span class="mdi mdi-arrow-right-drop-circle text-danger"></span>
                                                                </p>
                                                            </a>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                `;
                        },
                        onClick: {
                            "link-history": function () {
                                if (!currentBienban) {
                                    webix.message("Không tìm thấy thông tin biên bản", "error");
                                    return;
                                }
                                currentBienban.apiHost = CONSTANTS.API.BIENBAN.EMAIL_LOG;
                                currentBienban.typeView = "BIENBAN";
                                var detailForm = webix.ui(viewLogEmail.$ui);
                                viewLogEmail.setValues(currentBienban);
                                detailForm.show();
                            }
                        }
                    },
                    {
                        view: "text",
                        id: customerEmail,
                        name: "customer_email",
                        label: "Email khách hàng",
                        labelPosition: "top",
                        placeholder: "Mỗi email cách nhau bởi dấu , hoặc ;",
                        required: true,
                        invalidMessage: "Email không được để trống!"
                    },
                    {
                        cols: [
                            {},
                            {
                                shortcut: "F10",
                                view: "button",
                                id: btnSendEmail,
                                label: "Gửi email",
                                type: "form",
                                align: "center",
                                width: 120,
                                on: {
                                    onClick: function () {
                                        if (!currentBienban || !currentBienban.ngay_ky) {
                                            webix.message("Biên bản chưa ký, không thể gửi email", "error");
                                            return;
                                        }

                                        var form = $$(sendEmailForm);

                                        if (form.validate()) {
                                            var itemData = form.getValues();
                                            var patt = /\S+@[^@\s]+\.[^@\s]+$/;
                                            var emails = itemData.customer_email.split(/[\s,;]+/).filter(Boolean);
                                            for (var i = 0; i < emails.length; i++) {
                                                if (!patt.test(emails[i])) {
                                                    webix.message("Tồn tại email không hợp lệ!", "error");
                                                    return;
                                                }
                                            }
                                            if (emails.length > 5) {
                                                webix.message("Không được gửi quá 5 email!", "error");
                                                return;
                                            }
                                            var sendData = {
                                                id: currentBienban.bienban_id || currentBienban.id || "",
                                                to: emails.join(","),
                                                scret: functionExtension.SaltEmail(emails.join(","))
                                            };
                                            var table = $$(sendEmailModal);
                                            webix.extend(table, webix.ProgressBar);
                                            table.disable();
                                            table.showProgress();
                                            webix.ajax()
                                                .headers({ 'Content-type': 'application/json' })
                                                .post(app.config.host + "/Bienban70/SendEmailBienban", JSON.stringify(sendData), {
                                                    error: function () {
                                                        table.enable();
                                                        table.hideProgress();
                                                    },
                                                    success: function (text) {
                                                        table.enable();
                                                        table.hideProgress();
                                                        var res = JSON.parse(text);
                                                        if (res.code === "00") {
                                                            webix.message("Gửi email thành công!", "success");
                                                            $$(sendEmailModal).close();
                                                            $$(bienbanForm).close();
                                                        } else {
                                                            webix.message(res.message || "Có lỗi khi gửi email", "error");
                                                        }
                                                    }
                                                });
                                        }
                                    }
                                },
                                click: function () {
                                    this.callEvent("onClick");
                                }
                            },
                            {
                                view: "button",
                                label: "Đóng",
                                css: "webix_danger",
                                width: 120,
                                click: function () {
                                    $$(sendEmailModal).close();
                                }
                            },
                            {}
                        ]
                    },
                    { height: 10 }
                ]
            }
        },
        show: function (bienban) {
            currentBienban = bienban;
            var bienban_id = bienban.bienban_id || bienban.id;

            if (!bienban_id) {
                webix.message("Không tìm thấy ID biên bản", "error");
                return;
            }
            if (!$$(sendEmailModal)) {
                webix.ui(this.$ui);
            }
            var modal = $$(sendEmailModal);
            modal.show();
            webix.extend(modal, webix.ProgressBar);
            modal.disable();
            modal.showProgress();

            webix.ajax()
                .get(app.config.host + CONSTANTS.API.BIENBAN.GET_BIENBAN_BY_ID + "?id=" + bienban_id)
                .then(function (res) {
                    var response = res.json();
                    if (response && response.data) {
                        currentBienban = response.data;
                        getSendCount(bienban_id).then(function (count) {
                            currentBienban.sendCount = count;
                            $$(tempBienban).setValues(currentBienban);
                            if (currentBienban.hoadon68_id) {
                                webix.ajax().get(app.config.host + "/Invoice68/GetInvoiceById?id=" + currentBienban.hoadon68_id, {
                                    error: function (err) {
                                        $$(customerEmail).setValue(currentBienban.email || "");
                                        modal.enable();
                                        modal.hideProgress();
                                        modal.show();
                                    },
                                    success: function (response2) {
                                        try {
                                            const res = JSON.parse(response2);
                                            const email = res.data.email || currentBienban.email || "";
                                            $$(customerEmail).setValue(email);
                                        } catch (e) {
                                            $$(customerEmail).setValue(currentBienban.email || "");
                                        }
                                        modal.enable();
                                        modal.hideProgress();
                                        modal.show();
                                    }
                                });
                            } else {
                                $$(customerEmail).setValue(currentBienban.email || "");
                                modal.enable();
                                modal.hideProgress();
                            }
                        }.bind(this));
                    } else {
                        modal.enable();
                        modal.hideProgress();
                        webix.message("Không tìm thấy dữ liệu biên bản", "error");
                    }
                }.bind(this))
                .catch(function () {
                    modal.enable();
                    modal.hideProgress();
                    webix.message("Không tải được thông tin biên bản", "error");
                });
        }
    };
});

define('views/modules/Component/grid',["app",
    "locale",
    "views/modules/Component/constantManager",
    "views/forms/forms68/68_viewsLogEmail",
    "views/menus/version",
    "views/forms/forms68/HDon/taxStatusForm",
    "views/forms/forms70/BienBan/SendEmailBienban",
], function (app, _, CONSTANTS, viewLogEmail, versions, taxStatusForm,sendEmail) {
    function changeMultiChoice() {
        var table = $$("invoiceViews");
        var columns = webix.toArray(table.config.columns);

        if (table.getColumnConfig("colMultiChoice") == undefined) {
            columns.insertAt({
                id: "colMultiChoice",
                header: [{ text: "", content: "masterCheckbox", contentId: "mc1" }],
                width: 50,
                checkValue: 'C',
                uncheckValue: 'K',
                template: "{common.checkbox()}",
                value: 'K'

            }, 0);
        }
        else {
            columns.removeAt(0);
        }
        table.refreshColumns();
    }
    function changeMultiChoiceId(datatableId) {
        var table = $$(datatableId);
        var columns = webix.toArray(table.config.columns);

        if (table.getColumnConfig("colMultiChoice") == undefined) {
            columns.insertAt({
                id: "colMultiChoice",
                header: [{ text: "", content: "masterCheckbox", contentId: "mc1" }],
                width: 50,
                checkValue: 'C',
                uncheckValue: 'K',
                template: "{common.checkbox()}",
                value: 'K'

            }, 0);
        }
        else {
            columns.removeAt(0);
        }
        table.refreshColumns();
    }

    webix.ui({
        view: "contextmenu",
        id: "cmenu",
        autowidth: true,
        data: [
            { id: "cmenuAdd", value: "Thêm (F4)", icon: "mdi mdi-plus-box-outline" },
            { id: "cmenuEdit", value: "Sửa (F3)", icon: "mdi mdi-pencil-box-outline" },
            { id: "cmenuDelete", value: "Xóa (F8)", icon: "mdi mdi-trash-can-outline" },
            { id: "cmenuCopy", value: "Sao chép", icon: "mdi mdi-content-duplicate" },
            { $template: "Separator" },
            { id: "cmenuEmail", value: "Lịch sử gửi email", icon: "mdi mdi-email-outline" },
            { $template: "Separator" },
            { id: "updateStatus", value: "Cập nhật trạng thái phát hành", icon: "mdi mdi-file-arrow-up-down-outline" },
            { id: "getStatusFromTax", value: "Lấy trạng thái hóa đơn từ CQT", icon: "mdi mdi-file-document-check-outline" },
        ],
        on: {
            onItemClick: function (id) {
                if (this.getItem(id).id == "cmenuAdd") {
                    $$("btnPlus").callEvent("onClick");
                }
                if (this.getItem(id).id == "cmenuEdit") {
                    $$("btnEdit").callEvent("onClick");
                }
                if (this.getItem(id).id == "cmenuDelete") {
                    $$("btnDelete").callEvent("onClick");
                }
                if (this.getItem(id).id == "cmenuCopy") {
                    $$("btnCopy").callEvent("onClick");
                }
                if (this.getItem(id).id == "cmenuEmail") {
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();
                    if (item == null || item == undefined) {
                        webix.message("Bạn chưa chọn hóa đơn", "debug");
                        return;
                    }
                    item.apiHost = CONSTANTS.API.SEND_EMAIL_LOG;
                    item.typeView = "INVOICE";
                    var detailForm = $$("frmView").$scope.ui(viewLogEmail.$ui);
                    viewLogEmail.setValues(item);
                    detailForm.show();
                }
                if (this.getItem(id).id == "updateStatus") {
                    var frmViews = $$("frmView");
                    var table = webix.$$("invoiceViews");
                    var item = table.getSelectedItem();
                    if (item == null || item == undefined) {
                        webix.message("Bạn chưa chọn hóa đơn", "debug");
                        return;
                    }
                    webix.extend(frmViews, webix.ProgressBar);
                    frmViews.disable();
                    frmViews.showProgress();
                    webix.ajax()
                        .headers({ "Content-type": "application/text" })
                        .get(app.config.host + "/Invoice68/FixInvoiceStatus?id=" + item.hoadon68_id,
                            function (text, data, XmlHttpRequest) {
                                var response = JSON.parse(text);
                                frmViews.enable();
                                frmViews.hideProgress();
                                if (response.code == "00") {
                                    webix.message("Cập nhật thành công", "success");
                                    table.clearAll();
                                    table.load(table.config.url);
                                }
                                else
                                    webix.message(response.message, "error");
                            }
                        );
                }
                // if (this.getItem(id).id == "getStatusFromTax") {
                //     {
                //         var frmViews = $$("frmView");
                //         var table = webix.$$("invoiceViews");
                //         var item = table.getSelectedItem();
                //         if (item == null || item == undefined) {
                //             webix.message("Bạn chưa chọn hóa đơn", "debug");
                //             return;
                //         }           
                //         if (item.tthai != CONSTANTS.DA_GUI) {
                //             webix.message("Hóa đơn chưa gửi CQT, thao tác không thành công.", "debug");
                //             return;
                //         }
                //         var format = item.khieu;
                //         var hdon = (format[0] == 6 && format[4] == "N") ? "06_01" : (format[0] == 6 && format[4] == "B") ? "06_02" : `0${format[0]}`;
                //         var model = {
                //             hoadon68_id: item.hoadon68_id,
                //             khmshdon: item.khieu[0],
                //             hdon: hdon,
                //             nbmst: versions.getInfocompany().ms_thue,
                //             khhdon: item.khieu.substring(1),
                //             shdon: item.shdon,
                //             tgtttbso: item.tgtttbso
                //         };

                //         if(hdon.substring(0, 2) == "06"){
                //             delete model.tgtttbso;
                //             model.nlap = item.nlap;
                //         }
                //         webix.extend(frmViews, webix.ProgressBar);
                //         frmViews.disable();
                //         frmViews.showProgress();
                //         webix.ajax()
                //             .headers({ "Content-type": "application/json" })
                //             .post(app.config.host + "/Invoice68/FixInvoiceStatusFromTax", model, function (text, data, XmlHttpRequest) {
                //                 var response = JSON.parse(text);
                //                 frmViews.enable();
                //                 frmViews.hideProgress();
                //                 if (response.code == "00") {
                //                     webix.message("Cập nhật trạng thái thành công", "success");
                //                     table.clearAll();
                //                     table.load(table.config.url);
                //                 }
                //                 else webix.message(response.message, "error");
                //             });
                //     }
                // }

                if (this.getItem(id).id == "getStatusFromTax") {
                    {
                        var frmViews = $$("frmView");
                        var table = webix.$$("invoiceViews");
                        var item = table.getSelectedItem();
                        if (item == null || item == undefined) {
                            webix.message("Bạn chưa chọn hóa đơn", "debug");
                            return;
                        }
                        if (item.tthai != CONSTANTS.DA_GUI) {
                            webix.message("Hóa đơn chưa gửi CQT, thao tác không thành công.", "debug");
                            return;
                        }

                        var isTThai = -1;
                        var format = item.khieu;
                        var hdon = (format[0] == 6 && format[4] == "N") ? "06_01" : (format[0] == 6 && format[4] == "B") ? "06_02" : `0${format[0]}`;
                        var model = {
                            hoadon68_id: item.hoadon68_id,
                            khmshdon: item.khieu[0],
                            hdon: hdon,
                            nbmst: versions.getInfocompany().ms_thue,
                            khhdon: item.khieu.substring(1),
                            shdon: item.shdon,
                            tgtttbso: item.tgtttbso
                        };
                        if (hdon.substring(0, 2) == "06") {
                            model.tgtttbso;
                            model.nlap = item.nlap;
                        }
                        webix.extend(frmViews, webix.ProgressBar);
                        frmViews.disable();
                        frmViews.showProgress();
                        webix.ajax()
                            .headers({ "Content-type": "application/json" })
                            .post(app.config.host + "/Invoice68/InvoiceStatusFromTaxShowForm", model, function (text, data, XmlHttpRequest) {
                                var response = JSON.parse(text);

                                frmViews.enable();
                                frmViews.hideProgress();
                                if (response.code == "0000") {
                                    isTThai = response.data.tthai;
                                    updateModelToShowForm();
                                }
                                else webix.message(response.message, "error");
                            });

                        function updateModelToShowForm() {
                            model.hoadon68_id;
                            delete model.khhdon;
                            model.nbmst = versions.getInfocompany().ms_thue;
                            model.khmshdon = item.khieu;
                            model.nlap = webix.Date.strToDate("%d/%m/%Y")(webix.Date.dateToStr("%d/%m/%Y")(new Date(item.nlap)));
                            model.tthaiHienTai = item.is_tthdon;
                            model.tthaiCQT = isTThai;

                            var frm = webix.ui(taxStatusForm.$ui);
                            var invoiceInfoForm = $$("invoiceInfoForm");
                            invoiceInfoForm.getBody().clear();
                            invoiceInfoForm.getBody().setValues(model);
                            frm.show();
                        }
                    }
                }
            }
        }
    });
    function threeStateCompare(value, filter) {
        if (filter == "thirdState") return true;
        return value == filter
    };
    return {
        gridInitInvoice: function (viewLogForm, type, typeInvoice) {
            var grid =
            {
                rows: [
                    {
                        view: "datatable",
                        id: "invoiceViews",
                        select: true,
                        resizeColumn: true,
                        fixedRowHeight: false,
                        leftSplit: 8,
                        rightSplit: 1,
                        rowLineHeight: 25, rowHeight: 25,
                        tooltip: true,
                        //autowidth: true,
                        footer: true,
                        headermenu: {
                            //width: 200,
                            autoheight: false,
                            scroll: true,
                            autowidth: true,
                            // ready() {
                            //     this.attachEvent("onMenuItemClick", (id, e) => {
                            //         // const item = this.getItem(id);
                            //         // console.log(e);
                            //         // console.log(id);
                            //         var grids = $$("invoiceViews");
                            //         console.log(grids);
                            //         var columns = webix.toArray(grids.columns);
                            //         columns.insertAt({
                            //             id: "title" + webix.uid(),
                            //             header: id
                            //         }, 2);
                            //         grids.refreshColumns();
                            //     })
                            // },
                            // url: app.config.host + "/Invoice68/GridColumnSetting"
                        },
                        multiview: { keepViews: true },
                        keepViews: true,
                        editable: false,
                        hover: "myhover",
                        url: {
                            $proxy: true,
                            load: function (view, callback, params) {
                                var start = null;
                                var count = null;
                                var filter = [];
                                var infoparam = null;
                                var tlbparam_s = [];
                                var url = app.config.host + "/Pattern/GetData";
                                if (params == null) {
                                    start = 0;
                                    count = view.config.datafetch;
                                    url = url + "?command=CM0009&start=0&count=" + view.config.datafetch + "&continue=null&filter=null";
                                }
                                else {
                                    start = params.start;
                                    count = params.count;
                                    url = url + "?command=CM0009&start=" + params.start + "&count=" + params.count + "&continue=" + params.continue;
                                    if (params.filter != null) {
                                        var array = [];
                                        for (var property in params.filter) {
                                            var column = view.getColumnConfig(property);
                                            var value = params.filter[property];

                                            var isNullObject = value && value.start === null && value.end === null;
                                            if (!isNullObject && value !== "") {
                                                var item = {
                                                    columnName: property,
                                                    columnType: column.columnType,
                                                    value: params.filter[property]
                                                };
                                                array.push(item);
                                            }
                                        }
                                        if (array.length > 0) {
                                            filter = array;
                                            url = url + "&filter=" + JSON.stringify(array);
                                        }
                                        else {
                                            url = url + "&filter=null";
                                        }
                                    }
                                }
                                var tlbParams = $$("paramKH");
                                if (tlbParams !== undefined) {
                                    var childViews = tlbParams.getChildViews();
                                    var parameters = [];
                                    for (var i = 0; i < childViews.length; i++) {
                                        var child = childViews[i];
                                        if (child.data.id === "cbGetAll") continue;
                                        var id = child.config.id;
                                        var value = $$(id).getValue();
                                        if (value != undefined && value != "") {
                                            var item = {
                                                columnName: "cctbao_id",
                                                value: $$(id).getValue()
                                            };
                                            parameters.push(item);
                                        }
                                        else {
                                            $$("invoiceViews").hideProgress();
                                            $$("invoiceViews").hideOverlay();
                                            $$("invoiceViews").showOverlay("<div><img src='assets/imgs/nodata.png'><div class='showOverlaydata'>Bạn chưa chọn ký hiệu, hoặc chưa được phân quyền ký hiệu hóa đơn</div></div>");
                                            return;
                                        }
                                    }
                                    tlbparam_s = parameters;
                                    url = url + "&tlbparam=" + JSON.stringify(parameters);
                                }
                                else {
                                    url = url + "&tlbparam=null";
                                }
                                var cbGetAll = $$("cbGetAll");
                                var item = {
                                    command: "CM0009",
                                    start: start,
                                    count: count,
                                    filter: filter,
                                    tlbparam: tlbparam_s
                                };

                                if (cbGetAll) {
                                    item.isListAll = Boolean(cbGetAll.data.value);
                                }

                                if (filter.length > 0) {
                                    item.filter = filter;
                                    item.isListAll = true;
                                }

                                var apiHost = app.config.host + "/Pattern/GetData";
                                webix.ajax()
                                    .headers({ 'Content-type': 'application/json' })
                                    .bind(view)
                                    .post(apiHost, item, callback, view);
                            }
                        },
                        onClick: {
                            "btnViewLichsu": function (event, cell, target) {
                                var table = webix.$$("invoiceViews");
                                var item = table.getItem(cell.row);
                                var detailForm = this.$scope.ui(viewLogForm.$ui);
                                viewLogForm.initUI("hd", item.matdiep, item);
                                detailForm.show();
                            },
                            "btnLapBienBan": function (e, id, trg) {
                                var item = this.getItem(id.row);
                                require(["views/forms/forms70/BienBan/bienbanForm"], function (bienban) {
                                    var detailForm = webix.ui(bienban.$ui);
                                    detailForm.getBody().setValues({
                                        hdlket_id: item.hdlket_id,
                                        ten_tt: item.ten_tt,
                                        bienban_id: item.bienban_id || "00000000-0000-0000-0000-000000000000",
                                        hoadon68_id: item.hoadon68_id,
                                        so_bke: item.sbke_lquan,
                                        ngay_bke: item.nbke_lquan
                                    });
                                    bienban.initUI(item);
                                    detailForm.show();
                                });
                                return false;
                            },
                            "btnUpload": function (e, id, trg) {
                                var item = this.getItem(id.row);
                                if (!item.bienban_id) return showError("Cần lập biên bản tại phần mềm trước khi đính kèm file");

                                require(["views/forms/forms70/BienBan/uploadBienBan"], function (uploadPDF) {
                                    var detailForm = webix.ui(uploadPDF.$ui);
                                    uploadPDF.initUI(item.bienban_id, item);
                                    detailForm.show();
                                });
                                return false;
                            },
                            "btnSendEmailBienBan": function (e, id, trg) {
                                var record = this.getItem(id);
                                 if (!record.bienban_id) return showError("Cần lập biên bản tại trước khi gửi email");
                                if (!$$("sendemail-win")) {
                                    webix.ui(sendEmail.$ui);
                                }
                                sendEmail.show(record);
                            },
                            "btnPrint": function (e, id, trg) {
                                var item = this.getItem(id.row);
                                if (!item.lap_bban) {
                                    webix.message("Bạn chưa lập biên bản, không thể xem in", "error");
                                    return false;
                                }
                                var box = webix.modalbox({
                                    title: "Đang in biên bản ....",
                                    text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                                    width: 350,
                                    height: 200,
                                });

                                var newWin = window.open();
                                var html = "<html><head><title>Hóa đơn điện tử M-Invoice</title>" +
                                    '<link rel="stylesheet" href="assets/fontawesome_pro/css/all.css" type="text/css" charset="utf-8">' +
                                    '<link rel="stylesheet" href="assets/fontawesome.css" type="text/css" charset="utf-8">' +
                                    '</head><body><center>Đang tải dữ liệu ... <br><p><i style="font-size:200%;" class="fa fa-spin fa-spinner"></i></p></center></body></html>';
                                newWin.document.write(html);

                                webix.ajax()
                                    .response("arraybuffer")
                                    .headers({ "Content-type": "application/json" })
                                    .get(app.config.host + CONSTANTS.API.BIENBAN.PRINT_BIENBAN + "?id=" + item.bienban_id + "&type=PDF", {
                                        error: function (text, data, XmlHttpRequest) {
                                            webix.modalbox.hide(box);
                                        },
                                        success: function (text, data, XmlHttpRequest) {
                                            var file = new Blob([data], { type: "application/pdf" });
                                            var fileURL = URL.createObjectURL(file);
                                            webix.modalbox.hide(box);
                                            newWin.location = fileURL;
                                        },
                                    });
                                return false;
                            }
                        },
                        type: {
                            rcheckbox: function (obj, common, value, config) {
                                var checked = (value == config.checkValue) ? 'checked="true"' : '';
                                return "<input disabled class='webix_table_checkbox' type='checkbox' " + checked + ">";
                            },
                            mtrangthai: function (obj, common, value, config) {
                                if (obj.tthai == CONSTANTS.DA_GUI) {
                                    var checked = (obj.is_success == 1) ? `<sup style='color:${CONSTANTS.COLOR.DA_GUI}'> <span class='mdi mdi-check'></span></sup>` : `<sup style='color:${CONSTANTS.COLOR.CO_LOI}'> <span class='mdi mdi-close'></span></sup>`;
                                    var color = (obj.is_success == 1) ? CONSTANTS.COLOR.DA_GUI : CONSTANTS.COLOR.CO_LOI;
                                    return `<span class='btnViewLichsu' style='color: ${color};font-weight: bold; text-decoration: underline;'>${obj.tthai}${checked}</span>`;
                                }
                                else {
                                    var color = (obj.tthai == CONSTANTS.CHO_KY) ? CONSTANTS.COLOR.CHO_KY : CONSTANTS.COLOR.DA_KY;
                                    return `<span style='color: ${color};font-weight: bold;'>${obj.tthai}</span>`;
                                }
                            },
                            amount: function (obj, common, value, config) {
                                return value == null ? 0 : formatDecimal(value);
                            }
                        },
                        on: {
                            "data->onStoreUpdated": function () {
                                this.data.each(function (obj, i) { obj.stt = i + 1; });
                            },
                            onItemClick: function (id) {
                            },
                            onClick: function (e) {
                            },
                            onItemDblClick: function (id, e, node) {
                                var btnEdit = $$("btnEdit");
                                btnEdit.callEvent("onClick");
                            },
                            onBeforeLoad: function () {
                                webix.extend(this, webix.ProgressBar);
                                this.showProgress({
                                    type: "top"
                                });
                            },
                            onAfterLoad: function () {
                                this.hideProgress();
                                if (!this.count())
                                    this.showOverlay("<div><img src='assets/imgs/nodata.png'><div class='showOverlaydata'>Không có dữ liệu </br> Chúng tôi không tìm thấy hóa đơn</div></div>");
                                else
                                    this.hideOverlay();
                                $$("cmenu").attachTo($$("invoiceViews"));
                            },
                            onHeaderClick: function (header, event, target) {

                            },
                            onAfterRender: function () {
                            },
                            onColumnResize: function () {
                                // this.adjustRowHeight("ten_loai", true);
                                // this.render();
                            },
                            onSubViewCreate: function (view, item) {
                                var subView = view;
                                if (subView != null) {
                                    var tableDetail = webix.$$("hoadon68_chitiet_view");
                                    var url = app.config.host + "/Invoice68/GetDetailInvoice?id=" + item.id;
                                    tableDetail.clearAll();
                                    tableDetail.load(url);
                                }
                            },
                            onBeforeEditStart: function (id) {
                            }
                        },
                        subview: {
                            borderless: true,
                            view: "tabview",
                            height: 255,
                            css: "subInvoice",
                            scrollX: true,
                            multiview: {
                                fitBiggest: true
                            },
                            cells: [
                                {
                                    header: "Chi tiết hóa đơn",
                                    select: "cell",
                                    body: {
                                        view: "datatable",
                                        resizeColumn: true,
                                        margin: 10,
                                        id: "hoadon68_chitiet_view",
                                        height: 200,
                                        columns: [
                                            { id: "stt", header: "", width: 30 },
                                            { id: "ma", header: _("Mã hàng hóa"), editor: "text", width: 100, editable: true },
                                            { id: "ten", header: _("Tên hàng hóa"), editor: "text", width: 350, editable: true },
                                            { id: "mdvtinh", header: _("ĐVT"), editor: "text", width: 80, editable: true },
                                            {
                                                id: "sluong",
                                                header: _("Số lương"), editor: "autonumeric", width: 100,
                                                editable: true, css: { "text-align": "right" },
                                                format: webix.Number.numToStr({
                                                    groupDelimiter: ",",
                                                    groupSize: 3,
                                                    decimalDelimiter: ".",
                                                    decimalSize: 2
                                                })
                                            },
                                            {
                                                id: "dgia",
                                                header: _("Đơn giá"), width: 150, editor: "autonumeric", editable: true,
                                                css: { "text-align": "right" },
                                                format: webix.Number.numToStr({
                                                    groupDelimiter: ",",
                                                    groupSize: 3,
                                                    decimalDelimiter: ".",
                                                    decimalSize: 2
                                                })
                                                // value_change: field.value_change
                                            },
                                            {
                                                id: "thtien",
                                                header: _("Tiền trước thuế"),
                                                width: 150, editor: "autonumeric", editable: true, css: { "text-align": "right" },
                                                format: webix.Number.numToStr({
                                                    groupDelimiter: ",",
                                                    groupSize: 3,
                                                    decimalDelimiter: ".",
                                                    decimalSize: 2
                                                })
                                                // value_change: field.value_change
                                            },
                                            {
                                                id: "tlckhau",
                                                header: _("% CK"), width: 80, editor: "autonumeric", editable: true,
                                                css: { "text-align": "right" },
                                                format: webix.Number.numToStr({
                                                    groupDelimiter: ",",
                                                    groupSize: 3,
                                                    decimalDelimiter: ".",
                                                    decimalSize: 2
                                                })
                                            },
                                            {
                                                id: "stckhau", header: _("Tiền CK"),
                                                width: 150, editor: "autonumeric", editable: true,
                                                css: { "text-align": "right" },
                                                format: webix.Number.numToStr({
                                                    groupDelimiter: ",",
                                                    groupSize: 3,
                                                    decimalDelimiter: ".",
                                                    decimalSize: 2
                                                })
                                            },
                                            {
                                                id: "tsuat",
                                                header: _("Thuế suất"), width: 100, editor: "autonumeric", editable: true,
                                                css: { "text-align": "right" },
                                                format: webix.Number.numToStr({
                                                    groupDelimiter: ",",
                                                    groupSize: 3,
                                                    decimalDelimiter: ".",
                                                    decimalSize: 2
                                                })
                                            },
                                            {
                                                id: "tthue",
                                                header: _("Tiền thuế"),
                                                width: 150, editor: "autonumeric", editable: true, css: { "text-align": "right" },
                                                format: webix.Number.numToStr({
                                                    groupDelimiter: ",",
                                                    groupSize: 3,
                                                    decimalDelimiter: ".",
                                                    decimalSize: 2
                                                })
                                            },
                                            {
                                                id: "tgtien",
                                                header: _("Tiền sau thuế"), width: 150, editor: "autonumeric", editable: true,
                                                css: { "text-align": "right" },
                                                format: webix.Number.numToStr({
                                                    groupDelimiter: ",",
                                                    groupSize: 3,
                                                    decimalDelimiter: ".",
                                                    decimalSize: 2
                                                })
                                            },
                                            {
                                                id: "khuyen_mai", header: _("Khuyến mại"), width: 100, editor: "checkbox", editable: true,
                                                template: "{common.checkbox()}",
                                                checkValue: true,
                                                uncheckValue: false
                                            }
                                        ],
                                        on: {
                                            onBeforeLoad: function () {
                                                this.showOverlay(_("LOADING") + "...");
                                            },
                                            onAfterLoad: function () {
                                                this.hideOverlay();
                                            }
                                        }
                                    }
                                }
                            ]
                        },
                        checkboxRefresh: true,
                        columns: [
                            {
                                id: "subRowMain",
                                header: "&nbsp;",
                                template: "{common.subrow()}",
                                width: 40
                            },
                            {
                                id: "stt",
                                header: ["STT", { content: "textFilter" }],
                                sort: "int",
                                width: 40,
                                hidden: true
                            },
                            {
                                id: "ten_tt", header: [_("TRANG_THAI"), { content: "multiSelectFilter", options: CONSTANTS.STATUS_INVOICE }],
                                template: "<span class='mcls_status#is_tthdon#'>#ten_tt#</span>",
                                width: 120, columnType: "nvarchar", editor: "text", sort: "string"
                            },
                            {
                                id: "tthai", header: [_("TT_GUI"), { content: "multiSelectFilter", options: CONSTANTS.STATUS_SEND_INVOICE }],
                                width: 140, columnType: "nvarchar", editor: "text", sort: "string", template: "{common.mtrangthai()}"
                            },
                            type == "C" ? { id: "macqt", header: [_("MA_CQT"), { content: "textFilter" }], width: 130, columnType: "nvarchar" } : { hidden: true },
                            {
                                id: "tdlap", header: [_("NGAY_HDON"), { content: "serverDateRangeFilter" }], width: 120, columnType: "datetime",
                                format: function (text) { return formatDate(text); }
                            },
                            {
                                id: "khieu", header: [_("KY_HIEU"), { content: "textFilter" }], width: 100, columnType: "nvarchar"
                            },
                            { id: "shdon", header: [_("SO_HDON"), { content: "customFilter" }], width: 100, columnType: "nvarchar", editor: "text", sort: "int" },

                            { id: "mst", header: [_("MST"), { content: "textFilter" }], width: 100, columnType: "nvarchar" },
                            { id: "nguoimuahang", header: [_("DV_NMUA"), { content: "textFilter" }], width: 240, columnType: "nvarchar" },
                            // {
                            //     id: "is_send_email", header: ["Email", { content: "filterCheckBox" }], width: 60,
                            //     columnType: "bit", css: { "text-align": "center" }, template: "{common.rcheckbox()}"
                            // },
                            { id: "cccdan", header: ["CCCD", { content: "textFilter" }], width: 110, columnType: "nvarchar" },
                            {
                                id: "is_send_email", header: ["Email", { content: "selectFilter", options: CONSTANTS.STATUS_SEND_EMAIL }], width: 60,
                                columnType: "bit", css: { "text-align": "center" }, template: "{common.rcheckbox()}"
                            },
                            {
                                id: "tgtcthue", header: [_("TIEN"), { content: "customFilter" }], width: 120,
                                css: { "text-align": "right" }, columnType: "decimal", editor: "text", sort: "int",
                                template: "{common.amount()}",
                                footer: {
                                    content: "summColumn", height: "22", template: function (obj) {
                                        return formatDecimal(obj.value);
                                    }
                                }
                            },
                            {
                                id: "tgtthue", header: [_("TIEN_THUE"), { content: "customFilter" }], width: 120,
                                css: { "text-align": "right" }, columnType: "decimal", editor: "text", sort: "int",
                                template: "{common.amount()}",
                                footer: {
                                    content: "summColumn", height: "22", template: function (obj) {
                                        return formatDecimal(obj.value);
                                    }
                                }
                            },
                            {
                                id: "tgtttbso", header: [_("THANH_TIEN"), { content: "customFilter" }], width: 120,
                                css: { "text-align": "right", "padding": "0px" }, editor: "text", sort: "int",
                                template: "{common.amount()}", columnType: "decimal",
                                footer: {
                                    content: "summColumn", height: "22", template: function (obj) {
                                        return formatDecimal(obj.value);
                                    }
                                }
                            },
                            { id: "mdvqhnsach_nmua", header: ["Mã đơn vị QHNS", { content: "textFilter" }], width: 150, columnType: "nvarchar" },
                            { id: "htttoan", header: [_("HT_TTOAN"), { content: "textFilter" }], width: 120, columnType: "nvarchar" },
                            {
                                id: "nlap", header: [_("NGAY_TAO_MOI"), { content: "serverDateRangeFilter" }], width: 120, columnType: "datetime", hidden: true,
                                format: function (text) { return formatDate(text); }
                            },
                            { id: "nglap", header: [_("USER_NEW"), { content: "textFilter" }], width: 150, columnType: "nvarchar" },
                            typeInvoice == 6 ? { id: "hdktso", header: ["HĐ KT số", { content: "textFilter" }], width: 150, columnType: "nvarchar" } : { hidden: true },
                            typeInvoice == 6 ? {
                                id: "hdktngay", header: ["HĐ KT ngày", { content: "textFilter" }], width: 150, format: function (text) {
                                    return formatDate(text);
                                }
                                , columnType: "datetime"
                            } : { hidden: true },
                            {
                                id: "actions",
                                header: "Biên bản",
                                width: 110,
                                tooltip: false,
                                template: function (obj) {
                                    var actions = '';
                                    if (
                                        obj.ten_tt &&
                                        (
                                            obj.ten_tt.toLowerCase() == "điều chỉnh" ||
                                            obj.ten_tt.toLowerCase() == "thay thế"
                                        )
                                    ) {
                                        var btnColor = (obj.lap_bban == true || obj.lap_bban == 1) ? "rgb(0, 189, 32)" : "#333333";
                                        actions += `<i class="btnLapBienBan mdi mdi-file-arrow-left-right-outline" title="Lập biên bản" style="color:${btnColor};margin-right:10px;"></i>`;
                                        actions += `<i class="btnPrint fa fa-print" title="Xem/In" style="color:${btnColor};margin-right:10px;"></i>`;
                                        actions += `<i class="btnSendEmailBienBan mdi mdi-email-send-outline" title="Gửi Email" style="color:${btnColor};margin-right:10px;"></i>`;
                                        actions += `<i class="btnUpload mdi mdi-upload" title="Tải tệp lên" style="color:${btnColor};margin-right:10px;"></i>`;
                                    }
                                    return actions;
                                },
                            },
                        ],
                        pager: "pagerA"
                    },
                    {
                        cols: [
                            {
                                view: "button",
                                type: "icon",
                                icon: "fas fa-th-list",
                                tooltip: "chọn nhiều chứng từ",
                                width: 30,
                                on: {
                                    onClick: function () {
                                        changeMultiChoice();
                                    }
                                },
                                click: function () {
                                    this.callEvent("onClick");
                                }
                            },
                            {
                                view: "icon", icon: "fas fa-question-circle", id: "help_form_main", tooltip: _("HELPER"),
                                css: "helper",
                                click: function () {
                                    var newWin = window.open();
                                    newWin.location = "https://hdsd.minvoice.com.vn/tutorials/thao-tac/dang-nhap/";
                                }
                            },
                            {
                                view: "combo",
                                label: _("MENU_QUICK"),
                                id: "QuickMenuMain",
                                options: {
                                },
                                on: {
                                    onChange: function (newv, oldv) {
                                    }
                                }
                            },
                            {},
                            {
                                id: "pagerA",
                                view: "pager",
                                size: 50,
                                group: 5,
                                on: {
                                    onAfterPageChange: function (id) {
                                    }
                                },
                                template: function (data, common) {
                                    return "Số dòng: " + data.count + ". " + common.first(data) + common.prev(data) + common.pages(data) + common.next(data) + common.last(data);
                                }
                            },
                            {}
                        ]
                    }
                ]
            };
            return grid;
        },
        gridWbSetting: function () {
            var grid =
            {
                rows: [
                    {
                        view: "datatable",
                        id: "wbsettingViews",
                        select: true,
                        resizeColumn: true,
                        fixedRowHeight: false,
                        rowLineHeight: 25, rowHeight: 25,
                        tooltip: true,
                        headermenu: {
                            autoheight: false,
                            scroll: true,
                            autowidth: true
                        },
                        multiview: { keepViews: true },
                        keepViews: true,
                        hover: "myhover",
                        url: {
                            $proxy: true,
                            load: function (view, callback, params) {
                                var start = null;
                                var count = null;
                                var filter = [];
                                var infoparam = null;
                                var tlbparam_s = [];
                                var url = app.config.host + "/Pattern/GetData";
                                if (params == null) {
                                    start = 0;
                                    count = view.config.datafetch;
                                    url = url + "?command=CM0029&start=0&count=" + view.config.datafetch + "&continue=null&filter=null";
                                }
                                else {
                                    start = params.start;
                                    count = params.count;
                                    url = url + "?command=CM0029&start=" + params.start + "&count=" + params.count + "&continue=" + params.continue;
                                    if (params.filter != null) {
                                        console.log(params);
                                        var array = [];
                                        for (var property in params.filter) {
                                            var column = view.getColumnConfig(property);
                                            var item = {
                                                columnName: property,
                                                columnType: column.columnType,
                                                value: params.filter[property]
                                            };
                                            array.push(item);
                                        }
                                        if (array.length > 0) {
                                            filter = array;
                                            url = url + "&filter=" + JSON.stringify(array);
                                        }
                                        else {
                                            url = url + "&filter=null";
                                        }
                                    }
                                }
                                var item = {
                                    command: "CM0029",
                                    start: start,
                                    count: count,
                                    filter: filter,
                                    tlbparam: tlbparam_s
                                };
                                var apiHost = app.config.host + "/Pattern/GetData";
                                webix.ajax()
                                    .headers({ 'Content-type': 'application/json' })
                                    .bind(view)
                                    .post(apiHost, item, callback, view);
                            }
                        },
                        onClick: {
                        },
                        on: {
                            "data->onStoreUpdated": function () {
                                this.data.each(function (obj, i) {
                                    obj.stt = i + 1;
                                });
                            },
                            onItemClick: function (id) {
                            },
                            onClick: function (e) {
                            },
                            onItemDblClick: function (id, e, node) {
                                var btnEdit = $$("btnEdit");
                                btnEdit.callEvent("onClick");
                            },
                            onBeforeLoad: function () {
                                webix.extend(this, webix.ProgressBar);
                                this.showProgress({
                                    type: "top"
                                });
                            },
                            onAfterLoad: function () {
                                this.hideProgress();
                                if (!this.count())
                                    this.showOverlay("<div><img src='assets/imgs/nodata.png'><div class='showOverlaydata'>Không có dữ liệu </br> Chúng tôi không tìm thấy hóa đơn</div></div>");
                                else
                                    this.hideOverlay();
                            },
                            onHeaderClick: function (header, event, target) {
                            },
                            onAfterRender: function () {
                            },
                            onColumnResize: function () {
                            },
                            onSubViewCreate: function (view, item) {
                            },
                            onAfterDelete: function (id) {
                            },
                        },
                        checkboxRefresh: true,
                        columns: [
                            {
                                id: "stt",
                                header: ["STT", { content: "textFilter" }],
                                sort: "int",
                                width: 40,
                                // hidden: true
                            },
                            { id: "ma", header: [_("MA"), { content: "serverFilter" }], width: 200, columnType: "nvarchar", editor: "text", sort: "string" },
                            { id: "dien_giai", header: [_("DIEN_GIAI"), { content: "serverFilter" }], width: 400, columnType: "nvarchar" },
                            { id: "gia_tri", header: [_("GIA_TRI"), { content: "serverFilter" }], width: 200, columnType: "nvarchar", editor: "text", sort: "string" },
                            { id: "ma_dvcs", header: [_("MA_DVCS"), { content: "serverFilter" }], width: 150, columnType: "nvarchar", editor: "text", sort: "string" }
                        ],
                        pager: "pagerA"
                    },
                    {
                        cols: [
                            {
                                view: "button",
                                type: "icon",
                                icon: "fas fa-th-list",
                                tooltip: "chọn nhiều chứng từ",
                                width: 30,
                                on: {
                                    onClick: function () {
                                        changeMultiChoice();
                                    }
                                },
                                click: function () {
                                    this.callEvent("onClick");
                                }
                            },
                            {
                                view: "icon", icon: "fas fa-question-circle", id: "help_form_main", tooltip: _("HELPER"),
                                css: "helper",
                                click: function () {
                                    var newWin = window.open();
                                    newWin.location = "http://huongdansudung.minvoice.com.vn/Tomihoadon.html";
                                }
                            },
                            {
                                view: "combo",
                                label: _("MENU_QUICK"),
                                id: "QuickMenuMain",
                                options: {
                                },
                                on: {
                                    onChange: function (newv, oldv) {
                                    }
                                }
                            },
                            {},
                            {
                                id: "pagerA",
                                view: "pager",
                                size: 50,
                                group: 5,
                                on: {
                                    onAfterPageChange: function (id) {
                                    }
                                },
                                template: function (data, common) {
                                    return "Số dòng: " + data.count + ". " + common.first(data) + common.prev(data) + common.pages(data) + common.next(data) + common.last(data);
                                }
                            },
                            {}
                        ]
                    }
                ]
            };
            return grid;
        },
        gridWbCronjobInvoiceSigningPos: function () {
            var grid =
            {
                rows: [
                    {
                        view: "datatable",
                        id: "wbCronjobInvoiceSigningPos",
                        select: true,
                        resizeColumn: true,
                        fixedRowHeight: false,
                        rowLineHeight: 25, rowHeight: 25,
                        tooltip: true,
                        headermenu: {
                            autoheight: false,
                            scroll: true,
                            autowidth: true
                        },
                        multiview: { keepViews: true },
                        keepViews: true,
                        hover: "myhover",
                        url: {
                            $proxy: true,
                            load: function (view, callback, params) {
                                var start = null;
                                var count = null;
                                var filter = [];
                                var infoparam = null;
                                var tlbparam_s = [];
                                var url = app.config.host + "/Pattern/GetData";
                                if (params == null) {
                                    start = 0;
                                    count = view.config.datafetch;
                                    url = url + "?command=CM0035&start=0&count=" + view.config.datafetch + "&continue=null&filter=null";
                                }
                                else {
                                    start = params.start;
                                    count = params.count;
                                    url = url + "?command=CM0035&start=" + params.start + "&count=" + params.count + "&continue=" + params.continue;
                                    if (params.filter != null) {
                                        var array = [];
                                        for (var property in params.filter) {
                                            var valueFilter = params.filter[property];
                                            if (valueFilter != '' && valueFilter != 'thirdState') {
                                                var column = view.getColumnConfig(property);
                                                var item = {
                                                    columnName: property,
                                                    columnType: column.columnType,
                                                    value: params.filter[property]
                                                };
                                                array.push(item);
                                            }
                                        }
                                        if (array.length > 0) {
                                            filter = array;
                                            url = url + "&filter=" + JSON.stringify(array);
                                        }
                                        else {
                                            url = url + "&filter=null";
                                        }
                                    }
                                }
                                var item = {
                                    command: "CM0035",
                                    start: start,
                                    count: count,
                                    filter: filter,
                                    tlbparam: tlbparam_s
                                };
                                var apiHost = app.config.host + "/Pattern/GetData";
                                webix.ajax()
                                    .headers({ 'Content-type': 'application/json' })
                                    .bind(view)
                                    .post(apiHost, item, callback, view);
                            }
                        },
                        onClick: {
                        },
                        on: {
                            "data->onStoreUpdated": function () {
                                this.data.each(function (obj, i) {
                                    obj.stt = i + 1;
                                });
                            },
                            onItemClick: function (id) {
                            },
                            onClick: function (e) {
                            },
                            onItemDblClick: function (id, e, node) {
                                var btnEdit = $$("btnEdit");
                                btnEdit.callEvent("onClick");
                            },
                            onBeforeLoad: function () {
                                webix.extend(this, webix.ProgressBar);
                                this.showProgress({
                                    type: "top"
                                });
                            },
                            onAfterLoad: function () {
                                this.hideProgress();
                                if (!this.count())
                                    this.showOverlay("<div><img src='assets/imgs/nodata.png'><div class='showOverlaydata'>Không có dữ liệu </br> Chúng tôi không tìm thấy hóa đơn</div></div>");
                                else
                                    this.hideOverlay();
                            },
                            onHeaderClick: function (header, event, target) {
                            },
                            onAfterRender: function () {
                            },
                            onColumnResize: function () {
                            },
                            onSubViewCreate: function (view, item) {
                            },
                            onAfterDelete: function (id) {
                            },
                        },
                        checkboxRefresh: true,
                        columns: [
                            { id: "stt", header: ["STT"], sort: "int", width: 40 },
                            { id: "khieu", header: ["Ký hiệu", { content: "serverFilter" }], width: 200, columnType: "nvarchar", editor: "text", sort: "string" },
                            {
                                id: "run_cycle",
                                header: ["Chu kỳ chạy (phút)", { content: "serverFilter" }],
                                width: 200,
                                sort: "string",
                                columnType: "nvarchar",
                                css: { "text-align": "right" },
                            },
                            { id: "number_record", header: ["Số bản ghi", { content: "serverFilter" }], width: 100, columnType: "nvarchar", css: { "text-align": "right" } },
                            { id: "scan_start_time", header: ["Thời gian bắt đầu quét (giờ)", { content: "serverFilter" }], width: 200, columnType: "nvarchar", editor: "text", sort: "string", css: { "text-align": "right" } },
                            { id: "scan_end_time", header: ["Thời gian kết thúc quét (giờ)", { content: "serverFilter" }], width: 200, columnType: "nvarchar", editor: "text", sort: "string", css: { "text-align": "right" } },
                            {
                                id: "is_active",
                                header: ["Sử dụng", { content: "filterCheckBox" }],
                                width: 100,
                                columnType: "bit",
                                css: "center",
                                template: function (obj) {
                                    var checked = obj.is_active == "1" ? 'checked="true"' : "";
                                    return ("<input disabled class='webix_table_checkbox' type='checkbox' " + checked + ">");
                                },
                            },
                        ],
                        pager: "pagerA"
                    },
                    {
                        cols: [
                            {
                                view: "icon", icon: "fas fa-question-circle", id: "help_form_main", tooltip: _("HELPER"),
                                css: "helper",
                                click: function () {
                                    var newWin = window.open();
                                    newWin.location = "http://huongdansudung.minvoice.com.vn/Tomihoadon.html";
                                }
                            },
                            {
                                view: "combo",
                                label: _("MENU_QUICK"),
                                id: "QuickMenuMain",
                                options: {
                                },
                                on: {
                                    onChange: function (newv, oldv) {
                                    }
                                }
                            },
                            {},
                            {
                                id: "pagerA",
                                view: "pager",
                                size: 50,
                                group: 5,
                                on: {
                                    onAfterPageChange: function (id) {
                                    }
                                },
                                template: function (data, common) {
                                    return "Số dòng: " + data.count + ". " + common.first(data) + common.prev(data) + common.pages(data) + common.next(data) + common.last(data);
                                }
                            },
                            {}
                        ]
                    }
                ]
            };
            return grid;
        },
        gridComponent: function (props) {
            var datatableId = props.datatableId;
            var commandId = props.commandId;
            var paramterId = props.paramterId;
            var datatableDetailId = "hoadon68_chitiet_view";
            var apiGetDetails = props.apiGetDetails;
            var datatableDetailHeader = props.datatableDetailHeader;
            var colsMaster = props.colsMaster;
            var colsDetail = props.colsDetail;
            var loai = props.loai;
            var grid =
            {
                rows: [
                    {
                        view: "datatable",
                        id: datatableId,
                        select: true,
                        resizeColumn: true,
                        fixedRowHeight: false,
                        leftSplit: 8,
                        rowLineHeight: 25, rowHeight: 25,
                        tooltip: true,
                        footer: true,
                        headermenu: {
                            autoheight: false,
                            scroll: true,
                            autowidth: true,
                        },
                        multiview: { keepViews: true },
                        keepViews: true,
                        editable: false,
                        hover: "myhover",
                        url: {
                            $proxy: true,
                            load: function (view, callback, params) {
                                var start = (params && params.start) || 0;
                                var count = (params && params.count) || view.config.datafetch;
                                var filter = [{
                                    columnName: "loai",
                                    columnType: "int",
                                    value: loai
                                }];
                                var tlbparam_s = [];

                                if (params && params.filter) {
                                    for (var key in params.filter) {
                                        if (params.filter.hasOwnProperty(key)) {
                                            var val = params.filter[key];
                                            if (val != null && val.toString() !== "") {
                                                var columnCfg = view.getColumnConfig(key);
                                                filter.push({
                                                    columnName: key,
                                                    columnType: columnCfg.columnType,
                                                    value: val
                                                });
                                            }
                                        }
                                    }
                                }

                                var tlbParams = $$(paramterId);
                                if (tlbParams) {
                                    var childViews = tlbParams.getChildViews();
                                    for (var i = 0; i < childViews.length; i++) {
                                        var id = childViews[i].config.id;
                                        var val = $$(id).getValue();
                                        if (val == null || val === "") {
                                            $$(datatableId).hideProgress();
                                            $$(datatableId).hideOverlay();
                                            $$(datatableId).showOverlay(
                                                "<div><img src='assets/imgs/nodata.png'><div class='showOverlaydata'>Bạn chưa chọn ký hiệu, hoặc chưa được phân quyền ký hiệu hóa đơn</div></div>"
                                            );
                                            return;
                                        }
                                        tlbparam_s.push({
                                            columnName: "cctbao_id",
                                            value: val
                                        });
                                    }
                                }

                                var item = {
                                    command: commandId,
                                    start: start,
                                    count: count,
                                    filter: filter,
                                    tlbparam: tlbparam_s
                                };

                                webix.ajax()
                                    .headers({ 'Content-type': 'application/json' })
                                    .bind(view)
                                    .post(app.config.host + "/Pattern/GetData", item, callback, view);
                            }
                        },
                        onClick: {
                        },
                        type: {
                            mCheckbox: function (obj, common, value, config) {
                                var checked = (value == config.checkValue) ? 'checked="true"' : '';
                                return "<input disabled class='webix_table_checkbox' type='checkbox' " + checked + ">";
                            },
                            mAmount: function (obj, common, value, config) {
                                return value == null ? 0 : formatDecimal(value);
                            }
                        },
                        on: {
                            "data->onStoreUpdated": function () {
                                this.data.each(function (obj, i) {
                                    obj.stt = i + 1;
                                });
                            },
                            onItemClick: function (id) { },
                            onClick: function (e) { },
                            onItemDblClick: function (id, e, node) {
                                var btnEdit = $$("btnEdit");
                                btnEdit.callEvent("onClick");
                            },
                            onBeforeLoad: function () {
                                webix.extend(this, webix.ProgressBar);
                                this.showProgress({ type: "top" });
                            },
                            onAfterLoad: function () {
                                this.hideProgress();
                                if (!this.count())
                                    this.showOverlay("<div><img src='assets/imgs/nodata.png'><div class='showOverlaydata'>Không có dữ liệu </br> Chúng tôi không tìm thấy hóa đơn</div></div>");
                                else
                                    this.hideOverlay();
                                $$("cmenu").attachTo($$(datatableId));
                            },
                            onHeaderClick: function (header, event, target) { },
                            onAfterRender: function () { },
                            onColumnResize: function () { },
                            onSubViewCreate: function (view, item) {
                                var subView = view;
                                if (subView != null) {
                                    var tableDetail = webix.$$(datatableDetailId);
                                    tableDetail.clearAll();
                                    tableDetail.load(app.config.host + apiGetDetails + item.id);
                                }
                            },
                            onBeforeEditStart: function (id) { }
                        },
                        subview: {
                            borderless: true,
                            view: "tabview",
                            height: 255,
                            css: "subInvoice",
                            scrollX: true,
                            multiview: {
                                fitBiggest: true
                            },
                            cells: [
                                {
                                    header: datatableDetailHeader,
                                    select: "cell",
                                    body: {
                                        view: "datatable",
                                        resizeColumn: true,
                                        margin: 10,
                                        id: datatableDetailId,
                                        height: 200,
                                        columns: colsDetail,
                                        on: {
                                            onBeforeLoad: function () { this.showOverlay(_("LOADING") + "..."); },
                                            onAfterLoad: function () { this.hideOverlay(); }
                                        }
                                    }
                                }
                            ]
                        },
                        checkboxRefresh: true,
                        columns: colsMaster,
                        pager: "pagerA"
                    },
                    {
                        cols: [
                            {
                                view: "button",
                                type: "icon",
                                icon: "fas fa-th-list",
                                tooltip: "chọn nhiều chứng từ",
                                width: 30,
                                on: {
                                    onClick: function () { changeMultiChoiceId(datatableId); }
                                },
                                click: function () {
                                    this.callEvent("onClick");
                                }
                            },
                            {
                                view: "icon", icon: "fas fa-question-circle", id: "help_form_main", tooltip: _("HELPER"),
                                css: "helper",
                                click: function () {
                                    var newWin = window.open();
                                    newWin.location = "https://hdsd.minvoice.com.vn/tutorials/thao-tac/dang-nhap/";
                                }
                            },
                            {},
                            {
                                id: "pagerA",
                                view: "pager",
                                size: 50,
                                group: 5,
                                on: {
                                    onAfterPageChange: function (id) {
                                    }
                                },
                                template: function (data, common) {
                                    return "Số dòng: " + data.count + ". " + common.first(data) + common.prev(data) + common.pages(data) + common.next(data) + common.last(data);
                                }
                            },
                            {}
                        ]
                    }
                ]
            };
            return grid;
        },
        gridDMKH: function (props) {
            var window_id = props.window_id;
            var tabTableNameBank = props.tabTableNameBank;
            var datatableId = props.datatableId;
            var datatableDetailId = props.datatableDetailId;
            var apiGetDetails = props.apiGetDetails;
            var datatableDetailHeader = props.datatableDetailHeader;
            var colsMaster = props.colsMaster;
            var colsDetail = props.colsDetail;
            var grid = {
                rows: [
                    {
                        view: "datatable",
                        id: datatableId,
                        select: true,
                        resizeColumn: true,
                        datafetch: 50,
                        pager: "pagerA",
                        fixedRowHeight: false,
                        leftSplit: 8,
                        rowLineHeight: 25, rowHeight: 25,
                        tooltip: true,
                        checkboxRefresh: true,
                        headermenu: {
                            autoheight: false,
                            scroll: true,
                            autowidth: true,
                        },
                        multiview: { keepViews: true },
                        keepViews: true,
                        editable: false,
                        hover: "myhover",
                        url: {
                            $proxy: true,
                            load: function (view, callback, params) {
                                webix.extend(view, webix.ProgressBar);
                                view.disable();
                                view.showProgress();
                                var start = null;
                                var count = null;
                                var filter = [];
                                var tlbparam_s = [];
                                if (params == null) {
                                    start = 0;
                                    count = view.config.datafetch;
                                }
                                else {
                                    start = params.start;
                                    count = params.count;
                                    if (params.filter != null) {
                                        var array = [];
                                        for (var property in params.filter) {
                                            var column = view.getColumnConfig(property);
                                            var item = {
                                                columnName: property,
                                                columnType: column.columnType,
                                                value: params.filter[property]
                                            };
                                            array.push(item);
                                        }
                                        filter = array;
                                    }
                                }
                                var item = {
                                    window_id: window_id,
                                    start: start,
                                    count: count,
                                    filter: filter,
                                    tlbparam: tlbparam_s
                                };

                                var apiHost = app.config.host + "/System/GetDataByWindowNo1";
                                webix.ajax()
                                    .headers({ 'Content-type': 'application/json' })
                                    .bind(view)
                                    .post(apiHost, item, callback, view);
                            }
                        },
                        columns: colsMaster,
                        type: {
                            mCheckbox: function (obj, common, value, config) {
                                var checked = (value == config.checkValue) ? 'checked="true"' : '';
                                return "<input disabled class='webix_table_checkbox' type='checkbox' " + checked + ">";
                            },
                        },
                        onClick: {
                        },
                        on: {
                            "data->onStoreUpdated": function () {
                                this.data.each(function (obj, i) {
                                    obj.stt = i + 1;
                                });
                            },
                            onItemClick: function (id) { },
                            onClick: function (e) { },
                            onItemDblClick: function (id, e, node) {
                                var btnEdit = $$("btnEditCustomer");
                                btnEdit.callEvent("click");
                            },
                            onBeforeLoad: function () {
                                webix.extend(this, webix.ProgressBar);
                                this.showProgress({ type: "top" });
                            },
                            onAfterLoad: function () {
                                this.hideProgress();
                                this.enable();
                                if (!this.count())
                                    this.showOverlay("<div><img src='assets/imgs/nodata.png'><div class='showOverlaydata'>Không có dữ liệu </br> Chúng tôi không tìm thấy hóa đơn</div></div>");
                                else
                                    this.hideOverlay();
                                $$("cmenu").attachTo($$(datatableId));
                            },
                            onHeaderClick: function (header, event, target) { },
                            onAfterRender: function () { },
                            onColumnResize: function () { },
                            onSubViewCreate: function (view, item) {
                                var subView = view;
                                if (subView != null) {
                                    var tableDetail = webix.$$(datatableDetailId);
                                    tableDetail.clearAll();
                                    tableDetail.load(app.config.host + apiGetDetails + "?window_id=" + window_id + "&id=" + item.id + "&tab_table=" + tabTableNameBank);
                                }
                            },
                            onBeforeEditStart: function (id) { }
                        },
                        subview: {
                            borderless: true,
                            view: "tabview",
                            height: 255,
                            css: "subInvoice",
                            scrollX: true,
                            multiview: {
                                fitBiggest: true
                            },
                            cells: [
                                {
                                    header: datatableDetailHeader,
                                    select: "cell",
                                    body: {
                                        view: "datatable",
                                        resizeColumn: true,
                                        margin: 10,
                                        id: datatableDetailId,
                                        height: 200,
                                        columns: colsDetail,
                                        on: {
                                            onBeforeLoad: function () { this.showOverlay(_("LOADING") + "..."); },
                                            onAfterLoad: function () { this.hideOverlay(); }
                                        }
                                    }
                                }
                            ]
                        }
                    },
                    {
                        cols: [
                            {
                                view: "button",
                                type: "icon",
                                icon: "fas fa-th-list",
                                tooltip: "Chọn nhiều dòng",
                                width: 30,
                                on: {
                                    onClick: function () { changeMultiChoiceId(datatableId); }
                                },
                                click: function () {
                                    this.callEvent("onClick");
                                }
                            },
                            {
                                view: "icon", icon: "fas fa-question-circle", id: "help_form_main", tooltip: _("HELPER"),
                                css: "helper",
                                click: function () {
                                    var newWin = window.open();
                                    newWin.location = "https://hdsd.minvoice.com.vn/tutorials/thao-tac/dang-nhap/";
                                }
                            },
                            {},
                            {
                                id: "pagerA",
                                view: "pager",
                                size: 50,
                                group: 5,
                                on: {
                                    onAfterPageChange: function (id) {
                                    }
                                },
                                template: function (data, common) {
                                    return "Số dòng: " + data.count + ". " + common.first(data) + common.prev(data) + common.pages(data) + common.next(data) + common.last(data);
                                }
                            },
                            {}
                        ]
                    }
                ]
            };
            return grid;
        }
    }
});
define('views/forms/forms68/EXCEL/68_uploadExcel_chitiet',["app", "locale"], function (app, _) {
    var hoadon68_id;
    return {
        $ui: {
            view: "window", modal: true, id: "uploadfile-win78", position: "center",
            head: "Nhận chi tiết hóa đơn từ file Excel",
            width: 500,
            height: 500,
            body: {
                paddingY: 10,
                paddingX: 10,
                elementsConfig: { labelWidth: 100 },
                view: "form",
                id: "uploadfile-form78",
                complexData: true,
                elements: [
                    {
                        cols: [
                            {
                                view: "toolbar",
                                css: { "background": "#e6f7ff !important" },
                                rows: [
                                    // { gravity: 2 },
                                    {
                                        view: "button", type: "icon", css: "btnExcel", icon: "fas fa-folder-open", label: "Chọn file", width: 110,
                                        on: {
                                            onClick: function () {
                                                webix.$$("uploader").fileDialog();
                                            }
                                        },
                                        click: function () {
                                            this.callEvent("onClick");
                                        }
                                    },
                                    {
                                        view: "button", type: "icon", css: { "background-color": "#e6f7ff !important" }, icon: "fas fa-download", label: "Tải file mẫu", width: 110,
                                        on: {
                                            onClick: function () {
                                                var uploader = webix.$$("uploader");
                                                var formData = uploader.config.formData;
                                                var table = $$("uploadfile-win78");

                                                webix.extend(table, webix.ProgressBar);
                                                table.disable();
                                                table.showProgress();
                                                webix.ajax()
                                                    .response("arraybuffer")
                                                    .headers({ 'Content-type': 'application/json' })
                                                    .get(app.config.host + "/Invoice68/DownloadFileExcelTemplateDetail",
                                                        {
                                                            error: function (text, data, XmlHttpRequest) {
                                                                webix.message(text + data.toString(), "error");
                                                                table.enable();
                                                                table.hideProgress();
                                                            },
                                                            success: function (text, data, XmlHttpRequest) {

                                                                webix.delay(function () {
                                                                    var file = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                                                                    var fileURL = URL.createObjectURL(file);

                                                                    var link = document.createElement('a');
                                                                    document.body.appendChild(link);
                                                                    link.download = "ExcelTemplate_Detail.xlsx";
                                                                    link.href = fileURL;
                                                                    link.click();
                                                                    document.body.removeChild(link); // remove the link when done
                                                                    //document.location.href = fileURL;
                                                                }, null, null, 500);

                                                                table.enable();
                                                                table.hideProgress();
                                                                // })
                                                            }
                                                        }
                                                    );
                                            }
                                        },
                                        click: function () {
                                            this.callEvent("onClick");
                                        }
                                    },
                                    {
                                        shortcut: "F10", view: "button", css: { "background": "#e6f7ff !important" }, type: "icon", icon: "fas fa-check", label: "Nhận file (F10)", width: 120, on: {
                                            onClick: function () {
                                                var table = $$("uploadfile-win78");

                                                let tableName = webix.$$("invoiceViews");
                                                if (tableName.getSelectedItem() == null) {
                                                    return webix.message("Chưa chọn dòng dữ liệu.", "error");
                                                }
                                                const item = tableName.getSelectedItem();
                                                webix.$$("uploader").define("formData", { id: item.id });
           
                                                webix.extend(table, webix.ProgressBar);
                                                table.disable();
                                                table.showProgress();
                                                var file = $$("uploader").files.getFirstId();
                                                if (file == undefined || file == null) {
                                                    webix.message("Bạn chưa chọn file !", "error");
                                                    $$("uploadfile-win78").enable();
                                                    $$("uploadfile-win78").hideProgress();
                                                    return;
                                                }
                                                $$("uploader").send(function (response) {

                                                    if (response != undefined) {
                                                        if (response.code == "00") {
                                                            $$("uploadfile-win78").enable();
                                                            $$("uploadfile-win78").hideProgress();
                                                            //this.callEvent("onUploadComplete");
                                                            // success call event onUploadComplete ở trên 
                                                            var topParentView = this.getTopParentView();

                                                            if (topParentView.config.tableId !== undefined) {
                                                                var table = $$(topParentView.config.tableId);

                                                                if (table != null) {
                                                                    table.clearAll();
                                                                    table.load(table.config.url);
                                                                }
                                                            }

                                                            webix.alert({
                                                                title: "Thành công !",
                                                                text: "Nhận dữ liệu Excel thành công !",
                                                                type: "alert-warning",
                                                                callback: function (result) {
                                                                    webix.$$("uploadfile-win78").close();
                                                                }
                                                            });
                                                            //webix.message("Nhận dữ liệu Excel thành công !", "debug");
                                                        }
                                                        else {
                                                            $$("uploadfile-win78").enable();
                                                            $$("uploadfile-win78").hideProgress();

                                                            webix.alert({
                                                                title: "Lỗi !",
                                                                text: response.message,
                                                                type: "alert-error"
                                                            });
                                                            //webix.message(response.error, "error");
                                                        }
                                                    }
                                                    else {
                                                        $$("uploadfile-win78").enable();
                                                        $$("uploadfile-win78").hideProgress();
                                                    }
                                                });
                                            }
                                        },
                                        click: function () {
                                            this.callEvent("onClick");
                                        }
                                    },
                                    {
                                        hotkey: "esc", view: "button", css: { "background": "#e6f7ff !important" }, type: "icon", icon: "fas fa-times", label: "Hủy bỏ (ESC)", width: 110,
                                        on: {
                                            onClick: function () {
                                                $$("mylist").clearAll();
                                                $$("mylist").unbind();
                                                var id = $$("uploader").files.getFirstId();
                                                if (id != undefined) {
                                                    $$("uploader").stopUpload(id);
                                                }
                                                webix.$$("uploadfile-win78").close();
                                            }
                                        },
                                        click: function () {
                                            this.callEvent("onClick");
                                        }
                                    }

                                ]
                            },
                            {
                                rows: [
                                    // {view:"text",id:"df",label:"errr"},
                                    {
                                        id: "uploader",
                                        view: "uploader",
                                        value: 'Chọn file',
                                        hide: true,
                                        name: "uploader",
                                        accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                                        link: "mylist",
                                        autosend: false,
                                        //borderless: true,
                                        multiple: false,
                                        upload: app.config.host + "/Invoice68/UploadExcelDetail",

                                        on: {
                                            onClick: function () {
                                            },
                                            onAfterRender: function () {
                                                this.hide();
                                            },
                                            onAfterFileAdd: function (file) {
                                                $$("mylist").refresh();

                                            },
                                            onUploadComplete: function (response) {
                                            },
                                            onFileUploadError: function (file, response) {
                                                console.log(file);
                                                console.log(response);
                                                $$("uploadfile-win78").enable();
                                                $$("uploadfile-win78").hideProgress();
                                            }
                                        },
                                        apiOnly: true,
                                    },
                                    {
                                        view: "list",
                                        id: "mylist",
                                        type: "uploader",
                                        height: 100,
                                        borderless: true
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        },
        setEditMode: function (id) {
            hoadon68_id = id;
        }
    };

});
define('views/forms/forms68/EXCEL/68_uploadExxcel_chitiet_0102294599',["app", "locale"], function (app, _) {
    var hoadon68_id;
    return {
        $ui: {
            view: "window", modal: true, id: "uploadfile-win78-gpd", position: "center",
            head: "Nhận chi tiết hóa đơn từ file Excel",
            width: 500,
            height: 500,
            body: {
                paddingY: 10,
                paddingX: 10,
                elementsConfig: { labelWidth: 100 },
                view: "form",
                id: "uploadfile-form78-gpd",
                complexData: true,
                elements: [
                    {
                        cols: [
                            {
                                view: "toolbar",
                                css: { "background": "#e6f7ff !important" },
                                rows: [
                                    // { gravity: 2 },
                                    {
                                        view: "button", type: "icon", css: "btnExcel", icon: "fas fa-folder-open", label: "Chọn file", width: 110,
                                        on: {
                                            onClick: function () {
                                                webix.$$("uploader").fileDialog();
                                            }
                                        },
                                        click: function () {
                                            this.callEvent("onClick");
                                        }
                                    },
                                    {
                                        view: "button", type: "icon", css: { "background-color": "#e6f7ff !important" }, icon: "fas fa-download", label: "Tải file mẫu", width: 110,
                                        on: {
                                            onClick: function () {
                                                var uploader = webix.$$("uploader");
                                                var formData = uploader.config.formData;
                                                var table = $$("uploadfile-win78-gpd");

                                                webix.extend(table, webix.ProgressBar);
                                                table.disable();
                                                table.showProgress();
                                                webix.ajax()
                                                    .response("arraybuffer")
                                                    .headers({ 'Content-type': 'application/json' })
                                                    .get(app.config.host + "/Invoice68/DownloadFileExcelTemplateDetailGPDong",
                                                        {
                                                            error: function (text, data, XmlHttpRequest) {
                                                                webix.message(text + data.toString(), "error");
                                                                table.enable();
                                                                table.hideProgress();
                                                            },
                                                            success: function (text, data, XmlHttpRequest) {

                                                                webix.delay(function () {
                                                                    var file = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                                                                    var fileURL = URL.createObjectURL(file);

                                                                    var link = document.createElement('a');
                                                                    document.body.appendChild(link);
                                                                    link.download = "ExcelTemplate_Detail.xlsx";
                                                                    link.href = fileURL;
                                                                    link.click();
                                                                    document.body.removeChild(link); // remove the link when done
                                                                    //document.location.href = fileURL;
                                                                }, null, null, 500);

                                                                table.enable();
                                                                table.hideProgress();
                                                                // })
                                                            }
                                                        }
                                                    );
                                            }
                                        },
                                        click: function () {
                                            this.callEvent("onClick");
                                        }
                                    },
                                    {
                                        shortcut: "F10", view: "button", css: { "background": "#e6f7ff !important" }, type: "icon", icon: "fas fa-check", label: "Nhận file (F10)", width: 120, on: {
                                            onClick: function () {
                                                var table = $$("uploadfile-win78-gpd");

                                                let tableName = webix.$$("invoiceViews");
                                                if (tableName.getSelectedItem() == null) {
                                                    return webix.message("Chưa chọn dòng dữ liệu.", "error");
                                                }
                                                const item = tableName.getSelectedItem();
                                                webix.$$("uploader").define("formData", { id: item.id });
           
                                                webix.extend(table, webix.ProgressBar);
                                                table.disable();
                                                table.showProgress();
                                                var file = $$("uploader").files.getFirstId();
                                                if (file == undefined || file == null) {
                                                    webix.message("Bạn chưa chọn file !", "error");
                                                    $$("uploadfile-win78-gpd").enable();
                                                    $$("uploadfile-win78-gpd").hideProgress();
                                                    return;
                                                }
                                                $$("uploader").send(function (response) {

                                                    if (response != undefined) {
                                                        if (response.code == "00") {
                                                            $$("uploadfile-win78-gpd").enable();
                                                            $$("uploadfile-win78-gpd").hideProgress();
                                                            //this.callEvent("onUploadComplete");
                                                            // success call event onUploadComplete ở trên 
                                                            var topParentView = this.getTopParentView();

                                                            if (topParentView.config.tableId !== undefined) {
                                                                var table = $$(topParentView.config.tableId);

                                                                if (table != null) {
                                                                    table.clearAll();
                                                                    table.load(table.config.url);
                                                                }
                                                            }

                                                            webix.alert({
                                                                title: "Thành công !",
                                                                text: "Nhận dữ liệu Excel thành công !",
                                                                type: "alert-warning",
                                                                callback: function (result) {
                                                                    webix.$$("uploadfile-win78-gpd").close();
                                                                }
                                                            });
                                                            //webix.message("Nhận dữ liệu Excel thành công !", "debug");
                                                        }
                                                        else {
                                                            $$("uploadfile-win78-gpd").enable();
                                                            $$("uploadfile-win78-gpd").hideProgress();

                                                            webix.alert({
                                                                title: "Lỗi !",
                                                                text: response.message,
                                                                type: "alert-error"
                                                            });
                                                            //webix.message(response.error, "error");
                                                        }
                                                    }
                                                    else {
                                                        $$("uploadfile-win78-gpd").enable();
                                                        $$("uploadfile-win78-gpd").hideProgress();
                                                    }
                                                });
                                            }
                                        },
                                        click: function () {
                                            this.callEvent("onClick");
                                        }
                                    },
                                    {
                                        hotkey: "esc", view: "button", css: { "background": "#e6f7ff !important" }, type: "icon", icon: "fas fa-times", label: "Hủy bỏ (ESC)", width: 110,
                                        on: {
                                            onClick: function () {
                                                $$("mylist").clearAll();
                                                $$("mylist").unbind();
                                                var id = $$("uploader").files.getFirstId();
                                                if (id != undefined) {
                                                    $$("uploader").stopUpload(id);
                                                }
                                                webix.$$("uploadfile-win78-gpd").close();
                                            }
                                        },
                                        click: function () {
                                            this.callEvent("onClick");
                                        }
                                    }

                                ]
                            },
                            {
                                rows: [
                                    // {view:"text",id:"df",label:"errr"},
                                    {
                                        id: "uploader",
                                        view: "uploader",
                                        value: 'Chọn file',
                                        hide: true,
                                        name: "uploader",
                                        accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                                        link: "mylist",
                                        autosend: false,
                                        //borderless: true,
                                        multiple: false,
                                        upload: app.config.host + "/Invoice68/UploadExcelDetailGPdong",

                                        on: {
                                            onClick: function () {
                                            },
                                            onAfterRender: function () {
                                                this.hide();
                                            },
                                            onAfterFileAdd: function (file) {
                                                $$("mylist").refresh();

                                            },
                                            onUploadComplete: function (response) {
                                            },
                                            onFileUploadError: function (file, response) {
                                                console.log(file);
                                                console.log(response);
                                                $$("uploadfile-win78-gpd").enable();
                                                $$("uploadfile-win78-gpd").hideProgress();
                                            }
                                        },
                                        apiOnly: true,
                                    },
                                    {
                                        view: "list",
                                        id: "mylist",
                                        type: "uploader",
                                        height: 100,
                                        borderless: true
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        },
        setEditMode: function (id) {
            hoadon68_id = id;
        }
    };

});
define('views/forms/forms68/HDon/68_petro',["app", "locale",
    "views/modules/Component/constantManager",
    "views/modules/Component/componentHelper",
    "views/modules/Component/functionExtension",
    "views/modules/Component/ajaxHelper"],
    function (app, _, constant, componentHelper, functionExtension, Ajax) {

        var idForm = "invoiceForms";
        var idWindow = "invoice68";
        var dvtte = "VND";
        var tgia = 1;
        var editmode = 0;
        var headTitleHoadon = componentHelper.headTitleHoadon("Hóa đơn xăng dầu");
        var dauphieuXangdau = componentHelper.dauphieuXangdau();
        var kyHieuHD = 0;

        /*
        type = 1: lưu hóa đơn vả tắt modal
        type = 2: lưu hóa đơn và xem in (tắt modal)
        type = 3: lưu hóa đơn và không tắt modal
        */
        var funcSaveInvoice = function (type) {
            var formInvoice = $$(idForm);
            if (formInvoice.validate()) {
                var tsuat = webix.rules.isNumber($$("tsuat").getValue()) ? $$("tsuat").getValue() : 0;
                var tgtttbso = webix.rules.isNumber($$("tgtttbso").getValue()) ? $$("tgtttbso").getValue() : 0;
                var tgtcthue = webix.rules.isNumber($$("tgtcthue").getValue()) ? $$("tgtcthue").getValue() : 0;
                var tgtthue = webix.rules.isNumber($$("tgtthue").getValue()) ? $$("tgtthue").getValue() : 0;
                var menu_id = webix.storage.local.get("MENU_ID");
                var item = formInvoice.getValues();
                item.dvtte = dvtte;
                item.tgia = tgia;
                switch (tsuat.toString()) {
                    case "10":
                        item.tgtcthue10 = kyHieuHD == 2 ? null : tgtcthue;
                        item.tgtthue10 = kyHieuHD == 2 ? null : tgtthue;
                        item.ttcktmai10 = kyHieuHD == 2 ? null : 0;
                        item.tgtttbso10 = kyHieuHD == 2 ? null : tgtttbso;
                        break;
                    case "8":
                        item.tgtcthuekhac = kyHieuHD == 2 ? null : tgtcthue;
                        item.tgtthuekhac = kyHieuHD == 2 ? null : tgtthue;
                        item.ttcktmaikhac = kyHieuHD == 2 ? null : 0;
                        item.tgtttbsokhac = kyHieuHD == 2 ? null : tgtttbso;
                        break;
                    case "5":
                        item.tgtcthue5 = kyHieuHD == 2 ? null : tgtcthue;
                        item.tgtthue5 = kyHieuHD == 2 ? null : tgtthue;
                        item.ttcktmai5 = kyHieuHD == 2 ? null : 0;
                        item.tgtttbso5 = kyHieuHD == 2 ? null : tgtttbso;
                        break;
                    case "0":
                        item.tgtcthue0 = kyHieuHD == 2 ? null : tgtcthue;
                        item.tgtthue0 = kyHieuHD == 2 ? null : tgtthue;
                        item.ttcktmai0 = kyHieuHD == 2 ? null : 0;
                        item.tgtttbso0 = kyHieuHD == 2 ? null : tgtttbso;
                        break;
                }
                var dataDetails = [
                    {
                        tchat: 1,
                        stt: 1,
                        ma: $$("ma").getValue(),
                        ten: $$("tenhang").getText(),
                        mdvtinh: $$("mdvtinh").getValue(),
                        dvtinh: $$("dvtinh").getValue(),
                        tsuat: kyHieuHD == 2 ? null : $$("tsuat").getValue(),
                        sluong: $$("sluong").getValue(),
                        dgia: $$("dgia").getValue(),
                        thtien: $$("tgtcthue").getValue(),
                        tthue: kyHieuHD == 2 ? null : $$("tgtthue").getValue(),
                        tgtien: $$("tgtttbso").getValue()
                    }
                ];
                var details = {
                    tab_details: "hoadon68_chitiet",
                    data: dataDetails,
                };
                item["details"] = [details];
                var model = {
                    tab_masters: "hoadon68",
                    menu_id: menu_id,
                    editmode: editmode,
                    data: [item],
                };

                webix.extend(formInvoice, webix.ProgressBar);
                formInvoice.disable();
                formInvoice.showProgress();
                Ajax.POST(constant.API.INVOICE_SAVE, model)
                    .then((data) => {
                        var response = JSON.parse(data);
                        formInvoice.enable();
                        formInvoice.hideProgress();
                        if (response.code == "00") {
                            switch (type) {
                                case 1:
                                    webix.$$(idWindow).close();
                                    break;
                                case 2:
                                    var box = webix.modalbox({
                                        title: "Đang in hóa đơn ....",
                                        text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                                        width: 350,
                                        height: 200,
                                    });
                                    var apiPrint = app.config.host + "/Invoice68/PrintInvoice?id=" + response.data.hoadon68_id + "&type=PDF&inchuyendoi=false";
                                    var newWin = window.open();
                                    var html =
                                        "<html><head><title>Hóa đơn điện tử M-Invoice</title>" +
                                        '<link rel="stylesheet" href="assets/fontawesome_pro/css/all.css" type="text/css" charset="utf-8">' +
                                        '<link rel="stylesheet" href="assets/fontawesome.css" type="text/css" charset="utf-8">' +
                                        '</head><body><center>Đang tải dữ liệu ... <br><p><i style="font-size:200%;" class="fa fa-spin fa-spinner"></i></p></center></body></html>';
                                    newWin.document.write(html);
                                    webix
                                        .ajax()
                                        .response("arraybuffer")
                                        .headers({ "Content-type": "application/json" })
                                        .get(apiPrint, {
                                            error: function (text, data, XmlHttpRequest) {
                                                webix.modalbox.hide(box);
                                                webix.message(XmlHttpRequest.statusText, "error");
                                            },
                                            success: function (text, data, XmlHttpRequest) {
                                                var file = new Blob([data], { type: "application/pdf" });
                                                var fileURL = URL.createObjectURL(file);
                                                webix.modalbox.hide(box);
                                                newWin.location = fileURL;
                                                webix.$$(idWindow).close();
                                            },
                                        });
                                    break;
                                case 3:
                                    $$("tgtttbso").setValue("");
                                    break;
                            }
                            app.callEvent("dataChangedInvoie68", [editmode, response.data,]);
                        } else {
                            webix.message(response.message, "error");
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                        formInvoice.enable();
                        formInvoice.hideProgress();
                        webix.message(error, "error");
                    });
            }
        };
        var tenhang = {
            view: "combo",
            id: "tenhang",
            name: "tenhang",
            label: "Chọn loại hàng",
            required: true,
            invalidMessage: "Tên hàng không được để trống",
            validate: webix.rules.isNotEmpty,
            options: {
                view: "gridsuggest",
                template: "#ten_hang#",
                id: "grddmxangdau",
                body: {
                    scroll: true,
                    autoheight: false,
                    url: constant.API.GET_COMBOBOX_XANGDAU,
                    columns: [
                        { id: "ten_hang", header: _("Loại hàng hóa"), width: 280 },
                        { id: "tsuat", header: _("THUE_SUAT"), width: 90, template: "#tsuat# %", },
                        {
                            id: "dgia", header: _("DON_GIA"), width: 90, format: webix.Number.numToStr({
                                groupDelimiter: ",",
                                groupSize: 3,
                                decimalDelimiter: ".",
                                decimalSize: 0
                            })
                        },
                    ],
                    // dataFeed: function (filtervalue, filter) {
                    //     if (filtervalue.length < 1) {
                    //         this.load(this.config.url);
                    //         return;
                    //     }
                    //     var filter = [{
                    //         "columnName": "ten_hang",
                    //         "columnType": "string",
                    //         "value": filtervalue
                    //     }];
                    //     this.load(constant.API.GET_DM_XANGDAU_FILTER + JSON.stringify(filter), this.config.datatype);
                    // },
                },
                on: {
                    onValueSuggest: function (obj) {
                        $$("tsuat").setValue(obj.tsuat);
                        $$("dgia").setValue(obj.dgia);
                        $$("ma").setValue(obj.ma_hang);
                        $$("mdvtinh").setValue(obj.dvtinh);
                        $$("dvtinh").setValue(obj.dvtinh);
                        var tgtttbsoValue = $$("tgtttbso");
                        if (tgtttbsoValue) {
                            tgtttbsoValue.callEvent("onChange", [tgtttbsoValue.getValue(), null]);
                        }
                    },
                }
            }
        };
        var mahang = {
            view: "text",
            id: "ma",
            name: "ma",
            hidden: true
        };
        var dvtinh = {
            view: "text",
            id: "dvtinh",
            name: "dvtinh",
            hidden: true
        };
        var mdvtinh = {
            view: "text",
            id: "mdvtinh",
            name: "mdvtinh",
            hidden: true
        };
        var tgtttbso = {
            view: "autonumeric",
            id: "tgtttbso",
            name: "tgtttbso",
            label: "Tổng tiền thanh toán",
            required: true,
            invalidMessage: "Tổng tiền thanh toán không được để trống",
            validate: webix.rules.isNotEmpty,
            css: "css_numeric",
            on: {
                "onchange": function (newv, oldv) {
                    if (newv == undefined)
                        newv = 0;
                    var tsuat = webix.rules.isNumber($$("tsuat").getValue()) ? $$("tsuat").getValue() : 0;
                    var dgia = webix.rules.isNumber($$("dgia").getValue()) ? $$("dgia").getValue() : 0;

                    if (kyHieuHD == 2) {
                        tsuat = null;
                        tgtcthue = newv;
                        tgtthue = null;
                    }
                    else {
                        var tgtcthue = newv / (1 + (tsuat / 100));
                        var tgtthue = newv - tgtcthue;
                    }
                    var sluong = dgia == 0 ? 0 : tgtcthue / dgia;

                    $$("tgtcthue").setValue(tgtcthue);
                    $$("tgtthue").setValue(tgtthue);
                    $$("sluong").setValue(sluong);
                    var tien = functionExtension.DocTienBangChu(newv.toString(), dvtte);
                    webix.delay(
                        function (a) {
                            this.setValue(a);
                        }, $$("tgtttbchu"), [tien], 100);
                },
                onKeyPress: function (code, e) {
                    if (code == 46) return false;// 46 là mã ASCII của dấu chấm
                    if (code == 9) return true; //Cho phép phím Tab
                    return code >= 48 && code <= 57; // Chỉ nhận chữ số từ 0 đến 9
                }
            }
        };

        var tsuat = {
            view: "text",
            id: "tsuat",
            label: _("Thuế suất"),
            css: "mcls_readonly_number",
            readonly: true
        };
        var dgia = {
            view: "text",
            // width: 120,
            id: "dgia",
            label: _("Đơn giá"),
            format: "1,111.00",
            css: "mcls_readonly_number",
            readonly: true
        };
        var tgtcthue = {
            view: "text",
            // width: 120,
            id: "tgtcthue",
            name: "tgtcthue",
            label: _("Tổng tiền trước thuế"),
            format: "1,111",
            css: "mcls_readonly_number",
            readonly: true
        };
        var tgtthue = {
            view: "text",
            // width: 120,
            id: "tgtthue",
            name: "tgtthue",
            label: _("Tổng tiền thuế"),
            css: { "text-align": "right" },
            format: "1,111",
            css: "mcls_readonly_number",
            readonly: true
        };
        var sluong = {
            view: "text",
            id: "sluong",
            name: "sluong",
            label: "Số lít",
            css: { "text-align": "right" },
            format: "1,111.00",
            css: "mcls_readonly_number",
            readonly: true,
        };
        var rowsAmountToWord = {
            view: "text",
            id: "tgtttbchu",
            name: "tgtttbchu",
            css: "tienbangchu",
            // height: 22,
            validate: webix.rules.isNotEmpty,
            label: "Tổng tiền bằng chữ",
            required: true,
            invalidMessage: "Tiền bằng chữ không thể bỏ trống !",
        };
        var renderButton = function () {
            var lstButton = [
                { shortcut: "F10", label: "Lưu (F10)", type: 1, id: "btnSave" },
                { shortcut: "F11", label: "Lưu & In (F11)", type: 2, id: "btnSaveAndPrint" },
                { shortcut: "F12", label: "Lưu & Tạo tiếp (F12)", type: 3, id: "btnSaveAndCreateAgain" }
            ]
            var response = [];
            response.push({});
            lstButton.forEach((item) => {
                var btn = {
                    shortcut: item.shortcut, view: "button", label: item.label, type: "form", align: "center", id: item.id,
                    on: { onClick: function () { funcSaveInvoice(item.type); } },
                    click: function () { this.callEvent("onClick"); }
                };
                response.push(btn);
            });
            var btnCancel = {
                view: "button", id: "btnCancel", shortcut: "esc", label: "Hủy (ESC)", type: "danger", align: "center",
                on: { onClick: function () { $$(idWindow).close(); } },
                click: function () { this.callEvent("onClick"); }
            };
            response.push(btnCancel);
            response.push({});
            return response;
        }
        return {
            $ui: {
                view: "window",
                modal: true,
                id: idWindow,
                position: "center",
                move: true,
                resize: true,
                css: "headformchil",
                head: headTitleHoadon,
                width: 1100,
                height: 700,
                minWidth: 350,
                // fullscreen: true,
                body: {
                    view: "form",
                    id: idForm,
                    complexData: true,
                    margin: 0,
                    paddingY: 10,
                    paddingX: 10,
                    elementsConfig: { labelWidth: 140, labelPosition: "left" },
                    elements: [
                        dauphieuXangdau,
                        { view: "template", template: "Thông tin hàng hóa", type: "section" },
                        {
                            cols: [
                                mahang,
                                tenhang,
                                mdvtinh,
                                dvtinh,
                                tgtttbso
                            ]
                        },
                        {
                            cols: [
                                {},
                                {
                                    rows: [
                                        sluong,
                                        dgia,
                                        tgtcthue,
                                        tsuat,
                                        tgtthue,
                                    ]
                                }
                            ]
                        },
                        rowsAmountToWord,
                        { height: 5 },
                        { cols: renderButton() },
                    ]
                }
            },
            setEditMode: function (mode) {
                editmode = mode;
                var icon = "";
                kyHieuHD = ($$("khieu").getValue())[0];
                switch (editmode) {
                    case 1:
                        icon = "<span><i class='fa fa-plus' aria-hidden='true'></i></span>";
                        break;
                    case 2:
                        icon = "<i class='fa fa-edit' aria-hidden='true'></i>";
                        $$("btnSaveAndCreateAgain").hide();
                        break;
                    default:
                        icon = "<i class='fa fa-trash fa-lg' aria-hidden='true'></i>";
                        break;
                };
                if (kyHieuHD == 2) {
                    $$("tsuat").setValue(null)
                    $$("tsuat").hide();
                    $$("tgtthue").setValue(null)
                    $$("tgtthue").hide();
                }
                webix.$$("head-iconInvoice").setHTML(icon);
                webix.$$("head-iconInvoice").refresh();
            },
            initUINew: function (cctbao_id, khieu) {
                $$("cctbao_id").setValue(cctbao_id);
                var form = $$(idForm);
                var values = form.getValues();
                values["khieu"] = khieu;
                values["tnmua"] = "Khách lẻ không lấy hóa đơn";
                form.setValues(values);
            },
            setValues: function (item, winconfig, params) {
                var win = $$(this.$ui.id);
                var form = win.getChildViews()[1];
                if (item != null) {
                    if (item["ten"] != null) item["ckCustomer"] = 1;
                    item["tdlap"] = removeTimeZoneT(item["tdlap"]);
                    item["ngayvb"] = removeTimeZoneT(item["ngayvb"]);
                    form.setValues(item);
                    webix.ajax()
                        .headers({ 'Content-type': 'application/json' })
                        .get(constant.API.GET_DETAIL_INVOICE + item.id, function (text) {
                            var data = JSON.parse(text);
                            $$("tenhang").setValue(data[0].ten);
                            $$("sluong").setValue(data[0].sluong);
                            $$("tsuat").setValue(data[0].tsuat);
                            $$("dgia").setValue(data[0].dgia);
                        });
                }
            },
            copyValues: function (item) {
                var form = webix.$$(idForm);
                webix.ajax()
                    .headers({ 'Content-type': 'application/json' })
                    .get(constant.API.GET_DETAIL_INVOICE + item.id, function (text) {
                        var data = JSON.parse(text);
                        if (item["ten"] != null) item["ckCustomer"] = 1;
                        item["hoadon68_id"] = null;
                        item["hdlket_id"] = null;
                        item["sovb"] = null;
                        item["ngayvb"] = null;
                        item["nky"] = null;
                        item["shdon"] = null;
                        item["tdlap"] = new Date();
                        item["id"] = webix.uid();
                        item["ngay_hd32"] = null;
                        item["mauso_hd32"] = null;
                        item["kyhieu_hd32"] = null;
                        item["so_hd32"] = null;
                        item["loai_hd32"] = null;
                        item["tinhchat_hd32"] = null;
                        form.setValues(item);
                        $$("tenhang").setValue(data[0].ten);
                        $$("sluong").setValue(data[0].sluong);
                        $$("tsuat").setValue(data[0].tsuat);
                        $$("dgia").setValue(data[0].dgia);
                    });

            }
        };
    });
define('views/forms/forms70/BangKe/bangkeForm',[
    "app",
    "locale",
    "views/modules/Component/componentHelper",
    "views/modules/Component/constantManager",
    "views/modules/Component/functionExtension"
], function (app, _, componentHelper, constant, functionExtension) {
    var bangkeWindowId = "bangkeWindowId";
    var bangkeFormId = "bangkeFormId";
    var dauphieuBangke = componentHelper.dauphieuBangke();
    var btnChitietBangke = componentHelper.btnChitietBangke();
    var headTitleBangke = componentHelper.headTitleHoadon("Bảng kê hóa đơn");

    var tongtien = componentHelper.tongtien();
    var tongtienDetail = componentHelper.tongtienDetail();

    return {
        $ui: {
            view: "window",
            modal: true,
            position: "center",
            css: "headformchil",
            head: headTitleBangke,
            id: bangkeWindowId,
            resize: true,
            fullscreen: true,
            move: true,
            body: {
                paddingY: 10,
                paddingX: 10,
                elementsConfig: { labelWidth: 100 },
                view: "form",
                id: bangkeFormId,
                width: 800,
                height: 500,
                complexData: true,
                margin: 0,
                elements: [
                    {
                        view: "scrollview",
                        scroll: "y",
                        body: {
                            paddingX: 18,
                            rows: [
                                dauphieuBangke,
                                {
                                    borderless: true,
                                    view: "tabview",
                                    scrollX: true,
                                    tabbar: {
                                        width: 400
                                    },
                                    cells: [
                                        {
                                            header: "Chi tiết danh sách hóa đơn có chênh lệch",
                                            body: {
                                                rows: [
                                                    btnChitietBangke,
                                                    {
                                                        view: "datatable",
                                                        resizeColumn: true,
                                                        id: "bangke_chitiet",
                                                        editable: true,
                                                        select: "cell",
                                                        drag: true,
                                                        columns: [
                                                            { id: "stt", header: "STT", width: 50 },
                                                            { id: "kyhieu", header: "Ký hiệu", width: 100, editor: "text" },
                                                            { id: "sohoadon", header: "Số hóa đơn", width: 100, editor: "text" },

                                                            { id: "ten_hhdv_goc", header: [{ css: { "background": "#ecf1f1" }, text: "Thông tin trước điều chỉnh", colspan: 8 }, { text: "Tên hàng hóa dịch vụ", css: { "background": "#ecf1f1" } }], width: 200 },
                                                            { id: "sluong_goc", header: [null, { text: "Số lượng", css: { "background": "#ecf1f1" } }], width: 100 },
                                                            { id: "dgia_goc", header: [null, { text: "Đơn giá", css: { "background": "#ecf1f1" } }], width: 120 },
                                                            { id: "thtien_goc", header: [null, { text: "Tiền trước thuế", css: { "background": "#ecf1f1" } }], width: 130 },
                                                            { id: "tsuat_goc", header: [null, { text: "Thuế suất Thuế GTGT", css: { "background": "#ecf1f1" } }], width: 120 },
                                                            { id: "tthue_goc", header: [null, { text: "Tiền thuế GTGT", css: { "background": "#ecf1f1" } }], width: 120 },
                                                            { id: "tgtienkhac_goc", header: [null, { text: "Tổng tiền khác", css: { "background": "#ecf1f1" } }], width: 120 },
                                                            { id: "tgtien_goc", header: [null, { text: "Tổng tiền sau thuế", css: { "background": "#ecf1f1" } }], width: 120 },

                                                            { id: "ten_hhdv_tdoi", header: [{ css: { "background": "#e7e7e7" }, text: "Thông tin sau điều chỉnh", colspan: 8 }, { text: "Tên hàng hóa dịch vụ", css: { "background": "#e7e7e7" } }], width: 200, editor: "text" },
                                                            { id: "sluong_tdoi", header: [null, { text: "Số lượng", css: { "background": "#e7e7e7" } }], width: 100, editor: "text" },
                                                            { id: "dgia_tdoi", header: [null, { text: "Đơn giá", css: { "background": "#e7e7e7" } }], width: 120, editor: "text" },
                                                            { id: "thtien_tdoi", header: [null, { text: "Tiền trước thuế", css: { "background": "#e7e7e7" } }], width: 130, editor: "text" },
                                                            { id: "tsuat_tdoi", header: [null, { text: "Thuế suất GTGT", css: { "background": "#e7e7e7" } }], width: 120, editor: "combo" },
                                                            { id: "tthue_tdoi", header: [null, { text: "Tiền thuế GTGT", css: { "background": "#e7e7e7" } }], width: 120, editor: "text" },
                                                            { id: "tgtienkhac_tdoi", header: [null, { text: "Tổng tiền khác", css: { "background": "#e7e7e7" } }], width: 120, editor: "text" },
                                                            { id: "tgtien_tdoi", header: [null, { text: "Tiền thuế sau thuế", css: { "background": "#e7e7e7" } }], width: 120, editor: "text" },

                                                            { id: "thtien_clech", header: [{ css: { "background": "#fcf7fc" }, text: "Chênh lệch", colspan: 4 }, { text: "Tổng tiền trước thuế", css: { "background": "#fcf7fc" } }], width: 150, editor: "text" },
                                                            { id: "tthue_clech", header: [null, { text: "Tổng tiền thuế", css: { "background": "#fcf7fc" } }], width: 150, editor: "text" },
                                                            { id: "tgtienkhac_clech", header: [null, { text: "Tổng tiền khác", css: { "background": "#fcf7fc" } }], width: 150, editor: "text" },
                                                            { id: "tgtien_clech", header: [null, { text: "Tổng tiền sau thuế", css: { "background": "#fcf7fc" } }], width: 150, editor: "text" }
                                                        ],

                                                        on: {
                                                            "data->onStoreUpdated": function () {
                                                                this.data.each(function (obj, i) {
                                                                    obj.stt = i + 1;
                                                                });
                                                            },
                                                            onAfterEditStop: function (state, editor) {
                                                                const item = this.getItem(editor.row);
                                                                item.thtien_tdoi = (parseFloat(item.sluong_tdoi) || 0) * (parseFloat(item.dgia_tdoi) || 0);
                                                                item.tgtien_tdoi = item.thtien_tdoi + (parseFloat(item.tthue_tdoi) || 0) + (parseFloat(item.tgtienkhac_tdoi) || 0);
                                                                item.thtien_clech = (parseFloat(item.thtien_tdoi) || 0) - (parseFloat(item.thtien_goc) || 0);
                                                                item.tthue_clech = (parseFloat(item.tthue_tdoi) || 0) - (parseFloat(item.tthue_goc) || 0);
                                                                item.tgtienkhac_clech = (parseFloat(item.tgtienkhac_tdoi) || 0) - (parseFloat(item.tgtienkhac_goc) || 0);
                                                                item.tgtien_clech = (parseFloat(item.tgtien_tdoi) || 0) - (parseFloat(item.tgtien_goc) || 0);

                                                                this.updateItem(editor.row, item);
                                                            }
                                                        }
                                                    }
                                                ]
                                            }
                                        }
                                    ]
                                },
                                { height: 10 },
                                {
                                    margin: 10,
                                    cols: [
                                        {},
                                        {
                                            view: "button",
                                            value: "Hủy",
                                            css: "webix_danger",
                                            width: 150,
                                            click: function () {
                                                $$(bangkeWindowId).hide();
                                            }
                                        },
                                        {
                                            view: "button",
                                            value: "Lưu và Tạo hóa đơn",
                                            css: "webix_primary",
                                            width: 150,
                                            click: function () {
                                                var window = $$(bangkeWindowId);
                                                var form = $$(bangkeFormId);
                                                const formValues = form.getValues();
                                                const detailData = $$('bangke_chitiet').serialize();

                                                if (!formValues || !detailData || detailData.length === 0) {
                                                    webix.message("Dữ liệu không hợp lệ, vui lòng kiểm tra lại.", "error");
                                                    return;
                                                }

                                                const detailWithHoadonID = detailData.map(item => {
                                                    item.thtien_tdoi = (parseFloat(item.sluong_tdoi) || 0) * (parseFloat(item.dgia_tdoi) || 0);
                                                    item.tgtien_tdoi = item.thtien_tdoi + (parseFloat(item.tthue_tdoi) || 0) + (parseFloat(item.tgtienkhac_tdoi) || 0);
                                                    item.thtien_clech = (parseFloat(item.thtien_tdoi) || 0) - (parseFloat(item.thtien_goc) || 0);
                                                    item.tthue_clech = (parseFloat(item.tthue_tdoi) || 0) - (parseFloat(item.tthue_goc) || 0);
                                                    item.tgtienkhac_clech = (parseFloat(item.tgtienkhac_tdoi) || 0) - (parseFloat(item.tgtienkhac_goc) || 0);
                                                    item.tgtien_clech = (parseFloat(item.tgtien_tdoi) || 0) - (parseFloat(item.tgtien_goc) || 0);
                                                    return item;
                                                });

                                                const payload = {
                                                    ngay: formValues.ngay,
                                                    tchat: formValues.tchat,
                                                    nban: formValues.nban,
                                                    mst_nban: formValues.mst_nban,
                                                    dchi_nban: formValues.dchi_nban,
                                                    nmua: formValues.nmua,
                                                    mst_nmua: formValues.mst_nmua,
                                                    dchi_nmua: formValues.dchi_nmua,
                                                    ldo: formValues.ldo,
                                                    bangke_chitiets: detailWithHoadonID
                                                };
                                                if (form.validate()) {
                                                    webix.extend(window, webix.ProgressBar);
                                                    window.disable();
                                                    window.showProgress();

                                                    webix.ajax()
                                                        .headers({ 'Content-Type': 'application/json' })
                                                        .post(app.config.host + constant.API.BANGKE.SAVE_BANGKE + "?type=2", JSON.stringify(payload), {
                                                            error: function (text) {
                                                                window.enable();
                                                                window.hideProgress();
                                                                webix.message("Lỗi khi lưu thông tin: " + text, "error");
                                                            },
                                                            success: function (text) {
                                                                window.enable();
                                                                window.hideProgress();
                                                                const response = JSON.parse(text);
                                                                if (response.code === "00") {
                                                                    webix.message("Tạo bảng kê thành công!", "success");
                                                                    $$(bangkeWindowId).hide();
                                                                    require(["views/forms/forms70/BangKe/saveInvoiceForm"], function (saveInvoiceForm) {
                                                                        saveInvoiceForm.setData(payload);
                                                                        webix.ui(saveInvoiceForm.$ui).show();
                                                                    });
                                                                } else {
                                                                    webix.message(response.message || "Lưu thông tin thất bại", "error");
                                                                }
                                                            }
                                                        });
                                                }
                                            }
                                        },
                                        {}
                                    ]
                                }
                            ]
                        }
                    }
                ]
            }
        },
        setEditMode: function (mode) {
            $$("tchat").setValue(mode);
            $$('bangke_chitiet').clearAll();
            var icon = "<span><i class='fa fa-plus' aria-hidden='true'></i></span>";
            webix.$$("head-iconInvoice").setHTML(icon);
            webix.ajax().get(app.config.host + "/System/GetInfoCompany", {
                error: function (err) {
                    console.error("Error fetching seller information:", err);
                    webix.message("Không thể tải thông tin người bán", "error");
                },
                success: function (response) {
                    try {
                        const sellerInfo = JSON.parse(response);
                        $$('nban').setValue(sellerInfo.ten_dvcs || "");
                        $$('mst_nban').setValue(sellerInfo.ms_thue || "");
                        $$('dchi_nban').setValue(sellerInfo.dia_chi || "");
                    } catch (parseError) {
                        console.error("Error parsing seller information:", parseError);
                        webix.message("Dữ liệu trả về không hợp lệ cho thông tin người bán", "error");
                    }
                }
            });
        },

        loadDetailData: function (id) {
            webix.ajax().get(app.config.host + "/Bangke/GetDetail?id=" + id, function (text, data) {
                const detailData = data.json();
                $$("bangke_chitiet").parse(detailData);
            });
        },
        setData: function (selectedInvoices) {

            if (selectedInvoices.length > 0) {
                const firstInvoice = selectedInvoices[0];
                $$('nmua').setValue(firstInvoice.nguoimuahang || "");
                $$('mst_nmua').setValue(firstInvoice.mst || "");
                $$('dchi_nmua').setValue(firstInvoice.dchi || "");
            }

            selectedInvoices.forEach((invoice) => {
                if (invoice.id) {
                    const apiUrl = app.config.host + "/Invoice68/GetDetailInvoice?id=" + invoice.id;
                    webix.ajax().get(apiUrl, {
                        error: function (err) {
                            console.error("Error fetching details for invoice ID:", invoice.id, err);
                            webix.message("Không thể tải dữ liệu chi tiết cho hóa đơn: " + invoice.id, "error");
                        },
                        success: function (response) {
                            try {
                                const detailData = JSON.parse(response);
                                const mappedData = detailData.map((item, index) => ({
                                    stt: index + 1,
                                    kyhieu: invoice.khieu,
                                    sohoadon: invoice.shdon,
                                    ten_hhdv_goc: item.ten,
                                    sluong_goc: item.sluong,
                                    dgia_goc: item.dgia,
                                    thtien_goc: item.thtien,
                                    tsuat_goc: item.tsuat,
                                    tthue_goc: item.tthue,
                                    // tgtienkhac_goc: item.tgtien,
                                    tgtien_goc: item.tgtien,

                                    ten_hhdv_tdoi: item.ten,
                                    sluong_tdoi: item.sluong,
                                    dgia_tdoi: item.dgia,
                                    thtien_tdoi: item.thtien,
                                    tthue_tdoi: item.tthue,
                                    tsuat_tdoi: item.tsuat,
                                    // tgtienkhac_goc: item.tgtien,
                                    tgtien_tdoi: item.tgtien,
                                    hoadon68_id: invoice.id
                                }));
                                $$("bangke_chitiet").parse(mappedData);
                            } catch (parseError) {
                                console.error("Error parsing response for invoice ID:", invoice.id, parseError);
                                webix.message("Dữ liệu trả về không hợp lệ cho hóa đơn: " + invoice.id, "error");
                            }
                        }
                    });
                }
            });
        },
        openChonHoaDon: function (chonHoaDonForm) {
            var mst_nban = $$('mst_nban') ? $$('mst_nban').getValue() : null;
            var win = chonHoaDonForm && chonHoaDonForm.$ui ? webix.ui(chonHoaDonForm.$ui) : null;
            if (chonHoaDonForm && typeof chonHoaDonForm.setMSTValue === 'function' && mst_nban) {
                chonHoaDonForm.setMSTValue(mst_nban);
            }
            if (win) win.show();
        }
    };
});

define('views/forms/forms70/BangKe/hoadonChietKhauForm',[
    "app",
    "locale",
    "views/modules/Component/componentHelper",
    "views/modules/Component/constantManager",
], function (app, _, componentHelper, constant) {
    var hoadonchietkhauID = "hoadonchietkhauID";
    var hoadonFormId = "hoadonFormId";
    var dauphieuBangke = componentHelper.dphdonchietkhau();
    var btnChitietBangke = componentHelper.btnHoadonchietkhau_chitiet();
    var headTitleBangke = componentHelper.headTitleHoadon("Bảng kê đính kèm hóa đơn chiết khấu");

    return {
        $ui: {
            view: "window",
            modal: true,
            position: "center",
            css: "headformchil",
            head: headTitleBangke,
            id: hoadonchietkhauID,
            resize: true,
            fullscreen: true,
            move: true,
            body: {
                paddingY: 10,
                paddingX: 10,
                elementsConfig: { labelWidth: 100 },
                view: "form",
                id: hoadonFormId,
                width: 800,
                height: 500,
                complexData: true,
                margin: 0,
                elements: [
                    {
                        view: "scrollview",
                        scroll: "y",
                        body: {
                            paddingX: 18,
                            rows: [
                                dauphieuBangke,
                                {
                                    borderless: true,
                                    view: "tabview",
                                    scrollX: true,
                                    tabbar: {
                                        width: 400
                                    },
                                    cells: [
                                        {
                                            header: "Chi tiết danh sách hóa đơn có chênh lệch",
                                            body: {
                                                rows: [
                                                    btnChitietBangke,
                                                    {
                                                        view: "datatable",
                                                        resizeColumn: true,
                                                        id: "hdck_chitiet",
                                                        editable: true,
                                                        select: "cell",
                                                        drag: true,
                                                        footer: true,
                                                        columns: [
                                                            { id: "stt", header: "STT", width: 50 },
                                                            {
                                                                id: "khieu",
                                                                header: "Ký hiệu",
                                                                width: 150,
                                                                editor: "text",
                                                                footer: {
                                                                    text: "Tổng cộng",
                                                                    colspan: 5,
                                                                    css: "text-left",
                                                                },
                                                            },
                                                            {
                                                                id: "shdon",
                                                                header: "Số hóa đơn",
                                                                width: 100,
                                                                // editor: "text",
                                                            },
                                                            {
                                                                id: "tdlap",
                                                                header: "Ngày hóa đơn",
                                                                width: 150,
                                                                // editor: "datepicker",
                                                                format: function (text) { return formatDate(text); }
                                                            },
                                                            {
                                                                id: "dvtte",
                                                                header: "Đơn vị tiền tệ",
                                                                width: 100,
                                                                // editor: "text",
                                                            },
                                                            {
                                                                id: "tgia",
                                                                header: "Tỷ giá",
                                                                width: 100,
                                                                // editor: "text",
                                                            },
                                                            {
                                                                id: "tgtcthue",
                                                                header: "Tổng tiền trước thuế",
                                                                width: 150,
                                                                // editor: "text",
                                                                footer: { content: "summColumn" },
                                                            },
                                                            {
                                                                id: "tgtthue",
                                                                header: "Tổng tiền thuế",
                                                                width: 130,
                                                                // editor: "text",
                                                                footer: { content: "summColumn" },
                                                            },
                                                            {
                                                                id: "tgtphi",
                                                                header: "Tổng tiền phí",
                                                                width: 130,
                                                                // editor: "text",
                                                                footer: { content: "summColumn" },
                                                            },
                                                            {
                                                                id: "tgtttbso",
                                                                header: "Tổng tiền thanh toán",
                                                                width: 150,
                                                                fillspace: true,
                                                                // editor: "text",
                                                                footer: { content: "summColumn" },
                                                            },
                                                            {
                                                                id: "macqt",
                                                                header: "Mã CQT",
                                                                width: 150,
                                                                fillspace: true,
                                                                // editor: "text",
                                                            },
                                                        ],
                                                    }
                                                ]
                                            }
                                        }
                                    ]
                                },
                                { height: 10 },
                                {
                                    margin: 10,
                                    cols: [
                                        {},
                                        {
                                            view: "button",
                                            value: "Hủy",
                                            css: "webix_danger",
                                            width: 150,
                                            click: function () {
                                                $$(hoadonchietkhauID).hide();
                                            }
                                        },
                                        {
                                            view: "button",
                                            value: "Lưu và Tạo hóa đơn",
                                            css: "webix_primary",
                                            width: 150,
                                            click: function () {
                                                if ($$("sbke")) $$("sbke").show();
                                                if ($$("nbke")) $$("nbke").show();
                                                if ($$("tclquan")) $$("tclquan").show();

                                                var window = $$(hoadonchietkhauID);
                                                var form = $$(hoadonFormId);
                                                const formValues = form.getValues();
                                                const detailData = $$('hdck_chitiet').serialize();

                                                if (!formValues || !detailData || detailData.length === 0) {
                                                    webix.message("Dữ liệu không hợp lệ, vui lòng kiểm tra lại.", "error");
                                                    return;
                                                }
                                                const khieuList = detailData.map(item => item.khieu);
                                                const firstKhieu = khieuList[0];
                                                const allSameKhieu = khieuList.every(k => k === firstKhieu);
                                                if (!allSameKhieu) {
                                                    webix.message("Tất cả các ký hiệu hóa đơn phải giống nhau!", "error");
                                                    return;
                                                }
                                                const detailDatawithbk = detailData.map(item => {
                                                    item.dvtte = item.dvtte;
                                                    item.tgia = item.tgia;
                                                    item.khieu = item.khieu;
                                                    item.shdon = item.shdon;
                                                    item.tdlap = item.tdlap;
                                                    item.hoadon68_id = item.hoadon68_id;
                                                    item.tthue_clech = item.tthue_clech != null ? item.tthue_clech : 0;
                                                    return item;
                                                });
                                                const payload = {
                                                    ngay: formValues.ngay,
                                                    tchat: formValues.tchat,
                                                    nban: formValues.nban,
                                                    mst_nban: formValues.mst_nban,
                                                    dchi_nban: formValues.dchi_nban,
                                                    nmua: formValues.nmua ? formValues.nmua : "",
                                                    mst_nmua: formValues.mst_nmua,
                                                    dchi_nmua: formValues.dchi_nmua,
                                                    bangke_chitiets: detailDatawithbk
                                                };
                                                if (form.validate()) {
                                                    webix.extend(window, webix.ProgressBar);
                                                    window.disable();
                                                    window.showProgress();

                                                    webix.ajax()
                                                        .headers({ 'Content-Type': 'application/json' })
                                                        .post(app.config.host + constant.API.BANGKE.SAVE_BANGKE + "?type=1", JSON.stringify(payload), {
                                                            error: function (text) {
                                                                window.enable();
                                                                window.hideProgress();
                                                                webix.message("Lỗi khi lưu thông tin: " + text, "error");
                                                            },
                                                            success: function (text) {
                                                                window.enable();
                                                                window.hideProgress();
                                                                const response = JSON.parse(text);
                                                                if (response.code == "00") {
                                                                    webix.message("Tạo bảng kê thành công!", "success");
                                                                    $$(hoadonchietkhauID).close();
                                                                    webix.$$("btnPlus").callEvent("onCreate", [response.data]);
                                                                    if ($$("sbke")) $$("sbke").show();
                                                                    if ($$("nbke")) $$("nbke").show();
                                                                    if ($$("tclquan")) $$("tclquan").show();
                                                                } else {
                                                                    webix.message(response.message || "Lưu thông tin thất bại", "error");
                                                                }
                                                            }
                                                        });
                                                }
                                            }
                                        },
                                        {}
                                    ]
                                }
                            ]
                        }
                    }
                ]
            }
        },
        setEditMode: function (mode) {
            $$('hdck_chitiet').clearAll();
            var icon = "<span><i class='fa fa-plus' aria-hidden='true'></i></span>";
            webix.$$("head-iconInvoice").setHTML(icon);
            webix.ajax().get(app.config.host + "/System/GetInfoCompany", {
                error: function (err) {
                    console.error("Error fetching seller information:", err);
                    webix.message("Không thể tải thông tin người bán", "error");
                },
                success: function (response) {
                    try {
                        const sellerInfo = JSON.parse(response);
                        $$('nban').setValue(sellerInfo.ten_dvcs || "");
                        $$('mst_nban').setValue(sellerInfo.ms_thue || "");
                        $$('dchi_nban').setValue(sellerInfo.dia_chi || "");
                    } catch (parseError) {
                        console.error("Error parsing seller information:", parseError);
                        webix.message("Dữ liệu trả về không hợp lệ cho thông tin người bán", "error");
                    }
                }
            });
        },

        loadDetailData: function (id) {
            webix.ajax().get(app.config.host + "/Bangke70/GetDetail?id=" + id, function (text, data) {
                const detailData = data.json();
                $$("hdck_chitiet").parse(detailData);
            });
        },
        setData: function (selectedInvoices) {
            if (selectedInvoices.length > 0) {
                const firstInvoice = selectedInvoices[0];
                $$('nmua').setValue(firstInvoice.nguoimuahang || "");
                $$('mst_nmua').setValue(firstInvoice.mst || "");
                $$('dchi_nmua').setValue(firstInvoice.dchi || "");
            }
            const mappedData = selectedInvoices
                .filter(invoice => invoice && invoice.khieu && invoice.shdon)
                .map((invoice, index) => ({
                    stt: index + 1,
                    khieu: invoice.khieu,
                    shdon: invoice.shdon,
                    tdlap: invoice.tdlap,
                    dvtte: invoice.dvtte,
                    tgia: invoice.tgia,
                    tgtcthue: invoice.tgtcthue,
                    tgtthue: invoice.tgtthue,
                    tgtphi: invoice.tgtphi,
                    tgtttbso: invoice.tgtttbso,
                    macqt: invoice.macqt
                }));
            $$('hdck_chitiet').parse(mappedData);
        },
        openChonHoaDon: function (chonHoaDonForm) {
            var mst_nban = $$('mst_nban') ? $$('mst_nban').getValue() : null;
            var win = chonHoaDonForm && chonHoaDonForm.$ui ? webix.ui(chonHoaDonForm.$ui) : null;
            if (chonHoaDonForm && typeof chonHoaDonForm.setMSTValue === 'function' && mst_nban) {
                chonHoaDonForm.setMSTValue(mst_nban);
            }
            if (win) win.show();
        }
    };
});

define('views/68_invoiceViews_02',[
    "app",
    "locale",
    "models/user",
    "views/forms/forms68/HDon/68_invoiceForms_02",
    "views/forms/forms68/HDon/68_huyhoadon",
    "views/forms/forms68/HDon/68_dieuchinhhoadon",
    "views/forms/forms68/68_viewLogForm",
    "views/forms/forms68/HDon/68_sendEmailForm",
    "views/modules/Component/button",
    "views/forms/forms68/HDon/68_kynhieuhoadon",
    "views/modules/Component/grid",
    "views/modules/Component/componentHelper",
    "views/modules/Component/eventTableHelper",
    "views/forms/forms68/EXCEL/68_uploadExcel",
    "views/forms/forms68/EXCEL/68_uploadExcel_chitiet",
    "views/forms/forms68/EXCEL/68_uploadExxcel_chitiet_0102294599",
    "views/forms/forms68/HDon/68_petro",
    "views/forms/forms70/BangKe/bangkeForm",
    "views/forms/forms70/BangKe/hoadonChietKhauForm"
], function (app, _, user, invoiceForms, huyhoadon, dieuchinhhoadon,
    viewLogForm, sendEmailForm, buttonOption, signMultiInvoice, gridInvoice, componentHelper,
    eventTableHelper, uploadExcel, uploadExcelDetail, uploadExcelDetail0102294599, petroForm, bangkeForm, hdonchietkhauForm) {
    'use strict';

    var chucNangComponent = buttonOption.subChucnang(huyhoadon, invoiceForms, dieuchinhhoadon, null, bangkeForm, hdonchietkhauForm);
    var subChucNang = webix.ui(chucNangComponent);
    var btnEmail = buttonOption.btnEmail(sendEmailForm);
    var btnKyCQT = buttonOption.btnKyCQT(2);
    var btnKy = buttonOption.btnKy();
    var btnPrintInvoice = buttonOption.btnPrintInvoice();
    var btnCopy = buttonOption.btnCopy(invoiceForms, 2, petroForm);
    var btnDelete = buttonOption.btnDelete();
    var btnEdit = buttonOption.btnEdit(invoiceForms, 2, petroForm);
    var btnAdd = buttonOption.btnAdd(invoiceForms, 2, petroForm);
    var btnRefresh = buttonOption.btnRefresh();
    var btnKyNhieuHoadon = buttonOption.btnKyNhieuHoadon(signMultiInvoice, 2);
    var cbGetAll = buttonOption.cbGetAll();
    var grid = gridInvoice.gridInitInvoice(viewLogForm, "K");
    var optionsPrint = buttonOption.optionPrint();
    var settingColumn = buttonOption.settingColumn();
    var controls = [
        btnRefresh,
        btnAdd,
        btnEdit,
        btnDelete,
        btnCopy,
        btnPrintInvoice,
        btnEmail,
        btnKy,
        btnKyCQT,
        btnKyNhieuHoadon,
        {
            view: "button", type: "htmlbutton", width: 120,
            label: '<i class="fa fa-tasks fa-lg aria-hidden="true"></i> ' +
                '<span class="text">' + _("Nghiệp vụ") + '</span>',
            id: "btnChucNang",
            click: function () {
                subChucNang.show(webix.$$("btnChucNang").$view);
            }
        },
        {},
        optionsPrint,
        settingColumn
    ];
    var fm = webix.Number.numToStr({
        groupDelimiter: ",",
        groupSize: 3,
        decimalDelimiter: ".",
        decimalSize: 0
    });

    var layout = {
        css: "frmView",
        id: "frmView",
        rows: [
            {
                id: "paramKH",
                view: "toolbar",
                css: { "background-color": "#f5f5f5 !important" },
                borderless: true,
                height: 35,
                cols: [
                    componentHelper.kyhieuHoadon("2K"),
                    cbGetAll,
                ]
            },
            {
                height: 39,
                id: "btnControl",
                css: "btnControl",
                margin: 0,
                borderless: true,
                type: "toolbar",
                cols: controls
            },
            {
                rows: [
                    grid
                ]
            }
        ]

    };

    return {
        $ui: layout,
        $oninit: function (view, $scope) {
            eventTableHelper.OnInit(2);
            buttonOption.subOption(uploadExcel, uploadExcelDetail, uploadExcelDetail0102294599, 2, 2);
            $scope.on(app, "dataChangedInvoie68", function (editmode, item) {
                var table = webix.$$("invoiceViews");
                if (editmode == 1) {
                    table.clearAll();
                    table.load(table.config.url);
                }
                if (editmode == 2) {
                    table.clearAll();
                    table.load(table.config.url);
                }
            });
        }
    };
});
define('views/forms/forms68/HDon/68_invoiceForms_05',[
    "app",
    "locale",
    "models/user",
    "views/modules/Component/componentHelper",
    "views/modules/Component/eventTableHelper",
    "views/modules/Component/button",
    "views/modules/Component/constantManager",
    "views/modules/Component/functionExtension",
], function (app, _, user, componentHelper, eventTableHelper, buttonOptions, constant, functionExtension) {
    var editmode = 0;
    var afteredit = "";
    var fm = webix.Number.numToStr({
        groupDelimiter: ",",
        groupSize: 3,
        decimalDelimiter: ".",
        decimalSize: 0
    });
    var quantity = 0;
    var inv_TotalAmountWithoutVat = 0;
    var inv_TotalAmount = 0;
    var inv_unitPrice = 0;
    var inv_vatAmount = 0;
    var fmNumeric = function (format_config, decimalOp) {
        format_config.decimal = decimalOp;
        format_config.editParse = function (value) {
            return webix.Number.parse(value, {
                groupSize: webix.i18n.groupSize,
                groupDelimiter: ".",
                // decimalSize: webix.i18n.decimalSize,
                decimalSize: decimalOp,
                // decimalDelimiter: webix.i18n.decimalDelimiter,
                decimalDelimiter: ","
            });
        };
        format_config.editFormat = function (value) {
            return webix.i18n.numberFormat(value, {
                groupDelimiter: ".",
                groupSize: 3,
                decimalDelimiter: ",",
                decimalSize: decimalOp
            });
        };

        format_config.format = webix.Number.numToStr({
            groupDelimiter: ".",
            groupSize: 3,
            decimalDelimiter: ",",
            decimalSize: decimalOp
        });
    };

    var dauphieuHoadon = componentHelper.dauphieuHoadon();
    var btnChitietHoadon = componentHelper.btnChitietHoadon();
    var headTitleHoadon = componentHelper.headTitleHoadon("Tem vé thẻ điện tử");

    var tongtien = componentHelper.tongtien();
    var tongtienDetail = componentHelper.tongtienDetail();
    var tienbangchu = componentHelper.tienbangchu();

    var btnSaveHoadon = buttonOptions.btnSaveHoadon();
    var btnSaveHoadonThayThe = buttonOptions.btnSaveHoadonThayThe();
    var btnSaveHoadonDieuChinh = buttonOptions.btnSaveHoadonDieuChinh();

    var mahanghoaHoadon = componentHelper.mahanghoaHoadon(); mahanghoaHoadon.maxLength = 50;
    var colPtCk = componentHelper.numeric("tlckhau", "% CK", 3); colPtCk.hidden = true;
    var colTienCk = componentHelper.numeric("stckhau", "Tiền CK"); colTienCk.hidden = true;
    var colTienThue = componentHelper.numeric("tthue", "Tiền thuế");
    var colTienSauThue = componentHelper.numeric("tgtien", "Tiền sau thuế");
    var colSoKhung = componentHelper.soKhung();
    var colSoMay = componentHelper.soMay();
    var colBienSoXe = componentHelper.bienSoXe();
    var colTenNguoiGui = componentHelper.tenNguoiGui();
    var colDcNguoiGui = componentHelper.diaChiNguoiGui();
    var colMstNguoiGui = componentHelper.mstNguoiGui();
    var colSddNguoiGui = componentHelper.sddNguoiGui();
    var windowId = "invoice68";
    var formId = "invoiceForms";
    var datatableDetail = "hoadon68_chitiet";

    return {
        $ui: {
            view: "window",
            modal: true,
            position: "center",
            css: "headformchil",
            head: headTitleHoadon,
            id: windowId,
            resize: true,
            fullscreen: true,
            move: true,
            on: {
                onBeforeShow: function () {
                    var type = 5;
                    var promise = eventTableHelper.OnBeforeShowForm(editmode, type);
                    if (typeof promise === 'string') {
                        afteredit = promise;
                    } else {
                        Promise.resolve(promise).then(function (value) {
                            afteredit = value.json().data;
                            webix.storage.local.put(`${constant.CACHE.AFTER_EDIT}${type}`, value.json().data);
                        })
                    }
                }
            },
            body: {
                paddingY: 10,
                paddingX: 10,
                elementsConfig: { labelWidth: 100 },
                view: "form",
                id: formId,
                width: 800,
                height: 500,
                complexData: true,
                margin: 0,
                on: {
                    // onViewShow: function () {

                    // }
                },
                rules: functionExtension.ValidateInvoice32(),
                elements: [
                    {
                        view: "scrollview",
                        scroll: "y",
                        body: {
                            paddingX: 18,
                            rows: [
                                dauphieuHoadon,
                                {
                                    borderless: true,
                                    view: "tabview",
                                    scrollX: true,
                                    tabbar: {
                                        width: 200
                                    },
                                    cells: [
                                        {
                                            header: "Chi tiết hóa đơn",
                                            select: "cell",
                                            body: {
                                                rows: [
                                                    btnChitietHoadon,
                                                    {
                                                        view: "datatable",
                                                        resizeColumn: true,
                                                        id: datatableDetail,
                                                        editable: true,
                                                        select: "cell",
                                                        // height: 260,
                                                        drag: true,
                                                        columns: [
                                                            { id: "stt", header: "", width: 30, editable: true, editor: "text" },
                                                            { id: "stt_rec", header: "STT", width: 40, editable: true, editor: "text" },
                                                            mahanghoaHoadon,
                                                            {
                                                                id: "ten", header: _("Tên hàng hóa"), editor: "text", width: 350, editable: true
                                                            },
                                                            componentHelper.donvitinhHoadon(),
                                                            componentHelper.numeric("sluong", "Số lượng", quantity),
                                                            componentHelper.numeric("dgia", "Đơn giá"),
                                                            colPtCk,
                                                            colTienCk,
                                                            componentHelper.numeric("thtien", "Tiền trước thuế"),
                                                            {
                                                                id: "tsuat",
                                                                header: _("Thuế suất"), width: 100,
                                                                editor: "combo",
                                                                editable: true,
                                                                //value: "0",
                                                                options: app.config.host + "/Invoice68/GetVAT"
                                                            },
                                                            colTienThue,
                                                            colTienSauThue,
                                                            colSoKhung,
                                                            colSoMay,
                                                            colBienSoXe,
                                                            colTenNguoiGui,
                                                            colDcNguoiGui,
                                                            colMstNguoiGui,
                                                            colSddNguoiGui,
                                                            {
                                                                id: "tchat", name: "tchat",
                                                                header: "Tính chất", editable: false, width: 200, editor: "combo",
                                                                options: [
                                                                    { id: "1", value: "Hàng hóa dịch vụ" },
                                                                    { id: "2", value: "Khuyến mại" },
                                                                    { id: "3", value: "Chiết khấu thương mại" },
                                                                    { id: "4", value: "Ghi chú/ diễn giải" },
                                                                    { id: "5", value: "Hàng hóa đặc trưng" }
                                                                ]
                                                            },
                                                            {
                                                                id: "ctinh", name: "ctinh",
                                                                header: "Cách tính",
                                                                editable: false,
                                                                width: 200,
                                                                editor: "combo",
                                                                options: [
                                                                    { id: "1", value: "Tính xuôi" },
                                                                    { id: "2", value: "Tính ngược" }
                                                                ],
                                                                /* on:{
                                                                    onChange: function(newv,oldv) {

                                                                    }
                                                                } */
                                                            }
                                                        ],
                                                        scheme: {
                                                            //$init: function (obj) { obj.stt = this.count() + 1; }
                                                        },
                                                        on: {
                                                            "data->onStoreUpdated": function () {
                                                                this.data.each(function (obj, i) {
                                                                    obj.stt = i + 1;
                                                                })
                                                            },
                                                            onBeforeRender: function () {

                                                            },
                                                            onKeyPress: function (code, e) {
                                                                var table = this;
                                                                if (e.key == "F8") {
                                                                    $$("removerow").callEvent("onItemClick");
                                                                }
                                                                if (e.key == "F9") {
                                                                    $$("addrow").callEvent("onItemClick");
                                                                }
                                                                if (e.key == "F7") {
                                                                    $$("copyrow").callEvent("onItemClick");
                                                                }
                                                            },
                                                            onAfterLoad: function () {
                                                                var table = this;
                                                                var data = table.serialize();
                                                                data.forEach(function (entry) {
                                                                    if (entry["stckhau"] != undefined || entry["tlckhau"] != undefined) {
                                                                        if (entry["stckhau"] != 0) {
                                                                            var ck = $$("check_chietkhau");
                                                                            if (ck != undefined) {
                                                                                ck.setValue(1);
                                                                                return false;
                                                                            }
                                                                        }
                                                                    }
                                                                });
                                                            },
                                                            onCheck: function (row, column, state) {
                                                                var table = this;
                                                                if (column == "khuyen_mai") {

                                                                    if (state == true) {
                                                                        // var selectedItem = table.getItem(row);
                                                                        // selectedItem.don_gia = null;
                                                                        // table.updateItem(selectedItem.id, selectedItem);
                                                                        // table.callEvent("onAfterAdd");
                                                                    }
                                                                }

                                                            },
                                                            onAfterAdd: function (id, index) {
                                                                var table = $$(this.config.id);
                                                                var data = table.serialize();

                                                                var tong_tien_tt_dp = 0;
                                                                var tong_tien_thue_dp = 0
                                                                var tong_tien_ck_dp = 0;
                                                                var tong_tien_dp = 0

                                                                data.forEach(function (entry, count) {
                                                                    tong_tien_tt_dp += entry["tien_tt"] == null ? 0 : entry["tien_tt"];
                                                                    tong_tien_thue_dp += entry["tien_thue"] == null ? 0 : entry["tien_thue"];
                                                                    tong_tien_ck_dp += entry["tien_ck"] == null ? 0 : entry["tien_ck"];
                                                                    tong_tien_dp += entry["tong_tien"] == null ? 0 : entry["tong_tien"];
                                                                });
                                                            },
                                                            onAfterEditStop: function (state, editor, ignore) {
                                                                //eventTableHelper.AfterEdit(this, state, editor, ignore);
                                                                var fn = Function("columnId", "tableId", "rowId", afteredit);
                                                                fn(editor.config.id, this.config.id, editor.row);
                                                            },
                                                            onAfterEditStart: function (cell) {
                                                                if (cell.column == "ten") {
                                                                    this.getEditor().getInputNode().setAttribute("maxlength", 500);
                                                                }
                                                            },
                                                            onValidationError: function (id, obj, details) {
                                                                eventTableHelper.ValidateError(this, id, obj, details);
                                                            },
                                                            onBeforeEditStart: function (obj) {
                                                                return eventTableHelper.BeforEditRow(this, obj);
                                                            }
                                                        },
                                                        rules: {
                                                            "tchat": webix.rules.isNotEmpty,
                                                            $obj: webix.rules.validateMoney
                                                        },
                                                        ready: function () {
                                                            this.validate();
                                                        }
                                                    }
                                                ]
                                            }

                                        }
                                    ]
                                },
                                {
                                    css: "regiontongtien",
                                    rows: [
                                        tongtien,
                                        {
                                            view: "accordion",
                                            multi: true,
                                            borderless: true,
                                            // type: "clean",
                                            css: "tongtienChitiet",
                                            rows: [ //or cols 
                                                { header: " + Tổng tiền chi tiết", css: "ttChitiet", collapsed: true, body: tongtienDetail }
                                            ]
                                        },
                                        tienbangchu,
                                        { height: 10 }
                                    ]
                                },
                                { height: 10 },
                                {
                                    margin: 10,
                                    cols: [
                                        {},
                                        btnSaveHoadonDieuChinh,
                                        btnSaveHoadonThayThe,
                                        btnSaveHoadon,
                                        {
                                            view: "button", hotkey: "esc", label: "Hủy bỏ (ESC)", align: "center", type: "danger", width: 120,
                                            click: function () {
                                                this.getTopParentView().close();
                                            }
                                        },
                                        {}
                                    ]
                                }
                            ]
                        }
                    }
                ]
            }
        },
        setValues: function (item, winconfig, params) {
            var win = $$(this.$ui.id);
            var form = win.getChildViews()[1];
            // nếu hóa đơn là điều chỉnh, thay thế thì add các cột thông tin vào
            if (item.tthdon == 2 || item.tthdon == 3) {
                // var vanbanComponent = componentHelper.vanbanHoadon();
                // $$("info-invoice").addView(vanbanComponent, 0);
                // set title cho hóa đơn điều chỉnh, thay thế
                if (item != null) {
                    var url = app.config.host + "/Invoice68/GetInvoiceById?id=" + item.hdlket_id;
                    webix.ajax()
                        .headers({ 'Content-type': 'application/json' })
                        .get(url, function (text) {
                            var data = JSON.parse(text);

                            if (data.code == "00") {
                                if (item.tthdon == 2) {
                                    webix.$$("head-formInvoice").setHTML("Hóa đơn điều chỉnh cho hóa đơn số "
                                        + data.data.shdon + " ký hiệu " + data.data.khieu);
                                    webix.$$("head-formInvoice").refresh();
                                }
                                if (item.tthdon == 3) {
                                    webix.$$("head-formInvoice").setHTML("Hóa đơn thay thế cho hóa đơn số "
                                        + data.data.shdon + " ký hiệu " + data.data.khieu);
                                    webix.$$("head-formInvoice").refresh();
                                }
                            }

                        });
                }
            }
            if (item != null) {
                item["tdlap"] = removeTimeZoneT(item["tdlap"]);
                item["ngayvb"] = removeTimeZoneT(item["ngayvb"]);
                item["ngay_hd32"] = removeTimeZoneT(item["ngay_hd32"]);
                //item["hoadon68_id"] = null;
                $$("check_tinhctmathang").setValue(item["theomh"]);
                form.setValues(item);
                $$("tgtthue").setValue(item.tgtthue);

                var tableDetail = webix.$$("hoadon68_chitiet");
                var url = app.config.host + "/Invoice68/GetDetailInvoice?id=" + item.id;
                tableDetail.clearAll();
                tableDetail.load(url);

            }

            if (editmode == 2) {

            }
            // nếu có mẫu 04 (hóa đơn thay thế cũ)
            if (winconfig != null) {
                mau04 = winconfig;
                var cctbao_id = $$("kyhieu_id").getValue();
                var khieu = $$("kyhieu_id").getText();
                var form = $$("invoiceForms");
                var values = form.getValues();
                values["khieu"] = khieu;
                form.setValues(values);
                $$("btnHoadonSaveThayThe").show();
                $$("btnHoadonSave").destructor();
            }

        },
        setEditMode: function (mode, loai_doanh_nghiep) {
            editmode = mode;
            var form = $$(this.$ui.id);
            form.config.editmode = mode;
            var icon = "";
            switch (editmode) {
                case 1:
                    icon = "<span><i class='fa fa-plus' aria-hidden='true'></i></span>";
                    break;
                case 2:
                    icon = "<i class='fa fa-edit' aria-hidden='true'></i>";
                    break;
                default:
                    icon = "<i class='fa fa-trash fa-lg' aria-hidden='true'></i>";
                    break;
            };
            webix.$$("head-iconInvoice").setHTML(icon);
            webix.$$("head-iconInvoice").refresh();
            var formDetail = $$(datatableDetail);
            switch (loai_doanh_nghiep) {
                case 2:
                    formDetail.showColumn("skhung");
                    formDetail.showColumn("smay");
                    break;
                case 3:
                    formDetail.showColumn("bien_sxe");
                    break;
                case 4:
                    formDetail.showColumn("ten_ngui");
                    formDetail.showColumn("dc_ngui");
                    formDetail.showColumn("mst_ngui");
                    formDetail.showColumn("sddanh_ngui");
                    break;
            }
        },
        copyValues: function (item) {
            eventTableHelper.InvoiceCopy(item);
        },
        initUINew: function (cctbao_id, khieu) {

            var form = $$("invoiceForms");
            var values = form.getValues();
            values["khieu"] = khieu;
            values["cctbao_id"] = cctbao_id;
            form.setValues(values);
        },
        initUIDieuchinh: function (dataDetail, hdlket_id) {
            eventTableHelper.InvoiceAdjustment();
        },
        initUIThaythe: function (invoiceBase) {
            eventTableHelper.InvoiceReplacement(invoiceBase);
        },
        initUIThaytheTT32: function () {
            eventTableHelper.InvoiceReplacement32();
        },
        initUIDieuchinhTT32: function () {
            eventTableHelper.InvoiceAdjustment32();
        },
        initUIDieuchinhTT32Edit: function () {
            webix.$$("head-formInvoice").setHTML("Hóa đơn điều chỉnh");
            webix.$$("head-formInvoice").refresh();
            var info = componentHelper.dcttHoadon32(2);
            $$("info-invoice").addView(info, 10);
        },
        initUIHoaDonChietKhau: function (data) {
            webix.$$("head-formInvoice").setHTML("Hóa đơn chiết khấu đính kèm bảng kê");
            webix.$$("head-formInvoice").refresh();
            eventTableHelper.InvoiceDiscount(data, formId, datatableDetail);
        }
    };

});

define('views/68_invoiceViews_05',[
    "app",
    "locale",
    "models/user",
    "views/forms/forms68/HDon/68_invoiceForms_05",
    "views/forms/forms68/HDon/68_huyhoadon",
    "views/forms/forms68/HDon/68_dieuchinhhoadon",
    "views/forms/forms68/68_viewLogForm",
    "views/forms/forms68/HDon/68_sendEmailForm",
    "views/modules/Component/button",
    "views/forms/forms68/HDon/68_kynhieuhoadon",
    "views/modules/Component/grid",
    "views/modules/Component/componentHelper",
    "views/modules/Component/eventTableHelper",
    "views/forms/forms68/EXCEL/68_uploadExcel",
    "views/forms/forms68/EXCEL/68_uploadExcel_chitiet",
    "views/forms/forms68/EXCEL/68_uploadExxcel_chitiet_0102294599",
    "views/forms/forms68/HDon/68_petro",
    "views/forms/forms70/BangKe/bangkeForm",
    "views/forms/forms70/BangKe/hoadonChietKhauForm"
], function (app, _, user, invoiceForms, huyhoadon, dieuchinhhoadon, viewLogForm, sendEmailForm,
    buttonOption, signMultiInvoice, gridInvoice, componentHelper, eventTableHelper, uploadExcel, uploadExcelDetail, uploadExcelDetail0102294599, petroForm,bangkeForm, hdonchietkhauForm) {
    'use strict';

    var chucNangComponent = buttonOption.subChucnang(huyhoadon, invoiceForms, dieuchinhhoadon,bangkeForm, hdonchietkhauForm);
    var subChucNang = webix.ui(chucNangComponent);
    var btnEmail = buttonOption.btnEmail(sendEmailForm);
    var btnKyCQT = buttonOption.btnKyCQT(2);
    var btnKy = buttonOption.btnKy();
    var btnPrintInvoice = buttonOption.btnPrintInvoice();
    var btnCopy = buttonOption.btnCopy(invoiceForms, 5, petroForm);
    var btnDelete = buttonOption.btnDelete();
    var btnEdit = buttonOption.btnEdit(invoiceForms, 5, petroForm);
    var btnAdd = buttonOption.btnAdd(invoiceForms, 5, petroForm);
    var btnRefresh = buttonOption.btnRefresh();
    var btnKyNhieuHoadon = buttonOption.btnKyNhieuHoadon(signMultiInvoice, 2);
    var cbGetAll = buttonOption.cbGetAll();
    var grid = gridInvoice.gridInitInvoice(viewLogForm, "K");
    var controls = [
        btnRefresh,
        btnAdd,
        btnEdit,
        btnDelete,
        btnCopy,
        btnPrintInvoice,
        btnEmail,
        btnKy,
        btnKyCQT,
        btnKyNhieuHoadon,
        {
            view: "button", type: "htmlbutton", width: 120,
            label: '<i class="fa fa-tasks fa-lg aria-hidden="true"></i> ' +
                '<span class="text">' + _("Nghiệp vụ") + '</span>',
            id: "btnChucNang",
            click: function () {
                subChucNang.show(webix.$$("btnChucNang").$view);
            }
        },
        {}
    ];
    var fm = webix.Number.numToStr({
        groupDelimiter: ",",
        groupSize: 3,
        decimalDelimiter: ".",
        decimalSize: 0
    });

    var layout = {
        css: "frmView",
        id: "frmView",
        rows: [
            {
                id: "paramKH",
                view: "toolbar",
                css: { "background-color": "#f5f5f5 !important" },
                borderless: true,
                height: 35,
                cols: [
                    componentHelper.kyhieuHoadon("5K"),
                    cbGetAll,
                ]
            },
            {
                height: 39,
                id: "btnControl",
                css: "btnControl",
                margin: 0,
                borderless: true,
                type: "toolbar",
                cols: controls
            },
            {
                rows: [
                    grid
                ]
            }
        ]

    };

    return {
        $ui: layout,
        $oninit: function (view, $scope) {
            eventTableHelper.OnInit(5);
            buttonOption.subOption(uploadExcel, uploadExcelDetail, uploadExcelDetail0102294599, 5, 2);
            $scope.on(app, "dataChangedInvoie68", function (editmode, item) {

                var table = webix.$$("invoiceViews");
                if (editmode == 1) {
                    table.clearAll();
                    table.load(table.config.url);
                }

                if (editmode == 2) {
                    table.clearAll();
                    table.load(table.config.url);
                }
            });
        }
    };
});
define('views/forms/forms68/HDon/68_invoiceForms_06',[
  "app",
  "locale",
  "models/user",
  "views/modules/Component/componentHelper",
  "views/modules/Component/eventTableHelper",
  "views/modules/Component/button",
  "views/modules/Component/constantManager",
  "views/modules/Component/functionExtension",
], function (app, _, user, componentHelper, eventTableHelper, buttonOptions, constant, functionExtension) {
  var editmode = 0;
  var afteredit = "";
  var quantity = 0;
  var inv_TotalAmountWithoutVat = 0;
  var inv_TotalAmount = 0;
  var inv_unitPrice = 0;
  var inv_vatAmount = 0;
  var fmNumeric = function (format_config, decimalOp) {
    format_config.decimal = decimalOp;
    format_config.editParse = function (value) {
      return webix.Number.parse(value, {
        groupSize: webix.i18n.groupSize,
        groupDelimiter: ".",
        // decimalSize: webix.i18n.decimalSize,
        decimalSize: decimalOp,
        // decimalDelimiter: webix.i18n.decimalDelimiter,
        decimalDelimiter: ","
      });
    };
    format_config.editFormat = function (value) {
      return webix.i18n.numberFormat(value, {
        groupDelimiter: ".",
        groupSize: 3,
        decimalDelimiter: ",",
        decimalSize: decimalOp
      });
    };

    format_config.format = webix.Number.numToStr({
      groupDelimiter: ".",
      groupSize: 3,
      decimalDelimiter: ",",
      decimalSize: decimalOp
    });
  };
  var tongtien = componentHelper.tongtien();
  var tienbangchu = componentHelper.tienbangchu();
  var dauphieuHoadon = componentHelper.dauphieuMau06();
  var btnChitietHoadon = componentHelper.btnChitietHoadon();
  var headTitleHoadon = componentHelper.headTitleHoadon("Phiếu xuất kho KVCNB điện tử");

  var btnSaveHoadon = buttonOptions.btnSaveHoadon();
  var btnCancelHoadon = buttonOptions.btnCancelHoadon();
  var btnSaveHoadonThayThe = buttonOptions.btnSaveHoadonThayThe();
  var btnSaveHoadonDieuChinh = buttonOptions.btnSaveHoadonDieuChinh();

  var mahanghoaHoadon = componentHelper.mahanghoaHoadon(); mahanghoaHoadon.maxLength = 50;
  var colPtCk = componentHelper.numeric("tlckhau", "% CK", 3); colPtCk.hidden = true;
  var colTienCk = componentHelper.numeric("stckhau", "Tiền CK"); colTienCk.hidden = true;
  var colSoKhung = componentHelper.soKhung();
  var colSoMay = componentHelper.soMay();
  var colBienSoXe = componentHelper.bienSoXe();
  var colTenNguoiGui = componentHelper.tenNguoiGui();
  var colDcNguoiGui = componentHelper.diaChiNguoiGui();
  var colMstNguoiGui = componentHelper.mstNguoiGui();
  var colSddNguoiGui = componentHelper.sddNguoiGui();
  var windowId = "invoice68";
  var formId = "invoiceForms";
  var datatableDetail = "hoadon68_chitiet";

  return {
    $ui: {
      view: "window",
      modal: true,
      position: "center",
      css: "headformchil",
      head: headTitleHoadon,
      id: windowId,
      resize: true,
      fullscreen: true,
      move: true,
      on: {
        onBeforeShow: function () {
          var type = 6;
          var promise = eventTableHelper.OnBeforeShowForm(editmode, type);
          if (typeof promise === 'string') {
            afteredit = promise;
          } else {
            Promise.resolve(promise).then(function (value) {
              afteredit = value.json().data;
              webix.storage.local.put(`${constant.CACHE.AFTER_EDIT}${type}`, value.json().data);
            })
          }
        }
      },
      body: {
        paddingY: 10,
        paddingX: 10,
        elementsConfig: { labelWidth: 130 },
        view: "form",
        id: formId,
        width: 800,
        height: 500,
        complexData: true,
        margin: 0,
        on: {
          // onViewShow: function () {

          // }
        },
        rules: functionExtension.ValidateInvoice32(),
        elements: [
          {
            view: "scrollview",
            scroll: "y",
            body: {
              paddingX: 18,
              rows: [
                dauphieuHoadon,
                {
                  borderless: true,
                  view: "tabview",
                  scrollX: true,
                  tabbar: {
                    width: 200
                  },
                  cells: [
                    {
                      header: "Chi tiết hóa đơn",
                      select: "cell",
                      body: {
                        rows: [
                          btnChitietHoadon,
                          {
                            view: "datatable",
                            resizeColumn: true,
                            id: datatableDetail,
                            editable: true,
                            select: "cell",
                            // height: 260,
                            drag: true,
                            columns: [
                              { id: "stt", header: "", width: 30 },
                              { id: "stt_rec", header: "STT", width: 40, editable: true, editor: "text" },
                              mahanghoaHoadon,
                              {
                                id: "ten", header: _("Tên hàng hóa"), editor: "text", width: 350, editable: true,
                              },
                              componentHelper.donvitinhHoadon(),
                              componentHelper.numeric("sluong", "Số lượng"),
                              componentHelper.numeric("dgia", "Đơn giá"),
                              colPtCk,
                              colTienCk,
                              componentHelper.numeric("thtien", "Tiền trước thuế"),
                              colSoKhung,
                              colSoMay,
                              colBienSoXe,
                              colTenNguoiGui,
                              colDcNguoiGui,
                              colMstNguoiGui,
                              colSddNguoiGui,
                              {
                                id: "tchat", name: "tchat",
                                header: "Tính chất", editable: false, width: 200, editor: "combo",
                                options: [
                                  { id: "1", value: "Hàng hóa dịch vụ" },
                                  { id: "2", value: "Khuyến mại" },
                                  { id: "3", value: "Chiết khấu thương mại" },
                                  { id: "4", value: "Ghi chú/ diễn giải" },
                                  { id: "5", value: "Hàng hóa đặc trưng" }
                                ]
                              }
                            ],
                            on: {
                              "data->onStoreUpdated": function () {
                                this.data.each(function (obj, i) {
                                  obj.stt = i + 1;
                                })
                              },
                              onKeyPress: function (code, e) {
                                var table = this;
                                if (e.key == "F8") {
                                  $$("removerow").callEvent("onItemClick");
                                }
                                if (e.key == "F9") {
                                  $$("addrow").callEvent("onItemClick");
                                }
                                if (e.key == "F7") {
                                  $$("copyrow").callEvent("onItemClick");
                                }

                              },
                              onAfterLoad: function () {
                                var table = this;
                                var data = table.serialize();
                                data.forEach(function (entry) {
                                  if (entry["stckhau"] != undefined || entry["tlckhau"] != undefined) {
                                    if (entry["stckhau"] != 0) {

                                      var ck = $$("check_chietkhau");
                                      if (ck != undefined) {
                                        ck.setValue(1);
                                        return false;
                                      }
                                    }
                                  }
                                });
                              },
                              onCheck: function (row, column, state) {
                                var table = this;
                                if (column == "khuyen_mai") {
                                  if (state == true) {
                                  }
                                }
                              },
                              onAfterAdd: function (id, index) {
                                var table = $$(this.config.id);
                                var data = table.serialize();
                                var tong_tien_tt_dp = 0;
                                var tong_tien_thue_dp = 0
                                var tong_tien_ck_dp = 0;
                                var tong_tien_dp = 0
                                data.forEach(function (entry) {

                                  tong_tien_tt_dp += entry["tien_tt"] == null ? 0 : entry["tien_tt"];
                                  tong_tien_thue_dp += entry["tien_thue"] == null ? 0 : entry["tien_thue"];
                                  tong_tien_ck_dp += entry["tien_ck"] == null ? 0 : entry["tien_ck"];
                                  tong_tien_dp += entry["tong_tien"] == null ? 0 : entry["tong_tien"];

                                });
                              },
                              onAfterEditStop: function (state, editor, ignore) {
                                var fn = Function("columnId", "tableId", "rowId", afteredit);
                                fn(editor.config.id, this.config.id, editor.row);
                              },
                              onAfterEditStart: function (cell) {
                                if (cell.column == "ten") {
                                  this.getEditor().getInputNode().setAttribute("maxlength", 500);
                                }
                              },
                              onBeforeEditStart: function (obj) {
                                return eventTableHelper.BeforEditRow(this, obj);
                              },
                              onValidationError: function (id, obj, details) {
                                eventTableHelper.ValidateError(this, id, obj, details);
                              }
                            },
                            rules: {
                              "tchat": webix.rules.isNotEmpty,
                              $obj: webix.rules.validateMoney
                            },
                            ready: function () {
                              this.validate();
                            }
                          }
                        ]
                      }
                    }
                  ]
                },
                {
                  css: "regiontongtien",
                  rows: [
                    tongtien,
                    tienbangchu,
                    { height: 10 }
                  ]
                },
                { height: 10 },
                {
                  margin: 10,
                  cols: [
                    {},
                    btnSaveHoadonDieuChinh,
                    btnSaveHoadonThayThe,
                    btnSaveHoadon,
                    btnCancelHoadon,
                    {}
                  ]
                }
              ]
            }
          }
        ]
      }
    },
    setValues: function (item, winconfig, params) {
      var win = $$(this.$ui.id);
      var form = win.getChildViews()[1];
      // nếu hóa đơn là điều chỉnh, thay thế thì add các cột thông tin vào
      if (item.tthdon == 2 || item.tthdon == 3) {
        // var vanbanComponent = componentHelper.vanbanHoadon();
        // $$("info-invoice").addView(vanbanComponent, 0);
        // set title cho hóa đơn điều chỉnh, thay thế
        if (item != null) {
          var url = app.config.host + "/Invoice68/GetInvoiceById?id=" + item.hdlket_id;
          webix.ajax()
            .headers({ 'Content-type': 'application/json' })
            .get(url, function (text) {
              var data = JSON.parse(text);

              if (data.code == "00") {
                if (item.tthdon == 2) {
                  webix.$$("head-formInvoice").setHTML("Hóa đơn điều chỉnh cho hóa đơn số " + data.data.shdon + " ký hiệu " + data.data.khieu);
                  webix.$$("head-formInvoice").refresh();
                }
                if (item.tthdon == 3) {
                  webix.$$("head-formInvoice").setHTML("Hóa đơn thay thế cho hóa đơn số " + data.data.shdon + " ký hiệu " + data.data.khieu);
                  webix.$$("head-formInvoice").refresh();
                }
              }
            });
        }
      }
      if (item != null) {
        item["tdlap"] = removeTimeZoneT(item["tdlap"]);
        item["ngayvb"] = removeTimeZoneT(item["ngayvb"]);
        item["hdktngay"] = removeTimeZoneT(item["hdktngay"]);
        form.setValues(item);

        var tableDetail = webix.$$("hoadon68_chitiet");
        var url = app.config.host + "/Invoice68/GetDetailInvoice?id=" + item.id;
        tableDetail.clearAll();
        tableDetail.load(url);
      }
      if (editmode == 2) {

      }
      // nếu có mẫu 04 (hóa đơn thay thế cũ)
      if (winconfig != null) {
        mau04 = winconfig;
        var cctbao_id = $$("kyhieu_id").getValue();
        var khieu = $$("kyhieu_id").getText();
        var form = $$("invoiceForms");
        var values = form.getValues();
        values["khieu"] = khieu;
        form.setValues(values);
        $$("btnHoadonSaveThayThe").show();
        // $$("btnHoadonCQT").destructor();
        $$("btnHoadonSave").destructor();
      }

    },
    setEditMode: function (mode, loai_doanh_nghiep) {
      editmode = mode;
      var form = $$(this.$ui.id);
      form.config.editmode = mode;
      var khieu = $$("kyhieu_id").getText();
      var checkpXKDL = khieu.substring(4, 5);
      if (checkpXKDL.toUpperCase() == "B") {
        $$("lddnbo").define("hidden", true);
        $$("tnvchuyen").define("required", true);
        $$("tnvchuyen").define("invalidMessage", "Bạn phải nhập tên người vận chuyển");
      }
      if (checkpXKDL.toUpperCase() != "B") {
        $$("phieuxuatdaily").define("hidden", true);
      }
      var icon = "";
      switch (editmode) {
        case 1:
          icon = "<span><i class='fa fa-plus' aria-hidden='true'></i></span>";
          break;
        case 2:
          icon = "<i class='fa fa-edit' aria-hidden='true'></i>";
          break;
        default:
          icon = "<i class='fa fa-trash fa-lg' aria-hidden='true'></i>";
          break;
      };
      webix.$$("head-iconInvoice").setHTML(icon);
      webix.$$("head-iconInvoice").refresh();
      var formDetail = $$(datatableDetail);
      switch (loai_doanh_nghiep) {
        case 2:
          formDetail.showColumn("skhung");
          formDetail.showColumn("smay");
          break;
        case 3:
          formDetail.showColumn("bien_sxe");
          break;
        case 4:
          formDetail.showColumn("ten_ngui");
          formDetail.showColumn("dc_ngui");
          formDetail.showColumn("mst_ngui");
          formDetail.showColumn("sddanh_ngui");
          break;
      }
    },
    copyValues: function (item) {
      eventTableHelper.InvoiceCopy(item);
    },
    initUINew: function (cctbao_id, khieu) {
      $$("cctbao_id").setValue(cctbao_id);
      var form = $$("invoiceForms");
      var values = form.getValues();
      values["khieu"] = khieu;
      form.setValues(values);
    },
    initUIDieuchinh: function (dataDetail, hdlket_id) {
      eventTableHelper.InvoiceAdjustment();
    },
    initUIThaythe: function (invoiceBase) {
      eventTableHelper.InvoiceReplacement(invoiceBase);
    },
    initUIThaytheTT32: function () {
      eventTableHelper.InvoiceReplacement32();
    },
    initUIDieuchinhTT32: function () {
      eventTableHelper.InvoiceAdjustment32();
    },
    initUIHoaDonChietKhau: function (data) {
      webix.$$("head-formInvoice").setHTML("Hóa đơn chiết khấu đính kèm bảng kê");
      webix.$$("head-formInvoice").refresh();
      eventTableHelper.InvoiceDiscount(data, formId, datatableDetail);
    }
  };

});

define('views/68_invoiceViews_06',[
    "app",
    "locale",
    "models/user",
    "views/forms/forms68/HDon/68_invoiceForms_06",
    "views/forms/forms68/HDon/68_huyhoadon",
    "views/forms/forms68/HDon/68_dieuchinhhoadon",
    "views/forms/forms68/68_viewLogForm",
    "views/forms/forms68/HDon/68_sendEmailForm",
    "views/modules/Component/button",
    "views/forms/forms68/HDon/68_kynhieuhoadon",
    "views/modules/Component/grid",
    "views/modules/Component/componentHelper",
    "views/modules/Component/eventTableHelper",
    "views/forms/forms68/EXCEL/68_uploadExcel",
    "views/forms/forms68/EXCEL/68_uploadExcel_chitiet",
    "views/forms/forms68/EXCEL/68_uploadExxcel_chitiet_0102294599",
    "views/forms/forms68/HDon/68_petro",
    "views/forms/forms70/BangKe/bangkeForm",
    "views/forms/forms70/BangKe/hoadonChietKhauForm"
], function (app, _, user, invoiceForms, huyhoadon, dieuchinhhoadon, viewLogForm, sendEmailForm, buttonOption,
    signMultiInvoice, gridInvoice, componentHelper, eventTableHelper, uploadExcel, uploadExcelDetail, uploadExcelDetail0102294599, petroForm,bangkeForm, hdonchietkhauForm) {
    'use strict';

    var chucNangComponent = buttonOption.subChucnang(huyhoadon, invoiceForms, dieuchinhhoadon, 6,bangkeForm, hdonchietkhauForm);
    var subChucNang = webix.ui(chucNangComponent);
    var btnEmail = buttonOption.btnEmail(sendEmailForm);
    var btnKyCQT = buttonOption.btnKyCQT(2);
    var btnKy = buttonOption.btnKy();
    var btnPrintInvoice = buttonOption.btnPrintInvoice();
    var btnCopy = buttonOption.btnCopy(invoiceForms, 6, petroForm);
    var btnDelete = buttonOption.btnDelete();
    var btnEdit = buttonOption.btnEdit(invoiceForms, 6, petroForm);
    var btnAdd = buttonOption.btnAdd(invoiceForms, 6, petroForm);
    var btnRefresh = buttonOption.btnRefresh();
    var btnKyNhieuHoadon = buttonOption.btnKyNhieuHoadon(signMultiInvoice, 2);
    var cbGetAll = buttonOption.cbGetAll();
    var grid = gridInvoice.gridInitInvoice(viewLogForm, "K", 6);

    var controls = [
        btnRefresh,
        btnAdd,
        btnEdit,
        btnDelete,
        btnCopy,
        btnPrintInvoice,
        btnEmail,
        btnKy,
        btnKyCQT,
        btnKyNhieuHoadon,
        {
            view: "button", type: "htmlbutton", width: 120,
            label: '<i class="fa fa-tasks fa-lg aria-hidden="true"></i> ' +
                '<span class="text">' + _("Nghiệp vụ") + '</span>',
            id: "btnChucNang",
            click: function () {
                subChucNang.show(webix.$$("btnChucNang").$view);
            }
        },
        {}
    ];

    var layout = {
        css: "frmView",
        id: "frmView",
        rows: [
            {
                id: "paramKH",
                view: "toolbar",
                css: { "background-color": "#f5f5f5 !important" },
                borderless: true,
                height: 35,
                cols: [
                    componentHelper.kyhieuHoadon("6K"),
                    cbGetAll,
                ]
            },
            {
                height: 39,
                id: "btnControl",
                css: "btnControl",
                margin: 0,
                borderless: true,
                type: "toolbar",
                cols: controls
            },
            {
                rows: [
                    grid
                ]
            }
        ]

    };

    return {
        $ui: layout,
        $oninit: function (view, $scope) {
            eventTableHelper.OnInit(6);
            buttonOption.subOption(uploadExcel, uploadExcelDetail, uploadExcelDetail0102294599, 6, 2);
            $scope.on(app, "dataChangedInvoie68", function (editmode, item) {
                var table = webix.$$("invoiceViews");
                if (editmode == 1) {
                    table.clearAll();
                    table.load(table.config.url);
                }

                if (editmode == 2) {
                    table.clearAll();
                    table.load(table.config.url);
                }
            });
        }
    };
});
define('views/forms/forms68/HDon/68_invoiceForms_code_01',[
    "app",
    "locale",
    "models/user",
    "views/modules/Component/componentHelper",
    "views/modules/Component/eventTableHelper",
    "views/modules/Component/button",
    "views/modules/Component/constantManager",
    "views/modules/Component/functionExtension",
], function (app, _, user, componentHelper, eventTableHelper, buttonOptions, constant, functionExtension) {
    var editmode = 0;
    var afteredit = "";
    var quantity = 0;

    var dauphieuHoadon = componentHelper.dauphieuHoadon(1);
    var btnChitietHoadon = componentHelper.btnChitietHoadon();
    var headTitleHoadon = componentHelper.headTitleHoadon("Hóa đơn giá trị gia tăng");

    var tongtien = componentHelper.tongtien();
    var tongtienDetail = componentHelper.tongtienDetail();
    var tienbangchu = componentHelper.tienbangchu();

    var btnSaveHoadon = buttonOptions.btnSaveHoadon();
    var btnCancelHoadon = buttonOptions.btnCancelHoadon();
    var btnSaveHoadonThayThe = buttonOptions.btnSaveHoadonThayThe();
    var btnSaveHoadonDieuChinh = buttonOptions.btnSaveHoadonDieuChinh();

    var mahanghoaHoadon = componentHelper.mahanghoaHoadon(); mahanghoaHoadon.maxLength = 50;
    var colPtCk = componentHelper.numeric("tlckhau", "% CK", 3); colPtCk.hidden = true;
    var colTienCk = componentHelper.numeric("stckhau", "Tiền CK"); colTienCk.hidden = true;
    var colTienThue = componentHelper.numeric("tthue", _("TIEN_THUE"));
    var colTienSauThue = componentHelper.numeric("tgtien", "Tiền sau thuế");
    var colSoKhung = componentHelper.soKhung();
    var colSoMay = componentHelper.soMay();
    var colBienSoXe = componentHelper.bienSoXe();
    var colTenNguoiGui = componentHelper.tenNguoiGui();
    var colDcNguoiGui = componentHelper.diaChiNguoiGui();
    var colMstNguoiGui = componentHelper.mstNguoiGui();
    var colSddNguoiGui = componentHelper.sddNguoiGui();

    var windowId = "invoice68";
    var formId = "invoiceForms";
    var datatableDetail = "hoadon68_chitiet";

    return {
        $ui: {
            view: "window",
            modal: true,
            position: "center",
            css: "headformchil",
            head: headTitleHoadon,
            id: windowId,
            resize: true,
            fullscreen: true,
            move: true,
            on: {
                onBeforeShow: function () {
                    var type = 1;
                    var promise = eventTableHelper.OnBeforeShowForm(editmode, type);
                    if (typeof promise === 'string') {
                        afteredit = promise;
                    } else {
                        Promise.resolve(promise).then(function (value) {
                            afteredit = value.json().data;
                            webix.storage.local.put(`${constant.CACHE.AFTER_EDIT}${type}`, value.json().data);
                        })
                    }
                }
            },
            body: {
                paddingY: 10,
                paddingX: 10,
                elementsConfig: { labelWidth: 100 },
                view: "form",
                id: formId,
                width: 800,
                height: 500,
                complexData: true,
                margin: 0,
                on: {
                    // onViewShow: function () {
                    // }
                },
                rules: functionExtension.ValidateInvoice32(),
                // elementsConfig:{
                //     on:{
                //        'onChange':function(newv, oldv){
                //           this.validate();
                //         }
                //     }
                // },
                elements: [
                    {
                        view: "scrollview",
                        scroll: "y",
                        body: {
                            paddingX: 18,
                            rows: [
                                dauphieuHoadon,
                                {
                                    borderless: true,
                                    view: "tabview",
                                    scrollX: true,
                                    tabbar: {
                                        width: 200
                                    },
                                    cells: [
                                        {
                                            header: "Chi tiết hóa đơn",
                                            select: "cell",
                                            body: {
                                                rows: [
                                                    btnChitietHoadon,
                                                    {
                                                        view: "datatable",
                                                        resizeColumn: true,
                                                        id: datatableDetail,
                                                        editable: true,
                                                        select: "cell",
                                                        minHeight: 150,
                                                        drag: true,
                                                        columns: [
                                                            { id: "stt", header: "", width: 30, editable: true, editor: "text" },
                                                            { id: "stt_rec", header: "STT", width: 40, editable: true, editor: "text" },
                                                            mahanghoaHoadon,
                                                            {
                                                                id: "ten", header: _("TEN_HV"), editor: "text", width: 350, editable: true
                                                            },
                                                            componentHelper.donvitinhHoadon(),
                                                            componentHelper.numeric("sluong", _("SO_LUONG"), quantity),
                                                            componentHelper.numeric("dgia", _("DON_GIA")),
                                                            colPtCk,
                                                            colTienCk,
                                                            componentHelper.numeric("thtien", _("TIEN_TRUOC_THUE")),
                                                            {
                                                                id: "tsuat",
                                                                header: _("THUE_SUAT"), width: 100,
                                                                editor: "combo",
                                                                editable: true,
                                                                //value: "0",
                                                                options: app.config.host + "/Invoice68/GetVAT"
                                                            },
                                                            colTienThue,
                                                            colTienSauThue,
                                                            colSoKhung,
                                                            colSoMay,
                                                            colBienSoXe,
                                                            colTenNguoiGui,
                                                            colDcNguoiGui,
                                                            colMstNguoiGui,
                                                            colSddNguoiGui,
                                                            {
                                                                id: "tchat", name: "tchat",
                                                                header: _("TCHAT"), editable: false, width: 200, editor: "combo",
                                                                options: [
                                                                    { id: "1", value: "Hàng hóa dịch vụ" },
                                                                    { id: "2", value: "Khuyến mại" },
                                                                    { id: "3", value: "Chiết khấu thương mại" },
                                                                    { id: "4", value: "Ghi chú/ diễn giải" },
                                                                    { id: "5", value: "Hàng hóa đặc trưng" }
                                                                ]
                                                            },
                                                            {
                                                                id: "ctinh", name: "ctinh",
                                                                header: "Cách tính",
                                                                editable: false,
                                                                width: 200,
                                                                editor: "combo",
                                                                options: [
                                                                    { id: "1", value: "Tính xuôi" },
                                                                    { id: "2", value: "Tính ngược" }
                                                                ],
                                                            }
                                                        ],
                                                        scheme: {
                                                        },
                                                        on: {
                                                            "data->onStoreUpdated": function () {
                                                                this.data.each(function (obj, i) {
                                                                    obj.stt = i + 1;
                                                                })
                                                            },
                                                            onBeforeRender: function () {
                                                            },
                                                            onKeyPress: function (code, e) {
                                                                var table = this;
                                                                if (e.key == "F8") {
                                                                    $$("removerow").callEvent("onItemClick");
                                                                }
                                                                if (e.key == "F9") {
                                                                    $$("addrow").callEvent("onItemClick");
                                                                }
                                                                if (e.key == "F7") {
                                                                    $$("copyrow").callEvent("onItemClick");
                                                                }
                                                            },
                                                            onAfterLoad: function () {
                                                                var table = this;
                                                                var data = table.serialize();
                                                                data.forEach(function (entry) {
                                                                    if (entry["stckhau"] != undefined || entry["tlckhau"] != undefined) {
                                                                        if (entry["stckhau"] != 0) {
                                                                            var ck = $$("check_chietkhau");
                                                                            if (ck != undefined) {
                                                                                ck.setValue(1);
                                                                                return false;
                                                                            }
                                                                        }
                                                                    }
                                                                });
                                                            },
                                                            onCheck: function (row, column, state) {
                                                                var table = this;
                                                                if (column == "khuyen_mai") {
                                                                    if (state == true) {
                                                                    }
                                                                }
                                                            },
                                                            onAfterAdd: function (id, index) {
                                                                var table = $$(this.config.id);
                                                                var data = table.serialize();

                                                                var tong_tien_tt_dp = 0;
                                                                var tong_tien_thue_dp = 0
                                                                var tong_tien_ck_dp = 0;
                                                                var tong_tien_dp = 0

                                                                data.forEach(function (entry, count) {
                                                                    tong_tien_tt_dp += entry["tien_tt"] == null ? 0 : entry["tien_tt"];
                                                                    tong_tien_thue_dp += entry["tien_thue"] == null ? 0 : entry["tien_thue"];
                                                                    tong_tien_ck_dp += entry["tien_ck"] == null ? 0 : entry["tien_ck"];
                                                                    tong_tien_dp += entry["tong_tien"] == null ? 0 : entry["tong_tien"];
                                                                });
                                                            },
                                                            onAfterEditStop: function (state, editor, ignore) {
                                                                //eventTableHelper.AfterEdit(this, state, editor, ignore);
                                                                var fn = Function("columnId", "tableId", "rowId", afteredit);
                                                                fn(editor.config.id, this.config.id, editor.row);
                                                            },
                                                            onAfterEditStart: function (cell) {
                                                                if (cell.column == "ten") {
                                                                    this.getEditor().getInputNode().setAttribute("maxlength", 500);
                                                                }
                                                            },
                                                            onBeforeEditStart: function (obj) {
                                                                return eventTableHelper.BeforEditRow(this, obj);
                                                            },
                                                            onValidationError: function (id, obj, details) {
                                                                eventTableHelper.ValidateError(this, id, obj, details);
                                                            },
                                                            onBeforeDelete: function (id, editor) {
                                                            }
                                                        },
                                                        rules: {
                                                            "tchat": webix.rules.isNotEmpty,
                                                            $obj: webix.rules.validateMoney
                                                        },
                                                        ready: function () {
                                                            this.validate();
                                                        }
                                                    }
                                                ]
                                            }

                                        }
                                    ]
                                },
                                {
                                    css: "regiontongtien",
                                    rows: [
                                        tongtien,
                                        {
                                            view: "accordion",
                                            multi: true,
                                            borderless: true,
                                            // type: "clean",
                                            css: "tongtienChitiet",
                                            rows: [ //or cols
                                                { header: " + Tổng tiền chi tiết", css: "ttChitiet", collapsed: true, body: tongtienDetail }
                                            ]
                                        },
                                        tienbangchu,
                                        { height: 10 }
                                    ]
                                },
                                { height: 10 },
                                {
                                    // margin: 5,
                                    cols: [
                                        {},
                                        btnSaveHoadonDieuChinh,
                                        btnSaveHoadonThayThe,
                                        btnSaveHoadon,
                                        btnCancelHoadon,
                                        {}
                                    ]
                                }
                                // {
                                //     view:"text"
                                // }
                            ]
                        }
                    }
                ]
            }
        },
        setValues: function (item, winconfig, params) {
            var win = $$(this.$ui.id);
            var form = win.getChildViews()[1];
            // nếu hóa đơn là điều chỉnh, thay thế thì add các cột thông tin vào
            if (item.tthdon == 2 || item.tthdon == 3) {
                if (item != null) {
                    var apiHost = app.config.host + "/Invoice68/GetInvoiceById?id=" + item.hdlket_id;
                    webix.ajax().headers({ 'Content-type': 'application/json' })
                        .get(apiHost, function (text) {
                            var data = JSON.parse(text);
                            if (data.code == "00") {
                                if (item.tthdon == 2) {
                                    webix.$$("head-formInvoice").setHTML("Hóa đơn điều chỉnh cho hóa đơn số " + data.data.shdon + " ký hiệu " + data.data.khieu);
                                    webix.$$("head-formInvoice").refresh();
                                }
                                if (item.tthdon == 3) {
                                    webix.$$("head-formInvoice").setHTML("Hóa đơn thay thế cho hóa đơn số " + data.data.shdon + " ký hiệu " + data.data.khieu);
                                    webix.$$("head-formInvoice").refresh();
                                }
                            }
                        });
                }
            }
            if (item != null) {
                item["tdlap"] = removeTimeZoneT(item["tdlap"]);
                item["ngayvb"] = removeTimeZoneT(item["ngayvb"]);
                item["ngay_hd32"] = removeTimeZoneT(item["ngay_hd32"]);
                $$("check_tinhctmathang").setValue(item["theomh"]);
                form.setValues(item);
                $$("tgtthue").setValue(item.tgtthue);
                var tableDetail = webix.$$("hoadon68_chitiet");
                var url = app.config.host + "/Invoice68/GetDetailInvoice?id=" + item.id;
                tableDetail.clearAll();
                tableDetail.load(url);
            }
            if (editmode == 2) {

            }
            // nếu có mẫu 04 (hóa đơn thay thế cũ)
            if (winconfig != null) {
                mau04 = winconfig;
                var cctbao_id = $$("kyhieu_id").getValue();
                var khieu = $$("kyhieu_id").getText();
                var form = $$("invoiceForms");
                var values = form.getValues();
                values["khieu"] = khieu;
                form.setValues(values);
                $$("btnHoadonSaveThayThe").show();
                $$("btnHoadonSave").destructor();
            }

        },
        setEditMode: function (mode, loai_doanh_nghiep) {
            editmode = mode;
            var form = $$(this.$ui.id);
            form.config.editmode = mode;
            var icon = "";
            switch (editmode) {
                case 1:
                    icon = "<span><i class='fa fa-plus' aria-hidden='true'></i></span>";
                    break;
                case 2:
                    icon = "<i class='fa fa-edit' aria-hidden='true'></i>";
                    break;
                default:
                    icon = "<i class='fa fa-trash fa-lg' aria-hidden='true'></i>";
                    break;
            };
            webix.$$("head-iconInvoice").setHTML(icon);
            webix.$$("head-iconInvoice").refresh();
            var formDetail = $$(datatableDetail);
            switch (loai_doanh_nghiep) {
                case 2:
                    formDetail.showColumn("skhung");
                    formDetail.showColumn("smay");
                    break;
                case 3:
                    formDetail.showColumn("bien_sxe");
                    break;
                case 4:
                    formDetail.showColumn("ten_ngui");
                    formDetail.showColumn("dc_ngui");
                    formDetail.showColumn("mst_ngui");
                    formDetail.showColumn("sddanh_ngui");
                    break;
            }
        },
        copyValues: function (item) {
            eventTableHelper.InvoiceCopy(item);
        },
        initUINew: function (cctbao_id, khieu) {
            var form = $$("invoiceForms");
            var values = form.getValues();
            values["khieu"] = khieu;
            values["cctbao_id"] = cctbao_id;
            form.setValues(values);
        },
        initUIDieuchinh: function (dataDetail, hdlket_id) {
            eventTableHelper.InvoiceAdjustment();
        },
        initUIThaythe: function (invoiceBase) {
            eventTableHelper.InvoiceReplacement(invoiceBase);
        },
        initUIThaytheTT32: function () {
            eventTableHelper.InvoiceReplacement32();
        },
        initUIDieuchinhTT32: function () {
            eventTableHelper.InvoiceAdjustment32();
        },
        initUIDieuchinhTT32Edit: function () {
            webix.$$("head-formInvoice").setHTML("Hóa đơn điều chỉnh");
            webix.$$("head-formInvoice").refresh();
            var info = componentHelper.dcttHoadon32(2);
            $$("info-invoice").addView(info, 10);
        },
        initUIHoaDonChietKhau: function (data) {
            webix.$$("head-formInvoice").setHTML("Hóa đơn chiết khấu đính kèm bảng kê");
            webix.$$("head-formInvoice").refresh();
            // if (dauphieuCommon && dauphieuCommon.info_invoice) {
            //     dauphieuCommon.info_invoice.sbke.hidden = false;
            //     dauphieuCommon.info_invoice.nbke.hidden = false;
            //     dauphieuCommon.info_invoice.tclquan.hidden = false;
            // } else {
            //     console.warn("dauphieuCommon hoặc info_invoice không tồn tại");
            // }

            eventTableHelper.InvoiceDiscount(data, formId);
        }
    };
});

define('views/68_invoiceViews_code_01',[
    "app",
    "locale",
    "models/user",
    "views/forms/forms68/HDon/68_invoiceForms_code_01",
    "views/forms/forms68/HDon/68_huyhoadon",
    "views/forms/forms68/HDon/68_dieuchinhhoadon",
    "views/forms/forms68/68_viewLogForm",
    "views/forms/forms68/HDon/68_sendEmailForm",
    "views/modules/Component/button",
    "views/forms/forms68/HDon/68_kynhieuhoadon",
    "views/modules/Component/grid",
    "views/modules/Component/componentHelper",
    "views/forms/forms68/EXCEL/68_uploadExcel",
    "views/modules/Component/eventTableHelper",
    "views/forms/forms68/EXCEL/68_uploadExcel_chitiet",
    "views/forms/forms68/EXCEL/68_uploadExxcel_chitiet_0102294599",
    "views/menus/version",
    "views/forms/forms68/HDon/68_petro",
    "views/forms/forms70/BangKe/bangkeForm",
    "views/forms/forms70/BangKe/hoadonChietKhauForm",
], function (app, _, user, invoiceForms, huyhoadon, dieuchinhhoadon, viewLogForm, sendEmailForm, buttonOption,
    signMultiInvoice, gridInvoice, componentHelper, uploadExcel, eventTableHelper, uploadExcelDetail, uploadExcelDetail0102294599, version, petroForm, bangkeForm, hdonchietkhauForm) {
    'use strict';

    var chucNangComponent = buttonOption.subChucnang(huyhoadon, invoiceForms, dieuchinhhoadon, 1, bangkeForm, hdonchietkhauForm);
    var subChucNang = webix.ui(chucNangComponent);
    var mst = version.getMST();
    var btnEmail = buttonOption.btnEmail(sendEmailForm);
    var btnKyCQT = buttonOption.btnKyCQT(1);
    var btnPrintInvoice = buttonOption.btnPrintInvoice();
    var btnCopy = buttonOption.btnCopy(invoiceForms, 1, petroForm);
    var btnDelete = buttonOption.btnDelete();
    var btnEdit = buttonOption.btnEdit(invoiceForms, 1, petroForm);
    var btnAdd = buttonOption.btnAdd(invoiceForms, 1, petroForm);
    var btnRefresh = buttonOption.btnRefresh();
    var btnKyNhieuHoadon = buttonOption.btnKyNhieuHoadon(signMultiInvoice, 1);
    var cbGetAll = buttonOption.cbGetAll();
    var grid = gridInvoice.gridInitInvoice(viewLogForm, "C");
    var optionsPrint = buttonOption.optionPrint();
    var settingColumn = buttonOption.settingColumn();

    var btnKy = { width: 1 };
    var lstMST = ['0105117975', '0105117975-004', '0105117975-003', '0110142261', '0110142261-001', '0110142261-002', '0110396788'];
    if (lstMST.indexOf(mst) >= 0)
        btnKy = buttonOption.btnKy();

    var controls = [
        btnRefresh,
        btnAdd,
        btnEdit,
        btnDelete,
        btnCopy,
        btnPrintInvoice,
        btnEmail,
        btnKy,
        btnKyCQT,
        btnKyNhieuHoadon,
        {
            view: "button", type: "htmlbutton", width: 120,
            label: '<i class="fa fa-tasks fa-lg aria-hidden="true"></i> ' +
                '<span class="text">' + _("NGHIEP_VU") + '</span>',
            id: "btnChucNang",
            click: function () {
                subChucNang.show(webix.$$("btnChucNang").$view);
            }
        },
        {},
        optionsPrint,
        settingColumn
    ];

    var layout = {
        css: "frmView",
        id: "frmView",
        rows: [
            {
                id: "paramKH",
                view: "toolbar",
                css: { "background-color": "#f5f5f5 !important" },
                borderless: true,
                height: 35,
                cols: [
                    componentHelper.kyhieuHoadon("1C"),
                    cbGetAll,
                ]
            },
            { height: 39, id: "btnControl", css: "btnControl", margin: 0, borderless: true, type: "toolbar", cols: controls },
            { rows: [grid] }
        ]

    };

    return {
        $ui: layout,
        $oninit: function (view, $scope) {
            eventTableHelper.OnInit(1);
            buttonOption.subOption(uploadExcel, uploadExcelDetail, uploadExcelDetail0102294599, 1, 1);
            $scope.on(app, "dataChangedInvoie68", function (editmode, item) {
                var table = webix.$$("invoiceViews");
                if (editmode == 1) {
                    table.clearAll();
                    table.load(table.config.url);
                }
                if (editmode == 2) {
                    table.clearAll();
                    table.load(table.config.url);
                }
            });
        },
        $onurlchange: function (ui, name, url, scope) {
        }
    };
});
define('views/forms/forms68/HDon/68_invoiceForms_code_02',[
    "app",
    "locale",
    "models/user",
    "views/modules/Component/componentHelper",
    "views/modules/Component/eventTableHelper",
    "views/modules/Component/button",
    "views/modules/Component/constantManager",
    "views/modules/Component/functionExtension",
], function (app, _, user, componentHelper, eventTableHelper, buttonOptions, constant, functionExtension) {
    var editmode = 0;
    var afteredit = "";
    var quantity = 0;
    var inv_TotalAmountWithoutVat = 0;
    var inv_TotalAmount = 0;
    var inv_unitPrice = 0;
    var inv_vatAmount = 0;
    var fmNumeric = function (format_config, decimalOp) {
        format_config.editParse = function (value) {
            return webix.Number.parse(value, {
                groupSize: webix.i18n.groupSize,
                groupDelimiter: ".",
                // decimalSize: webix.i18n.decimalSize,
                decimalSize: decimalOp,
                // decimalDelimiter: webix.i18n.decimalDelimiter,
                decimalDelimiter: ","
            });
        };
        format_config.editFormat = function (value) {
            return webix.i18n.numberFormat(value, {
                groupDelimiter: ".",
                groupSize: 3,
                decimalDelimiter: ",",
                decimalSize: decimalOp
            });
        };

        format_config.format = webix.Number.numToStr({
            groupDelimiter: ".",
            groupSize: 3,
            decimalDelimiter: ",",
            decimalSize: decimalOp
        });
    };

    var tongtien = componentHelper.tongtienHDBH();
    var dauphieuHoadon = componentHelper.dauphieuHoadon(2);
    var btnChitietHoadon = componentHelper.btnChitietHoadon();
    var headTitleHoadon = componentHelper.headTitleHoadon("Hóa đơn bán hàng");
    var tienbangchu = componentHelper.tienbangchu();

    var btnSaveHoadon = buttonOptions.btnSaveHoadon();
    var btnCancelHoadon = buttonOptions.btnCancelHoadon();
    var btnSaveHoadonThayThe = buttonOptions.btnSaveHoadonThayThe();
    var btnSaveHoadonDieuChinh = buttonOptions.btnSaveHoadonDieuChinh();

    var colPtCk = componentHelper.numeric("tlckhau", "% CK", 3); colPtCk.hidden = true;
    var colTienCk = componentHelper.numeric("stckhau", "Tiền CK"); colTienCk.hidden = true;
    var mahanghoaHoadon = componentHelper.mahanghoaHoadon(6); mahanghoaHoadon.maxLength = 50;
    var colTienThue = componentHelper.numeric("tthue", "Tiền thuế"); colTienThue.hidden = true;
    var colTienSauThue = componentHelper.numeric("tgtien", "Tiền sau thuế"); colTienSauThue.hidden = true;
    var colSoKhung = componentHelper.soKhung();
    var colSoMay = componentHelper.soMay();
    var colBienSoXe = componentHelper.bienSoXe();
    var colTenNguoiGui = componentHelper.tenNguoiGui();
    var colDcNguoiGui = componentHelper.diaChiNguoiGui();
    var colMstNguoiGui = componentHelper.mstNguoiGui();
    var colSddNguoiGui = componentHelper.sddNguoiGui();
    var windowId = "invoice68";
    var formId = "invoiceForms";
    var datatableDetail = "hoadon68_chitiet";

    return {
        $ui: {
            view: "window",
            modal: true,
            position: "center",
            css: "headformchil",
            head: headTitleHoadon,
            id: windowId,
            resize: true,
            fullscreen: true,
            move: true,
            on: {
                onBeforeShow: function () {
                    var type = 2;
                    var promise = eventTableHelper.OnBeforeShowForm(editmode, type);
                    if (typeof promise === 'string') {
                        afteredit = promise;
                    } else {
                        Promise.resolve(promise).then(function (value) {
                            afteredit = value.json().data;
                            webix.storage.local.put(`${constant.CACHE.AFTER_EDIT}${type}`, value.json().data);
                        })
                    }
                }
            },
            body: {
                paddingY: 10,
                paddingX: 10,
                elementsConfig: { labelWidth: 100 },
                view: "form",
                id: formId,
                width: 800,
                height: 500,
                complexData: true,
                margin: 0,
                on: {
                    // onViewShow: function () {

                    // }
                },
                rules: functionExtension.ValidateInvoice32(),
                elements: [
                    {
                        view: "scrollview",
                        scroll: "y",
                        body: {
                            paddingX: 18,
                            rows: [
                                dauphieuHoadon,
                                {
                                    borderless: true,
                                    view: "tabview",
                                    scrollX: true,
                                    tabbar: {
                                        width: 200
                                    },
                                    cells: [
                                        {
                                            header: "Chi tiết hóa đơn",
                                            select: "cell",
                                            body: {
                                                rows: [
                                                    btnChitietHoadon,
                                                    {
                                                        view: "datatable",
                                                        resizeColumn: true,
                                                        id: datatableDetail,
                                                        editable: true,
                                                        select: "cell",
                                                        minHeight: 150,
                                                        drag: true,
                                                        columns: [
                                                            { id: "stt", header: "", width: 30 },
                                                            { id: "stt_rec", header: "STT", width: 40, editable: true, editor: "text" },
                                                            mahanghoaHoadon,
                                                            {
                                                                id: "ten", header: _("Tên hàng hóa"), editor: "text", width: 350, editable: true,
                                                            },
                                                            componentHelper.donvitinhHoadon(),
                                                            componentHelper.numeric("sluong", "Số lượng"),
                                                            componentHelper.numeric("dgia", "Đơn giá"),
                                                            colPtCk,
                                                            colTienCk,
                                                            componentHelper.numeric("thtien", "Tiền trước thuế"),
                                                            //colTienThue,
                                                            colTienSauThue,
                                                            colTienThue,
                                                            colTienSauThue,
                                                            colSoKhung,
                                                            colSoMay,
                                                            colBienSoXe,
                                                            colTenNguoiGui,
                                                            colDcNguoiGui,
                                                            colMstNguoiGui,
                                                            colSddNguoiGui,
                                                            {
                                                                id: "tchat", name: "tchat",
                                                                header: "Tính chất", editable: false, width: 200, editor: "combo",
                                                                options: [
                                                                    { id: "1", value: "Hàng hóa dịch vụ" },
                                                                    { id: "2", value: "Khuyến mại" },
                                                                    { id: "3", value: "Chiết khấu thương mại" },
                                                                    { id: "4", value: "Ghi chú/ diễn giải" },
                                                                    { id: "5", value: "Hàng hóa đặc trưng" }
                                                                ]
                                                            },
                                                            {
                                                                id: "ctinh", name: "ctinh",
                                                                header: "Cách tính",
                                                                editable: false,
                                                                width: 200,
                                                                editor: "combo",
                                                                options: [
                                                                    { id: "1", value: "Tính xuôi" },
                                                                    { id: "2", value: "Tính ngược" }
                                                                ],
                                                                /* on:{
                                                                    onChange: function(newv,oldv) {

                                                                    }
                                                                } */
                                                            }
                                                        ],
                                                        on: {
                                                            "data->onStoreUpdated": function () {
                                                                this.data.each(function (obj, i) {
                                                                    obj.stt = i + 1;
                                                                })
                                                            },
                                                            onKeyPress: function (code, e) {
                                                                var table = this;
                                                                if (e.key == "F8") {
                                                                    $$("removerow").callEvent("onItemClick");
                                                                }
                                                                if (e.key == "F9") {
                                                                    $$("addrow").callEvent("onItemClick");
                                                                }
                                                                if (e.key == "F7") {
                                                                    $$("copyrow").callEvent("onItemClick");
                                                                }

                                                            },
                                                            onAfterLoad: function () {
                                                                var table = this;
                                                                var data = table.serialize();
                                                                data.forEach(function (entry) {
                                                                    if (entry["stckhau"] != undefined || entry["tlckhau"] != undefined) {
                                                                        if (entry["stckhau"] != 0) {

                                                                            var ck = $$("check_chietkhau");
                                                                            if (ck != undefined) {
                                                                                ck.setValue(1);
                                                                                return false;
                                                                            }
                                                                        }
                                                                    }
                                                                });
                                                            },
                                                            onCheck: function (row, column, state) {
                                                                var table = this;
                                                                if (column == "khuyen_mai") {

                                                                    if (state == true) {
                                                                    }
                                                                }

                                                            },
                                                            onAfterAdd: function (id, index) {
                                                                var table = $$(this.config.id);
                                                                var data = table.serialize();

                                                                var tong_tien_tt_dp = 0;
                                                                var tong_tien_thue_dp = 0
                                                                var tong_tien_ck_dp = 0;
                                                                var tong_tien_dp = 0
                                                                data.forEach(function (entry) {

                                                                    tong_tien_tt_dp += entry["tien_tt"] == null ? 0 : entry["tien_tt"];
                                                                    tong_tien_thue_dp += entry["tien_thue"] == null ? 0 : entry["tien_thue"];
                                                                    tong_tien_ck_dp += entry["tien_ck"] == null ? 0 : entry["tien_ck"];
                                                                    tong_tien_dp += entry["tong_tien"] == null ? 0 : entry["tong_tien"];

                                                                });
                                                            },
                                                            onAfterEditStop: function (state, editor, ignore) {
                                                                // eventTableHelper.AfterEdit(this, state, editor, ignore);
                                                                var fn = Function("columnId", "tableId", "rowId", afteredit);
                                                                fn(editor.config.id, this.config.id, editor.row);
                                                            },
                                                            onAfterEditStart: function (cell) {
                                                                if (cell.column == "ten") {
                                                                    this.getEditor().getInputNode().setAttribute("maxlength", 500);
                                                                }
                                                            },
                                                            onBeforeEditStart: function (obj) {
                                                                return eventTableHelper.BeforEditRow(this, obj);
                                                            },
                                                            onValidationError: function (id, obj, details) {
                                                                eventTableHelper.ValidateError(this, id, obj, details);
                                                            },
                                                        },
                                                        rules: {
                                                            "tchat": webix.rules.isNotEmpty,
                                                            $obj: webix.rules.validateMoney
                                                        },
                                                        ready: function () {
                                                            this.validate();
                                                        }
                                                    }
                                                ]
                                            }
                                        }
                                    ]
                                },
                                {
                                    css: "regiontongtien",
                                    rows: [
                                        tongtien,
                                        tienbangchu,
                                        { height: 10 }
                                    ]
                                },
                                { height: 10 },
                                {
                                    margin: 10,
                                    cols: [
                                        {},
                                        btnSaveHoadonDieuChinh,
                                        btnSaveHoadonThayThe,
                                        btnSaveHoadon,
                                        btnCancelHoadon,
                                        {}
                                    ]
                                }
                            ]
                        }
                    }
                ]
            }
        },
        setValues: function (item, winconfig, params) {
            var win = $$(this.$ui.id);
            var form = win.getChildViews()[1];
            // nếu hóa đơn là điều chỉnh, thay thế thì add các cột thông tin vào
            if (item.tthdon == 2 || item.tthdon == 3) {
                // var vanbanComponent = componentHelper.vanbanHoadon();
                // $$("info-invoice").addView(vanbanComponent, 0);
                // set title cho hóa đơn điều chỉnh, thay thế
                if (item != null) {
                    var url = app.config.host + "/Invoice68/GetInvoiceById?id=" + item.hdlket_id;
                    webix.ajax()
                        .headers({ 'Content-type': 'application/json' })
                        .get(url, function (text) {
                            var data = JSON.parse(text);

                            if (data.code == "00") {
                                if (item.tthdon == 2) {
                                    webix.$$("head-formInvoice").setHTML("Hóa đơn điều chỉnh cho hóa đơn số "
                                        + data.data.shdon + " ký hiệu " + data.data.khieu);
                                    webix.$$("head-formInvoice").refresh();
                                }
                                if (item.tthdon == 3) {
                                    webix.$$("head-formInvoice").setHTML("Hóa đơn thay thế cho hóa đơn số "
                                        + data.data.shdon + " ký hiệu " + data.data.khieu);
                                    webix.$$("head-formInvoice").refresh();
                                }
                            }

                        });
                }

            }
            if (item != null) {
                item["tdlap"] = removeTimeZoneT(item["tdlap"]);
                item["ngayvb"] = removeTimeZoneT(item["ngayvb"]);
                form.setValues(item);

                var tableDetail = webix.$$("hoadon68_chitiet");
                var url = app.config.host + "/Invoice68/GetDetailInvoice?id=" + item.id;
                tableDetail.clearAll();
                tableDetail.load(url);
            }

            if (editmode == 2) {

            }
            // nếu có mẫu 04 (hóa đơn thay thế cũ)
            if (winconfig != null) {
                mau04 = winconfig;
                var cctbao_id = $$("kyhieu_id").getValue();
                var khieu = $$("kyhieu_id").getText();
                var form = $$("invoiceForms");
                var values = form.getValues();
                values["khieu"] = khieu;
                form.setValues(values);
                $$("btnHoadonSaveThayThe").show();
                // $$("btnHoadonCQT").destructor();
                $$("btnHoadonSave").destructor();
            }

        },
        setEditMode: function (mode, loai_doanh_nghiep) {
            editmode = mode;
            var form = $$(this.$ui.id);
            form.config.editmode = mode;
            var icon = "";
            switch (editmode) {
                case 1:
                    icon = "<span><i class='fa fa-plus' aria-hidden='true'></i></span>";
                    break;
                case 2:
                    icon = "<i class='fa fa-edit' aria-hidden='true'></i>";
                    break;
                default:
                    icon = "<i class='fa fa-trash fa-lg' aria-hidden='true'></i>";
                    break;
            };
            // $$("addrowCK").show();
            webix.$$("head-iconInvoice").setHTML(icon);
            webix.$$("head-iconInvoice").refresh();
            var formDetail = $$(datatableDetail);
            switch (loai_doanh_nghiep) {
                case 2:
                    formDetail.showColumn("skhung");
                    formDetail.showColumn("smay");
                    break;
                case 3:
                    formDetail.showColumn("bien_sxe");
                    break;
                case 4:
                    formDetail.showColumn("ten_ngui");
                    formDetail.showColumn("dc_ngui");
                    formDetail.showColumn("mst_ngui");
                    formDetail.showColumn("sddanh_ngui");
                    break;
            }
        },
        copyValues: function (item) {
            eventTableHelper.InvoiceCopy(item);
        },
        initUINew: function (cctbao_id, khieu) {
            $$("cctbao_id").setValue(cctbao_id);
            var form = $$("invoiceForms");
            var values = form.getValues();
            values["khieu"] = khieu;
            form.setValues(values);
        },
        initUIDieuchinh: function (dataDetail, hdlket_id) {
            eventTableHelper.InvoiceAdjustment();
        },
        initUIThaythe: function (invoiceBase) {
            eventTableHelper.InvoiceReplacement(invoiceBase);
        },
        initUIThaytheTT32: function () {
            eventTableHelper.InvoiceReplacement32();
        },
        initUIDieuchinhTT32: function () {
            eventTableHelper.InvoiceAdjustment32();
        },
        initUIDieuchinhTT32Edit: function () {
            webix.$$("head-formInvoice").setHTML("Hóa đơn điều chỉnh");
            webix.$$("head-formInvoice").refresh();
            var info = componentHelper.dcttHoadon32(2);
            $$("info-customer").addView(info, 10);
        },
        initUIHoaDonChietKhau: function (data) {
            webix.$$("head-formInvoice").setHTML("Hóa đơn chiết khấu đính kèm bảng kê");
            webix.$$("head-formInvoice").refresh();
            eventTableHelper.InvoiceDiscount(data, formId, datatableDetail);
        }
    };
});

define('views/68_invoiceViews_code_02',[
    "app",
    "locale",
    "models/user",
    "views/forms/forms68/HDon/68_invoiceForms_code_02",
    "views/forms/forms68/HDon/68_huyhoadon",
    "views/forms/forms68/HDon/68_dieuchinhhoadon",
    "views/forms/forms68/68_viewLogForm",
    "views/forms/forms68/HDon/68_sendEmailForm",
    "views/modules/Component/button",
    "views/forms/forms68/HDon/68_kynhieuhoadon",
    "views/modules/Component/grid",
    "views/modules/Component/componentHelper",
    "views/modules/Component/eventTableHelper",
    "views/forms/forms68/EXCEL/68_uploadExcel",
    "views/forms/forms68/EXCEL/68_uploadExcel_chitiet",
    "views/forms/forms68/EXCEL/68_uploadExxcel_chitiet_0102294599",
    "views/forms/forms68/HDon/68_petro",
    "views/forms/forms70/BangKe/bangkeForm",
    "views/forms/forms70/BangKe/hoadonChietKhauForm"
], function (app, _, user, invoiceForms, huyhoadon, dieuchinhhoadon, viewLogForm,
    sendEmailForm, buttonOption, signMultiInvoice, gridInvoice, componentHelper, eventTableHelper, uploadExcel, uploadExcelDetail, uploadExcelDetail0102294599, petroForm, bangkeForm,hdonchietkhauForm) {
    'use strict';

    var chucNangComponent = buttonOption.subChucnang(huyhoadon, invoiceForms, dieuchinhhoadon, 2, bangkeForm, hdonchietkhauForm);
    var subChucNang = webix.ui(chucNangComponent);
    var btnEmail = buttonOption.btnEmail(sendEmailForm);
    var btnKyCQT = buttonOption.btnKyCQT(1);
    var btnPrintInvoice = buttonOption.btnPrintInvoice();
    var btnCopy = buttonOption.btnCopy(invoiceForms, 2, petroForm);
    var btnDelete = buttonOption.btnDelete();
    var btnEdit = buttonOption.btnEdit(invoiceForms, 2, petroForm);
    var btnAdd = buttonOption.btnAdd(invoiceForms, 2, petroForm);
    var btnRefresh = buttonOption.btnRefresh();
    var btnKyNhieuHoadon = buttonOption.btnKyNhieuHoadon(signMultiInvoice, 1);
    var cbGetAll = buttonOption.cbGetAll();
    var grid = gridInvoice.gridInitInvoice(viewLogForm, "C");
    var optionsPrint = buttonOption.optionPrint();
    var settingColumn = buttonOption.settingColumn();
    var controls = [
        btnRefresh,
        btnAdd,
        btnEdit,
        btnDelete,
        btnCopy,
        btnPrintInvoice,
        btnEmail,
        btnKyCQT,
        btnKyNhieuHoadon,
        {
            view: "button", type: "htmlbutton", width: 120,
            label: '<i class="fa fa-tasks fa-lg aria-hidden="true"></i> ' +
                '<span class="text">' + _("Nghiệp vụ") + '</span>',
            id: "btnChucNang",
            click: function () {
                subChucNang.show(webix.$$("btnChucNang").$view);
            }
        },
        {},
        optionsPrint,
        settingColumn
    ];

    var layout = {
        css: "frmView",
        id: "frmView",
        rows: [
            {
                id: "paramKH",
                view: "toolbar",
                css: { "background-color": "#f5f5f5 !important" },
                borderless: true,
                height: 35,
                cols: [
                    componentHelper.kyhieuHoadon("2C"),
                    cbGetAll,
                ]
            },
            { height: 39, id: "btnControl", css: "btnControl", margin: 0, borderless: true, type: "toolbar", cols: controls },
            {
                rows: [
                    grid
                ]
            }
        ]

    };

    return {
        $ui: layout,
        $oninit: function (view, $scope) {
            eventTableHelper.OnInit(2);
            buttonOption.subOption(uploadExcel, uploadExcelDetail, uploadExcelDetail0102294599, 2, 1);
            $scope.on(app, "dataChangedInvoie68", function (editmode, item) {

                var table = webix.$$("invoiceViews");

                if (editmode == 1) {
                    table.clearAll();
                    table.load(table.config.url);
                }

                if (editmode == 2) {
                    table.clearAll();
                    table.load(table.config.url);
                }

            });
        }
    };
});
define('views/forms/forms68/HDon/68_invoiceForms_code_05',[
    "app",
    "locale",
    "models/user",
    "views/modules/Component/componentHelper",
    "views/modules/Component/eventTableHelper",
    "views/modules/Component/button",
    "views/modules/Component/constantManager",
    "views/modules/Component/functionExtension",
], function (app, _, user, componentHelper, eventTableHelper, buttonOptions, constant, functionExtension) {
    var editmode = 0;
    var afteredit = "";
    var quantity = 0;
    var inv_TotalAmountWithoutVat = 0;
    var inv_TotalAmount = 0;
    var inv_unitPrice = 0;
    var inv_vatAmount = 0;
    var fmNumeric = function (format_config, decimalOp) {
        format_config.decimal = decimalOp;
        format_config.editParse = function (value) {
            return webix.Number.parse(value, {
                groupSize: webix.i18n.groupSize,
                groupDelimiter: ".",
                // decimalSize: webix.i18n.decimalSize,
                decimalSize: decimalOp,
                // decimalDelimiter: webix.i18n.decimalDelimiter,
                decimalDelimiter: ","
            });
        };
        format_config.editFormat = function (value) {
            return webix.i18n.numberFormat(value, {
                groupDelimiter: ".",
                groupSize: 3,
                decimalDelimiter: ",",
                decimalSize: decimalOp
            });
        };

        format_config.format = webix.Number.numToStr({
            groupDelimiter: ".",
            groupSize: 3,
            decimalDelimiter: ",",
            decimalSize: decimalOp
        });
    };

    var dauphieuHoadon = componentHelper.dauphieuHoadon();
    var btnChitietHoadon = componentHelper.btnChitietHoadon();
    var headTitleHoadon = componentHelper.headTitleHoadon("Tem vé thẻ điện tử (Có mã CQT)");

    var tongtien = componentHelper.tongtien();
    var tongtienDetail = componentHelper.tongtienDetail();
    var tienbangchu = componentHelper.tienbangchu();

    var btnSaveHoadon = buttonOptions.btnSaveHoadon();
    var btnSaveHoadonThayThe = buttonOptions.btnSaveHoadonThayThe();
    var btnSaveHoadonDieuChinh = buttonOptions.btnSaveHoadonDieuChinh();

    var mahanghoaHoadon = componentHelper.mahanghoaHoadon(); mahanghoaHoadon.maxLength = 50;
    var colPtCk = componentHelper.numeric("tlckhau", "% CK", 3); colPtCk.hidden = true;
    var colTienCk = componentHelper.numeric("stckhau", "Tiền CK"); colTienCk.hidden = true;
    var colTienThue = componentHelper.numeric("tthue", "Tiền thuế");
    var colTienSauThue = componentHelper.numeric("tgtien", "Tiền sau thuế");
    var colSoKhung = componentHelper.soKhung();
    var colSoMay = componentHelper.soMay();
    var colBienSoXe = componentHelper.bienSoXe();
    var colTenNguoiGui = componentHelper.tenNguoiGui();
    var colDcNguoiGui = componentHelper.diaChiNguoiGui();
    var colMstNguoiGui = componentHelper.mstNguoiGui();
    var colSddNguoiGui = componentHelper.sddNguoiGui();
    var windowId = "invoice68";
    var formId = "invoiceForms";
    var datatableDetail = "hoadon68_chitiet";

    return {
        $ui: {
            view: "window",
            modal: true,
            position: "center",
            css: "headformchil",
            head: headTitleHoadon,
            id: windowId,
            resize: true,
            fullscreen: true,
            move: true,
            on: {
                onBeforeShow: function () {
                    var type = 5;
                    var promise = eventTableHelper.OnBeforeShowForm(editmode, type);
                    if (typeof promise === 'string') {
                        afteredit = promise;
                    } else {
                        Promise.resolve(promise).then(function (value) {
                            afteredit = value.json().data;
                            webix.storage.local.put(`${constant.CACHE.AFTER_EDIT}${type}`, value.json().data);
                        })
                    }
                }
            },
            body: {
                paddingY: 10,
                paddingX: 10,
                elementsConfig: { labelWidth: 100 },
                view: "form",
                id: formId,
                width: 800,
                height: 500,
                complexData: true,
                margin: 0,
                on: {
                    // onViewShow: function () {

                    // }
                },
                rules: functionExtension.ValidateInvoice32(),
                elements: [
                    {
                        view: "scrollview",
                        scroll: "y",
                        body: {
                            paddingX: 18,
                            rows: [
                                dauphieuHoadon,
                                {
                                    borderless: true,
                                    view: "tabview",
                                    scrollX: true,
                                    tabbar: {
                                        width: 200
                                    },
                                    cells: [
                                        {
                                            header: "Chi tiết hóa đơn",
                                            select: "cell",
                                            body: {
                                                rows: [
                                                    btnChitietHoadon,
                                                    {
                                                        view: "datatable",
                                                        resizeColumn: true,
                                                        id: datatableDetail,
                                                        editable: true,
                                                        select: "cell",
                                                        // height: 260,
                                                        drag: true,
                                                        columns: [
                                                            { id: "stt", header: "", width: 30, editable: true, editor: "text" },
                                                            { id: "stt_rec", header: "STT", width: 40, editable: true, editor: "text" },
                                                            mahanghoaHoadon,
                                                            {
                                                                id: "ten", header: _("Tên hàng hóa"), editor: "text", width: 350, editable: true
                                                            },
                                                            componentHelper.donvitinhHoadon(),
                                                            componentHelper.numeric("sluong", "Số lượng", quantity),
                                                            componentHelper.numeric("dgia", "Đơn giá"),
                                                            colPtCk,
                                                            colTienCk,
                                                            componentHelper.numeric("thtien", "Tiền trước thuế"),
                                                            {
                                                                id: "tsuat",
                                                                header: _("Thuế suất"), width: 100,
                                                                editor: "combo",
                                                                editable: true,
                                                                //value: "0",
                                                                options: app.config.host + "/Invoice68/GetVAT"
                                                            },
                                                            colTienThue,
                                                            colTienSauThue,
                                                            colSoKhung,
                                                            colSoMay,
                                                            colBienSoXe,
                                                            colTenNguoiGui,
                                                            colDcNguoiGui,
                                                            colMstNguoiGui,
                                                            colSddNguoiGui,
                                                            {
                                                                id: "tchat", name: "tchat",
                                                                header: "Tính chất", editable: false, width: 200, editor: "combo",
                                                                options: [
                                                                    { id: "1", value: "Hàng hóa dịch vụ" },
                                                                    { id: "2", value: "Khuyến mại" },
                                                                    { id: "3", value: "Chiết khấu thương mại" },
                                                                    { id: "4", value: "Ghi chú/ diễn giải" },
                                                                    { id: "5", value: "Hàng hóa đặc trưng" }
                                                                ]
                                                            },
                                                            {
                                                                id: "ctinh", name: "ctinh",
                                                                header: "Cách tính",
                                                                editable: false,
                                                                width: 200,
                                                                editor: "combo",
                                                                options: [
                                                                    { id: "1", value: "Tính xuôi" },
                                                                    { id: "2", value: "Tính ngược" }
                                                                ],
                                                                /* on:{
                                                                    onChange: function(newv,oldv) {

                                                                    }
                                                                } */
                                                            }
                                                        ],
                                                        scheme: {
                                                            //$init: function (obj) { obj.stt = this.count() + 1; }
                                                        },
                                                        on: {
                                                            "data->onStoreUpdated": function () {
                                                                this.data.each(function (obj, i) {
                                                                    obj.stt = i + 1;
                                                                })
                                                            },
                                                            onBeforeRender: function () {

                                                            },
                                                            onKeyPress: function (code, e) {
                                                                var table = this;
                                                                if (e.key == "F8") {
                                                                    $$("removerow").callEvent("onItemClick");
                                                                }
                                                                if (e.key == "F9") {
                                                                    $$("addrow").callEvent("onItemClick");
                                                                }
                                                                if (e.key == "F7") {
                                                                    $$("copyrow").callEvent("onItemClick");
                                                                }
                                                            },
                                                            onAfterLoad: function () {
                                                                var table = this;
                                                                var data = table.serialize();
                                                                data.forEach(function (entry) {
                                                                    if (entry["stckhau"] != undefined || entry["tlckhau"] != undefined) {
                                                                        if (entry["stckhau"] != 0) {
                                                                            var ck = $$("check_chietkhau");
                                                                            if (ck != undefined) {
                                                                                ck.setValue(1);
                                                                                return false;
                                                                            }
                                                                        }
                                                                    }
                                                                });
                                                            },
                                                            onCheck: function (row, column, state) {
                                                                var table = this;
                                                                if (column == "khuyen_mai") {

                                                                    if (state == true) {
                                                                        // var selectedItem = table.getItem(row);
                                                                        // selectedItem.don_gia = null;
                                                                        // table.updateItem(selectedItem.id, selectedItem);
                                                                        // table.callEvent("onAfterAdd");
                                                                    }
                                                                }

                                                            },
                                                            onAfterAdd: function (id, index) {
                                                                var table = $$(this.config.id);
                                                                var data = table.serialize();

                                                                var tong_tien_tt_dp = 0;
                                                                var tong_tien_thue_dp = 0
                                                                var tong_tien_ck_dp = 0;
                                                                var tong_tien_dp = 0

                                                                data.forEach(function (entry, count) {
                                                                    tong_tien_tt_dp += entry["tien_tt"] == null ? 0 : entry["tien_tt"];
                                                                    tong_tien_thue_dp += entry["tien_thue"] == null ? 0 : entry["tien_thue"];
                                                                    tong_tien_ck_dp += entry["tien_ck"] == null ? 0 : entry["tien_ck"];
                                                                    tong_tien_dp += entry["tong_tien"] == null ? 0 : entry["tong_tien"];
                                                                });
                                                            },
                                                            onAfterEditStop: function (state, editor, ignore) {
                                                                //eventTableHelper.AfterEdit(this, state, editor, ignore);
                                                                var fn = Function("columnId", "tableId", "rowId", afteredit);
                                                                fn(editor.config.id, this.config.id, editor.row);
                                                            },
                                                            onAfterEditStart: function (cell) {
                                                                if (cell.column == "ten") {
                                                                    this.getEditor().getInputNode().setAttribute("maxlength", 500);
                                                                }
                                                            },
                                                            onBeforeEditStart: function (obj) {
                                                                return eventTableHelper.BeforEditRow(this, obj);
                                                            },
                                                            onValidationError: function (id, obj, details) {
                                                                eventTableHelper.ValidateError(this, id, obj, details);
                                                            }
                                                        },
                                                        rules: {
                                                            "tchat": webix.rules.isNotEmpty,
                                                            $obj: webix.rules.validateMoney
                                                        },
                                                        ready: function () {
                                                            this.validate();
                                                        }
                                                    }
                                                ]
                                            }

                                        }
                                    ]
                                },
                                {
                                    css: "regiontongtien",
                                    rows: [
                                        tongtien,
                                        {
                                            view: "accordion",
                                            multi: true,
                                            borderless: true,
                                            // type: "clean",
                                            css: "tongtienChitiet",
                                            rows: [ //or cols 
                                                { header: " + Tổng tiền chi tiết", css: "ttChitiet", collapsed: true, body: tongtienDetail }
                                            ]
                                        },
                                        tienbangchu,
                                        { height: 10 }
                                    ]
                                },
                                { height: 10 },
                                {
                                    margin: 10,
                                    cols: [
                                        {},
                                        btnSaveHoadonDieuChinh,
                                        btnSaveHoadonThayThe,
                                        btnSaveHoadon,
                                        {
                                            view: "button", hotkey: "esc", label: "Hủy bỏ (ESC)", align: "center", type: "danger", width: 120,
                                            click: function () {
                                                this.getTopParentView().close();
                                            }
                                        },
                                        {}
                                    ]
                                }
                            ]
                        }
                    }
                ]
            }
        },
        setValues: function (item, winconfig, params) {
            var win = $$(this.$ui.id);
            var form = win.getChildViews()[1];
            // nếu hóa đơn là điều chỉnh, thay thế thì add các cột thông tin vào
            if (item.tthdon == 2 || item.tthdon == 3) {
                // var vanbanComponent = componentHelper.vanbanHoadon();
                // $$("info-invoice").addView(vanbanComponent, 0);
                // set title cho hóa đơn điều chỉnh, thay thế
                if (item != null) {
                    var url = app.config.host + "/Invoice68/GetInvoiceById?id=" + item.hdlket_id;
                    webix.ajax()
                        .headers({ 'Content-type': 'application/json' })
                        .get(url, function (text) {
                            var data = JSON.parse(text);

                            if (data.code == "00") {
                                if (item.tthdon == 2) {
                                    webix.$$("head-formInvoice").setHTML("Hóa đơn điều chỉnh cho hóa đơn số "
                                        + data.data.shdon + " ký hiệu " + data.data.khieu);
                                    webix.$$("head-formInvoice").refresh();
                                }
                                if (item.tthdon == 3) {
                                    webix.$$("head-formInvoice").setHTML("Hóa đơn thay thế cho hóa đơn số "
                                        + data.data.shdon + " ký hiệu " + data.data.khieu);
                                    webix.$$("head-formInvoice").refresh();
                                }
                            }

                        });
                }
            }
            if (item != null) {
                item["tdlap"] = removeTimeZoneT(item["tdlap"]);
                item["ngayvb"] = removeTimeZoneT(item["ngayvb"]);
                item["ngay_hd32"] = removeTimeZoneT(item["ngay_hd32"]);
                //item["hoadon68_id"] = null;
                $$("check_tinhctmathang").setValue(item["theomh"]);
                form.setValues(item);
                $$("tgtthue").setValue(item.tgtthue);

                var tableDetail = webix.$$("hoadon68_chitiet");
                var url = app.config.host + "/Invoice68/GetDetailInvoice?id=" + item.id;
                tableDetail.clearAll();
                tableDetail.load(url);

            }

            if (editmode == 2) {

            }
            // nếu có mẫu 04 (hóa đơn thay thế cũ)
            if (winconfig != null) {
                mau04 = winconfig;
                var cctbao_id = $$("kyhieu_id").getValue();
                var khieu = $$("kyhieu_id").getText();
                var form = $$("invoiceForms");
                var values = form.getValues();
                values["khieu"] = khieu;
                form.setValues(values);
                $$("btnHoadonSaveThayThe").show();
                $$("btnHoadonSave").destructor();
            }

        },
        setEditMode: function (mode, loai_doanh_nghiep) {
            editmode = mode;
            var form = $$(this.$ui.id);
            form.config.editmode = mode;
            var icon = "";
            switch (editmode) {
                case 1:
                    icon = "<span><i class='fa fa-plus' aria-hidden='true'></i></span>";
                    break;
                case 2:
                    icon = "<i class='fa fa-edit' aria-hidden='true'></i>";
                    break;
                default:
                    icon = "<i class='fa fa-trash fa-lg' aria-hidden='true'></i>";
                    break;
            };
            webix.$$("head-iconInvoice").setHTML(icon);
            webix.$$("head-iconInvoice").refresh();
            var formDetail = $$(datatableDetail);
            switch (loai_doanh_nghiep) {
                case 2:
                    formDetail.showColumn("skhung");
                    formDetail.showColumn("smay");
                    break;
                case 3:
                    formDetail.showColumn("bien_sxe");
                    break;
                case 4:
                    formDetail.showColumn("ten_ngui");
                    formDetail.showColumn("dc_ngui");
                    formDetail.showColumn("mst_ngui");
                    formDetail.showColumn("sddanh_ngui");
                    break;
            }
        },
        copyValues: function (item) {
            eventTableHelper.InvoiceCopy(item);
        },
        initUINew: function (cctbao_id, khieu) {

            var form = $$("invoiceForms");
            var values = form.getValues();
            values["khieu"] = khieu;
            values["cctbao_id"] = cctbao_id;
            form.setValues(values);
        },
        initUIDieuchinh: function (dataDetail, hdlket_id) {
            eventTableHelper.InvoiceAdjustment();
        },
        initUIThaythe: function (invoiceBase) {
            eventTableHelper.InvoiceReplacement(invoiceBase);
        },
        initUIThaytheTT32: function () {
            eventTableHelper.InvoiceReplacement32();
        },
        initUIDieuchinhTT32: function () {
            eventTableHelper.InvoiceAdjustment32();
        },
        initUIDieuchinhTT32Edit: function () {
            webix.$$("head-formInvoice").setHTML("Hóa đơn điều chỉnh");
            webix.$$("head-formInvoice").refresh();
            var info = componentHelper.dcttHoadon32(2);
            $$("info-invoice").addView(info, 10);
        },
        initUIHoaDonChietKhau: function (data) {
            webix.$$("head-formInvoice").setHTML("Hóa đơn chiết khấu đính kèm bảng kê");
            webix.$$("head-formInvoice").refresh();
            eventTableHelper.InvoiceDiscount(data, formId, datatableDetail);
        }
    };

});

define('views/68_invoiceViews_code_05',[
    "app",
    "locale",
    "models/user",
    "views/forms/forms68/HDon/68_invoiceForms_code_05",
    "views/forms/forms68/HDon/68_huyhoadon",
    "views/forms/forms68/HDon/68_dieuchinhhoadon",
    "views/forms/forms68/68_viewLogForm",
    "views/forms/forms68/HDon/68_sendEmailForm",
    "views/modules/Component/button",
    "views/forms/forms68/HDon/68_kynhieuhoadon",
    "views/modules/Component/grid",
    "views/modules/Component/componentHelper",
    "views/modules/Component/eventTableHelper",
    "views/forms/forms68/EXCEL/68_uploadExcel",
    "views/forms/forms68/EXCEL/68_uploadExcel_chitiet",
    "views/forms/forms68/EXCEL/68_uploadExxcel_chitiet_0102294599",
    "views/forms/forms68/HDon/68_petro",
    "views/forms/forms70/BangKe/bangkeForm",
    "views/forms/forms70/BangKe/hoadonChietKhauForm"
], function (app, _, user, invoiceForms, huyhoadon, dieuchinhhoadon, viewLogForm,
    sendEmailForm, buttonOption, signMultiInvoice, gridInvoice, componentHelper, eventTableHelper, uploadExcel, uploadExcelDetail, uploadExcelDetail0102294599, petroForm,bangkeForm, hdonchietkhauForm) {
    'use strict';
    var chucNangComponent = buttonOption.subChucnang(huyhoadon, invoiceForms, dieuchinhhoadon, 5, bangkeForm, hdonchietkhauForm);
    var subChucNang = webix.ui(chucNangComponent);
    var btnEmail = buttonOption.btnEmail(sendEmailForm);
    var btnKyCQT = buttonOption.btnKyCQT(1);
    var btnPrintInvoice = buttonOption.btnPrintInvoice();
    var btnCopy = buttonOption.btnCopy(invoiceForms, 5, petroForm);
    var btnDelete = buttonOption.btnDelete();
    var btnEdit = buttonOption.btnEdit(invoiceForms, 5, petroForm);
    var btnAdd = buttonOption.btnAdd(invoiceForms, 5, petroForm);
    var btnRefresh = buttonOption.btnRefresh();
    var btnKyNhieuHoadon = buttonOption.btnKyNhieuHoadon(signMultiInvoice, 1);
    var cbGetAll = buttonOption.cbGetAll();
    var grid = gridInvoice.gridInitInvoice(viewLogForm, "C");

    var controls = [
        btnRefresh,
        btnAdd,
        btnEdit,
        btnDelete,
        btnCopy,
        btnPrintInvoice,
        btnEmail,
        btnKyCQT,
        btnKyNhieuHoadon,
        {
            view: "button", type: "htmlbutton", width: 120,
            label: '<i class="fa fa-tasks fa-lg aria-hidden="true"></i> ' +
                '<span class="text">' + _("Nghiệp vụ") + '</span>',
            id: "btnChucNang",
            click: function () {
                subChucNang.show(webix.$$("btnChucNang").$view);
            }
        },
        {}
    ];
    var fm = webix.Number.numToStr({
        groupDelimiter: ",",
        groupSize: 3,
        decimalDelimiter: ".",
        decimalSize: 0
    });

    var layout = {
        css: "frmView",
        id: "frmView",
        rows: [
            {
                id: "paramKH",
                view: "toolbar",
                css: { "background-color": "#f5f5f5 !important" },
                borderless: true,
                height: 35,
                cols: [
                    componentHelper.kyhieuHoadon("5C"),
                    cbGetAll,
                ]
            },
            {
                height: 39,
                id: "btnControl",
                css: "btnControl",
                margin: 0,
                borderless: true,
                type: "toolbar",
                cols: controls
            },
            {
                rows: [
                    grid
                ]
            }
        ]

    };

    return {
        $ui: layout,
        $oninit: function (view, $scope) {
            eventTableHelper.OnInit(5);
            buttonOption.subOption(uploadExcel, uploadExcelDetail, uploadExcelDetail0102294599, 5, 1);
            $scope.on(app, "dataChangedInvoie68", function (editmode, item) {

                var table = webix.$$("invoiceViews");

                if (editmode == 1) {
                    table.clearAll();
                    table.load(table.config.url);
                }

                if (editmode == 2) {
                    table.clearAll();
                    table.load(table.config.url);
                }

            });
        }
    };
});
define('views/forms/forms68/HDon/68_invoiceForms_code_06',[
  "app",
  "locale",
  "models/user",
  "views/modules/Component/componentHelper",
  "views/modules/Component/eventTableHelper",
  "views/modules/Component/button",
  "views/modules/Component/constantManager",
  "views/modules/Component/functionExtension",
], function (app, _, user, componentHelper, eventTableHelper, buttonOptions, constant, functionExtension) {
  var editmode = 0;
  var afteredit = "";
  var quantity = 0;
  var inv_TotalAmountWithoutVat = 0;
  var inv_TotalAmount = 0;
  var inv_unitPrice = 0;
  var inv_vatAmount = 0;
  var fmNumeric = function (format_config, decimalOp) {
    format_config.decimal = decimalOp;
    format_config.editParse = function (value) {
      return webix.Number.parse(value, {
        groupSize: webix.i18n.groupSize,
        groupDelimiter: ".",
        // decimalSize: webix.i18n.decimalSize,
        decimalSize: decimalOp,
        // decimalDelimiter: webix.i18n.decimalDelimiter,
        decimalDelimiter: ","
      });
    };
    format_config.editFormat = function (value) {
      return webix.i18n.numberFormat(value, {
        groupDelimiter: ".",
        groupSize: 3,
        decimalDelimiter: ",",
        decimalSize: decimalOp
      });
    };

    format_config.format = webix.Number.numToStr({
      groupDelimiter: ".",
      groupSize: 3,
      decimalDelimiter: ",",
      decimalSize: decimalOp
    });
  };

  var tongtien = componentHelper.tongtien();
  var tienbangchu = componentHelper.tienbangchu();
  var dauphieuHoadon = componentHelper.dauphieuMau06();
  var btnChitietHoadon = componentHelper.btnChitietHoadon();
  var headTitleHoadon = componentHelper.headTitleHoadon("Phiếu xuất kho KVCNB điện tử");

  var btnSaveHoadon = buttonOptions.btnSaveHoadon();
  var btnCancelHoadon = buttonOptions.btnCancelHoadon();
  var btnSaveHoadonThayThe = buttonOptions.btnSaveHoadonThayThe();
  var btnSaveHoadonDieuChinh = buttonOptions.btnSaveHoadonDieuChinh();

  var mahanghoaHoadon = componentHelper.mahanghoaHoadon(6); mahanghoaHoadon.maxLength = 50;
  var colPtCk = componentHelper.numeric("tlckhau", "% CK", 3); colPtCk.hidden = true;
  var colTienCk = componentHelper.numeric("stckhau", "Tiền CK"); colTienCk.hidden = true;
  var colSoKhung = componentHelper.soKhung();
  var colSoMay = componentHelper.soMay();
  var colBienSoXe = componentHelper.bienSoXe();
  var colTenNguoiGui = componentHelper.tenNguoiGui();
  var colDcNguoiGui = componentHelper.diaChiNguoiGui();
  var colMstNguoiGui = componentHelper.mstNguoiGui();
  var colSddNguoiGui = componentHelper.sddNguoiGui();
  var windowId = "invoice68";
  var formId = "invoiceForms";
  var datatableDetail = "hoadon68_chitiet";

  return {
    $ui: {
      view: "window",
      modal: true,
      position: "center",
      css: "headformchil",
      head: headTitleHoadon,
      id: windowId,
      resize: true,
      fullscreen: true,
      move: true,
      on: {
        onBeforeShow: function () {
          var type = 6;
          var promise = eventTableHelper.OnBeforeShowForm(editmode, type);
          if (typeof promise === 'string') {
            afteredit = promise;
          } else {
            Promise.resolve(promise).then(function (value) {
              afteredit = value.json().data;
              webix.storage.local.put(`${constant.CACHE.AFTER_EDIT}${type}`, value.json().data);
            })
          }
        }
      },
      body: {
        paddingY: 10,
        paddingX: 10,
        elementsConfig: { labelWidth: 130 },
        view: "form",
        id: formId,
        width: 800,
        height: 500,
        complexData: true,
        margin: 0,
        on: {
          // onViewShow: function () {

          // }
        },
        rules: functionExtension.ValidateInvoice32(),
        elements: [
          {
            view: "scrollview",
            scroll: "y",
            body: {
              paddingX: 18,
              rows: [
                dauphieuHoadon,
                {
                  borderless: true,
                  view: "tabview",
                  scrollX: true,
                  tabbar: {
                    width: 200
                  },
                  cells: [
                    {
                      header: "Chi tiết hóa đơn",
                      select: "cell",
                      body: {
                        rows: [
                          btnChitietHoadon,
                          {
                            view: "datatable",
                            resizeColumn: true,
                            id: datatableDetail,
                            editable: true,
                            select: "cell",
                            // height: 260,
                            drag: true,
                            columns: [
                              { id: "stt", header: "", width: 30 },
                              { id: "stt_rec", header: "STT", width: 40, editable: true, editor: "text" },
                              mahanghoaHoadon,
                              {
                                id: "ten", header: _("Tên hàng hóa"), editor: "text", width: 350, editable: true,
                              },
                              componentHelper.donvitinhHoadon(),
                              componentHelper.numeric("sluong", "Số lượng"),
                              componentHelper.numeric("dgia", "Đơn giá"),
                              colPtCk,
                              colTienCk,
                              componentHelper.numeric("thtien", "Tiền trước thuế"),
                              colSoKhung,
                              colSoMay,
                              colBienSoXe,
                              colTenNguoiGui,
                              colDcNguoiGui,
                              colMstNguoiGui,
                              colSddNguoiGui,
                              {
                                id: "tchat", name: "tchat",
                                header: "Tính chất", editable: false, width: 200, editor: "combo",
                                options: [
                                  { id: "1", value: "Hàng hóa dịch vụ" },
                                  { id: "2", value: "Khuyến mại" },
                                  { id: "3", value: "Chiết khấu thương mại" },
                                  { id: "4", value: "Ghi chú/ diễn giải" },
                                  { id: "5", value: "Hàng hóa đặc trưng" }
                                ]
                              }
                            ],
                            on: {
                              "data->onStoreUpdated": function () {
                                this.data.each(function (obj, i) {
                                  obj.stt = i + 1;
                                })
                              },
                              onKeyPress: function (code, e) {
                                var table = this;
                                if (e.key == "F8") {
                                  $$("removerow").callEvent("onItemClick");
                                }
                                if (e.key == "F9") {
                                  $$("addrow").callEvent("onItemClick");
                                }
                                if (e.key == "F7") {
                                  $$("copyrow").callEvent("onItemClick");
                                }

                              },
                              onAfterLoad: function () {
                                var table = this;
                                var data = table.serialize();
                                data.forEach(function (entry) {
                                  if (entry["stckhau"] != undefined || entry["tlckhau"] != undefined) {
                                    if (entry["stckhau"] != 0) {

                                      var ck = $$("check_chietkhau");
                                      if (ck != undefined) {
                                        ck.setValue(1);
                                        return false;
                                      }
                                    }
                                  }
                                });
                              },
                              onCheck: function (row, column, state) {
                                var table = this;
                                if (column == "khuyen_mai") {
                                  if (state == true) {
                                  }
                                }

                              },
                              onAfterAdd: function (id, index) {
                                var table = $$(this.config.id);
                                var data = table.serialize();
                                var tong_tien_tt_dp = 0;
                                var tong_tien_thue_dp = 0
                                var tong_tien_ck_dp = 0;
                                var tong_tien_dp = 0
                                data.forEach(function (entry) {
                                  tong_tien_tt_dp += entry["tien_tt"] == null ? 0 : entry["tien_tt"];
                                  tong_tien_thue_dp += entry["tien_thue"] == null ? 0 : entry["tien_thue"];
                                  tong_tien_ck_dp += entry["tien_ck"] == null ? 0 : entry["tien_ck"];
                                  tong_tien_dp += entry["tong_tien"] == null ? 0 : entry["tong_tien"];
                                });
                              },
                              onAfterEditStop: function (state, editor, ignore) {
                                var fn = Function("columnId", "tableId", "rowId", afteredit);
                                fn(editor.config.id, this.config.id, editor.row);
                                //eventTableHelper.AfterEdit(this, state, editor, ignore);
                              },
                              onAfterEditStart: function (cell) {
                                if (cell.column == "ten") {
                                  this.getEditor().getInputNode().setAttribute("maxlength", 500);
                                }
                              },
                              onBeforeEditStart: function (obj) {
                                return eventTableHelper.BeforEditRow(this, obj);
                              },
                              onValidationError: function (id, obj, details) {
                                eventTableHelper.ValidateError(this, id, obj, details);
                              }
                            },
                            rules: {
                              "tchat": webix.rules.isNotEmpty,
                              $obj: webix.rules.validateMoney
                            },
                            ready: function () {
                              this.validate();
                            }
                          }
                        ]
                      }
                    }
                  ]
                },
                {
                  css: "regiontongtien",
                  rows: [
                    tongtien,
                    tienbangchu,
                    { height: 10 }
                  ]
                },
                { height: 10 },
                {
                  margin: 10,
                  cols: [
                    {},
                    btnSaveHoadonDieuChinh,
                    btnSaveHoadonThayThe,
                    btnSaveHoadon,
                    btnCancelHoadon,
                    {}
                  ]
                }
              ]
            }
          }
        ]
      }
    },
    setValues: function (item, winconfig, params) {
      var win = $$(this.$ui.id);
      var form = win.getChildViews()[1];
      // nếu hóa đơn là điều chỉnh, thay thế thì add các cột thông tin vào
      if (item.tthdon == 2 || item.tthdon == 3) {
        // var vanbanComponent = componentHelper.vanbanHoadon();
        // $$("info-invoice").addView(vanbanComponent, 0);
        // set title cho hóa đơn điều chỉnh, thay thế
        if (item != null) {
          var url = app.config.host + "/Invoice68/GetInvoiceById?id=" + item.hdlket_id;
          webix.ajax()
            .headers({ 'Content-type': 'application/json' })
            .get(url, function (text) {
              var data = JSON.parse(text);

              if (data.code == "00") {
                if (item.tthdon == 2) {
                  webix.$$("head-formInvoice").setHTML("Hóa đơn điều chỉnh cho hóa đơn số " + data.data.shdon + " ký hiệu " + data.data.khieu);
                  webix.$$("head-formInvoice").refresh();
                }
                if (item.tthdon == 3) {
                  webix.$$("head-formInvoice").setHTML("Hóa đơn thay thế cho hóa đơn số " + data.data.shdon + " ký hiệu " + data.data.khieu);
                  webix.$$("head-formInvoice").refresh();
                }
              }
            });
        }
      }
      if (item != null) {
        item["tdlap"] = removeTimeZoneT(item["tdlap"]);
        item["ngayvb"] = removeTimeZoneT(item["ngayvb"]);
        item["hdktngay"] = removeTimeZoneT(item["hdktngay"]);

        form.setValues(item);

        var tableDetail = webix.$$("hoadon68_chitiet");
        var url = app.config.host + "/Invoice68/GetDetailInvoice?id=" + item.id;
        tableDetail.clearAll();
        tableDetail.load(url);
      }
      if (editmode == 2) {

      }
      // nếu có mẫu 04 (hóa đơn thay thế cũ)
      if (winconfig != null) {
        mau04 = winconfig;
        var cctbao_id = $$("kyhieu_id").getValue();
        var khieu = $$("kyhieu_id").getText();
        var form = $$("invoiceForms");
        var values = form.getValues();
        values["khieu"] = khieu;
        form.setValues(values);
        $$("btnHoadonSaveThayThe").show();
        // $$("btnHoadonCQT").destructor();
        $$("btnHoadonSave").destructor();
      }

    },
    setEditMode: function (mode, loai_doanh_nghiep) {
      editmode = mode;
      var form = $$(this.$ui.id);
      form.config.editmode = mode;
      var khieu = $$("kyhieu_id").getText();
      var checkpXKDL = khieu.substring(4, 5);
      if (checkpXKDL.toUpperCase() == "B") {
        $$("lddnbo").define("hidden", true);
        $$("tnvchuyen").define("required", true);
        $$("tnvchuyen").define("invalidMessage", "Bạn phải nhập tên người vận chuyển");
      }
      if (checkpXKDL.toUpperCase() != "B") {
        $$("phieuxuatdaily").define("hidden", true);
      }
      var icon = "";
      switch (editmode) {
        case 1:
          icon = "<span><i class='fa fa-plus' aria-hidden='true'></i></span>";
          break;
        case 2:
          icon = "<i class='fa fa-edit' aria-hidden='true'></i>";
          break;
        default:
          icon = "<i class='fa fa-trash fa-lg' aria-hidden='true'></i>";
          break;
      };
      webix.$$("head-iconInvoice").setHTML(icon);
      webix.$$("head-iconInvoice").refresh();
      var formDetail = $$(datatableDetail);
      switch (loai_doanh_nghiep) {
        case 2:
          formDetail.showColumn("skhung");
          formDetail.showColumn("smay");
          break;
        case 3:
          formDetail.showColumn("bien_sxe");
          break;
        case 4:
          formDetail.showColumn("ten_ngui");
          formDetail.showColumn("dc_ngui");
          formDetail.showColumn("mst_ngui");
          formDetail.showColumn("sddanh_ngui");
          break;
      }
    },
    copyValues: function (item) {
      eventTableHelper.InvoiceCopy(item);
    },
    initUINew: function (cctbao_id, khieu) {
      $$("cctbao_id").setValue(cctbao_id);
      var form = $$("invoiceForms");
      var values = form.getValues();
      values["khieu"] = khieu;
      form.setValues(values);
    },
    initUIDieuchinh: function (dataDetail, hdlket_id) {
      eventTableHelper.InvoiceAdjustment();
    },
    initUIThaythe: function (invoiceBase) {
      eventTableHelper.InvoiceReplacement(invoiceBase);
    },
    initUIThaytheTT32: function () {
      eventTableHelper.InvoiceReplacement32();
    },
    initUIDieuchinhTT32: function () {
      eventTableHelper.InvoiceAdjustment32();
    },
    initUIDieuchinhTT32Edit: function () {
      webix.$$("head-formInvoice").setHTML("Hóa đơn điều chỉnh");
      webix.$$("head-formInvoice").refresh();
      var info = componentHelper.dcttHoadon32(2);
      $$("info-invoice").addView(info, 10);
    },
    initUIHoaDonChietKhau: function (data) {
      webix.$$("head-formInvoice").setHTML("Hóa đơn chiết khấu đính kèm bảng kê");
      webix.$$("head-formInvoice").refresh();
      eventTableHelper.InvoiceDiscount(data, formId, datatableDetail);
    }
  };

});

define('views/68_invoiceViews_code_06',[
    "app",
    "locale",
    "models/user",
    "views/forms/forms68/HDon/68_invoiceForms_code_06",
    "views/forms/forms68/HDon/68_huyhoadon",
    "views/forms/forms68/HDon/68_dieuchinhhoadon",
    "views/forms/forms68/68_viewLogForm",
    "views/forms/forms68/HDon/68_sendEmailForm",
    "views/modules/Component/button",
    "views/forms/forms68/HDon/68_kynhieuhoadon",
    "views/modules/Component/grid",
    "views/modules/Component/componentHelper",
    "views/modules/Component/eventTableHelper",
    "views/forms/forms68/EXCEL/68_uploadExcel",
    "views/forms/forms68/EXCEL/68_uploadExcel_chitiet",
    "views/forms/forms68/EXCEL/68_uploadExxcel_chitiet_0102294599",
    "views/forms/forms68/HDon/68_petro",
    "views/forms/forms70/BangKe/bangkeForm",
    "views/forms/forms70/BangKe/hoadonChietKhauForm"
], function (app, _, user, invoiceForms, huyhoadon, dieuchinhhoadon, viewLogForm,
    sendEmailForm, buttonOption, signMultiInvoice, gridInvoice, componentHelper, eventTableHelper, uploadExcel, uploadExcelDetail, uploadExcelDetail0102294599, petroForm ,bangkeForm, hdonchietkhauForm) {
    'use strict';

    var chucNangComponent = buttonOption.subChucnang(huyhoadon, invoiceForms, dieuchinhhoadon, 6, bangkeForm, hdonchietkhauForm);
    var subChucNang = webix.ui(chucNangComponent);
    var btnEmail = buttonOption.btnEmail(sendEmailForm);
    var btnKyCQT = buttonOption.btnKyCQT(1);
    var btnPrintInvoice = buttonOption.btnPrintInvoice();
    var btnCopy = buttonOption.btnCopy(invoiceForms, 6, petroForm);
    var btnDelete = buttonOption.btnDelete();
    var btnEdit = buttonOption.btnEdit(invoiceForms, 6, petroForm);
    var btnAdd = buttonOption.btnAdd(invoiceForms, 6, petroForm);
    var btnRefresh = buttonOption.btnRefresh();
    var btnKyNhieuHoadon = buttonOption.btnKyNhieuHoadon(signMultiInvoice, 1);
    var cbGetAll = buttonOption.cbGetAll();
    var grid = gridInvoice.gridInitInvoice(viewLogForm, "C", 6);
    var settingColumn = buttonOption.settingColumn();
    var controls = [
        btnRefresh,
        btnAdd,
        btnEdit,
        btnDelete,
        btnCopy,
        btnPrintInvoice,
        btnEmail,
        btnKyCQT,
        btnKyNhieuHoadon,
        {
            view: "button", type: "htmlbutton", width: 120,
            label: '<i class="fa fa-tasks fa-lg aria-hidden="true"></i> ' +
                '<span class="text">' + _("Nghiệp vụ") + '</span>',
            id: "btnChucNang",
            click: function () {
                subChucNang.show(webix.$$("btnChucNang").$view);
            }
        },
        {},
        settingColumn
    ];

    var layout = {
        css: "frmView",
        id: "frmView",
        rows: [
            {
                id: "paramKH",
                view: "toolbar",
                css: { "background-color": "#f5f5f5 !important" },
                borderless: true,
                height: 35,
                cols: [
                    componentHelper.kyhieuHoadon("6C"),
                    cbGetAll,
                ]
            },
            {
                height: 39,
                css: "btnControl",
                id: "btnControl",
                margin: 0,
                borderless: true,
                type: "toolbar",
                cols: controls
            },
            {
                rows: [
                    grid
                ]
            }
        ]

    };

    return {
        $ui: layout,
        $oninit: function (view, $scope) {
            eventTableHelper.OnInit(6);
            buttonOption.subOption(uploadExcel, uploadExcelDetail, uploadExcelDetail0102294599, 6, 1);
            $scope.on(app, "dataChangedInvoie68", function (editmode, item) {

                var table = webix.$$("invoiceViews");

                if (editmode == 1) {
                    table.clearAll();
                    table.load(table.config.url);
                }

                if (editmode == 2) {
                    table.clearAll();
                    table.load(table.config.url);
                }
            });
        }
    };
});
define('views/68_invoiceViews',[
    "app",
    "locale",
    "models/user",
    "views/forms/forms68/HDon/68_invoiceForms",
    "views/forms/forms68/HDon/68_huyhoadon",
    "views/forms/forms68/HDon/68_dieuchinhhoadon",
    "views/forms/forms68/68_viewLogForm",
    "views/forms/forms68/HDon/68_sendEmailForm",
    "views/modules/Component/button",
    "views/forms/forms68/HDon/68_kynhieuhoadon",
    "views/modules/Component/grid",
    "views/modules/Component/componentHelper",
    "views/forms/forms68/EXCEL/68_uploadExcel",
    "views/modules/Component/eventTableHelper",
    "views/forms/forms68/EXCEL/68_uploadExcel_chitiet",
    "views/forms/forms68/EXCEL/68_uploadExxcel_chitiet_0102294599",
    "views/forms/forms68/HDon/68_petro",
    "views/forms/forms70/BangKe/bangkeForm",
    "views/forms/forms70/BangKe/hoadonChietKhauForm",
], function (app, _, user, invoiceForms, huyhoadon, dieuchinhhoadon, viewLogForm, sendEmailForm, buttonOption,
    signMultiInvoice, gridInvoice, componentHelper, uploadExcel, eventTableHelper, uploadExcelDetail, uploadExcelDetail0102294599, petroForm, bangkeForm, hdonchietkhauForm) {
    'use strict';

    var chucNangComponent = buttonOption.subChucnang(huyhoadon, invoiceForms, dieuchinhhoadon, null, bangkeForm, hdonchietkhauForm);
    var subChucNang = webix.ui(chucNangComponent);
    var btnEmail = buttonOption.btnEmail(sendEmailForm);
    var btnKyCQT = buttonOption.btnKyCQT(2);
    var btnKy = buttonOption.btnKy();
    var btnPrintInvoice = buttonOption.btnPrintInvoice();
    var btnCopy = buttonOption.btnCopy(invoiceForms, 1, petroForm);
    var btnDelete = buttonOption.btnDelete();
    var btnEdit = buttonOption.btnEdit(invoiceForms, 1, petroForm);
    var btnAdd = buttonOption.btnAdd(invoiceForms, 1, petroForm);
    var btnRefresh = buttonOption.btnRefresh();
    var btnKyNhieuHoadon = buttonOption.btnKyNhieuHoadon(signMultiInvoice, 2);
    var cbGetAll = buttonOption.cbGetAll();
    var grid = gridInvoice.gridInitInvoice(viewLogForm, "K");
    var optionsPrint = buttonOption.optionPrint();
    var settingColumn = buttonOption.settingColumn();
    var controls = [
        btnRefresh,
        btnAdd,
        btnEdit,
        btnDelete,
        btnCopy,
        btnPrintInvoice,
        btnEmail,
        btnKy,
        btnKyCQT,
        btnKyNhieuHoadon,
        {
            view: "button", type: "htmlbutton", width: 120,
            label: '<i class="fa fa-tasks fa-lg aria-hidden="true"></i> ' +
                '<span class="text">' + _("Nghiệp vụ") + '</span>',
            id: "btnChucNang",
            click: function () {
                subChucNang.show(webix.$$("btnChucNang").$view);
            }
        },
        {},
        optionsPrint,
        settingColumn
    ];
    var fm = webix.Number.numToStr({
        groupDelimiter: ",",
        groupSize: 3,
        decimalDelimiter: ".",
        decimalSize: 0
    });

    var layout = {
        css: "frmView",
        id: "frmView",
        rows: [
            {
                id: "paramKH",
                view: "toolbar",
                css: { "background-color": "#f5f5f5 !important" },
                borderless: true,
                height: 35,
                cols: [
                    componentHelper.kyhieuHoadon("1K"),
                    cbGetAll,
                ]
            },
            { height: 39, id: "btnControl", css: "btnControl", margin: 0, borderless: true, type: "toolbar", cols: controls },
            { rows: [grid] }
        ]

    };

    return {
        $ui: layout,
        $oninit: function (view, $scope) {

            eventTableHelper.OnInit(1);
            buttonOption.subOption(uploadExcel, uploadExcelDetail, uploadExcelDetail0102294599, 1, 2);
            $scope.on(app, "dataChangedInvoie68", function (editmode, item) {
                var table = webix.$$("invoiceViews");

                if (editmode == 1) {
                    table.clearAll();
                    table.load(table.config.url);
                }
                if (editmode == 2) {
                    table.clearAll();
                    table.load(table.config.url);
                }
            });
        }
    };
});
define('views/forms/forms68/KyHieu/68_kyhieuForm',["app", "models/user"], function (app, user) {
    var editmode = 0;
    var param;
    var button = [
        {},
        {
            shortcut: "F10",
            view: "button",
            label: "Nhận (F10)",
            type: "form",
            align: "center",
            width: 120,
            on: {
                onClick: function () {
                    var item = $$("kyhieu-form").getValues();
                    var table = $$("kyhieu-form");

                    if (table.validate()) {
                        webix.extend(table, webix.ProgressBar);
                        table.disable();
                        table.showProgress();
                        webix.ajax()
                            .headers({ 'Content-type': 'application/json' })
                            .post(app.config.host + "/Serial/SerialSaveChange", item, {
                                error: function (text, data, XmlHttpRequest) {
                                    var table = $$("kyhieu-form");
                                    table.enable();
                                    table.hideProgress();
                                    webix.message(text, "error");

                                }, success: function (text, data, XmlHttpRequest) {
                                    var response = JSON.parse(text);
                                    var table = $$("kyhieu-form");
                                    table.enable();
                                    table.hideProgress();
                                    if (response.code == "00") {
                                        $$("kyhieu-win").close();
                                        var table = $$("kyhieu");
                                        table.clearAll();
                                        table.load(table.config.url);
                                    }
                                    else {
                                        webix.message(response.message, "error");
                                    }
                                }
                            });
                    }
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {
            view: "button",
            hotkey: "esc",
            label: "Hủy bỏ (ESC)",
            type: "danger",
            align: "center",
            width: 120,
            click: function () {
                webix.$$("kyhieu-win").close();
            }
        },
        {}
    ]

    var ui = {
        view: "window",
        modal: true,
        move: true,
        id: "kyhieu-win",
        position: "center",
        head: "Đăng ký ký hiệu hóa đơn/biên lai",
        on: {
            onBeforeShow: function () {
                if (editmode == 1) {
                    var date = new Date();
                    var year = date.getFullYear();
                    $$("khhdon").setValue("1C" + year.toString().substring(2, 4) + "TYY");
                }
            }
        },
        body: {
            paddingY: 10,
            paddingX: 10,
            view: "form",
            width: 600,
            id: "kyhieu-form",
            complexData: true,
            margin: 0,
            elements: [
                // {
                //     view: "text",
                //     label: "Tên mẫu",
                //     name: "ten_mau",
                //     required: true,
                //     invalidMessage: "Tên mẫu không được bỏ trống",
                //     labelWidth: 120
                // },
                {
                    view: "combo",
                    name: "lhdon",
                    label: "Loại hóa đơn",
                    //labelPosition: "top",
                    id: "lhdon",
                    required: true,
                    labelWidth: 120,
                    value: "1",
                    invalidMessage: "Loại hóa đơn không được bỏ trống !",
                    options: [
                        { id: "1", value: "Hóa đơn giá trị gia tăng" },
                        { id: "2", value: "Hóa đơn bán hàng" },
                        { id: "3", value: "Hóa đơn bán tài sản công" },
                        { id: "4", value: "Hóa đơn bán hàng dự trữ quốc gia" },
                        { id: "5", value: "Tem, vé, thẻ, phiếu thu điện tử, chứng từ điện tử khác có nội dung của hóa đơn điện tử" },
                        { id: "6", value: "Phiếu xuất kho kiêm vận chuyển nội bộ điện tử, Phiếu xuất kho hàng gửi bán đại lý điện tử" },
                        { id: "7", value: "Chứng từ khấu trừ thuế thu nhập cá nhân" },
                        { id: "8", value: "Biên lai điện tử theo nghị định 70" }
                    ],
                    on: {
                        onChange: function (newv, oldv) {
                            var kyhieu = $$("khhdon").getValue();
                            var res = kyhieu.replace(kyhieu.substring(0, 1), newv);
                            $$("khhdon").setValue(res);
                            $$("khhdon").refresh();
                            var year = new Date().getFullYear();
                            if (newv == 7) {
                                $$("khdon").hide();
                                $$("sdmau").hide();
                                $$("mau_so").show();
                                $$("khhdon").setValue("AA/" + year + "/E");
                                $$("hthuc").setValue("E");
                                $$("mau_so").define("options", [
                                    { id: "CT56", value: "CT56" }
                                ]);
                                $$("mau_so").setValue("CT56");
                                $$("mau_so").refresh();
                                $$("khhdon").enable();
                            }
                            else if (newv == 8) {
                                $$("khdon").hide();
                                $$("sdmau").hide();
                                $$("loai_doanh_nghiep").hide();
                                $$("mau_so").show();
                                $$("hthuc").setValue("B");
                                $$("mau_so").define("options", [
                                    { id: "EBL01", value: "EBL01-Biên lai không có mệnh giá" },
                                    { id: "EBL02", value: "EBL02- Biên lai có mệnh giá" }
                                ]);
                                $$("mau_so").setValue("EBL01");
                                $$("mau_so").refresh();
                                $$("khhdon").disable();
                            }
                            else {
                                if (newv == 6) {
                                    $$("hthuc").setValue("C");
                                    $$("khdon").setValue("N");
                                    $$("khhdon").setValue(`6C${year.toString().substring(2)}NYY`);
                                }
                                if (newv == 5) {
                                    $$("hthuc").setValue("C");
                                    $$("khdon").setValue("G");
                                    $$("khhdon").setValue(`5C${year.toString().substring(2)}GYY`);
                                }
                                if (newv == 2) {
                                    $$("hthuc").setValue("C");
                                    $$("khdon").setValue("T");
                                    $$("khhdon").setValue(`2C${year.toString().substring(2)}TYY`);
                                }
                                if (newv == 1) {
                                    $$("hthuc").setValue("C");
                                    $$("khdon").setValue("T");
                                    $$("khhdon").setValue(`1C${year.toString().substring(2)}TYY`);
                                }
                                $$("khdon").show();
                                $$("sdmau").show();
                                $$("mau_so").hide();
                                $$("khhdon").enable();
                            }
                        }
                    }
                },
                {
                    view: "combo",
                    label: "Hình thức",
                    name: "hthuc",
                    id: "hthuc",
                    required: true,
                    invalidMessage: "Hình thức không được bỏ trống",
                    labelWidth: 120, value: "C",
                    options: [
                        { id: "K", value: "Hóa đơn không có mã của CQT" },
                        { id: "C", value: "Hóa đơn có mã của CQT" },
                        { id: "E", value: "Chứng từ điện tử" },
                        { id: "B", value: "Biên lai điện tử do tổ chức đăng ký sử dụng với CQT" }
                    ],
                    on: {
                        onChange: function (newv, oldv) {
                            var kyhieu = $$("khhdon").getValue();
                            var res = kyhieu.replace(kyhieu.substring(1, 2), newv);
                            $$("khhdon").setValue(res);
                            $$("khhdon").refresh();
                        }
                    }
                },
                {
                    view: "combo",
                    label: "Kiểu hóa đơn",
                    name: "khdon",
                    id: "khdon",
                    labelWidth: 120,
                    required: true,
                    invalidMessage: "Hình thức không được bỏ trống", value: "T",
                    options: [
                        { id: "T", value: "Hóa đơn do doanh nghiệp tự đăng ký sử dụng" },
                        { id: "D", value: "Hóa đơn đặc thù, bán tài sản công" },
                        { id: "L", value: "Hóa đơn cơ quan thuế cấp từng lần" },
                        { id: "M", value: "Hóa đơn khởi tạo từ máy tính tiền" },
                        { id: "N", value: "Phiếu xuất kho kiêm vận chuyển nội bộ điện tử" },
                        { id: "B", value: "Phiếu xuất kho hàng gửi bán đại lý điện tử" },
                        { id: "G", value: "Tem, vé, thẻ điện tử là hóa đơn giá trị gia tăng" },
                        { id: "H", value: "Tem, vé, thử điện tử là hóa đơn bán hàng" }
                    ],
                    on: {
                        onChange: function (newv, oldv) {
                            var kyhieu = $$("khhdon").getValue();

                            var res = kyhieu.replace(kyhieu.substring(4, 5), newv);
                            $$("khhdon").setValue(res);
                            $$("khhdon").refresh();
                        }
                    }
                },
                {
                    view: "text",
                    label: "Ký hiệu",
                    name: "khhdon",
                    id: "khhdon",
                    labelWidth: 120,
                    required: true,
                    invalidMessage: "Ký hiệu không được bỏ trống",
                    attributes: {
                        maxlength: 9
                    }
                    // validate: webix.rules.isMauSo
                },
                {
                    view: "combo",
                    label: "Mẫu số",
                    name: "mau_so",
                    id: "mau_so",
                    value: "CTT56",
                    labelWidth: 120,
                    hidden: true,
                    required: true,
                    invalidMessage: "Mẫu số không được bỏ trống",
                    attributes: {
                        maxlength: 20
                    },
                    options: [
                        { id: "CTT56", value: "CTT56" }
                    ],
                    on: {
                        onChange: function(newv, oldv) {
                            var lhdonValue = $$("lhdon").getValue();
                            if (lhdonValue == 8) {
                                var year = new Date().getFullYear();
                                $$("khhdon").setValue(newv + "-" + year.toString().substring(2) + "T");
                            }
                        }
                    }
                    // validate: webix.rules.isMauSo
                },
                {
                    id: "sdmau",
                    name: "sdmau",
                    label: "Số dòng in mẫu",
                    labelWidth: 120,
                    view: "autonumeric",
                    css: {
                        "text-align": "right"
                    },
                    value: 8
                },
                {
                    view: "combo",
                    label: "Mẫu thiết kế",
                    name: "quanlymau68_id",
                    id: "quanlymau68_id",
                    labelWidth: 120,
                    required: true,
                    invalidMessage: "Mẫu không được bỏ trống",
                    options: app.config.host + "/TemplateInvoice/GetAllData",
                    on: {
                        onChange: function (newv, oldv) {

                        }
                    }
                },
                {
                    view: "combo",
                    label: "Loại doanh nghiệp",
                    name: "loai_doanh_nghiep",
                    id: "loai_doanh_nghiep",
                    labelWidth: 120,
                    options: [
                        { id: 99, value: "" },
                        { id: 1, value: "Xăng dầu" },
                        { id: 2, value: "Mua bán xe máy" },
                        { id: 3, value: "Dịch vụ vận chuyển" },
                        { id: 4, value: "Dịch vụ vận chuyển trên nền tảng số, TMĐT" }
                    ]
                },
                {
                    margin: 10,
                    cols: button
                }
            ]
        }

    };

    return {
        $ui: ui,
        setEditMode: function (mode) {
            editmode = mode;
        },
        initUI: function (item) {
            param = item;
        },
        setValues: function (item) {
            $$("kyhieu-form").setValues(item);
        }
    };
});
define('views/68_kyhieu',[
    "app",
    "locale",
    "models/user",
    "views/forms/forms68/KyHieu/68_kyhieuForm"
], function (
    app,
    _,
    user,
    kyhieuForm
) {
    "use strict";

    var initUI = function () {
        var table = webix.$$("kyhieu");
        var url = {
            $proxy: true,
            load: function (view, callback, params) {
                var start = null;
                var count = null;
                var filter = [];
                var tlbparam_s = [];
                var url = app.config.host + "/Pattern/GetData";
                if (params == null) {
                    start = 0;
                    count = view.config.datafetch;
                    url = url + "?command=CM0008&start=0&count=" + view.config.datafetch + "&continue=null&filter=null";
                    //webix.ajax(url, callback, view);
                }
                else {
                    start = params.start;
                    count = params.count;
                    url = url + "?start=" + params.start + "&count=" + params.count + "&continue=" + params.continue;
                    if (params.filter != null) {
                        var array = [];

                        for (var property in params.filter) {
                            var column = view.getColumnConfig(property);
                            var item = {
                                columnName: property,
                                columnType: column.columnType,
                                value: params.filter[property]
                            };
                            array.push(item);
                        }
                        if (array.length > 0) {
                            filter = array;
                            url = url + "&filter=" + JSON.stringify(array);
                        }
                        else {
                            url = url + "&filter=null";
                        }
                    }
                }
                //webix.ajax(url, callback, view);
                var item = {
                    command: "CM0008",
                    start: start,
                    count: count,
                    filter: filter,
                    tlbparam: tlbparam_s
                };
                var apiHost = app.config.host + "/Pattern/GetData";
                webix.ajax()
                    .headers({ 'Content-type': 'application/json' })
                    .bind(view)
                    .post(apiHost, item, callback, view);
            },
        };
        table.define("url", url);
    };

    var submenuChucNang = webix.ui({
        id: "submnchucnang",
        view: "submenu",
        width: 250,
        padding: 0,
        data: [{
            id: "UploadTemplate",
            value: "Tải mẫu lên"
        },
        {
            id: "SignTemplate",
            value: "Ký mẫu hóa đơn"
        },
        {
            id: "PreviewTemplate",
            value: "Xem mẫu hóa đơn (PDF)"
        },
        {
            id: "DownloadTemplate",
            value: "Tải mẫu thiết kế (.repx)"
        },

        ],
        on: {
            onItemClick: function (id, e, node) {
                this.hide();
                var selectedItem = webix.$$("congvieckinhdoanh").getSelectedItem();
                if (selectedselectedItem == null) {
                    webix.message("Bạn chưa chọn khách hàng !", "error");
                    return;
                }
            },
        },
    });

    var controls = [
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-refresh fa-lg" aria-hidden="true"></i> ' +
                '<span class="text">' + _("REFRESH") + '</span>',
            id: "btnRefresh",
            // id: "btnRefresh",
            // view: "button",
            // type: "icon",
            // icon: "refresh",
            // label: _("REFRESH"),
            // width: 100,
            // css: "button_raised",
            on: {
                onClick: function () {
                    var table = webix.$$("kyhieu");
                    table.clearAll();
                    table.load(table.config.url);
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-plus fa-lg" aria-hidden="true"></i> ' +
                '<span class="text">' + _("THEM") + ' (F4)</span>',
            id: "btnPlus",
            shortcut: "F4",
            on: {
                onClick: function () {
                    var detailForm = this.$scope.ui(kyhieuForm.$ui);
                    kyhieuForm.setEditMode(1);
                    var params = null;

                    var tlbParams = $$("paramDonvi");

                    if (tlbParams !== undefined) {
                        var childViews = tlbParams.getChildViews();

                        var item = [];

                        for (var i = 0; i < childViews.length; i++) {
                            var child = childViews[i];
                            var id = child.config.id;
                            var value_field = child.config.value_field;

                            item[id] = $$(id).getValue();

                        }

                        params = item;
                    }
                    kyhieuForm.initUI(params);
                    detailForm.show();
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-edit fa-lg" aria-hidden="true"></i> ' +
                '<span class="text">' + _("SUA") + ' (F3)</span>',
            id: "btnEdit",
            shortcut: "F2",
            // id: "btnEdit",
            // view: "button",
            // type: "icon",
            // icon: "edit",
            // label: _("SUA") + " (F3)",
            // width: 100,
            // css: "button_raised",
            // shortcut: "F3",
            on: {
                onClick: function () {
                    var table = webix.$$("kyhieu");
                    var selectedItem = table.getSelectedItem();
                    if (selectedItem == null) {
                        webix.message("Bạn chưa chọn khách hàng ! ", "error");
                        return;
                    }
                    if (selectedItem.tt_sd > 0) {
                        webix.message("Ký hiệu đã sử dụng không thể sửa ! ", "error");
                        return;
                    }
                    var detailForm = this.$scope.ui(kyhieuForm.$ui);
                    kyhieuForm.setEditMode(2);
                    kyhieuForm.setValues(selectedItem);
                    detailForm.show();
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-trash-o fa-lg" aria-hidden="true"></i> ' +
                '<span class="text">' + _("XOA") + ' (F3)</span>',
            id: "btnDelete",
            shortcut: "F3",
            // id: "btnDelete",
            // view: "button",
            // type: "icon",
            // icon: "trash-o",
            // label: _("XOA") + " (F8)",
            // width: 100,
            // css: "button_raised",
            // shortcut: "F8",
            on: {
                onClick: function () {
                    var table = webix.$$("kyhieu");
                    var selectedItem = table.getSelectedItem();
                    if (selectedItem == null) {
                        webix.message("Bạn chưa chọn ký hiệu hóa đơn cần xóa ! ", "error");
                        return;
                    }
                    if (selectedItem.tt_sd > 0) {
                        webix.message("Ký hiệu đã sử dụng không thể xóa ! ", "error");
                        return;
                    }

                    webix.confirm({
                        text: "Bạn có muốn xóa bản ghi",
                        ok: "Có",
                        cancel: "Không",
                        callback: function (choose) {
                            if (choose) {
                                webix.extend(table, webix.ProgressBar);
                                table.disable();
                                table.showProgress();

                                webix.ajax()
                                    .headers({ 'Content-type': 'application/json' })
                                    .get(app.config.host + "/Serial/SerialDelete?id=" + selectedItem.quanlykyhieu68_id,
                                        {
                                            error: function (text, data, XmlHttpRequest) {
                                                table.enable();
                                                table.hideProgress();
                                            },
                                            success: function (text, data, XmlHttpRequest) {
                                                var res = JSON.parse(text);
                                                table.enable();
                                                table.hideProgress();
                                                if (res.code != "00") {
                                                    webix.message(res.message, "error");
                                                }
                                                else {
                                                    table.remove(selectedItem.id);
                                                }
                                            }
                                        });
                            }
                        }
                    });
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-print fa-lg" aria-hidden="true"></i> ' +
                '<span class="text">' + _("PRINT") + ' (F7)</span>',
            id: "btnPrint",
            shortcut: "F7",
            on: {
                onClick: function () {
                    var table = webix.$$("kyhieu");
                    var item = table.getSelectedItem();
                    if (item == null || item == undefined) {
                        webix.message("Bạn chưa chọn hóa đơn cần in !", "error");
                        return;
                    }
                    var box = webix.modalbox({
                        title: "Đang in hóa đơn ....",
                        text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                        width: 350,
                        height: 200
                    });

                    var newWin = window.open();
                    var html = '<html><head><title>Hóa đơn điện tử M-Invoice</title>'
                        + '<link rel="stylesheet" href="assets/fontawesome_pro/css/all.css" type="text/css" charset="utf-8">'
                        + '<link rel="stylesheet" href="assets/fontawesome.css" type="text/css" charset="utf-8">'
                        + '</head><body><center>Đang tải dữ liệu ... <br><p><i style="font-size:200%;" class="fa fa-spin fa-spinner"></i></p></center></body></html>';
                    newWin.document.write(html);

                    webix.ajax()
                        .response("arraybuffer")
                        .headers({ 'Content-type': 'application/json' })
                        .get(app.config.host + "/Serial/PrintTemplateInvoice?id=" + item.quanlykyhieu68_id,
                            {
                                error: function (text, data, XmlHttpRequest) {
                                    webix.modalbox.hide(box);
                                },
                                success: function (text, data, XmlHttpRequest) {
                                    var file = new Blob([data], { type: 'application/pdf' });
                                    var fileURL = URL.createObjectURL(file);
                                    //window.open(fileURL, '_blank');
                                    webix.modalbox.hide(box);
                                    newWin.location = fileURL;
                                }
                            });
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {}
    ];

    var table = {
        margin: 0,
        rows: [
            {
                id: "kyhieu",
                view: "datatable",
                select: true,
                resizeColumn: true,
                footer: false,
                editable: false,
                tooltip: true,
                scheme: {
                    $init: function (obj) {
                    }
                },
                on: {
                    "data->onStoreUpdated": function () {
                        this.data.each(function (obj, i) {
                            obj.index = i + 1;
                        });
                    },
                    onItemDblClick: function (id, e, node) {
                        var btnEdit = $$("btnEdit");
                        btnEdit.callEvent("onClick");
                    },
                    onBeforeLoad: function () {
                        this.showOverlay("<p><i style='font-size:450%;' class='fa fa-spin fa-spinner fa-pulse'></i></p>");
                    },
                    onAfterLoad: function (id) {
                        this.hideOverlay();
                    }
                },
                columns: [
                    {
                        id: "quanlykyhieu68_id",
                        header: "quanlykyhieu68_id",
                        hidden: true
                    },
                    {
                        id: "index",
                        header: "STT",
                        sort: "int",
                        width: 40,
                        columnType: "numeric"
                    },
                    {
                        id: "tmau",
                        header: ["Tên mẫu", { content: "serverFilter" }],
                        width: 260
                    },
                    {
                        id: "lhdon",
                        header: ["Loại hóa đơn", { content: "serverFilter" }],
                        width: 120
                    },
                    {
                        id: "hthuc",
                        header: ["Hình thức", { content: "serverFilter" }],
                        width: 120
                    },
                    {
                        id: "khdon",
                        header: ["Kiểu hóa đơn", { content: "serverFilter" }],
                        width: 120
                    },
                    {
                        id: "mau_so",
                        header: ["Mẫu số", { content: "serverFilter" }],
                        width: 120
                    },
                    {
                        id: "khhdon",
                        header: ["Ký hiệu", { content: "serverFilter" }],
                        width: 120
                    },
                    {
                        id: "sdmau",
                        header: ["Số dòng in mẫu", { content: "serverFilter" }],
                        width: 120, columnType: "int"
                    },
                    // {
                    //     id: "trangThai",
                    //     header: [
                    //         "Số dòng in mẫu",
                    //         {
                    //             content: "serverFilter",
                    //         },
                    //     ],
                    //     width: 120,
                    //     template: function (obj) {
                    //         return (
                    //             "<span class='tt_kyhieu_status" +
                    //             obj.trangThai +
                    //             "'>" +
                    //             obj.trangThai +
                    //             "</span>"
                    //         );
                    //     }
                    // },
                    {
                        id: "date_new",
                        header: ["Ngày lập", { content: "serverDateRangeFilter" }],
                        width: 150,
                        columnType: "datetime",
                        format: function (text) { return formatDate(text); }
                    },
                    {
                        id: "user_new",
                        header: ["Người lập", { content: "serverFilter" }],
                        width: 120,
                    },
                    {
                        id: "tt_sdung",
                        header: ["Sử dụng", { content: "serverSelectFilter" }],
                        editor: "checkbox",
                        width: 90,
                        template: function (obj) {
                            var checked = obj.tt_sd > 1 ? 'checked="true"' : "";
                            return ("<input disabled class='webix_table_checkbox' type='checkbox' " + checked + ">");
                        }
                    }
                ],
                pager: "pagerA",
            },
            {
                id: "pagerA",
                view: "pager",
                template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}",
                container: "paging_here",
                size: 50,
                group: 5,
            },
        ],
    };

    var layout = {
        css: "frmView",
        rows: [
            {
                height: 39,
                css: "btnControl",
                margin: 0,
                borderless: true,
                type: "toolbar",
                // height: 40,
                cols: controls,
            },
            {
                rows: [table],
            },
        ],
    };

    function loadData() {
        var table = webix.$$("kyhieu");
        table.clearAll();
        table.load(table.config.url);
    }

    return {
        $ui: layout,
        $oninit: function (view, $scope) {
            var table = webix.$$("kyhieu");
            webix.extend(view, webix.ProgressBar);

            $scope.on(app, "dataChangedKyhieu68", function (mode, item) {

                if (mode == 1) {
                    table.add(item);
                }

                if (mode == 2) {
                    table.clearAll();
                    table.load(table.config.url);
                }
            });

            $scope.on(app, "filterTable", function (report_id, infoWindowId, item) {
                var infoparam = {
                    infowindow_id: infoWindowId,
                    parameter: item,
                };

                table.config.infoparam = infoparam;
                table.clearAll();
                table.load(table.config.url);
            });
        },
        $onurlchange: function (ui, name, url, scope) {
            initUI();
        },
    };
});
define('views/forms/forms68/Mau04/68_mau04FormList',["app", "models/user"], function (app, user) {
    var editmode = 0;

    var button = [
        {},
        {
            shortcut: "F10",
            view: "button",
            label: "Nhận (F10)",
            type: "form",
            align: "center",
            width: 120,
            on: {
                onClick: function () {

                    var table = webix.$$("list_hoadon");
                    var data = table.serialize();
                    var lstTemp = [];

                    for (var i = 0; i < data.length; i++) {
                        var item = data[i];
                        if (item.chon != undefined) {
                            if (item.chon == "C") {
                                item["tdlap"] = removeTimeZoneT(item["tdlap"]);
                                lstTemp.push(item);
                                item.nlap = item.tdlap;
                            }
                        }
                    }

                    if (lstTemp.length == 0) {
                        webix.message({ type: "error", text: "Bạn chưa chọn hóa đơn" });
                        return;
                    }

                    var frm = webix.$$("danhsach_hoadon");
                    var dataInvoice = frm.serialize();
                    dataInvoice.forEach(element => {
                        lstTemp.forEach(elementChild => {
                            if (elementChild.hoadon68_id == element.hoadon68_id) {
                                const index = dataInvoice.indexOf(element);
                                if (index > -1) {
                                    dataInvoice.splice(index, 1);
                                }
                            }
                        });
                    });
                    var newArray = lstTemp.concat(dataInvoice);
                    frm.clearAll();
                    frm.parse(newArray);
                    $$("danhsachmau04-win").close();
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {
            view: "button",
            hotkey: "esc",
            label: "Hủy (ESC)",
            type: "danger",
            align: "center",
            width: 120,
            click: function () {
                webix.$$("danhsachmau04-win").close();
            }
        },
        {}
    ]

    var ui = {
        view: "window",
        modal: true,
        move: true,
        id: "danhsachmau04-win",
        position: "center",
        head: "Chọn hóa đơn thông báo sai sót",
        body: {
            paddingY: 10,
            paddingX: 10,
            view: "form",
            width: 1200,
            height: 580,
            id: "danhsachmau04-form",
            complexData: true,
            margin: 0,
            elements: [
                {
                    cols: [
                        {
                            id: "kyhieu_id", view: "combo",
                            name: "kyhieu_id", width: 200, label: "Ký hiệu",
                            options: {
                                body: {
                                    url: app.config.host + "/Invoice68/GetAllSerial",
                                    ready: function () {
                                        var count = this.count();
                                        if (count > 0) {
                                            var combo = webix.$$("kyhieu_id");
                                            combo.setValue(this.getFirstId());
                                        }
                                    }
                                }
                            }
                        },
                        { id: "shdon", view: "text", attributes: { type: "number" }, name: "shdon", width: 200, label: "Số hóa đơn" },
                        { id: "tu_ngay", view: "datepicker", name: "tu_ngay", width: 200, label: "Từ ngày" },
                        { id: "den_ngay", view: "datepicker", name: "den_ngay", width: 200, label: "Đến ngày" },
                        {
                            view: "button", id: "btnSearch04",
                            css: "webix_primary",
                            type: "icon", icon: "mdi mdi-file-find",
                            width: 100, label: "Tìm kiếm",
                            on: {
                                onItemClick: function (id, e) {

                                    var data = webix.$$("danhsachmau04-form").getValues();
                                    var frm = $$("danhsachmau04-win");
                                    var table = $$("list_hoadon");
                                    var url = app.config.host + "/CancelInvoice/GetInvoiceNotCancel";

                                    webix.extend(frm, webix.ProgressBar);
                                    frm.disable();
                                    frm.showProgress();
                                    webix.ajax()
                                        .headers({ 'Content-Type': 'application/json' })
                                        .post(url, data, function (text) {
                                            frm.enable();
                                            frm.hideProgress();
                                            var result = JSON.parse(text);
                                            if (result.code == "00") {
                                                table.clearAll();
                                                result.data.forEach(function(item) {
                                                    if (item.tdlap) {
                                                        item.tdlap = new Date(item.tdlap);
                                                    }
                                                });
                                                table.parse(result.data);
                                            }
                                            else {
                                                webix.message(result.message + result.data, "error");
                                            }
                                        });
                                }
                            },
                        }
                    ]
                },
                {
                    height: 20
                },
                {
                    view: "datatable",
                    id: "list_hoadon",
                    name: "list_hoadon",
                    select: true,
                    resizeColumn: true,
                    footer: false,
                    editable: false,
                    tooltip: true,
                    //url: app.config.host + "/SummaryData/GetHoadonChoXuLy?tu_ngay=2020-99-90&den_ngay=20202-02929-92892",
                    scheme: {
                        $init: function (obj) {

                        },
                    },
                    on: {

                    },
                    columns: [
                        {
                            id: "chon",
                            header: [{ text: "", content: "masterCheckbox" }],
                            width: 55,
                            checkValue: 'C',
                            uncheckValue: 'K',
                            template: "{common.checkbox()}"
                        },
                        {
                            id: "ten_tt", name: "ten_tt",
                            header: ["Trạng thái", { content: "textFilter" }], width: 100
                        },
                        {
                            id: "khieu", name: "khieu",
                            header: ["Ký hiệu", { content: "textFilter" }], width: 100
                        },
                        {
                            id: "tdlap",
                            name: "tdlap",
                            header: ["Ngày hóa đơn", { content: "datepickerFilter" }],
                            width: 130,
                            format: function (text) {
                                var format = webix.Date.dateToStr("%d/%m/%Y");
                                text = removeTimeZoneT(text);
                                return format(text);
                            }
                        },
                        {
                            id: "shdon", name: "shdon",
                            header: ["Số hóa đơn", { content: "textFilter" }], width: 100
                        },

                        {
                            id: "tennguoimua", name: "tennguoimua",
                            header: ["Tên đơn vị/Tên người mua", { content: "textFilter" }],
                            width: 400
                        },
                        {
                            id: "mst", name: "mst",
                            header: ["Mã số thuế", { content: "textFilter" }],
                            width: 150
                        },
                        {
                            id: "macqt", name: "macqt",
                            header: ["Mã CQT cấp", { content: "textFilter" }],
                            width: 150
                        }
                    ]
                },
                {
                    margin: 10,
                    cols: button
                }
            ]
        }
    };

    return {
        $ui: ui,
        setEditMode: function (mode) {
            editmode = mode;
        },
        setValues: function (values) {
            var fmDate = function (text) {
                var format = webix.Date.dateToStr("%d/%m/%Y");
                text = removeTimeZoneT(text);
                return format(text);
            };
            var ngayFileter = fmDate(values.ngay);
            var url = app.config.host + "/SummaryData/GetHoadonChoXuLy?type="
                + values.lkdlieu + "&thang=" + values.thang + "&nam=" + values.nam + "&ngay=" + ngayFileter + "&cctbao_id=" + values.kyhieu_id;
            var tableDetail = webix.$$("list_hoadon");
            webix.ajax()
                .headers({ 'Content-type': 'application/json' })
                .get(url, function (text) {
                    var data = JSON.parse(text);
                    data.forEach(function(item) {
                        if (item.tdlap) {
                            item.tdlap = new Date(item.tdlap);
                        }
                    });
                    tableDetail.clearAll();
                    tableDetail.parse(data);
                });
        }
    };
});
define('views/forms/forms70/Mau04/70_mau04Form',["app", "models/user", "views/forms/forms68/Mau04/68_mau04FormList",
    "views/modules/Component/functionExtension"], function (app, user, mau04List, functionExtension) {
        var editmode = 0;
        var formId = "mau04-form";
        var tblId = "danhsach_hoadon";
        var eventChanged = "dataChangedMau0405";
        function isValidDate(dateStr) {
            const regex = /^(\d{2})\/(\d{2})\/(\d{4})$/;
            const match = dateStr.match(regex);
            if (!match) return false;

            const day = parseInt(match[1], 10);
            const month = parseInt(match[2], 10) - 1;
            const year = parseInt(match[3], 10);

            const date = new Date(year, month, day);
            return (
                date.getFullYear() === year &&
                date.getMonth() === month &&
                date.getDate() === day
            );
        }

        var button = [
            {},
            {
                shortcut: "F10", view: "button", label: "Lưu tạm (F10)", id: "btnBTHSave", type: "form", align: "center", width: 120,
                on: {
                    onClick: function () {
                        var item = $$(formId).getValues();
                        var tableHoadon = $$(formId);

                        if (tableHoadon.validate()) {
                            var ds_hdon = $$(tblId).serialize();
                            if (ds_hdon.length == 0) {
                                webix.message("Bạn chưa nhập chi tiết", "error");
                                return;
                            }
                            else {
                                if ($$(tblId).validate()) {
                                    var i = 0;
                                    var countLD = 0;

                                    webix.confirm({
                                        title: "04SS-HDDT",
                                        text: "Bạn có chắc chắn muốn lưu dữ liệu?", ok: "Có", cancel: "Không",
                                        callback: function (res) {
                                            if (res) {
                                                ds_hdon.forEach(function (entry, count) {
                                                    var khieu = entry["khieu"];
                                                    var loaiapdung = entry["ladhddt"];
                                                    var tinhchat_tb = entry["tctbao"];
                                                    var tthdon = entry["tthdon"];
                                                    var is_tthdon = entry["is_tthdon"];

                                                    if (loaiapdung != 3 && loaiapdung != 4) {
                                                        var otpCheck = khieu.toString();
                                                        if (otpCheck.substring(1, 2) == "C") {
                                                            if (entry["macqt"] == null || entry["macqt"] == "") {
                                                                webix.message("Mã cơ quan thuế không được để trống tại dòng " + (Number(count) + 1), "error");
                                                                i++;
                                                                return;
                                                            }
                                                        }
                                                        if (entry["ldo"] == null || entry["ldo"] == "") {
                                                            webix.message("Lý do không được để trống tại dòng " + (Number(count) + 1), "error");
                                                            countLD++;
                                                            return;
                                                        }
                                                    }
                                                });
                                                if (i > 0) {
                                                    return;
                                                }
                                                if (countLD > 0) {
                                                    return;
                                                }
                                                // }
                                                item["mau04_chitiets"] = ds_hdon;
                                                webix.extend(tableHoadon, webix.ProgressBar);
                                                tableHoadon.disable();
                                                tableHoadon.showProgress();
                                                webix.ajax()
                                                    .headers({ 'Content-type': 'application/json' })
                                                    .post(app.config.host + "/CancelInvoice/Mau04SaveChange", item, {
                                                        error: function (text, data, XmlHttpRequest) {
                                                            tableHoadon.enable();
                                                            tableHoadon.hideProgress();
                                                            webix.message(text, "error");

                                                        }, success: function (text, data, XmlHttpRequest) {
                                                            var response = JSON.parse(text);
                                                            tableHoadon.enable();
                                                            tableHoadon.hideProgress();
                                                            if (response.code != "00") return showError(response.message);
                                                            webix.$$("mau04-win").close();
                                                            app.callEvent(eventChanged, [1, null]);
                                                            webix.message("Tạo thông báo 04/SS-HDDT thành công", "success");
                                                            functionExtension.Sign04SS(response.data, $$("frmView"));
                                                        }
                                                    });
                                            }
                                        }
                                    });
                                }
                            }
                        }
                    }
                },
                click: function () {
                    this.callEvent("onClick");
                }
            },
            {
                view: "button", hotkey: "esc", label: "Quay lại (ESC)", type: "danger", align: "center", width: 120,
                click: function () {
                    webix.$$("mau04-win").close();
                }
            },
            {}
        ]
        var ui = {
            view: "window",
            modal: true,
            move: true,
            id: "mau04-win",
            position: "center",
            head: {
                height: 35,
                cols: [
                    {
                        id: "head-icondksd", view: "template", css: "headform", width: 35,
                        template: "<span><i class='fa fa-plus' aria-hidden='true'></i></span>"
                    },
                    {
                        id: "head-formdksd", view: "template", css: "headform", template: function (obj) {
                            return '<div>Thông báo hóa đơn điện tử có sai sót<div/>';
                        }
                    },
                    {
                        view: "icon", icon: "fas fa-question-circle", id: "help_dksdForms", tooltip: "HELPER", click: function () {
                        }
                    }
                ]
            },
            body: {
                view: "form",
                width: 1200,
                height: 580,
                id: formId,
                complexData: true,
                elementsConfig: { labelWidth: 170 },
                margin: 0,
                elements: [
                    {
                        template: "<center><b><span style='font-size:17px;'>THÔNG BÁO HÓA ĐƠN CÓ SAI SÓT</b></center>", borderless: true, height: 40
                    },
                    {
                        paddingX: 10,
                        rows: [
                            {
                                view: "combo",
                                label: "Loại thông báo",
                                value: 1,
                                options: [
                                    { id: "1", value: "Thông báo của Người nộp thuế" },
                                    { id: "2", value: "Thông báo của Người nộp thuế theo thông báo của CQT" }
                                ],
                                attributes: { readonly: true },
                                id: "loai_tbao",
                                name: "loai_tbao",
                                required: true,
                                invalidMessage: "Kính gửi không được để trống !",
                                on: {
                                    onChange: function (newVal) {
                                        const show = (newVal == "2");
                                        const form = this.getFormView();
                                        const soTB = form.elements["so"];
                                        const ntbccqt = form.elements["ntbccqt"];
                                        if (show) {
                                            soTB.show();
                                            ntbccqt.show();
                                        } else {
                                            soTB.hide();
                                            ntbccqt.hide();
                                            soTB.setValue(null);
                                            ntbccqt.setValue(null);
                                        }
                                        soTB.define("required", show);
                                        ntbccqt.define("required", show);
                                        soTB.refresh();
                                        ntbccqt.refresh();
                                    }
                                }
                            },
                            {
                                view: "text",
                                label: "Cơ quan thuế tiếp nhận ",
                                id: "tcqt",
                                name: "tcqt",
                                required: true,
                                invalidMessage: "Kính gửi không được để trống !",
                                disabled: true
                            },
                            {
                                view: "label",
                                borderless: true,
                                css: { "color": "red" },
                                template: "<span>Lưu ý: để thông báo hóa đơn sai sót Quý khách hàng cần cập"
                                    + " nhật đúng mã cơ quan thuế quản lý <a style='color: blue; 'text-decoration': 'underline'>tại đây<a></span>",
                                on: {
                                    onItemClick: function () {
                                        app.router('app/infocompany');
                                    }
                                }
                            },
                            {
                                view: "text",
                                label: "Tên người nộp thuế",
                                required: true,
                                invalidMessage: "Tên người nộp thuế không được để trống !",
                                id: "tnnt",
                                name: "tnnt",
                                disabled: true
                            },
                            {
                                view: "text",
                                label: "Mã số thuế",
                                id: "mst",
                                name: "mst",
                                required: true,
                                invalidMessage: "Mã số thuế không được để trống !",
                                disabled: true
                            },
                            {
                                cols: [
                                    {
                                        view: "text",
                                        label: "Số thông báo từ CQT",
                                        id: "so",
                                        name: "so",
                                        hidden: true,
                                        required: false,
                                        attributes: { maxlength: 30 },
                                        invalidMessage: "Số thông báo từ CQT không được để trống !",
                                    },
                                    {
                                        view: "datepicker",
                                        label: "Ngày thông báo của CQT",
                                        required: true,
                                        invalidMessage: "Ngày thông báo không được để trống!",
                                        hidden: true,
                                        id: "ntbccqt",
                                        name: "ntbccqt",
                                        editable: true,
                                        stringResult: true,
                                        format: "%d/%m/%Y",
                                        on: {
                                            onBlur: function () {
                                                const rawInput = this.getInputNode().value.trim();

                                                if (!isValidDate(rawInput)) {
                                                    this.setValue("");
                                                    webix.message("Ngày không hợp lệ, vui lòng nhập đúng định dạng dd/mm/yyyy!", "error");
                                                }
                                            },
                                            onEnter: function () {
                                                const rawInput = this.getInputNode().value.trim();

                                                if (!isValidDate(rawInput)) {
                                                    this.setValue("");
                                                    webix.message("Ngày không hợp lệ, vui lòng nhập đúng định dạng dd/mm/yyyy!", "error");
                                                }
                                            }
                                        }
                                    }
                                ]
                            },
                            {
                                cols: [
                                    {
                                        view: "datepicker",
                                        label: "Ngày lập",
                                        editable: true,
                                        required: true,
                                        invalidMessage: "Ngày lập không được để trống!",
                                        id: "ntbao",
                                        name: "ntbao",
                                        stringResult: true,
                                        value: new Date(),
                                        format: "%d/%m/%Y",
                                        on: {
                                            onChange: function (newValue, oldValue) {
                                                const inputValue = this.getInputNode().value;

                                                if (!isValidDate(inputValue)) {
                                                    this.setValue("");
                                                    webix.message({
                                                        type: "error",
                                                        text: "Ngày không hợp lệ, vui lòng nhập đúng định dạng dd/mm/yyyy!"
                                                    });
                                                }
                                            }
                                        }
                                    }
                                    ,
                                    {
                                        view: "text",
                                        label: "Nơi lập",
                                        required: true,
                                        invalidMessage: "Nơi lập không được để trống !",
                                        attributes: { maxlength: 50 },
                                        id: "ddanh",
                                        name: "ddanh"
                                    }
                                ]
                            }
                        ]
                    },
                    { height: 3 },
                    { template: "<b><span >Người nộp thuế thông báo về việc hủy/ giải trình hóa đơn điện tử do sai sót như sau:</b>", borderless: true, height: 40 },
                    {
                        cols: [
                            {
                                view: "button",
                                id: "btnSelectHD",
                                css: "webix_primary",
                                type: "icon", icon: "mdi mdi-plus-box",
                                width: 120,
                                label: "Chọn hóa đơn",
                                on: {
                                    onItemClick: function (id, e) {
                                        var frmHD = this.$scope.ui(mau04List.$ui);
                                        frmHD.show();
                                        frmHD.attachEvent("onSelectChange", function (selectedItem) {
                                            var table = webix.$$(tblId);
                                            var item = {
                                                id: webix.uid(),
                                                khmsohd: selectedItem.khieu.charAt(0),
                                                khieu: selectedItem.khieu.slice(1),
                                                ladhddt: 3,
                                                tctbao: 6
                                            };
                                            table.add(item);
                                            table.select(item.id, "khieu", false);
                                            table.edit({ row: item.id, column: "khieu" });
                                        });
                                    }
                                }
                            },
                            {
                                view: "button",
                                css: "webix_primary",
                                type: "icon", icon: "mdi mdi-plus",
                                width: 100,
                                label: "Thêm dòng",
                                on: {
                                    onItemClick: function (id, e) {
                                        var table = webix.$$(tblId);
                                        var item = { id: webix.uid(), ladhddt: 1, tctbao: 6 };
                                        table.add(item);
                                        table.select(item.id, "khieu", false);
                                        table.edit({ row: item.id, column: "khieu" });
                                    }
                                }
                            },
                            {
                                view: "button",
                                css: "webix_primary",
                                type: "icon", icon: "wxi-trash",
                                width: 100,
                                label: "Xóa dòng",
                                on: {
                                    onItemClick: function (id, e) {
                                        var table = webix.$$(tblId);
                                        table.editStop();
                                        var item = table.getSelectedItem();
                                        if (!webix.isUndefined(item)) {
                                            table.remove(item.id);
                                            table.clearSelection();
                                            return;
                                        }
                                        var editor = table.getEditState();
                                        if (!webix.isUndefined(editor)) {
                                            table.remove(editor.row);
                                            table.clearSelection();
                                            return;
                                        }
                                    }
                                }
                            }
                        ]
                    },
                    {
                        rows: [
                            {
                                view: "datatable",
                                id: tblId,
                                name: tblId,
                                select: "cell",
                                scroll: true,
                                resizeColumn: true,
                                autowidth: true,
                                editable: true,
                                tooltip: true,
                                scheme: {
                                    $init: function (obj) {

                                    }
                                },
                                on: {
                                    "data->onStoreUpdated": function () {
                                        this.data.each(function (obj, i) {
                                            obj.stt = i + 1;
                                        });
                                    },
                                    onValidationError: function (id, obj, details) {
                                    },
                                    onBeforeEditStart: function (obj) {
                                        if (obj.column == "khmsohd") {
                                            var row = this.getItem(obj.row);
                                            if (String(row.ladhddt) === "1") {
                                                return false;
                                            }
                                        }
                                        if (obj.column == "tctbao" && editmode == 2)
                                            return false;
                                    },
                                    onAfterEditStop: function (state, editor) {
                                        if (editor.column == "ladhddt") {
                                            const item = this.getItem(editor.row);
                                            if (state.value == "1") {
                                                this.getColumnConfig("khmsohd").editor = null;
                                            } else {
                                                this.getColumnConfig("khmsohd").editor = "text";
                                            }
                                            this.refreshColumns();
                                        }
                                    }
                                },

                                columns: [
                                    { id: "stt", name: "stt", header: "STT", width: 40, },
                                    { id: "khmsohd", name: "khmsohd", header: "Mẫu số", css: "text_toupper", width: 180, editor: "text", editable: true },
                                    { id: "khieu", name: "khieu", header: "Ký hiệu", css: "text_toupper", width: 100, editor: "text", editable: true },
                                    { id: "shdon", name: "shdon", header: "Số hóa đơn", width: 100, editor: "text", editable: true },
                                    {
                                        id: "ngay", name: "ngay", header: "Ngày lập hóa đơn", editable: true, width: 150,
                                        editor: "date",
                                        format: function (text) {
                                            var format = webix.Date.dateToStr("%d/%m/%Y");
                                            text = removeTimeZoneT(text);
                                            return format(text);
                                        }
                                    },
                                    {
                                        id: "ladhddt",
                                        name: "ladhddt",
                                        header: "Loại áp dụng hóa đơn điện tử",
                                        editable: false,
                                        width: 250,
                                        editor: "richselect",
                                        options: [
                                            { id: "1", value: "Hóa đơn điện tử NĐ 123, NĐ 70/2025" },
                                            { id: "2", value: "HĐĐT xác thực theo QĐ 1209" },
                                            { id: "3", value: "Hóa đơn theo NĐ 51/2010" },
                                            { id: "4", value: "Hóa đơn đặt in theo NĐ 123/2020" }
                                        ]
                                    },
                                    { id: "ldo", name: "ldo", header: "Lý do", editable: true, editor: "text", width: 200 },
                                    {
                                        id: "macqt", name: "macqt", header: "Mã CQT", editor: "text", width: 150, fillspace: true
                                    },
                                ],
                                rules: functionExtension.Validate04SS(),
                                ready: function () {
                                    this.validate();
                                },
                                scheme: {
                                    $init: function (obj) {
                                        if (obj.ngay != undefined && obj.ngay != null)
                                            obj.ngay = removeTimeZoneT(obj.ngay);
                                    }
                                }
                            }
                        ]
                    },
                    {
                        margin: 10,
                        cols: button
                    }
                ]
            }
        };
        return {
            $ui: ui,
            setEditMode: function (mode) {
                editmode = mode;
                if (editmode == 1) {
                    var result = webix.ajax().sync().get(app.config.host + "/System/GetCurrentDmdvcs");
                    var response = JSON.parse(result.response);
                    const mst_cccd=response[0].use_cccd === true ? response[0].cccd_ndd : response[0].ms_thue
                    $$("tnnt").setValue(response[0].ten_dvcs);
                    $$("mst").setValue(mst_cccd);
                    $$("tcqt").setValue(response[0].ten);
                    $$("ddanh").setValue(response[0].tinh_thanh);
                }
            },
            setValues: function (item) {
                var form = $$(formId);
                if (item != null) {
                    item["ntbao"] = removeTimeZoneT(item["ntbao"]);
                    item["ntbccqt"] = removeTimeZoneT(item["ntbccqt"]);
                    form.setValues(item);
                }
                var tableDetail = webix.$$(tblId);
                var url = app.config.host + "/CancelInvoice/GetDataDetail?id=" + item.id;
                tableDetail.clearAll();
                tableDetail.load(url);
            }
        };
    });
define('views/forms/forms68/Mau04/68_mau04Search',["app", "models/user"], function (app, user) {
    var editmode = 0;

    var button = [
        {},
        {
            shortcut: "F10", view: "button", id: "btnMau04Search", badge: "F10", css: "webix_primary",
            label: "Tìm kiếm", type: "icon", align: "center", width: 120,

            // shortcut: "F10",
            // view: "button",
            // label: "Tìm kiếm (F10)",
            // id: "btnMau04Search",
            // type: "form",
            // align: "center",
            // width: 120,
            on: {
                onClick: function () {
                    var item = $$("mau04search-form").getValues();
                    var tableHoadon = $$("mau04search-form");
                    if (tableHoadon.validate()) {
                        var kyhieu = $$("khieu").getText();
                        webix.extend(tableHoadon, webix.ProgressBar);
                        tableHoadon.disable();
                        tableHoadon.showProgress();
                        webix.ajax()
                            .headers({ 'Content-type': 'application/json' })
                            .get(app.config.host + "/CancelInvoice/FilterCancelInvoice?khieu=" + kyhieu + "&shdon=" + item.shdon, {
                                error: function (text, data, XmlHttpRequest) {
                                    tableHoadon.enable();
                                    tableHoadon.hideProgress();
                                    webix.message(text, "error");

                                }, success: function (text, data, XmlHttpRequest) {
                                    var response = JSON.parse(text);
                                    tableHoadon.enable();
                                    tableHoadon.hideProgress();
                                    $$("mau04_68").clearAll();
                                    $$("mau04_68").parse(response.data);
                                    webix.$$("mau04search-win").close();
                                }
                            });
                    }
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {
            view: "button", hotkey: "esc", label: "Hủy bỏ", badge: "ESC", css: "webix_danger",
            align: "center", type: "icon", width: 120,

            // view: "button",
            // hotkey: "esc",
            // label: "Hủy bỏ (ESC)",
            // type: "danger",
            // align: "center",
            // width: 120,
            click: function () {
                webix.$$("mau04search-win").close();
            }
        },
        {}
    ]
    var ui = {
        view: "window",
        modal: true,
        move: true,
        id: "mau04search-win",
        position: "center",
        head: "Tìm kiếm 04SS-HDDT",
        // head: {
        //     height: 35,
        //     cols: [
        //         {
        //             id: "head-icondksd", view: "template", css: "headform", width: 35,
        //             template: "<span><i class='fa fa-search' aria-hidden='true'></i></span>"
        //         },
        //         {
        //             id: "head-formdksd", view: "template", css: "headform", template: function (obj) {
        //                 return '<div><div/>';
        //             }
        //         },
        //         {
        //             view: "icon", icon: "fas fa-question-circle", id: "help_dksdForms", tooltip: "HELPER", click: function () { }
        //         }
        //     ]
        // },
        body: {
            // paddingY: 10,
            // paddingX: 10,
            view: "form",
            width: 400,
            // height: 580,
            id: "mau04search-form",
            complexData: true,
            elementsConfig: { labelWidth: 100 },
            margin: 0,
            elements: [
                {
                    view: "combo", label: "Ký hiệu", id: "khieu", name: "khieu", required: true,
                    options: {
                        body: {
                            url: app.config.host + "/Invoice68/GetAllSerial",
                            ready: function () {
                                var count = this.count();
                                if (count > 0) {
                                    var combo = webix.$$("khieu");
                                    combo.setValue(this.getFirstId());
                                }
                            }
                        }
                    },
                    invalidMessage: "Ký hiệu không được để trống !"
                },
                {
                    view: "text", label: "Số hóa đơn", id: "shdon", name: "shdon", required: true,
                    invalidMessage: "Số hóa đơn không được để trống !"
                },
                { height: 3 },
                {
                    margin: 10,
                    cols: button
                }
            ]
        }
    };

    return {
        $ui: ui,
        setEditMode: function (mode) {

        },
        setValues: function (item) {

        }
    };
});
define('views/forms/forms68/Mau04/sendEmail',["app", "views/forms/forms68/68_viewsLogEmail", "views/modules/Component/constantManager"], function (app, viewLogEmail, CONSTANTS) {
    var item;
    var modalId = "sendEmailModal";
    var formId = "sendEmailForm";
    var eventChanged = "dataChangedMau0405";
    return {
        $ui: {
            view: "window", move: true, resize: true,
            position: "center",
            // position: function (state) {
            //     state.width = state.maxWidth * 0.4;
            //     state.height = state.maxHeight * 0.25;
            //     state.left = (state.maxWidth - state.width) / 2;
            //     state.top = (state.maxHeight - state.height) / 2;
            // },
            modal: true,
            // head: false,
            head: "Gửi email",
            minWidth: 500,
            minHeight: 530,
            id: modalId,
            on: {
                onShow: function () {
                }
            },
            body: {
                paddingY: 0,
                paddingX: 10,
                view: "form",
                id: formId,
                complexData: true,
                keepViews: true,
                multiview: { keepViews: true },
                elementsConfig: { labelWidth: 150 },
                margin: 0,
                elements: [
                    {
                        // type: "space",
                        borderless: false,
                        rows: [
                            {
                                borderless: true,
                                id: "temp_voucher",
                                onClick: {
                                    "showlog04ss": function (ev, id) {
                                        var table = webix.$$("mau04_68");
                                        var item = table.getSelectedItem();
                                        item.apiHost = CONSTANTS.API.MAU04.SEND_EMAIL_LOG;
                                        item.typeView = "04SS";
                                        var detailForm = $$(modalId).$scope.ui(viewLogEmail.$ui);
                                        viewLogEmail.setValues(item);
                                        detailForm.show();
                                    }
                                },
                                template: function (obj) {
                                    return `<div class="card">
                                    <div class="card-body">
                                        <div class="d-flex align-items-center mb-4">
                                            <div class="flex-grow-1">
                                                <h5 class="font-size-14 mb-0">[${obj.mst}] Thông báo 04/SS-HDDT hóa đơn</h5>
                                                <small class="text-muted">support@minvoice.pro</small>
                                            </div>
                                        </div>
                                        <p style="text-align:left"><strong>K&iacute;nh gửi qu&yacute; kh&aacute;ch h&agrave;ng</strong></p>
                                        <p style="text-align:left">V&agrave;o ng&agrave;y ${formatDate(obj.ntbao)}, ${obj.tnnt} đ&atilde; gửi Th&ocirc;ng b&aacute;o 04/SS-HĐĐT cho Anh/Chị.</p>
                                        <p style="text-align:left">Th&ocirc;ng tin về th&ocirc;ng b&aacute;o h&oacute;a đơn điện tử c&oacute; sai s&oacute;t được đ&iacute;nh k&egrave;m dưới đ&acirc;y.</p>
                                        <p style="text-align:left">Mọi vướng mắc v&agrave; th&ocirc;ng tin li&ecirc;n quan đến h&oacute;a đơn được th&ocirc;ng b&aacute;o sai s&oacute;t vui l&ograve;ng li&ecirc;n hệ ${obj.tnnt}</p>
                                        <p style="text-align:left"><span style="color:#e74c3c">Ch&uacute; &yacute;:</span> Đ&acirc;y l&agrave; mail tự động từ hệ thống H&oacute;a đơn điện tử M-invoice. Qu&yacute; kh&aacute;ch vui l&ograve;ng kh&ocirc;ng trả lời mail n&agrave;y.</p>
                                        <p style="text-align:left"><strong>Tr&acirc;n trọng ./.</strong></p>
                                        <hr class ="mb-4">
                                        <a href="javascript: void(0);" class="showlog04ss"><p class="text-primary">Thông báo 04/SS-HDDT đã được gửi đi ${obj.number_send_email == null ? 0 : obj.number_send_email} lần. <span class="mdi mdi-hand-extended-outline"></span> Lịch sử gửi email</p></a>
                                    </div>
                                </div>`;
                                }
                            },
                            { height: 10 },
                            {
                                view: "text", id: "email_nnt", name: "email_nnt", labelPosition: "top", placeholder: "Mỗi email cách nhau bởi dấu ;",
                                label: "Email", required: true,
                                invalidMessage: "Email không được để trống !"
                            },
                            { height: 10 },
                            {
                                margin: 10,
                                cols: [
                                    {},
                                    {
                                        shortcut: "F10", view: "button", id: "btnSend", label: "Gửi email", type: "form", align: "center", width: 120,
                                        on: {
                                            onClick: function () {
                                                var dataPost = {
                                                    id: item.id,
                                                    sendTo: $$("email_nnt").getValue()
                                                };
                                                var table = $$(modalId);
                                                if ($$(formId).validate()) {
                                                    webix.extend(table, webix.ProgressBar);
                                                    table.disable();
                                                    table.showProgress();
                                                    webix.ajax()
                                                        .headers({ 'Content-type': 'application/json' })
                                                        .post(app.config.host + CONSTANTS.API.MAU04.SEND_EMAIL, dataPost,
                                                            {
                                                                error: function (text, data, XmlHttpRequest) {
                                                                    table.enable();
                                                                    table.hideProgress();
                                                                    webix.message(XmlHttpRequest.statusText, "error");
                                                                },
                                                                success: function (text, data, XmlHttpRequest) {
                                                                    table.enable();
                                                                    table.hideProgress();
                                                                    var response = JSON.parse(text);
                                                                    if (response.code == "00") {
                                                                        $$(modalId).close();
                                                                        app.callEvent(eventChanged, [1, null]);
                                                                        webix.message(response.message, "success");
                                                                    }
                                                                    else {
                                                                        webix.message(response.message, "error");
                                                                    }
                                                                }
                                                            });
                                                }
                                            }
                                        },
                                        click: function () { this.callEvent("onClick"); }
                                    },
                                    {
                                        view: "button", hotkey: "esc", label: "Đóng", width: 120, type: "danger", align: "center",
                                        click: function () { webix.$$(modalId).close(); }
                                    },
                                    {}
                                ]
                            },
                            { height: 10 }
                        ]
                    }

                ]
            },
            on: {
                onShow: function () {
                    var self = this;
                    $(".webix_modal").one("click", function () { self.hide(); });
                }
            }
        },
        InitUI: function (data) {
            item = data;
            webix.$$(modalId).getHead().setHTML("Gửi email thông báo 04/SS-HDDT");
            $$(formId).setValues(data);
            $$("temp_voucher").setValues(data);
        }
    };
});
define('views/68_mau0405',[
    "app",
    "locale",
    "models/user",
    "views/forms/forms70/Mau04/70_mau04Form",
    "views/forms/forms68/68_viewLogForm",
    "views/modules/Component/modalPlugin",
    "views/forms/forms68/Mau04/68_mau04Search",
    "views/modules/Component/functionExtension",
    "views/forms/forms68/Mau04/sendEmail",
    "views/forms/forms68/68_viewsLogEmail",
    "views/modules/Component/constantManager"
], function (
    app,
    _,
    user,
    mau04Form, viewLogForm, modalPlugin, mau04Search, functionExtension, sendEmail, viewLogEmail, CONSTANTS
) {
    "use strict";
    var eventChanged = "dataChangedMau0405";
    var tableId = "mau04_68";
    var initUI = function () {
        var table = webix.$$(tableId);
        var url = {
            $proxy: true,
            load: function (view, callback, params) {
                var url = app.config.host + "/Pattern/GetData";
                if (params == null) {
                    url = url + "?command=CM0010&start=0&count=" + view.config.datafetch + "&continue=null&filter=null";
                }
                else {
                    url = url + "?command=CM0010&start=" + params.start + "&count=" + params.count + "&continue=" + params.continue;
                    if (params.filter != null) {
                        var array = [];
                        for (var property in params.filter) {
                            var column = view.getColumnConfig(property);
                            var item = {
                                columnName: property,
                                columnType: column.columnType,
                                value: params.filter[property]
                            };
                            array.push(item);
                        }
                        url = url + "&filter=" + JSON.stringify(array);
                    }
                }
                webix.ajax(url, callback, view);
            }
        };
        table.define("url", url);
    };
    webix.ui({
        view: "contextmenu",
        id: "cmenu04SS",
        autowidth: true,
        data: [
            { id: "cmenuAdd", value: "Thêm (F4)", icon: "mdi mdi-plus-box-outline" },
            { id: "cmenuEdit", value: "Sửa (F3)", icon: "mdi mdi-pencil-box-outline" },
            { id: "cmenuDelete", value: "Xóa (F8)", icon: "mdi mdi-trash-can-outline" },
            { $template: "Separator" },
            { id: "cmenuEmail", value: "Lịch sử gửi email", icon: "mdi mdi-email-outline" }
        ],
        on: {
            onItemClick: function (id) {
                if (this.getItem(id).id == "cmenuAdd") {
                    $$("btnPlus").callEvent("onClick");
                }
                if (this.getItem(id).id == "cmenuEdit") {
                    $$("btnEdit").callEvent("onClick");
                }
                if (this.getItem(id).id == "cmenuDelete") {
                    $$("btnDelete").callEvent("onClick");
                }
                if (this.getItem(id).id == "cmenuEmail") {
                    var table = webix.$$(tableId);
                    var item = table.getSelectedItem();
                    if (item == null || item == undefined) {
                        webix.message("Bạn chưa chọn thông báo hủy 04/SS-HDDT", "debug");
                        return;
                    }
                    item.apiHost = CONSTANTS.API.MAU04.SEND_EMAIL_LOG;
                    item.typeView = "04SS";
                    var detailForm = $$("frmView").$scope.ui(viewLogEmail.$ui);
                    viewLogEmail.setValues(item);
                    detailForm.show();
                }
            }
        }
    });
    var controls =
        [
            {
                view: "button", type: "htmlbutton", width: 100,
                label: '<i class="fa fa-refresh fa-lg" aria-hidden="true"></i><span class="text">' + _("REFRESH") + '</span>',
                id: "btnReload",
                on: {
                    onClick: function () {
                        var table = webix.$$(tableId);
                        table.clearAll();
                        table.load(table.config.url);
                    },
                },
                click: function () {
                    this.callEvent("onClick");
                },
            },
            {
                view: "button", type: "htmlbutton", width: 100,
                label: '<i class="fa fa-plus fa-lg" aria-hidden="true"></i><span class="text">' + _("THEM") + ' (F4)</span>',
                id: "btnPlus",
                shortcut: "F4",
                on: {
                    onClick: function () {
                        var detailForm = this.$scope.ui(mau04Form.$ui);
                        mau04Form.setEditMode(1);
                        detailForm.show();
                    },
                },
                click: function () {
                    this.callEvent("onClick");
                },
            },
            {
                view: "button", type: "htmlbutton", width: 100,
                label: '<i class="fa fa-edit fa-lg" aria-hidden="true"></i><span class="text">' + _("SUA") + ' (F3)</span>',
                id: "btnEdit",
                shortcut: "F3",
                on: {
                    onClick: function () {
                        var table = webix.$$(tableId);
                        var selectedItem = table.getSelectedItem();
                        if (selectedItem == null) {
                            webix.message("Bạn chưa chọn hóa đơn ! ", "error");
                            return;
                        }
                        if (selectedItem.trang_thai == 3 || selectedItem.trang_thai == 4) {
                            webix.message("Thông báo hủy đã ký bạn không thể sửa! ", "error");
                            return;
                        }

                        if (selectedItem.loai_tbao == "5") {
                            webix.message("Mẫu 05 nhận từ CQT bạn không thể sửa! ", "error");
                            return;
                        }

                        var detailForm = this.$scope.ui(mau04Form.$ui);
                        mau04Form.setEditMode(2);
                        mau04Form.setValues(selectedItem);
                        detailForm.show();;

                    },
                },
                click: function () {
                    this.callEvent("onClick");
                },
            },
            {
                view: "button", type: "htmlbutton", width: 100,
                label: '<i class="fa fa-trash-o fa-lg" aria-hidden="true"></i> ' +
                    '<span class="text">' + _("XOA") + ' (F8)</span>',
                id: "btnDelete",
                shortcut: "F8",
                on: {
                    onClick: function () {
                        var table = webix.$$(tableId);
                        var selectedItem = table.getSelectedItem();
                        if (selectedItem == null) {
                            webix.message("Bạn chưa chọn khách hàng ! ", "error");
                            return;
                        }
                        if (selectedItem.trang_thai == 3 || selectedItem.trang_thai == 4) {
                            webix.message("Thông báo hủy đã ký bạn không thể xóa! ", "error");
                            return;
                        }
                        if (selectedItem.loai_tbao == "5") {
                            webix.message("Mẫu 05 nhận từ CQT bạn không thể xóa! ", "error");
                            return;
                        }
                        var dataPost = {
                            tab_masters: "mau04",
                            editmode: 3,
                            data: [
                                selectedItem
                            ]
                        };

                        webix.confirm({
                            title: "M-INVOICE",
                            text: "Bạn có muốn xóa thông báo hủy 04/SS-HDDT",
                            ok: "Có",
                            cancel: "Không",
                            callback: function (choose) {
                                if (choose) {
                                    webix.extend(table, webix.ProgressBar);
                                    table.disable();
                                    table.showProgress();

                                    webix.ajax()
                                        .headers({ 'Content-type': 'application/json' })
                                        .get(app.config.host + "/CancelInvoice/Mau04Delete?id=" + selectedItem.mau04_id,
                                            {
                                                error: function (text, data, XmlHttpRequest) {
                                                    table.enable();
                                                    table.hideProgress();
                                                },
                                                success: function (text, data, XmlHttpRequest) {
                                                    var js = JSON.parse(text);
                                                    if (js.code == "00") {
                                                        table.remove(selectedItem.id);
                                                    } else {
                                                        webix.message(js.message, "error");
                                                    }

                                                    table.enable();
                                                    table.hideProgress();
                                                }
                                            });
                                }
                            }
                        });
                    }
                },
                click: function () {
                    this.callEvent("onClick");
                }
            },
            {
                view: "button", type: "htmlbutton", width: 100,
                label: '<i class="fa fa-search fa-lg aria-hidden="true"></i> <span class="text">' + _("Tìm kiếm") + '</span>',
                id: "btnSearchMau04",
                click: function () {
                    var Form = this.$scope.ui(mau04Search.$ui);
                    Form.show();;
                }
            },
            {
                view: "button", type: "htmlbutton", width: 100,
                label: '<i class="fa fa-print fa-lg" aria-hidden="true"></i> <span class="text">' + _("PRINT") + '</span>',
                id: "btnPreview",
                on: {
                    onClick: function () {
                        var table = webix.$$(tableId);
                        var selectedItem = table.getSelectedItem();
                        if (selectedItem == null) {
                            webix.message("Bạn chưa dòng in ! ", "error");
                            return;
                        }
                        var box = webix.modalbox({
                            title: "Đang in hóa đơn ....",
                            text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                            width: 350,
                            height: 200
                        });

                        var newWin = window.open();
                        var html = '<html><head><title>Hóa đơn điện tử M-Invoice</title>'
                            + '<link rel="stylesheet" href="assets/fontawesome_pro/css/all.css" type="text/css" charset="utf-8">'
                            + '<link rel="stylesheet" href="assets/fontawesome.css" type="text/css" charset="utf-8">'
                            + '</head><body><center>Đang tải dữ liệu ... <br><p><i style="font-size:200%;" class="fa fa-spin fa-spinner"></i></p></center></body></html>';
                        newWin.document.write(html);

                        webix.ajax()
                            .response("arraybuffer")
                            .headers({ 'Content-type': 'application/json' })
                            .get(app.config.host + "/CancelInvoice/PrintMau04?id=" + selectedItem.id + "&type=PDF&loai=" + selectedItem.loai_tbao,
                                {
                                    error: function (text, data, XmlHttpRequest) {
                                        webix.modalbox.hide(box);
                                    },
                                    success: function (text, data, XmlHttpRequest) {
                                        var file = new Blob([data], { type: 'application/pdf' });
                                        var fileURL = URL.createObjectURL(file);
                                        //window.open(fileURL, '_blank');
                                        webix.modalbox.hide(box);
                                        newWin.location = fileURL;
                                    }
                                });
                    },
                },
                click: function () {
                    this.callEvent("onClick");
                },
            },
            {
                view: "button", type: "htmlbutton", width: 180,
                label: '<i class="fa fa-sign-in fa-lg aria-hidden="true"></i> <span class="text">' + _("Ký và gửi 04/SS-HĐĐ") + '</span>',
                id: "btnSign",
                on: {
                    onClick: function () {
                        var tableDK = webix.$$(tableId);
                        var selectedItem = tableDK.getSelectedItem();
                        if (selectedItem == null) {
                            webix.message("Bạn chưa chọn dòng ! ", "error");
                            return;
                        }
                        if (selectedItem.trang_thai == 3 || selectedItem.trang_thai == 4) {
                            webix.message("Thông báo hủy đã ký ! ", "error");
                            return;
                        }
                        functionExtension.Sign04SS(selectedItem, $$("frmView"));
                    }
                },
                click: function () {
                    this.callEvent("onClick");
                },
            },
            {
                view: "button", type: "htmlbutton", width: 100,
                label: '<i class="fa fa-paper-plane fa-lg aria-hidden="true"></i> <span class="text">' + _("Gửi CQT") + '</span>',
                id: "btnKyGuiCQT",
                click: function () {
                    var tableDK = webix.$$(tableId);
                    var selectedItem = tableDK.getSelectedItem();
                    if (selectedItem == null) {
                        webix.message("Bạn chưa chọn dòng ! ", "error");
                        return;
                    }
                    if (selectedItem.trang_thai == 1 || selectedItem.trang_thai == 2) {
                        webix.message("Thông báo chưa được ký ! ", "error");
                        return;
                    }
                    if (selectedItem.trang_thai == 4) {
                        webix.message("Thông báo 04/SS-HDDT đã được gửi, thao tác không thành công. ", "debug");
                        return;
                    }
                    webix.confirm({
                        title: "GỬI HÓA ĐƠN",
                        text: "Bạn có muốn gửi thông báo hủy", ok: "Có", cancel: "Không",
                        callback: function (res) {
                            if (res) {
                                webix.extend(tableDK, webix.ProgressBar);
                                tableDK.disable();
                                tableDK.showProgress();
                                webix.ajax()
                                    .headers({ 'Content-Type': 'application/json' })
                                    .get(app.config.host + "/CancelInvoice/SendToTVAN?id=" + selectedItem.mau04_id, function (text) {
                                        var result = JSON.parse(text);
                                        tableDK.enable();
                                        tableDK.hideProgress();
                                        if (result.code != "00") {
                                            webix.message({ type: 'error', text: result.message });
                                            return;
                                        }
                                        else {
                                            var table = webix.$$(tableId);
                                            table.clearAll();
                                            table.load(table.config.url);
                                        }
                                    });
                            }
                        }
                    });
                }
            },
            {

                view: "button",
                type: "htmlbutton",
                width: 100,
                label: '<i class="fa fa-envelope fa-lg" aria-hidden="true"></i><span class="text"> ' + _("SEND_EMAIL") + "</span>",
                id: "btnEmail04SS",
                on: {
                    onClick: function () {
                        webix.callEvent("onLoadError");
                        var table = webix.$$(tableId);
                        var item = table.getSelectedItem();
                        if (item == null || item == undefined) {
                            webix.message("Bạn chưa chọn thông báo 04/SS-HDDT cần gửi email", "error");
                            return;
                        }
                        var FormDialog = this.$scope.ui(sendEmail.$ui);
                        sendEmail.InitUI(item);
                        FormDialog.show();
                    },
                },
                click: function () {
                    this.callEvent("onClick");
                }
            },
            {},
            {
                view: "button", type: "icon", width: 30, icon: "mdi mdi-settings", click: function () {
                    var menu = $$(tableId).config.headermenu;
                    $$(menu).show(this.$view);
                }
            }
        ];

    var table = {
        margin: 0,
        rows: [
            {
                id: tableId,
                view: "datatable",
                select: true,
                resizeColumn: true,
                footer: false,
                editable: false,
                tooltip: true,
                headermenu: {
                    //width: 200,
                    autoheight: false,
                    scroll: true,
                    autowidth: true
                },
                subview: {
                    view: "tabview",
                    height: 200,
                    scroll: true,
                    cells: [{
                        header: "Chi tiết hóa đơn",
                        body: {
                            view: "datatable",
                            height: 400,
                            resizeColumn: true,
                            scroll: true,
                            id: "mau04_68_chitiet",
                            headerRowHeight: 50,
                            on: {
                                "data->onStoreUpdated": function () {
                                    this.data.each(function (obj, i) {
                                        obj.index = i + 1;
                                    });
                                },
                            },
                            columns: [
                                { view: "text", id: "mau04_id", name: "mau04_id", hidden: true },
                                { view: "text", id: "mau04_chitiet_id", name: "mau04_chitiet_id", hidden: true },
                                { view: "text", header: "STT", id: "index", name: "index", width: 80 },
                                {
                                    header: "Mẫu số",
                                    width: 120,
                                    template: function (obj) {
                                        return obj.khieu != null ? obj.khieu.toString().substring(0, 1) : "";
                                    }
                                },
                                { id: "khieu", name: "khieu", header: "Ký hiệu hóa đơn điện tử", width: 150 },
                                { id: "shdon", name: "shdon", header: "Số hóa đơn điện tử", width: 120 },
                                {
                                    id: "ngay", name: "ngay", header: "Ngày lập hóa đơn", width: 120,
                                    format: function (text) {
                                        var format = webix.Date.dateToStr("%d/%m/%Y");
                                        text = removeTimeZoneT(text);
                                        return format(text);
                                    }
                                },
                                { id: "ladhddt", name: "ladhddt", header: "Loại áp dụng hóa đơn điện tử", width: 150 },
                                { id: "tctbao", name: "tctbao", header: "Hủy/giải trình", width: 150 },
                                { id: "ldo", name: "ldo", header: "Lý do", width: 250 },
                            ],
                            scrollX: false,
                            autoheight: true,
                        },
                    },],
                },
                scheme: {
                    $init: function () {
                    },
                },
                onClick: {
                    "Dowload0405": function (event, cell, target) {
                        var win = webix.$$(tableId);
                        var record = win.getItem(cell.row);

                        if (record.loai_tbao != "5") {
                            if (record.trang_thai != 3 && record.trang_thai != 4) {
                                webix.message("Mẫu chưa được ký không thể tải !", "error");
                                return;
                            }
                        }
                        webix.extend(win, webix.ProgressBar);
                        win.disable();
                        win.showProgress();
                        var filename = record.loai_tbao == "5" ? "Mau05.xml" : "Mau04.xml";
                        var url = app.config.host + "/CancelInvoice/DowloadXml?id=" + cell.row;
                        webix.ajax().response("arraybuffer")
                            .get(url, function (text, data) {
                                win.enable();
                                win.hideProgress();
                                var file = new Blob([data], { type: "application/xml" });
                                webix.html.download(file, filename);

                            });
                        return false;
                    },
                    "btnViewLichsu": function (event, cell, target) {
                        var table = webix.$$(tableId);
                        var item = table.getItem(cell.row);
                        var detailForm = this.$scope.ui(viewLogForm.$ui);
                        viewLogForm.initUI("mau04", item.matdiep, item);
                        detailForm.show();
                    }
                },
                type: {
                    rcheckbox: function (obj, common, value, config) {
                        var checked = (value == config.checkValue) ? 'checked="true"' : '';
                        return "<input disabled class='webix_table_checkbox' type='checkbox' " + checked + ">";
                    },
                },
                on: {
                    onSubViewCreate: function (view, item) {
                        var subView = view;
                        if (subView != null) {
                            var tableDetail = webix.$$("mau04_68_chitiet");
                            var url = app.config.host + "/CancelInvoice/GetDataDetail?id=" + item.id;
                            tableDetail.clearAll();
                            tableDetail.load(url);
                        }
                    },
                    "data->onStoreUpdated": function () {
                        this.data.each(function (obj, i) {
                            obj.stt = i + 1;
                        });
                    },
                    onItemDblClick: function (id, e, node) {
                        var btnEdit = $$("btnEdit");
                        btnEdit.callEvent("onClick");
                    },
                    onAfterLoad: function () {
                        $$("cmenu04SS").attachTo($$(tableId));
                    },
                },
                columns: [
                    { id: "mau04_id", header: "mau04_id", hidden: true },
                    { template: "{common.subrow()}", width: 50, },
                    { id: "stt", header: "STT", sort: "int", width: 40 },
                    {
                        id: "loai_tbao", header: ["Loại thông báo", { content: "serverSelectFilter" }], width: 350,
                        options: [
                            { id: "1", value: "Thông báo của Người nộp thuế" },
                            { id: "2", value: "Thông báo của Người nộp thuế theo thông báo của CQT" }
                        ],
                    },
                    {
                        id: "gia_tri", header: ["<center>Trạng thái</center>", { content: "multiSelectFilter", options: CONSTANTS.STATUS_SEND_INVOICE }],
                        template: function (obj) {
                            var color = CONSTANTS.COLOR.DA_GUI;
                            var valueCheck = obj.ma;
                            switch (valueCheck) {
                                case "3":
                                    color = CONSTANTS.COLOR.DA_KY;
                                    break;
                                case "2":
                                    color = CONSTANTS.COLOR.CHO_KY;
                                    break;
                                case "1":
                                    color = CONSTANTS.COLOR.CHO_DUYET;
                                    break;
                            };
                            return `<span style='color:${color};font-weight: bold;'>${obj.gia_tri}</span>`;
                        },
                        width: 130
                    },
                    { id: "shdon", header: ["Số hóa đơn", { content: "textFilter" }], width: 150 },
                    {
                        id: "ntbao",
                        header: ["Ngày lập", { content: "serverDateRangeFilter" }],
                        width: 150,
                        columnType: "datetime",
                        format: function (text) { return formatDate(text); }
                    },
                    {
                        id: "ngay_gui",
                        header: ["Ngày gửi", { content: "serverDateRangeFilter" }],
                        width: 120,
                        columnType: "datetime",
                        format: function (text) { return formatDate(text); }
                    },
                    { id: "nguoi_gui", header: ["Người gửi", { content: "serverFilter" }], width: 120 },
                    {
                        id: "tt_cqt", header: ["Trạng thái CQT"], width: 150, css: { "text-align": "center" }, template: function (obj) {
                            var response = "";
                            if (obj.trang_thai == 4) {
                                switch (obj.is_success) {
                                    case "":
                                        break;
                                    case null:
                                        break;
                                    case true:
                                        response = `<span style='color: ${CONSTANTS.COLOR.CHAP_NHAN};font-weight: bold;'>Chấp nhận</span>`;
                                        break;
                                    case false:
                                        response = `<span style='color: ${CONSTANTS.COLOR.KHONG_CHAP_NHAN};font-weight: bold;'>Không chấp nhận</span>`;
                                        break;
                                };
                            }
                            return response;
                        }
                    },
                    {
                        id: "is_send_email", header: ["Email", { content: "filterCheckBox" }], width: 60,
                        columnType: "bit", css: { "text-align": "center" }, template: "{common.rcheckbox()}"
                    },
                    {
                        id: "Dowload0405",
                        header: "Tải xml",
                        width: 80,
                        css: { "text-align": "center" },
                        template: function (obj) {
                            if (obj.loai_tbao == "5") {
                                return "<span class='Dowload0405' style='color: #00b300'><i class='mdi mdi-24px mdi-download'></i></span> ";
                            }
                            else {
                                if (obj.trang_thai == 3 || obj.trang_thai == 4) {
                                    return "<span class='Dowload0405' style='color: #00b300;'><i class='mdi mdi-18px mdi-download-box'></i></span> ";
                                } else
                                    return "<span class='Dowload0405' style='color: #c8c8cc'><i class='mdi mdi-18px mdi-download'></i></span>";
                            }
                        }
                    },
                    {
                        id: "btnViewLichsu",
                        header: ["Xem thông báo"],
                        css: { "text-align": "center", "color": "blue", "text-decoration": "underline" },
                        template: function (obj) {
                            return "<span class='btnViewLichsu'>Thông báo<span>";
                        },
                        width: 120
                    }
                ],
                pager: "pagerA"
            },
            {
                id: "pagerA",
                view: "pager",
                template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}",
                container: "paging_here",
                size: 50,
                group: 5,
            },
        ],
    };

    var layout = {
        css: "frmView",
        id: "frmView",
        rows: [
            {
                height: 39,
                css: "btnControl",
                margin: 0,
                borderless: true,
                type: "toolbar",
                cols: controls,
            },
            {
                rows: [table],
            },
        ],
    };

    return {
        $ui: layout,
        $oninit: function (view, $scope) {
            var table = webix.$$(tableId);
            $scope.on(app, eventChanged, function (mode, item) {
                table.clearAll();
                table.load(table.config.url);
            });
            $scope.on(app, "filterTable", function (report_id, infoWindowId, item) {
                var infoparam = {
                    infowindow_id: infoWindowId,
                    parameter: item,
                };
                table.config.infoparam = infoparam;
                table.clearAll();
                table.load(table.config.url);
            });
        },
        $onurlchange: function (ui, name, url, scope) {
            initUI();
        },
    }
});
define('views/68_mau05',[
    "app",
    "locale",
    "models/user",
    "views/forms/forms70/Mau04/70_mau04Form"
], function (
    app,
    _,
    user,
    mau04Form
) {
        "use strict";

        webix.$$("title").parse({
            title: "Hóa đơn NDD123 -> Danh sách hóa đơn cần rà soát",
            details: "Hóa đơn NDD123 -> Danh sách hóa đơn cần rà soát",
        });

        var initUI = function () {
            //var windowno = app.path[1].params[0];
            var table = webix.$$("mau05_68");
            // table.disable();
            // table.showProgress();
            // table.clearAll();
            var url = {
                $proxy: true,
                load: function (view, callback, params) {
                    var url = app.config.host + "/Pattern/GetData";

                    if (params == null) {
                        url = url + "?command=CM0010&start=0&count=" + view.config.datafetch + "&continue=null&filter=null";
                    }
                    else {
                        url = url + "?command=CM0010&start=" + params.start + "&count=" + params.count + "&continue=" + params.continue;

                        if (params.filter != null) {
                            var array = [];

                            for (var property in params.filter) {

                                var column = view.getColumnConfig(property);

                                var item = {
                                    columnName: property,
                                    columnType: column.columnType,
                                    value: params.filter[property]
                                };

                                array.push(item);
                            }

                            //console.log(JSON.stringify(array));
                            url = url + "&filter=" + JSON.stringify(array);
                        }
                    }
                    webix.ajax(url, callback, view);
                },
            };
            table.define("url", url);
        };

        var controls =
            [
                {
                    view: "button", type: "htmlbutton", width: 100,
                    label: '<i class="fa fa-refresh fa-lg" aria-hidden="true"></i> ' +
                    '<span class="text">' + _("REFRESH") + '</span>',
                    id: "btnReload",

                    // view: "button",
                    // id: "btnRefresh",
                    // type: "icon",
                    // icon: "refresh",
                    // label: _("REFRESH"),
                    // width: 100,
                    on: {
                        onClick: function () {
                            var table = webix.$$("mau05_68");
                            table.clearAll();
                            table.load(table.config.url);
                        }
                    },
                    click: function () {
                        this.callEvent("onClick");
                    },
                },
                {
                    view: "button", type: "htmlbutton", width: 120,
                    label: '<i class="fa fa-paper-plane fa-lg aria-hidden="true"></i> ' +
                    '<span class="text">' + _("Phản hồi") + '</span>',
                    id: "btnKyGuiCQT",
                    click: function () {
                        var tableDK = webix.$$("mau05_68");
                        var selectedItem = tableDK.getSelectedItem();
                        if (selectedItem == null) {
                            webix.message("Bạn chưa chọn dòng ! ", "error");
                            return;
                        }

                        // webix.confirm({
                        //     title: "GỬI HÓA ĐƠN",
                        //     text: "Bạn có muốn gửi thông báo hủy: <span style='color: red'>" + selectedItem.trang_thai + "</span>", ok: "Có", cancel: "Không",
                        //     callback: function (res) {
                        //         if (res) {

                        //         }
                        //     }
                        // });
                    }
                },
                {
                    view: "button", type: "htmlbutton", width: 100,
                    label: '<i class="fa fa-search fa-lg" aria-hidden="true"></i> ' +
                    '<span class="text">' + _("Tìm kiếm") + '</span>',
                    id: "btnPlus",
                    // view: "button",
                    // id: "btnPlus",
                    // type: "icon",
                    // icon: "plus",
                    // label: _("THEM") + " (F4)",
                    // width: 100,
                    shortcut: "F4",
                    on: {
                        onClick: function () {
                            // var detailForm = this.$scope.ui(mau04Form.$ui);
                            // mau04Form.setEditMode(1);
                            // detailForm.show();
                        }
                    },
                    click: function () {
                        this.callEvent("onClick");
                    },
                },
                {}
            ];


        var table = {
            margin: 0,
            rows: [
                {
                    id: "mau05_68",
                    view: "datatable",
                    select: true,
                    resizeColumn: true,
                    footer: false,
                    editable: false,
                    tooltip: true,
                    subview: {
                        view: "tabview",
                        height: 200,
                        scroll: true,
                        cells: [{
                            header: "Chi tiết hóa đơn",
                            body: {
                                view: "datatable",
                                height: 400,
                                resizeColumn: true,
                                scroll: true,
                                id: "mau05_68_chitiet",
                                headerRowHeight: 50,
                                on: {
                                    "data->onStoreUpdated": function () {
                                        this.data.each(function (obj, i) {
                                            obj.index = i + 1;
                                        });
                                    },
                                },
                                columns: [
                                    {
                                        view: "text", id: "mau04_id", name: "mau04_id", hidden: true,
                                    },
                                    {
                                        view: "text", id: "mau04_chitiet_id", name: "mau04_chitiet_id", hidden: true
                                    },
                                    {
                                        view: "text", header: "STT", id: "index", name: "index", width: 80
                                    },
                                    {
                                        header: "Mẫu số",
                                        width: 120,
                                        template: function (obj) {
                                            return obj.khieu.toString().substring(0, 1);
                                        }
                                    },
                                    {
                                        id: "khieu", name: "khieu", header: "Ký hiệu hóa đơn điện tử", width: 150
                                    },

                                    {
                                        id: "shdon", name: "shdon", header: "Số hóa đơn điện tử", width: 120
                                    },
                                    {
                                        id: "ngay", name: "ngay", header: "Ngày lập hóa đơn", width: 120,
                                        format: function (text) {
                                            var format = webix.Date.dateToStr("%d/%m/%Y");
                                            text = removeTimeZoneT(text);
                                            return format(text);
                                        }
                                    },
                                    {
                                        id: "ladhddt", name: "ladhddt", header: "Loại áp dụng hóa đơn điện tử", width: 150
                                    },
                                    {
                                        id: "tctbao", name: "tctbao", header: "Hủy/giải trình", width: 150
                                    },
                                    {
                                        id: "ldo", name: "ldo", header: "Lý do", width: 250
                                    },
                                ],
                                scrollX: false,
                                autoheight: true,
                            },
                        },],
                    },
                    scheme: {
                        $init: function () {
                            // this.data.each(function (obj, i) {
                            //     obj.index = i + 1;
                            // });
                        },
                    },
                    onClick: {
                        "Dowload0405": function (event, cell, target) {
                            var win = webix.$$("mau05_68");
                            var record = win.getItem(cell.row);

                            if (record.loai_tbao != "5") {
                                if (record.trang_thai != 3 && record.trang_thai != 4) {
                                    webix.message("Mẫu chưa được ký không thể tải !", "error");
                                    return;
                                }
                            }
                            webix.extend(win, webix.ProgressBar);
                            win.disable();
                            win.showProgress();
                            var filename = record.loai_tbao == "5" ? "Mau05.xml" : "Mau04.xml";
                            var url = app.config.host + "/CancelInvoice/DowloadXml?id=" + cell.row;
                            webix.ajax().response("arraybuffer")
                                .get(url, function (text, data) {

                                    win.enable();
                                    win.hideProgress();

                                    var file = new Blob([data], { type: "application/xml" });
                                    webix.html.download(file, filename);
                                    // var fileURL = URL.createObjectURL(file);
                                    // window.open(fileURL, "_blank");
                                });
                            // webix.message("Delete row: " + cell.row);
                            return false; // here it blocks the default behavior
                        }
                    },
                    on: {
                        onSubViewCreate: function (view, item) {
                            var subView = view;

                            if (subView != null) {
                                var tableDetail = webix.$$("mau05_68_chitiet");
                                var url = app.config.host + "/CancelInvoice/GetDataDetail?id=" + item.id;
                                tableDetail.clearAll();
                                tableDetail.load(url);
                            }
                        },
                        "data->onStoreUpdated": function () {
                            this.data.each(function (obj, i) {
                                obj.stt = i + 1;
                            });
                        },
                        onItemDblClick: function (id, e, node) {
                            var btnEdit = $$("btnEdit");
                            btnEdit.callEvent("onClick");
                        },
                        onAfterLoad: function () {

                        },
                    },
                    columns: [
                        { id: "mau04_id", header: "mau04_id", hidden: true },
                        { template: "{common.subrow()}", width: 50, },
                        { id: "stt", header: "STT", sort: "int", width: 40 },
                        {
                            id: "tthai", header: ["Trạng thái", { content: "serverFilter" }], width: 150
                        },
                        {
                            id: "ntbao",
                            header: ["Ngày thông báo", { content: "datepickerFilter" }],
                            width: 120,
                            format: function (text) {
                                var format = webix.Date.dateToStr("%d/%m/%Y");
                                text = removeTimeZoneT(text);
                                return format(text);
                            },
                        },
                        { id: "stbao", header: ["Số thông báo", { content: "serverFilter" }], width: 150 },
                        { id: "lan", header: ["Lần", { content: "serverFilter" }], width: 150 },
                        { id: "thoihan", header: ["Thời hạn", { content: "serverFilter" }], width: 150 },
                        { id: "mthongdiep", header: ["Mã thông điệp", { content: "serverFilter" }], width: 150 },
                        {
                            id: "Dowload0405",
                            header: "Tải xml",
                            width: 120,
                            template: function (obj) {
                                if (obj.loai_tbao == "5") {
                                    return "<span class='Dowload0405' style='color: #00b300'><i class='fas fa-download'></i></span> ";
                                }
                                else {
                                    if (obj.trang_thai == 3 || obj.trang_thai == 4) {
                                        return "<span class='Dowload0405' style='color: #00b300'><i class='fas fa-download'></i></span> ";
                                    } else
                                        return "<span class='Dowload0405' style='color: #c8c8cc'><i class='fas fa-download'></i></span> ";
                                }
                            }
                        },
                        {
                            id: "btnInMau01",
                            header: ["In"],
                            css: { "text-align": "center" },
                            template: function (obj) {
                                if (obj.trang_thai == 3) {
                                    return "<span class='InMau01' style='color: #00b300'><i class='fas fa-print'></i></span> ";
                                } else
                                    return "<span class='InMau01' style='color: #c8c8cc'><i class='fas fa-print'></i></span> ";
                            },
                            width: 60
                        }
                    ],
                    // data: [
                    //     {
                    //         stt: 1,
                    //         loai_tb: "4",
                    //         trang_thai: "Chờ duyệt",
                    //         mso: "001",
                    //         ntbao: new Date(),
                    //         nguoi_gui: "ADMINNISTRATOR"
                    //     },
                    //     {
                    //         stt: 2,
                    //         loai_tb: "5",
                    //         trang_thai: "Chờ duyệt",
                    //         mso: "002",
                    //         ntbao: new Date(),
                    //         nguoi_gui: "ADMINNISTRATOR"
                    //     }
                    // ],
                    pager: "pagerA"
                },
                {
                    id: "pagerA",
                    view: "pager",
                    template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}",
                    container: "paging_here",
                    size: 50,
                    group: 5,
                },
            ],
        };

        var layout = {
            css: "frmView",
            rows: [
                {
                    height: 39,
                    css: "btnControl",
                    margin: 0,
                    borderless: true,
                    type: "toolbar",
                    cols: controls,
                },
                {
                    rows: [table],
                },
            ],
        };

        return {
            $ui: layout,
            $oninit: function (view, $scope) {
                var table = webix.$$("mau05_68");

                $scope.on(app, "dataChangedMau0405", function (mode, item) {
                    // if (mode == 1) {
                    //     table.add(item);
                    // }
                    // if (mode == 5) {
                    table.clearAll();
                    table.load(table.config.url);
                    // }
                });

                $scope.on(app, "filterTable", function (report_id, infoWindowId, item) {
                    var infoparam = {
                        infowindow_id: infoWindowId,
                        parameter: item,
                    };

                    table.config.infoparam = infoparam;
                    table.clearAll();
                    table.load(table.config.url);
                });
            },
            $onurlchange: function (ui, name, url, scope) {
                initUI();
            },
        }

    });
define('views/forms/forms68/MauHoaDon/68_quanlymauForm',["app", "models/user"], function (app, user) {
    var editmode = 0;

    var button = [
        {},
        {
            shortcut: "F10",
            view: "button",
            label: "Nhận (F10)",
            type: "form",
            align: "center",
            on: {
                onClick: function () {
                    var table = $$("mauthietke-form");
                    var item = table.getValues();
                    if (table.validate()) {
                        item.editmode = editmode;
                        $$("uploader68").define("upload", app.config.host + "/TemplateInvoice/SaveChange");
                        $$("uploader68").define("formData", item);
                        $$("uploader68").send(function (res) {
                            if (res != undefined) {
                                if (res.code != "00") {
                                    webix.message({ "type": "error", "text": res.message });
                                }
                                else {
                                    webix.message("Tạo mẫu hóa đơn thành công", "success");
                                    var win = $$("uploader68").getTopParentView();
                                    win.close();
                                    var table = $$("mauthietke");
                                    table.clearAll();
                                    table.load(table.config.url);
                                }
                            }
                            else {
                                webix.message("Bạn chưa chọn mẫu hóa đơn ", "error");
                            }
                        });
                    }
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {
            view: "button",
            hotkey: "esc",
            label: "Hủy bỏ (ESC)",
            type: "danger",
            align: "center",
            click: function () {
                webix.$$("mauthietke-win").close();
            }
        },
        {}
    ]

    var ui = {
        view: "window",
        modal: true,
        move: true,
        id: "mauthietke-win",
        position: "center",
        head: "Mẫu hóa đơn",
        body: {
            paddingY: 10,
            paddingX: 10,
            view: "form",
            width: 500,
            id: "mauthietke-form",
            complexData: true,
            margin: 0, elementsConfig: {
                labelPosition: "top"
            },
            elements: [
                {
                    view: "text",
                    label: "Mã mẫu",
                    name: "mmau",
                    id: "mmau",
                    readonly: true,
                    css: "mcls_readonly_text",
                    labelWidth: 120
                },
                {
                    view: "text",
                    label: "Tên mẫu",
                    name: "tmau",
                    id: "tmau",
                    labelWidth: 120,
                    required: true,
                    invalidMessage: "Tên mẫu không được bỏ trống",
                },
                {
                    view: "text",
                    label: "Số dòng in mẫu",
                    name: "sodong",
                    id: "sodong",
                    format: "1111",
                    labelWidth: 120,
                    value: 8,
                    required: true,
                    invalidMessage: "Số dòng in mẫu không được bỏ trống",
                },
                {
                    view: "uploader",
                    value: "Upload file",
                    label: "Mẫu thiết kế",
                    css: "btnUpload",
                    id: "uploader68",
                    name: "uploader68",
                    link: "mylist",
                    accept: "repx",
                    autosend: false,
                    // upload: app.config.host + "",
                    on: {
                        onUploadComplete: function (response) {

                        },
                        onFileUploadError: function (file, response) {

                        },
                        onAfterDelete: function (id) {

                        },
                    }
                },
                {
                    view: "list", id: "mylist", type: "uploader",
                    autoheight: true, borderless: true
                },
                {
                    height: 20
                },
                {
                    cols: button
                }
            ]
        }

    };

    return {
        $ui: ui,
        setEditMode: function (mode) {
            editmode = mode;
        },
        setValues: function (item) {
            var form = $$("mauthietke-form");
            form.setValues(item);
        },
    };
});
define('views/68_quanlymau',[
    "app",
    "locale",
    "models/user",
    "views/forms/forms68/MauHoaDon/68_quanlymauForm"
], function (
    app,
    _,
    user,
    mauthietkeform
) {
    "use strict";

    var initUI = function () {
        var table = webix.$$("mauthietke");
        var url = {
            $proxy: true,
            load: function (view, callback, params) {
                var url = app.config.host + "/Pattern/GetData";
                var start = null;
                var count = null;
                var filter = [];
                var tlbparam_s = [];
                if (params == null) {
                    start = 0;
                    count = view.config.datafetch;
                    url = url + "?command=CM0007&start=0&count=" + view.config.datafetch + "&continue=null&filter=null";
                }
                else {
                    start = params.start;
                    count = params.count;
                    url = url + "?start=" + params.start + "&count=" + params.count + "&continue=" + params.continue;
                    if (params.filter != null) {
                        var array = [];
                        for (var property in params.filter) {
                            var column = view.getColumnConfig(property);
                            var item = {
                                columnName: property,
                                columnType: column.columnType,
                                value: params.filter[property]
                            };
                            array.push(item);
                        }
                        if (array.length > 0) {
                            filter = array;
                            url = url + "&filter=" + JSON.stringify(array);
                        }
                        else {
                            url = url + "&filter=null";
                        }
                    }
                }
                var item = {
                    command: "CM0007",
                    start: start,
                    count: count,
                    filter: filter,
                    tlbparam: tlbparam_s
                };
                var apiHost = app.config.host + "/Pattern/GetData";
                webix.ajax()
                    .headers({ 'Content-type': 'application/json' })
                    .bind(view)
                    .post(apiHost, item, callback, view);
            },
        };
        table.define("url", url);
    };

    var controls = [
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-refresh fa-lg" aria-hidden="true"></i> ' +
                '<span class="text">' + _("REFRESH") + '</span>',
            id: "btnRefresh",
            on: {
                onClick: function () {
                    var table = webix.$$("mauthietke");
                    table.clearAll();
                    table.load(table.config.url);
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-plus fa-lg" aria-hidden="true"></i> ' +
                '<span class="text">' + _("THEM") + ' (F4)</span>',
            id: "btnPlus",
            shortcut: "F4",
            on: {
                onClick: function () {
                    var detailForm = this.$scope.ui(mauthietkeform.$ui);
                    mauthietkeform.setEditMode(1);
                    detailForm.show();
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-edit fa-lg" aria-hidden="true"></i> ' +
                '<span class="text">' + _("SUA") + ' (F2)</span>',
            id: "btnEdit",
            shortcut: "F2",
            on: {
                onClick: function () {
                    var table = webix.$$("mauthietke");
                    var selectedItem = table.getSelectedItem();
                    if (selectedItem == null) {
                        webix.message("Bạn chưa chọn mẫu hóa đơn cần sửa ! ", "error");
                        return;
                    }

                    if (selectedItem.tt_sd > 0) {
                        webix.message("Mẫu thiết kế đã sử dụng không thể sửa ! ", "error");
                        return;
                    }
                    var detailForm = this.$scope.ui(mauthietkeform.$ui);
                    mauthietkeform.setEditMode(2);
                    mauthietkeform.setValues(selectedItem);
                    detailForm.show();
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-trash-o fa-lg" aria-hidden="true"></i> ' +
                '<span class="text">' + _("XOA") + ' (F3)</span>',
            id: "btnDelete",
            shortcut: "F3",
            on: {
                onClick: function () {
                    var table = webix.$$("mauthietke");
                    var selectedItem = table.getSelectedItem();

                    if (selectedItem == null) {
                        webix.message("Bạn chưa chọn mẫu thiết kế ! ", "error");
                        return;
                    }
                    if (selectedItem.tt_sd > 0) {
                        webix.message("Mẫu thiết kế đã sử dụng không thể xóa ! ", "error");
                        return;
                    }
                    selectedItem.editmode = 3;
                    webix.confirm({
                        text: "Bạn có muốn xóa bản ghi",
                        ok: "Có",
                        cancel: "Không",
                        callback: function (choose) {
                            if (choose) {
                                webix.extend(table, webix.ProgressBar);
                                table.disable();
                                table.showProgress();

                                webix.ajax()
                                    .headers({ 'Content-type': 'application/json' })
                                    .get(app.config.host + "/TemplateInvoice/DeleteTemplate?id=" + selectedItem.quanlymau68_id,
                                        {
                                            error: function (text, data, XmlHttpRequest) {
                                                table.enable();
                                                table.hideProgress();
                                            },
                                            success: function (text, data, XmlHttpRequest) {
                                                var response = JSON.parse(text);
                                                table.enable();
                                                table.hideProgress();
                                                if (response.code == "00") {
                                                    table.remove(selectedItem.id);
                                                } else {
                                                    webix.message(response.message, "error");
                                                }
                                            }
                                        });
                            }
                        }
                    });
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-download fa-lg" aria-hidden="true"></i> ' +
                '<span class="text">' + _("Tải") + ' (F8)</span>',
            id: "btnDowload",
            shortcut: "F8",
            on: {
                onClick: function () {
                    var table = webix.$$("mauthietke");
                    var selectedItem = table.getSelectedItem();
                    if (selectedItem == null) {
                        webix.message("Bạn chưa chọn mẫu hóa đơn cần tải ! ", "error");
                        return;
                    }
                    var url = app.config.host + "/TemplateInvoice/DowloadRepx?id=" + selectedItem.id;
                    var box = webix.modalbox({
                        title: "Đang tải mẫu hóa đơn (repx) ....",
                        text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                        width: 350,
                        height: 200
                    });
                    webix.ajax()
                        .response("arraybuffer")
                        .get(url, function (text, data) {
                            var file = new Blob([data], { type: 'application/octet-stream' });
                            webix.html.download(file, "InvoiceTemplate.repx");
                            webix.modalbox.hide(box);
                        });
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {}
    ];

    var table = {
        margin: 0,
        rows: [
            {
                id: "mauthietke",
                view: "datatable",
                select: true,
                resizeColumn: true,
                footer: false,
                editable: false,
                tooltip: true,
                scheme: {
                    $init: function (obj) {
                    },
                },
                on: {
                    "data->onStoreUpdated": function () {
                        this.data.each(function (obj, i) {
                            obj.stt = i + 1;
                        });
                    },
                    onItemDblClick: function (id, e, node) {
                        var btnEdit = $$("btnEdit");
                        btnEdit.callEvent("onClick");
                    },
                    onBeforeLoad: function () {
                        this.showOverlay("<p><i style='font-size:450%;' class='fa fa-spin fa-spinner fa-pulse'></i></p>");
                    },
                    onAfterLoad: function (id) {
                        this.hideOverlay();
                    }
                },
                columns: [
                    {
                        id: "stt", header: "STT", sort: "int", width: 40,
                    },
                    {
                        id: "ntao",
                        header: ["Ngày tạo", { content: "datepickerFilter" }],
                        width: 150,
                        format: function (text) {
                            var format = webix.Date.dateToStr("%d/%m/%Y");
                            text = removeTimeZoneT(text);
                            return format(text);
                        }
                    },
                    {
                        id: "mmau",
                        header: ["Mã mẫu", { content: "serverFilter" }],
                        width: 120
                    },
                    {
                        id: "tmau",
                        header: ["Tên mẫu", { content: "serverFilter" }],
                        width: 120
                    },

                    {
                        id: "ngtao",
                        header: ["Người tạo", { content: "serverFilter" }],
                        width: 120,
                    },
                    {
                        id: "sodong",
                        header: ["Số dòng", { content: "serverFilter" }],
                        width: 120,
                    },
                    {
                        id: "tt_sdung",
                        header: ["Sử dụng", { content: "serverSelectFilter" }],
                        editor: "checkbox",
                        width: 90,
                        template: function (obj) {
                            var checked = obj.tt_sd > 1 ? 'checked="true"' : "";
                            return ("<input disabled class='webix_table_checkbox' type='checkbox' " + checked + ">");
                        }
                    }
                ],
                pager: "pagerA",
            },
            {
                id: "pagerA",
                view: "pager",
                template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}",
                container: "paging_here",
                size: 50,
                group: 5,
            },
        ],
    };

    var layout = {
        css: "frmView",
        rows: [{

            height: 39,
            css: "btnControl",
            type: "toolbar",
            margin: 0,
            borderless: true,
            // hidden: true,
            cols: controls
        },
        {
            rows: [table],
        },
        ],
    };


    function loadData() {
        var table = webix.$$("mauthietke");
        table.clearAll();
        table.load(table.config.url);
    }

    return {
        $ui: layout,
        $oninit: function (view, $scope) {
            var table = webix.$$("mauthietke");
            webix.extend(view, webix.ProgressBar);
            $scope.on(app, "dataChanged", function (mode, item) {
                if (mode == 1) {
                    table.add(item);
                }
                if (mode == 5) {
                    table.clearAll();
                    table.load(table.config.url);
                }
            });

            // $scope.on(app, "filterTable", function (report_id, infoWindowId, item) {
            //     var infoparam = {
            //         infowindow_id: infoWindowId,
            //         parameter: item,
            //     };

            //     table.config.infoparam = infoparam;
            //     table.clearAll();
            //     table.load(table.config.url);
            // });
        },
        $onurlchange: function (ui, name, url, scope) {
            initUI();
        },
    };
});
define('views/forms/forms68/68_thongtinkhacForm',["app", "models/user"], function (app, user) {
    var editmode = 0;
    var param;
    var button = [
        {},
        {
            shortcut: "F10",
            view: "button",
            label: "Nhận (F10)",
            type: "form",
            align: "center",
            width: 120,
            on: {
                onClick: function () {
                    var item = $$("thongtinkhac-form").getValues();
                    var table = $$("thongtinkhac-form");

                    if (table.validate()) {
                        webix.extend(table, webix.ProgressBar);
                        table.disable();
                        table.showProgress();
                        webix.ajax()
                            .headers({ 'Content-type': 'application/json' })
                            .post(app.config.host + "/Pattern/SaveChangeTTKhac", item, {
                                error: function (text, data, XmlHttpRequest) {
                                    var table = $$("thongtinkhac-form");
                                    table.enable();
                                    table.hideProgress();
                                    webix.message(text + XmlHttpRequest, "error");

                                }, success: function (text, data, XmlHttpRequest) {
                                    var json = JSON.parse(text);
                                    var table = $$("thongtinkhac-form");
                                    table.enable();
                                    table.hideProgress();
                                    if (json.code == "00") {
                                        $$("thongtinkhac-win").close();
                                        var table = $$("thongdiepViews");
                                        table.clearAll();
                                        table.load(table.config.url);
                                    }
                                    else {
                                        webix.message(json.message, "error");
                                    }
                                }
                            });
                    }
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {
            view: "button",
            hotkey: "esc",
            label: "Hủy bỏ (ESC)",
            type: "danger",
            align: "center",
            width: 120,
            click: function () {
                webix.$$("thongtinkhac-win").close();
            }
        },
        {}
    ]

    var ui = {
        view: "window",
        //modal: true,
        fullscreen: true,
        move: true,
        id: "thongtinkhac-win",
        position: "center",
        head: "Danh mục thông tin khác",
        on: {
            onBeforeShow: function () {

            }
        },
        body: {
            paddingY: 10,
            paddingX: 10,
            view: "form",
            width: 800,
            id: "thongtinkhac-form",
            complexData: true,
            margin: 0,
            elements: [
                {
                    cols: [
                        {
                            view: "combo",
                            name: "vitri",
                            label: "Vị trí",
                            //labelPosition: "top",
                            id: "vitri",
                            required: true,
                            labelWidth: 120,
                            value: "1",
                            invalidMessage: "Vị trí không được bỏ trống !",
                            options: [
                                { id: "dp", value: "Đầu phiếu" },
                                { id: "ct", value: "Chi tiết" }
                            ],
                            on: {
                                onChange: function (newv, oldv) {

                                }
                            }
                        },
                        {
                            view: "combo", label: "Loại hóa đơn", name: "loaihd_id",
                            id: "loaihd_id", required: true, invalidMessage: "Loại hóa đơn không được bỏ trống",
                            labelWidth: 120,
                            options: app.config.host + "/Pattern/GetData?command=CM0013&start=0&count=50&continue=null&filter=null",
                            on: {
                                onChange: function (newv, oldv) {

                                }
                            }
                        },
                    ]
                },
                {
                    cols: [
                        {
                            view: "text", label: "Tên trường", name: "ttruong", id: "ttruong", labelWidth: 120, required: true,
                            invalidMessage: "Tên trường không được bỏ trống"
                        },
                        {
                            id: "kdlieu", name: "kdlieu",
                            label: "Kiểu dữ liệu", labelWidth: 120, view: "combo", required: true,
                            invalidMessage: "Kiểu dữ liệu không được bỏ trống",
                            options: [
                                { id: "string", value: "string" },
                                { id: "numeric", value: "numeric" },
                                { id: "date", value: "date" },
                                { id: "datetime", value: "datetime" }
                            ]
                        }
                    ]
                },
                {
                    id: "parrent", name: "parrent", label: "parrent", labelWidth: 120, view: "text",
                    placeholder: "Điền info-invoice hoặc info-customer. Nếu muốn 2 cột trên 1 dòng điền {tên cột cha}_parrent"
                },
                {
                    id: "type_rows",
                    name: "type_rows",
                    label: "type_rows",
                    labelWidth: 120,
                    attributes: { readonly: true },
                    required: true,
                    invalidMessage: "type_rows không được bỏ trống",
                    view: "combo",
                    options: [
                        { id: "text", value: "text" },
                        { id: "datepicker", value: "datepicker" },
                        { id: "autonumeric", value: "autonumeric" },
                        { id: "combo", value: "combo" },
                        { id: "checkbox", value: "checkbox" },
                        { id: "multiselect", value: "multiselect" },
                        { id: "colorpicker", value: "colorpicker" }
                    ]
                },
                {
                    cols: [
                        {
                            id: "label", name: "label", label: "Label", labelWidth: 120, view: "text", required: true,
                            invalidMessage: "Label không được bỏ trống"
                        },
                        {
                            id: "label_width", name: "label_width", label: "Label Width",
                            labelWidth: 120, view: "autonumeric"
                        }
                    ]
                },
                {
                    cols: [
                        {
                            id: "rows", name: "rows", label: "Rows", labelWidth: 120, view: "text",
                            required: true, invalidMessage: "Rows không được bỏ trống"
                        },
                        {
                            id: "cols", name: "cols", label: "Cols", labelWidth: 120,
                            view: "text", required: true, invalidMessage: "Cols không được bỏ trống"
                        }
                    ]
                },
                { id: "format", name: "format", label: "Format", labelWidth: 120, view: "text", placeholder: "type_rows là autonumeric thì bắt buộc điền format: = [1,2,3,4,5...] type_rows khác autonumeric muốn format thì điền 1.111,00" },
                { id: "onclick", name: "onclick", label: "OnClick", labelWidth: 120, view: "textarea" },
                { id: "onchange", name: "onchange", label: "OnChange", labelWidth: 120, view: "textarea" },
                { id: "onselect", name: "onselect", label: "OnSelect", labelWidth: 120, view: "textarea" },
                { id: "is_use", name: "is_use", label: "Sử dụng", labelWidth: 120, view: "checkbox" },
                {
                    cols: [
                        { id: "is_lephi", name: "is_lephi", label: "Phí, lệ phí", labelWidth: 120, view: "checkbox" },
                        { id: "is_no_tax_reduce", name: "is_no_tax_reduce", label: "Giảm trừ không chịu thuế", labelWidth: 170, view: "checkbox" },
                        { id: "is_other_reduce", name: "is_other_reduce", label: "Giảm trừ khác", labelWidth: 100, view: "checkbox" }
                    ]
                },
                {
                    cols: [
                        { id: "is_readonly", name: "is_readonly", label: "Readonly", labelWidth: 120, view: "checkbox" },
                        { id: "hidden_in_grid", name: "hidden_in_grid", label: "Ẩn trên grid", labelWidth: 120, view: "checkbox" },
                        { id: "hidden_in_form", name: "hidden_in_form", label: "Ẩn trên form", labelWidth: 170, view: "checkbox" }
                    ]
                },
                { margin: 10, cols: button }
            ]
        }

    };

    return {
        $ui: ui,
        setEditMode: function (mode) {
            editmode = mode;
        },
        initUI: function (item) {
            param = item;
        },
        setValues: function (item) {
            $$("thongtinkhac-form").setValues(item);
        }
    };
});
define('views/68_thongtinkhac',[
    "app",
    "locale",
    "models/user",
    "views/forms/forms68/68_thongtinkhacForm",
], function (app, _, user, thongtinkhacForm) {
    'use strict';

    var controls = [
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-refresh fa-lg" aria-hidden="true"></i> ' +
                '<span class="text">' + _("REFRESH") + '</span>',
            id: "btnReload",
            on: {
                onClick: function () {
                    webix.callEvent("onLoadError");
                    var table = webix.$$("thongdiepViews");
                    table.clearAll();
                    table.load(table.config.url);
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-plus fa-lg" aria-hidden="true"></i> ' +
                '<span class="text">' + _("THEM") + ' (F4)</span>',
            id: "btnPlus",
            shortcut: "F4",
            on: {
                onClick: function () {
                    var detailForm = this.$scope.ui(thongtinkhacForm.$ui);
                    thongtinkhacForm.setEditMode(1);
                    detailForm.show();
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-edit fa-lg" aria-hidden="true"></i> ' +
                '<span class="text">' + _("SUA") + ' (F3)</span>',
            id: "btnEdit",
            shortcut: "F2",
            on: {
                onClick: function () {
                    var table = webix.$$("thongdiepViews");
                    var selectedItem = table.getSelectedItem();
                    if (selectedItem == null) {
                        webix.message("Bạn chưa chọn dòng ! ", "error");
                        return;
                    }

                    var detailForm = this.$scope.ui(thongtinkhacForm.$ui);
                    thongtinkhacForm.setEditMode(2);
                    thongtinkhacForm.setValues(selectedItem);
                    detailForm.show();
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-trash-o fa-lg" aria-hidden="true"></i> ' +
                '<span class="text">' + _("XOA") + ' (F3)</span>',
            id: "btnDelete",
            shortcut: "F3",
            on: {
                onClick: function () {
                    var table = webix.$$("thongdiepViews");
                    var selectedItem = table.getSelectedItem();
                    if (selectedItem == null) {
                        webix.message("Bạn chưa chọn dòng cần xóa ! ", "error");
                        return;
                    }
                    webix.confirm({
                        text: "Bạn có muốn xóa bản ghi",
                        ok: "Có",
                        cancel: "Không",
                        callback: function (choose) {
                            if (choose) {
                                webix.extend(table, webix.ProgressBar);
                                table.disable();
                                table.showProgress();

                                webix.ajax()
                                    .headers({ 'Content-type': 'application/json' })
                                    .get(app.config.host + "/Pattern/DeleteTTkhac?id=" + selectedItem.id,
                                        {
                                            error: function (text, data, XmlHttpRequest) {
                                                table.enable();
                                                table.hideProgress();
                                                var json = JSON.parse(text);
                                                webix.message(json.error, "error");
                                            },
                                            success: function (text, data, XmlHttpRequest) {
                                                var res = JSON.parse(text);
                                                if (res.code != "00") {
                                                    webix.message(res.error, "error");
                                                }
                                                else {
                                                    table.remove(selectedItem.id);
                                                    table.enable();
                                                    table.hideProgress();
                                                }
                                            }
                                        });
                            }
                        }
                    });
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        }
    ];

    var grid = {
        rows: [
            {
                view: "datatable",
                id: "thongdiepViews",
                select: true,
                resizeColumn: true,
                fixedRowHeight: false,
                // leftSplit: 8,
                // rightSplit: 1,
                rowLineHeight: 25, rowHeight: 25,
                tooltip: true,
                //autowidth: true,
                url: {
                    $proxy: true,
                    load: function (view, callback, params) {
                        var tlbparam_s = [];
                        var url = app.config.host + "/Pattern/GetData";

                        if (params == null) {
                            url = url + "?command=CM0012&start=0&count=" + view.config.datafetch + "&continue=null&filter=null";
                        }
                        else {
                            url = url + "?command=CM0012&start=" + params.start + "&count=" + params.count + "&continue=" + params.continue;

                            if (params.filter != null) {
                                var array = [];
                                for (var property in params.filter) {
                                    var column = view.getColumnConfig(property);
                                    var item = {
                                        columnName: property,
                                        columnType: column.columnType,
                                        value: params.filter[property]
                                    };
                                    array.push(item);
                                }
                                url = url + "&filter=" + JSON.stringify(array);
                            }
                        }
                        var tlbParams = $$("paramKH");
                        if (tlbParams !== undefined) {
                            var childViews = tlbParams.getChildViews();
                            var parameters = [];
                            for (var i = 0; i < childViews.length; i++) {
                                var child = childViews[i];
                                var id = child.config.id;
                                var item = {
                                    columnName: "cctbao_id",
                                    value: $$(id).getValue()
                                };
                                parameters.push(item);
                            }
                            tlbparam_s = parameters;
                            url = url + "&tlbparam=" + JSON.stringify(parameters);
                        }
                        webix.ajax(url, callback, view);
                    }
                },
                onClick: {
                    "dowloadXmlDKSD": function (event, cell, target) {

                    }
                },
                on: {
                    "data->onStoreUpdated": function () {
                        this.data.each(function (obj, i) {
                            obj.index = i + 1;
                        });
                    },
                    onItemClick: function (id) {

                    },
                    onClick: function (e) {
                        // var view = $$(e);
                        // if (!view || !view.getFormView || view.getFormView() != $$("invoiceDate"))
                        //     webix.confirm("The changes was not saved");
                    },
                    onItemDblClick: function (id, e, node) {
                        var btnEdit = $$("btnEdit");
                        btnEdit.callEvent("onClick");
                    },
                    onAfterLoad: function () {

                    },
                    onColumnResize: function () {
                        // this.adjustRowHeight("ten_loai", true);
                        // this.render();
                    }
                },
                columns: [
                    {
                        id: "index",
                        header: ["<center>STT</center>", { content: "textFilter" }],
                        sort: "int",
                        width: 40,
                    },
                    {
                        id: "vitri", header: ["<center>Vị trí</center>", { content: "textFilter" }],
                        width: 100, columnType: "nvarchar", template: function (obj) {
                            if (obj.vitri == "dp")
                                return "<span class='mcls_status1'>Đầu phiếu</span>";
                            else
                                return "<span class='mcls_status5'>Chi tiết</span>";
                        }
                    },
                    {
                        id: "label", header: ["<center>Label</center>", { content: "textFilter" }],
                        width: 200, columnType: "nvarchar"
                    },
                    {
                        id: "ttruong", header: ["<center>Tên trường</center>", { content: "textFilter" }],
                        width: 180, columnType: "nvarchar"
                    },
                    {
                        id: "kdlieu", header: ["<center>Kiểu dữ liệu</center>", { content: "textFilter" }],
                        width: 120, columnType: "nvarchar"
                    },
                    {
                        id: "type_rows", header: ["<center>Loại</center>", { content: "textFilter" }],
                        width: 130, columnType: "nvarchar"
                    },
                    {
                        id: "parrent", header: ["<center>Parrent</center>", { content: "textFilter" }],
                        width: 150, columnType: "nvarchar"
                    },
                    {
                        id: "ten", header: ["<center>Loại hóa đơn</center>", { content: "textFilter" }],
                        width: 200, columnType: "nvarchar"
                    },
                    {
                        id: "is_use", header: ["<center>Sử dụng</center>", { content: "textFilter" }],
                        width: 100, columnType: "nvarchar", editor: "checkbox",
                        template: function (obj) {
                            var checked = obj.is_use == true ? 'checked="true"' : "";
                            return ("<input disabled class='webix_table_checkbox' type='checkbox' " + checked + ">");
                        },
                        css: { "text-align": "center" }
                    },
                    {
                        id: "is_lephi", header: ["<center>Phí, lệ phí</center>", { content: "textFilter" }],
                        width: 100, columnType: "nvarchar", editor: "checkbox",
                        template: function (obj) {
                            var checked = obj.is_lephi == true ? 'checked="true"' : "";
                            return ("<input disabled class='webix_table_checkbox' type='checkbox' " + checked + ">");
                        },
                        css: { "text-align": "center" }
                    },
                    {
                        id: "is_no_tax_reduce", header: [{ text: "<center>Giảm trừ không chịu thuế</center>", css: "multilineColumn" }, { content: "textFilter" }],
                        width: 120, columnType: "nvarchar", editor: "checkbox",
                        template: function (obj) {
                            var checked = obj.is_no_tax_reduce == true ? 'checked="true"' : "";
                            return ("<input disabled class='webix_table_checkbox' type='checkbox' " + checked + ">");
                        },
                        css: { "text-align": "center" }
                    },
                    {
                        id: "is_other_reduce", header: ["<center>Giảm trừ khác</center>", { content: "textFilter" }],
                        width: 120, columnType: "nvarchar", editor: "checkbox",
                        template: function (obj) {
                            var checked = obj.is_other_reduce == true ? 'checked="true"' : "";
                            return ("<input disabled class='webix_table_checkbox' type='checkbox' " + checked + ">");
                        },
                        css: { "text-align": "center" }
                    },
                    {
                        id: "is_readonly", header: ["<center>Readonly</center>", { content: "textFilter" }],
                        width: 100, columnType: "nvarchar", editor: "checkbox",
                        template: function (obj) {
                            var checked = obj.is_readonly == true ? 'checked="true"' : "";
                            return ("<input disabled class='webix_table_checkbox' type='checkbox' " + checked + ">");
                        },
                        css: { "text-align": "center" }
                    },
                    {
                        id: "hidden_in_grid", header: ["<center>Ẩn trên grid</center>", { content: "textFilter" }],
                        width: 100, columnType: "nvarchar", editor: "checkbox",
                        template: function (obj) {
                            var checked = obj.hidden_in_grid == true ? 'checked="true"' : "";
                            return ("<input disabled class='webix_table_checkbox' type='checkbox' " + checked + ">");
                        },
                        css: { "text-align": "center" }
                    },
                    {
                        id: "hidden_in_form", header: ["<center>Ẩn trên form</center>", { content: "textFilter" }],
                        width: 100, columnType: "nvarchar", editor: "checkbox",
                        template: function (obj) {
                            var checked = obj.hidden_in_form == true ? 'checked="true"' : "";
                            return ("<input disabled class='webix_table_checkbox' type='checkbox' " + checked + ">");
                        },
                        css: { "text-align": "center" }
                    }
                ],
                pager: "pagerA"
            },
            {
                cols: [
                    {
                        view: "icon", icon: "fas fa-question-circle", id: "help_form_main", tooltip: _("HELPER"),
                        css: "helper",
                        click: function () {
                            webix.alert({
                                title: "Thông báo !",
                                text: "Bạn chưa khai báo hướng dẫn nhanh cho màn hình này !",
                                type: "alert-warning",
                                callback: function (result) {
                                }
                            });
                        }
                    },
                    {
                        view: "combo",
                        label: _("MENU_QUICK"),
                        id: "QuickMenuMain",
                        options: {

                        },
                        on: {
                            onChange: function (newv, oldv) {

                            }
                        }
                    },
                    {},
                    {
                        id: "pagerA",
                        view: "pager",
                        size: 100,
                        group: 5,
                        template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}"
                    }
                ]
            }
        ]
    }

    var layout = {
        css: "frmView",
        rows: [
            {
                height: 39,
                css: "btnControl",
                margin: 0,
                borderless: true,
                type: "toolbar",
                cols: controls
            },
            {
                rows: [
                    grid
                ]
            }
        ]

    };

    return {
        $ui: layout,
        $oninit: function (view, $scope) {

            $scope.on(app, "dataChangedViewsTTKhac", function (editmode, item) {

            });
        }
    };
});
define('views/68_viewLogs',[
    "app",
    "locale",
    "models/user"
], function (app, _, user) {
    'use strict';

    var controls = [
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-refresh fa-lg" aria-hidden="true"></i> ' +
                '<span class="text">' + _("REFRESH") + '</span>',
            id: "btnReload",
            on: {
                onClick: function () {
                    webix.callEvent("onLoadError");
                    var table = webix.$$("thongdiepViews");
                    table.clearAll();
                    table.load(table.config.url);
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {}
    ];

    var grid = {
        rows: [
            {
                view: "datatable",
                id: "thongdiepViews",
                select: true,
                resizeColumn: true,
                fixedRowHeight: false,
                // leftSplit: 8,
                // rightSplit: 1,
                rowLineHeight: 25, rowHeight: 25,
                tooltip: true,
                url: {
                    $proxy: true,
                    load: function (view, callback, params) {
                        var url = app.config.host + "/Pattern/GetData";
                        if (params == null) {
                            url = url + "?command=CM0015&start=0&count=" + view.config.datafetch + "&continue=null&filter=null";
                        }
                        else {
                            url = url + "?command=CM0015&start=" + params.start + "&count=" + params.count + "&continue=" + params.continue;
                            if (params.filter != null) {
                                var array = [];
                                for (var property in params.filter) {

                                    var column = view.getColumnConfig(property);
                                    var item = {
                                        columnName: property,
                                        columnType: column.columnType,
                                        value: params.filter[property]
                                    };
                                    array.push(item);
                                }
                                url = url + "&filter=" + JSON.stringify(array);
                            }
                        }
                        var tlbParams = $$("paramKH");

                        if (tlbParams !== undefined) {
                            var childViews = tlbParams.getChildViews();
                            var parameters = [];
                            for (var i = 0; i < childViews.length; i++) {
                                var child = childViews[i];
                                var id = child.config.id;
                                var item = {
                                    columnName: "cctbao_id",
                                    value: $$(id).getValue()
                                };
                                parameters.push(item);
                            }
                            tlbparam_s = parameters;
                            url = url + "&tlbparam=" + JSON.stringify(parameters);
                        }
                        webix.ajax(url, callback, view);
                    }
                },
                onClick: {
                    "dowloadXmlDKSD": function (event, cell, target) {
                        var win = webix.$$("thongdiepViews");
                        var record = win.getItem(cell.row);

                        if (!record.ghichu.startsWith('{')) {
                            var file = new Blob([record.ghichu], { type: "application/xml" });
                            webix.html.download(file, "thongdiep.xml");
                        }
                        else {
                            var jsXml = JSON.parse(record.ghichu);

                            var file = new Blob([jsXml.xml], { type: "application/xml" });
                            webix.html.download(file, "thongdiep.xml");
                        }
                    },
                    "ViewXSD": function (event, cell, target) {
                        var win = webix.$$("thongdiepViews");
                        var record = win.getItem(cell.row);
                        if (!record.ghichu.startsWith('{')) {

                            var newWin = window.open();
                            const files = new Blob([record.ghichu], { type: "application/xml" });
                            const fileURL = URL.createObjectURL(files);

                            newWin.location = fileURL;
                        }
                        else {
                            var jsXml = JSON.parse(record.ghichu);
                            var newWin = window.open();
                            const files = new Blob([jsXml.xml], { type: "application/xml" });
                            const fileURL = URL.createObjectURL(files);
                            newWin.location = fileURL;
                        }
                    }
                },
                on: {
                    "data->onStoreUpdated": function () {
                        this.data.each(function (obj, i) {
                            obj.stt = i + 1;
                        });
                    },
                    onItemClick: function (id) {
                    },
                    onClick: function (e) {
                    },
                    onItemDblClick: function (id, e, node) {
                    },
                    onBeforeLoad: function () {
                        webix.extend(this, webix.ProgressBar);
                        this.disable();
                        this.showProgress();
                    },
                    onAfterLoad: function () {
                        if (!this.count())
                            this.showOverlay("<div class='showOverlaydata'>Không có dữ liệu<div>");
                        else {
                            this.enable();
                            this.hideProgress();
                        }
                    },
                    onColumnResize: function () {
                    }
                },
                columns: [
                    // { id: "subRowMain", header: "&nbsp;", template: "{common.subrow()}", width: 40 },
                    {
                        id: "stt",
                        header: ["<center>STT</center>", { content: "serverFilter" }], sort: "int",
                        width: 40,
                    },
                    {
                        id: "fields2", header: ["<center>Mã loại TĐ</center>", { content: "serverFilter" }],
                        width: 110, columnType: "nvarchar"
                    },
                    { id: "kyhieu", name: "kyhieu", header: ["<center>Ký hiệu</center>", { content: "serverFilter" }], width: 110, editor: "text" },
                    { id: "sohoadon", name: "sohoadon", header: ["<center>Số hóa đơn</center>", { content: "serverFilter" }], width: 110, editor: "text" },
                    {
                        id: "fields4", header: ["<center>Mã lỗi</center>", { content: "serverFilter" }],
                        width: 110, columnType: "nvarchar"
                    },
                    {
                        id: "fields5", header: ["<center>Mô tả lỗi</center>", { content: "serverFilter" }],
                        width: 200, columnType: "nvarchar"
                    },
                    {
                        id: "fields1", header: ["<center>Mã TĐ</center>", { content: "serverFilter" }],
                        width: 150, columnType: "nvarchar"
                    },
                    {
                        id: "fields3", header: ["<center>Mã TĐ tham chiếu</center>", { content: "serverFilter" }],
                        width: 150, columnType: "nvarchar"
                    },
                    {
                        id: "datelog", header: ["<center>Thời điểm nhận</center>", { content: "serverDateRangeFilter" }], width: 150, columnType: "datetime",
                        format: function (text) {
                            var format = webix.Date.dateToStr("%d/%m/%Y %H:%i:%s");
                            text = removeTimeZoneT(text);
                            return format(text);
                        }
                    },
                    {
                        id: "ghichu", header: ["<center>Thông điệp</center>", { content: "serverFilter" }], width: 200, columnType: "nvarchar"
                    },
                    {
                        id: "dowloadXmlDKSD",
                        header: ["Tải về"],
                        css: { "text-align": "center" },
                        template: function (obj) {
                            return "<span class='dowloadXmlDKSD' style='color: #00b300'><i class='fas fa-download'></i></span> ";
                        },
                        width: 60
                    },
                    {
                        id: "ViewXSD",
                        header: ["Xem"],
                        css: { "text-align": "center" },
                        template: function (obj) {
                            return "<span class='ViewXSD' style='color: #00b300'><i class='fas fa-eye'></i></span> ";
                        },
                        width: 60
                    }
                ],
                pager: "pagerA"
            },
            {
                cols: [
                    {
                        view: "icon", icon: "fas fa-question-circle", id: "help_form_main", tooltip: _("HELPER"),
                        css: "helper",
                        click: function () {
                            webix.alert({
                                title: "Thông báo !",
                                text: "Bạn chưa khai báo hướng dẫn nhanh cho màn hình này !",
                                type: "alert-warning",
                                callback: function (result) {
                                }
                            });
                        }
                    },
                    {
                        view: "combo",
                        label: _("MENU_QUICK"),
                        id: "QuickMenuMain",
                        options: {

                        },
                        on: {
                            onChange: function (newv, oldv) {

                            }
                        }
                    },
                    {},
                    {
                        id: "pagerA",
                        view: "pager",
                        size: 50,
                        group: 5,
                        template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}"
                    }
                ]
            }
        ]
    }

    var layout = {
        css: "frmView",
        id: "frmView",
        rows: [
            {
                height: 39,
                css: "btnControl",
                margin: 0,
                borderless: true,
                type: "toolbar",
                cols: controls
            },
            {
                rows: [
                    grid
                ]
            }
        ]

    };

    return {
        $ui: layout,
        $oninit: function (view, $scope) {
            $scope.on(app, "dataChangedViewLogs", function (editmode, item) {

            });
        }
    };
});
define('views/70_bangke_hdck',[
    "app",
    "locale",
    "views/modules/Component/componentHelper",
    "views/modules/Component/constantManager",
], function (app, _) {
    'use strict';

    var controls = [
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-refresh fa-lg" aria-hidden="true"></i> ' +
                '<span class="text">' + _("Làm mới") + '</span>',
            id: "btnRefresh",
            click: function () {
                fetchData();
            }
        },
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-edit fa-lg" aria-hidden="true"></i> ' +
                '<span class="text">' + _("Sửa") + '</span>',
            id: "btnEdit",
        },
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-print fa-lg" aria-hidden="true"></i> ' +
                '<span class="text">' + _("PRINT") + '</span>',
            id: "btnPrint",
        },
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-plus fa-lg" aria-hidden="true"></i> ' +
                '<span class="text">' + _("Tạo HĐCK") + '</span>',
            id: "TaoHDCK",
            click: function () {
                var table = $$('bangke');
                if (!table) return;
                var selected = table.getSelectedItem();
                if (!selected) {
                    webix.message("Vui lòng chọn một bảng kê để tạo HĐCK!", "error");
                    return;
                }
                console.log("Bang ke", selected);
                webix.$$("btnPlus").callEvent("onCreate", [selected]);
            }
        }
    ];

    var gridColumn = [
        { id: "stt", header: "STT", width: 50 },

        {
            id: "tthai",
            header: [{ text: "Trạng thái" }, {
                content: "selectFilter",
                on: {
                    onChange: function () { fetchData(); }
                }
            }],
            width: 120,
            editor: "combo",
            options: ["Chờ ký", "Đã ký"]
        },

        {
            id: "khieu",
            header: [_("KY_HIEU"), {
                content: "textFilter",
                on: {
                    onTimedKeyPress: function () { fetchData(); }
                }
            }],
            width: 120,
            editor: "text"
        },

        {
            id: "so",
            header: [{ text: "Số bảng kê" }, {
                content: "textFilter",
                on: {
                    onTimedKeyPress: function () { fetchData(); }
                }
            }],
            width: 120,
            editor: "text"
        },

        {
            id: "ngay",
            header: [{ text: "Ngày bảng kê" }, {
                content: "dateRangeFilter",
                on: {
                    onChange: function () { fetchData(); }
                }
            }],
            width: 120,
            editor: "datepicker"
        },

        {
            id: "nban",
            header: [
                { text: "Đơn vị bán", colspan: 3 },
                {
                    text: "Tên đơn vị bán",
                    content: "textFilter",
                    on: {
                        onTimedKeyPress: function () { fetchData(); }
                    }
                }
            ],
            width: 200,
            editor: "text"
        },

        {
            id: "mst_nban",
            header: [null, {
                text: "Mã số thuế",
                content: "textFilter",
                on: {
                    onTimedKeyPress: function () { fetchData(); }
                }
            }],
            width: 150,
            editor: "text"
        },

        {
            id: "dchi_nban",
            header: [null, {
                text: "Địa chỉ",
                content: "textFilter",
                on: {
                    onTimedKeyPress: function () { fetchData(); }
                }
            }],
            width: 200,
            editor: "text"
        },

        {
            id: "nmua",
            header: [
                { text: "Đơn vị mua", colspan: 3 },
                {
                    text: "Tên đơn vị mua",
                    content: "textFilter",
                    on: {
                        onTimedKeyPress: function () { fetchData(); }
                    }
                }
            ],
            width: 200,
            editor: "text"
        },

        {
            id: "mst_nmua",
            header: [null, {
                text: "Mã số thuế",
                content: "textFilter",
                on: {
                    onTimedKeyPress: function () { fetchData(); }
                }
            }],
            width: 150,
            editor: "text"
        },

        {
            id: "dchi_nmua",
            header: [null, {
                text: "Địa chỉ",
                content: "textFilter",
                on: {
                    onTimedKeyPress: function () { fetchData(); }
                }
            }],
            width: 200,
            editor: "text"
        },

        {
            id: "ngtao",
            header: [{ text: "Người tạo" }, {
                content: "textFilter",
                on: {
                    onTimedKeyPress: function () { fetchData(); }
                }
            }],
            width: 120,
            editor: "text"
        },

        {
            id: "ngaytao",
            header: [{ text: "Ngày tạo" }, {
                content: "dateRangeFilter",
                on: {
                    onChange: function () { fetchData(); }
                }
            }],
            width: 120,
            editor: "datepicker", format: function (text) { return formatDate(text); }
        }
    ];


    const fetchData = () => {
        const table = $$('bangke');
        if (!table) return;

        const kyhieu_id = $$("kyhieu_id") ? $$("kyhieu_id").getValue() : null;
        const kyhieu_text = $$("kyhieu_id") ? $$("kyhieu_id").getText() : "";
        const mst = $$("filter_MST") ? $$("filter_MST").getValue() : "";
        const month = $$("filter_thang") ? $$("filter_thang").getValue() : null;
        const year = $$("filter_nam") ? $$("filter_nam").getValue() : null;
        const tuNgay = $$("filter_tu_ngay") ? $$("filter_tu_ngay").getValue() : null;
        const denNgay = $$("filter_den_ngay") ? $$("filter_den_ngay").getValue() : null;
        const start = 0;
        const count = 50;
        const isListAll = false;

        const filterArr = [];
        if (kyhieu_text && kyhieu_text.trim() !== "") {
            filterArr.push({
                columnName: "kyhieu",
                value: kyhieu_text,
                columnCondition: "=",
                columnType: "string"
            });
        }
        if (mst) {
            filterArr.push({
                columnName: "mst",
                value: mst,
                columnCondition: "=",
                columnType: "string"
            });
        }
        if (tuNgay) {
            filterArr.push({
                columnName: "ngay",
                value: webix.Date.dateToStr("%Y-%m-%d")(tuNgay),
                columnCondition: ">=",
                columnType: "date"
            });
        }
        if (denNgay) {
            filterArr.push({
                columnName: "ngay",
                value: webix.Date.dateToStr("%Y-%m-%d")(denNgay),
                columnCondition: "<=",
                columnType: "date"
            });
        }
        if (month && year && !tuNgay && !denNgay) {
            filterArr.push({
                columnName: "ngay",
                value: `${year}-${String(month).padStart(2, '0')}`,
                columnCondition: "month_year",
                columnType: "date"
            });
        }
        const payload = {
            start,
            count,
            isListAll,
            filter: filterArr,
            tlbparam: "",
        };
        const url = app.config.host.replace(/\/+$/, '') + "/Bangke70/GetData?type=1";
        webix.ajax()
            .headers({ "Content-Type": "application/json" })
            .post(url, payload)
            .then((data) => {
                try {
                    const obj = data.json();
                    if (obj.data) {
                        table.clearAll();
                        table.parse(obj.data);
                        table.config.total_count = obj.total_count || 0;

                        if (!table.count()) {
                            table.showOverlay("<div><img src='assets/imgs/nodata.png'><div class='showOverlaydata'>Không có dữ liệu</div></div>");
                        } else {
                            table.hideOverlay();
                        }
                    } else {
                        webix.message("Không có dữ liệu trả về.");
                        table.clearAll();
                    }
                } catch (e) {
                    webix.message("Lỗi định dạng JSON từ máy chủ.");
                }
            })
            .catch((err) => {
                webix.message("Lỗi khi gọi API. Vui lòng thử lại.");
            });
    };
    const grid = {
        rows: [
            {
                container: "testA",
                view: "datatable",
                id: "bangke",
                select: true,
                resizeColumn: true,
                fullScreen: true,
                leftSplit: 4,
                footer: true,
                columns: gridColumn,
                datafetch: 50,
                pager: "bangkePager",
                on: {
                    "data->onStoreUpdated": function () {
                        this.data.each((obj, i) => obj.stt = i + 1);
                    }
                }
            },
            {
                id: "bangkePager",
                view: "pager",
                size: 50,
                group: 5,
                template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}"
            }
        ]
    };

    const layout = {
        css: "frmView",
        rows: [
            {
                height: 39,
                type: "toolbar",
                css: "btnControl",
                borderless: true,
                cols: controls
            },
            {
                rows: [grid]
            }
        ]
    };

    return {
        $ui: layout,
        $oninit: function () {
            fetchData();
        }
    };
});

define('views/70_bangke',[
    "app",
    "locale",
    "views/modules/Component/componentHelper",
    "views/modules/Component/constantManager",
], function (app, _) {
    'use strict';

    var controls = [
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-refresh fa-lg" aria-hidden="true"></i> ' +
                '<span class="text">' + _("Làm mới") + '</span>',
            id: "btnRefresh",
            click: function () {
                fetchData();
            }
        },
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-edit fa-lg" aria-hidden="true"></i> ' +
                '<span class="text">' + _("Sửa") + '</span>',
            id: "btnEdit",
        },
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-print fa-lg" aria-hidden="true"></i> ' +
                '<span class="text">' + _("PRINT") + '</span>',
            id: "btnPrint",
        },
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-plus fa-lg" aria-hidden="true"></i> ' +
                '<span class="text">' + _("Tạo HĐ DCTT") + '</span>',
            id: "TaoHDDCTT",
            click: function () {
                var table = $$('bangke');
                if (!table) return;
                var selected = table.getSelectedItem();
                if (!selected) {
                    webix.message("Vui lòng chọn một bảng kê để tạo HD DCTT!", "error");
                    return;
                }
                webix.$$("btnPlus").callEvent("onCreate", [selected]);
            }
        }
    ];

    var gridColumn = [
        { id: "stt", header: "STT", width: 50 },

        {
            id: "tthai",
            header: [{ text: "Trạng thái" }, {
                content: "selectFilter",
                on: {
                    onChange: function () { fetchData(); }
                }
            }],
            width: 120,
            editor: "combo",
            options: ["Chờ ký", "Đã ký"]
        },

        {
            id: "khieu",
            header: [_("KY_HIEU"), {
                content: "textFilter",
                on: {
                    onTimedKeyPress: function () { fetchData(); }
                }
            }],
            width: 120,
            editor: "text"
        },

        {
            id: "so",
            header: [{ text: "Số bảng kê" }, {
                content: "textFilter",
                on: {
                    onTimedKeyPress: function () { fetchData(); }
                }
            }],
            width: 120,
            editor: "text"
        },

        {
            id: "ngay",
            header: [{ text: "Ngày bảng kê" }, {
                content: "dateRangeFilter",
                on: {
                    onChange: function () { fetchData(); }
                }
            }],
            width: 120,
            format: formatDate,
            editor: "datepicker"
        },

        {
            id: "nban",
            header: [
                { text: "Đơn vị bán", colspan: 3 },
                {
                    text: "Tên đơn vị bán",
                    content: "textFilter",
                    on: {
                        onTimedKeyPress: function () { fetchData(); }
                    }
                }
            ],
            width: 200,
            editor: "text"
        },

        {
            id: "mst_nban",
            header: [null, {
                text: "Mã số thuế",
                content: "textFilter",
                on: {
                    onTimedKeyPress: function () { fetchData(); }
                }
            }],
            width: 150,
            editor: "text"
        },

        {
            id: "dchi_nban",
            header: [null, {
                text: "Địa chỉ",
                content: "textFilter",
                on: {
                    onTimedKeyPress: function () { fetchData(); }
                }
            }],
            width: 200,
            editor: "text"
        },

        {
            id: "nmua",
            header: [
                { text: "Đơn vị mua", colspan: 3 },
                {
                    text: "Tên đơn vị mua",
                    content: "textFilter",
                    on: {
                        onTimedKeyPress: function () { fetchData(); }
                    }
                }
            ],
            width: 200,
            editor: "text"
        },

        {
            id: "mst_nmua",
            header: [null, {
                text: "Mã số thuế",
                content: "textFilter",
                on: {
                    onTimedKeyPress: function () { fetchData(); }
                }
            }],
            width: 150,
            editor: "text"
        },

        {
            id: "dchi_nmua",
            header: [null, {
                text: "Địa chỉ",
                content: "textFilter",
                on: {
                    onTimedKeyPress: function () { fetchData(); }
                }
            }],
            width: 200,
            editor: "text"
        },

        {
            id: "ldo",
            header: [{ text: "Lý do sai xót" }, {
                content: "textFilter",
                on: {
                    onTimedKeyPress: function () { fetchData(); }
                }
            }],
            width: 200,
            editor: "textarea"
        },

        {
            id: "ngtao",
            header: [{ text: "Người tạo" }, {
                content: "textFilter",
                on: {
                    onTimedKeyPress: function () { fetchData(); }
                }
            }],
            width: 120,
            editor: "text"
        },

        {
            id: "ngaytao",
            header: [{ text: "Ngày tạo" }, {
                content: "dateRangeFilter",
                on: {
                    onChange: function () { fetchData(); }
                }
            }],
            width: 120,
            editor: "datepicker", format: function (text) { return formatDate(text); }
        }
    ];


    const fetchData = () => {
        const table = $$('bangke');
        if (!table) return;

        const kyhieu_id = $$("kyhieu_id") ? $$("kyhieu_id").getValue() : null;
        const kyhieu_text = $$("kyhieu_id") ? $$("kyhieu_id").getText() : "";
        const mst = $$("filter_MST") ? $$("filter_MST").getValue() : "";
        const month = $$("filter_thang") ? $$("filter_thang").getValue() : null;
        const year = $$("filter_nam") ? $$("filter_nam").getValue() : null;
        const tuNgay = $$("filter_tu_ngay") ? $$("filter_tu_ngay").getValue() : null;
        const denNgay = $$("filter_den_ngay") ? $$("filter_den_ngay").getValue() : null;

        const start = 0;
        const count = 50;
        const isListAll = false;

        const filterArr = [];
        if (kyhieu_text && kyhieu_text.trim() !== "") {
            filterArr.push({
                columnName: "kyhieu",
                value: kyhieu_text,
                columnCondition: "=",
                columnType: "string"
            });
        }
        if (mst) {
            filterArr.push({
                columnName: "mst",
                value: mst,
                columnCondition: "=",
                columnType: "string"
            });
        }
        if (tuNgay) {
            filterArr.push({
                columnName: "ngay",
                value: webix.Date.dateToStr("%Y-%m-%d")(tuNgay),
                columnCondition: ">=",
                columnType: "date"
            });
        }
        if (denNgay) {
            filterArr.push({
                columnName: "ngay",
                value: webix.Date.dateToStr("%Y-%m-%d")(denNgay),
                columnCondition: "<=",
                columnType: "date"
            });
        }
        if (month && year && !tuNgay && !denNgay) {
            filterArr.push({
                columnName: "ngay",
                value: `${year}-${String(month).padStart(2, '0')}`,
                columnCondition: "month_year",
                columnType: "date"
            });
        }

        const payload = {
            start,
            count,
            isListAll,
            filter: filterArr,
            tlbparam: "",
        };
        const url = app.config.host.replace(/\/+$/, '') + "/Bangke70/GetData?type=2";
        webix.ajax()
            .headers({ "Content-Type": "application/json" })
            .post(url, payload)
            .then((data) => {
                try {
                    const obj = data.json();
                    if (obj.data) {
                        table.clearAll();
                        table.parse(obj.data);
                        table.config.total_count = obj.total_count || 0;

                        if (!table.count()) {
                            table.showOverlay("<div><img src='assets/imgs/nodata.png'><div class='showOverlaydata'>Không có dữ liệu</div></div>");
                        } else {
                            table.hideOverlay();
                        }
                    } else {
                        webix.message("Không có dữ liệu trả về.");
                        table.clearAll();
                    }
                } catch (e) {
                    webix.message("Lỗi định dạng JSON từ máy chủ.");
                }
            })
            .catch((err) => {
                webix.message("Lỗi khi gọi API. Vui lòng thử lại.");
            });
    };
    const grid = {
        rows: [
            {
                container: "testA",
                view: "datatable",
                id: "bangke",
                select: true,
                resizeColumn: true,
                fullScreen: true,
                leftSplit: 4,
                footer: true,
                columns: gridColumn,
                datafetch: 50,
                pager: "bangkePager",
                on: {
                    "data->onStoreUpdated": function () {
                        this.data.each((obj, i) => obj.stt = i + 1);
                    }
                }
            },
            {
                id: "bangkePager",
                view: "pager",
                size: 50,
                group: 5,
                template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}"
            }
        ]
    };

    const layout = {
        css: "frmView",
        rows: [
            {
                height: 39,
                type: "toolbar",
                css: "btnControl",
                borderless: true,
                cols: controls
            },
            {
                rows: [grid]
            }
        ]
    };

    return {
        $ui: layout,
        $oninit: function () {
            fetchData();
        }
    };
});

define('views/forms/forms70/DangKySD/70_dangkyComponent',[
    "app",
    "locale",
    "models/user",
    "views/modules/minvoiceplugin",
    "views/modules/Component/constantManager",
], function (app, _, user, minvoiceplugin, CONSTANTS) {
    'use strict';

    var id_dangkysudung = "dangkysudung";
    var form_dangkysudung = "form_dangkysudungs";

    var id_dscks = "danhsach_chukyso";
    var id_dsdvitruyennhan = "danhsach_dvitruyennhan";
    var id_dstochuc = "danhsach_tochuc";
    var id_dangkyuynhiem = "danhsach_dangkyuynhiem";

    var name_dsdvitruyennhan = "7. Thông tin đơn vị truyền nhận:";
    var name_dstochuc = "6. Tổ chức cung cấp dịch vụ:";
    var name_dschungthuso = "5. Danh sách chứng thư số sử dụng:";
    var name_dkuynhiem = "5. Đăng ký ủy nhiệm lập biên lai:";
    function validateID(value, config) {
        const cccd = $$("cccdan").getValue().trim();
        const hc = $$("shchieu").getValue().trim();
        if (cccd == "" && hc == "") {
            webix.message("Căn cước công dân và hộ chiếu của người đại diện pháp luật không được đồng thời trống", "error");
            return false;
        }
        return true;
    }
    function validateMST(value) {
        if (!value) {
            return "Mã số thuế không được để trống";
        }
        const regex10 = /^\d{10}$/;
        const regex13 = /^\d{10}-\d{3}$/;
        if (!regex10.test(value) && !regex13.test(value)) {
            return "Mã số thuế không đúng định dạng";
        }
        return true;
    }
    function validateFromToDate(row, fromField = "tngay", toField = "dngay") {
        var from = row[fromField];
        var to = row[toField];
        if (!from || !to) return true;
        var fromDate = (from instanceof Date) ? from : new Date(from);
        var toDate = (to instanceof Date) ? to : new Date(to);
        if (isNaN(fromDate) && typeof from == 'string' && from.length >= 10) {
            fromDate = new Date(from.replace(/-/g, '/').replace('T', ' '));
        }
        if (isNaN(toDate) && typeof to == 'string' && to.length >= 10) {
            toDate = new Date(to.replace(/-/g, '/').replace('T', ' '));
        }

        if (isNaN(fromDate) || isNaN(toDate)) return true;
        if (fromDate > toDate) {
            return `Trường "Từ ngày" phải nhỏ hơn hoặc bằng "Đến ngày"!`;
        }
        return true;
    }
    function validateFields(datatable, rowId, editorColumn, requiredFields, maxLength) {
        const obj = datatable.getItem(rowId);
        let isValid = true;
        let messages = [];
        if (requiredFields[editorColumn] && !webix.rules.isNotEmpty(obj[editorColumn])) {
            messages.push(`Không được để trống trường: "${requiredFields[editorColumn]}"`);
            isValid = false;
        }
        const val = obj[editorColumn] || "";
        if (maxLength[editorColumn] && val.length > maxLength[editorColumn]) {
            const fieldName = requiredFields[editorColumn] || editorColumn;
            messages.push(`Trường "${fieldName}" không được vượt quá ${maxLength[editorColumn]} ký tự (hiện tại: ${val.length} ký tự)`);
            isValid = false;
        }
        if (!isValid) {
            webix.message({
                type: "error",
                text: messages.join("<br>")
            });
        }

        return isValid;
    }
    function createNotEmptyRules(fields) {
        const rules = {};
        fields.forEach(field => {
            rules[field] = webix.rules.isNotEmpty;
        });
        return rules;
    }
    function normalizeDateFields(obj, fields = ["tngay", "dngay"]) {
        fields.forEach(field => {
            if (obj[field] && typeof obj[field] === "string") {
                let dateStr = obj[field].includes("T") ? obj[field] : obj[field].replace(" ", "T");
                const date = new Date(dateStr);
                if (!isNaN(date.getTime())) {
                    obj[field] = date;
                }
            }
        });
    }
    function validateCCCD(value) {
        if (!value || value.trim() == "") return true;
        if (!/^\d{12}$/.test(value)) return "CCCD phải gồm đúng 12 số";
        var first3 = parseInt(value.substr(0, 3), 10);
        var next1 = parseInt(value.substr(3, 1), 10);
        var year2 = value.substr(4, 2);
        if (first3 < 1 || first3 > 99) return "3 số đầu CCCD phải từ 001 đến 099";
        if (next1 < 0 || next1 > 5) return "Số thứ 4 CCCD phải từ 0 đến 5";
        if (parseInt(year2, 10) < 0 || parseInt(year2, 10) > 99) return "2 số tiếp theo phải là năm sinh hợp lệ (00-99)";
        return true;
    }
    var thongtinbienlai = {
        rows: [
            {
                cols: [
                    {},
                    { gravity: 0.25 },
                    {
                        id: "hthuc", name: "hthuc",
                        view: "radio", value: 1,
                        css: "radioRegister",
                        options: [
                            { id: "1", value: "Đăng ký mới" },
                            { id: "2", value: "Thay đổi thông tin" }
                        ],
                    },
                    {}
                ]
            },
            { view: "text", label: "Nơi lập:", css: "mcqtqlyRegister", id: "ddanh", name: "ddanh", required: true, invalidMessage: "Nơi lập không được để trống !", hidden: true },
            { view: "text", label: "Tên người nộp thuế:", name: "tnnt", id: "tnnt", css: "tnntRegister", required: true, invalidMessage: "Tên đơn vị không được để trống !" },
            {
                view: "text", label: "Mã số thuế:", name: "mst", id: "mst", css: "mstRegister", attributes: { maxlength: 13 },
                on: {
                    onSearchIconClick: function () {
                    }
                }
            },
            {
                view: "combo",
                name: "mcqtqly",
                label: "Cơ quan thuế quản lý:",
                id: "mcqtqly",
                css: "mcqtqlyRegister",
                required: true,
                invalidMessage: "Cơ quan thuế quản lý không thể bỏ trống !",
                options: {
                    view: "gridsuggest",
                    scroll: true,
                    autoheight: false,
                    template: "#value#",
                    url: app.config.host + "/Pattern/GetTaxQL",
                    body: {
                        scroll: true,
                        autoheight: false,
                        columns: [
                            { id: "id", header: _("Mã"), width: 80 },
                            { id: "value", header: _("Tên"), width: 400 }
                        ],
                        dataFeed: function (filtervalue, filter) {
                            if (filtervalue.length < 1) {
                                this.load(this.config.url);
                                return;
                            }
                            var pathUrl = app.config.host + "/Pattern/GetTaxQL?";
                            var urldata = "val=" + encodeURIComponent(filtervalue);
                            this.load(pathUrl + urldata, this.config.datatype);
                        }
                    },
                    on: {
                        onValueSuggest: function (obj) {
                        }
                    }
                }
            },
            {
                cols: [
                    { view: "text", label: "Người liên hệ:", css: "mcqtqlyRegister", id: "nlhe", name: "nlhe", attributes: { maxlength: 50 }, required: true, invalidMessage: "Người liên hệ không được để trống !" },
                    { view: "text", label: "Điện thoại liên hệ:", id: "dtlhe", name: "dtlhe", css: "mcqtqlyRegister", attributes: { maxlength: 15 }, required: true, invalidMessage: "Số điện thoại không được để trống !" }
                ]
            },
            {
                cols: [
                    { view: "text", label: "Địa chỉ liên hệ:", css: "mcqtqlyRegister", id: "dclhe", name: "dclhe", attributes: { maxlength: 50 }, required: true, invalidMessage: "Người liên hệ không được để trống !" },
                    {
                        view: "text",
                        label: "Thư điện tử:",
                        id: "dctdtu",
                        name: "dctdtu",
                        css: "mcqtqlyRegister",
                        required: true,
                        validate: function (value) {
                            if (!value) {
                                webix.message("Thư điện tử không được để trống", "error");
                                return false;
                            }
                            var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                            if (!emailRegex.test(value)) {
                                webix.message("Thư điện tử không đúng định dạng", "error");
                                return false;
                            }
                            var countMail = value.split(/[\s,\;]+/);
                            if (countMail.length > 1) {
                                webix.message("Bạn không được phép nhập quá 1 thư điện tử", "error");
                                return false;
                            }
                            return true;
                        },
                    },
                ]
            },
        ]
    };
    var thongtin = {
        rows: [
            {
                cols: [
                    {},
                    { gravity: 0.25 },
                    {
                        id: "hthuc", name: "hthuc",
                        view: "radio", value: 1,
                        css: "radioRegister",
                        options: [
                            { id: "1", value: "Đăng ký mới" },
                            { id: "2", value: "Thay đổi thông tin" }
                        ],
                        on: {
                            onChange: function (newValue, oldValue, config) {
                            }
                        }
                    },
                    {}
                ]
            },
            {
                cols: [
                    { view: "datepicker", name: "nlap", label: "Ngày lập:", id: "nlap", css: "nlapRegister", value: new Date(), width: 280, required: true, invalidMessage: "Ngày lập không được để trống !", validate: webix.rules.isEmpty },
                    { view: "text", label: "Nơi lập:", css: "mcqtqlyRegister", id: "ddanh", name: "ddanh", required: true, invalidMessage: "Nơi lập không được để trống !", validate: webix.rules.isEmpty }

                ]
            },
            { view: "text", label: "Tên người nộp thuế:", name: "tnnt", id: "tnnt", css: "tnntRegister", required: true, invalidMessage: "Tên đơn vị không được để trống !", validate: webix.rules.isEmpty },
            { view: "text", label: "Mã số thuế:", id: "mst", name: "mst", css: "mstRegister",disabled:true, on: { onSearchIconClick: function () { } } },
            {
                view: "combo",
                name: "mcqtqly",
                label: "Cơ quan thuế quản lý:",
                id: "mcqtqly",
                css: "mcqtqlyRegister",
                required: true,
                validate: webix.rules.isEmpty,
                invalidMessage: "Cơ quan thuế quản lý không thể bỏ trống !",
                options: {
                    view: "gridsuggest",
                    scroll: true,
                    autoheight: false,
                    template: "#value#",
                    url: app.config.host + "/Pattern/GetTaxQL",
                    body: {
                        scroll: true,
                        autoheight: false,
                        columns: [
                            { id: "id", header: _("Mã"), width: 80 },
                            { id: "value", header: _("Tên"), width: 400 }
                        ],
                        dataFeed: function (filtervalue, filter) {
                            if (filtervalue.length < 1) {
                                this.load(this.config.url);
                                return;
                            }
                            var pathUrl = app.config.host + "/Pattern/GetTaxQL?";
                            var urldata = "val=" + encodeURIComponent(filtervalue);
                            this.load(pathUrl + urldata, this.config.datatype);
                        }
                    },
                    on: {
                        onValueSuggest: function (obj) {
                        }
                    }
                }
            },
        ]
    };
    var nguoidaidien = {
        rows: [
            {
                cols: [
                    { view: "text", label: "Tên người đại diện:", css: "mcqtqlyRegister", id: "tnddpluat", name: "tnddpluat", attributes: { maxlength: 50 }, required: true, invalidMessage: "Tên người đại diện không được để trống !", validate: webix.rules.isEmpty },
                    { view: "text", label: "Số điện thoại:", id: "dtddpluat", name: "dtddpluat", css: "mcqtqlyRegister", required: true, invalidMessage: "Số điện thoại không được để trống !", validate: webix.rules.isEmpty }

                ]
            },
            {
                cols: [
                    { view: "text", label: "Căn cước công dân:", css: "mcqtqlyRegister", id: "cccdan", name: "cccdan", attributes: { maxlength: 12 }, validate: function (value) { var result = webix.rules.isTaxOrCCCD(value); if (result !== true) { webix.message(result, "error"); return false; } return true; } },
                    { view: "text", label: "Hộ chiếu:", css: "mcqtqlyRegister", id: "shchieu", name: "shchieu", attributes: { maxlength: 20 }, validate: validateID }

                ]
            },
            {
                cols: [
                    {
                        view: "datepicker",
                        label: "Ngày tháng năm sinh:",
                        css: "mcqtqlyRegister",
                        id: "nsddpluat",
                        editable: true,
                        name: "nsddpluat",
                        required: true,
                        validate: function (value) {
                            if (!value) {
                                webix.message("Ngày tháng năm sinh không được để trống!", "error");
                                return false;
                            }
                            var inputDate = value instanceof Date ? value : new Date(value);
                            if (!(inputDate instanceof Date) || isNaN(inputDate.getTime())) {
                                webix.message("Ngày tháng năm sinh phải là ngày hợp lệ, không được nhập chữ!", "error");
                                return false;
                            }
                            var now = new Date();
                            inputDate.setHours(0, 0, 0, 0);
                            now.setHours(0, 0, 0, 0);
                            if (inputDate > now) {
                                webix.message("Ngày tháng năm sinh phải nhỏ hơn hoặc bằng ngày hiện tại!", "error");
                                return false;
                            }
                            return true;
                        },
                        on: {
                            onBlur: function () {
                                var value = this.getValue();
                                if (value instanceof Date && !isNaN(value)) {
                                    this.setValue(value);
                                }
                            }
                        }
                    },
                    {
                        view: "radio",
                        label: "Giới tính:",
                        css: "mcqtqlyRegister",
                        required: true,
                        name: "gtinh",
                        id: "gtinh",
                        options: [
                            { id: "1", value: "Nam" },
                            { id: "0", value: "Nữ" }
                        ],
                        invalidMessage: "Giới tính không được để trống !",
                        validate: function (value) {
                            return value !== undefined && value !== null && value !== "";
                        }
                    }
                ]
            }
        ]
    };
    var nguoilienhe = {
        rows: [
            {
                cols: [
                    { view: "text", label: "Người liên hệ:", css: "mcqtqlyRegister", id: "nlhe", name: "nlhe", required: true, invalidMessage: "Người liên hệ không được để trống !", validate: webix.rules.isEmpty },
                    { view: "text", label: "Điện thoại liên hệ:", id: "dtlhe", name: "dtlhe", css: "mcqtqlyRegister", required: true, invalidMessage: "Điện thoại liên hệ không được để trống !", validate: webix.rules.isEmpty }
                ]
            },
            { view: "text", label: "Địa chỉ liên hệ:", css: "mcqtqlyRegister", id: "dclhe", name: "dclhe", required: true, invalidMessage: "Địa chỉ liên hệ không được để trống !", validate: webix.rules.isEmpty },
            {
                view: "text",
                label: "Thư điện tử:",
                id: "dctdtu",
                name: "dctdtu",
                css: "mcqtqlyRegister",
                required: true,
                validate: function (value) {
                    if (!value) {
                        webix.message("Thư điện tử không được để trống", "error");
                        return false;
                    }
                    var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                    if (!emailRegex.test(value)) {
                        webix.message("Thư điện tử không đúng định dạng", "error");
                        return false;
                    }
                    var countMail = value.split(/[\s,\;]+/);
                    if (countMail.length > 1) {
                        webix.message("Bạn không được phép nhập quá 1 thư điện tử", "error");
                        return false;
                    }
                    return true;
                },
            },
        ]
    };
    var dstochuc = {
        rows: [
            {
                view: "label",
                label: name_dstochuc,
                css: { "font-weight": "bold" }
            },
            {
                cols: [
                    {
                        view: "button",
                        type: "icon",
                        icon: "mdi mdi-plus-box-outline",
                        width: 123,
                        label: "Thêm dòng (F9)",
                        css: "btnForm",
                        on: {
                            onItemClick: function (id, e) {
                                var table = webix.$$(id_dstochuc);
                                var item = { id: webix.uid() };
                                table.add(item);
                                table.select(item.id, "ten_tcgp", false);
                                table.edit({ row: item.id, column: "ten_tcgp" });
                            }
                        }
                    },
                    {
                        view: "button",
                        type: "icon",
                        icon: "mdi mdi-minus-box-outline",
                        width: 115,
                        label: "Xóa dòng (F8)",
                        css: "btnForm",
                        on: {
                            onItemClick: function (id, e) {
                                var table = webix.$$(id_dstochuc);
                                table.editStop();
                                var item = table.getSelectedItem();
                                if (!webix.isUndefined(item)) {
                                    table.remove(item.id);
                                    table.clearSelection();
                                    return;
                                }
                                var editor = table.getEditState();
                                if (!webix.isUndefined(editor)) {
                                    table.remove(editor.row);
                                    table.clearSelection();
                                    return;
                                }
                            },
                        },
                    },
                    {}
                ],
            },
            {
                view: "datatable",
                id: id_dstochuc,
                height: 100,
                name: id_dstochuc,
                select: true,
                resizeColumn: true,
                footer: false,
                tooltip: true,
                editable: true,
                headerRowHeight: 25,
                scheme: {
                    $init: function (obj) {
                        obj._isErrorMessageShown = false;
                        normalizeDateFields(obj);
                    }
                },
                on: {
                    "data->onStoreUpdated": function () {
                        this.data.each(function (obj, i) {
                            obj.stt = i + 1;
                        });
                    },
                    onAfterEditStop: function (state, editor, ignoreUpdate) {
                        if (state.value !== state.old) {
                            if (editor.column == "mst_tcgp") {
                                var result = validateMST(state.value);
                                if (result !== true) {
                                    webix.message(result, "error");
                                    this.edit({ row: editor.row, column: editor.column });
                                    return false;
                                }
                            }
                            const requiredFields = {
                                ten_tcgp: "Tên tổ chức cung cấp dịch vụ",
                                mst_tcgp: "Mã số thuế",
                                tngay: "Thời gian từ ngày",
                                dngay: "Thời gian đến ngày"
                            };

                            const maxLength = {
                                ten_tcgp: 400,
                                mst_tcgp: 14,
                                gchu: 255
                            };
                            validateFields(this, editor.row, editor.column, requiredFields, maxLength);
                        }
                        var row = this.getItem(editor.row);
                        var dateResult = validateFromToDate(row, "tngay", "dngay");
                        if (dateResult !== true) {
                            webix.message(dateResult, "error");
                            this.edit({ row: editor.row, column: editor.column });
                            return false;
                        }
                    },
                    onStoreUpdated: function () {
                        this.data.each(function (item) {
                            item._isErrorMessageShown = false;
                        });
                    },
                },
                rules: createNotEmptyRules(["ten_tcgp", "mst_tcgp", "tngay"]),
                columns: [
                    { id: "stt", name: "stt", header: "STT", sort: "int", width: 40 },
                    {
                        id: "ten_tcgp",
                        name: "ten_tcgp",
                        width: 300,
                        header: "Tên tổ chức cung cấp dịch vụ",
                        editor: "combo",
                        editable: true,
                        suggest: {
                            view: "gridsuggest",
                            scroll: true,
                            autoheight: false,
                            textValue: "id",
                            url: app.config.host + CONSTANTS.API.REGISTER70.GET_GIAIPHAP,
                            body: {
                                scroll: true,
                                autoheight: false,
                                columns: [
                                    { id: "taxcode", header: "MST", width: 80 },
                                    { id: "id", header: _("Tên"), width: 300 }
                                ],
                                dataFeed: function (filtervalue, filter) {
                                    var baseUrl = app.config.host + CONSTANTS.API.REGISTER70.GET_GIAIPHAP;
                                    var urldata = "val=" + encodeURIComponent(filtervalue);
                                    var fullUrl = baseUrl
                                    if (filtervalue) {
                                        fullUrl += '?' + urldata
                                    }
                                    this.load(fullUrl, this.config.datatype);
                                }
                            },
                            on: {
                                onValueSuggest: function (obj) {
                                    var datatable = $$(id_dstochuc);
                                    var editor = datatable.getEditor();
                                    if (!editor) return;
                                    var item = datatable.getItem(editor.row);
                                    item.mst_tcgp = obj.taxcode;
                                    datatable.updateItem(item.id, item);
                                    datatable.editStop();
                                }
                            }
                        }
                    },
                    { id: "mst_tcgp", name: "mst_tcgp", header: "Mã số thuế", width: 200 },
                    { name: "tngay", id: "tngay", header: [{ text: "Thời gian sử dụng dịch vụ", colspan: 2 }, { text: "Từ ngày" }], width: 100, editor: "date", editable: true, format: function (text) { var format = webix.Date.dateToStr("%d/%m/%Y"); return format(text); } },
                    { name: "dngay", id: "dngay", header: [null, { text: "Đến ngày" }], width: 100, editor: "date", editable: true, format: function (text) { var format = webix.Date.dateToStr("%d/%m/%Y"); return format(text); } },
                    { name: "gchu", id: "gchu", width: 200, header: "Ghi chú", editor: "text", editable: true }
                ]
            }
        ]
    };
    var dsdvitruyennhan = {
        rows: [
            {
                view: "label",
                label: name_dsdvitruyennhan,
                css: { "font-weight": "bold" }
            },
            {
                cols: [
                    {
                        view: "button",
                        type: "icon",
                        icon: "mdi mdi-plus-box-outline",
                        width: 123,
                        label: "Thêm dòng (F9)",
                        css: "btnForm",
                        on: {
                            onItemClick: function (id, e) {
                                var table = webix.$$(id_dsdvitruyennhan);
                                var item = { id: webix.uid() };
                                table.add(item);
                                table.select(item.id, "ten_tctn", false);
                                table.edit({ row: item.id, column: "ten_tctn" });
                            }
                        }
                    },
                    {
                        view: "button",
                        type: "icon",
                        icon: "mdi mdi-minus-box-outline",
                        width: 115,
                        label: "Xóa dòng (F8)",
                        css: "btnForm",
                        on: {
                            onItemClick: function (id, e) {
                                var table = webix.$$(id_dsdvitruyennhan);
                                table.editStop();
                                var item = table.getSelectedItem();
                                if (!webix.isUndefined(item)) {
                                    table.remove(item.id);
                                    table.clearSelection();
                                    return;
                                }
                                var editor = table.getEditState();
                                if (!webix.isUndefined(editor)) {
                                    table.remove(editor.row);
                                    table.clearSelection();
                                    return;
                                }
                            },
                        },
                    },
                    {}
                ],
            },
            {
                view: "datatable",
                id: id_dsdvitruyennhan,
                height: 100,
                name: id_dsdvitruyennhan,
                select: true,
                resizeColumn: true,
                footer: false,
                tooltip: true,
                editable: true,
                headerRowHeight: 25,
                scheme: {
                    $init: function (obj) {
                        obj._isErrorMessageShown = false;
                        normalizeDateFields(obj);
                    }
                },
                on: {
                    "data->onStoreUpdated": function () {
                        this.data.each(function (obj, i) {
                            obj.stt = i + 1;
                        });
                    },
                    onAfterEditStop: function (state, editor, ignoreUpdate) {
                        if (state.value !== state.old) {
                            if (editor.column === "mst_tctn") {
                                var result = validateMST(state.value);
                                if (result !== true) {
                                    webix.message(result, "error");
                                    this.edit({ row: editor.row, column: editor.column });
                                    return false;
                                }
                            }
                            const requiredFields = {
                                ten_tctn: "Tên đơn vị",
                                mst_tctn: "Mã số thuế",
                                tngay: "Thời gian từ ngày"
                            };
                            const maxLength = {
                                ten_tctn: 400,
                                mst_tctn: 14,
                                gchu: 255
                            };
                            validateFields(this, editor.row, editor.column, requiredFields, maxLength);
                        }
                        var row = this.getItem(editor.row);
                        var dateResult = validateFromToDate(row, "tngay", "dngay");
                        if (dateResult !== true) {
                            webix.message(dateResult, "error");
                            this.edit({ row: editor.row, column: editor.column });
                            return false;
                        }
                    },
                    onStoreUpdated: function () {
                        this.data.each(function (item) {
                            item._isErrorMessageShown = false;
                        });
                    },
                },
                rules: createNotEmptyRules(["ten_tctn", "mst_tctn", "tngay"]),
                columns: [
                    { id: "stt", name: "stt", header: "STT", sort: "int", width: 40 },
                    {
                        id: "ten_tctn",
                        name: "ten_tctn",
                        width: 300,
                        header: "Tên đơn vị",
                        editor: "combo",
                        editable: true,
                        suggest: {
                            view: "gridsuggest",
                            scroll: true,
                            autoheight: false,
                            url: app.config.host + CONSTANTS.API.REGISTER70.GET_TVAN,
                            body: {
                                scroll: true,
                                autoheight: false,
                                textValue: "id",
                                columns: [
                                    { id: "taxcode", header: "MST", width: 80 },
                                    { id: "id", header: _("Tên"), width: 300 },
                                ],
                                dataFeed: function (filtervalue, filter) {
                                    var baseUrl = app.config.host + CONSTANTS.API.REGISTER70.GET_TVAN;
                                    var urldata = "val=" + encodeURIComponent(filtervalue);
                                    var fullUrl = baseUrl
                                    if (filtervalue) {
                                        fullUrl += '?' + urldata
                                    }
                                    this.load(fullUrl, this.config.datatype);
                                }
                            },
                            on: {
                                onValueSuggest: function (obj) {
                                    var datatable = $$(id_dsdvitruyennhan);
                                    var editor = datatable.getEditor();
                                    if (!editor) return;
                                    var item = datatable.getItem(editor.row);
                                    item.mst_tctn = obj.taxcode;
                                    datatable.updateItem(item.id, item);
                                    datatable.editStop();
                                }
                            }
                        }
                    },
                    { id: "mst_tctn", name: "mst_tctn", header: "Mã số thuế", width: 140 },
                    { name: "tngay", id: "tngay", header: [{ text: "Thời gian sử dụng dịch vụ", colspan: 2 }, { text: "Từ ngày" }], width: 100, editor: "date", editable: true, format: function (text) { var format = webix.Date.dateToStr("%d/%m/%Y"); return format(text); } },
                    { name: "dngay", id: "dngay", header: [null, { text: "Đến ngày" }], width: 100, editor: "date", editable: true, format: function (text) { var format = webix.Date.dateToStr("%d/%m/%Y"); return format(text); } },
                    { name: "gchu", id: "gchu", width: 200, header: "Ghi chú", editor: "text", editable: true }
                ]
            }
        ]
    };
    var dscts = {
        rows: [
            {
                view: "label", label: name_dschungthuso, css: { "font-weight": "bold" }
            },
            {
                cols: [
                    {
                        view: "button",
                        type: "icon",
                        icon: "mdi mdi-plus-box-outline",
                        width: 123,
                        label: "Thêm dòng (F9)",
                        css: "btnForm",
                        on: {
                            onItemClick: function (id, e) {
                                webix.ajax().headers({ 'Content-Type': 'application/json' })
                                    .get(app.config.host + "/Pattern/GetSignType", function (text) {
                                        var result = JSON.parse(text);
                                        var kytaptrung = result[0].gia_tri;
                                        switch (kytaptrung.toUpperCase()) {
                                            case "FILE":
                                                var box = webix.modalbox({
                                                    title: "CHỌN CHỨNG THƯ SỐ",
                                                    buttons: ["Nhận", "Hủy bỏ"],
                                                    text: "<div id='ctnCerts'></div>",
                                                    top: 100,
                                                    width: 750,
                                                    callback: function (result) {
                                                        switch (result) {
                                                            case "1":
                                                                webix.modalbox.hide();
                                                                break;
                                                            case "0":
                                                                var table = $$("tblCerts");
                                                                var data = table.serialize();
                                                                var tableDest = webix.$$(id_dscks);
                                                                var added = false;

                                                                for (var i = 0; i < data.length; i++) {
                                                                    if (data[i].chon === true) {
                                                                        var item = {
                                                                            stt: tableDest.count() + 1,
                                                                            seri: data[i].so_serial,
                                                                            tngay: data[i].ngaybatdau,
                                                                            dngay: data[i].ngayketthuc,
                                                                            ttchuc: data[i].issuer,
                                                                            hthuc: 1
                                                                        };
                                                                        tableDest.add(item);
                                                                        added = true;
                                                                    }
                                                                }

                                                                if (!added) {
                                                                    webix.message("Bạn chưa chọn chứng thư số");
                                                                    return;
                                                                }

                                                                webix.modalbox.hide();
                                                                return;

                                                        }
                                                    }
                                                });
                                                var tblMatHang = webix.ui({
                                                    container: "ctnCerts",
                                                    id: "tblCerts",
                                                    view: "datatable",
                                                    borderless: true,
                                                    resizeColumn: true,
                                                    height: 350,
                                                    columns: [
                                                        {
                                                            id: "chon", header: _("CHON"),
                                                            width: 65, checkValue: true, uncheckValue: false, template: "{common.checkbox()}"
                                                        },
                                                        { id: "so_serial", header: _("SO_SERIAL"), width: 150 },
                                                        { id: "subjectname", header: _("SUBJECTNAME"), width: 450 },
                                                        { id: "ngaybatdau", header: _("NGAY_BAT_DAU"), width: 180 },
                                                        { id: "ngayketthuc", header: _("NGAY_KET_THUC"), width: 180 },
                                                        { id: "issuer", header: _("DONVI"), width: 450 }
                                                    ],
                                                    url: app.config.host + "/Invoice/GetListCertificatesFile"
                                                });
                                                break;
                                            case "EASYCA":
                                                var box = webix.modalbox({
                                                    title: "Chọn chứng thư số EASYCA",
                                                    buttons: ["Nhận", "Hủy bỏ"],
                                                    text: "<div id='ctnCerts'></div>",
                                                    top: 100,
                                                    width: 750,
                                                    callback: function (result) {
                                                        switch (result) {
                                                            case "1":
                                                                webix.modalbox.hide();
                                                                break;
                                                            case "0":
                                                                var table = $$("tblCerts");
                                                                var data = table.serialize();
                                                                var cert = null;
                                                                for (var i = 0; i < data.length; i++) {
                                                                    if (data[i].chon == true) {
                                                                        cert = data[i];
                                                                        break;
                                                                    }
                                                                }
                                                                if (cert == null) {
                                                                    webix.message("Bạn chưa chọn chứng thư số", "debug");
                                                                    return;
                                                                }
                                                                var table = webix.$$(id_dscks);
                                                                var item = {
                                                                    stt: table.count() + 1,
                                                                    seri: cert.so_serial,
                                                                    tngay: cert.ngaybatdau,
                                                                    dngay: cert.ngayketthuc,
                                                                    ttchuc: cert.issuer,
                                                                    hthuc: 1
                                                                };
                                                                table.add(item);
                                                                return;
                                                        }
                                                    }
                                                });
                                                var popupText = document.getElementsByClassName("webix_popup_text")[0];
                                                popupText.style.paddingTop = 0;
                                                var tblMatHang = webix.ui({
                                                    container: "ctnCerts",
                                                    id: "tblCerts",
                                                    view: "datatable",
                                                    borderless: true,
                                                    resizeColumn: true,
                                                    height: 350,
                                                    columns: [
                                                        {
                                                            id: "chon",
                                                            header: _("CHON"),
                                                            width: 65,
                                                            checkValue: true,
                                                            uncheckValue: false,
                                                            template: "{common.checkbox()}"
                                                        },
                                                        { id: "libraryName", header: _("Loại"), width: 150 },
                                                        { id: "so_serial", header: _("SO_SERIAL"), width: 150 },
                                                        { id: "subjectname", header: _("SUBJECTNAME"), width: 450 },
                                                        { id: "ngaybatdau", header: _("NGAY_BAT_DAU"), width: 180 },
                                                        { id: "ngayketthuc", header: _("NGAY_KET_THUC"), width: 180 },
                                                        { id: "issuer", header: _("DONVI"), width: 450 }
                                                    ],
                                                    url: app.config.host + "/Invoice/GetListCertificatesEasyCA"
                                                });
                                                break;
                                            case "ICA":
                                                var box = webix.modalbox({
                                                    title: "Chọn chứng thư số ICA",
                                                    buttons: ["Nhận", "Hủy bỏ"],
                                                    text: "<div id='ctnCerts'></div>",
                                                    top: 100,
                                                    width: 750,
                                                    callback: function (result) {
                                                        switch (result) {
                                                            case "1":
                                                                webix.modalbox.hide();
                                                                break;
                                                            case "0":
                                                                var table = $$("tblCerts");
                                                                var data = table.serialize();
                                                                var cert = null;
                                                                for (var i = 0; i < data.length; i++) {
                                                                    if (data[i].chon == true) {
                                                                        cert = data[i];
                                                                        break;
                                                                    }
                                                                }
                                                                if (cert == null) {
                                                                    webix.message("Bạn chưa chọn chứng thư số", "debug");
                                                                    return;
                                                                }
                                                                var table = webix.$$(id_dscks);
                                                                var item = {
                                                                    stt: table.count() + 1,
                                                                    seri: cert.so_serial,
                                                                    tngay: cert.ngaybatdau,
                                                                    dngay: cert.ngayketthuc,
                                                                    ttchuc: cert.issuer,
                                                                    hthuc: 1
                                                                };
                                                                table.add(item);
                                                                return;
                                                        }
                                                    }
                                                });
                                                var popupText = document.getElementsByClassName("webix_popup_text")[0];
                                                popupText.style.paddingTop = 0;
                                                var tblMatHang = webix.ui({
                                                    container: "ctnCerts",
                                                    id: "tblCerts",
                                                    view: "datatable",
                                                    borderless: true,
                                                    resizeColumn: true,
                                                    height: 350,
                                                    columns: [
                                                        {
                                                            id: "chon",
                                                            header: _("CHON"),
                                                            width: 65,
                                                            checkValue: true,
                                                            uncheckValue: false,
                                                            template: "{common.checkbox()}"
                                                        },
                                                        { id: "libraryName", header: _("Loại"), width: 150 },
                                                        { id: "so_serial", header: _("SO_SERIAL"), width: 150 },
                                                        { id: "subjectname", header: _("SUBJECTNAME"), width: 450 },
                                                        { id: "ngaybatdau", header: _("NGAY_BAT_DAU"), width: 200 },
                                                        { id: "ngayketthuc", header: _("NGAY_KET_THUC"), width: 200 },
                                                        { id: "issuer", header: _("DONVI"), width: 450 }
                                                    ],
                                                    url: app.config.host + "/Invoice/GetListCertificatesAuto"
                                                });
                                                break;
                                            case "NCCA":
                                                var box = webix.modalbox({
                                                    title: "Chọn chứng thư số NCCA",
                                                    buttons: ["Nhận", "Hủy bỏ"],
                                                    text: "<div id='ctnCerts'></div>",
                                                    top: 100,
                                                    width: 750,
                                                    callback: function (result) {
                                                        switch (result) {
                                                            case "1":
                                                                webix.modalbox.hide();
                                                                break;
                                                            case "0":
                                                                var table = $$("tblCerts");
                                                                var data = table.serialize();
                                                                var cert = null;
                                                                for (var i = 0; i < data.length; i++) {
                                                                    if (data[i].chon == true) {
                                                                        cert = data[i];
                                                                        break;
                                                                    }
                                                                }
                                                                if (cert == null) {
                                                                    webix.message("Bạn chưa chọn chứng thư số", "debug");
                                                                    return;
                                                                }
                                                                var table = webix.$$(id_dscks);
                                                                var item = {
                                                                    stt: table.count() + 1,
                                                                    seri: cert.so_serial,
                                                                    tngay: cert.ngaybatdau,
                                                                    dngay: cert.ngayketthuc,
                                                                    ttchuc: cert.issuer,
                                                                    hthuc: 1
                                                                };
                                                                table.add(item);
                                                                return;
                                                        }
                                                    }
                                                });
                                                var popupText = document.getElementsByClassName("webix_popup_text")[0];
                                                popupText.style.paddingTop = 0;
                                                var tblMatHang = webix.ui({
                                                    container: "ctnCerts",
                                                    id: "tblCerts",
                                                    view: "datatable",
                                                    borderless: true,
                                                    resizeColumn: true,
                                                    height: 350,
                                                    columns: [
                                                        {
                                                            id: "chon",
                                                            header: _("CHON"),
                                                            width: 65,
                                                            checkValue: true,
                                                            uncheckValue: false,
                                                            template: "{common.checkbox()}"
                                                        },
                                                        { id: "libraryName", header: _("Loại"), width: 150 },
                                                        { id: "so_serial", header: _("SO_SERIAL"), width: 150 },
                                                        { id: "subjectname", header: _("SUBJECTNAME"), width: 450 },
                                                        { id: "ngaybatdau", header: _("NGAY_BAT_DAU"), width: 200 },
                                                        { id: "ngayketthuc", header: _("NGAY_KET_THUC"), width: 200 },
                                                        { id: "issuer", header: _("DONVI"), width: 450 }
                                                    ],
                                                    url: app.config.host + "/Invoice/GetListCertificatesAuto"
                                                });
                                                break;
                                            case "K":
                                                var hub = minvoiceplugin.hub();
                                                var hubconnect = minvoiceplugin.conn();
                                                if (hubconnect.state != 1) {
                                                    var form = webix.$$("chukyso-form");
                                                    form.enable();
                                                    form.hideProgress();
                                                    webix.message("Quý khách hàng chưa cài Plugin ký hóa đơn hoặc Plugin ký hóa đơn chưa được bật !", "error");
                                                    return;
                                                }
                                                else {
                                                    hub.off("resCommand");
                                                    hub.on("resCommand", function (response) {
                                                        var result = JSON.parse(response);
                                                        if (result.hasOwnProperty("error")) {
                                                            webix.message(result.error, "error");
                                                        } else {
                                                            var table = webix.$$(id_dscks);
                                                            var item = {
                                                                stt: table.count() + 1,
                                                                seri: result.data.so_serial,
                                                                tngay: result.data.ngaybatdau,
                                                                dngay: result.data.ngayketthuc,
                                                                ttchuc: result.data.issuer,
                                                                hthuc: 1
                                                            };
                                                            table.add(item);
                                                        }
                                                    });
                                                    var f = {
                                                        callback: "RegisterCert"
                                                    };
                                                    hub.invoke("execCommand", f.callback, JSON.stringify(f));
                                                }
                                                break;
                                            case "INTRUSTCA":
                                                var box = webix.modalbox({
                                                    title: "Chọn chứng thư số IntrustCa",
                                                    buttons: ["Nhận", "Hủy bỏ"],
                                                    text: "<div id='ctnCerts'></div>",
                                                    top: 100,
                                                    width: 750,
                                                    callback: function (result) {
                                                        switch (result) {
                                                            case "1":
                                                                webix.modalbox.hide();
                                                                break;
                                                            case "0":
                                                                var table = $$("tblCerts");
                                                                var data = table.serialize();
                                                                var cert = [];
                                                                for (var i = 0; i < data.length; i++) {
                                                                    if (data[i].chon == true)
                                                                        cert.push(data[i]);
                                                                }
                                                                if (cert.length == 0) {
                                                                    webix.message("Bạn chưa chọn chứng thư số", "debug");
                                                                    return;
                                                                }
                                                                var table = webix.$$(id_dscks);
                                                                cert.forEach((element) => {
                                                                    var item = {
                                                                        stt: table.count() + 1,
                                                                        seri: element.so_serial,
                                                                        tngay: element.ngaybatdau,
                                                                        dngay: element.ngayketthuc,
                                                                        ttchuc: element.issuer,
                                                                        hthuc: 1
                                                                    };
                                                                    table.add(item);
                                                                })
                                                                return;
                                                        }
                                                    }
                                                });
                                                var popupText = document.getElementsByClassName("webix_popup_text")[0];
                                                popupText.style.paddingTop = 0;
                                                var cert = webix.ui({
                                                    container: "ctnCerts",
                                                    id: "tblCerts",
                                                    view: "datatable",
                                                    borderless: true,
                                                    resizeColumn: true,
                                                    height: 350,
                                                    columns: [
                                                        {
                                                            id: "chon",
                                                            header: _("CHON"),
                                                            width: 60,
                                                            checkValue: true,
                                                            uncheckValue: false,
                                                            template: "{common.checkbox()}"
                                                        },
                                                        { id: "libraryName", header: _("Loại"), width: 150 },
                                                        { id: "so_serial", header: _("SO_SERIAL"), width: 250 },
                                                        { id: "subjectname", header: _("SUBJECTNAME"), width: 300 },
                                                        { id: "ngaybatdau", header: _("NGAY_BAT_DAU"), width: 180 },
                                                        { id: "ngayketthuc", header: _("NGAY_KET_THUC"), width: 180 },
                                                        { id: "issuer", header: _("DONVI"), width: 450 }
                                                    ],
                                                    url: app.config.host + "/Invoice/GetListCertificatesAuto",
                                                });
                                                break;
                                            case "VNET":
                                                var box = webix.modalbox({
                                                    title: "Chọn chứng thư số Vnet",
                                                    buttons: ["Nhận", "Hủy bỏ"],
                                                    text: "<div id='ctnCerts'></div>",
                                                    top: 100,
                                                    width: 750,
                                                    callback: function (result) {
                                                        switch (result) {
                                                            case "1":
                                                                webix.modalbox.hide();
                                                                break;
                                                            case "0":
                                                                var table = $$("tblCerts");
                                                                var data = table.serialize();
                                                                var cert = [];
                                                                for (var i = 0; i < data.length; i++) {
                                                                    if (data[i].chon == true)
                                                                        cert.push(data[i]);
                                                                }

                                                                if (cert.length == 0) {
                                                                    webix.message("Bạn chưa chọn chứng thư số", "debug");
                                                                    return;
                                                                }
                                                                var table = webix.$$(id_dscks);
                                                                cert.forEach((element) => {
                                                                    var item = {
                                                                        stt: table.count() + 1,
                                                                        seri: element.so_serial,
                                                                        tngay: element.ngaybatdau,
                                                                        dngay: element.ngayketthuc,
                                                                        ttchuc: element.issuer,
                                                                        hthuc: 1
                                                                    };
                                                                    table.add(item);
                                                                })
                                                                return;
                                                        }
                                                    }
                                                });
                                                var popupText = document.getElementsByClassName("webix_popup_text")[0];
                                                popupText.style.paddingTop = 0;
                                                var cert = webix.ui({
                                                    container: "ctnCerts",
                                                    id: "tblCerts",
                                                    view: "datatable",
                                                    borderless: true,
                                                    resizeColumn: true,
                                                    height: 350,
                                                    columns: [
                                                        {
                                                            id: "chon",
                                                            header: _("CHON"),
                                                            width: 60,
                                                            checkValue: true,
                                                            uncheckValue: false,
                                                            template: "{common.checkbox()}"
                                                        },
                                                        { id: "libraryName", header: _("Loại"), width: 150 },
                                                        { id: "so_serial", header: _("SO_SERIAL"), width: 250 },
                                                        { id: "subjectname", header: _("SUBJECTNAME"), width: 300 },
                                                        { id: "ngaybatdau", header: _("NGAY_BAT_DAU"), width: 180 },
                                                        { id: "ngayketthuc", header: _("NGAY_KET_THUC"), width: 180 },
                                                        { id: "issuer", header: _("DONVI"), width: 450 }
                                                    ],
                                                    url: app.config.host + "/Invoice/GetListCertificatesAuto",
                                                });
                                                break;
                                        }
                                    });
                            }
                        }
                    },
                    {
                        view: "button",
                        type: "icon",
                        icon: "mdi mdi-minus-box-outline",
                        width: 115,
                        label: "Xóa dòng (F8)",
                        css: "btnForm",
                        on: {
                            onItemClick: function (id, e) {
                                var table = webix.$$(id_dscks);
                                table.editStop();
                                var item = table.getSelectedItem();
                                if (!webix.isUndefined(item)) {
                                    table.remove(item.id);
                                    table.clearSelection();
                                    return;
                                }
                                var editor = table.getEditState();
                                if (!webix.isUndefined(editor)) {
                                    table.remove(editor.row);
                                    table.clearSelection();
                                    return;
                                }
                            },
                        },
                    },
                    {}
                ],
            },
            {
                view: "datatable",
                id: id_dscks,
                height: 100,
                name: id_dscks,
                select: true,
                resizeColumn: true,
                footer: false,
                tooltip: true,
                editable: true,
                headerRowHeight: 25,
                scheme: {
                    $init: function (obj) {

                    },
                },
                on: {

                },
                columns: [
                    { id: "stt", name: "stt", header: "STT", sort: "int", width: 40 },
                    { id: "ttchuc", name: "ttchuc", width: 250, header: "Tên tổ chức cơ quan" },
                    { id: "seri", name: "seri", header: "Số sê-ri chứng thư số", width: 300 },
                    { id: "tngay", name: "tngay", header: [{ text: "Thời hạn sử dụng chứng thư số", colspan: 2 }, { text: "Từ ngày" }], width: 150 },
                    { id: "dngay", name: "dngay", header: [null, { text: "Đến ngày" }], width: 150 },
                    { id: "hthuc", name: "hthuc", width: 130, header: "Hình thức đăng ký", editor: "combo", options: [{ id: "1", value: "Thêm mới" }, { id: "2", value: "Gia hạn" }, { id: "3", value: "Ngừng sử dụng" }] }
                ]
            }
        ]
    };
    var dkyuynhiem = {
        rows: [
            {
                view: "label", label: name_dkuynhiem, css: { "font-weight": "bold" }
            },
            {
                cols: [
                    {
                        view: "button",
                        type: "icon",
                        icon: "mdi mdi-plus-box-outline",
                        width: 123,
                        label: "Thêm dòng (F9)",
                        css: "btnForm",
                        on: {
                            onItemClick: function (id, e) {
                                var table = webix.$$(id_dangkyuynhiem);
                                var item = { id: webix.uid() };
                                table.add(item);
                            }
                        }
                    },
                    {
                        view: "button",
                        type: "icon",
                        icon: "mdi mdi-minus-box-outline",
                        width: 115,
                        label: "Xóa dòng (F8)",
                        css: "btnForm",
                        on: {
                            onItemClick: function (id, e) {
                                var table = webix.$$(id_dangkyuynhiem);
                                table.editStop();
                                var item = table.getSelectedItem();
                                if (!webix.isUndefined(item)) {
                                    table.remove(item.id);
                                    table.clearSelection();
                                    return;
                                }
                                var editor = table.getEditState();
                                if (!webix.isUndefined(editor)) {
                                    table.remove(editor.row);
                                    table.clearSelection();
                                    return;
                                }
                            },
                        },
                    },
                    {}
                ],
            },
            {
                view: "datatable",
                id: id_dangkyuynhiem,
                height: 150,
                name: id_dangkyuynhiem,
                select: true,
                resizeColumn: true,
                footer: false,
                tooltip: true,
                editable: true,
                headerRowHeight: 80,
                scheme: {
                    $init: function (obj) {
                        obj._isErrorMessageShown = false;
                        normalizeDateFields(obj);
                    },
                },
                on: {
                    "data->onStoreUpdated": function () {
                        this.data.each(function (obj, i) {
                            obj.stt = i + 1;
                        });
                    },
                    onAfterEditStop: function (state, editor, ignoreUpdate) {
                        if (state.value !== state.old) {
                            if (editor.column === "mst") {
                                var result = validateMST(state.value);
                                if (result !== true) {
                                    webix.message(result, "error");
                                    this.edit({ row: editor.row, column: editor.column });
                                    return false;
                                }
                            }
                            const requiredFields = {
                                tlctu: "Tên loại biên lai ủy nhiệm",
                                khieu_mctu: "Ký hiệu mẫu hóa biên lai ủy nhiệm",
                                khieu_ctu: "Ký hiệu hóa đơn tích hợp",
                                ttchuc: "Tên tổ chức được ủy nhiệm/tổ chức ủy nhiệm",
                                mst: "Mã số thuế",
                                mdich: "Mục đích ủy nhiệm",
                                tngay: "Từ ngày",
                                pthuc: "Phương thức thanh toán biên lai ủy nhiệm",
                                ldkunhiem: "Loại đăng ký ủy nhiệm"
                            };

                            const maxLength = {
                                tlctu: 100,
                                khieu_mctu: 10,
                                khieu_ctu: 9,
                                ttchuc: 400,
                                mst: 13,
                                mdich: 255,
                                pthuc: 50
                            };
                            validateFields(this, editor.row, editor.column, requiredFields, maxLength);
                        }
                        var row = this.getItem(editor.row);
                        var dateResult = validateFromToDate(row, "tngay", "dngay");
                        if (dateResult !== true) {
                            webix.message(dateResult, "error");
                            this.edit({ row: editor.row, column: editor.column });
                            return false;
                        }
                    },
                    onStoreUpdated: function () {
                        this.data.each(function (item) {
                            item._isErrorMessageShown = false;
                        });
                    },
                },
                columns: [
                    { id: "stt", name: "stt", header: "STT", sort: "int", width: 40, },
                    { id: "tlctu", name: "tlctu", width: 150, header: [{ text: "Tên loại biên lai ủy nhiệm", css: "multilineColumn" }], editor: "text", editable: true, attributes: { maxlength: 100 } },
                    { id: "khieu_mctu", name: "khieu_mctu", width: 90, header: [{ text: "Ký hiệu mẫu biên lai ủy nhiệm", css: "multilineColumn" }], editor: "text", editable: true, attributes: { maxlength: 10 } },
                    { id: "khieu_ctu", name: "khieu_ctu", width: 100, header: [{ text: "Ký hiệu hóa đơn tích hợp", css: "multilineColumn" }], editor: "text", editable: true, attributes: { maxlength: 9 } },
                    { id: "ttchuc", name: "ttchuc", width: 200, header: [{ text: "Tên tổ chức được ủy nhiệm/tổ chức ủy nhiệm", css: "multilineColumn" }], editor: "text", editable: true, attributes: { maxlength: 400 } },
                    { id: "mst", name: "mst", header: "Mã số thuế", width: 140, editor: "text", editable: true, attributes: { maxlength: 13 } },
                    { id: "mdich", name: "mdich", header: "Mục đích ủy nhiệm", width: 200, editor: "text", editable: true, attributes: { maxlength: 255 } },
                    { name: "tngay", id: "tngay", header: "Từ ngày", width: 100, editor: "date", editable: true, format: function (text) { var format = webix.Date.dateToStr("%d/%m/%Y"); return format(text); }, attributes: { maxlength: 10 } },
                    { name: "dngay", id: "dngay", header: "Đến ngày", width: 100, editor: "date", editable: true, format: function (text) { var format = webix.Date.dateToStr("%d/%m/%Y"); return format(text); }, attributes: { maxlength: 10 } },
                    { id: "pthuc", name: "pthuc", header: [{ text: "Phương thức thanh toán biên lai ủy nhiệm", css: "multilineColumn" }], width: 100, editor: "text", editable: true, attributes: { maxlength: 50 } },
                    {
                        id: "ldkunhiem", name: "ldkunhiem", width: 130, header: "Loại đăng ký ủy nhiệm", editor: "combo",
                        options: [
                            { id: "1", value: "Ủy nhiệm" },
                            { id: "2", value: "Nhận ủy nhiệm" },
                        ]
                    }
                ]
            }
        ]
    };

    return {
        id_dangkysudung: id_dangkysudung,
        form_dangkysudung: form_dangkysudung,
        id_dscks: id_dscks,
        id_dsdvitruyennhan: id_dsdvitruyennhan,
        id_dstochuc: id_dstochuc,
        id_dangkyuynhiem: id_dangkyuynhiem,
        name_dsdvitruyennhan: name_dsdvitruyennhan,
        name_dstochuc: name_dstochuc,
        name_dschungthuso: name_dschungthuso,
        thongtin: thongtin,
        thongtinbienlai: thongtinbienlai,
        nguoidaidien: nguoidaidien,
        nguoilienhe: nguoilienhe,
        dstochuc: dstochuc,
        dsdvitruyennhan: dsdvitruyennhan,
        dscts: dscts,
        dkyuynhiem: dkyuynhiem,
        validateID: validateID,
        validateMST: validateMST
    };
});
define('views/forms/forms70/DangKySD/70_dangkyForm',[
    "app",
    "locale",
    "models/user",
    "views/modules/minvoiceplugin",
    "views/modules/Component/constantManager",
    "views/forms/forms70/DangKySD/70_dangkyComponent"
], function (app, _, user, minvoiceplugin, CONSTANTS, dangkyComponent) {
    'use strict';

    webix.$$("title").parse({ title: "Đăng ký sử dụng", details: "Đăng ký sử dụng" });
    var editmode = 0;

    var id_dangkysudung = dangkyComponent.id_dangkysudung;
    var form_dangkysudung = dangkyComponent.form_dangkysudung;

    var id_dscks = dangkyComponent.id_dscks;
    var id_dsdvitruyennhan = dangkyComponent.id_dsdvitruyennhan;
    var id_dstochuc = dangkyComponent.id_dstochuc;
    var name_dstochuc = "6. Tổ chức cung cấp dịch vụ:";
    var name_dsdvitruyennhan = "7. Thông tin đơn vị truyền nhận:";

    var thongtin = dangkyComponent.thongtin;
    var nguoidaidien = dangkyComponent.nguoidaidien;
    var nguoilienhe = dangkyComponent.nguoilienhe;
    var dstochuc = dangkyComponent.dstochuc;
    var dsdvitruyennhan = dangkyComponent.dsdvitruyennhan;
    var dscts = dangkyComponent.dscts;

    function validateTables(tables) {
        for (var i = 0; i < tables.length; i++) {
            var tableInfo = tables[i];
            var table = $$(tableInfo.id);
            if (table) {
                table.editStop();
                if (!table.validate()) {
                    webix.message({ type: "error", text: "Dữ liệu bảng '" + tableInfo.name + "' chưa đủ thông tin, vui lòng kiểm tra lại" });
                    return false;
                }
                var data = table.serialize();
                for (var j = 0; j < data.length; j++) {
                    var row = data[j];
                    if (row.mst_tcth) {
                        var mstResult = dangkyComponent.validateMST(row.mst_tcth);
                        if (mstResult !== true) {
                            webix.message({ type: "error", text: "Mã số thuế không đúng định dạng ở dòng " + (j + 1) + " của bảng '" + tableInfo.name + "'" });
                            table.select(row.id);
                            table.showItem(row.id);
                            return false;
                        }
                    }
                    if (row.mst_tcgp) {
                        var mstResult = dangkyComponent.validateMST(row.mst_tcgp);
                        if (mstResult !== true) {
                            webix.message({ type: "error", text: "Mã số thuế không đúng định dạng ở dòng " + (j + 1) + " của bảng '" + tableInfo.name + "'" });
                            table.select(row.id);
                            table.showItem(row.id);
                            return false;
                        }
                    }
                    if (row.mst_dvht) {
                        var mstResult = dangkyComponent.validateMST(row.mst_dvht);
                        if (mstResult !== true) {
                            webix.message({ type: "error", text: "Mã số thuế không đúng định dạng ở dòng " + (j + 1) + " của bảng '" + tableInfo.name + "'" });
                            table.select(row.id);
                            table.showItem(row.id);
                            return false;
                        }
                    }
                    if (row.mst_tctn) {
                        var mstResult = dangkyComponent.validateMST(row.mst_tctn);
                        if (mstResult !== true) {
                            webix.message({ type: "error", text: "Mã số thuế không đúng định dạng ở dòng " + (j + 1) + " của bảng '" + tableInfo.name + "'" });
                            table.select(row.id);
                            table.showItem(row.id);
                            return false;
                        }
                    }
                }
            }
        }
        return true;
    }
    return {
        $ui: {
            view: "window",
            modal: true,
            position: function (state) {
                state.width = state.maxWidth * 0.6;
                state.height = state.maxHeight * 0.9;
                state.left = (state.maxWidth - state.width) / 2;
                state.top = (state.maxHeight - state.height) / 2;
            },
            css: "headformchil",
            id: form_dangkysudung,
            resize: true,
            fullscreen: true,
            move: true,
            head: false,
            on: {
                onShow: function () {
                    var self = this;
                    if (editmode == 1) {
                        var minvoiceGiaiphap = {
                            id: webix.uid(),
                            ten_tcgp: "CÔNG TY TNHH HÓA ĐƠN ĐIỆN TỬ M-INVOICE",
                            mst_tcgp: "0106026495",
                            tngay: new Date(),
                            dngay: "",
                            gchu: ""
                        };
                        var minvoiceTruyennhan = {
                            id: webix.uid(),
                            ten_tctn: "CÔNG TY TNHH HÓA ĐƠN ĐIỆN TỬ M-INVOICE",
                            mst_tctn: "0106026495",
                            tngay: new Date(),
                            dngay: "",
                            gchu: ""
                        };
                        var tableGiaiphap = $$("danhsach_tochuc");
                        var tableTruyennhan = $$("danhsach_dvitruyennhan");
                        if (tableGiaiphap.count() === 0) tableGiaiphap.add(minvoiceGiaiphap);
                        if (tableTruyennhan.count() === 0) tableTruyennhan.add(minvoiceTruyennhan);
                    }
                    $(".webix_modal").one("click", function () {
                        self.close();
                    });
                }
            },
            body: {
                view: "form",
                id: id_dangkysudung,
                position: "center",
                elementsConfig: { labelWidth: 150 },
                paddingY: 10,
                paddingX: 15,
                complexData: true,
                scroll: true,
                margin: 0,
                elements: [
                    {
                        view: "label", template: function (obj) { return "<div class='headRegisters'>TỜ KHAI</div>"; }
                    },
                    {
                        view: "label", template: function (obj) { return "<div class='headRegister'>Đăng ký/Thay đổi thông tin sử dụng hóa đơn điện tử</div>"; }
                    },
                    thongtin,
                    { height: 8 },
                    {
                        view: "label", css: "lblResgister", template: function () {
                            return `<div><i class='mdi mdi-18px mdi-lightbulb-on-10'></i>
                            <i>Thông tin người đại diện pháp luật phục vụ <b>Xác thực sinh trắc học</b>
                             trên hệ thống phần mềm của CQT.</i></div>`;
                        }
                    },
                    { height: 5 },
                    nguoidaidien,
                    {
                        view: "label", css: "lblResgister", template: function () {
                            return `<div><i class='mdi mdi-18px mdi-lightbulb-on-10'></i>
                            <i>Sau khi tờ khai được <b>chấp nhận</b>, cơ quan thuế sẽ <b>gửi các thông báo quan trọng</b>
                             liên quan đến hóa đơn điện tử tới email/số điện thoại/địa chỉ này.</i></div>`;
                        }
                    },
                    { height: 5 },
                    nguoilienhe,
                    {
                        view: "label", autoheight: true, css: "lblResgisterMess", template: function () {
                            return `<div><span>Theo nghị định số 123/2020/NĐ-CP ngày 19 tháng 10 năm 2020 của chính phủ,
                             chúng tôi/tôi thuộc đối tượng sử dụng hóa đơn điện tử.
                             Chúng tôi/tôi đăng ký/thay đổi thông tin đã đăng ký với cơ quan thuế về việc sử dụng hóa đơn điện tử như sau:</span></div>`;
                        }
                    },
                    {
                        rows: [
                            { view: "label", label: "<b>1. Hình thức hóa đơn:</b>" },
                            {
                                view: "checkbox",
                                id: "cma",
                                name: "cma",
                                labelRight: "Có mã của cơ quan thuế",
                                labelWidth: 0,
                                on: {
                                    onChange: function (newv, oldv) {
                                        if (newv == 1) {
                                            $$("cddu").setValue(1);
                                            $$("cdlttdcqt").disable();
                                            $$("cdlqtvan").disable();
                                            $$("nntdbkkhan").disable();
                                            $$("nntktdnubnd").disable();
                                            $$("cqxltscong").disable();
                                        }
                                        else {
                                            $$("cddu").setValue(0);
                                            $$("cdlttdcqt").enable();
                                            $$("cdlqtvan").enable();
                                            $$("nntdbkkhan").enable();
                                            $$("nntktdnubnd").enable();
                                            $$("cqxltscong").enable();
                                        }
                                    }
                                }
                            },
                            {
                                view: "checkbox", id: "cmtmttien", name: "cmtmttien",
                                labelRight: "Có mã của cơ quan thuế (Khởi tạo từ máy tính tiền)", labelWidth: 0,
                                on: {
                                    onChange: function (newv, oldv) {
                                        if (newv == 1) {
                                            $$("cdlttdcqt").disable();
                                            $$("cdlqtvan").disable();
                                            $$("nntdbkkhan").disable();
                                            $$("nntktdnubnd").disable();
                                            $$("cqxltscong").disable();
                                        } else {
                                            $$("cdlttdcqt").enable();
                                            $$("cdlqtvan").enable();
                                            $$("nntdbkkhan").enable();
                                            $$("nntktdnubnd").enable();
                                            $$("cqxltscong").enable();
                                        }
                                    }
                                }
                            },
                            {
                                view: "checkbox",
                                id: "kcma",
                                name: "kcma",
                                labelRight: "Không có mã của cơ quan thuế",
                                labelWidth: 0,
                                on: {
                                    onChange: function (newv, oldv) {
                                        if (newv == 1) {
                                            $$("cddu").setValue(1);
                                            $$("cdlqtvan").setValue(1);
                                            $$("cdlttdcqt").disable();
                                            $$("cdlqtvan").disable();
                                            $$("nntdbkkhan").disable();
                                            $$("nntktdnubnd").disable();
                                            $$("cqxltscong").disable();
                                        }
                                        else {
                                            $$("cddu").setValue(0);
                                            $$("cdlqtvan").setValue(0);
                                            $$("cdlttdcqt").enable();
                                            $$("cdlqtvan").enable();
                                            $$("nntdbkkhan").enable();
                                            $$("nntktdnubnd").enable();
                                            $$("cqxltscong").enable();
                                        }
                                    }
                                }
                            },
                            { view: "label", label: "<b>2. Hình thức gửi dữ liệu hóa đơn điện tử:</b>" },
                            {
                                view: "label", css: "lblResgister", template: function () {
                                    return `<div><i class='mdi mdi-18px mdi-lightbulb-on-10'></i>
                                    <i>Vui lòng bỏ qua nếu bạn không thuộc đối tượng nào trong các đối tượng dưới đây.</i></div>`;
                                }
                            },
                            {
                                view: "label", template: function () {
                                    return `<div>a. Trường hợp sử dụng hóa đơn điện tử có mã không phải trả tiền dịch vụ theo khoản 1 Điều 14 của Nghị định:</div>`;
                                }
                            },
                            {
                                view: "checkbox",
                                id: "nntdbkkhan",
                                name: "nntdbkkhan",
                                css: "lblCheckbox",
                                autoheight: true,
                                labelRight: "Doanh nghiệp nhỏ và vừa, hợp tác xã, hộ, cá nhân kinh doanh tại địa bàn có điều kiện kinh tế xã hội khó khăn, địa bàn có điều kiện kinh tế xã hội đặc biệt khó khăn.",
                                labelWidth: 0,
                                on: {
                                    onChange: function (newv, oldv) {
                                        if (newv == 1) {
                                            $$("nntdbkkhan").setValue(1);
                                            $$("cdlttdcqt").setValue(0);
                                            $$("cdlqtvan").setValue(0);
                                            $$("nntktdnubnd").setValue(0);
                                            $$("cqxltscong").setValue(0);
                                        }
                                    }
                                }
                            },
                            {
                                view: "checkbox",
                                id: "nntktdnubnd",
                                name: "nntktdnubnd",
                                css: "lblCheckbox",
                                labelRight: "Doanh nghiệp nhỏ và vừa khác theo đề nghị của Ủy ban nhân dân tỉnh, thành phố trực thuộc trung ương gửi Bộ Tài chính trừ doanh nghiệp hoạt động tại các khu kinh tế, khu công nghiệp, khu công nghệ ca.",
                                labelWidth: 0,
                                on: {
                                    onChange: function (newv, oldv) {
                                        if (newv == 1) {
                                            $$("nntktdnubnd").setValue(1);
                                            $$("cdlttdcqt").setValue(0);
                                            $$("cdlqtvan").setValue(0);
                                            $$("nntdbkkhan").setValue(0);
                                            $$("cqxltscong").setValue(0);

                                        }
                                    }
                                }
                            },
                            {
                                view: "checkbox",
                                id: "cqxltscong",
                                name: "cqxltscong",
                                labelRight: "Cơ quan thuế hoặc cơ quan được giao nhiệm vụ tổ chức, xử lý tài sản công theo quy định pháp luật về quản lý, sử dụng tài sản công.",
                                labelWidth: 0,
                                on: {
                                    onChange: function (newv, oldv) {
                                        if (newv == 1) {
                                            $$("cqxltscong").setValue(1);
                                            $$("cdlttdcqt").setValue(0);
                                            $$("cdlqtvan").setValue(0);
                                            $$("nntdbkkhan").setValue(0);
                                            $$("nntktdnubnd").setValue(0);
                                        }
                                    }
                                }
                            },
                            {
                                view: "label", template: function () {
                                    return `<div>b. Trường hợp sử dụng hóa đơn điện tử không có mã của cơ quan thuế:</div>`;
                                }
                            },
                            {
                                view: "checkbox",
                                id: "cdlqtvan",
                                name: "cdlqtvan",
                                labelRight: "Thông qua tổ chức truyền nhận hóa đơn điện tử (điểm b2, khoản 3, Điều 22 của Nghị định).",
                                labelWidth: 0,
                                on: {
                                    onChange: function (newv, oldv) {
                                        if (newv == 1) {
                                            $$("cdlqtvan").setValue(1);
                                            $$("cdlttdcqt").setValue(0);
                                            $$("nntdbkkhan").setValue(0);
                                            $$("nntktdnubnd").setValue(0);
                                            $$("cqxltscong").setValue(0);
                                        }
                                    }
                                }
                            },
                            {
                                view: "checkbox",
                                id: "cdlttdcqt",
                                name: "cdlttdcqt",
                                css: "lblCheckbox",
                                labelRight: "Chuyển dữ liệu hóa đơn điện tử trực tiếp đến CQT (Chuyển dữ liệu hóa đơn điện tử trực tiếp đến cơ quan thuế (điểm b1, khoản 3, Điều 22 của Nghị định 70)).",
                                labelWidth: 0,
                                on: {
                                    onChange: function (newv, oldv) {
                                        if (newv == 1) {
                                            $$("cdlttdcqt").setValue(1);
                                            $$("cdlqtvan").setValue(0);
                                            $$("nntktdnubnd").setValue(0);
                                            $$("nntdbkkhan").setValue(0);
                                            $$("cqxltscong").setValue(0);
                                        }
                                    }
                                }
                            },
                            {
                                rows: [
                                    { view: "label", label: "<b>3. Phương thức chuyển dữ liệu hóa đơn điện tử:</b>" },
                                    { view: "checkbox", id: "cddu", name: "cddu", labelRight: "Chuyển đầy đủ nội dung từng hóa đơn.", labelWidth: 0 },
                                    { view: "checkbox", id: "cbthop", name: "cbthop", css: "lblCheckbox", labelRight: "Chuyển theo bảng tổng hợp dữ liệu hóa đơn điện tử.", labelWidth: 0 }
                                ]
                            },
                            { view: "label", label: "<b>4. Loại hóa đơn sử dụng:</b>" },
                            { view: "checkbox", id: "hdgtgt", name: "hdgtgt", labelRight: "Hóa đơn giá trị gia tăng", labelWidth: 0 },
                            { view: "checkbox", id: "hdbhang", name: "hdbhang", labelRight: "Hóa đơn bán hàng", labelWidth: 0 },
                            { view: "checkbox", id: "hdkhac", name: "hdkhac", labelRight: "Các loại hóa đơn khác", labelWidth: 0 },
                            { view: "checkbox", id: "ctu", name: "ctu", labelRight: "Các chứng từ được in, phát hành, sử dụng và quản lý như hóa đơn", labelWidth: 0 }

                        ]
                    },
                    dscts,
                    dstochuc,
                    dsdvitruyennhan,
                    { height: 8 },
                    {
                        cols: [
                            {},
                            {
                                shortcut: "F10",
                                view: "button",
                                label: "Ghi (F10)",
                                id: "btnDKSDSave1",
                                width: 150,
                                align: "center",
                                type: "form",
                                on: {
                                    onClick: function () {
                                        if (!dangkyComponent.validateID()) return;

                                        if (!($$("cma").getValue() || $$("cmtmttien").getValue())) {
                                            if (!($$("cdlttdcqt").getValue() || $$("cdlqtvan").getValue() || $$("nntdbkkhan").getValue() || $$("nntktdnubnd").getValue() || $$("cqxltscong").getValue())) {
                                                return showError("Không được để trống Hình thức gửi dữ liệu hóa đơn điện tử");
                                            }
                                        }
                                        if (!($$("cddu").getValue() || $$("cbthop").getValue())) {
                                            return showError("Không được để trống Phương thức chuyển dữ liệu hóa đơn điện tử");
                                        }
                                        if (!($$("hdgtgt").getValue() || $$("hdbhang").getValue() || $$("hdkhac").getValue() || $$("ctu").getValue())) {
                                            return showError("Không được để trống Loại hóa đơn sử dụng");
                                        }

                                        if ($$(id_dsdvitruyennhan).count() === 0) {
                                            return showError("Không được để trống bảng Thông tin đơn vị truyền nhận");
                                        }
                                        if ($$(id_dstochuc).count() === 0) {
                                            return showError("Không được để trống bảng Tổ chức cung cấp dịch vụ");
                                        }

                                        var valid = validateTables([
                                            { id: id_dstochuc, name: name_dstochuc },
                                            { id: id_dsdvitruyennhan, name: name_dsdvitruyennhan }
                                        ]);
                                        if (!valid) return;

                                        var cks = $$(id_dscks).serialize();
                                        if (cks.length == 0) {
                                            return showError("Bạn chưa đăng ký chữ ký số cho thông báo phát hành.");
                                        }

                                        var item = $$(id_dangkysudung).getValues();
                                        var form = $$(form_dangkysudung);
                                        var table = $$(id_dangkysudung);

                                        var countMail = $$("dctdtu").getValue().split(/[\s,\;]+/);
                                        if (countMail.length > 1) {
                                            return showError("Bạn không được phép nhập quá 1 email");
                                        }

                                        if (!table.validate()) return;

                                        item.cqtqly = $$("mcqtqly").getText();
                                        item.hdbtscong = 0;
                                        item.hdbhdtqgia = 0;
                                        item["reg_chitiets"] = $$(id_dscks).serialize();
                                        item["reg_tvans"] = $$(id_dsdvitruyennhan).serialize() || [];
                                        item["reg_giaiphaps"] = $$(id_dstochuc).serialize() || [];
                                        webix.extend(form, webix.ProgressBar);
                                        form.disable();
                                        form.showProgress();
                                        webix.ajax()
                                            .headers({ 'Content-type': 'application/json' })
                                            .post(app.config.host + CONSTANTS.API.REGISTER70.SAVE_REGISTER70, item, {
                                                error: function (text, data, XmlHttpRequest) {
                                                    form.enable();
                                                    form.hideProgress();
                                                },
                                                success: function (text, data, XmlHttpRequest) {
                                                    form.enable();
                                                    form.hideProgress();
                                                    var response = JSON.parse(text);
                                                    if (response.code != "00") return showError(response.message);
                                                    app.callEvent("dataChangeDangkysudung68", [editmode, null]);
                                                    webix.message("Thành công !", "success");
                                                    webix.$$(form_dangkysudung).close();
                                                }
                                            });
                                    }
                                },
                                click: function () {
                                    this.callEvent("onClick");
                                }
                            },
                            {
                                view: "button",
                                hotkey: "esc",
                                label: "Hủy bỏ (ESC)",
                                width: 120,
                                type: "danger",
                                align: "center",
                                click: function () {
                                    webix.$$(form_dangkysudung).close();
                                }
                            },
                            {}
                        ]
                    },
                    { height: 8 },
                ]
            }
        },
        setEditMode: function (mode) {
            editmode = mode;
            var form = $$(this.$ui.id);
            form.config.editmode = mode;
            if (editmode == 1) {
                var result = webix.ajax().sync().get(app.config.host + "/System/GetCurrentDmdvcs");
                var data = JSON.parse(result.response);
                const mst_nban_cccd = data[0].use_cccd == true ? data[0].cccd_ndd : data[0].ms_thue;
                $$("dclhe").setValue(data[0].dia_chi);
                $$("tnnt").setValue(data[0].ten_dvcs);
                $$("mst").setValue(mst_nban_cccd);
                $$("dtlhe").setValue(data[0].dien_thoai);
                $$("dctdtu").setValue(data[0].email);
                $$("nlhe").setValue(data[0].nguoi_dai_dien);
                $$("mcqtqly").setValue(data[0].ma_cqthuecapql);
                $$("ddanh").setValue(data[0].tinh_thanh);
                $$("tnddpluat").setValue(data[0].ten_ndd);
                $$("dtddpluat").setValue(data[0].dthoai_ndd)
                $$("cccdan").setValue(data[0].cccd_ndd);
                $$("nsddpluat").setValue(removeTimeZoneT(data[0].nsinh_ndd));
                $$("shchieu").setValue(data[0].shchieu_ndd);
                $$("gtinh").setValue(data[0].gtinh_ndd === "F" ? 0 : 1);
            }
        },
        setValues: function (item, winconfig, params) {
            var win = $$(this.$ui.id);
            var form = $$(id_dangkysudung);
            item["nlap"] = removeTimeZoneT(item["nlap"]);
            item["nsddpluat"] = removeTimeZoneT(item["nsddpluat"]);
            form.setValues(item);
            if (item.trang_thai == 3 || item.trang_thai == 4) {
                var saveButton = $$("btnDKSDSave1");
                if (saveButton && typeof saveButton.destructor == 'function') {
                    saveButton.destructor();
                }
            }
            webix.extend(form, webix.ProgressBar);
            form.disable();
            form.showProgress();

            webix.ajax()
                .headers({ 'Content-type': 'application/json' })
                .get(app.config.host + CONSTANTS.API.REGISTER70.GET_REGISTERINVOICE + "?id=" + item.id, {
                    error: function (text, data, XmlHttpRequest) {
                        form.enable();
                        form.hideProgress();
                    }, success: function (text, data, XmlHttpRequest) {
                        form.enable();
                        form.hideProgress();
                        var response = JSON.parse(text);
                        if (response.code != "00") return showError(response.message);

                        $$(id_dstochuc).parse(response.data.reg_giaiphaps);
                        $$(id_dsdvitruyennhan).parse(response.data.reg_tvans);
                        $$(id_dscks).parse(response.data.reg_chitiets);
                    }
                });
        },
        setValuesChange: function (item, mode) {
            editmode = mode;
            var form = $$(id_dangkysudung);
            item["nlap"] = new Date();
            item["reg_dauphieu_id"] = "00000000-0000-0000-0000-000000000000";
            item["hthuc"] = 2;
            item["xml_send"] = null;
            item["mtdiep_gui"] = null;
            item["mtdiep_cqt"] = null;
            item["ket_qua"] = null;
            item["ngay_gui"] = null;
            item["nguoi_gui"] = null;
            form.setValues(item);
            var result = webix.ajax().sync().get(app.config.host + "/System/GetCurrentDmdvcs");
            var data = JSON.parse(result.response)[0] || {};
            const mst_nban_cccd = data.use_cccd == true ? data.cccd_ndd : data.ms_thue;
            $$("dclhe").setValue(data.dia_chi);
            $$("mst").setValue(mst_nban_cccd);
            $$("tnnt").setValue(data.ten_dvcs);
            $$("ddanh").setValue(data.tinh_thanh);
            $$("mcqtqly").setValue(data.ma_cqthuecapql);
            $$("dtlhe").setValue(data.dien_thoai ? data.dien_thoai : item.dtlhe);
            $$("dctdtu").setValue(data.email ? data.email : item.dctdtu);
            $$("nlhe").setValue(data.nguoi_dai_dien ? data.nguoi_dai_dien : item.nlhe);
            $$("tnddpluat").setValue(data.ten_ndd ? data.ten_ndd : item.tnddpluat);
            $$("dtddpluat").setValue(data.dthoai_ndd ? data.dthoai_ndd : item.dtddpluat);
            $$("cccdan").setValue(data.cccd_ndd ? data.cccd_ndd : item.cccdan);
            $$("nsddpluat").setValue(data.nsinh_ndd ? removeTimeZoneT(data.nsinh_ndd) : removeTimeZoneT(item.nsddpluat));
            $$("shchieu").setValue(data.shchieu_ndd ? data.shchieu_ndd : item.shchieu);
            $$("gtinh").setValue(
                data.gtinh_ndd ? (data.gtinh_ndd === "F" ? 0 : 1) : (item.gtinh !== undefined ? item.gtinh : 1)
            );
            var dataDetails = item.reg_chitiets;
            var tcgp = item.reg_giaiphaps;
            var tctn = item.reg_tvans;
            $$(id_dscks).parse(dataDetails);
            $$(id_dstochuc).parse(tcgp);
            $$(id_dsdvitruyennhan).parse(tctn);
        }
    };
});
define('views/forms/forms70/BienLai/70_dangkybienlaiForm',[
    "app",
    "locale",
    "models/user",
    "views/modules/minvoiceplugin",
    "views/modules/Component/constantManager",
    "views/forms/forms70/DangKySD/70_dangkyComponent"
], function (app, _, user, minvoiceplugin, CONSTANTS, dangkyComponent) {
    'use strict';

    webix.$$("title").parse({ title: "Đăng ký sử dụng", details: "Đăng ký sử dụng" });
    var editmode = 0;
    var id_dscks = dangkyComponent.id_dscks;
    var id_dangkyuynhiem = dangkyComponent.id_dangkyuynhiem;
    var id_dangkysudung = dangkyComponent.id_dangkysudung;

    return {
        $ui: {
            view: "window",
            modal: true,
            position: function (state) {
                state.width = state.maxWidth * 0.6;
                state.height = state.maxHeight * 0.9;
                state.left = (state.maxWidth - state.width) / 2;
                state.top = (state.maxHeight - state.height) / 2;
            },
            css: "headformchil",
            id: "dangkysudungForms",
            resize: true,
            fullscreen: true,
            move: true,
            head: false,
            on: {
                onShow: function () {
                    var self = this;
                    $(".webix_modal").one("click", function () {
                        self.close();
                    });
                }
            },
            body: {
                view: "form",
                id: "dangkysudung",
                position: "center",
                elementsConfig: { labelWidth: 150 },
                paddingY: 10,
                paddingX: 15,
                complexData: true,
                scroll: true,
                margin: 0,
                elements: [
                    { view: "label", template: "<div style='text-align:center;font-weight:bold;'>Mẫu số: 01/ĐKTĐ-CTĐT</div>" },
                    { view: "text", label: "Mẫu số:", name: "mso", id: "mso", css: "headRegisters", value: "01/ĐKTĐ-CTĐT", readonly: true, hidden: true },
                    { view: "label", template: function (obj) { return "<div class='headRegisters' style='text-align:center;font-weight:bold;font-size:15px;'>CỘNG HÒA XÃ HỘI CHỦ NGHĨA VIỆT NAM</div>"; } },
                    { view: "label", template: function (obj) { return "<div class='headRegister' style='text-align:center;'>Độc lập - Tự do - Hạnh phúc</div>"; } },
                    { view: "label", template: function (obj) { return "<div style='text-align:center;'>-------------------</div>"; } },
                    { view: "label", template: function (obj) { return "<div class='headRegisters'>TỜ KHAI</div>"; } },
                    { view: "label", template: function (obj) { return "<div class='headRegister'>Đăng ký/Thay đổi thông tin sử dụng chứng từ điện tử</div>"; } },
                    dangkyComponent.thongtinbienlai,
                    { height: 8 },
                    {
                        view: "label", autoheight: true, css: "lblResgisterMess", template: function () {
                            return `<div><span>Theo nghị định số 70/2025/NĐ-CP ngày 20 tháng 3 năm 2025 của Chính phủ,
                             chúng tôi/tôi thuộc đối tượng sử dụng chứng từ điện tử.
                             Chúng tôi/tôi đăng ký/thay đổi thông tin đã đăng ký với cơ quan thuế về việc sử dụng chứng từ điện tử như sau:</span></div>`;
                        }
                    },
                    {
                        rows: [
                            { view: "label", label: "<b>1.Đối tượng phát hành:</b>" },
                            {
                                view: "radio",
                                id: "dtphanh",
                                name: "dtphanh",
                                value: 1,
                                vertical: true,
                                options: [
                                    { id: 1, name: "tccnphanh", value: "Tổ chức, cá nhân phát hành" },
                                    { id: 2, name: "cqtphanh", value: "Cơ quan thuế phát hành" }
                                ],
                                labelWidth: 0
                            },
                            { view: "label", label: "<b>2.Loại hình sử dụng:</b>" },
                            { view: "checkbox", id: "cttncnhan", name: "cttncnhan", labelRight: "Chứng từ điện tử khấu trừ thuế thu nhập cá nhân", labelWidth: 0, },
                            { view: "checkbox", id: "ctktttmdtu", name: "ctktttmdtu", labelRight: "Chứng từ điện tử khấu trừ thuế đối với hoạt động kinh doanh trên nền tảng thương mại điện tử, nền tảng số", labelWidth: 0, disabled: true },
                            { view: "checkbox", id: "bltplpkin", name: "bltplpkin", labelRight: "Biên lai thu thuế, phí, lệ phí không in sẵn mệnh giá", labelWidth: 0 },
                            { view: "checkbox", id: "bltplpin", name: "bltplpin", labelRight: "Biên lai thu thuế, phí, lệ phí in sẵn mệnh giá", labelWidth: 0 },
                            { view: "checkbox", id: "blttplphi", name: "blttplphi", labelRight: "Biên lai thu thuế, phí, lệ phí của CQT mẫu CTT50", labelWidth: 0, disabled: true },
                            {
                                rows: [
                                    { view: "label", label: "<b>3.Hình thức gửi dữ liệu:</b>" },
                                    { view: "checkbox", id: "cdlqccqt", name: "cdlqccqt", css: "lblCheckbox", labelRight: "Trên cổng thông tin điện tử của cơ quan thuế", labelWidth: 0, disabled: true },
                                    { view: "checkbox", id: "cdlqtctn", name: "cdlqtctn", css: "lblCheckbox", labelRight: "Thông qua tổ chức cung cấp dịch vụ hóa đơn điện tử", labelWidth: 0, value: 1 },
                                    { view: "checkbox", id: "cdlqtctnut", name: "cdlqtctnut", css: "lblCheckbox", labelRight: "Thông qua tổ chức cung cấp dịch vụ hóa đơn điện tử được Tổng cục Thuế ủy thác", labelWidth: 0, disabled: true },
                                ]
                            },
                        ]
                    },
                    dangkyComponent.dscts,
                    dangkyComponent.dkyuynhiem,
                    { height: 8 },
                    {
                        cols: [
                            {},
                            {
                                shortcut: "F10",
                                view: "button",
                                label: "Ghi (F10)",
                                id: "btnDKSDSave1",
                                width: 150,
                                align: "center",
                                type: "form",
                                on: {
                                    onClick: function () {

                                        var item = $$("dangkysudung").getValues();
                                        var form = $$("dangkysudungForms");
                                        var table = $$("dangkysudung");

                                        var countMail = $$("dctdtu").getValue().split(/[\s,\;]+/);
                                        if (countMail.length > 1) {
                                            webix.message("Bạn không được phép nhập quá 1 email", "debug");
                                            return;
                                        } if (!table.validate()) return;
                                        var loaiHinhSuDung = [
                                            $$("cttncnhan").getValue(),
                                            $$("ctktttmdtu").getValue(),
                                            $$("bltplpkin").getValue(),
                                            $$("bltplpin").getValue(),
                                            $$("blttplphi").getValue()
                                        ];
                                        var hasSelected = false;
                                        for (var i = 0; i < loaiHinhSuDung.length; i++) {
                                            if (loaiHinhSuDung[i] === true || loaiHinhSuDung[i] === 1 || loaiHinhSuDung[i] === "1") {
                                                hasSelected = true;
                                                break;
                                            }
                                        }

                                        if (!hasSelected) {
                                            return showError("Bạn phải chọn ít nhất 1 loại hình sử dụng");
                                        }

                                        var hinhThucGuiDuLieu = [
                                            $$("cdlqccqt").getValue(),
                                            $$("cdlqtctn").getValue(),
                                            $$("cdlqtctnut").getValue()
                                        ];
                                        var hasSelectedHinhThuc = false;
                                        for (var j = 0; j < hinhThucGuiDuLieu.length; j++) {
                                            if (hinhThucGuiDuLieu[j] === true || hinhThucGuiDuLieu[j] === 1 || hinhThucGuiDuLieu[j] === "1") {
                                                hasSelectedHinhThuc = true;
                                                break;
                                            }
                                        }

                                        if (!hasSelectedHinhThuc) {
                                            return showError("Bạn phải chọn ít nhất 1 hình thức gửi dữ liệu");
                                        }
                                        if (!table.validate()) return;
                                        var loaiHinhSuDung = [
                                            $$("cttncnhan").getValue(),
                                            $$("ctktttmdtu").getValue(),
                                            $$("bltplpkin").getValue(),
                                            $$("bltplpin").getValue(),
                                            $$("blttplphi").getValue()
                                        ];
                                        var hasSelected = false;
                                        for (var i = 0; i < loaiHinhSuDung.length; i++) {
                                            if (loaiHinhSuDung[i] === true || loaiHinhSuDung[i] === 1 || loaiHinhSuDung[i] === "1") {
                                                hasSelected = true;
                                                break;
                                            }
                                        }
                                        if (!hasSelected) {
                                            return showError("Bạn phải chọn ít nhất 1 loại hình sử dụng");
                                        }
                                        var hinhThucGuiDuLieu = [
                                            $$("cdlqccqt").getValue(),
                                            $$("cdlqtctn").getValue(),
                                            $$("cdlqtctnut").getValue()
                                        ];
                                        var hasSelectedHinhThuc = false;
                                        for (var j = 0; j < hinhThucGuiDuLieu.length; j++) {
                                            if (hinhThucGuiDuLieu[j] === true || hinhThucGuiDuLieu[j] === 1 || hinhThucGuiDuLieu[j] === "1") {
                                                hasSelectedHinhThuc = true;
                                                break;
                                            }
                                        }
                                        if (!hasSelectedHinhThuc) {
                                            return showError("Bạn phải chọn ít nhất 1 hình thức gửi dữ liệu");
                                        }

                                        var cks = $$(id_dscks).serialize();
                                        if (cks.length == 0) {
                                            webix.message("Bạn chưa đăng ký chữ ký số cho thông báo phát hành.", "error");
                                            return;
                                        }
                                        item.cqtqly = $$("mcqtqly").getText();
                                        item.mso = $$("mso").getValue();
                                        if (item.dtphanh == 1) {
                                            item.tccnphanh = 1;
                                            item.cqtphanh = 0;
                                        } else {
                                            item.tccnphanh = 0;
                                            item.cqtphanh = 1;
                                        }
                                        delete item.dtphanh;
                                        item["reg_chitiets"] = $$(id_dscks).serialize();
                                        item["reg_uynhiems"] = $$(id_dangkyuynhiem).serialize() || [];
                                        webix.extend(form, webix.ProgressBar);
                                        form.disable();
                                        form.showProgress();
                                        webix.ajax()
                                            .headers({ 'Content-type': 'application/json' })
                                            .post(app.config.host + CONSTANTS.API.REGISTER70.SAVE_REGISTER70, item, {
                                                error: function (text, data, XmlHttpRequest) {
                                                    form.enable();
                                                    form.hideProgress();
                                                }, success: function (text, data, XmlHttpRequest) {
                                                    form.enable();
                                                    form.hideProgress();
                                                    var response = JSON.parse(text);
                                                    if (response.code != "00") return showError(response.message);
                                                    else {
                                                        app.callEvent("dataChangeDangkysudung68", [editmode, null]);
                                                        webix.message("Thành công !", "success");
                                                        webix.$$("dangkysudungForms").close();
                                                    }
                                                }
                                            });
                                    }
                                },
                                click: function () {
                                    this.callEvent("onClick");
                                }
                            },
                            {
                                view: "button",
                                hotkey: "esc",
                                label: "Hủy bỏ (ESC)",
                                width: 120,
                                type: "danger",
                                align: "center",
                                click: function () {
                                    webix.$$("dangkysudungForms").close();
                                }
                            },
                            {}
                        ]
                    },
                    { height: 8 },
                ]
            }
        },
        setEditMode: function (mode) {
            editmode = mode;
            var form = $$(this.$ui.id);
            form.config.editmode = mode;
            if (editmode == 1) {
                var result = webix.ajax().sync().get(app.config.host + "/System/GetCurrentDmdvcs");
                var data = JSON.parse(result.response);
                $$("tnnt").setValue(data[0].ten_dvcs);
                $$("mst").setValue(data[0].ms_thue);
                $$("nlhe").setValue(data[0].nguoi_dai_dien);
                $$("dtlhe").setValue(data[0].dien_thoai);
                $$("dclhe").setValue(data[0].dia_chi);
                $$("dctdtu").setValue(data[0].email);
                $$("mcqtqly").setValue(data[0].ma_cqthuecapql);
                $$("ddanh").setValue(data[0].tinh_thanh);
            }
        },
        setValues: function (item, winconfig, params) {
            var win = $$(this.$ui.id);
            var form = $$(id_dangkysudung);
            item["nlap"] = removeTimeZoneT(item["nlap"]);
            form.setValues(item);
            if (item.trang_thai == 3 || item.trang_thai == 4) {
                var saveButton = $$("btnDKSDSave1");
                if (saveButton && typeof saveButton.destructor == 'function') {
                    saveButton.destructor();
                }
            }
            if (item.hthuc) {
                $$("hthuc").setValue(item.hthuc);
            }
            if (item.tccnphanh == 1) {
                $$("dtphanh").setValue(1);
            } else if (item.cqtphanh == 1) {
                $$("dtphanh").setValue(2);
            }
            $$("cttncnhan").setValue(item.cttncnhan);

            webix.extend(form, webix.ProgressBar);
            form.disable();
            form.showProgress();
            webix.ajax()
                .headers({ 'Content-type': 'application/json' })
                .get(app.config.host + CONSTANTS.API.REGISTER70.GET_REGISTERINVOICE + "?id=" + item.id, {
                    error: function (text, data, XmlHttpRequest) {
                        form.enable();
                        form.hideProgress();
                    }, success: function (text, data, XmlHttpRequest) {
                        form.enable();
                        form.hideProgress();
                        var response = JSON.parse(text);
                        if (response.code != "00") return showError(response.message);
                        $$(id_dangkyuynhiem).parse(response.data.reg_uynhiems);
                        $$(id_dscks).parse(response.data.reg_chitiets);
                    }
                });
        },
        setValuesChange: function (item, mode) {
            editmode = mode;
            var form = $$(id_dangkysudung);
            item["nlap"] = new Date();
            item["reg_dauphieu_id"] = "00000000-0000-0000-0000-000000000000";
            item["hthuc"] = 2;
            item["xml_send"] = null;
            item["mtdiep_gui"] = null;
            item["mtdiep_cqt"] = null;
            item["ket_qua"] = null;
            item["ngay_gui"] = null;
            item["nguoi_gui"] = null;
            form.setValues(item);
            var result = webix.ajax().sync().get(app.config.host + "/System/GetCurrentDmdvcs");
            var data = JSON.parse(result.response)[0] || {};
            $$("mst").setValue(data.ms_thue);
            $$("tnnt").setValue(data.ten_dvcs);
            $$("mcqtqly").setValue(data.ma_cqthuecapql);
            $$("dtlhe").setValue(data.dien_thoai ? data.dien_thoai : item.dtlhe);
            $$("dctdtu").setValue(data.email ? data.email : item.dctdtu);
            $$("nlhe").setValue(data.nguoi_dai_dien ? data.nguoi_dai_dien : item.nlhe);
            $$("dclhe").setValue(data.dia_chi? data.dia_chi: item.dclhe);
            if (item.tccnphanh == 1) {
                $$("dtphanh").setValue(1);
            } else if (item.cqtphanh == 1) {
                $$("dtphanh").setValue(2);
            }
            var dataDetails = item.reg_chitiets;
            var uynhiem = item.reg_uynhiems;
            $$(id_dscks).parse(dataDetails);
            $$(id_dangkyuynhiem).parse(uynhiem);
        }
    };
});
define('views/70_dangkysudung',[
    "app",
    "locale",
    "models/user",
    "views/forms/forms70/DangKySD/70_dangkyForm",
    "views/forms/forms68/68_viewLogForm",
    "views/forms/forms68/DangKySD/68_dangkysudungV2Form",
    "views/modules/Component/modalPlugin",
    "views/modules/Component/constantManager",
    "views/forms/forms70/BienLai/70_dangkybienlaiForm"
], function (
    app,
    _,
    user,
    dangkysudung,
    viewLogForm,
    dangkysudungV2,
    modalPlugin,
    CONSTANTS,
    dangkybienlai
) {
    "use strict";

    var initUI = function () {
        var table = webix.$$("dangkysudung01Views");
        var url = {
            $proxy: true,
            load: function (view, callback, params) {
                var start = 0;
                var count = view.config.datafetch;
                var filter = [];
                var tlbparam_s = [];
                if (params) {
                    if (params.start !== undefined) start = params.start;
                    if (params.count !== undefined) count = params.count;
                    if (params.filter) {
                        for (var property in params.filter) {
                            var column = view.getColumnConfig(property);
                            var value = params.filter[property];
                            if (value !== "" && value !== null && value !== undefined) {
                                filter.push({
                                    columnName: property,
                                    columnType: column.columnType,
                                    value: value
                                });
                            }
                        }
                    }
                    if (params.tlbparam) tlbparam_s = params.tlbparam;
                }
                var item = {
                    command: "CM0006_70",
                    start: start,
                    count: count,
                    filter: filter,
                    tlbparam: tlbparam_s
                };
                var apiHost = app.config.host + "/Pattern/GetData";
                webix.ajax()
                    .headers({ 'Content-type': 'application/json' })
                    .bind(view)
                    .post(apiHost, item, callback, view);
            }
        };
        table.define("url", url);
    };
    var controls = [
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-refresh fa-lg" aria-hidden="true"></i> ' +
                '<span class="text">' + _("REFRESH") + '</span>',
            id: "btnRefresh",
            on: {
                onClick: function () {
                    var table = webix.$$("dangkysudung01Views");
                    table.clearAll();
                    table.load(table.config.url);
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button", type: "htmlbutton", width: 150,
            label: '<i class="fa fa-plus fa-lg" aria-hidden="true"></i> ' +
                '<span class="text">' + "Tờ khai Hóa đơn" + ' (F4)</span>',
            id: "btnPlus",
            shortcut: "F4",
            on: {
                onClick: function () {
                    var table = webix.$$("frmView");
                    webix.extend(table, webix.ProgressBar);
                    table.disable();
                    table.showProgress();
                    var detailForm = this.$scope.ui(dangkysudung.$ui);
                    webix.ajax()
                        .headers({ 'Content-type': 'application/json' })
                        .get(app.config.host + CONSTANTS.API.REGISTER70.BEFORADDNEW + "?isbienlai=false",
                            {
                                error: function (text, data, XmlHttpRequest) {
                                    table.enable();
                                    table.hideProgress();
                                },
                                success: function (text, data, XmlHttpRequest) {
                                    table.enable();
                                    table.hideProgress();
                                    var response = JSON.parse(text);
                                    if (response.code == "00") {
                                        dangkysudung.setEditMode(1);
                                        detailForm.show();
                                    } else {
                                        if (response.code == "01") {
                                            dangkysudung.setValuesChange(response.data, 1);
                                            detailForm.show();
                                        } else {
                                            webix.message(response.message, "error");
                                        }
                                    }
                                }
                            });
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button", type: "htmlbutton", width: 150,
            label: '<i class="fa fa-plus fa-lg" aria-hidden="true"></i> ' +
                '<span class="text">' + "Tờ khai Biên lai" + ' (F6)</span>',
            id: "btnPlusBienLai",
            shortcut: "F6",
            on: {
                onClick: function () {
                    var table = webix.$$("frmView");
                    webix.extend(table, webix.ProgressBar);
                    table.disable();
                    table.showProgress();
                    var detailForm = this.$scope.ui(dangkybienlai.$ui);
                    webix.ajax()
                        .headers({ 'Content-type': 'application/json' })
                        .get(app.config.host + CONSTANTS.API.REGISTER70.BEFORADDNEW + "?isbienlai=true",
                            {
                                error: function (text, data, XmlHttpRequest) {
                                    table.enable();
                                    table.hideProgress();
                                },
                                success: function (text, data, XmlHttpRequest) {
                                    table.enable();
                                    table.hideProgress();
                                    var response = JSON.parse(text);
                                    if (response.code == "00") {
                                        dangkybienlai.setEditMode(1);
                                        detailForm.show();
                                    } else {
                                        if (response.code == "01") {
                                            dangkybienlai.setValuesChange(response.data, 1);
                                            detailForm.show();
                                        } else {
                                            webix.message(response.message, "error");
                                        }
                                    }
                                }
                            });
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-edit fa-lg" aria-hidden="true"></i> ' +
                '<span class="text">' + _("SUA") + ' (F2)</span>',
            id: "btnEdit",
            shortcut: "F2",
            on: {
                onClick: function () {
                    var table = webix.$$("dangkysudung01Views");
                    var selectedItem = table.getSelectedItem();
                    if (selectedItem == null) {
                        webix.message("Bạn chưa chọn mẫu đăng ký cần sửa ! ", "error");
                        return;
                    }

                    var detailForm;
                    if (selectedItem.is_bienlai) {
                        detailForm = this.$scope.ui(dangkybienlai.$ui);
                        dangkybienlai.setEditMode(2);
                        dangkybienlai.setValues(selectedItem);
                    } else {
                        detailForm = this.$scope.ui(dangkysudung.$ui);
                        dangkysudung.setEditMode(2);
                        dangkysudung.setValues(selectedItem);
                    }

                    detailForm.show();

                    if (selectedItem.trang_thai == 3 || selectedItem.trang_thai == 4) {
                        var innerForm = detailForm.getBody();
                        if (innerForm && innerForm.elements) {
                            for (var key in innerForm.elements) {
                                var $el = innerForm.elements[key];
                                if ($el && typeof $el.define == 'function') {
                                    $el.define("readonly", "true");
                                    $el.define("css", "mcls_readonly_text");
                                    $el.refresh();
                                }
                            }
                        }
                        var saveButton = innerForm.queryView({ id: "btnDKSDSave1" }, "all");
                        if (saveButton && typeof saveButton.destructor == 'function') {
                            saveButton.destructor();
                        }
                    }
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-trash-o fa-lg" aria-hidden="true"></i> ' +
                '<span class="text">' + _("XOA") + ' (F3)</span>',
            id: "btnDelete",
            shortcut: "F3",
            on: {
                onClick: function () {
                    var table = webix.$$("dangkysudung01Views");
                    var selectedItem = table.getSelectedItem();
                    if (selectedItem == null) {
                        webix.message("Bạn chưa chọn mẫu đăng ký ! ", "error");
                        return;
                    }
                    if (selectedItem.trang_thai == 3 || selectedItem.trang_thai == 4) {
                        webix.message("Thông báo đã được ký và gửi CQT. Bạn không thể thực hiện chức năng này ! ", "error");
                        return;
                    }
                    selectedItem.editmode = 3;
                    webix.confirm({
                        title: "M-INVOICE",
                        text: "Bạn có muốn xóa bản ghi",
                        ok: "Có",
                        cancel: "Không",
                        callback: function (choose) {
                            if (choose) {
                                webix.extend(table, webix.ProgressBar);
                                table.disable();
                                table.showProgress();
                                webix.ajax()
                                    .headers({ 'Content-type': 'application/json' })
                                    .get(app.config.host + CONSTANTS.API.REGISTER70.MAU01_DELETE + "?id=" + selectedItem.reg_dauphieu_id,
                                        {
                                            error: function (text, data, XmlHttpRequest) {
                                                table.enable();
                                                table.hideProgress();
                                            },
                                            success: function (text, data, XmlHttpRequest) {
                                                table.remove(selectedItem.id);
                                                table.enable();
                                                table.hideProgress();
                                            }
                                        });
                            }
                        }
                    });
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {
            view: "button", type: "htmlbutton", width: 150,
            label: '<i class="fa fa-sign-in fa-lg" aria-hidden="true"></i> ' +
                '<span class="text">' + _('SIGN_SEND') + ' (F7)</span>',
            id: "btnSign",
            shortcut: "F7",
            on: {
                onClick: function () {
                    var tableDK = webix.$$("dangkysudung01Views");
                    var selectedItem = tableDK.getSelectedItem();
                    if (selectedItem == null) {
                        webix.message("Bạn chưa chọn mẫu đăng ký ! ", "error");
                        return;
                    }
                    if (selectedItem.trang_thai == 3 || selectedItem.trang_thai == 4) {
                        webix.message("Mẫu đã được ký hoặc gửi đi, bạn không thể ký lại ! ", "error");
                        return;
                    }
                    webix.ajax()
                        .headers({ 'Content-Type': 'application/json' })
                        .get(app.config.host + "/Pattern/GetSignType", function (text) {
                            var result = JSON.parse(text);
                            var kytaptrung = result[0].gia_tri;
                            switch (kytaptrung.toUpperCase()) {
                                case "FILE":
                                    var box = webix.modalbox({
                                        title: "Chọn chứng thư số",
                                        buttons: ["Nhận", "Hủy bỏ"],
                                        text: "<div id='ctnCerts'></div>",
                                        top: 100,
                                        width: 750,
                                        callback: function (result) {
                                            switch (result) {
                                                case "1":
                                                    webix.modalbox.hide();
                                                    break;
                                                case "0":
                                                    var table = $$("tblCerts");
                                                    var data = table.serialize();
                                                    var cert = null;
                                                    for (var i = 0; i < data.length; i++) {
                                                        if (data[i].chon == true) {
                                                            cert = data[i];
                                                            break;
                                                        }
                                                    }
                                                    if (cert == null) {
                                                        webix.message("Bạn chưa chọn chứng thư số");
                                                        return;
                                                    }
                                                    var postData = {
                                                        so_serial: cert.so_serial,
                                                        id: selectedItem.reg_dauphieu_id
                                                    };
                                                    webix.extend(tableDK, webix.ProgressBar);
                                                    tableDK.disable();
                                                    tableDK.showProgress();
                                                    webix.ajax()
                                                        .headers({ 'Content-type': 'application/json' })
                                                        .post(app.config.host + CONSTANTS.API.REGISTER70.SIGN_BY_FILE, postData, {
                                                            error: function (text, data, XmlHttpRequest) {
                                                                tableDK.enable();
                                                                tableDK.hideProgress();

                                                            }, success: function (text, data, XmlHttpRequest) {
                                                                var json = JSON.parse(text);
                                                                if (json.code != "00") {
                                                                    webix.message(json.message, "error");
                                                                    tableDK.enable();
                                                                    tableDK.hideProgress();
                                                                }
                                                                else {
                                                                    tableDK.enable();
                                                                    tableDK.hideProgress();
                                                                    app.callEvent("dataChangeDangkysudung68", [1, null]);
                                                                    webix.message("Ký và gửi CQT thành công!", "success");
                                                                }
                                                            }
                                                        });
                                                    return;
                                            }
                                        }
                                    });
                                    var tblMatHang = webix.ui({
                                        container: "ctnCerts",
                                        id: "tblCerts",
                                        view: "datatable",
                                        borderless: true,
                                        resizeColumn: true,
                                        height: 350,
                                        columns: [
                                            {
                                                id: "chon", header: _("CHON"), width: 65,
                                                checkValue: true, uncheckValue: false, template: "{common.checkbox()}"
                                            },
                                            { id: "so_serial", header: _("SO_SERIAL"), width: 150 },
                                            { id: "subjectname", header: _("SUBJECTNAME"), width: 450 },
                                            { id: "ngaybatdau", header: _("NGAY_BAT_DAU"), width: 200 },
                                            { id: "ngayketthuc", header: _("NGAY_KET_THUC"), width: 200 },
                                            { id: "issuer", header: _("DONVI"), width: 450 }
                                        ],
                                        url: app.config.host + "/Invoice/GetListCertificatesFile"
                                    });
                                    break;
                                case "EASYCA":
                                    var box = webix.modalbox({
                                        title: "Chọn chứng thư số",
                                        buttons: ["Nhận", "Hủy bỏ"],
                                        text: "<div id='ctnCerts'></div>",
                                        top: 100,
                                        width: 750,
                                        callback: function (result) {
                                            switch (result) {
                                                case "1":
                                                    webix.modalbox.hide();
                                                    break;
                                                case "0":
                                                    var table = $$("tblCerts");
                                                    var data = table.serialize();
                                                    var cert = null;
                                                    for (var i = 0; i < data.length; i++) {
                                                        if (data[i].chon == true) {
                                                            cert = data[i];
                                                            break;
                                                        }
                                                    }
                                                    if (cert == null) {
                                                        webix.message("Bạn chưa chọn chứng thư số", "debug");
                                                        return;
                                                    }
                                                    var tblInvoice = webix.$$("dangkysudung01Views");
                                                    var item = tblInvoice.getSelectedItem();
                                                    cert.id = item.id;
                                                    cert.tagSign = "TKhai/DSCKS/NNT";
                                                    cert.tagSignId = "data";

                                                    require(["app", "locale", "views/forms/forms68/EasyCA/signEasyCA"], function (app, _, signEasyCA) {
                                                        var frm = webix.$$("dangkysudung01Views").$scope.ui(signEasyCA.$ui);
                                                        signEasyCA.initUI(cert, "dangky");
                                                        webix.modalbox.hide();
                                                        frm.show();
                                                    });
                                            }
                                        }
                                    });
                                    var popupText = document.getElementsByClassName("webix_popup_text")[0];
                                    popupText.style.paddingTop = 0;
                                    var tblMatHang = webix.ui({
                                        container: "ctnCerts",
                                        id: "tblCerts",
                                        view: "datatable",
                                        borderless: true,
                                        resizeColumn: true,
                                        height: 350,
                                        columns: [
                                            {
                                                id: "chon", header: _("CHON"),
                                                width: 65, checkValue: true, uncheckValue: false, template: "{common.checkbox()}"
                                            },
                                            { id: "libraryName", header: _("Loại"), width: 150 },
                                            { id: "so_serial", header: _("SO_SERIAL"), width: 150 },
                                            { id: "subjectname", header: _("SUBJECTNAME"), width: 450 },
                                            { id: "ngaybatdau", header: _("NGAY_BAT_DAU"), width: 200 },
                                            { id: "ngayketthuc", header: _("NGAY_KET_THUC"), width: 200 },
                                            { id: "issuer", header: _("DONVI"), width: 450 }
                                        ],
                                        url: app.config.host + "/Invoice/GetListCertificatesEasyCA"
                                    });
                                    break;
                                case "NCCA":
                                    var box = webix.modalbox({
                                        title: "Chọn chứng thư số",
                                        buttons: ["Nhận", "Hủy bỏ"],
                                        text: "<div id='ctnCerts'></div>",
                                        top: 100,
                                        width: 750,
                                        callback: function (result) {
                                            switch (result) {
                                                case "1":
                                                    webix.modalbox.hide();
                                                    break;
                                                case "0":
                                                    var table = $$("tblCerts");
                                                    var data = table.serialize();
                                                    var cert = null;
                                                    for (var i = 0; i < data.length; i++) {
                                                        if (data[i].chon == true) {
                                                            cert = data[i];
                                                            break;
                                                        }
                                                    }
                                                    if (cert == null) {
                                                        webix.message("Bạn chưa chọn chứng thư số", "debug");
                                                        return;
                                                    }
                                                    var tblInvoice = webix.$$("dangkysudung01Views");
                                                    var item = tblInvoice.getSelectedItem();
                                                    cert.id = item.id;
                                                    cert.tagSign = "/DSCKS/NNT";
                                                    cert.tagSignId = "data";

                                                    require(["app", "locale", "views/forms/forms68/NCCA/signNCCA"], function (app, _, signNCCA) {
                                                        var frm = webix.$$("dangkysudung01Views").$scope.ui(signNCCA.$ui);
                                                        signNCCA.initUI(cert, "dangky");
                                                        webix.modalbox.hide();
                                                        frm.show();
                                                    });
                                            }
                                        }
                                    });
                                    var popupText = document.getElementsByClassName("webix_popup_text")[0];
                                    popupText.style.paddingTop = 0;
                                    var tblMatHang = webix.ui({
                                        container: "ctnCerts",
                                        id: "tblCerts",
                                        view: "datatable",
                                        borderless: true,
                                        resizeColumn: true,
                                        height: 350,
                                        columns: [
                                            {
                                                id: "chon", header: _("CHON"), width: 65, checkValue: true, uncheckValue: false,
                                                template: "{common.checkbox()}"
                                            },
                                            { id: "libraryName", header: _("Loại"), width: 150 },
                                            { id: "so_serial", header: _("SO_SERIAL"), width: 150 },
                                            { id: "subjectname", header: _("SUBJECTNAME"), width: 450 },
                                            { id: "ngaybatdau", header: _("NGAY_BAT_DAU"), width: 200 },
                                            { id: "ngayketthuc", header: _("NGAY_KET_THUC"), width: 200 },
                                            { id: "issuer", header: _("DONVI"), width: 450 }
                                        ],
                                        url: app.config.host + "/Invoice/GetListCertificatesAuto"
                                    });
                                    break;
                                case "ICA":
                                    var box = webix.modalbox({
                                        title: "Chọn chứng thư số",
                                        buttons: ["Nhận", "Hủy bỏ"],
                                        text: "<div id='ctnCerts'></div>",
                                        top: 100,
                                        width: 750,
                                        callback: function (result) {
                                            switch (result) {
                                                case "1":
                                                    webix.modalbox.hide();
                                                    break;
                                                case "0":
                                                    var table = $$("tblCerts");
                                                    var data = table.serialize();
                                                    var cert = null;
                                                    for (var i = 0; i < data.length; i++) {
                                                        if (data[i].chon == true) {
                                                            cert = data[i];
                                                            break;
                                                        }
                                                    }
                                                    if (cert == null) {
                                                        webix.message("Bạn chưa chọn chứng thư số", "debug");
                                                        return;
                                                    }
                                                    var tblInvoice = webix.$$("dangkysudung01Views");
                                                    var item = tblInvoice.getSelectedItem();
                                                    cert.id = item.id;
                                                    cert.tagSign = "/DSCKS/NNT";
                                                    cert.tagSignId = "data";

                                                    webix.ajax().headers({ 'Content-type': 'application/text' })
                                                        .get(app.config.host + "/TokenCloud/CheckShowPinCode", function (text, data, XmlHttpRequest) {
                                                            var response = JSON.parse(text);
                                                            if (response.show == true) {
                                                                require(["app", "locale", "views/forms/forms68/ICA/signICA"], function (app, _, signICA) {
                                                                    var frm = webix.$$("dangkysudung01Views").$scope.ui(signICA.$ui);
                                                                    signICA.initUI(cert, "dangky70");
                                                                    webix.modalbox.hide();
                                                                    frm.show();
                                                                });
                                                            }
                                                            else {
                                                                var form = webix.$$("frmView");
                                                                webix.extend(form, webix.ProgressBar);
                                                                form.disable();
                                                                form.showProgress();

                                                                var apiHost = app.config.host + CONSTANTS.API.REGISTER70.SIGN_BY_ICA;
                                                                var param = {
                                                                    so_serial: cert.so_serial,
                                                                    pinCode: cert.pass,
                                                                    id: item.id,
                                                                    agreementUUID: cert.value
                                                                };
                                                                webix.ajax()
                                                                    .headers({ 'Content-type': 'application/json' })
                                                                    .post(apiHost, param, {
                                                                        error: function (text, data, XmlHttpRequest) {
                                                                            form.enable();
                                                                            form.hideProgress();
                                                                        },
                                                                        success: function (text, data, XmlHttpRequest) {
                                                                            var response = JSON.parse(text);
                                                                            form.enable();
                                                                            form.hideProgress();
                                                                            if (response.code == "00") {
                                                                                app.callEvent("dataChangeDangkysudung68", [1, null]);
                                                                                webix.message("Ký và gửi CQT thành công!", "success");
                                                                            }
                                                                            else
                                                                                webix.message(response.message, "error");
                                                                        }
                                                                    });
                                                            }
                                                        });

                                            }
                                        }
                                    });
                                    var popupText = document.getElementsByClassName("webix_popup_text")[0];
                                    popupText.style.paddingTop = 0;
                                    var tblMatHang = webix.ui({
                                        container: "ctnCerts",
                                        id: "tblCerts",
                                        view: "datatable",
                                        borderless: true,
                                        resizeColumn: true,
                                        height: 350,
                                        columns: [
                                            {
                                                id: "chon", header: _("CHON"), width: 65, checkValue: true, uncheckValue: false,
                                                template: "{common.checkbox()}"
                                            },
                                            { id: "libraryName", header: _("Loại"), width: 150 },
                                            { id: "so_serial", header: _("SO_SERIAL"), width: 150 },
                                            { id: "subjectname", header: _("SUBJECTNAME"), width: 450 },
                                            { id: "ngaybatdau", header: _("NGAY_BAT_DAU"), width: 200 },
                                            { id: "ngayketthuc", header: _("NGAY_KET_THUC"), width: 200 },
                                            { id: "issuer", header: _("DONVI"), width: 450 }
                                        ],
                                        url: app.config.host + "/Invoice/GetListCertificatesAuto"
                                    });
                                    break;
                                case "INTRUSTCA":
                                    var box = webix.modalbox({
                                        title: "Chọn chứng thư số IntrustCa",
                                        buttons: ["Nhận", "Hủy bỏ"],
                                        text: "<div id='ctnCerts'></div>",
                                        top: 100,
                                        width: 750,
                                        callback: function (result) {
                                            switch (result) {
                                                case "1":
                                                    webix.modalbox.hide();
                                                    break;
                                                case "0":
                                                    var table = $$("tblCerts");
                                                    var data = table.serialize();
                                                    var cert = null;
                                                    for (var i = 0; i < data.length; i++) {
                                                        if (data[i].chon == true) {
                                                            cert = data[i];
                                                            break;
                                                        }
                                                    }
                                                    if (cert == null) {
                                                        webix.message("Bạn chưa chọn chứng thư số");
                                                        return;
                                                    }
                                                    var signModel = {
                                                        user_name: cert.username,
                                                        credentialID: cert.tokenSerial,
                                                        certificate: cert.cert_content,
                                                        pinCode: cert.pin_code,
                                                        auth_data: cert.auth_data,
                                                        mode: 1,
                                                        hoadon: [selectedItem.reg_dauphieu_id]
                                                    }

                                                    webix.extend(tableDK, webix.ProgressBar);
                                                    tableDK.disable();
                                                    tableDK.showProgress();
                                                    webix.ajax().headers({ "Content-Type": "application/json" })
                                                        .post(app.config.host + CONSTANTS.API.REGISTER70.SIGN_BY_INTRUSTCA, JSON.stringify(signModel), function (text) {
                                                            tableDK.enable();
                                                            tableDK.hideProgress();
                                                            var result = JSON.parse(text);
                                                            if (result.code == "00") {
                                                                app.callEvent("dataChangeDangkysudung68", [1, null]);
                                                                webix.message("Ký và gửi CQT thành công!", "success");
                                                            } else
                                                                webix.message(result.message, "error")
                                                        });
                                                    break;
                                            }
                                        }
                                    });

                                    var cert = webix.ui({
                                        container: "ctnCerts",
                                        id: "tblCerts",
                                        view: "datatable",
                                        borderless: true,
                                        resizeColumn: true,
                                        height: 350,
                                        columns: [
                                            {
                                                id: "chon", header: _("CHON"), width: 65, checkValue: true, uncheckValue: false,
                                                template: "{common.checkbox()}"
                                            },
                                            { id: "libraryName", header: _("Loại"), width: 100 },
                                            { id: "so_serial", header: _("SO_SERIAL"), width: 250 },
                                            { id: "subjectname", header: _("SUBJECTNAME"), width: 450 },
                                            { id: "ngaybatdau", header: _("NGAY_BAT_DAU"), width: 200 },
                                            { id: "ngayketthuc", header: _("NGAY_KET_THUC"), width: 200 },
                                            { id: "issuer", header: _("DONVI"), width: 450 }
                                        ],
                                        url: CONSTANTS.API.TOKEN_CERT_AUTO,
                                        ready: function () {
                                            this.data.each(function (row, index) {
                                                row.chon = false;
                                                if (index == 0) row.chon = true;
                                            });
                                            this.refresh();
                                        },
                                        on: {
                                            onCheck: function (rowId, colId, isChecked) {
                                                if (isChecked) {
                                                    this.data.each(function (row) {
                                                        if (row.id !== rowId) {
                                                            this.getItem(row.id).chon = false;
                                                            this.updateItem(row.id);
                                                        }
                                                    });
                                                }
                                            }
                                        }
                                    });
                                    break;

                                case "VNET":
                                    var box = webix.modalbox({
                                        title: "Chọn chứng thư số Vnet",
                                        buttons: ["Nhận", "Hủy bỏ"],
                                        text: "<div id='ctnCerts'></div>",
                                        top: 100,
                                        width: 750,
                                        callback: function (result) {
                                            switch (result) {
                                                case "1":
                                                    webix.modalbox.hide();
                                                    break;
                                                case "0":
                                                    var table = $$("tblCerts");
                                                    var data = table.serialize();
                                                    var cert = null;
                                                    for (var i = 0; i < data.length; i++) {
                                                        if (data[i].chon == true) {
                                                            cert = data[i];
                                                            break;
                                                        }
                                                    }
                                                    if (cert == null) {
                                                        webix.message("Bạn chưa chọn chứng thư số");
                                                        return;
                                                    }
                                                    var postData = {
                                                        chukyso_id: cert.chukyso_id,
                                                        id: selectedItem.reg_dauphieu_id
                                                    };
                                                    webix.extend(tableDK, webix.ProgressBar);
                                                    tableDK.disable();
                                                    tableDK.showProgress();
                                                    webix.ajax()
                                                        .headers({ 'Content-type': 'application/json' })
                                                        .post(app.config.host + CONSTANTS.API.SIGN_BY_VNET, postData, {
                                                            error: function (text, data, XmlHttpRequest) {
                                                                tableDK.enable();
                                                                tableDK.hideProgress();

                                                            }, success: function (text, data, XmlHttpRequest) {
                                                                var json = JSON.parse(text);
                                                                if (json.code != "00") {
                                                                    webix.message(json.message, "error");
                                                                    tableDK.enable();
                                                                    tableDK.hideProgress();
                                                                }
                                                                else {
                                                                    tableDK.enable();
                                                                    tableDK.hideProgress();
                                                                    app.callEvent("dataChangeDangkysudung68", [1, null]);
                                                                    webix.message("Ký và gửi CQT thành công!", "success");
                                                                }
                                                            }
                                                        });
                                                    return;
                                            }
                                        }
                                    });
                                    var tblMatHang = webix.ui({
                                        container: "ctnCerts",
                                        id: "tblCerts",
                                        view: "datatable",
                                        borderless: true,
                                        resizeColumn: true,
                                        height: 350,
                                        columns: [
                                            {
                                                id: "chon", header: _("CHON"), width: 65,
                                                checkValue: true, uncheckValue: false, template: "{common.checkbox()}"
                                            },
                                            { id: "so_serial", header: _("SO_SERIAL"), width: 150 },
                                            { id: "subjectname", header: _("SUBJECTNAME"), width: 450 },
                                            { id: "ngaybatdau", header: _("NGAY_BAT_DAU"), width: 200 },
                                            { id: "ngayketthuc", header: _("NGAY_KET_THUC"), width: 200 },
                                            { id: "issuer", header: _("DONVI"), width: 450 }
                                        ],
                                        url: app.config.host + "/Invoice/GetListCertificatesVnet"
                                    });
                                    break;
                                default:
                                    var table = $$("dangkysudung01Views");
                                    webix.extend(table, webix.ProgressBar);
                                    table.disable();
                                    table.showProgress();

                                    var a = webix.ajax(app.config.host + CONSTANTS.API.REGISTER70.GET_XML + "?id=" + selectedItem.id);
                                    var b = webix.ajax(app.config.host + "/Pattern/GetListCertificates");
                                    var c = webix.ajax(app.config.host + "/Register70/GetSerialAccept?id=" + selectedItem.id);
                                    webix.promise.all([a, b, selectedItem, c]).then(function (results) {
                                        var json = results[0].json();
                                        if (json.code != "00") {
                                            table.enable();
                                            table.hideProgress();
                                            webix.message({ type: 'error', text: json.message });
                                            return;
                                        }
                                        var listcerts = results[1].json();
                                        var item = results[2];

                                        if (listcerts.length == 0) {
                                            table.enable();
                                            table.hideProgress();
                                            webix.message({ type: "error", text: "Bạn chưa được phân quyền chứng thư số" });
                                            return;
                                        }
                                        var certAccept = results[3].json();
                                        if (certAccept == undefined || certAccept.length == 0) {
                                            table.enable();
                                            table.hideProgress();
                                            webix.message("Không tồn tại chữ ký số đăng ký sử dụng", "error");
                                            return;
                                        }

                                        require(["views/modules/minvoiceplugin"], function (plugin) {
                                            var hub = plugin.hub();
                                            var hubconnect = plugin.conn();

                                            if (hubconnect.state != 1) {
                                                table.enable();
                                                table.hideProgress();
                                                webix.message("Quý khách hàng chưa cài Plugin ký hóa đơn hoặc Plugin ký hóa đơn chưa được bật !", "error");
                                                var Form = $$("dangkysudung01Views").$scope.ui(modalPlugin.$ui);
                                                Form.show();
                                                return;
                                            }
                                            hub.off('resCommand');
                                            hub.on('resCommand', function (result) {
                                                var json = JSON.parse(result);
                                                if (json.hasOwnProperty("error")) {
                                                    webix.message({ type: 'error', text: json.error });
                                                }
                                                else {
                                                    var parameters = {
                                                        xml: json.xml,
                                                        id: item.id
                                                    };

                                                    webix.ajax()
                                                        .headers({ "Content-Type": "application/json" })
                                                        .post(app.config.host + CONSTANTS.API.REGISTER70.SAVE_XML, parameters, function (text) {
                                                            var result = JSON.parse(text);
                                                            if (result.hasOwnProperty("error")) {
                                                                webix.message(result.error, "error");
                                                            }
                                                            else {
                                                                app.callEvent("dataChangeDangkysudung68", [1, null]);

                                                                webix.message("Ký và gửi CQT thành công!", "success");
                                                            }

                                                        });
                                                }
                                                table.enable();
                                                table.hideProgress();
                                            });

                                            var _listcerts = [];

                                            for (var i = 0; i < listcerts.length; i++) {
                                                var _cert = listcerts[i];

                                                _listcerts.push({
                                                    so_serial: _cert.so_serial,
                                                    ngaybatdau: _cert.ngaybatdau,
                                                    ngayketthuc: _cert.ngayketthuc,
                                                    issuer: _cert.issuer,
                                                    subjectname: _cert.subjectname
                                                });
                                            }

                                            var arg = {
                                                idData: "#data",
                                                xml: json.data["xml"],
                                                shdon: "",
                                                idSigner: "",
                                                tagSign: "NNT",
                                                listcerts: _listcerts,
                                                certAccept: certAccept
                                            };
                                            hub.invoke('execCommand', 'SignXmlTag', JSON.stringify(arg))
                                                .done(function () {
                                                    console.log("Success !")
                                                })
                                                .fail(function (error) {

                                                    webix.message(error, "error");
                                                });
                                        });

                                    });
                                    break;
                            }
                        });
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button", type: "htmlbutton", width: 210,
            label: '<i class="fa fa-plus fa-lg aria-hidden="true"></i> ' +
                '<span class="text">' + _("Tạo mẫu và ký hiệu hóa đơn") + '</span>',
            id: "btnInsertMau",
            click: function () {
                var tableDK = webix.$$("dangkysudung01Views");
                webix.confirm({
                    title: "TẠO MẪU VÀ KÝ HIỆU HĐ TỰ ĐỘNG",
                    text: "Bạn có chắc chắn muốn tạo mẫu hóa đơn theo mẫu mặc định ?", ok: "Có", cancel: "Không",
                    callback: function (res) {
                        if (res) {
                            if (res) {
                                webix.extend(tableDK, webix.ProgressBar);
                                tableDK.disable();
                                tableDK.showProgress();
                                webix.ajax()
                                    .headers({ 'Content-Type': 'application/json' })
                                    .post(app.config.host + "/Pattern/InsertMauAndKyHieu", function (text) {
                                        var result = JSON.parse(text);
                                        tableDK.enable();
                                        tableDK.hideProgress();
                                        if (result.code != "00") {
                                            webix.message({ type: 'error', text: result.message });
                                            return;
                                        }
                                        else {
                                            var table = webix.$$("dangkysudung01Views");
                                            webix.message("Tạo mẫu hóa đơn và ký hiệu hóa đơn thành công !", "success");
                                            table.clearAll();
                                            table.load(table.config.url);
                                        }
                                    });
                            }
                        }
                    }
                });
            }
        },
        {
            view: "button", type: "htmlbutton", width: 160,
            label: '<i class="fa fa-plus fa-lg" aria-hidden="true"></i> ' +
                '<span class="text">' + _("Tải lên file chấp thuận") + '</span>',
            id: "btnAddM01",
            shortcut: "F4",
            on: {
                onClick: function () {
                    var us = user.getCurrentUser();
                    if (us != "ADMINISTRATOR") {
                        webix.message("Bạn không có quyền thực hiện thao tác này.", "error");
                        return;
                    }
                    var table = webix.$$("dangkysudung01Views");
                    var selectedItem = table.getSelectedItem();
                    if (selectedItem == null) {
                        webix.message("Bạn chưa chọn tờ khai cần tải file chấp thuận!", "error");
                        return;
                    }
                    var detailForm = this.$scope.ui(dangkysudungV2.$ui);
                    dangkysudungV2.setEditMode(1);
                    var formData = {
                        reg_dauphieu_id: selectedItem.reg_dauphieu_id,
                    };
                    dangkysudungV2.setValues(formData);
                    detailForm.show();
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {}
    ];

    var table = {
        margin: 0,
        rows: [{
            id: "dangkysudung01Views",
            view: "datatable",
            select: true,
            resizeColumn: true,
            footer: false,
            editable: false,
            tooltip: true,
            scheme: {
                $init: function (obj) {
                    obj.is_bienlai = !!obj.is_bienlai;
                },
            },
            onClick: {
                "dowloadXmlDKSD": function (event, cell, target) {
                    var win = webix.$$("dangkysudung01Views");
                    var record = win.getItem(cell.row);
                    if (record.trang_thai != 3 && record.trang_thai != 4) {
                        webix.message("Mẫu chưa được ký không thể tải !", "error");
                        return;
                    }

                    var file = new Blob([record.xml_send], { type: "application/xml" });
                    webix.html.download(file, "Mau01.xml");
                },
                "btndowloadXMLRep": function (event, cell, target) {
                    var win = webix.$$("dangkysudung01Views");
                    var record = win.getItem(cell.row);
                    if (record.ket_qua == null || record.ket_qua == "") {
                        webix.message("Mẫu chưa được CQT trả về không thể tải !", "error");
                        return;
                    }
                    webix.extend(win, webix.ProgressBar);
                    win.disable();
                    win.showProgress();

                    var url = app.config.host + "/Invoice68/ExportXMLMau02?id=" + cell.row;
                    webix.ajax().response("arraybuffer")
                        .get(url, function (text, data) {

                            win.enable();
                            win.hideProgress();

                            var file = new Blob([data], { type: "application/xml" });
                            webix.html.download(file, "Mau02.xml");
                        });
                },
                "InMau01": function (event, cell, target) {
                    var table = webix.$$("dangkysudung01Views");
                    var item = table.getItem(cell.row);
                    var box = webix.modalbox({
                        title: "Đang in mẫu đăng ký/ thay đổi ....",
                        text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                        width: 350,
                        height: 200
                    });

                    var newWin = window.open();
                    var html = '<html><head><title>Hóa đơn điện tử M-Invoice</title>'
                        + '<link rel="stylesheet" href="assets/fontawesome_pro/css/all.css" type="text/css" charset="utf-8">'
                        + '<link rel="stylesheet" href="assets/fontawesome.css" type="text/css" charset="utf-8">'
                        + '</head><body><center>Đang tải dữ liệu ... <br><p><i style="font-size:200%;" class="fa fa-spin fa-spinner"></i></p></center></body></html>';
                    newWin.document.write(html);

                    webix.ajax()
                        .response("arraybuffer")
                        .headers({ 'Content-type': 'application/json' })
                        .get(app.config.host + CONSTANTS.API.REGISTER70.PRINT_MAU01 + "?id=" + item.id + "&type=PDF",
                            {
                                error: function (text, data, XmlHttpRequest) {
                                    webix.modalbox.hide(box);
                                },
                                success: function (text, data, XmlHttpRequest) {
                                    var file = new Blob([data], { type: 'application/pdf' });
                                    var fileURL = URL.createObjectURL(file);
                                    webix.modalbox.hide(box);
                                    newWin.location = fileURL;
                                }
                            });

                },
                "InMau02": function (event, cell, target) {
                    var table = webix.$$("dangkysudung01Views");
                    var item = table.getItem(cell.row);

                    var box = webix.modalbox({
                        title: "Đang in mẫu đăng ký/ thay đổi ....",
                        text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                        width: 350,
                        height: 200
                    });

                    var newWin = window.open();
                    var html = '<html><head><title>Hóa đơn điện tử M-Invoice</title>'
                        + '<link rel="stylesheet" href="assets/fontawesome_pro/css/all.css" type="text/css" charset="utf-8">'
                        + '<link rel="stylesheet" href="assets/fontawesome.css" type="text/css" charset="utf-8">'
                        + '</head><body><center>Đang tải dữ liệu ... <br><p><i style="font-size:200%;" class="fa fa-spin fa-spinner"></i></p></center></body></html>';
                    newWin.document.write(html);

                    webix.ajax()
                        .response("arraybuffer")
                        .headers({ 'Content-type': 'application/json' })
                        .get(app.config.host + "/Invoice68/inMau02?id=" + item.id + "&type=PDF",
                            {
                                error: function (text, data, XmlHttpRequest) {
                                    webix.modalbox.hide(box);
                                },
                                success: function (text, data, XmlHttpRequest) {
                                    var file = new Blob([data], { type: 'application/pdf' });
                                    var fileURL = URL.createObjectURL(file);
                                    //window.open(fileURL, '_blank');
                                    webix.modalbox.hide(box);
                                    newWin.location = fileURL;
                                }
                            });
                },
                "btnViewLichsu": function (event, cell, target) {
                    var table = webix.$$("dangkysudung01Views");
                    var item = table.getItem(cell.row);
                    var detailForm = this.$scope.ui(viewLogForm.$ui);
                    viewLogForm.initUI(null, item.mtdiep_gui, item);
                    detailForm.config.mtdiep = item.mtdiep_gui;
                    detailForm.show();
                }
            },
            on: {
                "data->onStoreUpdated": function () {
                    this.data.each(function (obj, i) {
                        obj.stt = i + 1;
                    });
                },
                onItemDblClick: function (id, e, node) {
                    var btnEdit = $$("btnEdit");
                    btnEdit.callEvent("onClick");
                },
                onBeforeLoad: function () {
                    this.showOverlay("<p><i style='font-size:450%;' class='fa fa-spin fa-spinner fa-pulse'></i></p>");
                },
                onAfterLoad: function (id) {
                    this.hideOverlay();
                }
            },
            columns: [
                { id: "stt", header: ["STT"], width: 40 },
                {
                    id: "nlap", format: function (text) {
                        var format = webix.Date.dateToStr("%d/%m/%Y");
                        text = removeTimeZoneT(text);
                        return format(text);
                    }, header: ["Ngày lập"], width: 130
                },
                {
                    id: "hthuc", header: ["Hình thức"], width: 120, template: function (obj) {
                        if (obj.hthuc == 1)
                            return "Đăng ký";
                        else
                            return "Thay đổi";
                    }
                },
                { id: "dctdtu", header: ["Email"], width: 200 },
                {
                    id: "ngay_gui", header: ["Ngày gửi"], width: 110, format: function (text) {
                        var format = webix.Date.dateToStr("%d/%m/%Y");
                        text = removeTimeZoneT(text);
                        return format(text);
                    }
                },
                {
                    id: "is_bienlai", header: ["Biên lai"], width: 80,
                    columnType: "bit", css: { "text-align": "center" },
                    template: function (obj) {
                        return obj.is_bienlai ? "<input class='webix_table_checkbox' type='checkbox' checked disabled>" : "<input class='webix_table_checkbox' type='checkbox' disabled>";
                    }
                },
                {
                    id: "btnInMau01",
                    header: ["In"],
                    css: { "text-align": "center" },
                    template: function (obj) {
                        if (obj.trang_thai == 3 || obj.trang_thai == 4) {
                            return "<span class='InMau01' style='color: #00b300'><i class='mdi mdi-18px mdi-printer'></i></span> ";
                        } else
                            return "<span class='InMau01' style='color: #c8c8cc'><i class='mdi mdi-18px mdi-printer'></i></span> ";
                    },
                    width: 60
                },
                {
                    id: "dowloadXmlDKSD",
                    header: ["Tải về"],
                    css: { "text-align": "center" },
                    template: function (obj) {
                        if (obj.trang_thai == 3 || obj.trang_thai == 4) {
                            return "<span class='dowloadXmlDKSD' style='color: #00b300'><i class='fas fa-download'></i></span> ";
                        } else
                            return "<span class='dowloadXmlDKSD' style='color: #c8c8cc'><i class='fas fa-download'></i></span> ";
                    },
                    width: 60
                },
                {
                    id: "trang_thai", header: ["Trạng thái"], width: 130,
                    template: function (obj) {
                        if (obj.trang_thai == 3) {
                            return `<span style='color: ${CONSTANTS.COLOR.DA_KY};font-weight: bold;'>Đã ký</span>`;
                        } else {
                            if (obj.trang_thai == 4)
                                return `<span style='color: ${CONSTANTS.COLOR.DA_GUI};font-weight: bold;'>Đã Gửi</span>`;
                            else
                                return `<span style='color: ${CONSTANTS.COLOR.CHO_KY};font-weight: bold;'>Chờ ký</span>`;
                        }
                    }
                },
                {
                    id: "mtdiep_cqt", header: ["Trạng thái CQT"], width: 160, css: { "text-align": "center" }, template: function (obj) {
                        if (obj.trang_thai == 4) {
                            var response = "";
                            switch (obj.ket_qua) {
                                case "":
                                    break;
                                case null:
                                    break;
                                case "1":
                                    response = `<span style='color: ${CONSTANTS.COLOR.CHAP_NHAN};font-weight: bold;'>Chấp nhận</span>`;
                                    break;
                                case "5":
                                    response = `<span style='color: ${CONSTANTS.COLOR.CHAP_NHAN};font-weight: bold;'>Giải trình</span>`;
                                    break;
                                case "98":
                                    response = `<span style='color: ${CONSTANTS.COLOR.TIEP_NHAN};font-weight: bold;'>Tiếp nhận</span>`;
                                    break;
                                case "99":
                                    response = `<span style='color: ${CONSTANTS.COLOR.KHONG_CHAP_NHAN};font-weight: bold;'>Không tiếp nhận</span>`;
                                    break;
                                default:
                                    response = `<span style='color: ${CONSTANTS.COLOR.KHONG_CHAP_NHAN};font-weight: bold;'>Không chấp nhận</span>`;
                                    break;
                            };
                            return response;
                        }
                        else
                            return "";
                    }
                },
                {
                    id: "btnViewLichsu",
                    header: ["Xem thông báo"],
                    css: { "text-align": "center", "color": "blue", "text-decoration": "underline" },
                    template: function (obj) {
                        return "<span class='btnViewLichsu'>Thông báo<span>";
                    },
                    width: 150
                },
                { id: "nguoi_gui", header: ["Người gửi"], width: 180 },
                { id: "mtdiep_gui", header: ["Mã thông điệp gửi"], width: 150 }
            ],
            pager: "pagerA",
        },
        {
            id: "pagerA",
            view: "pager",
            template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}",
            container: "paging_here",
            size: 50,
            group: 5,
        },
        ]
    };

    var layout = {
        css: "frmView",
        id: "frmView",
        rows: [
            {
                id: "btnRegister",
                height: 39,
                css: "btnControl",
                type: "toolbar",
                margin: 0,
                borderless: true,
                cols: controls
            },
            {
                rows: [table],
            },
        ],
    };
    function loadData() {
        var table = webix.$$("dangkysudung01Views");
        table.clearAll();
        table.load(table.config.url);
    }
    return {
        $ui: layout,
        $oninit: function (view, $scope) {
            var table = webix.$$("dangkysudung01Views");
            webix.extend(view, webix.ProgressBar);
            $scope.on(app, "dataChangeDangkysudung68", function (mode, item) {
                if (mode == 1) {
                    table.clearAll();
                    table.load(table.config.url);
                }
                if (mode == 2) {
                    table.clearAll();
                    table.load(table.config.url);
                }
            });
            $scope.on(app, "filterTable", function (report_id, infoWindowId, item) {
                var infoparam = {
                    infowindow_id: infoWindowId,
                    parameter: item,
                };
                table.config.infoparam = infoparam;
                table.clearAll();
                table.load(table.config.url);
            });
        },
        $onurlchange: function (ui, name, url, scope) {
            initUI();
        }
    };
});
define('views/forms/forms70/BienLai/70_receipForm',[
    "app",
    "locale",
    "models/user",
    "views/modules/Component/componentHelper",
    "views/modules/Component/eventTableHelper",
    "views/modules/Component/button",
    "views/modules/Component/functionExtension",
    "views/modules/Component/constantManager",
  ], function (app, _, user, componentHelper, eventTableHelper, buttonOptions, functionExtension, constant) {
    var editmode = 0;
    var tgtienBeforeEdit = 0;
    var isAddoOrEdit = true;
    var clickedItem = {}
    var isFinishedEditing = true;
    var afteredit = "";

    function refresher (components) {
      if (!components || !components.length) return;

      components.forEach(function(component) {
        if (component && typeof component.refresh === 'function') {
          component.refresh();
        }
      });
    }
    function hideComponents (ids, isParent = false) {
      ids.forEach(id => {
        if (isParent) {
          $$(id).getParentView().hide()
        } else {
          $$(id).hide();
        }
      });
    } 
    function getItem () {
      var table = webix.$$("invoiceViews");
      return item = table.getSelectedItem();
    }
    function addTotalValue(value){
      var tgtienso = $$(tgtiensoId);
      var tgtienchu = $$(tgtienchuId);
      var dvtt = $$(dvttId);
      tgtienso.setValue(tgtienso.getValue() + value);
      tgtienchu.setValue(
        functionExtension.DocTienBangChu(
          tgtienso.getValue().toString(),
          dvtt.getValue()
        )
      );
    }
    
    function setDieuchinhthaytheTitle (item, titleStarting) {
      var splitKhieu = (item.khieu || "").split("-");
      var mauso = splitKhieu[0] || "";
      var kyhieu = splitKhieu[1] || "";

      webix
        .$$(invoiceHeadId)
        .setHTML(
          titleStarting +
          " cho biên lai có mẫu số " +
            mauso +
            ", ký hiệu " +
            kyhieu +
            ", số " +
            item.shdon +
            ", ngày " +
            webix.Date.dateToStr("%d/%m/%Y")(new Date(item.tdlap))
        );
    }

    var dauphieuHoadon = componentHelper.dauphieuHoadon();
    var btnChitietHoadon = componentHelper.btnChitietHoadon();
    var headTitleHoadon = componentHelper.headTitleHoadon("Biên lai thu phí, lệ phí không in sẵn mệnh giá");
    
    var btnSaveBienlai = buttonOptions.btnSaveBienlai();
    var btnSaveHoadonThayThe = buttonOptions.btnSaveHoadonThayThe();
    var btnSaveHoadonDieuChinh = buttonOptions.btnSaveHoadonDieuChinh();
    

    var mahanghoaHoadon = componentHelper.mahanghoaHoadon(); mahanghoaHoadon.maxLength = 50;
    mahanghoaHoadon.label = "Mã phí, lệ phí";
    mahanghoaHoadon.width = 200;
    var colTienSauThue = componentHelper.numeric("tgtien", "Thành tiền");
    var windowId = "invoice68";
    var formId = "invoiceForms";
    var datatableDetail = "hoadon68_chitiet";
    
    var bienlaiFormId = "info-invoice";
    var stknmuaId = 'stknmua'
    var tendvId = 'ten'
    var emailnbanId = "emailnban";
    var ngaylapId= "tdlap";
    var sobielaiId= "shdon"
    var stkbenbanId = "stknban";
    var nghangbenbanId = "nganhang_ngban";
    var maChId = "ma_ch";
    var manguoinopId = "mnmua";
    var tennguoimuaId = "tnmua";
    var tenChId = "ten_ch";
    var sohchieuId = "so_hchieu";
    var dvttId = "dvtte";
    
    var customerFormId = "info-customer";
    var allowEditId = "check_congthuc";
    var checkchietkhauId = "check_chietkhau";
    var tinhchatId = "check_tinhctmathang";
    var theokhieuId = "theokhkhac";
    var emailnguoinopId = "email";
    
    var tgtiensoId = "tgtttbso"; 
    var tgtienchuId = "tgtttbchu"; 
    
    var invoiceHeadId = "head-formInvoice";
    var kyhieuId = "kyhieu_id";
    
    var ngaybienlai32Id = "ngay_hd32";
    var sobienlai32Id = "so_hd32";
    var loaibienlai32Id = "loai_hd32";
    var mauso32Id = "mauso_hd32";
    var kyhieu32Id = "kyhieu_hd32";
    
    function set32Value (title) {
      var loaibienlai32 = $$(loaibienlai32Id)
      if (!loaibienlai32) return; 
      
      var ngaybienlai32 = $$(ngaybienlai32Id)
      var mauso32 = $$(mauso32Id);
      var kyhieu32 = $$(kyhieu32Id);
      var sobienlai32 = $$(sobienlai32Id)
      var loaibienlaiList = loaibienlai32.getList()
      var loaibienlaiPopup = loaibienlai32.getPopup()
      var parent = ngaybienlai32.getParentView().getParentView();
      var label = parent.getChildViews()[0];

      ngaybienlai32.define("label", "Ngày biên lai")
      sobienlai32.define("label", "Số biên lai")
      loaibienlai32.define("label", "Loại biên lai")
      mauso32.define("attributes", {maxLength: 10})
      kyhieu32.define("attributes", {maxLength: 8})

      refresher([ngaybienlai32, sobienlai32, loaibienlai32, mauso32, kyhieu32])
      
      loaibienlai32.attachEvent("onItemClick", function () {
        setTimeout(
          function () {
            var popupDom = loaibienlaiPopup.$view
            var listDom = loaibienlaiList.$view;
            popupDom.style["transition-duration"] = "0s";
            popupDom.style.width = "325px";
            listDom.style["transition-duration"] = "0s";
            listDom.style.width = "100%";
          }, 100
        )
      })
      
      loaibienlaiList.clearAll()
      loaibienlaiList.parse([
        {id: 3, value: "Biên lai không in sẵn mệnh giá NĐ 70/2025/ND-CP "},
        {id: 4, value: "Biên lai in sẵn mệnh giá NĐ 70/2025/NĐ-CP"},
        {id: 6, value: "Biên lai Nghị định 51/2010/NĐ-CP" }
      ])
      loaibienlai32.attachEvent("onChange", function (newv) {
        switch (newv) {
          case 3:
            mauso32.setValue("ELB01")
            kyhieu32.setValue("25T")
            break;
          case 4:
            mauso32.setValue("ELB02")
            kyhieu32.setValue("25T")
            break;
          case 6:
            mauso32.setValue("")
            kyhieu32.setValue("")
            break;
        }
      });
      label.define("template", "<span style ='text-transform: none;color: black;'>" + title + "</span>")
      parent.addView({
        view: "text",
        id: "gchu",
        name: "gchu",
        label: "Ghi chú"
      })
    }
    return {
      $ui: {
        view: "window",
        modal: true,
        position: "center",
        css: "headformchil",
        head: headTitleHoadon,
        id: windowId,
        resize: true,
        fullscreen: true,
        move: true,
        on: {
          onBeforeShow: function () {
              var type = 8;
                    var promise = eventTableHelper.OnBeforeShowForm(editmode, type);
                    if (typeof promise === 'string') {
                        afteredit = promise;
                    } else {
                        Promise.resolve(promise).then(function (value) {
                            afteredit = value.json().data;
                            webix.storage.local.put(`${constant.CACHE.AFTER_EDIT}${type}`, value.json().data);
                        })
                    }
          },
          onShow: function () {
            var bienlaiForm = $$(bienlaiFormId);
            bienlaiForm.getParentView().define("label", "Thông tin biên lai");

            var ngaylap = $$(ngaylapId)
            ngaylap.define("label", "Ngày biên lai");
            var sobienlai = $$(sobielaiId)
            sobienlai.define("label", "Số biên lai")
            var stkbenban = $$(stkbenbanId)
            stkbenban.define("label", "TK Bên Bán")
            var nganhangbenban = $$(nghangbenbanId)
            nganhangbenban.define("label", "NH Bên Bán")
            var manguoinop = $$(manguoinopId)
            manguoinop.define("label", "Mã người nộp")
            var tennguoimua = $$(tennguoimuaId)
            tennguoimua.define("label", "Tên người nộp")
            tennguoimua.define("attributes", { maxLength: 400 })
            var emailnguoinop = $$(emailnguoinopId)
            emailnguoinop.define("attributes", { maxLength: 50 })
            var customerForm = $$(customerFormId)
            customerForm.getParentView().define("label", "Thông tin người/ đơn vị nộp tiền");
            var tendv = $$(tendvId);
            tendv.define("label", "Tên đơn vị nộp");

            refresher([tendv, ngaylap, sobienlai, stkbenban, nganhangbenban, manguoinop, tennguoimua, emailnguoinop, bienlaiForm.getParentView(), customerForm.getParentView()])

            hideComponents([stknmuaId, emailnbanId], true)
            hideComponents([maChId, tenChId, sohchieuId, checkchietkhauId, tinhchatId, theokhieuId])

            $$(allowEditId).setValue(true)

            addTotalValue(0)
          },
        },
        body: {
          paddingY: 10,
          paddingX: 10,
          elementsConfig: { labelWidth: 100 },
          view: "form",
          id: formId,
          width: 800,
          height: 500,
          complexData: true,
          margin: 0,
          elements: [
            {
              view: "scrollview",
              scroll: "y",
              body: {
                paddingX: 18,
                rows: [
                  dauphieuHoadon,
                  {
                    borderless: true,
                    view: "tabview",
                    scrollX: true,
                    tabbar: {
                      width: 200,
                    },
                    cells: [
                      {
                        header: "Chi tiết biên lai",
                        select: "cell",
                        body: {
                          rows: [
                            btnChitietHoadon,
                            {
                              view: "datatable",
                              resizeColumn: true,
                              id: datatableDetail,
                              editable: true,
                              select: "cell",
                              // height: 260,
                              drag: true,
                              columns: [
                                {
                                  id: "stt",
                                  header: "",
                                  width: 30,
                                  editable: true,
                                  editor: "text",
                                },
                                {
                                  id: "stt_rec",
                                  header: "STT",
                                  width: 40,
                                  editable: true,
                                  editor: "text",
                                },
                                mahanghoaHoadon,
                                {
                                  id: "ten",
                                  header: _("Tên phí, lệ phí"),
                                  editor: "text",
                                  width: 350,
                                  editable: true,
                                },
                                colTienSauThue,
                              ],
                              on: {
                                "data->onStoreUpdated": function () {
                                  this.data.each(function (obj, i) {
                                    obj.stt = i + 1;
                                  });
                                },
                                onKeyPress: function (code, e) {
                                  var table = this;
                                  if (e.key == "F8") {
                                    $$("removerow").callEvent("onItemClick");
                                  }
                                  if (e.key == "F9") {
                                    $$("addrow").callEvent("onItemClick");
                                  }
                                  if (e.key == "F7") {
                                    $$("copyrow").callEvent("onItemClick");
                                  }
                                },
                                onAfterEditStop: function (state, editor) {
                                  var table = $$(this.config.id);
                                  var selectedItem = table.getItem(editor.row);

                                  if (
                                    editor.column == "ma" &&
                                    state.old != state.value
                                  ) {
                                    selectedItem.tgtien = selectedItem.gia_ban;
                                  }
                                  var tgtien = selectedItem.tgtien
                                    ? selectedItem.tgtien
                                    : 0;
                                  addTotalValue(-tgtienBeforeEdit + tgtien);
                                  isFinishedEditing = true;
                                },
                                onAfterDelete: function () {
                                  if (!clickedItem || !clickedItem.tgtien)
                                    return;
                                  addTotalValue(-clickedItem.tgtien)
                                },
                                onAfterAdd: function (id) {
                                  var newItem = this.getItem(id)
                                  if (newItem.tgtien) {
                                    addTotalValue(newItem.tgtien)
                                  }
                                },
                                onItemClick: function (id) {
                                  clickedItem = this.getItem(id);
                                },
                                onValidationError: function (id, obj, details) {
                                  eventTableHelper.ValidateError(
                                    this,
                                    id,
                                    obj,
                                    details
                                  );
                                },
                                //! the sequence of events would be start > start > end if 2 editing events happen next to each other
                                //* isFinishedEditing ensures editing event lifecycle start > end must be done before actions
                                onBeforeEditStart: function (obj) {
                                  var table = $$(this.config.id);
                                  var selectedItem = table.getItem(obj.row);
                                  function saveBeforeEditValue() {
                                    tgtienBeforeEdit = selectedItem.tgtien || 0;
                                    isFinishedEditing = false;
                                  }
                                  if (isFinishedEditing) {
                                    saveBeforeEditValue();
                                  } else {
                                    setTimeout(saveBeforeEditValue, 100);
                                  }
                                  return eventTableHelper.BeforEditRow(
                                    this,
                                    obj
                                  );
                                },
                              },
                              rules: {
                                tchat: webix.rules.isNotEmpty,
                                $obj: webix.rules.validateMoney,
                              },
                              ready: function () {
                                this.validate();
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                  {
                    css: "regiontongtien",
                    rows: [
                      {
                        view: "text",
                        id: "tgtttbchu",
                        name: "tgtttbchu",
                        clear: true,
                        readonly: true,
                        width: 1,
                        height: 1,
                      },
                      {
                        align: "right",
                        body: {
                          view: "text",
                          id: "tgtttbso",
                          name: "tgtttbso",
                          css: "txtTongtien",
                          label: "Tổng tiền",
                          clear: true,
                          readonly: true,
                          width: 350,
                          format: "1.111",
                        },
                      },
                      { height: 10 },
                    ],
                  },
                  { height: 10 },
                  {
                    margin: 10,
                    cols: [
                      {},
                      btnSaveBienlai,
                      btnSaveHoadonThayThe,
                      btnSaveHoadonDieuChinh,
                      {
                        view: "button",
                        hotkey: "esc",
                        label: "Hủy bỏ (ESC)",
                        align: "center",
                        type: "danger",
                        width: 120,
                        click: function () {
                          this.getTopParentView().close();
                        },
                      },
                      {},
                    ],
                  },
                ],
              },
            },
          ],
        },
      },
      setValues: function (item, winconfig, params) {
        var win = $$(this.$ui.id);
        var form = win.getChildViews()[1];
        if (item.tthdon == 2 || item.tthdon == 3) {
          if (item != null) {
            var url =
              app.config.host +
              "/Invoice68/GetInvoiceById?id=" +
              item.hdlket_id;
            webix
              .ajax()
              .headers({ "Content-type": "application/json" })
              .get(url, function (text) {
                var data = JSON.parse(text);

                if (data.code == "00") {
                  if (item.tthdon == 2) {
                    webix
                      .$$(invoiceHeadId)
                      .setHTML(
                        "Biên lai điều chỉnh cho biên lai số " +
                          data.data.shdon +
                          " ký hiệu " +
                          data.data.khieu
                      );
                    webix.$$(invoiceHeadId).refresh();
                  }
                  if (item.tthdon == 3) {
                    webix
                      .$$(invoiceHeadId)
                      .setHTML(
                        "Biên lai thay thế cho biên lai số " +
                          data.data.shdon +
                          " ký hiệu " +
                          data.data.khieu
                      );
                    webix.$$(invoiceHeadId).refresh();
                  }
                }
              });
          }
        }
        if (item != null) {
          item["tdlap"] = removeTimeZoneT(item["tdlap"]);
          item["ngayvb"] = removeTimeZoneT(item["ngayvb"]);
          item["ngay_hd32"] = removeTimeZoneT(item["ngay_hd32"]);
          item["ngay_hs"] = item["ngay_hs"] ? removeTimeZoneT(item["ngay_hs"]) : "";
          //item["hoadon68_id"] = null;
          $$("check_tinhctmathang").setValue(item["theomh"]);
          form.setValues(item);
          // $$("tgtthue").setValue(item.tgtthue);

          var tableDetail = webix.$$("hoadon68_chitiet");
          var url =
            app.config.host + "/Invoice68/GetDetailInvoice?id=" + item.id;
          tableDetail.clearAll();
          tableDetail.load(url);
        }

        if (editmode == 2) {
        }
        // nếu có mẫu 04 (hóa đơn thay thế cũ)
        if (winconfig != null) {
          mau04 = winconfig;
          var cctbao_id = $$("kyhieu_id").getValue();
          var khieu = $$("kyhieu_id").getText();
          var form = $$("invoiceForms");
          var values = form.getValues();
          values["khieu"] = khieu;
          form.setValues(values);
          $$("btnHoadonSaveThayThe").show();
          $$("btnHoadonSave").destructor();
        }
      },
      setEditMode: function (mode) {
        editmode = mode;
        var form = $$(this.$ui.id);
        form.config.editmode = mode;
        var icon = "";
        switch (editmode) {
          case 1:
            icon = "<span><i class='fa fa-plus' aria-hidden='true'></i></span>";
            break;
          case 2:
            icon = "<i class='fa fa-edit' aria-hidden='true'></i>";
            break;
          default:
            icon = "<i class='fa fa-trash fa-lg' aria-hidden='true'></i>";
            break;
        }
        webix.$$("head-iconInvoice").setHTML(icon);
        webix.$$("head-iconInvoice").refresh();
        var kyhieu = $$(kyhieuId)
        var item = getItem()
        if (item && item.is_tthdon == 2) {
          set32Value("Biên lai bị điều chỉnh")
        } else if (item && item.is_tthdon == 3) {
          set32Value("Biên lai bị thay thế")
        }
        if (kyhieu.getText() == "EBL02-25T" && isAddoOrEdit) {

          $$(invoiceHeadId).setHTML("Biên lai thu, lệ phí in sẵn mệnh giá");
        }
      },
      copyValues: function (item) {
        eventTableHelper.InvoiceCopy(item);
      },
      initUINew: function (cctbao_id, khieu) {
        var form = $$("invoiceForms");
        var values = form.getValues();
        values["khieu"] = khieu;
        values["cctbao_id"] = cctbao_id;
        form.setValues(values);
      },
      initUIDieuchinh: function (dataDetail, hdlket_id) {
        eventTableHelper.InvoiceAdjustment();
        var item = getItem();
        isAddoOrEdit = false;

        setDieuchinhthaytheTitle(item, "Điều chỉnh")
      },
      initUIThaythe: function (invoiceBase) {
        eventTableHelper.InvoiceReplacement(invoiceBase);
        var item = getItem();
        isAddoOrEdit = false;
        setDieuchinhthaytheTitle(item, "Thay thế")
      },
      initUIThaytheTT32: function () {
        eventTableHelper.InvoiceReplacement32();
        webix.$$(invoiceHeadId).setHTML("Biên lai thay thế");
        set32Value("Thông tin biên lai bị thay thế");
        isAddoOrEdit = false
      },
      initUIDieuchinhTT32: function () {
        eventTableHelper.InvoiceAdjustment32();
        webix.$$(invoiceHeadId).setHTML("Biên lai diều chỉnh");
        set32Value("Thông tin biên lai bị điều chỉnh");
        isAddoOrEdit = false;
      },
      initUIDieuchinhTT32Edit: function () {
        webix.$$(invoiceHeadId).setHTML("Biên lai điều chỉnh");
        webix.$$(invoiceHeadId).refresh();
        var info = componentHelper.dcttHoadon32(2);
        $$(bienlaiFormId).addView(info, 10);
      },
    };

});


define('views/modules/Component/signService',["app", "locale", "views/modules/Component/constantManager"], function (app, _, Constant) {
    function getCertColumns(fields) {
        const columnMap = {
            chon: {
                id: "chon", header: _("CHON"), width: 65,
                checkValue: true, uncheckValue: false, template: "{common.checkbox()}"
            },
            so_serial: { id: "so_serial", header: _("SO_SERIAL"), width: 150 },
            subjectname: { id: "subjectname", header: _("SUBJECTNAME"), width: 450 },
            ngaybatdau: { id: "ngaybatdau", header: _("NGAY_BAT_DAU"), width: 200 },
            ngayketthuc: { id: "ngayketthuc", header: _("NGAY_KET_THUC"), width: 200 },
            issuer: { id: "issuer", header: _("DONVI"), width: 450 },
            libraryName: { id: "libraryName", header: _("Loại"), width: 150 }
        };
        return fields.map(f => columnMap[f]);
    }
    function showCertSelectionModal(title, dataUrl, columns, onConfirm) {
        var box = webix.modalbox({
            title: title,
            buttons: ["Nhận", "Hủy bỏ"],
            text: "<div id='ctnCerts'></div>",
            top: 100,
            width: 750,
            callback: function (result) {
                if (result === "1") {
                    webix.modalbox.hide(box);
                } else if (result === "0") {
                    var table = $$("tblCerts");
                    var data = table.serialize();
                    var cert = data.find(x => x.chon === true);
                    onConfirm(cert);
                }
            }
        });

        var popupText = document.getElementsByClassName("webix_popup_text")[0];
        if (popupText) popupText.style.paddingTop = 0;

        webix.ui({
            container: "ctnCerts",
            id: "tblCerts",
            view: "datatable",
            borderless: true,
            resizeColumn: true,
            height: 350,
            columns: columns,
            url: dataUrl
        });
    }

    function SignService(windowView, gridInvoice, id, apiUrl, tagSignature) {
        var signTypeUrl = apiUrl.signTypeUrl;
        var exportXmlUrl = apiUrl.exportXmlUrl;
        var signXmlUrl = apiUrl.signXmlUrl;
        var showPinUrl = apiUrl.showPinUrl;
        var saveXmlUrl = apiUrl.saveXmlUrl;
        var certUrl = apiUrl.certUrl;

        function enableUI() {
            windowView.enable();
            windowView.hideProgress();
        }
        function disableUI() {
            webix.extend(windowView, webix.ProgressBar);
            windowView.disable();
            windowView.showProgress();
        }
        function reloadGrid() {
            if (gridInvoice) {
                gridInvoice.clearAll();
                gridInvoice.load(gridInvoice.config.url);
            }
        }
        function signSuccess() {
            webix.message("Ký thành công", "success");
            reloadGrid();
        }
        function showError(msg) {
            webix.message(msg || "Có lỗi khi ký", "error");
        }
        function callSignApi(reqData) {
            disableUI();
            webix.ajax()
                .headers({ 'Content-Type': 'application/json' })
                .post(signXmlUrl, reqData, {
                    error: function () { enableUI(); },
                    success: function (text) {
                        enableUI();
                        const response = JSON.parse(text);
                        if (response.code !== "00") return showError(response.message);
                        signSuccess();
                    }
                });
        }

        var dataRequest = {
            mode: 0,
            tokenInfo: {
                serial: null,
                authData: null,
                credentialID: null,
                uuId: null,
                userName: null,
                password: null,
                pinCode: null,
                certData: null
            },
            signInfo: [
                {
                    id: id,
                    tagId: id,
                    tagSignature: tagSignature,
                    xml: null,
                    apiExportXml: null,
                    apiSaveXml: null,
                    message: null
                }
            ]
        };
        var a = webix.ajax(signTypeUrl);
        var b = webix.ajax(exportXmlUrl);
        disableUI();
        webix.promise.all([a, b]).then(function (results) {
            enableUI();
            var kytaptrung = results[0].json();
            var xmlData = results[1].json();
            var mode = kytaptrung[0].gia_tri;
            switch (mode.toUpperCase()) {
                case "FILE":
                    var certColumns, onCertConfirm;
                    certColumns = getCertColumns(["chon", "so_serial", "subjectname", "ngaybatdau", "ngayketthuc", "issuer"]);
                    onCertConfirm = function (cert) {
                        if (!cert) return showError("Bạn chưa chọn chứng thư số");

                        disableUI();
                        dataRequest.mode = 1;
                        dataRequest.tokenInfo.serial = cert.so_serial;
                        dataRequest.tokenInfo.password = cert.pass;
                        dataRequest.tokenInfo.certData = cert.data;
                        dataRequest.signInfo[0].xml = xmlData;
                        dataRequest.signInfo[0].tagSignature = tagSignature.split('/').pop();
                        callSignApi(dataRequest);
                    };
                    showCertSelectionModal("Chọn chứng thư số", certUrl, certColumns, onCertConfirm);

                    break;
                case "ICA":
                    var certColumns, onCertConfirm;
                    certColumns = getCertColumns(["chon", "libraryName", "so_serial", "subjectname", "ngaybatdau", "ngayketthuc", "issuer"]);
                    onCertConfirm = function (cert) {
                        if (!cert) return showError("Bạn chưa chọn chứng thư số");

                        cert.id = id;
                        cert.tagSign = "/TCTPhi";
                        cert.tagSignId = id;

                        webix.ajax().headers({ 'Content-type': 'application/text' })
                            .get(showPinUrl, function (text, data, XmlHttpRequest) {
                                var response = JSON.parse(text);
                                if (response.show == true) {
                                    require(["views/forms/forms68/ICA/signICA"], function (signICA) {
                                        var frm = windowView.$scope.ui(signICA.$ui);
                                        signICA.initUI(cert, "bienban");
                                        webix.modalbox.hide();
                                        frm.show();
                                    });
                                }
                                else {
                                    dataRequest.mode = 2;
                                    dataRequest.tokenInfo.uuId = cert.agreementUUID;
                                    dataRequest.tokenInfo.pinCode = cert.pass;
                                    dataRequest.signInfo[0].xml = xmlData;

                                    callSignApi(dataRequest);
                                }
                            });
                    };
                    showCertSelectionModal("Chọn chứng thư số", certUrl, certColumns, onCertConfirm);

                    break;
                case "INTRUSTCA":
                    var certColumns, onCertConfirm;
                    certColumns = getCertColumns(["chon", "libraryName", "so_serial", "subjectname", "ngaybatdau", "ngayketthuc", "issuer"]);
                    onCertConfirm = function (cert) {
                        if (!cert) return showError("Bạn chưa chọn chứng thư số");

                        dataRequest.mode = 3;
                        dataRequest.tokenInfo.userName = cert.username;
                        dataRequest.tokenInfo.authData = cert.auth_data;
                        dataRequest.tokenInfo.certData = cert.cert_content;
                        dataRequest.tokenInfo.credentialID = cert.tokenSerial;
                        dataRequest.tokenInfo.pinCode = cert.pin_code;
                        dataRequest.signInfo[0].xml = xmlData;

                        callSignApi(dataRequest);
                    };
                    showCertSelectionModal("Chọn chứng thư số", certUrl, certColumns, onCertConfirm);
                    break;
                case "EASYCA":
                    var certColumns, onCertConfirm;
                    certColumns = getCertColumns(["chon", "libraryName", "so_serial", "subjectname", "ngaybatdau", "ngayketthuc", "issuer"]);
                    onCertConfirm = function (cert) {
                        if (!cert) return showError("Bạn chưa chọn chứng thư số");

                        cert.id = savedBienbanId;
                        cert.tagSign = "BIENBAN/DSCKS/NBan";
                        cert.tagSignId = "data";

                        webix.modalbox.hide();
                        require(["views/forms/forms68/EasyCA/signEasyCA"], function (signEasyCA) {
                            var frm = form.$scope.ui(signEasyCA.$ui);
                            signEasyCA.initUI(cert, "bienban");
                            frm.show();
                        });
                    };
                    showCertSelectionModal("Chọn chứng thư số", certUrl, certColumns, onCertConfirm);

                    break;
                default:
                    disableUI();
                    var b = webix.ajax(app.config.host + "/Pattern/GetListCertificates");
                    var c = webix.ajax(app.config.host + "/Pattern/GetSerialAcceptInvoice");
                    webix.promise.all([xmlData, b, c]).then(function (results) {
                        var xmlData = results[0];
                        var listcerts = results[1].json();
                        var listCertAccept = results[2].json();

                        if (listcerts.length == 0) {
                            enableUI();
                            showError("Bạn chưa được phân quyền chứng thư số");
                            return;
                        }
                        if (listCertAccept == undefined || listCertAccept.length == 0) {
                            enableUI();
                            showError("Đăng ký sử dụng hóa đơn NĐ 123 chưa được CQT chấp thuận.");
                            return;
                        }
                        require(["views/modules/minvoiceplugin"], function (plugin) {
                            var hub = plugin.hub();
                            var hubconnect = plugin.conn();

                            if (hubconnect.state != 1) {
                                enableUI();
                                webix.message("Quý khách hàng chưa cài Plugin ký hóa đơn hoặc Plugin ký hóa đơn chưa được bật !", "error");
                                var Form = form.$scope.ui(modalPlugin.$ui);
                                Form.show();
                                return;
                            }
                            hub.off('resCommand');
                            hub.on('resCommand', function (result) {
                                enableUI();
                                var responseSign = JSON.parse(result);
                                if (responseSign.hasOwnProperty("error")) return showError(responseSign.error);

                                var parameters = {
                                    xml: responseSign.xml,
                                    id: id
                                };
                                webix.ajax()
                                    .headers({ "Content-Type": "application/json" })
                                    .post(saveXmlUrl, parameters, function (text) {
                                        var response = JSON.parse(text);
                                        if (response.code != "00") return showError(response.message);
                                        signSuccess();
                                    });
                            });

                            var _listcerts = [];

                            for (var i = 0; i < listcerts.length; i++) {
                                var _cert = listcerts[i];

                                _listcerts.push({
                                    so_serial: _cert.so_serial,
                                    ngaybatdau: _cert.ngaybatdau,
                                    ngayketthuc: _cert.ngayketthuc,
                                    issuer: _cert.issuer,
                                    subjectname: _cert.subjectname
                                });
                            }

                            var arg = {
                                idData: "#" + id,
                                xml: xmlData,
                                shdon: "",
                                idSigner: "",
                                tagSign:  tagSignature.split("/").pop(),
                                listcerts: _listcerts,
                                certAccept: listCertAccept
                            };
                            hub.invoke('execCommand', 'SignXmlTag', JSON.stringify(arg))
                                .done(function () { console.log("Success !") })
                                .fail(function (error) { showError(error); });
                        });
                    }).fail(function () {
                        enableUI();
                        showError("Lỗi trong quá trình lấy dữ liệu ký biên bản");
                    });
            }
        }).catch((error) => {
            enableUI();
            showError(error);
        });
    }
  function SignMultiService(windowView, gridInvoice, ids, apiUrl, tagSignature, cert, refreshBtn) {
    var signTypeUrl = apiUrl.signTypeUrl;
    var exportXmlUrl = apiUrl.exportXmlUrl;
    var signXmlUrl = apiUrl.signXmlUrl;
    var showPinUrl = apiUrl.showPinUrl;
    var saveXmlUrl = apiUrl.saveXmlUrl;

    function enableUI() {
      windowView.enable();
      windowView.hideProgress();
    }
    function disableUI() {
      webix.extend(windowView, webix.ProgressBar);
      windowView.disable();
      windowView.showProgress();
    }
    function reloadGrid() {
      if (gridInvoice) {
        gridInvoice.clearAll();
        gridInvoice.load(gridInvoice.config.url);
      }
    }
    function signSuccess() {
      webix.message("Ký thành công", "success");
      reloadGrid();
    }
    function showError(msg) {
      webix.message(msg || "Có lỗi khi ký", "error");
    }
    function callSignApi(reqData, index) {
      disableUI();
      webix.ajax()
        .headers({ 'Content-Type': 'application/json' })
        .post(signXmlUrl, reqData, {
          error: function () { enableUI(); },
          success: function (text) {
            enableUI();
            const response = JSON.parse(text);
            if (response.code !== "00") return showError(response.message);
            signSuccess();
            refresh(index)
          }
        });
    }
    function refresh(index) {
      if (index + 1 == ids.length) {
        refreshBtn.callEvent("onClick")
      }
    }

    (async function () {
      for (let i = 0; i < ids.length; i++) {
        const id = ids[i];
        const index = i;
        var dataRequest = {
          mode: 0,
          tokenInfo: {
            serial: null,
            authData: null,
            credentialID: null,
            uuId: null,
            userName: null,
            password: null,
            pinCode: null,
            certData: null,
          },
          signInfo: [
            {
              id: id,
              tagId: id,
              tagSignature: tagSignature,
              xml: null,
              apiExportXml: null,
              apiSaveXml: null,
              message: null,
            },
          ],
        };
        var a = webix.ajax(signTypeUrl);
        var b = webix.ajax(exportXmlUrl + "?id=" + id);
        disableUI();
        const results = await webix.promise.all([a, b]);
        enableUI();
        var kytaptrung = results[0].json();
        var xmlData = results[1].json();
        var mode = kytaptrung[0].gia_tri;
        switch (mode.toUpperCase()) {
          case "FILE":
            var onCertConfirm;
            onCertConfirm = function () {
              if (!cert) return showError("Bạn chưa chọn chứng thư số");
              disableUI();
              dataRequest.mode = 1;
              dataRequest.tokenInfo.serial = cert.so_serial;
              dataRequest.tokenInfo.password = cert.pass;
              dataRequest.tokenInfo.certData = cert.data;
              dataRequest.signInfo[0].xml = xmlData;
              dataRequest.signInfo[0].tagSignature = tagSignature.split('/').pop();
              callSignApi(dataRequest, index);
            };
            onCertConfirm()

            break;
          case "ICA":
            var onCertConfirm;
            onCertConfirm = function () {
              if (!cert) return showError("Bạn chưa chọn chứng thư số");

              cert.id = id;
              cert.tagSign = "/TCTPhi";
              cert.tagSignId = id;

              webix
                .ajax()
                .headers({ "Content-type": "application/text" })
                .get(showPinUrl, function (text, data, XmlHttpRequest) {
                  var response = JSON.parse(text);
                  if (response.show == true) {
                    require(["views/forms/forms68/ICA/signICA"], function (
                      signICA
                    ) {
                      var frm = windowView.$scope.ui(signICA.$ui);
                      signICA.initUI(cert, "bienban");
                      webix.modalbox.hide();
                      frm.show();
                    });
                  } else {
                    dataRequest.mode = 2;
                    dataRequest.tokenInfo.uuId = cert.agreementUUID;
                    dataRequest.tokenInfo.pinCode = cert.pass;
                    dataRequest.signInfo[0].xml = xmlData;
                    callSignApi(dataRequest, index);
                  }
                });
            };
            onCertConfirm()

            break;
          case "INTRUSTCA":
            var onCertConfirm;
            onCertConfirm = function () {
              if (!cert) return showError("Bạn chưa chọn chứng thư số");

              dataRequest.mode = 3;
              dataRequest.tokenInfo.userName = cert.username;
              dataRequest.tokenInfo.authData = cert.auth_data;
              dataRequest.tokenInfo.certData = cert.cert_content;
              dataRequest.tokenInfo.credentialID = cert.tokenSerial;
              dataRequest.tokenInfo.pinCode = cert.pin_code;
              dataRequest.signInfo[0].xml = xmlData;

              callSignApi(dataRequest, index);
            };
            onCertConfirm()
            break;
          case "EASYCA":
            var onCertConfirm;
            onCertConfirm = function () {
              if (!cert) return showError("Bạn chưa chọn chứng thư số");

              cert.id = savedBienbanId;
              cert.tagSign = "BIENBAN/DSCKS/NBan";
              cert.tagSignId = "data";

              webix.modalbox.hide();
              require(["views/forms/forms68/EasyCA/signEasyCA"], function (
                signEasyCA
              ) {
                var frm = form.$scope.ui(signEasyCA.$ui);
                signEasyCA.initUI(cert, "bienban");
                frm.show();
              });
            };
            onCertConfirm()

            break;
          default:
            disableUI();
            var b = webix.ajax(
              app.config.host + "/Pattern/GetListCertificates"
            );
            var c = webix.ajax(
              app.config.host + "/Pattern/GetSerialAcceptInvoice"
            );
            const results = await webix.promise.all([xmlData, b, c]);
            var xmlData = results[0];
            var listcerts = results[1].json();
            var listCertAccept = results[2].json();

            if (listcerts.length == 0) {
              enableUI();
              showError("Bạn chưa được phân quyền chứng thư số");
              return;
            }
            if (
              listCertAccept == undefined ||
              listCertAccept.length == 0
            ) {
              enableUI();
              showError(
                "Đăng ký sử dụng hóa đơn NĐ 123 chưa được CQT chấp thuận."
              );
              return;
            }
            await new Promise((resolve, reject) => {
              require(["views/modules/minvoiceplugin"], function (plugin) {
                var hub = plugin.hub();
                var hubconnect = plugin.conn();

                if (hubconnect.state != 1) {
                  enableUI();
                  webix.message(
                    "Quý khách hàng chưa cài Plugin ký hóa đơn hoặc Plugin ký hóa đơn chưa được bật !",
                    "error"
                  );
                  var Form = form.$scope.ui(modalPlugin.$ui);
                  Form.show();
                  return;
                }
                hub.off("resCommand");
                hub.on("resCommand", function (result) {
                  enableUI();
                  var responseSign = JSON.parse(result);
                  if (responseSign.hasOwnProperty("error")) {
                    showError(responseSign.error);
                    reject(responseSign.error);
                    return;
                  }

                  var parameters = {
                    xml: responseSign.xml,
                    id: id,
                  };
                  webix
                    .ajax()
                    .headers({ "Content-Type": "application/json" })
                    .post(saveXmlUrl, parameters, function (text) {
                      var response = JSON.parse(text);
                      if (response.code != "00") {
                        showError(response.message);
                        reject(response.message);
                        return;
                      }
                      signSuccess();
                      resolve();
                    });
                });

                var _listcerts = [];

                for (var i = 0; i < listcerts.length; i++) {
                  var _cert = listcerts[i];

                  _listcerts.push({
                    so_serial: _cert.so_serial,
                    ngaybatdau: _cert.ngaybatdau,
                    ngayketthuc: _cert.ngayketthuc,
                    issuer: _cert.issuer,
                    subjectname: _cert.subjectname,
                  });
                }

                var arg = {
                  idData: "#" + id,
                  xml: xmlData,
                  shdon: "",
                  idSigner: "",
                  tagSign: tagSignature.split("/").pop(),
                  listcerts: _listcerts,
                  certAccept: listCertAccept,
                };
                hub
                  .invoke(
                    "execCommand",
                    "SignXmlTag",
                    JSON.stringify(arg)
                  )
                  .done(function () {
                    console.log("Success !");
                  })
                  .fail(function (error) {
                    showError(error);
                    reject(error);
                  });
              });
            });
            await new Promise(resolve => setTimeout(resolve, 300));
            break;
        }
      }
      if (refreshBtn) {
        refreshBtn.callEvent("onClick");
      }
    })();
  }
    return {
        Sign: SignService,
        SignMulti: SignMultiService
    }
});

define('views/70_receip',[
  "app",
  "locale",
  "models/user",
  "views/modules/Component/constantManager",
  "views/forms/forms70/BienLai/70_receipForm",
  "views/forms/forms68/HDon/68_huyhoadon",
  "views/forms/forms68/HDon/68_dieuchinhhoadon",
  "views/forms/forms68/68_viewLogForm",
  "views/forms/forms68/HDon/68_sendEmailForm",
  "views/modules/Component/button",
  "views/forms/forms68/HDon/68_kynhieuhoadon",
  "views/modules/Component/grid",
  "views/modules/Component/componentHelper",
  "views/modules/Component/eventTableHelper",
  "views/forms/forms68/EXCEL/68_uploadExcel",
  "views/forms/forms68/EXCEL/68_uploadExcel_chitiet",
  "views/forms/forms68/HDon/68_petro",
  "views/forms/forms70/BangKe/bangkeForm",
  "views/forms/forms70/BangKe/hoadonChietKhauForm",
  "views/modules/Component/signService",
  "views/menus/version",
], function (app, _, user, constant, invoiceForms, huyhoadon, dieuchinhhoadon, viewLogForm,
  sendEmailForm, buttonOption, signMultiReceip, gridInvoice, componentHelper, eventTableHelper,
  uploadExcel, uploadExcelDetail, petroForm, bangkeForm, hdonchietkhauForm, signService, version) {
  'use strict';

  var uploadFileModalId = "uploadfile-win78";

  var chucNangComponent = buttonOption.subChucnang(huyhoadon, invoiceForms, dieuchinhhoadon, 5, bangkeForm, hdonchietkhauForm);
  var chucnangComponentClone = deepClone(chucNangComponent)

  chucnangComponentClone.data[0].value = "Lập biên lai thay thế";
  chucnangComponentClone.data[1].value = "Lập biên lai điều chỉnh";
  chucnangComponentClone.data[3].value = "Thay thế biên lai hệ thống khác";
  chucnangComponentClone.data[4].value = "Điều chỉnh biên lai hệ thống khác ";
  chucnangComponentClone.data = removeItemsByIndex([5, 6], chucnangComponentClone.data)
  chucnangComponentClone.on = {
    onItemClick: function (id) {
      var type = 5;
      var record = this.getItem(id);
      var table = webix.$$("invoiceViews");
      var item = table.getSelectedItem();
      var cctbao_id = $$("kyhieu_id").getValue();
      var dataOptions = $$("kyhieu_id").getList().getItem(cctbao_id);

      this.hide();

      function showErrorIfNoSelection() {
        if (item) return false;
        webix.message("Bạn chưa chọn biên lai", "error");
        return true;
      }

      switch (record.id) {
        case "thaythe":
          if (showErrorIfNoSelection()) return;
          if ([0, 3, 4].indexOf(item.tthdon) === -1) return showError("Chỉ được phép thay thế biên lai gốc, biên lai giải trình hoặc biên lai thay thế !");
          if (item.tthai === "Chờ ký" || item.tthai === "Chờ duyệt") return showError("Biên lai đang ở trạng thái chờ ký, không thể thay thế !");
          //! window must be defined before calling component helper
          var winThayThe = table.$scope.ui(invoiceForms.$ui);
          if (type !== 6) componentHelper.changeDauphieuHoadon(table, type, item.khieu[4] === "M");

          invoiceForms.initUIThaythe(item);
          invoiceForms.setEditMode(1, dataOptions.loai_doanh_nghiep);
          $$("btnChonHangHoa").show();
          winThayThe.show();
          break;

        case "dowloadXml":
          if (showErrorIfNoSelection()) return;
          if (item.tthai === "Chờ ký") return showError("Biên lai đang ở trạng thái chờ ký, không thể tải XML !");

          webix.extend(table, webix.ProgressBar);
          table.disable();
          table.showProgress();

          webix.ajax()
            .response("arraybuffer")
            .get(constant.API.INVOICE_EXPORT_XML + item.hoadon68_id, function (text, data) {
              table.enable();
              table.hideProgress();
              var file = new Blob([data], { type: "application/xml" });
              webix.html.download(file, item.mst + "-" + item.khieu + "-" + item.shdon + ".xml");
            });
          break;

        case "dieuchinh":
          if (showErrorIfNoSelection()) return;

          if ([0, 7, 4].indexOf(item.is_tthdon) === -1) return showError("Chỉ được Điều chỉnh biên lai trạng thái Mới, Giải trình, Bị điều chỉnh, Giải trình.");
          if (item.tthai === "Chờ ký" || item.tthai === "Chờ duyệt") return showError("Chỉ cho phép điều chỉnh biên lai Đã gửi, Đã ký");
          //! same problem as winThayThe
          var winDC = table.$scope.ui(invoiceForms.$ui);
          if (type !== 6) componentHelper.changeDauphieuHoadon(table, type, item.khieu[4] === "M");

          invoiceForms.initUIDieuchinh(null, null);
          invoiceForms.setEditMode(1, dataOptions.loai_doanh_nghiep);

          $$("khieu").define("readonly", false);
          $$("khieu").define("css", "mcls_unreadonly");
          $$("khieu").refresh();

          $$("btnHoadonSaveDieuChinh").show();
          $$("btnHoadonSave").destructor();
          $$("btnChonHangHoa").show();
          winDC.show();
          break;

        case "dieuchinh32":
          var winDC32 = table.$scope.ui(invoiceForms.$ui);
          invoiceForms.initUIDieuchinhTT32();
          invoiceForms.setEditMode(1, dataOptions.loai_doanh_nghiep);
          winDC32.show();
          break;

        case "thaythe32":
          var winTT32 = table.$scope.ui(invoiceForms.$ui);
          invoiceForms.initUIThaytheTT32();
          invoiceForms.setEditMode(1, dataOptions.loai_doanh_nghiep);
          winTT32.show();
          break;
      }
    }
  };

  var subChucNang = webix.ui(chucnangComponentClone);
  var btnEmail = deepClone(buttonOption.btnEmail(sendEmailForm));
  var btnCopy = buttonOption.btnCopy(invoiceForms, 5, petroForm);
  var btnDelete = buttonOption.btnDelete();
  var btnEdit = buttonOption.btnEdit(invoiceForms, 8, petroForm);
  var btnAdd = buttonOption.btnAdd(invoiceForms, 5, petroForm);
  var btnRefresh = buttonOption.btnRefresh();
  var cbGetAllClone = deepClone(buttonOption.cbGetAll());
  var signMultiReceipClone = deepClone(signMultiReceip)
  signMultiReceipClone.$ui.head.cols[0].template = '<div>Ký biên lai chờ ký<div/>'
  signMultiReceipClone.$ui.body.elements[1].options.url = app.config.host + "/Invoice68/GetTypeInvoiceSeries?type=EBL"
  signMultiReceipClone.$ui.body.elements[3].template = "Danh sách biên lai chờ ký"
  signMultiReceipClone.$ui.body.elements[4].columns[3].header = "Ngày biên lai"
  signMultiReceipClone.$ui.body.elements[4].columns[4].header = "Số biên lai"
  signMultiReceipClone.$ui.body.elements[6].cols[1].id = "multiSigbRefreshBtn"
  signMultiReceipClone.$ui.body.elements[6].cols[3].label = "Ký biên lai (F11)"
  signMultiReceipClone.$ui.body.elements[6].cols[3].on.onClick = function () {
    var table = $$("tblHoadon");
    var txtCer = $$("txtCerSerial");
    var cert = txtCer.getList().getSelectedItem();
    var rowsData = table.serialize();
    var ids = []
    rowsData.forEach(function (item) {
      if (item.chon1 == "C") {
        ids.push(item.hoadon68_id)
      }
    })
    var refreshBtn = $$("multiSigbRefreshBtn");
    var grid = $$("invoiceViews");
    var windowView = $$("frmView");
    var apiUrl = {
      certUrl: constant.API.TOKEN_CERT_AUTO,
      signTypeUrl: constant.API.INVOICE_GET_TYPE_SIGN,
      exportXmlUrl: constant.API.RECEIP.GET_XML,
      signXmlUrl: constant.API.RECEIP.SIGN,
      showPinUrl: constant.API.TOKEN_SHOW_PIN,
      saveXmlUrl: constant.API.RECEIP.SAVE_XML,
    };
    signService.SignMulti(windowView, grid, ids, apiUrl, "BLai/DSCKS/TCTPhi", cert, refreshBtn);
  }
  signMultiReceipClone.$ui.body.elements[6].cols = removeItemsByIndex([2], signMultiReceipClone.$ui.body.elements[6].cols)
  var btnKyNhieuBienlai = deepClone(buttonOption.btnKyNhieuHoadon(signMultiReceipClone, 2));

  cbGetAllClone.labelRight = "Xem toàn bộ BL"
  btnKyNhieuBienlai.label = '<i class="fa fa-paper-plane fa-lg" aria-hidden="true"></i><span class="text"> ' + _("Ký nhiều biên lai") + "</span>"
  btnKyNhieuBienlai.tooltip = "Ký nhiều biên lai";
  btnEmail.on = {
    onClick: function () {
      webix.callEvent("onLoadError");
      var table = webix.$$("invoiceViews");
      if (table.getColumnConfig("colMultiChoice") == undefined) {
        var item = table.getSelectedItem();
        if (item == null || item == undefined) return showError("Bạn chưa chọn biên lai cần gửi email !");
        if (item.tthai == "Đã gửi" && item.is_success == 0) return showError("Biên lai có lỗi không thể gửi email !");
        if (item.tthai == "Chờ ký") return showError("Biên lai chưa ký không thể gửi email !");

        var dataPost = { id: item.hoadon68_id, type: "Gửi hóa đơn", };
        webix.ajax().headers({ "Content-type": "application/json" })
          .post(constant.API.INVOICE_TEMP_EMAIL, dataPost, {
            error: function (text, data, XmlHttpRequest) { },
            success: function (text, data, XmlHttpRequest) {
              var data = JSON.parse(text);
              if (data.code == "00") {
                var json = data.data;
                var itemData = {
                  nguoi_gui: json.nguoi_gui,
                  tieude: json.tieu_de,
                  noidung: json.noi_dung,
                  mat_khau: json.pass,
                  hoadon68_id: item.hoadon68_id,
                  type: "Gửi hóa đơn",
                  nguoinhan: item.email,
                  his_email: json.his_email,
                  bcc: json.bcc,
                };
                var win = table.$scope.ui(sendEmailForm.$ui);
                sendEmailForm.setValues(itemData);
                win.show();
                var headForm = $$("head-form")
                headForm.define("template", "<div>Gửi biên lai cho khách hàng qua email<div/>")
                headForm.refresh()
              } else {
                webix.message(data.message, "error");
              }
            },
          });
      } else {
        sendEmailMulti();
      }
    }
  }

  var subOption = function (excelModal, excelModalDetail, typeInvoice,) {
    var options = [
      { id: "excel", value: "Tạo biên lai từ file excel", icon: "mdi mdi-file-excel-outline", },
      { id: "excelDetail", value: "Nhận excel vào chi tiết biên lai", icon: "mdi mdi-file-document-plus-outline", },
    ];
    var optionsBtn = webix.ui({
      view: "submenu",
      width: 300,
      padding: 0,
      data: options,
      on: {
        onItemClick: function (id,) {
          var record = this.getItem(id);
          this.hide();
          var table = webix.$$("invoiceViews");
          var item = table.getSelectedItem();
          webix.callEvent("onLoadError");
          switch (record.id) {
            case "excel":
              var excelForm = table.$scope.ui(excelModal.$ui);
              excelModal.setTypeInvoice(typeInvoice);
              excelForm.show();
              $$(uploadFileModalId).getHead().setHTML("Nhận Excel biên lai");
              break;
            case "excelDetail":
              if (item == null) return showError("Bạn chưa chọn biên lai");
              if (item.tthai != "Chờ ký" && item.tthai != "Chờ duyệt") return showError("Không thể cập nhật biên lai Đã ký !");

              var excelForm = table.$scope.ui(excelModalDetail.$ui);
              excelForm.show();
              $$(uploadFileModalId).getHead().setHTML("Nhận chi tiết biên lai từ file Excel");
              break;
          }
          var fn = Function("_", "user", "idEx", record.on_click);
          fn(_, user, record.id);
        },
      },
    });

    var buttonExcel = webix.storage.local.get(constant.CACHE.BUTTON_EXCEL + typeInvoice);
    function btnExcelCache(arr, options, optionsBtn) {
      if (Array.isArray(arr)) {
        arr.forEach((element) => {
          var data = {
            id: element.wb_ex_id,
            value: element.ex_name,
            on_click: element.onClick,
          };
          options.push(data);
        });
      }
      optionsBtn.clearAll();
      optionsBtn.parse(options, "json");
    }
    if (buttonExcel != null) {
      btnExcelCache(buttonExcel, options, optionsBtn);
    } else {
      webix
        .ajax()
        .headers({ "Content-type": "application/json" })
        .get(constant.API.GET_BUTTON_EXCEL + typeInvoice, {
          success: function (text) {
            var arr = JSON.parse(text);
            btnExcelCache(arr, options, optionsBtn);
            webix.storage.local.put(constant.CACHE.BUTTON_EXCEL + typeInvoice, arr);
          },
        });
    }
    var btnChucNang = {
      view: "button",
      type: "htmlbutton",
      width: 120,
      label: '<i class="fa fa-th fa-lg aria-hidden="true"></i><span class="text">' + _("CHUC_NANG") + "</span>",
      id: "btnOptions",
      click: function () {
        optionsBtn.show(webix.$$("btnOptions").$view);
      },
    };
    var index = $$("btnControl").index($$("btnChucNang"));
    $$("btnControl").addView(btnChucNang, index);
  }

  var grid = gridInvoice.gridInitInvoice(viewLogForm, "EBL");
  var gridClone = deepClone(grid);

  gridClone.rows[0].columns[3].header[0] = "Trạng thái biên lai"
  gridClone.rows[0].columns[5].header[0] = "Ngày biên lai"
  gridClone.rows[0].columns[7].header[0] = "Số biên lai"
  gridClone.rows[0].columns[9].header[0] = "Tên người/ đơn vị nộp tiền"
  gridClone.rows[0].rightSplit = 0;
  gridClone.rows[0].leftSplit = 0;
  gridClone.rows[0].columns = removeItemsByIndex([6, 11, 12, 13, 21], gridClone.rows[0].columns);

  function openPdf(isInchuyenDoi) {
    var datatableId = "invoiceViews";
    var table = webix.$$(datatableId);
    if (table.getColumnConfig("colMultiChoice") != undefined) return;
    var item = table.getSelectedItem();
    if (item == null || item == undefined) return showError("Bạn chưa chọn dòng cần in");

    var box = webix.modalbox({
      title: "Đang in biên lai ....",
      text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
      width: 350,
      height: 200,
    });

    var newWin = window.open();
    var html =
      "<html><head><title>Hóa đơn điện tử M-Invoice</title>" +
      '<link rel="stylesheet" href="assets/fontawesome_pro/css/all.css" type="text/css" charset="utf-8">' +
      '<link rel="stylesheet" href="assets/fontawesome.css" type="text/css" charset="utf-8">' +
      '</head><body><center>Đang tải dữ liệu ... <br><p><i style="font-size:200%;" class="fa fa-spin fa-spinner"></i></p></center></body></html>';
    newWin.document.write(html);

    var url = app.config.host + "/Invoice68/PrintInvoice?id=" + item.id + "&type=PDF&inchuyendoi="
    if (isInchuyenDoi) url += "true"
    else url += false

    webix
      .ajax()
      .response("arraybuffer")
      .headers({ "Content-type": "application/json" })
      .get(url, {
        error: function (_text, _data, XmlHttpRequest) {
          webix.modalbox.hide(box);
          webix.message(XmlHttpRequest.statusText, "error");
        },
        success: function (_text, data) {
          var file = new Blob([data], { type: "application/pdf" });
          var fileURL = URL.createObjectURL(file);
          webix.modalbox.hide(box);
          newWin.location = fileURL;
        },
      });
  }

  var controls = [
    btnRefresh,
    btnAdd,
    btnEdit,
    btnDelete,
    btnCopy,
    {
      view: "button",
      type: "htmlbutton",
      width: 120,
      label: '<i class="fa fa-print fa-lg aria-hidden="true"></i><span class="text">' + _("PRINT") + "</span>",
      id: "btnPrint",
      click: function () {
        openPdf();
      },
    },
    btnEmail,
    {
      view: "button",
      type: "htmlbutton",
      width: 120,
      label: '<i class="fa fa-pencil fa-lg aria-hidden="true"></i><span class="text">' + _("Ký biên lai") + "</span>",
      id: "btnKy",
      click: function () {
        var grid = $$("invoiceViews");
        var selected = grid.getSelectedId();
        if (!selected) {
          webix.message("Vui lòng chọn biên lai để ký!", "error");
          return;
        }
        var item = grid.getItem(selected);
        var bienlaiId = item.hoadon68_id;
        var windowView = $$("frmView");
        var apiUrl = {
          certUrl: constant.API.TOKEN_CERT_AUTO,
          signTypeUrl: constant.API.INVOICE_GET_TYPE_SIGN,
          exportXmlUrl: constant.API.RECEIP.GET_XML + "?id=" + bienlaiId,
          signXmlUrl: constant.API.RECEIP.SIGN,
          showPinUrl: constant.API.TOKEN_SHOW_PIN,
          saveXmlUrl: constant.API.RECEIP.SAVE_XML,
        };
        signService.Sign(windowView, grid, bienlaiId, apiUrl, "BLai/DSCKS/TCTPhi");
      },
    },
    {
      view: "button",
      type: "htmlbutton",
      width: 120,
      label: '<i class="fa fa-print fa-lg aria-hidden="true"></i><span class="text">' + _("In chuyên đổi") + "</span>",
      id: "btnInchuyendoi",
      click: function () {
        openPdf(true)
      },
    },
    btnKyNhieuBienlai,
    {
      view: "button",
      type: "htmlbutton",
      width: 120,
      label: '<i class="fa fa-tasks fa-lg aria-hidden="true"></i><span class="text">' + _("Nghiệp vụ") + "</span>",
      id: "btnChucNang",
      click: function () {
        subChucNang.show(webix.$$("btnChucNang").$view);
      },
    },
    {},
  ];

  var layout = {
    css: "frmView",
    id: "frmView",
    rows: [
      {
        id: "paramKH",
        view: "toolbar",
        css: { "background-color": "#f5f5f5 !important" },
        borderless: true,
        height: 35,
        cols: [
          componentHelper.kyhieuHoadon("EBL"),
          cbGetAllClone,
        ]
      },
      {
        height: 39,
        id: "btnControl",
        css: "btnControl",
        margin: 0,
        borderless: true,
        type: "toolbar",
        cols: controls
      },
      {
        rows: [
          gridClone
        ]
      }
    ]

  };

  return {
    $ui: layout,
    $oninit: function (_view, $scope) {
      eventTableHelper.OnInit(8);
      subOption(uploadExcel, uploadExcelDetail, 8)

      $scope.on(app, "dataChangedInvoie68", function () {
        var table = webix.$$("invoiceViews");
        table.clearAll();
        table.load(table.config.url);
      });
    }
  }
});
define('views/forms/forms70/BienLai/70_reportReceipList',["app", "models/user", "views/modules/Component/constantManager"], function (app, user, CONSTANTS) {
    var formId = "bienlai_form";
    var winId = "bienlai_win";
    var tableId = "danhsach_bienlaiFrm";
    var formTableId = "danhsach_bienlai";
    var _callback = null;

    var ui = {
        view: "window",
        id: winId,
        modal: true,
        width: 1200,
        height: 500,
        position: "center",
        head: "Chọn biên lai vào báo cáo tình hình sử dụng biên lai",
        body: {
            view: "form",
            id: formId,
            elements: [
                {
                    view: "datatable",
                    id: tableId,
                    name: "danhsach_bienlaiFrm",
                    select: true,
                    resizeColumn: true,
                    scroll: true,
                    tooltip: true,
                    columns: [
                        {
                            id: "chon",
                            header: [{ text: "", content: "masterCheckbox" }],
                            width: 50,
                            checkValue: "C",
                            uncheckValue: "K",
                            template: "{common.checkbox()}"
                        },
                        { id: "khieu", header: ["Ký hiệu", { content: "textFilter" }], width: 100 },
                        {
                            id: "ten_tt", header: ["Trạng thái", { content: "selectFilter", options: [{ id: "", value: "Tất cả" }].concat(CONSTANTS.STATUS_INVOICE) }],
                            template: "<span class='mcls_status#is_tthdon#'>#ten_tt#</span>",
                            width: 120, columnType: "nvarchar", editor: "text", sort: "string"
                        },
                        { id: "tloai", header: ["Tên loại biên lai", { content: "textFilter" }], width: 200 },
                        { id: "khieu_mctu", header: "Ký hiệu mẫu biên lai", width: 150 },
                        { id: "khieu_ctu", header: "Ký hiệu biên lai", width: 150 },
                        { id: "mst", header: ["Mã số thuế", { content: "textFilter" }], width: 120 },
                        { id: "ten", header: ["Tên đơn vị/Tên người mua", { content: "textFilter" }], width: 300 },
                        { id: "tgtttbso", header: "Tổng tiền", width: 150 }
                    ],
                    on: {
                        onHeaderClick: function (header, _event, element) {
                        },
                    }
                },
                {
                    view: "checkbox",
                    id: "cbLoaiBoThayThe",
                    labelRight: "<b>Loại bỏ biên lai bị thay thế khi tính tổng tiền trên báo cáo BC26</b>",
                    value: 1,
                    on: {

                    }
                },
                {
                    margin: 10,
                    cols: [
                        {},
                        {
                            view: "button",
                            id: "btnNhanBienLai",
                            label: "Nhận",
                            css: "webix_primary",
                            width: 120,
                            click: function () {
                                var table = $$(tableId);
                                var formTable = $$(formTableId);
                                var loaiBoThayThe = $$("cbLoaiBoThayThe").getValue();

                                var data = table.serialize();
                                var recordCounter = {};
                                var tgtienCounter = {};
                                var selected = [];

                                data.forEach(function (item) {
                                    if (item.chon == "C") {
                                        if (recordCounter[item.khieu_mctu] != undefined) {
                                            recordCounter[item.khieu_mctu] += 1;
                                        } else {
                                            recordCounter[item.khieu_mctu] = 1;
                                            selected.push(item);
                                        }
                                        if (tgtienCounter[item.khieu_mctu] != undefined) {
                                            if (loaiBoThayThe == 0 || item.ten_tt !== "Bị thay thế") {
                                                tgtienCounter[item.khieu_mctu] += item.tgtttbso;
                                            }
                                        } else {
                                            tgtienCounter[item.khieu_mctu] = (loaiBoThayThe == 0 || item.ten_tt !== "Bị thay thế") ? item.tgtttbso : 0;
                                        }
                                    }
                                })
                                formTable.clearAll()
                                selected.forEach(function (item) {
                                    var savedItem = item
                                    savedItem.sluong = recordCounter[item.khieu_mctu]
                                    savedItem.tgtien = tgtienCounter[item.khieu_mctu]
                                    formTable.add(savedItem)
                                })
                                if (typeof _callback === "function") {
                                    _callback(selected);
                                }
                                $$(winId).close();
                            }
                        },
                        {
                            view: "button",
                            label: "Hủy",
                            css: "webix_danger",
                            width: 120,
                            click: function () {
                                $$(winId).close();
                            }
                        },
                        {}
                    ]
                }
            ]
        }
    };

    return {
        $ui: ui,

        setValues: function (values, callback) {
            _callback = callback;

            var requestData = {
                type: values.lkdlieu,
                thang: values.thang,
                nam: values.nam,
                ngay: values.ngay,
                cctbao_id: Array.isArray(values.kyhieu_id)
                    ? values.kyhieu_id.join(",")
                    : values.kyhieu_id,
                skip: 0,
                take: 1000
            };

            var tableBienLai = webix.$$(tableId);
            webix.extend(tableBienLai, webix.ProgressBar);
            tableBienLai.disable();
            tableBienLai.showProgress();

            webix.ajax()
                .headers({ "Content-type": "application/json" })
                .post(app.config.host + "/Receip/GetListReceip", requestData, {
                    error: function () {
                        tableBienLai.enable();
                        tableBienLai.hideProgress();
                    },
                    success: function (text) {
                        tableBienLai.enable();
                        tableBienLai.hideProgress();
                        var response = JSON.parse(text);
                        response.data.forEach(function (item) {
                            if (item.khieu && item.khieu.includes("-")) {
                                var parts = item.khieu.split("-");
                                item.khieu_mctu = parts[0];
                                item.khieu_ctu = parts[1];
                                item.tloai =
                                    item.khieu === "EBL02-25T"
                                        ? "Biên lai in sẵn mệnh giá"
                                        : item.khieu === "EBL01-25T"
                                            ? "Biên lai không in sẵn mệnh giá"
                                            : "";
                            }
                        });
                        tableBienLai.clearAll();
                        tableBienLai.parse(response.data);
                    }
                });
        }
    };
});
define('views/forms/forms70/BienLai/70_reportReceipForm',[
    "app",
    "locale",
    "models/user",
    "views/modules/Component/componentHelper",
    "views/modules/Component/constantManager",
    "views/forms/forms70/BienLai/70_reportReceipList"
], function (
    app,
    _,
    user,
    componentHelper,
    constant,
    bangdanhsachbienlai
) {
    "use strict";
    var editmode = 0;
    var formId = "bienlai-form";
    var winId = "bienlai-win";
    var tableId = "danhsach_bienlai";
    var btnSaveId = "btnBienLaiSave";
    var btnCopyId = "btnCopyRow";
    var btnDeleteId = "btnDeleteRow";
    var btnAddId = "btnAddRow";

    var button = [
        {},
        {
            shortcut: "F10",
            id: btnSaveId,
            view: "button",
            badge: "F10",
            css: "webix_primary",
            label: "Lưu tạm",
            type: "icon",
            align: "center",
            width: 120,
            on: {
                onClick: function () {
                    var item = $$(formId).getValues();
                    var tableBienLai = $$(formId);
                    if (tableBienLai.validate()) {
                        var ds_bienlai = $$(tableId).serialize();
                        if (ds_bienlai.length == 0) {
                            webix.message("Bạn chưa nhập chi tiết biên lai", "error");
                            return;
                        }
                        item["bienlai_chitiets"] = ds_bienlai;
                        webix.extend(tableBienLai, webix.ProgressBar);
                        tableBienLai.disable();
                        tableBienLai.showProgress();
                        webix.ajax()
                            .headers({ "Content-type": "application/json" })
                            .post(app.config.host + constant.API.BC26.SAVE, item, {
                                error: function (text, data, XmlHttpRequest) {
                                    tableBienLai.enable();
                                    tableBienLai.hideProgress();
                                },
                                success: function (text, data, XmlHttpRequest) {
                                    var response = JSON.parse(text);
                                    tableBienLai.enable();
                                    tableBienLai.hideProgress();
                                    if (response.code == "00") {
                                        webix.$$(winId).close();
                                        app.callEvent("dataChangeBCBL", [1, null]);
                                    } else {
                                        webix.message(response.message, "error");
                                    }
                                },
                            });
                    } else {
                        webix.message("Tồn tại trường dữ liệu không hợp lệ", "error");
                    }
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            hotkey: "esc",
            label: "Quay lại",
            badge: "ESC",
            css: "webix_danger",
            align: "center",
            type: "icon",
            width: 120,
            click: function () {
                webix.$$(winId).close();
            },
        },
        {},
    ];

    var dNow = new Date();
    var quarter = Math.floor(dNow.getMonth() / 3) + 1;
    var montNow = dNow.getMonth() + 1;
    var headTitleBienLai = componentHelper.headTitleHoadon("Lập báo cáo tình hình sử dụng biên lai");
    var fm = function (number) {
        var k = webix.Number.numToStr({
            groupDelimiter: ".",
            groupSize: 3,
            decimalDelimiter: ",",
            decimalSize: 2,
        });
        return k(number);
    };

    var layout = {
        view: "window",
        modal: true,
        move: true,
        fullscreen: true,
        id: winId,
        position: "center",
        head: headTitleBienLai,
        on: {
            onShow: function () {
                var form = $$(formId);
                webix.ajax().get(constant.API.GET_DMDVCS, {
                    error: function (err) {
                        console.error("Lỗi khi tải thông tin đơn vị:", err);
                    },
                    success: function (response) {
                        const sellerInfo = JSON.parse(response);
                        const mapdata = {
                            tdvi: sellerInfo.ten_dvcs || "",
                            dchi: sellerInfo.dia_chi || "",
                            mst: sellerInfo.ms_thue || "",
                            sdt: sellerInfo.dien_thoai || "",
                            ddien: sellerInfo.nguoi_dai_dien || "",
                            chucvu: sellerInfo.chuc_vu || "",
                            nlap: new Date(),
                        };
                        form.setValues(mapdata, true);
                        $$("lkdlieu").setValue("T");
                        $$("thang").show();
                        $$("nam").show();
                        $$("ngay").define("hidden", true);
                        var nam = $$("nam").getValue();
                        var thang = String($$("thang").getValue()).padStart(2, '0');
                        $$("kdlieu").setValue(`${thang}/${nam}`);
                    }
                });
            }
        },
        body: {
            paddingY: 10,
            paddingX: 20,
            view: "form",
            id: formId,
            complexData: true,
            margin: 0,
            elements: [
                {
                    cols: [
                        {
                            view: "fieldset",
                            label: "Lọc dữ liệu",
                            gravity: 1,
                            body: {
                                rows: [
                                    {
                                        cols: [
                                            { view: "label", label: "Loại kỳ dữ liệu", width: 100, },
                                            {
                                                id: "lkdlieu",
                                                name: "lkdlieu",
                                                view: "combo",
                                                width: 120,
                                                attributes: { readonly: true },
                                                value: "T",
                                                options: [
                                                    { id: "T", value: "Tháng" },
                                                    { id: "Q", value: "Quý" },
                                                ],
                                                on: {
                                                    onChange: function (newv, oldv) {
                                                        if (newv == "T") {
                                                            var k = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12",];
                                                            $$("thang").define("options", k);
                                                            $$("thang").setValue(montNow);
                                                            $$("thang").refresh();
                                                            $$("thang").show();
                                                            $$("nam").show();
                                                            $$("ngay").define("hidden", true);
                                                            var nam = $$("nam").getValue();
                                                            var thang = String($$("thang").getValue()).padStart(2, '0');
                                                            $$("kdlieu").setValue(`${thang}/${nam}`);
                                                        }
                                                        if (newv == "Q") {
                                                            var k = ["1", "2", "3", "4"];
                                                            $$("thang").define("options", k);
                                                            $$("thang").setValue(quarter);
                                                            $$("thang").refresh();
                                                            $$("thang").show();
                                                            $$("nam").show();
                                                            $$("ngay").define("hidden", true);
                                                            var nam = $$("nam").getValue();
                                                            var quy = $$("thang").getValue();
                                                            $$("kdlieu").setValue(quy + "/" + nam);
                                                        }
                                                    },
                                                },
                                            },
                                            {
                                                id: "thang",
                                                name: "thang",
                                                view: "combo",
                                                attributes: { readonly: true },
                                                width: 120,
                                                value: montNow,
                                                options: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12",],
                                                on: {
                                                    onChange: function (newv, oldv) {
                                                        var lkdlieu = $$("lkdlieu").getValue();
                                                        var nam = $$("nam").getValue();
                                                        if (lkdlieu == "T") {
                                                            var thangFormat = newv.toString().padStart(2, '0');
                                                            $$("kdlieu").setValue(thangFormat + "/" + nam);
                                                        } else if (lkdlieu == "Q") {
                                                            $$("kdlieu").setValue(newv + "/" + nam);
                                                        }
                                                    }
                                                }
                                            },
                                            {
                                                id: "nam",
                                                name: "nam",
                                                value: new Date().getFullYear(),
                                                view: "text",
                                                label: "Năm",
                                                labelWidth: 50,
                                                width: 120,
                                                attributes: { maxlength: 4, pattern: "[0-9]*" },
                                                on: {
                                                    onChange: function (newv, oldv) {
                                                        if (!/^\d{4}$/.test(newv) || parseInt(newv) < 2025) {
                                                            webix.message("Năm không hợp lệ!", "error");
                                                            this.setValue(oldv);
                                                            return;
                                                        }
                                                        var lkdlieu = $$("lkdlieu").getValue();
                                                        var thang = $$("thang").getValue();
                                                        if (lkdlieu == "T") {
                                                            var thangFormat = thang.toString().padStart(2, '0');
                                                            $$("kdlieu").setValue(thangFormat + "/" + newv);
                                                        } else if (lkdlieu == "Q") {
                                                            $$("kdlieu").setValue(thang + "/" + newv);
                                                        }
                                                    }
                                                }
                                            },
                                            {
                                                id: "ngay",
                                                name: "ngay",
                                                view: "datepicker",
                                                label: "Ngày",
                                                hidden: true,
                                                labelWidth: 50,
                                                width: 240,
                                                value: new Date(),
                                                format: function (text) {
                                                    var format = webix.Date.dateToStr("%d/%m/%Y");
                                                    text = removeTimeZoneT(text);
                                                    return format(text);
                                                },
                                                on: {
                                                    onChange: function (newv, oldv) {
                                                        var format = webix.Date.dateToStr("%d/%m/%Y");
                                                        $$("kdlieu").setValue(format(newv));
                                                    }
                                                }
                                            },
                                            {},
                                        ],
                                    },
                                    {
                                        cols: [
                                            { view: "label", label: "Kỳ dữ liệu:", width: 100, },
                                            { id: "kdlieu", name: "kdlieu", view: "text", width: 120, disabled: true },
                                            {
                                                id: "nlap", name: "nlap", view: "datepicker", label: "Ngày lập", width: 240, labelWidth: 100, value: new Date(),
                                                format: function (text) {
                                                    var format = webix.Date.dateToStr("%d/%m/%Y");
                                                    text = removeTimeZoneT(text);
                                                    return format(text);
                                                },
                                            },
                                            {},
                                        ],
                                    },
                                    {
                                        cols: [
                                            { view: "label", label: "Ký hiệu:", width: 100, },
                                            {
                                                id: "kyhieu_id",
                                                view: "multicombo",
                                                name: "kyhieu_id",
                                                width: 360,
                                                options: {
                                                    body: {
                                                        url: constant.API.SERIAL_TYPE + "EBL",
                                                    },
                                                },
                                            }
                                        ]
                                    },
                                ]
                            }
                        },
                        {
                            view: "fieldset",
                            label: "Thông tin đơn vị",
                            gravity: 2,
                            body: {
                                rows: [
                                    { view: "text", label: "Đơn vị", id: "tdvi", name: "tdvi", attributes: { maxlength: 400 }, },
                                    { view: "text", label: "Mã số thuế", id: "mst", name: "mst", },
                                    { view: "text", label: "Địa chỉ", id: "dchi", name: "dchi", attributes: { maxlength: 400 }, invalidMessage: "Địa chỉ đơn vị bán không được để trống !", validate: webix.rules.isNotEmpty },
                                ]
                            }
                        }
                    ]
                },
                { height: 5 },
                {
                    rows: [
                        {
                            cols: [
                                {
                                    view: "button",
                                    id: "btnChonBienLai",
                                    css: "webix_primary",
                                    type: "icon",
                                    icon: "mdi mdi-plus-box",
                                    width: 120,
                                    label: "Lấy dữ liệu",
                                    on: {
                                        onItemClick: function (id, e) {
                                            var frm = $$(formId).getValues();
                                            var kyhieu = $$("kyhieu_id").getValue();
                                            if (!kyhieu || (Array.isArray(kyhieu) && kyhieu.length === 0)) {
                                                webix.message("Vui lòng chọn ký hiệu trước khi lấy dữ liệu!", "error");
                                                return;
                                            }
                                            function isValidPeriod(type, now) {
                                                const get = id => $$(id).getValue();
                                                const year = now.getFullYear();
                                                const month = now.getMonth() + 1;
                                                const quarter = Math.floor(now.getMonth() / 3) + 1;
                                                const day = new Date(year, now.getMonth(), now.getDate());
                                                const checkers = {
                                                    "T": () => {
                                                        const t = parseInt(get("thang"));
                                                        const n = parseInt(get("nam"));
                                                        if (n > year || (n === year && t >= month))
                                                            return "Chỉ được lập báo cáo của tháng trước!";
                                                    },
                                                    "Q": () => {
                                                        const q = parseInt(get("thang"));
                                                        const n = parseInt(get("nam"));
                                                        if (n > year || (n === year && q >= quarter))
                                                            return "Chỉ được lập báo cáo của quý trước!";
                                                    },
                                                };
                                                return checkers[type] ? checkers[type]() : undefined;
                                            }
                                            var lkdlieu = $$("lkdlieu").getValue();
                                            var now = new Date();
                                            var errorMsg = isValidPeriod(lkdlieu, now);
                                            if (errorMsg) {
                                                webix.message(errorMsg, "error");
                                                return;
                                            }
                                            if (!$$("bienlai_win")) {
                                                var popup = webix.ui(bangdanhsachbienlai.$ui);
                                                bangdanhsachbienlai.setValues(frm, function (selected) {
                                                    var table = $$(tableId);
                                                    table.clearAll();
                                                    table.parse(selected);
                                                });
                                                popup.show();
                                            } else {
                                                bangdanhsachbienlai.setValues(frm, function (selected) {
                                                    var table = $$(tableId);
                                                    table.clearAll();
                                                    table.parse(selected);
                                                });
                                                $$("bienlai_win").show();
                                            }
                                        }
                                    }
                                },
                                {
                                    view: "button",
                                    id: btnDeleteId,
                                    css: "webix_primary",
                                    type: "icon",
                                    icon: "mdi mdi-delete-sweep",
                                    width: 100,
                                    label: "Xóa dòng",
                                    on: {
                                        onItemClick: function () {
                                            var table = $$(tableId);
                                            table.editStop();
                                            var item = table.getSelectedItem();
                                            if (!webix.isUndefined(item)) {
                                                table.remove(item.id);
                                                table.clearSelection();
                                                return;
                                            }
                                            var editor = table.getEditState();
                                            if (!webix.isUndefined(editor)) {
                                                table.remove(editor.row);
                                                table.clearSelection();
                                                return;
                                            }
                                        },
                                    },
                                },
                            ],
                        },
                        {
                            view: "datatable",
                            id: tableId,
                            name: "danhsach_bienlai",
                            select: true,
                            scroll: true,
                            resizeColumn: true,
                            footer: true,
                            editable: true,
                            tooltip: true,
                            scheme: {
                                $init: function (obj) { },
                            },
                            on: {
                                "data->onStoreUpdated": function () {
                                    this.data.each(function (obj, i) {
                                        obj.stt = i + 1;
                                    });
                                },
                            },
                            columns: [
                                { id: "stt", name: "stt", header: "STT", sort: "int", width: 40 },
                                { id: "tloai", name: "tloai", width: 300, header: "Tên loại biên lai ", editor: "text", editable: true, attributes: { maxlength: 100 } },
                                { id: "khieu_mctu", name: "khieu_mctu", width: 150, header: "Ký hiệu mẫu biên lai", editor: "text", editable: true, attributes: { maxlength: 10 } },
                                { id: "khieu_ctu", name: "khieu_ctu", width: 150, header: "Ký hiệu biên lai", editor: "text", editable: true, attributes: { maxlength: 9 } },
                                { id: "sluong", name: "sluong", width: 150, header: "Số biên lai sử dụng trong kỳ", editor: "text", editable: true, attributes: { maxlength: 400 } },
                                {
                                    id: "tgtien",
                                    name: "tgtien",
                                    header: "Tổng tiền",
                                    width: 140,
                                    editor: "text",
                                    editable: true,
                                    attributes: { maxlength: 13 },
                                    css: { "text-align": "right" },
                                    format: webix.Number.numToStr({
                                        groupDelimiter: ",",
                                        groupSize: 3,
                                        decimalDelimiter: ".",
                                        decimalSize: 0,
                                    }),
                                },
                            ],
                        },
                    ],
                },
                {
                    margin: 10,
                    cols: button,
                },
            ],
        },
    };

    return {
        $ui: layout,
        setEditMode: function (mode) {
            editmode = mode;
            var form = $$(formId);
            form.config.editmode = mode;
            var icon = "";
            if (editmode == 1) {
                icon = "<span><i class='fa fa-plus' aria-hidden='true'></i></span>";
            } else {
                if (editmode == 2)
                    icon = "<i class='fa fa-edit' aria-hidden='true'></i>";
                else icon = "<i class='fa fa-trash fa-lg' aria-hidden='true'></i>";
            }
            webix.$$("head-iconInvoice").setHTML(icon);
            webix.$$("head-iconInvoice").refresh();
        },
        setValues: function (item) {
            var win = $$(winId);
            var form = win.getChildViews()[1];
            if (item && item.nlap) {
                if (typeof item["nlap"] == "string") {
                    item["nlap"] = new Date(removeTimeZoneT(item["nlap"]));
                }
                form.setValues(item, true);
            }
            if (item && item.bienlai_id) {
                var tableDetail = $$(tableId);
                var apiHost = app.config.host + constant.API.BC26.GET_BY_ID + "?id=" + item.bienlai_id;
                tableDetail.clearAll();
                webix.ajax().get(apiHost, {
                    error: function (text, data, XmlHttpRequest) {
                        console.error("Lỗi khi load chi tiết:", text);
                    },
                    success: function (text, data, XmlHttpRequest) {
                        var response = JSON.parse(text);
                        if (response.code !== "00" || !response.data) {
                            console.error("Lỗi khi parse dữ liệu:", response.message);
                            return;
                        }

                        var baocao = response.data;
                        baocao.nlap && (baocao.nlap = new Date(removeTimeZoneT(baocao.nlap)));
                        form.setValues(baocao, true);
                        if (baocao.kdlieu) {
                            var parts = baocao.kdlieu.split("/");
                            var isLKDLieu = baocao.lkdlieu === "T" || baocao.lkdlieu === "Q";
                            isLKDLieu && parts.length === 2 && ($$("thang").setValue(parts[0]), $$("nam").setValue(parts[1]));
                            baocao.lkdlieu === "N" && parts.length === 3 && $$("ngay").setValue(new Date(parts[2], parts[1] - 1, parts[0]));
                        }

                        tableDetail.parse(baocao.bienlai_chitiets);
                        var saveButton = $$("btnBienLaiSave");
                        saveButton && saveButton[baocao.trang_thai !== "Chờ ký" ? "hide" : "show"]();
                    }
                });
            }
        }
    };
});
define('views/70_reportReceip',["app", "locale", "models/user",
    "views/forms/forms70/BienLai/70_reportReceipForm",
    "views/modules/Component/constantManager",
    "views/modules/Component/signService",
    "views/forms/forms68/68_viewLogForm",
], function (app, _, user, taobcblai, CONSTANTS, signService, viewLogForm) {
    "use strict";
    var tableId = "baocaobienlai";
    var formId = "frmViewBCBL";
    var pagerId = "pagerA";
    var btnRefreshId = "btnRefresh";
    var btnPlusId = "btnPlus";
    var btnEditId = "btnEdit";
    var btnDeleteId = "btnDelete";
    var btnPrintId = "btnPrint";
    var btnExportId = "btnExport";
    var btnKyId = "btnKyCXL";
    var btnDownloadXmlId = "btnDownloadXml";
    var modalId = "modalTaoBaoCaoBienLai";
    var initUI = function () {
        var table = $$(tableId);
        var url = {
            $proxy: true,
            load: function (view, callback, params) {
                var start = 0;
                var count = view.config.datafetch;
                var filter = [];
                var tlbparam_s = [];
                if (params) {
                    if (params.start !== undefined) start = params.start;
                    if (params.count !== undefined) count = params.count;
                    if (params.filter) {
                        for (var property in params.filter) {
                            var column = view.getColumnConfig(property);
                            var value = params.filter[property];
                            if (value !== "" && value !== null && value !== undefined) {
                                filter.push({
                                    columnName: property,
                                    columnType: column.columnType,
                                    value: value
                                });
                            }
                        }
                    }
                    if (params.tlbparam) tlbparam_s = params.tlbparam;
                }
                var item = {
                    command: "BC26",
                    start: start,
                    count: count,
                    filter: filter,
                    tlbparam: tlbparam_s
                };
                var apiHost = app.config.host + "/Pattern/GetData";
                webix.ajax()
                    .headers({ 'Content-type': 'application/json' })
                    .bind(view)
                    .post(apiHost, item, callback, view);
            }
        };
        table.define("url", url);
    };

    var controls = [
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-refresh fa-lg" aria-hidden="true"></i><span class="text"> ' + _("REFRESH") + "</span>",
            id: btnRefreshId,
            on: {
                onClick: function () {
                    var table = $$(tableId);
                    table.clearAll();
                    table.load(table.config.url);
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-plus fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("Thêm (F4)") + "</span>",
            id: btnPlusId,
            shortcut: "F4",
            on: {
                onClick: function () {
                    if (!$$(modalId)) {
                        webix.ui(taobcblai.$ui).show();
                    } else {
                        $$(modalId).show();
                    }
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-edit fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("Sửa (F3)") + "</span>",
            id: btnEditId,
            shortcut: "F3",
            on: {
                onClick: function () {
                    var table = $$(tableId);
                    var selectedItem = table.getSelectedItem();
                    if (selectedItem == null) {
                        webix.message("Bạn chưa chọn dòng nào ! ", "error");
                        return;
                    }
                    if (!$$(modalId)) {
                        var form = webix.ui(taobcblai.$ui);
                        form.show();
                        taobcblai.setValues(selectedItem);
                    } else {
                        $$(modalId).show();
                        taobcblai.setValues(selectedItem);
                    }
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-trash-o fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("Xóa (F8)") + "</span>",
            id: btnDeleteId,
            shortcut: "F8",
            on: {
                onClick: function () {
                    var table = $$(tableId);
                    var selectedItem = table.getSelectedItem();
                    if (selectedItem == null) {
                        webix.message("Bạn chưa chọn dòng nào ! ", "error");
                        return;
                    }
                    if (selectedItem.trang_thai !== "Chờ ký") {
                        webix.message("Chỉ được xóa báo cáo ở trạng thái Chờ ký!", "error");
                        return;
                    }
                    webix.confirm({
                        text: "Bạn có muốn xóa bản ghi",
                        ok: "Có",
                        cancel: "Không",
                        callback: function (choose) {
                            if (choose) {
                                webix
                                    .ajax()
                                    .headers({ "Content-type": "application/json" })
                                    .get(app.config.host + CONSTANTS.API.BC26.DELETE + "?id=" + selectedItem.bienlai_id, function (text) {
                                        var response = JSON.parse(text);
                                        if (response.code != "00") {
                                            webix.message({ type: "error", text: response.message });
                                            return;
                                        }
                                        var btnRefresh = $$(btnRefreshId);
                                        btnRefresh.callEvent("onClick");
                                    });
                            }
                        },
                    });
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-print fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("PRINT") + "</span>",
            id: btnPrintId,
            on: {
                onClick: function () {
                    var table = $$(tableId);
                    var selectedItem = table.getSelectedItem();

                    if (selectedItem == null) {
                        webix.message("Bạn chưa chọn dòng nào ! ", "error");
                        return;
                    }
                    var box = webix.modalbox({
                        title: "Đang in báo cáo thống kê biên lai ....",
                        text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                        width: 350,
                        height: 200,
                    });

                    var newWin = window.open();
                    var html = "<html><head><title>Hóa đơn điện tử M-Invoice</title>" + '<link rel="stylesheet" href="assets/fontawesome_pro/css/all.css" type="text/css" charset="utf-8">' + '<link rel="stylesheet" href="assets/fontawesome.css" type="text/css" charset="utf-8">' + '</head><body><center>Đang tải dữ liệu ... <br><p><i style="font-size:200%;" class="fa fa-spin fa-spinner"></i></p></center></body></html>';
                    newWin.document.write(html);

                    webix
                        .ajax()
                        .response("arraybuffer")
                        .headers({ "Content-type": "application/json" })
                        .get(app.config.host + CONSTANTS.API.BC26.PRINTBC26 + "?id=" + selectedItem.bienlai_id + "&type=Pdf", {
                            error: function (text, data, XmlHttpRequest) {
                                webix.modalbox.hide(box);
                            },
                            success: function (text, data, XmlHttpRequest) {
                                var file = new Blob([data], { type: "application/pdf" });
                                var fileURL = URL.createObjectURL(file);
                                webix.modalbox.hide(box);
                                newWin.location = fileURL;
                            },
                        });
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-download fa-lg aria-hidden="true"></i><span class="text"> ' + _("Tải xml") + "</span>",
            id: btnDownloadXmlId,
            on: {
                onClick: function () {
                    var table = $$(tableId);
                    var selectedItem = table.getSelectedItem();
                    if (selectedItem == null) {
                        webix.message("Bạn chưa chọn báo cáo biên lai ! ", "error");
                        return;
                    }
                    if (selectedItem.trang_thai === "Chờ ký") {
                        webix.message("Không được tải xml báo cáo ở trạng thái Chờ ký!", "error");
                        return;
                    }
                    webix.extend(table, webix.ProgressBar);
                    table.disable();
                    table.showProgress();

                    var url = app.config.host + CONSTANTS.API.BC26.DOWNLOAD_XML + "?id=" + selectedItem.bienlai_id;
                    webix.ajax().response("arraybuffer").get(url, function (text, data) {
                        table.enable();
                        table.hideProgress();
                        var file = new Blob([data], { type: "application/xml" });
                        webix.html.download(file, "BaoCaoBienLai.xml");
                    });
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 130,
            label: '<i class="fa fa-file-excel fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("EXPORT_EXCEL") + "</span>",
            id: btnExportId,
            on: {
                onClick: function () {
                    var table = $$(tableId);
                    var selectedItem = table.getSelectedItem();

                    if (selectedItem == null) {
                        webix.message("Bạn chưa chọn dòng nào ! ", "error");
                        return;
                    }
                    var box = webix.modalbox({
                        title: "Đang kết xuất báo cáo thống kê biên lai ....",
                        text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                        width: 350,
                        height: 200,
                    });

                    var newWin = window.open();
                    var html = "<html><head><title>Hóa đơn điện tử M-Invoice</title>" + '<link rel="stylesheet" href="assets/fontawesome_pro/css/all.css" type="text/css" charset="utf-8">' + '<link rel="stylesheet" href="assets/fontawesome.css" type="text/css" charset="utf-8">' + '</head><body><center>Đang tải dữ liệu ... <br><p><i style="font-size:200%;" class="fa fa-spin fa-spinner"></i></p></center></body></html>';
                    newWin.document.write(html);

                    webix.ajax().response("arraybuffer").headers({ "Content-type": "application/json" })
                        .get(app.config.host + CONSTANTS.API.BC26.PRINTBC26 + "?id=" + selectedItem.bienlai_id + "&type=Excel", {
                            error: function (text, data, XmlHttpRequest) {
                                webix.modalbox.hide(box);
                                webix.message(XmlHttpRequest.statusText, "error");
                            },
                            success: function (text, data, XmlHttpRequest) {
                                var file = new Blob([data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
                                var fileURL = URL.createObjectURL(file);
                                webix.modalbox.hide(box);
                                window.location.href = fileURL;
                            },
                        });
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-sign-in fa-lg aria-hidden="true"></i> ' + '<span class="text">' + _("Ký") + "</span>",
            id: btnKyId,
            on: {
                onClick: function () {
                    var tableDK = $$(tableId);
                    var selectedItem = tableDK.getSelectedItem();
                    if (selectedItem == null) {
                        webix.message("Bạn chưa chọn dòng dữ liệu ", "error");
                        return;
                    }
                    if (selectedItem.trang_thai == "Đã ký" || selectedItem.trang_thai == "Đã gửi") {
                        webix.message("Báo cáo đã ký hoặc đã gửi", "error");
                        return;
                    }
                    webix.confirm({
                        text: "Bạn có muốn ký báo cáo biên lai",
                        ok: "Có",
                        cancel: "Không",
                        callback: function (choose) {
                            if (choose) {
                                var windowView = $$(formId);
                                var gridInvoice = $$(tableId);
                                var bienlaiId = selectedItem.bienlai_id;
                                var apiUrl = {
                                    certUrl: CONSTANTS.API.TOKEN_CERT_AUTO,
                                    signTypeUrl: CONSTANTS.API.INVOICE_GET_TYPE_SIGN,
                                    exportXmlUrl: app.config.host + CONSTANTS.API.BC26.GET_XML + "?id=" + bienlaiId,
                                    signXmlUrl: app.config.host + CONSTANTS.API.BC26.SIGN,
                                    showPinUrl: CONSTANTS.API.TOKEN_SHOW_PIN,
                                    saveXmlUrl: app.config.host + CONSTANTS.API.BC26.BC26SAVE_XML,
                                };
                                signService.Sign(windowView, gridInvoice, bienlaiId, apiUrl, "BCTHSDBLai/DSCKS/TCTTPLPhi");
                            }
                        },
                    });
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button",
            type: "htmlbutton",
            width: 100,
            label: '<i class="fa fa-paper-plane fa-lg aria-hidden="true"></i><span class="text"> ' + _("Gửi CQT") + "</span>",
            id: "btnKyGuiCQT",
            click: function () {
                var table = $$(tableId);
                var selectedItem = table.getSelectedItem();
                if (selectedItem == null) {
                    webix.message("Bạn chưa chọn dòng nào ! ", "error");
                    return;
                }
                if (selectedItem.trang_thai !== "Đã ký") {
                    webix.message("Báo cáo biên lai chưa được ký hoặc đã gửi! ", "error");
                    return;
                }
                webix.confirm({
                    title: "GỬI BÁO CÁO BIÊN LAI",
                    text: "Bạn có muốn gửi báo cáo biên lai số: " + selectedItem.bienlai_id,
                    ok: "Có",
                    cancel: "Không",
                    callback: function (res) {
                        if (res) {
                            webix.extend(table, webix.ProgressBar);
                            table.disable();
                            table.showProgress();
                            webix
                                .ajax()
                                .headers({ "Content-Type": "application/json" })
                                .get(app.config.host + CONSTANTS.API.BC26.SEND_TVAN + "?id=" + selectedItem.bienlai_id, function (text) {
                                    var result = JSON.parse(text);
                                    table.enable();
                                    table.hideProgress();
                                    if (result.code != "00") {
                                        webix.message({ type: "error", text: result.message });
                                        return;
                                    } else {
                                        table.clearAll();
                                        table.load(table.config.url);
                                    }
                                });
                        }
                    },
                });
            },
        },
        {},
    ];

    var table = {
        margin: 0,
        rows: [
            {
                id: tableId,
                view: "datatable",
                datafetch: 50,
                select: true,
                resizeColumn: true,
                footer: false,
                editable: false,
                tooltip: true,
                scheme: {
                },
                on: {
                    onItemDblClick: function (id, e, node) {
                        var btnEdit = $$(btnEditId);
                        btnEdit.callEvent("onClick");
                    },
                    onAfterLoad: function () {
                        this.data.each(function (obj, i) {
                            obj.stt = i + 1;
                            if (obj.nlap && typeof obj.nlap === "string") {
                                obj.nlap = new Date(removeTimeZoneT(obj.nlap));
                            }
                        });
                    },
                    "data->onStoreUpdated": function () {
                        this.data.each(function (obj, i) {
                            obj.stt = i + 1;
                        });
                    }
                },
                onClick: {
                    btnViewLichsu: function (event, cell, target) {
                        var table = webix.$$(tableId);
                        var item = table.getItem(cell.row);
                        var detailForm = this.$scope.ui(viewLogForm.$ui);
                        viewLogForm.initUI("bc26", item.matdiep, item);
                        detailForm.show();
                    },
                },
                type: {
                    trangthaibc26: function (obj, common, value, config) {
                        var trang_thai = obj.trang_thai;
                        var mappingTT = {
                            [CONSTANTS.DA_KY]: `<span style='color: #63b4ea;font-weight: bold;'>${trang_thai}</span>`,
                            [CONSTANTS.CHO_KY]: `<span style='color: #f47537;font-weight: bold;'>${trang_thai}</span>`,
                            [CONSTANTS.THANH_CONG]: `<span class='btnViewLichsu' style='color: #008000;font-weight: bold; text-decoration: underline;'>${trang_thai}</span>`,
                            [CONSTANTS.CO_LOI]: `<span class='btnViewLichsu' style='color: #FF0000;font-weight: bold; text-decoration: underline;'>${trang_thai}</span>`
                        };
                        if (mappingTT[trang_thai]) return mappingTT[trang_thai];
                        return `<span class='btnViewLichsu' style='color: #0069b4;font-weight: bold; text-decoration: underline;'>${trang_thai}</span>`;
                    }
                },
                columns: [
                    { id: "stt", header: "STT", sort: "int", width: 40 },
                    {
                        id: "trang_thai",
                        header: ["Trạng thái", { content: "multiSelectFilter", options: CONSTANTS.STATUS_SEND_INVOICE }],
                        width: 110,
                        template: "{common.trangthaibc26()}"
                    },
                    { id: "tdvi", header: ["Tên đơn vị", { content: "serverFilter" }], width: 250, columnType: "nvarchar" },
                    {
                        id: "nlap",
                        header: ["Ngày lập", { content: "serverDateRangeFilter" }],
                        width: 150,
                        columnType: "datetime",
                        format: function (text) { return formatDate(text); }
                    },
                    { id: "mst", header: [_("MST"), { content: "serverFilter" }], width: 120, columnType: "nvarchar" },
                    { id: "dchi", header: ["Địa chỉ", { content: "serverFilter" }], width: 250, columnType: "nvarchar" },
                    {
                        id: "lkdlieu",
                        header: ["Loại kỳ dữ liệu", {
                            content: "multiSelectFilter",
                            options: [
                                { id: "T", value: "Tháng" },
                                { id: "Q", value: "Quý" },
                            ]
                        }],
                        width: 250,
                        columnType: "nvarchar",
                        template: function (obj) {
                            switch (obj.lkdlieu) {
                                case "T": return "Tháng";
                                case "Q": return "Quý";
                                case "N": return "Ngày";
                                default: return obj.lkdlieu || "";
                            }
                        }
                    },
                    { id: "kdlieu", header: ["Kỳ dữ liệu", { content: "serverFilter" }], width: 100, columnType: "nvarchar" },
                    {
                        id: "ngay_ky", header: ["Ngày ký", { content: "serverDateRangeFilter" }], width: 120, columnType: "datetime",
                        format: function (text) { return formatDate(text); }
                    },
                    {
                        id: "tgtien", header: ["Tổng tiền"], width: 120,
                        css: { "text-align": "right" }, columnType: "decimal", editor: "text", sort: "int",
                        template: function (obj) {
                            return obj.tgtien ? formatDecimal(obj.tgtien) : "0";
                        },
                    },
                ],
                pager: pagerId,
            },
            {
                id: pagerId,
                view: "pager",
                container: "paging_here",
                size: 50,
                group: 5,
                template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}"
            },
        ],
    };

    var layout = {
        css: "frmView",
        id: formId,
        rows: [
            { height: 39, css: "btnControl", margin: 0, borderless: true, type: "toolbar", cols: controls, },
            {
                rows: [table],
            },
        ],
    };
    return {
        $ui: layout,
        $oninit: function (view, $scope) {
            var table = $$(tableId);
            webix.extend(view, webix.ProgressBar);
            $scope.on(app, "dataChangeBCBL", function (mode, item) {
                table.clearAll();
                table.load(table.config.url);
            });
        },
        $onurlchange: function (ui, name, url, scope) {
            initUI();
        },
    };
});

define('views/forms/account',["app", "locale"], function (app, _) {
	var editmode = 0;

	return {
		$ui: {
			view: "window", modal: true, id: "dmtab-win",move: true,
			position: "center",
			head: "Người sử dụng",
			// 	position: function (state) {
			// 	state.width = state.maxWidth * 0.4;
			// 	state.height = state.maxHeight * 0.6;
			// 	state.left = (state.maxWidth - state.width) / 2;
			// 	state.top = (state.maxHeight - state.height) / 2;
			// },
			width: 500,
			height: 500,
			body: {
				paddingY: 10,
				paddingX: 10,
				elementsConfig: { labelWidth: 60 },
				view: "form",
				id: "dmtab-form",
				complexData: true,
				margin: 0,
				elements: [
					{
						view: "text",
						name: "username",
						labelPosition: "top",
						required: true,
						label: "Tên truy cập",
						id: "dmtab-username",
						invalidMessage: "Tên truy cập không để trống hoặc nhập không đúng (a-z,A-Z,0-9)",
						validate: webix.rules.isSpecialCharacter,
						css: "mcls_uppercase2",
						on: {
							onChange: function (newv, oldv) {
								if (newv != undefined) {
									if (oldv != undefined) {
										if (newv.toUpperCase() != oldv.toUpperCase()) {
											webix.$$(this.config.id).setValue(newv.toUpperCase());
										}
									}
									else {
										webix.$$(this.config.id).setValue(newv.toUpperCase());
									}

								}

							}
						}
					},
					{
						id: "ma_dvcs",
						view: "combo",
						name: "ma_dvcs",
						label: "Đơn vị",
						options: {
							view: "treesuggest",
							textValue: "value",
							url: {
								$proxy: true,
								load: function (view, callback, params) {
									var url = app.config.host + "/System/GetDataReferencesByRefId?refId=RF00061";

									webix.ajax(url, function (text) {
										var json = JSON.parse(text);
										var data = listToTree(json);
										view.parse(data, "json");
									});

								}
							},
							body: {
								textValue: "value",
								columns: [
									{
										id: "ma_dvcs",
										width: 100,
										header: _("MA_DVCS"),
										// hidden: true
									},
									{
										id: "ten_dvcs",
										width: 550,
										header: _("Tên đơn vị"),
										template: "{common.space()}{common.icon()}#ten_dvcs#"
									}
								],
								filterMode: {
									level: false,
									showSubItems: false
								}
							}
						},
						//id: "dmtab-store",
						labelPosition: "top",
						required: true,
						invalidMessage: "Bạn chưa chọn đơn vị"
					},
					{
						view: "combo",
						name: "wb_nhomquyen_id",
						label: "Nhóm quyền",
						options: app.config.host + "/System/GetDataReferencesByRefId?refId=RF00007",
						id: "dmtab-nhomquyen",
						labelPosition: "top",
						required: true,
						invalidMessage: "Bạn chưa chọn nhóm quyền"
					},
					{
						view: "text",
						name: "email",
						required: true,
						labelPosition: "top",
						label: "Email",
						id: "dmtab-email",
						validate: webix.rules.isEmail,
						invalidMessage: "Email không được để trống hoặc không đúng định dạng"
					},
					{
						view: "text",
						name: "ten_nguoi_sd",
						required: true,
						labelPosition: "top",
						label: "Tên người sử dụng",
						id: "dmtab-ten_nguoi_sd",
						//validate: webix.rules.isEmail,
						invalidMessage: "Tên người sử dụng không được để trống"
					},
					{
						cols: [
							{
								view: "text",
								name: "sdt",
								labelPosition: "top",
								label: "Số điện thoại",
								id: "dmtab-sdt"
							},
							{
								view: "text",
								name: "chucvu",
								labelPosition: "top",
								label: "Chức vụ",
								id: "dmtab-chucvu"
							}
						]
					},
					/* {
								view:"checkbox",
								id:"dmtab-issigninvoice",
								name:"issigninvoice",
								label:"Ký hóa đơn",
								checkValue:"C",
								uncheckValue:"K" ,
								labelWidth:85
					},
					{
						view:"fieldset",
						label:"Quyền truy cập",
						body:{
							cols:[
								{
									view:"checkbox",
									id:"dmtab-isviewuser",
									name:"isviewuser",
									label:"Xem",
									checkValue:"C",
									uncheckValue:"K" 
								},
								{
								view:"checkbox",
								id:"dmtab-isedituser",
								name:"isedituser",
								label:"Sửa",
								checkValue:"C",
								uncheckValue:"K" 
								},
								{
									view:"checkbox",
									id:"dmtab-isdeluser",
									name:"isdeluser",
									label:"Xóa",
									checkValue:"C",
									uncheckValue:"K" 
								}
							]
						}
					}, */
					{ view: "textarea", name: "dien_giai", labelPosition: "top", label: "Diễn giải", id: "dmtab-diengiai" },

					{
						margin: 10,
						cols: [
							{},
							{
								shortcut: "F10", view: "button", label: "Nhận (F10)", type: "form", align: "center",
								on: {
									onClick: function () {
										var form = webix.$$("dmtab-form");

										if (form.validate() == false) {
											return;
										}

										var item = form.getValues();

										var url = app.config.host + "/Account/Update";
										webix.extend(form, webix.ProgressBar);
										form.disable();
										form.showProgress();
										webix.ajax()
											.headers({ 'Content-type': 'application/json' })
											.post(url, item, function (text) {
												var data = JSON.parse(text);
												form.enable();
												form.hideProgress();
												if (!data.hasOwnProperty("error")) {
													item.id = data.id;
													webix.$$("dmtab-win").close();
													app.callEvent("dataChanged", [editmode, item]);
												}
												else {
													webix.message({ type: "error", text: data.error });
												}
											});
									}
								},
								click: function () {
									this.callEvent("onClick");

								}
							},
							{
								view: "button", hotkey: "esc", label: "Hủy bỏ (ESC)", type: "danger", align: "center",
								click: function () {
									webix.$$("dmtab-win").close();
								}
							},
							{}
						]
					}

				]
			}

		},
		setEditMode: function (mode) {
			editmode = mode;
		}
	};

});
define('views/forms/accountpermission',["app", "locale"], function (app, _) {

	function initUI(item) {

		var url = app.config.host + "/System/ExecuteCommand";
		var urlSeri = app.config.host + "/Serial/GetSeriPermission?id=";
		webix.ajax()
			.headers({ 'Content-type': 'application/json' })
			.post(url,
				{
					command: "CM00005",
					parameter: {
						wb_user_id: item.id
					}
				}
				, function (text) {
					var json = JSON.parse(text);
					var dtChuKySo = $$("dtChuKySo");
					dtChuKySo.parse(json, "json");
				});

		webix.ajax()
			.headers({ 'Content-type': 'application/json' })
			.post(url,
				{
					command: "CM00006",
					parameter: {
						wb_user_id: item.id,
						ma_dvcs: item.ma_dvcs
					}
				},
				function (text) {
					var json = JSON.parse(text);
					var dtMauHoaDon = $$("dtMauHoaDon");
					dtMauHoaDon.parse(json, "json");
				});
		webix.ajax()
			.headers({ 'Content-type': 'application/json' })
			.get(urlSeri + item.id,
				function (text) {
					var json = JSON.parse(text);
					var dtMauHoaDon = $$("dtMauHoaDon68");
					dtMauHoaDon.parse(json, "json");
				});
		$$("chkIssigninvoice").setValue(item.issigninvoice);
		$$("chkIsviewuser").setValue(item.isviewuser);
		$$("chkIsedituser").setValue(item.isedituser);
		$$("chkIsdeluser").setValue(item.isdeluser);
	}

	return {
		$ui: {
			view: "window", modal: true, id: "phanquyen-win", position: "center",
			head: "Thông tin Tab",
			fullscreen: true,
			css: "accountPermisson",
			body: {
				rows: [
					{
						borderless: true,
						view: "tabview",
						scrollX: true,
						multiview: {
							fitBiggest: true
						},
						cells: [
							{
								header: _("CHU_KY_SO"),
								body: {
									id: "dtChuKySo",
									view: "datatable",
									resizeRow: true,
									fixedRowHeight: false,
									rowLineHeight: 25,
									rowHeight: 70,
									//threeState: true,
									columns: [
										{
											id: "chon1",
											header: [{ text: "", content: "masterCheckbox" }, _("CHON")],
											width: 55,
											checkValue: 'C',
											uncheckValue: 'K',
											template: "{common.checkbox()}"
										},
										{ id: "so_serial", header: _("SO_SERIAL"), width: 280 },
										{ id: "subjectname", header: "Chủ thể", width: 500 },
										{ id: "ngaybatdau", header: "Ngày bắt đầu", width: 150 },
										{ id: "ngayketthuc", header: "Ngày kết thúc", width: 150 },
									]

								}
							},
							{
								header: _("MAU_HDON"),
								body: {
									id: "dtMauHoaDon",
									view: "datatable",
									columns: [
										{
											id: "chon1",
											header: [{ text: "", content: "masterCheckbox" }, _("CHON")],
											width: 55,
											checkValue: 'C',
											uncheckValue: 'K',
											template: "{common.checkbox()}"
										},
										{ id: "ma_loai", header: _("MA_LOAI"), width: 100 },
										{ id: "mau_so", header: _("MAU_SO"), width: 100 },
										{ id: "ky_hieu", header: _("KY_HIEU"), width: 100 },
										{ id: "tu_so", header: _("TU_SO"), width: 100 },
										{ id: "den_so", header: _("DEN_SO"), width: 100 },
										{
											id: "ngay_bd_sd", header: _("NGAY_BD_SD"), width: 150,
											format: function (text) {
												var format = webix.Date.dateToStr("%d/%m/%Y");
												text = removeTimeZoneT(text);
												return format(text);
											}
										}
									]
								}
							},
							{
								header: _("Mẫu hóa đơn NĐ 123"),
								body: {
									id: "dtMauHoaDon68",
									view: "datatable",
									scheme: {
										$init: function (obj) {

										}
									},
									columns: [
										{
											id: "chon1",
											header: [{ text: "", content: "masterCheckbox" }, _("CHON")],
											width: 55,
											checkValue: 'C',
											uncheckValue: 'K',
											template: "{common.checkbox()}"
										},
										{ id: "khhdon", header: [_("KY_HIEU"), { content: "textFilter" }], width: 100 },
										{ id: "lhdon", header: [_("Loại hóa đơn"), { content: "textFilter" }], width: 140 },
										{ id: "hthuc", header: [_("Hình thức"), { content: "textFilter" }], width: 140 },
										{ id: "khdon", header: [_("Kiểu hóa đơn"), { content: "textFilter" }], width: 140 }
									]
								}
							},
							// {
							// 	header: _("DONVI"),
							// 	body: {
							// 		id: "dtDonvi",
							// 		view: "datatable",
							// 		columns: [
							// 			{
							// 				id: "chon1",
							// 				header: [{ text: "", content: "masterCheckbox" }, _("CHON")],
							// 				width: 55,
							// 				checkValue: 'C',
							// 				uncheckValue: 'K',
							// 				template: "{common.checkbox()}"
							// 			},
							// 			{
							// 				id: "ma_dvcs",
							// 				header: _("MA"),
							// 				width: 100
							// 			},
							// 			{
							// 				id: "ten_dvcs",
							// 				header: _("TEN"),
							// 				width: 450
							// 			}

							// 		]
							// 	}
							// },
							{
								header: _("QUYEN_TRUY_CAP_HD"),
								body: {
									paddingY: 10,
									paddingX: 10,
									rows: [
										{ id: "chkIssigninvoice", view: "checkbox", name: "issigninvoice", labelRight: _("KY_HOA_DON"), checkValue: "C", uncheckValue: "K", labelWidth: 0 },
										{ id: "chkIsviewuser", view: "checkbox", name: "isviewuser", labelRight: _("IS_VIEW_USER"), checkValue: "C", uncheckValue: "K", labelAlign: "right", labelWidth: 0 },
										{ id: "chkIsedituser", view: "checkbox", name: "isedituser", labelRight: _("IS_EDIT_USER"), checkValue: "C", uncheckValue: "K", labelWidth: 0 },
										{ id: "chkIsdeluser", view: "checkbox", name: "isdeluser", labelRight: _("IS_DEL_USER"), checkValue: "C", uncheckValue: "K", labelWidth: 0 }
									]
								}
							}
						]
					},
					{
						cols: [
							{},
							{
								shortcut: "F10",
								view: "button", label: "Nhận (F10)", type: "form", align: "center",
								width: 100,
								on: {
									onClick: async function () {
										var dtChuKySo = $$("dtChuKySo");
										var dtMauHoaDon = $$("dtMauHoaDon");
										var kyhieu68 = $$("dtMauHoaDon68");

										var win = this.getTopParentView();
										var data = {
											wb_user_id: win.config.wb_user_id,
											ckspermission: dtChuKySo.serialize(),
											invtemppermission: dtMauHoaDon.serialize(),
											serial68: kyhieu68.serialize(),
											invoicepermission: {
												issigninvoice: $$("chkIssigninvoice").getValue(),
												isviewuser: $$("chkIsviewuser").getValue(),
												isedituser: $$("chkIsedituser").getValue(),
												isdeluser: $$("chkIsdeluser").getValue()
											}
										};
										var url = app.config.host + "/Account/Phanquyen";
										webix.extend(win, webix.ProgressBar);
										win.disable();
										win.showProgress();
										await webix.ajax()
											.bind(data)
											.headers({ 'Content-type': 'application/json' })
											.post(url, data, function (text) {
												var result = JSON.parse(text);
												win.enable();
												win.hideProgress();
												if (!result.hasOwnProperty("error")) {
													var table = webix.$$("dmwindowData");
													var item = table.getSelectedItem();

													item.issigninvoice = this.invoicepermission.issigninvoice;
													item.isviewuser = this.invoicepermission.isviewuser;
													item.isedituser = this.invoicepermission.isedituser;
													item.isdeluser = this.invoicepermission.isdeluser;

													table.updateItem(item.id, item);
													webix.$$("phanquyen-win").close();
												}
												else {
													webix.message({ type: "error", text: result.error });
												}
											});

										webix.storage.local.clear();
										webix.storage.local.put("APP_CACHE", {});
										await webix.ajax().get(app.config.host + "/Pattern/RemoveKeyRedisPattern", function (text) {
											var response = JSON.parse(text);
										});
									}
								},
								click: function () {
									this.callEvent("onClick");

								},
							},
							{
								view: "button", shortcut: "esc", type: "danger", label: "Hủy bỏ (ESC)", align: "center",
								width: 100,
								on: {
									onClick: function () {
										this.getTopParentView().close();
									}
								},
								click: function () {
									this.callEvent("onClick");
								}
							},
							{}

						]
					},
					{
						height: 5
					}
				]
			}

		},
		initUI: initUI
	};

});
define('views/account',[
    "app",
    "views/forms/account",
    "locale",
    "views/forms/accountpermission",
], function (app, dmwindowform, _, accountpermission) {
    'use strict';

    var op = [];

    webix.$$("title").parse({ title: "Hệ thống > Quản trị người dùng > Người sử dụng", details: "Danh mục người sử dụng" });

    var controls = [
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-plus fa-lg" aria-hidden="true"></i> ' +
                '<span class="text">' + _("THEM") + " (F4)" + '</span>',
            id: "btnPlus",
            shortcut: "F4",
            on: {
                onClick: function () {
                    var win = this.$scope.ui(dmwindowform.$ui);
                    dmwindowform.setEditMode(1);
                    win.show();
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-edit fa-lg" aria-hidden="true"></i> ' +
                '<span class="text">' + _("SUA") + " (F3)" + '</span>',
            id: "btnEdit",
            shortcut: "F3",
            on: {
                onClick: function () {
                    var detailForm = this.$scope.ui(dmwindowform.$ui);
                    var form = webix.$$("dmtab-form");

                    var table = webix.$$("dmwindowData");
                    var item = table.getSelectedItem();
                    if (item == null || item == undefined) {
                        webix.message("Bạn chưa chọn người sử dụng !", "error");
                        return;
                    }
                    if (item.username == "ADMINISTRATOR") {
                        webix.message("Bạn không được phép sửa tài khoản này !", "error");
                        return;
                    }

                    form.setValues(item);

                    dmwindowform.setEditMode(2);
                    detailForm.show();

                    var cb = $$("ma_dvcs");
                    cb.define("readonly", true);
                    cb.define("css", "mcls_readonly_text");
                    cb.refresh();

                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-trash-o fa-lg" aria-hidden="true"></i> ' +
                '<span class="text">' + _("XOA") + " (F8)" + '</span>',
            id: "btnDelete",
            shortcut: "F8",
            on: {
                onClick: function () {

                    var table = webix.$$("dmwindowData");
                    var item = table.getSelectedItem();
                    if (item == null || item == undefined) {
                        webix.message("Bạn chưa chọn người sử dụng !", "error");
                        return;
                    }
                    if (item.username == "ADMINISTRATOR") {
                        webix.message("Bạn không được phép xóa tài khoản này !", "error");
                        return;
                    }

                    webix.confirm({
                        text: "Bạn có muốn xóa " + item.username, ok: "Có", cancel: "Không",
                        callback: function (res) {
                            if (res) {
                                webix.ajax()
                                    .headers({ 'Content-type': 'application/json' })
                                    .post(app.config.host + "/Account/Delete", item, function (text, xml, xhr) {
                                        if (text.hasOwnProperty("error")) {
                                            webix.message(text.error);
                                            return;
                                        }

                                        table.remove(item.id);

                                    });

                            }
                        }
                    });
                }
            },
            click: function () {
                this.callEvent("onClick");
            }

        },
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-lock fa-lg" aria-hidden="true"></i> ' +
                '<span class="text">' + _("PHAN_QUYEN") + '</span>',
            id: "btnPhanQuyen",
            on: {
                onClick: function () {

                    var table = webix.$$("dmwindowData");
                    var item = table.getSelectedItem();

                    if (item == null) {
                        webix.message("Bạn chưa chọn người sử dụng", "error");
                        return;
                    }

                    var win = this.$scope.ui(accountpermission.$ui);
                    win.config.wb_user_id = item.id;
                    accountpermission.initUI(item);
                    win.getHead().setHTML("Người sử dụng: " + item.username);
                    win.show();
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {}

    ];

    var grid = {
        rows: [
            {
                id: "dmwindowData",
                view: "datatable",
                select: true,
                resizeColumn: true,
                url: app.config.host + "/Account/GetUsersByMadvcs",
                on: {
                    onItemDblClick: function (id, e, node) {
                        var btnEdit = $$("btnEdit");
                        btnEdit.callEvent("onClick");
                    }
                },
                columns: [
                    { id: "stt", header: "STT", width: 50 },
                    { id: "username", header: ["Tên truy cập", { content: "textFilter" }], width: 150 },
                    {
                        id: "wb_nhomquyen_id",
                        view: "combo",
                        options: app.config.host + "/System/GetDataReferencesByRefId?refId=RF00007",
                        header: ["Nhóm quyền", { content: "textFilter" }],
                        width: 250,
                    },
                    {
                        id: "email", header: ["Email", { content: "textFilter" }], width: 200
                    },
                    {
                        id: "ten_nguoi_sd", header: ["Tên người sử dụng", { content: "textFilter" }], width: 200
                    },
                    {
                        id: "issigninvoice", header: "Ký hóa đơn", width: 130
                    },
                    {
                        id: "isviewuser", header: "Xem", width: 60
                    },
                    {
                        id: "isedituser", header: "Sửa", width: 60
                    },
                    {
                        id: "isdeluser", header: "Xóa", width: 60
                    },
                    {
                        id: "dien_giai", header: ["Diễn giải", { content: "textFilter" }], width: 320
                    },
                    {
                        id: "ma_dvcs", header: "Đơn vị", width: 100
                    }
                ],
                pager: "pagerA"

            },
            {
                cols: [
                    {
                        view: "icon", icon: "fas fa-question-circle", id: "help_form_views", tooltip: _("HELPER"),
                        css: "helper",
                        click: function () {
                            webix.alert({
                                title: "Thông báo !",
                                text: "Bạn chưa khai báo hướng dẫn nhanh cho màn hình này !",
                                type: "alert-warning",
                                callback: function (result) {
                                }
                            });
                        }
                    },
                    {
                        view: "combo",
                        label: _("MENU_QUICK"),
                        id: "QuickMenu",
                        options: {
                            // view: "gridsuggest",
                            // id: "grid_window",
                            // template: "#name#",
                            // body: {
                            //     scroll: true,
                            //     autoheight: false,
                            //     columns: [
                            //         { id: "window_id", header: "Window Id", editor: "text", width: 100 },
                            //         { id: "name", header: "Window Name", editor: "text", width: 400 }
                            //     ],
                            //     url: app.config.host + "/System/GetQuickMenu"
                            // },
                            // on: {
                            //     onValueSuggest: function (obj) {
                            //         var start = obj.window_id != "" ? obj.code + ":" + obj.window_id : obj.code;
                            //         window.location.hash = "!/app/" + start;
                            //         $$("QuickMenu").setValue(null);
                            //     }
                            // }
                        },
                        on: {
                            onChange: function (newv, oldv) {

                            }
                        }
                    },
                    {},
                    {
                        id: "pagerA",
                        view: "pager",
                        size: 100,
                        group: 5,
                        template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}"
                    }
                ]
            }
        ]
    }

    var layout = {
        css: "frmView",
        rows: [
            {
                height: 39,
                css: "btnControl",
                type: "toolbar",
                margin: 0,
                borderless: true,
                cols: controls
            },
            {
                rows: [
                    grid
                ]
            }



        ]

    };

    return {
        $ui: layout,
        $oninit: function (view, $scope) {
            $scope.on(app, "dataChanged", function (mode, item) {

                var table = webix.$$("dmwindowData");

                if (mode == 1) {
                    table.add(item);
                    //table.select(item.iddmwindow,false);
                }

                if (mode == 2) {
                    var selectedItem = table.getSelectedItem();
                    table.updateItem(selectedItem.id, item);
                }

            });
        }
    };
});
define('views/forms/alert',[
    "app",
    "locale"
], function (app, _) {
    var editmode = 0;

    return {
        $ui: {
            view: "window",
            modal: true,
            id: "alert-win",
            css: "headformchil",
            position: "center",
            head: {
                height: 40,
                cols: [
                    {
                        id: "head-formtb", view: "template", css: "headform", template: function (obj) {
                            return '<div>Tạo thông báo đến khách hàng<div/>';
                        }
                    },
                    {
                        view: "icon", icon: "fas fa-question-circle", id: "help_formtb", tooltip: _("HELPER"), click: function () {
                            webix.alert({
                                title: "Thông báo !",
                                text: "Bạn chưa khai báo hướng dẫn nhanh cho màn hình này !",
                                type: "alert-warning",
                                callback: function (result) {
                                }
                            });
                        }
                    }
                ]
            },
            fullscreen: true,
            keepViews: true,
            move: true,
            body: {
                paddingY: 5,
                paddingX: 5,
                view: "form",
                id: "alert-form",
                elements: [
                    { view: "text", label: "inv_updateInfo_id", name: "id", hidden: true },
                    {
                        cols: [
                            {
                                view: "fieldset",
                                label: "Tài khoản",
                                body: {
                                    rows: [
                                        {
                                            view: "text",
                                            name: "taikhoan",
                                            label: _("USERNAME"),
                                            // css: "mcls_uppercase",
                                            labelPosition: "top",
                                            required: true,
                                            validate: webix.rules.isNotEmpty,
                                            invalidMessage: "Tài khoản không được để trống !"
                                        }, {
                                            view: "text",
                                            name: "matkhau",
                                            id: "matkhau",
                                            label: _("PASSWORD"),
                                            type: "password",
                                            labelPosition: "top",
                                            required: true,
                                            validate: webix.rules.isNotEmpty,
                                            invalidMessage: "Mật khẩu không được để trống !"
                                        }
                                    ]
                                }
                            },
                            {
                                view: "fieldset",
                                label: "Thông tin thông báo",
                                body: {
                                    rows: [
                                        {
                                            view: "text",
                                            name: "version",
                                            label: _("SOTB"),
                                            labelPosition: "top",
                                            required: true,
                                            validate: webix.rules.isNotEmpty,
                                            invalidMessage: "Số thông báo không được để trống !"
                                        }, {
                                            view: "text",
                                            name: "inv_describe",
                                            label: _("MOTA"),
                                            labelPosition: "top",
                                            required: true,
                                            validate: webix.rules.isNotEmpty,
                                            invalidMessage: "Mô tả không được để trống !"
                                        }
                                    ]
                                }
                            }
                        ]
                    },
                    {
                        name: "inv_content",
                        view: "ckeditor",
                        keepViews: true,
                        label: _("NOI_DUNG"),
                        labelPosition: "top"
                    },
                    {
                        margin: 10,
                        cols: [
                            {},
                            {
                                shortcut: "F10", view: "button", label: "Nhận (F10)", type: "form", align: "center", width: 120,
                                on: {
                                    onClick: function () {
                                        var form = webix.$$("alert-form");
                                        var item = form.getValues();

                                        var url = app.config.host + "/System/SaveChangeNotice";
                                        if ($$("alert-form").validate()) {
                                            webix.extend(form, webix.ProgressBar);
                                            form.disable();
                                            form.showProgress();

                                            webix.ajax()
                                                .headers({ 'Content-type': 'application/json' })
                                                .post(url, item, function (text) {

                                                    var form = webix.$$("alert-form");

                                                    form.enable();
                                                    form.hideProgress();

                                                    var data = JSON.parse(text);

                                                    if (!data.hasOwnProperty("error")) {
                                                        app.callEvent("reloadAlert");
                                                        webix.message("Tạo thông báo thành công !", "success");
                                                        webix.$$("alert-win").close();
                                                    }
                                                    else {
                                                        webix.message(data.error, "error");
                                                    }
                                                });
                                        }
                                        else {
                                            $$("matkhau").focus();
                                        }
                                    }
                                },
                                click: function () {
                                    this.callEvent("onClick");

                                }
                            },
                            {
                                view: "button", hotkey: "esc", label: "Hủy bỏ (ESC)", type: "danger", align: "center", width: 120,
                                click: function () {
                                    webix.$$("alert-win").close();
                                }
                            },
                            {}
                        ]
                    }
                ]

            }

        },
        setEditMode: function (mode) {
            editmode = mode;
        },
        setValues: function (values) {
            $$("alert-form").setValues(values);
        }
    };

});
define('views/alert',[
    "app",
    "locale",
    "views/forms/alert"
], function (app, _, alert) {
    'use strict';

    webix.$$("title").parse({ title: "M-Invoice thông báo", details: "Thông báo đến khách hàng (System M-Invoice)", url_help: "http://huongdansudung.minvoice.com.vn/" });
    var controls = [
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-refresh fa-lg" aria-hidden="true"></i> ' +
            '<span class="text">' + _("REFRESH") + '</span>',
            id: "btnRefresh",
            // shortcut: "F4",
            //css:"button_raised",
            on: {
                onClick: function () {
                    var table = webix.$$("lstAlert");
                    table.clearAll();
                    $$("contentAlert").setHTML("");
                    table.load(table.config.url);
                    //table.refresh();
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-plus fa-lg" aria-hidden="true"></i> ' +
            '<span class="text">' + _("THEM") + " (F4)" + '</span>',
            id: "btnPlus",
            //css:"button_raised",
            shortcut: "F4",
            on: {
                onClick: function () {
                    var detailForm = this.$scope.ui(alert.$ui);
                    detailForm.show();
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-edit fa-lg" aria-hidden="true"></i> ' +
            '<span class="text">' + _("SUA") + " (F3)" + '</span>',
            id: "btnEdit",
            shortcut: "F3",
            on: {
                onClick: function () {
                    var detailForm = this.$scope.ui(alert.$ui);

                    var table = webix.$$("lstAlert");
                    var item = table.getSelectedItem();
                    if (item == null) {
                        webix.message("Bạn chưa chọn dòng cần sửa !", "error");
                        return;
                    }

                    alert.setValues(item);
                    detailForm.show();
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-trash-o fa-lg" aria-hidden="true"></i> ' +
            '<span class="text">' + _("XOA") + " (F8)" + '</span>',
            id: "btnDelete",
            shortcut: "F8",
            on: {
                onClick: function () {
                    var table = webix.$$("lstAlert");
                    var item = table.getSelectedItem();
                    if (item == null) {
                        webix.message("Bạn chưa chọn dòng cần xóa !", "error");
                        return;
                    }

                    webix.confirm({
                        text: "Bạn có muốn xóa " + item.version, ok: "Có", cancel: "Không",
                        callback: function (res) {
                            if (res) {
                                webix.ajax()
                                    .headers({ 'Content-type': 'application/json' })
                                    .post(app.config.host + "/System/DeleteNotice", item, function (text) {

                                        if (text.hasOwnProperty("error")) {
                                            webix.message(text.error);
                                            return;
                                        }

                                        table.remove(item.id);
                                        $$("contentAlert").setHTML("");
                                        webix.message("Xóa thành công !", "success");
                                    });
                            }
                        }
                    });
                }
            },
            click: function () {
                this.callEvent("onClick");
            }

        },
        {}

    ];
    var grid = {
        cols: [
            {
                view: "list",
                id: "lstAlert",
                select: true,
                tooltip: function (obj) {
                    return obj.version + " - " + obj.inv_describe;
                },
                on: {
                    onItemClick: function (id, e, node) {
                        var item = this.getItem(id);
                        $$("contentAlert").setHTML(item.inv_content);
                    }
                },
                url: app.config.host + "/System/GetNotification",
                template: "#version# - #inv_describe#",
                width: 350
            },
            // {width:5},
            {
                // paddingX: 5,
                // paddingY: 5,
                rows: [
                    {
                        view: "template", id: "contentAlert", scroll: "xy",
                        type: { height: "auto" }
                    }
                ]
            }
        ]
    };
    var layout = {
        css: "frmView",
        rows: [
            {
                height: 39,
                css: "btnControl",
                type: "toolbar",
                margin: 0,
                borderless: true,
                cols: controls
            },
            {
                rows: [
                    grid
                ]
            }
        ]

    };

    return {
        $ui: layout,
        $oninit: function (view, $scope) {
            $scope.on(app, "reloadAlert", function () {
                var table = webix.$$("lstAlert");
                table.clearAll();
                $$("contentAlert").setHTML("");
                table.load(table.config.url);
            });
        }
    };
});
define('views/menus/search',[],function(){

return {
	$ui:{
		view: "popup",
		id: "searchPopup",

		width: 300,
		body:{
			rows:[
				{
					view: "search"
				},
				{
					borderless:true, css: "extended_search", template: "<span>Extended search</span>", height: 40
				}
			]

		}
	}
};

});
define('views/forms/changepass',["app"], function (app) {

	return {
		$ui: {
			view: "window", modal: true, id: "listuser-win", position: "center",move: true,
			head: "Đổi mật khẩu",
			body: {
				paddingY: 10,
				paddingX: 10,
				//elementsConfig:{labelWidth: 120}, 
				view: "form",
				id: "listuser-form",
				complexData: true,
				elements: [
					{ view: "text", name: "oldpass", required: true, invalidMessage: "Mật khẩu cũ không được bỏ trống", type: "password", label: "Mật khẩu cũ", labelPosition: "top" },
					{ view: "text", name: "newpass", required: true, invalidMessage: "Mật khẩu mới không được bỏ trống", type: "password", label: "Mật khẩu mới", labelPosition: "top" },
					{ view: "text", name: "confirmpass", required: true, invalidMessage: "Xác nhận mật khẩu không được bỏ trống", type: "password", label: "Xác nhận mật khẩu", labelPosition: "top" },
					{
						margin: 10,
						cols: [
							{},
							{
								view: "button", label: "Nhận (F10)", hotkey: "F10", type: "form", align: "center", width: 120, click: function () {

									var form = webix.$$("listuser-form");

									if (form.validate() == false) {
										return;
									}

									var item = form.getValues();

									if (item.newpass != item.confirmpass) {
										webix.message("Mật khẩu mới không giống nhau", "error");
										return;
									}

									webix.ajax()
										.post(app.config.host + "/Account/ChangePass", item, function (text) {
											var data = JSON.parse(text);

											if (!data.hasOwnProperty("error")) {
												webix.$$("listuser-win").close();
												webix.message("Đổi mật khẩu thành công !", "success");
											}
											else {
												webix.message(data.error, "error");
											}
										});
								}
							},
							{
								view: "button", label: "Hủy bỏ (ESC)", hotkey: "esc", type: "danger", align: "center", width: 120, click: function () {
									webix.$$("listuser-win").close();
								}
							},
							{}
						]
					}

				]
			}
		}
	};

});
define('views/modules/chatplugin',[
    'app',
    'models/user'
], function (app, user) {
    'use strict';
    var hub = null;
    // var ChatUrl = "http://localhost:52527/signalr";
    // //This will hold the connection to the signalr hub   
    // var SignalrConnection = $.hubConnection(ChatUrl, {
    //     useDefaultPath: false
    // });
    // var hub = SignalrConnection.createHubProxy('chatHub');
    // //connecting the client to the signalr hub   
    // hub.on("addNewMessageToPage", function (name, message) {
    //     console.log(name + message);
    // });

    // SignalrConnection.disconnected(function () {
    //     console.log('Connection disconnected');
    // });
    // SignalrConnection.start().done(function () {
    //     console.log("Connected to Signalr Server");
    // })
    //     .fail(function () {
    //         console.log("failed in connecting to the signalr server");
    //     });
    return {
        hub: function () {
            return hub;
        }
    }
});
define(
    'views/forms/chat',[
        "app",
        "models/user",
        "views/modules/chatplugin"
    ], function (app, user, proxy) {


        // var hub = proxy.hub();
        // hub.on("addNewMessageToPage", function (name, message) {
        //     addChatMessage(name, message);
        // });

        // function change_weather(i) {
        //     var jj = proxy.hub();
        //     jj.invoke('change_weather', i);
        // }

        function addChatMessage(name, message) {
            var chat = $$("chat");

            chat.add({
                user: name,
                value: message
            });

            var lastId = chat.getLastId();
            chat.scrollTo(0, lastId);

            $$("message").setValue("");
            $$("message").focus();
        }

        return {
            $ui: {
                view: "window", modal: true, id: "chat-win", position: "center", move: true,
                head: "M-Invoice Chat",
                // head: {
                //     view: "toolbar",
                //     height: 25,
                //     cols: [
                //         { view: "label", label: "M-Invoice Chat" },
                //         {
                //             view: "icon", icon: "times", hotkey: "esc", click: function () {
                //                 $$("chat-win").close();
                //             }
                //         }
                //     ]
                // },
                width: 700,
                height: 500,
                body: {
                    paddingY: 10,
                    paddingX: 10,
                    //elementsConfig:{labelWidth: 120}, 
                    view: "form",
                    id: "chat-form",
                    complexData: true,
                    elements: [
                        //rows: [
                        //  { template: "Webix Based Chat", type: "header" },
                        // {
                        //     view: "list", id: "chat", gravity: 3,
                        //     // url: "faye->/data", save: "faye->/data",
                        //     // type: { height: "auto" },
                        //     // template: chat_template
                        // },
                        {
                            view: "list", id: "chat", gravity: 3,
                            type: { height: "auto" },
                            template: function (obj) {
                                return "<span " + (obj.user == user.getCurrentUser() ? "class='rowBold'" : "class='rowBoldGreen'") + ">" + obj.user + "</span> " + obj.value;
                            }
                        },
                        {
                            cols: [
                                { view: "textarea", id: "message", placeholder: "Type message here", gravity: 3 },
                                {
                                    rows: [
                                        {
                                            view: "button", value: "Send", type: "form",
                                            // width: 100,
                                            click: function () {
                                                //change_weather(124124);
                                                var text = $$("message").getValue();
                                                var ds = user.getCurrentUser();
                                                //webix.message("Hệ thống đang bảo trì !", "error");
                                                //send(ds, text);
                                                var hub = proxy.hub();
                                                hub.invoke("Send", user.getCurrentUser(), text)
                                                    .done(function () {
                                                        console.log("send ok !")
                                                        //addChatMessage(ds, text);
                                                    })
                                                    .fail(function (error) {
                                                        console.log(error);
                                                    });

                                            }
                                            // click: function () {
                                            //     webix.message("Hệ thống đang bảo trì !", "error");
                                            // }
                                        },
                                        {
                                            view: "button", value: "Hủy bỏ (ESC)", type: "danger", hotkey: "esc", align: "center",
                                            // width: 100,
                                            click: function () {
                                                webix.$$("chat-win").close();
                                            }
                                        }
                                    ]
                                }

                            ]
                        }
                    ]
                }
                //], type: "space", margin: 2

            }
        };

    });
define('views/hotroform',["app", "locale"], function (app, _) {
    var layout = {
        view: "window", modal: true, id: "hotro-win", position: "center", move: true,
        head: "Gửi yêu cầu hỗ trợ đến M-Invoice",
        width: 500,
        body: {
            paddingY: 10,
            paddingX: 10,
            view: "form",
            id: "hotro-form",
            complexData: true,
            elements: [
                {
                    view: "text", name: "ms_thue", id: "ms_thue", label: _("MS_THUE"),
                    css: "mcls_readonly_text", readonly: true, labelPosition: "top"
                },
                {
                    view: "text", name: "ten_dvcs", id: "ten_dvcs", label: _("DONVI"),
                    css: "mcls_readonly_text", readonly: true, labelPosition: "top"
                },
                {
                    view: "text", name: "dia_chi", label: _("DIA_CHI"),
                    css: "mcls_readonly_text", readonly: true, labelPosition: "top"
                },
                {
                    cols: [
                        {
                            view: "text", name: "nguoi_dai_dien", label: _("NGUOI_DAI_DIEN_PL"),
                            css: "mcls_readonly_text", readonly: true, labelPosition: "top"
                        },
                        {
                            view: "text", name: "email", label: _("EMAIL"),
                            css: "mcls_readonly_text", readonly: true, labelPosition: "top"
                        }
                    ]
                },
                {
                    cols: [
                        {
                            view: "text", name: "nguoi_lien_he", id: "nguoi_lien_he", label: _("NGUOI_LIEN_HE"),
                            labelPosition: "top", required: true, invalidMessage: "Bạn phải nhập người liên hệ"
                        },

                        {
                            view: "text", name: "sdt", id: "sdt", label: _("SDT"),
                            labelPosition: "top", required: true, invalidMessage: "Bạn phải nhập số điện thoại"
                        }
                    ]
                },
                {
                    cols: [
                        { view: "text", name: "teamview", id: "teamview", label: _("TEAMVIEW"), labelPosition: "top" },
                        { view: "text", name: "pass", id: "pass", label: _("PASSWORD"), labelPosition: "top" }
                    ]
                },
                { id: "noi_dung", view: "textarea", name: "noi_dung", label: "Yêu cầu hỗ trợ", height: 120, labelPosition: "top" },
                {
                    margin: 10,
                    cols: [
                        {},
                        {
                            shortcut: "F10", view: "button", label: "Gửi (F10)", align: "center", width: 120, type: "form",
                            on: {
                                onClick: function () {
                                    var form = webix.$$("hotro-form");

                                    var item = form.getValues();
                                    var format = webix.Date.dateToStr("%d/%m/%Y - %H:%i");
                                    var string = format(new Date());

                                    var descrip = "Ngày :" + string + "</br>"
                                        + "Công ty :" + item.ten_dvcs + "</br>"
                                        + "Mã số thuế :" + item.ms_thue + "</br>"
                                        + "Người liên hệ: " + item.nguoi_lien_he + "</br>"
                                        + "Số điện thoại: " + item.sdt + "</br>"
                                        + "Teamview (UltraViewer): " + item.teamview + "</br>"
                                        + "Pass: " + item.pass + "</br>"
                                        + "Nội dung cần hỗ trợ: " + item.noi_dung + "</br>";

                                    if ($$("hotro-form").validate()) {
                                        var box = webix.modalbox({
                                            title: "Đang gửi yêu cầu hỗ trợ đến M-Invoice",
                                            text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                                            width: 350,
                                            height: 200
                                        });

                                        var data = {
                                            "mst": item.ms_thue,
                                            "noidung": item.noi_dung,
                                            "nguoi_lien_he": item.nguoi_lien_he,
                                            "sdt_nguoi_lien_he": item.sdt,
                                            "ultra_teamview": item.teamview,
                                            "pass": item.pass
                                        }
                                        // var data = {
                                        //     "chatId": uuidv4(),
                                        //     "visitor": {
                                        //         "name": "",
                                        //         "city": "",
                                        //         "country": "",
                                        //         "email": ""
                                        //     },
                                        //     "message": {
                                        //         "sender": {
                                        //             "type": "visitor"
                                        //         },
                                        //         "text": `Mã số thuế : ${item.ms_thue}\r\nHọ Tên : ${item.nguoi_lien_he}\r\nĐiện thoại : ${item.sdt}\r\nTeamview : ${item.teamview} ${item.pass}\r\nCâu hỏi cần hỗ trợ :${item.noi_dung}`,
                                        //         "type": "msg"
                                        //     },
                                        //     "time": "2023-04-17T09:51:23.481Z",
                                        //     "event": "chat:start",
                                        //     "property": {
                                        //         "id": "5b713334afc2c34e96e783c7",
                                        //         "name": "Support 1.0"
                                        //     }
                                        // };
                                        webix.ajax()
                                            .headers({ 'Content-type': 'application/json' })
                                            .post(app.config.host + "/System/SendSupport", data, {
                                                error: function (text, data, XmlHttpRequest) {
                                                    webix.modalbox.hide(box);
                                                    alert(text);
                                                },
                                                success: function (text, data, XmlHttpRequest) {
                                                    var json = JSON.parse(text);
                                                    if (!json.hasOwnProperty("error")) {
                                                        $$("nguoi_lien_he").setValue(null);
                                                        $$("sdt").setValue(null);
                                                        $$("teamview").setValue(null);
                                                        $$("pass").setValue(null);
                                                        $$("noi_dung").setValue(null);
                                                        webix.message("Gửi yêu cầu hỗ trợ thành công !", "debug");
                                                    }
                                                    else {
                                                        webix.message(json.error, "error");
                                                    }
                                                    webix.modalbox.hide(box);
                                                }
                                            });
                                    }
                                }
                            },
                            click: function () {
                                this.callEvent("onClick");
                            }
                        },
                        {
                            shortcut: "F10", view: "button", label: "Nhập lại (F9)", align: "center", width: 120, type: "form",
                            on: {
                                onClick: function () {
                                    $$("nguoi_lien_he").setValue(null);
                                    $$("sdt").setValue(null);
                                    $$("teamview").setValue(null);
                                    $$("pass").setValue(null);
                                    $$("noi_dung").setValue(null);
                                }
                            },
                            click: function () {
                                this.callEvent("onClick");
                            }
                        },
                        {
                            view: "button", hotkey: "esc", label: "Hủy bỏ (ESC)", align: "center", width: 120, type: "danger",
                            click: function () {
                                webix.$$("hotro-win").close();
                            }
                        },
                        {}
                    ]
                }
            ]
        }
    };
    return {
        $ui: layout,
        initUI: function (json) {
            $$("hotro-form").setValues(json);
        }
    };

});
define('views/menus/profile',[
	"app",
	"models/user",
	"views/forms/changepass",
	"locale",
	"views/forms/chat",
	"views/hotroform",
	"views/menus/version"
], function (app, user, changepass, _, chat, hotroform, version) {
	webix.attachEvent("onBeforeAjax",
		function (mode, url, data, request, headers, files, promise) {
			var token = user.getAccessToken();
			var dvcs = user.getDvcsID();
			var language = user.getLanguage();
			var bear = token + ";" + dvcs + ";" + language;
			headers["Authorization"] = "Bear " + bear;
		}
	);
	var company = version.getInfocompany();
	return {
		$ui: {
			view: "popup",
			id: "profilePopup",
			css: "profilePopup",
			resize: true,
			autofit: true,
			autoHeight: true,
			minHeight: 300,
			// minWidth: 360,
			body: {
				view: "list",
				select: true,
				datatype: "json",
				css: "profile",
				borderless: true,
				data: [
					{ id: "info", icon: "mdi mdi-logout", value: _("Info") },

					{ id: "infoCompany", icon: "mdi mdi-account-box-outline", value: "Thông tin công ty" },
					{ id: "minvoicesupport", icon: "mdi mdi-message-text-outline", value: _("MVSUPPORT") },
					{ id: "minvoicechat", icon: "mdi mdi-chat-alert-outline", value: _("MVCHAT") },

					{ id: "divider", icon: "", value: "" },

					{ id: "delcache", icon: "mdi mdi-cog-outline", value: _("DEL_CACHE") },
					{ id: "changepass", icon: "mdi mdi-lock", value: _("CHANGE_PASS") },
					{ id: "logout", icon: "mdi mdi-logout", value: _("LOGOUT") }
					// { $template: "Separator" },
				],
				template: function (obj) {
					var response;
					switch (obj.id) {
						case "info":
							response = `<div class="p-3 border-bottom">
								<h6 class="mb-0">${user.getCurrentUser()}</h6>
								<p class="mb-0 font-size-11 text-muted">${company.ms_thue}</p>
							</div>`
							break;
						case "divider":
							response = `<div class="dropdown-divider"></div>	`
							break;
						case "delcache":
							response = `<div class="${obj.id}"><a class="dropdown-item" href="#"><i class="mdi ${obj.icon} font-size-16 align-middle me-1"></i> <span class="align-middle">${obj.value} </span><span class="badge badge-soft-success ms-auto">Hot</span></a></div>`
							break;
						default:
							response = `<div class="${obj.id}"><a class="dropdown-item" href="#"><i class="mdi ${obj.icon} font-size-16 align-middle me-1"></i> <span class="align-middle">${obj.value}</span></a></div>`
							break;
					}
					return response;
				},
				type: {
					height: "auto"
				},
				on: {
					onItemClick: function (id, e, node) {
						$$("profilePopup").hide();
						switch (id) {
							case "infoCompany":
								var menu = $$('app:menu'); menu.$scope.show('./infocompany');
								break;
							case "minvoicesupport":
								var win = this.$scope.ui(hotroform.$ui);
								hotroform.initUI(company);
								win.show();
								break;
							case "minvoicechat":
								var win = this.$scope.ui(chat.$ui);
								win.show();
								break;
							case "delcache":
								webix.ajax().get(app.config.host + "/Pattern/RemoveKeyRedisPattern", function (text) {
									var response = JSON.parse(text);
								});
								webix.storage.local.clear();
								webix.storage.local.put("APP_CACHE", {});
								webix.message("Đã xóa cache dữ liệu", "debug");
								break;
							case "changepass":
								var win = this.$scope.ui(changepass.$ui);
								win.show();
								break;
							case "logout":
								user.logout();
								document.location.reload();
								/* require(["app"], function(app){
									app.router(app.config.start);
								}); */
								break;
						}
					}
				}
			}
		}
	};
});
define('views/menus/menubar',["app"], function (app) {
	function RouterMenuBar(item) {
		var start = item.window_id != "" ? item.code + ":" + item.window_id : item.code;
		if (item.window_id == "WIN00026")
			start = "wb_setting";
		app.router("app/" + start);
		webix.storage.local.put("APP_DEFAULT", "app/" + start);
		webix.storage.local.put("PATH", item.path);
		webix.storage.local.put("MENU_ID", item.id);
		// this.$scope.show("./" + start);
		if (webix.$$("title") != undefined)
			webix.$$("title").parse({ title: item.path, details: item.details, code: item.code });
	}
	function ReplaceIcon(icon, value) {
		var respone;
		switch (icon) {
			case "fas fa-home":
				respone = '<span class="mdi mdi-24px mdi-home-outline"></span><div style="color:#FF0000;">' + value + '</div>';
				break;
			case "fas fa-gear":
				respone = '<i class="mdi mdi-24px mdi-cog-outline"></i><div>' + value + '</div>';
				break;
			case "fas fa-file-text-o":
				respone = '<i class="mdi mdi-24px mdi-file-document-outline"></i><div>' + value + '</div>';
				break;
			case "fas fa-far fa-address-book-o":
				respone = '<i class="mdi mdi-24px mdi-file-import-outline"></i><div>' + value + '</div>';
				break;
			case "fas fa-chart-bar":
				respone = '<i class="mdi mdi-24px mdi-chart-bar"></i><div>' + value + '</div>';
				break;
			case "fas fa-bar-chart":
				respone = '<i class="mdi mdi-24px mdi-chart-bar"></i><div>' + value + '</div>';
				break;
			case "fas fa-cube":
				respone = '<i class="mdi mdi-24px mdi-cube-outline"></i><div>' + value + '</div>';
				break;
			case "fas fa-wrench":
				respone = '<i class="mdi mdi-24px mdi-hammer-screwdriver"></i><div>' + value + '</div>';
				break;
			case "fas fa-book":
				respone = '<i class="mdi mdi-24px mdi-folder-file-outline"></i><div>' + value + '</div>';
				break;
			case "voucher":
				respone = '<i class="mdi mdi-24px mdi-ticket-percent-outline"></i><div>' + value + '</div>';
				break;
			default:
				respone = '<span class="webix_icon ' + icon + ' fa-lg"></span><div>' + value + '</div>';
				break;
		};
		return respone;
	};
	return {
		$ui: {
			view: "menu",
			id: "app:menu",
			url: app.config.host + "/System/GetMenuBar",
			css: "menuView",
			autowidth: true,
			template: function (obj) {
				return ReplaceIcon(obj.icon, obj.value);
			},
			on: {
				onMenuItemClick: function (id) {
					var item = this.getMenuItem(id);
					if (item.url != "") {
						var win = window.open(item.url, '_blank');
						win.focus();
						return;
					}
					if (item.is_note == "") {
						webix.message("Chức năng chờ CQT ban hành trong thời gian tới", "debug");
						return;
					}
					if (item.code == "") return;
					RouterMenuBar(item);
				},
				onBeforeRender: function (data) {
				}
			},
			type: {
				iconTop: true,
				subsign: true
			}
		},
		getApiHost: function () {
			return app.config.host;
		}
	};
});


define('views/menus/notification',["app"
], function (app) {

    function initUI(item) {
        $$("lstUser").select(item.id);
        $$("content").setHTML(item.inv_content);
        $$("notification-win").getHead().setHTML("Thông tin bản cập nhật: " + item.version);
    }

    return {
        $ui: {
            view: "window", modal: true, id: "notification-win", position: "center", resize: true, move: true,
            head: "Thông tin bản cập nhật",
            body: {
                view: "form",
                id: "notification-form",
                height: 500,
                complexData: true,
                elements: [
                    {
                        cols: [
                            {
                                view: "list",
                                id: "lstUser",
                                select: true,
                                on: {
                                    onItemClick: function (id, e, node) {
                                        var item = this.getItem(id);
                                        //webix.message(id, "error");
                                        var frm = $$("notification-form");
                                        webix.extend(frm, webix.ProgressBar);
                                        frm.disable();
                                        frm.showProgress();
                                        webix.ajax()
                                            .headers({ 'Content-type': 'application/json' })
                                            .post(app.config.host + "/System/SaveReadNotice", item, {
                                                error: function (text, data, XmlHttpRequest) {
                                                    frm.enable();
                                                    frm.hideProgress();
                                                    alert(text);
                                                },
                                                success: function (text, data, XmlHttpRequest) {
                                                    frm.enable();
                                                    frm.hideProgress();
                                                    var js = JSON.parse(text);
                                                    if (js.hasOwnProperty("error")) {
                                                        webix.message(js.error, "error");
                                                    }
                                                    $$("notification-win").getHead().setHTML("Thông tin bản cập nhật: " + item.version);
                                                    $$("content").setHTML(item.inv_content);
                                                }
                                            });


                                    }
                                },
                                url: app.config.host + "/System/GetListNotification",
                                // data: [
                                //     { id: 1, version: "3.1.0.0", update: "Lorem ipsum dolor sit amet", personId: 1 },
                                //     { id: 2, version: "3.2.0.0", update: "Praesent luctus nulla enim, pellentesque condimentum ", personId: 2 },
                                //     { id: 3, version: "3.3.0.0", update: "Lorem ipsum dolor sit amet", personId: 2 },
                                //     { id: 4, version: "3.4.0.0", update: "Morbi eget facilisis risus", personId: 1 },
                                //     { id: 5, version: "3.5.0.0", update: "Cras lacinia bibendum arcu", personId: 1 }
                                // ],
                                template: "- #version#",
                                width: 300
                            },
                            {
                                width: 750,
                                paddingX: 5,
                                paddingX: 5,
                                rows: [
                                    {
                                        view: "template", id: "content", scroll: "xy",
                                        type: { height: "auto" }
                                    },
                                    {
                                        paddingY: 5,
                                        cols: [
                                            {},
                                            {
                                                view: "button", type: "danger", label: "Đóng (ESC)", shortcut: "esc", align: "center", width: 100,
                                                on: {
                                                    onClick: function () {
                                                        var url = app.config.host + "/System/GetNoticeCount";
                                                        webix.ajax()
                                                            .headers({ 'Content-type': 'application/json' })
                                                            .get(url, function (text) {
                                                                var notice = JSON.parse(text);
                                                                $$("mess").define({ value: notice.length });
                                                                $$("mess").refresh();
                                                            });
                                                        webix.$$("notification-win").close();
                                                    }
                                                },
                                                click: function () {
                                                    this.callEvent("onClick");
                                                }
                                            },
                                            {}
                                        ]
                                    }
                                ]
                            }
                        ]
                    }

                ]
            }
        },
        initUI: initUI
    };

});
// icon button with count marker
webix.protoUI({
	name:"icon",
	$skin:function(){
		this.defaults.height = webix.skin.$active.inputHeight;
	},
	defaults:{
		template:function(obj){
			var html = "<button style='height:100%;width:100%;line-height:"+obj.aheight+"px' class='webix_icon_button'>";
			html += "<span class='webix_icon fa-"+obj.icon+"'></span>";
			if(obj.value)
				html += "<span class='webix_icon_count'>"+obj.value+"</span>";
			html += "</button>";
			return html;
		},
		width:33
	},
	_set_inner_size:function(){

	}
}, webix.ui.button);
define("views/webix/icon", function(){});

// Type for left menu
webix.type(webix.ui.tree, {
	name:"menuTree",
	height: 40,
	icon:function(obj, common){
		var html = "";
		/*var open = "";
		for (var i=1; i<=obj.$level; i++){
			if (i==obj.$level && obj.$count){
				var dir = obj.open?"down":"right";
				html+="<span class='"+open+" webix_icon fa-angle-"+dir+"'></span>";
			}
		}*/
		return html;
	},
	folder:function(obj, common){
		if(obj.icon)
			return "<span class='webix_icon icon fa-"+obj.icon+"'></span>";
		return "";
	}
});
webix.type(webix.ui.tree, {
	name:"menuTree2",
	height: 40,

	icon:function(obj, common){
		var html = "";
		var open = "";
		for (var i=1; i<=obj.$level; i++){
			if (i==obj.$level && obj.$count){
				var dir = obj.open?"down":"right";
				html+="<span class='"+open+" webix_icon fa-angle-"+dir+"'></span>";
		    }
		}
		return html;
	},
	folder:function(obj, common){
		if(obj.icon)
			return "<span class='webix_icon icon fa-"+obj.icon+"'></span>";
		return "";
	}
});
define("views/webix/menutree", function(){});

define('views/app',[
	"views/menus/search",
	"views/menus/profile",
	//"views/menus/sidebar",
	"views/menus/menubar",
	"models/user",
	"views/menus/version",
	"views/menus/notification",
	"app",
	"views/webix/icon",
	"views/webix/menutree"
], function (search, profile, menuBar, user, version, notification, app) {
	var apiHost = menuBar.getApiHost();
	var getYear = function () {
		var dateCurrent = new Date();
		var monthCurrent = dateCurrent.getMonth() + 1;
		var yearCurrent = dateCurrent.getFullYear();
		if (monthCurrent >= 12)
			return Number(yearCurrent) + 1;
		else
			return yearCurrent;
	}
	webix.attachEvent("onBeforeAjax",
		function (mode, url, data, request, headers, files, promise) {
			webix.callEvent("onLoadError");
			var token = user.getAccessToken();
			var dvcs = user.getDvcsID();
			var language = user.getLanguage();
			var bear = token + ";" + dvcs + ";" + language;
			headers["Authorization"] = "Bear " + bear;
		}
	);
	webix.attachEvent("onLoadError", function (text, xml, ajax, owner) {
		if (text != undefined) {
			var response = JSON.parse(text);
			if (response.Message == "Authorization has been denied for this request.") {
				webix.message(response.Message + response.data, "error", 5000);
				user.logout();
				document.location.reload();
			}
			console.log(response);
		}
	});
	webix.attachEvent("onAjaxError", function (xhr) {
		console.log(xhr);
		var response = JSON.parse(xhr.response);
		showError(response.message);
	});
	webix.ui({
		view: "window", move: true,
		position: function (state) {
			state.width = state.maxWidth * 0.4;
			state.height = state.maxHeight * 0.6;
			state.left = (state.maxWidth - state.width) / 2;
			state.top = (state.maxHeight - state.height) / 2;
		},
		modal: true,
		head: "Danh sách ký hiệu sử dụng",
		id: "dangkyBanner",
		body: {
			paddingY: 0,
			paddingX: 0,
			view: "form",
			id: "dangkyForm",
			complexData: true,
			keepViews: true,
			multiview: { keepViews: true },
			margin: 0,
			elements: [
				{
					type: "space",
					borderless: false,
					rows: [
						{
							view: "datatable", resizeColumn: true, id: "lstKyhieu", editable: false, select: "row", drag: true,
							url: app.config.host + "/Serial/GetAllSeri",
							on: {
								"data->onStoreUpdated": function () {
									this.data.each(function (obj, i) { obj.stt = i + 1; })
								}
							},
							columns: [
								{ id: "stt", header: "", width: 30, editable: true, editor: "text" },
								{
									id: "hthuc", header: "Hình thức", editor: "text", editable: true, width: 130,
									template: function (obj) {
										if (obj.hthuc == "C")
											return "<span style='color: blue;'>Có mã CQT</span>";
										else
											return "<span style='color: #FF0000;'>Không mã CQT</span>";
									}
								},
								{ id: "lhdon", header: "Loại HĐ", editor: "text", editable: true },
								{ id: "khhdon", header: "Ký hiệu", editor: "text", editable: true },
								{ id: "tmau", header: "Mẫu hóa đơn", editor: "text", editable: true, fillspace: true }
							]
						},
						{
							view: "label",
							label: "Để chuyển các ký hiệu qua năm <b style='color:blue;'>" + getYear() + "</b> tự động, Quý khách hàng vui lòng nhấn <b style='color:blue;'>Đồng ý</b>."
						},
						{
							shortcut: "F10", view: "button", id: "btnChuyendoi", label: "Đồng ý", type: "form", align: "center", width: 120,
							on: {
								onClick: function () {

									webix.confirm({
										title: "CẬP NHẬT KÝ HIỆU",
										text: "Bạn có muốn tự động cập nhật ký hiệu lên năm <b style='color:blue;'>" + getYear() + "</b>", ok: "Có", cancel: "Không",
										callback: function (res) {
											if (res) {

												var url = app.config.host + "/Serial/UpdateSeriNewYear";
												var table = $$("lstKyhieu");
												webix.extend(table, webix.ProgressBar);
												table.disable();
												table.showProgress();
												webix.ajax()
													.headers({ 'Content-type': 'application/json' })
													.get(url, function (text) {
														var res = JSON.parse(text);
														table.enable();
														table.hideProgress();
														if (res.code == "00") {
															$$("dangkyBanner").close();
															webix.message("Chuyển ký hiệu thành công", "success");
														}
														else {
															webix.message(res.message, "error");
														}
													});
											}
										}
									});

								}
							},
							click: function () {
								this.callEvent("onClick");
							}
						}
					]
				}

			]
		},
		on: {
			onShow: function () {
				var self = this;
				$(".webix_modal").one("click", function () {
					self.hide();
				});
			}
		}
	});
	webix.ui({
		view: "window", move: true,
		// position: "center",
		position: function (state) {
			state.width = state.maxWidth * 0.4;
			state.height = state.maxHeight * 0.8;
			state.left = (state.maxWidth - state.width) / 2;
			state.top = (state.maxHeight - state.height) / 2;
		},
		modal: true,
		head: false,
		id: "noticeBanner",
		body: {
			paddingY: 0,
			paddingX: 0,
			view: "form",
			id: "noticeForm",
			complexData: true,
			keepViews: true,
			multiview: { keepViews: true },
			margin: 0,
			rows: [
				{
					view: "text",
					id: "inv_news_id",
					name: "inv_news_id",
					hidden: true
				},
				{
					id: "bodyBanner",
					view: "template",
					scroll: "y"
				},
				{
					view: "checkbox",
					id: "ck_banner",
					labelRight: "Không hiện thông báo này trong lần tiếp theo",
					labelWidth: 0
				}
			]
		},
		on: {
			onShow: function () {
				var self = this;
				$(".webix_modal").one("click", function () {
					var val = $$("ck_banner").getValue();
					if (val == 1) {
						var item = $$("noticeForm").getValues();
						var frm = $$("invoiceBody");
						webix.extend(frm, webix.ProgressBar);
						frm.disable();
						frm.showProgress();
						webix.ajax()
							.headers({ 'Content-type': 'application/json' })
							.post(app.config.host + "/System/SaveReadNotice", item, {
								error: function (text, data, XmlHttpRequest) {
									frm.enable();
									frm.hideProgress();
									alert(text);
								},
								success: function (text, data, XmlHttpRequest) {
									frm.enable();
									frm.hideProgress();
									var js = JSON.parse(text);
									if (js.hasOwnProperty("error")) {
										webix.message(js.error, "error");
									}
								}
							});
					}

					self.hide();
				});
			}
		}
	});
	webix.ui({
		view: "popup",
		css: "profilePopup",
		id: "messagePopup",
		on: {
			onShow: function () {
			}
		},
		body: {
			rows: [
				{
					id: "notice",
					view: "list",
					css: "profile",
					select: true,
					url: {
						$proxy: true,
						load: function (view, callback, params) {
							var url = apiHost + "/System/GetListNotification";

							webix.ajax().bind(view)
								.headers({ 'Content-type': 'application/json' })
								.get(url, callback);
						}
					},
					template: function (obj) {
						if (obj.read == false)
							return "<b> " + obj.version + "<sup style='color:blue;' > New</sup> </b></br>" + obj.inv_describe;
						else
							return "<b> " + obj.version + "<sup style='color:#e3aa24;' > <i class='fa fa-star' aria-hidden='true'></i></sup> </b></br>" + obj.inv_describe;
					},

					type: {
						height: "auto"
					},
					on: {
						onItemClick: function (id, e, trg) {
							var win = $$("app:menu").$scope.ui(notification.$ui);
							var item = this.getItem(id);
							notification.initUI(item);
							var frm = $$("invoiceBody");
							webix.extend(frm, webix.ProgressBar);
							frm.disable();
							frm.showProgress();
							webix.ajax()
								.headers({ 'Content-type': 'application/json' })
								.post(app.config.host + "/System/SaveReadNotice", item, {
									error: function (text, data, XmlHttpRequest) {
										frm.enable();
										frm.hideProgress();
										alert(text);
									},
									success: function (text, data, XmlHttpRequest) {
										frm.enable();
										frm.hideProgress();
										var js = JSON.parse(text);
										if (js.hasOwnProperty("error")) {
											webix.message(js.error, "error");
										}
										win.show();
										$$("messagePopup").hide();

									}
								});
						}
					}
				}
			]
		}
	});
	webix.ui({
		view: "popup",
		css: "profilePopup",
		id: "messageData",
		on: {
			onShow: function () {
			}
		},
		body: {
			rows: [
				{
					id: "noticeData",
					view: "list",
					css: "noticeList",
					select: true,
					borderless: true,
					data: [
						{
							tag: "header",
							title: "Kênh hướng dẫn sử dụng",
							label: ``,
							icon: ``
						},
						{
							title: "Video hướng dẫn sử dụng",
							label: 'https://www.youtube.com/c/HoaDonDienTuMinvoice',
							icon: "<i class='mdi mdi-18px mdi-youtube' style='color:#FF0000'></i>"
						},
						{
							title: "Website hướng dẫn sử dụng",
							label: 'https://huongdansudung.minvoice.com.vn/',
							icon: `<i class='mdi mdi-18px mdi-web' style='color:#FF0000'></i>`
						},
						{
							tag: "header",
							title: "Kênh công cụ",
							label: ``,
							icon: ``
						},
						{
							title: "Tải plugin ký hóa đơn điện tử",
							label: 'https://plugin.minvoice.com.vn/MinvoicePlugin/setup.exe',
							icon: `<i class='mdi mdi-18px mdi-hammer-screwdriver' style='color:#4267B2'></i>`
						},
						{
							title: "Cộng đồng Hóa đơn điện tử M-Invoice",
							label: `https://www.facebook.com/hoadondientu.m.invoice`,
							icon: `<i class='mdi mdi-18px mdi-facebook' style='color:#4267B2'></i>`
						}
					],
					template: function (obj) {
						if (obj.tag == "header")
							return "<b>" + obj.title + "</b>";
						else
							return "<div class='noticedata'><span>" + obj.icon + "</span> " + "<span>" + obj.title + "</span></div>";
					},
					type: {
						height: "auto"
					},
					on: {
						onItemClick: function (id, e, trg) {
							var item = this.getItem(id);
							window.open(item.label, '_blank').focus();
							$$("messageData").hide();
						}
					}
				}
			]
		}
	});
	var mainToolbar = {
		// css: "toolbarDash",
		rows: [
			{
				height: 45,
				cols: [
					{
						view: "button",
						type: "icon",
						css: "notice",
						id: "messData", icon: "mdi mdi-24px mdi-message-processing-outline", css: "btnNotice", badge: "Mới",
						width: 40, popup: "messageData"
					},
					{
						view: "button",
						type: "icon",
						css: "notice",
						id: "mess", icon: "mdi mdi-24px mdi-bell-ring-outline", css: "btnNotice", badge: 0,
						width: 40, popup: "messagePopup"
					},
					{
						view: "button",
						type: "icon",
						css: "notice",
						id: "messUser", icon: "mdi mdi-36px mdi-account-outline", css: "btnNotice",
						width: 40,
						popup: "profilePopup",
						// on: {
						// 	onClick: function () {
						// 		var element = document.getElementById("profilePopo");
						// 		element.classList.toggle("show");
						// 	},
						// },
						// click: function () {
						// 	this.callEvent("onClick");
						// }
					},
					{ width: 6, css: { "background": "#F2F7FC" } }
				]
			},
			{
				view: "template", template: "<span class='showpop'>" + user.getCurrentUser() + "</span>", borderless: true, css: { "background": "#F2F7FC", "color": "#0069b4", "text-align": "right" },
				onClick: {
					"showpop": function (ev, id) {
						// webix.$$("profilePopup").show();
					}
				}
			}
		]
	};
	var body = {
		id: "bodyInvoice",
		rows: [
			{
				height: 22,
				id: "title",
				css: "title",
				borderless: true,
				template: function (data) {
					if (Object.keys(data).length === 0 && data.constructor === Object)
						return `<hr class='gachngang' color='#dadee0' size='0px'/>`;
					else {
						var response;
						switch (data.code) {
							case "infocompany":
								response = `<div class='gachngangotp'><hr class='gachngang' color='#dadee0' size='0px'//></div><div class='header'>${data.title}</div><div class ='trogiup' style='float:right; font-size: 11px; line-height: normal;'><a href='https://huongdansudung.minvoice.com.vn/' target='_blank' style = 'text-decoration: none;color:#0069b4;'>Trợ giúp <i class='fas fa-question-circle'></i></a></div>`;
								break;
							case "license":
								response = `<div class='gachngangotp'><hr class='gachngang' color='#dadee0' size='0px'//></div><div class='header'>${data.title}</div><div class ='trogiup' style='float:right; font-size: 11px; line-height: normal;'><a href='https://huongdansudung.minvoice.com.vn/' target='_blank' style = 'text-decoration: none;color:#0069b4;'>Trợ giúp <i class='fas fa-question-circle'></i></a></div>`;
								break;
							case "tinhhinhsudung":
								response = `<div class='gachngangotp'><hr class='gachngang' color='#dadee0' size='0px'//></div><div class='header'>${data.title}</div><div class ='trogiup' style='float:right; font-size: 11px; line-height: normal;'><a href='https://huongdansudung.minvoice.com.vn/' target='_blank' style = 'text-decoration: none;color:#0069b4;'>Trợ giúp <i class='fas fa-question-circle'></i></a></div>`;
								break;
							case "dashboard":
								response = `<hr color='#dadee0' size='0px'/ />`;
								break;
							default:
								response = `<div class='header'>${data.title}</div><div class ='trogiup' style='float:right; font-size: 11px; line-height: normal;'><a href='https://huongdansudung.minvoice.com.vn/' target='_blank' style = 'text-decoration: none;color:#0069b4;'>Trợ giúp <i class='fas fa-question-circle'></i></a></div>`;
								break;
						};
						return response;
					}
				}
			},
			{
				view: "scrollview",
				scroll: "x",
				borderless: true,
				body: {
					paddingX: 8,
					css: "bodycolor",
					rows: [
						{
							$subview: true
						},
						{ height: 8 }
					]
				}

			}
		]
	};
	var layout = {
		id: "invoiceBody",
		responsive: true,
		rows: [
			{
				borderless: false,
				css: "topheader",
				responsive: true,
				cols: [
					{
						view: "label",
						css: { "background-color": "#F2F7FC", "padding-left": "16px", "padding-top": "5px", "max-width": "100%", "height": "auto" },
						borderless: true,
						label: "<a href='http://minvoice.vn' target='_blank'><img class='logo_app' src='assets/imgs/LogoAppMinvoice.png' height=90%/></a>",
						width: 185
					},
					{ width: 10, css: { "background": "#F2F7FC" } },
					{
						view: "template",
						height: 65,
						width: 250,
						borderless: true,
						css: { "background-color": "#F2F7FC !important" },
						url: {
							$proxy: true,
							load: function (view, callback, params) {
								var url = apiHost + "/System/ExecuteCommand";
								var parameters = {};
								parameters.command = "CM00010";
								parameters.parameter = {
									ma_dvcs: "VP"
								};
								webix.ajax().bind(view)
									.headers({ 'Content-type': 'application/json' })
									.post(url, parameters, callback);
							}
						},
						template: function (obj) {
							return `<div class='divDmdvcs'><div class='headDmdvcs'>${obj.ten_dvcs}<span class="tooltiptext">${obj.ten_dvcs}</span></div><div class='taxHeader'>Mã số thuế: <span style='color:#0069b4;'>${obj.ms_thue}<span></div></div>`;
						}
					},
					menuBar,
					{ width: 15, css: { "background": "#F2F7FC" } },
					mainToolbar,
					{ width: 15, css: { "background": "#F2F7FC" } }
				]
			},
			body
		]
	};
	return {
		$ui: layout,
		$menu: "app:menu",
		$oninit: function (view, scope) {
			scope.ui(search.$ui);
			scope.ui(profile.$ui);
			scope.ui(notification.$ui);
			webix.storage.local.put("APP_DEFAULT", app.config.start);
			var default_url = webix.storage.local.get("APP_DEFAULT");
			app.show("/app");
			app.router(default_url);
			var company = version.getInfocompany();
			document.title = company.ms_thue + " - " + company.ten_dvcs;

			var url = apiHost + "/System/GetNoticeCount";
			webix.ajax()
				.headers({ 'Content-type': 'application/json' })
				.get(url, function (text) {
					var notice = JSON.parse(text);
					$$("mess").define("badge", notice.length);
					$$("mess").refresh();
				});

			webix.ajax()
				.headers({ 'Content-type': 'application/json' })
				.get(apiHost + "/Pattern/CheckCreatKyHieu", function (text) {
					var res = JSON.parse(text);
					if (res.hasOwnProperty("error")) {
						webix.message(res.error, "error");
					} else {
						if (res.ok == true) {
							$$("dangkyBanner").show();
						} else {
							webix.ajax()
								.headers({ 'Content-type': 'application/json' })
								.get(apiHost + "/System/GetBanner", function (text) {
									var notice = JSON.parse(text);
									if (notice != null) {
										$$("noticeForm").setValues(notice);
										var htmls = `
											<div style="display: flex; flex-direction: column; align-items: center;">
												<a href="${notice.url}" target="_blank">
													<img 
														src="${notice.url_image}" 
														alt="NAM PV" 
														style="max-width: 100%; height: auto; object-fit: contain; margin-bottom: 10px;" 
													/>
												</a>
												<b style="margin-bottom: 10px; font-size: 16px; text-align: center;">${notice.title}</b>
												<div style="text-align: justify; font-size: 14px;">${notice.description}</div>
												<a 
													href="${notice.url}" 
													target="_blank" 
													style="margin-top: 15px; color: blue; text-decoration: none; align-self: flex-end;"
												>Xem chi tiết</a>
											</div>
										`;
										$$("bodyBanner").define("template", htmls);
										$$("noticeBanner").show();
									}
								});
						}
					}
				});
		}
	};
});
define('views/forms/bangkebanra',[
    "app",
    "locale",
    "models/user"
], function (app, _, user) {
    var editmode = 0;

    var date = new Date();
    var _month = date.getMonth() + 1;
    var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
    var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);

    function subviewT() {
        $$('cbQuy').define('label', "Tháng");
        $$('cbQuy').refresh();
        $$('cbQuy').define('options', ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"]);
        //webix.extend(config, $$('cbQuy').config);
        //webix.ui(config, $$('cbThang'));
        //$$('cbThang').destructor();
    }

    function subviewQ() {

        $$('cbQuy').define('label', "Quý");
        $$('cbQuy').refresh();
        $$('cbQuy').define('options', ["1", "2", "3", "4"]);
        // webix.extend($$('cbQuy').config, config, true);
        //webix.ui(config, $$('cbQuy'));
        //$$('cbQuy').destructor();
    }

    return {
        $ui: {
            view: "window",
            modal: true,
            position: "center",
            head: "Bảng kê bán ra",
            width: 400,
            resize: true,
            body: {
                paddingY: 10,
                paddingX: 10,
                elementsConfig: { labelWidth: 60 },
                view: "form",
                id: "bangkebr",
                complexData: true,
                margin: 0,
                elements: [
                    {
                        cols: [
                            {
                                view: "radio",
                                id: "head_extension",
                                value: 1,
                                options: [
                                    { "id": 1, "value": "Tháng" }, // the initially selected item
                                    { "id": 2, "value": "Quý" }
                                ],
                                on: {
                                    onChange: function (newv, oldv) {
                                        var d = new Date();
                                        var quarter = Math.floor((d.getMonth() / 3));
                                        var quarter1 = quarter + 1;
                                        if (newv == 2) {
                                            subviewQ();
                                            $$("cbQuy").setValue(quarter1);
                                        }
                                        if (newv == 1) {
                                            subviewT();
                                            $$("cbQuy").setValue(d.getMonth() + 1);
                                        }
                                    }
                                }
                            },
                            {
                                id: "cbQuy",
                                name: "quy",
                                view: "combo",
                                label: "Tháng",
                                value: _month,
                                options: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"],
                                on: {
                                    onChange: function () {
                                        var d = new Date();
                                        var quarter = Math.floor((d.getMonth() / 3));
                                        var quarter1 = quarter + 1;

                                        var option = $$('head_extension').getValue();
                                        if (option == 2) {
                                            var nam = d.getFullYear();
                                            var thang;
                                            var quy = $$("cbQuy").getValue();
                                            if (quy == 1) {
                                                thang = 0;
                                            }
                                            if (quy == 2) {
                                                thang = 3;
                                            }
                                            if (quy == 3) {
                                                thang = 6
                                            }
                                            if (quy == 4) {
                                                thang = 9
                                            }
                                            var firstDate = new Date(nam, thang, 1);
                                            var lastDate = new Date(nam, thang + 3, 0);

                                            $$("tu_ngay").setValue(firstDate);
                                            $$("tu_ngay").refresh();
                                            $$("den_ngay").setValue(lastDate);
                                            $$("den_ngay").refresh();
                                        }
                                        if (option == 1) {
                                            var year = d.getFullYear();
                                            var month = $$("cbQuy").getValue();
                                            var date1 = month + "/01" + "/" + year;

                                            var date = new Date(date1);
                                            var firstDay1 = new Date(date.getFullYear(), date.getMonth(), 1);

                                            var lastDay1 = new Date(date.getFullYear(), date.getMonth() + 1, 0);
                                            $$("tu_ngay").setValue(firstDay1);
                                            $$("tu_ngay").refresh();
                                            $$("den_ngay").setValue(lastDay1);
                                            $$("den_ngay").refresh();
                                        }
                                    }
                                }
                            }
                        ]
                    },
                    {
                        view: "datepicker", label: _("TU_NGAY"), name: "tu_ngay", id: "tu_ngay", value: firstDay, labelWidth: 80
                    },
                    {
                        view: "datepicker", label: _("DEN_NGAY"), name: "den_ngay", id: "den_ngay", value: lastDay, labelWidth: 80
                    },
                    {
                        view: "multicombo",
                        label: _("KY_HIEU"),
                        name: "inv_InvoiceCode_id",
                        labelWidth: 80,
                        // required: true,
                        // invalidMessage: "Tên truy cập không để trống hoặc nhập không đúng (a-z,A-Z,0-9)",
                        // validate: webix.rules.isNotEmpty,
                        suggest: {
                            selectAll: true,
                            body: {
                                url: app.config.host + "/Bcthsd/getInvoiceCode",
                                //template: webix.template("#value#")
                            }
                        }
                        //value: "2"
                    },
                    {
                        margin: 10,
                        cols: [
                            {},
                            {
                                shortcut: "F10", view: "button", label: "Nhận (F10)", width: 100, type: "form", align: "center",
                                on: {
                                    onClick: function () {
                                        var form = this.getParentView().getParentView();
                                        var win = this.getTopParentView();

                                        var item = form.getValues();
                                        var load_event = "loadBangkebanra";

                                        app.callEvent(load_event, [item]);

                                        win.close();
                                    }
                                },
                                click: function () {
                                    this.callEvent("onClick");

                                }
                            },
                            {
                                view: "button", hotkey: "esc", label: "Hủy bỏ (ESC)", width: 100, align: "center", type: "danger",
                                click: function () {
                                    this.getTopParentView().close();
                                }
                            },
                            {}
                        ]
                    }
                ]
            }

        },

        setValues: function (item) {
            var win = $$(this.$ui.id);
            var form = win.getChildViews()[1];

            form.setValues(item);
        }
    };

});

define('views/bangkebanra',[
    "app",
    "locale",
    "models/user",
    "views/forms/bangkebanra"
], function (app, _, user, bangkebanra) {
    'use strict';

    var fm = webix.Number.numToStr({
        groupDelimiter: ",",
        groupSize: 3,
        decimalDelimiter: ".",
        decimalSize: 0
    });
    var op = [];

    webix.$$("title").parse({ title: "Báo cáo > Bảng kê bán ra ( Mẫu PL01-1)", details: "Báo cáo bảng kê bán ra hóa đơn" });

    var controls = [
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-refresh fa-lg" aria-hidden="true"></i> ' +
            '<span class="text">' + _("REFRESH") + '</span>',
            id: "btnReload",
            on: {
                onClick: function () {
                    var wininfoparam = this.$scope.ui(bangkebanra.$ui);
                    wininfoparam.show();
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-print fa-lg" aria-hidden="true"></i> ' +
            '<span class="text">' + _("PRINT") + " PDF" + '</span>',
            id: "btnPrint",
            on: {
                onClick: function () {
                    var table = $$("bangkebanra");

                    var rpParameter = table.config.rpParameter;

                    if (rpParameter == undefined || rpParameter == null) {
                        webix.message("Bạn chưa chọn báo cáo hoặc chưa tải dữ liệu !", "error");
                        return;
                    }
                    rpParameter.type = "PDF";
                    //console.log(rpParameter);
                    if (rpParameter != null) {
                        var box = webix.modalbox({
                            title: "Đang in báo cáo ....",
                            text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                            width: 350,
                            height: 200
                        });

                        webix.ajax()
                            .response("arraybuffer")
                            .headers({ 'Content-type': 'application/json' })
                            .post(app.config.host + "/Bcthsd/PrintPDFBangKeBanRa", rpParameter,
                            {
                                error: function (text, data, XmlHttpRequest) {
                                    webix.modalbox.hide(box);
                                    webix.message(XmlHttpRequest.statusText, "error");
                                },
                                success: function (text, data, XmlHttpRequest) {
                                    var file = new Blob([data], { type: 'application/pdf' });
                                    var fileURL = URL.createObjectURL(file);
                                    webix.modalbox.hide(box);
                                    window.open(fileURL, '_blank');
                                }
                            }
                            // function (text, data) {
                            //     var file = new Blob([data], { type: 'application/pdf' });
                            //     var fileURL = URL.createObjectURL(file);
                            //     webix.modalbox.hide(box);
                            //     window.open(fileURL, '_blank');
                            // }
                            );
                    }
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {
            view: "button", type: "htmlbutton", width: 120,
            label: '<i class="fa fa-file-excel fa-lg" aria-hidden="true"></i> ' +
            '<span class="text">' + _("EXPORT_EXCEL") + '</span>',
            id: "btnExport",
            on: {
                onClick: function () {
                    var table = $$("bangkebanra");

                    var rpParameter = table.config.rpParameter;
                    if (rpParameter == undefined || rpParameter == null) {
                        webix.message("Bạn chưa chọn báo cáo hoặc chưa tải dữ liệu !", "error");
                        return;
                    }
                    rpParameter.type = "xlsx";

                    if (rpParameter != null) {
                        var box = webix.modalbox({
                            title: "Đang kết xuất Excel ....",
                            text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                            width: 350,
                            height: 200
                        });

                        webix.ajax()
                            .response("arraybuffer")
                            .headers({ 'Content-type': 'application/json' })
                            .post(app.config.host + "/Bcthsd/PrintPDFBangKeBanRa", rpParameter,
                            {
                                error: function (text, data, XmlHttpRequest) {
                                    webix.modalbox.hide(box);
                                },
                                success: function (text, data, XmlHttpRequest) {
                                    var file = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                                    var fileURL = URL.createObjectURL(file);
                                    webix.modalbox.hide(box);
                                    window.location.href = fileURL;
                                }
                            }
                            // function (text, data) {

                            //     var file = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                            //     var fileURL = URL.createObjectURL(file);

                            //     window.location.href = fileURL;
                            // }
                            );
                    }
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {
            view: "button", type: "htmlbutton", width: 120,
            label: '<i class="fa fa-file-text-o fa-lg" aria-hidden="true"></i> ' +
            '<span class="text">' + _("EXPORT_CSV") + '</span>',
            id: "btnExportCsv",
            on: {
                onClick: function () {
                    var table = $$("bangkebanra");

                    var rpParameter = table.config.rpParameter;
                    if (rpParameter == undefined || rpParameter == null) {
                        webix.message("Bạn chưa chọn báo cáo hoặc chưa tải dữ liệu !", "error");
                        return;
                    }
                    rpParameter.type = "CSV";

                    if (rpParameter != null) {
                        var box = webix.modalbox({
                            title: "Đang kết xuất Excel ....",
                            text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                            width: 350,
                            height: 200
                        });

                        webix.ajax()
                            .response("arraybuffer")
                            .headers({ 'Content-type': 'application/json' })
                            .post(app.config.host + "/Bcthsd/PrintPDFBangKeBanRa", rpParameter,
                            {
                                error: function (text, data, XmlHttpRequest) {
                                    webix.modalbox.hide(box);
                                    webix.message(XmlHttpRequest.statusText, "error");
                                },
                                success: function (text, data, XmlHttpRequest) {
                                    var file = new Blob([data], { type: 'application/csv' });
                                    //var fileURL = URL.createObjectURL(file);
                                    webix.html.download(file, "MinvoiceBangkebanra.csv");
                                    webix.modalbox.hide(box);
                                    //window.location.href = fileURL;
                                }
                            }
                            // function (text, data) {

                            //     var file = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                            //     var fileURL = URL.createObjectURL(file);

                            //     window.location.href = fileURL;
                            // }
                            );
                    }
                }
            },
            click: function () {
                this.callEvent("onClick");
            }

        },
        {
            view: "button", type: "htmlbutton", width: 120,
            label: '<i class="fa fa-file-text-o fa-lg" aria-hidden="true"></i> ' +
            '<span class="text">' + _("EXPORT_XML") + '</span>',
            id: "btnExportXml",
            on: {
                onClick: function () {
                    var comp = {
                        view: "window",
                        modal: true,
                        position: "center",
                        head: "Kết xuất XML 03/DL-HĐĐT",
                        width: 350,
                        resize: true,
                        body: {
                            paddingY: 10,
                            paddingX: 10,
                            elementsConfig: { labelWidth: 60 },
                            view: "form",
                            complexData: true,
                            margin: 0,
                            elements: [
                                {
                                    cols:[
                                        {
                                            name:"kieu",
                                            view: "radio",
                                            id: "head_extension",
                                            value: "T",
                                            options: [
                                                { "id": "T", "value": "Tháng" }, // the initially selected item
                                                { "id": "Q", "value": "Quý" }
                                            ],
                                            on: {
                                                onChange: function (newv, oldv) {
                                                    var win = this.getTopParentView();
                                                    var cbQuy = win.queryView({view:"combo"});

                                                    if (newv == "Q") {
                                                        cbQuy.define("label", "Quý");
                                                        cbQuy.define("options", ["1", "2", "3", "4"]);

                                                        cbQuy.setValue("1");
                                                    }

                                                    if (newv == "T") {
                                                        cbQuy.define("label", "Tháng");
                                                        cbQuy.define("options", ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"]);

                                                        cbQuy.setValue("1");
                                                    }

                                                    cbQuy.refresh();
                                                }
                                            }
                                        },
                                        {
                                            id: "cbQuy",                                            
                                            view: "combo",
                                            label: "Tháng",
                                            value: "1",
                                            name:"thang",
                                            options: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"]                                            
                                        }
                                    ]
                                },
                                {
                                    view:"text",
                                    name: "nam",
                                    label: "Năm",
                                    value: (new Date()).getFullYear()
                                },
                                {
                                    view: "datepicker", 
                                    label: _("NGAY_LAP"), 
                                    name: "nLap", 
                                    value: new Date()                                    
                                },
                                {
                                    margin: 10,
                                    cols: [
                                        {},
                                        {
                                            shortcut: "F10", view: "button", label: "Nhận (F10)", width: 100, type: "form", align: "center",
                                            on: {
                                                onClick: function () {
                                                    var form = this.getParentView().getParentView();
                                                    var win = this.getTopParentView();
            
                                                    var item = form.getValues();
                                                                
                                                    webix.ajax()
                                                        .bind(win)
                                                        .headers({"Content-Type":"application/json"})
                                                        .post(app.config.host + "/Invoice/ExportXmlDL30", item, function(text){
                                                            var result = JSON.parse(text);

                                                            if (result.code == "00") {
                                                                var link = document.createElement('a');

                                                                link.download = result.data.fileName;
                                                                var blob = new Blob([result.data.xml], {type: 'text/xml'});
                                                                link.href = window.URL.createObjectURL(blob);
                                                                link.click();

                                                                link.remove();


                                                                this.close();
                                                            }
                                                            else {
                                                                webix.message({type:"error",text:result.message});
                                                            }
                                                        });
                                                }
                                            },
                                            click: function () {
                                                this.callEvent("onClick");
            
                                            }
                                        },
                                        {
                                            view: "button", hotkey: "esc", label: "Hủy bỏ (ESC)", width: 100, align: "center", type: "danger",
                                            click: function () {
                                                this.getTopParentView().close();
                                            }
                                        },
                                        {}
                                    ]
                                }
                            ]
                        }
                    };

                    var win = this.$scope.ui(comp);
                    win.show();
                }
            },
            click: function () {
                this.callEvent("onClick");
            }

        },
        {}
    ];

    var grid = {
        rows: [
            {
                container: "testA",
                view: "treetable",
                id: "bangkebanra",
                select: true,
                resizeColumn: true,
                fullScreen: true,
                leftSplit: 5,
                columns: [
                    {
                        id: "stt", header: "<center>STT</center>", sort: "int", width: 40
                    },
                    {
                        id: "mau_hd", header: [{ "text": "<center>Hóa đơn chứng từ bán ra</center>", "colspan": 4 }, { "text": "<center>Mẫu hóa đơn</center>" }],
                        width: 425,
                        template: function (obj, common) {
                            if (obj.$level == 1) return common.treetable(obj, common) + "<span style='color:blue;'>" + obj.value + " ( " + (obj.$count - 1) + " )" + "</span>";
                            return obj.mau_hd;
                        }
                    },
                    { id: "HD_kyHieu", header: [null, { "text": "<center>Ký hiệu</center>" }] },
                    {
                        id: "HD_so", header: [null, { "text": "<center>Số hóa đơn</center>" }]
                    },
                    {
                        id: "HD_Ngay", header: [null, { "text": "<center>Ngày hóa đơn</center>" }], width: 120, format: function (text) {
                            var format = webix.Date.dateToStr("%d/%m/%Y");
                            text = removeTimeZoneT(text);
                            return format(text);
                        }
                    },
                    { id: "ten_kh", header: "<center>Tên người mua</center>", width: 300 },
                    // {
                    //     header: "<center>Trạng thái</center>", width: 150, template: function (obj) {
                    //         if (obj.$group == true) return "";
                    //         return "<span class='hotro_status" + obj.trang_thai + "'>" + obj.trang_thai + "</span>"
                    //     }
                    // },
                    { id: "mst_kh", header: "<center>Mã số thuế</center>", width: 120 },
                    { id: "mat_hang", header: "<center>Mặt hàng</center>", width: 200 },
                    {
                        id: "tien_tt", header: [{ text: "<center>Doanh thu chưa có thuế GTGT</center>", css: "multiline" }], width: 100, format: webix.Number.numToStr({
                            groupDelimiter: ",",
                            groupSize: 3,
                            decimalDelimiter: ".",
                            decimalSize: 0
                        }),
                        css: { "text-align": "right !important" }
                    },
                    {
                        id: "tien_ck", header: "<center>Tiền CK</center>", width: 100, format: webix.Number.numToStr({
                            groupDelimiter: ",",
                            groupSize: 3,
                            decimalDelimiter: ".",
                            decimalSize: 0
                        }),
                        css: { "text-align": "right !important" }
                    },
                    {
                        id: "tien_thue", header: "<center>Thuế GTGT</center>", width: 100, format: webix.Number.numToStr({
                            groupDelimiter: ",",
                            groupSize: 3,
                            decimalDelimiter: ".",
                            decimalSize: 0
                        }),
                        css: { "text-align": "right !important" }
                    },
                    {
                        id: "tong_tien", header: "<center>Tổng tiền</center>", width: 100, format: webix.Number.numToStr({
                            groupDelimiter: ",",
                            groupSize: 3,
                            decimalDelimiter: ".",
                            decimalSize: 0
                        }),
                        css: { "text-align": "right !important" }
                    },
                    { id: "ghi_chu", header: "<center>Ghi chú</center>", width: 150 }
                ],
                pager: "pagerA",
                scheme: {
                    $init: function (obj) {
                        if (obj.$group) {
                            obj.$css = 'bangkebanra';
                        }
                        //console.log(obj);
                        // if (obj.year >= 2000) obj.$css = "koko";
                        // if (obj.year <= 1970) obj.$css = "oldtime";
                    },
                    $serialize: function (obj) {
                        //console.log(obj);
                        // if (obj.$group) {
                        //     obj.$css = 'koko';
                        // }
                    },
                    $group: {
                        by: "nhom",
                        // map hoặc footer
                        footer: {
                            mau_hd: ["<span style='color: red;'>" + _("TOTAL") + "</span>", "string"],
                            tien_thue: ["tien_thue", "sum"],
                            tien_tt: ["tien_tt", "sum"],
                            tien_ck: ["tien_ck", "sum"],
                            tong_tien: ["tong_tien", "sum"]
                            // tong_tien: [function (obj) {
                            //     console.log(obj);
                            //     // var min = obj.year - obj.year%10; 
                            //     return obj.tong_tien;
                            // }]
                            // row: function (obj) {
                            // console.log(obj);
                            // return "<span style='float:right;'>Total: "
                            //     + webix.i18n.numberFormat(obj.tong_tien) + "</span>"
                            // }
                        }
                        , css: "bangkebanra"
                        // map:{
                        // 	nguoi_lien_he:["nguoi_lien_he", "count"]
                        // }
                    },
                    // $css: { "color": "red !important" }
                    //$sort: { by: "stt", dir: "asc" }
                },
                ready: function () {
                    //this.open(this.getFirstId());
                    //this.sort({ by: "stt", dir: "asc" });
                    this.openAll();
                }
                //url: app.config.host + "/System/ExecuteQuery?sql=" + sql
                //autoheight: true,
                //autowidth:true,
                //data: big_film_set
            },
            {
                id: "pagerA",
                view: "pager",
                size: 100,
                group: 5,
                template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}"
            },
            {
                id: "tong_doanhthu", view: "label", margin: 0, css: { "padding-left": "20px !important" },
                label: "Tổng doanh thu hàng hóa, dịch vụ bán ra chịu thuế GTGT (*): .......... "
            },
            {
                id: "tong_tienthue", view: "label", margin: 0, css: { "padding-left": "20px !important" },
                label: "Tổng số thuế GTGT của hàng hóa dịch vụ bán ra (**): .......... "
            }
        ]
    }

    var layout = {
        css: "frmView",
        rows: [
            {
                height: 39,
                type: "toolbar",
                css: "btnControl",
                borderless: true,
                cols: controls
            },
            {
                rows: [
                    grid
                ]
            }
        ]

    };

    return {
        $ui: layout,
        $oninit: function (view, $scope) {
            if ($$("hr") == undefined && $$("hr2") == undefined) {
                $$("bodyInvoice").removeView("hr");
                $$("bodyInvoice").removeView("hr2");
            }
            var load = $$("btnReload");
            load.callEvent("onClick");
            $scope.on(app, "loadBangkebanra", function (item) {

                var table = $$("bangkebanra");
                // webix.extend(table, webix.OverlayBox);
                webix.extend(table, webix.ProgressBar);
                table.disable();
                table.showProgress();

                table.config.rpParameter = item;

                webix.ajax()
                    .headers({ 'Content-type': 'application/json' })
                    .post(app.config.host + "/Bcthsd/bangkebanra", item, {
                        error: function (text, data, XmlHttpRequest) {
                            table.enable();
                            table.hideProgress();
                            alert(text);
                        },
                        success: function (text, data, XmlHttpRequest) {
                            var json = JSON.parse(text);
                            if (!json.hasOwnProperty("error")) {
                                //console.log(json);
                                $$("bangkebanra").clearAll();
                                $$("bangkebanra").parse(json);

                                $$("tong_doanhthu").setValue("<b>Tổng doanh thu hàng hóa, dịch vụ bán ra chịu thuế GTGT (*): " + fm(json.tong_doanhthu) + "</b>");
                                $$("tong_tienthue").setValue("<b>Tổng số thuế GTGT của hàng hóa dịch vụ bán ra (**): " + fm(json.tong_tienthue)) + "</b>";
                            }
                            else {
                                webix.message(json.error, "error");
                            }
                            table.enable();
                            table.hideProgress();
                        }
                    });
            });
        }
    };
});
define('views/forms/infowindow',[
	"app",
	"locale",
	"models/user"
], function (app, _, user) {
	var editmode = 0;

	var _date = new Date();
	var _month = _date.getMonth() + 1;
	function subviewT() {
		$$('cbQuy').define('label', "Tháng");
		$$('cbQuy').refresh();
		$$('cbQuy').define('options', ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"]);
		//webix.extend(config, $$('cbQuy').config);
		//webix.ui(config, $$('cbThang'));
		//$$('cbThang').destructor();
	}

	function subviewQ() {

		$$('cbQuy').define('label', "Quý");
		$$('cbQuy').refresh();
		$$('cbQuy').define('options', ["1", "2", "3", "4"]);
		// webix.extend($$('cbQuy').config, config, true);
		//webix.ui(config, $$('cbQuy'));
		//$$('cbQuy').destructor();
	}

	return {
		$ui: {
			view: "window",
			modal: true,
			position: "center",
			head: "Thông tin Tab",
			resize: true,
			body: {
				paddingY: 10,
				paddingX: 10,
				elementsConfig: { labelWidth: 60 },
				view: "form",
				complexData: true,
				margin: 0,
				elements: []
			}

		},
		initUI: function (infoWindowId) {

			var url = app.config.host + "/System/ExecuteCommand";

			var parameters = {
				command: "CM00013",
				parameter: {
					wb_infowindow_id: infoWindowId
				}
			};

			webix.ajax().headers({ "Content-Type": "application/json" })
				.post(url, parameters, function (response) {
					var result = JSON.parse(response);

					var win = webix.$$(infoWindowId);

					win.define("width", result[0].window_width);
					win.define("height", result[0].window_height);

					var form = win.getChildViews()[1];
					form.clear();

					var view_extension = {
						cols: [
							{
								view: "radio",
								id: "head_extension",
								value: 1,
								options: [
									{ "id": 1, "value": "Tháng" }, // the initially selected item
									{ "id": 2, "value": "Quý" }
								],
								on: {
									onChange: function (newv, oldv) {
										var d = new Date();
										var quarter = Math.floor((d.getMonth() / 3));
										var quarter1 = quarter + 1;
										if (newv == 2) {
											subviewQ();
											$$("cbQuy").setValue(quarter1);
										}
										if (newv == 1) {
											subviewT();
											$$("cbQuy").setValue(d.getMonth() + 1);
										}
									}
								}
							},
							{
								id: "cbQuy",
								name: "quy",
								view: "combo",
								label: "Tháng",
								//height: 30,
								value: _month,
								options: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"],
								on: {
									onChange: function () {
										var d = new Date();
										var quarter = Math.floor((d.getMonth() / 3));
										var quarter1 = quarter + 1;

										var option = $$('head_extension').getValue();
										if (option == 2) {
											var nam = d.getFullYear();
											var thang;
											var quy = $$("cbQuy").getValue();
											if (quy == 1) {
												thang = 0;
											}
											if (quy == 2) {
												thang = 3;
											}
											if (quy == 3) {
												thang = 6
											}
											if (quy == 4) {
												thang = 9
											}
											var firstDate = new Date(nam, thang, 1);
											var lastDate = new Date(nam, thang + 3, 0);

											$$(win.config.id + "_tu_ngay").setValue(firstDate);
											$$(win.config.id + "_tu_ngay").refresh();
											$$(win.config.id + "_den_ngay").setValue(lastDate);
											$$(win.config.id + "_den_ngay").refresh();
										}
										if (option == 1) {
											var year = d.getFullYear();
											var month = $$("cbQuy").getValue();
											var date1 = month + "/01" + "/" + year;

											var date = new Date(date1);
											var firstDay1 = new Date(date.getFullYear(), date.getMonth(), 1);

											var lastDay1 = new Date(date.getFullYear(), date.getMonth() + 1, 0);
											$$(win.config.id + "_tu_ngay").setValue(firstDay1);
											$$(win.config.id + "_tu_ngay").refresh();
											$$(win.config.id + "_den_ngay").setValue(lastDay1);
											$$(win.config.id + "_den_ngay").refresh();
										}
									}
								}
							}
						]
					};

					var formValues = {};

					var rows_max = result[0].rows_max;

					var el = [];

					for (var i = 1; i <= rows_max; i++) {
						el.push({ cols: [] });
					}

					for (var i = 0; i < result.length; i++) {

						var field = result[i];

						var row = field.row;

						var item = {
							view: field.type_editor,
							name: field.name,
							editable: true,
							label: _(field.caption),
							width: field.width,
							labelPosition: field.label_position,
							labelWidth: field.label_width,
							format: field.format,
							hidden: field.hidden == "C" ? true : false,
							id: win.config.id + "_" + field.name
						};

						if (field.defaultvalue != null) {
							var defaultValue = field.defaultvalue;

							var date = new Date();
							var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
							var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);

							if (defaultValue.startsWith("@Default=")) {
								defaultValue = defaultValue.replace("@Default=", "");
								if (defaultValue == "MA_DVCS") {
									item.value = user.getDvcsID();
								}
								else if (defaultValue == "USER") {
									item.value = user.getCurrentUser();
								}
								else if (defaultValue == "MA_CT") {
									item.value = "MA_CT";
								}
								else if (defaultValue == "FIRST_DATE") {
									item.value = firstDay;
								}
								else if (defaultValue == "LAST_DATE") {
									item.value = lastDay;
								}
								else {
									item.value = defaultValue;
								}
							}
						}

						if (item.hidden == true) {
							formValues[item.name] = item.value;
							continue;
						}

						if (item.view == "combo" || item.view == "multiselect") {
							item.options = app.config.host + "/System/GetDataByReferencesId?id=" + field.ref_id;
						}

						if (item.view == "radio") {
							var ajax = webix.ajax();
							ajax.master = {
								radio_id: item.id,
								win_id: win.config.id
							};

							ajax.get(app.config.host + "/System/GetDataByReferencesId?id=" + field.ref_id, function (text) {
								var json = JSON.parse(text);
								var radio = $$(this.radio_id);
								radio.define("options", json);
								radio.refresh();

								$$(this.win_id).resize();
							});
						}

						if (item.view == "treesuggest") {

							//item.REF_ID = field.REF_ID.toString();
							var listColumns = JSON.parse(field.list_column);

							for (var v = 0; v < listColumns.length; v++) {
								listColumns[v].header = _(listColumns[v].id);
							}

							item.view = "combo";
							item.options = {
								view: "treesuggest",
								url: {
									$proxy: true,
									load: function (view, callback, params) {
										var url = app.config.host + "/System/GetDataByReferencesId?id=" + view.config.refid;

										webix.ajax(url, function (text) {
											var json = JSON.parse(text);
											var data = listToTree(json);
											view.parse(data, "json");
										});

									}
								},
								body: {
									columns: listColumns,
									refid: field.ref_id,
									filterMode: {
										level: false,
										showSubItems: false
									}
								}
							};
						}

						if (item.view == "gridcombo") {

							var listColumns = JSON.parse(field.list_column);

							for (var v = 0; v < listColumns.length; v++) {
								listColumns[v].header = _(listColumns[v].id);
							}

							item.view = "combo";
							item.options = {
								view: "gridsuggest",
								url: app.config.host + "/api/System/GetDataByReferencesId?id=" + field.ref_id,
								body: {
									columns: listColumns,
									refid: field.ref_id
								}
							};
						}

						if (item.view == "gridsuggest") {
							var listColumns = JSON.parse(field.list_column);

							for (var v = 0; v < listColumns.length; v++) {
								listColumns[v].header = _(listColumns[v].id);
							}

							item.view = "text";
							item.suggest = {
								view: "gridsuggest",
								value_suggest: field.value_suggest,
								body: {
									columns: listColumns,
									refid: field.ref_id,
									datatype: "json",
									dataFeed: function (filtervalue, filter) {
										if (filtervalue.length < 3) return;

										var refid = this.config.refid;
										var pathUrl = app.config.host + "/System/GetDataByReferencesId?id=" + refid;
										var urldata = "filtervalue=" + encodeURIComponent(filtervalue);

										this.load(pathUrl + "&" + urldata, this.config.datatype);
									},

								},
								on: {
									onValueSuggest: function (obj) {
										if (this.config.value_suggest != null) {
											var fn = Function("obj", "id", this.config.value_suggest);
											fn(obj, this.config.id);
										}
									}
								}
							};
						}

						if (item.name == "tu_ngay") {
							item.value = firstDay;
						}

						if (item.name == "den_ngay") {
							item.value = lastDay;
						}

						formValues[item.name] = item.value;
						el[row - 1].cols.push(item);
					}

					form.setValues(formValues);

					var buttons = {
						margin: 10,
						cols: [
							{},
							{
								shortcut: "F10", view: "button", label: "Nhận (F10)",
								//  width: 90,
								type: "form", align: "center",
								on: {
									onClick: function () {
										var form = this.getParentView().getParentView();
										var win = this.getTopParentView();

										var item = form.getValues();
										// xóa header ngày tháng trong sproc ko cần
										delete item.quy;
										var load_event = win.config.load_event == null ? "loadReport" : win.config.load_event;

										app.callEvent(load_event, [win.config.report_id, win.config.id, item, win.config.menuitem]);

										win.close();
									}
								},
								click: function () {
									this.callEvent("onClick");

								}
							},
							{
								view: "button", hotkey: "esc", label: "Hủy bỏ (ESC)",
								// width: 90,
								align: "center", type: "danger",
								click: function () {
									this.getTopParentView().close();
								}
							},
							{}
						]
					};

					el.push(buttons);

					webix.ui(el, form);
					if ($$(win.config.id + "_tu_ngay") != undefined && $$(win.config.id + "_den_ngay") != undefined) {
						form.addView(view_extension, 0);
					}
					win.getHead().setHTML(result[0]["window_name"]);

					//win.config.height= result[0]["WINDOW_HEIGHT"];
					//win.config.width= result[0]["WINDOW_WIDTH"];

					if (win.config.editmode != null) {
						if (win.config.editmode == 1) {
							form.setValues(win.config.formvalues);
						}
					}
					//win.resize();
				});
		},
		setEditMode: function (mode) {
			editmode = mode;
		},
		setValues: function (item) {
			var win = $$(this.$ui.id);
			var form = win.getChildViews()[1];

			form.setValues(item);
		}
	};

});

define('views/forms/editwindow',[
	"app",
	"locale",
	"models/user"
], function (app, _, user) {
	var editmode = 0;
	var tables = [];

	var windowno = app.path[1].params[0];
	var col = [];
	var rw = [];
	var el = [];
	var head_name = [];
	var head;
	var url = app.config.host + "/System/GetAllByWindowNo?window_id=" + windowno;

	function setParentValue(windowId) {

		var win = $$(windowId);
		var form = win.getChildViews()[1];
		var item = form.getValues();
		var valueField = win.config.valueField;

		if (win.config.editorId == null) {

			if (win.config.tableId == null || win.config.tableId == undefined) return;

			var table = $$(win.config.tableId);
			var selectedItem = table.getSelectedItem();

			selectedItem[win.config.columnName] = item[valueField];

			if (win.config.fieldExpression != null) {
				var fields = win.config.fieldExpression.split(';');

				for (var i = 0; i < fields.length; i++) {
					var field = fields[i].replace("{", "").replace("}", "");
					var array = field.split(":");

					selectedItem[array[1]] = item[array[0]];
				}
			}

			table.updateItem(selectedItem.id, selectedItem);

		}
		else {

			if (win.config.editorId == null || win.config.editorId == undefined) return;

			var editor = $$(win.config.editorId);


			editor.setValue(item[valueField]);

			if (win.config.fieldExpression != null) {
				var formParent = $$(win.config.formId);
				var parentItem = formParent.getValues();

				var fields = win.config.fieldExpression.split(';');

				for (var i = 0; i < fields.length; i++) {
					var field = fields[i].replace("{", "").replace("}", "");
					var array = field.split(":");

					parentItem[array[1]] = item[array[0]];
				}

				formParent.setValues(parentItem);
			}
		}


	}

	return {
		$ui: {
			view: "window", modal: true, move: true, id: "editwindow-win", position: "center", css: { "border-radius": "12px 12px 0px 0px" },
			//width:800,
			//head: "Thông tin khách hàng",
			head: {
				//view: "toolbar",
				// css: { "box-shadow": "0 -2px #3498db inset !important", "background": "#ffffff !important" },
				//css: { "background": "#e6f2ff !important" },
				height: 40,
				cols: [
					{
						id: "edit_head-form", view: "template", css: "headform", template: function (obj) {
							return '<div>' + obj.title + '<div/>';
						}
					},
					{
						view: "icon", icon: "fas fa-question-circle", id: "edit_help_form", tooltip: _("HELPER"), click: function () {
							// var form = webix.$$("window-form");
							// hint_form(form.config.hint);
						}
					}
				]
			},
			//fullscreen:true,			
			body: {
				paddingY: 10,
				paddingX: 10,
				view: "form",
				id: "editwindow-form",
				complexData: true,
				margin: 0,
				elements: el
			}
		},
		initUI: function (windowconfig) {

			var rp = windowconfig;
			var rows_max = rp['data'][0]['rows_max'];
			var vc_window = rp["data"][0];
			var tabs = vc_window.Tabs;

			var win = $$(vc_window.window_id);

			if (typeof win.showProgress === "undefined")
				webix.extend(win, webix.ProgressBar);

			el = [];
			col = [];

			if (vc_window.width == null && vc_window.height == null) {
				win.config.fullscreen = true;
			}

			if (vc_window.after_save != null) {
				win.config.after_save = vc_window.after_save;
			}

			for (var i = 1; i <= rows_max; i++) {
				el.push({ cols: [] });
			}

			var fields = rp['data'][0]['Tabs'][0]['Fields'];

			for (var i = 0; i < fields.length; i++) {

				var field = fields[i];

				if (field.hidden == true) {
					continue;
				}

				var row = field.row;

				var item = {
					view: field.type_editor,
					name: field.column_name,
					label: _(field.column_name),
					id: field.column_name + "_" + rp['data'][0]['Tabs'][0]["tab_table"],
					width: field.width,
					labelPosition: field.label_position,
					labelWidth: field.label_width,
					format: field.format,
					css: field.css,
					fieldExpression: field.field_expression,
					value_change: field.value_change,
					on: {

					}
				};

				if (field.caption != null) {
					item.label = _(field.caption);
				}

				if (field.readonly == "C") {
					item.readonly = true;
				}

				if (item.view == "combo") {
					item.options = app.config.host + "/System/GetDataByReferencesId?id=" + field.ref_id
				}

				if (item.view == "checkbox") {
					if (field.label_position == "right") {
						item.labelRight = _(field.column_name);
						item.label = "";
					}

					if (field.column_type == "char" || field.column_type == "nvarchar" || field.column_type == "nchar") {
						item.checkValue = "C";
						item.uncheckValue = "K";
					}

					if (field.COLUMN_TYPE == "int") {
						item.checkValue = "1";
						item.uncheckValue = "0";
					}

					if (field.COLUMN_TYPE == "bit") {
						item.checkValue = true;
						item.uncheckValue = false;
					}
				}

				if (item.view == "autonumeric") {
					item.inputAlign = "right";
				}

				if (item.view == "treesuggest") {

					var listColumns = JSON.parse(field.list_column);

					for (var v = 0; v < listColumns.length; v++) {
						listColumns[v].header = _(listColumns[v].id);
					}

					item.view = "combo";
					item.options = {
						view: "treesuggest",
						url: {
							$proxy: true,
							load: function (view, callback, params) {
								var url = app.config.host + "/System/GetDataByReferencesId?id=" + view.config.refid;

								webix.ajax(url, function (text) {
									var json = JSON.parse(text);
									var data = listToTree(json);
									view.parse(data, "json");
								});

							}
						},
						body: {
							columns: listColumns,
							refid: field.ref_id,
							filterMode: {
								level: false,
								showSubItems: false
							}
						}
					};

					item.on.onKeyPress = function (code, e) {
						if (e.code == "F4") {
							alert("Moi");
						}
					};
				}

				if (item.view == "gridcombo") {

					var listColumns = JSON.parse(field.list_column);

					for (var v = 0; v < listColumns.length; v++) {
						listColumns[v].header = _(listColumns[v].id);
					}

					item.view = "combo";
					item.options = {
						view: "gridsuggest",
						url: app.config.host + "/System/GetDataByReferencesId?id=" + field.ref_id,
						body: {
							columns: listColumns,
							refid: field.ref_id
						}
					};

					item.on.onKeyPress = function (code, e) {
						if (e.code == "F4") {
							alert("Moi");
						}
					};
				}
				if (item.view == "search") {
				
					var express = item.fieldExpression;
					item.on.onSearchIconClick = function (e) {
						var form = $$(this.getFormView());

						//get value của form hiện tại để đổi giá trị
						var parentItem = form.getValues();

						var field_express = this.config.fieldExpression;
						var text = this.getValue();
						var datapost = { "masothue": text };
						webix.ajax()
							.headers({ 'Content-type': 'application/json' })
							.post(app.config.host + "/Pattern/GetInfoMST", datapost, function (text) {

								var json = JSON.parse(text);

								if (!json.hasOwnProperty("error")) {
									if (field_express != null) {

										var fields = field_express.split(';');
										// tách json thành array
										for (var i = 0; i < fields.length; i++) {
											var field = fields[i].replace("{", "").replace("}", "");
											var array = field.split(":");

											parentItem[array[1]] = json[array[0]];

										}
										form.setValues(parentItem);
									}
									else {
										webix.message("FIELD_EXPRESSION IS NULL IN FIELD !", "error", 2000);
									}
								}
								else {
									// nếu không tồn tại mã số thuế phải xóa địa chỉ + tên cty ở đây 
									webix.message(json.error, "error", 2000);
								}

							});

					}
				}


				if (item.view == "gridsuggest") {
					var listColumns = JSON.parse(field.list_column);

					for (var v = 0; v < listColumns.length; v++) {
						listColumns[v].header = _(listColumns[v].id);
					}

					item.view = "text";
					item.suggest = {
						view: "gridsuggest",
						value_suggest: field.value_suggest,
						body: {
							columns: listColumns,
							refid: field.ref_id,
							datatype: "json",
							dataFeed: function (filtervalue, filter) {
								if (filtervalue.length < 3) return;

								var refid = this.config.refid;
								var pathUrl = app.config.host + "/System/GetDataByReferencesId?id=" + refid;
								var urldata = "filtervalue=" + encodeURIComponent(filtervalue);

								this.load(pathUrl + "&" + urldata, this.config.datatype);
							},

						},
						on: {
							onValueSuggest: function (obj) {
								if (this.config.value_suggest != null) {
									var fn = Function("obj", "id", this.config.value_suggest);
									fn(obj, this.config.id);
								}
							}
						}
					};

					item.on.onKeyPress = function (code, e) {

					};
				}

				if (field.valid_rule != null) {
					var rule = field.valid_rule;

					if (rule == "isNotEmpty") {
						item.required = true;
						item.invalidMessage = item.label + " không được bỏ trống";
						item.validate = webix.rules.isNotEmpty;
					}

					if (rule == "isSpecialCharacter") {
						item.required = true;
						item.invalidMessage = item.label + " không được bỏ trống (a-z,A-Z,0-9)";
						item.validate = webix.rules.isSpecialCharacter;
					}

					if (rule == "isEmail") {
						item.invalidMessage = item.label + " không hợp lệ";
						item.validate = webix.rules.isEmail;
					}

					if (rule == "isTaxCode") {
						item.invalidMessage = item.label + " không hợp lệ";
						item.validate = webix.rules.isTaxCode;
					}
				}

				if (item.value_change != null || item.css != null || item.validate != null) {
					item.on.onChange = function (newv, oldv) {

						if (this.config.validate != null && editmode != 0 && oldv != undefined && newv != undefined) {
							this.validate();
						}

						if (this.config.css != null) {
							if (this.config.css == "mcls_uppercase" && newv !== undefined && oldv !== undefined) {
								if (newv.toUpperCase() != oldv.toUpperCase()) {
									webix.$$(this.config.id).setValue(newv.toUpperCase());
								}

							}
						}

						if (this.config.value_change != null) {

							var fn = Function("newv", "oldv", "id", this.config.value_change);
							fn(newv, oldv, this.config.id);
						}
					}
				}


				el[row - 1].cols.push(item);

			}

			if (vc_window.window_type == "MasterDetail") {

				var cells = [];

				for (var i = 0; i < tabs.length; i++) {
					var tab = tabs[i];

					if (tab.tab_type == "Master") {
						continue;
					}

					var subCols = [];

					for (var j = 0; j < tab.Fields.length; j++) {
						var field = tab.Fields[j];

						var subCol = {
							id: field.column_name,
							header: field.caption != null ? _(field.caption) : _(field.column_name),
							editor: field.type_editor,
							hidden: field.hidden,
							value_change: field.value_change
						};


						if (field.column_type == "date" || field.column_type == "datetime") {
							subCol.format = function (text) {
								var format = webix.Date.dateToStr("%d/%m/%Y");
								text = removeTimeZoneT(text);
								return format(text);
							};
						}

						if (field.column_type == "decimal") {
							subCol.css = { "text-align": "right" };
							subCol.format = webix.Number.numToStr({
								groupDelimiter: ",",
								groupSize: 3,
								decimalDelimiter: ".",
								decimalSize: 0
							});
						}



						if (field.column_width == null) {
							subCol.fillspace = true;
						}
						else {
							subCol.width = field.column_width;
						}

						if (field.type_editor == "combo") {
							subCol.options = app.config.host + "/System/GetDataByReferencesId?id=" + field.ref_id
						}

						if (field.type_editor == "datepicker") {
							subCol.editor = "date";
						}

						if (field.type_editor == "treesuggest") {
							var listColumns = JSON.parse(field.list_column);

							for (var v = 0; v < listColumns.length; v++) {
								listColumns[v].header = _(listColumns[v].id);
							}

							var popup = webix.ui({
								view: "treesuggest",
								body: {
									columns: listColumns,
									refid: field.ref_id,
									url: {
										$proxy: true,
										load: function (view, callback, params) {
											var url = app.config.host + "/System/GetDataByReferencesId?id=" + view.config.refid;

											webix.ajax(url, function (text) {
												var json = JSON.parse(text);
												var data = listToTree(json);
												view.parse(data, "json");
											});

										}
									},
									filterMode: {
										level: false,
										showSubItems: false
									}
								}
							});

							subCol.popup = popup;
							subCol.editor = "combo";

						}

						if (field.type_editor == "gridcombo") {
							var listColumns = JSON.parse(field.list_column);

							for (var v = 0; v < listColumns.length; v++) {
								listColumns[v].header = _(listColumns[v].id);
							}

							var popup = webix.ui({
								view: "gridsuggest",
								body: {
									columns: listColumns,
									refid: field.ref_id,
									url: app.config.host + "/System/GetDataByReferencesId?id=" + field.REF_ID
								}
							});

							subCol.popup = popup;
							subCol.editor = "combo";

						}

						if (field.type_editor == "gridsuggest") {
							var listColumns = JSON.parse(field.list_column);

							for (var v = 0; v < listColumns.length; v++) {
								listColumns[v].header = _(listColumns[v].id);
							}

							subCol.editor = "text";
							subCol.suggest = {
								view: "gridsuggest",
								value_suggest: field.value_suggest,
								body: {
									columns: listColumns,
									refid: field.ref_id,
									datatype: "json",
									dataFeed: function (filtervalue, filter) {
										if (filtervalue.length < 3) return;

										var refid = this.config.refid;
										var pathUrl = app.config.host + "/System/GetDataByReferencesId?id=" + refid;
										var urldata = "filtervalue=" + encodeURIComponent(filtervalue);

										this.load(pathUrl + "&" + urldata, this.config.datatype);
									}
								},
								on: {
									onValueSuggest: function (obj) {
										if (this.config.value_suggest != null) {
											var fn = Function("obj", "id", this.config.value_suggest);
											fn(obj, this.config.id);
										}
									}

								}
							}


						}

						subCols.push(subCol);
					}

					if (tab.tab_type == "Detail") {
						var item = {
							header: tab.tab_name,
							select: "cell",
							body: {
								rows: [
									{
										view: "toolbar",
										height: 25,
										cols: [
											{
												view: "icon",
												icon: "plus",
												on: {
													onItemClick: function (id, e) {
														var parentView = this.getParentView().getParentView();
														var childViews = parentView.getChildViews();

														for (var i = 0; i < childViews.length; i++) {
															var childview = childViews[i];

															if (childview.config.view == "datatable") {
																var table = childview;

																var item = {
																	id: webix.uid()
																};

																var vc_window = windowconfig['data'][0];
																var tabs = vc_window.Tabs;

																for (var i = 0; i < tabs.length; i++) {
																	var tab = tabs[i];
																	if (tab.tab_type == "Detail") {
																		var fields = tab.Fields;

																		for (var j = 0; j < fields.length; j++) {
																			var field = fields[j];

																			if (field.column_name == "ma_dvcs") {
																				item[field.column_name] = user.getDvcsID();
																			}



																			if (field.default_value != null) {
																				var defaultValue = field.DEFAULT_VALUE.toString();

																				if (defaultValue.startsWith("@Default=")) {
																					item[field.column_name] = defaultValue.replace("@Default=", "");
																				}

																				if (defaultValue.startsWith("@JS=")) {
																					var fn = Function(defaultValue.replace("@JS=", ""));
																					item[field.column_name] = fn();
																				}
																			}
																		}
																	}
																}


																table.add(item);

																break;
															}
														}

													}
												}
											},
											{
												view: "icon",
												icon: "minus",
												on: {
													onItemClick: function (id, e) {
														var parentView = this.getParentView().getParentView();
														var childViews = parentView.getChildViews();

														for (var i = 0; i < childViews.length; i++) {
															var childview = childViews[i];

															if (childview.config.view == "datatable") {
																var table = childview;

																table.editStop();

																var item = table.getSelectedItem();

																if (!webix.isUndefined(item)) {
																	table.remove(item.id);
																	table.clearSelection();
																	return;
																}

																var editor = table.getEditState();

																if (!webix.isUndefined(editor)) {
																	table.remove(editor.row);
																	table.clearSelection();
																	return;
																}

																break;
															}
														}

													}
												}
											}
										]
									},
									{
										view: "datatable",
										id: "edit_" + tab.tab_table,
										tab_table: tab.tab_table,
										tab_id: tab.tab_id,
										editable: true,
										select: "cell",
										select_change: tab.select_change,
										columns: subCols,
										on: {
											onAfterEditStop: function (state, editor, ignore) {
												if (editor.config.value_change != null) {
													var selectedItem = null;

													if (typeof editor.getPopup === "function") {
														var popup = editor.getPopup();

														if (popup != null) {
															var list = popup.getList();

															if (list != null) {
																selectedItem = list.getSelectedItem();
															}
														}
													}

													var fn = Function("newv", "oldv", "id", "selectedItem", editor.config.value_change);
													fn(state.value, state.old, editor.config.id, selectedItem);
												}

											},
											onKeyPress: function (code, e) {
												var table = this;

												if (e.key == "F4") {
													var editor = table.getEditState();

													if (!webix.isUndefined(editor)) {
														alert("test")
														return;
													}
												}
											},
											onSelectChange: function () {
												var selectedItem = this.getSelectedId();

												if (this.config.select_change != null) {
													var fn = Function("selectedItem", this.config.select_change);
													fn(selectedItem);
												}
											}
										}
									}
								]

							}
						};

						cells.push(item);
					}
				}

				var subview = {
					borderless: true,
					view: "tabview",
					scrollX: true,
					cells: cells,
					tabbar: {
						width: 200
					}
				};

				if (vc_window.width != null || vc_window.height != null) {
					subview.height = 250;
				}

				//el.push(subview);

				if (vc_window.row_tab != null) {
					el[vc_window.row_tab - 1] = subview;
				}
				else {
					el.push(subview);
				}

			}

			var cols = [
				{},
				{
					shortcut: "F10",
					view: "button", label: "Nhận (F10)", type: "form", align: "center",
					width: 100,
					on: {
						onClick: function () {
							var parent = this.getTopParentView();
							var form = parent.getChildViews()[1];

							if (form.validate() == false) {
								return;
							}
							var item = form.getValues();
							var khData = {};
							khData.windowid = String(rp['data'][0]['window_id']);
							khData.editmode = editmode;
							khData.data = [];
							var vc_window = rp['data'][0];
							if (vc_window.window_type == "MasterDetail") {
								var tabs = vc_window.Tabs;
								var details = [];
								for (var i = 0; i < tabs.length; i++) {
									var tab = tabs[i];
									if (tab.tab_type == "Detail") {
										var table = webix.$$("edit_" + tab.tab_table);
										details.push({
											tab_id: tab.tab_id,
											tab_table: tab.tab_table,
											data: table.serialize()
										});
									}
								}
								item["details"] = details;
							}
							khData.data.push(item);
							this.getTopParentView().disable();
							this.getTopParentView().showProgress();
							webix.ajax()
								.headers({ 'Content-type': 'application/json' })
								.post(app.config.host + "/System/Save", khData, function (text) {
									var json = JSON.parse(text);
									$$(json.windowid).enable();
									$$(json.windowid).hideProgress();
									if (!json.hasOwnProperty("error")) {
										var after_save = $$(json.windowid).config.after_save;
										if (after_save != null) {
											var fn = Function("editmode", "data", after_save);
											fn(editmode, json.data);
										}
										var win = $$(json.windowid);
										if (win.config.callback != null && win.config.callback != undefined) {
											win.config.callback(json.data);
										}
										setParentValue(json.windowid)
										$$(json.windowid).close();
									}
									else {
										webix.message(json.error);
									}
								});
						}
					},
					click: function () {
						this.callEvent("onClick");

					},
				},
				{
					view: "button", shortcut: "esc", label: "Hủy bỏ (ESC)", type: "danger", align: "center",
					width: 100,
					on: {
						onClick: function () {
							// var table = webix.$$("edit_" + tab.tab_table);
							// table.editStop();
							this.getTopParentView().close();
						}
					},
					click: function () {
						this.callEvent("onClick");
					}
				},
				{}
			];

			el.push({
				margin: 10,
				cols: cols
			});

			webix.ui(el, $$("editwindow-form"));
			webix.$$("edit_head-form").setValues({ title: windowconfig.data[0].window_name == undefined ? "" : windowconfig.data[0].window_name });
			$$("edit_head-form").refresh();
			//win.getHead().setHTML(windowconfig.data[0].window_name);
		},
		setEditMode: function (mode) {
			editmode = mode;
		},
		setValues: function (item, winconfig) {

			var form = webix.$$("editwindow-form");
			var vc_window = winconfig['data'][0];

			if (item == null) {
				var tabs = vc_window.Tabs;

				item = {};

				for (var i = 0; i < tabs.length; i++) {
					var tab = tabs[i];
					if (tab.tab_type == "Normal" || tab.tab_type == "Master") {
						var fields = tab.Fields;

						for (var j = 0; j < fields.length; j++) {
							var field = fields[j];

							if (field.column_name == "ma_dvcs") {
								item[field.column_name] = user.getDvcsID();
							}


							if (field.default_value != null) {
								var defaultValue = field.default_value.toString();

								if (defaultValue.startsWith("@Default=")) {
									item[field.column_name] = defaultValue.replace("@Default=", "");
								}

								if (defaultValue.startsWith("@JS=")) {
									var fn = Function(defaultValue.replace("@JS=", ""));
									item[field.column_name] = fn();
								}
							}
						}
					}
				}

				form.setValues(item);
			}
			else {

				form.setValues(item);

				if (vc_window.window_type == "MasterDetail") {
					var tabs = vc_window.Tabs;

					for (var i = 0; i < tabs.length; i++) {
						var tab = tabs[i];

						if (tab.tab_type == "Master") {
							continue;
						}

						var table = webix.$$("edit_" + tab.tab_table);

						var url = app.config.host + "/System/GetDataDetailsByTabTable?window_id=" + vc_window.window_id
							+ "&id=" + item.id + "&tab_table=" + tab.tab_table;
						table.clearAll();
						table.load(url);

					}
				}
			}
		}
	};

});
define('views/forms/selectwindow',[
	"app",
	"locale"
],function(app,_){

	return {		
		$ui:{   
			view:"window", modal:true, id:"select-win", position:"center",
			head:"Thông tin Tab",
			fullscreen:true,
			body:{
                rows:[
					{
						height:35,
						type: "toolbar",
						cols:[
							{
								view: "button", 
								type: "icon", 
								icon:"fas fa-check-square", 
								label: "Chọn" ,
								width:65,								
								on: {
									onClick: function(){
										var win = this.getTopParentView();

										var valueField = win.config.valueField;
										var displayField = win.config.displayField;
										var fieldExpression = win.config.fieldExpression;
										var table= win.getChildViews()[1].getChildViews()[1];

										if (win.config.editorId!=null){

											if (valueField!=null){									
												var selectedItem = table.getSelectedItem();
												var editor = $$(win.config.editorId);
												editor.setValue(selectedItem[valueField]);
											}

											if (displayField !== undefined){
												if (displayField!=null){
													var selectedItem = table.getSelectedItem();
													var editor = $$(win.config.editorId);
													editor.setValue(selectedItem[displayField]);
												}
											}

											if (fieldExpression!=null){
												var formParent = $$(win.config.formId);
												var parentItem = formParent.getValues(); 
												var selectedItem = table.getSelectedItem();
												var fields = fieldExpression.split(';');

												for(var i=0;i<fields.length;i++){
													var field = fields[i].replace("{","").replace("}","");
													var array = field.split(":");

													parentItem[array[1]] = selectedItem[array[0]];
												}

												formParent.setValues(parentItem);
												$$(win.config.editorId).focus();
											}
										}
										else {
											var tableParent = $$(win.config.tableId);
											var columnName = win.config.columnName;
											var item = tableParent.getSelectedItem();

											if (valueField!=null){									
												var selectedItem = table.getSelectedItem();
												item[columnName] = selectedItem[valueField];												
											}

											if (displayField !== undefined){
												if (displayField!=null){
													var selectedItem = table.getSelectedItem();
													item[columnName] = selectedItem[displayField];
												}
											}

											if (fieldExpression!=null){												
												var selectedItem = table.getSelectedItem();
												var fields = fieldExpression.split(';');

												for(var i=0;i<fields.length;i++){
													var field = fields[i].replace("{","").replace("}","");
													var array = field.split(":");

													item[array[1]] = selectedItem[array[0]];
												}												
											}

											tableParent.updateItem(item);
											//webix.UIManager.setFocus(tableParent.config.id);
											//tableParent.edit({row: item.id, column: columnName});	
										}										

										this.getTopParentView().close();
										if (win.config.tableId!=null){
											webix.UIManager.setFocus(win.config.tableId);
										}
										
									}
								},
								click: function(){                
									this.callEvent("onClick");
								}
							},
							{
								view: "button", 
								type: "icon", 
								icon:"fas fa-close", 
								label: "Thoát" ,
								width:65,								
								on: {
									onClick: function(){
										this.getTopParentView().close();										
									}
								},
								click: function(){                
									this.callEvent("onClick");
								}
							}

						]
					},
					{
						view: "datatable",
						select: "row",
						datafetch: 50,
						on:{
							onKeyPress: function(code,e){
								var table = this;

								if (e.key == "Enter"){
									var win = this.getTopParentView();
									var toolbar= win.getChildViews()[1].getChildViews()[0];

									var btnChon = toolbar.getChildViews()[0];
									btnChon.callEvent("onClick");
								}
							}
						},
						pager : "selectPagerA"
					},
					{
						id: "selectPagerA",
						view:"pager",
						size: 50,
						group: 5,
						template:"{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}"
					}
				]
			}				
			
		},
		initUI: function(windowconfig){
			var win=$$("select-win");
console.log(win);
			var table= win.getChildViews()[1].getChildViews()[1];
			table.clearAll();

			var vc_window = windowconfig["data"][0];
			var tabs = vc_window.Tabs;

			var masterTab = tabs[0];

			var fields = windowconfig['data'][0]['Tabs'][0]['Fields'];
			var cols = [];

			for(var i=0;i<masterTab.Fields.length;i++){
				var field = masterTab.Fields[i];

				if(field.hide_in_grid==true){
					continue;
				}			
					
				var item = {
					id: field.column_name, 
					header: _(field.caption),
					columnType: field.column_type 					
				};

				if (field.type_filter!=null){
                    if (field.type_filter!=""){
                        item.header = [_(item.header), { content: field.type_filter}]
                    }
                }

				if (field.column_width == null){
					item.fillspace = true;
				}
				else {
					item.width = field.column_width;
				}

				if (field.type_editor == "combo"){
					item.editor = field.type_editor;
					item.options = app.config.host + "/System/GetDataByReferencesId?id=" + field.ref_id;
                }

				cols.push(item);
			}

			table.config.columns = cols;			
			table.refreshColumns();
			
			table.config.windowno = vc_window.window_id;

			var url = {
                    $proxy:true,
                    load:function(view, callback, params){                        
                        var windowno = view.config.windowno;
						var url = app.config.host + "/System/GetDataByWindowNo";
						
						var parameters = {
							window_id: windowno
						};

                        if (params==null){
														
							parameters["start"] = 0;
							parameters["count"] = view.config.datafetch;
							parameters["continue"] = null;
							parameters["filter"] = [];
							parameters["infoparam"] = null;
							parameters["tlbparam"] = [];

                        }
                        else {
                            							
							parameters["start"] = params.start;
							parameters["count"] = params.count;
							parameters["continue"] = params.continue;
							parameters["filter"] = [];
							parameters["infoparam"] = null;
							parameters["tlbparam"] = [];

                            if (params.filter!=null){
                                var array=[];

                                for(var property in params.filter){

                                    var column = view.getColumnConfig(property);

                                    if (column !== undefined){
                                         var item = {
                                            columnName : property,
                                            columnType : column.columnType,
                                            value: params.filter[property]
                                        };

                                        array.push(item);
                                    }
                                    
                                   
								}
								
								parameters["filter"] = array;                            
                                
                            }
                                                       
                        }

                        if (view.config.infoparam!=null){
							parameters["infoparam"] = view.config.infoparam;
                        }
						
						webix.ajax().bind(view)
							.headers({"Content-Type": "application/json"})
							.post(url, parameters, callback);
                        
                    }
            };
				
			table.define("url",url );
		}		
	};

});
define('models/findjson',[

], function () {


    return {
        // findAndReplace: function findAndReplace(object, value, replacevalue) {
        //     for (var x in object) {
        //         if (object.hasOwnProperty(x)) {
        //             if (typeof object[x] == 'object') {
        //                 findAndReplace(object[x], value, replacevalue);
        //             }
        //             if (object[x] == value) {
        //                 object["name"] = replacevalue;
        //                 // break; // uncomment to stop after first replacement
        //             }
        //         }
        //     }
        // },
        getObjects: function getObjects(obj, key, val) {
            var objects = [];
            for (var i in obj) {
                // console.log(obj);
                if (!obj.hasOwnProperty(i)) continue;
                if (typeof obj[i] == 'object') {
                    objects = objects.concat(getObjects(obj[i], key, val));
                } else
                    //if key matches and value matches or if key matches and value is not passed (eliminating the case where key matches but passed value does not)
                    if (i == key && obj[i] == val || i == key && val == '') { //
                        objects.push(obj);
                    } else if (obj[i] == val && key == '') {
                        //only add if the object is not already in the array
                        if (objects.lastIndexOf(obj) == -1) {
                            objects.push(obj);
                        }
                    }
            }
            return objects;
        },
        findAndReplace: function findAndReplace(object, value, item) {

            for (var x in object) {

                if (typeof object[x] == typeof {}) {
                    findAndReplace(object[x], value, item);
                }
                //nếu tìm thấy name bằng với name của item truyền vào trong object thì thay thế object[name] bằng item
                if (object[x] == value) {
                    //console.log(object);
                    webix.extend(object, item, true);
                    //object["name"] = value[i];
                    // object[element] = replacevalue;
                    //object["name"] = replacevalue;
                    // break; // uncomment to stop after first replacement
                }
            }
            return object;
        },
        //return an array of values that match on a certain key
        getValues: function getValues(obj, key) {
            var objects = [];
            for (var i in obj) {
                if (!obj.hasOwnProperty(i)) continue;
                if (typeof obj[i] == 'object') {
                    objects = objects.concat(getValues(obj[i], key));
                } else if (i == key) {
                    objects.push(obj[i]);
                }
            }
            return objects;
        },

        //return an array of keys that match on a certain value
        getKeys: function getKeys(obj, val) {
            var objects = [];
            for (var i in obj) {
                if (!obj.hasOwnProperty(i)) continue;
                if (typeof obj[i] == 'object') {
                    objects = objects.concat(getKeys(obj[i], val));
                } else if (obj[i] == val) {
                    objects.push(i);
                }
            }
            return objects;
        }

    };

});
define('views/forms/window',[
	"app",
	"locale",
	"models/user",
	"views/forms/editwindow",
	"views/forms/selectwindow",
	"models/findjson"
], function (app, _, user, editwindow, selectwindow, findJson) {
	var editmode = 0;
	var tables = [];

	var windowno = app.path[1].params[0];
	var col = [];
	var rw = [];
	var el = [];
	var head_name = [];
	var head;
	var url = app.config.host + "/System/GetAllByWindowNo?window_id=" + windowno;

	function calculateColumn(tableId, columnId, type, fieldId) {
		var table = $$(tableId);
		var result = 0;

		table.eachRow(
			function (row) {
				var value = Number(row[columnId]);

				if (type == "SUM") {
					result = result + value;
				}
			}
		)

		$$(fieldId).setValue(result);
	}

	function showEditWindow(component, editmode) {
		var form = webix.$$("window-form");
		webix.extend(form, webix.ProgressBar);
		form.disable();
		form.showProgress();
		// var box = webix.modalbox({
		// 				title: "Đang in chứng từ",
		// 				text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
		// 				width: 350,
		// 				height: 200
		// 			});
		var self = component;
		var suggest = $$(self.config.suggest);
		var refid = suggest.config.body.refid;

		// var sql = "SELECT a.*,b.window_id as WINDOWNO FROM wb_references a INNER JOIN wb_window b ON a.wb_window_id=b.wb_window_id  WHERE a.wb_references_id='" + refid + "'";
		// var url = app.config.host + "/System/ExecuteQuery?sql=" + sql;
		var url = app.config.host + "/System/ExeCmd";
		var dataPost = {
			cmd: "CM0002",
			param: {
				wb_references_id: refid
			}
		};
		var win = self.getTopParentView();
		var form = win.getChildViews()[1];

		var editorId = self.config.id;
		var formId = form.config.id;

		var ajax = webix.ajax();

		ajax.master = {
			editorId: editorId,
			formId: formId,
			fieldExpression: self.config.fieldExpression,
			editmode: editmode,
			editorvalue: self.getValue(),
			suggest: self.config.suggest
		};
		ajax.headers({ 'Content-type': 'application/json' })
			.post(url, dataPost, function (text) {
				//ajax.get(url, function (text) {
				var json = JSON.parse(text);
				var master = ajax.master;
				// if (json.length > 0) {
				if (json.code == "00") {
					json.data[0].editorId = this.editorId;
					json.data[0].formId = this.formId;
					json.data[0].fieldExpression = this.fieldExpression;
					json.data[0].editmode = this.editmode;
					json.data[0].editorvalue = this.editorvalue;
					json.data[0].suggest = this.suggest;

					var windowno = json.data[0].WINDOWNO;

					var url = app.config.host + "/System/GetConfigWinByNo?id=" + windowno;
					var a = webix.ajax(url);
					url = app.config.host + "/System/GetRecordByReferencesId?id=" + json.data[0].wb_references_id + "&value=" + this.editorvalue;
					var b = webix.ajax(url);
					var c = this.editmode;
					var d = json.data[0];

					webix.promise.all([a, b, c, d]).then(function (results) {

						var windowconfig = results[0].json();
						var res_b = results[1].json();
						var mode = results[2];
						var master = results[3];

						var vc_window = windowconfig["data"][0];
						//  webix.modalbox.hide(box);
						form.enable();
						form.hideProgress();

						if (mode == 1) {

							editwindow.$ui.id = vc_window.window_id;
							editwindow.$ui.editorId = master.editorId;
							editwindow.$ui.valueField = master.value_field;
							editwindow.$ui.fieldExpression = master.fieldExpression;
							editwindow.$ui.formId = master.formId;

							var win = webix.ui(editwindow.$ui);

							editwindow.initUI(windowconfig);
							editwindow.setEditMode(mode);
							editwindow.setValues(null, windowconfig);

							$$(master.suggest).hide();

							win.show();
						}
						else {

							if (res_b.length == 0) {
								webix.alert({
									title: "Thông báo",
									text: "Không tìm thấy dữ liệu"
								});

								return;
							}

							var ajax = webix.ajax();

							ajax.master = {
								master: master,
								vc_window: vc_window
							};

							var url = app.config.host + "/System/GetDataById?window_id=" + vc_window.window_id + "&id=" + res_b[0].doc_id;

							ajax.get(url, function (text) {
								var json = JSON.parse(text);
								var data = json;

								var vc_window = this.vc_window;
								var master = this.master;

								editwindow.$ui.id = vc_window.window_id;
								editwindow.$ui.editorId = master.editorId;
								editwindow.$ui.valueField = master.value_field;
								editwindow.$ui.fieldExpression = master.fieldExpression;
								editwindow.$ui.formId = master.formId;

								var win = webix.ui(editwindow.$ui);

								editwindow.initUI(windowconfig);
								editwindow.setEditMode(2);
								editwindow.setValues(data, windowconfig);

								$$(master.suggest).hide();
								win.show();

							});
						}
					});
				}
			});
	}

	function tableShowEditWindow(table, editmode) {
		var editor = table.getEditState();

		if (!webix.isUndefined(editor)) {
			var suggest = $$(editor.config.suggest);
			var refid = suggest.config.body.refid;

			// var sql = "SELECT a.*,b.window_id as WINDOWNO FROM wb_references a INNER JOIN wb_window b ON a.wb_window_id=b.wb_window_id  WHERE a.wb_references_id='" + refid + "'";
			// var url = app.config.host + "/System/ExecuteQuery?sql=" + sql;
			var url = app.config.host + "/System/ExeCmd";
			var dataPost = {
				cmd: "CM0002",
				param: {
					wb_references_id: refid
				}
			};
			var tableId = table.config.id;
			//console.log(tableId);
			var columnName = editor.config.id;

			var ajax = webix.ajax();

			ajax.master = {
				editorId: null,
				tableId: tableId,
				fieldExpression: suggest.config.fieldExpression,
				columnName: columnName,
				editmode: editmode,
				editorvalue: editor.getValue(),
				suggest: editor.config.suggest
			};

			// ajax.get(url, function (text) {
			ajax.headers({ 'Content-type': 'application/json' })
				.post(url, dataPost, function (text) {
					var json = JSON.parse(text);

					if (json.code == "00") {

						json.data[0].editorId = this.editorId;
						json.data[0].tableId = this.tableId;
						json.data[0].fieldExpression = this.fieldExpression;
						json.data[0].columnName = this.columnName;
						json.data[0].editmode = this.editmode;
						json.data[0].editorvalue = this.editorvalue;
						json.data[0].suggest = this.suggest;

						var windowno = json.data[0].WINDOWNO;

						var url = app.config.host + "/System/GetConfigWinByNo?id=" + windowno;
						var a = webix.ajax(url);
						url = app.config.host + "/System/GetRecordByReferencesId?id=" + json.data[0].wb_references_id + "&value=" + this.editorvalue;
						var b = webix.ajax(url);
						var c = this.editmode;
						var d = json.data[0];

						webix.promise.all([a, b, c, d]).then(function (results) {

							var windowconfig = results[0].json();
							var res_b = results[1].json();
							var mode = results[2];
							var master = results[3];

							var vc_window = windowconfig["data"][0];

							if (mode == 1) {
								editwindow.$ui.id = vc_window.window_id;
								editwindow.$ui.editorId = master.editorId;
								editwindow.$ui.valueField = master.value_field;
								editwindow.$ui.fieldExpression = master.fieldExpression;
								editwindow.$ui.formId = master.formId;
								editwindow.$ui.tableId = master.tableId;
								editwindow.$ui.columnName = master.columnName;

								var win = webix.ui(editwindow.$ui);

								editwindow.initUI(windowconfig);
								editwindow.setValues(null, windowconfig);
								editwindow.setEditMode(mode);

								$$(master.suggest).hide();
								win.show();
							}
							else {
								if (res_b.length == 0) {
									webix.alert({
										title: "Thông báo",
										text: "Không tìm thấy dữ liệu"
									});

									return;
								}
								var ajax = webix.ajax();

								ajax.master = {
									master: master,
									vc_window: vc_window
								};

								var url = app.config.host + "/System/GetDataById?window_id=" + vc_window.window_id + "&id=" + res_b[0].doc_id;

								ajax.get(url, function (text) {
									var json = JSON.parse(text);
									var data = json;

									var vc_window = this.vc_window;
									var master = this.master;

									editwindow.$ui.id = vc_window.window_id;
									editwindow.$ui.editorId = master.editorId;
									editwindow.$ui.valueField = master.value_field;
									editwindow.$ui.fieldExpression = master.fieldExpression;
									editwindow.$ui.formId = master.formId;
									editwindow.$ui.tableId = master.tableId;
									editwindow.$ui.columnName = master.columnName;

									var win = webix.ui(editwindow.$ui);

									editwindow.initUI(windowconfig);
									editwindow.setValues(data, windowconfig);
									editwindow.setEditMode(2);

									$$(master.suggest).hide();
									win.show();

								});
							}
						});
					}
				});
		}
	}

	function hint_form(hint) {
		if (hint == undefined || hint == null || hint == "") {
			webix.alert({
				title: "Thông báo !",
				text: "Bạn chưa khai báo hướng dẫn nhanh cho màn hình này !",
				type: "alert-warning",
				callback: function (result) {

				}
			});
		}
		else {
			var views = {
				view: "hint",
				id: "hint",
				// nextButton: "fas fa-arrow-right",    // the new caption of the button
				// prevButton: "fas fa-arrow-left",
				steps: JSON.parse(hint)

			};

			webix.ui(views);
			$$("hint").start();
		}
	}
	return {
		$ui: {
			view: "window",
			modal: true,
			id: "window-win",
			position: "center",
			move: true,
			// point: true,
			// padding: 30,
			resize: true,
			css: "headformchil",
			//fullscreen:true,
			head: {
				//view: "toolbar",
				// css: { "box-shadow": "0 -2px #3498db inset !important", "background": "#ffffff !important" },
				//css: { "background": "#e6f2ff !important" },
				height: 35,
				cols: [
					{
						id: "head-icon",
						view: "template",
						css: "headform",
						width: 35,
						template: ""
					},
					{
						id: "head-form", view: "template", css: "headform", template: function (obj) {
							return '<div>' + obj.title + '<div/>';
						}
					},
					{
						view: "icon", icon: "fas fa-question-circle", id: "help_form", tooltip: _("HELPER"), click: function () {
							var form = webix.$$("window-form");
							hint_form(form.config.hint);
						}
					}
				]
			},
			body: {
				paddingY: 10,
				paddingX: 10,
				view: "form",
				id: "window-form",
				complexData: true,
				keepViews: true,
				multiview: { keepViews: true },
				margin: 0,
				elements: el
			}
		},
		initUI: function (windowconfig, checkbox_thue) {
			var rp = windowconfig;
			var rows_max = rp['data'][0]['rows_max'];
			var vc_window = rp["data"][0];
			var tabs = vc_window.Tabs;
			var win = $$(vc_window.window_id);
			var hint = rp['data'][0]['hint'];
			$$("window-form").config.hint = hint;

			if (typeof win.showProgress === "undefined")
				webix.extend(win, webix.ProgressBar);
			el = [];
			col = [];
			if (vc_window.width == null && vc_window.height == null) {
				win.config.fullscreen = true;
			}
			if (vc_window.after_save != null) {
				win.config.after_save = vc_window.after_save;
			}
			// nếu có layout_detail thì bindding layout vào el
			if (vc_window.layoutdetail != null && vc_window.layoutdetail != "") {
				var layoutdetail = JSON.parse(vc_window.layoutdetail);
				var layout_element = JSON.stringify(layoutdetail.elements);
				var json_layout = JSON.parse(layout_element);
				//console.log(json_layout);
				for (var i = 0; i < json_layout.length; i++) {
					el.push(json_layout[i]);
				}
				var jsonElement = findJson.getObjects(JSON.parse(JSON.stringify(el)), "id", "");
				for (var i = 0; i < jsonElement.length; i++) {
					var fields = rp['data'][0]['Tabs'][0]['Fields'];
					for (var j = 0; j < fields.length; j++) {
						var field = fields[j];
						if (jsonElement[i].name == field.column_name) {
							if (field.hidden == true) {
								continue;
							}
							var item = {
								view: field.type_editor,
								resizeColumn: true,
								editable: true,
								//keepViews: true,
								multiview: { keepViews: true },
								name: field.column_name,
								label: _(field.column_name),
								id: field.column_name + "_" + rp['data'][0]['Tabs'][0]["tab_table"],
								width: field.width,
								labelPosition: field.label_position,
								labelWidth: field.label_width,
								format: field.format,
								value_change: field.value_change,
								fieldExpression: field.field_expression,
								data_width: field.data_width,
								column_type: field.column_type,
								css: field.css,
								attributes: {},
								on: {}
							};
							if (field.type_editor == "datepicker") {
								item.placeholder = "dd/MM/yyyy";
								item.on.onKeyPress = function (code, e) {
									if ((code < 48 || code > 57) && code != 8 && code != 191 && code != 9) {
										return webix.html.preventEvent(e);
									}
								};

							}
							if (field.type_editor == "password") {
								item.view = "text";
								item.type = "password";
							}

							if (item.data_width != null) {
								if (item.data_width != 0) {
									item.attributes.maxlength = item.data_width;
									//style: "text-transform: uppercase;"						
								}
							}

							if (field.styleinput != null) {
								item.attributes.style = field.styleinput;
							}

							if (field.height != null) {
								if (field.height != 0) {
									item.height = field.height;
								}
							}

							if (field.caption != null) {
								item.label = _(field.caption);
							}

							if (field.read_only == "C") {
								item.readonly = true;
							}

							if (item.view == "combo") {
								item.suggest = {
									body: {
										url: app.config.host + "/System/GetDataByReferencesId?id=" + field.ref_id
									}
								}
								//item.options = app.config.host + "/System/GetDataByReferencesId?id=" + field.ref_id;
							}

							if (item.view == "select") {
								item.options = app.config.host + "/System/GetDataByReferencesId?id=" + field.ref_id;
							}
							if (item.view == "checkbox") {
								if (field.label_position == "right") {
									item.labelRight = _(field.column_name);
									item.label = "";
								}

								if (field.column_type == "char") {
									item.checkValue = "C";
									item.uncheckValue = "K";
								}

								if (field.column_type == "tinyint") {
									item.checkValue = "1";
									item.uncheckValue = "0";
								}

								if (field.column_type == "bit") {
									item.checkValue = true;
									item.uncheckValue = false;
								}
							}

							if (item.view == "autonumeric" || field.column_type == "decimal") {
								item.inputAlign = "right";
								item.decimalPlaces = field.data_decimal;
							}

							if (field.valid_rule != null) {
								var rule = field.valid_rule;

								if (rule == "isNotEmpty") {
									item.required = true;
									item.invalidMessage = item.label + " không được bỏ trống";
									item.validate = webix.rules.isNotEmpty;
								}

								if (rule == "isSpecialCharacter") {
									item.required = true;
									item.invalidMessage = "Không bỏ trống hoặc ký tự không hợp lệ (a-z,A-Z,0-9)";
									item.validate = webix.rules.isSpecialCharacter;
								}

								if (rule == "isEmail") {
									item.invalidMessage = item.label + " không hợp lệ";
									item.validate = webix.rules.isEmail;
								}

								if (rule == "isTaxCode") {
									item.invalidMessage = item.label + " không hợp lệ";
									item.validate = webix.rules.isTaxCode;
								}
							}

							if (item.view == "treesuggest") {

								//item.REF_ID = field.REF_ID.toString();
								var listColumns = JSON.parse(field.list_column);

								for (var v = 0; v < listColumns.length; v++) {
									listColumns[v].header = _(listColumns[v].id);
								}

								item.view = "combo";
								item.options = {
									view: "treesuggest",
									textValue: field.display_field,
									url: {
										$proxy: true,
										load: function (view, callback, params) {
											var url = app.config.host + "/System/GetDataByReferencesId?id=" + view.config.refid;

											webix.ajax(url, function (text) {
												var json = JSON.parse(text);
												var data = listToTree(json);
												view.parse(data, "json");
											});

										}
									},
									body: {
										columns: listColumns,
										textValue: field.display_field,
										refid: field.ref_id,
										filterMode: {
											level: false,
											showSubItems: false
										}
									}
								};

								item.on.onKeyPress = function (code, e) {
									if (e.code == "F4") {
										alert("Moi");
									}
								};
							}

							if (item.view == "gridcombo") {
								var listColumns = JSON.parse(field.list_column);
								for (var v = 0; v < listColumns.length; v++) {
									listColumns[v].header = _(listColumns[v].id);
								}
								item.view = "combo";
								item.options = {
									view: "gridsuggest",
									url: app.config.host + "/System/GetDataByReferencesId?id=" + field.ref_id,
									body: {
										columns: listColumns,
										refid: field.REF_ID,
										textValue: field.display_field
									}
								};

								item.on.onKeyPress = function (code, e) {
									if (e.code == "F4") {
										alert("Moi");
									}
								};
							}
							if (item.view == "search") {
								item.keyPressTimeout = 2000;
								var express = item.fieldExpression;
								item.on.onKeyPress = function (code, e) {
									if (code == 32) {
										return webix.html.preventEvent(e);
									}
								};

								item.on.onSearchIconClick = function (e) {
									var form = $$(this.getFormView());
									//get value của form hiện tại để đổi giá trị
									var parentItem = form.getValues();
									var field_express = this.config.fieldExpression;
									var text = this.getValue();
									var datapost = { "masothue": text };
									var form = $$("window-form");
									webix.extend(form, webix.ProgressBar);
									form.disable();
									form.showProgress();
									webix.ajax()
										.headers({ 'Content-type': 'application/json' })
										.post(app.config.host + "/Pattern/GetInfoMST", datapost,
											{
												error: function (text, data, XmlHttpRequest) {
													//webix.modalbox.hide(box);
													form.enable();
													form.hideProgress();
													webix.message(text, "error");
													// webix.alert({
													//     title: "Lỗi !",
													//     text: text,
													//     type: "alert-error"
													// });
												},
												success: function (text, data, XmlHttpRequest) {
													var json = JSON.parse(text);
													if (!json.hasOwnProperty("error")) {
														if (field_express != null) {
															var fields = field_express.split(';');
															// tách json thành array
															for (var i = 0; i < fields.length; i++) {
																var field = fields[i].replace("{", "").replace("}", "");
																var array = field.split(":");
																parentItem[array[1]] = json[array[0]];
															}
															form.setValues(parentItem);
														}
														else {
															webix.message("FIELD_EXPRESSION IS NULL IN FIELD !", "error", 2000);
														}
													}
													else {
														// nếu không tồn tại mã số thuế phải xóa địa chỉ + tên cty ở đây 
														webix.message(json.error, "error", 2000);
													}
													form.enable();
													form.hideProgress();
												}
											});
								}
							}

							if (item.view == "gridsuggest") {
								var listColumns = JSON.parse(field.list_column);

								for (var v = 0; v < listColumns.length; v++) {
									listColumns[v].header = _(listColumns[v].id);
								}

								item.view = "search";
								item.icon = "fas fa-plus";
								item.on.onSearchIconClick = function (e) {
									showEditWindow(this, 1);
								};
								item.suggest = {
									view: "gridsuggest",
									autoheight: false,
									value_suggest: field.value_suggest,
									textValue: field.display_field,
									body: {
										columns: listColumns,
										refid: field.ref_id,
										scroll: true,
										autoheight: false,
										datatype: "json",
										textValue: field.display_field,
										dataFeed: function (filtervalue, filter) {
											if (filtervalue.length < 1) return;

											var refid = this.config.refid;
											var pathUrl = app.config.host + "/System/GetDataByReferencesId?id=" + refid;
											var urldata = "filtervalue=" + encodeURIComponent(filtervalue);

											this.load(pathUrl + "&" + urldata, this.config.datatype);
										},

									},
									on: {
										onValueSuggest: function (obj) {
											//console.log(obj);
											var master = $$(this.config.master);
											if (master.config.fieldExpression != null) {

												var win = master.getTopParentView();
												var form = win.getChildViews()[1];
												//console.log(form);
												var parentItem = form.getValues();
												//console.log(parentItem);
												var fields = master.config.fieldExpression.split(';');

												for (var i = 0; i < fields.length; i++) {
													var field = fields[i].replace("{", "").replace("}", "");
													var array = field.split(":");
													//console.log(array);
													parentItem[array[1]] = obj[array[0]];
												}

												form.setValues(parentItem);
											}

											if (this.config.value_suggest != null) {
												var fn = Function("obj", "id", this.config.value_suggest);
												fn(obj, this.config.id);
											}
										}
									}
								};
								item.on.onKeyPress = function (code, e) {
									if (e.code == "F2") {

										var suggest = $$(this.config.suggest);
										var refid = suggest.config.body.refid;

										suggest.hide();

										// var sql = "SELECT a.*,b.window_id as WINDOWNO FROM wb_references a INNER JOIN wb_window b ON a.wb_window_id=b.wb_window_id  WHERE a.wb_references_id='" + refid + "'";
										// var url = app.config.host + "/System/ExecuteQuery?sql=" + sql;
										var url = app.config.host + "/System/ExeCmd";
										var dataPost = {
											cmd: "CM0002",
											param: {
												wb_references_id: refid
											}
										};
										var win = this.getTopParentView();
										var form = win.getChildViews()[1];

										var editorId = this.config.id;
										var formId = form.config.id;

										// var a = webix.ajax(url);
										var a = webix.ajax().headers({ 'Content-type': 'application/json' }).post(url, dataPost);
										var b = this.config.suggest;
										var c = this.config.id;
										var d = this.config.fieldExpression;
										var e = editorId;
										var f = formId;

										webix.promise.all([a, b, c, d, e, f]).then(function (results) {
											var res_a = results.data[0].json();

											var suggest = $$(results[1]);

											suggest.hide();

											var url = app.config.host + "/System/GetConfigWinByNo?id=" + res_a["WINDOWNO"];

											var ajax = webix.ajax();
											ajax.master = {
												searchId: results[2],
												fieldExpression: d,
												valueField: res_a["value_field"],
												formId: f,
												editorId: e
											};

											ajax.get(url, function (text) {
												var windowconfig = JSON.parse(text);

												var txtSearch = $$(this.searchId);
												// console.log(selectwindow.$ui);
												// console.log(this.valueField);
												var win = txtSearch.$scope.ui(selectwindow.$ui);

												win.config.valueField = this.valueField;
												win.config.fieldExpression = this.fieldExpression;
												win.config.formId = this.formId;
												win.config.editorId = this.editorId;

												selectwindow.initUI(windowconfig);

												win.getHead().setHTML(windowconfig.data[0].window_name);
												win.show();

											});
										});


										var win = this.$scope.ui(selectwindow.$ui);
										win.show();
									}

									if (e.code == "F4" || e.code == "F3") {

										var editmode = e.code == "F3" ? 2 : 1;
										showEditWindow(this, editmode);
									}
								};
							}

							if (item.value_change != null || item.css != null || item.validate != null) {
								item.on.onChange = function (newv, oldv) {

									if (this.config.validate != null && editmode != 0) {
										this.validate();
									}

									if (this.config.css != null) {
										if (this.config.css == "mcls_uppercase" && newv !== undefined && oldv !== undefined) {
											if (newv.toUpperCase() != oldv.toUpperCase()) {
												webix.$$(this.config.id).setValue(newv.toUpperCase());
											}
										}
									}

									if (this.config.value_change != null) {
										var topParentView = this.getTopParentView();

										if (topParentView.config.editmode == 0) return;

										var fn = Function("newv", "oldv", "id", this.config.value_change);
										fn(newv, oldv, this.config.id);
									}
								}
							}

							jsonElement[i] = item;
							var finish_replace = findJson.findAndReplace(el, jsonElement[i].name, item);
							// console.log(finish_replace);
							//webix.extend(el,jsonElement[i],  true);
						}
					}
				}
			} // nếu không có thì push vào el theo field
			else {
				// insert số dòng max của form
				for (var i = 1; i <= rows_max; i++) {
					el.push({ cols: [] });
				}
				var fields = rp['data'][0]['Tabs'][0]['Fields'];
				// field của tab master (đầu phiếu )
				for (var i = 0; i < fields.length; i++) {
					var field = fields[i];
					if (field.hidden == true) {
						continue;
					}
					var row = field.row;
					var item = {
						view: field.type_editor,
						resizeColumn: true,
						multiview: { keepViews: true },
						keepViews: true,
						name: field.column_name,
						label: _(field.column_name),
						id: field.column_name + "_" + rp['data'][0]['Tabs'][0]["tab_table"],
						width: field.width,
						labelPosition: field.label_position,
						labelWidth: field.label_width,
						format: field.format,
						value_change: field.value_change,
						fieldExpression: field.field_expression,
						data_width: field.data_width,
						column_type: field.column_type,
						css: field.css,
						attributes: {},
						on: {}
					};
					if (field.type_editor == "password") {
						item.view = "text";
						item.type = "password";
					}
					if (item.data_width != null) {
						if (item.data_width != 0) {
							item.attributes.maxlength = item.data_width;
							//style: "text-transform: uppercase;"						
						}
					}
					if (field.styleinput != null) {
						item.attributes.style = field.styleinput;
					}
					if (field.height != null) {
						if (field.height != 0) {
							item.height = field.height;
						}
					}
					if (field.caption != null) {
						item.label = _(field.caption);
					}
					if (field.read_only == "C") {
						item.readonly = true;
					}
					if (item.view == "combo") {
						item.suggest = {
							body: {
								url: app.config.host + "/System/GetDataByReferencesId?id=" + field.ref_id
							}
						}
						//item.options = app.config.host + "/System/GetDataByReferencesId?id=" + field.ref_id;
					}
					if (item.view == "select") {
						item.options = app.config.host + "/System/GetDataByReferencesId?id=" + field.ref_id;
					}
					if (item.view == "checkbox") {
						if (field.label_position == "right") {
							item.labelRight = _(field.column_name);
							item.label = "";
						}

						if (field.column_type == "char") {
							item.checkValue = "C";
							item.uncheckValue = "K";
						}

						if (field.column_type == "tinyint") {
							item.checkValue = "1";
							item.uncheckValue = "0";
						}

						if (field.column_type == "bit") {
							item.checkValue = true;
							item.uncheckValue = false;
						}
					}
					if (item.view == "autonumeric" || field.column_type == "decimal") {
						item.inputAlign = "right";
						item.decimalPlaces = field.data_decimal;
					}
					if (field.valid_rule != null) {
						var rule = field.valid_rule;

						if (rule == "isNotEmpty") {
							item.required = true;
							item.invalidMessage = item.label + " không được bỏ trống";
							item.validate = webix.rules.isNotEmpty;
						}

						if (rule == "isSpecialCharacter") {
							item.required = true;
							item.invalidMessage = "Không bỏ trống hoặc ký tự không hợp lệ (a-z,A-Z,0-9)";
							item.validate = webix.rules.isSpecialCharacter;
						}

						if (rule == "isEmail") {
							item.invalidMessage = item.label + " không hợp lệ";
							item.validate = webix.rules.isEmail;
						}

						if (rule == "isTaxCode") {
							item.invalidMessage = item.label + " không hợp lệ";
							item.validate = webix.rules.isTaxCode;
						}
					}
					if (item.view == "treesuggest") {

						//item.REF_ID = field.REF_ID.toString();
						var listColumns = JSON.parse(field.list_column);

						for (var v = 0; v < listColumns.length; v++) {
							listColumns[v].header = _(listColumns[v].id);
						}

						item.view = "combo";
						item.options = {
							view: "treesuggest",
							textValue: field.display_field,
							url: {
								$proxy: true,
								load: function (view, callback, params) {
									var url = app.config.host + "/System/GetDataByReferencesId?id=" + view.config.refid;

									webix.ajax(url, function (text) {
										var json = JSON.parse(text);
										var data = listToTree(json);
										view.parse(data, "json");
									});

								}
							},
							body: {
								columns: listColumns,
								refid: field.ref_id,
								filterMode: {
									level: false,
									showSubItems: false
								}
							}
						};

						item.on.onKeyPress = function (code, e) {
							if (e.code == "F4") {
								alert("Moi");
							}
						};
					}
					if (item.view == "gridcombo") {

						var listColumns = JSON.parse(field.list_column);

						for (var v = 0; v < listColumns.length; v++) {
							listColumns[v].header = _(listColumns[v].id);
						}

						item.view = "combo";
						item.options = {
							view: "gridsuggest",
							url: app.config.host + "/System/GetDataByReferencesId?id=" + field.ref_id,
							body: {
								columns: listColumns,
								refid: field.REF_ID,
								textValue: field.display_field
							}
						};

						item.on.onKeyPress = function (code, e) {
							if (e.code == "F4") {
								alert("Moi");
							}
						};
					}
					if (item.view == "search") {
						var express = item.fieldExpression;

						item.on.onSearchIconClick = function (e) {
							var form = $$(this.getFormView());
							//get value của form hiện tại để đổi giá trị
							var parentItem = form.getValues();
							var field_express = this.config.fieldExpression;
							var text = this.getValue();
							var datapost = { "masothue": text };
							webix.extend(form, webix.ProgressBar);
							form.disable();
							form.showProgress();
							webix.ajax()
								.headers({ 'Content-type': 'application/json' })
								.post(app.config.host + "/Pattern/GetInfoMST", datapost,
								{
									error: function (text, data, XmlHttpRequest) {
										//webix.modalbox.hide(box);
										form.enable();
										form.hideProgress();
										webix.message(text, "error");
										// webix.alert({
										//     title: "Lỗi !",
										//     text: text,
										//     type: "alert-error"
										// });
									},
									success: function (text, data, XmlHttpRequest) {
										var json = JSON.parse(text);
										if (!json.hasOwnProperty("error")) {
											if (field_express != null) {
												var fields = field_express.split(';');
												// tách json thành array
												for (var i = 0; i < fields.length; i++) {
													var field = fields[i].replace("{", "").replace("}", "");
													var array = field.split(":");
													parentItem[array[1]] = json[array[0]];
												}
												form.setValues(parentItem);
											}
											else {
												webix.message("FIELD_EXPRESSION IS NULL IN FIELD !", "error", 2000);
											}
										}
										else {
											// nếu không tồn tại mã số thuế phải xóa địa chỉ + tên cty ở đây 
											webix.message(json.error, "error", 2000);
										}
										form.enable();
										form.hideProgress();
									}

								});
						}
					}
					if (item.view == "gridsuggest") {
						var listColumns = JSON.parse(field.list_column);

						for (var v = 0; v < listColumns.length; v++) {
							listColumns[v].header = _(listColumns[v].id);
						}

						item.view = "search";
						item.icon = "mdi mdi-plus";
						item.on.onSearchIconClick = function (e) {
							showEditWindow(this, 1);
						};
						item.suggest = {
							view: "gridsuggest",
							autoheight: false,
							value_suggest: field.value_suggest,
							textValue: field.display_field,
							body: {
								columns: listColumns,
								refid: field.ref_id,
								scroll: true,
								autoheight: false,
								datatype: "json",
								textValue: field.display_field,
								dataFeed: function (filtervalue, filter) {
									if (filtervalue.length < 1) return;

									var refid = this.config.refid;
									var pathUrl = app.config.host + "/System/GetDataByReferencesId?id=" + refid;
									var urldata = "filtervalue=" + encodeURIComponent(filtervalue);

									this.load(pathUrl + "&" + urldata, this.config.datatype);
								},

							},
							on: {
								onValueSuggest: function (obj) {
									//console.log(obj);
									var master = $$(this.config.master);
									if (master.config.fieldExpression != null) {

										var win = master.getTopParentView();
										var form = win.getChildViews()[1];
										//console.log(form);
										var parentItem = form.getValues();
										//console.log(parentItem);
										var fields = master.config.fieldExpression.split(';');

										for (var i = 0; i < fields.length; i++) {
											var field = fields[i].replace("{", "").replace("}", "");
											var array = field.split(":");
											//console.log(array);
											parentItem[array[1]] = obj[array[0]];
										}

										form.setValues(parentItem);
									}

									if (this.config.value_suggest != null) {
										var fn = Function("obj", "id", this.config.value_suggest);
										fn(obj, this.config.id);
									}
								}
							}
						};



						item.on.onKeyPress = function (code, e) {
							if (e.code == "F2") {

								var suggest = $$(this.config.suggest);
								var refid = suggest.config.body.refid;

								suggest.hide();

								// var sql = "SELECT a.*,b.window_id as WINDOWNO FROM wb_references a INNER JOIN wb_window b ON a.wb_window_id=b.wb_window_id  WHERE a.wb_references_id='" + refid + "'";
								// var url = app.config.host + "/System/ExecuteQuery?sql=" + sql;
								var url = app.config.host + "/System/ExeCmd";
								var dataPost = {
									cmd: "CM0002",
									param: {
										wb_references_id: refid
									}
								};
								var win = this.getTopParentView();
								var form = win.getChildViews()[1];

								var editorId = this.config.id;
								var formId = form.config.id;

								var a = webix.ajax().headers({ 'Content-type': 'application/json' }).post(url, dataPost);
								var b = this.config.suggest;
								var c = this.config.id;
								var d = this.config.fieldExpression;
								var e = editorId;
								var f = formId;


								webix.promise.all([a, b, c, d, e, f]).then(function (results) {
									var res_a = results.data[0].json();
									var suggest = $$(results[1]);

									suggest.hide();

									var url = app.config.host + "/System/GetConfigWinByNo?id=" + res_a[0]["WINDOWNO"];

									var ajax = webix.ajax();
									ajax.master = {
										searchId: results[2],
										fieldExpression: d,
										valueField: res_a[0]["value_field"],
										formId: f,
										editorId: e
									};

									ajax.get(url, function (text) {
										var windowconfig = JSON.parse(text);
										var txtSearch = $$(this.searchId);
										var win = txtSearch.$scope.ui(selectwindow.$ui);

										win.config.valueField = this.valueField;
										win.config.fieldExpression = this.fieldExpression;
										win.config.formId = this.formId;
										win.config.editorId = this.editorId;

										selectwindow.initUI(windowconfig);

										win.getHead().setHTML(windowconfig.data[0].window_name);
										win.show();

									});


								});


								var win = this.$scope.ui(selectwindow.$ui);
								win.show();
							}

							if (e.code == "F4" || e.code == "F3") {

								var editmode = e.code == "F3" ? 2 : 1;
								showEditWindow(this, editmode);
							}
						};
					}
					if (item.value_change != null || item.css != null || item.validate != null) {
						item.on.onChange = function (newv, oldv) {

							if (this.config.validate != null && editmode != 0) {
								this.validate();
							}

							if (this.config.css != null) {
								if (this.config.css == "mcls_uppercase" && newv !== undefined && oldv !== undefined) {
									if (newv.toUpperCase() != oldv.toUpperCase()) {
										webix.$$(this.config.id).setValue(newv.toUpperCase());
									}

								}
							}

							if (this.config.value_change != null) {
								var topParentView = this.getTopParentView();

								if (topParentView.config.editmode == 0) return;

								var fn = Function("newv", "oldv", "id", this.config.value_change);
								fn(newv, oldv, this.config.id);
							}
						}
					}
					el[row - 1].cols.push(item);
					//console.log(el);
				}
			}
			if (vc_window.window_type == "MasterDetail") {

				var cells = [];

				for (var i = 0; i < tabs.length; i++) {
					var tab = tabs[i];

					if (tab.tab_type == "Master") {
						continue;
					}

					var subCols = [];
					var stt = { id: "idx", header: "", width: 30 };
					subCols.push(stt);
					for (var j = 0; j < tab.Fields.length; j++) {
						var field = tab.Fields[j];

						var subCol = {
							id: field.column_name,
							header: field.caption != null ? _(field.caption) : _(field.column_name),
							editor: field.type_editor,
							hidden: field.hidden,
							editable: true,
							value_change: field.value_change,
							// AITS
							template: field.template != null ? field.template : null
						};

						if (field.column_name == "inv_discountAmount" || field.column_name == "inv_discountPercentage") {
							subCol.hidden = true;
						}

						if (field.read_only == "C" || field.type_editor == "checkbox") {
							delete subCol.editor;
						}

						if (field.type_editor == "checkbox") {
							subCol.template = "{common.checkbox()}";
							subCol.checkValue = true;
							subCol.uncheckValue = false;
						}


						if (field.column_type == "date" || field.column_type == "datetime") {
							subCol.format = function (text) {
								if (text != null && text != undefined) {
									var format = webix.Date.dateToStr("%d/%m/%Y");
									text = removeTimeZoneT(text);
									return format(text);
								}
							};
						}

						if (field.column_type == "decimal") {
							subCol.css = { "text-align": "right" };
							subCol.format = webix.Number.numToStr({
								groupDelimiter: ".",
								groupSize: 3,
								decimalDelimiter: ",",
								decimalSize: field.data_decimal
							});

							if (field.type_editor == "autonumeric") {
								if (field.data_decimal >= 0) {
									var decimal = Array(field.data_decimal + 1).join("9");

									subCol.numericConfig = {
										maximumValue: Number("999999999999999." + decimal),
										minValue: Number("-999999999999999." + decimal),
										decimalPlaces: field.data_decimal
									};
								}
							}
						}

						if (field.column_width == null) {
							subCol.fillspace = true;
						}
						else {
							subCol.width = field.column_width;
						}

						if (field.type_editor == "combo" || field.type_editor == "multiselect") {
							subCol.options = app.config.host + "/System/GetDataByReferencesId?id=" + field.ref_id
							subCol.optionslist = true;
						}

						if (field.type_editor == "datepicker") {
							subCol.editor = "date";
						}

						if (field.type_editor == "treesuggest") {
							var listColumns = JSON.parse(field.list_column);

							for (var v = 0; v < listColumns.length; v++) {
								listColumns[v].header = _(listColumns[v].id);
							}

							var popup = webix.ui({
								view: "treesuggest",
								body: {
									columns: listColumns,
									refid: field.ref_id,
									url: {
										$proxy: true,
										load: function (view, callback, params) {
											var url = app.config.host + "/System/GetDataByReferencesId?id=" + view.config.refid;
											webix.ajax(url, function (text) {
												var json = JSON.parse(text);
												var data = listToTree(json);
												view.parse(data, "json");
											});
										}
									},
									filterMode: {
										level: false,
										showSubItems: false
									}
								}
							});

							subCol.popup = popup;
							subCol.editor = "combo";

						}

						if (field.type_editor == "gridcombo") {
							var listColumns = JSON.parse(field.list_column);

							for (var v = 0; v < listColumns.length; v++) {
								listColumns[v].header = _(listColumns[v].id);
							}

							var popup = webix.ui({
								view: "gridsuggest",
								textValue: field.display_field,
								body: {
									columns: listColumns,
									refid: field.ref_id,
									textValue: field.display_field,
									tableId: "edit_" + tab.tab_table,
									url: app.config.host + "/System/GetDataByReferencesId?id=" + field.ref_id
								}
							});

							subCol.popup = popup;
							subCol.editor = "combo";


						}
						if (field.type_editor == "search") {
							subCol.onSearchIconClick = function (e) {
								var form = $$(this.getFormView());
								var field_express = this.config.fieldExpression;
								var text = this.getValue();
								var datapost = { "masothue": text };
								webix.ajax()
									.headers({ 'Content-type': 'application/json' })
									.post(app.config.host + "/Pattern/GetInfoMST", datapost, function (text) {
										var json = JSON.parse(text);
										if (!json.hasOwnProperty("error")) {
											//console.log(JSON.stringify(json));
											form.setValues(json);
										}
										else {
											// nếu không tồn tại mã số thuế phải xóa địa chỉ + tên cty ở đây 
											webix.message(json.error, "error", 2000);
										}
									});
							}
						}
						if (field.type_editor == "gridsuggest") {
							var listColumns = JSON.parse(field.list_column);

							for (var v = 0; v < listColumns.length; v++) {
								listColumns[v].header = _(listColumns[v].id.toUpperCase());
							}

							subCol.editor = "textsearch";
							subCol.tableId = "edit_" + tab.tab_table;
							subCol.onIconButtonClick = function (e) {
								var tableId = this.getAttribute("tableId");
								var table = $$(tableId);
								tableShowEditWindow(table, 1);
							};

							subCol.suggest = {
								view: "gridsuggest",
								value_suggest: field.value_suggest,
								fieldExpression: field.field_expression,
								displayField: field.display_field,
								tableId: "edit_" + tab.tab_table,
								columnName: field.column_name,
								body: {
									columns: listColumns,
									refid: field.ref_id,
									scroll: true,
									autoheight: false,
									datatype: "json",
									dataFeed: function (filtervalue, filter) {
										if (filtervalue.length < 1) return;

										var refid = this.config.refid;
										var pathUrl = app.config.host + "/System/GetDataByReferencesId?id=" + refid;
										var urldata = "filtervalue=" + encodeURIComponent(filtervalue);

										this.load(pathUrl + "&" + urldata, this.config.datatype);
									}
								},
								on: {
									onValueSuggest: function (obj) {

										if (this.config.fieldExpression != null) {
											var table = $$(this.config.tableId);
											var selectedItem = table.getSelectedItem();

											var fields = this.config.fieldExpression.split(';');

											for (var i = 0; i < fields.length; i++) {
												var field = fields[i].replace("{", "").replace("}", "");
												var array = field.split(":");

												selectedItem[array[1]] = obj[array[0]];
											}

											table.updateItem(selectedItem.id, selectedItem);
										}

										if (this.config.value_suggest != null) {
											var fn = Function("obj", "id", this.config.value_suggest);
											fn(obj, this.config.id);
										}
									}

								}
							}
						}

						subCols.push(subCol);
					}

					if (tab.tab_type == "Detail") {
						var item = {
							header: tab.tab_name,
							select: "cell",
							body: {
								rows: [
									{
										id: "nampv",
										css: { "padding-bottom": "5px !important" },
										// view: "toolbar",
										// height: 28,
										cols: [
											{
												view: "button", type: "htmlbutton", width: 65,
												label: '<i class="fa fa-plus fa-lg" aria-hidden="true"></i> ' +
													'<span class="text">' + " (F9)" + '</span>',
												// id: "btnPrint",
												// view: "button", type: "icon",
												// //view: "icon",
												id: "addrow",
												// label: " (F9)",
												// width: 60,
												// icon: "fas fa-plus",
												css: "btnForm",
												//css: { "font-size": "15px" },
												on: {
													onItemClick: function (id, e) {
														var parentView = this.getParentView().getParentView();
														var childViews = parentView.getChildViews();

														for (var i = 0; i < childViews.length; i++) {
															var childview = childViews[i];

															if (childview.config.view == "datatable") {
																var table = childview;

																var item = {
																	id: webix.uid()
																};

																var vc_window = windowconfig['data'][0];
																var tabs = vc_window.Tabs;

																for (var i = 0; i < tabs.length; i++) {
																	var tab = tabs[i];
																	if (tab.tab_type == "Detail") {
																		var fields = tab.Fields;

																		for (var j = 0; j < fields.length; j++) {
																			var field = fields[j];

																			if (field.column_name == "ma_dvcs") {
																				item[field.column_name] = user.getDvcsID();
																			}

																			if (field.default_value != null) {
																				var defaultValue = field.default_value.toString();

																				if (defaultValue.startsWith("@Default=")) {
																					item[field.column_name] = defaultValue.replace("@Default=", "");
																				}

																				if (defaultValue.startsWith("@JS=")) {
																					var fn = Function(defaultValue.replace("@JS=", ""));
																					item[field.column_name] = fn();
																				}
																			}
																		}
																	}
																}

																table.add(item);

																table.select(item.id, table.config.columns[1].id, false);
																table.edit({ row: item.id, column: table.config.columns[1].id });

																break;
															}
														}

													}
												}
											},
											{
												view: "button", type: "htmlbutton", width: 65,
												label: '<i class="fa fa-minus fa-lg" aria-hidden="true"></i> ' +
													'<span class="text">' + " (F8)" + '</span>',
												// view: "button",
												id: "removerow",
												// type: "icon",
												// //view: "icon",
												// label: " (F8)",
												// width: 60,
												css: "btnForm",
												// icon: "fas fa-minus",
												on: {
													onItemClick: function (id, e) {
														var parentView = this.getParentView().getParentView();
														var childViews = parentView.getChildViews();

														for (var i = 0; i < childViews.length; i++) {
															var childview = childViews[i];

															if (childview.config.view == "datatable") {
																var table = childview;

																table.editStop();

																var item = table.getSelectedItem();

																if (!webix.isUndefined(item)) {
																	table.remove(item.id);
																	table.clearSelection();
																	return;
																}

																var editor = table.getEditState();

																if (!webix.isUndefined(editor)) {
																	table.remove(editor.row);
																	table.clearSelection();
																	return;
																}

																break;
															}
														}

													}
												}
											},
											{
												view: "button", type: "htmlbutton", width: 65,
												label: '<i class="fa fa-copy fa-lg" aria-hidden="true"></i> ' +
													'<span class="text">' + " (F7)" + '</span>',
												view: "button",
												id: "copyrow",
												// type: "icon",
												//view: "icon",
												// label: " (F7)",
												// width: 60,
												// icon: "fas fa-copy",
												css: "btnForm",
												on: {
													onItemClick: function (id, e) {
														var parentView = this.getParentView().getParentView();
														var childViews = parentView.getChildViews();

														for (var i = 0; i < childViews.length; i++) {
															var childview = childViews[i];

															if (childview.config.view == "datatable") {
																var table = childview;

																table.editStop();

																var item = table.getSelectedItem();
																if (item == null || item == undefined) {
																	webix.message("Bạn chưa chọn dòng cần copy !", "error");
																	return;
																}
																//item.id = webix.uid();
																var copy = webix.copy(item);
																copy.id = webix.uid();
																copy[tab.tab_table + "_id"] = null;

																table.add(copy);
																table.unselect(item.id);
																table.select(copy.id, table.config.columns[0].id, false);
																table.edit({ row: copy.id, column: table.config.columns[0].id });

																break;
															}
														}

													}
												}
											},
											{
												view: "checkbox",
												id: "check_chietkhau",
												// autowidth: true,
												width: 100,
												value: 0,
												labelRight: _("Chiết khấu"),
												labelWidth: 2,
												tooltip: "Tích vào đây nếu hóa đơn có chiết khấu",
												on: {
													onChange: function (newv, oldv) {
														if (newv == 1) {
															$$("edit_" + tab.tab_table).showColumn("inv_discountAmount");
															$$("edit_" + tab.tab_table).showColumn("inv_discountPercentage");
														}
														else {
															$$("edit_" + tab.tab_table).hideColumn("inv_discountAmount");
															$$("edit_" + tab.tab_table).hideColumn("inv_discountPercentage");
														}
													}
												}
											},
											{
												view: "checkbox",
												id: "check_tienthue",
												autowidth: true,
												value: checkbox_thue,
												labelRight: _("Tính thuế theo mặt hàng"),
												labelWidth: 2,
												tooltip: "Tích vào đây để thay đổi cách tính tiền thuế",
												on: {
													onChange: function (newv, oldv) {
														// console.log(this.getValue());
														// console.log(newv);
														// if(newv == 0)
														// {
														// 	$$("check_tienthue").define("labelRight", "Tính thuế theo tổng tiền hàng");
														// 	$$("check_tienthue").refresh();
														// }
														// if(newv == 1)
														// {
														// 	$$("check_tienthue").define("labelRight", "Tính thuế theo mặt hàng");
														// 	$$("check_tienthue").refresh();
														// }
														var form = $$("window-form");
														var values = form.getValues();
														var currency = values["inv_currencyCode"];
														var tableDetail = $$("edit_inv_InvoiceAuthDetail");

														if (newv == 0) {
															tableDetail.hideColumn("inv_vatAmount");
															tableDetail.hideColumn("inv_TotalAmount");
														}
														else {
															tableDetail.showColumn("inv_vatAmount");
															tableDetail.showColumn("inv_TotalAmount");
														}

														var inv_TotalAmountWithoutVat = 0;
														var inv_discountAmount = 0;
														var inv_vatAmount = 0;
														var inv_TotalAmount = 0;

														// Lấy phần thập phân ở danh mục ngoại tệ
														var table_decimalPlaces = {
															inv_quantity: 0,
															inv_TotalAmountWithoutVat: 0,
															inv_vatAmount: 0,
															inv_TotalAmount: 0
														}

														tableDetail.eachColumn(function (columnId) {
															var a = columnId.toString();
															if (a == "inv_quantity" || a == "inv_TotalAmountWithoutVat" || a == "inv_vatAmount" || a == "inv_TotalAmount") {
																var b = tableDetail.getColumnConfig(a).numericConfig.decimalPlaces;
																if (b != null) {
																	table_decimalPlaces[a] = b;
																}

															}
														});
														//End call dmnt

														var dataDetail = tableDetail.serialize();
														if (dataDetail.length > 0) {
															var maThue = dataDetail[0].hasOwnProperty("ma_thue") ? Number(dataDetail[0].ma_thue) : 0;
															for (var i = 0; i < dataDetail.length; i++) {
																var row = dataDetail[i];
																var check_giam_tru = row.hasOwnProperty("check_giam_tru") ? row.check_giam_tru : false;

																if (row.hasOwnProperty("inv_TotalAmountWithoutVat")) {
																	var value = row.inv_TotalAmountWithoutVat == null ? 0 : Number(row.inv_TotalAmountWithoutVat);
																	value = check_giam_tru === true ? -1 * value : value;
																	inv_TotalAmountWithoutVat = currency == "VND" ? Math.round(inv_TotalAmountWithoutVat + value) : inv_TotalAmountWithoutVat + value;
																}

																if (row.hasOwnProperty("inv_discountAmount")) {
																	var value = row.inv_discountAmount == null ? 0 : Number(row.inv_discountAmount);
																	inv_discountAmount = currency == "VND" ? Math.round(inv_discountAmount + value) : inv_discountAmount + value;
																}

																if (row.hasOwnProperty("inv_vatAmount")) {
																	var value = row.inv_vatAmount == null ? 0 : Number(row.inv_vatAmount);
																	value = check_giam_tru === true ? -1 * value : value;
																	inv_vatAmount = currency == "VND" ? Math.round(inv_vatAmount + value) : inv_vatAmount + value;
																}
																if (row.hasOwnProperty("inv_TotalAmount")) {
																	var value = row.inv_TotalAmount == null ? 0 : Number(row.inv_TotalAmount);
																	value = check_giam_tru === true ? -1 * value : value;
																	inv_TotalAmount = currency == "VND" ? Math.round(inv_TotalAmount + value) : inv_TotalAmount + value;
																}
															}

															if (newv == 0) {
																inv_vatAmount = (inv_TotalAmountWithoutVat * Math.abs(maThue) / 100).toFixed(table_decimalPlaces.inv_vatAmount);
																inv_TotalAmount = parseFloat(inv_TotalAmountWithoutVat) + parseFloat(inv_vatAmount) - inv_discountAmount;
															}

															values["inv_vatAmount"] = inv_vatAmount;
															values["inv_discountAmount"] = inv_discountAmount;
															values["inv_TotalAmount"] = inv_TotalAmount;
															form.setValues(values);
														}
														// if (newv == 1) {
														// 	$$("edit_" + tab.tab_table).showColumn("inv_discountAmount");
														// 	$$("edit_" + tab.tab_table).showColumn("inv_discountPercentage");
														// }
														// else {
														// 	$$("edit_" + tab.tab_table).hideColumn("inv_discountAmount");
														// 	$$("edit_" + tab.tab_table).hideColumn("inv_discountPercentage");
														// }
													}
												}
											}

											// {
											// 	view: "button", type: "htmlbutton", width: 65,
											// 	label: '<i class="fa fa-plus fa-lg" aria-hidden="true"></i> ' +
											// 	'<span class="text">' + " (F10)" + '</span>',
											// 	// id: "btnPrint",
											// 	// view: "button", type: "icon",
											// 	// //view: "icon",
											// 	id: "addnewRow",
											// 	// label: " (F9)",
											// 	// width: 60,
											// 	// icon: "fas fa-plus",
											// 	css: "btnForm",
											// 	//css: { "font-size": "15px" },
											// 	on: {
											// 		onItemClick: function (id, e) {
											// 			var parentView = this.getParentView().getParentView();
											// 			var childViews = parentView.getChildViews();

											// 			for (var i = 0; i < childViews.length; i++) {
											// 				var childview = childViews[i];

											// 				if (childview.config.view == "datatable") {
											// 					var table = childview;

											// 					var item = {
											// 						id: webix.uid()
											// 					};

											// 					var vc_window = windowconfig['data'][0];
											// 					var tabs = vc_window.Tabs;

											// 					for (var i = 0; i < tabs.length; i++) {
											// 						var tab = tabs[i];
											// 						if (tab.tab_type == "Detail") {
											// 							var fields = tab.Fields;

											// 							for (var j = 0; j < fields.length; j++) {
											// 								var field = fields[j];

											// 								if (field.column_name == "ma_dvcs") {
											// 									item[field.column_name] = user.getDvcsID();
											// 								}

											// 								if (field.default_value != null) {
											// 									var defaultValue = field.default_value.toString();

											// 									if (defaultValue.startsWith("@Default=")) {
											// 										item[field.column_name] = defaultValue.replace("@Default=", "");
											// 									}

											// 									if (defaultValue.startsWith("@JS=")) {
											// 										var fn = Function(defaultValue.replace("@JS=", ""));
											// 										item[field.column_name] = fn();
											// 									}
											// 								}
											// 							}
											// 						}
											// 					}

											// 					table.add(item);

											// 					table.select(item.id, table.config.columns[1].id, false);
											// 					table.edit({ row: item.id, column: table.config.columns[1].id });

											// 					break;
											// 				}
											// 			}

											// 		}
											// 	}
											// }
										]
									},
									{
										view: "datatable",
										resizeColumn: true,
										id: "edit_" + tab.tab_table,
										tab_table: tab.tab_table,
										tab_id: tab.tab_id,
										editable: true,
										select: "cell",
										drag: true,
										select_change: tab.select_change,
										cell_editstop: tab.cell_editstop,
										after_addrow: tab.after_addrow,
										after_delrow: tab.after_delrow,
										// AITS
										on_itemclick: tab.on_itemclick,
										// End AITS
										oncheck: tab.oncheck,
										columns: subCols,
										on: {
											"data->onStoreUpdated": function () {
												this.data.each(function (obj, i) {
													obj.idx = i + 1;
												})
											},
											onCheck: function (row, column, state) {
												var table = this;

												if (this.config.oncheck != null) {
													var fn = Function("row", "column", "state", "tableId", this.config.oncheck);
													fn(row, column, state, this.config.id);
												}
											},
											onAfterAdd: function (id, index) {
												if (this.config.after_addrow != null) {
													var fn = Function("id", "index", "tableId", this.config.after_addrow);
													fn(id, index, this.config.id);
												}
											},
											onAfterDelete: function (id) {
												if (this.config.after_delrow != null) {
													var fn = Function("id", "tableId", this.config.after_delrow);
													fn(id, this.config.id);
												}
											},
											onAfterEditStop: function (state, editor, ignore) {

												if (state.value === state.old) return;

												if (editor.config.value_change != null) {
													var selectedItem = null;

													if (typeof editor.getPopup === "function") {
														var popup = editor.getPopup();

														if (popup != null) {
															var list = popup.getList();

															if (list != null) {
																selectedItem = list.getSelectedItem();
															}
														}
													}

													var fn = Function("newv", "oldv", "id", "selectedItem", "rowId", editor.config.value_change);
													fn(state.value, state.old, editor.config.id, selectedItem, editor.row);
												}

												if (this.config.cell_editstop != null) {
													var fn = Function("columnId", "tableId", "rowId", this.config.cell_editstop);
													fn(editor.config.id, this.config.id, editor.row);
												}
												// var table = webix.$$("edit_" + tab.tab_table);
												// table.editStop();
											},
											onBeforeEditStart: function (id) {
												var it = this.getItem(id.row);
												var table = webix.$$("windowData");
												var item = table.getSelectedItem();
												var form = $$("window-form").getValues();
												if (item != null && item != undefined) {
													if (windowno == "WIN00187" || windowno == "WIN00193" || windowno == "WIN00189" || windowno == "WIN00192" || windowno == "WIN00194" || windowno == "WIN00195") {
														if (form.trang_thai_hd == "19" || form.trang_thai_hd == "21" || form.trang_thai_hd == "23" || form.trang_thai_hd == "3") {
															return;
														}
														if (item.hasOwnProperty("trang_thai")) {
															if (item.trang_thai == "Đã ký") {
																return false;
															}
														}
													}
												}
											},
											// onKeyDown: function(code, e)
											// {
											// 		if (e.key == 40) {
											// 		var toolbar = this.getParentView().getChildViews()[0];
											// 		var btnPlus = toolbar.getChildViews()[0];
											// 		console.log(btnPlus);
											// 		btnPlus.callEvent("onItemClick");
											// 	}
											// },
											onKeyPress: function (code, e) {
												var table = this;

												if (e.key == "F8") {
													var toolbar = this.getParentView().getChildViews()[0];
													var btnMinus = toolbar.getChildViews()[1];

													btnMinus.callEvent("onItemClick");
												}
												if (e.key == "F9") {
													var toolbar = this.getParentView().getChildViews()[0];
													var btnPlus = toolbar.getChildViews()[0];

													btnPlus.callEvent("onItemClick");
												}
												if (e.key == "F7") {
													var toolbar = this.getParentView().getChildViews()[0];
													var btnCopy = toolbar.getChildViews()[2];

													btnCopy.callEvent("onItemClick");
												}

												if (e.key == "F2") {

													var editor = table.getEditState();

													if (editor === false) return;

													var suggest = $$(editor.config.suggest);
													var refid = suggest.config.body.refid;

													// var sql = "SELECT a.*,b.window_id as WINDOWNO FROM wb_references a INNER JOIN wb_window b ON a.wb_window_id=b.wb_window_id  WHERE a.wb_references_id='" + refid + "'";
													// var url = app.config.host + "/System/ExecuteQuery?sql=" + sql;
													var url = app.config.host + "/System/ExeCmd";
													var dataPost = {
														cmd: "CM0002",
														param: {
															wb_references_id: refid
														}
													};

													var a = webix.ajax().headers({ 'Content-type': 'application/json' }).post(url, dataPost);
													var b = editor.config.suggest;
													var c = table.config.id;
													var d = suggest.config.fieldExpression;
													var e = editor.config.id;
													var f = suggest.config.displayField;
													//console.log(f);

													webix.promise.all([a, b, c, d, e, f]).then(function (results) {
														var res_a = results.data[0].json();
														//	console.log(res_a);
														var suggest = $$(results[1]);

														suggest.hide();

														var url = app.config.host + "/System/GetConfigWinByNo?id=" + res_a[0]["WINDOWNO"];

														var ajax = webix.ajax();
														ajax.master = {
															tableId: results[2],
															fieldExpression: d,
															valueField: res_a[0]["value_field"],
															editorId: null,
															columnName: e,
															displayField: f
														};

														ajax.get(url, function (text) {
															var windowconfig = JSON.parse(text);
															var table = $$(this.tableId);
															//console.log(windowconfig);
															var win = table.$scope.ui(selectwindow.$ui);

															win.config.valueField = this.valueField;
															win.config.fieldExpression = this.fieldExpression;
															win.config.tableId = this.tableId;
															win.config.editorId = null;
															win.config.columnName = this.columnName;
															win.config.displayField = this.displayField;

															selectwindow.initUI(windowconfig);

															win.getHead().setHTML(windowconfig.data[0].window_name);
															win.show();
														});
													});
													var win = this.$scope.ui(selectwindow.$ui);
													win.show();
												}

												if (e.key == "F4" || e.key == "F3") {
													var editor = table.getEditState();

													if (editor === false) {
														var toolbar = this.getParentView().getChildViews()[0];
														//console.log(toolbar);
														var btnPlus = toolbar.getChildViews()[0];
														//console.log(btnPlus);
														btnPlus.callEvent("onItemClick");
														return;

													}
													var editmode = e.key == "F3" ? 2 : 1;
													tableShowEditWindow(table, editmode);
												}
											},
											onSelectChange: function () {
												var selectedItem = this.getSelectedId();

												if (this.config.select_change != null) {
													var fn = Function("selectedItem", this.config.select_change);
													fn(selectedItem);
												}
											},
											onBeforeRender: function () {

											},
											onAfterRender: function () {
												// $$("addrow").callEvent("onItemClick");
												// this.eachColumn(function (columnid) {
												// 	if (columnid == "inv_discountAmount" || columnid == "inv_discountPercentage") {
												//  var colConfig = this.getColumnConfig(columnid);
												// this.hideColumn(columnid);
												// 	}
												// })
											},
											onAfterLoad: function () {
												// table chi tiết load ( trong TH sửa )
												var table = this;
												var data = table.serialize();

												data.forEach(function (entry) {
													if (entry["inv_discountAmount"] != undefined || entry["inv_discountPercentage"] != undefined) {
														if (entry["inv_discountAmount"] != 0 || entry["inv_discountPercentage"] != 0) {

															var ck = $$("check_chietkhau");
															if (ck != undefined) {
																ck.setValue(1);
																return false;
																// $$("edit_" + tab.tab_table).showColumn("inv_discountAmount");
																// $$("edit_" + tab.tab_table).showColumn("inv_discountPercentage");
															}
														}
													}
												});


											},
											// AITS
											onItemClick: function (id) {
												if (this.config.on_itemclick != null) {
													var fn = Function("id", "tableId", this.config.on_itemclick);
													fn(id, this.config.id);
												}

											}
										}
									}
								]
							}
						};
						cells.push(item);
					}
				}

				var subview = {
					borderless: true,
					view: "tabview",
					scrollX: true,
					cells: cells,
					tabbar: {
						width: 200
					}
				};

				if (vc_window.width != null || vc_window.height != null) {
					subview.height = 250;
				}

				//el.push(subview);

				var myJsonString = JSON.stringify(el);
				var x = findJson.getObjects(JSON.parse(myJsonString), "id", "tab_replace");
				//replace tab chi tiết
				if (x.length > 0) {
					var Y = x[0];
					//webix.extend(Y, subview, true);
					// cần cập nhật lại x[0] cho el

					for (var i = 0; i < el.length; i++) {
						if (el[i].id == "tab_replace") {
							//console.log(el[i]);
							el[i] = subview;
						}
					}
				}
				else {
					if (vc_window.row_tab != null) {
						el[vc_window.row_tab - 1] = subview;
					}
					else {
						el.push(subview);
					}
				}
			}

			var cols = [
				{},
				{
					shortcut: "F10",
					id: "btnSave",
					view: "button",
					label: "Nhận (F10)",
					type: "form",
					align: "center",
					width: 120,
					before_save: vc_window.before_save,
					on: {
						onClick: function () {
							var funClick = function () {
								var table = webix.$$("windowData");
								var form = webix.$$("window-form");
								if (table != null && table != undefined) {
									var item = table.getSelectedItem();

									if (item != null && item != undefined) {
										if (windowno == "WIN00187" || windowno == "WIN00193" || windowno == "WIN00189" || windowno == "WIN00192" || windowno == "WIN00194" || windowno == "WIN00195") {
											// if (form.trang_thai_hd != "19" && form.trang_thai_hd != "21" && form.trang_thai_hd != "23" && form.trang_thai_hd != "3") {
											// 	if (item.hasOwnProperty("trang_thai")) {
											// 		if (item.trang_thai == "Đã ký") {
											// 			webix.message("Hóa đơn đã ký, bạn không thể sửa !", "error");
											// 			return;
											// 		}
											// 	}
											// }
										}
									}
								}


								if (form.validate() == false) {
									return;
								}

								if (this.config.before_save != null) {
									var fn = Function(this.config.before_save);
									var result = fn();

									if (result == false)
										return;
								}

								var item = form.getValues();

								var khData = {};

								khData.windowid = String(rp['data'][0]['window_id']);
								khData.editmode = editmode;
								khData.data = [];

								var vc_window = rp['data'][0];

								if (vc_window.window_type == "MasterDetail") {

									var tabs = vc_window.Tabs;
									var details = [];

									for (var i = 0; i < tabs.length; i++) {
										var tab = tabs[i];

										if (tab.tab_type == "Detail") {
											var table = webix.$$("edit_" + tab.tab_table);
											console.log(table);
											var dataDetail = table.serialize();

											if (dataDetail.length > 0) {
												for (var i = 0; i < dataDetail.length; i++) {
													var item = dataDetail[i];
													item.dmngh_id = null;
													item.dmdt_id = null;

													table.updateItem(item.id, item);
												}
											};

											details.push({
												tab_id: tab.tab_id,
												tab_table: tab.tab_table,
												data: table.serialize()
											});
										}
									}

									item["details"] = details;
								}

								khData.data.push(item);

								this.getTopParentView().disable();
								this.getTopParentView().showProgress();

								webix.ajax()
									.headers({ 'Content-type': 'application/json' })
									.post(app.config.host + "/System/Save", khData, function (text) {

										var json = JSON.parse(text);

										$$(json.windowid).enable();
										$$(json.windowid).hideProgress();

										if (!json.hasOwnProperty("error")) {
											var after_save = $$(json.windowid).config.after_save;

											if (after_save != null) {
												//Function
												var fn = Function("editmode", "data", after_save);
												var kk = fn(editmode, json.data);
												// console.log(kk);
											}

											$$(json.windowid).close();
											app.callEvent("dataChanged", [editmode, json.data]);
										}
										else {
											webix.message(json.error, "error", 2000);
										}
									});
							};

							if (editmode == 2) {
								var frm = webix.ui({
									view: "window",
									modal: true,
									id: "window-esc",
									position: "center",
									move: true,
									padding: 30,
									css: { "border-radius": "6px" },
									// resize: true,
									// css: "headformchil",
									head: {
										height: 30,
										cols: [
											{
												id: "head-formDelete", view: "template", css: "headform", template: function (obj) {
													return '<div style ="float:left; font-size:15px;"><i style="padding-right:8px;" class="fa fa-edit"></i> Lưu dữ liệu<div/>';
												}
											},
											{
												view: "icon", icon: "fas fa-times", id: "help_formESC", tooltip: _("Đóng"), click: function () {
													$$("window-esc").close();
												}
											}
										]
									},
									body: {
										paddingY: 10,
										paddingX: 10,
										view: "form",
										id: "window-formesc",
										complexData: true,
										keepViews: true,
										multiview: { keepViews: true },
										margin: 0,
										elements: [
											{ view: "template", height: 80, template: "<div style='padding-top:10px;'><center>Bạn có chắc chắn muốn lưu dữ liệu đã sửa ?</center><div>" },
											{
												cols: [
													{},
													{
														id: "btnCo",
														view: "button",
														label: "Có",
														type: "form",
														align: "center",
														on: {
															onClick: function () {
																$$("window-esc").close();
																// $$("window-form").getTopParentView().close();
																var table = webix.$$("windowData");
																var form = webix.$$("window-form");
																if (table != null && table != undefined) {
																	var item = table.getSelectedItem();

																	if (item != null && item != undefined) {
																		if (windowno == "WIN00187" || windowno == "WIN00193" || windowno == "WIN00189" || windowno == "WIN00192" || windowno == "WIN00194" || windowno == "WIN00195") {
																			// if (form.trang_thai_hd != "19" && form.trang_thai_hd != "21" && form.trang_thai_hd != "23" && form.trang_thai_hd != "3") {
																			// 	if (item.hasOwnProperty("trang_thai")) {
																			// 		if (item.trang_thai == "Đã ký") {
																			// 			webix.message("Hóa đơn đã ký, bạn không thể sửa !", "error");
																			// 			return;
																			// 		}
																			// 	}
																			// }
																		}
																	}
																}


																if (form.validate() == false) {
																	return;
																}

																if (this.config.before_save != null) {
																	var fn = Function(this.config.before_save);
																	var result = fn();

																	if (result == false)
																		return;
																}

																var item = form.getValues();

																var khData = {};

																khData.windowid = String(rp['data'][0]['window_id']);
																khData.editmode = editmode;
																khData.data = [];

																var vc_window = rp['data'][0];

																if (vc_window.window_type == "MasterDetail") {

																	var tabs = vc_window.Tabs;
																	var details = [];

																	for (var i = 0; i < tabs.length; i++) {
																		var tab = tabs[i];

																		if (tab.tab_type == "Detail") {
																			var table = webix.$$("edit_" + tab.tab_table);

																			details.push({
																				tab_id: tab.tab_id,
																				tab_table: tab.tab_table,
																				data: table.serialize()
																			});
																		}
																	}

																	item["details"] = details;
																}

																khData.data.push(item);

																$$("window-form").getTopParentView().disable();
																$$("window-form").getTopParentView().showProgress();
																// this.getTopParentView().disable();
																// this.getTopParentView().showProgress();

																webix.ajax()
																	.headers({ 'Content-type': 'application/json' })
																	.post(app.config.host + "/System/Save", khData, function (text) {

																		var json = JSON.parse(text);

																		$$(json.windowid).enable();
																		$$(json.windowid).hideProgress();

																		if (!json.hasOwnProperty("error")) {
																			var after_save = $$(json.windowid).config.after_save;

																			if (after_save != null) {
																				//Function
																				var fn = Function("editmode", "data", after_save);
																				var kk = fn(editmode, json.data);
																				// console.log(kk);
																			}

																			$$(json.windowid).close();
																			app.callEvent("dataChanged", [editmode, json.data]);
																		}
																		else {
																			webix.message(json.error, "error", 2000);
																		}
																	});
															}
														},
														click: function () {
															$$("btnCo").callEvent("onClick");
														}
													},
													{
														view: "button", id: "btnKo", shortcut: "esc", label: "Không", type: "danger", align: "center",
														on: {
															onClick: function () {
																$$("window-esc").close();
															}
														},
														click: function () {
															this.callEvent("onClick");
														}
													},
													{}
												]
											}

										]
									}
								});

								frm.show();
							}
							else {
								var table = webix.$$("windowData");
								var form = webix.$$("window-form");
								if (table != null && table != undefined) {
									var item = table.getSelectedItem();

									if (item != null && item != undefined) {
										if (windowno == "WIN00187" || windowno == "WIN00193" || windowno == "WIN00189" || windowno == "WIN00192" || windowno == "WIN00194" || windowno == "WIN00195") {
											// if (form.trang_thai_hd != "19" && form.trang_thai_hd != "21" && form.trang_thai_hd != "23" && form.trang_thai_hd != "3") {
											// 	if (item.hasOwnProperty("trang_thai")) {
											// 		if (item.trang_thai == "Đã ký") {
											// 			webix.message("Hóa đơn đã ký, bạn không thể sửa !", "error");
											// 			return;
											// 		}
											// 	}
											// }
										}
									}
								}


								if (form.validate() == false) {
									return;
								}

								if (this.config.before_save != null) {
									var fn = Function(this.config.before_save);
									var result = fn();

									if (result == false)
										return;
								}

								var item = form.getValues();

								var khData = {};

								khData.windowid = String(rp['data'][0]['window_id']);
								khData.editmode = editmode;
								khData.data = [];

								var vc_window = rp['data'][0];

								if (vc_window.window_type == "MasterDetail") {

									var tabs = vc_window.Tabs;
									var details = [];

									for (var i = 0; i < tabs.length; i++) {
										var tab = tabs[i];

										if (tab.tab_type == "Detail") {
											var table = webix.$$("edit_" + tab.tab_table);
											var dataDetail = table.serialize();

											// set null id và foreignkey cho bảng detail trong trường hợp copy 
											if (dataDetail.length > 0) {
												for (var i = 0; i < dataDetail.length; i++) {
													var itemData = dataDetail[i];
													itemData[tab.tab_table + "_id"] = null;
													itemData[tab.foreign_key] = null;

													table.updateItem(itemData.id, itemData);
												}
											};

											details.push({
												tab_id: tab.tab_id,
												tab_table: tab.tab_table,
												data: table.serialize()
											});
										}
									}

									item["details"] = details;
								}

								khData.data.push(item);

								this.getTopParentView().disable();
								this.getTopParentView().showProgress();

								webix.ajax()
									.headers({ 'Content-type': 'application/json' })
									.post(app.config.host + "/System/Save", khData, function (text) {

										var json = JSON.parse(text);

										$$(json.windowid).enable();
										$$(json.windowid).hideProgress();

										if (!json.hasOwnProperty("error")) {
											var after_save = $$(json.windowid).config.after_save;

											if (after_save != null) {
												//Function
												var fn = Function("editmode", "data", after_save);
												var kk = fn(editmode, json.data);
												// console.log(kk);
											}

											$$(json.windowid).close();
											app.callEvent("dataChanged", [editmode, json.data]);
										}
										else {
											webix.message(json.error, "error", 2000);
										}
									});
							}
						}
					},
					click: function () {
						this.callEvent("onClick");

					},
				},
				{
					view: "button", id: "btnCancel", shortcut: "esc", label: "Hủy bỏ (ESC)", type: "danger", align: "center",
					width: 120,
					on: {
						onClick: function () {
							var frm = webix.ui({
								view: "window",
								modal: true,
								id: "window-esc",
								position: "center",
								move: true,
								padding: 30,
								css: { "border-radius": "6px" },
								// resize: true,
								// css: "headformchil",
								head: {
									height: 30,
									cols: [
										{
											id: "head-formDelete", view: "template", css: "headform", template: function (obj) {
												return '<div style ="float:left; font-size:15px;"><i style="padding-right:8px;" class="fa fa-sign-out"></i> Thoát<div/>';
											}
										},
										{
											view: "icon", icon: "fas fa-times", id: "help_formESC", tooltip: _("Đóng"), click: function () {
												$$("window-esc").close();
											}
										}
									]
								},
								body: {
									paddingY: 10,
									paddingX: 10,
									view: "form",
									id: "window-formesc",
									complexData: true,
									keepViews: true,
									multiview: { keepViews: true },
									margin: 0,
									elements: [
										{ view: "template", height: 80, template: "<div style='padding-top:10px;'><center><b style='color:red;'>Bạn có chắc chắn muốn thoát ?</b></center></br><center>(Lưu ý: bạn chưa lưu dữ liệu)</center><div>" },
										{
											cols: [
												{},
												{
													id: "btnCo",
													view: "button",
													label: "Có",
													type: "form",
													align: "center",
													on: {
														onClick: function () {
															if (tab != undefined && tab != null) {
																var table = webix.$$("edit_" + tab.tab_table);
																table.editStop();
															}
															$$("window-esc").close();
															$$("window-form").getTopParentView().close();
															//this.getTopParentView().close();
														}
													},
													click: function () {
														$$("btnCo").callEvent("onClick");
													}
												},
												{
													view: "button", id: "btnKo", shortcut: "esc", label: "Không", type: "danger", align: "center",
													on: {
														onClick: function () {
															$$("window-esc").close();
														}
													},
													click: function () {
														this.callEvent("onClick");
													}
												},
												{}
											]
										}

									]
								}
							});

							frm.show();

						}
					},
					click: function () {
						this.callEvent("onClick");
					}
				},
				{}
			];

			el.push({
				margin: 10,
				cols: cols
			});

			webix.ui(el, $$("window-form"));
			webix.$$("head-form").setValues({ title: windowconfig.data[0].window_name == undefined ? "" : windowconfig.data[0].window_name });
			$$("head-form").refresh();
			//  win.getHead().setHTML('<span>' + windowconfig.data[0].window_name + '</span><span class="nampvtest"><i class="fas fa-times" onclick=\"var form = webix.$$(\'window-form\'); webix.message(\'Click\',\'success\');\"></i></span>');
		},
		focusFirstElement: function () {
			var form = $$("window-form");
			form.focus(form.elements[0]);
		},
		setEditMode: function (mode) {
			editmode = mode;

			var form = webix.$$("window-form");
			var topParentView = form.getTopParentView();
			topParentView.config.editmode = mode;
			var icon = "";
			if (editmode == 1) {
				icon = "<span><i class='fa fa-plus' aria-hidden='true'></i></span>";
			}
			else {
				if (editmode == 2)
					icon = "<i class='fa fa-edit' aria-hidden='true'></i>";
				else
					icon = "<i class='fa fa-trash fa-lg' aria-hidden='true'></i>";
			}
			// var tit = webix.$$("head-form").getValues();
			// webix.$$("head-form").setValues({ title: icon + " " + tit.title });
			// webix.$$("head-form").refresh();
			webix.$$("head-icon").setHTML(icon);
			webix.$$("head-icon").refresh();
		},
		setValues: function (item, winconfig, params) {

			var form = webix.$$("window-form");
			var vc_window = winconfig['data'][0];

			if (item == null) {
				var tabs = vc_window.Tabs;

				item = {};

				if (params != null) {
					item = params;
				}

				for (var i = 0; i < tabs.length; i++) {
					var tab = tabs[i];
					if (tab.tab_type == "Normal" || tab.tab_type == "Master") {
						var fields = tab.Fields;

						for (var j = 0; j < fields.length; j++) {
							var field = fields[j];

							if (field.column_name == "ma_dvcs") {
								item[field.column_name] = user.getDvcsID();
							}


							if (field.default_value != null) {
								var defaultValue = field.default_value.toString();

								if (defaultValue.startsWith("@Default=")) {
									item[field.column_name] = defaultValue.replace("@Default=", "");
								}

								if (defaultValue.startsWith("@JS=")) {
									var fn = Function(defaultValue.replace("@JS=", ""));
									item[field.column_name] = fn();
								}
							}
						}
					}
				}

				form.setValues(item);
			}
			else {

				form.setValues(item);

				var tabs = vc_window.Tabs;

				for (var i = 0; i < tabs.length; i++) {
					var tab = tabs[i];

					if (tab.tab_type != "Detail") {
						var fields = tab.Fields;

						for (var j = 0; j < fields.length; j++) {
							var field = fields[j];
							//if (field.hidden != true) {
							if (field.column_type == "date" || field.column_type == "datetime") {
								if (item[field.column_name] != null && item[field.column_name] != undefined) {
									item[field.column_name] = removeTimeZoneT(item[field.column_name])
									form.setValues(item);
								}
							}
							//}
						}
						break;
					}
				}

				if (vc_window.window_type == "MasterDetail") {

					for (var i = 0; i < tabs.length; i++) {
						var tab = tabs[i];

						if (tab.tab_type == "Master") {
							continue;
						}

						var table = webix.$$("edit_" + tab.tab_table);

						var url = app.config.host + "/System/GetDataDetailsByTabTable?window_id=" + vc_window.window_id
							+ "&id=" + item.id + "&tab_table=" + tab.tab_table;
						table.clearAll();
						table.load(url);
					}
				}
			}
		},
		copyValues: function (item, winconfig) {

			var form = webix.$$("window-form");
			var vc_window = winconfig['data'][0];


			if (vc_window.window_type == "MasterDetail") {
				var tabs = vc_window.Tabs;

				for (var i = 0; i < tabs.length; i++) {
					var tab = tabs[i];

					if (tab.tab_type == "Master") {
						continue;
					}

					var table = webix.$$("edit_" + tab.tab_table);

					var url = app.config.host + "/System/GetDataDetailsByTabTable?window_id=" + vc_window.window_id
						+ "&id=" + item.id + "&tab_table=" + tab.tab_table;
					table.clearAll();
					table.load(url);

				}
			}

			var tabs = vc_window.Tabs;

			for (var i = 0; i < tabs.length; i++) {
				var tab = tabs[i];
				if (tab.tab_type == "Normal" || tab.tab_type == "Master") {
					var fields = tab.Fields;

					for (var j = 0; j < fields.length; j++) {
						var field = fields[j];

						if (field.column_name == tab.tab_table + "_id") {
							item[field.column_name] = null;
						}

						if (field.column_name == "ma_dvcs") {
							item[field.column_name] = user.getDvcsID();
						}


						if (field.default_value != null) {
							var defaultValue = field.default_value.toString();

							if (defaultValue.startsWith("@Default=")) {
								item[field.column_name] = defaultValue.replace("@Default=", "");
							}

							if (defaultValue.startsWith("@JS=")) {
								var fn = Function(defaultValue.replace("@JS=", ""));
								item[field.column_name] = fn();
							}
						}
					}
				}
			}

			form.setValues(item);

		}
	};
});
define('views/forms/detailreport',[
	"app",
	"locale",
	"views/forms/infowindow",
	"views/forms/window"
],function(app,_,infowindow,windowform){
	var editmode = 0;
	var tableId = 0;

	var contextmenu = webix.ui({
            view:"contextmenu",
            id:"ctxMenuDetail",
            on:{
                onMenuItemClick:function(id){
                    var item = this.getItem(id);

                    if (id=="SUACTGOCDETAIL"){
                        var table =this.getContext().obj;
                        var row = table.getSelectedItem();                        

                        var sql = "SELECT TOP 1 a.* FROM VC_WINDOW a WHERE a.ma_ct='"+row.MA_CT+"'";
                        var url = app.config.host + "/api/System/ExecuteQuery?sql=" + sql;

						var ajax = webix.ajax();
						ajax.master = table;

                        ajax.get(url,function(text){
                            var json = JSON.parse(text);
                            var data = json[0];
                            
                            var table = this;
                            var row = table.getSelectedItem();

                            var a = webix.ajax(app.config.host + "/api/System/GetDataById?window_id="+data.WINDOW_ID + "&id="+row.DOC_ID);
                            var b = webix.ajax(app.config.host + "/api/System/GetAllByWindowNo?window_id="+ data.WINDOW_ID);
							var c = table.config.id;

                            webix.promise.all([a,b,c]).then(function(results){
                                var a_result = results[0].json();
                                var windowconfig = results[1].json();

                                var vc_window = windowconfig["data"][0];
                                windowform.$ui.id = vc_window.WINDOW_ID;

                                var table = $$(c);
                                var detailForm = table.$scope.ui(windowform.$ui);
                            
                                var item = a_result.data[0];              
                                
                                windowform.initUI(windowconfig);
                                windowform.setEditMode(2);
                                windowform.setValues(item,windowconfig);
                                
                                detailForm.show();
                            });
                            
                        });
                    }
                    else {
                        var ctx =this.getContext();

                        detailreport.$ui.id = "dtrp_"+ item.MENU_ID;
                        detailreport.$ui.parentParameter = ctx.obj.config.rpParameter.parameters;
                        detailreport.$ui.parentRow = ctx.obj.getSelectedItem();

                        this.hide();

                        var win = ctx.obj.$scope.ui(detailreport.$ui);
                        detailreport.initUI(item);
                        win.show();
                    }
                    

                    
                }
            }
    });


	function initData(windowId,tableId,infoWindowId,report_id){

		var win = $$(windowId);
		var table = win.getChildViews()[1].getChildViews()[1];

		var menuitem = win.config.menuitem;

		var parentParamter = win.config.parentParameter;
		var parentRow = win.config.parentRow;

		infowindow.$ui.id = infoWindowId;
		infowindow.$ui.report_id = report_id;
		infowindow.$ui.editmode = 1;
		infowindow.$ui.load_event = "loadDetailReport";
		infowindow.$ui.menuitem = menuitem;

		var parameters = menuitem.PARAMETERS								
								.split(';');

		var item = {};

		for(var i=0;i<parameters.length;i++){
			var array = parameters[i]
								.replace("{","")
								.replace("}","")
								.split(':');

			if (array[0].toString()=="1"){
				item[array[2]] = parentParamter[array[1]];
			}

			if (array[0].toString()=="2"){
				item[array[2]] = parentRow[array[1]];
			}
		}

		table.config.rpParameter = {
			parameters : item
		};

		infowindow.$ui.formvalues = item;

		var wininfo = win.$scope.ui(infowindow.$ui);
		
		infowindow.initUI(infoWindowId);
		
		app.callEvent("loadDetailReport",[report_id,infoWindowId,item,menuitem]);
	}

	return {		
		$ui:{   
			view:"window", modal:true, 
			position:"center",
			head:"Thông tin Tab",
			fullscreen:true,
			body:{
				rows:[
					{
						view:"toolbar",
						height:35,
						cols:[
							{
								view:"button",
								type:"icon",
								icon:"refresh",
								label: _("REFRESH"),
								width:90,
								on: {
									onClick: function(){ 
										var win = this.getTopParentView();										
										var table = win.getChildViews()[1].getChildViews()[1];

										infowindow.$ui.id = table.config.infowindow_id;
										infowindow.$ui.report_id = table.config.report_id;
										infowindow.$ui.load_event = "loadDetailReport";
										infowindow.$ui.menuitem = win.config.menuitem;

										if (table.config.rpParameter!=null){									
											infowindow.$ui.editmode = 1;
											infowindow.$ui.formvalues = table.config.rpParameter.parameters;
										}
										else {
											infowindow.$ui.editmode = 0;
											infowindow.$ui.formvalues = null;
										}              

										var wininfoparam = this.$scope.ui(infowindow.$ui);

										infowindow.initUI(table.config.infowindow_id);              
										wininfoparam.show();                    
									}
								},
								click: function(){
									this.callEvent("onClick");
								}
							},
							{
								view:"button",
								type:"icon",
								icon:"print",
								label: _("PRINT"),
								width:40,
								click: function(){
									this.callEvent("onClick");
								},
								on: {
									onClick: function(){
										var win = this.getTopParentView();										
										var table = win.getChildViews()[1].getChildViews()[1];

										var rpParameter = table.config.rpParameter;
										
										rpParameter.type = "pdf";

										if (rpParameter!=null){
											webix.ajax()
												.response("arraybuffer")
												.headers({'Content-type':'application/json'})
												.post(app.config.host + "/api/System/CreateReport", rpParameter, function(text, data){
												var file = new Blob([data], {type: 'application/pdf'});
												var fileURL = URL.createObjectURL(file);
												window.open(fileURL,'_blank');
											});
										}
									}
								}
							},
							{
								view:"button",
								type:"icon",
								icon:"file",
								label: _("EXPORT"),
								width:80,
								click: function(){
									this.callEvent("onClick");
								},
								on: {
									onClick: function(){
										var win = this.getTopParentView();										
										var table = win.getChildViews()[1].getChildViews()[1];
										
										var rpParameter = table.config.rpParameter;
										rpParameter.type = "excel";

										if (rpParameter!=null){
											webix.ajax()
												.response("arraybuffer")
												.headers({'Content-type':'application/json'})
												.post(app.config.host + "/api/System/CreateReport", rpParameter, function(text, data){
												
												var file = new Blob([data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
												var fileURL = URL.createObjectURL(file);                        
																			
												window.location.href = fileURL;
											});
										}
									}
								}
							},
							{
								view:"button",
								type:"icon",
								icon:"close",
								label: _("EXIT"),
								width:80,
								click: function(){
									this.getTopParentView().close();
								}
							}
						]
					},
					{
						view:"datatable",
						scheme:{
							$change:function(item){
								if (item.BOLD == "C")
									item.$css = "rowBold";
							}
						},
						select: "row",
						on:{
							onBeforeContextMenu:function(id){
								var item = this.getItem(id);
								var mn = $$("ctxMenuDetail");

								if (item.DOC_ID!=null && item.MA_CT!=null){									
									var menuitem = mn.getItem("SUACTGOCDETAIL");
									if (menuitem==null){
										mn.add({id:"SUACTGOCDETAIL",value:"Sửa chứng từ"});
									}
								}
								else {
									mn.clearAll();
								}

								webix.delay(function(){
									this.clearSelection();
									this.select(id.row, id.column);
								},this);
							} 
						}
					}
				]
                
			}			
			
		},		
		setEditMode: function(mode) {
			editmode = mode;
		},
		setTableId: function(id){
			tableId = id;
		}, 
		initUI: function(item){
			var report_id = item.REPORT_ID;

			webix.$$("dtrp_" + item.MENU_ID).config.menuitem = item;			

			var sql = "SELECT a.*,b.INFOWINDOW_ID,'"+item.MENU_ID+"' as MENU_ID FROM VC_REPORTCOLUMN a "
					+" INNER JOIN VC_REPORT b ON b.id=a.VC_REPORT_id "
					+" WHERE a.VC_REPORT_id='"+report_id+"' ORDER BY a.SEQ_NO";

			var url=app.config.host + "/api/System/ExecuteQuery?sql=" + sql;
			
			webix.ajax(url,function(text){
				var json = JSON.parse(text);

				var win = webix.$$("dtrp_" + json[0]["MENU_ID"]);
				win.getHead().setHTML(win.config.menuitem.CAPTION);

				var table = win.getChildViews()[1].getChildViews()[1];
				table.config.rpParameter = null;
				table.clearAll();

				$$("ctxMenuDetail").attachTo(table);

				var cols=[];

				for(var i=0;i<json.length;i++){
					var col=json[i];

					var item = {
						id: col.REPORTCOLUMN_FIELD,
						header:"<center>" + _(col.REPORTCOLUMN_NAME) +"</center>",
						width: col.REPORTCOLUMN_WIDTH,
						hidden: col.HIDDEN == "C" ? true : false
					};

					if (col.HEADER!=null){
						if (col.HEADER!=""){
							var headers = JSON.parse(col.HEADER);

							for(var j=0;j<headers.length;j++){
								var hd = headers[j];
								if (hd!=null){
									hd.text = "<center>" + _(hd.text) +"</center>";
								}
							}

							item.header = headers;
						}
						
					}

					if (col.COLUMN_TYPE == "VC_DATE"){
						item.format = function(text) {
							var format = webix.Date.dateToStr("%d/%m/%Y");
							text = removeTimeZoneT(text);                            
							return format(text);
						};
					}

					if (col.COLUMN_TYPE == "VC_TYGIA" || col.COLUMN_TYPE == "VC_TIEN"){
						item.css = { "text-align" : "right" };
						item.format = webix.Number.numToStr({
								groupDelimiter:",",
								groupSize:3,
								decimalDelimiter:".",
								decimalSize:0
							});
					}

					cols.push(item);
				}

			
				table.config.columns = cols;
				table.config.report_id = json[0]["VC_REPORT_id"];
				table.config.infowindow_id = json[0]["INFOWINDOW_ID"];

				table.refreshColumns();	
				
				initData(win.config.id,table.config.id,json[0]["INFOWINDOW_ID"],json[0]["VC_REPORT_id"]);

			});
		},
		$oninit: function(view,$scope) {
			
			 $scope.on(app, "loadDetailReport", function(report_id,infoWindowId,item,menuitem){
				
                var win = $$(infoWindowId);
				var table = win.getChildViews()[1].getChildViews()[1];

                if (table.config.report_id == report_id){

                    var rpParameter={
                        parameters: item,
                        infowindow_id: infoWindowId,
                        type: "json",
                        report_id: report_id
                    };

                    table.config.rpParameter = rpParameter;

                    webix.ajax()
                        .headers({'Content-type':'application/json'})
                        .post( app.config.host + "/api/System/CreateReport", rpParameter, function(text){
                            var data = JSON.parse(text);

                            var table = $$("tblReport");
                            table.clearAll();
                            table.parse(data,"json");
                        });
                }

                
            });
        }
	};

});
define('views/baocaochitiet',[
    "app",
    "locale",
    "views/forms/infowindow",
    "views/forms/detailreport",
    "views/forms/window",
    "models/user"
], function (app, _, infowindow, detailreport, windowform, user) {
    'use strict';

    var windowno = app.path[1].params[0];

    var controls = [
        {
            id: "cbReport",
            view: "combo",
            width: 450,
            label: "Chọn báo cáo",

            labelWidth: 90,
            suggest: {
                url: {
                    $proxy: true,
                    load: function (view, callback, params) {
                        var windowno = app.path[1].params[0];
                        var url = app.config.host + "/System/ExecuteCommand";

                        var parameters = {
                            command: "CM00032",
                            parameter: {
                                // window_id: windowno,
                                username: user.getCurrentUser()
                            }
                        };

                        webix.ajax().bind(view)
                            .headers({ "Content-Type": "application/json" })
                            .post(url, parameters, callback);

                    }
                },
                template: "#report_name#",
                body: {
                    template: "#report_name#",
                    ready: function () {
                        $$("cbReport").setValue(this.getFirstId());
                    }
                }
            },
            on: {
                onChange: function () {
                    var report_id = this.getValue();

                    if (report_id == "") {
                        return;
                    }
                    var name = $$("cbReport").getText();

                    webix.$$("title").parse({ title: name, details: name, url_help: "http://huongdansudung.minvoice.com.vn/" });
                    initTable(report_id);
                    var btnReload = $$("btnReload");
                    btnReload.callEvent("onClick");
                }
            }
        },
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-refresh fa-lg" aria-hidden="true"></i> ' +
            '<span class="text">' + _("REFRESH") + '</span>',
            id: "btnReload",
            on: {
                onClick: function () {
                    //console.log($$("cbReport").getValue());
                    if ($$("cbReport").getValue() == null || $$("cbReport").getValue() == "") {
                        webix.message("Bạn chưa chọn báo cáo !", "error");
                        return;
                    }
                    var cbReport = webix.$$("cbReport");
                    var list = cbReport.getList();

                    var item = list.getItem(cbReport.getValue());

                    infowindow.$ui.id = item.wb_infowindow_id;
                    infowindow.$ui.report_id = cbReport.getValue();
                    infowindow.$ui.load_event = "loadReport";

                    if ($$("tblReport").config.rpParameter != null) {

                        infowindow.$ui.editmode = 1;
                        infowindow.$ui.formvalues = $$("tblReport").config.rpParameter.parameters;
                    }
                    else {
                        infowindow.$ui.editmode = 0;
                        infowindow.$ui.formvalues = null;
                    }

                    var wininfoparam = this.$scope.ui(infowindow.$ui);

                    infowindow.initUI(item.wb_infowindow_id);
                    wininfoparam.show();
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-print fa-lg" aria-hidden="true"></i> ' +
            '<span class="text">' + _("PRINT") + " PDF" + '</span>',
            id: "btnPrint",
            on: {
                onClick: function () {
                    var table = $$("tblReport");

                    var rpParameter = table.config.rpParameter;

                    if (rpParameter == undefined || rpParameter == null) {
                        webix.message("Bạn chưa chọn báo cáo hoặc chưa tải dữ liệu !", "error");
                        return;
                    }
                    rpParameter.type = "PDF";

                    if (rpParameter != null) {
                        var box = webix.modalbox({
                            title: "Đang in báo cáo ....",
                            text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                            width: 350,
                            height: 200
                        });

                        webix.ajax()
                            .response("arraybuffer")
                            .headers({ 'Content-type': 'application/json' })
                            .post(app.config.host + "/System/CreateReport", rpParameter,
                            {
                                error: function (text, data, XmlHttpRequest) {
                                    webix.modalbox.hide(box);
                                    webix.message(XmlHttpRequest.statusText, "error");
                                },
                                success: function (text, data, XmlHttpRequest) {
                                    var file = new Blob([data], { type: 'application/pdf' });
                                    var fileURL = URL.createObjectURL(file);
                                    webix.modalbox.hide(box);
                                    window.open(fileURL, '_blank');
                                }
                            }
                            // function (text, data) {
                            //     var file = new Blob([data], { type: 'application/pdf' });
                            //     var fileURL = URL.createObjectURL(file);
                            //     webix.modalbox.hide(box);
                            //     window.open(fileURL, '_blank');
                            // }
                            );
                    }
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {
            view: "button", type: "htmlbutton", width: 120,
            label: '<i class="fa fa-file-excel fa-lg" aria-hidden="true"></i> ' +
            '<span class="text">' + _("EXPORT_EXCEL") + '</span>',
            id: "btnExport",
            on: {
                onClick: function () {
                    var table = $$("tblReport");

                    var rpParameter = table.config.rpParameter;
                    if (rpParameter == undefined || rpParameter == null) {
                        webix.message("Bạn chưa chọn báo cáo hoặc chưa tải dữ liệu !", "error");
                        return;
                    }
                    rpParameter.type = "xlsx";

                    if (rpParameter != null) {
                        var box = webix.modalbox({
                            title: "Đang kết xuất Excel ....",
                            text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                            width: 350,
                            height: 200
                        });

                        webix.ajax()
                            .response("arraybuffer")
                            .headers({ 'Content-type': 'application/json' })
                            .post(app.config.host + "/System/CreateReport", rpParameter,
                            {
                                error: function (text, data, XmlHttpRequest) {
                                    webix.modalbox.hide(box);
                                    webix.message(XmlHttpRequest.statusText, "error");
                                },
                                success: function (text, data, XmlHttpRequest) {
                                    var file = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                                    var fileURL = URL.createObjectURL(file);
                                    webix.modalbox.hide(box);
                                    window.location.href = fileURL;
                                }
                            }
                            // function (text, data) {

                            //     var file = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                            //     var fileURL = URL.createObjectURL(file);

                            //     window.location.href = fileURL;
                            // }
                            );
                    }
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {
            view: "button", type: "htmlbutton", width: 120,
            label: '<i class="fa fa-file-text-o fa-lg" aria-hidden="true"></i> ' +
            '<span class="text">' + _("EXPORT_CSV") + '</span>',
            id: "btnExportCsv",
            on: {
                onClick: function () {
                    var table = $$("tblReport");

                    var rpParameter = table.config.rpParameter;
                    if (rpParameter == undefined || rpParameter == null) {
                        webix.message("Bạn chưa chọn báo cáo hoặc chưa tải dữ liệu !", "error");
                        return;
                    }
                    rpParameter.type = "CSV";

                    if (rpParameter != null) {
                        var box = webix.modalbox({
                            title: "Đang kết xuất Excel ....",
                            text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                            width: 350,
                            height: 200
                        });

                        webix.ajax()
                            .response("arraybuffer")
                            .headers({ 'Content-type': 'application/json' })
                            .post(app.config.host + "/System/CreateReport", rpParameter,
                            {
                                error: function (text, data, XmlHttpRequest) {
                                    webix.modalbox.hide(box);
                                    webix.message(XmlHttpRequest.statusText, "error");
                                },
                                success: function (text, data, XmlHttpRequest) {
                                    var file = new Blob([data], { type: 'application/csv' });
                                    webix.html.download(file, "minvoiceReport.csv");
                                    //var fileURL = URL.createObjectURL(file);
                                    webix.modalbox.hide(box);
                                    //window.location.href = fileURL;
                                }
                            }
                            // function (text, data) {

                            //     var file = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                            //     var fileURL = URL.createObjectURL(file);

                            //     window.location.href = fileURL;
                            // }
                            );
                    }
                }
            },
            click: function () {
                this.callEvent("onClick");
            }

        },
        {}
    ];

    var grid = {
        rows: [
            {
                id: "tblReport",
                view: "datatable",
                resizeColumn: true,
                footer: true,
                select: true,
                css: "report",
                columns: [{ id: "col1", width: 1, header: [null, null], headermenu: false, footer: null }],
                headermenu: {
                    width: 200,
                    autoheight: false,
                    scroll: true
                },
                scheme: {
                    $change: function (item) {
                        if (item.BOLD == "C")
                            item.$css = "rowBold";
                    }
                },
                pager: "pagerA",
                on: {
                    onBeforeContextMenu: function (id) {
                        var item = this.getItem(id);

                        if (item.DOC_ID != null && item.MA_CT != null) {
                            var mn = $$("ctxMenu");
                            var menuitem = mn.getItem("SUACTGOC");
                            if (menuitem == null) {
                                mn.add({ id: "SUACTGOC", value: "Sửa chứng từ" });
                            }
                        }

                        webix.delay(function () {
                            this.clearSelection();
                            this.select(id.row, id.column);
                        }, this);
                    }
                }
            },
            {
                cols: [
                    {
                        view: "icon", icon: "fas fa-question-circle", id: "help_form_viewsfile", tooltip: _("HELPER"),
                        css: "helper",
                        click: function () {
                            webix.alert({
                                title: "Thông báo !",
                                text: "Bạn chưa khai báo hướng dẫn nhanh cho màn hình này !",
                                type: "alert-warning",
                                callback: function (result) {
                                }
                            });
                        }
                    },
                    {
                        view: "combo",
                        label: _("MENU_QUICK"),
                        id: "QuickMenu1",
                        options: {
                            // view: "gridsuggest",
                            // id: "grid_window",
                            // template: "#name#",
                            // body: {
                            //     scroll: true,
                            //     autoheight: false,
                            //     columns: [
                            //         { id: "window_id", header: "Window Id", editor: "text", width: 100 },
                            //         { id: "name", header: "Window Name", editor: "text", width: 400 }
                            //     ],
                            //     url: app.config.host + "/System/GetQuickMenu"
                            // },
                            // on: {
                            //     onValueSuggest: function (obj) {
                            //         var start = obj.window_id != "" ? obj.code + ":" + obj.window_id : obj.code;
                            //         window.location.hash = "!/app/" + start;
                            //         $$("QuickMenu1").setValue(null);
                            //         $$("QuickMenu1").destructor();
                            //     }
                            // }
                        },
                        on: {
                            onChange: function (newv, oldv) {

                            }
                        }
                    },
                    {},
                    {
                        id: "pagerA",
                        view: "pager",
                        size: 1000,
                        group: 5,
                        template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}"
                    }
                ]
            }
        ]
    }

    var contextmenu = webix.ui({
        view: "contextmenu",
        id: "ctxMenu",
        on: {
            onMenuItemClick: function (id) {
                var item = this.getItem(id);

                if (id == "SUACTGOC") {
                    var table = $$("tblReport");
                    var row = table.getSelectedItem();

                    var sql = "SELECT TOP 1 a.* FROM VC_WINDOW a WHERE a.ma_ct='" + row.MA_CT + "'";
                    var url = app.config.host + "/api/System/ExecuteQuery?sql=" + sql;

                    webix.ajax(url, function (text) {
                        var json = JSON.parse(text);
                        var data = json[0];

                        var table = $$("tblReport");
                        var row = table.getSelectedItem();

                        var a = webix.ajax(app.config.host + "/api/System/GetDataById?window_id=" + data.WINDOW_ID + "&id=" + row.DOC_ID);
                        var b = webix.ajax(app.config.host + "/api/System/GetAllByWindowNo?window_id=" + data.WINDOW_ID);

                        webix.promise.all([a, b]).then(function (results) {
                            var a_result = results[0].json();
                            var windowconfig = results[1].json();

                            var vc_window = windowconfig["data"][0];
                            windowform.$ui.id = vc_window.WINDOW_ID;

                            var table = $$("tblReport");
                            var detailForm = table.$scope.ui(windowform.$ui);

                            var item = a_result.data[0];

                            windowform.initUI(windowconfig);
                            windowform.setEditMode(2);
                            windowform.setValues(item, windowconfig);

                            detailForm.show();
                        });

                    });
                }
                else {
                    var ctx = this.getContext();

                    detailreport.$ui.id = "dtrp_" + item.MENU_ID;
                    detailreport.$ui.parentParameter = ctx.obj.config.rpParameter.parameters;
                    detailreport.$ui.parentRow = ctx.obj.getSelectedItem();

                    this.hide();

                    var win = ctx.obj.$scope.ui(detailreport.$ui);
                    detailreport.initUI(item);
                    win.show();
                }
            }
        }
    });

    var layout = {
        css: "frmView",
        rows: [
            {
                height: 39,
                css: "btnControl",
                type: "toolbar",
                margin: 0,
                borderless: true,
                cols: controls
            },
            {
                rows: [
                    grid
                ]
            }
        ]
    };

    function initTable(report_id) {

        var url = app.config.host + "/System/ExecuteCommand";

        var parameters = {
            command: "CM00012",
            parameter: {
                wb_report_id: report_id
            }
        };

        webix.ajax().headers({ "Content-Type": "application/json" })
            .post(url, parameters, function (text) {
                var json = JSON.parse(text);

                var table = webix.$$("tblReport");
                table.clearAll();
                table.config.rpParameter = null;

                var cols = [];

                for (var i = 0; i < json.length; i++) {
                    var col = json[i];
                    //console.log(col);

                    var item = {
                        id: col.reportcolumn_field,
                        header: "<center>" + _(col.reportcolumn_name) + "</center>",
                        width: col.reportcolumn_width,
                        hidden: col.hidden == "C" ? true : false
                    };

                    // cột tổng dưới footer
                    if (col.footer === '' || col.footer === null) {
                    }
                    else {
                        var temp = JSON.parse(col.footer);
                        item.footer = temp;
                    }

                    //console.log(col.sum);
                    if (col.header != null) {
                        if (col.header != "") {
                            var headers = JSON.parse(col.header);

                            for (var j = 0; j < headers.length; j++) {
                                var hd = headers[j];
                                if (hd != null) {
                                    hd.text = "<center>" + _(hd.text) + "</center>";
                                }
                            }
                            item.header = headers;
                        }
                    }

                    if (col.column_type == "datetime" || col.column_type == "date") {
                        item.format = function (text) {
                            var format = webix.Date.dateToStr("%d/%m/%Y");
                            text = removeTimeZoneT(text);
                            return format(text);
                        };
                    }

                    if (col.column_type == "decimal" || col.column_type == "int") {
                        item.css = { "text-align": "right" };
                        item.format = webix.Number.numToStr({
                            groupDelimiter: ",",
                            groupSize: 3,
                            decimalDelimiter: ".",
                            decimalSize: 0
                        });
                    }

                    if (col.column_type == "bit") {
                        item.template = function (obj, common, value) {
                            if (value)
                                return "<div class='webix_icon fa-check-square-o'></div>";
                            else
                                return "<div class='webix_icon fa-square-o'></div>";
                        };
                    }

                    cols.push(item);
                }

                table.config.columns = cols;
                table.config.report_id = json[0]["wb_report_id"];
                table.refreshColumns();

            });
    }

    return {
        $ui: layout,
        $oninit: function (view, $scope) {

            var windowno = app.path[1].params[0];
            var query = "SELECT TOP 1 * FROM WB_MENU WHERE WINDOW_ID='" + windowno + "'";

            var url = app.config.host + "/System/ExecuteQuery?sql=" + query;

            webix.ajax(url, function (text) {
                var json = JSON.parse(text);

                if (json.length > 0) {
                    webix.$$("title").parse({ title: json[0]["name"], details: json[0]["details"], url_help: json[0]["url_help"] == null || undefined ? "http://huongdansudung.minvoice.com.vn/" : json[0]["url_help"] });
                }
            });

            if (app.path[1].params[1] != null) {
                var id = app.path[1].params[1];
                $$("cbReport").setValue(id);

                var load_event = "loadReport";
                var report_id = "d13001df-01fe-4d4f-ab65-cc98e7b41661";
                var id = "5accccd3-51bd-4370-b130-b01ab35d6c86";

                var now = new Date();
                now.setHours(0, 0, 0, 0);

                var item = {
                    ma_dvcs: user.getDvcsID(),
                    tu_ngay: null,
                    den_ngay: now
                };

                var table = $$("tblReport");
                table.report_id = report_id;

                var rpParameter = {
                    parameters: item,
                    infowindow_id: id,
                    type: "json",
                    report_id: report_id
                };

                table.config.rpParameter = rpParameter;

                webix.ajax()
                    .headers({ 'Content-type': 'application/json' })
                    .post(app.config.host + "/System/CreateReport", rpParameter, {
                        error: function (text, data, XmlHttpRequest) {
                            // alert(text);
                            webix.alert({
                                title: "Thông báo !",
                                text: text,
                                type: "alert-warning",
                                callback: function (result) {
                                }
                            });
                        },
                        success: function (text, data, XmlHttpRequest) {
                            var data = JSON.parse(text);

                            var table = $$("tblReport");
                            table.clearAll();
                            table.parse(data, "json");
                        }
                    }
                    // function (text) {
                    //     var data = JSON.parse(text);

                    //     var table = $$("tblReport");
                    //     table.clearAll();
                    //     table.parse(data, "json");
                    // }
                    );
            }

            $scope.on(app, "loadReport", function (report_id, infoWindowId, item) {

                var table = $$("tblReport");
                // webix.extend(table, webix.OverlayBox);
                webix.extend(table, webix.ProgressBar);
                table.disable();
                table.showProgress();
                //table.showOverlay("<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>");
                if (table.config.report_id == report_id) {

                    var rpParameter = {
                        parameters: item,
                        infowindow_id: infoWindowId,
                        type: "json",
                        report_id: report_id
                    };

                    table.config.rpParameter = rpParameter;

                    webix.ajax()
                        .headers({ 'Content-type': 'application/json' })
                        .post(app.config.host + "/System/CreateReport", rpParameter, function (text) {
                            webix.delay(function () {
                                var data = JSON.parse(text);

                                var table = $$("tblReport");
                                table.clearAll();
                                table.parse(data, "json");
                            }, null, null, 1000);

                            table.enable();
                            table.hideProgress();
                            // var data = JSON.parse(text);

                            // var table = $$("tblReport");
                            // table.clearAll();
                            // table.parse(data, "json");
                        });
                }
            });

            $scope.on(app, "loadDetailReport", function (report_id, infoWindowId, item, menuitem) {

                var win = $$("dtrp_" + menuitem.MENU_ID);
                var table = win.getChildViews()[1].getChildViews()[1];

                if (table.config.report_id == report_id) {

                    var rpParameter = {
                        parameters: item,
                        infowindow_id: infoWindowId,
                        type: "json",
                        report_id: report_id
                    };

                    table.config.rpParameter = rpParameter;

                    var ajax = webix.ajax();
                    ajax.master = menuitem;

                    ajax.headers({ 'Content-type': 'application/json' })
                        .post(app.config.host + "/api/System/CreateReport", rpParameter, function (text) {

                            var win = $$("dtrp_" + this.MENU_ID);
                            var table = win.getChildViews()[1].getChildViews()[1];

                            var data = JSON.parse(text);

                            table.clearAll();
                            table.parse(data, "json");
                        });
                }
            });
        },
        initUI: function () {

        }
    };
});
define('views/baocaotonghop',[
    "app",
    "locale",
    "views/forms/infowindow",
    "views/forms/detailreport",
    "views/forms/window",
    "models/user"
], function (app, _, infowindow, detailreport, windowform, user) {
    'use strict';

    var windowno = app.path[1].params[0];

    var controls = [
        {
            id: "cbReport",
            view: "combo",
            width: 450,
            label: "Chọn báo cáo",

            labelWidth: 90,
            suggest: {
                url: {
                    $proxy: true,
                    load: function (view, callback, params) {
                        var windowno = app.path[1].params[0];
                        var url = app.config.host + "/System/ExecuteCommand";

                        var parameters = {
                            command: "CM00033",
                            parameter: {
                                // window_id: windowno,
                                username: user.getCurrentUser()
                            }
                        };

                        webix.ajax().bind(view)
                            .headers({ "Content-Type": "application/json" })
                            .post(url, parameters, callback);

                    }
                },
                template: "#report_name#",
                body: {
                    template: "#report_name#",
                    ready: function () {
                        $$("cbReport").setValue(this.getFirstId());
                    }
                }
            },
            on: {
                onChange: function () {
                    var report_id = this.getValue();

                    if (report_id == "") {
                        return;
                    }
                    var name = $$("cbReport").getText();

                    webix.$$("title").parse({ title: name, details: name, url_help: "http://huongdansudung.minvoice.com.vn/" });
                    initTable(report_id);
                    var btnReload = $$("btnReload");
                    btnReload.callEvent("onClick");
                }
            }
        },
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-refresh fa-lg" aria-hidden="true"></i> ' +
            '<span class="text">' + _("REFRESH") + '</span>',
            id: "btnReload",
            on: {
                onClick: function () {
                    //console.log($$("cbReport").getValue());
                    if ($$("cbReport").getValue() == null || $$("cbReport").getValue() == "") {
                        webix.message("Bạn chưa chọn báo cáo !", "error");
                        return;
                    }
                    var cbReport = webix.$$("cbReport");
                    var list = cbReport.getList();

                    var item = list.getItem(cbReport.getValue());

                    infowindow.$ui.id = item.wb_infowindow_id;
                    infowindow.$ui.report_id = cbReport.getValue();
                    infowindow.$ui.load_event = "loadReport";

                    if ($$("tblReport").config.rpParameter != null) {

                        infowindow.$ui.editmode = 1;
                        infowindow.$ui.formvalues = $$("tblReport").config.rpParameter.parameters;
                    }
                    else {
                        infowindow.$ui.editmode = 0;
                        infowindow.$ui.formvalues = null;
                    }

                    var wininfoparam = this.$scope.ui(infowindow.$ui);

                    infowindow.initUI(item.wb_infowindow_id);
                    wininfoparam.show();
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-print fa-lg" aria-hidden="true"></i> ' +
            '<span class="text">' + _("PRINT") + " PDF" + '</span>',
            id: "btnPrint",
            on: {
                onClick: function () {
                    var table = $$("tblReport");

                    var rpParameter = table.config.rpParameter;

                    if (rpParameter == undefined || rpParameter == null) {
                        webix.message("Bạn chưa chọn báo cáo hoặc chưa tải dữ liệu !", "error");
                        return;
                    }
                    rpParameter.type = "PDF";

                    if (rpParameter != null) {
                        var box = webix.modalbox({
                            title: "Đang in báo cáo ....",
                            text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                            width: 350,
                            height: 200
                        });

                        webix.ajax()
                            .response("arraybuffer")
                            .headers({ 'Content-type': 'application/json' })
                            .post(app.config.host + "/System/CreateReport", rpParameter,
                            {
                                error: function (text, data, XmlHttpRequest) {
                                    webix.modalbox.hide(box);
                                    webix.message(XmlHttpRequest.statusText, "error");
                                },
                                success: function (text, data, XmlHttpRequest) {
                                    var file = new Blob([data], { type: 'application/pdf' });
                                    var fileURL = URL.createObjectURL(file);
                                    webix.modalbox.hide(box);
                                    window.open(fileURL, '_blank');
                                }
                            }
                            // function (text, data) {
                            //     var file = new Blob([data], { type: 'application/pdf' });
                            //     var fileURL = URL.createObjectURL(file);
                            //     webix.modalbox.hide(box);
                            //     window.open(fileURL, '_blank');
                            // }
                            );
                    }
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {
            view: "button", type: "htmlbutton", width: 120,
            label: '<i class="fa fa-file-excel fa-lg" aria-hidden="true"></i> ' +
            '<span class="text">' + _("EXPORT_EXCEL") + '</span>',
            id: "btnExport",
            on: {
                onClick: function () {
                    var table = $$("tblReport");

                    var rpParameter = table.config.rpParameter;
                    if (rpParameter == undefined || rpParameter == null) {
                        webix.message("Bạn chưa chọn báo cáo hoặc chưa tải dữ liệu !", "error");
                        return;
                    }
                    rpParameter.type = "xlsx";

                    if (rpParameter != null) {
                        var box = webix.modalbox({
                            title: "Đang kết xuất Excel ....",
                            text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                            width: 350,
                            height: 200
                        });

                        webix.ajax()
                            .response("arraybuffer")
                            .headers({ 'Content-type': 'application/json' })
                            .post(app.config.host + "/System/CreateReport", rpParameter,
                            {
                                error: function (text, data, XmlHttpRequest) {
                                    webix.modalbox.hide(box);
                                    webix.message(XmlHttpRequest.statusText, "error");
                                },
                                success: function (text, data, XmlHttpRequest) {
                                    var file = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                                    var fileURL = URL.createObjectURL(file);
                                    webix.modalbox.hide(box);
                                    window.location.href = fileURL;
                                }
                            }
                            // function (text, data) {

                            //     var file = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                            //     var fileURL = URL.createObjectURL(file);

                            //     window.location.href = fileURL;
                            // }
                            );
                    }
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {
            view: "button", type: "htmlbutton", width: 120,
            label: '<i class="fa fa-file-text-o fa-lg" aria-hidden="true"></i> ' +
            '<span class="text">' + _("EXPORT_CSV") + '</span>',
            id: "btnExportCsv",
            on: {
                onClick: function () {
                    var table = $$("tblReport");

                    var rpParameter = table.config.rpParameter;
                    if (rpParameter == undefined || rpParameter == null) {
                        webix.message("Bạn chưa chọn báo cáo hoặc chưa tải dữ liệu !", "error");
                        return;
                    }
                    rpParameter.type = "CSV";

                    if (rpParameter != null) {
                        var box = webix.modalbox({
                            title: "Đang kết xuất Excel ....",
                            text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                            width: 350,
                            height: 200
                        });

                        webix.ajax()
                            .response("arraybuffer")
                            .headers({ 'Content-type': 'application/json' })
                            .post(app.config.host + "/System/CreateReport", rpParameter,
                            {
                                error: function (text, data, XmlHttpRequest) {
                                    webix.modalbox.hide(box);
                                    webix.message(XmlHttpRequest.statusText, "error");
                                },
                                success: function (text, data, XmlHttpRequest) {
                                    var file = new Blob([data], { type: 'application/csv' });
                                    webix.html.download(file, "minvoiceReport.csv");
                                    //var fileURL = URL.createObjectURL(file);
                                    webix.modalbox.hide(box);
                                    //window.location.href = fileURL;
                                }
                            }
                            // function (text, data) {

                            //     var file = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                            //     var fileURL = URL.createObjectURL(file);

                            //     window.location.href = fileURL;
                            // }
                            );
                    }
                }
            },
            click: function () {
                this.callEvent("onClick");
            }

        },
        {}
    ];

    var grid = {
        rows: [
            {
                id: "tblReport",
                view: "datatable",
                resizeColumn: true,
                footer: true,
                select: true,
                css: "report",
                columns: [{ id: "col1", width: 1, header: [null, null], headermenu: false, footer: null }],
                headermenu: {
                    width: 200,
                    autoheight: false,
                    scroll: true
                },
                scheme: {
                    $change: function (item) {
                        if (item.BOLD == "C")
                            item.$css = "rowBold";
                    }
                },
                pager: "pagerA",
                on: {
                    onBeforeContextMenu: function (id) {
                        var item = this.getItem(id);

                        if (item.DOC_ID != null && item.MA_CT != null) {
                            var mn = $$("ctxMenu");
                            var menuitem = mn.getItem("SUACTGOC");
                            if (menuitem == null) {
                                mn.add({ id: "SUACTGOC", value: "Sửa chứng từ" });
                            }
                        }

                        webix.delay(function () {
                            this.clearSelection();
                            this.select(id.row, id.column);
                        }, this);
                    }
                }
            },
            {
                cols: [
                    {
                        view: "icon", icon: "fas fa-question-circle", id: "help_form_viewsfile", tooltip: _("HELPER"),
                        css: "helper",
                        click: function () {
                            webix.alert({
                                title: "Thông báo !",
                                text: "Bạn chưa khai báo hướng dẫn nhanh cho màn hình này !",
                                type: "alert-warning",
                                callback: function (result) {
                                }
                            });
                        }
                    },
                    {
                        view: "combo",
                        label: _("MENU_QUICK"),
                        id: "QuickMenu1",
                        options: {
                            // view: "gridsuggest",
                            // id: "grid_window",
                            // template: "#name#",
                            // body: {
                            //     scroll: true,
                            //     autoheight: false,
                            //     columns: [
                            //         { id: "window_id", header: "Window Id", editor: "text", width: 100 },
                            //         { id: "name", header: "Window Name", editor: "text", width: 400 }
                            //     ],
                            //     url: app.config.host + "/System/GetQuickMenu"
                            // },
                            // on: {
                            //     onValueSuggest: function (obj) {
                            //         var start = obj.window_id != "" ? obj.code + ":" + obj.window_id : obj.code;
                            //         window.location.hash = "!/app/" + start;
                            //         $$("QuickMenu1").setValue(null);
                            //         $$("QuickMenu1").destructor();
                            //     }
                            // }
                        },
                        on: {
                            onChange: function (newv, oldv) {

                            }
                        }
                    },
                    {},
                    {
                        id: "pagerA",
                        view: "pager",
                        size: 1000,
                        group: 5,
                        template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}"
                    }
                ]
            }
        ]
    }

    var contextmenu = webix.ui({
        view: "contextmenu",
        id: "ctxMenu",
        on: {
            onMenuItemClick: function (id) {
                var item = this.getItem(id);

                if (id == "SUACTGOC") {
                    var table = $$("tblReport");
                    var row = table.getSelectedItem();

                    var sql = "SELECT TOP 1 a.* FROM VC_WINDOW a WHERE a.ma_ct='" + row.MA_CT + "'";
                    var url = app.config.host + "/api/System/ExecuteQuery?sql=" + sql;

                    webix.ajax(url, function (text) {
                        var json = JSON.parse(text);
                        var data = json[0];

                        var table = $$("tblReport");
                        var row = table.getSelectedItem();

                        var a = webix.ajax(app.config.host + "/api/System/GetDataById?window_id=" + data.WINDOW_ID + "&id=" + row.DOC_ID);
                        var b = webix.ajax(app.config.host + "/api/System/GetAllByWindowNo?window_id=" + data.WINDOW_ID);

                        webix.promise.all([a, b]).then(function (results) {
                            var a_result = results[0].json();
                            var windowconfig = results[1].json();

                            var vc_window = windowconfig["data"][0];
                            windowform.$ui.id = vc_window.WINDOW_ID;

                            var table = $$("tblReport");
                            var detailForm = table.$scope.ui(windowform.$ui);

                            var item = a_result.data[0];

                            windowform.initUI(windowconfig);
                            windowform.setEditMode(2);
                            windowform.setValues(item, windowconfig);

                            detailForm.show();
                        });

                    });
                }
                else {
                    var ctx = this.getContext();

                    detailreport.$ui.id = "dtrp_" + item.MENU_ID;
                    detailreport.$ui.parentParameter = ctx.obj.config.rpParameter.parameters;
                    detailreport.$ui.parentRow = ctx.obj.getSelectedItem();

                    this.hide();

                    var win = ctx.obj.$scope.ui(detailreport.$ui);
                    detailreport.initUI(item);
                    win.show();
                }
            }
        }
    });

    var layout = {
        css: "frmView",
        rows: [
            {
                height: 39,
                css: "btnControl",
                type: "toolbar",
                margin: 0,
                borderless: true,
                cols: controls
            },
            {
                rows: [
                    grid
                ]
            }
        ]
    };

    function initTable(report_id) {

        var url = app.config.host + "/System/ExecuteCommand";

        var parameters = {
            command: "CM00012",
            parameter: {
                wb_report_id: report_id
            }
        };

        webix.ajax().headers({ "Content-Type": "application/json" })
            .post(url, parameters, function (text) {
                var json = JSON.parse(text);

                var table = webix.$$("tblReport");
                table.clearAll();
                table.config.rpParameter = null;

                var cols = [];

                for (var i = 0; i < json.length; i++) {
                    var col = json[i];
                    //console.log(col);

                    var item = {
                        id: col.reportcolumn_field,
                        header: "<center>" + _(col.reportcolumn_name) + "</center>",
                        width: col.reportcolumn_width,
                        hidden: col.hidden == "C" ? true : false
                    };

                    // cột tổng dưới footer
                    if (col.footer === '' || col.footer === null) {
                    }
                    else {
                        var temp = JSON.parse(col.footer);
                        item.footer = temp;
                    }

                    //console.log(col.sum);
                    if (col.header != null) {
                        if (col.header != "") {
                            var headers = JSON.parse(col.header);

                            for (var j = 0; j < headers.length; j++) {
                                var hd = headers[j];
                                if (hd != null) {
                                    hd.text = "<center>" + _(hd.text) + "</center>";
                                }
                            }
                            item.header = headers;
                        }
                    }

                    if (col.column_type == "datetime" || col.column_type == "date") {
                        item.format = function (text) {
                            var format = webix.Date.dateToStr("%d/%m/%Y");
                            text = removeTimeZoneT(text);
                            return format(text);
                        };
                    }

                    if (col.column_type == "decimal" || col.column_type == "int") {
                        item.css = { "text-align": "right" };
                        item.format = webix.Number.numToStr({
                            groupDelimiter: ",",
                            groupSize: 3,
                            decimalDelimiter: ".",
                            decimalSize: 0
                        });
                    }

                    if (col.column_type == "bit") {
                        item.template = function (obj, common, value) {
                            if (value)
                                return "<div class='webix_icon fa-check-square-o'></div>";
                            else
                                return "<div class='webix_icon fa-square-o'></div>";
                        };
                    }

                    cols.push(item);
                }

                table.config.columns = cols;
                table.config.report_id = json[0]["wb_report_id"];
                table.refreshColumns();

            });
    }

    return {
        $ui: layout,
        $oninit: function (view, $scope) {

            var windowno = app.path[1].params[0];
            var query = "SELECT TOP 1 * FROM WB_MENU WHERE WINDOW_ID='" + windowno + "'";

            var url = app.config.host + "/System/ExecuteQuery?sql=" + query;

            webix.ajax(url, function (text) {
                var json = JSON.parse(text);

                if (json.length > 0) {
                    webix.$$("title").parse({ title: json[0]["name"], details: json[0]["details"], url_help: json[0]["url_help"] == null || undefined ? "http://huongdansudung.minvoice.com.vn/" : json[0]["url_help"] });
                }
            });

            if (app.path[1].params[1] != null) {
                var id = app.path[1].params[1];
                $$("cbReport").setValue(id);

                var load_event = "loadReport";
                var report_id = "d13001df-01fe-4d4f-ab65-cc98e7b41661";
                var id = "5accccd3-51bd-4370-b130-b01ab35d6c86";

                var now = new Date();
                now.setHours(0, 0, 0, 0);

                var item = {
                    ma_dvcs: user.getDvcsID(),
                    tu_ngay: null,
                    den_ngay: now
                };

                var table = $$("tblReport");
                table.report_id = report_id;

                var rpParameter = {
                    parameters: item,
                    infowindow_id: id,
                    type: "json",
                    report_id: report_id
                };

                table.config.rpParameter = rpParameter;

                webix.ajax()
                    .headers({ 'Content-type': 'application/json' })
                    .post(app.config.host + "/System/CreateReport", rpParameter, {
                        error: function (text, data, XmlHttpRequest) {
                            // alert(text);
                            webix.alert({
                                title: "Thông báo !",
                                text: text,
                                type: "alert-warning",
                                callback: function (result) {
                                }
                            });
                        },
                        success: function (text, data, XmlHttpRequest) {
                            var data = JSON.parse(text);

                            var table = $$("tblReport");
                            table.clearAll();
                            table.parse(data, "json");
                        }
                    }
                    // function (text) {
                    //     var data = JSON.parse(text);

                    //     var table = $$("tblReport");
                    //     table.clearAll();
                    //     table.parse(data, "json");
                    // }
                    );
            }

            $scope.on(app, "loadReport", function (report_id, infoWindowId, item) {

                var table = $$("tblReport");
                // webix.extend(table, webix.OverlayBox);
                webix.extend(table, webix.ProgressBar);
                table.disable();
                table.showProgress();
                //table.showOverlay("<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>");
                if (table.config.report_id == report_id) {

                    var rpParameter = {
                        parameters: item,
                        infowindow_id: infoWindowId,
                        type: "json",
                        report_id: report_id
                    };

                    table.config.rpParameter = rpParameter;

                    webix.ajax()
                        .headers({ 'Content-type': 'application/json' })
                        .post(app.config.host + "/System/CreateReport", rpParameter, function (text) {
                            webix.delay(function () {
                                var data = JSON.parse(text);

                                var table = $$("tblReport");
                                table.clearAll();
                                table.parse(data, "json");
                            }, null, null, 1000);

                            table.enable();
                            table.hideProgress();
                            // var data = JSON.parse(text);

                            // var table = $$("tblReport");
                            // table.clearAll();
                            // table.parse(data, "json");
                        });
                }
            });

            $scope.on(app, "loadDetailReport", function (report_id, infoWindowId, item, menuitem) {

                var win = $$("dtrp_" + menuitem.MENU_ID);
                var table = win.getChildViews()[1].getChildViews()[1];

                if (table.config.report_id == report_id) {

                    var rpParameter = {
                        parameters: item,
                        infowindow_id: infoWindowId,
                        type: "json",
                        report_id: report_id
                    };

                    table.config.rpParameter = rpParameter;

                    var ajax = webix.ajax();
                    ajax.master = menuitem;

                    ajax.headers({ 'Content-type': 'application/json' })
                        .post(app.config.host + "/api/System/CreateReport", rpParameter, function (text) {

                            var win = $$("dtrp_" + this.MENU_ID);
                            var table = win.getChildViews()[1].getChildViews()[1];

                            var data = JSON.parse(text);

                            table.clearAll();
                            table.parse(data, "json");
                        });
                }
            });
        },
        initUI: function () {

        }
    };
});
define('views/forms/bc_payment_request',[
  "app",
  "locale",
  "models/user",
  "views/forms/forms68/BaoCao/bc_component",
  "views/modules/Component/constantManager",
], function (app, _, user, component, constants) {
  var dataInfo;
  var type;
  var gridId = "baocaodenghithutien";
  var paymentMethodId = "payment_method";
  var gridUrl = {
    $proxy: true,
    load: function (view) {
      var grid = $$(gridId);
      webix.extend(grid, webix.ProgressBar);
      grid.disable();
      grid.showProgress();
      var filter = {
        fromDate: webix.Date.dateToStr("%Y-%m-%d")(dataInfo.tu_ngay),
        toDate: webix.Date.dateToStr("%Y-%m-%d")(dataInfo.den_ngay),
        paymentMethod: dataInfo.payment_method,
        userCreate: dataInfo.user_new,
        type: type,
      };
      webix
        .ajax()
        .response("arraybuffer")
        .headers({ "Content-type": "application/json" })
        .bind(view)
        .post(constants.API.PAYMENT_REQUEST.CREATE_REPORT, filter, {
          error: function (_text, _data, XmlHttpRequest) {
            webix.message(XmlHttpRequest.statusText, "error");
          },
          success: function (_text, data) {
            var file = new Blob([data], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            var fileURL = URL.createObjectURL(file);
            webix.html.download(fileURL, "Bao_cao_chi_tiet_dntt.xlsx");
            grid.hideProgress();
          },
        });
    },
  };
  webix.ajax().get(constants.API.GET_HTTTOAN, function (res) {
    var data = JSON.parse(res).data;
    for (var i = 0; i < data.length; i++) {
      if (!data[i].value || !data[i].id) {
        data.splice(i, 1);
        i--;
      }
    }
    data = [{ id: " ", value: "Tất cả" }].concat(data);
    $$(paymentMethodId).define("options", data);
  });
  return {
    $ui: {
      view: "window",
      modal: true,
      position: "center",
      head: "Báo cáo chi tiết DNTT hóa đơn",
      width: 550,
      resize: true,
      body: {
        paddingY: 10,
        paddingX: 10,
        elementsConfig: { labelWidth: 150 },
        view: "form",
        id: "bc_payment_request_form",
        complexData: true,
        margin: 0,
        elements: [
          component.TuNgay(),
          component.DenNgay(),
          {
            view: "combo",
            label: _("Hình thức thanh toán"),
            name: paymentMethodId,
            id: paymentMethodId,
            clear: "replace",
          },
          {
            id: "user_new",
            name: "user_new",
            view: "text",
            value: ``,
            label: "Nguời lập",
            clear: true,
          },
          {
            margin: 10,
            cols: [
              {},
              {
                shortcut: "F10",
                view: "button",
                label: "Nhận (F10)",
                width: 100,
                type: "form",
                align: "center",
                on: {
                  onClick: function () {
                    var form = this.getParentView().getParentView();
                    if (form.validate()) {
                      var win = this.getTopParentView();
                      dataInfo = Object.assign({}, form.getValues());
                      dataInfo.TypeReport = 1;
                      var grid = $$(gridId);
                      grid.define("dataInfo", dataInfo);
                      grid.define("url", gridUrl);
                      grid.clearAll();
                      grid.load(grid.config.url);
                      win.close();
                    }
                  },
                },
                click: function () {
                  this.callEvent("onClick");
                },
              },
              {
                view: "button",
                hotkey: "esc",
                label: "Hủy bỏ (ESC)",
                width: 100,
                align: "center",
                type: "danger",
                click: function () {
                  this.getTopParentView().close();
                },
              },
              {},
            ],
          },
        ],
      },
    },
    setValues: function (item) {
      var win = $$(this.$ui.id);
      var form = win.getChildViews()[1];
      form.setValues(item);
    },
    setType: function (reportType) {
      type = reportType;
    },
    dataInfo: dataInfo,
  };
});

define('views/modules/payments/bc_payment_request_ui',["app", "locale", "views/forms/bc_payment_request"], function (
  _app,
  _,
  bcdntt
) {
  var dataTableId = "baocaodenghithutien";
  var controls = [
    {
      view: "button",
      type: "htmlbutton",
      width: 100,
      label:
        '<i class="fa fa-plus fa-lg" aria-hidden="true"></i> ' +
        '<span class="text">' +
        _("Tạo báo cáo") +
        "</span>",
      id: "btnReload",
      click: function () {
        var wininfoparam = this.$scope.ui(bcdntt.$ui);
        wininfoparam.show();
      },
    },
  ];
  var grid = {
    rows: [
      {
        container: "testA",
        view: "datatable",
        id: dataTableId,
        select: true,
        resizeColumn: true,
        fullScreen: true,
        leftSplit: 5,
        columns: [],
        pager: "hdssPager",
        on: {
          onAfterLoad: function () {
            this.enable();
            this.hideProgress();
            if (!this.count())
              this.showOverlay(
                "<div><img src='assets/imgs/nodata.png'><div class='showOverlaydata'>Không có dữ liệu</div></div>"
              );
            else this.hideOverlay();
          },
          "data->onStoreUpdated": function () {
            this.data.each(function (obj, i) {
              obj.stt = i + 1;
            });
          },
        },
      },
      {
        id: "hdssPager",
        view: "pager",
        size: 50,
        group: 5,
        template:
          "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}",
      },
    ],
  };

  return {
    css: "frmView",
    rows: [
      {
        height: 39,
        type: "toolbar",
        css: "btnControl",
        borderless: true,
        cols: controls,
      },
      {
        rows: [grid],
      },
    ],
  };
});

define('views/bc_payment_request_bienlai',[
  "app",
  "locale",
  "views/forms/bc_payment_request",
  "views/modules/payments/bc_payment_request_ui",
], function (_app, _, bcdntt, bcPaymentRequestUi) {
  "use strict";

  return {
    $ui: bcPaymentRequestUi,
    $oninit: function (_view, $scope) {
      $scope.ui(bcdntt.$ui).show();
      bcdntt.setType(2);
    },
  };
});

define('views/bc_payment_request',[
  "app",
  "locale",
  "views/forms/bc_payment_request",
  "views/modules/payments/bc_payment_request_ui",
], function (_app, _, bcdntt, bcPaymentRequestUi) {
  "use strict";

  return {
    $ui: bcPaymentRequestUi,
    $oninit: function (_view, $scope) {
      $scope.ui(bcdntt.$ui).show();
      bcdntt.setType(1);
    },
  };
});

define('views/buyer-sign',[
    "app",
    "locale",
    "views/modules/Component/constantManager",
    "views/modules/Component/modalPlugin",
    "views/modules/minvoiceplugin",
], function (app, _, constant, modalPlugin, minvoiceplugin) {
    'use strict';
    var bienbancontent = "bienbanContent";
    var bienbanData = {};
    function md5cycle(x, k) {
        var a = x[0], b = x[1], c = x[2], d = x[3];

        a = ff(a, b, c, d, k[0], 7, -680876936);
        d = ff(d, a, b, c, k[1], 12, -389564586);
        c = ff(c, d, a, b, k[2], 17, 606105819);
        b = ff(b, c, d, a, k[3], 22, -1044525330);
        a = ff(a, b, c, d, k[4], 7, -176418897);
        d = ff(d, a, b, c, k[5], 12, 1200080426);
        c = ff(c, d, a, b, k[6], 17, -1473231341);
        b = ff(b, c, d, a, k[7], 22, -45705983);
        a = ff(a, b, c, d, k[8], 7, 1770035416);
        d = ff(d, a, b, c, k[9], 12, -1958414417);
        c = ff(c, d, a, b, k[10], 17, -42063);
        b = ff(b, c, d, a, k[11], 22, -1990404162);
        a = ff(a, b, c, d, k[12], 7, 1804603682);
        d = ff(d, a, b, c, k[13], 12, -40341101);
        c = ff(c, d, a, b, k[14], 17, -1502002290);
        b = ff(b, c, d, a, k[15], 22, 1236535329);

        a = gg(a, b, c, d, k[1], 5, -165796510);
        d = gg(d, a, b, c, k[6], 9, -1069501632);
        c = gg(c, d, a, b, k[11], 14, 643717713);
        b = gg(b, c, d, a, k[0], 20, -373897302);
        a = gg(a, b, c, d, k[5], 5, -701558691);
        d = gg(d, a, b, c, k[10], 9, 38016083);
        c = gg(c, d, a, b, k[15], 14, -660478335);
        b = gg(b, c, d, a, k[4], 20, -405537848);
        a = gg(a, b, c, d, k[9], 5, 568446438);
        d = gg(d, a, b, c, k[14], 9, -1019803690);
        c = gg(c, d, a, b, k[3], 14, -187363961);
        b = gg(b, c, d, a, k[8], 20, 1163531501);
        a = gg(a, b, c, d, k[13], 5, -1444681467);
        d = gg(d, a, b, c, k[2], 9, -51403784);
        c = gg(c, d, a, b, k[7], 14, 1735328473);
        b = gg(b, c, d, a, k[12], 20, -1926607734);

        a = hh(a, b, c, d, k[5], 4, -378558);
        d = hh(d, a, b, c, k[8], 11, -2022574463);
        c = hh(c, d, a, b, k[11], 16, 1839030562);
        b = hh(b, c, d, a, k[14], 23, -35309556);
        a = hh(a, b, c, d, k[1], 4, -1530992060);
        d = hh(d, a, b, c, k[4], 11, 1272893353);
        c = hh(c, d, a, b, k[7], 16, -155497632);
        b = hh(b, c, d, a, k[10], 23, -1094730640);
        a = hh(a, b, c, d, k[13], 4, 681279174);
        d = hh(d, a, b, c, k[0], 11, -358537222);
        c = hh(c, d, a, b, k[3], 16, -722521979);
        b = hh(b, c, d, a, k[6], 23, 76029189);
        a = hh(a, b, c, d, k[9], 4, -640364487);
        d = hh(d, a, b, c, k[12], 11, -421815835);
        c = hh(c, d, a, b, k[15], 16, 530742520);
        b = hh(b, c, d, a, k[2], 23, -995338651);

        a = ii(a, b, c, d, k[0], 6, -198630844);
        d = ii(d, a, b, c, k[7], 10, 1126891415);
        c = ii(c, d, a, b, k[14], 15, -1416354905);
        b = ii(b, c, d, a, k[5], 21, -57434055);
        a = ii(a, b, c, d, k[12], 6, 1700485571);
        d = ii(d, a, b, c, k[3], 10, -1894986606);
        c = ii(c, d, a, b, k[10], 15, -1051523);
        b = ii(b, c, d, a, k[1], 21, -2054922799);
        a = ii(a, b, c, d, k[8], 6, 1873313359);
        d = ii(d, a, b, c, k[15], 10, -30611744);
        c = ii(c, d, a, b, k[6], 15, -1560198380);
        b = ii(b, c, d, a, k[13], 21, 1309151649);
        a = ii(a, b, c, d, k[4], 6, -145523070);
        d = ii(d, a, b, c, k[11], 10, -1120210379);
        c = ii(c, d, a, b, k[2], 15, 718787259);
        b = ii(b, c, d, a, k[9], 21, -343485551);

        x[0] = add32(a, x[0]);
        x[1] = add32(b, x[1]);
        x[2] = add32(c, x[2]);
        x[3] = add32(d, x[3]);
    }
    function cmn(q, a, b, x, s, t) {
        a = add32(add32(a, q), add32(x, t));
        return add32((a << s) | (a >>> (32 - s)), b);
    }
    function ff(a, b, c, d, x, s, t) { return cmn((b & c) | (~b & d), a, b, x, s, t); }
    function gg(a, b, c, d, x, s, t) { return cmn((b & d) | (c & ~d), a, b, x, s, t); }
    function hh(a, b, c, d, x, s, t) { return cmn(b ^ c ^ d, a, b, x, s, t); }
    function ii(a, b, c, d, x, s, t) { return cmn(c ^ (b | ~d), a, b, x, s, t); }

    function md51(s) {
        var n = s.length, state = [1732584193, -271733879, -1732584194, 271733878], i;
        for (i = 64; i <= n; i += 64) md5cycle(state, md5blk(s.substring(i - 64, i)));
        s = s.substring(i - 64);
        var tail = new Array(16).fill(0);
        for (i = 0; i < s.length; i++) tail[i >> 2] |= s.charCodeAt(i) << ((i % 4) << 3);
        tail[i >> 2] |= 0x80 << ((i % 4) << 3);
        if (i > 55) { md5cycle(state, tail); tail.fill(0); }
        tail[14] = n * 8;
        md5cycle(state, tail);
        return state;
    }
    function md5blk(s) {
        var md5blks = [], i;
        for (i = 0; i < 64; i += 4) {
            md5blks[i >> 2] =
                s.charCodeAt(i) +
                (s.charCodeAt(i + 1) << 8) +
                (s.charCodeAt(i + 2) << 16) +
                (s.charCodeAt(i + 3) << 24);
        }
        return md5blks;
    }
    function rhex(n) {
        var s = "", j;
        for (j = 0; j < 4; j++) {
            s += ((n >> (j * 8)) & 0xff).toString(16).padStart(2, "0");
        }
        return s;
    }
    function hex(x) {
        return x.map(rhex).join("");
    }
    function md5(s) {
        return hex(md51(s));
    }

    function add32(a, b) { return (a + b) & 0xffffffff; }
    function formatDate(raw) {
        if (!raw) return "";
        var date = new Date(raw);
        return `${("0" + date.getDate()).slice(-2)}/${("0" + (date.getMonth() + 1)).slice(-2)}/${date.getFullYear()}`;
    }
    function getBuyerSignId() {
        var hash = window.location.hash;
        var parts = hash.replace("#!/", "").split("/");
        return (parts[0] === "buyer-sign" && parts[1]) ? parts[1] : null;
    }
    function loadBienbanData(bienban_id) {
        if (!bienban_id) {
            webix.message("Không tìm thấy ID biên bản", "error");
            return;
        }
        webix.ajax()
            .get(app.config.host + constant.API.BIENBAN.GET_BIENBAN_BY_ID + "?id=" + bienban_id)
            .then(function (res) {
                var response = res.json();
                if (response && response.data) {
                    bienbanData = response.data;
                    if ($$(bienbancontent)) {
                        $$(bienbancontent).refresh();
                    }
                } else {
                    webix.message("Không tìm thấy dữ liệu biên bản", "error");
                }
            })
            .catch(function () {
                webix.message("Lỗi khi tải dữ liệu biên bản", "error");
            });
    }
    function showError(message) {
        webix.message(message || "Có lỗi xảy ra", "error");
    }
    function signBuyerPlugin(savedBienbanId) {
        var hub = minvoiceplugin.hub();
        var hubconnect = minvoiceplugin.conn();

        if (hubconnect.state != 1) {
            showError("Quý khách hàng chưa cài Plugin ký hóa đơn hoặc Plugin ký hóa đơn chưa được bật !");
            var Form = webix.ui(modalPlugin.$ui);
            Form.show();
            return;
        }
        var salt = "rz8LuOtFBXphj9WQfvFh";
        var key = md5(savedBienbanId + salt);
        webix.ajax(app.config.host + constant.API.BIENBAN.GET_XML_BUYER + "?id=" + savedBienbanId + "&key=" + key)
            .then(function (res) {
                var xmlData = res.json();
                if (xmlData.code != "00") {
                    showError(xmlData.message || "Không lấy được XML ký");
                    return;
                }
                hub.off('resCommand');
                hub.on('resCommand', function (result) {
                    var responseSign = {};
                    try {
                        responseSign = JSON.parse(result);
                    } catch (e) {
                        responseSign = { error: result };
                    }

                    if (responseSign.hasOwnProperty("error")) {
                        var errorMessage = responseSign.error;
                        if (errorMessage.includes("Không tồn tại phương thức trên plugin, vui lòng liên hệ M-Invoice để được hỗ trợ")) {
                            errorMessage = "Vui lòng cài phiên bản ký số M-invoice Plugin 4.2.9 trở lên dành cho ký người mua";
                        }
                        return showError(errorMessage);
                    }

                    var parameters = {
                        xml: responseSign.xml,
                        id: savedBienbanId,
                        ngay_ky_nmua: new Date(),
                        key: key,
                    };

                    webix.ajax()
                        .headers({ "Content-Type": "application/json" })
                        .post(app.config.host + constant.API.BIENBAN.SAVE_XML_BUYER, parameters, function (text) {
                            var response = JSON.parse(text);
                            if (response.code != "00") return showError(response.message);
                            webix.message("Ký biên bản thành công!", "success");
                            loadBienbanData(savedBienbanId);
                        });
                });
                var arg = {
                    idData: "#" + savedBienbanId,
                    xml: xmlData.data["xml"],
                    idSigner: "",
                    tagSign: "NMua"
                };

                hub.invoke('execCommand', 'SignXmlTagBuyer', JSON.stringify(arg))
                    .done(function () { console.log("Sign command sent"); })
                    .fail(function (error) { showError(error); });
            })
            .fail(function () {
                showError("Lỗi trong quá trình lấy dữ liệu ký biên bản");
            });
    }

    var bienbanContent = {
        view: "template",
        id: bienbancontent,
        autoheight: true,
        borderless: true,
        css: {
            "background": "#c9c9c9"
        },
        template: function () {
            var val = bienbanData;
            return `
                <div style="width:794px; min-height:1000px; margin:0 auto; padding:40px 50px; box-sizing:border-box; font-family:'Times New Roman',  word-wrap: break-word;overflow-wrap: break-word;  serif; font-size:14px; line-height:1.6; background:#fff; box-shadow:0 0 5px rgba(0,0,0,0.15);">
                    <div style="text-align:center; font-weight:bold;">CỘNG HÒA XÃ HỘI CHỦ NGHĨA VIỆT NAM</div>
                    <div style="text-align:center;">Độc lập - Tự do - Hạnh phúc</div>
                    <div style="text-align:center;">*****</div>
                    <div style="text-align:center; font-weight:bold; font-size:16px; margin-top:10px;">
                        BIÊN BẢN ${(val.tchat == 1 ? "điều chỉnh" : "thay thế").toUpperCase()} HÓA ĐƠN
                    </div>
                    <div style="text-align:center; font-weight:bold;">Số biên bản: ${val.so || ""}</div>
                    <div style="margin-top:15px;">
                        <em>- Căn cứ vào nghị định 70/2025/NĐ-CP ngày 20/03/2025 của Chính phủ quy định về hóa đơn, chứng từ.</em><br>
                        <em>- Căn cứ Nghị định 70/2025/NĐ-CP ngày 20/03/2025 của Chính phủ sửa đổi, bổ sung một số điều của Nghị định 123/2020/NĐ-CP ngày 19/10/2020 của Chính phủ quy định về hóa đơn, chứng từ.</em><br>
                        <em>- Căn cứ Thông tư 32/2025/TT-BTC ngày 31/05/2025 của Bộ Tài chính hướng dẫn thực hiện Nghị định số 123/2020/NĐ-CP ngày 19/10/2020 của Chính phủ quy định về hóa đơn, chứng từ, Nghị định số 70/2025/NĐ-CP ngày 20/03/2025 sửa đổi, bổ sung một số điều Nghị định số 123/2020/NĐ-CP.</em><br>
                        <em>- Căn cứ thỏa thuận giữa các bên</em>
                    </div>
                    <div style="margin-top:15px;">Hôm nay, ngày ${formatDate(val.ngay)}, đại diện hai bên gồm có:</div>
                    <div style="margin-top:15px; font-weight:bold;">BÊN A: ${val.nban || ""}</div>
                    <div>Địa chỉ: ${val.dchi_nban || ""}</div>
                    <div style="display:flex; max-width:600px;">
                        <div style="flex:1;">Mã số thuế: ${val.mst_nban || ""}</div>
                        <div style="flex:1;">Số điện thoại: ${val.sdt_nban || ""}</div>
                    </div>
                    <div style="display:flex; max-width:600px;">
                        <div style="flex:1;">Đại diện: ${val.ddien_nban || ""}</div>
                        <div style="flex:1;">Chức vụ: ${val.chucvu_nban || ""}</div>
                    </div>
                    <div style="margin-top:15px; font-weight:bold;">BÊN B: ${val.nmua || ""}</div>
                    <div>Địa chỉ: ${val.dchi_nmua || ""}</div>
                    <div style="display:flex; max-width:600px;">
                        <div style="flex:1;">Mã số thuế: ${val.mst_nmua || ""}</div>
                        <div style="flex:1;">Số điện thoại: ${val.sdt_nmua || ""}</div>
                    </div>
                    <div style="display:flex; max-width:600px;">
                        <div style="flex:1;">Đại diện: ${val.ddien_nmua || ""}</div>
                        <div style="flex:1;">Chức vụ: ${val.chucvu_nmua || ""}</div>
                    </div>
                    <div style="margin-top:15px;">
                        Hai bên thống nhất lập biên bản này để ${val.tchat === 1 ? "điều chỉnh" : "thay thế"} cho hóa đơn có ký hiệu ${val.khieu_hdon || ""}, số ${val.shdon || ""}, ngày ${formatDate(val.ngay_hdon)} theo quy định.
                    </div>
                    <div style="margin-top:15px; display:flex; align-items:center; font-weight:bold;">
                        <span>Lý do ${val.tchat == 1 ? "điều chỉnh" : "thay thế"}:</span>
                        <span style="font-weight: normal; margin-left: 5px;">${val.ldo || ""}</span>
                    </div>
                    <div style="margin-top:15px;">Chúng tôi xin cam đoan các thông tin khai ở trên là hoàn toàn chính xác. Nếu có bất kỳ sai sót nào chúng tôi xin chịu trách nhiệm trước pháp luật.</div>
                    <div style="margin-top:50px; display:flex; justify-content:space-between;">
                     <div style="text-align:center; width:45%;">
                            <b>ĐẠI DIỆN BÊN A</b><br>(Chữ ký số, chữ ký điện tử)
                            ${val.ngay_ky ? `
                                <div style="margin: 6px 0; padding: 8px 12px; border: 2px solid #28a745; border-radius: 0; background-color: #f8fff8; text-align: left;">
                                    <div style="color: #28a745; font-weight: bold; font-size: 14px; margin-bottom: 4px;">
                                        Signature Valid
                                    </div>
                                    <div style="text-align: left;">
                                        <div style="color: #28a745; font-size: 14px; margin-bottom: 4px;">
                                            Ký bởi: ${val.nban || ""}
                                        </div>
                                        <div style="color: #28a745; font-size: 14px; position: relative; display: flex; align-items: center; gap: 5px;">
                                            <span>Ký ngày: ${formatDateTime(val.ngay_ky)}</span>
                                            <span style="color: #28a745; font-size: 64px; font-weight: 500; position: absolute; bottom: -20px; right: -20px;">✓</span>
                                        </div>
                                    </div>
                                </div>
                            ` : ''}
                        </div>

                        <div style="text-align:center; width:45%;">
                            <b>ĐẠI DIỆN BÊN B</b><br>(Chữ ký số, chữ ký điện tử)
                            ${val.ngay_ky_nmua ? `
                                <div style="margin: 6px 0; padding: 8px 12px; border: 2px solid #28a745; border-radius: 0; background-color: #f8fff8; text-align: left;">
                                <div style="color: #28a745; font-weight: bold; font-size: 14px; margin-bottom: 4px;">
                                    Signature Valid
                                </div>
                                <div style="text-align: left;">
                                    <div style="color: #28a745; font-size: 14px; margin-bottom: 4px;">
                                        Ký bởi: ${val.nmua || ""}
                                    </div>
                                    <div style="color: #28a745; font-size: 14px; position: relative; display: flex; align-items: center; gap: 5px;">
                                        <span>Ký ngày: ${formatDateTime(val.ngay_ky_nmua)}</span>
                                        <span style="color: #28a745; font-size: 64px; font-weight: 500; position: absolute; bottom: -20px; right: -20px;">✓</span>
                                    </div>
                                </div>
                            </div>
                            ` : `
                                <div style="margin-top:10px;">
                                    <button class="btn-sign-b webix_button">✍ Ký điện tử</button>
                                </div>
                            `}
                        </div>

                    </div>
                </div>
            `;
        },
        onClick: {
            "btn-sign-b": function () {
                var id = getBuyerSignId();
                if (!id) return showError("Vui lòng kiểm tra lại link ký so với link trong email");
                signBuyerPlugin(id);
            }
        }
    };
    var bienban_id = getBuyerSignId();
    if (bienban_id) {
        loadBienbanData(bienban_id);
    }

    return {
        $ui: {
            rows: [
                {
                    view: "template",
                    css: "webix_header",
                    height: 60,
                    borderless: true,
                    template: `
                          <div style="display:flex; justify-content:space-between; align-items:center; height:100%; padding:0 15px; background:#fff;">
                            <a href="http://minvoice.vn" target="_blank">
                                <img src="assets/imgs/LogoAppMinvoice.png" 
                                    alt="Minvoice Logo" 
                                    style="height:40px; margin-right:15px;" />
                            </a>
                            <div style="font-size:18px; font-weight:bold; color:#363793;">
                                NGƯỜI MUA KÝ BIÊN BẢN ĐIỆN TỬ
                            </div>
                            <div style="display:flex; gap:10px; align-items:center;">
                                 <a href="https://minvoice.vn/dang-ky-su-dung/" target="_blank" style="color:#dc3545; text-decoration:underline; font-size:14px;">
                                        Mua hàng
                                 </a>
                                <a href="https://www.youtube.com/watch?v=d19r08wDStA&ab_channel=H%C3%B3a%C4%90%C6%A1n%C4%90i%E1%BB%87nT%E1%BB%ADM-invoice" target="_blank" 
                                style="padding:6px 12px; background:#363793; color:#fff; border-radius:6px; text-decoration:none; font-size:14px;">
                                    mSMI-mTax
                                </a>
                            </div>
                        </div>
                        `
                },

                {
                    view: "scrollview",
                    scroll: "y",
                    css: {
                        "background": "#c9c9c9"
                    },
                    body: {
                        rows: [
                            bienbanContent,
                            {
                                padding: 20,
                                cols: [
                                    {},
                                    {
                                        view: "button",
                                        label: "Tải xuống",
                                        width: 150,
                                        height: 40,
                                        css: "webix_primary",
                                        type: "form",
                                        click: function () {
                                            var id = getBuyerSignId();
                                            if (!id) {
                                                webix.message("Không tìm thấy ID biên bản", "error");
                                                return;
                                            }
                                            var btn = this;
                                            webix.extend(btn, webix.ProgressBar);
                                            btn.disable();
                                            btn.showProgress();
                                            webix.ajax()
                                                .response("arraybuffer")
                                                .headers({ "Content-type": "application/json" })
                                                .get(app.config.host + constant.API.BIENBAN.PRINT_BIENBAN + "?id=" + id + "&type=PDF", {
                                                    error: function () {
                                                        btn.enable();
                                                        btn.hideProgress();
                                                        webix.message("Không tạo được file PDF", "error");
                                                    },
                                                    success: function (text, data) {
                                                        btn.enable();
                                                        btn.hideProgress();
                                                        var blob = new Blob([data], { type: "application/pdf" });
                                                        var filename = (bienbanData.so || "BienBan") + ".pdf";
                                                        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                                                            window.navigator.msSaveOrOpenBlob(blob, filename);
                                                            return;
                                                        }
                                                        var url = URL.createObjectURL(blob);
                                                        var a = document.createElement("a");
                                                        a.style.display = "none";
                                                        a.href = url;
                                                        a.download = filename;
                                                        document.body.appendChild(a);
                                                        a.click();
                                                        a.remove();
                                                        setTimeout(function () { URL.revokeObjectURL(url); }, 0);
                                                    }
                                                });
                                        }
                                    },
                                    {}
                                ]
                            }
                        ]
                    }
                }
            ]
        },
        show: function () {
            if (bienbanData && bienbanData.so && $$(bienbancontent)) {
                $$(bienbancontent).refresh();
            }
        },
    };
});
define('views/forms/chukyso',["app", "locale"], function (app, _) {
	var editmode = 0;

	return {
		$ui: {
			view: "window", modal: true, id: "chukyso-win", position: "center",
			head: "Thông tin chứng thư số",
			// height: 490,
			body: {
				paddingY: 10,
				paddingX: 10,
				view: "form",
				id: "chukyso-form",
				complexData: true,
				margin: 0,
				elements: [
					{
						view: "text",
						name: "so_serial",
						labelPosition: "top",
						label: _("SO_SERIAL"),
						readonly: true,
						css: "mcls_readonly_text",
						width: 550
					},
					{
						view: "textarea",
						name: "subjectname",
						labelPosition: "top",
						label: _("SUBJECTNAME"),
						readonly: true,
						css: "mcls_readonly_text",
						height: 100
					},
					{
						view: "textarea",
						name: "issuer",
						labelPosition: "top",
						label: _("DONVI"),
						css: "mcls_readonly_text",
						readonly: true,
						height: 80
					},
					{
						cols: [
							{
								view: "datepicker",
								label: _("NGAY_BAT_DAU"),
								labelPosition: "top",
								name: "ngaybatdau",
								timepicker: true,
								format: "%d/%m/%Y %H:%i:%s",
								css: "mcls_readonly_text",
								readonly: true
							},
							{
								view: "datepicker",
								label: _("NGAY_KET_THUC"),
								labelPosition: "top",
								name: "ngayketthuc",
								format: "%d/%m/%Y %H:%i:%s",
								timepicker: true,
								css: "mcls_readonly_text",
								readonly: true
							}
						]
					},
					{
						view: "text",
						name: "tokenSerial",
						label: _("TOKEN_SERIAL"),
						labelPosition: "top",
						css: "mcls_readonly_text",
						readonly: true
					},
					{
						view: "text",
						name: "nguoiky",
						label: _("NGUOI_KY"),
						labelPosition: "top",
					},

					{
						view: "checkbox",
						name: "chon",
						label: _("CHON"),
						checkValue: true,
						uncheckValue: false,
					},
					{},
					{
						margin: 10,
						cols: [
							{},
							{
								shortcut: "F10", view: "button", label: "Nhận (F10)", type: "form", align: "center", width: 120,
								on: {
									onClick: function () {
										var form = webix.$$("chukyso-form");
										var item = form.getValues();
										var khData = {};
										khData.windowid = app.path[1].params[0];
										khData.editmode = editmode;
										khData.data = [];
										khData.data.push(item);
										webix.ajax()
											.headers({ 'Content-type': 'application/json' })
											.post(app.config.host + "/System/Save", khData, function (text) {

												var json = JSON.parse(text);

												if (!json.hasOwnProperty("error")) {
													$$("chukyso-win").close();
													app.callEvent("dataChanged", [editmode, json.data]);
												}
												else {
													webix.message(json.error);
												}
											});
									}
								},
								click: function () {
									this.callEvent("onClick");

								}
							},
							{
								view: "button", hotkey: "esc", label: "Hủy bỏ (ESC)", type: "danger", align: "center", width: 120,
								click: function () {
									webix.$$("chukyso-win").close();
								}
							},
							{}
						]
					}

				]
			}

		},
		setEditMode: function (mode) {
			editmode = mode;
		}
	};

});
define('views/forms/chukysocloud',["app"], function (app) {
    var editmode = 0;
    var item;
    function initUI(obj) {
        item = obj;
    }
    return {
        $ui: {
            view: "window",
            modal: true,
            id: "chukysocloud",
            position: "center",
            head: "Đăng ký chứng thư số Cloud FPT",
            move: true,
            height: 500,
            minWidth: 500,
            body: {
                view: "form",
                id: "chukysocloud-frm",
                elementsConfig: {
                    labelWidth: 120
                },
                elements: [
                    { view: "label", label: "Quý khách vui lòng nhập Username Cloud mà nhà cung cấp chữ ký số cung cấp cho bạn." },
                    // {
                    //     view: "text", label: "Số hóa đơn", name: "so_hd",
                    //     id: "sohd", required: true, invalidMessage: "Số hóa đơn không được để trống",
                    //     attributes: { maxlength: 7 },
                    //     on: {
                    //         onChange: function (newv, oldv) {
                    //             newv = newv.padStart(7, "0");
                    //             this.setValue(newv);
                    //         },
                    //         onKeyPress: function (code, e) {
                    //             if ((code < 48 || code > 57) && code != 8 && code != 9) {
                    //                 return webix.html.preventEvent(e);
                    //             }
                    //         }
                    //     }
                    // },
                    {
                        view: "text", name: "agreementUUID", id: "agreement_UUID", label: "Username Cloud", required: true,
                        invalidMessage: "Username Cloud không được để trống"
                    },
                    {
                        cols: [
                            {},
                            {
                                shortcut: "F10", view: "button", label: "Nhận (F10)", type: "form", align: "center", width: 100,
                                on: {
                                    onClick: function () {
                                        if ($$("chukysocloud-frm").validate()) {
                                            var form = $$("chukysocloud");
                                            var item = $$("chukysocloud-frm").getValues();

                                            webix.extend(form, webix.ProgressBar);
                                            form.disable();
                                            form.showProgress();
                                            var url = app.config.host + "/TokenCloud/SaveTokens";

                                            webix.ajax()
                                                .headers({ 'Content-type': 'application/json' })
                                                .post(url, item, {
                                                    error: function (text, data, XmlHttpRequest) {
                                                        form.enable();
                                                        form.hideProgress();
                                                        webix.message(text);
                                                    },
                                                    success: function (text, data, XmlHttpRequest) {
                                                        var obj = JSON.parse(text);
                                                        if (!obj.hasOwnProperty("error")) {
                                                            app.callEvent("dataChanged", [1, obj.data[0]]);
                                                            form.enable();
                                                            form.hideProgress();
                                                            $$("btnCancel").callEvent("onClick");
                                                            webix.message("Đã thực hiện xong !", "success");
                                                        }
                                                        else {
                                                            form.enable();
                                                            form.hideProgress();
                                                            webix.message(obj.error, "error");
                                                        }

                                                    }
                                                });
                                        }
                                    }
                                },
                                click: function () {
                                    this.callEvent("onClick");

                                }
                            },
                            {
                                view: "button", id: "btnCancel", shortcut: "esc", label: "Hủy (ESC)", type: "danger", align: "center",
                                width: 100,
                                on: {
                                    onClick: function () {
                                        $$("chukysocloud").close();
                                    }
                                },
                                click: function () {
                                    this.callEvent("onClick");
                                }
                            },
                            {}
                        ]
                    }
                ]
            }
        },
        setEditMode: function (mode) {
            editmode = mode;
        },
        initUI: initUI
    };

});
define('views/forms/chukysoEasyCA',["app"], function (app) {
    var editmode = 0;
    var item;
    function initUI(obj) {
        item = obj;
    }
    return {
        $ui: {
            view: "window",
            modal: true,
            id: "chukysoEasyCA",
            position: "center",
            head: "Đăng ký chứng thư số EasyCA",
            move: true,
            height: 350,
            minWidth: 500,
            body: {
                view: "form",
                id: "chukysoEasyCA-frm",
                elementsConfig: {
                    labelWidth: 120
                },
                elements: [
                    { view: "label", label: "Quý khách vui lòng nhập Serial mà nhà cung cấp chữ ký số cung cấp cho bạn." },
                    // {
                    //     view: "text", label: "Số hóa đơn", name: "so_hd",
                    //     id: "sohd", required: true, invalidMessage: "Số hóa đơn không được để trống",
                    //     attributes: { maxlength: 7 },
                    //     on: {
                    //         onChange: function (newv, oldv) {
                    //             newv = newv.padStart(7, "0");
                    //             this.setValue(newv);
                    //         },
                    //         onKeyPress: function (code, e) {
                    //             if ((code < 48 || code > 57) && code != 8 && code != 9) {
                    //                 return webix.html.preventEvent(e);
                    //             }
                    //         }
                    //     }
                    // },
                    {
                        view: "text", name: "username", id: "username", label: "Username", required: true, labelWidth: 100,
                        invalidMessage: "Bạn phải nhập Username"
                    },
                    {
                        view: "text", type: "password", name: "pass", id: "pass", label: "Password", required: true, labelWidth: 100,
                        invalidMessage: "Bạn phải nhập Password"
                    },
                    {
                        view: "text", name: "so_serial", id: "so_serial", label: "Số Serial", required: true, labelWidth: 100,
                        invalidMessage: "Số Serial không được để trống"
                    },
                    {
                        cols: [
                            {},
                            {
                                shortcut: "F10", view: "button", label: "Nhận (F10)", type: "form", align: "center", width: 100,
                                on: {
                                    onClick: function () {
                                        if ($$("chukysoEasyCA-frm").validate()) {
                                            var form = $$("chukysoEasyCA");
                                            var item = $$("chukysoEasyCA-frm").getValues();

                                            webix.extend(form, webix.ProgressBar);
                                            form.disable();
                                            form.showProgress();
                                            var url = app.config.host + "/Token/SaveEasyCA";

                                            webix.ajax()
                                                .headers({ 'Content-type': 'application/json' })
                                                .post(url, item, {
                                                    error: function (text, data, XmlHttpRequest) {
                                                        form.enable();
                                                        form.hideProgress();
                                                        webix.message(text);
                                                    },
                                                    success: function (text, data, XmlHttpRequest) {
                                                        var obj = JSON.parse(text);
                                                        if (!obj.hasOwnProperty("error")) {
                                                            app.callEvent("dataChanged", [1, obj.data[0]]);
                                                            form.enable();
                                                            form.hideProgress();
                                                            $$("btnCancel").callEvent("onClick");
                                                            webix.message("Đã thực hiện xong !", "success");
                                                        }
                                                        else {
                                                            form.enable();
                                                            form.hideProgress();
                                                            webix.message(obj.error, "error");
                                                        }

                                                    }
                                                });
                                        }
                                    }
                                },
                                click: function () {
                                    this.callEvent("onClick");

                                }
                            },
                            {
                                view: "button", id: "btnCancel", shortcut: "esc", label: "Hủy (ESC)", type: "danger", align: "center",
                                width: 100,
                                on: {
                                    onClick: function () {
                                        $$("chukysoEasyCA").close();
                                    }
                                },
                                click: function () {
                                    this.callEvent("onClick");
                                }
                            },
                            {}
                        ]
                    }
                ]
            }
        },
        setEditMode: function (mode) {
            editmode = mode;
        },
        initUI: initUI
    };

});
define('views/forms/chukysoNCCA',["app"], function (app) {
    var editmode = 0;
    var item;
    function initUI(obj) {
        item = obj;
    }
    return {
        $ui: {
            view: "window",
            modal: true,
            id: "chukysocloudNCCA",
            position: "center",
            head: "Đăng ký chứng thư số Cloud NCCA",
            move: true,
            height: 500,
            minWidth: 500,
            body: {
                view: "form",
                id: "chukysocloudNCCA-frm",
                elementsConfig: {
                    labelWidth: 120
                },
                elements: [
                    { view: "label", label: "Quý khách vui lòng nhập Username (Agreement UUID) mà nhà cung cấp chữ ký số cung cấp cho bạn." },
                    {
                        view: "text", name: "agreementUUID", id: "agreement_UUID", label: "Username (UUID)", required: true,
                        invalidMessage: "Username (UUID) không được để trống"
                    },
                    {
                        cols: [
                            {},
                            {
                                shortcut: "F10", view: "button", label: "Nhận (F10)", type: "form", align: "center", width: 100,
                                on: {
                                    onClick: function () {
                                        if ($$("chukysocloudNCCA-frm").validate()) {
                                            var form = $$("chukysocloudNCCA");
                                            var item = $$("chukysocloudNCCA-frm").getValues();
                                            webix.extend(form, webix.ProgressBar);
                                            form.disable();
                                            form.showProgress();
                                            var apiHost = app.config.host + "/TokenCloud/NccaSaveToken";
                                            webix.ajax()
                                                .headers({ 'Content-type': 'application/json' })
                                                .post(apiHost, item, {
                                                    error: function (text, data, XmlHttpRequest) {
                                                        form.enable();
                                                        form.hideProgress();
                                                        webix.message(text);
                                                    },
                                                    success: function (text, data, XmlHttpRequest) {
                                                        var response = JSON.parse(text);
                                                        if (response.code == "00") {
                                                            app.callEvent("dataChanged", [1, response.data[0]]);
                                                            form.enable();
                                                            form.hideProgress();
                                                            $$("btnCancel").callEvent("onClick");
                                                            webix.message("Đã thực hiện xong !", "success");
                                                        }
                                                        else {
                                                            form.enable();
                                                            form.hideProgress();
                                                            webix.message(response.message, "error");
                                                        }

                                                    }
                                                });
                                        }
                                    }
                                },
                                click: function () {
                                    this.callEvent("onClick");
                                }
                            },
                            {
                                view: "button", id: "btnCancel", shortcut: "esc", label: "Hủy (ESC)", type: "danger", align: "center",
                                width: 100,
                                on: {
                                    onClick: function () {
                                        $$("chukysocloudNCCA").close();
                                    }
                                },
                                click: function () {
                                    this.callEvent("onClick");
                                }
                            },
                            {}
                        ]
                    }
                ]
            }
        },
        setEditMode: function (mode) {
            editmode = mode;
        },
        initUI: initUI
    };

});
define('views/forms/chukysoICA',["app"], function (app) {
    var editmode = 0;
    var item;
    function initUI(obj) {
        item = obj;
    }
    return {
        $ui: {
            view: "window",
            modal: true,
            id: "chukysocloudICA",
            position: "center",
            head: "Đăng ký chứng thư số Cloud ICA",
            move: true,
            height: 500,
            minWidth: 500,
            body: {
                view: "form",
                id: "chukysocloudICA-frm",
                elementsConfig: {
                    labelWidth: 120
                },
                elements: [
                    { view: "label", label: "Quý khách vui lòng nhập Username (Agreement UUID) mà nhà cung cấp chữ ký số cung cấp cho bạn." },
                    {
                        view: "text", name: "agreementUUID", id: "agreement_UUID", label: "Username (UUID)", required: true,
                        invalidMessage: "Username (UUID) không được để trống"
                    },
                    { view: "text", name: "pass", id: "pass", label: "Mã pin", type: "password" },
                    {
                        cols: [
                            {},
                            {
                                shortcut: "F10", view: "button", label: "Nhận (F10)", type: "form", align: "center", width: 100,
                                on: {
                                    onClick: function () {
                                        if ($$("chukysocloudICA-frm").validate()) {
                                            var form = $$("chukysocloudICA");
                                            var item = $$("chukysocloudICA-frm").getValues();
                                            webix.extend(form, webix.ProgressBar);
                                            form.disable();
                                            form.showProgress();
                                            var apiHost = app.config.host + "/TokenCloud/IcaSaveToken";
                                            webix.ajax()
                                                .headers({ 'Content-type': 'application/json' })
                                                .post(apiHost, item, {
                                                    error: function (text, data, XmlHttpRequest) {
                                                        form.enable();
                                                        form.hideProgress();
                                                        webix.message(text);
                                                    },
                                                    success: function (text, data, XmlHttpRequest) {
                                                        var response = JSON.parse(text);
                                                        if (response.code == "00") {
                                                            app.callEvent("dataChanged", [1, response.data[0]]);
                                                            form.enable();
                                                            form.hideProgress();
                                                            $$("btnCancel").callEvent("onClick");
                                                            webix.message("Đã thực hiện xong !", "success");
                                                        }
                                                        else {
                                                            form.enable();
                                                            form.hideProgress();
                                                            webix.message(response.message, "error");
                                                        }

                                                    }
                                                });
                                        }
                                    }
                                },
                                click: function () {
                                    this.callEvent("onClick");
                                }
                            },
                            {
                                view: "button", id: "btnCancel", shortcut: "esc", label: "Hủy (ESC)", type: "danger", align: "center",
                                width: 100,
                                on: {
                                    onClick: function () {
                                        $$("chukysocloudICA").close();
                                    }
                                },
                                click: function () {
                                    this.callEvent("onClick");
                                }
                            },
                            {}
                        ]
                    }
                ]
            }
        },
        setEditMode: function (mode) {
            editmode = mode;
        },
        initUI: initUI
    };

});
define('views/forms/chukysoVIETTEL',["app"], function (app) {
    return {
        $ui: {
            view: "window",
            position: "center",
            modal: true,
            id: "chukysoVIETTELCA",
            position: "center",
            head: "Chứng thư số VIETTEL CA",
            move: true,
            height: 500,
            minWidth: 500,
            body: {
                view: "form",
                id: "chukysoVIETTELCAForm",
                elementsConfig: {
                    labelWidth: 120,
                },
                elements: [
                    { view: "text", name: "userId", label: "User ID", required: true, invalidMessage: "UserID không được để trống", placeholder: "Vui lòng nhập UserName do nhà cung cấp dịch vụ VIETTEL đã cấp cho bạn" },
                    {
                        cols: [
                            {
                                view: "button", type: "form", label: "Nhận", click: function () {
                                    if ($$("chukysoVIETTELCAForm").validate()) {
                                        var win = $$("chukysoVIETTELCA");
                                        var item = $$("chukysoVIETTELCAForm").getValues();
                                        webix.extend(win, webix.ProgressBar);
                                        win.disable();
                                        win.showProgress();
                                        var apiHost = app.config.host + "/TokenCloud/SaveVIETTELToken";
                                        webix.ajax().headers({ 'Content-type': 'application/json' }).post(apiHost, item, {
                                            error: function (text, data, XmlHttpRequest) {
                                                win.enable();
                                                win.hideProgress();
                                                webix.message(text);
                                            },
                                            success: function (text, data, XmlHttpRequest) {
                                                var response = JSON.parse(text);
                                                if (response.code == "00") {
                                                    win.enable();
                                                    win.hideProgress();
                                                    $$("btnCancel").callEvent("onClick");
                                                    webix.message("Đã thực hiện xong !", "success");
                                                    $$("dmwindowData").load($$("dmwindowData").config.url);
                                                }
                                                else {
                                                    win.enable();
                                                    win.hideProgress();
                                                    webix.message(response.message, "error");
                                                }

                                            }
                                        });
                                    }
                                }
                            },
                            {
                                view: "button", type: "danger", label: "Hủy", click: function () {
                                    $$("chukysoVIETTELCA").close();
                                }
                            }
                        ]
                    }
                ]

            }
        }
    }



});
define('views/forms/chukysoINTRUSTCA',[
    "app",
    "locale",
],
    function (app, _) {
        var windowId = "chukyso-intrustCa-win";
        var formId = "chukyso-intrustCa-form";
        var layout =
        {
            view: "window", modal: true, resize: true, id: windowId, position: "center", move: true, css: "headformchil",
            head: {
                height: 40,
                cols: [
                    { id: "head-form", view: "template", css: "headform", template: function (obj) { return '<div><center>Nhập thông tin đăng nhập IntrustCa<center><div/>'; } },
                ]
            },
            minWidth: 500,
            minHeight: 500,
            body: {
                paddingY: 10,
                paddingX: 10,
                view: "form",
                id: formId,
                complexData: true,
                margin: 0,
                elements: [
                    { height: 15 },
                    { view: "text", name: "user_name", id: "user_name", label: "Tài khoản:", required: true, invalidMessage: "Username không được để trống" },
                    { view: "text", name: "pass_word", id: "pass_word", label: "Mật khẩu:", required: true, type: "password", invalidMessage: "Password không được để trống" },
                    { view: "text", name: "pin_code", id: "pin_code", label: "Mã pin:", required: true, type: "password", invalidMessage: "Mã pin không được để trống" },
                    { height: 10 },
                    {
                        margin: 15,
                        cols: [
                            {},
                            {
                                shortcut: "F9", view: "button", type: "icon", icon: "mdi mdi mdi-file-document-outline", label: "Nhận (F9)", type: "form", align: "center", width: 120,
                                on: {
                                    onClick: function () {
                                        var formComponent = webix.$$(formId);
                                        if (formComponent.validate()) {
                                            var item = formComponent.getValues();
                                            webix.extend(formComponent, webix.ProgressBar);
                                            formComponent.disable();
                                            formComponent.showProgress();
                                            webix.ajax().headers({ 'Content-type': 'application/json' })
                                                .post(app.config.host + "/TokenCloud/IntrustCaLogin", item, function (text) {
                                                    var response = JSON.parse(text);
                                                    formComponent.enable();
                                                    formComponent.hideProgress();
                                                    if (response.code == 0) {
                                                        webix.message("Thêm chứng thư số thành công", "success");
                                                        webix.$$(windowId).close();
                                                    }
                                                    else
                                                        webix.message("Lỗi: " + response.message, "error");
                                                });
                                        }
                                    }
                                },
                                click: function () {
                                    this.callEvent("onClick");
                                }
                            },
                            {
                                view: "button", hotkey: "esc", label: "Hủy bỏ (ESC)", type: "danger", align: "center", width: 120,
                                click: function () {
                                    webix.$$(windowId).close();
                                }
                            },
                            {}
                        ]
                    }
                ]
            }
        };
        return {
            $ui: layout
        };
    }
);


define('views/forms/chukysoVNET',[
    "app",
    "locale",
],
    function (app, _) {
        var windowId = "chukyso-intrustCa-win";
        var formId = "chukyso-intrustCa-form";
        var layout =
        {
            view: "window", modal: true, resize: true, id: windowId, position: "center", move: true, css: "headformchil",
            head: {
                height: 40,
                cols: [
                    { id: "head-form", view: "template", css: "headform", template: function (obj) { return '<div><center>Nhập thông tin đăng nhập VNET để lấy chứng thư số</center><div/>'; } },
                ]
            },
            minWidth: 500,
            minHeight: 500,
            body: {
                paddingY: 10,
                paddingX: 10,
                view: "form",
                id: formId,
                complexData: true,
                margin: 0,
                elements: [
                    { height: 15 },
                    { view: "text", name: "apiId", id: "apiId", labelWidth: 114, label: "Tên đăng nhập:", required: true, invalidMessage: "Tên đăng nhập không được để trống" },
                    { view: "text", name: "secretKeyBase64", labelWidth: 114, id: "secretKeyBase64", label: "Khóa bảo mật:", required: true, invalidMessage: "Khóa bảo mật không được để trống" },
                    { height: 10 },
                    {
                        margin: 15,
                        cols: [
                            {},
                            {
                                shortcut: "F9", view: "button", type: "icon", icon: "mdi mdi mdi-file-document-outline", label: "Nhận (F9)", type: "form", align: "center", width: 120,
                                on: {
                                    onClick: function () {
                                        var formComponent = webix.$$(formId);
                                        if (formComponent.validate()) {
                                            var item = formComponent.getValues();
                                            webix.extend(formComponent, webix.ProgressBar);
                                            formComponent.disable();
                                            formComponent.showProgress();
                                            webix.ajax().headers({ 'Content-type': 'application/json' })
                                                .post(app.config.host + "/TokenCloud/VnetSaveToken", item, function (text) {
                                                    var response = JSON.parse(text);
                                                    formComponent.enable();
                                                    formComponent.hideProgress();
                                                    if (response.code == 0)
                                                        webix.message("Thêm chứng thư số thành công", "success")
                                                    else
                                                        webix.message("Lỗi: " + response.message, "error");
                                                });
                                        }
                                    }
                                },
                                click: function () {
                                    this.callEvent("onClick");
                                }
                            },
                            {},
                            {
                                view: "button", hotkey: "esc", label: "Hủy bỏ (ESC)", type: "danger", align: "center", width: 100,
                                click: function () {
                                    webix.$$(windowId).close();
                                }
                            },
                            {}
                        ]
                    }
                ]
            }
        };
        return {
            $ui: layout
        };
    }
);


define('views/chukyso',[
    "app",
    "views/forms/chukyso",
    "locale",
    "views/modules/minvoiceplugin",
    "views/forms/chukysocloud",
    "views/forms/chukysoEasyCA",
    "views/forms/chukysoNCCA",
    "views/forms/chukysoICA",
    "views/forms/chukysoVIETTEL",
    "views/forms/chukysoINTRUSTCA",
    "views/forms/chukysoVNET"
], function (app, dmwindowform, _, plugin, chukysocloud, chukysoEasyCA, chukysoNCCA, 
    chukysoICA,chukysoVIETTEL, chukysoINTRUSTCA, chukysoVNET) {
    'use strict';
    webix.$$("title").parse({ title: _("Hệ thống > Đăng ký chữ ký số > Đăng ký USB token"), details: _("DSCTS") });
    var controls = [
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-refresh fa-lg" aria-hidden="true"></i> ' +
                '<span class="text">' + _("REFRESH") + '</span>',
            id: "btnRefresh",
            shortcut: "F5",
            on: {
                onClick: function () {
                    webix.callEvent("onLoadError");
                    var table = webix.$$("dmwindowData");
                    table.clearAll();
                    table.load(table.config.url);
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-plus fa-lg" aria-hidden="true"></i> ' +
                '<span class="text">' + _("THEM") + " (F4)" + '</span>',
            id: "btnPlus",
            shortcut: "F4",
            on: {
                onClick: function () {
                    var url = app.config.host + "/System/ExecuteCommand";
                    webix.ajax()
                        .headers({ "Content-Type": "application/json" })
                        .post(url, { command: "CM00019", parameter: { ma_dvcs: "" } }, function (text) {
                            var array = JSON.parse(text);
                            var kytaptrung = "";
                            var server_cert = "";
                            for (var i = 0; i < array.length; i++) {
                                var item = array[i];
                                if (item.ma == "KYTAPTRUNG") {
                                    kytaptrung = item.gia_tri;
                                }
                                if (item.ma == "FILE") {
                                    kytaptrung = item.gia_tri;
                                }
                                if (item.ma == "SERVER_CERT") {
                                    server_cert = item.gia_tri;
                                }
                            }
                            switch (kytaptrung) {
                                case "C":
                                    var box = webix.modalbox({
                                        title: "Chọn chứng thư số",
                                        buttons: ["Nhận", "Hủy bỏ"],
                                        text: "<div id='ctnCerts'></div>",
                                        top: 100,
                                        width: 750,
                                        callback: function (result) {
                                            switch (result) {
                                                case "1":
                                                    webix.modalbox.hide();
                                                    break;
                                                case "0":

                                                    var table = $$("tblCerts");

                                                    var item = {
                                                        certs: table.serialize()
                                                    };

                                                    webix.ajax()
                                                        .headers({ 'Content-type': 'application/json' })
                                                        .post(app.config.host + "/Token/SaveCerts", item, function (text) {

                                                            var json = JSON.parse(text);

                                                            if (!json.hasOwnProperty("error")) {

                                                                var table = $$("dmwindowData");
                                                                table.clearAll();
                                                                table.load(table.config.url);

                                                                webix.modalbox.hide();
                                                            }
                                                            else {
                                                                webix.message(json.error);
                                                            }
                                                        });
                                                    break;
                                            }
                                        }
                                    });
                                    var popupText = document.getElementsByClassName("webix_popup_text")[0];
                                    popupText.style.paddingTop = 0;
                                    var tblMatHang = webix.ui({
                                        container: "ctnCerts",
                                        id: "tblCerts",
                                        view: "datatable",
                                        borderless: true,
                                        height: 350,
                                        columns: [
                                            {
                                                id: "chon",
                                                header: _("CHON"),
                                                width: 65,
                                                checkValue: true,
                                                uncheckValue: false,
                                                template: "{common.checkbox()}"
                                            },
                                            {
                                                id: "so_serial",
                                                header: _("SO_SERIAL"),
                                                width: 150
                                            },
                                            {
                                                id: "subjectname",
                                                header: _("SUBJECTNAME"),
                                                width: 450
                                            },
                                            {
                                                id: "ngaybatdau",
                                                header: _("NGAY_BAT_DAU"),
                                                width: 200
                                            },
                                            {
                                                id: "ngayketthuc",
                                                header: _("NGAY_HET_HAN"),
                                                width: 200
                                            },
                                            {
                                                id: "tokenSerial",
                                                header: _("TOKEN_SERIAL"),
                                                width: 150
                                            },
                                            {
                                                id: "issuer",
                                                header: _("DONVI"),
                                                width: 450
                                            },
                                        ],
                                        url: server_cert + "/Token/AllCertificates"
                                    });
                                    break;
                                case "FILE":
                                    var box = webix.modalbox({
                                        title: "Chọn chứng thư số",
                                        buttons: ["Nhận", "Hủy bỏ"],
                                        text: "<div id='ctnCerts'></div>",
                                        top: 100,
                                        width: 750,
                                        callback: function (result) {
                                            switch (result) {
                                                case "1":
                                                    webix.modalbox.hide();
                                                    break;
                                                case "0":
                                                    var table = $$("tblCerts");
                                                    var item = {
                                                        certs: table.serialize()
                                                    };
                                                    webix.ajax()
                                                        .headers({ 'Content-type': 'application/json' })
                                                        .post(app.config.host + "/Token/SaveChukysoFile", item, function (text) {
                                                            var json = JSON.parse(text);
                                                            if (!json.hasOwnProperty("error")) {
                                                                var table = $$("dmwindowData");
                                                                table.clearAll();
                                                                table.load(table.config.url);
                                                                webix.modalbox.hide();
                                                            }
                                                            else {
                                                                webix.message(json.error);
                                                            }
                                                        });
                                                    break;
                                            }
                                        }
                                    });
                                    var popupText = document.getElementsByClassName("webix_popup_text")[0];
                                    popupText.style.paddingTop = 0;
                                    var tblMatHang = webix.ui({
                                        container: "ctnCerts",
                                        id: "tblCerts",
                                        view: "datatable",
                                        borderless: true,
                                        height: 350,
                                        columns: [
                                            {
                                                id: "chon",
                                                header: _("CHON"),
                                                width: 65,
                                                checkValue: true,
                                                uncheckValue: false,
                                                template: "{common.checkbox()}"
                                            },
                                            {
                                                id: "serialNumber",
                                                header: _("SO_SERIAL"),
                                                width: 250
                                            },
                                            {
                                                id: "path",
                                                header: _("Đường dẫn"),
                                                width: 250
                                            }
                                        ],
                                        url: app.config.host + "/Token/AllCertificatesFile"
                                    });
                                    break;
                                case "CLOUD":
                                    var form = $$("dmwindowData").$scope.ui(chukysocloud.$ui);
                                    form.show();
                                    break;
                                case "EASYCA":
                                    var form = $$("dmwindowData").$scope.ui(chukysoEasyCA.$ui);
                                    form.show();
                                    break;
                                case "NCCA":
                                    var form = $$("dmwindowData").$scope.ui(chukysoNCCA.$ui);
                                    form.show();
                                    break;
                                case "ICA":
                                    var form = $$("dmwindowData").$scope.ui(chukysoICA.$ui);
                                    form.show();
                                    break;
                                case "K":
                                    var hub = plugin.hub();
                                    hub.off('resCommand');
                                    hub.on('resCommand', function (result) {
                                        var json = JSON.parse(result);
                                        if (json.hasOwnProperty("error")) {
                                            webix.message({ type: 'error', text: json.error });
                                        }
                                        else {
                                            var callback = json.callback;
                                            if (callback == "RegisterCert") {
                                                var item = {
                                                    chon: true,
                                                    so_serial: json.data.so_serial,
                                                    subjectname: json.data.subjectname,
                                                    issuer: json.data.issuer,
                                                    ngaybatdau: json.data.ngaybatdau,
                                                    ngayketthuc: json.data.ngayketthuc,
                                                    tokenSerial: null
                                                };

                                                var certs = [];
                                                certs.push(item);
                                                var parameter = {
                                                    certs: certs
                                                };

                                                webix.ajax()
                                                    .headers({ 'Content-type': 'application/json' })
                                                    .post(app.config.host + "/Token/SaveCerts", parameter, function (text) {
                                                        var json = JSON.parse(text);
                                                        if (!json.hasOwnProperty("error")) {
                                                            var table = $$("dmwindowData");
                                                            table.clearAll();
                                                            table.load(table.config.url);
                                                        }
                                                        else {
                                                            webix.message(json.error);
                                                        }
                                                    });
                                            }
                                        }
                                    });
                                    var arg = {
                                        callback: "RegisterCert"
                                    };
                                    hub.invoke('execCommand', arg.callback, JSON.stringify(arg));
                                    break;
                                case "VIETTEL": 
                                    var form = $$("dmwindowData").$scope.ui(chukysoVIETTEL.$ui);
                                    form.show();
                                    break;
                                case "INTRUSTCA": 
                                    var form = $$("dmwindowData").$scope.ui(chukysoINTRUSTCA.$ui);
                                    form.show();
                                    break;
                                case "VNET": 
                                var form = $$("dmwindowData").$scope.ui(chukysoVNET.$ui);
                                form.show();
                                break;
                        };
                        });
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-edit fa-lg" aria-hidden="true"></i> ' +
                '<span class="text">' + _("SUA") + " (F3)" + '</span>',
            id: "btnEdit",
            shortcut: "F3",
            on: {
                onClick: function () {
                    var detailForm = this.$scope.ui(dmwindowform.$ui);
                    var form = webix.$$("chukyso-form");
                    var table = webix.$$("dmwindowData");
                    var item = table.getSelectedItem();
                    if (item == null || item == undefined) {
                        webix.message("Bạn chưa chọn dòng cần sửa !", "error");
                        return;
                    }
                    var format = webix.Date.dateToStr("%d/%m/%Y %H:%i:%s");
                    item.ngaybatdau = removeTimeZoneT(item.ngaybatdau);
                    item.ngayketthuc = removeTimeZoneT(item.ngayketthuc);
                    form.setValues(item);
                    dmwindowform.setEditMode(2);
                    detailForm.show();
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-trash-o fa-lg" aria-hidden="true"></i> ' +
                '<span class="text">' + _("XOA") + " (F8)" + '</span>',
            id: "btnDelete",
            shortcut: "F8",
            on: {
                onClick: function () {
                    var table = webix.$$("dmwindowData");
                    var item = table.getSelectedItem();
                    var khData = {};
                    khData.windowid = app.path[1].params[0];
                    khData.editmode = 3;
                    khData.data = [];
                    khData.data.push(item);
                    webix.confirm({
                        text: "Bạn có muốn xóa " + item.so_serial, ok: "Có", cancel: "Không",
                        callback: function (res) {
                            if (res) {
                                webix.ajax()
                                    .headers({ 'Content-type': 'application/json' })
                                    .post(app.config.host + "/System/Save", khData, function (text) {
                                        var response = JSON.parse(text);
                                        if (response.hasOwnProperty("error")) {
                                            webix.message(response.error, "error");
                                            return;
                                        }
                                        table.remove(item.id);
                                    });
                            }
                        }
                    });
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {
            view: "button", type: "htmlbutton", width: 110,
            label: '<i class="fa fa-file-text-o fa-lg" aria-hidden="true"></i> ' +
                '<span class="text">' + _("Tải file") + " (F9)" + '</span>',
            id: "btnFile",
            shortcut: "F9",
            on: {
                onClick: function () {
                    var data = $$("dmwindowData").config.kytaptrung;
                    if (data == "FILE") {
                        var form = {
                            view: "form",
                            id: "frmFileCert",
                            elements: [
                                {
                                    id: "txtPass",
                                    view: "text",
                                    label: "Mật khẩu",
                                    labelPosition: "top",
                                    type: "password",
                                    validate: webix.rules.isNotEmpty,
                                    invalidMessage: "Mật khẩu không được để trống",
                                    required: true,
                                },
                                {
                                    view: "uploader",
                                    id: "upl1",
                                    autosend: false,
                                    css: "btnUpload",
                                    value: 'Chọn file',
                                    link: "mylist",
                                    accept: "application/keychain_access , application/x-pkcs12",
                                    upload: app.config.host + "/Token/UploadCertFile",
                                    on: {
                                        onAfterFileAdd: function (item) {
                                            var type = item.type.toLowerCase(); //deriving file extension
                                            if (type != "p12" && type != "crt") { //checking the format
                                                webix.message("Chú ý chọn file .p12 !", "error");
                                                return false;
                                            }
                                        }
                                    }
                                },
                                {
                                    view: "list", id: "mylist", type: "uploader",
                                    autoheight: true, borderless: true
                                },
                                {
                                    cols: [
                                        {
                                            view: "button",
                                            label: "Lưu file",
                                            type: "form",
                                            click: function () {
                                                if ($$("frmFileCert").validate()) {
                                                    var formData = {
                                                        pass: $$("txtPass").getValue()
                                                    };
                                                    $$("upl1").define("formData", formData);
                                                    $$("upl1").send(function (res) {
                                                        if (res != undefined) {
                                                            if (res.hasOwnProperty("error")) {
                                                                webix.message({ "type": "error", "text": res.error })
                                                            }
                                                            else {
                                                                webix.message("Đã tải thành công");
                                                                var win = $$("upl1").getTopParentView();
                                                                win.close();
                                                                var table = $$("dmwindowData");
                                                                table.clearAll();
                                                                table.load(table.config.url);
                                                            }
                                                        }
                                                    });
                                                }
                                            }
                                        },
                                        {
                                            view: "button",
                                            label: "Hủy bỏ",
                                            type: "danger",
                                            shortcut: "esc",
                                            click: function () {
                                                var win = this.getTopParentView();
                                                win.close();
                                            }
                                        }
                                    ]
                                }
                            ]
                        };

                        var comp = {
                            view: "window",
                            position: "center",
                            modal: true,
                            move: true,
                            resize: true,
                            head: "Đăng ký File chứng thư số",
                            body: form
                        };
                        var win = this.$scope.ui(comp);
                        win.show();
                    }
                    else {
                        webix.message("Chưa bật ký tập trung FILE", "error");
                        return;
                    }
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-key" aria-hidden="true"></i> ' +
                '<span class="text">' + _("Đổi mật khẩu") + '</span>',
            id: "btnChanggePass",
            on: {
                onClick: function () {
                    var data = $$("dmwindowData").config.kytaptrung;
                    if (data == "ICA") {
                        var table = webix.$$("dmwindowData");
                        var item = table.getSelectedItem();
                        if (item == null || item == undefined) {
                            webix.message("Bạn chưa chọn dòng cần sửa !", "error");
                            return;
                        }
                        if (item.libraryName == "ICA") {
                            require(["app", "locale", "views/forms/forms68/ICA/changePassICA"], function (app, _, changePassICA) {
                                var frm = webix.$$("dmwindowData").$scope.ui(changePassICA.$ui);
                                changePassICA.initUI(item.chukyso_id);
                                frm.show();
                            });
                        }
                        else {
                            webix.message("Chữ ký số bạn chọn không phải ICA", "error");
                            return;
                        }
                    }
                    else {
                        webix.message("Đổi mật khẩu chỉ áp dụng cho chữ ký số ICA", "debug");
                        return;
                    }
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {}

    ];

    var grid = {
        rows: [
            {
                id: "dmwindowData",
                view: "datatable",
                select: true,
                datafetch: 100,
                resizeColumn: true,
                leftSplit: 2,
                //loadahead: 15,
                on: {
                    "data->onStoreUpdated": function () {
                        this.data.each(function (obj, i) {
                            obj.index = i + 1;
                        })
                    },
                    onItemDblClick: function (id, e, node) {
                        var btnEdit = $$("btnEdit");
                        btnEdit.callEvent("onClick");
                    }
                },
                url: {
                    $proxy: true,
                    load: function (view, callback, params) {
                        var windowno = app.path[1].params[0];
                        var url = app.config.host + "/System/GetDataByWindowNo?window_id=" + windowno;
                        if (params == null) {
                            url = url + "&start=0&count=" + view.config.datafetch + "&continue=null&filter=null";
                        }
                        else {
                            url = url + "&start=" + params.start + "&count=" + params.count + "&continue=" + params.continue;
                            if (params.filter != null) {
                                var array = [];

                                for (var property in params.filter) {
                                    var column = view.getColumnConfig(property);
                                    if (column !== undefined) {
                                        var item = {
                                            columnName: property,
                                            columnType: column.columnType,
                                            value: params.filter[property]
                                        };
                                        array.push(item);
                                    }
                                }
                                if (array.length > 0) {
                                    url = url + "&filter=" + JSON.stringify(array);
                                }
                                else {
                                    url = url + "&filter=null";
                                }
                            }
                            else {
                                url = url + "&filter=null";
                            }
                        }

                        if (view.config.infoparam != null) {
                            url = url + "&infoparam=" + JSON.stringify(view.config.infoparam);
                        }
                        else {
                            url = url + "&infoparam=null";
                        }
                        var tlbParams = $$("tlbParams");
                        if (tlbParams !== undefined) {
                            var childViews = tlbParams.getChildViews();
                            var parameters = [];
                            for (var i = 0; i < childViews.length; i++) {
                                var child = childViews[i];
                                var id = child.config.id;
                                var value_field = child.config.value_field;
                                var item = {
                                    columnName: value_field,
                                    value: $$(id).getValue()
                                };
                                parameters.push(item);
                            }
                            url = url + "&tlbparam=" + JSON.stringify(parameters);
                        }
                        else {
                            url = url + "&tlbparam=null";
                        }
                        webix.ajax(url, callback, view);
                    }
                },
                columns: [
                    { id: "index", header: "", sort: "int", width: 40 },
                    { id: "subjectname", header: _("SUBJECTNAME"), width: 550 },
                    { id: "so_serial", header: _("SO_SERIAL"), width: 250 },
                    { id: "nguoiky", header: _("NGUOI_KY"), width: 200 },
                    {
                        id: "ngaybatdau",
                        header: _("NGAY_BAT_DAU"),
                        width: 150,
                        format: function (text) {
                            var format = webix.Date.dateToStr("%d/%m/%Y %H:%i:%s");
                            text = removeTimeZoneT(text);
                            return format(text);
                        }
                    },
                    {
                        id: "ngayketthuc",
                        header: _("NGAY_HET_HAN"),
                        width: 150,
                        format: function (text) {
                            var format = webix.Date.dateToStr("%d/%m/%Y %H:%i:%s");
                            text = removeTimeZoneT(text);
                            return format(text);
                        }
                    },
                    {
                        id: "chon",
                        checkValue: "true",
                        uncheckValue: "false",
                        template: function (obj, common, value) {
                            if (value)
                                return "<div class='webix_icon fa-check-square-o'></div>";
                            else
                                return "<div class='webix_icon fa-square-o'></div>";
                        },
                        header: _("CHON"),
                        width: 100
                    },
                    { id: "issuer", header: _("DONVI"), width: 550 },
                    { id: "libraryName", header: _("Loại"), width: 120 }
                ],
                pager: "pagerA"
            },
            {
                cols: [
                    {
                        view: "icon", icon: "fas fa-question-circle", id: "help_form_views", tooltip: _("HELPER"),
                        css: "helper",
                        click: function () {
                            webix.alert({
                                title: "Thông báo !",
                                text: "Bạn chưa khai báo hướng dẫn nhanh cho màn hình này !",
                                type: "alert-warning",
                                callback: function (result) {
                                }
                            });
                        }
                    },
                    {
                        view: "combo",
                        label: _("MENU_QUICK"),
                        id: "QuickMenu",
                        options: {
                            // view: "gridsuggest",
                            // id: "grid_window",
                            // template: "#name#",
                            // body: {
                            //     scroll: true,
                            //     autoheight: false,
                            //     columns: [
                            //         { id: "window_id", header: "Window Id", editor: "text", width: 100 },
                            //         { id: "name", header: "Window Name", editor: "text", width: 400 }
                            //     ],
                            //     url: app.config.host + "/System/GetQuickMenu"
                            // },
                            // on: {
                            //     onValueSuggest: function (obj) {
                            //         var start = obj.window_id != "" ? obj.code + ":" + obj.window_id : obj.code;
                            //         window.location.hash = "!/app/" + start;
                            //         $$("QuickMenu").setValue(null);
                            //     }
                            // }
                        },
                        on: {
                            onChange: function (newv, oldv) {

                            }
                        }
                    },
                    {},
                    {
                        id: "pagerA",
                        view: "pager",
                        size: 100,
                        group: 5,
                        template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}"
                    }
                ]
            }
        ]
    }

    var layout = {
        css: "frmView",
        rows: [
            {
                height: 39,
                css: "btnControl",
                type: "toolbar",
                margin: 0,
                borderless: true,
                cols: controls
            },
            {
                rows: [
                    grid
                ]
            }
        ]

    };

    return {
        $ui: layout,
        $oninit: function (view, $scope) {
            var url = app.config.host + "/System/ExecuteCommand";
            webix.ajax()
                .headers({ "Content-Type": "application/json" })
                .post(url, {
                    command: "CM00019",
                    parameter: {
                        ma_dvcs: ""
                    }
                }, function (text) {
                    var array = JSON.parse(text);

                    var kytaptrung = "";
                    var server_cert = "";

                    for (var i = 0; i < array.length; i++) {
                        var item = array[i];

                        if (item.ma == "KYTAPTRUNG") {
                            kytaptrung = item.gia_tri;
                        }

                        if (item.ma == "FILE") {
                            kytaptrung = item.gia_tri;
                        }

                        if (item.ma == "SERVER_CERT") {
                            server_cert = item.gia_tri;
                        }
                    }
                    $$("dmwindowData").config.kytaptrung = kytaptrung;
                    $$("dmwindowData").config.server_cert = server_cert;
                });
            $scope.on(app, "dataChanged", function (mode, item) {
                var table = webix.$$("dmwindowData");
                if (mode == 1) {
                    if (item != undefined)
                        table.add(item);
                    //table.select(item.iddmwindow,false);
                }

                if (mode == 2) {
                    var selectedItem = table.getSelectedItem();
                    table.updateItem(selectedItem.id, item);
                }
            });
        }
    };
});
define('views/modules/dashline',["app"], function (app) {

	return {
		$ui: {
			height: 136,
			css: "tiles",
			template: function (data) {
				var t = null;
				if (data.items == undefined) return;
				var items = data.items;
				var html = "<div class='flex_tmp'>";
				for (var i = 0; i < items.length; i++) {
					t = items[i];
					var soluong = webix.Number.format(t.soluong, {
						groupDelimiter: ",",
						groupSize: 3,
						decimalDelimiter: ".",
						decimalSize: 0
					});

					var tien = webix.Number.format(t.tien, {
						groupDelimiter: ",",
						groupSize: 3,
						decimalDelimiter: ".",
						decimalSize: 0
					});

					var code = "duyethoadon";
					var params = "0" + t.id;

					if (t.id == "03") {
						code = "bangkebanra";
					}

					html += "<div class='item " + t.css + "'>";
					html += "<div class='webix_icon icon fa-" + t.icon + "'></div>";
					html += "<div class='details'>";
					html += "<div class='text'>" + t.dien_giai + "</div><div class='value'><table style ='font-size:13px;text-align: left;'><tr><th>Số lượng: </th><th>" + soluong + "</th></tr><tr><td>Doanh thu: </td><td>" + tien + "</td></tr></table></div></div>";
					html += "<a href='#' onclick=\"var menu=$$('app:menu'); if(" + t.quyen + " ==0 ) { webix.message('Bạn chưa được phân quyền !','error'); return ;} $$('bodyInvoice').removeView('hr');$$('bodyInvoice').removeView('hr2');"
						+ "  require(['app'], function(app){"
						+ " app.router('app/" + code + ":" + params + "' );"
						+ "});\" style='color:white;text-decoration: none;'><div class='footerDash'>Chi tiết <span class='webix_icon fa-angle-double-right'></span></div></a>";
					html += "</div>";
				}
				html += "</div>";
				return html;
			},
			url: app.config.host + "/Invoice/DashboardTiles"
		}
	};

});
define('views/modules/data_invoice',["app", "locale"], function (app, _) {

    return {
        $ui: {
            "css": "table_dash_invoice",
            // "type": "clean",
            "rows": [
                {
                    "template": "<span class='webix_icon fa-star' style='color:#FF892A'></span><b style='color:blue'> Danh sách mẫu hóa đơn sử dụng</b>", "css": "sub_title", "height": 30
                },
                {
                    "view": "datatable",
                    "css": "mcls_invoiceDashboard",
                    "url": app.config.host + "/Invoice/DashboardInvoices",
                    "footer": "true",
                    "resize": "true",
                    "columns": [
                        {
                            id: "mau_so",
                            header: "Mẫu hóa đơn",
                            css: { "text-align": "center !important" },
                            template: "<a  style = 'text-decoration: none; color:blue;' href='#' onclick=\"var menu=$$('app:menu');"
                            + "	require(['app'], function(app){ "
                            + " app.router('app/window:#win#:#id#'); var k = webix.$$('tlbParams');"
                            + "}); \" >#mau_so#</a>",
                            fillspace: 1

                        },
                        {
                            id: "ky_hieu",
                            header: "Ký hiệu",
                            css: { "text-align": "center" },
                            fillspace: 1
                        },
                        {
                            id: "ngay_bd_sd",
                            header: "Ngày sử dụng",
                            css: { "text-align": "center" },
                            fillspace: 1,
                            format: function (text) {
                                var format = webix.Date.dateToStr("%d/%m/%Y");
                                text = removeTimeZoneT(text);
                                return format(text);
                            }
                        },
                        {
                            id: "so_luong",
                            header: "Số lượng",
                            width: 120,
                            css: { "text-align": "center !important", "color": "blue", "font-weight": "bold" },
                            format: webix.Number.numToStr({
                                groupDelimiter: ",",
                                groupSize: 3,
                                decimalDelimiter: ".",
                                decimalSize: 0
                            }),
                            footer: { content: "summColumn" }
                        },
                        {
                            id: "sl_xuat",
                            header: "Đã xuất",
                            width: 120,
                            css: { "text-align": "center !important", "color": "red", "font-weight": "bold" },
                            format: webix.Number.numToStr({
                                groupDelimiter: ",",
                                groupSize: 3,
                                decimalDelimiter: ".",
                                decimalSize: 0
                            }),
                            footer: { content: "summColumn" }
                        },
                        {
                            id: "con_lai",
                            header: "Còn lại",
                            width: 120,
                            css: { "text-align": "center", "font-weight": "bold", "color": "green" },
                            format: webix.Number.numToStr({
                                groupDelimiter: ",",
                                groupSize: 3,
                                decimalDelimiter: ".",
                                decimalSize: 0
                            }),
                            footer: { content: "summColumn" }
                        },
                        {
                            id: "trung_binh",
                            header: "Trung bình 1 ngày",
                            width: 130,
                            css: { "text-align": "center", "font-weight": "bold" },
                            format: webix.Number.numToStr({
                                groupDelimiter: ",",
                                groupSize: 3,
                                decimalDelimiter: ".",
                                decimalSize: 0
                            }),
                            footer: { content: "summColumn" }
                        }
                    ]
                }
            ]
        }
    };

});
define('views/modules/chart',["app"], function (app) {

    return {
        $ui: {
            "type": "clean",
            "cols": [
                {
                    rows: [
                        {
                            "template": "<span class='webix_icon fa-chart-bar' style='color:#FF892A;'></span><b style='color:blue'> Doanh thu ( triệu đồng )</b>",
                            "css": "sub_title",
                            "height": 30,
                            // "paddingX": 10,
                            // "paddingY": 10,
                            // "margin-left": 10
                        },
                        {
                            view: "chart",
                            type: "line",
                            barWidth: 165,
                            radius: 0,
                            resize: true,
                            gradient: "falling",
                            // value: "#hd01#",a
                            // label: "#hd01#",
                            preset: "column",
                            //border:false,
                            borderless: true,
                            xAxis: {
                                title: "Tháng",
                                lines: false,
                                template: "<span style = 'font-size:11px'> #thang#</span>"
                            },
                            yAxis: {
                                //  title: "Years",
                                //  lines: true,
                                start: 0,
                                step: 500,
                                end: 5000,
                                template: function (obj) {
                                    return (obj % 500 ? "" : obj)
                                }
                            },
                            legend: {
                                values: [{ text: "01GTKT", color: "#4bbaa4" }, { text: "02GTTT", color: "#ee9e36" }, { text: "03XKNB", color: "#36abee" }, { text: "07KPTQ", color: "#ee3639" }, { text: "01BLP", color: "#914ad8" }],
                                valign: "middle",
                                align: "right",
                                width: 90,
                                layout: "y",
                                marker: {
                                    type: "round",
                                    // width:15,
                                    radius: 3
                                }
                            },
                            eventRadius: 5,
                            series: [
                                {
                                    preset: "column",
                                    barWidth: 65,
                                    alpha: 1,
                                    value: "#hd01#",
                                    color: "#4bbaa4",
                                    item: {
                                        // radius: 3,
                                        // type: "s",
                                        borderColor: "#1777ef",
                                        color: "#ffffff"
                                    },
                                    line: {
                                        color: "#4bbaa4",
                                        width: 2
                                    },
                                    tooltip: {
                                        template: "Type: 01GTKT<br/>Value: #hd01#"
                                    }
                                },
                                {
                                    alpha: 0.5,
                                    value: "#hd02#",
                                    color: "#ee9e36",
                                    item: {
                                        borderColor: "#1777ef",
                                        color: "#ffffff"
                                    },
                                    line: {
                                        color: "#ee9e36",
                                        width: 2
                                    },
                                    tooltip: {
                                        template: "Type: 02GTTT<br/>Value: #hd02#"
                                    }
                                },
                                {
                                    alpha: 0.5,
                                    value: "#hd03#",
                                    color: "#36abee",
                                    item: {
                                        borderColor: "#1777ef",
                                        color: "#ffffff"
                                    },
                                    line: {
                                        color: "#36abee",
                                        width: 2
                                    },
                                    tooltip: {
                                        template: "Type: 03XKNB<br/>Value: #hd03#"
                                    }
                                },
                                {
                                    alpha: 0.5,
                                    value: "#hd07#",
                                    color: "#ee3639",
                                    item: {
                                        borderColor: "#1777ef",
                                        color: "#ffffff"
                                    },
                                    line: {
                                        color: "#ee3639",
                                        width: 2
                                    },
                                    tooltip: {
                                        template: "Type: 07KPTQ<br/>Value: #hd07#"
                                    }
                                },
                                {
                                    alpha: 0.5,
                                    value: "#bienlai#",
                                    color: "#914ad8",
                                    item: {
                                        borderColor: "#1777ef",
                                        color: "#ffffff"
                                    },
                                    line: {
                                        color: "#914ad8",
                                        width: 2
                                    },
                                    tooltip: {
                                        template: "Type: 01BLP<br/>Value: #bienlai#"
                                    }
                                }
                            ],
                            url: app.config.host + "/Invoice/bar_chart"
                        }
                    ]
                }
            ]
        }
    };

});
define('views/modules/minvoice_news',["app"], function (app) {
    return {
        $ui: {
            "type": "clean",
            autowidth: true,
            rows: [
                {
                    template: "<span class='webix_icon fa-newspaper-o' style='color:#FF892A;'></span><b style='color:blue'> Tin tức</b>",
                    css: "sub_title",
                    height: 30
                },
                {
                    cols: [
                        {
                            view: "list",
                            borderless: true,
                            id: "minvoiceNews",
                            name: "minvoiceNews",
                            select: true,
                           //  gravity: 2,
                            on: {
                                onAfterLoad: function () {
                                    var slideIndex = 0;
                                    showSlides();
                                    function showSlides() {
                                        var i;
                                        var slides = document.getElementsByClassName("mySlides");
                                        for (i = 0; i < slides.length; i++) {
                                            slides[i].style.display = "none";
                                        }
                                        slideIndex++;
                                        if (slideIndex > slides.length)
                                            slideIndex = 1;
                                        if (slides[slideIndex - 1] != undefined)
                                            slides[slideIndex - 1].style.display = "flex";
                                        setTimeout(showSlides, 3000);
                                    }
                                }
                            },
                            type: {
                                templateStart: `<div class="slideshow-container">`,
                                template: '<div class="mySlides fadeDash">'
                                    + '<div class ="imghaha"><a style ="float:right;text-decoration: none;color:blue;" href="#url#" target="_blank"><img src="#url_image#" class="imgNews" alt="NAM PV"></div>'
                                    + '<div class="texthaha"><h5><a style ="float:left;text-decoration: none;color:black;color:blue;" href="#url#" target="_blank">#title#</a></h5><br><span class="webix_icon mdi mdi-calendar"></span>#date_new#</br><p>#description#</p>'
                                    + '<br><a style ="float:right;text-decoration: none;color:blue;" href="#url#" target="_blank">Xem thêm</a></div>'
                                    // + '<div class="numbertext">1 / 3</div>'
                                    + '</div>',
                                templateEnd: '</div>'
                            },
                            url: app.config.host + "/System/MinvoiceNews"
                        }
                    ]
                }
            ]
        }
    };

});
define('views/modules/TrangChu/dashline',["app", "locale"], function (app, _) {
  var fm = function (number) {
    var k = webix.Number.numToStr({
      groupDelimiter: ".",
      groupSize: 3,
      decimalDelimiter: ",",
      decimalSize: 0
    });
    return k(number);
  };
  var title_bc = "Hóa đơn NĐ123 > Báo cáo > Báo cáo tổng hợp hóa đơn";
  var title_04ss = "Hóa đơn NĐ123 > Quản lý Thông báo 04/SS-HDDT";
  var title_invoice = "Hóa đơn NĐ123 > Lập hóa đơn (Có mã CQT) > Hóa đơn giá trị gia tăng";
  var title_tdiep = "Hóa đơn NĐ123 > Danh sách thông điệp trả về";
  return {
    $ui: {
      height: 128,
      css: "tiles",
      borderless: true,
      template: `<div class="flex_tmp">
      <div class="item orders">
         <div class="webix_icon icon fa-pencil"></div>
         <div class="details">
            <div class="text">${_("DS_HDON")}</div>
            <div class="value">
               <table class="tableDash" style="font-size:13px;text-align: left;">
                  <tbody>
                     <tr>
                        <th>Quản lý lập, phát hành và xử lý hóa đơn </th>
                     </tr>
                  </tbody>
               </table>
            </div>
         </div>
         <a href="#" onclick="var menu=$$('app:menu'); if(1==0 ) { webix.message('Bạn chưa được phân quyền !','error'); return ;} 
            require(['app'], function(app){ if (webix.$$('title') != undefined)
						webix.$$('title').parse({ title: '${title_invoice}', details: '${title_invoice}', code: '${title_invoice}' }); app.router('app/68_invoiceViews_code_01' );});" style="color:white;text-decoration: none;">
            <div class="footerDash">Truy cập <span class="webix_icon fa-angle-double-right"></span></div>
         </a>
      </div>
      <div class="item users">
         <div class="webix_icon icon fa-quote-right"></div>
         <div class="details">
            <div class="text">${_("BC_TK")}</div>
            <div class="value">
               <table class="tableDash" style="font-size:13px;text-align: left;">
                  <tbody>
                     <tr>
                        <th>Báo cáo hóa đơn tổng hợp, chi tiết </th>
                     </tr>
                  </tbody>
               </table>
            </div>
         </div>
         <a href="#" onclick="var menu=$$('app:menu'); if(1==0 ) { webix.message('Bạn chưa được phân quyền !','error'); return ;} 
            require(['app'], function(app){ if (webix.$$('title') != undefined)
						webix.$$('title').parse({ title: '${title_bc}', details: '${title_bc}', code: '${title_bc}' }); app.router('app/68_bc_tonghophoadon' );});" style="color:white;text-decoration: none;">
            <div class="footerDash">Truy cập <span class="webix_icon fa-angle-double-right"></span></div>
         </a>
      </div>
      <div class="item feedbacks">
         <div class="webix_icon icon fa-check-square-o"></div>
         <div class="details">
            <div class="text"> ${_("LS_TN")}</div>
            <div class="value">
               <table class="tableDash" style="font-size:13px;text-align: left;">
                  <tbody>
                     <tr>
                        <th>Xem lịch sử truyền nhận dữ liệu với Cơ quan thuế </th>
                     </tr>
                  </tbody>
               </table>
            </div>
         </div>
         <a href="#" onclick="var menu=$$('app:menu'); if(1==0 ) { webix.message('Bạn chưa được phân quyền !','error'); return ;} 
         require(['app'], function(app){ if (webix.$$('title') != undefined)
         webix.$$('title').parse({ title: '${title_tdiep}', details: '${title_tdiep}', code: '${title_tdiep}' }); app.router('app/68_viewLogs' );});" style="color:white;text-decoration: none;">
         <div class="footerDash">Truy cập <span class="webix_icon fa-angle-double-right"></span></div>
      </a>
      </div>
      <div class="item mau04ss">
         <div class="webix_icon icon fa-exclamation-triangle"></div>
         <div class="details">
            <div class="text">${_("TB_SAISOT")}</div>
            <div class="value">
               <table class="tableDash" style="font-size:13px;text-align: left;">
                  <tbody>
                     <tr>
                        <th>Thông báo hóa đơn điện tử có sai sót đến cơ quan thuế theo mẫu 04/SS-HĐĐT</th>
                     </tr>
                  </tbody>
               </table>
            </div>
         </div>
         <a href="#" onclick="var menu=$$('app:menu'); if(1==0 ) { webix.message('Bạn chưa được phân quyền !','error'); return ;} 
         require(['app'], function(app){ if (webix.$$('title') != undefined)
         webix.$$('title').parse({ title: '${title_04ss}', details: '${title_04ss}', code: '${title_04ss}' }); app.router('app/68_mau0405' );});" style="color:white;text-decoration: none;">
         <div class="footerDash">Truy cập <span class="webix_icon fa-angle-double-right"></span></div>
      </a>
      </div>
   </div>`
      // template: function (data) {
      //   var t = null;
      //   if (data.items == undefined) return;
      //   var items = data.items;
      //   var html = "<div class='flex_tmp'>";
      //   for (var i = 0; i < items.length; i++) {
      //     t = items[i];
      //     var soluong = fm(t.soluong);
      //     var tien = fm(t.tien);
      //     if (t.id == "1" || t.id == "2") {
      //       var code = "duyethoadon";
      //       var params = "0" + t.id;
      //       var duyethoadon = `<div class='item ${t.css}'>
      //       <div class='webix_icon icon fa-${t.icon}'></div>
      //       <div class='details'>
      //       <div class='text'>${t.dien_giai}</div>
      //       <div class='value'>
      //       <table class='tableDash' style ='font-size:13px;text-align: left;'>
      //       <tr><th>Số lượng: </th><th>${soluong}</th></tr>
      //       </table>
      //       </div>
      //       </div>
      //       <a href='#' onclick=\"var menu=$$('app:menu'); if(${t.quyen}==0 ) { webix.message('Bạn chưa được phân quyền !','error'); return ;} 
      //       $$('bodyInvoice').removeView('hr');$$('bodyInvoice').removeView('hr2')
      //       require(['app'], function(app){ app.router('app/${code}:${params}' );});\" style='color:white;text-decoration: none;'>
      //       <div class='footerDash'>Chi tiết <span class='webix_icon fa-angle-double-right'></span></div></a>
      //       </div>`;
      //       html += duyethoadon;
      //     }
      //     if (t.id == "3") {
      //       var daguithue = `<div class='item ${t.css}'>
      //       <div class='webix_icon icon fa-${t.icon}'></div>
      //       <div class='details'>
      //       <div class='text'> ${t.dien_giai}</div>
      //       <div class='value'><table class='tableDash' style ='font-size:13px;text-align: left;'><tr><th>Số lượng: </th><th>${soluong}</th></tr>
      //       <tr><td>Thành công: </td><td>${fm(t.thanh_cong)}</td></tr>
      //       <tr><td>Giá trị: </td><td>${tien}</td></tr>
      //       <tr><td>Có lỗi: </td><td>${fm(t.co_loi)}</td></tr>
      //       </table></div></div>
      //       </div>`;
      //       html += daguithue;
      //     }
      //     if (t.id == "4") {
      //       var hdon04ss = `<div class='item ${t.css}'>
      //       <div class='webix_icon icon fa-${t.icon}'></div>
      //       <div class='details'>
      //       <div class='text'>${t.dien_giai}</div>
      //       <div class='value'><table class='tableDash' style ='font-size:13px;text-align: left;'><tr><th>Số lượng hóa đơn sai sót: </th><th>${soluong}</th></tr>
      //       <tr><td>Hóa đơn đã lập 04SS: </td><td>${t.sl_hd_04}</td></tr>
      //       <tr><td>Hóa đơn cần lập 04SS: </td><td>0</td></tr>
      //       <tr><td>Số lượng thông báo 04SS: </td><td>${t.sl_tb_04}</td></tr>
      //       </table></div></div>
      //       </div>`;
      //       html += hdon04ss;
      //     }
      //   }
      //   html += "</div>";
      //   return html;
      // },
      // url: app.config.host + "/Pattern/Head",
    },
  };
});

define('views/modules/TrangChu/data_invoice',["app", "locale"], function (app, _) {
    return {
        $ui: {
            "css": "table_dash_invoice",
            "rows": [
                {
                    "template": `<span class='webix_icon fa-star' style='color:#FF892A'></span><b style='color:blue'> ${_("DS_KHIEU_HD")}</b>`, "css": "sub_title", "height": 30
                },
                {
                    "view": "datatable",
                    "css": "mcls_invoiceDashboard",
                    "url": app.config.host + "/Pattern/DashTable",
                    "footer": "true",
                    "resize": "true",
                    id: "tblDasInvoice",
                    minHeight: 150,
                    onClick: {
                        "clickInvoice": function (event, cell, target) {
                            var table = webix.$$("tblDasInvoice");
                            var item = table.getItem(cell.row);
                            app.router('app/' + item.router + ":" + item.cctbao_id);
                            webix.storage.local.put("MENU_ID", item.menu_id);
                            var mes = "Lập hóa đơn -> Hóa đơn GTGT có mã của CQT";
                            if (item.khhdon.substring(1, 1) == "K")
                                var mes = "Lập hóa đơn -> Hóa đơn bán hàng (Có mã CQT)";
                            if (webix.$$('title') != undefined)
                                webix.$$('title').parse({ title: mes, details: mes });
                        }
                    },
                    "columns": [
                        {
                            id: "loaihd",
                            header: "Loại hóa đơn",
                            fillspace: 1,
                            template: function (obj) {
                                var response = "";
                                if (obj.khhdon.startsWith("1"))
                                    response = "Hóa đơn giá trị gia tăng";
                                if (obj.khhdon.startsWith("2"))
                                    response = "Hóa đơn bán hàng";
                                if (obj.khhdon.startsWith("5"))
                                    response = "Tem, vé, thẻ điện tử";
                                if (obj.khhdon.startsWith("6")) {
                                    if (obj.khhdon[4] == "B")
                                        response = "Phiếu xuất kho kiêm vận chuyển hàng đại lý";
                                    else
                                        response = "Phiếu xuất kho kiêm vận chuyển nội bộ";
                                }
                                return response;
                            }
                        },
                        {
                            id: "khhdon",
                            header: "Ký hiệu",
                            css: { "text-align": "center" },
                            template: "<a class='clickInvoice'  style = 'text-decoration: none; color:blue;' href='#' >#khhdon#</a>",
                            // template: "<a  style = 'text-decoration: none; color:blue;' href='#' onclick=\"var menu=$$('app:menu');"
                            //     + "	require(['app'], function(app){ "
                            //     + " app.router('app/#router#');"
                            //     //app.show("/login");
                            //     + "}); \" >#khhdon#</a>",
                        },
                        {
                            id: "date_new", header: "Ngày tạo ký hiệu", css: { "text-align": "center" }, fillspace: 1, format: function (text) {
                                return formatDate(text);
                            }
                        },
                        // { id: "cho_ky", header: "Hóa đơn chưa ký", css: { "text-align": "center" }, fillspace: 1, },
                        // { id: "da_gui", header: "Hóa đơn đã gửi", css: { "text-align": "center" }, fillspace: 1, },
                        // { id: "thanh_cong", header: "Thành công", css: { "text-align": "center" }, fillspace: 1, },
                        // { id: "co_loi", header: "Có lỗi", css: { "text-align": "center" }, fillspace: 1, }
                    ]
                }
            ]
        }
    };

});
define('views/SearchMst',["app", "locale"], function (app, _) {
    var editmode = 0;
  
    return {
      $ui: {
        view: "window",
        modal: true,
        id: "dmtab-win",
        position: "center",
        head: "Thông tin tìm kiếm",
        body: {
          paddingY: 10,
          paddingX: 10,
          elementsConfig: {
            labelWidth: 60,
            labelPosition: "top",
          },
          view: "form",
          id: "license-form",
          complexData: true,
          margin: 0,
          borderless: true,
          elements: [
            
            {
              view: "text",
              name: "ten_dvcs",
              label: _("TEN_DON_VI"),
            },
            {
                view: "text",
                name: "dia_chi",
                label: "Địa chỉ",
                width: 450,
               
              },
            {
                view: "text",
                name: "ms_thue",
                label: _("MS_THUE"),
                width: 450,
               
              },
              {
                view: "text",
                name: "cqthuecap_tinh",
                label: "CQT cấp tỉnh",
                width: 450,
                
              },
              {
                view: "text",
                name: "cqthue_ql",
                label: "CQT cấp quản lý",
                width: 450,
                
              },
              {
                view: "text",
                name: "nguoi_dai_dien",
                label: "Người đại diện",
                width: 450,
                
              },
              {
                view: "text",
                name: "ngay_thanh_lap",
                label: "Ngày thành lập",
                width: 450,
                
              },
            
            {
              margin: 10,
              cols: [
                {},
                // {
                //   shortcut: "F10",
                //   id: "btnSave",
                //   view: "button",
                //   label: "Nhận (F10)",
                //   type: "form",
                //   align: "center",
                //   width: 120,
                //   on: {
                //   //   onClick: function () {
                //   //     var form = webix.$$("license-form");
                //   //     var item = form.getValues();
  
                //   //     if (
                //   //       item.sl_dk_them < 1 ||
                //   //       item.sl_dk_them == "" ||
                //   //       item.sl_dk_them == null
                //   //     ) {
                //   //       webix.message(
                //   //         "Số lượng đăng ký thêm không được để trống hoặc bằng 0 !",
                //   //         "error"
                //   //       );
                //   //       return false;
                //   //     }
                //   //     if ($$("license-form").validate()) {
                //   //       var url = app.config.host + "/License/Register";
  
                //   //       webix.extend(form, webix.ProgressBar);
                //   //       form.disable();
                //   //       form.showProgress();
  
                //   //       webix
                //   //         .ajax()
                //   //         .bind(this)
                //   //         .headers({ "Content-type": "application/json" })
                //   //         .post(url, item, function (text) {
                //   //           var result = JSON.parse(text);
  
                //   //           if (!result.hasOwnProperty("error")) {
                //   //             var interVal = setInterval(function () {
                //   //               var url =
                //   //                 app.config.host +
                //   //                 "/License/CheckLicense?id=" +
                //   //                 result.id;
  
                //   //               webix.ajax(url, {
                //   //                 error: function (text, data, XmlHttpRequest) {
                //   //                   webix.message(text);
  
                //   //                   var form = webix.$$("license-form");
                //   //                   form.enable();
                //   //                   form.hideProgress();
  
                //   //                   clearInterval(interVal);
                //   //                 },
                //   //                 success: function (text, data, XmlHttpRequest) {
                //   //                   var result = JSON.parse(text);
  
                //   //                   if (!result.hasOwnProperty("error")) {
                //   //                     var form = webix.$$("license-form");
  
                //   //                     var values = form.getValues();
                //   //                     values.key_license = result.key_license;
                //   //                     values.sl_dk_them = 0;
                //   //                     values.sl_hd = result.sl_hd;
  
                //   //                     form.setValues(values);
  
                //   //                     form.enable();
                //   //                     form.hideProgress();
  
                //   //                     clearInterval(interVal);
                //   //                   }
                //   //                 },
                //   //               });
                //   //             }, 3000);
                //   //           } else {
                //   //             webix.message(result.error, "error");
  
                //   //             var form = webix.$$("license-form");
                //   //             form.enable();
                //   //             form.hideProgress();
                //   //           }
                //   //         });
                //   //     }
                //   //   },
                //   },
                //   click: function () {
                //     this.callEvent("onClick");
                //   },
                // },
                {
                  view: "button",
                  hotkey: "esc",
                  label: "Hủy bỏ (ESC)",
                  type: "danger",
                  align: "center",
                  width: 120,
                  click: function () {
                    webix.$$("dmtab-win").close();
                  },
                },
                {},
              ],
            },
          ],
        },
      },
      setEditMode: function (mode) {
        editmode = mode;
      },
    };
  });
  
define('views/forms/forms68/TrangChu/68_extendInvoice',["app", "locale"], function (app, _) {
  return {
    $ui: {
      view: "window",
      modal: true,
      id: "dmtab-winLicense",
      position: "center",
      head: "Thông tin bản quyền NĐ123",
      body: {
        paddingY: 10,
        paddingX: 10,
        elementsConfig: {
          labelWidth: 60,
          labelPosition: "top"
        },
        view: "form",
        id: "license-form78",
        complexData: true,
        margin: 0,
        borderless: true,
        elements: [
          { view: "text", name: "ms_thue", label: _("MS_THUE"), width: 450, readonly: true, css: "mcls_readonly_text" },
          { view: "text", name: "ten_dvcs", label: _("TEN_DON_VI"), readonly: true, css: "mcls_readonly_text" },
          { view: "autonumeric", name: "sl_hd", label: _("SL_HD_DK"), readonly: true, css: "mcls_readonly_text" },
          {
            view: "autonumeric", name: "sl_dk_them",
            label: _("SL_HD_THEM"), required: true,
            invalidMessage: "Số lượng nhập không đúng giá trị >= 1 !",
            validate: webix.rules.isNumber,
            on: {
              onChange: function (newv, oldv) {
                if (newv == undefined) return;
                if (newv == "") return;
                // if (newv < 1) {
                // 	webix.message("Số lượng đăng ký phải lớn hơn hoặc bằng 1", "error");
                // 	return;
                // }
              }
            }
          },
          {
            view: "textarea",
            name: "nguoi_lien_he",
            label: _("Thông tin người liên hệ"),
            required: true,
            placeholder: "Nhập số điện thoại, email",
            invalidMessage: "Bạn phải nhập thông tin người liên hệ",
            validate: webix.rules.isNotEmpty,
            on: {
              onChange: function (newv, oldv) {
                if (newv == undefined) return;
                if (newv == "") return;
              }
            }
          },
          { view: "text", name: "key_license", label: _("KEY_LICENSE"), readonly: true, inputAlign: "center", css: "mcls_license_text" },
          {
            margin: 10,
            cols: [
              {},
              {
                shortcut: "F10", view: "button", id: "btnSave", badge: "F10", css: "webix_primary",
                label: "Gia hạn", type: "icon", align: "center", width: 120,
                on: {
                  onClick: function () {
                    var form = webix.$$("license-form78");
                    var item = form.getValues();

                    if (item.sl_dk_them < 1 || item.sl_dk_them == "" || item.sl_dk_them == null) {
                      webix.message("Số lượng đăng ký thêm không được để trống hoặc bằng 0 !", "error");
                      return false;
                    }
                    if ($$("license-form78").validate()) {
                      var url = app.config.host + "/License/Register";
                      webix.extend(form, webix.ProgressBar);
                      form.disable();
                      form.showProgress();
                      webix
                        .ajax()
                        .bind(this)
                        .headers({ "Content-type": "application/json" })
                        .post(url, item, function (text) {
                          var result = JSON.parse(text);
                          if (!result.hasOwnProperty("error")) {
                            var interVal = setInterval(function () {
                              var url = app.config.host + "/License/CheckLicense?id=" + result.id;
                              webix.ajax(url, {
                                error: function (text, data, XmlHttpRequest) {
                                  webix.message(text);
                                  var form = webix.$$("license-form78");
                                  form.enable();
                                  form.hideProgress();
                                  clearInterval(interVal);
                                },
                                success: function (text, data, XmlHttpRequest) {
                                  var result = JSON.parse(text);

                                  if (!result.hasOwnProperty("error")) {
                                    var form = webix.$$("license-form78");

                                    var values = form.getValues();
                                    values.key_license = result.key_license;
                                    values.sl_dk_them = 0;
                                    values.sl_hd = result.sl_hd;

                                    form.setValues(values);
                                    form.enable();
                                    form.hideProgress();

                                    clearInterval(interVal);
                                  }
                                },
                              });
                            }, 3000);
                          } else {
                            webix.message(result.error, "error");

                            var form = webix.$$("license-form78");
                            form.enable();
                            form.hideProgress();
                          }
                        });
                    }
                  }
                },
                click: function () {
                  this.callEvent("onClick");
                }
              },
              {
                view: "button", hotkey: "esc", label: "Hủy bỏ", badge: "ESC", css: "webix_danger",
                align: "center", type: "icon", width: 120,
                click: function () {
                  webix.$$("dmtab-winLicense").close();
                }
              },
              {}
            ]
          }
        ]
      }
    },
    setEditMode: function (mode) {
      editmode = mode;
    }
  };
});

define('views/forms/forms68/TrangChu/68_infoTaxcode',["app", "locale"], function (app, _) {

  return {
    $ui: {
      view: "window",
      modal: true,
      id: "win-searchtax",
      position: "center",
      head: "Kết quả tra cứu mã số thuế",
      body: {
        paddingY: 10,
        paddingX: 10,
        elementsConfig: {
          labelWidth: 60,
          labelPosition: "top"
        },
        view: "form",
        id: "form-searchtax",
        complexData: true,
        margin: 0,
        borderless: true,
        elements: [
          { view: "text", name: "ma_so_thue", label: _("MS_THUE"), width: 650, readonly: true, css: "mcls_readonly_text" },
          { view: "text", name: "ten_cty", label: _("Tên công ty"), readonly: true, css: "mcls_readonly_text" },
          { view: "textarea", name: "dia_chi", label: _("Địa chỉ"), readonly: true, css: "mcls_readonly_text" },
          { view: "text", name: "cqthuecap_tinh", label: _("Thành phố"), readonly: true, css: "mcls_readonly_text" },
          { view: "text", name: "cqthue_ql", label: _("Chi cục"), readonly: true, css: "mcls_readonly_text" },
          { view: "text", name: "ngay_thanh_lap", label: _("Ngày thành lập"), readonly: true, css: "mcls_readonly_text" },
          { view: "text", name: "nguoi_dai_dien", label: _("Người đại diện"), readonly: true, css: "mcls_readonly_text" },
          {
            margin: 10,
            cols: [
              {},
              {
                view: "button", hotkey: "esc", label: "Hủy bỏ (ESC)", type: "danger", align: "center", width: 120,
                click: function () {
                  webix.$$("win-searchtax").close();
                }
              },
              {}
            ]
          }
        ]
      }
    },
    setValue: function (value) {
      $$("form-searchtax").setValues(value);
    }
  };
});

define('views/modules/TrangChu/chart',[
  "app",
  "locale",
  "views/SearchMst",
  "views/forms/forms68/TrangChu/68_extendInvoice",
  "views/forms/forms68/TrangChu/68_infoTaxcode"
], function (app, _, searchMst, extendInvoice, infotaxcode) {
  var fm = webix.Number.numToStr({
    groupDelimiter: ",",
    groupSize: 3,
    decimalDelimiter: ".",
    decimalSize: 0
  });
  var layout = {
    "css": "table_dash_invoice",
    rows: [
      {
        "template": `<span class='webix_icon fa-star' style='color:#FF892A'></span><b style='color:blue'> ${_("Thông tin bản quyền")}</b>`, "css": "sub_title", "height": 30
      },
      {
        "view": "datatable",
        "css": "mcls_invoiceDashboard",
        "url": app.config.host + "/Pattern/ChartPie",
        "footer": "true",
        "resize": "true",
        id: "tblLicense",
        onClick: {
          "clickInvoice": function (event, cell, target) { }
        },
        columns: [
          { id: "ten_loai", header: "Loại hóa đơn", fillspace: 1, },
          { id: "so_luong", header: "Số lượng đăng ký", css: { "text-align": "center" }, fillspace: 1, format: fm },
          { id: "su_dung", header: "Sử dụng", css: { "text-align": "center" }, fillspace: 1, format: fm },
          { id: "con_lai", header: "Còn lại", css: { "text-align": "center" }, fillspace: 1, format: fm }
        ]
      }
    ]
  };
  return {
    $ui: layout,
    $oninit: function (view, $scope) {
    },
    callBack: function () {
    }
  };
});

define('views/forms/forms68/TemVeThe/68_createInvoice',["app", "locale", "views/forms/forms68/HDon/68_printfMultiChoice"], function (app, _, printMulti) {
    var khieu;
    var type;
    return {
			$ui: {
				view: "window",
				modal: true,
				id: "68_ticket_create",
				position: "center",
				head: "In vé",
				headHeight: 50,
				width: 580,
				minheight: 450,
				move: false,
				body: {
					paddingY: 10,
					paddingX: 10,
					view: "form",
					id: "68_ticket_create_form",
					complexData: true,
					elementsConfig: { labelWidth: 100 },
					margin: 0,
					elements: [
						{
							cols: [
								{
									view: "datepicker",
									label: "Ngày lập vé",
									id: "tdlap",
									name: "tdlap",
									value: new Date(),
									format: "%d/%m/%Y",
									required: true,
									invalidMessage: "Ngày lập vé không được để trống",
									validate: webix.rules.isNotEmpty,
								},
							],
						},
						{
							cols: [
								{
									view: "text",
									label: "Tên hàng hóa",
									id: "ten",
									name: "ten",
									required: true,
									invalidMessage: "Tên hàng hóa không được để trống",
									validate: webix.rules.isNotEmpty,
								},
								{
									view: "autonumeric",
									label: "Mệnh giá",
									id: "dongia",
									name: "dongia",
									required: true,
									invalidMessage: "Mệnh giá không được để trống",
									validate: webix.rules.isNotEmpty,
								},
							],
						},
						{
							cols: [
								{
									view: "checkbox",
									label: "In nhiều",
									id: "multichk",
									name: "multi",
									on: {
										onChange: function (newV, oldV, config) {
											if (newV == true) $$("multiNo_txt").enable();
											else $$("multiNo_txt").disable();
										},
									},
								},
								{ view: "text", label: "", id: "multiNo_txt", name: "multiNo", placeholder: "Nhập số lượng in" },
								{ view: "checkbox", label: "Ký gửi CQT", id: "saveSign", name: "saveSign" },
								{ view: "text", label: "Thuế suất", id: "tsuat", name: "tsuat" },
							],
						},
						{
							cols: [
								{
									view: "text",
									label: "Biển số xe",
									id: "so_xe",
									name: "so_xe",
									invalidMessage: "Biển số xe không được vượt quá 30 ký tự",
									attributes: {
										style: "width: auto !important;",
									},
									validate: function (value) {
										return value.length <= 30;
									},
								},
							],
						},
						{ height: 8 },
						{
							margin: 10,
							cols: [
								{},
								{
									id: "crebtn",
									view: "button",
									label: "In vé",
									css: "webix_primary",
									click: function () {
										if ($$("68_ticket_create_form").validate()) {
											var item = $$("68_ticket_create_form").getValues();
											var number = !webix.rules.isNumber(webix.$$("multiNo_txt").getValue()) ? 1 : Number(webix.$$("multiNo_txt").getValue());
											item.NUMBER_PRINT = number;
											item.details = [
												{
													stt: 1,
													ten: item.ten,
													tgtien: item.dongia,
													tsuat: item.tsuat,
												},
											];
											var frm = $$("68_ticket_create");
											var apiHost = app.config.host + "/Ticket68/Save";
											if (type) apiHost = app.config.host + "/Ticket68/SaveReceipt";
											webix.extend(frm, webix.ProgressBar);
											frm.disable();
											frm.showProgress();
											webix
												.ajax()
												.headers({ "Content-type": "application/json" })
												.post(apiHost, item, {
													error: function (text, data, XmlHttpRequest) {
														webix.message(text + XmlHttpRequest, "error");
													},
													success: function (text, data, XmlHttpRequest) {
														var response = JSON.parse(text);
														var frm = $$("68_ticket_create");
														frm.enable();
														frm.hideProgress();
														if (response.code == "00") {
															webix.message("Tạo thành công", "success");
															var array = response.data;
															//var printForm = frm.$scope.ui(printMulti.$ui);
															var apiHostPrint = app.config.host + "/Invoice68/PrintInvoiceMulti";
															if (type) apiHostPrint = app.config.host + "/Invoice/PrintInvoiceMulti";
															// printMulti.initUI(idList, apiHostPrint);
															// printForm.show();
															var chunkSize = 9;
															var mimetype = "application/pdf";
															var box = webix.modalbox({
																title: "Đang in hóa đơn ....",
																text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
																width: 350,
																height: 200,
															});
															var promise = [];
															for (let i = 0; i < array.length; i += chunkSize) {
																var chunk = array.slice(i, i + chunkSize);
																var paramPrint = {
																	parameter: chunk,
																	type: "PDF",
																	opt: "medium",
																	optionPrint: "INVOICE",
																};
																var c = webix
																	.ajax()
																	.response("arraybuffer")
																	.headers({ "Content-type": "application/json" })
																	.post(apiHostPrint, paramPrint, {
																		error: function (text, data, XmlHttpRequest) {
																			webix.modalbox.hide(box);
																			if ($$("window-print") != undefined) $$("window-print").close();
																			alert(text);
																		},
																		success: function (text, data, XmlHttpRequest) {
																			webix.modalbox.hide(box);
																			if ($$("window-print") != undefined) $$("window-print").close();
																			var file = new Blob([data], { type: mimetype });
																			var fileURL = URL.createObjectURL(file);
																			var newWin = window.open();
																			var html =
																				"<html><head><title>Hóa đơn điện tử M-Invoice</title>" +
																				'<link rel="stylesheet" href="assets/fontawesome_pro/css/all.css" type="text/css" charset="utf-8">' +
																				'<link rel="stylesheet" href="assets/fontawesome.css" type="text/css" charset="utf-8">' +
																				'</head><body><center>Đang tải dữ liệu ... <br><p><i style="font-size:200%;" class="fa fa-spin fa-spinner"></i></p></center></body></html>';
																			newWin.document.write(html);
																			newWin.location = fileURL;
																		},
																	});
																promise.push(c);
															}
															webix.promise.all(promise).then(function (results) {
																var response = results[0].json();
															});
														} else {
															webix.message(response.message, "error");
														}
													},
												});
										}
									},
								},
								{
									id: "canbtn",
									view: "button",
									label: "Hủy",
									css: "webix_danger",
									align: "center",
									click: function () {
										webix.$$("68_ticket_create").close();
									},
								},
								{},
							],
						},
					],
				},
			},
			initUI: function (kyhieu_text, options) {
				khieu = kyhieu_text;
				type = options;
				webix
					.$$("68_ticket_create")
					.getHead()
					.setHTML("In vé có ký hiệu: " + kyhieu_text);
				if (options) {
					$$("tsuat").hide();
					$$("68_ticket_create_form").elements.saveSign.define("label", "Lưu và Ký");
					$$("68_ticket_create_form").elements.tdlap.define("label", "Ngày biên lai");
					webix
						.$$("68_ticket_create")
						.getHead()
						.setHTML("In biên lai: " + kyhieu_text);
				}
			},
		};
});

define('views/forms/forms68/TemVeThe/68_settingInvoice',["app", "locale"], function (app, _) {
    var quanlykyhieu68_id;
    var type;
    return {
			$ui: {
				view: "window",
				modal: true,
				id: "68_ticket_setting_win",
				position: "center",
				head: "Cấu hình vé",
				headHeight: 50,
				width: 580,
				minheight: 450,
				move: true,
				body: {
					paddingY: 10,
					paddingX: 10,
					view: "form",
					id: "68_ticket_setting_form",
					complexData: true,
					elementsConfig: { labelWidth: 150 },
					margin: 0,
					elements: [
						{ view: "text", label: "Tên hàng hóa", name: "ten", id: "ten", attributes: { maxlength: 255 } },
						{ view: "text", label: "Biển số xe", name: "so_xe", id: "so_xe", attributes: { maxlength: 30 } },
						{ view: "autonumeric", label: "Mệnh giá bao gồm VAT", id: "dongia", decimalPlaces: 6, name: "dongia" },
						{ view: "combo", label: "Thuế suất", options: app.config.host + "/Invoice68/GetVAT", name: "tsuat", id: "tsuat" },
						{ height: 8 },
						{
							cols: [
								{},
								{
									id: "crebtn",
									view: "button",
									label: "Lưu",
									css: "webix_primary",
									click: function () {
										var item = $$("68_ticket_setting_form").getValues();
										item.quanlykyhieu68_id = quanlykyhieu68_id;
										var window = $$("68_ticket_setting_form");
										webix.extend(window, webix.ProgressBar);
										window.disable();
										window.showProgress();
										webix
											.ajax()
											.headers({ "Content-type": "application/json" })
											.post(app.config.host + "/Ticket68/SaveSetting", item, {
												error: function (text, data, XmlHttpRequest) {
													webix.message(text + XmlHttpRequest, "error");
													window.enable();
													window.hideProgress();
												},
												success: function (text, data, XmlHttpRequest) {
													window.enable();
													window.hideProgress();
													var response = JSON.parse(text);
													if (response.code == "00") {
														webix.$$("68_ticket_setting_win").close();
														var table = webix.$$("tblInvoiceDashTicket");
														if (type) table = webix.$$("tblInvoiceDash");
														table.clearAll();
														table.load(table.config.url);
														webix.message("Lưu cấu hình thành công", "success");
													} else {
														webix.message(response.message, "error");
													}
												},
											});
									},
								},
								{
									id: "canbtn",
									view: "button",
									label: "Hủy",
									css: "webix_danger",
									align: "center",
									click: function () {
										webix.$$("68_ticket_setting_win").close();
									},
								},
								{},
							],
						},
					],
				},
			},
			initUI: function (kyhieu_id, kyhieu_text, options) {
				quanlykyhieu68_id = kyhieu_id;
				type = options;
				webix
					.$$("68_ticket_setting_win")
					.getHead()
					.setHTML("Cấu hình cho ký hiệu: " + kyhieu_text);
				if (options) {
					$$("tsuat").hide();
					$$("68_ticket_setting_form").elements.ten.define("label", "Tên khoản thu");
					$$("68_ticket_setting_form").elements.dongia.define("label", "Mệnh giá");
				}
			},
		};
});
define(
    'views/modules/TrangChu/data_ticket',[
        "app",
        "locale",
        "views/forms/forms68/TemVeThe/68_createInvoice",
        "views/forms/forms68/TemVeThe/68_settingInvoice"
    ],
    function (
        app,
        _,
        createTicket,
        ticketSetting
    ) {
        return {
            $ui: {
                css: "table_dash_invoice",
                rows: [
                    {
                        template: "<span class='webix_icon fa-star' style='color:#FF892A'></span><b style='color:blue'> Danh sách tem - vé - thẻ</b>", "css": "sub_title", "height": 30
                    },
                    {
                        view: "datatable",
                        id: "tblInvoiceDashTicket",
                        name: "tblInvoiceDashTicket",
                        css: "mcls_invoiceDashboard",
                        url: app.config.host + "/Ticket68/GetTicketList",
                        footer: "true",
                        resize: "true",
                        columns: [
                            {
                                id: "khhdon",
                                header: "Ký hiệu",
                                css: { "text-align": "center" },
                                template: "<a  style = 'text-decoration: none; color:blue;' href='#' onclick=\" var menu=$$('app:menu');"
                                    + "	require(['app'], function(app){ "
                                    + " app.router('app/68_invoiceViews_code_05'); var khieu = webix.$$('khhdon');"
                                    + "}); \" >#khhdon#</a>",
                                fillspace: 1
                            },
                            {
                                id: "ten",
                                header: "Tên hàng hóa",
                                css: { "text-align": "center" },
                                fillspace: true
                            },
                            {
                                id: "dongia",
                                header: "Mệnh giá",
                                css: { "text-align": "center" },
                                fillspace: 1,
                                // css: { "text-align": "right" },
                                template: function (obj, common) {
                                    return obj.dongia == null ? "" : formatDecimal(obj.dongia, 0);
                                }
                            },
                            {
                                id: "tao_moi",
                                header: "Tạo mới vé",
                                css: { "text-align": "center" },
                                template: "<input class='prtbtn' type='button' value='In vé'>",
                                fillspace: 1
                            },
                            {
                                id: "ticketSetting68_id",
                                header: "Cấu hình",
                                css: { "text-align": "center" },
                                template: "<input class='settingbtn' type='button' value='Cấu hình'>",
                                fillspace: 1,
                            }
                        ],
                        onClick: {
                            prtbtn: function (event, khhdon) {
                                webix.ajax().bind(this)
                                    .get(app.config.host + "/Ticket68/GetSettingById?id=" + khhdon,
                                        function (text) {
                                            var response = JSON.parse(text);
                                            if (response["code"] != "00") {
                                                webix.message(response["message"], "debug");
                                                return;
                                            }
                                            var data = response["data"][0];
                                            var detailForm = this.$scope.ui(createTicket.$ui);
                                            createTicket.initUI(data.khhdon);
                                            detailForm.show();
                                            data.tdlap = new Date();
                                            $$("68_ticket_create_form").setValues(data);
                                        });
                            },
                            settingbtn: function (event, khhdon) {
                                webix.ajax().bind(this)
                                    .get(app.config.host + "/Ticket68/GetSettingById?id=" + khhdon,
                                        function (text) {
                                            var response = JSON.parse(text);
                                            if (response["code"] != "00") {
                                                webix.message(response.message, "error");
                                                var item = $$("tblInvoiceDashTicket").getItem(khhdon);
                                                var detailForm = this.$scope.ui(ticketSetting.$ui);
                                                ticketSetting.initUI(item.id, item.khhdon);
                                                detailForm.show();
                                            }
                                            else {
                                                var dataJs = response["data"][0];
                                                var detailForm = this.$scope.ui(ticketSetting.$ui);
                                                ticketSetting.initUI(dataJs.quanlykyhieu68_id, dataJs.khhdon);
                                                detailForm.show();
                                                $$("68_ticket_setting_form").setValues(dataJs);
                                            }
                                        });
                            }
                        }
                    }
                ]
            }
        };
    });
define('views/modules/TrangChu/data_chukyso',["app", "locale"], function (app, _) {

    return {
        $ui: {
            "css": "table_dash_invoice",
            autowidth:true,
            "rows": [
                {
                    "template": `<span class='webix_icon fa-star' style='color:#FF892A'></span><b style='color:blue'> ${_("DS_CKS")}</b>`, "css": "sub_title", "height": 30
                },
                {
                    "view": "datatable",
                    "css": "mcls_invoiceDashboard",
                    "url": app.config.host + "/Pattern/GetCertExpise",
                    "footer": "true",
                    "resize": "true",
                    tooltip: true,
                    id: "tblDasCKS",
                    onClick: {
                        "clickInvoice": function (event, cell, target) {

                        }
                    },
                    scheme: {
                        $change: function (item) {
                            if (item.hight == 1)
                                item.$css = "highlight_column";
                            if (item.hight == 3)
                                item.$css = "highlight_column_3";
                        }
                    },
                    "columns": [
                        {
                            id: "so_serial",
                            header: "Số serial",
                            css: { "text-align": "center" },
                            //template: "<a class='clickInvoice'  style = 'text-decoration: none; color:blue;' href='#' >#so_serial#</a>",
                            fillspace: 1
                        },
                        {
                            id: "ngaybatdau",
                            header: "Ngày bắt đầu",
                            css: { "text-align": "center" },
                            fillspace: 1,
                            format: function (text) {
                                var format = webix.Date.dateToStr("%d/%m/%Y");
                                text = removeTimeZoneT(text);
                                return format(text);
                            }
                        },
                        {
                            id: "ngayketthuc",
                            header: "Ngày kết thúc",
                            css: { "text-align": "center" },
                            fillspace: 1,
                            format: function (text) {
                                var format = webix.Date.dateToStr("%d/%m/%Y");
                                text = removeTimeZoneT(text);
                                return format(text);
                            }
                        },
                        {
                            id: "hethan",
                            header: "Trạng thái",
                            css: { "text-align": "center" },
                            fillspace: 1,
                            template: function (obj) {
                                var res = "";
                                switch (obj.hight) {
                                    case 1:
                                        res = "Sắp hết hạn";
                                        break;
                                    case 3:
                                        res = "Đã hết hạn";
                                        break;
                                    default:
                                        res = "<span>Đang sử dụng</span>";
                                        break;
                                };
                                return res;
                            }
                        }
                        // {
                        //     id: "subjectname",
                        //     header: "Đơn vị",
                        //     css: { "text-align": "center" },
                        //     fillspace: 1,
                        // }
                    ]
                }
            ]
        }
    };
});
define('views/modules/TrangChu/chartv2',[
    "app",
    "views/SearchMst",
    "views/forms/forms68/TrangChu/68_extendInvoice",
    "views/forms/forms68/TrangChu/68_infoTaxcode",
    "models/user"
], function (app, searchMst, extendInvoice, infotaxcode, user) {
    var fm = function (number) {
        var k = webix.Number.numToStr({
            groupDelimiter: ".",
            groupSize: 3,
            decimalDelimiter: ",",
            decimalSize: 0
        });
        return k(number);
    };
    return {
        $ui: {
            maxWidth: 350,
            minWidth: 300,
            borderless: true,
            css: "chartv2",
            template: `<div class="card-body p-0">
        <div class="user-profile-img">
           <img src="assets/imgs/pattern-bg.jpg" class="profile-img profile-foreground-img rounded-top" style="height: 100px;" alt="">
            <div class="overlay-content rounded-top">
                <div>
                    <div class="user-nav p-3">
                        <div class="d-flex justify-content-end">
                            <div class="dropdown">
                                <a class="dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" class="eva eva-more-horizontal-outline fill-white"><g data-name="Layer 2"><g data-name="more-horizotnal"><rect width="24" height="24" opacity="0"></rect><circle cx="12" cy="12" r="2"></circle><circle cx="19" cy="12" r="2"></circle><circle cx="5" cy="12" r="2"></circle></g></g></svg>
                                </a>

                                <ul class="dropdown-menu dropdown-menu-end">
                                    <li><a class="dropdown-item" href="#">Action</a></li>
                                    <li><a class="dropdown-item" href="#">Another action</a>
                                    </li>
                                    <li><a class="dropdown-item" href="#">Something else
                                            here</a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- end user-profile-img -->

        <div class="mt-n5 position-relative">
            <div class="text-center">
                <img src="assets/imgs/LogoMinvoice.jpg" alt="" class="avatar-xl rounded-circle img-thumbnail">

                <div class="mt-3">
                    <h5 class="mb-1">${user.getCurrentUser()}</h5>
                    <p class="text-muted"><div class="badge rounded-pill font-size-13 badge-soft-success">Online</div></p>
                </div>
            </div>
        </div>

        <div class="p-3">
            <div class="row text-center pb-3">
                <div class="col-6 border-end">
                    <div class="p-1">
                        <h5 id="soluonghddangky" class="mb-1">1,269</h5>
                        <p class="text-muted mb-0">Tổng số</p>
                    </div>
                </div>
                <div class="col-6">
                    <div class="p-1">
                        <h5 id="soluonghdsudung" class="mb-1">5.2k</h5>
                        <p class="text-muted mb-0">Sử dụng</p>
                    </div>
                </div>
            </div>

            <hr class="mb-4">

            <div class="mb-4" style="position: relative;">
                <div class="d-flex align-items-start">
                    <div class="flex-grow-1">
                        <h5 class="card-title mb-3">Hóa đơn</h5>
                    </div>
                    <div>
                        <button class="btn btn-link py-0 shadow-none" data-bs-toggle="tooltip" data-bs-placement="left" data-bs-trigger="hover" title="" data-bs-original-title="Info">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" class="eva eva-info-outline fill-muted"><g data-name="Layer 2"><g data-name="info"><rect width="24" height="24" transform="rotate(180 12 12)" opacity="0"></rect><path d="M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2zm0 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8z"></path><circle cx="12" cy="8" r="1"></circle><path d="M12 10a1 1 0 0 0-1 1v5a1 1 0 0 0 2 0v-5a1 1 0 0 0-1-1z"></path></g></g></svg>
                        </button>
                    </div>
                </div>

                <div id="chartInvoice-radial" ></div>

                <div class="text-center mt-0">
                <h4 id="soluonghdconlai">Σ0</h4>
                    <p class="text-muted">Hóa đơn chưa sử dụng</p>
                </div>
            <div class="resize-triggers"><div class="expand-trigger"><div style="width: 273px; height: 223px;"></div></div><div class="contract-trigger"></div></div></div>

            <hr class="mb-4">
            <div class="px-4 mx-n3" data-simplebar="init" style="height: 258px;"><div class="simplebar-wrapper" style="margin: 0px -24px;"><div class="simplebar-height-auto-observer-wrapper"><div class="simplebar-height-auto-observer"></div></div><div class="simplebar-mask"><div class="simplebar-offset" style="right: -17px; bottom: 0px;"><div class="simplebar-content-wrapper" style="height: 100%; overflow: hidden scroll;"><div class="simplebar-content" style="padding: 0px 24px;">
                <div>
                    <h5 class="card-title mb-3">Hoạt động</h5>
                    <ul class="list-unstyled mb-0">
                        <li class="py-2">
                            <div class="d-flex align-items-start">
                                <div class="flex-shrink-0 me-3">
                                    <div class="avatar-md h-auto p-1 py-2 bg-light rounded">
                                        <div class="text-center">
                                            <h5 class="mb-0">22</h5>
                                            <div>Jan</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="flex-grow-1 pt-2 text-muted">
                                    <p class="mb-0">Chúc mừng năm mới. An khang thịnh vượng, Vạn sự như ý.</p>
                                </div>
                            </div>
                        </li>

                        <li class="pt-2">
                            <a href="#" class="btn btn-link w-100 shadow-none"><i class="mdi mdi-loading mdi-spin me-2"></i> Load More</a>
                        </li>
                    </ul>
                </div>
            </div></div></div></div><div class="simplebar-placeholder" style="width: auto; height: 303px;"></div></div><div class="simplebar-track simplebar-horizontal" style="visibility: hidden;"><div class="simplebar-scrollbar" style="transform: translate3d(0px, 0px, 0px); display: none;"></div></div><div class="simplebar-track simplebar-vertical" style="visibility: visible;"><div class="simplebar-scrollbar" style="height: 219px; transform: translate3d(0px, 0px, 0px); display: block;"></div></div></div>
        </div>
    </div>`
        },
        $oninit: function (view, $scope) {
        },
        callBack: function () {
            webix.ajax()
                .headers({ 'Content-type': 'application/json' })
                .get(app.config.host + "/Pattern/ChartPie", {
                    error: function (text, data, XmlHttpRequest) {
                    }, success: function (text, data, XmlHttpRequest) {
                        var response = JSON.parse(text);
                        document.querySelector("#soluonghddangky").innerHTML = fm(response[0].soluong);
                        document.querySelector("#soluonghdsudung").innerHTML = fm(response[1].soluong);
                        document.querySelector("#soluonghdconlai").innerHTML = fm(response[2].soluong);
                        var invoicePercentage = fm(response[3].soluong);
                        var options = {
                            series: [invoicePercentage],
                            //colors: ["#3498db"],
                            chart: {
                                type: 'radialBar',
                                offsetY: -20,
                                sparkline: {
                                    enabled: true
                                }
                            },
                            plotOptions: {
                                radialBar: {
                                    startAngle: -90,
                                    endAngle: 90,
                                    hollow: {
                                        size: "60%",
                                    },
                                    track: {
                                        background: "#e7e7e7",
                                        strokeWidth: '95%',
                                        margin: 5, // margin is in pixels
                                        dropShadow: {
                                            enabled: true,
                                            top: 2,
                                            left: 0,
                                            color: '#999',
                                            opacity: 1,
                                            blur: 2
                                        }
                                    },
                                    dataLabels: {
                                        name: {
                                            show: false
                                        },
                                        value: {
                                            offsetY: -2,
                                            fontSize: '22px'
                                        }
                                    }
                                }
                            },
                            grid: {
                                padding: {
                                    top: -10
                                }
                            },
                            fill: {
                                type: 'gradient',
                                gradient: {
                                    shade: 'light',
                                    shadeIntensity: 0.4,
                                    inverseColors: false,
                                    opacityFrom: 1,
                                    opacityTo: 1,
                                    stops: [0, 50, 53, 91]
                                },
                            },
                            labels: ['Hóa đơn'],
                        };
                        var parentNode = document.querySelector("#chartInvoice-radial");
                        var chart = new ApexCharts(parentNode, options);
                        chart.render();
                    }
                });
        }
    };
});

define('views/modules/TrangChu/dashlinev2',["app"], function (app) {
    var fm = function (number) {
      var k = webix.Number.numToStr({
        groupDelimiter: ".",
        groupSize: 3,
        decimalDelimiter: ",",
        decimalSize: 0
      });
      return k(number);
    };
    return {
      $ui: {
        height: 100,
        borderless: true,
        css: "tiles",
        template: `<div class="row">
        <div class="col-xl-3 col-lg-6">
            <div class="card">
                <div class="card-body">
                    <div class="d-flex align-items-center">
                        <div class="flex-shrink-0 me-3">
                            <div class="avatar">
                                <div class="avatar-title rounded bg-primary bg-gradient">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" class="eva eva-pie-chart-2 fill-white"><g data-name="Layer 2"><g data-name="pie-chart-2"><rect width="24" height="24" opacity="0"></rect><path d="M14.5 10.33h6.67A.83.83 0 0 0 22 9.5 7.5 7.5 0 0 0 14.5 2a.83.83 0 0 0-.83.83V9.5a.83.83 0 0 0 .83.83zm.83-6.6a5.83 5.83 0 0 1 4.94 4.94h-4.94z"></path><path d="M21.08 12h-8.15a.91.91 0 0 1-.91-.91V2.92A.92.92 0 0 0 11 2a10 10 0 1 0 11 11 .92.92 0 0 0-.92-1z"></path></g></g></svg>
                                </div>
                            </div>
                        </div>
                        <div class="flex-grow-1">
                            <p class="text-muted mb-1">Revenue</p>
                            <h4 class="mb-0">$21,456</h4>
                        </div>

                        <div class="flex-shrink-0 align-self-end ms-2">
                            <div class="badge rounded-pill font-size-13 badge-soft-success">+ 2.65%
                            </div>
                        </div>
                    </div>
                </div>
                <!-- end card body -->
            </div>
            <!-- end card -->
        </div>
        <!-- end col -->
        <div class="col-xl-3 col-lg-6">
            <div class="card">
                <div class="card-body">
                    <div class="d-flex align-items-center">
                        <div class="flex-shrink-0 me-3">
                            <div class="avatar">
                                <div class="avatar-title rounded bg-primary bg-gradient">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" class="eva eva-shopping-bag fill-white"><g data-name="Layer 2"><g data-name="shopping-bag"><rect width="24" height="24" opacity="0"></rect><path d="M20.12 6.71l-2.83-2.83A3 3 0 0 0 15.17 3H8.83a3 3 0 0 0-2.12.88L3.88 6.71A3 3 0 0 0 3 8.83V18a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3V8.83a3 3 0 0 0-.88-2.12zM12 16a4 4 0 0 1-4-4 1 1 0 0 1 2 0 2 2 0 0 0 4 0 1 1 0 0 1 2 0 4 4 0 0 1-4 4zM6.41 7l1.71-1.71A1.05 1.05 0 0 1 8.83 5h6.34a1.05 1.05 0 0 1 .71.29L17.59 7z"></path></g></g></svg>
                                </div>
                            </div>
                        </div>
                        <div class="flex-grow-1">
                            <p class="text-muted mb-1">Orders</p>
                            <h4 class="mb-0">5,643</h4>
                        </div>
                        <div class="flex-shrink-0 align-self-end ms-2">
                            <div class="badge rounded-pill font-size-13 badge-soft-danger">- 0.82%
                            </div>
                        </div>
                    </div>
                </div>
                <!-- end card body -->
            </div>
            <!-- end card -->
        </div>
        <!-- end col -->
        <div class="col-xl-3">
            <div class="card">
                <div class="card-body">
                    <div class="d-flex align-items-center">
                        <div class="flex-shrink-0 me-3">
                            <div class="avatar">
                                <div class="avatar-title rounded bg-primary bg-gradient">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" class="eva eva-people fill-white"><g data-name="Layer 2"><g data-name="people"><rect width="24" height="24" opacity="0"></rect><path d="M9 11a4 4 0 1 0-4-4 4 4 0 0 0 4 4z"></path><path d="M17 13a3 3 0 1 0-3-3 3 3 0 0 0 3 3z"></path><path d="M21 20a1 1 0 0 0 1-1 5 5 0 0 0-8.06-3.95A7 7 0 0 0 2 20a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1"></path></g></g></svg>
                                </div>
                            </div>
                        </div>
                        <div class="flex-grow-1">
                            <p class="text-muted mb-1">Customers</p>
                            <h4 class="mb-0">45,254</h4>
                        </div>
                        <div class="flex-shrink-0 align-self-end ms-2">
                            <div class="badge rounded-pill font-size-13 badge-soft-danger">- 1.04%
                            </div>
                        </div>
                    </div>
                </div>
                <!-- end card body -->
            </div>
            <!-- end card -->
        </div>
        <!-- end col -->
        <div class="col-xl-3">
            <div class="card">
                <div class="card-body">
                    <div class="d-flex align-items-center">
                        <div class="flex-shrink-0 me-3">
                            <div class="avatar">
                                <div class="avatar-title rounded bg-primary bg-gradient">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" class="eva eva-people fill-white"><g data-name="Layer 2"><g data-name="people"><rect width="24" height="24" opacity="0"></rect><path d="M9 11a4 4 0 1 0-4-4 4 4 0 0 0 4 4z"></path><path d="M17 13a3 3 0 1 0-3-3 3 3 0 0 0 3 3z"></path><path d="M21 20a1 1 0 0 0 1-1 5 5 0 0 0-8.06-3.95A7 7 0 0 0 2 20a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1"></path></g></g></svg>
                                </div>
                            </div>
                        </div>
                        <div class="flex-grow-1">
                            <p class="text-muted mb-1">Customers</p>
                            <h4 class="mb-0">45,254</h4>
                        </div>
                        <div class="flex-shrink-0 align-self-end ms-2">
                            <div class="badge rounded-pill font-size-13 badge-soft-danger">- 1.04%
                            </div>
                        </div>
                    </div>
                </div>
                <!-- end card body -->
            </div>
            <!-- end card -->
        </div>
    </div>`
      },
    };
  });
  
define(
    'views/modules/TrangChu/data_receipt',[
        "app",
        "locale",
        "views/forms/forms68/TemVeThe/68_createInvoice",
        "views/forms/forms68/TemVeThe/68_settingInvoice"
    ],
    function (
        app,
        _,
        createTicket,
        ticketSetting
    ) {
        return {
            $ui: {
                css: "table_dash_invoice",
                rows: [
                    {
                        template: "<span class='webix_icon fa-star' style='color:#FF892A'></span><b style='color:blue'> Danh sách biên lai</b>", "css": "sub_title", "height": 30
                    },
                    {
                        view: "datatable",
                        id: "tblInvoiceDash",
                        name: "tblInvoiceDash",
                        css: "mcls_invoiceDashboard",
                        url: app.config.host + "/Ticket68/GetReceiptList",
                        footer: "true",
                        resize: "true",
                        columns: [
                            {
                                id: "khhdon",
                                header: "Ký hiệu",
                                css: { "text-align": "center" },
                                template: "<a  style = 'text-decoration: none; color:blue;' href='#' onclick=\" var menu=$$('app:menu');"
                                    + "	require(['app'], function(app){ "
                                    + " app.router('app/window:WIN00196'); var khieu = webix.$$('khhdon');"
                                    + "}); \" >#value#</a>",
                                fillspace: 1
                            },
                            {
                                id: "ten",
                                header: "Tên hàng hóa",
                                css: { "text-align": "center" },
                                fillspace: true
                            },
                            {
                                id: "dongia",
                                header: "Mệnh giá",
                                css: { "text-align": "center" },
                                fillspace: 1,
                                // css: { "text-align": "right" },
                                template: function (obj, common) {
                                    return obj.dongia == null ? "" : formatDecimal(obj.dongia, 0);
                                }
                            },
                            {
                                id: "tao_moi",
                                header: "Tạo mới vé",
                                css: { "text-align": "center" },
                                template: "<input class='PrintReceipt' type='button' value='In vé'>",
                                fillspace: 1
                            },
                            {
                                id: "ticketSetting68_id",
                                header: "Cấu hình",
                                css: { "text-align": "center" },
                                template: "<input class='SettingReceipt' type='button' value='Cấu hình'>",
                                fillspace: 1,
                            }
                        ],
                        onClick: {
                            PrintReceipt: function (event, khhdon) {
                                webix.ajax().bind(this)
                                    .get(app.config.host + "/Ticket68/GetSettingById?id=" + khhdon,
                                        function (text) {
                                            var response = JSON.parse(text);
                                            if (response["code"] != "00") {
                                                webix.message(response["message"], "debug");
                                                return;
                                            }
                                            var data = response["data"][0];
                                            var detailForm = this.$scope.ui(createTicket.$ui);
                                            createTicket.initUI(data.ten, true);
                                            detailForm.show();
                                            data.tdlap = new Date();
                                            $$("68_ticket_create_form").setValues(data);
                                        });
                            },
                            SettingReceipt: function (event, khhdon) {
                                webix.ajax().bind(this)
                                    .get(app.config.host + "/Ticket68/GetSettingById?id=" + khhdon,
                                        function (text) {
                                            var response = JSON.parse(text);
                                            if (response["code"] != "00") {
                                                webix.message(response.message, "error");
                                                var item = $$("tblInvoiceDash").getItem(khhdon);
                                                var detailForm = this.$scope.ui(ticketSetting.$ui);
                                                ticketSetting.initUI(item.id, item.value, true);
                                                detailForm.show();
                                            }
                                            else {
                                                var dataJs = response["data"][0];
                                                var detailForm = this.$scope.ui(ticketSetting.$ui);
                                                ticketSetting.initUI(dataJs.quanlykyhieu68_id, dataJs.value, true);
                                                detailForm.show();
                                                $$("68_ticket_setting_form").setValues(dataJs);
                                            }
                                        });
                            }
                        }
                    }
                ]
            }
        };
    });
define('views/modules/TrangChu/license',["app"], function (app) {
    return {
        $ui: {
            "type": "clean",
            autowidth: true,
            rows: [
                {
                    template: "<span class='webix_icon fa-star' style='color:#FF892A;'></span><b style='color:blue'> Bản quyền</b>",
                    css: "sub_title",
                    height: 30
                },
                {
                    cols: [
                        {
                            borderless: true,
                            css: "chatdashboard",
                            template: `<div class="chat-message-list widget-chat-list mx-n3" data-simplebar="init">
                            <div class="simplebar-wrapper" style="margin: 0px;">
                               <div class="simplebar-height-auto-observer-wrapper">
                                  <div class="simplebar-height-auto-observer"></div>
                               </div>
                               <div class="simplebar-mask">
                                  <div class="simplebar-offset" style="right: -17px; bottom: 0px;">
                                     <div class="simplebar-content-wrapper" style="height: 100%; overflow: hidden scroll;">
                                        <div class="simplebar-content" style="padding: 0px;">
                                           <div class="px-3">
                                              <ul class="list-unstyled chat-list">
                                                 <li>
                                                    <a href="#" class="clickInvoice">
                                                       <div class="d-flex align-items-start">
                                                          <div class="flex-shrink-0 align-self-center me-3">
                                                             <span class="user-status"><i class="mdi mdi-36px mdi-alert-octagram-outline text-primary"></i></span>
                                                          </div>
                                                          <div class="flex-grow-1">
                                                             <div class="d-flex">
                                                                <div class="flex-grow-1 overflow-hidden">
                                                                   <h5 class="text-truncate font-size-14 mb-1">Hóa đơn</h5>
                                                                   <p class="text-truncate mb-0">Thống kê hóa đơn gửi thuế thành công, có lỗi ...</p>
                                                                </div>
                                                                <div class="flex-shrink-0">
                                                                   <div class="badge bg-danger rounded-pill font-size-11">Kiểm tra</div>
                                                                </div>
                                                             </div>
                                                          </div>
                                                       </div>
                                                    </a>
                                                 </li>
                                                 <!-- end li -->
                                                 <li>
                                                    <a href="#" class="clickLicense">
                                                       <div class="d-flex align-items-start">
                                                          <div class="flex-shrink-0 align-self-center me-3">
                                                             <span class="user-status"><i class="mdi mdi-36px mdi-license text-primary"></i></span>
                                                          </div>
                                                          <div class="flex-grow-1">
                                                             <div class="d-flex">
                                                                <div class="flex-grow-1 overflow-hidden">
                                                                   <h5 class="text-truncate font-size-14 mb-1">Bản quyền</h5>
                                                                   <p class="text-truncate mb-0">Thống kê số lượng sử dụng, còn lại của các loại hóa đơn.</p>
                                                                </div>
                                                                <div class="flex-shrink-0">
                                                                   <div class="badge bg-danger rounded-pill font-size-11">Kiểm tra</div>
                                                                </div>
                                                             </div>
                                                          </div>
                                                       </div>
                                                    </a>
                                                 </li>
                                                 <!-- end li -->
                                              </ul>
                                              <!-- end ul -->
                                           </div>
                                        </div>
                                     </div>
                                  </div>
                               </div>
                               <div class="simplebar-placeholder" style="width: auto; height: 554px;"></div>
                            </div>
                            <div class="simplebar-track simplebar-horizontal" style="visibility: hidden;">
                               <div class="simplebar-scrollbar" style="transform: translate3d(0px, 0px, 0px); display: none;"></div>
                            </div>
                            <div class="simplebar-track simplebar-vertical" style="visibility: visible;">
                               <div class="simplebar-scrollbar" style="height: 288px; transform: translate3d(0px, 112px, 0px); display: block;"></div>
                            </div>
                         </div>`,
                         onClick:{
                            "clickInvoice":function(ev, id){
                                app.router("app/invoice");
                            },
                            "clickLicense":function(ev, id){
                                app.router("app/license");
                            }
                        }
                        }
                    ]
                }
            ]
        }
    };

});
define('views/forms/reconfirm-address',["app"], function (app) {
  var reconfirmAddressFormId = "reconfirm-address-form";
  var newAddressWinId = "new-address-win";

  return {
    $ui: {
      view: "window",
      modal: true,
      id: newAddressWinId,
      position: "center",
      head:
        '<div style="display: flex; flex-direction: column; justify-content: center; align-items: center;">' +
        '<strong style="line-height: 25px">Thông báo</strong>' +
        '<strong style="line-height: 25px">V/v Cập nhật thông tin địa chỉ theo thay đổi địa giới hành chính</strong>' +
        "</div>",
      width: 800,
      headHeight: 56,
      height: 400,
      body: {
        paddingY: 20,
        paddingX: 30,
        view: "form",
        id: reconfirmAddressFormId,
        margin: 0,
        elementsConfig: {
          labelPosition: "top",
        },
        rule: {
          new_address: webix.rules.isNotEmpty,
        },
        elements: [
          {
            view: "template",
            id: "reconfirm-address-template",
            css: { "border-width": "0px !important" },

            template:
              "Kính gửi Quý khách hàng. <br> <br>" +
              "Cảm ơn Quý khách đã sử dụng dịch vụ Hóa đơn điện tử Minvoice. <br><br> " +
              "Theo Nghị quyết số 60-NQ / TW, việc tổ chức chính quyền địa phương theo mô hình hai cấp(Tỉnh/ Thành phố và Xã / Phường) sẽ <strong> được áp dụng từ ngày 01/07/2025</strong>.<br><br> " +
              "Để phát hành hóa đơn theo địa chỉ mới Quý khách cần cập nhật lại thông tin địa chỉ dưới đây. Việc cập nhật địa chỉ đơn vị theo <strong>thay đổi địa giới hành chính không cần lập và gửi tờ khai thay đổi thông tin sử dụng hóa đơn điện từ đến Cơ quan Thuế</strong>.",
          },
          {
            view: "text",
            name: "dia_chi",
            label: "Địa chỉ đơn vị",
            id: "dia_chi",
            required: true,
            attributes: {
              maxLength: 400,
            },
            invalidMessage: "Không được để trống địa chỉ",
          },
          {
            view: "template",
            css: { "border-width": "0px !important", "margin-bottom": "2px", "padding-bottom": "0px" },
            height: 36,
            template: '<strong>Theo Thông tư 86/2024/TT-BTC, Trường hợp người bán là Hộ, Cá nhân kinh doanh sử dụng CCCD thay cho Mã số thuế bên bán thì tích chọn tham số dưới đây </strong>',
          },
          {
            view: "text",
            name: "cccd_ndd",
            label: "Căn cước công dân",
            id: "cccd_ndd",
            required: true,
            invalidMessage: "Không được để trống căn cước công dân",
            hidden: true,
            attributes: {
              maxLength: 12,
            },
          },
          {
            view: "checkbox",
            name: "use_cccd",
            id: "use_cccd",
            labelRight: "Hộ kinh doanh sử dụng căn cước công dân thay mã số thuế",
            labelWidth: 0,
            labelPosition: "right",
            on: {
              onChange: function (newv) {
                var idCard = $$("cccd_ndd");
                var win = $$("new-address-win");
                if (newv) {
                  win.define("height", 450);
                  win.resize();
                  idCard.show();
                } else {
                  win.define("height", 400);
                  win.resize();
                  idCard.hide();
                }
              },
            },
          },

          {
            css: { "margin-top": "16px !important" },
            cols: [
              {},
              {
                shortcut: "F10",
                view: "button",
                label: "Nhận (F10)",
                type: "form",
                align: "center",
                width: 120,
                on: {
                  onClick: function () {
                    var form = webix.$$("reconfirm-address-form");
                    var item = form.getValues();
                    if (!form.validate()) return;
                    item.editmode = 4;
                    if (item.cccd_ndd && item.use_cccd) {
                      var idCardRegex = /^(0[0-9]{2})([0-3])([0-9]{2})([0-9]{6})$/;
                      if (!idCardRegex.test(item.cccd_ndd))
                        return showError("Căn cước công dân không hợp lệ");
                    }


                    webix.confirm({
                      title: "Xác nhận",
                      text: "Bạn chắc chắn các thông tin đã chính xác ?",
                      ok: "Có",
                      cancel: "Không",
                      type: "confirm-warning",
                      callback: function (res) {
                        if (res) {
                          webix.extend(form, webix.ProgressBar);
                          form.disable();
                          form.showProgress();
                          if (form.validate()) {
                            webix
                              .ajax()
                              .headers({ "Content-type": "application/json" })
                              .post(
                                app.config.host + "/System/SaveInfoCompany",
                                item,
                                {
                                  error: function () {
                                    webix.message({
                                      type: "error",
                                      text: data.error,
                                    });
                                    form.enable();
                                    form.hideProgress();
                                  },
                                  success: function (text) {
                                    var data = JSON.parse(text);
                                    form.enable();
                                    form.hideProgress();
                                    if (data.code == "00") {
                                      webix.message({
                                        type: "debug",
                                        text: "Đã lưu thành công",
                                      });
                                      $$(newAddressWinId).hide();
                                    } else {
                                      webix.message({
                                        type: "error",
                                        text: data.message,
                                      });
                                    }
                                  },
                                }
                              );
                          }
                        }
                      },
                    });
                  },
                },
                click: function () {
                  this.callEvent("onClick");
                },
              },
              {
                view: "button",
                hotkey: "esc",
                label: "Hủy bỏ (ESC)",
                align: "center",
                type: "danger",
                width: 120,
                click: function () {
                  webix.$$("new-address-win").close();
                },
              },
              {},
            ],
          },
        ],
      },
    },
    setData: function (data) {
      // var dataCopy = Object.assign({}, data);
      // delete dataCopy.cccd_ndd;
      $$(reconfirmAddressFormId).setValues(data);
    },
  };
});

define('views/dashboard',[
  "locale",
  "views/modules/dashline",
  "views/modules/data_invoice",
  "views/menus/version",
  "views/modules/chart",
  "views/modules/minvoice_news",
  "views/modules/TrangChu/dashline",
  "views/modules/TrangChu/data_invoice",
  "views/modules/TrangChu/chart",
  "views/modules/TrangChu/data_ticket",
  "views/modules/TrangChu/data_chukyso",
  "views/modules/TrangChu/chartv2",
  "views/modules/TrangChu/dashlinev2",
  "views/modules/TrangChu/data_receipt",
  "views/modules/TrangChu/license",
  "views/forms/reconfirm-address",
  "views/modules/Component/constantManager"

], function (_, dashline, invoice, version, chart, minvoice_news, dashline_ND123, invoice_ND123, chart_ND123, Ticket68, data_chukyso, chartv2, dashlinev2, Receipt,
   License, reconfirmAddress, constantManager) {
  var layout = {
    view: "tabview",
    css: "tabDashboard",
    id: 'tabViewInfo',
    cells: [
      {
        header: _("HD_ND123"),
        id: "Invoice123",
        body: {
          type: "clean", borderless: true, css: "tthome",
          cols: [
            {
              rows: [
                dashline_ND123,
                {
                  cols: [
                    { paddingX: 25, css: "dash_invoice", type: "space", rows: [invoice_ND123] },
                    { paddingX: 18, css: "dash_invoice2", type: "space", rows: [data_chukyso] }
                  ]
                },
                { height: 15 },
                {
                  cols: [
                    // { with: 10 },
                    { paddingX: 31, css: "dash_invoice", type: "space", rows: [License] },
                    { paddingX: 16, css: "dash_invoice1", type: "space", rows: [minvoice_news] }
                  ]
                },
                { height: 1 }
              ]
            },
          ]
        }
      },
      // {
      //   header: "| Hóa đơn NĐ 51",
      //   id: "Invoice51",
      //   body: {
      //     type: "clean", borderless: true, css: "tthome",
      //     rows: [
      //       dashline,
      //       { paddingX: 35, css: "dash_invoice", type: "space", rows: [invoice], },
      //       { height: 8 },
      //       {
      //         cols: [
      //           { paddingX: 18, css: "dash_invoice", type: "space", rows: [chart] },
      //           { paddingX: 30, css: "dash_invoice1", type: "space", rows: [minvoice_news] }
      //         ]
      //       }
      //     ]
      //   }
      // },
      {
        header: `| ${_("TEM_VE")}`,
        id: "Ticket68",
        body: {
          type: "clean", borderless: true, css: "tthome",
          cols: [
            {
              rows: [
                { paddingX: 35, css: "dash_invoice", type: "space", rows: [Ticket68] },
                { height: 12 },
                {
                  cols: [
                    { paddingX: 31, css: "dash_invoice", type: "space", rows: [License] },
                    { paddingX: 16, css: "dash_invoice1", type: "space", rows: [minvoice_news] }
                  ]
                },
                { height: 1 }
              ]
            }]
        }
      },
      {
        header: `| ${_("BIEN_LAI")}`,
        id: "Receipt",
        body: {
          type: "clean", borderless: true, css: "tthome",
          cols: [
            {
              rows: [
                { paddingX: 35, css: "dash_invoice", type: "space", rows: [Receipt] },
                { height: 12 },
                {
                  cols: [
                    { paddingX: 31, css: "dash_invoice", type: "space", rows: [License] },
                    { paddingX: 16, css: "dash_invoice1", type: "space", rows: [minvoice_news] }
                  ]
                },
                { height: 1 }
              ]
            }]
        }
      },
    ],
  };

  return {
    $ui: layout,
    $oninit: function (view, $scope) {
      chart_ND123.callBack();
      webix
        .ajax()
        .get(constantManager.API.GET_DMDVCS)
        .then(function (res) {
          var data = res.json();
          if (data.lancapnhat == null) {
            var reconfirmAddressForm = webix.ui(reconfirmAddress.$ui);
            reconfirmAddressForm.show();
            reconfirmAddress.setData(data);
          }
        });
    }
  };
});

define('views/forms/dmfield',["app"], function (app) {
	var editmode = 0;

	return {
		$ui: {
			view: "window", modal: true, id: "dmfield-win", position: "center",
			head: "Thông tin Field",
			fullscreen: true,
			body: {
				view: "scrollview",
				scroll: "native-y",
				body: {
					paddingY: 10,
					paddingX: 10,
					elementsConfig: { labelWidth: 150 },
					view: "form",
					id: "dmfield-form",
					complexData: true,
					margin: 0,
					elements: [
						{
							cols: [
								{ view: "text", name: "stt", label: "STT", id: "dmfield-id" },
								{ view: "text", name: "column_name", label: "Column Name", id: "dmfield-name" }
							]
						},
						{
							cols: [
								{ view: "text", name: "row", label: "Row", id: "dmfield-row" },
								{ view: "text", name: "col", label: "Col", id: "dmfield-col" }
							]
						},
						{
							cols: [
								{ view: "text", name: "width", label: "Width", id: "dmfield-width" },
								{ view: "text", name: "height", label: "Height", id: "dmfield-height" },
							]
						},
						{ view: "text", name: "column_width", label: "Column Width", id: "dmfield-columnwidth" },
						{ view: "text", name: "default_value", label: "DEFAULT VALUE" },
						{
							cols: [
								{
									view: "combo",
									name: "column_type",
									label: "Column Type",
									id: "dmfield-columntype",
									suggest: {
										body: {
											url: app.config.host + "/System/GetTypeSQL"
										}
									}
									//options: app.config.host + "/System/GetTypeSQL"
								},
								{
									view: "combo",
									name: "type_editor",
									label: "TYPE EDITOR",
									id: "dmfield-typeeditor",
									suggest: {
										body: {
											data: ["text", "combo", "checkbox", "datepicker", "autonumeric", "treesuggest", "gridsuggest", "gridcombo", "textarea", "multiselect", "select", "ckeditor", "password", "search"]
										}
									}
									//options: ["text", "combo", "checkbox", "datepicker", "autonumeric", "treesuggest", "gridsuggest", "gridcombo", "textarea", "multiselect", "ckeditor", "password","search"]
								}
							]
						},
						{
							cols: [
								{
									view: "text",
									name: "data_width",
									label: "Data Width"
								},
								{
									view: "text",
									name: "data_decimal",
									label: "Data decimal"
								}
							]
						},
						{
							cols: [
								{ view: "text", name: "label_width", label: "Label Width", id: "dmfield-labelwidth" },
								{ view: "combo", name: "label_position", options: ["left", "top", "right", "bottom"], label: "Label Position", id: "dmfield-labelposition" },
							]

						},
						{
							view: "combo",
							name: "ref_id",
							label: "REF ID",
							id: "dmfield-refid",
							suggest: {
								body: {
									url: app.config.host + "/System/GetDataReferencesByRefId?refId=RF00004"
								}
							}
							//options: app.config.host + "/System/GetDataReferencesByRefId?refId=RF00004"

						},
						{ view: "text", name: "list_column", label: "LIST COLUMN" },
						{ view: "text", name: "display_field", label: "DISPLAY_FIELD" },
						{ view: "text", name: "format", label: "FORMAT" },
						{ view: "text", name: "field_expression", label: "FIELD_EXPRESSION" },
						{ view: "text", name: "css", label: "Css" },
						{ view: "text", name: "template", label: "Template" },
						{ view: "text", name: "styleinput", label: "Style Input" },
						{ view: "combo", name: "space", options: [{ id: "BEFORE", value: "Trước" }, { id: "AFTER", value: "Sau" }], label: "SPACE" },
						{ view: "text", name: "caption", label: "CAPTION" },
						{ view: "text", name: "read_only", label: "READONLY" },
						{ view: "combo", name: "type_filter", options: ["checkboxFilter","textFilter", "serverFilter", "numberFilter", "datepickerFilter", "serverDateRangeFilter", "serverSelectFilter"], label: "Type Filter", id: "dmfield-typefilter" },
						{ view: "combo", name: "valid_rule", options: ["isNotEmpty", "isEmail", "isSpecialCharacter", "isTaxCode"], label: "Valid Rule", id: "dmfield-validrule" },
						{ view: "text", name: "total_column", label: "Total Column", id: "dmfield-totalcolumn" },
						{ view: "textarea", height: 160, name: "value_change", label: "VALUE_CHANGE" },
						{ view: "textarea", height: 160, name: "value_suggest", label: "VALUE_SUGGEST" },
						{
							cols: [
								{ view: "checkbox", name: "hide_in_grid", label: "HIDE_IN_GRID", checkValue: true, uncheckValue: false, id: "dmfield-hiddeningrid" },
								{ view: "checkbox", name: "hidden", label: "Hidden", checkValue: true, uncheckValue: false, id: "dmfield-hidden" }
							]
						},
						{
							margin: 10,
							cols: [
								{},
								{
									shortcut: "F10", view: "button", label: "Nhận (F10)", type: "form", align: "center", width: 120,
									on: {
										onClick: function () {
											var form = webix.$$("dmfield-form");
											var item = form.getValues();

											var url = "/WbField/Update";

											webix.ajax().post(app.config.host + url, item, function (text) {
												var data = JSON.parse(text);

												if (!data.hasOwnProperty("error")) {
													item.id = data.id;
													webix.$$("dmfield-win").close();
													app.callEvent("dataChanged", [editmode, item]);
												}
												else {
													webix.message(data.error);
												}
											});
										}
									},
									click: function () {
										this.callEvent("onClick");
									}
								},
								{
									view: "button", hotkey: "esc", label: "Hủy bỏ (ESC)", type: "danger", align: "center", width: 140,
									click: function () {
										webix.$$("dmfield-win").close();
									}
								}
							]
						}

					]
				}

			}

		},
		setEditMode: function (mode) {
			editmode = mode;
		}
	};

});
define('views/dmfield',[
    "app",
    "views/forms/dmfield",
    "locale"
], function (app, dmfieldform, _) {
    'use strict';

    //var windowno = app.path[1].params[0];
    webix.$$("title").parse({ title: "Điều khiển > Danh mục field", details: "Danh mục field system" });
    var submenu = webix.ui({
        view: "submenu",
        width: 300,
        padding: 0,
        data: [
            { id: "importcolumns", icon: "fas fa-angle-right", value: "Tải cột" },
            { id: "createtable", icon: "fas fa-angle-right", value: "Tạo bảng dữ liệu" },
            { id: "createproccrud", icon: "fas fa-angle-right", value: "Tạo thủ tục (Thêm - Sửa - Xóa)" },
            { id: "processstt", icon: "fas fa-angle-right", value: "Đánh lại số thứ tự" }
        ],
        on: {
            onItemClick: function (id, e, node) {
                if (id == "importcolumns") {

                    var url = app.config.host + "/System/InsertFieldsByTabId";
                    var tabId = webix.$$("txtTabId").getValue();

                    webix.ajax()
                        .headers({ 'Content-type': 'application/json' })
                        .post(url, { id: tabId }, function (text) {
                            var json = JSON.parse(text);

                            if (!json.hasOwnProperty("error")) {
                                loadData();
                            }
                            else {
                                webix.message(json.error);
                            }

                        });
                }

                if (id == "createtable") {

                    var url = app.config.host + "/System/AutoCreateTable";
                    var tabId = webix.$$("txtTabId").getValue();

                    webix.ajax()
                        .headers({ 'Content-type': 'application/x-www-form-urlencoded' })
                        .post(url, "id=" + tabId, function (text) {
                            var json = JSON.parse(text);

                            if (!json.hasOwnProperty("error")) {
                                loadData();
                            }
                            else {
                                webix.message(json.error);
                            }

                        });
                }

                if (id == "createproccrud") {

                    var url = app.config.host + "/System/AutoCreateCmd";
                    var tabId = webix.$$("txtTabId").getValue();

                    webix.ajax()
                        //.headers({'Content-type':'application/x-www-form-urlencoded'})
                        .post(url, "id=" + tabId, function (text) {
                            var json = JSON.parse(text);

                            if (!json.hasOwnProperty("error")) {
                                loadData();
                                webix.message("Đã thực hiện xong");
                            }
                            else {
                                webix.message(json.error);
                            }

                        });
                }

                if (id == "processstt") {
                    var table = webix.$$("dmfieldData");
                    var numberRow = table.count();

                    var url = "/WbField/Update";

                    for (var i = 0; i < numberRow; i++) {
                        var id = table.getIdByIndex(i);
                        var item = table.getItem(id);

                        item.stt = i + 1;

                        webix.ajax().post(app.config.host + url, item, function (text) {
                            var data = JSON.parse(text);

                            if (!data.hasOwnProperty("error")) {
                                webix.$$("dmfieldData").updateItem(item.id, item);

                            }

                        });
                    }



                }
            }
        }
    });

    var controls = [
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-plus fa-lg" aria-hidden="true"></i> ' +
            '<span class="text">' + "Thêm (F4)" + '</span>',
            id: "btnPlus",
            // view: "button",
            // type: "icon",
            // icon: "fas fa-plus",
            // label: "Thêm (F4)",
            // css: "webix_secondary",
            // width: 90,
            shortcut: "F4",
            on: {
                onClick: function () {
                    var win = this.$scope.ui(dmfieldform.$ui);
                    var form = webix.$$("dmfield-form");

                    if (webix.$$("txtTabId").getValue() == "") {
                        webix.message("Bạn chưa chọn Tab Id")
                        return;
                    }

                    var item = {
                        wb_tab_id: $$("txtTabId").getValue()
                    };

                    form.setValues(item);

                    dmfieldform.setEditMode(1);
                    win.show();
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-edit fa-lg" aria-hidden="true"></i> ' +
            '<span class="text">' + "Sửa (F3)" + '</span>',
            id: "btnEdit",
            // view: "button",
            // type: "icon",
            // icon: "fas fa-edit",
            // label: "Sửa (F3)",
            // css: "webix_secondary",
            // width: 60,
            shortcut: "F3",
            on: {
                onClick: function () {
                    var detailForm = this.$scope.ui(dmfieldform.$ui);
                    var form = webix.$$("dmfield-form");

                    var table = webix.$$("dmfieldData");
                    var item = table.getSelectedItem();

                    form.setValues(item);

                    dmfieldform.setEditMode(2);
                    detailForm.show();
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-trash-o fa-lg" aria-hidden="true"></i> ' +
            '<span class="text">' + "Xóa (F8)" + '</span>',
            id: "btnDelete",
            // view: "button",
            // type: "icon",
            // icon: "fas fa-trash-o",
            // label: "Xóa (F8)",
            // css: "webix_secondary",
            // width: 80,
            shortcut: "F8",
            on: {
                onClick: function () {
                    var table = webix.$$("dmfieldData");
                    var item = table.getSelectedItem();

                    webix.confirm({
                        text: "Bạn có muốn xóa " + item.column_name, ok: "Có", cancel: "Không",
                        callback: function (res) {
                            if (res) {
                                webix.ajax().post(app.config.host + "/WbField/Delete", item, function (text, xml, xhr) {
                                    if (text.hasOwnProperty("error")) {
                                        webix.message(text.error);
                                        return;
                                    }

                                    table.remove(item.id);

                                });

                            }
                        }
                    });
                }
            },
            click: function () {
                this.callEvent("onClick");
            }

        },
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-files-o fa-lg" aria-hidden="true"></i> ' +
            '<span class="text">' + "Sao chép" + '</span>',
            id: "btnCopy",
            // view: "button",
            // type: "icon",
            // icon: "fas fa-files-o",
            // label: "Sao chép",
            // css: "webix_secondary",
            // width: 85,
            on: {
                onClick: function () {
                    var detailForm = this.$scope.ui(dmfieldform.$ui);
                    var form = webix.$$("dmfield-form");

                    var table = webix.$$("dmfieldData");
                    var item = table.getSelectedItem();

                    if (item == null) {
                        webix.message({ type: "error", text: "Bạn chưa chọn mục field" });
                        return;
                    }

                    item.id = null;
                    form.setValues(item);

                    dmfieldform.setEditMode(1);
                    detailForm.show();
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {
            view: "button", type: "htmlbutton", width: 110,
            label: '<i class="fa fa-angle-down fa-lg" aria-hidden="true"></i> ' +
            '<span class="text">' + "Chức năng" + '</span>',
            id: "btnChucNang",
            // view: "button",
            // type: "icon",
            // icon: "fas fa-angle-down",
            // label: "Chức năng",
            // css: "webix_secondary",
            // width: 100,
            click: function () {
                submenu.show(webix.$$("btnChucNang").$view);
            }
        },
        {},
        {
            view: "combo",
            width: 400,
            label: "Tab ID",
            id: "txtTabId",
            options: {
                view: "gridsuggest",
                id: "grid_tab",
                // filter: function (obj, value) {
                //     var string = "";
                //     if (obj) {
                //         string += obj.id + " ";
                //         string += obj.window_name + " ";

                //     }
                //     return string.toLowerCase().indexOf(value.toLowerCase()) >= 0;
                // },
                // template: function (item) {
                //     return item.name + " ";
                //},
                template: "#tab_name#",
                width: 550,
                body: {
                    scroll: true,
                    autoheight: false,
                    columns: [
                        { id: "tab_id", header: "Window Id", editor: "text", width: 100 },
                        { id: "tab_name", header: "Window Name", editor: "text", width: 400 }
                    ],
                    url: app.config.host + "/WbTab/All"
                }
            },
            // suggest: {
            // 	url: app.config.host + "/WbTab/All",
            // 	template: "#tab_name#",
            // 	body: {
            // 		template: "#tab_name#"
            // 	}
            // },
            on: {
                onChange: function () {
                    loadData();
                }
            }
        }
    ];

    var grid = {
        rows: [
            {
                id: "dmfieldData",
                view: "datatable",
                select: true,
                resizeColumn: true,
                datafetch: 2,
                loadahead: 15,
                drag: true,
                on: {
                    onItemDblClick: function (id, e, node) {
                        var btnEdit = $$("btnEdit");
                        btnEdit.callEvent("onClick");
                    }
                },
                columns: [
                    { id: "wb_tab_id", header: "Tab Id", width: 100, hidden: true },
                    { id: "stt", header: "STT", width: 75 },
                    { id: "column_name", header: "Column Name", width: 150 },
                    { id: "row", header: "Row", width: 60 },
                    { id: "col", header: "Col", width: 60 },
                    { id: "width", header: "Width", width: 80 },
                    { id: "column_width", header: "Column Width", width: 150 },
                    { id: "column_type", header: "Column Type", width: 150 },
                    { id: "label_width", header: "Label Width", width: 150 },
                    { id: "label_position", header: "Label Position", width: 150 },
                    { id: "space", header: "SPACE", width: 150 },
                    { id: "type_editor", header: "TYPE EDITOR", width: 150 },
                    { id: "ref_id", header: "REF ID", hidden: true, width: 150 },
                    { id: "default_value", header: "Default Value", width: 250 },
                    { id: "hide_in_grid", header: "HIDE_IN_GRID", width: 120, checkValue: true, uncheckValue: false, template: "{common.rcheckbox()}" },
                    { id: "hidden", header: "Hidden", width: 80, checkValue: true, uncheckValue: false, template: "{common.rcheckbox()}" }
                ],
                //columns: columns
                pager: "pagerA",
                type: {
                    rcheckbox: function (obj, common, value, config) {
                        var checked = (value == config.checkValue) ? 'checked="true"' : '';
                        return "<input disabled class='webix_table_checkbox' type='checkbox' " + checked + ">";
                    }
                }

            },
            {
                cols: [
                    {
                        view: "icon", icon: "fas fa-question-circle", id: "help_form_views", tooltip: _("HELPER"),
                        css: "helper",
                        // click: function () {
                        //     this.callEvent("onClick");
                        // }
                        click: function () {
                            webix.alert({
                                title: "Thông báo !",
                                text: "Bạn chưa khai báo hướng dẫn nhanh cho màn hình này !",
                                type: "alert-warning",
                                callback: function (result) {
                                }
                            });
                        }
                    },
                    {
                        view: "combo",
                        label: _("MENU_QUICK"),
                        id: "QuickMenu1",
                        options: {
                            // view: "gridsuggest",
                            // id: "grid_window",
                            // template: "#name#",
                            // body: {
                            //     scroll: true,
                            //     autoheight: false,
                            //     columns: [
                            //         { id: "window_id", header: "Window Id", editor: "text", width: 100 },
                            //         { id: "name", header: "Window Name", editor: "text", width: 400 }
                            //     ],
                            //     url: app.config.host + "/System/GetQuickMenu"
                            // },
                            // on: {
                            //     onValueSuggest: function (obj) {
                            //         var start = obj.window_id != "" ? obj.code + ":" + obj.window_id : obj.code;
                            //         window.location.hash = "!/app/" + start;
                            //         $$("QuickMenu1").setValue(null);
                            //         $$("QuickMenu1").destructor();
                            //     }
                            // }
                        },
                        on: {
                            onChange: function (newv, oldv) {

                            }
                        }
                    },
                    {},
                    {
                        id: "pagerA",
                        view: "pager",
                        size: 50,
                        group: 5,
                        // animate: { direction:"top" },
                        template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}"
                    }
                ]
            }
        ]
    }

    var layout = {
        css: "frmView",
        rows: [
            {
                height: 39,
                css: "btnControl",
                type: "toolbar",
                margin: 0,
                borderless: true,
                cols: controls
            },
            {
                rows: [
                    grid
                ]
            }



        ]

    };

    function loadData() {
        var tabId = webix.$$("txtTabId").getValue();
        var url = app.config.host + "/WbField/GetFieldsByTabId?id=" + tabId;

        webix.ajax().get(url, function (text) {
            var json = JSON.parse(text);

            var table = webix.$$("dmfieldData");
            table.clearAll();

            for (var i = 0; i < json.length; i++) {
                var item = json[i];

				/* if (item.hidden!=null){
					item.hidden = item.toString();
				} */
            }

            table.parse(json);

        });
    }



    return {
        $ui: layout,
        $oninit: function (view, $scope) {
            $scope.on(app, "dataChanged", function (mode, item) {

                var table = webix.$$("dmfieldData");

                if (mode == 1) {
                    table.add(item);
                    //table.select(item.iddmfield,false);
                }

                if (mode == 2) {
                    var selectedItem = table.getSelectedItem();
                    table.updateItem(selectedItem.id, item);
                }

            });
        }
    };
});
define('views/dmhv',[
    "app",
    "views/forms/window"
], function(app,dmhvform) {
    'use strict';

     //var hvno = app.path[1].params[0];    
     var col = [];
     var url = app.config.host + "/api/System/GetAllByWindowId?id=09a8b24b-52b5-46a6-931d-d6f005da0dd7";
     webix.ajax(url, function (text, xml, xhr) {

        var rp = JSON.parse(text);
        //console.log(Object.keys(rp).length);

        for (var j = 0; j < (Object.keys(rp['data'][0]['Tabs'][0]['Fields']).length); j++) {

              col.push({ header: '' + String(rp['data'][0]['Tabs'][0]['Fields'][j]['COLUMN_NAME']) + '' , fillspace: true});
        }
        $$("windowData").define("columns",col );
        $$("windowData").refresh();

        //   console.log(col);
        //   console.log(Object.keys(rp.data).length);
      });

    var controls = [
        { 
            id: "btnPlus",
            view: "button", 
            type: "iconButton", 
            icon:"plus", 
            label: "Thêm" ,
            width:110,
            css:"button_raised",
            shortcut: "F4",
            on: {
                onClick: function(){
                    var win = this.$scope.ui(dmhvform.$ui);                   
                    dmhvform.setEditMode(1);
                    win.show();
                }
            },
            click: function(){
                this.callEvent("onClick");
            }
        },
        {
            id: "btnEdit",
            view: "button", 
            type: "iconButton", 
            icon:"edit", 
            label: "Sửa" ,
            width:100,
            css:"button_raised",
            shortcut: "F3",
            on: {
                onClick: function() {
                    var detailForm = this.$scope.ui(dmhvform.$ui);
                    var form = webix.$$("window-form");

                    var table = webix.$$("windowData");
                    var item = table.getSelectedItem();                   

                    form.setValues(item);

                    dmhvform.setEditMode(2);
                    detailForm.show();
                }
            },
            click: function(){
                this.callEvent("onClick");
            }           
        },
        {
            id: "btnDelete", 
            view: "button", 
            type: "iconButton", 
            icon:"trash-o", 
            label: "Xóa" ,
            width:100,
            css:"button_raised",
            shortcut: "F8",
            on : {
                onClick: function() {
                    var table = webix.$$("windowData");
                    var item = table.getSelectedItem();

                    webix.confirm({
                        text:"Bạn có muốn xóa " + item.ten_hv, ok:"Có", cancel:"Không",
                        callback:function(res){
                            if(res){
                                webix.ajax().post( app.config.host + "/api/Dmhv/Delete", item , function(text, xml, xhr){
                                    if (text.hasOwnProperty("error")){
                                        webix.message(text.error);
                                        return;
                                    }
                                    
                                    table.remove(item.id);

                                });
                                
                            }
                        }
                    });
                }
            },
            click: function(){
                this.callEvent("onClick");
            }
            
        },
        {}
    ];       
    
    var grid = {
        margin: 10,
        rows:[
            {
                id : "dmhvData",
                view: "datatable", 
                select: true,
                datafetch: 2,
                loadahead: 15,
                // url: {
                //     $proxy:true,
                //     load:function(view, callback, params){
                //             var url = app.config.host+ "/api/dmhv/All";
                           
                //             webix.ajax(url, callback, view);
                //     }
                // },                
                columns: col,
                    //  {id: "ma_hv", header: "Mã hàng" , width: 100 },
                    //  {id: "ten_hv", header: "Tên hàng" , fillspace: true },
                    // {id: "dvt", header: "Đơn vị tính" , fillspace: true }
                    // {id: "quai", header: "Quai", width:80},
                    // {id: "mau", header: "Màu sắc", width:80},
                    // {id: "doday", header: "Độ dày", width:80},
                    // {
                    //     id: "gia_ban", header: "Giá bán", width:80 ,
                    //     format:webix.Number.numToStr({
                    //             groupDelimiter:",",
                    //             groupSize:3,
                    //             decimalDelimiter:".",
                    //             decimalSize:0
                    //         }),
                    //     css:{'text-align':'right'}
                    // }
                //  ],
                //columns: columns
                pager:"pagerA"
                
            },
            {
                id: "pagerA",
                view:"pager",
                size: 100,
                group: 5,
                template:"{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}"
            }
        ]
    }

    var layout = {
		type: "space",
		rows:[
			{
				height:40,
				cols:controls
			},
			{
				rows:[
					grid					
				]
			}



		]

    };


    
    return {
        $ui: layout,
        $oninit: function(view,$scope) {
            $scope.on(app, "dataChanged", function(mode,item){

                var table = webix.$$("dmhvData");

                if (mode == 1){
                    table.add(item);
                    //table.select(item.iddmhv,false);
                }

                if (mode == 2){
                    var selectedItem = table.getSelectedItem();
                    table.updateItem(selectedItem.id,item);
                }
                
            });
        }
	};
});
define('views/modules/Component/buttonAnimation',[
    "app",
    "locale",
    "views/modules/Component/constantManager",
    "views/modules/Component/button",
    "views/modules/Component/ajaxHelper",
], function (app, _, constant, buttonComponent, Ajax) {
    var allowEditTgtienId = "check_congthuc"; 
    var createInvoiceModalId = "hoadon68_chitiet";
    var defaultKyhieu = ""
  
    function startProgress (table) {
      webix.extend(table, webix.ProgressBar);
      table.disable();
      table.showProgress();
    }
    function deletePaymentRequests(params, table) {
      var apiUrl = Array.isArray(params.ids) ? constant.API.PAYMENT_REQUEST.DELETE_MULTIPLE : constant.API.PAYMENT_REQUEST.SAVE
      webix
        .ajax()
        .headers({ "Content-type": "application/json" })
        .post(apiUrl, params, {
          error: function (text) {
            table.enable();
            table.hideProgress();
            webix.message(text, "error");
            app.callEvent("DataRefresh", [1, null]);
          },
          success: function (text) {
            var response = JSON.parse(text);
            if (response.code != "00") webix.message(response.message, "error");
            app.callEvent("DataRefresh", [1, null]);
            table.enable();
            table.hideProgress();
            webix.message("Xóa phiếu đề nghi thu tiền thành công", "success");
          },
        });
    }
    function changePaymentStatus(ids, status, table) {
      webix
        .ajax()
        .headers({ "Content-type": "application/json" })
        .post(
          constant.API.PAYMENT_REQUEST.CHANGE_STATUS,
          { ids: ids, status: status },
          {
            error: function (text) {
              table.enable();
              table.hideProgress();
              webix.message(text, "error");
              app.callEvent("DataRefresh", [1, null]);
            },
            success: function (text) {
              var response = JSON.parse(text);
              if (response.code != "00")
                webix.message(response.message, "error");
              else if (status == 1) 
                webix.message("Thanh toán thành công", "success");
              else if (status == 0) 
                webix.message("Gỡ thanh toán thành công", "success");
              app.callEvent("DataRefresh", [1, null]);
              table.enable();
              table.hideProgress();
            },
          }
        );
    }
    function openPdf (item) {
      var box = webix.modalbox({
        title: "Đang in phiếu ....",
        text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
        width: 350,
        height: 200,
      });

      var newWin = window.open();
      var html =
        "<html><head><title>Hóa đơn điện tử M-Invoice</title>" +
        '<link rel="stylesheet" href="assets/fontawesome_pro/css/all.css" type="text/css" charset="utf-8">' +
        '<link rel="stylesheet" href="assets/fontawesome.css" type="text/css" charset="utf-8">' +
        '</head><body><center>Đang tải dữ liệu ... <br><p><i style="font-size:200%;" class="fa fa-spin fa-spinner"></i></p></center></body></html>';
      newWin.document.write(html);

      webix
        .ajax()
        .response("arraybuffer")
        .headers({ "Content-type": "application/json" })
        .get(constant.API.PAYMENT_REQUEST.PRINT + item.dntt_id, {
          error: function (_text, _data, XmlHttpRequest) {
            webix.modalbox.hide(box);
            webix.message(XmlHttpRequest.statusText, "error");
          },
          success: function (_text, data) {
            var file = new Blob([data], { type: "application/pdf" });
            var fileURL = URL.createObjectURL(file);
            webix.modalbox.hide(box);
            newWin.location = fileURL;
          },
        });
    }
    function exportExcel (table, type) {
        var box = webix.modalbox({
          title: "Đang xuất excel  ....",
          text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
          width: 350,
          height: 200,
        });
        var tableState = table.getState();
        var filterArray = [
          {
            columnName: "loai",
            columnType: "int",
            value: type,
          },
        ];
        for (var key in tableState.filter) {
              var column = table.getColumnConfig(key);
            if ((column.columnType == "datetime" && tableState.filter[key].start && tableState.filter[key].end) ||
              (column.columnType != "datetime" && tableState.filter[key])) {
                filterArray.push({
                  columnName: key,
                  value: tableState.filter[key],
                  columnType: column.columnType
                });
            }
        }
      
        webix
          .ajax()
          .response("arraybuffer")
          .headers({ "Content-type": "application/json" })
          .post(
            constant.API.PAYMENT_REQUEST.EXPORT_EXCEL,
            {
              command: "CM0036",
              start: table.config.pager.page * table.config.pager.size,
              count: 0,
              filter: filterArray,
              tlbparam: [],
            },
            {
              error: function (_text, _data, XmlHttpRequest) {
                webix.modalbox.hide(box);
                webix.message(XmlHttpRequest.statusText, "error");
              },
              success: function (_text, data) {
                var file = new Blob([data], {
                  type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                });
                var fileURL = URL.createObjectURL(file);
                webix.html.download(fileURL, "De_nghi_thu_tien.xlsx");
                webix.modalbox.hide(box);
              },
            }
          );
    }
    function frmYesNo(editmode, table, messageData, model) {
        return webix.ui({
            view: "window", modal: true, id: "window-esc", position: "center", move: true, padding: 30, css: "frmSaveInvoice", autoheight: true,
            head: {
                borderless: true,
                view: "toolbar",
                cols: [
                    {
                        view: "label",
                        width: 40,
                        template: function (obj) {
                            var color = "#00b300";
                            var icon = "mdi-shield-check-outline";
                            if (messageData.code != 0) {
                                color = "#ff8839";
                                icon = "mdi-alert-outline";
                            }
                            return `<span style='color:${color};' class='mdi mdi-24px ${icon}'></span>`;
                        },
                    },
                    {
                        view: "label", css: { color: "back !important" },
                        template: function (obj) {
                            var title = "Lập phiếu thu";
                            if (editmode == 2) title = "Sửa phiếu thu";
                            return `<span style='color:black;font-size:15px;'>${title}</span>`;
                        },
                    },
                    {
                        view: "button", width: 30, type: "icon", icon: "mdi mdi-close", align: "right",
                        click: function () {
                            $$("window-esc").close();
                        },
                    },
                ],
            },
            body: {
                paddingY: 10,
                paddingX: 10,
                view: "form",
                id: "window-formesc",
                css: "frmYesNo",
                complexData: true,
                keepViews: true,
                autoheight: true,
                multiview: { keepViews: true },
                margin: 0,
                elements: [
                    { view: "template", autoheight: true, template: function () { return messageData.messageData; }, },
                    { height: 10 },
                    {
                        cols: [
                            {},
                            {
                                id: "btnCo", view: "button", label: "Có", type: "form", align: "center",
                                on: {
                                    onClick: function () {
                                        $$("window-esc").close();
                                        startProgress(table);
                                        Ajax.POST(constant.API.PAYMENT_REQUEST.SAVE, model)
                                            .then((data) => {
                                                var response = JSON.parse(data);
                                                table.enable();
                                                table.hideProgress();
                                                if (response.code == "00") {
                                                    webix.$$("invoice68").close();
                                                    app.callEvent("DataRefresh", [editmode, response.data,]);
                                                } else {
                                                    webix.message(response.message, "error");
                                                }
                                            })
                                            .catch((error) => {
                                                table.enable();
                                                table.hideProgress();
                                                webix.message(error, "error");
                                            });
                                    },
                                },
                                click: function () {
                                    $$("btnCo").callEvent("onClick");
                                },
                            },
                            {
                                view: "button", id: "btnKo", shortcut: "esc", label: "Không", type: "danger", align: "center",
                                on: {
                                    onClick: function () {
                                        $$("window-esc").close();
                                    },
                                },
                                click: function () {
                                    $$("window-esc").close();
                                },
                            },
                            {},
                        ],
                    },
                    { height: 10 },
                ],
            },
        }).show();
    }
    function openConfirmModal(title, text, callback, table) {
      webix.confirm({
        title: title,
        text: text,
        ok: "Có",
        cancel: "Không",
        callback: function (res) {
          if (res) {
            startProgress(table);
            callback()
          }
        },
      });
    }
    function setKyhieuDefaultValue(khieucombo) {
      var patternUrl = app.config.host + "/Pattern/GetData";
      function setValue() {
        setTimeout(function () {
            khieucombo.setValue(defaultKyhieu);
            khieucombo.define("text", defaultKyhieu);
        }, 300)
      }
      if (defaultKyhieu) {
        setValue();
      } else {
        webix
          .ajax()
          .post(patternUrl, {
            command: "CM0029",
            start: 0,
            count: 50,
            filter: [],
            tlbparam: [],
          })
          .then(function (res) {
            var data = JSON.parse(res.text());
            data.data.forEach(function (item) {
              if (item.ma == "KYHIEU_API") {
                defaultKyhieu = item.gia_tri;
                setValue()
              }
            });
          });
      }
    }

    return {
        btnRefresh: function (datatabeId) {
            var res = {
                view: "button",
                type: "htmlbutton",
                width: 100,
                label: `<i class="fa fa-refresh fa-lg" aria-hidden="true"></i><span class="text"> ${_("REFRESH")}</span>`,
                id: "btnReload",
                on: {
                    onClick: function () {
                        webix.callEvent("onLoadError");
                        var table = webix.$$(datatabeId);
                        buttonComponent.clearFilter(table);
                        table.clearAll();
                        table.load(table.config.url);
                    },
                },
                click: function () {
                    this.callEvent("onClick");
                },
            };
            return res;
        },
        btnAdd: function (invoiceForms, loai, autoAllowEditTgtien = false) {
            return {
                view: "button",
                type: "htmlbutton",
                width: 100,
                label: `<i class="fa fa-plus fa-lg" aria-hidden="true"></i><span class="text"> ${_("THEM")} (F4)</span>`,
                id: "btnPlus",
                shortcut: "F4",
                on: {
                    onClick: function () {
                        webix.callEvent("onLoadError");
                        var detailForm = this.$scope.ui(invoiceForms.$ui);
                        invoiceForms.initUINew();
                        invoiceForms.setEditMode(1, loai);
                        detailForm.show();

                        webix.ajax().bind(detailForm).get(constant.API.GET_DMDVCS, function (text) {
                            var result = JSON.parse(text);
                            var txtEmailnban = webix.$$("emailnban");
                            var txtSdt = webix.$$("sdt_ngban");
                            var txtStk = webix.$$("stknban");
                            var txtNH = webix.$$("nganhang_ngban");
                            if (txtEmailnban != null && txtEmailnban != undefined) {
                                txtEmailnban.setValue(result.email);
                            }
                            if (txtSdt != null && txtSdt != undefined) {
                                txtSdt.setValue(result["dien_thoai"]);
                            }
                            if (txtStk != null && txtStk != undefined) {
                                txtStk.setValue(result["tai_khoan"]);
                            }
                            if (txtNH != null && txtNH != undefined) {
                                txtNH.setValue(result["tai_nh"]);
                            }
                        });
                        if(autoAllowEditTgtien){
                          var allowEditTgtienCheckbox = webix.$$(allowEditTgtienId);
                          allowEditTgtienCheckbox.setValue(1);
                        }
                    }
                },
                click: function () {
                    this.callEvent("onClick");
                },
            };
        },
        btnDelete: function (isBienlai = false) {
            return {
                view: "button",
                type: "htmlbutton",
                width: 100,
                label: `<i class="fa fa-trash-o fa-lg" aria-hidden="true"></i><span class="text"> ${_("XOA")} (F8)</span>`,
                id: "btnDelete",
                shortcut: "F8",
                on: {
                    onClick: function () {
                        webix.callEvent("onLoadError");
                        var datatableId = "invoiceViews";
                        var table = webix.$$(datatableId);

                        if (table.getColumnConfig("colMultiChoice") == undefined) {
                            var item = table.getSelectedItem();
                            if (item == null || item == undefined) return showError("Bạn chưa chọn dòng dữ liệu cần xóa!");
                            if (item.tthai!= 0 && isBienlai) return showError("Phiếu thu không ở trạng thái Chờ TT");
                            else if(item.tthai!= 0 || (item.khieu && item.shdon)) return showError("Phiếu thu không ở trạng thái Chờ TT hoặc đã xuất hóa đơn");
                            var menu_id = webix.storage.local.get("MENU_ID");
                            item.menu_id = menu_id;
                            item.editmode = 3;

                            openConfirmModal(
                                "XÓA PHIẾU ĐỀ NGHỊ THU TIỀN",
                                "Bạn có muốn xóa Phiếu đề nghị thu tiền số: <span style='color: red'>" + item.so + "</span>",
                                function () {
                                    deletePaymentRequests(item, table);
                              },
                              table
                            )
                        } else {
                          var array = [];
                          var containsInValidItems = false;
                            table.eachRow(function (row) {
                                var record = JSON.stringify(table.getItem(row));
                                if (record != undefined) {
                                    var ref = JSON.parse(record);

                                  if (ref.colMultiChoice == "C") {
                                    if (ref.tthai!= 0 || (ref.khieu && ref.shdon)) {
                                        containsInValidItems = true;
                                      }
                                        array.push(ref.dntt_id);
                                    }
                                }
                            }, true);

                            if (array.length == 0) return showError("Bạn chưa chọn dòng dữ liệu cần xóa!")
                            if(containsInValidItems && !isBienlai) return showError("Phiếu thu không ở trạng thái Chờ TT hoặc đã xuất hóa đơn")
                            else if(containsInValidItems && isBienlai) return showError("Phiếu thu không ở trạng thái Chờ TT")

                            var rpParameter = {
                                menu_id: webix.storage.local.get("MENU_ID"),
                                ids: array,
                            };
                            openConfirmModal(
                                "XOÁ NHIỀU PHIẾU THU TIỀN",
                                "Bạn có muốn xóa nhiều phiếu thu tiền đã chọn?",
                                function () {
                                    deletePaymentRequests(rpParameter, table);
                              },
                              table
                            )
                        }
                    },
                },
                click: function () {
                    this.callEvent("onClick");
                },
            };
        },
        btnEdit: function (formModal, loai, isAllowEditTgTien = false) {
            return {
                view: "button",
                type: "htmlbutton",
                width: 100,
                label: `<i class="fa fa-edit fa-lg" aria-hidden="true"></i><span class="text"> ${_("SUA")} (F3)</span>`,
                id: "btnEdit",
                shortcut: "F3",
                on: {
                    onClick: function () {
                        webix.callEvent("onLoadError");
                        var datatableId = "invoiceViews";
                        var formId = "invoiceForms";
                        var table = webix.$$(datatableId);
                        var item = table.getSelectedItem();

                        if (item == null || item == undefined) return showError("Bạn chưa chọn dòng dữ liệu cần sửa!");
                        if (item.tthai!= 0 && loai == 2) return showError("Phiếu thu không ở trạng thái Chờ TT");
                        else if (item.tthai!= 0 || (item.khieu && item.shdon)) return showError("Phiếu thu không ở trạng thái Chờ TT hoặc đã xuất hóa đơn");

                        var detailForm = this.$scope.ui(formModal.$ui);
                        if (item.tthai != 0) {
                            var form = $$(formId).elements;
                            for (var key in form) {
                                var $el = form[key];
                                $el.define("readonly", "true");
                                $el.define("css", "mcls_readonly_text");
                                $el.refresh();
                            }
                            if ($$("btnSave") != undefined) $$("btnSave").destructor();
                        }
                        formModal.setEditMode(2, loai);
                        formModal.setValues(item, null);
                        detailForm.show();

                        webix
                            .ajax()
                            .bind(detailForm)
                            .get(constant.API.GET_DMDVCS, function (text) {
                                var result = JSON.parse(text);
                                webix.delay(
                                    function (a) {
                                        var txtEmailnban = webix.$$("emailnban");
                                        var txtSdt = webix.$$("sdt_ngban");
                                        var txtStk = webix.$$("stknban");
                                        var txtNH = webix.$$("nganhang_ngban");
                                        if (txtEmailnban != null && txtEmailnban != undefined)
                                            txtEmailnban.setValue(result.email);
                                        if (txtSdt != null && txtSdt != undefined)
                                            txtSdt.setValue(result["dien_thoai"]);
                                        if (txtStk != null && txtStk != undefined)
                                            txtStk.setValue(result["tai_khoan"]);
                                        if (txtNH != null && txtNH != undefined)
                                            txtNH.setValue(result["tai_nh"]);
                                    },
                                    formModal,
                                    [item],
                                    100
                                );
                            });
                        if(isAllowEditTgTien) {
                          var allowEditTgtienCheckbox = webix.$$(allowEditTgtienId);
                          allowEditTgtienCheckbox.setValue(1);
                        }
                    },
                },
                click: function () {
                    this.callEvent("onClick");
                },
            };
        },
        btnCopy: function (formModal, loai) {
            var res = {
                view: "button",
                type: "htmlbutton",
                width: 100,
                label: `<i class="fa fa-files-o fa-lg" aria-hidden="true"></i><span class="text"> ${_("COPY")}</span>`,
                id: "btnCopy",
                on: {
                    onClick: function () {
                        webix.callEvent("onLoadError");
                        var datatableId = "invoiceViews";
                        var table = webix.$$(datatableId);
                        var item = table.getSelectedItem();
                        if (item == null) {
                            webix.message("Bạn chưa chọn dòng dữ liệu sao chép", "debug");
                            return;
                        }
                        var detailForm = this.$scope.ui(formModal.$ui);
                        var data = JSON.parse(JSON.stringify(item));
                        formModal.setEditMode(1, loai);
                        formModal.copyValues(data);
                        detailForm.show();

                        webix.ajax().bind(detailForm).get(constant.API.GET_DMDVCS, function (text) {
                            var result = JSON.parse(text);
                            webix.delay(
                                function (a) {
                                    var txtEmailnban = webix.$$("emailnban");
                                    var txtSdt = webix.$$("sdt_ngban");
                                    var txtStk = webix.$$("stknban");
                                    var txtNH = webix.$$("nganhang_ngban");
                                    if (txtEmailnban != null && txtEmailnban != undefined)
                                        txtEmailnban.setValue(result.email);
                                    if (txtSdt != null && txtSdt != undefined)
                                        txtSdt.setValue(result["dien_thoai"]);
                                    if (txtStk != null && txtStk != undefined)
                                        txtStk.setValue(result["tai_khoan"]);
                                    if (txtNH != null && txtNH != undefined)
                                        txtNH.setValue(result["tai_nh"]);
                                },
                                formModal,
                                [item],
                                100
                            );
                        });
                    },
                },
                click: function () {
                    this.callEvent("onClick");
                },
            };
            return res;
        },
        btnCreateInvoice: function (formModal, loai) {
            return {
                view: "button",
                type: "htmlbutton",
                width: 140,
                label: `<i class="fa fa-plus-square fa-lg" aria-hidden="true"></i><span class="text"> ${_("Tạo hóa đơn")}</span>`,
                id: "btnCreateInvoice",
                on: {
                        onClick: function () {
                          webix.callEvent("onLoadError");
                          var datatableId = "invoiceViews";
                          var table = webix.$$(datatableId);
                          var item = table.getSelectedItem();
                          if (item == null) return showError("Bạn chưa chọn dòng dữ liệu tạo hóa đơn");
                          if (item.khieu && item.shdon) return showError("Phiếu đề nghị thu tiền đẫ tạo hóa đơn");

                          var detailForm = this.$scope.ui(formModal.$ui);
                          var data = JSON.parse(JSON.stringify(item));
                          formModal.setEditMode(1, loai);
                          var url = constant.API.PAYMENT_REQUEST.GET_DETAIL + item.id;
                          var table = webix.$$(createInvoiceModalId);
                          data.sdhang = data.mhso;
                          
                          formModal.copyValues(data);
                          // copyValues might miss data values, use this to make sure every value is copied
                          formModal.setValues(data)
                          
                          // table.load(url) wont work
                          webix.ajax().get(url).then(function (res) {
                            var data = JSON.parse(res.text());
                            if (Array.isArray(data)) {
                              table.define("data", data);
                              table.refresh();
                            } 
                          });
                          detailForm.show();
                          var khieucombo = $$("khieu");
                          var khieuComboList = khieucombo.getList();
                          khieuComboList.attachEvent(
                            "onAfterLoad", function () {
                              // prevent refetch from server which causes filter bug
                              this.define("dataFeed", null)
                              setKyhieuDefaultValue(khieucombo)
                            }
                          );
                          webix.ajax().bind(detailForm).get(constant.API.GET_DMDVCS, function (text) {
                            var result = JSON.parse(text);
                            webix.delay(
                                function (a) {
                                    var txtEmailnban = webix.$$("emailnban");
                                    var txtSdt = webix.$$("sdt_ngban");
                                    var txtStk = webix.$$("stknban");
                                    var txtNH = webix.$$("nganhang_ngban");
                                    if (txtEmailnban != null && txtEmailnban != undefined)
                                        txtEmailnban.setValue(result.email);
                                    if (txtSdt != null && txtSdt != undefined)
                                        txtSdt.setValue(result["dien_thoai"]);
                                    if (txtStk != null && txtStk != undefined)
                                        txtStk.setValue(result["tai_khoan"]);
                                    if (txtNH != null && txtNH != undefined)
                                        txtNH.setValue(result["tai_nh"]);
                                },
                                formModal,
                                [item],
                                100
                              );
                            });
                            detailForm.attachEvent("onDestruct", function () {
                              app.callEvent("DataRefresh", [1, null]);
                            });  
                        },
                },
                click: function () {
                    this.callEvent("onClick");
                },
            };
        },
        btnPrint: function () {
            return {
                view: "button",
                type: "htmlbutton",
                width: 140,
                label: `<i class="fa fa-print fa-lg" aria-hidden="true"></i><span class="text"> ${_("Xem in")}</span>`,
                id: "btnPrint",
                on: {
                    onClick: function () {
                      var datatableId = "invoiceViews";
                      var table = webix.$$(datatableId);
                      if (table.getColumnConfig("colMultiChoice") != undefined) return; 
                      var item = table.getSelectedItem();
                      if (item == null || item == undefined) return showError("Bạn chưa chọn dòng cần in");
                      openPdf(item)
                    },
                },
                click: function () {
                    this.callEvent("onClick");
                },
            };
        },
        btnPayment: function () {
            return {
                view: "button",
                type: "htmlbutton",
                width: 140,
                label: `<i class="fa fa-credit-card fa-lg" aria-hidden="true"></i><span class="text"> ${_("Thanh toán")}</span>`,
                id: "btnPayment",
                on: {
                    onClick: function () {
                        webix.callEvent("onLoadError");
                        var datatableId = "invoiceViews";
                        var table = webix.$$(datatableId);
                        
                        if (table.getColumnConfig("colMultiChoice") == undefined) {
                            var item = table.getSelectedItem();
                            if (item == null || item == undefined) return showError("Bạn chưa chọn dòng dữ liệu cần chuyển trạng thái !");
                            if(item.tthai!= 0) return showError("Phiếu đề nghị thu tiền không ở trạng thái Chờ TT"); 
                            var menu_id = webix.storage.local.get("MENU_ID");
                            item.menu_id = menu_id;
                            item.editmode = 3;
                            openConfirmModal(
                                "THANH TOÁN PHIẾU ĐỀ NGHỊ THU TIỀN",
                                "Bạn có muốn thanh toán Phiếu đề nghị thu tiền số: <span style='color: red'>" + item.so + "</span>",
                                function () {
                                    changePaymentStatus([item.dntt_id], 1, table);
                                },
                                table
                            )
                        } else {
                          var array = [];
                          var containsInvalidItems = false;
                            table.eachRow(function (row) {
                              var record = JSON.stringify(table.getItem(row));
                                if (record != undefined) {
                                  var ref = JSON.parse(record);
                                  if (ref.colMultiChoice == "C") {
                                      if(ref.tthai!= 0) 
                                        containsInvalidItems = true;
                                      array.push(ref.dntt_id);
                                    }
                                }
                            }, true);
                            if (array.length == 0)  return showError("Không có bản ghi nào được chọn")
                            if (containsInvalidItems) return showError("Phiếu thu không ở trạng thái Chờ TT")
                            openConfirmModal(
                                "THANH TOÁN NHIỀU PHIẾU THU TIỀN",
                                "Bạn có muốn thanh toán nhiều phiếu thu tiền đã chọn?",
                                function () {
                                    changePaymentStatus(array, 1, table);
                                },
                                table
                            ) 
                        }
                    },
                },
                click: function () {
                    this.callEvent("onClick");
                },
            };
        },
        btnSave: function () {
            var res = {
                shortcut: "F10",
                view: "button",
                id: "btnSave",
                badge: "F10",
                css: "webix_primary",
                label: "Lưu dữ liệu",
                type: "icon",
                align: "center",
                width: 130,
                on: {
                    onClick: function () {
                        webix.callEvent("onLoadError");
                        var datatableDetailId = createInvoiceModalId;
                        var windowId = "invoice68";
                        var formId = "invoiceForms";
                        var window = $$(windowId);
                        var editmode = window.config.editmode;
                        var loai = window.config.loai;
                        $$(datatableDetailId).editStop();

                        var formModal = $$(formId);
                        if (formModal.validate()) {
                            var item = formModal.getValues();
                            var dataDetails = $$(datatableDetailId).serialize();
                            if (!buttonComponent.validateDetailBeforeSave(dataDetails, 1)) return;

                            item["dntt_chitiets"] = dataDetails;
                            item.editmode = editmode;
                            item.loai = loai;
                            item.menu_id = webix.storage.local.get("MENU_ID");
                            var messageData = buttonComponent.validateMoney();
                            frmYesNo(editmode, formModal, messageData, item);
                        }
                    },
                },
                click: function () {
                    this.callEvent("onClick");
                },
            };
            return res;
        },
        btnClose: function () {
            var windowId = "invoice68";
            var res = {
                view: "button", hotkey: "esc", label: "Hủy bỏ", badge: "ESC", css: "webix_danger", align: "center", type: "icon", width: 120,
                click: function () {
                    $$(windowId).close();
                },
            };
            return res;
        },
        btnRemovePayment: function () {
            return {
              view: "button",
              type: "htmlbutton",
              width: 140,
              label: `<i class="fa fa-money-bill fa-lg" aria-hidden="true"></i><span class="text"> ${_("Gỡ Thanh toán")}</span>`,
              id: "btnRemovePayment",
              on: {
                onClick: function () {
                  webix.callEvent("onLoadError");
                  var datatableId = "invoiceViews";
                  var table = webix.$$(datatableId);

                  if (table.getColumnConfig("colMultiChoice") == undefined) {
                    var item = table.getSelectedItem();
                    if (item == null || item == undefined) return showError("Bạn chưa chọn dòng dữ liệu cần chuyển trạng thái !");
                    if (item.tthai != 1) return showError("Không thể gỡ thanh toán các phiếu thu chưa TT hoặc phiếu thu đã xuất hóa đơn");
                    var menu_id = webix.storage.local.get("MENU_ID");
                    item.menu_id = menu_id;
                    item.editmode = 3;

                    openConfirmModal(
                      "GỠ THANH TOÁN PHIẾU THU TIỀN",
                      "Bạn có muốn gỡ thanh toán phiếu thu tiền đã chọn?",
                      function () {
                          changePaymentStatus([item.dntt_id], 0, table);
                      },
                      table
                    )
                  } else {
                    var array = [];
                    var containsInvalidItems = false;
                    table.eachRow(function (row) {
                      var record = JSON.stringify(table.getItem(row));
                      if (record != undefined) {
                        var ref = JSON.parse(record);
                        if (ref.colMultiChoice == "C") {
                          if (ref.tthai == 0 || (ref.khieu && ref.shdon)) {
                            containsInvalidItems = true;
                          }
                          array.push(ref.dntt_id);
                        }
                      }
                    }, true);
                    if (array.length == 0) return showError("Không có bản ghi nào được chọn");
                    if (array.length > 1) return showError("Chỉ được gỡ thanh toán 1 phiếu mỗi lần");
                    if (containsInvalidItems) return showError("Không thể gỡ thanh toán các phiếu thu chưa TT hoặc phiếu thu đã xuất hóa đơn");
                    openConfirmModal(
                      "GỠ THANH TOÁN PHIẾU THU TIỀN",
                      "Bạn có muốn gỡ thanh toán phiếu thu tiền đã chọn?",
                      function () {
                          changePaymentStatus(array, 0, table);
                      },
                      table
                    );
                  }
                },
              },
              click: function () {
                this.callEvent("onClick");
              },
            };
        },
        btnExportExcel: function (type) {
            return {
                view: "button",
                type: "htmlbutton",
                width: 120,
                label: `<i class="fa fa-table fa-lg" aria-hidden="true"></i><span class="text"> ${_("EXPORT_EXCEL")}</span>`,
                id: "btnExportExcel",
                on: {
                    onClick: function () {
                    var datatableId = "invoiceViews";
                    var table = webix.$$(datatableId);
                    exportExcel(table, type);
                    },
                },
                click: function () {
                    this.callEvent("onClick");
                },
            };
        }
    };
});
define('views/forms/forms68/DanhMuc/dmkh',[
    "app",
    "locale",
    "views/modules/Component/constantManager",
    "models/user",
    "views/modules/Component/ajaxHelper",
    "views/modules/Component/buttonAnimation"
], function (app, _, constant, user, Ajax, button) {
    var editMode = 0;
    var winId = "dmkhWin";
    var formId = "dmkhForm";
    var datatableBankList = "ds_nganhang";
    var btnReload = "btnReload";

    var btnSaveDMKH = {
        shortcut: "F10",
        view: "button",
        id: "btnSaveDMKH",
        badge: "F10",
        css: "webix_primary",
        label: "Lưu dữ liệu",
        type: "icon",
        align: "center",
        width: 130,
        on: {
            onClick: function () {
                webix.callEvent("onLoadError");
                $$(datatableBankList).editStop();
                var model = $$(formId).getValues();
                if (!validateBeforeSave(model)) return;

                var table = $$(formId);
                if (table.validate()) {
                    var bankData = $$(datatableBankList).serialize();
                    if (bankData.length != 0) {
                        bankData = bankData.filter(function (item) {
                            return item.so_tk || item.tai_ngh;
                        });

                        bankData.forEach(function (item) {
                            item["ma_dvcs"] = user.getDvcsID();
                        });
                    };
                    model["ds_ngan_hang"] = bankData;
                    model["ma_dvcs"] = user.getDvcsID();
                    model["editmode"] = editMode;
                    frmYesNoDMKH(editMode, table, model);
                }
            },
        },
        click: function () {
            this.callEvent("onClick");
        },
    };

    var btnCancelDMKH = {
        view: "button",
        hotkey: "esc",
        label: "Hủy bỏ",
        badge: "ESC",
        css: "webix_danger",
        align: "center",
        type: "icon",
        width: 120,
        click: function () {
            $$(winId).close();
        },
    };

    var generalCustomer = {
        empty_line: { height: 0, gravity: 0, template: "" },
        empty_cols: { width: 0, gravity: 0, template: "" },
        info_customer: {
            ma_dt: {
                view: "text",
                label: _("Mã đối tượng"),
                labelWidth: 120,
                name: "ma_dt",
                id: "ma_dt",
                required: true,
                invalidMessage: "Mã đối tượng không được để trống",
            },
            ms_thue: {
                id: "ms_thue",
                name: "ms_thue",
                view: "search",
                label: _("Mã số thuế"),
                labelWidth: 120,
                validate: webix.rules.isTaxOrCCCD,
                invalidMessage: "Mã số thuế không hợp lệ",
                placeholder: _("SEARCH") + "...",
                on: {
                    onChange: function (newv, oldv) {
                        if (newv == undefined || oldv == undefined) return;
                        if (newv == "") return;
                        if (!webix.rules.isTaxOrCCCD(newv)) {
                            showError("Mã số thuế không hợp lệ");
                            this.focus();
                            return;
                        }
                    },
                    onTimedKeyPress: function () { },
                    onSearchIconClick: function (e) {
                        var text = this.getValue();
                        var datapost = { masothue: text };
                        var table = $$(formId);
                        if (!webix.rules.isTaxOrCCCD(text)) return showError("Mã số thuế không hợp lệ");
                        webix.extend(table, webix.ProgressBar);
                        table.disable();
                        table.showProgress();
                        function getInfoFromSubApi() {
                            webix
                                .ajax()
                                .bind(this)
                                .headers({ "Content-type": "application/json" })
                                .post(constant.API.POST_INFO_MST, datapost, {
                                    error: function (text, data, XmlHttpRequest) {
                                        var response = JSON.parse(text);
                                        var table = $$("invoiceForms");
                                        table.enable();
                                        table.hideProgress();
                                        this.focus();
                                        webix.message(response.error, "error", 1500);
                                    },
                                    success: function (text) {
                                        var response = JSON.parse(text);
                                        table.enable();
                                        table.hideProgress();
                                        this.focus();
                                        if (response.hasOwnProperty("error")) return showError(response.error);
                                        $$("ma_dt").setValue(response.ma_so_thue);
                                        $$("ten_dt").setValue(response.ten_cty || response.ho_ten);
                                        $$("dia_chi").setValue(response.dia_chi || "");
                                    },
                                });
                        }
                        webix
                            .ajax()
                            .bind(this)
                            .headers({ "Content-type": "application/json" })
                            .get(constant.API.POST_INFO_MST_GOV + text + "/manager", {
                                error: function (text, data, XmlHttpRequest) {
                                    getInfoFromSubApi()
                                },
                                success: function (text) {
                                    var response = JSON.parse(text);
                                    if (!response.mst) return getInfoFromSubApi();

                                    table.enable();
                                    table.hideProgress();
                                    this.focus();
                                    if (response.hasOwnProperty("error")) return showError(response.error);
                                    $$("ma_dt").setValue(response.mst);
                                    $$("ten_dt").setValue(response.tennnt);
                                    if (response.dctsdchi && response.dctsxaten && response.dctstinh) {
                                        var fullAddress = response.dctsdchi + ", " + response.dctsxaten;
                                        if (response.dctstinh.includes("TP")) fullAddress += ", " + response.dctstinh.replace("TP", "Thành phố");
                                        else fullAddress += ", Tỉnh " + response.dctstinh;
                                        fullAddress += ", Việt Nam";
                                        $$("dia_chi").setValue(fullAddress);
                                    } else {
                                        $$("dia_chi").setValue("");
                                    }
                                },
                            });
                    },
                },
            },
            dt_me_id: {
                view: "combo",
                name: "dt_me_id",
                label: _("Nhóm đối tượng"),
                labelWidth: 120,
                hidden: false,
                suggest: {
                    url: constant.API.GET_NHOM_DT,
                    body: {
                        template: "#value#",
                        columns: [
                            { id: "value", header: _("Nhóm đối tượng") }
                        ],
                        dataFeed: function (text) {
                            if (!text || text.length < 1) {
                                this.load(this.config.url);
                            } else {
                                var urldata = "filtervalue=" + encodeURIComponent(text);
                                this.load(constant.API.GET_NHOM_DT + "&" + urldata);
                            }
                        }
                    }
                }
            },
            ten_dt: {
                view: "text",
                label: _("Tên đối tượng"),
                labelWidth: 120,
                name: "ten_dt",
                id: "ten_dt",
                // required: true,
                // invalidMessage: "Tên đối tượng không được để trống"
            },
            email: {
                view: "text",
                label: _("Email"),
                labelWidth: 120,
                name: "email",
                id: "email_dt",
                invalidMessage: "Email không hợp lệ",
                validate: webix.rules.isEmail,
                attributes: { maxlength: 255 },
                on: {
                    onTimedKeyPress: function () {
                        if ($$("email_dt").getValue().length > 255) {
                            webix.message("Độ dài email không được vượt quá 255 ký tự", "debug");
                            return;
                        }
                    },
                    onChange: function (newValue, oldValue) { },
                },
            },
            dai_dien: {
                view: "text",
                label: _("Người mua hàng"),
                labelWidth: 120,
                name: "dai_dien",
                id: "dai_dien"
            },
            dia_chi: {
                view: "text",
                label: _("Địa chỉ"),
                labelWidth: 120,
                name: "dia_chi",
                attributes: { maxlength: 200 },
                id: "dia_chi",
                required: true,
                invalidMessage: "Địa chỉ không được để trống",
            },
            dien_thoai: {
                view: "text",
                label: _("Điện thoại"),
                labelWidth: 120,
                name: "dien_thoai",
                id: "dien_thoai"
            },
            dien_giai: {
                view: "text",
                label: _("Diễn giải"),
                labelWidth: 120,
                attributes: { maxlength: 200 },
                name: "dien_giai",
                id: "dien_giai"
            },
            fax: {
                view: "text",
                label: _("Fax"),
                labelWidth: 120,
                name: "fax",
                id: "fax"
            },
            cccdan: {
                view: "text",
                label: _("Căn cước công dân"),
                labelWidth: 120,
                attributes: { maxlength: 12 },
                name: "cccdan",
                id: "cccdan_dt"
            },
            mdvqhnsach_nmua: {
                view: "text",
                label: _("Mã đơn vị QHNS"),
                labelWidth: 120,
                attributes: { maxlength: 7 },
                name: "mdvqhnsach_nmua",
                id: "mdvqhnsach"
            },
            empty: {
                labelWidth: 120
            }
        }
    };

    var btnFunction = {
        id: "mainBankList",
        cols: [
            {
                view: "button",
                type: "icon",
                icon: "mdi mdi-plus-box-outline",
                width: 120,
                label: "Thêm (F9)",
                id: "addRowBank",
                css: "btnForm",
                tooltip: "Thêm dòng ngân hàng",
                on: {
                    onItemClick: function () {
                        var table = $$("ds_nganhang");
                        var item = { id: webix.uid(), so_tk: "", tai_ngh: "" };
                        table.add(item);
                        table.select(item.id);
                        table.edit({ row: item.id, column: "so_tk" });
                    }
                }
            },
            {
                view: "button",
                type: "icon",
                icon: "mdi mdi-minus-box-outline",
                width: 120,
                label: "Xóa (F8)",
                id: "removeRowBank",
                css: "btnForm",
                tooltip: "Xóa dòng ngân hàng",
                on: {
                    onItemClick: function () {
                        var table = $$("ds_nganhang");
                        table.editStop();
                        var item = table.getSelectedItem();
                        if (item) {
                            table.remove(item.id);
                            table.clearSelection();
                        }
                    }
                }
            },
            {
                view: "button",
                type: "icon",
                icon: "mdi mdi-content-duplicate",
                width: 120,
                label: "Sao chép (F7)",
                id: "copyRowBank",
                css: "btnForm",
                tooltip: "Sao chép dòng ngân hàng",
                on: {
                    onItemClick: function () {
                        var table = $$("ds_nganhang");
                        table.editStop();
                        var item = table.getSelectedItem();
                        if (!item) {
                            webix.message("Bạn chưa chọn dòng cần sao chép", "error");
                            return;
                        }
                        var copy = webix.copy(item);
                        delete copy.stt;
                        copy.id = webix.uid();
                        table.add(copy);
                        table.select(copy.id);
                        table.edit({ row: copy.id, column: "so_tk" });
                    }
                }
            }
        ]
    };

    return {
        $ui: {
            view: "window",
            modal: true,
            id: winId,
            position: "center",
            css: "headformchil",
            resize: true,
            fullscreen: true,
            move: true,
            editmode: editMode,
            on: {
                onShow: function () { }
            },
            head: {
                height: 35,
                cols: [
                    {
                        id: "headDmkh",
                        view: "template",
                        css: "headform",
                        width: 35,
                        template: "<span><i class='fa fa-plus' aria-hidden='true'></i></span>",
                    },
                    {
                        id: "head-frmDmkh",
                        view: "template",
                        css: "headform",
                        template: function (obj) {
                            return "<div>Danh mục đối tượng<div/>";
                        },
                    },
                    {
                        view: "icon",
                        icon: "fas fa-question-circle",
                        id: "help_frmDmkh",
                        tooltip: _("HELPER"),
                        click: function () {
                            var newWin = window.open();
                            newWin.location =
                                "https://hdsd.minvoice.com.vn/tutorials/thao-tac/dang-nhap/";
                        },
                    },
                ],
            },
            body: {
                paddingY: 10,
                paddingX: 10,
                elementsConfig: { labelWidth: 100 },
                view: "form",
                id: formId,
                width: 800,
                height: 500,
                complexData: true,
                margin: 0,
                elementsConfig: {
                    labelWidth: 120,
                    labelAlign: "right",
                    labelPosition: "left"
                },
                elements: [
                    {
                        view: "scrollview",
                        scroll: "y",
                        body: {
                            paddingX: 18,
                            rows: [
                                {
                                    view: "fieldset",
                                    body: {
                                        id: "info-customer",
                                        rows: [
                                            {
                                                cols: [
                                                    generalCustomer.info_customer.ma_dt,
                                                    generalCustomer.info_customer.ms_thue,
                                                    generalCustomer.info_customer.dt_me_id
                                                ],
                                            },
                                            {
                                                cols: [
                                                    generalCustomer.info_customer.ten_dt,
                                                    generalCustomer.info_customer.email,
                                                    generalCustomer.info_customer.dai_dien
                                                ],
                                            },
                                            {
                                                cols: [
                                                    generalCustomer.info_customer.dia_chi
                                                ],
                                            },
                                            {
                                                cols: [
                                                    generalCustomer.info_customer.dien_thoai,
                                                    generalCustomer.info_customer.dien_giai,
                                                    generalCustomer.info_customer.fax,
                                                ],
                                            },
                                            {
                                                cols: [
                                                    generalCustomer.info_customer.cccdan,
                                                    generalCustomer.info_customer.mdvqhnsach_nmua,
                                                    generalCustomer.info_customer.empty
                                                ],
                                            }
                                        ],
                                    },
                                },
                                {
                                    borderless: true,
                                    view: "tabview",
                                    scrollX: true,
                                    tabbar: {
                                        width: 200
                                    },
                                    cells: [
                                        {
                                            header: "Danh sách ngân hàng",
                                            select: "cell",
                                            body: {
                                                rows: [
                                                    btnFunction,
                                                    {
                                                        view: "datatable",
                                                        id: datatableBankList,
                                                        resizeColumn: true,
                                                        editable: true,
                                                        select: "cell",
                                                        minHeight: 150,
                                                        width: 700,
                                                        drag: true,
                                                        columns: [
                                                            { id: "stt", header: "STT", width: 50 },
                                                            { id: "so_tk", header: "Số TK", editor: "text", width: 250 },
                                                            { id: "tai_ngh", header: "Tại ngân hàng", editor: "text", width: 400 }
                                                        ],
                                                        on: {
                                                            "data->onStoreUpdated": function () {
                                                                this.data.each(function (obj, i) {
                                                                    obj.stt = i + 1;
                                                                });
                                                            },
                                                            onAfterRender: function () {
                                                            },
                                                            onKeyPress: function (code, e) {
                                                                if (e.key == "F8") {
                                                                    $$("removeRowBank").callEvent("onItemClick");
                                                                }
                                                                if (e.key == "F9") {
                                                                    $$("addRowBank").callEvent("onItemClick");
                                                                }
                                                                if (e.key == "F7") {
                                                                    $$("copyRowBank").callEvent("onItemClick");
                                                                }
                                                            }
                                                        }
                                                    }
                                                ]
                                            }
                                        }
                                    ]
                                },
                                { height: 10 },
                                {
                                    cols: [
                                        {},
                                        btnSaveDMKH,
                                        btnCancelDMKH,
                                        {}
                                    ]
                                }
                            ]
                        }
                    }
                ]
            }
        },
        setEditMode: function (mode) {
            editMode = mode;
        }
    };

    function frmYesNoDMKH(editmode, table, model) {
        return webix
            .ui({
                view: "window",
                modal: true,
                id: "window-esc",
                position: "center",
                move: true,
                padding: 30,
                css: "frmSaveInvoice",
                autoheight: true,
                head: {
                    borderless: true,
                    view: "toolbar",
                    cols: [
                        {
                            view: "label",
                            width: 40,
                            template: function (obj) {
                                var color = "#00b300";
                                var icon = "mdi-shield-check-outline";
                                return `<span style='color:${color};' class='mdi mdi-24px ${icon}'></span>`;
                            },
                        },
                        {
                            view: "label",
                            css: { color: "back !important" },
                            template: function (obj) {
                                var title = "Tạo khách hàng";
                                if (editmode == 2) title = "Sửa thông tin khách hàng";
                                return `<span style='color:black;font-size:15px;'>${title}</span>`;
                            },
                        },
                        {
                            view: "button",
                            width: 30,
                            type: "icon",
                            icon: "mdi mdi-close",
                            align: "right",
                            click: function () {
                                $$("window-esc").close();
                            },
                        },
                    ],
                },
                body: {
                    paddingY: 10,
                    paddingX: 10,
                    view: "form",
                    id: "window-formesc",
                    css: "frmYesNo",
                    complexData: true,
                    keepViews: true,
                    autoheight: true,
                    multiview: { keepViews: true },
                    margin: 0,
                    elements: [
                        {
                            view: "template",
                            autoheight: true,
                            template: "<span style='color:#0069b4'>Bạn có muốn lưu thông tin khách hàng này không?</span>"
                        },
                        { height: 10 },
                        {
                            cols: [
                                {},
                                {
                                    id: "btnCo",
                                    view: "button",
                                    label: "Có",
                                    type: "form",
                                    align: "center",
                                    on: {
                                        onClick: function () {
                                            $$("window-esc").close();
                                            webix.extend(table, webix.ProgressBar);
                                            table.disable();
                                            table.showProgress();
                                            Ajax.POST(constant.API.DMKH.SAVE, model)
                                                .then((data) => {
                                                    var response = JSON.parse(data);
                                                    table.enable();
                                                    table.hideProgress();
                                                    if (response.code != "00") return showError(response.message);

                                                    const win = webix.$$(winId);
                                                    if (win && win.config.callback) {
                                                        win.config.callback(model);
                                                    }

                                                    webix.$$(winId).close();
                                                    $$(btnReload).callEvent("onClick");
                                                })
                                                .catch((error) => {
                                                    console.log(error.message);
                                                    table.enable();
                                                    table.hideProgress();
                                                });
                                        },
                                    },
                                    click: function () {
                                        $$("btnCo").callEvent("onClick");
                                    },
                                },
                                {
                                    view: "button",
                                    id: "btnKo",
                                    shortcut: "esc",
                                    label: "Không",
                                    type: "danger",
                                    align: "center",
                                    on: {
                                        onClick: function () {
                                            $$("window-esc").close();
                                        },
                                    },
                                    click: function () {
                                        $$("window-esc").close();
                                    },
                                },
                                {},
                            ],
                        },
                        { height: 10 },
                    ],
                },
            })
            .show();
    }

    function validateBeforeSave(item) {
        var response = true;
        var emails = $$("email_dt").getValue().split(/[\s,\;]+/);
        emails.forEach((item) => {
            if (!webix.rules.isEmail(item)) {
                webix.message(`Email không đúng định dạng ${item}`, "error");
                response = false;
            }
        });
        return response;
    }
});


define('views/forms/usertracuu',[
    "app",
    "models/user",
    "views/menus/version",
    "locale"
], function (app, user, version, _) {
    var editmode = 0;
    function initUI(item) {
        var mst = version.getMST();
        item.mst = mst;

        webix.ajax()
            .headers({ 'content-type': 'application/json' })
            .post(app.config.host + "/Invoice/GetUserTracuu", item, function (result) {
                var data = JSON.parse(result);
                if (!data.hasOwnProperty("error")) {
                    var btnEdit = webix.$$("btnSavve");
                    btnEdit.define("label", "Sửa");
                    btnEdit.refresh();

                    $$("usertracuu-form").setValues(data);
                }
                else {
                    webix.message(data.error, "debug");
                    $$("mst").setValue(item.mst);
                    $$("email").setValue(item.email);
                    $$("username").setValue(item.ma_dt.replace(/[^a-zA-Z0-9 ]/g, ''));
                    $$("ma_dt").setValue(item.ma_dt);
                }
            });

    }
    return {
        $ui: {
            view: "window", modal: true, id: "usertracuu-win", position: "center", move: true, resize: true,
            head: "Thông tin khách hàng hỗ trợ",
            body: {
                paddingY: 10,
                paddingX: 10,
                elementsConfig: { labelWidth: 100 },
                view: "form",
                width: 500,
                // height: 150,
                id: "usertracuu-form",
                complexData: true,
                margin: 0,
                elements: [
                    {
                        view: "text",
                        label: _("MST"),
                        // labelWidth: 80,
                        name: "mst",
                        id: "mst",
                        readonly: true,
                        css: "mcls_readonly_text"
                    },
                    {
                        view: "text",
                        label: _("MKH"),
                        // labelWidth: 80,
                        name: "ma_dt",
                        id: "ma_dt",
                        readonly: true,
                        css: "mcls_readonly_text"
                    },
                    {
                        view: "text",
                        label: _("USERNAME"),
                        // labelWidth: 80,
                        name: "username",
                        id: "username",
                        // readonly: true,
                        readonly: true,
                        css: "mcls_readonly_text",
                        required: true,
                        invalidMessage: "Tên truy cập không để trống hoặc nhập không đúng (a-z,A-Z,0-9)",
                        validate: webix.rules.isSpecialCharacter,
                    },
                    {
                        view: "text",
                        label: _("PASSWORD"),
                        // labelWidth: 80,
                        name: "password",
                        id: "password",
                        value: "minvoice",
                        required: true,
                        invalidMessage: "Password không được để trống",
                    },
                    {
                        view: "text",
                        label: _("EMAIL"),
                        // labelWidth: 80,
                        name: "email",
                        id: "email"
                    },
                    {
                        margin: 10,
                        cols: [
                            {},
                            {
                                view: "button", id: "btnSavve", type: "image", image: "assets/imgs/save.png", label: "Lưu", width: 60, click: function () {

                                    var form = webix.$$("usertracuu-form");
                                    var item = form.getValues();

                                    if ($$("usertracuu-form").validate()) {
                                        webix.extend(form, webix.ProgressBar);
                                        form.disable();
                                        form.showProgress();
                                        webix.ajax()
                                            .headers({ 'Content-type': 'application/json' })
                                            .post(app.config.host + "/Invoice/CreateUser_tracuu", item, function (text) {
                                                var data = JSON.parse(text);

                                                if (!data.hasOwnProperty("error")) {
                                                    webix.message(data.ok, "success");
                                                    webix.$$("usertracuu-win").close();
                                                }
                                                else {
                                                    webix.message(data.error, "error");
                                                }
                                                form.enable();
                                                form.hideProgress();
                                            });
                                    }
                                }
                            },
                            {
                                view: "button", type: "image", image: "assets/imgs/reset.png", label: "Reset Password", width: 130, click: function () {
                                    var form = webix.$$("usertracuu-form");
                                    var item = form.getValues();

                                    webix.confirm({
                                        text: "Bạn có chắc chắn muốn reset mật khẩu về mật khẩu mặc định ?", ok: "Có", cancel: "Không",
                                        callback: function (res) {
                                            if (res) {
                                                webix.extend(form, webix.ProgressBar);
                                                form.disable();
                                                form.showProgress();
                                                webix.ajax()
                                                    .headers({ 'Content-type': 'application/json' })
                                                    .post(app.config.host + "/Invoice/ResetPassUserTracuu", item, function (text) {
                                                        var data = JSON.parse(text);

                                                        if (!data.hasOwnProperty("error")) {
                                                            webix.message(data.ok, "success");
                                                            webix.$$("usertracuu-win").close();
                                                        }
                                                        else {
                                                            webix.message(data.error, "error");
                                                        }
                                                        form.enable();
                                                        form.hideProgress();
                                                    });
                                            }
                                        }
                                    });
                                }
                            },
                            {
                                view: "button", id: "btnXoa", type: "image", image: "assets/imgs/xoa.png", label: "Xóa", width: 60, click: function () {
                                    var form = webix.$$("usertracuu-form");
                                    var item = form.getValues();
                                    webix.confirm({
                                        text: "Bạn có chắc chắn muốn xóa tài khoản ?", ok: "Có", cancel: "Không",
                                        callback: function (res) {
                                            if (res) {
                                                webix.ajax()
                                                    .headers({ 'Content-type': 'application/json' })
                                                    .post(app.config.host + "/Invoice/DeleteUserTracuu", item, function (text) {
                                                        var data = JSON.parse(text);

                                                        if (!data.hasOwnProperty("error")) {
                                                            webix.message(data.ok, "success");
                                                            webix.$$("usertracuu-win").close();
                                                        }
                                                        else {
                                                            webix.message(data.error, "error");
                                                        }
                                                    });
                                            }
                                        }
                                    });
                                }
                            },
                            {
                                view: "button", type: "image", image: "assets/imgs/close.png", label: "Hủy bỏ", hotkey: "esc", width: 80, click: function () {
                                    webix.$$("usertracuu-win").close();
                                }
                            },
                            {}
                        ]
                    }

                ]
            }
        },
        initUI: initUI,
        setEditMode: function (mode) {
            editmode = mode;
        },
        setValues: function (item) {
            var form = webix.$$("usertracuu-form");
            // var table = webix.$$("discountTable");

            form.setValues(item);
            // table.parse(item.hp_hsgiamtrus, "json");

        }
    };

});
define('views/dmkh',[
    "app",
    "locale",
    "views/modules/Component/buttonAnimation",
    "views/modules/Component/constantManager",
    "views/modules/Component/grid",
    "views/forms/forms68/DanhMuc/dmkh",
    "views/forms/forms68/EXCEL/68_uploadExcel",
    "views/forms/usertracuu",
], function (app, _, buttonOption, constant, grid, dmkhForm, uploadExcel, usertracuuForm) {
    'use strict';

    var window_id = "WIN00009";
    var datatableId = "customerViews";
    var datatableDetailId = "bankAccountDetails";
    var datatableDetailHeader = "Danh sách ngân hàng";
    var tabTableNameBank = "dmngh";
    var formId = "dmkhForm";
    var datatableBankList = "ds_nganhang";

    function startProgress(table) {
        webix.extend(table, webix.ProgressBar);
        table.disable();
        table.showProgress();
    }
    function openConfirmDelete(title, text, callback, table) {
        webix.confirm({
            title: title,
            text: text,
            ok: "Có",
            cancel: "Không",
            callback: function (res) {
                if (res) {
                    startProgress(table);
                    callback()
                }
            },
        });
    }
    function deleteCustomer(params, table) {
        var apiUrl = Array.isArray(params.ids) ? constant.API.DMKH.DELETE_MULTIPLE : constant.API.DMKH.SAVE
        webix
            .ajax()
            .headers({ "Content-type": "application/json" })
            .post(apiUrl, params, {
                error: function (text) {
                    table.enable();
                    table.hideProgress();
                    webix.message(text, "error");
                    app.callEvent("DataRefresh", [1, null]);
                },
                success: function (text) {
                    var response = JSON.parse(text);
                    if (response.code != "00") webix.message(response.message, "error");
                    app.callEvent("DataRefresh", [1, null]);
                    table.enable();
                    table.hideProgress();
                    webix.message("Xóa đối tượng thành công", "success");
                },
            });
    }
    var importExcel = function () {
        var fileId = $$("uploader").files.getFirstId();
        if (!fileId) {
            webix.message("Bạn chưa chọn file!", "error");
            $$("uploadfile-win78").enable();
            $$("uploadfile-win78").hideProgress();
            return;
        }

        var file = $$("uploader").files.getItem(fileId);
        var reader = new FileReader();

        reader.onload = function (e) {
            $$("uploadfile-win78").disable();
            $$("uploadfile-win78").showProgress();

            var data = e.target.result;
            var workbook = XLSX.read(data, { type: "binary" });
            var firstSheet = workbook.Sheets[workbook.SheetNames[0]];
            var range = XLSX.utils.decode_range(firstSheet["!ref"]);

            var model = [
                "ma_dt",
                "ten_dt",
                "dia_chi",
                "dien_thoai",
                "fax",
                "ms_thue",
                "dai_dien",
                "dien_giai",
                "dt_me_id",
                "email",
                "cccdan",
                "mdvqhnsach_nmua"
            ];

            var dataList = [];

            for (let row = range.s.r + 1; row <= range.e.r; row++) {
                let rowData = {};
                for (let col = range.s.c; col <= range.e.c && col - range.s.c < model.length; col++) {
                    let cellAddress = { c: col, r: row };
                    let cellRef = XLSX.utils.encode_cell(cellAddress);
                    let cell = firstSheet[cellRef];
                    let field = model[col - range.s.c];
                    if (cell && cell.w !== undefined) {
                        rowData[field] = cell.w.trim();
                    } else {
                        rowData[field] = "";
                    }
                }

                if (!rowData.ma_dt || !rowData.ten_dt || !rowData.dia_chi) continue;

                if (rowData.cccdan && rowData.cccdan.length > 12) {
                    webix.message("CCCD không hợp lệ tại dòng " + (row + 1), "error");
                    continue;
                }
                if (rowData.mdvqhnsach_nmua && rowData.mdvqhnsach_nmua.length > 7) {
                    webix.message("Mã QHNS không hợp lệ tại dòng " + (row + 1), "error");
                    continue;
                }

                dataList.push(rowData);
            }

            $$("danhsach_khachhang").clearAll();
            $$("danhsach_khachhang").parse(dataList);

            webix.message("Nhập thành công!", "success");
            $$("uploadfile-win78").enable();
            $$("uploadfile-win78").hideProgress();
            $$("uploadfile-win78").close();
        };

        reader.onerror = function (ex) {
            webix.message("Lỗi đọc file: " + ex, "error");
            $$("uploadfile-win78").enable();
            $$("uploadfile-win78").hideProgress();
        };

        reader.readAsBinaryString(file.file);
    };

    var btnRefresh = buttonOption.btnRefresh(datatableId);
    var btnAdd = {
        view: "button",
        type: "htmlbutton",
        width: 100,
        label: '<i class="fa fa-plus fa-lg" aria-hidden="true"></i><span class="text">' + _("Thêm (F4)") + "</span>",
        id: "btnAddCustomer",
        shortcut: "F4",
        click: function () {
            var grid = $$(datatableId);
            dmkhForm.setEditMode(1);
            grid.$scope.ui(dmkhForm).show();
        },
    };
    var btnEdit = {
        view: "button",
        type: "htmlbutton",
        width: 100,
        label: '<i class="fa fa-edit fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("Sửa (F3)") + "</span>",
        id: "btnEditCustomer",
        shortcut: "F3",
        click: function () {
            webix.callEvent("onLoadError");
            var table = webix.$$(datatableId);
            var item = table.getSelectedItem();

            if (item == null || item == undefined) return showError("Bạn chưa chọn dòng dữ liệu cần sửa!");

            var detailForm = this.$scope.ui(dmkhForm.$ui);
            dmkhForm.setEditMode(2);
            $$(formId).setValues(item, null);
            detailForm.show();

            var bankTable = webix.$$(datatableBankList);
            if (bankTable) {
                var url = app.config.host + constant.API.GET_DETAIL_TAB_TABLE + "?window_id=" + window_id + "&id=" + item.id + "&tab_table=" + tabTableNameBank;
                bankTable.load(url);
            }
        },
    };
    var btnDelete = {
        view: "button",
        type: "htmlbutton",
        width: 100,
        label: '<i class="fa fa-trash-o fa-lg" aria-hidden="true"></i><span class="text">' + _("Xóa (F8)") + "</span>",
        id: "btnDeleteCustomer",
        shortcut: "F8",
        click: function () {
            webix.callEvent("onLoadError");
            var table = $$(datatableId);

            if (table.getColumnConfig("colMultiChoice") == undefined) {
                var item = table.getSelectedItem();
                if (item == null || item == undefined) return showError("Bạn chưa chọn dòng dữ liệu cần xóa!");
                item.editMode = 3;
                openConfirmDelete(
                    "XÓA ĐỐI TƯỢNG",
                    "Bạn có muốn xóa đối tượng này?",
                    function () {
                        deleteCustomer(item, table);
                    },
                    table
                )
            } else {
                var array = [];
                table.eachRow(function (row) {
                    var record = JSON.stringify(table.getItem(row));
                    if (record != undefined) {
                        var ref = JSON.parse(record);

                        if (ref.colMultiChoice == "C") array.push(ref.dmdt_id);
                    }
                }, true);

                if (array.length == 0) return showError("Bạn chưa chọn dòng dữ liệu cần xóa!")

                var rpParameter = {
                    ids: array
                };
                openConfirmDelete(
                    "XOÁ NHIỀU PHIẾU ĐỐI TƯỢNG",
                    "Bạn có muốn xóa nhiều phiếu đối tượng đã chọn?",
                    function () {
                        deleteCustomer(rpParameter, table);
                    },
                    table
                )
            }
        }
    }
    var btnCopy = {
        view: "button",
        type: "htmlbutton",
        width: 100,
        label: `<i class="fa fa-files-o fa-lg" aria-hidden="true"></i><span class="text"> ${_("COPY")}</span>`,
        id: "btnCopyCustomer",
        click: function () {
            webix.callEvent("onLoadError");
            var table = webix.$$(datatableId);
            var item = table.getSelectedItem();

            if (item == null || item == undefined) return showError("Bạn chưa chọn dòng dữ liệu cần sửa!");

            var detailForm = this.$scope.ui(dmkhForm.$ui);
            dmkhForm.setEditMode(1);
            $$(formId).setValues(item, null);
            detailForm.show();

            var bankTable = webix.$$(datatableBankList);
            if (bankTable) {
                var url = app.config.host + constant.API.GET_DETAIL_TAB_TABLE + "?window_id=" + window_id + "&id=" + item.id + "&tab_table=" + tabTableNameBank;
                bankTable.load(url);
            }
        }
    };
    var btnImportExcel = {
        view: "button",
        type: "htmlbutton",
        width: 100,
        label: `<i class="fa fa-file-excel-o fa-lg" aria-hidden="true"></i><span class="text"> ${_("Nhận Excel")}</span>`,
        id: "btnImportExcelCustomer",
        click: function () {
            var excelForm = this.$scope.ui(uploadExcel.$ui);
            uploadExcel.setTypeDMKH(10);
            $$("importExcel").attachEvent("onClick", importExcel);
            excelForm.show();
        }
    };
    var btnExportExcel = {
        view: "button",
        type: "htmlbutton",
        width: 120,
        label: `<i class="fa fa-table fa-lg" aria-hidden="true"></i><span class="text"> ${_("EXPORT_EXCEL")}</span>`,
        id: "btnExportExcelCustomer",
        click: function () {
            const table = $$(datatableId);
            const tableState = table.getState();

            const filterArray = [];
            for (var key in tableState.filter) {
                var column = table.getColumnConfig(key);
                if (!column) continue;
                var val = tableState.filter[key];
                filterArray.push({
                    columnName: key,
                    columnType: column.columnType,
                    value: val
                });
            }

            webix.ui({
                id: "tableId",
                view: "datatable",
                autoheight: true,
                columns: [
                    { id: "stt", header: "STT", width: 50 },
                    { id: "ma_dt", header: "Mã Đối Tượng", width: 120 },
                    { id: "ten_dt", header: "Tên Đối Tượng", width: 550 },
                    { id: "dia_chi", header: "Địa Chỉ", width: 650 },
                    { id: "ms_thue", header: "Mã Số Thuế", width: 130 },
                    { id: "email", header: "Email", width: 180 },
                    { id: "dien_thoai", header: "Điện Thoại", width: 100 },
                    { id: "dien_giai", header: "Diễn Giải", width: 100 },
                    { id: "dt_me_id", header: "Nhóm Đối Tượng", width: 100 },
                    { id: "cccdan", header: "Căn cước công dân", width: 120 },
                    { id: "mdvqhnsach_nmua", header: "Mã đơn vị QHNS", width: 130 }
                ]
            });

            webix.ajax()
                .headers({ "Content-Type": "application/json" })
                .post(app.config.host + "/System/GetDataByWindowNo1", {
                    window_id: window_id,
                    start: 0,
                    count: 999999999,
                    filter: filterArray,
                    tlbparam: []
                }, function (text) {
                    var json = JSON.parse(text);
                    var dataAll = json.data;

                    const customerGroups = {};
                    webix.$$(datatableId)
                        .getColumnConfig("dt_me_id")
                        .collection
                        .serialize()
                        .forEach(x => {
                            customerGroups[x.id] = x.value;
                        });

                    dataAll.forEach((item, index) => {
                        item.stt = index + 1;

                        for (let key in item) {
                            if (item[key] === null || item[key] === undefined || item[key] === "null") {
                                item[key] = "";
                            }
                        }

                        const fieldsToQuote = ["ma_dt", "ms_thue", "dien_thoai", "cccdan", "mdvqhnsach_nmua"];
                        fieldsToQuote.forEach(f => {
                            if (item[f]) item[f] = `'${item[f]}`;
                        });

                        item.dt_me_id = customerGroups[item.dt_me_id] || "";
                    });

                    $$("tableId").clearAll();
                    $$("tableId").parse(dataAll);

                    webix.toExcel($$("tableId"), {
                        filename: "Danh_sach_khach_hang"
                    });
                });
        }
    };
    var btnCreateUser = {
        view: "button",
        type: "htmlbutton",
        width: 140,
        label: `<i class="fa fa-user fa-lg" aria-hidden="true"></i><span class="text"> ${_("Tạo User tra cứu")}</span>`,
        id: "btnCreateUser",
        click: function () {
            var table = webix.$$(datatableId);
            var item = table.getSelectedItem();
            if (!item) {
                webix.message("Bạn chưa chọn khách hàng !", "error");
                return;
            }

            var win = table.$scope.ui(usertracuuForm.$ui);
            usertracuuForm.initUI(item);
            win.getHead().setHTML("Tạo tài khoản tra cứu cho KH: " + item.ten_dt);
            win.show();
        }
    };

    var colsMaster = [
        { id: "subRowMain", header: "&nbsp;", template: "{common.subrow()}", width: 40 },
        { id: "stt", header: ["STT"], width: 50 },
        { id: "ma_dt", header: [_("Mã đối tượng"), { content: "serverFilter" }], fillspace: true, columnType: "string" },
        { id: "ten_dt", header: [_("Tên đối tượng"), { content: "serverFilter" }], fillspace: true, columnType: "string" },
        { id: "dia_chi", header: [_("Địa chỉ"), { content: "serverFilter" }], fillspace: true, columnType: "string" },
        { id: "ms_thue", header: [_("Mã số thuế"), { content: "serverFilter" }], fillspace: true, columnType: "string" },
        { id: "email", header: [_("Email"), { content: "serverFilter" }], fillspace: true, columnType: "string" },
        { id: "dien_thoai", header: [_("Điện thoại"), { content: "serverFilter" }], fillspace: true, columnType: "string" },
        { id: "dien_giai", header: [_("Diễn giải"), { content: "serverFilter" }], fillspace: true, columnType: "string" },
        {
            id: "dt_me_id",
            header: [_("Nhóm đối tượng"), { content: "selectFilter" }],
            fillspace: true,
            columnType: "string",
            editor: "combo",
            template: function (obj, common, value, config) {
                var data = [];

                if (config && config.collection && config.collection.s && config.collection.s.data) {
                    data = config.collection.s.data;
                }
                var item = data.find(function (x) { return x.id === value; });
                return (item && item.value) || "";
            }
        },
        { id: "cccdan", header: [_("Căn cước công dân"), { content: "serverFilter" }], fillspace: true, columnType: "string" },
        { id: "mdvqhnsach_nmua", header: [_("Mã đơn vị QHNS"), { content: "serverFilter" }], fillspace: true, columnType: "string" }
    ];

    var colsDetail = [
        { id: "so_tk", header: _("Số tài khoản"), editor: "text", width: 150, editable: true },
        { id: "tai_ngh", header: _("Tại ngân hàng"), editor: "text", width: 200, editable: true }
    ];

    var props = {
        window_id: window_id,
        colsMaster: colsMaster,
        colsDetail: colsDetail,
        datatableId: datatableId,
        datatableDetailId: datatableDetailId,
        datatableDetailHeader: datatableDetailHeader,
        tabTableNameBank: tabTableNameBank,
        apiGetDetails: constant.API.GET_DETAIL_TAB_TABLE
    };

    var gridContent = grid.gridDMKH(props);

    var controls = [btnRefresh, btnAdd, btnEdit, btnDelete, btnCopy, btnImportExcel, btnExportExcel, btnCreateUser];

    var layout = {
        css: "frmView",
        id: "frmView",
        rows: [
            {
                height: 39,
                id: "btnControl",
                css: "btnControl",
                margin: 0,
                borderless: true,
                type: "toolbar",
                cols: controls
            },
            {
                rows: [gridContent]
            }
        ]
    };

    return {
        $ui: layout,
        $oninit: function (view, $scope) {
            webix.ajax().get(constant.API.GET_NHOM_DT).then(function (response) {
                let data = response.json();
                const table = webix.$$(datatableId);
                const colConfig = table.getColumnConfig("dt_me_id");
                colConfig.collection = data;
                const filter = table.getFilter("dt_me_id");
                if (filter && filter.define) {
                    filter.define("options", data.map(x => ({ id: x.id, value: x.value })));
                    filter.refresh();
                }

                table.refreshColumns();
            });

            $scope.on(app, "DataRefresh", function () {
                const table = webix.$$(datatableId);
                table.clearAll();
                table.load(table.config.url);
            });
        },
        $onurlchange: function () { }
    };
});

define('views/forms/dmlanguage',["app"], function (app) {
	var editmode = 0;

	return {
		$ui: {
			view: "window", modal: true, id: "dmtab-win", position: "center",
			head: "Thông tin ngôn ngữ",
			width: 400,
			height: 250,
			body: {
				paddingY: 20,
				paddingX: 30,
				elementsConfig: { labelWidth: 60 },
				view: "form",
				id: "dmtab-form",
				complexData: true,
				margin: 0,
				elements: [
					{ view: "text", name: "wb_lang_id", label: "wb_lang_id", id: "wb_lang_id", hidden: true },
					{ view: "text", name: "key_lang", label: "Key", id: "dmtab-name" },
					{ view: "textarea", name: "value_lang", label: "Value", id: "dmtab-table" },
					{
						margin: 10,
						cols: [
							{},
							{
								shortcut: "F10", view: "button", label: "Nhận (F10)", type: "form", align: "center", width: 120,
								on: {
									onClick: function () {
										var form = webix.$$("dmtab-form");
										var item = form.getValues();
										//console.log(item);
										var url = editmode == 1 ? app.config.host + "/System/InsertLanguages" : app.config.host + "/System/UpdateLanguages"

										webix.ajax()
											.headers({ 'Content-type': 'application/json' })
											.post(url, item, function (text) {
												var data = JSON.parse(text);

												if (!data.hasOwnProperty("error")) {
													item.id = data.id;
													$$("dmtab-win").close();
													app.callEvent("dataChanged", [editmode, item]);
												}
												else {
													webix.message(data.error, "error");
												}
											});
									}
								},
								click: function () {
									this.callEvent("onClick");

								}
							},
							{
								view: "button", hotkey: "esc", label: "Hủy bỏ (ESC)", align: "center", type: "danger", width: 120,
								click: function () {
									webix.$$("dmtab-win").close();
								}
							},
							{}
						]
					}

				]
			}

		},
		setEditMode: function (mode) {
			editmode = mode;
		}
	};

});
define('views/dmlanguage',[
    "app",
    "views/forms/dmlanguage",
    "locale"
], function (app, dmtabform, _) {
    'use strict';

    //var windowno = app.path[1].params[0];    
    webix.$$("title").parse({ title: "Danh mục ngôn ngữ", details: "Chuyển ngôn ngữ" });
    var controls = [
        // {
        //     id: "btnRefresh",
        //     view: "button",
        //     type: "icon",
        //     icon: "refresh",
        //     label: _("REFRESH"),
        //     width: 90,
        //     // shortcut: "F4",
        //     //css:"button_raised",
        //     on: {
        //         onClick: function () {
        //             var table = webix.$$("dmtabData");
        //             table.clearAll();

        //             table.load(loadData());
        //         }
        //     },
        //     click: function () {
        //         this.callEvent("onClick");
        //     }
        // },
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-plus fa-lg" aria-hidden="true"></i> ' +
            '<span class="text">' + _("THEM") + " (F4)" + '</span>',
            id: "btnPlus",
            // view: "button",
            // type: "icon",
            // icon: "fas fa-plus",
            // label: _("THEM") + " (F4)",
            // width: 100,
            // css: "webix_secondary",
            shortcut: "F4",
            on: {
                onClick: function () {
                    var win = this.$scope.ui(dmtabform.$ui);
                    var form = webix.$$("dmtab-form");

                    if (webix.$$("txtWindowId").getValue() == "") {
                        webix.message("Bạn chưa chọn loại ngôn ngữ !", "error");
                        return;
                    }

                    var item = {
                        language_code: $$("txtWindowId").getValue()
                    };

                    form.setValues(item);

                    dmtabform.setEditMode(1);
                    win.show();
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-edit fa-lg" aria-hidden="true"></i> ' +
            '<span class="text">' + "Sửa (F3)" + '</span>',
            id: "btnEdit",
            // view: "button",
            // type: "icon",
            // icon: "fas fa-edit",
            // label: "Sửa (F3)",
            // width: 70,
            // css: "webix_secondary",
            shortcut: "F3",
            on: {
                onClick: function () {
                    var detailForm = this.$scope.ui(dmtabform.$ui);
                    var form = webix.$$("dmtab-form");

                    var table = webix.$$("dmtabData");
                    var item = table.getSelectedItem();
                    if (item == null || item == undefined) {
                        webix.message("Bạn chưa chọn dòng cần sửa ! ", "error");
                        return;
                    }
                    form.setValues(item);

                    dmtabform.setEditMode(2);
                    detailForm.show();
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-trash-o fa-lg" aria-hidden="true"></i> ' +
            '<span class="text">' + "Xóa (F8)" + '</span>',
            id: "btnDelete",
            // view: "button",
            // type: "icon",
            // icon: "fas fa-trash-o",
            // label: "Xóa (F8)",
            // width: 80,
            // css: "webix_secondary",
            shortcut: "F8",
            on: {
                onClick: function () {
                    var table = webix.$$("dmtabData");
                    var item = table.getSelectedItem();

                    webix.confirm({
                        text: "Bạn có muốn xóa " + item.key_lang, ok: "Có", cancel: "Không",
                        callback: function (res) {
                            if (res) {
                                webix.ajax().post(app.config.host + "/System/DeleteLanguages", item, function (text, xml, xhr) {
                                    if (text.hasOwnProperty("error")) {
                                        webix.message(text.error);
                                        return;
                                    }

                                    table.remove(item.id);

                                });

                            }
                        }
                    });
                }
            },
            click: function () {
                this.callEvent("onClick");
            }

        },
        {},
        {
            view: "combo",
            width: 300,
            label: "Ngôn ngữ",
            id: "txtWindowId",
            // options: ["en", "vi"],
            suggest: {
                // body: {
                //     url: app.config.host + "/System/GetDataReferencesByRefId?refId=RF00012"
                // }
                data: [
                    { id: "vi", value: "Việt Nam" },
                    { id: "en", value: "English" },
                    { id: "ko", value: "Korean" }
                ]
            },
            on: {
                onChange: function () {
                    loadData();
                }
            }
        }
    ];

    var grid = {
        rows: [
            {
                id: "dmtabData",
                view: "datatable",
                select: true,
                datafetch: 50,
                loadahead: 15,
                on: {
                    onItemDblClick: function (id, e, node) {
                        var btnEdit = $$("btnEdit");
                        btnEdit.callEvent("onClick");
                    }
                },
                columns: [
                    { id: "wb_lang_id", header: "wb_lang_id", hidden: true },
                    { id: "language_code", header: "LANGUAGES", hidden: true },
                    { id: "key_lang", header: ["Key", { content: "textFilter" }], width: 200 },
                    { id: "value_lang", header: ["Value", { content: "textFilter" }], fillspace: true }
                ],
                //columns: columns
                pager: "pagerA"

            },
            {
                id: "pagerA",
                view: "pager",
                size: 100,
                group: 5,
                template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}"
            }
        ]
    }

    var layout = {
        rows: [
            {
                id: "tlbMain",
                height: 39,
                css: "btnControl",
                type: "toolbar",
                margin: 0,
                borderless: true,
                cols: controls
            },
            {
                rows: [
                    grid
                ]
            }



        ]

    };

    function loadData() {
        var windowId = webix.$$("txtWindowId").getValue();
        var url = app.config.host + "/System/GetLanguagesByMa?lang=" + windowId;

        webix.ajax().get(url, function (text) {
            var json = JSON.parse(text);

            var table = webix.$$("dmtabData");
            table.clearAll();
            table.parse(json);

        });
    }



    return {
        $ui: layout,
        $oninit: function (view, $scope) {
            $scope.on(app, "dataChanged", function (mode, item) {

                var table = webix.$$("dmtabData");

                if (mode == 1) {
                    table.add(item);
                    //table.select(item.iddmtab,false);
                }

                if (mode == 2) {
                    var selectedItem = table.getSelectedItem();
                    table.updateItem(selectedItem.id, item);
                }

            });
        }
    };
});
define('views/forms/dmmaloi',["app"], function (app) {
	var editmode = 0;

	return {
		$ui: {
			view: "window", modal: true, id: "dmmaloi-win", position: "center",
			head: "Thông tin mã lỗi",
			width: 400,
			height: 250,
			body: {
				paddingY: 20,
				paddingX: 30,
				elementsConfig: { labelWidth: 60 },
				view: "form",
				id: "dmmaloi-form",
				complexData: true,
				margin: 0,
				elements: [
					{ view: "text", name: "wb_error_id", label: "wb_error_id", id: "wb_error_id", hidden: true },
					{ view: "text", name: "err_code", label: "Mã lỗi", id: "dm_err_code" },
					{ view: "textarea", name: "description", label: "Mô tả", id: "dm_description" },
                    { view: "textarea", name: "note", label: "Ghi chú", id: "dm_note" },
					{
						margin: 10,
						cols: [
							{},
							{
								shortcut: "F10", view: "button", label: "Nhận (F10)", type: "form", align: "center", width: 120,
								on: {
									onClick: function () {
										var form = webix.$$("dmmaloi-form");
										var item = form.getValues();
										//console.log(item);
										var url = editmode == 1 ? app.config.host + "/System/InsertWb_Error" : app.config.host + "/System/UpdateWb_Error"

										webix.ajax()
											.headers({ 'Content-type': 'application/json' })
											.post(url, item, function (text) {
												var data = JSON.parse(text);

												if (!data.hasOwnProperty("error")) {
													item.id = data.id;
													$$("dmmaloi-win").close();
													app.callEvent("dataErrorChanged", [editmode, item]);
												}
												else {
													webix.message(data.error, "error");
												}
											});
									}
								},
								click: function () {
									this.callEvent("onClick");

								}
							},
							{
								view: "button", hotkey: "esc", label: "Hủy bỏ (ESC)", align: "center", type: "danger", width: 120,
								click: function () {
									webix.$$("dmmaloi-win").close();
								}
							},
							{}
						]
					}

				]
			}

		},
		setEditMode: function (mode) {
			editmode = mode;
		},
        setValues: function(item)
        {
            $$("dmmaloi-form").setValues(item);
        }
	};

});
define('views/dmmaloi',[
    "app",
    "views/forms/dmmaloi",
    "locale"
], function (app, dmmaloiform, _) {
    'use strict';

    //var windowno = app.path[1].params[0];    
    webix.$$("title").parse({ title: "Danh mục mã lỗi", details: "Danh mục mã lỗi" });
    var controls = [
        // {
        //     id: "btnRefresh",
        //     view: "button",
        //     type: "icon",
        //     icon: "refresh",
        //     label: _("REFRESH"),
        //     width: 90,
        //     // shortcut: "F4",
        //     //css:"button_raised",
        //     on: {
        //         onClick: function () {
        //             var table = webix.$$("dmerrorData");
        //             table.clearAll();

        //             table.load(loadData());
        //         }
        //     },
        //     click: function () {
        //         this.callEvent("onClick");
        //     }
        // },
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-plus fa-lg" aria-hidden="true"></i> ' +
            '<span class="text">' + _("THEM") + " (F4)" + '</span>',
            id: "btnPlus",
            // view: "button",
            // type: "icon",
            // icon: "fas fa-plus",
            // label: _("THEM") + " (F4)",
            // width: 100,
            // css: "webix_secondary",
            shortcut: "F4",
            on: {
                onClick: function () {
                    var win = this.$scope.ui(dmmaloiform.$ui);
                    var form = webix.$$("dmmaloi-form");

                    if (webix.$$("cbLanguage").getValue() == "") {
                        webix.message("Bạn chưa chọn loại ngôn ngữ !", "error");
                        return;
                    }

                    var item = {
                        language_code: $$("cbLanguage").getValue()
                    };

                    form.setValues(item);

                    dmmaloiform.setEditMode(1);
                    win.show();
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-edit fa-lg" aria-hidden="true"></i> ' +
            '<span class="text">' + _("Sửa (F3)") + '</span>',
            id: "btnEdit",
            // view: "button",
            // type: "icon",
            // icon: "fas fa-edit",
            // label: "Sửa (F3)",
            // width: 65,
            // css: "webix_secondary",
            shortcut: "F3",
            on: {
                onClick: function () {
                    var detailForm = this.$scope.ui(dmmaloiform.$ui);
                    // var form = webix.$$("dmmaloi-form");

                    var table = webix.$$("dmerrorData");
                    var item = table.getSelectedItem();
                    if (item == null || item == undefined) {
                        webix.message("Bạn chưa chọn dòng cần sửa ! ", "error");
                        return;
                    }
                    // form.setValues(item);
                    dmmaloiform.setValues(item);
                    dmmaloiform.setEditMode(2);
                    detailForm.show();
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-trash-o fa-lg" aria-hidden="true"></i> ' +
            '<span class="text">' + _("Xóa (F8)") + '</span>',
            id: "btnDelete",
            // view: "button",
            // type: "icon",
            // icon: "fas fa-trash-o",
            // label: "Xóa (F8)",
            // width: 80,
            // css: "webix_secondary",
            shortcut: "F8",
            on: {
                onClick: function () {
                    var table = webix.$$("dmerrorData");
                    var item = table.getSelectedItem();

                    webix.confirm({
                        text: "Bạn có muốn xóa " + item.key_lang, ok: "Có", cancel: "Không",
                        callback: function (res) {
                            if (res) {
                                webix.ajax().post(app.config.host + "/System/DeleteWb_Error", item, function (text, xml, xhr) {
                                    if (text.hasOwnProperty("error")) {
                                        webix.message(text.error);
                                        return;
                                    }

                                    table.remove(item.id);

                                });

                            }
                        }
                    });
                }
            },
            click: function () {
                this.callEvent("onClick");
            }

        },
        {},
        {
            view: "combo",
            width: 300,
            label: "Ngôn ngữ",
            id: "cbLanguage",
            // options: ["en", "vi"],
            suggest: {
                // body: {
                //     url: app.config.host + "/System/GetDataReferencesByRefId?refId=RF00012"
                // }
                data: [
                    { id: "vi", value: "Việt Nam" },
                    { id: "en", value: "English" },
                    { id: "ko", value: "Korean" }
                ]
            },
            on: {
                onChange: function () {
                    loadData();
                }
            }
        }
    ];

    var grid = {
        rows: [
            {
                id: "dmerrorData",
                view: "datatable",
                select: true,
                datafetch: 50,
                loadahead: 15,
                on: {
                    onItemDblClick: function (id, e, node) {
                        var btnEdit = $$("btnEdit");
                        btnEdit.callEvent("onClick");
                    }
                },
                columns: [
                    { id: "wb_error_id", header: "wb_lang_id", hidden: true },
                    { id: "language_code", header: "LANGUAGES", hidden: true },
                    { id: "err_code", header: ["Mã lỗi", { content: "textFilter" }], width: 200 },
                    { id: "description", header: ["Mô tả", { content: "textFilter" }], fillspace: true },
                    { id: "note", header: ["Ghi chú", { content: "textFilter" }], width: 300 }
                ],
                //columns: columns
                pager: "pagerA"

            },
            {
                id: "pagerA",
                view: "pager",
                size: 100,
                group: 5,
                template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}"
            }
        ]
    }

    var layout = {
        rows: [
            {
                id: "tlbMain",
                height: 39,
                css: "btnControl",
                type: "toolbar",
                margin: 0,
                borderless: true,
                cols: controls
            },
            {
                rows: [
                    grid
                ]
            }



        ]

    };

    function loadData() {
        var windowId = webix.$$("cbLanguage").getValue();
        var url = app.config.host + "/System/GetErrorByLang?lang=" + windowId;

        webix.ajax().get(url, function (text) {
            var json = JSON.parse(text);

            var table = webix.$$("dmerrorData");
            table.clearAll();
            table.parse(json);

        });
    }



    return {
        $ui: layout,
        $oninit: function (view, $scope) {
            $scope.on(app, "dataErrorChanged", function (mode, item) {

                var table = webix.$$("dmerrorData");

                if (mode == 1) {
                    table.add(item);
                    //table.select(item.iddmtab,false);
                }

                if (mode == 2) {
                    var selectedItem = table.getSelectedItem();
                    table.updateItem(selectedItem.id, item);
                }

            });
        }
    };
});
define('views/forms/forms68/ChungTu/dmngnopthue',["app"], function (app) {
    var editmode = 0;

    return {
        $ui: {
            view: "window", modal: true, id: "dmngnopthue-win", position: "center",
            head: "Thông tin người nộp thuế",
            width: 600,
            height: 600,
            move: true,
            resize: true,
            body: {
                paddingY: 10,
                paddingX: 10,
                view: "form",
                id: "dmngnopthue-form",
                elementsConfig: { labelWidth: 150 },
                complexData: true,
                margin: 0,
                elements: [
                    {
                        cols: [
                            {
                                view: "text", name: "ma_nnt", label: "Mã NNT", width: 290, css: "mcls_uppercase2",
                                invalidMessage: "Mã người nộp thuế không được để trống",
                                validate: webix.rules.isNotEmpty,
                                required: true,
                            },
                            {
                                view: "search", name: "mstcn", id: "mstcn", label: "Mã số thuế TNCN", width: 290,
                                on: {
                                    onChange: function (newv, oldv) {
                                        if (newv == undefined || oldv == undefined) return;
                                        if (oldv == "") return;
                                        if (newv == "") return;
                                    },
                                    onTimedKeyPress: function () {

                                    },
                                    onSearchIconClick: function (e) {
                                        $$("hoten").setValue("");
                                        $$("dia_chi").setValue("");
                                        var text = this.getValue();
                                        var datapost = { "masothue": text };
                                        var table = $$("dmngnopthue-form");
                                        webix.extend(table, webix.ProgressBar);
                                        table.disable();
                                        table.showProgress();
                                        webix.ajax()
                                            .bind(this)
                                            .headers({ 'Content-type': 'application/json' })
                                            .post(app.config.host + "/Pattern/GetInfoMST", datapost, {
                                                error: function (text, data, XmlHttpRequest) {
                                                    var table = $$("dmngnopthue-form");
                                                    table.enable();
                                                    table.hideProgress();
                                                    this.focus();
                                                },
                                                success: function (text) {
                                                    var response = JSON.parse(text);
                                                    table.enable();
                                                    table.hideProgress();
                                                    this.focus();

                                                    if (!response.hasOwnProperty("error")) {
                                                        $$("hoten").setValue(response.nguoi_dai_dien);
                                                        $$("dia_chi").setValue(response.dia_chi);
                                                    }
                                                    else {
                                                        webix.message(response.error, "error", 2000);
                                                    }
                                                }
                                            });
                                    }
                                }
                            },
                        ]
                    },
                    {
                        cols: [
                            {
                                view: "text", name: "hoten", id: "hoten", label: "Họ và tên", required: true,
                                invalidMessage: "Họ tên không được để trống",
                                validate: webix.rules.isNotEmpty
                            },
                            {
                                view: "search", name: "cmnd", id: "cmnd", label: "CMND/CCCD",
                                on: {
                                    onChange: function (newv, oldv) {
                                        if (newv == undefined || oldv == undefined) return;
                                        if (newv == "") return;
                                    },
                                    onTimedKeyPress: function () {

                                    },
                                    onSearchIconClick: function (e) {
                                        $$("mstcn").setValue("");
                                        $$("hoten").setValue("");

                                        var text = this.getValue();
                                        var datapost = { "cid": text };
                                        var table = $$("dmngnopthue-form");
                                        webix.extend(table, webix.ProgressBar);
                                        table.disable();
                                        table.showProgress();
                                        webix.ajax()
                                            .bind(this)
                                            .headers({ 'Content-type': 'application/json' })
                                            .post(app.config.host + "/Pattern/GetInfoCID", datapost, {
                                                error: function (text, data, XmlHttpRequest) {
                                                    var table = $$("dmngnopthue-form");
                                                    table.enable();
                                                    table.hideProgress();
                                                    this.focus();
                                                },
                                                success: function (text) {
                                                    var response = JSON.parse(text);
                                                    table.enable();
                                                    table.hideProgress();
                                                    this.focus();

                                                    if (!response.hasOwnProperty("error")) {
                                                        $$("hoten").setValue(response.ho_ten);
                                                        $$("mstcn").setValue(response.mst_tncn);
                                                    }
                                                    else {
                                                        webix.message(response.error, "error", 2000);
                                                    }
                                                }
                                            });
                                    }
                                }
                            }
                        ]
                    },
                    {
                        cols: [
                            { view: "text", name: "noicap_cmnd", label: "Nơi cấp CMND/CCCD" },
                            {
                                view: "datepicker", name: "ngaycap_cmnd", label: "Ngày cấp CMND/CCCD", editable: true,
                                id: "ngaycap_cmnd"
                            },
                        ]
                    },
                    { view: "text", id: "dia_chi", name: "dia_chi", label: "Địa chỉ" },
                    {
                        cols: [
                            {
                                view: "text", name: "quoc_tich", label: "Quốc tịch", value: "Việt Nam", required: true,
                                invalidMessage: "Quốc tịch không được để trống",
                                validate: webix.rules.isNotEmpty
                            },
                            {
                                view: "radio", name: "cu_tru", label: "Cá nhân cư trú", required: true,
                                value: true, labelWidth: 100,
                                options: [
                                    { id: true, value: "Có" },
                                    { id: false, value: "Không" }
                                ]
                            },
                        ]
                    },
                    {
                        cols: [
                            { view: "text", name: "dien_thoai", label: "Điện thoại" },
                            {
                                view: "text", name: "email", label: "Email",
                                invalidMessage: "Địa chỉ email không hợp lệ",
                                validate: webix.rules.isEmail
                            },
                        ]
                    },
                    {
                        cols: [
                            { view: "text", name: "chuc_vu", label: "Chức vụ" },
                            { view: "text", name: "so_hdld", label: "Số HĐLĐ" },
                        ]
                    },
                    {
                        cols: [
                            { view: "datepicker", name: "ngayden_vn", label: "Ngày đến VN", editable: true },
                            { view: "datepicker", name: "ngay_hdld", label: "Ngày HĐLĐ", editable: true },
                        ]
                    },
                    {
                        view: "combo", name: "pp_tinhthue", label: "Cách tính thuế",
                        options: [
                            { id: 1, value: "1- Cá nhân cư trú có hợp đồng lao động" },
                            { id: 2, value: "2- Cá nhân cư trú không ký hợp đồng, hợp đồng dưới 3 tháng" },
                            { id: 3, value: "3- Cá nhân không cư trú" },
                        ]
                    },
                    {
                        margin: 10,
                        cols: [
                            {},
                            {
                                shortcut: "F10", view: "button", label: "Nhận (F10)", type: "form", align: "center", width: 140,
                                on: {
                                    onClick: function () {
                                        var form = webix.$$("dmngnopthue-form");
                                        if (!form.validate()) {
                                            return;
                                        }

                                        var item = form.getValues();

                                        if (item.mstcn != null && item.mstcn != "") {
                                            var valid = webix.rules.isTaxCode(item.mstcn);
                                            if (valid == false) {
                                                webix.message({ type: "error", text: "Mã số thuế cá nhân không hợp lệ" });
                                                return;
                                            }
                                        }
                                        // if (item.cmnd != null && item.cmnd != "") {
                                        //     var valid = webix.rules.isNumber(item.cmnd);
                                        //     if (valid == false) {
                                        //         webix.message({ type: "error", text: "CMND/CCCD không hợp lệ" });
                                        //         return;
                                        //     }
                                        // }

                                        webix.ajax()
                                            .headers({ 'Content-type': 'application/json' })
                                            .post(app.config.host + "/Dmngnopthue/Save", item, function (text) {
                                                var res = JSON.parse(text);

                                                if (res.code == "00") {
                                                    if ($$("dmngnopthue-win").config.callback != undefined)
                                                        $$("dmngnopthue-win").config.callback(res.data);
                                                    webix.$$("dmngnopthue-win").close();
                                                    app.callEvent("dataChanged", [editmode, res.data]);
                                                }
                                                else {
                                                    webix.message(res.message);
                                                }
                                            });
                                    }
                                },
                                click: function () {
                                    this.callEvent("onClick");
                                }
                            },
                            {
                                view: "button", hotkey: "esc", label: "Hủy bỏ (ESC)", type: "danger", align: "center", width: 140,
                                click: function () {
                                    webix.$$("dmngnopthue-win").close();
                                }
                            },
                            {}
                        ]
                    }

                ]

            }

        },
        setEditMode: function (mode) {
            editmode = mode;
        }
    };

});
define('views/dmngnopthue',[
    "app",
    "views/forms/forms68/ChungTu/dmngnopthue",
    "locale"
], function (app, dmwindowform, _) {
    'use strict';

    var controls = [
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-refresh fa-lg" aria-hidden="true"></i> ' +
                '<span class="text">' + _("REFRESH") + '</span>',
            id: "btnRefresh",
            on: {
                onClick: function () {
                    var table = webix.$$("dmngnopthue");
                    table.clearAll();
                    table.load(table.config.url);
                },
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-plus fa-lg" aria-hidden="true"></i> ' +
            '<span class="text">' + _("THEM") + " (F4)" + '</span>',
            id: "btnPlus",            
            shortcut: "F4",
            on: {
                onClick: function () {
                    var win = this.$scope.ui(dmwindowform.$ui);
                    dmwindowform.setEditMode(1);
                    win.show();
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-edit fa-lg" aria-hidden="true"></i> ' +
            '<span class="text">' + _("SUA") + " (F3)" + '</span>',
            id: "btnEdit",            
            shortcut: "F3",
            on: {
                onClick: function () {
                    var table = webix.$$("dmngnopthue");
                    var selectedItem = table.getSelectedItem();
                    if (selectedItem == null) {
                        webix.message("Bạn chưa chọn dòng cần sửa ! ", "error");
                        return;
                    }

                    var detailForm = this.$scope.ui(dmwindowform.$ui);
                    var form = webix.$$("dmngnopthue-form");

                    var table = webix.$$("dmngnopthue");
                    var item = table.getSelectedItem();
                    if (item.ngaycap_cmnd != null && item.ngaycap_cmnd != undefined){
                        item.ngaycap_cmnd = removeTimeZoneT(item.ngaycap_cmnd);
                    }
                    if (item.ngayden_vn != null && item.ngayden_vn != undefined){
                        item.ngayden_vn = removeTimeZoneT(item.ngayden_vn);
                    }
                    if (item.ngay_hdld != null && item.ngay_hdld != undefined){
                        item.ngay_hdld = removeTimeZoneT(item.ngay_hdld);
                    }
                    //console.log(item);
                    form.setValues(item);
                    dmwindowform.setEditMode(2);
                    detailForm.show();                    
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-trash-o fa-lg" aria-hidden="true"></i> ' +
            '<span class="text">' + _("XOA") + " (F8)" + '</span>',
            id: "btnDelete",            
            shortcut: "F8",
            on: {
                onClick: function () {
                    var table = webix.$$("dmngnopthue");
                    var item = table.getSelectedItem();
                    if (item == null) {
                        webix.message("Bạn chưa chọn dòng cần xóa ! ", "error");
                        return;
                    }
                    webix.confirm({
                        text: "Bạn có muốn xóa " + item.ma_nnt, ok: "Có", cancel: "Không",
                        callback: function (res) {
                            if (res) {
                                webix.ajax()
                                    .headers({ 'Content-type': 'application/json' })
                                    .post(app.config.host + "/Dmngnopthue/Delete", item, function (text, xml, xhr) {
                                        if (text.hasOwnProperty("error")) {
                                            webix.message(text.error);
                                            return;
                                        }

                                        table.remove(item.id);

                                    });

                            }
                        }
                    });
                }
            },
            click: function () {
                this.callEvent("onClick");
            }

        },        
        {}

    ];

    var grid = {
        rows: [
            {
                id: "dmngnopthue",
                view: "datatable",
                select: true,
                datafetch: 100,
                resizeColumn: true,
                //loadahead: 15,
                url: {
                    $proxy: true,
                    load: function (view, callback, params) {
                        var url = app.config.host + "/Dmngnopthue/GetData";
                        
                        var postData = {
                            start: 0,
                            count: view.config.datafetch,
                            continue: null,
                            filter: null
                        };                        
                        
                        if (params != null) {

                            postData.start = params.start;
                            postData.count = params.count;
                            postData.continue = params.continue;                            
                            postData.filter = [];

                            if (params.filter != null) {                                

                                for (var property in params.filter) {

                                    var value = params.filter[property];
                                    if (value == "" || value == null) continue;

                                    var column = view.getColumnConfig(property);

                                    var item = {
                                        columnName: property,
                                        columnType: column.columnType,
                                        value: params.filter[property]
                                    };

                                    postData.filter.push(item);
                                }                                
                            }
                        }

                        webix.ajax()
                            .headers({ 'Content-type': 'application/json' })
                            .bind(view)
                            .post(url, postData, callback, view);
                    }   
                },
                on: {
                    "data->onStoreUpdated": function () {
                        this.data.each(function (obj, i) {
                            obj.stt = i + 1;
                        });
                    },
                    onItemDblClick: function (id, e, node) {
                        var btnEdit = $$("btnEdit");
                        btnEdit.callEvent("onClick");
                    },
                    onBeforeLoad: function () {
                        this.showOverlay("<p><i style='font-size:450%;' class='fa fa-spin fa-spinner fa-pulse'></i></p>");
                    },
                    onAfterLoad: function (id) {
                        this.hideOverlay();
                    }
                },
                columns: [
                    {
                        id: "stt", header: "STT", sort: "int", width: 40,
                    },
                    { id: "ma_nnt", header: ["Mã NNT", { content: "serverFilter" }], width: 100 },
                    { id: "mstcn", header: ["Mã số thuế TNCN", { content: "serverFilter" }], width: 150 },
                    { id: "hoten", header: ["Họ tên", { content: "serverFilter" }], width: 200 },
                    { id: "cmnd", header: ["CMND/CCCD", { content: "serverFilter" }], width: 150 },
                    { id: "noicap_cmnd", header: ["Nơi cấp CMND/CCCD", { content: "serverFilter" }], width: 250 },
                    { id: "ngaycap_cmnd", header: ["Ngày cấp CMND/CCCD", { content: "serverDateRangeFilter" }], width: 150,
                        format: function (text) {
                            var format = webix.Date.dateToStr("%d/%m/%Y");
                            text = removeTimeZoneT(text);
                            return format(text);
                        }
                    },
                    { id: "dia_chi", header: ["Địa chỉ", { content: "serverFilter" }], width: 250 },
                    { id: "quoc_tich", header: ["Quốc tịch", { content: "serverFilter" }], width: 120 },
                    { id: "cu_tru", header: ["Cá nhân cư trú", { content: "serverSelectFilter" }], width: 130,
                        editor:"combo",
                        options:[
                            { id:true, value:"Có" },
                            { id:false, value:"Không" },
                        ],
                        template: function (obj) {
                            var checked = obj.cu_tru === true ? 'checked="true"' : "";
                            return ("<input disabled class='webix_table_checkbox' type='checkbox' " + checked + ">");
                        }
                    },
                    { id: "dien_thoai", header: ["Điện thoại", { content: "serverFilter" }], width: 150 },
                    { id: "email", header: ["Email", { content: "serverFilter" }], width: 150 },
                    { id: "pp_tinhthue", header: ["Cách tính thuế", { content: "serverSelectFilter" }], width: 250 ,
                        editor:"combo",
                        options:[
                            { id:1, value:"1- Cá nhân cư trú có hợp đồng lao động" },
                            { id:2, value:"2- Cá nhân cư trú không ký hợp đồng, hợp đồng dưới 3 tháng" },
                            { id:3, value:"3- Cá nhân không cư trú" },
                        ],
                        template: function (obj) {
                            if (obj.pp_tinhthue == null) return "";
                            if (obj.pp_tinhthue == 1) return "1- Cá nhân cư trú có hợp đồng lao động";
                            if (obj.pp_tinhthue == 2) return "2- Cá nhân cư trú không ký hợp đồng, hợp đồng dưới 3 tháng";
                            if (obj.pp_tinhthue == 3) return "3- Cá nhân không cư trú";
                        }
                    },
                ],
                pager: "pagerA"

            },
            {
                cols: [
                    {
                        view: "icon", icon: "fas fa-question-circle", id: "help_form_views", tooltip: _("HELPER"),
                        css: "helper",
                        // click: function () {
                        //     this.callEvent("onClick");
                        // }
                        click: function () {
                            webix.alert({
                                title: "Thông báo !",
                                text: "Bạn chưa khai báo hướng dẫn nhanh cho màn hình này !",
                                type: "alert-warning",
                                callback: function (result) {
                                }
                            });
                        }
                    },
                    {
                        view: "combo",
                        label: _("MENU_QUICK"),
                        id: "QuickMenu1",
                        options: {
                        },
                        on: {
                            onChange: function (newv, oldv) {

                            }
                        }
                    },
                    {},
                    {
                        id: "pagerA",
                        view: "pager",
                        size: 50,
                        group: 5,
                        on: {
                            onAfterPageChange: function (id) {
                            }
                        },
                        template: function (data, common) {
                            return "Số dòng: " + data.count + ". " + common.first(data) + common.prev(data) + common.pages(data) + common.next(data) + common.last(data);
                        },
                        animate: { direction:"top" }
                    }
                ]
            }
        ]
    }

    var layout = {
        css: "frmView",
        rows: [
            {
                height: 39,
                css: "btnControl",
                type: "toolbar",
                margin: 0,
                borderless: true,
                cols: controls
            },
            {
                rows: [
                    grid
                ]
            }



        ]

    };    

    return {
        $ui: layout,
        $oninit: function (view, $scope) {
            $scope.on(app, "dataChanged", function (mode, item) {

                var table = webix.$$("dmngnopthue");

                if (mode == 1) {
                    table.add(item);
                    //table.select(item.iddmwindow,false);
                }

                if (mode == 2) {
                    var selectedItem = table.getSelectedItem();
                    table.updateItem(selectedItem.id, item);
                }

            });
        }
    };
});
define('views/forms/dmreferences',["app"],function(app){
	var editmode = 0;	

	return {		
		$ui:{   
			view:"window", modal:true, id:"dmwindow-win", position:"center",
			head:"Thông tin Window",
			fullscreen:true,
			body:{
                paddingY:20, 
                paddingX:30, 
                elementsConfig:{labelWidth: 100}, 
                view:"form", 
				id:"dmwindow-form", 
				complexData:true,
				margin:0,
                elements:[
					{ view:"text", name:"REFERENCES_ID", label:"RF ID",  id:"dmwindow-rfid"},
                    { view:"text", name:"NAME", label:"Name",  id:"dmwindow-name"},
					{
						cols:[
							{ view:"text", name:"VALUE_FIELD", label:"Value Field",  id:"dmwindow-valuefield"},
							{ view:"text", name:"DISPLAY_FIELD", label:"Display Field",  id:"dmwindow-displayfield"},
						]
					},
					{ view:"combo", name:"TYPE", label:"TYPE", options:[ "List", "SQL" ], id:"dmwindow-type"},
					{ view:"text", name:"SQL", label:"SQL",  id:"dmwindow-sql"},
					{ view:"text", name:"LIST_VALUE", label:"LIST VALUE",  id:"dmwindow-listvalue"},
					{ view:"text", name:"LIST_COLUMN", label:"LIST COLUMN",  id:"dmwindow-listcolumn"},
					{ view:"text", name:"FILTER_VALUE", label:"FILTER VALUE",  id:"dmwindow-filtervalue"},
					{ view:"text", name:"ORDER_BY", label:"ORDER BY",  id:"dmwindow-orderby"},
					{ view:"text", name:"GHICHU", label:"Ghi chú",  id:"dmwindow-ghichu"},
					{ 
						view:"combo", 
						name:"WINDOW_ID", 
						label:"WINDOW ID",  
						id:"dmwindow-windowid",
						options: app.config.host + "/api/System/GetDataByReferencesId?id=76DCF72E-7631-458A-986F-5B6D9BE9B203"
					},
					{
						margin:10,
						cols:[
							{},
							{ 
								shortcut:"F10",  view:"button", label:"Nhận", type:"form", align:"center", width:120, 
								on: {
									onClick: function() {
										var form = webix.$$("dmwindow-form");
										var item = form.getValues();
										console.log(item);
										if(editmode==1){
											webix.ajax().post( app.config.host + "/api/System/InsertReferences", item, function(text){
												var data = JSON.parse(text);
												//console.log(data);
												if (!data.hasOwnProperty("error")){
													item.id = data.id;
													webix.$$("dmwindow-win").close();
													app.callEvent("dataChanged",[editmode,item]);
												}
												else {
													webix.message(data.error);
												}
											});
										}
										if(editmode==2){
											webix.ajax().post( app.config.host + "/api/System/UpdateReferences", item, function(text){
												var data = JSON.parse(text);
												//console.log(data);
												if (!data.hasOwnProperty("error")){
													item.id = data.id;
													webix.$$("dmwindow-win").close();
													app.callEvent("dataChanged",[editmode,item]);
												}
												else {
													webix.message(data.error);
												}
											});
										}
										
									}
								},
								click:function(){								
									this.callEvent("onClick");							
									
								}
							},
							{ view:"button", hotkey:"esc", label:"Hủy bỏ",align:"center", width:120, 
								click:function(){
									webix.$$("dmwindow-win").close();
								}
							}
						]
					}

				]
			}			
			
		},		
		setEditMode: function(mode) {
			editmode = mode;
		}
	};

});
define('views/dmreferences',[
    "app",
    "views/forms/dmreferences"
], function(app,dmwindowform) {
    'use strict';

    var op=[];
    var url = app.config.host + "/api/System/getAllWindows";
     webix.ajax(url, function (text, xml, xhr) {

        var rp = JSON.parse(text);
        //console.log(Object.keys(rp).length);

        for (var i = 0; i < (Object.keys(rp['data']).length); i++) {

              op.push({ ID: String(rp['data'][i]['ID']), WINDOW_NAME: String(rp['data'][i]['WINDOW_NAME'])});
        }
       console.log(op[0]['WINDOW_NAME']);
      });

    var controls = [
        { 
            id: "btnPlus",
            view: "button", 
            type: "iconButton", 
            icon:"plus", 
            label: "Thêm" ,
            width:110,
            css:"button_raised",
            shortcut: "F4",
            on: {
                onClick: function(){
                    var win = this.$scope.ui(dmwindowform.$ui);                   
                    dmwindowform.setEditMode(1);
                    win.show();
                }
            },
            click: function(){
                this.callEvent("onClick");
            }
        },
        {
            id: "btnEdit",
            view: "button", 
            type: "iconButton", 
            icon:"edit", 
            label: "Sửa" ,
            width:100,
            css:"button_raised",
            shortcut: "F3",
            on: {
                onClick: function() {
                    var detailForm = this.$scope.ui(dmwindowform.$ui);
                    var form = webix.$$("dmwindow-form");
                    
                    var table = webix.$$("dmwindowData");
                    var item = table.getSelectedItem();                   
                    console.log(item);
                    form.setValues(item);
                    
                    dmwindowform.setEditMode(2);
                    detailForm.show();
                }
            },
            click: function(){
                this.callEvent("onClick");
            }           
        },
        {
            id: "btnDelete", 
            view: "button", 
            type: "iconButton", 
            icon:"trash-o", 
            label: "Xóa" ,
            width:100,
            css:"button_raised",
            shortcut: "F8",
            on : {
                onClick: function() {
                    
					var table = webix.$$("dmwindowData");
                    var item = table.getSelectedItem();
					
                    webix.confirm({
                        text:"Bạn có muốn xóa " + item.WINDOW_NAME, ok:"Có", cancel:"Không",
                        callback:function(res){
                            if(res){
                                webix.ajax().post( app.config.host + "/api/System/DeleteReferences?id=" + item.id , function(text, xml, xhr){
                                    if (text.hasOwnProperty("error")){
                                        webix.message(text.error);
                                        return;
                                    }
                                    
                                    table.remove(item.id);

                                });
                                
                            }
                        }
                    });
                }
            },
            click: function(){
                this.callEvent("onClick");
            }
            
        },
        {}
        
    ];       
    
    var grid = {
        rows:[
            {
                id : "dmwindowData",
                view: "datatable", 
                select: true,
                datafetch: 2,
                loadahead: 15,
                resizeColumn:true,
                url: {
                     $proxy:true,
                     load:function(view, callback, params){
                            var url = app.config.host + "/api/System/GetAllReferences";                           
                            webix.ajax(url, callback, view);
                            
                   }
                },                
                columns: [
					 {id: "REFERENCES_ID", header: "RF ID" , width:100 },
                     {id: "NAME", header: "Title" , width:250 },
                     {id: "VALUE_FIELD", header: "Value Field" , width: 150 },
                     {id: "DISPLAY_FIELD", header: "Display Field" , width: 150 },
                     {id: "TYPE", header: "Type" , width:100 },
                     {id: "SQL", header: "SQL" , width: 250 }, 
                     {id: "ORDER_BY", header: "ORDER BY" , width: 150 }, 
					 {id: "LIST_VALUE", header: "LIST VALUE" , width: 250 }, 
					 {id: "GHICHU", header: "GHI CHU" , width: 250 }, 
                 ],                
                pager:"pagerA"
                
            },
            {
                id: "pagerA",
                view:"pager",
                size: 100,
                group: 5,
                template:"{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}"
            }
        ]
    }

    var layout = {
		rows:[
			{
				height:45,
				view:"toolbar",
				cols:controls
			},
			{
				rows:[
					grid					
				]
			}



		]

    };
    
    
    return {
        $ui: layout,
        $oninit: function(view,$scope) {
            $scope.on(app, "dataChanged", function(mode,item){

                var table = webix.$$("dmwindowData");

                if (mode == 1){
                    table.add(item);
                    //table.select(item.iddmwindow,false);
                }

                if (mode == 2){
                    var selectedItem = table.getSelectedItem();
                    table.updateItem(selectedItem.id,item);
                }
                
            });
        }
	};
});
define('views/forms/dmtab',["app"], function (app) {
	var editmode = 0;

	return {
		$ui: {
			view: "window", modal: true, id: "dmtab-win", position: "center",
			head: "Thông tin Tab",
			fullscreen: true,
			body: {
				view: "scrollview",
				scroll: "native-y",
				body: {
					paddingY: 10,
					paddingX: 10,
					elementsConfig: { labelWidth: 100 },
					view: "form",
					id: "dmtab-form",
					complexData: true,
					margin: 0,
					elements: [
						{
							cols: [
								{ view: "text", name: "tab_id", label: "TAB ID", id: "dmtab-id" },
								{ view: "text", name: "stt", label: "STT", id: "dmtab-stt" },
							]
						},
						{ view: "text", name: "tab_name", label: "Tab Name", id: "dmtab-name" },
						{ view: "text", name: "tab_table", label: "Tab Table", id: "dmtab-table" },
						{
							cols: [
								{
									view: "combo",
									name: "tab_type",
									label: "TAB TYPE",
									options: ["Normal", "Detail", "Master"],
									id: "dmtab-type"
								},
								{
									view: "combo",
									name: "tab_view",
									label: "TAB VIEW",
									options: ["Grid", "Tree"],
									id: "dmtab-view"
								}
							]
						},
						{ view: "text", name: "foreign_key", label: "FOREIGN KEY", id: "dmtab-FOREIGN-KEY" },
						{ view: "text", name: "insert_cmd", label: "INSERT CMD", id: "dmtab-insert-cmd" },
						{ view: "text", name: "update_cmd", label: "UPDATE CMD", id: "dmtab-update-cmd" },
						{ view: "text", name: "delete_cmd", label: "DELETE CMD", id: "dmtab-delete-cmd" },
						{ view: "textarea", name: "select_cmd", label: "SELECT CMD", height: 100, id: "dmtab-select-cmd" },
						{ view: "textarea", name: "select_change", label: "SELECT CHANGE", height: 150, id: "dmtab-select-change" },
						{ view: "textarea", name: "cell_editstop", label: "CELL EDITSTOP", height: 150, id: "dmtab-cell-editstop" },
						{ view: "textarea", name: "after_addrow", label: "AFTER ADDROW", height: 150, id: "dmtab-afteraddrow" },
						{ view: "textarea", name: "after_delrow", label: "AFTER DELROW", height: 150, id: "dmtab-afterdelrow" },
						// AITS
						// { view: "textarea", name: "on_itemclick", label: "ITEM CLICK", height: 150, id: "dmtab-onitemclick" },
						{ view: "textarea", name: "oncheck", label: "ON CHECK", height: 150, id: "dmtab-oncheck" },
						{ view: "text", name: "prefix", label: "PREFIX", id: "dmtab-prefix" },
						{ view: "text", name: "order_by", label: "ORDER BY", id: "dmtab-orderby" },
						{
							margin: 10,
							cols: [
								{},
								{
									shortcut: "F10", view: "button", label: "Nhận (F10)", type: "form", align: "center", width: 140,
									on: {
										onClick: function () {
											var form = webix.$$("dmtab-form");
											var item = form.getValues();

											var url = app.config.host + "/WbTab/Update";

											webix.ajax()
												.headers({ 'Content-type': 'application/json' })
												.post(url, item, function (text) {
													var data = JSON.parse(text);

													if (!data.hasOwnProperty("error")) {
														item.id = data.id;
														webix.$$("dmtab-win").close();
														app.callEvent("dataChanged", [editmode, item]);
													}
													else {
														webix.message(data.error);
													}
												});
										}
									},
									click: function () {
										this.callEvent("onClick");
									}
								},
								{
									view: "button", hotkey: "esc", label: "Hủy bỏ (ESC)", type: "danger", align: "center", width: 140,
									click: function () {
										webix.$$("dmtab-win").close();
									}
								}
							]
						}

					]
				}

			}

		},
		setEditMode: function (mode) {
			editmode = mode;
		}
	};

});
define('views/dmtab',[
    "app",
    "views/forms/dmtab",
    "locale"
], function (app, dmtabform, _) {
    'use strict';

    //var windowno = app.path[1].params[0];    
    webix.$$("title").parse({ title: "Điều khiển > Danh mục Tab", details: "Danh mục Tab system" });
    var controls = [
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-plus fa-lg" aria-hidden="true"></i> ' +
            '<span class="text">' + "Thêm (F4)" + '</span>',
            id: "btnPlus",
            // view: "button",
            // type: "icon",
            // icon: "fas fa-plus",
            // label: "Thêm (F4)",
            // css: "webix_secondary",
            // width: 95,
            shortcut: "F4",
            on: {
                onClick: function () {
                    var win = this.$scope.ui(dmtabform.$ui);
                    var form = webix.$$("dmtab-form");

                    if (webix.$$("txtWindowId").getValue() == "") {
                        webix.message("Bạn chưa chọn Window Id")
                        return;
                    }

                    var item = {
                        wb_window_id: $$("txtWindowId").getValue()
                    };

                    form.setValues(item);

                    dmtabform.setEditMode(1);
                    win.show();
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-edit fa-lg" aria-hidden="true"></i> ' +
            '<span class="text">' + "Sửa (F3)" + '</span>',
            id: "btnEdit",
            // view: "button",
            // type: "icon",
            // icon: "fas fa-edit",
            // label: "Sửa (F3)",
            // width: 85,
            // css: "webix_secondary",
            shortcut: "F3",
            on: {
                onClick: function () {
                    var detailForm = this.$scope.ui(dmtabform.$ui);
                    var form = webix.$$("dmtab-form");

                    var table = webix.$$("dmtabData");
                    var item = table.getSelectedItem();

                    form.setValues(item);

                    dmtabform.setEditMode(2);
                    detailForm.show();
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-trash-o fa-lg" aria-hidden="true"></i> ' +
            '<span class="text">' + "Xóa (F8)" + '</span>',
            id: "btnDelete",
            // view: "button",
            // type: "icon",
            // icon: "fas fa-trash-o",
            // label: "Xóa (F8)",
            // css: "webix_secondary",
            // width: 85,
            shortcut: "F8",
            on: {
                onClick: function () {
                    var table = webix.$$("dmtabData");
                    var item = table.getSelectedItem();

                    webix.confirm({
                        text: "Bạn có muốn xóa " + item.tab_name, ok: "Có", cancel: "Không",
                        callback: function (res) {
                            if (res) {
                                webix.ajax().post(app.config.host + "/WbTab/Delete", item, function (text, xml, xhr) {
                                    if (text.hasOwnProperty("error")) {
                                        webix.message(text.error);
                                        return;
                                    }

                                    table.remove(item.id);

                                });

                            }
                        }
                    });
                }
            },
            click: function () {
                this.callEvent("onClick");
            }

        },
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-files-o fa-lg" aria-hidden="true"></i> ' +
            '<span class="text">' + "Sao chép" + '</span>',
            id: "btnCopy",
            // view: "button",
            // type: "icon",
            // icon: "fas fa-files-o",
            // label: "Sao chép",
            // css: "webix_secondary",
            // width: 85,
            on: {
                onClick: function () {
                    var detailForm = this.$scope.ui(dmtabform.$ui);
                    var form = webix.$$("dmtab-form");

                    var table = webix.$$("dmtabData");
                    var item = table.getSelectedItem();

                    if (item == null) {
                        webix.message({ type: "error", text: "Bạn chưa chọn mục tab" });
                        return;
                    }

                    item.id = null;
                    form.setValues(item);

                    dmtabform.setEditMode(1);
                    detailForm.show();
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {},
        {
            view: "combo",
            width: 450,
            label: "Window ID",
            id: "txtWindowId",
            options: {
                view: "gridsuggest",
                id: "grid_window",
                template: "#window_name#",
                width: 550,
                body: {
                    scroll: true,
                    autoheight: false,
                    columns: [
                        { id: "window_id", header: "Window Id", editor: "text", width: 100 },
                        { id: "window_name", header: "Window Name", editor: "text", width: 400 }
                    ],
                    url: app.config.host + "/WbWindow/All"
                }
            },
            // suggest: {
            // 	url: app.config.host + "/WbWindow/All",
            // 	template: "#window_name#",
            // 	body: {
            // 		template: "#window_name#"
            // 	}
            // },
            on: {
                onChange: function () {
                    loadData();
                }
            }
        }
    ];

    var grid = {
        rows: [
            {
                id: "dmtabData",
                view: "datatable",
                select: true,
                resizeColumn: true,
                datafetch: 2,
                loadahead: 15,
                on: {
                    onItemDblClick: function (id, e, node) {
                        var btnEdit = $$("btnEdit");
                        btnEdit.callEvent("onClick");
                    }
                },
                columns: [
                    { id: "stt", header: "STT", width: 80 },
                    { id: "tab_id", header: "Tab Id", width: 80 },
                    { id: "window_id", header: "Window Id", hidden: true },
                    { id: "tab_name", header: "Tab Name", width: 250 },
                    { id: "tab_table", header: "Tab Table", width: 150 },
                    { id: "tab_type", header: "Tab Type", width: 100 },
                    { id: "tab_view", header: "Tab View", width: 100 },
                    { id: "foreign_key", header: "FOREIGN KEY", width: 150 },
                    { id: "insert_cmd", header: "INSERT CMD", width: 150 },
                    { id: "update_cmd", header: "UPDATE CMD", width: 150 },
                    { id: "delete_cmd", header: "DELETE CMD", width: 150 },
                    { id: "select_cmd", header: "SELECT CMD", width: 150 }
                ],
                //columns: columns
                pager: "pagerA"

            },
            {
                cols: [
                    {
                        view: "icon", icon: "fas fa-question-circle", id: "help_form_views", tooltip: _("HELPER"),
                        css: "helper",
                        // click: function () {
                        //     this.callEvent("onClick");
                        // }
                        click: function () {
                            webix.alert({
                                title: "Thông báo !",
                                text: "Bạn chưa khai báo hướng dẫn nhanh cho màn hình này !",
                                type: "alert-warning",
                                callback: function (result) {
                                }
                            });
                        }
                    },
                    {
                        view: "combo",
                        label: _("MENU_QUICK"),
                        id: "QuickMenu1",
                        options: {
                            // view: "gridsuggest",
                            // id: "grid_window",
                            // template: "#name#",
                            // body: {
                            //     scroll: true,
                            //     autoheight: false,
                            //     columns: [
                            //         { id: "window_id", header: "Window Id", editor: "text", width: 100 },
                            //         { id: "name", header: "Window Name", editor: "text", width: 400 }
                            //     ],
                            //     url: app.config.host + "/System/GetQuickMenu"
                            // },
                            // on: {
                            //     onValueSuggest: function (obj) {
                            //         var start = obj.window_id != "" ? obj.code + ":" + obj.window_id : obj.code;
                            //         window.location.hash = "!/app/" + start;
                            //         $$("QuickMenu1").setValue(null);
                            //         $$("QuickMenu1").destructor();
                            //     }
                            // }
                        },
                        on: {
                            onChange: function (newv, oldv) {

                            }
                        }
                    },
                    {},
                    {
                        id: "pagerA",
                        view: "pager",
                        size: 50,
                        group: 5,
                        // animate: { direction:"top" },
                        template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}"
                    }
                ]
            }
        ]
    }

    var layout = {
         css: "frmView",
        rows: [
            {
                height: 39,
                css: "btnControl",
                type: "toolbar",
                margin: 0,
                borderless: true,
                cols: controls
            },
            {
                rows: [
                    grid
                ]
            }



        ]

    };

    function loadData() {
        var windowId = webix.$$("txtWindowId").getValue();
        var url = app.config.host + "/WbTab/GetTabsByWindowId?id=" + windowId;

        webix.ajax().get(url, function (text) {
            var json = JSON.parse(text);

            var table = webix.$$("dmtabData");
            table.clearAll();
            table.parse(json);

        });
    }

    return {
        $ui: layout,
        $oninit: function (view, $scope) {
            $scope.on(app, "dataChanged", function (mode, item) {

                var table = webix.$$("dmtabData");

                if (mode == 1) {
                    table.add(item);
                    //table.select(item.iddmtab,false);
                }

                if (mode == 2) {
                    var selectedItem = table.getSelectedItem();
                    table.updateItem(selectedItem.id, item);
                }

            });
        }
    };
});
define('views/forms/dmwindow',["app"], function (app) {
	var editmode = 0;

	return {
		$ui: {
			view: "window", modal: true, id: "dmwindow-win", position: "center",
			head: "Thông tin Window",
			fullscreen: true,
			body: {
				view: "scrollview",
				scroll: "native-y",
				body: {
					paddingY: 10,
					paddingX: 10,
					elementsConfig: { labelWidth: 120 },
					view: "form",
					id: "dmwindow-form",
					complexData: true,
					margin: 0,
					elements: [
						{ view: "text", name: "window_id", label: "WINDOW ID", id: "dmwindow-id" },
						{ view: "text", name: "window_name", label: "Tittle", id: "dmwindow-name" },
						{
							view: "combo",
							name: "window_type",
							label: 'Window Type',
							value: "Grid",
							options: ["Grid", "Detail", "MasterDetail", "Report"],
							id: "dmwindow-type"
						},
						{
							cols: [
								{ view: "text", name: "width", label: "Width", id: "dmwindow-width" },
								{ view: "text", name: "height", label: "Height", id: "dmwindow-height" },
							]
						},
						{
							cols: [
								{ view: "text", name: "fix_left", label: "fix_left", id: "dmwindow-fix_left", tooltip: "Số dòng cố định bên trái" },
								{ view: "text", name: "fix_right", label: "fix_right", id: "dmwindow-fix_right", tooltip: "Số dòng cố định bên phải" },
							]
						},
						{ view: "text", name: "rows_max", label: "Rows max", id: "dmwindow-rowsmax", tooltip: "Số dòng lớn nhất của form" },
						{ view: "text", name: "row_tab", label: "Row tab", id: "dmwindow-rowtab", tooltip: "Dòng bắt đầu của form chi tiết nếu có" },
						{ view: "text", name: "ma_ct", label: "MA_CT", id: "dmwindow-mact" },
						{ view: "text", name: "sql_code", label: "SQL_CODE", id: "dmwindow-sqlcode" },
						{
							view: "combo",
							name: "wb_infowindow_id",
							label: "INFO WINDOW",
							id: "dmwindow-vcinfowindowid",
							options: app.config.host + "/System/GetDataReferencesByRefId?refId=RF00028"
						},
						{ view: "textarea", height: 160, name: "after_new", label: "AFTER_NEW", tooltip: "Trước khi UI forms được tạo" },
						{ view: "textarea", height: 160, name: "before_save", label: "BEFORE_SAVE", tooltip: "Trước khi lưu dữ kiệu {TO DO CODE}" },
						{ view: "textarea", height: 160, name: "after_save", label: "AFTER_SAVE" },
						{ view: "textarea", height: 160, name: "layoutdetail", label: "Layout Detail", tooltip: "Nếu triển khai UI ở đây thì không Auto UI" },
						{ view: "textarea", height: 160, name: "after_edit", label: "AFTER_EDIT" },
						{ view: "textarea", height: 160, name: "after_delete", label: "AFTER_DELETE", tooltip: "Trước khi xóa dữ liệu {TO DO CODE}" },
						{ view: "textarea", height: 160, name: "hint", label: "HINT", tooltip: "Tạo hướng dẫn trên form {TO DO CODE}" },
						{ view: "textarea", height: 160, name: "hint_base", label: "HINT_BASE", tooltip: "Tạo hướng dẫn {TO DO CODE}" },
						{
							margin: 10,
							cols: [
								{},
								{
									shortcut: "F10", view: "button", label: "Nhận (F10)", type: "form", align: "center", width: 140,
									on: {
										onClick: function () {
											var form = webix.$$("dmwindow-form");
											var item = form.getValues();

											webix.ajax()
												.headers({ 'Content-type': 'application/json' })
												.post(app.config.host + "/WbWindow/Update", item, function (text) {
													var data = JSON.parse(text);
													//console.log(data);
													if (!data.hasOwnProperty("error")) {
														item.id = data.id;
														webix.$$("dmwindow-win").close();
														app.callEvent("dataChanged", [editmode, item]);
													}
													else {
														webix.message(data.error);
													}
												});
										}
									},
									click: function () {
										this.callEvent("onClick");
									}
								},
								{
									view: "button", hotkey: "esc", label: "Hủy bỏ (ESC)", type: "danger", align: "center", width: 140,
									click: function () {
										webix.$$("dmwindow-win").close();
									}
								}
							]
						}

					]
				}

			}

		},
		setEditMode: function (mode) {
			editmode = mode;
		}
	};

});
define('views/dmwindow',[
    "app",
    "views/forms/dmwindow",
    "locale"
], function (app, dmwindowform, _) {
    'use strict';

    var op = [];
    webix.$$("title").parse({ title: "Điều khiển > Danh mục window", details: "Danh mục window system" });
    var controls = [
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-plus fa-lg" aria-hidden="true"></i> ' +
            '<span class="text">' + _("THEM") + " (F4)" + '</span>',
            id: "btnPlus",
            // view: "button",
            // type: "icon",
            // icon: "fas fa-plus",
            // label: _("THEM") + " (F4)",
            // width: 95,
            // css: "webix_secondary",
            shortcut: "F4",
            on: {
                onClick: function () {
                    var win = this.$scope.ui(dmwindowform.$ui);
                    dmwindowform.setEditMode(1);
                    win.show();
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-edit fa-lg" aria-hidden="true"></i> ' +
            '<span class="text">' + _("SUA") + " (F3)" + '</span>',
            id: "btnEdit",
            // view: "button",
            // type: "icon",
            // icon: "fas fa-edit",
            // label: _("SUA") + " (F3)",
            // width: 85,
            // css: "webix_secondary",
            shortcut: "F3",
            on: {
                onClick: function () {
                    var detailForm = this.$scope.ui(dmwindowform.$ui);
                    var form = webix.$$("dmwindow-form");

                    var table = webix.$$("dmwindowData");
                    var item = table.getSelectedItem();
                    //console.log(item);
                    form.setValues(item);

                    dmwindowform.setEditMode(2);
                    detailForm.show();
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-trash-o fa-lg" aria-hidden="true"></i> ' +
            '<span class="text">' + _("XOA") + " (F8)" + '</span>',
            id: "btnDelete",
            // view: "button",
            // type: "icon",
            // icon: "fas fa-trash-o",
            // label: _("XOA") + " (F8)",
            // width: 85,
            // css: "webix_secondary",
            shortcut: "F8",
            on: {
                onClick: function () {

                    var table = webix.$$("dmwindowData");
                    var item = table.getSelectedItem();

                    webix.confirm({
                        text: "Bạn có muốn xóa " + item.window_name, ok: "Có", cancel: "Không",
                        callback: function (res) {
                            if (res) {
                                webix.ajax()
                                    .headers({ 'Content-type': 'application/json' })
                                    .post(app.config.host + "/WbWindow/Delete", item, function (text, xml, xhr) {
                                        if (text.hasOwnProperty("error")) {
                                            webix.message(text.error);
                                            return;
                                        }

                                        table.remove(item.id);

                                    });

                            }
                        }
                    });
                }
            },
            click: function () {
                this.callEvent("onClick");
            }

        },
        {
            view: "button", type: "htmlbutton", width: 120,
            label: '<i class="fa fa-files-o fa-lg" aria-hidden="true"></i> ' +
            '<span class="text">' + _("COPY") + " (F7)" + '</span>',
            id: "btnCopy",
            // view: "button",
            // type: "icon",
            // icon: "fas fa-files-o",
            // label: _("COPY"),
            // width: 85,
            // css: "webix_secondary",
            shortcut: "F7",
            on: {
                onClick: function () {

                    var table = webix.$$("dmwindowData");
                    var item = table.getSelectedItem();

                    if (item == null) {
                        webix.message("Bạn chưa chọn dữ liệu");
                        return;
                    }

                    webix.confirm({
                        text: "Bạn có muốn sao chép: " + item.window_name, ok: "Có", cancel: "Không",
                        callback: function (res) {
                            if (res) {
                                // var query = "EXECUTE sproc_copy_vcwindow'" + item.id + "',null";

                                // var url = app.config.host + "/api/System/ExecuteQuery?sql=" + query;
                                var url = app.config.host + "/System/ExeCmd";
                                var dataPost = {
                                    cmd: "CM00099",
                                    param: {
                                        WINDOW_ID: windowno
                                    }
                                };
                                webix.ajax(url, function (text) {
                                    var json = JSON.parse(text);

                                    if (json.length > 0) {
                                        webix.message(json[0]["ERROR"]);
                                    }
                                    else {
                                        table.clearAll();
                                        table.load(table.config.url);
                                    }
                                });

                            }
                        }
                    });
                }
            },
            click: function () {
                this.callEvent("onClick");
            }

        },
        {}

    ];

    var grid = {
        rows: [
            {
                id: "dmwindowData",
                view: "datatable",
                select: true,
                datafetch: 100,
                resizeColumn: true,
                //loadahead: 15,
                url: {
                    $proxy: true,
                    load: function (view, callback, params) {
                        var url = app.config.host + "/WbWindow/GetWindows";

                        if (params == null) {
                            url = url + "?start=0&count=" + view.config.datafetch + "&continue=null&filter=null";
                        }
                        else {
                            url = url + "?start=" + params.start + "&count=" + params.count + "&continue=" + params.continue;

                            if (params.filter != null) {
                                var array = [];

                                for (var property in params.filter) {

                                    var column = view.getColumnConfig(property);

                                    var item = {
                                        columnName: property,
                                        columnType: column.columnType,
                                        value: params.filter[property]
                                    };

                                    array.push(item);
                                }

                                //console.log(JSON.stringify(array));
                                url = url + "&filter=" + JSON.stringify(array);
                            }
                        }

                        webix.ajax(url, callback, view);

                    }
                },
                on: {
                    onItemDblClick: function (id, e, node) {
                        var btnEdit = $$("btnEdit");
                        btnEdit.callEvent("onClick");
                    }
                },
                columns: [
                    { id: "window_id", header: ["No", { content: "textFilter" }], width: 100 },
                    { id: "window_name", header: ["Title", { content: "textFilter" }], width: 400 },
                    { id: "window_type", header: "Window Type", fillspace: true },
                    { id: "width", header: "Width", fillspace: true },
                    { id: "height", header: "Height", fillspace: true },
                    { id: "rows_max", columnType: "VC_TIEN", header: ["Rows max", { content: "textFilter" }], fillspace: true },
                    { id: "row_tab", header: "Row tab", fillspace: true },
                    { id: "ma_ct", header: "MA_CT", fillspace: true },
                    { id: "sql_code", header: "SQL_CODE", fillspace: true }
                ],
                pager: "pagerA"

            },
            {
                cols: [
                    {
                        view: "icon", icon: "fas fa-question-circle", id: "help_form_views", tooltip: _("HELPER"),
                        css: "helper",
                        // click: function () {
                        //     this.callEvent("onClick");
                        // }
                        click: function () {
                            webix.alert({
                                title: "Thông báo !",
                                text: "Bạn chưa khai báo hướng dẫn nhanh cho màn hình này !",
                                type: "alert-warning",
                                callback: function (result) {
                                }
                            });
                        }
                    },
                    {
                        view: "combo",
                        label: _("MENU_QUICK"),
                        id: "QuickMenu1",
                        options: {
                            // view: "gridsuggest",
                            // id: "grid_window",
                            // template: "#name#",
                            // body: {
                            //     scroll: true,
                            //     autoheight: false,
                            //     columns: [
                            //         { id: "window_id", header: "Window Id", editor: "text", width: 100 },
                            //         { id: "name", header: "Window Name", editor: "text", width: 400 }
                            //     ],
                            //     url: app.config.host + "/System/GetQuickMenu"
                            // },
                            // on: {
                            //     onValueSuggest: function (obj) {
                            //         var start = obj.window_id != "" ? obj.code + ":" + obj.window_id : obj.code;
                            //         window.location.hash = "!/app/" + start;
                            //         $$("QuickMenu1").setValue(null);
                            //         $$("QuickMenu1").destructor();
                            //     }
                            // }
                        },
                        on: {
                            onChange: function (newv, oldv) {

                            }
                        }
                    },
                    {},
                    {
                        id: "pagerA",
                        view: "pager",
                        size: 50,
                        group: 5,
                        // animate: { direction:"top" },
                        template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}"
                    }
                ]
            }
        ]
    }

    var layout = {
        css: "frmView",
        rows: [
            {
                height: 39,
                css: "btnControl",
                type: "toolbar",
                margin: 0,
                borderless: true,
                cols: controls
            },
            {
                rows: [
                    grid
                ]
            }



        ]

    };

    function loadData() {
        var schoolyearcode = webix.$$("dmwindow").getValue();

        var url = app.config.host + "/api/System/GetWindowById?ID=" + schoolyearcode;

        webix.ajax().get(url, function (text) {
            var data = JSON.parse(text);

            var table = webix.$$("dmwindowData");
            table.clearAll();
            table.parse(data);

        });
    }

    return {
        $ui: layout,
        $oninit: function (view, $scope) {
            $scope.on(app, "dataChanged", function (mode, item) {

                var table = webix.$$("dmwindowData");

                if (mode == 1) {
                    table.add(item);
                    //table.select(item.iddmwindow,false);
                }

                if (mode == 2) {
                    var selectedItem = table.getSelectedItem();
                    table.updateItem(selectedItem.id, item);
                }

            });
        }
    };
});
define('views/forms/signEasyCAMulti',["app"], function (app) {
    var editmode = 0;
    var item;
    var cerSerial;
    function initUI(obj, cert) {
        item = obj;
        cerSerial = cert;
    }
    return {
        $ui: {
            view: "window",
            modal: true,
            id: "signEasyCA",
            css: "signEasyCA",
            position: "center",
            move: true,
            head: false,
            minWidth: 350,
            // height: 100,
            body: {
                view: "form",
                id: "signEasyCA-frm",
                elementsConfig: {
                    labelWidth: 60
                },
                elements: [
                    {
                        view: "text", type: "password", name: "pin_Code", id: "pinCode", label: "Mã pin", required: true,
                        invalidMessage: "Bạn phải nhập mã pin"
                    },
                    // {
                    //     view: "text", name: "username", id: "username", label: "Username", required: true,
                    //     invalidMessage: "Bạn phải nhập Username"
                    // },
                    // {
                    //     view: "text", type: "password", name: "password", id: "password", label: "Password", required: true,
                    //     invalidMessage: "Bạn phải nhập Password"
                    // },
                    {
                        cols: [
                            {},
                            {
                                shortcut: "F10", view: "button", label: "Nhận (F10)", type: "form", align: "center", width: 80,
                                on: {
                                    onClick: function () {
                                        if ($$("signEasyCA-frm").validate()) {
                                            var form = $$("signEasyCA");
                                            var promises = "[";

                                            for (var i = 0; i < item.length; i++) {
                                                var k = {};
                                                k.id = item[i];
                                                k.so_serial = cerSerial;
                                                k.pin = $$("pinCode").getValue();
                                                // k.username = $$("username").getValue();
                                                // k.password = $$("password").getValue();
                                                promises = promises + JSON.stringify(k) + ",";
                                            }

                                            promises = promises.substring(0, promises.length - 1) + "]";
                                            var param = JSON.parse(promises);

                                            // var param = {
                                            //     agreementUUID: item.agreementUUID,
                                            //     pinCode: $$("pinCode").getValue(),
                                            //     id: item.inv_InvoiceAuth_id
                                            // }

                                            webix.extend(form, webix.ProgressBar);
                                            form.disable();
                                            form.showProgress();
                                            var url = app.config.host + "/Token/SignEasyCAMulti";

                                            webix.ajax()
                                                .headers({ 'Content-type': 'application/json' })
                                                .post(url, JSON.stringify(param), {
                                                    error: function (text, data, XmlHttpRequest) {
                                                        form.enable();
                                                        form.hideProgress();
                                                        webix.message(text);
                                                    },
                                                    success: function (text, data, XmlHttpRequest) {
                                                        var obj = JSON.parse(text);
                                                        if (!obj.hasOwnProperty("error")) {
                                                            // if (obj.trang_thai == "Đã ký") {

                                                            //     var table = webix.$$("windowData");
                                                            //     var item = table.getSelectedItem();

                                                            //     item.trang_thai = "Đã ký";
                                                            //     item.inv_invoiceNumber = obj.inv_invoiceNumber;
                                                            //     table.updateItem(item.id, item);

                                                            //     webix.ajax()
                                                            //         .headers({ 'Content-type': 'application/json' })
                                                            //         .post(app.config.host + "/System/ExecuteCommand",
                                                            //         {
                                                            //             command: "CM00025",
                                                            //             parameter: {
                                                            //             }
                                                            //         }
                                                            //         , function (text) {
                                                            //             var json = JSON.parse(text);
                                                            //             // auto send SMS 
                                                            //             if (json[1].gia_tri == "C") {
                                                            //                 var data = { id: item.inv_InvoiceAuth_id };

                                                            //                 webix.ajax()
                                                            //                     .headers({ 'Content-type': 'application/json' })
                                                            //                     .post(app.config.host + "/Sms/NotifyInvoice", data, function (text) {
                                                            //                         var data = JSON.parse(text);

                                                            //                         if (!data.hasOwnProperty("error")) {
                                                            //                         }
                                                            //                         else {
                                                            //                             webix.message(data.error, "error");
                                                            //                         }
                                                            //                     });
                                                            //             }
                                                            //             // send email ma = 'AUTO_SEND_EMAIL'
                                                            //             if (json[0].gia_tri == "C") {
                                                            //                 var data = { inv_InvoiceAuth_id: item.inv_InvoiceAuth_id, nguoinhan: item.inv_buyerEmail, tieude: "Thông báo xuất hóa đơn điện tử" };

                                                            //                 webix.ajax()
                                                            //                     .headers({ 'Content-type': 'application/json' })
                                                            //                     .post(app.config.host + "/Invoice/AutoEmail", data, function (text) {
                                                            //                         var data = JSON.parse(text);

                                                            //                         if (!data.hasOwnProperty("error")) {

                                                            //                         }
                                                            //                         else {
                                                            //                             webix.message(data.error, "error");
                                                            //                         }
                                                            //                     });
                                                            //             }
                                                            //         });

                                                            // }
                                                            form.enable();
                                                            form.hideProgress();
                                                            $$("btnCancel").callEvent("onClick");
                                                            webix.message("Ký hóa đơn thành công !", "success");
                                                        }
                                                        else {
                                                            form.enable();
                                                            form.hideProgress();
                                                            webix.message(obj.error, "error");
                                                        }

                                                    }
                                                });
                                        }
                                    }
                                },
                                click: function () {
                                    this.callEvent("onClick");

                                }
                            },
                            {
                                view: "button", id: "btnCancel", shortcut: "esc", label: "Hủy (ESC)", type: "danger", align: "center",
                                width: 80,
                                on: {
                                    onClick: function () {
                                        $$("signEasyCA").close();
                                    }
                                },
                                click: function () {
                                    this.callEvent("onClick");
                                }
                            },
                            {}
                        ]
                    }
                ]
            }
        },
        setEditMode: function (mode) {
            editmode = mode;
        },
        initUI: initUI
    };

});
define('views/duyethoadon',[
    "app",
    "views/forms/dmwindow",
    "locale",
    "views/modules/minvoiceplugin",
    "views/forms/signCloudMulti",
    "views/forms/signEasyCAMulti"
], function (app, dmwindowform, _, plugin, signCloudMulti, signEasyCAMulti) {
    'use strict';

    function signOnServerFile(data, cert, server_cert) {

        var parameters = {
            xml: data["InvoiceXmlData"],
            refUri: "#data",
            certSerial: cert.so_serial,
            tokenSerial: cert.tokenSerial,
            signId: "seller",
            signTag: "Signatures",
            pass: cert.pass,
            path: cert.path,
            inv_InvoiceAuth_id: data["inv_InvoiceAuth_id"]
        };

        webix.ajax()
            .headers({ "Content-Type": "application/json" })
            .post(server_cert + "/Token/SignXmlByFile", parameters, function (text) {
                var json = JSON.parse(text);

                if (json.hasOwnProperty("error")) {
                    webix.message(json["error"], "error");
                }
                else {
                    var parameters = {
                        InvoiceXmlData: json.xml,
                        inv_InvoiceAuth_id: json.inv_InvoiceAuth_id
                    };
                    //console.log(parameters);

                    webix.ajax()
                        .headers({ "Content-Type": "application/json" })
                        .post(app.config.host + "/Invoice/SaveXml", parameters, function (text) {
                            var result = JSON.parse(text);

                            if (result.trang_thai == "Đã ký") {

                                var table = webix.$$("dmwindowData");
                                table.clearAll();
                                table.load(table.config.url);

                                webix.ajax()
                                    .headers({ 'Content-type': 'application/json' })
                                    .post(app.config.host + "/System/ExecuteCommand",
                                    {
                                        command: "CM00025",
                                        parameter: {

                                        }
                                    }, function (text) {
                                        var json = JSON.parse(text);
                                        // auto send SMS 
                                        if (json[1].gia_tri == "C") {
                                            var data = { id: item.inv_InvoiceAuth_id };

                                            webix.ajax()
                                                .headers({ 'Content-type': 'application/json' })
                                                .post(app.config.host + "/Sms/NotifyInvoice", data, function (text) {
                                                    var data = JSON.parse(text);

                                                    if (!data.hasOwnProperty("error")) {


                                                    }
                                                    else {
                                                        webix.message(data.error, "error");
                                                    }
                                                });
                                        }
                                        // send email ma = 'AUTO_SEND_EMAIL'
                                        // if (json[0].gia_tri == "C") {
                                        //     var data = { inv_InvoiceAuth_id: item.inv_InvoiceAuth_id, nguoinhan: item.inv_buyerEmail, tieude: "Thông báo xuất hóa đơn điện tử" };

                                        //     webix.ajax()
                                        //         .headers({ 'Content-type': 'application/json' })
                                        //         .post(app.config.host + "/Invoice/AutoEmail", data, function (text) {
                                        //             var data = JSON.parse(text);

                                        //             if (!data.hasOwnProperty("error")) {


                                        //             }
                                        //             else {
                                        //                 webix.message(data.error, "error");
                                        //             }
                                        //         });
                                        // }


                                    });
                                // webix.modalbox.hide();
                                // webix.message("Ký hóa đơn thành công !", "debug");
                            }

                        });
                }
            });
    }

    function signOnServer(data, cert, server_cert) {

        var parameters = {
            xml: data["InvoiceXmlData"],
            refUri: "#data",
            certSerial: cert.so_serial,
            tokenSerial: cert.tokenSerial,
            signId: "seller",
            signTag: "Signatures",
            pass: cert.pass,
            inv_InvoiceAuth_id: data["inv_InvoiceAuth_id"]
        };

        webix.ajax()
            .headers({ "Content-Type": "application/json" })
            .post(server_cert + "/Token/SignXml", parameters, function (text) {
                var json = JSON.parse(text);

                if (json.hasOwnProperty("error")) {
                    webix.message(json["error"]);
                }
                else {
                    var parameters = {
                        InvoiceXmlData: json.xml,
                        inv_InvoiceAuth_id: json.inv_InvoiceAuth_id
                    };
                    //console.log(parameters);

                    webix.ajax()
                        .headers({ "Content-Type": "application/json" })
                        .post(app.config.host + "/Invoice/SaveXml", parameters, function (text) {
                            var result = JSON.parse(text);

                            if (result.trang_thai == "Đã ký") {

                                var table = webix.$$("dmwindowData");
                                table.clearAll();
                                table.load(table.config.url);

                                webix.ajax()
                                    .headers({ 'Content-type': 'application/json' })
                                    .post(app.config.host + "/System/ExecuteCommand",
                                    {
                                        command: "CM00025",
                                        parameter: {

                                        }
                                    }, function (text) {
                                        var json = JSON.parse(text);
                                        // auto send SMS 
                                        if (json[1].gia_tri == "C") {
                                            var data = { id: item.inv_InvoiceAuth_id };

                                            webix.ajax()
                                                .headers({ 'Content-type': 'application/json' })
                                                .post(app.config.host + "/Sms/NotifyInvoice", data, function (text) {
                                                    var data = JSON.parse(text);

                                                    if (!data.hasOwnProperty("error")) {

                                                    }
                                                    else {
                                                        webix.message(data.error, "error");
                                                    }
                                                });
                                        }
                                        // send email ma = 'AUTO_SEND_EMAIL'
                                        // if(json[0].gia_tri == "C")
                                        // {
                                        // 	var data = { inv_InvoiceAuth_id: item.inv_InvoiceAuth_id, nguoinhan: item.inv_buyerEmail, tieude: "Thông báo xuất hóa đơn điện tử" };

                                        // 	webix.ajax()
                                        // 		.headers({ 'Content-type': 'application/json' })
                                        // 		.post(app.config.host + "/Invoice/AutoEmail", data, function (text) {
                                        // 			var data = JSON.parse(text);

                                        // 			if (!data.hasOwnProperty("error")) {


                                        // 			}
                                        // 			else {
                                        // 				webix.message(data.error, "error");
                                        // 			}
                                        // 		});
                                        // }
                                    });

                                // webix.modalbox.hide();
                                // webix.message("Ký hóa đơn thành công !", "debug");
                            }
                        });
                }
            });
    }

    var op = [];

    //webix.$$("title").parse({ title: "Duyệt hóa đơn", details: "Danh sách hóa đơn chờ duyệt", url_help: "http://huongdansudung.minvoice.com.vn/" });

    var controls = [
        {
            view: "button", type: "htmlbutton", width: 150,
            label: '<i class="fas fa-edit fa-lg" aria-hidden="true"></i> ' +
            '<span class="text">' + _("DUYET") + " (F10)" + '</span>',
            id: "btnEdit",
            //css:"button_raised",
            shortcut: "F10",
            on: {
                onClick: function () {
                    var type = "01";

                    if (app.path.length > 0) {

                        if (typeof app.path[1].params[0] == 'undefined') {
                            type = "01";
                        }
                        else {
                            type = app.path[1].params[0];
                        }
                    };

                    if (type == "01") {
                        webix.confirm({
                            text: "Bạn có muốn duyệt hóa đơn không?", ok: "Có", cancel: "Không",
                            callback: function (res) {
                                if (res) {
                                    DuyetHoaDon();
                                }
                            }
                        });
                    }
                    else if (type == "02") {
                        webix.confirm({
                            text: "Bạn có muốn ký hóa đơn không?", ok: "Có", cancel: "Không",
                            callback: function (res) {
                                if (res) {
                                    KyHoaDon();
                                }
                            }
                        });
                    }
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {}
    ];

    var grid = {
        rows: [
            {
                id: "dmwindowData",
                view: "datatable",
                subview: {
                    borderless: true,
                    view: "tabview",
                    height: 285,
                    scrollX: true,
                    css: "subInvoice",
                    cells: [
                        {
                            header: "Chi tiết hóa đơn",
                            select: "cell",
                            body: {
                                view: "datatable",
                                margin: 10,
                                height: 220,
                                id: "tblInvoiceDetail",
                                columns: [
                                    { id: "inv_itemCode", header: "Mã hàng", sort: "string", width: 150 },
                                    { id: "inv_itemName", header: "Tên hàng", sort: "string", fillspace: true },
                                    { id: "inv_unitPrice", header: "Đơn giá" },
                                    {
                                        id: "inv_quantity", header: "Số lượng", format: webix.Number.numToStr({
                                            groupDelimiter: ",",
                                            groupSize: 3,
                                            decimalDelimiter: ".",
                                            decimalSize: 0
                                        })
                                    },
                                    {
                                        id: "inv_TotalAmountWithoutVat", header: "Tiền trước thuế", format: webix.Number.numToStr({
                                            groupDelimiter: ",",
                                            groupSize: 3,
                                            decimalDelimiter: ".",
                                            decimalSize: 0
                                        })
                                    },
                                    {
                                        id: "inv_vatPercentage", header: "% thuế", format: webix.Number.numToStr({
                                            groupDelimiter: ",",
                                            groupSize: 3,
                                            decimalDelimiter: ".",
                                            decimalSize: 0
                                        })
                                    },
                                    {
                                        id: "inv_vatAmount", header: "Tiền thuế", format: webix.Number.numToStr({
                                            groupDelimiter: ",",
                                            groupSize: 3,
                                            decimalDelimiter: ".",
                                            decimalSize: 0
                                        })
                                    },
                                    {
                                        id: "inv_TotalAmount", header: "Tổng tiền", format: webix.Number.numToStr({
                                            groupDelimiter: ",",
                                            groupSize: 3,
                                            decimalDelimiter: ".",
                                            decimalSize: 0
                                        })
                                    }
                                ]
                            }
                        }

                    ],
                    // tabbar: {
                    //     close: true
                    // },
                    multiview: {
                        fitBiggest: true
                    }
                },
                select: true,
                resizeColumn: true,
                datafetch: 100,
                url: app.config.host + "/Invoice/GetHoaDonChoDuyet",
                columns: [
                    {
                        id: "chon",
                        header: [{ text: "", content: "masterCheckbox" }],
                        width: 45,
                        checkValue: true,
                        uncheckValue: false,
                        template: "{common.checkbox()}"
                    },
                    {
                        id: "subRow",
                        header: "&nbsp;",
                        template: "{common.subrow()}",
                        width: 40,
                        height: 25
                    },
                    { id: "user_new", header: [_("USER_NEW"), { content: "textFilter" }], width: 150 },
                    {
                        id: "inv_invoiceIssuedDate",
                        header: [_("NGAY_HDON"), { content: "multiComboFilter" }],
                        width: 130,
                        format: function (text) {
                            var format = webix.Date.dateToStr("%d/%m/%Y");
                            text = removeTimeZoneT(text);
                            return format(text);
                        }
                    },
                    { id: "mau_hd", header: [_("MAU_HD"), { content: "textFilter" }], width: 130 },
                    { id: "inv_invoiceSeries", header: [_("KY_HIEU"), { content: "textFilter" }], width: 100 },
                    { id: "inv_invoiceNumber", header: [_("SO_HDON"), { content: "textFilter" }], width: 120 },
                    { id: "ten_dt", header: [_("TEN_DON_VI"), { content: "textFilter" }], width: 350 },
                    {
                        id: "inv_TotalAmountWithoutVat",
                        // header: _("TIEN_TRUOC_THUE"),
                        header: [_("TIEN_TRUOC_THUE"), { content: "textFilter" }],
                        width: 140,
                        format: webix.Number.numToStr({
                            groupDelimiter: ",",
                            groupSize: 3,
                            decimalDelimiter: ".",
                            decimalSize: 0
                        }),
                        css: { "text-align": "right" }
                    },
                    {
                        id: "inv_discountAmount",
                        header: [_("TIEN_CK"), { content: "textFilter" }],
                        // header: _("TIEN_CK"),
                        width: 140,
                        format: webix.Number.numToStr({
                            groupDelimiter: ",",
                            groupSize: 3,
                            decimalDelimiter: ".",
                            decimalSize: 0
                        }),
                        css: { "text-align": "right" }
                    },
                    {
                        id: "inv_vatAmount",
                        // header: _("TIEN_THUE"),
                        header: [_("TIEN_THUE"), { content: "textFilter" }],
                        width: 140,
                        format: webix.Number.numToStr({
                            groupDelimiter: ",",
                            groupSize: 3,
                            decimalDelimiter: ".",
                            decimalSize: 0
                        }),
                        css: { "text-align": "right" }
                    },
                    {
                        id: "inv_TotalAmount",
                        // header: _("THANH_TIEN"),
                        header: [_("THANH_TIEN"), { content: "textFilter" }],
                        width: 140,
                        format: webix.Number.numToStr({
                            groupDelimiter: ",",
                            groupSize: 3,
                            decimalDelimiter: ".",
                            decimalSize: 0
                        }),
                        css: { "text-align": "right" }
                    }
                ],
                on: {
                    onSubViewCreate: function (view, item) {
                        var subView = view;
                        if (subView != null) {
                            var url = app.config.host + "/System/GetDataDetailInvoice?id=" + item.inv_InvoiceAuth_id;
                            var dt = $$("tblInvoiceDetail");
                            dt.clearAll();
                            dt.load(url);
                        }

                    },
                    onSubViewOpen: function (id) {
                        var table = $$("dmwindowData");
                        var subView = table.getSubView(id);

                        if (subView != null) {
                            var url = app.config.host + "/System/GetDataDetailInvoice?id=" + item.inv_InvoiceAuth_id;
                            var dt = $$("tblInvoiceDetail");
                            dt.clearAll();
                            dt.load(url);
                        }
                    }
                },
                pager: "pagerA"
            },
            {
                cols: [
                    {
                        view: "icon", icon: "fas fa-question-circle", id: "help_form_views", tooltip: _("HELPER"),
                        css: "helper",
                        click: function () {
                            webix.alert({
                                title: "Thông báo !",
                                text: "Bạn chưa khai báo hướng dẫn nhanh cho màn hình này !",
                                type: "alert-warning",
                                callback: function (result) {
                                }
                            });
                        }
                    },
                    {
                        view: "combo",
                        label: _("MENU_QUICK"),
                        id: "QuickMenu",
                        options: {
                            // view: "gridsuggest",
                            // id: "grid_window",
                            // template: "#name#",
                            // body: {
                            //     scroll: true,
                            //     autoheight: false,
                            //     columns: [
                            //         { id: "window_id", header: "Window Id", editor: "text", width: 100 },
                            //         { id: "name", header: "Window Name", editor: "text", width: 400 }
                            //     ],
                            //     url: app.config.host + "/System/GetQuickMenu"
                            // },
                            // on: {
                            //     onValueSuggest: function (obj) {
                            //         var start = obj.window_id != "" ? obj.code + ":" + obj.window_id : obj.code;
                            //         window.location.hash = "!/app/" + start;
                            //         $$("QuickMenu").setValue(null);
                            //     }
                            // }
                        },
                        on: {
                            onChange: function (newv, oldv) {

                            }
                        }
                    },
                    {},
                    {
                        id: "pagerA",
                        view: "pager",
                        size: 100,
                        group: 5,
                        template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}"
                    }
                ]
            }

        ]
    }

    var layout = {
        css: "frmView",
        rows: [
            {
                id: "tlbMain",
                height: 35,
                css: "btnControl",
                type: "toolbar",
                margin: 0,
                borderless: true,
                cols: controls
            },
            {
                rows: [
                    grid
                ]
            }
        ]
    };

    function KyHoaDon() {

        var table = webix.$$("dmwindowData");
        var kytaptrung = table.config.kytaptrung;
        var server_cert = table.config.server_cert;

        if (kytaptrung == "FILE") {

            var box = webix.modalbox({
                title: "Chọn chứng thư số",
                buttons: ["Nhận", "Hủy bỏ"],
                text: "<div id='ctnCerts'></div>",
                top: 100,
                width: 750,
                callback: function (result) {
                    switch (result) {
                        case "1":
                            // var form = webix.$$("dmwindowData");
                            // form.enable();
                            // form.hideProgress();

                            webix.modalbox.hide();
                            break;
                        case "0":
                            var table = $$("tblCerts");
                            var data = table.serialize();

                            var cert = null;

                            for (var i = 0; i < data.length; i++) {
                                if (data[i].chon == true) {
                                    cert = data[i];
                                    break;
                                }
                            }

                            if (cert == null) {
                                webix.message("Bạn chưa chọn chứng thư số");
                                return;
                            }

                            webix.modalbox.hide();

                            var wintable = webix.$$("dmwindowData");
                            var data = wintable.serialize();

                            webix.extend(wintable, webix.ProgressBar);
                            wintable.disable();
                            wintable.showProgress();

                            for (var i = 0; i < data.length; i++) {
                                var item = data[i];
                                if (item.chon != undefined) {
                                    if (item.chon == true) {
                                        var a = webix.ajax(app.config.host + "/Invoice/ExportXml?id=" + item.inv_InvoiceAuth_id);

                                        webix.promise.all([a]).then(function (results) {
                                            var a_result = results[0].json();
                                            signOnServerFile(a_result, cert, server_cert);
                                        }).fail(function (err) {
                                            var form = webix.$$("dmwindowData");
                                            form.enable();
                                            form.hideProgress();

                                            webix.alert({
                                                title: "Lỗi !",
                                                text: err,
                                                type: "alert-error"
                                            });
                                        });
                                    }
                                }
                            }

                            var form = webix.$$("dmwindowData");
                            form.enable();
                            form.hideProgress();

                            break;
                    }
                }
            });

            var popupText = document.getElementsByClassName("webix_popup_text")[0];
            popupText.style.paddingTop = 0;

            var tblMatHang = webix.ui({
                container: "ctnCerts",
                id: "tblCerts",
                view: "datatable",
                borderless: true,
                // xmlData: a_result,
                server_cert: server_cert,
                height: 350,
                columns: [
                    {
                        id: "chon",
                        header: _("CHON"),
                        width: 65,
                        checkValue: true,
                        uncheckValue: false,
                        template: "{common.checkbox()}"
                    },
                    {
                        id: "so_serial",
                        header: _("SO_SERIAL"),
                        width: 150
                    },
                    {
                        id: "subjectname",
                        header: _("SUBJECTNAME"),
                        width: 450
                    },
                    {
                        id: "ngaybatdau",
                        header: _("NGAY_BAT_DAU"),
                        width: 200
                    },
                    {
                        id: "ngayketthuc",
                        header: _("NGAY_KET_THUC"),
                        width: 200
                    },
                    {
                        id: "issuer",
                        header: _("DONVI"),
                        width: 450
                    },
                ],
                url: app.config.host + "/Invoice/GetListCertificatesFile"
            });
        }
        else {
            if (kytaptrung == "C") {
                var box = webix.modalbox({
                    title: "Chọn chứng thư số",
                    buttons: ["Nhận", "Hủy bỏ"],
                    text: "<div id='ctnCerts'></div>",
                    top: 100,
                    width: 750,
                    callback: function (result) {
                        switch (result) {
                            case "1":
                                // var form = webix.$$("dmwindowData");
                                // form.enable();
                                // form.hideProgress();

                                webix.modalbox.hide();
                                break;
                            case "0":
                                var table = $$("tblCerts");
                                var data = table.serialize();

                                var cert = null;

                                for (var i = 0; i < data.length; i++) {
                                    if (data[i].chon == true) {
                                        cert = data[i];
                                        break;
                                    }
                                }

                                if (cert == null) {
                                    webix.message("Bạn chưa chọn chứng thư số");
                                    return;
                                }

                                webix.modalbox.hide();

                                var wintable = webix.$$("dmwindowData");
                                var data = wintable.serialize();

                                webix.extend(wintable, webix.ProgressBar);
                                wintable.disable();
                                wintable.showProgress();

                                for (var i = 0; i < data.length; i++) {
                                    var item = data[i];
                                    if (item.chon != undefined) {
                                        if (item.chon == true) {
                                            var a = webix.ajax(app.config.host + "/Invoice/ExportXml?id=" + item.inv_InvoiceAuth_id);

                                            webix.promise.all([a]).then(function (results) {
                                                var a_result = results[0].json();
                                                signOnServer(a_result, cert, server_cert);
                                            }).fail(function (err) {
                                                var form = webix.$$("dmwindowData");
                                                form.enable();
                                                form.hideProgress();

                                                webix.alert({
                                                    title: "Lỗi !",
                                                    text: err,
                                                    type: "alert-error"

                                                });
                                            });
                                        }
                                    }
                                }

                                var form = webix.$$("dmwindowData");
                                form.enable();
                                form.hideProgress();

                                break;
                        }
                    }
                });

                var popupText = document.getElementsByClassName("webix_popup_text")[0];
                popupText.style.paddingTop = 0;

                var tblMatHang = webix.ui({
                    container: "ctnCerts",
                    id: "tblCerts",
                    view: "datatable",
                    borderless: true,
                    // xmlData: a_result,
                    server_cert: server_cert,
                    height: 350,
                    columns: [
                        {
                            id: "chon",
                            header: _("CHON"),
                            width: 65,
                            checkValue: true,
                            uncheckValue: false,
                            template: "{common.checkbox()}"
                        },
                        {
                            id: "so_serial",
                            header: _("SO_SERIAL"),
                            width: 150
                        },
                        {
                            id: "subjectname",
                            header: _("SUBJECTNAME"),
                            width: 450
                        },
                        {
                            id: "ngaybatdau",
                            header: _("NGAY_BAT_DAU"),
                            width: 200
                        },
                        {
                            id: "ngayketthuc",
                            header: _("NGAY_KET_THUC"),
                            width: 200
                        },
                        {
                            id: "issuer",
                            header: _("DONVI"),
                            width: 450
                        },
                    ],
                    url: app.config.host + "/Invoice/GetListCertificates"
                });
            }
            else {
                if (kytaptrung == "CLOUD") {
                    var table = webix.$$("dmwindowData");
                    var data = table.serialize();
                    var promises = [];
                    webix.extend(table, webix.ProgressBar);
                    table.disable();
                    table.showProgress();

                    for (var i = 0; i < data.length; i++) {
                        var item = data[i];
                        if (item.chon != undefined) {
                            if (item.chon == true) {
                                promises.push(item.inv_InvoiceAuth_id);
                            }
                        }
                    }
                    if (promises.length <= 0) {
                        webix.message("Bạn chưa chọn hóa đơn nào để ký !", "debug");
                        var table = webix.$$("dmwindowData");
                        table.enable();
                        table.hideProgress();
                        return;
                    }
                    var box = webix.modalbox({
                        title: "Chọn chứng thư số",
                        buttons: ["Nhận", "Hủy bỏ"],
                        text: "<div id='ctnCerts'></div>",
                        top: 100,
                        width: 750,
                        callback: function (result) {
                            switch (result) {
                                case "1":
                                    webix.modalbox.hide();
                                    break;
                                case "0":

                                    var table = $$("tblCerts");
                                    var data = table.serialize();

                                    var cert = null;

                                    for (var i = 0; i < data.length; i++) {
                                        if (data[i].chon == true) {
                                            cert = data[i];
                                            break;
                                        }
                                    }

                                    if (cert == null) {
                                        webix.message("Bạn chưa chọn chứng thư số", "debug");
                                        var table = webix.$$("dmwindowData");
                                        table.enable();
                                        table.hideProgress();
                                        return;
                                    }

                                    var frm = webix.$$("dmwindowData").$scope.ui(signCloudMulti.$ui);
                                    signCloudMulti.initUI(promises, cert.so_serial);
                                    var table = webix.$$("dmwindowData");
                                    table.enable();
                                    table.hideProgress();
                                    webix.modalbox.hide();
                                    frm.show();
                            }
                        }
                    });

                    var popupText = document.getElementsByClassName("webix_popup_text")[0];
                    popupText.style.paddingTop = 0;

                    var tblMatHang = webix.ui({
                        container: "ctnCerts",
                        id: "tblCerts",
                        view: "datatable",
                        borderless: true,
                        resizeColumn: true,
                        height: 350,
                        columns: [
                            {
                                id: "chon",
                                header: _("CHON"),
                                width: 65,
                                checkValue: true,
                                uncheckValue: false,
                                template: "{common.checkbox()}"
                            },
                            {
                                id: "libraryName",
                                header: _("Loại"),
                                width: 150
                            },
                            {
                                id: "agreementUUID",
                                header: _("ID"),
                                width: 150
                            },
                            {
                                id: "so_serial",
                                header: _("SO_SERIAL"),
                                width: 150
                            },
                            {
                                id: "subjectname",
                                header: _("SUBJECTNAME"),
                                width: 450
                            },
                            {
                                id: "ngaybatdau",
                                header: _("NGAY_BAT_DAU"),
                                width: 200
                            },
                            {
                                id: "ngayketthuc",
                                header: _("NGAY_KET_THUC"),
                                width: 200
                            },
                            {
                                id: "issuer",
                                header: _("DONVI"),
                                width: 450
                            },
                        ],
                        url: app.config.host + "/Invoice/GetListCertificatesCloud"
                    });
                }
                else {
                    if (kytaptrung == "EASYCA") {
                        var table = webix.$$("dmwindowData");
                        var data = table.serialize();
                        var promises = [];
                        webix.extend(table, webix.ProgressBar);
                        table.disable();
                        table.showProgress();

                        for (var i = 0; i < data.length; i++) {
                            var item = data[i];
                            if (item.chon != undefined) {
                                if (item.chon == true) {
                                    promises.push(item.inv_InvoiceAuth_id);
                                }
                            }
                        }
                        if (promises.length <= 0) {
                            webix.message("Bạn chưa chọn hóa đơn nào để ký !", "debug");
                            var table = webix.$$("dmwindowData");
                            table.enable();
                            table.hideProgress();
                            return;
                        }
                        var box = webix.modalbox({
                            title: "Chọn chứng thư số",
                            buttons: ["Nhận", "Hủy bỏ"],
                            text: "<div id='ctnCerts'></div>",
                            top: 100,
                            width: 750,
                            callback: function (result) {
                                switch (result) {
                                    case "1":
                                        webix.modalbox.hide();
                                        var table = webix.$$("dmwindowData");
                                        table.enable();
                                        table.hideProgress();
                                        break;
                                    case "0":

                                        var table = $$("tblCerts");
                                        var data = table.serialize();

                                        var cert = null;

                                        for (var i = 0; i < data.length; i++) {
                                            if (data[i].chon == true) {
                                                cert = data[i];
                                                break;
                                            }
                                        }

                                        if (cert == null) {
                                            webix.message("Bạn chưa chọn chứng thư số", "debug");
                                            var table = webix.$$("dmwindowData");
                                            table.enable();
                                            table.hideProgress();
                                            return;
                                        }

                                        var frm = webix.$$("dmwindowData").$scope.ui(signEasyCAMulti.$ui);
                                        signEasyCAMulti.initUI(promises, cert.so_serial);
                                        var table = webix.$$("dmwindowData");
                                        table.enable();
                                        table.hideProgress();
                                        webix.modalbox.hide();
                                        frm.show();
                                }
                            }
                        });

                        var popupText = document.getElementsByClassName("webix_popup_text")[0];
                        popupText.style.paddingTop = 0;

                        var tblMatHang = webix.ui({
                            container: "ctnCerts",
                            id: "tblCerts",
                            view: "datatable",
                            borderless: true,
                            resizeColumn: true,
                            height: 350,
                            columns: [
                                {
                                    id: "chon",
                                    header: _("CHON"),
                                    width: 65,
                                    checkValue: true,
                                    uncheckValue: false,
                                    template: "{common.checkbox()}"
                                },
                                {
                                    id: "libraryName",
                                    header: _("Loại"),
                                    width: 150
                                },
                                {
                                    id: "so_serial",
                                    header: _("SO_SERIAL"),
                                    width: 250
                                }
                            ],
                            url: app.config.host + "/Invoice/GetListCertificatesEasyCA"
                        });
                    }
                    else {
                        //  webix.message("Quý khách vui lòng vào hóa đơn và chọn ký nhiều !", "error");

                        var table = webix.$$("dmwindowData");
                        var data = table.serialize();

                        webix.extend(table, webix.ProgressBar);
                        table.disable();
                        table.showProgress();

                        var hub = plugin.hub();
                        hub.off('resCommand');

                        hub.on('resCommand', function (result) {
                            var json = JSON.parse(result);

                            if (json.hasOwnProperty("error")) {
                                webix.message({ type: 'error', text: json.error });

                                var table = webix.$$("dmwindowData");
                                table.enable();
                                table.hideProgress();
                            }
                            else {
                                var promises = [];

                                var array = json.data;

                                for (var i = 0; i < array.length; i++) {
                                    var item = array[i];
                                    if (item.hasOwnProperty("error")) {
                                        webix.message({ type: 'error', text: item.error });
                                        continue;
                                    }
                                    var parameters = {
                                        InvoiceXmlData: item.InvoiceXmlData,
                                        inv_InvoiceAuth_id: item.inv_InvoiceAuth_id
                                    };

                                    var a = webix.ajax()
                                        .headers({ "Content-Type": "application/json" })
                                        .post(app.config.host + "/Invoice/SaveXml", parameters);

                                    promises.push(a);
                                }

                                webix.promise.all(promises).then(function (results) {
                                    var invoiceEmail = [];
                                    for (var i = 0; i < results.length; i++) {

                                        if (results[i].json().trang_thai == "Đã ký") {
                                            var item = results[i].json();
                                            webix.ajax()
                                                .headers({ 'Content-type': 'application/json' })
                                                .post(app.config.host + "/System/ExecuteCommand",
                                                {
                                                    command: "CM00025",
                                                    parameter: {
                                                    }
                                                }
                                                , function (text) {
                                                    var json = JSON.parse(text);
                                                    // auto send SMS 

                                                    if (json[1].gia_tri == "C") {
                                                        var data = { id: item.inv_InvoiceAuth_id };
                                                    }
                                                    // send email ma = 'AUTO_SEND_EMAIL'
                                                    if (json[0].gia_tri == "C") {
                                                        // var data = {
                                                        //     inv_InvoiceAuth_id: item.inv_InvoiceAuth_id,
                                                        //     nguoinhan: item.nguoinhan,
                                                        //     tieude: item.tieude
                                                        // };
                                                        // var send = webix.ajax()
                                                        //     .headers({ "Content-Type": "application/json" })
                                                        //     .post(app.config.host + "/Invoice/AutoEmail", data);
                                                        // invoiceEmail.push(send);
                                                        // console.log(invoiceEmail);
                                                        // webix.promise.all(invoiceEmail).then(function (results) { });
                                                        webix.ajax()
                                                            .headers({ 'Content-type': 'application/json' })
                                                            .post(app.config.host + "/Invoice/AutoEmail", data, function (text) {
                                                                var data = JSON.parse(text);

                                                                if (!data.hasOwnProperty("error")) {
                                                                }
                                                                else {
                                                                    webix.message(data.error, "error");
                                                                }
                                                            });
                                                    }
                                                });
                                        }
                                    }


                                    var table = webix.$$("dmwindowData");
                                    table.clearAll();
                                    table.load(table.config.url);

                                    table.enable();
                                    table.hideProgress();
                                });
                            }
                        });

                        var promises = [];

                        for (var i = 0; i < data.length; i++) {
                            var item = data[i];
                            if (item.chon != undefined) {
                                if (item.chon == true) {
                                    var a = webix.ajax(app.config.host + "/Invoice/ExportXml?id=" + item.inv_InvoiceAuth_id);
                                    promises.push(a);
                                }
                            }
                        }
                        if (promises.length <= 0) {
                            webix.message("Bạn chưa chọn hóa đơn nào để ký !", "debug");
                            var table = webix.$$("dmwindowData");
                            table.enable();
                            table.hideProgress();
                            return;
                        }
                        var b = webix.ajax(app.config.host + "/Invoice/GetListCertificates");
                        promises.push(b);

                        webix.promise.all(promises).then(function (results) {
                            var arrays = [];
                            var listcerts = results[results.length - 1].json();
                            for (var i = 0; i < results.length - 1; i++) {
                                arrays.push(results[i].json());
                            }

                            var arg = {
                                idData: "#data",
                                data: arrays,
                                idSigner: "seller",
                                tagSign: "Signatures",
                                listcerts: listcerts
                            };

                            hub.invoke('execCommand', 'SignListInvoices', JSON.stringify(arg))
                                .done(function () {
                                    //console.log("Success !")
                                })
                                .fail(function (error) {
                                    var table = webix.$$("dmwindowData");
                                    // table.clearAll();
                                    // table.load(table.config.url);
                                    table.enable();
                                    table.hideProgress();
                                    webix.message(error, "error");
                                });;
                        });
                    }
                }
            }
        }
    }

    function DuyetHoaDon() {
        var table = webix.$$("dmwindowData");
        var data = table.serialize();

        for (var i = 0; i < data.length; i++) {
            var item = data[i];

            if (item.chon != undefined) {
                if (item.chon == true) {
                    webix.ajax()
                        .bind(item)
                        .sync()
                        .headers({ 'Content-type': 'application/json' })
                        .post(app.config.host + "/Invoice/DuyetHoaDon", { inv_InvoiceAuth_id: item.inv_InvoiceAuth_id }, function (text) {

                            if (text.hasOwnProperty("error")) {
                                webix.message(text.error);
                                return;
                            }

                            $$("dmwindowData").remove(this.id);

                        });
                }
            }
        }

        table.clearAll();
        table.load(table.config.url);
    }

    return {
        $ui: layout,
        $oninit: function (view, $scope) {
            if ($$("hr") == undefined && $$("hr2") == undefined) {
                $$("bodyInvoice").removeView("hr");
                $$("bodyInvoice").removeView("hr2");
            }

            if ($$("title") == undefined) {
                var k = {
                    height: 22,
                    id: "title",
                    css: "title",
                    borderless: true,
                    //css: { "box-shadow": "0 -2px #3498db inset !important" , "background":"#ffffff !important"},
                    template: "<div class='header'>#title#</div><div class ='trogiup' style='float:right; font-size: 11px; line-height: normal;'><a href = '#url_help#' target='_blank' style = 'text-decoration: none;color:#0069b4;'>Trợ giúp <i class='fas fa-question-circle'></i></a></div>",
                    data: { text: "", title: "Lập hóa đơn ", details: "Phân tích và thống kê" }
                };
                $$("bodyInvoice").addView(k, 0);
            }
            var params = app.path[1].params;
            var table = webix.$$("dmwindowData");
            // Lấy thông tin ký tập trung -----------------------------------------
            webix.ajax()
                .headers({ 'Content-type': 'application/json' })
                .post(app.config.host + "/System/ExecuteCommand", {
                    command: "CM00019",
                    parameter: {
                        ma_dvcs: ""
                    }
                }, {
                    error: function (text, data, XmlHttpRequest) {
                        //webix.modalbox.hide(box);
                        webix.alert({
                            title: "Lỗi !",
                            text: err,
                            type: "alert-error"
                        });
                    },
                    success: function (text, data, XmlHttpRequest) {
                        var c_result = JSON.parse(text);

                        for (var i = 0; i < c_result.length; i++) {
                            var item = c_result[i];

                            if (item.ma == "KYTAPTRUNG") {
                                table.config.kytaptrung = item.gia_tri;
                            }

                            if (item.ma == "SERVER_CERT") {
                                table.config.server_cert = item.gia_tri;
                            }
                        }
                    }
                });

            table.define("url", app.config.host + "/Invoice/GetHoaDonChoDuyet?trangthai=Chờ duyệt");

            webix.$$("title").parse({ title: "Trang chủ -> Duyệt hóa đơn", details: "Danh sách hóa đơn chờ duyệt", url_help: "http://huongdansudung.minvoice.com.vn/" });

            var btnEdit = webix.$$("btnEdit");
            btnEdit.define("width", 120);
            btnEdit.define("label", '<i class="fa fa-edit fa-lg" aria-hidden="true"></i> ' +
                '<span class="text">' + _("DUYET") + " (F10)" + '</span>');

            if (params[0] != undefined) {
                var type = params[0];

                if (type == "02") {
                    webix.$$("title").parse({ title: "Trang chủ -> Ký hóa đơn", details: "Danh sách hóa đơn chờ ký", url_help: "http://huongdansudung.minvoice.com.vn/" });
                    table.define("url", app.config.host + "/Invoice/GetHoaDonChoDuyet?trangthai=Chờ ký");
                    btnEdit.define("width", 150);
                    btnEdit.define("label", '<i class="fa fa-edit fa-lg" aria-hidden="true"></i> ' +
                        '<span class="text">' + _("SIGN") + " (F10)" + '</span>');
                }
            }

            table.clearAll();
            table.load(table.config.url);
            btnEdit.refresh();

            $scope.on(app, "dataChanged", function (mode, item) {

                var table = webix.$$("dmwindowData");

                if (mode == 1) {
                    table.add(item);
                    //table.select(item.iddmwindow,false);
                }

                if (mode == 2) {
                    var selectedItem = table.getSelectedItem();
                    table.updateItem(selectedItem.id, item);
                }

            });
        }
    };
});
define('views/forms/file',["app", "locale"], function (app, _) {
    var editmode = 0;
    // {
    //     "paddingY":3, "paddingX":3, "view":"form", "id":"window-form", "complexData":true, "margin":0, "borderless":true, "elements":
    //     [{
    //         "cols": [
    //             {
    //             "view": "fieldset", "label": "Thông tin chung", "body": {
    //                 "rows": [{
    //                     "cols":
    //                     [{ "id": "MA_DT0_DPKT", "view": "text", "label": "Mã đối tượng", "labelWidth": 100, "width": 200, "name": "MA_DT0" }, { "id": "TEN_DT0_DPKT", "view": "text", "label": "Tên đối tượng", "labelWidth": 110, "name": "TEN_DT0" }]
    //                 }, { "id": "ONG_BA_DPKT", "view": "text", "label": "Ông bà", "labelWidth": 100, "name": "ONG_BA" }, { "id": "CT_GOC_DPKT", "view": "text", "label": "Chứng từ gốc", "labelWidth": 100, "name": "CT_GOC" }, { "id": "DIA_CHI_DPKT", "view": "text", "label": "Địa chỉ", "labelWidth": 100, "name": "DIA_CHI" }, { "id": "DIEN_GIAI_DPKT", "view": "text", "label": "Diễn giải", "labelWidth": 100, "name": "DIEN_GIAI" }]
    //             }
    //         }, 
    //         { "width": 10 },
    //          {
    //             "view": "fieldset", "label": "Chứng từ", "body": {
    //                 "rows":
    //                 [
    //                     { "id": "NGAY_CT_DPKT", "view": "datepicker", "label": "Ngày chứng từ", "labelWidth": 110, "width": 300, "name": "NGAY_CT" }, { "id": "SO_CT_DPKT", "view": "text", "labelWidth": 110, "label": "Số chứng từ", "name": "SO_CT" }, 
    //                     { "cols": [{ "id": "MA_NT_DPKT", "view": "text", "name": "MA_NT", "label": "Mã ngoại tệ", "labelWidth": 110, "width": 170 }, { "id": "TY_GIA_DPKT", "view": "text", "name": "TY_GIA", "label": "Tỷ giá", "labelWidth": 50 }] }, { "id": "MA_HT_DPKT", "view": "text", "labelWidth": 110, "label": "Mã hạch toán", "name": "MA_HT" }, { "id": "MA_BP_DPKT", "view": "text", "labelWidth": 110, "label": "Mã bộ phận", "name": "MA_BP" }]
    //             }
    //         }]
    //     },
    //     {
    //         "view": "tabview", "id": "tab_replace", "cells": [{ "header": "Chi tiết thu" },
    //         { "header": "Chi tiết thuế" }]
    //     }, {
    //         "cols": [{ "id": "T_TIEN_TT_DPKT", "view": "text", "label": "Tổng tiền trước thuế", "labelWidth": 170, "name": "T_TIEN_TT" },
    //         { "id": "T_THUE_DPKT", "view": "text", "label": "Tổng tiền thuế", "labelWidth": 130, "name": "T_THUE" }, { "id": "T_TIEN_DPKT", "view": "text", "label": "Tổng tiền", "labelWidth": 100, "name": "T_TIEN" }]
    //     },
    //     {
    //         "cols": [{ "id": "T_TIEN_TT_NT_DPKT", "view": "text", "label": "Tổng tiền trước thuế NT", "labelWidth": 170, "name": "T_TIEN_TT_NT" },
    //         { "id": "T_THUE_NT_DPKT", "view": "text", "label": "Tổng tiền thuế NT", "labelWidth": 130, "name": "T_THUE_NT" },
    //         { "id": "T_TIEN_NT_DPKT", "view": "text", "label": "Tổng tiền NT", "labelWidth": 100, "name": "T_TIEN_NT" }]
    //     }]
    // }
    return {
        $ui: {
            view: "window", modal: true, id: "window-win", position: "center",
            //width:800,
            head: "Nam đại ka",
            fullscreen: true,
            body: {
                paddingY: 10,
                paddingX: 10,
                view: "form",
                id: "window-form",
                complexData: true,
                keepViews: true,
                margin: 0,
                elements: [
                    {
                        cols: [
                            {
                                view: "fieldset",
                                id: "2",
                                label: "Field Set 1",
                                body: {
                                    rows: [
                                        {
                                            column_type: "datetime",
                                            css: null,
                                            data_width: null,
                                            fieldExpression: null,
                                            format: "%d/%m/%Y",
                                            id: "inv_invoiceIssuedDate_inv_InvoiceAuth",
                                            keepViews: true,
                                            label: "Ngày hóa đơn",
                                            labelPosition: "left",
                                            labelWidth: 100,
                                            name: "inv_invoiceIssuedDate",
                                            on: {},
                                            resizeColumn: true,
                                            value_change: null,
                                            view: "datepicker",
                                            width: null
                                        },
                                        {
                                            column_type: "nvarchar",
                                            css: "mcls_readonly_text",
                                            data_width: null,
                                            fieldExpression: null,
                                            format: null,
                                            id: "inv_invoiceNumber_inv_InvoiceAuth",
                                            keepViews: true,
                                            label: "Số hóa đơn",
                                            labelPosition: "left",
                                            labelWidth: 100,
                                            name: "inv_invoiceNumber",
                                            on: {},
                                            readonly: true,
                                            resizeColumn: true,
                                            value_change: null,
                                            view: "text",
                                            width: null
                                        }
                                    ]
                                }
                            },
                            {
                                view: "fieldset",
                                id: "22",
                                label: "Thông tin 2",
                                body: {
                                    rows: [
                                        {
                                            column_type: "datetime",
                                            css: null,
                                            data_width: null,
                                            fieldExpression: null,
                                            format: "%d/%m/%Y",
                                            id: "inv_invoiceIssuedDate_inv_InvoiceAuth1",
                                            keepViews: true,
                                            label: "Ngày hóa đơn",
                                            labelPosition: "left",
                                            labelWidth: 100,
                                            name: "inv_invoiceIssuedDate4",
                                            on: {},
                                            resizeColumn: true,
                                            value_change: null,
                                            view: "datepicker",
                                            width: null
                                        },
                                        {
                                            column_type: "nvarchar",
                                            css: "mcls_readonly_text",
                                            data_width: null,
                                            fieldExpression: null,
                                            format: null,
                                            id: "inv_invoiceNumber_inv_InvoiceAuth1",
                                            keepViews: true,
                                            label: "Số hóa đơn",
                                            labelPosition: "left",
                                            labelWidth: 100,
                                            name: "inv_invoiceNumber5",
                                            on: {},
                                            readonly: true,
                                            resizeColumn: true,
                                            value_change: null,
                                            view: "text",
                                            width: null
                                        }
                                    ]
                                }
                            }
                        ]
                    },
                    {
                        cols: [
                            { view: "text", label: "Email1" },
                            { view: "text", label: "ahihi", id: "lala" }
                        ]

                    }

                ]
            }
        },
        setEditMode: function (mode) {
            editmode = mode;
        }
    };

});
define('views/file',[
    "app",
    "locale",
    "views/forms/file"
], function (app, _, fileform) {
    'use strict';

    var op = [];

    webix.$$("title").parse({ title: "Báo cáo > File báo cáo", details: "Danh sách file báo cáo" });

    var controls = [
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-refresh fa-lg" aria-hidden="true"></i> ' +
            '<span class="text">' + _("REFRESH") + '</span>',
            id: "btnRefresh",
            // shortcut: "F4",
            // css: "webix_secondary",
            on: {
                onClick: function () {
                    var table = webix.$$("dmwindowData");
                    table.clearAll();
                    //console.log(table);
                    table.load(table.config.url);
                    //table.refresh();
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-download fa-lg" aria-hidden="true"></i> ' +
            '<span class="text">' + _("Tải File") + '</span>',
            id: "btnDowload",
            // shortcut: "F4",
            // css: "webix_secondary",
            on: {
                onClick: function () {
                    var table = webix.$$("dmwindowData");
                    var item = table.getSelectedItem();
                    if (item == null) {
                        webix.message("Bạn chưa chọn file cần báo cáo !", "error");
                        return;
                    }
                    var box = webix.modalbox({
                        title: "Đang tải xuống",
                        text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                        width: 350,
                        height: 200
                    });

                    webix.ajax()
                        .response("arraybuffer")
                        //.headers({ 'Content-type': 'application/json' })
                        .get(app.config.host + "/Invoice/Floder?filename=" + item.fName, {
                            error: function (text, data, XmlHttpRequest) {
                                webix.modalbox.hide(box);
                                alert(text);
                            },
                            success: function (text, data, XmlHttpRequest) {
                                var file = new Blob([data], { type: 'text/csv' });
                                webix.html.download(file, item.fName + ".repx");

                                webix.modalbox.hide(box);
                            }
                        });
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        // {
        //     id: "btnTest",
        //     view: "button",
        //     type: "icon",
        //     icon: "refresh",
        //     label: _("TEst"),
        //     width: 90,
        //     // shortcut: "F4",
        //     //css:"button_raised",
        //     on: {
        //         onClick: function () {
        //             var detailForm = this.$scope.ui(fileform.$ui);
        //             detailForm.show();

        //         }
        //     },
        //     click: function () {
        //         this.callEvent("onClick");
        //     }
        // },
        {}

    ];

    var grid = {
        rows: [
            {
                id: "dmwindowData",
                view: "datatable",
                select: true,
                datafetch: 100,
                resizeColumn: true,
                //loadahead: 15,
                url: {
                    $proxy: true,
                    load: function (view, callback, params) {
                        var windowno = app.path[1].params[0];
                        var url = app.config.host + "/Invoice/FloderInfo";

                        webix.ajax(url, callback, view);

                    }
                },
                on: {
                    "data->onStoreUpdated": function () {
                        this.data.each(function (obj, i) {
                            obj.index = i + 1;
                        })
                    },
                    onItemDblClick: function (id, e, node) {
                        var btnEdit = $$("btnDowload");
                        btnEdit.callEvent("onClick");
                    }
                },
                columns: [
                    { id: "index", header: "", sort: "int", width: 40 },
                    { id: "fName", header: ["Tên file", { content: "textFilter" }], width: 300 },
                    //{ id: "fExtension", header: "Loại", width: 100 },
                    {
                        id: "fTime", header: _("Ngày"), width: 100, format: function (text) {
                            var format = webix.Date.dateToStr("%d/%m/%Y");
                            text = removeTimeZoneT(text);
                            return format(text);
                        }
                    }
                ],
                pager: "pagerA"

            },
            {
                cols: [
                    {
                        view: "icon", icon: "fas fa-question-circle", id: "help_form_viewsfile", tooltip: _("HELPER"),
                        css: "helper",
                        click: function () {
                            webix.alert({
                                title: "Thông báo !",
                                text: "Bạn chưa khai báo hướng dẫn nhanh cho màn hình này !",
                                type: "alert-warning",
                                callback: function (result) {
                                }
                            });
                        }
                    },
                    {
                        view: "combo",
                        label: _("MENU_QUICK"),
                        id: "QuickMenu1",
                        options: {
                            // view: "gridsuggest",
                            // id: "grid_window",
                            // template: "#name#",
                            // body: {
                            //     scroll: true,
                            //     autoheight: false,
                            //     columns: [
                            //         { id: "window_id", header: "Window Id", editor: "text", width: 100 },
                            //         { id: "name", header: "Window Name", editor: "text", width: 400 }
                            //     ],
                            //     url: app.config.host + "/System/GetQuickMenu"
                            // },
                            // on: {
                            //     onValueSuggest: function (obj) {
                            //         var start = obj.window_id != "" ? obj.code + ":" + obj.window_id : obj.code;
                            //         window.location.hash = "!/app/" + start;
                            //         $$("QuickMenu1").setValue(null);
                            //         $$("QuickMenu1").destructor();
                            //     }
                            // }
                        },
                        on: {
                            onChange: function (newv, oldv) {

                            }
                        }
                    },
                    {},
                    {
                        id: "pagerA",
                        view: "pager",
                        size: 100,
                        group: 5,
                        template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}"
                    }
                ]
            }
        ]
    }

    var layout = {
        css: "frmView",
        rows: [
            {
                height: 39,
                css: "btnControl",
                borderless: true,
                type: "toolbar",
                margin: 0,
                cols: controls
            },
            {
                rows: [
                    grid
                ]
            }



        ]

    };

    return {
        $ui: layout,
        $oninit: function (view, $scope) {
            $scope.on(app, "dataChanged", function (mode, item) {

                var table = webix.$$("dmwindowData");

                if (mode == 1) {
                    table.add(item);
                    //table.select(item.iddmwindow,false);
                }

                if (mode == 2) {
                    var selectedItem = table.getSelectedItem();
                    table.updateItem(selectedItem.id, item);
                }

            });
        }
    };
});
define('views/forms/createinvoicebangke',["app", "locale"], function (app, _) {

    function initUI(item) {
        $$('sobangke').setValue(item.list_number);
    }

    return {
        $ui: {
            view: "window",
            id: "crinvoice",
            head: "Tạo hóa đơn từ bảng kê",
            modal: true,
            width: 400,
            position: "center",
            // css: { "font-weight": "bold", "text-transform": "uppercase" },
            body: {
                view: "form", id: "crinvoiceform", elements: [

                    { view: "text", label: _("SO_BANG_KE"), id: "sobangke", name: "list_number", readonly: true, labelWidth: 90 },
                    {
                        view: "richselect",
                        id: "inv_InvoiceCode_id",
                        name: "inv_InvoiceCode_id",
                        label: _("MAU_SO"),
                        labelWidth: 90,
                        //options: app.config.host +"/System/GetAllDmDvcs",
                        options: {
                            view: "gridsuggest",
                            textValue: "ky_hieu",
                            body: {
                                url: app.config.host + "/System/GetDataReferencesByRefId?refId=RF00027",
                                textValue: "ky_hieu",
                                columns: [
                                    {
                                        id: "mau_so",
                                        width: 100,
                                        header: _("MAU_SO")
                                    },
                                    {
                                        id: "ky_hieu",
                                        width: 100,
                                        header: _("KY_HIEU")
                                    },
                                    {
                                        id: "ma_loai",
                                        width: 100,
                                        header: _("MA_LOAI")
                                    },
                                    {
                                        id: "ngay_bd_sd",
                                        width: 150,
                                        header: _("NGAY_BD_SD"),
                                        format: function (text) {
                                            var format = webix.Date.dateToStr("%d/%m/%Y");
                                            text = removeTimeZoneT(text);
                                            return format(text);
                                        }
                                    },
                                    {
                                        id: "tu_so",
                                        width: 100,
                                        header: _("TU_SO")
                                    },
                                    {
                                        id: "den_so",
                                        width: 100,
                                        header: _("DEN_SO")
                                    }
                                ]
                            }
                        }
                    },
                    { view: "datepicker", label: _("NGAY_HDON"), id: "ngayhd", name: "ngay_hd", value: new Date(), labelWidth: 90 },
                    {
                        cols: [

                            {
                                view: "button", value: "Đồng ý", type: "form", click: function () {

                                    var item = $$("crinvoiceform").getValues();
                                    console.log(item);

                                    var url = app.config.host + "/Invoice/CreateInvoiceFromList";
                                    webix.ajax()
                                        .headers({ 'Content-type': 'application/json' })
                                        .post(url, item, function (text) {
                                            var data = JSON.parse(text);

                                            if (!data.hasOwnProperty("error")) {
                                                webix.message("Tạo hóa đơn thành công !");
                                                $$("crinvoice").close();
                                            }
                                            else {
                                                webix.message(data.error, "error");
                                            }
                                        });
                                }
                            },
                            {
                                view: "button", hotkey: "esc", value: "Hủy bỏ", click: function () {
                                    this.getTopParentView().hide();
                                }
                            }
                        ]
                    }
                ]
            }
        },
        initUI: initUI
    };

});
define('views/forms/dmhanghoas',[
    "app",
    "locale",
    "models/user"
], function (app, _, user) {
    var windowId = "hanghoa-win";
    var formId = "hanghoa-form";
    var tableId = "tblHanghoa";
    var message_nodata = "Không có dữ liệu";
    var message_empty_data = "Bạn chưa chọn hàng hóa";
    var message_notice = "Bạn có chắc chắn muốn cập nhật thuế suất";
    var layout = {
        view: "window", modal: true, resize: true, id: windowId, position: "center", move: true, css: "headformchil",
        head: {
            height: 40,
            cols: [
                { id: "head-form", view: "template", css: "headform", template: function (obj) { return '<div>Cập nhật thuế suất<div/>'; } },
                { view: "icon", icon: "fas fa-question-circle", id: "help_form", tooltip: _("HELPER"), click: function () { } }
            ]
        },
        minWidth: 600,
        minHeight: 600,
        on: {
        },
        body: {
            paddingY: 10,
            paddingX: 10,
            view: "form",
            id: formId,
            complexData: true,
            margin: 0,
            elements: [
                {
                    view: "combo",
                    name: "dmloaithue_68_id",
                    label: "Loại thuế suất",
                    labelPosition: "top",
                    // required: true,
                    // invalidMessage: "Ký hiệu hóa đơn không được để trống !",
                    options:
                    {
                        view: "gridsuggest",
                        url: app.config.host + "/Invoice68/GetVAT",
                        body: {
                            scroll: true,
                            autoheight: false,
                            autofocus: true,
                            yCount: 10,
                            columns: [
                                { id: "value", header: _("Thuế suất"), width: 150 },
                                { id: "id", header: _("Giá trị"), width: 150 },
                            ]
                        }
                    },
                    on: {
                        onChange: function (newv, oldv) {
                            var item = this.getPopup().getList().getItem(newv);
                        },
                        onBeforeRender: function () {
                        },
                    }
                    // validate: webix.rules.isEmpty
                },
                { view: "template", template: "Danh sách hàng hóa dịch vụ", type: "section" },
                {

                    view: "datatable",
                    select: "row",
                    id: tableId,
                    resizeColumn: true,
                    datafetch: 50,
                    on: {
                        "data->onStoreUpdated": function () {
                            this.data.each(function (obj, i) {
                                obj.index = i + 1;
                            })
                        },
                        onBeforeLoad: function () {
                            webix.extend(this, webix.ProgressBar);
                            // this.showProgress({
                            //     type: "top"
                            // });
                        },
                        onAfterLoad: function () {
                            this.hideProgress();
                            if (!this.count())
                                this.showOverlay("<div><img src='assets/imgs/nodata.png'><div class='showOverlaydata'>Không có dữ liệu </br> Chúng tôi không tìm thấy hóa đơn</div></div>");
                            else
                                this.hideOverlay();
                        }
                    },
                    url: {
                        $proxy: true,
                        load: function (view, callback, params) {
                            var start = null;
                            var count = null;
                            var filter = [];
                            var infoparam = null;
                            var tlbparam_s = [];

                            if (params == null) {
                                start = 0;
                                count = view.config.datafetch;
                            }
                            else {
                                start = params.start;
                                count = params.count;
                                if (params.filter != null) {
                                    var array = [];
                                    for (var property in params.filter) {
                                        var column = view.getColumnConfig(property);
                                        if (column !== undefined) {
                                            var item = {
                                                columnName: property,
                                                columnType: column.columnType,
                                                value: params.filter[property]
                                            };
                                            array.push(item);
                                        }
                                    }
                                    if (array.length > 0) {
                                        filter = array;
                                    }
                                }
                            }
                            var item = {
                                command: "CM0030",
                                start: start,
                                count: count,
                                filter: filter,
                                tlbparam: tlbparam_s
                            };
                            var hostApi = app.config.host + "/Pattern/GetData";
                            webix.ajax()
                                .headers({ 'Content-type': 'application/json' })
                                .bind(view)
                                .post(hostApi, item, callback, view);
                        }
                    },
                    columns: [
                        {
                            id: "chon1",
                            header: [{ text: "", content: "masterCheckbox" }], width: 55, checkValue: 'C', uncheckValue: 'K',
                            template: "{common.checkbox()}"
                        },
                        { id: "index", sort: "int", header: "STT", width: 50 },
                        { id: "dmhv_id", header: "ID hàng hóa", width: 250, hidden: true },
                        { id: "ma_hv", header: [_("Mã hàng hóa"), { content: "serverFilter" }], columnType: "nvarchar" },
                        { id: "ten_hv", header: [_("Tên hàng hóa"), { content: "serverFilter" }], columnType: "nvarchar" },
                        { id: "ma_dvt", header: "ĐVT" },
                        { id: "ma_thue", header: [_("Thuế suất"), { content: "serverFilter" }], columnType: "nvarchar" },
                        {
                            id: "gia_ban", header: "Giá bán", width: 150, format: webix.Number.numToStr({
                                groupDelimiter: ",",
                                groupSize: 3,
                                decimalDelimiter: ".",
                                decimalSize: 0
                            })
                        }
                    ],
                    pager: "selectPagerA"
                },
                {
                    id: "selectPagerA",
                    view: "pager",
                    size: 50,
                    group: 5,
                    template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}"
                },
                {
                    margin: 10,
                    cols: [
                        {},
                        {
                            shortcut: "F9", view: "button", label: "Nhận (F9)", type: "form", align: "center", width: 120,
                            on: {
                                onClick: function () {
                                    webix.confirm({
                                        title: "Cập nhật thuế suất",
                                        text: message_notice, ok: "Có", cancel: "Không",
                                        callback: function (res) {
                                            if (res) {
                                                var formComponent = webix.$$(formId);
                                                if (formComponent.validate()) {
                                                    webix.extend(formComponent, webix.ProgressBar);
                                                    formComponent.disable();
                                                    formComponent.showProgress();
                                                    var tableInvoiceComponent = $$(tableId);
                                                    var dataInvoice = tableInvoiceComponent.serialize();
                                                    if (dataInvoice.length == 0) {
                                                        webix.message(message_nodata, "error");
                                                        formComponent.enable();
                                                        formComponent.hideProgress();
                                                        return;
                                                    }
                                                    var item = [];
                                                    for (var i = 0; i < dataInvoice.length; i++) {
                                                        if (dataInvoice[i] != undefined) {
                                                            if (dataInvoice[i].chon1 != null && dataInvoice[i].chon1 == "C") {
                                                                item.push(dataInvoice[i].dmhv_id);
                                                            }
                                                        }
                                                    }
                                                    if (item.length <= 0) {
                                                        webix.message(message_empty_data, "error");
                                                        formComponent.enable();
                                                        formComponent.hideProgress();
                                                        return;
                                                    }
                                                    var formData = formComponent.getValues();
                                                    var parameter = {
                                                        thue_suat: formData.dmloaithue_68_id,
                                                        data: item
                                                    };
                                                    webix.ajax().headers({ 'Content-type': 'application/json' })
                                                        .post(app.config.host + "/Pattern/UpdateTaxHv", parameter, function (text) {
                                                            var response = JSON.parse(text);
                                                            formComponent.enable();
                                                            formComponent.hideProgress();
                                                            if (response.code != "00") {
                                                                webix.message(response.message, "error");
                                                            }
                                                            else {
                                                                webix.message("Thao tác thành công", "success");
                                                                var table = $$(tableId);
                                                                table.clearAll();
                                                                table.load(table.config.url);
                                                            }
                                                        });
                                                }
                                            }
                                        }
                                    });
                                }
                            },
                            click: function () {
                                this.callEvent("onClick");
                            }
                        },
                        {
                            view: "button", hotkey: "esc", label: "Hủy bỏ (ESC)", type: "danger", align: "center", width: 100,
                            click: function () {
                                webix.$$(windowId).close();
                            }
                        },
                        {}
                    ]
                }
            ]
        }
    };
    return {
        $ui: layout,
        setEditMode: function (mode) {
            editmode = mode;
        }
    };
});
define('views/forms/dmhv',["app"],function(app){
	var editmode = 0;
	var col=[];
					
	var el = [];
	var head_name=[];
	var head;
    var url = app.config.host + "/api/System/GetAllByWindowId?id=09a8b24b-52b5-46a6-931d-d6f005da0dd7";
    webix.ajax(url, function (text, xml, xhr) {

        var rp = JSON.parse(text);
        head_name.push(String(rp['data'][0]['Tabs'][0]['TAB_NAME']));
        for (var i = 0; i < (rp['data'][0]['ROWS_MAX']); i++) {
			var col1=[];
			
			for (var j = 0; j < (Object.keys(rp['data'][0]['Tabs'][0]['Fields']).length); j++) {
				
				if(i==(Number(rp['data'][0]['Tabs'][0]['Fields'][j]['ROW'])-1)){
					var el1=[];
					col1.push({ view:"text", name: '' + String(rp['data'][0]['Tabs'][0]['Fields'][j]['COLUMN_NAME']) + '',label: '' + String(rp['data'][0]['Tabs'][0]['Fields'][j]['COLUMN_NAME']) + '' , 
			  			id: 'dmhv-'+ String(rp['data'][0]['Tabs'][0]['Fields'][j]['COLUMN_NAME']) + '',width:Number(rp['data'][0]['Tabs'][0]['Fields'][j]['WIDTH'])});
					
						  
				}
				
							
			}
			
			if(col1.length>0){
				el.push({
				cols:col1
			});
			}
			
        }
		col.push({});
		col.push({ 
			shortcut:"F10",  view:"button", label:"Nhận", type:"form", align:"center", 
			on: {
				onClick: function() {
					var form = webix.$$("dmhv-form");
						var item = form.getValues();
						var hvData={};
						hvData.windowno=String(rp['data'][0]['ID']);
						hvData.editmode=editmode;
						hvData.data=[];
						hvData.data.push(item);
						console.log(item);
						console.log(hvData);
						webix.ajax().post( app.config.host + "/api/System/Save", hvData, function(text){
						var data = JSON.parse(text);
											
						if (!data.hasOwnProperty("error")){
							item.id = data.id;
							webix.$$("dmhv-win").close();
							app.callEvent("dataChanged",[editmode,item]);
						}
						else {
							webix.message(data.error);
						}
					});
									}
				},
			click:function(){								
				this.callEvent("onClick");							
									
			}
		});	
		col.push({ view:"button", hotkey:"esc", label:"Hủy bỏ",align:"center", 
			click:function(){
				webix.$$("dmhv-win").close();
			}
		});	
		col.push({});	
		el.push({
			margin:10,
			cols:col
		});
        $$("dmhvData").define("elements",el );;
        $$("dmhvData").refresh();
		//console.log(head_name[0]);
    });
	  
	return {		
		$ui:{
			view:"window", modal:true, id:"dmhv-win", position:"center",
			head:'' + head + '',
			//fullscreen:true,
			//width: 350,
			body:{
                paddingY:20, 
                paddingX:30, 
                elementsConfig:{labelWidth: 80}, 
                view:"form", 
				id:"dmhv-form", 
				complexData:true,
                elements:
                    el
					// {
					// 	margin:10,
					// 	cols:[
					// 		{},
					// 		{ 
					// 			shortcut:"F10",  view:"button", label:"Nhận", type:"form", align:"center", width:120, 
					// 			on: {
					// 				onClick: function() {
					// 					var form = webix.$$("dmhv-form");
					// 					var item = form.getValues();

					// 					webix.ajax().post( app.config.host + "/api/Dmhv/Update", item, function(text){
					// 						var data = JSON.parse(text);
											
					// 						if (!data.hasOwnProperty("error")){
					// 							item.id = data.id;
					// 							webix.$$("dmhv-win").close();
					// 							app.callEvent("dataChanged",[editmode,item]);
					// 						}
					// 						else {
					// 							webix.message(data.error);
					// 						}
					// 					});
					// 				}
					// 			},
					// 			click:function(){								
					// 				this.callEvent("onClick");							
									
					// 			}
					// 		},
					// 		{ view:"button", hotkey:"esc", label:"Hủy bỏ",align:"center", width:120, 
					// 			click:function(){
					// 				webix.$$("dmhv-win").close();
					// 			}
					// 		}
					// 	]
					// }

				
			}			
			
		},		
		setEditMode: function(mode) {
			editmode = mode;
		}
	};

});
define('views/forms/excelAccounting',["app", "locale"], function (app, _) {
    var editmode = 0;
    var inv_codeId;
    return {
        $ui: {
            view: "window", modal: true, id: "excelAccounting-win", position: "center",
            head: "Kết xuất Excel vào PM Kế toán",
            width: 400,
            body: {
                paddingY: 10,
                paddingX: 10,
                view: "form",
                id: "excelAccounting-form",
                complexData: true,
                margin: 0,
                elements: [
                    {
                        view: "multicombo",
                        label: _("KY_HIEU"),
                        name: "inv_invoiceCode_id",
                        id: "inv_invoiceCode_id",
                        required: true,
                        invalidMessage: "Ký hiệu hóa đơn không được để trống",
                        validate: webix.rules.isNotEmpty,
                        labelWidth: 80,
                        // required: true,
                        // invalidMessage: "Tên truy cập không để trống hoặc nhập không đúng (a-z,A-Z,0-9)",
                        // validate: webix.rules.isNotEmpty,
                        suggest: {
                            selectAll: true,
                            body: {
                                url: app.config.host + "/System/GetDataReferencesByRefId?refId=RF00027",
                                //template: webix.template("#value#")
                            }
                        }
                        //value: "2"
                    },
                    {
                        view: "datepicker",
                        label: _("Từ ngày"),
                        // labelPosition: "top",
                        name: "tu_ngay",
                        format: "%d/%m/%Y",
                        id: "tu_ngay",
                        ediable: true,
                        required: true,
                        value: new Date(),
                        invalidMessage: "Từ ngày không được để trống"
                    },
                    {
                        view: "datepicker",
                        label: _("Đến ngày"),
                        // labelPosition: "top",
                        name: "den_ngay",
                        ediable: true,
                        value: new Date(),
                        format: "%d/%m/%Y",
                        id: "den_ngay",
                        required: true,
                        invalidMessage: "Đến ngày không được để trống"
                    },
                    {
                        view: "combo",
                        name: "loai_bc",
                        label: "Loại báo cáo ",
                        id: "loai_bc",
                        required: true,
                        invalidMessage: "Loại báo cáo không được để trống",
                        validate: webix.rules.isNotEmpty,
                        options: {
                            view: "gridsuggest",
                            id: "grid_ExcelAccounting",
                            template: "#name#",
                            width: 550,
                            body: {
                                scroll: true,
                                autoheight: false,
                                // dataFeed: function (filtervalue, filter) {
                                //     console.log(filtervalue);
                                //     console.log(filter);
                                // },
                                columns: [
                                    { id: "bc", header: "STT", editor: "text", width: 50 },
                                    { id: "name", header: "Tên báo cáo", editor: "text", width: 300 }
                                ],
                                data: [
                                    { id: "1", bc: "1", name: "Báo cáo Misa" },
                                    // { id: "2", bc: "2", name: "Báo cáo dịch vụ Misa" },
                                    { id: "3", bc: "3", name: "Báo cáo Fast" },
                                    // { id: "4", bc: "4", name: "Báo cáo dịch vụ Fast" },
                                    { id: "5", bc: "5", name: "Báo cáo bán hàng LinQ" },
                                    { id: "6", bc: "6", name: "Báo cáo mua hàng LinQ" },
                                    { id: "7", bc: "7", name: "Báo cáo Sivip" },
                                    { id: "8", bc: "8", name: "Báo cáo Augess" },
                                    { id: "9", bc: "9", name: "Báo cáo VACOM" },
                                    { id: "10", bc: "10", name: "Báo cáo 3TSOFT" }
                                ]
                            }
                        },
                        // options: [
                        //     { id: "1", value: "Báo cáo hàng hóa Misa" },
                        //     { id: "2", value: "Báo cáo hàng hóa Sivip" }
                        // ]
                    },
                    {
                        margin: 10,
                        cols: [
                            {},
                            {
                                shortcut: "F10", view: "button", label: "Nhận (F10)", type: "form", align: "center", width: 100,
                                on: {
                                    onClick: function () {
                                        if ($$("loai_bc").validate() && $$("inv_invoiceCode_id").validate()) {
                                            var form = $$("excelAccounting-win");
                                            webix.extend(form, webix.ProgressBar);
                                            form.disable();
                                            form.showProgress();

                                            var param = $$("excelAccounting-form").getValues();
                                            //param.inv_invoiceCode_id = inv_codeId;

                                            webix.ajax()
                                                .response("arraybuffer")
                                                .post(app.config.host + "/Bcthsd/ExportExcelAccounting", param, function (text, data) {
                                                    var file = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                                                    webix.html.download(file, "Minvoice.xlsx");

                                                    form.enable();
                                                    form.hideProgress();
                                                });
                                        }
                                    }
                                },
                                click: function () {
                                    this.callEvent("onClick");

                                }
                            },
                            {
                                view: "button", hotkey: "esc", label: "Hủy bỏ (ESC)", type: "danger", align: "center", width: 100,
                                click: function () {
                                    webix.$$("excelAccounting-win").close();
                                }
                            },
                            {}
                        ]
                    }

                ]
            }

        },
        setEditMode: function (mode) {
            editmode = mode;
        },
        initUI: function (item) {
            inv_codeId = item;
        }
    };

});
define('views/forms/file_IM',["app", "locale"], function (app, _) {
    var fm = function (text) {
        var format = webix.Date.dateToStr("%d/%m/%Y %H:%i:%s");
        text = removeTimeZoneT(text);
        return format(text);
    };
    var _id;
    var _table;
    function initUI(id, table) {
        _id = id;
        _table = table;
        // webix.message(_id);
        // $$("tbl_file_IM").url(app.config.host + "/ManageInvoice/GetListFileById?id=" + _id);
        // var url = app.config.host + "/ManageInvoice/GetListFileById?id=" + _id;

        $$("tbl_file_IM").load({
            $proxy: true,
            load: function (view, callback, params) {
                // return webix.ajax().get("some.php", params);
                var url = app.config.host + "/ManageInvoice/GetListFileById?id=" + _id;
                webix.ajax(url, callback, view);
            }
        });
        // var model = { inv_InvoiceAuth_id: inv_InvoiceAuth_id };
        // webix.ajax()
        //     .headers({ 'Content-type': 'application/json' })
        //     .get(url, function (text) {
        //         var data = JSON.parse(text);

        //         if (!data.hasOwnProperty("error")) {
        //             $$('tbl_file_IM').parse(data, 'json');
        //         }
        //         else {
        //             webix.message(data.error, "error");
        //         }
        //     });
    };

    return {
        $ui: {
            view: "window", modal: true, id: "fileIM-win", position: "center",
            head: "Danh sách tệp đính kèm",
            headHeight: 80,
            width: 550,
            height: 350,
            move: true,
            body: {
                paddingY: 10,
                paddingX: 10,
                view: "form",
                id: "fileIM-form",
                complexData: true,
                margin: 0,
                elements: [
                    {
                        view: "datatable",
                        // header: "Lịch sử gửi Email",
                        id: "tbl_file_IM",
                        editable: false,
                        resizeColumn: true,
                        select: true,
                        leftSplit: 5,
                        tooltip: true,
                        // fixedRowHeight: true,
                        // rowLineHeight: 25,
                        // rowHeight: 25,
                        //autoheight:true,
                        // url: {
                        //     $proxy: true,
                        //     load: function (view, callback, params) {
                        //         var url = app.config.host + "/ManageInvoice/GetListFileById?id=02B07655-F728-4E5F-ABDC-D91F9E5EB4E3";
                        //         webix.ajax(url, callback, view);
                        //     }
                        // },
                        on: {
                            onItemClick: function (id) {
                                if (id.column == "dow") {
                                    var item = this.getItem(id);
                                    webix.confirm({
                                        title: "TẢI HÓA ĐƠN",
                                        text: "Bạn có muốn tải file: <span style='color: red'>" + item.value + "</span> đính kèm hóa đơn số: <span style='color: red'>" + item.invoiceNumber + "</span>", ok: "Có", cancel: "Không",
                                        callback: function (res) {
                                            if (res) {
                                                var table = webix.$$("fileIM-win");
                                                webix.extend(table, webix.ProgressBar);
                                                table.disable();
                                                table.showProgress();
                                                // console.log(item);
                                                webix.ajax()
                                                    .response("arraybuffer")
                                                    .get(app.config.host + "/ManageInvoice/FtpDowloadFileIM?path=" + item.path_file + "&fileName=" + item.value + "&fileType=" + item.fileType, function (text, data) {
                                                        var file = new Blob([data], { type: item.fileType });
                                                        //  var fileURL = URL.createObjectURL(file);
                                                        //    window.open(fileURL, '_blank');
                                                        webix.html.download(file, item.value);
                                                        table.enable();
                                                        table.hideProgress();
                                                    });

                                            }
                                        }
                                    });

                                }
                            },
                            // "onresize": webix.once(function () {
                            //     // this.adjustRowHeight("loai", true);
                            // }),
                            "data->onStoreUpdated": function () {
                                this.data.each(function (obj, i) {
                                    obj.stt = i + 1;
                                })
                            },
                            onItemDblClick: function (id, e, node) {
                                // var btnEdit = $$("btncskh");
                                // btnEdit.callEvent("onClick");
                                //webix.message("Click M-invoice", "error");
                            },
                            onBeforeRender: function () {
                                // var table = webix.$$("windowData").getSelectedItem();
                                $$("fileIM-win").getHead().setHTML("Danh sách tệp đính kèm </br><span style='font-size: 14px;'> Hóa đơn số:<b style='color:blue'> " + _table.invoiceNumber + "</b> Mẫu số:<b style='color:blue'> " + _table.mauhd + "</b> Ký hiệu:<b style='color:blue'> " + _table.invoiceSeries + "</b></span>");
                                //$$("tbl_email").refresh();
                                //$$("tbl_email").define("pager", kk);
                            },
                            onBeforeLoad: function () {
                                webix.extend(this, webix.ProgressBar);
                                this.disable();
                                this.showProgress();
                                // this.showOverlay("LOADING ...");
                            },
                            onAfterLoad: function () {
                                this.enable();
                                this.hideProgress();
                                // this.hideOverlay();
                            }
                        },
                        columns: [
                            { id: "stt", header: "STT", width: 40 },
                            { id: "loai", name: "loai", header: "Loại gửi", width: 150, editor: "text", hidden: true },
                            { id: "inv_Invoice_id", name: "inv_Invoice_id", header: "", editor: "text", hidden: true, adjust: true },
                            { id: "value", name: "value", header: "Tên tệp", adjust: true, fillspace: true, editor: "text" },
                            {
                                id: "dow", header: "", tooltip: "Tải tệp",
                                template: function (obj) {
                                    return "<div class='webix_el_button'><button><i style='color: #00b300' class='fa fa-download' aria-hidden='true'></i></button></div>";
                                }
                            }
                        ],
                        pager: "pagerB",
                        ready: function () {
                            //this.open(this.getFirstId());
                            this.sort({ by: "stt", dir: "desc" });
                        },
                    },
                    {
                        id: "pagerB",
                        view: "pager",
                        size: 100,
                        group: 5,
                        template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}"
                    },
                    {
                        margin: 10,
                        cols: [
                            {},
                            {
                                view: "button", hotkey: "esc", label: "Đóng", align: "center", width: 120, type: "danger",
                                click: function () {
                                    webix.$$("fileIM-win").close();
                                }
                            },
                            {}
                        ]
                    }

                ]
            }

        },
        initUI: initUI
    };

});
define('views/forms/forms68/DangKySD/68_dangkysudungForms',[
    "app",
    "locale",
    "models/user",
    "views/modules/minvoiceplugin"
], function (app, _, user, minvoiceplugin) {
    'use strict';

    webix.$$("title").parse({ title: "Đăng ký sử dụng", details: "Đăng ký sử dụng" });
    var editmode = 0;
    var thongtinchung = {
        view: "fieldset", label: "Thông tin chung", body: {
            rows: [
                {
                    cols: [
                        {
                            id: "hthuc", name: "hthuc",
                            label: "Hình thức", view: "combo", value: 1,
                            options: [
                                { id: "1", value: "Đăng ký" },
                                { id: "2", value: "Thay đổi" }
                            ],
                            on: {
                                onChange: function (newValue, oldValue, config) {
                                    if (newValue == 2) {

                                        var tableHoadon = $$("dangkysudungForms");
                                        webix.extend(tableHoadon, webix.ProgressBar);
                                        tableHoadon.disable();
                                        tableHoadon.showProgress();

                                        var url = app.config.host + "/Register68/GetSerialAcceptInvoice";

                                        webix.ajax()
                                            .headers({ 'Content-type': 'application/json' })
                                            .get(url, {
                                                error: function (text, data, XmlHttpRequest) {
                                                    tableHoadon.enable();
                                                    tableHoadon.hideProgress();

                                                }, success: function (text, data, XmlHttpRequest) {
                                                    tableHoadon.enable();
                                                    tableHoadon.hideProgress();
                                                    var data = JSON.parse(text);
                                                    $$("danhsach_chukyso").parse(data);
                                                }
                                            });
                                    }
                                    if (newValue == 1) {
                                        $$("danhsach_chukyso").clearAll();
                                    }
                                }
                            }
                        },
                        {
                            view: "datepicker",
                            name: "nlap",
                            label: "Ngày lập",
                            id: "nlap",
                            value: new Date(),
                            required: true,
                            invalidMessage: "Ngày lập không được để trống !",
                            validate: webix.rules.isEmpty
                        }
                    ]
                },
                {
                    view: "text",
                    label: "Tên đơn vị ",
                    labelWidth: 150,
                    name: "tnnt",
                    id: "tnnt",
                    required: true,
                    invalidMessage: "Tên đơn vị không được để trống !",
                    validate: webix.rules.isEmpty
                    // css: "mcls_uppercase",
                },
                {
                    cols: [
                        {
                            view: "text",
                            label: "Mã số thuế",
                            id: "mst",
                            name: "mst",
                            labelWidth: 150,
                            on: {
                                onSearchIconClick: function () {
                                    var model = { masothue: $$("mst").getValue(), };
                                    var url = "http://demo.minvoice.com.vn/api/Pattern/GetInfoMST";
                                    webix.ajax().headers({ "Content-type": "application/json", }).post(url, model, function (response) {
                                        var data = JSON.parse(response);
                                        if (data.hasOwnProperty("ten_cty")) {

                                        } else {
                                            webix.message(data.error, "error");
                                            return false;
                                        }
                                    });

                                }
                            }
                        },
                        {
                            view: "text",
                            label: "Địa danh",
                            id: "ddanh",
                            name: "ddanh",
                            required: true,
                            invalidMessage: "Địa danh không được để trống !",
                            validate: webix.rules.isEmpty
                        }
                    ]
                },
                {
                    cols: [

                        // {
                        //     view: "text",
                        //     label: "Mã cơ quan thuế QL",
                        //     id: "mcqtqly",
                        //     name: "mcqtqly",
                        //     required: true,
                        //     validate: webix.rules.isEmpty,
                        //     invalidMessage: "Mã cơ quan thuế QL không được để trống"
                        // },
                        {
                            view: "combo",
                            name: "mcqtqly",
                            label: "Mã cơ quan thuế QL",
                            id: "mcqtqly",
                            required: true,
                            validate: webix.rules.isEmpty,
                            invalidMessage: "Mã cơ quan thuế QL không thể bỏ trống !",
                            options: {
                                view: "gridsuggest",
                                scroll: true,
                                autoheight: false,
                                template: "#id#",
                                url: app.config.host + "/Pattern/GetTaxQL",
                                body: {
                                    scroll: true,
                                    autoheight: false,
                                    columns: [
                                        { id: "id", header: _("Mã"), width: 80 },
                                        { id: "value", header: _("Tên"), width: 250 }
                                    ],
                                    dataFeed: function (filtervalue, filter) {

                                        if (filtervalue.length < 1) {
                                            this.load(this.config.url);
                                            return;
                                        }
                                        var pathUrl = app.config.host + "/Pattern/GetTaxQL?";
                                        var urldata = "val=" + encodeURIComponent(filtervalue);
                                        this.load(pathUrl + urldata, this.config.datatype);
                                    }
                                },
                                on: {
                                    onValueSuggest: function (obj) {
                                        $$("cqtqly").setValue(obj.value);
                                    }
                                }
                            }
                        },
                        {
                            view: "text",
                            label: "Cơ quan thuế QL",
                            id: "cqtqly",
                            name: "cqtqly",
                            required: true,
                            validate: webix.rules.isEmpty,
                            invalidMessage: "Cơ quan thuế QL không được để trống"
                        }
                    ]
                }
            ]
        }
    };

    var thongtinnguoilienhe = {
        view: "fieldset", label: "Thông tin người liên hệ", body: {
            rows: [
                {
                    cols: [
                        {
                            view: "text",
                            label: "Tên",
                            id: "nlhe",
                            name: "nlhe",
                            required: true,
                            invalidMessage: "Tên không được để trống !",
                            validate: webix.rules.isEmpty
                        },
                        {
                            view: "text",
                            label: "Email",
                            id: "dctdtu",
                            name: "dctdtu",
                            required: true,
                            invalidMessage: "Email không được để trống !",
                            validate: webix.rules.isEmail,
                            on: {
                                onTimedKeyPress: function () {
                                    var countMail = $$("dctdtu").getValue().split(/[\s,\;]+/);
                                    // console.log(countMail);
                                    if (countMail.length > 1) {
                                        webix.message("Bạn không được phép nhập quá 1 email", "debug");
                                        return;
                                    }
                                }
                            }
                        }
                    ]
                },
                {
                    cols: [
                        {
                            view: "text",
                            label: "Địa chỉ",
                            id: "dclhe",
                            name: "dclhe",
                            required: true,
                            invalidMessage: "Địa chỉ không được để trống !",
                            validate: webix.rules.isEmpty
                        },
                        {
                            view: "text",
                            label: "Số điện thoại",
                            id: "dtlhe",
                            name: "dtlhe",
                            required: true,
                            //pattern:{ mask:"###-## ########"},
                            invalidMessage: "Số điện thoại không được để trống !",
                            validate: webix.rules.isEmpty
                        }
                    ]
                }
            ]
        }
    }
    return {
        $ui: {
            view: "window",
            modal: true,
            // position: "center",
            position: function (state) {
                state.width = state.maxWidth * 0.7;
                state.height = state.maxHeight * 0.9;
                state.left = (state.maxWidth - state.width) / 2;
                state.top = (state.maxHeight - state.height) / 2;
            },
            css: "headformchil",
            head: {
                //view: "toolbar",
                // css: { "box-shadow": "0 -2px #3498db inset !important", "background": "#ffffff !important" },
                //css: { "background": "#e6f2ff !important" },
                height: 35,
                cols: [
                    {
                        id: "head-icondksd",
                        view: "template",
                        css: "headform",
                        width: 35,
                        template: ""
                    },
                    {
                        id: "head-formdksd", view: "template", css: "headform", template: function (obj) {
                            return '<div>Đăng ký/thay đổi thông tin sử dụng hóa đơn điện tử<div/>';
                        }
                    },
                    {
                        view: "icon", icon: "fas fa-question-circle", id: "help_dksdForms", tooltip: _("HELPER"), click: function () {
                            // var form = webix.$$("window-form");
                            // hint_form(form.config.hint);
                        }
                    }
                ]
            },
            id: "dangkysudungForms",
            resize: true,
            fullscreen: true,
            move: true,
            on: {
                onShow: function () {
                    var self = this;
                    $(".webix_modal").one("click", function () {
                        self.hide();
                    });
                }
            },
            body: {
                view: "form",
                id: "dangkysudung",
                // width: 1500,
                position: "center",
                // autowidth:true,
                elementsConfig: { labelWidth: 150 },
                paddingY: 10,
                paddingX: 15,
                complexData: true,
                scroll: true,
                margin: 0,
                elements: [
                    thongtinchung,
                    thongtinnguoilienhe,
                    {
                        rows: [
                            {
                                cols: [
                                    {
                                        rows: [
                                            { view: "label", label: "<b>- Hình thức hóa đơn:</b>" },
                                            {
                                                view: "checkbox",
                                                id: "cma",
                                                name: "cma",
                                                labelRight: "Có mã của cơ quan thuế",
                                                labelWidth: 0,
                                                on: {
                                                    onChange: function (newv, oldv) {
                                                        // if (newv == 1) {
                                                        //     $$("cma").setValue(1);
                                                        //     $$("kcma").setValue(0);
                                                        //     $$("cbthop").disable();
                                                        //     $$("cdlttdcqt").disable();
                                                        //     $$("cdlqtvan").disable();
                                                        // }
                                                        // else {
                                                        //     $$("cbthop").enable();
                                                        //     $$("cdlttdcqt").enable();
                                                        //     $$("cdlqtvan").enable();
                                                        // }
                                                    }
                                                }
                                            },
                                            { view: "checkbox", id: "cmtmttien", name: "cmtmttien", labelRight: "Có mã của cơ quan thuế khởi tạo từ máy tính tiền", labelWidth: 0 },
                                            {
                                                view: "checkbox",
                                                id: "kcma",
                                                name: "kcma",
                                                // value: 1,
                                                labelRight: "Không có mã của cơ quan thuế",
                                                labelWidth: 0,
                                                on: {
                                                    onChange: function (newv, oldv) {
                                                        // if (newv == 1) {
                                                        //     $$("cma").setValue(0);
                                                        //     $$("kcma").setValue(1);
                                                        //     $$("nntdbkkhan").disable();
                                                        //     $$("nntktdnubnd").disable();
                                                        // }
                                                        // else {
                                                        //     $$("nntdbkkhan").enable();
                                                        //     $$("nntktdnubnd").enable();
                                                        // }
                                                    }
                                                }
                                            },
                                        ]
                                    },
                                    {
                                        rows: [
                                            { view: "label", label: "<b>- Phương thức chuyển dữ liệu:</b>" },
                                            {
                                                view: "checkbox",
                                                id: "cddu",
                                                name: "cddu",
                                                //value: 1,
                                                labelRight: "Chuyển đầy đủ thông tin hóa đơn",
                                                labelWidth: 0,
                                                on: {
                                                    onChange: function (newv, oldv) {
                                                        // if (newv == 1) {
                                                        //     $$("cddu").setValue(1);
                                                        //     $$("cbthop").setValue(0);
                                                        // }
                                                    }
                                                }
                                            },
                                            {
                                                view: "checkbox",
                                                id: "cbthop",
                                                name: "cbthop",
                                                labelRight: "Chuyển bảng tổng hợp dữ liệu điện tử",
                                                labelWidth: 0,
                                                on: {
                                                    onChange: function (newv, oldv) {
                                                        // if (newv == 1) {
                                                        //     $$("cddu").setValue(0);
                                                        //     $$("cbthop").setValue(1);
                                                        // }
                                                    }
                                                }
                                            },
                                        ]
                                    }
                                ]
                            },
                            { view: "label", label: "<b>- Hình thức gửi dữ liệu:</b>" },
                            {
                                cols: [
                                    {
                                        view: "checkbox",
                                        id: "cdlqtvan",
                                        name: "cdlqtvan",
                                        //value: 1,
                                        labelRight: "Chuyển dữ liệu qua tổ chức truyển nhận",
                                        labelWidth: 0,
                                        on: {
                                            onChange: function (newv, oldv) {
                                                if (newv == 1) {
                                                    $$("cdlqtvan").setValue(1);
                                                    $$("cdlttdcqt").setValue(0);
                                                    $$("nntdbkkhan").setValue(0);
                                                    $$("nntktdnubnd").setValue(0);
                                                }
                                            }
                                        }
                                    },
                                    {
                                        view: "checkbox",
                                        id: "nntdbkkhan",
                                        name: "nntdbkkhan",
                                        labelRight: "NNT địa bàn khó khăn",
                                        labelWidth: 0,
                                        on: {
                                            onChange: function (newv, oldv) {
                                                if (newv == 1) {
                                                    $$("nntdbkkhan").setValue(1);
                                                    $$("cdlttdcqt").setValue(0);
                                                    $$("cdlqtvan").setValue(0);
                                                    $$("nntktdnubnd").setValue(0);
                                                }
                                            }
                                        }
                                    }
                                ]

                            },
                            {
                                cols: [
                                    {
                                        view: "checkbox",
                                        id: "cdlttdcqt",
                                        name: "cdlttdcqt",
                                        labelRight: "Chuyển dữ liệu trực tiếp tới Cơ quan thuế",
                                        labelWidth: 0,
                                        on: {
                                            onChange: function (newv, oldv) {
                                                if (newv == 1) {
                                                    $$("cdlttdcqt").setValue(1);
                                                    $$("cdlqtvan").setValue(0);
                                                    $$("nntktdnubnd").setValue(0);
                                                    $$("nntdbkkhan").setValue(0);
                                                }
                                            }
                                        }
                                    },
                                    {
                                        view: "checkbox",
                                        id: "nntktdnubnd",
                                        name: "nntktdnubnd",
                                        labelRight: "NNT theo đề nghị UBND",
                                        labelWidth: 0,
                                        on: {
                                            onChange: function (newv, oldv) {
                                                if (newv == 1) {
                                                    $$("nntktdnubnd").setValue(1);
                                                    $$("cdlttdcqt").setValue(0);
                                                    $$("cdlqtvan").setValue(0);
                                                    $$("nntdbkkhan").setValue(0);
                                                }
                                            }
                                        }
                                    }
                                ]
                            },
                            { view: "label", label: "<b>- Loại hóa đơn sử dụng:</b>" },
                            {
                                cols: [
                                    {
                                        view: "checkbox",
                                        id: "hdgtgt",
                                        name: "hdgtgt",
                                        labelRight: "Hóa đơn giá trị gia tăng",
                                        //value: 1,
                                        labelWidth: 0
                                    },
                                    {
                                        view: "checkbox",
                                        id: "hdbhdtqgia",
                                        name: "hdbhdtqgia",
                                        labelRight: "Hóa đơn bán hàng dữ trữ quốc gia",
                                        labelWidth: 0
                                    }
                                ]
                            },
                            {
                                cols: [
                                    {
                                        view: "checkbox",
                                        id: "hdbhang",
                                        name: "hdbhang",
                                        labelRight: "Hóa đơn bán hàng",
                                        labelWidth: 0
                                    },
                                    {
                                        view: "checkbox",
                                        id: "hdkhac",
                                        name: "hdkhac",
                                        labelRight: "Các loại hóa đơn khác",
                                        labelWidth: 0
                                    }
                                ]
                            },
                            {
                                cols: [
                                    {
                                        view: "checkbox",
                                        id: "hdbtscong",
                                        name: "hdbtscong",
                                        labelRight: "Hóa đơn bán tài sản công",
                                        labelWidth: 0
                                    },
                                    {
                                        view: "checkbox",
                                        id: "ctu",
                                        name: "ctu",
                                        labelRight: "Các chứng từ được in, phát hành, sử dụng và quản lý như hóa đơn",
                                        labelWidth: 0
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        rows: [
                            {
                                view: "label", label: "- Danh sách chứng thư số sử dụng:", css: { "font-weight": "bold" }
                            },
                            {
                                cols: [
                                    {
                                        view: "button",
                                        type: "icon",
                                        icon: "mdi mdi-plus-box-outline",
                                        width: 123,
                                        label: "Thêm dòng (F9)",
                                        css: "btnForm",
                                        on: {
                                            onItemClick: function (id, e) {
                                                webix.ajax()
                                                    .headers({ 'Content-Type': 'application/json' })
                                                    .get(app.config.host + "/Pattern/GetSignType", function (text) {
                                                        var result = JSON.parse(text);
                                                        var kytaptrung = result.gia_tri;
                                                        switch (kytaptrung.toUpperCase()) {
                                                            case "FILE":
                                                                var box = webix.modalbox({
                                                                    title: "CHỌN CHỨNG THƯ SỐ",
                                                                    buttons: ["Nhận", "Hủy bỏ"],
                                                                    text: "<div id='ctnCerts'></div>",
                                                                    top: 100,
                                                                    width: 750,
                                                                    callback: function (result) {
                                                                        switch (result) {
                                                                            case "1":
                                                                                webix.modalbox.hide();
                                                                                break;
                                                                            case "0":
                                                                                var table = $$("tblCerts");
                                                                                var data = table.serialize();
                                                                                var cert = null;
                                                                                for (var i = 0; i < data.length; i++) {
                                                                                    if (data[i].chon == true) {
                                                                                        cert = data[i];
                                                                                        break;
                                                                                    }
                                                                                }
                                                                                if (cert == null) {
                                                                                    webix.message("Bạn chưa chọn chứng thư số");
                                                                                    return;
                                                                                }
                                                                                var table = webix.$$("danhsach_chukyso");
                                                                                var item = {
                                                                                    stt: table.count() + 1,
                                                                                    seri: cert.so_serial,
                                                                                    tngay: cert.ngaybatdau,
                                                                                    dngay: cert.ngayketthuc,
                                                                                    ttchuc: cert.issuer,
                                                                                    hthuc: 1
                                                                                };
                                                                                table.add(item);
                                                                                return;
                                                                        }
                                                                    }
                                                                });
                                                                var tblMatHang = webix.ui({
                                                                    container: "ctnCerts",
                                                                    id: "tblCerts",
                                                                    view: "datatable",
                                                                    borderless: true,
                                                                    resizeColumn: true,
                                                                    height: 350,
                                                                    columns: [
                                                                        {
                                                                            id: "chon", header: _("CHON"),
                                                                            width: 65, checkValue: true, uncheckValue: false, template: "{common.checkbox()}"
                                                                        },
                                                                        { id: "so_serial", header: _("SO_SERIAL"), width: 150 },
                                                                        { id: "subjectname", header: _("SUBJECTNAME"), width: 450 },
                                                                        { id: "ngaybatdau", header: _("NGAY_BAT_DAU"), width: 200 },
                                                                        { id: "ngayketthuc", header: _("NGAY_KET_THUC"), width: 200 },
                                                                        { id: "issuer", header: _("DONVI"), width: 450 }
                                                                    ],
                                                                    url: app.config.host + "/Invoice/GetListCertificatesFile"
                                                                });
                                                                break;
                                                            case "EASYCA":
                                                                var box = webix.modalbox({
                                                                    title: "Chọn chứng thư số EASYCA",
                                                                    buttons: ["Nhận", "Hủy bỏ"],
                                                                    text: "<div id='ctnCerts'></div>",
                                                                    top: 100,
                                                                    width: 750,
                                                                    callback: function (result) {
                                                                        switch (result) {
                                                                            case "1":
                                                                                webix.modalbox.hide();
                                                                                break;
                                                                            case "0":
                                                                                var table = $$("tblCerts");
                                                                                var data = table.serialize();
                                                                                var cert = null;
                                                                                for (var i = 0; i < data.length; i++) {
                                                                                    if (data[i].chon == true) {
                                                                                        cert = data[i];
                                                                                        break;
                                                                                    }
                                                                                }
                                                                                if (cert == null) {
                                                                                    webix.message("Bạn chưa chọn chứng thư số", "debug");
                                                                                    return;
                                                                                }
                                                                                var table = webix.$$("danhsach_chukyso");
                                                                                var item = {
                                                                                    stt: table.count() + 1,
                                                                                    seri: cert.so_serial,
                                                                                    tngay: cert.ngaybatdau,
                                                                                    dngay: cert.ngayketthuc,
                                                                                    ttchuc: cert.issuer,
                                                                                    hthuc: 1
                                                                                };
                                                                                table.add(item);
                                                                                return;
                                                                        }
                                                                    }
                                                                });
                                                                var popupText = document.getElementsByClassName("webix_popup_text")[0];
                                                                popupText.style.paddingTop = 0;
                                                                var tblMatHang = webix.ui({
                                                                    container: "ctnCerts",
                                                                    id: "tblCerts",
                                                                    view: "datatable",
                                                                    borderless: true,
                                                                    resizeColumn: true,
                                                                    height: 350,
                                                                    columns: [
                                                                        {
                                                                            id: "chon",
                                                                            header: _("CHON"),
                                                                            width: 65,
                                                                            checkValue: true,
                                                                            uncheckValue: false,
                                                                            template: "{common.checkbox()}"
                                                                        },
                                                                        { id: "libraryName", header: _("Loại"), width: 150 },
                                                                        { id: "so_serial", header: _("SO_SERIAL"), width: 150 },
                                                                        { id: "subjectname", header: _("SUBJECTNAME"), width: 450 },
                                                                        { id: "ngaybatdau", header: _("NGAY_BAT_DAU"), width: 200 },
                                                                        { id: "ngayketthuc", header: _("NGAY_KET_THUC"), width: 200 },
                                                                        { id: "issuer", header: _("DONVI"), width: 450 }
                                                                    ],
                                                                    url: app.config.host + "/Invoice/GetListCertificatesEasyCA"
                                                                });
                                                                break;
                                                            case "ICA":
                                                                var box = webix.modalbox({
                                                                    title: "Chọn chứng thư số ICA",
                                                                    buttons: ["Nhận", "Hủy bỏ"],
                                                                    text: "<div id='ctnCerts'></div>",
                                                                    top: 100,
                                                                    width: 750,
                                                                    callback: function (result) {
                                                                        switch (result) {
                                                                            case "1":
                                                                                webix.modalbox.hide();
                                                                                break;
                                                                            case "0":
                                                                                var table = $$("tblCerts");
                                                                                var data = table.serialize();
                                                                                var cert = null;
                                                                                for (var i = 0; i < data.length; i++) {
                                                                                    if (data[i].chon == true) {
                                                                                        cert = data[i];
                                                                                        break;
                                                                                    }
                                                                                }
                                                                                if (cert == null) {
                                                                                    webix.message("Bạn chưa chọn chứng thư số", "debug");
                                                                                    return;
                                                                                }
                                                                                var table = webix.$$("danhsach_chukyso");
                                                                                var item = {
                                                                                    stt: table.count() + 1,
                                                                                    seri: cert.so_serial,
                                                                                    tngay: cert.ngaybatdau,
                                                                                    dngay: cert.ngayketthuc,
                                                                                    ttchuc: cert.issuer,
                                                                                    hthuc: 1
                                                                                };
                                                                                table.add(item);
                                                                                return;
                                                                        }
                                                                    }
                                                                });
                                                                var popupText = document.getElementsByClassName("webix_popup_text")[0];
                                                                popupText.style.paddingTop = 0;
                                                                var tblMatHang = webix.ui({
                                                                    container: "ctnCerts",
                                                                    id: "tblCerts",
                                                                    view: "datatable",
                                                                    borderless: true,
                                                                    resizeColumn: true,
                                                                    height: 350,
                                                                    columns: [
                                                                        {
                                                                            id: "chon",
                                                                            header: _("CHON"),
                                                                            width: 65,
                                                                            checkValue: true,
                                                                            uncheckValue: false,
                                                                            template: "{common.checkbox()}"
                                                                        },
                                                                        { id: "libraryName", header: _("Loại"), width: 150 },
                                                                        { id: "so_serial", header: _("SO_SERIAL"), width: 150 },
                                                                        { id: "subjectname", header: _("SUBJECTNAME"), width: 450 },
                                                                        { id: "ngaybatdau", header: _("NGAY_BAT_DAU"), width: 200 },
                                                                        { id: "ngayketthuc", header: _("NGAY_KET_THUC"), width: 200 },
                                                                        { id: "issuer", header: _("DONVI"), width: 450 }
                                                                    ],
                                                                    url: app.config.host + "/Invoice/GetListCertificatesAuto"
                                                                });
                                                                break;
                                                            case "NCCA":
                                                                var box = webix.modalbox({
                                                                    title: "Chọn chứng thư số NCCA",
                                                                    buttons: ["Nhận", "Hủy bỏ"],
                                                                    text: "<div id='ctnCerts'></div>",
                                                                    top: 100,
                                                                    width: 750,
                                                                    callback: function (result) {
                                                                        switch (result) {
                                                                            case "1":
                                                                                webix.modalbox.hide();
                                                                                break;
                                                                            case "0":
                                                                                var table = $$("tblCerts");
                                                                                var data = table.serialize();
                                                                                var cert = null;
                                                                                for (var i = 0; i < data.length; i++) {
                                                                                    if (data[i].chon == true) {
                                                                                        cert = data[i];
                                                                                        break;
                                                                                    }
                                                                                }
                                                                                if (cert == null) {
                                                                                    webix.message("Bạn chưa chọn chứng thư số", "debug");
                                                                                    return;
                                                                                }
                                                                                var table = webix.$$("danhsach_chukyso");
                                                                                var item = {
                                                                                    stt: table.count() + 1,
                                                                                    seri: cert.so_serial,
                                                                                    tngay: cert.ngaybatdau,
                                                                                    dngay: cert.ngayketthuc,
                                                                                    ttchuc: cert.issuer,
                                                                                    hthuc: 1
                                                                                };
                                                                                table.add(item);
                                                                                return;
                                                                        }
                                                                    }
                                                                });
                                                                var popupText = document.getElementsByClassName("webix_popup_text")[0];
                                                                popupText.style.paddingTop = 0;
                                                                var tblMatHang = webix.ui({
                                                                    container: "ctnCerts",
                                                                    id: "tblCerts",
                                                                    view: "datatable",
                                                                    borderless: true,
                                                                    resizeColumn: true,
                                                                    height: 350,
                                                                    columns: [
                                                                        {
                                                                            id: "chon",
                                                                            header: _("CHON"),
                                                                            width: 65,
                                                                            checkValue: true,
                                                                            uncheckValue: false,
                                                                            template: "{common.checkbox()}"
                                                                        },
                                                                        { id: "libraryName", header: _("Loại"), width: 150 },
                                                                        { id: "so_serial", header: _("SO_SERIAL"), width: 150 },
                                                                        { id: "subjectname", header: _("SUBJECTNAME"), width: 450 },
                                                                        { id: "ngaybatdau", header: _("NGAY_BAT_DAU"), width: 200 },
                                                                        { id: "ngayketthuc", header: _("NGAY_KET_THUC"), width: 200 },
                                                                        { id: "issuer", header: _("DONVI"), width: 450 }
                                                                    ],
                                                                    url: app.config.host + "/Invoice/GetListCertificatesAuto"
                                                                });
                                                                break;
                                                            case "K":
                                                                var hub = minvoiceplugin.hub();
                                                                var hubconnect = minvoiceplugin.conn();
                                                                if (hubconnect.state != 1) {
                                                                    var form = webix.$$("chukyso-form");
                                                                    form.enable();
                                                                    form.hideProgress();
                                                                    webix.message("Quý khách hàng chưa cài Plugin ký hóa đơn hoặc Plugin ký hóa đơn chưa được bật !", "error");
                                                                    return;
                                                                }
                                                                else {
                                                                    hub.off("resCommand");
                                                                    hub.on("resCommand", function (response) {
                                                                        var result = JSON.parse(response);
                                                                        if (result.hasOwnProperty("error")) {
                                                                            webix.message(result.error, "error");
                                                                        } else {
                                                                            var table = webix.$$("danhsach_chukyso");
                                                                            var item = {
                                                                                stt: table.count() + 1,
                                                                                seri: result.data.so_serial,
                                                                                tngay: result.data.ngaybatdau,
                                                                                dngay: result.data.ngayketthuc,
                                                                                ttchuc: result.data.issuer,
                                                                                hthuc: 1
                                                                            };
                                                                            table.add(item);
                                                                        }
                                                                    });
                                                                    var f = {
                                                                        callback: "RegisterCert"
                                                                    };
                                                                    hub.invoke("execCommand", f.callback, JSON.stringify(f));
                                                                }
                                                                break;
                                                        }
                                                    });
                                            }
                                        }
                                    },
                                    {
                                        view: "button",
                                        type: "icon",
                                        icon: "mdi mdi-minus-box-outline",
                                        width: 115,
                                        label: "Xóa dòng (F8)",
                                        css: "btnForm",
                                        on: {
                                            onItemClick: function (id, e) {
                                                var table = webix.$$("danhsach_chukyso");
                                                table.editStop();
                                                var item = table.getSelectedItem();
                                                if (!webix.isUndefined(item)) {
                                                    table.remove(item.id);
                                                    table.clearSelection();
                                                    return;
                                                }
                                                var editor = table.getEditState();
                                                if (!webix.isUndefined(editor)) {
                                                    table.remove(editor.row);
                                                    table.clearSelection();
                                                    return;
                                                }
                                            },
                                        },
                                    },
                                    {}
                                ],
                            },
                            {
                                view: "datatable",
                                id: "danhsach_chukyso",
                                height: 250,
                                name: "danhsach_chukyso",
                                select: true,
                                resizeColumn: true,
                                footer: false,
                                tooltip: true,
                                editable: true,
                                scheme: {
                                    $init: function (obj) {

                                    },
                                },
                                on: {

                                },
                                columns: [
                                    {
                                        id: "stt", name: "stt", header: "STT", sort: "int", width: 40,
                                    },
                                    {
                                        id: "ttchuc", name: "ttchuc", header: "Tên tổ chức cơ quan chứng thực/cấp/công nhận chữ ký số, chữ ký điện tử", width: 450,
                                    },
                                    {
                                        id: "seri", name: "seri", header: "Số sê-ri chứng thư số", width: 300
                                    },
                                    {
                                        id: "tngay",
                                        name: "tngay",
                                        header: [
                                            {
                                                "text": "Thời hạn sử dụng chứng thư số",
                                                "colspan": 2
                                            },
                                            {
                                                "text": "Từ ngày"
                                            }
                                        ],
                                        width: 200
                                        //format: webix.i18n.dateFormatStr,
                                    },
                                    {
                                        id: "dngay",
                                        name: "dngay",
                                        header: [
                                            null,
                                            {
                                                "text": "Đến ngày"
                                            }
                                        ],
                                        width: 200
                                        //format: webix.i18n.dateFormatStr,
                                    },
                                    {
                                        id: "hthuc",
                                        name: "hthuc",
                                        header: "Hình thức đăng ký ( Thêm mới, Gia hạn, ngừng sử dụng)",
                                        fillspace: true,
                                        editor: "combo",
                                        options: [
                                            { id: "1", value: "Thêm mới" },
                                            { id: "2", value: "Gia hạn" },
                                            { id: "3", value: "Ngừng sử dụng" }
                                        ]
                                    },

                                ]
                            }
                        ]
                    },
                    // {
                    //     rows: [
                    //         {
                    //             view: "label", label: "- Thông tin ủy nhiệm lập hóa đơn (Chỉ nhập khi Ủy nhiệm xuất hóa đơn):"
                    //         },
                    //         {
                    //             cols: [
                    //                 {
                    //                     view: "button", type: "icon",
                    //                     //view: "icon",
                    //                     label: " (F9)",
                    //                     width: 60,
                    //                     // autowidth: true,
                    //                     icon: "fas fa-plus",
                    //                     on: {
                    //                         onItemClick: function (id, e) {
                    //                             var table = webix.$$("tbl_UyNhiem");
                    //                             var item = { id: webix.uid() };
                    //                             table.add(item);
                    //                             table.select(item.id, "tlhdon", false);
                    //                             table.edit({ row: item.id, column: "tlhdon" });
                    //                         },
                    //                     },
                    //                 },
                    //                 {
                    //                     view: "button",
                    //                     type: "icon",
                    //                     //view: "icon",
                    //                     // autowidth: true,
                    //                     label: " (F8)",
                    //                     width: 60,
                    //                     icon: "fas fa-minus",
                    //                     on: {
                    //                         onItemClick: function (id, e) {
                    //                             var table = webix.$$("tbl_UyNhiem");
                    //                             table.editStop();
                    //                             var item = table.getSelectedItem();
                    //                             if (!webix.isUndefined(item)) {
                    //                                 table.remove(item.id);
                    //                                 table.clearSelection();
                    //                                 return;
                    //                             }
                    //                             var editor = table.getEditState();
                    //                             if (!webix.isUndefined(editor)) {
                    //                                 table.remove(editor.row);
                    //                                 table.clearSelection();
                    //                                 return;
                    //                             }
                    //                         },
                    //                     },
                    //                 },
                    //                 {}
                    //             ],
                    //         },
                    //         {
                    //             view: "datatable",
                    //             id: "tbl_UyNhiem",
                    //             height: 250,
                    //             name: "tbl_UyNhiem",
                    //             editable: true,
                    //             select: "cell",
                    //             resizeColumn: true,
                    //             footer: false,
                    //             tooltip: true,
                    //             scheme: {
                    //                 $init: function (obj) {

                    //                 },
                    //             },
                    //             on: {
                    //                 "data->onStoreUpdated": function () {
                    //                     this.data.each(function (obj, i) {
                    //                         obj.stt = i + 1;
                    //                     })
                    //                 }
                    //             },
                    //             columns: [
                    //                 { id: "stt", name: "stt", header: "STT", sort: "int", editor: "text", editable: true, width: 40 },
                    //                 {
                    //                     id: "tlhdon",
                    //                     name: "tlhdon", editable: true,
                    //                     header: "Tên Loại hóa đơn",
                    //                     fillspace: true,
                    //                     editor: "combo",
                    //                     width: 200,
                    //                     options: [
                    //                         { id: "1", value: "Hóa đơn giá trị gia tăng" },
                    //                         { id: "2", value: "Hóa đơn bán hàng" },
                    //                         { id: "3", value: "Hóa đơn bán tài sản công" },
                    //                         { id: "4", value: "Hóa đơn bán hàng dự trữ quốc gia" },
                    //                         { id: "5", value: "Tem, vé, thẻ, phiếu thu điện tử, chứng từ điện tử khác có nội dung của hóa đơn điện tử" },
                    //                         { id: "6", value: "Phiếu xuất kho kiêm vận chuyển nội bộ điện tử, Phiếu xuất kho hàng gửi bán đại lý điện tử" }
                    //                     ]
                    //                 },
                    //                 { id: "khmshdon", name: "khmshdon", header: "Ký hiệu mẫu hóa đơn", editor: "text", width: 150, editable: true },
                    //                 { id: "khhdon", name: "khhdon", header: "Ký hiệu hóa đơn ủy nhiệm", editor: "text", width: 150, editable: true },
                    //                 { id: "mst", name: "mst", header: "Mã số thuế", width: 100, editor: "text", editable: true },
                    //                 { id: "ttchuc", name: "ttchuc", header: "Tên tổ chức", width: 150, editor: "text", editable: true },
                    //                 {
                    //                     id: "mdich", name: "mdich", header: "Mục đích", width: 150, editor: "text",
                    //                     editable: true
                    //                 },
                    //                 {
                    //                     id: "tngay", name: "tngay", header: "Đến ngày", width: 100, editor: "date",
                    //                     editable: true,
                    //                     // format: webix.Date.dateToStr("%d/%m/%Y"),
                    //                     format: function (text) {
                    //                         text = removeTimeZoneT(text);
                    //                         var format = webix.Date.dateToStr("%d/%m/%Y");
                    //                         return format(text);
                    //                     }
                    //                 },
                    //                 {
                    //                     id: "dngay", name: "dngay", header: "Đến ngày", width: 100, editor: "date",
                    //                     editable: true,
                    //                     // format: webix.Date.dateToStr("%d/%m/%Y")
                    //                     //format: webix.i18n.dateFormatStr,
                    //                     format: function (text) {
                    //                         text = removeTimeZoneT(text);
                    //                         var format = webix.Date.dateToStr("%d/%m/%Y");
                    //                         return format(text);
                    //                     }
                    //                 },
                    //                 {
                    //                     id: "pthuc",
                    //                     name: "pthuc", editable: true,
                    //                     header: "Phương thức",
                    //                     fillspace: true,
                    //                     editor: "combo",
                    //                     options: [
                    //                         { id: "1", value: "Đối trừ công nợ" },
                    //                         { id: "2", value: "Không thu tiền" },
                    //                         { id: "3", value: "Khác" },
                    //                         { id: "4", value: "Tiền mặt/ Chuyển khoản" }
                    //                     ]
                    //                 },
                    //                 {
                    //                     id: "thtttkhac", name: "thtttkhac", header: "Tên hình thức thanh toán khác", width: 190, editor: "text", editable: true
                    //                     //format: webix.i18n.dateFormatStr,
                    //                 }

                    //             ]
                    //         }
                    //     ]
                    // },
                    {
                        cols: [
                            {},
                            {
                                shortcut: "F10",
                                view: "button",
                                label: "Ghi (F10)",
                                id: "btnDKSDSave1",
                                width: 150,
                                align: "center",
                                type: "form",
                                on: {
                                    onClick: function () {
                                        var item = $$("dangkysudung").getValues();
                                        var table = $$("dangkysudung");

                                        var countMail = $$("dctdtu").getValue().split(/[\s,\;]+/);
                                        // console.log(countMail);
                                        if (countMail.length > 1) {
                                            webix.message("Bạn không được phép nhập quá 1 email", "debug");
                                            return;
                                        }

                                        if (table.validate()) {
                                            var cks = $$("danhsach_chukyso").serialize();
                                            if (cks.length == 0) {
                                                webix.message("Bạn chưa đăng ký chữ ký số cho thông báo phát hành !", "error");
                                                return;
                                            }
                                            webix.extend(table, webix.ProgressBar);
                                            table.disable();
                                            table.showProgress();

                                            var details = [];
                                            details.push({ tab_details: "mau01_chitiet", data: $$("danhsach_chukyso").serialize() });
                                            // details.push({ tab_details: "mau01_uyquyen", data: $$("tbl_UyNhiem").serialize() });
                                            item["mau01_chitiets"] = $$("danhsach_chukyso").serialize();

                                            var item1 = [];
                                            item1.push(item);
                                            var data_post = { tab_masters: "mau01", editmode: editmode, data: item1 };

                                            webix.ajax()
                                                .headers({ 'Content-type': 'application/json' })
                                                .post(app.config.host + "/Register68/Mau01SaveChange", item, {
                                                    error: function (text, data, XmlHttpRequest) {
                                                        table.enable();
                                                        table.hideProgress();
                                                    }, success: function (text, data, XmlHttpRequest) {
                                                        table.enable();
                                                        table.hideProgress();
                                                        var json = JSON.parse(text);
                                                        if (json.code != "00") {
                                                            webix.message(json.message, "error");
                                                        }
                                                        else {
                                                            app.callEvent("dataChangeDangkysudung68", [editmode, null]);
                                                            webix.message("Thành công !", "success");
                                                            webix.$$("dangkysudungForms").close();
                                                        }
                                                    }
                                                });
                                        }

                                    }
                                },
                                click: function () {
                                    this.callEvent("onClick");
                                }
                            },
                            {
                                view: "button",
                                hotkey: "esc",
                                label: "Hủy bỏ (ESC)",
                                width: 120,
                                type: "danger",
                                align: "center",
                                click: function () {
                                    webix.$$("dangkysudungForms").close();
                                }
                            },
                            {}
                        ]
                    }
                ]
                // rules: {
                //     begin_date: function (value) {
                //         if (value != "") {

                //             if (value.toString().length != 5)
                //                 return false;

                //             var patt = /^[0-1][1-2][/][0-9][0-9]$/;

                //             return patt.test(value);

                //         }
                //         return true;
                //     }
                // }
            }
        },
        setEditMode: function (mode) {
            editmode = mode;
            var form = $$(this.$ui.id);
            //var topParentView = form.getTopParentView();
            form.config.editmode = mode;
            var icon = "";
            if (editmode == 1) {
                icon = "<span><i class='fa fa-plus' aria-hidden='true'></i></span>";
                var result = webix.ajax().sync().get(app.config.host + "/System/GetCurrentDmdvcs");
                var json = JSON.parse(result.response);

                $$("dclhe").setValue(json[0].dia_chi);
                $$("tnnt").setValue(json[0].ten_dvcs);
                $$("mst").setValue(json[0].ms_thue);
                $$("dtlhe").setValue(json[0].dien_thoai);
                $$("dctdtu").setValue(json[0].email);
                $$("nlhe").setValue(json[0].nguoi_dai_dien);
                $$("cqtqly").setValue(json[0].ten);
                $$("mcqtqly").setValue(json[0].mcqthue);
                $$("ddanh").setValue(json[0].tinh_thanh);
            }
            else {
                if (editmode == 2)
                    icon = "<i class='fa fa-edit' aria-hidden='true'></i>";
                else
                    icon = "<i class='fa fa-trash fa-lg' aria-hidden='true'></i>";
            }

            webix.$$("head-icondksd").setHTML(icon);
            webix.$$("head-icondksd").refresh();
        },
        setValues: function (item, winconfig, params) {
            var win = $$(this.$ui.id);
            var form = win.getChildViews()[1];

            item["nlap"] = removeTimeZoneT(item["nlap"]);
            form.setValues(item);

            // if (editmode == 2) {

            // }

            var tableDetail = webix.$$("danhsach_chukyso");
            var url = app.config.host + "/Register68/GetMau01Detail?id=" + item.id;
            tableDetail.clearAll();
            tableDetail.load(url);

            // var tableUyNhiem = webix.$$("tbl_UyNhiem");
            // var url = app.config.host + "/Register68/GetMau01UyQuyen?id=" + item.id;
            // tableUyNhiem.clearAll();
            // tableUyNhiem.load(url);

        },
        // $oninit: function (view, $scope) {
        //     var url = app.config.host + "/Invoice68/getDangkysudung";

        //     webix.ajax(url, function (text) {
        //         var json = JSON.parse(text);

        //         $$("dangkysudung").setValues(json);
        //         $$("danhsach_chukyso").parse(json["data"]);
        //     });
        // }
    };
});
define('views/forms/forms68/EasyCA/signEasyCA',["app"], function (app) {
    var editmode = 0;
    var item;
    var type_sign;
    function initUI(obj, type) {
        item = obj;
        type_sign = type;
    }
    return {
        $ui: {
            view: "window",
            modal: true,
            id: "signEasyCA68",
            css: "signEasyCA",
            position: "center",
            move: true,
            head: false,
            minWidth: 350,
            // height: 100,
            body: {
                view: "form",
                id: "signEasyCA68-frm",
                elementsConfig: {
                    labelWidth: 60
                },
                elements: [
                    {
                        view: "text", type: "password", name: "pin", id: "pin", label: "Mã pin", required: true,
                        invalidMessage: "Bạn phải nhập mã pin"
                    },
                    {
                        cols: [
                            {},
                            {
                                shortcut: "F10", view: "button", label: "Nhận (F10)", type: "form", align: "center", width: 80,
                                on: {
                                    onClick: function () {
                                        if ($$("signEasyCA68-frm").validate()) {
                                            var form = $$("signEasyCA68");
                                            var param = {
                                                username: item.username,
                                                password: item.pass,
                                                so_serial: item.so_serial,
                                                pin: $$("pin").getValue(),
                                                id: item.id,
                                                tagSign: item.tagSign,
                                                tagSignId: item.tagSignId
                                            };

                                            var apiHost = app.config.host;
                                            switch (type_sign) {
                                                case "dangky":
                                                    apiHost += "/Register68/SignEasyCA";
                                                    break;
                                                case "invoiceCma":
                                                    apiHost += "/Invoice68/SignEasyCA";
                                                    param.type = 1;
                                                    break;
                                                case "invoiceKma":
                                                    apiHost += "/Invoice68/SignEasyCA";
                                                    param.type = 1;
                                                    break;
                                                case "invoiceSign":
                                                    apiHost += "/Invoice68/SignEasyCA";
                                                    param.type = 2;
                                                    break;
                                                case "cancelInvoice":
                                                    apiHost += "/CancelInvoice/SignCancelInvoiceEasyCA";
                                                    break;
                                            };
                                            
                                            webix.extend(form, webix.ProgressBar);
                                            form.disable();
                                            form.showProgress();
                                            webix.ajax()
                                                .headers({ 'Content-type': 'application/json' })
                                                .post(apiHost, param, {
                                                    error: function (text, data, XmlHttpRequest) {
                                                        form.enable();
                                                        form.hideProgress();
                                                        webix.message(text);
                                                    },
                                                    success: function (text, data, XmlHttpRequest) {
                                                        var response = JSON.parse(text);
                                                        if (response.code == "00") {
                                                            form.enable();
                                                            form.hideProgress();
                                                            switch (type_sign) {
                                                                case "cancelInvoice":
                                                                    app.callEvent("dataChangedMau0405", [1, null]);
                                                                    break;
                                                                case "dangky":
                                                                    app.callEvent("dataChangeDangkysudung68", [1, null]);
                                                                    break;
                                                                default:
                                                                    app.callEvent("dataChangedMau0405", [1, null]);
                                                                    break;
                                                            }
                                                            $$("btnCancel").callEvent("onClick");
                                                            webix.message("Ký thành công !", "success");
                                                        }
                                                        else {
                                                            form.enable();
                                                            form.hideProgress();
                                                            webix.message(response.message, "error");
                                                        }

                                                    }
                                                });
                                        }
                                    }
                                },
                                click: function () {
                                    this.callEvent("onClick");

                                }
                            },
                            {
                                view: "button", id: "btnCancel", shortcut: "esc", label: "Hủy (ESC)", type: "danger", align: "center",
                                width: 80,
                                on: {
                                    onClick: function () {
                                        $$("signEasyCA68").close();
                                    }
                                },
                                click: function () {
                                    this.callEvent("onClick");
                                }
                            },
                            {}
                        ]
                    }
                ]
            }
        },
        setEditMode: function (mode) {
            editmode = mode;
        },
        initUI: initUI
    };

});
define('views/forms/forms68/EXCEL/68_importExcel',["app", "locale"], function (app, _) {
    return {
        $ui: {
            view: "window", modal: true, id: "uploadfile-win78", position: "center",
            head: "Nhận dữ liệu từ file Excel",
            width: 500,
            height: 500,
            body: {
                paddingY: 10,
                paddingX: 10,
                elementsConfig: { labelWidth: 100 },
                view: "form",
                id: "uploadfile-form78",
                complexData: true,
                elements: [
                    {
                        cols: [
                            {
                                view: "toolbar",
                                css: { "background": "#e6f7ff !important" },
                                rows: [
                                    // { gravity: 2 },
                                    {
                                        view: "button", type: "icon", css: "btnExcel", icon: "fas fa-folder-open", label: "Chọn file", width: 110,
                                        on: {
                                            onClick: function () {
                                                webix.$$("uploader").fileDialog();
                                            }
                                        },
                                        click: function () {
                                            this.callEvent("onClick");
                                        }
                                    },
                                    {
                                        view: "button", type: "icon", css: { "background-color": "#e6f7ff !important" }, icon: "fas fa-download", label: "Tải file mẫu", width: 110,
                                        on: {
                                            onClick: function () {
                                                var uploader = webix.$$("uploader");
                                                var formData = uploader.config.formData;
                                                //console.log(formData);
                                                var table = $$("uploadfile-win78");

                                                webix.extend(table, webix.ProgressBar);
                                                table.disable();
                                                table.showProgress();
                                                webix.ajax()
                                                    .response("arraybuffer")
                                                    .headers({ 'Content-type': 'application/json' })
                                                    .get(app.config.host + "/Pattern/DownloadFileExcelTemplate?id=" + formData["excel_id"],
                                                        {
                                                            error: function (text, data, XmlHttpRequest) {
                                                                table.enable();
                                                                table.hideProgress();
                                                            },
                                                            success: function (text, data, XmlHttpRequest) {

                                                                webix.delay(function () {
                                                                    var file = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                                                                    var fileURL = URL.createObjectURL(file);

                                                                    var link = document.createElement('a');
                                                                    document.body.appendChild(link);
                                                                    link.download = "InvoiceTemplate.xlsx";
                                                                    link.href = fileURL;
                                                                    link.click();
                                                                    document.body.removeChild(link); // remove the link when done
                                                                    //document.location.href = fileURL;
                                                                }, null, null, 500);

                                                                table.enable();
                                                                table.hideProgress();
                                                                // })
                                                            }
                                                        }
                                                    );
                                            }
                                        },
                                        click: function () {
                                            this.callEvent("onClick");
                                        }
                                    },
                                    {
                                        shortcut: "F10", view: "button", css: { "background": "#e6f7ff !important" }, type: "icon", icon: "fas fa-check", label: "Nhận file (F10)", width: 120, on: {
                                            onClick: function () {
                                                var table = $$("uploadfile-win78");
                                                webix.extend(table, webix.ProgressBar);
                                                table.disable();
                                                table.showProgress();
                                                var file = $$("uploader").files.getFirstId();
                                                if (file == undefined || file == null) {
                                                    webix.message("Bạn chưa chọn file !", "error");
                                                    $$("uploadfile-win78").enable();
                                                    $$("uploadfile-win78").hideProgress();
                                                    return;
                                                }

                                                $$("uploader").send(function (response) {

                                                    if (response != undefined) {
                                                        if (response.code == "00") {
                                                            $$("uploadfile-win78").enable();
                                                            $$("uploadfile-win78").hideProgress();
                                                            //this.callEvent("onUploadComplete");
                                                            // success call event onUploadComplete ở trên 
                                                            var topParentView = this.getTopParentView();

                                                            if (topParentView.config.tableId !== undefined) {
                                                                var table = $$(topParentView.config.tableId);

                                                                if (table != null) {
                                                                    table.clearAll();
                                                                    table.load(table.config.url);
                                                                }
                                                            }

                                                            webix.alert({
                                                                title: "Thành công !",
                                                                text: "Nhận dữ liệu Excel thành công !",
                                                                type: "alert-warning",
                                                                callback: function (result) {
                                                                    webix.$$("uploadfile-win78").close();
                                                                }
                                                            });
                                                        }
                                                        else {
                                                            $$("uploadfile-win78").enable();
                                                            $$("uploadfile-win78").hideProgress();

                                                            webix.alert({
                                                                title: "Lỗi !",
                                                                text: response.message,
                                                                type: "alert-error"
                                                            });
                                                        }
                                                    }
                                                    else {
                                                        $$("uploadfile-win78").enable();
                                                        $$("uploadfile-win78").hideProgress();
                                                    }
                                                });
                                            }
                                        },
                                        click: function () {
                                            this.callEvent("onClick");
                                        }
                                    },
                                    {
                                        hotkey: "esc", view: "button", css: { "background": "#e6f7ff !important" }, type: "icon", icon: "fas fa-times", label: "Hủy bỏ (ESC)", width: 110,
                                        on: {
                                            onClick: function () {
                                                $$("mylist").clearAll();
                                                $$("mylist").unbind();
                                                var id = $$("uploader").files.getFirstId();
                                                if (id != undefined) {
                                                    $$("uploader").stopUpload(id);
                                                }
                                                webix.$$("uploadfile-win78").close();
                                            }
                                        },
                                        click: function () {
                                            this.callEvent("onClick");
                                        }
                                    }

                                ]
                            },
                            {
                                rows: [
                                    {
                                        id: "uploader",
                                        view: "uploader",
                                        value: 'Chọn file',
                                        hide: true,
                                        name: "uploader",
                                        accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                                        link: "mylist",
                                        autosend: false,
                                        multiple: false,
                                        upload: app.config.host + "/Pattern/UploadExcel",
                                        on: {
                                            onAfterRender: function () {
                                                this.hide();
                                            },
                                            onAfterFileAdd: function (file) {
                                                $$("mylist").refresh();
                                            },
                                            onUploadComplete: function (response) {

                                            },
                                            onFileUploadError: function (file, response) {
                                                console.log(file);
                                                console.log(response);
                                                $$("uploadfile-win78").enable();
                                                $$("uploadfile-win78").hideProgress();
                                            }
                                        },
                                        apiOnly: true,
                                    },
                                    {
                                        view: "list",
                                        id: "mylist",
                                        type: "uploader",
                                        height: 100,
                                        borderless: true
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        }
    };
});
define('views/forms/forms68/ICA/changePassICA',["app"], function (app) {
    var chukyso_id;

    return {
        $ui: {
            view: "window", modal: true, id: "changePass-win", position: "center", move: true,
            head: "Đổi mật khẩu chữ ký số",
            body: {
                paddingY: 10,
                paddingX: 10,
                //elementsConfig:{labelWidth: 120}, 
                view: "form",
                id: "changePass-form",
                complexData: true,
                elements: [
                    { view: "text", name: "oldpass", required: true, invalidMessage: "Mã pin cũ không được bỏ trống", type: "password", label: "Mã pin cũ", labelPosition: "top" },
                    {
                        view: "text", name: "newpass", required: true,
                        invalidMessage: "Mã pin mới không được bỏ trống",
                        type: "password", label: "Mã pin mới (chỉ nhập số)", labelPosition: "top",
                        attributes: { maxlength: 14 }, tooltip:"Mã pin có độ dài 8-14 ký tự, chỉ được nhập số"
                    },
                    { view: "text", name: "confirmpass", required: true, invalidMessage: "Xác nhận mã pin không được bỏ trống", type: "password", label: "Xác nhận mã pin mới (chỉ nhập số)", labelPosition: "top" },
                    {
                        margin: 10,
                        cols: [
                            {},
                            {
                                view: "button", label: "Nhận (F10)", hotkey: "F10", type: "form", align: "center", width: 120, click: function () {
                                    var form = webix.$$("changePass-form");
                                    if (form.validate() == false) {
                                        return;
                                    }
                                    var item = form.getValues();
                                    if (item.newpass.length < 8) {
                                        webix.message("Mã pin phải có độ dài >= 8 ký tự", "error");
                                        return;
                                    }
                                    if (item.newpass.length > 14) {
                                        webix.message("Mã pin phải có độ dài <= 14 ký tự", "error");
                                        return;
                                    }
                                    if (item.newpass != item.confirmpass) {
                                        webix.message("Mã pin mới không giống nhau", "error");
                                        return;
                                    }
                                    item.chukyso_id = chukyso_id;
                                    webix.ajax()
                                        .post(app.config.host + "/TokenCloud/IcaChangePass", item, function (text) {
                                            var response = JSON.parse(text);
                                            if (response.code == "00") {
                                                webix.$$("changePass-win").close();
                                                webix.message("Đổi mã pin thành công !", "success");
                                            }
                                            else {
                                                webix.message(response.message, "error");
                                            }
                                        });
                                }
                            },
                            {
                                view: "button", label: "Hủy bỏ (ESC)", hotkey: "esc", type: "danger", align: "center", width: 120, click: function () {
                                    webix.$$("changePass-win").close();
                                }
                            },
                            {}
                        ]
                    }
                ]
            }
        },
        initUI: function (cks_id) {
            chukyso_id = cks_id;
            $$("changePass-win").getHead().setHTML("Đổi mật khẩu chữ ký số: " + cks_id);
        }
    };
});
define('views/forms/forms68/ICA/signICA',["app"], function (app) {
    var item;
    var type_sign;
    var dataInvoice;
    function initUI(obj, type) {
        item = obj;
        type_sign = type;
    }
    return {
        $ui: {
            view: "window",
            modal: true,
            id: "signICA",
            css: "signEasyCA",
            position: "center",
            move: true,
            head: false,
            minWidth: 350,
            body: {
                view: "form",
                id: "signICA-frm",
                elementsConfig: {
                    labelWidth: 60
                },
                elements: [
                    {
                        view: "text", type: "password", name: "pin", id: "pin", label: "Mã pin", required: true,
                        invalidMessage: "Bạn phải nhập mã pin"
                    },
                    {
                        cols: [
                            {},
                            {
                                shortcut: "F10", view: "button", label: "Nhận (F10)", type: "form", align: "center", width: 80,
                                on: {
                                    onClick: function () {
                                        if ($$("signICA-frm").validate()) {
                                            var form = $$("signICA");
                                            var param = {
                                                so_serial: item.so_serial,
                                                pinCode: $$("pin").getValue(),
                                                id: item.id,
                                                agreementUUID: item.value
                                            };
                                            var apiHost = app.config.host;
                                            switch (type_sign) {
                                                case "dangky":
                                                    apiHost += "/Register68/SignByIca";
                                                    break;
                                                case "dangky70":
                                                    apiHost += "/Register70/SignByIca";
                                                    break;
                                                case "bienban":
                                                    apiHost += "/Bienban70/SignByIca";
                                                    break;
                                                case "invoiceCma":
                                                    apiHost += "/TokenCloud/IcaSignInvoice";
                                                    break;
                                                case "invoiceKma":
                                                    apiHost += "/TokenCloud/IcaSignInvoice";
                                                    break;
                                                case "invoiceSignNotSend":
                                                    apiHost += "/TokenCloud/IcaSignInvoiceNotSend";
                                                    break;
                                                case "invoiceSign":
                                                    apiHost += "/TokenCloud/IcaSignInvoice";
                                                    break;
                                                case "invoiceSignMulti":
                                                    param = {
                                                        so_serial: item.so_serial,
                                                        pinCode: $$("pin").getValue(),
                                                        agreementUUID: item.value,
                                                        data: dataInvoice
                                                    };
                                                    apiHost += "/TokenCloud/IcaSignInvoiceMulti";
                                                    break;
                                                case "invoiceSignMultiNotSend":
                                                    param = {
                                                        so_serial: item.so_serial,
                                                        pinCode: $$("pin").getValue(),
                                                        agreementUUID: item.value,
                                                        data: dataInvoice
                                                    };
                                                    apiHost += "/TokenCloud/IcaSignInvoiceMultiNotSend";
                                                    break;
                                                case "cancelInvoice":
                                                    apiHost += "/CancelInvoice/SignCancelInvoiceIca";
                                                    break;
                                            };

                                            webix.extend(form, webix.ProgressBar);
                                            form.disable();
                                            form.showProgress();

                                            webix.ajax()
                                                .headers({ 'Content-type': 'application/json' })
                                                .post(apiHost, param, {
                                                    error: function (text, data, XmlHttpRequest) {
                                                        form.enable();
                                                        form.hideProgress();
                                                    },
                                                    success: function (text, data, XmlHttpRequest) {
                                                        var response = JSON.parse(text);
                                                        if (response.code == "00") {
                                                            form.enable();
                                                            form.hideProgress();
                                                            var message = "Ký thành công hóa đơn";
                                                            switch (type_sign) {
                                                                case "cancelInvoice":
                                                                    app.callEvent("dataChangedMau0405", [1, null]);
                                                                    message = "Ký thành công thông báo hủy hóa đơn 04/SS-HDDT";
                                                                    break;
                                                                case "dangky":
                                                                    app.callEvent("dataChangeDangkysudung68", [1, null]);
                                                                    message = "Ký thành công mẫu đăng ký sử dụng/ thay đổi HDDT";
                                                                    break;
                                                                case "invoiceSignMulti":
                                                                    app.callEvent("dataChangedInvoie68", [1, null]);
                                                                    message = "Ký hóa đơn theo lô thành công";
                                                                    var tableHD = webix.$$("tblHoadon");
                                                                    tableHD.clearAll();
                                                                    break;
                                                                default:
                                                                    app.callEvent("dataChangedInvoie68", [1, null]);
                                                                    break;
                                                            }
                                                            $$("btnCancel").callEvent("onClick");
                                                            webix.message(message, "success");
                                                        }
                                                        else {
                                                            form.enable();
                                                            form.hideProgress();
                                                            webix.message(response.message, "error");
                                                        }
                                                    }
                                                });
                                        }
                                    }
                                },
                                click: function () {
                                    this.callEvent("onClick");
                                }
                            },
                            {
                                view: "button", id: "btnCancel", shortcut: "esc", label: "Hủy (ESC)", type: "danger", align: "center",
                                width: 80,
                                on: {
                                    onClick: function () {
                                        $$("signICA").close();
                                    }
                                },
                                click: function () {
                                    this.callEvent("onClick");
                                }
                            },
                            {}
                        ]
                    }
                ]
            }
        },
        setEditMode: function (mode) {
            editmode = mode;
        },
        initUI: initUI,
        initUIMulti: function (obj, invoice, type) {
            item = obj;
            dataInvoice = invoice;
            type_sign = type;
        }
    };

});
define('views/forms/forms68/ICA/signInvoiceICA',["app"], function (app) {
    var item;
    var type_sign;
    var dataInvoice;
    var type_sinhsosau;
    function initUI(obj, type) {
        item = obj;
        type_sign = type;
    }
    function loadingStatus(current, code, message) {
        if (code == "00")
            webix.message(`Ký hóa đơn số: ${current}`, "debug");
        else
            webix.message(`Lỗi ký hóa đơn số: ${current} ${message}`, "error");
    };
    return {
        $ui: {
            view: "window",
            modal: true,
            id: "signInvoiceICA",
            css: "signEasyCA",
            position: "center",
            move: true,
            head: false,
            minWidth: 350,
            body: {
                view: "form",
                id: "signInvoiceICA-frm",
                elementsConfig: {
                    labelWidth: 60
                },
                elements: [
                    {
                        view: "text", type: "password", name: "pin", id: "pin", label: "Mã pin", required: true,
                        invalidMessage: "Bạn phải nhập mã pin"
                    },
                    {
                        cols: [
                            {},
                            {
                                shortcut: "F10", view: "button", label: "Nhận (F10)", type: "form", align: "center", width: 80,
                                on: {
                                    onClick: function () {
                                        if ($$("signInvoiceICA-frm").validate()) {
                                            var form = $$("signInvoiceICA");
                                            var apiHost = app.config.host;
                                            switch (type_sign) {
                                                case "invoiceSignMulti":
                                                    apiHost += "/TokenCloud/IcaSignInvoiceMulti";
                                                    break;
                                                case "invoiceSignMultiNotSend":
                                                    apiHost += "/TokenCloud/IcaSignInvoiceMultiNotSend";
                                                    break;
                                            };
                                            var promiseData = [];
                                            if (type_sinhsosau == "true") {
                                                webix.extend(form, webix.ProgressBar);
                                                form.disable();
                                                form.showProgress();

                                                var param = {
                                                    so_serial: item.so_serial,
                                                    pinCode: $$("pin").getValue(),
                                                    agreementUUID: item.value,
                                                    data: dataInvoice
                                                };
                                                webix.ajax().headers({ 'Content-type': 'application/json' })
                                                    .post(apiHost, param, {
                                                        error: function (text, data, XmlHttpRequest) {
                                                            form.enable();
                                                            form.hideProgress();
                                                            webix.message(text);
                                                        },
                                                        success: function (text, data, XmlHttpRequest) {
                                                            var response = JSON.parse(text);
                                                            form.enable();
                                                            form.hideProgress();
                                                            var tableHD = webix.$$("tblHoadon");
                                                            tableHD.clearAll();
                                                            $$("signInvoiceICA").close();
                                                            if (response.code == "00") {
                                                                app.callEvent("dataChangedInvoie68", [1, null]);
                                                                webix.message("Kết thúc quá trình", "success");
                                                            }
                                                            else
                                                                webix.message(response.message, "error");
                                                        }
                                                    });
                                            }
                                            else {
                                                var size = 5;
                                                for (var i = 0; i < dataInvoice.length; i += size) {
                                                    var invoice = dataInvoice.slice(i, i + size);
                                                    var input = {
                                                        so_serial: item.so_serial,
                                                        pinCode: $$("pin").getValue(),
                                                        agreementUUID: item.value,
                                                        data: invoice
                                                    };
                                                    var objPromise = webix.ajax().headers({ "Content-Type": "application/json", }).post(apiHost, input);
                                                    promiseData.push(objPromise);
                                                }
                                                webix.extend(form, webix.ProgressBar);
                                                form.disable();
                                                form.showProgress();

                                                (async () => {
                                                    const promises = promiseData.map((item) => item.then((obj) => {
                                                        if (obj.json().data != null)
                                                            loadingStatus(obj.json().data["shdon"], obj.json().code, obj.json().message);
                                                        else
                                                            loadingStatus(null, obj.json().code, obj.json().message);
                                                    }));
                                                    await Promise.all(promises);
                                                    var tableHD = webix.$$("tblHoadon");
                                                    tableHD.clearAll();
                                                    form.enable();
                                                    form.hideProgress();
                                                    webix.message(`Kết thúc`, "success", 3000);
                                                    $$("btnCancel").callEvent("onClick");
                                                    app.callEvent("dataChangedInvoie68", [1, null]);
                                                })();
                                            }
                                            return;

                                        }
                                    }
                                },
                                click: function () {
                                    this.callEvent("onClick");
                                }
                            },
                            {
                                view: "button", id: "btnCancel", shortcut: "esc", label: "Hủy (ESC)", type: "danger", align: "center",
                                width: 80,
                                on: {
                                    onClick: function () {
                                        $$("signInvoiceICA").close();
                                    }
                                },
                                click: function () {
                                    this.callEvent("onClick");
                                }
                            },
                            {}
                        ]
                    }
                ]
            }
        },
        setEditMode: function (mode) {
            editmode = mode;
        },
        initUI: initUI,
        initUIMulti: function (obj, invoice, type, sinhsosau) {
            item = obj;
            dataInvoice = invoice;
            type_sign = type;
            type_sinhsosau = sinhsosau;
        }
    };

});
define('views/forms/forms68/Mau04/68_mau04Form',["app", "models/user", "views/forms/forms68/Mau04/68_mau04FormList",
    "views/modules/Component/functionExtension"], function (app, user, mau04List, functionExtension) {
        var editmode = 0;
        var formId = "mau04-form";
        var tblId = "danhsach_hoadon";
        var eventChanged = "dataChangedMau0405";
        var button = [
            {},
            {
                shortcut: "F10", view: "button", label: "Lưu tạm (F10)", id: "btnBTHSave", type: "form", align: "center", width: 120,
                on: {
                    onClick: function () {
                        var item = $$(formId).getValues();
                        var tableHoadon = $$(formId);

                        if (tableHoadon.validate()) {
                            var ds_hdon = $$(tblId).serialize();
                            if (ds_hdon.length == 0) {
                                webix.message("Bạn chưa nhập chi tiết", "error");
                                return;
                            }
                            else {
                                if ($$(tblId).validate()) {
                                    var i = 0;
                                    var countLD = 0;

                                    webix.confirm({
                                        title: "04SS-HDDT",
                                        text: "Bạn có chắc chắn muốn lưu dữ liệu?", ok: "Có", cancel: "Không",
                                        callback: function (res) {
                                            if (res) {
                                                // if (editmode == 1) {
                                                ds_hdon.forEach(function (entry, count) {
                                                    var khieu = entry["khieu"];
                                                    var loaiapdung = entry["ladhddt"];
                                                    var tinhchat_tb = entry["tctbao"];
                                                    var tthdon = entry["tthdon"];
                                                    var is_tthdon = entry["is_tthdon"];
                                                    // if (loaiapdung == 1 && (tinhchat_tb == 2 || tinhchat_tb == 3)) {
                                                    //     webix.message("Không được tạo 04SS-HDDT khi thực hiện điều chỉnh/thay thế cho hóa đơn điện tử NĐ123. Dòng lỗi: " + (Number(count) + 1), "error");
                                                    //     i++;
                                                    //     return;
                                                    // }
                                                    // if (tinhchat_tb == 2 && loaiapdung != 1) {
                                                    //     webix.message("Không được tạo 04SS-HDDT khi điều chỉnh cho hóa đơn NĐ 51. Dòng lỗi: " + (Number(count) + 1), "error");
                                                    //     i++;
                                                    //     return;
                                                    // }
                                                    // if (tinhchat_tb == 3 && loaiapdung != 1) {
                                                    //     webix.message("Không được tạo 04SS-HDDT khi thay thế cho hóa đơn NĐ 51. Dòng lỗi: " + (Number(count) + 1), "error");
                                                    //     i++;
                                                    //     return;
                                                    // }
                                                    if (tinhchat_tb == 1) {
                                                        if (is_tthdon == 6 || is_tthdon == 7 || is_tthdon == 2) {
                                                            webix.message("Tính chất thông báo là Hủy chỉ áp dụng cho hóa đơn Mới hoặc Thay thế. Dòng lỗi: " + (Number(count) + 1), "error");
                                                            i++;
                                                            return;
                                                        }
                                                    }

                                                    if (tinhchat_tb == 3 && is_tthdon != undefined && is_tthdon != null) {
                                                        if (is_tthdon != 6) {
                                                            webix.message("Tính chất thông báo là Thay thế chỉ áp dụng cho hóa đơn Bị thay thế. Dòng lỗi: " + (Number(count) + 1), "error");
                                                            i++;
                                                            return;
                                                        }
                                                    }
                                                    if (tinhchat_tb == 3 && loaiapdung == 1) {
                                                        if (is_tthdon != 6) {
                                                            webix.message("Tính chất thông báo là Thay thế chỉ áp dụng cho hóa đơn Bị thay thế. Dòng lỗi: " + (Number(count) + 1), "error");
                                                            i++;
                                                            return;
                                                        }
                                                    }
                                                    if (tinhchat_tb == 2 && loaiapdung == 1) {
                                                        if (is_tthdon != 7) {
                                                            webix.message("Tính chất thông báo là Điều chỉnh chỉ áp dụng cho hóa đơn Bị điều chỉnh. Dòng lỗi: " + (Number(count) + 1), "error");
                                                            i++;
                                                            return;
                                                        }
                                                    }

                                                    if (loaiapdung != 3 && loaiapdung != 4) {
                                                        var otpCheck = khieu.toString();
                                                        if (otpCheck.substring(1, 2) == "C") {
                                                            if (entry["macqt"] == null || entry["macqt"] == "") {
                                                                webix.message("Mã cơ quan thuế không được để trống tại dòng " + (Number(count) + 1), "error");
                                                                i++;
                                                                return;
                                                            }
                                                        }
                                                        if (entry["ldo"] == null || entry["ldo"] == "") {
                                                            webix.message("Lý do không được để trống tại dòng " + (Number(count) + 1), "error");
                                                            countLD++;
                                                            return;
                                                        }
                                                    }
                                                });
                                                if (i > 0) {
                                                    return;
                                                }
                                                if (countLD > 0) {
                                                    return;
                                                }
                                                // }
                                                item["mau04_chitiets"] = ds_hdon;
                                                webix.extend(tableHoadon, webix.ProgressBar);
                                                tableHoadon.disable();
                                                tableHoadon.showProgress();
                                                webix.ajax()
                                                    .headers({ 'Content-type': 'application/json' })
                                                    .post(app.config.host + "/CancelInvoice/Mau04SaveChange", item, {
                                                        error: function (text, data, XmlHttpRequest) {
                                                            tableHoadon.enable();
                                                            tableHoadon.hideProgress();
                                                            webix.message(text, "error");

                                                        }, success: function (text, data, XmlHttpRequest) {
                                                            var response = JSON.parse(text);
                                                            tableHoadon.enable();
                                                            tableHoadon.hideProgress();
                                                            if (response.code == "00") {
                                                                webix.$$("mau04-win").close();
                                                                app.callEvent(eventChanged, [1, null]);
                                                                webix.message("Tạo thông báo 04/SS-HDDT thành công", "success");
                                                                functionExtension.Sign04SS(response.data, $$("frmView"));
                                                            }
                                                            else {
                                                                webix.message(response.message + response.data.toString(), "error");
                                                            }
                                                        }
                                                    });
                                            }
                                        }
                                    });
                                }
                            }
                        }
                    }
                },
                click: function () {
                    this.callEvent("onClick");
                }
            },
            {
                view: "button", hotkey: "esc", label: "Quay lại (ESC)", type: "danger", align: "center", width: 120,
                click: function () {
                    webix.$$("mau04-win").close();
                }
            },
            {}
        ]
        var ui = {
            view: "window",
            modal: true,
            move: true,
            id: "mau04-win",
            position: "center",
            head: {
                height: 35,
                cols: [
                    {
                        id: "head-icondksd", view: "template", css: "headform", width: 35,
                        template: "<span><i class='fa fa-plus' aria-hidden='true'></i></span>"
                    },
                    {
                        id: "head-formdksd", view: "template", css: "headform", template: function (obj) {
                            return '<div>Thông báo hóa đơn điện tử có sai sót<div/>';
                        }
                    },
                    {
                        view: "icon", icon: "fas fa-question-circle", id: "help_dksdForms", tooltip: "HELPER", click: function () {
                        }
                    }
                ]
            },
            body: {
                // paddingY: 10,
                // paddingX: 10,
                view: "form",
                width: 1200,
                height: 580,
                id: formId,
                complexData: true,
                elementsConfig: { labelWidth: 170 },
                margin: 0,
                elements: [
                    {
                        template: "<center><b><span style='font-size:17px;'>THÔNG BÁO HÓA ĐƠN CÓ SAI SÓT</b></center>", borderless: true, height: 40
                    },
                    {
                        paddingX: 10,
                        rows: [
                            {
                                view: "combo",
                                label: "Loại thông báo",
                                value: 1,
                                options: [
                                    { id: "1", value: "Thông báo của Người nộp thuế" },
                                    { id: "2", value: "Thông báo của Người nộp thuế theo thông báo của CQT" }
                                ],
                                attributes: { readonly: true },
                                id: "loai_tbao",
                                name: "loai_tbao",
                                required: true,
                                invalidMessage: "Kính gửi không được để trống !"
                            },
                            {
                                view: "text",
                                label: "Cơ quan thuế tiếp nhận ",
                                id: "tcqt",
                                name: "tcqt",
                                required: true,
                                disabled: true,
                                invalidMessage: "Kính gửi không được để trống !"
                            },
                            {
                                view: "label",
                                borderless: true,
                                css: { "color": "red" },
                                template: "<span>Lưu ý: để thông báo hóa đơn sai sót Quý khách hàng cần cập"
                                    + " nhật đúng mã cơ quan thuế quản lý <a style='color: blue; 'text-decoration': 'underline'>tại đây<a></span>",
                                on: {
                                    onItemClick: function () {
                                        app.router('app/infocompany');
                                    }
                                }
                            },
                            {
                                view: "text",
                                label: "Tên người nộp thuế",
                                required: true,
                                disabled: true,
                                invalidMessage: "Tên người nộp thuế không được để trống !",
                                id: "tnnt",
                                name: "tnnt"
                            },
                            {
                                view: "text",
                                label: "Mã số thuế",
                                id: "mst",
                                name: "mst",
                                required: true,
                                disabled: true,
                                invalidMessage: "Mã số thuế không được để trống !",
                            },
                            {
                                cols: [
                                    {
                                        view: "datepicker",
                                        label: "Ngày lập",
                                        value: new Date(),
                                        required: true,
                                        invalidMessage: "Ngày lập không được để trống !",
                                        id: "ntbao",
                                        name: "ntbao"
                                    },
                                    {
                                        view: "text",
                                        label: "Nơi lập",
                                        required: true,
                                        invalidMessage: "Nơi lập không được để trống !",
                                        id: "ddanh",
                                        name: "ddanh"
                                    }
                                ]
                            }
                        ]
                    },
                    { height: 3 },
                    { template: "<b><span >Người nộp thuế thông báo về việc hủy/ giải trình hóa đơn điện tử do sai sót như sau:</b>", borderless: true, height: 40 },
                    // { height: 3 },
                    {
                        cols: [
                            {
                                view: "button",
                                id: "btnSelectHD",
                                css: "webix_primary",
                                type: "icon", icon: "mdi mdi-plus-box",
                                width: 120,
                                label: "Chọn hóa đơn",
                                on: {
                                    onItemClick: function (id, e) {
                                        var frmHD = this.$scope.ui(mau04List.$ui);
                                        frmHD.show();
                                    }
                                }
                            },
                            {
                                view: "button",
                                css: "webix_primary",
                                type: "icon", icon: "mdi mdi-plus",
                                width: 100,
                                label: "Thêm dòng",
                                on: {
                                    onItemClick: function (id, e) {
                                        var table = webix.$$(tblId);
                                        var item = { id: webix.uid(), ladhddt: 3, tctbao: 2 };
                                        table.add(item);
                                        table.select(item.id, "khieu", false);
                                        table.edit({ row: item.id, column: "khieu" });
                                    }
                                }
                            },
                            {
                                view: "button",
                                css: "webix_primary",
                                type: "icon", icon: "wxi-trash",
                                width: 100,
                                label: "Xóa dòng",
                                on: {
                                    onItemClick: function (id, e) {
                                        var table = webix.$$(tblId);
                                        table.editStop();
                                        var item = table.getSelectedItem();
                                        if (!webix.isUndefined(item)) {
                                            table.remove(item.id);
                                            table.clearSelection();
                                            return;
                                        }
                                        var editor = table.getEditState();
                                        if (!webix.isUndefined(editor)) {
                                            table.remove(editor.row);
                                            table.clearSelection();
                                            return;
                                        }
                                    }
                                }
                            }
                        ]
                    },
                    {
                        rows: [
                            {
                                view: "datatable",
                                id: tblId,
                                // height: 300,
                                name: tblId,
                                select: "cell",
                                scroll: true,
                                resizeColumn: true,
                                // footer: true,
                                autowidth: true,
                                editable: true,
                                tooltip: true,
                                scheme: {
                                    $init: function (obj) {

                                    }
                                },
                                on: {
                                    "data->onStoreUpdated": function () {
                                        this.data.each(function (obj, i) {
                                            obj.stt = i + 1;
                                        });
                                    },
                                    onValidationError: function (id, obj, details) {
                                        // var index = this.getIndexById(id) + 1;
                                        // webix.message({ type: "error", text: "Bạn chưa nhập Mã cơ quan thuế hoặc Lý do, tại dòng " + index });
                                    },
                                    onBeforeEditStart: function (obj) {
                                        if (obj.column == "tctbao" && editmode == 2)
                                            return false;
                                    },
                                },
                                columns: [
                                    { id: "stt", name: "stt", header: "STT", width: 40, },
                                    { id: "khieu", name: "khieu", header: "Ký hiệu", css: "text_toupper", width: 100, editor: "text", editable: true },
                                    { id: "shdon", name: "shdon", header: "Số hóa đơn", width: 100, editor: "text", editable: true },
                                    //{id: "is_tthdon", name:"is_tthdon", header: "Trạng thái hóa đơn" ,width: 200, editable:false},
                                    {
                                        id: "ngay", name: "ngay", header: "Ngày lập hóa đơn", editable: true, width: 150,
                                        editor: "date",
                                        format: function (text) {
                                            var format = webix.Date.dateToStr("%d/%m/%Y");
                                            text = removeTimeZoneT(text);
                                            return format(text);
                                        }
                                    },
                                    {
                                        id: "ladhddt", name: "ladhddt",
                                        header: "Loại áp dụng hóa đơn điện tử", editable: false, width: 250, editor: "combo",
                                        options: [
                                            { id: "1", value: "HĐĐT theo NĐ số 123/2020" },
                                            { id: "2", value: "HĐĐT xác thực theo QĐ 1209" },
                                            { id: "3", value: "Hóa đơn theo NĐ 51/2010" },
                                            { id: "4", value: "Hóa đơn đặt in theo NĐ 123/2020" }
                                        ]
                                    },
                                    {
                                        id: "tctbao", name: "tctbao",
                                        header: "Tính chất thông báo", editable: true, width: 200, editor: "combo",
                                        options: [
                                            // { id: "0", value: "Mới" },
                                            // { id: "1", value: "Hủy" },
                                            { id: "2", value: "Điều chỉnh" },
                                            { id: "3", value: "Thay thế" },
                                            { id: "4", value: "Giải trình " },
                                            // { id: "5", value: "Sai sót do tổng hợp" }
                                        ]
                                    },
                                    { id: "ldo", name: "ldo", header: "Lý do", editable: true, editor: "text", width: 200 },
                                    {
                                        id: "macqt", name: "macqt", header: "Mã CQT", editor: "text", width: 150, fillspace: true
                                        // required: true,
                                        // validate: webix.rules.isNotEmpty, invalidMessage: "Login can not be empty",
                                        // suggest: {
                                        //     view: "gridsuggest",
                                        //     columnName: "value",
                                        //     url: app.config.host + "/Pattern/GetTaxQL",
                                        //     body: {
                                        //         columns: [{ "id": "id", "width": 80, "header": "Mã" },
                                        //         { "id": "value", "width": 150, "header": "Tên CQT" }],
                                        //         scroll: true,
                                        //         autoheight: false,
                                        //         datatype: "json",
                                        //         dataFeed: function (filtervalue, filter) {
                                        //             if (filtervalue.length < 1) if (filtervalue.length < 1) {
                                        //                 this.load(this.config.url);
                                        //                 return;
                                        //             }
                                        //             var pathUrl = app.config.host + "/Pattern/GetTaxQL?";
                                        //             var urldata = "val=" + encodeURIComponent(filtervalue);

                                        //             this.load(pathUrl + urldata, this.config.datatype);
                                        //         }
                                        //     },
                                        //     on: {
                                        //         onValueSuggest: function (obj) {
                                        //             $$("macqt").setValue(obj.value);
                                        //         }
                                        //     }
                                        // }
                                    },
                                    { id: "khmsohd", name: "khmsohd", header: "Mẫu số", css: "text_toupper", width: 100, editor: "text", editable: true },
                                ],
                                rules: functionExtension.Validate04SS(),
                                ready: function () {
                                    this.validate();
                                },
                                scheme: {
                                    $init: function (obj) {
                                        if (obj.ngay != undefined && obj.ngay != null)
                                            obj.ngay = removeTimeZoneT(obj.ngay);
                                    }
                                }
                            }
                        ]
                    },
                    {
                        margin: 10,
                        cols: button
                    }
                ]
            }

        };

        return {
            $ui: ui,
            setEditMode: function (mode) {
                editmode = mode;
                if (editmode == 1) {
                    var result = webix.ajax().sync().get(app.config.host + "/System/GetCurrentDmdvcs");
                    var response = JSON.parse(result.response);
                    $$("tnnt").setValue(response[0].ten_dvcs);
                    $$("mst").setValue(response[0].ms_thue);
                    $$("tcqt").setValue(response[0].ten);
                    $$("ddanh").setValue(response[0].tinh_thanh);
                }
            },
            setValues: function (item) {
                var form = $$(formId);
                if (item != null) {
                    item["ntbao"] = removeTimeZoneT(item["ntbao"]);
                    form.setValues(item);
                }
                var tableDetail = webix.$$(tblId);
                var url = app.config.host + "/CancelInvoice/GetDataDetail?id=" + item.id;
                tableDetail.clearAll();
                tableDetail.load(url);
            }
        };
    });
define('views/forms/forms68/NCCA/signNCCA',["app"], function (app) {
    var item;
    var type_sign;
    function initUI(obj, type) {
        item = obj;
        type_sign = type;
    }
    return {
        $ui: {
            view: "window",
            modal: true,
            id: "signNCCA",
            css: "signEasyCA",
            position: "center",
            move: true,
            head: false,
            minWidth: 350,
            body: {
                view: "form",
                id: "signNCCA-frm",
                elementsConfig: {
                    labelWidth: 60
                },
                elements: [
                    {
                        view: "text", type: "password", name: "pin", id: "pin", label: "Mã pin", required: true,
                        invalidMessage: "Bạn phải nhập mã pin"
                    },
                    {
                        cols: [
                            {},
                            {
                                shortcut: "F10", view: "button", label: "Nhận (F10)", type: "form", align: "center", width: 80,
                                on: {
                                    onClick: function () {
                                        if ($$("signNCCA-frm").validate()) {
                                            var form = $$("signNCCA");
                                            var param = {
                                                so_serial: item.so_serial,
                                                pinCode: $$("pin").getValue(),
                                                id: item.id,
                                                agreementUUID: item.value
                                            };
                                            var apiHost = app.config.host;
                                            switch (type_sign) {
                                                case "dangky":
                                                    apiHost += "/Register68/SignByNcca";
                                                    break;
                                                case "invoiceCma":
                                                    apiHost += "/TokenCloud/NccaSignInvoice";
                                                    break;
                                                case "invoiceKma":
                                                    apiHost += "/TokenCloud/NccaSignInvoice";
                                                    break;
                                                case "invoiceSign":
                                                    apiHost += "/TokenCloud/NccaSignInvoice";
                                                    break;
                                                case "cancelInvoice":
                                                    apiHost += "/CancelInvoice/SignCancelInvoiceNcca";
                                                    break;
                                            };

                                            webix.extend(form, webix.ProgressBar);
                                            form.disable();
                                            form.showProgress();

                                            webix.ajax()
                                                .headers({ 'Content-type': 'application/json' })
                                                .post(apiHost, param, {
                                                    error: function (text, data, XmlHttpRequest) {
                                                        form.enable();
                                                        form.hideProgress();
                                                        webix.message(text);
                                                    },
                                                    success: function (text, data, XmlHttpRequest) {
                                                        var response = JSON.parse(text);
                                                        if (response.code == "00") {
                                                            form.enable();
                                                            form.hideProgress();
                                                            switch (type_sign) {
                                                                case "cancelInvoice":
                                                                    app.callEvent("dataChangedMau0405", [1, null]);
                                                                    break;
                                                                case "dangky":
                                                                    app.callEvent("dataChangeDangkysudung68", [1, null]);
                                                                    break;
                                                                default:
                                                                    app.callEvent("dataChangedMau0405", [1, null]);
                                                                    break;
                                                            }
                                                            $$("btnCancel").callEvent("onClick");
                                                            webix.message("Ký thành công !", "success");
                                                        }
                                                        else {
                                                            form.enable();
                                                            form.hideProgress();
                                                            webix.message(response.message, "error");
                                                        }
                                                    }
                                                });
                                        }
                                    }
                                },
                                click: function () {
                                    this.callEvent("onClick");
                                }
                            },
                            {
                                view: "button", id: "btnCancel", shortcut: "esc", label: "Hủy (ESC)", type: "danger", align: "center",
                                width: 80,
                                on: {
                                    onClick: function () {
                                        $$("signNCCA").close();
                                    }
                                },
                                click: function () {
                                    this.callEvent("onClick");
                                }
                            },
                            {}
                        ]
                    }
                ]
            }
        },
        setEditMode: function (mode) {
            editmode = mode;
        },
        initUI: initUI
    };

});
define('views/forms/forms70/Bangke/bangkeform',[
    "app",
    "locale",
    "views/modules/Component/componentHelper",
    "views/modules/Component/constantManager",
    "views/modules/Component/functionExtension"
], function (app, _, componentHelper, constant, functionExtension) {
    var bangkeWindowId = "bangkeWindowId";
    var bangkeFormId = "bangkeFormId";
    var dauphieuBangke = componentHelper.dauphieuBangke();
    var btnChitietBangke = componentHelper.btnChitietBangke();
    var headTitleBangke = componentHelper.headTitleHoadon("Bảng kê hóa đơn");

    var tongtien = componentHelper.tongtien();
    var tongtienDetail = componentHelper.tongtienDetail();

    return {
        $ui: {
            view: "window",
            modal: true,
            position: "center",
            css: "headformchil",
            head: headTitleBangke,
            id: bangkeWindowId,
            resize: true,
            fullscreen: true,
            move: true,
            body: {
                paddingY: 10,
                paddingX: 10,
                elementsConfig: { labelWidth: 100 },
                view: "form",
                id: bangkeFormId,
                width: 800,
                height: 500,
                complexData: true,
                margin: 0,
                elements: [
                    {
                        view: "scrollview",
                        scroll: "y",
                        body: {
                            paddingX: 18,
                            rows: [
                                dauphieuBangke,
                                {
                                    borderless: true,
                                    view: "tabview",
                                    scrollX: true,
                                    tabbar: {
                                        width: 400
                                    },
                                    cells: [
                                        {
                                            header: "Chi tiết danh sách hóa đơn có chênh lệch",
                                            body: {
                                                rows: [
                                                    btnChitietBangke,
                                                    {
                                                        view: "datatable",
                                                        resizeColumn: true,
                                                        id: "bangke_chitiet",
                                                        editable: true,
                                                        select: "cell",
                                                        drag: true,
                                                        columns: [
                                                            { id: "stt", header: "STT", width: 50 },
                                                            { id: "kyhieu", header: "Ký hiệu", width: 100, editor: "text" },
                                                            { id: "sohoadon", header: "Số hóa đơn", width: 100, editor: "text" },

                                                            { id: "ten_hhdv_goc", header: [{ css: { "background": "#ecf1f1" }, text: "Thông tin trước điều chỉnh", colspan: 8 }, { text: "Tên hàng hóa dịch vụ", css: { "background": "#ecf1f1" } }], width: 200 },
                                                            { id: "sluong_goc", header: [null, { text: "Số lượng", css: { "background": "#ecf1f1" } }], width: 100 },
                                                            { id: "dgia_goc", header: [null, { text: "Đơn giá", css: { "background": "#ecf1f1" } }], width: 120 },
                                                            { id: "thtien_goc", header: [null, { text: "Tiền trước thuế", css: { "background": "#ecf1f1" } }], width: 130 },
                                                            { id: "tsuat_goc", header: [null, { text: "Thuế suất Thuế GTGT", css: { "background": "#ecf1f1" } }], width: 120 },
                                                            { id: "tthue_goc", header: [null, { text: "Tiền thuế GTGT", css: { "background": "#ecf1f1" } }], width: 120 },
                                                            { id: "tgtienkhac_goc", header: [null, { text: "Tổng tiền khác", css: { "background": "#ecf1f1" } }], width: 120 },
                                                            { id: "tgtien_goc", header: [null, { text: "Tổng tiền sau thuế", css: { "background": "#ecf1f1" } }], width: 120 },

                                                            { id: "ten_hhdv_tdoi", header: [{ css: { "background": "#e7e7e7" }, text: "Thông tin sau điều chỉnh", colspan: 8 }, { text: "Tên hàng hóa dịch vụ", css: { "background": "#e7e7e7" } }], width: 200, editor: "text" },
                                                            { id: "sluong_tdoi", header: [null, { text: "Số lượng", css: { "background": "#e7e7e7" } }], width: 100, editor: "text" },
                                                            { id: "dgia_tdoi", header: [null, { text: "Đơn giá", css: { "background": "#e7e7e7" } }], width: 120, editor: "text" },
                                                            { id: "thtien_tdoi", header: [null, { text: "Tiền trước thuế", css: { "background": "#e7e7e7" } }], width: 130, editor: "text" },
                                                            { id: "tsuat_tdoi", header: [null, { text: "Thuế suất GTGT", css: { "background": "#e7e7e7" } }], width: 120, editor: "combo" },
                                                            { id: "tthue_tdoi", header: [null, { text: "Tiền thuế GTGT", css: { "background": "#e7e7e7" } }], width: 120, editor: "text" },
                                                            { id: "tgtienkhac_tdoi", header: [null, { text: "Tổng tiền khác", css: { "background": "#e7e7e7" } }], width: 120, editor: "text" },
                                                            { id: "tgtien_tdoi", header: [null, { text: "Tiền thuế sau thuế", css: { "background": "#e7e7e7" } }], width: 120, editor: "text" },

                                                            { id: "thtien_clech", header: [{ css: { "background": "#fcf7fc" }, text: "Chênh lệch", colspan: 4 }, { text: "Tổng tiền trước thuế", css: { "background": "#fcf7fc" } }], width: 150, editor: "text" },
                                                            { id: "tthue_clech", header: [null, { text: "Tổng tiền thuế", css: { "background": "#fcf7fc" } }], width: 150, editor: "text" },
                                                            { id: "tgtienkhac_clech", header: [null, { text: "Tổng tiền khác", css: { "background": "#fcf7fc" } }], width: 150, editor: "text" },
                                                            { id: "tgtien_clech", header: [null, { text: "Tổng tiền sau thuế", css: { "background": "#fcf7fc" } }], width: 150, editor: "text" }
                                                        ],

                                                        on: {
                                                            "data->onStoreUpdated": function () {
                                                                this.data.each(function (obj, i) {
                                                                    obj.stt = i + 1;
                                                                });
                                                            },
                                                            onAfterEditStop: function (state, editor) {
                                                                const item = this.getItem(editor.row);
                                                                item.thtien_tdoi = (parseFloat(item.sluong_tdoi) || 0) * (parseFloat(item.dgia_tdoi) || 0);
                                                                item.tgtien_tdoi = item.thtien_tdoi + (parseFloat(item.tthue_tdoi) || 0) + (parseFloat(item.tgtienkhac_tdoi) || 0);
                                                                item.thtien_clech = (parseFloat(item.thtien_tdoi) || 0) - (parseFloat(item.thtien_goc) || 0);
                                                                item.tthue_clech = (parseFloat(item.tthue_tdoi) || 0) - (parseFloat(item.tthue_goc) || 0);
                                                                item.tgtienkhac_clech = (parseFloat(item.tgtienkhac_tdoi) || 0) - (parseFloat(item.tgtienkhac_goc) || 0);
                                                                item.tgtien_clech = (parseFloat(item.tgtien_tdoi) || 0) - (parseFloat(item.tgtien_goc) || 0);

                                                                this.updateItem(editor.row, item);
                                                            }
                                                        }
                                                    }
                                                ]
                                            }
                                        }
                                    ]
                                },
                                { height: 10 },
                                {
                                    margin: 10,
                                    cols: [
                                        {},
                                        {
                                            view: "button",
                                            value: "Hủy",
                                            css: "webix_danger",
                                            width: 150,
                                            click: function () {
                                                $$(bangkeWindowId).hide();
                                            }
                                        },
                                        {
                                            view: "button",
                                            value: "Lưu và Tạo hóa đơn",
                                            css: "webix_primary",
                                            width: 150,
                                            click: function () {
                                                var window = $$(bangkeWindowId);
                                                var form = $$(bangkeFormId);
                                                const formValues = form.getValues();
                                                const detailData = $$('bangke_chitiet').serialize();

                                                if (!formValues || !detailData || detailData.length === 0) {
                                                    webix.message("Dữ liệu không hợp lệ, vui lòng kiểm tra lại.", "error");
                                                    return;
                                                }

                                                const detailWithHoadonID = detailData.map(item => {
                                                    item.thtien_tdoi = (parseFloat(item.sluong_tdoi) || 0) * (parseFloat(item.dgia_tdoi) || 0);
                                                    item.tgtien_tdoi = item.thtien_tdoi + (parseFloat(item.tthue_tdoi) || 0) + (parseFloat(item.tgtienkhac_tdoi) || 0);
                                                    item.thtien_clech = (parseFloat(item.thtien_tdoi) || 0) - (parseFloat(item.thtien_goc) || 0);
                                                    item.tthue_clech = (parseFloat(item.tthue_tdoi) || 0) - (parseFloat(item.tthue_goc) || 0);
                                                    item.tgtienkhac_clech = (parseFloat(item.tgtienkhac_tdoi) || 0) - (parseFloat(item.tgtienkhac_goc) || 0);
                                                    item.tgtien_clech = (parseFloat(item.tgtien_tdoi) || 0) - (parseFloat(item.tgtien_goc) || 0);
                                                    return item;
                                                });

                                                const payload = {
                                                    ngay: formValues.ngay,
                                                    tchat: formValues.tchat,
                                                    nban: formValues.nban,
                                                    mst_nban: formValues.mst_nban,
                                                    dchi_nban: formValues.dchi_nban,
                                                    nmua: formValues.nmua,
                                                    mst_nmua: formValues.mst_nmua,
                                                    dchi_nmua: formValues.dchi_nmua,
                                                    ldo: formValues.ldo,
                                                    bangke_chitiets: detailWithHoadonID
                                                };
                                                if (form.validate()) {
                                                    webix.extend(window, webix.ProgressBar);
                                                    window.disable();
                                                    window.showProgress();

                                                    webix.ajax()
                                                        .headers({ 'Content-Type': 'application/json' })
                                                        .post(app.config.host + constant.API.BANGKE.SAVE_BANGKE + "?type=2", JSON.stringify(payload), {
                                                            error: function (text) {
                                                                window.enable();
                                                                window.hideProgress();
                                                                webix.message("Lỗi khi lưu thông tin: " + text, "error");
                                                            },
                                                            success: function (text) {
                                                                window.enable();
                                                                window.hideProgress();
                                                                const response = JSON.parse(text);
                                                                if (response.code === "00") {
                                                                    webix.message("Tạo bảng kê thành công!", "success");
                                                                    $$(bangkeWindowId).hide();
                                                                    require(["views/forms/forms70/BangKe/saveInvoiceForm"], function (saveInvoiceForm) {
                                                                        saveInvoiceForm.setData(payload);
                                                                        webix.ui(saveInvoiceForm.$ui).show();
                                                                    });
                                                                } else {
                                                                    webix.message(response.message || "Lưu thông tin thất bại", "error");
                                                                }
                                                            }
                                                        });
                                                }
                                            }
                                        },
                                        {}
                                    ]
                                }
                            ]
                        }
                    }
                ]
            }
        },
        setEditMode: function (mode) {
            $$("tchat").setValue(mode);
            $$('bangke_chitiet').clearAll();
            var icon = "<span><i class='fa fa-plus' aria-hidden='true'></i></span>";
            webix.$$("head-iconInvoice").setHTML(icon);
            webix.ajax().get(app.config.host + "/System/GetInfoCompany", {
                error: function (err) {
                    console.error("Error fetching seller information:", err);
                    webix.message("Không thể tải thông tin người bán", "error");
                },
                success: function (response) {
                    try {
                        const sellerInfo = JSON.parse(response);
                        $$('nban').setValue(sellerInfo.ten_dvcs || "");
                        $$('mst_nban').setValue(sellerInfo.ms_thue || "");
                        $$('dchi_nban').setValue(sellerInfo.dia_chi || "");
                    } catch (parseError) {
                        console.error("Error parsing seller information:", parseError);
                        webix.message("Dữ liệu trả về không hợp lệ cho thông tin người bán", "error");
                    }
                }
            });
        },

        loadDetailData: function (id) {
            webix.ajax().get(app.config.host + "/Bangke/GetDetail?id=" + id, function (text, data) {
                const detailData = data.json();
                $$("bangke_chitiet").parse(detailData);
            });
        },
        setData: function (selectedInvoices) {

            if (selectedInvoices.length > 0) {
                const firstInvoice = selectedInvoices[0];
                $$('nmua').setValue(firstInvoice.nguoimuahang || "");
                $$('mst_nmua').setValue(firstInvoice.mst || "");
                $$('dchi_nmua').setValue(firstInvoice.dchi || "");
            }

            selectedInvoices.forEach((invoice) => {
                if (invoice.id) {
                    const apiUrl = app.config.host + "/Invoice68/GetDetailInvoice?id=" + invoice.id;
                    webix.ajax().get(apiUrl, {
                        error: function (err) {
                            console.error("Error fetching details for invoice ID:", invoice.id, err);
                            webix.message("Không thể tải dữ liệu chi tiết cho hóa đơn: " + invoice.id, "error");
                        },
                        success: function (response) {
                            try {
                                const detailData = JSON.parse(response);
                                const mappedData = detailData.map((item, index) => ({
                                    stt: index + 1,
                                    kyhieu: invoice.khieu,
                                    sohoadon: invoice.shdon,
                                    ten_hhdv_goc: item.ten,
                                    sluong_goc: item.sluong,
                                    dgia_goc: item.dgia,
                                    thtien_goc: item.thtien,
                                    tsuat_goc: item.tsuat,
                                    tthue_goc: item.tthue,
                                    // tgtienkhac_goc: item.tgtien,
                                    tgtien_goc: item.tgtien,

                                    ten_hhdv_tdoi: item.ten,
                                    sluong_tdoi: item.sluong,
                                    dgia_tdoi: item.dgia,
                                    thtien_tdoi: item.thtien,
                                    tthue_tdoi: item.tthue,
                                    tsuat_tdoi: item.tsuat,
                                    // tgtienkhac_goc: item.tgtien,
                                    tgtien_tdoi: item.tgtien,
                                    hoadon68_id: invoice.id
                                }));
                                $$("bangke_chitiet").parse(mappedData);
                            } catch (parseError) {
                                console.error("Error parsing response for invoice ID:", invoice.id, parseError);
                                webix.message("Dữ liệu trả về không hợp lệ cho hóa đơn: " + invoice.id, "error");
                            }
                        }
                    });
                }
            });
        },
        openChonHoaDon: function (chonHoaDonForm) {
            var mst_nban = $$('mst_nban') ? $$('mst_nban').getValue() : null;
            var win = chonHoaDonForm && chonHoaDonForm.$ui ? webix.ui(chonHoaDonForm.$ui) : null;
            if (chonHoaDonForm && typeof chonHoaDonForm.setMSTValue === 'function' && mst_nban) {
                chonHoaDonForm.setMSTValue(mst_nban);
            }
            if (win) win.show();
        }
    };
});

define('views/forms/forms70/Bangke/hoadonChietKhauForm',[
    "app",
    "locale",
    "views/modules/Component/componentHelper",
    "views/modules/Component/constantManager",
], function (app, _, componentHelper, constant) {
    var hoadonchietkhauID = "hoadonchietkhauID";
    var hoadonFormId = "hoadonFormId";
    var dauphieuBangke = componentHelper.dphdonchietkhau();
    var btnChitietBangke = componentHelper.btnHoadonchietkhau_chitiet();
    var headTitleBangke = componentHelper.headTitleHoadon("Bảng kê đính kèm hóa đơn chiết khấu");

    return {
        $ui: {
            view: "window",
            modal: true,
            position: "center",
            css: "headformchil",
            head: headTitleBangke,
            id: hoadonchietkhauID,
            resize: true,
            fullscreen: true,
            move: true,
            body: {
                paddingY: 10,
                paddingX: 10,
                elementsConfig: { labelWidth: 100 },
                view: "form",
                id: hoadonFormId,
                width: 800,
                height: 500,
                complexData: true,
                margin: 0,
                elements: [
                    {
                        view: "scrollview",
                        scroll: "y",
                        body: {
                            paddingX: 18,
                            rows: [
                                dauphieuBangke,
                                {
                                    borderless: true,
                                    view: "tabview",
                                    scrollX: true,
                                    tabbar: {
                                        width: 400
                                    },
                                    cells: [
                                        {
                                            header: "Chi tiết danh sách hóa đơn có chênh lệch",
                                            body: {
                                                rows: [
                                                    btnChitietBangke,
                                                    {
                                                        view: "datatable",
                                                        resizeColumn: true,
                                                        id: "hdck_chitiet",
                                                        editable: true,
                                                        select: "cell",
                                                        drag: true,
                                                        footer: true,
                                                        columns: [
                                                            { id: "stt", header: "STT", width: 50 },
                                                            {
                                                                id: "khieu",
                                                                header: "Ký hiệu",
                                                                width: 150,
                                                                editor: "text",
                                                                footer: {
                                                                    text: "Tổng cộng",
                                                                    colspan: 5,
                                                                    css: "text-left",
                                                                },
                                                            },
                                                            {
                                                                id: "shdon",
                                                                header: "Số hóa đơn",
                                                                width: 100,
                                                                // editor: "text",
                                                            },
                                                            {
                                                                id: "tdlap",
                                                                header: "Ngày hóa đơn",
                                                                width: 150,
                                                                // editor: "datepicker",
                                                                format: function (text) { return formatDate(text); }
                                                            },
                                                            {
                                                                id: "dvtte",
                                                                header: "Đơn vị tiền tệ",
                                                                width: 100,
                                                                // editor: "text",
                                                            },
                                                            {
                                                                id: "tgia",
                                                                header: "Tỷ giá",
                                                                width: 100,
                                                                // editor: "text",
                                                            },
                                                            {
                                                                id: "tgtcthue",
                                                                header: "Tổng tiền trước thuế",
                                                                width: 150,
                                                                // editor: "text",
                                                                footer: { content: "summColumn" },
                                                            },
                                                            {
                                                                id: "tgtthue",
                                                                header: "Tổng tiền thuế",
                                                                width: 130,
                                                                // editor: "text",
                                                                footer: { content: "summColumn" },
                                                            },
                                                            {
                                                                id: "tgtphi",
                                                                header: "Tổng tiền phí",
                                                                width: 130,
                                                                // editor: "text",
                                                                footer: { content: "summColumn" },
                                                            },
                                                            {
                                                                id: "tgtttbso",
                                                                header: "Tổng tiền thanh toán",
                                                                width: 150,
                                                                fillspace: true,
                                                                // editor: "text",
                                                                footer: { content: "summColumn" },
                                                            },
                                                            {
                                                                id: "macqt",
                                                                header: "Mã CQT",
                                                                width: 150,
                                                                fillspace: true,
                                                                // editor: "text",
                                                            },
                                                        ],
                                                    }
                                                ]
                                            }
                                        }
                                    ]
                                },
                                { height: 10 },
                                {
                                    margin: 10,
                                    cols: [
                                        {},
                                        {
                                            view: "button",
                                            value: "Hủy",
                                            css: "webix_danger",
                                            width: 150,
                                            click: function () {
                                                $$(hoadonchietkhauID).hide();
                                            }
                                        },
                                        {
                                            view: "button",
                                            value: "Lưu và Tạo hóa đơn",
                                            css: "webix_primary",
                                            width: 150,
                                            click: function () {
                                                if ($$("sbke")) $$("sbke").show();
                                                if ($$("nbke")) $$("nbke").show();
                                                if ($$("tclquan")) $$("tclquan").show();

                                                var window = $$(hoadonchietkhauID);
                                                var form = $$(hoadonFormId);
                                                const formValues = form.getValues();
                                                const detailData = $$('hdck_chitiet').serialize();

                                                if (!formValues || !detailData || detailData.length === 0) {
                                                    webix.message("Dữ liệu không hợp lệ, vui lòng kiểm tra lại.", "error");
                                                    return;
                                                }
                                                const khieuList = detailData.map(item => item.khieu);
                                                const firstKhieu = khieuList[0];
                                                const allSameKhieu = khieuList.every(k => k === firstKhieu);
                                                if (!allSameKhieu) {
                                                    webix.message("Tất cả các ký hiệu hóa đơn phải giống nhau!", "error");
                                                    return;
                                                }
                                                const detailDatawithbk = detailData.map(item => {
                                                    item.dvtte = item.dvtte;
                                                    item.tgia = item.tgia;
                                                    item.khieu = item.khieu;
                                                    item.shdon = item.shdon;
                                                    item.tdlap = item.tdlap;
                                                    item.hoadon68_id = item.hoadon68_id;
                                                    item.tthue_clech = item.tthue_clech != null ? item.tthue_clech : 0;
                                                    return item;
                                                });
                                                const payload = {
                                                    ngay: formValues.ngay,
                                                    tchat: formValues.tchat,
                                                    nban: formValues.nban,
                                                    mst_nban: formValues.mst_nban,
                                                    dchi_nban: formValues.dchi_nban,
                                                    nmua: formValues.nmua ? formValues.nmua : "",
                                                    mst_nmua: formValues.mst_nmua,
                                                    dchi_nmua: formValues.dchi_nmua,
                                                    bangke_chitiets: detailDatawithbk
                                                };
                                                if (form.validate()) {
                                                    webix.extend(window, webix.ProgressBar);
                                                    window.disable();
                                                    window.showProgress();

                                                    webix.ajax()
                                                        .headers({ 'Content-Type': 'application/json' })
                                                        .post(app.config.host + constant.API.BANGKE.SAVE_BANGKE + "?type=1", JSON.stringify(payload), {
                                                            error: function (text) {
                                                                window.enable();
                                                                window.hideProgress();
                                                                webix.message("Lỗi khi lưu thông tin: " + text, "error");
                                                            },
                                                            success: function (text) {
                                                                window.enable();
                                                                window.hideProgress();
                                                                const response = JSON.parse(text);
                                                                if (response.code == "00") {
                                                                    webix.message("Tạo bảng kê thành công!", "success");
                                                                    $$(hoadonchietkhauID).close();
                                                                    webix.$$("btnPlus").callEvent("onCreate", [response.data]);
                                                                    if ($$("sbke")) $$("sbke").show();
                                                                    if ($$("nbke")) $$("nbke").show();
                                                                    if ($$("tclquan")) $$("tclquan").show();
                                                                } else {
                                                                    webix.message(response.message || "Lưu thông tin thất bại", "error");
                                                                }
                                                            }
                                                        });
                                                }
                                            }
                                        },
                                        {}
                                    ]
                                }
                            ]
                        }
                    }
                ]
            }
        },
        setEditMode: function (mode) {
            $$('hdck_chitiet').clearAll();
            var icon = "<span><i class='fa fa-plus' aria-hidden='true'></i></span>";
            webix.$$("head-iconInvoice").setHTML(icon);
            webix.ajax().get(app.config.host + "/System/GetInfoCompany", {
                error: function (err) {
                    console.error("Error fetching seller information:", err);
                    webix.message("Không thể tải thông tin người bán", "error");
                },
                success: function (response) {
                    try {
                        const sellerInfo = JSON.parse(response);
                        $$('nban').setValue(sellerInfo.ten_dvcs || "");
                        $$('mst_nban').setValue(sellerInfo.ms_thue || "");
                        $$('dchi_nban').setValue(sellerInfo.dia_chi || "");
                    } catch (parseError) {
                        console.error("Error parsing seller information:", parseError);
                        webix.message("Dữ liệu trả về không hợp lệ cho thông tin người bán", "error");
                    }
                }
            });
        },

        loadDetailData: function (id) {
            webix.ajax().get(app.config.host + "/Bangke70/GetDetail?id=" + id, function (text, data) {
                const detailData = data.json();
                $$("hdck_chitiet").parse(detailData);
            });
        },
        setData: function (selectedInvoices) {
            if (selectedInvoices.length > 0) {
                const firstInvoice = selectedInvoices[0];
                $$('nmua').setValue(firstInvoice.nguoimuahang || "");
                $$('mst_nmua').setValue(firstInvoice.mst || "");
                $$('dchi_nmua').setValue(firstInvoice.dchi || "");
            }
            const mappedData = selectedInvoices
                .filter(invoice => invoice && invoice.khieu && invoice.shdon)
                .map((invoice, index) => ({
                    stt: index + 1,
                    khieu: invoice.khieu,
                    shdon: invoice.shdon,
                    tdlap: invoice.tdlap,
                    dvtte: invoice.dvtte,
                    tgia: invoice.tgia,
                    tgtcthue: invoice.tgtcthue,
                    tgtthue: invoice.tgtthue,
                    tgtphi: invoice.tgtphi,
                    tgtttbso: invoice.tgtttbso,
                    macqt: invoice.macqt
                }));
            $$('hdck_chitiet').parse(mappedData);
        },
        openChonHoaDon: function (chonHoaDonForm) {
            var mst_nban = $$('mst_nban') ? $$('mst_nban').getValue() : null;
            var win = chonHoaDonForm && chonHoaDonForm.$ui ? webix.ui(chonHoaDonForm.$ui) : null;
            if (chonHoaDonForm && typeof chonHoaDonForm.setMSTValue === 'function' && mst_nban) {
                chonHoaDonForm.setMSTValue(mst_nban);
            }
            if (win) win.show();
        }
    };
});

define('views/forms/forms70/Bangke/saveInvoiceForm',[
    "app",
    "locale",
    "models/user",
    "views/modules/Component/componentHelper",
    "views/modules/Component/eventTableHelper",
    "views/modules/Component/button",
    "views/modules/Component/constantManager",
    "views/modules/Component/functionExtension",
], function (app, _, user, componentHelper, eventTableHelper, buttonOptions, constant, functionExtension) {
    var editmode = 0;
    var afteredit = "";
    var mahanghoaHoadon = componentHelper.mahanghoaHoadon();
    mahanghoaHoadon.maxLength = 50;
    var colPtCk = componentHelper.numeric("tlckhau", "% CK", 3); colPtCk.hidden = true;
    var colTienCk = componentHelper.numeric("stckhau", "Tiền CK"); colTienCk.hidden = true;
    var colTienThue = componentHelper.numeric("tthue", "Tiền thuế");
    var colTienSauThue = componentHelper.numeric("tgtien", "Tiền sau thuế");

    var dauphieuHoadonBangke = componentHelper.dauphieuHoadonBangke();
    var btnChitietHoadon = componentHelper.btnChitietHoadon();
    var headTitleHoadon = componentHelper.headTitleHoadon("Hóa đơn điều chỉnh kèm bảng kê số");
    var tongtien = componentHelper.tongtien();
    var tongtienDetail = componentHelper.tongtienDetail();
    var tienbangchu = componentHelper.tienbangchu();
    var btnSaveHoadon = buttonOptions.btnSaveHoadon();
    var btnCancelHoadon = buttonOptions.btnCancelHoadon();
    var btnSaveHoadonDieuChinh = buttonOptions.btnSaveHoadonDieuChinh();
    var btnSaveHoadonThayThe = buttonOptions.btnSaveHoadonThayThe();

    var windowId = "invoice68";
    var formId = "invoiceForms";
    var datatableDetail = "hoadon68_chitiet";
    return {
        $ui: {
            view: "window",
            modal: true,
            position: "center",
            css: "headformchil",
            head: headTitleHoadon,
            id: windowId,
            resize: true,
            fullscreen: true,
            move: true,
            body: {
                paddingY: 10,
                paddingX: 10,
                elementsConfig: { labelWidth: 100 },
                view: "form",
                id: formId,
                width: 800,
                height: 500,
                complexData: true,
                margin: 0,
                rules: functionExtension.ValidateInvoice32(),
                elements: [
                    {
                        view: "scrollview",
                        scroll: "y",
                        body: {
                            paddingX: 18,
                            rows: [
                                dauphieuHoadonBangke,
                                {
                                    borderless: true,
                                    view: "tabview",
                                    scrollX: true,
                                    tabbar: { width: 200 },
                                    cells: [
                                        {
                                            header: "Chi tiết hóa đơn",
                                            select: "cell",
                                            body: {
                                                rows: [
                                                    btnChitietHoadon,
                                                    {
                                                        view: "datatable",
                                                        resizeColumn: true,
                                                        id: datatableDetail,
                                                        editable: true,
                                                        select: "cell",
                                                        drag: true,
                                                        columns: [
                                                            { id: "stt", header: "", width: 30 },
                                                            { id: "stt_rec", header: "STT", width: 40, editable: true, editor: "text" },
                                                            mahanghoaHoadon,
                                                            { id: "ten", header: _("Tên hàng hóa"), editor: "text", width: 350, editable: true },
                                                            componentHelper.donvitinhHoadon(),
                                                            componentHelper.numeric("sluong", "Số lượng"),
                                                            componentHelper.numeric("dgia", "Đơn giá"),
                                                            colPtCk,
                                                            colTienCk,
                                                            componentHelper.numeric("thtien", "Tiền trước thuế"),
                                                            { id: "tsuat", header: _("Thuế suất"), width: 100, editor: "combo", editable: true, value: "0", options: app.config.host + "/Invoice68/GetVAT" },
                                                            colTienThue,
                                                            colTienSauThue,
                                                            { id: "tchat", name: "tchat", header: "Tính chất", editable: false, width: 200, editor: "combo", options: [{ id: "1", value: "Hàng hóa dịch vụ" }, { id: "2", value: "Khuyến mại" }, { id: "3", value: "Chiết khấu thương mại" }, { id: "4", value: "Ghi chú/ diễn giải" }] },
                                                            { id: "ctinh", name: "ctinh", header: "Cách tính", editable: false, width: 200, editor: "combo", options: [{ id: "1", value: "Tính xuôi" }, { id: "2", value: "Tính ngược" }] }
                                                        ],
                                                        on: {
                                                            onAfterEditStart: function (cell) {
                                                                if (cell.column == "ten") {
                                                                    this.getEditor().getInputNode().setAttribute("maxlength", 500);
                                                                }
                                                            }
                                                        },
                                                        rules: {
                                                            "tchat": webix.rules.isNotEmpty,
                                                            $obj: webix.rules.validateMoney
                                                        },
                                                        ready: function () {
                                                            this.validate();
                                                        }
                                                    }
                                                ]
                                            }
                                        }
                                    ]
                                },
                                {
                                    css: "regiontongtien",
                                    rows: [
                                        tongtien,
                                        {
                                            view: "accordion",
                                            multi: true,
                                            borderless: true,
                                            type: "clean",
                                            css: "tongtienChitiet",
                                            rows: [
                                                { header: " + Tổng tiền chi tiết", css: "ttChitiet", collapsed: true, body: tongtienDetail }
                                            ]
                                        },
                                        tienbangchu,
                                        { height: 10 }
                                    ]
                                },
                                { height: 10 },
                                {
                                    margin: 10,
                                    cols: [
                                        {},
                                        btnSaveHoadonDieuChinh,
                                        btnSaveHoadonThayThe,
                                        btnSaveHoadon,
                                        btnCancelHoadon,
                                        {}
                                    ]
                                }
                            ]
                        }
                    }
                ]
            }
        }
    };
});

define('views/forms/forms70/BienBan/bienbanForm',[
    "app",
    "locale",
    "views/modules/Component/constantManager",
    "views/modules/Component/modalPlugin",
    "views/forms/forms68/EasyCA/signEasyCA",
    "views/forms/forms68/ICA/signICA",
    "views/modules/minvoiceplugin",
    "views/forms/forms70/BienBan/SendEmailBienban",
], function (app, _, constant, modalPlugin, signEasyCA, signICA, minvoiceplugin, sendEmail) {
    'use strict';
    var bienbanId = "bienban";
    var bienbanForm = "BienBanForms";
    var initData;
    function randomUniqueString(length) {
        const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
        if (length > chars.length) {
            throw new Error('Length exceeds unique characters available.');
        }

        let charsArray = chars.split('');
        let result = '';

        for (let i = 0; i < length; i++) {
            const randIndex = Math.floor(Math.random() * charsArray.length);
            result += charsArray[randIndex];
            charsArray.splice(randIndex, 1);
        }

        return result;
    }
    function loadBienBanById(bienban_id, bienbanId, options = {}) {
        if (!bienban_id || bienban_id === "00000000-0000-0000-0000-000000000000") {
            return false;
        }
        webix.ajax().get(app.config.host + constant.API.BIENBAN.GET_BIENBAN_BY_ID + "?id=" + bienban_id, {
            error: function (err) {
                console.error("Lỗi khi lấy chi tiết biên bản:", err);
                webix.message("Không thể lấy chi tiết biên bản", "error");
            },
            success: function (response) {
                const responseData = JSON.parse(response);
                if (responseData.code === "00") {
                    var form = $$(bienbanId);
                    const data = responseData.data;
                    var tchatValue = options.useTchat ? (form.getValues().ten_tt.toLowerCase().includes("điều chỉnh") ? 1 : 2) : data.tchat;
                    const dataMapping = {
                        bienban_id: bienban_id,
                        so_bban: data.so || "",
                        so: data.so || "",
                        ngay: new Date(data.ngay),
                        shdon: data.shdon || "",
                        ngay_hdon: data.ngay_hdon || data.tdlap || "",
                        nban: data.nban || "",
                        dchi_nban: data.dchi_nban || "",
                        mst_nban: data.mst_nban || "",
                        sdt_nban: data.sdt_nban || "",
                        ddien_nban: data.ddien_nban || "",
                        chucvu_nban: data.chucvu_nban || "",
                        nmua: data.nmua || "",
                        dchi_nmua: data.dchi_nmua || "",
                        mst_nmua: data.mst_nmua || "",
                        sdt_nmua: data.sdt_nmua || "",
                        ddien_nmua: data.ddien_nmua || "",
                        chucvu_nmua: data.chucvu_nmua || "",
                        ldo: data.ldo || "",
                        tchat: tchatValue,
                        kyhieu_mau: data.khieu_hdon.charAt(0) || "",
                        kyhieu_hd: data.khieu_hdon.substring(1) || "",
                        ten_tt: (data.tchat == 1) ? "Điều chỉnh" : "Thay thế",
                        ngay_ky: data.ngay_ky ? removeTimeZoneT(data.ngay_ky) : "",
                        ngay_ky_nmua: data.ngay_ky_nmua ? removeTimeZoneT(data.ngay_ky_nmua) : (data.ngay_nmua_ky ? removeTimeZoneT(data.ngay_nmua_ky) : "")
                    };
                    form.setValues(dataMapping);
                    $$("so_bban").setValues({ so_bban: data.so });
                    data.ngay_ky ? $$("btnSendEmail").show() : $$("btnSendEmail").hide();
                    if (options.delayedRefresh) {
                        setTimeout(function () {
                            $$("dai_dien_ben_a_tpl").refresh();
                            $$("invoice_replace_info").refresh();
                            if ($$("dai_dien_ben_b_tpl")) $$("dai_dien_ben_b_tpl").refresh();
                        }, 10);
                    } else {
                        $$("dai_dien_ben_a_tpl").refresh();
                        $$("invoice_replace_info").refresh();
                        if ($$("dai_dien_ben_b_tpl")) $$("dai_dien_ben_b_tpl").refresh();
                    }
                } else {
                    webix.message(responseData.message || "Không thể lấy chi tiết biên bản", "error");
                }
            }
        });
        return true;
    }
    function loadDefaultBienBan(initData, bienbanId, hoadon68_id_value, hdlketId, bienban_id, tchat, initial_ten_tt_value) {
        var khieu = initData.khieu;
        var shdon = initData.shdon || randomUniqueString(4);
        var defaultSoBienBan = `BB-${khieu}-${shdon}`;
        $$("so_bban").setValues({ so_bban: defaultSoBienBan });
        $$("so_bban").refresh();
        webix.ajax().get(app.config.host + "/Invoice68/GetInvoiceById?id=" + hdlketId, {
            error: function (err) {
                console.error("Lỗi khi lấy chi tiết hóa đơn liên kết:", err);
            },
            success: function (response1) {
                const responseData1 = JSON.parse(response1);
                const data1 = responseData1.data;

                webix.ajax().get(app.config.host + "/Invoice68/GetInvoiceById?id=" + hoadon68_id_value, {
                    error: function (err) {
                        console.error("Lỗi khi lấy thông tin người mua:", err);
                    },
                    success: function (response2) {
                        const responseData2 = JSON.parse(response2);
                        const data2 = responseData2.data;

                        webix.ajax().get(constant.API.GET_DMDVCS, {
                            error: function (err) {
                                console.error("Error fetching seller information:", err);
                            },
                            success: function (response3) {
                                const sellerInfo = JSON.parse(response3);
                                const mst_nban_cccd = sellerInfo.use_cccd ? sellerInfo.cccd_ndd : sellerInfo.ms_thue;
                                const mapdata = {
                                    bienban_id: bienban_id,
                                    so: defaultSoBienBan,
                                    kyhieu_mau: data1.khieu.charAt(0) || "",
                                    kyhieu_hd: data1.khieu.substring(1) || "",
                                    shdon: data1.shdon || "",
                                    ngay_hdon: data1.tdlap || "",
                                    nmua: data2.ten || "",
                                    mst_nmua: data2.mst || "",
                                    dchi_nmua: data2.dchi || "",
                                    nban: sellerInfo.ten_dvcs || "",
                                    mst_nban: mst_nban_cccd || "",
                                    dchi_nban: sellerInfo.dia_chi || "",
                                    sdt_nban: sellerInfo.dien_thoai || "",
                                    ddien_nban: sellerInfo.nguoi_dai_dien || "",
                                    chucvu_nban: sellerInfo.chuc_vu || "",
                                    ngay: new Date(),
                                    tchat: tchat,
                                    ten_tt: initial_ten_tt_value
                                };
                                var form = $$(bienbanId);
                                form.setValues(mapdata);
                                $$("invoice_replace_info").refresh();
                            }
                        });
                    }
                });
            }
        });
    }

    function showCertSelectionModal(title, dataUrl, columns, onConfirm) {
        var box = webix.modalbox({
            title: title,
            buttons: ["Nhận", "Hủy bỏ"],
            text: "<div id='ctnCerts'></div>",
            top: 100,
            width: 750,
            callback: function (result) {
                if (result === "1") {
                    webix.modalbox.hide(box);
                } else if (result === "0") {
                    var table = $$("tblCerts");
                    var data = table.serialize();
                    var cert = data.find(x => x.chon === true);
                    onConfirm(cert);
                }
            }
        });

        var popupText = document.getElementsByClassName("webix_popup_text")[0];
        if (popupText) popupText.style.paddingTop = 0;

        webix.ui({
            container: "ctnCerts",
            id: "tblCerts",
            view: "datatable",
            borderless: true,
            resizeColumn: true,
            height: 350,
            columns: columns,
            url: dataUrl
        });
    }
    function getCertColumns(fields) {
        const columnMap = {
            chon: {
                id: "chon", header: _("CHON"), width: 65,
                checkValue: true, uncheckValue: false, template: "{common.checkbox()}"
            },
            so_serial: { id: "so_serial", header: _("SO_SERIAL"), width: 150 },
            subjectname: { id: "subjectname", header: _("SUBJECTNAME"), width: 450 },
            ngaybatdau: { id: "ngaybatdau", header: _("NGAY_BAT_DAU"), width: 200 },
            ngayketthuc: { id: "ngayketthuc", header: _("NGAY_KET_THUC"), width: 200 },
            issuer: { id: "issuer", header: _("DONVI"), width: 450 },
            libraryName: { id: "libraryName", header: _("Loại"), width: 150 }
        };
        return fields.map(f => columnMap[f]);
    }
    function Sign(windowView, gridInvoice, savedBienbanId) {
        function enableUI() {
            windowView.enable();
            windowView.hideProgress();
        }

        function disableUI() {
            webix.extend(windowView, webix.ProgressBar);
            windowView.disable();
            windowView.showProgress();
        }

        function reloadGrid() {
            if (gridInvoice) {
                gridInvoice.clearAll();
                gridInvoice.load(gridInvoice.config.url);
            }
        }

        function signSuccess() {
            webix.message("Ký biên bản thành công!", "success");
            $$("btnSendEmail").show();
            reloadGrid();
            var form = $$(bienbanId);
            var bienban_id = form.getValues().bienban_id;
            loadBienBanById(bienban_id, bienbanId, { useTchat: true, refreshTemplateA: true, delayedRefresh: true });
        }

        webix.ajax()
            .headers({ "Content-type": "application/json" })
            .get(app.config.host + "/Pattern/GetSignType", function (text) {
                var result = JSON.parse(text);
                var kytaptrung = result[0].gia_tri;
                switch (kytaptrung.toUpperCase()) {
                    case "FILE":
                        var certUrl, certColumns, onCertConfirm;
                        certUrl = app.config.host + "/Invoice/GetListCertificatesFile";
                        certColumns = getCertColumns(["chon", "so_serial", "subjectname", "ngaybatdau", "ngayketthuc", "issuer"]);
                        onCertConfirm = function (cert) {
                            if (!cert) return showError("Bạn chưa chọn chứng thư số");

                            var postData = {
                                so_serial: cert.so_serial,
                                id: savedBienbanId
                            };
                            disableUI();

                            webix.ajax()
                                .headers({ 'Content-type': 'application/json' })
                                .post(app.config.host + constant.API.BIENBAN.SIGN_BIENBAN_BYFILE, postData, {
                                    error: function (text, data, XmlHttpRequest) {
                                        enableUI();
                                    },
                                    success: function (text) {
                                        enableUI();
                                        var response = JSON.parse(text);
                                        if (response.code != "00") return showError(response.message);

                                        signSuccess();
                                    }
                                });
                        };
                        showCertSelectionModal("Chọn chứng thư số", certUrl, certColumns, onCertConfirm);

                        break;
                    case "EASYCA":
                        var certUrl, certColumns, onCertConfirm;
                        certUrl = app.config.host + "/Invoice/GetListCertificatesEasyCA";
                        certColumns = getCertColumns(["chon", "libraryName", "so_serial", "subjectname", "ngaybatdau", "ngayketthuc", "issuer"]);
                        onCertConfirm = function (cert) {
                            if (!cert) return showError("Bạn chưa chọn chứng thư số");

                            cert.id = savedBienbanId;
                            cert.tagSign = "BIENBAN/DSCKS/NBan";
                            cert.tagSignId = "data";

                            webix.modalbox.hide();
                            var frm = form.$scope.ui(signEasyCA.$ui);
                            signEasyCA.initUI(cert, "bienban");
                            frm.show();
                        };
                        showCertSelectionModal("Chọn chứng thư số", certUrl, certColumns, onCertConfirm);

                        break;
                    case "ICA":
                        var certUrl, certColumns, onCertConfirm;
                        certUrl = app.config.host + "/Invoice/GetListCertificatesAuto";
                        certColumns = getCertColumns(["chon", "libraryName", "so_serial", "subjectname", "ngaybatdau", "ngayketthuc", "issuer"]);
                        onCertConfirm = function (cert) {
                            if (!cert) return showError("Bạn chưa chọn chứng thư số");

                            cert.id = savedBienbanId;
                            cert.tagSign = "/BIENBAN/DSCKS/NBan";
                            cert.tagSignId = "data";

                            webix.ajax().headers({ 'Content-type': 'application/text' })
                                .get(app.config.host + "/TokenCloud/CheckShowPinCode", function (text, data, XmlHttpRequest) {
                                    var response = JSON.parse(text);
                                    if (response.show == true) {
                                        var frm = $$("invoiceViews").$scope.ui(signICA.$ui);
                                        signICA.initUI(cert, "bienban");
                                        webix.modalbox.hide();
                                        frm.show();
                                    }
                                    else {
                                        disableUI();

                                        var apiHost = app.config.host + constant.API.BIENBAN.SIGN_BY_ICA;
                                        var param = {
                                            so_serial: cert.so_serial,
                                            pinCode: cert.pass,
                                            id: savedBienbanId,
                                            agreementUUID: cert.value
                                        };
                                        webix.ajax()
                                            .headers({ 'Content-type': 'application/json' })
                                            .post(apiHost, param, {
                                                error: function (text, data, XmlHttpRequest) {
                                                    enableUI();
                                                },
                                                success: function (text, data, XmlHttpRequest) {
                                                    var response = JSON.parse(text);
                                                    enableUI();
                                                    if (response.code != "00") return showError(response.message);
                                                    signSuccess();
                                                }
                                            });
                                    }
                                });
                        };
                        showCertSelectionModal("Chọn chứng thư số", certUrl, certColumns, onCertConfirm);

                        break;
                    case "INTRUSTCA":
                        var certUrl, certColumns, onCertConfirm;
                        certUrl = app.config.host + "/Invoice/GetListCertificatesAuto";
                        certColumns = getCertColumns(["chon", "libraryName", "so_serial", "subjectname", "ngaybatdau", "ngayketthuc", "issuer"]);
                        onCertConfirm = function (cert) {
                            if (!cert) return showError("Bạn chưa chọn chứng thư số");

                            var signModel = {
                                user_name: cert.username,
                                credentialID: cert.tokenSerial,
                                certificate: cert.cert_content,
                                pinCode: cert.pin_code,
                                auth_data: cert.auth_data,
                                mode: 1,
                                hoadon: [savedBienbanId]
                            }

                            disableUI();
                            webix.ajax().headers({ "Content-Type": "application/json" })
                                .post(app.config.host + constant.API.BIENBAN.SIGN_BY_INTRUSTCA, JSON.stringify(signModel), function (text) {
                                    enableUI();
                                    var result = JSON.parse(text);
                                    if (result.code != "00") return showError(response.message);
                                    signSuccess();

                                });
                        };
                        showCertSelectionModal("Chọn chứng thư số", certUrl, certColumns, onCertConfirm);
                        break;
                    default:
                        disableUI();
                        var a = webix.ajax(app.config.host + constant.API.BIENBAN.GET_XML + "?id=" + savedBienbanId);
                        var b = webix.ajax(app.config.host + "/Pattern/GetListCertificates");
                        var c = webix.ajax(app.config.host + "/Pattern/GetSerialAcceptInvoice");
                        webix.promise.all([a, b, c]).then(function (results) {
                            var xmlData = results[0].json();
                            var listcerts = results[1].json();
                            var listCertAccept = results[2].json();
                            if (xmlData.code != "00") {
                                enableUI();
                                showError(xmlData.message);
                                return;
                            }
                            if (listcerts.length == 0) {
                                enableUI();
                                showError("Bạn chưa được phân quyền chứng thư số");
                                return;
                            }
                            if (listCertAccept == undefined || listCertAccept.length == 0) {
                                enableUI();
                                showError("Đăng ký sử dụng hóa đơn NĐ 123 chưa được CQT chấp thuận.");
                                return;
                            }
                            require(["views/modules/minvoiceplugin"], function (plugin) {
                                var hub = plugin.hub();
                                var hubconnect = plugin.conn();

                                if (hubconnect.state != 1) {
                                    enableUI();
                                    webix.message("Quý khách hàng chưa cài Plugin ký hóa đơn hoặc Plugin ký hóa đơn chưa được bật !", "error");
                                    var Form = form.$scope.ui(modalPlugin.$ui);
                                    Form.show();
                                    return;
                                }
                                hub.off('resCommand');
                                hub.on('resCommand', function (result) {
                                    enableUI();
                                    var responseSign = JSON.parse(result);
                                    if (responseSign.hasOwnProperty("error")) return showError(responseSign.error);

                                    var parameters = {
                                        xml: responseSign.xml,
                                        id: savedBienbanId
                                    };
                                    webix.ajax()
                                        .headers({ "Content-Type": "application/json" })
                                        .post(app.config.host + constant.API.BIENBAN.SAVE_XML, parameters, function (text) {
                                            var response = JSON.parse(text);
                                            if (response.code != "00") return showError(response.message);
                                            signSuccess();
                                        });
                                });

                                var _listcerts = [];

                                for (var i = 0; i < listcerts.length; i++) {
                                    var _cert = listcerts[i];

                                    _listcerts.push({
                                        so_serial: _cert.so_serial,
                                        ngaybatdau: _cert.ngaybatdau,
                                        ngayketthuc: _cert.ngayketthuc,
                                        issuer: _cert.issuer,
                                        subjectname: _cert.subjectname
                                    });
                                }

                                var arg = {
                                    idData: "#" + savedBienbanId,
                                    xml: xmlData.data["xml"],
                                    shdon: "",
                                    idSigner: "",
                                    tagSign: "NBan",
                                    listcerts: _listcerts,
                                    certAccept: listCertAccept
                                };
                                hub.invoke('execCommand', 'SignXmlTag', JSON.stringify(arg))
                                    .done(function () { console.log("Success !") })
                                    .fail(function (error) { showError(error); });
                            });
                        }).fail(function () {
                            enableUI();
                            showError("Lỗi trong quá trình lấy dữ liệu ký biên bản");
                        });
                        break;
                }
            });
    }
    var thongtinbenban = {
        rows: [
            {
                cols: [
                    { view: "datepicker", name: "ngay", label: "Hôm nay, ngày", id: "ngay", value: new Date(), stringResult: true, format: "%d/%m/%Y", width: 280, },
                    { view: "label", label: "Chúng tôi gồm có:", borderless: true, css: "text-left", width: 400, },
                ]
            },
            {
                view: "text",
                label: "<b>Bên A (Bên bán)</b>",
                name: "nban",
                id: "nban",
                required: true,
                attributes: { maxlength: 400 },
                invalidMessage: "Tên đơn vị bán không được để trống !",
                validate: webix.rules.isNotEmpty,
                on: {
                    onAfterRender: function () {
                        var value = this.getValue();
                        this.getInputNode().style.fontWeight = 'bold';
                    }
                }
            },
            {
                view: "text",
                label: "Địa chỉ",
                id: "dchi_nban",
                name: "dchi_nban",
                required: true,
                attributes: { maxlength: 400 },
                invalidMessage: "Địa chỉ đơn vị bán không được để trống !",
                validate: webix.rules.isNotEmpty
            },
            {
                cols: [
                    {
                        view: "text",
                        label: "Mã số thuế",
                        id: "mst_nban",
                        name: "mst_nban",
                        required: true,
                        invalidMessage: "Mã số thuế bên bán không được để trống !",
                        validate: webix.rules.isNotEmpty,
                        on: {
                            onBlur: function () {
                                var mst = this.getValue();
                                if (mst) validateTaxCode(mst);
                            }
                        }
                    },
                    { view: "text", label: "Số điện thoại", id: "sdt_nban", name: "sdt_nban", attributes: { maxlength: 20 }, }
                ]
            },
            {
                cols: [
                    {
                        view: "text",
                        label: "Đại diện",
                        id: "ddien_nban",
                        name: "ddien_nban",
                        attributes: { maxlength: 400 },
                        invalidMessage: "Tên người đại diện không được để trống !",
                        validate: webix.rules.isEmpty
                    },
                    {
                        view: "text",
                        label: "Chức vụ",
                        id: "chucvu_nban",
                        name: "chucvu_nban",
                        attributes: { maxlength: 400 },
                        invalidMessage: "Chức vụ không được để trống !",
                        validate: webix.rules.isEmpty
                    }
                ]
            },
        ]
    };
    var thongtinbenmua = {
        rows: [
            {
                view: "text",
                label: "<b>Bên B (Bên mua)</b>",
                name: "nmua",
                id: "nmua",
                required: true,
                attributes: { maxlength: 400 },
                invalidMessage: "Tên đơn vị mua không được để trống !",
                validate: webix.rules.isNotEmpty,
                on: {
                    onAfterRender: function () {
                        var value = this.getValue();
                        this.getInputNode().style.fontWeight = 'bold';
                    }
                }
            },
            {
                view: "text",
                label: "Địa chỉ",
                id: "dchi_nmua",
                name: "dchi_nmua",
                attributes: { maxlength: 400 },
            },
            {
                cols: [
                    {
                        view: "text", label: "Mã số thuế", id: "mst_nmua", name: "mst_nmua",
                        on: {
                            onBlur: function () {
                                var mst = this.getValue();
                                if (mst) validateTaxCode(mst);
                            }
                        }
                    },
                    { view: "text", label: "Số điện thoại", id: "sdt_nmua", name: "sdt_nmua", attributes: { maxlength: 20 }, }
                ]
            },
            {
                cols: [
                    {
                        view: "text",
                        label: "Đại diện",
                        id: "ddien_nmua",
                        name: "ddien_nmua",
                        attributes: { maxlength: 400 },
                        invalidMessage: "Tên người đại diện không được để trống !",
                        validate: webix.rules.isEmpty
                    },
                    {
                        view: "text",
                        label: "Chức vụ",
                        id: "chucvu_nmua",
                        name: "chucvu_nmua",
                        attributes: { maxlength: 400 },
                        invalidMessage: "Chức vụ không được để trống !",
                        validate: webix.rules.isEmpty
                    }
                ]
            },
        ]
    };
    return {
        $ui: {
            view: "window",
            modal: true,
            position: function (state) {
                state.width = state.maxWidth * 0.6;
                state.height = state.maxHeight * 0.92;
                state.left = (state.maxWidth - state.width) / 2;
                state.top = (state.maxHeight - state.height) / 2;
            },
            css: "headformchil",
            id: bienbanForm,
            resize: true,
            fullscreen: true,
            move: true,
            head: {
                cols: [
                    { view: "label", label: "<b>Lập biên bản</b>", align: "left", css: { "padding-left": "10px" } },
                    {},
                    {
                        view: "label",
                        tooltip: "Đóng",
                        label: `<b style="border-radius:9999999px; padding:0.25rem; cursor: pointer; margin-right:1rem; border: 1px solid black: "> X </b>`,
                        align: "right",
                        css: "",
                        click: function () {
                            this.getTopParentView().close();
                        }
                    },

                ]
            },
            on: {
                onShow: function () {
                    var self = this;
                    $(".webix_modal").one("click", function () {
                        self.close();
                    });

                    var form = $$(bienbanId);
                    var formValues = form.getValues();

                    var hoadon68_id_value = formValues.hoadon68_id || "";
                    var hdlketId = formValues.hdlket_id;
                    var bienban_id = formValues.bienban_id;
                    var initial_ten_tt_value = formValues.ten_tt || "";

                    form.config.hoadon68_id = hoadon68_id_value;

                    var labelText = initial_ten_tt_value.toLowerCase().includes("điều chỉnh") ? "Lý do điều chỉnh" : "Lý do thay thế";
                    var tchat = initial_ten_tt_value.toLowerCase().includes("điều chỉnh") ? 1 : 2;
                    $$("ten_tt").setValue(initial_ten_tt_value);
                    $$("ldo").define("label", labelText);
                    $$("ldo").refresh();

                    if (!loadBienBanById(bienban_id, bienbanId, tchat)) {
                        loadDefaultBienBan(initData, bienbanId, hoadon68_id_value, hdlketId, bienban_id, tchat, initial_ten_tt_value);
                    }
                }
            },

            body: {
                view: "form",
                id: bienbanId,
                // width: 1500,
                position: "center",
                // autowidth:true,
                elementsConfig: { labelWidth: 150 },
                paddingY: 10,
                paddingX: 10,
                complexData: true,
                height: 1200,
                scroll: true,
                margin: 0,
                elements: [
                    {
                        template: "<div class='headRegisters' style='text-align:center;font-weight:bold;font-size:20px;'>CỘNG HÒA XÃ HỘI CHỦ NGHĨA VIỆT NAM</div>",
                        borderless: true
                    },
                    {
                        template: "<div class='headRegister' style='text-align:center;'>Độc lập - Tự do - Hạnh phúc</div>",
                        borderless: true
                    },
                    {
                        template: function () {
                            var formValues = $$(bienbanId).getValues();
                            var ten_tt = formValues.ten_tt || "";
                            return `<div id='bienban_title' class='headRegisters' style='text-align:center;font-weight:bold;'>BIÊN BẢN ${ten_tt.toUpperCase()} HÓA ĐƠN</div>`;
                        },
                        borderless: true
                    },
                    { view: "text", id: "so", name: "so", hidden: true },
                    {
                        template: "<div style='text-align:center;'>Số biên bản: #so_bban#</div>",
                        borderless: true,
                        id: "so_bban",
                    },
                    {
                        template: "<hr style='border: none; border-top: 1px solid #333; width: 70%; margin: 10px auto;'>",
                        borderless: true
                    },
                    {
                        template: "- Căn cứ Nghị định 70/2025/NĐ-CP ngày 20/3/2025 của Chính phủ quy định về hóa đơn, chứng từ.",
                        borderless: true
                    },
                    {
                        template: "- Căn cứ vào thỏa thuận giữa các bên.",
                        borderless: true
                    },
                    {
                        template: "<hr style='border: none; border-top: 1px solid #333; width: 70%; margin: 10px auto;'>",
                        borderless: true
                    },
                    thongtinbenban,
                    thongtinbenmua,
                    { view: "text", hidden: true, id: "kyhieu_mau", name: "kyhieu_mau" },
                    { view: "text", hidden: true, id: "kyhieu_hd", name: "kyhieu_hd" },
                    { view: "text", hidden: true, id: "shdon", name: "shdon" },
                    { view: "text", hidden: true, id: "ngay_hdon", name: "ngay_hdon", },
                    { view: "text", hidden: true, id: "ten_tt", name: "ten_tt" },
                    { view: "text", hidden: true, id: "hoadon68_id", name: "hoadon68_id" },
                    { view: "text", hidden: true, id: "ngay_bke", name: "ngay_bke", },
                    { view: "text", hidden: true, id: "so_bke", name: "so_bke", },
                    { view: "text", hidden: true, id: "ngay_ky", name: "ngay_ky", },
                    {
                        css: "template-left",
                        id: "invoice_replace_info",
                        template: function () {
                            var kyhieu_mau = $$("kyhieu_mau").getValue();
                            var kyhieu_hd = $$("kyhieu_hd").getValue();
                            var shdon = $$("shdon").getValue();
                            var ngay_hdon_raw = $$("ngay_hdon").getValue();
                            var ten_tt = ($$("ten_tt").getValue() || "").toLowerCase();

                            return `<div style="height:fit-content">
                                        Hai bên thống nhất lập biên bản này để ${ten_tt} 
                                        cho hóa đơn có mẫu số <b>${kyhieu_mau}</b>, 
                                        ký hiệu <b>${kyhieu_hd}</b>, 
                                        số <b>${shdon}</b>, 
                                        ngày <b>${formatDate(ngay_hdon_raw)}</b> theo quy định.
                                    </div>`;
                        },
                        borderless: true,
                        height: "auto"
                    },
                    {
                        view: "text",
                        label: function () {
                            var ten_tt = ($$(bienbanId).getValues().ten_tt || "");
                            return "Lý do " + ten_tt;
                        },
                        name: "ldo",
                        id: "ldo",
                        required: true,
                        attributes: { maxlength: 500 },
                        invalidMessage: "Lý do không được để trống !",
                        validate: webix.rules.isNotEmpty
                    },
                    {
                        css: "template-left",
                        template: "Chúng tôi xin cam đoan các thông tin khai ở trên là hoàn toàn chính xác. Nếu có bất kỳ sai sót nào chúng tôi xin chịu trách nhiệm trước pháp luật.",
                        borderless: true
                    },
                    {
                        cols: [
                            {
                                id: "dai_dien_ben_a_tpl",
                                template: function () {
                                    var formValues = $$(bienbanId).getValues() || {};
                                    var ngayky = formValues.ngay_ky || "";
                                    var nban = formValues.nban || "";
                                    var html = `
                                                <div style='text-align:center; font-weight:bold;'>ĐẠI DIỆN BÊN A</div>
                                                <div style='text-align:center;'>(Chữ ký số, chữ ký điện tử)</div>
                                            `;

                                    if (ngayky) {
                                        html += `
                                                <div style="margin: 4px auto; padding: 3px 8px; width: 85%; border: 2px solid #28a745; border-radius: 0; background-color: #f8fff8; text-align: left; overflow:hidden;">
                                                    <div style="color:#28a745; font-weight:bold; font-size:13px; margin-bottom:2px;">
                                                        Signature Valid
                                                    </div>
                                                    <div style="color:#28a745; font-size:12px; margin-bottom:2px; word-break:break-word; white-space:normal">
                                                        Ký bởi: ${nban}
                                                    </div>
                                                    <div style="color:#28a745; font-size:12px; position:relative; display:flex; align-items:center; gap:5px; flex-wrap:wrap; word-break:break-word; white-space:normal;">
                                                        <span>Ký ngày: ${formatDateTime(ngayky)}</span>
                                                        <span style="color:#28a745; font-size:48px; font-weight:500; position:absolute; bottom:-12px; right:-12px;">✓</span>
                                                    </div>
                                                </div>
                                            `;
                                    }
                                    return html;

                                },
                                borderless: true,
                                on: { onShow: function () { this.refresh(); } }
                            },
                            {
                                id: "dai_dien_ben_b_tpl",
                                template: function () {
                                    var formValues = $$(bienbanId).getValues() || {};
                                    var ngayky = formValues.ngay_ky_nmua || formValues.ngay_nmua_ky || "";
                                    var nmua = formValues.nmua || "";

                                    var html = `
                                                <div style='text-align:center; font-weight:bold;'>ĐẠI DIỆN BÊN B</div>
                                                <div style='text-align:center;'>(Chữ ký số, chữ ký điện tử)</div>
                                            `;
                                    if (ngayky) {
                                        html += `
                                             <div style="margin: 4px auto; padding: 3px 8px; width: 85%; border: 2px solid #28a745; border-radius: 0; background-color: #f8fff8; text-align: left;">
                                                    <div style="color:#28a745; font-weight:bold; font-size:13px; margin-bottom:2px;">
                                                        Signature Valid
                                                    </div>
                                                    <div style="color:#28a745; font-size:12px; margin-bottom:2px; word-wrap: break-word;overflow-wrap: break-word;">
                                                        Ký bởi: ${nmua}
                                                    </div>
                                                    <div style="color:#28a745; font-size:12px; position:relative; display:flex; align-items:center; gap:5px;">
                                                        <span>Ký ngày: ${formatDateTime(ngayky)}</span>
                                                        <span style="color:#28a745; font-size:48px; font-weight:500; position:absolute; bottom:-12px; right:-12px;">✓</span>
                                                    </div>
                                            </div>
                                        `;
                                    }
                                    return html;
                                },
                                borderless: true,
                                on: { onShow: function () { this.refresh(); } }
                            }
                        ]
                    },

                    { height: 65 },
                    {
                        cols: [
                            {},
                            {
                                view: "button",
                                label: "Lưu & Ký",
                                id: "btnSaveAndSign",
                                width: 150,
                                align: "center",
                                type: "form",
                                on: {
                                    onItemClick: function () {
                                        var form = $$(bienbanId);
                                        if (form.validate()) {
                                            var data = form.getValues();
                                            data.hoadon68_id = form.config.hoadon68_id;
                                            data.bienban_id = data.bienban_id || "00000000-0000-0000-0000-000000000000";
                                            data.khieu_hdon = (data.kyhieu_mau || "") + (data.kyhieu_hd || "");
                                            data.xml_send = null;

                                            webix.extend(form, webix.ProgressBar);
                                            form.disable();
                                            form.showProgress();
                                            webix.ajax()
                                                .headers({ "Content-Type": "application/json" })
                                                .post(app.config.host + constant.API.BIENBAN.SAVE_BIENBAN, JSON.stringify(data), {
                                                    success: function (response) {
                                                        form.enable();
                                                        form.hideProgress();
                                                        var result = JSON.parse(response);
                                                        if (result.code != "00") return showError(result.message);
                                                        var savedBienbanId = result.data.bienban_id;
                                                        form.setValues({ bienban_id: savedBienbanId }, true);
                                                        var windowView = $$(bienbanForm);
                                                        var gridInvoice = $$("invoiceViews");
                                                        Sign(windowView, gridInvoice, savedBienbanId);
                                                    },
                                                    error: function (err) {
                                                        form.enable();
                                                        form.hideProgress();
                                                        console.error("Error saving:", err);
                                                        webix.message("Lỗi khi lưu biên bản!", "error");
                                                    }
                                                });
                                        } else {
                                            webix.message("Vui lòng nhập đầy đủ thông tin!", "error");
                                        }
                                    }
                                }
                            },
                            {
                                view: "button",
                                label: "Lưu",
                                id: "btnSave",
                                width: 150,
                                align: "center",
                                type: "form",
                                click: function () {
                                    var form = $$(bienbanId);
                                    if (form.validate()) {
                                        var data = form.getValues();
                                        data.hoadon68_id = form.config.hoadon68_id;
                                        data.bienban_id = data.bienban_id || "00000000-0000-0000-0000-000000000000";
                                        data.khieu_hdon = (data.kyhieu_mau || "") + (data.kyhieu_hd || "");
                                        data.xml_send = null;

                                        webix.extend(form, webix.ProgressBar);
                                        form.disable();
                                        form.showProgress();
                                        webix.ajax()
                                            .headers({ "Content-Type": "application/json" })
                                            .post(app.config.host + constant.API.BIENBAN.SAVE_BIENBAN, JSON.stringify(data), {
                                                error: function (err) {
                                                    form.enable();
                                                    form.hideProgress();
                                                },
                                                success: function (text) {
                                                    form.enable();
                                                    form.hideProgress();
                                                    const response = JSON.parse(text);
                                                    if (response.code == "00") {
                                                        webix.message(response.message || "Lưu biên bản thành công!", "success");
                                                        var windowView = $$(bienbanForm);
                                                        windowView.close();
                                                        var grid = $$("invoiceViews");
                                                        if (grid) {
                                                            grid.clearAll();
                                                            grid.load(grid.config.url);
                                                        }
                                                    } else {
                                                        webix.message(response.message || "Lưu biên bản thất bại", "error");
                                                    }
                                                }
                                            });
                                    }
                                }
                            },
                            {
                                view: "button",
                                label: "Ký",
                                id: "btnKy",
                                width: 150,
                                align: "center",
                                type: "form",
                                on: {
                                    onItemClick: function () {
                                        var form = $$(bienbanId);
                                        var bienban_id = form.getValues().bienban_id;

                                        if (bienban_id && bienban_id !== "00000000-0000-0000-0000-000000000000") {
                                            var windowView = $$(bienbanForm);
                                            var gridInvoice = $$("invoiceViews");
                                            Sign(windowView, gridInvoice, bienban_id);
                                        } else {
                                            webix.message("Không tìm thấy biên bản để ký. Vui lòng lưu biên bản trước!", "error");
                                        }
                                    }
                                }
                            },
                            {
                                view: "button",
                                label: "Gửi Email",
                                id: "btnSendEmail",
                                width: 150,
                                align: "center",
                                type: "form",
                                hidden: true,
                                click: function () {
                                    var bienbanData = $$(bienbanId).getValues();
                                    if (!bienbanData.bienban_id || bienbanData.bienban_id === "00000000-0000-0000-0000-000000000000") {
                                        webix.message("Chưa có biên bản để gửi email!", "error");
                                        return;
                                    }
                                    if (!$$("sendemail-win")) {
                                        webix.ui(sendEmail.$ui);
                                    }
                                    sendEmail.show(bienbanData);
                                }
                            },
                            {}
                        ]
                    }
                ]
            }
        },
        initUI: function (item) {
            initData = item;
        }
    };

});
define('views/forms/forms70/BienBan/uploadBienBan',["app", "locale", "views/modules/Component/constantManager"], function (app, _, CONSTANTS) {
    var uploadPdfwin = "uploadpdf-win";
    var uploadForm = "uploadpdf-form";
    var bienbanId = null;

    return {
        $ui: {
            view: "window",
            modal: true,
            id: uploadPdfwin,
            position: "center",
            head: "Tải file biên bản",
            width: 500,
            height: 500,
            resize: true,
            body: {
                paddingY: 10,
                paddingX: 10,
                elementsConfig: { labelWidth: 100 },
                view: "form",
                id: uploadForm,
                complexData: true,
                elements: [
                    {
                        rows: [
                            {
                                rows: [
                                    {
                                        id: "uploader",
                                        view: "uploader",
                                        value: "Chọn file",
                                        hide: true,
                                        name: "uploader",
                                        accept: "application/pdf,image/png,image/jpeg",
                                        link: "mylist",
                                        autosend: false,
                                        multiple: false,
                                        apiOnly: true,
                                        on: {
                                            onAfterRender: function () {
                                                this.hide();
                                            },
                                        }
                                    },
                                    {
                                        view: "list",
                                        id: "mylist",
                                        name: "mylist",
                                        css: "lst-uploadPdf",
                                        type: {
                                            template: function (obj) {
                                                return `<span class='webix_upload_file' style='cursor:pointer;color:#36a;'>${obj.name}</span>`;
                                            },
                                            height: 30
                                        },
                                        height: 120,
                                        borderless: true,
                                        onClick: {
                                            "webix_upload_file": function (e, id) {
                                                var file = this.getItem(id);
                                                if (!file || !file.name) {
                                                    webix.message("Không tìm thấy file!", "error");
                                                    return;
                                                }

                                                var box = webix.modalbox({
                                                    title: "Đang tải file xem trước...",
                                                    text: "<p><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                                                    width: 350,
                                                    height: 200,
                                                });

                                                var newWin = window.open();
                                                var html = "<html><head><title>Xem trước file</title>" +
                                                    '<link rel="stylesheet" href="assets/fontawesome_pro/css/all.css" type="text/css" charset="utf-8">' +
                                                    '<link rel="stylesheet" href="assets/fontawesome.css" type="text/css" charset="utf-8">' +
                                                    '</head><body><center>Đang tải dữ liệu ... <br><p><i style="font-size:200%;" class="fa fa-spin fa-spinner"></i></p></center></body></html>';
                                                newWin.document.write(html);
                                                webix.ajax()
                                                    .response("arraybuffer")
                                                    .get(app.config.host + "/BienBan70/PreviewFileByFileName?fileName=" + encodeURIComponent(file.name), {
                                                        error: function (xhr, data, req) {
                                                            webix.modalbox.hide(box);
                                                            webix.message("Không thể xem trước file", "error");
                                                            console.error("Lỗi khi gọi preview file:", xhr);
                                                            newWin.close();
                                                        },
                                                        success: function (res, data, xhr) {
                                                            webix.modalbox.hide(box);
                                                            try {
                                                                const contentType = xhr.getResponseHeader("Content-Type") || "application/pdf";
                                                                const blob = new Blob([data], { type: contentType });
                                                                const url = URL.createObjectURL(blob);
                                                                newWin.location = url;
                                                            } catch (e) {
                                                                webix.message("Lỗi khi xử lý file", "error");
                                                                newWin.close();
                                                            }
                                                        }
                                                    });
                                            }
                                        }
                                    },
                                ],
                            },
                            { height: 10 },
                            {
                                view: "toolbar",
                                borderless: true,
                                cols: [
                                    {},
                                    {
                                        view: "button",
                                        type: "icon",
                                        icon: "mdi mdi-folder-open-outline",
                                        label: "Chọn file",
                                        on: {
                                            onClick: function () {
                                                webix.$$("uploader").fileDialog();
                                            },
                                        },
                                        click: function () {
                                            this.callEvent("onClick");
                                        },
                                    },
                                    {
                                        shortcut: "F10",
                                        view: "button",
                                        label: "Nhận (F10)",
                                        type: "icon",
                                        align: "center",
                                        icon: "mdi mdi-check",
                                        id: "uploadPDF",
                                        width: 110,
                                        click: function () {
                                            var list = $$("mylist");
                                            var file = list.getFirstId() ? list.getItem(list.getFirstId()) : null;
                                            if (!file || !file.file) return showError("Vui lòng chọn file để tải lên");
                                            if (!bienbanId) return showError("Cần lập biên bản tại phần mềm trước khi đính kèm file");
                                            if (file.file.size > 1 * 1024 * 1024) return showError("Kích thước file không được vượt quá 1MB");

                                            var allowedTypes = [".pdf", ".jpeg", ".png", ".jpg"];
                                            var extension = file.name.substring(file.name.lastIndexOf(".")).toLowerCase();
                                            if (!allowedTypes.includes(extension)) return showError("Chỉ chấp nhận file PDF hoặc Ảnh");

                                            webix.extend($$(uploadForm), webix.ProgressBar);
                                            $$(uploadForm).disable();
                                            $$(uploadForm).showProgress();

                                            $$("uploader").define({
                                                upload: app.config.host + CONSTANTS.API.BIENBAN.UPLOAD_BIENBAN,
                                                formData: { bienban_id: bienbanId }
                                            });
                                            $$("uploader").send(function (response) {
                                                $$(uploadForm).enable();
                                                $$(uploadForm).hideProgress();

                                                if (response.code == "00") {
                                                    webix.message("Tải file lên thành công", "success");
                                                    $$("mylist").clearAll();
                                                    $$(uploadPdfwin).close();
                                                } else {
                                                    webix.message(response.message || "Có lỗi xảy ra", "error");
                                                }

                                            });
                                        }
                                    },
                                    {
                                        view: "button",
                                        hotkey: "esc",
                                        label: "Hủy (ESC)",
                                        type: "icon",
                                        icon: "mdi mdi-close",
                                        align: "center",
                                        on: {
                                            onClick: function () {
                                                $$("mylist").clearAll();
                                                $$("mylist").unbind();
                                                var id = $$("uploader").files.getFirstId();
                                                if (id) {
                                                    $$("uploader").stopUpload(id);
                                                }
                                                $$(uploadPdfwin).close();
                                            },
                                        },
                                        click: function () {
                                            this.callEvent("onClick");
                                        },
                                    },
                                    {}
                                ],
                            },
                            { height: 10 }
                        ]
                    }
                ]
            }
        },
        initUI: function (id, item) {
            bienbanId = id;
            webix.$$(uploadPdfwin).getHead().setHTML(`Biên bản của hóa đơn số: ${item.shdon} Ký hiệu: ${item.khieu}`);
            this.getDetails();
        },
        getDetails: function () {
            if (!bienbanId) return;

            webix.ajax().get(app.config.host + CONSTANTS.API.BIENBAN.GET_BIENBAN_BY_ID + "?id=" + bienbanId, {
                error: function (err) {
                    console.error("Lỗi khi lấy chi tiết biên bản:", err);
                    webix.message("Không thể lấy chi tiết biên bản", "error");
                },
                success: function (response) {
                    const responseData = JSON.parse(response);
                    if (responseData.code == "00" && responseData.data) {
                        const filePath = responseData.data.file_path;
                        if (filePath) {
                            $$("mylist").clearAll();
                            $$("mylist").add({ name: filePath });
                        }
                    }
                }
            });
        }
    };
});

define('views/forms/frmPassPrint',["app"], function (app) {
    var editmode = 0;
    var item;
    function initUI(obj) {
        item = obj;
    }
    return {
        $ui: {
            view: "window",
            modal: true,
            id: "printA",
            position: "center",
            head: "In hóa đơn",
            move: true,
            height: 500,
            minWidth: 500,
            body: {
                view: "form",
                id: "printA-frm",
                elements: [
                    { view: "label", label: "Hóa đơn đã được in. Bạn hãy nhập mã để được in lần tiếp theo !" },
                    {
                        view: "text", id: "pass", type: "password", label: "Password", required: true,
                        invalidMessage: "Mật khẩu không được để trống",
                        validate: webix.rules.isNotEmpty
                    },
                    {
                        cols: [
                            {},
                            {
                                shortcut: "F10", view: "button", label: "In (F10)", type: "form", align: "center", width: 120,
                                on: {
                                    onClick: function () {
                                        if ($$("printA-frm").validate()) {
                                            if ($$("pass").getValue() == "nampv") {
                                                if (editmode == 1) {
                                                    var cbMauIn = $$("cbMauIn");
                                                    var cbTypeIn = $$("cbTypeIn");

                                                    var rpParameter = {
                                                        parameter: item,
                                                        wb_mauin_id: cbMauIn.getValue(),
                                                        type: cbTypeIn.getValue()
                                                    };

                                                    var mimetype = cbTypeIn.getValue() == "PDF" ? "application/pdf" : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

                                                    var url = app.config.host + "/System/InChungTu";

                                                    var box = webix.modalbox({
                                                        title: "Đang in chứng từ",
                                                        text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                                                        width: 350,
                                                        height: 200
                                                    });

                                                    var newWin = window.open();

                                                    webix.ajax()
                                                        .response("arraybuffer")
                                                        .headers({ 'Content-type': 'application/json' })
                                                        .post(url, rpParameter, {
                                                            error: function (text, data, XmlHttpRequest) {
                                                                webix.modalbox.hide(box);
                                                                alert(text);
                                                            },
                                                            success: function (text, data, XmlHttpRequest) {
                                                                var file = new Blob([data], { type: mimetype });
                                                                var fileURL = URL.createObjectURL(file);

                                                                webix.modalbox.hide(box);
                                                                // var win = $$("windowData").$scope.ui(printf.$ui);
                                                                // win.config.url = fileURL;
                                                                // win.show();
                                                                newWin.location = fileURL;
                                                            }
                                                        });
                                                    $$("printA").close();
                                                }
                                                if (editmode == 2) {
                                                    var cbMauIn = $$("cbMauIn");
                                                    var rpParameter = {
                                                        parameter: item,
                                                        wb_mauin_id: cbMauIn.getValue(),
                                                        type: "PDF"
                                                    };

                                                    var mimetype = "application/pdf";

                                                    var url = app.config.host + "/System/PrintInvoiceMulti";

                                                    var box = webix.modalbox({
                                                        title: "Đang in chứng từ",
                                                        text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                                                        width: 350,
                                                        height: 200
                                                    });

                                                    var newWin = window.open();

                                                    webix.ajax()
                                                        .response("arraybuffer")
                                                        .headers({ 'Content-type': 'application/json' })
                                                        .post(url, rpParameter, {
                                                            error: function (text, data, XmlHttpRequest) {
                                                                webix.modalbox.hide(box);
                                                                alert(text);
                                                            },
                                                            success: function (text, data, XmlHttpRequest) {
                                                                var file = new Blob([data], { type: mimetype });
                                                                var fileURL = URL.createObjectURL(file);

                                                                webix.modalbox.hide(box);
                                                                // var win = $$("windowData").$scope.ui(printf.$ui);
                                                                // win.config.url = fileURL;
                                                                // win.show();
                                                                newWin.location = fileURL;
                                                            }
                                                        });
                                                    $$("printA").close();
                                                }
                                            }
                                            else {
                                                webix.message("Mật khẩu không đúng !", "error");
                                                return;
                                            }
                                        }
                                    }
                                },
                                click: function () {
                                    this.callEvent("onClick");

                                }
                            },
                            {
                                view: "button", id: "btnCancel", shortcut: "esc", label: "Hủy bỏ (ESC)", type: "danger", align: "center",
                                width: 120,
                                on: {
                                    onClick: function () {
                                        $$("printA").close();
                                    }
                                },
                                click: function () {
                                    this.callEvent("onClick");
                                }
                            },
                            {}
                        ]
                    }
                ]
            }
        },
        setEditMode: function (mode) {
            editmode = mode;
        },
        initUI: initUI
    };

});
define('views/forms/kyhoadon',[
    "app",
    "locale",
    "models/user",
    "views/modules/minvoiceplugin"
], function (app, _, user, plugin) {
    var editmode = 0;

    return {
        $ui: {
            view: "window", modal: true, id: "chukyso-win", position: "center",
            head: "Ký hóa đơn chờ ký",
            //fullscreen: true,
            width: 600,
            height: 600,
            body: {
                paddingY: 10,
                paddingX: 10,
                view: "form",
                id: "chukyso-form",
                complexData: true,
                margin: 0,
                elements: [
                    {
                        cols: [
                            {
                                view: "datepicker",
                                name: "tu_ngay",
                                format: "%d/%m/%Y",
                                label: "Từ ngày",
                                width: 290,
                                labelPosition: "top"
                            },
                            {
                                view: "datepicker",
                                name: "den_ngay",
                                format: "%d/%m/%Y",
                                label: "Đến ngày",
                                width: 290,
                                labelPosition: "top"
                            },
                        ]
                    },
                    {
                        view: "combo",
                        name: "inv_InvoiceCode_id",
                        label: "Ký hiệu",
                        width: 600,
                        labelPosition: "top",
                        options: app.config.host + "/System/GetDataReferencesByRefId?refId=RF00029"
                    },
                    {
                        view: "combo",
                        width: 600,
                        name: "cerSerial",
                        label: "Chứng thư số",
                        labelPosition: "top",
                        id: "txtCerSerial",
                        options: {
                            view: "gridsuggest",
                            url: app.config.host + "/Invoice/GetListCertificates",
                            body: {
                                columns: [
                                    {
                                        id: "so_serial",
                                        header: _("SO_SERIAL"),
                                        width: 150
                                    },
                                    {
                                        id: "subjectname",
                                        header: _("SUBJECTNAME"),
                                        width: 550
                                    },
                                    {
                                        id: "ngaybatdau",
                                        header: _("NGAY_BAT_DAU"),
                                        width: 150,
                                        format: function (text) {
                                            var format = webix.Date.dateToStr("%d/%m/%Y");
                                            text = removeTimeZoneT(text);
                                            return format(text);
                                        }
                                    },
                                    {
                                        id: "ngayketthuc",
                                        header: _("NGAY_KET_THUC"),
                                        width: 150,
                                        format: function (text) {
                                            var format = webix.Date.dateToStr("%d/%m/%Y");
                                            text = removeTimeZoneT(text);
                                            return format(text);
                                        }
                                    }
                                ]
                            }

                        }
                    },
                    {
                        view: "template",
                        template: "Danh sách hóa đơn chờ ký",
                        type: "section"
                    },
                    {

                        view: "datatable",
                        select: "row",
                        id: "tblHoadon",
                        resizeColumn: true,
                        datafetch: 50,
                        on: {
                            "data->onStoreUpdated": function () {
                                this.data.each(function (obj, i) {
                                    obj.index = i + 1;
                                })
                            }
                            // onKeyPress: function (code, e) {
                            //     var table = this;

                            //     if (e.key == "Enter") {
                            //         var win = this.getTopParentView();
                            //         var toolbar = win.getChildViews()[1].getChildViews()[0];

                            //         var btnChon = toolbar.getChildViews()[0];
                            //         btnChon.callEvent("onClick");
                            //     }
                            // }
                        },
                        columns: [
                            {
                                id: "chon1",
                                header: [{ text: "", content: "masterCheckbox" }],
                                width: 55,
                                checkValue: 'C',
                                uncheckValue: 'K',
                                template: "{common.checkbox()}"
                            },
                            { id: "index", sort: "int", header: "STT", width: 50 },
                            { id: "inv_InvoiceAuth_id", header: "ID hóa đơn", width: 250 },
                            { id: "inv_invoiceNumber", header: "Số hóa đơn" }
                        ],
                        pager: "selectPagerA"
                    },
                    {
                        id: "selectPagerA",
                        view: "pager",
                        size: 50,
                        group: 5,
                        template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}"
                    },
                    {
                        margin: 10,
                        cols: [
                            {},
                            {
                                shortcut: "F9", view: "button", label: "Tải dữ liệu (F9)", type: "form", align: "center", width: 120,
                                on: {
                                    onClick: function () {
                                        var form = webix.$$("chukyso-form");

                                        var item = form.getValues();

                                        var parameter = {
                                            command: "CM00020",
                                            parameter: {
                                                ma_dvcs: user.getDvcsID(),
                                                tu_ngay: item.tu_ngay,
                                                den_ngay: item.den_ngay,
                                                inv_InvoiceCode_id: item.inv_InvoiceCode_id
                                            }
                                        };

                                        var url = app.config.host + "/System/ExecuteCommand";

                                        webix.extend(form, webix.ProgressBar);
                                        //form.disable();
                                        form.showProgress();

                                        webix.ajax()
                                            .headers({ 'Content-type': 'application/json' })
                                            .post(url, parameter, function (text) {

                                                var json = JSON.parse(text);
                                                console.log(json);
                                                if (!json.hasOwnProperty("error")) {

                                                    if (json.length == 0) {
                                                        webix.message("Không có dữ liệu", "error");
                                                        var table = $$("tblHoadon");
                                                        //table.load(table.config.url);
                                                        table.clearAll();
                                                        form.hideProgress();
                                                        return;
                                                    }
                                                    else {
                                                        form.hideProgress();
                                                        $$("btnNhan").enable();
                                                        var table = $$("tblHoadon");
                                                        //table.load(table.config.url);
                                                        table.clearAll();
                                                        var table = $$("tblHoadon");
                                                        table.parse(json);
                                                    }
                                                }
                                            });
                                    }
                                },
                                click: function () {
                                    this.callEvent("onClick");
                                }
                            },
                            {
                                shortcut: "F10", id: "btnNhan", name: "btnNhan", view: "button", label: "Nhận (F10)", align: "center", width: 80,
                                on: {
                                    onClick: function () {
                                        var form = webix.$$("chukyso-form");

                                        // var item = form.getValues();

                                        // var parameter = {
                                        //     command: "CM00020",
                                        //     parameter: {
                                        //         ma_dvcs: user.getDvcsID(),
                                        //         tu_ngay: item.tu_ngay,
                                        //         den_ngay: item.den_ngay,
                                        //         inv_InvoiceCode_id: item.inv_InvoiceCode_id
                                        //     }
                                        // };

                                        // var url = app.config.host + "/System/ExecuteCommand";

                                        webix.extend(form, webix.ProgressBar);
                                        form.disable();
                                        form.showProgress();
                                        var json = $$("tblHoadon").serialize();
                                        if (json.length == 0) {
                                            webix.message("Không có dữ liệu !", "error");
                                            form.enable();
                                            form.hideProgress();
                                            return;
                                        }
                                        //console.log(json);

                                        // webix.ajax()
                                        // .headers({ 'Content-type': 'application/json' })
                                        // .post(url, parameter, function (text) {

                                        //     var json = JSON.parse(text);

                                        //     if (!json.hasOwnProperty("error")) {

                                        //         if (json.length == 0) {
                                        //             webix.message("Không có dữ liệu");
                                        //             return;
                                        //         }

                                        //         console.log(json);
                                        //         console.log(json.data);

                                        // var dshoadon = this.$scope.ui(dshoadon.$ui);
                                        // dshoadon.$ui.show();
                                        var win = $$("chukyso-win");
                                        var server_cert = win.config.server_cert;

                                        if (server_cert == null) {
                                            var hub = plugin.hub();
                                            hub.off('resCommand');

                                            hub.on('resCommand', function (result) {
                                                var json = JSON.parse(result);

                                                if (json.hasOwnProperty("error")) {
                                                    webix.message({ type: 'error', text: json.error });

                                                    var form = webix.$$("chukyso-form");
                                                    form.enable();
                                                    form.hideProgress();
                                                }
                                                else {
                                                    var promises = [];

                                                    var array = json.data;

                                                    for (var i = 0; i < array.length; i++) {
                                                        var item = array[i];

                                                        var parameters = {
                                                            InvoiceXmlData: item.InvoiceXmlData,
                                                            inv_InvoiceAuth_id: item.inv_InvoiceAuth_id
                                                        };

                                                        var a = webix.ajax()
                                                            .headers({ "Content-Type": "application/json" })
                                                            .post(app.config.host + "/Invoice/SaveXml", parameters);

                                                        promises.push(a);
                                                    }

                                                    webix.promise.all(promises).then(function (results) {
                                                        var table = webix.$$("windowData");
                                                        table.clearAll();
                                                        table.load(table.config.url);

                                                        var form = webix.$$("chukyso-form");
                                                        form.enable();
                                                        form.hideProgress();

                                                        var win = $$("chukyso-win");
                                                        win.close();
                                                    });


                                                }
                                            });

                                            var promises = [];

                                            for (var i = 0; i < json.length; i++) {
                                                if (json[i].chon1 != null && json[i].chon1 != "") {
                                                    if (json[i].chon1 == "C") {
                                                        //console.log(json[i]);
                                                        var a = webix.ajax().get(app.config.host + "/Invoice/ExportXml?id=" + json[i].inv_InvoiceAuth_id);
                                                        promises.push(a);
                                                    }
                                                }

                                            }

                                            webix.promise.all(promises).then(function (results) {
                                                var arrays = [];

                                                for (var i = 0; i < results.length; i++) {
                                                    arrays.push(results[i].json());
                                                }

                                                var form = webix.$$("chukyso-form");
                                                var item = form.getValues();

                                                var arg = {
                                                    idData: "#data",
                                                    data: arrays,
                                                    idSigner: "seller",
                                                    tagSign: "Signatures",
                                                    listcerts: [
                                                        {
                                                            so_serial: item.cerSerial
                                                        }
                                                    ]
                                                };

                                                hub.invoke('execCommand', 'SignListInvoices', JSON.stringify(arg));
                                            });
                                        }
                                        else {

                                            var promises = [];

                                            // for (var i = 0; i < json.length; i++) {
                                            //     if (json[i].chon1 != null && json[i].chon1 != "") {
                                            //         if (json[i].chon1 == "C") {

                                            //             var a = webix.ajax().get(app.config.host + "/Invoice/ExportXml?id=" + json[i].inv_InvoiceAuth_id);
                                            //             promises.push(a);
                                            //         }
                                            //     }

                                            // }

                                            for (var i = 0; i < json.length; i++) {
                                                // console.log(json[i]);
                                                if (json[i].chon1 == null && json[i].chon1 == "") {
                                                    continue;
                                                }
                                                else {
                                                    if (json[i].chon1 == "C") {
                                                        //console.log(json[i]);
                                                        var a = webix.ajax().get(app.config.host + "/Invoice/ExportXml?id=" + json[i].inv_InvoiceAuth_id);

                                                        //var text = xhr.responseText;
                                                        // var b = JSON.parse(a.responseText);
                                                        //console.log(a);
                                                        promises.push(a);

                                                    }
                                                }

                                            }

                                            webix.promise.all(promises).then(function (results) {
                                                var promises = [];
                                                console.log(results);
                                                var server_cert = win.config.server_cert;


                                                var txtCer = $$("txtCerSerial");
                                                var cert = txtCer.getList().getSelectedItem();

                                                for (var i = 0; i < results.length; i++) {
                                                    var json = results[i].json();

                                                    var parameters = {
                                                        xml: json["InvoiceXmlData"],
                                                        refUri: "#data",
                                                        certSerial: cert.so_serial,
                                                        tokenSerial: cert.tokenSerial,
                                                        signId: "seller",
                                                        signTag: "Signatures",
                                                        pass: cert.pass,
                                                        inv_InvoiceAuth_id: json["inv_InvoiceAuth_id"]
                                                    };

                                                    var a = webix.ajax()
                                                        .headers({ "Content-Type": "application/json" })
                                                        .post(server_cert + "/Token/SignXml", parameters, function (text) {
                                                            //console.log(text);
                                                        });

                                                    promises.push(a);
                                                }

                                                webix.promise.all(promises).then(function (results) {
                                                    var promises = [];

                                                    for (var i = 0; i < results.length; i++) {
                                                        var json = results[i].json();

                                                        var parameters = {
                                                            InvoiceXmlData: json.xml,
                                                            inv_InvoiceAuth_id: json.inv_InvoiceAuth_id
                                                        };

                                                        var a = webix.ajax()
                                                            .headers({ "Content-Type": "application/json" })
                                                            .post(server_cert + "/Invoice/SaveXml", parameters, function (text) {
                                                                //console.log(text);
                                                            });

                                                        promises.push(a);
                                                    }
                                                    webix.promise.all(promises).then(function (results) {
                                                        var table = webix.$$("windowData");
                                                        table.clearAll();
                                                        table.load(table.config.url);

                                                        var form = webix.$$("chukyso-form");
                                                        form.enable();
                                                        form.hideProgress();

                                                        var win = $$("chukyso-win");
                                                        win.close();
                                                    }).fail(function (err) {
                                                        alert(err);

                                                        var form = webix.$$("chukyso-form");
                                                        form.enable();
                                                        form.hideProgress();
                                                    });


                                                }).fail(function (err) {
                                                    alert(err);

                                                    var form = webix.$$("chukyso-form");
                                                    form.enable();
                                                    form.hideProgress();
                                                });

                                            }).fail(function (err) {
                                                alert(err);

                                                var form = webix.$$("chukyso-form");
                                                form.enable();
                                                form.hideProgress();
                                            });

                                        }
                                    }
                                    // else {
                                    //     webix.message(json.error);

                                    //     var form = webix.$$("chukyso-form");
                                    //     form.enable();
                                    //     form.hideProgress();

                                    // }

                                    //});
                                    // }
                                },
                                click: function () {
                                    this.callEvent("onClick");

                                }
                            },
                            {
                                view: "button", hotkey: "esc", label: "Hủy bỏ (ESC)", type: "danger", align: "center", width: 100,
                                click: function () {
                                    webix.$$("chukyso-win").close();
                                }
                            },
                            {}
                        ]
                    }

                ]
            }
            // onBeforeShow: function()
            // {
            //     webix.$$("btnNhan").define("disabled", true);
            //     webix.$$('btnNhan').disable();
            // }

        },
        // $oninit: function (view, $scope) {
        //     webix.$$("btnNhan").disable();
        // },
        setEditMode: function (mode) {
            editmode = mode;
        }
    };

});
define('views/forms/kynhieuhoadon',["app", "locale", "models/user",
    "views/modules/minvoiceplugin",
    "views/menus/version",
    "views/forms/signCloudMulti",
    "views/forms/signEasyCAMulti",
    "views/modules/Component/constantManager"
], function (app, _, user, plugin, version, signCloudMulti, signEasyCAMulti, CONSTANTS) {
    var editmode = 0;

    function signOnServerFile(data, cert, server_cert, formComponent, total, step) {
        webix.extend(formComponent, webix.ProgressBar);
        formComponent.disable();
        formComponent.showProgress();
        var parameters = {
            xml: data["InvoiceXmlData"],
            refUri: "#data",
            certSerial: cert.so_serial,
            tokenSerial: cert.tokenSerial,
            signId: "seller",
            signTag: "Signatures",
            pass: cert.pass,
            path: cert.path,
            inv_InvoiceAuth_id: data["inv_InvoiceAuth_id"]
        };

        webix.ajax()
            .headers({ "Content-Type": "application/json" })
            .post(server_cert + "/Token/SignXmlByFile", parameters, function (text) {
                var json = JSON.parse(text);

                if (json.hasOwnProperty("error")) {
                    formComponent.enable();
                    formComponent.hideProgress();
                    webix.message(json["error"], "error");
                }
                else {
                    var parameters = {
                        InvoiceXmlData: json.xml,
                        inv_InvoiceAuth_id: json.inv_InvoiceAuth_id
                    };
                    //console.log(parameters);

                    webix.ajax()
                        .headers({ "Content-Type": "application/json" })
                        .post(app.config.host + "/Invoice/SaveXml", parameters, function (text) {
                            var result = JSON.parse(text);
                            if (result.hasOwnProperty("error")) {
                                webix.message(result["error"], "error");
                                return;
                            }
                            if (result.trang_thai == "Đã ký") {
                                if (step == total) {
                                    webix.message("Ký hóa đơn thành công !", "success");
                                }
                                // var table = webix.$$("dmwindowData");
                                // table.clearAll();
                                // table.load(table.config.url);

                                // webix.ajax()
                                //     .headers({ 'Content-type': 'application/json' })
                                //     .post(app.config.host + "/System/ExecuteCommand",
                                //     {
                                //         command: "CM00025",
                                //         parameter: {

                                //         }
                                //     }, function (text) {

                                //         var json = JSON.parse(text);
                                //         // auto send SMS 
                                //         if (json[1].gia_tri == "C") {
                                //             // var data = { id: item.inv_InvoiceAuth_id };

                                //             // webix.ajax()
                                //             //     .headers({ 'Content-type': 'application/json' })
                                //             //     .post(app.config.host + "/Sms/NotifyInvoice", data, function (text) {
                                //             //         var data = JSON.parse(text);

                                //             //         if (!data.hasOwnProperty("error")) {

                                //             //         }
                                //             //         else {
                                //             //             webix.message(data.error, "error");
                                //             //         }
                                //             //     });
                                //         }
                                //         // send email ma = 'AUTO_SEND_EMAIL'
                                //         // if (json[0].gia_tri == "C") {
                                //         //     var data = { inv_InvoiceAuth_id: item.inv_InvoiceAuth_id, nguoinhan: item.inv_buyerEmail, tieude: "Thông báo xuất hóa đơn điện tử" };

                                //         //     webix.ajax()
                                //         //         .headers({ 'Content-type': 'application/json' })
                                //         //         .post(app.config.host + "/Invoice/AutoEmail", data, function (text) {
                                //         //             var data = JSON.parse(text);

                                //         //             if (!data.hasOwnProperty("error")) {


                                //         //             }
                                //         //             else {
                                //         //                 webix.message(data.error, "error");
                                //         //             }
                                //         //         });
                                //         // }


                                //     });
                                // webix.modalbox.hide();
                                // webix.message("Ký hóa đơn thành công !", "debug");
                            }

                        });
                        formComponent.enable();
                        formComponent.hideProgress();
                }
            });
    }
    var layout = {
        view: "window", modal: true, resize: true, id: "chukyso-win", position: "center", move: true, css: "headformchil",
        head: {
            height: 40,
            cols: [
                { id: "head-form", view: "template", css: "headform", template: function (obj) { return '<div>Ký hóa đơn chờ ký<div/>'; } },
                { view: "icon", icon: "fas fa-question-circle", id: "help_form", tooltip: _("HELPER"), click: function () { } }
            ]
        },
        minWidth: 600,
        minHeight: 600,
        on: {
            onBeforeShow: function () {
                webix.ajax()
                    .headers({ 'Content-type': 'application/json' })
                    .post(app.config.host + "/System/ExecuteCommand", {
                        command: "CM00019",
                        parameter: {
                            ma_dvcs: ""
                        }
                    }, {
                        error: function (text, data, XmlHttpRequest) {
                            //webix.modalbox.hide(box);
                            webix.alert({
                                title: "Lỗi !",
                                text: err,
                                type: "alert-error"
                            });
                        },
                        success: function (text, data, XmlHttpRequest) {
                            var c_result = JSON.parse(text);

                            for (var i = 0; i < c_result.length; i++) {
                                var item = c_result[i];

                                if (item.ma == "KYTAPTRUNG") {
                                    $$("chukyso-win").config.kytaptrung = item.gia_tri;
                                }
                                if (item.ma == "SERVER_CERT") {
                                    $$("chukyso-win").config.server_cert = item.gia_tri;
                                }
                            }
                        }
                    });
            }
        },
        body: {
            paddingY: 10,
            paddingX: 10,
            view: "form",
            id: "chukyso-form",
            complexData: true,
            margin: 0,
            elements: [
                {
                    cols: [
                        { view: "datepicker", name: "tu_ngay", format: "%d/%m/%Y", label: "Từ ngày", labelPosition: "top", value: new Date() },
                        { view: "datepicker", name: "den_ngay", format: "%d/%m/%Y", label: "Đến ngày", labelPosition: "top", value: new Date() },
                    ]
                },
                {
                    view: "combo",
                    name: "inv_InvoiceCode_id",
                    label: "Ký hiệu",
                    labelPosition: "top",
                    options: app.config.host + "/System/GetDataReferencesByRefId?refId=RF00089",
                    required: true,
                    invalidMessage: "Ký hiệu hóa đơn không được để trống !"
                    // validate: webix.rules.isEmpty
                },
                {
                    view: "combo",
                    name: "cerSerial",
                    label: "Chứng thư số",
                    labelPosition: "top",
                    id: "txtCerSerial",
                    required: true,
                    invalidMessage: "Chứng thư số không được để trống !",
                    options: {
                        view: "gridsuggest",
                        url: app.config.host + "/Invoice/GetListCertificatesAuto",
                        // template:"#subjectname#",
                        body: {
                            columns: [
                                { id: "so_serial", header: _("SO_SERIAL"), width: 150 },
                                { id: "subjectname", header: _("SUBJECTNAME"), width: 550 },
                                {
                                    id: "ngaybatdau", header: _("NGAY_BAT_DAU"), width: 150, format: function (text) {
                                        var format = webix.Date.dateToStr("%d/%m/%Y");
                                        text = removeTimeZoneT(text);
                                        return format(text);
                                    }
                                },
                                {
                                    id: "ngayketthuc", header: _("NGAY_KET_THUC"), width: 150,
                                    format: function (text) {
                                        var format = webix.Date.dateToStr("%d/%m/%Y");
                                        text = removeTimeZoneT(text);
                                        return format(text);
                                    }
                                }
                            ]
                        }
                    }
                },
                { view: "template", template: "Danh sách hóa đơn chờ ký", type: "section" },
                {

                    view: "datatable",
                    select: "row",
                    id: "tblHoadon",
                    resizeColumn: true,
                    datafetch: 50,
                    on: {
                        "data->onStoreUpdated": function () {
                            this.data.each(function (obj, i) {
                                obj.index = i + 1;
                            })
                        }
                        // onKeyPress: function (code, e) {
                        //     var table = this;

                        //     if (e.key == "Enter") {
                        //         var win = this.getTopParentView();
                        //         var toolbar = win.getChildViews()[1].getChildViews()[0];

                        //         var btnChon = toolbar.getChildViews()[0];
                        //         btnChon.callEvent("onClick");
                        //     }
                        // }
                    },
                    columns: [
                        {
                            id: "chon1",
                            header: [{ text: "", content: "masterCheckbox" }],
                            width: 55,
                            checkValue: 'C',
                            uncheckValue: 'K',
                            template: "{common.checkbox()}"
                        },
                        { id: "index", sort: "int", header: "STT", width: 50 },
                        { id: "inv_InvoiceAuth_id", header: "ID hóa đơn", width: 250, hidden: true },
                        {
                            id: "inv_invoiceIssuedDate", header: "Ngày hóa đơn", width: 150, format: function (text) {
                                var format = webix.Date.dateToStr("%d/%m/%Y");
                                text = removeTimeZoneT(text);
                                return format(text);
                            }
                        },
                        { id: "inv_invoiceNumber", header: "Số hóa đơn" },
                        {
                            id: "inv_TotalAmount", header: "Tổng tiền", width: 150, format: webix.Number.numToStr({
                                groupDelimiter: ",",
                                groupSize: 3,
                                decimalDelimiter: ".",
                                decimalSize: 0
                            })
                        }
                    ],
                    pager: "selectPagerA"
                },
                {
                    id: "selectPagerA",
                    view: "pager",
                    size: 50,
                    group: 5,
                    template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}"
                },
                {
                    margin: 10,
                    cols: [
                        {},
                        {
                            shortcut: "F9", view: "button", label: "Tải dữ liệu (F9)", type: "form", align: "center", width: 120,
                            on: {
                                onClick: function () {
                                    var form = webix.$$("chukyso-form");
                                    if (form.validate()) {
                                        var item = form.getValues();
                                        var format = webix.Date.dateToStr("%Y-%m-%d");

                                        var parameter = {
                                            command: "CM00020",
                                            parameter: {
                                                ma_dvcs: user.getDvcsID(),
                                                tu_ngay: format(item.tu_ngay),
                                                den_ngay: format(item.den_ngay),
                                                inv_InvoiceCode_id: item.inv_InvoiceCode_id,
                                                // dành cho mst 4600123233 lọc dữ liệu ký theo tổ (Quang Huy HCM Y/C)
                                                phuong: item.phuong,
                                                // mst 0315687749 Hiếu VACOM HCM
                                                tu_so: item.tu_so == "" ? 0 : item.tu_so,
                                                den_so: item.den_so == "" ? 9999999 : item.den_so,
                                                // mst 0102013921 anh Truyền
                                                dia_chi: item.dia_chi == "" ? null : item.dia_chi
                                            }
                                        };

                                        var url = app.config.host + "/System/ExecuteCommand";

                                        webix.extend(form, webix.ProgressBar);
                                        //form.disable();
                                        form.showProgress();

                                        webix.ajax()
                                            .headers({ 'Content-type': 'application/json' })
                                            .post(url, parameter, function (text) {

                                                var json = JSON.parse(text);

                                                if (!json.hasOwnProperty("error")) {

                                                    if (json.length == 0) {
                                                        webix.message("Không có dữ liệu", "error");
                                                        var table = $$("tblHoadon");
                                                        //table.load(table.config.url);
                                                        table.clearAll();
                                                        form.hideProgress();
                                                        return;
                                                    }
                                                    else {
                                                        form.hideProgress();
                                                        $$("btnNhan").enable();
                                                        var table = $$("tblHoadon");
                                                        //table.load(table.config.url);
                                                        table.clearAll();
                                                        var table = $$("tblHoadon");
                                                        table.parse(json);
                                                    }
                                                }
                                            });
                                    }
                                }
                            },
                            click: function () {
                                this.callEvent("onClick");
                            }
                        },
                        {
                            shortcut: "F10", view: "button", id: "btnNhan", name: "btnNhan", type: "form", label: "Nhận (F10)", align: "center",
                            on: {
                                onClick: function () {
                                    var form = webix.$$("chukyso-form");
                                    webix.extend(form, webix.ProgressBar);
                                    form.disable();
                                    form.showProgress();
                                    var json = $$("tblHoadon").serialize();
                                    if (json.length == 0) {
                                        webix.message("Không có dữ liệu !", "error");
                                        form.enable();
                                        form.hideProgress();
                                        return;
                                    }
                                    var win = $$("chukyso-win");
                                    var kytaptrung = win.config.kytaptrung;
                                    var server_cert = win.config.server_cert;
                                    switch (kytaptrung) {
                                        case "FILE":
                                            var box = webix.modalbox({
                                                title: "Đang ký hóa đơn .... ",
                                                buttons: ["Hủy bỏ"],
                                                text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                                                width: 350,
                                                height: 200,
                                                callback: function (result) {
                                                    switch (result) {
                                                        case "0":
                                                            //clearTimeout(interVal);
                                                            webix.modalbox.hide(box);
                                                            break;
                                                    }
                                                }
                                            });
                                            var txtCer = $$("txtCerSerial");
                                            var cert = txtCer.getList().getSelectedItem();
                                            var promises = [];
                                            var step = 0;
                                            var total = 0;

                                            for (var i = 0; i < json.length; i++) {

                                                if (json[i]["chon1"] != null && json[i]["chon1"] == "C") {
                                                    total = total + 1;
                                                    var a = webix.ajax().get(app.config.host + "/Invoice/ExportXml?id=" + json[i].inv_InvoiceAuth_id);
                                                    // promises.push(a);
                                                    var kjjj = webix.promise.all([a]).then(function (results) {
                                                        var a_result = results[0].json();
                                                        step = step + 1;
                                                        signOnServerFile(a_result, cert, server_cert, webix.$$("chukyso-form"), total, step);

                                                        // console.log(step);
                                                        // console.log(total);
                                                        if (step == total) {
                                                            webix.modalbox.hide(box);
                                                        }
                                                        // form.enable();
                                                        // form.hideProgress();
                                                        //webix.modalbox.hide(box);
                                                        //clearTimeout(interVal);
                                                    }).fail(function (err) {
                                                        var form = webix.$$("chukyso-form");
                                                        form.enable();
                                                        form.hideProgress();
                                                        webix.alert({
                                                            title: "Lỗi !",
                                                            text: err,
                                                            type: "alert-error"
                                                        });
                                                    });
                                                    console.log(kjjj);
                                                }
                                            }
                                            var tableHD = webix.$$("tblHoadon");
                                            tableHD.clearAll();
                                            form.enable();
                                            form.hideProgress();
                                            break;
                                        case "C":
                                            var promises = [];
                                            for (var i = 0; i < json.length; i++) {
                                                if (json[i]["chon1"] != null && json[i]["chon1"] == "C") {
                                                    var a = webix.ajax().get(app.config.host + "/Invoice/ExportXml?id=" + json[i].inv_InvoiceAuth_id);
                                                    promises.push(a);
                                                }
                                            }

                                            webix.promise.all(promises).then(function (results) {
                                                var promises = [];
                                                var server_cert = win.config.server_cert;
                                                var txtCer = $$("txtCerSerial");
                                                var cert = txtCer.getList().getSelectedItem();
                                                for (var i = 0; i < results.length; i++) {
                                                    var json = results[i].json();

                                                    var parameters = {
                                                        xml: json["InvoiceXmlData"],
                                                        refUri: "#data",
                                                        certSerial: cert.so_serial,
                                                        tokenSerial: cert.tokenSerial,
                                                        signId: "seller",
                                                        signTag: "Signatures",
                                                        pass: cert.pass,
                                                        inv_InvoiceAuth_id: json["inv_InvoiceAuth_id"]
                                                    };

                                                    var a = webix.ajax()
                                                        .headers({ "Content-Type": "application/json" })
                                                        .post(server_cert + "/Token/SignXml", parameters, function (text) {
                                                        });
                                                    promises.push(a);
                                                }

                                                webix.promise.all(promises).then(function (results) {
                                                    var promises = [];
                                                    for (var i = 0; i < results.length; i++) {
                                                        var json = results[i].json();

                                                        var parameters = {
                                                            InvoiceXmlData: json.xml,
                                                            inv_InvoiceAuth_id: json.inv_InvoiceAuth_id
                                                        };

                                                        var a = webix.ajax()
                                                            .headers({ "Content-Type": "application/json" })
                                                            .post(server_cert + "/Invoice/SaveXml", parameters, function (text) {
                                                            });

                                                        promises.push(a);
                                                    }

                                                    webix.promise.all(promises).then(function (results) {
                                                        var table = webix.$$("windowData");
                                                        table.clearAll();
                                                        table.load(table.config.url);

                                                        var form = webix.$$("chukyso-form");
                                                        form.enable();
                                                        form.hideProgress();

                                                        var win = $$("chukyso-win");
                                                        win.close();
                                                    }).fail(function (err) {
                                                        alert(err);

                                                        var form = webix.$$("chukyso-form");
                                                        form.enable();
                                                        form.hideProgress();
                                                    });


                                                }).fail(function (err) {
                                                    alert(err);

                                                    var form = webix.$$("chukyso-form");
                                                    form.enable();
                                                    form.hideProgress();
                                                });

                                            }).fail(function (err) {
                                                alert(err);

                                                var form = webix.$$("chukyso-form");
                                                form.enable();
                                                form.hideProgress();
                                            });
                                            break;
                                        case "CLOUD":
                                            var item = [];
                                            for (var i = 0; i < json.length; i++) {
                                                if (json[i]["chon1"] != null && json[i]["chon1"] == "C") {
                                                    item.push(json[i].inv_InvoiceAuth_id);
                                                }
                                            }
                                            if (item.length <= 0) {
                                                webix.message("Bạn chưa chọn hóa đơn cần ký !", "error");
                                                form.enable();
                                                form.hideProgress();
                                                return;
                                            }
                                            var frm = webix.$$("chukyso-win").$scope.ui(signCloudMulti.$ui);
                                            signCloudMulti.initUI(item, $$("txtCerSerial").getValue());
                                            form.enable();
                                            form.hideProgress();
                                            var win = $$("chukyso-win");
                                            win.close();
                                            frm.show();
                                            break;
                                        case "EASYCA":
                                            var item = [];
                                            for (var i = 0; i < json.length; i++) {
                                                if (json[i]["chon1"] != null && json[i]["chon1"] == "C") {
                                                    item.push(json[i].inv_InvoiceAuth_id);
                                                }
                                            }
                                            if (item.length <= 0) {
                                                webix.message("Bạn chưa chọn hóa đơn cần ký !", "error");
                                                form.enable();
                                                form.hideProgress();
                                                return;
                                            }
                                            var frm = webix.$$("chukyso-win").$scope.ui(signEasyCAMulti.$ui);
                                            signEasyCAMulti.initUI(item, $$("txtCerSerial").getValue());
                                            form.enable();
                                            form.hideProgress();
                                            var win = $$("chukyso-win");
                                            win.close();
                                            frm.show();
                                            break;
                                        case "ICA":
                                            var box = webix.modalbox({
                                                title: "Chọn chứng thư số",
                                                buttons: ["Nhận", "Hủy bỏ"],
                                                text: "<div id='ctnCerts'></div>",
                                                top: 100,
                                                width: 750,
                                                callback: function (result) {
                                                    var form = webix.$$("chukyso-form");
                                                    form.enable();
                                                    form.hideProgress();
                                                    switch (result) {
                                                        case "1":
                                                            webix.modalbox.hide();
                                                            break;
                                                        case "0":
                                                            var table = $$("tblCerts");
                                                            var data = table.serialize();
                                                            var cert = null;
                                                            for (var i = 0; i < data.length; i++) {
                                                                if (data[i].chon == true) {
                                                                    cert = data[i];
                                                                    break;
                                                                }
                                                            }
                                                            if (cert == null) {
                                                                webix.message("Bạn chưa chọn chứng thư số");
                                                                return;
                                                            }

                                                            var promises = [];
                                                            for (var i = 0; i < json.length; i++) {
                                                                if (json[i]["chon1"] != null && json[i]["chon1"] == "C") {
                                                                    // ky bang service
                                                                    promises.push(json[i].inv_InvoiceAuth_id);
                                                                    
                                                                    // ky bang plugin
                                                                    // var inv = {
                                                                    //     idInvoice: json[i].inv_InvoiceAuth_id,
                                                                    //     numberInvoice: json[i].inv_invoiceNumber
                                                                    // };
                                                                    // promises.push(inv);

                                                                }
                                                            }

                                                            // ky bang service
                                                            let promiseData = [];
                                                            for (let i = 0; i < promises.length; i += CONSTANTS.CHUNK.DANH_SACH_KY_BIEN_LAI) {
                                                                var parameters = {
                                                                    agreementUUID: cert.agreementUUID,
                                                                    invoiceId: promises.slice(i, i + CONSTANTS.CHUNK.DANH_SACH_KY_BIEN_LAI),
                                                                    pinCode: cert.pass,
                                                                    tagSignId: "data",
                                                                    tagSign: "Signatures"
                                                                };
                                                                var promise = webix.ajax()
                                                                .headers({ "Content-Type": "application/json" })
                                                                .post(app.config.host + "/TokenCloud/IcaSignInvoice32", parameters, function (text) {
                                                                    var json = JSON.parse(text);
                                                                    if (json.hasOwnProperty("error")) {
                                                                        webix.message(json["error"], "error");
                                                                    } else {
                                                                        if (json.hasOwnProperty("code")) {
                                                                            if (json.code == "99") {
                                                                                webix.message(json.message, "error");
                                                                            } else if (json.code == "00") {
                                                                                webix.message("Ký hóa đơn thành công !", "debug");
                                                                            }
                                                                        }
                                                                    }
                                                                });
                                                                promiseData.push(promise);
                                                            }
                                                            (async () => {
                                                                console.log(promiseData.length)
                                                                const promises = promiseData.map((item) => item.then((obj) => {
                                                                    if (obj.json().data != null)
                                                                        loadingStatus(obj.json().data.shdon, obj.json().code, obj.json().message);
                                                                }));
                                                                await Promise.all(promises);
                                                                $$("btnRefresh").callEvent("onClick");
                                                                var table = webix.$$("windowData");
                                                                table.clearAll();
                                                                table.load(table.config.url);
                                                                var win = $$("chukyso-win");
                                                                win.close();
                                                            })();

                                                            // ky bang plugin
                                                            /*
                                                            var parameters = {
                                                                tagSignId: "data",
                                                                tagSign: "Signatures",
                                                                agreementUUID: cert.agreementUUID,
                                                                pinCode: cert.pass,
                                                                invoice: promises,
                                                                cookie: user.getAppCookie()
                                                            };
                                                            var apiHost = document.location.protocol + "//" + document.location.hostname;
                                                            var pathApiSign = "/api/TokenCloud/IcaSignInvoice32";
                                                            if (document.location.protocol == "file:" || document.hostname == "127.0.0.1")
                                                            {
                                                                pathApiSign= "/TokenCloud/IcaSignInvoice32";
                                                                apiHost = "http://localhost:18374/";
                                                            }
                                                            parameters.pathApiSign = pathApiSign;
                                                            parameters.apiHost = apiHost;

                                                            var hub = plugin.hub();
                                                            var hubconnect = plugin.conn();
                                                            if (hubconnect.state != 1) {
                                                                var form = webix.$$("chukyso-form");
                                                                form.enable();
                                                                form.hideProgress();
                                                                webix.message("Quý khách hàng chưa cài Plugin ký hóa đơn hoặc Plugin ký hóa đơn chưa được bật !", "error");
                                                                return;
                                                            }
                                                            else {
                                                            hub.off('resCommand');
                                                            hub.on('resCommand', function (result) {
                                                                var pluginResponse = JSON.parse(result);
                                                                if (pluginResponse.code != "00") {
                                                                    webix.message({ type: 'error', text: pluginResponse.message });
                                                                    var form = webix.$$("chukyso-form");
                                                                    form.enable();
                                                                    form.hideProgress();
                                                                }
                                                                else {
                                                                    var table = webix.$$("windowData");
                                                                    table.clearAll();
                                                                    table.load(table.config.url);
                                                                    var form = webix.$$("chukyso-form");
                                                                    form.enable();
                                                                    form.hideProgress();
                                                                    var win = $$("chukyso-win");
                                                                    win.close();
                                                                    webix.message("Ký thành công !", "success");
                                                                }
                                                            });
                                                            hub.off('resNotice');
                                                            hub.on('resNotice', function (result) {
                                                                webix.message(result, "debug");
                                                            });
            
                                                            hub.invoke('execCommand', 'SIGN_INVOICE_LIST', JSON.stringify(parameters))
                                                                .done(function () {
                                                                    console.log("Success SignXmlInvoices!")
                                                                })
                                                                .fail(function (error) {
                                                                    var form = webix.$$("chukyso-form");
                                                                    form.enable();
                                                                    form.hideProgress();
                                                                    webix.message(error, "error");
                                                                });
                                                            }
                                                            */
                                                    }
                                                }
                                            });
                                            var popupText = document.getElementsByClassName("webix_popup_text")[0];
                                            popupText.style.paddingTop = 0;
                                            var tblMatHang = webix.ui({
                                                container: "ctnCerts",
                                                id: "tblCerts",
                                                view: "datatable",
                                                borderless: true,
                                                resizeColumn: true,
                                                height: 350,
                                                columns: [
                                                    { id: "chon", header: _("CHON"), width: 65, checkValue: true, uncheckValue: false, template: "{common.checkbox()}", },
                                                    { id: "libraryName", header: _("Loại"), width: 150, },
                                                    { id: "so_serial", header: _("SO_SERIAL"), width: 150, },
                                                    { id: "subjectname", header: _("SUBJECTNAME"), width: 450, },
                                                    { id: "ngaybatdau", header: _("NGAY_BAT_DAU"), width: 200, },
                                                    { id: "ngayketthuc", header: _("NGAY_KET_THUC"), width: 200, },
                                                    { id: "issuer", header: _("DONVI"), width: 450 },
                                                ],
                                                url: app.config.host + "/Invoice/GetListCertificatesAuto",
                                            });
                                            break;
                                        default:
                                            var promises = "";
                                            for (var i = 0; i < json.length; i++) {
                                                if (json[i]["chon1"] != null && json[i]["chon1"] == "C") {
                                                    promises = promises + "'" + json[i].inv_InvoiceAuth_id + "',";
                                                }
                                            }
                                            var promises_auth = promises.substring(0, promises.length - 1);
                                            webix.extend(form, webix.ProgressBar);
                                            form.disable();
                                            form.showProgress();

                                            var hub = plugin.hub();
                                            var hubconnect = plugin.conn();
                                            if (hubconnect.state != 1) {
                                                var form = webix.$$("chukyso-form");
                                                form.enable();
                                                form.hideProgress();
                                                webix.message("Quý khách hàng chưa cài Plugin ký hóa đơn hoặc Plugin ký hóa đơn chưa được bật !", "error");
                                                return;
                                            }
                                            else {
                                                hub.off('resCommand');
                                                hub.on('resCommand', function (result) {
                                                    var json = JSON.parse(result);

                                                    if (json.hasOwnProperty("error")) {
                                                        webix.message({ type: 'error', text: json.error });
                                                    }
                                                    else {
                                                        var table = webix.$$("windowData");
                                                        table.clearAll();
                                                        table.load(table.config.url);

                                                        var win = $$("chukyso-win");
                                                        win.close();
                                                        webix.message("Ký thành công !", "success");
                                                    }
                                                    var form = webix.$$("chukyso-form");
                                                    form.enable();
                                                    form.hideProgress();
                                                });
                                                hub.off('resNotice');
                                                hub.on('resNotice', function (result) {
                                                    webix.message(result, "debug");
                                                });

                                                hub.off('resNoticeEmail');
                                                hub.on('resNoticeEmail', function (result) {
                                                    webix.message(result, "debug");
                                                });

                                                var form = webix.$$("chukyso-form");
                                                var item = form.getValues();
                                                var homeURL;
                                                if (document.location.protocol == "file:") {
                                                    //homeURL = version.getMST();
                                                    homeURL = "hoadon";
                                                }
                                                else {
                                                    // cắt url lấy mst 
                                                    homeURL = version.getURL().split('.')[0];
                                                }
                                                var arg = {
                                                    idData: "#data",
                                                    data: promises_auth,
                                                    // mst: version.getMST(),
                                                    mst: homeURL,
                                                    idSigner: "seller",
                                                    tagSign: "Signatures",
                                                    host: document.location.origin,
                                                    cookie: user.getAppCookie(),
                                                    listcerts: [
                                                        {
                                                            so_serial: item.cerSerial
                                                        }
                                                    ]
                                                };

                                                hub.invoke('execCommand', 'SignXmlInvoicesWin10', JSON.stringify(arg))
                                                    .done(function () {
                                                        console.log("Success SignXmlInvoices!")
                                                    })
                                                    .fail(function (error) {
                                                        var form = webix.$$("chukyso-form");
                                                        form.enable();
                                                        form.hideProgress();
                                                        webix.message(error, "error");
                                                    });
                                            }
                                            break;
                                    };
                                }
                            },
                            click: function () {
                                this.callEvent("onClick");
                            }
                        },
                        {
                            view: "button", hotkey: "esc", label: "Hủy bỏ (ESC)", type: "danger", align: "center", width: 100,
                            click: function () {
                                webix.$$("chukyso-win").close();
                            }
                        },
                        {}
                    ]
                }
            ]
        }
    };
    return {
        $ui: layout,
        setEditMode: function (mode) {
            editmode = mode;
        }
    };

});
// define(["app", "locale", "models/user", "views/modules/minvoiceplugin"], function (app, _, user, plugin) {
//     var editmode = 0;
//     var MD5 = function MD5(d) {
//         result = M(V(Y(X(d), 8 * d.length))); return result.toLowerCase();
//     };
//     function M(d) {
//         for (var _, m = "0123456789ABCDEF", f = "", r = 0; r < d.length; r++) {
//             _ = d.charCodeAt(r), f += m.charAt(_ >>> 4 & 15) + m.charAt(15 & _);
//         } return f;
//     } function X(d) {
//         for (var _ = Array(d.length >> 2), m = 0; m < _.length; m++) {
//             _[m] = 0;
//         } for (m = 0; m < 8 * d.length; m += 8) {
//             _[m >> 5] |= (255 & d.charCodeAt(m / 8)) << m % 32;
//         } return _;
//     } function V(d) {
//         for (var _ = "", m = 0; m < 32 * d.length; m += 8) {
//             _ += String.fromCharCode(d[m >> 5] >>> m % 32 & 255);
//         } return _;
//     } function Y(d, _) {
//         d[_ >> 5] |= 128 << _ % 32, d[14 + (_ + 64 >>> 9 << 4)] = _; for (var m = 1732584193, f = -271733879, r = -1732584194, i = 271733878, n = 0; n < d.length; n += 16) {
//             var h = m,
//                 t = f,
//                 g = r,
//                 e = i; f = md5_ii(f = md5_ii(f = md5_ii(f = md5_ii(f = md5_hh(f = md5_hh(f = md5_hh(f = md5_hh(f = md5_gg(f = md5_gg(f = md5_gg(f = md5_gg(f = md5_ff(f = md5_ff(f = md5_ff(f = md5_ff(f, r = md5_ff(r, i = md5_ff(i, m = md5_ff(m, f, r, i, d[n + 0], 7, -680876936), f, r, d[n + 1], 12, -389564586), m, f, d[n + 2], 17, 606105819), i, m, d[n + 3], 22, -1044525330), r = md5_ff(r, i = md5_ff(i, m = md5_ff(m, f, r, i, d[n + 4], 7, -176418897), f, r, d[n + 5], 12, 1200080426), m, f, d[n + 6], 17, -1473231341), i, m, d[n + 7], 22, -45705983), r = md5_ff(r, i = md5_ff(i, m = md5_ff(m, f, r, i, d[n + 8], 7, 1770035416), f, r, d[n + 9], 12, -1958414417), m, f, d[n + 10], 17, -42063), i, m, d[n + 11], 22, -1990404162), r = md5_ff(r, i = md5_ff(i, m = md5_ff(m, f, r, i, d[n + 12], 7, 1804603682), f, r, d[n + 13], 12, -40341101), m, f, d[n + 14], 17, -1502002290), i, m, d[n + 15], 22, 1236535329), r = md5_gg(r, i = md5_gg(i, m = md5_gg(m, f, r, i, d[n + 1], 5, -165796510), f, r, d[n + 6], 9, -1069501632), m, f, d[n + 11], 14, 643717713), i, m, d[n + 0], 20, -373897302), r = md5_gg(r, i = md5_gg(i, m = md5_gg(m, f, r, i, d[n + 5], 5, -701558691), f, r, d[n + 10], 9, 38016083), m, f, d[n + 15], 14, -660478335), i, m, d[n + 4], 20, -405537848), r = md5_gg(r, i = md5_gg(i, m = md5_gg(m, f, r, i, d[n + 9], 5, 568446438), f, r, d[n + 14], 9, -1019803690), m, f, d[n + 3], 14, -187363961), i, m, d[n + 8], 20, 1163531501), r = md5_gg(r, i = md5_gg(i, m = md5_gg(m, f, r, i, d[n + 13], 5, -1444681467), f, r, d[n + 2], 9, -51403784), m, f, d[n + 7], 14, 1735328473), i, m, d[n + 12], 20, -1926607734), r = md5_hh(r, i = md5_hh(i, m = md5_hh(m, f, r, i, d[n + 5], 4, -378558), f, r, d[n + 8], 11, -2022574463), m, f, d[n + 11], 16, 1839030562), i, m, d[n + 14], 23, -35309556), r = md5_hh(r, i = md5_hh(i, m = md5_hh(m, f, r, i, d[n + 1], 4, -1530992060), f, r, d[n + 4], 11, 1272893353), m, f, d[n + 7], 16, -155497632), i, m, d[n + 10], 23, -1094730640), r = md5_hh(r, i = md5_hh(i, m = md5_hh(m, f, r, i, d[n + 13], 4, 681279174), f, r, d[n + 0], 11, -358537222), m, f, d[n + 3], 16, -722521979), i, m, d[n + 6], 23, 76029189), r = md5_hh(r, i = md5_hh(i, m = md5_hh(m, f, r, i, d[n + 9], 4, -640364487), f, r, d[n + 12], 11, -421815835), m, f, d[n + 15], 16, 530742520), i, m, d[n + 2], 23, -995338651), r = md5_ii(r, i = md5_ii(i, m = md5_ii(m, f, r, i, d[n + 0], 6, -198630844), f, r, d[n + 7], 10, 1126891415), m, f, d[n + 14], 15, -1416354905), i, m, d[n + 5], 21, -57434055), r = md5_ii(r, i = md5_ii(i, m = md5_ii(m, f, r, i, d[n + 12], 6, 1700485571), f, r, d[n + 3], 10, -1894986606), m, f, d[n + 10], 15, -1051523), i, m, d[n + 1], 21, -2054922799), r = md5_ii(r, i = md5_ii(i, m = md5_ii(m, f, r, i, d[n + 8], 6, 1873313359), f, r, d[n + 15], 10, -30611744), m, f, d[n + 6], 15, -1560198380), i, m, d[n + 13], 21, 1309151649), r = md5_ii(r, i = md5_ii(i, m = md5_ii(m, f, r, i, d[n + 4], 6, -145523070), f, r, d[n + 11], 10, -1120210379), m, f, d[n + 2], 15, 718787259), i, m, d[n + 9], 21, -343485551), m = safe_add(m, h), f = safe_add(f, t), r = safe_add(r, g), i = safe_add(i, e);
//         } return Array(m, f, r, i);
//     } function md5_cmn(d, _, m, f, r, i) {
//         return safe_add(bit_rol(safe_add(safe_add(_, d), safe_add(f, i)), r), m);
//     } function md5_ff(d, _, m, f, r, i, n) {
//         return md5_cmn(_ & m | ~_ & f, d, _, r, i, n);
//     } function md5_gg(d, _, m, f, r, i, n) {
//         return md5_cmn(_ & f | m & ~f, d, _, r, i, n);
//     } function md5_hh(d, _, m, f, r, i, n) {
//         return md5_cmn(_ ^ m ^ f, d, _, r, i, n);
//     } function md5_ii(d, _, m, f, r, i, n) {
//         return md5_cmn(m ^ (_ | ~f), d, _, r, i, n);
//     } function safe_add(d, _) {
//         var m = (65535 & d) + (65535 & _); return (d >> 16) + (_ >> 16) + (m >> 16) << 16 | 65535 & m;
//     } function bit_rol(d, _) {
//         return d << _ | d >>> 32 - _;
//     }
//     function signOnServerFile(data, cert, server_cert) {

//         var parameters = {
//             xml: data["InvoiceXmlData"],
//             refUri: "#data",
//             certSerial: cert.so_serial,
//             tokenSerial: cert.tokenSerial,
//             signId: "seller",
//             signTag: "Signatures",
//             pass: cert.pass,
//             path: cert.path,
//             inv_InvoiceAuth_id: data["inv_InvoiceAuth_id"]
//         };

//         webix.ajax()
//             .headers({ "Content-Type": "application/json" })
//             .post(server_cert + "/Token/SignXmlByFile", parameters, function (text) {
//                 var json = JSON.parse(text);

//                 if (json.hasOwnProperty("error")) {
//                     webix.message(json["error"], "error");
//                 }
//                 else {
//                     var parameters = {
//                         InvoiceXmlData: json.xml,
//                         inv_InvoiceAuth_id: json.inv_InvoiceAuth_id
//                     };
//                     //console.log(parameters);

//                     webix.ajax()
//                         .headers({ "Content-Type": "application/json" })
//                         .post(app.config.host + "/Invoice/SaveXml", parameters, function (text) {
//                             var result = JSON.parse(text);

//                             if (result.trang_thai == "Đã ký") {

//                                 // var table = webix.$$("dmwindowData");
//                                 // table.clearAll();
//                                 // table.load(table.config.url);

//                                 webix.ajax()
//                                     .headers({ 'Content-type': 'application/json' })
//                                     .post(app.config.host + "/System/ExecuteCommand",
//                                     {
//                                         command: "CM00025",
//                                         parameter: {

//                                         }
//                                     }, function (text) {
//                                         var json = JSON.parse(text);
//                                         // auto send SMS 
//                                         if (json[1].gia_tri == "C") {
//                                             var data = { id: item.inv_InvoiceAuth_id };

//                                             webix.ajax()
//                                                 .headers({ 'Content-type': 'application/json' })
//                                                 .post(app.config.host + "/Sms/NotifyInvoice", data, function (text) {
//                                                     var data = JSON.parse(text);

//                                                     if (!data.hasOwnProperty("error")) {


//                                                     }
//                                                     else {
//                                                         webix.message(data.error, "error");
//                                                     }
//                                                 });
//                                         }
//                                         // send email ma = 'AUTO_SEND_EMAIL'
//                                         // if (json[0].gia_tri == "C") {
//                                         //     var data = { inv_InvoiceAuth_id: item.inv_InvoiceAuth_id, nguoinhan: item.inv_buyerEmail, tieude: "Thông báo xuất hóa đơn điện tử" };

//                                         //     webix.ajax()
//                                         //         .headers({ 'Content-type': 'application/json' })
//                                         //         .post(app.config.host + "/Invoice/AutoEmail", data, function (text) {
//                                         //             var data = JSON.parse(text);

//                                         //             if (!data.hasOwnProperty("error")) {


//                                         //             }
//                                         //             else {
//                                         //                 webix.message(data.error, "error");
//                                         //             }
//                                         //         });
//                                         // }


//                                     });
//                                 // webix.modalbox.hide();
//                                 // webix.message("Ký hóa đơn thành công !", "debug");
//                             }

//                         });
//                 }
//             });
//     }
//     var layout = {
//         view: "window", modal: true, id: "chukyso-win", position: "center",
//         head: "Ký hóa đơn chờ ký",
//         width: 600,
//         height: 600,
//         on: {
//             onBeforeShow: function () {
//                 webix.ajax()
//                     .headers({ 'Content-type': 'application/json' })
//                     .post(app.config.host + "/System/ExecuteCommand", {
//                         command: "CM00019",
//                         parameter: {
//                             ma_dvcs: ""
//                         }
//                     }, {
//                         error: function (text, data, XmlHttpRequest) {
//                             //webix.modalbox.hide(box);
//                             webix.alert({
//                                 title: "Lỗi !",
//                                 text: err,
//                                 type: "alert-error"
//                             });
//                         },
//                         success: function (text, data, XmlHttpRequest) {
//                             var c_result = JSON.parse(text);

//                             for (var i = 0; i < c_result.length; i++) {
//                                 var item = c_result[i];

//                                 if (item.ma == "KYTAPTRUNG") {
//                                     $$("chukyso-win").config.kytaptrung = item.gia_tri;
//                                 }
//                                 if (item.ma == "SERVER_CERT") {
//                                     $$("chukyso-win").config.server_cert = item.gia_tri;
//                                 }
//                             }
//                         }
//                     });
//             }
//         },
//         body: {
//             paddingY: 10,
//             paddingX: 10,
//             view: "form",
//             id: "chukyso-form",
//             complexData: true,
//             margin: 0,
//             elements: [
//                 {
//                     cols: [
//                         {
//                             view: "datepicker",
//                             name: "tu_ngay",
//                             format: "%d/%m/%Y",
//                             label: "Từ ngày",
//                             labelPosition: "top",
//                             value: new Date()
//                         },
//                         {
//                             view: "datepicker",
//                             name: "den_ngay",
//                             format: "%d/%m/%Y",
//                             label: "Đến ngày",
//                             labelPosition: "top",
//                             value: new Date()
//                         },
//                     ]
//                 },
//                 {
//                     view: "combo",
//                     name: "inv_InvoiceCode_id",
//                     label: "Ký hiệu",
//                     labelPosition: "top",
//                     options: app.config.host + "/System/GetDataReferencesByRefId?refId=RF00029",
//                     required: true,
//                     invalidMessage: "Ký hiệu hóa đơn không được để trống !"
//                     // validate: webix.rules.isEmpty
//                 },
//                 {
//                     view: "combo",
//                     name: "cerSerial",
//                     label: "Chứng thư số",
//                     labelPosition: "top",
//                     id: "txtCerSerial",
//                     required: true,
//                     invalidMessage: "Chứng thư số không được để trống !",
//                     options: {
//                         view: "gridsuggest",
//                         url: app.config.host + "/Invoice/GetListCertificatesAuto",
//                         body: {
//                             columns: [
//                                 {
//                                     id: "so_serial",
//                                     header: _("SO_SERIAL"),
//                                     width: 150
//                                 },
//                                 {
//                                     id: "subjectname",
//                                     header: _("SUBJECTNAME"),
//                                     width: 550
//                                 },
//                                 {
//                                     id: "ngaybatdau",
//                                     header: _("NGAY_BAT_DAU"),
//                                     width: 150,
//                                     format: function (text) {
//                                         var format = webix.Date.dateToStr("%d/%m/%Y");
//                                         text = removeTimeZoneT(text);
//                                         return format(text);
//                                     }
//                                 },
//                                 {
//                                     id: "ngayketthuc",
//                                     header: _("NGAY_KET_THUC"),
//                                     width: 150,
//                                     format: function (text) {
//                                         var format = webix.Date.dateToStr("%d/%m/%Y");
//                                         text = removeTimeZoneT(text);
//                                         return format(text);
//                                     }
//                                 }
//                             ]
//                         }

//                     }
//                 },
//                 {
//                     view: "template",
//                     template: "Danh sách hóa đơn chờ ký",
//                     type: "section"
//                 },
//                 {

//                     view: "datatable",
//                     select: "row",
//                     id: "tblHoadon",
//                     resizeColumn: true,
//                     datafetch: 50,
//                     on: {
//                         "data->onStoreUpdated": function () {
//                             this.data.each(function (obj, i) {
//                                 obj.index = i + 1;
//                             })
//                         }
//                         // onKeyPress: function (code, e) {
//                         //     var table = this;

//                         //     if (e.key == "Enter") {
//                         //         var win = this.getTopParentView();
//                         //         var toolbar = win.getChildViews()[1].getChildViews()[0];

//                         //         var btnChon = toolbar.getChildViews()[0];
//                         //         btnChon.callEvent("onClick");
//                         //     }
//                         // }
//                     },
//                     columns: [
//                         {
//                             id: "chon1",
//                             header: [{ text: "", content: "masterCheckbox" }],
//                             width: 55,
//                             checkValue: 'C',
//                             uncheckValue: 'K',
//                             template: "{common.checkbox()}"
//                         },
//                         { id: "index", sort: "int", header: "STT", width: 50 },
//                         { id: "inv_InvoiceAuth_id", header: "ID hóa đơn", width: 250, hidden: true },
//                         {
//                             id: "inv_invoiceIssuedDate", header: "Ngày hóa đơn", width: 150, format: function (text) {
//                                 var format = webix.Date.dateToStr("%d/%m/%Y");
//                                 text = removeTimeZoneT(text);
//                                 return format(text);
//                             }
//                         },
//                         { id: "inv_invoiceNumber", header: "Số hóa đơn" },
//                         {
//                             id: "inv_TotalAmount", header: "Tổng tiền", width: 150, format: webix.Number.numToStr({
//                                 groupDelimiter: ",",
//                                 groupSize: 3,
//                                 decimalDelimiter: ".",
//                                 decimalSize: 0
//                             })
//                         }
//                     ],
//                     pager: "selectPagerA"
//                 },
//                 {
//                     id: "selectPagerA",
//                     view: "pager",
//                     size: 50,
//                     group: 5,
//                     template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}"
//                 },
//                 {
//                     margin: 10,
//                     cols: [
//                         {},
//                         {
//                             shortcut: "F9", view: "button", label: "Tải dữ liệu (F9)", type: "form", align: "center", width: 120,
//                             on: {
//                                 onClick: function () {
//                                     var form = webix.$$("chukyso-form");
//                                     if (form.validate()) {
//                                         var item = form.getValues();

//                                         var parameter = {
//                                             command: "CM00020",
//                                             parameter: {
//                                                 ma_dvcs: user.getDvcsID(),
//                                                 tu_ngay: item.tu_ngay,
//                                                 den_ngay: item.den_ngay,
//                                                 inv_InvoiceCode_id: item.inv_InvoiceCode_id
//                                             }
//                                         };

//                                         var url = app.config.host + "/System/ExecuteCommand";

//                                         webix.extend(form, webix.ProgressBar);
//                                         //form.disable();
//                                         form.showProgress();

//                                         webix.ajax()
//                                             .headers({ 'Content-type': 'application/json' })
//                                             .post(url, parameter, function (text) {

//                                                 var json = JSON.parse(text);

//                                                 if (!json.hasOwnProperty("error")) {

//                                                     if (json.length == 0) {
//                                                         webix.message("Không có dữ liệu", "error");
//                                                         var table = $$("tblHoadon");
//                                                         //table.load(table.config.url);
//                                                         table.clearAll();
//                                                         form.hideProgress();
//                                                         return;
//                                                     }
//                                                     else {
//                                                         form.hideProgress();
//                                                         $$("btnNhan").enable();
//                                                         var table = $$("tblHoadon");
//                                                         //table.load(table.config.url);
//                                                         table.clearAll();
//                                                         var table = $$("tblHoadon");
//                                                         table.parse(json);
//                                                     }
//                                                 }
//                                             });
//                                     }
//                                 }
//                             },
//                             click: function () {
//                                 this.callEvent("onClick");
//                             }
//                         },
//                         {
//                             shortcut: "F10", view: "button", id: "btnNhan", name: "btnNhan", type: "form", label: "Nhận (F10)", align: "center",
//                             on: {
//                                 onClick: function () {
//                                     var form = webix.$$("chukyso-form");

//                                     webix.extend(form, webix.ProgressBar);
//                                     form.disable();
//                                     form.showProgress();
//                                     var json = $$("tblHoadon").serialize();

//                                     if (json.length == 0) {

//                                         webix.message("Không có dữ liệu !", "error");
//                                         form.enable();
//                                         form.hideProgress();
//                                         return;
//                                     }
//                                     var win = $$("chukyso-win");

//                                     var kytaptrung = win.config.kytaptrung;
//                                     var server_cert = win.config.server_cert;

//                                     if (kytaptrung == "FILE") {
//                                         var box = webix.modalbox({
//                                             title: "Đang ký hóa đơn .... ",
//                                             buttons: ["Hủy bỏ"],
//                                             text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
//                                             width: 350,
//                                             height: 200,
//                                             callback: function (result) {
//                                                 switch (result) {
//                                                     case "0":
//                                                         //clearTimeout(interVal);
//                                                         webix.modalbox.hide(box);
//                                                         break;
//                                                 }
//                                             }
//                                         });
//                                         var txtCer = $$("txtCerSerial");
//                                         var cert = txtCer.getList().getSelectedItem();
//                                         var d = 0;
//                                         var d1 = 0;
//                                         for (var i = 0; i < json.length; i++) {
//                                             var item = json[i];

//                                             if (item.chon1 != undefined) {
//                                                 if (item.chon1 == "C") {
//                                                     d1 = d1 + 1;
//                                                     console.log(d1);
//                                                     var a = webix.ajax(app.config.host + "/Invoice/ExportXml?id=" + item.inv_InvoiceAuth_id);

//                                                     webix.promise.all([a]).then(function (results) {
//                                                         var a_result = results[0].json();

//                                                         signOnServerFile(a_result, cert, server_cert);
//                                                         d = d + 1;
//                                                         console.log(d);

//                                                         if (d == d1) {
//                                                             webix.modalbox.hide(box);
//                                                         }
//                                                         form.enable();
//                                                         form.hideProgress();
//                                                         //webix.modalbox.hide(box);
//                                                         //clearTimeout(interVal);

//                                                     }).fail(function (err) {

//                                                         form.enable();
//                                                         form.hideProgress();

//                                                         webix.alert({
//                                                             title: "Lỗi !",
//                                                             text: err,
//                                                             type: "alert-error"
//                                                         });
//                                                     });
//                                                 }
//                                             }
//                                         }
//                                         //console.log(d);

//                                         // var interVal = setTimeout(function () {

//                                         //     var txtCer = $$("txtCerSerial");
//                                         //     var cert = txtCer.getList().getSelectedItem();

//                                         //         clearTimeout(interVal);
//                                         //         webix.modalbox.hide(box);

//                                         // }, 500);

//                                         var tableHD = webix.$$("tblHoadon");
//                                         tableHD.clearAll();
//                                         form.enable();
//                                         form.hideProgress();

//                                         //tableHD.load(tableHD.config.url);

//                                         // var table = webix.$$("windowData");
//                                         // table.clearAll();
//                                         // table.load(table.config.url);
//                                     }
//                                     else {
//                                         if (kytaptrung == "C") {
//                                             var promises = [];

//                                             for (var i = 0; i < json.length; i++) {

//                                                 if (json[i]["chon1"] != null && json[i]["chon1"] == "C") {
//                                                     var a = webix.ajax().get(app.config.host + "/Invoice/ExportXml?id=" + json[i].inv_InvoiceAuth_id);
//                                                     promises.push(a);
//                                                 }
//                                             }

//                                             webix.promise.all(promises).then(function (results) {
//                                                 var promises = [];

//                                                 var server_cert = win.config.server_cert;

//                                                 var txtCer = $$("txtCerSerial");
//                                                 var cert = txtCer.getList().getSelectedItem();

//                                                 for (var i = 0; i < results.length; i++) {
//                                                     var json = results[i].json();

//                                                     var parameters = {
//                                                         xml: json["InvoiceXmlData"],
//                                                         refUri: "#data",
//                                                         certSerial: cert.so_serial,
//                                                         tokenSerial: cert.tokenSerial,
//                                                         signId: "seller",
//                                                         signTag: "Signatures",
//                                                         pass: cert.pass,
//                                                         inv_InvoiceAuth_id: json["inv_InvoiceAuth_id"]
//                                                     };

//                                                     var a = webix.ajax()
//                                                         .headers({ "Content-Type": "application/json" })
//                                                         .post(server_cert + "/Token/SignXml", parameters, function (text) {
//                                                         });

//                                                     promises.push(a);
//                                                 }

//                                                 webix.promise.all(promises).then(function (results) {
//                                                     var promises = [];

//                                                     for (var i = 0; i < results.length; i++) {
//                                                         var json = results[i].json();

//                                                         var parameters = {
//                                                             InvoiceXmlData: json.xml,
//                                                             inv_InvoiceAuth_id: json.inv_InvoiceAuth_id
//                                                         };

//                                                         var a = webix.ajax()
//                                                             .headers({ "Content-Type": "application/json" })
//                                                             .post(server_cert + "/Invoice/SaveXml", parameters, function (text) {
//                                                             });

//                                                         promises.push(a);
//                                                     }

//                                                     webix.promise.all(promises).then(function (results) {
//                                                         var table = webix.$$("windowData");
//                                                         table.clearAll();
//                                                         table.load(table.config.url);

//                                                         var form = webix.$$("chukyso-form");
//                                                         form.enable();
//                                                         form.hideProgress();

//                                                         var win = $$("chukyso-win");
//                                                         win.close();
//                                                     }).fail(function (err) {
//                                                         alert(err);

//                                                         var form = webix.$$("chukyso-form");
//                                                         form.enable();
//                                                         form.hideProgress();
//                                                     });


//                                                 }).fail(function (err) {
//                                                     alert(err);

//                                                     var form = webix.$$("chukyso-form");
//                                                     form.enable();
//                                                     form.hideProgress();
//                                                 });

//                                             }).fail(function (err) {
//                                                 alert(err);

//                                                 var form = webix.$$("chukyso-form");
//                                                 form.enable();
//                                                 form.hideProgress();
//                                             });
//                                         }
//                                         else {
//                                             var promises = "";
//                                             for (var i = 0; i < json.length; i++) {
//                                                 if (json[i]["chon1"] != null && json[i]["chon1"] == "C") {
//                                                     promises = promises + "'" + json[i].inv_InvoiceAuth_id + "',";
//                                                 }
//                                             }

//                                             var promises_auth = promises.substring(0, promises.length - 1);
//                                             console.log(promises_auth);

//                                             var promises_auth_base = btoa(promises_auth);

//                                             var item = form.getValues();
//                                             var data_post = {
//                                                 inv_InvoiceCode_id: item.inv_InvoiceCode_id,
//                                                 tu_ngay: item.tu_ngay,
//                                                 den_ngay: item.den_ngay,
//                                                 data: promises_auth_base
//                                             };

//                                             var url = app.config.host + "/Invoice/GetXmlSignInvoices";
//                                             // var url = app.config.host + "/Invoice/GetXmlSignInvoices?inv_InvoiceCode_id=" + item.inv_InvoiceCode_id
//                                             //     + "&tu_ngay=" + moment(item.tu_ngay).format("DD/MM/YYYY") + "&den_ngay=" + moment(item.den_ngay).format("DD/MM/YYYY") + "&inv_invoiceAuth_id=" + promises_auth_base;

//                                             webix.extend(form, webix.ProgressBar);
//                                             form.disable();
//                                             form.showProgress();

//                                             webix.ajax()
//                                                 .headers({ 'Content-type': 'application/json' })
//                                                 .post(url, data_post, function (text) {

//                                                     var json = JSON.parse(text);

//                                                     if (!json.hasOwnProperty("error")) {
//                                                         var hub = plugin.hub();
//                                                         hub.off('resCommand');

//                                                         hub.on('resCommand', function (result) {
//                                                             console.log("4");
//                                                             var json = JSON.parse(result);
//                                                             //console.log(json);
//                                                             if (json.hasOwnProperty("error")) {
//                                                                 webix.message({ type: 'error', text: json.error });

//                                                                 var form = webix.$$("chukyso-form");
//                                                                 form.enable();
//                                                                 form.hideProgress();
//                                                             }
//                                                             else {
//                                                                 var parameter = {
//                                                                     data: json.data,
//                                                                     cerSerial: $$("txtCerSerial").getValue()
//                                                                 };

//                                                                 webix.ajax()
//                                                                     .headers({ "Content-Type": "application/json" })
//                                                                     .post(app.config.host + "/Invoice/SaveXmlSign", parameter, function (text) {
//                                                                         var json = JSON.parse(text);
//                                                                         //console.log(json);
//                                                                         var form = webix.$$("chukyso-form");
//                                                                         form.enable();
//                                                                         form.hideProgress();

//                                                                         if (json.hasOwnProperty("error")) {
//                                                                             webix.message({ type: 'error', text: json.error });
//                                                                         }
//                                                                         else {
//                                                                             var table = webix.$$("windowData");
//                                                                             table.clearAll();
//                                                                             table.load(table.config.url);

//                                                                             var win = $$("chukyso-win");
//                                                                             win.close();
//                                                                         }

//                                                                     });
//                                                             }
//                                                         });

//                                                         var form = webix.$$("chukyso-form");
//                                                         var item = form.getValues();

//                                                         var arg = {
//                                                             idData: "#data",
//                                                             data: json,
//                                                             idSigner: "seller",
//                                                             tagSign: "Signatures",
//                                                             listcerts: [
//                                                                 {
//                                                                     so_serial: item.cerSerial
//                                                                 }
//                                                             ]
//                                                         };
//                                                         // var kf = btoa(arg);

//                                                         // console.log(kf);
//                                                         // var k = MD5(arg);
//                                                         // console.log(arg);

//                                                         hub.invoke('execCommand', 'SignXmlInvoices', JSON.stringify(arg))
//                                                             .done(function () {
//                                                                 //console.log("Success !")
//                                                                 console.log("2");
//                                                             })
//                                                             .fail(function (error) {
//                                                                 // console.log(error);
//                                                                 var form = webix.$$("chukyso-form");
//                                                                 form.enable();
//                                                                 form.hideProgress();
//                                                                 webix.message(error, "error");
//                                                             });
//                                                     }
//                                                     else {
//                                                         webix.message(json.error);

//                                                         var form = webix.$$("chukyso-form");
//                                                         form.enable();
//                                                         form.hideProgress();
//                                                     }
//                                                 });
//                                         }
//                                     }
//                                 }
//                             },
//                             click: function () {
//                                 this.callEvent("onClick");
//                             }
//                         },
//                         {
//                             view: "button", hotkey: "esc", label: "Hủy bỏ (ESC)", type: "danger", align: "center", width: 100,
//                             click: function () {
//                                 webix.$$("chukyso-win").close();
//                             }
//                         },
//                         {}
//                     ]
//                 }
//             ]
//         }
//     };
//     return {
//         $ui: layout,
//         setEditMode: function (mode) {
//             editmode = mode;
//         }
//     };

// });
define("views/forms/kynhieuhoadonold", function(){});

define('views/forms/license',["app", "locale"], function (app, _) {
	var editmode = 0;

	return {
		$ui: {
			view: "window", modal: true, id: "dmtab-win", position: "center",
			head: "Thông tin bản quyền",
			body: {

				paddingY: 10,
				paddingX: 10,
				elementsConfig: {
					labelWidth: 60,
					labelPosition: "top"
				},
				view: "form",
				id: "license-form",
				complexData: true,
				margin: 0,
				borderless: true,
				elements: [
					{ view: "text", name: "ms_thue", label: _("MS_THUE"), width: 450, readonly: true, css: "mcls_readonly_text" },
					{ view: "text", name: "ten_dvcs", label: _("TEN_DON_VI"), readonly: true, css: "mcls_readonly_text" },
					{ view: "autonumeric", name: "sl_hd", label: _("SL_HD_DK"), readonly: true, css: "mcls_readonly_text" },
					{
						view: "autonumeric",
						name: "sl_dk_them",
						label: _("SL_HD_THEM"),
						required: true,
						invalidMessage: "Số lượng nhập không đúng giá trị >= 1 !",
						validate: webix.rules.isNumber,
						on: {
							onChange: function (newv, oldv) {
								if (newv == undefined) return;
								if (newv == "") return;
								// if (newv < 1) {
								// 	webix.message("Số lượng đăng ký phải lớn hơn hoặc bằng 1", "error");
								// 	return;
								// }
							}
						}
					},
					{ view: "text", name: "key_license", label: _("KEY_LICENSE"), readonly: true, inputAlign: "center", css: "mcls_license_text" },
					{
						margin: 10,
						cols: [
							{},
							{
								shortcut: "F10", id: "btnSave", view: "button", label: "Nhận (F10)", type: "form", align: "center", width: 120,
								on: {
									onClick: function () {
										var form = webix.$$("license-form");
										var item = form.getValues();

										if (item.sl_dk_them < 1 || item.sl_dk_them == "" || item.sl_dk_them == null) {
											webix.message("Số lượng đăng ký thêm không được để trống hoặc bằng 0 !", "error");
											return false;
										}
										if ($$("license-form").validate()) {
											var url = app.config.host + "/License/Register";
											webix.extend(form, webix.ProgressBar);
											form.disable();
											form.showProgress();

											webix.ajax()
												.bind(this)
												.headers({ 'Content-type': 'application/json' })
												.post(url, item, function (text) {
													var result = JSON.parse(text);
													if (!result.hasOwnProperty("error")) {
														var interVal = setInterval(function () {
															var url = app.config.host + "/License/CheckLicense?id=" + result.id;
															webix.ajax(url, {
																error: function (text, data, XmlHttpRequest) {
																	webix.message(text);
																	var form = webix.$$("license-form");
																	form.enable();
																	form.hideProgress();
																	clearInterval(interVal);

																},
																success: function (text, data, XmlHttpRequest) {
																	var result = JSON.parse(text);
																	if (!result.hasOwnProperty("error")) {

																		var form = webix.$$("license-form");
																		var values = form.getValues();
																		values.key_license = result.key_license;
																		values.sl_dk_them = 0;
																		values.sl_hd = result.sl_hd;

																		form.setValues(values);
																		form.enable();
																		form.hideProgress();

																		clearInterval(interVal);
																	}
																}
															});

														}, 3000);
													}
													else {
														webix.message(result.error, "error");
														var form = webix.$$("license-form");
														form.enable();
														form.hideProgress();
													}
												});
										}
									}
								},
								click: function () {
									this.callEvent("onClick");
								}
							},
							{
								view: "button", hotkey: "esc", label: "Hủy bỏ (ESC)", type: "danger", align: "center", width: 120,
								click: function () {
									webix.$$("dmtab-win").close();
								}
							},
							{}
						]
					}

				]
			}
		},
		setEditMode: function (mode) {
			editmode = mode;
		}
	};

});
define('views/forms/lichsudmdvcs',["app", "locale"], function (app, _) {
    var fm = function (text) {
        var format = webix.Date.dateToStr("%d/%m/%Y %H:%i:%s");
        text = removeTimeZoneT(text);
        return format(text);
    };

    var mst;
    function initUI(ms_thue) {
        mst = ms_thue;
        // var model = { inv_InvoiceAuth_id: inv_InvoiceAuth_id };
        // webix.ajax()
        //     .headers({ 'Content-type': 'application/json' })
        //     .post(app.config.host + "/Invoice/history_email", model, function (text) {
        //         var data = JSON.parse(text);

        //         if (!data.hasOwnProperty("error")) {
        //             $$('dmdvcs-forms').setValue(data);
        //         }
        //         else {
        //             webix.message(data.error, "error");
        //         }
        //     });
    };

    return {
        $ui: {
            view: "window", modal: true, id: "dmdvcs-wins", position: "center",
            head: "Lịch sử thay đổi thông tin doanh nghiệp",
            //  headHeight: 80,
            width: 930,
            height: 400,
            move: true,
            body: {
                paddingY: 10,
                paddingX: 10,
                view: "form",
                id: "dmdvcs-forms",
                complexData: true,
                margin: 0,
                elements: [
                    {
                        view: "datatable",
                        // header: "Lịch sử gửi Email",
                        id: "tbl_dmdvcss",
                        tooltip: true,
                        editable: false,
                        resizeColumn: true,
                        clipboard: "selection",
                        select: "cell",
                        // leftSplit: 5,
                        // fixedRowHeight: true,
                        // rowLineHeight: 25,
                        // rowHeight: 25,
                        //autoheight:true,
                        // url: app.config.host + "/System/GetLogDmdvcs",
                        url: {
                            $proxy: true,
                            load: function (view, callback, params) {
                                // var table = webix.$$("windowData").getSelectedItem();

                                var url = app.config.host + "/System/GetLogDmdvcs";
                                webix.ajax(url, callback, view);
                            }
                        },
                        on: {
                            "onresize": webix.once(function () {
                                this.adjustRowHeight("datelog", true);
                            }),
                            "data->onStoreUpdated": function () {
                                this.data.each(function (obj, i) {
                                    obj.stt = i + 1;
                                })
                            },
                            onItemDblClick: function (id, e, node) {
                                // var btnEdit = $$("btncskh");
                                // btnEdit.callEvent("onClick");
                                //webix.message("Click M-invoice", "error");
                            },
                            onBeforeRender: function () {
                                // var table = webix.$$("windowData").getSelectedItem();
                                //    webix.$$("dmdvcs-wins").getHead().setHTML("Lịch sử thay đổi thông tin doanh nghiệp</br><span style='font-size: 14px;'> Mã số thuế:<b style='color:blue'> " + mst + "</b></span>");
                                //$$("tbl_dmdvcss").refresh();
                                //$$("tbl_dmdvcss").define("pager", kk);
                            },
                            onBeforeLoad: function () {
                                webix.extend(this, webix.ProgressBar);
                                this.disable();
                                this.showProgress();
                                this.showOverlay("LOADING ...");
                            },
                            onAfterLoad: function () {
                                this.enable();
                                this.hideProgress();
                                this.hideOverlay();
                            }
                        },
                        columns: [
                            { id: "stt", header: "STT", width: 40 },
                            { id: "user_new", name: "user_new", header: "Người sửa", width: 130, editor: "text" },
                            {
                                id: "datelog", name: "datelog", header: "Ngày sửa", width: 110, editor: "date", format: function (text) {
                                    var format = webix.Date.dateToStr("%d/%m/%Y %H:%i:%s");
                                    text = removeTimeZoneT(text);
                                    return format(text);
                                }, sort: "date"
                            },
                            { id: "ghichu", name: "ghichu", header: "Dữ liệu", fillspace: true, editor: "text" },
                            // {
                            //     id: "ghichu", name: "ghichu", header: "Dữ liệu", width: 150, editor: "text",
                            //     template: function (obj) {
                            //         //     if (obj.failed == "OK")
                            //         //         return "<span style='color: #00b300'><i class='fas fa-check'></i></span> " + fm(obj.date_send);
                            //         //     else
                            //         //         if (obj.failed == null) {
                            //         //             return "<span>Không hỗ trợ</span>"
                            //         //         }
                            //         //         else
                            //         //             return "<span style='color: red'><i class='fas fa-times'></i></span> " + obj.failed == null ? "" : obj.failed;
                            //     }
                            // }
                        ],
                        // pager: "pagerB",
                        // ready: function () {
                        //     //this.open(this.getFirstId());
                        //     this.sort({ by: "stt", dir: "desc" });
                        // },
                    },
                    // {
                    //     id: "pagerB",
                    //     view: "pager",
                    //     size: 100,
                    //     group: 5,
                    //     template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}"
                    // },
                    {
                        margin: 10,
                        cols: [
                            {},
                            {
                                view: "button", hotkey: "esc", label: "Hủy bỏ (ESC)", align: "center", width: 120, type: "danger",
                                click: function () {
                                    webix.$$("dmdvcs-wins").close();
                                }
                            },
                            // {
                            //     view: "button", hotkey: "esc", label: "Event", align: "center", width: 120, type: "danger",
                            //     click: function () {
                            //         webix.ajax()
                            //             .headers({ 'Content-type': 'application/json' })
                            //             .get(app.config.host + "/Invoice/MaigunEvent", {
                            //                 error: function (text, data, XmlHttpRequest) {
                            //                     //webix.modalbox.hide(box);
                            //                     webix.alert({
                            //                         title: "Lỗi !",
                            //                         text: err,
                            //                         type: "alert-error"
                            //                     });
                            //                 },
                            //                 success: function (text, data, XmlHttpRequest) {
                            //                     var c_result = JSON.parse(text);

                            //                 }
                            //             });
                            //     }
                            // },
                            {}
                        ]
                    }

                ]
            }

        },
        initUI: initUI
    };

});
define('views/forms/lichsuemail',["app", "locale"], function (app, _) {
    var fm = function (text) {
        var format = webix.Date.dateToStr("%d/%m/%Y %H:%i:%s");
        text = removeTimeZoneT(text);
        return format(text);
    };
    function initUI(inv_InvoiceAuth_id) {
        // var model = { inv_InvoiceAuth_id: inv_InvoiceAuth_id };
        // webix.ajax()
        //     .headers({ 'Content-type': 'application/json' })
        //     .post(app.config.host + "/Invoice/history_email", model, function (text) {
        //         var data = JSON.parse(text);

        //         if (!data.hasOwnProperty("error")) {
        //             $$('email-form').setValue(data);
        //         }
        //         else {
        //             webix.message(data.error, "error");
        //         }
        //     });
    };

    return {
        $ui: {
            view: "window", modal: true, id: "email-win", position: "center",
            head: "Lịch sử gửi Email", headHeight: 80,
            width: 930,
            height: 400,
            move: true,
            body: {
                paddingY: 10,
                paddingX: 10,
                view: "form",
                id: "email-form",
                complexData: true,
                margin: 0,
                elements: [
                    {
                        view: "datatable",
                        // header: "Lịch sử gửi Email",
                        id: "tbl_email",
                        editable: false,
                        resizeColumn: true,
                        select: true,
                        leftSplit: 5,
                        // fixedRowHeight: true,
                        // rowLineHeight: 25,
                        // rowHeight: 25,
                        //autoheight:true,
                        url: {
                            $proxy: true,
                            load: function (view, callback, params) {
                                var table = webix.$$("windowData").getSelectedItem();

                                var url = app.config.host + "/Invoice/history_email?inv_InvoiceAuth_id=" + table.inv_InvoiceAuth_id;
                                webix.ajax(url, callback, view);
                            }
                        },
                        on: {
                            "onresize": webix.once(function () {
                                this.adjustRowHeight("loai", true);
                            }),
                            "data->onStoreUpdated": function () {
                                this.data.each(function (obj, i) {
                                    obj.stt = i + 1;
                                })
                            },
                            onItemDblClick: function (id, e, node) {
                                // var btnEdit = $$("btncskh");
                                // btnEdit.callEvent("onClick");
                                //webix.message("Click M-invoice", "error");
                            },
                            onBeforeRender: function () {
                                var table = webix.$$("windowData").getSelectedItem();
                                $$("email-win").getHead().setHTML("Lịch sử gửi Email</br><span style='font-size: 14px;'> Số hóa đơn:<b style='color:blue'> " + table.inv_invoiceNumber + "</b> Mẫu số:<b style='color:blue'> " + table.mau_hd + "</b> Ký hiệu:<b style='color:blue'> " + table.inv_invoiceSeries + "</b></span>");
                                //$$("tbl_email").refresh();
                                //$$("tbl_email").define("pager", kk);
                            },
                            onBeforeLoad: function () {
                                webix.extend(this, webix.ProgressBar);
                                this.disable();
                                this.showProgress();
                                // this.showOverlay("LOADING ...");
                            },
                            onAfterLoad: function () {
                                this.enable();
                                this.hideProgress();
                                // this.hideOverlay();
                            }
                        },
                        columns: [
                            { id: "stt", header: "STT", width: 40 },
                            { id: "user_send", name: "user_send", header: "Người gửi", width: 130, editor: "text" },
                            { id: "send_to", name: "send_to", header: "Email người nhận", width: 150, editor: "text" },
                            {
                                id: "date_send", name: "date_send", header: "Ngày gửi", width: 110, editor: "date", format: function (text) {
                                    var format = webix.Date.dateToStr("%d/%m/%Y");
                                    text = removeTimeZoneT(text);
                                    return format(text);
                                }, sort: "date"
                            },
                            // { id: "inv_invoiceNumber", name: "inv_invoiceNumber", header: "Số hóa đơn", width: 100, editor: "text" },
                            // { id: "mau_hd", name: "mau_hd", header: "Mẫu hóa đơn", width: 120, editor: "text" },
                            // { id: "inv_invoiceSeries", name: "inv_invoiceSeries", header: "Ký hiệu", width: 90, editor: "text" },
                            { id: "messId", name: "messId", header: "messId", width: 90, editor: "text", hidden: true },
                            {
                                id: "failed", name: "failed", header: "Trạng thái gửi", width: 150, editor: "text",
                                template: function (obj) {
                                    if (obj.failed == "OK")
                                        return "<span style='color: #00b300'><i class='fas fa-check'></i></span> " + fm(obj.date_send);
                                    else
                                        if (obj.failed == null) {
                                            return "<span>Không hỗ trợ</span>"
                                        }
                                        else
                                            return "<span style='color: red'><i class='fas fa-times'></i></span> " + obj.failed == null ? "" : obj.failed;
                                }
                            },
                            {
                                id: "opened", name: "opened", header: "Trạng thái xem", width: 150, editor: "date",
                                //  format: function (text) {
                                //     var format = webix.Date.dateToStr("%d/%m/%Y %H:%i:%s");
                                //     text = removeTimeZoneT(text);
                                //     return format(text);
                                // },
                                sort: "date",
                                template: function (obj) {
                                    if (obj.opened == "" || obj.opened == null)
                                        return "<span style='color: red'><i class='fas fa-times'></i></span>";
                                    else
                                        return "<span style='color: #00b300'><i class='fas fa-check'></i></span> " + fm(obj.opened);
                                }
                            },
                            { id: "loai", name: "loai", header: "Loại gửi", width: 150, editor: "text" }
                        ],
                        pager: "pagerB",
                        ready: function () {
                            //this.open(this.getFirstId());
                            this.sort({ by: "stt", dir: "desc" });
                        },
                    },
                    {
                        id: "pagerB",
                        view: "pager",
                        size: 100,
                        group: 5,
                        template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}"
                    },
                    {
                        margin: 10,
                        cols: [
                            {},
                            {
                                view: "button", hotkey: "esc", label: "Hủy bỏ (ESC)", align: "center", width: 120, type: "danger",
                                click: function () {
                                    webix.$$("email-win").close();
                                }
                            },
                            // {
                            //     view: "button", hotkey: "esc", label: "Event", align: "center", width: 120, type: "danger",
                            //     click: function () {
                            //         webix.ajax()
                            //             .headers({ 'Content-type': 'application/json' })
                            //             .get(app.config.host + "/Invoice/MaigunEvent", {
                            //                 error: function (text, data, XmlHttpRequest) {
                            //                     //webix.modalbox.hide(box);
                            //                     webix.alert({
                            //                         title: "Lỗi !",
                            //                         text: err,
                            //                         type: "alert-error"
                            //                     });
                            //                 },
                            //                 success: function (text, data, XmlHttpRequest) {
                            //                     var c_result = JSON.parse(text);

                            //                 }
                            //             });
                            //     }
                            // },
                            {}
                        ]
                    }

                ]
            }

        },
        initUI: initUI
    };

});
define('views/forms/lichsuZns',["app", "locale"], function (app, _) {
    var fm = function (text) {
        var format = webix.Date.dateToStr("%d/%m/%Y %H:%i:%s");
        text = removeTimeZoneT(text);
        return format(text);
    };
    function initUI(inv_InvoiceAuth_id) {

    };

    return {
        $ui: {
            view: "window", modal: true, id: "zns-win", position: "center",
            head: "Lịch sử gửi Email", headHeight: 80,
            width: 800,
            height: 400,
            move: true,
            body: {
                paddingY: 10,
                paddingX: 10,
                view: "form",
                id: "zns-form",
                complexData: true,
                margin: 0,
                elements: [
                    {
                        view: "datatable",
                        // header: "Lịch sử gửi Email",
                        id: "tbl_zns",
                        editable: false,
                        resizeColumn: true,
                        select: true,
                        leftSplit: 5,
                        // fixedRowHeight: true,
                        // rowLineHeight: 25,
                        // rowHeight: 25,
                        //autoheight:true,
                        url: {
                            $proxy: true,
                            load: function (view, callback, params) {
                                var table = webix.$$("windowData").getSelectedItem();

                                var url = app.config.host + "/Invoice/historyZNS?id=" + table.inv_InvoiceAuth_id;
                                webix.ajax(url, callback, view);
                            }
                        },
                        on: {
                            "onresize": webix.once(function () {
                                this.adjustRowHeight("loai", true);
                            }),
                            "data->onStoreUpdated": function () {
                                this.data.each(function (obj, i) {
                                    obj.stt = i + 1;
                                })
                            },
                            onItemDblClick: function (id, e, node) {
                                // var btnEdit = $$("btncskh");
                                // btnEdit.callEvent("onClick");
                                //webix.message("Click M-invoice", "error");
                            },
                            onBeforeRender: function () {
                                var table = webix.$$("windowData").getSelectedItem();
                                $$("zns-win").getHead().setHTML("Lịch sử gửi Zalo</br><span style='font-size: 14px;'> Số hóa đơn:<b style='color:blue'> " + table.inv_invoiceNumber + "</b> Mẫu số:<b style='color:blue'> " + table.mau_hd + "</b> Ký hiệu:<b style='color:blue'> " + table.inv_invoiceSeries + "</b></span>");
                                //$$("tbl_zns").refresh();
                                //$$("tbl_zns").define("pager", kk);
                            },
                            onBeforeLoad: function () {
                                webix.extend(this, webix.ProgressBar);
                                this.disable();
                                this.showProgress();
                                // this.showOverlay("LOADING ...");
                            },
                            onAfterLoad: function () {
                                this.enable();
                                this.hideProgress();
                                // this.hideOverlay();
                            }
                        },
                        columns: [
                            { id: "stt", header: "STT", width: 40 },
                            { id: "user_new", name: "user_new", header: "Người gửi", width: 130, editor: "text" },
                            { id: "toPhone", name: "toPhone", header: "SĐT người nhận", width: 150, editor: "text" },
                            {
                                id: "date_new", name: "date_new", header: "Ngày gửi", width: 110, editor: "date", format: function (text) {
                                    var format = webix.Date.dateToStr("%d/%m/%Y");
                                    text = removeTimeZoneT(text);
                                    return format(text);
                                }, sort: "date"
                            },
                            // { id: "inv_invoiceNumber", name: "inv_invoiceNumber", header: "Số hóa đơn", width: 100, editor: "text" },
                            // { id: "mau_hd", name: "mau_hd", header: "Mẫu hóa đơn", width: 120, editor: "text" },
                            // { id: "inv_invoiceSeries", name: "inv_invoiceSeries", header: "Ký hiệu", width: 90, editor: "text" },
                            { id: "messId", name: "messId", header: "messId", width: 90, editor: "text", hidden: true },
                            {
                                id: "isSuccess", name: "isSuccess", header: "Trạng thái gửi", fillspace: true, editor: "text",
                                template: function (obj) {
                                    if (obj.isSuccess == "1")
                                        return "<span style='color: #00b300'><i class='fas fa-check'></i></span> ";
                                    else
                                        return "<span style='color: red'><i class='fas fa-times'></i></span> " + obj.response;
                                }
                            }
                        ],
                        pager: "pagerB",
                        ready: function () {
                            //this.open(this.getFirstId());
                            this.sort({ by: "stt", dir: "desc" });
                        },
                    },
                    {
                        id: "pagerB",
                        view: "pager",
                        size: 100,
                        group: 5,
                        template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}"
                    },
                    {
                        margin: 10,
                        cols: [
                            {},
                            {
                                view: "button", hotkey: "esc", label: "Hủy bỏ (ESC)", align: "center", width: 120, type: "danger",
                                click: function () {
                                    webix.$$("zns-win").close();
                                }
                            },
                            {}
                        ]
                    }

                ]
            }

        },
        initUI: initUI
    };

});
define('views/forms/main',[
    "app",
    "locale",
    "models/user"
], function (app, _, user) {
    var editmode = 0;
    var fm = webix.Number.numToStr({
        groupDelimiter: ",",
        groupSize: 3,
        decimalDelimiter: ".",
        decimalSize: 0
    });


    return {
        $ui: {
            view: "window",
            modal: true,
            position: "center",
            css: "headformchil",
            head: {
                //view: "toolbar",
                // css: { "box-shadow": "0 -2px #3498db inset !important", "background": "#ffffff !important" },
                //css: { "background": "#e6f2ff !important" },
                height: 35,
                cols: [
                    {
                        id: "head-iconMain",
                        view: "template",
                        css: "headform",
                        width: 35,
                        template: ""
                    },
                    {
                        id: "head-formmain", view: "template", css: "headform", template: function (obj) {
                            return '<div>Hóa đơn đầu vào<div/>';
                        }
                    },
                    {
                        view: "icon", icon: "fas fa-question-circle", id: "help_formmain", tooltip: _("HELPER"), click: function () {
                            // var form = webix.$$("window-form");
                            // hint_form(form.config.hint);
                        }
                    }
                ]
            },
            id: "main",
            resize: true,
            fullscreen: true,
            move: true,
            on: {
                onBeforeShow: function () {
                    $$("uploader").files.attachEvent("onAfterDelete", function () {
                        $$("inv_Invoice_fileName").setValue(null);
                        $$("inv_Invoice_fileData").setValue(null);
                        $$("inv_Invoice_fileType").setValue(null);
                        $$("inv_Invoice_fileSize").setValue(null);
                    });
                }
            },
            body: {
                paddingY: 10,
                paddingX: 10,
                elementsConfig: { labelWidth: 100 },
                view: "form",
                id: "main-form",
                width: 800,
                height: 500,
                complexData: true,
                margin: 0,
                on: {
                    // onViewShow: function () {

                    // }
                },
                elements: [
                    {
                        view: "scrollview",
                        scroll: "y",
                        body: {
                            paddingX: 18,
                            rows: [
                                {
                                    view: "combo",
                                    name: "inv_ncc_id",
                                    label: "Nhà cung cấp",
                                    //labelPosition: "top",
                                    id: "inv_Invoice_inv_ncc_id",
                                    required: true,
                                    invalidMessage: "Nhà cung cấp không thể bỏ trống !",
                                    options: {
                                        view: "gridsuggest",
                                        template: "#ten_ncc#",
                                        body: {
                                            scroll: true,
                                            autoheight: false,
                                            columns: [
                                                // { id: "id", header: _("MS_THUE"), width: 150 },
                                                { id: "mst", header: _("MS_THUE"), width: 150 },
                                                { id: "thuong_hieu", header: _("Thương hiệu"), width: 200 },
                                                { id: "ten_ncc", header: _("Tên nhà cung cấp"), width: 550 }
                                            ],
                                            dataFeed: function (filtervalue, filter) {
                                                if (filtervalue.length < 1) {
                                                    this.load(this.config.url);
                                                    return;
                                                }

                                                var pathUrl = app.config.host + "/System/GetDataReferencesByRefId?refId=RF00300";
                                                var urldata = "filtervalue=" + encodeURIComponent(filtervalue);

                                                this.load(pathUrl + "&" + urldata, this.config.datatype);
                                            }
                                        },
                                        url: app.config.host + "/System/GetDataReferencesByRefId?refId=RF00300",
                                    },
                                    on: {
                                        onChange: function (newv, oldv) {
                                            var option = this.getList().getItem(newv);
                                            if (option != undefined) {
                                                $$("inv_Invoice_url_tracuu").setValue(option.link_tracuu);
                                            }
                                            //  webix.message("CurData: " + option.thuong_hieu);
                                        }
                                    }
                                },
                                {
                                    cols: [
                                        {
                                            view: "button", type: "icon", icon: "fas fa-folder-open", label: "Chọn file", width: 110, placeholder: " Chọn file *.xml hoặc *.PDF",
                                            css: "btnMain",
                                            on: {
                                                onClick: function () {
                                                    webix.$$("uploader").fileDialog();
                                                }
                                            },
                                            click: function () {
                                                this.callEvent("onClick");
                                            }
                                        },
                                        {
                                            view: "button", type: "icon", icon: "fas fa-folder-open", label: "Đọc file", width: 110,
                                            css: "btnMain",
                                            on: {
                                                onClick: function () {
                                                    var table = $$("main-form");

                                                    var file = $$("uploader").files.getFirstId();
                                                    if (file == undefined || file == null) {
                                                        webix.message("Bạn chưa chọn File hóa đơn đính kèm", "error");
                                                        return;
                                                    }
                                                    var type = $$("uploader").files.getItem(file).type;
                                                    if (type != "xml") {
                                                        webix.message("File tải lên không phải định dạng XML. Không thể đọc", "error");
                                                        return;
                                                    }
                                                    webix.extend(table, webix.ProgressBar);
                                                    table.disable();
                                                    table.showProgress();
                                                    var data_post = { data: $$("inv_Invoice_fileData").getValue(), id: $$("inv_Invoice_inv_ncc_id").getValue() };
                                                    webix.ajax()
                                                        .headers({ 'Content-type': 'application/json' })
                                                        .post(app.config.host + "/ManageInvoice/ReadXml", data_post, {
                                                            error: function (text, data, XmlHttpRequest) {
                                                                table.enable();
                                                                table.hideProgress();
                                                                webix.message(text + XmlHttpRequest, "error");

                                                            }, success: function (text, data, XmlHttpRequest) {
                                                                var json = JSON.parse(text);
                                                                if (!json.hasOwnProperty("error")) {
                                                                    //$$("main-form").parse(json);
                                                                    $$("inv_Invoice_invoiceNumber").setValue(json.invoiceNumber);
                                                                    $$("inv_Invoice_invoiceSeries").setValue(json.invoiceSeries);
                                                                    $$("inv_Invoice_mauhd").setValue(json.mauhd);
                                                                    $$("inv_Invoice_sellerTaxCode").setValue(json.sellerTaxCode);
                                                                    $$("inv_Invoice_sellerName").setValue(json.sellerName);
                                                                    $$("inv_Invoice_sellerAdress").setValue(json.sellerAdress);
                                                                    $$("inv_Invoice_sdt").setValue(json.sdt);
                                                                    
                                                                    $$("inv_Invoice_tien_tt").setValue(json.tien_tt);
                                                                    $$("inv_Invoice_tien_ck").setValue(json.tien_ck);
                                                                    $$("inv_Invoice_tien_thue").setValue(json.tien_thue);
                                                                    $$("inv_Invoice_tong_tien").setValue(json.tong_tien);
                                                                    $$("inv_InvoiceDetails").clearAll();
                                                                    $$("inv_InvoiceDetails").parse(json["Details"]);
                                                                    table.enable();
                                                                    table.hideProgress();
                                                                }
                                                                else {
                                                                    webix.message(json.error, "error");
                                                                    table.enable();
                                                                    table.hideProgress();
                                                                }
                                                            }
                                                        });
                                                }
                                            },
                                            click: function () {
                                                this.callEvent("onClick");
                                            }
                                        },
                                        {
                                            rows: [
                                                // {view:"text",id:"df",label:"errr"},
                                                {
                                                    id: "uploader",
                                                    view: "uploader",
                                                    value: 'Chọn file',
                                                    hide: true,
                                                    name: "uploader",
                                                    placeholder: " Chọn file *.xml",
                                                    // accept: "image/png, image/jpeg, application/vnd.ms-excel,text/XML,text/plain,application/octet-stream,application/pdf,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                                                    accept: "text/XML",
                                                    link: "mylist",
                                                    autosend: false,
                                                    //borderless: true,
                                                    multiple: false,
                                                    //upload: app.config.host + "/Invoice/SaveInv",
                                                    on: {
                                                        onBeforeFileAdd: function (file) {

                                                            var size = file.size;
                                                            if (size > 1024000) {
                                                                webix.message("Bạn chỉ được đính kèm File <= 1 Mb", "error");
                                                                return false;
                                                            }
                                                            var typeList = ["xml", "pdf"];
                                                            if (typeList.indexOf(file.type) < 0) {
                                                                webix.message('File tải lên không đúng định dạng: xml, pdf !', "error");
                                                                return false;
                                                            }
                                                        },
                                                        onAfterRender: function () {
                                                            //console.log('called once after first rendering:');
                                                            this.hide();
                                                        },
                                                        onAfterFileAdd: function (upload) {
                                                            var file = new Blob([upload.file]);

                                                            var reader = new FileReader();
                                                            var type = upload.type;
                                                            if (type == "txt") { type = "text/plain"; }
                                                            if (type == "xml") { type = "text/XML"; }
                                                            if (type == "xls") { type = "application/vnd.ms-excel"; }
                                                            if (type == "docx") { type = "application/vnd.openxmlformats-officedocument.wordprocessingml.document"; }
                                                            if (type == "xlsx") { type = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"; }
                                                            if (type == "repx" || type == "rar") { type = "application/octet-stream"; }
                                                            if (type == "jpg") { type = "image/jpeg"; }
                                                            if (type == "png") { type = "image/png"; }
                                                            if (type == "pdf") { type = "application/pdf"; }

                                                            reader.onload = function () {

                                                                var arrayBuffer = this.result,
                                                                    array = new Uint8Array(arrayBuffer);

                                                                var array1 = Array.from(array)
                                                                // console.log(array1);
                                                                //var data_btoa = btoa(array1);
                                                                var data = {
                                                                    ten_file: upload.name,
                                                                    file_data: array1,
                                                                    loai_file: type
                                                                }

                                                                $$("inv_Invoice_fileName").setValue(upload.name);
                                                                $$("inv_Invoice_fileData").setValue(array1);
                                                                $$("inv_Invoice_fileType").setValue(type);
                                                                $$("inv_Invoice_fileSize").setValue(upload.size / 1024);
                                                            }
                                                            reader.readAsArrayBuffer(upload.file);

                                                        },
                                                        onUploadComplete: function (response) {
                                                            // var topParentView = this.getTopParentView();

                                                            // if (topParentView.config.tableId !== undefined) {
                                                            // 	var table = $$(topParentView.config.tableId);

                                                            // 	if (table != null) {
                                                            // 		table.clearAll();
                                                            // 		table.load(table.config.url);
                                                            // 	}
                                                            // }
                                                            // webix.message("Upload File thành công !", "debug");
                                                            // webix.$$("uploadfile-win").close();
                                                        },
                                                        onFileUploadError: function (file, response) {
                                                            $$("mylist").clearAll();
                                                            $$("mylist").refresh();
                                                            //console.log(file);
                                                            //console.log(response);
                                                            var table = $$("main-form");
                                                            table.enable();
                                                            table.hideProgress();
                                                            webix.message(response.error, "error");
                                                        }
                                                    },
                                                    apiOnly: true,
                                                },
                                                {
                                                    view: "list",
                                                    id: "mylist",
                                                    type: "uploader",
                                                    placeholder: " Chọn file *.xml hoặc *.PDF",
                                                    //css:{"border-bottom": "none !important", "border-color":"white !important"},
                                                    //height: 100,
                                                    //autoheight: true
                                                    borderless: true,
                                                    on: {
                                                        onAfterDelete: function (id) {
                                                            webix.message("Delete Success!");
                                                        }
                                                    }
                                                }
                                            ]
                                        }
                                    ]
                                },
                                { height: 4 },
                                // { type: "section", template: "Thông tin hóa đơn" },
                                {
                                    cols: [
                                        {
                                            view: "fieldset", label: "Thông tin hóa đơn", body: {
                                                rows: [
                                                    {
                                                        cols: [
                                                            {
                                                                view: "combo",
                                                                name: "dmloaihd_id",
                                                                label: "Loại hóa đơn",
                                                                //labelPosition: "top",
                                                                id: "inv_Invoice_dmloaihd_id",
                                                                required: true,
                                                                invalidMessage: "Loại hóa đơn không thể bỏ trống !",
                                                                options: {
                                                                    view: "gridsuggest",
                                                                    template: "#ten_loai#",
                                                                    url: app.config.host + "/System/GetDataReferencesByRefId?refId=RF00301",
                                                                    body: {
                                                                        columns: [
                                                                            { id: "ma_loai", header: _("Mã loại"), width: 80 },
                                                                            { id: "ten_loai", header: _("Tên loại hóa đơn"), width: 700 }
                                                                        ],
                                                                        dataFeed: function (filtervalue, filter) {
                                                                            if (filtervalue.length < 1) {
                                                                                this.load(this.config.url);
                                                                                return;
                                                                            }
                                                                            var pathUrl = app.config.host + "/System/GetDataReferencesByRefId?refId=RF00301";
                                                                            var urldata = "filtervalue=" + encodeURIComponent(filtervalue);

                                                                            this.load(pathUrl + "&" + urldata, this.config.datatype);
                                                                        }
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                view: "combo",
                                                                name: "trangthai_hd",
                                                                label: "Trạng thái hóa đơn",
                                                                //labelPosition: "top",
                                                                id: "inv_Invoice_trangthai_hd",
                                                                required: true,
                                                                value: "1",
                                                                invalidMessage: "Trạng thái hóa đơn không thể bỏ trống !",
                                                                options: {
                                                                    view: "gridsuggest",
                                                                    value: "1",
                                                                    template: "#ten_trang_thai#",
                                                                    url: app.config.host + "/System/GetDataReferencesByRefId?refId=RF00302",
                                                                    body: {
                                                                        columns: [
                                                                            { id: "ten_trang_thai", header: _("Tên trạng thái"), width: 250 }
                                                                        ],
                                                                        dataFeed: function (filtervalue, filter) {

                                                                            if (filtervalue.length < 1) {
                                                                                this.load(this.config.url);
                                                                                return;
                                                                            }

                                                                            var pathUrl = app.config.host + "/System/GetDataReferencesByRefId?refId=RF00302";
                                                                            var urldata = "filtervalue=" + encodeURIComponent(filtervalue);

                                                                            this.load(pathUrl + "&" + urldata, this.config.datatype);
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                view: "text", label: _("Số hóa đơn"), name: "invoiceNumber",
                                                                id: "inv_Invoice_invoiceNumber",
                                                                // type:"number",
                                                                attributes: { maxlength: 7 },
                                                                on: {
                                                                    onChange: function (newv, oldv) {
                                                                        newv = newv.padStart(7, "0");
                                                                        if (newv == 0) {
                                                                            webix.message("Số hóa đơn không thể bằng 0", "error");
                                                                            this.setValue(null);
                                                                            return;
                                                                        }
                                                                        else {
                                                                            this.setValue(newv);
                                                                        }
                                                                    },
                                                                    onKeyPress: function (code, e) {
                                                                        if ((code < 48 || code > 57) && code != 8 && code != 9) {
                                                                            return webix.html.preventEvent(e);
                                                                        }
                                                                    }
                                                                }
                                                            },
                                                            { view: "datepicker", label: _("Ngày hóa đơn"), editable: true, placeholder: "dd/MM/yyyy", name: "invoiceDate", value: new Date(), id: "inv_Invoice_invoiceDate" }
                                                        ]

                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                view: "text",
                                                                label: "Mẫu số",
                                                                name: "mauhd",
                                                                id: "inv_Invoice_mauhd",
                                                                //  css: "mcls_uppercase",
                                                                //labelWidth: 90,
                                                                required: true,
                                                                invalidMessage: "Mẫu số không được bỏ trống",
                                                                attributes: {
                                                                    maxlength: 11
                                                                },
                                                                on: {
                                                                    onChange: function (newv, oldv) {
                                                                        if (newv == undefined) return;
                                                                        if (newv == "") return;

                                                                        if (newv.length != 11) {
                                                                            webix.message({ type: "error", text: "Độ dài mẫu số phải là 11 ký tự" });
                                                                            this.focus();
                                                                            return;
                                                                        }
                                                                        var sttMau = newv.substring(newv.length - 3, newv.length);
                                                                        var patt = /^[0-9][0-9][0-9]$/;
                                                                        if (patt.test(sttMau) == false) {
                                                                            webix.message({ type: "error", text: "3 ký tự cuối phải là số" });
                                                                            this.focus();
                                                                        }

                                                                        var sttMau1 = newv.substring(0, 2);
                                                                        var patt1 = /^[0-9][0-9]$/;
                                                                        if (patt1.test(sttMau1) == false) {
                                                                            webix.message({ type: "error", text: "2 ký tự đầu phải là số" });
                                                                            this.focus();
                                                                        }

                                                                        var sttMau2 = newv.substring(newv.length - 5, newv.length - 4);

                                                                        var patt2 = /^[0-9]$/;
                                                                        if (patt2.test(sttMau2) == false) {
                                                                            webix.message({ type: "error", text: "Ký tự thứ 7 phải là số" });
                                                                            this.focus();
                                                                        }
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                view: "text",
                                                                label: "Ký hiệu",
                                                                name: "invoiceSeries",
                                                                //  css: "mcls_uppercase",
                                                                id: "inv_Invoice_invoiceSeries",
                                                                // labelWidth: 110,
                                                                required: true,
                                                                invalidMessage: "Ký hiệu không được bỏ trống",
                                                                attributes: { maxlength: 6 },
                                                                on: {
                                                                    onChange: function (newv, oldv) {
                                                                        if (newv == undefined) return;
                                                                        if (newv == "") return;

                                                                        if (newv.length != 6) {
                                                                            webix.message({ type: "error", text: "Độ dài ký hiệu phải là 6 ký tự" });
                                                                            this.focus();
                                                                            return;
                                                                        }

                                                                        var patt = /^[A,B,C,D,E,G,H,K,L,M,N,P,Q,R,S,T,U,V,X,Y][A,B,C,D,E,G,H,K,L,M,N,P,Q,R,S,T,U,V,X,Y][/]$/;

                                                                        if (patt.test(newv.substring(0, 3)) == false) {
                                                                            webix.message({ type: "error", text: "3 ký tự đầu của ký hiệu không đúng" });
                                                                            this.focus();
                                                                            return;
                                                                        }

                                                                        patt = /^[0-9][0-9]$/;

                                                                        var nam = newv.substring(3, 5);

                                                                        if (patt.test(nam) == false) {
                                                                            webix.message({ type: "error", text: "2 ký tự năm của ký hiệu không đúng" });
                                                                            this.focus();
                                                                            return;
                                                                        }

                                                                        var now = new Date();
                                                                        var year = now.getFullYear();

                                                                        nam = Number("20" + nam);

                                                                        // if (nam < (year - 1) || nam > year) {
                                                                        //     webix.message({ type: "error", text: "Năm ký hiệu không đúng" });
                                                                        //     this.focus();
                                                                        //     return;
                                                                        // }

                                                                        if (newv.substring(5, 6) != "E") {
                                                                            webix.message({ type: "error", text: "Ký tự cuối phải là E" });
                                                                            this.focus();
                                                                            return;
                                                                        }

                                                                    }
                                                                }
                                                            },
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                view: "combo",
                                                                name: "loai_tien",
                                                                label: "Loại tiền",
                                                                //labelPosition: "top",
                                                                value: "đồng",
                                                                id: "inv_Invoice_loai_tien",
                                                                options: {
                                                                    view: "gridsuggest",
                                                                    template: "#ten_nt#",
                                                                    body: {
                                                                        scroll: true,
                                                                        autoheight: false,
                                                                        columns: [
                                                                            // { id: "id", header: _("MS_THUE"), width: 150 },
                                                                            { id: "ma_nt", header: _("Mã ngoại tệ"), width: 150 },
                                                                            { id: "ten_nt", header: _("Tên ngoại tệ"), width: 550 }
                                                                        ],
                                                                        dataFeed: function (filtervalue, filter) {
                                                                            if (filtervalue.length < 1) return;

                                                                            var pathUrl = app.config.host + "/System/GetDataReferencesByRefId?refId=RF00188";
                                                                            var urldata = "filtervalue=" + encodeURIComponent(filtervalue);

                                                                            this.load(pathUrl + "&" + urldata, this.config.datatype);
                                                                        }
                                                                    },
                                                                    url: app.config.host + "/System/GetDataReferencesByRefId?refId=RF00188",
                                                                },
                                                                on: {

                                                                }
                                                            },
                                                            // { view: "text", label: "Loại tiền", name: "loai_tien", id: "inv_Invoice_loai_tien" },
                                                            {
                                                                view: "text", label: "Tỷ giá", type: "number", value: 1, name: "ty_gia", id: "inv_Invoice_ty_gia",
                                                                on: {
                                                                    onChange: function (newv, oldv) {
                                                                        if (newv == undefined) return;
                                                                        if (newv == "") return;
                                                                        if (!webix.rules.isNumber(newv)) {
                                                                            webix.message("Tỷ giá phải nhập số", "error");
                                                                            this.focus();
                                                                            return;
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        ]
                                                    }

                                                ]
                                            }
                                        },
                                        {
                                            view: "fieldset", label: "Thông tin bên bán", body: {
                                                rows: [
                                                    {
                                                        id: "inv_Invoice_sellerTaxCode",
                                                        name: "sellerTaxCode",
                                                        view: "search",
                                                        label: "MST người bán",
                                                        //align: "center",
                                                        validate: webix.rules.isTaxCode,
                                                        invalidMessage: "Mã số thuế không hợp lệ",
                                                        placeholder: _("SEARCH") + "...",
                                                        // width: 300,
                                                        on: {
                                                            onChange: function (newv, oldv) {
                                                                if (newv == undefined) return;
                                                                if (newv == "") return;
                                                                if (!webix.rules.isTaxCode(newv)) {
                                                                    webix.message("Mã số thuế không hợp lệ", "error");
                                                                    this.focus();
                                                                    return;
                                                                }
                                                                // if (newv.length != 11) {
                                                                //     webix.message({ type: "error", text: "Độ dài mẫu số phải là 11 ký tự" });
                                                                //     this.focus();
                                                                //     return;
                                                                // }
                                                            },
                                                            onTimedKeyPress: function () {
                                                                // var table = $$("tblSearch");

                                                                // table.clearAll();
                                                                // table.load(table.config.url);
                                                            },
                                                            onSearchIconClick: function (e) {
                                                                var text = this.getValue();
                                                                var datapost = { "masothue": text };
                                                                var table = $$("main-form");
                                                                webix.extend(table, webix.ProgressBar);
                                                                table.disable();
                                                                table.showProgress();
                                                                webix.ajax()
                                                                    .headers({ 'Content-type': 'application/json' })
                                                                    .post(app.config.host + "/Pattern/GetInfoMST", datapost, function (text) {

                                                                        var json = JSON.parse(text);
                                                                        table.enable();
                                                                        table.hideProgress();
                                                                        if (!json.hasOwnProperty("error")) {
                                                                            $$("inv_Invoice_sellerName").setValue(json.ten_cty);
                                                                            $$("inv_Invoice_sellerAdress").setValue(json.dia_chi);
                                                                        }
                                                                        else {
                                                                            // nếu không tồn tại mã số thuế phải xóa địa chỉ + tên cty ở đây 
                                                                            webix.message(json.error, "error", 1500);
                                                                        }

                                                                    });
                                                            }
                                                        }
                                                    },
                                                    { view: "text", label: _("Tên công ty"), name: "sellerName", id: "inv_Invoice_sellerName" },
                                                    { view: "text", label: _("Địa chỉ"), name: "sellerAdress", id: "inv_Invoice_sellerAdress" },
                                                    {
                                                        cols: [
                                                            {
                                                                view: "text", label: "Email", name: "email", id: "inv_Invoice_email",
                                                                validate: webix.rules.isEmail,
                                                                invalidMessage: "Email không đúng định dạng !"
                                                            },
                                                            { view: "text", label: "Số điện thoại", type: "number", name: "sdt", id: "inv_Invoice_sdt" }
                                                        ]
                                                    }
                                                ]
                                            }
                                        }
                                    ]
                                },

                                // { type: "section", template: "Giá trị hóa đơn" },
                                {
                                    borderless: true,
                                    view: "tabview",
                                    scrollX: true,
                                    tabbar: {
                                        width: 300
                                    },
                                    cells: [
                                        {
                                            header: "Chi tiết hóa đơn",
                                            select: "cell",
                                            body: {
                                                rows: [
                                                    {
                                                        id: "mainInvoiceManage",
                                                        css: { "padding-bottom": "5px !important" },
                                                        // view: "toolbar",
                                                        // height: 18,
                                                        cols: [
                                                            {
                                                                view: "button", type: "htmlbutton", width: 65,
                                                                label: '<i class="fa fa-plus fa-lg" aria-hidden="true"></i> ' +
                                                                '<span class="text">' + " (F9)" + '</span>',
                                                                // id: "btnPrint",
                                                                // view: "button", type: "icon",
                                                                // //view: "icon",
                                                                id: "addrow",
                                                                // label: " (F9)",
                                                                // width: 60,
                                                                // icon: "fas fa-plus",
                                                                css: "btnForm",
                                                                //css: { "font-size": "15px" },
                                                                on: {
                                                                    onItemClick: function (id, e) {
                                                                        var table = webix.$$("inv_InvoiceDetails");
                                                                        var item = { id: webix.uid() };
                                                                        table.add(item);
                                                                        table.select(item.id, "ma_hanghoa", false);
                                                                        table.edit({ row: item.id, column: "ma_hanghoa" });
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                view: "button", type: "htmlbutton", width: 65,
                                                                label: '<i class="fa fa-minus fa-lg" aria-hidden="true"></i> ' +
                                                                '<span class="text">' + " (F8)" + '</span>',
                                                                // view: "button",
                                                                id: "removerow",
                                                                // type: "icon",
                                                                // //view: "icon",
                                                                // label: " (F8)",
                                                                // width: 60,
                                                                css: "btnForm",
                                                                // icon: "fas fa-minus",
                                                                on: {
                                                                    onItemClick: function (id, e) {

                                                                        var table = webix.$$("inv_InvoiceDetails");

                                                                        table.editStop();

                                                                        var item = table.getSelectedItem();

                                                                        if (!webix.isUndefined(item)) {
                                                                            table.remove(item.id);
                                                                            table.clearSelection();
                                                                            return;
                                                                        }

                                                                        var editor = table.getEditState();

                                                                        if (!webix.isUndefined(editor)) {
                                                                            table.remove(editor.row);
                                                                            table.clearSelection();
                                                                            return;
                                                                        }
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                view: "button", type: "htmlbutton", width: 65,
                                                                label: '<i class="fa fa-copy fa-lg" aria-hidden="true"></i> ' +
                                                                '<span class="text">' + " (F7)" + '</span>',
                                                                view: "button",
                                                                id: "copyrow",
                                                                // type: "icon",
                                                                //view: "icon",
                                                                // label: " (F7)",
                                                                // width: 60,
                                                                // icon: "fas fa-copy",
                                                                css: "btnForm",
                                                                on: {
                                                                    onItemClick: function (id, e) {
                                                                        var table = webix.$$("inv_InvoiceDetails");;

                                                                        table.editStop();

                                                                        var item = table.getSelectedItem();
                                                                        if (item == null || item == undefined) {
                                                                            webix.message("Bạn chưa chọn dòng cần copy !", "error");
                                                                            return;
                                                                        }
                                                                        //item.id = webix.uid();
                                                                        var copy = webix.copy(item);
                                                                        copy.id = webix.uid();
                                                                        //copy[tab.tab_table + "_id"] = null;

                                                                        table.add(copy);
                                                                        table.unselect(item.id);
                                                                        table.select(copy.id, "ma_hanghoa", false);
                                                                        table.edit({ row: copy.id, column: "ma_hanghoa" });

                                                                    }
                                                                }
                                                            }

                                                        ]
                                                    },
                                                    {
                                                        view: "datatable",
                                                        resizeColumn: true,
                                                        id: "inv_InvoiceDetails",
                                                        // tab_table: tab.tab_table,
                                                        // tab_id: tab.tab_id,
                                                        editable: true,
                                                        select: "cell",
                                                        height: 220,
                                                        drag: true,
                                                        // select_change: tab.select_change,
                                                        // cell_editstop: tab.cell_editstop,
                                                        // after_addrow: tab.after_addrow,
                                                        // after_delrow: tab.after_delrow,
                                                        // oncheck: tab.oncheck,
                                                        columns: [
                                                            { id: "stt", header: "", width: 30 },
                                                            {
                                                                id: "ma_hanghoa", header: _("Mã hàng hóa"), editor: "textsearch", width: 100, editable: true,
                                                                suggest: {
                                                                    view: "gridsuggest",
                                                                    // value_suggest: field.value_suggest,
                                                                    // fieldExpression: field.field_expression,
                                                                    // displayField: field.display_field,
                                                                    // tableId: "edit_inv_InvoiceDetail",
                                                                    columnName: "ma_hanghoa",
                                                                    body: {
                                                                        columns: [{ "id": "id", "hidden": true, "header": "id" }, { "id": _("ma_hv"), "width": 120, "header": "ma_hv" }, { "id": _("ten_hv"), "width": 350, "header": "ten_hv" }],
                                                                        scroll: true,
                                                                        autoheight: false,
                                                                        datatype: "json",
                                                                        dataFeed: function (filtervalue, filter) {
                                                                            if (filtervalue.length < 1) return;

                                                                            var refid = this.config.refid;
                                                                            var pathUrl = app.config.host + "/System/GetDataByReferencesId?id=3A99C8EC-A467-4591-85E5-E5DFEC4FEAE0";
                                                                            var urldata = "filtervalue=" + encodeURIComponent(filtervalue);

                                                                            this.load(pathUrl + "&" + urldata, this.config.datatype);
                                                                        }
                                                                    },
                                                                    on: {
                                                                        onValueSuggest: function (obj) {

                                                                            var table = $$("inv_InvoiceDetails");
                                                                            var selectedItem = table.getSelectedItem();
                                                                            selectedItem["ma_hanghoa"] = obj["ma_hv"];
                                                                            selectedItem["ten_hang"] = obj["ten_hv"];
                                                                            selectedItem["ma_dvt"] = obj["dvt"];
                                                                            selectedItem["gia_ban"] = obj["don_gia"];
                                                                            selectedItem["ma_thue"] = obj["pt_thue"];
                                                                            table.updateItem(selectedItem.id, selectedItem);

                                                                        }
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                id: "ten_hang", header: _("Tên hàng hóa"), editor: "text", width: 350, editable: true,
                                                                // suggest: {
                                                                //     view: "gridsuggest",
                                                                //     columnName: "ten_hv",
                                                                //     body: {
                                                                //         columns: [{ "id": "id", "hidden": true, "header": "id" }, { "id": _("ma_hv"), "width": 120, "header": "ma_hv" }, { "id": _("ten_hv"), "width": 350, "header": "ten_hv" }],
                                                                //         scroll: true,
                                                                //         autoheight: false,
                                                                //         datatype: "json",
                                                                //         dataFeed: function (filtervalue, filter) {
                                                                //             if (filtervalue.length < 1) return;

                                                                //             var refid = this.config.refid;
                                                                //             var pathUrl = app.config.host + "/System/GetDataByReferencesId?id=3A99C8EC-A467-4591-85E5-E5DFEC4FEAE0";
                                                                //             var urldata = "filtervalue=" + encodeURIComponent(filtervalue);

                                                                //             this.load(pathUrl + "&" + urldata, this.config.datatype);
                                                                //         }
                                                                //     },
                                                                //     on: {
                                                                //         onValueSuggest: function (obj) {
                                                                //             var table = $$("inv_InvoiceDetails");
                                                                //             var selectedItem = table.getSelectedItem();
                                                                //             selectedItem["ma_hanghoa"] = obj["ma_hv"];
                                                                //             selectedItem["ten_hang"] = obj["ten_hv"];
                                                                //             selectedItem["ma_dvt"] = obj["dvt"];
                                                                //             selectedItem["gia_ban"] = obj["don_gia"];
                                                                //             selectedItem["ma_thue"] = obj["pt_thue"];
                                                                //             table.updateItem(selectedItem.id, selectedItem);
                                                                //         }
                                                                //     }
                                                                // }
                                                            },
                                                            {
                                                                id: "dvt", header: _("ĐVT"), editor: "text", width: 80, editable: true,
                                                                suggest: {
                                                                    view: "gridsuggest",
                                                                    columnName: "dvt",
                                                                    body: {
                                                                        columns: [{ "id": "id", "hidden": true, "header": "id" }, { "id": "ma_dvt", "width": 120, "header": "ma_dvt" }],
                                                                        scroll: true,
                                                                        autoheight: false,
                                                                        datatype: "json",
                                                                        dataFeed: function (filtervalue, filter) {
                                                                            if (filtervalue.length < 1) return;

                                                                            var refid = this.config.refid;
                                                                            var pathUrl = app.config.host + "/System/GetDataByReferencesId?id=883B9B50-C52B-46BE-9D5A-4755D48183A5";
                                                                            var urldata = "filtervalue=" + encodeURIComponent(filtervalue);

                                                                            this.load(pathUrl + "&" + urldata, this.config.datatype);
                                                                        }
                                                                    },
                                                                    on: {
                                                                        onValueSuggest: function (obj) {

                                                                            var table = $$("inv_InvoiceDetails");
                                                                            var selectedItem = table.getSelectedItem();
                                                                            selectedItem["ma_dvt"] = obj["dvt"];

                                                                            table.updateItem(selectedItem.id, selectedItem);

                                                                        }
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                id: "so_luong",
                                                                header: _("Số lương"), editor: "autonumeric", width: 100,
                                                                editable: true, css: { "text-align": "right" },
                                                                format: webix.Number.numToStr({
                                                                    groupDelimiter: ".",
                                                                    groupSize: 3,
                                                                    decimalDelimiter: ",",
                                                                    decimalSize: 2
                                                                })
                                                            },
                                                            {
                                                                id: "don_gia",
                                                                header: _("Đơn giá"), width: 150, editor: "autonumeric", editable: true,
                                                                css: { "text-align": "right" },
                                                                format: webix.Number.numToStr({
                                                                    groupDelimiter: ".",
                                                                    groupSize: 3,
                                                                    decimalDelimiter: ",",
                                                                    decimalSize: 2
                                                                })
                                                                // value_change: field.value_change
                                                            },
                                                            {
                                                                id: "tien_tt",
                                                                header: _("Tiền trước thuế"),
                                                                width: 150, editor: "autonumeric", editable: true, css: { "text-align": "right" },
                                                                format: webix.Number.numToStr({
                                                                    groupDelimiter: ".",
                                                                    groupSize: 3,
                                                                    decimalDelimiter: ",",
                                                                    decimalSize: 2
                                                                })
                                                                // value_change: field.value_change
                                                            },
                                                            {
                                                                id: "pt_ck",
                                                                header: _("% CK"), width: 80, editor: "autonumeric", editable: true,
                                                                css: { "text-align": "right" },
                                                                format: webix.Number.numToStr({
                                                                    groupDelimiter: ".",
                                                                    groupSize: 3,
                                                                    decimalDelimiter: ",",
                                                                    decimalSize: 2
                                                                })
                                                            },
                                                            {
                                                                id: "tien_ck", header: _("Tiền CK"),
                                                                width: 150, editor: "autonumeric", editable: true,
                                                                css: { "text-align": "right" },
                                                                format: webix.Number.numToStr({
                                                                    groupDelimiter: ".",
                                                                    groupSize: 3,
                                                                    decimalDelimiter: ",",
                                                                    decimalSize: 2
                                                                })
                                                            },
                                                            {
                                                                id: "pt_thue",
                                                                header: _("Thuế suất"), width: 100, editor: "combo", editable: true,
                                                                css: { "text-align": "right" },
                                                                format: webix.Number.numToStr({
                                                                    groupDelimiter: ".",
                                                                    groupSize: 3,
                                                                    decimalDelimiter: ",",
                                                                    decimalSize: 2
                                                                }),
                                                                on: {
                                                                    onChange: function (newv, oldv) {
                                                                    }
                                                                },
                                                                options: app.config.host + "/System/GetDataByReferencesId?id=D6FAEAFC-4EF2-4ABD-AB45-F3DCB4805740",
                                                                optionslist: true
                                                            },
                                                            {
                                                                id: "tien_thue",
                                                                header: _("Tiền thuế"),
                                                                width: 150, editor: "autonumeric", editable: true, css: { "text-align": "right" },
                                                                format: webix.Number.numToStr({
                                                                    groupDelimiter: ".",
                                                                    groupSize: 3,
                                                                    decimalDelimiter: ",",
                                                                    decimalSize: 2
                                                                })
                                                            },
                                                            {
                                                                id: "tong_tien",
                                                                header: _("Tiền sau thuế"), width: 150, editor: "autonumeric", editable: true,
                                                                css: { "text-align": "right" },
                                                                format: webix.Number.numToStr({
                                                                    groupDelimiter: ".",
                                                                    groupSize: 3,
                                                                    decimalDelimiter: ",",
                                                                    decimalSize: 2
                                                                })
                                                            },
                                                            {
                                                                id: "khuyen_mai", header: _("Khuyến mại"), width: 100, editor: "checkbox", editable: true,
                                                                template: "{common.checkbox()}",
                                                                checkValue: true,
                                                                uncheckValue: false
                                                            },
                                                            {
                                                                id: "giam_tru", header: _("Giảm trừ"), width: 100, editor: "checkbox", editable: true,
                                                                template: "{common.checkbox()}",
                                                                checkValue: true,
                                                                uncheckValue: false
                                                            }
                                                        ],
                                                        on: {
                                                            "data->onStoreUpdated": function () {
                                                                this.data.each(function (obj, i) {
                                                                    obj.stt = i + 1;
                                                                })
                                                            },
                                                            onCheck: function (row, column, state) {
                                                                var table = this;
                                                                if (column == "khuyen_mai") {

                                                                    if (state == true) {
                                                                        var selectedItem = table.getItem(row);
                                                                        selectedItem.don_gia = null;
                                                                        selectedItem.tien_tt = null;
                                                                        selectedItem.pt_ck = null;
                                                                        selectedItem.tien_ck = null;
                                                                        selectedItem.pt_thue = null;
                                                                        selectedItem.tien_thue = null;
                                                                        selectedItem.tong_tien = null;
                                                                        table.updateItem(selectedItem.id, selectedItem);
                                                                        // table.callEvent("onAfterAdd");
                                                                    }
                                                                }
                                                                if (column == "giam_tru") {
                                                                    if (state == true) {
                                                                        var selectedItem = table.getItem(row);
                                                                        selectedItem.don_gia = -1 * selectedItem.don_gia;
                                                                        selectedItem.tien_tt = -1 * selectedItem.tien_tt;
                                                                        selectedItem.pt_ck = -1 * selectedItem.pt_ck;
                                                                        selectedItem.tien_thue = -1 * selectedItem.tien_thue;
                                                                        selectedItem.tong_tien = -1 * selectedItem.tong_tien;
                                                                    }
                                                                }

                                                            },
                                                            onAfterAdd: function (id, index) {
                                                                var table = $$(this.config.id);
                                                                var data = table.serialize();

                                                                var tong_tien_tt_dp = 0;
                                                                var tong_tien_thue_dp = 0
                                                                var tong_tien_ck_dp = 0;
                                                                var tong_tien_dp = 0
                                                                data.forEach(function (entry) {

                                                                    tong_tien_tt_dp += entry["tien_tt"] == null ? 0 : entry["tien_tt"];
                                                                    tong_tien_thue_dp += entry["tien_thue"] == null ? 0 : entry["tien_thue"];
                                                                    tong_tien_ck_dp += entry["tien_ck"] == null ? 0 : entry["tien_ck"];
                                                                    tong_tien_dp += entry["tong_tien"] == null ? 0 : entry["tong_tien"];

                                                                    $$("inv_Invoice_tien_tt").setValue(tong_tien_tt_dp);
                                                                    $$("inv_Invoice_tien_ck").setValue(tong_tien_ck_dp);
                                                                    $$("inv_Invoice_tien_thue").setValue(tong_tien_thue_dp);
                                                                    $$("inv_Invoice_tong_tien").setValue(tong_tien_dp);

                                                                });
                                                            },
                                                            onAfterEditStop: function (state, editor, ignore) {

                                                                var table = $$(this.config.id);
                                                                var selectedItem = table.getItem(editor.row);
                                                                var columnId = editor.config.id;
                                                                var so_luong = webix.rules.isNumber(selectedItem.so_luong) ? selectedItem.so_luong : 0;
                                                                var don_gia = webix.rules.isNumber(selectedItem.don_gia) ? selectedItem.don_gia : 0;
                                                                var tien_tt = webix.rules.isNumber(selectedItem.tien_tt) ? selectedItem.tien_tt : 0;
                                                                var pt_ck = webix.rules.isNumber(selectedItem.pt_ck) ? selectedItem.pt_ck : 0;
                                                                var tien_ck = webix.rules.isNumber(selectedItem.tien_ck) ? selectedItem.tien_ck : 0;
                                                                var pt_thue = webix.rules.isNumber(selectedItem.pt_thue) ? selectedItem.pt_thue : 0;
                                                                var tien_thue = webix.rules.isNumber(selectedItem.tien_thue) ? selectedItem.tien_thue : 0;
                                                                var tong_tien = webix.rules.isNumber(selectedItem.tong_tien) ? selectedItem.tong_tien : 0;
                                                                if (columnId == "pt_thue" || columnId == "so_luong" || columnId == "don_gia" || columnId == "tien_tt" || columnId == "tong_tien" || columnId == "pt_ck" || columnId == "tien_ck") {
                                                                    if (don_gia < 0) {
                                                                        don_gia = 0;
                                                                    }
                                                                    if (so_luong < 0) {
                                                                        so_luong = 0;
                                                                    }

                                                                    if (don_gia > 0) {
                                                                        tien_tt = (so_luong * don_gia);
                                                                    }

                                                                    if (pt_ck < 0) { pt_ck = 0; }
                                                                    if (pt_ck > 100) { pt_ck = 0; }

                                                                    tien_ck = tien_tt * pt_ck / 100;
                                                                    if ((tien_ck - tien_tt) > 0) {
                                                                        tien_ck = 0;
                                                                    }
                                                                    tien_thue = ((tien_tt - tien_ck) * pt_thue / 100);

                                                                    tong_tien = Math.round(tien_tt - tien_ck + parseFloat(tien_thue));
                                                                }
                                                                selectedItem.so_luong = so_luong;
                                                                selectedItem.don_gia = don_gia;
                                                                selectedItem.tien_tt = tien_tt;
                                                                selectedItem.pt_ck = pt_ck;
                                                                selectedItem.tien_ck = tien_ck;
                                                                selectedItem.tien_thue = tien_thue;
                                                                selectedItem.tong_tien = tong_tien;
                                                                table.updateItem(selectedItem.id, selectedItem);


                                                                var data = table.serialize();

                                                                var tong_tien_tt_dp = 0;
                                                                var tong_tien_thue_dp = 0
                                                                var tong_tien_ck_dp = 0;
                                                                var tong_tien_dp = 0
                                                                data.forEach(function (entry) {

                                                                    tong_tien_tt_dp += entry["tien_tt"] == null ? 0 : entry["tien_tt"];
                                                                    tong_tien_thue_dp += entry["tien_thue"] == null ? 0 : entry["tien_thue"];
                                                                    tong_tien_ck_dp += entry["tien_ck"] == null ? 0 : entry["tien_ck"];
                                                                    tong_tien_dp += entry["tong_tien"] == null ? 0 : entry["tong_tien"];

                                                                    $$("inv_Invoice_tien_tt").setValue(tong_tien_tt_dp);
                                                                    $$("inv_Invoice_tien_ck").setValue(tong_tien_ck_dp);
                                                                    $$("inv_Invoice_tien_thue").setValue(tong_tien_thue_dp);
                                                                    $$("inv_Invoice_tong_tien").setValue(tong_tien_dp);

                                                                });
                                                            }
                                                        }
                                                    }
                                                ]
                                            }
                                        },
                                        {
                                            header: "Đính kèm file",
                                            select: "cell",
                                            body: {
                                                rows: [
                                                    // {
                                                    //     view: "button", type: "icon", icon: "fas fa-folder-open", label: "chọn file", width: 110,
                                                    //     css: "btnMain",
                                                    //     click: function () {
                                                    //         webix.$$("upload_FileDkem").fileDialog();
                                                    //     }
                                                    // },
                                                    {
                                                        cols: [
                                                            {
                                                                id: "upload_FileDkem",
                                                                view: "uploader",
                                                                template: '<button type="button" class="webix_img_btn" style="line-height:24px;width:100px;"><span class="webix_icon_btn fas fa-folder-open" style="max-width:24px;"></span>Chọn file</button>',
                                                                name: "Ffile",
                                                                //accept:"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                                                                link: "lstFileDkem",
                                                                autosend: false,
                                                                width: 100,
                                                                multiple: true, apiOnly: true,
                                                                // upload: app.config.host + "/Dmkh/UploadDmkhhsMulti",
                                                                on: {
                                                                    onUploadComplete: function (response) {

                                                                    },
                                                                    onAfterFileAdd: function (upload) {

                                                                        var file = new Blob([upload.file]);

                                                                        var reader = new FileReader();
                                                                        var type = upload.type;
                                                                        if (type == "xml") { type = "text/XML"; }
                                                                        if (type == "xls") { type = "application/vnd.ms-excel"; }
                                                                        if (type == "docx") { type = "application/vnd.openxmlformats-officedocument.wordprocessingml.document"; }
                                                                        if (type == "xlsx") { type = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"; }
                                                                        if (type == "repx" || type == "rar") { type = "application/octet-stream"; }
                                                                        if (type == "jpg") { type = "image/jpeg"; }
                                                                        if (type == "pdf") { type = "application/pdf"; }

                                                                        reader.onload = function () {

                                                                            var arrayBuffer = this.result,
                                                                                array = new Uint8Array(arrayBuffer);
                                                                            //binaryString = String.fromCharCode.apply(null, array);

                                                                            var array1 = Array.from(array)
                                                                            //console.log(array1);

                                                                            var data = {
                                                                                ten_file: upload.name,
                                                                                file_data: array1,
                                                                                loai_file: type,
                                                                                size: upload.size,
                                                                                size_text: upload.sizetext
                                                                            }

                                                                            $$("lstFile").parse(data);
                                                                        }
                                                                        reader.readAsArrayBuffer(upload.file);

                                                                    }
                                                                }
                                                            },
                                                            {
                                                                view: "button", type: "htmlbutton", width: 65,
                                                                label: '<i class="fa fa-minus fa-lg" aria-hidden="true"></i> ' +
                                                                '<span class="text">' + " (F8)" + '</span>',
                                                                // view: "button",
                                                                id: "removerowlstFile",
                                                                // type: "icon",
                                                                // //view: "icon",
                                                                // label: " (F8)",
                                                                // width: 60,
                                                                css: "btnForm",
                                                                // icon: "fas fa-minus",
                                                                on: {
                                                                    onItemClick: function (id, e) {

                                                                        var table = webix.$$("lstFile");

                                                                        table.editStop();

                                                                        var item = table.getSelectedItem();

                                                                        if (!webix.isUndefined(item)) {
                                                                            table.remove(item.id);
                                                                            table.clearSelection();
                                                                            return;
                                                                        }

                                                                        var editor = table.getEditState();

                                                                        if (!webix.isUndefined(editor)) {
                                                                            table.remove(editor.row);
                                                                            table.clearSelection();
                                                                            return;
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        ]
                                                    },
                                                    { height: 5 },
                                                    {
                                                        view: "datatable",
                                                        id: "lstFile",
                                                        editable: true,
                                                        resizeColumn: true,
                                                        height: 215,
                                                        // width: 500,
                                                        select: "cell",
                                                        columns: [
                                                            { id: "stt", header: "", width: 30 },
                                                            {
                                                                id: "file_data", name: "file_data", header: "", editor: "combo", hidden: true
                                                            },
                                                            {
                                                                id: "loai_file", name: "loai_file", header: "", editor: "text", hidden: true
                                                            },
                                                            {
                                                                id: "ten_file", name: "ten_file", header: "File", editor: "text", width: 400
                                                            },
                                                            {
                                                                id: "size", name: "size", header: "", editor: "text", hidden: true
                                                            },
                                                            {
                                                                id: "size_text", name: "size_text", header: "Size", editor: "text", width: 100
                                                            }
                                                        ],
                                                        on: {
                                                            "data->onStoreUpdated": function () {
                                                                this.data.each(function (obj, i) {
                                                                    obj.stt = i + 1;
                                                                })
                                                            }
                                                        },
                                                        rules: {
                                                            "ma_hs": webix.rules.isNotEmpty,
                                                            "ten_hs": webix.rules.isNotEmpty,
                                                        }
                                                    }
                                                ]
                                            }
                                        }
                                    ]
                                },
                                {
                                    cols: [
                                        {
                                            id: "inv_Invoice_tien_tt",
                                            name: "tien_tt",
                                            view: "text",
                                            label: _("Tiền trước thuế"),
                                            // width: 150, 
                                            inputAlign: "right", format: "1.111,00",
                                            // css: "mcls_license_text",
                                            // value_change: field.value_change
                                        },
                                        {
                                            id: "inv_Invoice_tien_ck",
                                            name: "tien_ck",
                                            view: "text",
                                            label: _("Tiền CK"),
                                            // css: "mcls_license_text",
                                            // width: 150, 
                                            inputAlign: "right", format: "1.111,00"
                                        },
                                        {
                                            id: "inv_Invoice_tien_thue",
                                            name: "tien_thue",
                                            view: "text",
                                            label: _("Tiền thuế"),
                                            // css: "mcls_license_text",
                                            // width: 150,
                                            inputAlign: "right", format: "1.111,00"
                                        },
                                        {
                                            id: "inv_Invoice_tong_tien",
                                            name: "tong_tien",
                                            // css: "mcls_license_text",
                                            view: "text",
                                            label: _("Tổng tiền sau thuế"),
                                            // width: 150, 
                                            inputAlign: "right", format: "1.111,00"
                                        }
                                    ]
                                },
                                { type: "section", template: "Thông tin tra cứu" },
                                { view: "text", label: _("Link tra cứu"), labelWidth: 120, name: "url_tracuu", id: "inv_Invoice_url_tracuu" },

                                { view: "textarea", label: _("GHI_CHU"), name: "ghi_chu", id: "inv_Invoice_ghi_chu", labelWidth: 120 },
                                { view: "text", label: _("Tên File"), name: "fileName", id: "inv_Invoice_fileName", hidden: true },
                                { view: "text", label: _("File Data"), name: "fileData", id: "inv_Invoice_fileData", hidden: true },
                                { view: "text", label: _("Mime Type"), name: "fileType", id: "inv_Invoice_fileType", hidden: true },
                                { view: "text", label: _("File Size"), name: "fileSize", id: "inv_Invoice_fileSize", hidden: true },
                                { view: "text", label: _("File Url"), name: "fileUrl", id: "inv_Invoice_fileUrl", hidden: true },
                                {
                                    margin: 10,
                                    cols: [
                                        {},
                                        {
                                            shortcut: "F10", view: "button", label: "Nhận (F10)", type: "form", align: "center", width: 120,
                                            on: {
                                                onClick: function () {
                                                    var item = $$("main-form").getValues();
                                                    var table = $$("main-form");

                                                    if (table.validate()) {
                                                        // var fn = Function(check);
                                                        // var result = fn();
                                                        // console.log(result);
                                                        webix.extend(table, webix.ProgressBar);
                                                        table.disable();
                                                        table.showProgress();
                                                        var file = $$("uploader").files.getFirstId();
                                                        // if (file == undefined || file == null) {
                                                        //     webix.message("Bạn chưa chọn File hóa đơn đính kèm !", "error");
                                                        //     table.enable();
                                                        //     table.hideProgress();
                                                        //     return;
                                                        // }
                                                        var details = [];
                                                        details.push({ data: $$("inv_InvoiceDetails").serialize() });
                                                        item["details"] = details;

                                                        var lstFile = [];
                                                        lstFile.push({ data: $$("lstFile").serialize() });
                                                        item["lstFile"] = lstFile;

                                                        var item1 = [];
                                                        item1.push(item);
                                                        var data_post = { editmode: editmode, data: item1 };

                                                        webix.ajax()
                                                            .headers({ 'Content-type': 'application/json' })
                                                            .post(app.config.host + "/ManageInvoice/SaveInvoiceManage", data_post, {
                                                                error: function (text, data, XmlHttpRequest) {
                                                                    table.enable();
                                                                    table.hideProgress();
                                                                    // var json = JSON.parse(text);
                                                                    // webix.message(json.ExceptionMessage, "error");
                                                                    webix.message(text + XmlHttpRequest, "error");

                                                                }, success: function (text, data, XmlHttpRequest) {
                                                                    var json = JSON.parse(text);
                                                                    table.enable();
                                                                    table.hideProgress();
                                                                    if (!json.hasOwnProperty("error")) {
                                                                        webix.$$("main").close();
                                                                        app.callEvent("dataChangedMain", [editmode, json.data]);
                                                                    }
                                                                    else {
                                                                        webix.message(json.error, "error");
                                                                    }
                                                                }
                                                            });
                                                    }
                                                }
                                            },
                                            click: function () {
                                                this.callEvent("onClick");

                                            }
                                        },
                                        {
                                            view: "button", hotkey: "esc", label: "Hủy bỏ (ESC)", align: "center", type: "danger", width: 120,
                                            click: function () {
                                                $$("mylist").clearAll();
                                                $$("mylist").unbind();
                                                var id = $$("uploader").files.getFirstId();
                                                if (id != undefined) {
                                                    $$("uploader").stopUpload(id);
                                                }
                                                this.getTopParentView().close();
                                            }
                                        },
                                        {}
                                    ]
                                }
                            ]
                        }
                    }

                ]
            }
        },
        setValues: function (item, winconfig, params) {
            var win = $$(this.$ui.id);
            var form = win.getChildViews()[1];

            item["invoiceDate"] = removeTimeZoneT(item["invoiceDate"]);
            form.setValues(item);

            if (editmode == 2) {
                $$("uploader").files.parse([
                    { name: item.fileName == null ? "" : item.fileName, sizetext: item.fileSize == null ? "" : item.fileSize, status: "server" }
                ]);
            }

            var tableFile = webix.$$("lstFile");
            var url = app.config.host + "/ManageInvoice/GetDataDetailFile?id=" + item.id;
            tableFile.clearAll();
            tableFile.load(url);

            var tableDetail = webix.$$("inv_InvoiceDetails");
            var url = app.config.host + "/ManageInvoice/GetDataDetail?id=" + item.id;
            tableDetail.clearAll();
            tableDetail.load(url);

        },
        setEditMode: function (mode) {
            editmode = mode;

            //var form = webix.$$("main-form");
            var form = $$(this.$ui.id);
            //var topParentView = form.getTopParentView();
            form.config.editmode = mode;
            var icon = "";
            if (editmode == 1) {
                icon = "<span><i class='fa fa-plus' aria-hidden='true'></i></span>";
            }
            else {
                if (editmode == 2)
                    icon = "<i class='fa fa-edit' aria-hidden='true'></i>";
                else
                    icon = "<i class='fa fa-trash fa-lg' aria-hidden='true'></i>";
            }
            // var tit = webix.$$("head-form").getValues();
            // webix.$$("head-form").setValues({ title: icon + " " + tit.title });
            // webix.$$("head-form").refresh();
            webix.$$("head-iconMain").setHTML(icon);
            webix.$$("head-iconMain").refresh();
        }
    };

});

define('views/forms/mauhoadon',["app"], function (app) {
	var editmode = 0;

	return {
		$ui: {
			view: "window", modal: true, id: "mauhoadon-win", position: "center",
			head: "Mẫu hóa đơn",
			height: 320,
			body: {
				paddingY: 10,
				paddingX: 10,
				//elementsConfig:{labelWidth: 120}, 
				view: "form",
				id: "mauhoadon-form",
				complexData: true,
				margin: 0,
				elements: [
					{
						borderless: true,
						view: "tabview",
						scrollX: true,
						cells: [
							{
								header: "Thông tin mẫu hóa đơn",
								select: "cell",
								body: {
									rows: [
										{
											view: "text",
											label: "Tên mẫu",
											name: "ten_mau",
											required: true,
											invalidMessage: "Tên mẫu không được bỏ trống",
											width: 600,
											labelWidth: 90
										},
										{
											view: "combo",
											label: "Hình thức",
											name: "hinhthuc",
											id: "hinhthuc_dmmauhoadon",
											required: true,
											invalidMessage: "Hình thức không được bỏ trống",
											labelWidth: 90,
											options: app.config.host + "/System/GetDataReferencesByRefId?refId=RF00009",
											on: {
												onChange: function (newv, oldv) {
													var txtSolien = $$("so_lien_dmmauhoadon");

													if (newv == "E") {
														txtSolien.setValue(0);
														txtSolien.define("readonly", true);
													}
													else {
														txtSolien.define("readonly", false);
													}

													txtSolien.refresh();


												}
											}
										},
										{
											view: "combo",
											label: "Loại hóa đơn",
											name: "dmloaihd_id",
											id: "dmloaihd_id_dmmauhoadon",
											required: true,
											invalidMessage: "Loại hóa đơn không được bỏ trống",
											labelWidth: 90,
											options: app.config.host + "/System/GetDataReferencesByRefId?refId=RF00008",
											on: {
												onChange: function (newv, oldv) {
													var list = this.getPopup().getList();
													var item = list.getItem(newv);

													if (item === undefined) {
														return;
													}

													var txtMauso = $$("mau_so_dmmauhoadon");

													var txtSolien = $$("so_lien_dmmauhoadon");
													var so_lien = txtSolien.getValue();
													var mau_so = item.ma_loai + so_lien + "/001";

													txtMauso.setValue(mau_so);
												}
											}
										},
										{
											cols: [
												{
													view: "text",
													label: "Số liên",
													name: "so_lien",
													id: "so_lien_dmmauhoadon",
													labelWidth: 90
												},
												{
													view: "text",
													label: "Số dòng in mẫu",
													name: "sodonginmau",
													labelWidth: 110
												},
											]
										},
										{
											cols: [
												{
													view: "text",
													label: "Mẫu số",
													name: "mau_so",
													id: "mau_so_dmmauhoadon",
													labelWidth: 90,
													required: true,
													invalidMessage: "Mẫu số không được bỏ trống",
													attributes: {
														maxlength: 11
													},
													on: {
														onChange: function (newv, oldv) {
															if (newv == undefined) return;
															if (newv == "") return;

															if (newv.length != 11) {
																webix.message({ type: "error", text: "Độ dài mẫu số phải là 11 ký tự" });
																this.focus();
																return;
															}

															var txtHinhThuc = $$("hinhthuc_dmmauhoadon");
															var txtLoaihd = $$("dmloaihd_id_dmmauhoadon");

															if (txtHinhThuc.getValue() == "") {
																webix.message({ type: "error", text: "Bạn chưa chọn hình thức hóa đơn" });
																return;
															}

															if (txtLoaihd.getValue() == "") {
																webix.message({ type: "error", text: "Bạn chưa chọn loại hóa đơn" });
																return;
															}

															var hinhthuc = txtHinhThuc.getValue();
															var list = txtLoaihd.getList();

															var selectedItem = list.getItem(txtLoaihd.getValue());

															if (selectedItem == undefined) return;

															var ma_loai = selectedItem.ma_loai;

															var so_lien = hinhthuc == "E" ? 0 : "";
															var mau_so = ma_loai + so_lien + "/";

															if (newv.startsWith(mau_so) == false) {
																webix.message({ type: "error", text: "Mẫu số không đúng" });
																this.focus();
																return;
															}

															var sttMau = newv.substring(newv.length - 3, newv.length);
															var patt = /^[0-9][0-9][0-9]$/;

															if (patt.test(sttMau) == false) {
																webix.message({ type: "error", text: "3 ký tự cuối phải là số" });
																this.focus();
															}
														}
													}
												},
												{
													view: "text",
													label: "Ký hiệu",
													name: "ky_hieu",
													labelWidth: 110,
													required: true,
													invalidMessage: "Ký hiệu không được bỏ trống",
													attributes: {
														maxlength: 6
													},
													on: {
														onChange: function (newv, oldv) {
															if (newv == undefined) return;
															if (newv == "") return;

															if (newv.length != 6) {
																webix.message({ type: "error", text: "Độ dài ký hiệu phải là 6 ký tự" });
																this.focus();
																return;
															}

															var patt = /^[A,B,C,D,E,G,H,K,L,M,N,P,Q,R,S,T,U,V,X,Y][A,B,C,D,E,G,H,K,L,M,N,P,Q,R,S,T,U,V,X,Y][/]$/;

															if (patt.test(newv.substring(0, 3)) == false) {
																webix.message({ type: "error", text: "3 ký tự đầu không đúng" });
																this.focus();
																return;
															}

															patt = /^[1-9][1-9]$/;

															var nam = newv.substring(3, 5);

															if (patt.test(nam) == false) {
																webix.message({ type: "error", text: "2 ký tự năm không đúng" });
																this.focus();
																return;
															}

															var now = new Date();
															var year = now.getFullYear();

															nam = Number("20" + nam);

															// if (nam < (year - 1) || nam > year) {
															// 	webix.message({ type: "error", text: "Năm ký hiệu không đúng" });
															// 	this.focus();
															// 	return;
															// }

															if (newv.substring(5, 6) != "E") {
																webix.message({ type: "error", text: "Ký tự cuối phải là E" });
																this.focus();
																return;
															}

														}
													}
												},
											]
										}
									]
								}
							},
							{
								header: "Tiêu đề liên",
								select: "cell",
								body: {
									rows: [
										{
											cols: [
												{
													view: "text", label: "Liên 1", name: "lien1", width: 300
												},
												{
													view: "text", label: "Liên 2", name: "lien2", width: 300
												},
											]

										},
										{
											cols: [
												{
													view: "text", label: "Liên 3", name: "lien3"
												},
												{
													view: "text", label: "Liên 4", name: "lien4"
												},
											]

										},
										{
											cols: [
												{
													view: "text", label: "Liên 5", name: "lien5"
												},
												{
													view: "text", label: "Liên 6", name: "lien6"
												},
											]

										},
										{
											cols: [
												{
													view: "text", label: "Liên 7", name: "lien7"
												},
												{
													view: "text", label: "Liên 8", name: "lien8"
												},
											]

										},
										{
											cols: [
												{
													view: "text", label: "Liên 9", name: "lien9"
												},
												{}
											]
										}
									]
								}
							}
						]
						/* tabbar:{
							width:200
						} */
					},
					{},
					{
						margin: 10,
						cols: [
							{},
							{
								shortcut: "F10", view: "button", label: "Nhận (F10)", type: "form", align: "center", width: 120,
								on: {
									onClick: function () {
										var form = webix.$$("mauhoadon-form");

										if (form.validate() == false) return;

										var item = form.getValues();

										var khData = {};

										khData.windowid = app.path[1].params[0];
										khData.editmode = editmode;
										khData.data = [];

										khData.data.push(item);

										webix.ajax()
											.headers({ 'Content-type': 'application/json' })
											.post(app.config.host + "/System/Save", khData, function (text) {

												var json = JSON.parse(text);

												if (!json.hasOwnProperty("error")) {
													$$("mauhoadon-win").close();
													app.callEvent("dataChanged", [editmode, json.data]);
												}
												else {
													webix.message(json.error);
												}

											});
									}
								},
								click: function () {
									this.callEvent("onClick");

								}
							},
							{
								view: "button", hotkey: "esc", label: "Hủy bỏ (ESC)",type:"danger", align: "center", width: 120,
								click: function () {
									webix.$$("mauhoadon-win").close();
								}
							},
							{}
						]
					}

				]
			}

		},
		setEditMode: function (mode) {
			editmode = mode;
		}
	};

});
define('views/forms/minvoicenews',[
    "app",
    "locale"
], function (app, _) {
    var editmode = 0;

    return {
        $ui: {
            view: "window",
            modal: true,
            id: "news-win",
            css: "headformchil",
            width: 500,
            height: 600,
            minHeight: 500,
            minWidth: 500,
            position: "center",
            head: {
                height: 40,
                cols: [
                    {
                        id: "head-formnews", view: "template", css: "headform", template: function (obj) {
                            return '<div>Tạo tin tức<div/>';
                        }
                    },
                    {
                        view: "icon", icon: "fas fa-question-circle", id: "help_formnews", tooltip: _("HELPER"), click: function () {
                            webix.alert({
                                title: "Thông báo !",
                                text: "Bạn chưa khai báo hướng dẫn nhanh cho màn hình này !",
                                type: "alert-warning",
                                callback: function (result) {
                                }
                            });
                        }
                    }
                ]
            },
            // fullscreen: true,
            keepViews: true,
            move: true,
            body: {
                paddingY: 5,
                paddingX: 5,
                view: "form",
                id: "news-form",
                elements: [
                    { view: "text", label: "inv_news_id", name: "id", hidden: true },
                    {
                        view: "fieldset",
                        label: "Tài khoản",
                        body: {
                            rows: [
                                {
                                    view: "text",
                                    name: "taikhoan",
                                    label: _("USERNAME"),
                                    // css: "mcls_uppercase",
                                    labelPosition: "top",
                                    required: true,
                                    validate: webix.rules.isNotEmpty,
                                    invalidMessage: "Tài khoản không được để trống !"
                                }, {
                                    view: "text",
                                    name: "matkhau",
                                    id: "matkhau",
                                    label: _("PASSWORD"),
                                    type: "password",
                                    labelPosition: "top",
                                    required: true,
                                    validate: webix.rules.isNotEmpty,
                                    invalidMessage: "Mật khẩu không được để trống !"
                                }
                            ]
                        }
                    },
                    {
                        name: "title",
                        view: "text",
                        label: _("Tiêu đề"),
                        labelPosition: "top",
                        required: true,
                        invalidMessage: "Tiêu đề không được để trống !"
                    },
                    {
                        name: "description",
                        view: "textarea",
                        label: _("Mô tả"),
                        labelPosition: "top"
                    },
                    {
                        name: "url_image",
                        view: "text",
                        label: _("Đường dẫn file ảnh"),
                        labelPosition: "top"
                    },
                    {
                        name: "url",
                        view: "text",
                        label: _("Đường dẫn đến website khi click"),
                        labelPosition: "top"
                    },
                    {
                        name: "su_dung",
                        view: "combo",
                        label: _("Sử dụng"),
                        labelPosition: "top",
                        options: [{ id: "C", value: "C" }, { id: "K", value: "K" }]
                    },
                    {
                        view: "checkbox",
                        id: "is_banner",
                        name: "is_banner",
                        // label: "Banner",
                        labelRight: "Banner",
                        labelWidth: 0
                    },
                    {
                        margin: 10,
                        cols: [
                            {},
                            {
                                shortcut: "F10", view: "button", label: "Nhận (F10)", type: "form", align: "center", width: 120,
                                on: {
                                    onClick: function () {
                                        var form = webix.$$("news-form");
                                        var item = form.getValues();

                                        var url = app.config.host + "/System/SaveChangeMinvoiceNews";
                                        if ($$("news-form").validate()) {
                                            webix.extend(form, webix.ProgressBar);
                                            form.disable();
                                            form.showProgress();

                                            webix.ajax()
                                                .headers({ 'Content-type': 'application/json' })
                                                .post(url, item, function (text) {

                                                    var form = webix.$$("news-form");

                                                    form.enable();
                                                    form.hideProgress();

                                                    var data = JSON.parse(text);

                                                    if (!data.hasOwnProperty("error")) {
                                                        app.callEvent("reloadNews");
                                                        webix.message("Tạo tin tức thành công !", "success");
                                                        webix.$$("news-win").close();
                                                    }
                                                    else {
                                                        webix.message(data.error, "error");
                                                    }
                                                });
                                        }
                                        else {
                                            $$("matkhau").focus();
                                        }
                                    }
                                },
                                click: function () {
                                    this.callEvent("onClick");

                                }
                            },
                            {
                                view: "button", hotkey: "esc", label: "Hủy bỏ (ESC)", type: "danger", align: "center", width: 120,
                                click: function () {
                                    webix.$$("news-win").close();
                                }
                            },
                            {}
                        ]
                    }
                ]

            }

        },
        setEditMode: function (mode) {
            editmode = mode;
        },
        setValues: function (values) {
            $$("news-form").setValues(values);
        }
    };

});
define('views/forms/payment_request_bienlai',[
    "app",
    "locale",
    "models/user",
    "views/modules/Component/componentHelper",
    "views/modules/Component/eventTableHelper",
    "views/modules/Component/button",
    "views/modules/Component/constantManager",
    "views/modules/Component/functionExtension",
    "views/modules/Component/buttonAnimation",
], function (app, _, user, componentHelper, eventTableHelper, buttonOptions, constant, functionExtension, buttonAnimation) {
    var editmode = 0;
    var tgtienBeforeEdit = 0;
    var clickedItem = {}
    var isFinishedEditing = false;

    var dauphieuHoadon = componentHelper.masterPaymentRequest();
    var btnChitietHoadon = componentHelper.btnChitietHoadon();
    var headTitleHoadon = componentHelper.headTitleHoadon("Phiếu đề nghị thu tiền");

    var tongtien = componentHelper.tongtien();
    var tongtienDetail = componentHelper.tongtienDetail();
    var tienbangchu = componentHelper.tienbangchu();

    var btnSave = buttonAnimation.btnSave();
    var btnClose = buttonAnimation.btnClose();
    var mahanghoaHoadon = componentHelper.mahanghoaHoadon(); mahanghoaHoadon.maxLength = 50;

    var colPhiThamDinh = componentHelper.numeric("phi_thamdinh", _("Giá trị nhà, đất"));
    var colTienSauThue = componentHelper.numeric("tgtien", "Tiền sau thuế");

    var windowId = "invoice68";
    var formId = "invoiceForms";
    var headerDetail = "Chi tiết phiếu thu";
    var datatableDetailId = "hoadon68_chitiet";
    var tgtttbsoId = "tgtttbso";
    
    function addTotalValue(value) {
      var tgtienso = $$(tgtttbsoId);
      tgtienso.setValue(tgtienso.getValue() + Math.ceil(value));
    }
    
    return {
        $ui: {
            view: "window",
            modal: true,
            position: "center",
            css: "headformchil",
            head: headTitleHoadon,
            id: windowId,
            resize: true,
            fullscreen: true,
            move: true,
            on: {
                onBeforeShow: function () {

                }
            },
            body: {
                paddingY: 10,
                paddingX: 10,
                elementsConfig: { labelWidth: 100 },
                view: "form",
                id: formId,
                width: 800,
                height: 500,
                complexData: true,
                margin: 0,
                on: {
                  
                },
                rules: functionExtension.ValidateInvoice32(),
                // elementsConfig:{
                //     on:{
                //        'onChange':function(newv, oldv){
                //           this.validate();
                //         }
                //     }
                // },
                elements: [
                    {
                        view: "scrollview",
                        scroll: "y",
                        body: {
                            paddingX: 18,
                            rows: [
                                dauphieuHoadon,
                                {
                                    borderless: true,
                                    view: "tabview",
                                    scrollX: true,
                                    tabbar: {
                                        width: 200
                                    },
                                    cells: [
                                        {
                                            header: headerDetail,
                                            select: "cell",
                                            body: {
                                                rows: [
                                                    btnChitietHoadon,
                                                    {
                                                        view: "datatable",
                                                        resizeColumn: true,
                                                        id: datatableDetailId,
                                                        editable: true,
                                                        select: "cell",
                                                        drag: true,
                                                        columns: [
                                                            { id: "stt", header: "", width: 30, editable: true, editor: "text" },
                                                            { id: "stt_rec", header: "STT", width: 40, editable: true, editor: "text" },
                                                            mahanghoaHoadon,
                                                            { id: "ten", header: _("TEN_HV"), editor: "text", width: 350, editable: true },
                                                            componentHelper.donvitinhHoadon(),
                                                            colPhiThamDinh,
                                                            colTienSauThue,
                                                        ],
                                                        scheme: {
                                                        },
                                                        on: {
                                                            "data->onStoreUpdated": function () {
                                                                this.data.each(function (obj, i) {
                                                                    obj.stt = i + 1;
                                                                })
                                                            },
                                                            onKeyPress: function (code, e) {
                                                                var table = this;
                                                                if (e.key == "F8") {
                                                                    $$("removerow").callEvent("onItemClick");
                                                                }
                                                                if (e.key == "F9") {
                                                                    $$("addrow").callEvent("onItemClick");
                                                                }
                                                                if (e.key == "F7") {
                                                                    $$("copyrow").callEvent("onItemClick");
                                                                }
                                                            },
                                                            onAfterAdd: function (id, index) {
                                                                var table = $$(this.config.id);
                                                                var data = table.serialize();

                                                                var tong_tien_tt_dp = 0;
                                                                var tong_tien_thue_dp = 0
                                                                var tong_tien_ck_dp = 0;
                                                                var tong_tien_dp = 0

                                                                data.forEach(function (entry, count) {
                                                                    tong_tien_tt_dp += entry["tien_tt"] == null ? 0 : entry["tien_tt"];
                                                                    tong_tien_thue_dp += entry["tien_thue"] == null ? 0 : entry["tien_thue"];
                                                                    tong_tien_ck_dp += entry["tien_ck"] == null ? 0 : entry["tien_ck"];
                                                                    tong_tien_dp += entry["tong_tien"] == null ? 0 : entry["tong_tien"];
                                                                });
                                                            },
                                                            onAfterEditStop: function (state, editor, ignore) {
                                                                var table = $$(this.config.id);
                                                                var selectedItem = table.getItem(editor.row);
                                                                var columnId = editor.config.id;
                                                                var phi_thamdinh = webix.rules.isNumber(selectedItem.phi_thamdinh) ? selectedItem.phi_thamdinh : 0;
                                                                var tgtien = webix.rules.isNumber(selectedItem.tgtien) ? selectedItem.tgtien : 0;
                                                                if (columnId == "phi_thamdinh") {
                                                                  tgtien = (phi_thamdinh * 0.15 / 100);
                                                                  if (tgtien > 5000000) tgtien = 5000000;
                                                                }
                                                                selectedItem.tgtien = Math.round(tgtien);
                                                                addTotalValue(- tgtienBeforeEdit + Math.round(tgtien))
                                                            },
                                                            onAfterEditStart: function (cell) {
                                                                if (cell.column == "ten") {
                                                                    this.getEditor().getInputNode().setAttribute("maxlength", 500);
                                                                }
                                                            },
                                                            onBeforeEditStart: function (obj) {
                                                                var table = $$(this.config.id);
                                                                var selectedItem = table.getItem(obj.row);
                                                                setTimeout(function () {
                                                                  tgtienBeforeEdit = selectedItem.tgtien || 0;
                                                                }, 100)
                                                                return eventTableHelper.BeforEditRow(this, obj);
                                                            },
                                                            onValidationError: function (id, obj, details) {
                                                                eventTableHelper.ValidateError(this, id, obj, details);
                                                            },
                                                            onAfterDelete: function () {
                                                              if (!clickedItem || !clickedItem.tgtien)
                                                                return;
                                                              addTotalValue(-clickedItem.tgtien)
                                                            },
                                                            onItemClick: function (id) {
                                                              clickedItem = this.getItem(id);
                                                            },
                                                        },
                                                        rules: {

                                                        },
                                                        ready: function () {
                                                            this.validate();
                                                        }
                                                    }
                                                ]
                                            }

                                        }
                                    ]
                                },
                                {
                                    css: "regiontongtien",
                                    rows: [
                                        tongtien,
                                        {
                                            view: "accordion",
                                            multi: true,
                                            borderless: true,
                                            css: "tongtienChitiet",
                                            rows: [
                                                { header: " + Tổng tiền chi tiết", css: "ttChitiet", collapsed: true, body: tongtienDetail }
                                            ]
                                        },
                                        tienbangchu,
                                        { height: 10 }
                                    ]
                                },
                                { height: 10 },
                                {
                                    margin: 5,
                                    cols: [
                                        {},
                                        btnSave,
                                        btnClose,
                                        {}
                                    ]
                                }
                            ]
                        }
                    }
                ]
            }
        },
        setValues: function (item, winconfig, params) {
            var win = $$(this.$ui.id);
            var form = win.getChildViews()[1];
            if (item != null) {
                item["tdlap"] = removeTimeZoneT(item["tdlap"]);
                form.setValues(item);
                $$("tgtthue").setValue(item.tgtthue);
                var tableDetail = webix.$$(datatableDetailId);
                var url = constant.API.PAYMENT_REQUEST.GET_DETAIL + item.id;
                tableDetail.clearAll();
                tableDetail.load(url);
            }
            addTotalValue(item[tgtttbsoId])
        },
        setEditMode: function (mode, loai) {
            editmode = mode;
            var form = $$(this.$ui.id);
            form.config.editmode = mode;
            form.config.loai = loai;
            var icon = "";
            switch (editmode) {
                case 1:
                    icon = "<span><i class='fa fa-plus' aria-hidden='true'></i></span>";
                    break;
                case 2:
                    icon = "<i class='fa fa-edit' aria-hidden='true'></i>";
                    break;
                default:
                    icon = "<i class='fa fa-trash fa-lg' aria-hidden='true'></i>";
                    break;
            };
            webix.$$("head-iconInvoice").setHTML(icon);
            webix.$$("head-iconInvoice").refresh();
        },
        copyValues: function (item) {
            eventTableHelper.PaymentRequestCopy(item);
        },
        initUINew: function () {
        },
    };
});

define('views/forms/payment_request',[
    "app",
    "locale",
    "models/user",
    "views/modules/Component/componentHelper",
    "views/modules/Component/eventTableHelper",
    "views/modules/Component/button",
    "views/modules/Component/constantManager",
    "views/modules/Component/functionExtension",
    "views/modules/Component/buttonAnimation",
], function (app, _, user, componentHelper, eventTableHelper, buttonOptions, constant, functionExtension, buttonAnimation) {
    var editmode = 0;
    var afteredit = "";
    var quantity = 0;

    var dauphieuHoadon = componentHelper.masterPaymentRequest();
    var btnChitietHoadon = componentHelper.btnChitietHoadon();
    var headTitleHoadon = componentHelper.headTitleHoadon("Phiếu đề nghị thu tiền");

    var tongtien = componentHelper.tongtien();
    var tongtienDetail = componentHelper.tongtienDetail();
    var tienbangchu = componentHelper.tienbangchu();

    var btnSave = buttonAnimation.btnSave();
    var btnClose = buttonAnimation.btnClose();
    var mahanghoaHoadon = componentHelper.mahanghoaHoadon(); mahanghoaHoadon.maxLength = 50;
    var colPtCk = componentHelper.numeric("tlckhau", "% CK", 3); colPtCk.hidden = true;
    var colTienCk = componentHelper.numeric("stckhau", "Tiền CK"); colTienCk.hidden = true;
    var colTienThue = componentHelper.numeric("tthue", _("TIEN_THUE"));
    var colTienSauThue = componentHelper.numeric("tgtien", "Tiền sau thuế");

    var windowId = "invoice68";
    var formId = "invoiceForms";
    var headerDetail = "Chi tiết phiếu thu";
    var datatableDetailId = "hoadon68_chitiet";

    var defaultMahoso = "H26.103"; 

    function setMahosoDefaultValue(control) {
        var paramUrl = app.config.host + "/Pattern/GetData";

        function setValue(value) {
        setTimeout(function () {
            control.setValue(value);
            control.define("text", value);
        }, 300);
        }

        if (defaultMahoso && defaultMahoso !== "H26.103") {
        setValue(defaultMahoso);
        } else {
        webix
            .ajax()
            .post(paramUrl, {
            command: "CM0029",
            start: 0,
            count: 50,
            filter: [],
            tlbparam: [],
            })
            .then(function (res) {
            var data = JSON.parse(res.text());
            data.data.forEach(function (item) {
                if (item.ma == "MA_HO_SO") {
                defaultMahoso = item.dien_giai || "H26.103"; 
                setValue(defaultMahoso);
                }
            });
            });
        }
    }

    return {
        $ui: {
            view: "window",
            modal: true,
            position: "center",
            css: "headformchil",
            head: headTitleHoadon,
            id: windowId,
            resize: true,
            fullscreen: true,
            move: true,
            on: {
                onBeforeShow: function () {
                    var type = 1;
                    var promise = eventTableHelper.OnBeforeShowForm(editmode, type);
                    if (typeof promise === 'string') {
                        afteredit = promise;
                    } else {
                        Promise.resolve(promise).then(function (value) {
                            afteredit = value.json().data;
                            webix.storage.local.put(`${constant.CACHE.AFTER_EDIT}${type}`, value.json().data);
                        })
                    }
                }
            },
            body: {
                paddingY: 10,
                paddingX: 10,
                elementsConfig: { labelWidth: 100 },
                view: "form",
                id: formId,
                width: 800,
                height: 500,
                complexData: true,
                margin: 0,
                on: {

                },
                rules: functionExtension.ValidateInvoice32(),
                // elementsConfig:{
                //     on:{
                //        'onChange':function(newv, oldv){
                //           this.validate();
                //         }
                //     }
                // },
                elements: [
                    {
                        view: "scrollview",
                        scroll: "y",
                        body: {
                            paddingX: 18,
                            rows: [
                                dauphieuHoadon,
                                {
                                    borderless: true,
                                    view: "tabview",
                                    scrollX: true,
                                    tabbar: {
                                        width: 200
                                    },
                                    cells: [
                                        {
                                            header: headerDetail,
                                            select: "cell",
                                            body: {
                                                rows: [
                                                    btnChitietHoadon,
                                                    {
                                                        view: "datatable",
                                                        resizeColumn: true,
                                                        id: datatableDetailId,
                                                        editable: true,
                                                        select: "cell",
                                                        drag: true,
                                                        columns: [
                                                            { id: "stt", header: "", width: 30, editable: true, editor: "text" },
                                                            { id: "stt_rec", header: "STT", width: 40, editable: true, editor: "text" },
                                                            mahanghoaHoadon,
                                                            { id: "ten", header: _("TEN_HV"), editor: "text", width: 350, editable: true },
                                                            componentHelper.donvitinhHoadon(),
                                                            componentHelper.numeric("sluong", _("SO_LUONG"), quantity),
                                                            componentHelper.numeric("dgia", _("DON_GIA")),
                                                            colPtCk,
                                                            colTienCk,
                                                            componentHelper.numeric("thtien", _("TIEN_TRUOC_THUE")),
                                                            {
                                                                id: "tsuat",
                                                                header: _("THUE_SUAT"), width: 100,
                                                                editor: "combo",
                                                                editable: true,
                                                                options: app.config.host + "/Invoice68/GetVAT"
                                                            },
                                                            colTienThue,
                                                            colTienSauThue,
                                                            {
                                                                id: "tchat", name: "tchat",
                                                                header: _("TCHAT"), editable: false, width: 200, editor: "combo",
                                                                options: [
                                                                    { id: "1", value: "Hàng hóa dịch vụ" },
                                                                    { id: "2", value: "Khuyến mại" },
                                                                    { id: "3", value: "Chiết khấu thương mại" },
                                                                    { id: "4", value: "Ghi chú/ diễn giải" },
                                                                ]
                                                            },
                                                            {
                                                                id: "ctinh", name: "ctinh",
                                                                header: "Cách tính",
                                                                editable: false,
                                                                width: 200,
                                                                editor: "combo",
                                                                options: [
                                                                    { id: "1", value: "Tính xuôi" },
                                                                    { id: "2", value: "Tính ngược" }
                                                                ],
                                                            }
                                                        ],
                                                        scheme: {
                                                        },
                                                        on: {
                                                            "data->onStoreUpdated": function () {
                                                                this.data.each(function (obj, i) {
                                                                    obj.stt = i + 1;
                                                                })
                                                            },
                                                            onKeyPress: function (code, e) {
                                                                var table = this;
                                                                if (e.key == "F8") {
                                                                    $$("removerow").callEvent("onItemClick");
                                                                }
                                                                if (e.key == "F9") {
                                                                    $$("addrow").callEvent("onItemClick");
                                                                }
                                                                if (e.key == "F7") {
                                                                    $$("copyrow").callEvent("onItemClick");
                                                                }
                                                            },
                                                            onAfterLoad: function () {
                                                                var table = this;
                                                                var data = table.serialize();
                                                                data.forEach(function (entry) {
                                                                    if (entry["stckhau"] != undefined || entry["tlckhau"] != undefined) {
                                                                        if (entry["stckhau"] != 0) {
                                                                            var ck = $$("check_chietkhau");
                                                                            if (ck != undefined) {
                                                                                ck.setValue(1);
                                                                                return false;
                                                                            }
                                                                        }
                                                                    }
                                                                });
                                                            },
                                                            onCheck: function (row, column, state) {
                                                                var table = this;
                                                                if (column == "khuyen_mai") {
                                                                    if (state == true) {
                                                                    }
                                                                }
                                                            },
                                                            onAfterAdd: function (id, index) {
                                                                var table = $$(this.config.id);
                                                                var data = table.serialize();

                                                                var tong_tien_tt_dp = 0;
                                                                var tong_tien_thue_dp = 0
                                                                var tong_tien_ck_dp = 0;
                                                                var tong_tien_dp = 0

                                                                data.forEach(function (entry, count) {
                                                                    tong_tien_tt_dp += entry["tien_tt"] == null ? 0 : entry["tien_tt"];
                                                                    tong_tien_thue_dp += entry["tien_thue"] == null ? 0 : entry["tien_thue"];
                                                                    tong_tien_ck_dp += entry["tien_ck"] == null ? 0 : entry["tien_ck"];
                                                                    tong_tien_dp += entry["tong_tien"] == null ? 0 : entry["tong_tien"];
                                                                });
                                                                var addedItem = table.getItem(id);
                                                                addedItem.tchat = 1;
                                                            },
                                                            onAfterEditStop: function (state, editor, ignore) {
                                                                var fn = Function("columnId", "tableId", "rowId", afteredit);
                                                                fn(editor.config.id, this.config.id, editor.row);
                                                                var selectedItem = this.getItem(editor.row);
                                                                console.log(selectedItem);
                                                                
                                                            },
                                                            onAfterEditStart: function (cell) {
                                                                if (cell.column == "ten") {
                                                                    this.getEditor().getInputNode().setAttribute("maxlength", 500);
                                                                }
                                                            },
                                                            onBeforeEditStart: function (obj) {
                                                                return eventTableHelper.BeforEditRow(this, obj);
                                                            },
                                                            onValidationError: function (id, obj, details) {
                                                                eventTableHelper.ValidateError(this, id, obj, details);
                                                            },
                                                        },
                                                        rules: {
                                                            "tchat": webix.rules.isNotEmpty,
                                                            $obj: webix.rules.validateMoney
                                                        },
                                                        ready: function () {
                                                            this.validate();
                                                        }
                                                    }
                                                ]
                                            }

                                        }
                                    ]
                                },
                                {
                                    css: "regiontongtien",
                                    rows: [
                                        tongtien,
                                        {
                                            view: "accordion",
                                            multi: true,
                                            borderless: true,
                                            css: "tongtienChitiet",
                                            rows: [
                                                { header: " + Tổng tiền chi tiết", css: "ttChitiet", collapsed: true, body: tongtienDetail }
                                            ]
                                        },
                                        tienbangchu,
                                        { height: 10 }
                                    ]
                                },
                                { height: 10 },
                                {
                                    margin: 5,
                                    cols: [
                                        {},
                                        btnSave,
                                        btnClose,
                                        {}
                                    ]
                                }
                            ]
                        }
                    }
                ]
            }
        },
        setValues: function (item, winconfig, params) {
            var win = $$(this.$ui.id);
            var form = win.getChildViews()[1];
            if (item != null) {
                item["tdlap"] = removeTimeZoneT(item["tdlap"]);
                form.setValues(item);
                $$("tgtthue").setValue(item.tgtthue);
                $$("tgtttbso").setValue(item.tgtttbso);
                var tableDetail = webix.$$(datatableDetailId);
                var url =
                  constant.API.PAYMENT_REQUEST.GET_DETAIL +
                  item.id;
                tableDetail.clearAll();
                tableDetail.load(url);
            }
        },
        setEditMode: function (mode, loai) {
            editmode = mode;
            var form = $$(this.$ui.id);
            form.config.editmode = mode;
            form.config.loai = loai;
            var icon = "";
            switch (editmode) {
                case 1:
                    icon = "<span><i class='fa fa-plus' aria-hidden='true'></i></span>";
                    break;
                case 2:
                    icon = "<i class='fa fa-edit' aria-hidden='true'></i>";
                    break;
                default:
                    icon = "<i class='fa fa-trash fa-lg' aria-hidden='true'></i>";
                    break;
            };
            webix.$$("head-iconInvoice").setHTML(icon);
            webix.$$("head-iconInvoice").refresh();
        },
        copyValues: function (item) {
            eventTableHelper.PaymentRequestCopy(item);
        },
        initUINew: function () {
            var mahosoCtrl = $$("mhso");
            setMahosoDefaultValue(mahosoCtrl);
        },
    };
});

define('views/forms/phanquyen',["app","locale"],function(app,_){
	
	function initUI(item){
		
		var url = app.config.host + "/System/ExecuteCommand";

		webix.ajax()
			.headers({'Content-type':'application/json'})
			.post(url,
				{
					command:"CM00003",
					parameter:{
						wb_nhomquyen_id: item.id
					}
				}
				,function(text){
            var json = JSON.parse(text);
			var data = listToTree(json, { idKey: "id", parentId: "parentId" });
			
			var trtChucNang = $$("trtChucNang");

			trtChucNang.parse(data,"json");
			trtChucNang.openAll();

			for(var i=0;i<json.length;i++){
				var item = json[i];

				if (item.wb_nhomquyen_id!=null){
					trtChucNang.checkItem(item.id);
				}				
			}
			
		});
		

		webix.ajax().headers({"Content-Type":"application/json"})
			.post(url,
				{
					command:"CM00015",
					parameter:{
						wb_nhomquyen_id: item.id
					}
				},function(text){
            var json = JSON.parse(text);
			var data = listToTree(json, { idKey: "id", parentId: "parentId" });
			
			var trtBaoCao=$$("trtBaoCao");

			trtBaoCao.parse(data,"json");
			trtBaoCao.openAll();

			for(var i=0;i<json.length;i++){
				var item = json[i];

				if (item.wb_nhomquyen_id!=null){
					trtBaoCao.checkItem(item.id);
				}
			}
			
		});

	}

	return {		
		$ui:{   
			view:"window", modal:true, id:"phanquyen-win", position:"center",
			head:"Thông tin Tab",
			css: "accountPermisson",
			fullscreen:true,
			body:{
				rows:[
					{
						borderless:true,
						view:"tabview",
						scrollX:true,
						multiview: {
							fitBiggest:true
						},
						cells:[
							{
								header: _("CHUC_NANG"),
								body:{
									id:"trtChucNang",
									view:"treetable",
									threeState: true,
									columns:[
										{
											id:"name",
											css: {"text-align" : "left !important"},
											header:"<center style ='text-align: left'><input style='text-align: left' id='chkBox' class='chkBox' type='checkbox' />" + _("TEN_CHUC_NANG")+"</center>",
											template : "{common.space()} {common.icon()} {common.treecheckbox()} #name#",
											fillspace:true																				
										},
										{
											id:"them",
											header: [ {text:"", content:"masterCheckbox" }, _("THEM")],
											width:55,
											checkValue:'C', 
											uncheckValue:'K', 
											template: function(obj,common,value, config) {
												if (obj.$count>0){
													return "";
												}
												return common.checkbox(obj, common,value, config);
											}
										},
										{
											id:"sua",
											header: [ {text:"", content:"masterCheckbox" }, _("SUA")],
											width:55,
											checkValue:'C', 
											uncheckValue:'K', 
											template: function(obj,common,value, config) {
												if (obj.$count>0){
													return "";
												}
												return common.checkbox(obj, common,value, config);
											}
										},
										{
											id:"xoa",
											header: [ {text:"", content:"masterCheckbox" }, _("XOA")],
											width:55,
											checkValue:'C', 
											uncheckValue:'K', 
											template: function(obj,common,value, config) {
												if (obj.$count>0){
													return "";
												}
												return common.checkbox(obj, common,value, config);
											}
										}
									],
									on:{
										onHeaderClick:function(id, e, node){
											if (e.target.className == "chkBox"){
												var chk=document.getElementById("chkBox").checked;

												var trtChucNang = $$("trtChucNang");			
												trtChucNang.openAll();

												var json = trtChucNang.serialize();

												for(var i=0;i<json.length;i++){
													var item = json[i];

													if (chk == true){
														trtChucNang.checkItem(item.id);
													}
													else {
														trtChucNang.uncheckItem(item.id);
													}
																													
												}
											}											
										}
									} 
								}
							},
							{
								header: _("BAO_CAO"),
								body:{
									id:"trtBaoCao",
									view:"treetable",
									threeState: true,
									columns:[
										{
											id:"name",
											header:"<center style='text-align: left'><input style='text-align: left' id='chkBox' class='chkBox' type='checkbox' />" +_("CHON_BOCHON") +"</center>",
											template : "{common.space()} {common.icon()} {common.treecheckbox()} #name#",
											fillspace:true																				
										}										
									],
									on:{
										onHeaderClick:function(id, e, node){
											if (e.target.className == "chkBox"){
												var chk=document.getElementById("chkBox").checked;

												var trtBaoCao = $$("trtBaoCao");			
												trtBaoCao.openAll();

												var json = trtBaoCao.serialize();

												for(var i=0;i<json.length;i++){
													var item = json[i];

													if (chk == true){
														trtBaoCao.checkItem(item.id);
													}
													else {
														trtBaoCao.uncheckItem(item.id);
													}
																													
												}
											}											
										}
									}
								}
							} 
						]						
					},
					{
						cols:[
							{},
							{ 
								shortcut:"F10",  
								view:"button", label:"Nhận (F10)", type:"form", align:"center", 
								width:100,
								on: {
									onClick: function() {										
										var tblChucnang = $$("trtChucNang");
										var tblBaoCao = $$("trtBaoCao");

										var win = this.getTopParentView();

										var checkedItems = tblChucnang.getChecked();

										var data = {
											wb_nhomquyen_id: win.config.wb_nhomquyen_id,
											wb_ctquyen: [],
											wb_ctquyenrp: []
										};

										for(var i=0;i<checkedItems.length;i++){
											var checked = tblChucnang.getItem(checkedItems[i]);
											
											if (checked.$count==0){
												var item = {
													wb_nhomquyen_id: win.config.wb_nhomquyen_id,
													wb_menu_id: checked.id,
													them: checked.them,
													sua: checked.sua,
													xoa: checked.xoa
												};
												
												data.wb_ctquyen.push(item);
											}
										}

										checkedItems = tblBaoCao.getChecked();

										for(var i=0;i<checkedItems.length;i++){
											var checked = tblBaoCao.getItem(checkedItems[i]);
											
											if (checked.$count==0){
												var item = {
													wb_nhomquyen_id: win.config.wb_nhomquyen_id,
													wb_report_id: checked.id													
												};
												
												data.wb_ctquyenrp.push(item);
											}
										}

										var url = app.config.host + "/System/Phanquyen";

										webix.ajax()
											.headers({'Content-type':'application/json'})
											.post(url, data, function(text){
											var result = JSON.parse(text);
											
											if (!result.hasOwnProperty("error")){
												webix.$$("phanquyen-win").close();												
											}
											else {
												webix.message(result.error);
											}
										});
									}
								},
								click:function(){								
									this.callEvent("onClick");							
														
								},
							},
							{ 
								view:"button", shortcut:"esc", label:"Hủy bỏ (ESC)",type:"danger",align:"center",
								width:100,
								on:{
									onClick: function(){
										this.getTopParentView().close();
									}
								},
								click:function(){
									this.callEvent("onClick");
								}
							},
							{}

						]
					},
					{
						height:5
					}
				]
			}			
			
		},		
		initUI: initUI
	};

});
define('views/forms/printf',[
    "app",
    "locale"
], function (app, _) {
    'use strict';

    function initUI(url) {

    };

    return {
        $ui: {
            view: "window",
            move: true,
            position: "center",
            id: "nampv",
            modal: true,
            resize: true,
            // borderless: false,
            fullscreen: true,
            css: { "border-radius": "8px 8px 0px 0px", "border-bottom": "none !important" },
            head: {
                //view: "toolbar",
                // css: { "box-shadow": "0 -2px #3498db inset !important" },
                height: 35,
                cols: [

                    { template: "<div class ='printf'><i class='fas fa-print'></i> Xem trước khi in</div>" },
                    {
                        view: "icon", icon: "times", hotkey: "esc", click: function () {
                            $$("nampv").close();
                        }
                    }
                ]
            },
            body: {
                rows: [
                    {
                        view: "iframe", id: "frame-body", css: { "width": "80%", "height": "80%" },
                        src: "https://minvoice.vn/"
                    },
                    //{ gravity: 0.1, template: "" }
                ]
            },
            on: {
                onBeforeShow: function () {
                    var link = $$("nampv").config.url;
                    //$$("myframe").getIframe();
                    $$("frame-body").define("src", link);

                }
            }
        },
        $oninit: function (view, $scope) {

        },
        initUI: initUI
    }
});
define('views/forms/searchinvoice',["app", "locale"],function(app,_){
	var editmode = 0;	

	return {		
		$ui:{   
			view:"window", modal:true, id:"dmtab-win", position:"center",
			head:"Tìm kiếm chi tiết",
			width:500,
			body:{
                paddingY:10, 
                paddingX:10, 
                view:"form", 
				id:"dmtab-form", 
				complexData:true,
				margin: 0,
                elements:[
					{
						view:"combo", 
						name:"inv_invoiceType", 
						label:_("MA_LOAI"), 
						labelPosition:"top",
						options: {
							body:{
								url: app.config.host + "/System/GetDataReferencesByRefId?refId=RF00019"
							},									
							width: 550,
							fitMaster:false
						}
					},
					{
						cols:[							
							{ view:"text", name:"mau_hd", label:_("MAU_HDON"), labelPosition:"top" },
							{ view:"text", name:"inv_invoiceSeries", label:_("SO_SERIAL"), labelPosition:"top" }
						]
					},
					{
						cols:[
							{ view:"text", name:"inv_invoiceNumber", label:_("SO_HDON"), labelPosition:"top" },
							{ 
								view:"combo", 
								name:"user_new", 
								label:_("NGUOI_LAP"), 
								labelPosition:"top",
								options: app.config.host + "/System/GetDataReferencesByRefId?refId=RF00020" 
							}
						]
					},
					{
						cols:[
							{ view:"datepicker", name:"tu_ngay", label:_("TU_NGAY"), labelPosition:"top" },
							{ view:"datepicker", name:"den_ngay", label:_("DEN_NGAY"), labelPosition:"top" }
						]
					},
					{
						cols:[
							{ view:"combo", name:"trang_thai", options:["Chờ duyệt","Chờ ký", "Đã ký", "Đã kê khai"], label:_("TRANG_THAI"), labelPosition:"top" },
							{ 
								view:"combo", 
								name:"trang_thai_hd", 
								label:_("TRANG_THAI_HDON"), 
								labelPosition:"top",
								options: app.config.host + "/System/GetDataReferencesByRefId?refId=RF00017"
							}
						]
					},								
					{
						margin:10,
						cols:[
							{},
							{ 
								shortcut:"F10",  
								view:"button", 
								label:"Nhận (F10)", 
								type:"form", 
								icon:"",
								align:"center", 
								width:120, 
								on: {
									onClick: function() {
										var form = webix.$$("dmtab-form");
										var item = form.getValues();

										webix.$$("dmtab-win").close();
										app.callEvent("dataChanged",[1,item]);										
										
									}
								},
								click:function(){								
									this.callEvent("onClick");							
									
								}
							},
							{ view:"button", hotkey:"esc", label:"Hủy bỏ (ESC)",type:"danger", align:"center", width:120, 
								click:function(){
									webix.$$("dmtab-win").close();
								}
							},
							{}
						]
					}

				]
			}			
			
		},		
		setEditMode: function(mode) {
			editmode = mode;
		},
		setValues: function(values){
			$$("dmtab-form").setValues(values);
		}
	};

});
define('views/forms/sendemail',["app", "locale", "views/forms/lichsuemail", "views/modules/Component/constantManager", "views/modules/Component/functionExtension",], function (app, _, his_email, CONSTANTS, functionExtension) {

	return {
		$ui: {
			view: "window", modal: true, id: "dmtab-win", position: "center", move: true,
			head: {
				height: 40,
				cols: [
					{
						id: "head-form", view: "template", css: "headform", template: function (obj) {
							return '<div>Gửi hóa đơn cho khách hàng qua email<div/>';
						}
					},
					{ view: "icon", icon: "fas fa-question-circle", id: "help_form", tooltip: _("HELPER"), click: function () { } }
				]
			},
			fullscreen: true,
			css: "headformchil",
			keepViews: true,
			move: true,
			on: {
				onBeforeShow: function () {
					var result = webix.ajax().sync().get(app.config.host + "/System/GetOTPMail", function (text) {
						$$("otpMail").setValue(text);
					});
				}
			},
			body: {
				paddingY: 5,
				paddingX: 5,
				view: "form",
				id: "dmtab-form",
				on: {
					// onItemClick: function (id) {
					// 	if (id == "his_email") {
					// 		var detailForm = $$("dmtab-win").$scope.ui(his_email.$ui);
					// 		detailForm.show();
					// 	}
					// }
				},
				elements: [
					{
						view: "fieldset",
						label: "Thông tin gửi mail",
						body: {
							rows: [
								{
									view: 'checkbox',
									//name: "otpMail",
									// name: "rememberme",
									id: "otpMail",
									label: "Sử dụng email của M-Invoice để gửi đi", labelPosition: "left",
									labelWidth: 230, tooltip: "Tích vào đây nếu bạn muốn email gửi đi sử dụng email của M-Invoice ! Gửi email bằng mail hệ thống của M-Invoice sẽ theo dõi được email gửi thành công hay không, người nhận đã xem email bạn gửi hay chưa.",
									on: {
										onChange: function (newv, oldv) {
											// webix.message(newv);
											if (newv == 1) {
												$$("fromName").define("readonly", true);
												$$("fromName").define("css", "mcls_readonly_text");
												$$("fromName").setValue("***");
												$$("fromName").refresh();

												$$("passMail").define("readonly", true);
												$$("passMail").define("css", "mcls_readonly_text");
												$$("passMail").setValue("***");
												$$("passMail").refresh();
											}
											if (newv == 0) {
												var table = webix.$$("windowData");
												var selectedItem = table.getSelectedItem();
												var url = "/Invoice/GetEmailTemplate?type=Gửi hóa đơn&id=" + selectedItem.inv_InvoiceAuth_id;

												webix.ajax(app.config.host + url, function (text) {
													var json = JSON.parse(text);
													$$("fromName").setValue(json.nguoi_gui);
													$$("fromName").define("readonly", false);
													webix.html.removeCss($$("fromName").$view, "mcls_readonly_text");
													$$("fromName").refresh();

													$$("passMail").setValue(json.pass);
													$$("passMail").define("readonly", false);
													webix.html.removeCss($$("passMail").$view, "mcls_readonly_text");
													$$("passMail").refresh();
												});
											}
										}
									}
								},
								{
									cols: [
										{
											view: "text",
											id: "fromName",
											name: "nguoi_gui",
											label: _("NGUOI_GUI"),
											labelPosition: "top",
											required: true,
											validate: webix.rules.isNotEmpty,
											invalidMessage: "Người gửi không được để trống !"
										}, {
											view: "text",
											id: "passMail",
											name: "mat_khau",
											label: _("PASSWORD"),
											type: "password",
											labelPosition: "top",
											required: true,
											validate: webix.rules.isNotEmpty,
											invalidMessage: "Mật khẩu không được để trống !"
										}
									]
								},
								{
									cols: [
										{
											view: "text",
											name: "nguoinhan",
											id: "nguoinhan",
											label: _("NGUOI_NHAN"),
											keyPressTimeout: 100,
											labelPosition: "top",
											placeholder: "Nhập email người nhận, nhiều hơn 1 email thì cách nhau bằng dấu phẩy (,)",
											required: true,
											validate: webix.rules.isNotEmpty,
											invalidMessage: "Người nhận không được để trống !",
											on: {
												onTimedKeyPress: function () {
													var countMail = $$("nguoinhan").getValue().split(/[\s,\;]+/);
													// console.log(countMail);
													if (countMail.length > 5) {
														webix.message("Bạn không được phép gửi quá 5 Email."
															+ " Vui lòng liên hệ nhà cung cấp để được giải đáp.", "debug");
														return;
													}

												}
											}
										},
										{
											view: "text",
											name: "bcc",
											label: "BCC",
											labelPosition: "top"
										}
									]
								},
								{
									view: "text",
									name: "tieude",
									label: _("TIEU_DE"),
									labelPosition: "top",
								}
							]
						}
					},
					{
						view: "label",
						name: "his_email",
						id: "his_email",
						template: function (obj) {
							if (obj.value == 0) return "<span style='color:blue'>Hóa đơn chưa gửi cho khách hàng !</span>";
							return "<span style='color:blue'>Hóa đơn đã được gửi <big>" + obj.value + "</big> lần !<sub style='color:red'> Lịch sử gửi email <i class='fa fa-hand-o-left' aria-hidden='true'></i></sub></span>"
						},
						on: {
							onItemClick: function () {
								var table = webix.$$("windowData").getSelectedItem();
								var detailForm = $$("dmtab-win").$scope.ui(his_email.$ui);
								his_email.initUI(table.inv_InvoiceAuth_id);
								detailForm.show();

							}
						}
					},
					{
						name: "noidung",
						view: "ckeditor",
						keepViews: true,
						label: _("NOI_DUNG"),
						labelPosition: "top"
					},
					{
						margin: 10,
						cols: [
							{},
							{
								shortcut: "F10", view: "button", label: "Nhận (F10)", type: "form", align: "center", width: 120,
								on: {
									onClick: function () {
										var form = webix.$$("dmtab-form");
										var item = form.getValues();
										item.otpmail = $$("otpMail").getValue();
										item.scret = functionExtension.SaltEmail(item.nguoinhan);

										var url = app.config.host + "/Invoice/Email";
										var countMail = $$("nguoinhan").getValue().split(/[\s,\;]+/);
										if (countMail.length > 5) {
											webix.message("Bạn không được phép gửi quá 5 Email."
												+ " Vui lòng liên hệ nhà cung cấp để được giải đáp.", "debug");
											return;
										}
										else {
											if ($$("dmtab-form").validate()) {

												webix.extend(form, webix.ProgressBar);
												form.disable();
												form.showProgress();

												webix.ajax()
													.headers({ 'Content-type': 'application/json' })
													.post(url, item, function (text) {

														var form = webix.$$("dmtab-form");

														form.enable();
														form.hideProgress();

														var data = JSON.parse(text);

														if (!data.hasOwnProperty("error")) {
															webix.message("Gửi Email thành công !", "debug");

															var item = form.getValues();
															var topParentView = form.getTopParentView();

															if (topParentView.config.tableId != undefined) {
																var table = $$(topParentView.config.tableId);

																var item = table.getSelectedItem();
																item.trang_thai = "Chờ người mua ký";
																table.updateItem(item.id, item);
															}

															webix.$$("dmtab-win").close();
														}
														else {
															webix.message(data.error);
														}
													});
											}
											else {
												$$("nguoinhan").focus();
											}
										}
									}
								},
								click: function () {
									this.callEvent("onClick");

								}
							},
							{
								view: "button", hotkey: "esc", label: "Hủy bỏ (ESC)", type: "danger", align: "center", width: 120,
								click: function () {
									webix.$$("dmtab-win").close();
								}
							},
							{}
						]
					}
				]

			}

		},
		setEditMode: function (mode) {
			editmode = mode;
		},
		setValues: function (values) {
			$$("dmtab-form").setValues(values);
		}
	};

});
define('views/forms/sendZNS',["app", "locale", "views/forms/lichsuZns"], function (app, _, his_ZNS) {
    var editmode = 0;
    var inv_InvoiceAuth_id;

    return {
        $ui: {
            view: "window", modal: true, id: "sendZNS-win", position: "center", move: true,
            // head: "Gửi hóa đơn cho khách hàng qua email",
            head: {
                //view: "toolbar",
                // css: { "box-shadow": "0 -2px #3498db inset !important", "background": "#ffffff !important" },
                //css: { "background": "#e6f2ff !important" },
                height: 40,
                cols: [
                    {
                        id: "head-form", view: "template", css: "headform", template: function (obj) {
                            return '<div>Gửi hóa đơn cho khách hàng qua Zalo<div/>';
                        }
                    },
                    {
                        view: "icon", icon: "fas fa-question-circle", id: "help_form", tooltip: _("HELPER"), click: function () {
                            // var form = webix.$$("window-form");
                            // hint_form(form.config.hint);
                        }
                    }
                ]
            },
            // fullscreen: true,
            width: 500,
            height: 550,
            // css: {"border-radius":"10px 10px 0px 0px"},
            css: "headformchil",
            keepViews: true,
            move: true,
            on: {
                onBeforeShow: function () {
                    // var result = webix.ajax().sync().get(app.config.host + "/System/GetOTPMail", function (text) {
                    //     $$("otpMail").setValue(text);
                    //     // webix.message(text);
                    //     //console.log(text);
                    // });
                    //var json = result.response.substring(1,result.response.length -1);
                }
            },
            body: {
                paddingY: 5,
                paddingX: 5,
                view: "form",
                id: "sendZNS-form",
                on: {
                    // onItemClick: function (id) {
                    // 	if (id == "his_email") {
                    // 		var detailForm = $$("sendZNS-win").$scope.ui(his_email.$ui);
                    // 		detailForm.show();
                    // 	}
                    // }
                },
                elements: [
                    {
                        view: "template", id: "znsTemp", borderless: true, template: function (obj) {
                            return obj;
                        }
                    },
                    {
                        view: "text",
                        name: "sdt",
                        id: "sdt",
                        // type: "number",
                        label: _("Số điện thoại"),
                        labelPosition: "top",
                        required: true,
                        tooltip: "Nếu nhiều hơn 1 số điện thoại thì cách nhau bằng dấu phẩy (,)",
                        validate: webix.rules.isNotEmpty,
                        placeholder: "Nếu nhiều hơn 1 số điện thoại thì cách nhau bằng dấu phẩy (,)",
                        invalidMessage: "Số điện thoại không được để trống !"
                        //                         on: {
                        //                             onkeypress: function (code, e) {
                        //                                 console.log(code);
                        //                                 if (code != 186 && code != 188 && code != 8) {
                        // console.log("ss");
                        //                                     if (code < 48 || code > 57) {
                        //                                         return webix.html.preventEvent(e);
                        //                                     }
                        //                                 }
                        //                             }
                        //                         }
                    },
                    {
                        view: "label",
                        name: "log_count",
                        id: "log_count",
                        //label: "Hóa đơn đã được gửi đi 5 lần",
                        template: function (obj) {
                            if (obj.value == 0) return "<span style='color:blue'>Hóa đơn chưa gửi cho khách hàng !</span>";
                            return "<span style='color:blue'>Hóa đơn đã được gửi <big>" + obj.value + "</big> lần !<sub style='color:red'> Lịch sử gửi zalo <i class='fa fa-hand-o-left' aria-hidden='true'></i></sub></span>"
                        },
                        on: {
                            onItemClick: function () {
                                var table = webix.$$("windowData").getSelectedItem();

                                var detailForm = $$("sendZNS-win").$scope.ui(his_ZNS.$ui);
                                his_ZNS.initUI(table.inv_InvoiceAuth_id);
                                detailForm.show();

                            }
                        }
                    },
                    {
                        margin: 10,
                        cols: [
                            {},
                            {
                                shortcut: "F10", view: "button", label: "Nhận (F10)", type: "form", align: "center", width: 120,
                                on: {
                                    onClick: function () {
                                        webix.message("Đã hết hạn dùng thử. Vui lòng liên hệ Công ty TNHH hóa đơn điện tử M-Invoice để đăng ký dịch vụ.", "error");
                                        
                                        // var form = webix.$$("sendZNS-form");
                                        // var item = form.getValues();

                                        // var dataPost = {
                                        //     id: inv_InvoiceAuth_id,
                                        //     sdt: $$("sdt").getValue()
                                        // };

                                        // var url = app.config.host + "/Invoice/SendZns";
                                        // var countMail = $$("sdt").getValue().split(/[\s,\;]+/);
                                        // if (countMail.length > 5) {
                                        //     webix.message("Bạn không được phép gửi quá 5 Email."
                                        //         + " Vui lòng liên hệ nhà cung cấp để được giải đáp.", "debug");
                                        //     return;
                                        // }
                                        // else {
                                        //     if ($$("sendZNS-form").validate()) {

                                        //         webix.extend(form, webix.ProgressBar);
                                        //         form.disable();
                                        //         form.showProgress();

                                        //         webix.ajax()
                                        //             .headers({ 'Content-type': 'application/json' })
                                        //             .post(url, dataPost, function (text) {

                                        //                 var form = webix.$$("sendZNS-form");

                                        //                 form.enable();
                                        //                 form.hideProgress();

                                        //                 var data = JSON.parse(text);
                                        //                 //console.log(data);
                                        //                 if (data.code == "00") {
                                        //                     webix.message("Gửi ZNS thành công !", "success");
                                        //                     webix.message(JSON.stringify(data.data), "success");

                                        //                     // var item = form.getValues();
                                        //                     // var topParentView = form.getTopParentView();

                                        //                     // if (topParentView.config.tableId != undefined) {
                                        //                     //     var table = $$(topParentView.config.tableId);

                                        //                     //     var item = table.getSelectedItem();
                                        //                     //     item.trang_thai = "Chờ người mua ký";
                                        //                     //     table.updateItem(item.id, item);
                                        //                     // }

                                        //                     webix.$$("sendZNS-win").close();
                                        //                 }
                                        //                 else {
                                        //                     webix.message(data.message);
                                        //                 }
                                        //             });
                                        //     }
                                        //     else {
                                        //         $$("sdt").focus();
                                        //     }
                                        // }
                                    }
                                },
                                click: function () {
                                    this.callEvent("onClick");

                                }
                            },
                            {
                                view: "button", hotkey: "esc", label: "Hủy bỏ (ESC)", type: "danger", align: "center", width: 120,
                                click: function () {
                                    webix.$$("sendZNS-win").close();
                                }
                            },
                            {}
                        ]
                    }
                ]

            }

        },
        setEditMode: function (mode) {
            editmode = mode;
        },
        setValues: function (id, value) {
            inv_InvoiceAuth_id = id;
            $$("znsTemp").setValues(value.temp_zns);
            $$("log_count").setValue(value.log_count);
        }
    };

});
define('views/forms/signCloud',["app"], function (app) {
    var editmode = 0;
    var item;
    function initUI(obj) {
        item = obj;
    }
    return {
        $ui: {
            view: "window",
            modal: true,
            id: "signCloud",
            css: "signCloud",
            position: "center",
            move: true,
            head: false,
            minWidth: 350,
            // height: 100,
            body: {
                view: "form",
                id: "signCloud-frm",
                elementsConfig: {
                    labelWidth: 60
                },
                elements: [
                    {
                        view: "text", type: "password", name: "pin_Code", id: "pinCode", label: "Mã pin", required: true,
                        invalidMessage: "Bạn phải nhập mã pin"
                    },
                    {
                        cols: [
                            {},
                            {
                                shortcut: "F10", view: "button", label: "Nhận (F10)", type: "form", align: "center", width: 80,
                                on: {
                                    onClick: function () {
                                        if ($$("signCloud-frm").validate()) {
                                            var form = $$("signCloud");
                                            var param = {
                                                agreementUUID: item.agreementUUID,
                                                pinCode: $$("pinCode").getValue(),
                                                id: item.inv_InvoiceAuth_id
                                            }

                                            webix.extend(form, webix.ProgressBar);
                                            form.disable();
                                            form.showProgress();
                                            var url = app.config.host + "/TokenCloud/SignCloud";

                                            webix.ajax()
                                                .headers({ 'Content-type': 'application/json' })
                                                .post(url, param, {
                                                    error: function (text, data, XmlHttpRequest) {
                                                        form.enable();
                                                        form.hideProgress();
                                                        webix.message(text);
                                                    },
                                                    success: function (text, data, XmlHttpRequest) {
                                                        var obj = JSON.parse(text);
                                                        if (!obj.hasOwnProperty("error")) {
                                                            if (obj.trang_thai == "Đã ký") {

                                                                var table = webix.$$("windowData");
                                                                var item = table.getSelectedItem();

                                                                item.trang_thai = "Đã ký";
                                                                item.inv_invoiceNumber = obj.inv_invoiceNumber;
                                                                table.updateItem(item.id, item);

                                                                webix.ajax()
                                                                    .headers({ 'Content-type': 'application/json' })
                                                                    .post(app.config.host + "/System/ExecuteCommand",
                                                                    {
                                                                        command: "CM00025",
                                                                        parameter: {
                                                                        }
                                                                    }
                                                                    , function (text) {
                                                                        var json = JSON.parse(text);
                                                                        // auto send SMS 
                                                                        if (json[1].gia_tri == "C") {
                                                                            var data = { id: item.inv_InvoiceAuth_id };

                                                                            webix.ajax()
                                                                                .headers({ 'Content-type': 'application/json' })
                                                                                .post(app.config.host + "/Sms/NotifyInvoice", data, function (text) {
                                                                                    var data = JSON.parse(text);

                                                                                    if (!data.hasOwnProperty("error")) {
                                                                                    }
                                                                                    else {
                                                                                        webix.message(data.error, "error");
                                                                                    }
                                                                                });
                                                                        }
                                                                        // send email ma = 'AUTO_SEND_EMAIL'
                                                                        if (json[0].gia_tri == "C") {
                                                                            var data = { inv_InvoiceAuth_id: item.inv_InvoiceAuth_id, nguoinhan: item.inv_buyerEmail, tieude: "Thông báo xuất hóa đơn điện tử" };

                                                                            webix.ajax()
                                                                                .headers({ 'Content-type': 'application/json' })
                                                                                .post(app.config.host + "/Invoice/AutoEmail", data, function (text) {
                                                                                    var data = JSON.parse(text);

                                                                                    if (!data.hasOwnProperty("error")) {

                                                                                    }
                                                                                    else {
                                                                                        webix.message(data.error, "error");
                                                                                    }
                                                                                });
                                                                        }
                                                                    });

                                                            }
                                                            form.enable();
                                                            form.hideProgress();
                                                            $$("btnCancel").callEvent("onClick");
                                                            webix.message("Ký hóa đơn thành công !", "success");
                                                        }
                                                        else {
                                                            form.enable();
                                                            form.hideProgress();
                                                            webix.message(obj.error, "error");
                                                        }

                                                    }
                                                });
                                        }
                                    }
                                },
                                click: function () {
                                    this.callEvent("onClick");

                                }
                            },
                            {
                                view: "button", id: "btnCancel", shortcut: "esc", label: "Hủy (ESC)", type: "danger", align: "center",
                                width: 80,
                                on: {
                                    onClick: function () {
                                        $$("signCloud").close();
                                    }
                                },
                                click: function () {
                                    this.callEvent("onClick");
                                }
                            },
                            {}
                        ]
                    }
                ]
            }
        },
        setEditMode: function (mode) {
            editmode = mode;
        },
        initUI: initUI
    };

});
define('views/forms/signCloudXoabo',["app"], function (app) {
    var editmode = 0;
    var item;
    var dataCert;
    function initUI(data, cert) {
        item = data;
        dataCert = cert;
    }
    return {
        $ui: {
            view: "window",
            modal: true,
            id: "signCloudXoabo",
            css: "signCloudXoabo",
            position: "center",
            move: true,
            head: false,
            minWidth: 350,
            // height: 100,
            body: {
                view: "form",
                id: "signCloudXoabo-frm",
                elementsConfig: {
                    labelWidth: 60
                },
                elements: [
                    {
                        view: "text", type: "password", name: "pin_Code", id: "pinCode", label: "Mã pin", required: true,
                        invalidMessage: "Bạn phải nhập mã pin"
                    },
                    {
                        cols: [
                            {},
                            {
                                shortcut: "F10", view: "button", label: "Nhận (F10)", type: "form", align: "center", width: 80,
                                on: {
                                    onClick: function () {
                                        if ($$("signCloudXoabo-frm").validate()) {
                                            var form = $$("signCloudXoabo");
                                            var param = {
                                                agreementUUID: dataCert.agreementUUID,
                                                pinCode: $$("pinCode").getValue(),
                                                InvoiceXmlData: item.InvoiceXmlData
                                            }

                                            webix.extend(form, webix.ProgressBar);
                                            form.disable();
                                            form.showProgress();
                                            var url = app.config.host + "/TokenCloud/SingXmldata";

                                            webix.ajax()
                                                .headers({ 'Content-type': 'application/json' })
                                                .post(url, param, {
                                                    error: function (text, data, XmlHttpRequest) {
                                                        form.enable();
                                                        form.hideProgress();
                                                        webix.message(text);
                                                    },
                                                    success: function (text, data, XmlHttpRequest) {

                                                        var obj = JSON.parse(text);
                                                        if (!obj.hasOwnProperty("error")) {

                                                            var parameters = item;
                                                            parameters.InvoiceXmlData = obj.InvoiceXmlData;
                                                            parameters.serialNumber = dataCert.so_serial;

                                                            webix.ajax()
                                                                .headers({ "Content-Type": "application/json" })
                                                                .post(app.config.host + "/Invoice/SaveInvoiceXoaBo", parameters,
                                                                {
                                                                    error: function (text, data, XmlHttpRequest) {
                                                                        form.enable();
                                                                        form.hideProgress();
                                                                        webix.message(text);
                                                                    },
                                                                    success: function (text, data, XmlHttpRequest) {
                                                                        var result = JSON.parse(text);

                                                                        if (result.hasOwnProperty("error")) {
                                                                            webix.message({ type: "error", text: result["error"] });
                                                                        }
                                                                        else {
                                                                            webix.$$("chukyso-win").close();
                                                                        }
                                                                        form.enable();
                                                                        form.hideProgress();

                                                                        $$("signCloudXoabo").close();
                                                                        var form = webix.$$("chukyso-form");
                                                                        form.close();

                                                                        webix.message("Xóa bỏ hóa đơn thành công !", "success");
                                                                    }

                                                                    // error: function (text) {
                                                                    //     var result = JSON.parse(text);

                                                                    //     if (result.hasOwnProperty("error")) {
                                                                    //         webix.message({ type: "error", text: result["error"] });
                                                                    //     }
                                                                    //     else {
                                                                    //         webix.$$("chukyso-win").close();
                                                                    //     }
                                                                });
                                                        }
                                                        else {
                                                            form.enable();
                                                            form.hideProgress();
                                                            webix.message(obj.error, "error");
                                                        }

                                                    }
                                                });
                                        }
                                    }
                                },
                                click: function () {
                                    this.callEvent("onClick");

                                }
                            },
                            {
                                view: "button", id: "btnCancel", shortcut: "esc", label: "Hủy (ESC)", type: "danger", align: "center",
                                width: 80,
                                on: {
                                    onClick: function () {
                                        $$("signCloudXoabo").close();
                                        var form = webix.$$("chukyso-form");
                                        form.enable();
                                        form.hideProgress();
                                    }
                                },
                                click: function () {
                                    this.callEvent("onClick");
                                }
                            },
                            {}
                        ]
                    }
                ]
            }
        },
        setEditMode: function (mode) {
            editmode = mode;
        },
        initUI: initUI
    };

});
define('views/forms/signEasyCA',["app"], function (app) {
    var editmode = 0;
    var item;
    function initUI(obj) {
        item = obj;
    }
    return {
        $ui: {
            view: "window",
            modal: true,
            id: "signEasyCA",
            css: "signEasyCA",
            position: "center",
            move: true,
            head: false,
            minWidth: 350,
            // height: 100,
            body: {
                view: "form",
                id: "signEasyCA-frm",
                elementsConfig: {
                    labelWidth: 60
                },
                elements: [
                    {
                        view: "text", type: "password", name: "pin", id: "pin", label: "Mã pin", required: true,
                        invalidMessage: "Bạn phải nhập mã pin"
                    },
                    // {
                    //     view: "text",  name: "username", id: "username", label: "Username", required: true,
                    //     invalidMessage: "Bạn phải nhập Username"
                    // },
                    // {
                    //     view: "text", type: "password", name: "password", id: "password", label: "Password", required: true,
                    //     invalidMessage: "Bạn phải nhập Password"
                    // },
                    {
                        cols: [
                            {},
                            {
                                shortcut: "F10", view: "button", label: "Nhận (F10)", type: "form", align: "center", width: 80,
                                on: {
                                    onClick: function () {
                                        if ($$("signEasyCA-frm").validate()) {
                                            var form = $$("signEasyCA");
                                            var param = {
                                                so_serial: item.so_serial,
                                                pin: $$("pin").getValue(),
                                                id: item.inv_InvoiceAuth_id,
                                                username: item.username,
                                                password: item.pass
                                            }

                                            webix.extend(form, webix.ProgressBar);
                                            form.disable();
                                            form.showProgress();
                                            var url = app.config.host + "/Token/SignEasyCA";

                                            webix.ajax()
                                                .headers({ 'Content-type': 'application/json' })
                                                .post(url, param, {
                                                    error: function (text, data, XmlHttpRequest) {
                                                        form.enable();
                                                        form.hideProgress();
                                                        webix.message(text);
                                                    },
                                                    success: function (text, data, XmlHttpRequest) {
                                                        var obj = JSON.parse(text);
                                                        if (!obj.hasOwnProperty("error")) {
                                                            if (obj.trang_thai == "Đã ký") {

                                                                var table = webix.$$("windowData");
                                                                var item = table.getSelectedItem();

                                                                item.trang_thai = "Đã ký";
                                                                item.inv_invoiceNumber = obj.inv_invoiceNumber;
                                                                table.updateItem(item.id, item);

                                                                webix.ajax()
                                                                    .headers({ 'Content-type': 'application/json' })
                                                                    .post(app.config.host + "/System/ExecuteCommand",
                                                                    {
                                                                        command: "CM00025",
                                                                        parameter: {
                                                                        }
                                                                    }
                                                                    , function (text) {
                                                                        var json = JSON.parse(text);
                                                                        // auto send SMS 
                                                                        if (json[1].gia_tri == "C") {
                                                                            var data = { id: item.inv_InvoiceAuth_id };

                                                                            webix.ajax()
                                                                                .headers({ 'Content-type': 'application/json' })
                                                                                .post(app.config.host + "/Sms/NotifyInvoice", data, function (text) {
                                                                                    var data = JSON.parse(text);

                                                                                    if (!data.hasOwnProperty("error")) {
                                                                                    }
                                                                                    else {
                                                                                        webix.message(data.error, "error");
                                                                                    }
                                                                                });
                                                                        }
                                                                        // send email ma = 'AUTO_SEND_EMAIL'
                                                                        if (json[0].gia_tri == "C") {
                                                                            var data = { inv_InvoiceAuth_id: item.inv_InvoiceAuth_id, nguoinhan: item.inv_buyerEmail, tieude: "Thông báo xuất hóa đơn điện tử" };

                                                                            webix.ajax()
                                                                                .headers({ 'Content-type': 'application/json' })
                                                                                .post(app.config.host + "/Invoice/AutoEmail", data, function (text) {
                                                                                    var data = JSON.parse(text);

                                                                                    if (!data.hasOwnProperty("error")) {

                                                                                    }
                                                                                    else {
                                                                                        webix.message(data.error, "error");
                                                                                    }
                                                                                });
                                                                        }
                                                                    });

                                                            }
                                                            form.enable();
                                                            form.hideProgress();
                                                            $$("btnCancel").callEvent("onClick");
                                                            webix.message("Ký hóa đơn thành công !", "success");
                                                        }
                                                        else {
                                                            form.enable();
                                                            form.hideProgress();
                                                            webix.message(obj.error, "error");
                                                        }

                                                    }
                                                });
                                        }
                                    }
                                },
                                click: function () {
                                    this.callEvent("onClick");

                                }
                            },
                            {
                                view: "button", id: "btnCancel", shortcut: "esc", label: "Hủy (ESC)", type: "danger", align: "center",
                                width: 80,
                                on: {
                                    onClick: function () {
                                        $$("signEasyCA").close();
                                    }
                                },
                                click: function () {
                                    this.callEvent("onClick");
                                }
                            },
                            {}
                        ]
                    }
                ]
            }
        },
        setEditMode: function (mode) {
            editmode = mode;
        },
        initUI: initUI
    };

});
define('views/forms/signEasyCAXoabo',["app"], function (app) {
    var editmode = 0;
    var item;
    var dataCert;
    function initUI(data, cert) {
        item = data;
        dataCert = cert;
    }
    return {
        $ui: {
            view: "window",
            modal: true,
            id: "signEasyCAXoabo",
            css: "signEasyCAXoabo",
            position: "center",
            move: true,
            head: false,
            minWidth: 350,
            // height: 100,
            body: {
                view: "form",
                id: "signEasyCAXoabo-frm",
                elementsConfig: {
                    labelWidth: 60
                },
                elements: [
                    {
                        view: "text", type: "password", name: "pin_Code", id: "pinCode", label: "Mã pin", required: true,
                        invalidMessage: "Bạn phải nhập mã pin"
                    },
                    // {
                    //     view: "text", name: "username", id: "username", label: "Username", required: true,
                    //     invalidMessage: "Bạn phải nhập Username"
                    // },
                    // {
                    //     view: "text", type: "password", name: "password", id: "password", label: "Password", required: true,
                    //     invalidMessage: "Bạn phải nhập Password"
                    // },
                    {
                        cols: [
                            {},
                            {
                                shortcut: "F10", view: "button", label: "Nhận (F10)", type: "form", align: "center", width: 80,
                                on: {
                                    onClick: function () {
                                        if ($$("signEasyCAXoabo-frm").validate()) {

                                            var form = $$("signEasyCAXoabo");
                                            var param = {
                                                password: dataCert.pass,
                                                username: dataCert.username,
                                                pin: $$("pinCode").getValue(),
                                                InvoiceXmlData: item.InvoiceXmlData,
                                                id: item.inv_InvoiceAuth_id,
                                                so_serial: dataCert.so_serial
                                            }

                                            webix.extend(form, webix.ProgressBar);
                                            form.disable();
                                            form.showProgress();
                                            var url = app.config.host + "/Token/SignXmlEasyCA";

                                            webix.ajax()
                                                .headers({ 'Content-type': 'application/json' })
                                                .post(url, param, {
                                                    error: function (text, data, XmlHttpRequest) {
                                                        form.enable();
                                                        form.hideProgress();
                                                        webix.message(text);
                                                    },
                                                    success: function (text, data, XmlHttpRequest) {

                                                        var obj = JSON.parse(text);
                                                        if (!obj.hasOwnProperty("error")) {

                                                            var parameters = item;
                                                            parameters.InvoiceXmlData = obj.InvoiceXmlData;
                                                            parameters.serialNumber = dataCert.so_serial;

                                                            webix.ajax()
                                                                .headers({ "Content-Type": "application/json" })
                                                                .post(app.config.host + "/Invoice/SaveInvoiceXoaBo", parameters,
                                                                {
                                                                    error: function (text, data, XmlHttpRequest) {
                                                                        var form = $$("signEasyCAXoabo");
                                                                        form.enable();
                                                                        form.hideProgress();
                                                                        webix.message(text);
                                                                    },
                                                                    success: function (text, data, XmlHttpRequest) {
                                                                        var result = JSON.parse(text);

                                                                        if (result.hasOwnProperty("error")) {
                                                                            webix.message({ type: "error", text: result["error"] });
                                                                        }
                                                                        else {
                                                                            webix.$$("chukyso-win").close();
                                                                        }
                                                                        var form = $$("signEasyCAXoabo");
                                                                        form.enable();
                                                                        form.hideProgress();

                                                                        $$("signEasyCAXoabo").close();
                                                                        var form = webix.$$("chukyso-form");
                                                                        form.close();

                                                                        webix.message("Xóa bỏ hóa đơn thành công !", "success");
                                                                    }

                                                                    // error: function (text) {
                                                                    //     var result = JSON.parse(text);

                                                                    //     if (result.hasOwnProperty("error")) {
                                                                    //         webix.message({ type: "error", text: result["error"] });
                                                                    //     }
                                                                    //     else {
                                                                    //         webix.$$("chukyso-win").close();
                                                                    //     }
                                                                });
                                                        }
                                                        else {
                                                            form.enable();
                                                            form.hideProgress();
                                                            webix.message(obj.error, "error");
                                                        }

                                                    }
                                                });
                                        }
                                    }
                                },
                                click: function () {
                                    this.callEvent("onClick");

                                }
                            },
                            {
                                view: "button", id: "btnCancel", shortcut: "esc", label: "Hủy (ESC)", type: "danger", align: "center",
                                width: 80,
                                on: {
                                    onClick: function () {
                                        $$("signEasyCAXoabo").close();
                                        var form = webix.$$("chukyso-form");
                                        form.enable();
                                        form.hideProgress();
                                    }
                                },
                                click: function () {
                                    this.callEvent("onClick");
                                }
                            },
                            {}
                        ]
                    }
                ]
            }
        },
        setEditMode: function (mode) {
            editmode = mode;
        },
        initUI: initUI
    };

});
define('views/forms/sqltoolchoky',["app"], function (app) {
    var editmode = 0;
    var item;
    function initUI(obj) {
        item = obj;
    }
    return {
        $ui: {
            view: "window",
            modal: true,
            id: "SqlTool",
            position: "center",
            head: "Chuyển trạng thái hóa đơn",
            move: true,
            height: 500,
            minWidth: 500,
            body: {
                view: "form",
                id: "SqlTool-frm",
                elementsConfig: {
                    labelWidth: 100
                },
                elements: [
                    {
                        view: "text", label: "Số hóa đơn", name: "so_hd",
                        id: "sohd", required: true, invalidMessage: "Số hóa đơn không được để trống",
                        attributes: { maxlength: 7 },
                        on: {
                            onChange: function (newv, oldv) {
                                newv = newv.padStart(7, "0");
                                this.setValue(newv);
                            },
                            onKeyPress: function (code, e) {
                                if ((code < 48 || code > 57) && code != 8 && code != 9) {
                                    return webix.html.preventEvent(e);
                                }
                            }
                        }
                    },
                    {
                        view: "text", name: "mau_so", id: "mauso", label: "Mẫu số", required: true,
                        invalidMessage: "Mẫu số hóa đơn không được để trống"
                    },
                    {
                        view: "text", name: "ky_hieu", id: "kyhieu", label: "Ký hiệu", required: true,
                        invalidMessage: "Ký hiệu hóa đơn không được để trống"
                    },
                    {
                        cols: [
                            {},
                            {
                                shortcut: "F10", view: "button", label: "Thực hiện (F10)", type: "form", align: "center", width: 120,
                                on: {
                                    onClick: function () {
                                        if ($$("SqlTool-frm").validate()) {
                                            var form = $$("SqlTool");
                                            var item = $$("SqlTool-frm").getValues();

                                            webix.extend(form, webix.ProgressBar);
                                            form.disable();
                                            form.showProgress();
                                            var url = app.config.host + "/Invoice/RollBackInvoice";

                                            webix.ajax()
                                                .headers({ 'Content-type': 'application/json' })
                                                .post(url, item, {
                                                    error: function (text, data, XmlHttpRequest) {
                                                        form.enable();
                                                        form.hideProgress();
                                                        webix.message(text);
                                                    },
                                                    success: function (text, data, XmlHttpRequest) {
                                                        var obj = JSON.parse(text);
                                                        if (!obj.hasOwnProperty("error")) {
                                                            $$("btnCancel").callEvent("onClick");
                                                            webix.message("Đã thực hiện xong !", "success");
                                                        }
                                                        else {
                                                            webix.message(obj.error, "error");
                                                        }
                                                        form.enable();
                                                        form.hideProgress();
                                                    }
                                                });
                                        }
                                    }
                                },
                                click: function () {
                                    this.callEvent("onClick");

                                }
                            },
                            {
                                view: "button", id: "btnCancel", shortcut: "esc", label: "Hủy bỏ (ESC)", type: "danger", align: "center",
                                width: 120,
                                on: {
                                    onClick: function () {
                                        $$("SqlTool").close();
                                    }
                                },
                                click: function () {
                                    this.callEvent("onClick");
                                }
                            },
                            {}
                        ]
                    }
                ]
            }
        },
        setEditMode: function (mode) {
            editmode = mode;
        },
        initUI: initUI
    };

});
define('views/forms/templatewindow',[
	"app",
	"locale",
	"models/user",
	"views/forms/editwindow",
	"views/forms/selectwindow"
],function(app,_,user,editwindow,selectwindow){
	var editmode = 0;	
    var tables = [];

	var windowno = app.path[1].params[0];
    var col=[];
	var rw =[];					
	var el = [];
	var head_name=[];
	var head;
	var url = app.config.host + "/api/System/GetAllByWindowNo?window_id=" + windowno;
		    
	return {		
		$ui:{
			view:"window", modal:true, id:"window-win", position:"center",
			//width:800,
			head:"Thông tin khách hàng",
			//fullscreen:true,			
			body:{
                paddingY:10, 
                paddingX:10, 
                view:"form", 
				id:"window-form", 
				complexData:true,
				margin:0,
				borderless:true,
                elements:el				
			}			
		},	
		initUI: function(windowconfig) {
			
			var rp = windowconfig;
			var rows_max = rp['data'][0]['rows_max'];
			var vc_window = rp["data"][0];
			var tabs = vc_window.Tabs;

			var win = $$(vc_window.window_id);

			if (typeof win.showProgress === "undefined")
				webix.extend(win, webix.ProgressBar);
			
			el = [];
			col = [] ;			

			if (vc_window.width==null && vc_window.height==null){
				win.config.fullscreen = true;				
			}

			if (vc_window.after_save!=null){
				win.config.after_save = vc_window.after_save;
			}

			var layoutdetail = vc_window.layoutdetail;
			webix.ui(JSON.parse(layoutdetail),$$("window-form"));

			var fields = rp['data'][0]['Tabs'][0]['Fields'];

			for(var i=0;i<fields.length;i++){
				
				var field = fields[i];				
				
				if (field.hidden == true){
					continue;
				}

				var row = field.row;

				var item = {
					view: field.type_editor, 
					name: field.column_name,
					label: _(field.column_name), 
					id: field.column_name+"_"+rp['data'][0]['Tabs'][0]["tab_table"],
					width: field.width,
					labelPosition: field.label_position,
					labelWidth: field.label_width,
					format: field.format,
					value_change: field.value_change,
					fieldExpression: field.field_expression,
					data_width: field.data_width,
					column_type: field.column_type,
					on:{
						
					}
				};

				if (field.height!=null){
					if (field.height!=0){
						item.height = field.height;
					}
				}

				if (field.caption!=null){
					item.label = _(field.caption);
				}				

				if (field.read_only == "C"){
					item.readonly = true;
				}
				
				if (item.view == "combo"){
					item.options = app.config.host + "/System/GetDataByReferencesId?id=" + field.ref_id;
				}						

				if (item.view == "checkbox"){
					if (field.label_position == "right"){
						item.labelRight = _(field.column_name) ;
						item.label = "";							
					}

					if (field.column_type == "char"){
						item.checkValue = "C";
						item.uncheckValue = "K";
					}

					if (field.column_type == "tinyint"){
						item.checkValue = "1";
						item.uncheckValue = "0";
					}
				}

				if (item.view == "autonumeric"){
					item.inputAlign ="right";
				}

				if (item.view == "treesuggest"){
					
					//item.REF_ID = field.REF_ID.toString();
					var listColumns = JSON.parse(field.list_column);

					for(var v=0;v<listColumns.length;v++){
						listColumns[v].header =_(listColumns[v].id);
					}
					
					item.view = "combo";
					item.options = {
						view: "treesuggest",
						textValue: field.display_field,
						url: {
							$proxy:true,
							load:function(view, callback, params){
									var url = app.config.host + "/api/System/GetDataByReferencesId?id=" + view.config.refid;

									webix.ajax(url, function(text){
										var json = JSON.parse(text);
										var data = listToTree(json);
										view.parse(data,"json");
									});
									
							}
						},
						body: {
							columns: listColumns,
							refid: field.ref_id,
							filterMode:{
								level:false,
								showSubItems:false
							}						
						}
					};

					item.on.onKeyPress = function(code, e){
						if (e.code == "F4"){
							alert("Moi");
						}
					};
				}

				if (item.view == "gridcombo"){
					
					var listColumns = JSON.parse(field.list_column);

					for(var v=0;v<listColumns.length;v++){
						listColumns[v].header =_(listColumns[v].id);
					}
					
					item.view = "combo";
					item.options = {
						view: "gridsuggest",
						url: app.config.host + "/System/GetDataByReferencesId?id=" + field.ref_id,
						body: {
							columns: listColumns,
							refid: field.REF_ID,
							textValue: field.display_field											
						}
					};

					item.on.onKeyPress = function(code, e){
						if (e.code == "F4"){
							alert("Moi");
						}
					};
				}

				if (item.view == "gridsuggest"){
					var listColumns = JSON.parse(field.list_column);

					for(var v=0;v<listColumns.length;v++){
						listColumns[v].header =_(listColumns[v].id);
					}

					item.view = "text";
					item.suggest = {
						view: "gridsuggest",
						value_suggest: field.value_suggest,
						body:{
							columns:listColumns,
							refid: field.ref_id,
							datatype:"json",
							dataFeed: function(filtervalue, filter){
								if(filtervalue.length<3) return;

								var refid = this.config.refid;
								var pathUrl = app.config.host + "/System/GetDataByReferencesId?id=" + refid;
								var urldata = "filtervalue="+encodeURIComponent(filtervalue);
								
								this.load(pathUrl+"&"+urldata, this.config.datatype);
							},
							
						},
						on: {
							onValueSuggest: function(obj){
								var master = $$(this.config.master);

								if (master.config.fieldExpression!=null){
									
									var win = master.getTopParentView();
									var form = win.getChildViews()[1];
									var parentItem = form.getValues();

									var fields = master.config.fieldExpression.split(';');

									for(var i=0;i<fields.length;i++){
										var field = fields[i].replace("{","").replace("}","");
										var array = field.split(":");

										parentItem[array[1]] = obj[array[0]];
									}

									form.setValues(parentItem);
								}

								if (this.config.value_suggest!=null){								
									var fn = Function("obj","id",this.config.value_suggest);
									fn(obj,this.config.id);
								}
							}							
						}
					};

					item.on.onKeyPress = function(code, e){
						if (e.code == "F2"){
							var suggest = $$(this.config.suggest);
							var refid = suggest.config.body.refid;

							suggest.hide();

							var sql = "SELECT a.*,b.window_id as WINDOWNO FROM wb_references a INNER JOIN wb_window b ON a.wb_window_id=b.wb_window_id  WHERE a.wb_references_id='"+refid +"'";
							var url = app.config.host + "/System/ExecuteQuery?sql=" + sql;

							var win = this.getTopParentView();
							var form = win.getChildViews()[1];

							var editorId = this.config.id;
							var formId = form.config.id;
							
							var a= webix.ajax(url);
							var b= this.config.suggest;
							var c = this.config.id;
							var d = this.config.fieldExpression;
							var e = editorId;
							var f = formId;
							

							webix.promise.all([a,b,c,d,e,f]).then(function(results){
								var res_a = results[0].json();
								var suggest = $$(results[1]);								

								suggest.hide();

								var url = app.config.host + "/System/GetConfigWinByNo?id="+ res_a[0]["WINDOWNO"] ;

								var ajax = webix.ajax();
								ajax.master = {
									searchId : results[2],
									fieldExpression: d,
									valueField: res_a[0]["value_field"],
									formId: f,
									editorId:e
								};

								ajax.get(url,function(text){
									var windowconfig = JSON.parse(text);
									var txtSearch = $$(this.searchId);

									var win = txtSearch.$scope.ui(selectwindow.$ui);
									
									win.config.valueField = this.valueField;
									win.config.fieldExpression = this.fieldExpression;
									win.config.formId = this.formId;
									win.config.editorId = this.editorId;

									selectwindow.initUI(windowconfig);

									win.getHead().setHTML(windowconfig.data[0].window_name);
									win.show();

								});


							});


							var win = this.$scope.ui(selectwindow.$ui);
							win.show();							
						}

						if (e.code == "F4" || e.code == "F3"){
							var suggest = $$(this.config.suggest);
							var refid = suggest.config.body.refid;

							var sql = "SELECT a.*,b.window_id as WINDOWNO FROM wb_references a INNER JOIN wb_window b ON a.wb_window_id=b.wb_window_id  WHERE a.wb_references_id='"+refid +"'";
							var url = app.config.host + "/System/ExecuteQuery?sql=" + sql;

							var win = this.getTopParentView();
							var form = win.getChildViews()[1];

							var editorId = this.config.id;
							var formId = form.config.id;

							var ajax = webix.ajax();
							
							ajax.master = {
								editorId: editorId,
								formId: formId,
								fieldExpression: this.config.fieldExpression,
								editmode: e.code == "F3" ? 2 : 1,
								editorvalue: this.getValue(),
								suggest: this.config.suggest
							};							

							ajax.get(url,function(text){
								var json = JSON.parse(text);
								
								if (json.length>0){

									json[0].editorId = this.editorId;
									json[0].formId = this.formId;
									json[0].fieldExpression = this.fieldExpression;
									json[0].editmode = this.editmode;
									json[0].editorvalue = this.editorvalue;
									json[0].suggest = this.suggest;

									var windowno = json[0].WINDOWNO;					

									var url = app.config.host + "/api/System/GetAllByWindowNo?window_id="+windowno ;
									var a = webix.ajax(url);
									url = app.config.host +"/api/System/GetDataByReferences?id="+json[0].id+"&value_field=" + this.editorvalue;
									var b = webix.ajax(url);
									var c= this.editmode;
									var d = json[0];

									webix.promise.all([a,b,c,d]).then(function(results){
										
										var windowconfig = results[0].json();
										var res_b = results[1].json();
										var mode = results[2];
										var master = results[3];

										var vc_window = windowconfig["data"][0];

										if (mode == 1){
											editwindow.$ui.id = vc_window.window_id;
											editwindow.$ui.editorId = master.editorId;
											editwindow.$ui.valueField = master.value_field;
											editwindow.$ui.fieldExpression = master.fieldExpression;
											editwindow.$ui.formId = master.formId;

											var win = webix.ui(editwindow.$ui);            
											
											editwindow.initUI(windowconfig);
											editwindow.setEditMode(mode);
											editwindow.setValues(null,windowconfig);
											
											$$(master.suggest).hide();
											win.show();
										}
										else {

											if (res_b.length == 0){
												webix.alert({
													title: "Thông báo",
													text: "Không tìm thấy dữ liệu"
												});

												return;
											}

											var ajax = webix.ajax();
											
											ajax.master = {
												master: master,
												vc_window: vc_window												
											};

											var url = app.config.host + "/api/System/GetDataById?window_id="+ vc_window.window_id + "&id="+res_b[0].doc_id;

											ajax.get(url,function(text){
												var json = JSON.parse(text);
												var data = json.data[0];

												var vc_window = this.vc_window;
												var master = this.master;

												editwindow.$ui.id = vc_window.window_id;
												editwindow.$ui.editorId = master.editorId;
												editwindow.$ui.valueField = master.value_field;
												editwindow.$ui.fieldExpression = master.fieldExpression;
												editwindow.$ui.formId = master.formId;

												var win = webix.ui(editwindow.$ui);            
												
												editwindow.initUI(windowconfig);
												editwindow.setEditMode(2);
												editwindow.setValues(data,windowconfig);
												
												$$(master.suggest).hide();
												win.show();

											});
										}
									});									
								}
							});

							
						}
					};
				}

				if (item.value_change!=null || field.column_type == "nvarchar" || field.column_type == "varchar" || field.column_type == "char"){
					item.on.onChange = function(newv,oldv){
							var data_width = this.config.data_width;

							if (data_width< newv.length){
								webix.message("Số lượng ký tự tối đa là " + data_width.toString());
								return;
							}

							if (this.config.value_change!=null){
								
								
								var fn = Function("newv","oldv","id",this.config.value_change);
								fn(newv,oldv,this.config.id);
							}
						}
				}
				
				webix.ui(item,$$(item.id));
				//el[row-1].cols.push(item);
								
			}

			if (vc_window.window_type == "MasterDetail"){

				var cells = [];

                for(var i=0;i<tabs.length;i++){
                    var tab = tabs[i];

                    if (tab.TAB_TYPE == "Master"){
                        continue;
                    }

                    var subCols = [];

                    for(var j=0;j<tab.Fields.length;j++){
                        var field = tab.Fields[j];

                        var subCol = {
                            id: field.column_name, 
							header: field.caption!=null ? _(field.caption) : _(field.column_name),
							editor: field.type_editor,
							hidden: field.hidden,
							value_change: field.value_change
						};
						

                        if (field.column_type == "date" || field.column_type == "datetime" ){
                            subCol.format = function(text) {
                                var format = webix.Date.dateToStr("%d/%m/%Y");
                                text = removeTimeZoneT(text);                            
                                return format(text);
                            };
						}

						if (field.column_type == "decimal"){
							subCol.css = { "text-align": "right" };
							subCol.format = webix.Number.numToStr({
												groupDelimiter:",",
												groupSize:3,
												decimalDelimiter:".",
												decimalSize:0
											});
						}
						
						
                        
                        if (field.column_width == null){
                            subCol.fillspace = true;
                        }
                        else {
                            subCol.width = field.column_width;
						}

						if (field.type_editor == "combo"){
							subCol.options = app.config.host + "/System/GetDataByReferencesId?id=" + field.ref_id
						}

						if (field.type_editor == "datepicker"){
							subCol.editor = "date";
						}
						
						if (field.type_editor == "treesuggest"){
							var listColumns = JSON.parse(field.list_column);

							for(var v=0;v<listColumns.length;v++){
								listColumns[v].header =_(listColumns[v].id);
							}
							
							var popup = webix.ui({
								view:"treesuggest",								
								body:{
									columns: listColumns,
									refid: field.ref_id,
									url: {
										$proxy:true,
										load:function(view, callback, params){
												var url = app.config.host + "/System/GetDataByReferencesId?id=" + view.config.refid;

												webix.ajax(url, function(text){
													var json = JSON.parse(text);
													var data = listToTree(json);
													view.parse(data,"json");
												});
												
										}
									},
									filterMode:{
										level:false,
										showSubItems:false
									}	
								}
							});											

							subCol.popup = popup;
							subCol.editor = "combo";
							
						}

						if (field.type_editor == "gridcombo"){
							var listColumns = JSON.parse(field.list_column);

							for(var v=0;v<listColumns.length;v++){
								listColumns[v].header =_(listColumns[v].id);
							}
							
							var popup = webix.ui({
								view:"gridsuggest",	
								textValue: field.display_field,
								body:{
									columns: listColumns,
									refid: field.ref_id,
									textValue: field.display_field,
									tableId: "edit_"+tab.tab_table,
									url: app.config.host + "/System/GetDataByReferencesId?id=" + field.ref_id								
								}
							});											

							subCol.popup = popup;
							subCol.editor = "combo";
							
							
						}

						if (field.type_editor == "gridsuggest"){
							var listColumns = JSON.parse(field.list_column);

							for(var v=0;v<listColumns.length;v++){
								listColumns[v].header =_(listColumns[v].id.toUpperCase());
							}

							subCol.editor = "text";
							subCol.suggest = {
								view: "gridsuggest",
								value_suggest: field.value_suggest,
								fieldExpression: field.field_expression,
								displayField: field.display_field,
								tableId: "edit_"+tab.tab_table,
								columnName:field.column_name,
								body:{
									columns:listColumns,
									refid: field.ref_id,									
									datatype:"json",
									dataFeed: function(filtervalue, filter){
										if(filtervalue.length<3) return;

										var refid = this.config.refid;
										var pathUrl = app.config.host + "/System/GetDataByReferencesId?id=" + refid;
										var urldata = "filtervalue="+encodeURIComponent(filtervalue);
										
										this.load(pathUrl+"&"+urldata, this.config.datatype);
									}
								},
								on: {
									onValueSuggest: function(obj){
										
										if (this.config.fieldExpression!=null){
											var table = $$(this.config.tableId);
											var selectedItem = table.getSelectedItem();

											var fields = this.config.fieldExpression.split(';');

											for(var i=0;i<fields.length;i++){
												var field = fields[i].replace("{","").replace("}","");
												var array = field.split(":");

												selectedItem[array[1]] = obj[array[0]];
											}

											table.updateItem(selectedItem.id,selectedItem);
										}

										if (this.config.value_suggest!=null){								
											var fn = Function("obj","id",this.config.value_suggest);
											fn(obj,this.config.id);
										}
									}
									
								}
							}

							
						}
                        
                        subCols.push(subCol);
                    }

                    if (tab.tab_type=="Detail"){
                        var item = {
                            header: tab.tab_name,
                            select: "cell",
                            body: {
								rows:[
									{
										view:"toolbar",
										height:25,
										cols:[
											{
												view:"icon",
												icon:"plus",
												on: {
													onItemClick: function(id,e){
														var parentView = this.getParentView().getParentView();
														var childViews = parentView.getChildViews();

														for(var i=0;i<childViews.length;i++){
															var childview = childViews[i];

															if (childview.config.view=="datatable"){
																var table = childview;

																var item = {
																	id: webix.uid()
																};

																var vc_window = windowconfig['data'][0];																
																var tabs = vc_window.Tabs;															

																for(var i=0;i<tabs.length;i++){
																	var tab = tabs[i];
																	if (tab.tab_type == "Detail"){
																		var fields=tab.Fields;

																		for(var j=0;j<fields.length;j++){
																			var field = fields[j];

																			if (field.column_name == "ma_dvcs"){
																				item[field.column_name] = user.getDvcsID();
																			}																			
																			
																			if (field.default_value!=null){
																				var defaultValue = field.default_value.toString();

																				if (defaultValue.startsWith("@Default=")){
																					item[field.column_name] = defaultValue.replace("@Default=","");
																				}
																				
																				if (defaultValue.startsWith("@JS=")){
																					var fn = Function(defaultValue.replace("@JS=",""));
																					item[field.column_name] = fn();
																				}
																			}
																		}
																	}
																}								
																

																table.add(item);

																table.select(item.id, table.config.columns[0].id, false);
																table.edit({row: item.id, column: table.config.columns[0].id});

																break;
															}
														}
														
													}
												}
											},
											{
												view:"icon",
												icon:"minus",
												on: {
													onItemClick: function(id,e){
														var parentView = this.getParentView().getParentView();
														var childViews = parentView.getChildViews();

														for(var i=0;i<childViews.length;i++){
															var childview = childViews[i];

															if (childview.config.view=="datatable"){
																var table = childview;

																table.editStop();

																var item = table.getSelectedItem();
												
																if (!webix.isUndefined(item)){
																	table.remove(item.id);
																	table.clearSelection();
																	return;
																}

																var editor = table.getEditState();

																if (!webix.isUndefined(editor)){
																	table.remove(editor.row);
																	table.clearSelection();
																	return;
																}

																break;
															}
														}
														
													}
												}
											}
										]
									},
									{
										view: "datatable",
										id:"edit_"+tab.tab_table,
										tab_table: tab.tab_table,
										tab_id: tab.tab_id,
										editable:true,
										select: "cell",
										select_change: tab.select_change,
										cell_editstop: tab.cell_editstop,
										columns: subCols,
										on:{
											onAfterEditStop:function(state, editor, ignore){
												
												if (this.config.cell_editstop!=null){
													var fn = Function("columnId","tableId",this.config.cell_editstop);
													fn(editor.config.id,this.config.id);
												}

												if (editor.config.value_change!=null){
													var selectedItem = null;

													if (typeof editor.getPopup === "function") { 
														var popup = editor.getPopup();
													
														if (popup!=null){
															var list = popup.getList();

															if (list!=null){
																selectedItem = list.getSelectedItem();
															}
														}
													}
													
													var fn = Function("newv","oldv","id","selectedItem",editor.config.value_change);
													fn(state.value,state.old,editor.config.id,selectedItem);
												}

											},
											onKeyPress: function(code,e){
												var table = this;

												if (e.key == "F8"){
													var toolbar = this.getParentView().getChildViews()[0];
													var btnMinus = toolbar.getChildViews()[1];

													btnMinus.callEvent("onItemClick");
												}

												if (e.key == "F2"){

													var editor = table.getEditState();

													if (editor === false) return;

													var suggest = $$(editor.config.suggest);
													var refid = suggest.config.body.refid;

													var sql = "SELECT a.*,b.window_id as WINDOWNO FROM wb_references a INNER JOIN wb_window b ON a.wb_window_id=b.wb_window_id  WHERE a.wb_references_id='"+refid +"'";
													var url = app.config.host + "/System/ExecuteQuery?sql=" + sql;

													var a= webix.ajax(url);
													var b= editor.config.suggest;
													var c = table.config.id;
													var d = suggest.config.fieldExpression;
													var e = editor.config.id;
													var f = suggest.config.displayField;
													
													webix.promise.all([a,b,c,d,e,f]).then(function(results){
														var res_a = results[0].json();
														var suggest = $$(results[1]);								

														suggest.hide();

														var url = app.config.host + "/System/GetConfigWinByNo?id="+ res_a[0]["WINDOWNO"] ;

														var ajax = webix.ajax();
														ajax.master = {
															tableId : results[2],
															fieldExpression: d,
															valueField: res_a[0]["value_field"],
															editorId:null,
															columnName: e,
															displayField:f
														};

														ajax.get(url,function(text){
															var windowconfig = JSON.parse(text);
															var table = $$(this.tableId);

															var win = table.$scope.ui(selectwindow.$ui);
															
															win.config.valueField = this.valueField;
															win.config.fieldExpression = this.fieldExpression;
															win.config.tableId = this.tableId;
															win.config.editorId = null;
															win.config.columnName = this.columnName;
															win.config.displayField = this.displayField;

															selectwindow.initUI(windowconfig);
															
															win.getHead().setHTML(windowconfig.data[0].window_name);
															win.show();

														});


													});


													var win = this.$scope.ui(selectwindow.$ui);
													win.show();
												}

												if (e.key == "F4" || e.key == "F3"){
													var editor = table.getEditState();

													if (editor === false){
														var toolbar = this.getParentView().getChildViews()[0];
														var btnPlus = toolbar.getChildViews()[0];

														btnPlus.callEvent("onItemClick");

													}

													if (!webix.isUndefined(editor)){
														var suggest = $$(editor.config.suggest);
														var refid = suggest.config.body.refid;

														var sql = "SELECT a.*,b.WINDOW_ID as WINDOWNO FROM VC_REFERENCES a INNER JOIN VC_WINDOW b ON a.WINDOW_ID=b.id  WHERE a.id='"+refid +"'";
														var url = app.config.host + "/api/System/ExecuteQuery?sql=" + sql;

														var tableId = table.config.id;
														var columnName = editor.config.id;

														var ajax = webix.ajax();
														
														ajax.master = {
															editorId: null,
															tableId: tableId,
															fieldExpression: suggest.config.fieldExpression,
															columnName: columnName,
															editmode: e.key == "F3" ? 2 : 1,
															editorvalue: editor.getValue(),
															suggest: editor.config.suggest
														};

														ajax.get(url,function(text){
															var json = JSON.parse(text);
															
															if (json.length>0){

																json[0].editorId = this.editorId;
																json[0].tableId = this.tableId;
																json[0].fieldExpression = this.fieldExpression;
																json[0].columnName = this.columnName;
																json[0].editmode = this.editmode;
																json[0].editorvalue = this.editorvalue;
																json[0].suggest = this.suggest;

																var windowno = json[0].WINDOWNO;															

																var url = app.config.host + "/api/System/GetAllByWindowNo?window_id="+windowno ;
																var a = webix.ajax(url);
																url = app.config.host +"/api/System/GetDataByReferences?id="+json[0].id+"&value_field=" + this.editorvalue;
																var b = webix.ajax(url);
																var c= this.editmode;
																var d = json[0];

																webix.promise.all([a,b,c,d]).then(function(results){
										
																	var windowconfig = results[0].json();
																	var res_b = results[1].json();
																	var mode = results[2];
																	var master = results[3];

																	var vc_window = windowconfig["data"][0];

																	if (mode == 1){
																		editwindow.$ui.id = vc_window.window_id;
																		editwindow.$ui.editorId = master.editorId;
																		editwindow.$ui.valueField = master.value_field;
																		editwindow.$ui.fieldExpression = master.fieldExpression;
																		editwindow.$ui.formId = master.formId;
																		editwindow.$ui.tableId = master.tableId;
																		editwindow.$ui.columnName = master.columnName;

																		var win = webix.ui(editwindow.$ui);            
																		
																		editwindow.initUI(windowconfig);
																		editwindow.setEditMode(mode);
																		editwindow.setValues(null,windowconfig);
																		
																		$$(master.suggest).hide();
																		win.show();
																	}
																	else {
																		if (res_b.length == 0){
																			webix.alert({
																				title: "Thông báo",
																				text: "Không tìm thấy dữ liệu"
																			});

																			return;
																		}
																		var ajax = webix.ajax();
																		
																		ajax.master = {
																			master: master,
																			vc_window: vc_window												
																		};

																		var url = app.config.host + "/api/System/GetDataById?window_id="+ vc_window.window_id + "&id="+res_b[0].doc_id;

																		ajax.get(url,function(text){
																			var json = JSON.parse(text);
																			var data = json.data[0];

																			var vc_window = this.vc_window;
																			var master = this.master;

																			editwindow.$ui.id = vc_window.window_id;
																			editwindow.$ui.editorId = master.editorId;
																			editwindow.$ui.valueField = master.value_field;
																			editwindow.$ui.fieldExpression = master.fieldExpression;
																			editwindow.$ui.formId = master.formId;
																			editwindow.$ui.tableId = master.tableId;
																			editwindow.$ui.columnName = master.columnName;

																			var win = webix.ui(editwindow.$ui);            
																			
																			editwindow.initUI(windowconfig);
																			editwindow.setEditMode(2);
																			editwindow.setValues(data,windowconfig);
																			
																			$$(master.suggest).hide();
																			win.show();

																		});
																	}
																});																
															}
														});

														return;
													}
													
												}
											},
											onSelectChange:function(){
												var selectedItem = this.getSelectedId();
												
												if (this.config.select_change!=null){
													var fn = Function("selectedItem",this.config.select_change);
													fn(selectedItem);
												}
											}
										}
									}
								]
                                
                            }
                        };

                        cells.push(item);
                    }
				}
				
                var subview = {
                    borderless:true,
                    view:"tabview",
                    scrollX:true,
					cells: cells,
					tabbar:{
						width:200
					}					
				};

				if (vc_window.width!=null || vc_window.height!=null){
					subview.height = 250;
				}

				//el.push(subview);
				
				if (vc_window.row_tab!=null){
					el[vc_window.row_tab-1]=subview;
				}
				else {
					el.push(subview);
				}
				
            }
			
			var cols = [
				{},
				{ 
					shortcut:"F10",  
					view:"button", label:"Nhận", type:"form", align:"center", 
					width:100,
					on: {
						onClick: function() {
							var form = webix.$$("window-form");
							
							var item = form.getValues();
							
							var khData={};

							khData.windowid=String(rp['data'][0]['window_id']);
							khData.editmode=editmode;
							khData.data=[];

							var vc_window = rp['data'][0];

							if (vc_window.window_type == "MasterDetail"){
								
								var tabs = vc_window.Tabs;
								var details = [];

								for(var i=0;i<tabs.length;i++){
									var tab = tabs[i];

									if (tab.tab_type == "Detail"){
										var table = webix.$$("edit_"+tab.tab_table);
										
										details.push({
											tab_id: tab.tab_id,
											tab_table: tab.tab_table,
											data: table.serialize()
										});
									}
								}

								item["details"] = details;
							}							
							
							khData.data.push(item);
							
							this.getTopParentView().disable();
							this.getTopParentView().showProgress();
							
							webix.ajax()
								.headers({'Content-type':'application/json'})
								.post( app.config.host + "/System/Save", khData, function(text){									
							
									var json = JSON.parse(text);

									$$(json.windowid).enable();
									$$(json.windowid).hideProgress();
												
									if (!json.hasOwnProperty("error")){
										var after_save = $$(json.windowid).config.after_save;

										if (after_save!=null){
											var fn = Function("editmode","data",after_save);
											fn(editmode,json.data);
										}										

										$$(json.windowid).close();
										app.callEvent("dataChanged",[editmode,json.data]);
									}
									else {
										webix.message(json.error);
									}
									
									
								});	
							
						}
					},
					click:function(){								
						this.callEvent("onClick");							
											
					},
				},
				{ 
					view:"button", shortcut:"esc", label:"Hủy bỏ",align:"center",
					width:100,
					on:{
						onClick: function(){
							this.getTopParentView().close();
						}
					},
					click:function(){
						this.callEvent("onClick");
					}
				},
				{}
			];			
			
			/* el.push({
				margin:10,
				cols:cols
			}); */

			$$("window-form").addView({margin:10,cols:cols},$$("window-form").getChildViews().length);
			$$("window-form").$view.style.borderWidth = 0;
			//webix.ui(el, $$("window-form"));

			win.getHead().setHTML(windowconfig.data[0].window_name);
		},
		focusFirstElement:function(){
			var form = $$("window-form");
			form.focus(form.elements[0]);
		},	
		setEditMode: function(mode) {
			editmode = mode;
		},		
		setValues: function(item,winconfig,params){

			var form = webix.$$("window-form");
			var vc_window = winconfig['data'][0];

			if (item == null){
				var tabs = vc_window.Tabs;
				
				item = {};

				if (params!=null){
					item = params;
				}

                for(var i=0;i<tabs.length;i++){
                    var tab = tabs[i];
                    if (tab.tab_type == "Normal" || tab.tab_type == "Master"){
                        var fields=tab.Fields;

                        for(var j=0;j<fields.length;j++){
							var field = fields[j];
							
							if (field.column_name == "ma_dvcs"){
								item[field.column_name] = user.getDvcsID();
							}

							                            
                            if (field.default_value!=null){
                                var defaultValue = field.default_value.toString();

                                if (defaultValue.startsWith("@Default=")){
                                    item[field.column_name] = defaultValue.replace("@Default=","");
								}
								
								if (defaultValue.startsWith("@JS=")){
									var fn = Function(defaultValue.replace("@JS=",""));
									item[field.column_name] = fn();
								}
                            }
                        }
                    }
				}
				
				form.setValues(item);
			}
			else {

				form.setValues(item);	
				
				var tabs = vc_window.Tabs;

				for(var i=0;i<tabs.length;i++){
					var tab = tabs[i];

					if (tab.tab_type != "Detail")
					{
						var fields=tab.Fields;

						for(var j=0;j<fields.length;j++){
							var field = fields[j];
							
							if (field.column_type == "date" || field.column_type == "datetime"){
								item[field.column_name] = removeTimeZoneT(item[field.column_name])
								form.setValues(item);
							}														
							
						}							

						break;
					}				
					
				}

				if (vc_window.window_type == "MasterDetail"){
					

					for(var i=0;i<tabs.length;i++){
						var tab = tabs[i];

						if (tab.tab_type == "Master")
						{
							continue;
						}

						var table = webix.$$("edit_"+tab.tab_table);

						var url = app.config.host + "/System/GetDataDetailsByTabTable?window_id="+ vc_window.window_id
										+"&id="+item.id + "&tab_table="+tab.tab_table;
						table.clearAll();
						table.load(url);
						
					}
				}
				
			}
		},
		copyValues: function(item,winconfig){

			var form = webix.$$("window-form");
			var vc_window = winconfig['data'][0];
							

			if (vc_window.window_type == "MasterDetail"){
				var tabs = vc_window.Tabs;

				for(var i=0;i<tabs.length;i++){
					var tab = tabs[i];

					if (tab.tab_type == "Master")
					{
						continue;
					}

					var table = webix.$$("edit_"+tab.tab_table);

					var url = app.config.host + "/System/GetDataDetailsByTabTable?window_id="+ vc_window.window_id
									+"&id="+item.id + "&tab_table="+tab.tab_table;
					table.clearAll();
					table.load(url);
					
				}
			}

			var tabs = vc_window.Tabs;

			for(var i=0;i<tabs.length;i++){
				var tab = tabs[i];
				if (tab.tab_type == "Normal" || tab.tab_type == "Master"){
					var fields=tab.Fields;

					for(var j=0;j<fields.length;j++){
						var field = fields[j];

						if (field.column_name == tab.tab_table + "_id"){
							item[field.column_name] = null;
						}
						
						if (field.column_name == "ma_dvcs"){
							item[field.column_name] = user.getDvcsID();
						}

													
						if (field.default_value!=null){
							var defaultValue = field.default_value.toString();

							if (defaultValue.startsWith("@Default=")){
								item[field.column_name] = defaultValue.replace("@Default=","");
							}
							
							if (defaultValue.startsWith("@JS=")){
								var fn = Function(defaultValue.replace("@JS=",""));
								item[field.column_name] = fn();
							}
						}
					}
				}
			}

			form.setValues(item);
			
		}

	};

});
// define(["app", "locale"
// ], function (app, _) {
//     var editmode = 0;

//     var layout = {
//         id: "uploadAPI",
//         view: "uploader",
//         // upload: app.config.host + "/System/Save",
//         multiple: false,
//         on: {
//             onAfterFileAdd: function (upload) {

//                 var id = upload.context.rowid;
//                 var tabName = upload.context.tableName;

//                 var row = webix.$$(tabName).getItem(id);

//                 var file = new Blob([upload.file]);

//                 var reader = new FileReader();
//                 var type = upload.type;
//                 reader.onload = function () {

//                     var arrayBuffer = this.result,
//                         array = new Uint8Array(arrayBuffer);
//                     //binaryString = String.fromCharCode.apply(null, array);

//                     var array1 = Array.from(array);

//                     var data = {
//                         ten_file: upload.name,
//                         file_data: array1,
//                         loai_file: type,
//                         size: upload.size,
//                         size_text: upload.sizetext
//                     }
//                     if (tabName === "edit_inv_InvoiceAuthDetail") {
//                         row.upload_file = array1;
//                         row.ten_file = upload.name;
//                         row.file_size = upload.sizetext;
//                     }
//                     webix.$$(tabName).updateItem(id, row);
//                     webix.$$(tabName).refresh();

//                 }
//                 reader.readAsArrayBuffer(upload.file);

//             },
//             onBeforeFileAdd: function (item) {
//                 var type = item.type.toLowerCase();
//                 if (type != "jpg" && type != "png" && type != "pdf") {
//                     webix.message("Only PNG or JPG or PDF images are supported");
//                     return false;
//                 }
//                 if (item.size && item.size > 1000000) {
//                      webix.message("File tải lên phải nhỏ hơn 1 Mb", "debug");
//                     return false;
//                 }
//             },
//             onFileUpload: function (item) {

//             },
//             onFileUploadError: function (item) {
//                 webix.alert("Có lỗi xảy ra");
//             }
//         },
//         apiOnly: false
//     }
//     return {
//         $ui: layout,
//         setEditMode: function (mode) {
//             editmode = mode;
//         }
//     };

// });
define("views/forms/testuploader", function(){});

define('views/forms/tinhhinhsudung',["app", "locale", "models/user"], function (app, _, user) {
    var iData;
    function initUI(item) {
        iData = item;
        if (item.tokhai_thang == 1) {
            $$('kybc').setValue("Kỳ báo cáo: Tháng " + moment(item.tu_ngay).format("MM") + " năm " + moment(item.den_ngay).format("YYYY"));
        }
        if (item.tokhai_quy == 1) {
            $$('kybc').setValue("Kỳ báo cáo: Quý " + (Math.floor((item.tu_ngay.getMonth() / 3)) + 1) + " năm " + moment(item.den_ngay).format("YYYY"));
        }
        $$('tungay').setValue("( từ " + moment(item.tu_ngay).format("DD/MM/YYYY") + " đến " + moment(item.den_ngay).format("DD/MM/YYYY") + " )");
        $$('zmau312').setValue(item.mau_312);
        $$('zmau310').setValue(item.mau_310);
        $$('dataform').setValue(item);

        webix.ajax()
            .headers({ 'Content-type': 'application/json' })
            .post(app.config.host + "/Bcthsd/InfoDvcs", item, function (text) {
                var data = JSON.parse(text);

                if (!data.hasOwnProperty("error")) {
                    $$('tccanhan').setValue("[02] Tên tổ chức, cá nhân " + data.TEN_DVCS);
                    $$('mst').setValue("[03] Mã số thuế " + data.MS_THUE);
                }
                else {
                    webix.message(data.error, "error");
                }
            });

        webix.ajax()
            .headers({ 'Content-type': 'application/json' })
            .get(app.config.host + "/Bcthsd/GetInfoDonvi", function (text) {
                var data = JSON.parse(text);
                //console.log(data);
                if (!data.hasOwnProperty("error")) {
                    $$('nguoi_dai_dien').setValue(data.nguoi_dai_dien);
                    $$('nguoi_lap').setValue(data.nguoi_lap);
                    // $$('mst').setValue("[03] Mã số thuế " + data.MS_THUE);
                }
                else {
                    webix.message(data.error, "error");
                }
            });

        // webix.ajax()
        //     .headers({ 'Content-type': 'application/json' })
        //     .get(app.config.host + "/System/ExecuteQuery?sql=SELECT * FROM dmdvcs", function (text) {
        //         var data = JSON.parse(text);
        //         if (!data.hasOwnProperty("error")) {
        //             $$('nguoi_dai_dien').setValue(data.nguoi_dai_dien);
        //             // $$('mst').setValue("[03] Mã số thuế " + data.MS_THUE);
        //         }
        //         else {
        //             webix.message(data.error, "error");
        //         }
        //     });

        webix.ajax()
            .headers({ "Conten-type": "application/json" })
            .get(app.config.host + "/Bcthsd/GetTenFile", function (text) {
                var data = JSON.parse(text);
                if (item.tokhai_thang == 1) {
                    var filename = data.name + "-M" + item.thang + item.nam + "-L00";
                    $$('tenfile').setValue(filename);
                    return;
                }
                if (item.tokhai_quy == 1) {
                    var filename = data.name + "-Q" + item.quy + item.nam + "-L00";
                    $$('tenfile').setValue(filename);
                    return;
                }

            })
    }

    return {
        $ui: {
            view: "window",
            fullscreen: true,
            modal: true, id: "thsd-win", position: "center",
            move: true,
            css: "headformchil",
            head: {
                //view: "toolbar",
                // css: { "box-shadow": "0 -2px #3498db inset !important", "background": "#ffffff !important" },
                //css: { "background": "#e6f2ff !important" },
                // height: 25,
                cols: [
                    { gravity: 1, template: "", css: "headform" },
                    {
                        view: "icon", icon: "times", hotkey: "esc", click: function () {
                            $$("thsd-win").close();
                        }
                    }
                ]
            },
            //height:420,		
            body: {
                paddingY: 10,
                paddingX: 10,
                view: "form",
                id: "thsd-form",
                complexData: true,
                margin: 0,
                elements: [
                    {
                        rows: [
                            {
                                view: "label",
                                id: "dataform",
                                hidden: true
                            },
                            {
                                view: "label",
                                id: "tenfile",
                                hidden: true
                            },
                            {
                                view: "label",
                                label: "BÁO CÁO TÌNH HÌNH SỬ DỤNG HÓA ĐƠN (BC26/AC)",
                                css: { "font-weight": "bold", "font-size": "15px" },
                                inputWidth: 100,
                                align: "center"
                            },
                            {
                                view: "label",
                                id: "kybc",
                                name: "kybc",
                                label: "Kỳ báo cáo: Tháng ",
                                inputWidth: 100,
                                align: "center"

                            },
                            {
                                view: "label",
                                label: "Từ ngày: ",
                                id: "tungay",
                                inputWidth: 100,
                                align: "center"
                            },
                            {
                                view: "label",
                                label: "[02] Tên tổ chức, cá nhân ",
                                id: "tccanhan",
                                inputWidth: 100,
                                align: "left"
                            },
                            {
                                view: "label",
                                label: "[03] Mã số thuế ",
                                id: "mst",
                                inputWidth: 100,
                                align: "left"
                            },
                            {
                                cols: [
                                    {
                                        view: "checkbox",
                                        id: "zmau312",
                                        name: "zmau_312",
                                        label: "Mẫu 3.12 (Kỳ báo cáo cuối cùng)",
                                        labelWidth: 200
                                    },
                                    {
                                        view: "checkbox",
                                        id: "zmau310",
                                        name: "zmau_310",
                                        label: "Mẫu 3.10 (Chuyển địa điểm)",
                                        labelWidth: 200
                                    }
                                ]

                            },
                            {
                                id: "dataBC",
                                view: "datatable",
                                editable: true,
                                editaction: "dblclick",
                                select: true,
                                datafetch: 2,
                                loadahead: 15,
                                resizeColumn: true,
                                leftSplit: 5,
                                //drag: true,
                                columns: [
                                    { id: "stt", header: "<center>STT</center>", width: 50 },
                                    { id: "ma_loai", header: "<center>Mã loại hóa đơn</center>", width: 100 },
                                    { id: "ten_loai", header: "<center>Tên loại hóa đơn</center>", width: 160 },
                                    { id: "mau_hd", header: "<center>Mẫu hóa đơn</center>", width: 120 },
                                    { id: "ky_hieu", header: "<center>Ký hiệu</center>", width: 100 },
                                    {
                                        id: "ton_dau_ky", header: [
                                            {
                                                content: "columnGroup", closed: false, batch: "ton_dau",
                                                groupText: "Tổng số tồn đầu kỳ", colspan: 1
                                            },
                                            "Tổng số "], width: 150, format: webix.Number.numToStr({
                                                groupDelimiter: ",",
                                                groupSize: 3,
                                                decimalDelimiter: ".",
                                                decimalSize: 0
                                            }),
                                        css: { 'text-align': 'right' }
                                    },
                                    {
                                        id: "tu_so1", header: [
                                            {
                                                content: "columnGroup", closed: false, batch: "gr1",
                                                groupText: "Số tồn đầu kỳ", colspan: 2
                                            },
                                            "Từ số"]
                                    },
                                    { id: "den_so1", batch: "gr1", header: [null, "Đến số"] },
                                    {
                                        id: "tu_so2", header: [
                                            {
                                                content: "columnGroup", closed: false, batch: "gr2",
                                                groupText: "Số mua/phát hành trong kỳ", colspan: 2
                                            },
                                            "Từ số"]
                                    },
                                    { id: "den_so2", batch: "gr2", header: [null, "Đến số"] },
                                    {
                                        id: "tu_so3", header: [
                                            {
                                                content: "columnGroup", closed: false, batch: "gr3",
                                                groupText: "Tổng số sử dụng, xóa bỏ, mất, hủy", colspan: 3
                                            },
                                            "Từ số"]
                                    },
                                    { id: "den_so3", batch: "gr3", header: [null, "Đến số"] },
                                    {
                                        id: "cong", batch: "gr3", header: [null, "Cộng"], format: webix.Number.numToStr({
                                            groupDelimiter: ",",
                                            groupSize: 3,
                                            decimalDelimiter: ".",
                                            decimalSize: 0
                                        }),
                                        css: { 'text-align': 'right' }
                                    },
                                    {
                                        id: "sl_sd", header: [
                                            {
                                                content: "columnGroup", closed: false, batch: "gr4",
                                                groupText: "Đã sử dụng", colspan: 1
                                            },
                                            "Số lượng"], width: 150, format: webix.Number.numToStr({
                                                groupDelimiter: ",",
                                                groupSize: 3,
                                                decimalDelimiter: ".",
                                                decimalSize: 0
                                            }),
                                        css: { 'text-align': 'right' }
                                    },
                                    {
                                        id: "so_luong1", header: [
                                            {
                                                content: "columnGroup", closed: false, batch: "gr5",
                                                groupText: "Xóa bỏ", colspan: 2
                                            },
                                            "Số lượng"], width: 110, format: webix.Number.numToStr({
                                                groupDelimiter: ",",
                                                groupSize: 3,
                                                decimalDelimiter: ".",
                                                decimalSize: 0
                                            }),
                                        css: { 'text-align': 'right' }
                                    },
                                    { id: "so1", batch: "gr5", header: [null, "Số"] },
                                    {
                                        id: "so_luong2", header: [
                                            {
                                                content: "columnGroup", closed: false, batch: "gr6",
                                                groupText: "Mất", colspan: 2
                                            },
                                            "Số lượng"], width: 110, format: webix.Number.numToStr({
                                                groupDelimiter: ",",
                                                groupSize: 3,
                                                decimalDelimiter: ".",
                                                decimalSize: 0
                                            }),
                                        css: { 'text-align': 'right' }
                                    },
                                    { id: "so2", batch: "gr6", header: [null, "Số"] },
                                    {
                                        id: "so_luong3", header: [
                                            {
                                                content: "columnGroup", closed: false, batch: "gr7",
                                                groupText: "Hủy", colspan: 2
                                            },
                                            "Số lượng"], width: 110, format: webix.Number.numToStr({
                                                groupDelimiter: ",",
                                                groupSize: 3,
                                                decimalDelimiter: ".",
                                                decimalSize: 0
                                            }),
                                        css: { 'text-align': 'right' }
                                    },
                                    { id: "so3", batch: "gr7", header: [null, "Số"] },
                                    {
                                        id: "tu_so4", header: [
                                            {
                                                content: "columnGroup", closed: false, batch: "gr8",
                                                groupText: "Tồn cuối kỳ", colspan: 3
                                            },
                                            "Từ số"]
                                    },
                                    { id: "den_so4", batch: "gr8", header: [null, "Đến số"] },
                                    {
                                        id: "so_luong4", batch: "gr8", header: [null, "Số lượng"], format: webix.Number.numToStr({
                                            groupDelimiter: ",",
                                            groupSize: 3,
                                            decimalDelimiter: ".",
                                            decimalSize: 0
                                        }),
                                        css: { 'text-align': 'right' }
                                    }

                                ]
                            },
                            {
                                view: "fieldset",
                                label: "Thông tin đơn vị",
                                body: {
                                    rows: [
                                        {
                                            view: "text",
                                            id: "nguoi_dai_dien",
                                            name: "nguoi_dai_dien",
                                            //labelPosition: "top",
                                            label: "Người đại diện",
                                            // css: "mcls_readonly_text",
                                            labelWidth: 100,
                                            // readonly: true,
                                            width: 500
                                        },
                                        {
                                            cols: [
                                                {
                                                    id: "nguoi_lap",
                                                    view: "text",
                                                    name: "nguoi_lap",
                                                    //labelPosition: "top",
                                                    // css: "mcls_readonly_text",
                                                    labelWidth: 100,
                                                    label: "Người lập",
                                                    // readonly: true,
                                                    width: 500
                                                },
                                                {
                                                    id: "ngay_lap",
                                                    view: "datepicker",
                                                    name: "ngay_lap",
                                                    // css: "mcls_readonly_text",
                                                    value: new Date(),
                                                    label: "Ngày lập",
                                                    // readonly: true,
                                                    width: 500
                                                }
                                            ]
                                        }
                                    ]
                                }
                            },
                            {
                                margin: 10,
                                cols: [
                                    {},
                                    {
                                        shortcut: "F11", view: "button", icon: "refresh", type: "form", label: "Tải dữ liệu (F11)", align: "center", width: 120,
                                        on: {
                                            onClick: function () {
                                                var form = $$("thsd-win");
                                                webix.extend(form, webix.ProgressBar);
                                                form.disable();
                                                form.showProgress();
                                                webix.ajax()
                                                    .headers({ 'Content-type': 'application/json' })
                                                    .post(app.config.host + "/Bcthsd/BcTinhhinhsudung", $$('dataform').getValue(),
                                                    {
                                                        error: function (text, data, XmlHttpRequest) {
                                                            //webix.modalbox.hide(box);
                                                            form.enable();
                                                            form.hideProgress();
                                                            webix.message(text, "error");
                                                            // webix.alert({
                                                            //     title: "Lỗi !",
                                                            //     text: text,
                                                            //     type: "alert-error"
                                                            // });
                                                        },
                                                        success: function (text, data, XmlHttpRequest) {
                                                            form.enable();
                                                            form.hideProgress();
                                                            var data = JSON.parse(text);
                                                            if (data[0].hasOwnProperty("error")) {
                                                                webix.message(data[0].error);
                                                            }
                                                            else {
                                                                var table = webix.$$("dataBC");
                                                                table.clearAll();
                                                                table.parse(data);
                                                            }
                                                        }

                                                    });
                                             }
                                        },
                                        click: function () {
                                            this.callEvent("onClick");
                                        }
                                    },
                                    {
                                        shortcut: "F10", id: "btnGhi", view: "button", icon: "refresh", label: "Ghi (F10)", type: "danger", align: "center", width: 120,
                                        on: {
                                            onClick: function () {
                                                var ss = $$("dataBC").serialize();
                                                var form = $$("thsd-win");
                                                webix.extend(form, webix.ProgressBar);
                                                form.disable();
                                                form.showProgress();
                                                var dataBC = {
                                                    data: ss,
                                                    nguoi_lap: $$('nguoi_lap').getValue(),
                                                    nguoi_dai_dien: $$('nguoi_dai_dien').getValue(),
                                                    ngay_lap: $$('ngay_lap').getValue()
                                                };

                                                webix.ajax()
                                                    .headers({ 'Content-type': 'application/json' })
                                                    .post(app.config.host + "/Bcthsd/bcthsd_INSERT", dataBC,
                                                    {
                                                        error: function (text, data, XmlHttpRequest) {
                                                            //webix.modalbox.hide(box);
                                                            form.enable();
                                                            form.hideProgress();
                                                            webix.message(text, "error");
                                                            // webix.alert({
                                                            //     title: "Lỗi !",
                                                            //     text: text,
                                                            //     type: "alert-error"
                                                            // });
                                                        },
                                                        success: function (text, data, XmlHttpRequest) {

                                                            form.enable();
                                                            form.hideProgress();
                                                            var data = JSON.parse(text);
                                                            if (data.hasOwnProperty("error")) {
                                                                webix.message(data.error);
                                                            }
                                                            else {
                                                                webix.message(data.ok, "debug");
                                                            }
                                                        }

                                                    });
                                            }
                                        },
                                        click: function () {
                                            this.callEvent("onClick");
                                        }
                                    },
                                    {
                                        shortcut: "F9", view: "button", type: "form", icon: "refresh", label: "Kết xuất XML (F9)", align: "center", width: 120,
                                        on: {
                                            onClick: function () {
                                                var form = $$("thsd-form");
                                                webix.extend(form, webix.ProgressBar);
                                                form.disable();
                                                form.showProgress();
                                                webix.ajax()
                                                    .headers({ 'Content-type': 'application/json' })
                                                    .post(app.config.host + "/Bcthsd/Check_xulyHD", iData, function (text) {
                                                        var data = JSON.parse(text);

                                                        if (!data.hasOwnProperty("error")) {
                                                            webix.confirm({
                                                                text: "Bạn có muốn ghi báo cáo trước khi kết suất XML không ?", ok: "Có", cancel: "Không",
                                                                callback: function (res) {
                                                                    if (res) {
                                                                        var ss = $$("dataBC").serialize();

                                                                        var dataBC = {
                                                                            data: ss,
                                                                            nguoi_lap: $$('nguoi_lap').getValue(),
                                                                            nguoi_dai_dien: $$('nguoi_dai_dien').getValue(),
                                                                            ngay_lap: $$('ngay_lap').getValue()
                                                                        };
                                                                        var box = webix.modalbox({
                                                                            title: "Đang kết suất XML ....",
                                                                            text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                                                                            width: 350,
                                                                            height: 200
                                                                        });
                                                                        webix.ajax()
                                                                            .headers({ 'Content-type': 'application/json' })
                                                                            .post(app.config.host + "/Bcthsd/bcthsd_INSERT", dataBC, function (text) {
                                                                                var data = JSON.parse(text);
                                                                                if (data.hasOwnProperty("error")) {
                                                                                    webix.modalbox.hide(box);
                                                                                    webix.message(data.error, "error");
                                                                                }
                                                                                else {
                                                                                    var item = $$('dataform').getValue();
                                                                                    // console.log(item);
                                                                                    var input = {
                                                                                        ma_dvcs: user.getDvcsID(),
                                                                                        tokhai_quy: item.tokhai_quy,
                                                                                        tokhai_thang: item.tokhai_thang,
                                                                                        nam: item.nam,
                                                                                        thang: item.thang,
                                                                                        tu_ngay: item.tu_ngay,
                                                                                        den_ngay: item.den_ngay
                                                                                    }
                                                                                    webix.ajax()
                                                                                        .headers({ 'Content-type': 'application/json' })
                                                                                        .get(app.config.host + "/Bcthsd/ValidateInfoCompany", function (text) {
                                                                                            var data = JSON.parse(text);
                                                                                            if (data.hasOwnProperty("error")) {
                                                                                                webix.modalbox.hide(box);
                                                                                                webix.message(data.error, "error");
                                                                                            }
                                                                                            else {
                                                                                                webix.ajax()
                                                                                                    .response("arraybuffer")
                                                                                                    .get(app.config.host + "/Bcthsd/ExportFileXML", input, function (text, data) {
                                                                                                        var file = new Blob([data], { type: 'application/xml' });
                                                                                                        webix.html.download(file, $$('tenfile').getValue());
                                                                                                        webix.modalbox.hide(box);
                                                                                                    });
                                                                                            }
                                                                                        });
                                                                                }
                                                                            });
                                                                    }
                                                                    else {
                                                                        var item = $$('dataform').getValue();
                                                                        // console.log(item);
                                                                        var input = {
                                                                            ma_dvcs: user.getDvcsID(),
                                                                            tokhai_quy: item.tokhai_quy,
                                                                            tokhai_thang: item.tokhai_thang,
                                                                            nam: item.nam,
                                                                            thang: item.thang,
                                                                            tu_ngay: item.tu_ngay,
                                                                            den_ngay: item.den_ngay
                                                                        }
                                                                        var box = webix.modalbox({
                                                                            title: "Đang kết suất XML ....",
                                                                            text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                                                                            width: 350,
                                                                            height: 200
                                                                        });
                                                                        webix.ajax()
                                                                            .headers({ 'Content-type': 'application/json' })
                                                                            .get(app.config.host + "/Bcthsd/ValidateInfoCompany", function (text) {
                                                                                var data = JSON.parse(text);
                                                                                if (data.hasOwnProperty("error")) {
                                                                                    webix.modalbox.hide(box);
                                                                                    webix.message(data.error, "error");
                                                                                }
                                                                                else {
                                                                                    webix.ajax()
                                                                                        .response("arraybuffer")
                                                                                        .get(app.config.host + "/Bcthsd/ExportFileXML", input, function (text, data) {
                                                                                            var file = new Blob([data], { type: 'application/xml' });
                                                                                            webix.html.download(file, $$('tenfile').getValue() + ".xml");
                                                                                            webix.modalbox.hide(box);
                                                                                        });
                                                                                }
                                                                            });
                                                                    }
                                                                }
                                                            });
                                                        }
                                                        else {
                                                            webix.message(data.error, "error");
                                                        }
                                                        form.enable();
                                                        form.hideProgress();
                                                    });
                                            }
                                        },
                                        click: function () {
                                            this.callEvent("onClick");
                                        }
                                    },
                                    {
                                        shortcut: "F8", view: "button", type: "form", icon: "far fa-refresh", label: "Print (F8)", align: "center", width: 120,
                                        on: {
                                            onClick: function () {
                                                var form = $$("thsd-form");
                                                webix.extend(form, webix.ProgressBar);
                                                form.disable();
                                                form.showProgress();
                                                webix.ajax()
                                                    .headers({ 'Content-type': 'application/json' })
                                                    .post(app.config.host + "/Bcthsd/Check_xulyHD", iData, function (text) {
                                                        var data = JSON.parse(text);

                                                        if (!data.hasOwnProperty("error")) {
                                                            var item = $$('dataform').getValue();
                                                            var input = {
                                                                ma_dvcs: user.getDvcsID(),
                                                                bc_soluong: item.bc_soluong,
                                                                nam: item.nam,
                                                                thang: item.thang,
                                                                tokhai_quy: item.tokhai_quy,
                                                                tokhai_thang: item.tokhai_thang
                                                            }
                                                            var box = webix.modalbox({
                                                                title: "Đang in báo cáo ....",
                                                                text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                                                                width: 350,
                                                                height: 200
                                                            });
                                                            webix.ajax()
                                                                .response("arraybuffer")
                                                                .get(app.config.host + "/Bcthsd/PrintPDF?ma_dvcs=" + user.getDvcsID() + "&bc_soluong=" + item.bc_soluong + "&nam=" + item.nam + "&thang=" + item.thang + "&tokhai_quy=" + item.tokhai_quy + "&tokhai_thang=" + item.tokhai_thang, function (text, data) {
                                                                    var file = new Blob([data], { type: 'application/pdf' });
                                                                    var fileURL = URL.createObjectURL(file);
                                                                    webix.modalbox.hide(box);
                                                                    window.open(fileURL, '_blank');
                                                                });

                                                        }
                                                        else {
                                                            webix.message(data.error, "error");
                                                        }
                                                        form.enable();
                                                        form.hideProgress();
                                                    });
                                            }
                                        },
                                        click: function () {
                                            this.callEvent("onClick");
                                        }
                                    },
                                    {
                                        shortcut: "F8", view: "button", type: "form", icon: "far fa-refresh", label: "Kết xuất Excel (F7)", align: "center", width: 140,
                                        on: {
                                            onClick: function () {
                                                var form = $$("thsd-form");
                                                webix.extend(form, webix.ProgressBar);
                                                form.disable();
                                                form.showProgress();
                                                webix.ajax()
                                                    .headers({ 'Content-type': 'application/json' })
                                                    .post(app.config.host + "/Bcthsd/Check_xulyHD", iData, function (text) {
                                                        var data = JSON.parse(text);

                                                        if (!data.hasOwnProperty("error")) {
                                                            var item = $$('dataform').getValue();
                                                            // console.log(item);
                                                            var input = {
                                                                ma_dvcs: user.getDvcsID(),
                                                                bc_soluong: item.bc_soluong,
                                                                nam: item.nam,
                                                                thang: item.thang,
                                                                tokhai_quy: item.tokhai_quy,
                                                                tokhai_thang: item.tokhai_thang
                                                            }
                                                            var box = webix.modalbox({
                                                                title: "Đang in báo cáo ....",
                                                                text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                                                                width: 350,
                                                                height: 200
                                                            });
                                                            webix.ajax()
                                                                .response("arraybuffer")
                                                                .get(app.config.host + "/Bcthsd/ExportExcel?ma_dvcs=" + user.getDvcsID() + "&bc_soluong=" + item.bc_soluong + "&nam=" + item.nam + "&thang=" + item.thang + "&tokhai_quy=" + item.tokhai_quy + "&tokhai_thang=" + item.tokhai_thang, function (text, data) {
                                                                    var file = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                                                                    //var fileURL = URL.createObjectURL(file);
                                                                    //webix.modalbox.hide(box);
                                                                    //  var printWindow = window.open(fileURL, '', 'width=800,height=500');
                                                                    //           printWindow.print()
                                                                    // var a = document.createElement("a");
                                                                    // a.target = '_blank';
                                                                    // document.body.appendChild(a);

                                                                    // a.href = fileURL;
                                                                    // a.download = "fileName.pdf";
                                                                    // a.click();
                                                                    //$$("frame-body").define("src", fileURL);
                                                                    //kk.show();
                                                                    // window.open(fileURL, '_blank');
                                                                    webix.html.download(file, $$('tenfile').getValue() + ".xlsx");
                                                                    webix.modalbox.hide(box);

                                                                    // webix.html.download(file, $$('tenfile').getValue());
                                                                });

                                                        }
                                                        else {
                                                            webix.message(data.error, "error");
                                                        }
                                                        form.enable();
                                                        form.hideProgress();
                                                    });


                                            }
                                        },
                                        click: function () {
                                            this.callEvent("onClick");
                                        }
                                    },
                                    {}
                                    /*{
                                        view: "button", hotkey: "esc", label: "Hủy bỏ", align: "center", width: 120,
                                        click: function () {
                                            $$("tinhhinhsudung").removeView("dataBC");
                                            // webix.$$("tinhhinhsudung").close();
                                        }
                                    }*/
                                ]
                            }
                        ]
                    }
                ]
            }

        },
        initUI: initUI
    };

});
define('views/forms/token',["app", "locale"], function (app, _) {
	var editmode = 0;

	return {
		$ui: {
			view: "window", modal: true, id: "chukyso-win", position: "center",
			head: "Thông tin Token",
			//height:420,		
			body: {
				paddingY: 10,
				paddingX: 10,
				view: "form",
				id: "chukyso-form",
				complexData: true,
				margin: 0,
				elements: [
					{
						view: "text",
						name: "serialNumber",
						labelPosition: "top",
						label: _("SO_SERIAL"),
						readonly: true,
						width: 350
					},
					{
						view: "text",
						name: "tokenLabel",
						labelPosition: "top",
						label: "TOKEN LABEL",
						readonly: true,
					},
					{
						view: "text",
						name: "pass",
						labelPosition: "top",
						label: _("PASSWORD"),
						type: "password"
					},
					{},
					{
						margin: 10,
						cols: [
							{},
							{
								shortcut: "F10", view: "button", label: "Nhận (F10)", type: "form", align: "center", width: 120,
								on: {
									onClick: function () {
										var form = webix.$$("chukyso-form");

										var item = form.getValues();

										var khData = {};

										khData.windowid = app.path[1].params[0];
										khData.editmode = editmode;
										khData.data = [];

										khData.data.push(item);
										webix.extend(form, webix.ProgressBar);
										form.disable();
										form.showProgress();
										webix.ajax()
											.headers({ 'Content-type': 'application/json' })
											.post(app.config.host + "/System/Save", khData, function (text) {
												form.enable();
												form.hideProgress();
												var json = JSON.parse(text);

												if (!json.hasOwnProperty("error")) {
													$$("chukyso-win").close();
													app.callEvent("dataChanged", [editmode, json.data]);
												}
												else {
													webix.message(json.error, "error");
												}


											});
									}
								},
								click: function () {
									this.callEvent("onClick");

								}
							},
							{
								view: "button", hotkey: "esc", label: "Hủy bỏ (ESC)", align: "center", width: 120, type: "danger",
								click: function () {
									webix.$$("chukyso-win").close();
								}
							},
							{}
						]
					}

				]
			}

		},
		setEditMode: function (mode) {
			editmode = mode;
		}
	};

});
define('views/forms/tokenfile',["app", "locale"], function (app, _) {
    var editmode = 0;

    return {
        $ui: {
            view: "window", modal: true, id: "tokenfile-win", position: "center",
            head: "Thông tin Token File",
            //height:420,		
            body: {
                paddingY: 10,
                paddingX: 10,
                view: "form",
                id: "tokenfile-form",
                complexData: true,
                margin: 0,
                elements: [
                    {
                        view: "textarea",
                        name: "path",
                        labelPosition: "top",
                        label: _("PATH"),
                        height: 100,
                        required: true,
                        validate: webix.rules.isNotEmpty,
                        invalidMessage: "Đường dẫn không được để trống !"
                    },
                    {
                        view: "text",
                        name: "pass",
                        labelPosition: "top",
                        label: _("PASSWORD"),
                        type: "password",
                        required: true,
                        invalidMessage: "Password không được để trống !",
                        validate: webix.rules.isNotEmpty
                    },
                    {},
                    {
                        margin: 10,
                        cols: [
                            {},
                            {
                                shortcut: "F10", view: "button", label: "Nhận (F10)", type: "form", align: "center", width: 120,
                                on: {
                                    onClick: function () {
                                        if ($$("tokenfile-form").validate()) {
                                            var form = webix.$$("tokenfile-form");

                                            var item = form.getValues();

                                            var khData = {};

                                            khData.windowid = app.path[1].params[0];
                                            khData.editmode = editmode;
                                            khData.data = [];

                                            khData.data.push(item);
                                            webix.extend(form, webix.ProgressBar);
                                            form.disable();
                                            form.showProgress();
                                            webix.ajax()
                                                .headers({ 'Content-type': 'application/json' })
                                                .post(app.config.host + "/Token/SaveTokenFile", khData, function (text) {
                                                    form.enable();
                                                    form.hideProgress();
                                                    var json = JSON.parse(text);

                                                    if (!json.hasOwnProperty("error")) {
                                                        $$("tokenfile-win").close();
                                                        app.callEvent("dataChanged", [editmode, json.data]);
                                                    }
                                                    else {
                                                        webix.message(json.error, "error");
                                                    }


                                                });
                                        }
                                    }
                                },
                                click: function () {
                                    this.callEvent("onClick");

                                }
                            },
                            {
                                view: "button", hotkey: "esc", label: "Hủy bỏ (ESC)", align: "center", width: 120, type: "danger",
                                click: function () {
                                    webix.$$("tokenfile-win").close();
                                }
                            },
                            {}
                        ]
                    }

                ]
            }

        },
        setEditMode: function (mode) {
            editmode = mode;
        }
    };

});
define('views/forms/updateToWeb',[
    'require',
    'locale',
    'app'
], function (require, _, app) {
    'use strict';

    var layout = {
        view: "window",
        id: "formConfirm",
        head: "Đăng nhập",
        modal: true,
        position: "center",
        // css: { "font-weight": "bold", "text-transform": "uppercase" },
        body: {
            view: "form",
            id: "formConfirmValid",
            // elementsConfig: {
            //     labelPosition: "top",
            //     //validateEvent: "key"
            // },
            elements: [
                {
                    view: "text", label: _("Account"), id: "1", name: "taikhoan", width: 350,
                    invalidMessage: "Tài khoản không được để trống !",
                    required: true,
                    css: "mcls_uppercase"
                },
                {
                    view: "text", label: _("PASSWORD"), id: "pass", name: "matkhau", type: "password", width: 350,
                    invalidMessage: "Mật khẩu không được để trống !",
                    required: true
                },
                // {
                //     view: "label",
                //     name: "lb1",
                //     id: "lb",
                //     template: "<hr>"
                // },
                {

                    view: "button",
                    css: "mcls_btnRegisterLogin",
                    type: "iconButton",
                    icon: "fas fa-long-arrow-right",
                    label: _("Phần mềm hóa đơn điện tử M-Invoice"), width: 350,
                    click: function () {
                        window.open('http://minvoice.vn/dang-ky-su-dung/', '_blank');
                    }
                },
                {
                    cols: [
                        {
                            view: "button", value: "Đồng ý", type: "danger", click: function () {
                                var model = {
                                    username: $$('1').getValue(),
                                    password: $$('pass').getValue()
                                }
                                if ($$("formConfirmValid").validate()) {
                                    var box = webix.modalbox({
                                        title: "Đang cập nhật phần mềm ....",
                                        text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                                        width: 350,
                                        height: 200
                                    });
                                    var urlCheck = app.config.host + "/System/CheckPassUpdate";

                                    var url = app.config.host + "/System/UpdateToWeb";
                                    webix.ajax()
                                        .headers({ 'Content-type': 'application/json' })
                                        .post(urlCheck, model, function (text) {
                                            var data = JSON.parse(text);

                                            if (!data.hasOwnProperty("error")) {
                                                webix.ajax()
                                                    .headers({ 'Content-type': 'application/json' })
                                                    .post(url,
                                                    {
                                                        error: function (text, data, XmlHttpRequest) {
                                                            webix.modalbox.hide(box);
                                                            webix.message(XmlHttpRequest.statusText, "error");
                                                        },
                                                        success: function (text, data, XmlHttpRequest) {
                                                            //console.log(text);
                                                            var data = JSON.parse(text);

                                                            if (data.error == "" || data.error == null) {

                                                                webix.modalbox.hide(box);
                                                                webix.message(data.ok, "debug");

                                                                webix.$$("formConfirm").close();

                                                            }
                                                            else {
                                                                webix.$$("formConfirm").close();
                                                                webix.modalbox.hide(box);
                                                                webix.message(data.error, "error");
                                                            }
                                                        }
                                                    }
                                                    )
                                            }
                                            else {
                                                webix.modalbox.hide(box);
                                                webix.message(data.error, "error");
                                            }
                                        });
                                    //this.getTopParentView().hide();
                                }
                            }
                        },
                        {
                            view: "button", hotkey: "esc", label: "Hủy bỏ", type: "form", click: function () {
                                //this.getFormView().save();
                                $$("formConfirm").close();
                                //this.getTopParentView().hide();
                            }
                        }
                    ]
                }
            ]
        }
    };

    return {
        $ui: layout,
        $oninit: function () {
            $$("formConfirmValid").focus();
        }
    }
});
define('views/forms/uploadexcel',["app", "locale"], function (app, _) {

	// var dialog = webix.ui({
	// 	id: "uploader",
	// 	view: "uploader",
	// 	value: 'Chọn file',
	// 	name: "uploader",
	// 	accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
	// 	link: "mylist",
	// 	autosend: false,
	// 	//borderless: true,
	// 	multiple: false,
	// 	upload: app.config.host + "/System/UploadExcel",
	// 	on: {
	// 		onAfterFileAdd: function (file) {
	// 			//console.log(file);
	// 			// var kk = {
	// 			// 	name: file.name, 
	// 			// 	lastModified: file.lastModified,
	// 			// 	lastModifiedDate: file.lastModifiedDate,
	// 			// 	webkitRelativePath: file.webkitRelativePath,
	// 			// 	id: file.id,
	// 			// 	size: file.size,
	// 			// 	sizetext: file.sizetext,
	// 			// 	status: file.status,
	// 			// 	type: file.type
	// 			// };
	// 			// $$("mylist").add(kk);

	// 			// console.log($$("mylist").getIdByIndex(0));
	// 			// var id = $$("mylist").getIdByIndex(0);
	// 			// console.log($$("mylist").getItem(id));
	// 			$$("mylist").refresh();
	// 			//$$("mylist").show();

	// 		},
	// 		onUploadComplete: function (response) {
	// 			// var topParentView = this.getTopParentView();

	// 			// if (topParentView.config.tableId !== undefined) {
	// 			// 	var table = $$(topParentView.config.tableId);

	// 			// 	if (table != null) {
	// 			// 		table.clearAll();
	// 			// 		table.load(table.config.url);
	// 			// 	}
	// 			// }
	// 			// webix.message("Upload File thành công !", "debug");
	// 			// webix.$$("uploadfile-win").close();
	// 		},
	// 		onFileUploadError: function (file, response) {
	// 			console.log(file);
	// 			console.log(response);
	// 		}
	// 	},
	// 	apiOnly: true,
	// });

	return {
		$ui: {
			view: "window", modal: true, id: "uploadfile-win", position: "center",
			head: "Nhận dữ liệu từ file Excel",
			width: 500,
			height: 500,
			body: {
				paddingY: 10,
				paddingX: 10,
				elementsConfig: { labelWidth: 100 },
				view: "form",
				id: "uploadfile-form",
				complexData: true,
				elements: [
					{
						cols: [
							{
								view: "toolbar",
								css: { "background": "#e6f7ff !important" },
								rows: [
									// { gravity: 2 },
									{
										view: "button", type: "icon",css: "btnExcel", icon: "fas fa-folder-open", label: "Chọn file", width: 110,
										on: {
											onClick: function () {
												webix.$$("uploader").fileDialog();
											}
										},
										click: function () {
											this.callEvent("onClick");
										}
									},
									{
										view: "button", type: "icon",css: { "background-color": "#e6f7ff !important" }, icon: "fas fa-download", label: "Tải file mẫu", width: 110,
										on: {
											onClick: function () {
												var uploader = webix.$$("uploader");
												var formData = uploader.config.formData;
												var table = $$("uploadfile-win");
												// webix.extend(table, webix.OverlayBox);
												var fname = webix.ajax().get(app.config.host + "/System/GetWbExcel?id=" + formData["excel_id"]).then(function (data) {

													var result = data.json();
													var fname = result[0].name;

													webix.extend(table, webix.ProgressBar);
													table.disable();
													table.showProgress();
													webix.ajax()
														.response("arraybuffer")
														.headers({ 'Content-type': 'application/json' })
														.get(app.config.host + "/System/DownloadFileExcelTemplate?id=" + formData["excel_id"],
														{
															error: function (text, data, XmlHttpRequest) {
																webix.message(text + data.toString(),"error");
																table.enable();
																table.hideProgress();
															},
															success: function (text, data, XmlHttpRequest) {

																webix.delay(function () {
																	var file = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
																	var fileURL = URL.createObjectURL(file);

																	var link = document.createElement('a');
																	document.body.appendChild(link);
																	link.download = fname + ".xlsx";
																	link.href = fileURL;
																	link.click();
																	document.body.removeChild(link); // remove the link when done
																	//document.location.href = fileURL;
																}, null, null, 500);

																table.enable();
																table.hideProgress();
																// })
															}
														}
														);

												});
											}
										},
										click: function () {
											this.callEvent("onClick");
										}
									},
									{
										shortcut: "F10", view: "button",css: { "background": "#e6f7ff !important" }, type: "icon", icon: "fas fa-check", label: "Nhận file (F10)", width: 120, on: {
											onClick: function () {
												var table = $$("uploadfile-win");
												// webix.extend(table, webix.OverlayBox);
												webix.extend(table, webix.ProgressBar);
												table.disable();
												table.showProgress();
												var file = $$("uploader").files.getFirstId();
												if (file == undefined || file == null) {
													webix.message("Bạn chưa chọn file !", "error");
													$$("uploadfile-win").enable();
													$$("uploadfile-win").hideProgress();
													return;
												}
												// var kk = $$("uploader").files.data.pull;
												// console.log(kk);
												$$("uploader").send(function (response) {

													if (response != undefined) {
														if (!response.hasOwnProperty("error")) {
															$$("uploadfile-win").enable();
															$$("uploadfile-win").hideProgress();
															//this.callEvent("onUploadComplete");
															// success call event onUploadComplete ở trên 
															var topParentView = this.getTopParentView();

															if (topParentView.config.tableId !== undefined) {
																var table = $$(topParentView.config.tableId);

																if (table != null) {
																	table.clearAll();
																	table.load(table.config.url);
																}
															}

															webix.alert({
																title: "Thành công !",
																text: "Nhận dữ liệu Excel thành công !",
																type: "alert-warning",
																callback: function (result) {
																	webix.$$("uploadfile-win").close();
																}
															});
															//webix.message("Nhận dữ liệu Excel thành công !", "debug");
														}
														else {
															$$("uploadfile-win").enable();
															$$("uploadfile-win").hideProgress();

															webix.alert({
																title: "Lỗi !",
																text: response.error,
																type: "alert-error"
																// callback: function (result) {
																// 	webix.alert({
																// 		title: "Custom title",
																// 		ok: "Custom text",
																// 		text: "Result: " + result
																// 	});
																// }
															});
															//webix.message(response.error, "error");
														}
													}
													else {
														$$("uploadfile-win").enable();
														$$("uploadfile-win").hideProgress();
													}
												});
											}
										},
										click: function () {
											this.callEvent("onClick");
										}
									},
									{
										hotkey: "esc", view: "button",css: { "background": "#e6f7ff !important" }, type: "icon", icon: "fas fa-times", label: "Hủy bỏ (ESC)", width: 110,
										on: {
											onClick: function () {
												$$("mylist").clearAll();
												$$("mylist").unbind();
												var id = $$("uploader").files.getFirstId();
												if (id != undefined) {
													$$("uploader").stopUpload(id);
												}
												webix.$$("uploadfile-win").close();
											}
										},
										click: function () {
											this.callEvent("onClick");
										}
									}

								]
							},
							{
								rows: [
									// {view:"text",id:"df",label:"errr"},
									{
										id: "uploader",
										view: "uploader",
										value: 'Chọn file',
										hide: true,
										name: "uploader",
										accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
										link: "mylist",
										autosend: false,
										//borderless: true,
										multiple: false,
										upload: app.config.host + "/System/UploadExcel",
										on: {
											onAfterRender: function () {
												//console.log('called once after first rendering:');
												this.hide();
											},
											onAfterFileAdd: function (file) {
												//console.log(file);
												// var kk = {
												// 	name: file.name, 
												// 	lastModified: file.lastModified,
												// 	lastModifiedDate: file.lastModifiedDate,
												// 	webkitRelativePath: file.webkitRelativePath,
												// 	id: file.id,
												// 	size: file.size,
												// 	sizetext: file.sizetext,
												// 	status: file.status,
												// 	type: file.type
												// };
												// $$("mylist").add(kk);

												// console.log($$("mylist").getIdByIndex(0));
												// var id = $$("mylist").getIdByIndex(0);
												// console.log($$("mylist").getItem(id));
												$$("mylist").refresh();
												//$$("mylist").show();

											},
											onUploadComplete: function (response) {
												// var topParentView = this.getTopParentView();

												// if (topParentView.config.tableId !== undefined) {
												// 	var table = $$(topParentView.config.tableId);

												// 	if (table != null) {
												// 		table.clearAll();
												// 		table.load(table.config.url);
												// 	}
												// }
												// webix.message("Upload File thành công !", "debug");
												// webix.$$("uploadfile-win").close();
											},
											onFileUploadError: function (file, response) {
												console.log(file);
												console.log(response);
												$$("uploadfile-win").enable();
												$$("uploadfile-win").hideProgress();
											}
										},
										apiOnly: true,
									},
									{
										view: "list",
										id: "mylist",
										type: "uploader",
										height: 100,
										//autoheight: true
										borderless: true
									}
								]
							}
						]
					}
				]
			}
		}
	};
});
define('views/forms/uploadfile',["app"], function (app) {

	return {
		$ui: {
			view: "window", modal: true, id: "uploadfile-win", position: "center",
			head: "Tải file",
			body: {
				paddingY: 20,
				paddingX: 30,
				elementsConfig: { labelWidth: 100 },
				view: "form",
				id: "uploadfile-form",
				complexData: true,
				elements: [
					{
						id: "uploader",
						view: "uploader",
						value: 'Upload file',
						css: "btnUpload",
						name: "file",
						//accept:"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
						link: "mylist",
						//upload: app.config.host + "/System/UploadExcel" ,
						on: {
							onUploadComplete: function (response) {

								if (response.hasOwnProperty("error")) {
									webix.message({ type: "error", text: response["error"] });
									return;
								}

								var topParentView = this.getTopParentView();

								if (topParentView.config.tableId !== undefined) {
									var table = $$(topParentView.config.tableId);

									if (table != null) {
										table.clearAll();
										table.load(table.config.url);
									}
								}

								webix.$$("uploadfile-win").close();
							}
						}
					},
					{
						view: "list",
						id: "mylist",
						type: "uploader",
						autoheight: true, borderless: true
					},
					{
						view: "button",
						label: "Hủy bỏ",
						css: "btnUpload",
						click: function () {
							webix.$$("uploadfile-win").close();
						}
					}
				]
			}

		}

	};

});

define('views/forms/wb_config_job',[
	"app",
	"locale",
	"views/modules/Component/constantManager",
	"views/menus/version"
], function (app, _, constant, version) {
	var editMode = 0;
	var winId = "configJobWin";
	var formId = "configJobForm";

	return {
		$ui: {
			view: "window", modal: true, id: winId, position: "center", width: 600, minHeight: 200,
			head: "Thêm mới cấu hình gửi email thông báo hóa đơn máy tính tiền cần ký",
			head: {
				height: 35,
				cols: [
					{
						id: "headHttoan", view: "template", css: "headform", width: 35, template: "<span><i class='fa fa-plus' aria-hidden='true'></i></span>",
					},
					{
						id: "head-frmHttoan", view: "template", css: "headform",
						template: function (obj) {
							switch (editMode) {
								case 1: return "<div>Thêm mới cấu hình gửi email thông báo hóa đơn máy tính tiền cần ký<div/>"; break;
								case 2: return "<div>Sửa cấu hình gửi email thông báo hóa đơn máy tính tiền cần ký<div/>"; break;
							}
						},
					},
					{
						view: "icon", icon: "fas fa-question-circle", id: "help_frmhttoan", tooltip: _("HELPER"),
						click: function () {
							var newWin = window.open();
							newWin.location =
								"http://huongdansudung.minvoice.com.vn/Tomihoadon.html";
						},
					},
				],
			},
			move: true,
			resize: true,
			body: {
				paddingY: 20,
				paddingX: 30,
				elementsConfig: { labelWidth: 60, labelPosition: "top" },
				view: "form",
				id: formId,
				complexData: true,
				margin: 0,
				elements: [
					{ view: "text", name: "wb_config_job_id", hidden: true },
					{
						view: "text", id: "email", name: "email", label: "Email nhận thông báo", required: true, invalidMessage: "Email không hợp lệ",
						validate: function (value) {
							const emailRegex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
							const emails = value.split(',').map(email => email.trim());
							return emails.every(email => emailRegex.test(email));
						}
					},
					{
						view: "combo", name: "time_interval", label: "Thời gian ký lại hóa đơn", value: 30, required: true, invalidMessage: "Thời gian ký lại hóa đơn không được để trống",
						options: [
							{ id: 1, value: "1 phút test" },
							{ id: 5, value: "5 phút" },
							{ id: 10, value: "10 phút" },
							{ id: 15, value: "15 phút" },
							{ id: 20, value: "20 phút" },
							{ id: 25, value: "25 phút" },
							{ id: 30, value: "30 phút" }
						]
					},
					{
						cols: [
							{
								view: "combo", name: "time_start", label: "Thời gian bắt đầu", value: 18, required: true, invalidMessage: "Thời gian ký lại hóa đơn không được để trống",
								options: [
									{ id: 7, value: "7:00 test" },
									{ id: 18, value: "18:00" },
									{ id: 19, value: "19:00" },
									{ id: 20, value: "20:00" },
									{ id: 21, value: "21:00" },
									{ id: 22, value: "22:00" },
									{ id: 23, value: "23:00" }
								]
							},
							{
								view: "combo", name: "serial", id: "serial", label: "Ký hiệu", labelPosition: "top", required: true, invalidMessage: "Ký hiệu hóa đơn không được để trống !",
								validate: function (value) { return value.trim().length > 0; },
								options:
								{
									view: "gridsuggest", url: app.config.host + "/Invoice68/GetTypeInvoiceCashRegister",
									body: { scroll: true, autoheight: false, autofocus: true, yCount: 10, columns: [{ id: "value", header: _("KY_HIEU"), width: 150 }] },
								},
							},
						]
					},
					{ view: "radio", id: "action", name: "action", value: "SendEmail", options: [{ id: "SendEmail", value: "Gửi email thông báo", }, { id: "Sign", value: "Ký tự động hóa đơn" }], vertical: true },
					{
						cols: [
							{},
							{
								shortcut: "F10", view: "button", label: "Nhận (F10)", type: "form", align: "center", width: 120,
								on: {
									onClick: function () {
										var form = $$(formId);
										var win = $$(winId);
										if (form.validate()) {
											var formValue = form.getValues();
											var serial = webix.$$("serial").getText();
											var item = {
												wb_config_job_id: formValue.wb_config_job_id,
												email: formValue.email,
												time_interval: formValue.time_interval,
												time_start: formValue.time_start,
												serial: serial,
												action: formValue.action,
												editMode: editMode,
												mst: version.getMST()
											}
											if (editMode == 1) item.wb_config_job_id = "00000000-0000-0000-0000-000000000000";
											var url = app.config.host + "/Pattern/ConfigSignInvoiceCashRegisterAuto";
											webix.extend(win, webix.ProgressBar);
											win.disable();
											win.showProgress();

											webix.ajax()
												.headers({ 'Content-type': 'application/json' })
												.post(url, item, function (text) {
													var data = JSON.parse(text);
													if (data.code == "00") {
														$$(winId).close();
														webix.callEvent("onRefreshEvent");
														app.callEvent("dataErrorChanged", [editMode, item]);
													}
													else {
														webix.message(data.error, "error");
													}
												});
										}

									}
								},
								click: function () {
									this.callEvent("onClick");
								}
							},
							{ view: "button", hotkey: "esc", label: "Hủy bỏ (ESC)", align: "center", type: "danger", width: 120, click: function () { webix.$$(winId).close(); } },
							{}
						]
					}
				]
			}
		},
		setEditMode: function (mode) {
			editMode = mode;
		},
		setValues: function (item) {
			$$(formId).setValues(item);
		}
	};

});

define('views/forms/wb_cronjob_invoice_signing_pos',["app", "locale"], function (app, _) {
	var winId = "dmtab-win";
	var editMode = 0;
	var runCycleOptions = [
		{ "id": 10, "value": 10 },
		{ "id": 15, "value": 15 },
		{ "id": 20, "value": 20 },
		{ "id": 25, "value": 25 },
		{ "id": 30, "value": 30 },
	];
	var scanTimeOptions = [];
	for (var i = 0; i <= 23; i++) {
		scanTimeOptions.push({ "id": i, "value": i });
	}

	return {
		$ui: {
			view: "window", modal: true, id: winId,move: true,
			position: "center",
			head: function () {
				return (editMode === 1 ? "Thêm mới" : "Chỉnh sửa") + " job tự động ký hóa đơn máy tính tiền";
			},
			width: 500,
			height: 500,
			body: {
				paddingY: 10,
				paddingX: 10,
				elementsConfig: { labelWidth: 60 },
				view: "form",
				id: "dmtab-form",
				complexData: true,
				margin: 0,
				elements: [
					{
						id: "dmtab-khieu",
						view: "combo",
						name: "khieu",
						label: "Ký hiệu",
						options:
						{
							view: "gridsuggest", 
							url: app.config.host + "/Invoice68/GetTypePosInvoiceSeries",
							filter: function (item, value) {
								return item.value.toString().toLowerCase().indexOf(value.toLowerCase()) != -1;
							},
							body: { scroll: true, autoheight: false, autofocus: true, yCount: 10, columns: [{ id: "value", header: _("KY_HIEU"), width: 150}] },
						},
						labelPosition: "top",
						required: true,
						invalidMessage: "Bạn chưa chọn ký hiệu",
					},
					{
						cols:[
							{
								id: "dmtab-run_cycle",
								view: "select",
								name: "run_cycle",
								label: "Chu kỳ chạy (phút)",
								value: 10,
								options: runCycleOptions,
								labelPosition: "top",
								required: true,
								invalidMessage: "Bạn chưa điền chu kỳ chạy",
							},
							{
								id: "dmtab-number_record",
								view: "text",
								attributes: { type:"number" },
								name: "number_record",
								label: "Số bản ghi",
								value: 100,
								labelPosition: "top",
								required: true,
								validate: function(value) {
									return !isNaN(value) && parseInt(value) <= 500;
								},
								invalidMessage: "Tối đa số bản ghi là 500",
							},
						],
					},
					{
						cols:[
							{
								id: "dmtab-scan_start_time",
								view: "select",
								name: "scan_start_time",
								label: "Thời gian bắt đầu quét (giờ)",
								value: 0,
								options: scanTimeOptions,
								labelPosition: "top",
								required: true,
								invalidMessage: "Bạn chưa điền số thời gian bắt đầu quét",
							},
							{
								id: "dmtab-scan_end_time",
								view: "select",
								name: "scan_end_time",
								label: "Thời gian dừng quét (giờ)",
								value: 23,
								options: scanTimeOptions,
								labelPosition: "top",
								required: true,
								invalidMessage: "Bạn chưa điền số thời gian dừng quét",
							},
						],
					},
					{
						id: "dmtab-is_active",
						view: "checkbox",
						name: "is_active",
						label: "Sử dụng",
					},
					{
						margin: 10,
						cols: [
							{},
							{
								shortcut: "F10", view: "button", label: "Nhận (F10)", type: "form", align: "center",
								on: {
									onClick: function () {
										var form = webix.$$("dmtab-form");
										var win = $$(winId);
										
										if (!form.validate()) return; 
										var formValue = form.getValues();
										var numberRecord = formValue.number_record;
										var scanStartTime = formValue.scan_start_time;
										var scanEndTime = formValue.scan_end_time;
										if (parseInt(numberRecord) <= 0) {
											webix.message("Số bản ghi phải là số nguyên dương", "error");
											return;
										}
										if(parseInt(scanStartTime) > parseInt(scanEndTime)) {
											webix.message("Giờ bắt đầu quét phải nhỏ hơn hoặc bằng giờ dừng quét", "error");
											return;
										}

										var apiHost = app.config.host + "/Category/WbCronjobInvoicecSigningPosSaveChange";
										formValue.editMode = editMode;
										if (editMode == 1) formValue.wb_cronjob_id = "00000000-0000-0000-0000-000000000000";
										webix.extend($$(winId), webix.ProgressBar);
										win.disable();
										win.showProgress();

										webix.ajax().header({ "content-type": "application/json" }).post(apiHost, formValue, function (result) {
											win.enable();
											win.hideProgress();
											var response = JSON.parse(result);
											if (response.code == "00") {
												app.callEvent("wbsettingChanged", [editMode, response.data]);
												webix.message((editMode == 1 ? "Thêm mới" : "Chỉnh sửa") + " thành công", "success");
												win.close();
												var table = webix.$$("wbCronjobInvoiceSigningPos");
												table.clearAll();
												table.load(table.config.url);
											} else {
												webix.message(response.message, "error");
											}
										});
									}
								},
								click: function () {
									this.callEvent("onClick");

								}
							},
							{
								view: "button", hotkey: "esc", label: "Hủy bỏ (ESC)", type: "danger", align: "center",
								click: function () {
									$$(winId).close();
								}
							},
							{}
						]
					}

				]
			}

		},
		setEditMode: function (mode, item) {
			editMode = mode;
			if (item) {
                $$("dmtab-form").setValues(item);
				$$("dmtab-khieu").disable();
			} else {
				$$("dmtab-is_active").setValue(1);
			}
		}
	};

});
define('views/forms/wb_setting',["app", "locale"], function (app, _) {
    var editMode = 0;
    var winId = "WbSettingWin";
    var formId = "WbSettingForm";
    return {
        $ui: {
            view: "window", modal: true, id: winId, position: "center",
            head: {
                height: 35,
                cols: [
                    { id: "headWbSetting", view: "template", css: "headform", width: 35, template: "<span><i class='fa fa-plus' aria-hidden='true'></i></span>", },
                    {
                        id: "head-frmHttoan", view: "template", css: "headform",
                        template: function (obj) { return "<div>Khai báo tham số hệ thống<div/>"; },
                    },
                    {
                        view: "icon", icon: "fas fa-question-circle", id: "help_frmhttoan", tooltip: _("HELPER"),
                        click: function () {
                            var newWin = window.open();
                            newWin.location = "http://huongdansudung.minvoice.com.vn/Tomihoadon.html";
                        },
                    },
                ],
            },
            // move: true,
            resize: true,
            body: {
                paddingY: 10,
                paddingX: 10,
                view: "form",
                id: formId,
                elementsConfig: { labelWidth: 100, labelPosition: "top" },
                complexData: true,
                margin: 0,
                width: 400,
                resize: true,
                elements: [
                    { view: "text", id: "wb_setting_id", name: "wb_setting_id", hidden: true },
                    { view: "text", id: "ma", name: "ma", label: "Mã", required: true, invalidMessage: "Mã không được để trống" },
                    { view: "textarea", id: "dien_giai", name: "dien_giai", label: "Diễn giải", height: 120 },
                    { view: "select", id: "gia_tri", name: "gia_tri", label: "Giá trị", options: ["C", "K"] },
                    {
                        margin: 10,
                        cols: [
                            {},
                            {
                                shortcut: "F10", view: "button", label: "Nhận", type: "form", align: "center", width: 100,
                                on: {
                                    onClick: function () {
                                        var form = $$(formId);
                                        var win = $$(winId);
                                        if (form.validate()) {

                                            var formValue = form.getValues();
                                            var apiHost = app.config.host + "/Category/WbSettingSaveChange";
                                            formValue.editMode = editMode;
                                            if (editMode == 1) formValue.wb_setting_id = "00000000-0000-0000-0000-000000000000";
                                            webix.extend(win, webix.ProgressBar);
                                            win.disable();
                                            win.showProgress();

                                            webix.ajax().header({ "content-type": "application/json" }).post(apiHost, formValue, function (result) {
                                                win.enable();
                                                win.hideProgress();
                                                var response = JSON.parse(result);
                                                if (response.code == "00") {
                                                    app.callEvent("wbsettingChanged", [editMode, response.data]);
                                                    webix.message((editMode == 1 ? "Thêm mới" : "Chỉnh sửa") + " thành công", "success");
                                                    $$(winId).close();
                                                } else {
                                                    webix.message(response.message, "error");
                                                }
                                            })
                                        }
                                    }
                                },
                                click: function () {
                                    this.callEvent("onClick");
                                }
                            },
                            { view: "button", hotkey: "esc", label: "Hủy", type: "danger", align: "center", width: 100, click: function () { $$(winId).close(); } },
                            {}
                        ]
                    }
                ]
            }
        },
        setEditMode: function (mode, item) {
            editMode = mode;
            if (item)
                $$(formId).setValues(item);
        }
    };
});
define('views/forms/xoabo',["app", "locale",
    "models/user", "views/modules/minvoiceplugin",
    "views/menus/version",
    "views/forms/signCloudXoabo",
    "views/forms/signEasyCAXoabo"
], function (app, _, user, plugin, version, signCloudXoabo, signEasyCAXoabo) {
    var editmode = 0;

    function signOnServer(data, cert, server_cert) {

        var parameters = {
            xml: data["InvoiceXmlData"],
            refUri: "#data",
            certSerial: cert.so_serial,
            tokenSerial: cert.tokenSerial,
            signId: "seller",
            signTag: "Signatures",
            pass: cert.pass,
            inv_InvoiceAuth_id: data["inv_InvoiceAuth_id"]
        };

        data.serialNumber = cert.so_serial;

        webix.ajax()
            .bind(data)
            .headers({ "Content-Type": "application/json" })
            .post(server_cert + "/Token/SignXml", parameters, function (text) {
                var json = JSON.parse(text);

                if (json.hasOwnProperty("error")) {
                    webix.message({ type: "error", text: json["error"] });

                    var form = webix.$$("chukyso-form");
                    form.enable();
                    form.hideProgress();
                }
                else {
                    var parameters = this;
                    parameters.InvoiceXmlData = json.xml;

                    webix.ajax()
                        .headers({ "Content-Type": "application/json" })
                        .post(app.config.host + "/Invoice/SaveInvoiceXoaBo", parameters, function (text) {
                            var result = JSON.parse(text);

                            var form = webix.$$("chukyso-form");
                            form.enable();
                            form.hideProgress();

                            if (result.hasOwnProperty("error")) {
                                webix.message({ type: "error", text: result["error"] });
                            }
                            else {
                                var table = webix.$$("windowData");
                                table.clearAll();
                                table.load(table.config.url);

                                $$("chukyso-win").close();
                            }

                        });

                }
            });
    }

    function signOnServerFile(data, cert, server_cert) {
        
        var parameters = {
            xml: data["InvoiceXmlData"],
            refUri: "#data",
            certSerial: cert.so_serial,
            tokenSerial: cert.tokenSerial,
            signId: "seller",
            signTag: "Signatures",
            pass: cert.pass,
            path: cert.path,
            inv_InvoiceAuth_id: data["inv_InvoiceAuth_id"]
        };

        data.serialNumber = cert.so_serial;

        webix.ajax()
            .bind(data)
            .headers({ "Content-Type": "application/json" })
            .post(server_cert + "/Token/SignXmlByFile", parameters, function (text) {
                var json = JSON.parse(text);

                if (json.hasOwnProperty("error")) {
                    webix.message({ type: "error", text: json["error"] });

                    var form = webix.$$("chukyso-form");
                    form.enable();
                    form.hideProgress();
                }
                else {
                    var parameters = this;
                    parameters.InvoiceXmlData = json.xml;

                    webix.ajax()
                        .headers({ "Content-Type": "application/json" })
                        .post(app.config.host + "/Invoice/SaveInvoiceXoaBo", parameters, function (text) {
                            var result = JSON.parse(text);

                            var form = webix.$$("chukyso-form");
                            form.enable();
                            form.hideProgress();

                            if (result.hasOwnProperty("error")) {
                                webix.message({ type: "error", text: result["error"] });
                            }
                            else {
                                var table = webix.$$("windowData");
                                table.clearAll();
                                table.load(table.config.url);

                                $$("chukyso-win").close();
                            }

                        });

                }
            });
    }

    function signOnICA(data, cert, server_cert) {
        var tblInvoice = webix.$$("windowData");
        var item = tblInvoice.getSelectedItem();

        var parameters = {
            agreementUUID: cert.agreementUUID,
            invoiceId: [item.inv_InvoiceAuth_id],
            pinCode: cert.pass,
            tagSignId: "data",
            tagSign: "Signatures"
        };

        data.serialNumber = cert.so_serial;

        webix.ajax()
            .bind(data)
            .headers({ "Content-Type": "application/json" })
            .post(app.config.host + "/TokenCloud/IcaSignInvoice32", parameters, function (text) {
                var json = JSON.parse(text);

                if (json.hasOwnProperty("error")) {
                    webix.message({ type: "error", text: json["error"] });
                }
                else {
                    var parameters = this;
                    parameters.InvoiceXmlData = json.data[0];

                    webix.ajax()
                        .headers({ "Content-Type": "application/json" })
                        .post(app.config.host + "/Invoice/SaveInvoiceXoaBo", parameters, function (text) {
                            var result = JSON.parse(text);

                            if (result.hasOwnProperty("error")) {
                                webix.message({ type: "error", text: result["error"] });
                            }
                            else if(result.hasOwnProperty("ok")) {
                                var table = webix.$$("windowData");
                                table.clearAll();
                                table.load(table.config.url);
                                $$("chukyso-win").close();
                                webix.message("Xóa bỏ biên lai thành công","success");
                            }
                        });
                }
                var form = webix.$$("chukyso-form");
                form.enable();
                form.hideProgress();
            });
    }

    return {
        $ui: {
            view: "window", modal: true, id: "chukyso-win", position: "center",
            head: "Xoá bỏ hóa đơn",
            width: 400,
            body: {
                paddingY: 10,
                paddingX: 10,
                view: "form",
                id: "chukyso-form",
                complexData: true,
                margin: 0,
                elements: [
                    {
                        view: "text",
                        label: _("SOVB"),
                        labelPosition: "top",
                        name: "sovb",
                        required: true,
                        invalidMessage: "Số văn bản không được để trống"
                    },
                    {
                        view: "datepicker",
                        label: _("NGAYVB"),
                        labelPosition: "top",
                        name: "ngayvb",
                        format: "%d/%m/%Y",
                        id: "ngayvanban",
                        required: true,
                        invalidMessage: "Ngày văn bản không được để trống"
                    },
                    {
                        view: "textarea",
                        name: "ghi_chu",
                        label: _("LY_DO_XB"),
                        labelPosition: "top",
                        height: 150
                    },
                    {
                        margin: 10,
                        cols: [
                            {},
                            {
                                shortcut: "F10", view: "button", label: "Nhận (F10)", type: "form", align: "center", width: 100,
                                on: {
                                    onClick: function () {

                                        var form = webix.$$("chukyso-form");

                                        if (form.validate() == false) return;

                                        var item = form.getValues();

                                        var table = webix.$$("windowData");
                                        var selectedItem = table.getSelectedItem();
                                        // xóa bỏ version 2
                                        var homeURL;
                                        if (document.location.protocol == "file:") {
                                            homeURL = version.getMST();
                                        }
                                        else {
                                            // cắt url lấy mst 
                                            homeURL = version.getURL().split('.')[0];
                                        }
                                        //console.log(homeURL);

                                        var ngayvanban = $$("ngayvanban").getValue();
                                        var ngayvanbanDate = new Date(Date.parse(ngayvanban));

                                        // var date2 = webix.Date.add(ngayvanbanDate, 1, "day");

                                        var format = webix.Date.dateToStr("%Y-%m-%d");
                                        var ngayvanbanXoabo = format(ngayvanbanDate);

                                        var dt = {
                                            id: selectedItem.id,
                                            sovb: item.sovb,
                                            ngayvb: ngayvanbanXoabo,
                                            ghi_chu: item.ghi_chu,
                                            //mst: version.getMST()
                                            mst: homeURL
                                        };

                                        var a = webix.ajax()
                                            .headers({ "Content-Type": "application/json" })
                                            .post(app.config.host + "/Invoice/GetThongTinXoaBo", {
                                                id: selectedItem.id,
                                                sovb: item.sovb,
                                                ngayvb: item.ngayvb,
                                                ghi_chu: item.ghi_chu
                                            });

                                        // var b = webix.ajax(app.config.host + "/Invoice/GetListCertificates");
                                        var b = webix.ajax(app.config.host + "/Invoice/GetListCertificatesAuto");

                                        var c = webix.ajax()
                                            .headers({ "Content-Type": "application/json" })
                                            .post(app.config.host + "/System/ExecuteCommand", {
                                                command: "CM00019",
                                                parameter: {
                                                    ma_dvcs: ""
                                                }
                                            });

                                        webix.extend(form, webix.ProgressBar);
                                        form.disable();
                                        form.showProgress();

                                        webix.promise.all([a, b, c]).then(function (results) {
                                            var a_result = results[0].json();
                                            var listcerts = results[1].json();
                                            var c_result = results[2].json();

                                            var form = webix.$$("chukyso-form");

                                            if (listcerts.length == 0) {
                                                webix.message({ type: "error", text: "Bạn chưa được phân quyền chứng thư số" });

                                                form.enable();
                                                form.hideProgress();

                                                return;
                                            }

                                            if (a_result.hasOwnProperty("error")) {
                                                webix.message({ type: 'error', text: a_result.error });

                                                form.enable();
                                                form.hideProgress();

                                                return;

                                            }

                                            var kytaptrung = "";
                                            var server_cert = "";

                                            for (var i = 0; i < c_result.length; i++) {
                                                var item = c_result[i];

                                                if (item.ma == "KYTAPTRUNG") {
                                                    kytaptrung = item.gia_tri;
                                                }

                                                if (item.ma == "SERVER_CERT") {
                                                    server_cert = item.gia_tri;
                                                }
                                            }

                                            //console.log(listcerts.length);

                                            if (kytaptrung == "C") {
                                                if (listcerts.length == 1) {
                                                    signOnServer(a_result, listcerts[0], server_cert);
                                                }
                                                else {
                                                    var box = webix.modalbox({
                                                        title: "Chọn chứng thư số",
                                                        buttons: ["Nhận", "Hủy bỏ"],
                                                        text: "<div id='ctnCerts'></div>",
                                                        top: 100,
                                                        width: 750,
                                                        callback: function (result) {
                                                            switch (result) {
                                                                case "1":
                                                                    var form = webix.$$("chukyso-form");
                                                                    form.enable();
                                                                    form.hideProgress();

                                                                    webix.modalbox.hide();
                                                                    break;
                                                                case "0":
                                                                    var table = $$("tblCerts");
                                                                    var data = table.serialize();

                                                                    var cert = null;

                                                                    for (var i = 0; i < data.length; i++) {
                                                                        if (data[i].chon == true) {
                                                                            cert = data[i];
                                                                            break;
                                                                        }
                                                                    }

                                                                    if (cert == null) {
                                                                        webix.message("Bạn chưa chọn chứng thư số");
                                                                        return;
                                                                    }

                                                                    webix.modalbox.hide();
                                                                    signOnServer(table.config.xmlData, cert, table.config.server_cert);

                                                                    break;
                                                            }
                                                        }
                                                    });

                                                    var popupText = document.getElementsByClassName("webix_popup_text")[0];
                                                    popupText.style.paddingTop = 0;

                                                    var tblMatHang = webix.ui({
                                                        container: "ctnCerts",
                                                        id: "tblCerts",
                                                        view: "datatable",
                                                        borderless: true,
                                                        xmlData: a_result,
                                                        server_cert: server_cert,
                                                        height: 350,
                                                        columns: [
                                                            {
                                                                id: "chon",
                                                                header: _("CHON"),
                                                                width: 65,
                                                                checkValue: true,
                                                                uncheckValue: false,
                                                                template: "{common.checkbox()}"
                                                            },
                                                            {
                                                                id: "so_serial",
                                                                header: _("SO_SERIAL"),
                                                                width: 150
                                                            },
                                                            {
                                                                id: "subjectname",
                                                                header: _("SUBJECTNAME"),
                                                                width: 450
                                                            },
                                                            {
                                                                id: "ngaybatdau",
                                                                header: _("NGAY_BAT_DAU"),
                                                                width: 200
                                                            },
                                                            {
                                                                id: "ngayketthuc",
                                                                header: _("NGAY_KET_THUC"),
                                                                width: 200
                                                            },
                                                            {
                                                                id: "issuer",
                                                                header: _("DONVI"),
                                                                width: 450
                                                            },
                                                        ],
                                                        url: app.config.host + "/Invoice/GetListCertificates"
                                                    });
                                                }
                                            }
                                            else {
                                                if (kytaptrung == "FILE") {
                                                    var box = webix.modalbox({
                                                        title: "Chọn chứng thư số",
                                                        buttons: ["Nhận", "Hủy bỏ"],
                                                        text: "<div id='ctnCerts'></div>",
                                                        top: 100,
                                                        width: 750,
                                                        callback: function (result) {
                                                            switch (result) {
                                                                case "1":
                                                                    var form = webix.$$("chukyso-form");
                                                                    form.enable();
                                                                    form.hideProgress();

                                                                    webix.modalbox.hide();
                                                                    break;
                                                                case "0":
                                                                    var table = $$("tblCerts");
                                                                    var data = table.serialize();

                                                                    var cert = null;

                                                                    for (var i = 0; i < data.length; i++) {
                                                                        if (data[i].chon == true) {
                                                                            cert = data[i];
                                                                            break;
                                                                        }
                                                                    }

                                                                    if (cert == null) {
                                                                        webix.message("Bạn chưa chọn chứng thư số");
                                                                        return;
                                                                    }

                                                                    webix.modalbox.hide();
                                                                    signOnServerFile(table.config.xmlData, cert, table.config.server_cert);

                                                                    break;
                                                            }
                                                        }
                                                    });

                                                    var popupText = document.getElementsByClassName("webix_popup_text")[0];
                                                    popupText.style.paddingTop = 0;

                                                    var tblMatHang = webix.ui({
                                                        container: "ctnCerts",
                                                        id: "tblCerts",
                                                        view: "datatable",
                                                        borderless: true,
                                                        xmlData: a_result,
                                                        server_cert: server_cert,
                                                        height: 350,
                                                        columns: [
                                                            {
                                                                id: "chon",
                                                                header: _("CHON"),
                                                                width: 65,
                                                                checkValue: true,
                                                                uncheckValue: false,
                                                                template: "{common.checkbox()}"
                                                            },
                                                            {
                                                                id: "so_serial",
                                                                header: _("SO_SERIAL"),
                                                                width: 150
                                                            },
                                                            {
                                                                id: "subjectname",
                                                                header: _("SUBJECTNAME"),
                                                                width: 450
                                                            },
                                                            {
                                                                id: "ngaybatdau",
                                                                header: _("NGAY_BAT_DAU"),
                                                                width: 200
                                                            },
                                                            {
                                                                id: "ngayketthuc",
                                                                header: _("NGAY_KET_THUC"),
                                                                width: 200
                                                            },
                                                            {
                                                                id: "issuer",
                                                                header: _("DONVI"),
                                                                width: 450
                                                            },
                                                        ],
                                                        url: app.config.host + "/Invoice/GetListCertificatesFile"
                                                    });
                                                }
                                                else {
                                                    if (kytaptrung == "CLOUD") {
                                                        var box = webix.modalbox({
                                                            title: "Chọn chứng thư số",
                                                            buttons: ["Nhận", "Hủy bỏ"],
                                                            text: "<div id='ctnCerts'></div>",
                                                            top: 100,
                                                            width: 750,
                                                            callback: function (result) {
                                                                switch (result) {
                                                                    case "1":
                                                                        webix.modalbox.hide();
                                                                        break;
                                                                    case "0":

                                                                        var table = $$("tblCerts");
                                                                        var data = table.serialize();

                                                                        var cert = null;

                                                                        for (var i = 0; i < data.length; i++) {
                                                                            if (data[i].chon == true) {
                                                                                cert = data[i];
                                                                                break;
                                                                            }
                                                                        }

                                                                        if (cert == null) {
                                                                            webix.message("Bạn chưa chọn chứng thư số", "debug");
                                                                            var table = webix.$$("dmwindowData");
                                                                            table.enable();
                                                                            table.hideProgress();
                                                                            return;
                                                                        }
                                                                        // console.log(cert);

                                                                        var frm = $$("chukyso-win").$scope.ui(signCloudXoabo.$ui);
                                                                        signCloudXoabo.initUI(table.config.xmlData, cert);
                                                                        frm.show();
                                                                }
                                                            }
                                                        });

                                                        var popupText = document.getElementsByClassName("webix_popup_text")[0];
                                                        popupText.style.paddingTop = 0;

                                                        var tblMatHang = webix.ui({
                                                            container: "ctnCerts",
                                                            id: "tblCerts",
                                                            view: "datatable",
                                                            xmlData: a_result,
                                                            borderless: true,
                                                            resizeColumn: true,
                                                            height: 350,
                                                            columns: [
                                                                {
                                                                    id: "chon",
                                                                    header: _("CHON"),
                                                                    width: 65,
                                                                    checkValue: true,
                                                                    uncheckValue: false,
                                                                    template: "{common.checkbox()}"
                                                                },
                                                                {
                                                                    id: "libraryName",
                                                                    header: _("Loại"),
                                                                    width: 150
                                                                },
                                                                {
                                                                    id: "agreementUUID",
                                                                    header: _("ID"),
                                                                    width: 150
                                                                },
                                                                {
                                                                    id: "so_serial",
                                                                    header: _("SO_SERIAL"),
                                                                    width: 150
                                                                },
                                                                {
                                                                    id: "subjectname",
                                                                    header: _("SUBJECTNAME"),
                                                                    width: 450
                                                                },
                                                                {
                                                                    id: "ngaybatdau",
                                                                    header: _("NGAY_BAT_DAU"),
                                                                    width: 200
                                                                },
                                                                {
                                                                    id: "ngayketthuc",
                                                                    header: _("NGAY_KET_THUC"),
                                                                    width: 200
                                                                },
                                                                {
                                                                    id: "issuer",
                                                                    header: _("DONVI"),
                                                                    width: 450
                                                                },
                                                            ],
                                                            url: app.config.host + "/Invoice/GetListCertificatesCloud"
                                                        });
                                                    }
                                                    else {
                                                        if (kytaptrung == "EASYCA") {
                                                            var box = webix.modalbox({
                                                                title: "Chọn chứng thư số",
                                                                buttons: ["Nhận", "Hủy bỏ"],
                                                                text: "<div id='ctnCerts'></div>",
                                                                top: 100,
                                                                width: 750,
                                                                callback: function (result) {
                                                                    switch (result) {
                                                                        case "1":
                                                                            webix.modalbox.hide();
                                                                            break;
                                                                        case "0":

                                                                            var table = $$("tblCerts");
                                                                            var data = table.serialize();

                                                                            var cert = null;

                                                                            for (var i = 0; i < data.length; i++) {
                                                                                if (data[i].chon == true) {
                                                                                    cert = data[i];
                                                                                    break;
                                                                                }
                                                                            }

                                                                            if (cert == null) {
                                                                                webix.message("Bạn chưa chọn chứng thư số", "debug");
                                                                                var table = webix.$$("dmwindowData");
                                                                                table.enable();
                                                                                table.hideProgress();
                                                                                return;
                                                                            }
                                                                            
                                                                            // console.log(cert);
                                                                            var frm = $$("chukyso-win").$scope.ui(signEasyCAXoabo.$ui);
                                                                            signEasyCAXoabo.initUI(table.config.xmlData, cert);
                                                                            frm.show();
                                                                    }
                                                                }
                                                            });

                                                            var popupText = document.getElementsByClassName("webix_popup_text")[0];
                                                            popupText.style.paddingTop = 0;

                                                            var tblMatHang = webix.ui({
                                                                container: "ctnCerts",
                                                                id: "tblCerts",
                                                                view: "datatable",
                                                                xmlData: a_result,
                                                                borderless: true,
                                                                resizeColumn: true,
                                                                height: 350,
                                                                columns: [
                                                                    {
                                                                        id: "chon",
                                                                        header: _("CHON"),
                                                                        width: 65,
                                                                        checkValue: true,
                                                                        uncheckValue: false,
                                                                        template: "{common.checkbox()}"
                                                                    },
                                                                    {
                                                                        id: "libraryName",
                                                                        header: _("Loại"),
                                                                        width: 150
                                                                    },
                                                                    {
                                                                        id: "so_serial",
                                                                        header: _("SO_SERIAL"),
                                                                        width: 150
                                                                    }
                                                                ],
                                                                url: app.config.host + "/Invoice/GetListCertificatesEasyCA"
                                                            });
                                                        }
                                                        else {
                                                            if (kytaptrung == "ICA") {
                                                                var box = webix.modalbox({
                                                                    title: "Chọn chứng thư số",
                                                                    buttons: ["Nhận", "Hủy bỏ"],
                                                                    text: "<div id='ctnCerts'></div>",
                                                                    top: 100,
                                                                    width: 750,
                                                                    callback: function (result) {
                                                                        switch (result) {
                                                                            case "1":
                                                                                var form = webix.$$("chukyso-form");
                                                                                form.enable();
                                                                                form.hideProgress();
            
                                                                                webix.modalbox.hide();
                                                                                break;
                                                                            case "0":
                                                                                var table = $$("tblCerts");
                                                                                var data = table.serialize();
            
                                                                                var cert = null;
            
                                                                                for (var i = 0; i < data.length; i++) {
                                                                                    if (data[i].chon == true) {
                                                                                        cert = data[i];
                                                                                        break;
                                                                                    }
                                                                                }
            
                                                                                if (cert == null) {
                                                                                    webix.message("Bạn chưa chọn chứng thư số");
                                                                                    return;
                                                                                }
            
                                                                                webix.modalbox.hide();
                                                                                signOnICA(table.config.xmlData, cert, table.config.server_cert);
                                                                                var form = webix.$$("chukyso-form");
                                                                                form.enable();
                                                                                form.hideProgress();
            
                                                                                webix.modalbox.hide();
                                                                                break;
                                                                        }
                                                                    }
                                                                });
            
                                                                var popupText = document.getElementsByClassName("webix_popup_text")[0];
                                                                popupText.style.paddingTop = 0;
            
                                                                var tblMatHang = webix.ui({
                                                                    container: "ctnCerts",
                                                                    id: "tblCerts",
                                                                    view: "datatable",
                                                                    borderless: true,
                                                                    xmlData: a_result,
                                                                    server_cert: server_cert,
                                                                    height: 350,
                                                                    columns: [
                                                                        {
                                                                            id: "chon",
                                                                            header: _("CHON"),
                                                                            width: 65,
                                                                            checkValue: true,
                                                                            uncheckValue: false,
                                                                            template: "{common.checkbox()}"
                                                                        },
                                                                        {
                                                                            id: "so_serial",
                                                                            header: _("SO_SERIAL"),
                                                                            width: 150
                                                                        },
                                                                        {
                                                                            id: "subjectname",
                                                                            header: _("SUBJECTNAME"),
                                                                            width: 450
                                                                        },
                                                                        {
                                                                            id: "ngaybatdau",
                                                                            header: _("NGAY_BAT_DAU"),
                                                                            width: 200
                                                                        },
                                                                        {
                                                                            id: "ngayketthuc",
                                                                            header: _("NGAY_KET_THUC"),
                                                                            width: 200
                                                                        },
                                                                        {
                                                                            id: "issuer",
                                                                            header: _("DONVI"),
                                                                            width: 450
                                                                        },
                                                                    ],
                                                                    url: app.config.host + "/Invoice/GetListCertificatesAuto"
                                                                });
                                                            }
                                                            else {
                                                                console.log("Signature_Client");
                                                                //console.log(a_result);
                                                                var hub = plugin.hub();
                                                                var hubconnect = plugin.conn();
                                                                if (hubconnect.state != 1) {
                                                                    var form = webix.$$("chukyso-form");
                                                                    form.enable();
                                                                    form.hideProgress();
                                                                    webix.message("Quý khách hàng chưa cài Plugin ký hóa đơn hoặc Plugin ký hóa đơn chưa được bật !", "error");
                                                                    return;
                                                                }
                                                                else {
    
                                                                    hub.off('resCommand');
                                                                    hub.on('resCommand', function (result) {
                                                                        var json = JSON.parse(result);
    
                                                                        if (json.hasOwnProperty("error")) {
                                                                            webix.message({ type: 'error', text: json.error });
    
                                                                            var form = webix.$$("chukyso-form");
                                                                            form.enable();
                                                                            form.hideProgress();
    
                                                                        }
                                                                        else {
                                                                            var callback = json.callback;
    
                                                                            if (callback == "SignCancelInvoice") {
                                                                                var parameters = json.data;
    
                                                                                if (parameters.hasOwnProperty("error")) {
                                                                                    webix.message({ type: "error", text: parameters["error"] });
                                                                                }
                                                                                else {
                                                                                    var table = webix.$$("windowData");
                                                                                    table.clearAll();
                                                                                    table.load(table.config.url);
    
                                                                                    $$("chukyso-win").close();
                                                                                }
                                                                                // webix.ajax()
                                                                                //     .headers({ "Content-Type": "application/json" })
                                                                                //     .post(app.config.host + "/Invoice/SaveInvoiceXoaBo", parameters, function (text) {
                                                                                //         var result = JSON.parse(text);
    
                                                                                //         var form = webix.$$("chukyso-form");
                                                                                //         form.enable();
                                                                                //         form.hideProgress();
    
                                                                                //         if (result.hasOwnProperty("error")) {
                                                                                //             webix.message({ type: "error", text: result["error"] });
                                                                                //         }
                                                                                //         else {
                                                                                //             var table = webix.$$("windowData");
                                                                                //             table.clearAll();
                                                                                //             table.load(table.config.url);
    
                                                                                //             $$("chukyso-win").close();
                                                                                //         }
                                                                                //     });
                                                                            }
                                                                        }
                                                                    });
                                                                    // Nếu dùng ver2 thì cần put lên (mst và thông tin xóa bỏ)
    
                                                                    var arg = {
                                                                        // callback: "SignCancelInvoice",
                                                                        callback: "SignCancelInvoiceVer2",
                                                                        idData: "#data",
                                                                        // data: a_result,
                                                                        data: dt,
                                                                        idSigner: "seller",
                                                                        tagSign: "Signatures",
                                                                        listcerts: listcerts,
                                                                        // mst: version.getMST()
                                                                        mst: homeURL
                                                                    };
                                                                    // console.log(arg);
    
                                                                    hub.invoke('execCommand', arg.callback, JSON.stringify(arg))
                                                                        .done(function () {
                                                                            console.log("Success SignCancelInvoice!")
                                                                        })
                                                                        .fail(function (error) {
                                                                            console.log("Lỗi");
                                                                            console.log(error);
                                                                            var form = webix.$$("chukyso-form");
                                                                            form.enable();
                                                                            form.hideProgress();
    
                                                                            webix.message(error, "error");
                                                                        });
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }

                                        }).fail(function (err) {
                                            alert(err);

                                            var form = webix.$$("chukyso-form");
                                            form.enable();
                                            form.hideProgress();
                                        });

                                    }
                                },
                                click: function () {
                                    this.callEvent("onClick");
                                }
                            },
                            {
                                view: "button", hotkey: "esc", label: "Hủy bỏ (ESC)", type: "danger", align: "center", width: 100,
                                click: function () {
                                    webix.$$("chukyso-win").close();
                                }
                            },
                            {}
                        ]
                    }

                ]
            }

        },
        setEditMode: function (mode) {
            editmode = mode;
        }
    };

});
define('views/hotro',[
    "app",
    "locale",
    "views/forms/license",
], function (app, _, licenseForm) {
    'use strict';

    webix.$$("title").parse({ title: "Gửi yêu cầu hỗ trợ đến M-Invoice", details: "Gửi yêu cầu hỗ trợ đến M-Invoice" });

    var layout = {
        // paddingY: 60,
        // paddingX: 500,
        cols: [
            { gravity: 1, template: "" },
            {
                rows: [
                    { gravity: 1, template: "" },
                    // {
                    //     height: 35,
                    //     type: "toolbar",
                    //     cols: controls
                    // },
                    {
                        // view: "scrollview",
                        // scroll: "y",
                        // body: {
                        view: "form",
                        id: "form_hotro",
                        paddingY: 10,
                        // width: 500,
                        // height: 500,
                        position: "center",
                        paddingX: 10,
                        complexData: true,
                        margin: 0,
                        elements: [
                            {
                                view: "text",
                                name: "ms_thue",
                                id: "ms_thue",
                                label: _("MS_THUE"),
                                css: "mcls_readonly_text",
                                readonly: true,
                                labelPosition: "top"
                            },
                            {
                                view: "text",
                                name: "ten_dvcs",
                                id: "ten_dvcs",
                                label: _("DONVI"),
                                css: "mcls_readonly_text",
                                readonly: true,
                                labelPosition: "top"
                            },
                            {
                                view: "text",
                                name: "dia_chi",
                                label: _("DIA_CHI"),
                                css: "mcls_readonly_text",
                                readonly: true,
                                labelPosition: "top"
                            },
                            {
                                cols: [
                                    {
                                        view: "text",
                                        name: "nguoi_dai_dien",
                                        label: _("NGUOI_DAI_DIEN_PL"),
                                        css: "mcls_readonly_text",
                                        readonly: true,
                                        labelPosition: "top"
                                    },
                                    {
                                        view: "text",
                                        name: "email",
                                        label: "Email",
                                        css: "mcls_readonly_text",
                                        readonly: true,
                                        labelPosition: "top"
                                    }
                                ]
                            },
                            {
                                cols: [
                                    {
                                        view: "text",
                                        name: "nguoi_lien_he",
                                        id: "nguoi_lien_he",
                                        label: _("Người liên hệ"),
                                        labelPosition: "top",
                                        required: true,
                                        invalidMessage: "Bạn phải nhập người liên hệ"
                                    },

                                    {
                                        view: "text",
                                        name: "sdt",
                                        id: "sdt",
                                        label: "Số điện thoại",
                                        labelPosition: "top",
                                        required: true,
                                        //webix.ru
                                        invalidMessage: "Bạn phải nhập số điện thoại"
                                    }
                                ]
                            },
                            {
                                cols: [
                                    {
                                        view: "text",
                                        name: "teamview",
                                        id: "teamview",
                                        label: _("Teamview (UltraViewer)"),
                                        labelPosition: "top"
                                    },

                                    {
                                        view: "text",
                                        name: "pass",
                                        id: "pass",
                                        label: "Password",
                                        labelPosition: "top"
                                    }
                                ]
                            },
                            {
                                id: "noi_dung",
                                view: "textarea",
                                name: "noi_dung",
                                label: "Yêu cầu hỗ trợ",
                                height: 160,
                                labelPosition: "top"

                            },

                            {
                                margin: 10,
                                cols: [
                                    {},
                                    {
                                        shortcut: "F10", view: "button", type:"form", label: "Gửi (F10)", align: "center", width: 120,
                                        on: {
                                            onClick: function () {
                                                var form = webix.$$("form_hotro");

                                                var item = form.getValues();
                                                var format = webix.Date.dateToStr("%d/%m/%Y - %H:%i");
                                                var string = format(new Date());

                                                var descrip = "Ngày :" + string + "</br>"
                                                    + "Công ty :" + item.ten_dvcs + "</br>"
                                                    + "Mã số thuế :" + item.ms_thue + "</br>"
                                                    + "Người liên hệ: " + item.nguoi_lien_he + "</br>"
                                                    + "Số điện thoại: " + item.sdt + "</br>"
                                                    + "Teamview (UltraViewer): " + item.teamview + "</br>"
                                                    + "Pass: " + item.pass + "</br>"
                                                    + "Nội dung cần hỗ trợ: " + item.noi_dung + "</br>";

                                                if ($$("form_hotro").validate()) {
                                                    var box = webix.modalbox({
                                                        title: "Đang gửi yêu cầu hỗ trợ đến M-Invoice",
                                                        text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                                                        width: 350,
                                                        height: 200
                                                    });

                                                    var data = {
                                                        "mst": item.ms_thue,
                                                        "noidung": item.noi_dung,
                                                        "nguoi_lien_he": item.nguoi_lien_he,
                                                        "sdt_nguoi_lien_he": item.sdt,
                                                        "ultra_teamview": item.teamview,
                                                        "pass": item.pass
                                                    }
                                                    webix.ajax()
                                                        .headers({ 'Content-type': 'application/json' })
                                                        .post(app.config.host + "/System/SendSupport", data, {
                                                            error: function (text, data, XmlHttpRequest) {
                                                                webix.modalbox.hide(box);
                                                                alert(text);
                                                            },
                                                            success: function (text, data, XmlHttpRequest) {
                                                                var json = JSON.parse(text);
                                                                if (!json.hasOwnProperty("error")) {
                                                                    $$("nguoi_lien_he").setValue(null);
                                                                    $$("sdt").setValue(null);
                                                                    $$("teamview").setValue(null);
                                                                    $$("pass").setValue(null);
                                                                    $$("noi_dung").setValue(null);
                                                                    webix.message("Gửi yêu cầu hỗ trợ thành công !", "debug");
                                                                }
                                                                else {
                                                                    webix.message(json.error, "error");
                                                                }
                                                                webix.modalbox.hide(box);
                                                            }
                                                        });
                                                }
                                            }
                                        },
                                        click: function () {
                                            this.callEvent("onClick");

                                        }
                                    },
                                    {
                                        view: "button", hotkey: "esc", label: "Nhập lại (ESC)", align: "center", width: 120, type: "danger",
                                        click: function () {
                                            $$("nguoi_lien_he").setValue(null);
                                            $$("sdt").setValue(null);
                                            $$("teamview").setValue(null);
                                            $$("pass").setValue(null);
                                            $$("noi_dung").setValue(null);
                                            // webix.$$("chukyso-win").close();
                                        }
                                    },
                                    {}
                                ]
                            }

                        ]
                    },
                    { gravity: 1, template: "" }
                ]
            },
            { gravity: 1, template: "" }
        ]

    };

    return {
        $ui: layout,
        $oninit: function (view, $scope) {

            var url = app.config.host + "/System/GetInfoCompany";

            webix.ajax(url, function (text) {
                var json = JSON.parse(text);
                $$("form_hotro").setValues(json);

            });
        }

    };
});
define('views/infocompany',[
    "app",
    "locale",
    "views/forms/license",
    "views/forms/lichsudmdvcs"
], function (app, _, licenseForm, lichsudmdvcs) {
    'use strict';

    var controls = [
        {
            id: "btnGoHome",
            view: "button",
            css: "webix_danger",
            type: "icon",
            icon: "mdi mdi-home-outline",
            label: _("Trang chủ"),
            width: 105,
            on: {
                onClick: function () {
                    require(["app"], function (app) {
                        // app.show("/app/dashboard")
                        app.router("/app/dashboard");
                    });
                }
            },
            click: function () {
                this.callEvent("onClick");
            }

        },
        {
            id: "btnSave",
            view: "button",
            css: "webix_primary",
            type: "icon",
            icon: "mdi mdi-check-all",
            label: _("Lưu dữ liệu"),
            badge: "F10",
            width: 135,
            shortcut: "F10",
            on: {
                onClick: function () {
                    webix.confirm({
                        title: "CHÚ Ý",
                        text: "Tất cả các hóa đơn ký sau thời điểm này sẽ lưu thông tin mới vào dữ liệu xml. Bạn có chắc chắn muốn thay đổi thông tin ?", ok: "Có", cancel: "Không",
                        type: "confirm-warning",
                        callback: function (res) {
                            if (res) {
                                var txtEmail = webix.$$("email");

                                if (txtEmail.validate() == false) {
                                    webix.message("Email không hợp lệ");
                                    return;
                                };

                                var form = webix.$$("foInfoCompany");
                                webix.extend(form, webix.ProgressBar);
                                form.disable();
                                form.showProgress();
                                if (form.validate({ disabled: true })) {
                                    var item = form.getValues();
                                    delete item.lancapnhat;
                                    // delete item.editmode;
                                    webix.ajax()
                                        .headers({ 'Content-type': 'application/json' })
                                        .post(app.config.host + "/System/SaveInfoCompany", item, function (text) {
                                            var data = JSON.parse(text);
                                            form.enable();
                                            form.hideProgress();
                                            if (!data.hasOwnProperty("error")) {
                                                webix.message({ type: "debug", text: "Đã lưu thành công" });
                                                webix.$$("btnInfoCompany").callEvent("onClick")
                                            }
                                            else {
                                                webix.message({ type: "error", text: data.error });
                                            }
                                        });
                                } else {
                                    form.enable();
                                    form.hideProgress();
                                }
                            }
                        }
                    });
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {}
    ];
    var fmDatetime = function (params) {
        var format = webix.Date.dateToStr("%d/%m/%Y %H:%m:%s");
        params = removeTimeZoneT(params);
        return format(params);
    }
    var layout = {
        rows: [
            {
                cols: [
                    {
                        paddingY: 10,
                        paddingX: 10,
                        rows: [
                            { paddingY: 5, cols: controls },
                            {
                                view: "form",
                                id: "foInfoCompany",
                                // minWidth: 800,
                                paddingY: 20,
                                paddingX: 20,
                                // borderless: true,
                                complexData: true,
                                elementsConfig: { labelWidth: 120 },
                                margin: 0,
                                elements: [
                                    {
                                        cols: [
                                            {
                                                view: "text",
                                                name: "ms_thue",
                                                id: "ms_thue",
                                                label: _("MS_THUE"),
                                                css: "mcls_readonly_text",
                                                readonly: true,
                                                labelPosition: "left"
                                            },
                                            {
                                                view: "text",
                                                name: "macqt_mttien",
                                                id: "macqt_mttien",
                                                label: _("Mã định danh MTT"),
                                                css: "mcls_readonly_text",
                                                readonly: true,
                                                labelPosition: "left",
                                            },
                                        ]
                                    },

                                    {
                                        view: "text",
                                        name: "ten_dvcs",
                                        label: _("DONVI"),
                                        // css: "mcls_readonly_text",
                                        // readonly: true,
                                        labelPosition: "left"
                                    },
                                    {
                                        view: "text",
                                        name: "dia_chi",
                                        label: _("DIA_CHI"),
                                        // css: "mcls_readonly_text",
                                        // readonly: true,
                                        labelPosition: "left"
                                    },
                                    {
                                        cols: [
                                            {
                                                view: "text",
                                                name: "nguoi_dai_dien",
                                                label: _("Người liên hệ"),
                                                // css: "mcls_readonly_text",
                                                // readonly: true,
                                                labelPosition: "left"
                                            },
                                            {
                                                id: "email",
                                                view: "text",
                                                name: "email",
                                                label: "Email",
                                                // css: "mcls_readonly_text",
                                                // readonly: true,
                                                labelPosition: "left",
                                                invalidMessage: "Email không hợp lệ",
                                                validate: webix.rules.isEmail,
                                                on: {
                                                    onChange: function (newv, oldv) {
                                                        if (newv != "") {
                                                            this.validate();
                                                        }
                                                    }
                                                }
                                            }
                                        ]
                                    },
                                    {
                                        cols: [
                                            {
                                                view: "text",
                                                name: "chuc_vu",
                                                label: _("CHUC_VU"),
                                                // css: "mcls_readonly_text",
                                                // readonly: true,
                                                labelPosition: "left"
                                            },
                                            {
                                                view: "text",
                                                name: "ngay_bd_nam_tc",
                                                label: _("NGAY_BD_NAM_TC"),
                                                placeholder: "dd/mm",
                                                labelPosition: "left",
                                                invalidMessage: _("NGAY_BD_NAM_TC") + " không hợp lệ",
                                                on: {
                                                    onChange: function (newv, oldv) {
                                                        this.validate();
                                                    }
                                                }
                                            }
                                        ]
                                    },
                                    {
                                        cols: [
                                            {
                                                view: "text",
                                                name: "dien_thoai",
                                                label: _("DIEN_THOAI"),
                                                labelPosition: "left",
                                                validate: webix.rules.isPhoneNumber,
                                                invalidMessage: "Định dạng điện thoại nhập không đúng",
                                                attributes: { maxlength: 20 },
                                                on: {
                                                    onChange: function (newv, oldv) {
                                                        if (newv != "") {
                                                            this.validate();
                                                        }
                                                    }
                                                }
                                            },

                                            {
                                                view: "text",
                                                name: "fax",
                                                label: "Fax",
                                                labelPosition: "left",
                                                validate: webix.rules.isPhoneNumber,
                                                invalidMessage: "Định dạng fax nhập không đúng",
                                                on: {
                                                    onChange: function (newv, oldv) {
                                                        if (newv != "") {
                                                            this.validate();
                                                        }
                                                    }
                                                }
                                            }
                                        ]
                                    },
                                    {
                                        cols: [
                                            {
                                                view: "text",
                                                name: "tinh_thanh",
                                                label: _("TINH_THANH"),
                                                labelPosition: "left"
                                            },

                                            {
                                                view: "text",
                                                name: "quan_huyen",
                                                label: "Quận huyện",
                                                labelPosition: "left"
                                            }
                                        ]
                                    },
                                    {
                                        cols: [
                                            {
                                                view: "text",
                                                name: "tai_khoan",
                                                label: _("TAI_KHOAN"),
                                                labelPosition: "left",
                                                validate: webix.rules.isPhoneNumber,
                                                invalidMessage: "Định dạng tài khoản nhập không đúng",
                                                on: {
                                                    onChange: function (newv, oldv) {
                                                        if (newv != "") {
                                                            this.validate();
                                                        }
                                                    }
                                                }
                                            },
                                            {
                                                view: "text",
                                                name: "tai_nh",
                                                label: _("TAI_NH"),
                                                labelPosition: "left"
                                            }
                                        ]
                                    },
                                    {
                                        cols: [
                                            {
                                                view: "combo",
                                                name: "ma_cqthuecaptinh",
                                                label: "CQ thuế cấp tỉnh",
                                                labelPosition: "left",
                                                options: app.config.host + "/Pattern/GetTaxProvince",
                                                on: {
                                                    onChange: function (newv, oldv) {
                                                        var url = app.config.host + "/Pattern/GetTaxQLbyNhom?id=" + newv;
                                                        webix.ajax()
                                                            .headers({ 'Content-Type': 'application/json' })
                                                            .get(
                                                                url,
                                                                function (text) {
                                                                    var result = JSON.parse(text);
                                                                    var list = $$("ma_cqthuecapql").getPopup().getList();
                                                                    list.clearAll();
                                                                    list.parse(result);
                                                                });
                                                    }
                                                }
                                            },
                                            {
                                                id: "ma_cqthuecapql",
                                                view: "combo",
                                                name: "ma_cqthuecapql",
                                                label: "Chi cục thuế quản lý",
                                                labelPosition: "left",
                                                options: []
                                            }
                                        ]
                                    },
                                    { view: "template", template: "Thông tin người đại diện pháp luật", type: "section" },
                                    {
                                        cols: [
                                            {
                                                view: "text",
                                                name: "ten_ndd",
                                                label: _("Tên người đại diện"),
                                                attributes: { maxlength: 50 },
                                                labelPosition: "left",
                                            },
                                            {
                                                view: "text",
                                                name: "dthoai_ndd",
                                                label: _("Số điện thoại"),
                                                labelPosition: "left",
                                            }
                                        ]
                                    },
                                    {
                                        cols: [
                                            {
                                                view: "text",
                                                name: "cccd_ndd",
                                                id: "cccd_ndd",
                                                label: _("Căn cước công dân"),
                                                attributes: { maxlength: 12 },
                                                validate: function (value) {
                                                    var form = $$("foInfoCompany");
                                                    var input = form.elements.cccd_ndd;
                                                    var use_cccd = form.getValues().use_cccd;
                                                    if (use_cccd) {
                                                        if (value.length == 0) {
                                                            input.define("invalidMessage", "CCCD không được để trống ")
                                                            return false;
                                                        }
                                                        if (!webix.rules.isTaxOrCCCD(value)) {
                                                            return false
                                                        }
                                                        var genderNumber = Number.parseInt(value[3])
                                                        var genderValue = form.getValues().gtinh_ndd
                                                        if (!genderValue || (genderValue == "M" && ![0, 2, 4].includes(genderNumber)) || (genderValue == "F" && ![1, 3, 5].includes(genderNumber))) {
                                                            input.define("invalidMessage", "Giới tính không hợp lệ so với căn cước khai báo")
                                                            return false
                                                        }
                                                        return true
                                                    }
                                                        return true
                                                },
                                                invalidMessage: "Căn cước công dân không hợp lệ",
                                            },
                                            {
                                                view: "checkbox",
                                                name: "use_cccd",
                                                id: "use_cccd",
                                                labelRight: "Hộ kinh doanh sử dụng căn cước công dân thay mã số thuế",
                                                labelWidth: 0,
                                                labelPosition: "right",
                                            },
                                        ]
                                    },
                                    {
                                        view: "text",
                                        name: "shchieu_ndd",
                                        label: _("Hộ chiếu"),
                                        labelPosition: "left",
                                        attributes: { maxlength: 20 }
                                    },
                                    {
                                        cols: [
                                            {
                                                view: "datepicker",
                                                name: "nsinh_ndd",
                                                label: _("Ngày sinh"),
                                                labelPosition: "left",
                                                suggest: {
                                                    type: "calendar",
                                                    body: {
                                                        maxDate: new Date().toISOString().split('T')[0],
                                                    }
                                                }
                                            },
                                            {
                                                css: { "margin-top": "3px !important" },
                                                view: "radio",
                                                name: "gtinh_ndd",
                                                label: _('Giới tính'),
                                                labelPosition: "left",
                                                optionHeight: 26,
                                                options: [
                                                    { id: "M", value: "Nam" },
                                                    { id: "F", value: "Nữ" },
                                                ]
                                            },
                                        ]
                                    },
                                    { view: "template", template: "Thông tin đơn vị chủ quản", type: "section" },
                                    {
                                        view: "text",
                                        name: "mst_dvcq",
                                        label: _("MS_THUE"),
                                        validate: webix.rules.isTaxCode,
                                        invalidMessage: "Mã số thuế không hợp lệ",
                                        labelPosition: "left",
                                        on: {
                                            onChange: function (newv, oldv) {
                                                if (newv != "") {
                                                    this.validate();
                                                }
                                            }
                                        }
                                    },
                                    {
                                        view: "text",
                                        name: "ten_dvcq",
                                        label: _("DONVI"),
                                        labelPosition: "left"
                                    },
                                    {
                                        view: "text",
                                        name: "email_dvcq",
                                        validate: webix.rules.isEmail,
                                        invalidMessage: "Email không hợp lệ",
                                        label: _("EMAIL"),
                                        labelPosition: "left",
                                        on: {
                                            onChange: function (newv, oldv) {
                                                if (newv != "") {
                                                    this.validate();
                                                }
                                            }
                                        }
                                    }
                                ],
                                rules: {
                                    ngay_bd_nam_tc: function (value) {
                                        if (value != "") {

                                            if (value.toString().length != 5)
                                                return false;

                                            var patt = /^[0-1][1-2][/][0-9][0-9]$/;

                                            return patt.test(value);

                                        }
                                        return true;
                                    }
                                }
                            }
                        ]
                    },
                    {
                        paddingY: 10,
                        paddingX: 10,
                        rows: [
                            {
                                cols: [
                                    {
                                        template: `<br><i class="mdi mdi-star-outline font-size-18 me-2 align-middle"></i><b>Lịch sử thay đổi thông tin</b>`, height: 40,
                                        type: "clean"
                                    },
                                    {
                                        view: "button", type: "htmlbutton", width: 100,
                                        label: '<i class="fa fa-refresh fa-lg" aria-hidden="true"></i> ' +
                                            '<span class="text">' + _("REFRESH") + '</span>',
                                        id: "btnReloadInfo",
                                        css: "btnInfoCompany",
                                        on: {
                                            onClick: function () {
                                                webix.callEvent("onLoadError");
                                                var table = webix.$$("InfocompanyHistory");
                                                table.clearAll();
                                                table.load(table.config.url);
                                            }
                                        },
                                        click: function () {
                                            this.callEvent("onClick");
                                        }
                                    }
                                ]

                            },
                            {
                                view: "list",
                                id: "InfocompanyHistory",
                                width: 450,
                                select: true,
                                tooltip: function (obj) {
                                    return moment(obj.date_new).format("DD/MM/YYYY") + " - " + obj.user_new;
                                },
                                on: {
                                    onItemClick: function (id, e, node) {
                                        var item = this.getItem(id);
                                        var data = "<pre>" + item.ghichu + "</pre>";
                                        $$("contentLog").setHTML(data);
                                    }
                                },
                                url: app.config.host + "/System/GetLogDmdvcs",
                                template: function (item) {
                                    return "- " + fmDatetime(item.datelog) + " : " + item.user_new + " <span style='color: #00b300'><i class='fas fa-check'></i></span>";
                                }
                            },
                            { height: 5, template: "" },
                            { paddingY: 5, view: "template", id: "contentLog", scroll: "xy", type: { height: "auto" } }
                        ]
                    }
                ]
            },
            { gravity: 0.5, template: "", css: { "background": "#F2F7FC !important" } }
        ],
    };

    var scrollContainer = {
        view: "scrollview",
        scroll: "y",
        body: layout,
    }

    return {
        $ui: scrollContainer,
        $oninit: function (view, $scope) {
            var apiHost = app.config.host + "/System/GetInfoCompany";
            webix.ajax(apiHost, function (text) {
                var response = JSON.parse(text);
                var form = $$("foInfoCompany")
                if (response.nsinh_ndd) {
                    response.nsinh_ndd = removeTimeZoneT(response.nsinh_ndd);
                }
                form.setValues(response);
            });
        }
    };
});
define('views/invoice',["app", "locale"], function (app, _) {
    "use strict";

    return {
        $ui: {
            cols: [
                {
                    // paddingY: 10,
                    paddingX: 10,
                    rows: [
                        {
                            template: `<br><i class="mdi mdi-star-outline font-size-18 me-2 align-middle"></i><b>Danh sách ký hiệu hóa đơn sử dụng<b>`, height: 40,
                            type: "clean"
                        },
                        {
                            "view": "datatable",
                            // "css": "mcls_invoiceDashboard",
                            // "url": app.config.host + "/Pattern/Head",
                            // "footer": "true",
                            "resize": "true",
                            id: "tblInvoiceCountCheck",
                            // height: 500,
                            width: 900,
                            // minHeight: 150,
                            onClick: {
                                "clickInvoice": function (event, cell, target) {
                                    var table = webix.$$("tblInvoiceCountCheck");
                                    var item = table.getItem(cell.row);
                                    app.router('app/' + item.router);
                                    webix.storage.local.put("MENU_ID", item.menu_id);
                                    var mes = "Lập hóa đơn -> Hóa đơn GTGT có mã của CQT";
                                    if (item.khhdon.substring(1, 1) == "K")
                                        var mes = "Lập hóa đơn -> Hóa đơn bán hàng (Có mã CQT)";
                                    if (webix.$$('title') != undefined)
                                        webix.$$('title').parse({ title: mes, details: mes });
                                }
                            },
                            "columns": [
                                {
                                    id: "stt",
                                    header: "#",
                                    css: { "text-align": "center" },
                                    width: 40
                                },
                                {
                                    id: "khhdon",
                                    header: "Ký hiệu",
                                    css: { "text-align": "center" },
                                    template: "<a class='clickInvoice'  style = 'text-decoration: none; color:blue;' href='#' >#khhdon#</a>",
                                    // template: "<a  style = 'text-decoration: none; color:blue;' href='#' onclick=\"var menu=$$('app:menu');"
                                    //     + "	require(['app'], function(app){ "
                                    //     + " app.router('app/#router#');"
                                    //     //app.show("/login");
                                    //     + "}); \" >#khhdon#</a>",
                                    fillspace: 1
                                },
                                { id: "cho_ky", header: "Hóa đơn Chờ ký", css: { "text-align": "center" }, fillspace: 1, },
                                { id: "da_gui", header: "Hóa đơn Đã gửi", css: { "text-align": "center" }, fillspace: 1, },
                                { id: "thanh_cong", header: "Thành công", css: { "text-align": "center", "color": "#63AD6F" }, fillspace: 1, },
                                { id: "co_loi", header: "Có lỗi", css: { "text-align": "center", "color": "#F56E6E" }, fillspace: 1, }
                            ]
                        },
                        { }
                    ]
                }
            ]
        },
        $oninit: function (view, $scope) {
            var apiHost = app.config.host + "/Pattern/Head";
            var form = view;
            webix.extend(form, webix.ProgressBar);
            form.disable();
            form.showProgress();
            webix.ajax().get(apiHost, {
                error: function (text, data, XmlHttpRequest) {
                    form.enable();
                    form.hideProgress();
                    alert(text);
                },
                success: function (text, data, XmlHttpRequest) {
                    var data = JSON.parse(text);
                    $$("tblInvoiceCountCheck").parse(data.items);
                    form.enable();
                    form.hideProgress();
                }
            });
        },
    };
});

define('views/license',["app", "locale", "views/forms/license"], function (app, _, licenseForm) {
  "use strict";
  var controls = [
    {
      id: "btnRegFirst", view: "button", type: "icon", css: "webix_primary", shortcut: "F9", badge: "F9",
      icon: "mdi mdi-license", label: _("DANG_KY_LAN_DAU"), width: 150,
      on: {
        onClick: function () {
          webix.callEvent("onLoadError");
          webix.ajax().bind(this).get(app.config.host + "/License/Info", function (text) {
            var dataResponse = JSON.parse(text);
            if (dataResponse.key_license != undefined) {
              webix.alert({
                title: _("THONG_BAO"),
                ok: "OK",
                text: "Phần mềm đã được đăng ký lần đầu",
              });
            } else {
              var win = this.$scope.ui(licenseForm.$ui);
              win.getHead().setHTML(_("DANG_KY_LAN_DAU"));
              win.show();
              $$("license-form").setValues(dataResponse);
            }
          });
        },
      },
      click: function () {
        this.callEvent("onClick");
      },
    },
    {
      id: "btnRegMore", view: "button", type: "icon", css: "webix_danger",
      icon: "mdi mdi-content-save-plus-outline", label: _("DANG_KY_THEM"), width: 150, shortcut: "F10", badge: "F10",
      on: {
        onClick: function () {
          webix.callEvent("onLoadError");
          webix.ajax().bind(this).get(app.config.host + "/License/Info", function (text) {
            var dataResponse = JSON.parse(text);
            if (dataResponse.key_license != undefined) {
              var win = this.$scope.ui(licenseForm.$ui);
              win.getHead().setHTML(_("DANG_KY_THEM"));
              win.show();
              $$("license-form").setValues(dataResponse);
            } else {
              webix.alert({
                title: _("THONG_BAO"),
                ok: "OK",
                text: "Phần mềm chưa được đăng ký lần đầu",
              });
            }
          });
        },
      },
      click: function () {
        this.callEvent("onClick");
      },
    },
    {},
  ];

  var layout = {
    rows: [
      {
        height: 35,
        css: { "background-color": "#f2f7fc !important" }, type: "toolbar",
        margin: 0, borderless: true, cols: controls
      },
      { view: "iframe", id: "framePdf", toolbar: "toolbar" }
    ],
  };

  return {
    $ui: {
      cols: [
        {
          // paddingY: 10,
          paddingX: 10,
          rows: [
            // {
            //   paddingY: 5, cols: controls,
            //   // type: "toolbar"
            // },
            {
              template: `<br><i class="mdi mdi-star-outline font-size-18 me-2 align-middle"></i><b>Danh sách bản quyền đăng ký<b>`, height: 40,
              type: "clean"
            },
            {
              id: "listLicense",
              template: function (model) {
                var content = "";
                if (model.length != undefined && model.length > 0) {
                  model.forEach((element, index) => {
                    var data = `<tr>
                        <td>${index + 1}</td>
                        <td class="text-primary">${element.ten_loai}</td>
                        <td>${formatDecimal(element.so_luong, 0)} <span class="badge badge-soft-success">Tổng mua</span></td>
                        <td>${element.ngay_ket_thuc != null ? formatDate(element.ngay_ket_thuc) : "" }</td>
                        <td><span class="text-danger"> ${formatDecimal(element.su_dung, 0)}</span></td>
                        <td><span class="text-success"> ${formatDecimal(element.con_lai, 0)}</span></td>
                        </tr>`;
                    content += data;
                  });
                }
                var response = `<div class="simplebar-content" style="padding: 0px;">
                                <table class="table align-middle table-striped table-nowrap mb-0">
                                    <thead>
                                        <tr>
                                            <th class="align-middle"><b>#</b></th>
                                            <th class="align-middle"><b>Loại hóa đơn</b></th>
                                            <th class="align-middle"><b>Số lượng đăng ký</b></th>
                                            <th class="align-middle"><b>Ngày hết hạn</b></th>
                                            <th class="align-middle"><b>Sử dụng</b></th>
                                            <th class="align-middle"><b>Còn lại</b></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        ${content}
                                    </tbody>
                                </table>
                                <!-- end table -->
                            </div></div>`
                return response;
              }
            },
            // { view: "iframe", id: "framePdf", toolbar: "toolbar" }
          ]
        },
        {
          // paddingY: 10,
          paddingX: 10,
          rows: [
            {
              cols: [
                {
                  template: `<br><i class="mdi mdi-star-outline font-size-18 me-2 align-middle"></i><b>Lịch sử cấp bản quyền<b>`, height: 40,
                  type: "clean"
                },
                {
                  view: "button", type: "htmlbutton", width: 100,
                  label: '<i class="fa fa-refresh fa-lg" aria-hidden="true"></i> ' +
                    '<span class="text">' + _("REFRESH") + '</span>',
                  id: "btnReloadInfo",
                  css: "btnInfoCompany",
                  on: {
                    onClick: function () {
                      webix.callEvent("onLoadError");
                      var table = webix.$$("LicenseHistory");
                      table.clearAll();
                      table.load(table.config.url);
                    }
                  },
                  click: function () {
                    this.callEvent("onClick");
                  }
                }
              ]
            },
            {
              view: "list",
              id: "LicenseHistory",
              width: 350,
              select: true,
              tooltip: function (obj) {
                return moment(obj.date_new).format("DD/MM/YYYY") + " - " + obj.user_new;
              },
              on: {
                onItemClick: function (id, e, node) {
                  var item = this.getItem(id);
                  var data = "<pre>" + item.ghichu + "</pre>";
                  $$("contentLicense").setHTML(data);
                }
              },
              url: app.config.host + "/System/GetLogLicenseinfo",
              template: function (item) {
                return "- " + formatDate(item.datelog) + " : " + item.user_new + " <span style='color: #00b300'><i class='fas fa-check'></i></span>";
              }
            },
            { height: 5, template: "" },
            { paddingY: 5, view: "template", id: "contentLicense", scroll: "xy", type: { height: "auto" } }
          ]
        }
      ]
    },
    $oninit: function (view, $scope) {
      // var apiHost = app.config.host + "/License/PrintLicenseInfo";
      // var form = view;
      // webix.extend(form, webix.ProgressBar);
      // form.disable();
      // form.showProgress();
      // webix.ajax().response("arraybuffer").get(apiHost, {
      //   error: function (text, data, XmlHttpRequest) {
      //     form.enable();
      //     form.hideProgress();
      //     alert(text);
      //   },
      //   success: function (text, data, XmlHttpRequest) {
      //     var file = new Blob([data], { type: "application/pdf" });
      //     var fileURL = URL.createObjectURL(file);
      //     var framePdf = $$("framePdf");
      //     framePdf.load(fileURL);
      //     form.enable();
      //     form.hideProgress();
      //   }
      // });
      var apiHost = app.config.host + "/License/GetLicense";
      var form = view;
      webix.extend(form, webix.ProgressBar);
      form.disable();
      form.showProgress();
      webix.ajax().get(apiHost, {
        error: function (text, data, XmlHttpRequest) {
          form.enable();
          form.hideProgress();
          alert(text);
        },
        success: function (text, data, XmlHttpRequest) {
          var data = JSON.parse(text);
          $$("listLicense").setValues(data);
          form.enable();
          form.hideProgress();
        }
      });
    },
  };
});

define('views/licenseInvoice',[
    "app",
    "locale",
    "models/user",
    "views/menus/version",
], function (app, _, user, version) {
    'use strict';

    var op = [];
  
    var controls = [
        {},
        // {
        //     id: "btnDangky",
        //     view: "button",
        //     type: "form",
        //     icon: "save",
        //     label: "Đăng ký bản quyền (F9)",
        //     //width: 135,
        //     shortcut: "F9",
        //     on: {
        //         onClick: function () {
        //             webix.message("Watting for ... ", "error");
        //         }
        //     },
        //     click: function () {
        //         this.callEvent("onClick");
        //     }
        // },
        {
            id: "btnSave",
            view: "button",
            type: "danger",
            icon: "save",
            label: "Đăng ký bản quyền (F10)",
            //width: 135,
            shortcut: "F10",
            on: {
                onClick: function () {
                    var form = webix.$$("foInfoCompany");
                    var item = form.getValues();

                    if (item.sl_dk_them < 1 || item.sl_dk_them == "" || item.sl_dk_them == null) {
                        webix.message("Số lượng đăng ký thêm không được để trống hoặc bằng 0 !", "error");
                        return false;
                    }
                    if (form.validate()) {

                        var homeURL;
                        if (document.location.protocol == "file:") {
                            //homeURL = version.getMST();
                            homeURL = "testinvoice";
                        }
                        else {
                            // cắt url lấy mst 
                            homeURL = version.getURL().split('.')[0];
                        }

                        webix.extend(form, webix.ProgressBar);
                        form.disable();
                        form.showProgress();

                        webix.ajax()
                            .bind(this)
                            .headers({ 'Content-type': 'application/json' })
                            .post(app.config.host + "/License/InsertLicenseIM", item, function (text) {
                                var result = JSON.parse(text);

                                if (!result.hasOwnProperty("error")) {
                                    var interVal = setInterval(function () {

                                        var url = app.config.host + "/License/CheckLicenseIM?id=" + result.id;

                                        webix.ajax(url, {
                                            error: function (text, data, XmlHttpRequest) {
                                                webix.message(text, "error");
                                                var form = webix.$$("foInfoCompany");
                                                form.enable();
                                                form.hideProgress();
                                                clearInterval(interVal);
                                            },
                                            success: function (text, data, XmlHttpRequest) {
                                                var result = JSON.parse(text);

                                                if (!result.hasOwnProperty("error")) {

                                                    var table = webix.$$("foInfoCompany");
                                                    table.refresh();
                                                    table.load(table.config.url);

                                                    table.enable();
                                                    table.hideProgress();

                                                    clearInterval(interVal);
                                                }
                                            }
                                        });

                                    }, 3000);
                                }
                                else {
                                    webix.message(result.error, "error");

                                    var form = webix.$$("foInfoCompany");
                                    form.enable();
                                    form.hideProgress();
                                }
                            });



                        // item.path = homeURL;

                        // webix.ajax()
                        //     .headers({ 'Content-type': 'application/json' })
                        //     .post(app.config.host + "/License/RegisLicenseIM", item, function (text) {
                        //         var data = JSON.parse(text);

                        //         if (!data.hasOwnProperty("error")) {
                        //             webix.message({ type: "debug", text: "Cấp bản quyền thành công" });
                        //             var table = webix.$$("foInfoCompany");
                        //             table.refresh();

                        //             table.load(table.config.url);
                        //             webix.modalbox.hide(box);
                        //         }
                        //         else {
                        //             webix.message({ type: "error", text: data.error });
                        //             webix.modalbox.hide(box);
                        //         }
                        //     });

                    }
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {}
    ];

    var layout = {
        // paddingY: 60,
        // paddingX: 500,
        view: "scrollview",
        scroll: "y",
        borderless: true,
        css: { "background": "#f2f7fc !important" },
        body: {
            cols: [
                { gravity: 0.5, template: "" },
                {
                    rows: [
                        { gravity: 1, template: "" },
                        {
                            view: "form",
                            id: "foInfoCompany",
                            paddingY: 15,
                            // width: 700,
                            // height:300,
                            position: "center",
                            paddingX: 15,
                            complexData: true,
                            margin: 0,
                            elements: [
                                {
                                    cols: [
                                        {
                                            view: "text",
                                            name: "ms_thue",
                                            label: _("MS_THUE"),
                                            css: "mcls_license_text",
                                            readonly: true,
                                            labelPosition: "top"
                                        },
                                        {
                                            view: "text",
                                            name: "nguoi_dai_dien",
                                            label: _("NGUOI_DAI_DIEN_PL"),
                                            css: "mcls_readonly_text",
                                            readonly: true,
                                            labelPosition: "top"
                                        }
                                    ]

                                },
                                {
                                    view: "text",
                                    name: "ten_dvcs",
                                    label: _("DONVI"),
                                    css: "mcls_readonly_text",
                                    readonly: true,
                                    labelPosition: "top"
                                },
                                {
                                    view: "text",
                                    name: "dia_chi",
                                    label: _("DIA_CHI"),
                                    css: "mcls_readonly_text",
                                    readonly: true,
                                    labelPosition: "top"
                                },
                                {
                                    view: "fieldset",
                                    label: "Thông tin đơn vị chủ quản",
                                    body: {
                                        rows: [
                                            {
                                                view: "text",
                                                name: "mst_dvcq",
                                                label: _("MS_THUE"),
                                                validate: webix.rules.isTaxCode,
                                                invalidMessage: "Mã số thuế không hợp lệ",
                                                labelPosition: "top",
                                                on: {
                                                    onChange: function (newv, oldv) {
                                                        if (newv != "") {
                                                            this.validate();
                                                        }
                                                    }
                                                }
                                            },
                                            {
                                                view: "text",
                                                name: "ten_dvcq",
                                                label: _("DONVI"),
                                                labelPosition: "top"
                                            },
                                            {
                                                view: "text",
                                                name: "email_dvcq",
                                                validate: webix.rules.isEmail,
                                                invalidMessage: "Email không hợp lệ",
                                                label: _("EMAIL"),
                                                labelPosition: "top",
                                                on: {
                                                    onChange: function (newv, oldv) {
                                                        if (newv != "") {
                                                            this.validate();
                                                        }
                                                    }
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    view: "text",
                                    name: "key_license",
                                    label: _("Key bản quyền"),
                                    css: "mcls_license_text",
                                    readonly: true,
                                    labelPosition: "top"
                                },
                                {
                                    cols: [
                                        {
                                            view: "richselect",
                                            id: "goihd_id",
                                            name: "goihd_id",
                                            label: "Gói đăng ký",
                                            labelPosition: "top",
                                            value: "1",
                                            required: true,
                                            invalidMessage: "Bạn phải chọn gói sử dụng",
                                            on: {
                                                onChange: function (newVal, oldVal) {
                                                    var obj = this.getList().getItem(newVal);
                                                    if (obj != null && obj != undefined) {
                                                        $$("thoi_gian_sd").setValue(obj.thoi_gian);
                                                    }
                                                }
                                            },
                                            options: {
                                                view: "gridsuggest",
                                                textValue: "ten_goi",
                                                body: {
                                                    url: app.config.host + "/ManageInvoice/GetGoiHD",
                                                    textValue: "ten_goi",
                                                    columns: [
                                                        {
                                                            id: "goihd_id",
                                                            width: 60,
                                                            header: _("Mã")
                                                        },
                                                        {
                                                            id: "ten_goi",
                                                            width: 120,
                                                            header: _("Gói")
                                                        },
                                                        {
                                                            id: "thoi_gian",
                                                            width: 180,
                                                            header: _("Thời gian sử dụng (Tháng)")
                                                        }
                                                    ]
                                                }
                                            }
                                        },
                                        {
                                            view: "text",
                                            labelPosition: "top",
                                            label: "Thời gian sử dụng (Tháng)",
                                            id: "thoi_gian_sd",
                                            name: "thoi_gian_sd",
                                            readonly: true,
                                            css: "mcls_license_text",
                                            required: true,
                                            invalidMessage: "Bạn phải nhập thời gian sử dụng"
                                        }
                                    ]
                                },
                                {
                                    cols: [
                                        {
                                            view: "text",
                                            name: "tong_sl",
                                            label: _("Tổng số lượng đã đăng ký"),
                                            css: "mcls_license_text",
                                            readonly: true,
                                            labelPosition: "top"
                                            // css: { "text-align": "right" },
                                            // format: webix.Number.numToStr({
                                            //     groupDelimiter: ".",
                                            //     groupSize: 3,
                                            //     decimalDelimiter: ",",
                                            //     decimalSize: 2
                                            // })
                                        },
                                        {
                                            view: "text",
                                            name: "sl_dk_them",
                                            label: _("Số lượng đăng ký thêm gần nhất"),
                                            labelPosition: "top",
                                            required: true,
                                            invalidMessage: "Số lượng nhập không đúng giá trị >= 1",
                                            validate: webix.rules.isNumber,
                                            // css: { "text-align": "right" },
                                            // format: webix.Number.numToStr({
                                            //     groupDelimiter: ".",
                                            //     groupSize: 3,
                                            //     decimalDelimiter: ",",
                                            //     decimalSize: 2
                                            // }),
                                            on: {
                                                onChange: function (newv, oldv) {
                                                    if (newv == undefined) return;
                                                    if (newv == "") return;
                                                    // if (newv < 1) {
                                                    // 	webix.message("Số lượng đăng ký phải lớn hơn hoặc bằng 1", "error");
                                                    // 	return;
                                                    // }
                                                }
                                            }
                                        }
                                    ]

                                },

                                {
                                    view: "text",
                                    name: "dung_luong_dk",
                                    label: _("Dung lượng đăng ký"),
                                    required: true,
                                    hidden: true,
                                    //css: "mcls_readonly_text",
                                    //readonly: true,
                                    labelPosition: "top",
                                    invalidMessage: "Dung lượng nhập không đúng giá trị >= 1 !",
                                    validate: webix.rules.isNumber,
                                    on: {
                                        onChange: function (newv, oldv) {
                                            if (newv == undefined) return;
                                            if (newv == "") return;
                                            // if (newv < 1) {
                                            // 	webix.message("Số lượng đăng ký phải lớn hơn hoặc bằng 1", "error");
                                            // 	return;
                                            // }
                                        }
                                    }
                                },
                                {
                                    margin: 15,
                                    cols: controls

                                }

                            ]
                        },
                        { gravity: 5, template: "" }
                    ]
                },
                // {
                //     view: "label",
                //     template: "<a href='http://minvoice.vn/' target='_blank'><img  src='assets/imgs/inv.jpg' /></a>",
                //     // height: 65,
                //     borderless: true
                //     // css: { "padding": "10px", "padding-top": "15px" }
                // }
                { gravity: 0.5, template: "" }
            ]
        }
    };

    return {
        $ui: layout,
        $oninit: function (view, $scope) {
            var url = app.config.host + "/License/GetLicenseIM";
            $$("foInfoCompany").config.url = url;
            webix.ajax(url, function (text) {
                var json = JSON.parse(text);
                $$("foInfoCompany").setValues(json);

            });
        }
    };
});
define('views/quenmk',["app", "locale", "views/modules/minvoiceplugin", "views/menus/version"], function (app, _, plugin, version) {

    var layout = {
        view: "window", modal: true, move: true, id: "retrivepass-win", position: "center",
        head: "Quên mật khẩu",
        width: 500,
        height: 400,
        body: {
            paddingY: 10,
            paddingX: 10,
            view: "form",
            id: "retrivepassForm",
            complexData: true,
            elements: [
                {
                    view: "radio", vertical: true, id: "optionType", name: "type",
                    value: 1, options: [
                        { "id": 1, "value": "1. Lấy lại mật khẩu qua Email" },
                        { "id": 2, "value": "2. Lấy lại mật khẩu bằng chữ ký số" }
                    ],
                    on: {
                        onChange: function (newValue, oldValue, config) {

                            if (newValue == 1) {
                                $$("tempMess").define("hidden", false);
                                $$("tempMess").show();
                                $$("tempMess").refresh();
                                $$("txtEmail").define("hidden", false);
                                $$("txtEmail").show();
                                $$("txtEmail").refresh();
                                // hide cks

                                $$("txtAccount").hide();
                                $$("txtPass").hide();
                                $$("txtRePass").hide();
                            }
                            if (newValue == 2) {
                                $$("txtAccount").define("hidden", false);
                                $$("txtAccount").setValue("");
                                $$("txtAccount").show();

                                $$("txtAccount").refresh();
                                $$("txtPass").define("hidden", true);
                                $$("txtPass").setValue("");
                                $$("txtPass").show();
                                $$("txtPass").refresh();
                                $$("txtRePass").define("hidden", true);
                                $$("txtRePass").setValue("");
                                $$("txtRePass").show();
                                $$("txtRePass").refresh();
                                // hide email
                                $$("tempMess").hide();
                                $$("txtEmail").hide();
                            }
                        }
                    }
                },
                {
                    view: "text",
                    labelPosition: "top",
                    id: "txtEmail",
                    name: "email",
                    label: "Nhập địa chỉ email để nhận mật khẩu mới",
                    icon: "email",
                    required: true,
                    invalidMessage: "Bạn chưa nhập địa chỉ email hoặc email định dạng không đúng",
                    placeholder: "Nhập email ...",
                    validate: webix.rules.isEmail
                },
                {
                    id: "version",
                    borderless: true,
                    // css: { "background": "#F2F7FC !important" },
                    view: "template",
                    id: "tempMess",
                    template: `<div class="alert alert-success text-center my-4 font-size-12" role="alert">
                    Hệ thống của M-Invoice sẽ gửi mật khẩu mới vào email cho Quý khách hàng. Quý khách hàng vui lòng kiểm tra email để nhận thông tin mật khẩu mới !
                </div>`
                },
                {
                    view: "text", id: "txtAccount", hidden: true, name: "account", required: true, invalidMessage: "Tài khoản không được bỏ trống",
                    label: "Tài khoản", labelPosition: "top"
                },
                {
                    view: "text", id: "txtPass", hidden: true, name: "newpass", required: true, invalidMessage: "Mật khẩu mới không được bỏ trống",
                    type: "password", label: "Mật khẩu mới", labelPosition: "top"
                },
                {
                    view: "text", id: "txtRePass", hidden: true, name: "confirmpass", required: true, invalidMessage: "Xác nhận mật khẩu không được bỏ trống",
                    type: "password", label: "Xác nhận mật khẩu", labelPosition: "top"
                },
                {
                    margin: 10,
                    cols: [
                        {},
                        {
                            shortcut: "F10", view: "button", label: "Gửi (F10)", align: "center", width: 120, type: "form",
                            on: {
                                onClick: function () {
                                    if ($$("retrivepassForm").validate()) {

                                        var form = $$("retrivepassForm");
                                        var item = form.getValues();
                                        if ($$("optionType").getValue() == 2) {
                                            if (item.newpass != item.confirmpass) {
                                                webix.message("Mật khẩu mới không giống nhau", "error");
                                                return;
                                            }
                                            else {
                                                webix.extend(form, webix.ProgressBar);
                                                form.disable();
                                                form.showProgress();

                                                var hub = plugin.hub();
                                                var hubconnect = plugin.conn();
                                                if (hubconnect.state != 1) {
                                                    var form = webix.$$("retrivepassForm");
                                                    form.enable();
                                                    form.hideProgress();
                                                    webix.message("Quý khách hàng chưa cài Plugin ký hóa đơn hoặc Plugin ký hóa đơn chưa được bật !", "error");
                                                    return;
                                                }
                                                else {
                                                    hub.off('resCommand');
                                                    hub.on('resCommand', function (result) {
                                                        var json = JSON.parse(result);
                                                        if (json.hasOwnProperty("error")) {
                                                            webix.message({ type: 'error', text: json.error });
                                                            var form = webix.$$("retrivepassForm");
                                                            form.enable();
                                                            form.hideProgress();
                                                        }
                                                        else {
                                                            webix.ajax()
                                                                .headers({ 'Content-type': 'application/json' })
                                                                .post(app.config.host + "/Account/ResetPass", item, function (text) {
                                                                    var form = webix.$$("retrivepassForm");
                                                                    form.enable();
                                                                    form.hideProgress();
                                                                    var data = JSON.parse(text);
                                                                    if (!data.hasOwnProperty("error")) {
                                                                        var win = $$("retrivepass-win");
                                                                        win.close();
                                                                        webix.message("Đổi mật khẩu thành công !", "success");
                                                                    }
                                                                    else {
                                                                        webix.message(data.error, "error");
                                                                    }
                                                                });


                                                        }
                                                    });

                                                    var homeURL;
                                                    if (document.location.protocol == "file:") {
                                                        homeURL = "testinvoice";
                                                    }
                                                    else {
                                                        homeURL = version.getURL().split('.')[0];
                                                    }
                                                    item.mst = homeURL;
                                                    hub.invoke('execCommand', 'ResetPassByToken', JSON.stringify(item))
                                                        .done(function () {
                                                            console.log("Success ResetPassByToken!")
                                                        })
                                                        .fail(function (error) {
                                                            var form = webix.$$("retrivepassForm");
                                                            form.enable();
                                                            form.hideProgress();
                                                            webix.message(error, "error");
                                                        });
                                                }
                                            }
                                        }
                                        else {
                                            webix.extend(form, webix.ProgressBar);
                                            form.disable();
                                            form.showProgress();
                                            webix.ajax()
                                                .headers({ 'Content-type': 'application/json' })
                                                .post(app.config.host + "/Account/ResetPass", $$("retrivepassForm").getValues(), function (text, xml, xhr) {
                                                    var json = JSON.parse(text);
                                                    var form = $$("retrivepassForm");
                                                    form.enable();
                                                    form.hideProgress();

                                                    if (json.hasOwnProperty("error")) {
                                                        webix.message(json.error, "error");
                                                    }
                                                    else {
                                                        webix.alert({
                                                            title: "Thông báo",
                                                            ok: "OK",
                                                            text: "Đã gửi mật khẩu mới tới email. Bạn hãy kiểm tra email."
                                                        });
                                                    }
                                                });
                                        }
                                    } else {
                                        $$("retrivepassForm").focus();
                                    }
                                }
                            },
                            click: function () {
                                this.callEvent("onClick");
                            }
                        },
                        {
                            view: "button", hotkey: "esc", label: "Hủy bỏ (ESC)", align: "center", width: 120, type: "danger",
                            click: function () {
                                webix.$$("retrivepass-win").close();
                            }
                        },
                        {}
                    ]
                }

            ]
        }
    };
    return {
        $ui: layout,
        initUI: function (json) {
            $$("retrivepassForm").setValues(json);
        }
    };

});
/**
 * Created by Mads on 03-10-2015.
 */
define('views/login',[
    "models/user",
    "locale",
    "app",
    "helpers/locale",
    "views/menus/version",
    "views/quenmk"
], function (user, _, app, locale, version, quenmk) {

    "use strict";
    webix.ui({
        view: "popup",
        id: "my_pop",
        head: "Submenu",
        width: 250,
        body: {
            view: "list",
            data: [
                { id: "1", name: _("Nâng cấp lên phiên bản Online"), location: "M-Invoice Desktop" }
            ],
            template: "#name#",
            autoheight: true,
            select: true,
            on: {
                onItemClick: function (id) {
                    if (id == "1") {
                        app.router("/updateToWeb");
                    }
                }
            }
        }
    });
    var values = webix.copy({
        username: '',
        password: '',
        rememberme: false,
        language: 'vi',
        ma_dvcs: "VP"
    }, Cookies.getJSON("Crm"));

    function LoginFunc() {
        var username = document.getElementById("username").value.toUpperCase();
        document.getElementById("username").value = username;
        var password = document.getElementById("password-input").value;
        var remember = document.getElementById("remember").value;
        var ma_dvcs = $$("ma_dvcs").getValue();
        // var lang = $$("cbLanguage").getValue();
        var lang = "vi";
        var data = {
            username: username,
            password: password,
            ma_dvcs: ma_dvcs
        };
        if (remember == "on") {
            data.language = lang;
            Cookies.set("Crm", data);
        }
        else {
            //Clear cookie
            Cookies.remove("Crm");
        }
        user.login(data.username, data.password, data.ma_dvcs, lang, $$('loginForm'));
    }
    return {
        $ui: {
            cols: [
                {

                    view: "template",
                    autoheight: true,
                    borderless: true,
                    id: "login_left",
                    css: "body_login_left",
                    template: `<div class="col-xxl-12 col-lg-12 col-md-12">
                    <div class="auth-bg bg-white">
                       <div class="row justify-content-center align-items-center">
                          <div class="col-xl-8">
                             <div class="p-0 p-sm-4 px-xl-0 py-5">
                                <h4 class="mt-5">Hệ sinh thái M-INVOICE</h4>
                                <p class="text-muted edition">
                                   Chúng tôi mang đến cho bạn hệ sinh thái công nghệ thông tin đa dạng và chất lượng dịch vụ hàng đầu giúp bạn kinh doanh thành công.
                                   <a href="https://minvoice.vn" target="_blank" class="more-green" style='text-decoration: none; color:blue;'>Xem thêm tại đây</a>
                                </p>
                             </div>
                             <div class="row justify-content-center">
                                <div class ="col-sm-10">
                                    <div class="maintenance-img">
                                    <img src="./assets/imgs/login_minvoice.png" alt="" class="img-fluid mx-auto d-block">
                                    </div>
                                </div>
                             </div>
                             <ul class="boxlogo-green">
                                <li><label><a href="https://minvoice.vn/minvoice-hoa-don-dien-tu/" target="_blank"><img alt="Minvoice" src="./assets/imgs/login_invoice.svg" style="width: 110px;"><span>M-invoice đã cung cấp giải pháp Hóa đơn điện tử và Hóa đơn xác thực cho hơn 50.000 Doanh nghiệp lớn thuộc mọi ngành nghề Sản xuất, Thương mại, Dịch vụ, Nhà hàng, Bệnh viện, Trường học, Logistic……</span></a></label></li>
                                <li><label><a href="https://minvoice.vn/phan-mem-quan-ly-hoa-don-dau-vao-dau-ra-msmi/" target="_blank"><img alt="Minvoice" src="./assets/imgs/login_smi.svg" style="width: 110px;"><span>Giải pháp quản lý, lưu trữ và kiểm tra tính hợp lệ của toàn bộ hóa đơn của Doanh nghiệp bao gồm quản lý hóa đơn đầu vào và hóa đơn đầu ra của Doanh nghiệp.</span></a></label></li>
                                <li><label><a href="https://mbhxh.vn/" target="_blank"><img alt="Minvoice" src="./assets/imgs/login_bhxh.svg" style="width: 110px;"><span>Hỗ trợ các doanh nghiệp, người lao động thực hiện tốt nhất việc khai báo các thông tin, nghiệp vụ kê khai bảo hiểm thông qua hệ thống điện tử theo đúng quy trình của cơ quan quản lý BHXH.</span></a></label></li>
                                <li><label><a href="https://mecontract.vn/" target="_blank"><img alt="Minvoice" src="./assets/imgs/login_contract.svg" style="width: 110px;"><span>Nền tảng giúp Doanh nghiệp số hóa quy trình quản lý và ký kết tài liệu thay thế cho phương pháp truyền thống.Tính năng dễ sử dụng, ký hợp đồng từ xa, mọi lúc, mọi nơi.</span></a></label></li>
                                <li><label><a href="https://minvoice.vn/" target="_blank"><img alt="Minvoice" src="./assets/imgs/login_mca.svg" style="width: 110px;"><span>Đáp ứng đầy đủ nghiệp vụ ký kết văn bản/hợp đồng/giao dịch điện tử.</span></a></label></li>
                             </ul>
                          </div>
                       </div>
                    </div>
                 </div>`
                },
                {
                    cols: [
                        { gravity: 1, template: "" },
                        {
                            rows: [
                                { gravity: 1, template: "" },
                                {
                                    view: "form",
                                    gravity: 1,
                                    id: 'loginForm',
                                    width: 380,
                                    margin: 5,
                                    css: { "border-radius": "10px 10px 10px 10px", "box-shadow": "0 3px 10px rgba(0,0,0,0.2)", "zoom": "90%" },
                                    borderless: false,
                                    elements: [
                                        {
                                            view: "template",
                                            template: "<center><a href='http://minvoice.vn/' target='_blank'><img  src='assets/imgs/LogoMinvoice.jpg' width=63%;/></a></center>",
                                            height: 150,
                                            borderless: true,
                                            css: { padding: "0px" }
                                        },
                                        { height: 5 },
                                        {
                                            view: "richselect",
                                            id: "ma_dvcs",
                                            name: "ma_dvcs",
                                            css: "donvilogin",
                                            height: 62,
                                            width: 326,
                                            options: {
                                                view: "gridsuggest",
                                                textValue: "ten_dvcs",
                                                body: {
                                                    url: app.config.host + "/System/GetAllDmDvcs",
                                                    textValue: "ten_dvcs",
                                                    columns: [
                                                        {
                                                            id: "ms_thue",
                                                            width: 120,
                                                            header: _("MS_THUE")
                                                        },
                                                        {
                                                            id: "ten_dvcs",
                                                            width: 450,
                                                            header: _("DONVI")
                                                        }
                                                    ]
                                                }
                                            },
                                            value: values.ma_dvcs,
                                            required: true
                                        },
                                        {
                                            view: "template",
                                            autoheight: true,
                                            borderless: true,
                                            hotkey: "enter",
                                            template: ` <form id="myFormLogin" >
                                            <div class="form-floating form-floating-custom mb-3">
                                                <input type="text" style="text-transform:uppercase" required autofocus class="form-control" id="username" placeholder="Enter User Name">
                                                <label for="input-username">${_("TAI_KHOAN")}</label>
                                                <div class="form-floating-icon">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" class="eva eva-people-outline"><g data-name="Layer 2"><g data-name="people"><rect width="24" height="24" opacity="0"></rect><path d="M9 11a4 4 0 1 0-4-4 4 4 0 0 0 4 4zm0-6a2 2 0 1 1-2 2 2 2 0 0 1 2-2z"></path><path d="M17 13a3 3 0 1 0-3-3 3 3 0 0 0 3 3zm0-4a1 1 0 1 1-1 1 1 1 0 0 1 1-1z"></path><path d="M17 14a5 5 0 0 0-3.06 1.05A7 7 0 0 0 2 20a1 1 0 0 0 2 0 5 5 0 0 1 10 0 1 1 0 0 0 2 0 6.9 6.9 0 0 0-.86-3.35A3 3 0 0 1 20 19a1 1 0 0 0 2 0 5 5 0 0 0-5-5z"></path></g></g></svg>
                                                </div>
                                            </div>
                                            <div class="form-floating form-floating-custom mb-3 auth-pass-inputgroup">
                                                <input type="password" class="form-control pe-5" required minlength="6" id="password-input" placeholder="Enter Password">
                                                <button type="button" class="btn btn-link position-absolute h-100 end-0 top-0" id="password-addon">
                                                    <i class="mdi mdi-eye-outline font-size-18 text-muted"></i>
                                                </button>
                                                <label for="input-password">${_("PASSWORD")}</label>
                                                <div class="form-floating-icon">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" class="eva eva-lock-outline"><g data-name="Layer 2"><g data-name="lock"><rect width="24" height="24" opacity="0"></rect><path d="M17 8h-1V6.11a4 4 0 1 0-8 0V8H7a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3v-8a3 3 0 0 0-3-3zm-7-1.89A2.06 2.06 0 0 1 12 4a2.06 2.06 0 0 1 2 2.11V8h-4zM18 19a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-8a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1z"></path><path d="M12 12a3 3 0 1 0 3 3 3 3 0 0 0-3-3zm0 4a1 1 0 1 1 1-1 1 1 0 0 1-1 1z"></path></g></g></svg>
                                                </div>
                                            </div>
                                            <div class="row mb-3">
                                                <div class="col">
                                                    <div class="form-check font-size-15">
                                                        <input class="form-check-input" type="checkbox" id="remember" name="remember">
                                                        <label class="form-check-label font-size-13" for="remember">${_("REMEMBERME")}</label>
                                                    </div>  
                                                </div>
                                                <div class="col">
                                                <div class="form-check font-size-15">
                                                    <span class="quenmatkhau"><label class="form-check-label font-size-13">${_("QUENMK")}</label></span>
                                                </div>  
                                            </div>
                                            </div>
                                            <div class="mb-3">
                                                <span class="btnLogins"><button type="submit" class="btn btn-primary w-100 waves-effect waves-light">${_("DANGNHAP")}</button></span>
                                            </div>
                                            </form>
                                            <div class="mt-0 pt-1 text-center">
                                                        <div class="signin-other-title">
                                                            <h5 class="font-size-14 mb-3 text-muted fw-medium">- ${_("KET_NOI")} -</h5>
                                                        </div>
                                                        <div class="d-flex gap-1">
                                                            <button type="button" class="facebookInvoice btn btn-soft-primary waves-effect waves-light w-100">
                                                                <i class="mdi mdi-facebook font-size-16 align-middle"></i> 
                                                            </button>
                                                            <button type="button" class="webInvoice btn btn-soft-info waves-effect waves-light w-100">
                                                                <i class="mdi mdi-firefox font-size-16 align-middle"></i> 
                                                            </button>
                                                            <button type="button" class="youtubeInvoice btn btn-soft-danger waves-effect waves-light w-100">
                                                                <i class="mdi mdi-youtube font-size-16 align-middle"></i> 
                                                            </button>
                                                        </div>
                                                    </div>
                                                    <div class="mt-3 pt-2 text-center">
                                                        <p class="text-muted mb-0">${_("DUNG_THU")} <a href="https://minvoice.vn/dang-ky-dai-ly-hoa-don-dien-tu/" target="_blank" class="text-primary fw-semibold"> ${_("DANGKY")} </a> </p>
                                                    </div>
                                                    <div class="mt-3 text-center">
                                                        <p class="mb-0">© <script>document.write(new Date().getFullYear())</script>2023 Công ty TNHH Hóa đơn điện tử M-Invoice <i class="mdi mdi-heart text-danger"></i></p>
                                                    </div>`,
                                            onClick: {
                                                "quenmatkhau": function (ev, id) {
                                                    var win = this.$scope.ui(quenmk.$ui);
                                                    win.show();
                                                },
                                                "webInvoice": function (ev, id) {
                                                    var win = window.open("https://minvoice.vn", '_blank');
                                                    win.focus();
                                                    return;
                                                },
                                                "facebookInvoice": function (ev, id) {
                                                    var win = window.open("https://www.facebook.com/hoadondientu.m.invoice", '_blank');
                                                    win.focus();
                                                    return;
                                                },
                                                "youtubeInvoice": function (ev, id) {
                                                    var win = window.open("https://www.youtube.com/c/HoaDonDienTuMinvoice", '_blank');
                                                    win.focus();
                                                    return;
                                                }
                                            }
                                        },
                                        { height: 5 }
                                    ]
                                },
                                { gravity: 1, temlate: "" }
                            ]
                        },
                        { gravity: 1, template: "" },
                        {
                            rows:[
                                { gravity: 0.1, template: "" },
                                {
                                    id: "cbLanguage",
                                    view: "combo",
                                    width: 125,
                                    options: [
                                        { id: "vi", value: "Việt Nam" },
                                        { id: "en", value: "English" },
                                        { id: "ko", value: "Korean" }
                                    ],
                                    value: locale.getLang(),
                                    on: {
                                        onChange: function (newv, oldv) {
                                            locale.setLang(newv, null);
                                        }
                                    }
                                },
                                // {
                                //     id: "phanvung",
                                //     borderless: true,
                                //     view: "label",
                                //     template: `<label class='f1s' style='color:blue'>${_("PHAN_VUNG")}: ...</label>`
                                // },
                                { gravity: 4, template: "" },
                            ]
                        },
                        { gravity: 0.1, template: "" },
                    ]
                }
            ]
        },
        $oninit: function () {
            // var ma_dvcs = $$("ma_dvcs").getValue();
            // webix.ajax()
            //     .headers({ 'content-type': 'application/json' })
            //     .get(app.config.host + "/System/GetPhanVung?ma_dvcs=" + ma_dvcs, function (result) {
            //         var _res = result == "null" ? null : result.substr(1, result.length - 2);
            //         $$("phanvung").define("template", `<label class='f1s' style='color:blue'>${_("PHAN_VUNG")} : ${res}</label>`);
            //         $$("phanvung").refresh();
            //     })
            document.getElementById("password-addon").addEventListener("click", function () { var e = document.getElementById("password-input"); "password" === e.type ? e.type = "text" : e.type = "password" });
            document.getElementById("myFormLogin").addEventListener("submit", function (e) {
                e.preventDefault();
                e.stopPropagation();
                LoginFunc();
            });
        }
    };
});

/**
 * Created by Mads on 03-10-2015.
 */
define('views/login23',[
    "models/user",
    "locale",
    "app",
    "helpers/locale",
    "views/menus/version",
    "views/quenmk"
], function (user, _, app, locale, version, quenmk) {

    "use strict";
    webix.ui({
        view: "popup",
        id: "my_pop",
        head: "Submenu",
        width: 250,
        body: {
            view: "list",
            data: [
                { id: "1", name: _("Nâng cấp lên phiên bản Online"), location: "M-Invoice Desktop" }
            ],
            template: "#name#",
            autoheight: true,
            select: true,
            on: {
                onItemClick: function (id) {
                    if (id == "1") {
                        app.router("/updateToWeb");
                    }
                }
            }
        }
    });
    var values = webix.copy({
        username: '',
        password: '',
        rememberme: false,
        language: 'vi',
        ma_dvcs: "VP"
    }, Cookies.getJSON("Crm"));

    function LoginFunc() {
        var username = document.getElementById("username").value.toUpperCase();
        document.getElementById("username").value = username;
        var password = document.getElementById("password-input").value;
        var remember = document.getElementById("remember").value;
        var ma_dvcs = $$("ma_dvcs").getValue();
        var data = {
            username: username,
            password: password,
            ma_dvcs: ma_dvcs
        };
        if (remember == "on") {
            data.language = $$("cbLanguage").getValue();
            Cookies.set("Crm", data);
        }
        else {
            //Clear cookie
            Cookies.remove("Crm");
        }
        user.login(data.username, data.password, data.ma_dvcs, $$("cbLanguage").getValue(), $$('loginForm'));
    }
    return {
        $ui: {
            rows: [
                {
                    css: { "box-shadow": "0 5px 15px rgba(0,0,0,0.2)" },
                    height: 80,
                    cols: [
                        { gravity: 1, template: "", width: 150 },
                        {
                            view: "label",
                            template: "<a href='http://minvoice.vn/' target='_blank'><img  src='assets/imgs/head-banner.jpg' height=100%; /></a>",
                            height: 65,
                            borderless: true,
                            css: { "padding": "10px", "padding-top": "15px" }
                        },
                        {
                            id: "version",
                            borderless: true,
                            view: "label",
                            template: `<div class='hotline'><b style='font-family:Arial;'>${_("HOT_LINE")}:</b> <label class='f1s' style='color:red'>0901 80 16 18</label> <br /><i class='f2s' style='float:right; color:red'>info@minvoice.vn</i></div>`,
                            css: { "padding": "10px", "padding-top": "20px" }
                        },
                        {
                            rows: [
                                { gravity: 1, template: "" },
                                {
                                    id: "cbLanguage",
                                    view: "combo",
                                    width: 125,
                                    options: [
                                        { id: "vi", value: "Việt Nam" },
                                        { id: "en", value: "English" },
                                        { id: "ko", value: "Korean" }
                                    ],
                                    value: locale.getLang(),
                                    on: {
                                        onChange: function (newv, oldv) {
                                            locale.setLang(newv, null);
                                        }
                                    }
                                },
                                {
                                    id: "phanvung",
                                    borderless: true,
                                    view: "label",
                                    template: `<label class='f1s' style='color:blue'>${_("PHAN_VUNG")}: ...</label>`
                                }
                            ]
                        },
                        {
                            view: "label",
                            css: "loginfootercog",
                            width: 50,
                            template: function (obj) {
                                var html = "<div style='font-size: 15px;width: 30px;height:100%;float:right;' onclick='webix.$$(\"my_pop\").show(this)'><i class='fas fa-cog'></i></div>";
                                return html;
                            }
                        },
                        { gravity: 1, template: "", width: 150 }
                    ]
                },
                {
                    css: "bodylogin",
                    cols: [
                        { gravity: 1, template: "" },
                        { gravity: 1, template: "" },
                        { gravity: 1, template: "" },
                        { gravity: 1, template: "" },
                        { gravity: 1, template: "" },
                        { gravity: 1, template: "" },
                        {
                            rows: [
                                { gravity: 1, template: "" },
                                {
                                    view: "form",
                                    gravity: 1,
                                    id: 'loginForm',
                                    width: 380,
                                    margin: 5,
                                    css: { "border-radius": "10px 10px 10px 10px", "box-shadow": "0 3px 10px rgba(0,0,0,0.2)" },
                                    borderless: false,
                                    elements: [
                                        {
                                            view: "template",
                                            template: "<center><a href='http://minvoice.vn/' target='_blank'><img  src='assets/imgs/LogoMinvoice.jpg' width=63%;/></a></center>",
                                            height: 150,
                                            borderless: true,
                                            css: { padding: "0px" }
                                        },
                                        { height: 5 },
                                        // { type: "section", template: "Giá trị hóa đơn" },
                                        {
                                            view: "richselect",
                                            id: "ma_dvcs",
                                            name: "ma_dvcs",
                                            css: "donvilogin",
                                            height: 62,
                                            width: 326,
                                            options: {
                                                view: "gridsuggest",
                                                textValue: "ten_dvcs",
                                                body: {
                                                    url: app.config.host + "/System/GetAllDmDvcs",
                                                    textValue: "ten_dvcs",
                                                    columns: [
                                                        {
                                                            id: "ms_thue",
                                                            width: 120,
                                                            header: _("MS_THUE")
                                                        },
                                                        {
                                                            id: "ten_dvcs",
                                                            width: 450,
                                                            header: _("DONVI")
                                                        }
                                                    ]
                                                }
                                            },
                                            value: values.ma_dvcs,
                                            required: true
                                        },
                                        {
                                            view: "template",
                                            autoheight: true,
                                            borderless: true,
                                            hotkey: "enter",
                                            template: ` <form id="myFormLogin" >
                                            <div class="form-floating form-floating-custom mb-3">
                                                <input type="text" style="text-transform:uppercase" required autofocus class="form-control" id="username" placeholder="Enter User Name">
                                                <label for="input-username">${_("TAI_KHOAN")}</label>
                                                <div class="form-floating-icon">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" class="eva eva-people-outline"><g data-name="Layer 2"><g data-name="people"><rect width="24" height="24" opacity="0"></rect><path d="M9 11a4 4 0 1 0-4-4 4 4 0 0 0 4 4zm0-6a2 2 0 1 1-2 2 2 2 0 0 1 2-2z"></path><path d="M17 13a3 3 0 1 0-3-3 3 3 0 0 0 3 3zm0-4a1 1 0 1 1-1 1 1 1 0 0 1 1-1z"></path><path d="M17 14a5 5 0 0 0-3.06 1.05A7 7 0 0 0 2 20a1 1 0 0 0 2 0 5 5 0 0 1 10 0 1 1 0 0 0 2 0 6.9 6.9 0 0 0-.86-3.35A3 3 0 0 1 20 19a1 1 0 0 0 2 0 5 5 0 0 0-5-5z"></path></g></g></svg>
                                                </div>
                                            </div>
                                            <div class="form-floating form-floating-custom mb-3 auth-pass-inputgroup">
                                                <input type="password" class="form-control pe-5" required minlength="6" id="password-input" placeholder="Enter Password">
                                                <button type="button" class="btn btn-link position-absolute h-100 end-0 top-0" id="password-addon">
                                                    <i class="mdi mdi-eye-outline font-size-18 text-muted"></i>
                                                </button>
                                                <label for="input-password">${_("PASSWORD")}</label>
                                                <div class="form-floating-icon">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" class="eva eva-lock-outline"><g data-name="Layer 2"><g data-name="lock"><rect width="24" height="24" opacity="0"></rect><path d="M17 8h-1V6.11a4 4 0 1 0-8 0V8H7a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3v-8a3 3 0 0 0-3-3zm-7-1.89A2.06 2.06 0 0 1 12 4a2.06 2.06 0 0 1 2 2.11V8h-4zM18 19a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-8a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1z"></path><path d="M12 12a3 3 0 1 0 3 3 3 3 0 0 0-3-3zm0 4a1 1 0 1 1 1-1 1 1 0 0 1-1 1z"></path></g></g></svg>
                                                </div>
                                            </div>
                                            <div class="row mb-3">
                                                <div class="col">
                                                    <div class="form-check font-size-15">
                                                        <input class="form-check-input" type="checkbox" id="remember" name="remember">
                                                        <label class="form-check-label font-size-13" for="remember">${_("REMEMBERME")}</label>
                                                    </div>  
                                                </div>
                                                <div class="col">
                                                <div class="form-check font-size-15">
                                                    <span class="quenmatkhau"><label class="form-check-label font-size-13">${_("QUENMK")}</label></span>
                                                </div>  
                                            </div>
                                            </div>
                                            <div class="mb-3">
                                                <span class="btnLogins"><button type="submit" class="btn btn-primary w-100 waves-effect waves-light">${_("DANGNHAP")}</button></span>
                                            </div>
                                            </form>
                                            <div class="mt-0 pt-1 text-center">
                                                        <div class="signin-other-title">
                                                            <h5 class="font-size-14 mb-3 text-muted fw-medium">- ${_("KET_NOI")} -</h5>
                                                        </div>
                                                        <div class="d-flex gap-1">
                                                            <button type="button" class="facebookInvoice btn btn-soft-primary waves-effect waves-light w-100">
                                                                <i class="mdi mdi-facebook font-size-16 align-middle"></i> 
                                                            </button>
                                                            <button type="button" class="webInvoice btn btn-soft-info waves-effect waves-light w-100">
                                                                <i class="mdi mdi-firefox font-size-16 align-middle"></i> 
                                                            </button>
                                                            <button type="button" class="youtubeInvoice btn btn-soft-danger waves-effect waves-light w-100">
                                                                <i class="mdi mdi-youtube font-size-16 align-middle"></i> 
                                                            </button>
                                                        </div>
                                                    </div>
                                                    <div class="mt-3 pt-2 text-center">
                                                        <p class="text-muted mb-0">${_("DUNG_THU")} <a href="https://minvoice.vn/dang-ky-dai-ly-hoa-don-dien-tu/" target="_blank" class="text-primary fw-semibold"> ${_("DANGKY")} </a> </p>
                                                    </div>
                                                    <div class="mt-3 text-center">
                                                        <p class="mb-0">© <script>document.write(new Date().getFullYear())</script>2023 Công ty TNHH Hóa đơn điện tử M-Invoice <i class="mdi mdi-heart text-danger"></i></p>
                                                    </div>`,
                                            onClick: {
                                                "quenmatkhau": function (ev, id) {
                                                    var win = this.$scope.ui(quenmk.$ui);
                                                    win.show();
                                                },
                                                "webInvoice": function (ev, id) {
                                                    var win = window.open("https://minvoice.vn", '_blank');
                                                    win.focus();
                                                    return;
                                                },
                                                "facebookInvoice": function (ev, id) {
                                                    var win = window.open("https://www.facebook.com/hoadondientu.m.invoice", '_blank');
                                                    win.focus();
                                                    return;
                                                },
                                                "youtubeInvoice": function (ev, id) {
                                                    var win = window.open("https://www.youtube.com/c/HoaDonDienTuMinvoice", '_blank');
                                                    win.focus();
                                                    return;
                                                }
                                            }
                                        },
                                        { height: 5 }
                                        // {
                                        //     view: "search",
                                        //     id: "username",
                                        //     name: "username",
                                        //     icon: "mdi mdi-account-circle",
                                        //     placeholder: "Tên truy cập",
                                        //     value: values.username,
                                        //     required: true,
                                        //     invalidMessage: "Tên truy cập không để trống hoặc nhập không đúng (a-z,A-Z,0-9)",
                                        //     validate: webix.rules.isSpecialCharacter,
                                        //     css: "mcls_uppercase"
                                        // },
                                        // {
                                        //     view: "search",
                                        //     id: "password",
                                        //     name: "password",
                                        //     type: "password",
                                        //     icon: "mdi mdi-lock-outline",
                                        //     placeholder: "Mật khẩu",
                                        //     value: values.password,
                                        //     invalidMessage: "Mật khẩu không được để trống",
                                        //     required: true,
                                        //     css: "passlogin"
                                        // },
                                        // {
                                        //     cols: [
                                        //         {
                                        //             view: 'checkbox',
                                        //             id: 'remember',
                                        //             name: "rememberme",
                                        //             // css: "rememberlogin",
                                        //             labelRight: _("REMEMBERME"),
                                        //             labelPosition: "left",
                                        //             labelWidth: 5,
                                        //             checkValue: true,
                                        //             uncheckValue: false,
                                        //             value: values.rememberme
                                        //         },
                                        //         {
                                        //             view: "button",
                                        //             label: _("QUENMK") + " ?",
                                        //             // css: "mcls_btnResetPassLogin",
                                        //             type: "iconButton",
                                        //             width: 150,
                                        //             click: function () {
                                        //                 var win = this.$scope.ui(quenmk.$ui);
                                        //                 win.show();
                                        //             }
                                        //         }
                                        //     ]

                                        // },
                                        // {
                                        //     view: "button",
                                        //     id: "login",
                                        //     name: "login",
                                        //     label: _("DANGNHAP"),
                                        //     css: "btnlogin",
                                        //     height: 40,
                                        //     hotkey: "enter",
                                        //     type: "form",
                                        //     click: function () {
                                        //         var username = $$("username").getValue();
                                        //         $$("username").setValue(username.toUpperCase());
                                        //         if ($$("loginForm").validate()) {
                                        //             var values = $$("loginForm").getValues();
                                        //             if (true === values.rememberme) {
                                        //                 values.language = $$("cbLanguage").getValue();
                                        //                 Cookies.set("Crm", values);
                                        //             } else {
                                        //                 // Clear cookie
                                        //                 Cookies.remove("Crm");
                                        //             }
                                        //             user.login(values.username, values.password, values.ma_dvcs, $$("cbLanguage").getValue(), $$('loginForm'));
                                        //         } else {
                                        //             $$("username").focus();
                                        //             $$("loginForm").focus();
                                        //         }
                                        //     }
                                        // },
                                        // {
                                        //     view: "label", label: "<center>Bạn muốn dùng thử ?<b style='color:red;'> <a href='http://minvoice.vn/dang-ky-dai-ly/' data-toggle='tooltip' title='Đăng ký sử dụng M-Invoice !' target='_blank' style='text-decoration:none; color: red;'>Đăng ký</a></b></center>"
                                        // },
                                        // {
                                        //     view: "label",
                                        //     height: 22,
                                        //     css: { "padding-top": "6px" },
                                        //     label: "<hr size='1px' align='center' color='#dadee0'>"
                                        // },
                                        // {
                                        //     cols: [
                                        //         {},
                                        //         {
                                        //             view: "icon", icon: "fab fa-facebook-f",
                                        //             //  width: 100, 
                                        //             css: "fbFooter",
                                        //             on: {
                                        //                 onClick: function () {
                                        //                     var win = window.open("https://www.facebook.com/hoadondientu.m.invoice", '_blank');
                                        //                     win.focus();
                                        //                     return;
                                        //                 }
                                        //             }, click: function () {
                                        //                 this.callEvent("onClick");
                                        //             }
                                        //         }, { width: 15 },
                                        //         {
                                        //             view: "icon", icon: "fab fa-youtube-play",
                                        //             //  width: 100,
                                        //             css: "ybFooter",
                                        //             on: {
                                        //                 onClick: function () {
                                        //                     var win = window.open("https://www.youtube.com/c/HoaDonDienTuMinvoice", '_blank');
                                        //                     win.focus();
                                        //                     return;
                                        //                 }
                                        //             }, click: function () {
                                        //                 this.callEvent("onClick");
                                        //             }
                                        //         }, { width: 15 },
                                        //         {
                                        //             view: "icon", icon: "fab fa-chrome",
                                        //             // width: 100,
                                        //             css: "igFooter",
                                        //             on: {
                                        //                 onClick: function () {
                                        //                     var win = window.open("https://minvoice.vn", '_blank');
                                        //                     win.focus();
                                        //                     return;
                                        //                 }
                                        //             }, click: function () {
                                        //                 this.callEvent("onClick");
                                        //             }
                                        //         },
                                        //         {}
                                        //     ]
                                        // }
                                    ]
                                },
                                { gravity: 1, temlate: "" }
                            ]
                        },
                        { gravity: 1, template: "" }
                    ]
                }
            ]
        },
        $oninit: function () {
            var ma_dvcs = $$("ma_dvcs").getValue();
            webix.ajax()
                .headers({ 'content-type': 'application/json' })
                .get(app.config.host + "/System/GetPhanVung?ma_dvcs=" + ma_dvcs, function (result) {
                    var _res = result == "null" ? null : result.substr(1, result.length - 2);
                    $$("phanvung").define("template", `<label class='f1s' style='color:blue'>${_("PHAN_VUNG")} : ${res}</label>`);
                    $$("phanvung").refresh();
                })
            // $$("loginForm").focus();
            document.getElementById("password-addon").addEventListener("click", function () { var e = document.getElementById("password-input"); "password" === e.type ? e.type = "text" : e.type = "password" });
            document.getElementById("myFormLogin").addEventListener("submit", function (e) {
                e.preventDefault();
                e.stopPropagation();
                LoginFunc();
            });
        }
    };
});

define('views/main',[
    "app",
    "locale",
    "models/user",
    "views/forms/main",
    "views/forms/file_IM"
], function (app, _, user, main, file_IM) {
    'use strict';
    var fm = function (number) {
        var k = webix.Number.numToStr({
            groupDelimiter: ".",
            groupSize: 3,
            decimalDelimiter: ",",
            decimalSize: 0
        });
        return k(number);
    }

    var op = [];
    var subChucNang = webix.ui({
        view: "submenu",
        width: 300,
        minWidth: 400,
        // autofit: true,
        id: "subDowload",
        padding: 0,
        on: {
            onItemClick: function (id, e, node) {
                var item = this.getItem(id);
                webix.confirm({
                    title: "TẢI HÓA ĐƠN",
                    text: "Bạn có muốn tải file: <span style='color: red'>" + item.value + "</span> đính kèm hóa đơn số: <span style='color: red'>" + item.invoiceNumber + "</span>", ok: "Có", cancel: "Không",
                    callback: function (res) {
                        if (res) {
                            var table = webix.$$("mainData");
                            webix.extend(table, webix.ProgressBar);
                            table.disable();
                            table.showProgress();
                            webix.ajax()
                                .response("arraybuffer")
                                .get(app.config.host + "/ManageInvoice/DowloadFileIM?id=" + item.inv_Invoice_id + "&fileName=" + item.value + "&fileType=" + item.fileType, function (text, data) {
                                    var file = new Blob([data], { type: item.fileType });
                                    //  var fileURL = URL.createObjectURL(file);
                                    //    window.open(fileURL, '_blank');
                                    webix.html.download(file, item.value);
                                    table.enable();
                                    table.hideProgress();
                                });
                            // webix.ajax()
                            //     .headers({ 'Content-type': 'application/json' })
                            //     .post(app.config.host + "/ManageInvoice/SaveInv", khData,
                            //     {
                            //         error: function (text, data, XmlHttpRequest) {
                            //             table.enable();
                            //             table.hideProgress();
                            //             var json = JSON.parse(text);
                            //             webix.message(json.ExceptionMessage, "error");
                            //             //webix.message(XmlHttpRequest.statusText, "error");
                            //         },
                            //         success: function (text, data, XmlHttpRequest) {
                            //             table.remove(item.id);
                            //             table.enable();
                            //             table.hideProgress();
                            //         }
                            //     });
                        }
                    }
                });
            }
        }
    });

    webix.$$("title").parse({ title: "Quản lý hóa đơn > Hóa đơn đầu vào", details: "Quản lý hóa đơn đầu vào" });
    webix.ui({
        view: "contextmenu",
        id: "cmenu",
        autowidth: true,
        //css: { "background": "#ccc !important" },
        data: [
            { value: "Thêm (F4)", icon: "far fa-plus" },
            { value: "Sửa (F3)", icon: "far fa-edit" },
            { value: "Xóa (F8)", icon: "far fa-trash" },
            { $template: "Separator" },
            { value: "Tải File đính kèm", icon: "fas fa-file-text-o" },
            { value: "Xem in", icon: "fas fa-print" }
        ],
        on: {
            onItemClick: function (id) {

                if (this.getItem(id).value == "Thêm (F4)") {
                    $$("btnPlus").callEvent("onClick");
                }
                if (this.getItem(id).value == "Sửa (F3)") {
                    $$("btnEdit").callEvent("onClick");
                }
                if (this.getItem(id).value == "Xóa (F8)") {
                    $$("btnDelete").callEvent("onClick");
                }
                if (this.getItem(id).value == "Tải File đính kèm") {
                    var table = webix.$$("mainData");
                    var item = table.getSelectedItem();
                    if (item == null) {
                        webix.message("Bạn chưa chọn hóa đơn !", "error");
                        return;
                    }
                    webix.message("Continue !", "debug");
                    //console.log(item);
                    // if (item.inv_originalId != null && item.inv_originalId != undefined) {
                    //     var box = webix.modalbox({
                    //         title: "Đang in chứng từ",
                    //         text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                    //         width: 350,
                    //         height: 200
                    //     });

                    //     //var newWin = window.open();

                    //     webix.ajax()
                    //         .response("arraybuffer")
                    //         .headers({ 'Content-type': 'application/json' })
                    //         .get(app.config.host + "/Invoice/PrintInvoice?id=" + item.inv_originalId + "&type=PDF", {
                    //             error: function (text, data, XmlHttpRequest) {
                    //                 webix.modalbox.hide(box);
                    //                 alert(text);
                    //             },
                    //             success: function (text, data, XmlHttpRequest) {
                    //                 var file = new Blob([data], { type: 'application/pdf' });
                    //                 var fileURL = URL.createObjectURL(file);

                    //                 webix.modalbox.hide(box);
                    //                 //newWin.location = fileURL;
                    //                 window.open(fileURL, '_blank');

                    //             }
                    //         });

                    //     // webix.ajax()
                    //     // .response("arraybuffer")
                    //     // .get(app.config.host + "/Invoice/PrintInvoice?id=" + item.inv_originalId + "&type=PDF", function (text, data) {
                    //     //     var file = new Blob([data], { type: 'application/pdf' });
                    //     //     var fileURL = URL.createObjectURL(file);
                    //     //     window.open(fileURL, '_blank');
                    //     //     // webix.html.download(file, $$('tenfile').getValue());
                    //     // });
                    // }
                    // else {
                    //     webix.message("Không tồn tại hóa đơn gốc !", "error");
                    //     return;
                    // }
                }

            }
        }
    });
    var controls = [
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-refresh fa-lg" aria-hidden="true"></i> ' +
            '<span class="text">' + _("REFRESH") + '</span>',
            id: "btnReload",
            on: {
                onClick: function () {
                    webix.callEvent("onLoadError");
                    var table = webix.$$("mainData");
                    table.clearAll();
                    table.load(table.config.url);
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-plus fa-lg" aria-hidden="true"></i> ' +
            '<span class="text">' + _("Thêm (F4)") + '</span>',
            id: "btnPlus",
            //css:"button_raised",
            on: {
                onClick: function () {
                    webix.callEvent("onLoadError");
                    var detailForm = this.$scope.ui(main.$ui);
                    //main.setValues(null, null, null);
                    main.setEditMode(1);
                    detailForm.show();
                    // if (vc_window.after_new != null) {
                    //     var fn = Function("app", vc_window.after_new);
                    //     fn(app);
                    // }
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-edit fa-lg" aria-hidden="true"></i> ' +
            '<span class="text">' + _("Sửa (F3)") + '</span>',
            id: "btnEdit",
            shortcut: "F3",
            //css:"button_raised",
            on: {
                onClick: function () {
                    webix.callEvent("onLoadError");
                    var detailForm = this.$scope.ui(main.$ui);
                    //var detailForm = this.$scope.ui(webix.$$("main"));
                    var table = webix.$$("mainData");
                    var item = table.getSelectedItem();

                    if (item == null || item == undefined) {
                        webix.message("Bạn chưa chọn dòng cần sửa !", "error");
                        return;
                    }

                    if (item.$group) {
                        webix.message("Không thể sửa nhóm !", "error");
                        return;
                    }
                    // main.setEditMode(0);
                    // main.initUI(windowconfig);
                    main.setEditMode(2);
                    main.setValues(item, null);

                    detailForm.show();
                    //main.focusFirstElement();
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-trash-o fa-lg" aria-hidden="true"></i> ' +
            '<span class="text">' + _("Xóa (F8)") + '</span>',
            id: "btnDelete",
            shortcut: "F8",
            //css:"button_raised",
            on: {
                onClick: function () {
                    var table = webix.$$("mainData");
                    var item = table.getSelectedItem();
                    if (item == null || item == undefined) {
                        webix.message("Bạn chưa chọn dòng cần xóa !", "error");
                        return;
                    }
                    if (item.$group) {
                        webix.message("Không thể xóa cột nhóm !", "error");
                        return;
                    }

                    var khData = {};
                    // khData.windowid = windowconfig.data[0].window_id;
                    khData.editmode = 3;
                    khData.data = [];
                    khData.data.push(item);

                    webix.confirm({
                        title: "XÓA HÓA ĐƠN",
                        text: "Bạn có muốn xóa hóa đơn số: <span style='color: red'>" + item.invoiceNumber + "</span>", ok: "Có", cancel: "Không",
                        callback: function (res) {
                            if (res) {

                                webix.extend(table, webix.ProgressBar);
                                table.disable();
                                table.showProgress();

                                webix.ajax()
                                    .headers({ 'Content-type': 'application/json' })
                                    .post(app.config.host + "/ManageInvoice/SaveInvoiceManage", khData,
                                    {
                                        error: function (text, data, XmlHttpRequest) {
                                            table.enable();
                                            table.hideProgress();
                                            var json = JSON.parse(text);
                                            webix.message(json.ExceptionMessage, "error");
                                            //webix.message(XmlHttpRequest.statusText, "error");
                                        },
                                        success: function (text, data, XmlHttpRequest) {
                                            table.remove(item.id);
                                            table.enable();
                                            table.hideProgress();
                                        }
                                    });
                            }
                        }
                    });
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-print fa-lg" aria-hidden="true"></i> ' +
            '<span class="text">' + _("PRINT") + '</span>',
            id: "btnPrint",
            on: {
                onClick: function () {

                    var table = webix.$$("mainData");
                    var item = table.getSelectedItem();
                    if (item == null || item == undefined) {
                        webix.message("Bạn chưa chọn hóa đơn cần in !", "error");
                        return;
                    }
                    //webix.message("Chưa có mẫu in ...", "error");
                    // var rpParameter = null;
                    var box = webix.modalbox({
                        title: "Đang in hóa đơn ....",
                        text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                        width: 350,
                        height: 200
                    });

                    var newWin = window.open();
                    var html = '<html><head><title>Hóa đơn điện tử M-Invoice</title>'
                        + '<link rel="stylesheet" href="assets/fontawesome_pro/css/all.css" type="text/css" charset="utf-8">'
                        + '<link rel="stylesheet" href="assets/fontawesome.css" type="text/css" charset="utf-8">'
                        + '</head><body><center>Đang tải dữ liệu ... <br><p><i style="font-size:200%;" class="fa fa-spin fa-spinner"></i></p></center></body></html>';
                    newWin.document.write(html);

                    webix.ajax()
                        .response("arraybuffer")
                        .headers({ 'Content-type': 'application/json' })
                        .get(app.config.host + "/ManageInvoice/PrintPDF?id=" + item.id,
                        {
                            error: function (text, data, XmlHttpRequest) {
                                webix.modalbox.hide(box);
                                webix.message(XmlHttpRequest.statusText, "error");
                            },
                            success: function (text, data, XmlHttpRequest) {
                                var file = new Blob([data], { type: 'application/pdf' });
                                var fileURL = URL.createObjectURL(file);
                                //window.open(fileURL, '_blank');
                                webix.modalbox.hide(box);
                                newWin.location = fileURL;
                            }
                        });
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {
            view: "button", type: "htmlbutton", width: 115,
            label: '<i class="fa fa-file-text-o fa-lg" aria-hidden="true"></i> ' +
            '<span class="text">' + _("EXPORT_EXCEL") + '</span>',
            id: "btnExport",
            on: {
                onClick: function () {
                    var box = webix.modalbox({
                        title: "Đang kết suất Excel ... ",
                        buttons: ["Hủy bỏ"],
                        text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                        width: 350,
                        height: 200,
                        callback: function (result) {
                            switch (result) {
                                case "0":
                                    clearTimeout(interVal);
                                    webix.modalbox.hide(box);
                                    break;
                            }
                        }
                    });
                    var interVal = setTimeout(function () {
                        var table = $$("mainData");
                        webix.toExcel(table, {
                            filename: "danh sach hoa don",
                            rawValues: true,
                            filterHTML: true
                        });
                        clearTimeout(interVal);
                        webix.modalbox.hide(box);
                    }, 1500);

                    // var rpParameter = table.config.rpParameter;
                    // if (rpParameter == undefined || rpParameter == null) {
                    //     webix.message("Bạn chưa chọn báo cáo hoặc chưa tải dữ liệu !", "error");
                    //     return;
                    // }
                    // rpParameter.type = "xlsx";

                    // if (rpParameter != null) {
                    //     var box = webix.modalbox({
                    //         title: "Đang kết xuất Excel ....",
                    //         text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                    //         width: 350,
                    //         height: 200
                    //     });

                    //     webix.ajax()
                    //         .response("arraybuffer")
                    //         .headers({ 'Content-type': 'application/json' })
                    //         .post(app.config.host + "/Bcthsd/PrintPDFBangKeBanRa", rpParameter,
                    //         {
                    //             error: function (text, data, XmlHttpRequest) {
                    //                 webix.modalbox.hide(box);
                    //                 webix.message(XmlHttpRequest.statusText, "error");
                    //             },
                    //             success: function (text, data, XmlHttpRequest) {
                    //                 var file = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                    //                 var fileURL = URL.createObjectURL(file);
                    //                 webix.modalbox.hide(box);
                    //                 window.location.href = fileURL;
                    //             }
                    //         }
                    //         // function (text, data) {

                    //         //     var file = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                    //         //     var fileURL = URL.createObjectURL(file);

                    //         //     window.location.href = fileURL;
                    //         // }
                    //         );
                    // }
                }
            },
            click: function () {
                this.callEvent("onClick");
            }

        },
        // {
        //     id: "btnDowload", width: 100,
        //     view: "button", type: "htmlbutton",
        //     label: '<i class="fa fa-download fa-lg" aria-hidden="true"></i> ' +
        //     '<span class="text">' + _("Tải File") + '</span>',
        //     on: {
        //         onClick: function () {
        //             webix.callEvent("onLoadError");
        //             var table = webix.$$("mainData");
        //             var item = table.getSelectedItem();
        //             if (item == null || item == undefined) {
        //                 webix.message("Bạn chưa chọn hóa đơn !", "error");
        //                 return;
        //             }
        //             var url = app.config.host + "/ManageInvoice/GetListFileById?id=" + item.id;

        //             $$("subDowload").clearAll()
        //             $$("subDowload").define("url", url);;
        //             subChucNang.show(webix.$$("btnDowload").$view);
        //         }
        //     }, click: function () {
        //         this.callEvent("onClick");
        //     }
        // },
        {}
    ];
    var fm = webix.Number.numToStr({
        groupDelimiter: ",",
        groupSize: 3,
        decimalDelimiter: ".",
        decimalSize: 0
    });
    var grid = {
        rows: [
            {
                //container: "testA",
                view: "datatable",
                id: "mainData",
                select: true,
                resizeColumn: true,
                fixedRowHeight: false,
                leftSplit: 8,
                rightSplit: 1,
                rowLineHeight: 25, rowHeight: 25,
                tooltip: true,
                //autowidth: true,
                url: {
                    $proxy: true,
                    load: function (view, callback, params) {
                        var url = app.config.host + "/ManageInvoice/GetData";

                        if (params == null) {
                            url = url + "?start=0&count=" + view.config.datafetch + "&continue=null&filter=null";
                        }
                        else {
                            url = url + "?start=" + params.start + "&count=" + params.count + "&continue=" + params.continue;

                            if (params.filter != null) {
                                var array = [];

                                for (var property in params.filter) {

                                    var column = view.getColumnConfig(property);

                                    var item = {
                                        columnName: property,
                                        columnType: column.columnType,
                                        value: params.filter[property]
                                    };

                                    array.push(item);
                                }

                                //console.log(JSON.stringify(array));
                                url = url + "&filter=" + JSON.stringify(array);
                            }
                        }
                        webix.ajax(url, callback, view);
                    }
                },
                on: {
                    onItemClick: function (id) {
                        if (id.column == "ten_loai") {
                            //webix.confirm()
                            //webix.message("Continue Dowloading ... !", "debug");
                        }
                        if (id.column == "lstFile") {
                            var item = this.getItem(id);
                            var detailForm = this.$scope.ui(file_IM.$ui);
                            file_IM.initUI(id.row, item);
                            detailForm.show();
                        }
                    },
                    onClick: function (e) {
                        var view = $$(e);
                        if (!view || !view.getFormView || view.getFormView() != $$("invoiceDate"))
                            webix.confirm("The changes was not saved");
                    },
                    onItemDblClick: function (id, e, node) {
                        var btnEdit = $$("btnEdit");
                        btnEdit.callEvent("onClick");
                    },
                    onAfterLoad: function () {
                        // webix.delay(function () {
                        //     this.adjustRowHeight("ten_loai", true);
                        //     this.render();
                        // }, this);
                        //console.log($$("mainData").serialize());
                        // this.openAll();
                        $$("cmenu").attachTo($$("mainData"));
                    },
                    onColumnResize: function () {
                        this.adjustRowHeight("ten_loai", true);
                        this.render();
                    },
                    onSubViewCreate: function (view, item) {
                        var subView = view;

                        if (subView != null) {
                            // var windowno = app.path[1].params[0];

                            // var url = app.config.host + "/System/GetDataDetailsByTabTable?window_id=" + windowno
                            //     + "&id=" + item.id;

                            // var detailTables = subView.getChildViews()[1].getChildViews();

                            // for (var i = 0; i < detailTables.length; i++) {
                            //     var dt = detailTables[i];
                            //     dt.clearAll();
                            //     dt.load(url + "&tab_table=" + dt.config.tab_table);
                            // }

                            var tableDetail = webix.$$("inv_InvoiceDetails_view");
                            var url = app.config.host + "/ManageInvoice/GetDataDetail?id=" + item.id;
                            tableDetail.clearAll();
                            tableDetail.load(url);

                            var tableFile = webix.$$("lstFile_view");
                            var url = app.config.host + "/ManageInvoice/GetDataDetailFile?id=" + item.id;
                            tableFile.clearAll();
                            tableFile.load(url);
                        }
                    }
                    // "data->onStoreUpdated": function () {
                    //     this.data.each(function (obj, i) {
                    //         console.log(obj);
                    //         console.log(i);
                    //         obj.index = i + 1;
                    //     })
                    // }
                },
                subview: {
                    borderless: true,
                    view: "tabview",
                    height: 255,
                    css: "subInvoice",
                    scrollX: true,
                    // tabbar: {
                    //     width: 200
                    // },
                    multiview: {
                        fitBiggest: true
                    },
                    cells: [
                        {
                            header: "Chi tiết hóa đơn",
                            select: "cell",
                            body: {
                                view: "datatable",
                                resizeColumn: true,
                                margin: 10,
                                id: "inv_InvoiceDetails_view",
                                height: 200,
                                columns: [
                                    { id: "stt", header: "", width: 30 },
                                    {
                                        id: "ma_hanghoa", header: _("Mã hàng hóa"), editor: "text", width: 100, editable: true
                                    },
                                    {
                                        id: "ten_hang", header: _("Tên hàng hóa"), editor: "text", width: 350, editable: true
                                    },
                                    {
                                        id: "dvt", header: _("ĐVT"), editor: "text", width: 80, editable: true
                                    },
                                    {
                                        id: "so_luong",
                                        header: _("Số lương"), editor: "autonumeric", width: 100,
                                        editable: true, css: { "text-align": "right" },
                                        format: webix.Number.numToStr({
                                            groupDelimiter: ",",
                                            groupSize: 3,
                                            decimalDelimiter: ".",
                                            decimalSize: 2
                                        })
                                    },
                                    {
                                        id: "don_gia",
                                        header: _("Đơn giá"), width: 150, editor: "autonumeric", editable: true,
                                        css: { "text-align": "right" },
                                        format: webix.Number.numToStr({
                                            groupDelimiter: ",",
                                            groupSize: 3,
                                            decimalDelimiter: ".",
                                            decimalSize: 2
                                        })
                                        // value_change: field.value_change
                                    },
                                    {
                                        id: "tien_tt",
                                        header: _("Tiền trước thuế"),
                                        width: 150, editor: "autonumeric", editable: true, css: { "text-align": "right" },
                                        format: webix.Number.numToStr({
                                            groupDelimiter: ",",
                                            groupSize: 3,
                                            decimalDelimiter: ".",
                                            decimalSize: 2
                                        })
                                        // value_change: field.value_change
                                    },
                                    {
                                        id: "pt_ck",
                                        header: _("% CK"), width: 80, editor: "autonumeric", editable: true,
                                        css: { "text-align": "right" },
                                        format: webix.Number.numToStr({
                                            groupDelimiter: ",",
                                            groupSize: 3,
                                            decimalDelimiter: ".",
                                            decimalSize: 2
                                        })
                                    },
                                    {
                                        id: "tien_ck", header: _("Tiền CK"),
                                        width: 150, editor: "autonumeric", editable: true,
                                        css: { "text-align": "right" },
                                        format: webix.Number.numToStr({
                                            groupDelimiter: ",",
                                            groupSize: 3,
                                            decimalDelimiter: ".",
                                            decimalSize: 2
                                        })
                                    },
                                    {
                                        id: "pt_thue",
                                        header: _("Thuế suất"), width: 100, editor: "autonumeric", editable: true,
                                        css: { "text-align": "right" },
                                        format: webix.Number.numToStr({
                                            groupDelimiter: ",",
                                            groupSize: 3,
                                            decimalDelimiter: ".",
                                            decimalSize: 2
                                        })
                                    },
                                    {
                                        id: "tien_thue",
                                        header: _("Tiền thuế"),
                                        width: 150, editor: "autonumeric", editable: true, css: { "text-align": "right" },
                                        format: webix.Number.numToStr({
                                            groupDelimiter: ",",
                                            groupSize: 3,
                                            decimalDelimiter: ".",
                                            decimalSize: 2
                                        })
                                    },
                                    {
                                        id: "tong_tien",
                                        header: _("Tiền sau thuế"), width: 150, editor: "autonumeric", editable: true,
                                        css: { "text-align": "right" },
                                        format: webix.Number.numToStr({
                                            groupDelimiter: ",",
                                            groupSize: 3,
                                            decimalDelimiter: ".",
                                            decimalSize: 2
                                        })
                                    },
                                    {
                                        id: "khuyen_mai", header: _("Khuyến mại"), width: 100, editor: "checkbox", editable: true,
                                        template: "{common.checkbox()}",
                                        checkValue: true,
                                        uncheckValue: false
                                    },
                                    {
                                        id: "giam_tru", header: _("Giảm trừ"), width: 100, editor: "checkbox", editable: true,
                                        template: "{common.checkbox()}",
                                        checkValue: true,
                                        uncheckValue: false
                                    }
                                ],
                                on: {
                                    onBeforeLoad: function () {
                                        this.showOverlay(_("LOADING") + "...");
                                    },
                                    onAfterLoad: function () {
                                        this.hideOverlay();
                                    },
                                    "data->onStoreUpdated": function () {
                                        this.data.each(function (obj, i) {
                                            obj.stt = i + 1;
                                        })
                                    }
                                }
                            }
                        },
                        {
                            header: "File đính kèm",
                            select: "cell",
                            body: {
                                view: "datatable",
                                resizeColumn: true,
                                margin: 10,
                                height: 200,
                                id: "lstFile_view",
                                columns: [
                                    { id: "stt", header: "", width: 30 },
                                    {
                                        id: "file_data", name: "file_data", header: "", editor: "combo", hidden: true
                                    },
                                    {
                                        id: "loai_file", name: "loai_file", header: "", editor: "text", hidden: true
                                    },
                                    {
                                        id: "ten_file", name: "ten_file", header: "File", editor: "text", width: 400
                                    },
                                    {
                                        id: "size", name: "size", header: "", editor: "text", hidden: true
                                    },
                                    {
                                        id: "size_text", name: "size_text", header: "Size", editor: "text", width: 100
                                    }
                                ]
                            }
                        }
                    ]
                },
                columns: [
                    {
                        id: "subRowMain",
                        header: "&nbsp;",
                        template: "{common.subrow()}",
                        width: 40
                        // height: 25
                    },
                    {
                        id: "ten_trang_thai", header: ["<center>Trạng thái HĐ</center>", { content: "textFilter" }],
                        template: function (obj, common) {
                            return "<span class='mcls_status " + obj.className + "'>" + obj.ten_trang_thai + "</span>";
                        }, width: 100, columnType: "nvarchar"
                    },
                    { id: "invoiceNumber", header: ["<center>Số hóa đơn</center>", { content: "textFilter" }], width: 100, columnType: "nvarchar" },
                    // {
                    //     id: "ten_loai", header: [{ "text": "<center>Hóa đơn chứng từ bán</center>", "colspan": 2 }, { "text": "<center>Số hóa đơn</center>" }],
                    //     width: 525,
                    //     // template: function (obj, common) {
                    //     //     if (obj.$group) return common.treetable(obj, common) + obj.invoiceNumber;
                    //     //     return obj.invoiceNumber;
                    //     //}
                    //     template: function (obj, common) {
                    //         if (obj.$level == 1) return common.treetable(obj, common) + "<span style='color:red;'>" + obj.value + " ( " + obj.$count + " )" + "</span>";
                    //         //return obj.invoiceNumber;
                    //         return "<a style = 'text-decoration: none; color:blue;' href='JavaScript:Void(0);'> " + obj.invoiceNumber + "</a>"
                    //     }
                    // },
                    {
                        id: "invoiceDate", header: ["<center>Ngày hóa đơn</center>", { content: "serverDateRangeFilter" }], width: 110,
                        //format:webix.i18n.dateFormatStr
                        format: function (text) {
                            var format = webix.Date.dateToStr("%d/%m/%Y");
                            text = removeTimeZoneT(text);
                            return format(text);
                        }
                        , columnType: "datetime"
                    },
                    { id: "mauhd", header: ["<center>Mẫu số</center>", { content: "textFilter" }], width: 100, columnType: "nvarchar" },
                    { id: "invoiceSeries", header: ["<center>Ký hiệu</center>", { content: "textFilter" }], width: 80, columnType: "nvarchar" },
                    { id: "sellerTaxCode", header: ["<center>Mã số thuế</center>", { content: "textFilter" }], width: 120, columnType: "nvarchar" },
                    { id: "sellerName", header: ["<center>Tên người mua</center>", { content: "textFilter" }], width: 300, columnType: "nvarchar" },

                    {
                        id: "tien_tt", header: ["<center>Tiền trước thuế</center>", { content: "textFilter" }], width: 150,
                        //  format: webix.Number.numToStr({
                        //     groupDelimiter: ".",
                        //     groupSize: 3,
                        //     decimalDelimiter: ",",
                        //     decimalSize: 0
                        // }),
                        css: { "text-align": "right" },
                        template: function (obj, common) {
                            return obj.tien_tt == null ? 0 : fm(obj.tien_tt);
                        }, columnType: "decimal"
                    },
                    {
                        id: "tien_thue", header: ["<center>Tổng tiền thuế</center>", { content: "textFilter" }], width: 150,
                        template: function (obj, common) {
                            return obj.tien_thue == null ? 0 : fm(obj.tien_thue);
                        },
                        //  format: webix.Number.numToStr({
                        //     groupDelimiter: ".",
                        //     groupSize: 3,
                        //     decimalDelimiter: ",",
                        //     decimalSize: 0
                        // }),
                        css: { "text-align": "right" }, columnType: "decimal"
                    },
                    {
                        id: "tien_ck", header: ["<center>Tổng tiền CK</center>", { content: "textFilter" }], width: 150,
                        template: function (obj, common) {
                            return obj.tien_ck == null ? 0 : fm(obj.tien_ck);
                        },
                        //  format: webix.Number.numToStr({
                        //     groupDelimiter: ".",
                        //     groupSize: 3,
                        //     decimalDelimiter: ",",
                        //     decimalSize: 0
                        // }),
                        css: { "text-align": "right" }, columnType: "decimal"
                    },
                    {
                        id: "tong_tien", header: ["<center>Tổng tiền sau thuế</center>", { content: "textFilter" }], width: 150,
                        template: function (obj, common) {
                            return obj.tong_tien == null ? 0 : fm(obj.tong_tien);
                        },
                        //  format: webix.Number.numToStr({
                        //     groupDelimiter: ".",
                        //     groupSize: 3,
                        //     decimalDelimiter: ",",
                        //     decimalSize: 0
                        // }),
                        css: { "text-align": "right" }, columnType: "decimal"
                    },
                    { id: "ghi_chu", header: ["<center>Ghi chú</center>", { content: "textFilter" }], width: 200, columnType: "nvarchar" },
                    { id: "ten_ncc", header: ["<center>Tên nhà cung cấp</center>", { content: "textFilter" }], width: 200, columnType: "nvarchar" },
                    {
                        id: "ma_loai", header: ["<center>Mã loại HĐ</center>", { content: "serverSelectFilter" }],
                        width: 50, tooltip: "#ten_loai#", columnType: "nvarchar",
                        options: app.config.host + "/System/GetDataReferencesByRefId?refId=RF00303"
                    },
                    {
                        id: "lstFile", header: "", width: 50, tooltip: "Tệp đính kèm",
                        template: function (obj) {
                            return "<div class='webix_el_button'><button class='webixtype_base'><i class='fa fa-paperclip' aria-hidden='true'></i></button></div>";
                        }
                    }
                    // { id: "ten_loai", header: ["<center>Tên loại HĐ</center>", { content: "textFilter" }], width: 200, columnType: "nvarchar" }
                ],
                pager: "pagerA",
                // scheme: {
                //     $group: {
                //         by: "ten_loai",
                //         //css:"multiline",
                //         map: {
                //             vatAmount: ["vatAmount", "sum"],
                //             totalAmountWithoutVat: ["totalAmountWithoutVat", "sum"]
                //             //title: ["year"]
                //         }
                //     },
                //     //$sort: { by: "stt", dir: "asc" }
                // },
                // ready: function () {
                //     //this.open(this.getFirstId());
                //     //this.sort({ by: "stt", dir: "asc" });
                //     this.openAll();
                // },
            },
            {
                cols: [
                    {
                        view: "icon", icon: "fas fa-question-circle", id: "help_form_main", tooltip: _("HELPER"),
                        css: "helper",
                        click: function () {
                            webix.alert({
                                title: "Thông báo !",
                                text: "Bạn chưa khai báo hướng dẫn nhanh cho màn hình này !",
                                type: "alert-warning",
                                callback: function (result) {
                                }
                            });
                        }
                    },
                    {
                        view: "combo",
                        label: _("MENU_QUICK"),
                        id: "QuickMenuMain",
                        options: {
                            // view: "gridsuggest",
                            // id: "grid_window",
                            // template: "#name#",
                            // body: {
                            //     scroll: true,
                            //     autoheight: false,
                            //     columns: [
                            //         { id: "window_id", header: "Window Id", editor: "text", width: 100 },
                            //         { id: "name", header: "Window Name", editor: "text", width: 400 }
                            //     ],
                            //     url: app.config.host + "/System/GetQuickMenu"
                            // },
                            // on: {
                            //     onValueSuggest: function (obj) {
                            //         var start = obj.window_id != "" ? obj.code + ":" + obj.window_id : obj.code;
                            //         window.location.hash = "!/app/" + start;
                            //         $$("QuickMenu").setValue(null);
                            //     }
                            // }
                        },
                        on: {
                            onChange: function (newv, oldv) {

                            }
                        }
                    },
                    {},
                    {
                        id: "pagerA",
                        view: "pager",
                        size: 100,
                        group: 5,
                        template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}"
                    }
                ]
            }
        ]
    }

    var layout = {
        css: "frmView",
        rows: [
            {
                height: 39,
                css: "btnControl",
                margin: 0,
                borderless: true,
                type: "toolbar",
                cols: controls
            },
            {
                rows: [
                    grid
                ]
            }
        ]

    };

    return {
        $ui: layout,
        $oninit: function (view, $scope) {

            $scope.on(app, "dataChangedMain", function (editmode, item) {

                var table = webix.$$("mainData");

                if (editmode == 1) {
                    table.clearAll();
                    table.load(table.config.url);
                    // console.log(item);
                    // console.log(item.ten_loai);
                    // table.add(item);
                    //table.select(item.id,false);
                }

                if (editmode == 2) {
                    table.clearAll();
                    table.load(table.config.url);
                    // var selectedItem = table.getSelectedItem();
                    // table.updateItem(selectedItem.id, item);

                    // webix.UIManager.setFocus($$(table.config.id));
                }

            });
            // var table = $$("mainData");
            // var url = {
            //     $proxy: true,
            //     load: function (view, callback, params) {
            //         console.log(view.config);
            //         console.log(callback);
            //         console.log(params);
            //         /*var windowno = app.path[1].params[0];
            //         var url = app.config.host + "/System/GetDataByWindowNo?window_id=" + windowno;

            //         if (params == null) {
            //             url = url + "&start=0&count=" + view.config.datafetch + "&continue=null&filter=null";
            //         }
            //         else {
            //             url = url + "&start=" + params.start + "&count=" + params.count + "&continue=" + params.continue;

            //             if (params.filter != null) {
            //                 var array = [];

            //                 for (var property in params.filter) {

            //                     var column = view.getColumnConfig(property);

            //                     if (column !== undefined) {
            //                         var item = {
            //                             columnName: property,
            //                             columnType: column.columnType,
            //                             value: params.filter[property]
            //                         };

            //                         array.push(item);
            //                     }
            //                 }

            //                 //console.log(JSON.stringify(array));
            //                 if (array.length > 0) {
            //                     url = url + "&filter=" + JSON.stringify(array);
            //                 }
            //                 else {
            //                     url = url + "&filter=null";
            //                 }

            //             }
            //             else {
            //                 url = url + "&filter=null";
            //             }
            //         }

            //         if (view.config.infoparam != null) {
            //             url = url + "&infoparam=" + JSON.stringify(view.config.infoparam);
            //         }
            //         else {
            //             url = url + "&infoparam=null";
            //         }

            //         var tlbParams = $$("tlbParams");

            //         if (tlbParams !== undefined) {
            //             var childViews = tlbParams.getChildViews();

            //             var parameters = [];

            //             for (var i = 0; i < childViews.length; i++) {
            //                 var child = childViews[i];

            //                 var id = child.config.id;
            //                 var value_field = child.config.value_field;

            //                 var item = {
            //                     columnName: value_field,
            //                     value: $$(id).getValue()
            //                 };

            //                 parameters.push(item);
            //             }

            //             url = url + "&tlbparam=" + JSON.stringify(parameters);

            //         }
            //         else {
            //             url = url + "&tlbparam=null";
            //         }*/

            //         //console.log(url);

            //         /* webix.ajax().bind(view)
            //             .get(url,function(text){
            //                 var json =JSON.parse(text);

            //                 this.clearAll();

            //                 if (!json.hasOwnProperty("error")){
            //                     this.parse(json.data,"json");
            //                 }
            //         }); */

            //         //webix.ajax(url, callback, view);

            //     }
            // };

            // table.define("url", url);

        }
    };
});
define('views/mauhoadon',[
    "app",
    "views/forms/mauhoadon",
    "locale",
    "views/modules/minvoiceplugin"
], function (app, dmwindowform, _, plugin) {
    'use strict';

    var op = [];

    webix.$$("title").parse({ title: "Hóa đơn > Quản lý phát hành > Mẫu hóa đơn", details: "Danh sách mẫu hóa đơn" });

    var submenu = webix.ui({
        view: "submenu",
        width: 200,
        padding: 0,
        data: [
            // { id: "createInvoiceTemplate", value: "Tạo mẫu hóa đơn" },
            { id: "uploadInvoiceTemplate", value: "Tải mẫu lên" },
            { id: "signInvoiceTemplate", value: "Ký mẫu hóa đơn" },
            { $template: "Separator" },
            { id: "printInvoiceTemplate", value: "Xem mẫu hóa đơn (PDF)" },
            // { id: "printTempHtml", value: "Xem mẫu hóa đơn (Html)" },
            { id: "dowload", value: "Tải mẫu thiết kế (.repx)" }

        ],
        on: {
            onItemClick: function (id, e, node) {
                this.hide();
                if (id == "createInvoiceTemplate") {
                    var table = webix.$$("dmwindowData");
                    var item = table.getSelectedItem();
                    if (item == null) {
                        webix.message("Bạn chưa chọn mẫu hóa đơn", "error");
                        return;
                    }
                    var box = webix.modalbox({
                        title: "Đang tạo mẫu hóa đơn",
                        buttons: ["Hủy bỏ"],
                        text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                        width: 350,
                        height: 200,
                        callback: function (result) {
                            switch (result) {
                                case "0":
                                    clearInterval(interVal);
                                    webix.modalbox.hide(box);
                                    break;
                            }
                        }
                    });

                    var interVal = setInterval(function () {
                        var url = app.config.host + "/Invoice/GetInvoiceTemplate?id=" + item.id;
                        webix.ajax(url, {
                            error: function (text, data, XmlHttpRequest) {
                                alert(text);
                                webix.modalbox.hide(box);
                                clearInterval(interVal);

                            },
                            success: function (text, data, XmlHttpRequest) {
                                var result = JSON.parse(text);

                                if (result.trang_thai_mau == "Đã tạo mẫu") {
                                    var table = webix.$$("dmwindowData");
                                    var item = table.getSelectedItem();
                                    item.trang_thai_mau = "Đã tạo mẫu";
                                    table.updateItem(item);
                                    webix.modalbox.hide(box);
                                    clearInterval(interVal);
                                }
                            }
                        });

                    }, 3000);
                    window.location.href = app.config.host + "/Content/App/ReportDesign/ReportDesign.application?type=99&id=" + item.id;
                }
                if (id == "printInvoiceTemplate") {
                    var item = $$("dmwindowData").getSelectedItem();
                    if (item == null) {
                        webix.message("Bạn chưa chọn mẫu hóa đơn", "error");
                        return;
                    }
                    if (item.trang_thai_mau != "Đã tạo mẫu") {
                        webix.message("Mẫu này chưa được tạo. Vui lòng kiểm tra lại !", "error");
                        return;
                    }
                    var url = app.config.host + "/Invoice/PrintInvoiceTemplate?id=" + item.id;
                    var box = webix.modalbox({
                        title: "Đang in mẫu hóa đơn (PDF) ....",
                        text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                        width: 350,
                        height: 200
                    });
                    webix.ajax()
                        .response("arraybuffer")
                        .get(url, function (text, data) {
                            var file = new Blob([data], { type: 'application/pdf' });
                            var fileURL = URL.createObjectURL(file);
                            webix.modalbox.hide(box);
                            window.open(fileURL, '_blank');
                        });

                }
                if (id == "dowload") {
                    var item = $$("dmwindowData").getSelectedItem();
                    if (item == null) {
                        webix.message("Bạn chưa chọn mẫu hóa đơn", "error");
                        return;
                    }

                    if (item.trang_thai_mau != "Đã tạo mẫu") {
                        webix.message("Mẫu hóa đơn chưa được tạo, không thể tải xuống !", "error");
                        return;
                    }

                    var url = app.config.host + "/Invoice/DowloadRepx?id=" + item.id;
                    var box = webix.modalbox({
                        title: "Đang tải mẫu hóa đơn (repx) ....",
                        text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                        width: 350,
                        height: 200
                    });
                    webix.ajax()
                        .response("arraybuffer")
                        .get(url, function (text, data) {
                            var file = new Blob([data], { type: 'application/octet-stream' });
                            webix.html.download(file, "InvoiceTemplate.repx");
                            webix.modalbox.hide(box);
                        });

                }
                if (id == "printTempHtml") {
                    var item = $$("dmwindowData").getSelectedItem();
                    if (item == null) {
                        webix.message("Bạn chưa chọn mẫu hóa đơn");
                        return;
                    }
                    if (item.trang_thai_mau != "Đã tạo mẫu") {
                        webix.message("Mẫu này chưa được tạo. Vui lòng kiểm tra lại !", "error");
                        return;
                    }

                    var url = app.config.host + "/Invoice/PrintInvoiceTemplate?id=" + item.id + "&type=Html";
                    var box = webix.modalbox({
                        title: "Đang in mẫu hóa đơn (Html) ....",
                        text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                        width: 350,
                        height: 200
                    });
                    var newwin = window.open();

                    webix.ajax()
                        .response("arraybuffer")
                        .get(url, function (text, data) {
                            var file = new Blob([data], { type: 'text/html' });
                            var fileURL = URL.createObjectURL(file);
                            webix.modalbox.hide(box);
                            newwin.location = fileURL;
                        });

                }
                if (id == "signInvoiceTemplate") {

                    var table = webix.$$("dmwindowData");
                    var item = table.getSelectedItem();

                    if (item == null) {
                        webix.message("Bạn chưa chọn mẫu hóa đơn", "error");
                        return;
                    }
                    if (item.da_ky == true) {
                        webix.message("Mẫu hóa đơn đã ký !", "error");
                        return;
                    }
                    var a = webix.ajax(app.config.host + "/Invoice/GetXmlTemplate?id=" + item.id);
                    var b = webix.ajax(app.config.host + "/Invoice/GetListCertificates");
                    var c = webix.ajax()
                        .headers({ "Content-Type": "application/json" })
                        .post(app.config.host + "/System/ExecuteCommand", {
                            command: "CM00019",
                            parameter: {
                                ma_dvcs: ""
                            }
                        });

                    webix.promise.all([a, b, c]).then(function (results) {
                        var xmlData = results[0].json();
                        var listcerts = results[1].json();
                        var c_results = results[2].json();

                        if (listcerts.length == 0) {
                            webix.message({ type: "error", text: "Bạn chưa được phân quyền chứng thư số" });
                            return;
                        }

                        var kytaptrung = "";
                        var server_cert = "";

                        for (var i = 0; i < c_results.length; i++) {
                            var item = c_results[i];

                            if (item.ma == "KYTAPTRUNG") {
                                kytaptrung = item.gia_tri;
                            }

                            if (item.ma == "SERVER_CERT") {
                                server_cert = item.gia_tri;
                            }
                        }

                        if (kytaptrung == "K") {
                            var hub = plugin.hub();
                            hub.off('resCommand');
                            hub.on('resCommand', function (result) {
                                var json = JSON.parse(result);
                                if (json.hasOwnProperty("error")) {
                                    webix.message({ type: 'error', text: json.error });
                                }
                                else {
                                    var callback = json.callback;

                                    if (callback == "SignInvoice") {
                                        var table = webix.$$("dmwindowData");
                                        var item = table.getSelectedItem();

                                        var parameter = {
                                            id: item.id,
                                            xml: json.xml
                                        };

                                        webix.ajax()
                                            .headers({ 'Content-type': 'application/json' })
                                            .post(app.config.host + "/Invoice/SignXmlTemplate", parameter, function (text) {
                                                var json = JSON.parse(text);
                                                if (!json.hasOwnProperty("error")) {
                                                    var table = $$("dmwindowData");
                                                    table.clearAll();
                                                    table.load(table.config.url);
                                                }
                                                else {
                                                    webix.message({ type: "error", text: json.error });
                                                }
                                            });
                                    }

                                }
                            });

                            var arg = {
                                callback: "SignInvoice",
                                idData: "#data",
                                xml: xmlData["xml"],
                                idSigner: "seller",
                                tagSign: "Signatures",
                                listcerts: listcerts
                            };

                            hub.invoke('execCommand', arg.callback, JSON.stringify(arg));
                        }
                        else {
                            var box = webix.modalbox({
                                title: "Chọn chứng thư số",
                                buttons: ["Nhận", "Hủy bỏ"],
                                text: "<div id='ctnCerts'></div>",
                                top: 100,
                                width: 750,
                                callback: function (result) {
                                    switch (result) {
                                        case "1":
                                            webix.modalbox.hide();
                                            break;
                                        case "0":
                                            var table = $$("tblCerts");
                                            var data = table.serialize();
                                            var cert = null;
                                            for (var i = 0; i < data.length; i++) {
                                                if (data[i].chon == true) {
                                                    cert = data[i];
                                                    break;
                                                }
                                            }

                                            if (cert == null) {
                                                webix.message("Bạn chưa chọn chứng thư số");
                                                return;
                                            }

                                            var table = webix.$$("dmwindowData");
                                            var item = table.getSelectedItem();

                                            webix.ajax(app.config.host + "/Invoice/GetXmlTemplate?id=" + item.id, function (text, data) {
                                                var xmlData = JSON.parse(text);

                                                var parameters = {
                                                    xml: xmlData["xml"],
                                                    refUri: "#data",
                                                    certSerial: cert.so_serial,
                                                    tokenSerial: cert.tokenSerial,
                                                    signId: "seller",
                                                    signTag: "Signatures",
                                                    pass: cert.pass,
                                                    inv_InvoiceAuth_id: xmlData["id"]
                                                };

                                                webix.ajax()
                                                    .headers({ "Content-Type": "application/json" })
                                                    .post(server_cert + "/Token/SignXml", parameters, function (text) {
                                                        var json = JSON.parse(text);
                                                        if (json.hasOwnProperty("error")) {
                                                            webix.message(json["error"]);
                                                        }
                                                        else {
                                                            var parameter = {
                                                                id: item.inv_InvoiceAuth_id,
                                                                xml: json.xml
                                                            };

                                                            webix.ajax()
                                                                .headers({ 'Content-type': 'application/json' })
                                                                .post(app.config.host + "/Invoice/SignXmlTemplate", parameter, function (text) {
                                                                    var json = JSON.parse(text);
                                                                    if (!json.hasOwnProperty("error")) {

                                                                        var table = $$("dmwindowData");
                                                                        table.clearAll();
                                                                        table.load(table.config.url);

                                                                    }
                                                                    else {
                                                                        webix.message({ type: "error", text: json.error });
                                                                    }
                                                                });
                                                        }
                                                    });
                                            });

                                    }
                                }
                            });

                            var popupText = document.getElementsByClassName("webix_popup_text")[0];
                            popupText.style.paddingTop = 0;

                            var tblMatHang = webix.ui({
                                container: "ctnCerts",
                                id: "tblCerts",
                                view: "datatable",
                                borderless: true,
                                height: 350,
                                columns: [
                                    {
                                        id: "chon",
                                        header: _("CHON"),
                                        width: 65,
                                        checkValue: true,
                                        uncheckValue: false,
                                        template: "{common.checkbox()}"
                                    },
                                    { id: "so_serial", header: _("SO_SERIAL"), width: 150 },
                                    { id: "subjectname", header: _("SUBJECTNAME"), width: 450 },
                                    { id: "ngaybatdau", header: _("NGAY_BAT_DAU"), width: 200 },
                                    { id: "ngayketthuc", header: _("NGAY_KET_THUC"), width: 200 },
                                    { id: "issuer", header: _("DONVI"), width: 450 },
                                ],
                                url: app.config.host + "/Invoice/GetListCertificates"
                            });
                        }
                    });
                }
                if (id == "uploadInvoiceTemplate") {
                    require(["views/forms/uploadfile"], function (uploadForm) {
                        var table = webix.$$("dmwindowData");
                        uploadForm.$ui.tableId = table.config.id;
                        var win = table.$scope.ui(uploadForm.$ui);
                        win.getHead().setHTML("Tải file mẫu hóa đơn");
                        win.show();
                        var item = table.getSelectedItem();
                        webix.$$("uploader").define("upload", app.config.host + "/Invoice/UploadInvTemplate");
                        webix.$$("uploader").define("formData", { dmmauhoadon_id: item.id });
                        webix.$$("uploader").refresh();
                    });
                }


            }
        }
    });

    var controls = [
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-plus fa-lg" aria-hidden="true"></i> ' +
                '<span class="text">' + _("THEM") + " (F4)" + '</span>',
            id: "btnPlus",
            //css:"button_raised",
            shortcut: "F4",
            on: {
                onClick: function () {
                    var win = this.$scope.ui(dmwindowform.$ui);
                    dmwindowform.setEditMode(1);
                    win.show();
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-edit fa-lg" aria-hidden="true"></i> ' +
                '<span class="text">' + _("SUA") + " (F3)" + '</span>',
            id: "btnEdit",
            //css:"button_raised",
            shortcut: "F3",
            on: {
                onClick: function () {
                    var detailForm = this.$scope.ui(dmwindowform.$ui);
                    var form = webix.$$("mauhoadon-form");
                    var table = webix.$$("dmwindowData");
                    var item = table.getSelectedItem();

                    if (item.da_ky == true) {
                        webix.message("Mẫu hóa đơn đã ký ! Bạn không thể sửa.", "error");
                        return;
                    }
                    form.setValues(item);
                    dmwindowform.setEditMode(2);
                    detailForm.show();
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-trash-o fa-lg" aria-hidden="true"></i> ' +
                '<span class="text">' + _("XOA") + " (F8)" + '</span>',
            id: "btnDelete",
            shortcut: "F8",
            on: {
                onClick: function () {
                    var table = webix.$$("dmwindowData");
                    var item = table.getSelectedItem();
                    var khData = {};
                    khData.windowid = app.path[1].params[0];
                    khData.editmode = 3;
                    khData.data = [];
                    khData.data.push(item);
                    webix.confirm({
                        text: "Bạn có muốn xóa " + item.ten_mau, ok: "Có", cancel: "Không",
                        callback: function (res) {
                            if (res) {
                                webix.ajax()
                                    .headers({ 'Content-type': 'application/json' })
                                    .post(app.config.host + "/System/Save", khData, function (text) {
                                        var json = JSON.parse(text);
                                        if (json.hasOwnProperty("error")) {
                                            webix.message({ type: "error", text: json.error });
                                            return;
                                        }
                                        table.remove(item.id);
                                    });
                            }
                        }
                    });
                }
            },
            click: function () {
                this.callEvent("onClick");
            }

        },
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-angle-down fa-lg" aria-hidden="true"></i> ' +
                '<span class="text">Chức năng</span>',
            id: "btnChucNang",
            click: function () {
                submenu.show(webix.$$("btnChucNang").$view);
            }
        },
        {}

    ];

    var grid = {
        rows: [
            {
                id: "dmwindowData",
                view: "datatable",
                select: true,
                datafetch: 100,
                //loadahead: 15,
                url: {
                    $proxy: true,
                    load: function (view, callback, params) {
                        var windowno = app.path[1].params[0];
                        var url = app.config.host + "/System/GetDataByWindowNo?window_id=" + windowno;

                        if (params == null) {
                            url = url + "&start=0&count=" + view.config.datafetch + "&continue=null&filter=null";
                        }
                        else {
                            url = url + "&start=" + params.start + "&count=" + params.count + "&continue=" + params.continue;

                            if (params.filter != null) {
                                var array = [];

                                for (var property in params.filter) {

                                    var column = view.getColumnConfig(property);

                                    if (column !== undefined) {
                                        var item = {
                                            columnName: property,
                                            columnType: column.columnType,
                                            value: params.filter[property]
                                        };

                                        if (column.tableAlias != undefined) {
                                            item.tableAlias = column.tableAlias;
                                        }

                                        if (item.columnType == "bit") {
                                            if (item.value != "") {
                                                item.value = item.value == "true" ? true : item.value == "false" ? false : "";
                                            }
                                        }

                                        if (item.columnType == "int" || item.columnType == "decimal") {
                                            if (item.value != "") {

                                                if (webix.rules.isNumber(item.value)) {
                                                    item.value = Number(item.value);
                                                }
                                                else {
                                                    item.value = "";
                                                }
                                            }
                                        }
                                        array.push(item);
                                    }
                                }

                                //console.log(JSON.stringify(array));
                                if (array.length > 0) {
                                    url = url + "&filter=" + JSON.stringify(array);
                                }
                                else {
                                    url = url + "&filter=null";
                                }

                            }
                            else {
                                url = url + "&filter=null";
                            }
                        }

                        if (view.config.infoparam != null) {
                            url = url + "&infoparam=" + JSON.stringify(view.config.infoparam);
                        }
                        else {
                            url = url + "&infoparam=null";
                        }

                        var tlbParams = $$("tlbParams");
                        if (tlbParams !== undefined) {
                            var childViews = tlbParams.getChildViews();
                            var parameters = [];
                            for (var i = 0; i < childViews.length; i++) {
                                var child = childViews[i];
                                var id = child.config.id;
                                var value_field = child.config.value_field;
                                var item = {
                                    columnName: value_field,
                                    value: $$(id).getValue()
                                };

                                parameters.push(item);
                            }

                            url = url + "&tlbparam=" + JSON.stringify(parameters);

                        }
                        else {
                            url = url + "&tlbparam=null";
                        }
                        webix.ajax(url, callback, view);
                    }
                },
                on: {
                    onItemDblClick: function (id, e, node) {
                        var btnEdit = $$("btnEdit");
                        btnEdit.callEvent("onClick");
                    },
                },
                columns: [
                    { id: "ten_mau", columnType: "nvarchar", header: [_("TEN_MAU"), { content: "serverFilter" }], width: 250 },
                    {
                        id: "dmloaihd_id",
                        view: "combo",
                        options: app.config.host + "/System/GetDataReferencesByRefId?refId=RF00008",
                        header: [_("LOAI_HOA_DON"), { content: "serverSelectFilter" }],
                        columnType: "uniqueidentifier",
                        tableAlias: "dmmauhoadon",
                        width: 300
                    },
                    {
                        id: "hinhthuc",
                        view: "combo",
                        options: app.config.host + "/System/GetDataReferencesByRefId?refId=RF00009",
                        header: [_("HINH_THUC"), { content: "serverSelectFilter" }],
                        columnType: "nvarchar",
                        width: 200
                    },
                    { id: "mau_so", columnType: "nvarchar", header: [_("MAU_SO"), { content: "serverFilter" }], width: 150 },
                    { id: "ky_hieu", columnType: "nvarchar", header: [_("KY_HIEU"), { content: "serverFilter" }], width: 150 },
                    { id: "so_lien", columnType: "int", header: [_("SO_LIEN"), { content: "serverFilter" }], width: 150 },
                    { id: "trang_thai_mau", columnType: "nvarchar", header: [_("TRANG_THAI_MAU"), { content: "serverFilter" }], width: 150 },
                    {
                        id: "da_ky",
                        checkValue: true,
                        uncheckValue: false,
                        template: function (obj, common, value) {
                            if (value)
                                return "<div class='webix_icon fa-check-square-o'></div>";
                            else
                                return "<div class='webix_icon fa-square-o'></div>";
                        },
                        columnType: "bit",
                        header: [_("DA_KY"), { content: "serverFilter" }],
                        width: 100
                    }
                ],
                pager: "pagerA"

            },
            {
                cols: [
                    {
                        view: "icon", icon: "fas fa-question-circle", id: "help_form_viewsfile", tooltip: _("HELPER"),
                        css: "helper",
                        click: function () {
                            webix.alert({
                                title: "Thông báo !",
                                text: "Bạn chưa khai báo hướng dẫn nhanh cho màn hình này !",
                                type: "alert-warning",
                                callback: function (result) {
                                }
                            });
                        }
                    },
                    {
                        view: "combo",
                        label: _("MENU_QUICK"),
                        id: "QuickMenu1",
                        options: {
                        },
                        on: {
                            onChange: function (newv, oldv) {

                            }
                        }
                    },
                    {},
                    {
                        id: "pagerA",
                        view: "pager",
                        size: 100,
                        group: 5,
                        template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}"
                    }
                ]
            }

        ]
    }

    var layout = {
        css: "frmView",
        rows: [
            {
                height: 35,
                css: "btnControl",
                type: "toolbar",
                margin: 0,
                borderless: true,
                cols: controls
            },
            {
                rows: [
                    grid
                ]
            }



        ]

    };

    return {
        $ui: layout,
        $oninit: function (view, $scope) {
            $scope.on(app, "dataChanged", function (mode, item) {

                var table = webix.$$("dmwindowData");

                if (mode == 1) {
                    table.add(item);
                    //table.select(item.iddmwindow,false);
                }

                if (mode == 2) {
                    var selectedItem = table.getSelectedItem();
                    table.updateItem(selectedItem.id, item);
                }

            });
        }
    };
});
define('views/menus/sidebar',["app"],function(app){
	
	return {
		$ui:{
			width: 220,

			rows:[
				{
					view: "tree",
					//id: "app:menu",
					type: "menuTree2",
					css: "menu",
					activeTitle: true,
					select: true,
					tooltip: {
						template: function(obj){
							return obj.$count?"":obj.details;
						}
					},
					on:{
						onBeforeSelect:function(id){
							if(this.getItem(id).$count){
								return false;
							}
							
						},
						onAfterSelect:function(id){
							
							var item = this.getItem(id);
							
							var start = item.window_id!=null ? item.code + ":" + item.window_id : item.code;
							this.$scope.show("./"+ start);
							
							webix.$$("title").parse({title: item.value, details: item.details});
						}
					},
					url: app.config.host + "/api/System/GetSideBar"
				}
			]
		},
		getApiHost: function(){
			return app.config.host;
		}
	};

});

define('views/minvoicenews',[
    "app",
    "locale",
    "views/forms/minvoicenews"
], function (app, _, minvoicenews) {
    'use strict';

    webix.$$("title").parse({ title: "M-Invoice tin tức", details: "Tin tức (System M-Invoice)", url_help: "http://huongdansudung.minvoice.com.vn/" });
    var controls = [
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-refresh fa-lg" aria-hidden="true"></i> ' +
            '<span class="text">' + _("REFRESH") + '</span>',
            id: "btnRefresh",
            // shortcut: "F4",
            //css:"button_raised",
            on: {
                onClick: function () {
                    var table = webix.$$("lstNews");
                    table.clearAll();
                    $$("contentNews").setHTML("");
                    table.load(table.config.url);
                    //table.refresh();
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-plus fa-lg" aria-hidden="true"></i> ' +
            '<span class="text">' + _("THEM") + " (F4)" + '</span>',
            id: "btnPlus",
            //css:"button_raised",
            shortcut: "F4",
            on: {
                onClick: function () {
                    var detailForm = this.$scope.ui(minvoicenews.$ui);
                    detailForm.show();
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-edit fa-lg" aria-hidden="true"></i> ' +
            '<span class="text">' + _("SUA") + " (F3)" + '</span>',
            id: "btnEdit",
            shortcut: "F3",
            on: {
                onClick: function () {
                    var detailForm = this.$scope.ui(minvoicenews.$ui);

                    var table = webix.$$("lstNews");
                    var item = table.getSelectedItem();
                    if (item == null) {
                        webix.message("Bạn chưa chọn dòng cần sửa !", "error");
                        return;
                    }

                    minvoicenews.setValues(item);
                    detailForm.show();
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-trash-o fa-lg" aria-hidden="true"></i> ' +
            '<span class="text">' + _("XOA") + " (F8)" + '</span>',
            id: "btnDelete",
            shortcut: "F8",
            on: {
                onClick: function () {
                    var table = webix.$$("lstNews");
                    var item = table.getSelectedItem();
                    if (item == null) {
                        webix.message("Bạn chưa chọn dòng cần xóa !", "error");
                        return;
                    }

                    webix.confirm({
                        text: "Bạn có muốn xóa " + item.title, ok: "Có", cancel: "Không",
                        callback: function (res) {
                            if (res) {
                                webix.ajax()
                                    .headers({ 'Content-type': 'application/json' })
                                    .post(app.config.host + "/System/DeleteMinvoiceNews", item, function (text) {

                                        if (text.hasOwnProperty("error")) {
                                            webix.message(text.error);
                                            return;
                                        }

                                        table.remove(item.id);
                                        $$("contentNews").setHTML("");
                                        webix.message("Xóa thành công !", "success");
                                    });
                            }
                        }
                    });
                }
            },
            click: function () {
                this.callEvent("onClick");
            }

        },
        {}

    ];
    var fm = function (date) {
        var format = webix.Date.dateToStr("%d/%m/%Y");
        date = removeTimeZoneT(date);
        return format(date);
    }
    var grid = {
        cols: [
            {
                view: "list",
                id: "lstNews",
                select: true,
                scrollX: true,
                tooltip: function (obj) {
                    return obj.title + " - " + fm(obj.date_new);
                },
                on: {
                    onItemClick: function (id, e, node) {
                        var item = this.getItem(id);
                        $$("contentNews").setHTML('<b style="font-size:15px;">' + item.title + '</b><br>' + item.description + '<br>' + '<img src="' + item.url_image + '" alt="NAMPV M-Invoice">');
                    }
                },
                url: app.config.host + "/System/GetMinvoiceNews",
                template: function (obj) {
                    if (obj.su_dung == "C")
                        return "<span style='color: #00b300'><i class='fas fa-check'></i></span> " + obj.title + " - " + fm(obj.date_new);
                    else
                        return "<span style='color: red'><i class='fas fa-times'></i></span> " + obj.title + " - " + fm(obj.date_new);
                },
                width: 450
            },
            // { view: "resizer" },
            // {width:5},
            {
                // paddingX: 5,
                // paddingY: 5,
                rows: [
                    {
                        view: "template", id: "contentNews", scroll: "xy",
                        type: { height: "auto" }
                    }
                ]
            }
        ]
    };
    var layout = {
        css: "frmView",
        rows: [
            {
                height: 39,
                css: "btnControl",
                type: "toolbar",
                margin: 0,
                borderless: true,
                cols: controls
            },
            {
                rows: [
                    grid
                ]
            }
        ]

    };

    return {
        $ui: layout,
        $oninit: function (view, $scope) {
            $scope.on(app, "reloadNews", function () {
                var table = webix.$$("lstNews");
                table.clearAll();
                $$("contentNews").setHTML("");
                table.load(table.config.url);
            });
        }
    };
});
define('views/modules/chart_IM',["app"], function (app) {

    return {
        $ui: {
            "type": "clean",
            "height": 220,
            "cols": [
                {
                    rows: [
                        {
                            "template": "<span class='webix_icon fa-clock' style='color:#FF892A;'></span><b style='color:blue'> THỜI GIAN SỬ DỤNG</b>",
                            "css": "sub_title",
                            "height": 30,
                            // "paddingX": 10,
                            // "paddingY": 10,
                            // "margin-left": 10
                        },
                        {
                            css: { "padding-right": "50px" },
                            cols: [
                                { view: "text", label: "Số lượng đăng ký", css: "mcls_license_text", labelWidth: 120, value: "1000" },
                                { view: "text", label: "Ngày hết hạn", css: "mcls_license_text", labelWidth: 120, value: "01/01/2050" },
                                { width: 20 }
                            ]
                        },
                        {
                            cols: [
                                {},
                                { view: "button", label: "Gia hạn", width: 120, type: "form" },
                                { width: 20 }
                            ]
                        }
                    ]
                }

            ]
        }
    };

});
define('views/modules/dashline_IM',["app"], function (app) {

    return {
        $ui: {
            height: 136,
            css: "tiles",
            template: function (data) {
                var t = null;
                if (data.items == undefined) return;
                var items = data.items;
                var html = "<div class='flex_tmp'>";
                for (var i = 0; i < items.length; i++) {
                    t = items[i];

                    var tien = webix.Number.format(t.tien, {
                        groupDelimiter: ",",
                        groupSize: 3,
                        decimalDelimiter: ".",
                        decimalSize: 0
                    });

                    var code = "duyethoadon";
                    var params = "0" + t.id;

                    if (t.id == "03") {
                        code = "bangkebanra";
                    }
                    var fmtien = t.id == "4" ? tien + " MB" : tien;
                    html += "<div class='item " + t.css + "'>";
                    html += "<div class='webix_icon icon fa-" + t.icon + "'></div>";
                    html += "<div class='details'><div class='value'>" + fmtien + "</div><div class='text'>" + t.dien_giai + "</div></div>";
                    html += "</div>";
                }
                html += "</div>";
                return html;
            },
            url: app.config.host + "/Invoice/DashboardTiles_IM"
        }
    };

});
define('views/modules/data_invoiceIM',["app", "locale"], function (app, _) {

    return {
        $ui: {
            "css": "table_dash_invoice",
            // "type": "clean",
            "rows": [
                {
                    "template": "<span class='webix_icon fa-star' style='color:#FF892A'></span><b style='color:blue'> Danh sách hóa đơn tải lên gần nhất</b>", "css": "sub_title", "height": 30
                },
                {
                    "view": "datatable",
                    "css": "mcls_invoiceDashboard",
                    "url": app.config.host + "/ManageInvoice/DashboardInvoices",
                    "footer": "true",
                    "resize": "true",
                    "height": "240",
                    "columns": [
                        {
                            id: "ten_trang_thai",
                            header: "Trạng thái",
                            css: { "text-align": "center" },
                            fillspace: 1
                        },
                        {
                            id: "invoiceNumber",
                            header: "Số hóa đơn",
                            css: { "text-align": "center" },
                            fillspace: 1
                        },
                        {
                            id: "sellerName",
                            header: "Tên người bán",
                            css: { "text-align": "center" },
                            fillspace: 1
                        },
                        {
                            id: "tien_tt",
                            header: "Tiền trước thuế",
                            // width: 120,
                            fillspace: 1,
                            css: { "text-align": "center !important", "color": "red", "font-weight": "bold" },
                            format: webix.Number.numToStr({
                                groupDelimiter: ",",
                                groupSize: 3,
                                decimalDelimiter: ".",
                                decimalSize: 0
                            }),
                            footer: { content: "summColumn" }
                        },
                        {
                            id: "tien_thue",
                            header: "Tổng tiền thuế",
                            // width: 120,
                            fillspace: 1,
                            css: { "text-align": "center", "font-weight": "bold", "color": "green" },
                            format: webix.Number.numToStr({
                                groupDelimiter: ",",
                                groupSize: 3,
                                decimalDelimiter: ".",
                                decimalSize: 0
                            }),
                            footer: { content: "summColumn" }
                        },
                        {
                            id: "tong_tien",
                            header: "Tiền sau thuế",
                            // width: 130,
                            fillspace: 1,
                            css: { "text-align": "center", "font-weight": "bold" },
                            format: webix.Number.numToStr({
                                groupDelimiter: ",",
                                groupSize: 3,
                                decimalDelimiter: ".",
                                decimalSize: 0
                            }),
                            footer: { content: "summColumn" }
                        }
                    ]
                }
            ]
        }
    };
});
define('views/payment_request_bienlai',[
    "app",
    "locale",
    "views/modules/Component/buttonAnimation",
    "views/modules/Component/grid",
    "views/modules/Component/eventTableHelper",
    "views/modules/Component/constantManager",
    "views/forms/payment_request_bienlai",
], function (app, _, buttonOption, gridInvoice, eventTableHelper, CONSTANTS, paymentRequestForm) {
    'use strict';
    var datatableId = "invoiceViews";
    var btnRefresh = buttonOption.btnRefresh(datatableId);
    var btnAdd = buttonOption.btnAdd(paymentRequestForm, 2, true);
    var btnEdit = buttonOption.btnEdit(paymentRequestForm, 2, true);
    var btnDelete = buttonOption.btnDelete(true);
    var btnCopy = buttonOption.btnCopy(paymentRequestForm, 2);
    var btnPrint = buttonOption.btnPrint();
    var btnPayment = buttonOption.btnPayment();
    var btnRemovePayment = buttonOption.btnRemovePayment();
    var btnExportExcel = buttonOption.btnExportExcel(2); 
    var colsMaster = [
        { id: "subRowMain", header: "&nbsp;", template: "{common.subrow()}", width: 40 },
        { id: "stt", header: ["STT", { content: "textFilter" }], sort: "int", width: 40, hidden: true },
        {
            id: "tthai", header: [_("TRANG_THAI"), { content: "multiSelectFilter", options: CONSTANTS.STATUS_PAYMENT_REQUEST }],
            template: function (obj) {
                return "<span class='mcls_status#tthai#'>" + (CONSTANTS.STATUS_PAYMENT_REQUEST_MAP[obj.tthai] || obj.tthai) + "</span>";
            },
            width: 120, columnType: "nvarchar", editor: "text", sort: "string"
        },
        { id: "tdlap", header: [_("NGAY_LAP"), { content: "serverDateRangeFilter" }], width: 120, columnType: "datetime", format: function (text) { return formatDate(text); } },
        { id: "mhso", header: [_("Mã hồ sơ"), { content: "textFilter" }], width: 100, columnType: "nvarchar" },
        { id: "so", header: [_("Số phiếu thu"), { content: "customFilter" }], width: 100, columnType: "nvarchar", editor: "text", sort: "int" },
        { id: "mst", header: [_("MST"), { content: "textFilter" }], width: 100, columnType: "nvarchar" },
        { id: "nguoimuahang", header: [_("DV_NMUA"), { content: "textFilter" }], width: 240, columnType: "nvarchar", template: function (obj) { 
            if(obj.nguoimuahang)
              return '<span>' + obj.nguoimuahang + '</span>';
            else
              return "<span>" + obj.tnmua + "</span>";
          } 
        },
        {
            id: "tgtttbso", header: [_("THANH_TIEN"), { content: "customFilter" }], width: 120,
            css: { "text-align": "right", "padding": "0px" }, editor: "text", sort: "int",
            columnType: "decimal",
            format: webix.Number.numToStr({
                groupDelimiter: ",",
                groupSize: 3,
                decimalDelimiter: ".",
                decimalSize: 0
            }),
            footer: {
                content: "summColumn", height: "22", template: function (obj) {
                    return formatDecimal(obj.value);
                }
            }
        },
        { id: "htttoan", header: [_("HT_TTOAN"), { content: "textFilter" }], width: 120, columnType: "nvarchar" },
        { id: "user_new", header: [_("USER_NEW"), { content: "textFilter" }], width: 150, columnType: "nvarchar" },
    ];
    var colsDetail = [
        { id: "stt", header: "", width: 30 },
        { id: "ma", header: _("Mã hàng hóa"), editor: "text", width: 100, editable: true },
        { id: "ten", header: _("Tên hàng hóa"), editor: "text", width: 350, editable: true },
        { id: "mdvtinh", header: _("ĐVT"), editor: "text", width: 80, editable: true },
        {
            id: "tgtien",
            header: _("Tiền sau thuế"), width: 150, editor: "autonumeric", editable: true,
            css: { "text-align": "right" },
            format: webix.Number.numToStr({
                groupDelimiter: ",",
                groupSize: 3,
                decimalDelimiter: ".",
                decimalSize: 2
            })
        },
    ];
    var props = {
        datatableId: datatableId,
        commandId: "CM0036",
        datatableDetailHeader: "Chi tiết phiếu thu",
        colsMaster: colsMaster,
        colsDetail: colsDetail,
        apiGetDetails: CONSTANTS.API.PAYMENT_REQUEST.GET_DETAIL.replace(app.config.host, ""),
        loai: 2
    };
    var grid = gridInvoice.gridComponent(props);

    var controls = [
        btnRefresh,
        btnAdd,
        btnEdit,
        btnDelete,
        btnCopy,
        btnPrint,
        btnPayment,
        btnRemovePayment,
        btnExportExcel,
    ];

    var layout = {
        css: "frmView",
        id: "frmView",
        rows: [
            { height: 39, id: "btnControl", css: "btnControl", margin: 0, borderless: true, type: "toolbar", cols: controls },
            { rows: [grid] }
        ]

    };

    return {
        $ui: layout,
        $oninit: function (view, $scope) {
            eventTableHelper.OnInit(1);
            $scope.on(app, "DataRefresh", function (editmode, item) {
                var table = webix.$$(datatableId);
                table.clearAll();
                table.load(table.config.url);
            });
        },
        $onurlchange: function (ui, name, url, scope) {
        }
    };
});
define('views/payment_request',[
    "app",
    "locale",
    "views/modules/Component/buttonAnimation",
    "views/modules/Component/grid",
    "views/modules/Component/eventTableHelper",
    "views/modules/Component/constantManager",
    "views/forms/payment_request",
    'views/forms/forms68/HDon/68_invoiceForms_code_01'
], function (app, _, buttonOption, gridInvoice, eventTableHelper, CONSTANTS, paymentRequestForm, createInvoiceForm) {
    'use strict';

    var datatableId = "invoiceViews";
    var btnRefresh = buttonOption.btnRefresh(datatableId);
    var btnAdd = buttonOption.btnAdd(paymentRequestForm, 1);
    var btnEdit = buttonOption.btnEdit(paymentRequestForm, 1);
    var btnDelete = buttonOption.btnDelete();
    var btnCopy = buttonOption.btnCopy(paymentRequestForm, 1);
    var btnCreateInvoice = buttonOption.btnCreateInvoice(createInvoiceForm, 1);
    var btnPrint = buttonOption.btnPrint();
    var btnPayment = buttonOption.btnPayment();
    var btnRemovePayment = buttonOption.btnRemovePayment();
    var btnExportExcel = buttonOption.btnExportExcel(1);
    var colsMaster = [
        { id: "subRowMain", header: "&nbsp;", template: "{common.subrow()}", width: 40 },
        { id: "stt", header: ["STT", { content: "textFilter" }], sort: "int", widthp: 40, hidden: true },
        {
            id: "tthai", header: [_("TRANG_THAI"), { content: "multiSelectFilter", options: CONSTANTS.STATUS_PAYMENT_REQUEST }],
            template: function (obj) {
                return "<span class='mcls_status#tthai#'>" + (CONSTANTS.STATUS_PAYMENT_REQUEST_MAP[obj.tthai] || obj.tthai) + "</span>";
            },
            width: 120, columnType: "nvarchar", editor: "text", sort: "string"
        },
        { id: "tdlap", header: [_("NGAY_LAP"), { content: "serverDateRangeFilter" }], width: 120, columnType: "datetime", format: function (text) { return formatDate(text); } },
        { id: "mhso", header: [_("Mã hồ sơ"), { content: "textFilter" }], width: 100, columnType: "nvarchar" },
        { id: "so", header: [_("Số phiếu thu"), { content: "customFilter" }], width: 100, columnType: "nvarchar", editor: "text", sort: "int" },
        { id: "mst", header: [_("MST"), { content: "textFilter" }], width: 100, columnType: "nvarchar" },
        { id: "nguoimuahang", header: [_("DV_NMUA"), { content: "textFilter" }], width: 240, columnType: "nvarchar", template: function (obj) { 
            if(obj.nguoimuahang)
              return '<span>' + obj.nguoimuahang + '</span>';
            else
              return "<span>" + obj.tnmua + "</span>";
          }
        },
        {
            id: "tgtcthue", header: [_("TIEN"), { content: "customFilter" }], width: 120,
            css: { "text-align": "right" }, columnType: "decimal", editor: "text", sort: "int",
            format: webix.Number.numToStr({
                groupDelimiter: ",",
                groupSize: 3,
                decimalDelimiter: ".",
                decimalSize: 0
            }),
            footer: {
                content: "summColumn", height: "22", template: function (obj) {
                    return formatDecimal(obj.value);
                }
            }
        },
        {
            id: "tgtthue", header: [_("TIEN_THUE"), { content: "customFilter" }], width: 120,
            css: { "text-align": "right" }, columnType: "decimal", editor: "text", sort: "int",
            format: webix.Number.numToStr({
                groupDelimiter: ",",
                groupSize: 3,
                decimalDelimiter: ".",
                decimalSize: 0
            }),
            footer: {
                content: "summColumn", height: "22", template: function (obj) {
                    return formatDecimal(obj.value);
                }
            }
        },
        {
            id: "tgtttbso", header: [_("THANH_TIEN"), { content: "customFilter" }], width: 120,
            css: { "text-align": "right", "padding": "0px" }, editor: "text", sort: "int",
            format: webix.Number.numToStr({
                groupDelimiter: ",",
                groupSize: 3,
                decimalDelimiter: ".",
                decimalSize: 0
            }),
            columnType: "decimal",
            footer: {
                content: "summColumn", height: "22", template: function (obj) {
                    return formatDecimal(obj.value);
                }
            }
        },
        { id: "htttoan", header: [_("HT_TTOAN"), { content: "textFilter" }], width: 120, columnType: "nvarchar" },
        {
            id: "nlap", header: [_("NGAY_TAO_MOI"), { content: "serverDateRangeFilter" }], width: 120, columnType: "datetime", hidden: true,
            format: function (text) { return formatDate(text); }
        },
        { id: "user_new", header: [_("USER_NEW"), { content: "textFilter" }], width: 150, columnType: "nvarchar" },
        { id: "khieu", header: [_("Ký hiệu"), { content: "textFilter" }], width: 100, columnType: "nvarchar" },
        { id: "shdon", header: [_("Số hóa đơn"), { content: "customFilter" }], width: 100, columnType: "nvarchar", editor: "text", sort: "int" },
    ];
    var colsDetail = [
        { id: "stt", header: "", width: 30 },
        { id: "ma", header: _("Mã hàng hóa"), editor: "text", width: 100, editable: true },
        { id: "ten", header: _("Tên hàng hóa"), editor: "text", width: 350, editable: true },
        { id: "mdvtinh", header: _("ĐVT"), editor: "text", width: 80, editable: true },
        {
            id: "sluong",
            header: _("Số lương"), editor: "autonumeric", width: 100,
            editable: true, css: { "text-align": "right" },
            format: webix.Number.numToStr({
                groupDelimiter: ",",
                groupSize: 3,
                decimalDelimiter: ".",
                decimalSize: 2
            })
        },
        {
            id: "dgia",
            header: _("Đơn giá"), width: 150, editor: "autonumeric", editable: true,
            css: { "text-align": "right" },
            format: webix.Number.numToStr({
                groupDelimiter: ",",
                groupSize: 3,
                decimalDelimiter: ".",
                decimalSize: 2
            })
        },
        {
            id: "thtien",
            header: _("Tiền trước thuế"),
            width: 150, editor: "autonumeric", editable: true, css: { "text-align": "right" },
            format: webix.Number.numToStr({
                groupDelimiter: ",",
                groupSize: 3,
                decimalDelimiter: ".",
                decimalSize: 2
            })
        },
        {
            id: "tlckhau",
            header: _("% CK"), width: 80, editor: "autonumeric", editable: true,
            css: { "text-align": "right" },
            format: webix.Number.numToStr({
                groupDelimiter: ",",
                groupSize: 3,
                decimalDelimiter: ".",
                decimalSize: 2
            })
        },
        {
            id: "stckhau", header: _("Tiền CK"),
            width: 150, editor: "autonumeric", editable: true,
            css: { "text-align": "right" },
            format: webix.Number.numToStr({
                groupDelimiter: ",",
                groupSize: 3,
                decimalDelimiter: ".",
                decimalSize: 2
            })
        },
        {
            id: "tsuat",
            header: _("Thuế suất"), width: 100, editor: "autonumeric", editable: true,
            css: { "text-align": "right" },
            format: webix.Number.numToStr({
                groupDelimiter: ",",
                groupSize: 3,
                decimalDelimiter: ".",
                decimalSize: 2
            })
        },
        {
            id: "tthue",
            header: _("Tiền thuế"),
            width: 150, editor: "autonumeric", editable: true, css: { "text-align": "right" },
            format: webix.Number.numToStr({
                groupDelimiter: ",",
                groupSize: 3,
                decimalDelimiter: ".",
                decimalSize: 2
            })
        },
        {
            id: "tgtien",
            header: _("Tiền sau thuế"), width: 150, editor: "autonumeric", editable: true,
            css: { "text-align": "right" },
            format: webix.Number.numToStr({
                groupDelimiter: ",",
                groupSize: 3,
                decimalDelimiter: ".",
                decimalSize: 2
            })
        },
        {
            id: "khuyen_mai", header: _("Khuyến mại"), width: 100, editor: "checkbox", editable: true,
            template: "{common.checkbox()}",
            checkValue: true,
            uncheckValue: false
        }
    ];
    var props = {
        datatableId: datatableId,
        commandId: "CM0036",
        datatableDetailHeader: "Chi tiết phiếu thu",
        colsMaster: colsMaster,
        colsDetail: colsDetail,
        apiGetDetails: CONSTANTS.API.PAYMENT_REQUEST.GET_DETAIL.replace(app.config.host, ""),
        loai: 1
    };
  
    var grid = gridInvoice.gridComponent(props);

    var controls = [
        btnRefresh,
        btnAdd,
        btnEdit,
        btnDelete,
        btnCopy,
        btnCreateInvoice,
        btnPrint,
        btnPayment,
        btnRemovePayment,
        btnExportExcel
    ];

    var layout = {
        css: "frmView",
        id: "frmView",
        rows: [
            { height: 39, id: "btnControl", css: "btnControl", margin: 0, borderless: true, type: "toolbar", cols: controls },
            { rows: [grid] }
        ]

    };

    return {
        $ui: layout,
        $oninit: function (view, $scope) {
          eventTableHelper.OnInit(1);
            $scope.on(app, "DataRefresh", function (editmode, item) {
                var table = webix.$$(datatableId);
                table.clearAll();
                table.load(table.config.url);
            });
        },
        $onurlchange: function (ui, name, url, scope) {
        }
    };
});
define('views/ptp/68_sendEmailForm',["app", "locale", "views/forms/forms68/68_viewsLogEmail"], function (app, _, viewLogEmail) {
	var editmode = 0;

	return {
		$ui: {
			view: "window", modal: true, id: "dmtab-win", position: "center", move: true,
			head: {
				height: 40,
				cols: [
					{
						id: "head-iconInvoice", view: "template", css: "headform", width: 35,
						template: "<span><i class='fa fa-paper-plane' aria-hidden='true'></i></span>"
					},
					{ id: "head-form", view: "template", css: "headform", template: function (obj) { return '<div>Gửi hóa đơn cho khách hàng qua email<div/>'; } },
					{ view: "icon", icon: "fas fa-question-circle", id: "help_form", tooltip: _("HELPER"), click: function () { } }
				]
			},
			fullscreen: true,
			css: "headformchil",
			keepViews: true,
			move: true,
			on: {
				onBeforeShow: function () {

				}
			},
			body: {
				paddingY: 5,
				paddingX: 5,
				view: "form",
				id: "dmtab-form",
				on: {
				},
				elements: [
					{
						view: "fieldset",
						label: "Thông tin gửi mail",
						body: {
							rows: [
								{
									view: 'checkbox',
									id: "otpMail",
									label: "Sử dụng email của PTP-Invoice để gửi đi", labelPosition: "left",
									labelWidth: 230, tooltip: "Tích vào đây nếu bạn muốn email gửi đi sử dụng email của M-Invoice ! Gửi email bằng mail hệ thống của M-Invoice sẽ theo dõi được email gửi thành công hay không, người nhận đã xem email bạn gửi hay chưa.",
									on: {
										onChange: function (newv, oldv) {
											if (newv == 1) {
												$$("fromName").define("readonly", true);
												$$("fromName").define("css", "mcls_readonly_text");
												$$("fromName").setValue("***");
												$$("fromName").refresh();

												$$("passMail").define("readonly", true);
												$$("passMail").define("css", "mcls_readonly_text");
												$$("passMail").setValue("***");
												$$("passMail").refresh();
											}
											if (newv == 0) {
												var table = webix.$$("invoiceViews");
												var selectedItem = table.getSelectedItem();
												var dataPost = {
													id: selectedItem.hoadon68_id,
													type: "Gửi hóa đơn"
												};
												webix.ajax()
													.headers({ 'Content-type': 'application/json' })
													.post(app.config.host + "/Invoice68/GetEmailTemplate", dataPost, function (text) {
														var data = JSON.parse(text);
														var json = data.data;
														$$("fromName").setValue(json.nguoi_gui);
														$$("fromName").define("readonly", false);
														webix.html.removeCss($$("fromName").$view, "mcls_readonly_text");
														$$("fromName").refresh();

														$$("passMail").setValue(json.pass);
														$$("passMail").define("readonly", false);
														webix.html.removeCss($$("passMail").$view, "mcls_readonly_text");
														$$("passMail").refresh();
													});
											}
										}
									}
								},
								{
									cols: [
										{
											view: "text",
											id: "fromName",
											name: "nguoi_gui",
											label: _("NGUOI_GUI"),
											labelPosition: "top",
											required: true,
											validate: webix.rules.isNotEmpty,
											invalidMessage: "Người gửi không được để trống !"
										}, {
											view: "text",
											id: "passMail",
											name: "mat_khau",
											label: _("PASSWORD"),
											type: "password",
											labelPosition: "top",
											required: true,
											validate: webix.rules.isNotEmpty,
											invalidMessage: "Mật khẩu không được để trống !"
										}
									]
								},
								{
									cols: [
										{
											view: "text",
											name: "nguoinhan",
											id: "nguoinhan",
											label: _("NGUOI_NHAN"),
											keyPressTimeout: 100,
											labelPosition: "top",
											placeholder: "Nhập email người nhận, nhiều hơn 1 email thì cách nhau bằng dấu phẩy (,)",
											required: true,
											validate: webix.rules.isNotEmpty,
											invalidMessage: "Người nhận không được để trống !",
											on: {
												onTimedKeyPress: function () {
													var countMail = $$("nguoinhan").getValue().split(/[\s,\;]+/);
													if (countMail.length > 5) {
														webix.message("Bạn không được phép gửi quá 5 Email."
															+ " Vui lòng liên hệ nhà cung cấp để được giải đáp.", "debug");
														return;
													}

												}
											}
										},
										{ view: "text", name: "bcc", label: "BCC", labelPosition: "top" }
									]
								},
								{ view: "text", name: "tieude", label: _("TIEU_DE"), labelPosition: "top", }
							]
						}
					},
					{
						view: "label",
						name: "his_email",
						id: "his_email",
						template: function (obj) {
							if (obj.value == 0) return "<span style='color:blue'>Hóa đơn chưa gửi cho khách hàng !</span>";
							return "<span style='color:blue'>Hóa đơn đã được gửi <big>" + obj.value + "</big> lần !<sub style='color:red'> Lịch sử gửi email <i class='fa fa-hand-o-left' aria-hidden='true'></i></sub></span>"
						},
						on: {
							onItemClick: function () {
								var table = webix.$$("invoiceViews").getSelectedItem();
								var detailForm = $$("dmtab-win").$scope.ui(viewLogEmail.$ui);
								viewLogEmail.initUI(table.hoadon68_id);
								detailForm.show();

							}
						}
					},
					{ name: "noidung", view: "ckeditor", keepViews: true, label: _("NOI_DUNG"), labelPosition: "top" },
					{
						margin: 10,
						cols: [
							{},
							{
								shortcut: "F10", view: "button", label: "Nhận (F10)", type: "form", align: "center", width: 120,
								on: {
									onClick: function () {
										var form = webix.$$("dmtab-form");
										var item = form.getValues();
										item.otpmail = $$("otpMail").getValue();
										var url = app.config.host + "/Invoice68/Email";
										var countMail = $$("nguoinhan").getValue().split(/[\s,\;]+/);
										if (countMail.length > 5) {
											webix.message("Bạn không được phép gửi quá 5 Email. Vui lòng liên hệ nhà cung cấp để được giải đáp.", "debug");
											return;
										}
										else {
											if ($$("dmtab-form").validate()) {
												webix.extend(form, webix.ProgressBar);
												form.disable();
												form.showProgress();
												webix.ajax()
													.headers({ 'Content-type': 'application/json' })
													.post(url, item, function (text) {
														var form = webix.$$("dmtab-form");
														form.enable();
														form.hideProgress();
														var data = JSON.parse(text);
														if (data.code == "00") {
															webix.message("Gửi Email thành công !", "debug");
															webix.$$("dmtab-win").close();
														}
														else {
															webix.message(data.message, "error");
														}
													});
											}
											else {
												$$("nguoinhan").focus();
											}
										}
									}
								},
								click: function () {
									this.callEvent("onClick");

								}
							},
							{
								view: "button", hotkey: "esc", label: "Hủy bỏ (ESC)", type: "danger", align: "center", width: 120,
								click: function () {
									webix.$$("dmtab-win").close();
								}
							},
							{}
						]
					}
				]

			}

		},
		setEditMode: function (mode) {
			editmode = mode;
		},
		setValues: function (values) {
			$$("dmtab-form").setValues(values);
		}
	};

});
define('views/ptp/app',[
	"views/modules/minvoiceplugin",
	"views/menus/search",
	"views/menus/profile",
	//"views/menus/sidebar",
	"views/menus/menubar",
	"models/user",
	"views/menus/version",
	"views/menus/notification",
	"app",
	"views/webix/icon",
	"views/webix/menutree"
], function (plugin, search, profile, menuBar, user, version, notification, app) {

	// var url = window.location.href;
	// window.location.replace(url);

	var apiHost = menuBar.getApiHost();

	webix.attachEvent("onBeforeAjax",
		function (mode, url, data, request, headers, files, promise) {
			// console.log(url);
			var token = user.getAccessToken();
			var dvcs = user.getDvcsID();
			var language = user.getLanguage();
			var bear = token + ";" + dvcs + ";" + language;
			headers["Authorization"] = "Bear " + bear;
		}
	);

	webix.attachEvent("onLoadError", function (text, xml, ajax, owner) {
		// console.log(text);
		// console.log(xml);
		// console.log(ajax);
		// console.log(owner);

		if (text != undefined) {
			//console.log(text);
			var json = JSON.parse(text);

			if (json.Message == "Authorization has been denied for this request.") {
				webix.message(json.Message, "error", 5000);
				user.logout();
				document.location.reload();
			}
		}
	});

	webix.ui({
		view: "window", move: true,
		// position: "center",
		position: function (state) {
			state.width = state.maxWidth * 0.4;
			state.height = state.maxHeight * 0.6;
			state.left = (state.maxWidth - state.width) / 2;
			state.top = (state.maxHeight - state.height) / 2;
		},
		modal: true,
		// head: false,
		head: "Danh sách ký hiệu sử dụng",
		id: "dangkyBanner",
		body: {
			paddingY: 0,
			paddingX: 0,
			view: "form",
			id: "dangkyForm",
			complexData: true,
			keepViews: true,
			multiview: { keepViews: true },
			margin: 0,
			elements: [
				{
					type: "space",
					borderless: false,
					rows: [
						{
							view: "datatable",
							resizeColumn: true,
							id: "lstKyhieu",
							editable: false,
							select: "row",
							// height: 260,
							drag: true,
							url: app.config.host + "/Serial/GetAllSeri",
							on: {
								"data->onStoreUpdated": function () {
									this.data.each(function (obj, i) {
										obj.stt = i + 1;
									})
								}
							},
							columns: [
								{ id: "stt", header: "", width: 30, editable: true, editor: "text" },
								{
									id: "hthuc", header: "Hình thức", editor: "text", editable: true, width: 130,
									template: function (obj) {
										if (obj.hthuc == "C")
											return "<span style='color: blue;'>Có mã CQT</span>";
										else
											return "<span style='color: #FF0000;'>Không mã CQT</span>";
									}
								},
								{
									id: "lhdon", header: "Loại HĐ", editor: "text", editable: true
								},
								{
									id: "khhdon", header: "Ký hiệu", editor: "text", editable: true
								},
								{
									id: "tmau", header: "Mẫu hóa đơn", editor: "text", editable: true, fillspace: true
								}
							]
						},
						{
							view: "label",
							label: "Để chuyển các ký hiệu qua năm 2022 tự động, Quý khách hàng vui lòng nhấn Đồng ý."
						},
						{
							shortcut: "F10", view: "button", id: "btnChuyendoi", label: "Đồng ý", type: "form", align: "center", width: 120,
							on: {
								onClick: function () {

									webix.confirm({
										title: "CẬP NHẬT KÝ HIỆU",
										text: "Bạn có muốn tự động cập nhật ký hiệu lên năm 2022", ok: "Có", cancel: "Không",
										callback: function (res) {
											if (res) {

												var url = app.config.host + "/Serial/UpdateSeriNewYear";
												var table = $$("lstKyhieu");
												webix.extend(table, webix.ProgressBar);
												table.disable();
												table.showProgress();
												webix.ajax()
													.headers({ 'Content-type': 'application/json' })
													.get(url, function (text) {
														var res = JSON.parse(text);
														table.enable();
														table.hideProgress();
														if (res.code == "00") {
															$$("dangkyBanner").close();
															webix.message("Chuyển ký hiệu thành công", "success");
														}
														else {
															webix.message(res.message, "error");
														}
													});
											}
										}
									});

								}
							},
							click: function () {
								this.callEvent("onClick");
							}
						}
					]
				}

			]
		},
		on: {
			onShow: function () {
				var self = this;
				$(".webix_modal").one("click", function () {
					self.hide();
				});
			}
		}
	});

	webix.ui({
		view: "window", move: true,
		// position: "center",
		position: function (state) {
			state.width = state.maxWidth * 0.4;
			state.height = state.maxHeight * 0.6;
			state.left = (state.maxWidth - state.width) / 2;
			state.top = (state.maxHeight - state.height) / 2;
		},
		modal: true,
		head: false,
		id: "noticeBanner",
		body: {
			paddingY: 0,
			paddingX: 0,
			view: "form",
			id: "noticeForm",
			complexData: true,
			keepViews: true,
			multiview: { keepViews: true },
			margin: 0,
			elements: [
				{
					view: "text",
					id: "inv_news_id",
					name: "inv_news_id",
					hidden: true
				},
				{
					id: "bodyBanner",
					view: "template",
					// template: function (obj) {
					// 	return '<a style ="float:right;text-decoration: none;color:blue;" href="' + obj.url + '" target="_blank"><img src="https://minvoice.vn/wp-content/uploads/2020/07/QLT38-263x300.png" alt="NAM PV">'
					// 		+ '</br>Mở rộng quyền của người nộp thuế, Quy định về quản lý thuế đối với giao dịch điện tử, Tăng cường quản lý hoạt động chuyển giá, Kéo dài thời hạn nộp hồ sơ quyết toán thuế TNCN, Thêm chức năng cung cấp dịch vụ cho đại lý thuế là 5 điểm mới trong Luật Quản lý thuế 38/2019/QH14 được Quốc hội thông qua ngày 13/6/2019 có hiệu lực từ ngày 01/07/2020 có một số nội dung thay đổi quan trọng. Dưới đây là 5 nội dung đáng chú ý nhất.'
					// }
				},
				{
					view: "checkbox",
					id: "ck_banner",
					// label: "Không hiện nữa",
					labelRight: "Không hiện thông báo này trong lần tiếp theo",
					labelWidth: 0
				}
			]
		},
		on: {
			onShow: function () {
				var self = this;
				$(".webix_modal").one("click", function () {
					var val = $$("ck_banner").getValue();
					if (val == 1) {
						var item = $$("noticeForm").getValues();
						var frm = $$("invoiceBody");
						webix.extend(frm, webix.ProgressBar);
						frm.disable();
						frm.showProgress();
						webix.ajax()
							.headers({ 'Content-type': 'application/json' })
							.post(app.config.host + "/System/SaveReadNotice", item, {
								error: function (text, data, XmlHttpRequest) {
									frm.enable();
									frm.hideProgress();
									alert(text);
								},
								success: function (text, data, XmlHttpRequest) {
									frm.enable();
									frm.hideProgress();
									var js = JSON.parse(text);
									if (js.hasOwnProperty("error")) {
										webix.message(js.error, "error");
									}
								}
							});
					}

					self.hide();
				});
			}
		}
	});

	webix.ui({
		view: "popup",
		css: "profilePopup",
		id: "messagePopup",
		on: {
			onShow: function () {
				//$$("mess").setValue(0);
				// $$("mess").define({ value: 0 });
				// $$("mess").refresh();
			}
		},
		body: {
			rows: [
				// {
				// 	view: "template", template: "<span>ÂFAFAF</span>"
				// },
				{
					id: "notice",
					view: "list",
					css: "profile",
					select: true,
					url: {
						$proxy: true,
						load: function (view, callback, params) {
							var url = apiHost + "/System/GetListNotification";

							webix.ajax().bind(view)
								.headers({ 'Content-type': 'application/json' })
								.get(url, callback);
						}
					},
					template: function (obj) {
						if (obj.read == false)
							return "<b> " + obj.version + "<sup style='color:blue;' > New</sup> </b></br>" + obj.inv_describe;
						else
							return "<b> " + obj.version + "<sup style='color:#e3aa24;' > <i class='fa fa-star' aria-hidden='true'></i></sup> </b></br>" + obj.inv_describe;
					},

					type: {
						height: "auto"
					},
					on: {
						onItemClick: function (id, e, trg) {
							var win = $$("app:menu").$scope.ui(notification.$ui);
							// var item = this.getSelectedItem();
							var item = this.getItem(id);
							notification.initUI(item);
							var frm = $$("invoiceBody");
							webix.extend(frm, webix.ProgressBar);
							frm.disable();
							frm.showProgress();
							webix.ajax()
								.headers({ 'Content-type': 'application/json' })
								.post(app.config.host + "/System/SaveReadNotice", item, {
									error: function (text, data, XmlHttpRequest) {
										frm.enable();
										frm.hideProgress();
										alert(text);
									},
									success: function (text, data, XmlHttpRequest) {
										frm.enable();
										frm.hideProgress();
										var js = JSON.parse(text);
										if (js.hasOwnProperty("error")) {
											webix.message(js.error, "error");
										}
										win.show();
										$$("messagePopup").hide();

									}
								});

							// if (id == "1") {
							// 	// app.router("/updateToWeb");
							// 	webix.message("aksjflka", "debug");
							// }
						}
					}
				}
			]
		}
	});

	//Top toolbar
	var mainToolbar = {
		cols: [
			// {
			// 	view: "label",
			// 	css: { "background-color": "#F2F7FC", "padding-left": "12px", "padding-top": "10px", "max-width": "100%", "height": "auto" },
			// 	borderless: true,
			// 	label: "<a href='https://www.facebook.com/hoadondientu.m.invoice' data-toggle='tooltip' title='Page Hóa đơn điện tử M-Invoice !' target='_blank'><i class='fab fa-facebook-square fa-2x' style='color:#4267B2'></i></a>",
			// 	width: 35
			// },
			// {
			// 	view: "label",
			// 	css: { "background-color": "#F2F7FC", "padding-left": "12px", "padding-top": "10px", "max-width": "100%", "height": "auto" },
			// 	borderless: true,
			// 	label: "<a href='https://www.youtube.com/c/HoaDonDienTuMinvoice' data-toggle='tooltip' title='Video hướng dẫn sử dụng của M-Invoice !' target='_blank'><i class='fab fa-youtube fa-2x' style='color:#FF0000'></i></a>",
			// 	width: 40
			// },
			{
				view: "label",
				css: { "background-color": "#F2F7FC", "padding-left": "12px", "padding-top": "2px", "width": "100%", "height": "auto" },
				borderless: true,
				label: "<a href='https://plugin.minvoice.com.vn/MinvoicePlugin/setup.exe' data-toggle='tooltip' title='Tải Plugin ký hóa đơn !' target='_blank'><img class='logo_app'  src='assets/imgs/plugin.png' width='22' height='22' /></a>",
				width: 40
			},
			{
				// view:"button",
				view: "icon",
				css: "notice",
				id: "mess", icon: "far fa-bell fa-2x",
				// value: 2,
				// badge: 5,
				width: 45, popup: "messagePopup"
			},
			{ width: 6, css: { "background": "#F2F7FC" } }
		]
	};

	var body = {
		id: "bodyInvoice",
		rows: [
			// { view: "label", id: "hr", hidden: false, height: 1, css: { "background-color": "#F2F7FC" } },
			// {
			// 	height: 22,
			// 	id: "title",
			// 	css: "title",
			// 	borderless: true,
			// 	//css: { "box-shadow": "0 -2px #3498db inset !important" , "background":"#ffffff !important"},
			// 	template: "<div class='header'>#title#</div><div class ='trogiup' style='float:right; font-size: 11px; line-height: normal;'><a href = '#url_help#' target='_blank' style = 'text-decoration: none;color:#0069b4;'>Trợ giúp <i class='fas fa-question-circle'></i></a></div>",
			// 	data: { text: "", title: "Trang chủ", details: "Phân tích và thống kê" }
			// },
			{
				view: "scrollview",
				scroll: "x",
				borderless: true,
				// paddingY: 8,
				body: {
					paddingX: 8,
					css: "bodycolor",
					rows: [
						{
							// cols: [
							// 	{
							$subview: true
							// 	}
							// ]
						},
						{ height: 8 }
						// { paddingX: 8,
						// 	cols: [
						// 		{
						// 			view: "label", css: { "border-top": "1px solid rgba(0,0,0,0.2) !important", "border-radius": "0px 0px 10px 10px" }, height:12
						// 		}
						// 	] }
					]
				}

			}
		]
	};

	var layout = {
		id: "invoiceBody",
		rows: [
			{
				// height:80,
				css: "topheader",
				// scroll: "x",
				cols: [
					{
						view: "label",
						css: { "background-color": "#F2F7FC", "padding-left": "16px", "padding-top": "5px", "max-width": "100%", "height": "auto" },
						borderless: true,
						label: "<a href='http://minvoice.vn' target='_blank'><img class='logo_app'  src='assets/imgs/LogoAppMinvoice.png' width='175' height='42' /></a>",
						width: 210
					},
					{
						view: "toolbar",
						borderless: true,
						css: { "background-color": "#F2F7FC !important", "border-width": "0px !important; ", "border-bottom": "none !important" },
						elements: [
							{
								height: 65,
								id: "person_template",
								css: "header_person",
								view: "template",
								borderless: true,
								width: 70,
								url: {
									$proxy: true,
									load: function (view, callback, params) {
										var url = apiHost + "/System/ExecuteCommand";

										var parameters = {};

										parameters.command = "CM00010";
										parameters.parameter = {
											ma_dvcs: "VP"
										};

										webix.ajax().bind(view)
											.headers({ 'Content-type': 'application/json' })
											.post(url, parameters, callback);
									}
								},

								template: function (obj) {
									var html = "<div style='float:left;' onclick='webix.$$(\"profilePopup\").show(this)'>";
									// html += "<img class='photo' src='assets/imgs/photos/userprofile.png' /><span class='name' >" + user.getCurrentUser() + "</span>";
									// html += "<span class='webix_icon mdi mdi-chevron-down'></span></div>";
									// html += "<span data-toggle='tooltip' data-placement='top' title='" + user.getCurrentUser() + "'><i class='fas fa-user-circle fa-3x'></i></span>";
									html += "<span><i class='fas fa-user-circle fa-3x'></i></span><span class='webix_tree_open'></span>";
									html += "</div><span data-toggle='tooltip' data-placement='top' title='" + user.getCurrentUser() + "'></span>";
									// html += "<div class='mainToolbar' ><b>" + obj.ten_dvcs + "</b><br /><i>MST: " + obj.ms_thue + "</i></div>";
									return html;
								}
							}
						]
					},
					menuBar,
					{ width: 15, css: { "background": "#F2F7FC" } },
					mainToolbar
				]
			},
			// { view: "label", height: 1, css:{"background-color":"#edf2f7"}},
			body
		]
	};

	return {
		$ui: layout,
		$menu: "app:menu",
		$oninit: function (view, scope) {
			scope.ui(search.$ui);
			scope.ui(profile.$ui);
			scope.ui(notification.$ui);

			webix.storage.local.put("APP_DEFAULT", app.config.start);
			var default_url = webix.storage.local.get("APP_DEFAULT");
			app.show("/app");
			app.router(default_url);
			var company = version.getInfocompany();
			document.title = company.ms_thue + " - " + company.ten_dvcs;

			var url = apiHost + "/System/GetNoticeCount";
			webix.ajax()
				.headers({ 'Content-type': 'application/json' })
				.get(url, function (text) {
					var notice = JSON.parse(text);
					$$("mess").define({ value: notice.length });
					$$("mess").refresh();
				});

				webix.ajax()
				.headers({ 'Content-type': 'application/json' })
				.get(apiHost + "/Pattern/CheckCreatKyHieu", function (text) {
					var res = JSON.parse(text);
					if (res.hasOwnProperty("error")) {
						webix.message(res.error, "error");
					} else {
						if (res.ok == true) {
							$$("dangkyBanner").show();
						} else {
							webix.ajax()
								.headers({ 'Content-type': 'application/json' })
								.get(apiHost + "/System/GetBanner", function (text) {
									var notice = JSON.parse(text);
									if (notice != null) {
										$$("noticeForm").setValues(notice);

										var htmls = '<a style ="float:right;text-decoration: none;color:blue;" href="' + notice.url + '" target="_blank"><img style="height: 100%; width: 100%; object-fit: contain; padding-bottom: 10px;" src="' + notice.url_image + '" alt="NAM PV"></a>'
											+ '<b>' + notice.title + '</b>'
											+ '</br>' + notice.description;
										$$("bodyBanner").define("template", htmls);
										$$("noticeBanner").show();
									}
								});
						}
					}
				});
		}
	};

});
/**
 * Created by Mads on 03-10-2015.
 */
 define('views/ptp/login',[
    "models/user",
    "locale",
    "app",
    "helpers/locale",
    "views/menus/version",
    "views/quenmk"
], function (user, _, app, locale, version, quenmk) {

    "use strict";
    webix.ui({
        view: "popup",
        id: "my_pop",
        head: "Submenu",
        width: 250,
        body: {
            view: "list",
            data: [
                { id: "1", name: _("Nâng cấp lên phiên bản Online"), location: "M-Invoice Desktop" }
            ],
            template: "#name#",
            autoheight: true,
            select: true,
            on: {
                onItemClick: function (id) {
                    if (id == "1") {
                        app.router("/updateToWeb");
                    }
                }
            }
        }
    });
    var values = webix.copy({
        username: '',
        password: '',
        rememberme: false,
        language: 'vi',
        ma_dvcs: "VP"
    }, Cookies.getJSON("Crm"));

    var demo = function () {
        webix.message("nam pv");
    };
    // var Tawk_API = {
    //     isPopup: true,
    //     onLoad: function () {
    //         var dataObj = parseQueryString();

    //         if (dataObj.tags !== undefined) {
    //             Tawk_API.addTags(dataObj.tags);
    //         }

    //         if (dataObj.event !== undefined) {
    //             if (dataObj.attrLength !== 0) {
    //                 Tawk_API.addEvent(dataObj.event, dataObj.attributes);
    //             } else {
    //                 Tawk_API.addEvent(dataObj.event);
    //             }
    //         };
    //     }

    // }, Tawk_LoadStart = new Date();

    // (function () {
    //     var s1 = document.createElement("script"),
    //         s0 = document.getElementsByTagName("script")[0];

    //     s1.async = true;
    //     s1.src = 'https://embed.tawk.to/5b713334afc2c34e96e783c7/default';
    //     s1.charset = 'UTF-8';
    //     s1.setAttribute('crossorigin', '*');

    //     s0.parentNode.insertBefore(s1, s0);
    // })();

    return {
        $ui: {
            rows: [
                {
                    //borderless: true,
                    css: { "box-shadow": "0 5px 15px rgba(0,0,0,0.2)" },
                    height: 80,
                    cols: [
                        { gravity: 1, template: "", width: 150 },
                        {
                            view: "label",
                            template: "<a href='https://hoadondientu-ptp.vn/' target='_blank'><img  src='assets/imgs/head-banner.jpg' /></a>",
                            height: 65,
                            borderless: true,
                            css: { "padding": "10px", "padding-top": "15px" }
                        },
                        {
                            id: "version",
                            borderless: true,
                            view: "label",
                            template: "<div class='hotline'><b style='font-family:Arial;'>Hotline:</b> <label class='f1s' style='color:red'>1800558850</label> <br /><i class='f2s' style='float:right; color:red'>chamsockhachhang.ptp@gmail.com</i></div>",
                            css: { "padding": "10px", "padding-top": "20px" }
                        },
                        {
                            rows: [
                                { gravity: 1, template: "" },
                                {
                                    id: "cbLanguage",
                                    view: "combo",
                                    width: 125,
                                    options: [
                                        { id: "vi", value: "Việt Nam" },
                                        { id: "en", value: "English" },
                                        { id: "ko", value: "Korean" }
                                    ],
                                    // inputAlign: "right",
                                    //css: "cbLanguage",
                                    value: locale.getLang(),
                                    on: {
                                        onChange: function (newv, oldv) {
                                            locale.setLang(newv, null);
                                        }
                                    }
                                },
                                {
                                    id: "phanvung",
                                    borderless: true,
                                    view: "label",
                                    template: "<label class='f1s' style='color:blue'>Phân vùng: ...</label>"
                                }
                                // { gravity: 1, template: "" }
                            ]

                        },
                        {
                            view: "label",
                            css: "loginfootercog",
                            width: 50,
                            template: function (obj) {
                                var html = "<div style='font-size: 15px;width: 30px;height:100%;float:right;' onclick='webix.$$(\"my_pop\").show(this)'><i class='fas fa-cog'></i></div>";
                                return html;
                            }
                        },
                        { gravity: 1, template: "", width: 150 }
                    ]
                },

                // {
                //     height: 100,
                //     cols: [
                //           { gravity: 1, template: "", width: 1000 },
                //           { gravity: 1, template: "" }
                //         // {
                //         //     view: "label",
                //         //    // type: "header",
                //         //     template: "M-Invoice Copyright © " + new Date().getFullYear(),
                //         //     css: { "background-color": "#0295E3", "color": "white" },
                //         //     borderless: true,
                //         //     width: 250
                //         // },
                //         // {},
                //         // {
                //         //     id: "cbLanguage",
                //         //     view: "combo",
                //         //     width: 125,
                //         //     options: [
                //         //         { id: "vi", value: "Việt Nam" },
                //         //         { id: "en", value: "English" },
                //         //         { id: "ko", value: "Korea" }
                //         //     ],
                //         //    // inputAlign: "right",
                //         //     //css: "cbLanguage",
                //         //     value: locale.getLang(),
                //         //     on: {
                //         //         onChange: function (newv, oldv) {
                //         //             locale.setLang(newv, null);
                //         //         }
                //         //     }
                //         // },
                //     ]
                // },
                {
                    css: "bodylogin",
                    cols: [
                        { gravity: 1, template: "" },
                        { gravity: 1, template: "" },
                        { gravity: 1, template: "" },
                        { gravity: 1, template: "" },
                        { gravity: 1, template: "" },
                        { gravity: 1, template: "" },
                        {
                            //  css: { "padding-left": "450px" },
                            rows: [
                                { gravity: 1, template: "" },
                                // {
                                // view: "label",
                                // label: "Đăng nhập",
                                //css: { "background-color": "white", "color": "red", "border-radius": "15px 15px 0px 0px" },
                                //height: 10
                                // cols: [
                                //     {
                                //         view: "template",
                                //         type: "header",
                                //         template: "M-Invoice Copyright © " + new Date().getFullYear(),
                                //         css: { "background-color": "#0295E3", "color": "white" },
                                //         borderless: true,
                                //         width: 250
                                //     },
                                //     {},
                                //     {
                                //         id: "cbLanguage",
                                //         view: "richselect",
                                //         width: 125,
                                //         options: [
                                //             { id: "vi", value: "Việt Nam" },
                                //             { id: "en", value: "English" },
                                //             { id: "ko", value: "Korea" }
                                //         ],
                                //         inputAlign: "right",
                                //         css: "cbLanguage",
                                //         value: locale.getLang(),
                                //         on: {
                                //             onChange: function (newv, oldv) {
                                //                 locale.setLang(newv, null);
                                //             }
                                //         }
                                //     }

                                // ]
                                // },
                                {
                                    view: "form",
                                    gravity: 1,
                                    id: 'loginForm',
                                    width: 380,
                                    // height: 446,
                                    margin: 5,
                                    css: { "border-radius": "10px 10px 10px 10px", "box-shadow": "0 3px 10px rgba(0,0,0,0.2)" },
                                    borderless: false,
                                    elements: [
                                        {
                                            view: "template",
                                            // temlate :"<span><i class='fad fa-user-circle fa-3x'></i></span>",
                                            template: "<center><a href='https://hoadondientu-ptp.vn/' target='_blank'><img  src='assets/imgs/LogoMinvoice.jpg' /></a></center>",
                                            height: 150,
                                            borderless: true,
                                            css: { padding: "0px" }
                                        },
                                        { height: 5 },
                                        // { type: "section", template: "Giá trị hóa đơn" },
                                        {
                                            view: "richselect",
                                            id: "ma_dvcs",
                                            name: "ma_dvcs",
                                            // label: _("DONVI"),
                                            // labelPosition:"top",
                                            css: "donvilogin",
                                            //options: app.config.host +"/System/GetAllDmDvcs",
                                            options: {
                                                view: "gridsuggest",
                                                textValue: "ten_dvcs",
                                                body: {
                                                    url: app.config.host + "/System/GetAllDmDvcs",
                                                    textValue: "ten_dvcs",
                                                    columns: [
                                                        {
                                                            id: "ms_thue",
                                                            width: 120,
                                                            header: _("MS_THUE")
                                                        },
                                                        {
                                                            id: "ten_dvcs",
                                                            width: 450,
                                                            header: _("DONVI")
                                                        }
                                                    ]
                                                }
                                            },
                                            value: values.ma_dvcs,
                                            required: true
                                        },
                                        {
                                            view: "search",
                                            id: "username",
                                            name: "username",
                                            // label: _("USERNAME"),
                                            icon: "fad fa-user",
                                            placeholder: "Tên truy cập",
                                            value: values.username,
                                            required: true,
                                            invalidMessage: "Tên truy cập không để trống hoặc nhập không đúng (a-z,A-Z,0-9)",
                                            validate: webix.rules.isSpecialCharacter,
                                            css: "mcls_uppercase"
                                        },
                                        {
                                            view: "search",
                                            id: "password",
                                            name: "password",
                                            type: "password",
                                            icon: "fab fa-lock",
                                            // label: _("PASSWORD"),
                                            placeholder: "Mật khẩu",
                                            value: values.password,
                                            invalidMessage: "Mật khẩu không được để trống",
                                            required: true,
                                            css: "passlogin"
                                        },
                                        // {view: "slidebox", id: "chkRemoteRowSource", label: "ReadyWeb" },
                                        {
                                            cols: [
                                                {
                                                    view: 'checkbox',
                                                    id: 'remember',
                                                    name: "rememberme",
                                                    css: "rememberlogin",
                                                    labelRight: _("REMEMBERME"),
                                                    labelPosition: "left",
                                                    labelWidth: 5,
                                                    checkValue: true,
                                                    uncheckValue: false,
                                                    value: values.rememberme
                                                },
                                                {
                                                    view: "button",
                                                    label: _("QUENMK") + " ?",
                                                    css: "mcls_btnResetPassLogin",
                                                    type: "iconButton",
                                                    // icon: "far fa-key",
                                                    width: 150,
                                                    click: function () {
                                                        var win = this.$scope.ui(quenmk.$ui);
                                                        win.show();
                                                        // app.router("/retrivepass");
                                                    }
                                                }
                                            ]

                                        },
                                        {
                                            view: "button",
                                            //type: "form",
                                            id: "login",
                                            name: "login",
                                            label: _("DANGNHAP"),
                                            css: "btnlogin",
                                            height: 40,
                                            hotkey: "enter",
                                            type: "form",
                                            click: function () {
                                                var username = $$("username").getValue();
                                                $$("username").setValue(username.toUpperCase());

                                                if ($$("loginForm").validate()) {

                                                    var values = $$("loginForm").getValues();
                                                    if (true === values.rememberme) {
                                                        values.language = $$("cbLanguage").getValue();
                                                        Cookies.set("Crm", values);
                                                    } else {
                                                        // Clear cookie
                                                        Cookies.remove("Crm");
                                                    }
                                                    user.login(values.username, values.password, values.ma_dvcs, $$("cbLanguage").getValue(), $$('loginForm'));
                                                } else {
                                                    $$("username").focus();
                                                    $$("loginForm").focus();
                                                }
                                            }
                                        },
                                        {
                                            view: "label", label: "<center>Bạn muốn dùng thử ?<b style='color:red;'> <a href='https://hoadondientu-ptp.vn/dang-ky-dai-ly/' data-toggle='tooltip' title='Đăng ký sử dụng PTP-Invoice !' target='_blank' style='text-decoration:none; color: red;'>Đăng ký</a></b></center>"
                                        },
                                        {
                                            view: "label",
                                            height: 42,
                                            css: { "padding-top": "16px" },
                                            label: "<hr size='1px' align='center' color='#dadee0'>"
                                        },
                                        // {
                                        //     type: "section",
                                        //     // template: "or connect using",
                                        //     template: "<span style='text-transform:lowercase;'>or connect using</span>",
                                        //     // css: "lineFooter"
                                        // },
                                        {
                                            cols: [
                                                { width: 10 },
                                                {
                                                    view: "icon", icon: "fab fa-facebook-f", width: 100, css: "fbFooter",
                                                    on: {
                                                        onClick: function () {
                                                            var win = window.open("hhttps://hoadondientu-ptp.vn/", '_blank');
                                                            win.focus();
                                                            return;
                                                        }
                                                    }, click: function () {
                                                        this.callEvent("onClick");
                                                    }
                                                }, { width: 15 },
                                                {
                                                    view: "icon", icon: "fab fa-youtube-play", width: 100, css: "ybFooter",
                                                    on: {
                                                        onClick: function () {
                                                            var win = window.open("https://hoadondientu-ptp.vn/", '_blank');
                                                            win.focus();
                                                            return;
                                                        }
                                                    }, click: function () {
                                                        this.callEvent("onClick");
                                                    }
                                                }, { width: 15 },
                                                {
                                                    view: "icon", icon: "fab fa-internet-explorer", width: 100, css: "igFooter",
                                                    on: {
                                                        onClick: function () {
                                                            var win = window.open("https://hoadondientu-ptp.vn/", '_blank');
                                                            win.focus();
                                                            return;
                                                        }
                                                    }, click: function () {
                                                        this.callEvent("onClick");
                                                    }
                                                }
                                            ]
                                        }
                                        // {
                                        //     css: "linelogin",
                                        //     cols: [
                                        //         {
                                        //             view: "button",
                                        //             label: _("QUENMK"),
                                        //             css: "mcls_btnResetPassLogin",
                                        //             type: "iconButton",
                                        //             icon: "far fa-key",
                                        //             width: 150,
                                        //             click: function () {
                                        //                 var win = this.$scope.ui(quenmk.$ui);
                                        //                 win.show();
                                        //                 // app.router("/retrivepass");
                                        //             }
                                        //         },
                                        //         {},
                                        //         {
                                        //             view: "button",
                                        //             css: "mcls_btnRegisterLogin",
                                        //             type: "iconButton",
                                        //             icon: "far fa-long-arrow-right",
                                        //             label: _("DANGKY"),
                                        //             width: 90,
                                        //             click: function () {
                                        //                 window.open('https://hoadondientu-ptp.vn/dang-ky-su-dung/', '_blank');
                                        //             }
                                        //         }
                                        //     ]
                                        // }
                                    ],
                                    // elementsConfig: {
                                    //     labelPosition: "top",
                                    //     //validateEvent: "key"
                                    // }
                                },
                                { gravity: 1, temlate: "" }
                            ]
                        },
                        { gravity: 1, template: "" }
                    ]
                },
                // {
                //     height: 30,
                //     cols: [
                //         { width: 150, css: "loginfooter" },
                //         {
                //             id: "demo",
                //             borderless: true,
                //             width: 120,
                //             view: "label",
                //             template: "<div class='loginfooter'>" + _("HD") + "</div>",
                //             css: "loginfooter",
                //             on: {
                //                 onClick: function () {
                //                     window.open('http://huongdansudung.minvoice.com.vn/');
                //                     //window.location.href = 'https://minvoice.vn/';
                //                 }
                //             },
                //             click: function () {
                //                 this.callEvent("onClick");
                //             }
                //         },
                //         {
                //             id: "dangky",
                //             borderless: true,
                //             width: 90,
                //             view: "label",
                //             template: "<div class='loginfooter'>" + _("DANGKY2") + "</div>",
                //             css: "loginfooter",
                //             on: {
                //                 onClick: function () {
                //                     window.open('https://minvoice.vn/');
                //                     //window.location.href = 'https://minvoice.vn/';
                //                 }
                //             },
                //             click: function () {
                //                 this.callEvent("onClick");
                //             }
                //         },
                //         {
                //             view: "template",
                //             template: "<div class='loginfooter1'><span>Copyrights © " + new Date().getFullYear() + " Phần mềm Hóa đơn điện tử M-Invoice (#Version#). All Rights Reserved.</span></div>",
                //             //height: 50,
                //             borderless: true,
                //             css: "loginfooter1",
                //             // data: version.getVersion(),
                //             url: app.config.host + "/System/GetVersion",
                //             on: {
                //                 onClick: function () {
                //                     window.open('https://minvoice.vn/');
                //                     //window.location.href = 'https://minvoice.vn/';
                //                 }
                //             },
                //             click: function () {
                //                 this.callEvent("onClick");
                //             }
                //         },
                //         {
                //             view: "label",
                //             css: "loginfootercog",
                //             width: 50,
                //             template: function (obj) {
                //                 var html = "<div style='font-size: 15px;width: 30px;height:100%;float:right;' onclick='webix.$$(\"my_pop\").show(this)'><i class='fas fa-cog'></i></div>";
                //                 return html;
                //             }
                //         },
                //         // {
                //         //     view: "button",
                //         //     css: "loginfooter1",
                //         //     borderless: true,
                //         //     width: 50, align: "left",
                //         //     type: "icon", icon: "far fa-cog",
                //         //     popup: "my_pop"
                //         // },
                //         { width: 10 }
                //         // {
                //         //     view: "label",
                //         //     temlate:"<select>i<option value='mercedes'>Mercedes</option><option value='audi'>Audi</option></select>"
                //         // }
                //     ]
                // }
            ]
        },
        $oninit: function () {
            var val = $$("ma_dvcs").getValue();

            webix.ajax()
                .headers({ 'content-type': 'application/json' })
                .get(app.config.host + "/System/GetPhanVung?ma_dvcs=" + val, function (result) {

                    var _res = result == "null" ? null : result.substr(1, result.length - 2);

                    $$("phanvung").define("template", "<label class='f1s' style='color:blue'>Phân vùng: " + _res + "</label>");
                    $$("phanvung").refresh();
                })
            $$("loginForm").focus();
        }
    };
});

define('views/ptp/profile',[
	"app",
	"models/user",
	"views/forms/changepass",
	"locale",
	"views/forms/chat",
	"views/hotroform",
	"views/menus/version"
], function (app, user, changepass, _, chat, hotroform, version) {

	webix.attachEvent("onBeforeAjax",
		function (mode, url, data, request, headers, files, promise) {

			var token = user.getAccessToken();
			var dvcs = user.getDvcsID();

			var language = user.getLanguage();

			var bear = token + ";" + dvcs + ";" + language;

			headers["Authorization"] = "Bear " + bear;
		}
	);
	var ver = version.getVersion();
	var company = version.getInfocompany();

	return {
		$ui:
		{
			view: "popup",
			id: "profilePopup",
			css: "profilePopup",
			resize: true,
			autofit: true,
			minHeight: 350,
			minWidth: 360,
			body: {
				view: "list",
				select: true,
				datatype: "json",
				css: "profile",
				data: [
					{ id: "signOut", icon: "mdi mdi-logout", value: _("LOGOUT") },
					{ id: "1", icon: "mdi mdi-key", value: "USER" },
					{ id: "changepass", icon: "mdi mdi-key", value: _("CHANGE_PASS") },
					{ id: "delcache", icon: "mdi mdi-settings", value: _("DEL_CACHE") },
					// { $template: "Separator" },
					// { id: "hotro", icon: "mdi mdi-ambulance", value: _("MVSUPPORT") },
					// { id: "chat", icon: "mdi mdi-comment-account-outline", value: _("MVCHAT") }
					// { $template: "Separator" },
				],
				template: function (obj) {
					if (obj.value == "USER") {
						var k = "<div item_id='id' class='custom_profile'>"
							+ "<p><i class='fas fa-user-circle fa-lg'></i><span style='margin-left:8px;'> " + user.getCurrentUser() + "</span></p><br>"
							+ "<p><b>Tên công ty: </b>" + company.ten_dvcs + "</p></br>"
							+ "<p><b>Mã số thuế: </b>" + company.ms_thue + "</p></br>"
							+ "<p><b>Phiên bản: </b>" + ver.Version + "</p></br>"
							+ "<a style ='float:right;text-decoration: none;color:blue;' onclick=\"var menu=$$('app:menu'); menu.$scope.show('./infocompany');\" >Xem thêm</a>"
							+ "</div>"
							+ "</div>";
						return k;
					}
					else {
						return "<span style ='color: #475466' class='webix_icon alerts " + obj.icon + "' ></span><span> " + obj.value + "</span>";
					}
				},
				type: {
					height: "auto"
				},
				on: {
					onItemClick: function (id, e, node) {
						$$("profilePopup").hide();

						if (id == "signOut") {
							user.logout();
							document.location.reload();
							/* require(["app"], function(app){
								app.router(app.config.start);
							}); */
						}

						if (id == "changepass") {
							var win = this.$scope.ui(changepass.$ui);
							win.show();
						}

						if (id == "hotro") {
							var json = version.getInfocompany();
							var win = this.$scope.ui(hotroform.$ui);
							hotroform.initUI(json);
							win.show();
						}

						if (id == "chat") {
							var win = this.$scope.ui(chat.$ui);
							win.show();
						}
						if (id == "delcache") {
							webix.storage.local.remove("APP_CACHE");
							webix.storage.local.put("APP_CACHE", {});
							webix.message("Đã xóa cache dữ liệu", "debug");
						}
					}
				}

			}


		}
	};

});
define('views/ptp/quenmk',["app", "locale", "views/modules/minvoiceplugin", "views/menus/version"], function (app, _, plugin, version) {

    //var json = version.getInfocompany();
    //$$("hotro-form").setValues(json);

    var layout = {
        view: "window", modal: true, move: true, id: "retrivepass-win", position: "center",
        head: "Quên mật khẩu",
        width: 500,
        height: 380,
        body: {
            paddingY: 10,
            paddingX: 10,
            //elementsConfig:{labelWidth: 120}, 
            view: "form",
            id: "retrivepassForm",
            complexData: true,
            elements: [
                {
                    view: "radio", vertical: true, id: "optionType", name: "type",
                    // labelRight: "Branch",
                    value: 1, options: [
                        { "id": 1, "value": "1. Lấy lại mật khẩu qua Email" }, // the initially selected item
                        { "id": 2, "value": "2. Lấy lại mật khẩu bằng chữ ký số" }
                    ],
                    on: {
                        onChange: function (newValue, oldValue, config) {

                            if (newValue == 1) {
                                $$("tempMess").define("hidden", false);
                                $$("tempMess").show();
                                $$("tempMess").refresh();
                                $$("txtEmail").define("hidden", false);
                                $$("txtEmail").show();
                                $$("txtEmail").refresh();
                                // hide cks

                                $$("txtAccount").hide();
                                $$("txtPass").hide();
                                $$("txtRePass").hide();
                            }
                            if (newValue == 2) {
                                $$("txtAccount").define("hidden", false);
                                $$("txtAccount").setValue("");
                                $$("txtAccount").show();

                                $$("txtAccount").refresh();
                                $$("txtPass").define("hidden", true);
                                $$("txtPass").setValue("");
                                $$("txtPass").show();
                                $$("txtPass").refresh();
                                $$("txtRePass").define("hidden", true);
                                $$("txtRePass").setValue("");
                                $$("txtRePass").show();
                                $$("txtRePass").refresh();
                                // hide email
                                $$("tempMess").hide();
                                $$("txtEmail").hide();
                            }
                        }
                    }
                },
                {
                    view: "text",
                    labelPosition: "top",
                    id: "txtEmail",
                    //id:          "email",
                    name: "email",
                    label: "Nhập địa chỉ email để nhận mật khẩu mới",
                    icon: "email",
                    required: true,
                    invalidMessage: "Bạn chưa nhập địa chỉ email hoặc email định dạng không đúng",
                    placeholder: "Nhập email ...",
                    validate: webix.rules.isEmail
                },
                // {
                //     view: "fieldset",
                //     label: "Hướng dẫn",
                //     body: {
                //         rows: [
                {
                    id: "version",
                    //borderless: true,
                    css: { "background": "#F2F7FC !important" },
                    // width: 200,
                    view: "template",
                    id: "tempMess",
                    template:
                    //  "<div class=''><p><b>Bước 1:</b></p><label> Quý khách hàng vui lòng nhập Email đăng ký tài khoản !</label> <br />"
                    // + "<p><b>Bước 2:</b></p><label> Đăng nhập tài khoản Email vừa nhập !</label></div>"
                    "<div><label> Hệ thống của PTP-Invoice sẽ gửi mật khẩu mới vào email cho Quý khách hàng.</br>"
                    + " Quý khách hàng vui lòng kiểm tra email để nhận thông tin mật khẩu mới !</label></div>"
                    //         }
                    //     ]
                    // }
                },
                {
                    view: "text", id: "txtAccount", hidden: true, name: "account", required: true, invalidMessage: "Tài khoản không được bỏ trống",
                    label: "Tài khoản", labelPosition: "top"
                },
                {
                    view: "text", id: "txtPass", hidden: true, name: "newpass", required: true, invalidMessage: "Mật khẩu mới không được bỏ trống",
                    type: "password", label: "Mật khẩu mới", labelPosition: "top"
                },
                {
                    view: "text", id: "txtRePass", hidden: true, name: "confirmpass", required: true, invalidMessage: "Xác nhận mật khẩu không được bỏ trống",
                    type: "password", label: "Xác nhận mật khẩu", labelPosition: "top"
                },
                {
                    margin: 10,
                    cols: [
                        {},
                        {
                            shortcut: "F10", view: "button", label: "Gửi (F10)", align: "center", width: 120, type: "form",
                            on: {
                                onClick: function () {
                                    if ($$("retrivepassForm").validate()) {

                                        var form = $$("retrivepassForm");
                                        var item = form.getValues();
                                        if ($$("optionType").getValue() == 2) {
                                            if (item.newpass != item.confirmpass) {
                                                webix.message("Mật khẩu mới không giống nhau", "error");
                                                return;
                                            }
                                            else {
                                                webix.extend(form, webix.ProgressBar);
                                                form.disable();
                                                form.showProgress();

                                                var hub = plugin.hub();
                                                var hubconnect = plugin.conn();
                                                if (hubconnect.state != 1) {
                                                    var form = webix.$$("retrivepassForm");
                                                    form.enable();
                                                    form.hideProgress();
                                                    webix.message("Quý khách hàng chưa cài Plugin ký hóa đơn hoặc Plugin ký hóa đơn chưa được bật !", "error");
                                                    return;
                                                }
                                                else {
                                                    hub.off('resCommand');

                                                    hub.on('resCommand', function (result) {

                                                        var json = JSON.parse(result);

                                                        if (json.hasOwnProperty("error")) {
                                                            webix.message({ type: 'error', text: json.error });

                                                            var form = webix.$$("retrivepassForm");
                                                            form.enable();
                                                            form.hideProgress();
                                                        }
                                                        else {
                                                            webix.ajax()
                                                                .headers({ 'Content-type': 'application/json' })
                                                                .post(app.config.host + "/Account/ResetPass", item, function (text) {
                                                                    var form = webix.$$("retrivepassForm");
                                                                    form.enable();
                                                                    form.hideProgress();
                                                                    var data = JSON.parse(text);
                                                                    //console.log(data);
                                                                    if (!data.hasOwnProperty("error")) {

                                                                        var win = $$("retrivepass-win");
                                                                        win.close();
                                                                        webix.message("Đổi mật khẩu thành công !", "success");
                                                                    }
                                                                    else {
                                                                        webix.message(data.error, "error");
                                                                    }
                                                                });


                                                        }
                                                    });

                                                    var homeURL;
                                                    if (document.location.protocol == "file:") {
                                                        //homeURL = version.getMST();
                                                        homeURL = "testinvoice";
                                                    }
                                                    else {
                                                        // cắt url lấy mst 
                                                        homeURL = version.getURL().split('.')[0];
                                                    }
                                                    item.mst = homeURL;

                                                    hub.invoke('execCommand', 'ResetPassByToken', JSON.stringify(item))
                                                        .done(function () {
                                                            console.log("Success ResetPassByToken!")
                                                        })
                                                        .fail(function (error) {
                                                            var form = webix.$$("retrivepassForm");
                                                            form.enable();
                                                            form.hideProgress();
                                                            webix.message(error, "error");
                                                        });
                                                }
                                            }
                                        }
                                        else {
                                            webix.extend(form, webix.ProgressBar);
                                            form.disable();
                                            form.showProgress();

                                            webix.ajax()
                                                .headers({ 'Content-type': 'application/json' })
                                                .post(app.config.host + "/Account/ResetPass", $$("retrivepassForm").getValues(), function (text, xml, xhr) {

                                                    var json = JSON.parse(text);

                                                    var form = $$("retrivepassForm");
                                                    form.enable();
                                                    form.hideProgress();

                                                    if (json.hasOwnProperty("error")) {
                                                        // webix.alert({
                                                        //     title: "Thông báo",
                                                        //     ok: "OK",
                                                        //     text: json.error,
                                                        //     type: "alert-error"
                                                        // });
                                                        webix.message(json.error, "error");
                                                    }
                                                    else {
                                                        webix.alert({
                                                            title: "Thông báo",
                                                            ok: "OK",
                                                            text: "Đã gửi mật khẩu mới tới email. Bạn hãy kiểm tra email."
                                                        });
                                                    }

                                                });
                                        }
                                    } else {
                                        $$("retrivepassForm").focus();
                                    }
                                }
                            },
                            click: function () {
                                this.callEvent("onClick");
                            }
                        },
                        {
                            view: "button", hotkey: "esc", label: "Hủy bỏ (ESC)", align: "center", width: 120, type: "danger",
                            click: function () {
                                webix.$$("retrivepass-win").close();
                            }
                        },
                        {}
                    ]
                }

            ]
        }
    };
    return {
        $ui: layout,
        initUI: function (json) {
            $$("retrivepassForm").setValues(json);
        }
    };

});
define('views/ptp/updateToWeb',[
    "app",
    "locale",
    "views/forms/updateToWeb"
], function (app, _, formUpdate) {
    'use strict';

    //var windowno = app.path[1].params[0];
    var windowno = null;
    //webix.$$("title").parse({ title: "Nhận dữ liệu từ VACOMS", details: "Nhận dữ liệu từ VACOMS" });
    var header = {
        //borderless: true,
        css: { "box-shadow": "0 2px 10px rgba(0,0,0,0.2)" },
        height: 135,
        cols: [
            // { gravity: 1, template: "", width: 150 },
            {
                view: "label",
                template: "<a href='#' target='_blank'><img  src='assets/imgs/LogoMinvoice.jpg' /></a>",
                height: 115,
                borderless: true,
                css: { "padding": "10px" }
            },
            {
                id: "version",
                borderless: true,
                view: "label",
                template: "<div class='hotline'><b style='font-family:Arial;'>Hotline:</b> <label style='color:red'>1800558850</label> <br /><i style='float:right; color:red'>chamsockhachhang.ptp@gmail.com</i></div>",
                css: { "padding": "40px", "padding-top": "50px" }
            },
            {
                rows: [
                    { gravity: 1, template: "" },
                    {
                        id: "cbLanguage",
                        view: "combo",
                        width: 125,
                        options: [
                            { id: "vi", value: "Việt Nam" },
                            { id: "en", value: "English" },
                            { id: "ko", value: "Korea" }
                        ],
                        // inputAlign: "right",
                        //css: "cbLanguage",
                        value: "vi",
                        // on: {
                        //     onChange: function (newv, oldv) {
                        //         locale.setLang(newv, null);
                        //     }
                        // }
                    },
                    { gravity: 1, template: "" }
                ]

            }
            // { gravity: 1, template: "", width: 150 }
        ]
    };
    var controls = [
        {},
        {
            id: "btnSave",
            view: "button",
            type: "danger",
            icon: "save",
            label: _("THUCHIEN")+" (F10)",
            //  width: 120,
            shortcut: "F10",
            on: {
                onClick: function () {
                    var frm = this.$scope.ui(formUpdate.$ui);
                    frm.show();
                    // $$("formConfirm").show();
                    // $$("formConfirmValid").bind($$("formInfo"));
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {
            view: "button",
            label: _("BACKLOGIN"),
            type: "form",
            icon: "fas fa-repeat",
            click: function () {
                app.router("/login");
            }
        },
        {}
    ];

    var tabview = {
        id: "my_tabview",
        view: "tabview",
        cells: [
            {
                header: _("BANG_DU_LIEU"),
                body: {
                    id: "tblDM",
                    view: "datatable",
                    select: true,
                    editable: false,
                    disable: true,
                    data: [
                        { chon: true, MA: "SYS", TEN_DM: "Bảng hệ thống" },
                        { chon: true, MA: "BQ", TEN_DM: "Bản Quyền" },
                        { chon: true, MA: "CKS", TEN_DM: "Chữ ký số" },
                        { chon: true, MA: "TBH", TEN_DM: "Thông báo hủy" },
                        { chon: true, MA: "QTC", TEN_DM: "Quyền truy cập" },
                        { chon: true, MA: "LDC", TEN_DM: "Loại điều chỉnh" }
                    ],
                    columns: [
                        {
                            id: "chon",
                            header: { content: "masterCheckbox" },
                            template: "{common.checkbox()}",
                            checkValue: true,
                            uncheckValue: false,
                            value: true,
                            width: 50,
                            css: { 'text-align': 'right' }
                        },
                        {
                            id: "MA",
                            header: _("MA"),
                            width: 80
                        },
                        {
                            id: "TEN_DM",
                            header: _("TABLENAME"),
                            width: 250
                        }
                    ]
                }
            },
            {
                header: "Stored Procedures",
                body: {
                    id: "tblDMCT",
                    view: "datatable",
                    select: true,
                    editable: true,
                    data: [
                        { chon: true, MA_CT: "MNU", TEN_CT: "Get Menu" },
                        { chon: true, MA_CT: "DHB", TEN_CT: "Dashboard" },
                        { chon: true, MA_CT: "CHA", TEN_CT: "Biểu đồ" },
                        { chon: true, MA_CT: "PRI", TEN_CT: "Print Invoice" },
                        { chon: true, MA_CT: "PRL", TEN_CT: "Print License" },
                        { chon: true, MA_CT: "TEM", TEN_CT: "Temple Email" },
                        { chon: true, MA_CT: "TSM", TEN_CT: "Temple SMS" },
                        { chon: true, MA_CT: "SEI", TEN_CT: "Search Invoice" },
                        { chon: true, MA_CT: "ATC", TEN_CT: "Auto Create CMD" },
                        { chon: true, MA_CT: "ATF", TEN_CT: "Auto Create Field" }
                    ],
                    columns: [
                        {
                            id: "chon",
                            header: { content: "masterCheckbox" },
                            template: "{common.checkbox()}",
                            checkValue: true,
                            uncheckValue: false,
                            value: true,
                            width: 50,
                            css: { 'text-align': 'right' }
                        },
                        {
                            id: "MA_CT",
                            header: _("Mã"),
                            width: 80
                        },
                        {
                            id: "TEN_CT",
                            header: _("Tên Stored Procedures"),
                            width: 250
                        }

                    ]
                }
            }
        ]
    };


    var layout = {
        // paddingY: 60,
        // paddingX: 500,
        cols: [
            { gravity: 0.5, template: "" },
            {
                rows: [
                    header,
                    { gravity: 0.1, template: "" },
                    {
                        gravity: 0.1,
                        template: "<div><center><b style='color:#e60000'><i class='fa fa-globe'></i> "+_("UDTOWEB")+"</b></center></div>", css: { "padding-top": "15px" }
                    },
                    {
                        view: "form",
                        id: "formInfo",
                        paddingY: 10,
                        // width: 700,
                        // height:300,
                        position: "center",
                        paddingX: 10,
                        complexData: true,
                        margin: 0,
                        //  elementsConfig: {
                        //         labelPosition: "top",
                        //         //validateEvent: "key"
                        //     },
                        url: app.config.host + "/System/GetAllDmDvcs",
                        elements: [
                            {
                                cols: [
                                    {
                                        id: "ten_dvcs",
                                        name: "ten_dvcs",
                                        view: "text",
                                        label: _("TEN_DON_VI"),
                                        readonly: true,
                                        css: "mcls_readonly_text"
                                    },
                                    {
                                        id: "ms_thue",
                                        name: "ms_thue",
                                        view: "text",
                                        label: _("MST"),
                                        readonly: true,
                                        css: "mcls_readonly_text"
                                    }
                                ]
                            },
                            {
                                cols: [
                                    {
                                        id: "dia_chi",
                                        view: "text",
                                        name: "dia_chi",
                                        label: _("DIA_CHI"),
                                        readonly: true,
                                        css: "mcls_readonly_text"
                                    },
                                    {
                                        id: "tk",
                                        name: "gd",
                                        view: "checkbox",
                                        value: 1,
                                        label: _("GHI_DE")
                                    }
                                ]
                            },
                            {
                                view: "template",
                                template: "Lựa chọn Bảng/Stored Procedures Update",
                                type: "section"
                            },
                            tabview,
                            {
                                margin: 10,
                                cols: controls
                            }
                        ]
                    },
                    { gravity: 0.5, template: "" }
                ]
            },
            { gravity: 0.5, template: "" }
        ]

    };

    return {
        $ui: layout
    };
});
define('views/reportwindow',[
    "app",
    "locale",
    "views/forms/infowindow",
    "views/forms/detailreport",
    "views/forms/window",
    "models/user",
    "views/modules/minvoiceplugin",
    "views/modules/Component/modalPlugin"
], function (app, _, infowindow, detailreport, windowform, user, plugin, modalPlugin) {
    'use strict';

    var fm = function (cel) {
        return webix.Number.numToStr({
            groupDelimiter: ",",
            groupSize: 3,
            decimalDelimiter: ".",
            decimalSize: cel
        })
    }
    var controls = [
        {
            id: "cbReport",
            view: "combo",
            width: 450,
            label: "Chọn báo cáo",
            labelWidth: 90,
            suggest: {
                url: {
                    $proxy: true,
                    load: function (view, callback, params) {
                        var windowno = app.path[1].params[0];
                        var url = app.config.host + "/System/ExecuteCommand";
                        var parameters = {
                            command: "CM00016",
                            parameter: {
                                window_id: windowno,
                                username: user.getCurrentUser()
                            }
                        };
                        webix.ajax().bind(view)
                            .headers({ "Content-Type": "application/json" })
                            .post(url, parameters, callback);
                    }
                },
                template: "#report_name#",
                body: {
                    template: "#report_name#"
                }
            },
            on: {
                onChange: function () {
                    var report_id = this.getValue();
                    if (report_id == "") {
                        return;
                    }
                    var name = $$("cbReport").getText();
                    webix.$$("title").parse({ title: name, details: name, url_help: "http://huongdansudung.minvoice.com.vn/" });
                    initTable(report_id);
                    var btnReload = $$("btnReload");
                    btnReload.callEvent("onClick");
                }
            }
        },
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-refresh fa-lg" aria-hidden="true"></i> ' +
                '<span class="text">' + _("REFRESH") + '</span>',
            id: "btnReload",
            on: {
                onClick: function () {
                    if ($$("cbReport").getValue() == null || $$("cbReport").getValue() == "") {
                        webix.message("Bạn chưa chọn báo cáo !", "error");
                        return;
                    }
                    var cbReport = webix.$$("cbReport");
                    var list = cbReport.getList();
                    var item = list.getItem(cbReport.getValue());

                    infowindow.$ui.id = item.wb_infowindow_id;
                    infowindow.$ui.report_id = cbReport.getValue();
                    infowindow.$ui.load_event = "loadReport";

                    if ($$("tblReport").config.rpParameter != null) {
                        infowindow.$ui.editmode = 1;
                        infowindow.$ui.formvalues = $$("tblReport").config.rpParameter.parameters;
                    }
                    else {
                        infowindow.$ui.editmode = 0;
                        infowindow.$ui.formvalues = null;
                    }

                    var wininfoparam = this.$scope.ui(infowindow.$ui);
                    infowindow.initUI(item.wb_infowindow_id);
                    wininfoparam.show();
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-print fa-lg" aria-hidden="true"></i> ' +
                '<span class="text">' + _("PRINT") + " PDF" + '</span>',
            id: "btnPrint",
            on: {
                onClick: function () {
                    var table = $$("tblReport");
                    var rpParameter = table.config.rpParameter;
                    if (rpParameter == undefined || rpParameter == null) {
                        webix.message("Bạn chưa chọn báo cáo hoặc chưa tải dữ liệu !", "error");
                        return;
                    }
                    rpParameter.type = "PDF";
                    if (rpParameter != null) {
                        var box = webix.modalbox({
                            title: "Đang in báo cáo ....",
                            text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                            width: 350,
                            height: 200
                        });

                        webix.ajax()
                            .response("arraybuffer")
                            .headers({ 'Content-type': 'application/json' })
                            .post(app.config.host + "/System/CreateReport", rpParameter,
                                {
                                    error: function (text, data, XmlHttpRequest) {
                                        webix.modalbox.hide(box);
                                        webix.message(XmlHttpRequest.statusText, "error");
                                    },
                                    success: function (text, data, XmlHttpRequest) {
                                        var file = new Blob([data], { type: 'application/pdf' });
                                        var fileURL = URL.createObjectURL(file);
                                        webix.modalbox.hide(box);
                                        window.open(fileURL, '_blank');
                                    }
                                }
                                // function (text, data) {
                                //     var file = new Blob([data], { type: 'application/pdf' });
                                //     var fileURL = URL.createObjectURL(file);
                                //     webix.modalbox.hide(box);
                                //     window.open(fileURL, '_blank');
                                // }
                            );
                    }
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {
            view: "button", type: "htmlbutton", width: 120,
            label: '<i class="fa fa-file-excel fa-lg" aria-hidden="true"></i> ' +
                '<span class="text">' + _("EXPORT_EXCEL") + '</span>',
            id: "btnExport",
            on: {
                onClick: function () {
                    var table = $$("tblReport");

                    var rpParameter = table.config.rpParameter;
                    if (rpParameter == undefined || rpParameter == null) {
                        webix.message("Bạn chưa chọn báo cáo hoặc chưa tải dữ liệu !", "error");
                        return;
                    }
                    rpParameter.type = "xlsx";
                    if (rpParameter != null) {
                        var box = webix.modalbox({
                            title: "Đang kết xuất Excel ....",
                            text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                            width: 350,
                            height: 200
                        });

                        webix.ajax()
                            .response("arraybuffer")
                            .headers({ 'Content-type': 'application/json' })
                            .post(app.config.host + "/System/CreateReport", rpParameter,
                                {
                                    error: function (text, data, XmlHttpRequest) {
                                        webix.modalbox.hide(box);
                                        webix.message(XmlHttpRequest.statusText, "error");
                                    },
                                    success: function (text, data, XmlHttpRequest) {
                                        var file = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                                        var fileURL = URL.createObjectURL(file);
                                        webix.modalbox.hide(box);
                                        window.location.href = fileURL;
                                    }
                                }
                            );
                    }
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {
            view: "button", type: "htmlbutton", width: 120,
            label: '<i class="fa fa-file-text-o fa-lg" aria-hidden="true"></i> ' +
                '<span class="text">' + _("EXPORT_CSV") + '</span>',
            id: "btnExportCsv",
            on: {
                onClick: function () {
                    var table = $$("tblReport");
                    var rpParameter = table.config.rpParameter;
                    if (rpParameter == undefined || rpParameter == null) {
                        webix.message("Bạn chưa chọn báo cáo hoặc chưa tải dữ liệu !", "error");
                        return;
                    }
                    rpParameter.type = "CSV";
                    if (rpParameter != null) {
                        var box = webix.modalbox({
                            title: "Đang kết xuất CSV ....",
                            text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                            width: 350,
                            height: 200
                        });

                        webix.ajax()
                            .response("arraybuffer")
                            .headers({ 'Content-type': 'application/json' })
                            .post(app.config.host + "/System/CreateReport", rpParameter,
                                {
                                    error: function (text, data, XmlHttpRequest) {
                                        webix.modalbox.hide(box);
                                        webix.message(XmlHttpRequest.statusText, "error");
                                    },
                                    success: function (text, data, XmlHttpRequest) {
                                        var file = new Blob([data], { type: 'application/csv' });
                                        webix.html.download(file, "minvoiceReport.csv");
                                        //var fileURL = URL.createObjectURL(file);
                                        webix.modalbox.hide(box);
                                        //window.location.href = fileURL;
                                    }
                                }
                            );
                    }
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        // {
        //     view: "button", type: "htmlbutton", width: 120,
        //     label: '<i class="fa fa-file-excel fa-lg" aria-hidden="true"></i> ' +
        //         '<span class="text">' + _("Kết xuất Excel (Nhanh)") + '</span>',
        //     id: "btnExportNew32",
        //     on: {
        //         onClick: function () {
        //             var table = $$("tblReport");
        //             var rpParameter = table.config.rpParameter;
        //             if (rpParameter == undefined || rpParameter == null) {
        //                 webix.message("Bạn chưa chọn báo cáo hoặc chưa tải dữ liệu !", "error");
        //                 return;
        //             }
        //             rpParameter.type = "xlsx";
        //             if (rpParameter != null) {
        //                 var box = webix.modalbox({
        //                     title: "Đang kết xuất Excel ....",
        //                     text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
        //                     width: 350,
        //                     height: 200
        //                 });
        //                 webix.toExcel($$("tonghophoadon"), {
        //                     filename: "Minvoice_EXCEL_REPORT"
        //                 });
        //                 webix.modalbox.hide(box);
        //             }
        //         },
        //         click: function () {
        //             this.callEvent("onClick");
        //         }
        //     }
        // },
        {
            view: "button", type: "htmlbutton", width: 150,
            label: `<i class="fa fa-plug fa-lg" aria-hidden="true"></i> ${_("Kết xuất trên Plugin")}`,
            id: "btnExportPlugin",
            on: {
                onClick: function () {
                    var table = $$("tblReport");

                    var rpParameter = table.config.rpParameter;
                    if (rpParameter == undefined || rpParameter == null) {
                        webix.message("Bạn chưa chọn báo cáo hoặc chưa tải dữ liệu !", "error");
                        return;
                    }

                    var hub = plugin.hub();
                    var hubconnect = plugin.conn();
                    var form = $$("grdViewReport");
                    webix.extend(form, webix.ProgressBar);
                    form.disable();
                    form.showProgress();

                    if (hubconnect.state != 1) {
                        form.enable();
                        form.hideProgress();
                        webix.message("Quý khách hàng chưa cài Plugin ký hóa đơn hoặc Plugin ký hóa đơn chưa được bật !", "error");
                        var Form = $$("grdViewReport").$scope.ui(modalPlugin.$ui);
                        Form.show();
                        return;
                    }

                    var currentLocation = window.location.origin + "/api/";
                    if (document.location.protocol == "file:" || document.location.hostname == "127.0.0.1") {
                        currentLocation = "http://localhost:18374/";
                    };
                    rpParameter.location = currentLocation;
                    rpParameter.cookie = user.getAppCookie();
                    rpParameter.type = "xlsx";
                    rpParameter.is_delete = "1";
                    var table = $$("tblReport");
                    rpParameter.data = table.serialize();
                    var name = $$("cbReport").getText();
                    rpParameter.name = name;
                    hub.invoke('execCommand', 'BC_DACTHU', JSON.stringify(rpParameter))
                        .done(function () {
                            console.log("Run report on plugin success !")
                        })
                        .fail(function (error) {
                            webix.message(error, "error");
                        });
                    hub.off('resNotice');
                    hub.on('resNotice', function (result) {
                        webix.message(result, "debug", 4000);
                    });
                    hub.off('resCommand');
                    hub.on('resCommand', function (result) {
                        var response = JSON.parse(result);
                        form.enable();
                        form.hideProgress();
                        if (response.code == "00") {
                            webix.message("Đã tạo báo cáo thành công trên plugin", "success", 3000);
                        }
                        else {
                            webix.message("Code: " + response.code + " Message: " + response.message + ". Plugin xảy ra lỗi", "error");
                        }
                    });
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {},
        {
            view: "button",
            type: "icon",
            width: 30,
            icon: "mdi mdi-settings",
            click: function () {
                var menu = $$("tblReport").config.headermenu;
                $$(menu).show(this.$view);
            },
        }
    ];

    var grid = {
        rows: [
            {
                id: "tblReport",
                view: "datatable",
                resizeColumn: true,
                footer: true,
                select: true,
                css: "report",
                columns: [{ id: "col1", width: 1, header: [null, null], headermenu: false, footer: null }],
                headermenu: {
                    autoheight: false,
                    scroll: true,
                    autowidth: true
                },
                scheme: {
                    $change: function (item) {
                        if (item.BOLD == "C")
                            item.$css = "rowBold";
                    }
                },
                pager: "pagerA",
                on: {
                    onBeforeContextMenu: function (id) {
                        var item = this.getItem(id);

                        if (item.DOC_ID != null && item.MA_CT != null) {
                            var mn = $$("ctxMenu");
                            var menuitem = mn.getItem("SUACTGOC");
                            if (menuitem == null) {
                                mn.add({ id: "SUACTGOC", value: "Sửa chứng từ" });
                            }
                        }

                        webix.delay(function () {
                            this.clearSelection();
                            this.select(id.row, id.column);
                        }, this);
                    }
                }
            },
            {
                cols: [
                    {
                        view: "icon", icon: "fas fa-question-circle", id: "help_form_viewsfile", tooltip: _("HELPER"),
                        css: "helper",
                        click: function () {
                            webix.alert({
                                title: "Thông báo !",
                                text: "Bạn chưa khai báo hướng dẫn nhanh cho màn hình này !",
                                type: "alert-warning",
                                callback: function (result) {
                                }
                            });
                        }
                    },
                    {
                        view: "combo",
                        label: _("MENU_QUICK"),
                        id: "QuickMenu1",
                        options: {
                            // view: "gridsuggest",
                            // id: "grid_window",
                            // template: "#name#",
                            // body: {
                            //     scroll: true,
                            //     autoheight: false,
                            //     columns: [
                            //         { id: "window_id", header: "Window Id", editor: "text", width: 100 },
                            //         { id: "name", header: "Window Name", editor: "text", width: 400 }
                            //     ],
                            //     url: app.config.host + "/System/GetQuickMenu"
                            // },
                            // on: {
                            //     onValueSuggest: function (obj) {
                            //         var start = obj.window_id != "" ? obj.code + ":" + obj.window_id : obj.code;
                            //         window.location.hash = "!/app/" + start;
                            //         $$("QuickMenu1").setValue(null);
                            //         $$("QuickMenu1").destructor();
                            //     }
                            // }
                        },
                        on: {
                            onChange: function (newv, oldv) {

                            }
                        }
                    },
                    {},
                    {
                        id: "pagerA",
                        view: "pager",
                        size: 1000,
                        group: 5,
                        template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}"
                    }
                ]
            }
        ]
    }

    var contextmenu = webix.ui({
        view: "contextmenu",
        id: "ctxMenu",
        on: {
            onMenuItemClick: function (id) {
                var item = this.getItem(id);

                if (id == "SUACTGOC") {
                    var table = $$("tblReport");
                    var row = table.getSelectedItem();

                    var sql = "SELECT TOP 1 a.* FROM VC_WINDOW a WHERE a.ma_ct='" + row.MA_CT + "'";
                    var url = app.config.host + "/api/System/ExecuteQuery?sql=" + sql;

                    webix.ajax(url, function (text) {
                        var json = JSON.parse(text);
                        var data = json[0];

                        var table = $$("tblReport");
                        var row = table.getSelectedItem();

                        var a = webix.ajax(app.config.host + "/api/System/GetDataById?window_id=" + data.WINDOW_ID + "&id=" + row.DOC_ID);
                        var b = webix.ajax(app.config.host + "/api/System/GetAllByWindowNo?window_id=" + data.WINDOW_ID);

                        webix.promise.all([a, b]).then(function (results) {
                            var a_result = results[0].json();
                            var windowconfig = results[1].json();

                            var vc_window = windowconfig["data"][0];
                            windowform.$ui.id = vc_window.WINDOW_ID;

                            var table = $$("tblReport");
                            var detailForm = table.$scope.ui(windowform.$ui);

                            var item = a_result.data[0];

                            windowform.initUI(windowconfig);
                            windowform.setEditMode(2);
                            windowform.setValues(item, windowconfig);

                            detailForm.show();
                        });

                    });
                }
                else {
                    var ctx = this.getContext();

                    detailreport.$ui.id = "dtrp_" + item.MENU_ID;
                    detailreport.$ui.parentParameter = ctx.obj.config.rpParameter.parameters;
                    detailreport.$ui.parentRow = ctx.obj.getSelectedItem();

                    this.hide();

                    var win = ctx.obj.$scope.ui(detailreport.$ui);
                    detailreport.initUI(item);
                    win.show();
                }
            }
        }
    });

    var layout = {
        css: "frmView",
        id: "grdViewReport",
        rows: [
            {
                height: 39,
                css: "btnControl",
                type: "toolbar",
                margin: 0,
                borderless: true,
                cols: controls
            },
            {
                rows: [
                    grid
                ]
            }
        ]
    };

    function initTable(report_id) {

        var url = app.config.host + "/System/ExecuteCommand";
        var parameters = {
            command: "CM00012",
            parameter: {
                wb_report_id: report_id
            }
        };

        webix.ajax().headers({ "Content-Type": "application/json" })
            .post(url, parameters, function (text) {
                var json = JSON.parse(text);
                var table = webix.$$("tblReport");
                table.clearAll();
                table.config.rpParameter = null;
                var cols = [];
                for (var i = 0; i < json.length; i++) {
                    var col = json[i];
                    var item = {
                        id: col.reportcolumn_field,
                        header: _(col.reportcolumn_name),
                        width: col.reportcolumn_width,
                        hidden: col.hidden == "C" ? true : false
                    };
                    // cột tổng dưới footer
                    if (col.footer === '' || col.footer === null) {
                    }
                    else {
                        var temp = JSON.parse(col.footer);
                        item.footer = temp;
                        item.footer.height = 22;
                    }

                    //console.log(col.sum);
                    if (col.header != null) {
                        if (col.header != "") {
                            var headers = JSON.parse(col.header);

                            for (var j = 0; j < headers.length; j++) {
                                var hd = headers[j];
                                if (hd != null) {
                                    hd.text = _(hd.text);
                                }
                            }
                            item.header = headers;
                        }
                    }

                    if (col.column_type == "datetime" || col.column_type == "date") {
                        item.format = function (text) {
                            var format = webix.Date.dateToStr("%d/%m/%Y");
                            text = removeTimeZoneT(text);
                            return format(text);
                        };
                    }

                    if (col.column_type == "decimal" || col.column_type == "int") {
                        item.css = { "text-align": "right" };
                        if (col.reportcolumn_format != null && col.reportcolumn_format != "") {
                            // item.format = col.reportcolumn_format;
                            // item.format = webix.i18n.numberFormat();
                            item.format = fm(col.reportcolumn_format);
                        }
                        else {
                            item.format = webix.Number.numToStr({
                                groupDelimiter: ",",
                                groupSize: 3,
                                decimalDelimiter: ".",
                                decimalSize: 0
                            });
                        }
                    }

                    if (col.column_type == "bit") {
                        item.template = function (obj, common, value) {
                            if (value)
                                return "<div class='webix_icon fa-check-square-o'></div>";
                            else
                                return "<div class='webix_icon fa-square-o'></div>";
                        };
                    }
                    cols.push(item);
                }
                table.config.columns = cols;
                table.config.report_id = json[0]["wb_report_id"];
                table.refreshColumns();
            });
    }

    return {
        $ui: layout,
        $oninit: function (view, $scope) {

            if (app.path[1].params[1] != null) {
                var id = app.path[1].params[1];
                $$("cbReport").setValue(id);

                var load_event = "loadReport";
                var report_id = "d13001df-01fe-4d4f-ab65-cc98e7b41661";
                var id = "5accccd3-51bd-4370-b130-b01ab35d6c86";

                var now = new Date();
                now.setHours(0, 0, 0, 0);

                var item = {
                    ma_dvcs: user.getDvcsID(),
                    tu_ngay: null,
                    den_ngay: now
                };

                var table = $$("tblReport");
                table.report_id = report_id;

                var rpParameter = {
                    parameters: item,
                    infowindow_id: id,
                    type: "json",
                    report_id: report_id
                };

                table.config.rpParameter = rpParameter;

                webix.ajax()
                    .headers({ 'Content-type': 'application/json' })
                    .post(app.config.host + "/System/CreateReport", rpParameter, {
                        error: function (text, data, XmlHttpRequest) {
                            // alert(text);
                            webix.alert({
                                title: "Thông báo !",
                                text: text,
                                type: "alert-warning",
                                callback: function (result) {
                                }
                            });
                        },
                        success: function (text, data, XmlHttpRequest) {
                            var data = JSON.parse(text);

                            var table = $$("tblReport");
                            table.clearAll();
                            table.parse(data, "json");
                        }
                    }
                    );
            }

            $scope.on(app, "loadReport", function (report_id, infoWindowId, item) {
                var table = $$("tblReport");
                webix.extend(table, webix.ProgressBar);
                table.disable();
                table.showProgress();
                if (table.config.report_id == report_id) {

                    var rpParameter = {
                        parameters: item,
                        infowindow_id: infoWindowId,
                        type: "json",
                        report_id: report_id
                    };
                    table.config.rpParameter = rpParameter;
                    webix.ajax()
                        .headers({ 'Content-type': 'application/json' })
                        .post(app.config.host + "/System/CreateReport", rpParameter, function (text) {
                            webix.delay(function () {
                                var data = JSON.parse(text);
                                var table = $$("tblReport");
                                table.clearAll();
                                table.parse(data, "json");
                            }, null, null, 1000);

                            table.enable();
                            table.hideProgress();
                        });
                }
            });

            $scope.on(app, "loadDetailReport", function (report_id, infoWindowId, item, menuitem) {
                var win = $$("dtrp_" + menuitem.MENU_ID);
                var table = win.getChildViews()[1].getChildViews()[1];

                if (table.config.report_id == report_id) {

                    var rpParameter = {
                        parameters: item,
                        infowindow_id: infoWindowId,
                        type: "json",
                        report_id: report_id
                    };

                    table.config.rpParameter = rpParameter;
                    var ajax = webix.ajax();
                    ajax.master = menuitem;
                    ajax.headers({ 'Content-type': 'application/json' })
                        .post(app.config.host + "/api/System/CreateReport", rpParameter, function (text) {

                            var win = $$("dtrp_" + this.MENU_ID);
                            var table = win.getChildViews()[1].getChildViews()[1];
                            var data = JSON.parse(text);
                            table.clearAll();
                            table.parse(data, "json");
                        });
                }
            });
        },
        initUI: function () {

        }
    };
});
/**
 * Created by Mads on 03-10-2015.
 */
define('views/retrivepass',[
    "models/user",
    "locale",
    "app",
    "helpers/locale"
], function (user, _, app, locale) {

    "use strict";
    var values = webix.copy({
        username: '',
        password: '',
        rememberme: false,
        language: 'vi',
        ma_dvcs: "VP"
    }, Cookies.getJSON("Crm"));

    return {
        $ui: {
            cols: [
                { gravity: 1, template: "" },
                {
                    rows: [
                        { gravity: 1, template: "" },
                        {
                            css: { "background-color": "#cc0000", "color": "white", "border-radius": "15px 15px 0px 0px" },
                            cols: [
                                {
                                    view: "template",
                                    type: "header",
                                    template: "Quên mật khẩu ?",
                                    css: { "background-color": "#cc0000", "color": "white", "padding-bottom": "5px" },
                                    borderless: true,
                                    //width:180
                                }
                            ]
                        },
                        {
                            cols: [
                                {
                                    view: "form",
                                    gravity: 1,
                                    id: 'loginForm',
                                    width: 360,
                                    elementsConfig: {
                                        labelPosition: "top",
                                    },
                                    elements: [
                                        {
                                            view: "template",
                                            template: "<center><a href='http://minvoice.vn/' target='_blank'><img  src='assets/imgs/LogoMinvoice.png' /></a></center>",
                                            height: 130,
                                            borderless: true,
                                            css: { padding: "0px" }
                                        },
                                        {
                                            height: 15
                                        },
                                        {
                                            view: "text",
                                            //id:          "email",
                                            name: "email",
                                            label: "Nhập địa chỉ email để gửi mật khẩu mới",
                                            icon: "email",
                                            required: true,
                                            invalidMessage: "Bạn chưa nhập địa chỉ email hoặc email định dạng không đúng",
                                            placeholder: "Email",
                                            validate: webix.rules.isEmail
                                        },
                                        {
                                            view: "button",
                                            //type:"danger",
                                            id: "login",
                                            name: "login",
                                            label: "Gửi yêu cầu tạo mật khẩu",
                                            //hotkey: "enter",
                                            css: "mcls_btnResetPass",
                                            click: function () {
                                                if ($$("loginForm").validate()) {

                                                    var form = $$("loginForm");
                                                    webix.extend(form, webix.ProgressBar);
                                                    form.disable();
                                                    form.showProgress();
                                                    webix.ajax()
                                                        .headers({ 'Content-type': 'application/json' })
                                                        .post(app.config.host + "/Account/ResetPass", $$("loginForm").getValues(), function (text, xml, xhr) {

                                                            var json = JSON.parse(text);
                                                            var form = $$("loginForm");
                                                            form.enable();
                                                            form.hideProgress();
                                                            if (json.hasOwnProperty("error")) {
                                                                webix.alert({
                                                                    title: "Thông báo",
                                                                    ok: "OK",
                                                                    text: json.error,
                                                                    type: "alert-error"
                                                                });
                                                            }
                                                            else {
                                                                webix.alert({
                                                                    title: "Thông báo",
                                                                    ok: "OK",
                                                                    text: "Đã gửi mật khẩu tới email.Bạn hãy kiểm tra lại."
                                                                });
                                                            }

                                                        });
                                                } else {
                                                    $$("loginForm").focus();
                                                }
                                            }
                                        },
                                        {
                                            view: "button",
                                            label: "Quay lại đăng nhập",
                                            type: "form",
                                            icon: "repeat",
                                            click: function () {
                                                app.router("/login");
                                            }
                                        }
                                    ]
                                },
                                {
                                    id: "version",
                                    //borderless: true,
                                    css: { "background": "#e6f7ff !important" },
                                    width: 200,
                                    view: "template",
                                    template: "<div class=''><p><b>Bước 1:</b></p><label> Quý khách hàng vui lòng nhập Email đăng ký tài khoản !</label> <br />"
                                    + "<p><b>Bước 2:</b></p><label> Đăng nhập tài khoản Email vừa nhập !</label></div>"
                                    + "<p><b>Bước 3:</b></p><label> Hệ thống của M-Invoice sẽ gửi mật khẩu mới cho Quý khách hàng. Quý khách hàng dùng mật khẩu đó để đăng nhập vào phần mềm !</label></div>"
                                }
                            ]
                        },
                        { gravity: 1, temlate: "" }
                    ]
                },
                { gravity: 1, template: "" }
            ]
        },

        $oninit: function () {
            $$("loginForm").focus();
        }
    };
});

define('views/searchinvoice',[
    "app",
    "views/forms/searchinvoice",
    "locale"
], function (app, searchForm, _) {
    'use strict';

    var op = [];

    webix.$$("title").parse({ title: "Tra cứu hóa đơn", details: "Hóa đơn đã lập" });

    var controls = [
        {
            id: "txtSearch",
            view: "search",
            align: "center",
            placeholder: _("SEARCH") + "..",
            width: 300,
            on: {
                onTimedKeyPress: function () {
                    var table = $$("tblSearch");

                    table.clearAll();
                    table.load(table.config.url);
                }
            }
        },
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-edit fa-lg" aria-hidden="true"></i> ' +
            '<span class="text">' + _("TIM_CHI_TIET") + '</span>',
            id: "btnEdit",
            // view: "button",
            // type: "icon",
            // css: "webix_secondary",
            // icon: " fas fa-edit",
            // label: _("TIM_CHI_TIET"),
            // width: 100,
            on: {
                onClick: function () {
                    var win = this.$scope.ui(searchForm.$ui);
                    searchForm.setValues($$("tblSearch").config.paramFilter);
                    win.show();
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-print fa-lg" aria-hidden="true"></i> ' +
            '<span class="text">' + _("PRINT") + " (F7)" + '</span>',
            id: "btnPrint",
            // view: "button",
            // type: "icon",
            // icon: "fas fa-print",
            // css: "webix_secondary",
            // label: _("PRINT"),
            // width: 65,
            shortcut: "F7",
            on: {
                onClick: function () {
                    var table = webix.$$("tblSearch");
                    var item = table.getSelectedItem();

                    if (item == null) {
                        webix.message("Bạn chưa chọn hóa đơn", "debug");
                        return;
                    }

                    var url = app.config.host + "/Invoice/Preview?id=" + item.inv_InvoiceAuth_id;

                    var box = webix.modalbox({
                        title: "Đang in hóa đơn",
                        text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                        width: 350,
                        height: 200
                    });

                    webix.ajax()
                        .response("arraybuffer")
                        .get(url, {
                            error: function (text, data, XmlHttpRequest) {
                                webix.modalbox.hide(box);
                                alert(text);
                            },
                            success: function (text, data, XmlHttpRequest) {
                                var file = new Blob([data], { type: 'application/pdf' });
                                var fileURL = URL.createObjectURL(file);

                                webix.modalbox.hide(box);
                                window.open(fileURL, '_blank');
                            }
                        });

                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {}

    ];

    var grid = {
        rows: [
            {
                id: "tblSearch",
                view: "datatable",
                select: true,
                datafetch: 100,
                url: {
                    $proxy: true,
                    load: function (view, callback, params) {
                        var url = app.config.host + "/Invoice/Search";
                        var item = {};

                        var txtSearch = $$("txtSearch");

                        var filter = {};

                        if (txtSearch !== undefined) {
                            var typingFilter = txtSearch.getValue();

                            if (typingFilter != "") {
                                filter.typingFilter = typingFilter;
                            }

                        }

                        if (view.config.paramFilter != null) {
                            filter.paramFilter = view.config.paramFilter;
                        }

                        if (params == null) {
                            item.start = 0;
                            item.count = view.config.datafetch;
                            item.continue = null;
                            item.filter = filter;
                        }
                        else {
                            item.start = params.start;
                            item.count = params.count;
                            item.continue = params.continue;
                            item.filter = filter;
                        }

                        webix.ajax()
                            .bind(view)
                            .headers({ 'Content-Type': 'application/json' })
                            .post(url, item, callback);

                    }
                },
                columns: [
                    { id: "mau_hd", header: _("MAU_HD"), width: 150 },
                    { id: "inv_invoiceSeries", header: _("KY_HIEU"), width: 120 },
                    { id: "inv_invoiceNumber", header: _("SO_HDON"), width: 120 },
                    { id: "inv_invoiceIssuedDate", header: _("NGAY_HDON"), width: 150 },
                    { id: "ma_dt", header: _("MA_DT"), width: 150 },
                    { id: "inv_buyerLegalName", header: _("TEN_DON_VI"), width: 250 },
                    { id: "inv_buyerDisplayName", header: _("TEN_NGUOI_MUA"), width: 250 }
                ],
                pager: "pagerA"

            },
            {
                cols: [
                    {
                        view: "icon", icon: "fas fa-question-circle", id: "help_form_views", tooltip: _("HELPER"),
                        css: "helper",
                        // click: function () {
                        //     this.callEvent("onClick");
                        // }
                        click: function () {
                            webix.alert({
                                title: "Thông báo !",
                                text: "Bạn chưa khai báo hướng dẫn nhanh cho màn hình này !",
                                type: "alert-warning",
                                callback: function (result) {
                                }
                            });
                        }
                    },
                    {
                        view: "combo",
                        label: _("MENU_QUICK"),
                        id: "QuickMenu1",
                        options: {
                            // view: "gridsuggest",
                            // id: "grid_window",
                            // template: "#name#",
                            // body: {
                            //     scroll: true,
                            //     autoheight: false,
                            //     columns: [
                            //         { id: "window_id", header: "Window Id", editor: "text", width: 100 },
                            //         { id: "name", header: "Window Name", editor: "text", width: 400 }
                            //     ],
                            //     url: app.config.host + "/System/GetQuickMenu"
                            // },
                            // on: {
                            //     onValueSuggest: function (obj) {
                            //         var start = obj.window_id != "" ? obj.code + ":" + obj.window_id : obj.code;
                            //         window.location.hash = "!/app/" + start;
                            //         $$("QuickMenu1").setValue(null);
                            //         $$("QuickMenu1").destructor();
                            //     }
                            // }
                        },
                        on: {
                            onChange: function (newv, oldv) {

                            }
                        }
                    },
                    {},
                    {
                        id: "pagerA",
                        view: "pager",
                        size: 50,
                        group: 5,
                        // animate: { direction:"top" },
                        template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}"
                    }
                ]
            }
        ]
    }

    var layout = {
        css: "frmView",
        rows: [
            {
                height: 39,
                css: "btnControl",
                view: "toolbar",
                margin: 0,
                borderless: true,
                cols: controls
            },
            {
                rows: [
                    grid
                ]
            }



        ]

    };

    return {
        $ui: layout,
        $oninit: function (view, $scope) {

            $$("tblSearch").config.paramFilter = {};

            $scope.on(app, "dataChanged", function (mode, item) {
                var table = webix.$$("tblSearch");
                table.config.paramFilter = item;

                table.clearAll();
                table.load(table.config.url);
            });
        }
    };
});
define('views/sqltool',[
    "app",
    "locale",
    "views/forms/sqltoolchoky"
], function (app, _, sqltoolchoky) {
    'use strict';

    webix.$$("title").parse({ title: "SQL Server Tool", details: "SQL Server Tool", url_help: "http://huongdansudung.minvoice.com.vn/" });

    return {
        $ui: {
            cols: [
                {
                    view: "list",
                    id: "lstSqltool",
                    select: true,
                    tooltip: function (obj) {
                        return moment(obj.date_new).format("DD/MM/YYYY") + " - " + obj.user_new;
                    },
                    on: {
                        onItemClick: function (id, e, node) {
                            var item = this.getItem(id);

                            $$("contentSQL").setHTML(item.update);
                            if (item.id == 1) {
                                var frm = this.$scope.ui(sqltoolchoky.$ui);
                                frm.show();
                            }
                            if (item.id == 2) {
                                webix.confirm({
                                    text: "Bạn có chắc chắn xóa bản quyền không?", ok: "Có", cancel: "Không",
                                    callback: function (res) {
                                        if (res) {
                                            // webix.ajax()
                                            //     .header({ 'Content-type': 'application/json' })
                                            //     .get(url, function (text) {

                                            //     })
                                            var url = app.config.host + "/Invoice/DeleteLicense";
                                            var xhr = webix.ajax().sync().get(url);
                                            var obj = JSON.parse(xhr.response);
                                            if (!obj.hasOwnProperty("error")) {
                                                webix.message("Xóa bản quyền thành công !", "success");
                                            }
                                            else {
                                                webix.message(obj.error, "error");
                                            }
                                        }
                                    }
                                });
                            }
                            //webix.message(id, "error");
                            // $$("notification-win").getHead().setHTML("Thông tin bản cập nhật: " + item.version);
                        }
                    },
                    //url: app.config.host + "/System/GetAllFloderUpdate",
                    data: [
                        { id: 1, des: "Đưa hóa đơn về chờ ký", update: "Chuyển trạng thái của 1 hóa đơn bất kỳ về trạng thái chờ ký", date_new: "2019-12-14", user_new: "NAMPV" },
                        { id: 2, des: "Xóa bản quyền", update: "Xóa bản quyền sử dụng phần mềm hóa đơn", personId: 2, user_new: "NAMPV" },
                        { id: 3, des: "....", update: "Lorem ipsum dolor sit amet", date_new: "2019-12-14", user_new: "NAMPV" },
                        { id: 4, des: "....", update: "Morbi eget facilisis risus", date_new: "2019-12-14", user_new: "NAMPV" },
                        { id: 5, des: "....", update: "Cras lacinia bibendum arcu", date_new: "2019-12-14", user_new: "NAMPV" }
                    ],
                    template: function (item) {
                        if (item.trang_thai == true) {
                            return "- " + item.des + " <span style='color: #00b300'><i class='fas fa-check'></i></span>"
                        }
                        else {
                            return "- " + item.des + " <span style='color: red'><i class='fas fa-times'></i></span>"
                        }
                    },
                    //ptemplate: "<span class='webix_icon fa-user'></span> <span class='rowBold'>#User# </span>",
                    width: 250
                },
                {
                    // width: 900,
                    paddingX: 5,
                    rows: [
                        {
                            view: "template", id: "contentSQL", scroll: "xy",
                            // , gravity: 3
                            type: { height: "auto" },
                            // template: function (obj) {
                            //     return "<span " + (obj.user == user.getCurrentUser() ? "class='rowBold'" : "class='rowBoldGreen'") + ">" + obj.user + "</span> " + obj.value;
                            // }
                        },
                        { view: "label", label: "SQL Query" },
                        { view: "textarea", id: "query", value: "SELECT * FROM inv_InvoiceAuth" },
                        {
                            paddingY: 5,
                            cols: [
                                {},
                                // {
                                //     view: "button", value: "Cập nhật", width: 100, type: "danger",
                                //     click: function () {
                                //     }
                                // },
                                {
                                    view: "button", type: "form", label: "Thực hiện (F10)", shortcut: "F10", align: "center",
                                    on: {
                                        onClick: function () {
                                            webix.message("Dừng lại ở đây thôi !", "success");
                                            //     var form = webix.$$("contentSQL");

                                            //     var item = $$("lstSqltool").getSelectedItem();
                                            //     if (item == undefined || item == null) {
                                            //         webix.message("Bạn chưa chọn versison cập nhật !", "error");
                                            //         return;
                                            //     }
                                            //     else {
                                            //         if (item.trang_thai == true) {
                                            //             webix.message("Version này đã được cập nhật ! Bạn không thể cập nhật thêm !", "error");
                                            //             return
                                            //         }
                                            //         else {
                                            //             // console.log(id);
                                            //             webix.confirm({
                                            //                 title: "Cập nhật phần mềm",
                                            //                 text: "Bạn có muốn cập nhật phần mềm ", ok: "Có", cancel: "Không",
                                            //                 callback: function (res) {
                                            //                     if (res) {
                                            //                         var box = webix.modalbox({
                                            //                             title: "Đang tải cập nhật",
                                            //                             buttons: ["Hủy bỏ"],
                                            //                             text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                                            //                             width: 350,
                                            //                             height: 200,
                                            //                             callback: function (result) {
                                            //                                 switch (result) {
                                            //                                     case "0":
                                            //                                         clearTimeout(interVal);
                                            //                                         webix.modalbox.hide(box);
                                            //                                         break;
                                            //                                 }
                                            //                             }
                                            //                         });
                                            //                         var interVal = setTimeout(function () {

                                            //                             webix.ajax()
                                            //                                 .headers({ 'contentSQL-type': 'application/json' })
                                            //                                 .post(app.config.host + "/System/UpdateVersionManual", item, function (text) {
                                            //                                     var data = JSON.parse(text);
                                            //                                     if (!data.hasOwnProperty("error")) {
                                            //                                         webix.modalbox.hide(box);
                                            //                                         clearTimeout(interVal);

                                            //                                         webix.message("Cập nhật thành công !", "debug");
                                            //                                     }
                                            //                                     else {
                                            //                                         webix.modalbox.hide(box);
                                            //                                         clearTimeout(interVal);
                                            //                                         webix.message(data.error, "error");
                                            //                                     }
                                            //                                 });

                                            //                         }, 3000);
                                            //                     }
                                            //                 }
                                            //             });
                                            //         }
                                            //     }
                                        }
                                    },
                                    click: function () {
                                        this.callEvent("onClick");
                                    }
                                },
                                {}
                            ]
                        }
                    ]
                }
            ]
        }
    };
});
define('views/templatewindow',[
    "app",
    "views/forms/templatewindow",
    "views/forms/infowindow",
	"locale"
], function(app,windowform,infowindow,_) {
    'use strict';
	
	var layoutId = "";
	var col = [];
	var sub_col = [];
    var windowconfig = null;
    var buttons = [];
	//var windowno = "":
	
	var initUI = function(){
		var windowno = app.path[1].params[0];
		
		col = [];		
        sub_col = [];
        
        var query = "SELECT TOP 1 * FROM WB_MENU WHERE WINDOW_ID='"+ windowno +"'";

        var url = app.config.host + "/System/ExecuteQuery?sql=" + query;

        webix.ajax(url,function(text){
            var json = JSON.parse(text);

            if (json.length>0){
                webix.$$("title").parse({title: json[0]["name"], details: json[0]["details"]});
            }
        });

        /* query = "SELECT CODE as id,NAME as value FROM VC_MAUIN WHERE WINDOW_ID='"+ windowno +"'";
        url = app.config.host + "/api/System/ExecuteQuery?sql=" + query;

        webix.ajax(url,function(text){
            var json = JSON.parse(text);

            if (json.length>0){
                $$("cbMauIn").define("options",json);
                $$("cbMauIn").setValue(json[0].id);
                $$("cbMauIn").show();
                $$("btnPrint").show();                
            }
            else {
                 $$("cbMauIn").define("options",[]);
                 $$("cbMauIn").hide();
                 $$("btnPrint").hide();
            }

            $$("cbMauIn").refresh();
        }); */

        url = app.config.host + "/System/ExecuteCommand";

        webix.ajax()
            .headers({'Content-type':'application/json'})
            .post(url,
                    { 
                        command : "CM00002", 
                        parameter: {
                            window_id: windowno
                        }
                    },function(text){
            var json = JSON.parse(text);

            if (buttons.length>0){
                for(var i=0;i<buttons.length;i++){
                    var item = buttons[i];
                    $$("tlbMain").removeView(item.id);
                }                
            }

            buttons = [];

            for(var i=0;i<json.length;i++){
                var item = json[i];

                var fn = new Function(item.on_click);

                var button = {
                    id: item.name,
                    label: _(item.caption),
                    view: "button", 
                    type: "icon", 
                    icon: item.icon, 
                    width: item.width,
                    click: fn                  
                };

                buttons.push(button);
                $$("tlbMain").addView(button,6);

            }

            
        });

		
		url = app.config.host + "/System/GetConfigWinByNo?id="+windowno ;
		
		webix.$$("windowData").getParentView().getParentView().getParentView().disable();
        webix.$$("windowData").getParentView().getParentView().getParentView().showProgress();
		
		webix.ajax(url, function (text, xml, xhr) {

			var rp = JSON.parse(text);
			windowconfig = rp;
			//console.log(Object.keys(rp).length);
            var k= Object.keys(rp['data'][0]['Tabs']).length;
            var vc_window = rp["data"][0];
            var tabs = vc_window.Tabs;

            if (vc_window.window_type == "MasterDetail"){
                col.push({
                    id: "subRow",
                    header: "&nbsp;",
                    template:"{common.subrow()}",
                    width:40
                });
            }

            var masterTab = tabs[0];

			for (var j = 0; j < masterTab.Fields.length; j++) {

                var field = masterTab.Fields[j];

				if(field.hide_in_grid==true){
					continue;
				}			
				
				var item = {
					id: field.column_name, 
                    header: _(field.column_name) ,
                    columnType: field.column_type					
                };
                
                if (field.caption!=null){
                    item.header = _(field.caption);
                }
				
				if (field.column_type == "decimal" ){
					item.css = { "text-align" : "right" };
					item.format = webix.Number.numToStr({
                            groupDelimiter:",",
                            groupSize:3,
                            decimalDelimiter:".",
                            decimalSize:0
                        });
                }
                    
                if (field.type_filter!=null){
                    if (field.type_filter!=""){
                        item.header = [_(field.column_name), { content: field.type_filter}]
                    }
                }
				
				if (field.type_filter == "combo"){
					item.editor = field.type_editor;
					item.options = app.config.host + "/api/System/GetDataByReferencesId?id=" + field.ref_id;
                }
                
                if (field.column_type == "date" || field.column_type == "datetime"){
                    item.format = function(text) {
                        var format = webix.Date.dateToStr("%d/%m/%Y");
                        text = removeTimeZoneT(text);                            
                        return format(text);
                    };
                }
				
				if (field.column_width == null){
					item.fillspace = true;
				}
				else {
					item.width = field.column_width;
				}
				
				col.push(item);
			}
			
			var table = $$("windowData");
			table.clearAll();			
            
            if (vc_window.window_type == "MasterDetail"){               

                var cells = [];

                for(var i=0;i<tabs.length;i++){
                    var tab = tabs[i];

                    if (tab.tab_type == "Master"){
                        continue;
                    }

                    var subCols = [];

                    for(var j=0;j<tab.Fields.length;j++){
                        var field = tab.Fields[j];

                        if (field.hide_in_grid == true){
                            continue;
                        }

                        var subCol = {
                            id: field.column_name, 
                            header: field.caption == null ? _(field.column_name) : _(field.caption),
                            hidden: field.hide_in_grid
                        };

                        if (field.column_type == "date" || field.column_type == "datetime"){
                            subCol.format = function(text) {
                                var format = webix.Date.dateToStr("%d/%m/%Y");
                                text = removeTimeZoneT(text);                            
                                return format(text);
                            };
                        }

                        if (field.column_type == "decimal"){
							subCol.css = { "text-align": "right" };
							subCol.format = webix.Number.numToStr({
												groupDelimiter:",",
												groupSize:3,
												decimalDelimiter:".",
												decimalSize:0
											});
						}
                        
                        if (field.column_width == null){
                            subCol.fillspace = true;
                        }
                        else {
                            subCol.width = field.column_width;
                        }
                        
                        subCols.push(subCol);
                    }

                    if (tab.tab_type=="Detail"){
                        var item = {
                            header: tab.tab_name,
                            select: "cell",
                            body: {
                                view: "datatable",
                                tab_table: tab.tab_table,
                                columns: subCols,
                                on:{
                                    onBeforeLoad:function(){
                                        this.showOverlay(_("LOADING")+"...");
                                    },
                                    onAfterLoad:function(){
                                        this.hideOverlay();
                                    }
                                }
                            }
                        };

                        cells.push(item);
                    }
                }

                var subview = {
                    borderless:true,
                    view:"tabview",
                    height:200,
                    scrollX:true,
                    cells:cells,
                    multiview: {
                        fitBiggest:true
                    }
                };

                table.define("subview",subview);                
            }

            table.define("windowno", windowno);
            
            table.config.infoparam = null ;
            table.config.columns = col;
            table.config.ma_ct = vc_window.ma_ct;

            table.refreshColumns();	

            var parentToolBar = $$("tlbMain").getParentView();
            parentToolBar.removeView("tlbParams");

            if (vc_window.WinParams !== undefined){

                var toolBarParams = {
                    id:"tlbParams",
                    view: "toolbar",
                    height: 35,
                    cols:[]
                }
                
                for(var i=0;i<vc_window.WinParams.length;i++){
                    var item=vc_window.WinParams[i];

                    var comp = {
                        view: item.type_editor,
                        width: item.width,
                        label: _(item.caption),
                        value_field: item.value_field,
                        on:{}
                    };

                    if (comp.view == "combo"){
                        comp.options = app.config.host + "/System/GetDataByReferencesId?id=" + item.ref_id;
                        
					    comp.on.onChange = function(newv,oldv){
							var table = $$("windowData");                            
                            table.clearAll();
                            table.load(table.config.url);
						}
				
                    }

                    toolBarParams.cols.push(comp);

                }

                parentToolBar.addView(toolBarParams);
            }
            
            var url = {
                    $proxy:true,
                    load:function(view, callback, params){                        
                        var windowno = app.path[1].params[0];
                        var url = app.config.host + "/System/GetDataByWindowNo?window_id="+windowno;                        

                        if (params==null){
                            url = url + "&start=0&count="+view.config.datafetch + "&continue=null&filter=null" ;                               
                        }
                        else {
                            url = url + "&start="+params.start+"&count="+params.count + "&continue=" + params.continue;
                            
                            if (params.filter!=null){
                                var array=[];

                                for(var property in params.filter){

                                    var column = view.getColumnConfig(property);

                                    if (column !== undefined){
                                         var item = {
                                            columnName : property,
                                            columnType : column.columnType,
                                            value: params.filter[property]
                                        };

                                        array.push(item);
                                    }
                                    
                                   
                                }

                                //console.log(JSON.stringify(array));
                                if (array.length>0){
                                    url = url + "&filter=" +JSON.stringify(array);
                                }
                                else {
                                    url = url + "&filter=null";
                                }
                                
                            }
                            else {
                                 url = url + "&filter=null";
                            }                                
                        }

                        if (view.config.infoparam!=null){
                            url = url + "&infoparam=" + JSON.stringify(view.config.infoparam);
                        }
                        else {
                            url = url + "&infoparam=null";
                        }

                        var tlbParams = $$("tlbParams");

                        if (tlbParams!== undefined){
                            var childViews = tlbParams.getChildViews();

                            var parameters = [];

                            for(var i=0;i< childViews.length;i++){
                                var child = childViews[i];

                                var id = child.config.id;
                                var value_field = child.config.value_field;

                                var item = {
                                    columnName: value_field,
                                    value: $$(id).getValue()
                                };
                               
                                parameters.push(item);
                            }

                            url = url + "&tlbparam=" + JSON.stringify(parameters);

                        }
                        else {
                            url = url + "&tlbparam=null" ;
                        }
                        
                        console.log(url);

                        webix.ajax(url, callback, view);
                        
                    }
            };
            
            table.define("url", url );

            if (vc_window.vc_infowindow_id!=null){
                if (vc_window.vc_infowindow_id!=""){
                    $$("btnSearch").show();
                    table.config.infowindow_id = vc_window.vc_infowindow_id;
                }
                else {
                    $$("btnSearch").hide();
                    table.config.infowindow_id = null;
                }
            }
            else {
                $$("btnSearch").hide();
                table.config.infowindow_id = null;
            }

            
            

			webix.$$("windowData").getParentView().getParentView().getParentView().enable();
			webix.$$("windowData").getParentView().getParentView().getParentView().hideProgress();

		});
	};
	

    var controls = [
        { 
            id: "btnPlus",
            view: "button", 
            type: "icon", 
            icon:"plus", 
            label: "Thêm" ,
            width:65,
            shortcut: "F4",
            //css:"button_raised",
            on:{
                onClick: function(){
                    var vc_window = windowconfig["data"][0];
                    windowform.$ui.id = vc_window.window_id;

                    var detailForm = this.$scope.ui(windowform.$ui);            
                    
                    windowform.initUI(windowconfig);
                    windowform.setEditMode(1);

                    var params = null;

                    var tlbParams = $$("tlbParams");

                    if (tlbParams!== undefined){
                        var childViews = tlbParams.getChildViews();

                        var item = [];

                        for(var i=0;i< childViews.length;i++){
                            var child = childViews[i];

                            var id = child.config.id;
                            var value_field = child.config.value_field;

                            item[value_field] = $$(id).getValue();                            
                           
                        }

                        params = item;

                    }
                    

                    windowform.setValues(null,windowconfig,params);
                    
                    detailForm.show();
                    windowform.focusFirstElement();

                    if (vc_window.after_new!=null){
                        var fn = Function("app",vc_window.after_new);
                        fn(app);
                    }
                }
            },
            click: function(){
                this.callEvent("onClick");                
            }
        },
        { 
            id: "btnEdit",
            view: "button", 
            type: "icon", 
            icon:"edit", 
            label: "Sửa" ,
            width:55,
            shortcut: "F3",
            //css:"button_raised",
            on: {
                onClick: function(){
                    var vc_window = windowconfig["data"][0];
                    windowform.$ui.id = vc_window.window_id;

                    var detailForm = this.$scope.ui(windowform.$ui);
                
                    var table = webix.$$("windowData");
                    var item = table.getSelectedItem();                
                    
                    windowform.initUI(windowconfig);
                    windowform.setEditMode(2);
                    windowform.setValues(item,windowconfig);
                    
                    detailForm.show();
                    windowform.focusFirstElement();
                }
            },
            click: function(){                
                this.callEvent("onClick");
            }
        },
        { 
            id: "btnDelete", 
            view: "button", 
            type: "icon", 
            icon:"trash-o", 
            label: "Xóa" ,
            width:55,
            shortcut: "F8",
            //css:"button_raised",
            on: {
                onClick: function(){
                    var table = webix.$$("windowData");
                    var item = table.getSelectedItem();

                    var khData={};
                    khData.windowid=windowconfig.data[0].window_id;
                    khData.editmode=3;
                    khData.data=[];
                    khData.data.push(item);
                    
                    webix.confirm({
                        text:"Bạn có muốn xóa ", ok:"Có", cancel:"Không",
                        callback:function(res){
                            if(res){
                                webix.ajax()
                                .headers({'Content-type':'application/json'})
                                .post( app.config.host + "/System/Save", khData , function(text){
                                    if (text.hasOwnProperty("error")){
                                        webix.message(text.error);
                                        return;
                                    }
                                    
                                    table.remove(item.id);

                                });
                                
                            }
                        }
                    });
                }
            },
            click: function(){               
                this.callEvent("onClick");
            }
        },
        { 
            id: "btnCopy", 
            view: "button", 
            type: "icon", 
            icon:"files-o", 
            label: _("COPY") ,
            width:85,
            on: {
                onClick: function(){
                    var table = webix.$$("windowData");
                    var item = table.getSelectedItem();

                    if (item == null){
                        webix.message("Bạn chưa chọn dòng dữ liệu");
                        return;
                    }

                    var vc_window = windowconfig["data"][0];
                    windowform.$ui.id = vc_window.window_id;

                    var detailForm = this.$scope.ui(windowform.$ui);            
                    
                    windowform.initUI(windowconfig);
                    windowform.setEditMode(1);
                    windowform.copyValues(item,windowconfig);
                    
                    detailForm.show();
                    windowform.focusFirstElement();

                    if (vc_window.after_new!=null){
                        var fn = Function(vc_window.after_new);
                        fn();
                    }

                    
                }
            },
            click: function(){               
                this.callEvent("onClick");
            }
        },
        { 
            id: "btnSearch", 
            view: "button", 
            type: "icon", 
            icon:"search", 
            label: _("SEARCH") ,
            width:85,
            shortcut: "F2",
            on: {
                onClick: function(){
                    var table = webix.$$("windowData");
                    
                    infowindow.$ui.id = table.config.infowindow_id;
                    infowindow.$ui.load_event = "filterTable";                      

                    var wininfoparam = this.$scope.ui(infowindow.$ui);

                    infowindow.initUI(table.config.infowindow_id);              
                    wininfoparam.show();
                }
            },
            click: function(){               
                this.callEvent("onClick");
            }
        },
        { 
            id: "btnPrint", 
            view: "button", 
            type: "icon", 
            icon:"print", 
            label: _("PRINT") ,
            width:40,
            shortcut: "F7",
            on: {
                onClick: function(){
                    var table = webix.$$("windowData");
                    var item = table.getSelectedItem();

                    if (item == null) {
                        webix.message("Bạn chưa chọn dữ liệu cần in");
                        return;
                    }

                    var cbMauIn = $$("cbMauIn");

                    var rpParameter = {
                        parameter : item,
                        CODE: cbMauIn.getValue()
                    };

                    var url = app.config.host + "/api/System/InChungTu" ;

                    webix.ajax()
                        .response("arraybuffer")
                        .headers({'Content-type':'application/json'})
                        .post(url, rpParameter, function(text, data){
                        var file = new Blob([data], {type: 'application/pdf'});
                        var fileURL = URL.createObjectURL(file);
                        window.open(fileURL,'_blank');
                    });
                    
                }
            },
            click: function(){               
                this.callEvent("onClick");
            }
        },
        {},
        {
            view:"richselect",
            label:_("MAUIN"),
            width:250,
            labelWidth:50,
            id:"cbMauIn"
        }
    ]    
    
    var grid = {
        rows:[
            {
                id : "windowData",
                view: "datatable", 
                select: true,
                datafetch: 50,
                columns: col ,
                on:{
                    onSubViewCreate:function(view, item){
                        var subView = view;

                        if (subView!=null){
                            var windowno = app.path[1].params[0];

                            var url = app.config.host + "/System/GetDataDetailsByTabTable?window_id="+ windowno
                                    +"&id="+item.id;
                            
                            var detailTables = subView.getChildViews()[1].getChildViews();

                            for(var i=0;i<detailTables.length;i++){
                                var dt = detailTables[i];
                                dt.clearAll();
                                dt.load(url + "&tab_table="+dt.config.tab_table);
                            }                         
                        }

                    },
                    onSubViewOpen: function(id){
                        var table = this;
                        var subView = table.getSubView(id);
                        
                        if (subView!=null){
                            var windowno = app.path[1].params[0];

                            var url = app.config.host + "/System/GetDataDetailsByTabTable?window_id="+ windowno
                                    +"&id="+id.row;
                            
                            var detailTables = subView.getChildViews()[1].getChildViews();

                            for(var i=0;i<detailTables.length;i++){
                                var dt = detailTables[i];
                                dt.clearAll();
                                dt.load(url + "&tab_table="+dt.config.tab_table);
                            }                         
                        }
                    },
                    onItemDblClick: function(id, e, node){
                        var btnEdit = $$("btnEdit");
                        btnEdit.callEvent("onClick");
                    }
                },
                subview: {
                    borderless:true,
                    view:"tabview",
                    height:200,
                    scrollX:true,
                    tabbar:{
						width:200
					},
                    cells:[]
                },
                pager:"pagerA"                                        
            },
            {
                id: "pagerA",
                view:"pager",
                size: 50,
                group: 5,
                template:"{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}"
            }
        ]
    }

    var layout = {		
		rows:[
			{
                rows:[
                    {
                        id:"tlbMain",
                        height:35,
                        type: "toolbar",
                        cols:controls 
                    }                    
                ]                                                          
			},
			{
				rows:[
					grid					
				]
			}



		]

    };
    
    return {
        $ui: layout,
        $oninit: function(view,$scope) {
			
			webix.extend(view, webix.ProgressBar);
			
			
            $scope.on(app, "dataChanged", function(mode,item){
				
                var table = webix.$$("windowData");

                if (mode == 1){
                    table.add(item);
                    //table.select(item.id,false);
                }

                if (mode == 2){
                    var selectedItem = table.getSelectedItem();
                    table.updateItem(selectedItem.id,item);

                    webix.UIManager.setFocus($$(table.config.id));
                }
                
            });

            $scope.on(app, "filterTable", function(report_id,infoWindowId,item){				
                var table = $$("windowData");
 
                /* if (item.hasOwnProperty("p_MA_CT")){
                    item["p_MA_CT"] = table.config.ma_ct;
                } */

                var infoparam = {
                    infowindow_id : infoWindowId,
                    parameter : item                    
                };

                table.config.infoparam = infoparam;
                table.clearAll();
                table.load(table.config.url);                
            });
        },
		$onurlchange:function(ui, name, url, scope){
			initUI();
		}
	};
});
define('views/tinhhinhsudung',[
    "app",
    "views/forms/dmwindow",
    "locale",
    "models/user",
    "views/forms/tinhhinhsudung"
], function (app, dmwindowform, _, user, tinhhinhsudungform) {
    'use strict';

    var op = [];
   
    var controls = [
        {},
        {
            id: "btnSave",
            view: "button",
            type: "danger",
            icon: "save",
            label: "Nhận (F10)",
            width: 85,
            shortcut: "F10",
            on: {
                onClick: function () {
                    // var form = webix.$$("tinhhinhsudung");
                    // var item = form.getValues();
                    // webix.extend(form, webix.ProgressBar);
                    // form.disable();
                    // form.showProgress();
                    // webix.ajax()
                    //     .headers({ 'Content-type': 'application/json' })
                    //     .post(app.config.host + "/Bcthsd/Check_xulyHD", item, function (text) {
                    //         var data = JSON.parse(text);

                    //         if (!data.hasOwnProperty("error")) {
                    webix.$$('btnshow').callEvent("onClick");

                    //     }
                    //     else {
                    //         webix.message(data.error, "error");


                    //     }
                    //     form.enable();
                    //     form.hideProgress();
                    // });

                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {
            id: "btnshow",
            view: "button",
            type: "icon",
            icon: "save",
            label: "Nhận",
            hidden: true,
            width: 65,
            shortcut: "F11",
            on: {
                onClick: function () {

                    var form = webix.$$("tinhhinhsudung");
                    var item = form.getValues();
                    var win = this.$scope.ui(tinhhinhsudungform.$ui);
                    if (item.hasOwnProperty("quy")) {
                        item.thang = item.quy;
                    }
                    tinhhinhsudungform.initUI(item);
                    win.show();
                },
                click: function () {
                    this.callEvent("onClick");
                }
            }
        },
        {}
    ];

    var thang = webix.Date.dateToStr("%n");
    var thangcb = thang(new Date());
    var nam = webix.Date.dateToStr("%Y");
    var cbnam = nam(new Date());

    var date = new Date();
    var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
    var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);

    var layout = {
        // paddingY: 60,
        // paddingX: 500,
        cols: [
            { gravity: 0.5, template: "" },
            {
                rows: [
                    { gravity: 1, template: "" },
                    {
                        view: "form",
                        id: "tinhhinhsudung",
                        paddingY: 10,
                        // width: 700,
                        // height:300,
                        position: "center",
                        paddingX: 10,
                        complexData: true,
                        margin: 0,
                        elements: [
                            {
                                cols: [
                                    {
                                        id: "tkThang",
                                        name: "tokhai_thang",
                                        view: "checkbox",
                                        value: 1,
                                        label: "Tờ khai tháng",
                                        labelWidth: 100
                                    },
                                    {
                                        id: "tkQuy",
                                        name: "tokhai_quy",
                                        view: "checkbox",
                                        label: "Tờ khai quý",
                                        labelWidth: 100
                                    }
                                ]
                            },
                            {
                                cols: [
                                    {
                                        id: "cbThang",
                                        name: "thang",
                                        view: "combo",
                                        label: "Tháng",
                                        value: thangcb,
                                        options: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"]
                                    },
                                    {
                                        id: "cbNam",
                                        name: "nam",
                                        view: "text",
                                        value: cbnam,
                                        label: "Năm"
                                    }
                                ]
                            },
                            {
                                cols: [
                                    {
                                        id: "cbTungay",
                                        view: "datepicker",
                                        name: "tu_ngay",

                                        label: "Từ ngày"

                                    },
                                    {
                                        id: "cbDenngay",
                                        view: "datepicker",
                                        name: "den_ngay",

                                        label: "Đến ngày"
                                    }
                                ]
                            },
                            {
                                view: "fieldset",
                                label: "Chọn phụ lục kê khai",
                                body: {
                                    rows: [
                                        {
                                            view: "checkbox",
                                            id: "mau312",
                                            name: "mau_312",
                                            label: "Mẫu 3.12(Kỳ báo cáo cuối cùng)",
                                            labelWidth: 200
                                        },
                                        {
                                            view: "checkbox",
                                            id: "mau310",
                                            name: "mau_310",
                                            label: "Mẫu 3.10(Chuyển địa điểm)",
                                            labelWidth: 200
                                        },
                                    ]
                                }
                            },
                            {
                                id: "bcSoluong",
                                name: "bc_soluong",
                                view: "checkbox",
                                label: "Báo cáo theo số lượng hóa đơn",
                                labelWidth: 210
                            },
                            // {
                            //     view: "template",
                            //     template: "<hr class='ahii2'>"
                            //    // type: "section"
                            // },
                            {
                                margin: 10,
                                cols: controls

                            }

                        ]
                    },
                    { gravity: 5, template: "" }
                ]
            },
            { gravity: 0.5, template: "" }
        ]

    };

    function subview(config) {
        webix.ui(config, $$('tinhhinhsudung').getChildViews()[1].getChildViews()[0]);
    }

    var d = new Date();
    var quarter = Math.floor((d.getMonth() / 3));
    var quarter1 = quarter + 1;
    var firstDate = new Date(d.getFullYear(), quarter * 3, 1);
    var lastDate = new Date(firstDate.getFullYear(), firstDate.getMonth() + 3, 0)

    return {
        $ui: layout,
        $oninit: function (view, $scope) {
            var year = $$("cbNam").getValue();
            var month = $$("cbThang").getValue();
            var date1 = month + "/01" + "/" + year;

            var date = new Date(date1);
            var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
            var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
            $$("cbTungay").setValue(firstDay);
            $$("cbDenngay").setValue(lastDay);
            var tkQuy = $$("tkQuy").getValue();

            $$("tkThang").attachEvent("onChange", function (newv, oldv) {
                if (newv == 1) {
                    $$("tkQuy").setValue(0);
                    $$("tkThang").setValue(1);

                    subview({
                        id: "cbThang",
                        name: "thang",
                        view: "combo",
                        label: "Tháng",
                        value: thangcb,
                        options: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"]
                    });
                    var ssk = $$('tinhhinhsudung').getChildViews()[1].getChildViews()[0];
                    ssk.define("id", "cbThang");

                    $$("cbThang").attachEvent("onChange", function (newv, oldv) {
                        var year = $$("cbNam").getValue();
                        var month = $$("cbThang").getValue();
                        var date1 = month + "/01" + "/" + year;

                        var date = new Date(date1);
                        var firstDay1 = new Date(date.getFullYear(), date.getMonth(), 1);

                        var lastDay1 = new Date(date.getFullYear(), date.getMonth() + 1, 0);
                        $$("cbTungay").setValue(firstDay1);
                        $$("cbTungay").refresh();
                        $$("cbDenngay").setValue(lastDay1);
                        $$("cbDenngay").refresh();
                    });
                    $$("cbNam").attachEvent("onChange", function (newv, oldv) {
                        var year2 = $$("cbNam").getValue();
                        var month2 = $$("cbThang").getValue();
                        var date1 = month2 + "/01" + "/" + year2;

                        var date2 = new Date(date1);
                        var firstDay2 = new Date(date2.getFullYear(), date2.getMonth(), 1);

                        var lastDay2 = new Date(date2.getFullYear(), date2.getMonth() + 1, 0);
                        $$("cbTungay").setValue(firstDay2);
                        $$("cbTungay").refresh();
                        $$("cbDenngay").setValue(lastDay2);
                        $$("cbDenngay").refresh();
                    });
                    var year = $$("cbNam").getValue();
                    var month = $$("cbThang").getValue();
                    var date1 = month + "/01" + "/" + year;

                    var date = new Date(date1);
                    var firstDay1 = new Date(date.getFullYear(), date.getMonth(), 1);

                    var lastDay1 = new Date(date.getFullYear(), date.getMonth() + 1, 0);
                    $$("cbTungay").setValue(firstDay1);
                    $$("cbTungay").refresh();
                    $$("cbDenngay").setValue(lastDay1);
                    $$("cbDenngay").refresh();
                }
                // webix.message("value cũ : "+oldv+" Mới: "+newv);
            });

            $$("tkQuy").attachEvent("onChange", function (newv, oldv) {
                if (newv == 1) {
                    $$("tkThang").setValue(0);

                    subview({
                        id: "cbQuy",
                        name: "quy",
                        view: "combo",
                        label: "Quý",
                        value: quarter1,
                        options: ["1", "2", "3", "4"]
                    });


                    var ssk = $$('tinhhinhsudung').getChildViews()[1].getChildViews()[0];
                    ssk.define("id", "cbQuy");

                    $$("cbQuy").attachEvent("onChange", function (newv, oldv) {
                        var quy = $$("cbQuy").getValue();
                        //console.log(quy);
                        var nam = $$("cbNam").getValue();
                        var thang;
                        if (quy == 1) {
                            thang = 0;
                        }
                        if (quy == 2) {
                            thang = 3;
                        }
                        if (quy == 3) {
                            thang = 6
                        }
                        if (quy == 4) {
                            thang = 9
                        }
                        var firstDate = new Date(nam, thang, 1);
                        var lastDate = new Date(nam, thang + 3, 0);

                        $$("cbTungay").setValue(firstDate);
                        $$("cbTungay").refresh();
                        $$("cbDenngay").setValue(lastDate);
                        $$("cbDenngay").refresh();
                    });

                    var quy = $$("cbQuy").getValue();
                    var nam = $$("cbNam").getValue();
                    var thang;
                    if (quy == 1) {
                        thang = 0;
                    }
                    if (quy == 2) {
                        thang = 3;
                    }
                    if (quy == 3) {
                        thang = 6
                    }
                    if (quy == 4) {
                        thang = 9
                    }
                    var firstDate = new Date(nam, thang, 1);
                    var lastDate = new Date(nam, thang + 3, 0);

                    $$("cbTungay").setValue(firstDate);
                    $$("cbTungay").refresh();
                    $$("cbDenngay").setValue(lastDate);
                    $$("cbDenngay").refresh();

                }

            });

            $$("cbThang").attachEvent("onChange", function (newv, oldv) {
                var year = $$("cbNam").getValue();
                var month = $$("cbThang").getValue();
                var date1 = month + "/01" + "/" + year;

                var date = new Date(date1);
                var firstDay1 = new Date(date.getFullYear(), date.getMonth(), 1);

                var lastDay1 = new Date(date.getFullYear(), date.getMonth() + 1, 0);
                $$("cbTungay").setValue(firstDay1);
                $$("cbTungay").refresh();
                $$("cbDenngay").setValue(lastDay1);
                $$("cbDenngay").refresh();
            });

            $$("cbNam").attachEvent("onChange", function (newv, oldv) {

                if ($$("tkThang").getValue() == 1) {
                    var year2 = $$("cbNam").getValue();
                    var month2 = $$("cbThang").getValue();
                    var date1 = month2 + "/01" + "/" + year2;

                    var date2 = new Date(date1);
                    var firstDay2 = new Date(date2.getFullYear(), date2.getMonth(), 1);

                    var lastDay2 = new Date(date2.getFullYear(), date2.getMonth() + 1, 0);
                    $$("cbTungay").setValue(firstDay2);
                    $$("cbTungay").refresh();
                    $$("cbDenngay").setValue(lastDay2);
                    $$("cbDenngay").refresh();
                }
                if ($$("tkQuy").getValue() == 1) {
                    var quy = $$("cbQuy").getValue();
                    //console.log(quy);
                    var nam = $$("cbNam").getValue();
                    var thang;
                    if (quy == 1) {
                        thang = 0;
                    }
                    if (quy == 2) {
                        thang = 3;
                    }
                    if (quy == 3) {
                        thang = 6
                    }
                    if (quy == 4) {
                        thang = 9
                    }
                    var firstDate = new Date(nam, thang, 1);
                    var lastDate = new Date(nam, thang + 3, 0);

                    $$("cbTungay").setValue(firstDate);
                    $$("cbTungay").refresh();
                    $$("cbDenngay").setValue(lastDate);
                    $$("cbDenngay").refresh();
                }
            });

            $$("mau312").attachEvent("onChange", function (newv, oldv) {
                if (newv == 1) {
                    $$("mau310").setValue(0);
                }

            });

            $$("mau310").attachEvent("onChange", function (newv, oldv) {
                if (newv == 1) {
                    $$("mau312").setValue(0);
                }

            });
        }
    };
});
define('views/token',[
    "app",
    "views/forms/token",
    "locale"
], function (app, dmwindowform, _) {
    'use strict';

    var op = [];

    webix.$$("title").parse({ title: _("Hệ thống > Đăng ký chữ ký số > Đăng ký chứng thư số server"), details: _("DSTK") });

    var controls = [
        // {
        //     id: "btnRefrescacash",
        //     view: "button",
        //     type: "icon",
        //     icon: "refresh",
        //     label: _("Tải báo cáo"),
        //     width: 90,
        //     // shortcut: "F4",
        //     //css:"button_raised",
        //     on: {
        //         onClick: function () {
        //             var box = webix.modalbox({
        //                 title: "Đang tải xuống",
        //                 text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
        //                 width: 350,
        //                 height: 200
        //             });

        //             webix.ajax()
        //                 .response("arraybuffer")
        //                 //.headers({ 'Content-type': 'application/json' })
        //                 .get(app.config.host + "/Invoice/Floder?filename=BC_CHITIET_ACB_201812151033.csv", {
        //                     error: function (text, data, XmlHttpRequest) {
        //                         webix.modalbox.hide(box);
        //                         alert(text);
        //                     },
        //                     success: function (text, data, XmlHttpRequest) {
        //                         var file = new Blob([data], { type: 'text/csv' });
        //                         webix.html.download(file, "baocao.csv");

        //                         webix.modalbox.hide(box);
        //                     }
        //                 });
        //         }
        //     },
        //     click: function () {
        //         this.callEvent("onClick");
        //     }
        // },
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-refresh fa-lg" aria-hidden="true"></i> ' +
            '<span class="text">' + _("REFRESH") + '</span>',
            id: "btnRefresh",
            // shortcut: "F4",
            //css:"button_raised",
            on: {
                onClick: function () {
                    var table = webix.$$("dmwindowData");
                    table.clearAll();
                    //console.log(table);
                    table.load(table.config.url);
                    //table.refresh();
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-plus fa-lg" aria-hidden="true"></i> ' +
            '<span class="text">' + _("THEM") + " (F4)" + '</span>',
            id: "btnPlus",
            //css:"button_raised",
            shortcut: "F4",
            on: {
                onClick: function () {
                    var box = webix.modalbox({
                        title: "Chọn Token",
                        buttons: ["Nhận", "Hủy bỏ"],
                        text: "<div id='ctnToken'></div>",
                        top: 100,
                        width: 750,
                        callback: function (result) {
                            switch (result) {
                                case "1":
                                    webix.modalbox.hide();
                                    break;
                                case "0":
                                    var table = $$("tblToken");
                                    var item = {
                                        tokens: table.serialize()
                                    };
                                    webix.ajax()
                                        .headers({ 'Content-type': 'application/json' })
                                        .post(app.config.host + "/Token/SaveTokens", item, function (text) {
                                            var json = JSON.parse(text);
                                            if (!json.hasOwnProperty("error")) {
                                                var table = $$("dmwindowData");
                                                table.clearAll();
                                                table.load(table.config.url);
                                                webix.modalbox.hide();
                                            }
                                            else {
                                                webix.message(json.error);
                                            }
                                        });

                                    break;

                            }
                        }
                    });
                    var popupText = document.getElementsByClassName("webix_popup_text")[0];
                    popupText.style.paddingTop = 0;
                    var tblMatHang = webix.ui({
                        container: "ctnToken",
                        id: "tblToken",
                        view: "datatable",
                        borderless: true,
                        height: 350,
                        columns: [
                            {
                                id: "chon",
                                header: _("CHON"),
                                width: 65,
                                checkValue: true,
                                uncheckValue: false,
                                template: "{common.checkbox()}"
                            },
                            {
                                id: "serialNumber",
                                header: _("SO_SERIAL"),
                                width: 150
                            },
                            {
                                id: "tokenLabel",
                                header: _("TOKEN LABEL"),
                                width: 550
                            },

                        ],
                        //url: app.config.host + "/Token/SelectTokens"
                    });
                    var url = app.config.host + "/System/ExecuteCommand";
                    webix.ajax()
                        .headers({ "Content-Type": "application/json" })
                        .post(url, {
                            command: "CM00019",
                            parameter: {
                                ma_dvcs: ""
                            }
                        }, function (text) {
                            var array = JSON.parse(text);
                            var kytaptrung = "";
                            var server_cert = "";
                            for (var i = 0; i < array.length; i++) {
                                var item = array[i];
                                if (item.ma == "KYTAPTRUNG") {
                                    kytaptrung = item.gia_tri;
                                }
                                if (item.ma == "SERVER_CERT") {
                                    server_cert = item.gia_tri;
                                }
                            }
                            webix.ajax(server_cert + "/Token/SelectTokens", function (text) {
                                $$("tblToken").clearAll();
                                $$("tblToken").parse(text, "json");
                            });
                        });
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-edit fa-lg" aria-hidden="true"></i> ' +
            '<span class="text">' + _("SUA") + " (F3)" + '</span>',
            id: "btnEdit",
            //css:"button_raised",
            shortcut: "F3",
            on: {
                onClick: function () {
                    var detailForm = this.$scope.ui(dmwindowform.$ui);
                    var form = webix.$$("chukyso-form");

                    var table = webix.$$("dmwindowData");
                    var item = table.getSelectedItem();
                    if (item == null) {
                        webix.message("Bạn chưa chọn dòng cần sửa !", "error");
                        return;
                    }
                    var chon = item.chon;

                    item.chon = chon == true ? "true" : "false";

                    form.setValues(item);

                    dmwindowform.setEditMode(2);
                    detailForm.show();
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-trash fa-lg" aria-hidden="true"></i> ' +
            '<span class="text">' + _("XOA") + " (F8)" + '</span>',
            id: "btnDelete",
            //css:"button_raised",
            shortcut: "F8",
            on: {
                onClick: function () {

                    var table = webix.$$("dmwindowData");
                    var item = table.getSelectedItem();

                    var khData = {};
                    khData.windowid = app.path[1].params[0];
                    khData.editmode = 3;
                    khData.data = [];
                    khData.data.push(item);

                    webix.confirm({
                        text: "Bạn có muốn xóa " + item.serialNumber, ok: "Có", cancel: "Không",
                        callback: function (res) {
                            if (res) {
                                webix.ajax()
                                    .headers({ 'Content-type': 'application/json' })
                                    .post(app.config.host + "/System/Save", khData, function (text) {

                                        if (text.hasOwnProperty("error")) {
                                            webix.message(text.error);
                                            return;
                                        }

                                        table.remove(item.id);

                                    });
                            }
                        }
                    });
                }
            },
            click: function () {
                this.callEvent("onClick");
            }

        },
        {}

    ];

    var grid = {
        rows: [
            {
                id: "dmwindowData",
                view: "datatable",
                select: true,
                datafetch: 100,
                resizeColumn: true,
                //loadahead: 15,
                url: {
                    $proxy: true,
                    load: function (view, callback, params) {
                        var windowno = app.path[1].params[0];
                        var url = app.config.host + "/System/GetDataByWindowNo?window_id=" + windowno;

                        if (params == null) {
                            url = url + "&start=0&count=" + view.config.datafetch + "&continue=null&filter=null";
                        }
                        else {
                            url = url + "&start=" + params.start + "&count=" + params.count + "&continue=" + params.continue;

                            if (params.filter != null) {
                                var array = [];

                                for (var property in params.filter) {

                                    var column = view.getColumnConfig(property);

                                    if (column !== undefined) {
                                        var item = {
                                            columnName: property,
                                            columnType: column.columnType,
                                            value: params.filter[property]
                                        };

                                        array.push(item);
                                    }
                                }

                                //console.log(JSON.stringify(array));
                                if (array.length > 0) {
                                    url = url + "&filter=" + JSON.stringify(array);
                                }
                                else {
                                    url = url + "&filter=null";
                                }
                            }
                            else {
                                url = url + "&filter=null";
                            }
                        }

                        if (view.config.infoparam != null) {
                            url = url + "&infoparam=" + JSON.stringify(view.config.infoparam);
                        }
                        else {
                            url = url + "&infoparam=null";
                        }

                        var tlbParams = $$("tlbParams");

                        if (tlbParams !== undefined) {
                            var childViews = tlbParams.getChildViews();

                            var parameters = [];

                            for (var i = 0; i < childViews.length; i++) {
                                var child = childViews[i];

                                var id = child.config.id;
                                var value_field = child.config.value_field;

                                var item = {
                                    columnName: value_field,
                                    value: $$(id).getValue()
                                };

                                parameters.push(item);
                            }

                            url = url + "&tlbparam=" + JSON.stringify(parameters);

                        }
                        else {
                            url = url + "&tlbparam=null";
                        }
                        //console.log(url);
                        webix.ajax(url, callback, view);

                    }
                },
                on: {
                    "data->onStoreUpdated": function () {
                        this.data.each(function (obj, i) {
                            obj.index = i + 1;
                        })
                    },
                    onItemDblClick: function (id, e, node) {
                        var btnEdit = $$("btnEdit");
                        btnEdit.callEvent("onClick");
                    }
                },
                columns: [
                    { id: "index", header: "", sort: "int", width: 40 },
                    { id: "serialNumber", header: _("SO_SERIAL"), width: 200 },
                    { id: "tokenLabel", header: "TOKEN LABEL", width: 350 }
                ],
                pager: "pagerA"

            },
            {
                cols: [
                    {
                        view: "icon", icon: "fas fa-question-circle", id: "help_form_views", tooltip: _("HELPER"),
                        css: "helper",
                        click: function () {
                            webix.alert({
                                title: "Thông báo !",
                                text: "Bạn chưa khai báo hướng dẫn nhanh cho màn hình này !",
                                type: "alert-warning",
                                callback: function (result) {
                                }
                            });
                        }
                    },
                    {
                        view: "combo",
                        label: _("MENU_QUICK"),
                        id: "QuickMenu",
                        options: {
                            // view: "gridsuggest",
                            // id: "grid_window",
                            // template: "#name#",
                            // body: {
                            //     scroll: true,
                            //     autoheight: false,
                            //     columns: [
                            //         { id: "window_id", header: "Window Id", editor: "text", width: 100 },
                            //         { id: "name", header: "Window Name", editor: "text", width: 400 }
                            //     ],
                            //     url: app.config.host + "/System/GetQuickMenu"
                            // },
                            // on: {
                            //     onValueSuggest: function (obj) {
                            //         var start = obj.window_id != "" ? obj.code + ":" + obj.window_id : obj.code;
                            //         window.location.hash = "!/app/" + start;
                            //         $$("QuickMenu").setValue(null);
                            //     }
                            // }
                        },
                        on: {
                            onChange: function (newv, oldv) {

                            }
                        }
                    },
                    {},
                    {
                        id: "pagerA",
                        view: "pager",
                        size: 100,
                        group: 5,
                        template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}"
                    }
                ]
            }

        ]
    }

    var layout = {
        css: "frmView",
        rows: [
            {
                height: 39,
                css: "btnControl",
                type: "toolbar",
                margin: 0,
                borderless: true,
                cols: controls
            },
            {
                rows: [
                    grid
                ]
            }
        ]

    };

    return {
        $ui: layout,
        $oninit: function (view, $scope) {
            $scope.on(app, "dataChanged", function (mode, item) {

                var table = webix.$$("dmwindowData");

                if (mode == 1) {
                    table.add(item);
                    //table.select(item.iddmwindow,false);
                }

                if (mode == 2) {
                    var selectedItem = table.getSelectedItem();
                    table.updateItem(selectedItem.id, item);
                }

            });
        }
    };
});
define('views/tokenfile',[
    "app",
    "views/forms/tokenfile",
    "locale"
], function (app, dmwindowform, _) {
    'use strict';
    webix.$$("title").parse({ title: "Hệ thống > Đăng ký chữ ký số > Đăng ký chứng thư số mềm", details: "Danh sách Token File mềm" });
    var controls = [
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-refresh fa-lg" aria-hidden="true"></i> ' +
                '<span class="text">' + _("REFRESH") + '</span>',
            id: "btnRefresh",
            // shortcut: "F4",
            //css:"button_raised",
            // css: "webix_secondary",
            on: {
                onClick: function () {
                    var table = webix.$$("dmwindowData");
                    table.clearAll();
                    //console.log(table);
                    table.load(table.config.url);
                    //table.refresh();
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-plus fa-lg" aria-hidden="true"></i> ' +
                '<span class="text">' + _("THEM") + " (F4)" + '</span>',
            id: "btnPlus",
            // view: "button",
            // type: "icon",
            // icon: "fas fa-plus",
            // label: _("THEM") + " (F4)",
            // width: 85,
            // //css:"button_raised",
            // css: "webix_secondary",
            shortcut: "F4",
            on: {
                onClick: function () {
                    var detailForm = this.$scope.ui(dmwindowform.$ui);
                    var form = webix.$$("tokenfile-form");
                    var table = webix.$$("dmwindowData");
                    var item = table.getSelectedItem();
                    dmwindowform.setEditMode(1);
                    detailForm.show();
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-edit fa-lg" aria-hidden="true"></i> ' +
                '<span class="text">' + _("SUA") + " (F3)" + '</span>',
            id: "btnEdit",
            shortcut: "F3",
            on: {
                onClick: function () {
                    var detailForm = this.$scope.ui(dmwindowform.$ui);
                    var form = webix.$$("tokenfile-form");

                    var table = webix.$$("dmwindowData");
                    var item = table.getSelectedItem();
                    if (item == null) {
                        webix.message("Bạn chưa chọn dòng cần sửa !", "error");
                        return;
                    }
                    form.setValues(item);
                    dmwindowform.setEditMode(2);
                    detailForm.show();
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-trash-o fa-lg" aria-hidden="true"></i> ' +
                '<span class="text">' + _("XOA") + " (F8)" + '</span>',
            id: "btnDelete",
            shortcut: "F8",
            on: {
                onClick: function () {
                    var table = webix.$$("dmwindowData");
                    var item = table.getSelectedItem();
                    var khData = {};
                    khData.windowid = app.path[1].params[0];
                    khData.editmode = 3;
                    khData.data = [];
                    khData.data.push(item);
                    webix.confirm({
                        text: "Bạn có muốn xóa " + item.serialNumber, ok: "Có", cancel: "Không",
                        callback: function (res) {
                            if (res) {
                                webix.ajax()
                                    .headers({ 'Content-type': 'application/json' })
                                    .post(app.config.host + "/System/Save", khData, function (text) {

                                        if (text.hasOwnProperty("error")) {
                                            webix.message(text.error);
                                            return;
                                        }
                                        table.remove(item.id);
                                    });
                            }
                        }
                    });
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {}

    ];

    var grid = {
        rows: [
            {
                id: "dmwindowData",
                view: "datatable",
                select: true,
                datafetch: 100,
                resizeColumn: true,
                //loadahead: 15,
                url: {
                    $proxy: true,
                    load: function (view, callback, params) {
                        var windowno = app.path[1].params[0];
                        var url = app.config.host + "/System/GetDataByWindowNo?window_id=" + windowno;
                        if (params == null) {
                            url = url + "&start=0&count=" + view.config.datafetch + "&continue=null&filter=null";
                        }
                        else {
                            url = url + "&start=" + params.start + "&count=" + params.count + "&continue=" + params.continue;

                            if (params.filter != null) {
                                var array = [];
                                for (var property in params.filter) {
                                    var column = view.getColumnConfig(property);
                                    if (column !== undefined) {
                                        var item = {
                                            columnName: property,
                                            columnType: column.columnType,
                                            value: params.filter[property]
                                        };
                                        array.push(item);
                                    }
                                }
                                if (array.length > 0)
                                    url = url + "&filter=" + JSON.stringify(array);
                                else
                                    url = url + "&filter=null";
                            }
                            else {
                                url = url + "&filter=null";
                            }
                        }

                        if (view.config.infoparam != null) {
                            url = url + "&infoparam=" + JSON.stringify(view.config.infoparam);
                        }
                        else {
                            url = url + "&infoparam=null";
                        }

                        var tlbParams = $$("tlbParams");
                        if (tlbParams !== undefined) {
                            var childViews = tlbParams.getChildViews();
                            var parameters = [];
                            for (var i = 0; i < childViews.length; i++) {
                                var child = childViews[i];
                                var id = child.config.id;
                                var value_field = child.config.value_field;
                                var item = {
                                    columnName: value_field,
                                    value: $$(id).getValue()
                                };
                                parameters.push(item);
                            }
                            url = url + "&tlbparam=" + JSON.stringify(parameters);
                        }
                        else {
                            url = url + "&tlbparam=null";
                        }
                        webix.ajax(url, callback, view);
                    }
                },
                on: {
                    "data->onStoreUpdated": function () {
                        this.data.each(function (obj, i) {
                            obj.index = i + 1;
                        })
                    },
                    onItemDblClick: function (id, e, node) {
                        var btnEdit = $$("btnEdit");
                        btnEdit.callEvent("onClick");
                    }
                },
                columns: [
                    { id: "index", header: "", sort: "int", width: 40 },
                    { id: "path", header: _("PATH"), width: 350 },
                    { id: "serialNumber", header: "Số serial", sort: "int", width: 250 },
                    { id: "tokenLabel", header: "Serial token", sort: "int", width: 250 }

                ],
                pager: "pagerA"
            },
            {
                cols: [
                    {
                        view: "icon", icon: "fas fa-question-circle", id: "help_form_views", tooltip: _("HELPER"),
                        css: "helper",
                        click: function () {
                            webix.alert({
                                title: "Thông báo !",
                                text: "Bạn chưa khai báo hướng dẫn nhanh cho màn hình này !",
                                type: "alert-warning",
                                callback: function (result) {
                                }
                            });
                        }
                    },
                    {
                        view: "combo",
                        label: _("MENU_QUICK"),
                        id: "QuickMenu",
                        options: {
                        },
                        on: {
                            onChange: function (newv, oldv) {

                            }
                        }
                    },
                    {},
                    {
                        id: "pagerA",
                        view: "pager",
                        size: 100,
                        group: 5,
                        template: "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}"
                    }
                ]
            }

        ]
    }

    var layout = {
        css: "frmView",
        rows: [
            {
                height: 39,
                css: "btnControl",
                type: "toolbar",
                margin: 0,
                borderless: true,
                cols: controls
            },
            {
                rows: [
                    grid
                ]
            }
        ]

    };

    return {
        $ui: layout,
        $oninit: function (view, $scope) {
            $scope.on(app, "dataChanged", function (mode, item) {
                var table = webix.$$("dmwindowData");
                if (mode == 1) {
                    table.add(item);
                }
                if (mode == 2) {
                    var selectedItem = table.getSelectedItem();
                    table.updateItem(selectedItem.id, item);
                }
            });
        }
    };
});
define('views/treewindow',[
    "app",
    "views/forms/window",
    "locale",
    "models/user"
], function (app, windowform, _, user) {
    'use strict';

    var layoutId = "";
    var col = [];
    var sub_col = [];
    var windowconfig = null;
    //var windowno = "":   


    var initUI = function () {
        var windowno = app.path[1].params[0];

        col = [];
        sub_col = [];

        // var query = "SELECT TOP 1 * FROM wb_menu WHERE WINDOW_ID='" + windowno + "'";

        // var url = app.config.host + "/System/ExecuteQuery?sql=" + query;

        var url = app.config.host + "/System/ExeCmd";
        var dataPost = {
            cmd: "CM0001",
            param: {
                WINDOW_ID: windowno
            }
        };

        webix.ajax()
            .headers({ 'Content-type': 'application/json' })
            .post(url, dataPost, function (text) {
                var data = JSON.parse(text);
                var json = data.data;
                if (json.length > 0) {
                    webix.$$("title").parse({ title: json[0]["name"], details: json[0]["details"] });
                }
            });

        var url = app.config.host + "/System/GetAllByWindowNo?window_id=" + windowno;

        webix.$$("treewindowData").getParentView().getParentView().getParentView().disable();
        webix.$$("treewindowData").getParentView().getParentView().getParentView().showProgress();

        webix.ajax(url, function (text, xml, xhr) {

            var rp = JSON.parse(text);
            windowconfig = rp;

            var isPlusIcon = false;

            var k = Object.keys(rp['data'][0]['Tabs']).length;
            //console.log(k);
            for (var j = 0; j < (Object.keys(rp['data'][0]['Tabs'][k - 1]['Fields']).length); j++) {

                var field = rp['data'][0]['Tabs'][k - 1]['Fields'][j];
                //console.log(field);
                if (field.hide_in_grid == true) {
                    continue;
                }

                var item = {
                    id: rp['data'][0]['Tabs'][k - 1]['Fields'][j]['column_name'],
                    header: _(String(rp['data'][0]['Tabs'][k - 1]['Fields'][j]['column_name'])),
                    formatColumn: field.format
                };

                if (field.caption != null) {
                    item.header = _(field.caption);
                }

                if (field.type_filter != null) {
                    if (field.type_filter != "") {
                        item.header = [_(item.header), { content: field.type_filter }]
                    }
                }

                if (isPlusIcon == false) {
                    item.template = "{common.space()} {common.icon()} #" + item.id + "#";
                    isPlusIcon = true;
                }

                if (field.FORMAT != null) {
                    if (field.column_type == "decimal") {
                        item.css = { "text-align": "right" };
                        item.format = webix.Number.numToStr({
                            groupDelimiter: ",",
                            groupSize: 3,
                            decimalDelimiter: ".",
                            decimalSize: 0
                        });
                    }

                    if (field.column_type == "datetime" || field.column_type == "date") {
                        item.format = function (text) {
                            var format = webix.Date.dateToStr(this.formatColumn);
                            text = removeTimeZoneT(text);
                            return format(text);
                        };
                    }
                }

                if (field.type_editor == "combo") {
                    item.editor = field.type_editor;
                    item.options = app.config.host + "/System/GetDataByReferencesId?id=" + field.ref_id;
                }

                if (field.column_width == null) {
                    item.fillspace = true;
                }
                else {
                    item.width = field.column_width;
                }

                col.push(item);
            }

            var table = $$("treewindowData");
            table.clearAll();

            table.config.columns = col;
            table.refreshColumns();

            //table.define("url",app.config.host + "/api/System/GetDataByWindowNo?window_id="+windowno );	

            webix.ajax()
                .headers({ "Content-Type": "application/json" })
                .post(app.config.host + "/System/GetDataByWindowNo1",
                {
                    window_id: windowno,
                    start: 0,
                    count: 999999999,
                    continue: null,
                    filter: [],
                    infoparam: null,
                    tlbparam: []
                }, function (text) {
                    var json = JSON.parse(text);
                    //console.log(json);
                    var data = listToTree(json.data, { idKey: "id", parentId: "parentId" });
                    //console.log(data);
                    $$("treewindowData").parse(data, "json");
                    $$("treewindowData").openAll();
                });

            table.getParentView().getParentView().getParentView().enable();
            table.getParentView().getParentView().getParentView().hideProgress();

        });
    };


    var controls = [
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-refresh fa-lg" aria-hidden="true"></i> ' +
            '<span class="text">' + _("REFRESH") + '</span>',
            id: "btnRefresh",
            // view: "button",
            // type: "icon",
            // icon: "fas fa-refresh",
            // label: _("REFRESH"),
            // css: "webix_secondary",
            // width: 95,
            // shortcut: "F4",
            //css:"button_raised",
            on: {
                onClick: function () {
                    loadData();
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-plus fa-lg" aria-hidden="true"></i> ' +
            '<span class="text">' + _("Thêm") + " (F4)" + '</span>',
            id: "btnPlus",
            // view: "button",
            // type: "icon",
            // icon: "fas fa-plus",
            // label: "Thêm",
            // css: "webix_secondary",
            // width: 65,
            //css:"button_raised",
            shortcut: "F4",
            on: {
                onClick: function () {
                    var vc_window = windowconfig["data"][0];
                    windowform.$ui.id = vc_window.window_id;

                    var detailForm = this.$scope.ui(windowform.$ui);

                    windowform.initUI(windowconfig);
                    windowform.setEditMode(1);
                    windowform.setValues(null, windowconfig);

                    detailForm.show();

                    if (vc_window.after_new != null) {
                        var fn = Function(vc_window.after_new);
                        fn();
                    }
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-edit fa-lg" aria-hidden="true"></i> ' +
            '<span class="text">' + _("Sửa") + " (F3)" + '</span>',
            id: "btnEdit",
            // view: "button",
            // type: "icon",
            // icon: "fas fa-edit",
            // css: "webix_secondary",
            // label: "Sửa",
            // width: 55,
            shortcut: "F3",
            on: {
                onClick: function () {
                    var vc_window = windowconfig["data"][0];


                    windowform.$ui.id = vc_window.window_id;

                    var detailForm = this.$scope.ui(windowform.$ui);

                    var table = webix.$$("treewindowData");
                    var item = table.getSelectedItem();
                    if (item == null || item == "") {
                        webix.message("Bạn chưa chọn dòng cần sửa ! ", "error");
                        return;
                    }
                    windowform.initUI(windowconfig);
                    windowform.setEditMode(2);
                    windowform.setValues(item, windowconfig);

                    if (vc_window.after_edit != null) {
                        var fn = Function("app", "_", "user", vc_window.after_edit);
                        var result = fn(app, _, user);
                        if (result == false)
                            return;
                    }
                    detailForm.show();
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-trash-o fa-lg" aria-hidden="true"></i> ' +
            '<span class="text">' + _("Xóa") + " (F8)" + '</span>',
            id: "btnDelete",
            // view: "button",
            // type: "icon",
            // icon: "fas fa-trash-o",
            // css: "webix_secondary",
            // label: "Xóa",
            // width: 55,
            shortcut: "F8",
            on: {
                onClick: function () {
                    var table = webix.$$("treewindowData");
                    var item = table.getSelectedItem();

                    if (item.$count > 0) {
                        webix.message("Đã có nhóm con. Không thể xóa");
                        return;
                    }

                    var khData = {};
                    khData.windowid = windowconfig.data[0].window_id;
                    khData.editmode = 3;
                    khData.data = [];
                    //khData.data.push({ id: item.id });
                    khData.data.push(item);

                    webix.confirm({
                        text: "Bạn có muốn xóa ", ok: "Có", cancel: "Không",
                        callback: function (res) {
                            if (res) {
                                webix.ajax()
                                    .headers({ 'Content-type': 'application/json' })
                                    .post(app.config.host + "/System/Save", khData, function (text) {
                                        var json = JSON.parse(text);
                                        //console.log(json);
                                        if (json.hasOwnProperty("error")) {
                                            webix.message(json.error);
                                            return;
                                        }

                                        table.remove(item.id);

                                    });

                            }
                        }
                    });
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-files-o fa-lg" aria-hidden="true"></i> ' +
            '<span class="text">' + _("COPY") + '</span>',
            id: "btnCopy",
            // view: "button",
            // type: "icon",
            // icon: "fas fa-files-o",
            // css: "webix_secondary",
            // label: _("COPY"),
            // width: 85,
            on: {
                onClick: function () {
                    var table = webix.$$("treewindowData");
                    var item = table.getSelectedItem();

                    if (item == null) {
                        webix.message("Bạn chưa chọn dòng dữ liệu !", "error");
                        return;
                    }

                    var vc_window = windowconfig["data"][0];
                    windowform.$ui.id = vc_window.window_id;

                    var detailForm = this.$scope.ui(windowform.$ui);

                    windowform.initUI(windowconfig);
                    windowform.setEditMode(1);
                    windowform.copyValues(item, windowconfig);

                    detailForm.show();

                    if (vc_window.after_new != null) {
                        var fn = Function(vc_window.after_new);
                        fn();
                    }
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {}
    ]

    var grid = {
        rows: [
            {
                container: "testA",
                id: "treewindowData",
                view: "treetable",
                select: true,
                css: "display:grid !important;",
                resizeColumn: true,
                fixedRowHeight: false,
                rowLineHeight: 25, rowHeight: 25,
                scheme: {
                    $change: function (item) {
                        if (item.$count > 1980)
                            item.$css = "highlight";
                    }
                },
                on: {
                    onItemDblClick: function (id, e, node) {
                        var btnEdit = $$("btnEdit");
                        btnEdit.callEvent("onClick");
                    }
                },
                //url: app.config.host + "/api/System/GetDataByWindowNo?window_id="+windowno ,
                columns: col
            }
        ]
    }

    var layout = {
        rows: [
            {
                id: "tlbMain",
                height: 39,
                css: "btnControl",
                type: "toolbar",
                // margin: 0,
                borderless: true,
                cols: controls
            },
            {
                rows: [
                    grid
                ]
            }
        ]

    };

    function loadData() {
        var windowno = app.path[1].params[0];
        var table = webix.$$("treewindowData");
        table.clearAll();

        webix.ajax()
            .headers({ "Content-Type": "application/json" })
            .post(app.config.host + "/System/GetDataByWindowNo1",
            {
                window_id: windowno,
                start: 0,
                count: 999999999,
                continue: null,
                filter: [],
                infoparam: null,
                tlbparam: []
            }, function (text) {
                var json = JSON.parse(text);
                var data = listToTree(json.data, { idKey: "id", parentId: "parentId" });
                $$("treewindowData").parse(data, "json");
                $$("treewindowData").openAll();
            });
    }

    return {
        $ui: layout,
        $oninit: function (view, $scope) {

            webix.extend(view, webix.ProgressBar);

            var windowno = app.path[1].params[0];

            $scope.on(app, "dataChanged", function (mode, item) {

                var table = webix.$$("treewindowData");
                var url = app.config.host + "/System/GetDataById?window_id=" + windowno + "&id=" + item.id;

                webix.ajax(url, function (text) {
                    var json = JSON.parse(text);

                    if (mode == 1) {
                        // table.data.add(json.data[0], 0, json.data[0].parentId);
                        // table.select(json.data[0].id);
                        table.data.add(json, 0, json.parentId);
                        table.select(json.id);
                    }

                    if (mode == 2) {
                        var selectedItem = table.getSelectedItem();
                        // console.log(json);
                        if (selectedItem.parentId != json.parentId) {

                            var nodeId = table.getSelectedId();
                            table.remove(nodeId);

                            table.clearSelection();

                            table.data.add(json.data[0], 0, json.data[0].parentId);
                            table.select(json.data[0].id);
                        }
                        else {
                            table.updateItem(selectedItem.id, json);
                        }


                    }


                });



            });
        },
        $onurlchange: function (ui, name, url, scope) {
            initUI();
        }
    };
});
define('views/update',[
    "app",
    "locale"
], function (app, _) {
    'use strict';

    webix.$$("title").parse({ title: "Cập nhật phần mềm", details: "Cập nhật phần mềm", url_help: "http://huongdansudung.minvoice.com.vn/" });

    return {
        $ui: {
            cols: [
                {
                    view: "list",
                    id: "lstUpdate",
                    select: true,
                    tooltip: function (obj) {
                        return moment(obj.date_new).format("DD/MM/YYYY") + " - " + obj.user_new;
                    },
                    on: {
                        onItemClick: function (id, e, node) {
                            var item = this.getItem(id);
                            $$("content").setHTML(item.ghi_chu);
                        }
                    },
                    url: app.config.host + "/System/GetAllFloderUpdate",
                    template: function (item) {
                        if (item.trang_thai == true) {
                            return "- " + item.name + " <span style='color: #00b300'><i class='fas fa-check'></i></span>"
                        }
                        else {
                            return "- " + item.name + " <span style='color: red'><i class='fas fa-times'></i></span>"
                        }
                    },
                    width: 150
                },
                {
                    paddingX: 5,
                    rows: [
                        { view: "template", id: "content", scroll: "xy", type: { height: "auto" } },
                        {
                            paddingY: 5,
                            cols: [
                                {},
                                {
                                    view: "button", type: "form", label: "Cập nhật (F10)", shortcut: "F10", align: "center",
                                    on: {
                                        onClick: function () {
                                            var form = webix.$$("content");
                                            var item = $$("lstUpdate").getSelectedItem();
                                            if (item == undefined || item == null) {
                                                webix.message("Bạn chưa chọn versison cập nhật !", "error");
                                                return;
                                            }
                                            else {
                                                if (item.trang_thai == true) {
                                                    webix.message("Version này đã được cập nhật ! Bạn không thể cập nhật thêm !", "error");
                                                    return
                                                }
                                                else {
                                                    webix.confirm({
                                                        title: "Cập nhật phần mềm",
                                                        text: "Bạn có muốn cập nhật phần mềm ", ok: "Có", cancel: "Không",
                                                        callback: function (res) {
                                                            if (res) {
                                                                var box = webix.modalbox({
                                                                    title: "Đang tải cập nhật",
                                                                    buttons: ["Hủy bỏ"],
                                                                    text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                                                                    width: 350,
                                                                    height: 200,
                                                                    callback: function (result) {
                                                                        switch (result) {
                                                                            case "0":
                                                                                clearTimeout(interVal);
                                                                                webix.modalbox.hide(box);
                                                                                break;
                                                                        }
                                                                    }
                                                                });
                                                                var interVal = setTimeout(function () {

                                                                    webix.ajax()
                                                                        .headers({ 'Content-type': 'application/json' })
                                                                        .post(app.config.host + "/System/UpdateVersionManual", item, function (text) {
                                                                            var data = JSON.parse(text);
                                                                            if (!data.hasOwnProperty("error")) {
                                                                                webix.modalbox.hide(box);
                                                                                clearTimeout(interVal);

                                                                                webix.message("Cập nhật thành công !", "debug");
                                                                            }
                                                                            else {
                                                                                webix.modalbox.hide(box);
                                                                                clearTimeout(interVal);
                                                                                webix.message(data.error, "error");
                                                                            }
                                                                        });

                                                                }, 3000);
                                                            }
                                                        }
                                                    });
                                                }
                                            }
                                        }
                                    },
                                    click: function () {
                                        this.callEvent("onClick");
                                    }
                                },
                                {}
                            ]
                        }
                    ]
                }
            ]
        }
    };
});
define('views/update2',[
    "app",
    "locale",
    "views/forms/license",
], function (app, _, licenseForm) {
    'use strict';

    webix.$$("title").parse({ title: "Cập nhật phần mềm", details: "Cập nhật phần mềm" });

    var controls = [
        {},
        {
            id: "btnUpdate",
            view: "button",
            type: "danger",
            //css: "mcls_btn_save", 
            icon: "save",
            label: _("Cập nhật (F10)"),
            // width: 100,
            shortcut: "F10",
            on: {
                onClick: function () {

                    var form = webix.$$("updateform");

                    if (form.validate()) {
                        webix.confirm({
                            title: "Cập nhật phần mềm",
                            text: "Bạn có muốn cập nhật phần mềm ", ok: "Có", cancel: "Không",
                            callback: function (res) {
                                if (res) {
                                    var box = webix.modalbox({
                                        title: "Đang tải cập nhật",
                                        buttons: ["Hủy bỏ"],
                                        text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                                        width: 350,
                                        height: 200,
                                        callback: function (result) {
                                            switch (result) {
                                                case "0":
                                                    clearTimeout(interVal);
                                                    webix.modalbox.hide(box);
                                                    break;
                                            }
                                        }
                                    });
                                    var interVal = setTimeout(function () {

                                        webix.ajax()
                                            .headers({ 'Content-type': 'application/json' })
                                            .post(app.config.host + "/System/UpdateVersion", function (text) {
                                                var data = JSON.parse(text);
                                                if (!data.hasOwnProperty("error")) {
                                                    webix.modalbox.hide(box);
                                                    clearTimeout(interVal);

                                                    webix.message("Cập nhật thành công !", "debug");
                                                }
                                                else {
                                                    webix.modalbox.hide(box);
                                                    clearTimeout(interVal);
                                                    webix.message(data.error, "error");
                                                }
                                            });

                                    }, 3000);
                                }
                            }
                        });
                    }

                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {}
    ];

    var layout = {
        cols: [
            { gravity: 0.5, template: "" },
            {
                rows: [
                    { gravity: 0.2, template: "" },
                    {
                        view: "template", template: "<div><span style = 'padding-left:15px; margin-top:65px;'><i class='fas fa-star'></i> Thông tin cập nhật</span></div>",
                        css: { "background-color": "white", "color": "red", "border-radius": "15px 15px 0px 0px", "font-size": "15px", "margin-top":"65px" },
                        type: "header"
                    },
                    {
                        view: "form",
                        id: "updateform",
                        paddingY: 10,
                        paddingX: 10,
                        complexData: true,
                        margin: 0,
                        elements: [
                            {
                                view: "text",
                                name: "old_ver",
                                label: "Version hiện tại",
                                css: "mcls_readonly_text",
                                readonly: true,
                                labelPosition: "top"
                            },
                            {
                                view: "text",
                                name: "new_ver",
                                label: "Version mới nhất",
                                css: "mcls_readonly_text",
                                readonly: true,
                                labelPosition: "top"
                            },
                            {
                                view: "fieldset",
                                label: "Thông tin bản cập nhật",
                                height: 200,
                                body: {
                                    rows: [
                                        {
                                            view: "textarea",
                                            name: "info_update",
                                            labelPosition: "top",
                                            css: "mcls_readonly_text",
                                            readonly: true,
                                        }
                                    ]
                                }
                            },
                            {
                                margin: 15,
                                cols: controls
                            }
                        ]

                    },
                    { gravity: 1, template: "" }
                ]
            },
            { gravity: 0.5, template: "" }
        ]
    };

    return {
        $ui: layout,
        $oninit: function (view, $scope) {
            var url = app.config.host + "/System/GetVersionUpdate";

            webix.ajax(url, function (text) {
                var json = JSON.parse(text);
                $$("updateform").setValues(json);

            });
        }

    };
});
define('views/updateToWeb',[
    "app",
    "locale",
    "views/forms/updateToWeb"
], function (app, _, formUpdate) {
    'use strict';

    var header = {
        css: { "box-shadow": "0 2px 10px rgba(0,0,0,0.2)" },
        height: 135,
        cols: [
            {
                view: "label",
                template: "<a href='http://minvoice.vn/' target='_blank'><img  src='assets/imgs/LogoMinvoice.png' /></a>",
                height: 115,
                borderless: true,
                css: { "padding": "10px" }
            },
            {
                id: "version",
                borderless: true,
                view: "label",
                template: "<div class='hotline'><b style='font-family:Arial;'>Hotline:</b> <label style='color:red'>0901 80 16 18</label> <br /><i style='float:right; color:red'>info@minvoice.vn</i></div>",
                css: { "padding": "40px", "padding-top": "50px" }
            },
            {
                rows: [
                    { gravity: 1, template: "" },
                    {
                        id: "cbLanguage",
                        view: "combo",
                        width: 125,
                        options: [
                            { id: "vi", value: "Việt Nam" },
                            { id: "en", value: "English" },
                            { id: "ko", value: "Korea" }
                        ],
                        value: "vi",
                    },
                    { gravity: 1, template: "" }
                ]
            }
        ]
    };
    var controls = [
        {},
        {
            id: "btnSave",
            view: "button",
            type: "danger",
            icon: "save",
            label: _("THUCHIEN") + " (F10)",
            shortcut: "F10",
            on: {
                onClick: function () {
                    var frm = this.$scope.ui(formUpdate.$ui);
                    frm.show();
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {
            view: "button",
            label: _("BACKLOGIN"),
            type: "form",
            icon: "fas fa-repeat",
            click: function () {
                app.router("/login");
            }
        },
        {}
    ];

    var tabview = {
        id: "my_tabview",
        view: "tabview",
        cells: [
            {
                header: _("BANG_DU_LIEU"),
                body: {
                    id: "tblDM",
                    view: "datatable",
                    select: true,
                    editable: false,
                    disable: true,
                    data: [
                        { chon: true, MA: "SYS", TEN_DM: "Bảng hệ thống" },
                        { chon: true, MA: "BQ", TEN_DM: "Bản Quyền" },
                        { chon: true, MA: "CKS", TEN_DM: "Chữ ký số" },
                        { chon: true, MA: "TBH", TEN_DM: "Thông báo hủy" },
                        { chon: true, MA: "QTC", TEN_DM: "Quyền truy cập" },
                        { chon: true, MA: "LDC", TEN_DM: "Loại điều chỉnh" }
                    ],
                    columns: [
                        {
                            id: "chon",
                            header: { content: "masterCheckbox" },
                            template: "{common.checkbox()}",
                            checkValue: true, uncheckValue: false,
                            value: true, width: 50,
                            css: { 'text-align': 'right' }
                        },
                        { id: "MA", header: _("MA"), width: 80 },
                        { id: "TEN_DM", header: _("TABLENAME"), width: 250 }
                    ]
                }
            },
            {
                header: "Stored Procedures",
                body: {
                    id: "tblDMCT",
                    view: "datatable",
                    select: true,
                    editable: true,
                    data: [
                        { chon: true, MA_CT: "MNU", TEN_CT: "Get Menu" },
                        { chon: true, MA_CT: "DHB", TEN_CT: "Dashboard" },
                        { chon: true, MA_CT: "CHA", TEN_CT: "Biểu đồ" },
                        { chon: true, MA_CT: "PRI", TEN_CT: "Print Invoice" },
                        { chon: true, MA_CT: "PRL", TEN_CT: "Print License" },
                        { chon: true, MA_CT: "TEM", TEN_CT: "Temple Email" },
                        { chon: true, MA_CT: "TSM", TEN_CT: "Temple SMS" },
                        { chon: true, MA_CT: "SEI", TEN_CT: "Search Invoice" },
                        { chon: true, MA_CT: "ATC", TEN_CT: "Auto Create CMD" },
                        { chon: true, MA_CT: "ATF", TEN_CT: "Auto Create Field" }
                    ],
                    columns: [
                        {
                            id: "chon", header: { content: "masterCheckbox" }, template: "{common.checkbox()}",
                            checkValue: true, uncheckValue: false,
                            value: true, width: 50,
                            css: { 'text-align': 'right' }
                        },
                        { id: "MA_CT", header: _("Mã"), width: 80 },
                        { id: "TEN_CT", header: _("Tên Stored Procedures"), width: 250 }
                    ]
                }
            }
        ]
    };


    var layout = {
        cols: [
            { gravity: 0.5, template: "" },
            {
                rows: [
                    header,
                    { gravity: 0.1, template: "" },
                    {
                        gravity: 0.1,
                        template: "<div><center><b style='color:#e60000'><i class='fa fa-globe'></i> " + _("UDTOWEB") + "</b></center></div>", css: { "padding-top": "15px" }
                    },
                    {
                        view: "form",
                        id: "formInfo",
                        paddingY: 10,
                        position: "center",
                        paddingX: 10,
                        complexData: true,
                        margin: 0,
                        url: app.config.host + "/System/GetAllDmDvcs",
                        elements: [
                            {
                                cols: [
                                    { id: "ten_dvcs", name: "ten_dvcs", view: "text", label: _("TEN_DON_VI"), readonly: true, css: "mcls_readonly_text" },
                                    { id: "ms_thue", name: "ms_thue", view: "text", label: _("MST"), readonly: true, css: "mcls_readonly_text" }
                                ]
                            },
                            {
                                cols: [
                                    { id: "dia_chi", view: "text", name: "dia_chi", label: _("DIA_CHI"), readonly: true, css: "mcls_readonly_text" },
                                    { id: "tk", name: "gd", view: "checkbox", value: 1, label: _("GHI_DE") }
                                ]
                            },
                            {
                                view: "template",
                                template: "Lựa chọn Bảng/Stored Procedures Update",
                                type: "section"
                            },
                            tabview,
                            {
                                margin: 10,
                                cols: controls
                            }
                        ]
                    },
                    { gravity: 0.5, template: "" }
                ]
            },
            { gravity: 0.5, template: "" }
        ]

    };

    return {
        $ui: layout
    };
});

define('views/wb_config_job',[
    "app",
    "views/forms/wb_config_job",
    "locale",
    "views/menus/version"
], function (app, configJobForm, _, version) {
    'use strict';

    var formId = "configJobForm";
    var tableId = "configJobTable";
    var btnReloadId = "btnReload"
    function actionText(actionId) {
        switch (actionId) {
            case "SendEmail":
                return "Gửi email thông báo";
            case "Sign":
                return "Ký tự động hóa đơn";
        }
    }
    
    webix.$$("title").parse({ title: "Tự động ký/ gửi email", details: "Tự động ký/ gửi email" });
    var controls = [
        {
            view: "button", id: btnReloadId, type: "htmlbutton", width: 100,
            label: '<i class="fa fa-refresh fa-lg" aria-hidden="true"></i><span class="text">' + _("REFRESH") + "</span>",
            on: {
                onClick: function () {
                    webix.callEvent("onLoadError");
                    var table = webix.$$(tableId);
                    table.clearAll();
                    table.load(table.config.url);
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {
            view: "button", type: "htmlbutton", width: 100, id: "btnPlus", shortcut: "F4",
            label: '<i class="fa fa-plus fa-lg" aria-hidden="true"></i> <span class="text">' + _("THEM") + " (F4)" + '</span>',
            on: {
                onClick: function () {
                    var win = this.$scope.ui(configJobForm.$ui);
                    configJobForm.setEditMode(1);
                    win.show();
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {
            view: "button", type: "htmlbutton", width: 100, id: "btnEdit", shortcut: "F3",
            label: '<i class="fa fa-edit fa-lg" aria-hidden="true"></i><span class="text">' + _("Sửa (F31)") + '</span>',
            on: {
                onClick: function () {
                    var detailForm = this.$scope.ui(configJobForm.$ui);
                    var table = webix.$$(tableId);
                    var item = table.getSelectedItem();
                    if (item == null || item == undefined) {
                        webix.message("Bạn chưa chọn dòng cần sửa ! ", "error");
                        return;
                    }
                    configJobForm.setValues(item);
                    configJobForm.setEditMode(2);
                    detailForm.show();
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {
            view: "button", type: "htmlbutton", width: 100, id: "btnDelete", shortcut: "F8",
            label: '<i class="fa fa-trash-o fa-lg" aria-hidden="true"></i><span class="text">' + _("Xóa (F8)") + '</span>',
            on: {
                onClick: function () {
                    var table = webix.$$(tableId);
                    var item = table.getSelectedItem();
                    if (item == null) {
                        webix.message("Bạn chưa chọn dòng cần xóa", "error");
                        return;
                    }
                    item.editMode = 3;
                    item.mst = version.getMST();
                    webix.confirm({
                        title: "XÓA ĐẶT LỊCH", text: "Bạn có muốn xóa đặt lịch này?", ok: "Có", cancel: "Không",
                        callback: function (res) {
                            if (res) {
                                webix.extend(grid, webix.ProgressBar);
                                table.disable();
                                table.showProgress();
                                var url = app.config.host + "/Pattern/ConfigSignInvoiceCashRegisterAuto"
                                webix.ajax().header({ "content-type": "application/json" }).post(url, item, function (result) {
                                    table.enable();
                                    table.hideProgress();
                                    var response = JSON.parse(result);
                                    if (response.code == "00") {
                                        webix.message("Xóa thành công", "success");
                                        $$(btnReloadId).callEvent("onClick");
                                    } else {
                                        webix.message(response.message, "error");
                                    }
                                })
                            }
                        }
                    });
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {
            view: "button", type: "htmlbutton", width: 100, id: "btnCopyPetro", shortcut: "F3",
            label: '<i class="fa fa-edit fa-lg" aria-hidden="true"></i> ' + '<span class="text">' + _("COPY") + "</span>",
            on: {
                onClick: function () {
                    var table = $$(tableId);
                    var item = table.getSelectedItem();
                    if (item == null) {
                        webix.message("Bạn chưa chọn dòng cần sao chép", "error");
                        return;
                    }
                    var form = table.$scope.ui(configJobForm);
                    configJobForm.setEditMode(1, item);
                    $$(formId).setValues(item);
                    form.show();
                }
            },
            click: function () {
                this.callEvent("onClick");
            },
        },
    ];

    var grid = {
        rows: [
            {
                view: "datatable", id: tableId, select: true, resizeColumn: true, datafetch: 50, pager: "pagerA",
                url: {
                    $proxy: true,
                    load: function (view, callback, params) {
                        webix.extend(view, webix.ProgressBar);
                        view.disable();
                        view.showProgress();
                        var start = null;
                        var count = null;
                        var filter = [];
                        var tlbparam_s = [];
                        if (params == null) {
                            start = 0;
                            count = view.config.datafetch;
                        }
                        else {
                            start = params.start;
                            count = params.count;
                            if (params.filter != null) {
                                var array = [];
                                for (var property in params.filter) {
                                    var column = view.getColumnConfig(property);
                                    var item = {
                                        columnName: property,
                                        columnType: column.columnType,
                                        value: params.filter[property]
                                    };
                                    array.push(item);
                                }
                                filter = array;
                            }
                        }
                        var item = {
                            command: "CM0034",
                            start: start,
                            count: count,
                            filter: filter,
                            tlbparam: tlbparam_s
                        };
                        var apiHost = app.config.host + "/Pattern/GetData";
                        webix.ajax()
                            .headers({ 'Content-type': 'application/json' })
                            .bind(view)
                            .post(apiHost, item, callback, view);
                    }
                },
                type: {
                    amount: function (obj, common, value, config) {
                        return value == null ? 0 : formatDecimal(value);
                    }`  `
                },
                columns: [
                    {
                        id: "indexs", header: ["STT"], width: 50,
                    },
                    {
                        id: "wb_config_job_id", header: ["Id", { content: "serverFilter" }], width: 240, sort: "server", columnType: "string", hidden: false,
                    },
                    {
                        id: "email", header: ["Danh sách email", { content: "serverFilter" }], width: 240, sort: "server", columnType: "string",
                    },
                    {
                        id: "serial", header: ["Ký hiệu", { content: "serverFilter" }], width: 240, sort: "server", columnType: "string",
                    },
                    {
                        id: "time_interval", header: ["Thời gian ký lại", { content: "serverFilter", }], width: 140, sort: "server", columnType: "decimal"
                    },
                    {
                        id: "time_start", header: ["Thời gian bắt đầu", { content: "serverFilter" }], width: 140, sort: "server", columnType: "decimal"
                    },
                    {
                        id: "user_new", header: ["Người tạo", { content: "serverFilter" }], width: 150, sort: "server", columnType: "string",
                    },
                    {
                        id: "date_new", header: ["Ngày tạo", { content: "serverDateRangeFilter" }],
                        width: 150, format: function (text) { var format = webix.Date.dateToStr("%d/%m/%Y %H:%i"); text = removeTimeZoneT(text); return format(text); },
                        sort: "server", columnType: "datetime",
                    },
                    {
                        id: "action", header: "Hành động", width: 160, sort: "server", columnType: "string", readonly: true, template: function (obj) { return actionText(obj.action); }
                    },
                ],
                on: {
                    "data->onStoreUpdated": function () {
                        this.data.each(function (obj, i) {
                            obj.indexs = i + 1;
                        });
                    },
                    onAfterLoad: function () {
                        $$(tableId).enable();
                        $$(tableId).hideProgress();
                    },
                    onItemDblClick: function (id, e, node) {
                        var btnEdit = $$("btnEditPetro");
                        btnEdit.callEvent("onClick");
                    },
                }
            },
            {
                cols: [
                    {
                        view: "icon", icon: "fas fa-question-circle", id: "help_form_main", tooltip: _("HELPER"), css: "helper",
                        click: function () {
                            var newWin = window.open();
                            newWin.location = "http://huongdansudung.minvoice.com.vn/Tomihoadon.html";
                        }
                    },
                    {},
                    {
                        id: "pagerA", view: "pager", size: 50, group: 5,
                        template: function (data, common) {
                            return "Số dòng: " + data.count + ". " + common.first(data) + common.prev(data) + common.pages(data) + common.next(data) + common.last(data);
                        }
                    },
                    {}
                ]
            }
        ]
    }
    var layout = {
        rows: [
            { id: "tlbMain", height: 39, css: "btnControl", type: "toolbar", margin: 0, borderless: true, cols: controls },
            { rows: [grid] }
        ]
    };

    return {
        $ui: layout,
        $oninit: function (view, $scope) {
            $scope.on(app, "dataErrorChanged", function (mode, item) {
                var table = webix.$$(tableId);
                if (mode == 1) {
                    table.add(item);
                }
                if (mode == 2) {
                    var selectedItem = table.getSelectedItem();
                    table.updateItem(selectedItem.id, item);
                }
            });
            webix.attachEvent("onRefreshEvent", function() {
                var table = webix.$$(tableId);
                table.clearAll();
                table.load(table.config.url);
            });
        }
    };
    
}); 
define('views/wb_cronjob_invoice_signing_pos',[
    "app",
    "views/forms/wb_cronjob_invoice_signing_pos",
    "locale",
    "views/modules/Component/grid",
    "views/modules/Component/componentHelper",
    "models/user"
], function (app, wbCronjobInvoiceSigningPos, _, grid, componentHelper, user) {
    'use strict';
    if (webix.$$("title") != undefined)
        webix.$$("title").parse({ title: _("Hệ thống > Job tự động ký hóa đơn máy tính tiền"), details: _("Hệ thống > Job tự động ký hóa đơn máy tính tiền") });
    var controls = [
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-refresh fa-lg" aria-hidden="true"></i><span class="text"> ' + _("REFRESH") + '</span>',
            id: "btnRefresh",
            on: {
                onClick: function () {
                    var table = webix.$$("wbCronjobInvoiceSigningPos");
                    table.clearAll();
                    table.load(table.config.url);
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-plus fa-lg" aria-hidden="true"></i><span class="text">' + _("THEM") + " (F4)" + '</span>',
            id: "btnPlus",
            shortcut: "F4",
            on: {
                onClick: function () {
                    var ModalForm = this.$scope.ui(wbCronjobInvoiceSigningPos.$ui);
                    wbCronjobInvoiceSigningPos.setEditMode(1);
                    ModalForm.show();
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-edit fa-lg" aria-hidden="true"></i><span class="text">' + _("SUA") + " (F3)" + '</span>',
            id: "btnEdit",
            shortcut: "F3",
            on: {
                onClick: function () {
                    var ModalForm = this.$scope.ui(wbCronjobInvoiceSigningPos.$ui);
                    var table = webix.$$("wbCronjobInvoiceSigningPos");
                    var item = table.getSelectedItem();
                    if (item == null) {
                        webix.message("Bạn chưa chọn dòng cần sửa !", "error");
                        return;
                    }
                    wbCronjobInvoiceSigningPos.setEditMode(2, item);
                    ModalForm.show();
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-trash fa-lg" aria-hidden="true"></i><span class="text">' + _("XOA") + " (F8)" + '</span>',
            id: "btnDelete",
            shortcut: "F8",
            on: {
                onClick: function () {
                    var curentUser = user.getCurrentUser();
                    if (curentUser != "ADMINISTRATOR") {
                        webix.message("Bạn không có quyền xóa !", "error");
                        return false;
                    }
                    var table = webix.$$("wbCronjobInvoiceSigningPos");
                    var item = table.getSelectedItem();
                    if (item == null) {
                        webix.message("Bạn chưa chọn dòng cần xóa !", "error");
                        return;
                    }
                    item.editMode = 3;
                    webix.confirm({
                        title: "M-INVOICE",
                        text: "Bạn có muốn xóa mã: " + item.khieu, ok: "Có", cancel: "Không",
                        callback: function (res) {
                            if (res) {
                                webix.ajax()
                                    .headers({ 'Content-type': 'application/json' })
                                    .post(app.config.host + "/Category/WbCronjobInvoicecSigningPosSaveChange", item, function (text) {
                                        var response = JSON.parse(text);
                                        if (response.code != "00")
                                            webix.message(response.message, "error");
                                        else {
                                            webix.message("Xóa thành công", "success");
                                            table.remove(item.id);
                                        }
                                    });
                            }
                        }
                    });
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {}
    ];

    var layout = componentHelper.layoutGrid(controls, grid.gridWbCronjobInvoiceSigningPos());

    return {
        $ui: layout,
        $oninit: function (view, $scope) {
            $scope.on(app, "wbCronjobInvoiceSigningPosChanged", function (mode, item) {
                var table = webix.$$("wbCronjobInvoiceSigningPos");
                if (mode == 1) {
                    table.add(item);
                }
                if (mode == 2) {
                    var selectedItem = table.getSelectedItem();
                    table.updateItem(selectedItem.id, item);
                }
            });
        }
    };
});
define('views/wb_setting',[
    "app",
    "views/forms/wb_setting",
    "locale",
    "views/modules/Component/grid",
    "views/modules/Component/componentHelper",
    "models/user"
], function (app, WbSettingForms, _, grid, componentHelper, user) {
    'use strict';
    if (webix.$$("title") != undefined)
        webix.$$("title").parse({ title: _("Hệ thống > Khai báo tham số hệ thống"), details: _("Hệ thống > Khai báo tham số hệ thống") });
    function AfterEdit(ma) {
        $$("ma").define("readonly", true);
        $$("ma").define("css", "mcls_readonly_text");
        if (ma == "QUY_TRINH_HD") {
            var op = ["Chờ ký", "Chờ duyệt"];
            $$("gia_tri").define("options", op);
        }
        if (ma == "AUTO_SEND_EMAIL" || ma == "MA_HOA_XML" || ma == "OPT_TINH_TIEN_THUE") {
            var op = ["C", "K"];
            $$("gia_tri").define("options", op);
        }
        if (ma == "OPT_EMAIL") {
            var op = ["C", "K", "TRACUU"];
            $$("gia_tri").define("options", op);
        }
        if (ma == "KYTAPTRUNG") {
            var op = ["C", "K", "FILE", "CLOUD", "EASYCA", "NCCA", "ICA", "VIETTEL", "INTRUSTCA", "VNET"];
            $$("gia_tri").define("options", op);
        }
        if (ma == "DEFAULT_HTTT") {
            var op = ["TM/CK","Tiền mặt","Chuyển khoản"];
            $$("gia_tri").define("options", op);
        }
        if (ma == "QR_CODE_LINK") {
            var op = ["C", "K", "VIMO", "VNPAY"];
            $$("gia_tri").define("options", op);
        }
        if (ma == "SERVER_CERT" || ma == "EMAIL_BCC" || ma == "EMAIL_CC" || ma == "EMAIL_SIGNATURE" || ma == "KYHIEU_API" || ma == "OPT_ADDINVOICE" || ma == "MAUSO_API" || ma == "BRAND_NAME" || ma == "MA_DVCS_VACOM" || ma == "TTKhac" || ma == "VAN_RESPONSE" || ma == "TIME_FIND_INVOICE") {
            var table = webix.$$("wbsettingViews");
            var item = table.getSelectedItem();
            $$("WbSettingForm").removeView("gia_tri");
            var items = {
                view: "textarea",
                name: "gia_tri",
                id: "gia_tri",
                label: "Giá trị",
                labelPosition: "top",
                value: item.gia_tri,
                height: 120
            };
            webix.$$("WbSettingForm").addView(items, 3);
            webix.$$("WbSettingForm").refresh();
        }
    }
    var controls = [
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-refresh fa-lg" aria-hidden="true"></i><span class="text"> ' + _("REFRESH") + '</span>',
            id: "btnRefresh",
            on: {
                onClick: function () {
                    var table = webix.$$("wbsettingViews");
                    table.clearAll();
                    table.load(table.config.url);
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-plus fa-lg" aria-hidden="true"></i><span class="text">' + _("THEM") + " (F4)" + '</span>',
            id: "btnPlus",
            shortcut: "F4",
            on: {
                onClick: function () {
                    var ModalForm = this.$scope.ui(WbSettingForms.$ui);
                    WbSettingForms.setEditMode(1);
                    ModalForm.show();
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-edit fa-lg" aria-hidden="true"></i><span class="text">' + _("SUA") + " (F3)" + '</span>',
            id: "btnEdit",
            shortcut: "F3",
            on: {
                onClick: function () {
                    var ModalForm = this.$scope.ui(WbSettingForms.$ui);
                    var table = webix.$$("wbsettingViews");
                    var item = table.getSelectedItem();
                    if (item == null) {
                        webix.message("Bạn chưa chọn dòng cần sửa !", "error");
                        return;
                    }
                    AfterEdit(item.ma);
                    WbSettingForms.setEditMode(2, item);
                    ModalForm.show();
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-trash fa-lg" aria-hidden="true"></i><span class="text">' + _("XOA") + " (F8)" + '</span>',
            id: "btnDelete",
            shortcut: "F8",
            on: {
                onClick: function () {
                    var curentUser = user.getCurrentUser();
                    if (curentUser != "ADMINISTRATOR") {
                        webix.message("Bạn không có quyền xóa !", "error");
                        return false;
                    }
                    var table = webix.$$("wbsettingViews");
                    var item = table.getSelectedItem();
                    if (item == null) {
                        webix.message("Bạn chưa chọn dòng cần xóa !", "error");
                        return;
                    }
                    item.editMode = 3;
                    webix.confirm({
                        title: "M-INVOICE",
                        text: "Bạn có muốn xóa mã: " + item.ma, ok: "Có", cancel: "Không",
                        callback: function (res) {
                            if (res) {
                                webix.ajax()
                                    .headers({ 'Content-type': 'application/json' })
                                    .post(app.config.host + "/Category/WbSettingSaveChange", item, function (text) {
                                        var response = JSON.parse(text);
                                        if (response.code != "00")
                                            webix.message(response.message, "error");
                                        else {
                                            webix.message("Xóa thành công", "success");
                                            table.remove(item.id);
                                        }
                                    });
                            }
                        }
                    });
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {}
    ];

    var layout = componentHelper.layoutGrid(controls, grid.gridWbSetting());

    return {
        $ui: layout,
        $oninit: function (view, $scope) {
            $scope.on(app, "wbsettingChanged", function (mode, item) {
                var table = webix.$$("wbsettingViews");
                if (mode == 1) {
                    table.add(item);
                }
                if (mode == 2) {
                    var selectedItem = table.getSelectedItem();
                    table.updateItem(selectedItem.id, item);
                }
            });
        }
    };
});
webix.protoUI({
	name: "ckeditor",
	$init: function (config) {
		this.$view.className += " webix_selectable";
		this._waitEditor = webix.promise.defer();
	},
	defaults: {
		borderless: true,
		language: "vi",
		extraPlugins:'colorbutton',
		toolbar: [
			{ name: 'document', items: ['Source', '-', 'Save', 'NewPage', 'Preview', 'Print', '-', 'Templates'] },
			{ name: 'clipboard', items: ['Cut', 'Copy', 'Paste', 'PasteText', 'PasteFromWord', '-', 'Undo', 'Redo'] },
			{ name: 'editing', items: ['Find', 'Replace', '-', 'SelectAll', '-', 'Scayt'] },
			{ name: 'forms', items: ['Form', 'Checkbox', 'Radio', 'TextField', 'Textarea', 'Select', 'Button', 'ImageButton', 'HiddenField'] },
			'/',
			{ name: 'basicstyles', items: ['Bold', 'Italic', 'Underline', 'Strike', 'Subscript', 'Superscript', '-', 'CopyFormatting', 'RemoveFormat'] },
			{ name: 'paragraph', items: ['NumberedList', 'BulletedList', '-', 'Outdent', 'Indent', '-', 'Blockquote', 'CreateDiv', '-', 'JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock', '-', 'BidiLtr', 'BidiRtl', 'Language'] },
			{ name: 'links', items: ['Link', 'Unlink', 'Anchor'] },
			{ name: 'insert', items: ['Image', 'Flash', 'Table', 'HorizontalRule', 'Smiley', 'SpecialChar', 'PageBreak', 'Iframe'] },
			'/',
			{ name: 'styles', items: ['Styles', 'Format', 'Font', 'FontSize'] },
			{ name: 'colors', items: ['TextColor', 'BGColor'] },
			{ name: 'tools', items: ['Maximize', 'ShowBlocks'] },
			{ name: 'about', items: ['About'] }
		]
	},
	_init_ckeditor_once: function () {
		var tid = this.config.textAreaID = "t" + webix.uid();
		this.$view.innerHTML = "<textarea id='" + tid + "'>" + this.config.value + "</textarea>";

		this._3rd_editor = CKEDITOR.replace(this.config.textAreaID, {
			toolbar: this.config.toolbar,
			language: this.config.language,
			width: this.$width - 2,
			height: this.$height - 140
		});
		this._waitEditor.resolve(this._3rd_editor);

		this._init_ckeditor_once = function () { };
	},
	_render_ckeditor: function () {
		var initMethod = "replace";
		if (this.config.editorType === "inline") {
			CKEDITOR.disableAutoInline = true;
			initMethod = "inline";
		}

		this._3rd_editor = CKEDITOR[initMethod](this.config.textAreaID, {
			toolbar: this.config.toolbar,
			language: this.config.language,
			width: this.$width - 2,
			height: this.$height - this.config.barHeight


		});
		console.log(this.config.barHeight);
		this._waitEditor.resolve(this._3rd_editor);
	},
	_set_inner_size: function (x, y) {
		//alert(x+"-"+y);
		if (!this._3rd_editor || !this._3rd_editor.container || !this.$width || this.config.editorType === "inline") return;
		this._3rd_editor.resize(x, y);
	},
	$setSize: function (x, y) {
		//alert(x+"-"+y);
		if (webix.ui.view.prototype.$setSize.call(this, x, y)) {
			this._init_ckeditor_once();
			this._set_inner_size(x, y);
		}
	},
	setValue: function (value) {
		this.config.value = value;

		if (this._3rd_editor && this._3rd_editor.status === "ready")
			this._3rd_editor.setData(value);
		else webix.delay(function () {
			this.setValue(value);
		}, this, [], 100);
	},
	getValue: function () {
		return this._3rd_editor ? this._3rd_editor.getData() : this.config.value;
	},
	focus: function () {
		this._focus_await = true;
		if (this._3rd_editor)
			this._3rd_editor.focus();
	},
	getEditor: function (waitEditor) {
		return waitEditor ? this._waitEditor : this._3rd_editor;
	}
}, webix.ui.view);
define("views/webix/ckeditor", function(){});

webix.protoUI({
	name:"edittree"
}, webix.EditAbility, webix.ui.tree);
define("views/webix/editable", function(){});

webix.type(webix.ui.tree, {
	name:"fileTree",
	css: "file",
	height: 40,
	templateCommon:webix.template("{common.icon()} <div class='folder_title'>{common.folder()} #value#</div>"),
	folder:function(obj, common){
		return "<span class='webix_icon icon fa-folder"+(obj.open?"-open":(obj.$level>3?"-o":""))+"'></span>";
	}
});
define("views/webix/filetree", function(){});

webix.type(webix.ui.dataview, {
	name:"fileView",
	css: "files",
	height: 80,
	width: 150,

	template: function(obj){
		var icon = (obj.icon||"folder-o");
		return "<div class='"+(obj.type||"folder")+"'><span class='webix_icon fa-"+icon+"'></span></div>"+obj.value;
	}

});
define("views/webix/fileview", function(){});

webix.protoUI({
	name:"google-map",
	$init:function(config){
		this.$view.innerHTML = "<div class='webix_map_content' style='width:100%;height:100%'></div>";
		this._contentobj = this.$view.firstChild;

		this.map = null;
		this.$ready.push(this.render);
	},
	render:function(){
        if(typeof google=="undefined"||typeof google.maps=="undefined"){
            var name = "webix_callback_"+webix.uid();
            window[name] = webix.bind(function(){
                 this._initMap.call(this,true);
            },this);

            var script = document.createElement("script");
            script.type = "text/javascript";
            script.src = "//maps.google.com/maps/api/js?sensor=false&callback="+name;
            document.getElementsByTagName("head")[0].appendChild(script);
        }
        else
            this._initMap();
	},
    _initMap:function(define){
        var c = this.config;

        this.map = new google.maps.Map(this._contentobj, {
            zoom: c.zoom,
            center: new google.maps.LatLng(c.center[0], c.center[1]),
            mapTypeId: google.maps.MapTypeId[c.mapType]
        });
        webix._ldGMap = null;
    },
	center_setter:function(config){
		if(this.map)
            this.map.setCenter(new google.maps.LatLng(config[0], config[1]));
        
		return config;
	},
	mapType_setter:function(config){
		/*ROADMAP,SATELLITE,HYBRID,TERRAIN*/
        if(this.map)
        	this.map.setMapTypeId(google.maps.MapTypeId[config]);

		return config;
	},
	zoom_setter:function(config){
		if(this.map)
			 this.map.setZoom(config);

		return config;
	},
	defaults:{
		zoom: 5,
		center:[ 39.5, -98.5 ],
		mapType: "ROADMAP" 
	},
	$setSize:function(){
		webix.ui.view.prototype.$setSize.apply(this, arguments);
		if(this.map)
            google.maps.event.trigger(this.map, "resize");
	}
}, webix.ui.view);

define("views/webix/googlemap", function(){});

define('views/window',[
    "app",
    "views/forms/window",
    "views/forms/infowindow",
    "locale",
    "models/user",
    "views/forms/printf",
    "views/forms/sendemail",
    "views/forms/lichsuemail",
    "views/menus/version",
    "views/forms/frmPassPrint",
    "views/forms/sendZNS",
    "views/forms/dmhanghoas"
], function (app, windowform, infowindow, _, user, printf, sendemail, his_email, version, frmPassPrint, sendZNS, dmhanghoas) {
    'use strict';
    var layoutId = "";
    var col = [];
    var sub_col = [];
    var windowconfig = null;
    var buttons = [];
    var checkbox_thue = 1;
    //var windowno = "":
    var subChucNang = webix.ui({
        view: "submenu",
        width: 300,
        padding: 0,
        data: [],
        on: {
            onItemClick: function (id, e, node) {
                var item = this.getItem(id);
                this.hide();
                var fn = Function("_", "user", item.on_click);
                fn(_, user);
            }
        }
    });
    var subChucNangExcel = webix.ui({
        view: "submenu",
        width: 300,
        padding: 0,
        data: [],
        on: {
            onItemClick: function (id, e, node) {

                var item = this.getItem(id);
                this.hide();
                var fn = Function("_", "user", item.on_click);
                fn(_, user);
            }
        }
    });

    var initUI = function () {
        webix.ajax()
            .headers({ 'Content-type': 'application/json' })
            .get(app.config.host + "/System/GetCheckboxTienthue", function (response) {
                var json = JSON.parse(response);

                if (!json.hasOwnProperty("error")) {
                    if (json.opt == "K") {
                        checkbox_thue = 1;
                    }
                    else {
                        if (json.opt == "C") {
                            checkbox_thue = 0;
                        }
                    }
                }
            });
        var windowno = app.path[1].params[0];

        col = [];
        sub_col = [];
        var app_cache1 = webix.storage.local.get("PATH");

        var url = app.config.host + "/System/ExeCmd";
        var dataPost = {
            cmd: "CM0001",
            param: {
                WINDOW_ID: windowno
            }
        };

        webix.ajax()
            .headers({ 'Content-type': 'application/json' })
            .post(url, dataPost, function (text) {
                var data = JSON.parse(text);
                var json = data.data;
                if (data.length > 0) {
                    webix.$$("title").parse({ title: app_cache1, details: json[0]["details"], url_help: json[0]["url_help"] == null || undefined ? "http://huongdansudung.minvoice.com.vn/" : json[0]["url_help"] });
                }
            });
        // webix.ajax(url, function (text) {
        //     var json = JSON.parse(text);
        //     if (json.length > 0) {
        //         webix.$$("title").parse({ title: app_cache1, details: json[0]["details"], url_help: json[0]["url_help"] == null || undefined ? "http://huongdansudung.minvoice.com.vn/" : json[0]["url_help"] });
        //     }
        // });

        url = app.config.host + "/System/ExecuteCommand";

        $$("tlbMain").removeView("btnChucNang");
        $$("tlbMain").removeView("btnChucNangExcel");

        webix.ajax()
            .headers({ 'Content-type': 'application/json' })
            .post(url, {
                command: "CM00004",
                parameter: {
                    window_id: windowno
                }
            }, function (text) {
                var json = JSON.parse(text);

                if (json.length > 0) {
                    $$("cbMauIn").define("options", json);
                    $$("cbMauIn").setValue(json[0].id);
                    $$("cbMauIn").show();
                    $$("cbTypeIn").show();
                    $$("btnPrint").show();
                }
                else {
                    $$("cbMauIn").define("options", []);
                    $$("cbMauIn").hide();
                    $$("cbTypeIn").hide();
                    $$("btnPrint").hide();
                }

                $$("cbMauIn").refresh();
            });

        if (windowno === "WIN00015") {
            var btnDecreaseTax = {
                view: "button", type: "htmlbutton", width: 140,
                label: '<i class="fa fa-edit fa-lg aria-hidden="true"></i><span class="text"> Cập nhật thuế suất</span>',
                id: "btnDecreaseTax",
                icon: "fas fa-edit",
                click: function () {
                    webix.callEvent("onLoadError");
                    var modalForm = $$("windowData").$scope.ui(dmhanghoas.$ui);
                    modalForm.show();
                }
            };
            $$("tlbMain").addView(btnDecreaseTax, 7);
        }
        webix.ajax()
            .headers({ 'Content-type': 'application/json' })
            .post(url,
                {
                    command: "CM00002",
                    parameter: {
                        window_id: windowno
                    }
                }, function (text) {
                    var json = JSON.parse(text);

                    if (buttons.length > 0) {
                        for (var i = 0; i < buttons.length; i++) {
                            var item = buttons[i];
                            $$("tlbMain").removeView(item.id);
                        }
                    }

                    buttons = [];
                    var menus = [];
                    var menusExcel = [];
                    for (var i = 0; i < json.length; i++) {
                        var item = json[i];

                        if (item.chuc_nang == "C") {
                            if (item.hidden != 1) {
                                menus.push({
                                    id: item.name,
                                    value: _(item.caption),
                                    on_click: item.on_click
                                });
                            }
                        }
                        else {
                            if (item.chuc_nang == "N") {

                                if (item.hidden != 1) {
                                    menusExcel.push({
                                        id: item.name,
                                        value: _(item.caption),
                                        on_click: item.on_click
                                    });
                                }
                            }
                            else {
                                if (item.hidden != 1) {
                                    var fn = new Function(item.on_click);
                                    var button = {
                                        view: "button", type: "htmlbutton", width: item.width,
                                        label: '<i class="fa fa-' + item.icon + ' fa-lg aria-hidden="true"></i> ' +
                                            '<span class="text">' + _(item.caption) + '</span>',
                                        id: item.name,
                                        // label: _(item.caption),
                                        // view: "button",
                                        // type: "icon",
                                        // css: "webix_secondary",
                                        icon: "fas fa-" + item.icon,
                                        // width: item.width,
                                        click: fn
                                    };

                                    buttons.push(button);
                                    $$("tlbMain").addView(button, 7);
                                }
                            }
                        }
                    }

                    if (menus.length > 0) {
                        subChucNang.clearAll();
                        subChucNang.parse(menus, "json");

                        var index = $$("tlbMain").index($$("cbMauIn"));

                        var btnChucNang = {
                            view: "button", type: "htmlbutton", width: 120,
                            label: '<i class="fa fa-tasks fa-lg aria-hidden="true"></i> ' +
                                '<span class="text">' + _("CONG_CU") + '</span>',
                            id: "btnChucNang",
                            // label: _("CONG_CU"),
                            // view: "button",
                            // type: "icon",
                            // css: "webix_secondary",
                            // icon: "fas fa-tasks",
                            // width: 120,
                            click: function () {
                                subChucNang.show(webix.$$("btnChucNang").$view);
                            }
                        }

                        $$("tlbMain").addView(btnChucNang, index - 1);
                    }

                    if (menusExcel.length > 0) {
                        var item = {
                            id: "koaskvoksv",
                            value: _("Kết xuất Excel PM kế toán"),
                            on_click: 'var table = webix.$$("windowData");require(["app", "views/forms/excelAccounting"], function (app, excelAccounting) {var codeId=$$("tlbParams"); var childViews = codeId.getChildViews()[0]; var code = childViews.getValue(); var win = table.$scope.ui(excelAccounting.$ui);excelAccounting.initUI(code); win.show();});'
                        };
                        menusExcel.push(item);
                        subChucNangExcel.clearAll();
                        subChucNangExcel.parse(menusExcel, "json");
                        var index = $$("tlbMain").index($$("cbMauIn"));
                        var btnChucNangExcel = {
                            view: "button", type: "htmlbutton", width: 100,
                            label: '<i class="fa fa-cube fa-lg aria-hidden="true"></i> ' +
                                '<span class="text">' + _("CHUC_NANG") + '</span>',
                            id: "btnChucNangExcel",
                            // label: _("CHUC_NANG"),
                            // view: "button",
                            // type: "icon",
                            // css: "webix_secondary",
                            // icon: "fas fa-cube",
                            // width: 100,
                            click: function () {
                                subChucNangExcel.show(webix.$$("btnChucNangExcel").$view);
                            }
                        }
                        $$("tlbMain").addView(btnChucNangExcel, index - 2);
                    }
                });

        // lấy thông tin của window
        url = app.config.host + "/System/GetConfigWinByNo?id=" + windowno;

        webix.$$("windowData").getParentView().getParentView().getParentView().disable();
        webix.$$("windowData").getParentView().getParentView().getParentView().showProgress();

        var app_cache = webix.storage.local.get("APP_CACHE");
        // console.log(app_cache);
        //nếu có trong cache
        if (app_cache[windowno] != null) {
            windowconfig = app_cache[windowno];
            initComponents(windowconfig);
        }//không có cache
        else {
            webix.ajax(url, function (text, xml, xhr) {
                var rp = JSON.parse(text);
                windowconfig = rp;
                var app_cache = webix.storage.local.get("APP_CACHE");
                app_cache[windowno] = windowconfig;
                webix.storage.local.put("APP_CACHE", app_cache);
                initComponents(windowconfig);
            });
        }
    };

    var initComponents = function (_windowconfig) {
        // console.log(_windowconfig);
        var k = Object.keys(_windowconfig['data'][0]['Tabs']).length;
        //console.log(k);
        var vc_window = _windowconfig["data"][0];

        var tabs = vc_window.Tabs;
        var qrCode = vc_window.QrCode;
        var windowno = vc_window.window_id;

        if (vc_window.window_type == "MasterDetail") {
            col.push({
                id: "subRow",
                header: "&nbsp;",
                template: "{common.subrow()}",
                width: 40,
                css: "nampvsub",
                height: 25
            });
        }

        var masterTab = tabs[0];
        //console.log(masterTab);

        if (masterTab.insert_cmd == "" || masterTab.insert_cmd == null) {
            $$("btnPlus").hide();
            $$("btnCopy").hide();
        }
        else {
            $$("btnPlus").show();
            $$("btnCopy").show();
        }

        if (masterTab.update_cmd == "" || masterTab.update_cmd == null) {
            $$("btnEdit").hide();
        }
        else {
            $$("btnEdit").show();
        }

        if (masterTab.delete_cmd == "" || masterTab.delete_cmd == null) {
            $$("btnDelete").hide();
        }
        else {
            $$("btnDelete").show();
        }

        for (var j = 0; j < masterTab.Fields.length; j++) {

            var field = masterTab.Fields[j];

            if (field.hide_in_grid == true) {
                continue;
            }

            var item = {
                id: field.column_name,
                header: _(field.column_name),
                columnType: field.column_type,
                template: field.template,
                columnFormat: field.format
            };

            if (field.caption != null) {
                item.header = _(field.caption);
            }

            if (field.column_type == "decimal") {
                item.css = { "text-align": "right" };
                item.format = webix.Number.numToStr({
                    groupDelimiter: ".",
                    groupSize: 3,
                    decimalDelimiter: ",",
                    decimalSize: field.data_decimal
                });

                item.footer = { content: "summColumn", height: "22" };
            }

            if (field.type_filter != null) {
                if (field.type_filter != "") {
                    if (field.type_filter == "serverSelectFilter" || field.type_filter == "numberFilter") {
                        item.header = [_(item.header), { content: field.type_filter }];
                        item.options = "";
                        if (field.ref_id != "" && field.ref_id != null) {
                            item.options = app.config.host + "/System/GetDataByReferencesId?id=" + field.ref_id;
                        }
                    }
                    else {
                        if (field.type_filter == "checkboxFilter") {
                            item.header = [_(item.header), {
                                content: field.type_filter
                                , compare: function (value, filter) {
                                    if (filter == "thirdState") return 1;
                                    return value == filter
                                }
                            }];
                            item.cssFormat = function (value, obj) {
                                if (obj.status) return "row-marked";
                                return "";
                            };
                        }
                        else {
                            item.header = [_(item.header), { content: field.type_filter }]
                        }

                    }
                }
            }

            if (field.type_editor == "combo") {
                item.editor = field.type_editor;
                item.options = app.config.host + "/System/GetDataByReferencesId?id=" + field.ref_id;
            }

            if (field.column_type == "date" || field.column_type == "datetime") {
                item.format = function (text) {
                    var format = webix.Date.dateToStr(this.columnFormat);
                    text = removeTimeZoneT(text);
                    return format(text);
                };
            }

            if (field.column_width == null) {
                item.fillspace = true;
            }
            else {
                item.width = field.column_width;
            }

            col.push(item);
        }
        // lấy trạng thái thanh toán VNPay
        if (windowno == "WIN00187" || windowno == "WIN00189" || windowno == "WIN00192" || windowno == "WIN00193") {
            $$("windowData").define("footer", true);
            if (qrCode != undefined) {
                if (qrCode[0].gia_tri == "VNPAY") {
                    col.push(
                        {
                            id: "thanh_toan", header: "", width: 40, tooltip: "Trạng thái thanh toán", columnType: "bit",
                            template: function (obj) {
                                if (obj.thanh_toan == true) {
                                    return "<span style='color: #00b300'><i class='fas fa-check'></i></span> "
                                }
                                else {
                                    return "<span style='color: red'><i class='fas fa-times'></i></span> "
                                }
                                // return "<span style='color: #00b300'><i class='fas fa-check'></i></span> "
                            }
                        },
                        {
                            id: "get_tt_thanhtoan", header: "", width: 40, tooltip: "Cập nhật trạng thái thanh toán",
                            template: function (obj) {
                                return "<div class='webix_el_button'><button class='webixtype_base'><i class='fa fa-refresh' aria-hidden='true'></i></button></div>";
                            }
                        });
                }
            }
        }
        else {
            $$("windowData").define("footer", false);
        }
        var table = $$("windowData");
        table.clearAll();

        if (vc_window.window_type == "MasterDetail") {

            var cells = [];

            for (var i = 0; i < tabs.length; i++) {
                var tab = tabs[i];

                if (tab.tab_type == "Master") {
                    continue;
                }

                var subCols = [];

                for (var j = 0; j < tab.Fields.length; j++) {
                    var field = tab.Fields[j];

                    if (field.hide_in_grid == true) {
                        continue;
                    }

                    var subCol = {
                        id: field.column_name,
                        header: [field.caption == null ? _(field.column_name) : _(field.caption), { content: "textFilter" }],
                        hidden: field.hide_in_grid
                    };

                    if (field.column_type == "date" || field.column_type == "datetime") {
                        subCol.format = function (text) {
                            var format = webix.Date.dateToStr("%d/%m/%Y");
                            text = removeTimeZoneT(text);
                            return format(text);
                        };
                    }

                    if (field.column_type == "decimal") {
                        subCol.css = { "text-align": "right" };
                        subCol.format = webix.Number.numToStr({
                            groupDelimiter: ".",
                            groupSize: 3,
                            decimalDelimiter: ",",
                            decimalSize: field.data_decimal
                        });
                    }

                    if (field.column_width == null) {
                        subCol.fillspace = true;
                    }
                    else {
                        subCol.width = field.column_width;
                    }

                    subCols.push(subCol);
                }

                if (tab.tab_type == "Detail") {
                    var item = {
                        header: tab.tab_name,
                        select: "cell",
                        css: "ca",
                        body: {
                            view: "datatable",
                            tab_table: tab.tab_table,
                            margin: 10,
                            height: 220,
                            columns: subCols,
                            on: {
                                onBeforeLoad: function () {
                                    this.showOverlay(_("LOADING") + "...");
                                },
                                onAfterLoad: function () {
                                    this.hideOverlay();
                                }
                            }
                        }
                    };

                    cells.push(item);
                }
            }

            var subview = {
                borderless: true,
                view: "tabview",
                height: 285,
                scrollX: true,
                css: "subInvoice",
                cells: cells,
                // tabbar: {
                //     close: true
                // },
                multiview: {
                    fitBiggest: true
                }
            };

            table.define("subview", subview);
        }

        table.define("windowno", windowno);
        table.define("leftSplit", vc_window.fix_left == null ? 0 : vc_window.fix_left);
        table.define("rightSplit", vc_window.fix_right == null ? 0 : vc_window.fix_right);

        table.config.infoparam = null;
        table.config.columns = col;
        table.config.ma_ct = vc_window.ma_ct;
        table.config.hint_base = vc_window.hint_base;
        table.refreshColumns();

        var parentToolBar = $$("tlbMain").getParentView();
        parentToolBar.removeView("tlbParams");

        // toolBar windown parram  
        if (vc_window.WinParams !== undefined) {

            var toolBarParams = {
                id: "tlbParams",
                view: "toolbar",
                borderless: true,
                height: 35,
                cols: []
            }

            for (var i = 0; i < vc_window.WinParams.length; i++) {
                var item = vc_window.WinParams[i];

                var comp = {
                    id: webix.uid(),
                    view: item.type_editor,
                    width: item.width,
                    labelWidth: 60,
                    label: _(item.caption),
                    value_field: item.value_field,
                    isDefault: item.isDefault,
                    on: {}
                };

                if (comp.view == "combo") {
                    comp.options = {
                        body: {
                            comboId: comp.id,
                            isDefault: item.isDefault,
                            url: app.config.host + "/System/GetDataByReferencesId?id=" + item.ref_id,
                            ready: function () {
                                if (this.config.isDefault == "C") {
                                    var count = this.count();
                                    var ctthongbao_id = app.path[1].params[1];
                                    //console.log(ctthongbao_id);
                                    if (ctthongbao_id != undefined) {
                                        var combo = webix.$$(this.config.comboId);
                                        combo.setValue(ctthongbao_id);
                                    }
                                    else {
                                        if (count > 0) {
                                            var combo = webix.$$(this.config.comboId);
                                            combo.setValue(this.getFirstId());
                                        }
                                    }
                                }
                            }
                        }
                    };

                    comp.on.onChange = function (newv, oldv) {
                        var table = $$("windowData");
                        table.clearAll();
                        table.load(table.config.url);
                    }
                }
                if (comp.view == "treesuggest") {

                    var listColumns = JSON.parse(item.list_column);

                    for (var v = 0; v < listColumns.length; v++) {
                        listColumns[v].header = _(listColumns[v].header);
                    }

                    comp.view = "combo";

                    comp.options = {
                        view: "treesuggest",
                        textValue: item.display_field,
                        isDefault: item.isDefault,
                        url: {
                            $proxy: true,
                            load: function (view, callback, params) {
                                var url = app.config.host + "/System/GetDataByReferencesId?id=" + item.ref_id;

                                webix.ajax(url, function (text) {
                                    var json = JSON.parse(text);
                                    var data = listToTree(json);
                                    view.parse(data, "json");
                                });
                            }
                        },
                        body: {
                            isDefault: item.isDefault,
                            comboId: comp.id,
                            columns: listColumns,
                            refid: item.wb_references_id,
                            filterMode: {
                                level: false,
                                showSubItems: false
                            },
                            ready: function () {
                                if (this.config.isDefault == "C") {
                                    var count = this.count();

                                    if (count > 0) {
                                        var combo = webix.$$(this.config.comboId);
                                        combo.setValue(this.getFirstId());
                                    }
                                }
                            }
                        }
                    };

                    comp.on.onChange = function (newv, oldv) {
                        var table = $$("windowData");
                        table.clearAll();
                        table.load(table.config.url);
                    }
                }
                toolBarParams.cols.push(comp);
            }
            parentToolBar.addView(toolBarParams);
        }

        var url = {
            $proxy: true,
            load: function (view, callback, params) {
                var windowno = app.path[1].params[0];
                var url = app.config.host + "/System/GetDataByWindowNo?window_id=" + windowno;

                var start = null;
                var count = null;
                var filter = [];
                var infoparam = null;
                var tlbparam_s = [];

                if (params == null) {
                    url = url + "&start=0&count=" + view.config.datafetch + "&continue=null&filter=null";
                    start = 0;
                    count = view.config.datafetch;
                }
                else {
                    url = url + "&start=" + params.start + "&count=" + params.count + "&continue=" + params.continue;
                    start = params.start;
                    count = params.count;
                    if (params.filter != null) {
                        var array = [];

                        for (var property in params.filter) {

                            var column = view.getColumnConfig(property);

                            if (column !== undefined) {
                                var item = {
                                    columnName: property,
                                    columnType: column.columnType,
                                    value: params.filter[property]
                                };
                                array.push(item);
                            }
                        }

                        if (array.length > 0) {
                            filter = array;
                            url = url + "&filter=" + JSON.stringify(array);
                        }
                        else {
                            url = url + "&filter=null";
                        }
                    }
                    else {
                        url = url + "&filter=null";
                    }
                }

                if (view.config.infoparam != null) {
                    infoparam = view.config.infoparam;
                    url = url + "&infoparam=" + JSON.stringify(view.config.infoparam);
                }
                else {
                    url = url + "&infoparam=null";
                }

                var tlbParams = $$("tlbParams");

                if (tlbParams !== undefined) {
                    var childViews = tlbParams.getChildViews();

                    var parameters = [];

                    for (var i = 0; i < childViews.length; i++) {
                        var child = childViews[i];

                        var id = child.config.id;
                        var value_field = child.config.value_field;

                        var item = {
                            columnName: value_field,
                            value: $$(id).getValue()
                        };

                        parameters.push(item);
                    }
                    tlbparam_s = parameters;
                    url = url + "&tlbparam=" + JSON.stringify(parameters);

                }
                else {
                    url = url + "&tlbparam=null";
                }

                var item = {
                    window_id: windowno,
                    start: start,
                    count: count,
                    filter: filter,
                    infoparam: infoparam,
                    tlbparam: tlbparam_s
                };
                var url1 = app.config.host + "/System/GetDataByWindowNo1";
                webix.ajax()
                    .headers({ 'Content-type': 'application/json' })
                    .bind(view)
                    .post(url1, item, callback, view);

                // webix.ajax().headers({ 'Content-type': 'application/json' })
                //     .bind(view)
                //     .post(url, item, function (text) {
                //         var json = JSON.parse(text);

                //         this.clearAll();

                //         if (!json.hasOwnProperty("error")) {
                //             this.bind(json);
                //             // this.refresh();
                //             // table.parse(json.data, "json");
                //         }
                //     });

                //    webix.ajax(url, callback, view);
            }
        };

        table.define("url", url);

        // if (windowno != "WIN00187" && windowno != "WIN00189" && windowno != "WIN00193" && windowno != "WIN00192" && windowno != "WIN00194") {
        //     $$("btnZNS").hide();
        // }
        // else {
        //     $$("btnZNS").show();
        // }

        if (vc_window.wb_infowindow_id != null) {
            if (vc_window.wb_infowindow_id != "") {
                $$("btnSearch").show();
                table.config.infowindow_id = vc_window.wb_infowindow_id;
            }
            else {
                $$("btnSearch").hide();
                table.config.infowindow_id = null;
            }
        }
        else {
            $$("btnSearch").hide();
            table.config.infowindow_id = null;
        }

        webix.$$("windowData").getParentView().getParentView().getParentView().enable();
        webix.$$("windowData").getParentView().getParentView().getParentView().hideProgress();
    }

    webix.ui({
        view: "contextmenu",
        id: "cmenu",
        autowidth: true,
        //css: { "background": "#ccc !important" },
        data: [
            { value: "Tải dữ liệu (F5)", icon: "far fa-refresh" },
            { value: "Thêm (F4)", icon: "far fa-plus" },
            { value: "Sửa (F3)", icon: "far fa-edit" },
            { value: "Xóa (F8)", icon: "far fa-trash" },
            { value: "Sao chép", icon: "far fa-files-o" },
            { $template: "Separator" }, { value: "Xem hóa đơn gốc", icon: "fas fa-file-text-o" },
            { value: "Gửi hóa đơn qua email", icon: "fas fa-envelope" },
            { value: "In hóa đơn", icon: "fas fa-print" },
            { value: "Lịch sử gửi Email", icon: "fas fa-history" }
        ],
        on: {
            onItemClick: function (id) {
                if (this.getItem(id).value == "Tải dữ liệu (F5)") {
                    $$("btnRefresh").callEvent("onClick");
                }
                if (this.getItem(id).value == "Thêm (F4)") {
                    $$("btnPlus").callEvent("onClick");
                }
                if (this.getItem(id).value == "Sửa (F3)") {
                    $$("btnEdit").callEvent("onClick");
                }
                if (this.getItem(id).value == "Xóa (F8)") {
                    $$("btnDelete").callEvent("onClick");
                }
                if (this.getItem(id).value == "Sao chép") {
                    $$("btnCopy").callEvent("onClick");
                }
                if (this.getItem(id).value == "Xem hóa đơn gốc") {
                    var table = webix.$$("windowData");
                    var item = table.getSelectedItem();
                    if (item == null) {
                        webix.message("Bạn chưa chọn hóa đơn", "error");
                        return;
                    }
                    //console.log(item);
                    if (item.inv_originalId != null && item.inv_originalId != undefined) {
                        var box = webix.modalbox({
                            title: "Đang in chứng từ",
                            text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                            width: 350,
                            height: 200
                        });

                        //var newWin = window.open();

                        webix.ajax()
                            .response("arraybuffer")
                            .headers({ 'Content-type': 'application/json' })
                            .get(app.config.host + "/Invoice/PrintInvoice?id=" + item.inv_originalId + "&type=PDF", {
                                error: function (text, data, XmlHttpRequest) {
                                    webix.modalbox.hide(box);
                                },
                                success: function (text, data, XmlHttpRequest) {
                                    var file = new Blob([data], { type: 'application/pdf' });
                                    var fileURL = URL.createObjectURL(file);

                                    webix.modalbox.hide(box);
                                    //newWin.location = fileURL;
                                    window.open(fileURL, '_blank');

                                }
                            });

                        // webix.ajax()
                        // .response("arraybuffer")
                        // .get(app.config.host + "/Invoice/PrintInvoice?id=" + item.inv_originalId + "&type=PDF", function (text, data) {
                        //     var file = new Blob([data], { type: 'application/pdf' });
                        //     var fileURL = URL.createObjectURL(file);
                        //     window.open(fileURL, '_blank');
                        //     // webix.html.download(file, $$('tenfile').getValue());
                        // });
                    }
                    else {
                        webix.message("Không tồn tại hóa đơn gốc !", "error");
                        return;
                    }
                }
                if (this.getItem(id).value == "Lịch sử gửi Email") {
                    var table = webix.$$("windowData");
                    var selectedItem = table.getSelectedItem();
                    if (selectedItem == null) {
                        webix.message("Bạn chưa chọn hóa đơn", "error");
                        return;
                    }
                    var detailForm = webix.$$("windowData").$scope.ui(his_email.$ui);
                    his_email.initUI(selectedItem.inv_InvoiceAuth_id);
                    detailForm.show();
                }
                if (this.getItem(id).value == "Gửi hóa đơn qua email") {
                    var table = webix.$$("windowData");
                    var selectedItem = table.getSelectedItem();
                    if (selectedItem == null) {
                        webix.message("Bạn chưa chọn hóa đơn", "error");
                        return;
                    }

                    if (selectedItem.trang_thai == "Chờ ký" || selectedItem.trang_thai == "Chờ duyệt") {
                        webix.message("Hóa đơn chưa được ký", "error");
                        return;
                    }

                    var url = "/Invoice/GetEmailTemplate?type=Gửi hóa đơn&id=" + selectedItem.inv_InvoiceAuth_id;

                    webix.ajax(app.config.host + url, function (text) {
                        var json = JSON.parse(text);

                        var win = webix.$$("windowData").$scope.ui(sendemail.$ui);
                        var check_bcc = $$("dmtab-form").elements.hasOwnProperty("bcc");
                        if (check_bcc) {
                            $$("dmtab-form").elements["bcc"].hide();
                        }
                        var item = {
                            nguoi_gui: json.nguoi_gui,
                            tieude: json.tieu_de,
                            noidung: json.noi_dung,
                            mat_khau: json.pass,
                            inv_InvoiceAuth_id: selectedItem.inv_InvoiceAuth_id,
                            type: "Gửi hóa đơn",
                            nguoinhan: selectedItem.inv_buyerEmail,
                            his_email: json.his_email
                        };
                        //console.log(sendemail);
                        url = app.config.host + "/Invoice/GetMailOptBCC";
                        webix.ajax(url, function (text) {
                            var json = JSON.parse(text);
                            if (json.length > 0) {
                                item.bcc = json[0].gia_tri;
                            }
                            sendemail.setValues(item);
                            win.show();
                        });
                    });
                }
                if (this.getItem(id).value == "In hóa đơn") {
                    var table = webix.$$("windowData");
                    var item = table.getSelectedItem();

                    if (item == null) {
                        webix.message("Bạn chưa chọn dữ liệu cần in", "error");
                        return;
                    }

                    var cbMauIn = $$("cbMauIn");
                    var cbTypeIn = $$("cbTypeIn");

                    var rpParameter = {
                        parameter: item,
                        wb_mauin_id: cbMauIn.getValue(),
                        type: cbTypeIn.getValue()
                    };

                    var mimetype = cbTypeIn.getValue() == "PDF" ? "application/pdf" : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

                    var url = app.config.host + "/System/InChungTu";

                    var box = webix.modalbox({
                        title: "Đang in chứng từ",
                        text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                        width: 350,
                        height: 200
                    });

                    var newWin = window.open();

                    webix.ajax()
                        .response("arraybuffer")
                        .headers({ 'Content-type': 'application/json' })
                        .post(url, rpParameter, {
                            error: function (text, data, XmlHttpRequest) {
                                webix.modalbox.hide(box);
                            },
                            success: function (text, data, XmlHttpRequest) {
                                var file = new Blob([data], { type: mimetype });
                                var fileURL = URL.createObjectURL(file);

                                webix.modalbox.hide(box);

                                // var win = $$("windowData").$scope.ui(printf.$ui);
                                // win.config.url = fileURL;
                                // win.show();

                                newWin.location = fileURL;
                            }
                        });
                }
            }
        }
    });

    var controls = [
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-refresh fa-lg" aria-hidden="true"></i> ' +
                '<span class="text">' + _("REFRESH") + '</span>',
            id: "btnRefresh",
            // view: "button",
            // type: "icon",
            // icon: "far fa-refresh",
            // label: _("REFRESH"),
            // width: 100,
            shortcut: "F5",
            // css: "webix_secondary",
            // shortcut: "F4",
            //css:"button_raised",
            on: {
                onClick: function () {
                    webix.callEvent("onLoadError");
                    var table = webix.$$("windowData");
                    table.clearAll();

                    table.load(table.config.url);
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-plus fa-lg" aria-hidden="true"></i> ' +
                '<span class="text">' + _("THEM") + " (F4)" + '</span>',
            id: "btnPlus",
            // view: "button",
            // type: "icon",
            // icon: "far fa-plus",
            // label: _("THEM") + " (F4)",
            // css: "webix_secondary",
            // width: 100,
            shortcut: "F4",
            //css:"button_raised",
            on: {
                onClick: function () {
                    webix.callEvent("onLoadError");
                    webix.$$("windowData").clearSelection();
                    var vc_window = windowconfig["data"][0];
                    windowform.$ui.id = vc_window.window_id;

                    var detailForm = this.$scope.ui(windowform.$ui);

                    windowform.setEditMode(0);
                    windowform.initUI(windowconfig, checkbox_thue);
                    if (vc_window.window_id != "WIN00187" && vc_window.window_id != "WIN00189" && vc_window.window_id != "WIN00192" && vc_window.window_id != "WIN00193") {
                        if (webix.$$("check_chietkhau") != undefined) {
                            webix.$$("check_chietkhau").hide();
                        }
                        if (webix.$$("check_tienthue") != undefined) {
                            webix.$$("check_tienthue").hide();
                        }
                    }

                    var params = null;

                    var tlbParams = $$("tlbParams");

                    if (tlbParams !== undefined) {
                        var childViews = tlbParams.getChildViews();

                        var item = [];
                        for (var i = 0; i < childViews.length; i++) {
                            var child = childViews[i];

                            var id = child.config.id;
                            var value_field = child.config.value_field;
                            // console.log(id);
                            item[value_field] = $$(id).getValue();
                        }
                        params = item;
                    }

                    windowform.setValues(null, windowconfig, params);
                    windowform.setEditMode(1);
                    if (vc_window.after_new != null) {
                        var fn = Function("app", "user", vc_window.after_new);
                        var result = fn(app, user);
                        if (result == false)
                            return;
                    }

                    detailForm.show();
                    windowform.focusFirstElement();

                    webix.delay(function () {
                        if (webix.$$("addrow") != undefined) {
                            webix.$$("addrow").callEvent("onItemClick");
                        }
                    });
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-edit fa-lg" aria-hidden="true"></i> ' +
                '<span class="text">' + _("SUA") + " (F3)" + '</span>',
            id: "btnEdit",
            // view: "button",
            // type: "icon",
            // icon: "far fa-edit",
            // label: _("SUA") + " (F3)",
            // width: 100,
            shortcut: "F3",
            // css: "webix_secondary",
            //css:"button_raised",
            on: {
                onClick: function () {
                    webix.callEvent("onLoadError");
                    var vc_window = windowconfig["data"][0];
                    windowform.$ui.id = vc_window.window_id;
                    var detailForm = this.$scope.ui(windowform.$ui);
                    var table = webix.$$("windowData");
                    var item = table.getSelectedItem();
                    if (item == null || item == undefined) {
                        webix.message("Bạn chưa chọn dòng cần sửa !", "error");
                        return;
                    }
                    // không cho sửa hóa đơn điều chỉnh, thay thế đang fix cứng 
                    if (vc_window.window_id == "WIN00187" || vc_window.window_id == "WIN00189" || vc_window.window_id == "WIN00192" || vc_window.window_id == "WIN00193") {
                        if (item.trang_thai_hd == 13 || item.trang_thai_hd == 15 || item.trang_thai_hd == 17) {
                            webix.message("Không thể sửa hóa đơn xóa bỏ. Bạn cần phải sử dụng chức năng tương ứng", "error");
                            return;
                        }
                    }

                    windowform.setEditMode(0);
                    windowform.initUI(windowconfig, checkbox_thue);
                    if (vc_window.window_id != "WIN00187" && vc_window.window_id != "WIN00189" && vc_window.window_id != "WIN00192" && vc_window.window_id != "WIN00193") {
                        if (webix.$$("check_chietkhau") != undefined) {
                            webix.$$("check_chietkhau").hide();
                        }
                        if (webix.$$("check_tienthue") != undefined) {
                            webix.$$("check_tienthue").hide();
                        }
                    }

                    windowform.setValues(item, windowconfig);
                    windowform.setEditMode(2);
                    if (vc_window.after_edit != null) {
                        var fn = Function("app", "_", "user", vc_window.after_edit);
                        var result = fn(app, _, user);
                        if (result == false)
                            return;
                    }
                    if (vc_window.window_id == "WIN00187" || vc_window.window_id == "WIN00189" || vc_window.window_id == "WIN00192" || vc_window.window_id == "WIN00193") {
                        if (item.hasOwnProperty("trang_thai")) {
                            if (item.trang_thai == "Đã ký") {
                                var form = $$("window-form").elements;
                                for (var key in form) {
                                    var $el = form[key];
                                    $el.define("readonly", "true")
                                    $el.define("css", "mcls_readonly_text")
                                    $el.refresh()
                                }

                                $$("btnSave").destructor();
                            }
                        }
                    }
                    detailForm.show();
                    windowform.focusFirstElement();

                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-trash fa-lg" aria-hidden="true"></i> ' +
                '<span class="text">' + _("XOA") + " (F8)" + '</span>',
            id: "btnDelete",
            // view: "button",
            // type: "icon",
            // icon: "fas fa-trash",
            // label: _("XOA") + " (F8)",
            // width: 100,
            shortcut: "F8",
            // css: "webix_secondary",
            //css:"button_raised",
            on: {
                onClick: function () {
                    webix.callEvent("onLoadError");
                    var table = webix.$$("windowData");
                    if (table.getColumnConfig("colMultiChoice") == undefined) {
                        var item = table.getSelectedItem();
                        if (item == null || item == undefined) {
                            webix.message("Bạn chưa chọn dòng cần xóa !", "error");
                            return;
                        }

                        var vc_window = windowconfig["data"][0];
                        if (vc_window.after_delete != null) {
                            var fn = Function("app", "user", vc_window.after_delete);
                            var result = fn(app, user);
                            if (result == false)
                                return;
                        }

                        var khData = {};
                        khData.windowid = windowconfig.data[0].window_id;
                        khData.editmode = 3;
                        khData.data = [];
                        khData.data.push(item);
                        var frm = webix.ui({
                            view: "window",
                            modal: true,
                            id: "window-delete",
                            position: "center",
                            move: true,
                            padding: 30,
                            css: { "border-radius": "6px" },
                            // resize: true,
                            // css: "headformchil",
                            head: {
                                height: 30,
                                cols: [
                                    {
                                        id: "head-formDelete", view: "template", css: "headform", template: function (obj) {
                                            return '<div style ="float:left; font-size:15px;"><i style="padding-right:8px;" class="fa fa-trash-o"></i> Xóa<div/>';
                                        }
                                    },
                                    {
                                        view: "icon", icon: "fas fa-times", id: "help_formDelete", tooltip: _("Đóng"), click: function () {
                                            $$("window-delete").close();
                                        }
                                    }
                                ]
                            },
                            body: {
                                paddingY: 10,
                                paddingX: 10,
                                view: "form",
                                id: "window-formdelete",
                                complexData: true,
                                keepViews: true,
                                multiview: { keepViews: true },
                                margin: 0,
                                elements: [
                                    { view: "template", height: 90, template: "<div style='padding-top:15px;'><center><b style='color:red;'>Bạn có chắc chắn muốn xóa ?</b></center></br><center>(Hãy cân nhắc trước khi xóa)</center><div>" },
                                    {
                                        cols: [
                                            { gravity: 0.3 },
                                            {
                                                id: "btnCo",
                                                view: "button",
                                                label: "Có",
                                                type: "form",
                                                align: "center",
                                                on: {
                                                    onClick: function () {
                                                        var form = webix.$$("window-delete");

                                                        webix.extend(form, webix.ProgressBar);
                                                        form.disable();
                                                        form.showProgress();

                                                        webix.ajax()
                                                            .headers({ 'Content-type': 'application/json' })
                                                            .post(app.config.host + "/System/Save", khData, function (text) {
                                                                form.enable();
                                                                form.hideProgress();
                                                                $$("window-delete").close();
                                                                var response = JSON.parse(text);

                                                                if (response.hasOwnProperty("error")) {
                                                                    webix.message({ type: "error", text: response.error });
                                                                    return;
                                                                }
                                                                table.remove(item.id);
                                                            });
                                                    }
                                                },
                                                click: function () {
                                                    $$("btnCo").callEvent("onClick");
                                                }
                                            },
                                            {
                                                view: "button", id: "btnKo", shortcut: "esc", label: "Không", type: "danger", align: "center",
                                                on: {
                                                    onClick: function () {
                                                        $$("window-delete").close();
                                                    }
                                                },
                                                click: function () {
                                                    this.callEvent("onClick");
                                                }
                                            },
                                            { gravity: 0.3 }
                                        ]
                                    }

                                ]
                            }
                        });

                        frm.show();
                    }
                    else {

                        var khData = {};
                        khData.windowid = windowconfig.data[0].window_id;
                        khData.editmode = 3;
                        khData.data = [];
                        khData.data.push(item);
                        var frm = webix.ui({
                            view: "window",
                            modal: true,
                            id: "window-delete",
                            position: "center",
                            move: true,
                            padding: 30,
                            // resize: true,
                            // css: "headformchil",
                            head: {
                                height: 30,
                                cols: [
                                    {
                                        id: "head-formDelete", view: "template", css: "headform", template: function (obj) {
                                            return '<div style ="float:left; font-size:15px;"><i style="padding-right:8px;" class="fa fa-trash-o"></i> Xóa<div/>';
                                        }
                                    },
                                    {
                                        view: "icon", icon: "fas fa-times", id: "help_formDelete", tooltip: _("Đóng"), click: function () {
                                            $$("window-delete").close();
                                        }
                                    }
                                ]
                            },
                            body: {
                                paddingY: 10,
                                paddingX: 10,
                                view: "form",
                                id: "window-formdelete",
                                complexData: true,
                                keepViews: true,
                                multiview: { keepViews: true },
                                margin: 0,
                                elements: [
                                    { view: "template", template: "<div style='padding-top:30px;'><center><b style='color:red;'>Bạn có chắc chắn muốn xóa ?</b></center></br><center>(Hãy cân nhắc trước khi xóa)</center><div>" },
                                    {
                                        cols: [
                                            { gravity: 0.3 },
                                            {
                                                id: "btnCo",
                                                view: "button",
                                                label: "Có",
                                                type: "form",
                                                align: "center",
                                                on: {
                                                    onClick: function () {
                                                        deleteMultiChoice();
                                                    }
                                                },
                                                click: function () {
                                                    $$("btnCo").callEvent("onClick");
                                                }
                                            },
                                            {
                                                view: "button", id: "btnKo", shortcut: "esc", label: "Không", type: "danger", align: "center",
                                                on: {
                                                    onClick: function () {
                                                        $$("window-delete").close();
                                                    }
                                                },
                                                click: function () {
                                                    this.callEvent("onClick");
                                                }
                                            },
                                            { gravity: 0.3 }
                                        ]
                                    }
                                ]
                            }
                        });
                        frm.show();
                    }
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-files-o fa-lg" aria-hidden="true"></i> ' +
                '<span class="text">' + _("COPY") + '</span>',
            id: "btnCopy",
            // view: "button",
            // type: "icon",
            // icon: "far fa-files-o",
            // label: _("COPY"),
            // width: 100,
            // css: "webix_secondary",
            on: {
                onClick: function () {
                    webix.callEvent("onLoadError");
                    var table = webix.$$("windowData");
                    var item = table.getSelectedItem();

                    if (item == null) {
                        webix.message("Bạn chưa chọn dòng dữ liệu", "debug");
                        return;
                    }

                    var vc_window = windowconfig["data"][0];
                    windowform.$ui.id = vc_window.window_id;

                    var detailForm = this.$scope.ui(windowform.$ui);

                    windowform.setEditMode(0);
                    windowform.initUI(windowconfig, checkbox_thue);
                    windowform.setEditMode(1);
                    windowform.copyValues(item, windowconfig);
                    if (vc_window.after_new != null) {
                        var fn = Function("app", "user", vc_window.after_new);
                        var result = fn(app, user);
                        if (result == false)
                            return;
                    }
                    detailForm.show();
                    windowform.focusFirstElement();

                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        // {
        //     view: "button",
        //     // type: "htmlbutton", 
        //     width: 110, type: "image",
        //     // css:"webix_transparent",
        //     image: "assets/imgs/zalo.png",
        //     label: '<span class="text">' + _("Gửi Zalo") + '</span>',
        //     id: "btnZNS",
        //     // hidden: true,
        //     // view: "button",
        //     // type: "icon",
        //     // icon: "far fa-search",
        //     // label: _("SEARCH") + " (F2)",
        //     // width: 100,
        //     // css: "webix_secondary",
        //     shortcut: "F2",
        //     on: {
        //         onClick: function () {
        //             webix.callEvent("onLoadError");
        //             var table = webix.$$("windowData");
        //             var item = table.getSelectedItem();
        //              if (item == null || item == undefined) {
        //                 webix.message("Bạn chưa chọn dòng cần gửi tin !", "error");
        //                 return;
        //             }
        //             var zalo = this.$scope.ui(sendZNS.$ui);

        //             // ajax call thông tin hóa đơn + mst bên bán + số lần gửi tin
        //             var url = app.config.host + "/Invoice/beforeZNS?id=" + item.id;
        //             webix.ajax().get(url, function (res) {
        //                 var data = JSON.parse(res);
        //                 sendZNS.setValues(item.id, data);
        //                 zalo.show();
        //             });

        //         }
        //     },
        //     click: function () {
        //         this.callEvent("onClick");
        //     }
        // },
        {
            view: "button", type: "htmlbutton", width: 110,
            label: '<i class="fa fa-search fa-lg" aria-hidden="true"></i> ' +
                '<span class="text">' + _("SEARCH") + " (F2)" + '</span>',
            id: "btnSearch",
            // view: "button",
            // type: "icon",
            // icon: "far fa-search",
            // label: _("SEARCH") + " (F2)",
            // width: 100,
            // css: "webix_secondary",
            shortcut: "F2",
            on: {
                onClick: function () {
                    webix.callEvent("onLoadError");
                    var table = webix.$$("windowData");

                    infowindow.$ui.id = table.config.infowindow_id;
                    infowindow.$ui.load_event = "filterTable";

                    var wininfoparam = this.$scope.ui(infowindow.$ui);

                    if (table.config.infoparam != undefined) {
                        wininfoparam.config.editmode = 1;
                        wininfoparam.config.formvalues = table.config.infoparam.parameter;
                    }
                    else {
                        wininfoparam.config.editmode = 0;
                        wininfoparam.config.formvalues = null;
                    }

                    infowindow.initUI(table.config.infowindow_id);
                    wininfoparam.show();
                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {
            view: "button", type: "htmlbutton", width: 100,
            label: '<i class="fa fa-print fa-lg" aria-hidden="true"></i> ' +
                '<span class="text">' + _("PRINT") + " (F7)" + '</span>',
            id: "btnPrint",
            // view: "button",
            // type: "icon",
            // icon: "fas fa-print",
            // label: _("PRINT") + " (F7)",
            // width: 100,
            shortcut: "F7",
            // css: "webix_secondary",
            on: {
                onClick: function () {
                    webix.callEvent("onLoadError");
                    var table = webix.$$("windowData");
                    if (table.getColumnConfig("colMultiChoice") == undefined) {
                        var item = table.getSelectedItem();

                        if (item == null) {
                            webix.message("Bạn chưa chọn dữ liệu cần in", "error");
                            return;
                        }
                        var mst = version.getMST();
                        if (mst == "4900239158") {
                            var url = app.config.host + "/Invoice/GetById?id=" + item.inv_InvoiceAuth_id;

                            var xhr = webix.ajax().sync().get(url);
                            var json = JSON.parse(xhr.response);

                            if (json.check_in == true) {
                                var detailForm = this.$scope.ui(frmPassPrint.$ui);
                                frmPassPrint.initUI(item);
                                frmPassPrint.setEditMode(1);
                                detailForm.show();
                                return;
                            }
                        }
                        var cbMauIn = $$("cbMauIn");
                        var cbTypeIn = $$("cbTypeIn");

                        var rpParameter = {
                            parameter: item,
                            wb_mauin_id: cbMauIn.getValue(),
                            type: cbTypeIn.getValue()
                        };

                        var mimetype = cbTypeIn.getValue() == "PDF" ? "application/pdf" : cbTypeIn.getValue() == "CSV" ? "application/csv" : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

                        var url = app.config.host + "/System/InChungTu";

                        var box = webix.modalbox({
                            title: "Đang in chứng từ",
                            text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
                            width: 350,
                            height: 200
                        });

                        var newWin = window.open();
                        var html = '<html><head><title>Hóa đơn điện tử M-Invoice</title>'
                            + '<link rel="stylesheet" href="assets/fontawesome_pro/css/all.css" type="text/css" charset="utf-8">'
                            + '<link rel="stylesheet" href="assets/fontawesome.css" type="text/css" charset="utf-8">'
                            + '</head><body><center>Đang tải dữ liệu ... <br><p><i style="font-size:200%;" class="fa fa-spin fa-spinner"></i></p></center></body></html>';
                        newWin.document.write(html);

                        webix.ajax()
                            .response("arraybuffer")
                            .headers({ 'Content-type': 'application/json' })
                            .post(url, rpParameter, {
                                error: function (text, data, XmlHttpRequest) {
                                    webix.modalbox.hide(box);
                                },
                                success: function (text, data, XmlHttpRequest) {

                                    if (cbTypeIn.getValue() == "CSV") {
                                        var file = new Blob([data], { type: mimetype });
                                        webix.html.download(file, item.inv_invoiceNumber + ".csv");
                                        webix.modalbox.hide(box);
                                        newWin.close();
                                    }
                                    else {
                                        var file = new Blob([data], { type: mimetype });
                                        var fileURL = URL.createObjectURL(file);
                                        webix.modalbox.hide(box);
                                        // var win = $$("windowData").$scope.ui(printf.$ui);
                                        // win.config.url = fileURL;
                                        // win.show();
                                        newWin.location = fileURL;
                                    }
                                }
                            });
                        // var btnRefresh = $$("btnRefresh");
                        // btnRefresh.callEvent("onClick");
                    }
                    else {
                        var window_id = windowconfig["data"][0].window_id;
                        var arr = ["WIN00187", "WIN00189", "WIN00192", "WIN00193", "WIN00194", "WIN00195", "WIN00196"];
                        if (arr.indexOf(window_id) == -1) {
                            webix.message("In nhiều chứng từ chỉ áp dụng cho hóa đơn !", "error");
                            return;
                        }
                        else {
                            printMultiChoice();
                        }

                    }

                }
            },
            click: function () {
                this.callEvent("onClick");
            }
        },
        {},
        {
            view: "richselect",
            label: _("MAUIN"),
            width: 250,
            labelWidth: 50,
            id: "cbMauIn"
        },
        {
            view: "richselect",
            //label: _("MAUIN"),
            width: 80,
            labelWidth: 50,
            css: "cbTypePrint",
            id: "cbTypeIn",
            value: "PDF", options: [
                { "id": "PDF", "value": "PDF" },
                { "id": "Excel", "value": "EXCEL" },
                { "id": "CSV", "value": "CSV" }
            ]
        }
    ]

    var grid = {
        rows: [
            {
                id: "windowData",
                view: "datatable",
                select: true,
                datafetch: 50,
                resizeColumn: true,
                resizeRow: true,
                columns: col,
                tooltip: true,
                leftSplit: 0,
                footer: false,
                rightSplit: 0,
                headermenu: {
                    autoheight: false,
                    scroll: true,
                    autowidth: true
                },
                multiview: { keepViews: true },
                keepViews: true,
                hover: "myhover",
                ready: function () {

                },
                on: {
                    onItemClick: function (id) {
                        if (id.column == "get_tt_thanhtoan") {
                            var item = this.getItem(id);
                            if (item.thanh_toan == true) {
                                webix.message("Hóa đơn đã thanh toán", "success");
                                return;
                            }
                            webix.extend(this, webix.ProgressBar);
                            this.disable();
                            this.showProgress();

                            webix.ajax()
                                .headers({ 'Content-type': 'application/json' })
                                .post(app.config.host + "/Invoice/VNPayStatus", item, function (text) {
                                    $$("windowData").enable();
                                    $$("windowData").hideProgress();
                                    var json = JSON.parse(text);

                                    if (!json.hasOwnProperty("error")) {
                                        if (json.ok == true) {
                                            item.thanh_toan = true;
                                            $$("windowData").updateItem(id, item);

                                        }
                                        else {
                                            webix.message(json.message, "error", 2000);
                                        }
                                    }
                                    else {
                                        // nếu không tồn tại mã số thuế phải xóa địa chỉ + tên cty ở đây 
                                        webix.message(json.error, "error", 2000);
                                    }

                                });

                        }
                    },
                    onSubViewCreate: function (view, item) {
                        var subView = view;

                        if (subView != null) {
                            var windowno = app.path[1].params[0];

                            var url = app.config.host + "/System/GetDataDetailsByTabTable?window_id=" + windowno
                                + "&id=" + item.id;

                            var detailTables = subView.getChildViews()[1].getChildViews();

                            for (var i = 0; i < detailTables.length; i++) {
                                var dt = detailTables[i];
                                dt.clearAll();
                                dt.load(url + "&tab_table=" + dt.config.tab_table);
                            }
                        }

                    },
                    onSubViewOpen: function (id) {
                        var table = this;
                        var subView = table.getSubView(id);

                        if (subView != null) {
                            var windowno = app.path[1].params[0];

                            var url = app.config.host + "/System/GetDataDetailsByTabTable?window_id=" + windowno
                                + "&id=" + id.row;

                            var detailTables = subView.getChildViews()[1].getChildViews();

                            for (var i = 0; i < detailTables.length; i++) {
                                var dt = detailTables[i];
                                dt.clearAll();
                                dt.load(url + "&tab_table=" + dt.config.tab_table);
                            }
                        }
                    },
                    onItemDblClick: function (id, e, node) {
                        var btnEdit = $$("btnEdit");
                        btnEdit.callEvent("onClick");
                    },
                    onBeforeLoad: function () {
                        this.showOverlay("<p style='padding-top:160px;'><i style='font-size:450%;' class='fa fa-spin fa-spinner fa-pulse'></i></p>");
                    },

                    onAfterLoad: function (id) {
                        this.hideOverlay();
                        var windowno = app.path[1].params[0];
                        if (windowno != "WIN00187" && windowno != "WIN00189" && windowno != "WIN00193" && windowno != "WIN00192" && windowno != "WIN00194") {
                            $$("cmenu").clearAll();
                            var menu = [
                                { value: "Tải dữ liệu (F5)", icon: "far fa-refresh" },
                                { value: "Thêm (F4)", icon: "far fa-plus" },
                                { value: "Sửa (F3)", icon: "far fa-edit" },
                                { value: "Xóa (F8)", icon: "far fa-trash" },
                                { value: "Sao chép", icon: "far fa-files-o" }
                            ];
                            $$("cmenu").parse(menu);
                            $$("cmenu").attachTo($$("windowData"));
                        }
                        else {
                            $$("cmenu").clearAll();
                            var menu = [
                                { value: "Tải dữ liệu (F5)", icon: "far fa-refresh" },
                                { value: "Thêm (F4)", icon: "far fa-plus" },
                                { value: "Sửa (F3)", icon: "far fa-edit" },
                                { value: "Xóa (F8)", icon: "far fa-trash" },
                                { value: "Sao chép", icon: "far fa-files-o" },
                                { $template: "Separator" }, { value: "Xem hóa đơn gốc", icon: "fas fa-file-text-o" },
                                { value: "Gửi hóa đơn qua email", icon: "fas fa-envelope" },
                                { value: "In hóa đơn", icon: "fas fa-print" },
                                { value: "Lịch sử gửi Email", icon: "fas fa-history" }
                            ];
                            $$("cmenu").parse(menu);
                            $$("cmenu").attachTo($$("windowData"));
                        }
                    }
                },
                subview: {
                    borderless: true,
                    view: "tabview",
                    height: 200,
                    // css: "subInvoice",
                    scrollX: true,
                    tabbar: {
                        width: 200
                    },
                    cells: []
                },
                pager: "pagerA"
            },
            {
                cols: [
                    {
                        view: "button",
                        type: "icon",
                        icon: "fas fa-th-list",
                        tooltip: "chọn nhiều chứng từ",
                        width: 30,
                        on: {
                            onClick: function () {
                                changeMultiChoice();
                            }
                        },
                        click: function () {
                            this.callEvent("onClick");
                        }
                    },
                    {
                        view: "icon", icon: "fas fa-question-circle", id: "help_form_views", tooltip: _("HELPER"),
                        css: "helper",
                        // click: function () {
                        //     this.callEvent("onClick");
                        // }
                        click: function () {
                            var form = webix.$$("windowData");
                            hint_base(form.config.hint_base);
                        }
                    },
                    {
                        view: "combo",
                        // width: 450,
                        label: _("MENU_QUICK"),
                        id: "QuickMenu",
                        options: {
                            view: "gridsuggest",
                            id: "grid_window",
                            // filter: function (obj, value) {
                            //     var string = "";
                            //     if (obj) {
                            //         string += obj.id + " ";
                            //         string += obj.window_name + " ";

                            //     }
                            //     return string.toLowerCase().indexOf(value.toLowerCase()) >= 0;
                            // },
                            // template: function (item) {
                            //     return item.name + " ";
                            //},
                            template: "#name#",
                            // width: 550,
                            body: {
                                scroll: true,
                                autoheight: false,
                                columns: [
                                    { id: "window_id", header: "Window Id", editor: "text", width: 100 },
                                    { id: "name", header: "Window Name", editor: "text", width: 400 }
                                ],
                                url: app.config.host + "/System/GetQuickMenu"
                            },
                            on: {
                                onValueSuggest: function (obj) {
                                    var start = obj.window_id != "" ? obj.code + ":" + obj.window_id : obj.code;
                                    // console.log(app.$scope);
                                    // console.log(this.$scope);
                                    // window.location.hash = "!/app/" + start;
                                    // this.$scope.show("./" + start);
                                    app.router("/app/" + start);
                                    $$("QuickMenu").setValue(null);
                                }
                            }
                        },
                        // suggest: {
                        // 	url: app.config.host + "/WbWindow/All",
                        // 	template: "#window_name#",
                        // 	body: {
                        // 		template: "#window_name#"
                        // 	}
                        // },
                        on: {
                            onChange: function (newv, oldv) {

                            }
                        }
                    },
                    {},
                    {
                        id: "pagerA",
                        view: "pager",
                        size: 50,
                        group: 5,
                        // animate: { direction:"top" },
                        template: function (data, common) {
                            // console.log(data);
                            return "Số dòng: " + data.count + ". " + common.first(data) + common.prev(data) + common.pages(data) + common.next(data) + common.last(data);
                            //return "{common.first()} {common.prev()} {common.pages()} {common.next()} {common.last()}";
                        }
                    },
                    {}
                ]
            }
            // {height:2,css:{"border-bottom":"1px solid red !important"}}
        ]
    }
    var hint_base = function (hint) {
        if (hint == undefined || hint == null || hint == "") {
            webix.alert({
                title: "Thông báo !",
                text: "Bạn chưa khai báo hướng dẫn nhanh cho màn hình này !",
                type: "alert-warning",
                callback: function (result) {
                }
            });
        }
        else {
            var views = {
                view: "hint",
                id: "hint_base",
                // nextButton: "fas fa-arrow-right",    // the new caption of the button
                // prevButton: "fas fa-arrow-left",
                steps: JSON.parse(hint)
            };

            webix.ui(views);
            $$("hint_base").start();
        }
    };
    var layout = {
        css: "frmView",
        // paddingY: 10,
        // paddingX: 10,
        rows: [
            {
                rows: [
                    {
                        id: "tlbMain",
                        height: 39,
                        css: "btnControl",
                        type: "toolbar",
                        margin: 0,
                        borderless: true,
                        // hidden: true,
                        cols: controls
                    }
                    // {
                    //     view: "segmented", value: "two", inputWidth: 250, options: [
                    //         { id: "one", value: "One" },
                    //         { id: "two", value: "Two" },
                    //         { id: "three", value: "Three" }
                    //     ], align: "center"
                    // }
                ]
            },
            {
                //  css: "frmView",
                rows: [
                    grid,
                ]
            }
        ]

    };
    function changeMultiChoice() {
        var table = $$("windowData");
        var columns = webix.toArray(table.config.columns);

        if (table.getColumnConfig("colMultiChoice") == undefined) {
            columns.insertAt({
                id: "colMultiChoice",
                header: [{ text: "", content: "masterCheckbox" }],
                width: 50,
                checkValue: 'C',
                uncheckValue: 'K',
                template: "{common.checkbox()}",
                value: 'K'

            }, 0);
        }
        else {
            columns.removeAt(0);
        }

        table.refreshColumns();
    }
    function deleteMultiChoice() {
        var form = webix.$$("window-delete");

        webix.extend(form, webix.ProgressBar);
        form.disable();
        form.showProgress();

        var table = $$("windowData");
        var array = [];
        // var array = new Array();
        table.eachRow(function (row) {

            var record = JSON.stringify(table.getItem(row));
            if (record != undefined) {
                var ref = JSON.parse(record);

                if (ref.colMultiChoice == "C") {
                    array.push(ref.id);
                }
            }
        }, true);

        if (array.length == 0) {
            webix.message({ type: "error", text: "Không có bản ghi nào được chọn" });
            return;
        }

        var khData = {};
        khData.windowid = windowconfig.data[0].window_id;
        khData.editmode = 3;
        khData.data = array;

        webix.ajax()
            .headers({ 'Content-type': 'application/json' })
            .post(app.config.host + "/System/DeleteMultiChoice", khData, function (text) {

                var response = JSON.parse(text);

                if (response.hasOwnProperty("error")) {
                    webix.message({ type: "error", text: response.error });
                    // return;
                }
                form.enable();
                form.hideProgress();
                $$("window-delete").close();
                $$("btnRefresh").callEvent("onClick");
            });
    }
    function printMultiChoice() {
        var table = $$("windowData");
        var array = [];
        // var array = new Array();
        table.eachRow(function (row) {

            var record = JSON.stringify(table.getItem(row));
            if (record != undefined) {
                var ref = JSON.parse(record);

                if (ref.colMultiChoice == "C") {
                    array.push(ref.id);
                }
            }
        }, true);

        if (array.length == 0) {
            webix.message({ type: "error", text: "Không có bản ghi nào được chọn" });
            return;
        }

        var mst = version.getMST();
        if (mst == "4900239158") {
            var detailForm = $$("windowData").$scope.ui(frmPassPrint.$ui);
            frmPassPrint.initUI(array);
            frmPassPrint.setEditMode(2);
            detailForm.show();
            return;
        }
        var cbMauIn = $$("cbMauIn");
        var rpParameter = {
            parameter: array,
            wb_mauin_id: cbMauIn.getValue(),
            type: "PDF"
        };

        var mimetype = "application/pdf";

        var url = app.config.host + "/Invoice/PrintInvoiceMulti";
        var frm = webix.ui({
            view: "window",
            modal: true,
            id: "window-print",
            position: "center",
            move: true,
            padding: 30,
            css: { "border-radius": "6px" },
            // resize: true,
            // css: "headformchil",
            head: {
                height: 30,
                cols: [
                    {
                        id: "head-formDelete", view: "template", css: "headform", template: function (obj) {
                            return '<div style ="float:left; font-size:15px;"><i style="padding-right:8px;" class="fa fa-print"></i> In nhiều hóa đơn<div/>';
                        }
                    },
                    {
                        view: "icon", icon: "fas fa-times", id: "help_formDelete", tooltip: _("Đóng"), click: function () {
                            $$("window-print").close();
                        }
                    }
                ]
            },
            body: {
                paddingY: 10,
                paddingX: 10,
                view: "form",
                id: "window-formprint",
                complexData: true,
                keepViews: true,
                multiview: { keepViews: true },
                margin: 0,
                elements: [
                    {
                        view: "radio", id: "optPrint", value: "medium", options: [
                            { value: "Chất lượng hình ảnh thấp nhất", id: "lowest" },
                            { value: "Chất lượng hình ảnh thấp", id: "low" },
                            { value: "Chất lượng hình ảnh trung bình", id: "medium" },
                            { value: "Chất lượng hình ảnh cao", id: "high" },
                            { value: "Chất lượng hình ảnh cao nhất", id: "highest" }
                        ],
                        align: "center",
                        vertical: true
                    },
                    {
                        cols: [
                            { gravity: 0.3 },
                            {
                                id: "btnCoPrint",
                                view: "button",
                                label: "In",
                                type: "form",
                                align: "center",
                                on: {
                                    onClick: function () {

                                        rpParameter.opt = $$("optPrint").getValue();
                                        var form = webix.$$("window-print");

                                        webix.extend(form, webix.ProgressBar);
                                        form.disable();
                                        form.showProgress();
                                        var newWin = window.open();
                                        var html = '<html><head><title>Hóa đơn điện tử M-Invoice</title>'
                                            + '<link rel="stylesheet" href="assets/fontawesome_pro/css/all.css" type="text/css" charset="utf-8">'
                                            + '<link rel="stylesheet" href="assets/fontawesome.css" type="text/css" charset="utf-8">'
                                            + '</head><body><center>Đang tải dữ liệu ... <br><p><i style="font-size:200%;" class="fa fa-spin fa-spinner"></i></p></center></body></html>';
                                        newWin.document.write(html);

                                        webix.ajax()
                                            .response("arraybuffer")
                                            .headers({ 'Content-type': 'application/json' })
                                            .post(url, rpParameter, {
                                                error: function (text, data, XmlHttpRequest) {
                                                    webix.modalbox.hide(box);
                                                    form.enable();
                                                    form.hideProgress();
                                                    $$("window-print").close();
                                                },
                                                success: function (text, data, XmlHttpRequest) {
                                                    form.enable();
                                                    form.hideProgress();
                                                    $$("window-print").close();
                                                    var file = new Blob([data], { type: mimetype });
                                                    var fileURL = URL.createObjectURL(file);

                                                    // webix.modalbox.hide(box);
                                                    // var win = $$("windowData").$scope.ui(printf.$ui);
                                                    // win.config.url = fileURL;
                                                    // win.show();
                                                    newWin.location = fileURL;
                                                }
                                            });
                                    }
                                },
                                click: function () {
                                    $$("btnCoPrint").callEvent("onClick");
                                }
                            },
                            {
                                view: "button", id: "btnKoPrint", shortcut: "esc", label: "Thoát", type: "danger", align: "center",
                                on: {
                                    onClick: function () {
                                        $$("window-print").close();
                                    }
                                },
                                click: function () {
                                    this.callEvent("onClick");
                                }
                            },
                            { gravity: 0.3 }
                        ]
                    }

                ]
            }
        });

        frm.show();
        // var box = webix.modalbox({
        //     title: "Đang in chứng từ",
        //     text: "<p ><i style='font-size:450%;' class='fa fa-spin fa-spinner'></i></p>",
        //     width: 350,
        //     height: 200
        // });

        // var newWin = window.open();
        // var html = '<html><head><title>Hóa đơn điện tử M-Invoice</title>'
        //     + '<link rel="stylesheet" href="assets/fontawesome_pro/css/all.css" type="text/css" charset="utf-8">'
        //     + '<link rel="stylesheet" href="assets/fontawesome.css" type="text/css" charset="utf-8">'
        //     + '</head><body><center>Đang tải dữ liệu ... <br><p><i style="font-size:200%;" class="fa fa-spin fa-spinner"></i></p></center></body></html>';
        // newWin.document.write(html);

        // webix.ajax()
        //     .response("arraybuffer")
        //     .headers({ 'Content-type': 'application/json' })
        //     .post(url, rpParameter, {
        //         error: function (text, data, XmlHttpRequest) {
        //             webix.modalbox.hide(box);
        //             alert(text);
        //         },
        //         success: function (text, data, XmlHttpRequest) {
        //             var file = new Blob([data], { type: mimetype });
        //             var fileURL = URL.createObjectURL(file);

        //             webix.modalbox.hide(box);
        //             // var win = $$("windowData").$scope.ui(printf.$ui);
        //             // win.config.url = fileURL;
        //             // win.show();
        //             newWin.location = fileURL;
        //         }
        //     });

        // $$("btnRefresh").callEvent("onClick");
    }
    return {
        $ui: layout,
        $oninit: function (view, $scope) {
            webix.extend(view, webix.ProgressBar);
            $scope.on(app, "dataChanged", function (mode, item) {
                var table = webix.$$("windowData");
                if (mode == 1) {
                    table.add(item);
                    table.clearAll();
                    table.load(table.config.url);
                }
                if (mode == 2) {
                    var selectedItem = table.getSelectedItem();
                    table.updateItem(selectedItem.id, item);
                    webix.UIManager.setFocus($$(table.config.id));
                    table.clearAll();
                    table.load(table.config.url);
                }
            });
            $scope.on(app, "filterTable", function (report_id, infoWindowId, item) {
                var table = $$("windowData");
                var infoparam = {
                    infowindow_id: infoWindowId,
                    parameter: item
                };
                table.config.infoparam = infoparam;
                table.clearAll();
                table.load(table.config.url);
            });
        },
        $onurlchange: function (ui, name, url, scope) {
            initUI();
        }
    };
});
define('locales/en',[], function () {
    return {
        "DS_KHIEU_HD": "List of invoice symbols used",
        "BIEN_LAI": "Receipt",
        "HOA_DON_CSD": "Unused invoice",
        "HOA_DON": "Bill",
        "CON_LAI": "Remaining",
        "SU_DUNG": "Use",
        "TONG_SO": "Total",
        "TEM_VE": "Stamps - Tickets - Cards",
        "HD_ND123": "Decree bill 123",
        "LS_TN_CQT": "History of transmission with tax authorities",
        "DN_CQT": "Log in to your tax office account",
        "DN_PMQL": "Log in to the Invoice Management software",
        "TB_SAISOT": "NOTICE OF WRONG BILLING",
        "LS_TN": "TRANSMISSION HISTORY",
        "DS_HDON": "BILLS LIST",
        "BC_TK": "STATISTIC",
        "GIA_HAN": "Extend",
        "EXPORT_CSV": "CSV dump",
        "DS_CKS": "List of digital signatures used",
        "DS_MAU_HD": "List of invoice templates to use",
        "LOAI_THUE": "Kind of tax",
        "TIEN_CKHAU": "Discount",
        "TIEN_TTHUE": "Earning money before tax",
        "TIEN_SAU_THUE": "Total amount after tax",
        "TONG_CONG_HH": "Total goods and services",
        "TIEN_BANG_CHU": "Read money in words",
        "HT_TTOAN": "Payments",
        "NGAY_TAO_MOI": "New creation date",
        "NGHIEP_VU": "Major",
        "TCHAT": "Nature",
        "TSUAT_CT": "Calculate the tax rate according to the total details of each item",
        "HDON_CK": "Discount invoice",
        "XOA_DONG": "Delete line",
        "THEM_DONG": "Add line",
        "NGAY_LAP": "Date founded",
        "TT_GUI": "Sending Status",
        "MA_CQT": "Tax authority code",
        "DV_NMUA": "Name of unit / Name of buyer",
        "SIGN_SEND_MULTIPLE": "Sign and send in bulk",
        "SIGN_SEND": "Sign and send",
        "SEND_EMAIL": "Send email",
        "MA_TIEN_TE": "Currency code",
        "HOT_LINE": "Hotline",
        "DUNG_THU": "Want to try it out ?",
        "KET_NOI": "Connect with us",
        "PHAN_VUNG": "Partition",
        "CONFIG_CAL": "Edit value money",
        "ALIAS": "Alias",
        "TOTAL": "Total",
        "AMOUNT_TO_WORD": "into money in words",
        "MKH": "Customer's code",
        "DSCTS": "List of digital certificates",
        "DKCTS": "Register for digital certificates",
        "DKTK": "Register Token",
        "DSTK": "Token list",
        "SDT": "Phone number",
        "TEAMVIEW": "Teamview (UltraViewer)",
        "NGUOI_LIEN_HE": "Contact",
        "MVCHAT": "M-Invoice Chat",
        "MVSUPPORT": "M-Invoice Support",
        "TONG_CONG": "Total",
        "USER_NEW": "The establishment",
        "CONG_CU": "Tool",
        "LY_DO_XB": "Reason for deletion",
        "MST": "Tax code",
        "TEN_NCC": "Supplier Name",
        "THUONG_HIEU": "Trademark",
        "LINK_TRACUU": "Link Lookup",
        "Bạn chưa chọn hóa đơn": "Not select Invoie",
        "IMPORT_EXCEL_CT": "Get Excel details",
        "ma_dt": "Object code",
        "ten_dt": "Object name",
        "THEM": "Plus",
        "SUA": "Edit",
        "XOA": "Delete",
        "COPY": "Copy",
        "USERNAME": "Username",
        "PASSWORD": "Password",
        "REMEMBERME": "Remember me",
        "DANGNHAP": "Login",
        "DANGKY": "Register",
        "QUENMK": "Forgot password ?",
        "MAU_HD": "Sample invoice",
        "KY_HIEU": "Symbol",
        "MAUIN": "Printed form",
        "SO_HDON": "Some bills",
        "NGAY_HDON": "Bill date",
        "TEN_DON_VI": "Company",
        "TEN_NGUOI_MUA": "Buyer name",
        "SO_DH": "Order number",
        "MA_DT": "Object code",
        "MS_THUE": "Tax code",
        "DIA_CHI": "Address",
        "TK_BEN_MUA": "Buyer's account",
        "NGAN_HANG_BEN_MUA": "Buyer bank",
        "TK_BEN_BAN": "Seller account",
        "NGAN_HANG_BEN_BAN": "Seller bank",
        "HT_TT": "Payments",
        "PRINT": "Print",
        "MA_HV": "Line code",
        "TEN_HV": "Goods name",
        "DVT": "Unit",
        "SO_LUONG": "Quantity",
        "GIA": "Price",
        "TIEN": "Amount",
        "PT_CK": "% discount",
        "TIEN_CK": "Discount amount",
        "MA_THUE": "code tax",
        "TIEN_THUE": "VAT amount",
        "THANH_TIEN": "Total amount",
        "MA": "Code",
        "TEN": "Name",
        "DUYET": "Check",
        "PHAN_QUYEN": "Decentralization",
        "CHUC_NANG": "Function",
        "BAO_CAO": "Report",
        "TEN_CHUC_NANG": "Function name",
        "TEN_MAU": "Form name",
        "LOAI_HOA_DON": "Type invoice",
        "HINH_THUC": "Form",
        "MAU_SO": "Denominator",
        "SO_LIEN": "Contact number",
        "DA_KY": "Signed",
        "TRANG_THAI_MAU": "Sample status",
        "NGAY_TB": "Notice date",
        "NGUOI_DAI_DIEN_PL": "Legal representative",
        "DON_VI_CHU_QUAN": "Managing unit",
        "CO_QUAN_THUE_NHAN_TB": "Tax authorities receive notices",
        "TRANG_THAI": "Status",
        "MA_LOAI": "Code type",
        "TEN_LOAI": "Type name",
        "TU_SO": "From number",
        "DEN_SO": "To number",
        "NGAY_BD_SD": "Day started using",
        "DN_IN": "Doanh nghiệp In/Cung cấp phần mềm",
        "MAU_HDON": "Sample invoice",
        "TEN_DT": "Object name",
        "CHUC_VU": "Position",
        "DIEN_THOAI": "Phone number",
        "DAI_DIEN": "Đại diện",
        "EXPORT_XML": "Kết xuất XML",
        "NGUOI_KY": "The signer",
        "SO_SERIAL": "Symbol",
        "MA_DVT": "Mã ĐVT",
        "TEN_DVT": "Tên ĐVT",
        "CHU_KY_SO": "Digital signatures",
        "CHON": "To choose",
        "DONVI": "Company",
        "TINH_THANH": "City",
        "NGAY_BD_NAM_TC": "The start of the fiscal year",
        "TAI_KHOAN": "Account",
        "TAI_NH": "Tại ngân hàng",
        "EMAIL": "Email",
        "SUBJECTNAME": "Chủ thể",
        "SIGN": "Ký hóa đơn",
        "KY_HOA_DON": "Ký hóa đơn",
        "DC_DINH_DANH": "Điều chỉnh định danh",
        "SOVB": "Text number",
        "NGAYVB": "Text date",
        "DIEN_GIAI": "Explain",
        "SEARCH": "Search",
        "TIM_CHI_TIET": "Find details",
        "NGUOI_LAP": "The establishment",
        "TRANG_THAI_HDON": "Invoice status",
        "TU_NGAY": "Since",
        "DEN_NGAY": "To date",
        "NGUOI_NHAN": "Receiver",
        "TIEU_DE": "Title",
        "NOI_DUNG": "Content",
        "SEND_EMAIL_INVOICE": "Gửi hóa đơn qua email",
        "KHUYEN_MAI": "Khuyến mãi",
        "TIEU_THUC": "Tiêu thức",
        "DC_TANG": "Điều chỉnh tăng",
        "DC_GIAM": "Điều chỉnh giảm",
        "HDON_THAY_THE": "Hóa đơn thay thế",
        "REFRESH": "Refresh",
        "EXPORT": "Output",
        "EXPORT_EXCEL": "Output Excel",
        "XOA_BO": "Cancel",
        "MST_BEN_BAN": "MST Bên bán",
        "MST_BEN_MUA": "MST Bên mua",
        "HDON_CT_BRA": "Hóa đơn chứng từ bán ra",
        "TIEN_TRUOC_THUE": "Amount exclude tax",
        "TIEN_THUE_10": "10%",
        "TIEN_THUE_05": "5%",
        "TIEN_THUE_00": "0%",
        "KHONG_CHIU_THUE": "Không chịu thuế",
        "KHONG_KK": "Không kê khai",
        "GHI_CHU": "Note",
        "IMPORT_EXCEL": "Receive Excel",
        "NGUOI_GUI": "Sender",
        "KY_HOA_DON_CHO_KY": "Sign multiple invoices",
        "SMTP_SERVER": "SMTP Server",
        "SMTP_PORT": "SMTP Port",
        "enableSSL": "Enable SSL",
        "LOAI": "Type",
        "SEND_EMAIL_CONFIRM": "Send Email to request confirmation",
        "NHOM": "Group",
        "GIA_BAN": "price",
        "DANG_KY": "Registration",
        "SL_HD_DK": "Number of registered invoices",
        "KEY_LICENSE": "License key",
        "SL_HD_THEM": "Number of additional registration invoices",
        "GIA_TRI": "Value",
        "NGAY_BAT_DAU": "Start day",
        "NGAY_KET_THUC": "End date",
        "TOKEN_SERIAL": "Token serial",
        "CHUYEN_DOI": "Convert",
        "SO_TK": "Account number",
        "NGAY_HET_HAN": "Expiration date",
        "CHON_BOCHON": "Select / Uncheck",
        "QUYEN_TRUY_CAP_HD": "Invoice access",
        "IS_VIEW_USER": "See other user documentation",
        "IS_EDIT_USER": "Modify documents of other users",
        "IS_DEL_USER": "Delete documents from other users",
        "KY_HOA_DON": "Sign the bill",
        "DANG_KY_LAN_DAU": "First registration",
        "DANG_KY_THEM": "Register more",
        "THONG_BAO": "Notification",
        "TAI_FILE_MAU": "Download the sample file",
        "MA_NT": "Currency code",
        "TEN_NT": "Name of foreign currency",
        "TY_GIA": "Exchange rate",
        "TEN_NH": "Bank name",
        "IN_CHUYEN_DOI": "Print conversion",
        "NGUOI_IN_CDOI": "Printers convert",
        "NGAY_IN_CDOI": "Print conversion date",
        "PHAN_CACH_HANG_NGHIN": "Separating thousands",
        "PHAN_CACH_THAP_PHAN": "Decimal decimal",
        "PRINT_INVOICE_HTML": "8.View invoice (Html)",
        "DEL_CACHE": "Clear the cache",
        "LOGOUT": "Log out",
        "CHANGE_PASS": "Change Password",
        "SO_BANG_KE": "Table number",
        "TAO_HD": "Create an invoice from a list",
        "LIST_DATE": "List date",
        "LIST_NUMBER": "List number",
        "MA_CHUNGTU": "Voucher code",
        "NGAY_CHUNGTU": "Day vouchers",
        "SO_CHUNGTU": "Number of vouchers",
        "PT_THUE": "% tax",
        "TEN_DV": "Company",
        "TONG_TIEN": "Total amount",
        "MA_DVCS": "Unit code",
        "TEN_NHV": "Group name",
        "USER_TRACUU": "Create user lookup",
        "MA_HANG": "Mã hàng hóa",
        "TEN_HANG": "Name of goods",
        "DON_GIA": "Unit price",
        "DOANH_THU": "Revenue",
        "THUE_SUAT": "Tax",
        "GIO_TB": "The date and time of cancellation notice is as follows:",
        "NGAY_TB": "Day",
        "PHUONG_PHAP_HUY": "Method of canceling the invoice:",
        "NGAY_LAP_TB": "Notice date:",
        "NGUOI_LAP_BIEU": "The establishment",
        "PATH": "File path signed",
        "KET_XUAT_EXCEL": "Export Excel",
        "HIDDEN": "Show / hide",
        "HD": "USER GUIDE",
        "DANGKY2": "REGISTER",
        "UPDATEDESKTOP": "Update old version",
        "THUCHIEN": "Perform",
        "BACKLOGIN": "Back to login",
        "TABLENAME": "Table name",
        "GHI_DE": "Override",
        "UDTOWEB": "UPDATE SOFTWARE ON ONLINE VERSION (WEB)",
        "BANG_DU_LIEU": "Data sheet",
        "MOTA": "Describe",
        "SOTB": "Notice number",
        "SIGN_TB": "Sign notice",
        "HELPER": "Quick help",
        "MENU_QUICK": "Find the menu"
    };
});
define('locales/ko',[], function () {
    return {
        "DS_KHIEU_HD": "사용된 인보이스 기호 목록",
        "BIEN_LAI": "영수증",
        "HOA_DON_CSD": "미사용 송장",
        "HOA_DON": "청구서",
        "CON_LAI": "남은",
        "SU_DUNG": "사용",
        "TONG_SO": "총",
        "TEM_VE": "우표 - 티켓 - 카드",
        "HD_ND123": "법령 법안 123",
        "LS_TN_CQT": "세무 당국과의 전송 내역",
        "DN_CQT": "세무 당국 계정에 로그인하십시오",
        "DN_PMQL": "인보이스 관리 소프트웨어에 로그인합니다",
        "TB_SAISOT": "잘못된 청구에 대한 통지",
        "LS_TN": "전송 내역",
        "DS_HDON": "청구서 목록",
        "BC_TK": "통계량",
        "GIA_HAN": "연장하다",
        "EXPORT_CSV": "CSV 덤프",
        "DS_CKS": "사용된 디지털 서명 목록",
        "DS_MAU_HD": "사용할 송장 템플릿 목록",
        "LOAI_THUE": "세금의 종류",
        "TIEN_CKHAU": "할인",
        "TIEN_TTHUE": "세전 수익",
        "TIEN_SAU_THUE": "세후 총액",
        "TONG_CONG_HH": "총 상품 및 서비스",
        "TIEN_BANG_CHU": "말로 돈 읽기",
        "HT_TTOAN": "결제",
        "NGAY_TAO_MOI": "새 생성 날짜",
        "CONFIG_CAL": "세액, 총액 수정",
        "NGHIEP_VU": "주요한",
        "TCHAT": "자연",
        "TSUAT_CT": "각 항목의 총 세부 사항에 따라 세율을 계산합니다",
        "HDON_CK": "할인 송장",
        "XOA_DONG": "라인 삭제",
        "THEM_DONG": "라인 추가",
        "NGAY_LAP": "설립일",
        "TT_GUI": "발송현황",
        "MA_CQT": "세무 기관 코드",
        "DV_NMUA": "단위 이름 / 구매자 이름",
        "SIGN_SEND_MULTIPLE": "대량으로 서명하고 보내기",
        "SIGN_SEND": "서명하고 보내기",
        "SEND_EMAIL": "이메일을 보내",
        "MA_TIEN_TE": "통화 코드",
        "HOT_LINE": "핫라인",
        "DUNG_THU": "사용해 보시겠습니까 ?",
        "KET_NOI": "우리와 접촉",
        "PHAN_VUNG": "분할",
        "AMOUNT_TO_WORD": "말로 돈으로",
        "MKH": "고객 코드",
        "DSCTS": "디지털 인증서 목록",
        "DKCTS": "디지털 인증서 등록",
        "DKTK": "토큰 등록",
        "DSTK": "토큰리스트",
        "SDT": "전화 번호",
        "TEAMVIEW": "Teamview (UltraViewer)",
        "NGUOI_LIEN_HE": "담당자",
        "MVCHAT": "M-Invoice Chat",
        "MVSUPPORT": "M-Invoice Hỗ trợ",
        "TONG_CONG": "합계",
        "USER_NEW": "설립자",
        "CONG_CU": "도구",
        "LY_DO_XB": "삭제 사유",
        "MST": "세금 코드",
        "TEN_NCC": "공급 업체 이름",
        "THUONG_HIEU": "브랜드",
        "LINK_TRACUU": "링크 조회",
        "Bạn chưa chọn hóa đơn": "Not select Invoie",
        "IMPORT_EXCEL_CT": "Excel 세부 사항 가져 오기",
        "ma_dt": "객체 코드",
        "ten_dt": "객체 이름",
        "THEM": "추가",
        "SUA": "편집",
        "XOA": "삭제",
        "COPY": "복사",
        "USERNAME": "아이디",
        "PASSWORD": "비밀번호",
        "REMEMBERME": "기억해",
        "DANGNHAP": "로그인",
        "DANGKY": "가입",
        "QUENMK": "비밀번호를 잊어 버렸습니다 ?",
        "MAU_HD": "샘플 송장",
        "KY_HIEU": "표기법",
        "MAUIN": "인쇄 된 양식",
        "SO_HDON": "송장 번호",
        "NGAY_HDON": "송장 날짜",
        "TEN_DON_VI": "단위 이름",
        "TEN_NGUOI_MUA": "구매자 이름",
        "SO_DH": "주문 번호",
        "MA_DT": "객체 코드",
        "MS_THUE": "세금 코드",
        "DIA_CHI": "주소",
        "TK_BEN_MUA": "구매자의 계정",
        "NGAN_HANG_BEN_MUA": "구매자 은행",
        "TK_BEN_BAN": "판매자 계정",
        "NGAN_HANG_BEN_BAN": "판매자 은행",
        "HT_TT": "결제 양식",
        "PRINT": "인쇄",
        "MA_HV": "제품 코드",
        "TEN_HV": "상품명",
        "DVT": "계산 단위",
        "SO_LUONG": "수량",
        "GIA": "가격",
        "TIEN": "돈",
        "PT_CK": "% 할인",
        "TIEN_CK": "할인 된 돈",
        "MA_THUE": "세금 코드",
        "TIEN_THUE": "세금 돈",
        "THANH_TIEN": "돈",
        "MA": "코드",
        "TEN": "이름",
        "DUYET": "찾아보기",
        "PHAN_QUYEN": "탈 중앙화",
        "CHUC_NANG": "기능",
        "BAO_CAO": "보고",
        "TEN_CHUC_NANG": "기능 이름",
        "TEN_MAU": "샘플 이름",
        "LOAI_HOA_DON": "송장 유형",
        "HINH_THUC": "형태",
        "MAU_SO": "모델 번호",
        "SO_LIEN": "연락 번호",
        "DA_KY": "서명",
        "TRANG_THAI_MAU": "샘플 상태",
        "NGAY_TB": "Ngày thông báo",
        "NGUOI_DAI_DIEN_PL": "Người đại diện pháp luật",
        "DON_VI_CHU_QUAN": "Đơn vị chủ quản",
        "CO_QUAN_THUE_NHAN_TB": "Cơ quan thuế nhận thông báo",
        "TRANG_THAI": "상태",
        "MA_LOAI": "코드 타입",
        "TEN_LOAI": "타입 이름",
        "TU_SO": "Từ số",
        "DEN_SO": "Đến số",
        "NGAY_BD_SD": "Ngày bắt đầu sử dụng",
        "DN_IN": "Doanh nghiệp In/Cung cấp phần mềm",
        "MAU_HDON": "샘플 송장",
        "TEN_DT": "객체 이름",
        "CHUC_VU": "직책",
        "DIEN_THOAI": "전화",
        "DAI_DIEN": "대표",
        "SU_DUNG": "사용",
        "EXPORT_XML": "Kết xuất XML",
        "NGUOI_KY": "서명자",
        "SO_SERIAL": "표기법",
        "MA_DVT": "Mã ĐVT",
        "TEN_DVT": "Tên ĐVT",
        "CHU_KY_SO": "디지털 서명",
        "CHON": "선택",
        "DONVI": "단위",
        "TINH_THANH": "도시",
        "NGAY_BD_NAM_TC": "회계 연도의 시작",
        "TAI_KHOAN": "계정",
        "TAI_NH": "은행에서",
        "EMAIL": "이메일",
        "SUBJECTNAME": "제목",
        "SIGN": "청구서에 서명",
        "KY_HOA_DON": "청구서에 서명",
        "DC_DINH_DANH": "Điều chỉnh định danh",
        "SOVB": "텍스트 번호",
        "NGAYVB": "텍스트 날짜",
        "DIEN_GIAI": "통역",
        "SEARCH": "검색",
        "TIM_CHI_TIET": "세부 사항 찾기",
        "NGUOI_LAP": "설립자",
        "TRANG_THAI_HDON": "송장 상태",
        "TU_NGAY": "하루부터",
        "DEN_NGAY": "어서",
        "NGUOI_NHAN": "받는 사람",
        "TIEU_DE": "직함",
        "NOI_DUNG": "내용",
        "SEND_EMAIL_INVOICE": "Gửi hóa đơn qua email",
        "KHUYEN_MAI": "Khuyến mãi",
        "TIEU_THUC": "Tiêu thức",
        "DC_TANG": "Điều chỉnh tăng",
        "DC_GIAM": "Điều chỉnh giảm",
        "HDON_THAY_THE": "Hóa đơn thay thế",
        "REFRESH": "데이터 다운로드",
        "EXPORT": "출력t",
        "EXPORT_EXCEL": "Kết xuất Excel",
        "XOA_BO": "Xóa bỏ",
        "MST_BEN_BAN": "MST Bên bán",
        "MST_BEN_MUA": "MST Bên mua",
        "HDON_CT_BRA": "Hóa đơn chứng từ bán ra",
        "TIEN_TRUOC_THUE": "세금 별도 금액",
        "TIEN_THUE_10": "10%",
        "TIEN_THUE_05": "5%",
        "TIEN_THUE_00": "0%",
        "KHONG_CHIU_THUE": "Không chịu thuế",
        "KHONG_KK": "Không kê khai",
        "GHI_CHU": "비고",
        "IMPORT_EXCEL": "Nhận Excel",
        "NGUOI_GUI": "Người gửi",
        "KY_HOA_DON_CHO_KY": "Ký nhiều hóa đơn",
        "SMTP_SERVER": "SMTP Server",
        "SMTP_PORT": "SMTP Port",
        "enableSSL": "Enable SSL",
        "LOAI": "Loại",
        "SEND_EMAIL_CONFIRM": "Gửi email yêu cầu người mua ký số",
        "NHOM": "Nhóm",
        "GIA_BAN": "Giá bán",
        "DANG_KY": "가입",
        "SL_HD_DK": "등록 된 송장 수",
        "KEY_LICENSE": "라이센스 키",
        "SL_HD_THEM": "추가 등록 송장 수",
        "GIA_TRI": "가치",
        "NGAY_BAT_DAU": "Ngày bắt đầu",
        "NGAY_KET_THUC": "Ngày kết thúc",
        "TOKEN_SERIAL": "Token serial",
        "CHUYEN_DOI": "Chuyển đổi",
        "SO_TK": "계좌 번호",
        "NGAY_HET_HAN": "Ngày hết hạn",
        "CHON_BOCHON": "Chọn/Bỏ chọn",
        "QUYEN_TRUY_CAP_HD": "송장 액세스",
        "IS_VIEW_USER": "Xem chứng từ của NSD khác",
        "IS_EDIT_USER": "Sửa chứng từ của NSD khác",
        "IS_DEL_USER": "Xóa chứng từ của NSD khác",
        "KY_HOA_DON": "청구서에 서명",
        "DANG_KY_LAN_DAU": "최초 등록",
        "DANG_KY_THEM": "더 등록",
        "THONG_BAO": "Thông báo",
        "TAI_FILE_MAU": "샘플 파일 다운로드",
        "MA_NT": "Mã ngoại tệ",
        "TEN_NT": "Tên ngoại tệ",
        "TY_GIA": "환율",
        "TEN_NH": "Tên ngân hàng",
        "IN_CHUYEN_DOI": "In chuyển đổi",
        "NGUOI_IN_CDOI": "Người in chuyển đổi",
        "NGAY_IN_CDOI": "Ngày in chuyển đổi",
        "PHAN_CACH_HANG_NGHIN": "Phân cách hàng nghìn",
        "PHAN_CACH_THAP_PHAN": "Phân cách thập phân",
        "PRINT_INVOICE_HTML": "8. Đọc chữ ký số trên hóa đơn ( HTML)",
        "DEL_CACHE": "캐시 지우기",
        "LOGOUT": "로그 아웃",
        "CHANGE_PASS": "비밀번호 변경",
        "SO_BANG_KE": "테이블 번호",
        "TAO_HD": "목록에서 송장 작성",
        "LIST_DATE": "일자",
        "LIST_NUMBER": "테이블 번호",
        "MA_CHUNGTU": "바우처 코드",
        "NGAY_CHUNGTU": "날짜 바우처",
        "SO_CHUNGTU": "바우처 수",
        "PT_THUE": "% 세금",
        "TEN_DV": "단위 이름",
        "TONG_TIEN": "총 돈",
        "MA_DVCS": "단위 코드",
        "TEN_NHV": "그룹 이름",
        "USER_TRACUU": "사용자 조회 만들기",
        "MA_HANG": "상품 코드",
        "TEN_HANG": "상품명",
        "DON_GIA": "단가",
        "DOANH_THU": "수익",
        "THUE_SUAT": "세율",
        "GIO_TB": "취소 통지 날짜 및 시간은 다음과 같습니다 :",
        "NGAY_TB": "일",
        "PHUONG_PHAP_HUY": "송장을 취소하는 방법 :",
        "NGAY_LAP_TB": "공지 날짜 :",
        "NGUOI_LAP_BIEU": "설립자",
        "PATH": "서명 된 파일 경로",
        "KET_XUAT_EXCEL": "엑셀 내보내기",
        "HIDDEN": "보이기 / 숨기기",
        "HD": "지침",
        "DANGKY2": "등록",
        "UPDATEDESKTOP": "이전 버전 업데이트",
        "THUCHIEN": "완료",
        "BACKLOGIN": "로그인으로 돌아 가기",
        "TABLENAME": "테이블 이름",
        "GHI_DE": "무시",
        "UDTOWEB": "온라인 버전의 소프트웨어 업데이트 (WEB)",
        "BANG_DU_LIEU": "데이터 테이블",
        "MOTA": "설명",
        "SOTB": "통지 번호",
        "SIGN_TB": "서명 통지",
        "HELPER": "빠른 도움",
        "MENU_QUICK": "메뉴 찾기"
    };
});
define('locales/vi',[], function () {
    return {
        "DS_KHIEU_HD": "Danh sách ký hiệu hóa đơn sử dụng",
        "BIEN_LAI": "Biên lai",
        "HOA_DON_CSD": "Hóa đơn chưa sử dụng",
        "HOA_DON": "Hóa đơn",
        "CON_LAI": "Còn lại",
        "SU_DUNG": "Sử dụng",
        "TONG_SO": "Tổng số",
        "TEM_VE": "Tem - Vé - Thẻ",
        "HD_ND123": "Hóa đơn NĐ123",
        "LS_TN_CQT": "Lịch sử truyền nhận với CQT",
        "DN_CQT": "Đăng nhập tài khoản của CQT",
        "DN_PMQL": "Đăng nhập PM Quản lý HĐ",
        "TB_SAISOT": "THÔNG BÁO HĐ SAI SÓT",
        "LS_TN": "LỊCH SỬ TRUYỀN NHẬN",
        "DS_HDON": "DANH SÁCH HÓA ĐƠN",
        "BC_TK": "BÁO CÁO, THỐNG KÊ",
        "GIA_HAN": "Gia hạn",
        "EXPORT_CSV": "Kết xuất CSV",
        "DS_CKS": "Danh sách chữ ký số sử dụng",
        "DS_MAU_HD": "Danh sách mẫu hóa đơn sử dụng",
        "LOAI_THUE": "Loại thuế",
        "TIEN_CKHAU": "Tiền chiết khấu",
        "TIEN_TTHUE": "Thành tiền trước thuế",
        "TIEN_SAU_THUE": "Tổng tiền sau thuế",
        "TONG_CONG_HH": "Tổng cộng hàng hóa, dịch vụ",
        "TIEN_BANG_CHU": "Đọc tiền bằng chữ",
        "HT_TTOAN": "Hình thức TT",
        "NGAY_TAO_MOI": "Ngày tạo mới",
        "NGHIEP_VU": "Nghiệp vụ",
        "TCHAT": "Tính chất",
        "TSUAT_CT": "Tính thuế suất theo tổng chi tiết từng mặt hàng",
        "HH_KHKHAC": "Chọn hàng hóa từ ký hiệu khác",
        "HDON_CK": "Hóa đơn chiết khấu",
        "XOA_DONG": "Xóa dòng",
        "THEM_DONG": "Thêm dòng",
        "NGAY_LAP": "Ngày lập",
        "TT_GUI": "Trạng thái gửi CQT",
        "MA_CQT": "Mã cơ quan thuế",
        "DV_NMUA": "Tên đơn vị/ Tên người mua",
        "SIGN_SEND_MULTIPLE": "Ký và gửi hàng loạt",
        "SIGN_SEND": "Ký và gửi CQT",
        "SEND_EMAIL": "Gửi email",
        "MA_TIEN_TE": "Mã tiền tệ",
        "HOT_LINE": "Hotline",
        "DUNG_THU": "Bạn muốn dùng thử ?",
        "KET_NOI": "Kết nối với chúng tôi",
        "PHAN_VUNG": "Phân vùng",
        "CONFIG_CAL": "Sửa giá trị tiền thuế, tổng tiền",
        "VALID_TBPH": "Kiểm tra TBPH",
        "EXPORT_CSV": "Kết xuất CSV",
        "mau_so": "Mẫu số",
        "tu_so": "Từ số",
        "den_so": "Đến số",
        "KY_HIEU": "Ký hiệu",
        "NGUOI_DAI_DIEN": "Người đại diện",
        "NGAY_BD_NAM_TC": "Ngày bắt đầu năm TC",
        "TEN_DVCS": "Tên đơn vị",
        "CQTCAPTINH": "Cơ quan thuế cấp tỉnh",
        "CQTCAPQL": "Cơ quan thuế cấp quản lý",
        "LOADING": "Đang tải dữ liệu",
        "ALIAS": "Bí danh",
        "TOTAL": "Tổng cộng",
        "KY_HOA_DON_VER2": "Ký hóa đơn (Version 2)",
        "so_tk": "Số TK",
        "AMOUNT_TO_WORD": "Thành tiền bằng chữ",
        "MKH": "Mã khách hàng",
        "DSCTS": "Danh sách chứng thư số",
        "DKCTS": "Đăng ký chứng thư số",
        "DKTK": "Đăng ký Token",
        "DSTK": "Danh sách Token",
        "SDT": "Số điện thoại",
        "TEAMVIEW": "Teamview (UltraViewer)",
        "NGUOI_LIEN_HE": "Người liên hệ",
        "MVCHAT": "M-Invoice Chat",
        "MVSUPPORT": "M-Invoice Hỗ trợ",
        "TONG_CONG": "Tổng cộng",
        "USER_NEW": "Người lập",
        "CONG_CU": "Nghiệp vụ HĐ",
        "LY_DO_XB": "Lý do xóa bỏ",
        "MST": "Mã số thuế",
        "TEN_NCC": "Tên nhà cung cấp",
        "THUONG_HIEU": "Thương hiệu",
        "LINK_TRACUU": "Link Tra cứu",
        "Bạn chưa chọn hóa đơn": "Not select Invoie",
        "IMPORT_EXCEL_CT": "Nhận Excel chi tiết",
        "ma_dt": "Mã đối tượng",
        "ten_dt": "Tên đối tượng",
        "THEM": "Thêm",
        "SUA": "Sửa",
        "XOA": "Xóa",
        "COPY": "Sao chép",
        "USERNAME": "Tên truy cập",
        "PASSWORD": "Mật khẩu",
        "REMEMBERME": "Ghi nhớ",
        "DANGNHAP": "Đăng nhập",
        "DANGKY": "Đăng ký",
        "QUENMK": "Quên mật khẩu ?",
        "MAU_HD": "Mẫu hóa đơn",
        "KY_HIEU": "Ký hiệu",
        "MAUIN": "Mẫu in",
        "SO_HDON": "Số hóa đơn",
        "NGAY_HDON": "Ngày hóa đơn",
        "TEN_DON_VI": "Tên đơn vị",
        "TEN_NGUOI_MUA": "Tên người mua",
        "SO_DH": "Số đơn hàng",
        "MA_DT": "Mã đối tượng",
        "MS_THUE": "Mã số thuế",
        "DIA_CHI": "Địa chỉ",
        "TK_BEN_MUA": "TK Bên Mua",
        "NGAN_HANG_BEN_MUA": "NH Bên Mua",
        "TK_BEN_BAN": "TK Bên Bán",
        "NGAN_HANG_BEN_BAN": "NH Bên Bán",
        "HT_TT": "HT thanh toán",
        "PRINT": "Xem in",
        "MA_HV": "Mã hàng hóa",
        "TEN_HV": "Tên hàng hóa",
        "DVT": "ĐVT",
        "SO_LUONG": "Số lượng",
        "GIA": "Giá",
        "TIEN": "Tiền",
        "PT_CK": "% CK",
        "TIEN_CK": "Tiền CK",
        "MA_THUE": "Mã thuế",
        "TIEN_THUE": "Tiền thuế",
        "THANH_TIEN": "Thành tiền",
        "MA": "Mã",
        "TEN": "Tên",
        "DUYET": "Duyệt",
        "PHAN_QUYEN": "Phân quyền",
        "CHUC_NANG": "Chức năng",
        "BAO_CAO": "Báo cáo",
        "TEN_CHUC_NANG": "Tên chức năng",
        "TEN_MAU": "Tên mẫu",
        "LOAI_HOA_DON": "Loại hóa đơn",
        "HINH_THUC": "Hình thức",
        "MAU_SO": "Mẫu số",
        "SO_LIEN": "Số liên",
        "DA_KY": "Đã ký",
        "TRANG_THAI_MAU": "Trạng thái mẫu",
        "NGAY_TB": "Ngày thông báo",
        "NGUOI_DAI_DIEN_PL": "Người đại diện pháp luật",
        "DON_VI_CHU_QUAN": "Đơn vị chủ quản",
        "CO_QUAN_THUE_NHAN_TB": "Cơ quan thuế nhận thông báo",
        "TRANG_THAI": "Trạng thái",
        "MA_LOAI": "Mã loại",
        "TEN_LOAI": "Tên loại",
        "TU_SO": "Từ số",
        "DEN_SO": "Đến số",
        "NGAY_BD_SD": "Ngày bắt đầu sử dụng",
        "DN_IN": "Doanh nghiệp In/Cung cấp phần mềm",
        "MAU_HDON": "Mẫu hóa đơn",
        "TEN_DT": "Tên đối tượng",
        "CHUC_VU": "Chức vụ",
        "DIEN_THOAI": "Điện thoại",
        "DAI_DIEN": "Đại diện",
        "SU_DUNG": "Sử dụng",
        "EXPORT_XML": "Kết xuất XML",
        "NGUOI_KY": "Người ký",
        "SO_SERIAL": "Ký hiệu",
        "MA_DVT": "Mã ĐVT",
        "TEN_DVT": "Tên ĐVT",
        "CHU_KY_SO": "Chữ ký số",
        "CHON": "Chọn",
        "DONVI": "Đơn vị",
        "TINH_THANH": "Tỉnh thành",
        "NGAY_BD_NAM_TC": "Ngày bắt đầu năm tài chính",
        "TAI_KHOAN": "Tài khoản",
        "TAI_NH": "Tại ngân hàng",
        "EMAIL": "Email",
        "SUBJECTNAME": "Chủ thể",
        "SIGN": "Ký hóa đơn",
        "KY_HOA_DON": "Ký hóa đơn",
        "DC_DINH_DANH": "Điều chỉnh định danh",
        "SOVB": "Số văn bản",
        "NGAYVB": "Ngày văn bản",
        "DIEN_GIAI": "Diễn giải",
        "SEARCH": "Tìm kiếm",
        "TIM_CHI_TIET": "Tìm chi tiết",
        "NGUOI_LAP": "Người lập",
        "TRANG_THAI_HDON": "Trạng thái hóa đơn",
        "TU_NGAY": "Từ ngày",
        "DEN_NGAY": "Đến ngày",
        "NGUOI_NHAN": "Người nhận",
        "TIEU_DE": "Tiêu đề",
        "NOI_DUNG": "Nội dung",
        "SEND_EMAIL_INVOICE": "Gửi hóa đơn qua email",
        "KHUYEN_MAI": "Khuyến mãi",
        "TIEU_THUC": "Tiêu thức",
        "DC_TANG": "Điều chỉnh tăng",
        "DC_GIAM": "Điều chỉnh giảm",
        "HDON_THAY_THE": "Hóa đơn thay thế",
        "REFRESH": "Tải dữ liệu",
        "EXPORT": "Kết xuất",
        "EXPORT_EXCEL": "Kết xuất Excel",
        "XOA_BO": "Xóa bỏ",
        "MST_BEN_BAN": "MST Bên bán",
        "MST_BEN_MUA": "MST Bên mua",
        "HDON_CT_BRA": "Hóa đơn chứng từ bán ra",
        "TIEN_TRUOC_THUE": "Tiền trước thuế",
        "TIEN_THUE_10": "10%",
        "TIEN_THUE_05": "5%",
        "TIEN_THUE_00": "0%",
        "KHONG_CHIU_THUE": "Không chịu thuế",
        "KHONG_KK": "Không kê khai",
        "GHI_CHU": "Ghi chú",
        "IMPORT_EXCEL": "Nhận Excel",
        "NGUOI_GUI": "Người gửi",
        "KY_HOA_DON_CHO_KY": "Ký nhiều hóa đơn",
        "SMTP_SERVER": "SMTP Server",
        "SMTP_PORT": "SMTP Port",
        "enableSSL": "Enable SSL",
        "LOAI": "Loại",
        "SEND_EMAIL_CONFIRM": "Gửi email yêu cầu người mua ký số",
        "NHOM": "Nhóm",
        "GIA_BAN": "Giá bán",
        "DANG_KY": "Đăng ký",
        "SL_HD_DK": "Số lượng hóa đơn đã đăng ký",
        "KEY_LICENSE": "Key bản quyền",
        "SL_HD_THEM": "Số lượng hóa đơn đăng ký thêm",
        "GIA_TRI": "Giá trị",
        "NGAY_BAT_DAU": "Ngày bắt đầu",
        "NGAY_KET_THUC": "Ngày kết thúc",
        "TOKEN_SERIAL": "Token serial",
        "CHUYEN_DOI": "Chuyển đổi",
        "SO_TK": "Số tài khoản",
        "NGAY_HET_HAN": "Ngày hết hạn",
        "CHON_BOCHON": "Chọn/Bỏ chọn",
        "QUYEN_TRUY_CAP_HD": "Quyền truy cập hóa đơn",
        "IS_VIEW_USER": "Xem chứng từ của NSD khác",
        "IS_EDIT_USER": "Sửa chứng từ của NSD khác",
        "IS_DEL_USER": "Xóa chứng từ của NSD khác",
        "KY_HOA_DON": "Ký hóa đơn",
        "DANG_KY_LAN_DAU": "Đăng ký lần đầu",
        "DANG_KY_THEM": "Đăng ký thêm",
        "THONG_BAO": "Thông báo",
        "TAI_FILE_MAU": "Tải file mẫu",
        "MA_NT": "Mã ngoại tệ",
        "TEN_NT": "Tên ngoại tệ",
        "TY_GIA": "Tỷ giá",
        "TEN_NH": "Tên ngân hàng",
        "IN_CHUYEN_DOI": "In chuyển đổi",
        "NGUOI_IN_CDOI": "Người in chuyển đổi",
        "NGAY_IN_CDOI": "Ngày in chuyển đổi",
        "PHAN_CACH_HANG_NGHIN": "Phân cách hàng nghìn",
        "PHAN_CACH_THAP_PHAN": "Phân cách thập phân",
        "PRINT_INVOICE_HTML": "8. Đọc chữ ký số trên hóa đơn ( HTML)",
        "DEL_CACHE": "Xóa cache",
        "LOGOUT": "Đăng xuất",
        "CHANGE_PASS": "Đổi mật khẩu",
        "SO_BANG_KE": "Số bảng kê",
        "TAO_HD": "Tạo hóa đơn từ bảng kê",
        "LIST_DATE": "Ngày bảng kê",
        "LIST_NUMBER": "Số bảng kê",
        "MA_CHUNGTU": "Mã chứng từ",
        "NGAY_CHUNGTU": "Ngày chứng từ",
        "SO_CHUNGTU": "Số chứng từ",
        "PT_THUE": "% thuế",
        "TEN_DV": "Tên đơn vị",
        "TONG_TIEN": "Tổng tiền",
        "MA_DVCS": "Mã đơn vị",
        "TEN_NHV": "Tên nhóm",
        "USER_TRACUU": "Tạo user tra cứu",
        "MA_HANG": "Mã hàng hóa",
        "TEN_HANG": "Tên hàng",
        "DON_GIA": "Đơn giá",
        "DOANH_THU": "Doanh thu",
        "THUE_SUAT": "Thuế suất",
        "GIO_TB": "Ngày, giờ thông báo hủy hóa đơn như sau:",
        "NGAY_TB": "Ngày",
        "PHUONG_PHAP_HUY": "Phương pháp hủy hóa đơn:",
        "NGAY_LAP_TB": "Ngày lập thông báo:",
        "NGUOI_LAP_BIEU": "Người lập",
        "PATH": "Đường dẫn file ký",
        "KET_XUAT_EXCEL": "Kết xuất Excel",
        "HIDDEN": "Ẩn/hiện",
        "HD": " HƯỚNG DẪN",
        "DANGKY2": "ĐĂNG KÝ",
        "UPDATEDESKTOP": "Cập nhật bản cũ",
        "THUCHIEN": "Thực hiện",
        "BACKLOGIN": "Quay lại đăng nhập",
        "TABLENAME": "Tên bảng",
        "GHI_DE": "Ghi đè",
        "UDTOWEB": "CẬP NHẬT PHẦN MỀM LÊN PHIÊN BẢN ONLINE (WEB)",
        "BANG_DU_LIEU": "Bảng dữ liệu",
        "MOTA": "Mô tả",
        "SOTB": "Số thông báo",
        "SIGN_TB": "Ký thông báo",
        "HELPER": "Trợ giúp nhanh",
        "MENU_QUICK": "Tìm menu"
    };
});

require(["app"]);
